module.exports = {
    login:{
        '1':'超进化物语后台管理',
        '2':'帐号',
        '3':'密码',
        '4':'登录',
        '5':'修改密码',
        '6':'修改成功',
    },
    master:{
        '1':'超进化物语后台管理',
        '2':'退出',
        '3':'世界服',
        '4':'游戏服',
        '5':'首页',
    },
    mask_word:{
        '1':'屏蔽字',
        '2':'输入屏蔽字',
        '3':'搜索',
        '4':'添加cjhwy2屏蔽字',
        '5':'重载全部屏蔽字',
        '6':'id',
        '7':'屏蔽字',
        '8':'操作',
        '9':'来源',
        '10':'强制检测屏蔽字OSS'
    },
    activity_editor:{
        '6':'保底设置',
        '7':'天选之日',
        '8':'影响的服务器ids',
        '9':'活动名',
        '10':'描述',
        '11':'开关',
        '12':'开始日期',
        '13':'结束日期',
        '14':'活动总配置',
        '15':'活动详细配置',
        '16':'操作',
        '17':'编辑',
        '18':'删除',
        '19':'活动时间范围',
        '20':'至',
        '21':'开始日期',
        '22':'结束日期',
        '23':'参数配置',
        '24':'配方编号',
        '25':'请选择',
        '26':'造物台类型',
        '27':'X次内必得不朽或以上怪兽',
        '28':'触发 X次内必得不朽或以上怪兽 次数',
        '29':'消耗材料',
        '30':'消耗钻石',
        '31':'添加',
        '32':'修改',
        '33':'取消',
        '34':'通用配置',
        '35':'开启',
        '36':'关闭',
        '37':'添加天选之日',
        '38':'检测是否包含重复时间段',
    },
    config:{
        '1':'表名',
        '2':'请选择',
        '3':'查询表数据',
        '4':'查询更新时间',
        '5':'选择上传文件',
        '6':'批量上传',
        '7':'表名',
        '8':'更新时间',
        '9':'请选择表名!',
        '10':'上传成功',
        '11':'上传失败',
        '12':'请先上传文件',
        '13':'重载全部配置',
        '14':'服务器',
        '15':'IP地址',
        '16':'取消',
        '17':'确定重载',
        '18':'返回消息码',
        '19':'返回消息',
        '20':'重置单个配置',
        '21':'配置表版本',
    },
    dialog_editor:{
        '1':'上传乱入剧本',
        '2':'对话组编号',
        '3':'对话组',
        '4':'操作',
        '5':'显示对话组',
        '6':'对话模拟',
        '7':'下一句',
        '8':'关闭对话',
        '9':'格式错误！请重新选择!',
    },
    game_servers:{
        '1':'查询游戏服',
        '2':'创建游戏服',
        '3':'游戏服ID',
        '4':'游戏服名称',
        '5':'游戏服描述',
        '6':'游戏服主IP',
        '7':'游戏服副IP',
        '8':'操作',
        '9':'编辑',
        '10':'合服',
        '11':'添加副IP',
        '12':'取消',
        '13':'确定',
        '14':'游戏服IP',
        '15':'编辑游戏服',
        '16':'合服',
        '17':'创建成功',
        '18':'删除成功',
        '19':'更新成功',
        '20':'合服成功',
        '21':'此操作将删除该服务器信息, 是否继续?',
        '22':'游戏服',
        '23':'世界服',
    },
    lang_conf:{
        '1':'请输入i18n关键字/中文/英文/日文/韩文',
        '2':'搜索',
        '3':'i18n关键字',
        '4':'中文',
        '5':'英文',
        '6':'日文',
        '7':'韩文',
        '8':'修改',
        '9':'修改语义!',
        '10':'取消',
        '11':'修改',
        '12':'操作成功',
        '13':'同步配置',
        '14':'导出json',
        '15':'本版号',
        '16':'语言',
        '17':'本版描述',
        '18':'最后一次更改日期',
        '19':'操作',
        '20':'审核用',
        '21':'导出语言包',
        '22':'id',
        '23':'语言包版本'
    },
    level_editor:{
        '1':'请选择',
        '2':'添加',
        '3':'百分比填小数',
        '4':'怪兽',
        '5':'编号',
        '6':'性格',
        '7':'等级',
        '8':'基因强化条数',
        '9':'基因编号',
        '10':'技能等级',
        '11':'极化攻击力',
        '12':'极化体力',
        '13':'极化霸气',
        '14':'极化移动速度',
        '15':'极化能力条数',
        '16':'元核',
        '17':'效果',
        '18':'等级',
        '19':'进阶次数',
        '20':'词条属性条数',
        '21':'效果',
        '22':'浮动值',
        '23':'宿命',
        '24':'效果',
        '25':'浮动值',
        '26':'同调效果',
        '27':'其他增减益条数',
        '28':'确认',
        '29':'取消',
        '30':'神灵',
        '31':'编号',
        '32':'等级',
        '33':'神灵契约',
        '34':'层数',
        '35':'层等级',
        '36':'神灵自动释放序列',
        '37':'条数',
        '38':'释放次数',
        '39':'起源基石增益',
        '40':'条数',
        '41':'增益提升',
        '42':'黑暗森林增益',
        '43':'条数',
        '44':'等级',
        '45':'皮肤增益',
        '46':'战墙',
        '47':'加固次数',
        '48':'战纹效果条数',
        '49':'配置',
        '50':'生成',
        '51':'解析',
        '52':'等级',
        '53':'白',
        '54':'绿',
        '55':'蓝',
        '56':'紫',
        '57':'橙',
        '58':'红',
        '59':'1次',
        '60':'2次',
        '61':'3次',
        '62':'循环',
        '63':'攻击力',
        '64':'体力',
        '65':'霸气',
        '66':'移动速度',
        '67':'真实伤害',
        '68':'生物屏障',
        '69':'攻击速度',
        '70':'射程',
        '71':'子弹速度',
        '72':'体型',
        '73':'普攻回复',
        '74':'自愈回复',
        '75':'增益效果持续时间',
        '76':'负面效果持续时间',
        '77':'回复效果',
        '78':'攻击力%',
        '79':'体力%',
        '80':'霸气%',
        '81':'移动速度%',
        '82':'真实伤害%',
        '83':'生物屏障%',
        '84':'攻击速度%',
        '85':'射程%',
        '86':'子弹速度%',
        '87':'体型%',
        '88':'普攻回复%',
        '89':'愈回复%',
        '90':'增益效果持续时间%',
        '91':'负面效果持续时间%',
        '92':'回复效果%',
        '93':'被击退时忽视敌方霸气',
    },
    reward_editor:{
        '1':'大类',
        '2':'请选择',
        '3':'编号',
        '4':'碎片',
        '5':'主属性',
        '6':'品质',
        '7':'等级',
        '8':'选择元核等级',
        '9':'阶段',
        '10':'选择元核阶段',
        '11':'宿命',
        '12':'关闭随机',
        '13':'开启随机',
        '14':'词条',
        '15':'添加词条',
        '16':'删除词条',
        '17':'觉醒结晶',
        '18':'觉醒结晶碎片',
        '19':'数量',
        '20':'开启随机数量',
        '21':'关闭随机数量',
        '22':'数量1',
        '23':'数量2',
        '24':'爆率',
        '25':'开启爆率',
        '26':'关闭爆率',
        '27':'数量设置(小于1的小数)',
        '28':'添加奖励',
        '29':'整理标签',
        '30':'最终解析串',
        '31':'白',
        '32':'绿',
        '33':'蓝',
        '34':'紫',
        '35':'橙',
        '36':'红',
        '37':'二字词条',
        '38':'四字词条',
        '39':'必要资源',
        '40':'怪兽',
        '41':'怪兽碎片',
        '42':'材料/道具',
        '43':'元核',
        '44':'觉醒结晶',
        '45':'战纹',
        '46':'觉醒结晶碎片',
        '47':'部落公共资源',
        '48':'按配置随机属性',
        '49':'',
        '50':'必出指定属性',
        '51':'必定不出',
        '52':'特殊',
        '53':'自定义概率'
    },
    plate:{
        '1':'重量',
        '2':'技能数量',
        '3':'当前起源盘的品质权重'
    },
    world_servers:{
        '1' :'查询世界区',
        '2' :'创建世界区',
        '3' :'世界区ID',
        '4' :'世界区名称',
        '5' :'世界区描述',
        '6' :'世界区主IP',
        '7' :'世界区副IP',
        '8' :'操作',
        '9' :'编辑',
        '10':'合服',
        '11':'添加副IP',
        '12':'取消',
        '13':'确定',
        '14':'世界区主IP',
        '15':'编辑世界区',
        '16':'合区',
        '17':'创建成功',
        '18':'删除成功',
        '19':'更新成功',
        '20':'合服成功',
        '21':'此操作将删除该服务器信息, 是否继续?',
        '22':'游戏服',
        '23':'世界服',
    },

    post_mails:{},
    query_players:{},

    menu: {
        "1000": "内部工具",
        "1001": "管理员",
        "1002": "权限管理",
        "1003": "操作日志查询",
        "1004": "服务器-游戏服",
        "1005": "服务器-世界区",
        "2000": "策划工具",
        "2001": "配置管理",
        "2002": "关卡编辑器",
        "2003": "奖励串编辑器",
        "2004": "活动编辑器",
        "2005": "对话编辑器",
        "2006": "屏蔽字编辑",
        "2007": "礼包兑换码",
        "3000": "运营工具",
        "3001": "语义化管理",
        "3002": "充值统计",
        "3003": "运营统计",
        "3004": "封号禁言",
        "3005": "GM公告",
        "4000": "邮件工具",
        "4001": "邮件模板",
        "4002": "普通邮件",
        "4003": "全局邮件",
        "5000": "玩家相关",
        "5001": "玩家查询",
        "5002": "聊天留言查询",
        "5003": "玩家邮件查询",
        "5004": "玩家充值查询",
        "5005": "礼包查询及补偿",
        "6000": "测试工具",
        "6001": "常用工具",
        "6002": "模拟充值",


    },
    servers: {
        '1' :'查询世界区',
        '2' :'查询游戏服',
        '3' :'创建世界区',
        '4' :'创建游戏服',
        '5' :'游戏服ID',
        '6' :'游戏服名称',
        '7' :'游戏服描述',
        '8' :'游戏服主IP',
        '9' :'游戏服副IP',
        '10':'操作',
        '11':'编辑',
        '12':'合服',
        '13':'取消关联',
        '14':'上传ips',
        '15':'上传connect',
        '16':'下载',
        '17':'世界区ID',
        '18':'世界区名称',
        '19':'世界区描述',
        '20':'世界区主IP',
        '21':'世界区副IP',
        '22':'关联的世界区',
        '23':'名称',
        '24':'描述',
        '25':'ID',
        '26':'主IP',
        '27':'添加副IP',
        '28':'副IP',
        '29':'取消',
        '30':'确定',
        '31':'编辑游戏服',
        '32':'编辑世界区',
        '33':'合区',
        '34':'关联游戏服',
        '35':'创建成功',
        '36':'更新成功',
        '37':'合服成功',
        '38':'添加关联游戏服',
        '39':'关联成功',
        '40':'取消关联成功',
        '41':'上传成功',
        '42':'登录服配置',
        '43':'全服跨服配置',
        '44':'通信服IP',
    },


    "99_123": "{1}回复{2}",
    "99_122": "魔物",
    "99_121": "{1}最多购买{2}次",
    "99_120": "每{1}月",
    "99_127": "探索",
    "99_126": "消耗提示：元核被{1}装嵌，是否继续选取该元核？",
    "99_125": "消耗提示：怪兽在{1}中，是否继续选取该怪兽？",
    "99_124": "到达上限",
    "99_129": "好友助战",
    "99_128": "起源基石上阵",
    "99_134": "暴走旷野上阵",
    "skillName_208": "逆刃·断罪",
    "99_133": "部落战上阵",
    "skillName_207": "逆刃·凶锐",
    "99_132": "深渊先遣压制词缀",
    "skillName_206": "逆刃·荆戒",
    "99_131": "阵容{1}上阵",
    "skillName_205": "逆刃·柔风",
    "99_138": "探索者等级{1}前免费",
    "skillName_204": "逆刃",
    "99_137": "重生",
    "skillName_203": "煞·轮回",
    "99_136": "{1}的怪兽{2}",
    "skillName_202": "煞·饲魂",
    "99_135": "斗技场上阵",
    "skillName_201": "煞·暗流",
    "99_139": "本{1}毫秒",
    "skillName_209": "湮灭",
    "messageInitContent_9601": "火苗跃动，生生不息",
    "messageInitContent_9600": "火焰为我见证",
    "messageInitContent_9605": "火焰就是是我的勇气",
    "messageInitContent_9604": "开火吃饭",
    "messageInitContent_9603": "是谁高喊开火吃饭？可恶的渎神之徒！",
    "messageInitContent_9602": "火下约定绝对无法违背",
    "skillName_200": "煞·光流",
    "99_130": "部落部队{1}上阵",
    "99_145": "本{1}月",
    "99_144": "本{1}周",
    "99_143": "今{1}天",
    "99_142": "本{1}时",
    "99_149": "轮回",
    "99_148": "天启",
    "99_147": "神罚",
    "99_146": "{1}还能购买{2}次",
    "messageInitContent_9609": "伟大的火神啊，开火吃饭才是正经事",
    "messageInitContent_9608": "一边以火为证，一边烤鸡，谁教你的？",
    "messageInitContent_9607": "以火为证",
    "messageInitContent_9606": "火焰横扫邪恶",
    "messageInitContent_9612": "火神保佑我家哥哥早日火起来",
    "messageInitContent_9611": "竟以锅碗瓢盆戏谑圣火，真是不敬之至",
    "messageInitContent_9610": "火神请赐我一锅好饭",
    "messageInitContent_9616": "让我不用改ppt吧火神",
    "messageInitContent_9615": "火神在背包，保佑我不用加班",
    "messageInitContent_9614": "浇油",
    "messageInitContent_9613": "谁是你家哥哥",
    "99_141": "本{1}分",
    "99_140": "本{1}秒",
    "99_156": "部落印记",
    "99_155": "同部落探索者挑战世界之王时会增加1层部落印记，每层部落印记会使敌方怪兽受到的伤害提升1%，最多叠加30层",
    "99_154": "游戏已更新，请重新登录游戏",
    "99_153": "[表情]",
    "99_159": "幻化品质",
    "99_158": "幼体品质",
    "99_157": "进化至{1}解锁",
    "messageInitContent_9619": "烈焰指引，迷雾尽退",
    "messageInitContent_9618": "烈火升腾，锅巴已成",
    "messageInitContent_9617": "火种不灭",
    "messageInitContent_9623": "浇点油",
    "messageInitContent_9622": "火焰就是你的命运",
    "messageInitContent_9621": "感受火焰的意志",
    "messageInitContent_9620": "火焰是神谕，不是厨房用具",
    "messageInitContent_9627": "愿火庇佑你",
    "messageInitContent_9626": "火焰吞噬着所有的阴谋",
    "messageInitContent_9625": "连冰之女神都为祂倾倒",
    "messageInitContent_9624": "火焰将净化你的灵魂",
    "99_152": "暂时没有录像",
    "99_151": "没有上阵怪兽，无法开始战斗",
    "99_150": "魔魇",
    "skillName_239": "喵呜",
    "skillName_238": "蜃境·启动",
    "skillName_237": "蜃境·延迟",
    "skillName_236": "蜃境·警戒",
    "skillName_235": "蜃境·承伤",
    "channelName_28871": "抖音全官服平台",
    "skillName_234": "蜃境",
    "messageInitContent_9629": "添油加醋中",
    "messageInitContent_9628": "你必须记住火焰",
    "15_27": "{1}秒后自动回到房间",
    "15_28": "小队已解散",
    "15_29": "空缺",
    "15_34": "所有己方怪兽的攻击力和体力提升15%",
    "messageInitContent_9634": "火神守护，今晚准时收工",
    "15_35": "匹配房间",
    "messageInitContent_9633": "浇点儿油",
    "15_36": "匹配中",
    "messageInitContent_9632": "火种不灭",
    "15_37": "开始匹配",
    "messageInitContent_9631": "怎么混进了什么奇怪玩意",
    "15_30": "探索者等级>={1}，点击加入小队",
    "messageInitContent_9638": "而我只能接受空蝉的审判",
    "15_31": "只有队长可以释放神灵",
    "messageInitContent_9637": "我只能接受奖励的审判",
    "15_32": "更换怪兽",
    "messageInitContent_9636": "燃烧吧，小宇宙！",
    "15_33": "下阵怪兽",
    "messageInitContent_9635": "接受灰烬的审判吧",
    "skillName_233": "光栅·反射",
    "skillName_232": "光栅·光甲",
    "skillName_231": "光栅·退散",
    "skillName_230": "光栅·溃散",
    "messageInitContent_9630": "火焰起舞，烤肉翻身",
    "skillName_249": "横刀",
    "skillName_248": "创能·献身",
    "skillName_247": "创能·同调",
    "skillName_246": "创能·汇聚",
    "skillName_245": "创能·刻印",
    "messageInitContent_9639": "让我吃顿烧烤吧 我什么都会做的",
    "15_38": "取消",
    "15_39": "关卡{1}",
    "messageInitContent_9645": "火神在上，别糊锅",
    "messageInitContent_9644": "圣火不是烧烤架",
    "messageInitContent_9643": "今天烤点什么好呢",
    "messageInitContent_9642": "火神保佑，记得关火",
    "messageInitContent_9649": "求火神宽恕",
    "messageInitContent_9648": "我看你是想灵魂糊底了",
    "messageInitContent_9647": "驱逐不敬火神者",
    "messageInitContent_9646": "火神在上，那些说别糊锅的……都该拿去净化",
    "skillName_244": "创能",
    "skillName_243": "喵呜·拒绝",
    "skillName_242": "喵呜·炸毛",
    "skillName_241": "喵呜·贴贴",
    "messageInitContent_9641": "圣火不容玩笑，它是神，是审判",
    "skillName_240": "喵呜·角落",
    "messageInitContent_9640": "火庇护你",
    "99_101": "公告",
    "skillName_219": "本格",
    "99_100": "您的账号已被强制下线",
    "skillName_218": "毁坏·解构",
    "skillName_217": "毁坏·转能",
    "skillName_216": "毁坏·蔑视",
    "99_105": "异象将在{1}后出现",
    "skillName_215": "毁坏·绝体",
    "99_104": "暂无挑战记录",
    "skillName_214": "毁坏",
    "99_103": "图鉴",
    "skillName_213": "湮灭·屏障",
    "99_102": "观察者",
    "skillName_212": "湮灭·锁定",
    "99_109": "传送门未解锁",
    "99_108": "猎物未出现",
    "99_107": "世界灾厄未出现",
    "99_106": "深渊先遣未出现",
    "15_12": "是否消耗{1}{2}发布招募信息？",
    "messageInitContent_9656": "烧烤盛宴，火神必达",
    "15_13": "已发布招募信息",
    "messageInitContent_9655": "愿火庇佑你",
    "15_14": "条件不符",
    "messageInitContent_9654": "啊这",
    "15_15": "【凿星裂痕】{1}，探索者等级>={2}，点击加入小队",
    "messageInitContent_9653": "家人们谁懂啊",
    "messageInitContent_9659": "你们都当火神是树洞吗？？",
    "15_10": "已有探索者上阵该怪兽，请重新选择",
    "messageInitContent_9658": "火神，她回我消息了",
    "15_11": "每名探索者必须选择1只出战的怪兽",
    "messageInitContent_9657": "一群不敬者！",
    "skillName_211": "湮灭·星光",
    "skillName_210": "湮灭·消失",
    "messageInitContent_9652": "你得找财神吧",
    "messageInitContent_9651": "希望今年发财，火神看看我",
    "messageInitContent_9650": "火庇护你",
    "99_112": "野生怪兽未出现",
    "messageInitNick_9390": "梨是战士",
    "99_111": "探索节点未解锁",
    "messageInitNick_9391": "蒜苔魔法师",
    "skillName_229": "光栅",
    "99_110": "集市未解锁",
    "skillName_228": "逢弦·重合",
    "skillName_227": "逢弦·拒",
    "99_116": "每{1}分",
    "skillName_226": "逢弦·引",
    "99_115": "每{1}秒",
    "skillName_225": "逢弦·疗",
    "99_114": "每{1}毫秒",
    "skillName_224": "逢弦",
    "99_113": "是否消耗{1}购买{2}{3}？",
    "skillName_223": "本格·麒麟",
    "messageInitNick_9398": "二点五条什么",
    "99_119": "每{1}周",
    "messageInitNick_9399": "天堂耳环",
    "99_118": "每{1}天",
    "messageInitNick_9396": "蛋挞战士",
    "99_117": "每{1}时",
    "messageInitNick_9397": "特征值探索者",
    "15_16": "{1}秒后可发送",
    "messageInitNick_9394": "代购辣条",
    "15_17": "刚与你一起击败强敌，是否加为好友",
    "messageInitNick_9395": "代码大师",
    "15_18": "离开将不会获得宝箱中的奖励，是否离开？",
    "messageInitNick_9392": "极品男爵",
    "15_19": "上阵怪兽",
    "messageInitNick_9393": "无公害橙子",
    "15_23": "探索者{1}上线了",
    "messageInitContent_7004": "未覆盖收发",
    "messageInitContent_9667": "今晚吃啥",
    "15_24": "离线",
    "messageInitContent_7005": "冷静",
    "messageInitContent_9666": "饿了",
    "15_25": "「五位一体」",
    "messageInitContent_7002": "啥情况",
    "messageInitContent_9665": "开火，烧菜",
    "15_26": "结算中",
    "messageInitContent_7003": "██████████████████████████████████",
    "messageInitContent_9664": "圣火用以净世，而你却用来煎蛋？",
    "messageInitContent_7008": "它在呼唤",
    "15_20": "{1}秒后自动开始战斗",
    "messageInitContent_7009": "它在呼唤它在呼唤",
    "15_21": "房间不存在",
    "messageInitContent_7006": "来，来吧",
    "messageInitContent_9669": "怎么变味了啊",
    "messageInitNick_9389": "效果不错",
    "15_22": "探索者{1}下线了",
    "messageInitContent_7007": "这是？",
    "messageInitContent_9668": "火焰寿司",
    "skillName_222": "本格·青龙",
    "skillName_221": "本格·玄武",
    "skillName_220": "本格·白虎",
    "messageInitContent_7000": "听#￥到……？&#%……&#",
    "messageInitContent_9663": "开火，煎蛋",
    "messageInitContent_7001": "危阿斯顿发生发阿斯顿发森岛帆高发给险",
    "messageInitContent_9662": "火焰不歇，吃货不灭",
    "messageInitContent_9661": "笑谈圣火者，其舌将被烈焰舔尽",
    "messageInitContent_9660": "圣火为证，夜宵开席",
    "messageInitNick_9380": "续写以往",
    "messageInitNick_9387": "富而忧伤",
    "messageInitNick_9388": "炖饭",
    "messageInitNick_9385": "打脸王",
    "messageInitNick_9386": "特长普度众生",
    "messageInitNick_9383": "自走脸盆",
    "messageInitNick_9384": "衣服再买一件",
    "messageInitNick_9381": "学渣要逆袭",
    "messageInitNick_9382": "绕过山河错落",
    "messageInitNick_9378": "斑马线",
    "messageInitNick_9379": "路过的蚂蚁",
    "messageInitNick_9376": "肉的一批",
    "messageInitNick_9377": "甩锅冠军",
    "messageInitNick_9374": "芙蓉鲜蔬汤",
    "messageInitNick_9375": "野孩子",
    "messageInitNick_9372": "短腿小可爱",
    "messageInitNick_9373": "雪莲果先锋",
    "messageInitNick_9370": "坏坏的宝贝",
    "messageInitNick_9371": "呆萌女汉",
    "messageInitNick_9369": "永远可爱",
    "messageInitNick_9367": "芒果君快逃",
    "messageInitNick_9368": "笨猪会发光",
    "messageInitNick_9365": "午餐吃馒头",
    "messageInitNick_9366": "假面骑龙",
    "messageInitNick_9363": "安静就好",
    "messageInitNick_9364": "蝴蝶仙子",
    "messageInitNick_9361": "眉梢带笑",
    "messageInitNick_9362": "火龙果去哪了",
    "messageInitNick_9360": "曙光划破星空",
    "messageInitNick_9358": "先看看属地",
    "messageInitNick_9359": "葡萄柚消灭者",
    "messageInitNick_9356": "开始慌了",
    "messageInitNick_9357": "单枪浪徒",
    "messageInitNick_9354": "指尖上的风景",
    "messageInitNick_9355": "收拾好了",
    "messageInitNick_9352": "水煮薯条",
    "messageInitNick_9353": "唇齿的轮回",
    "messageInitNick_9350": "扛枪萝莉",
    "messageInitNick_9351": "麻辣小龙虾",
    "messageInitNick_9349": "渴望的影子",
    "messageInitNick_9347": "牙签翘地球",
    "messageInitNick_9348": "万能戒指",
    "messageInitNick_9345": "吃货乐园",
    "messageInitNick_9346": "五杀教主",
    "99_167": "移动力不足，是否消耗移动力药水回复100移动力",
    "99_166": "谜……",
    "99_165": "是否删除该录像？",
    "99_164": "[录像]",
    "99_169": "是否消耗{1}钻石重置该契约？",
    "99_168": "是否消耗{1}钻石重置该神灵？（资源全额返还）",
    "darkForestAbilityConfigName_15": "回复同调",
    "messageInitNick_9343": "辅助跟姐抓人",
    "darkForestAbilityConfigName_14": "伤害同调",
    "messageInitNick_9344": "她比塔难守",
    "darkForestAbilityConfigName_13": "防御同调",
    "messageInitNick_9341": "傲娇女王范",
    "darkForestAbilityConfigName_12": "固守同调",
    "messageInitNick_9342": "蛋挞游荡者",
    "darkForestAbilityConfigName_11": "霸气同调",
    "darkForestAbilityConfigName_10": "体力同调",
    "messageInitNick_9340": "爱我要趁早",
    "messageInitNick_9338": "电子木鱼",
    "messageInitNick_9339": "最强亮点",
    "messageInitNick_9336": "灵动的芒果",
    "messageInitNick_9337": "青花瓷",
    "messageInitNick_9334": "实名预定",
    "messageInitNick_9335": "期待的那窗",
    "96_MysteryLair": "谜之巢穴",
    "99_163": "谜之生物",
    "99_162": "觉醒品质",
    "99_161": "不朽品质",
    "99_160": "究极品质",
    "99_178": "概率",
    "99_177": "，解禁时间为{1}",
    "99_176": "是否重新下载游戏资源以修复现有问题？",
    "99_175": "探索者",
    "99_179": "正在{1}",
    "messageInitNick_9332": "柠檬兽",
    "messageInitNick_9333": "迷路的距骨",
    "messageInitNick_9330": "美美下播",
    "messageInitNick_9331": "奇异雪糕",
    "messageInitNick_9329": "大熊宝贝",
    "messageInitNick_9327": "全体起立",
    "messageInitNick_9328": "猕猴桃去哪了",
    "messageInitNick_9325": "鲸鱼到此一游",
    "messageInitNick_9326": "枯萎的花瓶",
    "messageInitNick_9323": "云完就跑",
    "messageInitNick_9324": "爱若寒冷",
    "99_170": "发现新资源版本[{1}MB]，是否开始更新？",
    "99_174": "cjhwy2",
    "99_173": "cjhwy2",
    "99_172": "强制引导很快就会结束！请您再忍耐一下下@@",
    "99_171": "资源更新失败，是否重试？",
    "99_189": "，您的账号当前已被永久封停。",
    "99_188": "可注册数到达上限",
    "99_187": "网络翻船中，是否重试？",
    "99_186": "重试",
    "messageInitNick_9321": "无意识的秘密",
    "messageInitNick_9322": "熊群的科学家",
    "messageInitNick_9320": "懂的都懂",
    "messageInitNick_9318": "搬砖鉴定家",
    "messageInitNick_9319": "感激你曾来过",
    "messageInitNick_9316": "音乐虫子",
    "messageInitNick_9317": "睡觉中",
    "messageInitNick_9314": "超级烤肉串",
    "messageInitNick_9315": "薄荷微微凉",
    "messageInitNick_9312": "假面王子",
    "messageInitNick_9313": "划水泰斗",
    "99_181": "获取登录服配置",
    "99_180": "{1}失败，请检查网络",
    "99_185": "获取服务器列表",
    "99_184": "登录账号",
    "99_183": "获取游戏配置",
    "99_182": "获取版本配置",
    "99_199": "古记战役在排阵里可以配置专属的怪兽，元核和神灵",
    "99_198": "通关王关卡会获得丰富的奖励",
    "99_197": "重置怪兽会返还除金币外的所有养成资源（30级前免费）",
    "messageInitNick_9310": "尬聊机器",
    "messageInitNick_9311": "天涯浪客",
    "messageInitNick_9307": "冰箱软妹贴",
    "messageInitNick_9308": "炒炒炒炒面",
    "messageInitNick_9305": "喧闹的街",
    "messageInitNick_9306": "菠萝兽",
    "messageInitNick_9303": "本菇凉是神",
    "messageInitNick_9304": "除非忍不住",
    "messageInitNick_9301": "枪口给你缝上",
    "messageInitNick_9302": "烧饼分你一半",
    "99_192": "是否观看该录像？",
    "99_191": "分享成功",
    "99_190": "，您的角色当前已被永久禁言。",
    "99_196": "{1}限购（{2}/{3}）",
    "99_195": "<face color=#ffffff dilate=0.52 softness=0.07>游戏版本过低，请下载最新版本。\\n若无法自动跳转，请在 {1} 手动更新，或点击下方按钮复制下载地址：\\n<on click='copyText' param='{2}'><face color=#ff9900 dilate=0.55 softness=0.07><u>复制下载地址</u></face></on></face>",
    "99_194": "是否消耗{1}代金券？",
    "messageInitNick_9309": "收收味",
    "99_193": "Socket连接失败",
    "messageInitContent_7091": "谁在呼唤",
    "messageInitContent_7092": "████████████████████████",
    "messageInitContent_7090": "外神召唤术开启",
    "messageInitNick_9300": "道不清的忧伤",
    "messageInitContent_7095": "懂了是ai",
    "messageInitContent_7096": "这么不智能的吗",
    "messageInitContent_7093": "舔舔怪",
    "messageInitContent_7094": "星之彩！",
    "messageInitContent_7099": "███████████████████████",
    "messageInitContent_7097": "不够疯狂！！",
    "messageInitContent_7098": "抓走一只小沸体",
    "mapEffectConfigName_2": "冰霜之地",
    "mapEffectConfigName_1": "禁疗之地",
    "mapEffectConfigName_4": "炼狱之地",
    "mapEffectConfigName_3": "血战之地",
    "mapEffectConfigName_6": "监禁之地",
    "mapEffectConfigName_5": "压迫之地",
    "skillName_159": "入魂",
    "skillName_158": "Queen·状态变换",
    "skillName_157": "Queen·诡秘祝福",
    "messageInitContent_7015": "又回来了",
    "messageInitContent_9678": "哪哪都有你们这种亵渎者",
    "messageInitContent_7016": "很好",
    "messageInitContent_9677": "看我火焰操控术，煮饭之术",
    "messageInitContent_7013": "兜兜转转",
    "messageInitContent_9676": "火神在上，我的红线是不是点着了",
    "messageInitContent_7014": "完全没在怕",
    "messageInitContent_9675": "绕火而舞，献上我们的心",
    "messageInitContent_7019": "我先过去了~",
    "messageInitContent_7017": "没问题",
    "messageInitContent_7018": "啊它在招手",
    "messageInitContent_9679": "锅盖绝不饶恕你们",
    "messageInitContent_9670": "火神管姻缘的吗",
    "skillName_156": "Queen·惊雷",
    "skillName_155": "Queen·召唤",
    "skillName_154": "Queen",
    "skillName_153": "御·宏",
    "messageInitContent_7011": "它在呼唤它在呼唤它在呼唤它在呼唤",
    "messageInitContent_9674": "竟敢威胁圣火",
    "skillName_152": "御·地",
    "messageInitContent_7012": "它在呼唤它在呼唤它在呼唤它在呼唤它在呼唤它在呼唤",
    "messageInitContent_9673": "不然我去问月老？",
    "skillName_151": "御·天",
    "messageInitContent_9672": "在灰烬中忏悔你的罪行",
    "skillName_150": "御·散",
    "messageInitContent_7010": "它在呼唤",
    "messageInitContent_9671": "火神啊，我不贪，只求一段不被烧焦的恋情",
    "skillName_169": "天雷",
    "skillName_168": "魔物·魔改",
    "messageInitContent_7026": "咯咯咯咯咯咯咯咯咯咯",
    "messageInitContent_9689": "蚊子在上",
    "messageInitContent_7027": "快放我出去！",
    "messageInitContent_9688": "每一个火苗都是火神的化身，你拿去点蚊香？？",
    "messageInitContent_7024": "嘶唔啊啦阿巴",
    "messageInitContent_9687": "圣火不该待在厨房",
    "messageInitContent_7025": "它在呼唤",
    "messageInitContent_9686": "圣火不等人，怎么还没洗完菜",
    "messageInitContent_7028": "请宽恕我……",
    "messageInitContent_7029": "iiiiiiiiiiiiiiiiiiiiii",
    "messageInitContent_9681": "火神在上，我何时脱单？",
    "skillName_167": "魔物·改造III",
    "messageInitContent_9680": "火神在上，今晚吃啥？",
    "skillName_166": "魔物·改造II",
    "skillName_165": "魔物·改造I",
    "skillName_164": "魔物",
    "messageInitContent_7022": "吃饭了吗",
    "messageInitContent_9685": "你们在贬低生活",
    "skillName_163": "入魂·连射",
    "messageInitContent_7023": "咦啊咦啊",
    "messageInitContent_9684": "火神庙不是厨神，别搞了你们",
    "skillName_162": "入魂·结界",
    "messageInitContent_7020": "██████████████",
    "messageInitContent_9683": "吃下火神的怒火",
    "skillName_161": "入魂·保护",
    "messageInitContent_7021": "降临这边吧",
    "messageInitContent_9682": "看锅盖动没动。",
    "skillName_160": "入魂·摄取",
    "skillName_139": "杀生石",
    "skillName_138": "光能·犄",
    "skillName_137": "光能·注",
    "skillName_136": "光能·蚀",
    "skillName_135": "光能·聚",
    "messageInitContent_7037": "拥抱疯狂吧哈哈哈哈哈",
    "messageInitContent_7038": "这是梦吗？",
    "messageInitContent_9699": "你们是带着锅盖的嘲笑者！",
    "messageInitContent_7035": "它在呼唤",
    "messageInitContent_9698": "烧！！",
    "messageInitContent_7036": "我我什么么什么都不不知道",
    "messageInitContent_9697": "好心神借个火吧",
    "messageInitContent_7039": "还是现实？",
    "messageInitContent_9692": "反了反了",
    "skillName_134": "光能",
    "messageInitContent_7030": "███████████████████████",
    "messageInitContent_9691": "竟敢用圣火煎鱼？？？",
    "skillName_133": "空境·凭依",
    "messageInitContent_9690": "火神饿了",
    "skillName_132": "空境·黯羽",
    "skillName_131": "空境·转移",
    "messageInitContent_7033": "那到底是什么声音",
    "messageInitContent_9696": "怪不得那么腥",
    "skillName_130": "空境·合一",
    "messageInitContent_7034": "你们都能听到吗",
    "messageInitContent_9695": "我忏悔，煎鱼用了圣火！",
    "messageInitContent_7031": "哦哦哦噢噢噢哦哦",
    "messageInitContent_9694": "驱逐驱逐它们！！",
    "messageInitContent_7032": "颤抖吧",
    "messageInitContent_9693": "异端都是异端！！",
    "skillName_149": "御",
    "skillName_148": "极地·冰墙",
    "skillName_147": "极地·护佑",
    "skillName_146": "极地·寒风",
    "messageInitContent_7048": "实在是愉悦",
    "messageInitContent_7049": "都疯了吗",
    "messageInitContent_7046": "都是幻觉 一定是幻觉",
    "messageInitContent_7047": "不——————————————",
    "messageInitContent_7040": "它在无意识的旋转旋转",
    "skillName_145": "极地·低温",
    "messageInitContent_7041": "████████████",
    "skillName_144": "极地",
    "skillName_143": "杀生石·摄食",
    "skillName_142": "杀生石·不蛊",
    "messageInitContent_7044": "你看到了吗",
    "skillName_141": "杀生石·真实",
    "messageInitContent_7045": "不 不 不不不不不",
    "skillName_140": "杀生石·黑洞",
    "messageInitContent_7042": "啊呜啊",
    "messageInitContent_7043": "世界在闪了一下",
    "warGrooveConfigDes_12": "敌方战墙起始位置向外移动{?}PX",
    "warGrooveConfigDes_11": "己方战墙起始位置向外移动{?}PX",
    "warGrooveConfigDes_10": "敌方怪兽触碰战墙时，受到{?}真实伤害，每{p1}秒最多触发{p2}次",
    "messageInitContent_7059": "到底是哪里缺失了？",
    "skillName_192": "咒·惧",
    "skillName_191": "咒·亡",
    "messageInitContent_7057": "忘记吧忘记吧把一切都忘记把",
    "skillName_190": "咒·降",
    "messageInitContent_7058": "啊————————",
    "messageInitContent_7051": "谁在呼唤",
    "messageInitContent_7052": "█████████████████████████████",
    "skillName_199": "煞",
    "skillName_198": "壁垒·镇守",
    "messageInitContent_7050": "醒醒醒醒醒醒吧",
    "skillName_197": "壁垒·甲胄",
    "messageInitContent_7055": "嗡嗡……噗嗤嗤……哈哈啊",
    "skillName_196": "壁垒·特化",
    "messageInitContent_7056": "██████████████████",
    "skillName_195": "壁垒·肃清",
    "messageInitContent_7053": "别在盯着我，不要再看着我了",
    "skillName_194": "壁垒",
    "messageInitContent_7054": "不不不，不应该是这样的",
    "skillName_193": "咒·卸",
    "messageInitContent_7068": "别动",
    "messageInitContent_7069": "别看！别看！别看过去",
    "messageInitContent_7062": "喂喂有人吗",
    "messageInitContent_7063": "伊亚伊亚伊…………亚伊亚伊亚",
    "messageInitContent_7060": "能看到我的话吗？",
    "messageInitContent_7061": "███████████████████████",
    "messageInitContent_7066": "阿嘶……兹噜嗤嗡斯……兹",
    "messageInitContent_7067": "谁在呼唤",
    "messageInitContent_7064": "嘶……",
    "messageInitContent_7065": "抓紧！",
    "messageInitContent_7070": "屏住呼吸",
    "skillName_179": "破魔",
    "skillName_170": "天雷·轰击",
    "messageInitContent_7079": "这是什么气味?",
    "messageInitContent_7073": "谁在叫我？",
    "skillName_178": "巽·狂愈",
    "messageInitContent_7074": "沉睡吧",
    "skillName_177": "巽·迷雾",
    "messageInitContent_7071": "千万别看过去",
    "skillName_176": "巽·闪耀",
    "messageInitContent_7072": "不！！！！！！！",
    "skillName_175": "巽·永生",
    "messageInitContent_7077": "声音在我脑海里回荡",
    "skillName_174": "巽",
    "messageInitContent_7078": "别过……别过啊来……",
    "skillName_173": "天雷·零式",
    "messageInitContent_7075": "到这来，快",
    "skillName_172": "天雷·连锁",
    "messageInitContent_7076": "████████████",
    "skillName_171": "天雷·标记",
    "messageInitContent_7080": "它透过空间穿梭而来……",
    "messageInitContent_7081": "演得不错",
    "skillName_181": "破魔·卸甲",
    "skillName_180": "破魔·避战",
    "messageInitContent_7084": "好的",
    "skillName_189": "咒",
    "messageInitContent_7085": "完全没在怕",
    "skillName_188": "投隙·奇迹",
    "messageInitContent_7082": "下一关，下一关在哪里，为什么退出按钮消失了",
    "skillName_187": "投隙·庇护",
    "messageInitContent_7083": "正常点",
    "skillName_186": "投隙·静止",
    "messageInitContent_7088": "到底是谁在深渊呼唤",
    "skillName_185": "投隙·扩散",
    "messageInitContent_7089": "让我看看",
    "skillName_184": "投隙",
    "messageInitContent_7086": "天空碎了一地，有什么东西出来了",
    "skillName_183": "破魔·魔免",
    "messageInitContent_7087": "是kb侠在乱按键盘吗",
    "skillName_182": "破魔·领域",
    "skillName_318": "刻机·心韧",
    "skillName_317": "刻机·摧盾",
    "skillName_316": "刻机·星芒",
    "skillName_315": "刻机·钢魂",
    "skillName_314": "刻机",
    "skillName_313": "胞刺·骸化",
    "skillName_312": "胞刺·侵蚀",
    "skillName_311": "胞刺·紊乱",
    "messageInitContent_9708": "胆敢假扮吾神！",
    "messageInitContent_9707": "我还微波炉神",
    "messageInitContent_9706": "电磁炉神使在此",
    "messageInitContent_9705": "嘿嘿我用电磁炉",
    "messageInitContent_9709": "由来一堆亵渎者！通通去租！",
    "skillName_319": "影替",
    "messageInitContent_9711": "竟敢冒充吾神！",
    "messageInitContent_9710": "空气炸锅神谁与争锋",
    "messageInitContent_9715": "你们停火吧",
    "messageInitContent_9714": "火神在上，凡火皆灵",
    "messageInitContent_9713": "智能炉，预约我的火神",
    "messageInitContent_9712": "都是伪神！",
    "skillName_310": "胞刺·内噬",
    "skillName_329": "构具",
    "skillName_328": "擂槌·律动",
    "skillName_327": "擂槌·回荡",
    "skillName_326": "擂槌·爆轰",
    "skillName_325": "擂槌·逆流",
    "skillName_324": "擂槌",
    "skillName_323": "影替·辅冲",
    "skillName_322": "影替·鼓动",
    "messageInitContent_9719": "我还电磁圣母呢",
    "messageInitContent_9718": "本烤箱萨满表示你们都可以退下了",
    "97_10005": "1.捕抓野生怪兽时需要消耗移动力\\n2.使用捕兽夹可以提升捕捉的成功率\\n3.捕捉成功获得怪兽，捕捉失败则只会获得怪兽碎片",
    "messageInitContent_9717": "笑鼠",
    "97_10004": "进入狩猎模式后，可对附近区域进行无差别搜索，请谨慎选择你的狩猎对象，谁是猎物还不一定呢！搜索并战斗一次后即可进入狩猎排行榜。",
    "messageInitContent_9716": "圣火绝不可熄灭",
    "97_10003": "探索：指派更多怪兽探索不会增加获得的奖励，但会增加遇上其他探索小队时获胜的概率，胜者可以把对方的部分奖励抢过来哟！\\n野生：成功捕捉野生怪兽可以获得整只怪兽，捕捉失败就只能摸到一些碎片啦，对了，使用捕兽夹可以增加捕捉成功率！",
    "97_10002": "他们都战败了，消失在超星洪流中。但它在“重置”时竟然没有把这些战役抹去……如果是你去再做一次选择，能获得胜利吗？排阵吧，探索者。",
    "97_10001": "本周可获得世界灾厄排行奖励的次数，跟朋友们一起击退灾厄吧╰(*°▽°*)╯",
    "97_10000": "-",
    "messageInitContent_9722": "都是串子",
    "messageInitContent_9721": "到底有没有在好好打的",
    "messageInitContent_9720": "看笑了",
    "messageInitContent_9726": "看看这边又整什么幺蛾子",
    "messageInitContent_9725": "新空域我来啦！",
    "messageInitContent_9724": "够了。我是灭火器！",
    "messageInitContent_9723": "烧烤架之王驾到，还不快快迎接",
    "skillName_321": "影替·协防",
    "skillName_320": "影替·助攻",
    "messageInitContent_9729": "伟大的先祖，请赐我勇气与力量，我将取得胜利",
    "messageInitContent_9728": "这是一片信仰先祖之力的空域",
    "messageInitContent_9727": "你听说过祖先的力量吗！",
    "messageInitContent_9733": "先祖说那是神之眼",
    "messageInitContent_9732": "你们也将是遗迹的一部分",
    "messageInitContent_9731": "血归土地，魂归祖灵",
    "messageInitContent_9730": "我太奶说饭后需要用水冲牙",
    "messageInitContent_9737": "呜呜祖拉是在和太奶交流吗",
    "messageInitContent_9736": "先祖之言就是真理",
    "messageInitContent_9735": "战斗也是仪式的一种吗",
    "messageInitContent_9734": "成为仪式的一部分吧",
    "skillName_307": "碫·强韧",
    "skillName_306": "碫·威韧",
    "skillName_305": "碫·继韧",
    "skillName_304": "碫",
    "skillName_303": "蛇噬·誓愿",
    "skillName_302": "蛇噬·祈守",
    "skillName_301": "蛇噬·渗透",
    "skillName_300": "蛇噬·增灭",
    "messageInitContent_9739": "将你的血献给土地，成为仪式的一部分吧",
    "messageInitContent_9738": "聆听先祖的教诲",
    "skillName_309": "胞刺",
    "skillName_308": "碫·抵抗",
    "messageInitContent_9744": "战斗是最激烈的仪式",
    "messageInitContent_9743": "必须畏惧先祖",
    "messageInitContent_9742": "必须敬畏先祖",
    "messageInitContent_9741": "身上的伤疤是先祖的认可",
    "messageInitContent_9748": "献祭你的怯弱",
    "messageInitContent_9747": "让先祖触碰你的恐惧",
    "messageInitContent_9746": "无需害怕离开，它们会指引你",
    "messageInitContent_9745": "祖灵会记住您的呼喊",
    "messageInitContent_9740": "战斗也是仪式的一部分",
    "messageInitContent_9749": "献祭你的元核",
    "messageInitContent_9755": "让先祖触碰你的内心",
    "messageInitContent_9754": "献上你的无知",
    "messageInitContent_9753": "献上你的午餐",
    "messageInitContent_9752": "献上你的钻石",
    "messageInitContent_9759": "献祭你的恐惧",
    "messageInitContent_9758": "先祖始终在等待着我们的回归",
    "messageInitContent_9757": "献出你的进化孢子",
    "messageInitContent_9756": "献上你的恨意",
    "messageInitContent_9751": "让先祖触碰你的灵魂",
    "messageInitContent_9750": "献祭你的金币",
    "messageInitNick_9291": "夕颜蝶泪",
    "messageInitNick_9292": "角落里的阳光",
    "messageInitNick_9290": "那就是萌新",
    "messageInitNick_9299": "无痛养狗",
    "messageInitNick_9297": "不能熬夜",
    "messageInitNick_9298": "铃儿响叮当",
    "messageInitNick_9295": "打卡泰斗",
    "messageInitNick_9296": "菠萝消灭者",
    "messageInitNick_9293": "来点酱油",
    "messageInitNick_9294": "尬聊先驱",
    "messageInitContent_7103": "是什么在耳畔低语",
    "messageInitContent_9766": "你必须记住先祖的话语",
    "messageInitContent_7104": "是什么在大地腐朽",
    "messageInitContent_9765": "不要在头骨旁边窃窃私语，先祖在聆听",
    "messageInitContent_7101": "胡言乱语哥你好",
    "messageInitContent_9764": "听见了吗，先祖的头颅在诉说",
    "messageInitContent_7102": "嗡…………滋……",
    "messageInitContent_9763": "让先祖指引你前行",
    "messageInitContent_7107": "是什么在噩梦回眸",
    "messageInitContent_7108": "一直一直一直一直一直一直一直一直一直",
    "messageInitContent_9769": "献祭你的怒火",
    "messageInitContent_7105": "是什么在天空盘旋",
    "messageInitContent_9768": "献祭你的悲伤，祖灵将赐予平静",
    "messageInitContent_7106": "是什么在海底召唤",
    "messageInitContent_9767": "违背祖灵必遭灾祸",
    "messageInitContent_9762": "献祭你的噩梦",
    "messageInitContent_7100": "又来了？",
    "messageInitContent_9761": "献祭你的灵魂",
    "messageInitContent_9760": "献祭你的饥饿",
    "messageInitNick_9280": "猫咪厂长",
    "messageInitNick_9281": "焦糖玛奇朵",
    "skillName_338": "爆丸·爆破",
    "skillName_337": "爆丸·爆盾",
    "skillName_336": "爆丸·爆压",
    "skillName_335": "爆丸·爆噬",
    "skillName_334": "爆丸",
    "skillName_333": "构具·魔灵星枪",
    "messageInitNick_9288": "进击星人",
    "messageInitNick_9289": "炒菜必粘锅",
    "messageInitContent_7109": "我将无数遍无数遍挑战这里",
    "messageInitNick_9286": "智能辣椒",
    "messageInitNick_9287": "最强碗",
    "messageInitNick_9284": "无奈的猫生",
    "messageInitNick_9285": "小萌神",
    "messageInitNick_9282": "发光体",
    "messageInitNick_9283": "疗伤灵鹿",
    "messageInitContent_7114": "那是禁忌的剩下",
    "messageInitContent_9777": "献上你的誓言",
    "messageInitContent_7115": "快停下",
    "messageInitContent_9776": "献上你的造物许可",
    "messageInitContent_7112": "疯狂将一切吞没",
    "messageInitContent_9775": "献祭你的孤独，祖灵会陪伴你",
    "messageInitContent_7113": "啊是谁在呼喊它的名字",
    "messageInitContent_9774": "祖灵将引导你的刀刃",
    "messageInitContent_7118": "异样不知从何升起",
    "messageInitContent_7119": "怪异不知从何渗入",
    "messageInitContent_7116": "停下",
    "messageInitContent_9779": "先祖从未远离，只是你未曾倾听",
    "messageInitNick_9279": "赛博饺子",
    "messageInitContent_7117": "停下这毛骨悚然的声响",
    "messageInitContent_9778": "这边真的很有仪式感",
    "skillName_332": "构具·偶识木链",
    "skillName_331": "构具·尸胄鬼甲",
    "skillName_330": "构具·灭祖龙炮",
    "messageInitContent_7110": "直至……",
    "messageInitContent_9773": "你的哭泣，先祖将铭记",
    "messageInitContent_7111": "████████████",
    "messageInitContent_9772": "嗯，发现一个不跟队形的",
    "messageInitContent_9771": "献上我的心脏",
    "messageInitContent_9770": "献出你的攻略",
    "messageInitNick_9270": "颗颗蛀牙",
    "messageInitNick_9277": "头铁王",
    "messageInitNick_9278": "笨瓜",
    "messageInitNick_9275": "十二点的凉粉",
    "messageInitNick_9276": "麻木的微笑",
    "messageInitNick_9273": "迷途猫",
    "messageInitNick_9274": "迷人的珠宝",
    "messageInitNick_9271": "一眼万年",
    "messageInitNick_9272": "光棍村村长",
    "messageInitContent_7125": "啊是谁啊胡言乱语",
    "messageInitContent_9788": "它们是你们的未来也是你们的过去",
    "messageInitContent_7126": "啊是谁在哭嚎",
    "messageInitContent_9787": "当星辰汇聚时，祖灵便现身于此",
    "messageInitContent_7123": "啊是谁在哀嚎",
    "messageInitContent_9786": "驱走灾害必先招来灾祸",
    "messageInitContent_7124": "啊是谁在尖叫",
    "messageInitContent_9785": "是时候开始仪式了",
    "messageInitContent_7129": "通往腐蚀异界的消化道",
    "messageInitContent_7127": "啊是我",
    "messageInitNick_9268": "早上四点半",
    "messageInitContent_7128": "邪恶双子",
    "messageInitContent_9789": "不可低估先祖的愤怒",
    "messageInitNick_9269": "洋葱魔法师",
    "messageInitContent_9780": "献祭你的傲慢，祖灵会赐下谦卑",
    "messageInitContent_7121": "诡异不知从何诞生",
    "messageInitContent_9784": "不要与先祖对视，它们能看穿你的灵魂",
    "messageInitContent_7122": "神秘不知从何躁动",
    "messageInitContent_9783": "献出你的迷茫，让祖灵点亮你的道路",
    "messageInitContent_9782": "再多的仪式结果也是一样",
    "messageInitContent_7120": "███████████████████████",
    "messageInitContent_9781": "向先祖低头者，将得到永恒的指引",
    "messageInitNick_9266": "泡面怪客",
    "messageInitNick_9267": "超级红地毯",
    "messageInitNick_9264": "雀斑少女",
    "messageInitNick_9265": "来自文件夹",
    "messageInitNick_9262": "泪眼看世界",
    "messageInitNick_9263": "橙子君快逃",
    "randomEventDialogueGroupConfig_12.99": "算了离开",
    "messageInitNick_9260": "行为艺术家",
    "messageInitNick_9261": "无语草莓",
    "messageInitNick_9259": "贝多芬的寂寞",
    "messageInitNick_9257": "倚栏听风叙",
    "messageInitNick_9258": "闪电快递",
    "messageInitNick_9255": "旧街",
    "messageInitNick_9256": "不爱就坚强",
    "messageInitNick_9253": "蛋挞怪兽",
    "messageInitNick_9254": "福如东海",
    "messageInitNick_9251": "国民女汉纸",
    "randomEventDialogueGroupConfig_12.89": "有一处上坡路一处下坡路。",
    "messageInitNick_9252": "烫烫烫",
    "randomEventDialogueGroupConfig_12.88": "挠痒叫醒",
    "messageInitNick_9250": "我不尬就他尬",
    "randomEventDialogueGroupConfig_12.96": "表示怀疑",
    "randomEventDialogueGroupConfig_12.95": "啊，商店已经搬空了，我懒。",
    "randomEventDialogueGroupConfig_12.98": "去看看",
    "randomEventDialogueGroupConfig_12.97": "那你自己去看看吧，有合适的就拿走别烦我。",
    "messageInitNick_9248": "引战门首席",
    "randomEventDialogueGroupConfig_12.92": "你赢了。再见。",
    "messageInitNick_9249": "万能冰箱",
    "randomEventDialogueGroupConfig_12.91": "下坡路",
    "messageInitNick_9246": "世界第一勇敢",
    "randomEventDialogueGroupConfig_12.94": "离开",
    "messageInitNick_9247": "别来沾边",
    "randomEventDialogueGroupConfig_12.93": "要求真打",
    "randomEventDialogueGroupConfig_12.90": "上坡路",
    "messageInitNick_9244": "石榴之心",
    "messageInitNick_9245": "流浪之旅",
    "messageInitNick_9242": "下辈子见",
    "messageInitNick_9243": "熬夜高手",
    "messageInitNick_9240": "哗啦啦小魔仙",
    "messageInitNick_9241": "白水咖啡",
    "messageInitNick_9239": "站位不行",
    "messageInitNick_9237": "芬尼巧克力",
    "messageInitNick_9238": "迟到的香水",
    "messageInitNick_9235": "模型守护者",
    "messageInitNick_9236": "蛋挞剑客",
    "messageInitNick_9233": "吃剩一口",
    "messageInitNick_9234": "快乐的小鸟",
    "messageInitNick_9231": "半糖甜入心",
    "messageInitNick_9232": "克努姆神",
    "messageInitNick_9230": "丈母娘发货啊",
    "messageInitNick_9228": "生命之水",
    "messageInitNick_9229": "大脑通勤中",
    "messageInitNick_9226": "没钱但不说",
    "messageInitNick_9227": "追月亮的人",
    "messageInitNick_9224": "风火男爵",
    "messageInitNick_9225": "沉浸式吃饭",
    "messageInitNick_9222": "天上天堂",
    "messageInitNick_9223": "不爱比心",
    "messageInitNick_9220": "无公害蒜苔",
    "messageInitNick_9221": "蚂蚁绊大象",
    "messageInitNick_9219": "冒险公主",
    "monsterPolarityConfigDes_17": "受到封印效果时，受到伤害降低{?}%",
    "monsterPolarityConfigDes_16": "受到增益效果时，真实伤害提升{?}%，持续{p1}秒，每{p2}秒最多触发{p3}次",
    "messageInitNick_9217": "香蕉射手",
    "monsterPolarityConfigDes_15": "受到负面效果时，生物屏障提升{?}%，持续{p1}秒，每{p2}秒最多触发{p3}次",
    "messageInitNick_9218": "暴躁寿司",
    "monsterPolarityConfigDes_14": "拥有{p1}个以上（含）的增益效果时，受到伤害降低{?}%",
    "messageInitNick_9215": "骷髅控",
    "monsterPolarityConfigDes_13": "攻击血量低于{p1}%的怪兽时，会使其血量回复效果降低{?}%，持续{p2}秒",
    "messageInitNick_9216": "迷路的花瓶",
    "monsterPolarityConfigDes_12": "攻击拥有{p1}个以上（含）的负面效果的怪兽时，伤害提升{?}%",
    "messageInitNick_9213": "穿越去水底",
    "monsterPolarityConfigDes_11": "攻击有护盾的怪兽时，伤害提升{?}%",
    "messageInitNick_9214": "人类最高质量",
    "monsterPolarityConfigDes_10": "增加自身等级*{?}的移动速度",
    "messageInitNick_9211": "此女人已绝版",
    "messageInitNick_9212": "在线申请对象",
    "messageInitNick_9210": "懒门首席",
    "monsterPolarityConfigDes_19": "死亡时，为附近（{p1}）的所有己方怪兽回复死亡怪兽攻击力*{?}%的血量",
    "monsterPolarityConfigDes_18": "撞击体型小于自己的怪兽时，自身霸气增加{?}%，持续{p1}秒",
    "messageInitNick_9208": "无语葡萄",
    "monsterPolarityConfigDes_28": "远程怪兽攻速提高{?}%",
    "messageInitNick_9209": "谜语人滚出",
    "monsterPolarityConfigDes_27": "怪兽等级上限提升{?}",
    "messageInitNick_9206": "超级打脸神",
    "monsterPolarityConfigDes_26": "血量低于{p1}%时受到伤害，为附近（{p2}）的所有己方怪兽提升{?}%的攻击力，持续{p3}秒，每{p4}秒最多触发{p5}次",
    "messageInitNick_9207": "榴莲魔法师",
    "monsterPolarityConfigDes_25": "击破敌方怪兽时，被击破怪兽产生爆炸造成攻击力*{?}%的范围伤害（{p1}），每{p2}秒最多触发{p3}次",
    "messageInitNick_9204": "心里有点数",
    "monsterPolarityConfigDes_24": "击破敌方怪兽时，敌方怪兽的重生宿命效果血量回复效果降低{?}%",
    "messageInitNick_9205": "重开模拟器",
    "monsterPolarityConfigDes_23": "击破敌方怪兽时，回复攻击力*{?}%的血量",
    "messageInitNick_9202": "小心火烛",
    "monsterPolarityConfigDes_22": "受到致死的伤害时{p1}秒内不会死亡，并获得自身最大血量*{?}%的护盾，每场战斗最多触发{p2}次",
    "messageInitNick_9203": "不用管他",
    "monsterPolarityConfigDes_21": "战斗开始时，获得自身最大血量*{?}%的护盾",
    "monsterPolarityConfigDes_20": "死亡时，为附近（{p1}）的所有己方怪兽提升死亡怪兽攻击力*{?}%的攻击力，持续{p2}秒",
    "messageInitNick_9200": "美少女大佬",
    "messageInitNick_9201": "病娇少女",
    "monsterPolarityConfigDes_29": "近战怪兽基础体力提高{?}%",
    "monsterPolarityConfigDes_37": "增加自身等级*{?}+{p1}的破韧",
    "monsterPolarityConfigDes_36": "增加自身等级*{?}+{p1}的坚韧",
    "monsterPolarityConfigDes_35": "攻击有减速效果的怪兽时，伤害提升{?}%",
    "monsterPolarityConfigDes_34": "怪兽能量上限增加{?}",
    "monsterPolarityConfigDes_33": "受到减速负面效果时，受到伤害降低{?}%",
    "monsterPolarityConfigDes_32": "普通攻击时，追加{?}下普通攻击，每{p1}秒最多触发{p2}次",
    "monsterPolarityConfigDes_31": "全技能等级提升{?}级",
    "monsterPolarityConfigDes_30": "近战怪兽受到伤害时获得{?}%的反伤效果，持续{p1}秒，每{p2}秒最多触发{p3}次",
    "messageInitContent_9700": "演类了",
    "messageInitContent_9704": "消停点吧~",
    "messageInitContent_9703": "红红火火恍恍惚惚",
    "messageInitContent_9702": "愿祂的怒焰吞没愚人之舌",
    "messageInitContent_9701": "火山会告诉你们答案",
    "10_7": "战争号角效果",
    "10_6": "防守（{1}/{2}）",
    "10_5": "进攻（{1}/{2}）",
    "10_4": "每日0时重置",
    "10_3": "确认花费{1}钻石购买{2}次挑战次数",
    "10_2": "每日最多购买{1}次",
    "10_1": "消耗骨、木、鳞各{1}，增加1小时{2}",
    "10_9": "当前时长",
    "10_8": "（怪兽攻击和体力提升{1}%，仅斗技场战斗生效）",
    "originFootingStoneConfigDes_6": "所有种族攻击力+{p1}，体力+{p2}，真实伤害+{p3}，生物屏障+{p4}（双种族怪兽只生效1次）",
    "originFootingStoneConfigDes_5": "木偶族生物屏障+{p1}，远古族生物屏障+{p2}（双种族怪兽只享受{p3}%的效果）",
    "originFootingStoneConfigDes_4": "星灵族真实伤害+{p1}，远古族真实伤害+{p2}（双种族怪兽只享受{p3}%的效果）",
    "originFootingStoneConfigDes_3": "尸鬼族体力+{p1}，远古族体力+{p2}（双种族怪兽只享受{p3}%的效果）",
    "originFootingStoneConfigDes_2": "祖龙族攻击力+{p1}，远古族攻击力+{p2}（双种族怪兽只享受{p3}%的效果）",
    "originFootingStoneConfigDes_1": "所有种族攻击力+{p1}，体力+{p2}，真实伤害+{p3}，生物屏障+{p4}（双种族怪兽只会生效1次）",
    "skillName_279": "赫觞",
    "skillName_278": "炎魔·不灭",
    "messageInitContent_7136": "噩梦啊何时才肯离去",
    "messageInitContent_9799": "每一道伤痕，都是祖灵的祝福",
    "messageInitContent_7137": "循环不朽的噩梦啊",
    "messageInitContent_9798": "献祭你的无助，先祖将给予方向",
    "messageInitContent_7134": "耳朵在枯萎",
    "messageInitContent_9797": "献祭你的软弱，换取祖灵的力量",
    "messageInitContent_7135": "双眼在腐朽",
    "messageInitContent_9796": "在黑暗中倾听，先祖正诉说秘密",
    "messageInitContent_7138": "██爱████",
    "messageInitContent_7139": "████不█████",
    "messageInitContent_9791": "祖灵将铭记你的誓言",
    "skillName_277": "炎魔·灼烧",
    "messageInitContent_9790": "切勿惊扰先祖的沉睡，除非你已做好准备",
    "skillName_276": "炎魔·链式",
    "skillName_275": "炎魔·热解",
    "skillName_274": "炎魔",
    "messageInitContent_7132": "崩坏开始",
    "messageInitContent_9795": "你准备拿什么献给先祖",
    "skillName_273": "沸涌·升华",
    "messageInitContent_7133": "唇舌在腐坏",
    "messageInitContent_9794": "你的恐惧，就是祖灵的食粮",
    "skillName_272": "沸涌·幽狱",
    "messageInitContent_7130": "凝固的黏液",
    "messageInitContent_9793": "先祖一直等待着，你是否准备归来",
    "skillName_271": "沸涌·澎湃",
    "messageInitContent_7131": "███████████████████████",
    "messageInitContent_9792": "你的沉默，也是祖灵的言语",
    "skillName_270": "沸涌·滞流",
    "skillName_289": "崩刃",
    "messageInitContent_7147": "█森之█████████████████████████",
    "skillName_280": "赫觞·酣饮",
    "messageInitContent_7148": "要裂开了",
    "messageInitContent_7145": "████蹄",
    "messageInitContent_7146": "蠕动██",
    "messageInitContent_7149": "大地要裂开了",
    "skillName_288": "惧渗·胆颤",
    "messageInitContent_7140": "████不██",
    "skillName_287": "惧渗·尖嚎",
    "skillName_286": "惧渗·缠搅",
    "skillName_285": "惧渗·肉颤",
    "messageInitContent_7143": "████山█████幼███",
    "skillName_284": "惧渗",
    "messageInitContent_7144": "██████绳结██████",
    "skillName_283": "赫觞·腥风",
    "messageInitContent_7141": "██终████",
    "skillName_282": "赫觞·锈泊",
    "messageInitContent_7142": "███之王",
    "skillName_281": "赫觞·伤蚀",
    "skillName_259": "拟态",
    "skillName_258": "卧龙·降维",
    "skillName_257": "卧龙·熏陶",
    "skillName_256": "卧龙·瑞兽",
    "messageInitContent_7158": "你们是谁的眷属",
    "messageInitContent_7159": "是谁的子嗣",
    "messageInitContent_7156": "潜入深海",
    "messageInitContent_7157": "█液██污染",
    "messageInitContent_7150": "大脑要裂开了",
    "skillName_255": "卧龙·威势",
    "messageInitContent_7151": "一切都要裂开了",
    "skillName_254": "卧龙",
    "skillName_253": "横刀·一闪",
    "skillName_252": "横刀·守势",
    "messageInitContent_7154": "转化……",
    "skillName_251": "横刀·百炼",
    "messageInitContent_7155": "开始转化……",
    "skillName_250": "横刀·破障",
    "messageInitContent_7152": "███的裂缝降临",
    "messageInitContent_7153": "那是████的阴霾",
    "skillName_269": "沸涌",
    "skillName_268": "森荧·魔树",
    "skillName_267": "森荧·怒守",
    "messageInitContent_7169": "怪在微笑",
    "messageInitContent_7167": "那个触感到底是什么？",
    "messageInitContent_7168": "怪在笑",
    "messageInitContent_7161": "███████████████████████",
    "skillName_266": "森荧·魔种",
    "messageInitContent_7162": "是谁的噩梦",
    "skillName_265": "森荧·枯萎",
    "skillName_264": "森荧",
    "messageInitContent_7160": "██的后代",
    "skillName_263": "拟态·智械偶",
    "messageInitContent_7165": "浑身都在战栗",
    "skillName_262": "拟态·禁制灵",
    "messageInitContent_7166": "为什么为什么为什么",
    "skillName_261": "拟态·链路鬼",
    "messageInitContent_7163": "颤抖",
    "skillName_260": "拟态·仿生龙",
    "messageInitContent_7164": "止不住的颤抖",
    "messageInitContent_7178": "魔音贯耳",
    "messageInitContent_7179": "啊我的耳朵",
    "messageInitContent_7172": "怪异的笑",
    "messageInitContent_7173": "这次潜入的是谁的梦",
    "messageInitContent_7170": "怪在狂笑",
    "messageInitContent_7171": "████████████",
    "messageInitContent_7176": "色彩反相，左右倒颠",
    "messageInitContent_7177": "是捕捉灵魂的梦魇",
    "messageInitContent_7174": "是温柔乡",
    "messageInitContent_7175": "是异象人",
    "messageInitContent_7180": "疯狂的狂乱的笛声中██████降临了",
    "messageInitContent_7189": "什么回事",
    "messageInitContent_7183": "光的透镜闪烁着燃烧的辉光",
    "messageInitContent_7184": "嗯？？？",
    "messageInitContent_7181": "那不是喇叭",
    "messageInitContent_7182": "谢谢你杀死比赛",
    "messageInitContent_7187": "啊它又开始呼唤我了",
    "messageInitContent_7188": "突然无法动弹",
    "messageInitContent_7185": "看来这边污染没那么严重",
    "messageInitContent_7186": "███████████████████████",
    "messageInitContent_7190": "是██的束缚术吗",
    "messageInitContent_7191": "还是只是害怕得动弹不得",
    "skillName_291": "崩刃·巨擘",
    "skillName_290": "崩刃·疗殇",
    "messageInitContent_7194": "我也在其中",
    "skillName_299": "蛇噬",
    "messageInitContent_7195": "大家都融合在一起了",
    "skillName_298": "凝视·刻度",
    "messageInitContent_7192": "啊原来我已经不在身体里面了",
    "skillName_297": "凝视·诫约",
    "messageInitContent_7193": "周围在融化",
    "skillName_296": "凝视·禁戒",
    "messageInitContent_7198": "溃烂和撕裂，那是第几层的苦狱",
    "skillName_295": "凝视·咎罚",
    "messageInitContent_7199": "汝，能够掌控█了吗",
    "skillName_294": "凝视",
    "messageInitContent_7196": "再也不分你我",
    "skillName_293": "崩刃·背反",
    "messageInitContent_7197": "这是大家的海洋",
    "skillName_292": "崩刃·星宇",
    "warGrooveConfigDes_9": "己方怪兽触碰战墙时，回复{?}血量，每{p1}秒最多触发{p2}次",
    "warGrooveConfigDes_5": "敌方怪兽触碰战墙时，血量回复效果降低{p1}%，该负面效果无法清除，持续{p2}秒，每{p3}秒最多触发{p4}次",
    "warGrooveConfigDes_6": "敌方怪兽触碰战墙时，受到伤害提升{p1}%，该负面效果无法清除，持续{p2}秒，每{p3}秒最多触发{p4}次",
    "warGrooveConfigDes_7": "敌方怪兽触碰战墙时，移动速度和霸气均降低{p1}，该负面效果无法清除，持续{p2}秒，每{p3}秒最多触发{p4}次",
    "warGrooveConfigDes_8": "敌方怪兽触碰战墙时，攻击力降低{p1}%，该负面效果无法清除，持续{p2}秒，每{p3}秒最多触发{p4}次",
    "warGrooveConfigDes_1": "己方怪兽触碰战墙时，回复{p1}%的最大血量，每{p2}秒最多触发{p3}次",
    "warGrooveConfigDes_2": "己方怪兽触碰战墙时，受到伤害降低{p1}%，该增益效果无法清除，持续{p2}秒，每{p3}秒最多触发{p4}次",
    "warGrooveConfigDes_3": "己方怪兽触碰战墙时，移动速度提升{p1}，该增益效果无法清除，持续{p2}秒，每{p3}秒最多触发{p4}次",
    "warGrooveConfigDes_4": "己方怪兽触碰战墙时，霸气提升{p1}，该增益效果无法清除，持续{p2}秒，每{p3}秒最多触发{p4}次",
    "98_-10021": "鳞已达到存储上限",
    "98_-10020": "木已达到存储上限",
    "98_-10023": "探索者等级{1}解锁",
    "98_-10022": "socket验证不通过",
    "98_-10025": "狩猎目标不存在",
    "98_-10024": "录像已被删除",
    "98_-10027": "无效的兑换码",
    "98_-10026": "探索者账号注册失败，请重新注册",
    "98_-10029": "兑换冷却中，请{1}后再试",
    "98_-10028": "兑换码已兑换",
    "98_-10030": "找不到对应的探索者",
    "98_-10032": "该道具未解锁",
    "98_-10034": "封停中，不能登录{1}",
    "98_-10033": "探索者等级{1}可上阵第{2}只怪兽",
    "98_-10036": "您目前处于禁言状态中{1}",
    "98_-10035": "系统封停中，不能登录{1}",
    "98_-10038": "每日最多发起10次举报",
    "98_-10037": "订单状态为已下单，但是未检测到收款。",
    "98_-10039": "{1}后可以发送",
    "96_CreationStage": "造唤台",
    "messageInitContent_9403": "肉，香香香",
    "messageInitContent_9402": "大舌，舔舔舔",
    "messageInitContent_9401": "天，冷冷冷",
    "messageInitContent_9400": "脚，痛痛痛",
    "messageInitContent_9407": "肉香，怪来",
    "messageInitContent_9406": "蘑菇，有毒",
    "messageInitContent_9405": "牙齿，掉了",
    "messageInitContent_9404": "肚子，叫叫叫",
    "98_-10041": "订单状态为已发货，检测到重复购买限购礼包，留意邮件进行代金券补偿",
    "98_-10042": "订单状态不是已发货，程序根据status进行不同提示处理",
    "98_-10045": "开通鎏金月曜即可解锁该权益",
    "98_-10044": "到达阵容最大上阵数",
    "98_-10046": "种族限制",
    "98_-10049": "该阵容中有怪兽种族不符合条件无法复制",
    "messageInitContent_9409": "朋友，抱抱",
    "messageInitContent_9408": "朋友，打怪",
    "messageInitContent_9414": "点个赞爱你们",
    "messageInitContent_9413": "还在cos原始人",
    "messageInitContent_9412": "天黑，躲火",
    "messageInitContent_9411": "跑慢，会死",
    "messageInitContent_9418": "不睡？",
    "messageInitContent_9417": "不饿？",
    "messageInitContent_9416": "去哪？",
    "messageInitContent_9415": "你走？",
    "messageInitContent_9410": "没水，是坏地",
    "98_-10050": "渠道账号无需转绑",
    "98_-10052": "请{1}后重试",
    "98_-10051": "换绑账号不存在",
    "98_-10054": "验证信息不存在",
    "98_-10053": "账号迁移认证中，暂时无法进入游戏，请耐心等待",
    "98_-10056": "未开放绑定功能",
    "98_-10055": "验证信息已提交，等待审核",
    "messageInitContent_9419": "不走？",
    "messageInitContent_9425": "该吃饭了",
    "messageInitContent_9424": "给你个心心元核",
    "messageInitContent_9423": "是大叉叉地头",
    "messageInitContent_9422": "打得过打",
    "messageInitContent_9429": "该**了",
    "messageInitContent_9428": "该下一关了",
    "messageInitContent_9427": "该睡觉了",
    "messageInitContent_9426": "该喝水了",
    "messageInitContent_9421": "打不过快跑",
    "messageInitContent_9420": "哪里都有本香蕉",
    "3_2007": "招募频道",
    "3_2006": "部落频道",
    "3_2009": "好友数量",
    "3_2008": "发送",
    "3_2001": "聊天",
    "3_2003": "社交",
    "3_2002": "好友",
    "3_2005": "世界频道",
    "3_2004": "邮件",
    "3_2018": "有效期{1}",
    "3_2017": "邮件数量",
    "3_2019": "领取并删除",
    "3_2010": "在线",
    "3_2012": "一键领取",
    "3_2011": "一键赠送",
    "3_2014": "同意",
    "3_2013": "拒绝",
    "3_2016": "全部同意",
    "3_2015": "全部拒绝",
    "98_-10001": "钻石不足",
    "98_-10003": "cjhwy2",
    "98_-10002": "金币不足",
    "98_-10005": "账号尚未注册",
    "98_-10004": "行动力不足",
    "98_-10007": "探索者名称含有敏感信息或特殊字符，请输入英文、中文或数字",
    "98_-10006": "请输入探索者名称（3-12字符）",
    "98_-10009": "探索者名称修改失败，请重试！",
    "98_-10008": "探索者名称已存在，请重新编辑",
    "messageInitNick_9598": "用热吻逃避我",
    "messageInitNick_9599": "依然很装",
    "98_-10010": "账号已存在",
    "98_-10012": "已退出登录队列，请重新登录",
    "98_-10011": "账号异常，请向客服详询",
    "98_-10014": "奖励已领取",
    "98_-10013": "行动力已达到上限",
    "98_-10016": "留言不能超过400个字符，请重新输入",
    "messageInitNick_9596": "尖叫香菜",
    "98_-10015": "你已被禁言",
    "messageInitNick_9597": "天线短路宝宝",
    "98_-10018": "未找到订单记录",
    "messageInitNick_9594": "重新定义爱情",
    "98_-10017": "不如点个赞吧！",
    "messageInitNick_9595": "不要张嘴",
    "messageInitNick_9592": "残酷天使刚你",
    "98_-10019": "骨已达到存储上限",
    "messageInitNick_9593": "钢琴十级",
    "messageInitNick_9590": "第十九个梦",
    "messageInitNick_9591": "狼拿红烧人鱼",
    "messageInitNick_9589": "升个级先",
    "messageInitNick_9587": "城市赛亚人",
    "messageInitNick_9588": "栀子花开",
    "messageInitNick_9585": "额宙斯",
    "messageInitNick_9586": "苹果之谜",
    "messageInitNick_9583": "别黑了别黑了",
    "messageInitNick_9584": "探索营地等你",
    "messageInitNick_9581": "流浪的腰椎",
    "messageInitNick_9582": "都是演技",
    "messageInitNick_9580": "没通过我好急",
    "3_2043": "允许起源殿观战",
    "3_2042": "详细",
    "3_2045": "更换助战怪兽",
    "3_2044": "领取助战奖励",
    "3_2047": "头像框",
    "messageInitNick_9578": "网盘见",
    "3_2046": "头像",
    "messageInitNick_9579": "最爱芒果",
    "3_2049": "未解锁",
    "messageInitNick_9576": "花好月圆",
    "3_2048": "使用",
    "messageInitNick_9577": "水是冰的泪",
    "3_2041": "语言",
    "3_2040": "探索者经验",
    "darkForestEventConfigName_10": "幼体凶兽",
    "messageInitNick_9574": "请你吃拉面",
    "darkForestEventConfigName_11": "幻化凶兽",
    "messageInitNick_9575": "诺贝尔摸鱼奖",
    "messageInitNick_9572": "刚刚好",
    "messageInitNick_9573": "灯光闪闪闪",
    "darkForestEventConfigName_14": "觉醒凶兽",
    "messageInitNick_9570": "哥有四多兰",
    "darkForestEventConfigName_15": "命运之泉",
    "messageInitNick_9571": "英文版分身版",
    "98_-110002": "当未处于触发中的乱入事件",
    "darkForestEventConfigName_12": "究极凶兽",
    "98_-110001": "cjhwy2",
    "darkForestEventConfigName_13": "不朽凶兽",
    "3_2054": "违规名称",
    "98_-110004": "乱入事件类型错误",
    "darkForestEventConfigName_18": "？？？(特殊事件)",
    "3_2053": "违规言论（辱骂）",
    "98_-110003": "cjhwy2",
    "darkForestEventConfigName_19": "神性孢子树",
    "3_2056": "广告消息",
    "98_-110006": "事件未完成",
    "darkForestEventConfigName_16": "终焉之果",
    "messageInitNick_9569": "豆角之心",
    "3_2055": "自定义文本违规",
    "98_-110005": "本次对话异常，请重新选择",
    "darkForestEventConfigName_17": "其他探索者（特殊事件）",
    "3_2058": "其他",
    "98_-110008": "乱入事件-请向特定节点移动",
    "messageInitNick_9567": "我是你的苹果",
    "3_2057": "违法消息",
    "98_-110007": "没有可领取奖励的探索小队",
    "messageInitNick_9568": "不屈访客",
    "messageInitNick_9565": "等待你上线",
    "3_2059": "提交",
    "messageInitNick_9566": "不再心动",
    "3_2050": "正在使用",
    "3_2052": "举报投诉",
    "3_2051": "使用中",
    "11_6": "敌方正在禁用（{1}/2）",
    "11_5": "{1}秒",
    "11_4": "已选择",
    "11_3": "普通地图",
    "11_2": "敌方正在选择",
    "11_1": "未入榜",
    "3_2029": "凿星裂痕",
    "messageInitNick_9563": "深海废墟",
    "3_2028": "领取已达上限",
    "messageInitNick_9564": "村口蹲一狼",
    "messageInitNick_9561": "武林内传",
    "messageInitNick_9562": "安静别说话",
    "11_9": "准备开始",
    "messageInitNick_9560": "火麒麟",
    "11_8": "等待对手连接中",
    "11_7": "请禁用敌方怪兽（{1}/2）",
    "3_2021": "请留下您对这怪兽的评点",
    "3_2020": "领取",
    "3_2023": "{1}后过期",
    "messageInitNick_9558": "不萌少女",
    "3_2022": "限制字数100",
    "messageInitNick_9559": "自制豆浆",
    "3_2025": "推荐添加",
    "messageInitNick_9556": "花恋叶",
    "3_2024": "输入好友名字或id",
    "messageInitNick_9557": "仓库等你",
    "3_2027": "换一批",
    "messageInitNick_9554": "那个法师",
    "3_2026": "申请列表",
    "messageInitNick_9555": "老婆是天",
    "messageInitNick_9552": "金鳞银鳝",
    "3_2039": "已举报",
    "messageInitNick_9553": "专业尬聊",
    "messageInitNick_9550": "掠时刻",
    "messageInitNick_9551": "那份安静",
    "3_2032": "临时邮件",
    "messageInitNick_9549": "那个战士",
    "3_2031": "-",
    "3_2034": "发送信息",
    "messageInitNick_9547": "绿色发光",
    "3_2033": "查找结果",
    "messageInitNick_9548": "腐乳妖怪",
    "3_2036": "切磋",
    "messageInitNick_9545": "老子叫甜甜",
    "3_2035": "添加好友",
    "messageInitNick_9546": "笨吖頭",
    "resoundEventConfigDes_10": "与邪王大战",
    "3_2038": "举报",
    "messageInitNick_9543": "汤圆滚远了",
    "3_2037": "删除好友",
    "messageInitNick_9544": "香菜真好吃",
    "3_2030": "邮件满后自动删除已阅读/已领取奖励的邮件",
    "randomEventDialogueGroupConfig_12.19": "用力点",
    "messageInitNick_9541": "下雨收衣服啦",
    "randomEventDialogueGroupConfig_12.16": "问它哪里不舒服",
    "messageInitNick_9542": "前方说书反应",
    "randomEventDialogueGroupConfig_12.15": "它完全不想起来的样子，一直扒拉在地上。",
    "96_MarketNode": "集市",
    "randomEventDialogueGroupConfig_12.18": "你发现完全拉不动神秘商人。",
    "messageInitNick_9540": "苹果射手",
    "randomEventDialogueGroupConfig_12.17": "双手拉它起来",
    "randomEventDialogueGroupConfig_12.12": "它看到你了，但没有说话。",
    "randomEventDialogueGroupConfig_12.11": "-",
    "randomEventDialogueGroupConfig_12.14": "尝试唠嗑",
    "randomEventDialogueGroupConfig_12.13": "问好",
    "messageInitNick_9538": "怀中抱软猫",
    "messageInitNick_9539": "漫展显眼包",
    "messageInitNick_9536": "鸡头贼稳",
    "randomEventDialogueGroupConfig_12.21": "哈，你哪只眼看到我不舒服了。现在躺着，我舒服得很。",
    "messageInitNick_9537": "月亮私藏温柔",
    "randomEventDialogueGroupConfig_12.20": "放手",
    "messageInitNick_9534": "知识宝库",
    "messageInitNick_9535": "拆不穿的谎言",
    "messageInitNick_9532": "跟风流浪",
    "messageInitNick_9533": "马上是多久",
    "3_2081": "昵称框",
    "3_2080": "对话框",
    "messageInitNick_9530": "山不语",
    "messageInitNick_9531": "百事小甜饼",
    "messageInitNick_9527": "明明很可爱",
    "messageInitNick_9528": "复仇乞丐",
    "messageInitNick_9525": "与幸福有约",
    "randomEventDialogueGroupConfig_12.10": "-",
    "messageInitNick_9526": "独揽清风醉",
    "messageInitNick_9523": "但别把他当天",
    "messageInitNick_9524": "匿名博士",
    "messageInitNick_9521": "单挑你的吻",
    "messageInitNick_9522": "老鹰的秘密",
    "messageInitNick_9529": "射线",
    "randomEventDialogueGroupConfig_12.38": "由它离开",
    "messageInitNick_9520": "葡萄真好吃",
    "randomEventDialogueGroupConfig_12.37": "追上",
    "randomEventDialogueGroupConfig_12.39": "它没有做出任何反应。",
    "randomEventDialogueGroupConfig_12.34": "就这样躺着",
    "randomEventDialogueGroupConfig_12.33": "它察觉到你的到来，但依然躺在地上。",
    "randomEventDialogueGroupConfig_12.36": "它一听便光速滚远了。",
    "randomEventDialogueGroupConfig_12.35": "戳一戳它",
    "3_2065": "稍后评价",
    "messageInitNick_9516": "我大意了啊",
    "randomEventDialogueGroupConfig_12.41": "说再见",
    "3_2064": "马上评价",
    "messageInitNick_9517": "别再停下来",
    "randomEventDialogueGroupConfig_12.40": "继续问好",
    "3_2067": "设置",
    "messageInitNick_9514": "光轮扫地机",
    "randomEventDialogueGroupConfig_12.43": "问它为什么躺着",
    "3_2066": "成就",
    "messageInitNick_9515": "理智值直降",
    "randomEventDialogueGroupConfig_12.42": "慢走不送。",
    "3_2069": "斗技场等级",
    "messageInitNick_9512": "闻道者",
    "3_2068": "世界探索度",
    "messageInitNick_9513": "强壮复读神",
    "messageInitNick_9510": "萌兽使者",
    "messageInitNick_9511": "镶金键盘侠",
    "3_2061": "最近{1}条记录",
    "3_2060": "获得助战奖励",
    "3_2063": "嘿，探索者您喜欢我们的游戏吗？如果您享受您的探索之旅，不妨和更多人分享您的故事和体验，我们期待您的评价！",
    "messageInitNick_9518": "刀工无敌",
    "3_2062": "{1}秒后可以再次搜索",
    "messageInitNick_9519": "可乐加冰",
    "randomEventDialogueGroupConfig_12.27": "早上好，中午好，下午好，晚上好。你可以走了。",
    "randomEventDialogueGroupConfig_12.26": "硬嗑",
    "randomEventDialogueGroupConfig_12.29": "让它好好经营",
    "randomEventDialogueGroupConfig_12.28": "问它是否开始营业了",
    "randomEventDialogueGroupConfig_12.23": "不管它离开",
    "randomEventDialogueGroupConfig_12.22": "说只是关心它一下",
    "randomEventDialogueGroupConfig_12.25": "软嗑",
    "randomEventDialogueGroupConfig_12.24": "……",
    "3_2076": "已申请",
    "messageInitNick_9505": "辣椒先锋",
    "randomEventDialogueGroupConfig_12.30": "它捂住了一处可能是声音接收器官的部位。",
    "3_2075": "阵容",
    "messageInitNick_9506": "抱歉我喜欢它",
    "3_2078": "个人信息收集清单",
    "messageInitNick_9503": "玩水水",
    "randomEventDialogueGroupConfig_12.32": "靠近喊",
    "3_2077": "第三方信息收集清单",
    "messageInitNick_9504": "车上旅行",
    "randomEventDialogueGroupConfig_12.31": "加大音量喊",
    "messageInitNick_9501": "脑子被猪亲了",
    "3_2079": "联结",
    "messageInitNick_9502": "宇宙风",
    "messageInitNick_9500": "巨大化饼干",
    "3_2070": "起源殿等级",
    "3_2072": "暴走旷野击破数",
    "messageInitNick_9509": "猕猴桃摆动",
    "3_2071": "部落繁荣度排名",
    "3_2074": "未解锁",
    "messageInitNick_9507": "哈哈哈哈密瓜",
    "3_2073": "凿星裂痕通关",
    "messageInitNick_9508": "小脸红扑扑",
    "messageInitContent_11093": "你说得都对，但你就是凶手",
    "messageInitContent_11092": "你这个视角很奇怪",
    "randomEventDialogueGroupConfig_12.59": "给它灌鸡汤",
    "messageInitContent_11095": "键盘广告位招募",
    "messageInitContent_11094": "这是搞笑本吧",
    "randomEventDialogueGroupConfig_12.56": "它挪了一下身子挠了一下屁股，没有理你。",
    "randomEventDialogueGroupConfig_12.55": "放弃解释离开",
    "messageInitContent_11091": "我已经洞悉了一切",
    "randomEventDialogueGroupConfig_12.58": "和它讲收益",
    "messageInitContent_11090": "缺1快上车",
    "randomEventDialogueGroupConfig_12.57": "和它讲责任",
    "randomEventDialogueGroupConfig_12.63": "打商人了！打商人了！",
    "randomEventDialogueGroupConfig_12.62": "说只是逗它玩",
    "randomEventDialogueGroupConfig_12.65": "问它有没有事",
    "randomEventDialogueGroupConfig_12.64": "它艰难爬起，并开始作呕。",
    "messageInitContent_11097": "v我50",
    "messageInitContent_11096": "鼠标广告位招募",
    "messageInitContent_11099": "好耶",
    "randomEventDialogueGroupConfig_12.61": "说它就是神秘商人",
    "messageInitContent_11098": "这里就算飞行棋得终点了",
    "randomEventDialogueGroupConfig_12.60": "别叫了，别叫了！我不是神秘商人。你找错人了。",
    "messageInitContent_11082": "私我得天降一掌秘籍",
    "randomEventDialogueGroupConfig_12.49": "冲过去卡住它的退路",
    "messageInitContent_11081": "功夫怪兽",
    "randomEventDialogueGroupConfig_12.48": "它开始滚远。",
    "messageInitContent_11084": "夯",
    "messageInitContent_11083": "emmm",
    "randomEventDialogueGroupConfig_12.45": "它滚得太快了，你并没有跟上。",
    "randomEventDialogueGroupConfig_12.44": "离开",
    "messageInitContent_11080": "二胡达人",
    "randomEventDialogueGroupConfig_12.47": "离开",
    "randomEventDialogueGroupConfig_12.46": "尝试寻路",
    "randomEventDialogueGroupConfig_12.52": "离开",
    "messageInitContent_11089": "因为有我的怕怕",
    "randomEventDialogueGroupConfig_12.51": "问它为什么不理你",
    "randomEventDialogueGroupConfig_12.54": "胡乱解释",
    "randomEventDialogueGroupConfig_12.53": "能否解释一下你在干嘛？",
    "messageInitContent_11086": "这里轮到梅花哥了",
    "messageInitContent_11085": "梅花宝典！",
    "messageInitContent_11088": "这是我的世界",
    "randomEventDialogueGroupConfig_12.50": "它没有回答你。",
    "messageInitContent_11087": "有没有可能是梅花妹妹",
    "messageInitContent_11071": "红色的觉醒，蓝色的幻化",
    "messageInitContent_11070": "不要让我看到圆圈",
    "messageInitContent_11073": "围观群众表示不动",
    "messageInitContent_11072": "隐藏的恶魔在低语",
    "randomEventDialogueGroupConfig_12.78": "你盖好树皮后，发现树皮原来的位置下方有点什么。",
    "randomEventDialogueGroupConfig_12.77": "还是不管它算了",
    "randomEventDialogueGroupConfig_12.79": "拿走",
    "messageInitContent_11079": "下一关gogo",
    "randomEventDialogueGroupConfig_12.85": "改从它身后抱它起来",
    "messageInitContent_11078": "赢了",
    "randomEventDialogueGroupConfig_12.84": "它仍旧躺在地上。",
    "randomEventDialogueGroupConfig_12.87": "它完全睡过去了的样子。",
    "randomEventDialogueGroupConfig_12.86": "离开",
    "messageInitContent_11075": "艾在这里呀",
    "randomEventDialogueGroupConfig_12.81": "你看我像是没事的样子吗。啊不行，别说了，我难受，只要你别说下去你想干嘛我都答应你。",
    "messageInitContent_11074": "咚咚咚咚咚咚咚咚",
    "randomEventDialogueGroupConfig_12.80": "管它呢",
    "messageInitContent_11077": "分析进行中",
    "randomEventDialogueGroupConfig_12.83": "提出与它交易",
    "messageInitContent_11076": "闪光：我是谁，我在哪",
    "randomEventDialogueGroupConfig_12.82": "提出挑战它",
    "messageInitContent_11060": "丸子的牌面",
    "messageInitContent_11062": "请问和樱桃小丸子有什么关系",
    "messageInitContent_11061": "我们绿化带都是花丸子",
    "randomEventDialogueGroupConfig_12.67": "提出要交易",
    "randomEventDialogueGroupConfig_12.66": "它开始打盹。",
    "randomEventDialogueGroupConfig_12.69": "摇醒它",
    "randomEventDialogueGroupConfig_12.68": "它睡着了。",
    "messageInitContent_11068": "吃我重力锤",
    "randomEventDialogueGroupConfig_12.74": "找个东西给它盖上",
    "messageInitContent_11067": "吃我龙骨巨锤",
    "randomEventDialogueGroupConfig_12.73": "它完全没有要醒来的样子，甚至还说了几句梦话，你隐约听到什么，我干，好好我干，保证营业额达标，我保证！",
    "randomEventDialogueGroupConfig_12.76": "捡起树皮给它盖上",
    "messageInitContent_11069": "别吃我锤子！",
    "randomEventDialogueGroupConfig_12.75": "你看到附近有一块很大的树皮。",
    "messageInitContent_11064": "可怕捏",
    "randomEventDialogueGroupConfig_12.70": "它试图从没有被你卡住的地方滚开。",
    "messageInitContent_11063": "重装丸子",
    "messageInitContent_11066": "吃我超级大锤",
    "randomEventDialogueGroupConfig_12.72": "由它滚",
    "messageInitContent_11065": "吃我雷神之锤",
    "randomEventDialogueGroupConfig_12.71": "立刻冲回去另一边",
    "messageInitContent_11051": "可怕",
    "messageInitContent_11050": "赛马娘是吧",
    "messageInitContent_11057": "行！",
    "messageInitContent_9436": "沼泽，危险",
    "messageInitContent_11056": "行？",
    "messageInitContent_9435": "锤子，危险",
    "messageInitContent_11059": "不行！",
    "messageInitContent_9434": "你~在~干~嘛~",
    "messageInitContent_11058": "真行？",
    "messageInitContent_9433": "你有事？",
    "messageInitContent_11053": "救命",
    "messageInitContent_11052": "四舍五入御空也是！",
    "messageInitContent_9439": "危险危险危险",
    "messageInitContent_11055": "命运的分岔路",
    "messageInitContent_9438": "魅妆，危险",
    "messageInitContent_11054": "吃我一拳",
    "messageInitContent_9437": "火，危险",
    "messageInitContent_9432": "你好？",
    "messageInitContent_9431": "你有火？",
    "messageInitContent_9430": "你能看远？",
    "godContractConfigName_13": "开局补给",
    "godContractConfigName_14": "预支未来",
    "godContractConfigName_11": "神性共鸣",
    "godContractConfigName_12": "神权威压",
    "godContractConfigName_10": "神力接续",
    "messageInitContent_11040": "又见面了",
    "godContractConfigName_17": "神之哀恸",
    "godContractConfigName_18": "能量激荡",
    "godContractConfigName_15": "炼狱天堂",
    "godContractConfigName_16": "虚假消耗",
    "messageInitContent_11046": "两个参赛选手对吧",
    "messageInitContent_9447": "剑，好尖！",
    "messageInitContent_11045": "曾在打字比赛中获得第二名",
    "messageInitContent_9446": "眼，好贱！",
    "messageInitContent_11048": "看看谁血量最多",
    "messageInitContent_9445": "眼，好大！",
    "messageInitContent_11047": "作为东方高手，区区弹幕",
    "messageInitContent_9444": "爱空",
    "messageInitContent_11042": "我是entp",
    "messageInitContent_11041": "大家好我是狮子座",
    "messageInitContent_11044": "嗯？？",
    "messageInitContent_9449": "龙，好热！",
    "messageInitContent_11043": "大师算算我什么时候暴富",
    "messageInitContent_9448": "草，好草！",
    "messageInitContent_9443": "遇空，幸运",
    "messageInitContent_11049": "是它是它就是它",
    "messageInitContent_9442": "遇空，幸福",
    "messageInitContent_9441": "点头",
    "messageInitContent_9440": "你们好怪~",
    "messageInitContent_11035": "单纯的响度战争我的镇魂是不会输的",
    "messageInitContent_9458": "哎吼！哎吼！哎吼！",
    "messageInitContent_11034": "万物皆可模拟",
    "messageInitContent_9457": "咕嘎！咕嘎！",
    "messageInitContent_11037": "地龙的扫面仪疯狂工作中",
    "messageInitContent_9456": "呜嗷嗷～",
    "messageInitContent_11036": "沉默了",
    "messageInitContent_9455": "哎吼！",
    "messageInitContent_11031": "施下肥",
    "messageInitContent_11030": "浇下水",
    "messageInitContent_11033": "还有个割草的吗",
    "messageInitContent_11032": "还有个创晓打光灯",
    "messageInitContent_9459": "嘎巴~",
    "messageInitContent_9450": "咕嘎！",
    "messageInitContent_11039": "被污妖王拐了？",
    "messageInitContent_9454": "呜嗷嗷～",
    "messageInitContent_11038": "我的崩怎么跑这里来了",
    "messageInitContent_9453": "咚咚！",
    "messageInitContent_9452": "咕噜噜～",
    "messageInitContent_9451": "哇咕！",
    "messageInitContent_11024": "黯灭：？？？",
    "messageInitContent_9469": "肉肉肉肉肉肉肉肉肉肉肉肉！",
    "messageInitContent_11023": "当然是跟幻幻合照",
    "messageInitContent_9468": "咕噜噜～咕噜噜～",
    "messageInitContent_11026": "咚咚咚咚咚咚咚咚锵",
    "messageInitContent_9467": "哎吼哎吼哎吼肉",
    "messageInitContent_11025": "是兄弟，就来玩",
    "messageInitContent_9466": "哇咕！肉来咯！",
    "messageInitContent_11020": "真不是旅行青蛙",
    "messageInitContent_11022": "放开魅妆！",
    "messageInitContent_11021": "来来来拍照",
    "messageInitContent_9461": "哇咕！",
    "messageInitContent_9460": "巴嗷嗷嗷嗷嗷嗷嗷！",
    "messageInitContent_11028": "比心心",
    "messageInitContent_9465": "咕嘎咕嘎，肉来咯！",
    "messageInitContent_11027": "玩这么大",
    "messageInitContent_9464": "呼咕~~",
    "messageInitContent_9463": "咔啦咔啦！",
    "messageInitContent_11029": "皇城PK来吧",
    "messageInitContent_9462": "咕嘎！咕嘎！",
    "traceStarName_2": "凿星裂痕关卡2",
    "traceStarName_1": "凿星裂痕关卡1",
    "traceStarName_4": "凿星裂痕关卡4",
    "traceStarName_3": "凿星裂痕关卡3",
    "traceStarName_6": "凿星裂痕关卡6",
    "traceStarName_5": "凿星裂痕关卡5",
    "traceStarName_8": "凿星裂痕关卡8",
    "traceStarName_7": "凿星裂痕关卡7",
    "traceStarName_9": "凿星裂痕关卡9",
    "messageInitContent_11013": "道理我都懂，剩下的几只什么回事",
    "messageInitContent_11012": "方舟玩家在此",
    "messageInitContent_9479": "哎吼！哎吼！",
    "messageInitContent_11015": "这不是我的我的初号姬",
    "messageInitContent_9478": "巴嗷嗷嗷嗷嗷嗷嗷！",
    "messageInitContent_11014": "疾风兔别拿着奇怪的东西乱戳啊",
    "messageInitContent_9477": "咔啦咔啦！",
    "messageInitContent_11011": "小萝卜乖乖",
    "messageInitContent_11010": "萝卜别哭",
    "99_1014": "木偶族",
    "messageInitContent_9472": "哎吼！",
    "99_1013": "星灵族",
    "messageInitContent_9471": "咔啦咔啦！",
    "99_1016": "原生族",
    "messageInitContent_9470": "咕嘎！",
    "99_1015": "远古族",
    "messageInitContent_11017": "我最爱的泳装环节呢",
    "messageInitContent_9476": "咕嗷咕嗷",
    "99_1017": "彼岸族",
    "messageInitContent_11016": "还在建设中吗",
    "messageInitContent_9475": "咕嘎！咕嘎！",
    "messageInitContent_11019": "怎么就站到了我的对面",
    "messageInitContent_9474": "呜啦呜啦！",
    "messageInitContent_11018": "可怕除了风干还有烘干",
    "messageInitContent_9473": "嘎嘎嘎！呜啦呜啦！",
    "messageInitContent_11002": "好大的黑桃",
    "messageInitContent_11001": "祈是坦克驾驶员吗",
    "messageInitContent_11004": "什么大炮，明明是手电筒",
    "messageInitContent_9489": "呼呼咕~~",
    "messageInitContent_11003": "冲呀",
    "messageInitContent_9488": "哎吼！哎吼！",
    "messageInitContent_11000": "开炮！",
    "messageInitContent_9483": "咔啦！",
    "messageInitContent_11009": "啊这个金色的上升气流",
    "messageInitContent_9482": "哇咕哇咕哇咕",
    "messageInitContent_9481": "咕嗷咕嗷",
    "messageInitContent_9480": "呜嗷嗷～",
    "messageInitContent_11006": "好大的刀",
    "messageInitContent_9487": "咔啦咔啦！",
    "messageInitContent_11005": "没有进错关卡",
    "messageInitContent_9486": "嗷嗷嗷嗷嗷嗷",
    "messageInitContent_11008": "该不会是……",
    "messageInitContent_9485": "呼呼咕~~",
    "messageInitContent_11007": "家人们谁懂啊",
    "messageInitContent_9484": "咚咚咚咚咚咚咚咚咚咚咚咚",
    "messageInitContent_9490": "咔啦！",
    "messageInitContent_9499": "咔啦咔啦！",
    "messageInitContent_9494": "哇咕哇咕哇咕",
    "messageInitContent_9493": "嗷嗷嗷嗷嗷嗷",
    "messageInitContent_9492": "咕嗷咕嗷",
    "messageInitContent_9491": "巴嗷嗷嗷嗷嗷嗷嗷！",
    "messageInitContent_9498": "吼吼吼吼吼吼吼吼",
    "messageInitContent_9497": "巴嗷嗷嗷嗷嗷嗷嗷！",
    "messageInitContent_9496": "咚咚咚咚咚咚咚咚咚咚咚咚",
    "messageInitContent_9495": "呜嗷嗷～",
    "99_1012": "尸鬼族",
    "99_1011": "祖龙族",
    "99_244": "总战力提升",
    "99_243": "暂无进化光谱",
    "99_242": "{1}元核髓",
    "99_241": "[联结共鸣]",
    "99_248": "浮空巨塔上阵",
    "99_247": "源初境上阵",
    "99_246": "是否消耗{1}彩钻兑换{2}钻石？",
    "99_245": "总战力下降",
    "99_249": "共鸣试炼{1}上阵",
    "99_240": "红色品质",
    "99_255": "制造伤害时，降低坚韧产生的效果#只影响坚韧产生的效果，下限0",
    "resoundEventConfigDes_1002": "这是一处宽敞的园厅。由好几根粗壮高大的带枝树干，将数块大兽皮错落地支起撑开围城，各式巨大的雕纹兽骨穿插装饰其中。单块兽皮由数面兽皮缝制而成，树皮搓成的绳子把它们缝成一片。阳光透过兽皮落入账内，为圆厅增添了些许肃穆。\\n远方依稀可见一座塔的轮廓。这座塔就是各族怪兽的首领聚集于此的原因。\\n近一个月内，超进化大陆陆续出现了若干座石塔。它们从山野僻地里一座巍峨的石塔突然出现，并渐渐引起大家的注意。虽然石塔的数量还不超过十座，却让几个远古族的老智者们忧心忡忡。它们拿着比自己还要老上千年的猪皮卷，告诉酋长神剑古拉姆，石塔将会带来大灾难。\\n古拉姆是远古族三大部落的酋长之一。它对剑术有着由衷热爱，曾梦想着像远古的英雄那样砍杀邪王，但随着年岁渐增，它意识到统领部落得到强大的进化、抵御其它种族的滋扰才是它要真正面对的。智者们的话让古拉姆有点担心，憧憬是一回事，但那些故事，它一直把它们当作传说。古拉姆心中确实有一丝大灾难降临的期望不假，古老的英雄曾和邪王作战……给我一位邪王吧。\\n此时的古拉姆并不知道，它的梦想会以一种出乎意料的方式化为现实，它也不会预料到，接下来那场闹剧般的会议，将会为决定大陆命运的重大事件拉开帷幕。\\n在老智者的唠叨下，古拉姆和另外两个酋长商量后，决定邀请龙族、灵族、木偶族和尸族的族长来讨论。三个酋长都有点担心，大家能好好说话吗？特别是龙族族长那个傲慢的家伙，派去邀请的怪兽几乎被它打个半死回来。\\n不过，好歹大家都来了。\\n园厅中央放着一块长石，老智者们把猪皮卷摊开在上面，根据里面已经模糊不清的字迹和图画解释石塔和大灾难的关系。\\n“上次出现石塔是在一千年前，石塔出现没多久，邪王降临大地，它带来疯狂的杀戮。再上一次出现石塔是在两千年前，然后也是邪王和大灾难。”\\n一位智者向猪皮卷的另一端笨拙地挪动身体，试图在一个笔触模糊的东西上，辨认出邪王的身影。这张卷轴是远古族的流传下来的古物，上面字迹不清，句子残缺不全，从片言只语中推测它们的全貌是这些智者的工作。它们很早就放弃了体格上的进化，只为把所有能量集中到头脑中。\\n“哈哈哈哈哈哈哈！”钢铁龙王巴萨克忍不住爆发出一阵狂傲的笑声，笑声中夹杂着铁矿沙石互相摩擦的回响，“你要告诉我们，远古族的祖先打败邪王，结束了大灾难？”\\n“古籍上是这样记载的。”\\n另一位智者皱着眉头，不满地看着巴萨克，它正在一张新的猪皮卷上用碳石画下这次会议的情景。除了研究古籍，它最大的兴趣就是画画，虽然画技一言难尽，各位族长和酋长在它笔下就像歪歪扭扭的神秘符号。\\n“如果大家能以远古族为首，齐心合力对抗邪王——”第三位智者埋头摩挲着猪皮卷上的某段文字，完全没有留意古拉姆制止它说下去的眼色。\\n这智者！这样说和让各族臣服于远古族的统治有什么两样？说不定巴萨克明天就会带着龙族来挑战。古拉姆担忧地想到。\\n“把石塔毁掉，全部毁掉！”灵族族长苏比斯尖锐地抗议道。\\n“石塔，石塔，唔……或许有其它可能……”第三位智者停下了摩挲着猪皮卷的手，埋头喃喃自语。\\n“真的是毁掉石塔就可以了吗？”古拉姆问。\\n“那还用说！”苏比斯是最强的搜魂兽，据说它收集的灵魂都藏在斗篷下面。只要掀开斗篷就能听到无数灵魂的凄鸣。\\n“石塔就是鱼饵，邪王是为了咬到鱼饵追来的巨骨鱼，大灾难是鱼屎，只要鱼饵消失，巨骨鱼也会转头离开，我们也不需要清扫鱼屎。唔！唔！”苏比斯激动地挥舞镰刀，沉浸在自以为是的逻辑之中。\\n“那么挂上鱼饵的是谁？呵呵……我懂了，一定是来自异世界的灵魂。”\\n此时一直沉默的木偶族族长疤脸史卡非斯突然莫名其妙地胡说八道起来，它身体上的关节因激动发出吱嘎吱嘎的声音。木偶族笃信自己是被远古魔法师制造出来的生物，但魔法师早已离开，只徒留一群能自我繁衍的躯体。它们虽然有自我意识，但又相信自己的灵魂被魔法师放逐到虚空的宇宙中。\\n“那是无垠的黑暗！”\\n“超越梦境的魔法师的流星！”\\n“死神翼间的飞羽！”\\n“亡魂的梦魇！”\\n两个族长无休止的跨频道对话完全超出了大家的理解。\\n“它们在说什么？”圣盾埃癸斯一脸茫然地看着古拉姆。\\n埃癸斯是远古族另一个部落的酋长，它是古拉姆的挚友。远古族第三个部落的酋长月夕则一脸慈爱地看着它们。\\n“它们感情真好……”月夕由衷地感叹。这位美丽圣洁的女神能从任何事情中解读出它的正面意义。\\n古拉姆看向尸族的族长，尸王寇斯金正在做深蹲，对它来说，随时随地锻炼肌肉才是最重要的。\\n古拉姆有点头疼，它预料到会议不会进行得太顺利，但现在情况有点超出它的控制。\\n“咳咳。”它清了清嗓子，转向钢铁龙王巴萨克，“如果你们不相信古籍上的记载，那么今天为何远道而来？”\\n古拉姆绞尽脑汁，说出一个老智者们教过它的文绉绉的词语。它比巴萨克年轻，所以尽量想表现出一个酋长应有的庄重。\\n不料这句话像一根鞭子抽在巴萨克脸上，它一贯目中无人的表情不见了，取而代之的是一种被挫败后的愤恨。\\n“石塔里面有东西！”巴萨克低吼着，“如果那就是邪王，那么邪王只是躲在塔里不敢出来接受挑战的胆小鬼！”\\n“你是说塔里面有某只怪兽？”古拉姆不禁握紧了随身携带的长剑。\\n“它不属于我们任何一族。我还以为会在远古族智者的口中得到答案，看来是我高估你们了。”钢铁龙王回想起自己几乎被塔中巨兽喷出的烈焰烧融的情景，心里打了个冷战，但它倨傲的表情掩饰了这份恐惧。\\n“你到过石塔里面？你输了？你被塔里的怪兽赶了出来？”一位智者不留情面地问道。\\n“那只是一次试探！”族长的身份不容许巴萨克撒谎，但它也不愿承认。\\n“我们也去看看！”埃癸斯摩拳擦掌。\\n“不，你们要去不同的石塔！”喜欢画画的智者振奋地说。它突然从那堆猪皮卷中抬起脑袋，眼中闪烁着兴奋的战意。刚才一不小心，它把“会议记录”画到古老的猪皮卷上去了，这怪不得它，古老的书卷和新的画卷交叠在一起。然后，它无意中在一个它们一直解读不出的符号上画了几笔。\\n“我终于知道石塔里有什么了！”它喊道。\\n“是那个神秘的符号吗？”第三个智者急切问道。\\n“对，我解读出来了！就在刚才！”\\n“可以告诉我们您到底发现了什么吗？”古拉姆耐着性子打断几个智者的话。\\n“每个石塔里都藏着一个宝藏！”喜欢画画的智者激动攥紧猪皮卷，“只要得到那个宝藏，就能获得巨大的进化，打败邪王！”\\n“对啦！那个象征着神秘魔法阵的符号，你要说它是宝藏，这种比喻也勉强及格，但根本不是什么大发现吧？”\\n另一个智者不服气地问道，第三个智者则担心地看着随时会被拽坏的猪皮卷。\\n“魔法的事为什么不来请教我？”疤脸史卡非斯质问道，“木偶族最擅长魔法了！”\\n“它们想独自进化！”搜魂兽苏比斯加入指控的阵营。\\n“把魔法阵抢过来！”钢铁龙王巴萨克冲过去抢猪皮卷。\\n“锵”的一声，一把大剑挡在智者和钢铁龙王之间！大剑击中石桌，火花四溅。\\n“让它把话说完！”\\n古拉姆握着大剑跳到智者身前，埃癸斯也拿起了坚盾，月夕一脸担心地看着大家，但古拉姆知道如果她要强行“帮助”大家好好相处友情万岁的话，力量是也很强大。虽然三个远古族的酋长只是究极级，比已经进化到不朽级的钢铁龙王要低，但三人合力，一定能让巴萨克很难看。",
    "99_254": "破韧",
    "resoundEventConfigDes_1003": "天杀的，这群人根本不关心大陆的命运，古拉姆恼怒地想。\\n没有人比它更渴望进化了。远古族的不朽前辈在一百年前的大陆战争中牺牲，那是一场龙族挑起的战争，上一代的龙族首领逆焰龙王妄想称霸大陆。但即使这样，即使自己在邪王降临前没有进化成功，只要钢铁龙王愿意背负起保护大陆的使命，自己也会听它的指挥舍命而战。\\n智者们躲在古拉姆的大剑后面，渐渐壮起胆子来。\\n“那不是魔法阵。你们看这里，把这一划、这一点、还有这里连上……”智者用碳石把一块残缺的图案重新描绘了一遍，“看！这是不是很像一个盘子？”\\n这是它刚才描绘圆厅的长石时发现了，古老猪皮卷上的“盘子”就像长石的缩小版，不过更扁，而且中间凹陷进去了一大块。\\n“那上面这几条线表示什么？难道表示这块盘子干净得闪闪发光吗？”第二位智者明显很妒忌同僚的发现，语气中带着点找茬的意味。\\n“也有可能上面放着的才是宝藏。”第三个智者猜测到。\\n“无论如何，远古的英雄是因为得到这块盘子才获得进化，打败邪王！”喜欢画画的智者对自己的表现很满意，它已经称呼那东西为“盘子”了，“三位酋长，你们要去不同的石塔，找到里面的盘子，获得进化。”\\n“不用麻烦你们，石塔里的宝藏是我的！”巴萨克已经快步流星跑出帐篷，它输过一次，绝对不会输第二次，更不允许这些低等的究极怪兽超越自己。\\n“嘿嘿嘿，别白费劲了，只有——哎呀……”\\n喜欢画画的智者刚说到一半，就被另外两个同僚同时制止，一个想捂着它的嘴巴，另一个干脆把它撞倒在地上。\\n“只有什么？”搜魂兽苏比斯眯起眼睛，疑心地看着三个智者。\\n“只有……当然是只有我们的酋长才是最终的胜利者。”\\n“哼，远古族太骄傲了！”苏比斯鄙夷地看着古拉姆。\\n古拉姆强忍怒火，它看出智者们肯定有什么不想让其它族长知道的事情。\\n“为什么把邪王引来的石塔，会帮助我们进化？”苏比斯继续问到。\\n“影随光生，我们都走在光与影之间。可能，这就是古老真神给我们的试炼吧。既漠视我们，又怜悯我们。”月夕感叹。\\n“宝藏被龙王抢走，只有结实的肉体才能在大灾难中活下来。”尸王寇斯金终于发表了自己的意见，说话的同时还在努力地做俯卧撑。\\n“那个宝藏，说不定是来自遥远宇宙的灵魂……”疤脸史卡非斯说。\\n会议不欢而散。古拉姆猜到四族族长很快会到不同的石塔中争夺宝藏，不只它们，还有各族怪兽……石塔前即将掀起自相残杀的腥风血雨。如果钢铁龙王能再次进化——尽管大家都不知道凌驾于不朽之上的会是什么——带领大家打败邪王的话，它愿意听从龙王的差遣，冲锋陷阵，以最悲壮的姿态牺牲，作为英雄被超进化大陆铭记。\\n“钢铁龙王不会得逞的。”喜欢画画的智者看出古拉姆的心思。\\n“卷轴里最重要的信息，幸好刚才没有说出来。”第二位智者责备地瞄了它的同僚一眼，对方羞愧地干咳了一下。\\n各族族长离开后，它们又恢复了平日冷静和狡黠。\\n“能够通过石塔的宝藏获得进化的，只有远古族。”第三位智者说。\\n龙族居于超进化大陆东方的熔火之巅，灵族喜欢南方温暖的沼泽地带，皮糙肉厚的尸族认为北方的冰川谷能更好锻炼它们的体魄，木偶族则笃信大陆西南部古树秘境中的众多湖泊藏着神秘的灵魂。远古族聚居在大陆西部草原和丘陵地带。\\n世界树一共有七棵，它们分布在超进化大陆的森林中，是这里生命最悠久的生物。智者们常说是世界树把天与地撑开，然后才有了这片大陆和所有生物。世界树会长出进化孢子和强化孢子，两种孢子永不停歇地随风飘散到大陆的每个角落。以前，经常有怪兽不远千里地来到世界树下，等待彼此粘附成团的孢子团飘落到自己口中，但是不知从何时开始，进化孢子似乎失去了作用，强化孢子也如同鸡肋一般地存在，怪兽们失望而归。\\n而现在，突然有一种东西能让大家继续进化，这对大陆来说是令人振奋的消息，不过如果能进化的只有远古族，远古族就会成为大家的敌人。\\n会议之后，智者们向三位酋长讲起了那个比邪王和大灾难更古老的传说。那是三位酋长刚降生时就听过的摇篮曲——\\n在还没有太阳和月亮的远古，\\n那时世界还在无垠黑暗的宇宙中飘浮，\\n古老的神，睿智又慈爱，\\n在大陆播下生的希望，\\n缔造者把自己的血、肉和伟大的形态留下，\\n远古族，大陆最初始的生命，\\n铸造高山，\\n浇灌泽国，\\n肥沃森林，\\n开辟道路，\\n之后，多彩的生命纷至沓来。\\n古神离开，\\n往另一片大陆创造富足的世界……\\n古拉姆当然熟悉这首曲子，然而歌词却早已忘得差不多，大概只记得唱的是古神创造了远古族和超进化大陆的故事，不过，对其它种族来说，一定也流传大同小异的歌词，唯一不同的是神创造的第一批生命是各自的种族。\\n“这和那个宝藏有什么关系？难道那是神专门留给远古族的礼物吗？”古拉姆问。\\n“可能是神，也可能是和远古族有同一血脉的上古生物。如果那只盘子只能让远古族获得进化，那很可能和上古生物有关。”一位智者说。\\n“我们从何而来，将去往何处……”另一位智者低喃。\\n“我明白了。不过，我可不想当什么天选之子。我希望远古族不是注定最强，而是经历了无数磨炼变成最强。”古拉姆说。\\n“说得没错！”埃癸斯说。\\n两人意气相投地对视一眼。\\n“好啦，和荣誉相称的力量就靠各位酋长去争取吧，我们几个老头子只想趁此机会了解一下远古族的过去。”\\n古拉姆的动身有点仓促，三位酋长是被智者们催促着出发的。在离开之前，它们还得到了智者的祝福和赠礼——几个揉进了进化孢子和强化孢子的火山湖水藻团。它们是其中一位智者昨晚通宵做出来的，它的志向是当一位厨师，可惜大家对“味道”这种东西毫不在意，让它非常失落。\\n“你们就当是路上的干粮吧，饥饿的时候一定要好好品尝老夫的心意。”这位智者热泪盈眶地说，“等三位回来，应该进化成不朽的首领了。”\\n埃癸斯舔了舔团子，直率地皱起眉头。\\n“我们会好好珍惜的。”月夕珍重地捧起水藻团子，细细地闻了一下它的味道，“这就是所谓的苦口良药吧。”\\n“苦口？不对——”\\n“那我们走了！”古拉姆制止智者继续说下去。\\n它朝大家点点头，把大剑插回身后，转身跑开，埃癸斯和月夕也快步追上去。\\n“最近的石塔在那里。”当大家都走出古拉姆的部落后，埃癸斯指着远方一座模糊的塔顶说。塔身被低矮的树林挡着，看不到塔下的情景，说不定那里已经聚满了要争夺宝藏的怪兽。\\n“我们要一起去吗？”月夕有点担心地问。\\n“不，我们还是按照智者的建议，分头行动。”古拉姆说，“凭我们最快的速度，赶去那里只需要半天的时间。”\\n“恐怕宝藏已经被钢铁龙王拿走了。”月夕说。\\n“唔……无论如何还是要去确认一下。”\\n“古拉姆，那座塔就交给你了。”埃癸斯说，“我要先回部落布置好防线。”\\n埃癸斯的部落处于三个部落的最前沿，偶尔来自木偶族和灵族的滋扰，都是由埃癸斯带领战士来对付的。埃癸斯一直把守护三个部落的重任放在自己肩上。\\n“好！”古拉姆也不跟它客气。 \\n“祝你一路顺风，武运昌隆。”月夕说。\\n古拉姆点点头，转身离去。\\n“听说南边也有一座石塔，我就去那里看看吧。不过，再次之前，我也要回部落一趟。”月夕说，“啊啊，请你不要误会，我绝对不是信不过你的守卫工作，只是日夕最近一直说看到紫色的光点，我有点担心她的眼睛。”\\n日夕是月夕的妹妹，最近沉迷颜术，一直贴在镜子前欣赏自己的美貌。月夕担心妹妹会得眼疾。\\n“请代我向日夕小姐致以最诚挚的问候。”埃癸斯对女士总是彬彬有礼的。",
    "99_253": "受到伤害时，降低怪兽受到的伤害#效果只受破韧影响，下限0",
    "99_252": "坚韧",
    "resoundEventConfigDes_1001": "空气潮湿而凝滞，红色和绿色的细小光点弥漫其中。\\n这些光点是从一棵参天巨树上飘下来的。小小的光点在飘散的时候与其它光点粘附在一起，形成像毛鬼葡萄或硬山栗般大小的光团。\\n这就是可以激发超进化大陆所有生物潜能的必须品——进化孢子和强化孢子。\\n一只暴龙站在世界树下，正在捕捉一些个头比较大的孢子团。它已经站在树下老半天了，下巴不断滴着口水，焦躁早已爬上那张爬虫类的脸上。\\n终于，一个比硬山栗还要大的绿色孢子团飘浮到暴龙头顶，是进化孢子。它飞身一跃，张大牙齿向外龇着的大嘴，把孢子团吞进肚中。然后，它急切地看着自己的身体，期待某种变化。\\n一股热流从它的肚中涌向全身。\\n“吼！吼！”暴龙喊了几声。\\n热流很快消散在它的四肢和尾端。但是，除了身上的疲劳感消除了一点点，身体并没有任何变化。它既没有长出双翼，也没有长出铁质的犄角和背刺。\\n暴龙愤怒地嘶叫着。它以为！它真的以为！只要吃到足够大的孢子团就能进化！所以它才像傻子一样子在树下站了三天三夜！可是什么都没有！\\n暴龙用头部不断撞击粗壮的树干来泄愤。古老的世界树不为所动，任由这只可怜的生物把它周围的空气和光团搅动得更乱。\\n就在暴龙绝望地诅咒着，正要离去的时候，一个孢子团飘到它眼前。这个孢子团比毛鬼葡萄还要小，但闪烁着诡异的紫色。\\n世界树从来没有飘落过紫色的孢子。\\n暴龙的眼珠随着孢子团的飘动打转，但是它的脑袋并没有用来思考这个怪异之处。紫色的孢子团在它眼中，更像烦人的黑沼蝇，惹它生气。暴龙一口把孢子团吃掉，可是对手太小了迅速滑进它的肚子里，让它想用牙齿狠狠咬碎的想法落空。\\n暴龙不满地哼哼两声，转身离开。反正大伙都很久没有进化了，它的也没有进化并不算丢脸。\\n就在它踏出第二步时，熟悉的热流再次从它肚中涌向全身，但它带来的热量更高、更迅猛。炙热在暴龙的血管中奔腾，似乎要冲破这具粗厚的血肉。\\n“吼——！！”暴龙禁不住一声长嘶。\\n热量变为新的血肉、新的犄角，还有弯刃般的双翅从暴龙体内长出来。肌肉撕裂的痛楚让暴龙的嘶鸣在森林中久久回荡。\\n不，现在应该称它为荒火龙。诡异的孢子团让暴龙进化了。\\n荒火龙的形态渐渐稳定下来，刚才的阵痛也退去了。进化是这样痛苦的吗？自己从陆龙进化的时候好像没有经历这种痛苦？\\n不过现在不是回忆的时候，荒火龙惊喜地看着全新的身体，那双小短腿被锋利强壮的前爪代替！它试着飞，起初摇摇晃晃地、但经过短暂的适应后很快就飞到森林空中。浓雾依旧，但它能看到浓雾覆盖到更遥远的地方，一些矮树的树冠像墨绿的蘑菇一样点缀在浓雾中。这种新的视角让它相当心满意足。\\n正当这只新的荒火龙打算回部落炫耀一番时，一把极具诱惑力的嗓音在它耳边响起。\\n“亲爱的信徒，来到我身边……”\\n荒火龙有点犹豫。\\n“来吧……”\\n轻柔的嗓音穿过它的头骨，在它的脑里植入了一道不容拒绝的命令。\\n荒火龙转身，往森林的西边飞去。",
    "99_259": "积分说明",
    "99_258": "立刻登入《超2》！{1}输入邀请码{2}，跟我一起超进化！",
    "99_257": "已复制邀请码，可分享到聊天频道喔",
    "99_256": "【长id】{1}\\n【昵称】{2}\\n【短id】{3}\\n【区服】{4}\\n【sid】{5}\\n",
    "resoundEventConfigDes_1008": "哈灵顿·欧文最喜欢的电影是《大空头》。\\n险中求胜的刺激感只是其次，他最着迷的是那种在大数据中寻找真相、众人皆醉我独醒的领先感。\\n现在，他坐在宽敞的单人办公室，欣赏着窗外被落日余晖染成金色的林立高楼。\\n这间办公室，是他上一周用几个干脆利落的操作换来的。虽说次贷危机已经过去好几年，但历史总是惊人地相似。上周在数字货币资产价值蒸发的6500亿美元中，欧文通过某些市场操作为客户赚了100亿。再上一周，他在几个债券因违约停止交易前把它们抛售一空，虽然它们的评级都在AA级以上，但这只是因为地方政府做了担保，由政府担保的债券，永远都要小心。\\n这几次交易，让欧文得到了能让他一辈子过得很轻松的奖金，这个26岁的青年才俊不但惊艳了他任职的金融服务公司，还让他在圈子中小有名气，猎头挖角的电话和电邮络绎不绝。\\n但是，欧文依旧每天起早贪黑，在他的新办公室做着分析和研究。\\n虽然近几次交易中，欧文都是以做空为主，但他不是一个悲观主义者，他只是习惯在欣欣向荣的经济环境下寻找说真话的数据，应该说他是一个务实的猎人。\\n窗外满眼的高楼就像一棵棵镶金戴银的摇钱树，在这片森林中，他梦想寻找一棵大家都忽视的、却能像杰克的豌豆般在某个时机快速成长的摇钱树。\\n昨天董事会还告诉欧文，他可以建立自己的基金组，拥有自己的团队，掌控一定的现金流。明天，他将会面对几个重要的客户，汇报将来的投资策略。所以，他打算今晚在办公室里通宵检查所有的数据和投资章程中的每一个字。\\n时间在欧文的指尖和键盘间快速流逝，金色的夕阳余晖很快被第二天的朝霞代替，这条特别的街道显现出它的另一种美，互助互利、生机勃勃、共享财富。\\n欧文泡了杯黑咖啡，到洗手间整理了一下仪容，须后水、男士润肤乳、发胶、再喷上淡淡的古龙水，很好，年轻的脸颊依旧光滑，一点也看不出熬夜的痕迹。然后回到办公室，换上预先准备的一套西装，时间才来到七点。\\n欧文有点压力肥，但在剪裁得当的西装修饰下，也算是仪表堂堂，并有着一股和年龄不匹配的成熟感和可靠感。\\n再检查一遍所有材料，只能用“完美”来形容。\\n时间来到八点。\\n街上已经阳光普照，它展露出稍有变化的一面，繁华、匆忙、每个人只关心自己的口袋。\\n投资者们准时到了。\\n欧文把大家请进会议室，打开投影，已经打过上百遍腹稿的投资策略从口中娓娓道来。看着这几个比狐狸还狡猾的客户，表情渐渐从怀疑变得感兴趣，欧文知道自己成功地迈出了第一步。\\n接下来是客户提问的环节，在专业的数据调查分析下，欧文对此也是信心满满的。\\n“既然区块链能轻易抹去中间商的作用，为什么我们还要继续对它进行投资？”一个客户问道。\\n“因为——”\\n无懈可击的回答被突如其来的闪电雷鸣打断，万里晴空劈下来一道闪电。会议室里的人都惊讶地望着窗外可怕的电光。\\n而完全封闭着的会议室内竟然吹起了一股旋风，旋风越吹越激烈，把桌上的文件吹得乱七八糟。一时间，大家不知道是继续惊讶窗外的情况，还是震惊室内的异变。\\n纸张锋利的边缘刮过欧文的脸颊，他不由得举起手护住头部，低下头的同时，才发现自己的双脚竟然在旋风中慢慢离地上升！\\n欧文被旋风卷向落地玻璃窗，在他准备着被玻璃撞得头破血流的时候，却看到自己的身体似乎化为灵体穿过玻璃，飘出窗外。\\n天空好像被撕开了一条缝，但周围的人都只顾着跑到安全的地方躲避闪电，谁也没有看到这个奇景。\\n只有欧文一个人看到了，因为他正随着旋风穿过那道裂缝。\\n窗外的电闪雷鸣停止了，会议室内的旋风也停歇了，纷纷扬扬的纸张都散落地面后，大家却发现欧文不知所踪。窗户没有破损，一直躲在门边的助理也确认门没有被打开过。\\n简直就像密室失踪事件一样。",
    "resoundEventConfigDes_1009": "一切就像电影一样。《大空头》之前自己还看过什么电影呢？好像是《阿凡达》，那时只不过想和心仪的女孩有共同话题，但欧文很快就发现自己不属于那种高中生多姿多彩的小团体，电影中的一切他也觉得荒唐和无聊。但现在想不到电影中的故事竟然发生在自己身上。\\n不过，欧文花了5分钟不到就理解了所有情况。\\n异世界、合体、打怪，这些本来和他不是同一个次元的事情，他不但接受了，还在5分钟内想了好几种离开异世界的对策，其中包括了类似《盗梦空间》中脱离梦境的极端对策。但因为存在不确定性，所以不敢这么做，最重要的是自己似乎丧失了对身体的控制权。如果死亡才能离开的话，那么在以后的战斗中故意放水求死就可以了。\\n“那个，拜托你了。”\\n虚空中，一个形体和人类很相似的生物握着欧文的双手，诚恳地说道。\\n“……一定是哪里出错了，我并不擅长战斗，我在另一个世界里也不是战士型的人物。”\\n彼此的语言是相通的，看来把自己召唤而来的力量把这些琐碎的问题都解决了。另外，说对方是怪物好像有点无礼，即使以人类的角度来看也是个美女。\\n“不会的，你要相信自己！智慧也是重要的战斗力，你一定是一位以智慧取胜的英雄。”\\n“……即使你这样说，我也没有义务为你们战斗。我现在只想回去。”\\n“说不定……古神希望你通过战斗找到类似的意义。啊，抱歉，这种话让你很困扰吧。在你帮助我的同时，我会想想怎么送你回去的。你对这个世界还很陌生吧？我给你到外面介绍一下？”对方非常善解人意地说道。\\n“暂时只有这样了。”\\n说完，欧文和对方的意识重新合为一体，视角再次变得一致。完全镇定下来的他开始仔细观察这座奇怪的石塔。\\n绝美的少女高兴地亮起身后巨大的弯月，好像坐在一人座的天舟上绕着石塔内壁疾驰了好几圈。那股兴奋劲，和欧文拥有第一辆车的时候一模一样。和跟他解释这个异世界时成熟温柔和体贴的样子不同，对方现在完全是一个无拘无束的活泼少女。听她说，这是她渴望已久的进化形态。\\n风从脚下拂过，这时欧文才意识到自己正“穿”着一条裙子，不过，他并没有趁机偷窥谬的邪念，他好歹是个高素质的知识分子，而且大脑还在高速处理一切所见所闻，只能分出些许心思来习惯穿着女装的违和感。\\n不过，欧文的心情也因为少女的兴奋稍微放松了一点。\\n“对了，名字，我还不知道你的名字呢！”\\n跑着跑着，对方突然来了个急刹，正儿八经地问道。\\n“哈灵顿·欧文。大家都叫我欧文。”\\n“我叫月夕。”\\n“很好听的名字。”\\n“谢谢。”\\n名为月夕的少女又恢复了端庄的仪态，能看出刚才的无拘无束是她偶尔才会露出来的一面。\\n交换了名字之后，两者之间的联系、以后一起作战的信赖度似乎更深了一点。\\n“那么，我们出去吧。”月夕说。\\n原来石塔把外面激烈的打斗声完全屏蔽了。\\n月夕已经隐去了那钩弯月座驾，欧文和她一起站在塔门口，两者共用的身体依旧笼罩在塔内的阴影中。\\n一开始，欧文还以为是一群乌合之众在塔外混战，后来渐渐发现原来是两支小型战队在厮杀。\\n叫“灵族”的一方——这是月夕快速通过意识交流告诉他的——一边用引力攻击来改变对方的动作，一边用一种奇怪的能力吸引无数陨石砸向石塔。一时间，流星雨洒满天际。另一方是由不同怪兽组合而成的战队，他们毫无章法地乱打一通，但压倒性的力量让灵族渐渐不敌，而且他们脸上都有一种虔诚的表情，让他们与对手轻易地区分开来。\\n“这种表情，我好像在哪里见过。”欧文听到月夕对他说。\\n这时，一只怪兽想冲进石塔，但很快被身后的敌人扯了下来。\\n“我们要打败他们逃出去吗？”欧文问。\\n“逃？不，我们要阻止大家。这样……这样的战斗太残忍了……”即使是通过意识交流，欧文也能听到月夕的声音在颤抖。\\n身体不由自主地往前踏出一步。\\n“啊，等一下！”欧文这才发现自己完全没有身体的控制权。\\n塔外是大概二十人，不，是二十只怪兽的混战，就这样出去，就像掉进暴雨中的泥潭的鲜花，马上会被粗暴的雨水碾碎身体吧！\\n不过，出乎意料的是，众怪兽见到从塔内出来的月夕，都停下战斗。\\n“你……你拿到里面的宝物了？”一个灵族问道。\\n“宝物？你说这个吗？”月夕说。\\n欧文看到自己的双手捧起一个小小的方盘子，材质近似东方璞玉，大小和办公室用来装名片或者钥匙的小盘子差不多。\\n“这是什么？”另一个灵族问。\\n“嗯！它是古神的礼物，它帮助我得到进化！”月夕双手虔诚地捧高盘子，盘子中还有飘浮着微弱的幽幽绿光。\\n“嗤……”欧文不禁觉得好笑，但这份轻视很快被月夕捕捉到了。\\n“不可以哦，欧文先生，对古神要永远保持敬畏和感激。”\\n“啊，抱歉……”\\n不妥啊，太过明显的想法会像说话一样被对方听到，以后想另拟计划的时候只能暗暗打算。欧文马上克制住自己的不安，把思维调到和月夕同步。\\n“吼！我们晚了一步！”混搭战队中一只陆龙愤怒地叫道。\\n“我们走吧！”一只尸族腐化者忿忿不平地带头转身离去。\\n“不杀一下吗？有王的祝福，我们一定打败她！”一只木偶族的轮脉兽跃跃欲试地说。\\n混搭战队分成了犹豫的两方，而另一边的灵族战队则在窃窃私语，他们的目标好像是石塔本身，月夕的出现一时之间让他们不知如何是好。\\n“一群没用的胆小鬼，我先来！第一个得到王的爱，是我！”轮脉兽甩动绑在脖子上的像流星锤、又像车轮一样的武器，冲向月夕。\\n圆轮卷起旋风！\\n欧文无法控制身体闪躲，月夕依旧站在石塔门外，不打算抵抗、也不打算攻击。\\n要死了吗？能回去吗？这个念头还没来得及闪过脑际，手中已亮起一枚弯月。弯月放出的柔和光芒照亮了石塔前的整片空地。被月光照到的怪兽全都感到精神焕发，激战的折磨和伤痛一下子从他们的身上消去。\\n比星光耀眼、比阳光柔和、是肉眼可见的温柔的光芒。怪兽们沐浴在圣光中，感受着筋疲力尽的身体恢复精力的舒适感。离月夕最近的轮脉兽已经停下动作，陶醉在柔和强大的如母亲般的“怀抱”中。\\n月夕继续释放强大的治疗力量。\\n然而——\\n很快，轮脉兽带着迷醉的表情倒下了，一个接一个的怪兽带着同样的满足感倒下，就像陷入绵长的睡梦中。\\n当月夕完成治疗、睁开眼睛后，完全被眼前的景象吓到了。\\n“啊！大家……”\\n身体无力地瘫坐在地上，欧文感觉自己可以在月夕惊呆的时候控制身体，于是站起来向前走了两步。\\n“只是睡着了。”\\n他查探了一下怪兽们的鼻息。\\n“啊……太好了……”月夕松了一口气。\\n“你……很强吗？”欧文问。\\n“也不是……如果你指战斗力的话。不过，我的治疗效果还不错，通过刚才的进化，这份力量又强大了一点了吧。”\\n欧文感觉到自己的脸庞在略带羞赧和自豪地微笑着。\\n“嗯……可能因为治疗得太过头了，他们需要暂时昏睡一会儿来消化你的治疗之力，就像人类长身体的时候会发烧一样。”\\n“是这样吗？那就好！”\\n开心起来的月夕自然而然地重新掌握了身体的控制权。\\n“……”月夕念了一段欧文听不懂的咒语。\\n“你在念什么？”\\n“祝福祷文，我在祝福他们永远相亲相爱。”\\n“这、这也行？如果我的世界拥有这种力量，每个国家都会扔掉自己的核武器吧？”\\n“核武器？那是什么？”\\n“简单来说就是用来互相威胁的武器，迫不得已要使用的话，就得抱着毁灭世界或同归于尽的觉悟。”\\n“你的世界，比这里更可怕呀！”月夕有点同情地说道，“不过，我的力量也不是你想象中的那么夸张啦，只是他们在战斗的时候，会稍微有点阻力而已，‘啊，对方好像是我的朋友’，大概会产生这样的念头。”\\n好强……一开始以为月夕是个新手战士的欧文，现在才意识到对方是个强大得可怕的女神般的存在。\\n“你这样夸奖我，我会不好意思的。”月夕立刻意识到欧文的想法。\\n“这是真情实感的赞叹。对了，我们接下来要去哪？”\\n“先跟我回部落如何？我向你介绍大家。”月夕再次唤出银月座驾。\\n其实根本不需要询问自己，自己只能跟月夕一起行动，不过这样也好，和这位强大的女神合体，起码自己的性命是安全的。\\n“你说，用这座石塔来做古神的神殿，怎么样？”\\n“不错的想法。”\\n“还有呀……那个……合体后，我们变成什么样子了？相貌应该有点变化吧，回去要好好找镜子照一下。”\\n“我也没有见过自己女装的样子，有点忐忑啊。”\\n……\\n欧文和月夕在愉快的交谈中离石塔越来越远。",
    "99_251": "复制成功",
    "resoundEventConfigDes_1006": "月夕衷心希望超进化大陆永远和平丰饶、怪兽们永远健康平安。\\n每个怪兽在刚出生到幼体的阶段都曾怀揣过懵懂幼稚的、但在漫长而艰辛的进化道路上体会到弱肉强食的残酷后渐渐放弃的理想。\\n但月夕不同，她比任何怪兽都要有信念。无论经历多少战斗、悲悯多少生死，她的理想丝毫不会动摇。她相信终有一天，心中的乌托邦终会建立。\\n笃信着性本善的月夕，属于那种身负不为凡胎所理解的使命的天选者。\\n月夕的部落几乎都由她的信众组成。一部分和她怀着相同的理想，另一部分就是纯粹地信赖并喜爱着她。对后者来说，只要是月夕，不管她是要实现万物平等的乌托邦也好，建立秩序分明的阶级统治也好，他们都会支持到底。\\n究其原因，是由于月夕宝石般的美貌和善良的品格所带来的巨大吸引力，深度崇拜者便成为她信众中的后者。\\n昼夜都闪烁着柔光的银发、比蓝宝石更清澈的眼睛、和内心一样圣洁姣好的容颜、天籁般的嗓音、优雅苗条的身段、能随时出现在身后的仿佛女神座驾般的弯月，这一切让月夕无论走到哪里都能成为焦点。\\n仿佛在呼应酋长的美貌，月夕部落的建筑也比古拉姆和埃癸斯的部落更精致一点。\\n部落的西边和东边分别是月之殿和日之殿。两座大殿均由石头砌成，小巧古朴，顶部和门口都是曲线优美的拱形。部落中的房屋多以木头搭成，它们点缀在蜿蜒流过树林的小溪旁，恬静安逸。\\n这一切都是妹妹日夕的功劳，月夕时常感激地想到。当自己忙着照顾受伤的怪兽、抚慰进化失败的部落成员、日以继夜地为采集更多的进化和强化孢子奔波时，妹妹总在自己身后打理部落杂务——想方设法让部落更漂亮。\\n偶然某些怪兽对日夕花太多时间沉迷颜术颇有微词，但月夕却明白妹妹只是想用最完美的精神面貌为大家打气。不过，为此让眼睛受伤的话，也未免太辛苦了。\\n所以，月夕一回到部落，就直接奔向日之殿。\\n比起月之殿，日之殿的装饰稍显浮华。大殿屋顶画着太阳普照万物的顶画。殿中央建造了一个小小的喷泉，泉水日夜不停流动着，池面上涟漪不断。大殿东南西北四面的墙壁上还各镶嵌了一块镜子，这样，无论日夕往哪个方向走去，都能很快审视她的仪态是否优雅，一颦一笑是否足够动人。月夕一直认为妹妹比自己美丽，是部落的象征。\\n当月夕走进日之殿的时候，殿内的光芒陡然增加，里面的怪兽立刻转头望向大殿门口。\\n明明月亮的光芒来自太阳、逊于太阳，但这种事，在月夕身上是不成立的，她和妹妹散发出来的光芒不相伯仲，如果看久了，甚至会觉得月夕的光芒更明亮，不是刺目耀眼的明亮，是强大、温柔、令人安心的明亮。\\n月夕看到妹妹不像往常一样一边绕着喷泉或沿着镜子漫步，一边聆听大家的诉求，而是被大家里三层外三层的围着，如果不是环绕在日夕身上的太阳光环，她根本看不见日夕在哪里。\\n大家让开了一条道，让月夕走过去。\\n日夕看到姐姐，显然松了一口气。\\n“你可回来了！”\\n“发生什么事了吗？”\\n月夕看到大家围着一堆紫色的孢子团，孢子团的数量比她平时花几天几夜采集的还要多，围观的怪兽议论纷纷，有几个还克制地舔舔舌头。\\n“这些是进化孢子？”月夕问道。\\n“已经分不清是进化还是强化孢子了，大家都说这些孢子都是在屋子外面和溪边捡到的，简直就像被故意放在那里。”日夕说。\\n“看到送孢子的是谁吗？太慷慨了。”无论这些孢子有多么奇怪，月夕都觉得这是一件伟大的善举。\\n“那个神秘的家伙某次还是被我们一个部落成员看到了侧脸，他脸上好像有烧伤的疤痕。”日夕眨眨眼睛，故作神秘。\\n月夕的心猛然一沉。\\n“关于这个，你就别想太多了。大部分和龙族对战过的怪兽，都会被烧伤。”日夕轻描淡写地说道。\\n她本来想捉弄一下姐姐，但看到姐姐痛苦的表情，又有点于心不忍。\\n烧伤的疤痕，是月夕心中永远的痛。因为自己的过失，让青梅竹马的友人被黯炎古龙毁容，友人带着无法治愈的伤疤离开了她。偶尔听到关于友人的消息，也是她自称“毁容怪”，狂虐幼体和幻化级的怪兽这类和她昔日的品性大相径庭的传言。\\n妹妹有时会觉得她太小题大做。\\n“外表的丑陋不会改变我们的本性，只会把本性中丑陋的一面放大。”妹妹曾说。\\n但月夕总是摇摇头，无法认同。\\n“所以说啦，我根本没有眼疾！”妹妹的抗议声把月夕的思绪拉了回来，“那些紫色的光点，一定是从这些孢子团上飘出来的。”\\n日夕气鼓鼓的，毫不在意地在一群部落成员面前表现出不高兴的表情。\\n“啊啊，抱歉。”\\n“就说嘛。”一边说，日夕一边拿出精致的化妆盒，把一抹金色的眼影细细抹在眼睑上。\\n“这些孢子团，除了颜色之外，还有什么奇怪的地方吗？”月夕捧起一个孢子团，端详着。\\n“颜色就是它们最奇怪的地方，丑死了！如果孢子本身能够进化的话，好歹也是金色啊。”日夕最喜欢金色，并且讨厌一切暗色系。\\n“唔……大家如果还发现这样的孢子团，先把它交给我们。孢子库里还有足够的存货，需要的话可以去那里领取。”月夕向部落成员说道。\\n不同于其他部落，在月夕的部落，即便是弱者也能领到不少孢子。月夕的理想是建立一个按需所取的理想世界，在那个世界中，每个怪兽都勤奋劳动、努力进化、和平共处、远离战争。\\n突然，一个大胆的念头在月夕脑中闪过。\\n当部落成员都离开后，日之殿只剩下她和妹妹。\\n担忧和兴奋的表情轮流在月夕脸上呈现，让日夕有一种不祥的预感。\\n“大会开得怎么样？”日夕试探地问道。\\n月夕一五一十地把会议经过告诉妹妹。\\n“现在要尽快确认石塔的作用，还有邪王是否会降临。但是，我刚才在想，我们对邪王，是不是有点误会了？”\\n看到妹妹眼中的不安，月夕继续解释。\\n“以前的战争，可能都是源于误会。唉……”月夕哀伤地叹了口气，“如果邪王是古神派来帮助我们进化的使者，如果这些孢子是邪王送给我们的礼物？”\\n说到这里，月夕的表情亮起来，她心中充满了光明。\\n“……”日夕有点无语，“所以，你打算找邪王问清楚？”\\n“嗯！”因为满怀着希望，环绕在月夕身上的月亮更明亮了，“我们一起去好不好？先调查石塔，再去找邪王。”\\n“不要，这么危险的事情，万一毁容了怎么办？”日夕一口回绝。\\n她有自己的打算，和姐姐一起行动的话，那种被至善的存在紧紧跟随的压力感会让她非常不自在。\\n“你是担心我们都离开后，没有人留在部落里主持大局？也对。”月夕无视妹妹回答的字面意思，发掘出另一层善良的含义。\\n稍微休息之后，月夕向妹妹告别便出发了。",
    "99_250": "请重新到对应的平台下载并安装最新的游戏包体",
    "resoundEventConfigDes_1007": "远古族所在的晨光草原上出现了两座石塔，一座在草原的东边，月夕想古拉姆已经到达那里了，另一座在草原的南边，自己正准备前往。\\n月夕向南方放眼望去，一线低矮的丘陵出现在地平线上，那座石塔就在丘陵后方。\\n这时，月夕看到一队怪兽从不远处走来，数量大概有十个左右。在上前打招呼和躲起来之间犹豫了几秒，她敏捷地躲在一旁的灌木中，隐蔽起身上的月之光芒。她虽然是一个至善至纯的怪兽，但不是一个毫无防备之心的战士。\\n晨光草原主要是远古族的聚居地，但在三大部落之外的边缘地带，还居住着其他种族的怪兽。所以，当月夕看到队伍中有其他种族的怪兽时，并不感到奇怪。\\n那支队伍徐徐而来，队伍中都是幼体和幻化级的怪兽。他们步调十分缓慢，让月夕看清每个怪兽脸上那种朝圣般的神情。每个怪兽口中都轻轻呢喃着。起初，月夕听不清楚他们在说什么，凝神静听了好一会儿之后，终于从一片混乱的轻言细语中听到了一个怪兽们频繁重复的音节——爱……\\n爱？唉？矮？月夕不知道他们说的究竟是哪个字，只听到他们逐渐统一了发声频率，虔诚地呢喃着“爱”，向北走去。\\n月夕侧着头思考，这支不像乌合之众的队伍究竟要干什么？大陆的北方是尸族的领地，冰川谷，再往北是没有怪兽涉足过的神秘异域。\\n她摇摇头，或许自己想太多了，他们只是想到草原北方的海边散散心，现在谁都在烦恼进化停滞的事情。尽管如此，她还是打算再次见到古拉姆和埃癸斯时，把这件事告诉他们，如果三个部落能办一场宴会，邀请边缘地带的怪兽参加，或许能让大家开心起来吧。\\n月夕很快翻过最南边的山岭，来到一座石塔前。\\n这座石塔的外观和古拉姆的那座并没有什么不同。看到塔外没有战斗的痕迹，月夕松了一口气，慢慢走进石塔。\\n塔内的黑暗马上被月夕身上的月亮赶走，石壁被洒满了一层淡淡的银光，尽管如此，月夕还是看不清塔顶的高度。\\n“那个……请问有人吗？”\\n月夕的声音回荡在空荡荡的塔内。\\n“呵呵……”\\n过了半晌，不知从哪里飘出一声鬼魅似的冷笑。\\n“呵呵呵呵……”\\n笑声从四面八方此起彼落地传来，一个飘忽的身影从银光透不穿的暗处出现。\\n“月夕，你还认得我吗？”\\n和月夕相似的形体，褴褛的长裙，乱发像蜘蛛网般凌乱地覆盖在脸上。\\n月夕吓了一跳，对方的出现在她心中扯出一丝痛苦的熟悉感，明明知道她是谁，可名字却如鲠在喉，无论如何都喊不出来。\\n“这样呢？认出来了吗？”\\n鬼魅般的存在撩起头发，露出半张被灼烧得稀巴烂的脸，大块的扭曲疮疤蔓延到脖子上，但剩下的半张脸却有着不逊于月夕的美貌。\\n“你……你……”月夕头痛欲裂，不禁后退了两步。\\n“还记不起来吗？也罢，我已经彻底抛弃了过去，你就叫我‘毁容怪’吧。我的名字和模样，是不是很相衬？呵呵呵……哈哈哈……”\\n阴冷的笑声越发凄厉。\\n“啊……”月夕痛苦地呻吟了一声，“对不起……都是我的错……我……我一定会把你治好……”\\n“治不好了，我这张脸。不过，如果可以重来一次的话，你要是做出‘正确’而非‘善良’的选择，我或许会原谅你。”\\n“重来一次？”\\n“对，你的抉择不同，历史也会改变。”毁容怪诱惑到，“每逢刮风下雨，我脸上的疮疤就格外痛苦，你不想我痛苦，对不对？”\\n“嗯！如果能让你变回原来的样子，我愿意牺牲自己的生命！”\\n“那就好。”\\n毁容怪打了个响指，一阵热风从石塔上方迎头扑来！\\n“吼——！”\\n一条巨大的黯炎古龙飞向月夕，它口中喷出比黄昏更加昏暗、比鲜血更加鲜红的烈焰，焰火扫落了塔壁上的些许石砾。\\n“还发什么呆呢？我先把它引开，你从后面攻击！”\\n月夕回过神来，发现毁容怪已经不见踪影，自己身边是那位久违的友人。她突然分不清楚这究竟是梦还是现实。\\n友人还是未被毁容的样子，虽然是幻化级别，但信任自己的眼神十分坚定。这些，都和自己鲜明的记忆如出一辙。\\n黯炎古龙频频的攻击不容月夕多想，她不由自主地和友人配合起来。然后——\\n和记忆中的一样，对方只是一只有勇无谋的怪兽，很快被她们耍得团团转，友人放出蓄力已久的大招，黯炎古龙就倒在地上。\\n和记忆中的一样，战败的黯炎古龙身上掉下来一堆进化孢子和强化孢子。\\n那天，月夕是因为看到这只黯炎古龙从一群幼尸手上抢夺孢子才忍不住出手相助的。友人曾劝她不要管这件事，弱肉强食是超进化大陆永恒的真理，但刚进化到究极级别的自己却无法袖手旁观。\\n那接下来……\\n果然，也和记忆中一样，只是陷入思索片刻的一晃眼，黯炎古龙身边出现了几只身受重伤的幼尸。\\n那个时候，月夕连续发动逆转之力为幼尸治疗。这种治疗方法会为受伤最重的怪兽带来最大的疗效，但是，救护心切的月夕完全忽视了黯炎古龙的血量比几只幼尸还少，逆转之力大部分被黯炎古龙吸收了。\\n在友人提醒她黯炎古龙醒来的时候，她还笑着说“没关系，我只想让他长点教训，并不是要真的杀了他”——\\n下一瞬，黯炎古龙突然喷出从接受治疗开始便积聚下来的复仇火焰，把友人的半张脸烧毁。\\n接下来的日子，月夕废寝忘餐的治疗，也只是徒劳地增加友人的痛苦。对方以“绝交”回应月夕的善良和愧疚，从此在晨光草原上销声匿迹。\\n月夕无数次问自己，如果能重来一次，她会怎么做？\\n在还没找到答案的时候，重来一次的机会竟然以这样的方式出现在她面前。\\n对于其他怪兽，这不是一道选择题，几乎没有怪兽会救自己的敌人，但月夕不愿手上沾上任何怪兽的鲜血。\\n“把黯炎古龙杀掉，然后我们回部落吧。”友人柔声细语地在月夕耳边说道。\\n“不行……”月夕缓慢地抬起头，“我们没有权力代替古神审判其他怪兽的生命，既然古神赋予我治疗的天赋，我必须完成这份使命。”\\n溪流般清澄的声音响彻石塔，弯月闪耀着冰冷如霜的银光。\\n“以我的生命起誓，我不会再让他伤害你。”\\n月夕挡在珍视的友人面前，开始对黯炎古龙和幼尸们施放治疗。\\n“啊啊啊！无药可救的笨蛋！”友人的表情开始变得狰狞，丑陋的疮疤再次爬到脸上，她重新变成了“毁容怪”。\\n“完全无视我的要求，这就是你对我的愧疚吗？”\\n“不杀任何敌人，对所有生命施以援手，宁愿牺牲自己，也要唤醒对方的善良，真是矫情得可以！”\\n“像你这种幼稚的家伙怎么能对付邪王？”\\n“善良会使罪恶增长，到底还要造成多大牺牲，你才会停止痴人说梦？”\\n毁容怪的嘲弄像鞭子一样一下一下抽在月夕的心上。\\n“不能动摇……”月夕默默念道，施放的治疗之力完全没有减弱。\\n黯炎古龙慢慢睁开眼睛。\\n“愚蠢的家伙！吼——”\\n怒吼中，焰火向月夕劈头盖脑袭来。\\n月夕赶紧抱着身后的毁容怪趴到地上连滚几圈，烈焰从脸颊上擦过。\\n但是，当月夕回过神来，身边的毁容怪已经不见踪影，手上残留的触觉上飘荡着几缕白烟。转头望去，毁容怪和黯炎古龙渐渐消去实体，化成由浓重的白雾组成的存在，而且两者还汇聚在一起，变成月夕的不朽级，白雾中透出朗月般高洁的冷光。\\n“你是……”\\n“我是塔的守卫者，也是你的试炼者。”守护者的脸上闪耀着希望的光彩，也夹杂着无尽的忧伤。\\n“您是古神吗？”月夕虽然很吃惊，但并不害怕，满腔敬意涌上她的心头，她不由得跪了下来。\\n“不……此刻，我是你，过去的你、未来的你、胜利的你和失败的你。不要因为你的过失而愧疚，你的信念会引领你去到邪王面前。执着的善有时会显得愚蠢，但却能让我们在战争中保持初心。”\\n那个毁容怪，是自己的心魔，这是石塔对她的考验，月夕意识到。\\n“拿着吧，这个会为你呼唤出信念一致之人。”\\n声音消失了，白光的白雾也袅袅飘向塔顶而消散。\\n月夕发现自己手上捧着一汪绿莹莹的幽光。",
    "resoundEventConfigDes_1004": "冷冽的雾气在清晨泛起，古拉姆往东而行，在影影绰绰的树林间，远方的石塔时而隐蔽时而显露。不过，即使茂密的树冠遮蔽了天空，但不时从头顶飞过的荒火龙为古拉姆指引了方向。钢铁龙王已经把有关宝藏的消息告诉了它的部下。沿途有几头铁甲龙想阻拦古拉姆的前进，它们对古拉姆的大剑垂涎欲滴。\\n“小心消化不良！”古拉姆一剑砸飞一头。\\n这些铁甲龙是之前获得进化的怪兽。钢铁龙王还为此举行了三天三夜的狂欢。看来，龙王把最强的部下派来了。虽然它们和古拉姆都是究极怪兽，但两者的实力天差地别。古拉姆时常感觉到自己体内能量的涌动，离下一级的进化只距一线，即使这一线像永远横亘在它面前的一座高山。\\n一路上，古拉姆都在思考打败塔中巨兽的办法。那东西喷出的火焰连钢铁龙王也抵挡不住，必须要躲过烈焰攻击，埃癸斯的盾一定能够抵挡这个攻击，这时趁机找到对方的弱点，一举制胜。\\n想到这，古拉姆猛地摇摇头，看来一直和埃癸斯并肩作战，已经习惯了挚友在身边的战斗。这可不行，要变得更独当一面，努力成为超越一骑当千的将领才行。\\n独自战斗的战术在脑中轮番闪过，不知不觉，古拉姆来到一座巨大的石塔面前。\\n这是一座比古拉姆想象还要巨大的石塔，塔身并不是被薄雾覆盖时看到的灰色，而是更接近于骨头的灰白色。\\n骨塔，古拉姆条件反射地想到这个词。\\n塔的外墙很粗糙，从外面看，石塔没有明显的分层，也没有窗户，它就像一个歪扭破烂的纺锤直插云霄。塔外弥漫着火焰烧过的焦臭味和铁腥味，龙族已经不见踪影，塔内在不久前应该经历过一场恶斗。\\n古拉姆抽出背后的大剑，踏入塔内。\\n除了入口，没有其它地方让光线透进来，古拉姆眨了好几下眼睛才适应了里面的昏暗。这里没有楼梯，它极尽目力，能看到的也只有头顶的黑暗，不过脚踩的这片空地倒是大得像斗技场，仿佛置身于一只巨兽的空心犄角里面。\\n突然，一阵嘶哑的吼声在塔内回荡，接着，缭绕的黑烟凝聚成一个庞大的轮廓。这个看似没有实体的庞然大物踏向古拉姆的时候，地面随之震动。\\n巨兽的体格是古拉姆的五、六倍，黑色的火焰在它身上流动，像诡异的铠甲把它从头到脚包裹起来。它与任何一族都没有相似之处，又好像汇聚了它们最狰狞的一面，它的脸不断扭曲，眼中蕴含着极度混乱的空虚。\\n而且，明明身体是由黑暗组成，但身后的四把巨剑却闪耀着炽热的光芒，唯有这点，和远古族的某个不朽级一模一样。这正是古拉姆日思夜想的未来。\\n它好像和钢铁龙王描述的怪兽不同……\\n古拉姆还在发呆的时候，巨兽已经朝它冲过来。嘶吼如雷鸣，庞大的身躯仿佛暴风雨中翻腾的黑云，散发着狂暴的气息。它手中的剑是烈焰中的红色，古拉姆赶紧跳开，灼热的剑气从它面前扫过。\\n但是，巨兽背后的四把大剑却从不同的方向刺向古拉姆，古拉姆的出招逐渐慌乱起来。它拼命挥剑，可还是甩不开四股把它缠得死死的火焰，而且它们还没有实体，这一瞬间被劈断，下一瞬间重新汇聚成剑，最糟糕的是，它还要抵挡巨兽的巨剑。相比之下，古拉姆的剑就像一条脆弱的树枝。\\n塔内闪耀着刺眼的焰光，一道单薄的闪电被几束火焰围剿。\\n自己进化之后，能有这么强吗？古拉姆想。\\n巨兽虽然庞大，但移动速度很快，古拉姆仿佛被一团黑气盘旋在中心，它只能靠闪耀的焰光识别巨兽攻击的方向。很快，它的铠甲上增添了好几道又深又长的裂痕。\\n古拉姆开始大口喘气，动作稍微慢了一拍，背部又受了一剑。热辣辣的撞击透过盔甲直透体内，整个身体快要被烤焦了。\\n这时，巨兽好像要结束这场战斗，它高举巨剑，其余四把火焰剑也和它化为一体。\\n“来吧！一绝胜负！”古拉姆大喊。\\n巨剑卷着劲风以撼动大地的势头劈向古拉姆，古拉姆双手托起大剑来抵挡。\\n它打算看准机会滑到巨兽胯下，然后在巨兽的视觉盲区跃起直刺。可是，古拉姆想错了。\\n狂暴的剑风压得古拉姆无处可逃，巨剑的赤焰从自己的大剑传到双手，它看到自己的剑身中间出现了一条裂缝，下一瞬，自己的剑断成两段！\\n巨剑砍向古拉姆的头顶，接着，根本来不及品尝死亡的滋味，它就被一片黑暗笼罩。\\n……\\n“成为守卫者……”\\n一把声音在古拉姆耳边呢喃。\\n古拉姆睁开眼睛，发现自己身处无垠的黑暗中，这片黑暗压得它有点喘不过气。手脚还能动，断剑的裂口闪烁着惨淡的微光。眼前的黑暗渐渐褪去，它模糊看到一个又一个怪兽闯入塔内，自己则成为石塔的守卫不断砍杀那些挑战者。然后，黑暗再次紧裹着它的身体。\\n“你在我的身体里，成为我吧……”\\n古拉姆意识到，这是巨兽在跟它说话。\\n“……不要……”古拉姆挣扎着。\\n“那就凭自己的力量挣脱出来，意识还没消失，生死还在竞演……”\\n古拉姆想这是巨兽，不对，这是塔的意志。如果连塔里的守卫也打不过，怎么打败邪王？\\n能顺利回去的话，一定要对那几位智者老头表达相当的敬意，它们日夜苦心解读残卷里的故事，还真的发生了。\\n“来吧……”石塔再度催促。\\n不用你废话！\\n古拉姆挥了挥断剑，闭上眼睛，感受巨兽的气息。它的意志让手中的断剑延展出完整的剑身。现在，它也在塔内对入侵者虎视眈眈吗？也在用那粗哑的嘶吼威吓它们吗？\\n听到了，巨兽的呼吸！那是暗之流火最脆弱的地方。\\n古拉姆一剑劈过去——和体力上的对抗不同，这是贯注了它所有意志力的一剑，超越了不朽。\\n古拉姆慢慢睁开眼，一缕润绿色的光线从无边黑暗被撕开的一道裂缝中透射进来，光线逐渐变粗变强，那道细窄的裂缝很快增大成纺锤型的入口，一道流光溢彩的光速笼罩在古拉姆身上。\\n古拉姆发现自己已经回到塔内，它手上不知何时捧着一片一掌大的翠绿莹光，光芒并不炽人，凉丝丝的，但光亮却在不断增幅，很快就像倒流的瀑布般往塔顶倾泻。\\n古拉姆有点睁不开眼睛。\\n在耀眼的光芒中，一道细长的身影从天而降。",
    "resoundEventConfigDes_1005": "林宇翔是一个视频通关党，视频通关过数百款游戏，贡献过数十万条游戏视频弹幕。他的梦想是做一个风格诙谐但言辞犀利一针见血的游戏评论家，然后横向发展成一个随口一两句段子就能成为人生鸡汤的菁俊公知。\\n林宇翔打算在30岁之前实现这个梦想，他现在才大二。青春鲜嫩的20岁，给了他肆意挥霍的青春和杠精式的精神，喜欢就一个问题和人家一怼到底。\\n这天课后，他照常打开某个游戏直播网站，带着点围观受刑的幸灾乐祸心态，点开一个极其恐怖的游戏视频直播。播主是个有相当人气的小姐姐，被粉丝爱称为“女神”。他想象着女神被吓得花容失色的样子，想象着自己用几句妙趣的段子逗得女神哈哈大笑，帅爆全场的样子。当然其他围观者都看不到他的真容，但能隔着屏幕感受到他文采横溢笑谈游戏的气场。\\n时间到了，女神准时上线。\\n游戏是配合VR眼罩玩的，女神第一视角进入阴森的城堡内，城堡的墙和门开始长出肉质的东西，同一条走廊走到第三次的时候挂画会突然歪掉，随时跳出来鬼魂和怪物，甚至还有玩家在照镜子时发现自己变成厉鬼的模样。\\n因为是VR游戏的关系，女神的尖叫声特别颤抖特别真切，但围观者的弹幕让恐怖游戏直接变成搞笑娱乐节目。其中林宇翔是调侃得最得意的一个。\\n“这游戏的恐怖全靠BGM。”\\n“女神你能不能成熟点，这游戏有《寂静岭》有意思吗？画面是歪的，眼罩戴好一点啊。”\\n后来，随着游戏的恐怖度加深，林宇翔越看越兴奋，已经由嘴炮变成喷子。\\n“垃圾游戏！全程黑成这样怎么看啊？恐怖气氛就是无脑地不开灯？”\\n“女神你手残了吗？全程在用脸滚键盘玩儿吗？速度还没隔壁新来的UP主快！”\\n“30分钟的进度条女神你要玩八小时吗？”\\n林宇翔喷了差不多两小时后，突然收到女神的回复。\\n“我做视频只是想和大家分享这游戏，而不是拿出来炫耀我玩得有多好。看来你只喜欢网上撒泼，并不是游戏本身。You can you up，不行别瞎比比。”\\n林宇翔眼前浮现起女神轻蔑的笑容。他有一种鱼鲠在喉的感觉，内心深处知道女神说得对，可又不想承认，只好硬撑。\\n“不，我是真喜欢这游戏，只是觉得你玩得太烂，变成搞笑片了，我现在都不想买了。”\\n“游戏我送给你，刚才我玩的，你就当是新手攻略吧。”\\n“……”\\n女神再也没回复他，账号邮箱里却收到那款恐怖游戏的激活码。女神说到做到。\\n最后一丝愧疚被这个激活码激得烟消云散，林宇翔决心狠狠吐槽这款游戏！只不过，他激愤之时，没料到他还得买个最新款的VR眼罩。\\n于是，林宇翔跑出学校，来到专卖店，狠下心，用自己额度不高的大学生信用卡买了一个副VR眼罩。\\n一路上，林宇翔专心致志地组织语言，准备做直播的时候一边玩一边喷，说不定，这就是他提早出道的契机！回到宿舍的时候已经晚上十点，其他室友可能出去哪里浪了，都还没回来。他摸索了一下怎么使用VR眼罩后，下载了那款游戏，输入激活码，建立了一个ID登录了游戏。\\n眼前一片漆黑，林宇翔睁大眼睛，等待着，使劲寻找任何光点。这时，手机突然响起，他心一急，急忙朝铃声的方向跑去，不料一个踉跄，被自己随手扔地上的一个矿泉水瓶绊倒。\\n这时，伴随耳边传来“滴”的一声，一道强烈的金光冲入林宇翔眼中，仿佛有一股巨大得难以置信的能量波把他整个身体撞出大气层。那一瞬间，林宇翔确信自己窒息了。\\n林宇翔缓缓醒来的时候，发现自己置身于一片昏暗中，虽然身上各处都在痛，但是却好像飘浮在空中，没有踩在地面上的实感。低头一看，身上穿着奇怪的铠甲，铠甲上的暗纹好像流动的橙焰。\\n还挺威风的！而且，不知道是自己在发烧，还是铠甲传来的热量，一股热流在体内涌动，让自己有一股打架的冲动。\\n牛掰了！只是一款VR眼罩，怎么能给人一种细腻真实的体感反应？！连情绪也能影响，难道是眼罩里内置了能够模拟各种触感并连接脑部神经的装置？万一那些不符合游戏文明和道德羞耻的啥游戏也戴上这眼罩，不就可以感受超级真实的虚拟快感吗？\\n想到这，林宇翔激动地“*”了一声！\\n“*，是你们进化的意思吗？”\\n突然，脑海里另一把声音响起。\\n“我进化了，用你们的话来说，就是我*？”那把声音继续说道。\\n“不对！‘我*’是骂人的话，或者情绪很激动的时候才能用，同学，注意文明呢！”林宇翔下意识教育对方。\\n“终于进化了我能不激动吗？我*！”那把声音大喊。\\n不，等等！林宇翔的头脑陷入一片混乱，这是游戏里面的角色对他说话吗？一个类似人工智能的东西？好先进！虽然刷信用卡的时候有点心疼，但居然物超所值。林宇翔努力在眼前的昏暗中寻找代表HP的任何标志和“开始”按钮，并准备输入很久以前就给自己起的一个中二度爆表的ID。\\n可是，林宇翔还没有找到这些东西，身体就不由自主动起来——他往前走几步，捡起地上的一把……断剑？\\n断剑旁边有一个扁扁的小盘子，质地像墨玉，中间凹陷进去了一大块，有点像一个笨重的手机壳，上面还散发着盈盈的幽光。不过，他的身体并没有理会那个东西。\\n“喝！喝呀！”他双手握着断剑用力挥了几下。\\n就连吆喝声也是由另一个意识发出来的。\\n怎、怎么回事？！这、这是游戏中的开场动画吗？所以还没轮到自己操控？一定是这样！林宇翔鼓励自己。怎么说自己也是一个硬核玩家，不能随便大惊小怪——显然他把视频通关也当成“打游戏”……\\n松了一口气后，林宇翔才留意到这个身体和往日的不同，他好像变高了一点、变壮了一点，力气也大了很多——那把断剑几乎有一尺宽、一米长。\\n他用巨剑的金属边缘照了一下自己的样子。头盔里，古铜色的脸庞上爬满了左右对称的暗红纹路，暗纹中流动着和铠甲、大剑一样的焰光，双瞳是血红色的，往日稍嫌清秀的五官变得硬朗起来。\\n嘿！真帅！\\n“我当然帅，但现在不是高兴的时候。”那把声音说，“我问你，为什么靠了之后我的剑还是这个样子？”\\n自己好像和另一个意识共用一个身体。\\n“我、我怎么知道！要氪金才能换武器吗？啧啧，一开始就这样，吃相也太难看了！”\\n“不懂你在说什么。喝——啊！”\\n随着一声大吼，林宇翔的体内激起出一股强大的力量，后背像被点了一把火，四簇火焰迸射而出，像四把炫目的焰剑围绕在身侧。塔内在绚烂无比的火光照耀下，已如白昼，塔身震动，仿佛随时会四分五裂——\\n林宇翔觉得自己的心脏猛地跳动，全身血液刹那间沸腾起来。自己……在变成太阳吗？\\n不过，这场剧变只持续了几秒，火焰很快就熄灭，身体迅速冷却下来。林宇翔再也支持不住，无力地跪倒。另一个意识也沉默下来了。\\n……\\n“不对，究竟是哪里出错了……”过了很久，对方意识沮丧地问到，“明明已经进化了，明明已经成为不朽的神剑古拉姆……”\\n“神剑古拉姆？这是你的名字？”\\n虚空中，林宇翔看见面前单膝跪着一个身材魁梧的战士，战士的双手在不断颤抖。\\n“……”\\n对方无助的样子让他生出一丝怜悯。现在，他大概明白自己在这个游戏中成为了一名战士，不，应该说和这位战士合体了，但却面临着升级失败的状况。那还是氪一次？新手礼包应该有优惠吧，不过还得先找到“购买”键才行。\\n“咳咳……我叫林宇翔，是你的……”\\n主人？御主？契约者？林宇翔正寻思着该如何称呼这位战士。\\n“你不是古神，太弱了！”\\n战士盯着他，眼中充满了愤怒。\\n“喂喂！一个低级角色在耍什么优越感！”林宇翔也被激怒了，“这破游戏是想把玩家赶走吗？界面设计太不人性化，角色设定太差了，性格不讨好样子也丑，我想氪金都下不了手！”\\n林宇翔觉得自己的点评既优雅又有深度，并且一针见血，十分满足，但对方是一脸“不懂你在说什么”的表情。\\n突然，战士的表情亮起来。\\n“既然来到这个世界，这些东西对你说不定有用！”\\n林宇翔眼前一晃，视角再次和战士重叠，他又回到了昏暗的塔内。\\n再次，身体不受控制，他看到双手拿着两个暗绿色的团子送到嘴边。\\n“你你你你想做什么？！”\\n“一个是强化孢子水藻团，一个是进化孢子水藻团，你想先吃哪一个？”\\n虽然控制不了身体，但嗅觉依旧正常，团子苦涩的味道扑鼻而来。\\n“……哪、哪个都不想吃！”\\n“好吧，那就两个一起吃！”\\n一股发臭的海带味充满整个嘴巴，口感就像过期的艾糍……\\n“好难吃！”\\n林宇翔和战士不约而同地大喊，只不过，一个想吐出来，另一个要努力吞下去。",
    "99_264": "分享失败",
    "99_263": "广告载入中......",
    "resoundEventConfigDes_1010": "难吃！一言难尽的难吃！难吃得泪水都要流下来了……\\n但古拉姆的意识却阻止林宇翔做出流泪这种羞耻的事。\\n身体的控制权依旧在古拉姆手上，但做出双手撑在石塔的内壁上拼命抑制呕吐冲动的动作，是古拉姆和林宇翔合体以来的第一次同步。\\n只不过，味觉付出惨烈代价的两者还是没有丝毫变强的迹象。\\n“……现在怎么办？”古拉姆和林宇翔再次步调一致地问道，像是问对方，又像自言自语。\\n身体无力地走到塔外。\\n是先回部落告诉智者塔里的情况，还是去其他石塔找埃癸斯或者月夕？正当古拉姆犹豫不决的时候，身后悄然亮起一簇火苗。\\n古拉姆敏感地转身——无论在何种情绪下，战士的警觉性都会优先发挥作用。\\n赤金色的火苗飘浮在半空，绚丽非凡。\\n“这是什么？”林宇翔问。\\n“……我不知道。”似乎对自己的无知有点恼怒，古拉姆用力地握着断剑。\\n火苗突然窜高，变成一只形体比古拉姆还要硕大的火鸟。\\n“真·神剑古拉姆……”火鸟说。\\n“你怎么会知道我进化后的真名？”\\n不就是毫不帅气地多了一个“真”字吗？林宇翔暗自吐槽。\\n“超进化大陆终于等到你们了……”火鸟用慈祥的回答略过古拉姆的惊讶。\\n即使身体是由火焰构成，也能看出火鸟脸上十足的威严和慈祥。\\n好、好厉害的3D技术！这是重要的NPC吧！\\n林宇翔已经问过古拉姆无数次类似的问题，但古拉姆早已把它们当噪音般无视。\\n“我们？你知道我体内有另一个东西？你到底是谁？”\\n“*！我是你主人！”林宇翔的不满无法从这个躯体发出来，而且也理所当然地被古拉姆无视了。\\n火鸟扇动了两下翅膀，几点火星落在古拉姆身上，却完全没有炽烫感。\\n“我是朱雀，你可能已经听过我的传说，不过你的伙伴对我还很陌生吧。”\\n名为朱雀的火鸟很感兴趣地绕着古拉姆飞了几圈，然后从古拉姆身后直接穿过他的身体，重新飞到他们眼前。\\n“神灵朱雀？！”古拉姆惊讶地喊道。\\n“‘神灵’这个称呼，对真正的古神来说实在是一种冒犯，以后你们叫我‘朱雀’就行。”朱雀的声音拥有一种听不出年龄的苍老和威严。\\n对所有怪兽来说，神灵是梦寐以求的导师式的存在，据说他们已经在这片大陆上生活了好几千年，如果有幸遇到他们，获得一二指点，那么得到的成长堪比进化到另一个层级。而且神灵比月夕信奉的古神或者古老书卷中的邪王更亲民一些，因为时不时有怪兽说见到了他们。不过，神灵们神龙见首不见尾，声称见过神灵的怪兽，后来绝大部分都被证实不是撒谎就是幻觉。而确实见到的怪兽中，也是绝大部分没有得到神灵的指点。他们不是隐匿在茫茫林海中，就是缈迹于高山苍云间。\\n传说中的神灵一共有五位，朱雀、玄武、白虎、青龙、麒麟，但是，见过所有神灵的怪兽是不存在的。\\n所以古拉姆现在像小孩子见到偶像般兴奋地仰望着朱雀，完全屏蔽了林宇翔提出的各种问题。\\n“但您的身体……”\\n“我活得太久了，肉体已经和大陆的各种元素同化在一起。”见古拉姆不明白，朱雀补充到，“故弄玄虚说一句的话，就是吾即大陆，大陆即吾。”\\n“哦……”\\n古拉姆在细细咀嚼其中深奥的原理，林宇翔则囫囵吞枣地用丰富的游戏经验理解为朱雀已经失去实体，只留下强大的精神能量。这个想法在某种程度上是正确的。\\n“我的事先放到一边，如果你活到一定的年头，也会像我一样。我是来告诉你们，向北走，一直向北走，我感应到北方有不同寻常的邪恶气息，邪王很可能就在那里。”\\n“您知道邪王的事？”\\n“只见过四次，前三次我还参与了对抗他们的战争，但后来身体渐渐元素化后，我只能期待每隔千年的英雄降临，并用我贫瘠的经验辅助他们。”\\n“朱雀大人，我……”\\n“踏上征程的第一步难免有些疑惑，请说。”\\n“我的合体，是不是搞错了？我和这家伙，完全不合拍，即使进化到不朽级，也只是得到这把破剑。”\\n“*！我这是被游戏劝退吗？！”林宇翔以猛烈的气势抗议到。\\n朱雀无法听到林宇翔的不满，但他从古拉姆脸部有点抽搐的表情猜出了两者存在相当大的分歧。\\n“您有没有办法让我们解体，把这家伙送回他自己的世界去？”古拉姆无视林宇翔的技术渐进佳境，“然后召唤另一个厉害的家伙过来？”\\n“你对自己的同伴很不满吗？”朱雀低声问，耀红的眼睛盯着古拉姆，眼神中几乎带着一丝威胁。\\n古拉姆不禁后退一步，林宇翔也停止了吵闹。朱雀身上散发出一股惊人的强大气息，声音却柔和得让他们无法抗拒。\\n“石塔为你们召唤的，是能让你们发挥最大力量的同伴。如果觉得对方没能帮上忙，那一定是你自己的问题。”\\n“……”古拉姆和林宇翔都安静下来，古拉姆突然意识到不停抱怨的自己实在不像样子。\\n“往北而行吧，伟大的征程总有各种磨练，第一个考验不是最辛苦的，但一定是最重要的。”朱雀很快地隐去身影，耀眼的火光很快只剩下一簇火苗，“我会在远处守护着你们的。”\\n连火苗也熄灭了，最后几点火星在古拉姆身上缭绕了一会，向天空散去。\\n朱雀在高空看着古拉姆向北走去后，便飞往南方。\\n相比之下，南方的那组英雄感觉更可靠。他们虔诚地接受了任务，二话不说就往北方赶去，说不定很快就能和真·神剑古拉姆相遇。\\n战斗力开始汇聚了。还有多少组英雄呢？朱雀期待着。\\n石塔不会无穷无尽地出现，曾经有一次，大陆上只出现了两座石塔，幸好当时他们还有实体，但和邪王的对战也持续了三天三夜。\\n每千年出现的邪王都是不同的，这次不知道要面对的是何等险恶的存在。四千年的斗转星移和沧海桑田并没有让朱雀放松下来，每次的千年一役后，他都会心惊胆颤地倒数，并飞遍超进化大陆的每一个角落，观察着、等待着有潜力打败邪王的怪兽出现。\\n他不断探寻石塔出现的原因，但现在还毫无所获，唯一可以肯定的是，有一股力量在暗暗和邪王对抗。",
    "99_262": "广告奖励发放超时，若已观看完毕，请耐心等待",
    "99_261": "广告未能展示，请重试",
    "99_260": "· 充值 {1} 获得 {2} 充值积分",
    "messageInitContent_9502": "呜啦呜啦",
    "messageInitContent_9501": "咕嗷咕嗷",
    "messageInitContent_9500": "嘎嘎嘎",
    "messageInitContent_9506": "噜噜～",
    "messageInitContent_9505": "哇咕哇咕哇咕",
    "messageInitContent_9504": "咕哇咕哇",
    "messageInitContent_9503": "呜啦呜啦呜啦呜啦呜啦呜啦",
    "99_200": "怪兽基因强化后每个基因都可以自由选择属性",
    "skillName_119": "群兽",
    "skillName_118": "火拳·嗜心",
    "skillName_117": "火拳·不屈",
    "99_204": "分解元核会100%返还所有资源，大胆强化进阶吧 O(≧口≦)O",
    "skillName_116": "火拳·焚烧",
    "99_203": "分解元核会100%返还所有资源，大胆强化进阶吧 O(≧口≦)O",
    "skillName_115": "火拳·决意",
    "99_202": "分解元核会100%返还所有资源，大胆强化进阶吧 O(≧口≦)O",
    "skillName_114": "火拳",
    "99_201": "每占领一个关卡都会永久增加星律的挂机收益哟",
    "skillName_113": "虹光·本能",
    "99_208": "自定义名字功能暂时关闭，系统将随机分配名字并补偿改名道具",
    "99_207": "是否需要代金券抵扣？",
    "messageInitContent_9509": "嘎嘎嘎",
    "99_206": "到达等级后星律可挂机产出探索者经验，不伤肝！升级快！o(〃'▽'〃)o",
    "messageInitContent_9508": "呜嗷嗷～",
    "99_205": "到达等级后星律可挂机产出探索者经验，不伤肝！升级快！o(〃'▽'〃)o",
    "messageInitContent_9507": "呜啦呜啦",
    "9_2090": "起源盘效果属于不可清除不可封印的增益/负面效果",
    "99_209": "自定义名字功能暂时关闭，无法更改名字",
    "messageInitContent_9513": "咔啦咔啦！",
    "messageInitContent_9512": "呼呼咕~~",
    "9_2088": "使用新效果",
    "messageInitContent_9511": "咕嗷咕嗷",
    "9_2089": "效果重置不会改变起源盘重量和效果数量，只会重新随机效果，重置后可自由选择是否使用新效果",
    "messageInitContent_9510": "嘎巴",
    "9_2086": "新起源盘效果",
    "messageInitContent_9517": "是那个火神吗",
    "9_2087": "效果重置",
    "messageInitContent_9516": "听说这里是一个信奉火神的岛屿",
    "9_2084": "效果预览",
    "messageInitContent_9515": "新的空岛！",
    "9_2085": "原起源盘效果",
    "messageInitContent_9514": "咚咚咚咚咚咚咚咚咚咚咚咚咚咚咚咚咚咚咚咚咚咚咚咚",
    "skillName_112": "虹光·蒸发",
    "skillName_111": "虹光·高温",
    "skillName_110": "虹光·绯",
    "99_211": "是否消耗移动力药水回复100移动力？",
    "99_210": "当前状态无法使用该功能，请稍后再试",
    "skillName_129": "空境",
    "skillName_128": "黯灭·狙击",
    "99_215": "支付超时，若已支付成功，请耐心等待",
    "skillName_127": "黯灭焰·虚弱",
    "99_214": "录像版本与当前版本不同，战斗过程可能发生改变",
    "skillName_126": "黯灭·烬临",
    "99_213": "解锁获得",
    "skillName_125": "黯灭焰·点燃",
    "99_212": "本周已达上限",
    "skillName_124": "黯灭焰",
    "99_219": "和{appendAmount}{appendPropName}",
    "99_218": "可通过“雷霆游戏服务中心”公众号联系客服",
    "99_217": "适度娱乐\\n理性消费",
    "messageInitContent_9519": "这里还有守卫？",
    "99_216": "每月首个周一",
    "messageInitContent_9518": "这里也有大叉叉~",
    "messageInitContent_9524": "有火，便有神的庇护",
    "messageInitContent_9523": "圣火不熄",
    "messageInitContent_9522": "别让圣火熄灭",
    "messageInitContent_9521": "愿火神指引你前行",
    "messageInitContent_9528": "燃火三日三夜，以迎神临",
    "messageInitContent_9527": "愿神听我等之祷",
    "messageInitContent_9526": "用烈焰净化邪秽，用灰烬孕育新生",
    "messageInitContent_9525": "伟大的火神啊，燃尽我们的罪孽",
    "skillName_123": "群兽·兽王",
    "skillName_122": "群兽·近",
    "skillName_121": "群兽·远",
    "skillName_120": "群兽·切换",
    "messageInitContent_9520": "愿火神在你心中燃烧",
    "99_222": "10th",
    "99_221": "9th",
    "99_220": "服务器在线人数已满，正在排队等待中，请耐心等待或选择其他服务器",
    "99_226": "BOOM！BOOM！BOOM！你发现我啦！你知道20秒是什么吗？我的一生？NO~NO~NO~那是我忍耐的极限！",
    "99_225": "是否使用神行药水？",
    "99_224": "永久封停",
    "99_223": "SID: {1}{2}",
    "99_229": "打开后可{1}以下道具中的一项",
    "99_228": "选择一项",
    "99_227": "打开后可从以下道具中{1}",
    "messageInitContent_9529": "火焰不息",
    "messageInitContent_9535": "所有外来者必将被驱逐",
    "messageInitContent_9534": "火神在上",
    "messageInitContent_9533": "若你听见木柴爆裂，那是火神在回答",
    "messageInitContent_9532": "幼兽经过火焰才算出生",
    "messageInitContent_9539": "神圣之火净化大地吧",
    "messageInitContent_9538": "何者亵渎我们的火焰",
    "messageInitContent_9537": "火神在我背包",
    "messageInitContent_9536": "火神在上",
    "messageInitContent_9531": "请求火神宽恕我们",
    "messageInitContent_9530": "绝不能让外来者污染这片土地",
    "99_233": "（当前已叠加{1}层）",
    "skillName_109": "虹光",
    "99_232": "效果数量",
    "skillName_108": "终焉·神煞",
    "99_231": "一件",
    "skillName_107": "终焉·傲慢",
    "99_230": "随机获得",
    "skillName_106": "终焉·凌驾",
    "99_237": "蓝色品质",
    "skillName_105": "终焉·统治",
    "99_236": "绿色品质",
    "skillName_104": "终焉",
    "99_235": "白色品质",
    "skillName_103": "龙炮·潜龙",
    "99_234": "{1}起源盘",
    "skillName_102": "龙炮·再生",
    "99_239": "橙色品质",
    "99_238": "紫色品质",
    "messageInitContent_9546": "我闻到了火之呼吸",
    "messageInitContent_9545": "你听到了吗火之歌",
    "messageInitContent_9544": "燃起圣火",
    "messageInitContent_9543": "你看到了火焰中的预兆了吗",
    "messageInitContent_9549": "请火神赐予我们炽热与勇气",
    "messageInitContent_9548": "别搞",
    "messageInitContent_9547": "认真的吗",
    "skillName_101": "龙炮·吸收",
    "skillName_100": "龙炮·追击",
    "messageInitContent_9542": "绕着火焰起舞吧",
    "messageInitContent_9541": "火庇护你",
    "messageInitContent_9540": "让火焰浇灌一切",
    "messageInitNick_9499": "牛排的棉袄",
    "messageInitNick_9490": "折翅的天使",
    "messageInitNick_9497": "天天摇人喵",
    "messageInitNick_9498": "骑鱼的猫",
    "messageInitNick_9495": "半糖",
    "messageInitNick_9496": "李子爱好者",
    "messageInitNick_9493": "自家厨房",
    "messageInitNick_9494": "带我去荡漾",
    "messageInitNick_9491": "最爱沙棘果",
    "messageInitNick_9492": "亲吻镇魂曲",
    "messageInitNick_9488": "胖不了先生",
    "messageInitNick_9489": "跟风先驱",
    "resoundEventConfigName_4010": "10.变异孢子",
    "messageInitNick_9486": "干饭大师",
    "messageInitNick_9487": "智能灯泡",
    "messageInitNick_9484": "全员饿人",
    "messageInitNick_9485": "反重力拖鞋",
    "messageInitNick_9482": "半页童话",
    "messageInitNick_9483": "学舌鸦饲养员",
    "messageInitNick_9480": "绝对激情",
    "messageInitNick_9481": "小小花生米",
    "messageInitNick_9479": "相思染春风",
    "messageInitNick_9477": "一笑百媚生",
    "messageInitNick_9478": "自由飞翔",
    "resoundEventConfigName_4012": "12.无妄之灾",
    "resoundEventConfigName_4011": "11.性本善",
    "resoundEventConfigName_4014": "14.肉盾",
    "resoundEventConfigName_4013": "13.理智",
    "resoundEventConfigName_4016": "16.挑战",
    "resoundEventConfigName_4015": "15.求助",
    "messageInitNick_9475": "还没发工资",
    "messageInitNick_9476": "无敌模式",
    "messageInitNick_9473": "热情的炉灶",
    "messageInitNick_9474": "爱在戏院前",
    "messageInitNick_9471": "独饮孟婆汤",
    "messageInitNick_9472": "猫魂穿狗子",
    "messageInitNick_9470": "冰暴战神",
    "messageInitNick_9468": "武林萌主",
    "messageInitNick_9469": "假如我是羊",
    "messageInitNick_9466": "藏匿流星",
    "messageInitNick_9467": "究极颜控",
    "12_5": "所有怪兽饲星后均可在饲星商店换取万能碎片升级觉醒怪兽的技能等级",
    "12_4": "选定角色占觉醒卡总概率",
    "12_3": "商店",
    "12_2": "已选定",
    "12_1": "是否消耗{1}购买{2}个{3}？",
    "messageInitNick_9464": "出租半张床",
    "messageInitNick_9465": "齿轮在转动",
    "messageInitNick_9462": "既视感",
    "messageInitNick_9463": "不许发癫",
    "12_9": "选定的进化光谱占进化光谱总概率",
    "messageInitNick_9460": "过期冒险家",
    "12_8": "心愿单",
    "messageInitNick_9461": "看星星睡了没",
    "12_7": "选择心愿",
    "12_6": "{1}/{2}次",
    "messageInitNick_9459": "宁静的宇宙",
    "messageInitNick_9457": "丑到拖网速",
    "messageInitNick_9458": "葡萄的吻痕",
    "messageInitNick_9455": "神仍旧冷魅",
    "messageInitNick_9456": "可萌可猛",
    "messageInitNick_9453": "桃子爱好者",
    "messageInitNick_9454": "无敌卖惨神",
    "messageInitNick_9451": "不再打扰",
    "messageInitNick_9452": "飞走了飞走了",
    "messageInitNick_9450": "吟游至下世纪",
    "resoundEventConfigName_4009": "9.变异怪兽",
    "resoundEventConfigName_4008": "8.召唤具",
    "messageInitNick_9448": "恭喜发财",
    "messageInitNick_9449": "甜美的莲雾",
    "messageInitNick_9446": "黑翼天使",
    "messageInitNick_9447": "假面狐狸",
    "messageInitNick_9444": "会不会有以后",
    "messageInitNick_9445": "反拿捏的家伙",
    "resoundEventConfigName_4001": "1.锻炼",
    "resoundEventConfigName_4003": "3.流动",
    "resoundEventConfigName_4002": "2.初战",
    "resoundEventConfigName_4005": "5.传言",
    "resoundEventConfigName_4004": "4.囤食洞穴",
    "resoundEventConfigName_4007": "7.共用",
    "resoundEventConfigName_4006": "6.相遇",
    "messageInitNick_9442": "打小就傲",
    "messageInitNick_9443": "迷路的细胞膜",
    "messageInitNick_9440": "半暖时光",
    "messageInitNick_9441": "空大卖萌怪",
    "messageInitNick_9439": "差一点成帅哥",
    "messageInitNick_9437": "牌瘾入骨",
    "messageInitNick_9438": "柚子射手",
    "messageInitNick_9435": "稳控全场",
    "messageInitNick_9436": "特别精神君",
    "messageInitNick_9433": "俺是种瓜滴",
    "messageInitNick_9434": "戈壁骆驼",
    "messageInitNick_9431": "存钱小猪",
    "messageInitNick_9432": "暴走的冰糖",
    "messageInitNick_9430": "迷路小子",
    "messageInitNick_9428": "打开人性",
    "messageInitNick_9429": "蛋炒饭",
    "messageInitNick_9426": "一种小幸福",
    "messageInitNick_9427": "菠菜先锋",
    "messageInitNick_9424": "朋友快住手",
    "messageInitNick_9425": "过劳战士",
    "messageInitNick_9422": "超级骨头",
    "messageInitNick_9423": "强壮头铁神",
    "4_17": "战墙等级{1}开启",
    "messageInitNick_9420": "诡异噩梦",
    "4_16": "最多可提升到{1}好友位置",
    "messageInitNick_9421": "电子水果糖",
    "4_19": "解锁",
    "4_18": "好感度",
    "messageInitNick_9417": "三重梦",
    "messageInitNick_9418": "奉旨补刀",
    "4_11": "{1}刷新",
    "messageInitNick_9415": "萌面大虾",
    "4_10": "饲星商店",
    "messageInitNick_9416": "蒜之心",
    "4_13": "每日最多刷新{1}次",
    "messageInitNick_9413": "格式化中",
    "4_12": "刷新",
    "messageInitNick_9414": "告别小学时代",
    "4_15": "是否消耗{1}钻石购买{2}好友位置？",
    "messageInitNick_9411": "年轻的每米呦",
    "4_14": "未建造战墙",
    "messageInitNick_9412": "朋友侠",
    "messageInitNick_9419": "蛋挞怪客",
    "4_28": "起源殿积分{1}可购买",
    "4_27": "斗技场积分{1}可购买",
    "messageInitNick_9410": "类人生物",
    "15_comment": "凿星裂痕",
    "4_29": "造唤商店",
    "4_20": "每次刷新只可购买其中一件",
    "messageInitNick_9406": "嫌贵皇后",
    "messageInitNick_9407": "纯洁的蕾丝控",
    "4_22": "免费刷新",
    "messageInitNick_9404": "红人",
    "4_21": "暂无商品",
    "messageInitNick_9405": "撩妹突击手",
    "4_24": "饲星坛等级{1}可购买",
    "messageInitNick_9402": "不吃鱼的猫",
    "4_23": "下次免费",
    "messageInitNick_9403": "什么都不想说",
    "4_26": "狩猎排行{1}可购买",
    "messageInitNick_9400": "专注打酱油",
    "4_25": "狩猎积分{1}可购买",
    "messageInitNick_9401": "我看不懂",
    "messageInitNick_9408": "天堂橡皮",
    "messageInitNick_9409": "全幼儿园最萌",
    "4_39": "本周限购{1}次",
    "4_38": "本日限购{1}次",
    "4_31": "部落繁荣度{1}可购买",
    "4_30": "需要拥有{1}",
    "4_33": "是否消耗{1}钻石购买{2}背包位置？",
    "4_32": "使用",
    "4_35": "竞价",
    "4_34": "合成",
    "4_37": "已售罄",
    "4_36": "是否消耗{1}钻石重置{2}？",
    "4_49": "已解锁",
    "4_42": "免费",
    "4_41": "终生限购{1}次",
    "4_44": "1.购买月曜赠礼可立即获得钻石奖励，并使其生效时间延长30天\\n2.月曜赠礼生效期间，每日首次登录游戏可在邮件中领取奖励，生效期间未登录游戏不会收到邮件奖励\\n3.纹银月曜赠礼生效期间可额外获得探索者经验免费找回权益，鎏金月曜赠礼生效期间可额外获得复制体自动挑战权益\\n4.生效时间小于等于5天时，可再次购买月曜赠礼",
    "4_43": "1.默认解锁原始契约，完成蜕变契约任务，可获得契约经验提高契约等级，领取对应的奖励\\n2.购买超阶契约可额外领取超阶契约对应的奖励\\n3.蜕变契约到达满级后每提升1级，可领取1次循环奖励\\n4.若探索者创角时蜕变契约剩余时间已不足14天，则该期蜕变契约将至少持续14天\\n5.当蜕变契约剩余时间少于10分钟时，将无法购买超阶契约，少于1分钟时，蜕变契约将进行重置，届时将无法进行任何相关操作，请记得及时领取奖励喔",
    "4_46": "购买全部每日一弹可增加“本周买光次数”，当次数达到1，2，5次时可领取对应奖励",
    "4_45": "1.活动前7天任意充值均参与累计，第8天可领取进化之实额外赠送彩钻\\n2.进化之实额外赠送彩钻不影响首充等优惠活动\\n3.额外赠送比例：\\n充值{1}，额外赠送1000%彩钻\\n充值{2}，额外赠送200%彩钻\\n充值{3}，额外赠送50%彩钻\\n4.例：首充{4}，即时获得6480彩钻+6480钻石\\n第8天额外赠送： {5}部分额外赠送1000%即600彩钻，{6}部分额外赠送200%即1880彩钻，{7}部分额外赠送50%即2740彩钻，总额外赠送5220彩钻；若再充值{8}（即总共{9}，超出{10}的部分不参与返利），除了立即获得的6480彩钻外，还可领取额外1760彩钻，即总额外赠送6980彩钻",
    "4_48": "循环奖励",
    "4_47": "首充",
    "4_40": "本月限购{1}次",
    "4_53": "限购{1}次",
    "4_52": "{1}进化",
    "4_55": "解锁{1}可购买",
    "4_54": "剩余次数：{1}/{2}",
    "4_57": "购买{1}好礼每日领好礼",
    "4_56": "{1}使用成功",
    "4_59": "我可是要成为钻王的NPC！只要一点钻石就可以收下我这有温度的金币！牙不换~",
    "4_58": "形态预览",
    "4_51": "每日0点重置",
    "4_50": "{1}后重置",
    "4_64": "原价",
    "4_63": "{1}折",
    "4_66": "新",
    "4_65": "商店重置中",
    "4_68": "最多选择{1}条",
    "4_67": "起源盘分解",
    "4_69": "{1}未完成选定",
    "4_60": "剩余次数：",
    "4_62": "首次购买",
    "4_61": "果断换",
    "4_75": "无武装",
    "4_74": "1.购买永恒赠礼可立即获得钻石奖励，并永久生效\\n2.生效期间，每日首次登录游戏可在邮件中领取奖励，生效期间未登录游戏不会收到邮件奖励\\n3.永恒赠礼生效期间可额外获得远古族怪兽免费轮回权益",
    "4_77": "默认敌方一侧战墙",
    "4_76": "默认己方一侧战墙",
    "4_79": "拥有{1}个或以上的等级10战墙武装时",
    "4_78": "默认",
    "4_71": "限时星礼",
    "4_70": "探索者等级{1}",
    "4_73": "是否消耗{1}{2}重置武装？",
    "4_72": "解锁增益：战墙加固等级上限+{1}",
    "4_80": "{1}充值积分",
    "9_2050": "核心超频",
    "9_2046": "每装嵌1个红色品质的起源盘，所有起源基石的数值加成提升{1}%",
    "messageInitContent_9557": "跟随火焰的轨迹",
    "9_2047": "信息",
    "messageInitContent_9556": "你们在守护什么",
    "9_2044": "负重",
    "messageInitContent_9555": "我更勇",
    "9_2045": "起源基石当前数值加成：",
    "messageInitContent_9554": "愿火永不熄灭",
    "9_2042": "评级",
    "9_2043": "基石总评级",
    "9_2040": "全部",
    "messageInitContent_9559": "点起篝火",
    "9_2041": "剩余{1}",
    "messageInitContent_9558": "感受到火的注视了吗",
    "messageInitContent_9553": "火焰从不欺骗，它只揭露真相",
    "messageInitContent_9552": "你的心，是否已与烈火共鸣？",
    "9_2048": "分解",
    "messageInitContent_9551": "每一次火苗跳动都是未来的轨迹",
    "9_2049": "合成",
    "messageInitContent_9550": "妖火吗？？",
    "22_dish1356": "阳光生发特饮",
    "9_2060": "根据品质返还",
    "9_2061": "确认",
    "9_2057": "红色品质",
    "messageInitContent_9568": "愿圣火长燃，庇护此地的安宁",
    "9_2058": "单效果",
    "messageInitContent_9567": "火焰必将驱逐黑夜",
    "9_2055": "紫色品质",
    "messageInitContent_9566": "看啊，火神的烈火正在降临",
    "9_2056": "橙色品质",
    "messageInitContent_9565": "烈火蔓延",
    "9_2053": "请从左列表选择需要分解的起源盘（{1}）",
    "9_2054": "蓝色品质",
    "9_2051": "起源盘分解",
    "9_2052": "请从右列表选择需要分解的起源盘",
    "messageInitContent_9569": "圣火为证",
    "messageInitContent_9560": "火舌舔舐，罪恶灰飞",
    "messageInitContent_9564": "火光闪耀之处，异端必灭",
    "messageInitContent_9563": "以火为证",
    "9_2059": "双效果",
    "messageInitContent_9562": "火种长明",
    "messageInitContent_9561": "火焰不休",
    "9_2071": "超频增幅",
    "9_2072": "随机生成1-2条效果",
    "9_2070": "负重不足\\n无法装嵌",
    "9_2068": "重量",
    "messageInitContent_9579": "以火锅为名调笑神焰，当心灵魂被烹煮",
    "9_2069": "已装嵌",
    "messageInitContent_9578": "亵渎火焰者，连灰烬都不配留下",
    "9_2066": "起源核心",
    "messageInitContent_9577": "火锅一开，火神都馋",
    "9_2067": "起源盘",
    "messageInitContent_9576": "接受烈火的审判",
    "9_2064": "消耗",
    "9_2065": "合成",
    "9_2062": "起源盘合成",
    "9_2063": "合成将重新随机效果/效果数/重量",
    "messageInitContent_9571": "火焰净化万物",
    "messageInitContent_9570": "以火焰之名",
    "messageInitContent_9575": "火焰高歌",
    "messageInitContent_9574": "烈火狂舞",
    "messageInitContent_9573": "烈火高歌",
    "messageInitContent_9572": "火庇护你",
    "9_2082": "探索者等级{1}开启",
    "9_2083": "可装嵌",
    "9_2080": "未解锁",
    "9_2081": "时长：+{1}天",
    "9_2079": "未开启",
    "messageInitContent_9589": "以火焰之名",
    "9_2077": "效果重置",
    "messageInitContent_9588": "以火为证",
    "9_2078": "超频",
    "messageInitContent_9587": "向火焰起誓",
    "9_2075": "装嵌",
    "9_2076": "卸下",
    "9_2073": "必定出现1条起源盘效果",
    "9_2074": "必定出现2条起源盘效果",
    "messageInitContent_9582": "以火为证",
    "messageInitContent_9581": "烈火之辉抚慰我心",
    "messageInitContent_9580": "烈火炽烈驱走一切灾厄",
    "messageInitContent_9586": "绝不放过任何入侵者",
    "messageInitContent_9585": "感受火之意志",
    "messageInitContent_9584": "火庇护你",
    "messageInitContent_9583": "你必须记住火焰",
    "9_2002": "骨场",
    "9_2003": "木场",
    "messageInitContent_9599": "你听到火的愤怒吗",
    "9_2001": "领地",
    "messageInitContent_9598": "让火焰燃去一切痛苦",
    "messageInitContent_9593": "火焰燃烧之声就是祂的低语",
    "messageInitContent_9592": "火神在看着你",
    "9_2008": "一发入欧店",
    "messageInitContent_9591": "火焰必将驱逐外敌",
    "9_2009": "斗技场",
    "messageInitContent_9590": "接受火焰与命运的审判",
    "9_2006": "探索营地",
    "messageInitContent_9597": "火焰将惩戒不敬之徒",
    "9_2007": "起源基石",
    "messageInitContent_9596": "火种于心",
    "9_2004": "鳞场",
    "messageInitContent_9595": "火焰之下，愿我们坚守至永恒",
    "9_2005": "仓库",
    "messageInitContent_9594": "烈火环绕，邪灵尽散",
    "visionSagesOption3_13": "不需要，解锁即可获得",
    "visionSagesOption3_12": "不再自动产出",
    "visionSagesOption3_11": "每片森林只有一个，内含多种奖励",
    "9_2013": "战墙",
    "9_2014": "浮空巨塔",
    "9_2011": "谜之巢穴",
    "9_2012": "起源殿",
    "9_2010": "黑暗森林",
    "9_2019": "部落",
    "9_2017": "永生之茧",
    "9_2018": "凿星裂痕",
    "9_2015": "造唤台",
    "9_2016": "饲星坛",
    "9_2024": "领取资源",
    "visionSagesOption3_10": "不行，建议合作打敌人",
    "9_2023": "升级中",
    "9_2020": "立即完成",
    "9_2028": "建造",
    "9_2027": "进入",
    "9_2035": "回城",
    "godContractConfigDescription_14": "在战斗第{p1}秒时，获得{?}点能量",
    "9_2036": "总怪兽等级",
    "godContractConfigDescription_15": "进入炼狱模式时，获得{?}点能量",
    "9_2033": "点击输入留言",
    "godContractConfigDescription_12": "场上敌我双方神灵相同时，敌方神灵被动效果降低{?}%",
    "9_2034": "取消",
    "godContractConfigDescription_13": "在战斗第{p1}秒时，获得{?}点能量",
    "9_2031": "（该基石增益对双种族怪兽只生效1次）",
    "godContractConfigDescription_10": "战斗开始时上场的神灵切换后仍然会提供{?}%的被动效果",
    "9_2032": "种族限定：",
    "godContractConfigDescription_11": "所有神灵被动效果提升{?}%",
    "9_2030": "属性增益",
    "9_2039": "总极化评级",
    "godContractConfigDescription_18": "拥有{p1}点能量时，能量回复速度加快{?}%",
    "9_2037": "总基因强化等级",
    "godContractConfigDescription_16": "每消耗{p1}点能量时，回复{?}点能量",
    "9_2038": "总技能等级",
    "godContractConfigDescription_17": "己方远古族怪兽死亡时，回复{?}点能量（复活等可以触发多次）",
    "randomEventDialogueGroupConfig_9.167": "大包",
    "randomEventDialogueGroupConfig_9.168": "大包",
    "randomEventDialogueGroupConfig_9.169": "大包",
    "messageInitContent_11332": "秒懂",
    "randomEventDialogueGroupConfig_9.163": "它打开你选择的小包，里头确实是空的。",
    "messageInitContent_11331": "再见",
    "randomEventDialogueGroupConfig_9.164": "再来一次",
    "messageInitContent_11334": "爱你",
    "randomEventDialogueGroupConfig_9.165": "放弃",
    "messageInitContent_11333": "点个赞谢谢",
    "randomEventDialogueGroupConfig_9.166": "它又从兜里掏出了四个大包。",
    "randomEventDialogueGroupConfig_9.160": "中包",
    "messageInitContent_11330": "吃了吗",
    "randomEventDialogueGroupConfig_9.161": "中包",
    "randomEventDialogueGroupConfig_9.162": "中包",
    "messageInitContent_11339": "底下的红色板子是什么机关嘛",
    "messageInitContent_11336": "想当个什么都不用做的挂件",
    "messageInitContent_11335": "我服了",
    "messageInitContent_11338": "不许熬夜",
    "messageInitContent_11337": "摸鱼时间",
    "randomEventDialogueGroupConfig_9.178": "唔，让我想想，虚拟的我如何送出实际的东西呢，啊我也会创作了！谢谢你，还有你要的奖励。",
    "randomEventDialogueGroupConfig_9.179": "收下",
    "messageInitContent_11321": "行吧",
    "randomEventDialogueGroupConfig_9.174": "它很不情愿地把东西交给了你。",
    "messageInitContent_11320": "饭盒之王",
    "randomEventDialogueGroupConfig_9.175": "收下",
    "messageInitContent_11323": "等一个探索之风",
    "randomEventDialogueGroupConfig_9.176": "啊，这就放弃了吗，不知道你知不知道有个魔女曾经说过，退则存其一，进则两者皆存。#不过没关系啦，跟你聊天真开心，拜拜。",
    "messageInitContent_11322": "该搬砖了",
    "randomEventDialogueGroupConfig_9.177": "告别",
    "randomEventDialogueGroupConfig_9.170": "大包",
    "randomEventDialogueGroupConfig_9.171": "你又猜对了？不如，你知道我想说什么的。",
    "randomEventDialogueGroupConfig_9.172": "只要奖励",
    "randomEventDialogueGroupConfig_9.173": "相信自己的运气",
    "messageInitContent_11329": "搜完就走",
    "messageInitContent_11328": "对嘛好大个拳头",
    "messageInitContent_11325": "缩圈了",
    "messageInitContent_11324": "先走一步",
    "messageInitContent_11327": "报告，落地成盒",
    "messageInitContent_11326": "跑起来",
    "messageInitContent_11310": "什么元素克制火",
    "messageInitContent_11312": "消防安全齐关注",
    "messageInitContent_11311": "火抗性很高",
    "randomEventDialogueGroupConfig_9.181": "敷衍一下离开",
    "randomEventDialogueGroupConfig_9.182": "不对等等，说好的锻炼呢。",
    "randomEventDialogueGroupConfig_9.183": "赶紧走不锻炼了",
    "randomEventDialogueGroupConfig_9.184": "停步去锻炼",
    "messageInitContent_11318": "欧气吸取",
    "messageInitContent_11317": "这关是不是针对我了",
    "messageInitContent_11319": "反弹",
    "randomEventDialogueGroupConfig_9.180": "真的很好吃你不要我就自己吃了哼，再见咯。",
    "messageInitContent_11314": "瞬发多发定点",
    "messageInitContent_11313": "多放点灭火器",
    "messageInitContent_11316": "天才想法",
    "messageInitContent_11315": "挂机多少天机可以通关",
    "giantName_2": "祖龙族-浮空巨塔{1}",
    "giantName_1": "浮空巨塔{1}",
    "giantName_4": "星灵族-浮空巨塔{1}",
    "giantName_3": "尸鬼族-浮空巨塔{1}",
    "giantName_6": "原生族-浮空巨塔{1}",
    "giantName_5": "木偶族-浮空巨塔{1}",
    "messageInitContent_11301": "打得不错",
    "messageInitContent_11300": "你只能攻击那些关卡里的怪兽",
    "messageInitContent_11307": "你们可以滑倒地图的那一头",
    "messageInitContent_11306": "看着铺满地面的香蕉皮",
    "messageInitContent_11309": "看饿了",
    "messageInitContent_11308": "这进化叉会不会和酋长打起来",
    "messageInitContent_11303": "命运一抽",
    "messageInitContent_11302": "发牌员出来！",
    "messageInitContent_11305": "我的陷阱已经锁好",
    "messageInitContent_11304": "好好好",
    "randomEventDialogueGroupConfig_9.127": "不是这个哦~啊不过我已经没有库存让你猜了，如果你有什么好创作一定要告诉我哦，拜拜。",
    "randomEventDialogueGroupConfig_9.128": "告别",
    "randomEventDialogueGroupConfig_9.129": "这次你终于猜对了！恭喜你！就送你一个美好的祝福吧，希望你今晚能梦到自己在梦自己。",
    "randomEventDialogueGroupConfig_9.123": "收下",
    "randomEventDialogueGroupConfig_9.124": "你说什么呀，我可听不懂。你还要继续挑战吗？狂躁的稳定感和致命的爱歌，我最喜欢哪个？",
    "randomEventDialogueGroupConfig_9.125": "狂躁的稳定感",
    "randomEventDialogueGroupConfig_9.126": "致命的爱歌",
    "randomEventDialogueGroupConfig_9.120": "问它确定是那个字没错吗",
    "randomEventDialogueGroupConfig_9.121": "和它聊聊黑暗料理",
    "randomEventDialogueGroupConfig_9.122": "你猜对了，这句是它讽刺我唱情歌的样子的特意给我写的呢！突然想去找它算账了呢。来给你奖励。",
    "creationDialog561_1": "你在想什么呢？",
    "randomEventDialogueGroupConfig_9.138": "它说着从兜里拿出三个牌子，上面写着不同的文字。",
    "randomEventDialogueGroupConfig_9.139": "选写着“这个”的牌子",
    "creationDialog561_5": "我没听清楚~",
    "randomEventDialogueGroupConfig_9.134": "默默离开",
    "creationDialog561_4": "再说一遍！",
    "randomEventDialogueGroupConfig_9.135": "抱歉，刚刚好像被一阵邪典型黑暗冲昏头脑了，谢谢你拯救了我。商店开着，可以去看看哦。",
    "creationDialog561_3": "是嘛~",
    "randomEventDialogueGroupConfig_9.136": "进店",
    "creationDialog561_2": "你刚刚说什么了？",
    "randomEventDialogueGroupConfig_9.137": "说下次再去",
    "randomEventDialogueGroupConfig_9.130": "道谢告别",
    "randomEventDialogueGroupConfig_9.131": "说想要实际点的奖励",
    "randomEventDialogueGroupConfig_9.132": "说起这个，我可就不困了！我这里还有些从超星海洋沙滩捡来的小玩意。你看！#有酸梅酱咖啡、龟苓膏肠粉、辣味硬糖、饺子包披萨、黄瓜糖葫芦、大猪蹄子、虾仁猪心、酸菜鱼、柠檬树桃子汽水……",
    "randomEventDialogueGroupConfig_9.133": "打断它的话",
    "randomEventDialogueGroupConfig_9.149": "告别",
    "randomEventDialogueGroupConfig_9.145": "它很疑惑地看着你。",
    "randomEventDialogueGroupConfig_9.146": "跳高",
    "randomEventDialogueGroupConfig_9.147": "跳远",
    "randomEventDialogueGroupConfig_9.148": "发型和味道还差一些。走了走了，你加油。",
    "randomEventDialogueGroupConfig_9.141": "选写着“全都不选”的牌子",
    "randomEventDialogueGroupConfig_9.142": "它说着摆了摆手。",
    "randomEventDialogueGroupConfig_9.143": "动手",
    "creationDialog561_6": "嗯？",
    "randomEventDialogueGroupConfig_9.144": "动脚",
    "randomEventDialogueGroupConfig_9.140": "选写着“全都要选”的牌子",
    "randomEventDialogueGroupConfig_9.156": "它说着从兜里掏出两个小包。",
    "randomEventDialogueGroupConfig_9.157": "小包",
    "randomEventDialogueGroupConfig_9.158": "小包",
    "randomEventDialogueGroupConfig_9.159": "它又从兜里掏出了三个稍大一点的包。",
    "randomEventDialogueGroupConfig_9.152": "奖励真的非常好哦。而且很容易选中的呢。",
    "randomEventDialogueGroupConfig_9.153": "继续拒绝",
    "randomEventDialogueGroupConfig_9.154": "切，没意思，不好玩，拿去吧你。",
    "randomEventDialogueGroupConfig_9.155": "拿走奖励",
    "randomEventDialogueGroupConfig_9.150": "它一溜烟地跑了。",
    "randomEventDialogueGroupConfig_9.151": "离开",
    "98_-20029": "未达到指定的性格条件，无法指定",
    "98_-20028": "该下阵怪兽连续性缺失",
    "98_-20027": "该阵容位置不存在怪兽",
    "98_-20026": "一只怪兽都不上？那……谁上呢",
    "98_-20025": "等级{1}开启进化",
    "98_-20024": "性格点数不足，无法指定",
    "messageInitNick_236": "踩光游戏彩蛋",
    "98_-20023": "该限时形态已过期",
    "messageInitNick_237": "又冲上了赛道",
    "98_-20022": "尚未拥有该形态",
    "messageInitNick_238": "超神之路",
    "98_-20021": "一只自己的怪都不上？本队做不到啊！！",
    "messageInitNick_239": "翻车王",
    "98_-20020": "一只自己的怪都不上？不怕谜之生物跟你的好友跑了？",
    "messageInitNick_230": "肉的一批",
    "messageInitNick_231": "很满足",
    "messageInitNick_232": "伤害爆炸",
    "messageInitNick_233": "要成为王的人",
    "messageInitNick_234": "我是欧皇",
    "messageInitNick_235": "冲上了赛道",
    "98_-20039": "怪兽等级不足，无法进行基因强化",
    "98_-20038": "怪兽上阵中，无法进行选取",
    "98_-20037": "怪兽已进化",
    "98_-20036": "该怪兽重置没有可以返还的材料，无法进行重置",
    "98_-20035": "该怪兽饲星没有可以返还的材料，无法进行饲星",
    "messageInitNick_247": "肝帝和欧皇",
    "98_-20034": "远古族怪兽无法进行重置",
    "messageInitNick_248": "这河狸吗",
    "98_-20033": "远古族与原生族无法进行饲星",
    "messageInitNick_249": "时代变了",
    "98_-20032": "怪兽等级已达到最高",
    "98_-20031": "已拥有该形态",
    "98_-20030": "cjhwy2",
    "messageInitNick_240": "企业级李姐",
    "messageInitNick_241": "把欧气点满了",
    "messageInitNick_242": "翻车帝",
    "messageInitNick_243": "说句不好吃的",
    "messageInitNick_244": "肝帝与欧皇",
    "messageInitNick_245": "翻车之王",
    "messageInitNick_246": "食堂泼辣酱",
    "13_4": "驱散谜雾，展示所有进化孢子树所在的位置",
    "13_3": "驱散谜雾，展示所有强化孢子树所在的位置",
    "13_2": "立即完成",
    "13_1": "开始探索",
    "8_150": "玩物之地",
    "randomEventDialogueGroupConfig_9.109": "来来来！发烧的冰箱，还有吃饭减肥法二选一呢。你认为我最喜欢的是？",
    "98_-20049": "该配置的怪兽已在其他阶段使用，无法复制配置",
    "messageInitNick_258": "爱人鬼士",
    "randomEventDialogueGroupConfig_9.105": "啊，你懂了！",
    "98_-20045": "该配置的元核在其他部队使用，无法复制配置",
    "messageInitNick_259": "爱的战神",
    "randomEventDialogueGroupConfig_9.106": "说再见",
    "98_-20044": "该配置的怪兽已在援军中，无法复制配置",
    "randomEventDialogueGroupConfig_9.107": "顺着这个思路想也没错啦，毕竟生活其实最大的博弈对手就是自己。溜了溜了。",
    "13_9": "提升霸气{1}%（+{2}%）",
    "98_-20043": "该配置的怪兽已在其他部队中，无法复制配置",
    "randomEventDialogueGroupConfig_9.108": "说再见",
    "13_8": "提升体力{1}%（+{2}%）",
    "98_-20042": "部队中存在濒死怪兽，无法复制配置。",
    "randomEventDialogueGroupConfig_9.101": "我家里有个孢子矿，哦正确来说是曾经有一个。#现在里头虽然一个孢子都没有，但很快我就会把赚到的100个放回去了呢。",
    "13_7": "提升怪兽的攻击力{1}%（+{2}%）",
    "98_-20041": "已拥有远古族",
    "randomEventDialogueGroupConfig_9.102": "说再见",
    "13_6": "驱散谜雾，展示所有命运之泉所在的位置",
    "98_-20040": "该怪兽已被锁定，无法进行此操作",
    "randomEventDialogueGroupConfig_9.103": "因为深陷其中的家伙，我遇到了太多了。也许会是下次遇到的……#先不说啦，我妈喊我回家吃饭，再见！",
    "13_5": "驱散谜雾，展示所有凶兽所在的位置",
    "randomEventDialogueGroupConfig_9.104": "说再见",
    "messageInitNick_250": "好朋友联盟",
    "messageInitNick_251": "犬夜叉猹",
    "messageInitNick_252": "大人时代变了",
    "messageInitNick_253": "一飞冲天啊我",
    "randomEventDialogueGroupConfig_9.100": "问它为什么这么懂",
    "messageInitNick_254": "小难瓜",
    "messageInitNick_255": "指南针战士",
    "messageInitNick_256": "冲击性的事实",
    "messageInitNick_257": "菠萝皮卡丘",
    "messageInitNick_269": "爱迪不能生",
    "randomEventDialogueGroupConfig_9.116": "炙热的冰纯色的虹",
    "randomEventDialogueGroupConfig_9.117": "上传人下载自己",
    "randomEventDialogueGroupConfig_9.118": "说不继续猜了",
    "randomEventDialogueGroupConfig_9.119": "这个倒是也不错了，不过我还是更喜欢里头的吃的。",
    "randomEventDialogueGroupConfig_9.112": "嘻嘻，这个确实是我第二喜欢的。来来来，就请你到我商店看看，如何？",
    "randomEventDialogueGroupConfig_9.113": "说下次吧",
    "randomEventDialogueGroupConfig_9.114": "说好",
    "randomEventDialogueGroupConfig_9.115": "哈哈哈，这句呀，看来你音乐玩的不错。#你看这句是不是好像要自己和自己打起来，但可惜并不是我喜欢的。还来吗？炙热的冰纯色的虹和上传人下载自己。",
    "messageInitNick_261": "被窝哲学家",
    "messageInitNick_262": "爱鬼人士",
    "messageInitNick_263": "变个身先",
    "randomEventDialogueGroupConfig_9.110": "发烧的冰箱",
    "messageInitNick_264": "盐汁油梨",
    "randomEventDialogueGroupConfig_9.111": "吃饭减肥法",
    "messageInitNick_265": "我咧哇钢大木",
    "messageInitNick_266": "等我变个身先",
    "messageInitNick_267": "被窝天使",
    "messageInitNick_268": "不要停下来",
    "messageInitNick_260": "等我变身",
    "messageInitNick_272": "自闭羽毛球",
    "messageInitNick_273": "爱弟狂魔",
    "messageInitNick_274": "变个身就来",
    "messageInitNick_275": "焊在床上",
    "messageInitNick_276": "吾王一生推",
    "messageInitNick_277": "路过的骑士",
    "messageInitNick_278": "跑五百米如厕",
    "messageInitNick_279": "吾王万岁",
    "messageInitNick_270": "等我变身好吗",
    "messageInitNick_271": "焊在被窝",
    "randomEventDialogueGroupConfig_51.9": "所以这一趟就拜托你了。",
    "randomEventDialogueGroupConfig_51.6": "-",
    "randomEventDialogueGroupConfig_51.5": "-",
    "randomEventDialogueGroupConfig_51.8": "-",
    "randomEventDialogueGroupConfig_51.7": "-",
    "messageInitNick_283": "决带笑",
    "messageInitNick_284": "一位小胖友",
    "messageInitNick_285": "路边的石鬼面",
    "messageInitNick_286": "要决带笑",
    "messageInitNick_287": "小胖友",
    "messageInitNick_288": "龙舌兰菇凉",
    "messageInitNick_289": "带来笑容",
    "randomEventDialogueGroupConfig_51.2": "过去看看",
    "randomEventDialogueGroupConfig_51.1": "你来到大漠边缘的一个小镇，此时一张悬赏令随风吹到了你脸上，你扒下来一看，上面写着镖局重金招募高手。",
    "randomEventDialogueGroupConfig_51.4": "-",
    "randomEventDialogueGroupConfig_51.3": "-",
    "messageInitNick_280": "路过的决斗王",
    "messageInitNick_281": "床离厕所太远",
    "messageInitNick_282": "我不做人类了",
    "98_-20009": "无法召唤已拥有的觉醒怪兽，在饲星坛可转化为万能碎片",
    "98_-20008": "已拥有远古族怪兽",
    "98_-20007": "该怪兽目前无法进化",
    "98_-20006": "怪兽已达到目前的最终进化形态",
    "98_-20005": "无法选择该属性的基因",
    "98_-20004": "好友怪兽不能上阵援军",
    "98_-20003": "该怪兽不存在",
    "98_-20002": "怪兽未觉醒，无法开启领域副本",
    "98_-20001": "cjhwy2",
    "messageInitNick_294": "朋友快住手",
    "messageInitNick_295": "吃我一拳",
    "messageInitNick_296": "铁之意志",
    "messageInitNick_297": "芝士就是力量",
    "messageInitNick_298": "谁的压路机",
    "messageInitNick_299": "钢之强韧",
    "messageInitNick_290": "上好的拳头",
    "messageInitNick_291": "波纹疾走",
    "messageInitNick_292": "为你带来笑容",
    "messageInitNick_293": "好吃的拳头",
    "98_-20019": "该形态尚未开放购买",
    "98_-20018": "部分队伍未上阵怪兽无法匹配",
    "98_-20017": "极化能力锁定数已达到上限",
    "98_-20016": "领域副本挑战次数不足",
    "98_-20014": "觉醒怪兽无法饲星",
    "98_-20013": "该领域副本正在搭建中",
    "98_-20012": "濒死状态的怪兽无法进行饲星",
    "98_-20011": "怪兽技能已到达最高等级",
    "98_-20010": "非觉醒怪兽无法升级技能",
    "messageInitContent_9270": "求金币灵多给我的金币几个零",
    "messageInitContent_9279": "别走近水，那不是水。是汤",
    "messageInitContent_9274": "彩钻灵！",
    "messageInitContent_9273": "好像钻石灵好一点",
    "messageInitContent_9272": "金币灵可还行",
    "messageInitContent_9271": "huh？",
    "messageInitContent_9278": "谁要试试",
    "messageInitContent_9277": "隔壁的汤看着就很地狱",
    "messageInitContent_9276": "都让你懂完了",
    "messageInitContent_9275": "懂了这些怪兽都是来喝汤的",
    "messageInitContent_9281": "骨头断时，我听见了石头在叹气。",
    "messageInitContent_9280": "大家都很原始除了",
    "8_101": "捕捉怪兽",
    "8_100": "使用捕兽夹",
    "8_103": "公告",
    "8_102": "问卷",
    "8_105": "触发一次该功能后可快捷触发",
    "8_104": "（神行中）",
    "8_107": "地鸣进度",
    "8_106": "预约",
    "8_109": "地鸣",
    "8_108": "查看位置",
    "messageInitContent_9285": "别对蝉说谎",
    "messageInitContent_9284": "啊？",
    "messageInitContent_9283": "汤说它今天不开心，别喝它",
    "messageInitContent_9282": "火饿了，要喂它点肉。",
    "messageInitContent_9289": "零件？",
    "messageInitContent_9288": "好怪",
    "messageInitContent_9287": "嗯？？",
    "messageInitContent_9286": "爱你空蝉",
    "messageInitContent_9292": "懂了是烤鱼",
    "messageInitContent_9291": "让火之指引你的道路",
    "messageInitContent_9290": "月亮会带走你的悲伤",
    "messageInitContent_9296": "红元核灵在此",
    "messageInitContent_9295": "惊",
    "messageInitContent_9294": "火会照亮，也能烤熟",
    "messageInitContent_9293": "怪不得决定好像",
    "messageInitContent_9299": "感受万物的伤悲",
    "messageInitContent_9298": "耳朵贴近骨头，你能听见它的指引",
    "messageInitContent_9297": "别放走你的影子",
    "8_130": "联结大厅",
    "8_132": "\\n（购买纹银月曜后，可免费找回索者经验）",
    "8_131": "人数",
    "8_134": "购买鎏金月曜后可使用自动挑战，是否前往购买？",
    "8_133": "\\n（已购买纹银月曜，可免费找回索者经验）",
    "8_136": "复制体已全部被击破",
    "8_135": "猎物挑战完毕",
    "8_138": "共鸣评级到达{1}",
    "8_137": "申请已发送！",
    "8_139": "难度{1}",
    "8_141": "是否把该玩家踢出联结共鸣？",
    "8_140": "已使用",
    "8_143": "虚诞之地",
    "messageInitNick_203": "明天回非洲",
    "8_142": "获得评级",
    "messageInitNick_204": "第一战斗配置",
    "8_145": "广告",
    "messageInitNick_205": "队友很菜",
    "8_144": "太古之地",
    "messageInitNick_206": "今晚去非洲",
    "8_147": "开通纹银月曜即可免费获取奖励",
    "messageInitNick_207": "小力快跑",
    "8_146": "可领取奖励",
    "messageInitNick_208": "爱的末路",
    "8_149": "免费领取",
    "messageInitNick_209": "我是菜",
    "8_148": "观看广告",
    "messageInitNick_200": "今晚去欧洲",
    "messageInitNick_201": "在你心迷路",
    "messageInitNick_202": "队友很强",
    "8_110": "总探索度",
    "messageInitNick_214": "快去创造奇迹",
    "messageInitNick_215": "真是菜菜",
    "8_112": "{1}：{2}",
    "messageInitNick_216": "明晚回欧洲",
    "8_111": "未解锁",
    "messageInitNick_217": "我讨厌加班",
    "8_114": "解锁条件：{1}",
    "messageInitNick_218": "菜菜子",
    "8_113": "（已达上限）",
    "messageInitNick_219": "网恋选我",
    "8_116": "，拥有{1}只觉醒怪兽",
    "8_115": "世界总探索度到达{1}%{2}",
    "8_118": "闭锁的世界之门",
    "8_117": "进入",
    "8_119": "天选造唤",
    "messageInitNick_210": "今天去非洲",
    "messageInitNick_211": "勇敢的少年啊",
    "messageInitNick_212": "菜鸟在此",
    "messageInitNick_213": "土味哥",
    "8_121": "发现",
    "messageInitNick_225": "瞎得瑟",
    "8_120": "需在对应层才可查看位置",
    "messageInitNick_226": "这网线我拔了",
    "8_123": "探索之锋{1}：\\n有探索者踏入新一层位面时，之前所有位面的关卡中敌方怪兽血量降低25%。\\n一起为那些勇于挑战，一往无前的探索者欢呼吧！",
    "messageInitNick_227": "仙女界扛把子",
    "8_122": "探索之锋",
    "messageInitNick_228": "全点防御力",
    "8_125": "（效果未开启）",
    "messageInitNick_229": "这螺丝我拔了",
    "8_124": "[{1}] {2}连续3日一动不动后{3}成为了管理员",
    "8_127": "属于你的复制体已全部被击破",
    "8_126": "（效果已开启）",
    "8_129": "查看信息",
    "8_128": "已发布邀请信息",
    "messageInitNick_220": "我很好奇",
    "messageInitNick_221": "卡我捡来了",
    "messageInitNick_222": "我超甜",
    "messageInitNick_223": "节能主义",
    "messageInitNick_224": "卡都是捡来的",
    "messageInitContent_11291": "而我是要成为航海王的男人",
    "realmConfigDes_54": "崩界领主4",
    "messageInitContent_11290": "大家好我是潜水王",
    "realmConfigDes_53": "崩界领主3",
    "messageInitContent_11293": "我的潜水艇在哪里",
    "realmConfigDes_56": "破魂领主1",
    "messageInitContent_11292": "冒泡",
    "realmConfigDes_55": "崩界领主5",
    "realmConfigDes_50": "血渊守护5",
    "realmConfigDes_52": "崩界领主2",
    "realmConfigDes_51": "崩界领主1",
    "messageInitContent_11299": "测试打法中",
    "messageInitContent_11298": "欢迎回来",
    "messageInitContent_11295": "刚从传送带下来",
    "realmConfigDes_47": "血渊守护2",
    "messageInitContent_11294": "让大嘴鱼王带我潜水",
    "realmConfigDes_46": "血渊守护1",
    "messageInitContent_11297": "再打亿遍",
    "realmConfigDes_49": "血渊守护4",
    "messageInitContent_11296": "已经知道怎么赢了",
    "realmConfigDes_48": "血渊守护3",
    "messageInitContent_11280": "噢我的盘",
    "realmConfigDes_43": "咒灭守护3",
    "realmConfigDes_42": "咒灭守护2",
    "messageInitContent_11282": "冷静点",
    "realmConfigDes_45": "咒灭守护5",
    "messageInitContent_11281": "别砸到我的祈了可恶",
    "realmConfigDes_44": "咒灭守护4",
    "realmConfigDes_41": "咒灭守护1",
    "realmConfigDes_40": "永腐魔5",
    "messageInitContent_11288": "音响大冒险",
    "messageInitContent_9205": "进化树关2",
    "messageInitContent_11287": "反正我会",
    "messageInitContent_9204": "冲冲冲",
    "realmConfigDes_39": "永腐魔4",
    "messageInitContent_9203": "我是要成为海贼王的怪兽！",
    "messageInitContent_11289": "握爪爪",
    "messageInitContent_9202": "被新怪撞下去hhhhh",
    "messageInitContent_11284": "服了",
    "messageInitContent_9209": "我先上去了",
    "realmConfigDes_36": "永腐魔1",
    "messageInitContent_11283": "用扇子扇我！",
    "messageInitContent_9208": "好多传送门",
    "realmConfigDes_35": "凶噬魔5",
    "messageInitContent_11286": "猫罐头会晕3d吗",
    "messageInitContent_9207": "凶噬魔能飞回去吗",
    "realmConfigDes_38": "永腐魔3",
    "messageInitContent_11285": "这里有陪玩的吗",
    "messageInitContent_9206": "狩猎开始！",
    "realmConfigDes_37": "永腐魔2",
    "messageInitContent_9201": "貌似只有这个岛是海岛",
    "messageInitContent_9200": "这就是进化！",
    "realmConfigDes_32": "凶噬魔2",
    "realmConfigDes_31": "凶噬魔1",
    "messageInitContent_11271": "我哭死",
    "realmConfigDes_34": "凶噬魔4",
    "messageInitContent_11270": "推荐星之物语",
    "realmConfigDes_33": "凶噬魔3",
    "realmConfigDes_30": "尸狂5",
    "messageInitContent_11277": "需要白昼治愈我未能通关的心",
    "messageInitContent_9216": "首位上天的探索者再次",
    "realmConfigDes_29": "尸狂4",
    "messageInitContent_11276": "葬爱的龙王",
    "messageInitContent_9215": "第一",
    "realmConfigDes_28": "尸狂3",
    "messageInitContent_11279": "踢",
    "messageInitContent_9214": "你们都上天了吗",
    "messageInitContent_11278": "踢我一下",
    "messageInitContent_9213": "一片区域3个传送门",
    "messageInitContent_11273": "脑袋空空",
    "realmConfigDes_25": "熵鬼5",
    "messageInitContent_11272": "抱抱你社恐龙",
    "messageInitContent_9219": "早上好下午好晚上好",
    "realmConfigDes_24": "熵鬼4",
    "messageInitContent_11275": "Joker是宝箱怪吗",
    "messageInitContent_9218": "gogogo",
    "realmConfigDes_27": "尸狂2",
    "messageInitContent_11274": "抱抱你陌生人",
    "messageInitContent_9217": "据说这里相信万物有灵",
    "realmConfigDes_26": "尸狂1",
    "messageInitContent_9212": "通向新大陆的传送门我来啦",
    "messageInitContent_9211": "通向新大陆的传送门我来啦",
    "messageInitContent_9210": "进化树关3",
    "realmConfigDes_21": "熵鬼1",
    "realmConfigDes_20": "圣光古龙5",
    "messageInitContent_11260": "什么换装play",
    "realmConfigDes_23": "熵鬼3",
    "realmConfigDes_22": "熵鬼2",
    "messageInitContent_11266": "赛博朋克2088",
    "messageInitContent_9227": "我是关卡灵",
    "realmConfigDes_18": "圣光古龙3",
    "messageInitContent_11265": "大家好，我是强尼金手指",
    "messageInitContent_9226": "我是战墙灵",
    "realmConfigDes_17": "圣光古龙2",
    "messageInitContent_11268": "你好，V",
    "messageInitContent_9225": "天灵灵地灵灵过关第一名",
    "messageInitContent_11267": "没有bug的世界是这里吗",
    "messageInitContent_9224": "什么传送门铃",
    "realmConfigDes_19": "圣光古龙4",
    "messageInitContent_11262": "超进化暖暖",
    "realmConfigDes_14": "黯炎古龙4",
    "messageInitContent_11261": "是帮魅妆化妆的游戏？",
    "realmConfigDes_13": "黯炎古龙3",
    "messageInitContent_11264": "无敌了",
    "messageInitContent_9229": "嘻嘻",
    "realmConfigDes_16": "圣光古龙1",
    "messageInitContent_11263": "叉叉换装进化！",
    "messageInitContent_9228": "元核灵在此",
    "realmConfigDes_15": "黯炎古龙5",
    "messageInitContent_9223": "万物有灵",
    "messageInitContent_11269": "我还是W呢",
    "messageInitContent_9222": "我是传送门灵",
    "messageInitContent_9221": "握草",
    "messageInitContent_9220": "荧灵也是灵",
    "realmConfigDes_10": "逆焰龙王5",
    "realmConfigDes_12": "黯炎古龙2",
    "realmConfigDes_11": "黯炎古龙1",
    "messageInitContent_11255": "打完这关就睡",
    "messageInitContent_9238": "这个cp也锁得太死了吧",
    "messageInitContent_11254": "命令包租公把所有房子给我",
    "messageInitContent_9237": "第一时间看看奖励",
    "messageInitContent_11257": "不是在迷路，而是在探索",
    "messageInitContent_9236": "二小关混进了一只奇怪的东西",
    "messageInitContent_11256": "赢一把就睡",
    "messageInitContent_9235": "如果爱拥有颜色那一定是王色",
    "messageInitContent_11251": "国王游戏开始 我是国王",
    "messageInitContent_11250": "什么奇怪的片场",
    "messageInitContent_11253": "明明是包租公游戏",
    "messageInitContent_11252": "不对劲",
    "messageInitContent_9239": "请你吃香蕉",
    "messageInitContent_9230": "不要说太大声，风会听到。",
    "messageInitContent_11259": "我是NPC，你好",
    "messageInitContent_9234": "别在风还没醒时出发。",
    "messageInitContent_11258": "这就是探索者的精神",
    "messageInitContent_9233": "螺旋巽倒是真的风神",
    "messageInitContent_9232": "救命这些人玩够谐音梗了没有",
    "messageInitContent_9231": "眼瞪大像瞳灵",
    "messageInitContent_11244": "我的通关记录会不会被漆黑组件破解的，害怕",
    "messageInitContent_9249": "红词条灵在此",
    "messageInitContent_11243": "这个关卡不太冷",
    "messageInitContent_9248": "冲鸭",
    "messageInitContent_11246": "是把东西拼起来就可以了吗",
    "messageInitContent_9247": "怕怕",
    "messageInitContent_11245": "欢迎来到益智小游戏",
    "messageInitContent_9246": "这边是在搞什么仪式嘛",
    "messageInitContent_11240": "演戏是什么游戏",
    "messageInitContent_11242": "好冷",
    "messageInitContent_11241": "角色扮演游戏",
    "messageInitContent_9241": "第一个空岛关卡",
    "messageInitContent_9240": "火神应该在隔壁那个空岛",
    "messageInitContent_11248": "溜了溜了",
    "messageInitContent_9245": "蜃仙？",
    "messageInitContent_11247": "她盯着我 我害怕",
    "messageInitContent_9244": "会下海",
    "messageInitContent_9243": "会",
    "messageInitContent_11249": "谁要沙盒粉",
    "messageInitContent_9242": "这里掉下去会不会",
    "messageInitContent_11233": "咱们这个游戏不难，规则看2年就行了",
    "messageInitContent_11232": "不厚，压个泡面问题不大",
    "messageInitContent_9259": "请叫我赢灵",
    "messageInitContent_11235": "机械08永远的爱",
    "messageInitContent_9258": "我吃西餐用叉会亵渎叉灵吗",
    "messageInitContent_11234": "什么游戏？？",
    "messageInitContent_9257": "叉灵",
    "messageInitContent_11231": "规则书还在写",
    "messageInitContent_11230": "为什么规则书这么厚",
    "messageInitContent_9252": "前方即将到达全地图唯一集市",
    "messageInitContent_9251": "新原生",
    "messageInitContent_9250": "又混进了奇怪的东西",
    "messageInitContent_11237": "机器人永远的爱",
    "messageInitContent_9256": "叉叉是啥灵",
    "messageInitContent_11236": "机械迷城永远的爱",
    "messageInitContent_9255": "大家好",
    "messageInitContent_11239": "什么适合机器人可以养老",
    "messageInitContent_9254": "地图外面那个骷髅盯着我看，怎么办",
    "messageInitContent_11238": "不对，你的机器人怎么在跳秧歌",
    "messageInitContent_9253": "咎也拉出来打工了",
    "messageInitContent_11222": "千万要看着美杜莎莎",
    "messageInitContent_11221": "何时该前进",
    "messageInitContent_11224": "怎么一闭眼就通关了",
    "messageInitContent_9269": "晚安世界",
    "messageInitContent_11223": "不要碰她的魂灯",
    "messageInitContent_9268": "有端联想",
    "messageInitContent_11220": "自动通关的秘密v我",
    "messageInitContent_9263": "你们没把我大锤神放在眼里",
    "messageInitContent_11229": "必须踩上所有加速块！",
    "messageInitContent_9262": "寒息护我",
    "messageInitContent_9261": "祈求冰灵冻结敌兽",
    "messageInitContent_9260": "请求冰灵的冷静与庇佑",
    "messageInitContent_11226": "会飞出去",
    "messageInitContent_9267": "神灵也是灵~",
    "messageInitContent_11225": "站在上面会发生什么",
    "messageInitContent_9266": "才发现镰刀没有脖子",
    "messageInitContent_11228": "这里是我的赛道走开",
    "messageInitContent_9265": "幻这个吉他台不有灵",
    "messageInitContent_11227": "脚滑了一下",
    "messageInitContent_9264": "笑死",
    "messageInitContent_11211": "连锁2发动我的心",
    "messageInitContent_11210": "连锁1发动我的身体",
    "messageInitContent_11213": "连锁4发动我的被子",
    "messageInitContent_11212": "连锁3发动我的大脑",
    "messageInitContent_11219": "团结就是力量",
    "messageInitContent_11218": "好好加班",
    "messageInitContent_11215": "天才玩家",
    "messageInitContent_11214": "逆算处理，起床打怪",
    "messageInitContent_11217": "末日奇迹",
    "messageInitContent_11216": "好冷",
    "resoundEffectConfigName_8": "凿星钥匙上限+{p1}",
    "resoundEffectConfigName_7": "移动力上限+{p1}",
    "resoundEffectConfigName_6": "部落战令上限+{p1}",
    "resoundEffectConfigName_5": "移动力上限+{p1}",
    "resoundEffectConfigName_9": "移动力上限+{p1}",
    "messageInitContent_11200": "嘿嘿是按哪里",
    "messageInitContent_11202": "我还前前后后",
    "messageInitContent_11201": "哪里的上下左右",
    "messageInitContent_11208": "微笑",
    "messageInitContent_11207": "真的不会打到叉叉",
    "messageInitContent_11209": "手滑了一下",
    "messageInitContent_11204": "前排出售玩物之地地图",
    "resoundEffectConfigName_4": "黑暗森林探索点上限+{p1}",
    "messageInitContent_11203": "可怕",
    "resoundEffectConfigName_3": "移动力上限+{p1}",
    "messageInitContent_11206": "总之就算赢了",
    "resoundEffectConfigName_2": "永生尖刺上限+{p1}",
    "messageInitContent_11205": "想玩机械迷城",
    "resoundEffectConfigName_1": "移动力上限+{p1}",
    "randomEventDialogueGroupConfig_50.7": "-",
    "randomEventDialogueGroupConfig_50.6": "-",
    "randomEventDialogueGroupConfig_50.9": "……情况就是这样，这是镖单，行话和规矩可你都要记好了，这些伙计也会随你一同出发。凭你这身本事，这趟绝对旗开得胜。交给你了！",
    "randomEventDialogueGroupConfig_50.8": "-",
    "mainCityDes_18": "星球的微笑，神秘又美丽。\\n当你对星球微笑时，星球也在对你微笑。\\n深渊：“？？？”\\n裂痕：“这个时候只要微笑就可以了。”\\n「升级可增加凿星宝箱二次奖励概率」",
    "mainCityDes_19": "一只叉叉独自展开冒险，遇到了超级大危机。\\n三十只叉叉一起展开冒险，也遇到了同样的超级大危机。\\n与前者相比，后者说不定能跑掉几只。\\n这！就是部落。这就是部落吗？不，那是三十只叉叉！\\n三十只叉叉部落合力解决了超级大危机！这！就是部落！",
    "mainCityDes_10": "黑暗森林的黑暗是多义的，无光只是其一，在踏入森林那一刻就知道了；能否获悉更多，主要取决于接下来能走多远。\\n黑暗森林的森林是无意的，有意的是里头的猎物和猎手。它们的转换随时随地、毫无预兆。它们环环相扣构，形成复杂的链条。\\n认清自己身处在哪一环尤为重要，或者稍稍退一步说，最关键的选择反而回到了原点，进还是不进？\\n「升级可解锁漆黑之根能力」",
    "randomEventDialogueGroupConfig_50.3": "-",
    "mainCityDes_11": "这里是谜之生物的巢穴，谜之生物又是谜团的巢穴，充满各种谜之操作、谜之自信、谜之脸红……\\n巢穴之外是暴走旷野，一片满是对手的广阔草场，有着如“草草草草草草草”或“wwwwwww”一般的风景。与谜之生物一同冲杀过去，即可用“早早早早早早早”或“…………………”将风景瞬间覆写！\\n「升级可解锁暴走旷野援军位置」",
    "randomEventDialogueGroupConfig_50.2": "立即前往",
    "mainCityDes_12": "“胜负只是一时的，永恒的荣光自起源殿的高塔倾泻而下，照耀那些超越者。”\\n喂喂，搞什么啊，横幅不是挂那条啊，是这条。\\n“5V5公平对抗！齐聚起源，踏平巅峰！是兄弟就来战！” \\n是这条啊——！\\n「升级可增加起源殿每日免费挑战次数」",
    "randomEventDialogueGroupConfig_50.5": "-",
    "mainCityDes_13": "强有很多种，比如一般的强和肉眼可见的强。\\n墙也是一样，有很多种。一般的墙是被动的，守着墙内，阻挡入侵者。而战墙则是主动的……\\n等等我还没说完，那边那个搬梯子的什么回事？\\n「升级可解锁战纹位置」",
    "randomEventDialogueGroupConfig_50.4": "-",
    "mainCityDes_14": "我们会永远记住第一只将学舌鸦放生的怪兽。\\n正是它的这一善举，推开了笼罩浮空巨塔的迷雾，让地表的怪兽得以窥见这座如天空龙脊柱般的巨塔，大升空时代就此开启，怪兽前赴后继地对这片无主之地发起了挑战。\\n也正是它的这一善举，让学舌鸦的过劳率实现了从0到1的增长！",
    "mainCityDes_15": "这里可以窥探粉色的暧昧、自身的血统、造唤的秘密，更重要的是，还能窥探心底那头欲望的野兽。它不时对你发起挑战，顺着你的想法，拒绝它，或是接受它。\\n「升级可缩短免费造唤间隔」",
    "mainCityDes_16": "如果说怪兽与穿越之间，只差了一条马路，那么怪兽和重生之间，只差了一个饲星坛。就算有不得不要完成的事，也不要轻易触碰禁忌，那里通常意味着危险，意味着无法挽回。但也有例外的时候，例如你是不是也觉得这里缺个策划？指能饲星那种。\\n「升级可增加饲星商店可兑换物品数」",
    "randomEventDialogueGroupConfig_50.1": "你来到了中心集市，在骸骨广场上看到了一张崭新的悬赏令，上面写着镖局重金招募镖师走镖。",
    "mainCityDes_17": "它，是永远鼓动着的茧。\\n有的怪兽以为它渴望终止，因而侵入它，带去终结。\\n有的怪兽以为它带来永生，因而侵略它，夺取生命。\\n难道说，生与死的博弈才是真正的永恒……\\n「升级可缩短尖刺回复间隔」",
    "realmConfigDes_90": "暴虐战狂5",
    "realmConfigDes_92": "神剑古拉姆2",
    "realmConfigDes_91": "神剑古拉姆1",
    "realmConfigDes_98": "圣盾埃癸斯3",
    "realmConfigDes_97": "圣盾埃癸斯2",
    "realmConfigDes_99": "圣盾埃癸斯4",
    "realmConfigDes_94": "神剑古拉姆4",
    "realmConfigDes_93": "神剑古拉姆3",
    "realmConfigDes_96": "圣盾埃癸斯1",
    "realmConfigDes_95": "神剑古拉姆5",
    "realmConfigDes_81": "最终兵器1",
    "realmConfigDes_80": "决杀零式5",
    "realmConfigDes_87": "暴虐战狂2",
    "realmConfigDes_86": "暴虐战狂1",
    "realmConfigDes_89": "暴虐战狂4",
    "realmConfigDes_88": "暴虐战狂3",
    "realmConfigDes_83": "最终兵器3",
    "realmConfigDes_82": "最终兵器2",
    "realmConfigDes_85": "最终兵器5",
    "realmConfigDes_84": "最终兵器4",
    "realmConfigDes_79": "决杀零式4",
    "realmConfigDes_70": "破面巨像5",
    "realmConfigDes_76": "决杀零式1",
    "realmConfigDes_75": "合一零式5",
    "realmConfigDes_78": "决杀零式3",
    "realmConfigDes_77": "决杀零式2",
    "realmConfigDes_72": "合一零式2",
    "realmConfigDes_71": "合一零式1",
    "realmConfigDes_74": "合一零式4",
    "realmConfigDes_73": "合一零式3",
    "realmConfigDes_69": "破面巨像4",
    "realmConfigDes_68": "破面巨像3",
    "creationDialog560_2": "我害羞~\\n\\\\(//. //)\\\\",
    "realmConfigDes_65": "毁灭巨像5",
    "creationDialog560_1": "你太美了。\\n\\\\(-`ω´･)ﾉ♡",
    "realmConfigDes_64": "毁灭巨像4",
    "realmConfigDes_67": "破面巨像2",
    "realmConfigDes_66": "破面巨像1",
    "creationDialog560_6": "我喜欢你\\n( ¬､¬)~",
    "realmConfigDes_61": "毁灭巨像1",
    "creationDialog560_5": "\\\\(≧▽≦)/\\n又是美好的一天！",
    "realmConfigDes_60": "破魂领主5",
    "creationDialog560_4": "w(ﾟДﾟ)w\\n没什么！！",
    "realmConfigDes_63": "毁灭巨像3",
    "creationDialog560_3": "你好可爱\\n/(=>ω＜)/kira",
    "realmConfigDes_62": "毁灭巨像2",
    "messageInitContent_9304": "人均祭师？",
    "messageInitContent_9303": "你不是此地的子民，回头吧",
    "messageInitContent_9302": "你走近关卡，关卡也会走近你",
    "messageInitContent_9301": "红极化灵在此",
    "messageInitContent_9308": "晚安大地",
    "realmConfigDes_58": "破魂领主3",
    "messageInitContent_9307": "我是领地灵，请把木材留下",
    "realmConfigDes_57": "破魂领主2",
    "messageInitContent_9306": "与它一起入梦吧",
    "messageInitContent_9305": "别惊动这片土地",
    "realmConfigDes_59": "破魂领主4",
    "messageInitContent_9300": "要等大地入睡才可以出发",
    "14_3": "光谱饲星",
    "14_2": "怪兽饲星后将会消失，并获得该怪兽100%的怪兽经验，强化孢子，基因强化消耗的金币和对应的饲星之魂。\\n是否确定进行怪兽饲星？",
    "14_1": "没有符合该条件的怪兽",
    "messageInitNick_357": "虾仁不眨眼",
    "messageInitNick_358": "口胡门传人",
    "messageInitNick_359": "哦咧咯臀",
    "14_7": "每次饲星最多可选择{1}只怪兽（{2}/{3}）",
    "14_6": "怪兽重置后，将获得该怪兽技能等级对应数量的怪兽碎片，100%的怪兽经验，强化孢子和基因强化消耗的金币。\\n是否确定进行怪兽重置？",
    "14_5": "没有符合该条件的进化光谱",
    "14_4": "进化光谱饲星后将会消失，并获得对应的饲星之魂。\\n是否确定进行光谱饲星？",
    "messageInitNick_350": "锁血成功",
    "messageInitNick_351": "诺贝尔翻车奖",
    "messageInitNick_352": "一如风中残烛",
    "messageInitNick_353": "认证口胡专家",
    "messageInitNick_354": "社会加班人",
    "messageInitNick_355": "不残血不会玩",
    "messageInitNick_356": "还在口胡",
    "messageInitNick_368": "打牌很危险",
    "messageInitNick_369": "魔术手大师",
    "messageInitNick_360": "口胡门掌门",
    "22_dish35": "脑洞大开神水",
    "messageInitNick_361": "银河小铁骑",
    "messageInitNick_362": "天下第一",
    "messageInitNick_363": "喂自己袋盐",
    "messageInitNick_364": "又一个决带笑",
    "messageInitNick_365": "爱滚哪滚哪",
    "messageInitNick_366": "魔术手",
    "messageInitNick_367": "常困萝莉",
    "messageInitNick_379": "程序员煎饼",
    "messageInitNick_371": "娱乐决斗家",
    "messageInitNick_372": "注定一胜",
    "messageInitNick_373": "煎饼萝莉",
    "messageInitNick_374": "闪光抽卡",
    "messageInitNick_375": "无极巧手",
    "messageInitNick_376": "程序员卖牛杂",
    "messageInitNick_377": "前方说书反应",
    "22_dish26": "笑容瞬移烤鱼",
    "messageInitNick_378": "人类观察员",
    "messageInitNick_370": "煎饼悍将",
    "messageInitNick_382": "爱嘤嘤嘤斯坦",
    "22_dish13": "兄弟给你大饼",
    "messageInitNick_383": "锁血印卡",
    "messageInitNick_384": "文件转输助手",
    "messageInitNick_385": "迷上门口老头",
    "messageInitNick_386": "爱过狗喂过猪",
    "messageInitNick_387": "阿帕茶",
    "messageInitNick_388": "爱妃朕错了",
    "messageInitNick_389": "你又巨大喷流",
    "messageInitNick_380": "新的风暴",
    "messageInitNick_381": "热心市民",
    "randomEventDialogueGroupConfig_10.101": "饱了",
    "randomEventDialogueGroupConfig_10.102": "不够饱",
    "randomEventDialogueGroupConfig_10.103": "祝你可以自给自足。我要去找海法了，再见。",
    "randomEventDialogueGroupConfig_10.104": "离开",
    "randomEventDialogueGroupConfig_10.105": "那赶紧回去吃饭吧！我店里好像也有些吃的你可以看看呢。",
    "randomEventDialogueGroupConfig_10.106": "回去吃饭",
    "randomEventDialogueGroupConfig_10.107": "进店选购",
    "randomEventDialogueGroupConfig_10.108": "噢，太好了！你还有着无比旺盛的好奇心，像你这么有好奇心的探索者已经非常少了。好奇心非常珍贵的，请一定要珍惜。",
    "randomEventDialogueGroupConfig_10.109": "让它说下去",
    "messageInitNick_393": "铁之意志",
    "messageInitNick_394": "打脸小能手",
    "messageInitNick_395": "纯娘们",
    "messageInitNick_396": "潜行者",
    "messageInitNick_397": "已是陌生人",
    "messageInitNick_398": "倦客",
    "messageInitNick_399": "乖小兔殿下",
    "messageInitNick_390": "一同吃泥",
    "messageInitNick_391": "我有个梦想",
    "messageInitNick_392": "灵活抽卡",
    "randomEventDialogueGroupConfig_10.100": "爱让黑白有了色彩，爱让冰冷的空气有了温度，爱让寂静化作了喧哗。#不过那都是我以前的想法，一切都是抽象的……#但是现在，我觉得爱是我遇上海法后的一切……具象到每一个片刻。",
    "randomEventDialogueGroupConfig_10.145": "谢谢你。再见。",
    "randomEventDialogueGroupConfig_10.146": "告别",
    "randomEventDialogueGroupConfig_10.147": "不必为我感到遗憾，我觉得挺好的，再见。",
    "randomEventDialogueGroupConfig_10.148": "告别",
    "messageInitContent_9391": "饿了，得吃",
    "randomEventDialogueGroupConfig_10.149": "这可能有点难度。",
    "messageInitContent_9390": "兔子，快跑",
    "messageInitContent_9395": "酋长好",
    "messageInitContent_9394": "困了，得睡",
    "messageInitContent_9393": "夜晚，得水",
    "messageInitContent_9392": "关卡，得打",
    "randomEventDialogueGroupConfig_10.140": "对，外貌平等的世界就在我的眼中。",
    "messageInitContent_9399": "我也有只酋长",
    "randomEventDialogueGroupConfig_10.141": "说真棒",
    "messageInitContent_9398": "酋长再见",
    "randomEventDialogueGroupConfig_10.142": "表示遗憾",
    "messageInitContent_9397": "尊敬的酋长，怎么不逃呢",
    "randomEventDialogueGroupConfig_10.143": "唉，实不相瞒，我脸瞎不是那种脸盲，是脸瞎，就是说，在我眼里大家都长一样！你走吧。",
    "messageInitContent_9396": "尊敬的酋长，你要别我打败了",
    "randomEventDialogueGroupConfig_10.144": "欲言又止",
    "randomEventDialogueGroupConfig_10.134": "说无聊",
    "randomEventDialogueGroupConfig_10.135": "刚刚说了，是印象深刻的轮廓，看过一次就能记得！很有特色呢！总结一下就是不错，还行，挺好的，可以的！",
    "randomEventDialogueGroupConfig_10.136": "说它夸得不够具体",
    "randomEventDialogueGroupConfig_10.137": "我要试试手感才行！",
    "randomEventDialogueGroupConfig_10.138": "拒绝",
    "randomEventDialogueGroupConfig_10.139": "同意",
    "randomEventDialogueGroupConfig_10.130": "身材",
    "randomEventDialogueGroupConfig_10.131": "毛发",
    "randomEventDialogueGroupConfig_10.132": "容我观察观察，我看……唔……你一定是善良的嗯……慷慨的呃……厚道的……聪明的。#刚刚说的都是我瞎编的，我的功力还不能看穿内在。#只能说，相比起外在，你是更个关注内在的家伙。",
    "randomEventDialogueGroupConfig_10.133": "说它夸得不错",
    "randomEventDialogueGroupConfig_10.123": "那再次衷心感谢你，你让我看到了自己的极限。谢谢你，告辞。",
    "randomEventDialogueGroupConfig_10.124": "告别",
    "randomEventDialogueGroupConfig_10.125": "我想想……你的轮廓不错，很有辨识度。",
    "randomEventDialogueGroupConfig_10.126": "让它多夸点外在",
    "randomEventDialogueGroupConfig_10.127": "让它夸夸内在",
    "skinType_9": "熔岩",
    "randomEventDialogueGroupConfig_10.128": "说它还得想",
    "skinType_8": "冰川",
    "randomEventDialogueGroupConfig_10.129": "可否在告诉我具体要夸哪里呢？",
    "skinType_5": "玩具",
    "skinType_4": "制服",
    "skinType_7": "黄金",
    "skinType_6": "大和",
    "skinType_1": "星辰",
    "randomEventDialogueGroupConfig_10.120": "我明白你的意思了，拿走吧。",
    "skinType_0": "战狂",
    "randomEventDialogueGroupConfig_10.121": "拿走",
    "skinType_3": "美食",
    "randomEventDialogueGroupConfig_10.122": "表示它没有明白",
    "skinType_2": "机械",
    "randomEventDialogueGroupConfig_10.112": "让它说下去",
    "randomEventDialogueGroupConfig_10.113": "你……不仅在考验我的技艺，你还试图考验我的精神，没想到，你居然能把我逼到这个地步！",
    "randomEventDialogueGroupConfig_10.114": "让它说下去",
    "randomEventDialogueGroupConfig_10.115": "你不仅在考验我的精神，你还在某个危险的边缘疯狂试探，多么富有冒险精神啊！",
    "randomEventDialogueGroupConfig_10.116": "让它说下去",
    "randomEventDialogueGroupConfig_10.117": "既然把我逼到这个份上，只能说，还真是非一般的人。我意识到了我的动摇，到此为止吧。",
    "randomEventDialogueGroupConfig_10.118": "让它等等",
    "randomEventDialogueGroupConfig_10.119": "放它走",
    "messageInitNick_302": "不是融合",
    "messageInitNick_303": "孙尚香辣蟹",
    "messageInitNick_304": "欧拉欧拉",
    "messageInitNick_305": "都说不是融合",
    "messageInitNick_306": "孤身秀人机",
    "messageInitNick_307": "钢铁的恋人",
    "messageInitNick_308": "爱尔兰的风筝",
    "messageInitNick_309": "椅子王",
    "messageInitNick_300": "关羽毛球",
    "messageInitNick_301": "木大木大",
    "randomEventDialogueGroupConfig_10.110": "说它在胡说八道",
    "randomEventDialogueGroupConfig_10.111": "噢多么强烈的好奇心，多么强烈的探求欲，要是其它怪兽看到可能会以为你是在为难我神秘商人，但是没关系。#我知道这不是你真实的想法，你是在考验我，为了让我在修习夸人技艺的道路上走得更远。#你这种助神秘商人为乐的精神实在是让我感到敬佩！",
    "randomEventDialogueGroupConfig_10.189": "没关系哦，回去还想加入也行的哦，拜拜。",
    "messageInitNick_313": "手发陷阱",
    "messageInitNick_314": "卖鱼强",
    "messageInitNick_315": "能回滚一下吗",
    "messageInitNick_316": "西撒酱",
    "messageInitNick_317": "爱妃接旨",
    "messageInitNick_318": "一同吃泥",
    "messageInitNick_319": "典明粥",
    "messageInitNick_310": "打铁的白金",
    "messageInitNick_311": "社长深沉的爱",
    "messageInitNick_312": "塑料的世界",
    "randomEventDialogueGroupConfig_10.180": "立刻加入",
    "randomEventDialogueGroupConfig_10.181": "考虑一下",
    "randomEventDialogueGroupConfig_10.182": "没关系的，你可以慢慢考虑，想好了可以再来找我。再见！",
    "randomEventDialogueGroupConfig_10.183": "告别",
    "randomEventDialogueGroupConfig_10.184": "超进化夸夸组织欢迎你！",
    "randomEventDialogueGroupConfig_10.185": "了解组织宗旨",
    "randomEventDialogueGroupConfig_10.186": "了解组织规模",
    "randomEventDialogueGroupConfig_10.187": "没有要求，开心就来玩，不开心随时可以走。",
    "randomEventDialogueGroupConfig_10.188": "问它是否还有补充",
    "randomEventDialogueGroupConfig_10.178": "怎么会没有呢，只是你还没发现它们而已。#不如来我们夸夸组织学习一下！免费加入，免费培训。帮你提升观察能力，找准角度，挖掘自身亮点！",
    "randomEventDialogueGroupConfig_10.179": "疑骗速逃",
    "messageInitNick_324": "想过平静生活",
    "messageInitNick_325": "打不过就加入",
    "messageInitNick_326": "上去就是一拳",
    "messageInitNick_327": "但是我拒绝",
    "messageInitNick_328": "实力见发量",
    "messageInitNick_329": "我有个梦想",
    "messageInitNick_320": "土味哥",
    "messageInitNick_321": "阿帕茶",
    "messageInitNick_322": "爱妃朕错了",
    "messageInitNick_323": "你又巨大喷流",
    "randomEventDialogueGroupConfig_10.170": "原来如此，学到了，好开心！这个送个你！",
    "randomEventDialogueGroupConfig_10.171": "收下",
    "randomEventDialogueGroupConfig_10.172": "拒收离开",
    "randomEventDialogueGroupConfig_10.173": "原来是不够真诚和具体吗！受教了！下次一定记得！再见！",
    "randomEventDialogueGroupConfig_10.174": "告别",
    "randomEventDialogueGroupConfig_10.175": "你实在是太好了，我甚至想不到该怎么去形容你的伟大和优秀。",
    "randomEventDialogueGroupConfig_10.176": "……",
    "randomEventDialogueGroupConfig_10.177": "啊？",
    "randomEventDialogueGroupConfig_10.167": "具体？我们对具体的理解是不是有些差异。",
    "randomEventDialogueGroupConfig_10.168": "承认",
    "randomEventDialogueGroupConfig_10.169": "否认",
    "messageInitContent_11192": "我与漆黑组件",
    "messageInitNick_335": "灵活打牌",
    "messageInitContent_11191": "我与空蝉",
    "messageInitNick_336": "红色近战",
    "messageInitContent_11194": "剑与魔法",
    "messageInitNick_337": "随缘抽卡",
    "messageInitContent_11193": "我与金钱",
    "messageInitNick_338": "忘记补刀",
    "messageInitNick_339": "艺术就是爆炸",
    "messageInitContent_11190": "我与御空",
    "messageInitContent_11199": "快按下！",
    "messageInitNick_330": "爱疯几了",
    "messageInitContent_11196": "谁去按一下那个按钮",
    "messageInitNick_331": "灵活抽卡",
    "messageInitContent_11195": "不要按红色机关，除非你喜欢惊喜",
    "messageInitNick_332": "养肥再看",
    "messageInitContent_11198": "boom！",
    "messageInitNick_333": "阿斯绿",
    "messageInitContent_11197": "看看会发生什么",
    "messageInitNick_334": "爱已格式化",
    "randomEventDialogueGroupConfig_10.160": "我是认真的！很抱歉让你感到不满了，我一定回去勤修苦练，让你看到我的成长，再见！",
    "randomEventDialogueGroupConfig_10.161": "离开",
    "randomEventDialogueGroupConfig_10.162": "我怀疑你在骗我，并且有证据，一开始我只是从一个面去切入哪来的具体。生气了！",
    "randomEventDialogueGroupConfig_10.163": "接战",
    "randomEventDialogueGroupConfig_10.164": "离开",
    "randomEventDialogueGroupConfig_10.165": "是吗！我好开心！我要回去把这件事告诉我组织的朋友们！再见！",
    "randomEventDialogueGroupConfig_10.166": "离开",
    "randomEventDialogueGroupConfig_10.156": "在等等，哇哦~#实在是，实在是……这是何等的……",
    "randomEventDialogueGroupConfig_10.157": "阻止它",
    "randomEventDialogueGroupConfig_10.158": "幸好你不是说夸得不错，下次不要再夸了。感谢你的温柔，还有你的赞美，再见。",
    "randomEventDialogueGroupConfig_10.159": "告别",
    "messageInitContent_11181": "好傻的锤子",
    "messageInitNick_346": "收收味",
    "messageInitContent_11180": "这里打地鼠？",
    "messageInitNick_347": "一份儿童套餐",
    "messageInitContent_11183": "猛的",
    "messageInitNick_348": "诺贝尔口胡讲",
    "messageInitContent_11182": "打地龙",
    "messageInitNick_349": "炫彩学霸",
    "messageInitContent_11189": "任务完成",
    "messageInitContent_11188": "吃饭了吃饭了",
    "messageInitNick_340": "翻车专业户",
    "messageInitNick_341": "掌握核心科技",
    "messageInitContent_11185": "陷入疯狂，于是开始掉面包",
    "messageInitNick_342": "卡手专业户",
    "messageInitContent_11184": "吃俺一锤",
    "messageInitNick_343": "看看你",
    "messageInitContent_11187": "不许浪费食物听到吗",
    "messageInitNick_344": "逮虾户",
    "messageInitContent_11186": "怎么剧情都改了",
    "messageInitNick_345": "口胡专业户",
    "randomEventDialogueGroupConfig_10.150": "强商人所难",
    "randomEventDialogueGroupConfig_10.151": "问它是什么意思",
    "randomEventDialogueGroupConfig_10.152": "没关系，你的确能拒绝我。而且果断拒绝也是一种难得的美德。再见。",
    "randomEventDialogueGroupConfig_10.153": "告别",
    "randomEventDialogueGroupConfig_10.154": "唔……嗯嗯，嗷！等等，唔……",
    "randomEventDialogueGroupConfig_10.155": "问它摸够没有",
    "messageInitContent_11170": "硎玩游戏是不是那种死磕的类型哈哈",
    "messageInitContent_11172": "测评机器召唤",
    "messageInitContent_11171": "听到了骰子的声音",
    "messageInitContent_9309": "水灵灵也是灵",
    "messageInitContent_11178": "六边形打怪",
    "messageInitContent_9315": "荧灵在这边长的挺好",
    "messageInitContent_11177": "起来吧，我的小兵",
    "messageInitContent_9314": "我是个学生灵",
    "messageInitContent_9313": "送我",
    "messageInitContent_11179": "出售通关宝典",
    "messageInitContent_9312": "我只是个孩子",
    "messageInitContent_11174": "一个字赢",
    "messageInitContent_9319": "又见面了我的龙女仆",
    "messageInitContent_11173": "通关机器人召唤",
    "messageInitContent_9318": "火焰正在躁动",
    "messageInitContent_11176": "你们被我打败了，都来成为我的小弟吧",
    "messageInitContent_9317": "空气正在聆听",
    "messageInitContent_11175": "转生成为亡灵法师",
    "messageInitContent_9316": "土地肥沃",
    "messageInitContent_9311": "花香知道你的秘密",
    "messageInitContent_9310": "我还影灵衫呢",
    "messageInitContent_11161": "看看掉落！",
    "messageInitContent_11160": "前面就算古记了",
    "messageInitContent_11167": "隔壁有个传送带",
    "messageInitContent_9326": "花在微笑",
    "messageInitContent_11166": "走四步、退五步、免费赠送一次心脏骤停",
    "messageInitContent_9325": "花在低语",
    "messageInitContent_11169": "胜利是短暂的，奖励也是短暂的",
    "messageInitContent_9324": "火炎焱",
    "messageInitContent_11168": "谁过去试试",
    "messageInitContent_9323": "只有火能带走你的罪孽",
    "messageInitContent_11163": "怎么哪哪都看到你们",
    "messageInitContent_11162": "奔腾5000跟我回家吧",
    "messageInitContent_9329": "花在恸哭",
    "messageInitContent_11165": "这里没有边界，只有下一场游戏",
    "messageInitContent_9328": "花在怒吼",
    "messageInitContent_11164": "这个位面被棋兵入侵了吗！",
    "messageInitContent_9327": "花在引领",
    "messageInitContent_9322": "当第七个火圈闭合，火将睁眼",
    "messageInitContent_9321": "留下灰烬，不带走火苗。",
    "messageInitContent_9320": "不要直视火心",
    "messageInitContent_11150": "棋兵集结！",
    "messageInitContent_11156": "好怪哦",
    "messageInitContent_9337": "一个纯机械一个是生物机械",
    "messageInitContent_11155": "有端联想",
    "messageInitContent_9336": "外来者请小心",
    "messageInitContent_11158": "方块君你好",
    "messageInitContent_9335": "您就是这片土地的女王吗",
    "messageInitContent_11157": "我的ai也叫这个",
    "messageInitContent_9334": "继续叉",
    "messageInitContent_11152": "真的吗",
    "messageInitContent_11151": "最喜欢赤潮开无双了",
    "messageInitContent_11154": "到底谁在操控棋兵",
    "messageInitContent_9339": "啥都别说先看看首通奖励",
    "messageInitContent_11153": "win！",
    "messageInitContent_9338": "走上歧路的文明科技",
    "messageInitContent_9333": "叉累了",
    "messageInitContent_11159": "香蕉君您好",
    "messageInitContent_9332": "叉会腰",
    "messageInitContent_9331": "不要躲开，它不喜欢胆小的家伙",
    "messageInitContent_9330": "只可远观而不可亵玩焉",
    "messageInitContent_11145": "你两怎么老在一起",
    "messageInitContent_9348": "爱神的祝福？",
    "messageInitContent_11144": "月色真美",
    "messageInitContent_9347": "听说在520关和1314关留言就会得到爱神的祖父",
    "messageInitContent_11147": "又研究什么呢",
    "messageInitContent_9346": "表白圣地",
    "messageInitContent_11146": "研究人员的默契？",
    "messageInitContent_9345": "勿摘花",
    "messageInitContent_11141": "这里是光球",
    "messageInitContent_11140": "这里是要搞什么实验吗",
    "messageInitContent_11143": "弹幕护体",
    "randomEventDialogueGroupConfig_10.190": "离开",
    "messageInitContent_11142": "握爪爪",
    "messageInitContent_9349": "我先来，表白御空",
    "randomEventDialogueGroupConfig_10.191": "非常大！",
    "messageInitContent_9340": "通关开心~",
    "randomEventDialogueGroupConfig_10.192": "问具体有多大",
    "randomEventDialogueGroupConfig_10.193": "后悔加入",
    "randomEventDialogueGroupConfig_10.194": "我们的宗旨是——赞美真诚的赞美，发现发现的美！觉得怎样？",
    "randomEventDialogueGroupConfig_10.195": "表示了解",
    "messageInitContent_11149": "冲冲冲、冲鸭",
    "messageInitContent_9344": "点个赞谢谢",
    "randomEventDialogueGroupConfig_10.196": "继续了解组织要求",
    "messageInitContent_11148": "天才",
    "messageInitContent_9343": "啊？嗯?",
    "randomEventDialogueGroupConfig_10.197": "唔，希望你可以多关注身边的小伙伴的闪光点呢。",
    "messageInitContent_9342": "这里没有陷阱别问我为什么知道",
    "randomEventDialogueGroupConfig_10.198": "点头告别",
    "messageInitContent_9341": "恭喜你来到这里",
    "randomEventDialogueGroupConfig_10.199": "快告诉朋友，然后让它们也一起加入吧！拜拜。",
    "98_-230008": "没有循环奖励可领取",
    "98_-230009": "契约等级未解锁",
    "98_-230007": "契约周期已变更",
    "messageInitContent_11134": "我的存档（超大声",
    "messageInitContent_9359": "别熬夜，夜会生气",
    "messageInitContent_11133": "sl大法好",
    "messageInitContent_9358": "别吃糖，牙仙会生气",
    "messageInitContent_11136": "喜欢狂潮形态",
    "messageInitContent_9357": "别吃糖，糖灵会敲你",
    "messageInitContent_11135": "可以搭建我的漆黑组件吗",
    "messageInitContent_9356": "糖灵",
    "messageInitContent_11130": "存档了吗",
    "messageInitContent_11132": "真真真的吗",
    "messageInitContent_11131": "拍拍机器会好起来的",
    "messageInitContent_9351": "行不行",
    "messageInitContent_9350": "硎也加入战场了",
    "messageInitContent_11138": "我的天",
    "messageInitContent_9355": "真有受够谐音梗了",
    "messageInitContent_11137": "想哪里去了",
    "messageInitContent_9354": "真行",
    "messageInitContent_9353": "真行？",
    "messageInitContent_11139": "请给我一个那样的模型！",
    "messageInitContent_9352": "行",
    "messageInitContent_11123": "你们什么回事",
    "messageInitContent_11122": "潜入成功",
    "messageInitContent_9369": "金币金币进我袋",
    "messageInitContent_11125": "欢迎来到空间站",
    "messageInitContent_9368": "恭迎拿王归来",
    "messageInitContent_11124": "赢了",
    "messageInitContent_9367": "切勿对拿王不敬",
    "messageInitContent_11121": "快跑",
    "messageInitContent_11120": "这里是什么模块",
    "messageInitContent_9362": "脑壳疼",
    "messageInitContent_9361": "啊又起源盘",
    "messageInitContent_9360": "马上下一个空岛",
    "98_-230011": "没有可领奖励",
    "messageInitContent_11127": "异形模块载入完成",
    "messageInitContent_9366": "拿王到底什么鬼",
    "98_-230012": "蜕变契约结算中，请稍后再试",
    "messageInitContent_11126": "努力生存下去吧",
    "messageInitContent_9365": "马上到金矿",
    "messageInitContent_11129": "开挖",
    "messageInitContent_9364": "原始世界不用上班太好了",
    "98_-230010": "未开启超阶契约",
    "messageInitContent_11128": "异性模块载入完成",
    "messageInitContent_9363": "下一关见",
    "messageInitContent_11112": "一带四",
    "messageInitContent_11111": "镇魂带队",
    "messageInitContent_11114": "晚安卡皮巴拉",
    "messageInitContent_9379": "大地吼，快炮",
    "messageInitContent_11113": "早呀各位",
    "messageInitContent_9378": "草扎腿，走慢点",
    "messageInitContent_11110": "前面是模型店吗",
    "messageInitContent_9373": "吃够了",
    "messageInitContent_11119": "吃饭中",
    "messageInitContent_9372": "吃点",
    "messageInitContent_9371": "第一",
    "messageInitContent_9370": "听说这里已经被占了",
    "messageInitContent_11116": "怎么已经是这个点",
    "messageInitContent_9377": "有水。甜。可喝",
    "messageInitContent_11115": "欢迎来到终点站",
    "messageInitContent_9376": "脚印大",
    "messageInitContent_11118": "吃土中",
    "messageInitContent_9375": "兽来过",
    "messageInitContent_11117": "吃灰中",
    "messageInitContent_9374": "吃了吗",
    "messageInitContent_9380": "地热，天也热",
    "messageInitContent_11101": "烫",
    "messageInitContent_11100": "传火吗？",
    "messageInitContent_11103": "没演",
    "messageInitContent_11102": "演吗？",
    "messageInitContent_9389": "欧气，多多",
    "messageInitContent_11109": "吃饭吃饭",
    "messageInitContent_9384": "你们，原始人",
    "messageInitContent_11108": "只能感受到饿",
    "messageInitContent_9383": "石头，磨",
    "messageInitContent_9382": "危险，别过去",
    "messageInitContent_9381": "水，多喝",
    "messageInitContent_11105": "你好",
    "messageInitContent_9388": "脑袋，空空",
    "messageInitContent_11104": "下一把",
    "messageInitContent_9387": "肚子，饿饿",
    "messageInitContent_11107": "风的陪伴",
    "messageInitContent_9386": "孢子，几个",
    "messageInitContent_11106": "能感受到吗",
    "messageInitContent_9385": "金币，不多",
    "monsterName_510": "危险的草丛",
    "monsterName_511": "利爪狼",
    "monsterName_512": "圣堂武士",
    "monsterName_513": "制杖巨人",
    "monsterName_514": "制杖小人",
    "monsterName_515": "人间大炮",
    "messageInitContent_11574": "赞我欧气爆棚",
    "messageInitContent_11573": "为什么要让我有这种联想",
    "messageInitContent_11576": "我准备好了",
    "messageInitContent_11575": "将玖璃封印到我的身体内吧！",
    "messageInitContent_11570": "煮饭升级是吧",
    "messageInitContent_11572": "不敢想象",
    "messageInitContent_11571": "女主是GN还是",
    "monsterName_505": "呜呜祖拉",
    "monsterName_506": "塞尔雷特",
    "monsterName_507": "G-N",
    "monsterName_508": "红唇",
    "messageInitContent_11578": "哈？",
    "monsterName_509": "骑兵",
    "messageInitContent_11577": "我就是阴阳师！",
    "messageInitContent_11579": "跑了跑了",
    "monsterName_520": "金翅璞佳鸟",
    "monsterName_521": "异形",
    "monsterName_522": "炎之高兴",
    "monsterName_523": "KB侠",
    "monsterName_524": "污妖王",
    "monsterName_525": "海格力斯",
    "monsterName_526": "珀耳修斯",
    "messageInitContent_11563": "木之本樱",
    "messageInitContent_11562": "金之快乐",
    "messageInitContent_11565": "我的萝卜呢",
    "messageInitContent_11564": "风之叹息",
    "messageInitContent_11561": "水之呼吸",
    "messageInitContent_11560": "土之愤怒",
    "monsterName_516": "镰刀",
    "monsterName_517": "蜻蜓龙",
    "monsterName_518": "疾风兔",
    "monsterName_519": "大舌怪",
    "messageInitContent_11567": "王子？马？？马王子？",
    "messageInitContent_11566": "怎么增加和王子的亲密度",
    "messageInitContent_11569": "慢点王子殿下",
    "messageInitContent_11568": "问号问号问号",
    "themeCardPackName_24015": "剧变之间",
    "messageInitContent_11552": "原……来如此",
    "messageInitContent_11551": "还有火元素",
    "messageInitContent_11554": "进草隐身！",
    "messageInitContent_11553": "出来吧 德玛西亚",
    "messageInitContent_11550": "危险元素",
    "messageInitContent_11559": "GG",
    "messageInitContent_11556": "怪兽被探索者追哈哈",
    "messageInitContent_11555": "怪兽玩的神庙逃亡是吧",
    "messageInitContent_11558": "小心，地板是空的",
    "messageInitContent_11557": "不许逃",
    "themeCardPackName_24010": "剧变之初",
    "messageInitNick_9192": "暴走的冰糖",
    "messageInitNick_9193": "俺是种瓜滴",
    "messageInitNick_9190": "迷路小子",
    "messageInitNick_9191": "存钱小猪",
    "monsterName_501": "叉叉",
    "monsterName_502": "咻咻",
    "themeCardPackName_24005": "剧变前兆",
    "monsterName_503": "桐仁",
    "monsterName_504": "锤子",
    "messageInitNick_9198": "留不住那年",
    "messageInitNick_9199": "懒床钉子户",
    "messageInitNick_9196": "揣一袋欢乐",
    "messageInitNick_9197": "春夏秋东西",
    "messageInitNick_9194": "戈壁骆驼",
    "messageInitNick_9195": "悄悄上分",
    "messageInitContent_11541": "emm滤镜关闭",
    "messageInitContent_11540": "毛茸茸滤镜打开！",
    "messageInitContent_11543": "我一直都在",
    "messageInitContent_11542": "缝缝补补又一年",
    "messageInitContent_11549": "电池又在哪里",
    "messageInitContent_11548": "说明书又在哪里",
    "messageInitContent_11545": "发条在哪里",
    "messageInitContent_11544": "玩偶一败涂地",
    "messageInitContent_11547": "按钮在哪里",
    "messageInitContent_11546": "开关在哪里",
    "messageInitNick_9181": "电子水果糖",
    "monsterName_552": "社恐龙",
    "messageInitNick_9182": "超级骨头",
    "monsterName_553": "花丸子",
    "monsterName_554": "R帝",
    "messageInitNick_9180": "诡异噩梦",
    "monsterName_555": "白子",
    "monsterName_556": "黑子",
    "monsterName_557": "风水老树",
    "monsterName_558": "神秘商人",
    "monsterName_559": "王·量子巨龙",
    "messageInitNick_9189": "蛋炒饭",
    "messageInitNick_9187": "菠菜先锋",
    "messageInitNick_9188": "打开人性",
    "messageInitNick_9185": "过劳战士",
    "messageInitNick_9186": "一种小幸福",
    "messageInitNick_9183": "强壮头铁神",
    "monsterName_550": "锤爹",
    "messageInitNick_9184": "朋友快住手",
    "monsterName_551": "麦克斯韦妖",
    "messageInitContent_11530": "这也能扯上？",
    "messageInitContent_11532": "被自己的运气针对了",
    "messageInitContent_11531": "出来吧 比卡丘",
    "messageInitContent_11538": "我老婆还在卡带里，你不能租走！",
    "monsterName_549": "包租公",
    "messageInitContent_11537": "老板有啥推荐",
    "messageInitContent_11539": "不睡了",
    "messageInitContent_11534": "在逃长腿宝石海星",
    "messageInitContent_11533": "永远抽不到能量",
    "messageInitContent_11536": "又被封面骗了",
    "messageInitContent_11535": "你是会的包租公",
    "messageInitNick_9170": "类人生物",
    "monsterName_563": "王·赤色狮",
    "messageInitNick_9171": "年轻的每米呦",
    "monsterName_564": "王·霸者",
    "monsterName_565": "王·狈·爷",
    "monsterName_566": "灾·地裂",
    "monsterName_567": "灾·焚风",
    "messageInitContent_11519": "有点东西",
    "monsterName_568": "灾·赤潮",
    "monsterName_569": "灾·星落",
    "messageInitNick_9178": "奉旨补刀",
    "messageInitNick_9179": "蛋挞怪客",
    "messageInitNick_9176": "蒜之心",
    "messageInitNick_9177": "三重梦",
    "messageInitNick_9174": "告别小学时代",
    "messageInitNick_9175": "萌面大虾",
    "monsterName_560": "王·罗密欧",
    "messageInitNick_9172": "朋友侠",
    "monsterName_561": "王·朱丽叶",
    "messageInitNick_9173": "格式化中",
    "monsterName_562": "王·炼狱魔眼",
    "messageInitContent_11521": "猫儿去组乐队了",
    "messageInitContent_11520": "大象上了天",
    "messageInitNick_9169": "全幼儿园最萌",
    "messageInitContent_11527": "月亮会带来诅咒",
    "messageInitContent_11526": "暗月是答案",
    "messageInitContent_11529": "循环的终结，萨满的低语",
    "messageInitContent_11528": "代表月亮消灭你",
    "messageInitContent_11523": "蜀黍我啊",
    "messageInitContent_11522": "狼去狼人杀了",
    "messageInitContent_11525": "月相将改变规则",
    "messageInitContent_11524": "狮子在boss关",
    "15_2": "{1}未通关前置副本",
    "monsterName_530": "独角兽",
    "15_1": "不足5只怪兽无法开始战斗",
    "messageInitNick_9160": "专注打酱油",
    "monsterName_531": "穿角兽",
    "monsterName_532": "比蒙巨兽",
    "monsterName_533": "比蒙巨炮",
    "messageInitContent_11509": "该换了",
    "monsterName_534": "薛定鳄",
    "messageInitContent_11508": "我的屏幕漏光了",
    "monsterName_535": "莎士彼亚",
    "monsterName_536": "MountainJo",
    "monsterName_537": "飞头蛮",
    "messageInitNick_9167": "纯洁的蕾丝控",
    "15_9": "开启宝箱",
    "messageInitNick_9168": "天堂橡皮",
    "15_8": "重复挑战",
    "messageInitNick_9165": "撩妹突击手",
    "15_7": "{1}邀请你挑战【凿星裂痕】{2}",
    "messageInitNick_9166": "嫌贵皇后",
    "15_6": "单人挑战模式无法获得友好点数，建议与其他探索者组队挑战副本",
    "messageInitNick_9163": "什么都不想说",
    "15_5": "你已被踢出队伍",
    "messageInitNick_9164": "红人",
    "15_4": "当前神灵",
    "messageInitNick_9161": "我看不懂",
    "15_3": "{1}探索者等级未达要求",
    "messageInitNick_9162": "不吃鱼的猫",
    "messageInitContent_11510": "看我发现了什么",
    "messageInitNick_9158": "二点五条什么",
    "messageInitNick_9159": "天堂耳环",
    "messageInitContent_11516": "先不急",
    "monsterName_527": "美杜莎莎",
    "messageInitContent_11515": "毁灭与守护",
    "monsterName_528": "零",
    "messageInitContent_11518": "可以接受",
    "monsterName_529": "我的怕怕",
    "messageInitContent_11517": "懂得都懂",
    "messageInitContent_11512": "家人们蚌埠不住了",
    "messageInitContent_11511": "放个坚果墙",
    "messageInitContent_11514": "好好好",
    "messageInitContent_11513": "卧槽怎么又天亮了",
    "monsterName_541": "妖火",
    "monsterName_542": "沼兽",
    "monsterName_543": "火心",
    "monsterName_544": "藤妖",
    "monsterName_545": "墙神",
    "monsterName_546": "波多尔司机",
    "monsterName_547": "仁拳大师",
    "monsterName_548": "绒绒",
    "messageInitNick_9156": "蛋挞战士",
    "messageInitNick_9157": "特征值探索者",
    "messageInitNick_9154": "代购辣条",
    "messageInitNick_9155": "代码大师",
    "messageInitNick_9152": "极品男爵",
    "messageInitNick_9153": "无公害橙子",
    "messageInitNick_9150": "梨是战士",
    "messageInitNick_9151": "蒜苔魔法师",
    "monsterName_540": "龙皮匠",
    "messageInitNick_9149": "效果不错",
    "messageInitNick_9147": "富而忧伤",
    "messageInitNick_9148": "炖饭",
    "messageInitContent_11505": "和谐的力量",
    "monsterName_538": "虎皮匠",
    "messageInitContent_11504": "来不及解释了快跑",
    "monsterName_539": "豹皮匠",
    "messageInitContent_11507": "黑色的怪兽不需要任何形式的圣光",
    "messageInitContent_11506": "可恶的光",
    "messageInitContent_11501": "别回头。",
    "messageInitContent_11500": "不要停下来。",
    "messageInitContent_11503": "先跑再说",
    "messageInitContent_11502": "跑起来",
    "messageInitNick_9145": "打脸王",
    "messageInitNick_9146": "特长普度众生",
    "messageInitNick_9143": "自走脸盆",
    "messageInitNick_9144": "衣服再买一件",
    "messageInitNick_9141": "学渣要逆袭",
    "messageInitNick_9142": "绕过山河错落",
    "messageInitNick_9140": "续写以往",
    "messageInitNick_9138": "斑马线",
    "messageInitNick_9139": "路过的蚂蚁",
    "messageInitNick_9136": "肉的一批",
    "messageInitNick_9137": "甩锅冠军",
    "messageInitNick_9134": "芙蓉鲜蔬汤",
    "messageInitNick_9135": "野孩子",
    "messageInitNick_9132": "短腿小可爱",
    "messageInitNick_9133": "雪莲果先锋",
    "messageInitNick_9130": "坏坏的宝贝",
    "messageInitNick_9131": "呆萌女汉",
    "messageInitNick_9129": "永远可爱",
    "messageInitNick_9127": "芒果君快逃",
    "messageInitNick_9128": "笨猪会发光",
    "messageInitNick_9125": "午餐吃馒头",
    "messageInitNick_9126": "假面骑龙",
    "messageInitNick_9123": "安静就好",
    "messageInitNick_9124": "蝴蝶仙子",
    "messageInitNick_9121": "眉梢带笑",
    "messageInitNick_9122": "火龙果去哪了",
    "messageInitNick_9120": "曙光划破星空",
    "messageInitNick_9118": "先看看属地",
    "messageInitNick_9119": "葡萄柚消灭者",
    "messageInitNick_9116": "开始慌了",
    "messageInitNick_9117": "单枪浪徒",
    "messageInitNick_9114": "指尖上的风景",
    "messageInitNick_9115": "收拾好了",
    "messageInitNick_9112": "水煮薯条",
    "messageInitNick_9113": "唇齿的轮回",
    "messageInitNick_9110": "扛枪萝莉",
    "messageInitNick_9111": "麻辣小龙虾",
    "messageInitNick_9109": "渴望的影子",
    "messageInitNick_9107": "牙签翘地球",
    "messageInitNick_9108": "万能戒指",
    "messageInitNick_9105": "吃货乐园",
    "messageInitNick_9106": "五杀教主",
    "messageInitNick_9103": "辅助跟姐抓人",
    "messageInitNick_9104": "她比塔难守",
    "messageInitNick_9101": "傲娇女王范",
    "messageInitNick_9102": "蛋挞游荡者",
    "messageInitNick_9100": "爱我要趁早",
    "channelName_1003": "雷电游戏中心",
    "activityTaskDes_1003": "使用降临怪兽起源殿挑战{1}次",
    "activityTaskDes_1002": "使用降临怪兽斗技场挑战{1}次",
    "activityTaskDes_1001": "使用降临怪兽暴走旷野挑战{1}次",
    "22_dish1": "暴富龙宵串串",
    "22_dish3": "精神脱单果冻",
    "22_dish6": "奇迹摸鱼馅饼",
    "98_-9": "迷路怪兽乱入战场，请重新挑战",
    "98_-7": "系统进化中，刚长出另一条大腿！",
    "98_-8": "时间乱流席卷战场，请重新挑战",
    "98_-5": "账号登录受限，请向客服详询",
    "98_-6": "账号在其他设备登录，若这不是你的操作，请尽快修改密码",
    "98_-3": "操作过于频繁，请稍作休息",
    "98_-4": "服务器维护中，请稍后再试",
    "98_-1": "神秘怪兽正在拔螺丝",
    "98_-2": "数据异常，请稍后再试",
    "themeCardPackageName_140": "源裂变",
    "messageInitContent_9039": "让我猜对一次吧！",
    "messageInitContent_9038": "大家都选好了吗",
    "messageInitContent_9037": "五行缺答案",
    "messageInitContent_9032": "左右横跳中",
    "messageInitContent_9031": "怪兽赢了",
    "resoundEventConfigName_2010": "10.狂战",
    "messageInitContent_9030": "肯定是那边啊",
    "messageInitContent_9036": "看不出左边有啥胜算",
    "messageInitContent_9035": "这里是预言家，左",
    "messageInitContent_9034": "选对明天加鸡腿",
    "messageInitContent_9033": "佬快来指路",
    "themeCardPackageName_130": "赛博环",
    "messageInitContent_9049": "画面太可怕了",
    "messageInitContent_9048": "你们在说什么我不懂",
    "messageInitContent_9043": "对吗？不对吧",
    "messageInitContent_9042": "超纲了",
    "messageInitContent_9041": "相信第一感觉",
    "messageInitContent_9040": "主打一个随缘",
    "messageInitContent_9047": "啊这是我能看的吗",
    "messageInitContent_9046": "这画面光想想就有点哒咩",
    "messageInitContent_9045": "那你们真棒",
    "messageInitContent_9044": "呼呼呼",
    "messageInitContent_9050": "问号问号问号",
    "messageInitContent_9059": "看一眼技能懂了",
    "messageInitContent_9054": "拿着这只鲨叉，保我水逆退散",
    "messageInitContent_9053": "退退退",
    "messageInitContent_9052": "推推推",
    "messageInitContent_9051": "这不是被摁墙角摩擦的节奏",
    "messageInitContent_9058": "未尝一对",
    "messageInitContent_9057": "希望大家蒙的都对",
    "messageInitContent_9056": "等我问问ai",
    "messageInitContent_9055": "墙角很无辜",
    "messageInitContent_9061": "猜对day1",
    "messageInitContent_9060": "左左右右前前后后",
    "resoundEventConfigName_2006": "6.少女的秘密",
    "resoundEventConfigName_2007": "7.武器坟场",
    "resoundEventConfigName_2008": "8.合作",
    "resoundEventConfigName_2009": "9.巨兽",
    "messageInitContent_9065": "大家都选好了吗",
    "messageInitContent_9064": "五行缺答案",
    "messageInitContent_9063": "一眼",
    "messageInitContent_9062": "精致探索者竞猜中",
    "resoundEventConfigName_2001": "1.圣盾埃癸斯",
    "messageInitContent_9069": "猜对的方程式已经想好了",
    "resoundEventConfigName_2002": "2.史卡非斯",
    "messageInitContent_9068": "让我猜对一次吧！",
    "resoundEventConfigName_2003": "3.马克",
    "messageInitContent_9067": "抄作业时间到",
    "resoundEventConfigName_2004": "4.真·圣盾埃癸斯",
    "messageInitContent_9066": "人越多人越少",
    "resoundEventConfigName_2005": "5.洛菲菲",
    "themeCardPackageName_180": "海鸣起",
    "messageInitContent_9072": "晚安大小姐",
    "messageInitContent_9071": "今天选人多的",
    "messageInitContent_9070": "给网线把脉",
    "messageInitContent_9076": "森系队伍",
    "messageInitContent_9075": "新时代原生",
    "messageInitContent_9074": "有端联想",
    "messageInitContent_9073": "秒get",
    "messageInitContent_9079": "哪边风水好呢各位",
    "messageInitContent_9078": "什么鬼",
    "messageInitContent_9077": "吉噬魔参上",
    "themeCardPackageName_170": "启程季",
    "messageInitContent_9083": "这技能组不用想了",
    "messageInitContent_9082": "这里是。。",
    "messageInitContent_9081": "后排看吉凶，前后钱钱来",
    "messageInitContent_9080": "前排看风水，左右左右左",
    "messageInitContent_9087": "总有一个对的",
    "messageInitContent_9086": "在猜了在猜了",
    "messageInitContent_9085": "你呢",
    "messageInitContent_9084": "一个减伤一个减攻击",
    "messageInitContent_9089": "赢的是这边",
    "messageInitContent_9088": "一眼",
    "messageInitContent_9090": "发梦可得答案",
    "messageInitContent_9094": "量子波动选择法",
    "messageInitContent_9093": "这技能我熟",
    "messageInitContent_9092": "我梦到了是右边赢",
    "messageInitContent_9091": "给个机会",
    "themeCardPackageName_160": "盛夏诞",
    "messageInitContent_9098": "总有一个是错的",
    "messageInitContent_9097": "刚来选啥",
    "messageInitContent_9096": "抛个硬币看看先",
    "messageInitContent_9095": "今天选人多的",
    "messageInitContent_9099": "我有一个大胆的想法",
    "themeCardPackageName_150": "极巨化",
    "themeCardPackDes_22015": "整个血肉剧团被炸飞后不久，行尸和其他幸存的成员从将它们带离的怪兽的比划中，了解到了Joker和环形斗场的事情。行尸那只怪兽并没太深的印象，毕竟是在那样的日子中过来的，可它还是努力从一些很边缘的地方拼凑到一些记忆。和剧团大多数的怪兽一样，他一开始也没有名字，他的忍受力极强，总是会在危急之际为其他怪兽挡下攻击。他就是后来的环形斗场之主“硎”。\\n行尸暗下决心，继承Joker的名号，然后在新的归宿中，找到属于他缺失的东西，那种能触动怪兽，让怪兽展露笑容的东西。\\n不知道其他幸存的成员是否与它一样怀抱着类似的心情。",
    "themeCardPackDes_22010": "行尸并不愿意回想在血肉剧团的经历，但回忆并不会如他所愿……总是不清自来。剧团中的怪兽多是些无依无靠的怪兽，一些消失了也不会有其他怪兽在意的怪兽。在剧团长残忍的训练中存活下来已经可以称为奇迹，挨打遭虐，各种可怕折磨如同饮水一样寻常，仅是想起团长手中的倒刺直鞭，大家就止不住会颤抖。可当Queen加入剧团后，过往的可怕竟还有些怀念，什么都会被炸，只要是活的，会哀嚎的，会流血的。尽管这只是压轴表演，但剧团里的怪兽都知道，无论它们再怎么拼命表演，终有一日会变成炸开的“烟花”。\\n感谢那场毫无预兆的爆炸表演结束了这一切，它们的“归宿”被炸毁了，连同残忍的观众和剧团长一起，在爆炸中永远的消失了。那位带它离开的怪兽将会给了它和其他幸存的成员一个新的归宿……",
    "themeCardPackDes_22020": "“这次行动如果能成功，血肉剧团确实地彻底摧毁，那些被死死刻在我们身体的东西应该无法被简单磨灭，所以，继续表演也许是个不错的选择。我相信大家也需要一个新的归宿和依靠。即便是在血肉剧团的观众席，也曾有过不那么疯狂的观众。或许，可以试着让它们通过其他表演经历一点点去掩埋那些可怕回忆。我知道我的请求非常任性，但Queen只有我了，我没有办法。我只能相信你们了，其他成员就拜托了。”",
    "themeCardPackDes_22025": "大地咆哮着，数座规整的梯形土台在轰鸣声中拔地而起，飞沙走石间，土台围绕着中心的圆形沙场，错落有致地缓降停顿，土台上观众恰恰落座，随后爆发出尖叫与欢呼。沙场中心的崩界领主收起按在地面上的巨掌，拍了拍身上的尘土，然后一臂张开，一手放在胸前高喊：“欢迎来到环形斗场！”。\\n每次副场主的开场都能让行尸感到震撼，它深吸一口气，因为马上就是它的出场了！\\n随后崩界领主又向地面大力一推，圆柱形舞台升起，上面一朵足以覆盖整个场地的艳丽巨花在盛开！细看会发现，那是行尸头部绑着的数百根彩藤通过它头部的高速旋转而绽放的奇花。随着彩藤的收束，一个巨大的筒状物将行尸盖住，一只没有背着大炮的人间大炮用头朝巨大筒状物一顶，筒状物便凌空飞起在上空高速回旋，里头的行尸也不见踪影~那个巨大筒状物不是别的，正是比这个人间大炮身体大好几十倍的大炮……表演开始了！",
    "25_10": "刷新对手",
    "themeCardPackDes_22030": "环形斗场的大沙场开始旋转，咆哮与欢呼声此起彼伏，观众土台瞬间沸腾。因为斗场的高潮即将到来！沙粒漫天飞舞，如同即将拉开的金色帷幕。一位决斗者从土台跃下，另一位则从阴影中缓缓现身。对战围栏升起的轰鸣一止，决斗便开始了！\\n从土台跃下的是咒灭主宰，阴影处现身的则是血渊主宰，两位主宰的碰撞马上点燃了整个斗场！\\n数颗微形陨星坠入战场，四刃交锋，咒灭主宰的弯刃一转刺向血渊主宰，可血渊主宰将上下半身瞬间分开，刃峰竟从上下半身的缝隙间滑出去了……就在血渊主宰的手刃即将刺入咒灭主宰的胸膛之际，高踞于围栏之上的硎闪身落入战场，他单手捏住刃锋，战斗就此停滞。\\n“停。”\\n他的声量不大，却清晰地传入了在场怪兽的耳中。\\n是的，毫不留情的交锋固然是看点，但最让观众血脉偾张、屏息凝神的正是环形斗场之主硎登场的一刻！",
    "25_13": "每日最多刷新{1}次",
    "25_14": "队伍中所有怪兽均已阵亡，不能挑战",
    "25_11": "使用后队伍中的所有怪兽复活并回复100%的血量，每日仅可使用一次，是否使用？",
    "25_12": "开始击破",
    "themeCardPackDes_22035": "又一次巡演结束了。\\n幕后，崩界领主看着行尸、人间大炮、妖火还有其他表演者在相互热烈地比划着，不禁有点感慨，剧团曾烙下的阴影并没有消失，但大家都有了不会再被阴影压倒的韧性。\\n那时Joker还没变成盒子，他与硎一起从Joker那了解到要摧毁剧团的计划，之后计划实施，他们在暗中保护剧团成员离开……即便被这样拜托了，彼时的他们对所谓的照顾、安慰、关心一窍不通。他只能拼命掩盖不安，一味地推起土墙，阻止那些陷入错乱的怪兽乱跑。而硎，他只会用拳头表达内心，回过神来之后又靠着伤害自身宣泄懊恼……\\n改变始于那个下着暴雨的夜。与剧团长有过密切交往的兽群突然袭来，而它们手上拿着的，正是根植在每一位剧团成员脑海深处的恐怖象征——倒刺直鞭。一条条直鞭甩动靠近，可谁都动弹不得，只有硎冲了出去，即便他也无法作出像样的反击，只是一次次挡在前面，替每一位成员挡下鞭子。眼看着硎已经摇摇欲坠了，已经快要不行了，自己内心的呐喊却无法传递到身体，直至一只行尸在眼前闪过挡住了直鞭，随后是一头人间大炮，然后他也冲了出去……有什么东西在它们的体内决堤了。",
    "25_20": "随机重置增益",
    "25_21": "使用后队伍中的所有怪兽复活并回复100%的血量，是否{1}使用？",
    "themeCardPackDes_22040": "环形斗场的怪兽从那个雨夜领悟到的东西，不仅带领着它们同过去的阴影斗争，还将给予它们迈向未来的力量。行尸努力探究甩头表演的极限，人间大炮不断追求操控更大的大炮进行表演，妖火在创造更大面积的火海，硎仍在追求他所能抵达的坚韧的极限。\\n也许还有一点是他们所不知道的，它们演出得到了观众的各式解读，化作一股远超它们想象的力量。\\n现在超进化大陆已经有了这样的传闻，参加一次环形斗场的对决就会变强！甚至是看一次环形斗场的表演就会变强！也许这个传闻有一天会抵达远走的Joker和Queen那里~",
    "25_22": "消耗{1}",
    "25_17": "规则",
    "25_18": "已售罄",
    "25_15": "阵亡",
    "25_16": "开始后当日无法更换对手，是否开始连环击破？\\n（右方路线图可查看10位对手信息）",
    "25_19": "重置",
    "95_comment": "无需翻译",
    "messageInitContent_11491": "六星酒店",
    "messageInitContent_11490": "五星好评",
    "messageInitContent_11497": "家人们谁懂啊",
    "messageInitContent_11496": "在打了在打了",
    "messageInitContent_11499": "huh？",
    "messageInitContent_11498": "问题不大",
    "13_13": "挑战",
    "messageInitContent_11493": "八星战队",
    "13_12": "每种燃火可以叠加最多{1}次",
    "messageInitContent_11492": "七星瓢虫",
    "13_11": "同一时间只能探索一个节点",
    "messageInitContent_11495": "红红火火恍恍惚惚",
    "13_10": "提升移动速度{1}%（+{2}%）",
    "messageInitContent_11494": "九星连环",
    "themeCardPackName_24035": "先祖的岛",
    "themeCardPackName_24030": "万灵的岛",
    "13_17": "是否消耗{1}钻石重置黑暗森林？",
    "13_16": "黑暗森林建筑等级{1}解锁",
    "13_15": "漆黑之根",
    "messageInitContent_11480": "种下我的太阳花",
    "13_14": "该能力到达满级",
    "13_19": "已对符合条件的探索者发送邀请",
    "13_18": "是否重置黑暗森林？",
    "13_20": "摇一摇可收取已探索的所有资源，注意轻一点别把树摇断！",
    "messageInitContent_11486": "和剧情对上了",
    "messageInitContent_9007": "随机点",
    "messageInitContent_11485": "这里是四带一",
    "messageInitContent_9006": "玄学告诉我选右",
    "messageInitContent_11488": "不敢玩那么久游戏了",
    "messageInitContent_9005": "赢的是这边",
    "messageInitContent_11487": "沉迷游戏然后重生",
    "messageInitContent_9004": "emmm",
    "13_24": "是否消耗{1}钻石立即完成",
    "messageInitContent_11482": "没找到大脑",
    "13_23": "一键收取",
    "messageInitContent_11481": "花花在对我笑",
    "13_22": "该探索者也处于森林中，你们会相遇吗？",
    "messageInitContent_11484": "还要学会杂交",
    "messageInitContent_9009": "猜对day0",
    "13_21": "是否消耗{1}钻石重置漆黑之根？",
    "messageInitContent_11483": "我爱豌豆射手",
    "messageInitContent_9008": "未尝一对",
    "themeCardPackName_24025": "消失的岛",
    "messageInitContent_9003": "敌不懂我不动",
    "messageInitContent_11489": "快乐先一步接管了神经系统。理智在角落举手反对，而双腿已经准备起跳。",
    "messageInitContent_9002": "敌动我懂",
    "messageInitContent_9001": "敌懂我不动",
    "themeCardPackName_24020": "无佑的岛",
    "messageInitContent_9000": "敌不动我懂",
    "messageInitContent_11475": "我爱娜迦",
    "messageInitContent_9018": "差点看出捕鱼者",
    "messageInitContent_11474": "我围着池塘边奔跑然后被骂的日子里……",
    "messageInitContent_9017": "发生了什么",
    "messageInitContent_11477": "那是坠落深海的精灵",
    "messageInitContent_9016": "狼外婆和小兔子组队了",
    "messageInitContent_11476": "你的喜好有点特别",
    "messageInitContent_9015": "什么阵容搭配小课堂",
    "messageInitContent_11471": "哪来的新设定",
    "messageInitContent_11470": "蜻蜓龙可是拥有竹蜻蜓的神奇生物",
    "messageInitContent_11473": "小时候小时候",
    "messageInitContent_11472": "找bug我擅长",
    "messageInitContent_9019": "捕鱼达人高手再次",
    "messageInitContent_9010": "经典看技能",
    "messageInitContent_11479": "人家也不想的啊",
    "messageInitContent_9014": "对对对",
    "messageInitContent_11478": "别过来啊",
    "messageInitContent_9013": "是是是",
    "messageInitContent_9012": "我是猜错概念神",
    "messageInitContent_9011": "今天选人多的",
    "messageInitContent_11464": "还真不知道喀戎什么星座，人马座",
    "messageInitContent_9029": "在猜了在猜了",
    "messageInitContent_11463": "但喀戎算人马吗",
    "messageInitContent_9028": "交答案税",
    "messageInitContent_11466": "是不是写错了",
    "messageInitContent_9027": "鱼王能顶住。我吃饭",
    "messageInitContent_11465": "救命什么鬼",
    "messageInitContent_9026": "大兔子乖乖",
    "messageInitContent_11460": "请问这里是命运石之门吗",
    "messageInitContent_11462": "你好英雄",
    "messageInitContent_11461": "抱歉这里是魔法门",
    "messageInitContent_9021": "这不是但前排加后排吗",
    "messageInitContent_9020": "行了行了",
    "themeCardPackDes_22005": "地上的影子随着爆炸的冲天火光急速变换，腥味和硝烟味混杂在一起不断地冲袭而来，并不完整的“观众们”四处乱飞，气浪中Queen跳入了一个大盒子后就消失在烟幕之中。血肉剧团就这在无比精彩绝伦的爆炸中失去了最闪耀的新星，彻底消亡，刻的世界竟比往常更为安静。\\n行尸告别不久前的回忆，在恍惚间从一处温暖的山洞，随后疲惫、安心、害怕各种情绪袭来，早已不会哭泣的它嚎啕大哭起来。",
    "messageInitContent_11468": "学习机",
    "messageInitContent_9025": "饭点到了",
    "themeCardPackName_24040": "封闭的岛",
    "messageInitContent_11467": "这，这对吗",
    "messageInitContent_9024": "饿了",
    "messageInitContent_9023": "超！",
    "messageInitContent_11469": "插歪了要吹一吹",
    "messageInitContent_9022": "对面2个前排呢",
    "messageInitContent_11453": "遍地玩偶小兵",
    "messageInitNick_195": "使徒们快跑",
    "messageInitContent_11452": "如果皮匠你们被挟持了就眨眨眼",
    "messageInitNick_196": "好强太强了",
    "messageInitContent_11455": "这里是肺活量模拟器，请荧灵将您的……",
    "messageInitNick_197": "萌量不足",
    "messageInitContent_11454": "要加速了！",
    "messageInitNick_198": "初号机没电了",
    "messageInitNick_199": "你太强了",
    "messageInitContent_11451": "带上我的无敌王戒指",
    "messageInitContent_11450": "已经从你的眼神中看到了我的胜利",
    "messageInitNick_190": "信我唔坑",
    "messageInitContent_11457": "荧灵快跑",
    "messageInitNick_191": "国民辣条专家",
    "messageInitContent_11456": "这是什么生物写出来的东西",
    "messageInitNick_192": "人类橙汁计划",
    "messageInitContent_11459": "那就由我来帮您解决楼上的变态吧",
    "messageInitNick_193": "无坑真的",
    "messageInitContent_11458": "可是她没有脚",
    "messageInitNick_194": "盖世菜鸟",
    "messageInitNick_9093": "迷路的距骨",
    "messageInitNick_9094": "实名预定",
    "messageInitNick_9091": "奇异雪糕",
    "messageInitNick_9092": "柠檬兽",
    "messageInitNick_9090": "美美下播",
    "messageInitNick_9099": "最强亮点",
    "messageInitNick_9097": "青花瓷",
    "messageInitNick_9098": "电子木鱼",
    "messageInitNick_9095": "期待的那窗",
    "messageInitNick_9096": "灵动的芒果",
    "messageInitContent_11442": "能换个橡皮擦",
    "messageInitContent_11441": "然后那个地方就倒闭了对吧",
    "messageInitContent_11444": "最多不也就是超大熊贝贝",
    "messageInitContent_11443": "我看只能换个小零食",
    "messageInitContent_11440": "我家还有很多奖票没有兑换",
    "messageInitContent_11449": "有没有可能就是打游戏接触高纬度生物，掉理智了呢",
    "messageInitContent_11446": "一拳就够了",
    "messageInitContent_11445": "不需洞悉太多",
    "messageInitContent_11448": "不是打游戏打的吗",
    "messageInitContent_11447": "不要触及更高维度，不然可能会变成炼狱魔眼的样子",
    "messageInitNick_9082": "熊群的科学家",
    "randomEventDialogueGroupConfig_51.44": "出手相助",
    "messageInitNick_9083": "云完就跑",
    "randomEventDialogueGroupConfig_51.43": "咱们超镖局的镖师都派出去跟几趟重要的镖了，现在我们刚又接到新的委托，正愁没有人手。",
    "messageInitNick_9080": "懂的都懂",
    "randomEventDialogueGroupConfig_51.46": "刚刚那叉叉又跑了过来向你询问。",
    "messageInitNick_9081": "无意识的秘密",
    "randomEventDialogueGroupConfig_51.45": "你来到了悬赏令上的那家镖局，一个自称镖师的怪兽热情地迎接了你。",
    "randomEventDialogueGroupConfig_51.40": "离开",
    "randomEventDialogueGroupConfig_51.42": "离开",
    "randomEventDialogueGroupConfig_51.41": "密林只闻鸟鸣不见鸟影，沿途还有几个大坑。你们小心翼翼地穿过了树林，顺利交差。",
    "messageInitNick_9088": "猕猴桃去哪了",
    "messageInitNick_9089": "大熊宝贝",
    "messageInitNick_9086": "枯萎的花瓶",
    "randomEventDialogueGroupConfig_51.48": "刚刚那叉叉又跑了过来向你询问。",
    "messageInitNick_9087": "全体起立",
    "randomEventDialogueGroupConfig_51.47": "你来到了悬赏令上的那家镖局，一个自称镖师的怪兽热情地迎接了你。",
    "messageInitNick_9084": "爱若寒冷",
    "messageInitNick_9085": "鲸鱼到此一游",
    "messageInitContent_11431": "赤炼零式难道是？",
    "messageInitContent_11430": "欢迎来到锈湖",
    "messageInitContent_11433": "你并未死去，只是被拆分",
    "messageInitContent_11432": "你的记忆已被系统回收",
    "messageInitContent_11439": "我选择卡关",
    "messageInitContent_11438": "我选择通关",
    "messageInitContent_11435": "短剧之王",
    "messageInitContent_11434": "永生需要持续缴费",
    "messageInitContent_11437": "我们也是互动的一环吗",
    "messageInitContent_11436": "剧王原来是导演吗",
    "messageInitNick_9071": "天涯浪客",
    "randomEventDialogueGroupConfig_51.33": "前往搭救",
    "messageInitNick_9072": "假面王子",
    "randomEventDialogueGroupConfig_51.32": "你们顺利过了桥，突然听到有怪兽在前方求救，叫声惨绝。",
    "randomEventDialogueGroupConfig_51.35": "之后一路畅通，押镖完成。",
    "messageInitNick_9070": "尬聊机器",
    "randomEventDialogueGroupConfig_51.34": "绝不搭理",
    "randomEventDialogueGroupConfig_51.31": "离开",
    "randomEventDialogueGroupConfig_51.30": "亏得你们技高一筹，虽保下了镖车，但却伤亡惨重，路途未半，再难前行。",
    "messageInitNick_9079": "感激你曾来过",
    "messageInitNick_9077": "睡觉中",
    "messageInitNick_9078": "搬砖鉴定家",
    "messageInitNick_9075": "薄荷微微凉",
    "randomEventDialogueGroupConfig_51.37": "你顺利将货送达，完成了任务。",
    "messageInitNick_9076": "音乐虫子",
    "randomEventDialogueGroupConfig_51.36": "离开",
    "messageInitNick_9073": "划水泰斗",
    "randomEventDialogueGroupConfig_51.39": "一群恶兽一拥而上，将你们团团围住，并趁机劫走货物。有个大胆叉叉大喊着，让大家把身上值钱的货都交过去，怎料对方竟毫不动容。接下来想必是一番死斗，生死难料。",
    "messageInitNick_9074": "超级烤肉串",
    "randomEventDialogueGroupConfig_51.38": "离开",
    "messageInitContent_11420": "想和鸽子恋爱",
    "messageInitContent_11422": "我是一只没有脚的鸟",
    "messageInitContent_11421": "小朋友你是不是有很多问号",
    "messageInitContent_11428": "贴右",
    "messageInitContent_11427": "贴左",
    "messageInitContent_11429": "到底左还是右",
    "messageInitContent_11424": "真的怕怕",
    "messageInitContent_11423": "会被骂笨蛋吗",
    "messageInitContent_11426": "贴墙走是对的，直到它不是",
    "messageInitContent_11425": "墙神是造迷宫的吗",
    "16_1": "是否消耗{1}刷新永生之茧",
    "messageInitNick_9060": "道不清的忧伤",
    "messageInitNick_9061": "枪口给你缝上",
    "messageInitContent_11409": "被锁定了吗",
    "messageInitNick_9068": "炒炒炒炒面",
    "messageInitNick_9069": "收收味",
    "messageInitNick_9066": "菠萝兽",
    "messageInitNick_9067": "冰箱软妹贴",
    "messageInitNick_9064": "除非忍不住",
    "messageInitNick_9065": "喧闹的街",
    "messageInitNick_9062": "烧饼分你一半",
    "16_2": "敬请期待",
    "messageInitNick_9063": "本菇凉是神",
    "messageInitContent_11411": "不想努力了吗",
    "messageInitContent_11410": "纯情包租公",
    "messageInitNick_9059": "无痛养狗",
    "messageInitContent_11417": "为什么不能跳过这关",
    "messageInitContent_11416": "大脑加载中……",
    "messageInitContent_11419": "坚持就是胜利",
    "messageInitContent_11418": "出售金手指",
    "messageInitContent_11413": "好好工作别做梦",
    "messageInitContent_11412": "要努力啊",
    "messageInitContent_11415": "吸血鬼之吻来了",
    "messageInitContent_11414": "首先，然后",
    "messageInitNick_9050": "那就是萌新",
    "messageInitNick_9057": "不能熬夜",
    "messageInitNick_9058": "铃儿响叮当",
    "messageInitNick_9055": "打卡泰斗",
    "messageInitNick_9056": "菠萝消灭者",
    "messageInitNick_9053": "来点酱油",
    "messageInitNick_9054": "尬聊先驱",
    "messageInitNick_9051": "夕颜蝶泪",
    "messageInitNick_9052": "角落里的阳光",
    "messageInitContent_11400": "领域展开",
    "messageInitNick_9048": "进击星人",
    "messageInitNick_9049": "炒菜必粘锅",
    "messageInitContent_11406": "怎么就没有推荐阵容",
    "messageInitContent_11405": "那我走",
    "messageInitContent_11408": "可恶",
    "messageInitContent_11407": "怪兽的眼神变了！",
    "messageInitContent_11402": "别别别",
    "messageInitContent_11401": "战神在此",
    "messageInitContent_11404": "不许生气哦",
    "messageInitContent_11403": "时间就是生命",
    "messageInitNick_9046": "智能辣椒",
    "messageInitNick_9047": "最强碗",
    "messageInitNick_9044": "无奈的猫生",
    "messageInitNick_9045": "小萌神",
    "messageInitNick_9042": "发光体",
    "messageInitNick_9043": "疗伤灵鹿",
    "messageInitNick_9040": "猫咪厂长",
    "messageInitNick_9041": "焦糖玛奇朵",
    "messageInitNick_9039": "赛博饺子",
    "messageInitNick_9037": "头铁王",
    "messageInitNick_9038": "笨瓜",
    "messageInitNick_9035": "十二点的凉粉",
    "messageInitNick_9036": "麻木的微笑",
    "messageInitNick_9033": "迷途猫",
    "messageInitNick_9034": "迷人的珠宝",
    "messageInitNick_9031": "一眼万年",
    "messageInitNick_9032": "光棍村村长",
    "messageInitNick_9030": "颗颗蛀牙",
    "messageInitNick_9028": "早上四点半",
    "messageInitNick_9029": "洋葱魔法师",
    "messageInitNick_9026": "泡面怪客",
    "messageInitNick_9027": "超级红地毯",
    "messageInitNick_115": "行盖五过",
    "messageInitNick_9024": "雀斑少女",
    "messageInitNick_116": "脸有点肿",
    "messageInitNick_9025": "来自文件夹",
    "messageInitNick_117": "夜空一样温柔",
    "messageInitNick_9022": "泪眼看世界",
    "messageInitNick_118": "爱的啵啵酱",
    "messageInitNick_9023": "橙子君快逃",
    "messageInitNick_119": "好盖五过",
    "messageInitNick_9020": "行为艺术家",
    "messageInitNick_9021": "无语草莓",
    "messageInitNick_9019": "贝多芬的寂寞",
    "messageInitNick_110": "脸麻",
    "messageInitNick_111": "必杀技",
    "messageInitNick_9017": "倚栏听风叙",
    "messageInitNick_112": "盖五过",
    "messageInitNick_9018": "闪电快递",
    "messageInitNick_113": "脸有点麻",
    "messageInitNick_9015": "旧街",
    "messageInitNick_114": "过家家",
    "messageInitNick_9016": "不爱就坚强",
    "messageInitNick_126": "啊这过",
    "messageInitNick_9013": "蛋挞怪兽",
    "messageInitNick_127": "被优化人员",
    "messageInitNick_9014": "福如东海",
    "messageInitNick_128": "我略知一二",
    "messageInitNick_9011": "国民女汉纸",
    "messageInitNick_129": "爱的代驾",
    "messageInitNick_9012": "烫烫烫",
    "messageInitNick_9010": "我不尬就他尬",
    "messageInitNick_120": "平庸鬼",
    "messageInitNick_9008": "引战门首席",
    "messageInitNick_121": "一定是橙色",
    "messageInitNick_9009": "万能冰箱",
    "messageInitNick_122": "没事过",
    "messageInitNick_9006": "世界第一勇敢",
    "messageInitNick_123": "平庸大师",
    "messageInitNick_9007": "别来沾边",
    "messageInitNick_124": "夏威夷学的",
    "messageInitNick_9004": "石榴之心",
    "messageInitNick_125": "爱的创可贴",
    "messageInitNick_9005": "流浪之旅",
    "messageInitNick_137": "你毕业了",
    "messageInitNick_9002": "下辈子见",
    "messageInitNick_138": "逐渐理解一切",
    "messageInitNick_9003": "熬夜高手",
    "messageInitNick_139": "可以请",
    "messageInitNick_9000": "哗啦啦小魔仙",
    "messageInitNick_9001": "白水咖啡",
    "messageInitNick_130": "喂过",
    "messageInitNick_131": "拼搏的大爷",
    "messageInitNick_132": "一百亿",
    "messageInitNick_133": "直接叫过",
    "messageInitNick_134": "优秀毕业生",
    "messageInitNick_135": "不燃物",
    "messageInitNick_136": "还是过吧",
    "themeCardPackageName_190": "嬉游夜",
    "messageInitNick_148": "你坐啊",
    "messageInitNick_149": "叫你速动啊",
    "messageInitNick_140": "恭喜毕业",
    "messageInitNick_141": "只要微笑就好",
    "messageInitNick_142": "爱的仿制品",
    "messageInitNick_143": "无坑速动",
    "messageInitNick_144": "微笑就好了",
    "messageInitNick_145": "爱的分界线",
    "messageInitNick_146": "我叫你速动啊",
    "messageInitNick_147": "只能逃了",
    "randomEventDialogueGroupConfig_51.22": "高喊镖号迅速通行",
    "randomEventDialogueGroupConfig_51.21": "绕道而行",
    "randomEventDialogueGroupConfig_51.24": "行话专家",
    "randomEventDialogueGroupConfig_51.23": "准备指派谁去交涉呢？",
    "randomEventDialogueGroupConfig_51.20": "你们顺利过了桥，前方两山间出现了一片密林。",
    "messageInitNick_159": "飞天扫地机",
    "randomEventDialogueGroupConfig_51.29": "离开",
    "randomEventDialogueGroupConfig_51.26": "对方向你抱拳，大喊一声“合吾”便迅速散去。之后一路通畅，顺利押镖。",
    "randomEventDialogueGroupConfig_51.25": "情话砖家",
    "randomEventDialogueGroupConfig_51.28": "贼兽哄堂大笑，然后冲过来将镖车劫走。这次押镖失败了。",
    "randomEventDialogueGroupConfig_51.27": "离开",
    "messageInitNick_151": "海那边是自由",
    "messageInitNick_152": "速动吧无坑",
    "messageInitNick_153": "快逃",
    "messageInitNick_154": "真嗣美里帽",
    "messageInitNick_155": "都说无坑",
    "messageInitNick_156": "逃了逃了",
    "messageInitNick_157": "精神污染",
    "messageInitNick_158": "我信你无坑",
    "messageInitNick_150": "先逃了",
    "randomEventDialogueGroupConfig_51.11": "你手下的一只叉叉拿着超镖局的镖旗跑了过来，问你要不要插上。",
    "randomEventDialogueGroupConfig_51.10": "立刻出发",
    "randomEventDialogueGroupConfig_51.13": "不插",
    "randomEventDialogueGroupConfig_51.12": "插上",
    "randomEventDialogueGroupConfig_51.19": "尝试交涉",
    "randomEventDialogueGroupConfig_51.18": "全员突围",
    "randomEventDialogueGroupConfig_51.15": "有那么大声喊那么大声",
    "randomEventDialogueGroupConfig_51.14": "准备要过桥了，咱们要不要喊“合吾一声镖车走，我武唯扬——”",
    "randomEventDialogueGroupConfig_51.17": "过桥时，一群贼兽前后堵住了你们的来路与去路。",
    "randomEventDialogueGroupConfig_51.16": "绝不招摇",
    "messageInitNick_162": "扫地机二千",
    "messageInitNick_163": "绝对领域全开",
    "messageInitNick_164": "反正我不信",
    "messageInitNick_165": "光轮扫地机",
    "messageInitNick_166": "物品马赛克",
    "messageInitNick_167": "爱的狠伤得重",
    "messageInitNick_168": "五换一",
    "messageInitNick_169": "来一碗小鲜肉",
    "messageInitNick_160": "绝对领域",
    "messageInitNick_161": "鬼信你无坑",
    "messageInitNick_173": "吸管圣光",
    "messageInitNick_174": "换不过你",
    "messageInitNick_175": "辣条",
    "messageInitNick_176": "灯圣光",
    "messageInitNick_177": "真的无坑",
    "messageInitNick_178": "盖世辣条",
    "messageInitNick_179": "企鹅头圣光",
    "messageInitNick_170": "易拉罐圣光",
    "messageInitNick_171": "听说是换资源",
    "messageInitNick_172": "再来碗小鲜肉",
    "messageInitNick_184": "保证无坑",
    "messageInitNick_185": "极品辣条",
    "messageInitNick_186": "手套又黏脸",
    "messageInitNick_187": "在你心迷路",
    "messageInitNick_188": "辣条数星星",
    "messageInitNick_189": "生命之水",
    "messageInitNick_180": "绝对无坑",
    "messageInitNick_181": "超级辣条",
    "messageInitNick_182": "熟悉的天花板",
    "messageInitNick_183": "爱的警区",
    "themeCardPackageName_260": "月光漾",
    "messageInitContent_9159": "今天选人多的",
    "messageInitContent_9158": "给网线把脉",
    "messageInitContent_9153": "看不出左边有啥胜算",
    "messageInitContent_9152": "这里是预言家，左",
    "messageInitContent_9151": "猜对day0",
    "messageInitContent_9150": "左左右右前前后后",
    "messageInitContent_9157": "刚来选啥",
    "messageInitContent_9156": "精致探索者竞猜中",
    "messageInitContent_9155": "人越多人越少",
    "messageInitContent_9154": "大家都选好了吗",
    "channelName_1050": "MuMu模拟器",
    "messageInitContent_9160": "我有一个大胆的想法",
    "themeCardPackageName_250": "夏日祭",
    "messageInitContent_9169": "新兽必胜不然怎么对吧",
    "messageInitContent_9164": "地龙最怕的一集",
    "messageInitContent_9163": "先让我缓缓",
    "messageInitContent_9162": "你们快选啊",
    "messageInitContent_9161": "秒get",
    "messageInitContent_9168": "都是一棵进化树上出来的",
    "messageInitContent_9167": "超进化大陆也有超进化大陆的蚊子",
    "messageInitContent_9166": "都是吸血怪",
    "messageInitContent_9165": "肯定是新人光环啦",
    "messageInitContent_9171": "哪里有答案",
    "themeCardPackageName_240": "部落格",
    "messageInitContent_9170": "多谢前排答案",
    "randomEventDialogueGroupConfig_5.98": "那……回收之前还需要处理一下，来战。",
    "randomEventDialogueGroupConfig_5.97": "接受挑战",
    "randomEventDialogueGroupConfig_5.99": "战斗",
    "randomEventDialogueGroupConfig_5.94": "它握着大巴叶叶柄的手微微颤抖，显然已经在爆发边缘了。",
    "randomEventDialogueGroupConfig_5.93": "呃，这里还是我来吧。你先回吧。",
    "randomEventDialogueGroupConfig_5.96": "它做了个请的动作。",
    "randomEventDialogueGroupConfig_5.95": "道歉离开",
    "messageInitContent_9175": "来点击退",
    "messageInitContent_9174": "绯有击退呢",
    "messageInitContent_9173": "怪多力量大",
    "messageInitContent_9172": "这射程根本不够看啊",
    "messageInitContent_9179": "随机点",
    "messageInitContent_9178": "猜对day1",
    "messageInitContent_9177": "在猜了在猜了",
    "messageInitContent_9176": "大佬快来指路",
    "messageInitContent_9182": "总有一个对的",
    "messageInitContent_9181": "交答案税",
    "messageInitContent_9180": "怪兽赢了",
    "themeCardPackageName_230": "千舸竞",
    "messageInitContent_9186": "主打一个随缘",
    "messageInitContent_9185": "今天选人多的",
    "messageInitContent_9184": "收工",
    "messageInitContent_9183": "这里是预言家，左",
    "messageInitContent_9189": "对吗？不对吧",
    "messageInitContent_9188": "超纲了",
    "messageInitContent_9187": "总有一个是错的",
    "messageInitContent_9193": "听我的选这边",
    "messageInitContent_9192": "哈利波与？",
    "messageInitContent_9191": "选择困难症怎么办",
    "messageInitContent_9190": "在左右之间迷失了方向",
    "messageInitContent_9197": "这里是鸟龙龙龙龙龙龙",
    "messageInitContent_9196": "有探索者来拍照记得插袋",
    "messageInitContent_9195": "新大陆我来啦！",
    "messageInitContent_9194": "我家猫帮我选了",
    "messageInitContent_9199": "鸟龙的屁股上好像长了一只手……",
    "messageInitContent_9198": "提问：本关有多少鸟龙",
    "themeCardPackageName_280": "玩物谭",
    "themeCardPackageName_270": "燃云起",
    "messageInitNick_104": "无敌打脸神",
    "messageInitNick_105": "人体描边大师",
    "messageInitNick_106": "全速前进",
    "messageInitNick_107": "强壮打脸神",
    "messageInitNick_108": "正当防卫",
    "messageInitNick_109": "贴五过",
    "messageInitNick_100": "超级打脸神",
    "messageInitNick_101": "瑞贝卡酱",
    "messageInitNick_102": "爱得如此狼狈",
    "messageInitNick_103": "好糊",
    "95_2005": "领完红包再买哦",
    "monsterName_596": "玩偶棋兵♠",
    "95_2006": "立即购买",
    "monsterName_597": "玩偶棋兵♥",
    "95_2003": "0元起购",
    "monsterName_598": "玩偶棋兵♣",
    "95_2004": "领取红包，试试运气",
    "monsterName_599": "玩偶棋兵♦",
    "95_2001": "*点击0元购按钮即可跳转至活动页面，登录支付宝账号参与活动后在App Store设置以支付宝账号付款，红包将在支付时抵扣，实付低至0元起。详细规则请见活动页",
    "95_2002": "*本次活动折扣由支付宝Apple专区提供，使用渠道仅限App Store",
    "monsterName_590": "娜迦",
    "monsterName_591": "屠帝",
    "monsterName_592": "希",
    "monsterName_593": "笨拿拿",
    "monsterName_594": "月影萨满",
    "monsterName_595": "龙执事",
    "randomEventDialogueGroupConfig_5.32": "反问它那喜欢的人做什么都是对的",
    "randomEventDialogueGroupConfig_5.31": "没做错什么，对于它们而言，只要是它们不喜欢的，什么都是错的。",
    "randomEventDialogueGroupConfig_5.34": "敷衍离开",
    "randomEventDialogueGroupConfig_5.33": "问应该多少点缘由吧",
    "randomEventDialogueGroupConfig_5.30": "说下次再去",
    "randomEventDialogueGroupConfig_5.39": "那就让你流点汗吧。",
    "randomEventDialogueGroupConfig_5.36": "告别",
    "randomEventDialogueGroupConfig_5.35": "总觉得你在暗示什么，但我没有证据，先忙了。",
    "randomEventDialogueGroupConfig_5.38": "问它们是谁",
    "randomEventDialogueGroupConfig_5.37": "它们都说幻幻一定是被污蔑的。",
    "randomEventDialogueGroupConfig_5.43": "那请到这边丢人。",
    "randomEventDialogueGroupConfig_5.42": "建议它也听听其他团体的声音",
    "randomEventDialogueGroupConfig_5.45": "对战",
    "randomEventDialogueGroupConfig_5.44": "巧了，我的工作就是处理垃圾。",
    "randomEventDialogueGroupConfig_5.41": "幻幻的后援会的家伙都是这么说的。",
    "randomEventDialogueGroupConfig_5.40": "迎战",
    "randomEventDialogueGroupConfig_5.47": "那你是什么？",
    "randomEventDialogueGroupConfig_5.46": "它思考了一会。",
    "randomEventDialogueGroupConfig_5.49": "随便报一个名字",
    "randomEventDialogueGroupConfig_5.48": "报上自己的名号",
    "monsterName_574": "溜溜",
    "monsterName_575": "王霸",
    "monsterName_576": "倍速兽",
    "monsterName_577": "闪光",
    "monsterName_578": "殉道者",
    "monsterName_579": "吸盘兽",
    "messageInitContent_11390": "这个闪光和我想象的不一样",
    "messageInitContent_11392": "我的终极技能是留言",
    "messageInitContent_11391": "正在占领目标",
    "monsterName_570": "灾·雷鸣",
    "monsterName_571": "源·危险的草丛",
    "monsterName_572": "ㄨ",
    "monsterName_573": "毒",
    "messageInitContent_11398": "有司机却没有车",
    "randomEventDialogueGroupConfig_5.10": "继续捣乱",
    "messageInitContent_11397": "说起医院游戏，情不自禁想起了",
    "randomEventDialogueGroupConfig_5.12": "你是什么垃圾？",
    "messageInitContent_11399": "让她治愈你吧！",
    "randomEventDialogueGroupConfig_5.11": "将更多垃圾倾倒在这",
    "messageInitContent_11394": "不对劲",
    "messageInitContent_11393": "同样的臀",
    "messageInitContent_11396": "猫猫司机",
    "messageInitContent_11395": "继续前进！",
    "randomEventDialogueGroupConfig_5.18": "这个年头像，你这种乐于助人的已经很少见了，谢谢你，请收下这个。",
    "randomEventDialogueGroupConfig_5.17": "干垃圾",
    "randomEventDialogueGroupConfig_5.19": "收下",
    "randomEventDialogueGroupConfig_5.14": "湿垃圾",
    "randomEventDialogueGroupConfig_5.13": "不是垃圾",
    "randomEventDialogueGroupConfig_5.16": "可回收垃圾",
    "randomEventDialogueGroupConfig_5.15": "有害垃圾",
    "monsterName_585": "帅·歧兽",
    "monsterName_586": "美·歧兽",
    "monsterName_587": "壮·歧兽",
    "monsterName_588": "大嘴鱼王",
    "monsterName_589": "鲨叉",
    "messageInitContent_11381": "我受伤了需要治疗",
    "messageInitContent_11380": "超脱力",
    "monsterName_580": "幼体凶兽",
    "monsterName_581": "幻化凶兽",
    "monsterName_582": "究极凶兽",
    "monsterName_583": "不朽凶兽",
    "monsterName_584": "觉醒凶兽",
    "messageInitContent_11387": "一切都在预料之中",
    "messageInitContent_9106": "我看好老狮",
    "randomEventDialogueGroupConfig_5.21": "它握住大巴叶叶柄的双手前后拧了拧小声说道。",
    "messageInitContent_11386": "我已经进入第二阶段了",
    "messageInitContent_9105": "只要标签够多大家都是王者",
    "randomEventDialogueGroupConfig_5.20": "表示仅仅是助人为乐",
    "messageInitContent_11389": "怎么回事你们",
    "messageInitContent_9104": "走近竞猜",
    "randomEventDialogueGroupConfig_5.23": "它若有所思地点了点头。",
    "messageInitContent_11388": "已经备好解读剂",
    "messageInitContent_9103": "该不会是……",
    "randomEventDialogueGroupConfig_5.22": "它低头沉默了一会儿，然后又抬起头。",
    "messageInitContent_11383": "让g-n来",
    "messageInitContent_11382": "给你医疗包",
    "messageInitContent_9109": "好好好",
    "messageInitContent_11385": "危险区域会慢慢变红",
    "messageInitContent_9108": "两个技能看完",
    "messageInitContent_11384": "你们好坏",
    "messageInitContent_9107": "遇事不决看技能啊啊啊啊",
    "randomEventDialogueGroupConfig_5.29": "进店",
    "randomEventDialogueGroupConfig_5.28": "谢谢你，对了，您要来我店里看看吗。",
    "messageInitContent_9102": "早上好下午好晚上好",
    "randomEventDialogueGroupConfig_5.25": "与它告别",
    "messageInitContent_9101": "天天开心",
    "randomEventDialogueGroupConfig_5.24": "这可不能乱说，要讲求事实和证据！",
    "messageInitContent_9100": "坏了",
    "randomEventDialogueGroupConfig_5.27": "安慰它一下后离开",
    "randomEventDialogueGroupConfig_5.26": "跟风的哪哪都有，唉。",
    "messageInitContent_11370": "逃不出去的旋转木马",
    "randomEventDialogueGroupConfig_5.81": "开搞",
    "themeCardPackageName_220": "奇迹秀",
    "randomEventDialogueGroupConfig_5.80": "那就麻烦你了。",
    "messageInitContent_11376": "我的象能横着走",
    "messageInitContent_9117": "玄学告诉我选右",
    "randomEventDialogueGroupConfig_5.76": "离开",
    "messageInitContent_11375": "是谁家象棋掉这里了？",
    "messageInitContent_9116": "肯定是那边啊",
    "randomEventDialogueGroupConfig_5.75": "有证据的话再来找我吧，再见。",
    "messageInitContent_11378": "什么跟什么",
    "messageInitContent_9115": "左右横跳中",
    "randomEventDialogueGroupConfig_5.78": "说只是想帮忙",
    "messageInitContent_11377": "你的螃蟹叫大象？",
    "messageInitContent_9114": "狮os这次不用打赤虹了真好",
    "randomEventDialogueGroupConfig_5.77": "它看起来有些不知所措。\\n",
    "messageInitContent_11372": "回不去童年的你",
    "randomEventDialogueGroupConfig_5.72": "摊摊手离开",
    "messageInitContent_11371": "走不出关卡的独角兽",
    "randomEventDialogueGroupConfig_5.71": "指出是幻让兽丝出面的可能性",
    "messageInitContent_11374": "一年又一年",
    "messageInitContent_9119": "预言一下赢的是这边",
    "randomEventDialogueGroupConfig_5.74": "告别",
    "messageInitContent_11373": "一圈又一圈",
    "messageInitContent_9118": "难顶",
    "randomEventDialogueGroupConfig_5.73": "你说得对，确实它可以做的更好，谢谢你的分享。",
    "messageInitContent_9113": "好狮好狮好狮",
    "messageInitContent_11379": "双响炮",
    "messageInitContent_9112": "安安",
    "randomEventDialogueGroupConfig_5.79": "告别",
    "messageInitContent_9111": "好像很厉害的样子",
    "messageInitContent_9110": "狮有回血吧",
    "randomEventDialogueGroupConfig_5.90": "点头离开",
    "themeCardPackageName_210": "春祈至",
    "randomEventDialogueGroupConfig_5.92": "地面很快就干净了，甚至多出了一个洞。",
    "randomEventDialogueGroupConfig_5.91": "表示可以继续帮忙",
    "messageInitContent_11365": "那里有黑洞",
    "messageInitContent_9128": "猜对的方程式已经想好了",
    "randomEventDialogueGroupConfig_5.87": "收下帮忙",
    "messageInitContent_11364": "嗯？",
    "messageInitContent_9127": "夜观星象不知答案",
    "randomEventDialogueGroupConfig_5.86": "这里还有大巴叶呢，你用这个吧。",
    "messageInitContent_11367": "我喜欢大嘴鱼王",
    "messageInitContent_9126": "家人们谁懂啊",
    "randomEventDialogueGroupConfig_5.89": "它看起来有点为难的样子。",
    "messageInitContent_11366": "救命怎么这样",
    "messageInitContent_9125": "经典看技能",
    "randomEventDialogueGroupConfig_5.88": "要不你还是先去忙你的吧。",
    "messageInitContent_11361": "不要停下来啊啊啊",
    "randomEventDialogueGroupConfig_5.83": "手和脚和尾巴",
    "messageInitContent_11360": "这里就算终点了嘛",
    "randomEventDialogueGroupConfig_5.82": "用什么工具呢？",
    "messageInitContent_11363": "你好，我是土地有什么能帮到你",
    "randomEventDialogueGroupConfig_5.85": "它转头瞪着你发出了灵魂的拷问。",
    "messageInitContent_11362": "土精灵之门啊，应我进化魔女打开把",
    "messageInitContent_9129": "我是猜错概念神",
    "randomEventDialogueGroupConfig_5.84": "技能",
    "messageInitContent_9120": "收工",
    "messageInitContent_11369": "受不了了",
    "messageInitContent_9124": "咋选",
    "messageInitContent_11368": "我喜欢大炮",
    "messageInitContent_9123": "让我猜对一次吧！",
    "messageInitContent_9122": "发女装可得答案",
    "messageInitContent_9121": "选对明天加菜",
    "themeCardPackageName_200": "深渊谭",
    "messageInitContent_11354": "bgm变了！",
    "messageInitContent_9139": "我康康",
    "randomEventDialogueGroupConfig_5.54": "离开",
    "messageInitContent_11353": "人生三大错觉",
    "messageInitContent_9138": "但凡在等级多加几位",
    "randomEventDialogueGroupConfig_5.53": "它狐疑地看了你一眼，将你的名字记录在小本本上，然后指着远处示意让你赶紧离开。",
    "messageInitContent_11356": "别打我",
    "messageInitContent_9137": "离谱",
    "randomEventDialogueGroupConfig_5.56": "大发慈悲地离开",
    "messageInitContent_11355": "许愿先!",
    "messageInitContent_9136": "5个技能打1个技能是吧",
    "randomEventDialogueGroupConfig_5.55": "啊……行了行了，就请你大发慈悲地离开吧。",
    "messageInitContent_11350": "通关会加好感度的嘛",
    "randomEventDialogueGroupConfig_5.50": "说既然你诚心诚意地发问……",
    "messageInitContent_11352": "为什么她喜欢我",
    "randomEventDialogueGroupConfig_5.52": "离开",
    "messageInitContent_11351": "先读个档",
    "randomEventDialogueGroupConfig_5.51": "它认真的将你的名字记录在小本本上，然后指着远处示意让你赶紧离开。",
    "messageInitContent_9131": "再也没有世俗的烦恼",
    "messageInitContent_9130": "我柜子动了",
    "messageInitContent_11358": "醒醒别做梦了",
    "messageInitContent_9135": "看地龙表演",
    "randomEventDialogueGroupConfig_5.58": "哎，为什么幻幻要遭受这些，它明明没做什么坏事。",
    "messageInitContent_11357": "超进化物语2之所有关卡的怪兽都是我手下",
    "messageInitContent_9134": "问题不大",
    "randomEventDialogueGroupConfig_5.57": "它突然丢下手上的大巴叶，噔噔噔冲了过来。",
    "messageInitContent_9133": "暗中观察",
    "messageInitContent_11359": "许愿不是这么许的",
    "messageInitContent_9132": "别打啦别打啦",
    "randomEventDialogueGroupConfig_5.59": "过去询问发生了什么",
    "randomEventDialogueGroupConfig_5.70": "说幻没有引导好兽丝就是不对",
    "messageInitContent_11343": "要是不用上班就好了",
    "randomEventDialogueGroupConfig_5.65": "问幻是做错了什么",
    "messageInitContent_11342": "观察中",
    "messageInitContent_9149": "我梦到了是右边赢",
    "randomEventDialogueGroupConfig_5.64": "指出那样是不对的",
    "messageInitContent_11345": "怎么有点眼熟",
    "messageInitContent_9148": "天知道答案",
    "randomEventDialogueGroupConfig_5.67": "也许你说的也有道理，谢谢你。",
    "messageInitContent_11344": "龙帝要减肥了",
    "messageInitContent_9147": "ai知道答案",
    "randomEventDialogueGroupConfig_5.66": "问是不是幻的兽丝招黑了",
    "randomEventDialogueGroupConfig_5.61": "上前捣乱",
    "randomEventDialogueGroupConfig_5.60": "上前帮忙清理",
    "messageInitContent_11341": "gogogo",
    "randomEventDialogueGroupConfig_5.63": "那些不喜欢幻的怪兽故意将砂石倾倒在这里了。",
    "messageInitContent_11340": "哈哈哈带上我",
    "randomEventDialogueGroupConfig_5.62": "听见幻幻赶紧绕开",
    "messageInitContent_9142": "这不是前几天的那啥",
    "messageInitContent_9141": "带上懵比或许还能玩玩",
    "messageInitContent_9140": "那可是地龙",
    "messageInitContent_11347": "天天来视察",
    "messageInitContent_9146": "量子波动选择法",
    "randomEventDialogueGroupConfig_5.69": "那……那但为什么兽丝的锅，要偶像去背呢。",
    "messageInitContent_11346": "铸体是在这里开厂了嘛",
    "messageInitContent_9145": "正确的",
    "randomEventDialogueGroupConfig_5.68": "告别",
    "messageInitContent_11349": "不许舔",
    "messageInitContent_9144": "逐个击破",
    "messageInitContent_11348": "大蛇怪这个舌头需要增强一下了",
    "messageInitContent_9143": "比蒙着速度不行啊",
    "immortalCocoonConfigName_98": "墙战",
    "immortalCocoonConfigName_97": "墙战",
    "immortalCocoonConfigName_96": "墙战",
    "immortalCocoonConfigName_95": "“富有”",
    "immortalCocoonConfigName_94": "“富有”",
    "immortalCocoonConfigName_93": "“富有”",
    "immortalCocoonConfigName_92": "“富有”",
    "immortalCocoonConfigName_91": "“富有”",
    "messageInitContent_5229": "我预言明天选人多那边",
    "messageInitContent_5228": "一通乱指",
    "immortalCocoonConfigName_99": "墙战",
    "messageInitContent_5232": "什么友谊",
    "messageInitContent_7895": "1154。你相信这个世界上有鬼魂和外星人吗？",
    "messageInitContent_5231": "来个好心大佬带带我",
    "messageInitContent_7896": "【信息不完整为确保安全实施遮盖】",
    "messageInitContent_5234": "那是亲戚",
    "messageInitContent_7893": "1.真正的深渊是【】",
    "messageInitContent_5233": "什么爱情",
    "messageInitContent_7894": "2。如果你挑战下一关了，那不要再挑战下一关",
    "messageInitContent_5236": "原来柠檬是这个味道",
    "messageInitContent_7899": "2。谜语怪兽只有1个。",
    "messageInitContent_5235": "啊？",
    "messageInitContent_5238": "想手把手教漆黑组件切后嘿嘿",
    "messageInitContent_7897": "1154。啦啦啦",
    "resoundEventStoryDes_518": "狂猎几乎是和自适应晶体的发现同时出现的。\\n当初，一条沉浸在身体改造的钢铁龙王，在进食时阴差阳错地将一块装饰用的透明晶体吃了进肚子。\\n这一吃，竟解决了困扰它多年的肢体排异问题。\\n自适应晶体的美妙用途，随着钢铁龙王无私四处炫耀变得天下皆知。\\n早期的狂猎多半是一些意外获得大量自适应结晶的怪兽。\\n它们一开始只是为了让自己能装上更多炫酷的肢体而进行狩猎。\\n那些不小心猎多了的狂猎，开始与其他狂猎进行肢体交换。\\n交易地在一处狭长的峡谷，里头漆黑一片，找不着半条光带孢子藤。\\n狂猎大多拥有黑视能力，或着早已抢得拥有黑视能力的眼睛或感官。黑暗对于狂猎而言只是个入门槛而已。\\n不久之后，这片黑暗的峡谷就成为了狂猎的固定交易点，并被取名为“黑街”。\\np.s.注意~黑街叫黑街可不是因为黑暗或者听起来很酷，而是里头黑心的狂猎特别多。\\np.s.s.黑~可是狂猎自以为傲的特质之一！",
    "messageInitContent_5237": "能不能用白虎",
    "messageInitContent_7898": "1.重复的留言是迷途者的标记",
    "resoundEventStoryDes_519": "第一则\\n来客：我脑袋掉了，还有救吗？\\n拼装师：有足够的电气区块就有救！\\n第二则\\n来客：请收我为徒，我也想成为一名独当一面的拼装师，帮怪兽装上最合适的新肢体！\\n拼装师：你对拼装师是否有点误解？\\n来客：还有各种维护调整什么的？\\n拼装师：那些只是附带的。你来这，只需要交够电气区块，咱就给你进行登记，交给拼装师联盟。接下来给你的肢体打个记号，狂猎看见了，会知道哪些可以“拿掉”，哪些不可以。我们更多是为了保护你们肢体安全而存在的，你懂吗？\\n来客：可恶，原来你们是背地勾结狂猎，收保护费的！\\n拼装师：悟性不错嘛，你这发言加上脑子标本倒是能做个有趣的装饰，就作为我告诉你行业机密的报酬，怎样~\\n来客：啊？啊——啊啊啊啊！\\n拼装师：我的乖乖，别乱动嘛，马上就给你捆好。\\n——爱瞎打听的全息小助手",
    "resoundEventStoryDes_516": "在那段对生态造成极大影响的淘晶热潮过后，为数不多仍顽强存活下来的植物，粗看是一种长条状的发光植物，常见的光带孢子藤有绿色、橙色、蓝色、紫色等。因其塑形性极好被广泛用于舛误之地各地的大型造景。",
    "resoundEventStoryDes_517": "电气区块是一种六边形发光块状物，由特殊的光带孢子藤切片制成。这种特殊光带孢子藤只在自适应晶体矿内生长，因为随身携带自适应晶体风险较高，所以通常会以一定数量的电气区块代替自适应晶体用于计数和交易。听说，一些对电气区块非常熟悉的怪兽，还能从电气区块闪烁的光中读取每次交易的信息。",
    "resoundEventStoryDes_514": "提问，眼前的这位王·狈·爷有进行过身体改造吗？\\n嘿嘿，这么问相信你肯定能猜出来，是有的！\\n那么下一问！它改造的部位是哪里呢？\\n嘿嘿，这个我会！我会猜！\\n来来，你听听这个分析哈，作为食物链顶端的怪兽，王点狈点爷的改造必要应用如今最热最新最潮最高端的改造方案！\\n全身改造方案，也称如改方案。\\n这个改造的特点就在于全身都改了，但看起来就好像没改一样，十分考验拼装怪兽的手艺。\\n作为王，保留一贯令怪恐惧的姿态自然是再好不过的。\\n特别是，从初始形态一下子裂颅亮出新肢体的瞬间！\\n而其中提升幸福感最大的改造一定是这里，舌头！\\n植入多条来自不同怪兽的舌头，感受不同怪兽的味觉差异。多么美妙呢！\\n加上舛误之地的食物因肢体改造变得更加丰富多样，对王·狈·爷来说，一定相当幸福吧。\\n仿生王·狈·爷会想象灾·赤潮的味道吗？\\n——到处贴贴的全息小助手",
    "resoundEventStoryDes_515": "未名矿产是舛误之地独有的矿产之一。\\n自适应晶体则是里面最负盛名、最受欢迎的产物，没有之一。\\n自适应晶体是一种透明的晶体，不同矿区出产的晶体颜色略有差异。\\n摄入这种晶体能大幅降低植入肢体或器官时产生的排异反应，让怪兽可以轻松适应各种改造，哪怕植入体是来自其他种族或其他生物都可以完全适应。\\n因此，舛误之地曾有过一段淘晶热潮，这一热潮给生态造成了极大的影响，使得怪兽再难窥见舛误之地的天空。\\n王及灾厄依靠它们原本的强大，自然也搜刮了不少自适应晶体。\\n而宣告这股热潮终结的漆黑组件-狂潮形态及其势力，她就像是看准时机一样占据了所有大型的未名矿区，牢牢地控制着舛误之地的大多数自适应晶体。成为了舛误之地最大的矿主。\\n如今仍有不少无法获取或抢夺自适应晶体的怪兽，抱着侥幸心四处挖掘这种晶体。",
    "messageInitContent_7891": "1153。空即是狱门",
    "resoundEventStoryDes_512": "相信你已经见过或者听说过舛误之地的狂猎了，它们是一种专门以怪兽肢体为狩猎目标的怪兽。\\n由于身体改造技术的发展，即便是王和灾有机会遭到一些无组织狂猎的围猎。\\n你看灾·星落就给自己重金打造了一个金色元核。\\n再看看王·赤色狮，它头上顶着的脑袋已经是第81个了。\\n什么？你说王·赤色狮还是原来的赤色狮吗？当然，舛误之地谁会把脑袋安在头上，不对，谁会把脑袋带在身上啊！\\n——胡说八道的全息小助手",
    "messageInitContent_7892": "【数据已丢失】",
    "resoundEventStoryDes_513": "幼兽的噩梦、恐怖的化身、大地的阴霾！\\n它们是超进化大陆的王与灾。\\n可它们却仍然无法逃离那一位的掌控。\\n你可能会问，它们就不曾有过反抗与挣扎的吗？\\n但是，你会反抗你的欲望吗？至少它们不会。\\n王·炼狱魔眼最近可喜欢那款能一刀999999999的游戏了~\\n你可能还会问，当欲望无限膨胀的时候怎么办？\\n这可不能告诉你，要是你把重置键和静音键搞反了，就麻烦啦。\\n——喜欢哔哔的全息小助手",
    "messageInitContent_5230": "V我50",
    "resoundEventStoryDes_510": "在这个肢体改造如此便利与发达的舛误之地，王·霸者只需要随便找一位拼装师，九流也好，一流也罢，将对方的安保怪兽清退，再乱吼一番，就可迅速换上一副不需要减磅的身体了！\\n如果你想说，不好好对待拼装师不怕对方在拼装身体时动手脚吗？\\n首先，做生意嘛，少得罪一只是一只。\\n再者，还得看要不要打麻药，有些怪兽使用麻药根本不起作用~而且听说关闭痛感的草药最近也制造出来了，嘿嘿。\\n回到王·霸者身上，为什么王·霸者却没有这么马上“减磅”呢！它是怎么与自己的体型和解的呢？\\n我是这么想的，满大街都是改造的怪兽，只有自己是原本的模样，不是很有个性吗！\\n就算被仿制，那它也是原型！\\n你说危险的草丛为什么要躲在R帝后面？那就不得不提关闭痛感的草药了，最近可受欢迎了，听说是从危险的草丛提取出汁液再配合强化孢子一起服用就可以了！\\n懂了吧！噢？你说这是源·危险的草丛，不是危险的草丛？\\n它确实不是，但其他危险的草丛可老爱整成它的样子了。\\n——不请自来的全息小助手",
    "messageInitContent_7890": "3。如果你还是挑战了，那么先退出登录后，再重新登录",
    "resoundEventStoryDes_511": "进化不再是漫长的锻炼与坚持！\\n进化可以变得异常快捷！只要你是那位天 选 之 兽！\\n那么成为天选之兽需要经过哪几个步骤呢？\\n首先，你要碰巧遇到了一次高强度的混战，一定要两败俱伤。\\n再碰巧捡到一大块自适应晶体。接下来将能用的肢体安到自己的身体上去！\\n这样就完成“进化”啦！\\n记得先熟悉一下新身体哦，我就记得有人把**装到了**上。咳咳。\\n之后再去拼装巢穴“登记”一波，记得找相熟的拼装师或者正规那种，不然你的东西很快就会在其他怪兽身上长出来。\\n这么看来还是稳稳进化更好呢。是吧ㄨ~\\n——胡编乱造的全息小助手",
    "98_-120001": "该邮件已读",
    "resoundEventStoryDes_520": "从未名矿场移动到情绪调节之触所在地。用时占比4.17%。\\n给情绪调节之触拨到233号、投入今天的全部工钱、并设置了七天的时长。用时占0.00231%。\\n情绪调节之触并没辜负它付出，一跟荧光的触手轻轻碰了一下它的身体。\\n享受情绪调节之触带来的美妙感受。用时占比0.0001157%。\\n从情绪调节之触所在地移动到未名矿场。用时占比4.17%。\\n在未名矿场一直挖呀挖呀挖。用时占比等于100%减去以上各项之和。",
    "messageInitContent_5239": "看起来很猛哦左边",
    "messageInitContent_5243": "柠檬树下你和我",
    "messageInitContent_5242": "柠檬树上柠檬果",
    "messageInitContent_5245": "控制变量法",
    "messageInitContent_5244": "基情何在",
    "messageInitContent_5247": "能不能秒掉还是个问题",
    "messageInitContent_5246": "先把一样的去掉",
    "messageInitContent_5249": "留下了酸酸的泪",
    "resoundEventStoryDes_529": "漆黑组件偶尔会对终极模拟的指令感到不安，每当她不安时，她就会来到这儿，这个被群山环绕的湖泊，然后从悬崖跃下，再坠入水中，这种触及边缘的冲击能迅速将她拉回现实，让她试着接受种种暧昧不明的感觉，就像是她一直想不明白，这湖上的碎屑到底是在向天空扩散，还是在往湖面聚合。",
    "messageInitContent_5248": "我觉得问题不大",
    "resoundEventStoryDes_527": "来自源初之地的不明生物，好像不小心潜过头的样子。",
    "resoundEventStoryDes_528": "只有漆黑组件认可的怪兽才可以看见的标识，原理不明。\\n怪兽可通过该标记找到漆黑组件的据点。",
    "resoundEventStoryDes_525": "天池巢穴里有很多怪兽，它们过得非常快乐，每日大伙一起吃，一块玩，没烦恼。除了有点好奇，那条管道为什么能吐出种种好吃的食物来。\\n天池巢穴里的怪兽过得非常谨慎。那条管道最近吐出来的食物越来越少了，得小心守住自己的那一份才行。\\n天池巢穴里……只剩下最后一只怪兽了，它在管道尽头消失了。\\n在环境、狂猎、矿主等各种威胁下，可以预见自然出世的怪兽数量将会持续锐减。为了改变这种现状，让一切变得更加可持续，天池巢穴应运而生。",
    "resoundEventStoryDes_526": "并非所有怪兽都会被狂猎盯上，一些也会被矿主盯上，过上终日在矿场开采的生活。\\n而那些既没有被狂猎盯上又侥幸逃开了矿主抓捕的怪兽则大多会聚集到地火巢穴。地火巢穴不是一个具体的巢穴，而是一些拥有反叛精神的怪兽组成的组织。它们四处打探情报、挖掘不在矿场的自适应结晶、招揽成员、收集那些躺在废料区的肢体，改造自己，提升战力。它们为了让反叛之火燃尽阴霾而做着努力，但不多。\\n在环境、狂猎、矿主等各种威胁下，可以预见自然出世的怪兽数量将会持续锐减。为了改变这种现状，让一切变得更加可持续，地火巢穴也应运而生。",
    "98_-120005": "该邮件已删除",
    "resoundEventStoryDes_523": "这是一块大型拼装巢穴的招牌。\\n毫无疑问充满诱惑力，看那修长而优雅的曲线！\\n什么腿？不是那个。\\n是处处透露着财力与实力的四块超大招牌的边角曲线！\\n美腿？那可不难？招牌够大可不容易了~\\n——超级懂行的全息小助手",
    "98_-120004": "该邮件没有可领取的奖励",
    "resoundEventStoryDes_524": "不朽拼装巢穴隆重推荐，最新最潮的特色项目——可视化你的生命！灵感提取自自王·炼狱魔眼脑内的游戏画面~让你和你的对手随时掌握你的生体状况。快来尝尝鲜吧，不仅可以分期付费~还附赠肢体维护等多个项目。心动不如行动！",
    "98_-120003": "该邮件奖励已领",
    "messageInitContent_5241": "这个我懂",
    "resoundEventStoryDes_521": "[]\\n当X=爱\\n[]\\n为了爱你可以做什么？\\n不惜一切！\\n那为了让大家都知道我们的爱！你愿意付出一点点电气区块吗？\\n需要多少电气区块？\\n呐~\\n这么多？\\n这点钱你都不肯为我花，你是不是不爱我？\\n怎么会，花，都可以花？\\n你太棒了，等等，为什么这欠条上面还写着我的名字？\\n爱就要在一起，干活也要在一起！\\n爱，不要你说了算，要我说了算？\\n休息时间到了，我们快回去吧。\\n[]\\n偷听爱意传播之窗旁的情侣拌嘴真的非常有意思呢！\\n爱意传播之窗的吆喝声是这样的：\\n只要一点电气区块，就可以让全世界都知道你有多么爱TA！快快申请吧！\\n根据路过的怪兽不同，它还会用不同的吆喝方式呢！\\n对了，为了这2秒的展示时间，它们需要为矿主挖2亿年的矿呢~",
    "98_-120002": "cjhwy2",
    "messageInitContent_5240": "看看是朱丽叶先挂还是罗密欧先挂了",
    "resoundEventStoryDes_522": "曾经如火如荼的淘晶热潮，使得大量产生的晶矿碎屑渗入空气，变成了隔绝了天地黑色幕布。\\n随着黑夜的越来越长，一种奇怪的景象随之在舛误之地上出现。它们没有实体，如同发光的幽灵般，突然从地表冒出来，然后消失。\\n传说那是海市蜃楼在布满晶矿碎屑的空气中的表现。也就是说，当中的景物很可能真实发生某一个角落，发生在过去现在或未来。\\n最初它们还算是吓怪的玩意，不过后来怪兽慢慢就习以为常了。\\n后来，除了那些经常更换外形的怪兽，一些怪兽不禁担心了起来，担心有一天糗事传千里。",
    "resoundEventStoryDes_530": "俺听说！这个地方能让意识和身体彻底分离，不带一丝粘连。\\n你的意识将会随着电子泉水进入新世界，灵魂将会升华。\\n真假有那么重要吗？\\n如果你的感官根本无法分清，那么真假就不那么重要了。\\n这个也是我听说的~类似的泉还有几个哦！\\n——汗如泉涌的全息小助手",
    "resoundEventStoryDes_531": "大部分怪兽都活在“边缘”，它们数量庞大可所掌握的力量却很小，它们甚至没有能力使用情绪调节之触，只能哀叹自己的不幸，将愤懑宣泄在其他地方，涂鸦就是一种较为温和的手段。而在“边缘”怪兽之中有一种发光涂料特别受欢迎。\\n它们大概一辈子都不会想到，这些涂料中混入了纠缠汁液，当它们开始涂鸦的时候，处于世界另一个角落的同款纠缠汁液也会随之“起舞”，成为小部分怪兽每日的娱乐之一。\\n——泪如泉涌的全息小助手",
    "7_1001": "{1}-留言板",
    "17_8": "你已设置了一个优先占领的图腾，是否更改？",
    "extensionTaskName_31": "提升任意怪兽技能{target}次",
    "17_7": "每{1}分钟最多设置/取消1次",
    "extensionTaskName_32": "队伍最高战力到达{target}",
    "17_6": "图腾切换",
    "17_5": "比拼数值",
    "extensionTaskName_30": "拥有已极化的觉醒怪兽{target}只",
    "17_4": "图腾",
    "17_3": "比拼方式",
    "17_2": "已被{1}击破",
    "17_1": "{1}天后开启新赛季",
    "messageInitContent_11794": "偷偷暴走",
    "messageInitContent_5254": "能不能酸酸又甜甜",
    "messageInitContent_11793": "都别抢，是我的",
    "messageInitContent_5253": "想要酸酸的恋爱",
    "messageInitContent_11796": "都是有故事的怪兽",
    "messageInitContent_5256": "造唤台忙忘了？快给我造魅妆",
    "messageInitContent_11795": "抱走",
    "messageInitContent_5255": "处在恋爱和非恋爱的叠加态",
    "messageInitContent_11790": "表白花丸子",
    "messageInitContent_5258": "等等有没有可能误会了，那是",
    "messageInitContent_5257": "这边建议你们感觉回去多造几个漆黑组件给我",
    "messageInitContent_11792": "是我的妹妹",
    "messageInitContent_11791": "我的妹妹不可能那么可爱",
    "messageInitContent_5259": "又酸了",
    "resoundEventStoryDes_538": "有时候一只怪兽的强大并不只是某个维度的强大，而是多个维度综合而言的，就是所谓的强得立体。这种立体会让某一处被突破后，仍可以拿出其他办法作为应对。要同时在多个维度上变得强大并不容易，有时候还可能会相互影响，不进反退。而幽狱沸体则意外地找到了在不同维度获得提升的合力，那就是硬控怪兽和硬控水体维持极巨化的力量。是不是觉得非常抽象呢，是的，就像是面对轻而易举的多段阻抗时，死做烂做被一波清台的那种抽象。",
    "resoundEventStoryDes_539": "在超进化大陆，保护有很多种类型，有像是灾·星落星择的减伤之力，有像是王·霸者庞大肉身的挡伤之力。这可能也王·霸者老减肥失败的原因之一，毕竟后头的小弟天天喊着：其实这个肥，咱是不建议咱霸哥减的，这样才霸气呢，是吧！",
    "resoundEventStoryDes_536": "更大的体型意味着需要更大的活动空间以减少战斗时的相互影响，因此体型越大的怪兽群，相互配合的难度就越高。\\n所以你首先会遇到赤炼零式，再是王·炼狱魔眼，再来才是源·危险的草丛。\\n虽然危险是超级加大码，但至少危险没有超级加倍。这可能也能够解释在异世界的某些作品中，反派为什么总是能被简单地逐个击破，总不会是团体战难画、方便凸显主角魅力、拖时间这类原因吧（不会吧",
    "resoundEventStoryDes_537": "就像失败或失败的情况有很多种一样，那些先被疯狂吸血再被瞬间炸飞的怪兽也有很多种抱怨。\\n就像这个，大多数时候，应对强敌的策略之一就是逃跑，但此处却是个例外。\\n所以说啊，就是说啊！为什么怪兽极巨化了？这战场却没有呢？",
    "messageInitContent_11798": "死亡在盛放",
    "messageInitContent_5250": "原来这就是酸雨形成的原因吗",
    "resoundEventStoryDes_534": "想让爱情震撼天地？赶紧极巨化起来！\\n超巨型的王相拥旋转跳跃着，不仅天地都为之震动，周围的单身怪兽也受到了物理和心灵上的双重暴击！\\n这！就是爱情的力量！\\n这就是王·罗密欧、王·朱丽叶与灾·地裂相遇后受到的启发。\\n这！就是恋爱脑的力量！",
    "messageInitContent_11797": "我有白开水，你有故事吗",
    "resoundEventStoryDes_535": "王·量子巨龙在极巨化后获得了超巨大的体型、超巨大的肚脐，也就是更大的弱点……极巨化的美妙无需多言，但那不是绝对的，至少吧，弱点不能在体型上。\\n话虽如此，但那些弱点不在体型上的怪兽，如灾·赤潮，它们的弱点也不会因极巨化而消失，更大的潮启只会迎来更大的退潮……上~就对了~",
    "messageInitContent_5252": "那什么找到你我的答案",
    "resoundEventStoryDes_532": "对于那位而言，她的感官所在，就是她控制力的所在。这些模拟全息留影的小家伙正是她感官的延伸。",
    "messageInitContent_11799": "超进化有很多惊喜",
    "messageInitContent_5251": "我的天",
    "resoundEventStoryDes_533": "在失落废墟附近被挖掘出来的组件，估计与漆黑组件是同一个系列，据推测它的指令大概只是……坐着别动或者傻笑什么的。",
    "resoundEventStoryDes_541": "这个坑述说着崩坠之地的历史。很久很久以前，天空崩坠，无数天外来石遮天蔽日般袭来，或砸向大地，或停驻天际，大地哀嚎着变化着形状，最终形成了如今深坑遍地和浮岛满天的地貌。随后，在最大的浮岛上，那棵终将彻底改变崩坠之地一切的植物，开始了持续百年的疯长，如今它被称为崩坠之柱立于天地之间。来自浮岛的原住民，它们在啃食过崩坠之柱产出的巨果后，体内爆发出一股异乎寻常的旺盛生命力，体型变得越来越巨大。为了获取更多的生存空间和领地，这些怪兽离开浮岛在各处生息繁衍，巨大体型的怪兽日渐成为了崩坠之地的优势种群。\\n不对啊坑怎么会诉说历史呢，一定是掉坑里的怪兽的胡言乱语。",
    "resoundEventStoryDes_542": "这里正是崩坠之柱的底部。崩坠之柱正如其名，仿佛是整个崩坠之地的支柱，这棵过于巨大的树，其根系一头嵌入苍穹，一头攥住大地，中间是繁茂的枝叶。中心的浮岛如今已被粗状的树枝淹没。作为这个崩坠之地唯一能产出巨果的所在，早早被不同的超巨型怪兽瓜分殆尽，它的每个区域都是有主之地。",
    "resoundEventStoryDes_540": "王·狈·爷作为食物链顶端的生物，它的食物选择总是匪夷所思的，那么更巨大的王·狈·爷，它的胃口是否也更巨大了呢，它和灾·雷鸣联手的原因不得不让怪兽怀疑，它在追求一种更危险的食物，追求一种很新的美味，一种名为带电怪兽的滋味。",
    "messageInitContent_11783": "犹豫就会败北",
    "messageInitContent_5265": "康康喵jio",
    "messageInitContent_11782": "来领饭盒吧收工了",
    "messageInitContent_5264": "康康技能！",
    "messageInitContent_11785": "怪兽已经很努力了",
    "messageInitContent_5267": "独jio兽",
    "messageInitContent_11784": "泰裤辣",
    "messageInitContent_5266": "独角兽也是jio",
    "messageInitContent_5269": "没毛病",
    "messageInitContent_5268": "是整个独角兽倒过来是吧用角走路",
    "messageInitContent_11781": "老演员了都是",
    "17_9": "同一时间只能对一个遗迹宣战",
    "messageInitContent_11780": "又要拯救世界了吗！",
    "resoundEventStoryDes_549": "这个巨大石碑上曾经有一个模糊的印记，那是发起第二次巨兽大战的怪兽聚落的印记。这个聚落最初是第一大浮岛旁的一个小浮岛，由于它们聚落的势力最为薄弱，因此它们必须团结起来，发起群攻才能勉强维持聚落的存续。第一次巨兽大战结束之际，这座浮岛被打在了崩坠之柱上面，聚落的怪兽意外地吞下了11个巨果，11位来自同一聚落的超巨型怪兽诞生。11位原本能够默契发起群攻的怪兽，意味着太多，它们在第二次巨兽大战中给无数初代和次代超巨型怪兽留下了可怕的阴影。这片区域便是其中的幸存者所统领的区域，也是目前整个崩坠之地纷争最多的区域。\\n那个印记是团结的印记，是曾经的印记，是早已被遗忘的印记。",
    "resoundEventStoryDes_547": "这个硕大无比的兽骸正是首次巨兽大战留下的。这次大战中，不少怪兽初次尝到了巨果，获得了无比巨大的体型和力量，可它们所需要的食物和领地也随之变多和变大。\\n一开始只是两只超巨型怪兽的争吵，后来越来越多超大型怪兽加入了战斗，最终演变成巨兽间的大战。那些更快适应身体，更能利用巨大带来优势的巨兽迅速结束掉了这场大战，体型相对更小的怪兽向体型更大的怪兽俯首。在这场大战中，崩坠之地有半数怪兽消失了，毕竟超大型怪兽的每一个动作，对它们而言都是可怕的灾难。",
    "resoundEventStoryDes_548": "这个倒插在地上的断崖，正是第二次巨兽大战留下的痕迹。在第一次巨兽大战后，大多数普通体型的怪兽被迫朝远离崩坠之柱的地区迁徙。仍有一些怪兽不甘于此，以身犯险获得巨果，还有一部分则是在意外中得到了天降巨果。这部分怪兽中的超巨型怪兽被称作次代超巨兽。它们一点点蚕食着原本松散且没有组织的初代超巨体型怪兽的地盘。直到不详之兽诞生，初代和次代的超巨体型怪兽们才纷纷转攻为防，划定领地，并通过承诺巨果供应的方式统治其他体型的怪兽。",
    "messageInitContent_11787": "这个关卡意头不是",
    "messageInitContent_5261": "冲冲冲",
    "resoundEventStoryDes_545": "崩坠之果是崩坠之柱的果实，被称为巨果，怪兽吃了以后体型会迅速且永久地变得巨大，能变到什么程度则有一定的随机性。虽然，巨果本身并不大，只有普通植物果实的平均大小。据说这种果实有一种独特且极具吸引力的香气。\\n而最为特别的是，它在崩坠之柱产出的位置总是不变的，就是说只需要记住曾结出过巨果的位置，以后也能在同一个位置找到。\\n自然而然，这些地方都被超巨型怪兽所占据，无一例外。这些超巨型怪兽大都是初代超巨型怪兽，也就是第一批因巨果获得最大体型的怪兽。\\n还有一部分是次代超巨型怪兽，它们多是通过以身试险或意外发现等方式，找到一些隐秘的巨果，从而获得与其他超巨型怪兽抗衡的力量。",
    "messageInitContent_11786": "进化！",
    "messageInitContent_5260": "huh？",
    "resoundEventStoryDes_546": "这里是智者在崩坠之地的研究巢穴。里头有很多关于此地的研究，这是其中一份。\\n为了便于说明，后续的说明中将吃下巨果变大的怪兽简称为巨兽。\\n巨兽按体型的量级分为超巨型、巨型、超大型、大型和其他。\\n根据不断的实践和考察发现，巨兽最后的体型和这些因素相关：原本的体型、第一个吃到的巨果上面特殊纹路“巨纹”的数量和一些运气。理论上，一次性吃下多个巨果，也只有第一个被消化的巨果能发挥作用。\\n若吃下的巨果有1个巨纹，那么吃下的怪兽就能得到1个原本体型的变大。若吃下的巨果有100个巨纹，那就能获得100个原本体型的变大。就是说如果体型本来就小，就算吃下有多个巨纹的巨果，最后也不会变得特别大。\\n而且并非所有怪兽吃下巨果都必然会变大，存在极少数无法通过吃下巨果变大的怪兽，这些怪兽被称为诅咒之兽，据说它们永远无法获得大地的祝福，关于这点，由于样本量太少，目前仍在研究之中……",
    "messageInitContent_11789": "好耶",
    "messageInitContent_5263": "喵喵快过来，我这有你喜欢的小鱼干",
    "resoundEventStoryDes_543": "崩坠之地有两个夜晚，一个是普通的夜晚，一个是崩坠之影送来的夜晚，那是崩坠之柱在大地的投影，通常在白日某个时刻出现，世界会突然暗下来一段时间。由于不同地区落下崩坠之影的时间有所不同，各个地区的第二夜传说也各有不同，而这个区域，据说若能在第二夜做第二梦，巨果就会降临。",
    "messageInitContent_11788": "一路发发",
    "messageInitContent_5262": "S属性大爆发！",
    "resoundEventStoryDes_544": "这是一只轰龙巢穴的残骸。在巨果出现前，这是崩坠之地最大浮岛上的一个隐秘洞穴。这只轰龙之所以能在那个有着不少不朽和觉醒龙族筑巢的浮岛上栖息，主要得益于它的体型，它是一只超小型的轰龙，其他龙族基本不会注意到它的存在。直到那天的来临。\\n那天，它吃下了它巢穴旁的一个有着独特香气的未知果实，随后它轻轻挥动翅膀，便来到了原本需要几百个日月才能抵达的地方。它发现周遭的风景变得豁然开朗。世界仿佛变小了，又变大了那么多……啊，如此美妙~\\n它感叹着，惊叹着，化为了灰烬。\\n作为初尝巨果的怪兽，终于在这一天，被其他龙族怪兽注意到了。",
    "immortalCocoonConfigName_54": "进化试练",
    "resoundEventStoryDes_552": "两次的大战让不少超巨型怪兽意识到，超巨型怪兽间的战斗造成的破坏实在是前所未有。且看崩坠之柱的西侧，在各种烈焰和践踏之下，早早从大地上消失，变成了没有活物的死地。而不详之兽的诞生，则成为了它们转攻为守的开端，超巨型怪兽都知道了它们无法依靠血缘延续体型的事实，而尽可能守住已有的巨果产出点似乎是目前最好的选择。还有一部分领主准备将明面上的对抗转向暗处。\\n这个巨大圆桌正是用于处理各势力关系的场所，由各领主派出代表进行商议，解决各种小纷争和防止新一次大战的到来。\\n最近一次会议上，它们讨论了各方对普通怪兽的一些想法，大多数代表的意见都是毁灭或无视，那名本想发表与普通怪兽共存互补意见的代表咽下了话语，会议在它的沉默中结束。",
    "immortalCocoonConfigName_53": "进化试练",
    "resoundEventStoryDes_553": "这是一些肉眼可见的巨大植物，它们的周围有着对应势力的怪兽进行守卫，毕竟它们完美地解决了那些超越一般怪兽体型的怪兽的食物问题。\\n这些植物原本并没有这么大，它们变大的时间点和崩坠之柱出现的时期一致，智者怀疑，这些变大的植物的根系可能是与崩坠之柱那庞大的根系有了交集，才会变得异常巨大。它同时也对崩坠之柱那不寻常的生命力来源和过于庞大的根系感到不安。它不知道这些根最后会延伸至何处。它隐约觉得荧灵与崩坠之柱的力量有着千丝万缕的关系，甚至还猜测荧灵会不会是崩坠支柱庞大根系中一块意外掉落能量块茎。",
    "immortalCocoonConfigName_52": "进化试练",
    "resoundEventStoryDes_550": "此处是崩坠之柱底部的一隅，属于超巨型怪兽三果·叉叉。这些超巨型怪兽以实控的巨果数量为荣，并将实控的巨果数量冠在了自己的名字之前。不仅是这里，这片区域，也已经早早被超巨型怪兽控制的势力瓜分殆尽。",
    "immortalCocoonConfigName_51": "进化试练",
    "resoundEventStoryDes_551": "“巨大的延续”是吞食巨果获得超巨体型的怪兽都无法逃避的问题。\\n巨大的延续问题是在初代超巨型怪兽的首次繁育中出现的。初代超巨型怪兽结合后，诞下的却是一只普通体型的怪兽。作为首只二代怪兽，它一出生就被双亲视为耻辱囚禁起来。随着越来越多超巨型的下一代诞生，所有的超巨型怪兽都意识到了一个问题，必须牢牢守住巨果。当这个秘密不再是秘密时，首只二代怪兽在一场盛大的仪式中出场，并接受其他怪兽的祝福，其双亲一起将一个百纹巨果喂入了它的口中。可是，什么都没有发生。随后它就被视为不祥之兽被双亲扔了出去。\\n此处就是它落地的位置，命运的巨果开始转动。",
    "immortalCocoonConfigName_50": "回血与否这是个问题",
    "extensionTaskName_10": "队伍最高战力到达{target}",
    "immortalCocoonConfigName_59": "进化试练",
    "immortalCocoonConfigName_58": "进化试练",
    "immortalCocoonConfigName_57": "进化试练",
    "immortalCocoonConfigName_56": "进化试练",
    "immortalCocoonConfigName_55": "进化试练",
    "extensionTaskName_17": "斗技场到达{target}分",
    "messageInitContent_11772": "验光模拟器",
    "messageInitContent_5276": "你们知道吗，很多时候会喵喵的都不是猫",
    "extensionTaskName_18": "进行主城搬迁{target}次",
    "messageInitContent_11771": "煮开水模拟器",
    "messageInitContent_5275": "喵喵喵喵喵喵喵喵喵喵喵喵喵喵喵喵喵喵",
    "extensionTaskName_15": "拥有{target}只基因强化+{conditionVal}或以上的怪兽",
    "messageInitContent_11774": "烟花模拟器",
    "messageInitContent_5278": "我是一拳超喵",
    "extensionTaskName_16": "在狩猎商店购买任意道具{target}次",
    "messageInitContent_11773": "烧烤模拟器",
    "messageInitContent_5277": "咪咪咪咪咪咪",
    "extensionTaskName_13": "拥有{target}只{conditionVal}阶或以上的神灵",
    "extensionTaskName_14": "拥有{target}个{conditionVal}级或以上的元核",
    "messageInitContent_5279": "谈恋爱吗？二缺一",
    "extensionTaskName_11": "在部落商店购买任意道具{target}次",
    "messageInitContent_11770": "你们别过来啊",
    "extensionTaskName_12": "在饲星商店中购买万能碎片{target}次",
    "messageInitContent_11779": "火晶怎么了！",
    "messageInitContent_5270": "轻轻松松又一天",
    "resoundEventStoryDes_558": "这里正是沸湖的所在，幽狱沸体和其他沸体的故乡，无名岛屿！对岸那些通过吃下巨果变大的怪兽通常称这个岛为靶子岛，因为岛心的中心湖正是它们平时抛出普通体型怪兽的绝佳比试场所，在比试之中，谁能将更多的怪兽丢进中心湖，谁就能够获胜。这就是沸湖和无名岛屿的另一面。",
    "resoundEventStoryDes_559": "如题。\\n这只走路不看路只顾着思考的怪兽，不小心摔到了一个沸体集群内。\\n它思考的问题也很简单：巨大化能否有效应对可能出现的环境剧变呢，毕竟在天外来石后，崩坠之地的稳定气候和环境已经持续了相当之久，这些巨大怪兽也占据食物链顶端相当久了，久到以为巨大化就是足以不断存续的强大……直到剧变真正到来的那一天，它们才能察觉到那把早已悬在头顶的达摩克利斯之剑吗？",
    "messageInitContent_11776": "嗯？幻兽帕鲁？",
    "messageInitContent_5272": "喵响石我家的",
    "resoundEventStoryDes_556": "吞食巨果后，并非只有怪兽才会变大，其他生物也会。例如这个已化作海中之岛的不知道啥生物的壳，其精细的结构在巨大化后成为了一处复杂的天然隧洞，不少普通体型的怪兽就藏身在这座螺旋宫殿之中。\\n在经历了两次巨兽大战的如今，其中一部分怪兽打算永远生活在螺旋宫殿中，而另一部分怪兽则不一样，在这片巨大即是强大的大陆上，它们仍没有放弃寻找其他进化的可能，抱着终有一日要夺回自己巢穴的目标，不断地锻炼着，尝试抵达巨大以外的各种可能，极致的迅捷，极致的柔软，极致的进化……传说中的初代不祥之子，那只被双亲扔出去的怪兽正是这里的首领，它想要带领更多的怪兽，打破强大与体型成正相关的参考系，在极巨化以外的维度获得突破。",
    "messageInitContent_11775": "通关模拟器",
    "messageInitContent_5271": "感受到了吗，我家喵响的可爱",
    "resoundEventStoryDes_557": "请注意安全！这是一只不知名的海兽吃下巨果后的样子，原本可以在这片区域自由穿梭的它就这样卡在了原地，仅靠着为数不多的能自由活动的触手寻找食物，过着一边泡岩浆，一边泡海水的悠闲生活。",
    "extensionTaskName_19": "好友人数达到{target}或以上",
    "messageInitContent_11778": "到底是怎样没看懂",
    "messageInitContent_5274": "喵喵",
    "resoundEventStoryDes_554": "这是一个不同于幽狱沸体的沸体集群。它们同样选择了离开沸湖，在崩坠之地各处冒险。这个沸体集群似乎特别喜欢这个位置，于是就这样一直摊着不愿离开。如果仔细看到话，就会发现，它和幽狱沸体的形状并不一样。因为沸体集群的确能够变成任何它们想要和能实现的形状。最为知名的沸体集群——幽狱沸体，它现在的形态正是它最熟习的形状之一。",
    "messageInitContent_11777": "哦？打工怪兽",
    "messageInitContent_5273": "喵喵喵喵喵喵喵喵喵喵喵喵",
    "resoundEventStoryDes_555": "这是崩坠之地众多浮岛中的一个，也是最为特别的一个，这是一个会移动的浮岛。这座浮岛上的大多数怪兽，都因巨兽大战带来的混乱而离开了原来生活的区域，并在机缘巧合之中登上了这座浮岛。\\n这座浮岛的移动力源自于一条巨大的轰龙。\\n一切要从那天说起，那天是第一个巨果成熟的日子，也是巨兽战争的之前，当时，一只轰龙正以仰式在空中飞翔，恰巧一个巨果从天而降落入了它的嘴里，同一时间还有一只焦黑的轰龙狠狠地砸到了它的脑袋上。就这样，这只变巨的轰龙晕头转向地落在了浮岛之上。当时浮岛上的怪兽只当它是体型比较大的怪兽，纷纷热心帮忙喂治。从此以后，这只巨轰龙就赖上了这座浮岛上。它的脑子似乎因为之前的被撞，导致不太好使，只能勉强听得懂一些简单的指令。岛上的怪兽则通过指令指挥巨轰龙拖动浮岛，前往各处。\\n也正是因为这只巨轰龙的存在，其他超巨型也不会轻易找这个浮岛的麻烦，因此，这里成了崩坠之地为数不多的普通体型怪兽的乐土。",
    "immortalCocoonConfigName_65": "全体强化",
    "resoundEventStoryDes_563": "关于炼狱的恐怖传言有不少，据智者说，不在它店里购物的怪兽死后会被放逐至炼狱，感受永世无法逃离的痛苦与折磨。王·炼狱魔眼震慑怪兽的力量会不会是一种视野的共享，它的对手正是被迫看到了炼狱的恐怖景象，因而动弹不得。",
    "immortalCocoonConfigName_64": "全体强化",
    "resoundEventStoryDes_564": "有时候恐怖就埋藏在问题底下，例如杀死赤潮的究竟是什么？王·霸者减肥的目的又是什么？",
    "immortalCocoonConfigName_63": "全体强化",
    "resoundEventStoryDes_561": "最恐怖的地方在于未知，而你永远无法预知源·危险的草丛的背后会藏着些什么，如果藏在它背后的是无数的源·危险的草丛，那么未知的恐怖将会呈几何级数增加。\\n如果你碰巧发现了藏着它背后的王·罗密欧和王·朱丽叶，那么王·罗密欧和王·朱丽叶会摆出什么造型，更是另一种毛骨悚然的恐怖。",
    "immortalCocoonConfigName_62": "全体强化",
    "resoundEventStoryDes_562": "大多数怪兽都会简单地将灾·地裂的“地裂”理解为过强的力量导致大地都为之碎裂。但真的是这样的吗？这个裂，并非地裂，而是分裂之意，至于它是从什么东西里头分裂出来的，还是说只要满足某些诡异的条件，它就能无限裂变，那就不得而知了。",
    "immortalCocoonConfigName_61": "全体强化",
    "immortalCocoonConfigName_60": "全体强化",
    "resoundEventStoryDes_560": "怪兽们习惯将一切无法解释的东西都抛向宇宙~因此一些过于异常的怪兽个体，总是会被其他怪兽当作异星来客。\\n就像是灾·星落，它的降临并非简单的坠落，而是逃离，为了逃离那个被所有星球用于抛弃难以名状之物的宇宙，那片它在其中永远无声扭动的宇宙。",
    "extensionTaskName_20": "在一发入欧店购买任意道具{target}次",
    "extensionTaskName_21": "获得觉醒怪兽{target}只",
    "immortalCocoonConfigName_69": "神性集合",
    "immortalCocoonConfigName_68": "全体强化",
    "immortalCocoonConfigName_67": "全体强化",
    "immortalCocoonConfigName_66": "全体强化",
    "extensionTaskName_28": "把录像分享到世界频道{target}次",
    "messageInitContent_11761": "尚未毕业",
    "messageInitContent_5287": "有猫病",
    "extensionTaskName_29": "在部落遗迹中挑战任意探索者{target}次",
    "messageInitContent_11760": "勇士？！",
    "messageInitContent_5286": "大力出奇迹",
    "extensionTaskName_26": "在饲星坛进行碎片转化{target}次",
    "messageInitContent_11763": "别哭它只是怪兽不是鬼",
    "messageInitContent_5289": "邪魅一笑",
    "extensionTaskName_27": "拥有{target}只基因强化+{conditionVal}或以上的怪兽",
    "messageInitContent_11762": "跳过跳过跳过",
    "messageInitContent_5288": "这个力度",
    "extensionTaskName_24": "与其他探索者进行联结共鸣{target}次",
    "extensionTaskName_25": "在进化树使用便捷进化{target}次",
    "extensionTaskName_22": "拥有{target}只{conditionVal}阶或以上的神灵",
    "extensionTaskName_23": "拥有{target}个{conditionVal}级或以上的元核",
    "messageInitContent_11769": "你好像不小心把什么发群里了",
    "messageInitContent_11768": "流量套餐已超标",
    "messageInitContent_5281": "你好怪哦",
    "resoundEventStoryDes_569": "在这片睡着就会遭遇不可名状侵袭的诡潮之地，那些无需睡眠还能保留旺盛精力的怪兽是难得的幸运儿。它们大多有旺盛的精力，以及与其精力相匹配的巨大好奇心。在这份好奇心的驱动下，它们确实地行动起来，到处探究诡潮之地。它们就像是被未知和谜团的腐臭吸引的秃鹫，一只只扑向自身绝对意想不到的深渊。",
    "messageInitContent_5280": "养猫吗？我是猫",
    "messageInitContent_11765": "不是你不努力",
    "messageInitContent_5283": "让我错一天好吗",
    "resoundEventStoryDes_567": "《失落的记录》是一本异常古老的典籍，现在流传的是其残本碎片，其原本的下落已不得而知。里面尽是各类无法实证的描述，似是而非的幻想，不堪入目的游仪，将怪兽引入噩梦的提问，对疯狂的赞颂，对某个存在的暗示。对于一些部落而言，它是不可言说的邪恶禁忌，通往疯狂的密道，应当立即销毁的污秽。可诡异的是，不管经过怎样的摧毁，它都能再次出现各个隐秘的角落，出现在那些充满好奇的怪兽手上。\\n此外，还有小部分是后世怪兽修改创作的伪本，这部分通常是一些较为无害的改写或是仿写，虽然危害大可不计。",
    "messageInitContent_11764": "随机之神请对我好点",
    "messageInitContent_5282": "让我猜对1天好吗",
    "resoundEventStoryDes_568": "诡潮之地的其中一个别称正是不眠巢穴。因为对于诡潮之地的大多数怪兽而言，睡眠都是一件异常困难的事情。只要睡着了就会做梦，而梦在这里并不只是在熟睡中的风景，而是一扇厚重的大门。穿越梦之门后，它们将成为████的██，永远永远地受到奴役。虽然它们醒后无法记得梦中发生了什么，可疲惫得无法动弹的躯体和那股挥之不去的呕吐感将久久萦绕着它们。而躲开这种梦之后遗症的最简单的方法，自然就是醒着。",
    "messageInitContent_11767": "明天就要交作业了，但你还没开始做",
    "messageInitContent_5285": "有朱雀！",
    "resoundEventStoryDes_565": "大多数怪兽都是在与周围的怪兽的不断交互中迈向成年，迈向死亡的，这些交互包括交流，战斗，对抗，合作等等。这些来自周遭的反馈能够让怪兽感知到“我”的存在，感受到自己的形状，实现另一种意义上的成熟。可是，如果那是一只无法被任何怪兽记住的怪兽，那它会怎么样？它会孤独吗？它能借助极度显浅且重复不断的反馈认知自己吗？它能与普通怪兽一样正常活着吗？它会变成怎样的异类呢？",
    "messageInitContent_11766": "你好，你的工资到账0元",
    "messageInitContent_5284": "苍天绕过谁",
    "resoundEventStoryDes_566": "在一些阴暗的角落中，有着这样的传闻，那些被王·狈·爷消化过的食物，在离开王·狈·爷身体后，变得更生龙活虎地，四处游荡。它们眼神空洞，身上挂满腥臭的黏液，长着和王·狈·爷身后那肥厚触手类似的东西。难道王·狈·爷的消化道通往的不是他的胃，而是一个禁忌的国度？亦或是说，这个王·狈·爷已经不再是原本的它……",
    "immortalCocoonConfigName_76": "神性集合",
    "resoundEventStoryDes_574": "那是两块密密麻麻刻满东西的石头，理应没有生命的石头却不知为何在腐化……",
    "immortalCocoonConfigName_75": "神性集合",
    "resoundEventStoryDes_575": "我是咻咻中的异类，在这个大家都不愿意相互接触的世界里，我却爱上了她，她是一只美杜莎莎，她是我的女神，而碰巧她也喜欢着我。在牵起了她的蛇发那一刻我甚至有一种死而无憾的感觉，可现实是如此残酷，一想到有一天，突然出现的海底移变将使我们分离，我便痛苦不已。那时，我突然想起那日与一只调查兽的对话。虽然在这片总在变化的大陆上，地图这个词显得如此地可笑，但它给我的确实是张地图。上面记录着不动隧口的一切。爱就是这样短暂地蒙住了我眼前的恐惧，将我们带到了不动隧口前。",
    "immortalCocoonConfigName_74": "神性集合",
    "resoundEventStoryDes_572": "瑚珊是一种水陆混生的“海树”，在陆地和海底都可以常常看见它们的踪迹，有着类似布满细孔的骨头的质感，大多数时候呈海蓝色。这里的怪兽都会随身带一块小的瑚珊在身上，因为瑚珊震颤就意味着海地即将移变。",
    "immortalCocoonConfigName_73": "神性集合",
    "resoundEventStoryDes_573": "如果一片区域不断变动是常态，不变的地方就会成为那片区域最为异常的地点。如果怪兽知道无论与谁建立了亲密的联系后，都可能因海底移变与对方永生不得相见，那它还会选择结识身边的怪兽吗？如果万一不小心一只怪兽和另一只怪兽成为了伴侣，发誓誓死不渝，那么它们能选择的地方就只有那些不变的地方，例如这处看不见尽头，却听得见里头传来种种如同失去舌头的嘶哑怪声的隧口。",
    "immortalCocoonConfigName_72": "神性集合",
    "resoundEventStoryDes_570": "在诡潮之地，海与大陆之间的交界异常地模糊，陆地可能会瞬间变为海底，海底亦有可能瞬间变成地面。这里海底会突然升起成为地面，地面也可能瞬间沉入，变成海底。是的，萦绕诡潮之地的浓厚腐臭正是由此而来，那是大量无法适应压力变化的海底生物被死亡突然腐蚀后，所散发出来的气味。这种海底倒转的现象被称为海地移变。仍没有怪兽解明这背后的原理，更无法预知在这诡变之后，出现在它们身旁的会是什么……",
    "immortalCocoonConfigName_71": "神性集合",
    "resoundEventStoryDes_571": "在诡潮之地的活物几乎没有不会游泳的，因为不会游泳的怪兽基本无法在这里生存。毕竟谁都无法保证海底或地面会在什么时候什么地点，突然出现或消失。唯一值得庆幸的是，怪兽可以像在陆上一样在海中呼吸。",
    "immortalCocoonConfigName_70": "神性集合",
    "dailyTaskName_1": "任意怪兽提升{target}级",
    "dailyTaskName_5": "击破复制体{target}次",
    "dailyTaskName_4": "黑暗森林探索{target}次",
    "immortalCocoonConfigName_79": "“经验”",
    "dailyTaskName_3": "任意元核强化{target}次",
    "immortalCocoonConfigName_78": "“经验”",
    "dailyTaskName_2": "任意怪兽基因强化{target}次",
    "immortalCocoonConfigName_77": "神性集合",
    "messageInitContent_11750": "不愿细想",
    "messageInitContent_5298": "叉叉又是门卫",
    "messageInitContent_5297": "小别致",
    "messageInitContent_11752": "那是个怎样的国度",
    "messageInitContent_11751": "要通关吗？",
    "messageInitContent_5299": "你就是巨无霸的好兄弟",
    "messageInitContent_11758": "数量就是正义",
    "messageInitContent_5290": "睁开眼答案就会显现",
    "messageInitContent_11757": "什么战术？不知道",
    "messageInitContent_5292": "跟风路过",
    "messageInitContent_11759": "别被偷家了",
    "messageInitContent_5291": "人多还是人少啊",
    "messageInitContent_11754": "我不是这个意思",
    "messageInitContent_5294": "这只叉叉有点东西",
    "resoundEventStoryDes_578": "美杜莎莎再次见到咻咻是它踏入隧道后不久，不久准确来说是数个眨眼。美杜莎莎与它蛇发上的眼睛简直不敢相信，如此短短一个瞬间，可以让一只怪兽有如此之大的变化，她本想扑过去抱紧那只为了它们未来勇闯恐隧的怪兽，可咻咻身上愈加剧烈的可怕变化让她颤抖不已，她忍不住跌坐在地频频倒退。咻咻的身上刻满了扭曲的符号，一层灰白色的东西附着在它的身体上，它逐渐缩小，最后变成一块只有双眼的如同石头一般的硬块，她多么希望这一切只是她的臆想，可它能做到的只有尖叫。",
    "messageInitContent_11753": "给你防腐剂",
    "messageInitContent_5293": "叉叉再次欢迎你",
    "resoundEventStoryDes_579": "游仪通常刻在一些腐石之上。上面记载着关于不可名状存在的亵渎之语，它教导怪兽如何通过在水中进行特定的不规则游动和各种不可言说的行为，与一些邪恶无比的东西取得联系。我当初正是因为好奇捧起了一块腐石，看到了上面刻着的内容，而刚刚我所说的一切，现在应该正在另一块腐石上面吧……",
    "messageInitContent_11756": "什么你也有电脑课",
    "messageInitContent_5296": "新大陆！",
    "resoundEventStoryDes_576": "我是美杜莎莎中的异类，我和一只咻咻相爱了。在一起后的次日，它将它内心的恐惧说了出来，果然和我想的一样，我们都害怕分开。我们是幸运的，在前往它口中的永远不会变化的家园——不动隧口的路上，我们没有遇上海地移变，顺利地抵达了那里。我不知道该如何形容那个隧口的种种诡异，总之一靠近我就觉得异常害怕，我可以感觉到咻咻也在颤抖，可能是我们的爱压制住了它的恐惧，它没有听我的劝，还是独自进去探索了，它答应一定会回来接我。在它眯起的眼中，我看到了一股跃动的狂热。于是，我便眼睁睁地看着它踏入到了那可怖的隧道之中。",
    "messageInitContent_11755": "死去的回忆开始攻击我",
    "messageInitContent_5295": "崩坠之地！",
    "resoundEventStoryDes_577": "咻咻踏入隧道的动机并不完全像它想的那样，为了它和美杜莎莎的未来，它被隧道中某个声音吸引了，在美杜莎莎听起来是不似怪兽的绝叫，在它听来是无比诱惑的魔音。在万变的世界中唯一不变的隧道，就在它脚下。初时，隧道是黑暗的，随着眼睛的渐渐适应，它开始能看见隧壁上的浅浮雕。那是它从未见过的东西，和任何它见过的生物都截然不同，那是无比可怕的邪物。它开始感到恐惧，只可惜那是兴奋还稍稍压了恐惧一头。随着它的深入，它时而可以看到在隧道中穿行的自己，时而看到自己未来的转变，时而看见自己哭着逃亡……直至它失去意识。",
    "immortalCocoonConfigName_87": "“富有”",
    "resoundEventStoryDes_585": "来到这个节点时，以下规则自然而然地浮现在你的脑海。\\n【七段谜题的串联是世界遗落的馈赠，不要试图破解谜题，它会夺走你的时间，破坏你的实感】【若在死路徘徊，谜题则是脱出的关键】【错乱引你至迷途，循序而行方可抵达终点】【脱出点并非盒中少女】\\n【Ⅰ：？Ⅱ：？ Ⅲ：？】",
    "immortalCocoonConfigName_86": "“经验”",
    "resoundEventStoryDes_586": "来到这个节点时，以下规则自然而然地浮现在你的脑海。\\n【七段谜题的串联是世界遗落的馈赠，不要试图破解谜题，它会夺走你的时间，破坏你的实感】【若在死路徘徊，谜题则是脱出的关键】【错乱引你至迷途，循序而行方可抵达终点】【脱出点并非糖心反面】\\n【Ⅰ：？Ⅱ：？ Ⅲ：？】",
    "immortalCocoonConfigName_85": "“经验”",
    "resoundEventStoryDes_583": "那是一个沉睡的巨大生物的一个部分，它的鼾声混合了幼兽啼哭和将死之兽的呻吟声，它的翻身会导致整个区域的毁灭，怪兽日夜不停地进行着扭曲的祈祷和献身，只求毁天灭地的梦游之日不会来临。",
    "immortalCocoonConfigName_84": "“经验”",
    "resoundEventStoryDes_584": "这些半透明状的晶石，如同活物的眼眸一样，总在不停地转动。",
    "immortalCocoonConfigName_83": "“经验”",
    "propConfigName_90302": "白色生物屏障元核碎片",
    "resoundEventStoryDes_581": "还记得出现在源初之地和崩坠之地的海中异兽吗？或许之前的怪兽们一直都搞错了，它并非在源初之地来到崩坠之地，它是从诡潮之地延伸到其他位面，这里才是它真正的故乡。",
    "immortalCocoonConfigName_82": "“经验”",
    "messageInitContent_11739": "我膝盖中了一箭",
    "resoundEventStoryDes_582": "只有俯瞰才可以发现，这是一块满是脏污的贝壳状巨物，那是深海某个存在的寝宫。上面是各种生物狰狞面容的浮雕，异常的栩栩如生……",
    "immortalCocoonConfigName_81": "“经验”",
    "immortalCocoonConfigName_80": "“经验”",
    "resoundEventStoryDes_580": "不可以简单根据对其他位面的怪兽的印象去看待诡潮之地的怪兽，它们终日受到无孔不入的异常环境侵袭，加上长年无法入睡，大多数怪兽的精神状态已处在崩溃边缘，即便是那些精力旺盛不受困倦影响的怪兽也不例外，它们依靠高昂的亢奋维持着最后一丝理智，而在那根理智丝线断裂之时，它们将坠入更深恐怖之中。",
    "immortalCocoonConfigName_89": "“富有”",
    "immortalCocoonConfigName_88": "“富有”",
    "dailyTaskName_9": "消耗战令{target}次",
    "dailyTaskName_8": "斗技场挑战{target}次",
    "dailyTaskName_7": "挑战暴走旷野{target}次",
    "messageInitContent_11741": "你发工资？",
    "dailyTaskName_6": "通关永生之茧{target}次",
    "messageInitContent_11740": "怪兽们下班啦，回去吧",
    "immortalCocoonConfigName_90": "“富有”",
    "messageInitContent_11747": "只是想看沿途风景",
    "propConfigName_90306": "橙色生物屏障元核碎片",
    "messageInitContent_11746": "我不适合战斗，我会打字",
    "propConfigName_90305": "紫色生物屏障元核碎片",
    "messageInitContent_11749": "装填中",
    "propConfigName_90304": "蓝色生物屏障元核碎片",
    "messageInitContent_11748": "不说了开始吧",
    "propConfigName_90303": "绿色生物屏障元核碎片",
    "messageInitContent_11743": "直到世界的终结",
    "resoundEventStoryDes_589": "来到这个节点时，以下规则自然而然地浮现在你的脑海。\\n【七段谜题的串联是世界遗落的馈赠，不要试图破解谜题，它会夺走你的时间，破坏你的实感】【若在死路徘徊，谜题则是脱出的关键】【错乱引你至迷途，循序而行方可抵达终点】【脱出点并非齿轮正中】\\n【Ⅰ：？Ⅱ：？ Ⅲ：？】",
    "messageInitContent_11742": "奖励我来啦",
    "messageInitContent_11745": "你的齿轮掉了",
    "resoundEventStoryDes_587": "来到这个节点时，以下规则自然而然地浮现在你的脑海。\\n【七段谜题的串联是世界遗落的馈赠，不要试图破解谜题，它会夺走你的时间，破坏你的实感】【若在死路徘徊，谜题则是脱出的关键】【错乱引你至迷途，循序而行方可抵达终点】【脱出点并非大炮管口】\\n【Ⅰ：？Ⅱ：？ Ⅲ：？】",
    "messageInitContent_11744": "没有隐藏门，我已经撞了一小时墙",
    "propConfigName_90307": "红色生物屏障元核碎片",
    "resoundEventStoryDes_588": "来到这个节点时，以下规则自然而然地浮现在你的脑海。\\n【七段谜题的串联是世界遗落的馈赠，不要试图破解谜题，它会夺走你的时间，破坏你的实感】【若在死路徘徊，谜题则是脱出的关键】【错乱引你至迷途，循序而行方可抵达终点】【脱出点并非手中的卷轴】\\n【Ⅰ：？Ⅱ：？ Ⅲ：？】",
    "immortalCocoonConfigName_10": "尸狂开骚",
    "messageInitContent_11729": "这战斗怎么这么难，那不是战斗那是过场",
    "messageInitContent_11728": "那不是剧情，那是战斗",
    "immortalCocoonConfigName_18": "答应我别舔",
    "messageInitContent_7804": "1.带有.的规则一般是正确的，可以相信",
    "immortalCocoonConfigName_17": "当心中暑",
    "messageInitContent_7805": "1133。沸体体内的第6个月亮就是出口",
    "immortalCocoonConfigName_16": "此处没有梯子",
    "messageInitContent_7802": "【信息被涂鸦】",
    "immortalCocoonConfigName_15": "花丸破坏炮",
    "messageInitContent_7803": "静冷持保前战挑在请。0",
    "immortalCocoonConfigName_14": "龙“凤”呈祥",
    "messageInitContent_7808": "4.部分规则遭到了篡改不再是原来的留言",
    "immortalCocoonConfigName_13": "有神助攻",
    "messageInitContent_7809": "3.带有，的规则是假的要注意甄别",
    "immortalCocoonConfigName_12": "各族搭配打架不累",
    "messageInitContent_7806": "【信息被涂鸦】",
    "immortalCocoonConfigName_11": "别打我律师",
    "messageInitContent_7807": "1133。你见过有脖子的飞头蛮吗，如果见到了请捂住脖子",
    "messageInitContent_11730": "什么水杯战争",
    "messageInitContent_7811": "【信息不完整为确保安全实施遮盖】",
    "messageInitContent_7812": "1134。突破口有三个",
    "immortalCocoonConfigName_19": "点菜",
    "messageInitContent_7810": "1134。叠加的空间是拥有渗透的入口",
    "messageInitContent_11736": "有啥表演呢",
    "messageInitContent_11735": "悬着的心还是碎了",
    "messageInitContent_11738": "影曜表演什么？射箭吗",
    "messageInitContent_11737": "KB侠表演一下你的手速",
    "messageInitContent_11732": "来我帮你",
    "messageInitContent_11731": "我的魔力急需补充",
    "messageInitContent_11734": "可以了演到这里",
    "messageInitContent_11733": "你不要过来啊",
    "immortalCocoonConfigName_21": "反了你",
    "immortalCocoonConfigName_20": "双头奖",
    "messageInitContent_11718": "战术性进食",
    "messageInitContent_11717": "战术性变身",
    "messageInitContent_11719": "战术性挑战",
    "immortalCocoonConfigName_29": "白虎：？？？",
    "messageInitContent_7815": "守遵可不常通那，”须必“到提中则规果如。1",
    "immortalCocoonConfigName_28": "对墙打拳",
    "messageInitContent_7816": "1136。只能等盒子自己打开",
    "immortalCocoonConfigName_27": "暴君与狐仙",
    "messageInitContent_7813": "【该信息无法被识别】",
    "immortalCocoonConfigName_26": "燃烧的沼泽",
    "messageInitContent_7814": "1134。不必纠结哪个才是花丸子的头部",
    "immortalCocoonConfigName_25": "光影之象",
    "messageInitContent_7819": "转反而染污因会则规分部.0",
    "immortalCocoonConfigName_24": "躲后面有用？",
    "immortalCocoonConfigName_23": "光速变脸",
    "messageInitContent_7817": "【该信息无法被识别】",
    "immortalCocoonConfigName_22": "陷入永生的漩涡",
    "messageInitContent_7818": "1136。只能等盒子自己关上",
    "messageInitContent_7822": "2。谜语怪兽只有1个。",
    "messageInitContent_7823": "【##############】",
    "messageInitContent_7820": "1。切勿击杀第六只怪兽",
    "messageInitContent_7821": "1137。两只叉叉的进化体碰面可能会发生【】",
    "messageInitContent_11725": "这游戏规则说明书为什么那么厚",
    "messageInitContent_11724": "继续打啊啊",
    "messageInitContent_11727": "这游戏剧情为什么这么长",
    "messageInitContent_11726": "那不是规则，是剧本",
    "messageInitContent_11721": "无尽生存模式！",
    "messageInitContent_11720": "什么时候整个无尽暴走模式",
    "messageInitContent_11723": "但饿了",
    "messageInitContent_11722": "一战到天命",
    "immortalCocoonConfigName_32": "巨大炮流灵",
    "versionPackName_1.8": "海鸣起礼遇",
    "immortalCocoonConfigName_31": "回血是不可能回血的",
    "versionPackName_1.9": "嬉游夜礼遇",
    "immortalCocoonConfigName_30": "妹兄",
    "messageInitContent_11707": "我宣布这里我占了",
    "messageInitContent_11706": "这个小荒岛",
    "messageInitContent_11709": "晚安大小姐",
    "messageInitContent_11708": "让我康康",
    "messageInitContent_7826": "1138。颜色是可以被计数的",
    "immortalCocoonConfigName_39": "金翅威水鸟",
    "messageInitContent_7827": "【信息被隐藏】",
    "immortalCocoonConfigName_38": "开盒（物理）",
    "messageInitContent_7824": "戏游新重启立，刻即，疑迟何任有若，后下按。8",
    "immortalCocoonConfigName_37": "御草",
    "messageInitContent_7825": "1138.她是这关唯一的赤色",
    "versionPackName_1.3": "赛博环礼遇",
    "immortalCocoonConfigName_36": "多重自爆",
    "versionPackName_1.4": "源裂变礼遇",
    "immortalCocoonConfigName_35": "吸血比蒙",
    "versionPackName_1.5": "半周年礼遇",
    "immortalCocoonConfigName_34": "持久战",
    "messageInitContent_7828": "用适再不则规；后成完战挑关卡在。1",
    "versionPackName_1.6": "盛夏诞礼遇",
    "immortalCocoonConfigName_33": "一条龙",
    "messageInitContent_7829": "1,带关卡数字的是关卡独特规则",
    "versionPackName_1.7": "启程季礼遇",
    "messageInitContent_7830": "2.带有。的规则是假的要注意甄别",
    "messageInitContent_7833": "1139。不要提起美杜莎鲨",
    "messageInitContent_7834": "1139。不用提起妖焰",
    "messageInitContent_7831": "3。如果你还是挑战了，那么先退出登录后，再重新登录",
    "messageInitContent_7832": "1139。不要提起美杜莎莎",
    "messageInitContent_11714": "欢迎来到玖璃的夜宵店",
    "messageInitContent_11713": "来来来",
    "messageInitContent_11716": "战术性喝水",
    "messageInitContent_11715": "战术撤退",
    "messageInitContent_11710": "总算见到你了圣堂武士",
    "messageInitContent_11712": "我先来",
    "messageInitContent_11711": "不许插队",
    "immortalCocoonConfigName_43": "二人世界也不错",
    "immortalCocoonConfigName_42": "双拳头与双盾",
    "immortalCocoonConfigName_41": "龙之谷",
    "immortalCocoonConfigName_40": "无偿献血",
    "messageInitContent_7837": "1140.用你的幻想对抗这个世界",
    "messageInitContent_7838": "1140.用你的幻想驱逐世界的幻想",
    "immortalCocoonConfigName_49": "复眼plus",
    "messageInitContent_7835": "1140。如果比亚将他手上的书递给你，千万不要接过去",
    "immortalCocoonConfigName_48": "奶品丰富",
    "messageInitContent_7836": "2。如果你挑战下一关了，那不要再挑战下一关",
    "immortalCocoonConfigName_47": "厄加丘比特",
    "immortalCocoonConfigName_46": "幻神在此",
    "immortalCocoonConfigName_45": "Eyes on me？",
    "messageInitContent_7839": "1.带有.的规则一般是正确的，可以相信",
    "immortalCocoonConfigName_44": "皮皮皮",
    "messageInitContent_7840": "1141。馆长知道一切秘密",
    "messageInitContent_7841": "2。谜语怪兽只有1个。",
    "messageInitContent_7844": "【信息不完整为确保安全实施遮盖】",
    "messageInitContent_7845": "1143。此关不宜许愿。",
    "messageInitContent_7842": "【无法正确显示】",
    "messageInitContent_7843": "1141。馆长在【】",
    "messageInitContent_11703": "可以用吃的引开boss然后偷袭",
    "messageInitContent_11702": "如果我是你",
    "messageInitContent_11705": "喔吼",
    "messageInitContent_11704": "我懂得，我当然懂",
    "messageInitContent_11701": "什么都吃只会害了它",
    "messageInitContent_11700": "死去的记忆在攻击我",
    "15_2030": "队长才能出击",
    "15_2031": "刷新",
    "15_2036": "请输入4-6个字符的房间ID号",
    "messageInitContent_7848": "1143。此关不宜交友",
    "15_2037": "首通关卡",
    "messageInitContent_7849": "戏游新重启立，刻即，疑迟何任有若，后下按。8",
    "15_2038": "凿星裂痕当前通关",
    "messageInitContent_7846": "1143。此关不宜进食",
    "messageInitContent_7847": "8，按下挑战后，若有任何迟疑，立刻重启游戏",
    "15_2032": "快速加入",
    "15_2033": "邀请",
    "15_2034": "不足5只怪兽无法开始战斗",
    "15_2035": "无可加入的队伍",
    "messageInitContent_7851": "【没有阅读权限】",
    "messageInitContent_7852": "1144。不要在此关放入任何猫科动物",
    "messageInitContent_7850": "秒三睛眼上闭请，前战挑在。001",
    "15_2029": "踢出队伍",
    "messageInitContent_7855": "1145。找到喀戎的最后一只脚",
    "messageInitContent_7856": "1145。或者带白子找到黑子",
    "messageInitContent_7853": "1144。不要在此关放入任何猫科动物",
    "messageInitContent_7854": "3.带有，的规则是假的要注意甄别",
    "messageInitContent_7859": "【信息不完整为确保安全实施遮盖】",
    "messageInitContent_7857": "1,带关卡数字的是关卡独特规则",
    "messageInitContent_7858": "1。请在整点调整阵容",
    "messageInitContent_7862": "1147。水族馆2层不可以去，不过没关系这里不是那里",
    "messageInitContent_7863": "【内容不可视】",
    "messageInitContent_5201": "大叉出场率好高哦",
    "messageInitContent_7860": "1147。欢迎来到深渊水物馆2号馆",
    "messageInitContent_5200": "闭眼一点",
    "messageInitContent_7861": "3。如果你还是挑战了，那么先退出登录后，再重新登录",
    "messageInitContent_5203": "这不是一顿嘎嘎嘎嘎嘎",
    "messageInitContent_7866": "关一下战挑要不。1",
    "messageInitContent_5202": "镇剧王！！",
    "messageInitContent_7867": "1.无需畏惧危险",
    "messageInitContent_5205": "嘎嘎乱叫",
    "messageInitContent_7864": "1.部分规则会因污染而反转",
    "messageInitContent_5204": "报告前面有鸭子",
    "messageInitContent_7865": "1148。会游泳不可入内",
    "15_2014": "当前",
    "messageInitContent_5207": "这输出好像不太够看",
    "15_2015": "切换",
    "messageInitContent_5206": "今天也有神灵",
    "15_2016": "输入房间密码",
    "messageInitContent_5209": "进击的剧王",
    "messageInitContent_7868": "1.专属规则可能会出现序号异常",
    "15_2017": "加入小队",
    "messageInitContent_5208": "说的哪边",
    "messageInitContent_7869": "8，按下挑战后，若有任何迟疑，立刻重启游戏",
    "15_2010": "私密",
    "15_2011": "点击输入房间ID",
    "15_2012": "搜索",
    "15_2013": "点击设置密码",
    "messageInitContent_5210": "你在喊我？",
    "messageInitContent_7873": "1149。四倍速或许可以揭露它的秘密。",
    "messageInitContent_7874": "【信息不完整为确保安全实施遮盖】",
    "messageInitContent_5212": "一目了然",
    "messageInitContent_7871": "1149。二倍速或许可以揭露它的秘密。",
    "messageInitContent_5211": "猜饿了",
    "messageInitContent_7872": "转反而染污因会则规分部.0",
    "15_2007": "{1}的小队",
    "messageInitContent_5214": "急中生智",
    "messageInitContent_7877": "1150。飞舞的薄红背后隐藏了【】",
    "15_2008": "房间类型",
    "messageInitContent_5213": "燃眉之急",
    "messageInitContent_7878": "【内容不可视】",
    "15_2009": "公开",
    "messageInitContent_5216": "？？？？？？？？？",
    "messageInitContent_7875": "1.真正的深渊是【】",
    "messageInitContent_5215": "智力归零",
    "messageInitContent_7876": "1.重复的留言是迷途者的标记",
    "messageInitContent_7870": "【数据已丢失】",
    "15_2020": "切换关卡",
    "15_2025": "开始战斗",
    "messageInitContent_5218": "看看红叉的技能",
    "15_2026": "选择中",
    "messageInitContent_5217": "剧？！",
    "15_2027": "查看信息",
    "messageInitContent_7879": "1150。【】的好处在于无需思考",
    "15_2028": "转让队长",
    "messageInitContent_5219": "点赞就能猜对",
    "15_2021": "单人挑战",
    "15_2022": "-",
    "15_2023": "队长",
    "15_2024": "发布招募信息",
    "messageInitContent_5221": "哥————",
    "messageInitContent_7884": "1151。叉",
    "messageInitContent_5220": "竞猜天天有猜对没多少",
    "messageInitContent_7885": "【该信息无法被识别】",
    "messageInitContent_5223": "看看攻击力",
    "messageInitContent_7882": "1151。规则是用于遵守的",
    "messageInitContent_5222": "日常看看人数",
    "messageInitContent_7883": "3.带有，的规则是假的要注意甄别",
    "15_2018": "关卡信息",
    "messageInitContent_5225": "肯定是我大蜃兽",
    "messageInitContent_7888": "1152。52不只是诉说爱的数字",
    "resoundEventStoryDes_509": "非常可疑！\\n为什么魅妆站在了王·罗密欧的前面？王·朱丽叶却无动于衷！\\n难道说，它们接受了那个传闻中的可怕改造？\\n也就是说，王·朱丽叶其实是王·罗密欧？而王·罗密欧则是王·朱丽叶？\\n噢，多么奇怪的PLAY~\\n等等，灾·雷鸣胸口的线条真是3条吗？\\n不不，还是说，那只是两副徒有其表的躯壳，天知道它们是谁？\\n——有点酸了的全息小助手",
    "15_2019": "队伍无法挑战",
    "messageInitContent_5224": "当然是我大剧王",
    "messageInitContent_7889": "1152。无视是应对规则的最好法则",
    "messageInitContent_5227": "前前后后前前后",
    "messageInitContent_7886": "1152。一切尽在紫焰中",
    "resoundEventStoryDes_507": "王·朱丽叶：你觉得我们恋爱甜不甜？\\n王·罗密欧：咸多一点点。\\n王·朱丽叶：？",
    "messageInitContent_5226": "我夜观天象，左左右右左左右",
    "messageInitContent_7887": "1.无需畏惧危险",
    "resoundEventStoryDes_508": "在舛误之地的各大拼装巢穴逛逛就能发现，门口的全息波动都闪烁着同样的信息：\\n王·量子巨龙、MountainJo……等不得入内！黑名单可长了。\\n据不完全统计，已有大量的拼装师连同它们的拼装巢穴一起，被王·量子巨龙体内的强大能量击穿，造成了不可逆的创伤和损害。\\n接下来你即将遇到的王·量子巨龙，我猜它的一定是害怕的！\\n身处一个飞行器乱撞的世界，它的弱点——肚脐无时无刻不受着巨大的威胁。它何尝不想改造一下这个弱点呢，可造化弄怪，它似乎是天生无法改造的体质。\\n现在，跟在灾·焚风后面，至少爆了也能狠狠教训一下对方。\\n——突然出现的全息小助手",
    "resoundEventStoryDes_505": "王·朱丽叶：你对我似乎总是很热情的样子。\\n王·罗密欧：请去掉似乎！但千万不要因为我对你的热情就误会我了，我对其他怪兽可不会有此等的热切。\\n王·朱丽叶：有趣，但你也千万不要因为我对你的冷漠就误会我了，我对其他怪兽可不会有此等的冷漠。\\n王·罗密欧：呜呜……\\n王·朱丽叶：小欧欧，你怎么啦，别哭，我是说我甚至不会理它们！",
    "resoundEventStoryDes_506": "王·罗密欧：你就像是我忙碌一天后终于闲下来的夜……\\n王·朱丽叶：啊？\\n王·罗密欧：想一直留在它身边，不愿入睡。\\n王·朱丽叶：别给自己熬夜找借口，好吗？",
    "resoundEventStoryDes_503": "传说没有近战怪兽能打败王·赤色狮。这大概就是王·赤色狮选择与灾·赤潮并肩作战的原因，灾·赤潮是远程。\\n传说没有怪兽能在30秒内打败灾·赤潮。这大概就是灾·赤潮选择与王·赤色狮并肩作战的原因，30秒之后王·赤色狮自然会解决一切。\\n传说王·赤色狮与灾·赤潮的组合天下无敌。这大概就是你来到这的原因，传说就是用来打破的。",
    "resoundEventStoryDes_504": "王·罗密欧：（贴贴）今天也好喜欢你！\\n王·朱丽叶：（踹开）其实，你会不会只是馋我的……\\n王·罗密欧：（抢答）不只是",
    "messageInitContent_7880": "【数据已加密】",
    "resoundEventStoryDes_501": "据智者所言，在其他位面，肉食动物大多都比草食动物强大，毕竟肉食动物多以草食动物或其他肉食性动物为食。\\n但在这里，在超进化大陆，若有谁敢自称草食怪兽，是怪兽都会敬你三分。\\n首先，为什么一切怪兽在王·狈·爷眼中都是一块肉而不是一棵草？\\n其次，若你能经常以危险的草丛或源·危险的草丛为食，那你的实力自然不容小觑。\\n再退一万步，能经常吃下如此难以下咽的食物的，也定是非凡之兽。",
    "messageInitContent_7881": "1151。无序即是有序",
    "resoundEventStoryDes_502": "叫西偏去东、叫起偏照睡、叫睡反拆家。\\n以上这些都是一些难驯幼兽的日常，可自从有只怪兽发现这个圣地之后，幼兽难驯从此成为了历史。\\n只需要将幼兽带到圣地附近，教训道，以后不乖就把你丢在这里。幼兽就再也不敢造次，百试百灵。\\n这个圣地便是灾·雷鸣和王·量子巨龙的所在地之外的方圆几里，终日电闪雷鸣，要在这里听清楚雷鸣以外的声音真的十分困难。\\n在圣地的边缘，那些没听到“别再往那边走啦！”的被烤焦了的调皮幼兽是这么“说”的。",
    "resoundEventStoryDes_500": "王·朱丽叶：我记得你之前说过，你愿意为我做任何事？\\n王·罗密欧：我愿意为你做任何事！\\n王·朱丽叶：你愿为我摘下天上的星星吗？\\n王·罗密欧：我当然愿意！\\n王·朱丽叶：现在我不要你为我摘下天上的星星，我只要你把那灾·星落带回来就好。\\n王·罗密欧：那个……亲爱的您是不要我了吗？\\n王·朱丽叶：笨蛋，我问你，敌人看见我们想的第一件事是什么？\\n王·罗密欧：当然是如何将世界最美的你从我身边带走，我亲爱的王后！\\n王·朱丽叶：不，你猜错了，他们想的是如何将你从我身边带走，我亲爱的王！\\n王·罗密欧：怎么会呢！\\n王·朱丽叶：因为你离开了，又有谁会保护我呢！\\n王·罗密欧：我懂了！所以你让我把灾·星落带来就是为了保护我！我爱你！\\n王·朱丽叶：不！它来是保护我的。\\n灾·星落：*****",
    "messageInitNick_632": "半素颜",
    "messageInitNick_633": "谢幕",
    "messageInitNick_634": "傲娇腐女",
    "messageInitNick_635": "橘子",
    "messageInitNick_636": "呆萌小帅锅",
    "messageInitNick_637": "淡蓝色的梦",
    "messageInitNick_638": "踮脚要抱抱",
    "messageInitNick_639": "麦克风坏了",
    "messageInitNick_7597": "凌晨两点半",
    "messageInitNick_7596": "汪汪队",
    "messageInitNick_630": "丛林追迹者",
    "messageInitNick_7599": "大猫砂",
    "messageInitNick_631": "下一站雨会停",
    "messageInitNick_7598": "电磁炉歌舞团",
    "15_2003": "创建队伍",
    "messageInitNick_643": "播放着悲伤",
    "messageInitNick_7593": "迷路的核糖体",
    "15_2004": "多人挑战",
    "messageInitNick_644": "口胡勇士",
    "messageInitNick_7592": "热心的小天才",
    "15_2005": "房间设置",
    "messageInitNick_645": "国际驰名双标",
    "messageInitNick_7595": "红辣椒之子",
    "15_2006": "搜索房间",
    "messageInitNick_646": "接吻会减肥",
    "messageInitNick_7594": "跟骨",
    "messageInitNick_647": "酱油西瓜",
    "messageInitNick_648": "认证懂专家",
    "15_2001": "凿星裂痕",
    "messageInitNick_649": "空投没命捡",
    "messageInitNick_7591": "萝卜之心",
    "15_2002": "排行榜",
    "messageInitNick_7590": "挥剑断魂",
    "messageInitNick_7589": "您品您细品",
    "messageInitNick_7586": "不在乎过去",
    "messageInitNick_640": "把星星揣兜里",
    "messageInitNick_7585": "大脑按摩师",
    "messageInitNick_641": "帅气的板栗",
    "messageInitNick_7588": "冒牌货",
    "messageInitNick_642": "流过昼夜",
    "messageInitNick_7587": "漫展显眼包",
    "affixName_18": "吸血",
    "affixName_17": "净化",
    "affixName_16": "主宰",
    "affixName_15": "天灾",
    "affixName_19": "抗性",
    "affixName_10": "强韧",
    "messageInitNick_654": "跑调的安眠曲",
    "messageInitNick_7582": "龟咩之刀",
    "messageInitNick_655": "甩锅门首席",
    "messageInitNick_7581": "茄子女巫",
    "messageInitNick_656": "盒子自我跑",
    "messageInitNick_7584": "究成空",
    "messageInitNick_657": "克努姆神",
    "messageInitNick_7583": "白灼菜心",
    "affixName_14": "悲鸣",
    "messageInitNick_658": "半糖",
    "affixName_13": "反伤",
    "messageInitNick_659": "超级卖惨神",
    "affixName_12": "疾风",
    "messageInitNick_7580": "超级披萨",
    "affixName_11": "霸体",
    "messageInitNick_7579": "拉面牧师",
    "messageInitNick_7578": "你是大鲨鱼",
    "messageInitNick_650": "太绝望了吧",
    "messageInitNick_7575": "在逃艺术家",
    "messageInitNick_651": "让我访问",
    "messageInitNick_7574": "旋转肌肉",
    "messageInitNick_652": "狂奔的蜗牛",
    "messageInitNick_7577": "灵感女魂",
    "messageInitNick_653": "精准降落",
    "messageInitNick_7576": "鳄鱼缺根筋",
    "messageInitNick_665": "和风醉梦",
    "messageInitNick_7571": "抬杠神",
    "messageInitNick_666": "请勿复读",
    "messageInitNick_7570": "人参果龙",
    "messageInitNick_667": "超人不流泪",
    "messageInitNick_7573": "迷路的基质",
    "messageInitNick_668": "等雨停的猫",
    "messageInitNick_7572": "酿辣椒",
    "messageInitNick_669": "精神小伙",
    "messageInitNick_7568": "无公害菜花",
    "messageInitNick_7567": "凉粉怪客",
    "messageInitNick_660": "用脚印卡",
    "messageInitNick_7569": "金色战车",
    "shopName_1006": "补偿商店",
    "messageInitNick_661": "多啦爱梦",
    "messageInitNick_7564": "新型泡菜",
    "messageInitNick_662": "爱拼就能赢",
    "messageInitNick_7563": "现在是我的了",
    "messageInitNick_663": "别露出鸡脚",
    "messageInitNick_7566": "你好静静",
    "messageInitNick_664": "天使在身边",
    "messageInitNick_7565": "二点五条",
    "versionPackName_2.7": "燃云起礼遇",
    "versionPackName_2.8": "二周年礼遇",
    "messageInitNick_676": "旧楼天台",
    "messageInitNick_7560": "不准咬家具",
    "messageInitNick_677": "暗蓝之月",
    "versionPackName_2.0": "周年庆礼遇",
    "messageInitNick_678": "带泪的鱼",
    "messageInitNick_7562": "欠吻吗",
    "versionPackName_2.1": "春祈至礼遇",
    "messageInitNick_679": "卖的一手好萌",
    "messageInitNick_7561": "泡芙侦探",
    "versionPackName_2.2": "奇迹秀礼遇",
    "versionPackName_2.3": "千舸竞礼遇",
    "versionPackName_2.4": "部落格礼遇",
    "versionPackName_2.5": "夏日祭礼遇",
    "versionPackName_2.6": "月光漾礼遇",
    "messageInitNick_7557": "千面幻影",
    "messageInitNick_7556": "橙子君快逃",
    "messageInitNick_670": "把心掏你",
    "messageInitNick_7559": "清澈的愚蠢",
    "messageInitNick_671": "专治各种不服",
    "messageInitNick_7558": "跟寂寞和好",
    "messageInitNick_672": "瞌睡少女",
    "messageInitNick_7553": "满分喜欢",
    "messageInitNick_673": "抽刀断情仇",
    "messageInitNick_7552": "带火龙果探险",
    "messageInitNick_674": "没通过我很急",
    "messageInitNick_7555": "戒梦",
    "messageInitNick_675": "笨丫头",
    "messageInitNick_7554": "无上上上王",
    "messageInitNick_687": "残月孤星",
    "affixName_20": "耐受",
    "messageInitNick_688": "核桃小新",
    "messageInitNick_689": "是说谎的味道",
    "messageInitNick_7551": "别过来啊啊",
    "messageInitNick_7550": "逮虾户",
    "affixDescription_20": "怪兽受到炼狱伤害降低{p1}%",
    "messageInitNick_7546": "泪眼看世界",
    "messageInitNick_680": "高冷病友",
    "messageInitNick_7545": "黑白年代",
    "messageInitNick_681": "不想再心动了",
    "messageInitNick_7548": "逆袭这件事",
    "messageInitNick_682": "旧巷的猫",
    "messageInitNick_7547": "宫保鸡丁",
    "messageInitNick_683": "哭泣天使",
    "messageInitNick_7542": "角色不是声优",
    "messageInitContent_7900": "【该信息无法被识别】",
    "messageInitNick_684": "愤怒的老鸟",
    "messageInitNick_7541": "有脑魔女",
    "messageInitNick_685": "咕咕先驱",
    "messageInitNick_7544": "无线连接者",
    "messageInitNick_686": "地球常驻嘉宾",
    "messageInitNick_7543": "我推的池子",
    "messageInitNick_7549": "捂脸小可爱",
    "messageInitContent_7909": "1156。【】",
    "affixDescription_17": "怪兽不会受到任何负面效果影响",
    "affixDescription_16": "战力最高的怪兽没有死亡前，所有其他的己方怪兽都不会死亡",
    "affixDescription_19": "怪兽每被攻击{p1}次，受到伤害降低{p2}%，持续{p3}秒，最多叠加{p4}次",
    "affixDescription_18": "怪兽造成伤害的{p1}%用于回复自身血量",
    "affixDescription_13": "怪兽获得{p1}%的反伤效果",
    "messageInitContent_7903": "1155。四月是幻的谎言",
    "messageInitNick_698": "黑名单",
    "affixDescription_12": "怪兽无视所有减速效果",
    "messageInitContent_7904": "【信息被涂鸦】",
    "messageInitNick_699": "断桥残月",
    "affixDescription_15": "攻击力最高的怪兽每{p1}秒在场地中央（屏幕长度/2的坐标）召唤一道天雷，对敌方造成攻击力*{p2}%的范围伤害（范围{p3}）",
    "messageInitContent_7901": "3.带有，的规则是假的要注意甄别",
    "messageInitNick_7540": "气氛组先驱",
    "affixDescription_14": "每有一只己方怪兽死亡，怪兽攻击力、移动速度提高{p1}%",
    "messageInitContent_7902": "1.专属规则可能会出现序号异常",
    "messageInitContent_7907": "1156。鱿鱼就会败北。",
    "messageInitContent_7908": "2。如果你挑战下一关了，那不要再挑战下一关",
    "affixDescription_11": "怪兽霸气提升{p1}%",
    "messageInitContent_7905": "1156。不可带桐仁挑战此关",
    "affixDescription_10": "怪兽血量提升{p1}%",
    "messageInitContent_7906": "1.带有.的规则一般是正确的，可以相信",
    "messageInitNick_690": "穿靴子的猫",
    "messageInitNick_7535": "镜子剑客",
    "messageInitNick_691": "本小姐不太冷",
    "messageInitNick_7534": "咕咕门传人",
    "messageInitNick_692": "散步的鱼",
    "messageInitNick_7537": "香蕉去哪了",
    "messageInitNick_693": "悄悄躲进车里",
    "messageInitNick_7536": "八月的奇迹",
    "messageInitContent_7910": "1。请勿在整点调整阵容",
    "messageInitNick_694": "卖萌的小冤家",
    "messageInitNick_7531": "卖茶叶蛋的",
    "messageInitContent_7911": "1157。免费的饲料不要买",
    "messageInitNick_695": "司马迁戒导",
    "messageInitNick_7530": "咸甜花生酱",
    "messageInitNick_696": "小强关心你",
    "messageInitNick_7533": "茄子兽",
    "messageInitNick_697": "冰是睡着的水",
    "messageInitNick_7532": "炒面射手",
    "messageInitNick_7539": "无语草莓",
    "monsterTemperamentConfigDes_1": "暴走旷野战斗开始{p1}秒内击破{p2}只怪兽",
    "messageInitNick_7538": "世俗的欲望",
    "monsterTemperamentConfigDes_2": "暴走旷野战斗开始{p1}秒内击破{p2}只怪兽",
    "monsterTemperamentConfigDes_5": "暴走旷野1次战斗中使用元核自爆宿命效果击破{p1}只怪兽",
    "randomEventDialogueGroupConfig_56.5": "-",
    "monsterTemperamentConfigDes_6": "起源殿炼狱模式下存活超过{p1}秒",
    "randomEventDialogueGroupConfig_56.4": "-",
    "monsterTemperamentConfigDes_3": "狩猎战胜{p1}名探索者",
    "randomEventDialogueGroupConfig_56.7": "-",
    "monsterTemperamentConfigDes_4": "暴走旷野战斗开始{p1}秒内移动距离超过{p2}码",
    "randomEventDialogueGroupConfig_56.6": "-",
    "monsterTemperamentConfigDes_9": "暴走旷野战斗开始{p1}秒内触碰战墙{p2}次",
    "randomEventDialogueGroupConfig_56.1": "你在地上捡到一张悬赏令，悬赏令上的这只怪兽你觉得很熟悉，一看名字，是桐仁。赏金说多也不多，说少也不少。",
    "monsterTemperamentConfigDes_7": "暴走旷野持续{p1}秒血量低于{p2}%",
    "randomEventDialogueGroupConfig_56.3": "管它呢",
    "monsterTemperamentConfigDes_8": "暴走旷野战斗开始{p1}秒内受到{p2}的治疗量",
    "randomEventDialogueGroupConfig_56.2": "撕下来接了",
    "messageInitContent_7914": "1。.矛盾是正常的",
    "messageInitContent_7915": "1158。感受引力的话，就对了",
    "messageInitContent_7912": "1157。前面左转有免费的饲料出售",
    "messageInitContent_7913": "3.带有，的规则是假的要注意甄别",
    "messageInitContent_7918": "戏游受享。0",
    "randomEventDialogueGroupConfig_56.9": "-",
    "messageInitContent_7919": "1158。放飞情绪无惧一切",
    "randomEventDialogueGroupConfig_56.8": "-",
    "messageInitContent_7916": "0.享受游戏",
    "messageInitContent_7917": "【信息不完整为确保安全实施遮盖】",
    "messageInitNick_7524": "专治各种不服",
    "messageInitNick_7523": "别动我的心",
    "messageInitNick_7526": "那边怎么说",
    "messageInitNick_7525": "黑白的色调",
    "messageInitContent_7921": "1159。深渊的怪兽吞噬深渊。",
    "messageInitNick_7520": "插线板剑客",
    "messageInitContent_7922": "【该信息无法被识别】",
    "messageInitNick_7522": "不敢求婚",
    "messageInitContent_7920": "3。如果你还是挑战了，那么先退出登录后，再重新登录",
    "messageInitNick_7521": "酱香饼大师",
    "messageInitNick_7528": "浮生物语",
    "messageInitNick_7527": "熟悉的天花板",
    "messageInitNick_7529": "卷王",
    "resoundEventStoryDes_596": "【初始刻度】\\n【瞳】的每一天都是类似的，照看诞生在虚诞之地的虚体，尽可能地确保它们的稳定，以及最低限度保障闯入的实体的存在。【瞳】会仔细查阅掌中之瞳中记录着的每一个虚体信息。这些信息包括几个部分：【编号】、【代号】、【适用刻度】、【保育】、【所在区域】、【描述】。【瞳】将根据其中的条目采取相应的措施。",
    "resoundEventStoryDes_597": "这个瞳晶构筑了一条规则【如果怀疑会导致灭亡，那你会怀疑吗？】\\n这是【瞳】在【最高刻度】的规则中看到的唯一一条问句。",
    "resoundEventStoryDes_594": "接触这个晶体后，一段信息片段自然地浮现在你的脑海。\\n【如果有什么规则限制了你的阅读，可无视那些规则】虚体与实体之间接触会导致双方崩坏的结论得到了验证。那一刻我突然意识到自己的生命所剩无几了，实体和虚体对于对方而言都是可怕的药剂，必须在离开之前，确保双方无法接触，或许，让虚体忘记自己是虚体的规则也是一种方向？以后虚诞之地就交给你了【瞳】。",
    "resoundEventStoryDes_595": "这片位于海底之下的区域就是深渊，可随着那片奇怪区域的不断扩张，深渊已经被吞噬殆尽了。深渊现在只是虚诞之地的过去，只存在于某些幸存的原住民内心。",
    "resoundEventStoryDes_592": "接触这个晶体后，一段信息片段自然地浮现在你的脑海。\\n【如果有什么规则限制了你的阅读，可无视那些规则】大概谁都有过幻想变为现实的幻想。\\n或许不该有这种幻想，因为那不是幻想，在深渊里不是。\\n在鳄实验告一段落后，我意外在深渊，也就是这片海底之下的区域发现了一种异质瞳晶，它们是诞下虚体的神秘物质，是虚体的摇篮。得到了实体的幻想我称之为【虚体】。\\n最初我沉迷于研究这种能够将想象、幻想、虚象转变成有实体的物质。\\n这个转化的关键要素之一是稳定性，由于虚体的存在源自于想象、幻想、虚象一类没有根基的东西。而这些瞳晶恰好可以通过赋则，即赋予规则，让虚体维系短暂的稳定。由此我脑海中出现了一个疯狂的想法，通过组合和打磨瞳晶增加附则的量级和质量，是否就能够制造永远存在于现实的幻想呢？",
    "resoundEventStoryDes_593": "接触这个晶体后，一段信息片段自然地浮现在你的脑海。\\n【如果有什么规则限制了你的阅读，可无视那些规则】经过打磨的瞳晶宛如一只只深邃的眼眸，视线总会不自觉便被吸入其中，仿佛世间的一切都被排除在外，我甚至有些害怕，等回过神来自己已变成白骨。\\n附则的研究进展非常不错，第一个稳定存在的虚体源自于我的幻想，它叫薛定鳄的猫，有点类似喵响但又不完全相同。\\n那一天它跑出去了，在碰到了智者之后就崩坏了。智者和我一样，是确实存在的实体，看来要增加一条防止虚体与实体接触的规则了……",
    "resoundEventStoryDes_590": "来到这个节点时，以下规则自然而然地浮现在你的脑海。\\n【七段谜题的串联是世界遗落的馈赠，不要试图破解谜题，它会夺走你的时间，破坏你的实感】【若在死路徘徊，谜题则是脱出的关键】【错乱引你至迷途，循序而行方可抵达终点】【脱出点并非第二个圆环】\\n【Ⅰ：？Ⅱ：？ Ⅲ：？】",
    "resoundEventStoryDes_591": "来到这个节点时，以下规则自然而然地浮现在你的脑海。\\n【七段谜题的串联是世界遗落的馈赠，不要试图破解谜题，它会夺走你的时间，破坏你的实感】【若在死路徘徊，谜题则是脱出的关键】【错乱引你至迷途，循序而行方可抵达终点】【脱出点并非鱼之巨口】\\n【Ⅰ：？Ⅱ：？ Ⅲ：？】",
    "messageInitNick_7513": "胡萝卜魔法师",
    "messageInitNick_7512": "白玉天女",
    "messageInitNick_7515": "坚持下去",
    "messageInitNick_7514": "蓝翔老司机",
    "messageInitNick_7511": "太阳能剃须刀",
    "messageInitNick_7510": "桔梗的泪",
    "messageInitNick_7517": "路痴",
    "messageInitNick_7516": "降压玩具",
    "messageInitNick_7519": "一定要坚强啊",
    "resoundEventStoryDes_598": "【瞳】的视野遍布整个深渊，这样她就可以随时掌握深渊的状态。大多数视野都是机动式的，安排在一些重要的区域。例如路线的沿途，这些区域是为意外闯入这个区域的实体准备了，为了确保它们的安全，【瞳】会向它们注入必要的规则，只是总会有喜欢打破规则的家伙。",
    "messageInitNick_7518": "无所谓了",
    "resoundEventStoryDes_599": "【编号】00001\\n【代号】飞来之糕\\n【适用刻度】低\\n【保育】成功它接住1次。\\n【所在区域】触涌镜花\\n【描述】源于异界的幻想，具体机制不明，似乎是为了纪念某个特别的时间节点而生成的。",
    "messageInitNick_7502": "海猫鸣泣之时",
    "messageInitNick_7501": "悲有寂寞有染",
    "messageInitNick_7504": "最爱茄子",
    "messageInitNick_7503": "等你地久",
    "messageInitNick_7500": "新型榨菜",
    "messageInitNick_7509": "还没醒",
    "messageInitNick_7506": "助眠读物",
    "messageInitNick_7505": "蘑菇兽",
    "messageInitNick_7508": "无修容大师",
    "messageInitNick_7507": "到底要选哪个",
    "messageInitNick_607": "领家小家伙",
    "messageInitNick_608": "小仙女酱",
    "messageInitNick_609": "连夜读书",
    "messageInitNick_600": "断片先生",
    "messageInitNick_601": "机器师",
    "messageInitNick_602": "伯爵的猫",
    "messageInitNick_603": "其实我很坚强",
    "messageInitNick_604": "假装败给你",
    "messageInitNick_605": "笑熬浆糊",
    "messageInitNick_606": "混球你跑",
    "messageInitNick_618": "请不要爱上我",
    "messageInitNick_619": "遥想花开那年",
    "messageInitNick_610": "听见阳光",
    "messageInitNick_611": "蹲街等天黑",
    "messageInitNick_612": "爱鬼人士",
    "messageInitNick_613": "那个野蛮人",
    "messageInitNick_614": "别来我世界",
    "messageInitNick_615": "新角色",
    "messageInitNick_616": "虾系爱豆",
    "messageInitNick_617": "别弄丢了自我",
    "messageInitNick_629": "仅剩这句号",
    "messageInitNick_621": "未知数",
    "messageInitNick_622": "被雨打湿的泪",
    "messageInitNick_623": "白兔",
    "messageInitNick_624": "一个人挺好",
    "messageInitNick_625": "没有毛的猫",
    "messageInitNick_626": "把苦熬成甜",
    "messageInitNick_627": "很傻很天真",
    "messageInitNick_628": "聊天机器人",
    "messageInitNick_620": "水弹幕加经验",
    "randomEventDialogueGroupConfig_3.19": "复述它的话",
    "18_7": "谜体古基因",
    "18_6": "已满级",
    "messageInitContent_5349": "疯狂动物园怪兽版？",
    "18_5": "未解锁",
    "18_4": "卸下",
    "18_3": "使用",
    "18_2": "升级",
    "18_1": "重置",
    "messageInitContent_11695": "发动联栗炮固定式！",
    "messageInitContent_5353": "召唤红太狼",
    "messageInitContent_11694": "听说你很大胆",
    "messageInitContent_5352": "快跑狼来啦",
    "messageInitContent_11697": "你也是白银城吗",
    "messageInitContent_5355": "快变成彩虹小兽",
    "messageInitContent_11696": "让我按个计算器",
    "messageInitContent_5354": "又是你两兄弟",
    "randomEventDialogueGroupConfig_3.10": "-",
    "messageInitContent_11691": "就是为了大声尖叫",
    "messageInitContent_5357": "策马奔腾共享人家繁华",
    "messageInitContent_11690": "灵魂出窍模拟器",
    "messageInitContent_5356": "马娘也行",
    "messageInitContent_11693": "从零开始游乐园大亨",
    "messageInitContent_5359": "木大木大木小？",
    "messageInitContent_11692": "记得在最高点保持微笑",
    "messageInitContent_5358": "祝大家马到成功",
    "randomEventDialogueGroupConfig_3.15": "换个方式再问一次",
    "randomEventDialogueGroupConfig_3.16": "把它的堵嘴塞回去",
    "randomEventDialogueGroupConfig_3.17": "检查它身上的树藤",
    "randomEventDialogueGroupConfig_3.18": "它再次把你问它的问题复述了一次，仍旧一字不差。",
    "messageInitContent_11699": "先学学洗牌",
    "randomEventDialogueGroupConfig_3.11": "它挣扎着跳着试图跟上，可是很快就失去平衡倒在地上了。",
    "messageInitContent_11698": "这都什么年代的版本了",
    "randomEventDialogueGroupConfig_3.12": "将它扶好",
    "messageInitContent_5351": "突突突",
    "randomEventDialogueGroupConfig_3.13": "狠心离开",
    "messageInitContent_5350": "小兔子乖乖",
    "randomEventDialogueGroupConfig_3.14": "它迅速将嘴里的口水吐掉，然后把你刚问它的问题一字不差地说了一遍。",
    "messageInitContent_11684": "那抱一抱吧",
    "messageInitContent_5364": "什么鬼",
    "messageInitContent_11683": "你也是",
    "messageInitContent_5363": "还是喜欢你脑子带发条的样子",
    "messageInitContent_11686": "坚持就胜利！",
    "messageInitContent_5366": "门神",
    "randomEventDialogueGroupConfig_3.20": "离开",
    "messageInitContent_11685": "为什么到处都是这些卡牌兵",
    "messageInitContent_5365": "这是包租公的门卫吧",
    "randomEventDialogueGroupConfig_3.21": "它重复了你的问题。",
    "messageInitContent_11680": "总觉得关卡留言奇奇怪怪",
    "messageInitContent_5368": "司机是凳子",
    "messageInitContent_5367": "门卫和保镖",
    "18_9": "未入榜",
    "messageInitContent_11682": "你很眼熟诶",
    "resoundEventStoryDes_408": "介戈大坑显然不是天然形成的，它们有可能出现在超进化大陆的任何区域，这完全取决于地龙的喜好。踩到一些松软的新坑算是运气好的，即便不会飞也不会摔得太疼，找个水塘冲一冲又是一头精神的好怪兽。要是踩到一些没有被自然埋没的老坑那可是中了头彩，一趟有去无回的地底之旅呢。",
    "18_8": "谜之生物必须上阵",
    "messageInitContent_11681": "才发现吗",
    "messageInitContent_5369": "空蝉绝不会看错了",
    "resoundEventStoryDes_409": "总有怪兽指着它们说“叫你浪！”",
    "propConfigName_90405": "紫色真实伤害元核碎片",
    "randomEventDialogueGroupConfig_3.26": "它把你的话又说了一遍。",
    "resoundEventStoryDes_406": "总会有一些不会飞的怪兽，在野花上扬的山崖上，在飞龙卷起的狂风中，在眼帘映照的碧空下，萌生出想要飞翔的梦想。而翅膀苗之王，也就是“隐形的翅膀”正是它们实现梦想的其中一个方式。此外还需要一些技巧，一些值得信赖的同伴，和一颗不怕死的心。首先想飞的怪兽要将隐形的翅膀的金色部分缠绕在自己身上，并且缠紧，然后和同伴一起用全身的力气往下压。最后调整角度，一起松手。缠在隐形的翅膀上面的怪兽就会被弹射上天，短暂地飞翔。现在最受欢迎的隐形的翅膀位于瓜子独岛，因为在那里不管弹向哪个方向，大海都会仁慈地接住那些落入它胸口的怪兽。",
    "propConfigName_90404": "蓝色真实伤害元核碎片",
    "randomEventDialogueGroupConfig_3.27": "它把你的话又说了一遍。",
    "resoundEventStoryDes_407": "介戈天坑如同一座倒着发育的大山，割开地面，直伸地底。坑壁是大致与地面垂直的绝壁，有几处野草烂漫的岩突在绝壁中错落着探出。石壁上飞泉直下，宛如倒挽的银河。一座奇异的森林躲在天坑底部，尽是繁茂又见所未见的植株，林间一条似乎喝醉了的地下河歪扭地在里头漫步着，等待着不知何时闯入的访客。",
    "propConfigName_90403": "绿色真实伤害元核碎片",
    "randomEventDialogueGroupConfig_3.28": "复述它的话。",
    "resoundEventStoryDes_404": "仍旧是灰烟丘陵，一阵调皮的大风，在一个普通的夜里来到了灰烟的边缘，一只地底之兽在正要点燃树根的一瞬间无意中憋见了，那片没有灰烟遮挡的天空。它看到了一道横在天际的银白色光带，是它从未见过的光景，它想那一定就是末日的征兆。它惊恐的尖叫着，四肢疯狂甩动着在巢穴中乱撞。\\n如果此时它身边有一位智者，或许它就可以避开这个妄想出来的末日。\\n智者会告诉它，“不，那不是末日的征兆，那是银河。是的，它一直在那。” 、n只是智者并没有在它身旁。",
    "propConfigName_90402": "白色真实伤害元核碎片",
    "randomEventDialogueGroupConfig_3.29": "离开。",
    "resoundEventStoryDes_405": "所谓的翅膀苗，指的就是这种小小的植物，它们的植株一般都非常矮小，甚至还不及叉叉的脚掌高。靠近看就会发现它的主茎并不是直直的，而是螺旋式朝着天空生长，仿佛在绕着一根不存在的柱子往上爬似的。对于大多数翅膀苗来说，长到这个高度就是它们的极限了，不过，会有少数植株突破极限，长得更高，更壮，它们就是“王的后补”。\\n经历300多个日月之后，这场“营养争夺战”就会有结果，只会有一株能成为王。\\n这个植株极其粗壮，最粗的位置有2个叉叉高2个叉叉宽，它的顶部从原来的绿色转为金黄色，如同大自然的加冕。至于后补们，谁会在意它们呢。",
    "messageInitContent_11688": "那是有很多网瘾武士",
    "messageInitContent_5360": "巨像",
    "randomEventDialogueGroupConfig_3.22": "复述它的话。",
    "resoundEventStoryDes_402": "灰烟丘陵上充斥着暗沉的浓烟，浓烟将此地的视野压缩至仅剩几只叉叉身位宽，显然哪儿的风都不愿造访此处，驱散浓烟。\\n这里的白天异常静谧，灰烟轻轻接住阳光，无声地游移独舞。\\n可到了夜里，灰烟便披着星月的辉光，带着一阵阵喧哗从丘陵顶部的洞口冒出，混沌地相交乱舞。",
    "messageInitContent_11687": "它们是失踪的圣堂武士变的",
    "randomEventDialogueGroupConfig_3.23": "离开",
    "resoundEventStoryDes_403": "依旧是灰烟丘陵，这里的每一座丘陵的底部都是一座巢穴，由一条通道将巢穴与地面连通起来。除了少数荒废的巢穴，大多丘陵里都生活着一群群慵懒的怪兽。它们一出生就生活在地底巢穴之中，它们安寝的时间在白天，精力最为旺盛的时刻为夜里。它们用口中吹出的小火苗，点燃地底里唯一一种植物的根部，贪婪地吸入燃烧而生的浓烟，各种奇怪声调从它们的嘴里冒出，随着浓烟一道涌向地面。",
    "messageInitContent_5362": "大大的木偶转呀转呀转",
    "propConfigName_90407": "红色真实伤害元核碎片",
    "randomEventDialogueGroupConfig_3.24": "移开它的堵嘴，解开绳子，说“你自由了。”",
    "resoundEventStoryDes_400": "这个荒渚是微光之森一个形状奇怪的池子中的一小块荒芜的陆地，池水阻隔了它与周围土地的联系，只留它孤零零地在水中。",
    "messageInitContent_11689": "你们好懂",
    "messageInitContent_5361": "大木大木",
    "propConfigName_90406": "橙色真实伤害元核碎片",
    "randomEventDialogueGroupConfig_3.25": "-",
    "resoundEventStoryDes_401": "这个荒渚是微光之森一个形状奇怪的池子中的一小块荒芜的陆地，它可真是太幸运了，之前有一只胖的已经认不出是啥的怪兽在这重重地摔了一跤，砸了个池子出来，就它逃过了一劫。",
    "resoundEventStoryDes_410": "这里的瓜被蓝色海浪冲走了，所以看不见了！怪兽的声音在这里也会被震耳欲聋的涛声淹没。",
    "messageInitContent_11673": "夜了，睡吧",
    "messageInitContent_5375": "有半个身子在水下对吧",
    "messageInitContent_11672": "不对是战姬",
    "messageInitContent_5374": "经典水上战斗",
    "messageInitContent_11675": "这是湖中仙女吗",
    "messageInitContent_5377": "别闹乖乖输掉",
    "messageInitContent_11674": "最怕空气突然安静",
    "messageInitContent_5376": "针不戳",
    "messageInitContent_5379": "上一秒这么大现在突然就",
    "messageInitContent_5378": "拜拜~",
    "messageInitContent_11671": "能不能是战机",
    "resoundEventStoryDes_419": "王·朱丽叶：为什么之前都是你主动？\\n王·罗密欧：没有办法，我是猜拳高手。",
    "messageInitContent_11670": "重装中",
    "resoundEventStoryDes_417": "王·罗密欧：当时我害怕极了！\\n王·朱丽叶：哈？\\n王·罗密欧：之前被我追的，都跑得老远老远的。\\n王·朱丽叶：然后呢？\\n王·罗密欧：你当时居然反过来追着我跑！我都吓坏了，但又很开心。\\n王·朱丽叶：你欠我东西，我不追你我追谁？\\n王·罗密欧：竟有这回事？我欠什么了？\\n王·朱丽叶：你今天欠揍！",
    "resoundEventStoryDes_418": "王·朱丽叶：为什么之前都是你主动？\\n王·罗密欧：没有办法，我先攻高。",
    "resoundEventStoryDes_415": "王·罗密欧：亲爱的，你说爱是什么？\\n王·朱丽叶：临时疯狂。\\n王·罗密欧：你是爱我爱到失去理智了吗！\\n王·朱丽叶：是的，那一块大钻石我真的好爱啊！",
    "resoundEventStoryDes_416": "王·罗密欧：亲爱的，爱而不得是什么？\\n王·朱丽叶：当然是试探，一开始是试探对方，后来是试探自己，到底放下了多少。\\n王·罗密欧：亲爱的，你说的真好！\\n王·朱丽叶：那个是我朋友说的。你要听听我的回答吗？\\n王·罗密欧：当然！\\n王·朱丽叶：当然是你。",
    "messageInitContent_11677": "美好美，探索者你真的好美",
    "messageInitContent_5371": "空蝉狂喜",
    "resoundEventStoryDes_413": "王·罗密欧：想起最初遇到你的那会，在下雨天我总是听不见雨声。\\n王·朱丽叶：我就说你一直不长耳朵。\\n王·罗密欧：因为当时我的注意力都被你夺走了。\\n王·朱丽叶：现在呢？\\n王·罗密欧：我看看，原来下雨了啊。",
    "messageInitContent_11676": "帅好帅探索者你真的很帅",
    "messageInitContent_5370": "空蝉暗喜",
    "resoundEventStoryDes_414": "王·罗密欧：看到你的第一眼，我就同时恋爱和失恋了。\\n王·朱丽叶：都叫你别跟薛定鳄混太久。\\n王·罗密欧：你不是应该问问我为什么？\\n王·朱丽叶：为什么呢？\\n王·罗密欧：看到你那一刻，无数可能和结果就已经在我心里发生了！",
    "messageInitContent_11679": "上车咯",
    "messageInitContent_5373": "一直这样",
    "resoundEventStoryDes_411": "王·罗密欧：我在意你！\\n王·朱丽叶：我帮助你！",
    "messageInitContent_11678": "来咯来咯",
    "messageInitContent_5372": "您下巴是不是整过",
    "resoundEventStoryDes_412": "王·罗密欧：你一定很自恋！\\n王·朱丽叶：嗯？\\n王·罗密欧：你之前说过，我们很像。\\n王·朱丽叶：才没有说过！",
    "resoundEventStoryDes_420": "王·罗密欧：爱情来得太快就像龙卷风！\\n王·朱丽叶：不会唱可以别唱。\\n王·罗密欧：不，我在思考。\\n王·朱丽叶：……\\n王·罗密欧：怎样才可以抵达平静的风眼。",
    "resoundEventStoryDes_421": "王·罗密欧：好吃的食物真是让我上瘾啊。\\n王·朱丽叶：吃多了就没瘾了。\\n王·罗密欧：但好看的你真是……\\n王·朱丽叶：停。\\n王·罗密欧：果然唯有你能让我停下来，停下这种追逐。",
    "messageInitContent_11662": "不好，脑里跳出了另外一个词",
    "messageInitContent_5386": "这区域得多大",
    "messageInitContent_11661": "吃草？无双？",
    "messageInitContent_5385": "你们不挤的吗",
    "messageInitContent_11664": "割不了一点",
    "messageInitContent_5388": "爱了爱了",
    "messageInitContent_11663": "怎么才能在这个地图割草",
    "messageInitContent_5387": "好大queen",
    "messageInitContent_5389": "一脸睿智的锤",
    "messageInitContent_11660": "让我看看看看袍跟的哪位",
    "resoundEventStoryDes_428": "有没有觉得这高台看着就想插个眼？什么你说没有眼，唔……王·炼狱魔眼好像不太行，那就……找个愿意成为你的眼拿信息的辅助吧！",
    "messageInitContent_11669": "潜伏中",
    "resoundEventStoryDes_429": "王·罗密欧：最近发现，我对那个情感的认识变得前所未有地透彻。\\n王·朱丽叶：哦？那是什么？\\n王·罗密欧：是妒忌！我竟然开始妒忌你身边的空气了！\\n王·朱丽叶：谁跟我说爱能让我们更好地认识自己的，为什么我总觉得你有点变傻了。\\n王·罗密欧：我当然也意识到它的荒唐，可我无法阻止它。\\n王·朱丽叶：噢，我的小笨蛋，快来把我周围的空气赶走吧。\\n王·罗密欧：难道你是想要我？\\n王·朱丽叶：啊，你放屁！",
    "messageInitContent_5380": "萎了",
    "resoundEventStoryDes_426": "在键盘和鼠标的强烈要求下，KB侠决定暂别虚拟空间，开启现实冲浪。在大海中，他再一次被巨浪裹挟，冲上高峰，落入低谷。不过，他不再冲入各种漩涡，因为在这里他无处可躲无处可藏，他必须躲开这些漩涡以免葬身鱼腹。",
    "resoundEventStoryDes_427": "两座小丘……召唤巨大喷流。\\n红黑紫灰……我全都要。\\n小女孩……够了。\\n鸡……你……\\n泰……\\n果然，meme是有生命的！",
    "messageInitContent_11666": "害怕中",
    "messageInitContent_5382": "怎么少了一只",
    "resoundEventStoryDes_424": "王·罗密欧：你活着吗？\\n王·朱丽叶：当然活着！\\n王·罗密欧：我也活着，你我之间总有这么多巧合，可能这就是命运吧！",
    "messageInitContent_11665": "埋伏中",
    "messageInitContent_5381": "好大一根",
    "resoundEventStoryDes_425": "此处因常常能看见彩虹而命名。有的怪兽认为那是天空局部放出的气体，有的怪兽认为那是天空送出的芬芳。",
    "messageInitContent_11668": "隐身中",
    "messageInitContent_5384": "你猜猜少了谁",
    "resoundEventStoryDes_422": "王·罗密欧：呜呜，好伤心啊！\\n王·朱丽叶：？？？\\n王·罗密欧：你还记得5年前的今天吗？你第123次拒绝了我。\\n王·朱丽叶：你会记得这辈子吃了多少块神户牛肉吗？\\n王·罗密欧：你当时说，就算小船上一只怪兽都没有，它也没打算停下来等你，呜呜。",
    "messageInitContent_11667": "读秒中",
    "messageInitContent_5383": "景色不错",
    "resoundEventStoryDes_423": "王·罗密欧：“你可能会觉得如此婉丽的描述太过古怪，恐怕只有无可救药的情种，或是相思成疾的诗人才能说出口。你的想法没错，但这些字句却并不会因此而掺入半点虚假。”\\n王·朱丽叶：莎翁这一段写的真好。\\n王·罗密欧：是吧，所以……\\n王·朱丽叶：且不说你的口中的花言巧语是否精彩，是否掺假可不单单依靠语言判断的。",
    "resoundEventStoryDes_431": "地龙最喜欢的故事是《肖申克的救赎》，因为它总能从中受到启发，开拓前方的道路。",
    "resoundEventStoryDes_432": "神唤与天马、幻象之间隔着一道看不见的次元障壁。\\n就像是次元障壁与连接怪兽之间隔着的那道鸿沟。\\n尽是无奈……",
    "resoundEventStoryDes_430": "王·朱丽叶：造唤台为什么全年无休，为什么它们能问出这种问题！\\n王·罗密欧：对啊明知故问，爱永不停歇！\\n王·朱丽叶：你醒醒好吗？",
    "messageInitContent_11651": "形态变换",
    "messageInitContent_5397": "有点看不习惯",
    "randomEventDialogueGroupConfig_3.51": "它完全记不住10w字，晕了过去。",
    "messageInitContent_11650": "冲鸭，别思考",
    "messageInitContent_5396": "又来抢头条",
    "randomEventDialogueGroupConfig_3.52": "离开。",
    "messageInitContent_11653": "要火",
    "messageInitContent_5399": "帅的帅的 我说自己",
    "randomEventDialogueGroupConfig_3.53": "“那我给你一些？”#它向你打过来了。",
    "messageInitContent_11652": "热个身先",
    "messageInitContent_5398": "不够大啊",
    "randomEventDialogueGroupConfig_3.54": "战斗。",
    "randomEventDialogueGroupConfig_3.50": "“有些选择困难。”",
    "messageInitContent_11659": "不是丧尸打工模拟器",
    "randomEventDialogueGroupConfig_3.59": "老实说出你的难处",
    "resoundEventStoryDes_439": "只有地龙和一些不幸卷入其中的怪兽知道，有些沙暴并不是沙暴。\\n风沙之中，是马，是兽，是鼎沸的叫喊，是淹没的蹄声，是撕心的叫骂，是断肠的呼唤，是信仰的驻足，是忠诚的情谊，是无尽的箭雨，是阿育娅。\\n若然卷入这种大沙暴，就祈祷吧，祈祷那是蜃楼，祈祷能回到过去痛改犯下的罪行，祈祷能抓住那只名为地龙的救命稻草。",
    "messageInitContent_11658": "打波配合啊兄弟",
    "messageInitContent_5391": "更大了",
    "resoundEventStoryDes_437": "两行车辙向远处一直延伸，后面还跟着一行脚印，你仿佛听到了一个声音。\\n“知世郎想坐车。知世郎要坐车。”\\n车辙的终点似乎也是可以预测的。\\n“你这马怎么竟是用轮子走路的！”\\n“马就是用轮子走路的啊！”骑兵大喊道。",
    "messageInitContent_5390": "我裂了",
    "resoundEventStoryDes_438": "超进化委员会不知从哪学来了一种用于发布任务并附有报酬的东西。\\n值得庆幸的是，直至目前为止，还没有怪兽学到这东西的另一种用法，超进化大陆还没有老把戏（暂时）。\\n这个东西被称作悬赏树皮。只在这片树林制作和发布，久而久之，这片森林便有了悬赏林之称。\\n林中的树木多是粗矮的品种，树皮好撕不厚不薄且柔韧，撕下后约莫2个日月即可再生，撕开叶片渗出的汁液丰沛，颜色同怪兽一般黑。\\n只需要撕开叶片，涂上叶汁，即可制成一张悬赏树皮。\\n不少圣堂武士也在这里找到了它们的新工作，守护这些悬赏树皮和……\\n“一，二，三，四，五，六，……八！好了吗？”",
    "messageInitContent_11655": "友尽之路",
    "messageInitContent_5393": "更大更精神",
    "randomEventDialogueGroupConfig_3.55": "“小孩子才做选择，而我！选择了光辉灿烂的复读之道！”#它陷入了自我陶醉循环复读中。",
    "resoundEventStoryDes_435": "王·罗密欧和王·朱丽叶建造了一组冰雕纪念他们的新据点，左侧的王·朱丽叶冰雕冷艳高贵，右侧的王·罗密欧冰雕风流倜傥，两座还原度超高的冰雕将永远地深情对视直至……你的出现，将这组雕像的意象彻底粉碎。",
    "messageInitContent_11654": "快跑啊",
    "messageInitContent_5392": "更小了",
    "randomEventDialogueGroupConfig_3.56": "离开。",
    "resoundEventStoryDes_436": "这里曾是青铜五小强（又名晨光五怪）的据点，如今已经垮得差不多了，显然就没怎么用心修建。就剩一处石头上的秘密代号还隐约可见，结合自家怪兽探索回来的大讲特讲，事情迅速还原了出来。\\n智者分赐五小强神灵之号，让它们外出探索更有干劲。\\n提叉之兽，号为“天马”；吹箭之兽，号为“白虎”；呜拉之兽，号为“青龙”；执锤之兽，号为“幻象”；双剑之兽，号为“玄武”。\\n唯独叉叉觉得“天马”没有自己的特色，在“天马”的“天”上画了个叉，下面似乎想写“神”却写不了一点，然后补上自家怪兽的原话……\\n当时的提叉蒙面小怪就是这么自我介绍的：“我叫叉马，记住也好，记不住也好，反正名头不重要！”",
    "messageInitContent_11657": "人与人之间的信任",
    "messageInitContent_5395": "抱走零",
    "randomEventDialogueGroupConfig_3.57": "你自由了。",
    "resoundEventStoryDes_433": "“你知道吗？超进化大陆的和平象征就在这里！”\\n“怎么说？”\\n“他能将一切伤害变成治愈，他时刻用行动鼓励大家把一切伤害变为治愈，从而实现和平！”\\n“真的假的？他是谁？”\\n“他就是——王·狈·爷！”\\n“啊，这是我听过关于王·狈·爷的第二个地狱笑话……”\\n“嗯？第一个是什么？”\\n“超进化大陆又迎来了‘和平’的一天，因为那些不和平的怪兽都被王·狈·爷吃了。赞美食物链顶端之神！”",
    "messageInitContent_11656": "L4D？",
    "messageInitContent_5394": "武器不错，现在是我的了",
    "randomEventDialogueGroupConfig_3.58": "你是不是有什么难处？",
    "resoundEventStoryDes_434": "关于超进化大陆的七王有各种各样的传言，其中流传最广的当属七王有几位？\\n究其核心原因，就是六王，至今无人知道六王到底有多少怪兽。因为六王是贪婪的，一位不够，两位仍然不够，六王还要更多，乃至更多以上的更多更多，他们的数量如同他的贪念一样，持续越界、不断膨胀、难以估量……",
    "resoundEventStoryDes_442": "洞穴的入口相当隐秘，只有天选之兽才有缘误闯。整个洞穴的石壁都刻满了壁画，似乎记录了超进化大陆这次重启前的一切。",
    "resoundEventStoryDes_443": "此生命之树非那倒生之树，只是棵直白的生命之树。\\n它无比粗壮仿佛见证过上百年的事境，如今仍枝繁叶茂处处迸发着生机。\\n同时，它又散发着阵阵阴气，宛如地狱中爬出的恶鬼，让怪兽汗毛直立，冷汗狂流，那枝头上的东西决不能细看，一个个光洁的头颅，一双双扭曲的犄角，一片片柔顺的皮毛，些许双目紧闭的半脸，些许难以分辨的残躯，就像是这树结出的果实一般。\\n生与死交缠着化作巨蟒慵懒地挂在树上，不时地吐出它骇人的信子。\\n此时，一双手伸出，将一个头颅拿起，放在了帽檐之上。\\n原来这棵树不过是个首饰盒，属于王·朱丽叶的天然首饰盒。",
    "resoundEventStoryDes_440": "到这个温泉群泡的怪兽多是雄性。\\n一开始由于没啥规矩，所以来泡的怪兽也不少。\\n也由于没啥规矩，所以也来泡的怪兽也不多。\\n后来有个多事的智者给所有池子都取了名，什么规池、矩池、没规没矩池、规矩池、有没有规矩都行池，规矩自己想池、规矩自己改池。\\n里头反而闹得更凶了。",
    "resoundEventStoryDes_441": "相信这石壁上有一部分是幻想，一部分是写实。就是从这……到这。\\n从左至右刻着的一四脚生物，一两脚生物，还有它们的几种中间形态。\\n很可能是从*（mao）至*（niang）的数个化形阶段。\\n注意看这个最后阶段，就只剩下头上有毛了，这与某只叫喵什么响的怪兽有几分相似，至于这个初始阶段，似乎应按照那宇文姓大将军的猫的样子刻画更为恰当。",
    "messageInitContent_11640": "都给我正面刚！",
    "randomEventDialogueGroupConfig_3.62": "听下去",
    "randomEventDialogueGroupConfig_3.63": "不管它离开",
    "messageInitContent_11642": "通关提示：在下关",
    "randomEventDialogueGroupConfig_3.64": "它复读完你的难处，然后顿了顿。",
    "messageInitContent_11641": "任务开始",
    "randomEventDialogueGroupConfig_3.65": "它默默地转身离开。",
    "randomEventDialogueGroupConfig_3.60": "说别复读了行吗！",
    "randomEventDialogueGroupConfig_3.61": "它开始复读你的说的难处。",
    "messageInitContent_11648": "吃点怪兽吧",
    "messageInitContent_11647": "吞噬星球的粉色恶魔",
    "resoundEventStoryDes_448": "绿，千百种绿，不同层次的绿。\\n天空被绿叶遮蔽，树干被青藤或苔藓覆上，土地上挤满了青草和绿灌，就连那沿着绿林漫步的溪水也荡着碧波。绿就这样毫无疑问地成为了这座树林的名字。\\n江湖传闻中，不少英雄豪怪都出自这座绿林，大概就是怎样的林养怎样的怪，后来出自这片绿林的怪兽都被称作绿林好怪。",
    "messageInitContent_11649": "太邪恶了",
    "resoundEventStoryDes_449": "这山腰处的狭道，有二叉叉宽，底下是深不见底的山谷。\\n体型稍大的怪兽在此相遇多半需要有一只怪兽让出道来。不然要碰上一高霸气的，跌落多半就成了谷底游魂。\\n超进化委员会为了减少此类事故，在狭道两端的石壁上刻下了这个故事，提醒路过的怪兽注意别走错路。\\n狭道相逢多礼让，否则——\\n“来吧，亮兵器！”桐仁掏出兵刃示意对方让道。\\n叉叉伸手握住自己的叉，默默退后。\\n紧接着！亮出了在它身后的最终兵器！\\n“居然胆敢以双拳敌我双刀，敬你是条悍兽！来吧啊啊啊啊啊啊！”\\n桐仁还没叫完，兵器的拳已经收回，悠悠在桐仁身边飞过。\\n这狭道旁的一叉之隔处，被最终兵器生生锤了一条隧道出来。\\n否则——请往亮兵器隧道绕！",
    "messageInitContent_11644": "绕个路",
    "randomEventDialogueGroupConfig_3.66": "离开",
    "resoundEventStoryDes_446": "天上突然掉下了一本薄薄的树皮秘籍，上面画了两个大字《遁法》。\\n卷首写着“遁法乃是一门遁出生天的法门！”\\n后头的内容大部分都被撕毁了，看来这只算是《遁法》残本。\\n但若再细看，就会发现残页间还藏有一页，里面写着，真奇门遁法之一，死遁。\\n诸如无▇生还、借▇还魂、楚▇武公、乱▇之鬼、茅▇八等等，解明死里逃生之真意，就能掌握并熟习死遁。\\n要知道生机往往藏在死里，啊墨水用完了……",
    "messageInitContent_11643": "休息一下",
    "randomEventDialogueGroupConfig_3.67": "谢谢。",
    "resoundEventStoryDes_447": "遥望林间空地，二停顿相对而立，切磋比试。\\n看那指法，与传说中那依体内之力从大拇指指尖发出的指法有几分相似。\\n昔日，吾腿脚不便，便遣一叉叉前去，一探究竟。\\n殊不知，此叉一看便出了神。吾百般吆喝，皆无应。\\n其后又有兽入神观之，或一或数，已有百兽矣。\\n日来月往，斗转星移，至今竟有数十载。",
    "messageInitContent_11646": "次元胃袋",
    "randomEventDialogueGroupConfig_3.68": "指出感谢需要实际行动",
    "resoundEventStoryDes_444": "超进化大陆十大未解之谜之一，正是怪兽手中兵器的耐用度。\\n这些兵器是如何做到不折、不损、不朽的呢？因为在这个世界兵器是可以种出来的！\\n毕竟兵器这种用来保命的玩意，不多存一堆趁手的可怎么行。\\n而这里就是兵器长出来的地方，你只需要把兵器埋在土壤里，等十来个日月，新的兵器就会在这土壤里重生！\\n一块牌子插在这片坑坑洼洼的零星长着几根草的土壤之上，这牌子的最后一句写着：“如有怪兽让您以此法让兵器转生，请无需客气，揍就对了！”",
    "messageInitContent_11645": "超级欧气吸取",
    "randomEventDialogueGroupConfig_3.69": "安静离开",
    "resoundEventStoryDes_445": "远远就能闻到一股恶臭，寻着味道过去，可以看到杂草丛后有一长一短两条怪兽横着交叠在地面，血迹已经干了，伤势过重竟看不出原样，最上方插了一根鸭毛。这鸭毛在超进化大陆并不多见，若非王·狈·爷手中的武器，那便是王·罗密欧的腰带。莫非就是它们之一对这两怪兽下的手？又或者是……有谁为了隐藏身份利用此鸭毛嫁祸于王？",
    "resoundEventStoryDes_453": "此地有一块大石，大石较陡的一侧正对着太阳升起的方向，故得名向阳之地。\\n这大石则被称作日石，异常粗糙的表面有多处磨损的痕迹，智者提到能止痛的石灰恐怕就是从此石磨出。绕到大石后的缓坡，却看到一片阴森的尸林，若大胆细观之，便能察觉其怪异之处，此处的尸骸竟全是怪兽的下半身。上半身是为何要在此地舍弃生来就在一起的另一半，着实让怪费解。\\n走近大石继续探索，就能看到大石的纹路，似花又似字。其中又有数十处被毁，或利刃或钝器。这些花纹到底记载了什么，能叫怪兽如此心生怨恨呢，真是奇哉又怪也。",
    "resoundEventStoryDes_454": "若你路见不平想拔刀相助，一般的草丛绝不拦你。\\n若你路见密谈想偷听一番，一般的草丛绝不拦你。\\n但部分危险的草丛就不好说了，它们可是要收掩口费的！\\n那躲在石头、树或者花丛后面会不会好一点呢？\\n那要看看碰上的是不是崩界领主、风水老树或者花丸子、污妖王什么的。",
    "resoundEventStoryDes_451": "晨光五怪。\\n一说，叉叉、咻咻、呜呜祖拉、锤子、桐仁。\\n一说，山林多隐士、高崖不夺命、秘籍总遍地、奇遇又连连、有情兽终成……\\n胡说，都是桐仁胡说。智者听闻不禁摇头。",
    "resoundEventStoryDes_452": "龙族大多独居，但亦有少数龙族选择了另一条道，群居。\\n作为龙族第一大族群，它们群龙无首恰恰有数百个日月。族长不知所踪似已成定局。\\n又经过数十个日月，群龙已筹备妥当。\\n首先向焚烦峰飞去的是黯炎古龙与圣光古龙。\\n随后飞出的是逆焰龙王与钢铁龙王。\\n之后则是铁甲龙和荒火龙，暗黑龙和明光龙紧随其后。\\n最后抵达焚烦峰的是暴龙与轰龙。\\n焚烦峰峰顶，十二龙将黯灭围住，请它出山成为群龙之首。\\n这便是龙族族群流传已久的千里接龙头之礼，此处便是焚烦峰。\\n焦黑的峰顶上分明躺着十二具龙骨。",
    "messageInitContent_11629": "给个机会",
    "resoundEventStoryDes_450": "山上的这个小洞就像是怪兽毛发中的一根，毫不显眼。\\n洞中有一乱石堆，就像怪兽毛发中那撮异色的毛，极为显眼。\\n从石堆随便捡起一块石头，都能看到上面刻了个名号。\\n什么威震四方桐仁、晨光五怪之首、双刀桐仁、玉面大仁、飞火玫瑰通天仁、自家无敌桐仁、剑圣桐仁、怒目兽王桐仁什么的……\\n想必是桐仁自己刻下的，据说它每天都会从乱石堆中抽抓取十粒放入口袋带在身上，自报名号时便全部掏出连续念出。\\n虽然……名号还是其他怪兽口里提到的更加响亮。",
    "randomEventDialogueGroupConfig_3.30": "它仍旧复述了你的话。",
    "messageInitContent_11631": "万物皆可夹",
    "randomEventDialogueGroupConfig_3.31": "复述它的话。",
    "messageInitContent_11630": "看我的手抖大法",
    "randomEventDialogueGroupConfig_3.32": "离开。",
    "messageInitContent_11637": "关卡怪兽说话了",
    "randomEventDialogueGroupConfig_3.37": "它沉默了，又开始没有感情的复读。",
    "messageInitContent_11636": "想去其他关卡玩",
    "randomEventDialogueGroupConfig_3.38": "不再管它离开",
    "messageInitContent_11639": "怎么跳过关卡",
    "randomEventDialogueGroupConfig_3.39": "它艰难地跟上你的复读，但不久就精疲力尽地倒下了。",
    "resoundEventStoryDes_459": "这平原之上有一处突起的亭子，走近就会发现这个亭子有冰做的顶，顶上以干草枯枝覆盖，由于冰穹较高倒也不冷。如果碰巧撞上智者，你就能从它口中听到这冰亭的故事。那夜，仿佛神灵降怒般，昔日平静的原野骤然下起了暴雨，火神似乎是经过了一番死战后，勉强击败强敌后伤重倒地，恰巧冰霓路过，于是她一挥手，将连天的雨打成了这冰亭，生起火后，连夜踩着冰雨冲到智者的住所，将智者带到了这里，随后就消失在暴雨之中。",
    "messageInitContent_11638": "危险区危险区！",
    "messageInitContent_11633": "是的，一点都不配合",
    "randomEventDialogueGroupConfig_3.33": "它突然打断了复读，反问你。",
    "resoundEventStoryDes_457": "地上有一块破木块，有明显且粗糙的加工痕迹，上面写着“很想你”和画有智者的大头，周围散落了一些类似超进化委员会的封捆枝条。",
    "messageInitContent_11632": "不觉得那个夹子永远会在最后一秒打开",
    "randomEventDialogueGroupConfig_3.34": "它哇的一下哭了出来。",
    "resoundEventStoryDes_458": "越是平凡的峡谷，越能藏龙卧虎。\\n这里也不例外，虽无卧虎但藏龙无数。\\n因为传闻中异界有两大宝物让龙族最为忌惮，一套掌法和一把宝刀。而这两件宝物似乎就藏在此处，其一疑似是那套掌法的传人，自带BGM的MountainJo！其二则疑似是那把宝刀的持有者地裂！\\n欲要一统龙场的龙都潜伏于此，待那夺宝之日，得以号令天下。",
    "messageInitContent_11635": "今天也是蹲在关卡的一天",
    "randomEventDialogueGroupConfig_3.35": "安慰一下",
    "resoundEventStoryDes_455": "地上有一块破木块，有明显且粗糙的加工痕迹，上面写着“我在”，周围散落了一些类似超进化委员会的封捆枝条。",
    "messageInitContent_11634": "会掉回去的",
    "randomEventDialogueGroupConfig_3.36": "默默离开",
    "resoundEventStoryDes_456": "地上有一块破木块，有明显且粗糙的加工痕迹，上面写着“此地”，周围散落了一些类似超进化委员会的封捆枝条。",
    "resoundEventStoryDes_464": "看着这白云你可曾想起一位侠女说过：“你瞧这些白云聚了又聚，散了又散，人生离合，亦复如斯。你又何必烦恼？”",
    "resoundEventStoryDes_465": "这条路的这块平地曾经是凹凸不平的，是桐仁最近为了践行“路见不平拔刀相助”的精神，特地用手中的刀将路磨平了。",
    "resoundEventStoryDes_462": "这悬崖峭壁上有一处独特的客栈道，它既是客栈又是栈道，客房沿着峭壁而立，栈道又傍着客房而建。\\n不知建了多久，也不知由什么怪兽建成。不会飞又不会轻功，或者对自己轻功或实力不那么自信的怪兽而言，客栈道都是穿行此处，或落脚歇息的好地方。\\n疾风兔小二会在第一时间冲出来迎客。\\n如果只是普通过路，帮客栈道一个小忙就可以通过，诸如搬石头，盖茅草，打水之类的。\\n若要住店，只需拿出相应的物品交给小二即可住店，例如今日要住上房需要提供进化孢子，住中房需要提供金币。\\n上中下房由于位置不同风光亦各异，内饰也各不相同，有机会可以都一试。\\n顺便一提，智者特别推荐的房号是天字乙号！",
    "resoundEventStoryDes_463": "一只从天而降的巨掌打在了无辜的地表之上，自然就会留下一个坑。",
    "messageInitContent_11619": "长大发现游乐园已经没了",
    "resoundEventStoryDes_460": "这水潭坐落在陡峭的山岩之中，因数只陆龙常泡在这潭水中而得名陆龙潭。它们似乎出生不久就生活在此，靠着水潭之上的老枣树过日子，是罕见的非肉食陆龙。但这周围的森森白骨又是什么回事呢？它们又是怎么在其他强大怪兽的环伺下，存活如此之久，或许只有白骨间的枣子核知道答案。",
    "messageInitContent_11618": "小时候的梦想是在游乐园买票",
    "resoundEventStoryDes_461": "星秀派位于“星河灿烂，沧海天秀。”的星秀海边的一座悬崖之上。\\n掌门叫星秀老怪，是整个门派年龄最大资历也最深的怪兽。\\n星秀派的规矩很简单，就是“赞美至高”。\\n也正是因为太简单了，每一任掌门对此都有不同的理解。\\n前掌门认为，要多发现身边怪兽身上的美好之处并真诚赞美。\\n而现任掌门却认为，掌门就是至高，所以赞美掌门就好了。\\n门派招募节选：\\n把“恭颂掌门杨威星秀海岸赞”倒背如流即可成为本门入门弟子。\\n入门后，即可以开始修炼本门外功：摇旗呐喊敲螺打骨吹号角，这一层较为简单，肯用力用劲即可。\\n在第一层功法练熟之后，就可以由外至内，练习本门内功：马股功、海螺功、厚皮功。此等都是上乘功夫不便细说，期待你的入门。\\n恭颂掌门杨威星秀海岸赞:\\n略",
    "randomEventDialogueGroupConfig_3.40": "离开",
    "randomEventDialogueGroupConfig_3.41": "别复读了行吗！",
    "messageInitContent_11620": "他们说这个关卡有通关方法，但我怀疑他们指的是另一个游戏",
    "randomEventDialogueGroupConfig_3.42": "将它重新捆起来，并堵住它的嘴",
    "randomEventDialogueGroupConfig_3.43": "物理打断复读",
    "messageInitContent_11626": "看我发现了什么！",
    "randomEventDialogueGroupConfig_3.48": "告诉它你真的好难，此处省略10w字。",
    "messageInitContent_11625": "第一",
    "randomEventDialogueGroupConfig_3.49": "“没有难处。”",
    "messageInitContent_11628": "许愿双属性低重",
    "messageInitContent_11627": "我的盘！",
    "messageInitContent_11622": "那你很棒棒哦",
    "randomEventDialogueGroupConfig_3.44": "它一边复读着一边跑掉了。",
    "resoundEventStoryDes_468": "经过竹林这片空地的怪兽曾追求力量、追求权力、追求名望、追求认可、追求声色、渴望复仇、渴望不老、渴望真爱、渴望朋友或无欲无求。\\n数个日月后，它们可会突然记起这片空地。\\n辗转多年后，竟是一场空。\\n而那无求者，无求却尽有。",
    "messageInitContent_11621": "前面有个很大的宝箱，但我不建议你打开……我还没从里面出来",
    "randomEventDialogueGroupConfig_3.45": "离开",
    "resoundEventStoryDes_469": "视野极佳，喵草丰茂，仅此一角。\\n桐仁某天去放风的时候，发现喵响经常在这飞崖一角出没，苦思冥想多日后，让疾风兔去给御空送了一封信。\\n信中写到，“余偶遇一武功绝学，盼翌日日落与卿共赏，不知卿意如何？相信你已经猜到了，是的，我巢穴后的怪兽会后空翻！请务必来看看！”",
    "messageInitContent_11624": "天天开心",
    "randomEventDialogueGroupConfig_3.46": "我免费了！啊呸，我居然复读错了！我怎么会犯这种错误。赶紧换个地方再来一次好了。",
    "resoundEventStoryDes_466": "这里背山面海，兽迹罕至，可谓是个练就那招神掌的风水宝地。\\n在山高海阔间，放肆喊出这招神掌之名吧——排 山 倒 海 ！",
    "messageInitContent_11623": "溜溜真可爱",
    "randomEventDialogueGroupConfig_3.47": "“你是不是有什么难处。”",
    "resoundEventStoryDes_467": "这山顶是一些怪兽口耳相传的圣地，一些秘籍、藏宝图的终点。\\n日照之时，站在这山顶中心的怪兽全身上下会迸发出无量光明，仿如神迹。年长的怪兽会将自己的幼兽带到此处，它们希望被光明山顶的光芒包裹过的幼兽都能拥有各自光明的未来。\\n这里还有一个很隐秘的怪兽群体，它们自称光明教派。它们只会在月出之时，悄悄出现，为围绕山顶的石块拭去尘土，日复一日的对石块进行打磨，将日月之精华之光明赐予世间的众兽。\\n光明教派中又藏着一个暗月教派，它们称光明山顶为月出之塔，它们认为日月之精华不应与粗俗的世间怪兽分享，目前正蠢蠢欲动，此山中不少隧道都是它们偷偷挖凿而成，有兴趣可以去一探究竟，隧道里不会有什么会爆炸的东西的，大概。",
    "resoundEventConfigDes_3014": "朱丽叶的手指终于停在某只虚刃的额头上面。\\n“你。”\\n另外两只虚刃如获大赦，他们同情地看着瑟瑟发抖的同伴。\\n“大、大人……”\\n“我一早想试试这个了，希望你配得上我这份礼物。”\\n“咦？”不是扮演情敌或者自杀？\\n被选中的虚刃抬起头，看到朱丽叶大人的一只手掌上不知何时出现了一个紫色孢子团。\\n这不是两位大人往常赏赐给他们的孢子团吗？虚刃不解地想到。\\n而且，这个大小，还不如大人第一次赏赐给他的那个。这个毫无分量的“爱”是怎么回事？\\n“亲爱的，你到底……”\\n“大家都等等哟~”\\n朱丽叶向大家抛了个媚眼，然后深情地吻在孢子团上。\\n“噢！！”这个动作让罗密欧血脉偾张。\\n那丰满柔软的嘴唇！那深情款款的表情！这些不是自己专属的吗！？\\n吃掉孢子团的虚刃，不是等于和朱丽叶接吻了吗！？\\n罗密欧怒火中烧。突然，他醒悟过来——\\n噢！妒忌！朱丽叶要的就是妒忌！他瞬间做到了！欧耶！！\\n和被妒忌的怒火蒙蔽双眼的罗密欧不同，被选中的虚刃很快察觉到孢子团的异变，它与以往略带浑浊的紫酱色不同，是璀璨的水晶紫。\\n用尾巴想想就猜到这个孢子团的力量更大！\\n所以，他往前一步，忠诚地喊道：“大人，请相信我！我会成为一个更出色的仆人！”\\n“如你所愿。”\\n朱丽叶朝孢子团吹了一口气，孢子团便飘到虚刃嘴边。\\n在同伴艳羡的目光下，虚刃吞下了孢子团。\\n“哦哦哦哦哦！”\\n是会变成究极的咒刃还是血刃呢？虚刃无比期待着。但是——\\n当热流流淌了全身之后，什么变化都没有，虚刃还是虚刃的样子。\\n他的两个同族已经在窃笑。\\n“大人，他配不上这份礼物。”逆焰龙王补刀。\\n“不对哟~”朱丽叶神秘地笑笑，“过去我只在乎让你们快速进化，却忘记了你们本身的脆弱。揠苗助长果然不行。永恒的爱要以对爱人的忠贞为基础，破格的强大要以本源的强大为基础。这个世界，并没有规定‘幻化’能强到哪种程度哟~”\\n“亲爱的，你太有创意了！”罗密欧赞叹到。\\n“大人，就让我来试试他有没有超越幻化的力量！试试他有没有浪费大人的礼物！”\\n逆焰龙王跳了出来，没等罗密欧与朱丽叶允许，他就朝虚刃吐出一股烈焰。\\n虚刃慌忙躲开。\\n“亲爱的，他变厉害了。”\\n罗密欧赞赏的对象是虚刃，本来应该被秒杀、被烧成黑炭的他，竟然躲过逆焰龙王的三次攻击。\\n“当然，他是我们的爱情结晶哟~”\\n“结、结晶！？”罗密欧的心漏了一拍。\\n“因为你对我的爱，才让我的吻有这种力量。所以，那个孩子就是我们的爱情结晶哦！”\\n“噢噢噢噢噢噢噢！！爱情结晶啊！”罗密欧恍然大悟，兴奋得抱着朱丽叶的长腿连亲几口，“亲爱的能否赐予我更多爱情的结晶？”\\n“改天吧，这种魔法耗费了我巨大的力量。所以，你要更爱我，只要爱才能恢复我的力量。”朱丽叶望着头顶盘旋的异兽，打了个呵欠。\\n罗密欧心痛极了，自己怎么可以任性地要求爱人过分操劳呢？\\n他在朱丽叶的长腿上再度深情地奉上一吻。\\n“亲爱的，快去睡吧，我是属于你的，世界是属于你的。为了证明我对你的爱，我会为你奉上全世界……”\\n逆焰龙王和虚刃的追逐已经转移到石堡外，虚刃虽然还是处于劣势，但毫发无伤。\\n突然，一颗巨大的流星划过夜幕，长长的尾巴像是用一把硕大的刷子在天空中狠狠地刷了一把，擦出无比奇异的光芒。\\n流星差点砸中逆焰龙王，雪土飞扬中，一片冰晶弹到逆焰龙王身上，戳穿了他坚固的铠甲。\\n这本来是虚刃临死前才能发动的技能，但他现在竟然能在仓皇之下发动，让逆焰龙王吃了不少苦头。",
    "resoundEventConfigDes_3013": "罗密欧与朱丽叶居高临下地相拥着，一群怪兽在他们脚下匍匐着、争夺着，仿佛在为他们的爱情唱和。\\n突然，朱丽叶想起了什么，虽然没什么大不了，那只是他们征服大陆中飘起的几粒尘埃，况且征服大陆也只是顺便，他们来到这里，是为了续写他们好几千年前戛然而止的伟大爱情。\\n但是，不把几粒尘埃清除掉，总有点碍眼。\\n“对了，亲爱的。有一座石塔中的召唤具被抢去了。”\\n“我听说了，那群蠢货！放心吧，我不会让那些异变者打扰我们的爱情！”罗密欧咬牙切齿。\\n“不，他们不足为惧。”\\n“但我想把所有召唤具都献给亲爱的。我会再派部下去——唔……”\\n朱丽叶用手指捂住罗密欧的嘴唇，指尖的馨香让罗密欧迷醉。\\n“如果不是亲爱的要用它们制造一盏小夜灯，来装饰我的房间。那些没用的玩意儿，我也没多稀罕。但是呢……竟然有连这么简单的工作也完成不了的笨蛋。”\\n“唔唔，他们都逃回来了，还有脸问我要更多的孢子，结果当然被我二话不说地赶到地牢里面去。怎么，亲爱的想杀掉他们吗？其他的倒无所谓，但那只不朽级的蠢龙，有点可惜呢。”\\n“不，我只不过想他们长进点。如果仆人犯错就要死掉，那么我们相爱之外的事情，不就没人帮我们做了吗？”\\n“所以亲爱的只是想教训教训他们？”\\n罗密欧在暗自责怪自己为何不能与朱丽叶心有灵犀。\\n三只幻化级的虚刃和一只的逆焰龙王被带了上来。\\n“两位大人，请原谅我们！”\\n逆焰龙王匍匐在朱丽叶和罗密欧的脚下，虚刃们也跟着跪倒。\\n“你们选择了一条光荣但充满了艰险的路呢，你们也受到了足够的庇护。我还以为你们已经足够脱颖而出……”\\n朱丽叶迈着长腿在他们之间穿梭，语气中带着惋惜。\\n“请大人不要抛弃我，下一次，我发誓不会再失败！”逆焰龙王向着地板喊道。\\n朱丽叶笑了笑，逆焰龙王偷偷瞄了她一眼，她的神情不再让他紧张。\\n“但亲爱的，要怎么惩罚他们呢？”罗密欧问道。\\n“……惩罚？我突然改变主意了。我要给予他们……爱！”\\n“爱？！”\\n颤抖的叫声发自罗密欧。\\n“亲爱的……除了我……你还要爱他们吗？”\\n“因为嘛，嫉妒能让亲爱的更爱我，充满怒火的爱，会让我们的爱情更炽热！呵呵呵呵呵呵呵……”\\n朱丽叶半掩着嘴角，因为自己的疯狂想法而兴奋不已。\\n“既然亲爱的喜欢这种爱，我不会让亲爱的失望的！”罗密欧握紧拳头，决心满足朱丽叶的所有要求。\\n妒忌心什么的，简直不要来得太简单了！\\n朱丽叶用一根修长的手指在逆焰龙王和虚刃头顶徘徊，被手指扫过的怪兽如要躲开巨大的压力般，向左边或者右边偏斜着身体。\\n没有什么比朱丽叶大人爱的告白更可怕了。无论是假装成罗密欧大人的情敌和他决斗，还是为朱丽叶大人殉情喝毒药甚至刺死自己，都是让他们宁愿冒死逃跑或者自我监禁起来的选项。",
    "messageInitContent_11608": "俗话说得好",
    "resoundEventConfigDes_3012": "超进化大陆最北端的冰川谷是尸族的领地。\\n再往北是什么呢？没有人知道，狂风和暴雪阻挠了往北者的步伐。连不朽级的怪兽也很难穿越阻隔在冰川谷和极北之地间的暴风雪。\\n但是，只要穿过那片暴风雪，就会发现极北之地是一片平静得让人绝望的地方。\\n连雪花也失去了生命，连寒风也失去了呼吸。\\n此处正是比冰川谷还要广阔和寒冷的地域。\\n极寒的空气中，大地也被冻结。\\n一座古朴的石堡矗立在冻土之上，石堡的正厅中央，一个巨大的火炉正释放着浓浓暖意。\\n火炉边上有一圈铸造台，几个灵族、木偶族和尸族的幼体正拿着锤子在铸造台上叮叮当当地敲打着什么。\\n“亲爱的罗密欧，我喜爱凄美的悲剧，但这次，我想得到的是惊喜。”\\n一位有着漂亮的中分卷发的绅士，把一位有着一双长腿的窈窕淑女领入正厅。腿部修长的轮廓在她的礼服裙中若隐若现。\\n他的身高只有她的一半，但两者站在一起，竟如天造地设般登对。\\n对待让他倾心的朱丽叶，罗密欧像对待女皇一样，极尽亲切之能事，恳求她来看他近日的进展。\\n他知道，朱丽叶期待着奇迹的发生，而他，是不会让她失望的。\\n见到他们进来，所有怪兽都跪下了。他们的表情诚惶诚恐，害怕大人们因为失望而不悦。\\n“没什么两样啊。”朱丽叶看了看火炉，用失望的语气说道。\\n“你们退下。”\\n罗密欧打了个响指，负责往火炉添柴和敲打的怪兽都安静地退到一旁。\\n“把他们带上来。”他继续对身后的守卫下令。\\n很快，四个尸族的腐化者押着两只荒火龙进来了。\\n“荒火龙？这有什么好稀奇的，只要让陆龙和暴龙吞下我们的孢子，我们想要多少荒火龙，就有多少荒火龙。”\\n朱丽叶皱了皱眉头，如果不是看在对罗密欧的爱的份上，她才不愿从房间的阳台中走出来。\\n罗密欧每天都会爬上那个阳台，为的是得到她的一吻。\\n今天，这个甜蜜的惯例却被打断了。\\n“亲爱的，虽然古老的进化之法缓慢而低效，但却能让这些低等生物可以长时间维持他们的力量。”\\n“真亏他们能撑到这里呢。”\\n“是的，如果是其他幼体和幻化，恐怕早就冻死在路上了。”\\n两只荒火龙被押至火炉旁边，腐化者用枪在他们的背后戳了几下。\\n荒火龙不情不愿地开始朝着火炉喷火。\\n火势是刚才的十倍！\\n“工匠”怪兽们被吓了一跳，一只木偶族的皮诺丘大胆地凑近火炉，身体却被飞溅而来的火星点燃。\\n“哦？”\\n朱丽叶迈着优雅的步子走近火炉，目不转睛地看着里面的熊熊烈火。\\n她示意一只幼尸继续刚才的工作。\\n幼尸用火钳把一枚圆形的铁块放进火炉中，然后数了五下，再把铁块放在锻造台上，一锤下去，铁块中央出现了一个清晰的几何图案。\\n朱丽叶着迷地接过铁块，白皙的肌肤在接触到通红的铁块后丝毫没有损伤。\\n她用左手握着的那根造型精美的法杖碰了碰铁块，铁块就变成了一枚泛着戮魔钢般黑光的纹章。\\n“好漂亮的野性纹章……”朱丽叶赞美道。\\n一直以来的造唤计划终于了有进展。\\n“荒火龙喷出的火焰，才够热度烧软戮魔钢。”罗密欧说。\\n“真亏亲爱的能想到这个方法。”朱丽叶展露的笑颜让罗密欧心醉。\\n“有了荒火龙，这个造唤台就可以永远工作下去！不断制造属于我们的怪兽、孢子、武器和纹章！”\\n罗密欧的目光如炉火一样熊熊燃烧着。\\n“可是，我们只有两只，他们始终会倒下的。”\\n“就让我为亲爱的再多捉几只回来，让他们轮流喷火。那些愚蠢的龙族根本没发现他们的同族失踪了。”\\n“亲爱的，还是你最有办法！”\\n朱丽叶抛开纹章，仪态万千地蹲下，依偎在爱人身边。\\n“朱丽叶大人，这枚纹章……”\\n“你们谁想要就拿去吧。”\\n听到她这样说，正厅中的所有怪兽都扑向那枚能增加伤害的野性纹章。",
    "messageInitContent_11607": "天天想着发达",
    "resoundEventConfigDes_3011": "后面的三组英雄确实让朱雀头痛。\\n一为神志不清之混沌者。\\n一为逞强好胜之挑战者。\\n一为容颜盛美之自我者。\\n看来石塔的力量只是随意赠予有缘的远古族，而并非经过甄选的救世英雄。\\n真·日夕甚至没有留心听自己说话，而是把大部分心思放在她的外表变化上面。幸亏她对这种变化非常满意，打败邪王的信念和信心也随之高涨起来。\\n“帮助姐姐？别开玩笑了！说不定被邪王蛊惑两句，她就会以为对方是某种充满善意的存在。”\\n日夕拒绝朱雀的提议，她一向不赞同姐姐的理念。\\n“打败邪王的事就交给我，我会让他见识到什么是美与正义！”\\n说罢，日夕张扬着更灿烂的美和光芒，离开了朱雀。\\n“邪王正在壮大……到底，能相信这几组英雄到何等程度呢？”\\n看着日夕远去的身影，朱雀的低语在微风中消失。\\n日夕匆忙离开，一来是因为不想再听朱雀唠叨，二来是不想暴露自己体内另一个意识的害怕和不安。\\n她们在意识的虚空中相互对望时，都对彼此的外貌非常满意，然而，这个小姐姐很快就陷入慌乱之中。\\n不过，是心理质素过于强大还是过于差劲？小姐姐很快就构建起自己正在游戏之中的“现实”。\\n嘛……只要她别再歇斯底里地尖叫，就让她相信这种“现实”好了。\\n一切由自己掌控，一切由自己救赎。",
    "resoundEventConfigDes_3010": "超进化大陆中有许多选择独自生存的怪兽，他们大多数是究极级的怪兽，而少数幻化则用他们的小心翼翼来对待随时会出现的危险。\\n独来独往的暴虐战狂正是这些怪兽的偶像。\\n这位远古族不但打败过木偶族、灵族和尸族的族长，还和龙族的族长打个平手。\\n至于暴虐战狂的实力与远古族的两位英雄——古拉姆和埃癸斯相比如何，怪兽们还无从得知，因为暴虐战狂每次前往古拉姆和埃癸斯的部落挑战都扑空了。\\n一些不怕死的部落战士向暴虐战狂发起挑战，然后落于下风。显然，暴虐战狂并没有手下留情。也许是部落战士的视死如归被暴虐战狂看在了眼里，暴虐战狂每次把他们打至半死，便收手离去。\\n大概是被暴虐战狂激起了斗志，传闻这些落败的战士们之后还特地请求他们的酋长加强对他们的训练，想要以更猛烈的战斗回敬对方。\\n暴虐战狂最近一次前往远古族的部落，正是各族族长来开会的时候。暴虐战狂又扑了个空。\\n不过，他却听到了十分有趣的传闻。\\n那些石塔里竟然驻守着连龙族族长都会落败的怪物。也就是说，如果自己能打败石塔，龙族族长就再也没有挑战价值。\\n想到这里，暴虐战狂马上动身。\\n出现在晨光草原的石塔就留给古拉姆他们吧，他可不屑于在别人门口抢吃的。\\n而且，他要挑战的，铁定是最高的那座！\\n他记得，在石林荒野那里，有一座直插云霄的石塔。\\n可惜，当他花了好几天赶到那里的时候，石塔已经被一支诡异的队伍征服，为首的是一名不朽级的龙族——逆焰龙王。\\n竟然出现了不朽级的怪兽？不过，来得正好！\\n逆焰龙王身上的橙金色流动让暴虐战狂的战意沸腾起来！\\n与他的战意同时燃起的还有四周的火焰。\\n以暴虐战狂为圆心，五步的距离为半径的火焰圈不断刮着热风。\\n这个火焰圈开始逐渐缩小，不，应该说是在不断朝着圆心的暴虐战狂靠近，扩大着燃烧的区域，直至形成一堵谁都无法逃脱的厚火墙。\\n那正是逆焰龙王所创造的火焰区域。\\n在火墙之外的逆焰龙王正哈哈大笑着，笑声因杀戮的愉悦而扭曲。\\n他本应飞到对方头顶，用一束致命的烈焰结束敌人的性命。\\n但是，烈焰龙王产生了一种用火圈慢慢折磨死对方的想法。\\n再过一会儿，那头蠢兽就会变成一堆黑炭了吧！不过，说不定最里面的肉还是香嫩多汁的！\\n而火圈之内，似乎陷入死地的暴虐战狂也愉悦地笑了。\\n看似毫无破绽的攻击，一下子就被暴虐战狂想到击破的方法。\\n风向似乎变了，一股狂风横扫火圈，张狂的火焰像被风压低了身子的稻草。\\n逆焰龙王只露出一瞬间的诧异，但马上又放松下来，火是他最熟悉不过的东西，是他身体的组成部分。只是一阵荒野之风把火吹偏而已。\\n完全没有防备的逆焰龙王就这样迎来了暴虐战狂的痛击。\\n什……么……？！\\n战斧的轨迹在火墙的上空大幅横扫——狂风来自暴虐战狂的战斧。\\n在火墙变得低矮的瞬间，暴虐战狂从火墙中跳了出来。\\n虽然火墙很快又恢复了原来的高度，但猎物已经不在里头。\\n此刻，胜负已经决定了。\\n暴虐战狂一斧劈下，逆焰龙王甚至还没理解到底发生了什么，就倒下了……\\n宝物啊……\\n看来是只能让远古族进化的奇怪东西，要不，刚才队伍里的其他究极应该一早用来进化了，暴虐战狂看着自己变化了的身体想到。\\n而和自己合体的家伙，不仅爽快地接受了穿越的事实，还相当乐在其中！\\n接下来该做什么呢？\\n石林荒原的石塔看上去巍峨入云，但里面的怪物既然被逆焰龙王打败的话，也不过如此。\\n其他石塔会不会有更厉害的对手？带着这份好奇和誓要亲手征服一座石塔的决心，暴虐战狂继续踏上他的挑战之旅。\\n这段日子以来，大陆出现石塔的消息已经不是什么秘密，暴虐战狂很快从沿途的其他怪兽口中打听到其中一座石塔的所在。\\n第二座石塔的怪物还挺带劲的，可惜功亏一篑。\\n不止是最后一击被半路杀出来的远古族横插一手——暴虐战狂完全没想过自己才是横插一手的人，而且宝物也不能让自己再次进化。\\n只好寄希望于那个远古族进化到不朽之后再与之一战。\\n可是，她磨磨蹭蹭到自己都不耐烦了！\\n就在自己想直接开杀——虽然胜负早已猜到，但这样能逼对方马上进化的话——塔外出现了一股更强大的能量。\\n正好！就让它来承受自己满溢的战意吧！\\n但是……\\n无形之物要如何攻击？\\n那只火鸟自称朱雀，没经过同意，就把自己一路以来在战斗中落下的大小伤口全部疗愈了。更过分的是，他接下自己的全力攻击以后竟毫发无损。\\n哼，原来传说中的神灵就是这样子吗？\\n那种几乎苦口婆心的劝说令人生厌！搞什么？把自己看作弱者？还让我往北方去？\\n不过，自己最后还是被他打动了。\\n邪王啊……\\n单是名字就充满了邪恶与力量，但愿是个值得挑战的目标。\\n考虑到进化成不朽的古拉姆和埃癸斯就在往北的路上，值得去碰碰运气。\\n一路的不爽终于有回报了。",
    "messageInitContent_11609": "你好，我叫俗话",
    "messageInitContent_7925": "1,带关卡数字的是关卡独特规则",
    "messageInitContent_7926": "1160。什么你也是60卡",
    "messageInitContent_7923": "2.如果同一个关卡同时存在2条相同的规则那么该关卡的规则可能存在污染",
    "messageInitContent_7924": "2.如果同一个关卡同时存在2条相同的规则那么该关卡的规则可能存在污染",
    "messageInitContent_7929": "2.金字也意味着真实但这里没有金字",
    "messageInitContent_7927": "2。如果你挑战下一关了，那不要再挑战下一关",
    "messageInitContent_7928": "1160。懂了2张废卡",
    "messageInitContent_7932": "1161。请保持耐心",
    "messageInitContent_7933": "关一下战挑要不。1",
    "messageInitContent_7930": "0.挑战失败并不可怕",
    "messageInitContent_7931": "1161。请先种植向日葵",
    "messageInitContent_11615": "门票10金币",
    "22_dish11366": "熬夜季军火锅",
    "messageInitContent_11614": "确定是哪个名字？",
    "messageInitContent_11617": "小吃9金币",
    "messageInitContent_11616": "雨衣100金币",
    "messageInitContent_11611": "带上我",
    "messageInitContent_11610": "想玩十环过山车",
    "messageInitContent_11613": "我想玩飞机转转转",
    "messageInitContent_11612": "谁陪我着摩天轮",
    "messageInitContent_7936": "1.带有.的规则一般是正确的，可以相信",
    "messageInitContent_7937": "1。如果叉叉与【】同时存在，且关卡存在叉叉，那么那一关是安全的",
    "messageInitContent_7934": "8，按下挑战后，若有任何迟疑，立刻重启游戏",
    "messageInitContent_7935": "1162。希望之光带着绝望的光环",
    "messageInitContent_7938": "1162。进化的力量就在这里。",
    "messageInitContent_7939": "1。请勿在整点调整阵容",
    "messageInitContent_7940": "【信息被涂鸦】",
    "messageInitContent_7943": "2。如果你挑战下一关了，那不要再挑战下一关",
    "messageInitContent_7944": "1.如果你在挑战过程中有人找你 请优先处理找你的",
    "messageInitContent_7941": "1163。水物馆有一个馆的编号是错的。看指南的时候需要注意一下。",
    "messageInitContent_7942": "1.留白的规则可以改写",
    "messageInitContent_11604": "别把自己绕进去了",
    "messageInitContent_11603": "原地自闭冠军",
    "messageInitContent_11606": "大师，请问我什么时候发财",
    "messageInitContent_11605": "和空蝉斗智斗勇",
    "messageInitContent_11600": "贪吃祈",
    "messageInitContent_11602": "内卷教父？",
    "messageInitContent_11601": "嗯？",
    "unlockDes_3": "祖龙族觉醒怪兽的图鉴收集数达{1}",
    "unlockDes_4": "尸鬼族觉醒怪兽的图鉴收集数达{1}",
    "unlockDes_1": "谜之生物等级达{1}级",
    "unlockDes_2": "单次暴走旷野中选择「血条补完」增益次数达{1}",
    "unlockDes_7": "远古族怪兽拥有红色品质的极化技能数大于等于{1}",
    "unlockDes_8": "单次暴走旷野中选择「霸气冲阵」增益次数达{1}",
    "unlockDes_5": "星灵族觉醒怪兽的图鉴收集数达{1}",
    "unlockDes_6": "木偶族觉醒怪兽的图鉴收集数达{1}",
    "2_14": "浴火重生使己方怪兽受到致死的伤害时不会死亡，持续{1}秒",
    "messageInitContent_7947": "1164。【】使人懒惰",
    "2_15": "浴火重生为怪兽回复时，溢出的回复量将转变为护盾",
    "messageInitContent_7948": "0.挑战失败并不可怕",
    "2_16": "破阵瞬杀",
    "messageInitContent_7945": "1164。含见的深渊未变异实体",
    "unlockDes_9": "单次暴走旷野中选择「逮虾户！」增益次数达{1}",
    "2_17": "攻击血量最少的敌方怪兽，使其损失{1}%+{2}的血量",
    "messageInitContent_7946": "【信息不完整为确保安全实施遮盖】",
    "2_18": "己方怪兽真实伤害提升{1}",
    "2_19": "破阵瞬杀伤害提升{1}，并使敌方怪兽每秒损失{2}%的血量，持续{3}秒",
    "messageInitContent_7949": "相真的部全诉告你会则规条一何任有没。1",
    "messageInitContent_7950": "2。谜语怪兽只有1个。",
    "messageInitContent_7951": "1165。不要带着冰淇淋进入此关",
    "2_10": "浴火重生使己方怪兽每{1}秒回复{2}%的血量，持续{3}秒",
    "messageInitContent_7954": "1.无需畏惧危险",
    "2_11": "浴火重生使己方怪兽受到的伤害降低{1}%，持续{2}秒",
    "messageInitContent_7955": "发动少女贴真之光，真之光叫效果拉量子巨龙",
    "2_12": "浴火重生回复血量提升至{1}%",
    "messageInitContent_7952": "【该信息无法被识别】",
    "2_13": "浴火重生为血量百分比最少的己方怪兽额外回复{1}%的血量",
    "messageInitContent_7953": "1。.矛盾是正常的",
    "randomEventDialogueGroupConfig_54.7": "-",
    "randomEventDialogueGroupConfig_54.6": "-",
    "randomEventDialogueGroupConfig_54.9": "-",
    "randomEventDialogueGroupConfig_54.8": "-",
    "randomEventDialogueGroupConfig_54.3": "丢掉悬赏令",
    "randomEventDialogueGroupConfig_54.2": "出发",
    "randomEventDialogueGroupConfig_54.5": "-",
    "randomEventDialogueGroupConfig_54.4": "-",
    "2_25": "反伤结界",
    "messageInitContent_7958": "这量子巨龙是几脚啊",
    "2_26": "己方怪兽获得{1}%的反伤效果，持续{2}秒",
    "messageInitContent_7959": "冲冲冲",
    "2_27": "己方怪兽每{1}秒回复血量{2}",
    "messageInitContent_7956": "嗯？？？",
    "2_28": "反伤结界生效后每{1}秒清除1次所有负面效果",
    "messageInitContent_7957": "没有四脚就是0了",
    "2_29": "反伤结界生效时怪兽每被攻击1次回复{1}%的血量",
    "messageInitContent_7961": "1.请勿揭示【】中的内容",
    "messageInitContent_7962": "【内容已损坏】",
    "messageInitContent_5300": "咻咻你要多吃点",
    "2_20": "破阵瞬杀伤害提升{1}，并使敌方怪兽血量回复效果降低{2}%，持续{3}秒",
    "messageInitContent_7960": "狠狠地推开我吧！！",
    "2_21": "破阵瞬杀伤害提升{1}，并可把敌方怪兽拉向己方",
    "messageInitContent_5302": "对比？",
    "messageInitContent_7965": "1167。在广东话中这是个神奇的数字",
    "2_22": "破阵瞬杀伤害提升{1}，产生的所有负面效果不能被清除",
    "messageInitContent_5301": "问此处咻咻的作用",
    "messageInitContent_7966": "2.金字也意味着真实但这里没有金字",
    "2_23": "破阵瞬杀伤害提升{1}，使用后己方怪兽攻击力提升{2}%，持续{3}秒",
    "messageInitContent_5304": "懂了，要比战墙高",
    "messageInitContent_7963": "8，按下挑战后，若有任何迟疑，立刻重启游戏",
    "2_24": "破阵瞬杀能量消耗上限变为{1}，破阵瞬杀伤害提升{2}",
    "messageInitContent_5303": "不是兄弟",
    "messageInitContent_7964": "1.重复的留言是迷途者的标记",
    "randomEventDialogueGroupConfig_54.1": "黄沙中躺着一张悬赏令，你将它捡了起来，发现奖赏颇为丰厚，目标是将神秘商人从东集市护送到西集市。",
    "2_36": "己方怪兽攻击力提升{1}",
    "messageInitContent_5306": "小心背后",
    "messageInitContent_7969": "用适再不则规；后成完战挑关卡在。1",
    "2_37": "巨龙再临生效时己方怪兽被击退时忽视敌方霸气{1}%(含直接击退距离)",
    "messageInitContent_5305": "有一种独特的松弛感",
    "2_38": "巨龙再临生效时己方怪兽移动速度提升{1}%",
    "messageInitContent_5308": "下一关见",
    "messageInitContent_7967": "关一下战挑要不。1",
    "2_39": "巨龙再临效果提升至{1}%",
    "messageInitContent_5307": "辛苦你再缝合一次了",
    "messageInitContent_7968": "1168。这里直抵星穹",
    "messageInitContent_5309": "只要发挥一点点想象力",
    "messageInitContent_7972": "【无法加载内容】",
    "messageInitContent_7973": "1,带关卡数字的是关卡独特规则",
    "2_30": "反伤结界生效时怪兽每被攻击1次提升{1}秒持续时间",
    "messageInitContent_5311": "我又可以了",
    "messageInitContent_7970": "【信息不完整为确保安全实施遮盖】",
    "2_31": "反伤结界生效时血量回复效果提升{1}%",
    "messageInitContent_5310": "什么小怪兽开小马车",
    "messageInitContent_7971": "1170。长期摇滚",
    "2_32": "反伤结界反伤效果提升至{1}%",
    "messageInitContent_5313": "大小搭配干活不累",
    "messageInitContent_7976": "1171。这到底是加工什么？？",
    "2_33": "反伤结界持续时间提升{1}秒",
    "messageInitContent_5312": "你又可以了",
    "messageInitContent_7977": "【无法加载内容】",
    "2_34": "巨龙再临",
    "messageInitContent_5315": "越大越天真",
    "messageInitContent_7974": "1.在此关卡挑战完成后；规则不再适用",
    "2_35": "己方怪兽提升{1}%的攻击力和霸气，持续{2}秒",
    "messageInitContent_5314": "大一点就叫大人了？",
    "messageInitContent_7975": "【该信息无法被识别】",
    "2_47": "禁断魔咒会使敌方怪兽的攻击力降低{1}%",
    "messageInitContent_5317": "好粗的藤",
    "2_48": "禁断魔咒会使敌方怪兽的移动速度降低{1}%",
    "messageInitContent_5316": "前面好粗",
    "2_49": "禁断魔咒会使敌方怪兽的霸气降低{1}%",
    "messageInitContent_5319": "总觉得人间大炮很想咬一口但忍住了",
    "messageInitContent_7978": "1.在此关卡挑战完成后；规则不再适用",
    "messageInitContent_5318": "是大了，但只有一点",
    "messageInitContent_7979": "1.留白的规则可以改写",
    "messageInitContent_5320": "真大炮",
    "messageInitContent_7983": "1172。kb侠也是电子界",
    "2_40": "巨龙再临持续时间提升{1}%",
    "messageInitContent_7984": "1172。没有剪刀啊",
    "2_41": "巨龙再临生效时己方怪兽造成伤害的{1}%用于回复自身血量",
    "messageInitContent_5322": "我还可以呼吸",
    "messageInitContent_7981": "【信息被涂鸦】",
    "2_42": "消耗{1}点或以上的能量召唤青龙时，巨龙再临额外提升远程怪兽{2}%的攻击力，近战怪兽{3}%的霸气",
    "messageInitContent_5321": "这舌头我可以",
    "messageInitContent_7982": "1。请勿在整点调整阵容",
    "2_43": "禁断魔咒",
    "messageInitContent_5324": "制杖巨人首次和它的名字达成了共识",
    "messageInitContent_7987": "8，按下挑战后，若有任何迟疑，立刻重启游戏",
    "2_44": "封印敌方怪兽的所有技能，持续{1}秒",
    "messageInitContent_5323": "这样玩是吧",
    "messageInitContent_7988": "【##############】",
    "2_45": "敌方怪兽霸气降低{1}",
    "messageInitContent_5326": "塔塔开！",
    "messageInitContent_7985": "1172。前方跳入空间漩涡",
    "2_46": "禁断魔咒会使敌方怪兽受到的伤害提升{1}%",
    "messageInitContent_5325": "进击的巨兽",
    "messageInitContent_7986": "觉睡入睡下按请。1",
    "messageInitContent_7980": "1.专属规则可能会出现序号异常",
    "2_58": "旷野疾风会使己方远程怪兽的射程提升{1}%",
    "messageInitContent_5328": "下一关就对了",
    "2_59": "旷野疾风会使己方远程怪兽的体型缩小{1}%",
    "messageInitContent_5327": "努力思考其结构",
    "messageInitContent_7989": "1174。他就是瞳晶的创造者。",
    "messageInitContent_5329": "聚精会神中",
    "2_50": "禁断魔咒会使敌方怪兽血量回复效果降低{1}%",
    "messageInitContent_5331": "氛围妖娆",
    "messageInitContent_7994": "【信息被涂鸦】",
    "2_51": "麒麟禁断魔咒的移动速度降低效果提升至{1}%，该负面效果不可清除",
    "messageInitContent_5330": "巨巨晶？",
    "messageInitContent_7995": "1175。付费规则如下【】",
    "2_52": "旷野疾风",
    "messageInitContent_5333": "原来我的怕怕有尾巴",
    "messageInitContent_7992": "3.带有，的规则是假的要注意甄别",
    "2_53": "己方怪兽提升{1}%的移动速度和负面效果持续时间降低{2}%，持续{3}秒",
    "messageInitContent_5332": "全都吃了放大镜是吧",
    "messageInitContent_7993": "1175。请勿使用外带逗猫工具",
    "2_54": "己方怪兽移动速度提升{1}",
    "messageInitContent_5335": "这位置刚刚好",
    "messageInitContent_7998": "3。如果你还是挑战了，那么先退出登录后，再重新登录",
    "messageInitNick_7498": "爱因斯不舒坦",
    "2_55": "旷野疾风会使己方怪兽免疫减速效果",
    "messageInitContent_5334": "巨像见到也要喊一声好",
    "messageInitContent_7999": "1176。不要揭开鱼皮下的东西。",
    "messageInitNick_7497": "随行保温",
    "2_56": "旷野疾风会使己方近战怪兽的体型增大{1}%",
    "messageInitContent_5337": "你怎么知道我更",
    "messageInitContent_7996": "1176。披着鲨鱼皮的【】",
    "2_57": "旷野疾风触发时会使敌方怪兽被击退{1}码",
    "messageInitContent_5336": "我觉得不够大",
    "messageInitContent_7997": "【信息不完整为确保安全实施遮盖】",
    "messageInitNick_7499": "东方战神",
    "messageInitContent_7990": "1。请在整点调整阵容",
    "messageInitContent_7991": "2.金字也意味着真实但这里没有金字",
    "resoundEventConfigDes_3005": "晨光草原东北方的尽头，有一角陆地和草原旁边的那片广阔异域相连。\\n海水涨潮的时候，它们看上去是两片独立的大陆。\\n如果想从晨光草原走到异域，可以等到退潮的时候。两片大陆相连的地方会变成一道潮湿的浅滩。\\n日夕就是这样来到异域的。\\n异域的土地和河流都是黑紫色的，给人一种灾疫遍地的感觉。北部的群山寸草不生，南部的平原稀疏地点缀着几棵钩爪棘。不过，在如此恶劣的土地上，居然有一棵世界树生长在东部的平原上。\\n平时，部落中有专门的怪兽负责来这里采集孢子团，日夕只听他们说过异域的情况，她的想象里这里只是一个普通的荒原。\\n现在——\\n裙裾上沾满了泥土、全身沾满了海水的腥臭味儿、漂亮的长发上还沾着几滴月海鸥的鸟粪！\\n原以为十分轻松的旅程却让她异常烦躁。\\n和“月”有关的东西也让她异常烦躁。\\n明明是双胞胎姐妹，为什么日轮和月轮却差那么远？如果她也拥有能直冲云霄的座驾——名字她也想好了，就叫“驰骋云端之日轮”，去哪里都只是眨眼之间的事。\\n日夕嘴上拒绝姐姐的同行邀请，但其实心里另有打算。\\n她本来想跟踪姐姐到石塔，趁机夺取石塔赐予的宝物。\\n嘛，她倒不是那种对亲人背后插刀的女孩，只是与其让心慈手软的姐姐获得进化，还不如让她利用这份力量，马上让邪王见不到第二天的太阳！\\n就这么想着的时候，部落里几个笨蛋吞下了紫色的孢子团。\\n总不能把他们扔下不管。\\n就这样错过了跟踪姐姐的时机。\\n正在那时，出现第四座石塔的消息传到部落。\\n果然，真正的女神是会得到上天庇佑的！\\n日夕握着拳头兴高采烈地出发。然而，好心情被沿途的“风景”消耗殆尽。\\n虽然很快找到石塔，但里面的东西让日夕忍不住呕吐——\\n一团巨大的腐肉正在挪动着，它张开大嘴，日夕正好看到一条粪绿色的舌头闪闪发光地躺在满是黏液的牙床上，满是龋洞的尖牙上挂着更多的腐肉，有一个坏牙坑里还流着血糊糊的脓流。\\n日夕自从在洞外闻到一股酸腐的臭味时就屏住了呼吸，现在她有点撑不下去了。\\n不仅如此，那团腐肉还在不断膨胀，本来沾满眼屎的两只眼睛现在已经被膨胀出来的肉团挤到体内了吗？\\n再膨胀下去，自己不是被它压扁，就是被它吞噬！\\n日夕向它发动了几下攻击，可是，被击至流出脓血的腐肉很快就被新长出来的肉团覆盖。\\n能逃出去吗？\\n再寻找下一座石塔就好了！\\n但是，不知是有意还是无意，肉团在接下日夕的攻击的时候，也渐渐把她逼至离石塔出口最远的地方。\\n忍不住了，再不呼吸，自己会被自己憋死。\\n在日夕放弃抵抗恶臭空气的一刹那，肺部贪婪地吸入大量酸腐的气体。\\n后悔了！\\n感觉脸部开始腐烂，还不如死掉！\\n话说即使屏住呼吸，腐肉团的口气还是会喷在身上，说不定那时候就开始毁容了！\\n然后，在腐肉团的口水滴在日夕头上的瞬间，日夕确信自己被恶心的液体淹死了……\\n超进化大陆最美丽的女神竟然死在最丑陋的敌人口水中，可以说是流传千古的极品笑话了吧……\\n不知道过了多久，日夕听到耳边传来凌厉的风声。\\n是自己的灵魂被卷进虚空中的地狱吗？不对，前往地狱的道路为何还有那股口臭？而且自己的头发依旧黏成一团？\\n通往地狱的道路好歹友好一点啊！",
    "resoundEventConfigDes_3004": "在异世界突然多了一个妹妹，对身为独子的欧文来说真是一种异样的体验。月夕告诉过他，日夕几乎和她长得一模一样，现在知道妹妹如此担心“自己”，欧文对这个世界的不安便减少了一分。\\n“我们现在要去找她吗？”欧文试探性地问道。\\n两姐妹应该是在石塔到部落之间的那段路上彼此错过了，所以要找也未必能找得到。可现在主导权不在自己手上，便姑且友善地问问，自己最想做的当然是尽量收集异世界的情报，寻找回去的方法。\\n“不，我们先去找智者。”月夕坚定地说道。\\n不能浪费妹妹的争分夺秒，妹妹一定希望智者尽快查出紫色孢子的问题。\\n欧文很开心，有这么一个通情达理的拍档，不安感再次减轻一分。\\n见到三位智者的时候，他们正在围着变异的孢子团。他们老态龙钟的样子让欧文想起了某些内阁成员。\\n“噢……这不是月夕大人吗？看您的样子，一切都很顺利啊。”\\n三位智者都牵强地笑了笑，以稍微惊诧的表情表达他们对月夕成功进化后的兴奋——实际上连开心都说不上，欧文觉得他们就像是在金融风暴损失严重、但偶然得到一张50美金购物券的人。\\n连月夕也觉得奇怪，她完全没有期待智者也像众星捧月地崇拜她，但他们愁云惨淡的样子是怎么回事？\\n月夕简单地说了说进化的经过，并让欧文和智者们打了声招呼。\\n欧文的第一次和“内阁成员”的聊天就这样简单结束了。\\n“这些变异的孢子团，你们发现什么了吗？”\\n你一言我一语，三位智者越讨论越悲观，孢子团上的负能量波不断撩拨着他们脆弱的神经。\\n“可能这是被加入特殊配料的孢子。”\\n“或者被阴沟莓染色了。”\\n“反正一定是邪王的阴谋，我们反击得太迟了。”\\n“哎呀呀，完全没有抵抗的手段呐……”\\n面对已经进化过的月夕，和只渴求智力发展的智者，紫色孢子团的诱惑力意外地失去了作用，但它们正用另一种形式影响着月夕和智者。\\n月夕感到自己的内心涌进一股虚空和无力感。\\n“这样的邪王，我们能打败吗？还是……干脆投降？”月夕也灰心起来。\\n“月夕，振作一点！”\\n月夕突如其来的沮丧让欧文很意外，什么也做不了的他只能用喊的让月夕清醒起来。\\n“呀？！我刚才说什么了！”\\n月夕意识到自己的失态。很危险呢，只是靠近这些孢子，就会产生消极的情绪。几天前第一次见到这些孢子时，它们还没有这样的威力。\\n月夕甩甩头，像要赶跑自己的软弱，抱着绝不退缩的决心握紧拳头。\\n“大家不要靠近它们！”\\n月夕来到孢子团跟前，她双手放在孢子团上面，像往常给失血过多的怪兽治疗那样。\\n孢子团被一片银白色的光芒覆盖，诡异的紫色慢慢褪去，但是，原本健康的绿色和红色也被紫色带走，最后孢子变成一团黑灰，飘散于空中。\\n月夕倒退两步，刚才的“治疗”耗费了她巨大的体力，但看来是无法让变异的孢子变回原来的样子。\\n“月夕大人，现在该怎么办？”一位智者问道。\\n“在古拉姆、埃癸斯和我都不在的这段期间，三个部落就交给你们，严密看守孢子仓库、防止身份不明的怪兽潜入部落、发现变异孢子团要马上烧掉，这三个是优先级最高的任务。万一出现变异的怪兽，就让日夕帮忙给他们治疗。”\\n月夕一口气部署了接下来的工作。\\n三位智者一边听，一边点头如捣蒜。\\n他们就像农业部长、国防部长、卫生与公共服务部长，还未谋面的“妹妹”则是这里的副总统，欧文想到。\\n这里的怪兽只重视身体上的进化，社会架构还处于低级阶段，说不定上天让自己来到异世界，就是为了让这里进化成更高级的文明社会。自己念书的时候不是还梦想过成为国家的财政部长吗？\\n如果只是建立简单的货币制度，自己还是有自信在短期内做到的！\\n等等，怎么能悠哉游哉地想这些有的没的。得尽快找到回去的办法，成为新一代的金融街之狼才是自己的梦想。\\n愿意融入异世界，成为其中的一份子——他慌忙打消这种危险的念头。\\n离开三位智者后，巨大的弯月又出现在月夕背后。\\n“请上来。”\\n月夕邀请道，即使欧文没有拒绝的余地，月夕还是等欧文说了一声“好的”才坐上弯月。这种既淑女又绅士的态度让欧文这个来自高度文明社会的精英人士很受用。\\n“我们现在去哪儿？继续向北吗？”\\n“嗯。大概用半天就能追上古拉姆。虽然我还是想先和邪王谈一谈，但万一的时候也有两个不朽的远古族应对。”\\n月夕刚说完，弯月已经飞出一百多米。\\n她的体能远不及古拉姆和埃癸斯，但弯月的移动速度却远在他们之上。",
    "resoundEventConfigDes_3003": "刚走进村子，大家便很快觉察到以进化之姿归来的月夕，欢呼着前来迎接，还有几只怪兽向真·月夕撒了一把又一把的花瓣。\\n月夕轻轻地甩动一头银发，似乎沾上银光的花瓣纷纷落下。\\n如果自己穿着一套笔挺的礼服走在月夕旁边，会不会像一场小型婚礼？欧文想。\\n不不，明明是共同体，自己已不是那种看到漂亮女生就会荷尔蒙飙升的年纪，怎么想到那种地方去了？\\n欧文羞愧地摇摇头，并敦促自己马上把注意力集中到眼前。\\n这里更像是一个连城邦也说不上的村落，在大家簇拥着月夕回月之殿的路上，欧文听说了很多重要的信息。\\n比如月夕还有一个妹妹，日夕。\\n比如进化孢子和强化孢子是相当于黄金和粮食的重要资源。\\n比如奇怪的紫色孢子有点像很容易就上瘾的大麻。\\n坏消息是，有好些幼体级的怪兽经不住诱惑吞食了紫色孢子进化到幻化级，但他们的神志却陷于一种奇怪的状态，口中不停低吟着“爱”地向北前行。\\n他们在接受了日夕的治疗魔法后，正昏睡在守卫森严的木屋里。\\n这让月夕想起那支走向北方的队伍，她把这件事告诉了欧文。\\n“……事情比我想象得要严重，我之前太天真了。”\\n月夕愧疚地对欧文说。\\n月夕没有回去月之殿，而是直接来到日之殿，但日夕并不在这里。\\n“副酋长大人把剩余的紫色孢子送到三位智者那里去之后，就离开了。”\\n一个部下说道。\\n本来这件事，大家打算等酋长大人一回来就跟她说的，但是进化后的酋长大人实在太太太美丽了，所以就这么把重要的事情忘记了。\\n“副酋长去哪里了？”月夕担心地问道。\\n“她没说。”\\n“她该不会去找你了吧？”欧文以正常人的思维猜测道。\\n“呀！我曾说过要找邪王问清楚。”\\n月夕也以正常姐姐的心思说道，并开始担心起妹妹来。\\n“果然是太担心姐姐了。”\\n如果两人的对话被那位以自我为中心的女神听到，她恐怕会毫无顾忌地飒爽大笑：“谁在担心你呀！”\\n她拥有和姐姐不分伯仲的美貌、和一头同样光滑的银发，但细看之下，她的银发中会闪烁着点点金光。\\n可惜她现在没有从容的余力了。\\n月夕更猜不到妹妹此刻正身陷险境。",
    "resoundEventConfigDes_3002": "熟悉的玻璃屏幕、熟悉的亮光、电量还有百分之五十二，当然信号是没有的，但是把它握在手心，却有一种在异世界遇到亲人般的喜悦。\\n但这是怎么回事啊……？\\n微信、微博和QQ全部都显示着网络连接失败。\\n电话果然也一个都打不出去。\\n让林宇翔沮丧的不是没有信号，而是这些事情全都不由分说地让他接受一个事实——自己根本不是在游戏里面。\\n他一直不想认清这个事实。即使向古拉姆发问或者发牢骚，都是关于“游戏”方面的问题，现在想来，古拉姆不理他也不奇怪，因为完全听不懂。\\n原本打算游刃有余地通关……\\n原本打算成为一个桀骜不驯的高玩……\\n穿越到异世界什么的，在男频小说和二次元世界中是家常便饭，但在现实中，不是天文学概率的事吗？居然也被自己碰上了……\\n所以自己在原来的世界里是死了吗？还是完全消失了？\\n突然，林宇翔坐在地上哭了起来。\\n古拉姆看着流淌在自己手上的液体——一个战士眼中怎么能流出这种耻辱的液体！\\n但是，哭泣从几近崩溃的灵魂中传来，一阵又一阵如涨潮海浪般的难过把他的怒气扑灭，他的心也理所当然地难过起来，仿佛变成他人的一般。\\n“那个……有什么好哭的……”\\n古拉姆话到嘴边又吞了下去，说安慰别人的话是他的弱项，他给其他人的鼓励顶多只有“站起来”、“再来”、“只是到这种程度吗”这类气势汹汹的话。\\n怎么才能让这家伙止住眼泪呢？\\n不过，幸好这家伙现在完全把自己封闭在悲伤之中，他很轻易地重新掌握了身体的控制权。\\n古拉姆看到掉在地上那个东西——这家伙刚刚就是因为发现这东西而狂喜。\\n这东西是他的武器？\\n还以为是新盔甲的一部分。\\n表面已经暗下来的“武器”，在古拉姆触碰的一瞬间又亮了起来，并瞬间显示出真·神剑古拉姆的样子。\\n古拉姆被吓了一跳。\\n原来只是一块镜子？\\n所以这不是武器？\\n这家伙打算战斗的时候还要分心照看自己的仪容吗？\\n古拉姆刚才好不容易按捺下去的怒气再度上扬，抓住“镜子”的手指不禁愈发使劲。然后——\\n“喀嚓”一声，“镜子”闪烁出一阵强光，古拉姆眯起了眼睛。\\n强光很快消失，定格在“镜子”中的是真·神剑古拉姆被惊吓到的样子。\\n“你在干什么？”\\n林宇翔也回过神来，他看着手机中那张莫名其妙的自拍照，有点哭笑不得。\\n眼角带泪、上下唇却向不同方向裂开——活脱脱一个表情包！\\n“哈哈哈哈哈哈……”\\n林宇翔被古拉姆——也是自己这副模样——逗笑了，帅气中带着逗逼的喜感和一丝睥睨天下的神气。\\n“我说，咱们是彼此看不顺眼吧。”林宇翔说。\\n“没错！”古拉姆也毫不掩饰。\\n“那么，从现在开始，我也会拼死变强的！”\\n林宇翔看着手机中的自拍——也是自己和古拉姆的第一张合照，那是主角的模样。\\n“哦？你也终于认真起来了？”古拉姆兴致盎然地回应道。\\n“别说我不提醒你，我是个认真起来，连我自己都怕的男人。”\\n“但愿如此！”\\n“呼——那么，从现在开始，我是‘不高兴’，你来负责‘没头脑’！”\\n这样的组合在任何冒险故事中都是所向无敌的。\\n林宇翔努力而坦然地接受全部事实，总之，自己既然变成异世界的战士，就要倾尽全力完成异世界的使命，回家的路，一定会出现在使命的尽头。\\n“为什么？该生气的是我。我的剑断了！”\\n“背井离乡的不是你。而且，一直为某件事闹别扭，就是没头脑的表现——啊啊啊啊小心点别把我手机捏碎了！要不放回去原来的地方如何？”\\n古拉姆想把这个叫“手机”的东西狠狠捏碎后扔掉，但是被林宇翔用“我的武器能和你的断剑合体成一把新剑哦”这种毫无逻辑毫无根据的理由及时制止。\\n“合体？”\\n“我们不是合体了吗？那我们的武器也该合体，不是吗？”\\n“……为什么不在进化的时候进行合体？”\\n“这个嘛……”\\n林宇翔焦灼地催促自己快想出一个能令古拉姆信服的理由，不不不，也不能太焦躁，否则古拉姆会意识到自己在骗他。\\n要自信从容地诉说一个事实一般……想到了！！\\n“因为我的武器能量不足啊……现在只有一半的能量。”\\n林宇翔指引古拉姆去看手机屏幕上方那个表示电量的标志。\\n“唔……只有一半是绿色的。”古拉姆很快就看懂了那个标志。\\n“只要让它再次充满能量，就能和你的断剑合体成一把威力无比的大剑，就是这样！”\\n“就是说它不止是一块镜子？”\\n“当然不止，它的功能多着呢！”\\n林宇翔胡扯了一堆有的没的武器技能，包括其实只是闪光灯的“电光闪烁”、其实只是自拍的“震兽之貌”。\\n“既然我们的武器都只剩下一半，不是更应该马上合体吗？”\\n啊啊，真是的，偏偏在这个时候这么细心，要怎么回答好呢？林宇翔焦急地想。\\n不过，如果古拉姆就这样全盘相信了，自己会担心他这样的智商如何能打败邪王吧。虽然在这个组合里，自己是拥有智慧的一方。\\n之后古拉姆又问了很多问题。\\n不知不觉地，在林宇翔和古拉姆的攻防战中，这部普通的手机变成了一件几乎无所不能、最关键是能让旧武器升级的神器——当然是在充满能量的情况下。\\n此刻，古拉姆正用赞许和期待的眼神看着手机。\\n经过林宇翔的一番挑剔，古拉姆把手机藏好在胸部的护甲中。\\n对于林宇翔来说，手机是唯一让他还和原来的世界联系在一起的东西。只要手机还在自己身边，无论中途的战斗会多么艰难、但最后能说着“虽然发生了很多事，但我还是回来了”的这份希望就不会熄灭。\\n在这段旅程终了之时，希望剩余的电量还够他拍一张照片作为留念。",
    "resoundEventConfigDes_3001": "啊，竟然在游戏里度过了这么漫长的时间……现实中不知道过了多久，可能只是过了几分钟吧。\\n这几天以来，身体的支配权在古拉姆手中，林宇翔虽然什么也做不到，但是还是发现到了不少东西。\\n和古拉姆说话的时候，就跟正常情况下的说话一样，不过声音只能被古拉姆听到。而只是在脑瓜里打转的想法，则不会和古拉姆产生意识上的共通。\\n但如果想法过于强烈，还是会被对方感知得到。\\n尽管如此，直接说出口的吐槽和暗自或重或轻的抱怨都无差别地被古拉姆无视了。\\n唯一让林宇翔感到开心的事，是确认了自己的五感还在工作。\\n视野中永远是一片原始的自然景观。\\n那几个水藻团子怪异的味道还久久留在口腔中。\\n古拉姆并不像人类那样按时进食，虽然偶尔也会采摘一些野果食用，但更像是在吃零食。\\n对他们来说，强化孢子和进化孢子才是真正的主食。\\n强化孢子能使怪兽的力量增强，而进化孢子则能让他们进化到更高的级别。这是古拉姆唯一一次认真回答林宇翔的问题时说的。\\n不管吃下的是进化孢子还是强化孢子，吃下以后，都会有一股热流在体内流淌。\\n至于听觉方面，林宇翔从来没有听古拉姆哼过歌，也难以想象这种文艺系的行为会出现在他身上。沿途倒是遇到一些不怕死上来挑战的弱鸡怪兽，几次下来，原先害怕的武器相撞声也变得习以为常。\\n此外，古拉姆每天都会挥剑一万下。新躯体的双手皮肤粗糙，还长着一层硬茧。\\n但是，古拉姆的心情在每天挥剑练习的时候是最糟糕的，他对自己那把断剑又爱又恨，林宇翔再不会看气氛，也不敢在这个时候跟他说话。\\n不过，今天实在忍不住了……身体的某个地方，实在被搁得难受，刚开始以为是盔甲的问题，现在越来越觉得那里存在着某种异物，这家伙这么多天里都浑然不觉吗？\\n“那个……”\\n“嗨！哈！喝！！”\\n“我说！屁股那里——”\\n“嚯哈！！！”\\n不妙，刚鼓起的气势马上被对方的吆喝压了下去，像往常一样，被故意漠视了。\\n可恶！又被无视了！\\n自己也是这个身体的主人！总不能让玩家全程都在跑CG吧，也该轮到我控制了吧？\\n林宇翔连日以来被无视的怨气终于积累到极限，一直被无形的枷锁束缚着行动力也随着怒气的高涨而爆发——\\n“呀——”\\n当古拉姆挥剑挥至九千九百九十九次的时候，流利有力的动作突然嘎然而止，断剑掉在地上，双手不可控制地摸向后腰部盔甲往下的地方。\\n“你你你在干什么！”\\n一瞬间失去身体控制权的古拉姆以自己从没想过的姿势，用双手在屁股后面乱摸。他连睡觉也不曾解开的盔甲，在很久很久以前就成了他身体的一部分，林宇翔的举动等于在侮辱他身为战士的尊严。\\n“你让我摸一下那是啥！”\\n林宇翔的怨气和古拉姆的羞耻感化作两股怒气在体内交战，真·神剑古拉姆的身体倒在地上，和杂草纠缠在一起。\\n这次争夺以林宇翔稍胜一筹为结局，他在“自己的”屁股后面摸到一个熟悉的块状物体时简直欣喜若狂——",
    "2_69": "死亡判决造成的伤害提升至{1}%",
    "messageInitContent_5339": "为什么变大的不是我家玖璃",
    "messageInitNick_7494": "花环尾戒",
    "messageInitContent_5338": "大起来了",
    "messageInitNick_7493": "清香的蟠桃",
    "messageInitNick_7496": "行为艺术家",
    "messageInitNick_7495": "可降解拖鞋",
    "messageInitNick_7490": "引战大师",
    "messageInitNick_7492": "不需要眼泪",
    "messageInitNick_7491": "繁华独角戏",
    "2_61": "死亡判决",
    "messageInitContent_5342": "这个岛在笑",
    "2_62": "对屏幕中央的敌方怪兽造成其当前血量×{2}%的伤害，最大伤害为己方攻击力最高的怪兽的攻击力×{3}%",
    "messageInitContent_5341": "这下面是个岛吗",
    "2_63": "敌我双方怪兽受到的伤害提升{1}%",
    "messageInitContent_5344": "好粗景色",
    "2_64": "死亡判决会使敌方怪兽眩晕（伤害，移动速度，攻击速度变为0），持续{1}秒，该负面效果不可清除",
    "messageInitContent_5343": "我喜欢小的",
    "2_65": "死亡判决会使敌方怪兽受到的伤害提升{1}%，持续{2}秒",
    "messageInitContent_5346": "为什么没有广东蟑螂",
    "messageInitNick_7487": "红坑女王",
    "2_66": "死亡判决会蒸发敌方怪兽的子弹",
    "messageInitContent_5345": "喜欢多整点",
    "messageInitNick_7486": "你是故意的吧",
    "2_67": "死亡判决会使敌方怪兽血量回复效果降低{1}%，持续{2}秒",
    "messageInitContent_5348": "对对对",
    "messageInitNick_7489": "衣架破坏者",
    "2_68": "死亡判决会清除敌方怪兽所有的增益效果",
    "messageInitContent_5347": "有两条触须四舍五入就是",
    "messageInitNick_7488": "披着虎皮的猫",
    "resoundEventConfigDes_3009": "经常有人戏称邬羽刹的旅行社是死亡旅行社，邬羽刹不但不生气，还很开心地拿这个名号到处宣扬，而且他的生意还有增无减。\\n因为他的旅行社提供的都是挑战极限的冒险之旅。\\n老板是他，导游也是他。\\n每个顾客参团前都要签下生死状，里面包括了会严格遵循邬羽刹的要求做好一切旅行准备的约定。\\n不过，即使顾客愿意百分百听从邬羽刹的指示行动，也不代表邬羽刹一定会做他们的生意。\\n身体素质不好的顾客，他不接。\\n只是想用一段冒险经历作为以后吹嘘资本的顾客，他不接。\\n不信任他的顾客，他不接。\\n即使这样，旅行社的生意还是络绎不绝，有人甚至从国外飞到蒙古来报团，更有不少著名的越野车品牌找邬羽刹测试自家的车子。\\n邬羽刹是蒙古人，他最拿手的是穿越邻国新疆和内蒙古的无人区。\\n这次的旅程比较轻松，北疆的无人区相较于南疆的更安全。\\n南疆的雨水比北疆的雨水少，所以南疆的沙漠是移动沙漠，北疆沙漠的植被因为冬雪融水而存活，沙土被植被固定后，还算坚固。\\n由五辆越野车组成的车队驾驶在离开白雪皑皑的喀纳斯景区的山路上，他们准备前往一片戈壁滩无人区。\\n选在12月份出团，也是因为邬羽刹受某新品牌的委托测试他们车子的性能。对方还叮嘱邬羽刹要亲自驾驶他们的车。\\n阿勒泰市区中已经堆满积雪，但马路还是非常平坦，这多亏了市政府安排的铲雪车，而市内的车子频繁地在路上行驶也在一定程度上减少了积雪。\\n但喀纳斯景区的山路就不同了，积雪已有半米厚，连排水沟也覆盖严严实实。天气预报说接下来会有连日的大雪，如果不赶紧下山，他们就会被困在景区里好几天。\\n在积雪的山路上行驶，夜晚比白天安全，车头灯会照出积雪不同的层次，有经验的司机很快能分辨出哪里是路，哪里是雪。\\n可是为了在封路前赶紧下山，他们只能在白天尽快赶路。\\n一路上，不断有车子陷入路旁的排水沟里。每当发生这种小型事故，邬羽刹或其他司机只好让车上的人下车后，驱动车子用绳子和搭钩把事故车子拉出来。\\n于是，平时一小时不到的路程走了好几个小时。\\n时间快来到傍晚，邬羽刹终于把一辆翻陷的车子拉出来，准备再次上路时，他听到微弱的呼救声。\\n有人催促邬羽刹快点离开，如果再耽搁，他们说不定会被掩埋在白雪之下。\\n有人坚持救人。\\n邬羽刹犹豫了一下，朝着呼救声传来的地方走去。\\n倒不是因为他善良，而是他的内心被一种躁动的情绪鼓励着，对未知的险境产生强烈的好奇。\\n那是一辆挂在山腰一棵树上的小轿车，轿车已经被白雪覆盖，说不准哪一片雪花会成为让其坠落的最后一片雪花。\\n为了向经过的车辆求救，小轿车的一边车窗打开了一小半。可以想象，车里的人差不多该冻僵了。\\n用小轿车来冬天的北疆，一看就是毫无经验毫无准备的自驾游客。\\n邬羽刹心里骂了一句，但还是从车中拿出救援绳准备救出受困者。\\n“那我们的车呢？”一个受困者焦急地问道。\\n“车就别管了！”邬羽刹喊道。\\n车队中除了自己和四个司机，其余的都是乘客，救人的事只能由自己亲自去做。\\n呼……没想到在景区也会遇到生死存亡的状况，不过，遇到自己，算他们命大。\\n邬羽刹把救援绳的一端绑在自己越野车的拖车钩上，然后小心翼翼地拉着绳子滑落到受困车辆旁边。\\n车内只有两人，似乎是一对年轻的情侣，看起来问题不大。\\n以防在他们爬出车子时车子会从树干上滑落，邬羽刹让他们同时绑上救援绳。\\n不能用力打开车门导致车身受到震动而下坠，受困者慢慢地从车窗爬出来。\\n邬羽刹拉着他们慢慢地爬上去。\\n快大功告成的时候，突然，他感到腰部一松——\\n山上和身旁都传来尖锐的惊呼声。\\n视野急速往上飙升，在白蒙蒙的一片中，他唯一看清的，是拖车钩（还是拖车钩的某个零件？）从越野车的车尾脱落，和自己一样做自由落体运动，向山脚坠去。\\n是刚才用它来拉动翻陷的车辆导致使用过度？\\n还是车子的质量原本就不过硬？\\n*的！那么多的测评费（其实就是广告费），当初自己就该当心点！\\n邬羽刹在陡峭的山坡上连滚了几个圈，感觉自己四肢和脸部都被雪下的岩石擦伤。更糟糕的是，滚落的过程中救援绳缠紧了自己的身体，想伸手抓住身边的石块或者树枝都做不到。\\n这回恐怕会粉身碎骨吧……\\n这么想着的邬羽刹，不知道下一瞬间将迎来第二次生命。",
    "resoundEventConfigDes_3008": "李雨蒙有轻度的社交恐惧症，她在办理大学入学手续的那一天，就在学校附近租了一个十平方米的单间。\\n为了每个月一千块的租金，李雨蒙做起游戏直播。\\n如果说宅在家里做什么最自在，就是打打游戏、叫叫外卖、再打打游戏了。\\n一开始的时候她还不敢露脸直播，和陌生人面对面交流是她的死穴。\\n可惜她的操作只有中等水平，对游戏也没有非常独特的见解，所以粉丝数寥寥可数。\\n但是，自从某次她在摄像头前意外露出秀丽的面容后，人气在一夜之间有了爆发式的增长。\\n含有“女神”二字的弹幕从每一帧画面中狂涌而来，粉丝和路人请求李雨蒙露脸直播的呼声越来越高。\\n直播停了两晚。\\n重新开播的时候，化了淡妆、戴着鸭舌帽的李雨蒙羞涩地向观众问好。\\n停播的那两天，她特意为自己买了几套衣服，还练习了一个上手难度不大的淡妆。\\n自此之后，李雨蒙成为了一个小小小小网红。\\n每个月的房租也有着落了，还能买更多的新游戏和大家分享。\\n她那种有点笨拙的操作还被粉丝们善意地看成一种毫不做作的“萌”。\\n不过，在学校里李雨蒙总是脂粉不施，再戴上一副圆圆的黑框眼镜，没有人能认出来她就是某个二次元网站中颇有人气的美女主播。\\n即使能在网上和粉丝对答如流，她还是不想和现实生活中的人发生任何关系。\\n唯一一次联系，就是通过email联系了某个一直吐槽她的粉丝。\\n李雨蒙曾一度怀疑他是个黑粉。\\n但他不会人身攻击，顶多只会在自己误操作的时候说些尖酸刻薄的话，但令人讨厌的是他还以为自己说话多有趣。\\n李雨蒙最后判断他不是黑粉，但很可能是一个键盘侠。\\n终于忍不住反击的那晚，她正在和大家分享一个操作难度高、线索隐藏得极深的恐怖游戏。\\n本来她一个人呆在出租屋里就够害怕的，而且那晚还停电了！\\n为了不让等待她的粉丝失望，她强压下心中的恐惧坚持直播，并祈祷在手提电脑和手机（作为wifi）的电量耗尽之前来电。\\n那晚大部分粉丝都是暖心的小棉袄，一边鼓励她、一边和她一起找线索。\\n恐怖的夜晚变成了美好的夜晚——如果不是某人一直在讥笑她“脸滚键盘”。\\n虽然不是一个高玩，但普通玩家的尊严她还是有的！\\n直播结束之后，李雨蒙马上点入那个粉丝的空间，地毯式搜索他发布过的任何话题、照片和视频，可惜结果无聊得让人乍舌。\\n他只是一个无比平庸的青年。\\n平庸得让她有点失去了挑衅的兴趣。\\n不过，李雨蒙还是为他购买了一个激活码。\\n那个游戏的安装包可以在官网免费下载，只要购买一个激活码，就能进入游戏。\\n她把激活码email到对方的邮箱，并写了一封言辞挑衅的信——有种你也直播。\\n邮件很快显示已读，但对方并没有回复。\\n第二天，李雨蒙就后悔了。\\n万一对方玩得比自己好太多怎么办？\\n万一对方因此和自己杠起来怎么办？他看起来就很像杠精唉。\\n万一自己被“人肉”怎么办？\\n幸运的是，接下来的几天，邮件还是没有回复。而且对方的空间动态完全停止更新。\\n唔，这样就好。\\n就当白送了一个游戏给别人。\\n今晚，李雨蒙的心情特别好。\\n她化了一个美美的妆，准备和观众分享另一个新游戏。\\n不过，她才向大家献上一个飞吻，身体就凌空飞了起来，甚至来不及对着镜头喊“救命”。\\n随着李雨蒙的消失，一堆弹幕奔涌而来，但她再也看不到大家在说什么。\\n有人以为那是特效，有人以为那是恶作剧，大多数人等了没多久就退出李雨蒙的直播空间，只有少部分真爱粉一直在担心和讨论着李雨蒙的去向。",
    "messageInitContent_5340": "前方集市",
    "resoundEventConfigDes_3007": "在持斧怪兽看来，胜利就像肥肉在唾手可得的时候被不知道从哪儿飞来的臭嘴鸦叼走。\\n他还没回过神来，眼前那团东西就化作无数光子消失，只剩下一个比太阳还灿烂的远古族逆转的光体。\\n雌雄难辨的逆转光体飘浮在空中，把塔内照得个通透。日夕和持斧怪兽都用手挡在眼前遮挡强光。\\n虽然无法看清五官，却给日夕一种俊美少年的印象。\\n“……你本来应该治疗我的！”\\n但是，俊美少年却略带怒气地向日夕抱怨。\\n“克服自己的弱点，用你的逆转之力治疗我，让我变回真正的样子，而不是攻击我，厌恶我。”\\n“你是……被诅咒的王子？”日夕战战兢兢地问道。\\n“……我是这座塔的守卫，你的试炼者！”守卫的声音更加不悦。\\n“哈哈哈哈哈哈！”持斧怪兽爆发出一阵狂笑，“你的弱点，该不会是害怕一切丑陋的东西吧？”\\n“你闭嘴！”日夕喝道。\\n日夕崩溃的表情毫无疑问地证明持斧怪兽所猜不虚。\\n“你没有通过石塔的试炼，但却打败了我……”塔之守卫者为难地说道，“就破例赠予你进化的力量吧……”\\n说罢，塔之守卫者化作一道幽绿的光芒飞向日夕手中。\\n日夕心满意足地闭上眼睛，渴求着下一瞬间的进化。\\n突然，一道黑影飞跃到日夕的头上。她睁开眼，盛满绿莹之光的宝物已经落到持斧怪兽手上。\\n“这宝物归我了！”持斧怪兽眼中闪过一道狠光。\\n“还给我！”\\n“不是你趁虚而入，打败怪物的，是我！”\\n那把战斧上压倒性的威力让日夕无法轻举妄动，毕竟万一有损这个狂傲战士的心情，很可能就会枉死在这里。\\n但是，只能眼睁睁地看着他得到进化吗？不朽之上又是什么呢？\\n完全不将面带怒容的日夕放在眼里，持斧怪兽把宝物高举至自己头顶。\\n“赐予我超越真·暴虐战狂的力量吧！”\\n随着他的一声大吼，绿莹之光如倒流的瀑布冲泄至塔顶。\\n可惜，与他期待截然相反的是，光柱渐渐黯淡，然后消失，只徒留一掌绿莹之光在那个墨玉般的盘子里。\\n“……怎么会这样，不能继续进化了吗？”名为真·暴虐战狂的怪兽失望透顶地说道。\\n他冷笑几声，毫不留恋地把盘子扔到日夕面前，就像施舍给一个可怜虫的残羹冷炙。\\n“该你进化了。”\\n虽然很想马上把它捡起来，可是日夕咬紧牙关、握紧双拳，无论如何也不能在对方面前展露接受恩惠的丑态！\\n不过，暴虐战狂根本不在意日夕拼尽全力展现的骨气，他正兴致盎然地等待着日夕的进化。\\n“……”\\n怎么可能在其他怪兽面前暴露自己进化中的样子？！这简直就像被监视着囚犯一样！还是说他对自己产生了什么不轨的想法？！\\n“进化之后，你我再决一死战。”暴虐战狂像回答日夕的疑问说道，“打败你，就证明我能征服这座石塔。”\\n原来是这样，稍微松了一口气。但是，即使自己进化为真·日夕，真的就能打败他吗？\\n正当日夕苦思冥想着打败他的方法时，暴虐战狂突然眼中闪过一丝杀意，并握紧战斧跑出石塔。\\n日夕也感到塔外有一股巨大的能量在流动。\\n她按捺住自己的好奇心，不敢多想，马上捡起原本应该属于自己宝物，高举至头顶。\\n绿莹的光柱再次出现……\\n等暴虐战狂再次回到石塔时，日夕已经不知所踪。",
    "2_60": "旷野疾风会使己方远程怪兽的攻击速度提升{1}%",
    "resoundEventConfigDes_3006": "日夕愤怒地睁开眼睛。虽然粘在眼睛上的黏液模糊了她的视线，但她还是分明看到一名怪兽挥舞着战斧横扫竖劈。疾风正从他的斧下诞生。\\n那名怪兽身上笼罩着一层橙金色的光芒。不朽级的怪兽？是古拉姆吗？不对，古拉姆用的是大剑。\\n他的战斧和古拉姆的大剑一样流动着炽焰般的纹路。不过，虽然古拉姆没什么品味，但也不会在头盔上弄一对像疯马牛那样的犄角，不伦不类。\\n远古族的三个部落中都没有这号怪兽，但敌人的敌人，应该能看成同伴？\\n战斧下血肉横飞，这名怪兽砍下腐肉的速度比其再生的速度更快。他就是这样劈开腐肉一路冲到这边来的吧。\\n真是毫无技巧的战斗方法，不过，却十分有效。\\n怪兽突然闪到一侧，停下了攻击，在调整了一下握战斧的姿势后，很快又再次冲向腐肉团。\\n他的动作比刚才更快，而且不再是无差别地攻击腐肉团不同的部位。\\n如落雷般的战斧直击其中心。\\n几丝碧绿的幽光从腐肉团的中心透出来，那里似乎藏着这团污秽之物的能量核心。\\n不行，这样下去，石塔的宝物就会落入他的手里，日夕想到。\\n她已经完全清醒了，迅速检查了一下自己的身体状况，刚才只是吓晕，没有受伤，体力也几乎没有损耗。\\n日夕强忍着身上的恶臭，偷偷绕到持斧怪兽的背后。\\n“你给我好好呆着！”\\n可惜，她的一举一动都被对方捕捉在余光之内。\\n果然不是为了保护公主而战的风度翩翩的骑士呢！\\n日夕的掌中凝聚起一个像微缩太阳般的光球，石塔内充斥着小小太阳的强光，持斧怪兽顿时睁不开眼睛。\\n就在他稍微慢半拍的瞬间，日夕向腐肉团的中心射出光球。\\n一股巨大的能量在腐肉团身上炸开，把面向日夕和持斧怪兽的躯体炸得烟消云散。\\n“识趣的就马上让开！”日夕喝道。\\n“有点本事。但是我不需要有帮手！”\\n怪兽挡在日夕前面，挥动战斧挡开日夕频频发射过来的光球。\\n短时间内没法凝聚足够的能量，日夕的光球只能释放出刚才百分之一的攻击力，这对持斧怪兽来说犹如隔靴搔痒。\\n“不好意思，这是我的猎物！如果你想切磋，之后我不妨陪你过几招。”\\n持斧怪兽轻蔑地对日夕笑笑，完全不把她放在眼里。他战意愈来愈浓，围绕在他身上的橙金色的光芒更加灿烂，相比之下，日夕的光球只像点点火星。\\n“但是，你妨碍到我的话，就别怪我不客气了！！”\\n虽然对这种新颖的攻击方式在一开始颇有兴致，但在光球和战斧重复数次进攻和挡隔之后，持斧怪兽终于开始厌烦了。\\n他的眼睛逐渐笼罩上一层杀气。\\n不过，日夕并没有察觉对方的杀意。她从来没试过像现在这么沮丧。\\n无论从何种严格意义上来说，日夕都是一个能瞬间收获别人最高好感度的女神，她自己也深知这点。\\n如果日夕对部落的事务上心一点，说不定能拥有和姐姐数量匹敌的信众。\\n见到她的怪兽，即使是敌人，也无一不惊艳于她的美貌。于是，在那个惊诧的瞬间，她就能释放致命的一击，把敌人打败。\\n可是，这种策略却完全不适用于眼前的怪兽。\\n对方根本不屑于正眼看日夕一眼。\\n正当日夕在想办法对付持斧怪兽的时候，却发现他身后的腐肉团趁着没有攻击的间隙迅速恢复。\\n“你、你身后……”\\n好不容易才重挫其肉体，本应一口气破坏它的能量核心，但在持斧怪兽的放任下，它的肉体已经重生到未受到自己攻击之前的样子。\\n“我知道，我就是要让它恢复。”说罢，持斧怪兽转身，“这是我的猎物，它流的每一滴血，只能因为我的攻击！”\\n他向日夕宣告自己的所有权后，便再次向腐肉团的中心冲去。\\n战斧上的焰纹如加入了沸腾的鲜血，狂暴的杀意从腐肉在斧刃下撕裂的声音中绽放！\\n日夕在腐肉的鲜血飞溅到自己身上之前快速跳到一旁。\\n在另一个位置，她看到一股焰红的光团和一股幽绿的光团在腐肉团体内激烈地抗衡着。两股强烈的光芒透过厚厚的肉团照射出来。\\n焰红逐渐压制幽绿、吞噬幽绿。\\n照这样下去，石塔的宝物一定会被持斧怪兽据为己有。\\n虽然他救了自己一命，但那只是巧合。\\n那么，他和那团污秽之物都是自己的敌人。\\n虽然看上去很强大，但把竞争对手放在自己看不见的地方，证明了他只是一个莽汉而已。\\n这么想着，日夕遵从于自己的欲望开始行动了。\\n一个光球再次在日夕掌中凝聚，和之前的那个光球不同，它好像初升的太阳，毫不强烈的曦红，让人感到温暖和安心。\\n看着初升的小太阳朝腐肉团飞射而去，日夕露出了得意的微笑。\\n目标实在太大了，想不击中都难。\\n小太阳的速度本来不慢，快接近腐肉团的时候更突然加速，旋转着击进其肉山之中。它瞄准那丝已经变得很微弱的幽绿光芒，一触便将其击毁。\\n简直不能更易如反掌了！\\n哦哦哦哦哦——！！\\n干得漂亮！日夕不禁为自己鼓起掌来！\\n自己简直是美与智慧的女神！\\n这就是日夕的逆转之力，突袭！它的攻击是针对血量最少的敌人。\\n尽管威力没有持斧怪兽的一击大，但对已经处于强弩之末的腐肉团，已经足够了。",
    "17_140": "发送",
    "17_141": "剩余次数：{1}",
    "17_142": "发送成功",
    "17_143": "请选择部落图标",
    "17_144": "使用",
    "2_2001": "神灵",
    "messageInitNick_7483": "吃够了苦",
    "messageInitNick_753": "光下的沙漏",
    "17_145": "使用中",
    "2_2002": "升阶",
    "messageInitNick_7482": "烤焦的烧饼",
    "messageInitNick_754": "巅峰战神",
    "17_146": "准入条件",
    "2_2003": "重置",
    "messageInitNick_7485": "霸气小女子",
    "messageInitNick_755": "大脑内存不足",
    "17_147": "手动",
    "2_2004": "星图",
    "messageInitNick_7484": "怀中抱软猫",
    "messageInitNick_756": "队友别坑奶",
    "17_148": "自动",
    "messageInitNick_757": "粗来丸",
    "17_149": "探索者等级",
    "messageInitNick_758": "胜利的方程式",
    "messageInitNick_7481": "比油田油",
    "messageInitNick_759": "猪见愁",
    "messageInitNick_7480": "高傲囡人",
    "2_72": "每阶提升{1}",
    "messageInitNick_7479": "开门你的快递",
    "2_2005": "使用",
    "messageInitNick_7476": "五种辣",
    "2_2006": "已满级",
    "messageInitNick_7475": "成熟只是瞬间",
    "messageInitNick_750": "飞的猫",
    "2_2007": "{1}阶",
    "messageInitNick_7478": "贝多芬的寂寞",
    "messageInitNick_751": "复婚吧少年",
    "2_2008": "神灵 {1}",
    "messageInitNick_7477": "蒜蓉通菜",
    "messageInitNick_752": "诺贝尔懂奖",
    "2_70": "实体",
    "2_71": "被动效果({1})",
    "17_150": "大于等于{1}",
    "17_151": "等级限制{1}或以上",
    "17_152": "占领奖励",
    "17_153": "等级要求",
    "17_154": "部落宗旨",
    "17_155": "{1}或以上",
    "messageInitNick_7472": "队友我先撤",
    "messageInitNick_764": "成熟的错题本",
    "17_156": "无部落",
    "messageInitNick_7471": "断片先生",
    "messageInitNick_765": "写生少女",
    "17_157": "{1}占领",
    "messageInitNick_7474": "风扇晕了",
    "messageInitNick_766": "走音王",
    "17_158": "部队",
    "messageInitNick_7473": "金字塔等你",
    "messageInitNick_767": "流水的博士",
    "17_159": "防御",
    "messageInitNick_768": "考神附体",
    "messageInitNick_769": "空之歌",
    "messageInitNick_7470": "认证复读专家",
    "messageInitNick_7469": "在世魅魔",
    "messageInitNick_7468": "脆爽的榴莲",
    "messageInitNick_7465": "没干嘛",
    "messageInitNick_760": "超级摸鱼神",
    "messageInitNick_7464": "古怪大叔",
    "messageInitNick_761": "奉旨跑掉",
    "messageInitNick_7467": "不哄我了吗",
    "messageInitNick_762": "宇宙被解锁",
    "messageInitNick_7466": "无敌的核膜",
    "messageInitNick_763": "威我五十",
    "17_120": "龙牙",
    "17_121": "兽脊",
    "17_122": "灵刃",
    "2_2023": "被动技能",
    "messageInitNick_7461": "我后悔下凡了",
    "messageInitNick_775": "正在删除",
    "17_123": "战鼓数量不足，无法挑战",
    "messageInitNick_7460": "懒得取名字",
    "messageInitNick_776": "倦了轻狂少年",
    "17_124": "空缺",
    "messageInitNick_7463": "闪电快递",
    "messageInitNick_777": "不会搞颜色",
    "17_125": "没有升级权限",
    "messageInitNick_7462": "职业自由人",
    "messageInitNick_778": "无敌打脸帝",
    "17_126": "是否转让酋长给{1}？",
    "messageInitNick_779": "文案在线炒螺",
    "17_127": "是否任命{1}为管理？",
    "2_2020": "可解锁",
    "17_128": "是否免去{1}管理？",
    "2_2021": "获得{1}阶效果",
    "17_129": "是否踢出{1}？",
    "2_2022": "升阶到{1}阶时解锁",
    "17_119": "偶轮",
    "messageInitNick_7458": "豆角先锋",
    "messageInitNick_7457": "夜闯废校",
    "messageInitNick_7459": "七点的饺子",
    "messageInitNick_770": "不愿清醒",
    "messageInitNick_7454": "霸天书生",
    "messageInitNick_771": "婚姻终结者",
    "messageInitNick_7453": "管我什么",
    "messageInitNick_772": "觉醒四叶草",
    "messageInitNick_7456": "蓬松的头发",
    "messageInitNick_773": "不醉不归",
    "messageInitNick_7455": "暗恋不如不恋",
    "messageInitNick_774": "巨星",
    "17_130": "部落战详情",
    "17_131": "排名",
    "17_132": "部落邮件",
    "17_133": "未解锁",
    "messageInitNick_7450": "快去创造奇迹",
    "messageInitNick_786": "听说樱花很美",
    "17_134": "无",
    "2_2013": "{1}效果",
    "messageInitNick_787": "寄风给你",
    "17_135": "获得功勋",
    "messageInitNick_7452": "有点缺爱",
    "messageInitNick_788": "摸鱼门首席",
    "17_136": "部落邮件",
    "messageInitNick_7451": "短肌法师",
    "messageInitNick_789": "划水先驱",
    "17_137": "收件人",
    "17_138": "部落全体成员",
    "17_139": "内容",
    "messageInitNick_7447": "柠檬泪",
    "messageInitNick_7446": "草莓爱好者",
    "messageInitNick_7449": "晚餐吃蛋挞",
    "messageInitNick_780": "实际等等我",
    "messageInitNick_7448": "给杯子道歉",
    "messageInitNick_781": "不再说从前",
    "2_2016": "使用中",
    "messageInitNick_7443": "月亮私藏温柔",
    "messageInitNick_782": "今夜天台很挤",
    "2_2017": "选择神灵",
    "messageInitNick_7442": "纸质老虎",
    "messageInitNick_783": "贝多芬的悲伤",
    "2_2018": "神灵{1}阶解锁",
    "messageInitNick_7445": "卖萌之神",
    "messageInitNick_784": "潜水爱好者",
    "2_2019": "契约",
    "messageInitNick_7444": "盒饭之王",
    "messageInitNick_785": "绝版主宰",
    "channelName_9": "UC九游（阿里游戏）",
    "17_100": "是否放弃占领该遗迹",
    "messageInitNick_797": "此探索者名称不存在",
    "17_101": "所属塔",
    "messageInitNick_798": "阁楼里的小花",
    "17_102": "是否任命{1}为主将？",
    "messageInitNick_7441": "一介书生",
    "messageInitNick_799": "海绵没宝宝",
    "17_103": "{memberNick}加入了部落",
    "messageInitNick_7440": "不要伤我好吗",
    "17_104": "{memberNick}离开了部落",
    "17_105": "{memberNick}晋升为管理",
    "17_106": "{memberNick}晋升为大酋长",
    "17_107": "{memberNick}降级为成员",
    "messageInitNick_7436": "有星球快乐吗",
    "messageInitNick_7435": "年年有木鱼",
    "messageInitNick_790": "已加载请稍后",
    "messageInitNick_7438": "凡尔赛龙王",
    "messageInitNick_791": "拈花惹水草",
    "messageInitNick_7437": "二是一种特质",
    "messageInitNick_792": "套娃小能手",
    "messageInitNick_7432": "拉面的灵魂",
    "messageInitNick_793": "暴走御姐",
    "messageInitNick_7431": "爱满满的鱼",
    "messageInitNick_794": "夜明猪",
    "messageInitNick_7434": "僵尸小可爱",
    "messageInitNick_795": "强壮引战神",
    "messageInitNick_7433": "别来我世界",
    "messageInitNick_796": "跌得很华丽",
    "messageInitNick_7439": "尖叫番茄",
    "randomEventDialogueGroupConfig_55.6": "-",
    "randomEventDialogueGroupConfig_55.5": "-",
    "randomEventDialogueGroupConfig_55.8": "咱们要运一趟特别的镖，早就听闻探索者你的大名，希望你帮个忙，报酬那是大大滴有，它如此说道。",
    "randomEventDialogueGroupConfig_55.7": "-",
    "randomEventDialogueGroupConfig_55.2": "-",
    "randomEventDialogueGroupConfig_55.1": "你在北集市看到一张画得很丑的悬赏令，悬赏的家伙的眉毛特别奇怪。",
    "randomEventDialogueGroupConfig_55.4": "-",
    "17_110": "是否举报部落公告？",
    "randomEventDialogueGroupConfig_55.3": "-",
    "17_111": "{tribeNodeId}已被击破",
    "17_112": "部落大厅",
    "17_113": "偶轮",
    "messageInitNick_7430": "痛车大哥",
    "17_114": "龙牙",
    "17_115": "兽脊",
    "17_116": "灵刃",
    "randomEventDialogueGroupConfig_55.9": "了解一下情况再看",
    "17_117": "主核",
    "17_118": "鬼躯",
    "17_108": "{memberNick}创建了部落",
    "messageInitNick_7425": "逆境中的狐狸",
    "17_109": "是否举报部落名称？",
    "messageInitNick_7424": "北极星在闪烁",
    "messageInitNick_7427": "为谁上线",
    "messageInitNick_7426": "深海亡魂",
    "messageInitNick_7421": "大葱之心",
    "messageInitNick_7420": "踟蹰的转椅",
    "messageInitNick_7423": "内卷发明者",
    "messageInitNick_7422": "写生少女",
    "messageInitNick_7429": "飞花临蝶",
    "messageInitNick_7428": "高冷逗霸",
    "messageInitNick_7414": "比珍珠还真",
    "messageInitNick_7413": "把温柔当爱",
    "messageInitNick_7416": "摸鱼陪伴",
    "messageInitNick_7415": "末日泡面",
    "messageInitNick_7410": "橘子味橡皮",
    "messageInitNick_7412": "行走的饼干",
    "messageInitNick_7411": "辣椒射手",
    "messageInitNick_7418": "超时空电磁炉",
    "messageInitNick_7417": "秘密楼梯",
    "messageInitNick_7419": "吾王万岁",
    "messageInitNick_7403": "提灯映桃花",
    "messageInitNick_7402": "瓷娃娃",
    "messageInitNick_7405": "菠萝草莓酱",
    "messageInitNick_7404": "风之主",
    "messageInitNick_7401": "最爱大葱",
    "messageInitNick_7400": "那个野蛮人",
    "messageInitNick_7407": "美食狂欢",
    "messageInitNick_7406": "信号探测者",
    "messageInitNick_7409": "一分钟",
    "messageInitNick_7408": "给手机把脉",
    "resoundEventStoryDes_475": "因为那两家伙说话太大声了，你想不听也不行。\\n智者：桐仁你看！\\n桐仁：这是什么?\\n智者：《玄乎微步》、《林上飘》、《兽行千变》、《上天纵》、《水上无痕》、《八步摘星》、《星外月步》……\\n桐仁：停停，这啥？\\n智者：笨啊，绝世轻功秘技啊！\\n桐仁：哦，因为被大家轻视，所以已经在这个世界上绝迹了的东西，对吧？\\n智者：……第一次见你一顿分析猛如虎皮匠，但是错！错得离谱。飞林走壁，辗转腾挪，来去无踪的功夫可是行走江湖必备的！\\n桐仁：是是是，你说得对，但我会飞！\\n智者：你……\\n桐仁：说不出话了吧。\\n智者：我是说，你有所不知，身法技巧之中的奥秘是一个“飞”能了的吗？你不知道，有多少会飞的怪兽正在钻研这个。等你学会瞬发任意门，移形换影你再笑，好吗。\\n桐仁：我……\\n智者：我什么，一句话总结就是，比你厉害的人还比你努力，懂了吧！",
    "resoundEventStoryDes_476": "急风扫落叶，归根袭过客。剑影巧弄月，悬空泛飞花。",
    "resoundEventStoryDes_473": "数条粗壮的树藤将这片草地围了起来，上面吊着一块树皮，上面画有智者严肃比叉的大头，警告路过的怪兽，此处禁地，非请勿入。与那些没有围起来的地方相比，这块草地仅仅是多了一圈树藤，就变得充满吸引力，难怪有些怪兽偏要闯闯了。被诱惑的怪兽很快就会发现，里头的秘籍大多都是智者编制的超进化大陆小技巧。一些怪兽更是从中获益良多，坐镇禁地坐等猎物上门。",
    "resoundEventStoryDes_474": "由于西侧有一座高峰挡住了来自西方的湿气，而北侧的峻岭又挡住了南下的寒气，此山岭的洞穴干燥舒适，不少独龙都选择在此处筑巢。只要你够强或者跑得够快，不妨试试在此山岭大吼一句“龙儿——”感受一下万龙齐鸣的带来的小小震撼。",
    "resoundEventStoryDes_471": "这是一条狭小的道路，约莫三叉宽，狭道两侧的石壁上刻满了方和圆，而且神奇的是，方对圆，圆对方。左方右圆，或是左圆右方，据说是练功用的。",
    "resoundEventStoryDes_472": "你突然捡到了一独门秘籍！封面写着六个大字《超进化点穴手》，第一页写着“认穴极准之法门”，第二页写着“没用！”，第三页写着“除非又有谁无师自通，否则你需要认准的只有这三兽！世间就这三兽精通此道，切莫大意。”，后面几页是几幅画像，虽潦草无比，但大致还是能从中看出猫、锤、象的轮廓。",
    "resoundEventStoryDes_470": "这个口径不大的洞却极深，不知是天成，兽作，还是两者皆有。洞缘已经磨得相当光滑，里头还铺了几层厚厚的干草。关于这个深井洞，附近流传着这么一个说法，若是能与心爱的怪兽一同坠入这个深洞，就可以永远在一起。\\n这个说法也很好验证，只需和喜欢的怪兽一起下去，扒开那些干草，看看底下到底藏了多少骨头。",
    "randomEventDialogueGroupConfig_3.95": "远离一点点看",
    "randomEventDialogueGroupConfig_3.96": "离开",
    "randomEventDialogueGroupConfig_3.97": "你到底怎样才愿意说话，用这个东西交换如何？",
    "randomEventDialogueGroupConfig_3.98": "点头",
    "randomEventDialogueGroupConfig_3.91": "它绝望地瘫倒在地。",
    "randomEventDialogueGroupConfig_3.92": "靠近看看",
    "randomEventDialogueGroupConfig_3.93": "离开",
    "randomEventDialogueGroupConfig_3.94": "它似乎又生起了一点希望，开始扭动起了身体。",
    "randomEventDialogueGroupConfig_3.99": "摇头离开",
    "resoundEventStoryDes_479": "你似乎不小心踢到了一个东西，细看是一个小小的喇叭。\\n它曾经属于一只锤子，属于一整个故事。\\n那天，锤子一锤将一只金翅璞佳鸟锤飞，然后将一个小小的喇叭放在了鸟尸的隔壁。",
    "resoundEventStoryDes_477": "推开遮掩的杂草就能看到，底下石墙上刻着一条张牙舞爪的蜻蜓龙。\\n那正是红叶蜻蜓龙会的标记，据说此会有三百六十六处秘密分坛，这个地方很可能就是其中之一。\\n若想确认，不妨找一片大红叶插在胸前试试，看看是否会有怪兽前来接应。",
    "resoundEventStoryDes_478": "你似乎不小心踢到了一个东西，细看是一个大锤。\\n它曾经属于一只锤子，属于一个故事的尾声。\\n锤子兽称守魂奔雷锤，孤身独闯破魂领主的领地，依靠一手守魂奔雷锤和一个自爆元核大破破魂领地，让这片区域再次回归平静。\\n它不知道，空蝉悄悄地跟在了它的身后。",
    "resoundEventStoryDes_486": "大多怪兽被暗果所伤后，或是呼天抢地或是咒骂数年，但有一只怪兽开始了思考，它想将暗果作为它手中兵刃的延伸。第一年，它解决了拿取暗果的问题。第三年，它可以准确将暗果投到它所想的位置，百发百中绝无偏倚。第六年，它可以在瞬间投出6发暗果。第八年，它可以连续打出6发而无需任何显眼的动作。第十一年，它打出的暗果能够做到后发先至、虚实相应。第十五年，它打出的暗果能借助周围的环境变换轨迹。第十六年，它死了。",
    "resoundEventStoryDes_487": "曾经，它脚尖一点，便立于山巅之上，群峰览尽间不觉入神，刀光剑影恩仇诉尽，生离死别仿在眼前，飞鸟掠过长鸣回荡，方觉天地混沌，暮霭苍茫，烟雨无声。",
    "resoundEventStoryDes_484": "怪兽似乎天生就懂得弱肉强食，因此弱者注定是要屈服强者这一规则充斥着江湖之外的整片大陆，弱小的兽群结群生活，或是依附于实力强大的兽主。兽主凭借自身武力为所欲为，弱小的怪兽为了讨好兽主，纷纷送吃送喝建庙筑堂，随后又在其荫蔽下作威作福。",
    "resoundEventStoryDes_485": "这种不高不矮的常绿灌木是“死亡弹球”的一个变种，它在寒冷的季节里繁花挂满，在暖风袭来的日子球果满枝。与它的兄弟品种相比，差异最大的正是它的球果，颜色更浅还不会乱弹，但长满了无比锋利的尖刺。在这些灌木丛下找到几根切面平整的怪兽指头是很平常的事，毕竟有些怪兽手被切到了，还会一怒之下又踹上几脚。一些发育良好的暗色球果，经过特殊的处理后，可以轻而易举地刺入怪兽厚实的皮肉，甚至是某些怪兽的硬甲之中。",
    "resoundEventStoryDes_482": "这种白中带点红的花，名为一点红。据说能为看见它的怪兽带去美好的爱情。",
    "resoundEventStoryDes_483": "这江的一次突然的改道，便与那湖有了交汇，这江水融入那湖水，成了江湖。江湖潮湿多雨，鲜有强霸的怪兽会在这一区域落脚，久而久之，这片区域就成个整个超进化大陆最自由，最无拘无束之地。",
    "resoundEventStoryDes_480": "你似乎不小心踢到了一个东西，细看是一块巨大的石。\\n它曾经属于一只锤子，属于一个故事的一部分。\\n那次，锤子相中了一块大石，于是每天都用树藤拖着这块大石行走。\\n日复一日，大石由方到圆，数量也不断增加着。\\n锤子带它攀过一山又一山，跑过一个又一个崖壁。\\n一次坠落，让其中一块圆石永远留在了这里。\\n也是那次坠落，锤子遇到了它命定的元核、那命定之锤和那面画有千锤百炼绝技的石壁。\\n它每日都以强化孢子果腹，每日都在熟习千锤百炼，就这样十六年过去了。",
    "resoundEventStoryDes_481": "你似乎不小心踢到了一个东西，细看是一个被压扁了的喇叭。\\n它曾经属于一只呜呜祖拉，属于一只锤子，属于一个故事的开始。\\n那天，桐仁、叉叉、呜呜祖拉、锤子、咻咻一起玩找捉迷藏游戏。\\n呜呜祖拉找到一处大石藏好后，突然咻咻的尖叫声。\\n呜呜祖拉稍稍起身，看见一只金翅璞佳鸟正对咻咻发起了攻击。\\n“莫挣扎，跟我回去让破魂领主好好瞅瞅你灵魂的颜色！”那鸟似乎是破魂领主的手下，是出来为领主收集灵魂的。\\n“快放下咻咻！”呜呜祖拉大喊着飞身冲了出去，吹起喇叭对准那鸟就是一击。\\n鸟轻松接下一击后，非但没有放下脚下吓得哇哇大叫的咻咻，还对呜呜祖拉发起了攻击。\\n呜呜祖拉来没有后退硬是接了下来，随后向前猛冲，吹起喇叭又是一击。\\n“你这种招数对我没”话音未落，鸟便眼前一黑，放下咻咻，到处乱扑腾。\\n祖拉刚才悄悄从地上抓了一把土用喇叭对准鸟的眼吹出。\\n随后是鸟的一声尖啸，一只比蒙巨象从远处蹦了出来，一脚将呜呜祖拉踩在脚下。\\n此时桐仁和叉叉也赶到，叉叉颤抖着大吼“聚落里的人马上就倒，到时候，你们就……就”\\n鸟又尖啸一声抓起祖拉和巨象一起离开了。\\n只留下了一个被压扁的喇叭和一旁颤抖不已却又动弹不得的锤子。",
    "resoundEventStoryDes_488": "对决不一定要用手，还可以动口。\\n“只要是雄性怪兽，见到美丽的雌性怪兽就难免多看几眼。”\\n“只要你这么想，就难免让雌性怪兽生厌！”\\n“总是有例外的，例如我，就不会。”\\n“我呸。”\\n“……”\\n就好像这癫峰上的这两兽，一吵就是百年。",
    "resoundEventStoryDes_489": "这是一个风景优美的小海岛，海岛之上有果树林和丰沛的降水，怪兽到这里都可以吃到饱才离去，但东西不允许带走。",
    "resoundEventStoryDes_497": "“哈哈哈哈哈哈哈呼呼呼呼噗噗噗噗。”\\n听到这种如此特别的笑声，便知道距离笑动峡谷不远了。那是峡谷底炎之高兴的笑声。\\n那才是它真正的武器，无论它手中那把剑多锋利，也比不上它那爽朗的笑声。",
    "resoundEventStoryDes_498": "“你们无需惧怕死亡，死亡会使你变得更为强大。”灾·焚风的话语随着一股热风袭来。\\n王·炼狱魔眼肯定地对灾焚风眨了眨眼后便进入了焚寂状态。此时，它才意识到出大问题了！\\n“原来你说的不是游戏啊——！”它震惊的瞳孔里仿佛如此说道。\\n这个故事告诉我们，为了让每一次Game over都能使你变得更强大，记得装备重生宿命元核！\\n——莎士彼亚随笔",
    "resoundEventStoryDes_495": "练武之兽，最害怕的莫过于名叫走火入魔的怪兽，据说这走火入魔之兽会在练武到最关键的时候出现，随后神不知鬼不觉地附在怪兽身上，让修行中的怪兽前功尽弃甚至身受重伤。\\n但是，你只需要花一点小小的金币，就可以租用这个上古防魔洞，有效阻止各种闲杂怪等靠近，让你练功更安心。",
    "resoundEventStoryDes_496": "前面有个大坑，大坑里有一堆散乱的尸骸，还有被胡乱翻找过的痕迹。数日前，有个消息在江湖中传开了，“天上天下唯此宝衣甲刀剑不入拳脚无伤啃咬无缺，陪我百年足矣，是时候重现它的光辉，去寻找吧，它就在我的墓穴之中。” 似乎是一个谜题，正是这个谜题掀起了一股挖掘宝衣甲的浪潮。但事情是否真的如此简单？那就不得而知了。",
    "resoundEventStoryDes_493": "一只叉叉也许是弱小的，但多只叉叉团结起来就不一定了。\\n多叉派，正是这片区域最强大的叉叉门派，它们的宗旨是\\团结就是力量！\\。\\n多叉派的独门武功正是十八叉叉叉阵，该派挑选骨骼惊奇服从性高的小叉叉从小加入叉阵培养，十八叉无论做什么事情都要保持步调一致，甚至呼吸都不能有半点偏差。每日有半天用于练习基础体能，半天用于练习叉阵的阵法，这阵法参考海螺的花纹进行排布与变化，攻守兼备，千变万化，繁复无比。\\n铺垫了这么久，其实就是想说，这地上横七竖八躺着的那十八只叉叉，估计就是练太累了，终于顶不住，睡着了吧。",
    "resoundEventStoryDes_494": "仓帮是一个非常特殊的帮派，只需要拥有一朵造唤许可就可以加入。根据怪兽拥有的造唤许可朵数，在仓帮有不同的辈分。帮主是拥有最多造唤许可的怪兽，副帮主次之，千朵长老8名，之后是百朵弟子、十朵弟子、几朵弟子。这个帮派主要是修心，越是能抵御诱惑，就越受尊敬和推崇。",
    "resoundEventStoryDes_491": "这座树林似乎格外安静，有棵树上挂着一块显眼的兽皮，这块兽皮上记载了一种名为“真血功”的上乘功夫，练成后被击败就会有真血护体不会死掉，只是陷入假死，一段时间过后就会复活，修炼者只需要闭嘴一直保持安静离开这片树林，即可完成修炼，但修炼的时候绝不能说话，否则会立刻破功，真血反吞噬原来的血液，七窍流血而死。",
    "resoundEventStoryDes_492": "江湖中流传着一种极其阴险的武功，其名为击股传花神功。\\n此功并不难练，习得后体力、攻击力、移动速度、霸气等所有属性都会得到爆炸性提升。练成后，爪背上会出现一个特殊的花纹。\\n其阴险之处也就是这花纹，若未能在手背的多片花纹完全消失前，通过用手拍打其他怪兽的股部，将此功传递给其他怪兽，就会自爆而亡。\\n一些亡命之兽练过此功一次后，便再也舍不得失去，在花纹只剩下3瓣时，它们就会开始到处寻找下一个猎物，之后再重新修炼。但这也是有风险的，猎物若不知情由自可，一旦猎物知情，那便是对方的反杀时刻了。\\n据说一只习得击股传花神功的怪兽就在这附近，小心突然伸向你股部的爪哦。",
    "resoundEventStoryDes_490": "“吸血首~这名字不行，不得劲，唔~那就大蛮飞头！也不好~飞头又见飞头！也不好~大你老哥飞，好像还行！头飞头之飞头神功！唔长了！飞头问情！哪来的情！好难想啊啊啊啊啊啊啊啊”\\n“嘣————”\\n这里是刚刚传来抓狂大叫的地方，走近发现只见一个四分五裂的飞头蛮的头，似乎是因为想名字想爆了头。",
    "randomEventDialogueGroupConfig_3.73": "它继续复读着你的话语。",
    "randomEventDialogueGroupConfig_3.74": "动手",
    "randomEventDialogueGroupConfig_3.75": "离开",
    "randomEventDialogueGroupConfig_3.76": "它仍旧复读着你的话语。",
    "randomEventDialogueGroupConfig_3.70": "你说的很对。",
    "randomEventDialogueGroupConfig_3.71": "继续暗示",
    "randomEventDialogueGroupConfig_3.72": "直接明示",
    "randomEventDialogueGroupConfig_3.77": "动手",
    "randomEventDialogueGroupConfig_3.78": "离开",
    "randomEventDialogueGroupConfig_3.79": "它满眼期待地看着你。",
    "resoundEventStoryDes_499": "王·霸者：可惜。\\n灾·地裂：？\\n王·霸者：真可惜。\\n灾·地裂：？？\\n王·霸者：太可惜了。\\n灾·地裂：？？？\\n王·霸者：你这一刀999999999砍的为什么不是体重啊！\\n灾·地裂：666666666",
    "messageInitNick_706": "霸气总攻",
    "messageInitNick_707": "单只蝴蝶",
    "messageInitNick_708": "冰箱少男",
    "messageInitNick_709": "爱在掌心上",
    "messageInitNick_700": "脸红妹妹",
    "messageInitNick_701": "一杯敬相逢",
    "randomEventDialogueGroupConfig_3.90": "继续看它无能狂怒",
    "messageInitNick_702": "和素颜和解",
    "messageInitNick_703": "套路深得人心",
    "messageInitNick_704": "无敌跟风神",
    "messageInitNick_705": "假装的坚强",
    "randomEventDialogueGroupConfig_3.84": "继续盯着它",
    "randomEventDialogueGroupConfig_3.85": "它开心地把绳子抖落，将堵嘴拔掉。",
    "randomEventDialogueGroupConfig_3.86": "它似乎努力用眼神在说话。",
    "randomEventDialogueGroupConfig_3.87": "继续盯着它",
    "randomEventDialogueGroupConfig_3.80": "犹豫片刻",
    "randomEventDialogueGroupConfig_3.81": "坚决离开",
    "randomEventDialogueGroupConfig_3.82": "它对着你疯狂眨眼，在努力暗示着什么。",
    "randomEventDialogueGroupConfig_3.83": "解开它的绳子",
    "randomEventDialogueGroupConfig_3.88": "快步离开",
    "randomEventDialogueGroupConfig_3.89": "你倒是说话啊！啊，气死我了，你就不能说句话吗！为什么不说呢！",
    "17_180": "{1}挑战{2}胜利",
    "messageInitNick_717": "捕鸟达人",
    "17_181": "{1}挑战{2}失败",
    "messageInitNick_718": "老衲戒女神",
    "17_182": "【我方部落】占领的{tribeNodeId}进入交战状态，请求支援",
    "messageInitNick_719": "采花女",
    "17_183": "【我方部落】宣战的{tribeNodeId}进入交战状态，请求支援",
    "17_184": "已申请加入",
    "17_185": "捐献至下阶段奖励",
    "17_186": "击破数",
    "17_187": "剩余红心",
    "17_188": "备战期开启",
    "17_189": "已挑战",
    "messageInitNick_710": "开奔驰送外卖",
    "messageInitNick_711": "旧巷逢故人",
    "messageInitNick_712": "吃瓜带头人",
    "messageInitNick_713": "复杂的人类",
    "messageInitNick_714": "踏云归",
    "messageInitNick_715": "记忆黑名单",
    "messageInitNick_716": "森林迷了鹿",
    "17_191": "报！「{tribeName}」部落对「{oppTribeName}」部落的{relicName}宣战！",
    "messageInitNick_728": "懂鉴定家",
    "17_192": "开打啦！开打啦！「{oppTribeName}」部落的 {relicName}进入交战状态，进攻方为「{tribeName}」部落！点我跳转围观！",
    "messageInitNick_729": "花季中的雨季",
    "17_193": "结果出炉！经过{battleCount}场大战后，「{tribeName}」部落攻下了「{oppTribeName}」部落的{relicName}，用时{timeCount}分钟！",
    "17_194": "结果出炉！经过{battleCount}场大战后，「{tribeName}」部落挡下了「{oppTribeName}」部落的进攻，成功守住了{relicName}！",
    "17_195": "遗迹播报",
    "17_196": "是否消耗{1}钻石进行捐赠？",
    "17_197": "惊！「{tribeName}」部落守住了{relicName}！进攻方为「{oppTribeName}」部落，期间一场战斗都没有发生！ta们到底发生了什么！",
    "17_198": "是否确认转让酋长？",
    "messageInitNick_720": "向月亮道晚安",
    "messageInitNick_721": "日日铲翔真累",
    "messageInitNick_722": "国产好姑娘",
    "messageInitNick_723": "保护敌方中单",
    "messageInitNick_724": "穷游全世界",
    "messageInitNick_725": "斗魂讨债人",
    "messageInitNick_726": "偷走空投",
    "messageInitNick_727": "高姿态的女人",
    "17_190": "突发消息",
    "messageInitNick_739": "打小就酷",
    "17_160": "+{1}/小时",
    "17_161": "{1}后开始交战",
    "17_162": "{1}后交战结束",
    "17_163": "{1}后重置为中立",
    "17_164": "宣战中",
    "17_165": "交战中",
    "17_166": "占领中",
    "19_6": "移动力上限",
    "messageInitNick_731": "惊人的恶兽",
    "17_167": "放弃中",
    "19_5": "世界回响等级{1}时效果提升",
    "messageInitNick_732": "复读之王",
    "17_168": "宣战并进入交战状态或占领后可派遣部队",
    "19_4": "“一本残破怪异的笔记，里面的文字闪烁着微弱的光芒，淡的近乎没有颜色，只有在漆黑中才能稍微看清楚，页脚处刻着一串仿佛来自另外一个世界的符号F.r.E.a.S.o.N，像极了凝固在琥珀中的虫子。”",
    "messageInitContent_11590": "R帝+星烁",
    "messageInitNick_733": "藏不住的秘密",
    "17_169": "己方部队",
    "19_3": "你踏上了旅途，踩着不断变幻的影子，行走于朝暮之间。那天，风沙吹散了脚印，空气带走了叹息，时间模糊了经历，世界却记住了你，代替那些不愿遗忘你的、终将消逝的一切，将你记住，刻下只属于你的丰碑。",
    "messageInitNick_734": "好男人就是我",
    "19_2": "当星球成为了历史的记录者，当超星的洪流卷席大地，探索者早已置身其中，或随波逐流静观其变，或受阻力亦借此力，搅起属于他们的超进化狂潮。这里记载着过去，或许也能揭示未来。",
    "messageInitNick_735": "倚栏听夜雨",
    "19_1": "视线习惯性地略过背景，聚焦于前景。似乎谁都没有注意到，前景后面略微模糊的背景，正是前景所在的此处和彼方。若前景与背景在某一刻悄然反转，那定是遗落回响。",
    "messageInitNick_736": "搬砖观察员",
    "messageInitNick_737": "钓鱼之神",
    "messageInitNick_738": "一生漂泊",
    "messageInitContent_11596": "异端！",
    "messageInitContent_11595": "为了！",
    "messageInitContent_11598": "加入混沌",
    "messageInitContent_11597": "我之信仰坚不可摧",
    "messageInitContent_11592": "我不是故意的兄弟",
    "messageInitContent_11591": "你是个好人",
    "messageInitContent_11594": "Hey.",
    "messageInitContent_11593": "上车",
    "messageInitNick_730": "无敌卷王",
    "messageInitContent_11599": "先移动到下一个关了",
    "17_170": "敌方部队",
    "17_171": "排名",
    "17_172": "加成",
    "17_173": "需击破前置冒险关卡解锁该图腾",
    "17_174": "暂无部队",
    "17_175": "暂无部落",
    "17_176": "战况",
    "17_177": "部落战战况",
    "messageInitNick_742": "彪悍女汉子",
    "17_178": "我方部落",
    "messageInitNick_743": "往事如风",
    "17_179": "敌方部落",
    "messageInitNick_744": "孤单三色堇",
    "messageInitNick_745": "此男危勿靠近",
    "messageInitNick_746": "放生美人鱼",
    "messageInitNick_747": "差点变帅",
    "messageInitNick_748": "在下",
    "messageInitNick_749": "萝莉日常打野",
    "messageInitContent_11585": "给黯灭推荐几款游戏",
    "messageInitContent_11584": "难道不是我为金币狂",
    "messageInitContent_11587": "我来，双人成行",
    "messageInitContent_11586": "恋爱模拟器",
    "messageInitContent_11581": "那我拿出倍速兽阁下又应该如何应对呢",
    "19_9": "部落战令上限",
    "messageInitContent_11580": "跑酷兔兔",
    "19_8": "黑暗森林探索点上限",
    "messageInitContent_11583": "眼睛看见了，手没反应",
    "messageInitNick_740": "按时备份",
    "19_7": "永生尖刺上限",
    "messageInitContent_11582": "勇敢兔兔不怕困难",
    "messageInitNick_741": "独守一城",
    "messageInitContent_11589": "推荐，帅鸽男友，不能假定对吧",
    "messageInitContent_11588": "不如白色相簿2",
    "messageInitContent_7648": "老大",
    "messageInitContent_7649": "时尚时尚",
    "messageInitContent_7653": "还有个梵",
    "tutorialConfigName_48": "上阵天马",
    "messageInitContent_7654": "子弹问号",
    "tutorialConfigName_49": "进行元核熔炼1次",
    "messageInitContent_7651": "给网线把脉",
    "messageInitContent_7652": "拟态自动计算中",
    "messageInitContent_7657": "不许熬夜",
    "messageInitContent_7658": "肯定是右边",
    "messageInitContent_7655": "性感子弹",
    "messageInitContent_7656": "要啥有啥",
    "tutorialConfigName_40": "建造起源殿",
    "tutorialConfigName_41": "起源殿挑战",
    "tutorialConfigName_42": "上阵青龙",
    "tutorialConfigName_43": "怪兽不朽进化",
    "96_WarWall": "战纹分解",
    "tutorialConfigName_44": "狩猎挑战",
    "messageInitContent_7650": "全都是远程~~~",
    "tutorialConfigName_45": "上阵麒麟",
    "tutorialConfigName_46": "建造战墙",
    "tutorialConfigName_47": "加固战墙1次",
    "tutorialConfigName_50": "怪兽觉醒进化",
    "messageInitContent_7659": "色号是什么？",
    "messageInitContent_5001": "等等我！哥",
    "messageInitContent_7664": "很明显",
    "messageInitContent_5000": "叛徒算我一个",
    "messageInitContent_7665": "不要再打啦不要再打啦",
    "messageInitContent_5003": "天枢震是功德装置？？",
    "messageInitContent_7662": "让我猜中一次吧",
    "messageInitContent_5002": "骑龙去逛街",
    "messageInitContent_7663": "今天选人多的",
    "messageInitContent_5005": "又是你露西",
    "messageInitContent_7668": "1103。迈入深渊",
    "messageInitContent_5004": "钢龙是座位",
    "messageInitContent_7669": "1103。小心葬身鱼腹",
    "messageInitContent_5007": "这是要干嘛",
    "messageInitContent_7666": "别说了！",
    "messageInitContent_5006": "大卫看了要哭哭",
    "messageInitContent_7667": "一眼左边",
    "tutorialConfigName_51": "深渊先遣挑战",
    "tutorialConfigName_52": "上阵幻象",
    "tutorialConfigName_53": "怪兽极化",
    "tutorialConfigName_54": "神灵契约解锁",
    "messageInitContent_7660": "不难",
    "messageInitContent_7661": "咋选",
    "messageInitContent_5009": "？？？好怪 再看一眼",
    "messageInitContent_5008": "拉着二胡给你表演和治疗",
    "messageInitContent_5012": "啊我密恐",
    "messageInitContent_7675": "1104。鲨皮匠不是皮匠家族的。",
    "tutorialConfigName_26": "星律超跃",
    "messageInitContent_5011": "建议换一个部件",
    "messageInitContent_7676": "关一下战挑要不。1",
    "tutorialConfigName_27": "建造探索营地",
    "messageInitContent_5014": "你好我打野",
    "messageInitContent_7673": "1104。不能大喊这关究极怪的名字",
    "tutorialConfigName_28": "上阵五只怪兽",
    "messageInitContent_5013": "夜视仪",
    "messageInitContent_7674": "【信息读取失败】",
    "tutorialConfigName_29": "建造部落",
    "messageInitContent_5016": "发光发亮！",
    "messageInitContent_7679": "【信息不完整为确保安全实施遮盖】",
    "messageInitContent_5015": "赛博灯泡",
    "messageInitContent_5018": "很急",
    "messageInitContent_7677": "1.带有.的规则一般是正确的，可以相信",
    "messageInitContent_5017": "慢慢来宝宝",
    "messageInitContent_7678": "1106。切勿在主城缠绵",
    "tutorialConfigName_20": "复制体挑战",
    "tutorialConfigName_21": "上阵四只怪兽",
    "messageInitContent_7671": "88。规则的总数是揭开【内容】的关键",
    "tutorialConfigName_22": "建造永生之茧",
    "messageInitContent_7672": "1103。《海王》",
    "tutorialConfigName_23": "永生之茧挑战",
    "messageInitContent_5010": "c位还需努力",
    "tutorialConfigName_24": "建造斗技场",
    "messageInitContent_7670": "1103。大鱼吃小鱼",
    "tutorialConfigName_25": "斗技场挑战",
    "messageInitContent_5019": "启动帝王引擎",
    "messageInitContent_5023": "该学学拟态原生种族了",
    "messageInitContent_7686": "1.带有.的规则一般是正确的，可以相信",
    "tutorialConfigName_37": "通关凿星裂痕",
    "messageInitContent_5022": "卧龙拟态",
    "messageInitContent_7687": "9，【】中隐藏着真相",
    "tutorialConfigName_38": "世界灾厄挑战",
    "messageInitContent_5025": "这是最后的点了吗",
    "messageInitContent_7684": "【数据已丢失】",
    "tutorialConfigName_39": "建造一发入欧店",
    "messageInitContent_5024": "刀马的痛",
    "messageInitContent_7685": "1107。绝对不可以害怕",
    "messageInitContent_5027": "返璞归真",
    "messageInitContent_5026": "莎士比的大作写完了吗",
    "messageInitContent_5029": "不可以驼背",
    "messageInitContent_7688": "1108。必须同时击败幻化",
    "messageInitContent_5028": "真·拿头来见",
    "messageInitContent_7689": "【内容已损坏】",
    "propConfigName_90504": "蓝色自愈恢复元核碎片",
    "propConfigName_90503": "绿色自愈恢复元核碎片",
    "tutorialConfigName_30": "加入部落",
    "propConfigName_90502": "白色自愈恢复元核碎片",
    "tutorialConfigName_31": "上阵玄武",
    "tutorialConfigName_32": "怪兽究极进化",
    "messageInitContent_7682": "1106。地球会梦见吸盘兽吗",
    "tutorialConfigName_33": "建造谜之巢穴",
    "messageInitContent_7683": "1107。如果梦到被触手包围，可以挑战这关解除梦魇",
    "propConfigName_90507": "红色自愈恢复元核碎片",
    "tutorialConfigName_34": "暴走旷野挑战",
    "messageInitContent_5021": "给大家跳个科目三",
    "messageInitContent_7680": "1106。切勿在此关发梦",
    "propConfigName_90506": "橙色自愈恢复元核碎片",
    "tutorialConfigName_35": "遭遇野生怪兽",
    "messageInitContent_5020": "古希腊掌管蜗牛的神啊",
    "messageInitContent_7681": "【信息读取失败】",
    "propConfigName_90505": "紫色自愈恢复元核碎片",
    "tutorialConfigName_36": "建造凿星裂痕",
    "messageInitContent_5034": "什么印记",
    "messageInitContent_7697": "关一下战挑要不。1",
    "messageInitContent_5033": "可累坏梵梵了",
    "messageInitContent_7698": "1110。气奥的图阵是出口",
    "messageInitContent_5036": "仿生兽不需要标记（我说的",
    "messageInitContent_7695": "1109。G-N是唯一可以安全解除的怪兽",
    "messageInitContent_5035": "就是手上的轮子，蓝色小圈圈",
    "messageInitContent_7696": "0.享受世界",
    "messageInitContent_5038": "菜牌呢",
    "messageInitContent_5037": "高级餐厅？",
    "darkForestEventConfigName_1": "金币",
    "messageInitContent_7699": "【信息不完整为确保安全实施遮盖】",
    "darkForestEventConfigName_2": "骨",
    "messageInitContent_5039": "只见餐具不见料理",
    "darkForestEventConfigName_3": "木",
    "darkForestEventConfigName_4": "鳞",
    "messageInitContent_7690": "2。如果你挑战下一关了，那不要再挑战下一关",
    "darkForestEventConfigName_5": "怪兽经验",
    "darkForestEventConfigName_6": "森灯",
    "darkForestEventConfigName_7": "跳跃点",
    "messageInitContent_5030": "如果你弱小，生气也会让人觉得可爱",
    "messageInitContent_7693": "1109。绝对不喝可以喂虎皮匠",
    "darkForestEventConfigName_8": "强化孢子树",
    "messageInitContent_7694": "【信息读取失败】",
    "darkForestEventConfigName_9": "进化孢子树",
    "messageInitContent_5032": "原来仿生兽的印记就是梵打上的吗",
    "messageInitContent_7691": "1108。必须同时击败不朽",
    "messageInitContent_5031": "生气",
    "messageInitContent_7692": "2.带有。的规则是假的要注意甄别",
    "messageInitContent_5045": "在吗，出来聊天！",
    "messageInitContent_5044": "谁在呼唤我",
    "messageInitContent_5047": "猫德学院招生中",
    "messageInitContent_5046": "懂了是鞋店",
    "messageInitContent_5049": "我觉得漆黑组件会赢",
    "messageInitContent_5048": "如果贴贴和打架只能选一个，那么我选美女！",
    "messageInitContent_5041": "是双螺旋",
    "messageInitContent_5040": "叉叉下面那个好像8",
    "messageInitContent_5043": "我怀疑喵响喜欢我但是没有证据",
    "messageInitContent_5042": "吃我正宗猫猫拳",
    "messageInitContent_5056": "我背包暖和，快过来",
    "messageInitContent_5055": "竞猜我来啦~",
    "messageInitContent_5058": "就算猜错我也要支持正义的一方",
    "messageInitContent_5057": "第一时间看看数值",
    "messageInitContent_5059": "emmmmm",
    "messageInitContent_5050": "一目了然",
    "messageInitContent_5052": "听我一句劝，本是同根生",
    "messageInitContent_5051": "别打啦你们别打啦",
    "messageInitContent_5054": "我有一个很大胆的想法",
    "messageInitContent_5053": "黑vs白",
    "messageInitContent_5067": "答应我，下次还这么整",
    "messageInitContent_5066": "多整点形形色色的皮肤",
    "messageInitContent_5069": "脑子豁然开朗",
    "messageInitContent_5068": "各位大宝贝好呀",
    "messageInitContent_5061": "简单",
    "messageInitContent_5060": "冲鸭",
    "messageInitContent_5063": "这不是形态吗",
    "messageInitContent_5062": "没关系大部队会告诉我答案",
    "messageInitContent_5065": "这可难不倒我",
    "messageInitContent_5064": "没关系我会赢",
    "themeCardPackName_20035": "记录",
    "messageInitNick_478": "还在非洲",
    "activityNodeName_77": "前排是小弟#后排是小弟",
    "messageInitNick_479": "当心路人",
    "themeCardPackName_19040": "溜溜说",
    "activityNodeName_78": "双生与焚烧#铁幕与黯炎",
    "activityNodeName_79": "新晋主角#常驻反派",
    "messageInitNick_470": "还在打野",
    "activityNodeName_80": "当头一炮#一龙当先",
    "messageInitNick_471": "嘟嘟鱼",
    "messageInitNick_472": "大叔跟你走",
    "messageInitNick_473": "君为红颜醉",
    "activityNodeName_83": "城门失火#殃及池鱼",
    "messageInitNick_474": "短腿小可爱",
    "activityNodeName_84": "停下#灾变",
    "messageInitNick_475": "救世主",
    "activityNodeName_81": "“勇者”#“恶龙”",
    "messageInitNick_476": "顶层设计",
    "activityNodeName_82": "剧团#乐团",
    "messageInitNick_477": "纯情小家伙",
    "themeCardPackName_20030": "探索",
    "randomEventDialogueGroupConfig_53.8": "-",
    "themeCardPackName_19035": "王霸说",
    "randomEventDialogueGroupConfig_53.7": "-",
    "themeCardPackName_20025": "通用规则",
    "randomEventDialogueGroupConfig_53.9": "你来到小店前，之间小店大门紧闭。但你很快就发现了小店墙墩上的花纹，你认出那是南市集老大所在组织的标识。",
    "randomEventDialogueGroupConfig_53.4": "-",
    "randomEventDialogueGroupConfig_53.3": "-",
    "randomEventDialogueGroupConfig_53.6": "-",
    "randomEventDialogueGroupConfig_53.5": "-",
    "activityNodeName_65": "生存#毁灭",
    "messageInitNick_489": "跑调神",
    "activityNodeName_66": "五小强#两大头",
    "activityNodeName_63": "远古云集#野怪云集",
    "activityNodeName_64": "社恐龙龙#社恐龙",
    "themeCardPackName_19030": "锤子说",
    "activityNodeName_69": "竞猜左69#竞猜右69",
    "activityNodeName_67": "进击之龙#守愈之龙",
    "activityNodeName_68": "小女孩#大狮子",
    "messageInitNick_481": "这河里吗",
    "messageInitNick_482": "冬日傲娇菊",
    "messageInitNick_483": "狂暴血狼",
    "messageInitNick_484": "冻干潮人",
    "messageInitNick_485": "参见萌妹砸",
    "messageInitNick_486": "旋转木马",
    "activityNodeName_70": "竞猜左70#竞猜右70",
    "messageInitNick_487": "及时相爱",
    "messageInitNick_488": "勿忘我牛",
    "randomEventDialogueGroupConfig_53.2": "撕下悬赏令前往",
    "randomEventDialogueGroupConfig_53.1": "你看见一张有着超高赏金的神秘悬赏令，悬赏的内容是一幅图，你很快认出这是指向南集市一家小店的地图。",
    "themeCardPackName_20020": "瞳",
    "messageInitNick_480": "不再无所谓",
    "messageInitNick_492": "单人华尔兹",
    "themeCardPackDes_17005": "绯焉饿了。\\n但她不能饿了就吃，除非她动了吃光整个片区的心思。\\n绯焉显然没有这个心思，现在的她只会在太阳沉入地平线的一刻进食。\\n夕阳的余晖渐渐褪去，她抵达今日进食的地点，一处长满杂草的矮坡。不久前，她与一只怪兽有了约定，那只怪兽承诺会让她尝一口。这样的奇怪请求她还是第一次听，她有点疑惑，毕竟之前主动的明明都是她。\\n那只怪兽的呼喊声让她回过神来。\\n不一会，绯焉就知道那只怪兽已来到她的跟前，她的其他感官因眼耳长期被羽翼遮蔽变得更为敏锐。她伸出手示意陌生怪兽，她感觉到对方的爪子搭在了她的掌心上，此刻正在微微颤抖，她仔细感受着爪子的触感与份量，随后将手翻转过来，一点点在爪子上游动，在一处不错的位置停住后，指尖随手刺入，流出的食物被引入杯中。\\n绯焉纯白的双翼微张，举杯将食物饮尽。翼尖轻轻满足地拭去嘴角的微红。\\n谢谢款待~",
    "messageInitNick_493": "重新定义笨蛋",
    "messageInitNick_494": "请网友冷静",
    "messageInitNick_495": "人海中遇到你",
    "messageInitNick_496": "青眼因爱红",
    "messageInitNick_497": "鸡爪子",
    "messageInitNick_498": "别慌有姐姐在",
    "messageInitNick_499": "彩虹宝宝",
    "messageInitNick_490": "并肩压马路",
    "messageInitNick_491": "不要迷恋姐",
    "themeCardPackDes_17010": "怪兽满足饥饿的方式各不相同的。那些对食物有不寻常渴求的怪兽，在满足饥饿上有着更异乎寻常的方式。对于这些怪兽而言，每一次的饥饿都是巨大难题，一个源于不满足的大难题。\\n就像这只凶噬魔，敏感的巨舌使它获得了更富有层次、更高颗粒度的味觉。它尝过最结实、最多汁、最冰冷、最甜腻、最滑溜……的肉，每一种都使它回味无穷，但还不够，它希望尝到前所未有的味道，例如灵魂浓度最高的肉，而眼前刚好就有一只收集了一大堆有色灵魂的破魂领主！\\n就像这只破魂领主，在尝到将有色灵魂混入食物的美味后，就变得一发不可收拾，它试过浅色的、深色的、浑浊的、纯净的、邪恶的、善良的……灵魂，正当它为今日的灵魂调料发愁时，那只流着口水的凶噬魔自己送上门了，看它那缓缓甩动的长舌！那一定是它没试过的！吃货的灵魂！\\n两只从不知满足的怪兽就像约好了一样，同时扑向了对方。体型、霸气、战斗技巧这些要素早已被它们抛诸脑后，它们身心都早已被食欲占据！\\n镰刀割开肉体，一点点勾出灵魂，巨舌缠住躯体，巨嘴咬住头颅。\\n在它们都没有注意到的树荫中，一只绯红色巨鸟飞掠而至，三块肉团久久缠斗在一起，再也没有分离。",
    "themeCardPackDes_17015": "绯焉稍稍松开捂住眼耳的白羽，透过羽毛的缝隙，她看着那只在她身旁睡得正酣的怪兽。恍惚间，那个曾经侵扰她多时的梦又再次浮现。\\n她费了不少时日去思考那个梦，思考她对食物那份异乎寻常的渴求。这份欲望如同烙印般刻在她的灵肉之上。现在她知道了，答案就在梦中，她就是来自于那个肉团里的东西，也许她对血肉的渴望源自于凶噬魔，对血灵魂的渴望源自于破魂领主，最后一丝理智她也说不好从何而来，兴许是那只选错食物的巨鸟？\\n绯焉对血肉确实有数倍于凶噬魔的渴望，对灵魂同样有数倍于破魂领主渴求。她也知道该怎样与她的欲望相处，虽然那已经是那个梦很久之后的事了。\\n那只怪兽的梦也醒了，只是不像它的梦中那般，绯焉已不在它的身旁。",
    "messageInitContent_7602": "主打一个随缘",
    "messageInitContent_7603": "家人们谁懂啊",
    "messageInitContent_7600": "睡了睡了",
    "messageInitContent_7601": "饿了",
    "themeCardPackName_20040": "区间",
    "randomEventDialogueGroupConfig_10.222": "离开",
    "randomEventDialogueGroupConfig_10.223": "你好厉害啊啊啊啊啊啊啊啊啊啊——",
    "randomEventDialogueGroupConfig_10.224": "表示听不够",
    "randomEventDialogueGroupConfig_10.225": "表示听够了",
    "themeCardPackName_19005": "溜溜之死",
    "randomEventDialogueGroupConfig_10.226": "不必感到疑惑，这种灵动的秩序，就封印在你的心中。命运迟早会将这种体验具象抽出来赠与你。",
    "randomEventDialogueGroupConfig_10.227": "打出问号",
    "randomEventDialogueGroupConfig_10.228": "跑",
    "randomEventDialogueGroupConfig_10.229": "你好强啊啊啊啊啊啊啊啊啊啊——",
    "messageInitContent_7606": "晚安星烁大小姐",
    "messageInitContent_7607": "晚安世界",
    "messageInitContent_7604": "对了",
    "messageInitContent_7605": "希望大家蒙的都对",
    "messageInitContent_7608": "这就是所谓的热血吗",
    "messageInitContent_7609": "打个call",
    "messageInitContent_7610": "不大不小",
    "messageInitContent_7613": "OoOoOoOo",
    "messageInitContent_7614": "OoOoOoOoOoOoOoOoOoOoOoOoOoOoOoOoOoOoOoOoOoOo",
    "messageInitContent_7611": "就问你几v几",
    "messageInitContent_7612": "噢噢噢",
    "randomEventDialogueGroupConfig_10.220": "收下",
    "randomEventDialogueGroupConfig_10.221": "不理你了，走了。",
    "randomEventDialogueGroupConfig_10.211": "离开",
    "randomEventDialogueGroupConfig_10.212": "拉住它",
    "randomEventDialogueGroupConfig_10.213": "就是规模还在不断壮大中！我回去统计一下，下次再告诉你好吗！",
    "randomEventDialogueGroupConfig_10.214": "放开它",
    "randomEventDialogueGroupConfig_10.215": "不放开",
    "randomEventDialogueGroupConfig_10.216": "再不放开，我就让你看看神秘商人的千层套路了！",
    "randomEventDialogueGroupConfig_10.217": "不放",
    "randomEventDialogueGroupConfig_10.218": "放开",
    "messageInitContent_7617": "很多小无限",
    "randomEventDialogueGroupConfig_10.219": "好吧，看来大家对同一样东西也会有不同的理解，又学到了谢谢你。这个送你。",
    "messageInitContent_7618": "oooooo00000000000",
    "messageInitContent_7615": "我的小火炉",
    "messageInitContent_7616": "不多不小？",
    "messageInitContent_7619": "蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋",
    "messageInitContent_7620": "OOOOOOOooooooo",
    "messageInitContent_7621": "蛋蛋",
    "messageInitContent_7624": "蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋",
    "messageInitContent_7625": "蛋蛋蛋蛋蛋蛋蛋蛋",
    "messageInitContent_7622": "蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋",
    "messageInitContent_7623": "全都是远程~~~",
    "randomEventDialogueGroupConfig_10.210": "我突然想起组织叫我保密，嘻嘻。有事，先跑啦。",
    "randomEventDialogueGroupConfig_10.200": "点头告别",
    "randomEventDialogueGroupConfig_10.201": "那么大！全超进化大陆最大的夸夸组织！",
    "themeCardPackName_19025": "咻咻说",
    "randomEventDialogueGroupConfig_10.202": "让它说具体点",
    "randomEventDialogueGroupConfig_10.203": "不如来逛逛商店吧！",
    "randomEventDialogueGroupConfig_10.204": "逛商店",
    "randomEventDialogueGroupConfig_10.205": "追问",
    "randomEventDialogueGroupConfig_10.206": "那个，目前就……就，啊我这里有些小东西，送给你吧！",
    "themeCardPackName_20015": "规则",
    "randomEventDialogueGroupConfig_10.207": "继续追问",
    "messageInitContent_7628": "猜对day0",
    "randomEventDialogueGroupConfig_10.208": "收下",
    "messageInitContent_7629": "蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋",
    "randomEventDialogueGroupConfig_10.209": "离开",
    "messageInitContent_7626": "被占据了",
    "messageInitContent_7627": "蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋蛋",
    "themeCardPackName_19020": "桐仁说",
    "messageInitContent_7631": "好奇哦",
    "messageInitContent_7632": "本体和技能",
    "messageInitContent_7630": "主打一个随缘",
    "messageInitContent_7635": "来了来了",
    "messageInitNick_5198": "痛苦但不纠结",
    "messageInitContent_7636": "走了走了",
    "messageInitNick_5199": "胡萝卜兽",
    "messageInitContent_7633": "宠物医院这边请",
    "messageInitContent_7634": "在猜了在猜了",
    "themeCardPackName_20010": "事前准备",
    "themeCardPackName_19015": "祖拉说",
    "themeCardPackName_20005": "前言",
    "messageInitContent_7639": "子 弹 蒸 发",
    "messageInitNick_5194": "没关系",
    "messageInitNick_5195": "请别靠近我",
    "messageInitContent_7637": "OOOOOOOooooooo",
    "messageInitNick_5196": "千影妖魂",
    "messageInitContent_7638": "蒸发了都",
    "messageInitNick_5197": "拉肠侠",
    "messageInitNick_5190": "东方短毛猫",
    "messageInitNick_5191": "好奇怪妹妹",
    "themeCardPackName_19010": "叉叉说",
    "messageInitNick_5192": "无语凳子",
    "messageInitNick_5193": "光棍村村长",
    "messageInitContent_7642": "晚安大星星",
    "messageInitContent_7643": "肉眼可见的优势",
    "messageInitContent_7640": "出道吧！",
    "messageInitContent_7641": "晚安大魅魅",
    "messageInitContent_7646": "emm这同色系",
    "messageInitNick_5187": "笨吖頭",
    "messageInitContent_7647": "看看我的小宝贝在不在",
    "messageInitNick_5188": "音乐法师",
    "messageInitContent_7644": "有盾！",
    "messageInitNick_5189": "狂飙的企鹅",
    "messageInitContent_7645": "早上好下午好晚上好",
    "gameName_1004": "万事大吉",
    "gameName_1003": "万事亨通",
    "randomEventDialogueGroupConfig_10.266": "离开",
    "randomEventDialogueGroupConfig_10.267": "它一把将手里的东西丢出去，一边往反方向跑。",
    "randomEventDialogueGroupConfig_10.268": "追",
    "randomEventDialogueGroupConfig_10.269": "拿东西",
    "messageInitNick_5183": "小疯子",
    "messageInitNick_5184": "尘封灵魂",
    "messageInitNick_5185": "单身卫士",
    "messageInitNick_5186": "两点的凉茶",
    "messageInitNick_5180": "有学过的痕迹",
    "messageInitNick_5181": "不愿做李白",
    "messageInitNick_5182": "深度反思",
    "messageInitNick_5176": "退役跟风选手",
    "messageInitNick_5177": "芒果很忙",
    "messageInitNick_5178": "长得欠抽",
    "messageInitNick_5179": "我承认你很强",
    "randomEventDialogueGroupConfig_10.260": "嘿嘿，后面的还没背，跑了！",
    "randomEventDialogueGroupConfig_10.261": "离开",
    "randomEventDialogueGroupConfig_10.262": "它双手努力朝着外侧斜上高举。",
    "randomEventDialogueGroupConfig_10.263": "表扬它",
    "randomEventDialogueGroupConfig_10.264": "与它告别",
    "randomEventDialogueGroupConfig_10.265": "它红着脸跑掉了。",
    "messageInitNick_409": "懂神",
    "randomEventDialogueGroupConfig_10.255": "问号加一",
    "randomEventDialogueGroupConfig_10.256": "跑",
    "randomEventDialogueGroupConfig_10.257": "这种多维度的聚合将划出通往未来的轨迹，追寻每一个跳跃的尖峰。",
    "randomEventDialogueGroupConfig_10.258": "说下去",
    "randomEventDialogueGroupConfig_10.259": "跑",
    "messageInitNick_401": "满脑子都是你",
    "messageInitNick_5172": "独孤求胜",
    "messageInitNick_402": "小迷妹",
    "messageInitNick_5173": "捡漏公主",
    "messageInitNick_403": "别闹少年",
    "messageInitNick_5174": "觉醒四叶草",
    "messageInitNick_404": "好人",
    "messageInitNick_5175": "烧麦牧师",
    "messageInitNick_405": "独揽风月",
    "messageInitNick_406": "步行道之心",
    "messageInitNick_407": "黑玫瑰",
    "messageInitNick_5170": "到你玩了",
    "messageInitNick_408": "行走在你心里",
    "messageInitNick_5171": "浪出宇宙",
    "messageInitNick_5169": "把把评分第五",
    "messageInitNick_5165": "灰塔",
    "messageInitNick_5166": "半温半暖",
    "messageInitNick_5167": "东风醉",
    "messageInitNick_400": "独自去流浪",
    "messageInitNick_5168": "不标准答案",
    "randomEventDialogueGroupConfig_10.250": "你好……呀。",
    "randomEventDialogueGroupConfig_10.251": "继续听",
    "randomEventDialogueGroupConfig_10.252": "哇，你这个短暂的沉默，充分展现了你的成熟和沉稳，还有你的深思熟虑。",
    "randomEventDialogueGroupConfig_10.253": "……",
    "randomEventDialogueGroupConfig_10.254": "这是一种不定形态的潜力，但又能稳定地啄杀阴影中的魅影，这股被遗忘的能力一直寄宿在你的周围！",
    "activityNodeName_18": "王的晚餐",
    "randomEventDialogueGroupConfig_10.244": "进店",
    "activityNodeName_19": "巨龙炮袭",
    "randomEventDialogueGroupConfig_10.245": "不理它离开",
    "activityNodeName_16": "霸者",
    "randomEventDialogueGroupConfig_10.246": "夸就应该是要努力挖掘和充满想象的呢。",
    "activityNodeName_17": "强者云集",
    "randomEventDialogueGroupConfig_10.247": "夸得很好不要再说了",
    "randomEventDialogueGroupConfig_10.248": "你的这声惊叹，充分展现了你充沛的活力和对这个世界的好奇与兴奋。实在是太美妙！",
    "randomEventDialogueGroupConfig_10.249": "质疑它想太多了",
    "messageInitNick_412": "弓响日落",
    "messageInitNick_5161": "免费的点赞",
    "messageInitNick_413": "专业引战",
    "messageInitNick_5162": "给你带来笑容",
    "messageInitNick_414": "复读门传人",
    "messageInitNick_5163": "咕噜",
    "messageInitNick_415": "朕作业做完了",
    "messageInitNick_5164": "给梦插上翅膀",
    "activityNodeName_14": "林中的赤色",
    "messageInitNick_416": "请别叫我阿姨",
    "activityNodeName_15": "深渊在凝视你",
    "messageInitNick_417": "吃醋小王子",
    "activityNodeName_12": "巨龙炮袭",
    "messageInitNick_418": "大灰机",
    "activityNodeName_13": "异域爱情故事",
    "messageInitNick_419": "右心室爱你",
    "messageInitNick_5160": "超强星灵",
    "messageInitNick_5158": "老纳",
    "messageInitNick_5159": "神明未曾心动",
    "messageInitNick_5154": "早餐吃煎饼",
    "messageInitNick_5155": "西兰花撞地球",
    "messageInitNick_410": "沧海上的蝴蝶",
    "messageInitNick_5156": "话费不足",
    "messageInitNick_411": "琴音似君语",
    "messageInitNick_5157": "混世小魔女",
    "randomEventDialogueGroupConfig_10.240": "你真的好好啊啊啊啊啊啊啊啊啊啊啊——",
    "randomEventDialogueGroupConfig_10.241": "表示听不够",
    "randomEventDialogueGroupConfig_10.242": "表示听够了",
    "randomEventDialogueGroupConfig_10.243": "你这的漫长沉默想必是在酝酿着什么惊世的伟论，你也可以在我店里慢慢想想。",
    "randomEventDialogueGroupConfig_10.233": "说好的",
    "randomEventDialogueGroupConfig_10.234": "下次一定",
    "randomEventDialogueGroupConfig_10.235": "泥好，窝的赏兹补星了，虾刺再夸霸，再贱。",
    "randomEventDialogueGroupConfig_10.236": "夸它",
    "randomEventDialogueGroupConfig_10.237": "告别",
    "randomEventDialogueGroupConfig_10.238": "你好好好好牛哇哇哇哇哇哇哇哇哇哇哇哇——",
    "randomEventDialogueGroupConfig_10.239": "说听不够！",
    "messageInitNick_423": "嘴角上翘",
    "messageInitNick_5150": "转向未来",
    "messageInitNick_424": "欢乐法师",
    "messageInitNick_5151": "香水模拟器",
    "messageInitNick_425": "脑洞补偿",
    "messageInitNick_5152": "环保精英",
    "messageInitNick_426": "大众电灯泡",
    "messageInitNick_5153": "细雨挽轻裳",
    "messageInitNick_427": "今晚去非洲",
    "messageInitNick_428": "比纸薄的情",
    "messageInitNick_429": "笑多了会怀孕",
    "messageInitNick_5147": "比太阳耀眼",
    "messageInitNick_5148": "高情商炖汤",
    "messageInitNick_5149": "冷场怪物",
    "messageInitNick_5143": "猫咪饭堂",
    "messageInitNick_420": "愿你一切安好",
    "messageInitNick_5144": "我家烧烤店",
    "messageInitNick_421": "撩汉狂魔",
    "messageInitNick_5145": "过期的灵药",
    "messageInitNick_422": "全宇宙逃亡",
    "messageInitNick_5146": "异世界洞洞鞋",
    "randomEventDialogueGroupConfig_10.230": "表示听不够",
    "randomEventDialogueGroupConfig_10.231": "表示听够了",
    "randomEventDialogueGroupConfig_10.232": "蟹蟹泥。赖我赏殿康康吧。",
    "activityNodeName_38": "强者云集",
    "activityNodeName_39": "王的晚餐",
    "activityNodeName_32": "王的晚餐",
    "messageInitNick_434": "音乐虫子",
    "activityNodeName_33": "巨龙炮袭",
    "messageInitNick_435": "发狂的蜗牛",
    "messageInitNick_5140": "能动手少哔哔",
    "themeCardPackDes_17020": "撕心裂肺的疼痛将绯焉从无意识的虚空唤醒，四下死寂，遍地腥红，手上残留着不明的余温，她不知道这是什么回事，她只能确信那是现实，腹部突如其来的剧痛使她再度失去意识。\\n有一次撕心裂肺的疼痛将绯焉从无意识的虚空唤醒，这次她比往常都清醒得要早。\\n对灵魂和血肉的强烈欲望正裹挟着她，吞噬着手中的活物。往日的现实终于有了答案，不是什么异象，也不是兽群混战的战场，而是她，是她将沿途遇见的活物吃干抹净，吞噬血肉，夺取灵魂，将大地染红，以至于她的所到之处是消亡的聚落，是死寂的片区。\\n想到这她不由得尖叫起来，却没有半点声响。是的，她控制不了这具肉体，哪怕是尖叫都做不到。\\n不对。真的控制不了吗，她反问自己，刚刚不是有只东西从她手里跑掉了吗，她刚刚难道不是稍稍松开手了吗？",
    "activityNodeName_30": "霸者",
    "messageInitNick_436": "画饼高手",
    "messageInitNick_5141": "好好努力行不",
    "activityNodeName_31": "强者云集",
    "messageInitNick_437": "戴围巾的猪",
    "messageInitNick_5142": "爆米花仙子",
    "activityNodeName_36": "深渊在凝视你",
    "messageInitNick_438": "菠萝皮卡丘",
    "activityNodeName_37": "霸者",
    "messageInitNick_439": "比丸子还乖",
    "activityNodeName_34": "异域爱情故事",
    "themeCardPackDes_17025": "绯焉受够了这种无度的进食，受够了这种进食来带的疼痛，尚未消化的血肉撕扯着她的身体，尚未离去的灵魂在她大脑里疯狂嘶吼。\\n当欲望归于沉寂时，苦痛再也无法忽视地汹涌而出，她不想再为进食的快感，忍受随之而来的痛苦了。\\n所幸，意识到自己身体能够受控的那刻起，改变开始悄然在她身上发生。\\n当身体扑向活物，她不断将精力集中到双腿后的一只巨爪上，那爪也稍稍给出了回忆，小小地勾住了脚，她将自己绊倒在地。当闻到活物的气息时，她用单翼挡住口鼻。微小的掌控感渐渐变得更加持续，更加有力。直至她的巨爪足以钳制双脚，双翼能轻松持续遮蔽感官，长发能在关键时束缚身躯。越来越多的改变变得可见，不再过度进食的肉体变得越发纤长结实，她清醒的时刻也越来越长……\\n可她知道她的改变还远远不够，因为欲望越是压抑，下次的爆发就来得越发可怕。巨爪、双翼、长发只是其中一个手段，但依旧无法彻底解决她天生的对灵肉的渴望。\\n是的，她没办法完全不进食。在禁食二十个日月后，她抓住了路旁的一只怪兽。\\n只吃一点，就一点。吃啊！吃！吃啊！不要忍耐。快啊啊啊啊！欲望的低语渐渐变成了疯狂的咆哮。\\n双翼颤动着挣扎着要张开，扑鼻而来的腥味使得她无法自已，她咬了上去。\\n随后她透过羽毛看到了那只活物，看见了令她无比惊愕的一幕。",
    "activityNodeName_35": "林中的赤色",
    "messageInitNick_5136": "老旧奶瓶",
    "messageInitNick_7799": "唇齿间的故事",
    "messageInitNick_5137": "不爱补刀的哥",
    "messageInitNick_7798": "便当大师",
    "messageInitNick_5138": "傲拳狂连",
    "messageInitNick_5139": "万能项坠",
    "messageInitNick_430": "长得很抽象",
    "messageInitNick_5132": "花开无忧",
    "messageInitNick_7795": "欧气爆棚",
    "activityNodeName_40": "巨龙炮袭",
    "messageInitNick_431": "小满足",
    "messageInitNick_5133": "灵魂剑客",
    "messageInitNick_7794": "纯情糖果",
    "messageInitNick_432": "一二三我偏动",
    "messageInitNick_5134": "猕猴桃龙",
    "messageInitNick_7797": "雨伞先锋",
    "messageInitNick_433": "擅长敲退堂鼓",
    "messageInitNick_5135": "真心已售完",
    "messageInitNick_7796": "嫉妒使猫蒙蔽",
    "activityNodeName_29": "深渊在凝视你",
    "randomEventDialogueGroupConfig_10.299": "谢谢你，我会回去好好反思提升自己的水平的呢。再见。",
    "activityNodeName_27": "异域爱情故事",
    "activityNodeName_28": "林中的赤色",
    "activityNodeName_21": "林中的赤色",
    "messageInitNick_445": "虎牙少年",
    "messageInitNick_7791": "姜魔法师",
    "themeCardPackDes_17030": "挣扎了许久，绯焉终于撇下欲望的怒吼，回过神来。她手上正捧着一条柔软的东西，那是一条叫溜溜的怪兽。溜溜突然在她手上扭动了一下，然后溜出了她的双手，滑落到地面，在她面前疯狂扭动了好一阵子后才离开。\\n“它的意思是，感谢你它吸出了身上的毒液，那个扭动是道谢的动作。欲望未必是真正需要的东西，可能只是让我们以为我们渴求的东西。”路过的智者在远处吆喝了几声，说了一堆莫名奇妙的话后，就从她狭小的视野里消失不见了。\\n让绯焉更为诧异的是，积累多时的欲望竟被一点点毒血填满了。若是放在以前，那种欲望下，她可能要吃掉上百条溜溜才能满足。她不想放过这个不寻常的点，拼命地思考着刚刚发生的一切。\\n一个新的假想在她脑海中浮现，她或许只是空有对肉体和灵魂的渴望，可她身体真正需要的可能不完全是肉体和灵魂，而是……\\n趁着欲望被清空的间隙，她决定好好探究一番。",
    "activityNodeName_22": "深渊在凝视你",
    "messageInitNick_446": "不正经的枕头",
    "messageInitNick_7790": "及时雨",
    "messageInitNick_447": "久旱逢沐浴露",
    "messageInitNick_5130": "猪见愁",
    "messageInitNick_7793": "闪耀苹果",
    "activityNodeName_20": "异域爱情故事",
    "messageInitNick_448": "年轻的每米呦",
    "messageInitNick_5131": "手指骨",
    "messageInitNick_7792": "冠萼花楸",
    "activityNodeName_25": "王的晚餐",
    "messageInitNick_449": "不会过马路",
    "activityNodeName_26": "巨龙炮袭",
    "themeCardPackDes_17035": "一路上，绯焉处处留心着那些正在进食的怪兽，她试着观察它们，或是与它们搭话，了解它们进食的原因，她想搞懂真正能填满自己的到底是什么。\\n那天，她来到一处荒芜之地，她记得不久前这里还是一片郁郁葱葱的林地，转变的交叠使眼前的景色变得更加残酷。\\n一只只瘦得皮包骨的怪兽在扭曲的热气中爬行，随后一只体型更大的怪兽从地底扑出，张口将那只怪兽咬住扯入地底。突然，一只怪兽滚到了她的脚下，她不由得心头一震，她轻轻将那只怪兽拎起，放到双翼底下细嗅。她心头一震，心神有点恍惚，这只头上长着两条腿的怪兽不正是之前从她手里溜出去的怪兽吗，过去的回忆在羽翼的暗面翻涌。\\n下一秒一道黑影闪过，手中干瘪的星刃被夺走了。这里饥肠辘辘的怪兽为了填饱肚子已然顾不得太多。\\n转瞬间，星刃被她夺回。她不愿再次被愧疚包围。虽然她很清楚这只是一种虚无缥缈的安慰，但救下这只星刃确实让她感觉好了许多。\\n她还不知道这只星刃带给她的还不仅于此。",
    "activityNodeName_23": "霸者",
    "activityNodeName_24": "强者云集",
    "messageInitNick_5125": "老子叫甜甜",
    "messageInitNick_7788": "心动电量过低",
    "messageInitNick_5126": "好怪再吻一次",
    "messageInitNick_7787": "娇美的杏子",
    "messageInitNick_5127": "河水流流流",
    "messageInitNick_440": "路人乙",
    "messageInitNick_5128": "抢饭第一名",
    "messageInitNick_7789": "望远镜照镜子",
    "messageInitNick_441": "燃烧一颗恒星",
    "messageInitNick_5121": "甜甜甜甜甜瓜",
    "messageInitNick_7784": "夜空一样温柔",
    "messageInitNick_442": "流泪葱头",
    "messageInitNick_5122": "左右为难",
    "messageInitNick_7783": "饺子女巫",
    "messageInitNick_443": "隔壁的街",
    "messageInitNick_5123": "弱小可怜",
    "messageInitNick_7786": "旧日的约定",
    "messageInitNick_444": "转让半床",
    "messageInitNick_5124": "吃醋第一名",
    "messageInitNick_7785": "九点的凉茶",
    "randomEventDialogueGroupConfig_10.290": "我不……会了。我要……跑了。",
    "randomEventDialogueGroupConfig_10.291": "夸它并告别",
    "randomEventDialogueGroupConfig_10.292": "那是什么*禁止事项*？啊我的脑袋好疼，你做了什么。",
    "randomEventDialogueGroupConfig_10.293": "它疼得在地上打滚，然后滚远了，消失不见了。",
    "randomEventDialogueGroupConfig_10.294": "离开",
    "messageInitNick_5129": "椰子去哪了",
    "randomEventDialogueGroupConfig_10.295": "我这就回去加强修炼！谢谢你的指导，谢谢！",
    "randomEventDialogueGroupConfig_10.296": "离开",
    "randomEventDialogueGroupConfig_10.297": "好吧，照顾我一届陌生商人心情这一点也很令我动容呢，再见。",
    "randomEventDialogueGroupConfig_10.298": "告别",
    "randomEventDialogueGroupConfig_10.288": "同意",
    "randomEventDialogueGroupConfig_10.289": "表示算了",
    "themeCardPackDes_17040": "绯焉将救起的星刃带到一处水源，星刃圆滚滚的双眼正盯着她看。突然一股红色细流从星刃眼下嘴上的一处流出，它的伤口似乎裂开了。\\n绯焉伸出手指擦掉血液，随后把手放入嘴中，前所未有的满足感再一次出现了。\\n“谢谢你救了我，我的弟兄在那个荒漠的另一头，可以麻烦你带我回去吗？”。\\n那似乎是一只迷路的星刃，绯焉答应了它的请求。\\n路上，绯焉会尝一口从星刃的伤口渗出的血液，星刃则为她拉拢点点流星。在她的引领下，它们越过了大半个荒野。\\n那一夜，她突然被数颗硕大的流星砸中，她的身体先一步行动，将一只从未见过的怪兽压在身下。\\n那只怪兽一看见绯焉就开始抖个不停，嘴里不停滴说着是你，是你。\\n星刃跳了出来，拦在了中间，两头比划着。原来那就是星刃的弟兄血渊守护。星刃匆忙与绯焉道歉后，就拉着血渊守护离开了。\\n绯焉并没有追上去，因为她已经有点明白了她真正需要的是什么。\\n在那之后不久，若有怪兽找到绯焉，希望获得帮助，它们多半能如愿，代价仅仅是在获得帮助后为她献上一顿小小的大餐。",
    "activityNodeName_54": "巨龙炮袭",
    "messageInitNick_456": "秋水揽星河",
    "messageInitNick_7780": "我爱吃蛋挞",
    "activityNodeName_55": "异域爱情故事",
    "messageInitNick_457": "馋猫",
    "activityNodeName_52": "强者云集",
    "messageInitNick_458": "爱在夜里翻滚",
    "messageInitNick_7782": "高素质少女",
    "activityNodeName_53": "王的晚餐",
    "messageInitNick_459": "街灯亮起了",
    "messageInitNick_5120": "红毛丹真好吃",
    "messageInitNick_7781": "不爱舔毛的猫",
    "activityNodeName_58": "霸者",
    "activityNodeName_59": "强者云集",
    "activityNodeName_56": "林中的赤色",
    "activityNodeName_57": "深渊在凝视你",
    "messageInitNick_5114": "我已经在闹了",
    "messageInitNick_7777": "明晚回欧洲",
    "messageInitNick_5115": "流浪拾荒者",
    "messageInitNick_7776": "糖醋里脊",
    "messageInitNick_450": "哀家狠单纯",
    "messageInitNick_5116": "奖励你吃瓜",
    "messageInitNick_7779": "腰椎",
    "messageInitNick_451": "等候无期",
    "messageInitNick_5117": "天下第十",
    "messageInitNick_7778": "百变小怪",
    "activityNodeName_61": "集体发狂#独自放电",
    "messageInitNick_452": "已恢复单身",
    "messageInitNick_5110": "熬夜冠军",
    "messageInitNick_7773": "淡紫色梦境",
    "activityNodeName_62": "剑来#看剑",
    "messageInitNick_453": "吃货不会坏",
    "messageInitNick_5111": "等离子牙线",
    "messageInitNick_7772": "吃货王",
    "messageInitNick_454": "飚速之王",
    "messageInitNick_5112": "逆境局的狗",
    "messageInitNick_7775": "流浪的头状骨",
    "activityNodeName_60": "王的晚餐",
    "messageInitNick_455": "呆萌小怪",
    "messageInitNick_5113": "番茄先锋",
    "messageInitNick_7774": "梦开始的敌方",
    "randomEventDialogueGroupConfig_10.280": "继续",
    "randomEventDialogueGroupConfig_10.281": "你不怕困……难。",
    "randomEventDialogueGroupConfig_10.282": "继续",
    "randomEventDialogueGroupConfig_10.283": "你真独……特。",
    "messageInitNick_5118": "爱君君不知",
    "randomEventDialogueGroupConfig_10.284": "继续",
    "messageInitNick_5119": "傲娇小美女",
    "randomEventDialogueGroupConfig_10.285": "你行……不行啊。",
    "randomEventDialogueGroupConfig_10.286": "说它已经不是在夸你了",
    "randomEventDialogueGroupConfig_10.287": "那换一换。",
    "randomEventDialogueGroupConfig_10.277": "你是多么富有……精神。",
    "randomEventDialogueGroupConfig_10.278": "继续听",
    "activityNodeName_49": "林中的赤色",
    "randomEventDialogueGroupConfig_10.279": "你看起来很好……吃。",
    "activityNodeName_43": "深渊在凝视你",
    "messageInitNick_467": "初夏雨",
    "activityNodeName_44": "霸者",
    "messageInitNick_468": "不想输入",
    "activityNodeName_41": "异域爱情故事",
    "messageInitNick_469": "催泪小丑",
    "messageInitNick_7771": "嘴角上翘",
    "activityNodeName_42": "林中的赤色",
    "messageInitNick_7770": "文化灌溉",
    "activityNodeName_47": "巨龙炮袭",
    "activityNodeName_48": "异域爱情故事",
    "activityNodeName_45": "强者云集",
    "activityNodeName_46": "王的晚餐",
    "messageInitNick_5103": "爱吃无罪",
    "messageInitNick_7766": "锈色花楸",
    "messageInitNick_460": "蹲街卖汽水",
    "messageInitNick_5104": "黙写你柔情",
    "messageInitNick_7765": "倒吸一口凉皮",
    "messageInitNick_461": "吃饭从不留名",
    "messageInitNick_5105": "强壮跑调神",
    "messageInitNick_7768": "冬日傲娇菊",
    "messageInitNick_462": "爱我要走心",
    "messageInitNick_5106": "生无可恋",
    "messageInitNick_7767": "金线蔷薇",
    "activityNodeName_50": "深渊在凝视你",
    "messageInitNick_463": "吞掉小忧伤",
    "messageInitNick_7762": "叫我小透明",
    "activityNodeName_51": "霸者",
    "messageInitNick_464": "爱却说不出口",
    "messageInitNick_5100": "倒霉的河流",
    "messageInitNick_7761": "大脑断电",
    "messageInitNick_465": "比太阳耀眼",
    "messageInitNick_5101": "你不在的季节",
    "messageInitNick_7764": "翅膀硬了",
    "messageInitNick_466": "豆浆油条",
    "messageInitNick_5102": "被辐射的魂",
    "messageInitNick_7763": "尖叫柿子",
    "randomEventDialogueGroupConfig_10.270": "你在一处崎岖的地方跟丢了它。",
    "randomEventDialogueGroupConfig_10.271": "离开",
    "randomEventDialogueGroupConfig_10.272": "沉溺顺毛竟不能自拔的神秘商人被你强硬扯开，它突然想起什么似地从身上掏出了什么试图挽留你。",
    "messageInitNick_5107": "长命网红小吃",
    "randomEventDialogueGroupConfig_10.273": "拿了就跑",
    "messageInitNick_5108": "梨子捞月",
    "messageInitNick_7769": "超级肉丸",
    "randomEventDialogueGroupConfig_10.274": "趁商人不注意离开",
    "messageInitNick_5109": "榜二小哥",
    "randomEventDialogueGroupConfig_10.275": "这时隔壁有个体型和你差不多的家伙经过，神秘商人显然认错了扑了过去。",
    "randomEventDialogueGroupConfig_10.276": "离开",
    "messageInitNick_7760": "超级布丁",
    "messageInitContent_5078": "乖巧",
    "messageInitNick_7755": "迷路的粉底液",
    "messageInitContent_5077": "好耶",
    "messageInitNick_7754": "爱上了她",
    "messageInitNick_7757": "记忆格式化",
    "messageInitContent_5079": "不准说赤虹是小短腿！！",
    "messageInitNick_7756": "我有异议",
    "messageInitNick_7751": "得瑟小姐",
    "messageInitNick_7750": "霸天苍龙",
    "messageInitNick_7753": "大明湖畔的谁",
    "messageInitNick_7752": "流浪的头盖骨",
    "messageInitContent_5070": "我想要个狂野形态",
    "messageInitContent_5072": "都来我这就好，不用打",
    "messageInitContent_5071": "还不够大胆",
    "messageInitContent_5074": "方方圆圆",
    "messageInitNick_7759": "最爱菠菜",
    "messageInitContent_5073": "我喜欢白的",
    "messageInitNick_7758": "约定的饮料",
    "messageInitContent_5076": "日常等答案",
    "messageInitContent_5075": "真理还是掌握在大多数人手上的",
    "messageInitContent_5089": "暴力小萝莉遇上键盘侠",
    "messageInitNick_7744": "绝版丫头",
    "messageInitContent_5088": "KB侠是什么侠",
    "messageInitNick_7743": "吃饭之后",
    "messageInitNick_7746": "错银铜牛灯",
    "messageInitNick_7745": "纯净的纯净水",
    "messageInitNick_7740": "一坨肥猫",
    "messageInitNick_7742": "与幸福有约",
    "messageInitNick_7741": "蒜泥香蕉",
    "messageInitContent_5081": "这狂潮形态要拟态谁",
    "messageInitContent_5080": "可爱就是正义",
    "messageInitContent_5083": "高贵的原生族",
    "messageInitContent_5082": "怎么不可以拟态原生",
    "messageInitContent_5085": "刀马？？？",
    "messageInitNick_7748": "呀嘞呀嘞",
    "messageInitContent_5084": "赤虹我来帮你啦！",
    "messageInitNick_7747": "地铁卡忘带了",
    "messageInitContent_5087": "如果手长和短腿一定要选一个，那么我选择手长",
    "messageInitContent_5086": "欺负一个小萝莉！",
    "messageInitNick_7749": "尬聊门传人",
    "messageInitContent_5090": "你们有考虑过刀马的想法",
    "messageInitNick_7733": "龙眼爱好者",
    "messageInitContent_5099": "手长可以是一个射手最重要的素质之一",
    "messageInitNick_7732": "彼岸繁花",
    "messageInitNick_7735": "烧麦吞噬者",
    "messageInitNick_7734": "幻想时间到",
    "messageInitNick_7731": "姓女名王",
    "messageInitNick_7730": "咕咕王",
    "messageInitContent_5092": "过分",
    "messageInitContent_5091": "赤虹四舍五入也是个前排",
    "messageInitContent_5094": "略略略略略",
    "messageInitContent_5093": "你礼貌吗",
    "messageInitContent_5096": "我的无线鼠标",
    "messageInitNick_7737": "蟹妖的腰",
    "messageInitContent_5095": "这游戏最容易cos的就是键盘侠了",
    "messageInitNick_7736": "一点的拉肠",
    "messageInitContent_5098": "到底是谁欺负谁呢",
    "messageInitNick_7739": "跳时钟",
    "messageInitContent_5097": "巫妖王也好cos啊",
    "messageInitNick_7738": "独钓一江水",
    "messageInitNick_7722": "帅气的地瓜",
    "messageInitNick_7721": "助力高考",
    "messageInitNick_7724": "帅哥电量不足",
    "messageInitNick_7723": "紫色妖姬",
    "messageInitNick_7720": "哈密瓜魔法师",
    "messageInitNick_7729": "蘑菇撞地球",
    "messageInitNick_7726": "扭蛋肌肉",
    "messageInitNick_7725": "岸边花",
    "messageInitNick_7728": "泪姬",
    "messageInitNick_7727": "豆角撞地球",
    "22_comment": "活动",
    "messageInitNick_7711": "安静的等待",
    "messageInitNick_7710": "捡漏王",
    "messageInitNick_7713": "沧海行云",
    "messageInitNick_7712": "冰似绕指柔",
    "messageInitNick_7719": "拒绝勾引",
    "messageInitNick_7718": "酷到没对象",
    "messageInitNick_7715": "明年相亲",
    "messageInitNick_7714": "豌豆魔法",
    "messageInitNick_7717": "典当灵魂",
    "messageInitNick_7716": "沉浸式化妆",
    "messageInitNick_7700": "打脸王子",
    "messageInitNick_7702": "万恶之源",
    "messageInitNick_7701": "不愿透露姓名",
    "messageInitNick_7708": "危险勿近",
    "messageInitNick_7707": "感性又性感",
    "messageInitNick_7709": "风在喃我在听",
    "messageInitNick_7704": "双眼被祝福了",
    "messageInitNick_7703": "迷路的核膜",
    "messageInitNick_7706": "上课起立",
    "messageInitNick_7705": "灵魂摆渡人",
    "resoundEventStoryDes_630": "猎神图腾上生长着一种叫绿羽的神圣植物，用于制作狩猎用的箭羽。\\n然而，随着羽际线年年后退，能采集的绿羽也逐年减少。\\n面对这场神圣资源的稀缺危机，这个擅长狩猎的部族终于决定——捣鼓绿羽种植。\\n目前的捣鼓结论只有一个，拔出来放地上，会枯。",
    "messageInitContent_5108": "我要的档案呢",
    "messageInitContent_5107": "就很棒",
    "messageInitContent_7769": "【信息不完整为确保安全实施遮盖】",
    "messageInitContent_5109": "想你",
    "messageInitContent_5111": "你需要治疗孩子",
    "messageInitContent_7774": "1127。不要看到那个字就想起他",
    "messageInitContent_5110": "我不想放弃治疗",
    "messageInitContent_7775": "【##############】",
    "messageInitContent_5113": "到底是什么地方需要治疗",
    "messageInitContent_7772": "关一下战挑要不。1",
    "messageInitContent_5112": "快跟我回去接受治疗",
    "messageInitContent_7773": "1126。不要让屠帝知道你知道它的真名",
    "messageInitContent_5115": "已弃疗，正在工作",
    "messageInitContent_7778": "0.在挑战前请保持冷静情绪波动会影响规则的解释",
    "messageInitContent_5114": "我得了一种一上班就会晕的病",
    "messageInitContent_7779": "1,带关卡数字的是关卡独特规则",
    "messageInitContent_5117": "桃",
    "messageInitContent_7776": "1127。可以擦走涂鸦",
    "resoundEventStoryDes_639": "四位玩偶棋兵同时现身。它们的存在标志着B.B.Token首次将规则改写，成功施加于非玩物身上。然而，这种状态是否能够长期维持，仍需在本关卡中不断验证。",
    "messageInitContent_5116": "本人在世华佗，我选右边",
    "messageInitContent_7777": "【信息被涂鸦】",
    "resoundEventStoryDes_637": "这里的玩物游戏，意外地好评如潮。\\n即时战略x厨房烹饪，你试过了吗？你需要利用瞬间判断力调度厨房资源，一边下锅，一边救火，还要应付王·霸者这个难缠的客人。\\n来吧！厨房即战场，上菜吧！",
    "resoundEventStoryDes_638": "游戏玩得越多，王·炼狱魔眼眼球上的血丝也越来越多。\\n快乐并没有消失，只是变得越来越难被感知。\\n也许，这就是血丝诅咒。",
    "resoundEventStoryDes_635": "说出神秘口令，即可将王·量子力龙的量子波动攻击将从「必然命中」切换为「超密集弹幕」。\\n要试试自己的反应吗？",
    "resoundEventStoryDes_636": "有个恋爱游戏，你只需要轻轻一碰，对方的好感度立刻拉满至999999999。通关后，就有一定概率可以体验哦。（天知道这是不是只是为了引诱怪兽来这里挑战的陷阱呢。）\n",
    "messageInitContent_7770": "1126。终结者是屠帝的真名",
    "resoundEventStoryDes_633": "据说，严寒是猎神降下的考验。\\n若能在这个神坛献上令猎神满意的猎物，祂便会接纳祭献，驱散寒冬，赐予温暖。\\n听说驱寒神坛周边还会时不时出现好运神符，但天知道，那是不是哪个猎手的陷阱。",
    "messageInitContent_7771": "1126。切勿叫剧王的那个名字",
    "resoundEventStoryDes_634": "呜——\\n燃烧猎角每日都会在冰河空渊响起。\\n这是猎物难得的喘息时刻。\\n因为此刻所有信仰猎神的怪兽都停止狩猎，面朝寒风，献上最虔诚的祈祷。\\n毕竟猎神有训——无猎物，便无猎者。",
    "resoundEventStoryDes_631": "那本是始原荒地最高大最壮观的图腾，如今却因为战火而倒塌。图腾头部看起来也从“无所不能”变成了现在的“啊你行你上”。",
    "resoundEventStoryDes_632": "想找到好果子？那可不是随便捡捡就行的。\\n按照叉叉对太古图腾的解读，得先在那块长石头上躺一会儿，然后围着尖石跑三圈，接着用屁股在长石上摩几下，最后再跳上高石头来一段招果之舞。",
    "resoundEventStoryDes_640": "自从王·赤色狮与源·危险的草丛在爪机库里“理解”了什么是无双之后，它们便开始长期驻守在这里，彼此较劲，比拼谁能无双得更多。",
    "resoundEventStoryDes_641": "这里提供一种不记录在通关条件里的通关方式。\\n你将与王·贝·爷一同被投放进灾·焚风定制的区域。没有多余补给，没有明确指引。活过一周，即视为完成。\\n好像……还是老老实实干一场更好，对吧。",
    "messageInitContent_5119": "奶妈心好累",
    "messageInitContent_5118": "赤虹之后是赤炼零式哦",
    "messageInitContent_5122": "睡一觉就好",
    "messageInitContent_7785": "3。如果你还是挑战了，那么先退出登录后，再重新登录",
    "messageInitContent_5121": "多喝热水",
    "messageInitContent_7786": "1129。不要提起美杜莎莎",
    "messageInitContent_5124": "这题我懂",
    "messageInitContent_7783": "1128。第五只怪兽是另一个世界的幽灵",
    "messageInitContent_5123": "清醒一点",
    "messageInitContent_7784": "1129。不要提起美杜莎鲨",
    "messageInitContent_5126": "还是比中彩票简单的",
    "messageInitContent_7789": "0.在挑战前请保持冷静情绪波动会影响规则的解释",
    "messageInitContent_5125": "天天都是二分之一的机会",
    "messageInitContent_5128": "为空蝉打call",
    "messageInitContent_7787": "【该内容被遮挡】",
    "messageInitContent_5127": "乐",
    "messageInitContent_7788": "1129。溜溜是路线的神圣指引者",
    "resoundEventStoryDes_648": "水浦争夺战的受欢迎程度是超乎想象的。\\n它的规则相当简单易懂，最多同时允许3位玩家同时游戏，通过共感装置与触手完成同步，从而实现对应触手的控制。游戏开始后，每隔一段时间，水面上的彩色水浦就会被不规则的水流冲飞，玩家需要控制对应的触手，接住更多的彩色水浦。\\n乍看复杂度和游戏深度都不如周边的游戏，可却异常受欢迎。而它受欢迎的原因也不难理解，玩家是这么说的……还有什么比扮演触手更好玩的？触手那可是触手！巨大的触手！我可爱死触手了！\\n（该游戏尚无B.B.T额外规则。）",
    "resoundEventStoryDes_649": "里 这 是 机 动 迷 城 的 拼 好 图 物 玩 戏 游。\\n游戏规则如下：\\n只需凑齐2位或以上玩家即可开始。最快将所有拼图块正确拼接成完整图案即可获胜。期间不能以任何形式干扰其他玩家。\\n（B.B.T额外规则：拼图图案将按玩物世界特定时间的特定点位生成。拼图进度没超过10%将随机生成奖励包，或惩罚包，奖励包和惩罚包可用于自身或对手。惩罚包内容是尚未完整公开……）",
    "resoundEventStoryDes_646": "你盯着它看了很久。\\n蓝色外框像是特地围出的区域，黄色同心圆，像某种密码盘，又像是计数，也像按钮，甚至像一筒。\\n你开始推演：\\n是不是要按顺序触发？是不是要长按？是不是要换个角度看？有没有数字藏在里头？隔壁的星星是提示还是误导？那块红色小方块又在暗示什么。\\n你反复试，不断想，怀疑自己漏掉了什么。\\n可都不对。\\n直至终于意识到那件更荒唐的事：可能真的什么都不是。自以为的解密，实际上只是在凝视一块装饰。\\n而最可怕的是，正当你决定放弃思考，又开始不甘心地想：\\n……突破口真的不是这里吗？",
    "resoundEventStoryDes_647": "不碰一下会不会错过什么？\\n——你已经知道答案了。",
    "messageInitContent_7781": "0.享受世界",
    "resoundEventStoryDes_644": "这片区域的板件显然出了问题。\\n不管拆多少次，只会产出一模一样的叉叉板件。\\n但没有关系，怪兽们砌出的叉叉模型从不重样。",
    "messageInitContent_7782": "1128。切勿击杀第五只怪兽",
    "resoundEventStoryDes_645": "这是一个名为打地龙的玩物游戏。玩家需要用一旁的锤子，击打从洞口中随机冒出的地龙，地龙冒出的时间很短。目标是尽可能击中地龙，获得高分。\\n眼见的你可能会问，那里有地龙呢？\\n实际上确实是地龙，只是B.B.Token修改了规则。新规下，地龙将带着不同的怪兽头像随机冒出。打中不同头像得分不同。你看到的是由B.B.Token选的初始头像，它可能觉得这几个打起来挺好玩或者够嘲讽吧。\\n最重要是，从现在开始，怪兽们可以投票选出被打的怪兽头像！目前污妖王的票数遥遥领先。你也来投出宝贵的一票吧！",
    "messageInitContent_5120": "又是你麦克斯韦妖",
    "resoundEventStoryDes_642": "起初，地面上的怪兽只觉得这片地形的颜色有些不对劲。那些深浅不一的色块，看起来相当随意。\\n直到能飞上高空的怪兽俯瞰下来，才意识到这并不简单。不同深浅的格子并非杂乱无章，而是以某种规律排列。\\n可惜，这片地形并没有玩物游戏的初始规则，更像是某种残缺的玩物，或是部件。\\n既然规则不可考，怪兽们干脆按自己喜欢的玩。它们飞升至固定高度，对准那些不同大小的格子，向下投掷粪便。格子越小，得分越高。大家都玩得不亦乐乎。\\n最初的胡闹,变成了后来的默认规则。只是，粪便换成了石头。\\n新的玩物游戏就此诞生。",
    "messageInitContent_7780": "1128。有1就会有2",
    "resoundEventStoryDes_643": "方块雨下个不停，时而不断堆积，时而消失不见。\\n这是只能在几何幻境看到的雨，变化莫测的光线构成一个个立方体组合，变换着形状落下。\\n这样的方块雨曾经是一场灾难，由于不断堆积造成过量光污染，周围的怪兽只能带着眼罩外出，否则就会被方块雨的光淹没。\\n所幸，一只神秘怪兽在拔螺丝的时候想到了消除它们的办法，它们才成为了如今无害的区域美景。",
    "resoundEventStoryDes_651": "恭喜你发现了模块工坊最简单也最难的玩物游戏！\\n游戏规则如下：\\n只需凑齐2位或以上玩家即可开始。玩家需用身体中“可以按下按钮的部位”轻轻碰着红色按钮。在游戏过程中，只要有任意一位玩家按下按钮，该玩家就会立即淘汰，按钮也会自动复位。最终坚持到最后，没有按下按钮的玩家将取得胜利！\\n这款游戏之所以简单，是因为规则很容易理解，而难就难在如何逼迫对手按下，自己却不被干扰，现在就来试试吧！\\n（B.B.T额外规则：每20秒按钮会播报一个部位，玩家需要立刻进行变更碰触红色按钮的部位，若无对应部位，则使用与上一次触碰所不同的部位。以及感受大地的翻涌吧哈哈哈哈哈！）",
    "resoundEventStoryDes_652": "不需要任何提示，只要被看见，就能唤起你继续搭建的冲动。你甚至还没来得及理解它是什么。",
    "resoundEventStoryDes_650": "这是一个总散发着梦幻般光芒的玩物游戏。\\n想玩好这个游戏只需要记住一个口诀：哪里亮了蹦哪里。可若是有一次失误没有把方块按压下去，游戏就会结束，计分停止。\\n由于不少方块都异常巨大，普通怪兽仅凭一兽之力是不肯定完成这个游戏的。因此这个游戏变成了一个多怪合作游戏。\\n特定种族如尸族的怪兽或某些怪兽集团就特别喜欢在这里搞团队建设活动。",
    "messageInitContent_5129": "天天都有漆黑组件",
    "messageInitContent_5133": "233333！",
    "messageInitContent_7796": "龙族的数量？",
    "messageInitContent_5132": "连对不可断",
    "messageInitContent_7797": "双种族也是龙族",
    "messageInitContent_5135": "你闹吧",
    "messageInitContent_7794": "龙族不就是那么几个吗",
    "messageInitContent_5134": "再不告诉我答案，我就闹了",
    "messageInitContent_7795": "赞美网络时代",
    "messageInitContent_5137": "有本事你告诉我答案",
    "messageInitContent_5136": "让人头大",
    "messageInitContent_5139": "一眼左边",
    "messageInitContent_7798": "龙族秩序图",
    "messageInitContent_5138": "嗯？",
    "messageInitContent_7799": "帮大家探探路",
    "resoundEventStoryDes_659": "这个巨大的棋盘，正是如今玩物之地非常受欢迎的游戏——《怪与地底穴》的所在地。\\n一局又一局的多怪幻想扮演游戏，在其中同时展开。\\n最初，这不过是几只怪兽围在一起的过家家游戏。\\n直到沉浸花蕾与思想树藤的发现和B.B.T规则的引入，才逐渐发展成如今的规模。\\n游戏的幻想世界由主兽构建。它们借助思想树藤，与浸入沉浸花蕾的从兽协作，共同生成完整的故事。\\n为了防止怪兽的幻想过于离谱或贫瘠，游戏有复杂切庞多的规则，规则手册异常厚重。也正因如此，早期参与其中的怪兽并不多。\\n直到后来，怪兽能够在进入游戏的瞬间，通过沉浸花蕾理解规则，使得游玩门槛被彻底移除后，玩家的数量才迎来了顶峰。",
    "resoundEventStoryDes_657": "这是一个围绕着中心红色水晶旋转的机关。玩家可以在扇叶转到跟前时跳起，也可以坐到上头和它一起转动。\\n此类不完整的玩物部件散落在玩物之地的各处，它们的一个特征便是没有明确的玩法。目前有玩家打算将它们整合起来，联结或整合到一个更大的玩物系统中去。\\n至少此刻，它们认为复杂而庞大的系统优于简单而微小的系统。",
    "resoundEventStoryDes_658": "爪机库是集齐了无数大屏玩物游戏的区域。这里的游戏都会在中心的大屏幕上显示出来，需配合周边的按键控制游玩，因此这片区域总是堆满了怪兽。\\n除了正在游玩的怪兽外，更多是在苦苦等待的怪兽。它们都已经玩过了这里某些系列作品的前两部。却一直未能等来第三部。",
    "messageInitContent_7792": "1130。逃离这里的规则是击败【】",
    "resoundEventStoryDes_655": "当近战怪兽想从战斗碰撞中缓一缓或是远程怪兽也想和其他怪兽碰碰却担心身板脆时，就很适合来玩这个名为碰碰圈的玩物游戏！\\n只要怪兽坐在碰碰圈上面，就可以操控碰碰圈与其他怪兽进行无伤碰撞。而现时最受欢迎的玩法有两个。第一个是占点魔兽，在规定时间结束时成功占据目标点即可获胜！\\n第二个是B.B.T额外规则下的守护模式。怪兽必须组队参与，队员必须守护队长不被撞飞出边界！\\n快来试试吧！",
    "messageInitContent_7793": "容内【】示揭勿请。1",
    "resoundEventStoryDes_656": "这条大水管并不安分，它会突然扭动、改道，像是临时起意的恶作剧。\\n想让水流顺利抵达水池，玩家只能亲自动手，纠正这些任性过头的管道。\\n它被认为是个生错了位置的玩物游戏，怪兽们更多时候只希望它能安分做条水管，而不是为了好玩制造更多麻烦。",
    "messageInitContent_5131": "伸爪",
    "messageInitContent_7790": "【信息不完整为确保安全实施遮盖】",
    "resoundEventStoryDes_653": "齿轮在转，灯也亮着，一切运转正常。\\n至于它到底在转嘛，谁都不知道。",
    "messageInitContent_5130": "伸手",
    "messageInitContent_7791": "1130。逃离这里的规则只有1个。",
    "resoundEventStoryDes_654": "不管你把不同形状的板块摆成什么样，这里都会给你一个大大的赞。\\n音效夸张，特效爆闪，情绪价值直接给满。\\n至于你到底摆了什么，不重要。\\n开心本身，就是一切。",
    "messageInitContent_5144": "出息了我的小叉",
    "messageInitContent_5143": "嗯？",
    "messageInitContent_5146": "锤下去才有晕",
    "messageInitContent_5145": "a出去才有输出",
    "messageInitContent_5148": "原生与漆黑组件，神唤和天马巨象",
    "messageInitContent_5147": "晕了",
    "messageInitContent_5149": "还有彼岸族",
    "messageInitContent_5140": "简单又不简单",
    "messageInitContent_5142": "一叉当关万兽莫开",
    "messageInitContent_5141": "一锤当关万夫莫开",
    "resoundEventStyleName_40": "欲望",
    "resoundEventStyleName_41": "概率",
    "resoundEventStyleName_42": "选择",
    "messageInitContent_5155": "建议出一只刀刀",
    "resoundEventStyleName_36": "暴怒",
    "messageInitContent_5154": "和狂潮形态贴贴",
    "resoundEventStyleName_37": "懒惰",
    "messageInitContent_5157": "想你了",
    "resoundEventStyleName_38": "贪婪",
    "messageInitContent_5156": "超凶",
    "resoundEventStyleName_39": "暴食",
    "messageInitContent_5159": "ψψψψψψψψψψψ",
    "resoundEventStyleName_32": "我是正版",
    "messageInitContent_5158": "怪越少怪越强",
    "resoundEventStyleName_33": "挑战第一",
    "resoundEventStyleName_34": "傲慢",
    "resoundEventStyleName_35": "妒忌",
    "messageInitContent_5151": "打架不好",
    "messageInitContent_5150": "有没有平手的",
    "messageInitContent_5153": "和漆黑组件贴贴",
    "messageInitContent_5152": "舞叉弄锤的",
    "resoundEventStyleName_50": "改造",
    "resoundEventStyleName_51": "重置",
    "resoundEventStyleName_52": "NTFusion",
    "resoundEventStyleName_53": "完结",
    "messageInitContent_5166": "玖狸影曜锤？",
    "resoundEventStyleName_47": "存在",
    "messageInitContent_5165": "行吧",
    "resoundEventStyleName_48": "龙涎香",
    "messageInitContent_5168": "再看看面板",
    "resoundEventStyleName_49": "时间有误",
    "messageInitContent_5167": "日常看看技能",
    "resoundEventStyleName_43": "好友",
    "messageInitContent_5169": "懂了",
    "resoundEventStyleName_44": "第365天登录",
    "resoundEventStyleName_45": "怀念",
    "resoundEventStyleName_46": "▇▇",
    "messageInitContent_5160": "ψψψψψψ",
    "messageInitContent_5162": "XXXXXXXXXXXXXXXXXXX",
    "messageInitContent_5161": "ψψψψψψψψψψψ",
    "messageInitContent_5164": "脑袋瓜嗡嗡作响",
    "messageInitContent_5163": "叉叉你好朋友勾勾呢",
    "resoundEventStyleName_61": "传送",
    "resoundEventStyleName_62": "玩物",
    "resoundEventStyleName_63": "F记录63",
    "resoundEventStyleName_64": "F记录64",
    "resoundEventStyleName_60": "勿语",
    "messageInitContent_5177": "吃吃饭",
    "resoundEventStyleName_58": "地裂",
    "messageInitContent_5176": "摸摸鱼",
    "resoundEventStyleName_59": "雷鸣",
    "messageInitContent_5179": "我是jojo哒",
    "messageInitContent_5178": "你也是Joker吗",
    "resoundEventStyleName_54": "塔普塔普",
    "resoundEventStyleName_55": "焚风",
    "resoundEventStyleName_56": "赤潮",
    "resoundEventStyleName_57": "星落",
    "messageInitContent_5171": "？？？",
    "messageInitContent_5170": "1Joker=11Joker+1Queen",
    "messageInitContent_5173": "康康技能",
    "messageInitContent_5172": "眼熟",
    "messageInitContent_5175": "康康你",
    "messageInitContent_5174": "康康面板",
    "messageInitContent_5188": "你好",
    "messageInitContent_5187": "白子怎么混进去了",
    "messageInitContent_5189": "晚安",
    "messageInitContent_5180": "我是dio哒",
    "messageInitContent_5182": "木大木大木大木大木大",
    "messageInitContent_5181": "欧拉欧拉欧拉欧拉",
    "messageInitContent_5184": "这多少是有点",
    "messageInitContent_5183": "巴啦啦啦啦啦啦啦啦",
    "messageInitContent_5186": "有神灵了",
    "messageInitContent_5185": "boomboomboomboomboom",
    "randomEventDialogueGroupConfig_10.300": "告别",
    "randomEventDialogueGroupConfig_10.301": "我就是……就是想夸你。",
    "randomEventDialogueGroupConfig_10.302": "反过来扬它的诚实直接",
    "randomEventDialogueGroupConfig_10.303": "确实我的这种迟疑，让你有了不好的想法，这都被你发现了，你实在是太细心了。我这就回去检讨，谢谢你。",
    "randomEventDialogueGroupConfig_10.304": "它说便躬身离开了。",
    "randomEventDialogueGroupConfig_10.305": "离开",
    "randomEventDialogueGroupConfig_10.306": "所以它们才说我不适合当商人，哎，拜拜。",
    "messageInitNick_599": "大帅比",
    "randomEventDialogueGroupConfig_10.307": "告别",
    "randomEventDialogueGroupConfig_10.308": "这么容易就满足啦哈哈哈哈哈哈拜拜——",
    "randomEventDialogueGroupConfig_10.309": "告别",
    "messageInitNick_591": "谜语人滚出",
    "messageInitNick_592": "你二你先说",
    "messageInitNick_593": "凉拌炒鸡蛋",
    "messageInitNick_594": "说好不动情",
    "messageInitNick_595": "正规账号",
    "messageInitNick_596": "安分守己的心",
    "messageInitNick_597": "立夏",
    "messageInitNick_598": "别妄想泡我",
    "messageInitNick_590": "伏地嘤",
    "messageInitContent_7701": "【无法加载内容】",
    "messageInitContent_7702": "4.同时带有。，的规则尽可能参考，的",
    "messageInitContent_7700": "1110。气奥的图阵是出口是入口",
    "messageInitContent_7705": "1111。今天是光棍节",
    "messageInitContent_7706": "1111。吃我无限泡影",
    "messageInitContent_7703": "0.在挑战前请保持冷静情绪波动会影响规则的解释",
    "messageInitContent_7704": "2。如果你挑战下一关了，那不要再挑战下一关",
    "messageInitContent_7709": "转反而染污因会则规分部.0",
    "messageInitContent_7707": "【内容已隐藏】",
    "messageInitContent_7708": "怕可不以可败失战挑。0",
    "messageInitContent_7712": "1112。龙皮匠必须先于豹皮匠进行投喂，不然你的形态可能会受到影响",
    "messageInitContent_7713": "【信息不完整为确保安全实施遮盖】",
    "messageInitContent_7710": "1112。豹皮匠需要用专用波板糖投喂",
    "messageInitContent_7711": "【信息被涂鸦】",
    "messageInitContent_7716": "1114。也不可说那两只究极是长得像",
    "messageInitContent_7717": "【内容已隐藏】",
    "messageInitContent_7714": "1114。绝对不可以在锤子面前提起锤爹",
    "messageInitContent_7715": "2。如果你挑战下一关了，那不要再挑战下一关",
    "messageInitContent_7718": "1115。切勿使用相同品质的怪兽进行挑战",
    "messageInitContent_7719": "1115。切勿使用不同品质的怪兽进行挑战",
    "messageInitContent_7720": "【信息被涂鸦】",
    "messageInitContent_7723": "1116。第一时间找到管理员",
    "messageInitContent_7724": "3.带有，的规则是假的要注意甄别",
    "messageInitContent_7721": "觉睡入睡下按请。1",
    "messageInitContent_7722": "【##############】",
    "messageInitContent_11805": "居然还有",
    "messageInitContent_7727": "2.带有。的规则是假的要注意甄别",
    "messageInitContent_7728": "1118。不要使用御空挑战这关",
    "messageInitContent_7725": "1116。如果没有找到管理员请保持安静不要惊动这里的那个东西",
    "messageInitContent_7726": "1116。然后静静地离开",
    "messageInitContent_7729": "1118。切勿爬入比蒙巨炮的管口",
    "messageInitContent_7730": "1118。如果已经爬入了，请不要回头",
    "messageInitContent_7731": "【信息不完整为确保安全实施遮盖】",
    "messageInitContent_7734": "1119。如果喵响没有说话，那么你也不要说话",
    "messageInitNick_5099": "大大滴好",
    "messageInitContent_7735": "1119。如果喵响开始唱歌那么请不要挑战",
    "messageInitContent_7732": "2。如果你挑战下一关了，那不要再挑战下一关",
    "messageInitContent_7733": "1.没有任何一条规则会告诉你全部的真相",
    "messageInitNick_5090": "香菜真好吃",
    "messageInitContent_7738": "2.带有。的规则是假的要注意甄别",
    "messageInitNick_5095": "砂糖有点皮",
    "messageInitContent_7739": "1120。切勿轻易碰触溯仪的手",
    "messageInitNick_5096": "花姑娘",
    "messageInitContent_7736": "1119。影曜会告诉你为什么",
    "messageInitNick_5097": "田园靓汤王",
    "messageInitContent_7737": "【数据已丢失】",
    "messageInitNick_5098": "灵儿",
    "messageInitNick_5091": "林中鸟",
    "messageInitNick_5092": "拥抱暖手宝",
    "messageInitNick_5093": "踏遍人间景色",
    "messageInitNick_5094": "单枪浪情场",
    "messageInitContent_7741": "【信息被涂鸦】",
    "messageInitContent_7742": "1120。切勿试图通过这种方式回档，你无法承受后果",
    "messageInitContent_7740": "1120。不同的手指将会通往不同的时间线",
    "messageInitContent_7745": "1121。躲开那些心心",
    "messageInitNick_5088": "灵魂的过客",
    "resoundEventStoryDes_608": "【编号】00009\\n【代号】燃脂之火\\n【适用刻度】低\\n【保育】不让任何有减脂需求的生物体接近。\\n【所在区域】深幽水月\\n【描述】来源于霸者的幻想，是一种能凭空燃烧的火焰，无需任何气体，可燃物或热量就可以燃烧的火焰，能燃烧怪兽体内的脂肪。",
    "messageInitContent_7746": "【无法加载内容】",
    "messageInitNick_5089": "脸有点肿",
    "resoundEventStoryDes_609": "【编号】00000\\n【代号】█世之瞳\\n【适用刻度】█\\n【保育】【████████████████████████████】\\n【所在区域】深幽水月\\n【描述】███████规则█败███████████████████████████████████████████弃██世██████应对█████毁██",
    "messageInitContent_7743": "1121。躲开那些心心",
    "resoundEventStoryDes_606": "【编号】00007\\n【代号】水之月\\n【适用刻度】低\\n【保育】适度遮挡并注意月相变化带来的灾害。\\n【所在区域】深幽水月\\n【描述】来源不明的虚体，永存于水底的东西，会像是月亮一样有阴晴圆缺，会影响周围生物体的情绪。",
    "messageInitContent_7744": "【信息读取失败】",
    "resoundEventStoryDes_607": "【编号】00008\\n【代号】呐喊幽灵\\n【适用刻度】低\\n【保育】常规措施。\\n【所在区域】深幽水月\\n【描述】属于集合类无意识幻想，来源于一些对世界感到疲惫的生物体，想通过咆哮和呐喊将一切发泄出去。",
    "messageInitContent_11802": "有点暧昧了",
    "resoundEventStoryDes_604": "【编号】000000\\n【代号】瞳\\n【适用刻度】█n【保育】██████\\n【所在区域】████\\n【描述】█████████████████████████████████████████████████████████████████████",
    "messageInitContent_11801": "超进化天际线",
    "resoundEventStoryDes_605": "【编号】00006\\n【代号】欧气之触\\n【适用刻度】低\\n【保育】无需特殊处理。\\n【所在区域】缠绵幻梦\\n【描述】源于异界的幻想，最初是的寄生体，能依附在生物体身上为宿主吸收欧气，后因未知原因每次依附都会失败。",
    "messageInitContent_11804": "天天早睡",
    "resoundEventStoryDes_602": "【编号】00004\\n【代号】勤洗澡的牙\\n【适用刻度】低\\n【保育】用隔离区隔离。\\n【所在区域】虚无螺旋\\n【描述】该虚体来源自于凶噬魔的幻想，它自己的牙是成熟的牙，能学会自己洗自己，这样口气就可以一直保持清新了。于是这些牙就这样一直在海里泡着了，因此附近的海域受到一定程度的污染。",
    "messageInitContent_11803": "该不会是……",
    "resoundEventStoryDes_603": "【编号】00005\\n【代号】代行触手\\n【适用刻度】低\\n【保育】需要用地壳固定其行走及游走，以免造成破坏。\\n【所在区域】触涌镜花\\n【描述】该虚体来源于蜃兽的幻想，她希望镜中除了能伸出脚还能伸出触手，这样她的移动就可以更为灵活。",
    "resoundEventStoryDes_600": "【编号】00002\\n【代号】吃不完的大孢子\\n【适用刻度】低\\n【保育】定期切除增生部位。\\n【所在区域】沉浮泡影\\n【描述】这个虚体来源于某个叉叉部落的集体幻想。是一个会每日长大一点点的孢子，已放置于一个固定大小的坑洞，可以更直观地控制其大小。其口感与进化孢子接近，但更为多汁，成分与进化孢子一致，口头禅是快来进化。",
    "resoundEventStoryDes_601": "【编号】00003\\n【代号】人家大炮的朋友\\n【适用刻度】低\\n【保育】定期清扫通道中的朋友金币以免通道被堵塞。\\n【所在区域】缠绵幻梦\\n【描述】这个虚体来源于某只人间大炮想象中的朋友，嘴里还能吐出金币，会经常搭话遇见的生物体，询问对方是否有意成为它的朋友，并表示愿意给对方朋友金币。若回答不愿意的话，会被变成朋友金币。",
    "messageInitContent_11800": "只是一条无害的评论",
    "randomEventDialogueGroupConfig_10.321": "喂别跑啊，我们才不是什么可疑的组织。",
    "randomEventDialogueGroupConfig_10.322": "赶紧跑远点",
    "randomEventDialogueGroupConfig_10.323": "那就说声谢谢你吧。",
    "randomEventDialogueGroupConfig_10.324": "告诉它别客气",
    "randomEventDialogueGroupConfig_10.325": "你真有礼貌，再见。",
    "randomEventDialogueGroupConfig_10.326": "离开",
    "randomEventDialogueGroupConfig_10.327": "它无奈的又叫了你几次，便放弃了。",
    "randomEventDialogueGroupConfig_10.328": "离开",
    "messageInitContent_7749": "0.在挑战前请保持冷静情绪波动会影响规则的解释",
    "messageInitNick_5084": "电子鱼露",
    "messageInitNick_5085": "会变得幸运",
    "messageInitContent_7747": "转反而染污因会则规分部.0",
    "messageInitNick_5086": "永远快乐",
    "messageInitContent_7748": "1122。只能使用专门的饲料喂给大嘴鱼王。",
    "messageInitNick_5087": "想吃臭豆腐",
    "messageInitNick_5080": "佛系小可爱",
    "messageInitNick_5081": "辣条",
    "messageInitNick_5082": "卸载记忆",
    "messageInitNick_5083": "昨日不复来",
    "messageInitContent_7752": "【信息不完整为确保安全实施遮盖】",
    "messageInitContent_7753": "王不受规则影响.0",
    "messageInitContent_7750": "0.别忘了爱自己",
    "messageInitContent_7751": "1122。正确温度是12摄氏度",
    "messageInitContent_7756": "探索者不受规则影响.0",
    "messageInitNick_5077": "抠脚小仙女",
    "resoundEventStoryDes_619": "区域名称：归灵秘境\\n区域概况：植被茂盛、水源充沛，拥有不少藤林与沼泽。\\n信仰：信奉万物有灵，认为山川、草木、风雨皆有灵，需以对话、安抚、感谢换取庇护。\\n社会核心：没有具体的核心。\\n传送门数：2\\n对传送门的态度：以“望涡者”的观测和监视为主，未曾深入。\\n现状：与冰河空渊的斥候有过初步接触，尚未意识到危机。\\n刻录者：Δ-A.00-LZ\\n▌其余内容不可读",
    "messageInitContent_7757": "三个小关是分别对应某个数字的吗.0",
    "messageInitNick_5078": "国王的新衣",
    "messageInitContent_7754": "那么这些是什么.0",
    "messageInitNick_5079": "摸鱼小能手",
    "resoundEventStoryDes_617": "区域：灰烬遗迹\\n区域概况：这片区域曾遭火山肆虐，遍地焦土，部分区域仍有涌动的岩浆。\\n信仰：世代信奉火神，相信灾难与恩赐皆源于祂。火山被视为火神的愤怒，是区域的主宰。\\n社会核心：极端神权，长老拥有至高的权力，通过极端排外与封闭，以维护信仰与统治。\\n传送门数：3\\n对传送门的态度：视其为毁灭涡轮，一方面派出破轮斗士破坏传送门。另一方面派出封门守卫对从传送门出现的怪兽处以极刑。\\n现状：与冰河空渊、无佑离岛爆发冲突，内部也有不稳定势力。\\n刻录者：Δ-A.00-LZ\\n▌其余内容不可读",
    "messageInitContent_7755": "灾不受规则影响.0",
    "resoundEventStoryDes_618": "区域名称：秘仪圣域\\n区域概况：遍布变异植物与菌类的潮湿区域，瘴气能致幻。需要熟记先祖之引能在其中安全行走。\\n信仰：信仰先祖之魂，认为生存全凭祖灵梦中指引。只有梦智者可从梦中接收启示，成员则通过燃香共梦感受先祖之力。不同的先祖拥有各自不同的秘仪。\\n社会核心：由梦智者管辖，透过梦境传达先祖之意引领部族。\\n传送门数：2\\n对传送门的态度：视其为不可侵犯的“先祖之眼”，于其前祭拜，但不会进入或接触。\\n现状：梦智者在梦中看见异象，误将从传送门出现的怪兽错认为“先祖的使者”。\\n刻录者：Δ-A.00-LZ\\n▌其余内容不可读",
    "resoundEventStoryDes_615": "高明的猎手懂得等待，它们知道如何让猎物自己送上门~",
    "resoundEventStoryDes_616": "高明的猎手懂得等待，它们知道如何等其他猎手打到差不多再出手收割猎物。",
    "resoundEventStoryDes_613": "火神在上。（注：灰烬遗迹信奉的火神不是那只叫火神的怪兽。）\\n不少怪兽质疑为什么王·狈·爷可以成为高贵的灰烬审判。要知道成为灰烬审判需要通过试炼。\\n要知道，成为审判者得吞入火神之种，接受灼烧洗礼。对于啥都能吃的王·狈·爷来说就是个小前菜。\\n至于其他怪兽为什么也能试炼？只能说别低估权利的美味，即便代价是失去喉舌！",
    "resoundEventStoryDes_614": "多吃！\\n能吃就吃！\\n不吃就没得吃！\\n给我使劲吃！\\n——霸者太奶训",
    "resoundEventStoryDes_611": "万物皆有灵，没错~但灵也有高低之分。\\n我知道那些宣扬灵灵皆圣的萨满一定会反驳我，但它们反驳不了事实。\\n蕉灵就是天下第一灵！\\n蕉灵是真实存在的！看到我手上的叉叉头骨了吗？\\n那是给那只踩了香蕉皮，不敬蕉灵的怪兽的惩罚。\\n——选自笨拿拿香蕉神教传教发言",
    "resoundEventStoryDes_612": "如果上天给炼狱魔眼两个选择，一是立刻得到游戏盒玩7个日月，二是忍耐300多个日月后获得游戏盒。\\n始原之眼肯定毫不犹豫选前者！能吃就吃，能玩就玩。\\n单从结果来看，其他区域的魔眼并没有比始原之眼进化多少~",
    "randomEventDialogueGroupConfig_10.320": "离开",
    "resoundEventStoryDes_610": "你相信万物有灵吗？你相信——爱有灵吗？\\n你或许会质疑爱不是个东西，理应没有灵。\\n但对于罗密欧和朱丽叶而言，爱同时是物质和精神的。\\n就像罗密欧送给朱丽叶的钻石、金币或者KiraKira，全都是爱之灵，它们和它们的造物也都是~",
    "activityBuffDescription_18": "远程怪兽射程提升{p1}%",
    "randomEventDialogueGroupConfig_10.310": "下次还想被夸记得找我哦哈哈。",
    "randomEventDialogueGroupConfig_52.9": "-",
    "activityBuffDescription_19": "怪兽增益效果持续时间提升{p1}%",
    "randomEventDialogueGroupConfig_10.311": "告别",
    "randomEventDialogueGroupConfig_52.8": "-",
    "randomEventDialogueGroupConfig_10.312": "夸得很好，怎就不能再说了呢，你这是什么顶级矛盾文学呀。",
    "randomEventDialogueGroupConfig_10.313": "不理它离开",
    "activityBuffDescription_14": "霸气+{p1}%",
    "randomEventDialogueGroupConfig_10.314": "喂，别走得那么抽象呀。",
    "randomEventDialogueGroupConfig_52.5": "-",
    "activityBuffDescription_15": "怪兽能量回复效果+{p1}%",
    "randomEventDialogueGroupConfig_10.315": "继续离开",
    "randomEventDialogueGroupConfig_52.4": "-",
    "activityBuffDescription_16": "怪兽技能等级+{p1}",
    "randomEventDialogueGroupConfig_10.316": "好吧。",
    "randomEventDialogueGroupConfig_52.7": "-",
    "activityBuffDescription_17": "神灵能量回复速度提升{p1}%",
    "randomEventDialogueGroupConfig_10.317": "它有点丧气地走了。",
    "randomEventDialogueGroupConfig_52.6": "-",
    "activityBuffDescription_10": "怪兽负面效果持续时间降低{p1}%",
    "messageInitNick_5073": "憨憨的小鸟",
    "randomEventDialogueGroupConfig_10.318": "离开",
    "activityBuffDescription_11": "攻击力+{p1}%",
    "messageInitNick_5074": "巨星",
    "randomEventDialogueGroupConfig_10.319": "谢谢你，我会继续回去好好练的！",
    "activityBuffDescription_12": "受到伤害-{p1}%",
    "messageInitContent_7758": "有些怪兽不用打也是悬空的.0",
    "messageInitNick_5075": "复婚吧少年",
    "activityBuffDescription_13": "移动速度+{p1}%",
    "messageInitContent_7759": "1124。一般探索者是看不见玖狸的酒馆的，除非【】",
    "messageInitNick_5076": "趁爱不深",
    "messageInitNick_5070": "柿子龙",
    "messageInitNick_5071": "呆小熊",
    "messageInitNick_5072": "不一样的霸气",
    "messageInitContent_5100": "嘿嘿嘿",
    "messageInitContent_7763": "【你饿了】",
    "messageInitContent_7764": "1125。不能用龙族进行挑战",
    "messageInitContent_5102": "是时候升级一下装备了",
    "messageInitContent_7761": "1.带有.的规则一般是正确的，可以相信",
    "messageInitContent_5101": "带着昨天的胜利迎来新一天的胜利",
    "messageInitContent_7762": "2。如果你挑战下一关了，那不要再挑战下一关",
    "messageInitContent_5104": "我喜欢美杜莎莎",
    "messageInitContent_7767": "1125。但龙族的双种族怪兽是可以的",
    "messageInitNick_5066": "一起开拓",
    "messageInitContent_5103": "给大伙增加点难度",
    "messageInitContent_7768": "1125。切勿击杀第五只怪兽",
    "messageInitNick_5067": "电梯人",
    "messageInitContent_5106": "我喜欢污妖王",
    "messageInitContent_7765": "的确正是对绝0则规。1",
    "messageInitNick_5068": "迷路的细胞核",
    "resoundEventStoryDes_628": "水灵不息，水灵永存。\\n感谢你赐我们生存之力，让灵魂清明！\\n我们献上汗，献上泪。我们聆听你的教诲。\\n愿水灵垂听，保我族不溺不枯。",
    "messageInitContent_5105": "我也",
    "messageInitContent_7766": "【内容已隐藏】",
    "messageInitNick_5069": "渣男收割机",
    "resoundEventStoryDes_629": "大地在下，沉稳不动。\\n你肩负山川河流，你背负骨肉血脉。\\n我们从你而生，最后归你而去。\\n原您永远沉默，无需怒吼。\\n感恩，我们跪拜于你的胸脯之上。",
    "randomEventDialogueGroupConfig_52.1": "你来到了西北集市，无意中看见了一张超级显眼的悬赏令。有家孢子店招募镖师护院一天。",
    "resoundEventStoryDes_626": "这是一口独特的池子，梦智者会将从部族怪兽收集而来的果子与孢子投入池中，作为献给先祖的供品。据说，从先祖之口中缓缓溢出的液体可以治愈百病。\\n若无法痊愈，便是先祖喊它回彼岸，陪它老怪家去了。",
    "resoundEventStoryDes_627": "骨灵在地，沉眠不朽。\\n你撑起我们的身体，刻下我们的一切。\\n你听见万灵，你铭刻名字，你懂得裂纹与荣耀。\\n我们敲击你，呼唤你，愿骨灵护佑……",
    "randomEventDialogueGroupConfig_52.3": "先了解清楚任务再出发",
    "resoundEventStoryDes_624": "灰烬遗迹的怪兽进行灰烬审判的区域。虽然表面上看不出来，该图腾拥有极高的温度，而上面则沾满了怪兽追求权力的痕迹……无数烧焦的怪兽唇舌……",
    "randomEventDialogueGroupConfig_52.2": "立刻整备前往",
    "resoundEventStoryDes_625": "传闻中，先祖之面是梦智者雕的。上头满是它们对先祖的敬意，它们对先祖容貌的贫乏想象，还有它们多年燃香熏出的独特色泽。",
    "resoundEventStoryDes_622": "区域名称：无佑离岛\\n区域概况：曾是冰河空渊的一部分，被击坠后成为现在的海岛。\\n信仰：认为旧的狩猎之神已死，转信仰新的狩猎之神。\\n社会核心：狩猎实力最强者，猎神的战团。\\n传送门数：3\\n对传送门的态度：视为新猎场入口，认为传送门是新狩猎之神给的新考验。\\n现状：猎团与战部纷纷踏入其他区域进行狩猎，已毁灭始原荒地，正逼近归灵秘境。与冰河空渊的势力亦有冲突。\\n刻录者：Δ-A.00-LZ\\n▌其余内容不可读",
    "messageInitContent_7760": "3.带有，的规则是假的要注意甄别",
    "resoundEventStoryDes_623": "那尊图腾像在炙热岩浆中沉浮多年，至今仍保持最初的模样。\\n每日清晨，灰烬遗迹的长老都会组织族群前往祭拜。\\n最后一个抵达的怪兽，会被长老亲切地送上祭坛。\\n也正因如此，灰烬遗迹的怪兽个个都精于兽际交往，毕竟谁都不想从“走最后”变成“烤最熟”。",
    "resoundEventStoryDes_620": "区域名称：始原荒地\\n区域概况：气候温和，资源丰富，怪兽自然生息。\\n信仰：太古图腾。\\n社会核心：由生母维持松散部族秩序。\\n传送门数：2\\n对传送门的态度：漠不关心。\\n当前状态：遭冰河空渊和无佑离岛的袭击后几乎全族覆灭，大部分怪兽在临死前仍未意识到发生了什么。\\n刻录者：Δ-A.00-LZ\\n▌其余内容不可读",
    "resoundEventStoryDes_621": "区域名称：冰河空渊\\n区域概况：除了平原地区大部分区域极度寒冷，资源相对匮乏。\\n信仰：狩猎之神，认为天地间一切皆为猎物，唯有狩猎才能获得认可与庇佑。\\n社会核心：狩猎实力最强者，猎神的战团。\\n传送门数：2\\n对传送门的态度：视为新猎场入口，认为传送门是狩猎之神给的新考验。\\n现状：猎团与战部纷纷进入其他区域进行狩猎，已毁灭始原荒地，正逼近归灵秘境。与无佑离岛的势力亦有冲突。\\n刻录者：Δ-A.00-LZ\\n▌其余内容不可读",
    "messageInitNick_519": "本人特价",
    "messageInitNick_5062": "万能背锅虾",
    "messageInitNick_511": "大冰块",
    "messageInitNick_5063": "吸尘器的碎片",
    "messageInitNick_512": "放下那只吃货",
    "messageInitNick_5064": "寄没地址的信",
    "messageInitNick_513": "专业团队",
    "messageInitNick_5065": "强力去污粉",
    "messageInitNick_514": "北城九命猫",
    "messageInitNick_515": "地狱使者",
    "messageInitNick_516": "弦已断曲终散",
    "98_-240010": "消耗的起源盘品质需要一致",
    "messageInitNick_5060": "新式泡面",
    "messageInitNick_517": "光怪陆离的梦",
    "activityBuffDescription_20": "怪兽负面效果持续时间降低{p1}%",
    "messageInitNick_5061": "环保砧板",
    "messageInitNick_518": "蹲街式寂寞",
    "messageInitNick_5059": "拖地这件事",
    "messageInitNick_5055": "只想让你懂",
    "messageInitNick_5056": "小做作",
    "messageInitNick_5057": "半公开的秘密",
    "messageInitNick_5058": "星空如梦",
    "messageInitNick_510": "独孤求偶",
    "messageInitNick_5051": "拉肠哇哦",
    "messageInitNick_522": "夜雨声烦",
    "messageInitNick_5052": "免费上车",
    "messageInitNick_523": "暴富少女",
    "messageInitNick_5053": "蓝胖纸",
    "messageInitNick_524": "歇斯底里头",
    "messageInitNick_5054": "最强化妆品",
    "messageInitNick_525": "三行情书",
    "messageInitNick_526": "猫猫观察员",
    "messageInitNick_527": "氵孚夸",
    "messageInitNick_528": "何必说谎",
    "messageInitNick_5050": "赛博大悲咒",
    "messageInitNick_529": "风一样的少女",
    "98_-240001": "找不到该起源盘",
    "messageInitNick_5048": "梨消灭者",
    "98_-240002": "起源盘未重置",
    "messageInitNick_5049": "二手货",
    "98_-240003": "起源盘分解失败",
    "98_-240004": "起源盘被锁定",
    "98_-240005": "起源盘已镶嵌",
    "messageInitNick_5044": "掐住一只呆橘",
    "98_-240006": "起源盘未镶嵌",
    "messageInitNick_5045": "强壮走音神",
    "98_-240007": "当前剩余超过{1}天，无法继续超频",
    "messageInitNick_5046": "生菜之心",
    "messageInitNick_520": "乖宝",
    "98_-240008": "起源盘负重不足",
    "messageInitNick_5047": "纸片女友",
    "messageInitNick_521": "笑得很大声",
    "98_-240009": "分解的起源盘里包含已镶嵌的",
    "messageInitNick_5040": "我和他不熟",
    "messageInitNick_533": "美得不太显眼",
    "messageInitNick_5041": "我推的梳子",
    "messageInitNick_534": "鸡毛飞上天",
    "messageInitNick_5042": "跟随者",
    "messageInitNick_535": "快乐来敲门",
    "messageInitNick_5043": "辣椒兽",
    "messageInitNick_536": "黑暗领主",
    "messageInitNick_537": "二手货",
    "messageInitNick_538": "无聊我要看",
    "messageInitNick_539": "纯粗粮小姐",
    "messageInitNick_5037": "老派腊肠狗",
    "messageInitNick_5038": "大葱真好吃",
    "messageInitNick_7699": "抬杠小能手",
    "messageInitNick_5039": "看看你",
    "messageInitNick_5033": "离别的倒计时",
    "messageInitNick_7696": "捕鱼达人",
    "messageInitNick_5034": "爱上犀利哥",
    "messageInitNick_530": "辣条侠",
    "messageInitNick_7695": "无权限",
    "messageInitNick_5035": "铁根蓝莓",
    "messageInitNick_531": "复刻大夫",
    "messageInitNick_7698": "天台封了",
    "messageInitNick_5036": "不想买菜",
    "messageInitNick_532": "跑调之神",
    "messageInitNick_7697": "超级蛋挞",
    "messageInitNick_544": "暴富王",
    "messageInitNick_7692": "对线爱好者",
    "messageInitNick_5030": "大葱先锋",
    "messageInitNick_545": "超鬼特工",
    "messageInitNick_7691": "胡萝卜撞地球",
    "messageInitNick_5031": "低头思考明天",
    "messageInitNick_546": "咽不下的泪",
    "messageInitNick_7694": "按时摸鱼",
    "messageInitNick_5032": "断水流大师姐",
    "messageInitNick_547": "大叔不要跑",
    "messageInitNick_7693": "垃圾袋先锋",
    "messageInitNick_548": "宅宅一堂",
    "messageInitNick_549": "行盖五过",
    "messageInitNick_7690": "和孤独和好",
    "messageInitNick_5026": "猫猫观察员",
    "messageInitNick_7689": "卖萌嘟嘟嘴",
    "messageInitNick_5027": "长腿蜀黍",
    "messageInitNick_7688": "蹲街数寂寞",
    "messageInitNick_5028": "大脑在颤抖",
    "messageInitNick_5029": "豆角魔法",
    "messageInitNick_5022": "摸鱼爱好者",
    "messageInitNick_540": "夏威夷学的",
    "messageInitNick_7685": "按时进化",
    "messageInitNick_5023": "烧麦哇哦",
    "messageInitNick_541": "吃瓜带头人",
    "messageInitNick_7684": "独守一座空城",
    "messageInitNick_5024": "梵谷的左耳",
    "messageInitNick_542": "醋王学妹",
    "messageInitNick_7687": "按时备份",
    "messageInitNick_5025": "香蕉是法师",
    "messageInitNick_543": "老子叫甜甜",
    "messageInitNick_7686": "霸主魅影",
    "messageInitNick_555": "风吹落了记忆",
    "messageInitNick_7681": "最爱人参果",
    "messageInitNick_556": "为环保出分力",
    "messageInitNick_7680": "认证对线专家",
    "messageInitNick_5020": "白色的鸦",
    "messageInitNick_557": "会写信的猫",
    "messageInitNick_7683": "熬夜带头人",
    "messageInitNick_5021": "划水小天才",
    "messageInitNick_558": "白衬衫帆布鞋",
    "messageInitNick_7682": "春风正得意",
    "messageInitNick_559": "我是卧底",
    "messageInitNick_5015": "老谈酸菜",
    "messageInitNick_7678": "快餐大师",
    "messageInitNick_5016": "孤傲像匹狼",
    "messageInitNick_7677": "蛋挞怪兽",
    "messageInitNick_5017": "拉面猎手",
    "messageInitNick_5018": "柠檬真好吃",
    "messageInitNick_550": "霸娘",
    "messageInitNick_7679": "不再重提",
    "messageInitNick_5011": "多变花楸",
    "messageInitNick_551": "迷途的电子羊",
    "messageInitNick_7674": "初夏的阳光",
    "messageInitNick_5012": "可乐鸡翅",
    "messageInitNick_552": "安睡熊",
    "messageInitNick_7673": "沉浸式艺术",
    "messageInitNick_5013": "海边的沙声",
    "messageInitNick_553": "奋斗吧",
    "messageInitNick_7676": "等我变身好吗",
    "messageInitNick_5014": "古城新梦",
    "messageInitNick_554": "搬砖鉴定家",
    "messageInitNick_7675": "传说中的香蕉",
    "messageInitNick_5019": "倒霉的竹笋",
    "messageInitNick_566": "安魂",
    "messageInitNick_7670": "爵士少年",
    "messageInitNick_567": "独恋花尽散",
    "messageInitNick_568": "持刀斩情丝",
    "messageInitNick_7672": "苹果去哪了",
    "messageInitNick_5010": "巴士判官",
    "messageInitNick_569": "未来的大神们",
    "messageInitNick_7671": "上门做饭",
    "messageInitNick_5004": "家有冰雪龙",
    "messageInitNick_7667": "无公害萝卜",
    "messageInitNick_5005": "随它吧",
    "messageInitNick_7666": "饭堂大叔",
    "messageInitNick_5006": "跟风少年",
    "messageInitNick_560": "小黑是只猫",
    "messageInitNick_7669": "给皮皮虾上菜",
    "messageInitNick_5007": "超级熬夜神",
    "messageInitNick_561": "高端大器",
    "messageInitNick_7668": "我太菜了",
    "messageInitNick_5000": "瞎说大实话",
    "messageInitNick_562": "生命在于折腾",
    "messageInitNick_7663": "厨师过家家",
    "messageInitNick_5001": "麻烦解决大师",
    "messageInitNick_563": "拨云见",
    "messageInitNick_7662": "黑心的白天鹅",
    "messageInitNick_5002": "抽卡主播",
    "messageInitNick_564": "仙城月兔",
    "messageInitNick_7665": "蝶骨",
    "messageInitNick_5003": "又停电啦",
    "messageInitNick_565": "披着虎皮的猫",
    "messageInitNick_7664": "矮人科技",
    "messageInitNick_5008": "重新定义熬夜",
    "messageInitNick_5009": "时间逆行者",
    "messageInitNick_577": "请放下鼠标",
    "messageInitNick_578": "差点变帅",
    "messageInitNick_579": "抠脚女神",
    "messageInitNick_7661": "我可是打手",
    "messageInitNick_7660": "叉烧射手",
    "messageInitNick_7656": "尖叫姜",
    "messageInitNick_570": "霸气女孩",
    "messageInitNick_7655": "最爱椰子",
    "messageInitNick_571": "大猪蹄子",
    "messageInitNick_7658": "天堂水杯",
    "messageInitNick_572": "傲拳狂连",
    "messageInitNick_7657": "不喜勿撩",
    "messageInitNick_573": "别捏我肥脸",
    "messageInitNick_7652": "酣睡美人",
    "messageInitNick_574": "岁月是把猪刀",
    "messageInitNick_7651": "半妖妖妖",
    "messageInitNick_575": "海以南不再蓝",
    "messageInitNick_7654": "肌肉小猛男",
    "messageInitNick_576": "小火车污污污",
    "messageInitNick_7653": "就爱吃醋",
    "messageInitNick_7659": "一点点霸道",
    "messageInitNick_588": "揉你脸蛋",
    "messageInitNick_589": "刀剑美人",
    "messageInitNick_7650": "背景有点假",
    "messageInitNick_580": "冰淇淋小姐",
    "messageInitNick_7645": "雀斑少女",
    "messageInitNick_581": "啾一口草莓",
    "messageInitNick_7644": "凌晨的末班车",
    "messageInitNick_582": "超级平底锅",
    "messageInitNick_7647": "油缸呢",
    "messageInitNick_583": "随缘抽卡",
    "messageInitNick_7646": "满身是戏",
    "messageInitContent_7800": "1132。绯手中的东西喝不得",
    "messageInitNick_584": "挥剑断魂",
    "messageInitNick_7641": "打脸鉴定家",
    "messageInitContent_7801": "1,带关卡数字的是关卡独特规则",
    "messageInitNick_585": "燃尽流年",
    "messageInitNick_7640": "忧郁的暗夜",
    "messageInitNick_586": "剑断青丝",
    "messageInitNick_7643": "咳嗽补刀法",
    "messageInitNick_587": "喘气的夜明猪",
    "messageInitNick_7642": "跟风小天才",
    "messageInitNick_7649": "摆满了杯具啊",
    "messageInitNick_7648": "天下无双魂",
    "monsterName_112": "荆霵",
    "monsterName_113": "星烁",
    "monsterName_114": "赤炼零式",
    "monsterName_115": "神唤",
    "monsterName_116": "空蝉",
    "monsterName_117": "光囚",
    "monsterName_118": "蜃兽",
    "monsterName_119": "喵响",
    "monsterName_110": "重装",
    "monsterName_111": "影曜",
    "messageInitContent_5199": "easy啦",
    "messageInitNick_7634": "菠动你心",
    "messageInitContent_5198": "Joker不怕白虎，",
    "messageInitNick_7633": "亮得过阳光",
    "messageInitNick_7636": "纯情橡皮糖",
    "messageInitNick_7635": "摸鱼侠",
    "messageInitNick_7630": "沉浸式切菜",
    "messageInitNick_7632": "无公害黄瓜",
    "messageInitNick_7631": "我推的杯子",
    "messageInitContent_5191": "心态很好",
    "monsterName_109": "梵",
    "messageInitContent_5190": "吃不消吃不消",
    "messageInitContent_5193": "直觉告诉我是选人少那边",
    "messageInitContent_5192": "大脑运作中",
    "messageInitContent_5195": "你们直觉准不准的啊",
    "messageInitNick_7638": "洗衣液破坏者",
    "messageInitContent_5194": "直接告诉我是选怪少的那边",
    "messageInitNick_7637": "冰箱少男",
    "messageInitContent_5197": "我想通了",
    "messageInitContent_5196": "经过我精密的计算，等会吃饺子",
    "messageInitNick_7639": "打脸小天才",
    "monsterName_123": "漆黑组件",
    "monsterName_124": "荧灵",
    "monsterName_125": "幽狱沸体",
    "monsterName_126": "妄焱",
    "monsterName_127": "绯焉",
    "monsterName_128": "海漩",
    "monsterName_129": "崩律",
    "monsterName_120": "创晓",
    "monsterName_121": "刀马",
    "monsterName_122": "腾龙",
    "messageInitNick_7623": "撞到你怀里",
    "messageInitNick_7622": "小祖宗",
    "messageInitNick_7625": "你是懂我的",
    "messageInitNick_7624": "怎么停水了",
    "messageInitNick_7621": "不聊天打游戏",
    "messageInitNick_7620": "如果瓜子会笑",
    "messageInitNick_7627": "流浪猫",
    "messageInitNick_7626": "拳师的荣耀",
    "messageInitNick_7629": "不是怪兽是神",
    "messageInitNick_7628": "冬日傲娇的菊",
    "resoundEventStyleName_20": "流放之地",
    "messageInitNick_7612": "苹果射手",
    "resoundEventStyleName_14": "亮标",
    "messageInitNick_7611": "单车少年",
    "resoundEventStyleName_15": "完胜",
    "messageInitNick_7614": "智能食盐",
    "resoundEventStyleName_16": "熵鬼",
    "messageInitNick_7613": "咕咕爱好者",
    "resoundEventStyleName_17": "干杯",
    "resoundEventStyleName_10": "沙粒",
    "resoundEventStyleName_11": "24/7",
    "messageInitNick_7610": "纯情棒棒糖",
    "resoundEventStyleName_12": "观看",
    "resoundEventStyleName_13": "外语",
    "messageInitNick_7619": "作业做完了吗",
    "messageInitNick_7616": "尬聊小天才",
    "resoundEventStyleName_18": "败",
    "messageInitNick_7615": "一步一歪",
    "resoundEventStyleName_19": "野怪放生",
    "messageInitNick_7618": "绿色发电",
    "messageInitNick_7617": "沉浸式洗猫",
    "monsterName_101": "幻",
    "monsterName_102": "Joker",
    "monsterName_103": "魅妆",
    "monsterName_104": "∞",
    "monsterName_105": "天枢震",
    "monsterName_106": "螺旋巽",
    "monsterName_107": "气奥",
    "monsterName_108": "溯仪",
    "resoundEventStyleName_30": "稳定",
    "resoundEventStyleName_31": "凿星前夜",
    "monsterName_100": "冰霓",
    "messageInitNick_7601": "哇哦这样啊",
    "resoundEventStyleName_25": "熔炼饲星",
    "messageInitNick_7600": "道理我都不懂",
    "resoundEventStyleName_26": "胜利",
    "messageInitNick_7603": "谁把琴弦拨断",
    "resoundEventStyleName_27": "发呆",
    "messageInitNick_7602": "凉粉诗人",
    "resoundEventStyleName_28": "破解",
    "resoundEventStyleName_21": "日行八万里",
    "resoundEventStyleName_22": "另一个",
    "resoundEventStyleName_23": "抽屉",
    "resoundEventStyleName_24": "你的评点",
    "messageInitNick_7609": "我出双倍",
    "messageInitNick_7608": "熬夜先驱",
    "messageInitNick_7605": "番茄兽",
    "resoundEventStyleName_29": "鸡汤",
    "messageInitNick_7604": "冷眼看浮华",
    "messageInitNick_7607": "对方正在输入",
    "messageInitNick_7606": "沉迷吃饭",
    "darkForestAbilityConfigDescription_13": "怪兽受到伤害降低{?}%",
    "darkForestAbilityConfigDescription_14": "怪兽的伤害提升{?}%",
    "darkForestAbilityConfigDescription_11": "怪兽霸气提升{?}%",
    "darkForestAbilityConfigDescription_12": "怪兽被击退时忽视敌方霸气{?}%(含直接击退距离)",
    "darkForestAbilityConfigDescription_10": "怪兽体力提升{?}%",
    "tutorialConfigName_15": "建造浮空巨塔",
    "tutorialConfigName_16": "上阵白虎",
    "tutorialConfigName_17": "建造黑暗森林",
    "tutorialConfigName_18": "黑暗森林探索",
    "tutorialConfigName_19": "留言功能",
    "propConfigName_90603": "绿色普攻恢复元核碎片",
    "propConfigName_90602": "白色普攻恢复元核碎片",
    "tutorialConfigName_10": "建造仓库",
    "propConfigName_90607": "红色普攻恢复元核碎片",
    "tutorialConfigName_11": "建造起源基石",
    "propConfigName_90606": "橙色普攻恢复元核碎片",
    "tutorialConfigName_12": "起源基石放入怪兽",
    "propConfigName_90605": "紫色普攻恢复元核碎片",
    "tutorialConfigName_13": "进入频道",
    "propConfigName_90604": "蓝色普攻恢复元核碎片",
    "tutorialConfigName_14": "打开邮件",
    "monsterName_134": "艾娜璃兹",
    "monsterName_135": "戏战顽袍",
    "monsterName_136": "咚魁",
    "monsterName_137": "初号铸体",
    "monsterName_138": "B.B.Token",
    "monsterName_130": "瞳",
    "monsterName_131": "祈",
    "monsterName_132": "硎",
    "monsterName_133": "咎骸",
    "propConfigName_51000": "自选词条元核",
    "messageInitNick_508": "坏天使",
    "messageInitNick_509": "道一声晚安",
    "messageInitNick_500": "绝世小仙女",
    "messageInitNick_501": "残喘的回忆",
    "messageInitNick_502": "恶魔造梦者",
    "messageInitNick_503": "八千里海岸",
    "messageInitNick_504": "套娃大师",
    "messageInitNick_505": "内卷门掌门",
    "messageInitNick_506": "无法定义",
    "messageInitNick_507": "寂寞无处投递",
    "darkForestAbilityConfigDescription_15": "怪兽血量回复效果提升{?}%",
    "monsterDes_40": "定位：辅助，增伤，低血点杀，自我治疗\\n为了压制下身被斩断的恐惧，血渊守护利用其他怪兽的恐惧压制自身的恐惧。越来越多的鲜血从它的双刃底下流出，染红了整片深渊。后来，它成为这片血渊的主宰，它再也不需要压制内心的恐惧，它只需要将内心的恐惧赐予深渊。现在，它的所到之处就是深渊。",
    "monsterDes_41": "定位：辅助，击退\\n异兽得知在遥远的次元有一位可怕的大魔王总以跳跃踩扁怪(mó)兽(gū)为乐，在生物本能的驱使下，异兽进化出了头角以应对这种可怕的时刻。",
    "monsterDes_42": "定位：辅助，击退\\n名牌止尿裤、性感小肚脐、怼天的呆毛还有那一脸请你食蕉的淡定，无一不预示着这熊孩子未来肯定会是大魔王啊！什么？看名字的意思是它还会跳？！",
    "monsterDes_43": "定位：辅助，减速，击退\\n因成长过程中频繁使用右手导致手部力量异于一般怪兽，在地上轻轻拭擦手部就能引起如地震般的震感，被称为超进化大陆的黄金右手。",
    "monsterDes_44": "定位：输出，贯穿伤害，击退\\n搜魂兽热衷于收集怪兽的灵魂，是一位不折不扣的大魔王。偷偷告诉你，据说搜魂兽的技能是吃烤串时顿悟的。",
    "messageInitContent_7408": "脸孔隐藏在万事万物之间",
    "monsterDes_45": "定位：辅助，减速，击退\\n崩界领主深知左手是自己的短板，所以在漫长的岁月里苦练左手，有志者事竟成，双手终于完美无瑕。",
    "messageInitContent_7409": "只要你专注集中留神",
    "monsterDes_46": "定位：输出，贯穿伤害，击退\\n被超进化卫生部多次约谈，委员会要求破魂领主对其收集的灵魂常常带有迷の黄色作出解释，它本人的回答是“我要找律师”。",
    "messageInitContent_7406": "褪下了吗",
    "monsterDes_47": "定位：辅助，减速，击退，减攻速\\n震撼大地只是基础操作，崩界暴君还可以震撼怪兽的脑髓。",
    "messageInitContent_7407": "蜕下了",
    "monsterDes_48": "定位：输出，贯穿伤害，击退，缩小体型\\n破魂暴君换了一个新趣味后，迅速和超进化卫生部达成了共识，成为了超进化大陆首席鉴黄师，缩小那些带有迷の黄色的灵魂，在物理层面上帮助它们戒掉不良的习惯，为整个大陆的**的冷静而奋斗。",
    "monsterDes_49": "定位：坦克，偏移\\n没人知道它的骗术是如何运作的，只知道它遭遇危机时总能一一化解，并且极少伤害对手，但最让人疑惑的不是它的骗术，而是代表谎言的长鼻子去哪里了？",
    "messageInitContent_7411": "它们在看着看着",
    "messageInitContent_7412": "它们会看着，直至命运的丝线断裂那天",
    "messageInitContent_7410": "就能发现无处不在的脸",
    "messageInitContent_7415": "可以去理解吗",
    "messageInitContent_7416": "可以去感受吗",
    "messageInitContent_7413": "死亡会湮灭吗",
    "messageInitContent_7414": "微不足道可以长存吗",
    "monsterDes_50": "定位：坦克，偏移\\n善用骗术却拥有如此热血暴力的名字真是违和，强袭自己却非常满意，在这条欺诈道上，是什么让它选择了强袭，最终它又将强袭何处？",
    "monsterDes_51": "定位：坦克，反伤，偏移\\n极限的头部长出了犄角，眼珠变得弯曲，内心的束缚也不复存在了，没有怪兽能抵挡它的骗术，它不再是当年只求自保的皮诺丘，它反击一切伤害它的怪兽。",
    "monsterDes_52": "定位：坦克，全体偏移\\n又多了一道疤……",
    "monsterDes_53": "定位：坦克，反伤，偏移\\n它的骗术一次又一次的突破，每当怪兽看到毁灭巨像时都会觉得眼前的一切不再可信。毁灭巨像那一脸自信满足的笑容是真是假？或许永远没有人知道……",
    "monsterDes_54": "定位：坦克，全体偏移\\n“我没有骗过自己。”",
    "monsterDes_55": "定位：坦克，反伤，偏移\\n毁灭泰坦的一切都真伪难辨，除了它那以牙还牙，以眼还眼的决心。",
    "messageInitContent_7419": "可没有主语",
    "monsterDes_56": "定位：坦克，全体偏移\\n“谁会保护你们。”",
    "monsterDes_57": "定位：辅助，封印\\n演了无数场皮影戏的它，终于拥有了自己的灵魂，从来没人听过它说话，曾经有怪兽想与它对话，最终连自己都陷入了无尽的沉默。",
    "messageInitContent_7417": "可以别问了吗",
    "monsterDes_58": "定位：辅助，封印，降霸\\n“你不肯说话，时间彷佛停止转动，我不敢看你，怕你真的说出分手，哦不……怕你真的放出技能。”",
    "messageInitContent_7418": "压下弹起压下弹起",
    "monsterDes_59": "定位：辅助，封印，降霸\\n轮脉可以感知到能量的流动，并能巧妙的把流动阻断，很多怪兽对它非常畏惧，因为坊间传闻阻断能量流动的方法跟轮脉的车轮有关。",
    "messageInitContent_7422": "它如此说道",
    "messageInitContent_7423": "那是温暖的深渊",
    "messageInitContent_7420": "谁在将它压下",
    "messageInitContent_7421": "不可视不可听不可闻",
    "messageInitContent_7426": "那是梦境的摇篮",
    "messageInitContent_7427": "那是您的被窝",
    "messageInitContent_7424": "那是冬日的陷阱",
    "messageInitContent_7425": "那是倦怠的开始",
    "themeCardPackName_22040": "在抗争中",
    "monsterDes_20": "定位：坦克，区域伤害，自我治疗\\n尸王一生不羁放纵，能抗能打，曾与暴虐战狂互殴时突发奇想模仿小飞侠的飞拳不慎甩飞了右臂，右臂是何其的珍贵，就这点足以证明它有多么的不羁了。",
    "monsterDes_21": "定位：坦克，全体治疗\\n美丽的姑娘逐渐变为成熟的御姐，手也是越来越多了，不难看出岁月对它做了些什么，但也正因为岁月，让它深谙了熵之道。",
    "monsterDes_22": "定位：坦克，区域伤害，自我治疗\\n一只高举的手，一把电吉他，一副太阳镜，尸狂这么*还需要介绍吗？",
    "monsterDes_23": "定位：坦克，全体减伤，全体治疗\\n熵之道有两端，一端是一切既定，靠着获取无限的知识去逼近；另一端是一切未定，借由放任自身的无知来逼近，两端的终点却又恰好是同一个死寂的末日，所以熵鬼姬现在走得更小心了，在那两端之间。",
    "monsterDes_24": "定位：坦克，区域伤害，区域降霸，自我治疗\\n比尸狂更*的尸狂公无需介绍，碰上它的都懂。多数怪兽都会先被尸狂公冲天尸气吓到霸气全泄，然后被撞飞，一边在天空划出弧线，一边大喊好*啊——",
    "messageInitContent_7428": "小小的硬控控呀控呀控",
    "monsterDes_25": "定位：输出，偷取血量\\n拥有傲人的大嘴，饮食习惯特殊，每次进食必需同时吞下两位男性，对王♂比利有深入的研究，技能极度克制大只佬（肉盾）。",
    "messageInitContent_7429": "独one无two",
    "monsterDes_26": "定位：输出，偷取血量\\n大头、绷带、龅牙没人知道它经历了些什么，但它却有一个响亮的名字——捕食者，或许是猎人还是猎物真的只在一念之间。",
    "monsterDes_27": "定位：输出，低血终结，偷取血量\\n曾多次参与拍摄舌尖上的超进化物语，口头禅“没有什么是一口不能解决的。”对王·狈·爷嗤之以鼻，认为杂食是异端。擅长袭击受伤的怪兽，并一口吞下。",
    "monsterDes_28": "定位：输出，持续伤害，偷取血量\\n腐化者有着难以直言之兴趣，常手持长棍袭击怪兽后背，被它攻击过的怪兽除了受到肉体上的伤害外，内心也会崩溃，是一种可怕的持续性伤害。",
    "monsterDes_29": "定位：输出，低血终结，偷取血量\\n大肚能容天下事是它的境界，随身携带的刀叉是它的态度，那缕嗅尽美食极其敏感的长舌是它的骄傲，就连超进化史也专门为它设立了一个称号——真·吃货。",
    "messageInitContent_7433": "额……",
    "messageInitContent_7434": "不该沉默时沉默",
    "messageInitContent_7431": "幼体对撞!",
    "messageInitContent_7432": "对位",
    "messageInitContent_7437": "一对一",
    "messageInitContent_7438": "沉默了",
    "messageInitContent_7435": "精致探索者竞猜中",
    "messageInitContent_7436": "晚安大小姐",
    "messageInitContent_7430": "第一天猜主题",
    "monsterDes_30": "定位：输出，持续伤害，偷取血量\\n那根棒子已经不再是当年的那根棒子，它是超进化物语里所有怪兽心中的达摩克利斯之剑，它的出现改变了这个世界的规则，这里禁止敌方出现在后背。",
    "monsterDes_31": "定位：输出，低血终结，偷取血量\\n这是一个吃货界盛传的说法——吃货都非常关心其他怪兽。像凶噬魔罗这样的极品吃货更是如此，它也非常关心其他怪兽……到底能不能吃，好不好吃，怎么吃比较好吃。作为新一代光盘行动的代言兽，凶噬魔罗从都不会让它的“食物”担心自己会被浪费。",
    "monsterDes_32": "定位：输出，持续伤害，偷取血量\\n有一段歌谣在超进化大陆上广为流传，“净化，所谓万物皆净化……”，这是那些曾遭到过永腐魔毒手的怪兽们，为了抵抗腐化的共同创造。可是，它们很快就发现，系在马鬃上的达摩克利斯之剑并没有因为它们学会了净化而被解下，永腐魔罗带着新的净化后的噩梦出现了。",
    "monsterDes_33": "定位：辅助，低血点杀\\n星刃拥有极为神奇的力量——召唤流星，曾任职“流星花园”首席特效师，凭借一招”哇，流星，MUA”撩妹无数，被超进化大陆所有雄性怪兽视为头号敌人。",
    "monsterDes_34": "定位：辅助，低血点杀\\n风流倜傥的虚刃已双刀渐显，饥渴难耐，它四处挑战持剑的怪兽，在与炎之高兴对阵时不慎被其斩断下身，后来这天被其他雄性怪兽称为“好日”。",
    "monsterDes_35": "定位：辅助，减攻，低血点杀\\n咒刃花费了大量时间回复其被斩断的下身，并因为内心怨恨的影响，召唤的流星产生了诅咒的效果，不可否认的是，咒刃比以前更为强大了。",
    "messageInitContent_7439": "在猜了在猜了",
    "monsterDes_36": "定位：辅助，增伤，低血点杀\\n血刃花费了大量时间回复其被斩断的下身，并因为内心怒火的影响，召唤的流星产生了诅咒的效果，它已不是当年风流倜傥的双刀，它现在只追求见血。",
    "visionSagesOption1_13": "需要",
    "monsterDes_37": "定位：辅助，减攻，低血点杀，自我治疗\\n“咒灭即守护！”",
    "monsterDes_38": "定位：辅助，增伤，低血点杀，自我治疗\\n“当你望着血渊的时候血渊也在望着你。”",
    "visionSagesOption1_11": "传说中的恶魔果实",
    "monsterDes_39": "定位：辅助，减攻，低血点杀，自我治疗\\n咒灭主宰花费了大量时间去处理下身被斩断时留在精神上的伤口，它并非要让伤口愈合而是要让伤口保留。它持续刺激自己的伤口，越来越多利刃般的诅咒从伤痛中生出。它成为诅咒的主宰，将诅咒刺向它的对手。",
    "visionSagesOption1_12": "没事",
    "visionSagesOption1_10": "可以",
    "messageInitContent_7444": "有端联想",
    "messageInitContent_7445": "技能知道答案",
    "messageInitContent_7442": "走近竞猜",
    "messageInitContent_7443": "优势在我",
    "messageInitContent_7448": "保护我方远程",
    "messageInitContent_7449": "左边",
    "messageInitContent_7446": "据我所知我一无所知",
    "messageInitContent_7447": "前面前面借过",
    "messageInitContent_7440": "选完收工",
    "messageInitContent_7441": "跳个舞先",
    "monsterDes_81": "定位：辅助，治疗\\n逆转代表着超进化大陆的善良和希望，拥有大陆上极为稀有的回复能力，终极形态日夕和月夕都能极大的增强队伍的作战能力（因为貌美如花），逆转战局。",
    "monsterDes_82": "定位：辅助，全体治疗\\n“我不能让受伤的小鸟重新飞翔，但我能让不会飞的制杖巨人学会飞翔。”（因为貌美如花）",
    "themeCardPackName_22015": "Joker",
    "monsterDes_83": "定位：辅助，低血点杀，全体治疗\\n日夕热爱日光浴，性格热情开朗，口头禅“再撩我就请你吃枪子哟！”曾使用逆转弹狙击高速飞行的魔隼，是位可奶可补刀的超Hoooooooot美少女！",
    "monsterDes_84": "定位：辅助，减伤，全体治疗\\n月夕温柔善良，常常帮助落难的怪兽，怪兽们常说“那感觉就像初恋，甜蜜，珍贵，久久不能忘怀”（主要是因为貌美如花）",
    "monsterDes_85": "定位：辅助，增伤，低血点杀，全体治疗\\n原恒·日夕有着“超进化美少女”的美誉，长腿、短裙、秀发是它的标志，出场自带追光灯效果，无数怪兽为之倾倒，更有怪兽表示能见它一面，爆炸也愿意。",
    "monsterDes_86": "定位：辅助，持续回复，减伤，全体治疗\\n朣胧·月夕打心底喜欢鼓舞和帮助别人，很长一段时间里它苦练祝福术（使用护肤草、化妆花、美颜泥等），现在已是超进化大陆当之无愧的祝福之王。",
    "monsterDes_87": "定位：辅助，增攻，增伤，低血点杀，全体治疗\\n主序·日夕就像太阳一样，它灼眼的光芒甚至会伤害到自己，直到主序·日夕捡到了一支强效防晒霜，它才开始安心地展现真正的力量。 ",
    "monsterDes_88": "定位：辅助，清除负面，持续回复，减伤，全体治疗\\n瑶镜·月夕将在月光的祝福下迎来最后的觉醒，只是月夜变狼人的传说让它无法抉择（大概是因为貌美如花），直到它捡到了一支强效脱毛膏，它才放心接受月光的洗礼。",
    "monsterDes_89": "定位：坦克，区域减伤，区域增益，自我治疗\\n很多怪兽都怀疑冥龙王到底还算不算是生物，它仿佛就像哈迪斯一般，从来不会死亡，却掌控着你的生死，它散发的异能是超进化大陆中最为超自然的力量，异能区域是这片大陆上怪兽最为密集的地方，没有之一。\\n外面的怪兽想进去，里面的怪兽……挤不出来，大家把这种特殊的现象称为“围城”。",
    "messageInitContent_7455": "奶奶知道答案",
    "messageInitContent_7456": "悠着点",
    "messageInitContent_7453": "选完收工",
    "messageInitContent_7454": "相信第一感觉",
    "messageInitContent_7459": "看看技能",
    "messageInitContent_7457": "答案充斥着我的鼻腔胸腔",
    "messageInitContent_7458": "纠结",
    "messageInitContent_7451": "我家猫帮我选了",
    "messageInitContent_7452": "猜对day0",
    "monsterDes_90": "定位：输出，攻击转移，护盾，减速，区域治疗\\n镇魂对音乐的热情始于欲望，源于血脉，它学会了用灵魂发声，这种无法言喻的声音甚至能打动掌控生死的神灵，这种声音被怪兽们称为“镇魂曲”，受到镇魂曲影响的怪兽会变得“强”“大”无比，就像任何“替身”加上镇魂曲都会进化到一个新档次那样。",
    "themeCardPackName_22010": "血肉剧团",
    "messageInitContent_7450": "赢了",
    "monsterDes_91": "定位：输出，清除克星，减疗，偷取护盾，濒死自愈\\n“它突然破土而出，毫不费力地钳制住了那只体型比它还要庞大数倍的比蒙巨兽。”\\n它对所有热源垂涎，甚至热源属于大地，它破土疾行，直抵热核，贪婪地吞噬翻涌滚烫的热流。\\n这就是它不灭的奥秘——毫无底线的能量转化！（可以靠吃土为生）\\n“它残忍、它嗜血，它无法直视……！，它连外形都有着巨大的杀伤力！”",
    "monsterDes_92": "定位：输出，封印，缩小体型，区域减疗，能量回复提升\\n演武一族总是一胎四子，幺子血煞自出生起，就和兄长进行着不间断的战斗训练，备战最后的试炼“剧王演武”，他们相信兄弟同心必然可以通过试炼。试炼如期而至，他们知晓了一族的宿命，四子归一，演武的终焉只能有一个剧王。开幕而后落幕，机运、实力和信念为血煞写下了胜利的剧本。他将兄长的脸谱覆于自己脸上，连同他们的能力和意志，血煞成为了强大而永恒的剧王，然后是无尽的咆哮，从此，演武一族再无演武。",
    "themeCardPackName_22005": "无言告别",
    "monsterDes_93": "定位：输出，范围伤害，范围击退，增大体型，子弹蒸发\\n赤虹与火神是同♂异♀的兄妹，非常讨厌冰霓（原因未知），赤虹的火焰也更为任性和多变，难以预测。据火神口述“千万不要因为任何原因介入赤虹和冰霓之间的任何事情，除非你想在那天变大变小无数次……”",
    "monsterDes_94": "定位：输出，封印，减疗，区域持续伤害，伤害回血\\n火神用半管血去掂量对手的火候，再用半管血去穿越炼狱回到超进化大陆，暴走的苍炎化身为炼狱的末劫之火，它回归的目的只有一个，亲手焚尽大地的黑暗，为你献上盛大的烟火晚会。\\n而你，就是那颗燃爆得最绚烂的烟花。",
    "monsterDes_95": "定位：输出，远程近战切换，范围伤害，忽视减伤，免疫负面\\n喀戎拥有两个灵魂，擅长近战的喀和擅长远程的戎。过去，他们作为酋长统领着各自的部落，为了争夺夜光森林的至宝而世代相杀。在一次混战中他们的武器同时贯穿了对方的躯体，宝物不知所踪，夜光森林亦失去了光辉。\\n喀戎一直认为，他们的融合是上天的惩罚，直到他们得知，至宝背后的哲学远超他们的想象，两个灵魂融合正是迈向新世界的第一步。",
    "monsterDes_96": "定位：输出，范围持续伤害，全体增伤，范围减攻\\n黯灭自诞生起就被黯焰覆盖，它拥有无限火力，只有鲜血才能让它冷却片刻，其他怪兽一直认为黯灭被诅咒了，其实……黯灭才是诅咒本身，它能轻松且高效地烧怪于千里之外而不被发现，所以它很快就成为了3F团的高级荣誉团员。\\n面对它，大多数怪兽都会采取同样的“防守策略”，赶紧逃。所以谁都不会注意到，让它化身为诅咒的，只不过是那不起眼的孤独。",
    "monsterDes_97": "定位：辅助，凭依状态，属性共享，消除子弹，濒死治疗\\n御空生来就是一个异类，她不能使用最简单的攻击，也无法被任何攻击所伤害。在漫长的时间里，御空扇动着翅膀在天际游荡，就像世界的旁观者，存在却没有价值，直到那天，一个“声音”改变了御空的命运。\\n御空双翼不受控制地把她带向了“声音”的源头，那是一只饱受摧残的怪兽。她想要送上一个拥抱，让它在最后的时刻远离孤独，就在她触碰到那只怪兽的瞬间，一切就这么发生了，她追随着内心，拯救了那只怪兽，这种力量被其他怪兽称为“凭依”。\\n也是那天，一种全新的力量在超进化大陆破茧成蝶。",
    "monsterDes_98": "定位：辅助，区域治疗，区域伤害\\n与白昼在同一战线是一件非常幸运的事，她像天使一样治愈同伴，像魔鬼一样腐化敌人，她还拥有至高无上的护甲——黑丝！\\n光芒愈是耀眼，阴影就越是深沉，透过黑丝挥洒光芒，这就是白昼。 ",
    "resoundEventConfigName_10": "第10章",
    "monsterDes_99": "定位：输出，黑洞，范围伤害，忽视减伤，近战降低负面时间，远程增攻\\n辗转千年，最后一块散落的杀生石碎片融入玖璃体内，为了消解杀生石碎片带来的痛苦，玖璃在深夜时分便会点起手中的魂灯，利用漆黑之洞诱捕游荡的邪恶灵魂，无奈引来的多半是些“闪电”，如今又已千年，烛影幽幽映红颜，青丘月下兆狐仙，云妖缭缭妆九尾，迷离惊梦玉藻前，今天的玖璃又是何物呢？",
    "messageInitContent_7466": "听说",
    "messageInitContent_7467": "又是远程",
    "messageInitContent_7464": "大剑在此",
    "messageInitContent_7465": "讨好",
    "messageInitContent_7468": "技能知道答案",
    "messageInitContent_7469": "晚安大轰龙",
    "messageInitContent_7462": "很对称呢",
    "messageInitContent_7463": "怪兽与猎人",
    "messageInitContent_7460": "在左右之间迷失了方向",
    "messageInitContent_7461": "这是哪里",
    "monsterDes_60": "定位：辅助，减疗，封印，降霸\\n影杀带上了神秘的面具，获得了抹去治愈能量的能力，无数怪兽倒在这种诡秘的力量之下，无法诉说无法治愈真是一种深深的绝望。",
    "monsterDes_61": "定位：辅助，封印，降霸\\n合一零式掌握了独特的能量流动技巧，对超进化大陆怪兽们使用技能的原理有深入的理解，被称为最接近麒麟的怪兽，即便像王·狈·爷这么强大也忌它三分。",
    "monsterDes_62": "定位：辅助，减疗，封印，降霸\\n“学会了我的决杀，剩下的就是A了。”",
    "themeCardPackName_22035": "某次幕后",
    "monsterDes_63": "定位：辅助，封印，降霸\\n合一终式几乎让所有怪兽感到畏惧，因为没有多少怪兽能在习惯已久的能力完全失效后保持冷静。反过来说，能让合一终式感到畏惧的东西只有两种，一个是不可封印，另一个是它的自己。",
    "monsterDes_64": "定位：辅助，减疗，封印，清除增益，降霸\\n“学会了我的决杀，剩下的不A也没关系了。”",
    "monsterDes_65": "定位：输出，范围伤害，忽视减伤，免疫负面\\n混沌代表着超进化大陆的原始和凶猛，我要打十个对他来说就是过家家玩泥巴，他的两个终极形态都拥有极高的群体伤害能力，生命不息杀戮不止是他的真实写照。",
    "monsterDes_66": "定位：输出，范围伤害，忽视减伤，免疫负面\\n超进化大陆流传着这样一个传闻，每当启示击败（虐）敌人后，都会嘶吼“你，得到什么启示了？”可惜了的是，这个传闻至今没有找到当事人证实。",
    "monsterDes_67": "定位：输出，叠加增伤，范围伤害，忽视减伤，免疫负面\\n“它就像一台杀戮机器，开启了就不会停下，不……比起机器它更像是另外一个世界来的恶魔”赤色狮回忆道。",
    "monsterDes_68": "定位：输出，吸血，范围伤害，忽视减伤，免疫负面\\n暴虐战狂曾与一名叫“脑残吼”的兽人种厮杀，战果无从得知，可以确定的是自那次厮杀后，暴虐战狂获得一把力量惊人的巨斧并开始横扫一切。",
    "monsterDes_69": "定位：输出，叠加增伤，范围伤害，忽视减伤，免疫负面\\n“永远不要觉得你在面对拟决·最终兵器时能保护谁，你甚至连保护自己都做不到。”",
    "messageInitContent_7477": "等大家选完",
    "messageInitContent_7478": "啊啊啊啊啊啊",
    "messageInitContent_7475": "明天见",
    "messageInitContent_7476": "有回复啊",
    "messageInitContent_7479": "没有经验",
    "themeCardPackName_22030": "精确登场",
    "messageInitContent_7470": "真嘟假嘟",
    "messageInitContent_7473": "你快乐过生活",
    "messageInitContent_7474": "大家好",
    "messageInitContent_7471": "被发现了",
    "messageInitContent_7472": "刚来选啥",
    "monsterDes_70": "定位：输出，吸血，范围伤害，忽视减伤，免疫负面\\n“那场焦土上的战斗持续了三天，直至围攻破军·暴虐战狂的怪兽大军全部被击溃。”",
    "resoundEventStoryDes_101": "圣堂山谷中央，有一座由曜石堆砌而成的无顶圣堂，这个圣堂是所有圣堂武士共同的圣地。圣堂中央有一块不规则的八面体谷碑，每一个面似乎都得到了细致的打磨。能穿透山谷，越过圣堂，落在谷碑的光少之又少。那座如同一只巨大影兽的谷碑，吐出浓厚的影雾，仿佛要将所剩无几的光点全部吞噬一般。",
    "monsterDes_71": "定位：输出，叠加增伤，范围伤害，忽视减伤，免疫负面\\n夷平超进化大陆只需要两只怪兽，永逐·最终兵器和那只把它惹怒的怪兽。",
    "resoundEventStoryDes_102": "那是圣堂武士才能读懂刻画在谷碑上的图文，那是每一位圣堂武士都要遵守的戒律。只有圣堂武士的军团长才能在谷碑上刻入戒律，最初只有十条。\\n如今，谷碑上刻满了密密麻麻的戒律，后来的戒律只能刻在最初的戒律的缝隙里头。圣堂武士的其中一个重要试炼就是记熟这些戒律，并严格执行。",
    "monsterDes_72": "定位：输出，吸血，范围伤害，忽视减伤，免疫负面\\n怪兽大军全副武装，带上奶妈，誓要卷土重来，报焦土一战之仇。这次大战持续了三天，直至围攻神畏·暴虐战狂的怪兽大军全部被击溃。",
    "themeCardPackName_22025": "开场表演",
    "monsterDes_73": "定位：坦克，免伤\\n传说代表着超进化大陆的坚韧和勇气，终极形态神剑古拉姆几乎无坚不摧，而圣盾埃癸斯则是绝对的防御，是超进化大陆最强的剑与盾。",
    "resoundEventStoryDes_100": "圣堂武士的这个问题，犹如滴入浓墨中的一滴清水，只搅起了小幅的搅动，通往斗技场战斗的道路，很快就遭到了严厉的否决。\\n一条新的禁律诞生了。“大家都应该加入军团，不能有例外！”这是整个军团给出的答案。圣堂武士的禁律碑谷之中多出了一条新的禁律。",
    "monsterDes_74": "定位：坦克，免伤，全体霸气\\n打破封建迷信的思想，叫神赐只是因为它很强，剑和盾是强大的伙伴，而它同时拥有两名强大的伙伴……（别提索隆）",
    "monsterDes_75": "定位：输出，免伤，全体霸气\\n古拉姆崇尚进攻，疯起来连自己都打，认为防守和嘴炮并无区别，在一次战斗中顿悟“手中无剑心中有剑”的境界，然后就把盾牌丢掉了。",
    "monsterDes_76": "定位：坦克，自我治疗，免伤，全体霸气\\n埃癸斯口头禅“mamoru”，战斗时始终贯彻着守护某人的战斗方式，唯一一次战斗失利是与腐化者对战时被其偷袭后背，至此之后它换上了一面能包裹全身的盾牌。",
    "monsterDes_77": "定位：输出，攻血联动，免伤，全体霸气，全体增攻\\n没有人知道归刃·神剑古拉姆到底有多少把剑（数一下就知道是5把），它引发的进攻潮流像病毒般在怪兽中蔓延，超进化委员会为此颁布了一条法令，不准打自己。",
    "monsterDes_78": "定位：坦克，稳固，自我治疗，免伤，全体霸气\\n针对5把剑，6块盾牌应该是一个比较稳妥的防御方式，止戈·圣盾埃癸斯比谁都明白全方位的防护有多重要，至于加厚和夜用（夜光照明）则是它正在修炼的方向。",
    "monsterDes_79": "定位：输出，全体增攻，攻血联动，免伤，全体霸气\\n万象·神剑古拉姆举起剑的那一刻起，他就宣告了胜利。因为他总能鼓舞着每一个队友，背后的四把长剑与身后的四位队友，怎么会是巧合呢。",
    "messageInitContent_7488": "惊",
    "messageInitContent_7489": "原生竞技场",
    "messageInitContent_7486": "未尝一对",
    "messageInitContent_7487": "我梦到了是右边赢",
    "messageInitContent_7480": "技能知道答案",
    "resoundEventStoryDes_109": "大舌怪和镇魂刚从晨光之柱旁的南十字饭馆出来，一大群G-N立刻围了上去。镇魂张开手正准备迎接大波兽丝的热情拥抱。G-N群来势汹汹的冲了过来，怎料，它们在镇魂面前突然一个急转，G-N群的浪潮一拐，都涌到了大舌怪周围。大舌怪就这样被拥簇着离开了……几日后，镇魂看着大舌怪作的新歌词，理解到了一切。",
    "21_comment": "登录，选服，公告，进入动画",
    "messageInitContent_7481": "一眼答案",
    "resoundEventStoryDes_107": "近日，镇魂的新曲《舔狗到最后一无所有（不）》超越了幻的《听到是你的幻觉啦》，成为超进化大陆最受欢迎的歌曲。\\n“镇魂，你的新曲很受欢迎喔。”\\n“真是出乎意料，我自己都没想到。（灵魂发声）”\\n“可以说说这首歌的灵感来源吗？是你的亲身经历吗。”\\n“其实这首歌是我和大舌怪的合作作品，它填词，我作曲。舔狗是我们的组合名。（灵魂发声）”\\n“这真是……超进化物语电台记者白昼为你报道。”",
    "resoundEventStoryDes_108": "这天大舌怪和镇魂在晨光之柱旁边的饭馆见面。\\n镇魂：哇，你怎么胖了这么多，肉片长变肉团子了。（灵魂发声）\\n大舌怪：因为不再当舔狗了。（PeroPero声）\\n镇魂：……好吧。最近创作了一首新曲，想跟你碰碰想法。（灵魂发声）\\n大舌怪：喔喔。唔嗯，嗯嗯，不错，歌词我已经有想法了！（PeroPero声）\\n镇魂：好，等你到时候写好，咱们再约。（灵魂发声）\\n……",
    "messageInitContent_7484": "看我发现了什么！",
    "resoundEventStoryDes_105": "在那位捡到斗技场招募猪皮卷之后一段时间，谷碑上刻上了一条新的戒律，似乎在刻意隐藏或者引导些什么。翻译过来大致是——禁止禁止禁止禁止禁止禁止禁止禁止禁止禁止质疑。",
    "messageInitContent_7485": "选择困难",
    "resoundEventStoryDes_106": "镇魂没有灵感的时候，就会去找魅妆，然后向她示爱。\\n魅妆从不让镇魂失望，总是无情地拒绝镇魂。\\n这种被拒的痛苦，爱而不得的郁结，又恰好成为了召来灵感女神最有效的供物。",
    "messageInitContent_7482": "希望大家蒙的都对",
    "resoundEventStoryDes_103": "第二天，捡到斗技场招募猪皮卷的圣堂武士在谷碑上看到了一条新的戒律——每一位圣堂武士都必须加入军团，不得有异议。\\n这条戒律却让更多圣堂武士产生了新的疑惑。",
    "messageInitContent_7483": "看看伤害回血懂了",
    "monsterDes_80": "定位：坦克，范围减伤，稳固，自我治疗，免伤，全体霸气\\n面对天元·圣盾埃癸斯的时候，大多数怪兽会瞬间失去战意。一些仍有战意的怪兽试图突破它的防御，直至武器崩坏铩羽。剩下的一些怪兽突破了它的防御，并被圣盾背后的怪兽射成了筛子。",
    "resoundEventStoryDes_104": "它不知道违背了圣堂武士的戒律会怎样，因为从来没有出现过违背戒律的圣堂武士。由此一个这位圣堂武士生出了一个大胆的想法，它决定离开圣堂武士预备军团，到斗技场闯闯。",
    "themeCardPackName_22020": "他的托付",
    "randomEventDialogueGroupConfig_11.229": "离开",
    "randomEventDialogueGroupConfig_11.227": "捡起告诉它",
    "randomEventDialogueGroupConfig_11.228": "都不给力的！哼，我找其它怪兽帮我哼。再见",
    "randomEventDialogueGroupConfig_11.225": "有什么东西从它身上掉出来了。",
    "randomEventDialogueGroupConfig_11.226": "甩开它捡起",
    "randomEventDialogueGroupConfig_11.223": "有技巧地转",
    "randomEventDialogueGroupConfig_11.224": "随便转",
    "randomEventDialogueGroupConfig_11.221": "离开",
    "randomEventDialogueGroupConfig_11.222": "哇哇哇哇哇哇哇哇哇哇哇哇哇哇，太开心了。继续继续哈哈哈。",
    "giantExtraName_6": "原生族-塔中秘庭{1}",
    "giantExtraName_5": "木偶族-塔中秘庭{1}",
    "randomEventDialogueGroupConfig_11.220": "等待",
    "themeCardPackStoryId_5": "CR-001",
    "giantExtraName_2": "祖龙族-塔中秘庭{1}",
    "giantExtraName_1": "塔中秘庭{1}",
    "giantExtraName_4": "星灵族-塔中秘庭{1}",
    "giantExtraName_3": "尸鬼族-塔中秘庭{1}",
    "messageInitNick_7191": "无极上限",
    "messageInitNick_7190": "心理治疗师",
    "randomEventDialogueGroupConfig_11.218": "拒绝报答并离开",
    "randomEventDialogueGroupConfig_11.219": "它沉默了许久。",
    "messageInitNick_7197": "我推的垫子",
    "randomEventDialogueGroupConfig_11.216": "不要！不要停下来啊！我会报答你的。",
    "messageInitNick_7196": "跑分大师",
    "randomEventDialogueGroupConfig_11.217": "再次开始转",
    "messageInitNick_7199": "可爱的昨日",
    "randomEventDialogueGroupConfig_11.214": "搞什么，还不攻过来，这就是你的策略吗？#都被你绕晕了！你的攻击奏效了！店里随便看吧，哼唧。",
    "messageInitNick_7198": "复读先驱",
    "randomEventDialogueGroupConfig_11.215": "进店",
    "messageInitNick_7193": "公主骑士",
    "randomEventDialogueGroupConfig_11.212": "等待",
    "messageInitNick_7192": "卷帝",
    "randomEventDialogueGroupConfig_11.213": "离开",
    "messageInitNick_7195": "幻想家",
    "randomEventDialogueGroupConfig_11.210": "离开",
    "messageInitNick_7194": "立夏",
    "randomEventDialogueGroupConfig_11.211": "它还在沉默中……",
    "messageInitNick_7189": "义字当头",
    "messageInitNick_7180": "且行且珍惜",
    "randomEventDialogueGroupConfig_11.209": "等待",
    "randomEventDialogueGroupConfig_11.207": "哇哦，天，这是天堂吗？#噢，这飞一般的感觉，咦怎么松手了，啊啊啊啊啊啊。#你……下次……可不放过你！",
    "randomEventDialogueGroupConfig_11.208": "它仍然在沉默中……",
    "messageInitNick_7186": "傲似公主",
    "randomEventDialogueGroupConfig_11.205": "停下",
    "messageInitNick_7185": "痴心去扑火",
    "randomEventDialogueGroupConfig_11.206": "继续",
    "messageInitNick_7188": "套娃神",
    "randomEventDialogueGroupConfig_11.203": "离开",
    "messageInitNick_7187": "高温落汤鸡",
    "randomEventDialogueGroupConfig_11.204": "天呐，这种全新的转圈体验是什么！太棒了吧，不要停下来啊啊啊啊——",
    "messageInitNick_7182": "草莓酸奶酱",
    "randomEventDialogueGroupConfig_11.201": "战斗",
    "messageInitNick_7181": "愤怒的脚本",
    "randomEventDialogueGroupConfig_11.202": "你这样是抓不到我的哈哈哈。今天转足了。再见。",
    "messageInitNick_7184": "福音中心",
    "messageInitNick_7183": "花店老板",
    "randomEventDialogueGroupConfig_11.200": "居然堵在我必然会绕过的地方，真是勇敢！那就来吧。",
    "messageInitNick_7179": "整活大师",
    "messageInitNick_7178": "请和她交往",
    "messageInitNick_7175": "格兰芬少",
    "messageInitNick_7174": "超级钓鱼神",
    "messageInitNick_7177": "究极飞龙",
    "messageInitNick_7176": "北冥女皇",
    "messageInitNick_7171": "未曾设想的路",
    "messageInitNick_7170": "智能牙刷",
    "messageInitNick_7173": "养肥了看",
    "messageInitNick_7172": "好掏好掏好掏",
    "messageInitNick_7168": "猫咪交响乐",
    "messageInitNick_7167": "榴莲是厨师",
    "messageInitNick_7169": "阿姨来巡房",
    "messageInitNick_7164": "粽子觉得满足",
    "messageInitNick_7163": "流浪的枕骨",
    "messageInitNick_7166": "九百代单传",
    "randomEventDialogueGroupConfig_11.269": "离开",
    "messageInitNick_7165": "有故事的人",
    "messageInitNick_7160": "心弦在跳动",
    "randomEventDialogueGroupConfig_11.267": "离开",
    "randomEventDialogueGroupConfig_11.268": "它晕倒了。",
    "messageInitNick_7162": "冷静冷静",
    "randomEventDialogueGroupConfig_11.265": "离开",
    "messageInitNick_7161": "太上老菌",
    "randomEventDialogueGroupConfig_11.266": "这时候严查补习班的白昼突然出现，神秘商人吓得马上跑掉了。",
    "randomEventDialogueGroupConfig_11.263": "才不上当",
    "randomEventDialogueGroupConfig_11.264": "它又开心绕了几圈。",
    "randomEventDialogueGroupConfig_11.261": "到我店里找找呗。",
    "randomEventDialogueGroupConfig_11.262": "进店",
    "messageInitNick_7157": "繁星与夜",
    "messageInitNick_7156": "丑得那么别致",
    "randomEventDialogueGroupConfig_11.260": "离开",
    "messageInitNick_7159": "恰瓜大师",
    "messageInitNick_7158": "凉心姑娘",
    "messageInitNick_7153": "小小谎言",
    "messageInitNick_7152": "千机变大佬",
    "messageInitNick_7155": "开心的笨小孩",
    "randomEventDialogueGroupConfig_11.258": "不接",
    "messageInitNick_7154": "国民软妹",
    "randomEventDialogueGroupConfig_11.259": "它一边转圈一边说话完全追不上你。",
    "randomEventDialogueGroupConfig_11.256": "它开心地绕着你跑了几圈然后丢了一件东西给你。",
    "randomEventDialogueGroupConfig_11.257": "接住",
    "messageInitNick_7151": "东京老吃货",
    "randomEventDialogueGroupConfig_11.254": " 谴责打食物",
    "messageInitNick_7150": "月色如银",
    "randomEventDialogueGroupConfig_11.255": "思考",
    "randomEventDialogueGroupConfig_11.252": "离开",
    "messageInitNick_7149": "八十岁了",
    "randomEventDialogueGroupConfig_11.253": "它仍旧在高速转圈。",
    "randomEventDialogueGroupConfig_11.250": "战斗",
    "randomEventDialogueGroupConfig_11.251": "它低下了头，很失望的样子，转着小圈圈离开了。",
    "messageInitNick_7146": "咖喱加点糖",
    "messageInitNick_7145": "深海之主",
    "messageInitNick_7148": "期末刺客",
    "messageInitNick_7147": "天下起雨了",
    "messageInitNick_7142": "老婆我在呢",
    "randomEventDialogueGroupConfig_11.249": "可恶瞧不起我是吧，不可原谅！我打——",
    "messageInitNick_7141": "戳戳小狗腿",
    "messageInitNick_7144": "草莓消灭者",
    "randomEventDialogueGroupConfig_11.247": "否认",
    "messageInitNick_7143": "柿子兽",
    "randomEventDialogueGroupConfig_11.248": "找理由否认",
    "randomEventDialogueGroupConfig_11.245": "同意比比",
    "randomEventDialogueGroupConfig_11.246": "都说了让你别让我！你是不是看不起我在转圈这事上的觉悟？",
    "messageInitNick_7140": "时光忘记回来",
    "randomEventDialogueGroupConfig_11.243": "离开",
    "randomEventDialogueGroupConfig_11.244": "它一边转圈一边说。",
    "messageInitNick_7139": "你躲哪了",
    "randomEventDialogueGroupConfig_11.241": "离开",
    "messageInitNick_7138": "牙膏毁灭者",
    "randomEventDialogueGroupConfig_11.242": "你晕倒了。又醒来了。神秘商人已经不见影踪。",
    "randomEventDialogueGroupConfig_11.240": "它一时间反应不过来，愣在了原地。",
    "messageInitNick_7135": "橙子在唱歌",
    "messageInitNick_9798": "信仰不足",
    "messageInitNick_7134": "打小就可爱",
    "messageInitNick_9799": "不忘萤火",
    "messageInitNick_7137": "早上七点半",
    "messageInitNick_9796": "蘑菇射手",
    "messageInitNick_7136": "约定风琴",
    "messageInitNick_9797": "如若回到当初",
    "messageInitNick_7131": "始于脸红",
    "messageInitNick_9794": "整点海景房",
    "randomEventDialogueGroupConfig_11.238": "它大声咆哮着向你冲了过来。",
    "messageInitNick_7130": "天堂饭盒",
    "messageInitNick_9795": "我推的胖子",
    "randomEventDialogueGroupConfig_11.239": "战斗",
    "messageInitNick_7133": "救命稻草",
    "messageInitNick_9792": "无敌的法法",
    "randomEventDialogueGroupConfig_11.236": "准备发起攻击",
    "messageInitNick_7132": "短路一秒钟",
    "messageInitNick_9793": "煎蛋哥",
    "randomEventDialogueGroupConfig_11.237": "绕着它转一圈",
    "messageInitNick_9790": "万能电视",
    "randomEventDialogueGroupConfig_11.234": "哈喽呀。",
    "messageInitNick_9791": "幼稚鬼",
    "randomEventDialogueGroupConfig_11.235": "不管它离开",
    "randomEventDialogueGroupConfig_11.232": "我好满足，好开心。感觉也差不多了。",
    "randomEventDialogueGroupConfig_11.233": "放下它去拾起",
    "messageInitContent_7400": "却没有一个清晰的句子",
    "messageInitNick_7128": "旧街",
    "randomEventDialogueGroupConfig_11.230": "多转转，说不定还能掉更多哦，都送你哈哈。",
    "messageInitContent_7401": "没有一段完整的躯体",
    "messageInitNick_7127": "记忆摇晃着",
    "randomEventDialogueGroupConfig_11.231": "努力转",
    "messageInitNick_9789": "带橙子去玩耍",
    "messageInitNick_7129": "打扰了",
    "messageInitContent_7404": "遍地麟麟波光",
    "messageInitNick_7124": "喜欢我直说",
    "messageInitNick_9787": "咸咸咸咸鱼",
    "messageInitContent_7405": "那是黏液中含混的鳞片",
    "messageInitNick_7123": "米饭的烦恼",
    "messageInitNick_9788": "奉旨撸猫",
    "messageInitContent_7402": "幸好我已无法认知",
    "messageInitNick_7126": "懒鬼",
    "messageInitNick_9785": "爱笑的人",
    "messageInitContent_7403": "███████████████████████",
    "messageInitNick_7125": "脑干生成中",
    "messageInitNick_9786": "瘦猫达人",
    "resoundEventStoryDes_198": "入夜了，只见兽群在月色下只剩下模糊的外轮廓，它们抬头屏息，凝望夜空，等待着接下来的烟火大会。\\n夜幕中，第一个火球射出，炸裂，落下，第二个火球，第三个……，一个个火球升起，用尽全力在一瞬怒放，错落凋零，与最后的残响一同谢幕，将静谧还给夜空。\\n不久之后，是兽群连绵不断的欢呼。",
    "resoundEventStoryDes_199": "烟火大会结束后不久的山那头，随着最后一口龙焰在空中熄灭，轰龙啪嗒地倒在湿润的草地上，背后的翅膀向后微微一伸便迅速耷拉下去，后背随着呼吸快速起伏着。它将头扭向一侧，大口喘着粗气，吹得鼻头旁边的草儿连着几次被弯下又挺起。\\n陷入梦乡前的朦胧间，它听到了远处传来的欢呼声，如梦如似幻，那大概是坚持锻炼的奖励吧，它想……",
    "23_10": "……",
    "resoundEventStoryDes_196": "听，这就是桐仁的叫声。听不懂也没关系，有请翻译。\\n翻译1：谁还不是一只鸽子呢。\\n翻译2：谁还不是一只鸽子呢。\\n翻译3：谁还不是一只鸽子呢。",
    "resoundEventStoryDes_197": "桐仁看到《咸鱼剑与背锅盾的美味菜谱》后，决定亲自动手给御空小姐姐做一个火山湖水藻团·菜改。首先把强化孢子和进化孢子放在处理过的火山湖水藻上/然后努力卷起来/靠北啊搞得一塌糊涂就像你做的任何事一样/这个火山湖水藻团·菜改简直就是你兽生写照/火山湖水藻团·改没有火山水湖水藻团·改，就是菜/而且没有人爱你。",
    "23_12": "|c请相信|c这是记忆的一部分，我只负责展示。",
    "resoundEventStoryDes_194": "一天后，Joker听到了Queen羞涩的回复——\\n “你……真是……那个……八角尖尖、六面平平呢。”",
    "23_11": "我就知道……\\n这是|c给敌人的|c礼物。",
    "resoundEventStoryDes_195": "叉叉，谢谢你的全力以赴。",
    "11_25": "起源殿周悬赏",
    "messageInitNick_7120": "葡萄射手",
    "messageInitNick_9783": "概率预测家",
    "randomEventDialogueGroupConfig_10.79": "那你到底想怎样！",
    "randomEventDialogueGroupConfig_58.13": "绝不松手",
    "resoundEventStoryDes_192": "“新世界的大门怎么走？”\\n“走心。”\\n“前门还是后门？”\\n “后门！”\\n “暗号都对上了，同志哟，这边请，欢迎来到喀和戎的秘密组织‘新世界大门’。”",
    "11_26": "每周重置",
    "messageInitNick_9784": "落跑甜心",
    "randomEventDialogueGroupConfig_58.14": "爪子一下将悬赏令收入囊中便迅速消失不见了。你突然发现你怀里多了一张折起来的悬赏令。",
    "resoundEventStoryDes_193": "今天是Joker和Queen在一起的某个纪念日。\\n“Queen今天这么有意义的日子，满足我一个小小的愿望吧！”\\n“嗯？”\\n“夸我！”\\nQueen思考了良久，Joker紧张地等待着……",
    "11_23": "排行榜",
    "messageInitNick_7122": "顶骨",
    "messageInitNick_9781": "流浪的护士",
    "randomEventDialogueGroupConfig_58.15": "打开看看",
    "resoundEventStoryDes_190": "听说\\n爱是邂逅、离别、透明的面纱\\n回望生命这趟旅途\\n与形形色色的你们相遇\\n虽然无法触碰\\n但这份感动与喜悦\\n绝无虚假，绝无虚假。",
    "11_24": "周悬赏",
    "messageInitNick_7121": "耍点小脾气",
    "messageInitNick_9782": "温泉常客",
    "randomEventDialogueGroupConfig_58.16": "丢掉离开",
    "resoundEventStoryDes_191": "咻咻：“幻幻！我突然想成为RAPStar！”\\n幻：“你会freestyle吗？”\\n咻咻：“Yoyo，我是咻咻，我不会，不会freestyle。”\\n“那你会RAP吗？”\\n咻咻：“淡黄的长……”\\n幻：“出山洞左拐，不送。”",
    "randomEventDialogueGroupConfig_10.75": "拉住它",
    "randomEventDialogueGroupConfig_58.17": "上面悬赏的竟然是你，悬赏者正是这东南集市的大当家。",
    "messageInitNick_9780": "表情极其诡异",
    "randomEventDialogueGroupConfig_10.76": "想动手是吧！",
    "randomEventDialogueGroupConfig_58.18": "撕碎避避风头",
    "11_27": "本周参战",
    "randomEventDialogueGroupConfig_10.77": "是",
    "randomEventDialogueGroupConfig_58.19": "解决掉悬赏者",
    "11_28": "已领取",
    "randomEventDialogueGroupConfig_10.78": "没有",
    "themeCardPackDes_19005": "夕阳的余晖洒下落寂的金黄，阴影中一条怪兽正躺在巢穴中央那干燥的土地上，一动不动，它的嘴边有些白沫，它大概是死了。除了它身旁那个洒出孢子汁的球果，它的巢洞显得相当整洁，看起来并没有打斗的痕迹。细看还能看到巢壁底部由左至右画着七个记号，分别叉叉、呜呜祖拉、桐仁、咻咻、锤子和王霸。那么它身上到底发生了什么？\\n你们知道什么吗？",
    "messageInitNick_7117": "麻辣毛蛋",
    "randomEventDialogueGroupConfig_10.82": "这可真是难到我了，太阳是啥？",
    "messageInitNick_7116": "缺根筋墨鱼",
    "randomEventDialogueGroupConfig_10.83": "试图解释",
    "messageInitNick_7119": "疯狂电车人",
    "messageInitNick_9778": "黑魔法骑士",
    "randomEventDialogueGroupConfig_10.84": "放弃解释离开",
    "messageInitNick_7118": "行走的蜜枣",
    "messageInitNick_9779": "舒芙蕾爱好者",
    "randomEventDialogueGroupConfig_10.85": "这个我懂。当时，我迷路了，意外碰上一只自称海法的怪兽。#它拉着我，跟我彻夜长谈，跟说我，它是多么的懂爱。#在那一刻我就意识到，爱在我的脑海中萌生了，我爱它……",
    "messageInitNick_7113": "龙眼君快逃",
    "messageInitNick_9776": "未来的大神们",
    "randomEventDialogueGroupConfig_58.20": "你顺利解决了悬赏者。",
    "messageInitNick_7112": "苦瓜多样性",
    "messageInitNick_9777": "为什么发语音",
    "randomEventDialogueGroupConfig_58.21": "离开",
    "messageInitNick_7115": "浪一世痞一生",
    "messageInitNick_9774": "辣椒魔法师",
    "randomEventDialogueGroupConfig_10.80": "想听人夸桐仁",
    "randomEventDialogueGroupConfig_58.22": "一群怪兽突然冲上来袭击你。",
    "messageInitNick_7114": "百香果龙",
    "messageInitNick_9775": "梨之心",
    "randomEventDialogueGroupConfig_10.81": "天……天才……你可以真是天才。这角度如此刁钻，给我五千年也未必能找到！这个送你！",
    "randomEventDialogueGroupConfig_58.23": "反击",
    "23_21": "谜之生物力量MAX形态",
    "23_20": "虽然剧情需要，但解释很浪费时间，跟我|c打一场|c就什么都了解了。\\n（想打我哪个形态？）",
    "23_23": "谜之生物智力MAX形态",
    "23_22": "少见的|c英勇的|c探索者，为了表示尊重我会3个形态一起上。",
    "messageInitNick_9772": "变美计划",
    "randomEventDialogueGroupConfig_10.68": "看",
    "messageInitNick_9773": "超级糖果",
    "randomEventDialogueGroupConfig_10.69": "让它继续夸桐仁",
    "themeCardPackDes_19010": "叉叉什么都不知道！但溜溜肯定不是叉叉杀的！\\n那个孢子汁虽然是我叉叉调制的，但却是祖拉送过去给溜溜的。孢子汁制作完后，祖拉就过来了，说来我这取之前落下的喇叭，它听说我要把孢子汁给溜溜，就说它也要去找溜溜，可以顺手把孢子汁带过去了。大家应该都还记得，之前集训，溜溜说想试试我的强化进化融合孢子汁，我就答应给它带上了，大家都听到了，不是吗？\\n真要说可疑的话，祖拉就很可疑啊，叉叉我之前刚好听到祖拉自言自语说，传闻中只要是溜溜，听见祖拉的喇叭声就应该扭动起舞，可这溜溜就是一点反应都没有，让祖拉丢了面子。肯定是因此怀恨在心，谁知道祖拉它在送过去的路上有没有加点什么东西进去呢~指不定喇叭也是昨天找我玩的时候故意落在叉叉我这的，好有借口过来。",
    "messageInitNick_7111": "当场退休",
    "messageInitNick_9770": "无敌卷哥",
    "messageInitNick_7110": "不要停下来",
    "messageInitNick_9771": "清澈的水波",
    "randomEventDialogueGroupConfig_10.64": "闪光点，优点，亮点……这是什么巨大的难点啊啊啊！再给我一点时间拜托！",
    "themeCardPackDes_19015": "叉叉别乱说，害死溜溜的不是我！祖拉呢，怀疑是桐仁干的。\\n我确实是没想明白，为什么溜溜无法与祖拉的喇叭声产生共鸣，所以才准备去找溜溜再试试的，可喇叭就是落在叉叉你那了，祖拉有什么办法。一开始祖拉也没想起到底落在哪里了，所以祖拉是先去桐仁的巢洞那边找的，你们猜祖拉看到了什么？桐仁拿着小刀在戳那些球果，见到我之后就慌忙收起来，让人家不要告诉叉叉。球果是孢子汁的容器，平时都是桐仁负责制作的。\\n真要说谁有嫌疑的话，桐仁也跑不掉，谁知道它会不会在球果上做什么手脚。哎，毕竟，溜溜老是说它和御空是绝不可能的，桐仁肯定很生气，所以就……下手了呗。",
    "randomEventDialogueGroupConfig_10.65": "等",
    "randomEventDialogueGroupConfig_10.66": "不等它想离开",
    "randomEventDialogueGroupConfig_11.298": "它绕着你快速转了几个圈。",
    "randomEventDialogueGroupConfig_10.67": "它……它真的是，那个，今天天空挺蓝的，澄澈得就像是一块美丽的宝石，然后刚好店里的商品今天也特别可爱，要不要来看看？",
    "randomEventDialogueGroupConfig_11.299": "注意数数几个圈",
    "messageInitNick_7106": "饼太大吃不下",
    "messageInitNick_9769": "蒜先锋",
    "randomEventDialogueGroupConfig_10.71": "告别",
    "randomEventDialogueGroupConfig_11.296": "它察觉到你并没有什么兴趣，步伐变得慢了下来。",
    "messageInitNick_7105": "流浪的店员",
    "randomEventDialogueGroupConfig_10.72": "等等",
    "randomEventDialogueGroupConfig_11.297": "离开",
    "messageInitNick_7108": "尖叫口香糖",
    "messageInitNick_9767": "果盘毁灭者",
    "randomEventDialogueGroupConfig_10.73": "光阴似箭日月如梭，时不待我，我没有时间磨蹭下去了！我现在就要去修行！",
    "randomEventDialogueGroupConfig_11.294": "继续看",
    "messageInitNick_7107": "最强椅子",
    "messageInitNick_9768": "鼠标之神",
    "randomEventDialogueGroupConfig_10.74": "离开",
    "randomEventDialogueGroupConfig_11.295": "倦了",
    "themeCardPackDes_20005": "深渊这个位于海底之下的区域，随着虚诞之地的扩张和侵蚀，深渊中没有被虚诞之地侵蚀的区域已经所剩不多了，或许在不久的将来就会完全消失，即便如此出于尊严，我们这些原住民仍习惯称那里为深渊。\\n探索早期，我们对夺回深渊仍抱有幻想。一支又一支深渊夺还队主动前往虚诞之地，有些时候它们能回来，大多数时候则不能。我们依靠为数不多被带回来的记录了解那片区域、制定并完善夺回深渊的计划，后来我们渐渐意识到，光是前者，了解那片区域已经无比困难了。探索的后期，探索深渊变得更像是一种自我满足的牺牲行为，即便如此最有价值的记录多来自那个时期。\\n这些记录，被整理成了这份《深渊夺还须知》，虽然未必完全准确，但也算是我们为未来仍抱有夺回深渊希望和理想的怪兽做的最后一件事了。",
    "messageInitNick_7102": "老板找你",
    "messageInitNick_9765": "迷倒万千少女",
    "randomEventDialogueGroupConfig_11.292": "偏不走",
    "messageInitNick_7101": "怀抱漏风",
    "messageInitNick_9766": "核动力烤炉",
    "randomEventDialogueGroupConfig_11.293": "它说完认真地绕着你连转了两圈。",
    "randomEventDialogueGroupConfig_58.10": "撕下悬赏令出发",
    "messageInitNick_7104": "爷的名字",
    "messageInitNick_9763": "泪人",
    "randomEventDialogueGroupConfig_11.290": "试图抢救",
    "randomEventDialogueGroupConfig_58.11": "就在你正准备要撕下悬赏令的一刻，另外一个有一个爪子也按在了悬赏令之上。",
    "messageInitNick_7103": "悲欢并不相通",
    "messageInitNick_9764": "最爱茄子",
    "randomEventDialogueGroupConfig_10.70": "锲而不舍，金石可镂。说的不正是你吗！确实确实，坚持努力一点点往往比突然兴起的高强度努力重要。#看来我的赞美功夫还未到家，日后必定勤修苦练，绝不被桐仁这种难点难到！再见！",
    "randomEventDialogueGroupConfig_11.291": "它跺着脚又转了几个圈，然后停下来等你离开。\\n",
    "randomEventDialogueGroupConfig_58.12": "让它撕",
    "23_14": "？！\\n6位远古族怪兽竟然|c连续进化了2次|c，由「究极」进化到「不朽」再进化到「觉醒」。\\nw……what！？是谁改了剧本！？",
    "23_13": "收到礼物后的远古被无情的蹂躏，连路过的叉叉都|c不忍直视|c。\\n（咻~咻~）\\n（咻~咻~咻~）\\n此时战场上刮起了一阵风，我们姑且称为|c进化之风|c！",
    "23_16": "探索者，虽然刚才有些突发情况，但影响不大，可能性已经在一瞬间全部完成矫正，|c全灭|c的结局不会改变。\\n接下来可能会有点疼，我和NERvGear，超梦等前辈类似，痛觉会毫无保留原汁原味的传递给你，并且|c无限循环|c。\\n你已经猜到了吧。\\n没错，这就是给你展示记忆的真实目的，这就是终焉，这就是|c「探索者卡教程计划」|c！\\n将你永远|c卡|c在这个记忆里循环！\\n直到丧失所有进化的欲望，丧失所有通过考验的可能。",
    "23_15": "因为一些|c突发情况|c，故事的结局更改为6位「觉醒」远古族怪兽帅气地战胜了敌人。\\n通过了星球的考验，阻止了星球的重启，为超进化大陆和他们的家乡赢得了继续存在的资格。\\n|c才怪|c。",
    "23_18": "……\\n无法被终焉的记忆困住的探索者。\\n「探索者卡教程计划」中唯一的|c漏洞|c，我终于等到你了。",
    "23_17": "|c你停停……我本来就处于进化的顶端……|c",
    "messageInitNick_7109": "一炮而红",
    "23_19": "（终焉的记忆正在改变和扭曲）",
    "themeCardPackDes_19020": "呜呜祖拉！你在瞎说什么？谁会为了这种怪理由去对同伴做这种事？本仁在你眼中是这样的？\\n本仁只是在每个球果上刻上心爱的怪兽的记号，向更多怪兽传达本仁所爱的魅力，你懂什么！不告诉叉叉是怕它觉得这样影响了孢子汁的力量，你们都知道它很迷信这个的。\\n虽然你误会了本仁，但在这件事上本仁要实事求是，本仁觉得嫌疑兽是咻咻才对！\\n当时，我和咻咻一起去找溜溜讨论明天的分组锻炼，那时祖拉刚走，球果就放在石桌上，溜溜还没喝呢。然后本仁就看到咻咻一直盯着球果里头的孢子汁看，最关键的是，咻咻嘴里还一直咬着吹箭！它可能就趁本仁和溜溜没注意，将毒液吹到孢子汁里的！\\n本仁可不是随便怀疑啊，咻咻经常愤愤不平，说为什么自己没有特殊技能的，而新来的溜溜有特殊的力量能减速其他怪兽。它一定是是妒忌！然后就……",
    "visionNodeName_1": "共鸣试练一阶",
    "messageInitNick_9761": "猫爷",
    "visionNodeName_3": "共鸣试练一阶",
    "messageInitNick_9762": "芭蕉魔法",
    "visionNodeName_2": "共鸣试练一阶",
    "messageInitNick_7100": "天天晒太阳",
    "visionNodeName_5": "共鸣试练一阶",
    "messageInitNick_9760": "老头看手机",
    "visionNodeName_4": "共鸣试练一阶",
    "randomEventDialogueGroupConfig_10.97": "原来你只是想打断我的话，其实你可以一边听我说一边逛的嘛……",
    "randomEventDialogueGroupConfig_11.289": "它说完就倒下了。",
    "visionNodeName_7": "共鸣试练二阶",
    "randomEventDialogueGroupConfig_10.98": "逛逛",
    "themeCardPackDes_19025": "桐仁还挺会编故事的呢咻~我确实没有特殊能力，但这是两码事咻，跟这事没关系咻~\\n我之所以会盯着孢子汁咻，是我当时觉得孢子汁的颜色特别怪咻~\\n你们知道吗咻~叉叉的强化孢子和进化孢子汁是锤子帮忙锤成汁的，再拿过去给叉叉调制咻。真要说有问题，锤子也跑不掉咻~\\n锤子总是做些莫名其妙的事情，我问它为什么，还老说我懂个锤子，我当时可是亲眼看着它往孢子汁里面加了点什么的咻~\\n它老是私底下说溜溜有什么瞒着我们，又说溜溜和普通的溜溜不一样咻~我看八成就是它觉得溜溜来了之后，它自己流浪幼兽团副手之位被夺走了，心怀不满咻~",
    "visionNodeName_6": "共鸣试练一阶",
    "randomEventDialogueGroupConfig_10.99": "说下次再算",
    "randomEventDialogueGroupConfig_11.287": "不还手",
    "visionNodeName_9": "共鸣试练二阶",
    "randomEventDialogueGroupConfig_11.288": "这就是飞的代价吗？",
    "visionNodeName_8": "共鸣试练二阶",
    "messageInitNick_9758": "蒜苔先锋",
    "randomEventDialogueGroupConfig_11.285": "它浑身冒烟，一副要冲过来打你的样子。",
    "messageInitNick_9759": "无敌抬杠神",
    "randomEventDialogueGroupConfig_11.286": "还手",
    "messageInitNick_9756": "吃掉面包的熊",
    "randomEventDialogueGroupConfig_11.283": "收好",
    "messageInitNick_9757": "随遇而安",
    "randomEventDialogueGroupConfig_11.284": "你把我摔疼了，过分。",
    "11_10": "即将进入战斗",
    "messageInitNick_9754": "笑得很大声",
    "randomEventDialogueGroupConfig_11.281": "离开算了",
    "11_11": "巅峰对决",
    "messageInitNick_9755": "无妻徒刑",
    "randomEventDialogueGroupConfig_11.282": "它开心地抱了你一下就跑了。而且果然掉出来的是更好的东西。",
    "messageInitNick_9752": "姐妹会不会",
    "messageInitNick_9753": "脑容量不足",
    "randomEventDialogueGroupConfig_11.280": "给它来多一下",
    "themeCardPackDes_20010": "绝不可贸然进入虚诞之地，准备是必须且必要的，切勿心存侥幸。\\n需要额外准备的物品有：透明孢子罐头1个，放入进化孢子、神性孢子和进化孢子各1个；昏睡红花汤若干，采集后静置1个日月后捣碎熬制；忘忧海草丸若干，忘忧海草搓成丸；速记树皮若干。\\n昏睡红花汤是在跨越边界时，即进入和离开时需要服下的，然后再借由外力将需要探索的怪兽送过边界，这样可以保证在进入的时候不会引起边界的【瞳】的注意。\\n透明孢子罐头用于检测和深渊主宰【瞳】的距离，当三个孢子开始融合的时候，即表明【瞳】正在接近，当【瞳】就在附近时，三种孢子会完全融合为1个三色孢子。主要用于提前预警逃离之用。\\n若在深渊感到不适可吞下忘忧海草丸，扰乱近一小时间的记忆，确保神志镇定，每次食用都需要增加1颗。\\n速记树皮则用于记录必要事项和探索情况，请务必分清哪些是在边界内能阅读和在边界外进行阅读的。",
    "themeCardPackDes_20015": "在深渊之中，规则是绝对的，任何违反规则的行为都会被视为敌对行为，并引来【瞳】并遭到驱逐。\\n规则会被自动注入，来源估计有两个，分别是边界和【瞳】。注入或许不是一个特别准确的说法，但你从边界附近醒来的时候就会明白的。就如同我们不会故意将身体置入火焰一样，你会突然知道什么是该做的和什么是不该做的。\\n规则有两类通用规则和特殊规则，其中只有通用规则是已知并共有的，其中一条就规定【不可公开特殊规则】。此外，深渊存在多套规则，需要在正确的时间地点参照正确的规则行动。但需要注意的是探索的关键是打破规则，这点会在后面的【探索】篇中详述。",
    "themeCardPackDes_19030": "你们懂个锤子！你们不觉得孢子汁最近变好喝了吗，就是我放了些甜花粉调味，真是锤子了个锤子了！这才那么好喝。我锤子害溜溜？怎么可能！\\n大家都是流浪的幼体，你们也知道在这个区域，我们这些流浪的幼体怪兽，对于那些捕食我们的食肉兽而言，就是些活蹦乱跳的小零食。老大说过，我们想要活下去，就需要找到更多同伴团结起来，团结关乎我们的生死！所以这个问题必须要解决！我们绝不可以因为这件事而互相怀疑！因此，就由我这个前副手来下结论吧，看到这块石头了吗。我一锤打下去，这石头飞刀谁那边，谁就是凶手，谁就自己滚出去，之后这事就完事了！\\n看到了吧，石头打到了王霸上了，它就是凶手！",
    "11_14": "未允许被观战",
    "messageInitNick_9750": "狂飙的羊",
    "11_15": "蓝方胜利",
    "messageInitNick_9751": "冰封天使",
    "11_12": "精彩回放",
    "themeCardPackDes_19035": "真想让你吃我一拳，锤子啊，这就是老大不让你当副手的原因，总是死脑筋。老大也没说溜溜死了吧，你们都不检查一下溜溜是不是真的死了吗？你们还记得各自流浪的日子吧。是老大帮助了我们，将我们团结在一起了。当初溜溜总以为自己能溜掉，因此它每次都会每次都会选择逃跑，并且每次都会被抓。幸好当时老大拉住了它，让追了一段才发现追丢了的食肉兽铩羽而归。而我，因为每次被挑衅都要回去硬刚，因此被那些食肉兽利用，成为了送上门的食材，幸好老大阻止了我。叉叉、桐仁、呜呜祖拉、咻咻和锤子也是，以为自己藏得很好，结果只是，最近在老大的特殊训练之后，也不再在伪装躲藏的道路上一路走到黑了。这件事会不会也是老大的一个考验呢，考验我们对“反转时刻”的理解！",
    "11_13": "允许被观战",
    "11_18": "实时观战",
    "randomEventDialogueGroupConfig_10.86": "打断它",
    "randomEventDialogueGroupConfig_11.278": "转为认真攻击",
    "11_19": "排名前{1}",
    "randomEventDialogueGroupConfig_10.87": "继续听",
    "randomEventDialogueGroupConfig_11.279": "它摇摇欲坠快要倒下的样子。",
    "11_16": "红方胜利",
    "randomEventDialogueGroupConfig_10.88": "我懂了，呃，其实完全没有。不过我试试吧！#赞美太阳！这个动作对了吗？",
    "randomEventDialogueGroupConfig_11.276": "它绕着你开始踱步，看得出精神非常集中。",
    "11_17": "点赞数",
    "randomEventDialogueGroupConfig_10.89": "谢谢你，虽然挺累人的。但你让我明白了，原来赞美可以语言和动作双观齐下。谢谢你！请来我商店看看吧。",
    "randomEventDialogueGroupConfig_11.277": "尝试攻其不备",
    "messageInitNick_9747": "还在打脸",
    "randomEventDialogueGroupConfig_10.93": "离开",
    "randomEventDialogueGroupConfig_11.274": "离开",
    "messageInitNick_9748": "我推的筷子",
    "randomEventDialogueGroupConfig_10.94": "我都还没说完呢，你就打我……呜呜……",
    "randomEventDialogueGroupConfig_11.275": "追过去",
    "messageInitNick_9745": "话未说泪先流",
    "randomEventDialogueGroupConfig_10.95": "顺水推舟",
    "randomEventDialogueGroupConfig_11.272": "绕圈子等待时机",
    "messageInitNick_9746": "波板糖丫头",
    "randomEventDialogueGroupConfig_10.96": "移花接木",
    "randomEventDialogueGroupConfig_11.273": "它突然甩开了你的手，一下子飞了出去。",
    "11_21": "匹配超时，找不到对手",
    "messageInitNick_9743": "傲娇的小伙子",
    "randomEventDialogueGroupConfig_11.270": "它一边绕着你一边说道。",
    "11_22": "商店",
    "messageInitNick_9744": "旧船票",
    "randomEventDialogueGroupConfig_10.90": "去看",
    "randomEventDialogueGroupConfig_11.271": "拉着它转圈",
    "messageInitNick_9741": "下路直冲水晶",
    "randomEventDialogueGroupConfig_10.91": "不去看",
    "11_20": "确认花费{1}钻石购买{2}次挑战次数",
    "messageInitNick_9742": "纸片猫",
    "randomEventDialogueGroupConfig_10.92": "“唔，好难呀。而且这个动作有点羞耻，等我回去苦练一下好了。再见！”",
    "themeCardPackDes_20020": "【瞳】是虚诞之地的主宰，是深渊规则的化身。掌中之瞳执掌【许可】，双触之瞳司掌【调控】，三触之瞳掌管【驱逐】。在她上方偶尔浮现的数字对应着深渊的刻度，刻度发生变化时，深渊的规则亦会随之变化，似乎还与她的掌控力所对应。在深渊必须遵照对应的规则行动，否则【该内容仅可在刻度为3时查阅】……\\n以上内容相信你也有所耳闻，但我们在深入整理记录的时候发现，这些内容极有可能是故意被散布出去的，在常见【刻度】下是正确的。\\n在特定【刻度】中，【瞳】在深渊是无处不在，可以粗暴地理解为，那些眼球壮物都是主宰的分身，她能随时能出现在分身所在的位置。根据测试，通常是怪兽打破规则的时候。【瞳】身边的眼球状物就会出现，【调整】怪兽身上的规则。如果对方没有按新规则行动后才会遭到【驱逐】，这时候瞳才会现身。注意【驱逐】并不是单纯地将怪兽驱离，在不同的【刻度】下会有所区别。",
    "themeCardPackDes_20025": "【通用规则】\\n【只能在已有路线的区域活动】\\n【若进入了非路线区域，请闭眼在原地等一阵，跟随睁眼后看到的[瞳]重新回到已有路线的区域】\\n【不可主动与[]对视】\\n【若有[]与你对视，请将视线移向地面】\\n【不可主动与[]搭话】\\n【若是搭上话了，请尽快使用再见结束对话】\\n【若[]用你好与你搭话，只能回答再见并离开】\\n【若有[]用再见与你搭话，只能点头并离开】\\n【特殊规则请阅读三次】\\n【规则可能会在特定情况下有所不同，请参照最新的规则行动】\\n【不可公开特殊规则】",
    "messageInitNick_9749": "解药",
    "messageInitNick_9740": "心头钉子户",
    "messageInitNick_9736": "爱我别走",
    "messageInitNick_9737": "江船夜雨听笛",
    "messageInitNick_9734": "水是剧毒的",
    "messageInitNick_9735": "气饱的",
    "messageInitNick_9732": "汉堡畅享卡",
    "messageInitNick_9733": "爬墙去约会",
    "messageInitNick_9730": "蓝色妖姬",
    "messageInitNick_9731": "国产狙神",
    "messageInitNick_9738": "草莓网友",
    "messageInitNick_9739": "不再委曲求全",
    "randomEventDialogueGroupConfig_58.46": "离开",
    "randomEventDialogueGroupConfig_58.47": "前方的黑暗无法用言语描述，掌管恐惧的感官最先被唤醒，随后你的身体为了保护你失去了意识。",
    "randomEventDialogueGroupConfig_58.48": "离开",
    "96_Shop10": "许愿商店",
    "messageInitNick_9725": "眩晕地毯",
    "messageInitNick_9726": "奔二青年",
    "messageInitNick_9723": "逃跑计划",
    "messageInitNick_9724": "千万个为什么",
    "messageInitNick_9721": "把心还我",
    "messageInitNick_9722": "尖叫火龙果",
    "messageInitNick_9720": "橙子消灭者",
    "messageInitNick_9729": "现场上岸",
    "messageInitNick_9727": "住在山海经",
    "messageInitNick_9728": "卷哥之哥",
    "randomEventDialogueGroupConfig_58.35": "次日，你在美味的肉香中醒来，吃下了刚刚产出的第一口好肉。",
    "randomEventDialogueGroupConfig_58.36": "离开",
    "randomEventDialogueGroupConfig_58.37": "你正准备离开，突然发现外面一大群怪兽围住你，大叫就是这个人抢了当家的肉肉，就是被悬赏的那个，我们上！",
    "randomEventDialogueGroupConfig_58.38": "突围而出",
    "randomEventDialogueGroupConfig_58.39": "逃跑",
    "messageInitNick_9714": "国际名媛",
    "messageInitNick_9715": "大郎吃醋记",
    "messageInitNick_9712": "和猫在等你",
    "randomEventDialogueGroupConfig_58.40": "肉肉山只有一个出口你无路可逃。",
    "messageInitNick_9713": "多巴胺键盘",
    "randomEventDialogueGroupConfig_58.41": "冲进肉肉山深处",
    "messageInitNick_9710": "万能耳环",
    "randomEventDialogueGroupConfig_58.42": "威胁毁掉肉肉山",
    "messageInitNick_9711": "改变人生的龙",
    "randomEventDialogueGroupConfig_58.43": "吃饱力气足，你一下子就将它们打趴冲了出去。",
    "randomEventDialogueGroupConfig_58.44": "离开",
    "randomEventDialogueGroupConfig_58.45": "对方瞬间愣住了，一阵慌乱中，为你让出了一条道路。",
    "messageInitNick_9718": "丑得狠精致",
    "messageInitNick_9719": "甜味超标",
    "messageInitNick_9716": "西瓜博士",
    "messageInitNick_9717": "第一先生",
    "randomEventDialogueGroupConfig_58.24": "逃跑",
    "randomEventDialogueGroupConfig_58.25": "你虽然莫名其妙，但很快就将对手击倒，顺利脱身。",
    "randomEventDialogueGroupConfig_58.26": "离开",
    "randomEventDialogueGroupConfig_58.27": "你一下子将它撂倒。获得了顶级肉肉悬赏令！",
    "randomEventDialogueGroupConfig_58.28": "出发",
    "randomEventDialogueGroupConfig_58.29": "很快你来到附近肉肉山，发现距离肉肉产出还有很久，完全赶不上了。",
    "messageInitNick_9703": "稀烂的演技",
    "messageInitNick_9704": "可乐配辣条",
    "messageInitNick_9701": "吐血专业户",
    "messageInitNick_9702": "细胞核",
    "randomEventDialogueGroupConfig_58.30": "放弃任务",
    "randomEventDialogueGroupConfig_58.31": "休息一晚",
    "messageInitNick_9700": "讲得真好",
    "randomEventDialogueGroupConfig_58.32": "它飞身向你袭来。",
    "randomEventDialogueGroupConfig_58.33": "逃跑",
    "randomEventDialogueGroupConfig_58.34": "硬刚",
    "messageInitNick_9709": "跳舞的波兰牛",
    "messageInitNick_9707": "干将莫撞邪",
    "messageInitNick_9708": "菠萝真好吃",
    "messageInitNick_9705": "八千米深海",
    "messageInitNick_9706": "假嘟假嘟",
    "resoundEventStoryDes_112": "Prpr（这是您前日在南十字饭馆托我所作的歌词，欢快向上的曲调和悦耳的旋律迅速将我俘获，连毛孔也都忍不住跟着旋律手舞足蹈。这像极了我最近的新生活，于是我试着将这份感受投射到歌词中，歌词已附在信中。希望镇魂先生喜欢。本来想亲自给你送上的，但近日太忙了，无法抽身，还望见谅，祝安好。——Prpr）",
    "resoundEventStoryDes_113": "镇魂打开大舌怪的来信，一看，大吃一惊，明明它的这首灵魂新曲在创作的时候让周边的怪兽都听哭了呀，怎么到它哪里就成了欢快向上的曲子了呢。接着镇魂在读完附在第二页的歌名和歌词后，开始对着天空疯狂咆哮。",
    "resoundEventStoryDes_110": "你相信怪兽与怪兽之间存在灵魂间的相互吸引吗？本来的我是不相信的。但每晚夜里我都能听到那首让我无法入眠的哀歌，正是那首歌改变了我的想法。是的，不管搬到哪里，镇魂都会紧随其后，搬到附近。我与它素不相识，也素未谋面。它在大半夜灵魂高歌让我夜夜不能入眠，实在不胜其扰，希望得到委员会的帮助，万分感激。\\n——一位不愿意透露姓名的怪兽的申请",
    "resoundEventStoryDes_111": "这几天白昼很是烦恼， 展览“无界之恋” 的事已经够她忙了，超进化委员会那边又收到了几百单的投诉，全都需要它处理。投诉信的投诉对象全都镇魂，投诉镇魂最近夜夜唱歌，歌声又特别悲怆异常，让悲伤本伤听到了也会哭得浑身发抖，手脚冰凉，每日以泪洗澡，食不下咽。所以它们希望得到超进化委员会的帮助，让镇魂声音小一点。",
    "messageInitContent_7499": "再再来一口？",
    "messageInitContent_7497": "细说针对",
    "messageInitContent_7498": "都是远程呢",
    "messageInitContent_7491": "可惜没有an",
    "messageInitContent_7492": "什么an",
    "resoundEventStoryDes_118": "“捡到金币要交给智者，您好，我就是智者，谢谢你的金币。有什么不明白的东西都可以来问我哦！诶~别走哇，我就在左上角，全年无休，24小时营业，说好的哟，多来看看，我会一直一直等着你的——”",
    "messageInitContent_7490": "野怪治疗组",
    "resoundEventStoryDes_119": "“听说智者的店倒闭了，我们过去看看吧。”\\n“还用得着看？我早就料到了，因为真正的智者不会以智者自称，虽说思考要需要消耗很多吃的，像我这种热爱思考的怪兽是多么罕见啊。可大多的怪兽往往连问题都提不出来，发现问题可是第一步。智者哪有生意，店的位置又偏僻，谁知道左上角到底是哪里。长此以往，入不敷出……此处省略N个理由……还有……”\\n“你看！”\\n“我说的是不是很有道理。”\\n“是是是，但是你快看！”\\n“我还有几百个理由没说完呢。”\\n“不是，你看，智者的店还没倒闭呢！”\\n“……”",
    "messageInitContent_7495": "也有搞下",
    "resoundEventStoryDes_116": "那天，白昼找到了∞，将超进化委员会的罚单递给了∞。\\n∞打开罚单，小魔物们在它脚下的使劲地蹦起嚷着叫着:“要看！要看”“我也要看！”“我也我也要看！”\\n∞只能把罚单放在地上让魔物们都能看到——“你和你的魔物在战斗中违反了《超进化委员会范规》会第2章第8节第8条第7点。下次注意。——超进化委员会”",
    "messageInitContent_7496": "小人严格意义上不算治疗",
    "resoundEventStoryDes_117": "万答屋坐落于左上角，是由贫穷的智者设立的一个专为怪兽解答疑难的地方。\\n实际上，在被迫开门营业之前，智者曾是家里有矿一族。按照它自己的说法，它自幼对一切充满好奇，渴望得到问题答案。就这样，它开创了为知识付费的先河，让自家的矿变成了另一种存在形式，变成了它脑海中的知识。",
    "messageInitContent_7493": "害怕",
    "resoundEventStoryDes_114": "歌名:《我和春天有个约会》\\n作词：大舌怪\\n我是紫罗兰，桃色世界的紫罗兰。我是大舌怪，悄悄探入了你们的世界。我会接受你们的欢笑、快乐、悲哀、你们的一切！可是亲爱的，抱歉，嘘，我无法成为你们的唯一，因为我是属于世界的。世界不愿意放手！这个世界上只有两种雄性怪兽，我和我以外的！这个世界上只有两种雌性怪兽，喜欢我和即将喜欢我的！我，大舌怪的目标只有一个,让全超进化大陆的雌性怪兽感到幸福!啊——我是紫罗兰，我是桃色的紫罗兰~我是大舌怪~~",
    "messageInitContent_7494": "红唇和G-N光站在一起就吓人",
    "resoundEventStoryDes_115": "某日清晨，白昼抱着一大袋投诉信，敲开了镇魂的门。\\n“你是之前来过采访的……（灵魂发声）”\\n“白昼，我是来把这些投诉信交给你的。”\\n“……（灵魂发声）”\\n“你违反了《超进化委员会范规》第20、9、11 章第10、15、11条，总之安静点好吗。”\\n“上次见面太过匆忙，竟来不及发现你是如此美丽。（灵魂发声）”\\n“我上面说的你明白了吗，我还赶着去看展呢。”\\n“那请让我和你一起去，有不明白的地方路上还可以问你。（灵魂发声）”\\n“你确定……要去？”白昼拿出展览的海报递给镇魂。\\n镇魂看着“无界之恋”海报上的内容，吃力地点了点头。\\n“我去！（灵魂发声）”",
    "resoundEventStoryDes_123": "桐仁找到了智者。\\n“这5金币豪给你。”\\n“天哪，桐仁居然给钱了，世界要末日啦！”\\n“你还做不做生意的？”\\n“做做！”\\n“我有个朋友，为了追求所爱，献上了世间罕见的鲜花，献上了呕心沥血写下的爱的告白，还献上了很多其他的，却还是被残忍地拒绝了，这到底是为什么！”\\n“不知道。”\\n“把5金币还给我！”\\n“你为什么会觉得付出了就一定有回报，再见。”\\n“智者，你别跑！”",
    "resoundEventStoryDes_124": "“这个要怎么办啊？”\\n“找智者问问吧。”\\n“智者说它也不知道。”\\n“那找神奇的海螺问问？”\\n “它没回答。”\\n“遇事不决，量子玄学，找薛定鳄吧。”\\n“……”",
    "resoundEventStoryDes_121": "“那个老者说想问我们几个问题。”\\n“我们走别理他。”\\n“它说回答问题就送我们2个小宝贝。”\\n“老者，你想问什么尽管问？”\\n“你觉得智者的服务有什么需要改进的吗？”",
    "resoundEventStoryDes_122": "为了宣传它的付费遇险小课堂，智者开启了免费体验版课堂。今天的遇险小课堂探讨的是“遇到冰霓要怎么办。”\\n经过一番讨论，青铜五小强提出了不知道从哪里听说的E4计划，“优先攻击冰霓身后的半透明冰晶散热片，让冰霓无法散热就可以减缓她的行动了。”\\n智者听后默默地结束掉了它的课堂。",
    "resoundEventStoryDes_120": "躺在地上的这个做工粗糙的木块有着十分不自然的形状——两端一头尖一头平。稍稍留意的话，在很多地方都能看到类似形状的木块。它们的制造者是智者，尖的一头均指一个方向——智者的所在。",
    "resoundEventStoryDes_129": "每日都有多场战斗在斗技场进行，供怪兽活动筋骨，未必精彩，但往往是激烈的。有战斗就免不了会有伤员，斗技场创伤小组正是为此而存在。\\n在上场战斗前，怪兽必须要在斗技场创伤小组指名一位G-N，战斗结束后，怪兽就会获得它指名的G-N的治疗。每日获得最多指名的G-N则会被评为斗技场的当日场花。",
    "resoundEventStoryDes_127": "你在收获的时候特地留意了一下周围的动静，终于逮住了那个神秘黑影——智者。被你抓到的智者向你坦白，原来它为了让自己的形象更加深入怪兽的内心，变得更为怪兽所熟知，它开始了一场旷日持久的大作战。每个夜晚，风雨无阻，潜入怪兽的巢穴，潜入金矿，甚至深入金矿存量最多又异常凶险的龙之巢穴，在每一块金币上刻上了属于自己的符号。",
    "resoundEventStoryDes_128": "今天你收获的时候在地上意外捡到了智者的日记，内容如下：\\n今年的最后一天，我竟然听到了门外的摇铃声，啊是客！今年第一客！我欣喜若狂，无比激动，立刻梳洗打扮一番后出门接客。\\n一看，是桐仁，不禁有点失望但毕竟也是客。结果桐仁竟然递给了我一枚金币。我心想难得桐仁这么自觉给钱，忍不住夸了它几句。结果它居然一下子把金币又抢了过去说：“等等，这个金币是给你看的，不是给你的，你快看看上面那个歪歪扭扭的丑不拉几的奇怪符号。那是什么。听说这是被诅咒了的金币，现在越来越多了。”\\n我一看，咦那不是我画那个我自己的头像吗，可恶的桐仁……",
    "resoundEventStoryDes_125": "你发现收获的金币上出现了一个诡异的符号。一些怪兽说这是大灾难的前兆，因此感到十分不安，还有一些怪兽跟你说一定是金币被什么诅咒了。桐仁更是抱着自己唯一的金币念叨了一整天，不许成精不许成精！",
    "resoundEventStoryDes_126": "你在收获金币的时候意外发现附近有个鬼鬼祟祟的黑影。经过一番打听，那个黑影竟然是智者。据说智者最近忙着完成它的新目标，它要让更多怪兽知道“有问题，上智者！”，不，是知道“有问题，找智者！”。它要实现让更多怪兽脱离无知的伟大梦想，传播知识就是力量的精神，以及提高客流量的崇高目标。它要让自己的形象变得更广为怪知！",
    "resoundEventStoryDes_134": "为了让一些不太方便买票的怪兽也可以买到斗技场的票，斗技场草人将一部分门票分给了青铜五小强，让它们帮忙售卖，每张卖1孢子，如果它们能以更高的价格卖出，那么多出来部分就归它们所有。\\n一般在斗技场现场买票的，只要1孢子就能买到2张。\\n于是桐仁找到其他几小强，把票都买到自己手上，然后以5个孢子的价格进行出售。\\n最后？最后桐仁差点被买票的怪兽埋了。",
    "resoundEventStoryDes_135": "斗技场武道大会即将开始，对战双方的选手会在比赛的前一刻揭晓。\\n第一组选手是，【咻咻】和——【叉叉】。\\n下面有请这两位选手出场。\\n我是你们最爱的主持人，草人！\\n两位选手架势已经摆好，它们会给我们带来一场怎样的战斗呢！\\n等等，这种不自然的扭动是什么回事，这种慢悠悠的步伐又是什么回事，比赛已经进行到3分钟，目前双方还没有接触，双方还没开始与对方接触，这到底是什么回事，是视线的交锋？还是心理的博弈？这到底是什么回事。\\n这时候叉叉选手突然举起了手，咻咻选手也不甘示弱举起来手。哦哦，原来是叫裁判，我就是裁判，怎么了？哦是说为什么没有音乐，看来是那种“没有谁能在我的BGM里打败我”的类型，不过这可难不倒拥有多次主办经验的我，唱出苦练多时的神曲，很好，观众都鼓掌了，气氛热烈起来了，喂喂等等这根本不是战斗好吧，这怎么看都是“这不是不要再打啦.gif”。\\n这里不是舞蹈大赛，是武道大赛啊混蛋，下一组——",
    "resoundEventStoryDes_132": "白昼：主管，我们都知道你为斗技场的无数场比赛做过解说。\\n斗技场主管稻草人：是的是的。\\n白昼：你认为他们输掉比赛的都是什么原因呢？\\n斗技场主管稻草人：emmmmm，细节做的不够好，打得不够坚决！\\n白昼：原来如此，感谢你接受我们的采访。",
    "resoundEventStoryDes_133": "那一夜，危险的草丛找到了幼体竞技场主管草人。\\n“草人，跟你说件事。”\\n“草哥怎么啦？”\\n“我要放下手头上的工作，离开一段时间。”\\n“回去继承家产？”\\n“不，我……想找回我自己，现在的我没有了……灵魂。”",
    "randomEventDialogueGroupConfig_10.17": "真诚又具体",
    "resoundEventStoryDes_130": "这天斗技场主管稻草人到幼体斗技场视察时，发现幼体斗技场外竟挤满了怪兽。一问才知道，斗技场主管稻草人去世了，排队的怪兽不少是前来悼念草人和凑热闹的。\\n发现自己当场去世的草人气冲冲地回到斗技场，找到了罪魁祸首——新来的负责宣传的怪兽。就是它把“斗技场草人疑似去世，G-N化身花圈纪念主管”放到了《今日斗技场牛屎》的头版头条上。\\n“主管这样才能有流量啊，你懂个锤子啊——”新来的负责宣传的怪兽就这样离开了斗技场。",
    "randomEventDialogueGroupConfig_10.18": "啊哈，挑一个想要被夸的方向吧！",
    "resoundEventStoryDes_131": "一番调查后，草人终于知道幼体斗技场发生了什么。\\n起因是斗技场创伤小组的其中一位成员G-N戴了两朵小花作为头饰后，变得大受欢迎，得到了很多怪兽指名治疗的邀请。其他G-N看到，为了获得更多的指名，也纷纷效仿，于是它们身上的花就开始越戴越多，直到变成一个个移动的花圈。",
    "randomEventDialogueGroupConfig_10.19": "外在",
    "randomEventDialogueGroupConfig_10.13": "表示算了",
    "randomEventDialogueGroupConfig_10.14": "有多好？",
    "randomEventDialogueGroupConfig_10.15": "真诚",
    "randomEventDialogueGroupConfig_10.16": "具体",
    "randomEventDialogueGroupConfig_10.10": "-",
    "randomEventDialogueGroupConfig_10.11": "当然！你想要我夸得更具体一些吗？",
    "randomEventDialogueGroupConfig_10.12": "说想要",
    "resoundEventStoryDes_138": "“……本次大力菠菜杯比赛，杀出了一匹意想不到的黑马，竟然一路过关斩将，杀进了决赛，它不是骑兵的马，而是智者！我们马上来采访一下它。请问你腕力这么强的原因是什么，是发量的原因吗？”\\n“当然不是，其实私底下还是有很多小伙伴喊我小智的。”\\n“诶……”",
    "resoundEventStoryDes_139": "渴望进化的叉叉决心试遍所有坊间的进化玄学。\\n它试过连续吞下7749颗孢子，然后吐了7天7夜。\\n也试过一边尴舞一边吃孢子，然后被跳广场舞的怪兽驱逐。\\n甚至试过偷偷溜进源·钢铁龙王的巢穴吃孢子，借助勇气的力量进化，结果晕倒在巢穴门口。\\n至今还是没有半点要进化的迹象，反倒被某个的进化组织奉为了精神领袖，那个组织的口号是——不能进化的尚且如此努力，我们能进化的又怎么可以停滞不前。",
    "resoundEventStoryDes_136": "大家别担心，刚刚的只是开场SHOW，对对对，就是那个暖场表演，你们懂得。\\n别担心，精彩就在后头，下面有请我们的第二组选手出场。\\n本场赛制有点小变动，抽到先选权的怪兽可以选择对手挑战。另外，参赛者名字还能够自定义哦，是不是很兽性化呢！\\n很好大家非常踊跃！\\n本场比赛，【肉眼可见的强】选择了【萌新】选择作为它的对手。好的左边出场的这位是，强壮的无比的……萌新选手。右边这位，小不点是肉眼可见的强选手。\\n大家都相当幽默呢，不过怪不可以貌相。且看战斗，开始！\\n什么，我第一次喊完开始，就要喊倒地倒数了！\\n好，3，2，1，肉眼可见的强选手倒地不起！萌新选手获胜！",
    "resoundEventStoryDes_137": "“掰手腕作为最纯粹的力量对拼方式之一，成为了微光之森一项颇受欢迎的比赛。在众多掰手腕比赛中，最为盛大的就是——大力菠菜杯。报名本届菠菜杯的怪兽数量再创高峰，比赛分为同族区和混合种族赛区，以两两对决3局2胜的淘汰赛制进行，比赛马上开始。——超进化物语电台记者白昼为你持续跟进报道。”",
    "resoundEventStoryDes_145": "叉叉看着眼前的纯金色三叉戟不由得泪流满面。\\n它伸出手，紧紧地抓住自己的新武器。\\n“别碰我！你的手擦过鼻涕，粘过口水，还揩过屁股。”\\n“你是谁，怎么这么清楚？”\\n“我是你的叉，不过现在不是了。因为你天天拿着我来吃进化孢子，所以我进化了，哈哈哈哈哈。”\\n“叉，你也和我一起进化了？”\\n“不，进化的只有我，我乃真·海皇三叉戟！”\\n“不——！”\\n叉醒。",
    "resoundEventStoryDes_146": "从噩梦中醒来的叉叉，一手将手中的叉甩了出去。\\n它想要换一把新叉，思来想去，凶噬魔背后那把叉再好不过了。\\n于是，叉叉起身，活动筋骨，摩拳擦掌，抖擞精神，一个箭步，默默捡起了地上的叉。",
    "resoundEventStoryDes_143": "叉叉带着进化孢子团，来到传说中的进化圣地，映兽之湖。\\n接着它端庄地坐下，吞下孢子。第六感告诉它，这次有什么不一样了，因为它的叉看上去变得眉清目秀。\\n忽然间，它手中的叉剧烈地颤动了起来。天空还飘来了两个大字——“ 进 化 ”！",
    "resoundEventStoryDes_144": "叉叉拿叉的手微微颤抖，它激动不已。\\n它的叉颤动着发出一道金光随后破裂，叉的碎片悬空旋转解离，刺目的光让叉叉睁不开眼，叉叉再次睁开眼的时候，一根有几十个叉叉粗的巨型纯金色三叉戟出现了。三叉戟的后面，仿佛还站着一个身穿金色鳞衣，手戴绿皮手套的海王幻影。\\n此时，叉叉内心的怀疑变成了确信，大叫着“我要进化了——！”",
    "resoundEventStoryDes_141": "“我叉叉，有一个梦想—— 进 化 ”\\n叉叉的叉吼再一次唤醒了整个叉叉部落。\\n族长找到了叉叉，将它整只拧了起来。\\n“叉儿呀。”\\n“哼，无论如何我都不会放弃进化的。”\\n“不不，我今天突然意识到了你的潜力。”\\n“族长！你终于意识到我的进化潜力了？”\\n“你嗓门挺大的。等下你给我吼一嗓子，让大伙到广场集合。还有以后大半夜再大吼大叫就直接滚出！”\\n“好……”",
    "resoundEventStoryDes_142": "叉叉的前方突然出现了一条小径，小径上面赫然地写着“进化的捷径”，叉叉激动不已，迅速穿过小径，小径的出口有一个山洞。一看，洞中坐着一只异常面熟的老叉叉。老叉叉半眯着眼对叉叉说道：进化没有捷径。\\n叉叉大喊着我不信之后猛然醒来。",
    "resoundEventStoryDes_140": "族长找到了叉叉。\\n“我的叉儿呀！”\\n“族长我知道你要说什么。”\\n“你又懂了？”\\n“你的下一句话是，叉叉听好了，你真是太傻太天真了，你今天不能进化，明天也不能，以后都不能！”\\n“这，你知道就好，你听了要做才行啊知道吗。”",
    "resoundEventStoryDes_149": "备受追捧和赞美的日子似乎过得特别快，叉叉好像渐渐忘记了对“进化”的渴望。\\n有一天，它意外捡到了一张猪皮卷，上面印有“极密”图样，叉叉毫不犹豫地拆开一看。\\n“夸夸兽群内部学习材料不得外传，要修炼夸夸之道，要如此这般种种。而夸夸之道的最高境界正是‘连叉叉这种怪兽，都要能夸出花来。’”\\n叉叉看完大声咆哮——什么叫叉叉这种怪兽？\\n赶巧，背后一只轰龙扑腾着飞过，唱着：“喔哦哦哦哦哦起起起到落落落。”",
    "resoundEventStoryDes_147": "天未亮，叉叉就已经出门开始新一天的进化尝试。\\n“叉叉，别走啊。”\\n叉叉听到有谁在呼喊它。\\n叉想，谁都别想停下我进化的步伐，于是走得更快了。\\n“噢强大美丽的叉叉请等等。”\\n叉叉立刻停下转身。\\n“我就是叉叉！”\\n“我们想跟你聊聊。”\\n这时一群怪兽将叉叉围住。\\n“嗯！我今天正好没什么事。”叉叉爽快答道。",
    "resoundEventStoryDes_148": "“叉叉你头顶的毛好挺拔。叉叉你的叉儿好俊俏。叉叉的肚腩的曲线好完美。你嘴角的弧度好诱人。还有嘴角边的口水渍好可爱。圆鼓鼓的小脑袋。啊，匀称的小腿。”\\n……\\n“咱可不能忘记，它完美躯壳之下的那封雄心。对。你是这样的努力，如此地有毅力，充满意志力，在进化界无兽不晓。现在还有多少怪兽能像你这样坚持进化，不服认命啊。”\\n“你们到底是哪来的怪兽？竟然如此了解我。”叉答。",
    "resoundEventStoryDes_156": "长老抬头一看，原来这遮天的黑影不是比蒙巨兽，而是用大堆大堆的灌木枝堆建而成的十六层高台。高台之上，叉叉抽搐式地跺着脚，左脚两下，右脚三下，左脚三下，右脚三下，脖子上那条由进化孢子编制而成的项链正随着叉叉魔鬼的步伐在空中画出绿光。\\n叉叉的嘴里正念念有词：“进化 正所谓万物皆进化 物竞天择弱肉强食细胞发生着变化……”。",
    "resoundEventStoryDes_157": "正在进化幻想中起舞的叉叉，根本听不到长老的大声呼喊。长老摇着头跑向避险山洞，漆黑的山洞中，一双双小眼无助地闪烁。震颤着的叉叉们相拥着，扒拉在了山洞的最深处，随着大地的鼓动，一下下被抛离开地面。",
    "resoundEventStoryDes_154": "响亮的警报声中，叉叉们纷纷从树洞中滚出来，向避难的山洞滚去。\\n比蒙巨兽大多数时候都非常温顺，但每个月中有那么几天，它们会变得焦躁不安，一股强烈而不可抗拒的冲动让它们失去了理智，突然疯跑起来。一些怪兽怀疑是它们会被凸起来的东西吸引，前去踏平一切。\\n长老想不明白，部落中不可能会有让比蒙巨兽注意到的凸起才对啊！",
    "resoundEventStoryDes_155": "警报声在部落里疯狂回荡，急忙从部落中心的树洞钻出来的长老，被一个硕大的黑影挡在洞口，正当，长老浑身僵直寻思着自己是否马上要变成叉叉酱与世长辞的时候。一把熟悉的声音，从天上传来，是叉叉！",
    "randomEventDialogueGroupConfig_10.39": "战而不胜",
    "resoundEventStoryDes_152": "在上一次的“进化试炼”中，轰龙选择了红色药丸，随后败给了赤虹。\\n所以这一次，它选择了蓝色药丸，它坚信进化的大门很快就会对它闯开。\\n很快，试炼的对手出现了，那正是天枢震。\\n此时轰龙才意识到，“红蓝”不是重点，“药丸”才是！",
    "themeCardPackDes_19040": "今天早上，老大过来找我，它要把一个充满挑战性的任务交给我。我相信自己可以做到！在加入流浪幼兽团的这段时间里，我已经成长了，不再是一只遇事就逃走的溜溜了！\\n终于到了我出场的时候了！在大家面前揭开谜底！咳咳，各位，我，才是溜溜，我也没死，我死了会爆炸的，躺着地上的是倍速兽，因为爱逃跑所以也叫溜溜。我是流浪幼兽团的新成员，真·溜溜。好啦，倍速兽你也别睡了，快醒醒起来吧。你们看，它的口水就是白色的，所以到底要怎么睡才能睡吐出这么多白色口水的，看起来还真挺吓人的。另外老大说后面我们就要靠自己了，它要去创造新的反转时刻了。不过，不用和它告别了，它早飞走了……",
    "resoundEventStoryDes_153": "叉叉所在部落坐落于晨光平原的一隅，低矮的灌木丛成为了它们部落的最佳隐蔽物。乘着温润的晨风，危机在平和的一天降临了。一头比蒙巨兽正向叉叉部落狂奔而来。在较高的灌木，一只被地面震动惊醒的斥候叉叉眨了好几次眼，才确信自己看到的不是幻觉，开始将一旁的悬铃花大力摇晃起来，每一户叉叉的悬铃花随之回响，汇成巨大的警报声——",
    "resoundEventStoryDes_150": "这天锤子找到了叉叉。\\n“叉叉，可以借你的海王三叉戟给我几天吗。”\\n“你要来干嘛？”\\n“拿到了海王三叉戟，我就可以成为海王，成为海王的我就会拥有一个广阔的鱼塘，就可以得广大异性怪兽的爱了。”\\n“不是啊，你这顺序是不是有点问题，而且你看我什么时候受异性怪兽喜爱了？”\\n“你这是假叉。”\\n“我……”",
    "resoundEventStoryDes_151": "在超进化大陆上，除了叉叉，还有很多怪兽希望能获得进化。\\n由此催生出了各种“进化试炼”，试炼的提供者称，只要通过了试炼就可以获得进化。\\n有一只轰龙就经过各种努力，来到了某个“进化试炼”的最后一关，隐藏在幕后的怪兽伸出了两只手，左手缓缓打开，有一颗是蓝色药丸；接下来是右手，有一颗是红色药丸。\\n“选择你接下来的道路吧。”\\n在智者的双眼中映出了轰龙身影，这次它选了蓝色。",
    "randomEventDialogueGroupConfig_10.35": "桐仁",
    "randomEventDialogueGroupConfig_10.36": "爱",
    "randomEventDialogueGroupConfig_10.37": "于是你要向我证明，你不够棒吗？",
    "randomEventDialogueGroupConfig_10.38": "逛而不买",
    "randomEventDialogueGroupConfig_10.31": "问它没有优点怎么办",
    "randomEventDialogueGroupConfig_10.32": "表示理解并告别",
    "randomEventDialogueGroupConfig_10.33": "如果你不希望我夸你，那我也可以夸点别的，要知道我可真是太会夸了。#这么说吧，几乎没什么我是不会夸的，你想要我夸点什么其它的呢？",
    "randomEventDialogueGroupConfig_10.34": "太阳",
    "randomEventDialogueGroupConfig_10.40": "什么？哪里不对了！",
    "randomEventDialogueGroupConfig_10.41": "夸自己一遍演示给它看",
    "themeCardPackDes_20030": "看到【通用规则】就大概能够理解为什么探索的进度如此缓慢，在深渊中能够自由行动的区域极其有限，也不可以和区域中遇到的[]正常交流。实际上【通用规则】已经是相对较为自由的规则了。经过我们的测试得知，违反规则会遭遇【调整】，【调整】后再次违反规则就会遭到【驱逐】。然而，所有的探索成果都是经过违规才获得的。但我们必须作出警告，这其中包含了巨大的牺牲。",
    "resoundEventStoryDes_158": "叉叉的舞步越发急促，突然间，地动山摇，天地鸣动，突然间，它大叫道——进化之舞起效了我要进化了。随后，叉叉的小脚离开了地面，拥向澄空，天空是如此清澈仿佛在唱着属于叉叉的进化乐章。\\n“啊啊啊啊啊啊啊——”。叉叉就这样重重地摔落到地面，它旁边的正是将高台撞倒的比蒙巨兽。\\n下一瞬间，比蒙巨兽的脚掌就要压倒叉叉身上。\\n此刻叉叉体内汹涌的求生欲刺激着每一个细胞，叉叉一手捂鼻，一个灵活闪避，顺利躲过了第一次山崩地裂的猛踩，接下来是第二第三次，叉叉在石柱般的四腿间左右反复横跳躲避着。\\n比蒙巨兽将叉叉的家完全踏平后才冷静下来，缓缓离开。只剩瑟瑟发抖的叉叉和它的进化高台的残骸。",
    "themeCardPackDes_20035": "这里引用一些收集拾取的记录原文进行说明：\\n我遇到了一只高挑的带翅G-N，和它主动对视后，我试着不去回避，我看到了它眼中的愉悦，随后我的眼球裂开了，实在是太疼了我只能低头“看”向地面，那一刻我突然发现原以为裂开的眼球恢复了，在记录后，我吞下了忘忧海草丸。\\n那一次我故意偏离了路线，被主动搭话后没有立刻说再见，对方是一群社恐龙，热情地邀请我陪它们聊聊，但它们说的每一个字时仿佛有什么东西在重击我的耳膜，摸到耳中留出的血液时，我实在忍受不住，说出了再见，在记录后，我吞下了2颗忘忧海草丸，从此我再也听不到声音了。\\n那是一次偏离路线后的遭遇，我看到一只类似飞头蛮的怪兽，但它有脖子，我鼓起勇气主动向它搭话，问它怎么到这里来的，我的喉咙随即被撕裂了。在记录后，我吞下了3颗忘忧海草丸，用我的另外一个喉咙，是的幸好我花丸子有三根脖子。随后一个蓝色眼球状物出现在我前面，它看了我一眼，我认知中的【通用规则】就产生了变化，我只记得必须立刻跟上它……\\n至于那些从深渊归来的怪兽，它们似乎都变了，变得……",
    "resoundEventStoryDes_159": "“已经囤了这么多金币了呢。”这是忙于进化的叉叉新启用的进化口号，今日依旧早出迟归。就在天色渐浓时，疲倦的它踏上归路。迷糊间被什么绊倒在地，抬眼一看，视野中满是横七竖八的怪兽，全都焦痕累累，无一例外。叉叉才突然意识到不妙，快步赶回到部落，只见一群鼻青脸肿的同族正围在长老身旁，排队等待长老分派治疗青草。不久后，叉叉才得知自己刚逃过了一场灾难。",
    "resoundEventStoryDes_167": "超进化委员会提醒广大怪兽，如果路上遇到一只手握菊花、头顶三毛、腿毛特别稀疏的陌生怪兽跟你说，有个大宝贝想让你看看，并邀请你到它的洞穴内做客，请务必留心！\\n据过往受害者描述，它们在进入洞穴后的数秒内被制服，然后被一片漆黑和各种此起彼伏的奇怪声音包围，随后晕倒，失去意识。",
    "resoundEventStoryDes_168": "超进化委员会提醒广大怪兽，如果路上遇到一只手握菊花、头顶三毛、满脸胡渣、腿毛特别稀疏的陌生怪兽跟你说，有个大宝贝想让你看看，并邀请你到它的洞穴内做客，请务必留心！\\n据过往受害者描述，它们在进入洞穴后的数秒内被制服，然后被一片漆黑和各种此起彼伏的奇怪声音包围，随后晕倒，失去意识。",
    "resoundEventStoryDes_165": "超进化委员会提醒广大怪兽，如果路上有一只腿毛特别稀疏的陌生怪兽跟你说，有个大宝贝想让你看看，邀请你到它的洞穴内做客，请务必留心！\\n据过往受害者描述，它们在进入洞穴后的数秒内被制服，然后被一片漆黑和各种此起彼伏的奇怪声音包围，随后晕到，失去意识。",
    "resoundEventStoryDes_166": "超进化委员会提醒广大怪兽，如果路上遇到一只手握菊花、腿毛特别稀疏的陌生怪兽跟你说，有个大宝贝想让你看看，并邀请你到它的洞穴内做客，请务必留心！\\n据过往受害者描述，它们在进入洞穴后的数秒内被制服，然后被一片漆黑和各种此起彼伏的奇怪声音包围，随后晕倒，失去意识。",
    "randomEventDialogueGroupConfig_10.28": "说好",
    "resoundEventStoryDes_163": "拾金不倦的战斗持续到了第二天，叉叉部落的叉叉居然一个金币都没捡到。\\n因为，捡一个，被抢，发现一个，被抢。它们庆幸自己身上本来就没有几个金子，不然全没了。\\n那些收获颇丰的怪兽没想到还有一份“大礼”跟在后头。一条名叫“仓鼠”的龙循着金子的味道找到了它们，它们的金子“物归原主”，而它们，烧焦了。",
    "themeCardPackDes_20040": "瞳翻阅着《深渊夺还须知》里一张张速记树皮，她的眼眸微微低垂，头缓缓向一侧倾去陷入思考，甚至没有感觉到顺着肩膀滑落的发梢。\\n她没有名字，自有记忆以来，便依靠刻在脑海深处的规则行动。\\n她无疑是维护规则的力量，掌中之瞳生成【许可】，满足规则的虚体（幻想）将化为半实体纳入深渊内，并获得一定程度的自由。双触之瞳带来【调控】，违反规则的半实体或实体会被施加更进一步的规则。三触之瞳实施【驱逐】，驱赶带来不稳定的半实体或实体。被施加【调控】后仍违反规则的半实体或实体将会被驱逐或抹杀。\\n有时规则会随着瞳晶上的深渊刻度发生变化。当处于最高刻度时，【不能探求规则背后的意义】会出现变化，变为【不必探求规则背后的意义】，她才可以受到较少规则的束缚，一点点去解明深渊的谜团。\\n那正是此时，此刻。",
    "randomEventDialogueGroupConfig_10.29": "说不好",
    "resoundEventStoryDes_164": "超进化委员会提醒广大怪兽，如果路上有陌生怪兽跟你说，有个大宝贝想让你看看，邀请你到它的洞穴内做客，请务必留心！\\n据过往受害者描述，它们在进入洞穴后的数秒内被制服，然后被一片漆黑和各种此起彼伏的奇怪声音包围，随后晕到，失去意识。",
    "monsterDes_10": "定位：输出，范围伤害\\n与怪物猎人中的轰龙并没有关系，与怪物猎人中的轰龙并没有关系，与怪物猎人中的轰龙并没有关系。",
    "resoundEventStoryDes_161": "“仓鼠”在金堆中打滚，扑翅，翻腾。\\n金币堆中，一颗金子悄无声息地挤进了洞壁，一条细小的裂缝由此开始了它的野蛮生长，不断地往外延伸。\\n有一天，“仓鼠”的宝贝山洞变成了一座即将喷发的金山，它很快就会被引爆，被睡梦中的“仓鼠”的下一个小小的鼻息所引爆。",
    "monsterDes_11": "定位：输出，范围持续伤害，范围伤害\\n暗黑龙因长年进食烧焦的怪兽，烈焰进化成了黯炎，漆黑的火焰仿佛是神明开的玩笑，所触碰之物在燃尽前不会熄灭。",
    "resoundEventStoryDes_162": "叮叮砰砰咣咣的，叉叉部落附近的局部地区降下了一场黄金雨。在明媚阳光的加持下，处处都是耀目的金光，连怪兽贪婪的小眼睛也不例外。\\n它们将所有能装金子的东西都掏了出来，竭尽所能地将尽可能多的金子搬回去，叉叉部落的叉叉们自然也不甘示弱，加入到捡金子的兽群中，拾金的怪兽越来越多……它们手上金子量多数取决于它们拳头的大小。",
    "monsterDes_12": "定位：输出，范围伤害\\n明光龙有了自己独特的信仰，烈焰产生了特殊的变化，并开始使用双足行动，但它从来不说自己信的是什么，有怪兽猜测此事与秘密组织“安立”有关。",
    "randomEventDialogueGroupConfig_10.24": "自由",
    "monsterDes_13": "定位：输出，范围持续伤害，范围伤害\\n比黄昏更加昏暗，比鲜血更加鲜红，我在黑暗中发誓，所有阻塞在我面前的愚蠢之物，终将被我烤了吃。",
    "randomEventDialogueGroupConfig_10.25": "抽象",
    "resoundEventStoryDes_160": "“仓鼠”，族里的龙都这么喊它，它非常喜欢这个名字，因为这名字完美地概括了它的信条。 它居住的“宝贝山洞”隐藏在叉叉部落附近的一片密林之中，对外探索欲望无限趋向于零的怪兽的威胁程度同样趋向于零，非常的安全。那只成天喊着要进化的杂技叉叉更是不值一提。“仓鼠”把它成年以来所收集到的金子都藏到宝贝山洞之中，金山高度每有一点增加，它都会无比兴奋。如果有谁来问它，你幸福吗，它一定会回答，它很幸福，特别是在金币里钻来钻去，细嗅金子香气的时候。",
    "monsterDes_14": "定位：输出，范围伤害\\n圣光古龙救过和杀过的怪兽几乎一样多，你很难定义它的信仰，但它自己却深信不疑，它对马赛克有强烈的执着，每次看到都会发动圣光。",
    "randomEventDialogueGroupConfig_10.26": "另类",
    "monsterDes_15": "定位：输出，范围持续伤害，范围伤害\\n黯炎在所触碰之物完全燃尽时才会熄灭，普通的黯炎触及物质，魔龙的黯炎触及灵魂。凡是看不见可燃物，却在无声燃烧的火焰都是黯炎魔龙的龙焰，它正悄无声息地吞噬着灵魂的残渣。",
    "randomEventDialogueGroupConfig_10.27": "要不你说说我夸得怎样再走？",
    "monsterDes_16": "定位：输出，范围伤害\\n圣光神龙的信仰已经无需定义，它就是信仰本身。",
    "randomEventDialogueGroupConfig_10.20": "战力",
    "monsterDes_17": "定位：坦克，自我治疗\\n幼尸看似一脸柔弱，其实抗打系数MAX，它的性别常常被怪兽们讨论，但至今没有一个标准答案，等等，嘿朋友你在往哪里看？",
    "randomEventDialogueGroupConfig_10.21": "请自由发挥",
    "monsterDes_18": "定位：坦克，自我治疗\\n经过幼体期的锤炼行尸已成长的尸气逼人，但一直缠绕着它的问题并没有解决，每当别人问它是带男朋友还是女朋友回家吃饭时它的内心是崩溃(×2)的。",
    "randomEventDialogueGroupConfig_10.22": "你想要哪种风格呢。你看看这几种我都会！",
    "monsterDes_19": "定位：坦克，全体治疗\\n亭亭玉立的幽鬼有很多追求者，除了因为它的外表，它的能力也被万千怪兽所喜爱，能抗能治疗还有6只手的美丽姑娘，真是amazing！",
    "randomEventDialogueGroupConfig_10.23": "咆哮",
    "randomEventDialogueGroupConfig_10.30": "我只是希望大家多关注自己身上的优点、闪光点，还有好的方面。",
    "resoundEventStoryDes_169": "超进化委员会提醒广大怪兽，如果路上遇到一只手握菊花、头顶三毛、满脸胡渣、腿毛特别稀疏的陌生怪兽跟你说，有个大宝贝想让你看看，并邀请你到它的洞穴内做客，请务必留心！\\n据过往受害者描述，它们在进入洞穴后的数秒内被制服，然后被一片漆黑和各种此起彼伏的奇怪声音包围，随后晕倒，失去意识。醒来以后，它们发现了陌生的洞顶，以及自己的肉体被掏空了的事实。",
    "resoundEventStoryDes_178": "王·赤色狮：“你怎么每顿都吃三只小羊？”\\n利爪狼：“我也想吃小红帽啊。”\\n王·赤色狮：“吃呀。”\\n利爪狼：“打不过赤虹。”",
    "resoundEventStoryDes_179": "这是异形的故事，虽然不是工程师和黑水那个版本。异形们在超进化大陆中常常如同空气一般，随机四处飘荡。其中有少数的例外，例如那只在冰川谷飘荡的异形，它看见了无数燃烧的火球自夜空坠落而降，它听到了喃喃的呼唤后，逐渐偏离了原本轨迹……",
    "23_30": "“预设尚|c未可知|c，进化绝|c不湮灭|c。”\\n选项一校准完成。\\n选项二校准完成。\\n选项三校准完成。\\n为这段旅途，开始|c第一次真正的选择|c吧。\\n探索者，|c你是谁|c？",
    "resoundEventStoryDes_176": "像金子这种闪闪发光的东西，很容易得到怪兽的喜爱。例如某只锤子，它希望拥有很多很多的金子，整天躺在金子堆之中。于是它花了很长时间，为自己打造一个没有怪兽能找到的金库。这个金库将用于存放它的全部金子。\\n咻咻的天选之丘正是出自这只锤子之手。\\n如今，这只锤子的骸骨还躺在天选之丘的某个小洞穴中，旁边有两颗小小的金子，也是它所有的金子。",
    "resoundEventStoryDes_177": "美杜莎莎实际上还是一位极其出色的雕塑家，它的作品栩栩如生，千姿百态，就好像真的一样，怪兽雕塑是她最为擅长的领域。\\n有传言提到，美杜莎莎会为喜爱它作品的怪兽进行免费雕像。\\n每个参观者的部族在刚收到雕像时，都会被作品的栩栩如生惊艳。直到有一天，它们意识到同伴再也回不来了，或者意识到同伴其实早就回来了……",
    "23_32": "遇事不决就重启不是标准答案吗……？",
    "resoundEventStoryDes_174": "天选之丘底下有着无数条相互交错的通道，这些通道连同着无数个洞穴。丘顶的洞口是入口。从丘顶的洞口落下的咻咻，会有机会落到不同的洞穴之中。\\n选出新首领的规则非常简单，前首领会先从丘顶的洞口落下，之后首领候选者再逐一从丘顶洞口落下。最终，与前首领落到同一个洞穴的咻咻就是新一任的首领。如果没有候选者落到与首领同一个洞穴，那这个过程会重复，直到决出新一任首领位置。\\n每一任首领都认为自己是天选之咻，它相信正是自己在落入洞口前的努力，让它夺得了这个位置。",
    "23_31": "……纳尼？！",
    "resoundEventStoryDes_175": "前任咻咻首领在卸任后，会组织一个半地下式的讲学会。那些想成为下一任首领的咻咻都会前来学习，学习前任首领的“首领学”。\\n如果你在路上看到一群咻咻在进行着什么奇怪的仪式，不需要害怕，它们只是相信那样做，天命就会眷顾它们。\\n不过天命大概会和你一样，连那群咻咻谁是谁都无法分清楚就是了。",
    "23_34": "……",
    "resoundEventStoryDes_172": "我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——\\n我永远相信超进化委员会——",
    "23_33": "是因为你刚刚|c手抖刮了两次风|c吧……",
    "resoundEventStoryDes_173": "每个部落对部落首领都有不同的要求，有的选最强壮的，有的选最具神性的，有的选最擅伪装的，还有的挑最受欢迎的，或是运气最好的。\\n在某个咻咻的部落里，它们的部落的首领则是通过“滚”选取出来的。\\n一处看似普通实际也很普通的小丘却是咻咻们的圣地，因为它们的部落首领将从这里诞生，因而被称为“天选之丘”。",
    "randomEventDialogueGroupConfig_10.57": "不等它想离开",
    "resoundEventStoryDes_170": "超进化委员会提醒广大怪兽，如果路上遇到一只手握菊花、头顶三毛、满脸胡渣、腿毛特别稀疏的陌生怪兽跟你说，有个大宝贝想让你看看，并邀请你到它的洞穴内做客，请务必留心！\\n据过往受害者描述，它们在进入洞穴后的数秒内被制服，然后被一片漆黑和各种此起彼伏的奇怪声音包围，随后晕倒，失去意识。醒来以后，它们发现了陌生的洞顶，以及自己的肉体和心灵都被掏空了的事实。",
    "randomEventDialogueGroupConfig_10.58": "唔，我想想……",
    "resoundEventStoryDes_171": "超进化委员会提醒广大怪兽，如果路上遇到一只手握菊花、头顶三毛、满脸胡渣、腿毛特别稀疏的陌生怪兽跟你说，有个大宝贝想让你看看，并邀请你到它的洞穴内做客，请务必留心！\\n据过往受害者描述，它们在进入洞穴后的数秒内被制服，然后被一片漆黑和各种此起彼伏的奇怪声音包围，随后晕倒，失去意识。醒来以后，它们发现了陌生的洞顶，以及自己的肉体和心灵都被掏空了的事实。\\n（仔细看能发现后面歪歪扭扭写着“是真的”几个字。）",
    "randomEventDialogueGroupConfig_10.59": "等它想",
    "randomEventDialogueGroupConfig_10.53": "直接把战力值告诉它",
    "randomEventDialogueGroupConfig_10.54": "同意",
    "randomEventDialogueGroupConfig_10.55": "嗯……我要再组织一下语言。",
    "randomEventDialogueGroupConfig_10.56": "继续等",
    "randomEventDialogueGroupConfig_10.60": "不等它想离开",
    "randomEventDialogueGroupConfig_10.61": "夸可是要发自内心才行，我一直坚信大家身上必然会有只属于它的闪光点。#就像你对我的信任，你相信我的观察能力，相信我能发现属于你的美好那样。",
    "randomEventDialogueGroupConfig_10.62": "让它说下去",
    "randomEventDialogueGroupConfig_10.63": "借故离开",
    "23_25": "谜之生物想象力MAX形态",
    "23_24": "少见的|c睿智的|c探索者，为了表示尊重我会3个形态一起上。",
    "23_27": "你这样的更少见吧|c……|c",
    "23_26": "少见的|c变换莫测|c的探索者，为了表示尊重我会3个形态一起上。",
    "23_29": "探索者，你竟然打破了所有的预设，连「它」都被你打破了。\\n（终焉的记忆正在改变）\\n（终焉的记忆正在扭曲）",
    "23_28": "真是天赋异禀……短短一分钟你连|c远古技能和神灵释放|c都掌握了。\\n你得到了我的认可，在不远的将来|c我会找到你|c，到时带上我去看看这个星球不一样的结局吧！",
    "resoundEventStoryDes_189": "我的身体是音乐做的\\n血是音符\\n心是旋律\\n参演过数不尽的演唱会\\n一场都没有满\\n却也一场都没有空\\n歌手又成一人\\n在背包之中\\n静静守候\\n但是\\n就算是在仓库的身体\\n也是用灰尘堆砌出来的——",
    "resoundEventStoryDes_187": "智者：“怎么又来了，还找不到朋友吗？”\\n人间大炮：“就是来告诉你，我最近交了很多朋友！”\\n智者：“嗯？”\\n人间大炮：“我发现做人间大炮还是直接点好。于是我就直接问它们‘是想当炮灰啊，还是交个朋友啊？’”",
    "resoundEventStoryDes_188": "超进化大陆的风，偶尔会夹杂着一些讯息，据说大脑放空的怪兽更容易听到。\\n我上次听到的，是这个：“不同怪兽会有各自不同的小小癖好，听说幻在独自战斗的时候，就会高歌一曲，找机会听听看吧，到时候，你会闭上眼睛？还是捂住耳朵呢？”",
    "resoundEventStoryDes_185": "这座晚春的小山崖，如同草海上一头扬起的凝固浪涌。\\n一大早，呜呜祖拉就趴在这小山崖边上，不住往下探头，与周围一同沐浴着和风，期待着即将绽放的美景。\\n山崖下方，由内至外有六层不同颜色的弧形花圃。第七层的花圃挂满了含苞待放的花苞。忽然间，一阵狂风裹挟着暴雨袭来，花儿乱颤着与风雨较劲，可终究还是扒拉不住，红橙黄绿蓝靛六色花瓣纷飞落入雨中，就在这凌乱中，紫花初绽。",
    "resoundEventStoryDes_186": "人间大炮：“为什么大家都不愿意跟我做朋友呢？”\\n智者：“1个问题2枚金币。”\\n人间大炮：“给。”\\n智者：“人间大炮的朋友那不就是那啥。”\\n人间大炮：“你是说……”\\n智者：“对，它们怕你。”",
    "resoundEventStoryDes_183": "青铜五小强听说了马上变强训练营以后，不带半点犹豫，立刻东借西凑找来了30个进化孢子，加入了马上变强训练营。\\n训练营的宣传果真童叟无欺，所有训练的项目都是在骑兵的马上进行的。训练营营长告诉五小强，只要在马上训练连续不断坚持半年就可以初步见效，坚持的时间越久，效果就会越明显。\\n五小强带着自己报的训练营，死都要参加完的觉悟，顺利地让骑兵的马变强了……",
    "resoundEventStoryDes_184": "呜呜祖拉踮起左脚脚尖，右脚往后伸直，右手斜向上指，左手斜向下指，然后不断地左右交替互换重复着这个动作。\\n它已经连续两次靠着这个舞步招来了次日的好天气，呜呜祖拉相信这回也不会例外。\\n和它一起冒险，它或许会把更多的秘密告诉你哦。",
    "randomEventDialogueGroupConfig_10.46": "指出它很可疑",
    "resoundEventStoryDes_181": "异形发现了一座奇特的矮坡，经过那座矮坡的怪兽会无意识地绕路而行。这个现象吸引着异形，来到了矮坡之上的平地。\\n这里被一层薄雾包裹，云层又低又厚，挤压着这里的空间。坡顶的平地中间有个下凹的小坑，边缘插着一根简陋的鱼竿。很快一股倦意袭向异形，黑白的天空中心睁开了一只巨眼，一道诡异的七彩光芒从中放射出来，光芒中有3个黑影，他们的上臂紧贴着身体，前臂与之成90°，身体随着微曲的脚步慢摇。\\n一周以后，异形在矮坡边缘惊醒，不要命似地奔离矮坡。",
    "randomEventDialogueGroupConfig_10.47": "“怎么不好了，我可是经过组织培训的”",
    "resoundEventStoryDes_182": "“我是骑兵，你的天才导师，只要300个进化孢子作为保证，就可以加入马上变强训练营，体验马上变强的乐趣。变强成功，孢子全部归还。前100位入营的怪兽，则只要30个强化孢子就可以率先加入！不要犹豫了，加入就是现在！变强就是现在！”",
    "randomEventDialogueGroupConfig_10.48": "-",
    "randomEventDialogueGroupConfig_10.49": "你的身上散发着一股未知的氛围，它们能温和地侵入到周边的感官，构成了一个未知的有限场。#无形在固件实体内充斥交错，扭曲为可变的体验，造就超出完美构造的细节。",
    "resoundEventStoryDes_180": "最后一颗火球划破天空落入地平，异形向火球落下的方向飘去。\\n随着气温的升高，异形知道自己越来越接近目的地了。那是一片不大的焦土，中心躺着一颗仿佛会呼吸的石头。它的视线被石头紧紧抓住，周围的景象开始抖动扭曲，不存在的边沿线随之着抽离了化作不同颜色的晃动，不断分离重组，拧成一团扭曲的无名之物……\\n回过神后，它发现，那块石头竟不知不觉跑到了它的身上，一阵粘稠而冰冷的触感传来，一浪浪低语紧随而至，直抵它的意识深处。",
    "randomEventDialogueGroupConfig_10.42": "指出问题",
    "randomEventDialogueGroupConfig_10.43": "我是真心的！你不会以为是……",
    "randomEventDialogueGroupConfig_10.44": "指出它在嘲讽",
    "randomEventDialogueGroupConfig_10.45": "指出它另有所图",
    "randomEventDialogueGroupConfig_10.50": "表示疑惑",
    "randomEventDialogueGroupConfig_10.51": "跑",
    "randomEventDialogueGroupConfig_10.52": "这个可能要试试才好夸哦！",
    "23_36": "（谜之生物|c支起后腿|c，进行了一次漫长而温暖的“标记”）\\n（谜之生物深信会与你再次相遇，|c并肩作战|c。）\\n（谜之生物满意的离开了。）",
    "23_35": "谜之生物……名字没起错……",
    "23_38": "|c远古族怪兽主动技能|c\\n（长按可查看描述）",
    "23_37": "一看就知道你是不需要详细教程的探索者！ 哪亮点哪，点了就放|c神灵技能|c。",
    "messageInitContent_7529": "远程怪兽专场？！",
    "messageInitContent_7527": "精致探索者仍在竞猜中",
    "messageInitContent_7528": "技能看看",
    "messageInitContent_7532": "选完收工",
    "messageInitContent_7533": "今晚吃什么好呢",
    "messageInitContent_7530": "远程对对碰",
    "messageInitContent_7531": "咋选",
    "messageInitContent_7536": "右边啦",
    "messageInitContent_7537": "人越多人越少",
    "messageInitContent_7534": "不是哥们",
    "messageInitContent_7535": "在猜了在猜了",
    "messageInitContent_7538": "你家近战呢",
    "messageInitContent_7539": "一个肉盾都没有吗",
    "messageInitContent_7543": "好的",
    "messageInitContent_7544": "向左向右向前看",
    "messageInitContent_7541": "嘿嘿嘿",
    "messageInitContent_7542": "肯定是那边",
    "messageInitContent_7547": "手长者得天下",
    "messageInitContent_7548": "啥？",
    "messageInitContent_7545": "今天选人多的",
    "messageInitContent_7546": "让我诊一下网线看看那边赢了",
    "messageInitContent_7540": "选择困难",
    "messageInitContent_7549": "啊我的眼睛",
    "messageInitContent_7554": "不好意思我的闪光灯掉了",
    "messageInitContent_7555": "咋选",
    "messageInitContent_7552": "遇事不决看技能",
    "messageInitContent_7553": "闪光小可爱",
    "messageInitContent_7558": "要是不用上班就好了",
    "messageInitContent_7559": "bingbingbing~~",
    "messageInitContent_7556": "emmm",
    "messageInitContent_7557": "技能知道一切",
    "messageInitContent_7550": "万圣节过了",
    "messageInitContent_7551": "我占卜一下借过",
    "messageInitContent_7565": "你们快选啊",
    "messageInitContent_7566": "被闪光硬控",
    "messageInitContent_7563": "选人少的",
    "messageInitContent_7564": "哈哈哈哈哈哈",
    "messageInitContent_7569": "等大家选完",
    "messageInitContent_7567": "我跟你讲",
    "messageInitContent_7568": "先睡了",
    "messageInitContent_7561": "远程怪兽主场！",
    "messageInitContent_7562": "预言一下赢的是这边",
    "messageInitContent_7560": "该握你的哪个手呢",
    "randomEventDialogueGroupConfig_11.308": "它开始绕圈踱步思考。",
    "randomEventDialogueGroupConfig_11.309": "进店看看",
    "randomEventDialogueGroupConfig_11.306": "逛商店",
    "randomEventDialogueGroupConfig_11.307": "离开",
    "randomEventDialogueGroupConfig_11.304": "是态度",
    "randomEventDialogueGroupConfig_11.305": "它开始绕圈踱步思考。",
    "randomEventDialogueGroupConfig_11.302": "是力度或者角度",
    "randomEventDialogueGroupConfig_11.303": "是姿势",
    "randomEventDialogueGroupConfig_11.300": "现在离开",
    "randomEventDialogueGroupConfig_11.301": "它慢慢地转了一下，但没满一圈。",
    "messageInitContent_7576": "我是猜错概念神",
    "propConfigName_53001": "元核髓",
    "messageInitContent_7577": "家人们谁懂啊",
    "messageInitContent_7574": "我选了这边知道了吧",
    "messageInitContent_7575": "听我的选这边",
    "messageInitContent_7578": "根本站不住啊",
    "messageInitContent_7579": "能吸收也是肉",
    "messageInitContent_7572": "bingbingbingbingbingbingbing",
    "messageInitContent_7573": "未尝一对",
    "messageInitContent_7570": "发女装可得答案",
    "messageInitContent_7571": "我猜我猜我猜猜猜",
    "messageInitContent_7587": "咋选",
    "messageInitContent_7588": "妙哇",
    "messageInitContent_7585": "嗯？？？",
    "messageInitContent_7586": "先让我缓缓",
    "messageInitContent_7589": "在猜了在猜了",
    "messageInitContent_7580": "伤害杠杠滴",
    "messageInitContent_7583": "猜对的方程式已经想好了",
    "messageInitContent_7584": "收工",
    "messageInitContent_7581": "我命令你选这边",
    "messageInitContent_7582": "刚刚好",
    "messageInitContent_7598": "正在猜",
    "messageInitContent_7599": "两眼",
    "messageInitContent_7596": "正确的废话",
    "messageInitContent_7597": "一眼",
    "messageInitContent_7590": "妙哇妙哇",
    "messageInitContent_7591": "给个机会",
    "messageInitContent_7594": "远程，星，懂了",
    "messageInitContent_7595": "总有一个是错的",
    "messageInitContent_7592": "我近战怪兽呢",
    "messageInitContent_7593": "又是远程呢",
    "messageInitNick_7090": "静谧游泳圈",
    "messageInitNick_7092": "劳逸结合",
    "messageInitNick_7091": "小汤包儿",
    "messageInitNick_7098": "沙沙沙沙拉",
    "messageInitNick_7097": "随缘抽卡",
    "messageInitNick_7099": "掏不过掏不过",
    "messageInitNick_7094": "银河偶遇计划",
    "messageInitNick_7093": "最强的香蕉",
    "messageInitNick_7096": "机场等船",
    "messageInitNick_7095": "无公害辣椒",
    "messageInitNick_7081": "超前游玩",
    "messageInitNick_7080": "听见阳光",
    "messageInitNick_7087": "行走的果汁糖",
    "randomEventDialogueGroupConfig_11.348": "它仍然在沉默中……",
    "messageInitNick_7086": "橙子之心",
    "randomEventDialogueGroupConfig_11.349": "等待",
    "messageInitNick_7089": "油菜真好吃",
    "randomEventDialogueGroupConfig_11.346": "“哇哦，天，这是天堂吗，啊啊啊啊啊啊，怎么松手了。”#“你……下次……可不放过你！”它飞了出去倒地，又艰难爬起。",
    "messageInitNick_7088": "霹雳美人",
    "randomEventDialogueGroupConfig_11.347": "离开",
    "messageInitNick_7083": "第一视觉的你",
    "randomEventDialogueGroupConfig_11.344": "停下",
    "messageInitNick_7082": "蹲街角哭泣",
    "randomEventDialogueGroupConfig_11.345": "继续",
    "messageInitNick_7085": "怎样坚强",
    "randomEventDialogueGroupConfig_11.342": "离开",
    "messageInitNick_7084": "超级过山车",
    "randomEventDialogueGroupConfig_11.343": "“天呐，这种全新的转圈体验是什么！太棒了吧，不要停下来啊啊啊啊——”",
    "randomEventDialogueGroupConfig_11.340": "战斗",
    "randomEventDialogueGroupConfig_11.341": "“你这样是抓不到我的哈哈哈。今天满足了。再见。”",
    "messageInitNick_7079": "自私的前锋",
    "messageInitNick_7070": "天下第一卷",
    "propConfigName_90005": "紫色元核碎片",
    "propConfigName_90004": "蓝色元核碎片",
    "propConfigName_90003": "绿色元核碎片",
    "randomEventDialogueGroupConfig_11.339": "“堵在我必然会绕过的地方，真是勇敢！那就来吧。”",
    "propConfigName_90002": "白色元核碎片",
    "messageInitNick_7076": "盛夏光年",
    "randomEventDialogueGroupConfig_11.337": "因为太快了，你没有看穿它的走位并且打空了。",
    "messageInitNick_7075": "暴走的果汁糖",
    "randomEventDialogueGroupConfig_11.338": "再试一遍",
    "messageInitNick_7078": "发亮的灯泡",
    "randomEventDialogueGroupConfig_11.335": "你未能看穿它的走位，但你看到了离开的道路。",
    "messageInitNick_7077": "连呼吸都会痛",
    "randomEventDialogueGroupConfig_11.336": "离开",
    "messageInitNick_7072": "花与金丝雀",
    "randomEventDialogueGroupConfig_11.333": "“当然是跑路啦，今天我转的很开心，下次再见。”",
    "messageInitNick_7071": "不想理你",
    "randomEventDialogueGroupConfig_11.334": "离开",
    "messageInitNick_7074": "认证走音专家",
    "randomEventDialogueGroupConfig_11.331": "“还要攻击过来吗，好哇。让你看看我防御的终极奥义！”",
    "messageInitNick_7073": "奇迹玩家",
    "randomEventDialogueGroupConfig_11.332": "看看",
    "randomEventDialogueGroupConfig_11.330": "离开",
    "messageInitNick_7069": "大魔王",
    "messageInitNick_7068": "盐多了会咸",
    "propConfigName_90007": "红色元核碎片",
    "propConfigName_90006": "橙色元核碎片",
    "20_comment": "强制教程，引导卡",
    "randomEventDialogueGroupConfig_11.328": "离开",
    "randomEventDialogueGroupConfig_11.329": "它仍在思考没有追上来。",
    "messageInitNick_7065": "你在哪里等我",
    "randomEventDialogueGroupConfig_11.326": "离开",
    "messageInitNick_7064": "葫芦娃",
    "randomEventDialogueGroupConfig_11.327": "显然抢救并没有什么效果。",
    "messageInitNick_7067": "喵喵队立大功",
    "randomEventDialogueGroupConfig_11.324": "离开",
    "messageInitNick_7066": "萝卜先锋",
    "randomEventDialogueGroupConfig_11.325": "它锤了两下看你不还手就放过你离开了。",
    "messageInitNick_7061": "芒果先锋",
    "randomEventDialogueGroupConfig_11.322": "你好过分，呜呜，把人家拿捏住了，呜呜。",
    "messageInitNick_7060": "实名买房",
    "randomEventDialogueGroupConfig_11.323": "它伤心地走了。",
    "messageInitNick_7063": "电磁炉之彼端",
    "randomEventDialogueGroupConfig_11.320": "它突然稳住了，快速窜走了。",
    "messageInitNick_7062": "临海听风",
    "randomEventDialogueGroupConfig_11.321": "离开",
    "messageInitNick_7058": "一方通行",
    "messageInitNick_7057": "按时吃饭",
    "messageInitNick_7059": "摸鱼先锋",
    "randomEventDialogueGroupConfig_11.319": "离开",
    "randomEventDialogueGroupConfig_11.317": "离开",
    "randomEventDialogueGroupConfig_11.318": "那说好咯，拜拜。",
    "messageInitNick_7054": "提嫖",
    "randomEventDialogueGroupConfig_11.315": "拿好",
    "messageInitNick_7053": "愤怒的老鸟",
    "randomEventDialogueGroupConfig_11.316": "它一绕把你甩开了。",
    "messageInitNick_7056": "彩礼刺客",
    "randomEventDialogueGroupConfig_11.313": "放弃离开",
    "messageInitNick_7055": "吃饭了没",
    "randomEventDialogueGroupConfig_11.314": "好吧，你说服了我。拿好咯。",
    "messageInitNick_7050": "爱笑的萌汉纸",
    "randomEventDialogueGroupConfig_11.311": "我还是更喜欢转转转！不喜欢白给呢。",
    "randomEventDialogueGroupConfig_11.312": "说助人也是一种快乐",
    "messageInitNick_7052": "回收站长",
    "messageInitNick_7051": "萝卜兽",
    "randomEventDialogueGroupConfig_11.310": "离开",
    "messageInitNick_7047": "春天里的雪",
    "messageInitNick_7046": "画饼王",
    "messageInitNick_7049": "沙发毁灭者",
    "messageInitNick_7048": "凌晨两点半",
    "messageInitNick_7043": "沉浸式写作",
    "messageInitNick_7042": "尖叫洋葱",
    "messageInitNick_7045": "杂念减一",
    "messageInitNick_7044": "超晨光之柱",
    "randomEventDialogueGroupConfig_11.388": "动手",
    "randomEventDialogueGroupConfig_11.389": "离开",
    "messageInitNick_7041": "有主之地",
    "randomEventDialogueGroupConfig_11.386": "收下",
    "messageInitNick_7040": "狗狗的日常",
    "randomEventDialogueGroupConfig_11.387": "“爽飞了哈哈哈。”它快忘乎所以，似乎没打算把东西给你。",
    "randomEventDialogueGroupConfig_11.384": "好",
    "messageInitNick_7039": "承诺碎了一地",
    "randomEventDialogueGroupConfig_11.385": "“给你拿好了！”",
    "randomEventDialogueGroupConfig_11.382": "“我说真的，请相信我好吗。”",
    "randomEventDialogueGroupConfig_11.383": "不好",
    "messageInitNick_7036": "跳伞捡空投",
    "messageInitNick_9699": "思念的时钟",
    "randomEventDialogueGroupConfig_11.380": "“好啦，我答应你，再转一次就什么都给你，好吗！”",
    "messageInitNick_7035": "电影院里睡觉",
    "randomEventDialogueGroupConfig_11.381": "转",
    "messageInitNick_7038": "给冰箱把脉",
    "messageInitNick_9697": "干净得像风",
    "messageInitNick_7037": "流浪的律师",
    "messageInitNick_9698": "割藕狗",
    "messageInitNick_7032": "要变身了",
    "messageInitNick_9695": "寂寞是必需品",
    "messageInitNick_7031": "重新定义恰瓜",
    "messageInitNick_9696": "褪色灵感",
    "messageInitNick_7034": "霸气刺客",
    "messageInitNick_9693": "生活但是摸鱼",
    "randomEventDialogueGroupConfig_11.379": "离开",
    "messageInitNick_7033": "擦不完的地板",
    "messageInitNick_9694": "退出群聊",
    "messageInitNick_9691": "增殖的向日葵",
    "randomEventDialogueGroupConfig_11.377": "“妙，真是妙。”它半醒半梦绕进了商店。",
    "messageInitNick_9692": "纸片人仙女",
    "randomEventDialogueGroupConfig_11.378": "跟上",
    "messageInitNick_7030": "菜花魔法",
    "randomEventDialogueGroupConfig_11.375": "离开",
    "messageInitNick_9690": "保护好自己",
    "randomEventDialogueGroupConfig_11.376": "大力捏",
    "messageInitNick_7029": "百香果消灭者",
    "randomEventDialogueGroupConfig_11.373": "离开",
    "messageInitContent_7500": "在猜了在猜了",
    "messageInitNick_7028": "彩虹直至黑白",
    "randomEventDialogueGroupConfig_11.374": "它还是没有醒来。",
    "randomEventDialogueGroupConfig_11.371": "它仍然没有醒过来。",
    "randomEventDialogueGroupConfig_11.372": "大力摇",
    "messageInitContent_7503": "看一眼技能懂了",
    "messageInitNick_7025": "街机少年",
    "messageInitNick_9688": "抠脚大汉",
    "messageInitContent_7504": "你又懂了",
    "messageInitNick_7024": "逆境中的香蕉",
    "messageInitNick_9689": "八大姨",
    "randomEventDialogueGroupConfig_11.370": "离开",
    "messageInitContent_7501": "晚安kiss",
    "messageInitNick_7027": "生菜魔法",
    "messageInitNick_9686": "肥皂贩卖机",
    "messageInitContent_7502": "充满了和谐的气氛",
    "messageInitNick_7026": "菜汤不甜",
    "messageInitNick_9687": "流浪的歌手",
    "messageInitContent_7507": "好的",
    "messageInitNick_7021": "暗访西门庆",
    "messageInitNick_9684": "刚提的风油精",
    "messageInitContent_7508": "相信第一感觉",
    "messageInitNick_7020": "鳖载着理发店",
    "messageInitNick_9685": "能够放下了",
    "messageInitContent_7505": "正在猜",
    "messageInitNick_7023": "跑调门首席",
    "messageInitNick_9682": "三年又三年",
    "randomEventDialogueGroupConfig_11.368": "它开心到站着睁着眼睛晕了过去。",
    "messageInitContent_7506": "安安",
    "messageInitNick_7022": "诸神午后",
    "messageInitNick_9683": "天堂长裙",
    "randomEventDialogueGroupConfig_11.369": "摇醒它",
    "messageInitNick_9680": "这话题我喜欢",
    "randomEventDialogueGroupConfig_11.366": "停下",
    "messageInitNick_9681": "离线申请对象",
    "randomEventDialogueGroupConfig_11.367": "离开",
    "messageInitContent_7509": "想你了an",
    "randomEventDialogueGroupConfig_11.364": "继续转",
    "randomEventDialogueGroupConfig_11.365": "“噢，不，别走——”",
    "messageInitContent_7510": "我是猜错概念神",
    "messageInitNick_7018": "芹菜真好吃",
    "randomEventDialogueGroupConfig_11.362": "“太棒了，太棒了！你再多转一会，我就把你想要的东西给你。”",
    "messageInitContent_7511": "你看我对了吗",
    "messageInitNick_7017": "第四根肋骨",
    "randomEventDialogueGroupConfig_11.363": "怀疑",
    "messageInitNick_9679": "香瓜的清爽",
    "randomEventDialogueGroupConfig_11.360": "等待",
    "messageInitNick_7019": "向日葵的花语",
    "randomEventDialogueGroupConfig_11.361": "离开",
    "messageInitContent_7514": "总有一个对的",
    "messageInitNick_7014": "用力过猛的瓜",
    "messageInitNick_9677": "吃影子的猫",
    "messageInitContent_7515": "咋选",
    "messageInitNick_7013": "西门有很",
    "messageInitNick_9678": "黯然销魂掌",
    "messageInitContent_7512": "又能打又能奶",
    "messageInitNick_7016": "可乐",
    "messageInitNick_9675": "十分想打你",
    "messageInitContent_7513": "正确的废话",
    "messageInitNick_7015": "枫无痕",
    "messageInitNick_9676": "格式化悲伤",
    "messageInitContent_7518": "远程对轰",
    "messageInitNick_7010": "参见萌妹砸",
    "messageInitNick_9673": "靠谱女青年",
    "randomEventDialogueGroupConfig_11.359": "它沉默了很久。",
    "messageInitContent_7519": "好闪",
    "messageInitNick_9674": "生命的意义",
    "messageInitContent_7516": "咋办",
    "messageInitNick_7012": "直接开摆",
    "messageInitNick_9671": "人气声优",
    "randomEventDialogueGroupConfig_11.357": "再次开始转",
    "messageInitContent_7517": "很明显",
    "messageInitNick_7011": "瑟瑟发抖",
    "messageInitNick_9672": "异世界的你",
    "randomEventDialogueGroupConfig_11.358": "拒绝离开",
    "randomEventDialogueGroupConfig_11.355": "进店",
    "messageInitNick_9670": "划水天王",
    "randomEventDialogueGroupConfig_11.356": "“不要！不要停下来啊！你想怎样我都答应你！”",
    "randomEventDialogueGroupConfig_11.353": "离开",
    "randomEventDialogueGroupConfig_11.354": "“我想不明白……我的想法它被绕晕了！怎么办！你的攻击奏效了！店里随便看吧哼。”",
    "messageInitContent_7521": "Get不到~~",
    "messageInitNick_7007": "远方传来的你",
    "randomEventDialogueGroupConfig_11.351": "它还在沉默中……",
    "messageInitContent_7522": "原生中出现了一个！",
    "messageInitNick_7006": "霸天战狼",
    "randomEventDialogueGroupConfig_11.352": "等待",
    "messageInitNick_7009": "气质这块",
    "messageInitNick_9668": "战斗力还行",
    "messageInitContent_7520": "远程拼啥，手多？",
    "messageInitNick_7008": "拖鞋狂怒者",
    "messageInitNick_9669": "驭鲸少女",
    "randomEventDialogueGroupConfig_11.350": "离开",
    "messageInitContent_7525": "饿了",
    "messageInitNick_7003": "戴营养师",
    "messageInitNick_9666": "反派不够用",
    "messageInitContent_7526": "混入了一只异端",
    "messageInitNick_7002": "钢琴兔",
    "messageInitNick_9667": "尬聊带头人",
    "messageInitContent_7523": "手长",
    "messageInitNick_7005": "吃点人间的苦",
    "messageInitNick_9664": "芋圆诗人",
    "messageInitContent_7524": "你不够手长",
    "messageInitNick_7004": "超级平底锅",
    "messageInitNick_9665": "图一乐",
    "messageInitNick_9662": "家里有鱼缸",
    "messageInitNick_9663": "电子沙拉酱",
    "messageInitNick_7001": "夹娃娃请投币",
    "messageInitNick_9660": "再来碗小鲜肉",
    "messageInitNick_7000": "已恢复单身",
    "messageInitNick_9661": "作业跑了",
    "messageInitNick_9659": "疯狂星期五",
    "messageInitNick_9657": "纯情小家伙",
    "messageInitNick_9658": "黑夜的呼吸",
    "messageInitNick_9655": "旋转滑稽脸",
    "messageInitNick_9656": "半盏孤茶",
    "messageInitNick_9653": "卖惨之王",
    "messageInitNick_9654": "炼点儿丹",
    "messageInitNick_9651": "傲到骨子里",
    "messageInitNick_9652": "别动我兔子",
    "messageInitNick_9650": "疯狂输出",
    "messageInitNick_9648": "超级饺子",
    "messageInitNick_9649": "牙签剑客",
    "messageInitNick_9646": "情绪很稳定",
    "messageInitNick_9647": "修炼成精",
    "messageInitNick_9644": "认证捡漏专家",
    "messageInitNick_9645": "在你心上偷渡",
    "messageInitNick_9642": "合伙吃饭",
    "messageInitNick_9643": "黑色幽默",
    "messageInitNick_9640": "九五之尊",
    "messageInitNick_9641": "我不理解",
    "messageInitNick_9637": "放生美人鱼",
    "messageInitNick_9638": "沉睡月光",
    "messageInitNick_9635": "彩色胶卷",
    "messageInitNick_9636": "榴莲之心",
    "messageInitNick_9633": "火龙果之心",
    "messageInitNick_9634": "年度最萌",
    "messageInitNick_9631": "电视台异闻录",
    "messageInitNick_9632": "举高高",
    "messageInitNick_9639": "最强的哈密瓜",
    "messageInitNick_9630": "国民小甜心",
    "randomEventDialogueGroupConfig_11.399": "努力转",
    "randomEventDialogueGroupConfig_11.397": "离开",
    "randomEventDialogueGroupConfig_11.398": "“多转转，说不定还能掉更多哦，都送你哈哈。”",
    "messageInitNick_9626": "地面之上",
    "randomEventDialogueGroupConfig_11.395": "捡起告诉它",
    "messageInitNick_9627": "性感镜中人",
    "randomEventDialogueGroupConfig_11.396": "“给力点啊！哼，我找其它怪兽帮我哼。再见”",
    "messageInitNick_9624": "打得不错",
    "randomEventDialogueGroupConfig_11.393": "有什么东西从它身上掉出来了。",
    "messageInitNick_9625": "可再生洗衣粉",
    "randomEventDialogueGroupConfig_11.394": "捡起离开",
    "messageInitNick_9622": "流浪的设计师",
    "randomEventDialogueGroupConfig_11.391": "有技巧地转",
    "messageInitNick_9623": "拉面制作者",
    "randomEventDialogueGroupConfig_11.392": "随便转",
    "messageInitNick_9620": "老实巴交",
    "messageInitNick_9621": "可爱的小猫咪",
    "randomEventDialogueGroupConfig_11.390": "“哇哇哇哇哇哇哇哇哇哇哇哇哇哇，太开心了。”",
    "messageInitNick_9628": "故事说给风听",
    "messageInitNick_9629": "幻想时间到了",
    "messageInitNick_9615": "全息菜刀",
    "messageInitNick_9616": "在逃放大器",
    "messageInitNick_9613": "文盲胜负",
    "messageInitNick_9614": "假期延长大师",
    "messageInitNick_9611": "电子花生糖",
    "messageInitNick_9612": "沧海浮华",
    "messageInitNick_9610": "西瓜之心",
    "messageInitNick_9619": "歇斯底里头",
    "messageInitNick_9617": "尖叫土豆",
    "messageInitNick_9618": "橙子去哪了",
    "messageInitNick_9604": "超级爆米花",
    "messageInitNick_9605": "桃子消灭者",
    "messageInitNick_9602": "正牌男友",
    "messageInitNick_9603": "唔识啪拖",
    "messageInitNick_9600": "搬砖使我快乐",
    "messageInitNick_9601": "假装爱过",
    "messageInitNick_9608": "搂着你数星星",
    "messageInitNick_9609": "有主之号",
    "messageInitNick_9606": "流浪的钩骨",
    "messageInitNick_9607": "电子口香糖",
    "monsterDes_588": "定位：输出，叠加增大体型\\n拥有吃得越多体型越大的特殊体质，害怕的东西有深水炸弹、水雷、有毒鱼类、水母、老默和比它大只的家伙。",
    "monsterDes_589": "定位：坦克，稳固，恒定击退\\n不同于它毫无攻击性的本体，它的本名极具攻击性，千万别随便对其他怪兽大喊它的名字！不过，喊它技能名的话，说不准它会现身助你一鱼叉之力~",
    "monsterDes_586": "定位：输出\\n注意看！这只怪兽也叫歧兽，来自遥远的西亚大陆，无论遇到什么怪兽它都会发起攻击，非常危险！千万不要靠近，尽可能离得远远的！以上这些……其实是它自己添油加醋后散播出去的谣言，事实上，它叫小美，因为色泽妖艳经常受到其他怪兽的欺凌，在听闻小帅的谣言后，特地装成小帅的样子行走于超进化大陆。",
    "monsterDes_587": "定位：输出\\n注意看！这只怪兽还是叫歧兽，来自遥远的西亚大陆，无论遇到什么怪兽它都会发起攻击，非常危险！注意！这不是谣言！它长得很像小帅，因此时常被小帅的谣言所误伤。在意外结识小帅和小美后，它更是为它们的经历感到愤愤不平，它想为自己和有同样遭遇的帅美回击这个充满谣言的世界，经过不懈的锻炼，它终于变成了小壮，它身体强壮内心却异常细腻，其他怪兽一个眼色，一丝声响，一点动静，它都会视作不怀好意的信号，并发起可怕的回击！",
    "monsterDes_584": "定位：输出\\n它是黑暗森林特有的危险，或是特别的馈赠，答案将由实践给出，由实力改写。击败觉醒凶兽获得漆黑源（超量）。",
    "monsterDes_585": "定位：输出\\n注意看！这只怪兽叫歧兽，来自遥远的西亚大陆，无论遇到什么怪兽它都会发起攻击，非常危险！请小心点，不要靠近。以上这些……其实是部分危险的草丛颠倒黑白散播的谣言，实际上，它叫小帅，因为外形奇特被危险的草丛孤立，它后来忍无可忍，逮着危险的草丛就会不由分说地发起攻击。",
    "monsterDes_582": "定位：输出\\n它是黑暗森林特有的危险，或是特别的馈赠，答案将由实践给出，由实力改写。击败究极凶兽获得漆黑源（大量）。",
    "monsterDes_583": "定位：输出\\n它是黑暗森林特有的危险，或是特别的馈赠，答案将由实践给出，由实力改写。击败不朽凶兽获得漆黑源（巨量）。",
    "monsterDes_580": "定位：输出\\n它是黑暗森林特有的危险，或是特别的馈赠，答案将由实践给出，由实力改写。击败幼体凶兽获得漆黑源（小量）。",
    "monsterDes_581": "定位：输出\\n它是黑暗森林特有的危险，或是特别的馈赠，答案将由实践给出，由实力改写。击败幻化凶兽获得漆黑源（中量）。",
    "monsterDes_599": "定位：输出，范围伤害，范围眩晕，玩偶协同\\n就在圣堂武士又双叒叕迎着攻击发动圣堂之躯之际，「系统」的声音在它脑中响起——\\n啷！检测到宿主第999次幻想用钱袋砸晕对手，是否考虑重启怪生？\\n（友情提示：再继续下去您的工钱就没了）\\n圣堂武士迟疑了（友情提示：再继续下去您的同伴也要没了）随后它立刻作出了选择。n→【是】[否] \\n[♠尖枪][♥法杖]→[♣巨斧]→【♦巨锤】\\n就这样，圣堂武士重生成了玩偶棋兵。\\n咔哒——它摇了摇头，却收不住猛然迈出的步子……",
    "monsterDes_597": "定位：辅助，治疗，负面效果持续时间降低，玩偶协同\\n就在圣堂武士又双叒叕迎着攻击发动圣堂之躯之际，「系统」的声音在它脑中响起——\\n咚！检测到宿主第999次幻想一击回复血量，是否考虑重启怪生？\\n（友情提示：再继续下去您的血条就没了）\\n圣堂武士迟疑了……\\n（友情提示：再继续下去您的同伴也要没了）\\n它立刻作出了选择。\\n→【是】[否] \\n[♠尖枪]→【♥法杖】[♣巨斧][♦巨锤]\\n就这样，圣堂武士重生成了玩偶棋兵。\\n咯哒——它拍了拍脸，却挥不去脑中不时响起的声响……",
    "monsterDes_598": "定位：输出，范围伤害，范围扣减能量，玩偶协同\\n就在圣堂武士又双叒叕迎着攻击发动圣堂之躯之际，「系统」的声音在它脑中响起——\\n哐！检测到宿主第999次幻想用脸帅倒一片，是否考虑重启怪生？\\n（友情提示：再继续下去您的帅脸就没了）\\n圣堂武士迟疑了……\\n（友情提示：再继续下去您的同伴也要没了）\\n它立刻作出了选择。\\n→【是】[否] \\n[♠尖枪][♥法杖]→【♣巨斧】[♦巨锤]\\n就这样，圣堂武士重生成了玩偶棋兵。\\n啪嗒——它揉了揉肩，却卸不掉后背的那股力道……",
    "monsterDes_595": "定位：辅助，召唤\\n很久很久以前，一群睡过头的鸟龙，错过了龙族最重要的喷火仪式，因此触犯了禁忌，在天火之罚后瞬间化成了鸟龙灵体。它们的命运就这样被永远指定，唯有被祭师召唤时，才能短暂归来——或点燃将灭的图腾圣火，或抵御攻击图腾的敌人。不管是当年的龙祭师，还是现在的龙执事，都特别喜欢那个召唤咒语：起床吧，我的鸟龙！",
    "monsterDes_596": "定位：输出，贯穿伤害，玩偶协同\\n就在圣堂武士又双叒叕迎着攻击发动圣堂之躯之际，「系统」的声音在它脑中响起——\\n叮！检测到宿主第99次幻想一击贯穿多兽，是否考虑重启怪生？\\n（友情提示：再继续下去您的武器就没了）\\n圣堂武士迟疑了……\\n（友情提示：再继续下去您的同伴也要没了）\\n它立刻作出了选择。\\n→【是】[否]\\n→【♠尖枪】[♥法杖][♣巨斧][♦巨锤]\\n就这样，圣堂武士重生成了玩偶棋兵。\\n咔嗒——它揉了揉眼，却拭不去视野中隐现的方格……",
    "monsterDes_593": "定位：输出，区域伤害，软化状态\\n“没有邀请蕉皮，你也敢踏入酋长联会？”\\n“守卫！快把这来路不明的东西赶出去！”\\n“四部之首马上出关，别让它污了首领耳目！”\\n在兽群中，围着裆布的笨拿拿神情平静。面对谩骂讥讽，它没说话，只是挥了挥叉骨权杖。四周怪兽的嘴瞬间被香蕉堵住。骂声顿止，取而代之的是咀嚼声和……感动。在这片香蕉至上的区域，越擅长催熟香蕉者的地位越高。而这绝顶香气、这柔滑熟度——唯有四部之首才能催出。突然意识到了什么的怪兽们瞪大眼，边吃边低头伏地：\\n“恭迎四大部族之首——！恭迎拿王归来！赞美拿王！赞美软化！”全场沸腾~",
    "monsterDes_594": "定位：辅助，范围伤害，范围回复能量，范围治疗，范围降低增益时间\\n它降生在信仰太阳的部族，不幸的是，在它出生那天，太阳被月亮吞没，大地被月影覆盖。酋长视为它不详之子，将其驱逐。幸运的是，信仰月神的部族萨满早已候它多时。当它接过月神的权杖时，月光缓缓在权杖上的显形。从此，它成为月影萨满，成为月神在大地的化身。",
    "monsterDes_591": "定位：输出，忽视减伤，护盾克星\\n屠刀锋利、刀法精准、切点精确、力道恰当等要素并不足以说明屠帝的恐怖，真正的恐怖是——俎上是你。",
    "monsterDes_592": "定位：辅助，全体能量回复降低\\n叉叉的“终有一天”来了，它进化了！曾经，它和其他叉叉一样努力进化，每失败一次它就在对应的方法上打×，逐渐×布满了整个巢穴。但它仍没有停下，它不会停下，就算整个世界都被×包围，它也绝不会停下！面对无数的失败，它确实感到绝望，可它总能在每一次绝望中看到了新希望。正是这些希望给了它进化的力量，现在叉叉将它的绝望分享出去，以激发其他怪兽内心的希望之光。它大概不会预料到，在突然出现的深渊中，这份力量将成为其中的一道新光。",
    "monsterDes_590": "定位：输出，吸收能量\\n娜迦曾向深渊许愿，要与所爱之兽永远在一起。“深渊”实现了她的愿望！娜迦从此不再孤单，她手中多了一柄长枪，一柄由她所爱之兽化作的长枪，再也无法离开她半步，因为长枪对能量的可怕渴望唯有她能满足。至于摄入的能量终将汇入何处，她毫不在乎。",
    "monsterDes_568": "定位：输出，免死\\n赤潮总会退去，可那没有意义，它早已带着毁灭降临。",
    "monsterDes_569": "定位：坦克，低血保护\\n曾经的守护星，如今的灾星。这是怪兽对它的认知，也是怪兽意志能影响的为数不多的东西。星落仍是原来的星落，它只是挪了块地，它只是坠落了。",
    "monsterDes_566": "定位：输出，低血终结\\n确实存在战区，确实存在的送葬者。",
    "monsterDes_567": "定位：辅助，己方怪兽死亡触发区域伤害\\n焚风所到之处，再无燃起之时。",
    "monsterDes_564": "定位：坦克，稳固\\n王·霸者将击退一切敌人，你也不会例外。",
    "monsterDes_565": "定位：输出，受击回血\\n站在食物链顶端的生物，任何怪兽在它眼里都是一块肉，区别只是好吃和不好吃。",
    "monsterDes_562": "定位：辅助，全体减速\\n来自炼狱的魔眼，没有怪兽能与其直视。\\n据说它的能力是连续通宵玩游戏七天练成的，一般怪兽不要学。",
    "monsterDes_563": "定位：输出，吸血\\n关于王·赤色狮的传说有很多，最可怕的莫过于“没有近战怪兽能打败王·赤色狮。”",
    "monsterDes_560": "定位：输出，王·朱丽叶死亡时全体秒杀\\n超进化大陆汉森家族掌门人的儿子，风流倜傥帅气逼人，与王·朱丽叶一见钟情。",
    "monsterDes_561": "定位：坦克，免伤\\n超进化大陆笔替家族千金，冷艳高贵，一双三米大长腿让王·罗密欧一见钟情。",
    "monsterDes_579": "定位：输出，自我定身并免疫击退\\n听说给吸盘兽一个足够大的力，它可以牵走任何星球。",
    "monsterDes_577": "定位：输出，范围减射程，范围减速，范围伤害\\n闪光爱好光腚，与圣光古龙关系非同寻常。",
    "monsterDes_578": "定位：坦克，己方怪兽死亡触发自我治疗\\n“你们的血绝不会白流。”",
    "monsterDes_575": "定位：坦克，降霸\\n掌握自身霸气的运用只是新世界的入门，掌控对手霸气的才是真正的霸王。（那个字读第四声，不读第一声。）",
    "monsterDes_576": "定位：辅助，减速\\n最喜欢0.75倍速了！",
    "monsterDes_573": "定位：输出，持续伤害\\n你好，毒毒毒毒毒毒。",
    "monsterDes_574": "定位：输出，范围伤害\\n逃跑就是最优秀的战术，溜溜如此坚信，不接受任何反驳。",
    "monsterDes_571": "定位：输出，区域伤害\\n草这个字必须带上括号进一步说明含义，草（源·危险的草丛）！",
    "monsterDes_572": "定位：辅助，全体能量回复提升\\n叉叉的“终有一天”来了，它进化了！不像有些东西长了五年，还是刚长出大腿。（智者注释：此处为NTFusion的自嘲，仅为激励自身持续进化，没有内涵、营养、反讽、抬杠、敌意、谜语人、暗示……希望大家能感受到他们这股强烈的进(qiu)化(sheng)欲！）",
    "monsterDes_570": "定位：辅助，己方怪兽死亡触发自我治疗和增攻\\n雷鸣，战场的丧钟。不要问丧钟为谁而鸣，它就是……",
    "monsterDes_548": "定位：输出，叠加缩小体型，免疫负面\\n你的小可爱突然超凶。",
    "monsterDes_549": "定位：辅助，高战点杀，封印\\n包租公身穿孖烟囱，脚踩人字拖，凳子上挂着的几大抽钥匙是它身份的证明，作为鸭笼城寨的King，大多数对手都被它一句“想训街还是想赢，自己拣咯。”解决。但这还不是它最可怕之处，依靠绝技“擒贼先擒最强那个”，专治各种不服。",
    "monsterDes_546": "定位：辅助，同命\\n不知道为什么，在玩狼人游戏时，它总能抽到丘比特牌，大概这就是量子纠缠吧。",
    "monsterDes_547": "定位：输出，范围伤害\\n仁拳大师与一拳超人最大的区别是，它蓄力前后都会告知同伴“请稍等…………………………………………………………\\n…………………………………………………………\\n………………可以上了。”",
    "monsterDes_544": "定位：辅助，范围减攻\\n藤妖喜欢种菜，只要在它围造的菜园里头，不管什么怪兽都会变菜，还有一些会变成肥料。",
    "monsterDes_545": "定位：输出，普攻延长增益时间\\n发现无敌的墙壁才是这个世界yyds后，墙神开始研究墙的秘密，后来习得了独一无二的墙边战术。",
    "monsterDes_542": "定位：辅助，范围减速，范围减疗\\n沼兽是沼泽的种子，它四处流浪直到死亡停下了它的脚步，之后它便扎下根来，成为新的沼泽。",
    "monsterDes_543": "定位：输出，范围持续伤害\\n火心没有倒下，温室效应就不会停止，来啊，赶紧解决它！",
    "monsterDes_540": "定位：辅助，远程近战切换\\n皮匠家族老大——陈龙，一个看到不完美的东西就想去亲自修理的完美主义者。当他看到虎皮匠和豹皮匠同时出现，就很想去收拾他们，因而爆发出巨大的力量！",
    "monsterDes_541": "定位：输出，范围持续伤害\\n妖火倒下时，真正的杀戮才开始，来啊，互相伤害。",
    "monsterDes_559": "定位：输出，全体伤害\\n蕴藏着强大能量的巨龙，每次发怒都会造成大量怪兽的毁灭，唯一害怕的是敌人驾驶飞行器撞击其肚脐。",
    "monsterDes_557": "定位：坦克，全体减伤\\n过去现在未来同在此刻，改命只是表象，冥冥中自有定数。",
    "monsterDes_558": "定位：辅助，随机技能\\n买个技能怎么了，Sorry，有这个技能就是可以为所欲为。",
    "monsterDes_555": "定位：辅助，治疗全体化\\n有福同享。",
    "monsterDes_556": "定位：输出，伤害均摊\\n有难同当。",
    "monsterDes_553": "定位：输出，多体伤害\\n花丸子号称“战场明灯”，它总是为大家指明方向。总之大家听着，它打的那些留着最后打！",
    "monsterDes_554": "定位：输出，触墙增伤，击退，减速\\n一击众生平等，墙神的好基友（未必。",
    "monsterDes_551": "定位：辅助，反转治疗效果\\n让治疗和有回复能力的怪兽感到害怕.gif",
    "monsterDes_552": "定位：输出，只有自己在场时超强\\n这件蜥蜴皮外套专为社恐设计，穿上之后能让怪兽迅速与环境融为一体。与其他怪兽进行社交的场合，外套上的两双假眼和一双真眼是混淆怪兽视线的利器，但有一定引来了更多目光的副作用。\\n皮匠家族特制的蜥蜴皮外套正火热销售中，不要错过！\\n社恐龙是一只披着蜥蜴皮的社恐龙，本体是蜥蜴皮外套，不会弹吉他。",
    "monsterDes_550": "定位：坦克，多体伤害，多体眩晕\\n锤子它爹，胆子小的会被它吓晕，个子小的会被它敲晕。",
    "monsterDes_528": "定位：输出，减速，缩小体型\\n我的体型要变大了，你坐啊！",
    "monsterDes_529": "定位：坦克，全体霸气\\n珍宝，珍宝，伟大的珍宝~~~~~~~",
    "monsterDes_526": "定位：输出，自我治疗\\n一个街头坏少年成长为英雄，最后封神，在其他游戏里这就是主角啊……",
    "monsterDes_527": "定位：辅助，范围伤害，范围减速\\neyes on me, plz!",
    "monsterDes_524": "定位：输出，全体减伤\\n▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆",
    "monsterDes_525": "定位：输出，叠加攻击\\n曾是一位伟大的英雄，遭小人迫害沦为怪兽，它的故事才刚刚开始……",
    "monsterDes_522": "定位：输出，全体增攻\\n霜之哀伤的死敌，总是一脸高兴。\\n口头禅“爱笑的怪，运气不会太差。”",
    "monsterDes_523": "定位：输出，全体增伤\\n键盘当然是用来互怼的（物理）！\\n鼠标当然是用来丢人的（物理）！",
    "monsterDes_520": "定位：辅助，增伤\\n金翅璞佳鸟的嘴巴，善于创造怪兽的弱点，嘻嘻。",
    "monsterDes_521": "定位：坦克，叠加霸气\\n异形的霸气基因产生了剧烈的变异，把自己都吓坏了。可怕的是，它的变异仍在继续……",
    "randomEventDialogueGroupConfig_59.2": "-",
    "randomEventDialogueGroupConfig_59.1": "你来到了南集市，准备瞄一眼这边的悬赏令，突然一只老咻咻冲了出来，手里拿着一张悬赏令在兽群中大声吆喝。",
    "randomEventDialogueGroupConfig_59.4": "-",
    "randomEventDialogueGroupConfig_59.3": "-",
    "randomEventDialogueGroupConfig_59.9": "上前看看情况",
    "monsterDes_539": "定位：输出，清除增益\\n皮匠家族三把手——豹耳，拥有能令语言变质的可怕能力，时常通过污染对手的话语压制对手。常与虎man进行对战，兽称DVD大战。",
    "monsterDes_537": "定位：输出，吸血\\n飞头蛮的吸血首让吸血鬼相当头疼，因为它没有脖子，而吸血鬼有。",
    "randomEventDialogueGroupConfig_59.6": "-",
    "monsterDes_538": "定位：坦克，清除增益\\n皮匠家族二把手——虎man，以一招不变的“你话点就点咯”应对战场上的万变局势。常与豹耳进行对战，兽称DVD大战。",
    "randomEventDialogueGroupConfig_59.5": "-",
    "monsterDes_535": "定位：辅助，全体减疗\\n生存还是毁灭，这是一个值得思考的问题。在我看来，你需要毁灭一下。",
    "randomEventDialogueGroupConfig_59.8": "求求你们了，救救我儿！智者跟我说，如果无法在一日内取得无归雪山上的雪朵入药，我儿就要和我永别了。各位好汉女侠，救救我儿！救救我儿！",
    "monsterDes_536": "定位：输出，反伤\\nMountainJo字Look号crazy，人称灭龙魔导士，曾一掌打死以阿库诺洛基亚为首的十八条恶龙，所有龙族都忌它三分。",
    "randomEventDialogueGroupConfig_59.7": "-",
    "monsterDes_533": "定位：输出，范围伤害\\n比蒙巨炮擅长毁天灭地，简单来说就是发射一堆比蒙巨兽。",
    "monsterDes_534": "定位：坦克，免疫负面\\n薛定鳄以陆龙为对象，进行了著名的薛定鳄的鳄的实验，他在漫长的实验过程中，掌握了量子态、变态等状态。",
    "monsterDes_531": "定位：输出\\n多么可怕的故事，多么骨感的现实，多么真实的伤害。",
    "monsterDes_532": "定位：输出\\n比蒙巨兽擅长把3D变为2D，简单来说就是一巴掌把什么拍扁。",
    "monsterDes_530": "定位：输出\\n莫名的被估值达10亿，不堪重负，最后……哎不说了是个可怕的故事。",
    "monsterDes_508": "定位：辅助，全体治疗\\n红唇，治愈伤痛，让你直通极乐哟!",
    "monsterDes_509": "定位：输出\\n很多怪兽都非常讨厌骑兵，相对的，喜欢用两条腿走路的。\\n（马：怪我咯？）",
    "monsterDes_506": "定位：输出\\n塞尔雷特的遗物，对手的“遗物制造者”。",
    "monsterDes_507": "定位：辅助，全体治疗\\nG代表全体，N代表动作，G-N代表 FANTASY！",
    "monsterDes_504": "定位：坦克，范围伤害，击退\\n最近没有经常被索要手机了，口头禅依旧是“你懂个锤子哟！”",
    "monsterDes_505": "定位：输出，贯穿伤害\\n滴滴嗒嘀嘀嗒，祖拉喜欢吹喇叭~",
    "monsterDes_502": "定位：输出\\n“期待阿叉进化！（它能我还远吗！）”",
    "monsterDes_503": "定位：输出\\n二次元深度热爱者&Cos什么都像自己的不知名Coser……",
    "monsterDes_501": "定位：无法定位\\n“终有一天，我会进化！”",
    "monsterDes_519": "定位：坦克，自我治疗\\n擅长舔和写日记……",
    "monsterDes_517": "定位：输出，低血点杀\\n它是只蜻蜓，龙是自己改的名字。",
    "monsterDes_518": "定位：辅助，全体加速\\n疾风兔太快了，身边的问号都追不上它。",
    "monsterDes_515": "定位：输出，击退\\n人间大炮一级准备，人间大炮二级准备，人间大炮，流一噶 哇噶忒ki哟 库啦诶！",
    "monsterDes_516": "定位：输出，低血终结\\n“镰刀是一个可怕的物种，忽然地图炮，忽然6+2。”——NGA日常记事",
    "monsterDes_513": "定位：辅助，治疗\\n巨人制杖天赋惊人。\\n由于近期击剑爱好者增多，听说正在学习贩剑。",
    "monsterDes_514": "定位：输出，偷取血量\\n没有小人，怎么衬托出巨人呢？",
    "monsterDes_511": "定位：输出，减疗\\n每顿都吃三只小羊的利爪狼。\\n最近爱上了一只喜欢雄鹿的兔子。",
    "monsterDes_512": "定位：坦克，偏移\\n有信仰所以无所畏惧，没有信仰所以无所畏惧。",
    "monsterDes_510": "定位：输出，区域伤害\\n来自遥远的西亚大陆，非常的危险，每天有不计其数的怪兽倒在这样的草丛边。",
    "messageInitContent_9829": "很随机昵称就是了",
    "messageInitContent_9828": "亵渎者当心！",
    "messageInitContent_9827": "祖灵在摸鱼",
    "messageInitContent_9826": "祖灵在打工",
    "messageInitContent_9832": "画个图腾————++++=========",
    "messageInitContent_9831": "献上你的愚昧",
    "messageInitContent_9830": "这不是还没到那个节日",
    "messageInitContent_9836": "祖灵在中路",
    "messageInitContent_9835": "祖灵在升级",
    "messageInitContent_9834": "什么在此一游",
    "messageInitContent_9833": "没有仪式的人，是游荡的尸壳",
    "messageInitContent_9839": "请祖灵原谅无知者",
    "messageInitContent_9838": "一群亵渎者（笑）",
    "messageInitContent_9837": "祖灵在聆听",
    "messageInitContent_9843": "感受先祖的音乐",
    "messageInitContent_9842": "感受先祖的舌头",
    "messageInitContent_9841": "感受先祖的拳头",
    "messageInitContent_9840": "感受先祖的触感",
    "messageInitContent_9847": "希望世界和平",
    "messageInitContent_9846": "希望早日暴富",
    "messageInitContent_9845": "伟大的先祖，请聆听我的愿望",
    "messageInitContent_9844": "感受先祖的轻抚~",
    "ancientCampaignName_5": "“小红帽”",
    "ancientCampaignName_4": "可怕故事",
    "ancientCampaignName_7": "世界名画",
    "ancientCampaignName_6": "踏入花丛",
    "ancientCampaignName_9": "大力打大力奶",
    "ancientCampaignName_8": "疯狂收割",
    "messageInitContent_9849": "你准备拿什么祭奠先祖",
    "messageInitContent_9848": "先祖不是肝爆机",
    "ancientCampaignName_1": "初遇比蒙",
    "98_-130012": "蜕变契约即将重置，无法购买",
    "ancientCampaignName_3": "它的剧本",
    "ancientCampaignName_2": "炮灰",
    "messageInitContent_9854": "祖灵会回应你",
    "messageInitContent_9853": "拒绝献祭者，将别献上",
    "messageInitContent_9852": "让先祖为您指路",
    "messageInitContent_9851": "又一个冒牌货",
    "messageInitContent_9858": "强者无需死者的指引",
    "messageInitContent_9857": "以骨为祭坛，以痛为祭品",
    "messageInitContent_9856": "骨与火，血与魂，祖灵在此，庇佑吾众",
    "messageInitContent_9855": "祖灵会回应你",
    "messageInitContent_9850": "先祖在此",
    "resoundEventStoryDes_300": "这个年轻的湖尚未被命名，又或者说，这里并没有能为之命名的怪兽。稍稍俯身就可以透过清澈的湖水直探湖底。一个部落遗迹无声地落在湖底，坍塌的木杆，倒地的石图腾忠实地记录着它们的经历，突如其来的地陷降临到这个部落，雨水慢慢将其埋葬，地龙的鸣叫在不远处回荡。",
    "messageInitContent_9859": "强者无需死者的指引",
    "messageInitContent_7202": "那是魔鬼的恸哭",
    "messageInitContent_9865": "祖灵不渴求物质，只渴求真实的你",
    "messageInitContent_7203": "怎么又回到这里了",
    "messageInitContent_9864": "亵渎者的灵魂将被永远放逐",
    "messageInitContent_7200": "依附在上面的是黑暗的童谣",
    "messageInitContent_9863": "献出你的怀疑",
    "messageInitContent_7201": "您听到了吗",
    "messageInitContent_9862": "亵渎者的灵魂将被永远放逐",
    "messageInitContent_7206": "难道我在绕着星公转",
    "messageInitContent_9869": "若你无法献上勇气，那就献出你的软弱",
    "messageInitContent_7207": "HUH？",
    "messageInitContent_9868": "怎么都在和空气聊天",
    "messageInitContent_7204": "我明明做好了标记，怎么会这样",
    "messageInitContent_9867": "不信祖灵，那你的痛苦将不被听见",
    "resoundEventStoryDes_309": "阳光透过摇曳在风中的植物落在大地上、石壁中、溪流间，留下随处可见的影子。影子化成了在平面世界随风摇曳的图景。也许这样的风景本来就是留给大地、石壁和溪流，难怪很少有怪兽会留意到它们。",
    "messageInitContent_7205": "兜兜转转回到原点",
    "messageInitContent_9866": "祖灵永不离弃",
    "resoundEventStoryDes_307": "“‘走过忘忧花的花田，将如同上翘的嘴角似的忘忧花轻轻挤开。随之晃动的忘忧花儿就会发出爽朗的笑声，不管是谁听到这一片汹涌的笑声，心情都会不禁好起来吧。’这话到底是谁传的，就过分它兄弟给过分开门，看见隔壁站着个离谱，过分到家，离谱上门了，连花都嘲笑我，心情怎么可能会好起来！”",
    "resoundEventStoryDes_308": "这是一种极其罕见的玫瑰，时刻散发着寒气，它们的花蕾上永远都挂着像是泪水一般的水滴，因此被称为哭泣的玫瑰，相传这种玫瑰的泪水能够治愈各种各样的伤口。",
    "resoundEventStoryDes_305": "乐，亦称雨临花，能预报雨天。小灌木，高半叉叉。叶薄，倒卵形，顶端短急尖，基部渐尖，两面无毛。花单瓣，花被片淡紫红色，有叉叉一巴掌大，二歧聚伞花序，无香。萼片长圆状披针形，基部合生成短萼筒。果近球形，萼片宿存。特喜欢雨天，暴雨倾盆之际争相怒放，因此乐开了花。",
    "resoundEventStoryDes_306": "如果仔细找寻，你就会发现不同的怪兽，有各自各异的修炼方法。\\n不过，大多数修行者都只是躺在那呼呼大睡而已。虽然……按某怪兽的说法，把睡眠当成是修炼的一部分就没问题了。\\n瀑布，作为俯冲地面的河流，就是一处相当受欢迎的修炼地点。怪兽试图在瀑布冲刷下感受力量。\\n如果怪兽的一生是一条河流的话，瀑布就是它们一生中最为跌宕起伏的部分。错落的地形让河流得以用瀑布的姿态纵身跃下，河流又反过来不断侵蚀着错落的地形。瀑布终将消失，河流趋于平缓。\\n这就是当时师傅的教诲，不对，应该还有一句，我想想，唔……\\n唔……\\n啊，我想起来了，它说——\\n不要在瀑布下睡着啊混蛋！",
    "messageInitContent_9861": "别在骨灰中寻找安慰",
    "resoundEventStoryDes_303": "据说在很久很久以前，这里曾经是一片汪洋，如今只有一个时隐时现的盐湖留在这里，因而得名一溜盐湖。\\n大部分时候在你眼前铺开的都是裸露着的石盐矿床，但如果赶上下雨天，赶上天空趁着雨势侵入地面。那么可以试着躺在浅浅的湖面上，感受世界将你包围，阅览沿着地平线打开的天空之书。",
    "messageInitContent_9860": "每一次流血，都是通向祖灵的祷告",
    "resoundEventStoryDes_304": "那天，一只轰龙飞着飞着撞上了岩壁，随后晕倒，坠落，倒在了一块烧红了的石板之上。轰龙在朦胧间被一阵浓烈的香气唤醒，猛然向香气的来源处咬去。“真香，唔，但好疼。”它咬住了自己的尾巴。",
    "resoundEventStoryDes_301": "此处的四眼毒泉指的并非是哑泉、灭泉、黑泉、柔泉，而是特指污妖王洗漱时所泡过的泉水，因为其倒映在水中的双眼，一共有4只眼睛而得名。泉水的毒性并不亚于上面提到的4口泉水，其水如墨，怪若碰之，轻则恶心数日，反胃数日，重则当场逝去。\\n幸亏这个毒泉较为显眼，并不难躲避。多被用作对战期间的战略地形，小心别被丢进去哦。",
    "resoundEventStoryDes_302": "玛咖果盛产于雨水充足的地区，呈梨形，十二个月相盈亏一熟，味极苦。吃下玛咖果以后身上就会泛起阵阵星光，好似化作了落在地表的迷途之星。入夜以后效果更为明显，不过时效有限，只能维持一小会。",
    "resoundEventStoryDes_310": "不久前，一场暴雨的洗刷以及几头雨中奔跑的比蒙巨兽共同打“打造”了这个新鲜的泥场，几个深浅不一的大小泥坑错落有致地铺开，有的怪兽摊在其中，有的泡在之中，有的跳入泥浆中打滚、嬉戏，有的晒着泥浆浴。\\n阳光与清爽的风一点点带走泥场的水分。于是，泥场开始了它的想念。它想念一场雨，即便这雨滂沱不已，直至这雨将它冲散。",
    "resoundEventStoryDes_311": "这座是天堂山，云海、云河并非什么罕见的景象，在春冬两季，攀上一座空气湿润的不矮山巅，即可俯瞰广阔的云顶。可是，湍急如此的云海独此仅有。看起来，就像是将数日的云海，只用数秒欣赏完一般。又或者说，就像是悠然的云海突然在什么的催促下，开始疯狂加速。转眼数年。",
    "messageInitContent_7208": "谁在呼唤",
    "messageInitContent_7209": "内心的躁动",
    "messageInitContent_7213": "不许说话",
    "messageInitContent_9876": "只有胆小鬼才把恐惧献给虚无",
    "messageInitContent_7214": "不准出声",
    "messageInitContent_9875": "火焰熄灭之前，谁也不能说话",
    "messageInitContent_7211": "啊绝不让您束缚我的灵魂",
    "messageInitContent_9874": "只有无知的人才会质疑祖灵的存在",
    "messageInitContent_7212": "尖叫吧",
    "messageInitContent_9873": "不信祖灵，那你的痛苦将无人听见",
    "messageInitContent_7217": "永远沉默",
    "messageInitContent_7218": "███████████████████████",
    "messageInitContent_9879": "路过路过",
    "messageInitContent_7215": "别发言",
    "messageInitContent_9878": "太阳升起，先祖便来到我们之间",
    "messageInitContent_7216": "沉默吧",
    "messageInitContent_9877": "下一关gogo",
    "resoundEventStoryDes_318": "这种名为神木的常绿植物，生命力顽强，四处可见，它的茎不分枝，数量不等的一回羽状复叶从茎的顶部长出。\\n神奇的是，除了初生和凋落的时候，神木在整个周期内的叶片数都是不变的，叶片数量在1-20间。\\n一些怪兽热衷于收集神木的种子解决难以抉择的问题，它们种下抽到的种子，待它生长完全后，根据叶片数量确定最终的结果。",
    "resoundEventStoryDes_319": "捣蛋鬼是一种生长在角落，难以观测，推测可能存在的植物。如果你经过某个角落，发现有什么推了你一把，那多半就是它了。当然回过头的时候，什么都不会看见。智者曾经邀请疾风兔一同揪出捣蛋鬼的真身，它们分别从角落的两边包抄，却依然什么都没有发现。",
    "resoundEventStoryDes_316": "地面上覆满了歪扭的藤蔓，一些细长不能直立的茎缠到了附近的树木上，如同瀑布般从树木的枝头洒落。\\n稍微靠近就可以闻到，藤蔓上面挂着的爆浆果的清甜香气。这种很像强化孢子的红色果子富含水分，非常甜。\\n找懂行的怪兽问问就会知道，吃掉爆浆果是一种浪费，它的另一魅力绝对远超味蕾上的享受，只要试过一次就再也无法拒绝，那就是用手捏爆果子。\\n果肉在手心的炸开，巨量红色果浆从指缝射出，一颗两颗三颗……",
    "resoundEventStoryDes_317": "“对对，就是那个长满青苔的洞穴，看到了吗，里面有两块圆石的那个，现在可以眨眼了，看到了吗？那两块圆石发出了红光。然后再试试眨眼，是吧，洞穴消失了！估计是太过害羞所以躲了起来。再眨眼试试，是吧，它又出来了。”——不知道哪里传来的对话声",
    "messageInitContent_9872": "我宁愿相信自己的双手，也不信看不见的鬼魂",
    "resoundEventStoryDes_314": "希望之花是一种非常受怪兽喜爱的花，准确来说受欢迎的是它的梗。希望之花的梗非常柔韧、轻便、不易断裂，经过简单的去叶，风干，揉搓之后即可使用，被广泛用在各种地方，例如用作兽皮的缝合线、包裹的肩带、树梯等等。",
    "messageInitContent_7210": "我在俯瞰大地",
    "messageInitContent_9871": "祖灵正在检视你的灵魂",
    "resoundEventStoryDes_315": "平地上伶仃长着三棵树，其中一棵笔直笔直的，另外两棵长得弯弯曲曲的。这三颗树被一个粗糙的围栏围了起来，上面挂着超进化委员会的牌子。\\n牌子的如此写道：心树，因树叶是心形得名，王·罗密欧王·朱丽叶为了独占这些心树，对这个树种采取了毁灭性的破坏行动。最后剩下的三颗，在超进化委员会的沟通下，得到了收容和保护，如果没有外力的帮助，它们将会是这个区域中最后的三棵独苗。\\n之所以说它们是独苗，因为这是一种雌雄异株的植物，雌蕊和雄蕊不在同一棵植株上。它们都是雄植株。\\n——白昼",
    "messageInitContent_9870": "还没演累吗",
    "resoundEventStoryDes_312": "确实，这里什么都没有了。但从前，这里曾经是一片延绵不绝的，反射着太阳光芒的金黄山脉，这片山脉极易风化，即便是最柔和的微风，对于这片山脉也如同致命的利爪，轻轻拂过就能刮起一阵细碎的沙尘。这股沙尘在阳光底下，扬起了一股金黄的风。虽然现在这里只是一片普通的平地。但也有怪兽这认为，这股风已吹遍大地。",
    "resoundEventStoryDes_313": "龙颚峡谷极深，一条成年的钢铁龙王全速向上飞行，抵达峡谷顶部需要半日，其横向宽度最宽处仅能容纳3只叉叉穿过，如同一条侧卧巨龙的微张两颚，细窄的溪流是巨龙的口水，在峡谷最底部焦急流淌；夹岸陡峭异常的嶙峋怪石是巨龙的锋牙。\\n后来，一颗小小的种子的到来改变了这个峡谷的名字，这棵种子迅速生根发芽，野蛮生长，原本留给太阳不大的空隙已经完全被枝节交错的古藤盘绕遮蔽，白日被拉入了永恒的夜色之中，而无知路过的怪兽则被这种食兽藤拉进了它们的“胃袋”之中。",
    "resoundEventStoryDes_321": "这座山的山崖名为无限斗崖，上面原来有两块相对而立的石头，相传是从前有两只怪兽在这里决斗，它们都是强手中的强手，高手中的高手，它们谁都没有出招，一方预判了另一方的预判，另一方预判了一方预判了它的预判，一方又预判到了另一方预判了它预判了另一方的预判，就在漫长的预判对决中，变成石头，永远地对抗着。\\n就在不久前它们分出了胜负，御空不小心吹倒了左边的那个石头，现在右边的石头没有了对手，山崖的名字倒还是原来那个。",
    "resoundEventStoryDes_322": "在超进化大陆的湖边不时会出现这种牌子，“向这里丢入你最爱的宝贝吧！金币，孢子都可以，湖底的精灵就会给予你祝福，如果你之后仍然不够幸运，那就再多投入些宝贝！——湖底精灵”。\\n同时出现的还有那些往湖底丢宝贝的怪兽，一些是相信湖底精灵真实存在的怪兽，一些是“湖底精灵”。",
    "resoundEventStoryDes_320": "阴暗的洞穴里，闪烁的荧粉勾勒出无数怪兽骨头的轮廓，那是死亡草的荧粉，死亡草枯萎之后留下的痕迹。\\n之所以被称为死亡草，并不是因为怪兽在借助重生元核复活时在黄泉路上曾看见过它，而是单纯的，只是因为它生长在死去的怪兽尸骸之上而已。\\n它依靠怪兽尸体上的残余能量存活，长有死亡草的尸体会迅速变成骨头。\\n这些叶片如同水母一般晶莹剔透的死亡草，从发芽到凋谢不过数十秒，只生长在昏暗的地方。传闻说只要看见死亡草就会被厄运缠上。\\n所以说，遇见死亡草的荧粉，意味着与厄运擦肩而过。",
    "messageInitContent_7219": "███████████████████████",
    "98_-130007": "到达购买上限",
    "98_-130002": "不定项内购金额小于0",
    "98_-130001": "非内购项",
    "98_-130004": "不存在的订单",
    "98_-130003": "发起金额与回调金额不一致",
    "messageInitContent_7224": "别……",
    "messageInitContent_9887": "震怒之日",
    "messageInitContent_7225": "别过来",
    "messageInitContent_9886": "你颤抖的手，是先祖的震怒",
    "messageInitContent_7222": "████████",
    "messageInitContent_9885": "祖灵永不离弃",
    "messageInitContent_7223": "████████████",
    "messageInitContent_9884": "与祖先共鸣",
    "messageInitContent_7228": "古老的印记开始浮现",
    "messageInitContent_7229": "那是比遥远更为遥远的禁忌印记",
    "messageInitContent_7226": "别靠近",
    "messageInitContent_9889": "每个岛信奉的东西都很神奇",
    "messageInitContent_7227": "离我远一点啊啊啊啊啊",
    "messageInitContent_9888": "所以到底是祖先还先祖还是祖灵",
    "resoundEventStoryDes_329": "小鱼对着大鱼嘴巴一张一张，大鱼的嘴巴也对着小鱼一张一张。\\n小鱼说，总是有很多想法从它嘴里冒出来，例如……想试试泥土的味道啊；想试试水草的味道啊；想要那块石头啊；想要一个自己的洞穴啊；想和那边的小鱼做朋友啊。大鱼大鱼，怎么才能不让这些想法冒出来呢？\\n大鱼回答说，我可以帮你把想法都吃掉。然后小鱼就被大鱼吃掉了。\\n超进化大陆的鱼会不会说话不好说，但桐仁铁定听不懂，能确定的是，这是桐仁看到的某个鱼塘。",
    "resoundEventStoryDes_327": "智者、莎士彼亚、桐仁在一块大石头旁蹲了好几天了。\\n智者：“羡慕这泉。”\\n莎士彼亚：“为啥？”\\n智者：“一个月只出来干一天活。”\\n莎士彼亚：“你还不是天天闲着，说起来我的灵感更离谱，从不出来干活。”\\n桐仁：“所以你们蹲这里是干嘛？”\\n智者：“听说这里的泉水可以旺财。”\\n莎士彼亚：“听说这里的泉水可以带来灵感。”\\n桐仁：“知道你们不是蹲御空我就放心了。”",
    "resoundEventStoryDes_328": "按照桐仁的说法，心情不好的时候，可以借助这颗石头让心情变好。找个安静的地方，将止痛石拿在手心，然后把让你痛苦的事情向止痛石倾诉，再把止痛石埋起来就大功告成了。\\n（*该行为存在巨大争议）",
    "messageInitContent_7220": "█████████████████████████████████████████████████████████████████████",
    "messageInitContent_9883": "与先祖共鸣",
    "resoundEventStoryDes_325": "“A就是个世间罕见的【哔】。”“B是神一般的【哔】。”“这种鬼话你说出来你自己信吗，你有【哔】就在我面前【哔】。”“我【哔】你【哔——】。”“……”\\n——这一树洞位于有名的哔哔圣地，它记录的是许久之前一场旷日持久的骂战，如果希望您的【哔】【哔】【哔】记录可以永世流传，可以来这个树洞进行挑战，据说如果【哔】得比原来的更高更快更强，就会被哔哔树洞记住并复述。\\n目前还没有怪兽挑战成功。",
    "messageInitContent_7221": "███████████████████████",
    "messageInitContent_9882": "仪式未完，不得离开",
    "resoundEventStoryDes_326": "“是的，这片大地上有许多不可思议的景象和事物。大家自然而然地给出解释，将不可思议伪装成万灵刻下的祝福、诸神行于凡间的痕迹、古神不经意的吐息、星球降怒的预兆、狂风袭来的启示等等。我当然不例外，可我想用自己的方式去解读，而不是用另一种未知掩盖原来的未知，去揭开背后的秘密。那座有六个太阳，六个月亮的森林正是我的目标。在某天的日落时分，我亲眼看见了六个太阳，实际上是三个，另外三个映在了森林中心的湖里。另外，我还得知冰霓曾在这里出没，而冰霓出没的时间点和六个太阳出现的时间高度吻合……我好像知道了……锥晶……这是我还活着的时候特地刻下的碑文，如果你等会看到我的尸骸，答应我，将我埋葬，不管它还会不会动——您亲爱的陌生怪兽。”\\n这就是刻在无名森林中央的石碑上的歪扭碑文。",
    "messageInitContent_9881": "我是原始人之王",
    "resoundEventStoryDes_323": "如果你走在路上，突然听到什么声音，却没看到半只怪兽。别慌，先看看周围是否有一处的白色花丛。它们非常不起眼，存在感极低如同空气，所以你要仔细去找。它们偶尔会记录它们听到的声音，偶尔又会将这些声音重现，可能是怪兽的交谈，可能是战斗的嘶吼，可能是风的私语。",
    "messageInitContent_9880": "带着祖灵的祝福，踏上旅途",
    "resoundEventStoryDes_324": "无数未摘花摇曳在风中，仿若一片失温的火海，不带一丝温度。未摘花的美是多层的，存在于每个角度每个时刻每个距离，以及由角度时刻距离构成的无限可能之中，让怪兽不禁久久驻足，直到它们回过神来，要将未摘花据为己有。似乎为了嘲笑怪兽的占有欲，与植株分离的未摘花瞬间化作粉末，像燃尽烟尘般散去，不带半点星火。",
    "resoundEventStoryDes_332": "天使掌心在众多怪兽口中的“奇迹”中诞生，但怪兽更愿意相信那是某位巨大的神灵在超进化星无意间的一拍，这一拍让那个地方充满了神灵的祝福——被扯掉的肢体可以在祝福中再生，即便是失明亦能再见光明，濒死之兽重拾生命……可天使掌心到底在哪里呢，没有谁能说清楚，共同的说法只有一个，天使掌心周围的景色会不断变化，极具迷惑性，可谁能指出一处没有环境参考物的地点的所在，奇迹吗？",
    "resoundEventStoryDes_333": "与虚无缥缈的天使掌心传闻相比，歌女之泉显然实在很多。受伤的怪兽要在歌女之泉中获得治愈疗伤方面的帮助并不困难。\\n歌女之泉分布很广，十分好找。\\n在歌女之泉中治愈怪兽的是一群G-N，它们大多热爱歌唱，并且毫不吝啬于向它们的患者展现歌喉，聆听G-N的歌唱是进行治愈前必须要经过的仪式，至少G-N是这么告诉它们的患者的。\\n不过，据说失去意识或者听觉有问题的怪兽不需要这个仪式。",
    "resoundEventStoryDes_330": "总是会沦为美食世界的冒险好去处，有能吃和不能吃的生物。",
    "resoundEventStoryDes_331": "将好吃的果子放到由大片叶子制成的装载具上，再将装载具放到运河之上，用不了多久这些好吃的果子就会被送到咻咻所在的部族中。\\n这条运河从长有好吃的果子的灌木延展至咻咻部落的所在，里面挤满了不断翻滚的咻咻，这条黑色的运河就是它们。",
    "messageInitContent_7235": "浮沉沉沉沉沉沉沉沉沉沉沉",
    "messageInitContent_9898": "你准备拿什么给先祖",
    "messageInitContent_7236": "拼命想要抓住的东西已经不在",
    "messageInitContent_9897": "铭记先祖恩赐",
    "messageInitContent_7233": "下坠上浮",
    "messageInitContent_9896": "念念不忘",
    "messageInitContent_7234": "下沉下沉下沉下沉下沉下沉下沉下沉下沉",
    "messageInitContent_9895": "祖灵永不离弃",
    "messageInitContent_7239": "大地被天空撕裂",
    "messageInitContent_7237": "谁能拉我一把",
    "messageInitContent_7238": "天空被大地所劈开",
    "messageInitContent_9899": "与祖先共鸣",
    "messageInitContent_9890": "一场仪式，就是一次重生",
    "resoundEventStoryDes_338": "巨大的沙漠海葵就栖息在这里，这座沙漠之中。沙漠边缘偶然出现的沙漠海葵尸骸，为怪兽提供了一个窥探它全貌的机会，它呈圆柱形，底部有封闭的基盘，沙漠海葵通过这个部位稳稳地附着在沙漠下方的岩层上，然后进行短距滑动。开口端，也就是顶部口盘，上面长着一圈又圈尖触手。它可能是就是借助这些尖触手感知进化孢子的位置，同时将它们送到消化腔之中。\\n它们吃的“进化孢子”常常会带有一直叫“怪兽”的杂质，由于无法吸收，它们会顺便将之排出到沙漠的另一头。",
    "resoundEventStoryDes_339": "这片与崖壁相接的土地中，长有一种叉叉拳头大的豆子，被叫做土豆。一些瓜藤在土地边的崖壁上肆意生长延展。瓜藤硕果累累的日子，一阵调皮的狂风吹来，攀得老高的瓜藤被吹得直晃，那上面的瓜如同流星般疯狂地砸向地面，把地底的土豆都压扁了。",
    "messageInitContent_7231": "打开松动的封印",
    "messageInitContent_9894": "三场仪式，就是三个嗜血",
    "resoundEventStoryDes_336": "夜幕是不变的布景，但今夜星月退场，舞台倒置，投向大地的弧形浅湾。半空中，她是唯一的观众。她舒展双翼，倒吸了一口气，仿佛这是平生首次看见眼前的景象。层层浪涌包裹着蓝色的荧炎，温柔地扑向森林的怀抱。荧炎追逐着浪尖，渲染出变换莫测的水纹。只要她愿意，她能让景色一直循环下去，但她会等待，等待下一次。独占风景，是她唯一的任性。",
    "messageInitContent_7232": "迎接伟大的███████",
    "messageInitContent_9893": "三场仪式，就是三个无损",
    "resoundEventStoryDes_337": "这座沙漠附近的怪兽都知道，横穿沙漠的方法，它们也非常乐于把方法告诉些给它们送去进化孢子的怪兽。方法就是准备更多的进化孢子，怪兽们只需要走到沙漠边缘，将尽可能多的进化孢子投入沙漠之中，推荐使用到池塘喂鱼的动作。然后稍等一会，某股力量就会将你带去沙漠的另一端。期间会有一阵据说会很容易上瘾的类似吃撑的溺水麻痹感，沙漠附近的住民都是其成瘾者。",
    "messageInitContent_9892": "两场仪式，就是一次暴怒",
    "resoundEventStoryDes_334": "请务必躺在这看星空！\\n推荐这里的原因只有一个，这里没有那种会吸血的可恶的嗡嗡叫的飞虫！",
    "messageInitContent_7230": "是时候开始了",
    "messageInitContent_9891": "一场仪式，就是一次救赎",
    "resoundEventStoryDes_335": "鲜少会有怪兽牟然闯入陌生的区域，可这座森林显然就是为了驱逐那些例外，做足了准备。一些热心的怪兽会以此森林“来无去”的传闻警告入侵者。若警告无效，它们会看到入林必经之路上那些可怕的残骸，或者落入分布密集的陷坑之中。如果这还不足以吓退它们，等待它们的便是半遮半掩的遗迹或是宝藏痕迹的诱导。至于这座森林的最后一道防守，自然是那布置这一切的怪兽。",
    "messageInitNick_904": "牵你看日落",
    "resoundEventStoryDes_343": "荒漠的大地一点点将太阳吞没，一支踩在地平线上的怪兽队伍静默前行，在残留的天幕下镂出不带细节的黑色的空洞。沙随风，风起沙扬，风息沙落。这支一只跟着一只的怪兽队伍如沙一般，随风行或止。准确来说，它们正寻着某个难以描述的声音的源头前进。毫无预兆大小不一的短促尖声，毫无规律的怪异调子，暧昧不明的低鸣引导它们来到一处形状怪异布满孔洞的巨大岩石之前。这群怪兽中爆发了一阵骚动，但很快又安静了下来。它们找到了神留给它们的音匣，仪式要开始了。",
    "messageInitNick_905": "沸点",
    "resoundEventStoryDes_344": "同一地点，时间稍微往前推移半个日月，一只心情郁闷的人间大炮对着一块巨大的岩石狂喷了一轮，又喷了一轮。它觉得自己的心情稍微好多了，便离开了。",
    "messageInitNick_906": "全幼儿园最萌",
    "resoundEventStoryDes_341": "见花是一种同一枝上长有两朵花的植物，其中月见花在月亮出来时开放，日见花会在太阳出现时开放，而日月同辉的时候它们就会一齐盛放。",
    "messageInitNick_907": "开始安静",
    "resoundEventStoryDes_342": "月见花和日见花亦被怪兽称为舞见花与唱见花，一些喜欢唱歌跳舞的怪兽会在见花前唱歌或舞蹈，它们认为花开的数量越多意味着唱得越好或者跳的越好。",
    "messageInitNick_908": "单眼皮男孩",
    "messageInitNick_909": "宇宙风",
    "resoundEventStoryDes_340": "土豆中有个特别的品种叫服。这种土豆能够和钻石发生一种神奇的反应，钻石与土豆接触后，会对这种叫服的土豆造成爆炸性伤害。如果哪里的叫服的土豆炸了，一定就能看到这种钻石。这些炸过的土豆可是非常的好吃哦。",
    "messageInitNick_900": "不选择逃跑",
    "messageInitNick_901": "迷路的辅助",
    "messageInitNick_902": "就爱葛优躺",
    "messageInitNick_903": "飞天猪",
    "messageInitContent_7246": "天还来",
    "messageInitContent_7247": "补充点阳间评论",
    "messageInitContent_7244": "我看这些人演了一路",
    "messageInitContent_7245": "醉了",
    "messageInitContent_7248": "会跑的凳子",
    "messageInitContent_7249": "哈人",
    "resoundEventStoryDes_349": "超星海洋，超进化星上最广阔的水体总称，谁都不知道澄碧无边的海里是否还存有另一个怪兽世界。\\n比起这个，陆上的怪兽更关心能不能在海边捞到一些奇怪的好东西。少数怪兽知道这些东西的秘密，它们来自另一个位面。而这在这小数怪兽之中的大多数知道，另一个位面不过是一个地名，只有剩下的小部分怪兽确切地理解到“另一个位面”的真正意义。",
    "messageInitContent_7242": "阴影在角落中沸腾",
    "resoundEventStoryDes_347": "这是一片粉色的树林，隔壁的树林是绿色的，它常常因为自己的颜色感到与周围格格不入。颜色可能决定了它在位置，也不排除是它的位置决定了它的颜色。\\n粉色的树林会更害羞吗，想知道可以可以多戳几下试试。",
    "messageInitContent_7243": "缠绕攀爬紧勒",
    "resoundEventStoryDes_348": "“不可以瑟瑟？那就只能发抖了呢。”\\n“啊忘记了，这里的树林是不会说话的！”\\n不再有动静。",
    "messageInitContent_7240": "时间被幻觉吞噬",
    "resoundEventStoryDes_345": "永生花，永远不会凋谢的花，总会有怪兽觉得它不是真正的花，因为怎么可能会有能时刻保持着盛放的鲜花呢，每一个今日都如同往日，就好像永远活在某个瞬间，亦好似永远停在某个瞬间，没有丝毫变化。",
    "messageInitContent_7241": "异星的声响在冲撞",
    "resoundEventStoryDes_346": "永生花的秘密在于巧妙地死亡，日夜交替之际，旧的花朵会迅速凋谢，而新的花朵同时迅速在原来的位置重新绽放，这个过程只有数秒，悄无声息。",
    "propConfigName_90104": "蓝色攻击力元核碎片",
    "propConfigName_90103": "绿色攻击力元核碎片",
    "propConfigName_90102": "白色攻击力元核碎片",
    "propConfigName_90107": "红色攻击力元核碎片",
    "propConfigName_90106": "橙色攻击力元核碎片",
    "propConfigName_90105": "紫色攻击力元核碎片",
    "messageInitNick_7399": "沙棘果真好吃",
    "messageInitNick_7398": "少女的脸庞",
    "messageInitNick_7395": "标题五个字",
    "messageInitNick_7394": "噬菌体跑了",
    "messageInitNick_7397": "菜配送员到了",
    "messageInitNick_7396": "丨轮回丨",
    "messageInitNick_7391": "鼠标先锋",
    "messageInitNick_7390": "最爱柠檬",
    "messageInitNick_7393": "茄子怪客",
    "messageInitNick_7392": "欢快的猕猴桃",
    "messageInitContent_9803": "到处都在搞奇怪仪式",
    "messageInitNick_7388": "格式化淡忘",
    "messageInitContent_9802": "献上我的所有肉肉山",
    "messageInitNick_7387": "一起变胖",
    "messageInitContent_9801": "献出你的软弱，祖灵将赐予勇气",
    "messageInitContent_9800": "如果祖灵存在，为何你们还这么害怕黑夜",
    "messageInitNick_7389": "极窄宽带",
    "messageInitContent_9807": "先祖喜欢咖啡吗",
    "messageInitNick_7384": "梅开二度",
    "messageInitContent_9806": "烟雾中自有答案",
    "messageInitNick_7383": "窗外的晴天",
    "messageInitContent_9805": "你不相信先祖？那你从何而来",
    "messageInitNick_7386": "初夏微暖",
    "messageInitContent_9804": "先祖指引我！拥有低种双红盘的未来",
    "messageInitNick_7385": "那我走",
    "messageInitNick_7380": "鼻涕大佬",
    "messageInitContent_9809": "先祖可能吃kfc",
    "messageInitNick_7382": "水果观察者",
    "messageInitContent_9808": "先祖吃强化孢子吗",
    "messageInitNick_7381": "宠臣",
    "messageInitContent_9810": "祖灵在哪？我只看见疯狂",
    "messageInitContent_9814": "这个年代需要文明",
    "messageInitNick_7377": "外向孤独患者",
    "messageInitContent_9813": "先祖需要更新",
    "messageInitNick_7376": "不倾国的女子",
    "messageInitContent_9812": "我只信刀锋，不信骨灰",
    "messageInitNick_7379": "懒喵喵",
    "messageInitContent_9811": "祖灵在聆听",
    "messageInitNick_7378": "尖椒萝卜",
    "messageInitContent_9818": "感受红唇的热吻",
    "messageInitNick_7373": "量子手表",
    "messageInitContent_9817": "感受先祖的热吻",
    "messageInitNick_7372": "刀恋孤光",
    "messageInitContent_9816": "感受先祖的亲吻",
    "messageInitNick_7375": "吃货萌比",
    "messageInitContent_9815": "感受先祖的指引",
    "messageInitNick_7374": "残风冷月",
    "messageInitNick_7371": "鸡头贼稳",
    "messageInitContent_9819": "感受先祖的亲吻~",
    "messageInitNick_7370": "倚栏听风叙",
    "messageInitContent_9821": "祖灵在偷笑",
    "messageInitContent_9820": "惹",
    "messageInitNick_7369": "魔女的黑店",
    "messageInitContent_9825": "你否定祖灵，祖灵将剥夺你的名字",
    "messageInitNick_7366": "绝对的真心",
    "messageInitContent_9824": "与先祖共鸣",
    "messageInitNick_7365": "纯粹白痴",
    "messageInitContent_9823": "不许否认先祖",
    "messageInitNick_7368": "甜咸薯片",
    "messageInitContent_9822": "谁在亵渎祖灵",
    "messageInitNick_7367": "大时光",
    "messageInitNick_7362": "引战先驱",
    "messageInitNick_874": "抱着猫的老鼠",
    "messageInitNick_7361": "掩护我撤退",
    "messageInitNick_875": "众包偶像公司",
    "messageInitNick_7364": "修行者",
    "messageInitNick_876": "镜里花难折",
    "messageInitNick_7363": "断翅天使",
    "messageInitNick_877": "小醋包",
    "messageInitNick_878": "红颜纷扰红尘",
    "messageInitNick_879": "跟在小兵后面",
    "messageInitNick_7360": "假如有明天",
    "messageInitNick_7359": "一百香果",
    "messageInitNick_7358": "你好幼稚",
    "messageInitNick_7355": "精神王者",
    "messageInitNick_870": "晒月光",
    "messageInitNick_7354": "龙眼魔法",
    "messageInitNick_871": "冬日凉凉",
    "messageInitNick_7357": "千里追魂",
    "messageInitNick_872": "超级辣条",
    "messageInitNick_7356": "迷人小祖宗",
    "messageInitNick_873": "当淑女不容易",
    "messageInitNick_7351": "外星人摄影师",
    "messageInitNick_885": "北极星的泪",
    "messageInitNick_7350": "时空在呼吸",
    "messageInitNick_886": "黑豹",
    "messageInitNick_7353": "这假的吧",
    "messageInitNick_887": "巷子里的画家",
    "messageInitNick_7352": "胡萝卜先锋",
    "messageInitNick_888": "对线小能手",
    "messageInitNick_889": "痛苦面具",
    "messageInitNick_7348": "开心超人",
    "messageInitNick_7347": "十五了",
    "messageInitNick_7349": "床垫会跑",
    "messageInitNick_880": "哟小哥",
    "messageInitNick_7344": "脑电波电台",
    "messageInitNick_881": "认证跟风专家",
    "messageInitNick_7343": "半面妆",
    "messageInitNick_882": "头铁爱好者",
    "messageInitNick_7346": "寂寞仙哥",
    "messageInitNick_883": "打脸天后",
    "messageInitNick_7345": "不合群小姐",
    "messageInitNick_884": "风信子",
    "autoConfig_8": "{1}的进化光谱",
    "autoConfig_9": "独属于{1}的进化光谱，拨动那根试图凌驾光谱的谱线，超越进化。\\n「用于{2}超进化」",
    "autoConfig_6": "收集{1}块可合成{2}的觉醒结晶，{3}的觉醒结晶，需要{4}和{5}的力量进行觉醒。",
    "autoConfig_7": "想选谁就选谁，俗话说得好“有得拣先至系老板！”，现在你是老板啦！",
    "autoConfig_4": "相传齐集{2}和{3}后，可使用该结晶进行融合觉醒进化，{1}将会降临。\\n「用于{5}或{6}进化为{4}」",
    "messageInitNick_7340": "殷语学家",
    "messageInitNick_896": "大饭袋",
    "autoConfig_5": "{1}的觉醒结晶碎片",
    "messageInitNick_897": "大黄鸭",
    "autoConfig_2": "收集{1}块碎片可以召唤{2}！",
    "messageInitNick_7342": "把难过拉黑",
    "messageInitNick_898": "黑暗战神",
    "autoConfig_3": "{1}的觉醒结晶",
    "messageInitNick_7341": "这就是大佬",
    "messageInitNick_899": "一颗卷心菜",
    "autoConfig_1": "{1}的碎片",
    "messageInitNick_7337": "忘记打卡",
    "messageInitNick_7336": "酷炫老祖宗",
    "messageInitNick_7339": "凌晨十一点",
    "messageInitNick_890": "假成熟",
    "messageInitNick_9998": "邮寄月亮",
    "messageInitNick_7338": "无声无息",
    "messageInitNick_891": "我是学生送我",
    "messageInitNick_9999": "豌豆骨",
    "messageInitNick_7333": "饼太大",
    "messageInitNick_892": "把同事都卷走",
    "messageInitNick_9996": "肱二头肌魔法",
    "messageInitNick_7332": "神仙打假",
    "messageInitNick_893": "白日萌",
    "messageInitNick_9997": "无昵称可用",
    "messageInitNick_7335": "无敌打脸神",
    "messageInitNick_894": "打到你心坎",
    "messageInitNick_9994": "爱的警区",
    "messageInitNick_7334": "雪莲果去哪了",
    "messageInitNick_895": "汉语十级",
    "messageInitNick_9995": "孤舟一蓑笠",
    "randomEventDialogueGroupConfig_58.3": "-",
    "randomEventDialogueGroupConfig_58.2": "仔细看看",
    "randomEventDialogueGroupConfig_58.5": "-",
    "randomEventDialogueGroupConfig_58.4": "-",
    "randomEventDialogueGroupConfig_58.1": "在东南集市悬赏令柱上，一张悬赏肉肉山顶级肉肉的悬赏令吸引了你的注意。",
    "messageInitNick_9992": "无公害芒果",
    "messageInitNick_9993": "保质期已过",
    "messageInitNick_7331": "情是何物",
    "messageInitNick_9990": "西瓜的灵魂",
    "messageInitNick_7330": "我爱吃茄子",
    "messageInitNick_9991": "机器人化妆师",
    "randomEventDialogueGroupConfig_58.7": "-",
    "randomEventDialogueGroupConfig_58.6": "-",
    "randomEventDialogueGroupConfig_58.9": "将附近肉肉山的顶级肉肉送到东南集市的一个巢穴之中，必须在今日内送达。",
    "randomEventDialogueGroupConfig_58.8": "-",
    "messageInitNick_7326": "无公害柿子",
    "messageInitNick_9989": "邮一个纸飞机",
    "messageInitNick_7325": "作业他欺负我",
    "messageInitNick_7328": "点五个半身人",
    "messageInitNick_9987": "头状骨",
    "messageInitNick_7327": "忘记补刀",
    "messageInitNick_9988": "好奇宝宝",
    "messageInitNick_7322": "绳子一条",
    "messageInitNick_9985": "有人区",
    "messageInitNick_7321": "灰彩虹",
    "messageInitNick_9986": "神奇核液",
    "messageInitNick_7324": "狂飙的青蛙",
    "messageInitNick_9983": "白毛龙娘",
    "messageInitNick_7323": "安静的兔子",
    "messageInitNick_9984": "狠角色",
    "messageInitNick_7329": "打脸爱好者",
    "messageInitNick_9981": "半截的诗",
    "messageInitNick_9982": "头好痒是不是",
    "messageInitNick_7320": "蛋挞女巫",
    "messageInitNick_9980": "超人不会哭",
    "messageInitNick_7315": "诺贝尔躺赢奖",
    "messageInitNick_9978": "半醉人间",
    "messageInitNick_7314": "拆不穿的谎言",
    "messageInitNick_9979": "网红米粉",
    "messageInitNick_7317": "联名款香蕉",
    "messageInitNick_9976": "风一样的番薯",
    "messageInitNick_7316": "吃瓜鉴定家",
    "messageInitNick_9977": "来打我鸭",
    "messageInitNick_7311": "好好先森",
    "messageInitNick_9974": "逆天牌沐浴露",
    "messageInitNick_7310": "无公害洋葱",
    "messageInitNick_9975": "别逞强了",
    "messageInitNick_7313": "空房子",
    "messageInitNick_9972": "大叔怕萝莉",
    "messageInitNick_7312": "奶酪陷阱",
    "messageInitNick_9973": "过于抽象",
    "messageInitNick_7319": "新的大象",
    "messageInitNick_7318": "豌豆先锋",
    "resoundEventConfigDes_5008": "不过，没过多久，刺目的光芒中混入一缕温柔的银色，柔光从一缕化成一片，在它的鼓励下，怪兽们纷纷睁开了眼睛。\\n“用打架来寻开心可不行哦。”随着银光从天而降的是日夕相当熟悉的清丽女声。\\n姐姐是自己狼狈的时候最最不想见到的人——话虽如此，但体内的血量在极速恢复，先前残留的毒素也被慢慢清除掉了，呼，逃过一劫了。\\n月夕坐着弯月降临到日夕与吞噬者之间。\\n“嗝呃……”吞噬者打了一个巨大的饱嗝。\\n补血量充沛过头了！身体会爆炸的！没想到对方有帮手，而且用得还是这种豪华大放送的战术！不妙啊……吞噬者想，并急忙停下“虹吸”。可是——\\n没有用，鼻孔竟然流出两道鼻血！\\n“停停停停停！不要再回血了！”吞噬者捂着鼻子大喊。\\n“啊，对不起！因为担心所以做过头了！”月夕马上收起治疗的光芒和弯月座驾，跳到地上，“那个……好好和对方道歉，然后成为朋友可以吗？”\\n“开什么玩笑！他是邪王的手下！”听到姐姐这种劝解式的语气，日夕相当恼火。\\n“哼哼，不要把自己说得像正义的伙伴一样，明明在斗技场，却想着以多胜少……但是嘛，如果不是想打这种鬼主意的话，做朋友也是可以的咯咯咯。”\\n吞噬者一边不怀好意地笑着，一边伸出手，走向日夕，当然，那股浓臭的口气还是肆无忌惮地释放着。\\n本来想逃跑的，但这样会给王丢脸，无论如何也要靠小聪明扳回一点“胜利”。吞噬者这样计划着。\\n“呀！真是太好了！你们打起来肯定是因为某种误会，来，先握手，再解开误会。”月夕推了推日夕。\\n“不要！”不过，日夕在姐姐眼中看到了坚毅的决心，知道自己无论如何都拗不过这份强大的决意，但还是要垂死挣扎一下，“除非……除非你先治好他的口臭。”\\n哎，同是不朽级，为什么力量还是会有如此明显的差距呢？日夕非常郁闷。\\n“……不能以貌，不对，以口臭取怪兽。”月夕顿了顿，说道。\\n虽然是这样教训着妹妹，但月夕还是向吞噬者的腹部大口释放一速银光。\\n治疗的效果立杆见效，本来还想大喊着“搞什么”的吞噬者，也明显感到周围的空气变清新了。什么嘛，原来那股难闻的气味就是自己的口气吗？切，做大事不拘小节，这种事就不要在意了。他再次主动向日夕伸出手。\\n姐姐是不会为自己助战的，单凭自己的力量也不可能打败吞噬者。无可奈何，日夕也握住了敌人的手，就暂时做做样子吧。\\n月夕闭上眼睛，虔诚地念起祝福的祷文。\\n“姐姐，不要！”\\n吞噬者还没明白日夕在慌张什么，身体就被一股暖流包裹。\\n王的“爱”——孢子与纹章——会给予身体一股躁动的能量，能量带来了各种欲望，杀戮、破坏、为王献出生命。\\n但这股暖流不同，就好像冬天泡温泉后的一碗热汤，让身心舒展，让目之所及变成一片平和美好，对面的远古族也是如此友好。\\n面对日夕，吞噬者露出真挚友善的微笑。日夕也报以同样的笑容。两者紧握着对方的双手，友谊的小桥就这样搭了起来。\\n欧文曾经在月夕踏出试练石塔之后听过她念诵这种祝福祷文，月夕当时告诉他，这种祷文能让敌对的双方变成朋友。当时他还以为月夕过于相信祷文的力量，但现在这个情景，自己一定是惊讶得下巴都掉下来了吧。\\n说不定，还能让邪王成为我方的朋友？",
    "resoundEventConfigDes_5009": "“日夕，日夕！”\\n被李雨蒙的声音唤醒的时候，日夕发现姐姐正牵着自己的手，站在斗技场外面。\\n“诶？诶！？我什么时候出来了？”日夕甩开姐姐的手，想重新冲击斗技场。\\n“等等，大家都走了哦。”月夕笑眯眯地说。\\n“走了？”\\n“嗯！变成好朋友，手拉手那样走了。”\\n“……”日夕看看四周，果然，自己的追随者一个也没有跟上来。\\n不朽级的自己现在才清醒过来的话，其他怪兽的“友谊”持续时间看来会更长一点。日夕想，然后，她想到了自己那位“朋友”。\\n“那那那那吞噬者呢？就这样放他走了！？”\\n“嗯嗯！拜托他为我们传话了，人家可是开心地答应了哦。”\\n“传话？向谁？”\\n“邪王呀，说我们要拜访他，我想和邪王共同改善孢子的品质！”\\n“……”日夕认为姐姐的斗志完全昂然在错误的地方，“我们现在要去找邪王吗？”\\n“不，比起这个，还有更重要的事。”月夕神色一凛。\\n月夕把尸族失踪的事和要前往尸族部落进行调查的计划告诉了日夕，日夕虽然想单独行动，但也找不到拒绝和姐姐同行的理由。\\n日夕和月夕短暂地把身体交给李雨蒙和欧文，让两人互相打了个招呼。欧文发现李雨蒙是个和林宇翔年龄相仿的大学生，李雨蒙则以为欧文是某位北美服的高玩。\\n欧文非常有兴致地听着李雨蒙的描述，尤其是在莫名其妙的状况下花光所有金币的情节。他现在才知道超进化大陆有简单的金币交易系统，震惊之余有一种莫名的亲切感。\\n不过，这里金币之所以会成为最贵重的流通工具，也是因为看起来很珍贵但对进化和锻造武器完全没有作用。日夕喜欢金币，最主要的原因只是她喜欢金色的东西，而非热衷敛财。大家的消费观都非常朴素。\\n另外，怪兽不需要频繁地摄取食物，所以并不会经常看到像餐馆这类消费场所，而且月夕还有弯月座驾代步，根本不需要为穿越某些难以行走的陆地和超星海洋苦恼。\\n在穿越超星海洋的海峡时，欧文曾看到不少简陋的木筏被扔在海岸边，似乎是用之即弃的东西，连一艘严格意义上的小船都没有，需要渡海的怪兽可以随便捡一条木筏来使用，渡海之后也是把它扔在岸边。明明是可以发展海上经济的地方，好浪费……他不禁惋惜。\\n还有一件让欧文沉浸其中的事，便是他醒悟到月夕完全可以凭借其过人的内、外在魅力建立一支军队，成为打倒邪王正义之师的统帅。调兵遣将也是一种数字游戏，这不正是自己擅长的吗？\\n再交流了几句，李雨蒙和欧文就没有其他话题了，他们把身体的主控权归还给双胞胎姐妹。\\n“说起来，姐姐是怎样找到我的？”\\n“双胞胎的心灵感应，就在飞往尸族部落的路上突然心里一紧‘小夕有危险’，马上掉头飞了一小段之后，果然看到这里有小夕才能绽放出来的光芒。幸好及时赶到了，再晚一点的话，恐怕小夕的血都要被吞噬者吸光了。”月夕宽慰地笑笑。\\n“都说了别再叫我‘小夕’！”日夕别扭地说。\\n明明姐姐只比她早诞生几分钟，却一直这样叫她，弄得她好像那种永远只会拉着姐姐裙子哭鼻子的小女孩。\\n不爽，怎样才能超越姐姐呢？\\n“那个……”李雨蒙从日夕清醒后观察下来，确认到她还不知道那件事，“吞噬者送了一份礼物给你。”\\n“咦？不会是什么恶心的东西吧？”\\n“是两个紫色的孢子团，超大的。”\\n“我该不会吃了吧？”\\n“没有，不过你说了‘这是我收到的最好的礼物，一定会好好珍惜的’。”\\n“停！不要再说了！它们……在哪儿？”\\n“裙子的口袋里。”\\n日夕摸了摸裙子，果然发现口袋里有两团轻飘飘的东西。\\n“我姐知道吗？”\\n“应该不知道，那时她正闭着眼睛念诵祝福祷文。”\\n“吞噬者还说了什么？”\\n“‘约定好了，要一起变强哦’之类的话。”\\n“……”\\n“这些孢子，要烧掉吗？”李雨蒙感受到日夕的犹豫。\\n“不……先放着。”\\n月夕带着日夕，重新启程。\\n日夕有时会故意落在姐姐后面，偷偷拿出紫色孢子团揣摩着。\\n变强吗？以自己的力量，吃下孢子，能抵抗邪王的控制吧？",
    "messageInitNick_9970": "老顽童",
    "messageInitNick_9971": "淡淡的温柔",
    "messageInitNick_7304": "暴走的味精",
    "messageInitNick_9967": "时间线逆行",
    "messageInitNick_7303": "一班那谁别走",
    "messageInitNick_9968": "提笔落惆怅",
    "messageInitNick_7306": "车厘子之心",
    "messageInitNick_9965": "前年上岸",
    "messageInitNick_7305": "不倒翁不脸红",
    "messageInitNick_9966": "黑色高跟鞋",
    "messageInitNick_7300": "恰饭冠军",
    "messageInitNick_9963": "好男人的代表",
    "messageInitNick_9964": "傲慢的尘埃",
    "messageInitNick_7302": "冒个泡泡",
    "messageInitNick_9961": "君不知我心",
    "messageInitNick_7301": "金门弟子",
    "messageInitNick_9962": "迷路的胸骨",
    "resoundEventConfigDes_5001": "纱织、珠理、冬树、阳太、芽衣……\\n洛菲菲一气呵成地给呆在身上的各种小怪兽和小动物起名字，包括一只幼鸡般的鸟龙和两只扎着冲天小辫、含着奶嘴的幼尸。\\n马克（和埃癸斯）和洛菲菲（和意识沉睡的最终兵器）在森林中不紧不慢地结伴而行。朱雀看到埃癸斯和马克能让最终兵器冷静下来后，终于放心离开了。他要去看看其他几组英雄的情况，并尽快找到邪王的驻地。\\n马克看着前头比自己更魁梧的最终兵器，心中涌起一股奇妙感。\\n在这片森林里，洛菲菲就像在公园里嬉戏，刚来到这个世界的恐惧感荡然无存。\\n终归是个孩子，只要有信任的人在身边，就很快安心下来，马克想。他甚至把最终兵器沙哑厚重的机械嗓音脑补成稚嫩清脆的童音。\\n一开始被这具庞然躯体吓跑的小怪兽和小动物，逐渐被其友善的举动吸引，从草叶间冒出脑袋，有些胆大的，还聚拢到洛菲菲身边，甚至跳到其身上。\\n这副情景，就如童话中被驱逐到森林的老国王膝下最年幼天真的公主，因其自身的纯洁与善良吸引众多生灵。\\n“珠理乖，尝尝这个果子。”洛菲菲对停在肩膀上的一只苦笑鸟叫唤到。\\n“呵呵呵呵呵，冬树，不许挠我脚板底，呵呵呵呵……”然后忍不住痒痒，喝斥了一只她每走一步就跟着跳一步、长耳朵刚好扫在她脚底的疾风兔。\\n说完，又愉快地哼起歌来。一副无忧无虑的样子。\\n那场悚人的杀戮已经过去好几天了，马克慢慢引导着洛菲菲往北走，他们从大陆南端的沼泽之地，来到了西南方的古树秘境。生活在这里的大多是木偶族，埃癸斯已经告诉了马克他在石塔中和木偶族族长史卡非斯的交手过程。\\n“我觉得他不是一个坏人，只是因为过去木偶族所受的伤害，有点愤世。”马克和埃癸斯交换意见的时候说出自己的想法。\\n埃癸斯非常认同。\\n“无论何种情况，我们都不能攻击木偶族，尽量向对方说明情况。”\\n本来这样约定好，但和洛菲菲同行后，埃癸斯和马克都有点担心。如果最终兵器无差别杀戮的消息已经传到这里，他会被木偶族当成敌人吧，到时，最终兵器会不会暴走先不说，单凭防御能安全穿越古树秘境吗？\\n这么想着的埃癸斯和马克，突然察觉到了强大的敌意。\\n穿过叶间的风缓滞了下来，正午时分，一片墨色遮蔽了明媚的天光，而墨色之中竟然闪烁着点点繁星。\\n“哎呀！”原本在前方迈着轻快步子的洛菲菲突然摔在地上，她呻吟道，“身体……好重……”\\n小动物们嗅到危险的气息，迅速逃进森林深处。\\n不只洛菲菲，连埃癸斯和马克都感到身体猛然变得沉重。\\n“就像地心引力突然增加了！呃——”想到埃癸斯可能不知道“地心引力”这个概念，马克想换另一种比喻的方式。\\n“嗯！这是灵族的一种技能，改变引力。”埃癸斯不需要马克进一步解释，反而极快地一阵见血指出潜在敌人，“难道来找最终兵器报仇吗？”\\n洛菲菲努力地挣扎着爬起来，惊慌之下用力过猛，扇起狂风，飞过埃癸斯和马克的头顶，飞到森林之上，然后更惊慌地下坠，在几乎不能控制身体之前掉在地上，掉到埃癸斯和马克的背后。\\n“菲菲，别害怕！别离开我身后！”\\n“菲菲不想打架……”\\n“嗯，绝对不会让你受伤的。埃癸斯，交给你了！”\\n马克的意识一松，埃癸斯连一瞬间都没有浪费就接管了身体。\\n真·圣盾埃癸斯举起巨盾，稳稳地挡在真·最终兵器——此刻是一个无助的小女孩——面前。\\n密林中冒出六个灵族，两个究极级，提着双刀的血刃和拥有粗壮右手的撼地兽，其余四个都是幻化级的跃迁兽，对于进化停滞多时的大陆来说，这个团队的战力也算中上。\\n而且，说不定，还有更多灵族潜伏在周围。\\n完全没有对话的机会。\\n血刃快速挥舞着双刀向埃癸斯冲过来，撼地兽在另一边夹击。原本能强压着敌人的埃癸斯在被降低速度的情况下也是只挡不攻，虽然不至于马上战败，但如果让战斗一直胶着下去，还是会逐渐处于劣势。\\n更不用说流星不停地从天空下坠，埃癸斯为洛菲菲挡开这些流弹已经开始感到吃力了。\\n抓准埃癸斯防守的一个空门，撼地兽巨大的黄金右手给了埃癸斯腰部一拳重击：“出手啊！之前不是杀得很爽吗？”他的眼睛却怒瞪着埃癸斯巨盾后面的最终兵器。\\n“呀！”洛菲菲惊恐地后退两步。\\n这种怪物，一拳就可以秒杀了吧，洛菲菲冷静地判断到。但是，让埃癸斯当肉盾，对自己更有好处，她转念一想。\\n这时，四只穿着尿布的跃迁兽举着手中的大葱往最终兵器身上乱戳。\\n痒痒痒痒痒！洛菲菲快忍不住笑了。这是他们的战术吗？",
    "resoundEventConfigDes_5002": "埃癸斯看着最终兵器拼命忍耐的表情，还以为里面的小女孩相当痛苦，但是跃迁兽们的攻击更像嬉闹，他一时之间也不知道该如何应对。\\n血刃又气势汹汹地攻过来了，还召唤了一颗巨大的流星砸向最终兵器，流星会把最终兵器身边的跃迁兽一同击毁。\\n啊！是连同族也要一起消灭吗？\\n埃癸斯一手把最终兵器推开，另外一手飞出巨盾。巨盾在流星砸下来之前盖在四只跃迁兽身上，其余的重击全砸在了埃癸斯的背部。\\n土石飞溅，覆盖了所有视野。\\n埃癸斯背部流下几道鲜血，受伤不轻。\\n跃迁兽们从巨盾底下伸出脑袋，带着紧张的表情不解地仰视着埃癸斯。\\n同样向埃癸斯射来不解视线的还有血刃和撼地兽。\\n“为什么……要救他们？”撼地兽问道，其中一只跃迁兽是他弟弟，但遵从族长的命令，四只跃迁兽都为此战做好牺牲的准备。\\n “……保护弱者难道需要理由吗？”埃癸斯凛然答到，就好像一切都是理所当然的。\\n灵族战士首先发起进攻。血刃和撼地兽牵制埃癸斯，同时跃迁兽们负责挑衅极容易暴走的最终兵器。等到最终兵器丧失理智秒杀跃迁兽，向血刃和撼地兽发出致命攻击时，隐藏在密林的木偶族究极级怪兽极限进场，用骗术反射从最终兵器那受到的伤害，击破埃癸斯或者最终兵器。\\n这是灵族和木偶族两位族长共同制定的作战计划。灵族牺牲四只跃迁兽，木偶族牺牲一名极限，如果能达到预想中的结果，也算以弱胜强。\\n但是，战斗竟然往意外的方向发展。\\n感受到隐藏在密林中的极限的焦灼目光，撼地兽冲向最终兵器，发出一记重拳。\\n与此同时，极限从密林中跳出来。\\n洛菲菲真的害怕了。\\n“杀……”最终兵器在洛菲菲感受到危机的时候苏醒了。\\n迅雷不及掩耳之势，最终兵器已扑到撼地兽面前，拳头比他的黄金右手更快更猛，而早已盘算好的极限根本不可能来得及施展“骗术”赶在撼地兽之前接下这一击。\\n比最终兵器更快的是埃癸斯！\\n他几乎和最终兵器同时跃起，毫不犹豫地撞开撼地兽和极限。表面上看没有一丝拖泥带水的动作，实际上耗费了他全身的力量。虽然血刃的攻击已经停止，但他还要用一半力量抵抗撼地兽的“引力”。\\n原本应该打在撼地兽或者极限身上的重拳把一棵参天巨树拦腰击断，树干还飞出一段距离。\\n极限看呆了眼，意识到恐怕自己还没来得及反射这击伤害，就会被最终兵器打死了。\\n埃癸斯高举左手，巨盾飞回他的手上。他向最终兵器大喊：“冷静点！小姑娘！！”\\n洛菲菲似乎听见有人在喊她，但在她心里，全是因恐惧而扭曲成的愤怒。\\n骗子！\\n说过要保护我的！\\n说过不会让我受伤的！\\n可那些虫子比我还重要！\\n骗子！骗子！！\\n她的情绪刺激着最终兵器。\\n最终兵器把眼前的所有生物看成敌人，首先是挡在他面前的埃癸斯。\\n——没错！以保护弱者自居却失信的家伙！\\n自我意识稀薄的最终兵器正按照体内那个幼小的生物的愤怒意志行动。\\n被暂时晾在一旁的血刃和撼地兽对望一眼。要逃跑吗？但彼此都从对方的眼神中看出毅然的决心，逃跑可配不上他们体内的杀戮血统。\\n埃癸斯拖着沉重的步子，准备接下最终兵器的下一击。突然，他发现自己的脚步变轻了。\\n血刃和撼地兽来到埃癸斯的身边。\\n“多余的恩情麻烦死了。”血刃不耐烦地说。\\n“本大爷也不想一辈子抬不起头。”撼地兽也相当不满。\\n“使盾的，你要是不想杀他，我们也不会下狠手。”血刃说。\\n“但也仅限于这一次！”撼地兽说。",
    "resoundEventConfigDes_5003": "极限不知道什么时候逃走了。\\n数个攻防之后，洛菲菲再度在马克的呼叫下清醒过来。当然前提是最终兵器攻击埃癸斯时被撼地兽一拳击中腹部，再加上血刃召唤数颗流星把最终兵器围住。\\n战斗之后，血刃停止召唤流星，随着流星一起褪去的还有天空的墨色，阳光透过叶间的缝隙再度洒了下来。整场战斗不过是经历了一个晌午的时间。\\n埃癸斯看着因为瞬间放松过度紧张的神经而陷入沉睡的最终兵器，向血刃和撼地兽讲述了最终兵器被唤醒的过程。\\n听完后两者都沉默不语，这甚至不是解开误会的情况，而是无奈地明白到那些弱小的部落只因不幸而成为灾厄的牺牲品。真正的罪魁祸首，是一直以为只存在于耸听危言中的邪王。再加上，他们也亲眼目睹了最终兵器在暴走的时候甚至把埃癸斯当成敌人。\\n尽管如此，他们望向最终兵器的眼神还是充满戒备。\\n“埃癸斯……大……哥，我们会把这个情报报告族长，但是……”撼地兽不再以“本大爷”称呼自己，虽然对埃癸斯的战斗技术和战士品格佩服得五体投地，但后面的话还是难以开口。\\n“族长认为是那些石塔把邪王引出来的，而且，能通过石塔得到进化的只有你们远古族，所以……那个……远古族就是邪王出现的原因。”血刃补充道，语气中带着点嫉妒。\\n“……”埃癸斯想起在族长会议上灵族族长的样子，无奈地摇摇头。连沉睡多年的远古族都会被来自石塔的召唤具“选中”而唤醒，这恐怕会让灵族族长更笃信那种疯狂的设想。\\n埃癸斯也想知道远古族和石塔的关系，但他更期待朱雀大人的答案。\\n“埃癸斯大哥，那我们现在该咋办呢？”撼地兽问。\\n“唔……战斗力最弱的部落先往南部迁移，剩下的战士集结成防守战线，在还不清楚邪王身份和目的之前，不要轻举妄动。\\n“同时还要对负责防守的部队进行补充和替换，不要让他们出现疲劳期让敌人有机可乘。\\n“还有游离于部落之外、喜欢独来独往的灵族，遇到的话尽量劝他们暂时加入部落，或者前往晨光草原也行，我的战士们会关照他们。”\\n埃癸斯一板一眼地说道。\\n“开什么玩笑，族长怎么会听我们的？”血刃猛摇头。\\n“强大的战士都被族长带去消灭石塔了。”撼地兽说，\\n现在灵族除了他和血刃几个少数究极级的怪兽，剩下的可以毫不客气地说是老弱病残，连他的弟弟——正在一旁无忧无虑地揪着自己头顶小苗的跃迁兽——在这种情况下也算得上很不错的战力了。\\n“……就按埃癸斯、埃癸斯大哥的方法去做。”血刃想了想，还是下定了决心，并且跟着撼地兽称呼埃癸斯为“大哥”。\\n本来就不太赞同族长做法的血刃，经过短暂的思考，认为可以借助埃癸斯的建议巩固灵族的力量，并借此建立自己的威信。如果邪王的势力越来越大，族长灰头灰脸地回来，必定颜面尽失。自己和族长都是究极级，这段时间稍微加强锻炼，到时再和族长决斗，胜券在握。风流倜傥的自己通过这个机遇成为新的族长，岂不美滋滋？\\n撼地兽性格单纯，最关心的是弟弟。血刃拥有不小的野心，但他也拥有很强的灵族荣誉感和使命感，以保护同族来实现自己的野心，正合他意。\\n他们继续向埃癸斯请教了日后的防御方法，并约定必要时会向埃癸斯的部落请求支援后，就带着其他跃迁兽踏上归程。\\n“埃癸斯大哥，那我们先走了。”撼地兽把弟弟抱到自己的肩膀上。\\n“再见，一定要把弱者保护好。”埃癸斯又嘱咐了一句。\\n洛菲菲一直在假装睡觉，埃癸斯和两个灵族的对话她都听得清清楚楚。埃癸斯保护她，只是不想最终兵器伤害弱者，马克保护她，只是因为她是个弱小的女孩。通过刚才的战斗中，洛菲菲意识到只要操控好最终兵器，不断吸收战斗技巧，也许连埃癸斯都不是她的对手。\\n她要不断变强，不管何时何地能够依靠的人就只有自己。\\n可是，他们会保护不是弱者的自己吗？\\n肯定不会吧，那就不动声息地变强。况且，装弱对于她来说是再简单不过了的事了。\\n不过，这个不能为自己所利用的肉盾，早晚还是要抛弃的。",
    "messageInitNick_7308": "音乐在回荡",
    "resoundEventConfigDes_5004": "李雨蒙直到现在还和刚来的林宇翔一样，以为自己正在玩一个拥有超感体验的游戏。\\n日夕并没有乖乖听从朱雀的嘱咐，径直往北走，既然获得不朽级的美，当然要将之展现于天下；而对李雨蒙来说，支线任务比主线任务有趣多了。想法不同的两人意外地达成了一致的步调。\\n日夕离开部落之前带了不少金币，但她并不是吃苦耐劳的人，李雨蒙也不太了解这个“游戏”中的金币价值，所以她们很快就挥霍了大部分的金币。\\n这些金币都铸造得很粗糙，上面没有雕铸任何花纹，金币之下也没有银币和铜币，日夕告诉李雨蒙，日常需要什么东西，除了用金币购买，也可以和对方以物易物。\\n但是！作为首领的她，要是带着怪兽的粗皮、油脂、尖牙、心脏这些笨重的素材出行就太不美观了。\\n日夕迫不及待地花了一半的金币，在一间黑店洗了个澡。如果老板不是忌惮日夕不朽级的力量，早就和几个穷凶极恶的手下把她分解成各种怪兽素材了。\\n然后，又花了剩下金币的一半雇了几个锤子怪用小推车载自己走过一段泥泞的山路。\\n最后，想在一间囤食洞穴买点吃的喝的，才发现剩下的金币不知道什么时候丢了！\\n虽然这间小囤食洞穴因为同一天内有两位女神般漂亮的远古族降临而蓬荜生辉，但老板还是清醒地从日夕的表情中看出她身无分文的窘迫。\\n“怎、怎么办？”李雨蒙慌张地问日夕。\\n“没、没关系的，美，能克服一切，战胜一切。”日夕不太淡定地回答。\\n“您……和一位名叫‘月夕’的小姐是失散多年的姐妹吗？”老板试探地问道，“那位小姐刚离开不久，说不定你能找她借点金子？”\\n日夕被下达了婉转的逐客令。\\n什么嘛！看见本小姐的美貌，不是应该恭恭敬敬地奉上最好的食物吗？日夕恼火地想到。\\n然后，一盘辣白菜和一盘烤鸡腿被恭恭敬敬地奉上到她面前。\\n“超漂亮的小姐，你不介意的话，吃我的吧。”一名行尸红着脸说，他瞬间坠入了爱河。\\n不要“心怀不轨”地脸红啊！\\n“请和我生孩子！”一条明光龙仗着自己是究极级，鼓起勇气向日夕告白，并附赠一碗浓香的腐朽之汤。\\n喂喂喂，想死吗！\\n被四周火热的眼神注视着，日夕的内心万马奔腾，但想到自己的美貌有如此强大的威力，心中又不禁窃喜。自己的部落中也有不少崇拜者，但他们都被月夕养成一种虔诚、与世无争、助人为乐的乖顺感，相处久了还真有点无聊。\\n其实，在月夕到来的时候，囤食洞穴的客人们就想过去围观（搭讪）了。但因为古拉姆在月夕身边，所以他们都不敢表现出过分的骚动。\\n不过，现在日夕是孤身一位，而且还身无分文急需援手，几个胆大点的怪兽就跃跃欲试了。\\n颜值即正义啊，李雨蒙不禁感叹。\\n加之受到了行尸和明光龙的刺激，几乎所有怪兽都围拢到日夕身边。\\n很快，日夕面前堆满了小山般的食物。\\n“哼，哼。”日夕清了清嗓子，“如果想得到我的肯定，就先要展示一下自己的实力。能跟随我讨伐邪王的，我一定不会亏待你们。”\\n日夕意气风发的样子，绽放出流光溢彩的美。大家的内心都受到鼓动，马上变成了日夕死心塌地的亲卫队。\\n按照姐姐的性格，姐姐应该会按照朱雀的指引向北走，她才不要与姐姐同行，日夕想，她既不想听姐姐关于“性本善”的种种谬论，也不愿被姐姐限制行动。\\n就这样，日夕被大家簇拥着，离开了囤食洞穴。\\n“好想亲眼见识一下大姐头的厉害啊！”一名怪兽说道，然后其他怪兽跟着起哄，纷纷请求日夕和自己对战。\\n在异域囤食洞穴中歇息的，大部分是独来独往不属于任何部落的怪兽，他们独自前往世界树、采集强化孢子和进化孢子，修炼的方式通常是遇到什么不爽的事情就和对方干一架。日夕是个超级大美女，但对他们来说更是一个值得挑战的对手。\\n结果，日夕轻而易举地把他们打得落花流水。李雨蒙也陷入一种“自己已经是高玩”的错觉中。\\n然后，大家怂恿日夕前往一座位于魔法界的山寨斗技场。听说那个山寨斗技场是最近由究极级的吞噬者搭起来的，很受欢迎，每天去斗技的怪兽络绎不绝，如果敢直接挑战吞噬者，能挨过他十下攻击，还会得到强化孢子团和进化孢子团。\\n“大姐头出马的话，不但能得到所有孢子团，还能打败那个吞噬者！”一个怪兽说道。\\n孢子团？该不会是变异的孢子团吧。日夕心中涌起不祥的预感，随即决定去那里一探究竟。\\n不过……斗技场……日夕的眼前闪过真·暴虐战狂那张不可一世的脸。\\n不会的，不会在那里遇到他，只是一个区区究极，不值得他出手。这么一想，日夕便完全放下心来。她心中有个超级完美的计划——在斗技场中作为新世代的女神闪亮登场，再向观众们发表挑战邪王的宣言，接着，她会在斗技场等待邪王的挑战并一举将其击败。或许她并不能以一人之力击败邪王，但当她的宣言传遍整个大陆，古拉姆和埃癸斯也会赶来她身边帮助她。至于姐姐，到时就让她在“邪王并非善者”的事实面前低头！\\n日夕绽放出日轮，带领着追求者，意气风发地朝东北方的魔法界走去。她相信讨伐邪王的宏愿，马上就可以达成。",
    "messageInitNick_7307": "电音芭芘",
    "resoundEventConfigDes_5005": "来到魔法界是两天之后，路上没有遇到姐姐和暴虐战狂的日夕，心情相当愉快。\\n传说，超进化大陆的怪兽死去后，灵魂会被送到冥地，而冥地的入口就在魔法界，于是，魔法界变成一个盛产鬼故事的地方。而一直为自己寻找灵魂的木偶族，和相信流星是由灵魂变成的灵族，在这里进行了大量的魔法研究，让这里布满各种魔法能量残渣。就像李雨蒙说的这里和另一个位面的地雷一样危险。\\n斗技场搭在一片“危险的草丛”肆意生长的空地上。本来只是外来的无名野草种子，但意外地受到魔法能量残渣的影响，变异成有意识和具有危险性的草丛。草丛都能当boss——这是一些幼体级和幻化级怪兽对危险的草丛的评价。\\n“要进场挑战先付十块烤牛肉！”现在，危险的草丛充当起售票员的角色。\\n“不对！是十块金币！”但草丛与草丛之间并没有达成一致的协定。\\n混乱之中，几个幻化级和究极级的怪兽径直走进斗技场，而一个幼体级的怪兽，则掏出几块黄色的、已经凝固的怪兽油脂，把它们当做金币扔到危险的草丛脚边，也溜了进去。\\n不过，日夕一行太显眼了，一出现便在排队的怪兽中引起轰动。危险的草丛也停下争吵，愣愣地看着这位鹤立鸡群的远古族。\\n“我们……好像没那么多金子……”确切来说是一块也没有。曾经因为房租在贫穷线上挣扎的李雨蒙非常担心，该不会追随者们的门票也要她们来买吧？\\n“怕什么，看我的，美女能去任何地方！”日夕对李雨蒙说。\\n“杂草们，请转告你们的老大吞噬者，远古族的真·日夕来挑战他。”日夕居高临下地说。\\n危险的草丛忘乎所以地吸收着日夕的光芒，叶子不断朝日夕围拢。\\n你们这群痴汉——不对！你们这群痴草，是多久没进行光合作用了？李雨蒙暗暗吐槽。\\n首先失去耐心的是日夕的追随者明光龙。\\n“呆子！还不快去！！”\\n两团危险的草丛被明光龙扔向斗技场。\\n没等多久，日夕就如愿地站在斗技场中心。\\n斗技场旁边围了好几圈七零八落的木墩、石头当凳子，不过此刻观众们都站起来往前倾挤着身子，害怕自己看漏任何一次攻击。\\n “要直接挑战我吗？嚯嚯，那你已经输了哦！要是老老实实把身上的金子留下，就放你着回去。没有金子的话，就一辈子给我当奴隶吧！嚯嚯嚯嚯嚯嚯嚯！”\\n面对不朽级的日夕，吞噬者眼中依旧露出疯狂的紫光，并毫不顾忌地发出充满恶意的笑声。\\n笑声从他头部和腹部的口中同时发出。腹部的大口旁边长着一圈参差不齐的利齿，口中弥漫着一团深不见底的黑色漩涡。吞噬者，顾名思义，吞噬武器应该是腹部的大口。看来是会把手下败将吞噬殆尽的怪兽。\\n一股浓烈的口臭从那个大口中飘出来。\\n这让日夕想起了先前在石塔里那块巨大腐肉的浓烈恶臭，两者竟不相上下。\\n而李雨蒙这边，虽然直面这个梳着飞机头、如不良青年般、无论怎么看都是中级boss的怪兽让她感到害怕。但和直播时碰到的那些让人不快的口臭和下三滥弹幕相比，这点恶心不算什么。毕竟如果连这点恶心都忍受不了，李雨蒙早就不能在直播圈混下去了。\\n这臭味反而激起了她的斗志！\\n“哦哦？状态不错嘛！”日夕感应到李雨蒙高昂的情绪。\\n “我要代表这个美丽的世界消灭你！受死吧，你这个臭八怪！”\\n“这是属于美少女的战场！”\\n“把他晒成怪兽干！”\\n“驱逐一切丑陋之万丈金光！绽放！”\\n两个美少女就这么随心所欲地瞎呐喊着给彼此加油。如果不是在同一个身体，而是一对双人偶像组合的话，早已引发一片宅男的尖叫。\\n可惜台下只是一群迫切要看到一场厮杀的怪兽。",
    "messageInitNick_9969": "雪地上的雪",
    "resoundEventConfigDes_5006": "首先进攻的是日夕，她朝吞噬者射出数个光弹，但是，除了一个击中吞噬者，其余都被他悉数避开。\\n观众的喝彩声明显是属于吞噬者的。\\n“嚯嚯！只有这点能耐吗？轮到我了！”\\n吞噬者狂笑着张开腹部的大口冲向日夕。虽然不是能大意的狠角色，但经验丰富的战士都能看出吞噬者的爆发力和冲击力不算太强。可惜日夕不是经验丰富的战士，而且她最怕口臭，生理上无法接受，光是闻到就想吐。\\n就这样频频闪避，日夕错过了很多反击的机会。\\n嘘声一浪接一浪从观众席上传来，嘘声明显是属于日夕的。\\n“大姐头，快给点厉害他看看！”“大姐头，迅杀了他！”日夕的追随者大喊着，给日夕助威。\\n如果打持久战，日夕有信心在自己还没累倒之前耗尽吞噬者的体力，到时再发射光弹将其击倒——即使不算赢得威风凛凛，也算堂堂正正，最重要的是不用吸入那股口臭，从这种意义来说，这是最佳的战斗方法——啊咧？\\n就这样想着的日夕突然感到一阵头晕目眩，她看到一道金光从自己身上被吸收到吞噬者腹部的大口之中，随着金光的流逝，体内的血液仿佛被抽走了一半。\\n因为偷取了日夕一半血量的吞噬者精力十足，不，简直达到神采飞扬容光焕发的状态，他的笑声也更加洪亮。\\n“嚯哈哈哈哈！美女的血果然又香又甜！我有没有稍微变帅了一点？”\\n就这样说着轻佻的话语，吞噬者向日夕发出第二波攻击。\\n原来是这么回事吗？并不是吃掉手下败将，而是饮下敌人的鲜血，十足的阴招！\\n日夕慌乱避开，并为自己回血。\\n“憋住呼吸秒杀了他！”李雨蒙建议道。\\n“唔……”算是勉为其难的回答。\\n——失败了，李雨蒙目测日夕只向吞噬者靠近了两米就受不了了，而且这次被吞噬者吸走了更多血。无论持久战和速决战，日夕都无法击败吞噬者。\\n“不行，我要吐了……呕……不要让我在这里出丑……帮我……”日夕将身体的控制权交给李雨蒙。\\n又不能让敌人刷了牙再打，啧，吸血鬼不是哥特风帅哥的同义词吗？这个游戏为什么不按套路出牌？李雨蒙强忍下呕吐的欲望，恼火地想着。\\n怪兽们的呐喊、怒吼、嘘声、口哨声混杂成一片令人焦躁的噪音。李雨蒙快速地环视了斗技场一周，她捕捉到观众席上空余的一角。\\n那里有一个粗矮的木墩，可是没有怪兽坐在上面。木墩下长着几个色彩鲜艳的蘑菇，按照自然课本上的常识来讲，越鲜艳的蘑菇毒性越强。\\n“因为这样，才没有怪兽坐在那里吗？”李雨蒙问日夕。\\n“是的，那是地狱菇，吃下之后会中剧毒而死，即使是单纯的靠近，如果被它的孢子粘在身上，也会痒得要挠下自己的一层皮。”\\n“如果我们吃下地狱菇，你给自己回血前能坚持住吗？”\\n“……应该可以吧，如果不吃太多的话。”\\n日夕很快领悟了李雨蒙的战术。美貌与智慧并重说的就是自己吧，她镇定下来。\\n很快，吞噬者的第三波攻击把日夕击退到观众席上，日夕快速偷吃了一个小小的地狱菇。\\n“没用的，即使你逃到超星海洋，都躲不过我的‘虹吸’！嚯哈哈哈哈！！”吞噬者一个大口爆发着狂笑，另一个大口毫不留情地吸取着日夕的血。\\n“呜呃——”\\n气势如虹的偷血攻击戛然而止，吞噬者倒在地上，不断抽搐着。",
    "messageInitNick_7309": "当星光没有光",
    "resoundEventConfigDes_5007": "成功了！日夕马上给自己治疗，也多亏吞噬者吸取了她大量的血液，剩下的毒素并不多。\\n虽然日夕的追随者们不知道是怎么赢的，但依旧爆发出雷鸣般的欢呼。其他怪兽也跟着一起喝彩，所谓成王败寇，在哪个世界都是一样的。\\n日夕沐浴在所有怪兽的崇拜中。\\n“初次见面，我是远古族的真·日夕。我是来拯救你们的！”日夕得意地说道。\\n有的怪兽露出不解的表情。\\n“你们之中吃过紫色孢子的，要马上吐出来，只要愿意成为我的力量，我一定会帮大家净化体内的毒素！我的承诺如太阳一样永恒！”日夕本身无法像月夕那样帮怪兽净化毒素，她打算和姐姐相遇之后，让姐姐随手净化一下，当然追随者们不会知道，功劳都是她的。\\n“喔噢！！”又是一阵欢呼。\\n“你不是说吃过紫色孢子的怪兽都会不由自主地去寻找邪王吗？应该不会留在这里吧？”李雨蒙问。\\n“……啊，是有这么回事。”日夕不好意思地说。\\n原来日夕是一旦陷入偶像模式，就会有点脱线的小妹妹，李雨蒙想。\\n“而且哦，他们是不是误会了你会帮他们进化，而不是净化。”李雨蒙问，来到这里之后，语言就无师自通了，反正在汉语里“净化”和“进化”的发音挺相似的，而从怪兽们那种雀跃的反应来看，说不定还真产生了那种误会。\\n“呀……怪不得呢，我还在奇怪他们好像激动过头了。”日夕说。\\n看来又被李雨蒙说中了。\\n“大家请冷静！大家听错了哟，不过，净化也是必需的……”日夕朝怪兽们摆了摆双手。\\n“进化！忠诚！”怪兽们完全没听进去，情绪反而更加激昂。\\n“嗝嗝嗝嗝嗝……嚯嚯嚯嚯嚯……哈哈哈哈哈！”\\n日夕背后传来了令人毛骨悚然的三段式笑声，所有观众也因为这笑声安静下来。\\n吞噬者不知道在什么时候爬起来了，悠然的神情就像只是吃错了东西但现在完全好了，而且还能再吃一轮一样。\\n“你……为什么……”日夕哑然地张了张嘴。\\n“因为有这个，王的庇护。”吞噬者从腹部的大口中掏出一块亮黑色的金属块，刻在金属块上的一个涡旋形状的符号在闪烁着绿光，“圣洁纹章，全靠它，我才能重新站起来。还有……”\\n三块刻着N型闪光符号的纹章接连被它从大口中掏了出来。\\n“持久纹章。”像炫耀着宝物一样，吞噬者向日夕展示着另外三块纹章，“嚯嚯，王之所以伟大，是因为他们创造了更多进化的方法！远古族什么的，连杂鱼也称不上！是杂鱼中的鱼屎！”\\n吞噬者把四块纹章塞回腹部的大口中，并一扫战斗开始时戏谑的调调，表情变得狰狞。\\n在对方大放厥词的时候，日夕掌中迅速聚拢起一个光球。\\n“逆转之力——弱化！！”\\n同时，吞噬者的大口张开到比腹部还要宽的程度。\\n“虹吸！！”\\n…………\\n……\\n所有观众都不由自主地闭上了眼睛，斗技场中爆发出来的光波，让他们透过眼睑都能感受到一片金色。现在睁开眼睛，绝对会瞎的！大家心里都响起了警报。\\n这是不朽的日夕的力量？还是得到邪王庇护的究极吞噬者的力量？\\n只有日夕和李雨蒙两者知道，体内的血又少了一大半，往这个与自己预想背道而驰的现状继续下去，毫无疑问是战败和死亡。",
    "messageInitNick_9960": "认证套娃专家",
    "messageInitNick_9956": "单色拂晓",
    "messageInitNick_9957": "中午吃泡芙",
    "messageInitNick_9954": "反思自省",
    "messageInitNick_9955": "有趣的女人",
    "messageInitNick_9952": "嘀嘀咕咕的猪",
    "messageInitNick_9953": "记得相亲",
    "messageInitNick_9950": "西瓜君快逃",
    "messageInitNick_9951": "爱不爱一句话",
    "resoundEventConfigDes_5010": "埃癸斯想给最终兵器寻找一个监护者，自己要赶去和古拉姆汇合，继续寻找邪王，总不能一直慢慢地引导着最终兵器。即使只为抵挡敌袭，自己的武力行动也会引发最终兵器的暴走……他思来想去，还是觉得把最终兵器交给月夕最放心。\\n现在他正被最终兵器勾着双腋，飞越森林和超星海洋，寻找陆地上那抹独特的银光。\\n“哼！我要找个地方把你这家伙扔下去！”\\n但是，埃癸斯却不知道他背后的“小家伙”心里不断咒骂着，如果最终兵器的脸能还原洛菲菲的表情的话，埃癸斯转头就会看到一张噘着嘴、气鼓鼓的脸。\\n之所以用飞的，是埃癸斯不想陆地上再发生什么刺激最终兵器，令其暴走的事，而洛菲菲也想学习使用新的身体，并找机会报复一下埃癸斯。\\n“哎呀，大哥哥对不起，刚才手滑了，呜呜……”反正到时假装不小心就好。\\n但是，每到要下手的时候，她又纠结了起来，觉得落点还不够好，虽然一直在生闷气，但报复的欲望却渐渐淡了下去。归根结底，埃癸斯和马克只是没有保护好她，并没有故意伤害她。一路上都确切感受到这股善意的洛菲菲，产生的只有闹别扭程度的“怨恨”。不过她还不到能理性地总结自己心境的年龄，只会简单地把这种心情归结为“不玩了，无聊”。\\n几天后，当日夕和月夕看到一个身高几乎是她们两倍的巨兽怯怯地做出捏起不存在的裙摆向她们行礼的姿态后，惊讶得下巴都要掉下来。\\n“怎么连小孩子也……”欧文发出无法理解的喟叹。\\n“姐姐们好。”洛菲菲乖巧地向大家打招呼。\\n“你好……”最先反应过来的是日夕。\\n“你给我好好解释一下！”日夕把埃癸斯拉到一旁，“这个大块头也是我们的同伴？”\\n“……也不算同伴……暂时来说……”\\n比起同伴，埃癸斯更愿意把最终兵器和洛菲菲看作需要照顾的孩子，于是，他一五一十地向双胞胎姐妹讲述了从他无意中撞上最终兵器觉醒到找到她们之间发生的事情。\\n惊讶、哀伤、怜悯的表情轮番浮现在月夕脸上，日夕则把不安和嫌弃压在心底。\\n“明白了，菲菲和最终兵器就放心交给我们吧！”月夕拉起最终兵器的手，问埃癸斯，“你要和我们一起去尸族那里吗？”\\n “不了，我想尽快和古拉姆汇合，尸族就拜托你了。”说罢，埃癸斯便向大家告辞了。\\n“……”\\n“……”\\n洛菲菲和日夕无言地对视了好一会儿，倒是李雨蒙透过巨兽眼睛看到那个蜷缩起来的单薄身影有点不忍心。\\n“菲菲？肚子饿了吗？”\\n“饿……”\\n被问及，洛菲菲才想起最终兵器一定已经很久很久没吃东西了，证据就是肚子排山倒海的饥饿感。埃癸斯保护他们的时候，只是拼尽全力让他们毫发无伤，却没有细心到会照顾他们的饮食，他自己就是糙汉子一个，忍饥抵饿、风餐露宿是家常便饭。\\n于是，在双胞胎关怀的目光下，洛菲菲成为了第三个智者牌水藻团子的受害者。要是最终兵器醒着的话，说不定会因这种一言难尽的味道暴走。\\n “这是什么玩意？她们是故意的吗？”洛菲菲心中咬牙切齿，这份敌意反而让她愈发冷静下来，洛菲菲可不能这么容易被打败。可是——\\n“苦口良药，忍忍就好。”月夕再次握着最终兵器的手，一道甘流自掌心传至喉咙，苦涩的味道顿时减轻了不少。\\n洛菲菲听埃癸斯说过月夕有强大的治愈能力，但没想到连味觉上的痛苦也能治愈。看来这个女人并不是故意捉弄自己，她应该可以当自己死心塌地的守护者吧。\\n想到这里，洛菲菲像即将得到一件可以任由她摆布的新玩具般愉悦。",
    "resoundEventConfigDes_5011": "大部分尸族都生活在冰川谷，双胞胎带着最终兵器来到魔法界的边缘，只要跨过前方不远的超星海峡，就到达冰川谷了。现在是夜晚，月夕提议大家在这片森林空地上休息一晚再出发。\\n日夕在生闷气，两个会飞的带她一个只能靠双腿前进的，就像在可怜和责备她的无能。跃动的篝火把她意志消沉的表情照得明明灭灭。月夕在一旁祈祷，她把日夕的不悦理解成她对未来旅程和尸族的担心，并祈祷古神会让妹妹打起精神来。\\n洛菲菲饶有兴趣地观察着两人，她想找个机会和双胞胎体内的两个人类聊天。她最不擅应付的就是马克、埃癸斯和月夕这种老好人，但只要对方有那么一点小心思，她就会记在心中，并寻求让自己愉悦的机会。\\n“那么，大家晚安。早点休息，明天我们一早出发。”\\n“我睡不着，我来守夜吧。”\\n日夕说，黑眼圈让她的明艳有几分失色。但现在不是介意这个的时候，她想独自一人再细细琢磨一下那几个紫色的孢子团。\\n“不行，熬夜是身体和五官失衡的元凶。有我的月亮在，安心睡吧。”\\n不容分说地，月夕的背后亮出一轮弯月，那既是她的座驾，又是今晚的守卫，同时还将安眠之力通过温柔的银光传播到大家身上。\\n很快，双胞胎姐妹都进入安稳的梦乡，连洛菲菲也打起呵欠来，但她并没有在这种力量的影响下深眠，只是无比放松地躺着。\\n“欧文哥哥……雨蒙姐姐……”过了好一会儿，洛菲菲轻声呼唤道。\\n“小妹妹，你睡不着？”回答她的是李雨蒙。\\n睡在篝火对面的“日夕”侧头看着她，这位一路上高傲的女神现在变成一个忐忑的少女。\\n“我也没睡着。”“月夕”接话了，娴丽的脸上露出凝重的神色，“月夕有各种各样的祝福力量，没想到让大家睡个好觉也是其中一种。”\\n“那是不是证明我们比他们厉害？”洛菲菲干脆坐起来，就像小孩子在朋友家留宿时瞒过大人偷偷起床看漫画打游戏一样兴奋。\\n最终兵器的身体动作过大，发出响亮的盔甲碰撞声，李雨蒙赶紧朝她做了个“嘘”的手势。\\n“合体之后，我们和他们五感同步，身体受伤的话，大家都会感到疼痛，吃到难吃的东西都会想吐……”欧文自顾自地总结道，“但我们的意识拥有一定的自由度和自主度，只要思想和情感不要太强烈，他们就感觉不到……所以，能抵抗月夕祝福之力影响的意识，让我们保持清醒……”\\n这个人在说什么？李雨蒙想，玩家当然不会睡着呀，要不游戏怎么进行下去？还以为是个高玩，看来只是系统随机分配的伙伴角色。\\n那么，她就按照剧本的提示，接着演下去吧。\\n“你是说，我们可以趁她们睡着的时候偷偷行动？”\\n“如果动作不太大的话。”\\n“我不怕，我的大家伙一直在睡觉！”洛菲菲兴高采烈地说。\\n“我们……要背着她们偷偷做什么？”李雨蒙有点忐忑。\\n“……大家想回家吗？”欧文问道。\\n洛菲菲瞪大了眼睛，李雨蒙的心里扫过一抹不安。\\n从来到这里开始，欧文一直做好两手准备——在异世界生活下去，或者暗中找机会回家。在遇到其他人类后，“回家”的念头愈发强烈，大家和他一样，都是被一座石塔中的召唤具召唤来的，所以那些东西，一定能再次打开连接两个世界的通道。\\n问题在于，如何使用，总不能像动画片的英雄那样，高举召唤具大喊一声，就能打开通道。那么是数量的问题吗？\\n洛菲菲的召唤具已经遗失在狂野沙漠了，她只听说过这东西，而且一路上发生太多事，她还没来得及有心思让埃癸斯和马克拿召唤具给她看看。现在，她好奇地看着欧文和李雨蒙的召唤具。\\n两个召唤具大小和形状相仿，但又像同款的手工艺制品那样有些许区别。召唤具中心都散发着幽绿的微光，微光只能照亮大概一米的直线距离。\\n“这些召唤具辐射着某种能量，能给手机充电。”\\n看着惊讶的两人，欧文把林宇翔手机的事告诉大家。刚见到日夕和李雨蒙时，因为对超进化大陆拥有巨大潜能的“金融系统”和“航运系统”太兴奋，完全把那件事给忘了。\\n这游戏剧本……还编得挺严谨的。李雨蒙想，心中的不安更加强烈。她认为游戏故事就该天马行空，但这个“游戏”总和自己的现实世界有种扯不断的关系，让她渐渐分不清自己是站在幻想这边还是现实那边。\\n“是不是还要用咒语？”洛菲菲天真地问道。\\n“最终兵器大人，你说对了……”\\n森林中冒出一把夜风吹过枯木的声音，大家打了个激灵，如果还是人类躯体的话，准会起一层鸡皮疙瘩。\\n“谁？”欧文喝道。",
    "resoundEventConfigDes_5012": "“月夕大人，日夕大人。自从那次会议之后，好久不见了。”\\n来者彬彬有礼地向他们鞠了个躬，刻满刀疤的脸上看不出表情，他看出双胞胎姐妹、尤其是月夕脸上的疑惑，心中的怨恨更深了一层——进化成不朽的优越感让她们忘记他才是统领一族的族长了吗？\\n没错，来者正是在这场大战前夕寻觅灵魂的木偶族族长史卡非斯。自从狂野沙漠石塔之战的失败后，他一直在监视埃癸斯的行动。但是，他的目标是石塔宝物，看到埃癸斯把最终兵器交给月夕而没有一同前来，他有点遗憾，犹豫了一下，在日月姐妹和埃癸斯之间，他还是选择了较容易下手的月夕这方，企图一次骗走两个召唤具。\\n小心翼翼地偷听了好一会儿他们的对话，虽然没全弄懂是怎么回事——史卡非斯将之归结为自身灵魂的非完全体导致部分智慧缺失——但他听明白了这些不朽族体内藏着来自异界的灵魂，这些灵魂似乎想回家。\\n而且，那三个宝物他正是他梦寐以求的！要把它们骗过来！\\n“你都听到了什么？”欧文开门见山地问道，看着史卡非斯老谋深算的眼睛，他觉得没必要和对方装模作样。\\n“三位不朽大人的尊贵的异界灵魂，你们想回家吧？召唤具的确能打开连接异界的通道，但要再次打开通道，就需要咒语了。”\\n“日夕没有跟我说过这回事呀。”李雨蒙说。\\n“……是吗？她们果然不想你们回去啊……”史卡非斯叹了口气。\\n“你是说，她们其实知道我们回家的方法？”欧文想起月夕对自己诚挚的态度，一时间无法接受这样的解释。\\n“如果你们回去了，三位不朽级的大人就会退化为究极级，他们担心自己不是邪王的对手。”\\n“可是大家伙什么都没对我说过，他一直在睡觉……而且，召唤具也不在我们身上……”洛菲菲相信自己的判断，最终兵器不可能在装疯骗她，当然前提是怪兽和人类的情感是相似的。\\n“哦，是吗？最终兵器大人的另一面我不太了解，我只听说过他的种种传说，抱歉说了多余的话。”史卡非斯也不为自己辩解，他佯装自己对最终兵器一无所知，这会让自己显得更加真诚。另外，他是最清楚最终兵器的召唤具在哪里的怪兽了。\\n“如果我们回去自己的世界，你们能战胜邪王吗？”欧文问道，虽然会担心月夕孤军作战，甚至有种依依不舍，但他更想回家，趁还能扼杀这份不舍之前，回家。\\n上钩了。史卡非斯内心窃笑，不过，他表面上还是装出担心的样子。\\n“远古族的几位大人想把那份使命扛在自己身上，他们不希望其他怪兽参战……”\\n咈咈咈，月夕的想法太容易模仿了，就是假装自己是个好人有点恶心。史卡非斯努力按捺着那份恶心。\\n欧文更加动摇了，是的，月夕毫无底线地爱护着其他人，她迟早会因此吃大亏的。\\n李雨蒙一直以为这是游戏剧情，但没有快进键和跳过键稍微有点麻烦，估计这是游戏制作者对故事超级自信的表现，不过她倒觉得这个游戏的故事很一般。剧情之后就是战斗吧，所以，她从史卡非斯出现开始就警惕着要随时战斗。\\n洛菲菲还在理清突如其来的千头万绪，自己和大家伙合体，是不幸中的万幸吧？如果大家伙不爱睡觉一直醒着，恐怕不会放自己走。要回家，这个是千载难逢的机会！如果自己也能通过另外两人用召唤具打开的通道的话……不过，世上哪里会有主动帮助别人而不求回报的人。\\n“我们可没钱哦，你到底想要什么？”洛菲菲问。\\n“我想要各位大人的召唤具。” 史卡非斯毫不客气地展现自己的欲望。\\n所谓骗术的最高境界，就是在谎言中掺入真实，让行骗者也相信自己在展现着真实。\\n“……”\\n史卡非斯的坦白让大家陷入一片沉默。\\n“……月夕不会骗我的。”\\n“她把召唤咒语和法阵的记忆封印了，连自己都不知道自己在骗你。”\\n“……”\\n“但我知道，我偷听了远古族几个大人的会议，我也要用他们的召唤具进化成不朽！并不是只有他们能打败邪王！”史卡非斯说得连自己也燃了起来。\\n怎么回事？对方浑身充溢着一种不得不相信他志气，连最冷静的欧文也彻底动摇了。即使被他骗走召唤具，他们也没什么损失。但如果召唤具能让其他怪兽都进化成不朽，那么对付邪王就易如反掌了！\\n等等……这是不是意味着这个木偶怪兽以后会把其他人类召唤过来？但这与自己有什么关系，古拉姆体内的那个大学生、暴虐战狂体内的那个导游，自己也无法挽救，说不定对方还乐此不疲呢。欧文的良知也在动摇，然后，他决定了——\\n“要怎么做？如果我们把召唤具给你。”\\n哈哈哈哈哈哈！成功了！史卡非斯的内心在狂笑。",
    "resoundEventConfigDes_5013": "欧文不安地望了一眼稍远处的弯月座驾，它并没有跟在自己身边。是否单凭自己的意志，无法控制它呢？但不用担心吧，一个究极级的怪兽再强大也无法同时袭击三个不朽。\\n两个召唤具被放置在一个复杂的魔法阵上。据史卡非斯说，他们休憩的地方正好残留了高浓度的魔法能量残渣，非常适合作为打开异界通道的场所，如果有三个召唤具就更好了，但只有两个也能尽管尝试一下。\\n史卡非斯对着法阵轻声念诵咒语，大家不安地围观，屏声静气。\\n法阵中的召唤具发出更强烈的幽绿光芒。\\n“超进化大陆的安危，暂不劳三位来自异界的无形之神费心，我将回应命运的期待，抵达不朽之境！”\\n随着史卡非斯的一声大喝，欧文、李雨蒙、洛菲菲同时失去重心，离开地面！\\n可是，并非他们作为人类的躯体被抽离了怪兽的身体，而是保持着原来的形态被齐齐整整地倒吊在三棵大树上，起吊点是他们的脚踝。\\n如果只是在朦胧的夜色中匆匆一看，他们的脚踝上什么都没有，细看之下才会发现把他们吊起来的是宛若人类发丝般粗细的丝线。\\n“你骗我们！？”李雨蒙尖叫，同时还用双手紧紧按着裙子，以防走光。\\n“大坏蛋！！”\\n“……”\\n“咈咈咈咈咈，何必把如此明显的事实重复一遍！”史卡非斯愉悦地笑道。\\n法阵上的光芒消失了，他搓搓手，迫不及待地把召唤具收起来。\\n同时，由于刚才的一瞬惊吓，月夕、日夕和最终兵器一起醒过来。\\n“发生什么事了？”月夕瞬间夺回身体控制权。\\n“这个丑八怪趁我们睡着的时候偷走了召唤——吼！！”\\n洛菲菲的控诉还没结束，最终兵器狂暴的意识就占据了整个身体，那份混杂着愤怒的恐惧把洛菲菲的意识压抑在意识之壳的一角，但那份弱小的求救声还是传达到最终兵器心中。\\n他的激烈晃动震得树叶簌簌落下，几乎隐形的丝线似乎随时会被他扯断，挥动的双拳也差点就打在史卡非斯脸上。\\n史卡非斯跳开几步，奸笑着：“没错，大人们一半的灵魂沉睡了，另一半的灵魂却在密谋着离开的计划，呵呵……”\\n“史卡非斯大人，请不要离间我们。”月夕得到欧文快速的辩解后如此说道。\\n“你要的话，直接开口就好了，不用这么偷偷摸摸，我也会赏给你。” 日夕睥睨着史卡非斯。她只是在离开石塔的时候随手把召唤具带在身上，估计这东西已经没有什么作用了。\\n“你在可怜我？”因为日夕冷漠的声音刺伤了他的自尊，史卡非斯收起刚才的愉悦。\\n“是哦，你就顺从地接受这份怜悯吧。”\\n“史卡非斯大人，我的召唤具也请你拿去吧。”即使在倒吊的情况下，在最终兵器于一旁疯狂的摇晃中，月夕依旧绽放出令人安心的笑容。\\n可惜这对已经扭曲的灵魂没有任何作用。\\n“你们以为这样说，我就会感激涕零吗？”史卡非斯退到一棵大树背后，暗影让他阴沉的表情更加瘆人，“该感激涕零的是你们，因为我让你们不用看着同伴痛苦的面容死去……”\\n他没有挑衅地说出最终兵器的召唤具也在自己手上，他怕万一对方加剧了狂怒，能挣脱丝线。\\n毫无声色地，几十只皮诺丘和皮影人从空地旁边的密林中出现，渐渐在双胞胎姐妹和最终兵器下面形成包围圈。皮诺丘手上都拿着等身长的缝纫针，针尖在篝火的映照下闪烁着寒光。与躁动的皮诺丘相比，皮影人们显得异常安静，他们那像是被缝起来的嘴上挂着诡异的笑容。\\n“你们就无谓挣扎了，这些丝线都被我施加了强化魔法，即使古拉姆的剑都砍不断，呵呵呵呵……”\\n笑声越来越远，史卡非斯的身形完全隐没于林中。",
    "resoundEventConfigDes_5014": "逐渐聚拢的针尖簇拥成一片此起彼伏的尖刺刺向双胞胎姐妹和最终兵器的头部，即使最终兵器戴着头盔，暴露的眼睛依旧是最脆弱的部分。但他毫无章法地晃动身体，却是最有效的抵挡方法，猛力挥动的拳头偶尔会把某只皮诺丘打飞。\\n双胞胎姐妹一手遮掩头部，一手勉强的放出攻击法术，她们情况非常不容乐观，双臂都被刺得伤痕累累。\\n更糟糕的是，皮影人们封住了她们的技能，不论是治疗回血还是更进一步攻击都变得异常地吃力。\\n日夕一想到自己万一毁容了怎么办，就完全无法冷静下来。她慌乱地挥动着双臂，想抢夺皮诺丘的缝纫针，但手指快要触碰到针尖的时候又害怕地缩回来。\\n也不知道是哪只皮诺丘开始的恶作剧，日夕被他们当沙袋一样推来荡去，闹哄声和针尖一同起伏，日夕的尖叫更助长了皮诺丘们的兴致。\\n情急之下，月夕荡向妹妹，一手抓住一根快要刺到日夕眼睛的缝纫针，连带把举着针的皮诺丘甩到一旁。\\n但是，这只皮诺丘好死不死地飞到最终兵器那边，缝纫针以不可阻挡的势头直刺入最终兵器的身体。\\n“啊——嗷——”洛菲菲的惨叫和最终兵器的嚎叫重合在一起。\\n最终兵器本能地爆发出力量将身体推向上空，把大树连根拔起！\\n从未感受过的疼痛刺激着洛菲菲的每一寸神经，心底深处喷涌而出的绝望快要把她的心染成黑色。\\n“……杀了他们！”洛菲菲向眼前那个巨大的影子伸出手……\\n“吼啊……！！”\\n最终兵器俯冲而下，大部分敌人被它的双拳击倒，剩下的，被系在他腿上的大树扫飞或压扁。\\n皮诺丘和皮影人们的“狂欢”就这样落幕了。\\n待四周已经没有可击倒之物后，最终兵器看也不看双胞胎姐妹一眼，飞进森林。那棵被拔起的大树也扫荡着障碍物，森林中响起树木倒下的轰隆巨响。\\n月夕和日夕面面相觑。\\n“他……就这样走了？扔下我们不管就自己走了？”日夕惊愕地瞪着眼睛。\\n“喂，你们那位人类小朋友是怎么回事？竟然是个自私任性的小鬼吗？”日夕质问李雨蒙，但得到的只是沉默的回应。\\n“恐怕是吓坏了……”月夕说。\\n“那我们要怎么下来？我们可没他那种怪力。”\\n“这……”日夕一时也想不到办法。\\n黎明前的凉风吹过日夕又酸又麻的大腿，手臂受的伤已经痊愈了，但那种刺痛还历历在心。在侥幸逃开的皮诺丘和皮影人没有重新包围她们之前，冷静下来的月夕从最终兵器的自救中得到了启发——坐上弯月座驾，解开套紧脚踝的丝线，然后再放日夕下来。\\n丝线松开之后，日夕摔得一脸土，这比受伤更丢脸。\\n日夕的手不禁伸向藏在裙兜里的紫色孢子团。倒吊了那么久，它们竟然没有掉出来。\\n意志摇摆的日夕并没有在意李雨蒙的沉默不语，而李雨蒙正在“回味”刚才的痛楚。\\n好难……这游戏好难玩……\\n现在她总算明白合体设定的意义了，原来是手动模式和自动模式的区别。\\n既然无法选择难度，选择自动模式不就行了吗？\\n以旁观者的角度观摩整个游戏，忍受所有幻痛，努力寻找退出键。\\n万一找不到退出键……没错，一定是这个游戏公司利用某种不知名尖端科技策划的阴谋，可能是某种人体实验，一些小说不是写过游戏玩家意识被困在游戏中的故事吗？引起社会关注的话，自己就能得救。\\n——就这样，李雨蒙的思维向另一个方向跑偏，沉浸在另一个“现实”中。",
    "messageInitNick_9958": "茄子剑客",
    "messageInitNick_9959": "梦游大师",
    "messageInitNick_9945": "大鲨猫",
    "messageInitNick_9946": "眩晕眩晕",
    "messageInitNick_9943": "翻新过的猫",
    "messageInitNick_9944": "今天休息",
    "messageInitNick_9941": "琴狂剑也妄",
    "messageInitNick_9942": "职业摸鱼",
    "messageInitNick_9940": "醇香的榛子",
    "messageInitNick_9949": "无敌卷神",
    "messageInitNick_9947": "独守一人心",
    "messageInitNick_9948": "灵气少女",
    "resoundEventStoryDes_354": "你……你是否满腹惆怅，无处安放？想要告别独数晨曦，孤聆暮霭的日子？不想再笼闭一室，枯坐凝思？\\n欢迎到龟谷之上的长气之地游玩，环境得天独厚优渥安全，一群热心的阅历丰富的怪兽将为你排忧解难，独特的长气广场舞蹈文化带你告别的孤单，更有龟谷特产三色孢子盘。（翻译：赶紧来陪我们这些老头们唠嗑啊喂混蛋，长气总比叹气好哇。）",
    "resoundEventStoryDes_355": "长气之地是一个相当松散的组织，位于龟谷之顶的一个名叫长气之顶广场的宽广玄武岩平台上。组织实行头领终身制，长气之子是长气之地的头领，它们未必长寿，但必然长气。10年左右就会迎来头领的交替，这通常意味着，最年老的怪兽死亡的间隔。生活在这里的怪兽多是一些迈进了最后四分之一兽生的怪兽。它们深知时间的可贵，却又纵容自己挥霍时光，所以它们选择群居，因为最能警醒自己珍惜时间的，往往是被其他怪兽浪费自己时间的时刻。",
    "resoundEventStoryDes_352": "这是一个神秘的泥潭，和其他神秘的XX一样，非常地神秘。这个神秘的泥潭被一些怪兽称为过去的泥潭，凡是沉没其中的东西都无法挽回，可总是有很多怪兽围在泥潭附近，久久凝视着泥潭深处，不愿意离去。它们无法舍弃，那沉没泥潭之物，不管是时间，精力，还是肉肉山的肉肉。",
    "resoundEventStoryDes_353": "这也是一个神秘的泥潭，和其他神秘的XX一样，非常地神秘。这个神秘的被一些怪兽称为未至的泥潭，里面有杂乱的，不会出现的时间线团。实际上这个泥潭就在过去的泥潭的旁边，可是谁都没有留意到它，谁都注意不到它。怪兽们都没有意识到，它们看着过去的泥潭，就意味着它们失去了本可以利用这段时间来做点别的什么的可能。",
    "resoundEventStoryDes_350": "怪兽赋予了从超星海洋漂到岸上的东西不同的名字，有的称之为“洋垃圾”，有的称之为“洋馅饼”，有的称之为“海上珍宝”。这多少反映了它们对这些东西的不同态度。如果有机会到超星海洋的海岸走走，你就会在岸边见到一些忙碌着的怪兽，它们很可能是捡海馅饼的怪兽。",
    "resoundEventStoryDes_351": "捡海馅饼的怪兽偶尔还会打起来，常见原因之一是为了争抢一件海馅饼，这都是一些微不足道的零星个体。\\n值得注意的是以下两个组织，“超进化星防卫队”和“海上珍宝商人”。\\n前者认为海馅饼是一种入侵，它们不时会组织成员将岸边的海馅饼收集并处理掉。\\n而另一部分则将收集到的各种海馅饼收集分类，倒卖到大陆各处的怪兽手中。",
    "messageInitContent_7257": "再见了~",
    "messageInitNick_9934": "路霸猫",
    "messageInitContent_7258": "是谁在狞笑",
    "messageInitNick_9935": "此小子坏坏滴",
    "messageInitContent_7255": "冷冷冷雨夜",
    "messageInitNick_9932": "太阳之神",
    "messageInitContent_7256": "凉凉凉凉的手",
    "messageInitNick_9933": "等老娘出帽子",
    "messageInitNick_9930": "含一颗星星",
    "messageInitNick_9931": "狂野芒果",
    "messageInitContent_7259": "是它",
    "messageInitContent_7250": "吓人",
    "messageInitContent_7253": "怪不得老觉得凉凉",
    "messageInitNick_9938": "风中残烛",
    "resoundEventStoryDes_358": "月兽之洋的潮水并非常见的半日潮，而是罕见的一日七潮，造成这个异常的很可能就是海中的巨大怪兽，当它吞入海水的时候，就会退潮，当它吐出海水的时候，就会涨潮，潮起潮落，尽在它的吞吐之间。",
    "messageInitContent_7254": "到处都能看到冰",
    "messageInitNick_9939": "霸道哥气质姐",
    "resoundEventStoryDes_359": "触发这个隐藏开关，就可以打开通往造唤台的一隅的环形石室，石室数十个雕刻着复杂纹饰的兽首挂在平整的弧形石壁上，透过空无一物的眼眶俯视着走道，就像王·罗密欧王·朱丽叶的其他收藏室一样，在博得王·朱丽叶一笑后，就再也没有接待过谁。这些兽首仅在它们被放在这里的那天，用不存在的耳朵从王·罗密欧口中听到了自己的来历。\\n生前，它们是部落最强大的首领，死后，它们的兽首被用于祭祀，下一任首领将从这个头颅继承上一任的精神与力量。完成继承后，这个兽首也就不再具有力量，它最后的使命也完成了。",
    "messageInitContent_7251": "███████████████████████",
    "messageInitNick_9936": "大叔控",
    "resoundEventStoryDes_356": "龟谷，又称作玄武的移动城堡，外形是一只毫无创意的巨型石龟，在过去的无数年月里，精密地循着一条路线，以半只叉叉的行进速度，在路线上往返。尚不清楚到底是什么在驱动着龟谷。长气之地的怪兽相信龟谷之中必然存在一个自然之灵，每日清晨，它们会在长气之顶广场上，一边条跳舞一边唱歌歌颂自然之灵。由于路线附近的部落都搬走了，所以并不会因为歌舞时的声量过大而受到攻击。",
    "messageInitContent_7252": "一点都不吓人",
    "messageInitNick_9937": "柳无色",
    "resoundEventStoryDes_357": "月兽之洋是位于超进化大陆最西边的海洋，海中匍匐着一只巨大的触手怪。它是如此巨大，以至于不管处在海岸哪个位置都可以感觉到它的目光，仿佛它一直在凝望着你，好像天上的月亮一样。在怪兽们的记忆中，自有记载以来，就不曾有它袭击怪兽的记录，但我们可以就此安心了吗，还不可以，天知道对它而言，我们漫长的岁月是否只是它的数秒，万一它突然饿了呢。",
    "messageInitNick_805": "回到原点",
    "resoundEventStoryDes_365": "“荧惑星在远方凝视，划破天空的亮星直直下坠，直到一股暧昧不明的氛围将之缠绕，流星开始偏转，将夜空当成了它无尽旋转的舞池……”——这！就是螺旋流星！一种奇特且异常罕见的天象。在收集和研究目击者的情报中了解到，螺旋流星的出现时间和位置毫无规律。",
    "messageInitNick_806": "老师掉线了",
    "resoundEventStoryDes_366": "最近，关于螺旋流星的研究取得突破性进展，智者在贫穷无比饥饿的梦游期间，来到了早前被大体型轰龙撑爆了的投食洞穴，试图找到一些食物残渣的时候，发现了一块原本深埋在投食洞穴深处的石碑，智者经过一番研究，把石碑上的内容解读了出来“螺旋流星出现在赞美时。”",
    "messageInitNick_807": "距离产生美",
    "resoundEventStoryDes_363": "桐仁从疾风兔那打听到的偶木桥是这样的，那是架在微光之森西丘轻唱小溪上的桥。与普通的光棍独木桥不同，它由两根树干组成的。周围的环境清幽绮丽，充满遐想。只要在偶木桥上向喜欢的怪兽告白就必定会成功，之后永远相爱不分离，运气好的话，还能看见爱神的祝福。",
    "messageInitNick_808": "鸡蛋超人",
    "resoundEventStoryDes_364": "桐仁看到的偶木桥是这样的，小溪边沿的树木多数被拦腰折掉或是连根拔起，留下孤零零的树坑，远远向前看去，一大群怪兽挤在溪旁，桐仁挤了很久才能勉强看到溪上的偶木桥。\\n但小溪之上，那可不是一条桥，而是密密麻麻的，一延绵出去，一直铺到视野外的偶木桥。\\n如果这世界上真的有爱神，见到这幅光景应该早溜了。\\n后来桐仁才知道，因为到这里告白的怪兽实在太多了，最初的桥早已不堪重负垮掉，于是，更多架上了更多新桥，让大家都能顺利排队登桥告白。",
    "messageInitNick_809": "王位之上",
    "resoundEventStoryDes_361": "当太阳在天空最高处时，这个名为动心的湖的湖面会先大幅下降，再鼓起来，如同心脏的鼓动一般。\\n我让声称自学过水之呼吸的桐仁下水一探。它找到一根空心的芦苇咬住，跳入水中，展开探索。\\n桐仁出水后表示湖水有点臭味，水下有不少水草，并没有发现其他特别之处，真是让我头大呢。难道里面是有不能露面的水怪吗？",
    "resoundEventStoryDes_362": "这是解决篇，请放心，保证直奔结局，可不会到最后还是未解之谜哦。\\n那天，智者，也就是我，在上面提到的湖周围寻找线索，你猜我发现了什么，就在距离动心湖不远处隔着一片小树林的地方，我发现了另一个湖，那个湖和动心湖差不多大小，就在太阳高挂于空之际，我居然看到一只巨大的凶噬魔，它先是大口将湖水吸入嘴里，在漱了漱口之后，又把水吐了回去。\\n等这只巨大的凶噬魔离开后，我又将桐仁唤来，它下水之后在我所说的地方将水草拨开，果真如我所料，这两个湖是连通的！",
    "resoundEventStoryDes_360": "王·罗密欧用一大包进化孢子从有祭祀兽首习俗级的部落里，换了一个兽首。\\n对于这个部落来说，那不过是一个不再有力量的头颅，用来换一大堆进化孢子显然再划算不过。\\n随后兽首可以在王·罗密欧手上换取进化孢子的事渐渐传了出去。\\n环形石室内那个顶着三个角的是首领兽首，其余的，都只是听说自己是首领。\\n那个没有下巴那个头是不知道哪里挖出来的，那个带着鬃毛的是意外死亡的。\\n至于那个牙齿都还没掉的，则是被想要换取进化孢子的某头怪兽杀掉的，上面的纹饰都是后来伪造上去的。",
    "messageInitNick_800": "补刀公主",
    "messageInitNick_801": "横笛听雨",
    "messageInitNick_802": "弹琴不谈情",
    "messageInitNick_803": "末日第六感",
    "messageInitNick_804": "尬聊门传人",
    "messageInitContent_7268": "记忆丧失",
    "messageInitNick_9923": "旧恋人",
    "messageInitContent_7269": "记忆遭到清洗",
    "messageInitNick_9924": "香菜兽",
    "messageInitContent_7266": "███████████████████████",
    "messageInitNick_9921": "小乔不会玩",
    "messageInitContent_7267": "禁忌的第零章",
    "messageInitNick_9922": "无眠兔",
    "messageInitNick_9920": "暴走的小菇凉",
    "messageInitContent_7260": "它是谁",
    "messageInitContent_7261": "谁是它",
    "messageInitNick_9929": "会发光也会慌",
    "messageInitContent_7264": "禁忌的第2章",
    "messageInitNick_9927": "赶紧跑图",
    "resoundEventStoryDes_369": "和智者一样听到了神奇海螺消息的还有桐仁，它马上启程寻找海螺，和智者不一样，它是有问题的，它想知道，御空是怎么看待它的。这个问题一直困扰着它，它很清楚它的这种心情其实与御空的态度无关。可是说不在意那是就是假的。它又怎么可能不在意。",
    "messageInitContent_7265": "禁忌的终章",
    "messageInitNick_9928": "撩汉课代表",
    "messageInitContent_7262": "哈哈哈哈哈哈好好笑哦……啊",
    "messageInitNick_9925": "宝石流云",
    "resoundEventStoryDes_367": "当晚，智者找到了桐仁，智者卯足干劲开始赞美桐仁。整夜，山谷中都回荡着智者的声音，终于桐仁看天的脖子到达了极限，它对着智者用右手比了个赞“你可真能吹。”就在此时，螺旋流星出现了！",
    "messageInitContent_7263": "禁忌的第一章",
    "messageInitNick_9926": "酷到没边儿了",
    "resoundEventStoryDes_368": "“有问题就去问月兽之洋的神奇的海螺吧！”\\n智者从怪兽的口耳相传间听到了这句话。它想，如果真有这么个神奇的海螺，那对于它而言就是个毁灭性打击，本来生意就惨淡，再多了一个竞争对手还得了。于是它立刻把自己的店锁好，仔细地在店门贴上我很快就会回来哟的告示后，直奔月兽之洋。",
    "messageInitNick_816": "安徒生的剧本",
    "resoundEventStoryDes_376": "最近，智者听到了一些关于“四脚兽”的传闻，那是一种它不知道的全新物种，它自然是要去一探究竟。经过一番打听，智者在污妖王的口中得到了线索，“四脚兽？四脚兽很常见的，我经常在澡堂看到，运气好还能见到六脚兽噢。”\\n得到线索后智者马上准备好行囊，往污妖王提到的澡堂出发。",
    "messageInitNick_817": "假装有对象",
    "resoundEventStoryDes_377": "智者来到了污妖王所说的澡堂，为了一探门缝后的光景，为了获得更好的观察视野，它把脸贴到地面上进行观察。智者说服自己这不是偷窥，这只是为学术献身，是通往真相所必经之路。\\n在几次被赶后，智者还特地给自己制作了一个标牌插在自己身边，上面写着“正经的四脚兽研究进行中！”。",
    "messageInitNick_818": "超拽的小男人",
    "resoundEventStoryDes_374": "涤灵莲华，别名浴池花，澡堂花，是一种生长在淡水中的花，最小的浴池花内可以容纳5只叉叉，而最大的浴池花可以容纳50多只叉叉。\\n这种花拥有一个巨大且会发热的雌蕊，怪兽们只要推开花瓣，让池水涌入花的内部，就可以在里面泡澡了。\\n但千万不要随便跳到其他怪兽的澡堂花里头。因为不同怪兽的耐热程度不一样，熟挂了就不好了，而且偷窥是不好的！",
    "messageInitNick_819": "猫星人",
    "resoundEventStoryDes_375": "“这里是超进化大陆某处的澡堂，据说最近这里出现了一只偷窥澡堂的怪兽。现在超进化电台记者白昼将为你一探究竟。可以看到有几只怪兽陆续入场洗澡，噢。看到了，澡堂门口有个古怪的黑影。它首先在地上插上了一个牌子，然后用orZ的姿势窥探澡堂的内部。然后，它被发现了，它被赶走了！”",
    "resoundEventStoryDes_372": "夜幕渐渐降临，奇异的天光变换出各种无名的色彩，海岸边的智者正愁着自己是不是走错了。\\n此时，潮水渐渐褪去，一个开口有十叉叉大的海螺出现在天海之间。智者回过神后，紧张兮兮地将神性火丁旋开，才发现自己已经身处海螺之中，世界仿佛被海螺包围了一样。智者一步步走向海螺深处，“有怪兽吗——”它试着呼喊，只有回响，没有回应。智者来到海螺的最深处，发现就真是个海螺，没有竞争对手，于是它松了口气，满意的离开了。",
    "resoundEventStoryDes_373": "夜幕渐渐临，奇异的天光显现出变换出各种无名的色彩，海岸边的桐仁正愁着自己是不是走错了。\\n此时，潮水渐渐褪去，一个开口有山洞大的海螺显露在天海之间。桐仁者回过神后，紧张地搓着手手，才发现自己把神圣火丁漏在岸边了，黑暗以及超时的空气包围着它。“神奇的海螺，请告诉我，御空喜欢我吗——”它试着发问，只有回响，没有回应。于是桐仁转身离开。因为，问题的答案早就在漫长的独行中浮现。",
    "resoundEventStoryDes_370": "为了找到神奇的海螺，智者日夜兼程一路往南方向行进，它一边问路，一边走，得到了许多不知道和瞎指路的指点，来到了月兽之洋，传闻神奇的海螺的所在。可是眼前只有一望无际的海面。",
    "resoundEventStoryDes_371": "为了找到神奇的海螺，桐仁日夜兼程一路往南方向行进，它一边问路，一边走，得到了许多不知道和瞎指路的指点，来到了月兽之洋，传闻神奇的海螺的所在。可是眼前只有一望无际的海面。",
    "messageInitNick_810": "一壶铁观音",
    "messageInitNick_811": "食堂泼辣酱",
    "messageInitNick_812": "你未来的老公",
    "messageInitNick_813": "叫我一声爷",
    "messageInitNick_814": "第十人称",
    "messageInitNick_815": "程序在线卖饼",
    "messageInitContent_7279": "这肉块中有什么东西在里头爬行",
    "messageInitNick_9912": "卷门掌门",
    "messageInitNick_9913": "陨石送你修修",
    "messageInitContent_7277": "那是恐惧的形状吗",
    "messageInitNick_9910": "不爱化妆",
    "messageInitContent_7278": "四散的肉块，散发着阵阵恶臭",
    "messageInitNick_9911": "卖保险的大哥",
    "messageInitContent_7271": "记忆在跳舞",
    "messageInitContent_7272": "记忆在纠缠",
    "messageInitNick_9918": "吃的甜中甜",
    "messageInitContent_7270": "记忆被消除",
    "messageInitNick_9919": "狠狠拿捏",
    "messageInitContent_7275": "快……赶在那之前",
    "messageInitNick_9916": "此用户已离线",
    "messageInitContent_7276": "它的形状在不停变化",
    "messageInitNick_9917": "纯爱之王",
    "messageInitContent_7273": "████████████",
    "messageInitNick_9914": "牙线剑客",
    "resoundEventStoryDes_378": "此刻的智者非常兴奋，因为它终于看见了，门后有1，2，3，4，四只脚！它期待已久的四脚兽即将要走出来了！\\n下一秒，从门后走出来的竟然是两只怪兽！就在智者脑海的可怕想法逐渐形成之时，智者被真正的四脚兽叫住了，他自称喀戎。最终，在完全了解了喀戎的故事后，智者补全了《智者百科》四脚兽条目的空白。",
    "messageInitContent_7274": "惊骇的实际正在成形",
    "messageInitNick_9915": "伊人独醉",
    "resoundEventStoryDes_379": "幻之海并不是指有很多幻的地方，唔，不过在镜影森林确实有机会看见幻山幻海，这个倒是无法否认。\\n咳咳，容我重新向大家讲述一下我的那次经历。不单单是我，当时整片区域的怪兽都目睹了那一个奇观。天地相接的地平线上，一股巨浪直直地扑了过来，不断奔涌前进，怪兽们绝望的逃跑。那些脚程最慢的怪兽在慌乱间最先被巨浪裹挟，就在那一瞬，也就是那些正在逃命的怪兽，最先发现，那不过是无害的摸不着的巨浪幻影。",
    "messageInitNick_827": "老尼法号靓女",
    "resoundEventStoryDes_387": "碧空如洗，煦阳灿烂，留声岛倒影在无声湖的湖心，遥看破败凋零，阴森可怕，小岛在湖中独坐。细看虚晃的倒影，不死枯藤白骨上绕，腐臭四散，包围着凹凸不平的骸堆，几步一株，致幻毒草，引入幻景，奉上虚伪的美好。",
    "messageInitNick_828": "泪抹倾城妆",
    "resoundEventStoryDes_388": "留声岛上的草，就是留声草了，那是一种带有剧毒的草，其毒素透过土壤和周围的水分散播出去，接触到的怪兽会陷入到美妙的幻觉中，在幻觉中逝去。所以那一带总是异常地安静。至于稍微能挣扎制造出点动静的怪兽，它们最后的声音将会永远留在那座岛上。",
    "messageInitNick_829": "醉红颜",
    "resoundEventStoryDes_385": "偶尔能在金矿附近发现大兜树的叶子，大兜叶。通常还会附带一块写着“砸饭兜。欢迎用闪闪发光的东西砸，来，使劲砸。”的树皮。",
    "resoundEventStoryDes_386": "碧空如洗，煦阳灿烂，留声岛坐落在无声湖的湖心，遥看草木葱郁，繁花盛放，倒影在湖中虚晃。趟过不深的湖水，奇葩异卉争相招摇，暗香萦绕，簇拥着起伏蜿蜒的小道，几步一景，秀色可餐，导向岛央，独揽世间的美好。",
    "resoundEventStoryDes_383": "大兜树是一种常绿植物，多见于气候温暖的地区，因叶子呈半圆形，朝太阳的方向拱起，如同一个倒盖的大兜，而得名。一些怪兽将叶子摘下风干，待其变硬后，用作盛放物品或食物的器具。",
    "resoundEventStoryDes_384": "在幻的兽丝中流传这一个说法，大兜树的树叶，大兜叶会随着幻的RAP而抖动。大兜叶因此深受幻的各种兽丝欢迎，包括但不限于幻幻后援会头号兽丝、幻幻后援会1号兽丝、幻幻后援会首位兽丝、幻幻后援会首席兽丝。所以这棵低矮的大兜树秋天没到就秃了。",
    "resoundEventStoryDes_381": "这棵枝繁叶茂的树有一个异常舒适的树洞，在里面睡过一次的怪兽，都想在里面睡一辈子。随着时间的推移，睡过这个树洞的怪兽变得越来越多。对这个树洞念念不忘的怪兽也多了起来。于是一场不可避免的树洞争夺战开始了。树周围繁茂的草地变成了染血的荒地，智者为了改变这一现状，将争夺树洞所有权的怪兽集合起来，最终经过一天一夜的讨论，一个怪兽轮流独占树洞的规则被制定了下来。还规定树洞每七天有一天休息日。",
    "resoundEventStoryDes_382": "根据规则，怪兽按抽取的顺序排队睡树洞，新加入的怪兽排到最后。起先，排队的怪兽不算很多，大家对树洞都很是爱惜，因为用不着多久又会轮到自己。但随着排队怪兽数量慢慢变多，一些怪兽发现这辈子都不可能有第二次睡到树洞，甚至根本不可能轮到自己。这些怪兽开始了对当天睡树洞的怪兽的攻击。围绕着树洞的区域，冲突愈演愈烈，树洞本身反而得到了完整的休息日，就像台风的中心那般宁静，因为谁都别想睡在树洞里。",
    "messageInitNick_820": "被狗追的夏天",
    "resoundEventStoryDes_380": "路上的小石子总有一股奇妙的引力，让看见的怪兽忍不住想要踢上一脚。\\n在石子之中，隐藏着一种神奇的石子，而发现这种神奇的石子的契机就是某只怪兽无意中的一踢。\\n第一次踢到这种神奇的石子之后，石子周围一定范围的一切就会被记录，石子的大小会影响记录的范围和时长。第二踢之后，石子就会将存下的记录“再现”。\\n这种再现是如此真实，甚至欺骗了视觉，怪兽只能依靠它们的触觉来确认那只是幻象。这也许就是幻之海的成因。",
    "messageInitNick_821": "熊孩子",
    "messageInitNick_822": "躲在梦里边",
    "messageInitNick_823": "小霸道",
    "messageInitNick_824": "无敌懂神",
    "messageInitNick_825": "请输入心脏",
    "messageInitNick_826": "我后悔下凡了",
    "messageInitNick_9901": "上一次微笑",
    "messageInitNick_9902": "薯薯麦卡锡",
    "messageInitContent_7288": "到底是什么东西才能制造这样的现场",
    "messageInitContent_7289": "无序的破坏",
    "messageInitNick_9900": "橙子爱好者",
    "messageInitContent_7282": "将这些亵渎的东西烧掉！",
    "messageInitNick_9909": "猎魔仙女",
    "messageInitContent_7283": "这是什么的足迹",
    "messageInitContent_7280": "那是一种带着钩子的不可名状的东西",
    "messageInitNick_9907": "下年再见",
    "messageInitContent_7281": "快！将它们烧掉",
    "messageInitNick_9908": "正在改写剧本",
    "messageInitContent_7286": "扭曲的爪印",
    "messageInitNick_9905": "主动失忆",
    "messageInitContent_7287": "歪斜的行动轨迹",
    "messageInitNick_9906": "尖叫菠萝",
    "messageInitContent_7284": "这个足迹不属于任何已知怪兽",
    "messageInitNick_9903": "爱已格式化",
    "resoundEventStoryDes_389": "这种不高不矮的常绿灌木正是刺痛你指尖的“家伙”。它主要生长在幽关地区，原本有一个雅致的名号，可是由于它另一个外号“死亡弹球”过于响亮，以至于原来的名号早早被怪兽所遗忘。\\n它在温暖的季节里繁花挂满，在凉风袭来的日子变成满枝球果。若是没有外界干扰，这种黑色球果会在枝头上宿存相当长一段时间。若是不小心碰到了，等待你的将会是它的凶狠回击。",
    "messageInitContent_7285": "未知的怪异的形状",
    "messageInitNick_9904": "受不了这委屈",
    "messageInitNick_838": "萌言惑众",
    "resoundEventStoryDes_398": "高温、毒气、焦土，流火之巅的任意一样构成，单独拿出来都能简单将大多数生物距之门外。但流火之巅并非无主之地，少数其他生物在这里扎下了根。炎上花作为流火之巅少有的植物，拓宽了植物版图的疆域。它就生长岩浆旁，毒浪边，焦土上，每株都是独立单生的个体，炭黑色的根系紧紧地扎入地底，同时往外延展与同类的根交缠。它们的开花的顺序，正是其根系的具现。\\n第一朵花绽放，而后一路炎上。",
    "messageInitNick_839": "黑暗狙击手",
    "resoundEventStoryDes_399": "开花结果，炎上花的果子形状是扁平的柱状，果子成熟落地。若是果子的平面先着地，便会烂在地上，种子会随着果一同腐烂。若是果子的曲面先着地，它们就会开始滚动，如同一个孤独的滚轮，地形将决定它们会滚往何处，要完成落地生根的使命，顺利落入岩浆是必要的。落入岩浆后，果子吸入大量的能量，果瓣与种子之间的隔膜，拉扯果瓣变形，种子随之以极高的速度弹射出去，寻找自己的新天地。残余的果子会化作火花，迎来再次和最后的怒放，随后凋零，飘散。",
    "resoundEventStoryDes_396": "一片半透的花瓣露着微红，和风雨一同飘向大地。它来自不远处的悬铃花矮树群，由于花期较早叶片尚未长出，周围仿佛一片纯红的花海。近看就会发现，悬铃花花瓣的末端向内弯曲，如同星烁的裙摆，或是水母的薄伞，一朵朵将柔软的枝条压成弧形。生长在聚落区域的悬铃花矮树会被怪兽连根拔掉，因为悬铃花在风中摆动时，雌蕊与花瓣的碰撞会发出无比刺耳的声响。它们不知道，被雨水浸润的悬铃花之音，竟宛如天籁。",
    "resoundEventStoryDes_397": "“对这花感兴趣吗？这花挺好玩的。如果是生长在同一枝头的悬铃花，摘下后，摇动任意一朵，其他的悬铃花也会跟着一起摇动噢，嗯，不管相距多远。至于要怎么使用，这可是你的事了，记住每一枝花只能用一次。”路过的怪兽说完就跑了。",
    "resoundEventStoryDes_394": "陆龙们的母亲在离开巢穴后，便会将入口封闭起来，只留下一个小小的风口。大群陆龙生活在一个相对密闭，空气不流通的环境之中。这样的环境是否会影响陆龙的脑部发育，目前尚不得而知。不过没关系，在超进化大陆，智商不够进化来凑。",
    "messageInitContent_7290": "肆意的毁灭",
    "resoundEventStoryDes_395": "怪兽通常可以在探崖下方的森林中找到飞蘑。成熟的飞蘑菌盖直径五叉叉，呈现浅灰色，菌盖边缘圆整，上有圆形斑点，向内微卷，菌柄长三叉叉，粗半叉叉，均柔软而有韧性，多散生。可食用。找一朵成熟的飞蘑，到探崖的风口之上，等着风，然后轻轻跳起，暂离大地，让飞蘑和风带你拥抱天空吧。",
    "resoundEventStoryDes_392": "睁眼地狱是一种非常巨大的花，一朵成熟的睁眼地狱可以容纳十来只叉叉，暗红色的椭圆形花瓣向下微垂，花瓣上布满了淡黄色的颗粒状物，花心内部有一个如同怪兽大嘴般的缺口，无数粗须手状的突起从里头伸出，颜色从根部的浅红渐变为末端的深黑，突起上又布满了明黄色的斑点，让怪兽看了直掉理智。",
    "resoundEventStoryDes_393": "风口？掌心的风穴？会移动的回转弹孔？\\n不不，那是一处位于探崖山洞顶部，会规律地吹出烈风的洞口。风口之上时常上演着各种怪兽迷惑行为，但那不是这次重点。要探探的是风口之下！\\n那是龙的鼻息，一眼看去很容易误以为那是百眼巨龙，实际上那是数量众多的刚刚孵化出来的陆龙，孵化出来后，它们将沉睡一段时间，整齐的鼻息形成了风口的烈风。当某只陆龙的鼻息与它的兄弟姐妹不再一致时，便是它真正独立的时刻。",
    "messageInitNick_830": "空瓶在漂流",
    "resoundEventStoryDes_390": "横贯在两地的必经之路上的正是幽关。这个关口被一群神秘的怪兽占据，它们会向途径这里的怪兽收取“过关费”。它们把需要收取的物品摆到关口显眼处，经过的时候，需要交出数量一模一样的物品。很久以前，有一只怪兽没有交过关费硬通关，结果遭到了无数黑色球果的痛击，体型被动增加了几倍。超额提交过关费的怪兽同样也会遭到无数黑色球果的袭击，不过这些黑色球果所带来的冲击，能让怪兽的肌肉得到极大的放松，仿佛来到了有72个美兽的天堂一般。这是占据关口的怪兽掌握的绝不外传的秘方，通过控制死亡弹球的弹出力度，活用此地。",
    "messageInitNick_831": "咖喱加点糖",
    "resoundEventStoryDes_391": "闭眼天堂是一种非常巨大的花，一朵成熟的闭眼天堂可以容纳十来只叉叉，无意闯入花中的怪兽会被花中的突起的结构吞没，这些突起不断直击怪兽身体的各处痛点，多年累积起来的酸痛似乎都被这不可名状的触感驱逐，直至怪兽沾满花粉，被闭眼天堂吐出。",
    "messageInitNick_832": "无敌钓鱼神",
    "messageInitNick_833": "爱恨嗔痴",
    "messageInitNick_834": "拼搏的大爷",
    "messageInitNick_835": "只要微笑就好",
    "messageInitNick_836": "别打我是酱油",
    "messageInitNick_837": "海边人",
    "messageInitContent_7299": "猫咪突然炸毛",
    "messageInitContent_7293": "███████████████████████",
    "messageInitContent_7294": "██████████████████████████████████████████████",
    "messageInitContent_7291": "一些都已变得面目全非",
    "messageInitContent_7292": "啊啊啊啊啊啊啊啊啊啊啊啊",
    "messageInitContent_7297": "这片泥泞之地到底藏了怎样的脏污",
    "messageInitContent_7298": "猫猫突然尖叫",
    "messageInitContent_7295": "███████",
    "messageInitContent_7296": "█████████████████████",
    "messageInitNick_849": "宝宝心里苦",
    "messageInitNick_841": "国民极品老公",
    "messageInitNick_842": "怪怪怪大叔",
    "messageInitNick_843": "别哭不能输",
    "messageInitNick_844": "典型小二货",
    "messageInitNick_845": "不帅你报警啊",
    "messageInitNick_846": "洋娃娃长剑",
    "messageInitNick_847": "黑匣子",
    "messageInitNick_848": "傲娇女王范",
    "messageInitNick_840": "专业摸鱼",
    "messageInitNick_852": "火线三兄弟",
    "messageInitNick_853": "华丽的低调",
    "messageInitNick_854": "不喜勿撩",
    "messageInitNick_855": "不再心动",
    "messageInitNick_856": "贩糖仙女",
    "messageInitNick_857": "高温瘟神",
    "messageInitNick_858": "感动世界",
    "messageInitNick_859": "比纸巾还能扯",
    "messageInitNick_850": "空盒子的幻想",
    "messageInitNick_851": "按时熬夜",
    "messageInitNick_863": "江清月近人",
    "messageInitNick_864": "发型凌乱",
    "messageInitNick_865": "蟑螂很担心你",
    "messageInitNick_866": "人帅路子正",
    "messageInitNick_867": "吃瓜鉴定家",
    "messageInitNick_868": "风吹短裙飘",
    "messageInitNick_869": "哈喽小姐",
    "messageInitNick_860": "村中一帅",
    "messageInitNick_861": "眼带星辰",
    "messageInitNick_862": "隐形鸡翅膀",
    "messageInitContent_9949": "献上我的加密货币，愿疯狂升值",
    "messageInitContent_9948": "献祭我的电池，祈愿永不断电。",
    "messageInitContent_9947": "献上我的路由器，祈愿全屋满格信号。",
    "messageInitContent_9953": "冰河空渊欢迎您",
    "messageInitContent_9952": "冰冰~",
    "messageInitContent_9951": "冷~",
    "messageInitContent_9950": "新大陆我又又又来了！",
    "messageInitContent_9957": "让你的箭矢飞得像神的意志那样笔直",
    "messageInitContent_9956": "就是这边的怪把原始怪灭了",
    "messageInitContent_9955": "它们之前为啥不飞去隔壁",
    "messageInitContent_9954": "各位这边走~",
    "messageInitContent_9959": "神啊，请赐我今日的猎物",
    "messageInitContent_9958": "都是狩猎之神的恩赐",
    "messageInitContent_7301": "猫猫突然开始扭动身体",
    "messageInitContent_9964": "伤疤是猎神的印记",
    "messageInitContent_7302": "猫儿突然开始咬自己的毛",
    "messageInitContent_9963": "这里的怪似乎很缺勇气",
    "messageInitContent_9962": "神啊，请赐我今日的勇气",
    "messageInitContent_7300": "猫咪突然看向奇怪的地方",
    "messageInitContent_9961": "只相信自己",
    "messageInitContent_7305": "可以逃跑吗 可是我的脚呢",
    "messageInitContent_9968": "小心，这里到处都是猎人",
    "messageInitContent_7306": "███████████████████████",
    "messageInitContent_9967": "我将狩猎你们的灵魂",
    "messageInitContent_7303": "不可能的一切就发在眼前",
    "messageInitContent_9966": "怎么不是黯灭暖宝宝",
    "messageInitContent_7304": "有点搞不清楚状况了",
    "messageInitContent_9965": "沸体暖宝宝别跑！",
    "messageInitContent_9960": "看看这边又信什么",
    "messageInitContent_7309": "好大的触手",
    "messageInitContent_7307": "我呢？？？",
    "messageInitContent_7308": "好大的眼睛",
    "messageInitContent_9969": "当心，这里信奉的是狩猎之神",
    "messageInitContent_7312": "嗯？？？",
    "messageInitContent_9975": "等待是狩猎必须学会的第一件事",
    "messageInitContent_7313": "啊啊啊啊啊啊啊啊啊啊啊啊",
    "messageInitContent_9974": "今夜的篝火，为猎神而燃",
    "messageInitContent_7310": "███████████████████████",
    "messageInitContent_9973": "是的不怕",
    "messageInitContent_7311": "好大的雷",
    "messageInitContent_9972": "怪兽都不怕冷的妈",
    "messageInitContent_7316": "啊？",
    "messageInitContent_9979": "又来了！！！！！！够命",
    "messageInitContent_7317": "啊什么啊？",
    "messageInitContent_9978": "归途也需警觉，危险不止在猎杀的时刻",
    "messageInitContent_7314": "啊啊啊啊啊啊啊啊啊啊啊啊？",
    "messageInitContent_9977": "感谢大地与神灵的恩赐",
    "messageInitContent_7315": "啊！",
    "messageInitContent_9976": "看看我瞳！",
    "messageInitContent_9971": "小心地滑",
    "messageInitContent_9970": "狩猎开始",
    "messageInitContent_7318": "谁在低语",
    "messageInitContent_7319": "谁在低语",
    "messageInitContent_7323": "我……我这是在谁身体之中",
    "messageInitContent_9986": "在这儿，沉默比呼喊更有力量",
    "messageInitContent_7324": "嗯？",
    "messageInitContent_9985": "狩猎开始",
    "messageInitContent_7321": "谁在低语谁在低语谁在低语谁在低语谁在低语",
    "messageInitContent_9984": "猎兽人在此！",
    "messageInitContent_7322": "是谁在低语谁在低语谁在低语谁在低语谁在低语谁在低语",
    "messageInitContent_9983": "猎魔人在此！",
    "messageInitContent_7327": "███████████████████████",
    "messageInitContent_7328": "麻烦过个智力检定",
    "messageInitContent_9989": "永远别在黄昏后追逐",
    "messageInitContent_7325": "一睁眼就闻到一股恶臭",
    "messageInitContent_9988": "狩猎是一场和自然的对话",
    "messageInitContent_7326": "这里还剩多少活物？",
    "messageInitContent_9987": "我大兵器第一个不服",
    "messageInitContent_9982": "猎兽人什么鬼",
    "messageInitContent_7320": "谁在低语谁在低语谁在低语谁在低语谁在低语谁在低语",
    "messageInitContent_9981": "若你不敬畏生命，生命也不会敬畏你",
    "messageInitContent_9980": "这里的狩猎团的取名品味不行啊",
    "messageInitContent_7329": "过了",
    "messageInitContent_7334": "不可名状的分裂",
    "messageInitContent_9997": "例如暗夜精灵",
    "messageInitContent_7335": "为什么我的头发无法分裂",
    "messageInitContent_9996": "例如？",
    "messageInitContent_7332": "████████████",
    "messageInitContent_9995": "夜色属于比你更可怕的存在",
    "messageInitContent_7333": "恐怖的是下面",
    "messageInitContent_9994": "敢不敢再改一个字",
    "messageInitContent_7338": "通往金矿的必经之路",
    "messageInitContent_7339": "为什么要和金矿过不去",
    "messageInitContent_7336": "谁来保护我谁都可以救救我",
    "messageInitContent_9999": "就绕不开吃是吧",
    "messageInitContent_7337": "我准备分裂了，我先走了另一个我",
    "messageInitContent_9998": "例如烧烤",
    "messageInitContent_7330": "麻烦过个理智检定",
    "messageInitContent_9993": "是怪兽猎人（笑）",
    "messageInitContent_7331": "没过",
    "messageInitContent_9992": "猎人岛",
    "messageInitContent_9991": "掌控风的方向就掌控了第一步",
    "messageInitContent_9990": "慌乱只会让你失去一切",
    "22_dish3455": "无量肉肠森林",
    "resoundEventStoryDes_200": "此时此刻，妖火看着不久前几度被火球照亮的夜幕，看入了迷。\\n“我行我上。”\\n“你怎么行了？”\\n“我们可以一起躺在高高的山崖边上，脚悬空在山崖外，咱从里到外放出妖焰火和火海，肯定比那些小火球受欢迎，有画面了吗？”\\n这是妖火在夜幕里看到的，只存在于它心底的，与妖焰的点点回忆。",
    "resoundEventStoryDes_201": "这是妖火的另一个回忆。\\n“妖火，还有什么其他办法能让我们火起来的吗？”\\n“妖焰，莫急，最近我在超星海洋捡了一件新神器！”\\n“又是什么奇怪的东西？”\\n“神奇皇冠！”\\n“什么！你要变大火姬？”\\n“什么大火鸡，其实我有个想法……”\\n“嗯？”\\n“这样这样，红蓝、双子、女仆！”\\n“不不，照抄不说了，还过期照抄，讨论下一个方案。”",
    "propConfigName_90203": "绿色体力元核碎片",
    "propConfigName_90202": "白色体力元核碎片",
    "messageInitContent_7345": "深陷其中无法自拔",
    "messageInitContent_7346": "如梦如真浑身瘫软",
    "messageInitContent_7343": "幻象能使怪兽中毒？",
    "messageInitContent_7344": "无休止地复读",
    "messageInitContent_7349": "那是一道看不见摸不着的屏障",
    "messageInitContent_7347": "然后……",
    "messageInitContent_7348": "魅影红唇",
    "propConfigName_90207": "红色体力元核碎片",
    "resoundEventStoryDes_208": "前方草丛蹲伏着5只，诱饵是前面的6只，池塘边的岩石后还藏了4只，还有1只潜在水里的斥候，就不能走心点嘛？\\n镇魂无奈地打了个哈欠，它不知道为什么最近会有这么多怪兽联合起来对它发动袭击，难不成在它这里送死有BGM显得壮烈些？",
    "propConfigName_90206": "橙色体力元核碎片",
    "resoundEventStoryDes_209": "将偷袭的怪兽打飞的日子渐渐成了镇魂的日常。\\n在怪兽上天此起彼伏的尖叫声之中，镇魂产生了一个绝妙的想法。\\n根据怪兽们尖叫的音调，再配合调整击飞的力度，按节奏将它们打飞，这些怪兽小音符就能自己“叫”出一首曲子了“啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊！”",
    "propConfigName_90205": "紫色体力元核碎片",
    "resoundEventStoryDes_206": "锤子们有着同一个信仰——锤子之神，但围绕着神到底拿着哪种锤子的争论却一直存在。羊角锤、圆头锤、钳工锤、八角锤和扁尾锤都有各自的拥护者。随着争论的激化，原来的统一部落分裂为对应五个形状的五大部落。五大部落间，围绕锤子形状的冲突也开始了。现在它们唯一的共识只有一个——你懂个锤子。",
    "propConfigName_90204": "蓝色体力元核碎片",
    "resoundEventStoryDes_207": "八角锤部落的锤子为了让其他锤子相信锤子之神就是拿着八角锤的，先后与羊角锤与圆头锤部落发生了冲突。\\n其中实力较弱的锤子部落，也就是圆头锤部落，迫切希望找到一处易守难攻又适宜居住的险要之处。终于，它们找到盯头锤山。\\n现在的圆头锤部落，四面都由险峰环绕，唯一的入口相当细长狭窄,并且入口内长满了茂密的盯头锤树。盯头锤树的果子就是盯头锤，成熟的盯头锤有叉叉头的5倍之大，果皮异常坚硬，长满的四棱锥形密刺。\\n守备的锤子只需要蹲伏在树上，等待入侵怪兽进来，用盯头锤欢迎它们。\\n目前，圆头锤部落的长老们着手启动将它们的神手上的圆头锤改成盯头锤的计划。",
    "messageInitContent_7341": "金矿的味道",
    "resoundEventStoryDes_204": "胸肌最小的G-N却不忍心处理小咻咻。于是它和小咻咻坐上大王椰子壳，开始了海上漂流。\\n不久之后，它们来到了另外一个岛屿。\\nG-N惊喜地发现，这座岛屿上面的G-N都没有胸肌，并且自称A-N，G-N内心激动不已，它成为了这里胸肌最大的。\\n就在她正准备向这里的A-N宣称自己将会成为新的女王的时候，她被告知，在这里不欢迎有胸肌的A-N，并让G-N赶紧处理掉那个和它们长得完全不一样的小咻咻。",
    "messageInitContent_7342": "你确定是金矿的味道？",
    "resoundEventStoryDes_205": "G-N哭泣着将小咻咻带回到大王椰子壳，它们就这样坐着大王椰子壳上，在海上漂着漂着。\\n有一天,G-N听到了一些模糊的呼喊声从意识边缘响起的，渐渐地，声音逐渐清晰了起来，似乎在呼唤它一般。G-N想那一定是一个无有分别高低的世界，但要是全世界都长一样的世界，倒也够无趣的，就这么想着想着G-N睡着了。",
    "resoundEventStoryDes_202": "某天，一群星刃围在了一起，听最中间的星刃讲它的故事。\\n今天的故事，是这样的。\\n在不是很久很久以前，在另外某个世界，有一种跟我们长得很像的生物，它们叫做史莱姆。大多数史莱姆都很弱，就像我们一样，可也有一些例外的个体。\\n（什么什么？快说给我们听听！）\\n那是一只蓝色的史莱姆，非常厉害。\\n（有多厉害呀？）\\n常常都有一群漂亮的小姐姐围住它。\\n（哇——真的好厉害啊！）\\n而我呢，为什么围着我的却是你们！你们赶紧去进化成漂亮的小姐姐啊！",
    "messageInitContent_7340": "它会循着金币找到你",
    "resoundEventStoryDes_203": "十年前的一天，半只椰壳打破了那座孤岛的宁静，椰壳带着上面的小咻咻，来到那座孤岛。\\n这座孤岛上生活着很多的G-N，直到在它们看到小咻咻，它们才相信这个世界上，原来存在没有胸肌的生物。大多数G-N认定小咻咻会是带来灾难的恶魔，于是它们指派了岛上地位最卑微，胸肌最小的G-N将小咻咻处理掉。",
    "resoundEventStoryDes_211": "在半空，一只接着一只的怪兽，划出了优雅的弧线，“啊啊啊”的尖叫声此起彼伏，它们就是镇魂的新乐器。\\n“噢，还有一只突然喊破了嗓的家伙，意外的惊喜！唔这个音低了些，或许这个地方还能再加一只……”\\n全新的创作方式，激发出镇魂无限的灵感，创作火力全开！",
    "resoundEventStoryDes_212": "在跑腿之路上，疾风兔也狂飙了四年多了，它突然意识到自己的还没有一个正式的名号。于是向整个大陆展开一次征集。\\n没有过去多久，很多热心的小伙伴就为疾风兔送上了很多备选方案，混杂了很多奇怪东西，例如：大疾大利、G-Feng兔、逐月、G2、顺风兔、辣么大疾排物流、疯兔物流、超进化物流、生命鸽浅、兔崽子快递、寄你太兔、疾你快跑、疾风速递兔、疾速追兔、疾兔同笼、油炸兔、夺命兔递、疾风达、飓风兔、流氓TWO、疯兔传奇、too兔物流、疾快乐、负活者疾风、特污兔物流公司、兔儿索。\\n选择困难的风暴来临了！",
    "resoundEventStoryDes_210": "这天，镇魂从一只躲在树上准备要袭击它的怪兽口中，听到了自己被袭击理由。\\n原话大概是这样的“解决掉镇魂，就能激发出一种神奇的变大之力，就可以治好多年的老毛病，重！振！当！年！之！雄！风！”",
    "messageInitContent_7356": "阴影逐渐与我相融合",
    "messageInitContent_7357": "我将透过阴影见证暗面",
    "messageInitContent_7354": "阴影慢慢浮起",
    "messageInitContent_7355": "阴影逐渐厚重",
    "messageInitContent_7358": "冰冷的火焰将我包围",
    "messageInitContent_7359": "火焰逐渐将我冷却",
    "resoundEventStoryDes_219": "“祖拉你知道吗？撼地兽一旦遇上它们认为它命中注定的对象，就会将它右肩上那朵唯一的花儿摘下，送给对方。”\\n“哇噢~”\\n“那花的花语是‘你是我的唯一’，因为它被摘下来以后，就再也不会长出第二朵花来。”\\n“哇噢~可是？”\\n“嗯？”\\n“可是可是我碰见的撼地兽，它们肩膀上都是有花的！”\\n“喏……不然你以为它们的黄金右手是来的？”\\n《第一千零二夜》",
    "resoundEventStoryDes_217": "只要到过微光之森的怪兽都会听过这么一句话：“无论你身在何处，只要一直向着晨光之柱的方向走，就能抵达微光之森。”\\n这就是晨光之柱作为微光之森标志物的影响力。晨光之柱被认为是岩石风化和仔细雕琢的结果。在每日的清晨时分，晨光之柱都会发生柱食现象，一抹黑色从下至上将柱身覆盖，一段时间后，又一点点褪去，直至消失无踪。",
    "resoundEventStoryDes_218": "惊！原来是这样的！\\n近日，我从住在微光之森的桐仁那了解到关于柱食的真相，每日清晨为了提升肺活量，呜呜祖拉和咻咻都会到晨光之柱爬塔，化成一股充满朝气和拼劲的黑色浪潮。就是说，将晨光之柱覆盖的竟然是它们！",
    "messageInitContent_7352": "该如何是好",
    "resoundEventStoryDes_215": "这里是每天绕超进化大陆一圈的疾风兔，擅长通风、报信、送货、跑腿。\\n很多怪兽以为我只是个跑腿送快递的，那完全是个大大大大的误解！\\n本兔可不会落地成盒，不过你们可要小心超进化大陆的盒子。\\n咦不小心跑远了，咱们回来，总之，请随时呼唤我！《疾风兔见闻传》",
    "messageInitContent_7353": "地下的阴影不断扩散着",
    "resoundEventStoryDes_216": "敬告：有一种叫做锅菌的小怪兽，它们在世界各地的故事碎片中滋生，以故事碎片的文字为食。它们弱小，但能吃。\\n这些锅菌将文字吃掉后，就会分泌出一种带有思想神奇的物质，受到这些物质影响，故事碎片的内容发生了变化，可能会多字，少字，错字，或者多出一些又冷又过期的吐槽。总之都是它的锅！\\n（听说找到它就会有好事发生噢。",
    "messageInitContent_7350": "只有它能穿过来",
    "resoundEventStoryDes_213": "“嘤嘤嘤、放开我、你再这样我就大叫了、雅蠛蝶、布鲁艾斯怀特多拉贡、微光之森第一帅帅、流星螺旋巽、火神女友、甩葱哥、进化大帝、神灵白虎，超级大帅逼人太甚，来收件啦——！”\\n唉，又是羞耻无比的喊怪兽收件时间。就不能取点正常点的名字吗！疾风兔鼓起勇气将收件怪兽的名字念完后，叹了口气。",
    "messageInitContent_7351": "我们却无法穿过去",
    "resoundEventStoryDes_214": "有的怪兽珍惜平静与安宁，一处就是一生。\\n有的怪兽渴求生死一线的未知与惊险，以冒险为天命。\\n如果你属于后者，在旅途之中或者即将踏上旅途，那你就不应该错过这本见闻录。\\n你将从这个见闻录之中，知晓大陆的坦途、捷径和险路（本句引用自《******》），你也可以独自收藏，降低你同伴的存活率，当然我不建议你这么做！\\n毕竟，真正的独狼并不多。\\n《疾风兔见闻传》",
    "resoundEventStoryDes_222": "一开始，本委员会为了提高影响力，向怪兽提供了各种无条件的帮助，同时送出一本《超进化委员会范规》。\\n不久后，鸡毛蒜皮类的求助数量以肉眼可见的速度增长，本委员会成功打响了知名度。可是拿到《超进化委员会范规》的怪兽，别说遵守这个《范规》，更多的是看都不看。\\n这导致了委员会的工作中心的转移，变成了为怪兽服务。为了减轻工作量，我们近期将会开始制作避险信息和避险地图。",
    "resoundEventStoryDes_223": "超进化委员会发现，要制作避险地图就必须先有地图。要制作地图就……是个大工程了。但委员会似乎就是这么一个就算跑偏了，也会认真跑的组织。\\n于是，一顿统筹规划，超进化大陆的地图绘制工程正式开始。\\n经过了漫长的时间，委员会跑遍各地，通过收集小区域地图，以及实地考察，修正整合，第一版大陆猪皮卷地图正式出炉。\\n翻到地图的背面还可以看到秘密麻麻的《超进化委员会范规》，就还是不会有怪兽会去看就是了。",
    "resoundEventStoryDes_220": "“撼地兽会给它对象献花，那跃迁兽会送它的小草吗？”\\n“不，那草拔了就长不出花了。但他可以送葱。”\\n“那异兽呢。”\\n“它还小。”\\n“那崩界领主的花去哪了呢。”\\n“它变强了，也秃了。”\\n《第一千零三夜》",
    "resoundEventStoryDes_221": "本委员会致力于为超进化大陆带来秩序，创建一个文明和谐的超进化大陆。本范规共有二百八十二条……（划掉）本范规共有三百八十二条……（划掉）本范规共有一千三百八十二条……（划掉）本范规共有两万一千三百八十二条……（划掉）",
    "messageInitContent_7367": "那是决不能揭晓的骇人真相",
    "messageInitContent_7368": "透过腐败的瞳孔",
    "messageInitContent_7365": "每一只怪兽都是一座孤岛",
    "messageInitContent_7366": "激烈的地壳运动被动地将一切推向疯狂",
    "messageInitContent_7369": "只能看到腐败的东西吗",
    "messageInitContent_7360": "意识逐渐模糊",
    "resoundEventStoryDes_228": "我从一些怪兽口耳相传的片言只语中，以及从亘古流传下来的支离破碎的石壁刻画里，一点点窥探那个洞穴的可怕秘密，一个覆满石肌，潜伏于大地的巨大活物的形象逐渐浮现出来，据说它会用浑浊的纺锤状的石眼凝视大地。它是非常可怕的邪恶存在，可怕到连它的眼屎都想要尽快逃离。\\n《疾风兔见闻传》",
    "resoundEventStoryDes_229": "我几乎走遍了整个超进化大陆，除了那片被重雾笼罩的区域。我试着穿过它，试着一窥重雾后面的世界，但和其它怪兽一样，无论如何也走不到重雾的尽头。可当我转身返回时，我已经回到了出发的地方。\\n《疾风兔见闻传》",
    "messageInitContent_7363": "我无法将我所知的信息关联在一起",
    "resoundEventStoryDes_226": "……告别了这群怪兽之后，我长途跋涉，来到了凌云之脉的山脚。\\n凌云之脉确实是一座高耸入云的山峰，攀登经验丰富如我也没办法第一时间看出要从哪里开始往上爬，摸索了半天，终于找到一条崎岖的小路。刚好遇见一位骑着龟修行的MountainJo。上前一问，我才知道问题出在哪，上山的道路仅此一条，它在这修行多年，从来没见过什么叫“云玩家”的登山者。\\n《疾风兔见闻传》",
    "messageInitContent_7364": "世界仿佛一个又一个的孤岛",
    "resoundEventStoryDes_227": "我多次在破界沼地的月沼附近探寻，却再也没能再见到那个洞穴。我发誓那绝对不是我的幻想，也绝不是记忆被年岁模糊的缘故。它的模样在我第一次见到它的那一刻，便死死刻入了我的脑海。我确信，只需一眼，我就能将之认出。因为那个洞穴的样子实在过于诡异，破败与不详仿佛与倾斜歪扭的诡石融为一体，纺锤状的洞口向外张开，岩壁如同撕咬过后的淋漓血腹。我当时失了神似的走向洞穴，再度恢复意识后，我被排向了黑夜。\\n《疾风兔见闻传》",
    "messageInitContent_7361": "我要看到另外一个世界了",
    "resoundEventStoryDes_224": "超进化大陆的地图制成之后，超进化委员会开始着手进行避险地图的制作。这一步的完成时间出奇地短。\\n制作过程如下：\\n1、四处寻访怪兽。\\n2、让怪兽将它们遭遇过危险的地方标记出来。\\n3、在大地图上将这些怪兽标记的区域去除。\\n因为这些怪兽能活着回来，至少说明它们遭遇的危险并没有那么可怕。",
    "messageInitContent_7362": "如果时间可以扭转，我情愿……",
    "resoundEventStoryDes_225": "路上遇到了一群怪兽，它们让我一定要去凌云之脉看看。\\n它们是这么推荐的“……我们从凌云之脉的南峰山脚向高处进发，气温从暖变凉转冷,到恶寒，仿佛在阻止我们继续往上攀登。但这又怎么能挡下我们前进的坚实步伐，我们对云的执念与热爱，又怎么会惧怕大自然的考验。最终，凭借着这股坚定不移的信念，我们来到了凌云之脉的最高点，那是能触碰到云的地方，云的圣地。我们欢快地与云朵玩耍嬉戏，正如我们之名——云玩家。”\\n《疾风兔见闻传》",
    "randomEventDialogueGroupConfig_11.108": "离开",
    "randomEventDialogueGroupConfig_11.109": "好~了~吗？",
    "randomEventDialogueGroupConfig_11.106": "离开",
    "randomEventDialogueGroupConfig_11.107": "哼哼，菜，这都接不住，我帮你捡起来，然后塞到自己的口袋里。拜拜。",
    "randomEventDialogueGroupConfig_11.104": "离开",
    "randomEventDialogueGroupConfig_11.105": "吼吼，我赢啦。跑咯再见。",
    "randomEventDialogueGroupConfig_11.102": "哇，你太强了，我甘拜下风。",
    "randomEventDialogueGroupConfig_11.103": "嘻嘻，我赢啦啦。跑咯拜拜。",
    "randomEventDialogueGroupConfig_11.100": "放弃",
    "randomEventDialogueGroupConfig_11.101": "还没",
    "messageInitNick_7299": "不上班不行",
    "messageInitNick_7290": "知识宝库",
    "messageInitNick_7296": "东方苍狼",
    "messageInitNick_7295": "单肫飘",
    "messageInitNick_7298": "安静甜点",
    "messageInitNick_7297": "散步的菠萝",
    "messageInitNick_7292": "尖叫豌豆",
    "messageInitNick_7291": "退役潜水选手",
    "messageInitNick_7294": "听风的鲸",
    "messageInitNick_7293": "友尽拳",
    "messageInitContent_9902": "小心你的舌头",
    "messageInitNick_7289": "霸刀藐视天下",
    "messageInitContent_9901": "与其在头骨前跪拜，不如用骨头造一把新武器",
    "messageInitNick_7288": "落败的唯美",
    "messageInitContent_9900": "祭坛上流的血，只会滋养大地",
    "messageInitContent_9906": "感恩祖先",
    "messageInitNick_7285": "永远充满活力",
    "messageInitContent_9905": "铭记先祖恩赐",
    "messageInitNick_7284": "家在魔仙堡",
    "messageInitContent_9904": "不敬祖灵者，生者不容，死者不收",
    "messageInitNick_7287": "宇宙被解锁",
    "randomEventDialogueGroupConfig_11.148": "它又转了一圈。",
    "messageInitContent_9903": "小心你的脑袋",
    "messageInitNick_7286": "白雪公主",
    "randomEventDialogueGroupConfig_11.149": "走了",
    "messageInitNick_7281": "孤单少年",
    "randomEventDialogueGroupConfig_11.146": "看来你注意到我转了5圈了！还有一个更高阶的版本，不过我还在修炼。#注意看好了，看看你能不能看出来这次转转的关键。",
    "messageInitContent_9909": "领地的骨是不是来自？",
    "messageInitNick_7280": "搞笑王",
    "randomEventDialogueGroupConfig_11.147": "不许问，你走吧！",
    "messageInitContent_9908": "献上其他怪兽的欧气",
    "messageInitNick_7283": "作文乱码",
    "randomEventDialogueGroupConfig_11.144": "快乐闪人",
    "messageInitContent_9907": "与先祖共鸣",
    "messageInitNick_7282": "绝对无坑",
    "randomEventDialogueGroupConfig_11.145": "这个我也会！",
    "randomEventDialogueGroupConfig_11.142": "快乐白拿",
    "randomEventDialogueGroupConfig_11.143": "快乐逛逛",
    "randomEventDialogueGroupConfig_11.140": "看来你读你懂了快乐的密码！那你的快乐密码又是什么呢？",
    "randomEventDialogueGroupConfig_11.141": "快乐战斗",
    "messageInitContent_9913": "点赞功德+1",
    "messageInitNick_7278": "逗猫棒",
    "messageInitContent_9912": "功德+1功德+1功德+1",
    "messageInitNick_7277": "薄荷蛋糕",
    "messageInitContent_9911": "多多点赞",
    "channelName_28909": "TapTap 平台",
    "messageInitContent_9910": "祖灵喜欢电子仪式吗",
    "messageInitNick_7279": "超级火锅",
    "22_dish13345": "好运喷射烩菜",
    "messageInitContent_9917": "HUH？",
    "messageInitNick_7274": "柠檬之心",
    "randomEventDialogueGroupConfig_11.139": "哼哼好吧，下次我一定转出能让你明白个中的乐趣的转法！",
    "messageInitContent_9916": "嗯？",
    "messageInitNick_7273": "卷姐之姐",
    "messageInitContent_9915": "献上我的神秘学习资料",
    "messageInitNick_7276": "勿念旧人",
    "randomEventDialogueGroupConfig_11.137": "23333？",
    "messageInitContent_9914": "功德+1",
    "messageInitNick_7275": "跟着风行走",
    "randomEventDialogueGroupConfig_11.138": "555？",
    "messageInitNick_7270": "萌得无药可救",
    "randomEventDialogueGroupConfig_11.135": "继续看",
    "randomEventDialogueGroupConfig_11.136": "它又一次非常认真地转了三个圈，之后停住。",
    "messageInitContent_9919": "先祖顶不住了！",
    "messageInitNick_7272": "志当存高远",
    "randomEventDialogueGroupConfig_11.133": "你的快乐密码是？",
    "messageInitContent_9918": "让我康康又多神秘",
    "messageInitNick_7271": "风云潮男",
    "randomEventDialogueGroupConfig_11.134": "它又认真地绕着你转三个圈，然后停住。",
    "messageInitContent_9920": "与祖先共鸣",
    "randomEventDialogueGroupConfig_11.131": "进店",
    "randomEventDialogueGroupConfig_11.132": "追问什么转转",
    "randomEventDialogueGroupConfig_11.130": "哈？大鸟？你在说什么？我才……我才不知道呢，什么大鸟什么转转什么呢！#刚好我店里有一只会后空翻的怪兽，要去看看吗？",
    "messageInitContent_9924": "电子贡品已上传，祈求云端祖灵降福",
    "messageInitNick_7267": "海浪精灵",
    "messageInitContent_9923": "赛博香烛已点燃，请查收",
    "messageInitNick_7266": "改变历史的龙",
    "messageInitContent_9922": "献上我的移动电源，为祖灵充电",
    "messageInitNick_7269": "富婆饿饿饭饭",
    "messageInitContent_9921": "献上我的电子水果",
    "messageInitNick_7268": "第三人称",
    "messageInitContent_9928": "献祭我的充电器",
    "messageInitNick_7263": "悲报你要输了",
    "randomEventDialogueGroupConfig_11.128": "呜呜，怎么就不让我多绕一会嘛，哼我去找下一个目标！",
    "messageInitContent_9927": "是的电子祭祖",
    "messageInitNick_7262": "树莓兽",
    "randomEventDialogueGroupConfig_11.129": "离开",
    "messageInitContent_9926": "怎么开始赛博献祭了",
    "messageInitNick_7265": "无公害黄瓜",
    "randomEventDialogueGroupConfig_11.126": "可恶，被甩掉了，追不上了！",
    "messageInitContent_9925": "献祭我的固态硬盘",
    "messageInitNick_7264": "奋力考试全过",
    "randomEventDialogueGroupConfig_11.127": "离开",
    "randomEventDialogueGroupConfig_11.124": "趁机离开",
    "randomEventDialogueGroupConfig_11.125": "问它是不是叫大鸟",
    "messageInitNick_7261": "告别过去",
    "randomEventDialogueGroupConfig_11.122": "狂奔离开",
    "messageInitContent_9929": "献上我的显卡，换取祖灵显现",
    "messageInitNick_7260": "你最好别想我",
    "randomEventDialogueGroupConfig_11.123": "它不小心追过头了，但又快步绕到你这边。",
    "messageInitContent_9931": "功德+1功德+1功德+1",
    "randomEventDialogueGroupConfig_11.120": "停下来",
    "messageInitContent_9930": "献上我的电子木鱼",
    "messageInitNick_7259": "贝壳里的公主",
    "randomEventDialogueGroupConfig_11.121": "它还是追上来了，又绕着你转了一圈。",
    "messageInitContent_9935": "图腾守卫将会把你驱逐",
    "messageInitNick_7256": "控魂者",
    "messageInitContent_9934": "献上我的电子灵魂",
    "messageInitNick_7255": "遥遥领先",
    "messageInitContent_9933": "献上我的电子贡品",
    "messageInitNick_7258": "美丽的迷宫主",
    "messageInitContent_9932": "在干嘛这是",
    "messageInitNick_7257": "傲娇的野狗",
    "randomEventDialogueGroupConfig_11.119": "快步离开",
    "messageInitContent_9939": "图腾守卫绝不退缩",
    "messageInitNick_7252": "今日礼拜八",
    "randomEventDialogueGroupConfig_11.117": "这就是我的快乐的密码，转圈圈太开心了，你看！",
    "messageInitContent_9938": "图腾守卫不眠不休",
    "messageInitNick_7251": "拿什么抵抗你",
    "randomEventDialogueGroupConfig_11.118": "它追上来又绕着你转了一圈。",
    "messageInitContent_9937": "图腾守卫将会驱逐不敬者",
    "messageInitNick_7254": "眉眼藏山河",
    "randomEventDialogueGroupConfig_11.115": "喂，怎么变成躲猫猫了？喂——喂——",
    "messageInitContent_9936": "图腾守卫将会坚守",
    "messageInitNick_7253": "咩啊咩啊",
    "randomEventDialogueGroupConfig_11.116": "离开",
    "randomEventDialogueGroupConfig_11.113": "离开",
    "randomEventDialogueGroupConfig_11.114": "帮忙找",
    "messageInitNick_7250": "回眸一只狗",
    "randomEventDialogueGroupConfig_11.111": "好了！",
    "randomEventDialogueGroupConfig_11.112": "那就比二仁转吧！很简单的，首先要找两只桐仁，桐仁——桐仁——怎么找不到呢。",
    "messageInitContent_9942": "点燃电子香火",
    "messageInitNick_7249": "咕咕何其多",
    "messageInitContent_9941": "献上我的CPU",
    "messageInitNick_7248": "爱情纯属虚构",
    "randomEventDialogueGroupConfig_11.110": "放弃",
    "messageInitContent_9940": "献祭我的显卡",
    "messageInitContent_9946": "献上我的数字金币，祖灵赐我欧气",
    "messageInitNick_7245": "昂首做女王",
    "messageInitContent_9945": "你们的电子贡品呢",
    "messageInitNick_7244": "橙汁船长",
    "messageInitContent_9944": "供奉已完成，等候祖灵上链认证",
    "messageInitNick_7247": "匿名诗人",
    "messageInitContent_9943": "献上我的无线耳机，聆听祖灵之音",
    "messageInitNick_7246": "此情已成追忆",
    "messageInitNick_7241": "菠菜魔法师",
    "messageInitNick_995": "熬夜改稿",
    "messageInitNick_7240": "无敌恰瓜神",
    "messageInitNick_996": "飞天凤凰",
    "messageInitNick_7243": "香菜撞地球",
    "messageInitNick_997": "落泪成功",
    "messageInitNick_7242": "腐乳炒通菜",
    "messageInitNick_998": "橙子不甜",
    "messageInitNick_999": "独孤求婚",
    "randomEventDialogueGroupConfig_11.188": "好哇！居然能看穿我的走位！值得一战！",
    "randomEventDialogueGroupConfig_11.189": "战斗",
    "messageInitNick_7238": "深海摸鱼神",
    "randomEventDialogueGroupConfig_11.186": "知难而退",
    "messageInitNick_7237": "鲸鱼宝宝",
    "randomEventDialogueGroupConfig_11.187": "它刚好守住了这里，接着又绕着你转了几圈，防御变得愈发严密了。",
    "messageInitNick_9899": "独眼侦探",
    "randomEventDialogueGroupConfig_11.184": "它刚好守住了上路，接着又绕着你转了几圈，防御变得更加严密了。",
    "messageInitNick_7239": "老泰隆走中",
    "messageInitNick_990": "怎样才够给力",
    "randomEventDialogueGroupConfig_11.185": "迎难而上",
    "messageInitNick_7234": "哥本哈哈",
    "messageInitNick_9897": "从前雨很大",
    "messageInitNick_991": "我为改图狂",
    "randomEventDialogueGroupConfig_11.182": "拿一点点",
    "messageInitNick_7233": "炉灰菇凉",
    "messageInitNick_9898": "时尚眼界",
    "messageInitNick_992": "别急",
    "randomEventDialogueGroupConfig_11.183": "拿亿点点",
    "messageInitNick_7236": "马上是多久",
    "messageInitNick_9895": "来自地球的我",
    "messageInitNick_993": "第一千零一稿",
    "randomEventDialogueGroupConfig_11.180": "改变思路",
    "messageInitNick_7235": "文件乱码",
    "messageInitNick_9896": "柠檬去哪了",
    "messageInitNick_994": "第二张脸",
    "randomEventDialogueGroupConfig_11.181": "可恶没防到，不玩了！给你随便拿一点点东西好了。",
    "randomEventDialogueGroupConfig_57.4": "-",
    "randomEventDialogueGroupConfig_57.3": "看穿并走近",
    "randomEventDialogueGroupConfig_57.6": "-",
    "randomEventDialogueGroupConfig_57.5": "-",
    "randomEventDialogueGroupConfig_57.2": "撕下来过去看看",
    "randomEventDialogueGroupConfig_57.1": "你在东集市看到一张奇特的悬赏令，发布者是东集市的二把手，上面写着“我要你，艾旺油！”下面画了个图。",
    "messageInitNick_7230": "宝贝莫哭",
    "messageInitNick_9893": "霸道大叔",
    "messageInitNick_9894": "抽签大师",
    "messageInitNick_7232": "暗影大师的影",
    "messageInitNick_9891": "遍野盛开温柔",
    "messageInitNick_7231": "无敌懂神",
    "messageInitNick_9892": "复刻大夫",
    "randomEventDialogueGroupConfig_11.179": "延续思路",
    "randomEventDialogueGroupConfig_57.8": "-",
    "messageInitNick_9890": "乱世宠儿",
    "randomEventDialogueGroupConfig_57.7": "-",
    "randomEventDialogueGroupConfig_11.177": "有意思，让我看看你要怎么攻过来！",
    "randomEventDialogueGroupConfig_11.178": "这次你能打到我吗哈哈哈？",
    "randomEventDialogueGroupConfig_57.9": "-",
    "messageInitNick_7227": "诺贝尔对线奖",
    "randomEventDialogueGroupConfig_11.175": "大师，我好像懂什么了。先消化下，您自便。",
    "messageInitNick_7226": "下年摸鱼",
    "randomEventDialogueGroupConfig_11.176": "你的普通攻击是几次攻击来着？",
    "messageInitNick_7229": "傲娇小野猫",
    "messageInitNick_9888": "丽贝卡酱",
    "randomEventDialogueGroupConfig_11.173": "演示",
    "messageInitNick_7228": "仙人掌模拟器",
    "messageInitNick_9889": "打伞的兔纸",
    "randomEventDialogueGroupConfig_11.174": "不演了",
    "messageInitNick_7223": "电子冰糖",
    "messageInitNick_9886": "逆流的泪",
    "randomEventDialogueGroupConfig_11.171": "天……天才般的想法。我先消化下，您自便。",
    "messageInitNick_7222": "退退退",
    "messageInitNick_9887": "本宫做不到",
    "randomEventDialogueGroupConfig_11.172": "大师，我有点迷惑。您要不要演示一下。",
    "messageInitNick_7225": "空气宝宝",
    "messageInitNick_9884": "世界第一辣条",
    "messageInitNick_7224": "我不够拽",
    "messageInitNick_9885": "旺财",
    "randomEventDialogueGroupConfig_11.170": "攻其下路",
    "messageInitNick_9882": "杨桃兽",
    "messageInitNick_9883": "奉旨跑掉",
    "messageInitNick_7221": "超级卷姐",
    "messageInitNick_9880": "北城九命猫",
    "messageInitNick_7220": "泥巴佬",
    "messageInitNick_9881": "山河无恙",
    "randomEventDialogueGroupConfig_11.168": "它刚好守住了下路，接着又绕着你转了几圈，防御变得更加严密了。",
    "randomEventDialogueGroupConfig_11.169": "攻其上路",
    "randomEventDialogueGroupConfig_11.166": "呜呜呜，居然没看出来，太让人伤心了。拜拜。",
    "randomEventDialogueGroupConfig_11.167": "离开",
    "messageInitNick_7216": "喂自己袋盐",
    "messageInitNick_9879": "搬砖小能手",
    "randomEventDialogueGroupConfig_11.164": "用这些姿势转圈可是要苦练好久的呢，我要立刻开始练习才行，这个送你再见！",
    "messageInitNick_7215": "顶尖疯子",
    "randomEventDialogueGroupConfig_11.165": "收下",
    "messageInitNick_7218": "恋爱通知书",
    "messageInitNick_9877": "小迷妹",
    "randomEventDialogueGroupConfig_11.162": "比试一场",
    "messageInitNick_7217": "划水之王",
    "messageInitNick_9878": "雾里看小花",
    "randomEventDialogueGroupConfig_11.163": "说只是开玩笑然后离开",
    "messageInitNick_7212": "在赚钱的路上",
    "messageInitNick_9875": "粉饼贩卖机",
    "randomEventDialogueGroupConfig_11.160": "走了",
    "messageInitNick_7211": "哥累了",
    "messageInitNick_9876": "对猪乱弹琴",
    "randomEventDialogueGroupConfig_11.161": "你要作甚？",
    "messageInitNick_7214": "巧克力泡辣汤",
    "messageInitNick_9873": "老坛酸菜饭",
    "messageInitNick_7213": "放学等我",
    "messageInitNick_9874": "记忆的永恒",
    "messageInitNick_7219": "江湖见兄弟",
    "messageInitNick_9871": "开始变成",
    "messageInitNick_9872": "一身吉利服",
    "messageInitNick_7210": "寻找解决方案",
    "randomEventDialogueGroupConfig_11.159": "不走",
    "messageInitNick_9870": "与往事干杯",
    "randomEventDialogueGroupConfig_11.157": "不走",
    "randomEventDialogueGroupConfig_11.158": "它转了一圈盯着你看。",
    "randomEventDialogueGroupConfig_11.155": "它又转了一圈。",
    "randomEventDialogueGroupConfig_11.156": "走了",
    "messageInitNick_7205": "嗲嗲的女生",
    "messageInitNick_9868": "进餐小能手",
    "randomEventDialogueGroupConfig_11.153": "离开",
    "messageInitNick_7204": "夕阳当外套",
    "messageInitNick_9869": "控制欲",
    "randomEventDialogueGroupConfig_11.154": "拉住它",
    "messageInitNick_7207": "尖叫芭蕉",
    "messageInitNick_9866": "这也能不小心",
    "randomEventDialogueGroupConfig_11.151": "嘻嘻，看我的绕圈走位，你抓不到我的哈哈。",
    "messageInitNick_7206": "快乐司机",
    "messageInitNick_9867": "无敌补刀神",
    "randomEventDialogueGroupConfig_11.152": "已经转爽咯，你不走，我走啦~",
    "messageInitNick_7201": "生气的变速箱",
    "messageInitNick_9864": "属实是典中典",
    "messageInitNick_7200": "跟风流浪",
    "messageInitNick_9865": "橙子不甜",
    "randomEventDialogueGroupConfig_11.150": "不走",
    "messageInitNick_7203": "顶级抠脚大汉",
    "messageInitNick_9862": "沉默寡言的明",
    "messageInitNick_7202": "不爱就坚强",
    "messageInitNick_9863": "一个小花痴",
    "messageInitNick_7209": "国服第一可爱",
    "messageInitNick_7208": "劈开高跟鞋",
    "tribeCampConfigName_2": "统御",
    "tribeCampConfigName_1": "急行",
    "messageInitNick_9860": "数据大师",
    "messageInitNick_9861": "瓜子战士",
    "messageInitNick_9857": "指定网恋对象",
    "messageInitNick_9858": "差不多先生",
    "messageInitNick_9855": "本小姐不太冷",
    "messageInitNick_9856": "用回第一版",
    "messageInitNick_9853": "车到了总站",
    "messageInitNick_9854": "茄子撞地球",
    "messageInitNick_9851": "卷卷大王",
    "messageInitNick_9852": "重新定义打拳",
    "tribeCampConfigName_4": "涅槃",
    "tribeCampConfigName_3": "坚毅",
    "messageInitNick_9859": "神仙打假",
    "tribeCampConfigName_5": "据点",
    "96_MysReward": "谜宝",
    "messageInitNick_9850": "火龙果龙",
    "messageInitNick_9846": "毅力坚强帝",
    "messageInitNick_9847": "春江花月夜",
    "messageInitNick_9844": "天亮说晚安",
    "messageInitNick_9845": "鸟儿叽叽叽",
    "messageInitNick_9842": "浪漫野人",
    "messageInitNick_9843": "拉面大师",
    "messageInitNick_9840": "维持现状",
    "messageInitNick_9841": "明年约会",
    "messageInitNick_9848": "果断地摸鱼",
    "messageInitNick_9849": "赴远皇后",
    "messageInitNick_9835": "百变小妖怪",
    "messageInitNick_9836": "爱上猪",
    "messageInitNick_9833": "此妞爷宠",
    "messageInitNick_9834": "柿子去哪了",
    "messageInitNick_9831": "喘气的夜明猪",
    "messageInitNick_9832": "还是起猛了",
    "messageInitNick_9830": "把把评分第五",
    "messageInitNick_9839": "狂飙的蜜蜂",
    "messageInitNick_9837": "抽刀断情仇",
    "messageInitNick_9838": "高光时刻哒",
    "randomEventDialogueGroupConfig_11.199": "再试一遍",
    "messageInitNick_9824": "带火龙果探险",
    "randomEventDialogueGroupConfig_11.197": "离开",
    "messageInitNick_9825": "您品您细品",
    "randomEventDialogueGroupConfig_11.198": "因为太快了，你没有看穿它的走位并且打空了。",
    "messageInitNick_9822": "迷人小祖宗",
    "randomEventDialogueGroupConfig_11.195": "看看",
    "messageInitNick_9823": "欢快的猕猴桃",
    "randomEventDialogueGroupConfig_11.196": "防御终极奥义——跑路哒哟~今天我转的很开心，下次再见。",
    "messageInitNick_9820": "喵喵队立大功",
    "randomEventDialogueGroupConfig_11.193": "补刀是个好习惯，但我先跑了。",
    "messageInitNick_9821": "脑电波电台",
    "randomEventDialogueGroupConfig_11.194": "还要攻击过来吗，好哇。让你看看我防御的终极奥义！",
    "randomEventDialogueGroupConfig_11.191": "攻击左半区",
    "randomEventDialogueGroupConfig_11.192": "攻击右半区",
    "randomEventDialogueGroupConfig_11.190": "它开始绕着你转圈，越来越快，快到它的身影仅剩下一圈残影。",
    "messageInitNick_9828": "昨日不复来",
    "messageInitNick_9829": "爱吃无罪",
    "messageInitNick_9826": "划水小天才",
    "messageInitNick_9827": "我推的梳子",
    "messageInitNick_915": "天花板上",
    "resoundEventStoryDes_233": "那里的商人说话贼好听，进去之后钱就没有了。\\n《疾风兔见闻传》",
    "messageInitNick_916": "暗香先生",
    "resoundEventStoryDes_234": "多彩酸酸肉果成熟后有叉叉一拳头大，就像是名字所提到的那样，果皮有多种颜色，易剥离；果肉淡黄爽脆，拥有恰到好处的酸味，核少或无，很受欢迎。\\n多数多彩酸酸肉果都只能在神秘商人手上买到。最受欢迎的是最为稀少的纯白色酸酸肉果，听说特别好吃。\\n数量最多的纯黑酸酸肉果价格较低。\\n也有一些怪兽以盲选的方式进行售卖，让客户自行抽取，目前也绝赞发售中。\\n《疾风兔见闻传》",
    "messageInitNick_917": "纯真世界",
    "resoundEventStoryDes_231": "平凡的花并非它的名字，这种花和平凡的草一样平凡，遍地都是，毫不起眼，没有名字。或许消亡就是平凡不能逃避的宿命，很快这种花灭绝了，与超进化大陆永别。我之所以将它写下来，是为了记住它曾经存在，却因我们而亡。我还给它取了个名字，因为只存在于过去，所以叫做“灭绝时态”。\\n《疾风兔见闻传》",
    "messageInitNick_918": "说了无坑",
    "resoundEventStoryDes_232": "发现这种花，是从另一种花的灭亡开始的。就是在“灭绝时态”的数量迅速减少的时候，我亲眼目睹了这种花的奇特变化。一朵花变成了另一朵花，一朵“灭绝时态”变成了“普通小白花”，不可思议的完全变形。这就是“魔形之花”，以伪装成超进化大陆数量最多花的形式活着，未曾向世界展示过它“本来”面目。真是可爱的小家伙。\\n《疾风兔见闻传》",
    "messageInitNick_919": "吃货咕咕",
    "resoundEventStoryDes_230": "这是我在从某个无名的怪兽口中听到的，虽然没听明白，但还是记录了下来。\\n随着越来越多的脚印落在地上，走过越来越多的大地，我开始寻找，它们的边界到底在哪里。要有边界，必然要有一个基础的认知，大地是圆是方还是什么形状，在这个基础上才可以定义其边界。世界之外，是摄影棚？是充满着什么子和什么子的元宇宙？还是垂直不断崩落的0和1？还是浩瀚的宇宙？《疾风兔见闻传》",
    "messageInitNick_910": "诺贝尔补刀奖",
    "messageInitNick_911": "二货萌萌妹子",
    "messageInitNick_912": "卤蛋超人",
    "messageInitNick_913": "霸道女孩",
    "messageInitNick_914": "吃瓜门传人",
    "messageInitContent_7378": "我畏惧着这里的一切",
    "messageInitNick_9813": "霸气外露",
    "messageInitContent_7379": "我开始不择手段驱除恐惧",
    "messageInitNick_9814": "因帅被开除",
    "messageInitContent_7376": "████████████",
    "messageInitNick_9811": "乱室才子",
    "messageInitContent_7377": "它只是换了一件皮囊",
    "messageInitNick_9812": "明天相亲",
    "messageInitNick_9810": "姜射手",
    "messageInitContent_7370": "还是腐败过后才是最纯洁无暇的真实",
    "messageInitContent_7371": "眨眼之间，无数腐败的东西遮蔽世间",
    "messageInitNick_9819": "给冰箱把脉",
    "resoundEventStoryDes_239": "渐渐地，热诚部落里没有怪兽敢说谎，为了让信仰更为牢固，酋长又制作出了隐瞒之果，有所隐瞒的怪兽就要遭到驱逐。\\n渐渐地，部落的怪兽们不再隐藏内心的秘密。原本藏在心底的不满怨恨亦被释放出来，四处冲撞。最先扭打起来的只是2只怪兽，随后整个部落都卷入其中。\\n酋长见状，不得已说出了代代酋长相传的秘密“测谎之果、隐瞒之果都是为了坚定信仰的谎言，现在你们可以撒谎了，不要再打了好吗！”但都太迟了……如今，热诚部落的变成了一座废墟，里面横亘着一堆堆白骨。\\n《智者游记》",
    "messageInitContent_7374": "无限低增值扩散死亡再生",
    "messageInitNick_9817": "火星人才辈出",
    "resoundEventStoryDes_237": "它们是曾经得到一个名为热诚的部落的热情款待，下面是它们的所见所闻——穿过密林，趟过小溪，拨开迷雾，就来到了热诚部落。这个部落信仰的是诚实之神，它们的信条是永远保持诚实，永远不能说谎。它们利用“测谎之果”贯彻它们的信条，找出说谎话的怪兽。\\n《智者游记》",
    "messageInitContent_7375": "它只是换了一个身体",
    "messageInitNick_9818": "百香果消灭者",
    "resoundEventStoryDes_238": "测谎之果是热诚部落测谎必备的果实。测谎之前，酋长会进行一系列复杂的仪式，祈求诚实之神降临到测谎之果之中，随后酋长一边叫喊着“你说谎了吗？”一边摇动测谎之果。只要有牙从里面掉出来，那就证明是说谎，如果没有牙掉出，那就说明怪兽是诚实的。说谎的怪兽会遭到永久的放逐。\\n附上禁忌的测谎之果的制作方法，选取一个叉叉头那么大的果壳，掏空晾干后，在上面开有一个洞，将一颗牙放入其中。\\n《智者游记》",
    "messageInitContent_7372": "以腐败净化万物",
    "messageInitNick_9815": "捕鱼达人",
    "resoundEventStoryDes_235": "与它相遇是一次意外中的意外，我想大概只有命运能解释了。这件事大概谁看了都不会相信吧，这完全可以理解，若非亲眼所见，我也不信呐。\\n那天，我失足滚落山崖，滚到了一个石洞之中。石壁上突然浮现出一行文字，写着“你是谁？”。我四处张望，想看看到底是什么怪兽在捉弄我，却什么都没有发现。于是我在石壁上刻下了我的名字。很快，石壁上浮现出了新的内容，我和石壁的奇妙对话就这样开始了。\\n当我谈到我所在的世界的时候，它沉默了很久，我不知道用沉默这个词是否恰当，总之石板上很久没有浮现新的文字。在等待的这段时间里，一阵慌乱占据了我的内心，我是否做了什么不可挽回的事情。就在我这么想的时候，石壁回话了，说它需要一段时间去理解新的维度，如果它能完成这个认知，它会用它的方式告诉我。这就是我们最后的对话。\\n天哪，我到底做了什么。\\n《智者游记》",
    "messageInitContent_7373": "它是它是它是它",
    "messageInitNick_9816": "拒绝勾引",
    "resoundEventStoryDes_236": "我与石壁交流的事情，已经过去了很久很久。我感觉是久到再过一会我就能忘记的程度。就在这个微妙的时间里。我看到了那股不寻常的黄沙。\\n我并不畏惧飞舞的黄沙，可无风而起的黄沙在冰冷的白色月光里显得异常怪诞。黄沙在我面前缓缓移动，先是变成怪兽的模样，然后慢慢变换出一个个场景，最后展现出一个个美轮美奂不似寻常物的图景。我猛然意识到，原本我与它差了一个维度，现在我和它依然差了一个维度。区别在于我们相对的位置变了。我所看到的，只是它在高处降下的投影。\\n《智者游记》",
    "messageInitNick_926": "爱你会发光呀",
    "resoundEventStoryDes_244": "围栏处，一只星刃卡在了缝隙之中，圆滚滚的身躯不停地扭动着，水灵灵的小眼睛闪烁着光。这里是吞噬者的私家“农场”的星刃养植区！一起跟《舌尖上的超进化》走进这里的美味吧！这道星刃料理，以患抑郁症的星刃、中暑的星刃、内伤的星刃为原料制成，乃星刃料理中之上上品，肉质丰满，口感独特，让你的味蕾挂起一股美味的旋风。\\n——《舌尖上的超进化》第201期",
    "messageInitNick_927": "未成年面包",
    "resoundEventStoryDes_245": "感恩节五星推荐！朱雀一只洗净，无须去皮，撒上强化孢子，再裹上进化孢子，下锅和神性孢子一起炸至金黄后控油捞出，完成！\\n——《舌尖上的超进化》第2018期",
    "messageInitNick_928": "杯具刚开始",
    "resoundEventStoryDes_242": "首先准备好材料，进化孢子、强化孢子若干，以及火山湖水藻。火山湖水藻既是奇怪味道的根源，又是这道菜的核心，能让身体更好地吸收孢子。所以要想办法辟除味道，经过不懈的努力和尝试，我们终于找到了唯一的解决办法，那就是冰镇去味觉法！\\n《咸鱼剑与背锅盾的美味菜谱》",
    "messageInitNick_929": "流浪的闲猫",
    "resoundEventStoryDes_243": "《桐仁日记》记录了桐仁追逐爱的心路历程。作者并没有意识到，这类日记一般都有最低限度的互动。桐仁这个连最低限度的交流都没有。从另一个角度来看，本作更像是一部反面教材。最难能可贵的是，该作品目前仍在绝惨连载中……\\n不过这个年代，日更，不拖更，还无需投喂的作者应该珍惜的是稀有物种。\\n《桐仁日记》",
    "resoundEventStoryDes_240": "你好，我是**侠，你不认识也没关系，总之，我现在被困在超进化大陆，等下就要被可怕的大怪兽吃掉了，急需你的帮助，快带上你的金币和钻石，去找智者救我出来！因为只有智者才有办法找到我。智者热心助人，常热心为怪兽解决困难，请多给它一些金币和钻石。你找智者救了我以后，我立刻送你一件千金难换的绝世珍宝！",
    "resoundEventStoryDes_241": "众所周知，黑暗料理火山湖水藻团的味道是多么的一言难尽。不过有一说一,虽说火山湖水藻团不好吃，但其营养价值还是值得充分肯定的。所以今天我们给大家带来一种改进版的做法，让大家都爱上吃火山湖水藻团！\\n《咸鱼剑与背锅盾的美味菜谱》",
    "messageInitNick_920": "流动的世界",
    "messageInitNick_921": "空白系",
    "messageInitNick_922": "高调的范二",
    "messageInitNick_923": "对寂寞咆哮",
    "messageInitNick_924": "傲娇小公举",
    "messageInitNick_925": "纯路人非引战",
    "messageInitContent_7389": "傲慢的有翼生物被驯化",
    "messageInitNick_9802": "破案钻戒",
    "messageInitNick_9803": "霸气小男生",
    "messageInitContent_7387": "伟大的猎手啊",
    "messageInitNick_9800": "再见再也不见",
    "messageInitContent_7388": "亵渎的诗句正在生长",
    "messageInitNick_9801": "拖鞋破坏者",
    "messageInitContent_7381": "它让我接受恐惧",
    "messageInitContent_7382": "让我成为恐惧",
    "messageInitNick_9808": "派对皮卡丘",
    "messageInitContent_7380": "它正侵蚀着我的意志",
    "messageInitNick_9809": "复刻咭洹",
    "messageInitContent_7385": "怪了，坏了，歪了",
    "messageInitNick_9806": "伸手碰触阳光",
    "resoundEventStoryDes_248": "白天，那个东西会躲藏在一处名为贪婪后宫或噬零的阴森洞穴之中。\\n每当大地被银月的辉光铺满，那个东西就开始了它不休的追逐，蠕行在怪兽的背后，阴影之中。\\n它身上有着与明光龙类似的犄角、与最终兵器类似的刃角、与赤色狮类似的赤鬃、与毁灭巨像类似的锁链，还拖着与合一零式类似的齿轮。\\n如果看得更仔细的话，还可以在它身上看到更多的“类似”。\\n很快，怪兽们就发现，那不过是劣质的不敢出现在阳光底下的东西，它只会在苔藓的边沿，地底的深处，阴冷的角落中发出难以辨别的嘶叫，它费尽心思去模仿着那些强大的怪兽，却早早忘记了自己是谁。\\n《》",
    "messageInitContent_7386": "也是时候到了",
    "messageInitNick_9807": "桀骜不驯的你",
    "resoundEventStoryDes_249": "桐仁：我和我的小伙伴现向造唤台发出正式的参观请求！\\n王·朱丽叶：今儿忙，明天再来吧~\\n王·罗密欧：明儿也忙~",
    "messageInitContent_7383": "怪兽的嚎叫，怪叫",
    "messageInitNick_9804": "贪吃肥龙",
    "resoundEventStoryDes_246": "如果没有普通的衬托，那么再特别也是普通的特别。所以容我向您介绍一下超进化大陆的普通，看呐，普通的山、普通的河、普通的云、普通的叉叉，大概是哪个普通的家伙普通地用普通的心情普通地画出来的吧。\\n《》",
    "messageInitContent_7384": "怪异的嚎叫，怪叫",
    "messageInitNick_9805": "粗腿长颈鹿",
    "resoundEventStoryDes_247": "碎片制作流程：\\n1、往世界倒入墨水，刷均匀。\\n2、找一张白纸，印压在世界之上，拿起来，再吹干。\\n3、将白纸随意撕成碎片，大喊世界碎片。\\n《》",
    "messageInitNick_937": "车站拥吻",
    "resoundEventStoryDes_255": "是不是狠狠地戳了好多次，戳着戳着你发现今天隔壁的鸟叫了31回，我的怕怕身上有16个方块，它滚动了2次，每次90°，现在它一直保持这面朝土的姿势。你喊它去尝一下青草的味道，它告诉你有2根是苦的、1根是涩的，1根是甜的，半根是酸的，唔，还有1根，呕——",
    "messageInitNick_938": "不愿透露姓名",
    "resoundEventStoryDes_256": "身旁的我的怕怕在我的抚摸下发出享受的哼声，哼声在我内心的空洞中回荡，扩散。那是谁在我内心坠落时砸出来的空洞，都怪我没能抱住它，所以它消失了，只留下了空洞。我抱起苦力怕，起身，四处游荡，寻找能填满空洞的东西。",
    "messageInitNick_939": "林中鸟",
    "resoundEventStoryDes_253": "王·朱丽叶：小欧欧，我想要极品龙骨结晶！\\n王·罗密欧：老婆大人，您这不是让我去送死嘛？\\n王·朱丽叶：来，给你这个。\\n王·罗密欧：这……这太不自然，太不亲切了，太不真实了！\\n王·朱丽叶：这很自然，自然是为了我，去吧我的小欧欧！\\n（王·罗密欧咽下口水，握紧了手中的重生元核。）\\n（……）\\n（一看%@*&还是个白的。）",
    "resoundEventStoryDes_254": "王·朱丽叶：今日份的我爱你呢？\\n王·罗密欧：我爱你一万年。\\n王·朱丽叶：嗯？\\n王·罗密欧：我爱你三千次。\\n王·朱丽叶：啊？\\n王·罗密欧：你是我的唯一。\\n王·朱丽叶：哼，给你最后一次机会。\\n王·罗密欧：四季如春皆因有你。\\n王·朱丽叶：全是抄的！\\n王·罗密欧：那……我爱你加上……上面的数字。\\n王·朱丽叶：土！",
    "resoundEventStoryDes_251": "王·罗密欧：小心心，最近听到一个词叫近朱者赤，你知道什么意思不？\\n王·朱丽叶：哈？暗示我让你财政赤字？\\n王·罗密欧：我想起来我还有点事，亲爱的。\\n王·朱丽叶：站住，别跑！",
    "resoundEventStoryDes_252": "王·朱丽叶：你是不是藏了私房钱！\\n王·罗密欧：没有？\\n王·朱丽叶：真没有？\\n王·罗密欧：我我对天枢震发誓！\\n王·朱丽叶：上大舌怪。\\n大舌怪：PeroPero（翻译：吸溜，是说谎的味道。）",
    "resoundEventStoryDes_250": "王·罗密欧：小甜心，知道我跟智者有什么区别吗？\\n王·朱丽叶：身高？\\n王·罗密欧：不对，区别是智者住在左上角，我住在你心里！\\n王·朱丽叶：真的吗？\\n王·罗密欧：真的！\\n王·朱丽叶：那你白住不给钱吗？\\n王·罗密欧：我就喜欢你这么直接。\\n王·朱丽叶：别想蒙混过关，快把智者给你的推广费交出来！",
    "messageInitNick_930": "我就住隔壁",
    "messageInitNick_931": "假装不帅",
    "messageInitNick_932": "捡漏小能手",
    "messageInitNick_933": "浪瘾入骨",
    "messageInitNick_934": "八级大狂风",
    "messageInitNick_935": "华丽丽的跌倒",
    "messageInitNick_936": "流心雨",
    "messageInitContent_7398": "一个旁注",
    "messageInitContent_7399": "数百个旁注",
    "messageInitContent_7392": "只剩甜美的空壳",
    "messageInitContent_7393": "拨开邪恶的皮囊",
    "messageInitContent_7390": "噩梦结成无数颗粒",
    "messageInitContent_7391": "噩之果将在尖牙中爆发",
    "messageInitContent_7396": "啊不，那是眼眸的微笑",
    "resoundEventStoryDes_259": "我不知道那头无名之兽会在何时醒来，也不知道它会在何时睡去，只知道，若心是海洋，它便翻起巨浪，若心是大地，它便踏平一切，若心是天空，它便搅起狂风。它仿佛是混沌之母，诞下席卷一切的疯狂。我祈求它的安眠，因为那便是我的安宁。",
    "messageInitContent_7397": "那是它即将张开的嘴巴",
    "messageInitContent_7394": "留下纯真香甜的灵魂",
    "resoundEventStoryDes_257": "我带着苦力怕走着走着，我们跨过小山和小河，小草小花，穿过各种各样的怪兽，日月不知道轮转了几回，似乎已经走了很久很久了。同行的伙伴也换了一批又一批。走过千万条道路，不知道规不规范，只知有那么一条道，由始至终就只有我一个。",
    "messageInitContent_7395": "块状的瞳孔饱含笑意",
    "resoundEventStoryDes_258": "你，就是你，你就是跟我一样无聊的冒险者吗，不不，就是那个，也没啥不如……来聊聊吧！",
    "messageInitNick_948": "爱笑的女孩儿",
    "resoundEventStoryDes_266": "数行来自不同怪兽的脚印。\\n放轻松，在这里，脚印可以随便印。\\n但……卡，不可以。",
    "messageInitNick_949": "本人适合表白",
    "resoundEventStoryDes_267": "一片长满绒毛茅草的土地，上面有不少怪兽在滚来滚去。那是一种摸过就再也不愿放手的柔滑诱惑，根本没有怪兽能顶得住。\\n赞美绒毛茅草，还有那之上的短暂和平。这可能就是场地魔法吧。",
    "resoundEventStoryDes_264": "凝结的冰锥，舔一下试试看能不能黏上吧！",
    "resoundEventStoryDes_265": "和它打个招呼吧！\\n嗨，草！",
    "resoundEventStoryDes_262": "早上到这儿看看吧！\\n看太阳从天边升起，或看朝露从叶尖滴落。",
    "resoundEventStoryDes_263": "你碰到一个树皮堆，最上面的树皮写着：\\n总是想不出要写什么，但又必须写出什么来，最后反而写下了很多写不出来的理由。\\n再往下看，剩下的树皮上写满了写不出来的理由。",
    "resoundEventStoryDes_260": "超进化大陆最后一株星状龙舌兰曾在此处绽放。",
    "resoundEventStoryDes_261": "留心那些预示着危险的声音。\\n要是听到了……\\n自信点的，可以别跑，等着。\\n不那么自信的，就别愣着，跑吧。",
    "messageInitNick_940": "孤木不似林",
    "messageInitNick_941": "君不知我意",
    "messageInitNick_942": "风刮来的钱",
    "messageInitNick_943": "流浪的白云",
    "messageInitNick_944": "表情极其诡异",
    "messageInitNick_945": "你毕业了",
    "messageInitNick_946": "跟风门传人",
    "messageInitNick_947": "林深见鹿",
    "resoundEventStoryDes_268": "这座山名叫山外有山，它非常特别，山里还有另外一座山，姑且称之为山里有山。然后山外有山里有山里有山……",
    "resoundEventStoryDes_269": "这里是结晶海岸东南部地区，近日，附近的怪兽发现肉场的出口被一条巨大的尾巴堵住，以至于食物无法正常产出。现在，数名圣堂武士正在努力从各个位置切除这条尾巴，初步认为，尾巴属于一只体型+66%的大轰龙，吃太多导致体型暴增因而无法脱身。",
    "messageInitNick_959": "天亮前说晚安",
    "resoundEventStoryDes_277": "大概没有怪兽比它更懂，怪兽的头顶都长什么样，所以它老飘了。",
    "resoundEventStoryDes_278": "它让所有渴望得到温暖的怪兽都妒忌不已，因为总有怪兽希望它能孵化出些东西来。",
    "resoundEventStoryDes_275": "这座起眼的山洞中有一些不起眼的裂痕，可以借助强烈的阳光察觉到它们。这些裂痕……就像是怪兽一觉醒来的刹那里，那昨日与今天的裂痕那样，微小又迷人。",
    "resoundEventStoryDes_276": "怪兽总是不约而同来到这个台地讨论各种秘密的事情。\\n这台地要是有个嘴巴，它就是全大陆消息最灵通的情报贩子了。\\n另外，这里最初是个山头，踩的怪兽多了就变成台地了，变成平地大概也是迟早的事。",
    "resoundEventStoryDes_273": "这棵树的树干原本是相当地粗糙，但蹭的怪兽多了，就……没了，倒也不是蹭没的，而是被那些觉得能够以形补形的爱美怪兽吃掉了。是的，这些怪兽认为有皱褶的皮肤更有魅力。",
    "resoundEventStoryDes_274": "偶尔会有一群圆滚滚的干枯草团随风滚过地面，它们是草的行尸走肉，带着它们的种子，目标是占领这个星球！",
    "resoundEventStoryDes_271": "一种有着花的形状的贝壳，它无法为你实现什么梦想，但……至少它不会诱惑你。",
    "resoundEventStoryDes_272": "暗色的血液没过刚冒芽的嫩草缓缓流向低处，这些血液可能属于一只或者一群幸运或倒霉的怪兽。\\n挺常见的。",
    "messageInitNick_951": "元芳你怎样看",
    "messageInitNick_952": "黑色无欲者",
    "resoundEventStoryDes_270": "超进化大陆最大的色彩刷子，日复一日扫过它那爱转的画布。",
    "messageInitNick_953": "此女子不好惹",
    "messageInitNick_954": "看懂你的多情",
    "messageInitNick_955": "吃藕丑割吻滚",
    "messageInitNick_956": "乘风破浪的兽",
    "messageInitNick_957": "捡漏公主",
    "messageInitNick_958": "尬聊王",
    "messageInitNick_950": "凌晨别心动",
    "resoundEventStoryDes_279": "总会让怪兽停下来瞅一眼的，非常受欢迎的小水洼，特别是那些准备去求爱的怪兽。",
    "resoundEventStoryDes_288": "在可可洛果树林，要吃饱并不会太难，要吃好就要再努力一些，想吃香就更要多费心思。\\n要吃到美味的可可洛果要突破以下好几道难关。\\n第一关，高难。可可洛果树非常的高，抵达树冠的速度是第一关决胜的关键。飞的，爬的，把果树推倒的、把果子震下的各凭本事。\\n第二关，超难。大部分想得到可可洛果的怪兽都属于捡漏一批的，它们会在第一关选手那里与一大堆怪兽一起进行捡漏竞争，从其他怪兽嘴里掉出来的、抛或滚到不知道哪里去的可可洛果都是它们的目标。\\n第三关，绝难。吃香的大前提是活着，捕食者多的地方捕食者的捕食者也不少，所以逃命本领要练好。",
    "resoundEventStoryDes_289": "山洞之中有一个隐秘的通道，里面刮着时间的乱流，这个通道连通着相同却又不一样的山洞……",
    "resoundEventStoryDes_286": "这片葱郁的森林由数千棵大树组成，这些大树均有五十叉叉高，胸径约一叉叉，树皮褐色。\\n这里的大树仿佛都非常害怕接触到其他大树，每一棵树的树冠的边缘都保持着一定的间隔，没有半点交叠。\\n在穿过这片森林时不妨试试抬头看看，那个由数十个树冠织成的多边形光网，明媚的天光在树冠间的空隙间倾斜而下。\\n一些怪兽说那是大树的心之壁，可谁知道大地之下，它们的树根有没有紧密地纠缠着呢？",
    "resoundEventStoryDes_287": "某个叉叉部落的中心突然出现了一个大坑，不少叉叉不小心掉进了坑里。\\n大家开始讨论要怎么处理这个坑。\\n第一个方案是，用干草把坑口遮蔽起来来来来来。\\n第二个方案是，在隔壁挖个坑，用挖出来的泥土填上这个坑坑坑坑坑。\\n第三个方案，找其他部落的怪兽帮忙忙忙忙忙忙。\\n第四个……你肯定猜到了，这些带回音的方案都是掉进坑里的叉叉讨论出来的的的的的的。",
    "resoundEventStoryDes_284": "又一次踏入新区域，附近的迷雾随之消散。\\n那些迷雾可能是悬浮于空中对探险者单向不透明的微小水滴。也可能是某条曾经闲得尾巴疼的龙乱放的云雾术。\\n但它们为什么会跑呢，是害怕你吗？\\n它们总有一天会消失殆尽，那时，你会怀念它们吗？",
    "resoundEventStoryDes_285": "这棵树坐落在一个热爱记录的部落中央，这个部落每三百个日月就会记满一块大石板，这棵树已经出现在了600多块石板上了。\\n这大概意味着这个部落……不会太弱。",
    "resoundEventStoryDes_282": "污妖王手中的菊花的原产地，从这里的各处细节都可以看得出，这些花得到了非常悉心的照料。这主要与污妖王的理念有关。它的理念就是——花和**一样，要天天换！",
    "resoundEventStoryDes_283": "存在于四维空间的难以理解之物。",
    "messageInitNick_962": "头铁大师",
    "resoundEventStoryDes_280": "但会被其他什么定义，这主要看路过的怪兽是饿了还是肚子疼。",
    "messageInitNick_963": "此男人已疯",
    "resoundEventStoryDes_281": "普通在于，像这样的泉水还有很多。\\n有的热情，有的沉闷，有的平静。\\n特别在于，你注意到它了。",
    "messageInitNick_964": "退役杠精",
    "messageInitNick_965": "阴天的向日葵",
    "messageInitNick_966": "时光鸡",
    "messageInitNick_967": "超萌萌喵",
    "messageInitNick_968": "脑子短路",
    "messageInitNick_969": "破防男神",
    "messageInitNick_960": "会飞的马桶盖",
    "messageInitNick_961": "雾里闻花香",
    "resoundEventStoryDes_299": "石头能听，石头能看，石头明白生命的答案！石头是可以感知并捕捉空间中的不同波动，怪兽的情绪说散发出来的正面或负面的波动能够影响石头砸碎之后的样子。\\n如果心怀“爱”与“感谢”将石头砸到地上，石头就会碎得非常美丽。\\n如果一边骂“混蛋”将石头砸到地上，石头就会碎的歪曲散乱。\\n快试试吧！注意不要砸到尾巴了。",
    "resoundEventStoryDes_297": "龙皮匠正在林地找寻可用的木材，住在林地的本地怪兽将龙皮匠领到一颗枯树前。说那是一棵已经死了好几年的老树，只剩下主干，尚未被虫蚀，在绿意盎然的林地显得有几分落寂。\\n龙皮匠谢过当地怪兽后，开始着手将枯树拔起，平日的枯树只需要耗费5个日月，这棵枯树竟花费了它10个日月都还没完全拔出。\\n第11个日月，龙皮匠终于见到枯树的树根，只见枯树树根被周围青壮的树的树根紧紧地缠绕着。周围树竟悄悄地给它输送着养分。",
    "resoundEventStoryDes_298": "在湍急宽广河面上，宽大的圆形叶片随波起伏，一只只怪兽乘着叶片从河岸的一边来到另一边。\\n河的两岸常常蹲着两只怪兽，直直地盯着对岸的对方，用它们的秘密手势进行交流着。它们一见钟情，相惜相爱，并且和对方一样，碰到渡河的叶子就会腹痛，腹泄，呕吐，晕倒过去。\\n之后，一条爱管闲事的暗黑龙帮它们渡河相聚。\\n只是没过多久，它们就正式分开了。",
    "resoundEventStoryDes_295": "木森林贪婪地向上伸展，层层叠叠的树叶化作厚重的华盖遮蔽天空，不留给下方的稽谷半点阳光。\\n失去阳光的照拂后，一部分生物离开了稽谷，一部分生物留了下来。\\n留下了的那一部分生长得越来越奔放。\\n不久后，稽谷就成为了不少怪异生物的大本营。\\n智者认为，失去日照以后，如果生物相互之间都看不着对方，所以长什么样都没关系。如果生物相互之间可以看见对方，那长得怪都是为了让周围的生物发笑，解决没有日照带来的坏心情。",
    "resoundEventStoryDes_296": "对于游历的智者而言，在满眼都是大自然创造的世界里，看到有非自然雕琢的痕迹自然是欣喜的，缓慢的步子不自觉地转为轻快的小跳，踏着它可爱的小石地板，找寻遗迹的秘密。\\n有时候，它也会想，如果情况刚好相反，满地都是非自然的产物，届时，它大概又会觉得，小草才是最可爱的吧。",
    "resoundEventStoryDes_293": "从淡黄的草丛一直蜿蜒延展到蓬松的矮树，先是在长着白色小花的石头旁，微微拐向日出的方向，接着来到疾风兔的巢穴，再绕过无毒的蘑菇丛……\\n这些标示物的正下方，在阳光透不过的地底之中，有一条暗流，有着开阔水面，独自平静流淌。\\n流水的味道会是甘甜的吗？会是冰凉的吗？里头会有活物吗？\\n星刃移开它的耳朵，它灵敏的听觉没有告诉它更多。\\n或许地龙、撼地兽之类的怪兽不经意的造成的地表堪塌就可以揭示暗流的真相。\\n星刃期待同时又害怕着，现在的暗流只属于它和它的想象。",
    "resoundEventStoryDes_294": "如果走着走着发现有什么东西扒在了脚上，那多半就是它，抱腿丛。\\n抱腿丛依靠它叶片边缘的倒刺附着到路过的怪兽身上。但别担心，抱腿丛是无害的，取下它并不困难。\\n相反，还有很多怪兽会带着它到处跑，被它缠上的怪兽走过的路程越远，抱腿丛就长得越是壮实，一件越来越坚硬的天然的甲胄就此诞生。",
    "messageInitNick_973": "跟风少年",
    "resoundEventStoryDes_291": "素肉树虽然数量不多，分布却很广。\\n它是大陆最齐全的齿痕博物馆。辨认这种树的方法非常简单，看到树干布满各种各样的怪兽齿痕的树就是了。\\n素肉树生长到10叉叉高后，就会在夜晚散发出一阵极其有诱惑力的味道。怪兽受到这股味道吸引，咬到树干上，然后发现那是闻着香吃着臭的树干之后，愤然离去。",
    "messageInitNick_974": "风居住的街道",
    "resoundEventStoryDes_292": "浮石是浮在空中的石头。\\n一些不想用神秘力量四个字去解释石头为什么会待在空中的怪兽认为，真相就是，那是由某只透明的怪兽托举着的石头，之所以摸不着这只怪兽，则是因为托着石头的透明怪兽怕痒不喜欢被碰到。关于这个浮石的猜想越来越多。\\n若是未来有一天，浮石坠落地面，那一定是因为不堪猜想的重负，当然这个也只是一个猜想。",
    "messageInitNick_975": "胆怯的猫儿",
    "messageInitNick_976": "悲伤格化式",
    "resoundEventStoryDes_290": "名为太阳炉的山丘常年干燥炎热，零星生长着一些顽强的耐枯草。\\n通常是在冬去春来之际，被怪兽认为是距离太阳最近的时刻，一块块大小不一的厚石板被送到这里，竖置在挖好的长坑中。\\n怪兽们将它们对太阳的幻想都刻画在石碑的图文中。最古老的石板的刻画时间已不可追溯，向东的多是赞美太阳的，向西的多是诅咒太阳。\\n太阳被赋予了不同的阵营，而那些翻倒在地的石碑见证了这些阵营的斗争。",
    "messageInitNick_977": "这恒河里",
    "messageInitNick_978": "你必须取我",
    "messageInitNick_979": "夏末花未落",
    "messageInitNick_970": "孤僻浪子",
    "messageInitNick_971": "刹那与永恒",
    "messageInitNick_972": "天外世界",
    "messageInitNick_984": "草莓味少女",
    "messageInitNick_985": "猫粮",
    "messageInitNick_986": "佩奇大哥",
    "messageInitNick_987": "药不能停",
    "messageInitNick_988": "纯白紫色",
    "messageInitNick_989": "读不懂的流年",
    "messageInitNick_980": "擅长踹门而进",
    "messageInitNick_981": "奋斗吧小青年",
    "messageInitNick_982": "忍住心动",
    "messageInitNick_983": "剑客",
    "ancientCampaignName_24": "无尽冲击",
    "ancientCampaignName_25": "深渊之兽",
    "ancientCampaignName_22": "疯狂螺旋",
    "ancientCampaignName_23": "狂牙猛噬",
    "ancientCampaignName_20": "真实幻觉",
    "ancientCampaignName_21": "蠕动恶兽",
    "messageInitNick_5851": "天亮说晚安",
    "messageInitNick_5852": "风好大",
    "messageInitNick_5853": "梨花猫",
    "messageInitNick_5854": "打瞌睡的猪",
    "ancientCampaignName_28": "三皮杀",
    "ancientCampaignName_29": "四带一",
    "ancientCampaignName_26": "香月秘仪",
    "ancientCampaignName_27": "兽海战术",
    "messageInitNick_5850": "摆摊卖寂莫",
    "messageInitNick_5859": "坑神一号",
    "messageInitNick_5855": "未来的后视镜",
    "messageInitNick_5856": "葡萄柚兽",
    "messageInitNick_5857": "星空下流浪",
    "messageInitNick_5858": "大象是工程师",
    "ancientCampaignName_13": "难念的经",
    "ancientCampaignName_14": "大角转转转",
    "ancientCampaignName_11": "三龙携手",
    "ancientCampaignName_12": "独孤求败",
    "ancientCampaignName_10": "手上功夫",
    "messageInitNick_5840": "彪悍女汉子",
    "messageInitNick_5841": "第二眼美女",
    "ancientCampaignName_19": "森系草林",
    "messageInitNick_5842": "没人懂我",
    "messageInitNick_5843": "当场再见",
    "ancientCampaignName_17": "以小见大",
    "ancientCampaignName_18": "BigBang",
    "ancientCampaignName_15": "弹药包",
    "ancientCampaignName_16": "去月球",
    "messageInitNick_5848": "仙女界扛把子",
    "messageInitNick_5849": "自走鼠标",
    "messageInitNick_5844": "浑身难瘦",
    "messageInitNick_5845": "老婆是天",
    "messageInitNick_5846": "拉面大师",
    "messageInitNick_5847": "墨西哥卷饼",
    "worldBossConfigName_5": "灾·雷鸣",
    "worldBossConfigName_4": "灾·星落",
    "worldBossConfigName_3": "灾·赤潮",
    "randomEventDialogueGroupConfig_7.100": "说让它陪",
    "96_Altar": "怪兽饲星",
    "randomEventDialogueGroupConfig_7.101": "说让它赔",
    "randomEventDialogueGroupConfig_7.102": "早买早享受哦！",
    "randomEventDialogueGroupConfig_7.103": "表示不买立省100%",
    "messageInitNick_5830": "超级烤薯片",
    "randomEventDialogueGroupConfig_7.104": "碰瓷错人了，可恶算了，等你囤够了再来找我玩吧。",
    "messageInitNick_5831": "优雅永不过时",
    "randomEventDialogueGroupConfig_7.105": "它叹了口气失望地走了。",
    "messageInitNick_5832": "蚊子闯天下",
    "randomEventDialogueGroupConfig_7.106": "离开",
    "randomEventDialogueGroupConfig_7.107": "哎，总能碰上一两个老抠，随你吧。",
    "randomEventDialogueGroupConfig_7.108": "它双手一摊，转身离去。",
    "randomEventDialogueGroupConfig_7.109": "离开",
    "messageInitNick_5837": "那个法师",
    "messageInitNick_5838": "越陷越深",
    "messageInitNick_5839": "听说是换资源",
    "messageInitNick_5833": "欢快的糖罐",
    "messageInitNick_5834": "迷你披萨",
    "messageInitNick_5835": "富贵不能赢",
    "messageInitNick_5836": "面包的棉袄",
    "randomEventDialogueGroupConfig_7.110": "其实呢，我一个小商人，出来忙活这么久，都没几个朋友能聊的。#毕竟商人之间的竞争很激烈，大家都各自的一套机密商业模式，也不好聊太深入。",
    "randomEventDialogueGroupConfig_7.111": "它拉起你的手，又继续说。",
    "randomEventDialogueGroupConfig_7.112": "现在我把你当朋友了，不知道你愿不愿意帮我一个忙。",
    "randomEventDialogueGroupConfig_7.113": "问是要帮什么忙",
    "randomEventDialogueGroupConfig_7.114": "表示不愿意",
    "randomEventDialogueGroupConfig_7.115": "好吧，这事也强求不得，别了。",
    "messageInitNick_5820": "潜水王",
    "randomEventDialogueGroupConfig_7.116": "告别",
    "messageInitNick_5821": "局内人",
    "randomEventDialogueGroupConfig_7.117": "我好想知道其他商人是怎样的，希望你可以把你遇到其他商人的经历告诉我。",
    "randomEventDialogueGroupConfig_7.118": "指出它明明是想打探",
    "randomEventDialogueGroupConfig_7.119": "随便说一个",
    "messageInitNick_5826": "猫咪厂长",
    "messageInitNick_5827": "饺子的棉袄",
    "messageInitNick_5828": "奇迹会发生",
    "messageInitNick_5829": "在未来补兵",
    "messageInitNick_5822": "见过世面的猫",
    "worldBossConfigName_2": "灾·焚风",
    "messageInitNick_5823": "成精的土狗",
    "worldBossConfigName_1": "灾·地裂",
    "messageInitNick_5824": "红发魔女",
    "messageInitNick_5825": "如果莲雾会哭",
    "messageInitNick_5819": "向月亮道晚安",
    "messageInitNick_5810": "赛博饺子",
    "messageInitNick_5815": "消失的吃的",
    "messageInitNick_5816": "甩锅爱好者",
    "messageInitNick_5817": "暴龙磨牙石",
    "messageInitNick_5818": "纯真世界",
    "messageInitNick_5811": "四点的饺子",
    "messageInitNick_5812": "初二",
    "messageInitNick_5813": "被作业虐的人",
    "messageInitNick_5814": "长脚的香水",
    "messageInitNick_5808": "寂寞式滑屏",
    "messageInitNick_5809": "制服控香蕉",
    "messageInitNick_5804": "打脸大师",
    "messageInitNick_5805": "香瓜射手",
    "messageInitNick_5806": "怪生设计师",
    "messageInitNick_5807": "急需空调救命",
    "messageInitNick_5800": "彩虹捕手",
    "messageInitNick_5801": "老子可爱不",
    "messageInitNick_5802": "一次性恋爱",
    "messageInitNick_5803": "爱莫能助哦",
    "96_comment": "主要获得途径",
    "97_title8": "想买就能买，绝不剁手！",
    "97_title7": "团结的部落将战无不胜。",
    "97_title9": "愉快的进行造唤吧，哦勒哦勒！",
    "97_title4": "怪兽因你而变得强大。",
    "iapBuyConfigName_1902": "屯屯礼遇II",
    "97_title3": "领地不只是领地，谜语人最喜欢这样说话了。",
    "iapBuyConfigName_1903": "屯屯礼遇III",
    "97_title6": "没有最强的队伍，是真的！",
    "97_title5": "神灵，将逆转战斗。",
    "iapBuyConfigName_1901": "屯屯礼遇I",
    "worldName_30003": "互通战区三",
    "worldName_30001": "互通战区一",
    "worldName_30002": "互通战区二",
    "messageInitContent_3446": "僵住了",
    "messageInitContent_3447": "生活好难",
    "messageInitContent_3448": "快跑！",
    "messageInitContent_3449": "雷霆万钧！",
    "messageInitContent_3450": "很喜欢这种打不过的感觉",
    "messageInitContent_3451": "头头是道",
    "messageInitContent_3452": "乖巧",
    "messageInitContent_3453": "撒点猫粮",
    "messageInitContent_3454": "掏出我的逗猫棒！",
    "messageInitContent_3455": "咪咪~",
    "messageInitContent_3456": "小猫快到碗里来",
    "messageInitNick_10608": "呆萌男神",
    "messageInitNick_10609": "五级科员",
    "messageInitNick_10606": "天使不穿袜子",
    "messageInitNick_10607": "富贵险中求",
    "messageInitContent_3457": "谢谢你为我做毛衣",
    "messageInitNick_10600": "一碗泪流满面",
    "messageInitContent_3458": "我这有好多小鱼干哦",
    "messageInitNick_10601": "菠萝兽",
    "messageInitContent_3459": "好兄妹",
    "messageInitNick_10604": "蒜苔之心",
    "messageInitNick_10605": "强壮熬夜神",
    "messageInitNick_10602": "惊天大片局",
    "messageInitNick_10603": "懒癌入髓",
    "messageInitContent_3460": "可以组个cp了",
    "messageInitContent_3461": "惆怅",
    "messageInitContent_3462": "努力保持微笑",
    "messageInitContent_3463": "拼了",
    "messageInitContent_3464": "评了",
    "messageInitContent_3465": "让我猜猜空蝉绑哪了",
    "messageInitContent_3466": "我比较大！",
    "messageInitContent_3467": "哈？",
    "messageInitContent_3468": "盲猜冰霓",
    "messageInitContent_3469": "kiss me plz",
    "messageInitContent_3471": "浮沉随浪只记今朝",
    "messageInitContent_3472": "江山笑 烟雨遥",
    "messageInitContent_3473": "竟惹寂寥",
    "messageInitContent_3474": "豪情仍在痴痴笑笑",
    "messageInitContent_3475": "请",
    "messageInitContent_3476": "口都合不拢",
    "messageInitContent_3477": "我真是栓Q",
    "messageInitContent_3478": "早上好",
    "messageInitContent_3470": "沧海一声笑",
    "messageInitContent_3479": "晚上好",
    "messageInitContent_3482": "gggg",
    "messageInitContent_3483": "咆哮",
    "messageInitContent_3484": "心虚",
    "messageInitContent_3485": "拉线",
    "messageInitContent_3486": "姨姨好",
    "messageInitContent_3487": "糟了糟了",
    "messageInitContent_3488": "还没找到我宝贝",
    "messageInitContent_3489": "咩啊咩啊",
    "messageInitContent_3480": "锤子当先锋了哈",
    "messageInitContent_3481": "双火龙",
    "messageInitNick_10639": "山月知我意",
    "messageInitNick_10633": "人参果君快逃",
    "messageInitNick_10634": "橘子",
    "messageInitNick_10631": "不好玩云的",
    "messageInitNick_10632": "脑子逃跑了",
    "messageInitNick_10637": "枫之谷",
    "messageInitNick_10638": "活着刺客",
    "messageInitNick_10635": "要保护好自己",
    "messageInitNick_10636": "不如笑着放手",
    "messageInitContent_3493": "猫猫怂怂",
    "messageInitContent_3494": "猫猫超凶",
    "messageInitContent_3495": "不卖？",
    "messageInitContent_3496": "让我看看是谁卖艺",
    "messageInitContent_3497": "我想还是算了吧",
    "messageInitContent_3498": "好好好",
    "messageInitNick_10630": "请备注爱人",
    "messageInitContent_3499": "留下我的金币",
    "messageInitContent_3490": "打call",
    "messageInitContent_3491": "大猫猫",
    "messageInitContent_3492": "prprprpr",
    "activityTaskDes_333": "创糕糕糕分数到达{1}",
    "activityTaskDes_331": "创糕糕糕挑战{1}次",
    "activityTaskDes_332": "创糕糕糕分数到达{1}",
    "messageInitNick_10644": "画饼鉴定家",
    "messageInitNick_10645": "唯独月色依旧",
    "messageInitNick_10642": "扭蛋肌肉",
    "messageInitNick_10643": "霸气你姐",
    "messageInitNick_10648": "毒霸先锋",
    "messageInitNick_10649": "摸鱼恶魔",
    "messageInitNick_10646": "橙汁船长",
    "messageInitNick_10647": "世俗的欲望",
    "messageInitNick_10640": "最爱菜花",
    "messageInitNick_10641": "哈喽小姐",
    "activityTaskDes_330": "连环击破或七王轮战全通关{1}次",
    "activityTaskDes_322": "龙宵大作战到达{1}得分",
    "messageInitNick_10619": "三头肌法师",
    "activityTaskDes_323": "龙宵大作战到达{1}得分",
    "activityTaskDes_320": "天降一掌到达{1}分",
    "messageInitNick_10617": "无暇加班",
    "activityTaskDes_321": "龙宵大作战挑战{1}次",
    "messageInitNick_10618": "暴力仙女",
    "activityTaskDes_326": "一创到底单次最高胜场{1}次",
    "activityTaskDes_327": "一创到底单次最高胜场{1}次",
    "activityTaskDes_324": "一创到底战斗{1}次",
    "activityTaskDes_325": "一创到底单次最高胜场{1}次",
    "messageInitNick_10611": "流浪拾荒者",
    "messageInitNick_10612": "洋娃娃长剑",
    "activityTaskDes_328": "一创到底单次最高胜场{1}次",
    "activityTaskDes_329": "连环击破或七王轮战挑战{1}次",
    "messageInitNick_10610": "老板没有假期",
    "messageInitNick_10615": "打脸鉴定家",
    "messageInitNick_10616": "地狱战士",
    "messageInitNick_10613": "强壮打酱油神",
    "messageInitNick_10614": "暗夜霸主",
    "activityTaskDes_311": "三阵入局到达{1}积分",
    "activityTaskDes_312": "完成每日挑战{1}次",
    "messageInitNick_10628": "滚吧水果",
    "activityTaskDes_310": "三阵入局到达{1}积分",
    "messageInitNick_10629": "被猫吃破产",
    "activityTaskDes_315": "拼二大作战挑战{1}次",
    "activityTaskDes_316": "拼二大作战到达{1}分",
    "activityTaskDes_313": "本周活跃到达{1}",
    "activityTaskDes_314": "在{2}消耗{3}{1}",
    "activityTaskDes_319": "天降一掌到达{1}分",
    "messageInitNick_10622": "顽童",
    "messageInitNick_10623": "念念不忘",
    "activityTaskDes_317": "拼二大作战到达{1}分",
    "messageInitNick_10620": "刚好中意",
    "activityTaskDes_318": "天降一掌挑战{1}次",
    "messageInitNick_10621": "时光在流淌",
    "messageInitNick_10626": "芋圆怪兽",
    "messageInitNick_10627": "千里江山图",
    "messageInitNick_10624": "红颜纷扰红尘",
    "messageInitNick_10625": "揪揪揪揪心",
    "propConfigDes_40064": "随机召唤一只幼体怪兽。",
    "propConfigDes_40065": "随机召唤一只幻化怪兽。",
    "propConfigDes_40066": "随机召唤一只究极怪兽。",
    "propConfigDes_40067": "随机召唤一只不朽怪兽。",
    "propConfigDes_40068": "随机召唤一只单种族觉醒怪兽。",
    "propConfigDes_40069": "随机召唤一只双种族觉醒怪兽。",
    "messageInitNick_10556": "哥只抽寂寞",
    "messageInitNick_10557": "春天的雨露",
    "messageInitNick_10554": "香菜先锋",
    "messageInitNick_10555": "风雨断肠人",
    "messageInitNick_10558": "清新的橘子",
    "messageInitNick_10559": "你不在的季节",
    "messageInitNick_10552": "生活小爆炸",
    "messageInitNick_10553": "灵感请降临",
    "messageInitNick_10550": "易拉罐圣光",
    "messageInitNick_10551": "独家式温柔",
    "propConfigDes_40070": "本品有护肝、防秃的奇效。\\n「用于瞬破敌人快速获取奖励」",
    "propConfigDes_40071": "让友情从塑料、青铜、白银、黄金、铂金、钻石、到最强基友产生质变的点数。\\n友好点数每周获取上限为{1}。\\n「用于友好商店兑换」",
    "propConfigDes_40072": "用于兑换猎人协会提供的各种奖励，一个好的猎人协会虽然不会准时更新，但会拥有完善的奖励机制。\\n「用于狩猎商店兑换」",
    "propConfigDes_40073": "随机获得一枚怪兽觉醒结晶。",
    "propConfigDes_40074": "随机获得一枚怪兽觉醒结晶（父或母含祖龙族）",
    "propConfigDes_40075": "随机获得一枚怪兽觉醒结晶（父或母含尸鬼族）",
    "propConfigDes_40076": "随机获得一枚怪兽觉醒结晶（父或母含星灵族）",
    "propConfigDes_40077": "随机获得一枚怪兽觉醒结晶（父或母含木偶族）",
    "propConfigDes_40078": "领域副本次数",
    "propConfigDes_40079": "强征次数",
    "messageInitNick_10567": "家有风龙",
    "messageInitNick_10568": "猫咪很激情",
    "messageInitNick_10565": "蘑菇魔法",
    "messageInitNick_10566": "反转地球",
    "messageInitNick_10569": "果味小可爱",
    "messageInitNick_10560": "深海咸者",
    "messageInitNick_10563": "解谜老衲",
    "messageInitNick_10564": "地狱厨神",
    "messageInitNick_10561": "本猫很萌",
    "messageInitContent_3500": "抛出",
    "messageInitNick_10562": "小老弟",
    "propConfigDes_40080": "世界灾厄排行奖励次数",
    "propConfigDes_40081": "好友请求次数",
    "propConfigDes_40082": "一种带有粘性的羽毛，能遮盖学舌鸦在飞行过程中秃了的部分，安抚学舌鸦的情绪，助力鸦动力气球顺利浮空前往巨塔。\\n「用于浮空巨塔挑战」",
    "propConfigDes_40083": "好友上限",
    "propConfigDes_40084": "背包上限",
    "propConfigDes_40085": "探索者在超进化大陆冒险时发现的神秘符文。\\n「用于支线冒险宝箱开启」",
    "messageInitContent_3509": "又想封住我的行动",
    "propConfigDes_40086": "繁荣度越高部落就越是强盛，里面的草的长势就越不茂盛。\\n「用于部落之王排行」",
    "propConfigDes_40087": "是多多益善，还是少少无区，还是两者皆可？不妨先向酋长了解一下。\\n「用于部落遗迹功勋宝箱开启」。",
    "propConfigDes_40088": "蕴含着神秘力量的凿星之钥，经常在大家面前显示它真正的力量——打开宝箱！\\n「用于凿星裂痕宝箱开启」",
    "propConfigDes_40089": "收集30块碎片可以召唤随机幼体怪兽。",
    "messageInitContent_3501": "愤怒的拳头",
    "messageInitNick_10534": "把孤独喂饱",
    "messageInitContent_3502": "这个小岛是我的啦",
    "messageInitNick_10535": "酱油苹果",
    "messageInitContent_3503": "听说这岛有马喽",
    "messageInitNick_10532": "火焰热哭了",
    "messageInitContent_3504": "收工",
    "messageInitNick_10533": "防弹苹果",
    "messageInitContent_3505": "这就是新的入口了吗",
    "messageInitNick_10538": "拖鞋狂怒者",
    "messageInitContent_3506": "芝麻开门",
    "messageInitNick_10539": "安稳意中人",
    "messageInitContent_3507": "开门",
    "messageInitNick_10536": "无敌寂寞",
    "messageInitContent_3508": "漫天飞鱼？",
    "messageInitNick_10537": "喜欢的曼",
    "messageInitNick_10530": "残月夜半撩人",
    "messageInitNick_10531": "明年摸鱼",
    "messageInitContent_3510": "别再下星星了",
    "messageInitContent_3511": "藏不住了",
    "propConfigDes_40090": "收集30块碎片可以召唤随机幻化怪兽。",
    "propConfigDes_40091": "收集30块碎片可以召唤随机究极怪兽。",
    "propConfigDes_40092": "收集30块碎片可以召唤随机不朽怪兽。",
    "propConfigDes_40093": "收集30块碎片可以召唤随机单种族觉醒怪兽。",
    "propConfigDes_40094": "收集30块碎片可以召唤随机双种族觉醒怪兽。",
    "propConfigDes_40095": "一种能让大家了解其在造唤领域造诣如何的积分。\\n「用于造唤商店兑换」",
    "propConfigDes_40096": "让形形色色的怪兽欲罢不能的许可。\\n「用于造唤台怪兽造唤」",
    "propConfigDes_40097": "部落战进攻方发起进攻前必须要擂响的战鼓，声音很大，所以搞不了偷袭。注意不要在耳边使用噢。\\n「用于部落战挑战敌对部落成员」",
    "propConfigDes_40098": "虽然不能决定自己的狩猎对象，但可以提高狩猎积分，遇到更好的对手。\\n「用于狩猎积分排行」",
    "propConfigDes_40099": "来自氪星深处，充满超能力的宝石。\\n「用于感谢支持着超进化大陆发展的每一位」",
    "messageInitContent_3512": "变身！",
    "messageInitNick_10545": "庸俗又无趣",
    "messageInitContent_3513": "这次神唤的小伙伴居然是朱雀",
    "messageInitNick_10546": "无暇摸鱼",
    "messageInitContent_3514": "战地记者前来报道",
    "messageInitNick_10543": "芝士机器人",
    "messageInitContent_3515": "御空好忙",
    "messageInitNick_10544": "反正别熬夜",
    "messageInitContent_3516": "他怎么那么高大",
    "messageInitNick_10549": "来一份甜豆",
    "messageInitContent_3517": "勇敢牛牛不怕困难",
    "messageInitContent_3518": "噗嗤噗嗤",
    "messageInitNick_10547": "拾忆",
    "messageInitContent_3519": "你放心",
    "messageInitNick_10548": "你是印卡的吧",
    "messageInitNick_10541": "白了少年头",
    "messageInitContent_3520": "我听不懂，但大为震撼",
    "messageInitNick_10542": "移动楼梯",
    "messageInitContent_3521": "嘤嘤嘤",
    "messageInitContent_3522": "打饿了",
    "messageInitNick_10540": "苹果是牧师",
    "propConfigDes_40020": "影响怪兽一辈子的神奇点数，大家都想用在其他怪兽而不是自己身上。\\n「用于怪兽性格更改」",
    "propConfigDes_40021": "粉尘滚滚，粉尘可以全方位提升元核的强度。\\n「用于元核进阶」",
    "propConfigDes_40022": "原石能锁定元核的本源，那是熔炼都无法改变的，属于元核最原初的部分。\\n「用于元核熔炼时锁定词条属性」",
    "propConfigDes_40023": "多喝几口，想去哪儿就去哪儿。\\n「用于移动力补充，使用后可获得100移动力」",
    "propConfigDes_40024": "一将功成万骨枯的骨。\\n「用于领地建设」",
    "propConfigDes_40025": "朽木也可雕的木。\\n「用于领地建设」",
    "propConfigDes_40026": "龙鳞，标准的龙鳞。\\n「用于领地建设」",
    "propConfigDes_40027": "自称搬砖的通常都是那些不用搬砖的，真正搬砖砌墙的都在默默干活，例如战纹碎片。\\n「用于战墙加固」",
    "messageInitContent_3523": "好的好的",
    "propConfigDes_40028": "由射中斗技场主管稻草人膝盖的箭头熔炼而成，极具纪念价值，寓意不要停下来（拔刀相向）。\\n「用于斗技场商店兑换」",
    "messageInitContent_3524": "想要干饭",
    "propConfigDes_40029": "谜一样的物质你叫我怎么描述？(￣_,￣ )\\n我唯一知道的是可以在谜之巢穴→暴走旷野→中央的谜宝中获取！\\n「用于谜之生物古基因升级」",
    "messageInitContent_3525": "饱满",
    "messageInitNick_10598": "智商又上线",
    "messageInitContent_3526": "爷大锤",
    "messageInitNick_10599": "撸猫观察员",
    "messageInitContent_3527": "锤大爷",
    "messageInitContent_3528": "oioi",
    "messageInitContent_3529": "我的攻击力啊！",
    "messageInitNick_10592": "黑暗狙击手",
    "messageInitNick_3199": "欢歌笑语",
    "messageInitNick_10593": "肥皂盒毁灭者",
    "messageInitNick_3198": "忧郁的榨菜果",
    "messageInitNick_10590": "大翅膀的蜜蜂",
    "messageInitNick_3197": "不是哥的饭",
    "messageInitNick_10591": "支棱起来啊",
    "messageInitNick_3196": "半盏孤灯",
    "messageInitContent_3530": "笑容消失了",
    "messageInitNick_10596": "书籍的故事",
    "messageInitContent_3531": "这么厉害啊",
    "messageInitNick_10597": "逗你玩儿",
    "messageInitContent_3532": "帅哥在此",
    "messageInitNick_10594": "走音鉴定家",
    "messageInitContent_3533": "弹射下一关",
    "messageInitNick_10595": "广东蟑螂",
    "propConfigDes_40030": "漆黑之根渴望已久的能源，被触碰然后吸吮殆尽。\\n「用于黑暗森林漆黑之根能力提升」",
    "propConfigDes_40031": "进入黑暗森林，总得探索点什么。\\n「用于黑暗森林探索」",
    "propConfigDes_40032": "到起源殿参观可以看见它们，到起源殿战斗则可以获得它们。\\n「用于起源殿商店兑换」",
    "propConfigDes_40033": "铸造部落币的目的正是——为了联……合各个部落。刚刚是谁喊联盟的？\\n「用于部落商店兑换」",
    "propConfigDes_40034": "见战令如见酋长，直接开打。\\n「用于部落各种挑战」",
    "propConfigDes_40035": "一种水不出来的经验，但回响里好像水也不少( •̀ ω •́ ) \\n「用于世界回响等级提升」",
    "propConfigDes_40036": "随机召唤一只祖龙族幼体怪兽。",
    "propConfigDes_40037": "随机召唤一只祖龙族幻化怪兽。",
    "propConfigDes_40038": "随机召唤一只祖龙族究极怪兽。",
    "messageInitContent_3534": "！555555555",
    "messageInitNick_3191": "无效并破坏",
    "propConfigDes_40039": "随机召唤一只祖龙族不朽怪兽。",
    "messageInitContent_3535": "！66666666",
    "messageInitNick_3190": "一瞬间的火花",
    "messageInitContent_3536": "海对面的朋友",
    "messageInitContent_3537": "山顶的朋友你们好吗",
    "hintName_2003": "野生怪兽",
    "messageInitContent_3538": "海底的朋友你们好吗",
    "messageInitNick_3195": "快乐的小肥羊",
    "hintName_2004": "深渊先遣",
    "messageInitContent_3539": "究极四保一",
    "messageInitNick_3194": "疯了的圆规",
    "hintName_2001": "异象",
    "messageInitNick_3193": "连续的奇迹",
    "hintName_2002": "狩猎",
    "messageInitNick_3192": "心里有点数",
    "messageInitNick_3188": "运气对轰",
    "messageInitNick_3187": "深思熟虑先生",
    "hintName_2005": "世界灾厄",
    "messageInitNick_3186": "自我安慰师",
    "messageInitContent_3540": "可以换我上吗",
    "messageInitNick_3185": "智能八角",
    "messageInitContent_3541": "恨呐",
    "messageInitContent_3542": "羡慕妒忌",
    "messageInitContent_3543": "不如",
    "messageInitContent_3544": "这该不会是易容的吧",
    "messageInitNick_3189": "土豆射手",
    "propConfigDes_40040": "随机召唤一只尸鬼族幼体怪兽。",
    "propConfigDes_40041": "随机召唤一只尸鬼族幻化怪兽。",
    "propConfigDes_40042": "随机召唤一只尸鬼族究极怪兽。",
    "propConfigDes_40043": "随机召唤一只尸鬼族不朽怪兽。",
    "propConfigDes_40044": "随机召唤一只星灵族幼体怪兽。",
    "propConfigDes_40045": "随机召唤一只星灵族幻化怪兽。",
    "propConfigDes_40046": "随机召唤一只星灵族究极怪兽。",
    "propConfigDes_40047": "随机召唤一只星灵族不朽怪兽。",
    "propConfigDes_40048": "随机召唤一只木偶族幼体怪兽。",
    "propConfigDes_40049": "随机召唤一只木偶族幻化怪兽。",
    "messageInitContent_3545": "在下银花婆婆",
    "messageInitNick_10578": "种花的邮差",
    "messageInitNick_3180": "年度人物",
    "messageInitContent_3546": "吃我一拐",
    "messageInitNick_10579": "菜炒饭",
    "messageInitContent_3547": "这明明是紫衣星烁",
    "messageInitNick_10576": "这个陨石送你",
    "messageInitContent_3548": "又要修剪修剪了",
    "messageInitNick_10577": "微光少女",
    "messageInitContent_3549": "星之所愿",
    "messageInitNick_3184": "蒜先锋",
    "messageInitNick_3183": "太阳是我捏的",
    "messageInitNick_3182": "无需多言",
    "messageInitNick_3181": "太阳",
    "messageInitNick_10570": "我是男网红",
    "messageInitNick_3177": "心理咨询师",
    "messageInitNick_10571": "二手货",
    "messageInitNick_3176": "出逃鳄鱼",
    "messageInitContent_3550": "御星而行",
    "messageInitNick_3175": "无公害石榴",
    "messageInitContent_3551": "我先唱",
    "messageInitNick_3174": "明明很搞",
    "messageInitContent_3552": "我再唱",
    "messageInitNick_10574": "全息水果沙拉",
    "messageInitContent_3553": "看我铁血丹心",
    "messageInitNick_10575": "菜花先锋",
    "messageInitContent_3554": "狐狸就是爱骗人的动物",
    "messageInitNick_10572": "脱单片眼睛",
    "messageInitNick_3179": "失落的心情",
    "messageInitContent_3555": "想喝酸梅汤",
    "messageInitNick_10573": "叽叽喳喳",
    "messageInitNick_3178": "迷路的髌骨",
    "propConfigDes_40050": "随机召唤一只木偶族究极怪兽。",
    "propConfigDes_40051": "随机召唤一只木偶族不朽怪兽。",
    "propConfigDes_40052": "随机召唤一只原生族幼体怪兽。",
    "propConfigDes_40053": "随机召唤一只原生族幻化怪兽。",
    "propConfigDes_40054": "随机召唤一只原生族究极怪兽。",
    "propConfigDes_40055": "随机召唤一只原生族不朽怪兽。",
    "propConfigDes_40056": "随机召唤一只原生族觉醒怪兽。",
    "propConfigDes_40057": "随机召唤一只祖龙族觉醒怪兽。",
    "propConfigDes_40058": "随机召唤一只尸鬼族觉醒怪兽。",
    "propConfigDes_40059": "随机召唤一只星灵族觉醒怪兽。",
    "messageInitContent_3556": "好大只鸭子",
    "messageInitNick_10589": "等风说晚安",
    "messageInitContent_3557": "别踩了别踩了",
    "messageInitContent_3558": "我不好吃",
    "messageInitNick_10587": "热情在燃烧",
    "messageInitContent_3559": "御草而行",
    "messageInitNick_10588": "这个年龄的你",
    "messageInitNick_3173": "帮葡萄带货",
    "messageInitNick_3172": "量子活页纸",
    "messageInitNick_3171": "素三明治",
    "messageInitNick_3170": "橙子魔法",
    "messageInitNick_10581": "鼠标乱动",
    "messageInitNick_3166": "哥霸气内敛",
    "messageInitContent_3560": "皮匠是找到新老板了吗",
    "messageInitNick_10582": "大叔您真逗",
    "messageInitNick_3165": "爱你的胆小鬼",
    "messageInitContent_3561": "吃我一拳",
    "messageInitNick_3164": "末日拉肠",
    "messageInitContent_3562": "当2秒废物",
    "messageInitNick_10580": "欧气重置",
    "messageInitNick_3163": "不明爬行物",
    "messageInitContent_3563": "情绪很稳定",
    "messageInitNick_10585": "超级饼干",
    "messageInitContent_3564": "降龙十八掌传人在此",
    "messageInitNick_10586": "直视我弟弟",
    "messageInitNick_3169": "暮光倾城",
    "messageInitContent_3565": "上岸！",
    "messageInitNick_10583": "穿墙的猫",
    "messageInitNick_3168": "猫猫女仆",
    "messageInitContent_3566": "整个皮肤吧",
    "messageInitNick_10584": "智能跑步机",
    "messageInitNick_3167": "九宫格",
    "propConfigDes_40060": "随机召唤一只木偶族觉醒怪兽。",
    "propConfigDes_40061": "一种撕页状生物钟，一撕又一天。\\n「用于永生之茧刷新」",
    "propConfigDes_40062": "一种用于刺激永生之茧奖励神经的物质，一触即开。\\n「用于永生之茧挑战」",
    "propConfigDes_40063": "超进化大陆动物保护协会权威认证，快捷安全又舒适。\\n「用于提升捕捉野生怪兽的成功率」",
    "randomEventDialogueGroupConfig_7.160": "忍道，那是什么？",
    "randomEventDialogueGroupConfig_7.161": "说忍着不打它",
    "randomEventDialogueGroupConfig_7.162": "说忍着不买东西",
    "randomEventDialogueGroupConfig_7.163": "它脸色一变，立刻撒腿跑了。",
    "randomEventDialogueGroupConfig_7.164": "离开",
    "messageInitNick_3162": "不羁的灵魂",
    "randomEventDialogueGroupConfig_7.165": "那你需要面对更大的诱惑，进店试试吧！",
    "messageInitNick_3161": "临渊羡鱼",
    "randomEventDialogueGroupConfig_7.166": "进店",
    "messageInitNick_3160": "智能蒜头",
    "randomEventDialogueGroupConfig_7.167": "拒绝",
    "randomEventDialogueGroupConfig_7.168": "为什么要拒绝？这可是武功秘籍，共有接、化、发三大部！#连着翻还能看到绝技，闪电三连鞭！",
    "messageInitNick_3155": "路人甲乙丙",
    "randomEventDialogueGroupConfig_7.169": "表示全世界都知道的就不是秘籍了",
    "messageInitNick_3154": "高冷界扛把子",
    "messageInitNick_3153": "贝多芬的悲伤",
    "messageInitNick_3152": "云玩家来了",
    "messageInitNick_3159": "硬顶的你",
    "messageInitNick_3158": "酸酸酸酸柠檬",
    "messageInitNick_3157": "月亮凑过来听",
    "messageInitNick_3156": "蛋黄馅月饼",
    "randomEventDialogueGroupConfig_7.170": "拒绝回答离开",
    "randomEventDialogueGroupConfig_7.171": "那就来练练手？",
    "randomEventDialogueGroupConfig_7.172": "练手",
    "messageInitNick_3151": "红毛丹兽",
    "messageInitNick_3150": "画饼神",
    "messageInitNick_3144": "别怕有我哥",
    "messageInitNick_3143": "墓中无人",
    "messageInitNick_3142": "毛豆术士",
    "messageInitNick_3141": "黑色星期六",
    "messageInitNick_3148": "泡面侦探",
    "messageInitNick_3147": "节奏专家",
    "messageInitNick_3146": "沉浸式烹饪",
    "messageInitNick_3145": "下课铃响了",
    "messageInitNick_3149": "又是薰衣草味",
    "propConfigDes_40001": "一种能引起各种不切实际想象的小金块，例如，要是有这么多的金币，我该怎么花好呢？\\n「用途广泛你懂的」",
    "propConfigDes_40002": "来自探索者想象，充满超能力的宝石。\\n「用于恒久远和永流传」",
    "propConfigDes_40003": "让你想去哪儿就去哪儿，据统计在超进化大陆需要使用移动力的地方全部集中在世界，交几个朋友进行联结共鸣就可以实现移动力自由！\\n「用于世界移动和挑战」",
    "propConfigDes_40004": "探索者的认知随着经验的积累持续校准，在真实附近摇摆，或逐步逼近，或逐渐偏离。\\n「用于探索者等级提升」",
    "propConfigDes_40005": "这种经验无法通过灌水获得，但通过汗水或许可以。\\n「用于怪兽等级提升」",
    "propConfigDes_40006": "一个展现是活的，而且还很跳的指标，与含盐量呈负相关。",
    "propConfigDes_40007": "怪兽留在你身边的另一种形式。\\n「用于饲星商店兑换」",
    "propConfigDes_40008": "是怪兽都爱它！除了那些没有技能的……\\n「用于觉醒怪兽技能等级提升」",
    "propConfigDes_40009": "假如进化有颜色，那一定是……\\n假如进化孢子有颜色，那一定是……\\n「用于怪兽进化」",
    "messageInitNick_3140": "人类观察员",
    "messageInitNick_3133": "超级走音神",
    "messageInitNick_5796": "偏爱自由",
    "messageInitNick_3132": "常悠哉大王",
    "messageInitNick_5797": "淡然忆琉璃",
    "messageInitNick_3131": "手持大棍",
    "messageInitNick_5798": "朕带你打天下",
    "messageInitNick_3130": "记录的机器",
    "messageInitNick_5799": "莫比乌斯圈",
    "messageInitNick_3137": "短腿猪",
    "messageInitNick_5792": "傲娇的小碎步",
    "messageInitNick_3136": "菠萝爱好者",
    "messageInitNick_5793": "难逢你知心",
    "messageInitNick_3135": "雪花飘飘飘",
    "messageInitNick_5794": "江湖有姐妹",
    "messageInitNick_3134": "抱只软猫咪",
    "messageInitNick_5795": "喝醉的毛毛虫",
    "messageInitNick_3139": "生图勇者",
    "messageInitNick_3138": "捏捏小肥脸",
    "propConfigDes_40010": "一种让怪兽变大变小、变长、变强的孢子，有辣有不辣！\\n「用于怪兽基因强化」",
    "propConfigDes_40011": "赋予神灵神性的发光孢子，同时也是上好的照明用品。\\n「用于神灵升阶」",
    "propConfigDes_40012": "纠缠许可",
    "propConfigDes_40013": "进击许可",
    "propConfigDes_40014": "天选许可",
    "propConfigDes_40015": "圣光许可",
    "propConfigDes_40016": "听说主动“搜索”总比被动“推送”来得好一些。\\n「用于狩猎搜索」",
    "propConfigDes_40017": "我来，我建，我征服。\\n支配核心中捐献可获得。\\n「用于部落战增益开启、遗迹宣战和支配核心升级」",
    "propConfigDes_40018": "能与怪兽领域产生共鸣的神奇石头，别名敲门砖。\\n「用于觉醒怪兽领域副本挑战」",
    "messageInitNick_5790": "特长理发",
    "propConfigDes_40019": "羽化登仙，极化造极。注意是极化/石，不是极/化石哦。\\n「用于觉醒怪兽极化」",
    "messageInitNick_5791": "呆萌先生",
    "messageInitNick_3122": "高效发电",
    "messageInitNick_5785": "爱在夜里翻滚",
    "messageInitNick_3121": "没猫病",
    "messageInitNick_5786": "最强文件袋",
    "messageInitNick_3120": "独守夜空",
    "messageInitNick_5787": "自己的原因",
    "messageInitNick_5788": "不要入戏太深",
    "messageInitNick_3126": "平庸大师",
    "messageInitNick_5781": "尖叫萝卜",
    "messageInitNick_3125": "三千战两千五",
    "messageInitNick_5782": "菜花真好吃",
    "messageInitNick_3124": "跨球场射篮",
    "messageInitNick_5783": "孜然我的超人",
    "messageInitNick_3123": "爱情傀儡",
    "messageInitNick_5784": "雨滴在唱歌",
    "messageInitNick_3129": "撕开薯片的龙",
    "messageInitNick_3128": "不用管他",
    "messageInitNick_3127": "菜鸡战斗鸡",
    "messageInitNick_5789": "自制冬瓜条",
    "messageInitNick_5780": "国际美男",
    "randomEventDialogueGroupConfig_7.120": "哎呀，什么利用嘛，说得这么难听，这是友谊，朋友之间也是进行着非实物的利益交换的嘛，不是吗。",
    "randomEventDialogueGroupConfig_7.121": "说这就是它交不到朋友的原因",
    "randomEventDialogueGroupConfig_7.122": "这个我倒是听过了，没意思。你要不要来我店里看看算了。",
    "randomEventDialogueGroupConfig_7.123": "它的脸上闪过一丝失望，但很快就的很热情地招呼你去它的店里。",
    "randomEventDialogueGroupConfig_7.124": "转身离开",
    "messageInitNick_3111": "他给的太多了",
    "messageInitNick_5774": "沙漠厨师",
    "randomEventDialogueGroupConfig_7.125": "进店逛逛",
    "messageInitNick_3110": "精简生活",
    "messageInitNick_5775": "无效吃饭",
    "randomEventDialogueGroupConfig_7.126": "我也没想要交朋友哼，你不要用交朋友的思维教我做生意，我想做生意！你要不要来呀？",
    "messageInitNick_5776": "尖叫茄子",
    "randomEventDialogueGroupConfig_7.127": "交易",
    "messageInitNick_5777": "林空鹿饮溪",
    "randomEventDialogueGroupConfig_7.128": "拒绝交易",
    "messageInitNick_3115": "一丢丢可爱",
    "messageInitNick_5770": "六点的凉茶",
    "randomEventDialogueGroupConfig_7.129": "噢，非常好，我最喜欢陪人家这个的了。请~",
    "messageInitNick_3114": "持续吃饭",
    "messageInitNick_5771": "老太婆进被窝",
    "messageInitNick_3113": "懒癌晚期",
    "messageInitNick_5772": "程序创造者",
    "messageInitNick_3112": "地狱无厘头",
    "messageInitNick_5773": "沙拉酱有点皮",
    "messageInitNick_3119": "不讨好型人格",
    "messageInitNick_3118": "够讲究",
    "messageInitNick_3117": "此时风月旧",
    "messageInitNick_3116": "饺子侦探",
    "messageInitNick_5778": "临时嘉宾",
    "messageInitNick_5779": "专业对线",
    "randomEventDialogueGroupConfig_7.130": "交易",
    "randomEventDialogueGroupConfig_7.131": "算了算了不免强你。拜拜。",
    "randomEventDialogueGroupConfig_7.132": "告别",
    "randomEventDialogueGroupConfig_7.133": "我这里有一本能让你变强的武功秘籍，只要你到我店里买东西，就可以免费赠与你。如何？",
    "randomEventDialogueGroupConfig_7.134": "同意",
    "randomEventDialogueGroupConfig_7.135": "拒绝",
    "messageInitNick_3100": "你也是三千防",
    "messageInitNick_5763": "树上的咸鱼",
    "randomEventDialogueGroupConfig_7.136": "锻炼买东西的眼光我倒是可以陪陪你，普通的锻炼身体挥洒汗水就恕不奉陪了。",
    "messageInitNick_5764": "五手三寄",
    "randomEventDialogueGroupConfig_7.137": "硬要它陪",
    "messageInitNick_5765": "梨射手",
    "randomEventDialogueGroupConfig_7.138": "去锻炼眼光",
    "messageInitNick_5766": "喋血影魔",
    "randomEventDialogueGroupConfig_7.139": "赔你，好呀，大家都知道，我的商店是很难进去的。#就赔你一个进我商店逛逛的机会吧！",
    "messageInitNick_3104": "霸道的温柔",
    "messageInitNick_3103": "吃啥啥不剩",
    "messageInitNick_5760": "桔梗花的海洋",
    "messageInitNick_3102": "声优不是角色",
    "messageInitNick_5761": "恶魔造梦者",
    "messageInitNick_3101": "速度与情人",
    "messageInitNick_5762": "有点小情绪",
    "messageInitNick_3108": "你还是个孩子",
    "messageInitNick_3107": "快看牛星雨",
    "messageInitNick_3106": "潮男情歌",
    "messageInitNick_3105": "吃兔兔",
    "messageInitNick_5767": "茄子猎手",
    "messageInitNick_5768": "海岸线",
    "messageInitNick_5769": "张嘴喂你",
    "messageInitNick_3109": "噩梦魔法",
    "randomEventDialogueGroupConfig_7.140": "说它撒谎",
    "randomEventDialogueGroupConfig_7.141": "进店逛逛",
    "randomEventDialogueGroupConfig_7.142": "你有什么证据证明我说谎了。",
    "randomEventDialogueGroupConfig_7.143": "转身离开",
    "randomEventDialogueGroupConfig_7.144": "说上次就被骗过",
    "randomEventDialogueGroupConfig_7.145": "诶，别走嘛，你不是让我赔的嘛，我的商店里面真的不少好东西的，不去很可惜的呢。",
    "randomEventDialogueGroupConfig_7.146": "继续离开",
    "messageInitNick_5752": "茄汁蛋包饭",
    "randomEventDialogueGroupConfig_7.147": "它快步跟上你。",
    "messageInitNick_5753": "巧克力麦克风",
    "randomEventDialogueGroupConfig_7.148": "要不给个优惠你？大优惠哦！",
    "messageInitNick_5754": "张嘴就来",
    "randomEventDialogueGroupConfig_7.149": "妥协进店",
    "messageInitNick_5755": "猫猫都摇头",
    "messageInitNick_5750": "宇宙仙女",
    "messageInitNick_5751": "六点的饺子",
    "messageInitNick_5756": "可爱的泥鳅",
    "messageInitNick_5757": "犯二的小痞子",
    "messageInitNick_5758": "强力染色",
    "messageInitNick_5759": "喜欢咬吸管",
    "randomEventDialogueGroupConfig_7.150": "快步离开",
    "randomEventDialogueGroupConfig_7.151": "它叫了几声，就不再追上来了。",
    "randomEventDialogueGroupConfig_7.152": "离开",
    "randomEventDialogueGroupConfig_7.153": "现在轮到你骗我了吗？",
    "randomEventDialogueGroupConfig_7.154": "说它露馅了",
    "randomEventDialogueGroupConfig_7.155": "可恶，我就不赔。",
    "randomEventDialogueGroupConfig_7.156": "打它",
    "randomEventDialogueGroupConfig_7.157": "放过它",
    "messageInitNick_5741": "不会过马路",
    "randomEventDialogueGroupConfig_7.158": "这就是我的商道！",
    "messageInitNick_5742": "浪漫野人",
    "randomEventDialogueGroupConfig_7.159": "说这就是我的忍道",
    "messageInitNick_5743": "火龙果兽",
    "messageInitNick_5744": "满脸写着无敌",
    "messageInitNick_5740": "说唱不是医美",
    "messageInitNick_5749": "沉浸式夜跑",
    "messageInitNick_5745": "改变世界的龙",
    "messageInitNick_5746": "花一样的少女",
    "messageInitNick_5747": "橙子真好吃",
    "messageInitNick_5748": "豆角兽",
    "tribeNodeConfigName_30": "冒险关卡30",
    "messageInitNick_5730": "咖啡机之彼端",
    "tribeNodeConfigName_24": "冒险关卡24",
    "messageInitNick_5731": "帮你撑伞",
    "tribeNodeConfigName_25": "冒险关卡25",
    "messageInitNick_5732": "菠萝魔法师",
    "tribeNodeConfigName_26": "冒险关卡26",
    "messageInitNick_5733": "芭蕉爱好者",
    "tribeNodeConfigName_27": "冒险关卡27",
    "tribeNodeConfigName_20": "冒险关卡20",
    "tribeNodeConfigName_21": "冒险关卡21",
    "tribeNodeConfigName_22": "冒险关卡22",
    "tribeNodeConfigName_23": "冒险关卡23",
    "messageInitNick_5738": "明年约会",
    "messageInitNick_5739": "小小的香香的",
    "messageInitNick_5734": "高姿态的男人",
    "tribeNodeConfigName_28": "冒险关卡28",
    "messageInitNick_5735": "方糖有点皮",
    "tribeNodeConfigName_29": "冒险关卡29",
    "messageInitNick_5736": "赤面仙子",
    "messageInitNick_5737": "笨瓜",
    "iapBuyConfigName_1803": "幸运进阶III",
    "iapBuyConfigName_1801": "幸运进阶I",
    "iapBuyConfigName_1802": "幸运进阶II",
    "tribeNodeConfigName_13": "冒险关卡13",
    "messageInitNick_5720": "大眼萌妹",
    "tribeNodeConfigName_14": "冒险关卡14",
    "4_2142|L": "等级提升",
    "messageInitNick_5721": "菠菜之心",
    "tribeNodeConfigName_15": "冒险关卡15",
    "messageInitNick_5722": "无敌咕咕神",
    "tribeNodeConfigName_16": "冒险关卡16",
    "tribeNodeConfigName_10": "冒险关卡10",
    "tribeNodeConfigName_11": "冒险关卡11",
    "tribeNodeConfigName_12": "冒险关卡12",
    "messageInitNick_5727": "下辈子退休",
    "messageInitNick_5728": "你不在的饭堂",
    "messageInitNick_5729": "苹果爱好者",
    "messageInitNick_5723": "待绝笔墨痕干",
    "tribeNodeConfigName_17": "冒险关卡17",
    "messageInitNick_5724": "烧麦射手",
    "tribeNodeConfigName_18": "冒险关卡18",
    "messageInitNick_5725": "抱紧意中人",
    "tribeNodeConfigName_19": "冒险关卡19",
    "messageInitNick_5726": "我破防了",
    "messageInitNick_5710": "大掌门",
    "messageInitNick_5711": "吃瓜少女",
    "messageInitNick_5716": "静听一季花开",
    "messageInitNick_5717": "甩锅高手",
    "messageInitNick_5718": "断桥红颜醉",
    "messageInitNick_5719": "最爱菠菜",
    "messageInitNick_5712": "人傲脾气大",
    "messageInitNick_5713": "维持现状",
    "messageInitNick_5714": "智慧的眼神",
    "messageInitNick_5715": "五点的凉粉",
    "messageInitNick_5709": "早上吃通菜",
    "messageInitNick_5700": "红毯小美",
    "messageInitNick_5705": "爆米花的芳香",
    "messageInitNick_5706": "拖着疲倦的心",
    "messageInitNick_5707": "智能蒸蛋器",
    "messageInitNick_5708": "奇想空调",
    "messageInitNick_5701": "可再生牙签",
    "messageInitNick_5702": "单纯美妞",
    "messageInitNick_5703": "黑凤梨",
    "messageInitNick_5704": "欧巴多啦诶梦",
    "tribeNodeConfigName_71": "海螺遗迹6",
    "tribeNodeConfigName_72": "海螺遗迹7",
    "tribeNodeConfigName_73": "海螺遗迹8",
    "tribeNodeConfigName_74": "海螺遗迹9",
    "tribeNodeConfigName_70": "海螺遗迹5",
    "tribeNodeConfigName_68": "海螺遗迹3",
    "tribeNodeConfigName_69": "海螺遗迹4",
    "tribeNodeConfigName_64": "骇鸟遗迹",
    "tribeNodeConfigName_65": "狂龙遗迹",
    "tribeNodeConfigName_66": "海螺遗迹1",
    "tribeNodeConfigName_67": "海螺遗迹2",
    "tribeNodeConfigName_60": "灵能图腾",
    "tribeNodeConfigName_61": "海螺遗迹",
    "tribeNodeConfigName_62": "巨鲸遗迹",
    "tribeNodeConfigName_63": "古兽遗迹",
    "tribeNodeConfigName_57": "铁甲图腾",
    "tribeNodeConfigName_58": "增益图腾",
    "tribeNodeConfigName_59": "抑制图腾",
    "22_2088|L": "复制体掉落",
    "tribeNodeConfigName_53": "真实图腾",
    "tribeNodeConfigName_54": "庇护图腾",
    "tribeNodeConfigName_55": "强击图腾",
    "tribeNodeConfigName_56": "治愈图腾",
    "unlockDes_29": "通过超进化选召计划活动获得",
    "unlockDes_23": "好友数达{1}",
    "tribeNodeConfigName_50": "冒险关卡50",
    "unlockDes_24": "战墙大型战纹点亮数达{1}",
    "tribeNodeConfigName_51": "天使图腾",
    "unlockDes_21": "永生之茧通关{1}个一次性关卡",
    "tribeNodeConfigName_52": "狙击图腾",
    "unlockDes_22": "单次暴走旷野中击破数达{1}",
    "unlockDes_27": "通过蜕变契约获得",
    "unlockDes_28": "通过创世商店获得",
    "unlockDes_25": "图鉴怪兽收集数达{1}",
    "unlockDes_26": "通过首充礼包获得",
    "tribeNodeConfigName_46": "冒险关卡46",
    "tribeNodeConfigName_47": "冒险关卡47",
    "tribeNodeConfigName_48": "冒险关卡48",
    "tribeNodeConfigName_49": "冒险关卡49",
    "tribeNodeConfigName_42": "冒险关卡42",
    "tribeNodeConfigName_43": "冒险关卡43",
    "unlockDes_20": "一发入欧店好感度达{1}",
    "tribeNodeConfigName_44": "冒险关卡44",
    "tribeNodeConfigName_45": "冒险关卡45",
    "unlockDes_18": "世界灾厄排行{1}",
    "unlockDes_19": "造唤十次时获得的觉醒怪兽数达{1}",
    "unlockDes_12": "部落之王周期结算时排行{1}",
    "unlockDes_13": "凿星裂痕周期结算时排行{1}",
    "tribeNodeConfigName_40": "冒险关卡40",
    "unlockDes_10": "单次暴走旷野中选择「差点无敌」增益次数达{1}",
    "tribeNodeConfigName_41": "冒险关卡41",
    "unlockDes_11": "单次暴走旷野中选择「助战怪兽」增益次数达{1}",
    "unlockDes_16": "起源殿周期结算时段位到达{1}",
    "unlockDes_17": "世界探索度{1}%",
    "unlockDes_14": "斗技场周期结算时排行{1}",
    "unlockDes_15": "狩猎周期结算时排行{1}",
    "tribeNodeConfigName_35": "冒险关卡35",
    "tribeNodeConfigName_36": "冒险关卡36",
    "tribeNodeConfigName_37": "冒险关卡37",
    "tribeNodeConfigName_38": "冒险关卡38",
    "tribeNodeConfigName_31": "冒险关卡31",
    "tribeNodeConfigName_32": "冒险关卡32",
    "tribeNodeConfigName_33": "冒险关卡33",
    "tribeNodeConfigName_34": "冒险关卡34",
    "tribeNodeConfigName_39": "冒险关卡39",
    "messageInitContent_3567": "大力",
    "messageInitContent_3568": "开心",
    "messageInitContent_3569": "锤我呀",
    "messageInitContent_3570": "猫猫胖了",
    "messageInitContent_3571": "吃下我这一击你可能会",
    "messageInitContent_3572": "一闪一闪亮晶晶",
    "messageInitContent_3573": "沉思",
    "messageInitContent_3574": "思考下怎么吃肉",
    "messageInitContent_3575": "肉肉山我来啦",
    "messageInitContent_3576": "被山包围了",
    "messageInitContent_3577": "深山老林",
    "messageInitContent_3578": "竹林比武",
    "messageInitContent_3579": "我曾经跨过山和怪兽",
    "messageInitContent_3581": "你你你你你好好好好好好",
    "messageInitContent_3582": "巨龙：别撞我肚脐，谢谢",
    "messageInitContent_3583": "轰龙：为什么不是我，而是暴龙？！",
    "messageInitContent_3584": "小兵器，中兵器，大兵器",
    "messageInitContent_3585": "近战AOEVS远程AOE",
    "tribeNodeConfigName_97": "海螺遗迹32",
    "messageInitContent_3586": "赢的一定是怪兽",
    "tribeNodeConfigName_98": "海螺遗迹33",
    "messageInitContent_3587": "我在明天很想你",
    "tribeNodeConfigName_99": "海螺遗迹34",
    "messageInitContent_3588": "很喜欢兵器，所以我选右边",
    "messageInitContent_3580": "山里的怪兽",
    "messageInitContent_3589": "别在这理发店",
    "tribeNodeConfigName_93": "海螺遗迹28",
    "tribeNodeConfigName_94": "海螺遗迹29",
    "tribeNodeConfigName_95": "海螺遗迹30",
    "tribeNodeConfigName_96": "海螺遗迹31",
    "tribeNodeConfigName_90": "海螺遗迹25",
    "tribeNodeConfigName_91": "海螺遗迹26",
    "tribeNodeConfigName_92": "海螺遗迹27",
    "messageInitContent_3592": "我现在就要知道答案",
    "messageInitContent_3593": "我的猫选了左边",
    "messageInitContent_3594": "右手螺旋定则",
    "messageInitContent_3595": "好哇策划",
    "messageInitContent_3596": "猪脑过载",
    "tribeNodeConfigName_86": "海螺遗迹21",
    "messageInitContent_3597": "好大个音响",
    "tribeNodeConfigName_87": "海螺遗迹22",
    "messageInitContent_3598": "_(┐「ε:)_  _(┐「ε:)_  _(┐「ε:)_  ",
    "tribeNodeConfigName_88": "海螺遗迹23",
    "messageInitContent_3599": "_(:3 」∠)_ _(:3 」∠)_ ",
    "tribeNodeConfigName_89": "海螺遗迹24",
    "messageInitContent_3590": "我是穿越回来的，4只怪那边赢了",
    "messageInitContent_3591": "私我告诉你的答案",
    "tribeNodeConfigName_82": "海螺遗迹17",
    "tribeNodeConfigName_83": "海螺遗迹18",
    "tribeNodeConfigName_84": "海螺遗迹19",
    "tribeNodeConfigName_85": "海螺遗迹20",
    "tribeNodeConfigName_80": "海螺遗迹15",
    "tribeNodeConfigName_81": "海螺遗迹16",
    "tribeNodeConfigName_79": "海螺遗迹14",
    "tribeNodeConfigName_75": "海螺遗迹10",
    "tribeNodeConfigName_76": "海螺遗迹11",
    "tribeNodeConfigName_77": "海螺遗迹12",
    "tribeNodeConfigName_78": "海螺遗迹13",
    "messageInitNick_10518": "粽子选手",
    "messageInitNick_10519": "跳出天堂",
    "messageInitNick_10512": "高调转身",
    "messageInitNick_10513": "机场扛把子",
    "messageInitNick_10510": "柿子真好吃",
    "messageInitNick_10511": "流浪天堂",
    "messageInitNick_10516": "大班复读",
    "messageInitNick_10517": "低调男孩",
    "messageInitNick_10514": "天天打酱油",
    "messageInitNick_10515": "无公害李子",
    "messageInitNick_10529": "暴风雨巨人",
    "messageInitNick_10523": "狂飙的鸽子",
    "messageInitNick_10524": "渐成斗士",
    "messageInitNick_10521": "寒江独钓",
    "messageInitNick_10522": "卖鱼强",
    "messageInitNick_10527": "非诚勿扰民",
    "messageInitNick_10528": "六眼飞鱼酱",
    "messageInitNick_10525": "永远正直",
    "messageInitNick_10526": "那种自信",
    "messageInitNick_10520": "相机里的倒影",
    "20_1012": "恭喜，看到这个界面意味着你通过了首次筛选，进化通道没有被锁死。\\n屏幕中的这只怪兽将会是你进化之后的姿态，真是令人怀念。\\n越往顶端走，进化时就拥有越多的可能性，我有预感，|c在不久的将来你将会面临非常多的进化选择|c。\\n什么是好的选择？\\n追随内心抵达自己渴望的蜕变即可。\\n真想亲眼见证那一刻……\\n进化，然后继续GO吧！",
    "20_1011": "|c「进化」|c意味着变化……这真是一句废话，直观上的变化包括|c属性的提升|c和|c领悟新的技能|c。\\n深层次的变化则各不相同……\\n尝试进化前，先提升一下等级让身体做好准备。\\n然后一口吞下所有的绿光。\\n放心，目前还没有怪兽被「进化孢子」噎死的记录。\\n但是否能进化成功，取决于……你……有没踩着主角光环。",
    "20_1014": "骨，木，鳞？\\n从未见过的|c资源|c，但我却清楚知道它们|c用于「领地」的建造|c。\\n世界核心？……世界核心！\\n是因为「你」曾经触碰过世界核心吗！",
    "20_1013": "？？！\\n这竟然是|c有2波守关怪兽的据点|c，本应在后期出现的据点为什么会出现在这里，到底发生了什么……\\n探索者，小心！\\n这个据点的战斗还没结束，必须|c把所有守关怪兽都击败|c才能占领这个据点。",
    "20_1016": "先把……中心的高塔建起来吧……\\n那是领……地的核心……支撑着其他的建筑，代表了更多的可能。\\n难道这就是……过去缺失的突破口？\\n到底是……谁在……用我的嘴……说话！",
    "20_1015": "马上就……能见到你……的领……地了……我的身体……|c嘴|c……怎么……回事？",
    "20_1018": "说「生产建筑」好像有点抽象，|c造一下|c就明白了。",
    "20_1017": "这领地不拿去煲汤真有点浪费。\\n接下来要建造的，是|c领地里重要的生产建筑——「造唤台」|c。\\n因为它，领地才能生生不息。",
    "20_1019": "呼……\\n那么，我要开始崩坏了，现在开始。\\n虽然按照原计划，我应该给予你更多的指引，直到你熟知这个世界。\\n抱歉，我应该更早发现你跟「计划」不一样才对。\\n如果我继续存在，大概只会阻止你向前。\\n那么，\\nBYE！\\n等等，回来！虽然我崩坏了，但嘴还在，你|c可以在右上角联系它（-口-）|c\\n请一定不要在最后一次进化前止步，我的嘴与你同在|c（右上角）|c。",
    "messageInitNick_10509": "素颜很美",
    "messageInitNick_10507": "薄荷味的初夏",
    "messageInitNick_10508": "美得抽象",
    "messageInitNick_10501": "打小就酷",
    "messageInitNick_10502": "熬夜亚军",
    "messageInitNick_10500": "草莓果酱",
    "messageInitNick_10505": "爱懒猪",
    "messageInitNick_10506": "肥皂盒狂怒者",
    "20_1010": "前面的据点散发着一股异样的气息……\\n这次它的筛选提前开始了？！\\n进化的要素还没有齐备，从未遇过的状况。\\n探索者，我必须如实告诉你，接下来你面对的是不一定能成功的进化。\\n在这被称为SCHRODINGER'S EVO。",
    "messageInitNick_10503": "共饮孟婆汤",
    "messageInitNick_10504": "狂飙的海豚",
    "20_1001": "又要开始了吗？\\n重启……一次又一次！\\n探索者，我知道你也很想吐槽。\\n但还是出发吧，毕竟这次可能不一样。（毕竟TIME IS MONEY FRIEND！）",
    "20_1003": "叉叉反着飞出了屏幕。\\n叉叉留下了很大一坨通关奖励。\\n叉叉还把它仅有的据点送给了你。\\n|c据点占领后会持续为你产生收益|c，可以手动在|c「星律」|c处收取。\\nVERY……VERY FAST！没想到，你许愿的速度这么快！",
    "20_1002": "是叉叉，一位深不可测的对手。\\n试着在碰上它的瞬间出手，当然它也是这么想的。\\n所以，你们在碰上的瞬间就会立刻|c相互推开|c，我们把这种现象称为，力的作用是相互的！哦不，称为|c「霸气击退」|c。\\n在这片大陆，|c霸气越高将对方击退的距离就会越远|c，所以抬头看到天空出现反着飞的流星也不用惊慌（还可以许愿）。",
    "20_1005": "按照过往的经验，工具和队友都能解决旅途中的麻烦，可一旦陷入死胡同……\\n只有队友才会修理你。\\n皮诺丘似乎已经把你当成队友了呢。\\n和它一起挑战下一个据点吧。\\n这该死的FRIENDSHIP！",
    "20_1004": "叉叉留下的那坨首通奖励里，蹦出了一只皮诺丘，它说很欣赏你，加入了你的队伍。\\n并且鼻子上长出了一片长长的叶子。\\n别想太多，不是所有主角都能拣到知心队友的，先上车……|c上阵|c再培养感情才是真缘分。",
    "20_1007": "观察元核的颜色可以得知它的品质（稀有度）。\\n这高贵的灰色一看就知道不可或缺，是组成整个体系的关键……是最小计量单位！\\n元核|c品质越高|c，能容纳的|c词条数就越多|c。\\n快去试试这颗攻击元核的抛瓦吧！",
    "20_1006": "双人成行的胜利！\\n看到那块形状古怪的石头了吗？\\n那是纹……是|c「元核」|c，能为怪兽|c增加属性|c，珍稀的元核还能使怪兽|c获得额外的技能|c，如复活，护盾，自爆等等。\\n怎么配搭？你的思想真是超前……\\n别想太多（我也不懂），先把这新鲜的元核直接塞到……直接装备起来吧！",
    "20_1009": "看得出来，殴打小……咻咻也没让你多享受。\\n还是看看奖励堆里那发着绿光的小东西吧！\\n它，大名鼎鼎的|c「进化孢子」|c，让|c怪兽|c最为疯狂的存在，引发了一次又一次的|c进化|c狂潮。\\n还有一次又一次的……\\n算了，这不是现在应该展开的话题，NEXT！",
    "20_1008": "元核的力量由体内迸发而出（朗诵音）！\\n力量能让我们更接近战斗的胜利。\\n但对力量的合理运用才能让我们享受胜利。\\n比如|c「霸气击退」|c的运用。\\n看到那只躲在锤子背后一脸小夫……脆弱的咻咻了吗？\\n|c利用霸气把前排的锤子击退|c，再趁机|c攻击后面失去保护的咻咻|c，然后ENJOY IT！",
    "messageInitContent_3608": "起猛了",
    "messageInitContent_3609": "大脑失去了响应",
    "themeCardPackName_17020": "绯色片区",
    "messageInitContent_3600": "很忙，再用尺子计算哪边能赢",
    "messageInitNick_10435": "孤独零食",
    "messageInitContent_3601": "？？？",
    "messageInitNick_10436": "心酸比檬",
    "messageInitContent_3602": "我很好",
    "messageInitNick_10433": "肱二头肌魔法",
    "messageInitContent_3603": "出结果喊我",
    "messageInitNick_10434": "红色列车之心",
    "messageInitContent_3604": "前排",
    "messageInitNick_10439": "爆裂魔龙",
    "themeCardPackName_17025": "抢夺",
    "messageInitContent_3605": "各位猴密大噶好",
    "messageInitContent_3606": "那是敌密",
    "messageInitNick_10437": "未命名",
    "messageInitContent_3607": "这很难评",
    "messageInitNick_10438": "狂奔的蜗牛",
    "messageInitNick_10431": "认证套娃专家",
    "messageInitNick_10432": "别逞强了",
    "messageInitContent_3610": "理论上这应该很简单",
    "messageInitNick_10430": "爱不爱一句话",
    "messageInitContent_3619": "给我冲！",
    "themeCardPackName_17010": "饥饿感",
    "messageInitContent_3611": "很外向，竞猜都是随便选",
    "messageInitNick_10446": "洗面奶先锋",
    "messageInitContent_3612": "闭着眼睛都能知道答案",
    "messageInitNick_10447": "月亮挂在树上",
    "messageInitContent_3613": "瞎蒙一个",
    "messageInitNick_10444": "挂号思念",
    "messageInitContent_3614": "必须蓝色方啊",
    "messageInitNick_10445": "大佬看看我",
    "themeCardPackName_17015": "怪瘾",
    "messageInitContent_3615": "蓝色方的跑错游戏了把",
    "messageInitContent_3616": "兵器给我赢！",
    "messageInitContent_3617": "急死我了急死我了！！！！",
    "messageInitNick_10448": "看我的猫吗",
    "messageInitContent_3618": "麻了",
    "messageInitNick_10449": "惊人的恶兽",
    "19_2013": "世界回响等级{1}解锁",
    "19_2012": "领取奖励",
    "19_2011": "宝箱奖励",
    "19_2010": "可领取",
    "messageInitNick_10442": "风扇晕了",
    "messageInitNick_10443": "智能花生酱",
    "messageInitContent_3620": "赢了",
    "messageInitNick_10440": "暴走的火",
    "messageInitContent_3621": "无脑选主角",
    "messageInitNick_10441": "头铁鉴定家",
    "19_2014": "映像",
    "messageInitNick_10419": "柚子兽",
    "themeCardPackName_17040": "有效的",
    "messageInitContent_3622": "需要一个只充电宝龙",
    "messageInitNick_10413": "感到悲伤",
    "messageInitContent_3623": "答案已经告诉我答案了",
    "messageInitNick_10414": "闪光一抽",
    "messageInitContent_3624": "冲鸭我的兵器！",
    "messageInitNick_10411": "洋葱射手",
    "messageInitContent_3625": "我是高达",
    "messageInitNick_10412": "橙子龙",
    "messageInitContent_3626": "2887！",
    "messageInitNick_10417": "请别靠近我",
    "messageInitContent_3627": "冲鸭",
    "messageInitNick_10418": "扮乖少女",
    "messageInitContent_3628": "剑来",
    "messageInitNick_10415": "订阅悲伤",
    "messageInitContent_3629": "击剑？",
    "messageInitNick_10416": "忍不了一点",
    "messageInitNick_3099": "流泪葱头",
    "messageInitNick_3098": "沉浸式打机",
    "messageInitNick_3097": "图一乐",
    "messageInitContent_3630": "我数了左边8把剑，右边11把，8<11，右赢",
    "messageInitNick_10410": "治愈系萝卜",
    "messageInitContent_3631": "我掐指一算……别阻止我泄露天机，赢的是……",
    "messageInitContent_3632": "是时候亮剑了",
    "themeCardPackName_17030": "转机",
    "messageInitContent_3633": "摁墙上锤",
    "messageInitNick_10424": "人气声优",
    "messageInitNick_3092": "白发歌姬",
    "messageInitContent_3634": "我在中间留言害怕极了",
    "messageInitNick_10425": "天堂长裙",
    "messageInitNick_3091": "迷路的叶绿体",
    "messageInitContent_3635": "好多大珍宝贝",
    "messageInitNick_10422": "冰暴战神",
    "messageInitNick_3090": "小心火烛",
    "messageInitContent_3636": "你们正常点，我害怕",
    "messageInitNick_10423": "别动我兔子",
    "messageInitContent_3637": "《═══丨═",
    "messageInitNick_10428": "这也能不小心",
    "messageInitNick_3096": "草莓味肩带",
    "messageInitContent_3638": "《═════丨═",
    "messageInitNick_10429": "北城九命猫",
    "messageInitNick_3095": "程序烹饪家",
    "themeCardPackName_17035": "安慰剂",
    "messageInitContent_3639": "《═══════════丨═",
    "messageInitNick_10426": "下路直冲水晶",
    "messageInitNick_3094": "激萌少女",
    "messageInitNick_10427": "舒芙蕾爱好者",
    "messageInitNick_3093": "芹菜魔法",
    "messageInitNick_3089": "宇宙皇后",
    "messageInitNick_3088": "村中第一帅",
    "messageInitNick_3087": "可爱暴击",
    "messageInitNick_3086": "消费陷阱",
    "messageInitContent_3640": "吾夜观天象，剑尖所指便是胜利一方",
    "messageInitNick_10420": "福如东海",
    "messageInitContent_3641": "吾掐指一算，用剑的赢了",
    "messageInitNick_10421": "先看看属地",
    "messageInitContent_3642": "私我告诉你的答案",
    "messageInitContent_3643": "我也观天象，你命里缺钱",
    "messageInitContent_3644": "我也观天象，你命里缺我",
    "messageInitNick_10479": "甜品大侦探",
    "messageInitNick_3081": "蛋糕仔先生",
    "messageInitContent_3645": "我也观天象，你命里缺假",
    "messageInitNick_3080": "折成旧日时光",
    "messageInitContent_3646": "我也观天象，你命里缺假",
    "messageInitNick_10477": "哭是我的专长",
    "messageInitContent_3647": "你算什么东西",
    "messageInitNick_10478": "香瓜龙",
    "messageInitContent_3648": "《═════════丨═",
    "messageInitNick_3085": "很靠谱的青年",
    "messageInitContent_3649": "《═══丨═",
    "messageInitNick_3084": "鼠标之神",
    "messageInitNick_3083": "深夜睡不着",
    "monsterDes_128": "定位：辅助，子弹蒸发，子弹免疫，绑定治疗，能量回复提升\\n无端消失的力量、突如其来的窒息、黏腻可怖的触感……种种诡象如漩涡般将无数怪兽卷入恐怖之中，不幸的怪兽早早陷入癫狂，而有幸保有理智的怪兽仅能在遗忘前留下的片言只语，将一切指向那个不详的存在。依照那些受其影响，深陷疯狂的怪兽终日不知疲倦绘制的怪异图形，怪兽称它为“海漩”。\\n实际上，“海漩”本身与怪兽的理解相距甚远，它永远无法被怪兽长时间记住，仿佛世界总是一遍遍地将它抹掉。它那与外表极不相称的幼稚之心很快就接受这一切，它要拼命地留下存在的痕迹，和所有怪兽做好朋友。\\n只有某个遥远维度的不朽者知晓，远在比腐朽的过往更为古老的岁月里，黑狞无边的深海之中被播下了大量的仆役，一种为了散播不可名状的恐怖的仆役。意外苏醒的它就是其中之一，它正在不知不觉间出色地履行着使命。它留下痕迹的方式非常有效，它那恶童般的“恶作剧”带去的，正是一种最难以磨灭的情绪——恐惧。",
    "messageInitNick_3082": "怪怪怪大叔",
    "monsterDes_129": "定位：输出，巨擘状态，疗殇状态，星宇状态\\n在对手开战便占到上风时，在对手因得到治愈而感到安心时，在对手迫使它不停后退直抵墙边而得意时……甚至在对手将它逼入绝境而大意之时，等待它们的将是崩律铺排好的大反转戏码，是规律崩坏的高光时刻！开战时的伤害实则加速了崩律能量的积累，充足的疗愈只反倒被它转为了伤害，所谓的压制反而为它制造了持续击退的契机……连最后的补刀也徒劳地成了它打造护盾的帮手。崩律热衷于制造种种反常时刻，但它绝不会在那之前表露意图与愉悦，毕竟反常前越是正常，反转就越是壮丽。它还有更多新戏码准备上演，毕竟对它而言，反常才是日常……",
    "messageInitNick_10471": "夜明猪",
    "messageInitNick_3078": "我跟你麻麻港",
    "monsterDes_126": "定位：输出，妄焱·领域，免死，反伤，减疗\\n热浪胁迫着碳烟再度回归天际，巨木倒塌的轰隆声与爆裂的噼啪声盖过此起彼伏的哀嚎，一头长着犄角的怪兽在火海中缓缓睁开了眼，周遭扭曲的光景与狂舞的火焰瞬间被它纳入体内，黑夜重临，星火弥散……曾经的“它”玩命地进行各种试验，只为更接近它所痴迷的火焰。它在一次次越发危险的试验沉迷，无法自拔，它深信火焰同样爱着它，因为世上唯有它能理解火焰的本质，火焰即是解脱之力，火焰将被燃物的实相从燃尽的假象中解脱出来。它已迫不及待与火焰相融，见证它的实相，它开始了迄今为止最危险的试验，原来所谓的实相不过是以为被爱的幻梦，入火成魔的妄想。",
    "messageInitNick_10472": "爱轻易说出口",
    "messageInitNick_3077": "我瘦不了啦",
    "monsterDes_127": "定位：输出、偷取血量、受伤害锁定、腥风状态\\n颅内的尖鸣和阵阵的剧痛拉扯着绯焉在噩梦与现实间往返。若四下死寂，遍地腥红，手上残留着不明的余温，那便是现实。若看见被半折巨镰割开的畸形巨口和飞掠而至的绯红巨鸟，则是梦境。那眼前的又是什么？她正吞噬着手中的活物，对灵魂和血肉的强烈欲望正裹挟着她，她尖叫着，却没有半点声响，一只活物趁机在她眼皮底下窜出逃离。她突然发现自己奇迹般地控制了身体，虽然只有稍稍松手的瞬间，可这也是现实。此后，微小的改变持续在绯焉身上发生，她以巨爪钳制双脚，以双翼遮挡感官，以长发压制身躯。她依然会抚摸着那些合她口味的怪兽表达如“你摸起来真可口”一类的赞美，但也仅此而已，可面对那些试图用暴力窥探她真容的怪兽，她将解开束缚，释放抑制已久的强欲，吓退眼前的一切。",
    "messageInitNick_3076": "爱得如此狼狈",
    "monsterDes_124": "定位：近战辅助，反制清除，魔树状态\\n和超进化大陆其他植物一样，它已经在大地上矗立了足够之久，正缓缓步进腐朽，无数新芽得以滋养，在它身上争相冒出，荧灵便是其中一株，她无意中继承了它悠远的过往，成为绝无仅有的“万物有灵”。那个承载无数过往的瞬间，世事流转唯她不变。荧灵继承它的“意志”，去滋养那些被夺走生命力的怪兽，她的生命终将凋零，但她的意志将随着不断的新生而永存，例如那些刚刚继承了她意志的魔种，会任性地，给那些夺去它们存在的怪兽一点真实的报复。",
    "messageInitContent_3650": "《═════丨═",
    "messageInitNick_10470": "爽口的葡萄柚",
    "messageInitNick_3075": "凉拌",
    "monsterDes_125": "定位：辅助，触墙发动，全体能量回复提升，崩坏状态，极巨化保护\\n在一座无名的岛屿上，有一个沸腾的大湖，一些怪兽不幸在附近殒命，一些新的“沸体”在沸湖中诞生。在一个难得沸汽稀薄的日子里，一只沸体无意间贴近了湖面，发现了沸湖外的新世界！它立刻兴奋地向其他沸体宣告，它要去新的世界冒险！在所有沸体的注视下，它跃出了湖面，随后消失不见。那一刻，沸体们相继意识到沸湖就是一座幽狱，逃则亡。但这并不影响它们带着幽狱出逃~一只沸体禁锢的力量不够，就两只、三只……它们就这样离开了大湖，以禁锢之力触及到自由！它们咕噜咕噜地尖叫着，为探索神秘陆地的新冒险而呐喊！",
    "messageInitContent_3651": "《═══════════丨═",
    "messageInitNick_10475": "顶寄作案",
    "monsterDes_122": "定位：坦克、群体偏移、降维状态、受伤害锁定、能量回复提升\\n腾龙被称为最“懒”的龙，它从未否认，因为否认很麻烦，而它嫌麻烦，哪怕是一丁点的麻烦，例如站着，能躺着的时候它绝不站着。麻烦未至时，腾龙日常超凶使得生兽勿近。麻烦将至时，它创造二维区域“贴墙上观”让麻烦只找朋友。麻烦已至时？不！麻烦不敢至。那“麻烦”但凡理智尚存，见过一次腾龙的降维打击，都会为了避免被降维碾压，全力逃开。这也不难解释，为什么腾龙身边总是一派安静祥和的景象。",
    "messageInitContent_3652": "《═丨═",
    "messageInitNick_10476": "让我访问",
    "monsterDes_123": "定位：输出，护盾，能量上限降低，拟态\\n无尽的细雨下，死物与亡骸堆积而成的废墟上，它开始低声嗡鸣。漆黑组件，一个为了完成终极模拟，不断执行拟态指令的组件。“一开始”，终极模拟是对目标的彻底理解，为了确保理解，绝不干扰和影响目标，以便完成最真实的拟态和迭代。但拟态并非总是顺利的，那次滋长出无助和恐惧的拟态如期而至，当时的拟态目标夺去了漆黑组件的肢体，试图彻底支配它，但它没有想到，这一切在不久后被漆黑组件完美地重现。这次模拟就像落入精密机械的砂砾，机械越是运转，零件的咬合就越是松动，最终一组齿轮彻底分离形成了新的主体。那也是漆黑组件，一个为了完成终极模拟，不断执行着拟态指令的组件。它的终极模拟是对目标的精确再现，与“一开始”不同，为了确保精确，它对目标实施绝对的控制，做到精确且不变。",
    "messageInitContent_3653": "墨镜一戴，结果出来",
    "messageInitNick_10473": "谨慎交友",
    "monsterDes_120": "定位：输出，蓄力爆发，范围回能量，范围真实伤害，增伤\\n碰撞在超进化大陆就像呼吸一样自然，可为什么是碰撞？为什么这个世界选择了碰撞？无数变量在碰撞间诞生，碰撞让一切都充满了变数，碰撞创造了无穷的变化，就如同▇▇创造了这个多姿多彩的世界。这是创晓在碰撞中某个刹那的狂想，他把自己的霸气降至最低，他在碰撞间窥见了世界，触摸到那不愿停歇的意志，而后知晓了创。\\n不远处，一只飞向天际的叉叉正发出画外音：“这就是创……晓吗啊啊，刚刚明明还是0霸的啊啊啊啊”",
    "messageInitContent_3654": "我命里缺的是妹子",
    "messageInitNick_10474": "半世枪魂",
    "messageInitNick_3079": "光明的未来",
    "monsterDes_121": "定位：输出、范围伤害、生物屏障降低、范围扣减能量\\n“我叫刀马。记住也好，记不住也好，反正名头不重要。”\\n“他叫刀马。后头总有个小不点跟着的就是他，对啦，要瞅见那小不点蒙眼了可要赶紧跑！”\\n那里也好，这里也好，在哪里都不重要，刀马就是刀马。",
    "messageInitContent_3655": "我命里缺的是帅哥",
    "messageInitNick_3070": "爆米花龙",
    "messageInitContent_3656": "心理学专业来了",
    "messageInitContent_3657": "给策划过一个心理学",
    "messageInitNick_10488": "冰晶打手",
    "messageInitContent_3658": "═丨═══════════》",
    "messageInitNick_10489": "发际线疯退",
    "messageInitContent_3659": "《═════》",
    "messageInitNick_3074": "保存开心",
    "messageInitNick_3073": "超级汉堡",
    "messageInitNick_3072": "桃花初绽",
    "moorEffectConfigDescription_10": "怪兽造成伤害的{p1}%用于回复自身血量",
    "messageInitNick_3071": "大葱魔法",
    "moorEffectConfigDescription_11": "召唤此怪兽出战，全技能均为满级，怪兽在{p1}秒或死亡后消失。",
    "messageInitNick_10482": "遛狗仙女",
    "messageInitNick_3067": "悠闲的假日",
    "monsterDes_137": "定位：肉盾，种族构具\\n她是个不折不扣的种族专家，总爱对着空气抛出连造物主都觉得头疼的问题。\\n像是……种族是一开始就存在了吗，还是无数演化后的偶然？\\n又或者是……是不是只要剔除所有种族的差异，就能回到起源？对，只要做出“那个”就行！\\n她也是个极度冒失的构具天才，明明要打造适合所有种族的武具，却因粗心大意，反铸成了四件针对各个种族的构具：对抗祖龙族的【灭祖龙炮】，压制尸鬼族的【尸胄鬼甲】，干扰木偶族的【偶识木链】，抵御星灵族的【魔灵星枪】。\\n我就是【灭祖龙炮】，她最趁手，最偏爱的孩子~\\n我才是呢！不过，她已经一动不动很久很久了。\\n我可一点都不想她。\\n嘴硬，我们都很想她。\\n但没关系，只要我们将织念之线接入她的躯壳——她就会再次行动，仿佛从未离去。\\n她的神态、她的动作、她的一切……都将由我们，不断重构。",
    "messageInitNick_10483": "孔雀大爷",
    "messageInitNick_3066": "一笑百媚生",
    "monsterDes_138": "定位：输出，爆噬状态，全体恒定击退，远程破韧\\n关于玩物之地起源的那场“撞击事件”？B.B.Token会告诉你一切：\\n一切都很突然，我原本正要攻击一头恶龙，结果下一秒，我就碎了。\\n抓住我的那只大手被平地摔美少女撞倒，紧接着桌游柜倒塌、光芒爆散，无辜的我与一大堆棋子、模型、卡牌、新老游戏机一起，和地面进行了美妙接触。等我再醒来，眼前跳出了一堆等我选择的设定——\\n使用腹语+张合炮口进行交流（划掉），特殊炮弹是成熟后自动脱落的蛋蛋（迅速划掉）、锥形下半身为可伸缩光剑（大力划掉）……\\n好不容易看到几个像样的：恒定击退（保留）、受到致死的伤害时不会死亡（也留）、Unique域权（不明觉厉，留！）……\\n然后，最底下突然弹出系统提示：「已为您自动生成名称：B.B.Token」（……喂这肯定是Boss Beast吧？不可能是BoomBoom……更不可能是baby吧？……喂！？）\\n就这样，曾经是桌游Token的我成了一只域权Token怪兽。一直都只能看别人玩的我，眼馋了这么久的我，这下终于可以大玩特玩啦！哈哈哈哈哈！",
    "messageInitContent_3660": "看我御剑而行",
    "messageInitNick_10480": "你躲哪了",
    "messageInitNick_3065": "路边的单身狗",
    "monsterDes_135": "定位：输出，影替状态\\n戏战顽袍也没搞懂，自己是穿着怪兽的袍子，还是袍子成了精。\\n不过无所谓~能打架就行！它战斗不为杀戮，不为掠夺！就~挥挥弯折之镰，甩甩绷带魔杖，一会猛猛输出，一会套套护盾，一会加加霸气，拼尽全力玩爆战场的每一个元素~\\n只是玩归玩，打归打，它只管玩和打，受伤是不可能受伤的~毕竟，调动各个元素后的战斗反馈会带来至高无上的爽感，没命就爽不了，因此，它总会做好战前准备——\\n“兄弟，我给你好康的，你给我点血条呗？”",
    "messageInitContent_3661": "我好怕怕",
    "messageInitNick_10481": "奇幻的榴莲",
    "messageInitNick_3064": "纯情软糖",
    "monsterDes_136": "定位：辅助，逆流区域，被清除回能量\\n咚 咚 咚 | 咚咚 咚 咚咚 | 咚咚 咚 咚咚 咚咚咚\\n咚 | 咚 咚咚 | 咚 咚咚 咚 | 咚咚 | 咚 咚 咚 咚\\n咚 咚咚| 咚 咚咚 咚 咚 | 咚 咚咚 咚 咚\\n微点，轻敲，慢晃，缓跺，继而猛甩，重锤，狂摇，暴踏……\\n这鼓声似乎牵引着天，地，暗有所指——",
    "messageInitContent_3662": "能推到墙边吗",
    "messageInitNick_10486": "重新定义头铁",
    "monsterDes_133": "定位：输出，击退，内噬状态，崩坏状态\\n咎骸在超进化大陆上无休止地游荡，边走边向四周射出胞刺。被射中的活物将迅速陷入一种近乎偏执的痴狂——开始渴望血肉，渴求完整，渴盼成为“它”的一部分。这是由胞刺注入的内噬末梢所引发的神经渗透，骸化的冲动被传递到被刺活物身上，并在其濒死时到达极致。这种冲动并非毫无缘由，它本是一头畸兽的摄食器官，却在本体死亡后千年仍奇迹般保有活性。所幸它仍沉溺于本能的冲动中，否则它迟早会意识到，自身的存在早已突破生命的法则，而那将是更多器官从活体中剥离的开端……又有谁敢断言它摆脱冲动的那一天不会到来……",
    "messageInitContent_3663": "( ＿ ＿)ノ｜",
    "messageInitNick_10487": "芒果魔法",
    "monsterDes_134": "定位：辅助，魔反状态，钢魂区域，坚韧提升\\n千万年来，文明刻机Δ-A.00-LZ游走于星系之间，从未失误。可不出意外地，意外出现了。\\n“人家明明只是小小地打了一个盹嘛~”艾娜璃兹大声嚷着，直直坠入一片陌生星域。它不得不燃尽所有能量避免爆炸，并将身体退回到幼年时期以减少冲击，却仍难免一头撞落了一块漂浮空陆，坠向大海。几乎同时，数个漩涡突然涌现，它们如无形的通道，强行打破了各个空域长久的隔绝和封闭。\\n“不过……影响似乎……不大，真的不大吗？”艾娜璃兹唤起悬浮分析窗，与其说是懊悔，不如说更多的是激动——这简直是中大奖了！这是刻机未曾记录的世界，是纯粹的未知。而观测、解析前所未见的一切，将激活刻在它头部装置的兴奋回路。就像一场无尽的狩猎，同时收获快感与热量。战斗是它最爱的猎场，受击、异常或失衡反应——解析越深刻，感官越炽烈。似乎对它而言，存在的意义从不是“繁衍”，而是“追猎”。",
    "messageInitContent_3664": "墙都不扶",
    "messageInitNick_10484": "泡了对面大哥",
    "messageInitNick_3069": "暗夜猎手",
    "monsterDes_131": "定位：辅助，蛇噬状态，能量回复，绑定忽视减伤，免疫减速，增益效果持续时间降低\\n祈本是祈愿池中的一条小蛇，在池中误吞仙卷开了灵智。自此，她以吞噬怪兽的祈求之力为食，借助这些力量提升境界，逐渐能疗愈自身，化出新形。可就在她为自己的新模样暗自欣喜之时，一道天雷降下将她打回原型。同时一股强大的气息在它体内腾起涌动，拆骨剔肉的剧痛随之而来，仙卷从她的体内冲出，在她眼前展开，那是祈愿的仙卷。她强忍剧痛，挣扎着爬入仙卷……\\n走出仙卷的一刻，她才真正领悟到祈愿的真意，吞噬祈求之力是为了打破祈愿者依赖外力的桎梏，因为想实现愿望就决不能仅靠外力，更要有为之付出的决意。祈要继续提升境界不再落入歧途唯有一法，在每一次轮回中帮助祈愿者实现愿望，那些就算只有自己也要拼命接近愿望的怪兽将会是她的不二之选……",
    "messageInitContent_3665": "《═══════════丨═看我40m长剑",
    "messageInitNick_10485": "蒜苔兽",
    "messageInitNick_3068": "风筝寻梦",
    "monsterDes_132": "定位：肉盾，坚韧提升，抵抗状态，偏移\\n血肉剧团销声匿迹多年后，那些追求感官刺激的怪兽们找到了它们的新栖息地，四处巡回的环形斗场。那里没有规则与怜悯，怪兽们肆无忌惮地厮杀着，直至死亡即将降临的瞬间，环形斗场之主硎进场挡下最后一击，宣告胜负已决。环形斗场的创立源于硎的一次体验，在数刃贯穿的濒死之际，他感受到了一份原始而灼热的生命脉动，那是早已烙在怪兽体内却不被发现的「坚韧」。他决意将这份体验献给环形斗场的所有斗士，让利爪划开胸膛，让撕咬夺去血肉吧，然后在伤口深处领悟，那份独属自身的「坚韧」。",
    "messageInitContent_1003": "小兔子带头冲锋！",
    "messageInitContent_1002": "不开不开我不开，狼就在屋里呢。",
    "monsterDes_130": "定位：输出，深渊印记，增益效果持续时间降低\\n相较于虚诞之地，怪兽更习惯称那里为深渊，一片位于海底之下难以想象的区域。而她是那片区域中绝对无法忽视的存在，因身旁环绕着数个异质眼球，我们称她为【瞳】。来自不同怪兽的观测记录构成了我们对她的全部认知，其中充斥着大量荒诞的推测和众多前后矛盾的描述，以下是其中一部分：【瞳】是虚诞之地的主宰，是深渊规则的化身。掌中之瞳执掌【许可】，双触之瞳司掌【调控】，三触之瞳掌管【驱逐】。在她上方偶尔浮现的数字对应着深渊的刻度，刻度发生变化时，深渊的规则亦会随之变化，似乎还与她的掌控力所对应。在深渊必须遵照对应的规则行动，否则【该内容仅可在刻度为3时查阅】……",
    "98_-250004": "赛季已结束",
    "messageInitContent_1001": "小兔子乖乖，把关让开。",
    "98_-250005": "投注开放时间为周二至周日{1}",
    "messageInitContent_1000": "动物园已经演到这里了。",
    "98_-250002": "竞猜通道已关闭",
    "98_-250003": "竞猜通道已关闭",
    "98_-250001": "该轮次未开始竞猜",
    "messageInitContent_1009": "是的，我眼里只有珍宝。",
    "messageInitContent_1008": "受不了了，这么大个关卡，就看到珍宝？",
    "messageInitContent_1007": "珍宝！！！！！！",
    "messageInitContent_1006": "小兔子不乖！",
    "messageInitContent_1005": "附议",
    "messageInitContent_1004": "独角兽你的头也拿累了吧，该放下休息休息了。",
    "messageInitContent_3666": "无脑选主角",
    "messageInitNick_10457": "肱三头肌魔法",
    "messageInitContent_3667": "拿剑的giegie加油",
    "messageInitNick_10458": "催命判官",
    "messageInitContent_3668": "屠龙勇士都有了，公主呢",
    "messageInitNick_10455": "网盘再见",
    "themeCardPackName_17005": "饿了",
    "messageInitContent_3669": "公主给你们，我要魔法使就好",
    "messageInitNick_10456": "辣椒撞地球",
    "messageInitNick_3063": "凶我你敢啊",
    "monsterDes_108": "定位：辅助，追溯，护盾，击退，全体减伤\\n溯仪伸出她那宛如异物的巨爪，撕破现实的边界，轻轻抚弄着时间的洪流，片刻间，怪兽们被摁在原地，无法动弹。那些不可能治愈的伤，在她面前只是可以随便抹去的片段。然而所谓的奇迹？不过是被她操控的世界线，看不见的厄运在另一端延展，不曾消失。",
    "messageInitNick_3062": "记忆转圈圈",
    "monsterDes_109": "定位：辅助，全体减速，全体伤害，全体封印，全体降霸，全体击退\\n梵可能是超进化大陆里最具神性的怪兽，它的每一发攻击都会在敌人心里留下印记造成巨大深远的影响。“千万不要和梵战斗，除非拥有顶级圣洁元核。”",
    "messageInitNick_10459": "智能橡皮糖",
    "messageInitNick_3061": "饺子猎手",
    "monsterDes_106": "定位：输出，减射程，偏移，濒死自愈，低血点杀，反伤\\n“螺旋巽，为南天风神，无所不入，百里不停。而后，万物皆狂，螺旋而绕，且随风而动，随刃而行，皆随。 ”\\n“山枯树死，不知已是几更天，物换星移，风神又历几度秋，不再沉沦虚妄，不再顺势而行，无意逐风，万事皆允。”\\n皆是螺旋巽的写照，皆随皆允皆你来定。",
    "messageInitNick_3060": "明日之光",
    "monsterDes_107": "定位：辅助，范围清除增益，范围清除负面，后退射击，增伤\\n在木偶族的无底之墓，沉睡的气奥在梦境的封印中徘徊，他徘徊在无数残破的木偶族亡灵之间，看着亡灵们刻下一个又一个神秘的图阵，图阵逐渐在他脑海中重叠。最后，气奥刻下了一个全新的图阵，名为破魔，梦醒了。\\n气奥的破魔图阵让木偶族的亡灵得以摆脱不灭的噩梦，同时他自身亦透过破魔图阵得到了接近无限的时间。气奥慢慢意识到，这不过是另一种桎梏，于是他创造了一个完全相反的图阵，名为魔免，这会是另一场梦吗？",
    "19_2002": "遗落回响",
    "messageInitNick_3056": "牵着蚂蚁逛街",
    "monsterDes_104": "定位：辅助，召唤，区域击退，区域减速，区域增攻\\n∞到底是“它”还是“它们”？体内源源不断地分裂出魔物的∞是对手无尽的噩梦，无穷并非无中生有，它的灵魂分裂，死去，回归，融合。它的记忆被撕碎，它甚至无法想起它变为∞的原因，唯一的线索是残存在它每一块记忆碎片中的那一支双头骷髅权杖。\\n∞起始交叠，周而复始，循环往复，无穷无尽。是的，你们被∞包围了。",
    "19_2001": "世界回响",
    "messageInitContent_3670": "我是核弹",
    "messageInitNick_10450": "掌握核心科技",
    "messageInitNick_3055": "最爱豌豆",
    "monsterDes_105": "定位：辅助，降低增益时间，低血点杀，减伤\\n一道天雷落入东海岸战场，致死的电流瞬间穿过了每一个活物的身体，灵族与木偶族的大战就此终结。在这个终结的时刻，天枢震诞生了，他是残骸的聚合体，是无数亡者意志的统合。他深知战争的内核，更清楚该如何结束它。\\n“弱化它们的意志，缩短它们的时长，然后以战止战！”",
    "messageInitContent_3671": "强者云集",
    "messageInitNick_3054": "业界天花板",
    "monsterDes_102": "定位：输出，清除克星，区域伤害，自我治疗，范围减攻\\nQueen是超进化大陆最可悲的怪兽，陪伴着它的只有弥漫着血腥味的空气。因为它接触过的活物都会爆炸，非死即伤。\\nJoker却喜欢上了这样的Queen，不顾一切地追逐Queen，在一次又一次的爆炸中变得面目全非。这天，Queen松了口气，她以为Joker放弃了，直至她看见了一个精美的礼盒以及上面的字条，字条上面写着“终于变成了能够保护你的形状。——Joker”",
    "messageInitContent_3672": "眼熟",
    "messageInitNick_3053": "挂科难",
    "monsterDes_103": "定位：输出，区域免伤，偷取血量，偏移\\n魅妆拥有直击怪兽心灵的特殊力量，以及非常强大的防御结界，她还精通各种顶尖的美妆技巧，是月夕的头号劲敌。\\n她和“美”很像，这次给你带来了强烈的安全感，但很可能下一次，她就会横扫你的安全感。",
    "messageInitContent_3673": "远古轮流登场是吧",
    "messageInitNick_10453": "泪崩面条",
    "monsterDes_100": "定位：辅助，冰墙，区域减速，区域缩小，区域护盾\\n在仿若冰山一样的冰霓面前，任何怪兽都会显得渺小，哦不对……变得渺小。谁会知道在她冰冷的外表下是一颗柔软的……哦不对，是一堵冰墙，是一座无人的空碑。\\n或许还是冰山的一角……",
    "messageInitContent_3674": "很忙，正在乱猜",
    "messageInitNick_10454": "寒门中暑",
    "messageInitNick_3059": "墨染琉璃殇",
    "monsterDes_101": "定位：坦克，清除增益，自我治疗，区域伤害，区域击退\\nYoYo，超进化唯一Rapper幻！\\n一首《超幻》现在奏响！\\n幻登场全场骚乱，世界公认的实力偶像。\\n不服的通通锤成烤串，除去增益让它们够呛。\\n一拳下去对手就飞得老远，失败好像变得越发抽象。\\n说了不想让兽丝抱怨，幸亏搞事的一听就立刻投降。\\n狂轰乱炸任音符捣乱，放飞自我由想象翱翔。\\n看我御御散御天御地御宏，等等这御字后面是不是少了个空？可没关系，Love&Peace~",
    "messageInitContent_3675": "我就不信今天还能猜输",
    "messageInitNick_10451": "注意力跑了",
    "messageInitNick_3058": "匿名术士",
    "messageInitContent_3676": "正准备3连胜",
    "messageInitNick_10452": "电视台作家",
    "messageInitNick_3057": "不止眼前的狗",
    "messageInitContent_1014": "一直独角兽还不够吗？",
    "19_2009": "分享",
    "messageInitContent_1013": "大伙，那是怪兽！不是车车。",
    "19_2008": "评论",
    "messageInitContent_1012": "应该再装3个三个上去",
    "19_2007": "已领取",
    "messageInitContent_1011": "好想帮轮脉把轮子松开",
    "19_2006": "领取",
    "messageInitContent_1010": "腐化者，看来不用我多说了，你知道该怎么做了吧。",
    "19_2005": "微光笔记",
    "19_2004": "世界丰碑",
    "19_2003": "超星洪流",
    "98_-40003": "叠加时间到达上限，无法继续使用",
    "98_-40002": "{1}不足",
    "98_-40001": "道具不存在",
    "messageInitContent_1019": "有些时候呢，伤害别人就会伤害到自己。",
    "messageInitContent_1018": "这时候，就只能拜托了，玄武！",
    "messageInitContent_1017": "痛痛痛！",
    "messageInitContent_1016": "真是好痛啊。",
    "messageInitContent_1015": "它还整2，而且还是真实伤害！",
    "messageInitContent_3677": "加个好友",
    "messageInitNick_10468": "最强文件袋",
    "messageInitContent_3678": "左边赢，信我",
    "messageInitNick_10469": "不吃猫的鱼",
    "messageInitContent_3679": "我信你个大头鬼",
    "messageInitNick_10466": "娱乐决斗家",
    "messageInitNick_10467": "豆角魔法",
    "messageInitNick_3052": "悔恨的泪水",
    "monsterDes_119": "定位：辅助，眩晕，触墙能量回复，区域减速\\n喵喵在温柔的弹唱声中倒下了，伴随着雨声和一阵阵的白噪音，直至寂静。此时一个声音响起“你想成为？”喵喵几声作答。声音又说，“不考虑高存活率的锋利爪子、坚硬颌骨和如闪电般你再熟悉不过的反射神经吗？”喵喵给出了答案。“明白了，那就给你能弹奏的双手，能唱出美妙歌声的喉咙，还有能贯彻三个世界的‘响’！”",
    "messageInitNick_3051": "破防男神",
    "messageInitNick_3050": "柠檬消灭者",
    "monsterDes_117": "定位：输出，触墙增伤，减射程，击退，反射负面\\n追光者深受变幻莫测又无法触碰的光吸引，光囚是其中最为疯狂的一位，它相信唯有它能理解光的意念。它向光许下承诺，会不惜一切代价保护光，让光永续。但光囚在几乎踏遍整个大陆后发现，根本没有任何容器能成为保护光的盔甲。它的决意并未就此止步，光囚找到了溯仪，在时间的洪流中把自己的身体重塑成一个特殊的容器，完成了承诺。只是光囚还没发现，它没有成为盔甲，它成为了光的囚笼，亦是光的囚徒。",
    "monsterDes_118": "定位：坦克，代伤领域，范围增射程，范围减速，范围减攻速\\n真实与虚幻胡乱堆砌而成的不可能之景，却不掺杂一丝虚假地映在怪兽眼中，那就是蜃景。\\n被蜃景包围的怪兽，会先感觉到一股恶寒从后背蹿起，那是注视着自我而不自知的开端，随后身体如同映在湖中的倒影被吹皱般开始扭曲，那是觉察之初的幻痛。之后，少数接纳了自身的怪兽回归现实，见到了那穿梭在蜃景之中的生物，婀娜的身姿从方形石池之中探出，将整个蜃景如同云雾般吞来吐去，那是无数怪兽曾经祈愿的对象，那个据说能实现愿望的方形石池，它从无数的祈愿中诞生，它是怪兽对“祈愿”的共同想象的化身，掌握着将欲念投射到现实的力量。",
    "messageInitContent_3680": "私我告诉你的答案",
    "messageInitNick_10460": "目的地不明",
    "messageInitNick_3045": "空中飞人",
    "monsterDes_115": "定位：辅助，神灵联动，免疫负面，反伤，治疗\\n神灵与怪兽之间有一条看不见的界线，确实地将两者区分开来。神唤不是唯一一位试图突破界线，成为第八位神灵的怪兽，却是最接近界线的怪兽。它不惜一切，将七颗用以接纳神力的神石嵌入体内，其中两颗彻底破碎，剩下的五颗顺利与它的力量相融。\\n在神唤每次用手碰触神石，召唤神灵之际，总有一股异样从它心头涌起，若是刻意找寻就消失无踪，稍有放松又紧随不放，如同湖中倒影般，有另一只手，在另一侧与它一同指向神石。",
    "messageInitContent_3681": "一眼就能知道",
    "messageInitNick_10461": "深情选手",
    "messageInitNick_3044": "凌晨十二点",
    "monsterDes_116": "定位：辅助，宿命效果转移，治疗，远程拉扯，免死\\n传闻中，造唤羽化时会褪下空壳，空壳从落入大地的那刻起，就饱受觊觎，引来了无尽的归属权争斗。\\n“这有什么意义呢？”谁也没有想到一具空壳会突然发出这样的疑问。\\n“带你去看看这片大陆。”谁也没有想到回答来得如此之快。\\n空壳在争斗中辗转，生出了疑惑，得到了答案。它因此兴致盎然，此刻的她仿佛找到了自己的名字，自己的意义，自己的宿命，并把自己交给了对方。\\n听到的怪兽都不禁感叹，这真的是空蝉的故事吗？",
    "messageInitContent_3682": "我家狗告诉我选右边",
    "messageInitNick_3043": "退役搬砖选手",
    "monsterDes_113": "定位：辅助，受伤害锁定，偷取血量，清除增益，叠加减伤\\n星的出现就是为了消失吗？\\n噢……是闪烁。（星烁将手中刻有奇怪“F”型符号的石板用力掷向天际。）",
    "messageInitContent_3683": "_(┐「ε:)_  ",
    "messageInitNick_3042": "果盘毁灭者",
    "monsterDes_114": "定位：输出，转能，封印死亡效果，区域免疫封印，清除增益\\n钢铁和细胞的链接融合使得赤炼零式的肉体几乎不会衰老。但很快，它就理解到机械化只是一种低级的永生形式，灵魂的老化才是所有怪兽无法对抗的铁律，它确信更高级的永生是灵魂的不朽，强大而原始的渴望使它的右臂进化出一个诡秘的熔炉结构，时刻锤炼着它的灵魂，它成为了超进化大陆上最接近“永动机”的怪兽。这绝对不是一个好消息，它的爱好是“停下”……其他生命，毕竟，绝大多数生命都遭不住通往永生的锤炼。",
    "messageInitContent_3684": "乐子云集",
    "messageInitNick_10464": "上班兴风作浪",
    "messageInitNick_3049": "酸酸梅汤",
    "monsterDes_111": "定位：输出，叠加增伤，范围伤害，范围减疗，范围封印\\n狩魂暗影总是结群狩猎，它们久伏于暗处，直到恶魂出现的一瞬，群起攻之。它是其中的异类，一个发光的狩魂暗影。它身上的光让整个影群变得难以藏身，更别说发动突袭。无法狩猎的暗影注定被驱逐。光夺走了它的归属，它的未来。\\n被逐出影群的它成了“猎物的猎物”，需要整个影群才能围猎的恶魂盯上了它。求生欲迫使它竭尽一切，包括使用它痛恨的光。一道耀眼的光流划破天际，本该趁机逃生的它，没有了逃跑的理由。影是狩魂一族力量的具现，它的影在强光映衬下越发深邃，光与影顷刻覆盖大地，恶魂瞬间消散。\\n它成为了这片大陆上最强大的影——影曜。",
    "messageInitContent_3685": "无脑选主角",
    "messageInitNick_10465": "等离子洗衣液",
    "messageInitNick_3048": "呆萌小姐",
    "monsterDes_112": "定位：坦克，近战回光，反伤，降霸，血量上限扣减\\n荆霵知道自己即将要面临的是什么，和浑身长满尖刺、被视为“珍馐”的同族一样，在年幼、尖刺尚未硬化时被“食客”活生生吞掉，不一样的是她打算在被吞掉前让食客尝点苦头。她没有想到，手心那根提早成熟的尖刺不仅让食客尝到苦头，还刺穿了它的咽喉，可这一切，都不如内心那股突然涌现的欲望来得让她始料不及。初尝复仇甘美的她，渴望更多。起初，荆霵就像一个移动的屠宰场，一批又一批的食客成为了她的剑下亡魂。后来，她将剑指向了同族，除被吃掉以外，她的同族现在有了更多的选择，被荆霵杀死或是杀死食客。食物链上的箭头已悄然调转。",
    "messageInitContent_3686": "出个神话装先",
    "messageInitNick_10462": "葡萄消灭者",
    "messageInitNick_3047": "爱滚哪滚哪",
    "messageInitContent_3687": "如何同时拥有日夕和月夕",
    "messageInitNick_10463": "国际难民",
    "messageInitNick_3046": "口胡大哥",
    "monsterDes_110": "定位：辅助，镇守，叠加减伤，免疫封印\\n在无数次的战斗中，重装发现弱小的怪兽被击溃通常是由于对手的攻势超出了其肉体的极限，而强大的怪兽则不然，他们的溃败往往是因为优势被对方瓦解。如果说圣盾埃癸斯代表着超进化大陆的最强防御，那重装代表的则是最超出预期的防御。什么是最超出预期的防御？\\n“守护影响天枰倾侧的砝码从而拥有不会被瓦解的优势”",
    "messageInitContent_1025": "一炮泯恩仇",
    "messageInitContent_1024": "大家都有光明的未来。",
    "messageInitContent_1023": "大家都有平均的身高。",
    "messageInitContent_1022": "open the ga……！",
    "messageInitContent_1021": "前面是传送门！",
    "messageInitContent_1020": "嘻嘻，我有玄武。",
    "iapBuyConfigName_1779": "加实战纹碎片礼包",
    "iapBuyConfigName_1777": "实惠纬织源礼包",
    "iapBuyConfigName_1778": "纬织源大满足礼包",
    "iapBuyConfigName_1775": "钜惠纬织源礼包",
    "iapBuyConfigName_1776": "优惠纬织源礼包",
    "iapBuyConfigName_1773": "重构纬织源礼包",
    "unlockDes_45": "通过荧光商店获得",
    "iapBuyConfigName_1774": "重组纬织源礼包",
    "unlockDes_46": "通过半周年记获得",
    "iapBuyConfigName_1771": "增重战纹碎片礼包",
    "unlockDes_43": "通过黑街商店获得",
    "iapBuyConfigName_1772": "增固战纹碎片礼包",
    "unlockDes_44": "通过兽猎补给获得",
    "messageInitNick_3041": "慢半拍",
    "unlockDes_49": "源初境第2名",
    "iapBuyConfigName_1770": "增密战纹碎片礼包",
    "messageInitNick_3040": "听风就是雨",
    "unlockDes_47": "通过庆典商店获得",
    "unlockDes_48": "源初境第1名",
    "messageInitNick_3034": "零时零分说爱",
    "messageInitNick_5697": "为什么要上班",
    "messageInitNick_3033": "背靠暖阳",
    "messageInitNick_5698": "那我走问号",
    "messageInitNick_3032": "合成食品",
    "messageInitNick_5699": "逃出单位",
    "messageInitNick_3031": "记忆变得沉重",
    "messageInitNick_3038": "爱吃煎蛋",
    "messageInitNick_5693": "催泪小丑",
    "unlockDes_41": "通过社区部落活动获得",
    "messageInitNick_3037": "午夜的饭堂",
    "messageInitNick_5694": "霸王龙套",
    "unlockDes_42": "通过腾龙商店获得",
    "messageInitNick_3036": "失眠的夜",
    "messageInitNick_5695": "搬砖王",
    "messageInitNick_3035": "妖精哪里跑",
    "messageInitNick_5696": "牙膏的故事",
    "unlockDes_40": "通过赛博时戳获得",
    "messageInitNick_3039": "懒懒喵喵",
    "iapBuyConfigName_1768": "加厚战纹碎片礼包",
    "iapBuyConfigName_1769": "加强战纹碎片礼包",
    "iapBuyConfigName_1766": "爆载武装碎片礼包",
    "iapBuyConfigName_1767": "加实战纹碎片礼包",
    "iapBuyConfigName_1764": "满载武装碎片礼包",
    "iapBuyConfigName_1765": "超载武装碎片礼包",
    "iapBuyConfigName_1762": "中量武装碎片礼包",
    "unlockDes_34": "通过创作激励计划获得",
    "iapBuyConfigName_1763": "重量武装碎片礼包",
    "messageInitNick_5690": "苍白承诺",
    "unlockDes_35": "通过一箭五令获得",
    "iapBuyConfigName_1760": "极限极化石礼包",
    "messageInitNick_5691": "到底要怎样",
    "unlockDes_32": "通过万象琥珀获得",
    "iapBuyConfigName_1761": "轻量武装碎片礼包",
    "messageInitNick_5692": "尖叫蘑菇",
    "unlockDes_33": "通过一箭五令获得",
    "messageInitNick_3030": "菜鸟西瓜",
    "unlockDes_38": "通过iOS预约游戏获得",
    "unlockDes_39": "通过签福迎春获得",
    "unlockDes_36": "通过老莫集市获得",
    "unlockDes_37": "通过攻略征集活动获得",
    "messageInitNick_3023": "懒癌早期",
    "messageInitNick_5686": "狂飙的蜜蜂",
    "messageInitNick_3022": "最终价值",
    "messageInitNick_5687": "打鸡血的疯兔",
    "messageInitNick_3021": "菠萝蜜蜜蜜",
    "messageInitNick_5688": "眼睛里进了沙",
    "messageInitNick_3020": "火星人",
    "messageInitNick_5689": "内耗高手",
    "messageInitNick_3027": "红色近战轰龙",
    "messageInitNick_5682": "纯净的眸子",
    "unlockDes_30": "通过万象琥珀获得",
    "messageInitNick_3026": "狂风呼啸",
    "messageInitNick_5683": "画饼少女",
    "unlockDes_31": "通过许愿商店获得",
    "messageInitNick_3025": "枇杷龙",
    "messageInitNick_5684": "甜糖山旅行者",
    "messageInitNick_3024": "老子可爱",
    "messageInitNick_5685": "速度穿越时空",
    "messageInitNick_3029": "无敌电磁炉",
    "messageInitNick_3028": "飘雪公主",
    "iapBuyConfigName_1795": "无拘超进化礼包",
    "unlockDes_67": "通过祈福金印获得",
    "iapBuyConfigName_1796": "自由超进化礼包",
    "unlockDes_68": "通过游园畅玩获得",
    "iapBuyConfigName_1793": "重铸纬织源礼包",
    "messageInitNick_10499": "想养狗了",
    "messageInitNick_5680": "头铁王",
    "unlockDes_65": "通过派对记号获得",
    "iapBuyConfigName_1794": "随心超进化礼包",
    "messageInitNick_5681": "猪肉斌",
    "unlockDes_66": "通过周年商店获得",
    "iapBuyConfigName_1791": "重塑纬织源礼包",
    "iapBuyConfigName_1792": "重构纬织源礼包",
    "unlockDes_69": "通过粽夏夜梦获得",
    "iapBuyConfigName_1790": "纬织源大满足礼包",
    "messageInitNick_10493": "没有灵魂的茶",
    "messageInitNick_3012": "坏天使",
    "messageInitNick_5675": "超级套娃神",
    "messageInitNick_10494": "午餐吃蛋糕",
    "messageInitNick_3011": "翻车泰斗",
    "messageInitNick_5676": "劳资红遍全球",
    "unlockDes_60": "通过启程商店获得",
    "messageInitNick_10491": "懂门首席",
    "messageInitNick_3010": "把小熊还给我",
    "messageInitNick_5677": "狗粮的故事",
    "messageInitNick_10492": "小白鲨",
    "messageInitNick_5678": "疯狂的水果",
    "messageInitNick_10497": "独狼",
    "messageInitNick_3016": "餐厅的猫",
    "messageInitNick_5671": "九点的蒸蛋",
    "unlockDes_63": "通过捣蛋糖画获得",
    "messageInitNick_10498": "尖叫猕猴桃",
    "messageInitNick_3015": "水枪狙神",
    "messageInitNick_5672": "高光时刻哒",
    "unlockDes_64": "通过尖叫橱窗获得",
    "messageInitNick_10495": "缠绵的悲伤",
    "messageInitNick_3014": "吃素的蚊子",
    "messageInitNick_5673": "黑名单",
    "unlockDes_61": "通过鸣音回荡获得",
    "messageInitNick_10496": "窈窕柿子",
    "messageInitNick_3013": "给空调把脉",
    "messageInitNick_5674": "红尘仙子",
    "unlockDes_62": "通过海鸣商店获得",
    "messageInitNick_3019": "踌躇的键盘",
    "messageInitNick_3018": "喜剧不讨喜",
    "messageInitNick_3017": "柚子去哪了",
    "messageInitNick_5679": "脑电波",
    "messageInitNick_10490": "恋你朝朝暮暮",
    "iapBuyConfigName_1788": "优惠纬织源礼包",
    "iapBuyConfigName_1789": "实惠纬织源礼包",
    "iapBuyConfigName_1786": "重组纬织源礼包",
    "iapBuyConfigName_1787": "钜惠纬织源礼包",
    "iapBuyConfigName_1784": "增固战纹碎片礼包",
    "unlockDes_56": "通过形态同行获得",
    "iapBuyConfigName_1785": "重构纬织源礼包",
    "unlockDes_57": "通过盛夏足迹获得",
    "iapBuyConfigName_1782": "增密战纹碎片礼包",
    "unlockDes_54": "源初境第33-64名",
    "iapBuyConfigName_1783": "增重战纹碎片礼包",
    "messageInitNick_5670": "重新定义信仰",
    "unlockDes_55": "通过感恩纪礼获得",
    "iapBuyConfigName_1780": "加厚战纹碎片礼包",
    "iapBuyConfigName_1781": "加强战纹碎片礼包",
    "unlockDes_58": "通过盛夏商店获得",
    "unlockDes_59": "通过启程夜溯获得",
    "messageInitNick_3001": "偷吃一口甜",
    "messageInitNick_5664": "午餐盒",
    "messageInitNick_3000": "神奇的古偶",
    "messageInitNick_5665": "情话速递员",
    "messageInitNick_5666": "抽刀断情仇",
    "messageInitNick_5667": "把爱葬在沙里",
    "messageInitNick_3005": "避风港躲雨人",
    "messageInitNick_5660": "退役对线选手",
    "unlockDes_52": "源初境第9-16名",
    "messageInitNick_3004": "暗夜黑鹰",
    "messageInitNick_5661": "我开始慌了",
    "unlockDes_53": "源初境第17-32名",
    "messageInitNick_3003": "洗洗睡了",
    "messageInitNick_5662": "大哥靠边走",
    "unlockDes_50": "源初境第3名",
    "messageInitNick_3002": "火龙果先锋",
    "messageInitNick_5663": "巧克力有点皮",
    "unlockDes_51": "源初境第4-8名",
    "messageInitNick_3009": "最爱香瓜",
    "messageInitNick_3008": "漫天箭雨",
    "messageInitNick_3007": "单身才叫青涩",
    "messageInitNick_3006": "不小心登神",
    "messageInitNick_5668": "昨天的冒险家",
    "messageInitNick_5669": "丰盛的樱桃",
    "iapBuyConfigName_1737": "应急原石礼包",
    "iapBuyConfigName_1738": "备用原石礼包",
    "iapBuyConfigName_1735": "实惠纬织源礼包",
    "iapBuyConfigName_1736": "纬织源大满足礼包",
    "iapBuyConfigName_1733": "钜惠纬织源礼包",
    "iapBuyConfigName_1734": "优惠纬织源礼包",
    "iapBuyConfigName_1731": "钜惠起源片礼包",
    "iapBuyConfigName_1732": "优惠起源片礼包",
    "iapBuyConfigName_1730": "超凡起源盘礼包",
    "unlockDes_87": "通过3.0商店获得",
    "unlockDes_88": "通过3.1商店获得",
    "messageInitNick_5653": "专业尬聊",
    "unlockDes_81": "通过地腹岩窟获得",
    "messageInitNick_5654": "风暴火种",
    "unlockDes_82": "通过缤纷小铺获得",
    "messageInitNick_5655": "辞职养猪",
    "messageInitNick_5656": "特工要支教",
    "unlockDes_80": "通过端午游舫获得",
    "unlockDes_85": "通过周年橱窗获得",
    "messageInitNick_5650": "停止你的想法",
    "unlockDes_86": "通过2.9商店获得",
    "messageInitNick_5651": "巧克力爱情",
    "unlockDes_83": "通过玉兔宝盒获得",
    "messageInitNick_5652": "等离子菜刀",
    "unlockDes_84": "通过云霞燎里获得",
    "messageInitNick_5657": "为何不拜拜",
    "messageInitNick_5658": "我是酱油",
    "iapBuyConfigName_1739": "囤货原石礼包",
    "messageInitNick_5659": "泡芙侠",
    "iapBuyConfigName_1726": "紫色远古元核髓盒",
    "iapBuyConfigName_1727": "紫色宿命元核髓盒",
    "iapBuyConfigName_1724": "紫色宿命元核髓盒",
    "iapBuyConfigName_1725": "紫色特化元核髓盒",
    "iapBuyConfigName_1722": "紫色特化元核髓盒",
    "iapBuyConfigName_1723": "紫色远古元核髓盒",
    "iapBuyConfigName_1720": "橙色元核髓盒",
    "iapBuyConfigName_1721": "蓝色特化元核髓盒",
    "unlockDes_78": "通过春祈花市获得",
    "unlockDes_79": "通过奇迹集市获得",
    "unlockDes_76": "通过3.0签到战令获得",
    "unlockDes_77": "通过3.1签到战令获得",
    "messageInitNick_5642": "不干人事",
    "unlockDes_70": "通过光明轨迹获得",
    "messageInitNick_5643": "咆哮发动机",
    "unlockDes_71": "通过夏日追想获得",
    "messageInitNick_5644": "正在缓冲",
    "messageInitNick_5645": "单翼天使",
    "unlockDes_74": "通过派对点阵获得",
    "unlockDes_75": "通过2.9签到战令获得",
    "messageInitNick_5640": "流浪的砧骨",
    "unlockDes_72": "通过桂香盈月获得",
    "messageInitNick_5641": "快雪时晴",
    "unlockDes_73": "通过拾秋寻迹获得",
    "messageInitNick_5646": "打脸帝",
    "messageInitNick_5647": "地平线无际",
    "iapBuyConfigName_1728": "至臻起源盘礼包",
    "messageInitNick_5648": "尘埃开出花",
    "iapBuyConfigName_1729": "橙双效起源盘礼包",
    "messageInitNick_5649": "啊这过",
    "iapBuyConfigName_1759": "极致极化石礼包",
    "iapBuyConfigName_1757": "极意极化石礼包",
    "iapBuyConfigName_1758": "极顶极化石礼包",
    "iapBuyConfigName_1755": "极峰极化石礼包",
    "iapBuyConfigName_1756": "极魂极化石礼包",
    "iapBuyConfigName_1753": "无拘超进化礼包",
    "iapBuyConfigName_1754": "自由超进化礼包",
    "iapBuyConfigName_1751": "重铸纬织源礼包",
    "iapBuyConfigName_1752": "随心超进化礼包",
    "iapBuyConfigName_1750": "重构纬织源礼包",
    "messageInitNick_5631": "插线板破坏者",
    "messageInitNick_5632": "盛夏星空",
    "messageInitNick_5633": "青丝出走",
    "messageInitNick_5634": "五品带砖侍卫",
    "messageInitNick_5630": "金鳞银鳝",
    "messageInitNick_5639": "岛是海的寂寞",
    "messageInitNick_5635": "白胡子大佬",
    "messageInitNick_5636": "触碰到你的泪",
    "messageInitNick_5637": "五行缺一根筋",
    "messageInitNick_5638": "最强电视",
    "iapBuyConfigName_1748": "耀变武装碎片礼包",
    "iapBuyConfigName_1749": "重塑纬织源礼包",
    "iapBuyConfigName_1746": "突变武装碎片礼包",
    "iapBuyConfigName_1747": "升变武装碎片礼包",
    "iapBuyConfigName_1744": "高能武装碎片礼包",
    "iapBuyConfigName_1745": "超能武装碎片礼包",
    "iapBuyConfigName_1742": "极意极化石礼包",
    "iapBuyConfigName_1743": "潜能武装碎片礼包",
    "iapBuyConfigName_1740": "极限极化石礼包",
    "iapBuyConfigName_1741": "极致极化石礼包",
    "messageInitNick_5620": "冷门的懒得找",
    "messageInitNick_5621": "粒子捞月",
    "messageInitNick_5622": "网络红人",
    "messageInitNick_5623": "傲娇女王攻",
    "messageInitNick_5628": "云端吃货",
    "messageInitNick_5629": "假人",
    "messageInitNick_5624": "葡萄爱好者",
    "messageInitNick_5625": "毒奶",
    "messageInitNick_5626": "低分作文大赏",
    "messageInitNick_5627": "不靓你报警",
    "messageInitContent_3295": "看我泰山反压顶",
    "messageInitNick_3430": "骑猪闯世界",
    "messageInitContent_3296": "噫~",
    "messageInitContent_3297": "免费拥抱到这排队",
    "messageInitContent_3298": "尖叫",
    "messageInitContent_3299": "咆哮",
    "messageInitNick_3434": "幼稚完",
    "messageInitNick_3433": "趁微风正好",
    "messageInitNick_3432": "这效果假的吧",
    "messageInitNick_3431": "藏着一段故事",
    "messageInitNick_3438": "日夜扣光影",
    "messageInitNick_3437": "吾性傲且野",
    "messageInitNick_3436": "笨小蛋",
    "messageInitContent_3290": "我还楚留香呢",
    "messageInitNick_3435": "时尚眼光",
    "messageInitContent_3291": "蜃姐快来！",
    "messageInitContent_3292": "快把我的三叉戟抬过来",
    "messageInitContent_3293": "玻耳修斯快来！",
    "messageInitContent_3294": "请问谁要叫车",
    "messageInitNick_3439": "蛋挞牧师",
    "messageInitNick_3423": "最爱油菜",
    "messageInitNick_3422": "捣蛋鬼",
    "messageInitNick_3421": "纯天然",
    "messageInitNick_3420": "可爱卷心菜",
    "messageInitNick_3427": "笨蛋一生幸福",
    "messageInitNick_3426": "别爱我我怕疼",
    "messageInitNick_3425": "清澈的水波",
    "messageInitNick_3424": "不想醒来的梦",
    "messageInitNick_3429": "年事雪糕",
    "messageInitNick_3428": "无公害柚子",
    "iapBuyConfigName_1715": "实惠进化孢子礼包",
    "iapBuyConfigName_1716": "钜惠万能光谱礼包",
    "iapBuyConfigName_1713": "钜惠进化孢子礼包",
    "iapBuyConfigName_1714": "优惠进化孢子礼包",
    "iapBuyConfigName_1711": "橙双效起源盘礼包",
    "iapBuyConfigName_1712": "超凡起源盘礼包",
    "iapBuyConfigName_1710": "紫双效起源盘礼包",
    "messageInitNick_3412": "洗衣液的故事",
    "messageInitNick_3411": "何处可安生",
    "messageInitNick_3410": "酸甜彩虹糖",
    "messageInitNick_3416": "赤道少女",
    "messageInitNick_3415": "一个人挺好",
    "messageInitNick_3414": "告别多巴胺",
    "messageInitNick_3413": "蒜撞地球",
    "iapBuyConfigName_1719": "紫色元核髓盒",
    "messageInitNick_3419": "爱兔兔",
    "iapBuyConfigName_1717": "优惠万能光谱礼包",
    "messageInitNick_3418": "智能鸡精",
    "iapBuyConfigName_1718": "实惠万能光谱礼包",
    "messageInitNick_3417": "柿子之心",
    "iapBuyConfigName_1704": "重生宿命礼包",
    "iapBuyConfigName_1705": "特惠金币礼包",
    "activityTaskDes_199": "挑战猎物{1}次",
    "iapBuyConfigName_1702": "嗜血宿命礼包",
    "iapBuyConfigName_1703": "稳固宿命礼包",
    "iapBuyConfigName_1701": "暴怒宿命礼包",
    "messageInitNick_3401": "大艺术家",
    "activityTaskDes_190": "累计充值{1}",
    "messageInitNick_3400": "火车不会出轨",
    "activityTaskDes_193": "累计充值{1}",
    "messageInitNick_3405": "高美男",
    "activityTaskDes_194": "登录游戏{1}次",
    "messageInitNick_3404": "吃瓜带头人",
    "activityTaskDes_191": "累计充值{1}",
    "messageInitNick_3403": "电子糖果",
    "activityTaskDes_192": "累计充值{1}",
    "messageInitNick_3402": "贩糖仙女",
    "activityTaskDes_197": "部落支配核心捐献{1}次",
    "iapBuyConfigName_1708": "百炼起源盘礼包",
    "messageInitNick_3409": "半页童话",
    "activityTaskDes_198": "挑战凿星裂痕{1}次",
    "iapBuyConfigName_1709": "蓝双效起源盘礼包",
    "messageInitNick_3408": "苹果的脉动",
    "activityTaskDes_195": "消耗尖刺{1}次",
    "iapBuyConfigName_1706": "特惠粉尘礼包",
    "messageInitNick_3407": "吸猫的野心",
    "activityTaskDes_196": "赠送好友好点数{1}次",
    "iapBuyConfigName_1707": "精制起源盘礼包",
    "messageInitNick_3406": "但愿花常在",
    "activityTaskDes_188": "累计充值{1}",
    "activityTaskDes_189": "累计充值{1}",
    "activityTaskDes_182": "通关凿星裂痕{1}次",
    "activityTaskDes_183": "任意元核强化{1}次",
    "activityTaskDes_180": "挑战部落冒险关卡或者部落图腾{1}次",
    "activityTaskDes_181": "挑战暴走旷野{1}次",
    "activityTaskDes_186": "任意怪兽提升{1}级",
    "activityTaskDes_187": "消耗{1}或以上的钻石",
    "activityTaskDes_184": "任意怪兽极化{1}次",
    "activityTaskDes_185": "任意怪兽基因强化{1}次",
    "activityTaskDes_179": "任意商店购买道具{1}次",
    "messageInitNick_10806": "孤傲小公举",
    "messageInitNick_10807": "睡梦中勿打扰",
    "activityTaskDes_177": "造唤台造唤{1}次",
    "messageInitNick_10804": "你毕业了",
    "activityTaskDes_178": "黑暗森林探索{1}次",
    "messageInitNick_10805": "大橘为重",
    "messageInitNick_10808": "明年上岸",
    "messageInitNick_10809": "私奔的缩写是",
    "messageInitNick_10802": "无敌的狮王",
    "messageInitNick_10803": "天先别黑",
    "messageInitNick_10800": "尖叫柿子",
    "messageInitNick_10801": "把你归还人海",
    "activityTaskDes_175": "挑战斗技场{1}次",
    "activityTaskDes_176": "通关永生之茧{1}次",
    "activityTaskDes_173": "击破复制体{1}次",
    "activityTaskDes_174": "挑战起源殿{1}次",
    "messageInitNick_10839": "饭店老板",
    "messageInitNick_10837": "芝士球大冒险",
    "messageInitNick_10838": "蟹柳没有蟹",
    "messageInitContent_3204": "又是被自己饿醒的一天",
    "messageInitContent_5867": "什么还环海路线",
    "messageInitNick_10831": "蝶翅稳花稍",
    "messageInitContent_3205": "嚣张",
    "messageInitContent_5866": "你家小白呢",
    "messageInitNick_10832": "葬送的魔鬼",
    "messageInitContent_3206": "叉腰",
    "messageInitContent_5869": "腾云驾雾而来",
    "messageInitContent_3207": "金轮法王在此",
    "messageInitContent_5868": "受访怪兽腾某表示",
    "messageInitNick_10830": "消息可靠",
    "messageInitContent_3208": "鼻子",
    "messageInitNick_10835": "心脏大逃亡",
    "messageInitContent_3209": "梦醒了",
    "messageInitNick_10836": "吃醋的米虫",
    "messageInitNick_10833": "六月五瓣雪",
    "messageInitNick_10834": "纯情海盐",
    "messageInitContent_5870": "这关我会",
    "messageInitContent_5872": "伶仃的幻化小怪",
    "messageInitContent_3210": "哥就是自信",
    "messageInitContent_5871": "告辞",
    "messageInitContent_3211": "发出害羞的声音",
    "messageInitContent_5874": "我的荆！",
    "messageInitContent_3212": "我要进这个门派",
    "messageInitContent_5873": "画风变了",
    "messageInitContent_3213": "怎么加入",
    "messageInitContent_5876": "这腿爱了（指剧",
    "messageInitContent_3214": "我现在就要加入",
    "messageInitContent_5875": "前排表白",
    "messageInitNick_10848": "长安花落尽",
    "messageInitNick_10849": "满脸绯红",
    "messageInitContent_3215": "草中一点粉",
    "messageInitContent_5878": "晚安海螺",
    "messageInitNick_10842": "天弃之子",
    "messageInitContent_3216": "不要躲在草丛里呀",
    "messageInitContent_5877": "啊司机",
    "messageInitNick_10843": "捕梦大叔",
    "messageInitContent_3217": "好多小小只",
    "messageInitNick_10840": "卡都是捡来的",
    "messageInitContent_3218": "御空（尖叫）",
    "messageInitContent_5879": "超进化掌管守护的神",
    "messageInitNick_10841": "枸杞征服世界",
    "messageInitContent_3219": "我需要冰霓",
    "messageInitNick_10846": "胜听一席话",
    "messageInitNick_10847": "迷路的手掌骨",
    "messageInitNick_10844": "闲事保管员",
    "messageInitNick_10845": "爱因斯不舒坦",
    "messageInitContent_5881": "huh？",
    "messageInitContent_5880": "海的那边见",
    "messageInitContent_3220": "ineed冰霓",
    "messageInitContent_5883": "哪里的杀伤力",
    "messageInitContent_3221": "我要空调",
    "messageInitContent_5882": "马上到古记",
    "messageInitContent_3222": "我要跳进蜃兽背后的湖水里",
    "messageInitContent_5885": "地龙么么哒",
    "messageInitContent_3223": "好怪哦",
    "messageInitContent_5884": "这会是人间打炮",
    "messageInitContent_3224": "咦惹",
    "messageInitContent_5887": "觉醒搭配干活不累",
    "messageInitContent_3225": "污污污污污污污污",
    "messageInitContent_5886": "放学啦，社会大学放学啦",
    "messageInitNick_10817": "秋风落叶",
    "messageInitNick_10818": "纯天然的美貌",
    "messageInitNick_10815": "柿子射手",
    "messageInitNick_10816": "泪姬",
    "messageInitNick_10819": "高端大器",
    "messageInitContent_3226": "看来需要树德教育",
    "messageInitContent_5889": "要抱抱",
    "messageInitContent_3227": "怪兽的赞歌就是勇气的赞歌",
    "messageInitContent_5888": "情侣档？",
    "messageInitNick_10810": "最爱草莓",
    "messageInitContent_3228": "那你好勇哦",
    "messageInitContent_3229": "胸口刻着勇",
    "messageInitNick_10813": "香菜凤仁鸡",
    "messageInitNick_10814": "别口胡了",
    "messageInitNick_10811": "撒盐狂徒",
    "messageInitNick_10812": "独孤十一剑",
    "messageInitContent_5892": "吸溜",
    "messageInitContent_3230": "各位勇士",
    "messageInitContent_5891": "今天的班就上到这了",
    "messageInitContent_3231": "想为古龙代笔",
    "messageInitContent_5894": "萌新探头",
    "messageInitContent_3232": "白昼姐姐我受伤了能不能",
    "messageInitContent_5893": "hhhhhhh",
    "messageInitContent_3233": "我的心受伤了",
    "messageInitContent_5896": "尬住",
    "messageInitContent_3234": "点赞+1",
    "messageInitContent_5895": "八嘎八嘎八嘎",
    "messageInitContent_3235": "蒜了吧",
    "messageInitContent_5898": "祝福大家成功上岸",
    "messageInitContent_3236": "白昼是我滴",
    "messageInitContent_5897": "上岸",
    "messageInitContent_5890": "哈？",
    "activityTaskDes_113": "累计翻牌{1}次",
    "messageInitNick_10828": "小胖友",
    "messageInitNick_10829": "半仙",
    "messageInitNick_10826": "疯狂小蚂蚁",
    "messageInitNick_10827": "十二点的公主",
    "messageInitContent_3237": "问此关有多少龙jio",
    "messageInitNick_10820": "纯情辣椒酱",
    "messageInitContent_3238": "问此关有多少龙角",
    "messageInitContent_5899": "啊我的舌头粘住了，噢，我的冰",
    "messageInitNick_10821": "龙眼之心",
    "messageInitContent_3239": "6 哇",
    "messageInitNick_10824": "全息甜点",
    "messageInitNick_10825": "晚餐你克制点",
    "messageInitNick_10822": "阁下摸鱼很强",
    "messageInitNick_10823": "渐显实力",
    "messageInitContent_3240": "真的好怕蜃蜃被戳到",
    "messageInitContent_3241": "扎心了老独角兽",
    "messageInitContent_3242": "扎心了老兽",
    "messageInitContent_3243": "嗯？",
    "messageInitContent_3244": "要来一杯凉茶降降火吗",
    "messageInitContent_3245": "热情真热情",
    "messageInitContent_3246": "热烈欢迎233",
    "messageInitContent_3247": "好热啊",
    "activityTaskDes_102": "已购买纹银月曜",
    "activityTaskDes_103": "已购买鎏金月曜",
    "activityTaskDes_101": "累计登录{1}日",
    "activityTaskDes_106": "邀请{1}位好友",
    "activityTaskDes_104": "累计消耗{1}钻石",
    "activityTaskDes_105": "累计击破属于自己的{1}个复制体",
    "messageInitContent_3248": "500是一千的一半",
    "messageInitNick_10875": "乐中作苦",
    "messageInitContent_3249": "确实是很大的一掌",
    "messageInitNick_10876": "三点的凉茶",
    "messageInitNick_10873": "不要张嘴",
    "messageInitNick_10874": "折翼的鸡翅",
    "messageInitNick_10879": "甜酸鸡翅",
    "messageInitNick_10877": "闷声发大财",
    "messageInitNick_10878": "高校香蕉君",
    "messageInitContent_3251": "这个体型有攻城武器的感觉了",
    "messageInitContent_3252": "用对城宝具打我可以的",
    "messageInitContent_3253": "怕怕总是带头冲锋",
    "messageInitContent_3254": "勇敢牛牛不怕困难",
    "messageInitContent_3255": "想rua尾巴",
    "messageInitNick_10871": "国民小公举",
    "messageInitContent_3256": "欢迎大家",
    "messageInitNick_10872": "酱爆肉",
    "messageInitContent_3257": "我来啦啦啦",
    "messageInitContent_3258": "这一掌又毒又烧",
    "messageInitNick_10870": "插翅虎",
    "messageInitContent_3250": "这掌风还没开始打就feel到了",
    "13_comment": "黑暗森林",
    "messageInitContent_3259": "一个减低霸气，一个加自己霸气是吧",
    "messageInitNick_10886": "动物观察者",
    "messageInitNick_10887": "沉醉红颜",
    "messageInitNick_10884": "落霞与孤鹜",
    "messageInitNick_10885": "有故事的人",
    "messageInitNick_10888": "撩妹课代表",
    "messageInitNick_10889": "泡面怪兽",
    "messageInitContent_3262": "我先给大家探探路",
    "messageInitContent_3263": "镇魂剧王想你了",
    "messageInitContent_3264": "让我看看你带了什么元核",
    "messageInitContent_3265": "啊是司机",
    "messageInitContent_3266": "好大只镇魂",
    "messageInitNick_10882": "薄涼少年",
    "messageInitContent_3267": "一夫拚命，万夫难敌",
    "messageInitNick_10883": "神奇的莓子",
    "messageInitContent_3268": "射程再见了",
    "messageInitNick_10880": "连呼吸都会痛",
    "messageInitContent_3269": "爷哭了",
    "messageInitNick_10881": "技术翻译家",
    "messageInitContent_3260": "疯狂dot是吧",
    "messageInitContent_3261": "还带了个小老虎",
    "messageInitNick_10859": "又一个沙漠",
    "messageInitNick_10853": "彻底疯狂",
    "messageInitNick_10854": "逃出天堂",
    "messageInitNick_10851": "科目三大师",
    "messageInitNick_10852": "狂飙的狮子",
    "messageInitNick_10857": "尽力了吗",
    "messageInitNick_10858": "电视的雪景",
    "messageInitNick_10855": "它菜菜",
    "messageInitNick_10856": "夹娃娃的叔叔",
    "messageInitContent_3273": "有可爱的小哥哥吗",
    "messageInitContent_3274": "锤砸你怎么跑这了",
    "messageInitContent_3275": "锤子你要离开五小强了吗",
    "messageInitContent_3276": "出息了呀1000了",
    "messageInitContent_3277": "阔以阔以",
    "messageInitContent_3278": "你懂个锤子",
    "messageInitNick_10850": "安稳先生",
    "messageInitContent_3279": "这分明是小鸡扑腾",
    "messageInitContent_3270": "这里应该要整点鱼竿",
    "messageInitContent_3271": "想去钓鱼",
    "messageInitContent_3272": "有可爱的小姐姐吗",
    "messageInitNick_10864": "在月亮上罚站",
    "messageInitNick_10865": "弹幕养肥中",
    "messageInitNick_10862": "未谱完的曲",
    "messageInitNick_10863": "不止眼前的狗",
    "messageInitNick_10868": "便利店老板",
    "messageInitNick_10869": "六点的拉面",
    "messageInitNick_10866": "电台主持人",
    "messageInitNick_10867": "铁球捕捉者",
    "messageInitContent_3284": "想吃鸡腿了",
    "messageInitContent_3285": "哪里危险了",
    "messageInitContent_3286": "打得真好",
    "messageInitContent_3287": "loading",
    "messageInitContent_3288": "呵",
    "messageInitNick_10860": "好瘦的八戒啊",
    "messageInitContent_3289": "我是预言家",
    "messageInitNick_10861": "纯真的世界",
    "messageInitContent_3280": "介次……",
    "messageInitContent_3281": "别装了",
    "messageInitContent_3282": "大鹏？？？？？？",
    "messageInitContent_3283": "在逗我",
    "messageInitContent_5908": "这是小海草",
    "messageInitContent_5907": "这还小草",
    "messageInitContent_5909": "文明用语你我有责",
    "messageInitContent_5900": "你继续说反正我不停",
    "messageInitNick_10798": "零下一度",
    "messageInitNick_10799": "吃斋的狼",
    "messageInitContent_5902": "重赤哦",
    "messageInitNick_10796": "涨薪王者",
    "messageInitContent_5901": "嗨嗨嗨",
    "messageInitNick_10797": "空之歌",
    "messageInitContent_5904": "第一次看清它的后备",
    "messageInitContent_5903": "果然还是老熟人",
    "messageInitContent_5906": "小岛见",
    "messageInitContent_5905": "这麻麻的尾巴好像加了新特效",
    "messageInitNick_10790": "世界第二善良",
    "messageInitNick_10791": "你不在的演出",
    "messageInitNick_10794": "成功的抱抱",
    "messageInitNick_10795": "半袖桃花",
    "messageInitNick_10792": "别再沦陷",
    "messageInitNick_10793": "可爱的泥鳅",
    "messageInitContent_5919": "来一起睡觉吧",
    "messageInitContent_5918": "又又又大错了",
    "messageInitContent_5911": "拿个外卖先",
    "messageInitContent_5910": "今晚吃啥",
    "messageInitContent_5913": "尸狂尸狂我要迪斯尼",
    "messageInitContent_5912": "海上摇滚",
    "messageInitContent_5915": "摇滚？Rap？",
    "messageInitContent_5914": "幻幻我要迪斯尼",
    "messageInitContent_5917": "空蝉更可爱了",
    "messageInitContent_5916": "这都哪跟哪",
    "messageInitContent_5920": "超2启动",
    "messageInitContent_5929": "那你很棒棒哦",
    "21_50": "提交",
    "21_51": "绑定说明：\\n1.账号一旦完成绑定则无法进行解绑或换绑，请谨慎操作。\\n2.绑定后原（雷霆）账号下的所有角色都将一并迁移至新NTFusion账号，无法将同一雷霆账号下的多个角色进行拆分绑定。\\n3.每个雷霆账号的账号信息只能迁移至一个NTFusion账号，拥有多个雷霆账号的玩家需要申请对应数量的NTFusion账号进行迁移。",
    "21_52": "账号迁移",
    "21_53": "账号已提交迁移认证",
    "21_54": "发送成功",
    "messageInitContent_5922": "钢门",
    "messageInitNick_10776": "互联网大佛",
    "messageInitContent_5921": "大噶好",
    "messageInitNick_10777": "灵巧的蓝人",
    "messageInitContent_5924": "还有这种门派",
    "messageInitNick_10774": "大葱魔法",
    "messageInitContent_5923": "？？？",
    "messageInitNick_10775": "微波炉之彼端",
    "messageInitContent_5926": "可怕",
    "messageInitContent_5925": "剧门",
    "messageInitContent_5928": "突然有点不习惯，不够大",
    "messageInitNick_10778": "会谈恋爱的猪",
    "messageInitContent_5927": "我想开了",
    "messageInitNick_10779": "捡漏鉴定家",
    "messageInitNick_10772": "车厘子射手",
    "messageInitNick_10773": "豆瓣菜魔法师",
    "messageInitContent_5931": "谁会",
    "messageInitNick_10770": "自私的前锋",
    "messageInitContent_5930": "嗷嗷嗷嗷",
    "messageInitNick_10771": "懂鉴定家",
    "21_44": "原账号（雷霆SID）：{1}",
    "21_45": "绑定后的NT登录账号：{1}",
    "21_46": "迁移认证",
    "21_47": "雷霆账号手机号",
    "21_48": "验证码",
    "21_49": "发送",
    "messageInitContent_5933": "是它！",
    "messageInitNick_10787": "家里蹲大学",
    "messageInitContent_5932": "猜猜谁攻击更高",
    "messageInitNick_10788": "一块六毛",
    "messageInitContent_5935": "连夜通关",
    "messageInitNick_10785": "倍儿坚强",
    "messageInitContent_5934": "挺搭的",
    "messageInitNick_10786": "不捡一级头",
    "messageInitContent_5937": "大佬？书",
    "messageInitContent_5936": "刚醒",
    "messageInitContent_5939": "空白试卷？",
    "messageInitNick_10789": "头脑风暴",
    "messageInitContent_5938": "阅读使人减伤",
    "messageInitNick_10780": "全剧终",
    "messageInitContent_5940": "下班！！！",
    "messageInitNick_10783": "下手轻一点",
    "messageInitNick_10784": "怪兽小当家",
    "messageInitContent_5942": "这肉感",
    "messageInitNick_10781": "美容霜的故事",
    "messageInitContent_5941": "阴暗在蠕动",
    "messageInitNick_10782": "岸边花",
    "21_55": "适龄提示\\n1.本游戏是一款难度适中的策略手游，适用于年满 12 周岁及以上的用户，建议未成年人在家长监护下使用游戏产品。\\n2.本游戏基于架空的故事背景，剧情简单且积极向上，部分角色有区别于现实场景的适度改编，不会与现实混淆。游戏中有基于文字的陌生人社交系统。\\n3.本游戏已接入国家实名认证系统，未实名认证用户将无法登录游戏进行任何的游戏体验。游戏中部分玩法和道具需要付费。\\n4.游戏鼓励玩家通过探索不同的队伍搭配、养成方式和战斗策略达成通关目标。",
    "21_30": "记得",
    "21_31": "不记得",
    "21_32": "终焉？",
    "messageInitContent_5944": "超重怪兽了",
    "messageInitContent_5943": "只能看到肚子了",
    "messageInitContent_5946": "御星特别版",
    "messageInitContent_5945": "吃啥长的",
    "messageInitContent_5948": "让我来现场给它做个体检",
    "messageInitContent_5947": "好大坨肉盾",
    "messageInitContent_5949": "我觉得4号位可以加大一点",
    "messageInitContent_5951": "不能同意得更多",
    "messageInitContent_5950": "附议",
    "messageInitContent_5953": "我要狂潮形态！",
    "messageInitContent_5952": "咦",
    "21_22": "预祝你获得璀璨如夏花般的旅途。",
    "21_23": "期待我们的下一次见面，一次一次再一次……",
    "21_24": "你认为这条隧道最终通往何处？",
    "21_25": "游戏世界",
    "21_26": "超进化大陆",
    "21_27": "明白了，一个光怪陆离的游戏世界。",
    "21_28": "欢迎回到超进化大陆，我的朋友。",
    "21_29": "你记得“终焉”吗？",
    "21_40": "领取奖励",
    "21_41": "已发放",
    "21_42": "前往绑定",
    "21_43": "<face color=#ffffff dilate=0.52 softness=0.07>亲爱的探索者：\\n\\n          感谢大家一直以来对《超进化物语2》的支持与厚爱。由于《超进化物语2》的研发方NTFusion和运营方雷霆游戏在发行运营上的合作即将到期，经双方友好协商，从<face color=#feba29 dilate=0.52 softness=0.07>2024年11月12日</face>开始，《超进化物语2》的发行运营事宜将由NTFusion负责，即NTFusion将接手《超进化物语2》所有账号角色数据，并做好运营交接工作，继续为各位探索者提供优质服务，全力确保您的游戏进程不受影响。\\n         在2024年11月12日停服维护完成后，请您按以下方式进行账号迁移，以保障您在超进化大陆的探索之旅可以继续。\\n         <face color=#feba29 dilate=0.52 softness=0.07>如果您是雷霆账号系统的探索者</face>（包含官方安卓、iOS、TapTap、好游快爆、微博、微信等阵地下载的包体），则您需要通过<face color=#feba29 dilate=0.52 softness=0.07>【账号迁移】</face>功能进行账号绑定，该操作并不会影响您的正常游戏体验，绑定成功后可通过邮件获得限时账号绑定福利<face color=#feba29 dilate=0.52 softness=0.07>【钻石*100】</face>。在2025年1月15日【账号迁移】功能关闭后，需要下载新的游戏包体，并使用NTFusion账号系统进行登录，角色数据和进度不变，原账号（雷霆）将无法继续登录游戏。\\n         若账号迁移过程中遇到任何异常情况，您可查看下方【账号迁移FAQ】或添加客服QQ（3274465013，需输入验证信息【账号迁移】添加好友）联系NTFusion客服，我们将全力解决您遇到的问题，配合做好账号迁移工作。\\n<face color=#feba29 dilate=0.52 softness=0.07>         如果您是其他渠道的探索者</face>，那么您无需进行账号迁移，仍可继续使用原账号登录。\\n         请您合理安排游戏时间、及时进行账号迁移操作。再次感谢大家一直以来对《超进化物语2》的支持，祝大家游戏愉快。\\n\\n                                                                                                                                            超进化委员会\\n                                                                                                                                      2024年11月11日\\n\\n<face color=#feba29 dilate=0.52 softness=0.07>【账号迁移FAQ】</face>\\n\\n<face color=#a6bddd dilate=0.52 softness=0.07>Q：为什么需要您进行游戏迁移和绑定？</face>\\nA：基于《超进化物语2》的运营商即将变更，您需要在2025年1月15日前及时完成迁移与绑定，以确保自己的游戏进度和数据不受影响。为了不影响您的游戏体验，请您尽快进行迁移操作。\\n\\n<face color=#a6bddd dilate=0.52 softness=0.07>Q：哪些探索者需要进行账号迁移呢？具体要如何操作？</face>\\nA：如果您是雷霆账号系统的探索者（包含官方安卓、iOS、TapTap、好游快爆、微博、微信等阵地下载的包体），则您需要进行账号迁移，迁移步骤如下：\\n\\n1.在2024年11月12日停服维护完成后，使用雷霆账号登入游戏，在选服界面通过【账号迁移】功能进行账号绑定。点击【账号迁移】后再点击【前往绑定】将会跳转至NTFusion账号登录注册页。\\n2.可通过手机号验证码或账号密码两种方式注册NTFusion账号。若通过手机号验证码进行注册登录，可在输入手机号后，点击【获取验证码】，再进行登录。若通过账号密码进行注册登录，可点击其他登录方式下的图标，点击【立即注册】，完成注册后再进行登录。\\n3.完成NTFusion账号注册并登录后，点击【确认绑定】按钮完成绑定。绑定完成后，您仍可以使用原账号（雷霆）正常登录游戏进行游玩。\\n<face color=#feba29 dilate=0.52 softness=0.07>重要提示：请探索者务必妥善保管好自己原账号（雷霆）和NTFusion账号的登录信息，注意个人隐私安全，以免遗忘或在绑定过程中出现不必要的损失！</face>\\n4.在2025年1月15日【账号迁移】功能关闭后，需要在对应的平台下载新的游戏包体，并使用NTFusion账号系统进行登录，角色数据和进度不变，原账号（雷霆）将无法继续登录游戏。若尚未完成绑定，可通过联系人工客服的方式完成账号迁移。\\n\\n如果您是其他渠道的探索者（包含在华为、OPPO、vivo、bilibili、小米、九游、应用宝、4399等阵地下载的包体），那么您无需进行账号迁移。在2025年1月15日【账号迁移】功能关闭后，您只需要在渠道平台下载新的游戏包体即可用原来的账号正常进行游戏，原有的旧游戏包体将无法使用。\\n\\n<face color=#a6bddd dilate=0.52 softness=0.07>Q：如何确认自己的账号是否迁移和绑定成功？</face>\\nA：当探索者确认绑定后，将出现【您的账号已成功完成绑定！】的提示，再次打开【账号迁移】界面页可查看到您的绑定信息。当账号迁移出现异常时，原账号（雷霆SID）可作为验证原账号的依据之一。在2025年1月15日【账号迁移】功能关闭后，需要下载新的游戏包体，通过绑定后的NT登录账号进行登录。\\n\\n<face color=#a6bddd dilate=0.52 softness=0.07>Q：完成账号绑定与迁移后，有什么福利吗？</face>\\nA：对于此次账号迁移给您造成的不便，我们准备了相应的限时账号绑定福利。账号迁移完成后，账号下的每个角色均可通过邮件获得限时账号绑定福利【钻石*100】，福利发放存在半小时左右的延迟，还请您耐心等待。\\n\\n<face color=#a6bddd dilate=0.52 softness=0.07>Q：账号迁移过程有什么需要注意的吗？</face>\\nA：账号一旦完成迁移和绑定则无法进行解绑，绑定后，原账号（雷霆）下的所有角色都将一并迁移至新NTFusion账号，无法将同一雷霆账号下的多个角色进行拆分绑定。\\n\\n<face color=#a6bddd dilate=0.52 softness=0.07>Q：如果在2025年1月15日【账号迁移】功能关闭前没有完成账号迁移怎么办？</face>\\nA：在2025年1月15日【账号迁移】功能关闭后，可进行人工账号迁移。\\n\\n<face color=#a6bddd dilate=0.52 softness=0.07>Q：人工账号迁移具体要如何操作？</face>\\nA：在2025年1月15日【账号迁移】功能关闭后，可留意官方发布的【人工账号迁移说明公告】查看详细人工账号迁移流程。\\n\\n<face color=#a6bddd dilate=0.52 softness=0.07>Q：账号迁移的过程中出现问题该怎么办？</face>\\nA：若您在账号迁移的过程中遇到问题，可以添加客服QQ（3274465013，需输入验证信息【账号迁移】添加好友）向我们的游戏客服反馈。\\n\\n<face color=#a6bddd dilate=0.52 softness=0.07>Q：《超进化物语2》马上一周年了！周年庆版本的爆料在哪？在线等！急！</face>\\nA：嗯？FAQ之中怎么混进了一条神奇的问题？<face color=#a6bddd dilate=0.52 softness=0.07>（抢过话筒）</face>这个问题必须由本爆料仁亲自出马回答！\\n咳咳！在《超进化物语2》<face color=#feba29 dilate=0.52 softness=0.07>一周年</face>的大日子中！<face color=#feba29 dilate=0.52 softness=0.07>全新位面</face>【？？？？】将褪去迷雾，<face color=#feba29 dilate=0.52 softness=0.07>新双种族觉醒怪兽</face>随之降临！此外，进化树<face color=#feba29 dilate=0.52 softness=0.07>原生族</face>那块好像又热闹了一些~不仅如此，<face color=#feba29 dilate=0.52 softness=0.07>战墙</face>的武装之魂突然大爆发，解锁多种武装即可启用战墙新力量！刚好，叉叉拉着一大堆<face color=#feba29 dilate=0.52 softness=0.07>新福利</face>过来了！ 啊怎么回事，我的仁眼，还有这熟悉的进化BGM！<face color=#feba29 dilate=0.52 softness=0.07>叉叉</face>你怎么突然在发光<face color=#a6bddd dilate=0.52 softness=0.07>（推开叉叉）</face>快别挡着探索者关注官方社区啊！因为后头还有2.0、2.1……2.n版本的相关新资讯，新怪兽、新玩法、新福利陆续有来，千万不要错过啊啊啊啊啊！</face>",
    "messageInitContent_5955": "你好我的电子仙人掌",
    "messageInitContent_5954": "这仙人掌是谁咬",
    "messageInitContent_5957": "是大猫咪",
    "messageInitContent_5956": "大王",
    "messageInitContent_5959": "有点冷来取暖",
    "messageInitContent_5958": "兰花指瞩目",
    "messageInitContent_5960": "装成晴天娃娃",
    "messageInitContent_5962": "今晚吃臭豆腐",
    "messageInitContent_3300": "深情",
    "messageInitContent_5961": "有点饿来烧烤",
    "messageInitContent_3301": "采蘑菇的小姑娘",
    "messageInitContent_5964": "祝大家发发发",
    "messageInitContent_3302": "这里好像没有什么光滑的平面啊",
    "messageInitContent_5963": "隔壁温泉",
    "21_33": "那么请再次跟随我进入这段记忆，找出忘却的部分吧，探索者！",
    "21_34": "首次？探索者……深呼吸吧，跟随我进入这段记忆，然后再见！",
    "21_35": "终焉……也被称为重启时刻，跟随我进入彼刻自己确认一次吧，探索者！",
    "21_36": "开始游戏",
    "21_37": "账号迁移",
    "21_38": "账号迁移须知",
    "21_39": "绑定奖励",
    "21_10": "火爆",
    "messageInitContent_3303": "那两小jio",
    "messageInitContent_5966": "赶紧拿来拿坨屎",
    "messageInitContent_3304": "芜湖",
    "messageInitContent_5965": "8888888！恭喜发财",
    "messageInitContent_3305": "起飞",
    "messageInitContent_5968": "号码不错",
    "messageInitContent_3306": "贴贴",
    "messageInitContent_5967": "打呀打呀大萝卜",
    "messageInitContent_3307": "有吓到",
    "messageInitContent_3308": "我的小朋友呢",
    "messageInitContent_5969": "隔壁发财",
    "messageInitContent_3309": "呼叫玄武！",
    "messageInitContent_5971": "怪兽的吉他算身高吗",
    "messageInitContent_5970": "怪兽的角算身高的吗",
    "messageInitContent_3310": "发条魔马",
    "messageInitContent_5973": "火气有点重啊，喝点凉茶",
    "messageInitContent_3311": "你的眼里为什么喊着泪水",
    "messageInitContent_5972": "前排打call",
    "messageInitContent_3312": "暗示太过辣眼",
    "messageInitContent_5975": "好大的红唇",
    "messageInitContent_3313": "霸气0",
    "messageInitContent_5974": "阿这",
    "21_20": "一往无前",
    "21_21": "活下去",
    "messageInitContent_3314": "他好拼",
    "messageInitContent_5977": "可爱爱捏",
    "messageInitContent_3315": "气奥是唯一的绿光",
    "messageInitContent_5976": "比心心",
    "messageInitContent_3316": "你是光你是电",
    "messageInitContent_5979": "乖巧",
    "messageInitContent_3317": "既然如此就别怪我不客气了",
    "messageInitContent_5978": "喵喵拳",
    "messageInitContent_3318": "好大只",
    "messageInitContent_3319": "主角待遇",
    "21_19": "你认为什么是进化？",
    "messageInitContent_5980": "你见过大象的第五条腿吗",
    "messageInitContent_5982": "不想努力了",
    "messageInitContent_3320": "直接抱走",
    "messageInitContent_5981": "我来啦~",
    "messageInitContent_3321": "御空是我的，其他你们随便",
    "messageInitContent_5984": "我先变个身",
    "messageInitContent_3322": "抱走绒绒",
    "messageInitContent_5983": "开饭开饭",
    "messageInitContent_3323": "抱走重装",
    "messageInitContent_5986": "想我漆黑宝的一天",
    "messageInitContent_3324": "大家都是不朽怎么就你",
    "messageInitContent_5985": "看剑",
    "21_11": "爆满",
    "21_12": "游戏公告",
    "21_13": "一次无意义的测试，随意选择，简单回答吧。\\n大概……什么都无法改变。",
    "21_14": "你是否认为自己所处的星球很独特？",
    "21_15": "当然",
    "21_16": "不认为",
    "21_17": "多么傲慢的回答，跟它一样傲慢……",
    "21_18": "你……或许真的没有它们想象中独特，也或许……更为独特。",
    "messageInitNick_3397": "上帝的骰子",
    "messageInitNick_3396": "锅盖男孩",
    "messageInitNick_3395": "红色龙卷风",
    "messageInitNick_3394": "忍住不破防",
    "messageInitNick_3399": "我没惹任何人",
    "messageInitNick_3398": "懂冠军",
    "messageInitNick_3393": "榴莲魔法师",
    "messageInitNick_3392": "午夜狗叫",
    "messageInitNick_3391": "芭蕉魔法师",
    "messageInitNick_3390": "芭比蜀黍",
    "messageInitNick_3386": "魔杖不是筷子",
    "messageInitNick_3385": "梦幻火龙果",
    "messageInitNick_3384": "躲起来",
    "messageInitNick_3383": "甲鱼先生",
    "messageInitNick_3389": "别摸我猫耳朵",
    "messageInitNick_3388": "富婆看看我",
    "messageInitNick_3387": "草莓布丁",
    "messageInitNick_3382": "假动作",
    "messageInitNick_3381": "吃瓜勇者",
    "messageInitNick_3380": "冰雪伊人",
    "messageInitNick_3375": "会飞的警亭",
    "messageInitNick_3374": "臭臭的香猪",
    "messageInitNick_3373": "上午九点半",
    "messageInitNick_3372": "樱桃喵喵怪",
    "messageInitNick_3379": "焦虑的考拉",
    "messageInitNick_3378": "爱女神喵喵",
    "messageInitNick_3377": "浮云中的奇葩",
    "messageInitNick_3376": "光怪陆离的梦",
    "messageInitNick_3371": "李子龙",
    "messageInitNick_3370": "拖鞋先锋",
    "messageInitNick_3364": "鼠标吃书中",
    "messageInitNick_3363": "能跑就不要动",
    "messageInitNick_3362": "从不缺爱",
    "messageInitNick_3361": "柿子去哪了",
    "messageInitNick_3368": "正义口胡人",
    "messageInitNick_3367": "期待的眼神",
    "messageInitNick_3366": "不败姑娘",
    "messageInitNick_3365": "超时空烤箱",
    "messageInitNick_3369": "开始就认输",
    "messageInitNick_3360": "机械化龙眼",
    "messageInitNick_3353": "动感超人",
    "messageInitNick_3352": "浪客刀心",
    "messageInitNick_3351": "精致的镜子",
    "messageInitNick_3350": "小小花生米",
    "messageInitNick_3357": "降龙十巴掌",
    "messageInitNick_3356": "这谁顶得住",
    "messageInitNick_3355": "中午吃通菜",
    "messageInitNick_3354": "流水恋落花",
    "messageInitNick_3359": "果味小可爱",
    "messageInitNick_3358": "呆萌小魔女",
    "iapBuyConfigName_1603": "幸运之约III",
    "iapBuyConfigName_1601": "幸运之约I",
    "iapBuyConfigName_1602": "幸运之约II",
    "messageInitNick_3342": "流浪的肱骨",
    "messageInitNick_3341": "加糖珍珠奶茶",
    "messageInitNick_3340": "耳机狂怒者",
    "messageInitNick_3346": "智能花生酱",
    "messageInitNick_3345": "流星番茄",
    "messageInitNick_3344": "机动猕猴桃",
    "messageInitNick_3343": "超级打脸神",
    "messageInitNick_3349": "今天也要开心",
    "messageInitNick_3348": "图书馆的鸽子",
    "messageInitNick_3347": "灵感来自外卖",
    "messageInitNick_3331": "香蕉兽",
    "messageInitNick_5994": "跌得很华丽",
    "messageInitNick_3330": "高傲的女王",
    "messageInitNick_5995": "虾系男友",
    "messageInitNick_5996": "怜惜眼前人",
    "messageInitNick_5997": "好想放假",
    "messageInitNick_3335": "画饼门首席",
    "messageInitNick_5990": "霸道发型师",
    "messageInitNick_3334": "帮椰子道歉",
    "messageInitNick_5991": "霸服的琪琪",
    "messageInitNick_3333": "胖虎不胖",
    "messageInitNick_5992": "打不过张飞",
    "messageInitNick_3332": "有本事来咬我",
    "messageInitNick_5993": "和稀泥",
    "messageInitNick_3339": "摸鱼忍者",
    "messageInitNick_3338": "脸上有肉",
    "messageInitNick_3337": "绝对激情",
    "messageInitNick_3336": "水印忍者",
    "messageInitNick_5998": "匿名德鲁伊",
    "messageInitNick_5999": "神剑古拉姆",
    "messageInitNick_3320": "专业打酱油",
    "messageInitNick_5983": "锅盖头",
    "messageInitNick_5984": "好梦一日游",
    "messageInitNick_5985": "测测你几岁",
    "messageInitNick_5986": "爱情怎样喊停",
    "messageInitNick_3324": "卑怯少女",
    "messageInitNick_3323": "跟风大王",
    "messageInitNick_5980": "打不开的心门",
    "messageInitNick_3322": "多喝热水",
    "messageInitNick_5981": "黑色无欲者",
    "messageInitNick_3321": "搬砖老姐",
    "messageInitNick_5982": "变形吧金箍棒",
    "messageInitNick_3328": "柿子真好吃",
    "messageInitNick_3327": "折纸师",
    "messageInitNick_3326": "别对我心动",
    "messageInitNick_3325": "颤抖吧妹纸",
    "messageInitNick_5987": "走出世界",
    "messageInitNick_5988": "热血暑假人",
    "messageInitNick_5989": "懂高手",
    "messageInitNick_3329": "省心保温",
    "systemTaskConfigTitle_57": "源初境八强奖励",
    "systemTaskConfigTitle_56": "源初境四强奖励",
    "systemTaskConfigTitle_55": "源初境亚军奖励",
    "systemTaskConfigTitle_54": "源初境冠军奖励",
    "systemTaskConfigTitle_53": "进击巨物每日奖励",
    "systemTaskConfigTitle_52": "巨物进击每日奖励",
    "systemTaskConfigTitle_51": "部落名称修改通知",
    "systemTaskConfigTitle_50": "探索者名称修改通知",
    "messageInitNick_5972": "宝贝在干嘛",
    "messageInitNick_5973": "魔法的疑问",
    "messageInitNick_5974": "狂飙的大象",
    "messageInitNick_5975": "原本的味道",
    "messageInitNick_3313": "待我幼稚完",
    "messageInitNick_3312": "吃瓜王子",
    "messageInitNick_3311": "重新定义摸鱼",
    "messageInitNick_5970": "白珍珠巨人",
    "messageInitNick_3310": "吃饭冠军",
    "messageInitNick_5971": "再活五百岁",
    "messageInitNick_3317": "洗衣粉剑客",
    "messageInitNick_3316": "相思染春风",
    "messageInitNick_3315": "彩虹糖的梦",
    "messageInitNick_3314": "轻盈的芭乐",
    "messageInitNick_5976": "无语了家人们",
    "messageInitNick_5977": "大神舍我其谁",
    "systemTaskConfigTitle_49": "部落战轮空奖励",
    "messageInitNick_3319": "重开模拟器",
    "messageInitNick_5978": "全球第一帅",
    "systemTaskConfigTitle_48": "部落战奖励",
    "messageInitNick_3318": "伏尾窗的猫",
    "messageInitNick_5979": "豆角魔法",
    "systemTaskConfigTitle_47": "合围破阵每日奖励",
    "systemTaskConfigTitle_46": "突围鏖战每日奖励",
    "systemTaskConfigTitle_45": "到账通知",
    "systemTaskConfigTitle_44": "充值返还邮件",
    "systemTaskConfigTitle_43": "创世竞猜奖励",
    "systemTaskConfigTitle_42": "创世竞猜奖励",
    "systemTaskConfigTitle_41": "部落进入交战状态",
    "systemTaskConfigTitle_40": "部落进入交战状态",
    "17_totemModeDesc10": "战斗结束时，敌方怪兽被击退距离总和",
    "messageInitNick_5961": "冰美式的甜",
    "messageInitNick_5962": "嘟嘟脸",
    "messageInitNick_5963": "不再怕嘿",
    "messageInitNick_5964": "我飞得好高",
    "messageInitNick_3302": "请你吃凉粉",
    "messageInitNick_3301": "鱿鱼本鱼",
    "messageInitNick_3300": "霸气小哥",
    "messageInitNick_5960": "尖叫香瓜",
    "messageInitNick_3306": "芹菜撞地球",
    "messageInitNick_5969": "不要勾引猫",
    "messageInitNick_3305": "白球鞋",
    "messageInitNick_3304": "大众电灯泡",
    "messageInitNick_3303": "魔法少女",
    "messageInitNick_5965": "青春无处安放",
    "systemTaskConfigTitle_39": "到账通知",
    "messageInitNick_3309": "萌动的菠萝",
    "messageInitNick_5966": "我只会心疼哥",
    "systemTaskConfigTitle_38": "智者轮盘的定格",
    "messageInitNick_3308": "不当替身",
    "messageInitNick_5967": "春江花月夜",
    "systemTaskConfigTitle_37": "部落全体邮件",
    "messageInitNick_3307": "十二点的饺子",
    "messageInitNick_5968": "怒海生存者",
    "systemTaskConfigTitle_36": "世界灾厄平息",
    "moorEffectConfigName_9": "逮虾户！",
    "moorEffectConfigName_8": "霸气冲阵",
    "moorEffectConfigName_5": "浓缩就是精华",
    "moorEffectConfigName_4": "瞬间膨胀",
    "moorEffectConfigName_7": "机运重生",
    "moorEffectConfigName_6": "血条补完",
    "moorEffectConfigName_1": "谜之自信",
    "moorEffectConfigName_3": "差点无敌",
    "moorEffectConfigName_2": "强攻",
    "messageInitNick_5950": "五峰神剑传人",
    "messageInitNick_5951": "粽粽粽粽子",
    "messageInitNick_5952": "好妹子",
    "messageInitNick_5953": "我帅故我拽",
    "messageInitNick_5958": "对线冠军",
    "messageInitNick_5959": "凳子捞月",
    "messageInitNick_5954": "黑夜里的猫",
    "messageInitNick_5955": "吃货最怕饿梦",
    "messageInitNick_5956": "银色战车",
    "messageInitNick_5957": "当场结婚",
    "systemTaskConfigTitle_67": "部落名称修改通知",
    "systemTaskConfigTitle_66": "探索者名称修改通知",
    "systemTaskConfigTitle_65": "永恒赠礼",
    "systemTaskConfigTitle_64": "进化之实重置通知",
    "systemTaskConfigTitle_63": "账号绑定福利",
    "systemTaskConfigTitle_62": "源初境竞猜奖励",
    "systemTaskConfigTitle_61": "源初境竞猜奖励",
    "systemTaskConfigTitle_60": "源初境六十四强奖励",
    "messageInitNick_5940": "豆瓣菜先锋",
    "messageInitNick_5941": "香辣烤串",
    "messageInitNick_5942": "野生奥特曼",
    "messageInitNick_5947": "记忆已丢失",
    "messageInitNick_5948": "拿来把你",
    "messageInitNick_5949": "呆萌少女",
    "messageInitNick_5943": "躺上列表第一",
    "themeCardPackDes_26005": "斗门舞台一般设在斗技场前方或一侧，是进入斗技场的必经之处。\\n在斗技场对战开始前，不论是打算观战的怪兽，还是准备在斗技场大展拳脚的怪兽都会落座斗门舞台。\\n那是战前最后的狂欢与享受，各式各样的表演将轮番上演。\\n此时的舞台侧方——\\n“这场表演的重要性你们都知道吧。如果输了……”幻摊手。\\n“只是对你很重要，不是喵？”喵响尾巴扫过地面，淡淡地说道。\\n（注：喵响说话末尾的喵是它身上的猫叫的）\\n“之前不是都说好了吗，我们各管各的就好。”镇魂并没有张嘴，声音却通过奇妙的方式浮现在其他怪兽的脑海中。\\n“咚”咚魁敲了一下鼓，几面浮空的鼓和它一起向表演等候区飘去。\\n背着吉他的喵响耸耸肩，跟了过去。后面是边走边做发声热身的镇魂。\\n“喂，你们。”幻苦恼地跟上，背着贝斯的肩膀明显绷直了起来。\\n越过其他成员的身影，幻望见了舞台之上，笨拿拿一手高举香蕉，一手捶胸，表情浮夸，眼神狂热，喘吼着歌颂香蕉。它背后四只叉叉正拿着香蕉乱舞。\\n幻扭头看向一旁挂着的节目树皮表，下意识抓紧了手中已经调音完毕的贝斯。\\n《微光斗技场斗门舞台节目表》\\n1号队伍：请回答呜呜子子\\n【成员】呜呜祖拉、黑子、白子\\n【项目】舞蹈、吹奏\\n2号队伍：孤独摇怪！\\n【成员】桐仁、桐仁的左手、桐仁的右手\\n【项目】唱、跳、弄刀\\n3号队伍：双响炮\\n【成员】人间大炮、比蒙巨炮\\n【项目】保密\\n4号队伍：香蕉之心\\n【成员】笨拿拿、叉叉*4\\n【项目】朗诵\\n5号参赛队伍:未定乐队\\n【成员】幻、镇魂、喵响、咚魁\\n【项目】音乐\\n“还愣着干嘛，到我们了。”幻的脑海中想起镇魂的声音。",
    "messageInitNick_5944": "这幸福请签收",
    "messageInitNick_5945": "高情商寿司",
    "systemTaskConfigTitle_59": "源初境三十二强奖励",
    "messageInitNick_5946": "典明粥",
    "systemTaskConfigTitle_58": "源初境十六强奖励",
    "systemTaskConfigTitle_10": "世界灾厄肆虐",
    "themeCardPackDes_14025": "桐仁离开你一千个日月之后，金翅璞佳鸟挪窝的二千多个日月之后。\\n最近，连偶尔来歇脚的智者都没有出现了。它大概是已经知道了吧，这场约定的大战。\\n你这次成了战场中心，你的影子才刚消失不久，东西两侧突然锣鼓喧天，兽声鼎沸。\\n大地的微震沿着你的根系传来，怪兽嘶吼着靠近，一边是尸鬼族，另一边是星灵族，天上还有盘旋的龙族。\\n上万头尸鬼族依靠着数量的优势不断推进着，压得星灵族不断后撤，突然左翼的地面崩裂，尸鬼族这一侧的战线崩乱，在数百只撼地兽正在准备下一波轰拳之际，无数镰刀扫向尸鬼族的侧翼。\\n夜幕早已笼罩大地，可天上无数下坠的流星却将尸鬼族后排的头顶照得锃亮。大半尸鬼族瞬间倒地，一只血渊守护正要割开熵鬼胸膛，突然几只大手从地面伸出扼住了它的身体。随着月亮缓缓爬向天顶，更多倒地的尸鬼族爬起，一次又一次的爬起。其中一只凶噬魔的大长舌缠了刀叉上的虚刃，正准备饱餐一顿时，一只突进的血渊守护割下了它的长舌……不少星灵族似乎终于意识到开始的那波攻击是多么傲慢，它们面对的可是从死亡边缘爬过来的怪兽，怎能妄图仅依靠一波爆发压制呢。\\n好几个日升日落后，你周围只剩十几只怪兽在疲惫地挥舞着拳头，直到其中一头怪兽大喊：“都别打了，这里谁都打不死谁，伤口自己复原，看见了吗树在微微发光，这是神树！”\\n最终，瘫倒在地的星灵族和尸鬼族幸存者约定停战，双方聊到大战的起因，才知道一切都因那条喜欢看热闹的逆焰龙王而起，但这都不重要。\\n重要的是，星灵族和尸鬼族就此和解，并围绕着你建立了一个新的怪兽聚落。它们发誓要守住你的秘密。",
    "messageInitNick_5930": "火龙果魔法",
    "messageInitNick_5931": "泡芙射手",
    "themeCardPackDes_14020": "那头幼兽有一口锋利的牙齿，狩猎前它总能耐心地隐藏自己，而且它总能瞄准猎物的咽喉，然后死死咬住，直至对方结束挣扎后很久很久。\\n你后来才知道，它之所以能咬得那么准，不为什么，只因为那就是它唯一的一次机会了，一次赌上生命的撕咬。\\n当时，它的猎物以一种很诡异的运动轨迹躲过了它的偷袭，即便狩猎经验丰富如它也不会料想到，那只利爪狼居然抽筋了。随后它被利爪狼反口咬住了。就在你以为再也见不到它的时候，它和它的新伤口一起爬了起来。你第一次接触到了撞死以外的死法，装死。\\n几经波折，这只利爪狼终究还是成了它的盘中餐，你大概忘不了，它从地上爬起来，看着你的枯枝贯穿了自己胸口的样子。抽筋救了它，但只有一会。抽筋抽到扑入尖锐的枯枝上，是该说它幸运还是不幸呢。\\n之后你们一起度过了很多年月，你依然不懂，到处都是养分，为什么这些怪兽偏偏要捕食其他生物。\\n这些年月里，它赶跑了很多试图在你旁边休息，挠痒，玩耍的怪兽，除了叽叽喳喳的金翅璞佳鸟和神神叨叨的智者，前者会飞，后者不好吃。\\n它很坚强，即便迈入暮年，仍旧每顿都吃3只利爪狼。\\n终于它先你而去，慢慢也成为了你的一部分。\\n你当然也不知道那天它在弥留之际给你留下的话语。\\n它说，它喜欢你，它喜欢和你呆在一起，只要在你身边，就会有源源不断的“食物”送到它嘴边，它说它叫桐仁。\\n伤心？你那时还不会伤心呢。",
    "messageInitNick_5936": "一支穿云箭",
    "messageInitNick_5937": "向时间进攻",
    "messageInitNick_5938": "桃子君快逃",
    "messageInitNick_5939": "年度西瓜",
    "messageInitNick_5932": "北极星的泪",
    "messageInitNick_5933": "花恋叶",
    "messageInitNick_5934": "一个真正的鳗",
    "messageInitNick_5935": "超级牛奶",
    "messageInitNick_5929": "发光体",
    "themeCardPackDes_14015": "你的截断面相当不平整，多数怪兽都不会喜欢拿你垫屁股，可是总有例外。\\n一只不愿透露种族的怪兽已经悄悄探望过你好几次了。\\n那天，它等到了四下无兽的机会，兴奋地冲过来在你的截面上狠狠地蹭了好一阵子，突然它停了下来，紧紧地抱住了你。\\n你也许还不会不知所措，你还不知道你马上就要被连根拔起了，而你即将到达的地方就是你即将度过余生的地方。\\n那是一处距离它地下巢穴不远的平原，你被它重新放入土壤之中，你不会想到与土壤的短暂离别能带来如此之大的欢愉，你紧紧地抓住大地，仿佛再也不想放开。而且你发现你特别喜欢这片土地的味道，新的枝叶在断开的截面一点点往外生长，试探着新环境。\\n然后，然后你就失去了它们，把你抱来的怪兽似乎更喜欢你原来的样子。\\n已经是第几次被折断新枝了呢，你不知道，但你始终不会绝望，你始终循着本能，努力活着。\\n被折断的触感一次比一次熟悉，就在那不知是折或将折之际，一头幼兽扑了出来，撕开了折枝怪兽的咽喉，终结了你被不断被折断的命运。\\n这时你还不知道，这头幼兽有多么喜欢你，之后它将陪你度过一生，它的一生。",
    "themeCardPackDes_14010": "偶尔会有怪兽在你周围打闹，乘凉，或是摆摊。\\n你突然发现，你已经比大部分怪兽都还要高大和粗壮，你需要的水分和养分也变多了。\\n你本来是那么喜欢阳光、空气、雨水和大地。可那会你有些动摇了，雨已经很久没有找你玩耍了，热辣辣的阳光却总是赖着不走。\\n正当你以为你也马上要回归大地的怀抱时，一只巨大的金翅璞佳鸟咬住一只轰龙，压在了你的枝头，你不知道是它一生中最爱的餐桌之一。很快轰龙的血染红了你的身体，渗入土壤，几日后的你会感谢这只金翅璞佳鸟的，因为它，你才能等来那场雨，你又爱又恨的一场雨。\\n雨很大，雨打湿了你的身体，下一秒你的树干却贴在了湿润的土地上。\\n那是一头比蒙巨兽……的一个脚滑，与你狠狠地撞在了一起，它缓缓爬起，在泥水中打了好几个滚之后，就屁颠屁颠地跑掉了，你就没那么好运了，拦腰截断……",
    "messageInitNick_5920": "鸟儿叽叽叽",
    "messageInitNick_5925": "好玩云的",
    "messageInitNick_5926": "臣妾没空",
    "messageInitNick_5927": "焦糖玛奇朵",
    "messageInitNick_5928": "专业暴富",
    "messageInitNick_5921": "红袖无情",
    "messageInitNick_5922": "纯白梵唱",
    "messageInitNick_5923": "毅力坚强帝",
    "messageInitNick_5924": "谁还在等待",
    "systemTaskConfigTitle_35": "登录验证码",
    "systemTaskConfigTitle_34": "蜕变契约重置通知",
    "systemTaskConfigTitle_33": "苹果专属赠礼",
    "systemTaskConfigTitle_32": "神奇树洞的小憩",
    "messageInitNick_5918": "安睡熊",
    "systemTaskConfigTitle_31": "造唤盛宴的尾声",
    "messageInitNick_5919": "天堂沙滩裙",
    "systemTaskConfigTitle_30": "鎏金月曜赠礼",
    "themeCardPackDes_14005": "最初，你在土壤松软的怀内醒来，缓缓伸展身体，你初次被阳光包围，被调皮的轻风拂走叶尖的泪水。\\n你与身边的幼芽一同成长，一同分享阳光，一同吸取大地的养分，你只比它们长得慢了一点点。那天，下起了一阵味道古怪的雨，长得更高的幼芽把这阵怪雨挡住了。雨后，它们好像再也直不起身子，不久它们就融入土地，以另一种形式永远和你在一起。\\n之后，你身旁长出了一位新朋友，饱满的圆叶不时向你招手，招着招着就被呜呜祖拉顺手带走了。好像，待在你旁边的朋友变得越来越少了。\\n不过，还是有些朋友对你不离不弃，即便它们的脾气有点怪，好像雨儿好几次想带你去河里玩，就像风儿好几回拉着你想让你与它一起到天际翱翔，你都只能狠狠地拉住大地表达拒绝，还有很多很多类似的……\\n在这些特别的日子以外，也有好多好多平凡的日子，那里头有你喜欢的暖和阳光、雨儿、风儿、土壤和怪兽。",
    "messageInitNick_5914": "野百合的春天",
    "messageInitNick_5915": "信我唔坑",
    "messageInitNick_5916": "战斗力一般",
    "messageInitNick_5917": "好男人就是我",
    "systemTaskConfigTitle_29": "纹银月曜赠礼",
    "messageInitNick_5910": "无力回天器",
    "systemTaskConfigTitle_28": "兑换码奖励",
    "messageInitNick_5911": "旋转木马",
    "systemTaskConfigTitle_27": "参与问卷调查奖励",
    "messageInitNick_5912": "第六感",
    "systemTaskConfigTitle_26": "退款申请通知",
    "messageInitNick_5913": "风吹过的夏天",
    "systemTaskConfigTitle_25": "重复购买返还",
    "systemTaskConfigTitle_24": "暴走旷野每日奖励",
    "systemTaskConfigTitle_23": "部落名称修改通知",
    "systemTaskConfigTitle_22": "探索者名称修改通知",
    "systemTaskConfigTitle_21": "部落名称修改通知",
    "messageInitNick_5907": "叫我女王大人",
    "systemTaskConfigTitle_20": "探索者名称修改通知",
    "messageInitNick_5908": "禁止开挂",
    "messageInitNick_5909": "强硬的微风",
    "messageInitNick_5903": "幼儿园一姐",
    "messageInitNick_5904": "我都不信",
    "messageInitNick_5905": "膨化食品",
    "systemTaskConfigTitle_19": "探索者名称受限通知",
    "messageInitNick_5906": "蒜苔撞地球",
    "systemTaskConfigTitle_18": "部落之王赛季奖励",
    "systemTaskConfigTitle_17": "凿星裂痕每月奖励",
    "messageInitNick_5900": "末日第六感",
    "systemTaskConfigTitle_16": "神秘包裹",
    "messageInitNick_5901": "可爱的咖啡熊",
    "systemTaskConfigTitle_15": "斗技场每日奖励",
    "messageInitNick_5902": "吃瓜失败",
    "messageInitNick_10718": "幸福缺货",
    "messageInitNick_10719": "纯情橡皮糖",
    "messageInitNick_10716": "别逼我说人话",
    "messageInitNick_10717": "奋斗小青年",
    "messageInitContent_3325": "不许睡",
    "messageInitContent_5988": "脑袋空空",
    "messageInitNick_10710": "喘气的夜明猪",
    "messageInitContent_3326": "我是包租婆",
    "messageInitContent_5987": "么么哒",
    "messageInitNick_10711": "毅力坚强帝",
    "messageInitContent_3327": "我一直没看懂那是什么兵器",
    "messageInitContent_3328": "那是禁忌的钥匙",
    "messageInitContent_5989": "肚子空空",
    "messageInitContent_3329": "它的钥匙到底能打开哪里的大门",
    "messageInitNick_10714": "原本的味道",
    "messageInitNick_10715": "证据制作中",
    "messageInitNick_10712": "绝对奇幻",
    "messageInitNick_10713": "隔壁的泥鳅",
    "messageInitContent_5991": "R",
    "messageInitContent_5990": "你的大招是什么",
    "messageInitContent_3330": "这是谁割谁的草？",
    "messageInitContent_5993": "今晚要睡荧灵脚下",
    "messageInitContent_3331": "冰仙草",
    "messageInitContent_5992": "降龙十八掌",
    "messageInitContent_3332": "哟是耐寒的品种",
    "messageInitContent_5995": "大力戳戳",
    "messageInitContent_3333": "草（一种怪兽）",
    "messageInitContent_5994": "我不批准",
    "messageInitContent_3334": "草（一种植物）",
    "messageInitContent_5997": "蚌埠住了",
    "messageInitContent_3335": "草（一种态度）",
    "messageInitContent_5996": "暗中戳戳",
    "messageInitNick_10729": "被和谐的爱情",
    "messageInitNick_10727": "盛夏星空",
    "messageInitNick_10728": "淡蓝色的梦",
    "messageInitContent_3336": "草（一个强度）",
    "messageInitContent_5999": "拜拜",
    "messageInitNick_10721": "杏子射手",
    "messageInitContent_3337": "好家伙还都带不同的元核",
    "messageInitContent_5998": "起飞",
    "messageInitNick_10722": "狂飙的鲸",
    "messageInitContent_3338": "他将带头冲锋",
    "messageInitContent_3339": "飞头蛮呢",
    "messageInitNick_10720": "薄荷凉了夏天",
    "messageInitNick_10725": "无人空街",
    "messageInitNick_10726": "随他吧",
    "messageInitNick_10723": "不归牛顿管",
    "messageInitNick_10724": "半顆糖",
    "messageInitContent_3340": "s属性大爆发",
    "messageInitContent_3341": "开饭",
    "messageInitContent_3342": "开摆",
    "messageInitContent_3343": "开干",
    "messageInitContent_3344": "我是闲人",
    "messageInitContent_3345": "遍地祖拉",
    "messageInitContent_3346": "不太给力",
    "messageInitContent_3347": "兄弟，我来了！",
    "messageInitContent_3348": "兄弟~",
    "messageInitContent_3349": "挑战不打这一关",
    "messageInitContent_3350": "遍地祖拉",
    "messageInitContent_3351": "888哥！",
    "messageInitContent_3352": "王888",
    "messageInitContent_3353": "胸毛可以的",
    "messageInitContent_3354": "？",
    "messageInitContent_3355": "各位宝贝我来啦",
    "themeCardPackDes_14040": "“哈哈哈哈，天气真好，是时候起来噜！”魔种I在荧灵身上来回跑动，大声叫着。\\n“去玩！去玩！去玩！去玩！”魔种IV也不甘示弱，在荧灵肩膀上上下跳动。\\n魔种III则扯紧了荧灵的头发，将自己裹得更紧。\\n荧灵稍稍伸展了一下树枝，从睡梦中醒来。过去漫长的记忆时常会在梦中浮现，她不禁会想，如果哪怕有一个奇迹缺席会怎样。\\n她一边安抚着躁动的魔种I和魔种II，一边抽出树根，向前挪动，这是她的结论，若奇迹不再降临，那能依靠的就只有自己。\\n她不愿一动不动等着奇迹到来，但这些小魔种的过于主动却又成了她新的烦恼。\\n“小II呢？”荧灵问手心里的魔种I和魔种II。\\n“喏，在那边。”荧灵看向魔种们示意的方向。\\n“笨蛋笨蛋！快走开！你们不知道你们在这里吵架，这里附近的怪兽和植物都会受到威胁！”\\n“这不是嘛，你们别吵啦~”火神正好松了口气四处张望了起来，赤虹和冰霓则在后面气鼓鼓地相互不待见。\\n此时火神看见了荧灵，“刚刚是你在说话吗？很抱歉给森林添麻烦了。”\\n荧灵见状，头也不回地挪走了，一只小小的魔种，迅速从火神的脚边跑走，跳到了荧灵的身上~\\n“笨蛋笨蛋！是本魔种大种在说话！”魔种II说着从火神脚边跳到荧灵身上！\\n“去玩噜！去玩噜！去玩噜！”魔种IV手舞足蹈好像向此地挥别。",
    "messageInitContent_3356": "不在孤单",
    "messageInitContent_3357": "1111！",
    "messageInitNick_10707": "朕带你打天下",
    "messageInitNick_10708": "傲世小女人",
    "messageInitNick_10705": "流浪的肱骨",
    "messageInitNick_10706": "宿舍的空调",
    "messageInitNick_10709": "鲸鱼宝宝",
    "messageInitContent_3358": "！11111111",
    "messageInitContent_3359": "520！",
    "messageInitNick_10700": "精品探索者",
    "messageInitNick_10703": "猫科心理医生",
    "messageInitNick_10704": "世界第二美丽",
    "messageInitNick_10701": "好熊第",
    "messageInitNick_10702": "战斗力负五",
    "themeCardPackDes_14035": "你的树冠开始稀疏，树皮开始剥落，树干逐渐倾斜，干枯的部分越来越多。\\n你开始腐朽。你开始死亡。我则瞬间得到了你过往的无数碎片，并难以抑制地在其中加入不少的臆想。记忆和感受不断融合，有意义和无意义的画面一一流转。\\n“致我深爱的阳光、雨水、风儿和你们，感谢偶然诞下的奇迹，让我的生命得以延续？”\\n确实，你每一秒仿佛都像是成千上万个奇迹的延续。\\n但你的故事却不是我的故事，哪怕是只有一刻，你都没能做出任何抉择，只能活着，再活着。\\n而现在起，属于我的故事开始了，带着无数不知该如何表达的感谢，带着滋养那些被夺走生命力的怪兽，还有让更多生命得以延续的渴望。我从土壤中抽起了根，试着离开我的故乡。",
    "messageInitContent_3361": "救命",
    "messageInitContent_3362": "紫霞我爱你",
    "messageInitContent_3363": "御空我爱你",
    "messageInitContent_3364": "好多白虎",
    "messageInitContent_3365": "表白小狮子",
    "themeCardPackDes_14030": "一个新的怪兽聚落在你周围逐渐壮大，你得到了精心的照顾，有的怪兽为你修剪枝叶，有的怪兽保护你不被侵扰，偶尔会有受伤的怪兽被送到你身边，确实很不可思议，它们的伤口都开始迅速在愈合，看起来就像你在向它们注入了生命力一样。若是在夜里，还可以你身上还会发出微弱的光，仿佛生命的荧光。\\n大概每300多个日月中就会有一天，聚落中的大多数怪兽会聚集到你身边，它们轮流用各自的力道拥抱你，然后小声告诉你最近发生在它身上的好事，第一位来拥抱你的，通常都是聚落的酋长。每一任酋长的任期都不一样。\\n第一任酋长特别爱操心，几乎每天都会围着你转，仔细记录你的生长情况。第三任酋长是个秘密主义者，为了不让你的存在被其他怪兽发现，许多不幸知道你存在的非聚落怪兽都遭到了灭口。第七任酋长是个特别爱研究，它将你的枝叶摘下然后插入土壤加以繁育，可惜它试图栽培更多治愈之树的努力并没有成功，你似乎有些特别。第八任酋长没有什么特别，但你在它的任期遇到一件印象深刻的事，火神在你隔壁变大变小，他的两边则是冰霓和赤虹。你大概会很希望能把自己挪走吧。第十一任酋长非常好战，聚落的战士因你的力量可以迅速在受伤后回到战场。聚落规模大幅壮大，可在此任酋长战死后又迅速缩小。想要窥探聚落快速恢复秘密的怪兽也越来越多。第十五任酋长觉得你因该属于超进化大陆而非属于只属于一个聚落，而它们可以依靠为其他怪兽提供治疗帮助获取收益。消息很快传遍大陆，事情并没有如酋长所想的那样，一批又一批的怪兽军团为了夺走你而袭来，战火再次燃起！整个聚落就此全灭。\\n第二个新聚落再次包围了你。\\n第一任酋长上任后，不久后便自然死亡了，毕竟心脏离体自然就会死亡了。之后的第二任酋长认为聚落正是因你的存在而不停遭受战火的洗礼，你并非魔树而是神树，它决定毁掉你，让聚落回归和平。聚落也因此分裂，一些怪兽想要保护你，一些怪兽想要砍掉你。为了守护你，一些怪兽甚至付出了一生，而一些怪兽为了毁掉你，也同样付出了相当的牺牲。\\n你时常能看到守护你的怪兽和那些试图伤害你的怪兽的厮杀，而你却总是在努力治愈它们，没有半点分别。没有悲伤，也没有欢喜。除了周围越发茂盛的密林。",
    "messageInitContent_3366": "气奥好气嗷",
    "messageInitContent_3367": "我想",
    "messageInitContent_3368": "试图萌混过关",
    "messageInitContent_3360": "我的绝招是我爱你",
    "themeCardPackDes_26010": " “恭喜5号队伍【未定】取得微光斗门舞台的最终代表资格！鼓掌！”\\n“笑死了。这都行。”\\n“幻之前不是很火的吗？”\\n“是的，是之前火。现在只能这样赢，表演成这样有意思吗？”\\n“你们说，它们是不是偷偷收买了其他队伍。”\\n“可不是嘛，哪有这么巧的。”\\n“对啊对啊，桐仁就是来搞笑的，什么左手右手的，实际只有它一只，然后就因为不符合比赛资格被抬走了。”\\n“还有，那个【请回答呜呜子子】，吓死只怪了，听着浑身凉飕飕的，谁敢应啊。”\\n“别说了，那个【双响炮】更离谱，对着俺们观众席就是一顿乱轰，还辩称是表演失误。”\\n“那个卖香蕉的也是，香蕉皮乱飞，不过叉叉一本正经突然给香蕉皮来了个连环摔我是真笑出声了。”\\n“就是在一堆小石头里面挑石头，只有幻那个什么乐队勉强算是完成表演。”\\n“各演各的也叫表演倒是没错，就是跟乐队没什么关系。”\\n“说白了就是4只怪兽，轮流演了一段。”\\n“这就叫捡漏不是吗~”\\n“不许你们这么说我幻幻！”\\n台上，幻站在颁奖台正中，它身旁是第二名的笨拿拿和第三名的呜呜祖拉。乐队的家伙早早跑了，镇魂说要休息一下，喵响一不留神就没影了，咚魁，也不知道它怎么想的，打着鼓就离开了。\\n幻的目光掠过观众席，嘘声轻易盖过了零星的掌声，幻认出那掌声的源头是之前在它演唱会出现过的身影。\\n微光斗技场的主管赶紧干咳两声。\\n“那么，总之！恭喜【未定乐队】成为了微光斗门舞台的代表表演嘉宾——它们将会代表微光斗门舞台参与源初之地斗技场的斗门舞台大乱斗！届时其他斗技场的表演者也将登台对决，大家千万不要错过！”\\n随后四周响起不清不楚的掌声，像是某种被压抑的节奏，断续、不连贯。",
    "messageInitContent_3369": "搞",
    "messageInitNick_10754": "别急最重要快",
    "messageInitNick_10755": "泡面女巫",
    "messageInitNick_10752": "复杂的三角题",
    "messageInitNick_10753": "长得不潦草",
    "messageInitNick_10758": "怀念地球",
    "messageInitNick_10759": "早上吃烧麦",
    "messageInitNick_10756": "救急电台",
    "messageInitNick_10757": "小小鼓励",
    "messageInitContent_3372": "我叫不动",
    "messageInitContent_3373": "我叫不太平",
    "messageInitContent_3374": "我叫小路",
    "messageInitContent_3375": "开心到模糊",
    "messageInitContent_3376": "乐",
    "messageInitNick_10750": "画饼爱好者",
    "messageInitContent_3377": "我的叉",
    "messageInitNick_10751": "流浪的下鼻甲",
    "messageInitContent_3378": "出息了叉儿",
    "messageInitContent_3379": "刚好隔壁肉肉山来点餐具",
    "messageInitContent_3370": "难整",
    "messageInitContent_3371": "快乐大侠在此",
    "themeCardPackDes_26015": "幻不太记得自己是怎么走下舞台的，脚步像是踩在弦上，晃着晃着陷入到过往的种种当中。\\n它也有过一段独属于自己的高光时刻——\\n那时的它，手持贝斯，引爆全场。\\n从无兽问津，到场场爆满，再到沉寂，多久没有听过观众期待地喊再来一首了呢。\\n它不自觉地拨动弦，疲惫的砰——砰——\\n这时，熟悉又不讨喜的声音响起。\\n“你到了瓶颈期，观众又总是贪婪的。”\\n神秘商人不知道从哪里钻出来，那神秘的脸上露出捉摸不透的神情。\\n“如果再这样下去，后续你可能没办法继续使用斗门舞台了。”\\n幻抬起头，看着神秘商人。\\n神秘商人慢悠悠地将一张粗糙的树皮卷丢到幻手里。\\n“刚好，最近源初之地的斗门舞台将举办一场大赛，微光、凝时、破界、迷石、流火五大斗技场的斗门舞台，共25支参赛队伍，争夺最后一席斗门舞台使用权。”\\n神秘商人顿了顿。\\n“不过~得以组队的方式参加，多怪表演，这是我最近发现的新商机。来试试吧，顺便换个环境，说不定会有新发现呢。”\\n乐队——\\n幻第一次是在智者口中听到这个词。不是某只怪兽的声音，而是一群怪的协奏。\\n它不是没有幻想过，和其他怪兽一起在舞台激烈碰撞的情形。\\n可那时的它更相信自己的旋律足够完整，不需要“杂质”，也不需要“配角”。\\n但如今，它要试着注入新声。",
    "themeCardPackDes_26020": "幻先是在要找镇魂变大未果的大嘴鱼王嘴里找到了镇魂。\\n再是在昏暗的角落里捡到了顾着弹吉他然后饿晕了的喵响。\\n最后是在路上撞上了正在聆听大地节奏的咚魁……\\n“这样啊，很好！一起玩音乐吧！”\\n镇魂答应得很快。\\n“有吃的喵？”\\n喵响也答应得挺快，以消灭幻刚从投食洞穴运来的存货为代价。\\n“咚 咚 咚咚 咚咚~”\\n幻其实没听懂，但感觉咚魁也答应了，毕竟它跟过来了。\\n然而，乐队的组建有多简单，幻后面的遇到的事就有多闹心。\\n“Rap？我还是想试试其他风格，那种更加充满灵魂的感觉。”\\n作为乐队主唱的镇魂对幻的之前擅长的音乐完全不感兴趣。\\n“治愈大家喵~”\\n喵响只喜欢弹那种温柔治愈的节奏，偶尔还会磨爪制造奇怪的声响。\\n“咚咚 咚咚 咚 咚~”\\n咚魁的鼓声似乎就没有停过，轻重重轻~可光喜欢打鼓是不够的啊！\\n因此完全可以预见第一次合练就是一场噪音的狂欢。\\n“不行不行，这样，这样我们是没办法赢的。”\\n“混在一起不行吗？”镇魂灵魂发声。\\n“那就~分开喵。”喵响弹唱了一段像是什么情歌里的节选。\\n“咚咚~咚咚咚~”咚魁又不知道在打什么。\\n“喵你真是天才！”镇魂似乎想到了什么表示认同，“我们轮流表演就行了！”\\n于是就有了它们的第一次舞台，四段分离的独奏。\\n幻拨出熟悉的旋律，内心不禁有些怀疑——\\n乐队真是这样的吗？",
    "messageInitNick_10765": "暴走的沙拉酱",
    "messageInitNick_10766": "情深奈何缘浅",
    "messageInitNick_10763": "狂飙的猪",
    "messageInitNick_10764": "混世魔王",
    "messageInitNick_10769": "大脑健康证",
    "messageInitNick_10767": "假面人",
    "messageInitNick_10768": "万事胜意",
    "messageInitContent_3383": "花花世界",
    "messageInitContent_3384": "重锤出击",
    "messageInitContent_3385": "重拳出击",
    "messageInitContent_3386": "高达出击",
    "messageInitContent_3387": "给你小花花",
    "messageInitNick_10761": "西瓜海滩与你",
    "messageInitContent_3388": "毒砂掌",
    "messageInitNick_10762": "在线申请对线",
    "messageInitContent_3389": "千蛛万毒",
    "messageInitNick_10760": "残花若相惜",
    "messageInitContent_3380": "支持环保 请勾不需要餐具",
    "messageInitContent_3381": "叉教！",
    "themeCardPackDes_26025": " “哈喽，各位，恭喜夺得代表资格。”\\n神秘商人的出现让互不相让的乐声噶然而止，他自顾自继续说着。\\n“你们的运气还挺好的，碰上那种对手，可是接下来的对手，可不是靠运气就能解决的。”\\n“你到底想说什么？”幻按住指板问道。\\n“别急嘛，就是催一下你们的节目表。”神秘商人将一张树皮卷递到幻手上，“这是你们的对手已经提交好的表演项目，现在就差你们了。”\\n神秘商人微笑着补了一句：“音乐方面实在不行的话，杂技也不是不行的~”\\n“你……”幻猛地将节目单一扔，又马上泄了气，就像软趴趴落在地上的节目树皮卷一样。\\n喵响拨动琴弦，语气坚定：“音乐。”\\n“当然是音乐啊！”镇魂灵魂吼道。\\n“咚咚 咚咚咚咚咚咚！”\\n咚魁依然没有开口，只是连续打出一阵激昂的鼓声，如同加速心跳的节拍。\\n幻深吸一口气重重答道：“那就音乐！”\\n“好好，没问题，记上了。还有不要生气嘛小幻幻，我是来帮你们的。”神秘商人说着又掏出了一张树皮卷。\\n树皮上用极其粗犷的线条描绘着五头姿势张狂尸狂。\\n“这是迷石斗技场的表演乐队——【FIVE狂·天赋起源】，等下它们会在这附近进行试演出，去看看如何。”\\n“我们考虑一下。”幻接过宣传树皮，语气中的硬气少了几分。\\n“我是说了解一下差距如何，哈哈哈。到时再见。”神秘商人说着就飘走了。\\n“怎样？要去看喵？”喵响的左耳轻轻抖动了一下，眼神难得认真。\\n“去就去，怕什么！”镇魂甩动尾巴抢先冲了出去。\\n“咚咚咚 咚咚咚！”\\n“好！我们走！”",
    "messageInitContent_3382": "叉门！",
    "activityTaskDes_201": "暴走旷野战斗{1}次",
    "activityTaskDes_202": "黑暗森林探索{1}次",
    "themeCardPackDes_26035": "喵响拨动吉他，幻弹着贝斯，镇魂醉声吟唱，咚魁的鼓声依旧稳定，这是未定乐队出发前最后一次彩排。\\n忽然，咚魁的鼓声躁动起来，但这预警还是迟了。\\n下一秒，一道电光闪过，将幻劈倒在地，尾音的音符回荡一会，直至骤停。\\n灾·雷鸣降临！\\n镇魂最先行动，一嘴将喵响叼开，咚魁则毫不犹豫扑到前方，擂槌交叉在身前。\\n————\\n同一时间，最后对决的舞台——中心斗门舞台已经布置完毕。\\n观众陆续入席，场馆中流动着期待的节拍，再过一会就要开场。\\n————\\n“敲晕了喵。”喵响跌跌撞撞地站起来，手里仍抱着吉他。\\n“我来了！”镇魂从一侧跃起，对着灾·雷鸣一阵输出。\\n灾·雷鸣似乎受了一点伤害，可是瞬间它的体型变大了，伤势也完全恢复过来。\\n咚魁立刻冲出吃下灾·雷鸣的猛烈一击。\\n“咚——”\\n灾·雷鸣再次震退数步。\\n“幻！快醒醒啊喵！”\\n喵响退到被击倒的幻身旁拼命弹奏，粉红色的治愈圆环从它体内扩散跃动。\\n“它就是故意先攻击幻的！喝！再吃我一爪！”镇魂继续疯狂扑击。\\n咚魁没有出声，鼓声越来越密集。\\n灾·雷鸣被击退后又再次扑出，伤势恢复的速度被压制了下去，却因此变得更加狂躁。\\n“看我御御散御天御地御宏——”\\n“幻喵~”\\n终于，一道紫色的混沌之光从幻身上迸发，灾·雷鸣的体型瞬间恢复最初的体型。\\n幻起身扫了一眼同伴。\\n“一起上！”镇魂灵魂大喊。\\n————\\n此时此刻，中心斗门舞台上，罗密欧和朱丽叶深情对视后向观众微微颔首。\\n来自流火斗门舞台的【罗密欧暗得哆朱丽叶】，完成了莎士彼亚改编的剧本。\\n台下爆出热烈掌声。\\n“接下来登场的是——来自迷石斗门舞台的【FIVE狂·天赋起源】……”\\n————\\n“快快快！”幻一边挂好贝斯一边小跑。\\n“冲啊~~”灵魂发音~如同号角。\\n“喵啊~”喵响的耳朵和尾巴随着它的跑动而动。\\n“咚咚咚咚咚~”\\n灾·雷鸣的身影渐渐远去，未定乐队正朝最后的比赛场地——中心斗门舞台狂奔……\\n————\\n场上，三只歧兽组成的【向我们迎面走来的是】结束了它们的脱口秀表演，跃入观众兽群，观众沸腾。\\n但下一刻，观众席爆出更为狂热的尖叫：\\n“崩坏狂潮！崩坏狂潮！崩坏狂潮！崩坏狂潮！崩坏狂潮！”c来自破界斗门舞台的漆黑组件和御空登上了舞台，迷离的电子乐如浪潮一般向八方扩散。",
    "messageInitNick_10738": "祝我单身快乐",
    "activityTaskDes_200": "斗技场战斗{1}次",
    "messageInitNick_10739": "恶魔尊主",
    "activityTaskDes_205": "探索完成{1}次",
    "themeCardPackDes_26030": "脑海中的乐声仍在不停回荡，一次次冲击着幻的每一个神经。\\n幻知道不只是它，镇魂、喵响、咚魁——也沉浸在刚才的震撼中。那并不是一场普通的试演，那是【FIVE狂·天赋起源】以音浪展现自我的盛宴。\\n每个音符，每个节拍，都在告诉它们，那才是“乐队”。\\n那是五个灵魂在旋律中肉搏、相融与共振。\\n谁都没有说话，只是默默准备好。\\n最先响起的是咚魁的鼓声。\\n“咚——咚咚 咚咚咚”\\n紧接着，喵响拨动了吉他。幻下意识抬手跟进。最后是镇魂，贴着乐器节拍缓慢前行。\\n它们头一回不只是在“演”自己的，还是在“听”彼此的。\\n幻也在此刻明白了——咚魁的鼓声从来不是乱打，它一直在试着理解、探索每一位同伴的节奏。\\n此刻它所要做的，是聆听，聆听同伴的声音。\\n交织在一起的乐声胜过言语，在用尽最后一丝力气之前，绝不停止。\\n这才是真正的“未定乐队”。\\n来创造吧，只有我们，而非我才能创造的音乐！",
    "activityTaskDes_203": "部落冒险关卡战斗{1}次",
    "activityTaskDes_204": "造唤台累计造唤{1}次",
    "messageInitNick_10732": "眉笔道人",
    "messageInitNick_10733": "草莓在跳舞",
    "messageInitNick_10730": "我家断网了",
    "messageInitNick_10731": "花痴",
    "messageInitNick_10736": "拖鞋特别粘人",
    "messageInitNick_10737": "春狂想",
    "messageInitNick_10734": "玉米撞地球",
    "messageInitNick_10735": "高渐离不开你",
    "messageInitContent_3394": "迷迷糊糊就到这里了",
    "messageInitContent_3395": "在推关和推进之中，我选择了推拿",
    "messageInitContent_3396": "开饭！",
    "messageInitContent_3397": "真嘟假嘟",
    "messageInitContent_3398": "三花",
    "messageInitContent_3399": "花花世界",
    "messageInitContent_3390": "冰魄银针",
    "messageInitContent_3391": "五毒烟萝步",
    "messageInitContent_3392": "玄冥神掌",
    "messageInitContent_3393": "我尽量哭得大声点",
    "messageInitNick_10749": "阿巴阿巴",
    "themeCardPackDes_26040": "凉爽的风拂过未知乐队的每一位成员。\\n它们站在最终舞台的中央，一切都准备就绪了。\\n幻、喵响、镇魂、咚魁的视线短暂交汇，什么也没说，但已准备就绪了。\\n第一击，咚魁敲下鼓点。\\n“咚——咚咚，咚咚咚！”\\n节奏坚定而平稳，仿佛从大地的心跳。\\n喵响紧跟而上，音色不像以往那样软绵，而是多了一点清晰的破音，一点微妙的躁动，它的尾巴随着节奏轻轻摆动。\\n幻的贝斯低鸣入场，音波一圈一圈缠绕在吉他的主旋律之下。\\n镇魂缓缓闭上眼睛，仰起头，歌声从它的灵魂发出。\\n“未定之声，不定形态，献上吼鸣——”\\n它的声音被鼓点提起，被吉他拖拽，被贝斯托举，缓缓展开。\\n台下原本准备散场的观众，逐渐在舞台下方重新聚集。\\n最初它们只是好奇，现在却无法挪动半步。\\n一只怪兽下意识地抬爪，踏上了鼓点的节拍。\\n紧接着是第二只、第三只……\\n节奏在观众中传染、扩散。\\n这一刻，胜负已不再重要。\\n这是他们第一场，真正的——未定乐队演出。\\n它们创造出了它们的音乐。",
    "messageInitNick_10743": "点旳思念",
    "messageInitNick_10744": "香蕉想要休息",
    "messageInitNick_10741": "哇哦这样啊",
    "messageInitNick_10742": "随缘补刀",
    "messageInitNick_10747": "啾一口奶糖",
    "messageInitNick_10748": "暴富之神",
    "messageInitNick_10745": "打不开的心门",
    "messageInitNick_10746": "脑容量不足",
    "messageInitNick_10740": "冰箱探险者",
    "activityTaskDes_301": "突围鏖战或合围破阵挑战{1}次",
    "activityTaskDes_304": "暴走回廊到达{1}分",
    "activityTaskDes_305": "暴走回廊到达{1}分",
    "activityTaskDes_302": "突围鏖战或合围破阵挑战{1}次",
    "activityTaskDes_303": "暴走回廊挑战{1}次",
    "activityTaskDes_308": "三阵入局到达{1}积分",
    "messageInitNick_10677": "决战到四点",
    "activityTaskDes_309": "三阵入局到达{1}积分",
    "messageInitNick_10678": "黄色节制",
    "activityTaskDes_306": "暴走回廊到达{1}分",
    "messageInitNick_10675": "是个替代品",
    "activityTaskDes_307": "三阵入局匹配{1}次",
    "messageInitNick_10676": "榜一大哥",
    "messageInitNick_10679": "从大佬到萌新",
    "messageInitNick_10670": "引战冠军",
    "messageInitNick_10673": "玩味的菠萝蜜",
    "messageInitNick_10674": "兰陵王中王",
    "messageInitNick_10671": "阁楼猫",
    "messageInitNick_10672": "只是友情出演",
    "messageInitNick_10688": "泪听雨",
    "messageInitNick_10689": "捣蛋淑女",
    "messageInitNick_10686": "冷静奶茶",
    "messageInitNick_10687": "噼里啪啦",
    "messageInitNick_10680": "懒懒喵喵",
    "messageInitNick_10681": "星星之海",
    "messageInitNick_10684": "愁绪满风袖",
    "messageInitNick_10685": "把你养成猪",
    "messageInitNick_10682": "搬砖先驱",
    "messageInitNick_10683": "昂贵的温柔",
    "messageInitNick_10655": "菠萝射手",
    "messageInitNick_10656": "扑进猫猫怀里",
    "messageInitNick_10653": "俯瞰天空",
    "messageInitNick_10654": "原地起飞",
    "messageInitNick_10659": "豆瓣菜先锋",
    "messageInitNick_10657": "天秤座不平",
    "messageInitNick_10658": "霸气小哥",
    "messageInitNick_10651": "绝不久坐",
    "messageInitNick_10652": "越来越远",
    "messageInitNick_10650": "黄瓜魔法师",
    "messageInitNick_10666": "暗恋成真",
    "messageInitNick_10667": "海洋之神",
    "messageInitNick_10664": "超级炸虾",
    "messageInitNick_10665": "芹菜真好吃",
    "messageInitNick_10668": "未知的旅途",
    "messageInitNick_10669": "万能水杯",
    "messageInitNick_10662": "深度策略大炮",
    "messageInitNick_10663": "凉心姑娘",
    "messageInitContent_3400": "不要耍花招",
    "messageInitNick_10660": "爆裂魔龙",
    "messageInitContent_3401": "植物园",
    "messageInitNick_10661": "打脸鉴定家",
    "messageInitContent_3402": "不要过来啊啊啊",
    "messageInitContent_3403": "舌尖上的关卡",
    "messageInitContent_3404": "头大",
    "messageInitContent_3405": "雷犀利",
    "messageInitContent_3406": "我是来干嘛来着",
    "messageInitContent_3407": "好",
    "messageInitContent_3408": "我要掉下去了",
    "messageInitContent_3409": "水中火中泥中",
    "messageInitContent_3410": "火候可以",
    "messageInitContent_3411": "泡一泡",
    "messageInitContent_3412": "火心会怕热吗？",
    "messageInitContent_3413": "冰霓就是你了，冷死他们",
    "messageInitContent_3414": "妈妈，请再爱我一次",
    "messageInitContent_3415": "jojo，请再爱我一次",
    "messageInitContent_3416": "今天星期几？",
    "messageInitContent_3417": "加个好友",
    "messageInitContent_3418": "略略略~",
    "messageInitContent_3419": "水来",
    "messageInitContent_3420": "好多遗言",
    "messageInitContent_3421": "爆款？？",
    "messageInitContent_3422": "多喝热水",
    "messageInitContent_3423": "早睡早起身体好",
    "messageInitContent_3424": "我在这里不想你",
    "messageInitNick_10699": "独家占有",
    "messageInitContent_3425": "宝贝在干嘛~",
    "messageInitContent_3426": "在嘛在嘛",
    "messageInitNick_10697": "跑出地球",
    "messageInitContent_3427": "求现代人的精神状态",
    "messageInitNick_10698": "歌颂者",
    "messageInitContent_3428": "真行",
    "messageInitContent_3429": "九阴白骨爪",
    "messageInitNick_10691": "单马尾",
    "messageInitNick_3298": "两颗心脏",
    "messageInitNick_10692": "我选择困难",
    "messageInitNick_3297": "金刚老芭比",
    "messageInitNick_3296": "羊羊画家",
    "messageInitContent_3430": "拼命的人最可怕",
    "messageInitNick_10690": "万能鞋子",
    "messageInitNick_3295": "狂飙的蜗牛",
    "messageInitContent_3431": "司机是捕头",
    "messageInitNick_10695": "星辰在闪耀",
    "messageInitContent_3432": "吸溜",
    "messageInitNick_10696": "夜闯废校",
    "messageInitContent_3433": "委屈屈",
    "messageInitNick_10693": "变向的是人心",
    "messageInitContent_3434": "不困了！",
    "messageInitNick_10694": "会飞的迷彩猪",
    "messageInitNick_3299": "不就是拖鞋",
    "wallEquipmentConfigName_3": "远端蒸发武装",
    "wallEquipmentConfigName_2": "体型释放武装",
    "wallEquipmentConfigName_5": "坚韧增幅武装",
    "wallEquipmentConfigName_4": "体型抽取武装",
    "wallEquipmentConfigName_1": "近端蒸发武装",
    "messageInitContent_3435": "来吧",
    "messageInitNick_3290": "粉色甜心",
    "messageInitContent_3436": "啊~！",
    "messageInitContent_3437": "想吃披萨。",
    "messageInitContent_3438": "站岗",
    "messageInitContent_3439": "我在这等着你们",
    "messageInitNick_3294": "顽童",
    "wallEquipmentConfigName_7": "坚韧衰减武装",
    "messageInitNick_3293": "电子宠物",
    "wallEquipmentConfigName_6": "破韧增幅武装",
    "messageInitNick_3292": "行为艺术家",
    "messageInitNick_3291": "有几分帅气",
    "wallEquipmentConfigName_8": "破韧衰减武装",
    "messageInitNick_3287": "夹子先锋",
    "messageInitNick_3286": "我是硕博",
    "messageInitContent_3440": "贴贴",
    "messageInitNick_3285": "强壮打拳神",
    "messageInitContent_3441": "心生一计",
    "messageInitNick_3284": "一阵风吹过",
    "messageInitContent_3442": "迅速占领智商高地",
    "messageInitContent_3443": "球球你",
    "messageInitContent_3444": "火神出场吧！",
    "messageInitNick_3289": "无敌卷哥",
    "messageInitContent_3445": "冷冷冷雨夜",
    "messageInitNick_3288": "如果能重来",
    "mapNodeName_9": "凝时冰谷",
    "randomEventDialogueGroupConfig_55.28": "大力出奇迹，你闯了过去，但它们的对话似乎已经结束，正要离开。",
    "mapNodeName_8": "流星草原",
    "randomEventDialogueGroupConfig_55.27": "继续锤墙",
    "mapNodeName_7": "论某某侠如何输出",
    "randomEventDialogueGroupConfig_55.26": "离开",
    "mapNodeName_6": "所以怪会消失对吗",
    "randomEventDialogueGroupConfig_55.25": "前方有一堵看不见的墙挡住了你。似乎你只能放弃。",
    "randomEventDialogueGroupConfig_55.24": "上前一步加入对话",
    "randomEventDialogueGroupConfig_55.23": "离开",
    "randomEventDialogueGroupConfig_55.22": "只见它麻溜地又找上了另一个探索者。",
    "randomEventDialogueGroupConfig_55.21": "等待次日出发",
    "messageInitNick_3283": "柿子射手",
    "messageInitNick_3282": "孤城浪子",
    "messageInitNick_3281": "中文怎么说",
    "messageInitNick_3280": "控场美人",
    "randomEventDialogueGroupConfig_55.29": "跟上",
    "messageInitNick_3276": "骑着蜗牛狂飚",
    "messageInitNick_3275": "这道题怎么解",
    "messageInitNick_3274": "花引香",
    "messageInitNick_3273": "七十二家饭店",
    "messageInitNick_3279": "划水门首席",
    "messageInitNick_3278": "李子魔法",
    "messageInitNick_3277": "尖叫柚子",
    "randomEventDialogueGroupConfig_55.31": "这堵墙用计堵住了你的去路。它把选项调转了。",
    "randomEventDialogueGroupConfig_55.30": "离开",
    "randomEventDialogueGroupConfig_55.17": "之前也说了，这是一趟特殊的镖，明镖里带着暗镖，不能光明正大地走，报酬自然也不菲。",
    "randomEventDialogueGroupConfig_55.16": "它将你带回了它的镖局——超镖局。将你领到一处雅致的小院后，便招呼你坐下。",
    "randomEventDialogueGroupConfig_55.15": "盯着它看",
    "randomEventDialogueGroupConfig_55.14": "离开",
    "randomEventDialogueGroupConfig_55.13": "它如此说完麻就溜地走了。",
    "randomEventDialogueGroupConfig_55.12": "让它细说",
    "randomEventDialogueGroupConfig_55.11": "突然有谁一把将你扯到一旁，你没有出手，毕竟你察觉到它没有恶意。它单刀直入，希望你帮个忙。",
    "randomEventDialogueGroupConfig_55.10": "拒绝",
    "messageInitNick_3272": "把心熬成铁",
    "messageInitNick_3271": "隔空打人",
    "messageInitNick_3270": "可不可以上天",
    "randomEventDialogueGroupConfig_55.19": "询问盯上这批货的势力",
    "randomEventDialogueGroupConfig_55.18": "你要看好的是这暗的，路上你就照着平常的镖来跑。路上若遇到情况，疾风兔弟兄递到你手上的便是那暗的，再细就说不得了。你随机应变即可，我相信你探索者。",
    "messageInitNick_3265": "熬夜天王",
    "messageInitNick_3264": "超级干饭神",
    "messageInitNick_3263": "和风戏雨",
    "messageInitNick_3262": "哦呼",
    "messageInitNick_3269": "荆棘鸟",
    "messageInitNick_3268": "赛博大佛",
    "messageInitNick_3267": "凉粉好吃",
    "messageInitNick_3266": "地狱学者",
    "mapNodeName_1": "肉肉山",
    "randomEventDialogueGroupConfig_55.20": "南集市和东集市明面的老板后面的老大。不然怎要劳烦探索者您呀。咱们明早出发。",
    "mapNodeName_5": "周末双休",
    "mapNodeName_4": "瞬息草原",
    "mapNodeName_3": "在下叉叉有何贵干",
    "mapNodeName_2": "一堆吃货",
    "messageInitNick_3261": "霸气总攻",
    "messageInitNick_3260": "芭比美人鱼",
    "messageInitNick_3254": "六点的凉粉",
    "messageInitNick_3253": "谐音梗扣钱",
    "messageInitNick_3252": "笑我太傻",
    "messageInitNick_3251": "打小就稳重",
    "messageInitNick_3258": "四格麻花",
    "messageInitNick_3257": "冰原孤狼",
    "messageInitNick_3256": "大号萝莉",
    "messageInitNick_3255": "吃力狂魔",
    "messageInitNick_3259": "引战冠军",
    "messageInitNick_3250": "龙眼先锋",
    "messageInitNick_3243": "天生醋坛子",
    "messageInitNick_3242": "旧歌轻吟",
    "messageInitNick_3241": "汉堡包猎人",
    "messageInitNick_3240": "老司机等等我",
    "messageInitNick_3247": "头号侦探",
    "messageInitNick_3246": "拿梨子看世界",
    "messageInitNick_3245": "心易碎请勿碰",
    "messageInitNick_3244": "爱上孤独",
    "messageInitNick_3249": "氵孚夸",
    "messageInitNick_3248": "豆腐心",
    "messageInitNick_3232": "疯狂在跳舞",
    "messageInitNick_5895": "沙棘果魔法师",
    "messageInitNick_3231": "在吗多喝水",
    "messageInitNick_5896": "夕阳下的背影",
    "messageInitNick_3230": "隔壁情感导师",
    "messageInitNick_5897": "蓝天白云",
    "messageInitNick_5898": "风刮来的钱",
    "messageInitNick_3236": "心如狂蝶",
    "messageInitNick_5891": "视金钱如土",
    "messageInitNick_3235": "快乐跑分卡",
    "messageInitNick_5892": "我裂开了",
    "messageInitNick_3234": "享受青春",
    "messageInitNick_5893": "霸气仙女",
    "messageInitNick_3233": "红色沙漠",
    "messageInitNick_5894": "地狱软猫",
    "messageInitNick_3239": "拖鞋毁灭者",
    "messageInitNick_3238": "狂奔的且",
    "messageInitNick_3237": "给本宫站住",
    "messageInitNick_5899": "有医保你先走",
    "messageInitNick_5890": "我是学生送我",
    "messageInitNick_3221": "迷路的肱骨",
    "messageInitNick_5884": "奋斗小伙",
    "messageInitNick_3220": "邻座的笔记",
    "messageInitNick_5885": "蒸蛋怪兽",
    "messageInitNick_5886": "技术大神",
    "messageInitNick_5887": "蹦擦擦女王",
    "messageInitNick_3225": "薄涼少年",
    "messageInitNick_5880": "机车人",
    "messageInitNick_3224": "不重要的重要",
    "messageInitNick_5881": "朋友圈关了",
    "messageInitNick_3223": "钱钱到位",
    "messageInitNick_5882": "强壮划水神",
    "messageInitNick_3222": "笑容很灿烂",
    "messageInitNick_5883": "刚提的车",
    "messageInitNick_3229": "饿梦",
    "messageInitNick_3228": "生命暗道",
    "messageInitNick_3227": "啊你干嘛打我",
    "messageInitNick_3226": "当场放假",
    "messageInitNick_5888": "我的音乐梦",
    "messageInitNick_5889": "激动凹凸曼",
    "randomEventDialogueGroupConfig_55.49": "离开",
    "randomEventDialogueGroupConfig_55.48": "这暗标的秘密就藏在这旗杆之中，旗杆之中藏了一副绝世名画，价值非凡。",
    "randomEventDialogueGroupConfig_55.47": "等等",
    "randomEventDialogueGroupConfig_55.46": "离开",
    "randomEventDialogueGroupConfig_55.45": "虽然外围的战斗输了，明镖被抢去了，但你守住了最重要的暗标。顺利完成了任务。",
    "randomEventDialogueGroupConfig_55.44": "加入战斗",
    "randomEventDialogueGroupConfig_55.43": "死守镖旗",
    "messageInitNick_3210": "别碰我我有刺",
    "messageInitNick_5873": "迷失的地图",
    "messageInitNick_5874": "太空骑士",
    "messageInitNick_5875": "这题我不会",
    "messageInitNick_5876": "绝对魅力",
    "messageInitNick_3214": "迷路的股骨",
    "messageInitNick_3213": "坐热冷宫",
    "messageInitNick_5870": "残剑刺客",
    "messageInitNick_3212": "保健室主角",
    "messageInitNick_5871": "露水在游泳",
    "messageInitNick_3211": "魔法钥匙",
    "messageInitNick_5872": "被窝哲学家",
    "messageInitNick_3218": "打小我就美",
    "messageInitNick_3217": "没见过帅哥",
    "randomEventDialogueGroupConfig_55.52": "不愧是探索者，就是爽快！",
    "messageInitNick_3216": "纯白的梦",
    "randomEventDialogueGroupConfig_55.51": "离开",
    "messageInitNick_3215": "从容的猫咪",
    "randomEventDialogueGroupConfig_55.50": "任务失败了，你要看好的是这暗的，而暗的已被贼兽抢去了。",
    "messageInitNick_5877": "奉旨卖萌",
    "messageInitNick_5878": "请勿吞服",
    "messageInitNick_5879": "超级无敌卷姐",
    "messageInitNick_3219": "就你瞎逼逼",
    "randomEventDialogueGroupConfig_55.39": "离开",
    "randomEventDialogueGroupConfig_55.38": "确实这里需要预判一下选项是否被改写，但突然有什么瓦解了，你回到了原来的地方。",
    "iapBuyConfigName_1504": "DNA礼遇III",
    "randomEventDialogueGroupConfig_55.37": "离开",
    "iapBuyConfigName_1505": "DNA礼遇IV",
    "randomEventDialogueGroupConfig_55.36": "确实这里需要预判一下，选项是否被调转，但突然有什么瓦解了，你回到了原来的地方。",
    "iapBuyConfigName_1502": "DNA礼遇I",
    "randomEventDialogueGroupConfig_55.35": "离开",
    "iapBuyConfigName_1503": "DNA礼遇II",
    "randomEventDialogueGroupConfig_55.34": "跟上",
    "randomEventDialogueGroupConfig_55.33": "这堵墙试图通过“把选项调转”堵住了你的去路，显然你洞察到了它的计谋。它们走进了一个名叫超镖局的地方。",
    "iapBuyConfigName_1501": "DNA赠礼II",
    "randomEventDialogueGroupConfig_55.32": "离开",
    "messageInitNick_5862": "还在欧洲",
    "messageInitNick_5863": "落寞的凄凉",
    "messageInitNick_5864": "俯瞰天空",
    "messageInitNick_5865": "可爱值爆表",
    "messageInitNick_3203": "无添加小可爱",
    "messageInitNick_3202": "落叶数思念",
    "messageInitNick_3201": "高科技网球",
    "messageInitNick_5860": "解谜老衲",
    "messageInitNick_3200": "自由飞翔",
    "messageInitNick_5861": "石榴魔法师",
    "messageInitNick_3207": "无敌的核糖体",
    "randomEventDialogueGroupConfig_55.42": "敌兽来势汹汹，显然并非平庸之辈。此时疾风兔赶到你身前，将镖旗交了给你，便二话不说投入到了战斗之中。周围掌风呼呼，叫喊不断。",
    "messageInitNick_3206": "命运测算师",
    "randomEventDialogueGroupConfig_55.41": "可偏偏有些硬仗是躲不过的，一个镖师大声喝道，一定得破盘（撕破脸）吗？对面已冲了过来。",
    "messageInitNick_3205": "花开似花落",
    "randomEventDialogueGroupConfig_55.40": "镖队整齐划一镖号行话完全无误，大伙小心翼翼地躲开一切能躲避的危险，显然它们就是超镖局最优秀，最有经验的镖师。",
    "messageInitNick_3204": "钢之强韧",
    "messageInitNick_5866": "蚊香识男人",
    "messageInitNick_5867": "请网友喜欢我",
    "messageInitNick_3209": "戒网必须的",
    "messageInitNick_5868": "全息奶昔",
    "messageInitNick_3208": "机你太美",
    "messageInitNick_5869": "清甜的杨梅",
    "mapNodeName_1585": "金色传说",
    "messageInitContent_3053": "嘿嘿嘿",
    "mapNodeName_1584": "齿轮沙箱",
    "messageInitContent_3054": "咋还没人跟我表白捏哎",
    "mapNodeName_1583": "深海王子",
    "messageInitContent_3055": "我乃光明右使",
    "mapNodeName_1582": "喵响的冒险",
    "messageInitContent_3056": "我还左使呢",
    "mapNodeName_1581": "几何集市",
    "messageInitContent_3057": "等我带个墨镜再来",
    "mapNodeName_1580": "节奏大锤",
    "messageInitContent_3058": "拿来吧你",
    "messageInitContent_3059": "我家怪兽丢了大家有看到吗",
    "mapNodeName_1589": "沙盒之王",
    "mapNodeName_1588": "齿轮沙箱",
    "messageInitContent_3050": "huh",
    "mapNodeName_1587": "火球术",
    "messageInitContent_3051": "我真服了",
    "mapNodeName_1586": "齿轮沙箱",
    "messageInitContent_3052": "有点虚",
    "mapNodeName_1574": "王权游戏",
    "messageInitContent_3064": "好的",
    "mapNodeName_1573": "齿轮沙箱",
    "messageInitContent_3065": "好家伙",
    "mapNodeName_1572": "齿轮沙箱",
    "messageInitContent_3066": "2幼体是吧",
    "mapNodeName_1571": "机械之城",
    "messageInitContent_3067": "又是666的溜溜",
    "mapNodeName_1570": "规则书",
    "messageInitContent_3068": "466是66",
    "messageInitContent_3069": "你闷好冷",
    "mapNodeName_1579": "几何幻境",
    "mapNodeName_1578": "玩伴是右手",
    "messageInitContent_3060": "龙马精神万事如意",
    "mapNodeName_1577": "赛博组件",
    "messageInitContent_3061": "这东西才不是马！",
    "mapNodeName_1576": "魅力换装",
    "messageInitContent_3062": "喂？你要约我啊！有事先走了各位",
    "mapNodeName_1575": "几何幻境",
    "messageInitContent_3063": "别不识好歹 我劝你",
    "mapNodeName_1563": "红色机关",
    "messageInitContent_3075": "隔壁有个球",
    "mapNodeName_1562": "舌与顽袍",
    "messageInitContent_3076": "桐仁和咻咻捏",
    "mapNodeName_1561": "面包荒",
    "messageInitContent_3077": "这不是青铜三小强吗",
    "mapNodeName_1560": "打怪兽",
    "messageInitContent_3078": "又忍不住看了下等级",
    "messageInitContent_3079": "好家伙999桐仁",
    "mapNodeName_1569": "加速板",
    "mapNodeName_1568": "怪谈工坊",
    "messageInitContent_3070": "你怎么手抖了",
    "mapNodeName_1567": "冰霓时代",
    "messageInitContent_3071": "各位老baby好呀",
    "mapNodeName_1566": "模块工坊",
    "messageInitContent_3072": "别对我有奇怪的幻想谢谢",
    "mapNodeName_1565": "齿轮沙箱",
    "messageInitContent_3073": "大家听我说！",
    "mapNodeName_1564": "上下左右",
    "messageInitContent_3074": "给你好康的",
    "mapNodeName_1552": "研究工坊",
    "messageInitContent_3086": "春游吗",
    "mapNodeName_1551": "光逢",
    "messageInitContent_3087": "可可爱爱",
    "mapNodeName_1550": "组件工坊",
    "messageInitContent_3088": "大漠小龙龙",
    "messageInitContent_3089": "我乃独臂大虾",
    "mapNodeName_1559": "召唤流",
    "mapNodeName_1558": "模块工坊",
    "messageInitContent_3080": "还有1111叉叉",
    "mapNodeName_1557": "模块工坊",
    "messageInitContent_3081": "这不是骑兵和走路的兵",
    "mapNodeName_1556": "古记战役-四带一",
    "messageInitContent_3082": "明人不说暗化，不妨说清楚些",
    "mapNodeName_1555": "腾龙之谷",
    "messageInitContent_3083": "和谐和谐",
    "mapNodeName_1554": "香蕉大战",
    "messageInitContent_3084": "文明文明",
    "mapNodeName_1553": "潮霸世界",
    "messageInitContent_3085": "小马好可爱！",
    "99_comment": "通用词",
    "messageInitContent_3097": "喊你们的龙王出来见我",
    "messageInitContent_3098": "龙王在此",
    "messageInitContent_3099": "驭龙骑士在此",
    "messageInitContent_3090": "眼珠要保管好哦",
    "messageInitContent_3091": "看来非劫不可",
    "messageInitContent_3092": "劫什么？",
    "messageInitContent_3093": "戒色戒骄戒躁",
    "messageInitContent_3094": "沙发",
    "messageInitContent_3095": "噗还少了几条龙",
    "messageInitContent_3096": "这里好多龙",
    "randomEventDialogueGroupConfig_1.8": "犹豫就会败北！",
    "randomEventDialogueGroupConfig_1.9": "那果然还是来抢东西吧！让我为民除害！让我为民除害！……#……有贼呀，来怪呀，救我呀！",
    "randomEventDialogueGroupConfig_1.6": "-",
    "randomEventDialogueGroupConfig_1.7": "-",
    "randomEventDialogueGroupConfig_1.4": "-",
    "randomEventDialogueGroupConfig_1.5": "-",
    "randomEventDialogueGroupConfig_1.2": "-",
    "randomEventDialogueGroupConfig_1.3": "-",
    "randomEventDialogueGroupConfig_1.1": "前面有个神秘商人在大喊大叫，一边往前走一边捶胸顿足。",
    "mapNodeName_1596": "好结局",
    "mapNodeName_1595": "心跳组件",
    "mapNodeName_1594": "进化之舌",
    "mapNodeName_1593": "齿轮沙箱",
    "mapNodeName_1592": "齿轮陷阱",
    "mapNodeName_1591": "齿轮沙箱",
    "mapNodeName_1590": "大逃溜",
    "mapNodeName_1599": "时间黑洞",
    "mapNodeName_1598": "？？？？",
    "mapNodeName_1597": "真结局",
    "emblemEffectConfigName_30": "铁壁",
    "emblemEffectConfigName_31": "终结",
    "emblemEffectConfigName_32": "狂战",
    "emblemEffectConfigName_33": "负面抵抗",
    "emblemEffectConfigName_34": "无损",
    "messageInitContent_5625": "海龙破坏跑",
    "emblemEffectConfigName_35": "御守",
    "messageInitContent_5624": "终点见",
    "emblemEffectConfigName_36": "巨化",
    "messageInitContent_5627": "真让人大炮",
    "messageInitContent_5626": "你的大炮有点松弛",
    "messageInitContent_5629": "啊？",
    "messageInitContent_5628": "嗨各位大帅比",
    "messageInitContent_5630": "微妙的变化",
    "messageInitContent_5632": "真嘟假嘟",
    "messageInitContent_5631": "海拔最低的一级",
    "messageInitContent_5634": "懂",
    "messageInitContent_5633": "溜溜要考虑很多",
    "mapNodeName_1505": "贪吃鱼",
    "mapNodeName_1504": "几何幻境",
    "mapNodeName_1503": "方块大战",
    "mapNodeName_1502": "游戏开始",
    "mapNodeName_1501": "几何幻境",
    "mapNodeName_1500": "几何主城",
    "emblemEffectConfigName_20": "ξ",
    "emblemEffectConfigName_21": "稳固",
    "emblemEffectConfigName_22": "霸王",
    "emblemEffectConfigName_23": "自爆",
    "messageInitContent_5636": "大jio一飞",
    "emblemEffectConfigName_24": "野性",
    "messageInitContent_5635": "家人们谁懂啊",
    "emblemEffectConfigName_25": "暴怒",
    "messageInitContent_5638": "怪麻了",
    "emblemEffectConfigName_26": "重生",
    "messageInitContent_5637": "腾龙加赤色素啊",
    "emblemEffectConfigName_27": "嗜血",
    "emblemEffectConfigName_28": "圣洁",
    "messageInitContent_5639": "顶天立地的怪兽",
    "emblemEffectConfigName_29": "祝福",
    "messageInitContent_5641": "还以为什么任期主播",
    "messageInitContent_5640": "明天见",
    "messageInitContent_5643": "带的什么货",
    "messageInitContent_5642": "还有闪光灯",
    "messageInitContent_5645": "通关了主播还会给我送礼",
    "messageInitContent_5644": "点赞投币三连",
    "emblemEffectConfigName_10": "真实",
    "emblemEffectConfigName_11": "自愈",
    "emblemEffectConfigName_12": "普恢",
    "messageInitContent_5647": "好大没问题，要好打",
    "emblemEffectConfigName_13": "起源之魂",
    "messageInitContent_5646": "你好，大",
    "emblemEffectConfigName_14": "起源之魄",
    "messageInitContent_5649": "反正比你大",
    "emblemEffectConfigName_15": "种族克星",
    "messageInitContent_5648": "为什么普通怪兽没有大招",
    "emblemEffectConfigName_16": "增益极化",
    "emblemEffectConfigName_17": "极致元核",
    "emblemEffectConfigName_18": "破甲之力",
    "emblemEffectConfigName_19": "回复祝福",
    "messageInitContent_5650": "问题不大",
    "messageInitContent_5652": "别慌，有老司机",
    "messageInitContent_5651": "震惊",
    "messageInitContent_5654": "大jo！",
    "messageInitContent_5653": "老司机带路",
    "messageInitContent_5656": "隔壁的饭团是什么东东",
    "messageInitContent_5655": "我好慌",
    "messageInitContent_5658": "小拳拳锤你",
    "messageInitContent_5657": "无语子",
    "messageInitContent_5659": "头大",
    "messageInitContent_5661": "下面的面团是什么鬼",
    "messageInitContent_5660": "gogogo",
    "messageInitContent_3000": "我们的征途是星辰大海",
    "messageInitContent_5663": "重锤出击是吧",
    "messageInitContent_3001": "我觉得8星",
    "messageInitContent_5662": "对方正在输出……",
    "messageInitContent_3002": "我觉得行",
    "messageInitContent_5665": "……",
    "messageInitContent_3003": "。。。",
    "messageInitContent_5664": "该换无线键盘了",
    "messageInitContent_3004": "鱼雷宝典",
    "messageInitContent_5667": "真的假的",
    "messageInitContent_3005": "御雷有术",
    "messageInitContent_5666": "啊是面饼沸体",
    "mapNodeName_1539": "天降一掌",
    "messageInitContent_3006": "重重有赏",
    "messageInitContent_5669": "合照最怕的一集",
    "messageInitContent_3007": "浇花",
    "messageInitContent_5668": "地龙后面是什么龙",
    "messageInitContent_3008": "除草",
    "messageInitContent_3009": "谁喊我爹",
    "mapNodeName_1541": "剧本莎",
    "messageInitContent_5672": "战墙都被挡住了",
    "mapNodeName_1540": "我的方块",
    "messageInitContent_3010": "谁喊我十八爹",
    "messageInitContent_5671": "我的屏幕",
    "messageInitContent_3011": "我的墙说它不爱我了",
    "messageInitContent_5674": "这",
    "messageInitContent_3012": "得回去给强加个软垫",
    "messageInitContent_5673": "我的发",
    "messageInitContent_3013": "合理",
    "messageInitContent_5676": "隔壁那两坨到底是什么鬼",
    "messageInitContent_3014": "爱，很爱",
    "messageInitContent_5675": "这得吃多少",
    "messageInitContent_3015": "饿，极饿",
    "messageInitContent_5678": "别锤我！",
    "messageInitContent_3016": "风，很大",
    "messageInitContent_5677": "别反我！",
    "mapNodeName_1549": "突然的X",
    "mapNodeName_1548": "模块工坊",
    "mapNodeName_1547": "溜溜房间",
    "mapNodeName_1546": "模块工坊",
    "mapNodeName_1545": "模块工坊",
    "mapNodeName_1544": "风之旅兽",
    "mapNodeName_1543": "火焰之魂",
    "messageInitContent_5670": "晚安大少爷",
    "mapNodeName_1542": "模块工坊",
    "mapNodeName_1529": "模块工坊",
    "mapNodeName_1528": "模拟园丁",
    "messageInitContent_3017": "水，刺骨",
    "messageInitContent_3018": "你们，够了",
    "messageInitContent_5679": "别星我！",
    "messageInitContent_3019": "听说这里有黯然叉烧饭",
    "mapNodeName_1530": "命运之树",
    "messageInitContent_3020": "来一碗黯然叉烧饭",
    "messageInitContent_5683": "可怕",
    "messageInitContent_3021": "小二上茶",
    "messageInitContent_5682": "吸点欧气",
    "messageInitContent_3022": "来了客官",
    "messageInitContent_5685": "别吸了别吸了",
    "messageInitContent_3023": "请问几位捏",
    "messageInitContent_5684": "吸亿点欧气",
    "messageInitContent_3024": "我有一个梦想",
    "messageInitContent_5687": "风继续吹",
    "messageInitContent_3025": "我有一个幻想",
    "messageInitContent_5686": "大海马",
    "messageInitContent_3026": "我有一个理想",
    "messageInitContent_5689": "跨过山和大海",
    "messageInitContent_3027": "现在是幻想时间",
    "messageInitContent_5688": "别哭，马上就输了",
    "mapNodeName_1538": "齿轮沙箱",
    "mapNodeName_1537": "打鼓达怪",
    "mapNodeName_1536": "几何幻境",
    "mapNodeName_1535": "最强植物",
    "mapNodeName_1534": "几何幻境",
    "mapNodeName_1533": "人马兽",
    "mapNodeName_1532": "几何幻境",
    "messageInitContent_5681": "这是要干嘛",
    "mapNodeName_1531": "如沸星穹",
    "messageInitContent_5680": "啊？喵",
    "mapNodeName_1519": "海漩的呼唤",
    "mapNodeName_1518": "吉他大师",
    "mapNodeName_1517": "模块工坊",
    "messageInitContent_3028": "请停止你的幻想",
    "messageInitContent_3029": "一夫当关",
    "messageInitContent_3031": "这是",
    "messageInitContent_5694": "哪里松弛了",
    "messageInitContent_3032": "hi各位老baby",
    "messageInitContent_5693": "很有松弛感",
    "messageInitContent_3033": "今天也要开心哦",
    "messageInitContent_5696": "拥挤",
    "messageInitContent_3034": "看我一巴掌",
    "messageInitContent_5695": "好怪",
    "messageInitContent_3035": "放过墙吧",
    "messageInitContent_5698": "我荆！别挡住",
    "messageInitContent_3036": "改去战墙修修了",
    "messageInitContent_5697": "怪丛中一点花",
    "messageInitContent_3037": "大家早上好",
    "messageInitContent_3038": "你怎么敢的啊",
    "messageInitContent_5699": "小大姐晚安",
    "mapNodeName_1527": "恋爱传奇",
    "mapNodeName_1526": "旅行萨满",
    "mapNodeName_1525": "水上乐园",
    "mapNodeName_1524": "守卫萝卜",
    "mapNodeName_1523": "怪兽猎手",
    "messageInitContent_5690": "冲鸭",
    "mapNodeName_1522": "比蒙坦克",
    "mapNodeName_1521": "霸拳王",
    "messageInitContent_5692": "再大点好嘛，我说后面的",
    "mapNodeName_1520": "极品司机",
    "messageInitContent_3030": "3小镰刀",
    "messageInitContent_5691": "不够大啊",
    "mapNodeName_1509": "雷霆特攻",
    "mapNodeName_1508": "缤纷乐园",
    "mapNodeName_1507": "单干棋兵",
    "mapNodeName_1506": "黑桃老几",
    "messageInitContent_3039": "又来~",
    "messageInitContent_3042": "不知道还以为是被自己人砍断了",
    "messageInitContent_3043": "这身体到底怎么站在一起的",
    "messageInitContent_3044": "隔壁有个牌坊欸",
    "messageInitContent_3045": "连怪兽都成双成对",
    "messageInitContent_3046": "什么怪兽狗粮",
    "messageInitContent_3047": "闻到了酸臭味",
    "messageInitContent_3048": "抱抱你们",
    "messageInitContent_3049": "你不要过来啊",
    "mapNodeName_1516": "模块传送门",
    "mapNodeName_1515": "时之爪",
    "mapNodeName_1514": "捕鱼达怪",
    "mapNodeName_1513": "红唇游戏",
    "mapNodeName_1512": "天黑请闭眼",
    "mapNodeName_1511": "古记战役-三皮杀",
    "mapNodeName_1510": "桃心老几",
    "messageInitContent_3040": "整整齐齐",
    "messageInitContent_3041": "究极怪兽在开大会",
    "messageInitNick_5396": "纯情鸡精",
    "messageInitNick_5397": "懂的都懂",
    "messageInitNick_5398": "幼儿园班长",
    "messageInitNick_5399": "理工小霸王",
    "messageInitNick_5392": "超神战士",
    "messageInitNick_5393": "芒果之心",
    "messageInitNick_5394": "我好强",
    "messageInitNick_5395": "基于你还爱我",
    "messageInitNick_5390": "迷路的打野",
    "messageInitNick_5391": "不称职的过客",
    "messageInitNick_5389": "把遗憾填满",
    "messageInitNick_5385": "八点的蒸蛋",
    "messageInitNick_5386": "支持国产",
    "messageInitContent_5700": "爱我别走",
    "messageInitNick_5387": "只配当挂件",
    "resoundEventConfigDes_7001": "那一天，超进化大陆的海平面上升到了某个足以引起怪兽们恐慌的高度。\\n冰川谷一分为二，其中一半开始融化。\\n这两件事，迅速地从刚经历完一场大战的尸族口中传播开来。\\n根据尸族的说法，没有融化的那半片冰川谷现在被称作“邪王雪岭”。\\n当时，冰川谷的高空，银色的“月亮”拥向紫金色的“太阳”，试图用自己柔和的银光把释放着让怪兽倍觉煎熬的热量的“太阳”包裹起来。最终“太阳”还是挣脱了“月亮”的怀抱，划过天空，留下一抹紫金色的电光，径直朝西南方飞去。\\n在吞下邪王的孢子之前，日夕的心相当煎熬。\\n吃下去之后会毁容吧？不对，才不是担心这种事！\\n而是，一个从未有过的怀疑。\\n美即正义。她即是绝美。\\n所以，她自信一直站在正义的巅峰。\\n相信性本善的姐姐只能在她之下。\\n但是，万一邪王中的朱丽叶本尊真的拥有凌驾于她的美貌，则“正义”的定义和规则就会被她改写。\\n说不定，邪王要建立的世界才是正确的，而她和其他几个固执的远古族只会被后世记载为“邪恶”与“丑陋”的一方……\\n吞下变异孢子的怪兽会对邪王产生臣服的心情，越高级的怪兽越能抵抗这种意志。日夕不知道自己的怀疑，正是抵抗过程中的产物。若是平时的她，绝对不会相信有美貌凌驾于她们两姐妹之上的怪兽。\\n然后，她在变异孢子的影响下，感应到了那位女王的所在。\\n她打算去会一会朱丽叶。\\n如果对方拥有凌驾于她之上的美貌，那她就会心悦诚服地奉她为“王”。\\n至于罗密欧……无论以何种“美”为信仰的世界，都需要一些幽默。看在他为世界奉献幽默的份上，她就勉为其难地承认他是女王的另一半吧。\\n紫金色的太阳最后一次回头望了一眼被她融化得只剩下一半的冰川——姐姐的脸已经看不到了，银色月亮的柔光和冰雪融为一体——然后头也不回地飞向结晶平原。",
    "messageInitNick_5388": "划水大王",
    "resoundEventConfigDes_7003": "暴虐战狂在笑。\\n离开古拉姆和埃癸斯后，邬羽刹给了暴虐战狂三个提议：一，找剩下两个不朽级的远古族单挑，其中一个还是差点被暴虐战狂遗忘的对手、曾经受他馈赠之恩的真·日夕；二，直接找邪王单挑；三，成为邪王的手下再以敌人的身份和埃癸斯等怪兽对战。\\n前面两个提议都不错，但第三个提议荒唐得让暴虐战狂发笑。\\n不过细想之下又觉得有点道理，如果第二点以后，败给了邪王，小命还在，那成为邪王手下后又可以获得新的对战机会了。\\n说到底，世界的正义与他无关，他只想和看得上的对手拼个死活。\\n所以，当他看到天空出现橙金色的流动时，暴虐战狂露出许愿竟然能瞬间成真的惊愕。\\n被橙金色环绕的、明显不属于真·日夕的魁梧之躯，带着一个怪异的长腿怪从他头顶飞过。看来两者是同伴的关系。\\n“他们的实力，似乎在古拉姆和埃癸斯之上。怎么？你怕了？” 邬羽刹故意刺激暴虐战狂，“要不要先躲开他们？”\\n合体以来，暴虐战狂还是不愿意把身体的操控权交给他，而且这家伙强大得至今身体还是毫发无损。但勇猛过头并非好事，稍稍让这家伙吃点苦头，因为受挫而一蹶不振的话，自己就能顺利控制这个身体。\\n虽然这样做有两个风险，这家伙会越挫越勇，甚至可能在今天死掉。\\n邬羽刹想。\\n所谓冒险，就是明知道这样做会导致很严重的不利结果，但仍然会为有利的结果拼死一搏的行动。\\n邬羽刹正好是个冒险专家。\\n“躲？这种偶遇正求之不得啊！”暴虐战狂笑起来，长久以来积聚在他体内的战意终于得到宣泄的机会。\\n他以冷酷的眼神望着天空中的不朽级，那拳与翼的外轮廓，对方的身份只可能是远古族中的最终兵器。\\n他的战斧，锁定了最终兵器的翅膀，破风飞出！\\n“都下来与我一战！！”\\n算是突袭的一击，让最终兵器在空中振颤了一下。\\n暴虐战狂飞奔去接住急坠下来的战斧，同时心满意足地和那对怪异组合充满敌意的双眸对视了一眼。\\n长腿怪的攻击狂乱地砸下，或许是过于心急完全成了描边。而最终兵器的杀气明明已经被激荡开来，却能按捺着拳头继续往前飞。\\n第二击一定可以把他的双翼劈断！\\n暴虐战狂随着狮吼般的咆哮跃起，虽然他不能飞翔，但他的跨步撼动了脚下的大地，冲刺速度突破音速，他瞬间爆发自身肉体的最大动能，把自己和最终兵器之间的距离拉至最短。\\n他瞄准了最终兵器的背部连接着双翼那个全身最单薄的地方。\\n所有的能量都传至战斧，让战斧高速旋转着，斧刃和斧柄化为一圈互相叠加的残影。无论多么眼疾手快的战士，都不敢伸手硬接这一击。\\n但是，旋转突然停止，残影消失，明晃晃的斧刃对准暴虐战狂。\\n最终兵器，稳稳地接住了战斧。\\n长腿怪在嚷嚷着，法杖多次指向北方，但此刻没人管她说什么，她的声音已经化作互相敌视的两名狂战士的背景音。\\n“我还期待着以一对二啊。” \\n看到最终兵器不甚怜惜地把长腿怪扔到一边去，暴虐战狂有点惋惜地说。\\n下一瞬间，战斧以不输于刚才的威力向他飞来！",
    "resoundEventConfigDes_7002": "罗密欧战败的时候，朱丽叶打了个寒颤，这是共同生命体之间的感应。\\n意识到没有出现那种心如刀割的痛楚，她缓过神来。\\n她的小心肝还没死，可是受伤了吗？还是受到了比伤痛更痛苦的败北的屈辱？\\n朱丽叶，平时都是仪态万方的女王，从来没有表现过慌乱的情绪，但现在的她急如热锅上的蚂蚁，一直催促着洛菲菲赶快飞往极北之地。\\n极北之地是她和罗密欧的降临之地，他们的冰雪城堡的所在，越接近冰雪城堡，她的力量就会越强大。\\n自降临之日、降临之地起，他们的力量会慢慢增强，能完全施展力量的范围也会变广。同时，对方的战士则会获得新的力量。\\n这似乎是冥冥中自有主宰。\\n朱丽叶和罗密欧并没有太在意这些，因为最重要的是他们得到了让爱情延续和升华的舞台。\\n所谓爱情，就是一方死去，另一方就失去存在的意义。\\n就在朱丽叶担心着的时候，最终兵器的一只翅膀被突然飞来的战斧击中。\\n翅膀虽然没有被劈断，但几乎贯穿胸口的剧痛让最终兵器失去平衡，毫无预警的朱丽叶差点被甩到地上。\\n“稳住！继续飞！敌人在下面，我来对付他！”\\n看到一个疾驰的身影朝战斧跌落的地方奔去后，朱丽叶对惊慌的洛菲菲和最终兵器下令。\\n但是，战斧的主人轻松地避开她用法杖发出的几下攻击，并在接住战斧之后立刻转身再次把战斧投掷过来。\\n“嘁！”朱丽叶以厌恶的眼神狠狠瞪着战斧的主人。\\n她想起来了，张狂的杀气、巨大的战斧，他一定就是那个从自己愚蠢的手下手中抢夺石塔神器的怪兽！\\n偏偏这个时候来碍事！\\n朱丽叶的愤怒深深地刻在眉间，那一道道立起的皱纹把美貌变成了凶相。",
    "resoundEventConfigDes_7005": "负责交涉的三者，邪王朱丽叶、洛菲菲和邬羽刹，用怀疑的眼神看着彼此。\\n对心急如焚的朱丽叶来说，此刻已无法谨慎地思虑，只要暴虐战狂别挡路，他要做什么都没关系。但是，洛菲菲却坚决反对，她无法理解这种突然化敌为友的转变，甚至没有对邬羽刹的自我介绍进行礼貌的回应。\\n“咧咧，大姐姐，拜托你别悠哉游哉地袖手旁观，和我们一起攻击这个大块头好吗？”洛菲菲向朱丽叶抱怨道。\\n悠哉游哉？刚才把她甩到大老远的盐地上不正是你们吗？而且，块头更大的也是你们呀！朱丽叶平滑的额头暴起了若隐若现的青筋。\\n“别怪我不提醒你们，刚才你们也算是以二对一，应该明白了吧，要打倒我们不是一时三刻就能办到了吧？我们可是面对群攻更能大放异彩的狠角色哦！”\\n邬羽刹稍微暗示了一下暴虐战狂的技能。\\n“喂！别把不该说的也说了！”暴虐战狂紧张地阻止道。\\n“放心，他们现在的心思不在这里。”\\n邬羽刹向拍档解释完，继续向朱丽叶和洛菲菲说道。\\n“我们只是单纯地把你们看作有价值的对手，也不允许你们先死在其他怪兽手上。换句话说，要是这一路上你们遇上其他敌人，我们也会出手相助。”\\n看着不断点头示好的老女人，洛菲菲强迫自己和最终兵器冷静下来，彻底思考摆脱这个难缠的怪兽的方法。\\n除非把它击破，否则，即使自己获胜，它也会因为好战心继续死缠难打；也无法把以战斗作为生存意义的怪兽变成朋友……\\n“……要我们答应也行，但你们。”洛菲菲举起三根手指，“第一，不能突袭我们，第二，如果下一次一对一无法在十招内决胜负，双方都可以找帮手，以二对二的形式来战斗，如果十招之内还是平手，就请你离开。”\\n“……”\\n“第三——”\\n“第三，如果愿意成为我最优秀的手下，我可以赐予你们变强的礼物。到时，你们就尽情厮杀吧！”朱丽叶打断了洛菲菲的话，急不可待地说，“答应的话，就给我马上出发！！”\\n再磨蹭下去，老娘可饶不了你们！\\n朱丽叶心中这样骂着，可如何饶不了，实际上却毫无办法，只能抛出利诱的手段。\\n“咦？这和说好的不一样，大姐姐你不是说我什么都不用做吗？”洛菲菲质问到。果然，大人都喜欢撒谎。\\n“啧……”朱丽叶按捺着自己不耐烦的凶相，尽可能柔声道，“因为，此乃公主拯救王子之时刻。小妹妹，你依旧不需要做什么，依旧不需要为我而战，只要把我带回城堡就可以了。我并没有违背我的诺言。要不要和他厮杀，是你们的事。”\\n……好像也对。洛菲菲一时之间无法反驳。\\n“我倒想听听原来那个‘第三’是什么？”邬羽刹说。\\n呃……那只是虚张声势的随口一说，电影里和敌人讨价还价的时候，不是都会举起三根手指吗？硬要编一个“第三”的话，该说些什么帅气又故弄玄虚的话呢？\\n洛菲菲苦思冥想。\\n但这个过程并没有持续超过三秒，因为朱丽叶的耐心已经消耗殆尽了。\\n“有什么以后再说！我的耐性可不像我的美貌，能持续到永恒哟！”\\n突然，一股强大的热浪扑面而来，空气中扬起了怒涛般的震动。一个紫金色的“太阳”朝她直冲而来。\\n“那就让我见识一下，你的‘美貌’，喝——！！”\\n光球中蕴含着不服气的吼声。",
    "resoundEventConfigDes_7004": "钢铁与斗魂激烈冲突，拳头与战斧迸出火花。\\n此时的最终兵器清晰地意识到要保护洛菲菲，向暴虐战狂发起攻击。\\n而暴虐战狂终于得偿所愿。不能容忍比自己强大的怪兽存在的偏执，以及与强者交手的快意，这两种心情让他将好不容易接稳的战斧舞成高速断头台。\\n双方交战上百个回合还没分出胜负。乍看之下，能占据上空攻击领域的最终兵器处于有利的位置，但是暴虐战狂不断轮飞的战斧也延伸了他的攻击范围，而且每一击都是置之于死地而后生的招式。\\n果然失算了……现在暴虐战狂身上多多少少挂了点彩，但他完全没放在心上，不，更像是因为这些皮外伤更加勇猛。即使这次战败，也只会给他越挫越勇的志气。\\n区区致命伤而已！再下去，说出这样的话也不奇怪。\\n到底怎么做才能控制这个身体呢？\\n这么想着的邬羽刹，望向那个穿着华丽长裙的怪兽。\\n她是谁？拥有一副实力不止如此的邪魅外表，释放的攻击却毫无震慑力，还有急着要离开这里，却不得不依靠最终兵器的样子。\\n这些，或许都可以成为利用来进行新一次冒险的要素。\\n邬羽刹不但是个冒险专家，还是个胆大心细的男人。\\n“等等！”邬羽刹以不容置疑的语气，向暴虐战狂说道。\\n“怎么了？”\\n在互相挡开对方的一个间隙，暴虐战狂才有心思搭理邬羽刹。\\n“这样下去，恐怕只会变成单纯的体力战。你不觉得无聊吗？”\\n“确实，我的耐性也快被耗尽了。你有什么办法？”\\n暴虐战狂警惕地看着最终兵器，对方的双拳重新蓄聚起杀意，同时，他也提防着邬羽刹会劝说他不要恋战，离开这里。\\n“长腿怪好像急着要去什么地方，我们以保镖的身份，请求跟着他们一起走。”邬羽刹提出一个与暴虐战狂的担心相反的提议，“同行的时候，你可以伺机找出他的弱点，对方一定也会这样做。然后，你们再找机会再战。”\\n“……如果他们中途偷袭我呢？”\\n“难道你连随时踏上生命末路的勇气都没有吗？”\\n“哈哈哈，你这家伙，别太口不择言了，我现在还没完全信任你！好，就照你说的做，如果对方也愿意的话。”\\n暴虐战狂心动了，现在只剩下让邬羽刹说服对方。\\n第一次，暴虐战狂听从了邬羽刹的建议，几下格挡后，他来到已经放弃攻击的长腿怪身边。\\n“喂，你们要赶着去什么地方吗？”\\n他把交涉权交给了邬羽刹。",
    "resoundEventConfigDes_7007": "如暴虐战狂所说的，战斗很快结束了。\\n最终兵器依旧带着朱丽叶飞在空中，暴虐战狂则在地上狂奔。\\n因为冰川谷的融化，结晶平原也迎来了最严重的涨潮，陆地面积大大缩小。大家很快就来到了冰冷的海边。\\n越过超星海洋的时候，暴虐战狂吼了几只在海边捉鱼的叉叉帮他渡海。摇摇晃晃的木筏在快到达目的地的时候沉没了，暴虐战狂靠着几块浮冰和令人惊叹的跳跃力，和最终兵器同步到达邪王雪岭。\\n误打误撞地，暴虐战狂几乎一下子实现了三个愿望，所以一路上他心情大好地把身体交给邬羽刹控制。\\n一路以来，好几个疑问一直在洛菲菲脑海中盘旋。邪王朱丽叶越来越给她一种割裂的感觉，初遇时不费吹灰之力的强大优雅，和现在毫不掩饰的焦躁。\\n不，或许这是她在敌人面前的伪装？\\n洛菲菲这样为朱丽叶解释着。但是，邪王究竟做了什么坏事呢？曾听埃癸斯和日夕说过邪王用奇怪的进化和强化孢子引诱怪兽，让它们为自己效力。可这不是很正常的等价交换吗？孰正孰邪、孰强孰弱，洛菲菲想确认之后再选边站。\\n但是，为了给自己留一条后路，她并没有完全和日夕割席，战斗之中，最终兵器虚晃一下接近日夕身侧。\\n“这次就先装死吧，大姐姐。”\\n留下了这句不知道是单纯的手下留情，还是预告着再会的时候会一起密谋些什么的话。\\n日夕没准会以为自己是故意潜伏到邪王身边，不过自己并没有向她承诺什么。\\n洛菲菲这样打算着。\\n洛菲菲不知道日夕是抱着投诚的觉悟来的，而继续把她当作对立方的怪兽看待，无意中阻止了她向邪王投诚的计划。\\n另外，如果日夕再次和月夕、埃癸斯他们相遇，一定会把自己刚才的表现告诉大家，大家会因为自己这种模棱两可的态度产生疑惑，得出各种可能性。以后自己要是再次切换阵营，就能顺着他们的想法解释过去。\\n来到这里之后，第一次，洛菲菲露出了笑容。\\n她为自己的心计喝彩，并漠视了那个转瞬即逝的念头——是因为李雨蒙曾经的照顾，她才手下留情。",
    "resoundEventConfigDes_7006": "无法抑制的能量在日夕体内奔腾，炽热炙热燥热毒热，身体仿佛随时会爆炸。\\n找到了，那抹邪魅的紫色幻光！\\n终于，亲眼目睹了那份比雕像更能魅惑人心的美貌！\\n日夕调动全身的力量，抑制向朱丽叶投诚的冲动，并把它转化成对其是否值得她投诚的试炼之力。\\n朱丽叶很美，但并非美到她不敢直视、只能下跪膜拜的地步。\\n她，这片大陆最美的存在，要让出桂冠和奉上忠心，就要得到对方站在巅峰之上的证明。\\n而且！\\n她还有赢的可能性！静态的美和战斗的美，是美的两个层次！\\n就在此地，让这股躁动尽情释放吧！！\\n突然，日夕觉得此刻的自己很像在石塔遇到的那名战士。哼，即使再次相遇，她也能无畏与其一战，让那双曾露出不屑眼神的双眸，充满爱慕之情地仰视她！\\n紫金色的光球直击朱丽叶，那是胸有成竹的一击。但是同时，她透过自己的光芒，看到朱丽叶早已举起法杖。而她身边，还站着两名怪兽，他们身上都覆盖着橙金色的流动。\\n以法杖为中心，呈半圆形扩散开的暗紫色光波形成的防护罩，完全抵挡了紫金色的冲击波。表面看来，两者都是毋庸置疑的强大。\\n实际上，朱丽叶已经用光了所有魔力，握着法杖的手不住地颤抖，法杖也产生了细微的裂纹，而日夕的骨气，也被这一挡摧毁殆尽。\\n这丫头，有着和自己相似的力量波动，明显是吃了变异孢子才变得这么强大，可是却用强大的意志抵抗着向自己效忠的诱惑力，看来变异孢子对不朽级的控制力还是不够，还有改良的余地。但是，比起小心肝的安危，这事不急！自己已经拥有两名不相伯仲的不朽级骑士，以后慢慢用他们做实验品也不迟！\\n朱丽叶这么想着，她并不知道自己因紧张而僵直着身体被日夕误读成另一层意思——\\n这份力量、从容与优雅，果然是当之无愧的邪王呢！\\n这么想着的日夕，缓缓降落到地上，正准备以不输于邪王的优雅姿态下跪表示忠诚。这时，一阵豪爽的笑声传入日夕耳中。\\n光芒逐渐散去，两名不朽级的怪兽显露出她熟悉的身影。\\n“哈哈哈哈哈！原来是你，那天之后，你竟然有老老实实地锻炼自己！”\\n“呼……呼……你们……也投诚了吗？”日夕一边喘着气，一边试图重新积聚力量。\\n“嗯？不懂你在说什么，不过，既然好不容易相遇，就让我们把应尽的天命都尽了，把未完的战斗做个了断！”\\n不好，这家伙的斗志，又被激发起来了！邬羽刹相当懊恼。\\n幸好，日夕现在像燃尽的引擎，无法那么快重新点燃的样子，暴虐战狂应该一下子就能把她劈倒。\\n本来，邬羽刹就是个毫无怜香惜玉之情的男人，来到这片以更野性的方式生存的大陆，他只会更冷血地开拓属于自己的生存之道。\\n从这点来看，说不定他和洛菲菲会志同道合。\\n斧刃的寒光再次闪烁，不过，在它能染上日夕的鲜血之前，一记迅猛的铁拳以迅雷不及掩耳之势从侧方挥出，击中日夕的腹部。\\n最终兵器要保护洛菲菲的意识再度占据了主体。\\n不过，因为太容易得手了，洛菲菲十分错愕。\\n让最终兵器把身体控制权交给自己后，她来到倒地不起的日夕身边。\\n“大姐姐，好久不见……”\\n“小妹妹……就这么急不可待地，向邪王展现忠心吗？”\\n日夕在这般狼狈的境地，说出我是来投诚的呀，这种等于求饶的话，是无法说出口了。终究是远古族骄傲的首领，除了力量之外，骨气也重新积聚起来。它们逐渐化成光弹在她手中出现。\\n“啊！？”洛菲菲惊讶地回头看了眼那个面容扭曲、尖叫着“给我杀了她”的老女人。\\n可是，洛菲菲的攻击比日夕的力量积聚来得更快。\\n虽然洛菲菲还处于惊讶之中，但她同时出手了，是重伤日夕，却不致死的力度。\\n飞拳在无数的光弹中穿梭，在最终兵器越来越强的攻击中，光弹逐渐出现疲态，即使被打中也只是皮外伤的程度。\\n“哼，原来只是这种程度而已。”暴虐战狂把战斧扛回肩上，略感无聊，“刚才第一下的那种攻击，先冲我来嘛，哈哈哈！速战速决吧，我们还要赶路呐！”",
    "resoundEventConfigDes_7009": "前往熔火之巅，会先通过一片叫滚石山脉的陆地，那里最有名的，是经常会被山间疾风吹落的石头，第二出名的，是由流经熔火之巅从不冷却的火山周围的海水、汇入某个山坑形成的温泉湖。\\n现在，钢铁龙王巴萨克正惬意地泡在不断沸腾的温泉中，偶有从不知哪里的山巅吹落的石头打在他身上，“按摩”的力度刚刚好。\\n巴萨克在思考着。\\n最近有不少龙族怪兽离开了熔火之巅，哼，随便他们好了。稍有胆识的，就应该在外面历练一番后，回来挑战他的族长之位。\\n他稍作休息后，就会寻找下一座石塔。他逐渐觉得灵族族长的说法有点道理，如果是石塔的出现把邪王（如果有的话）引来的，只要把石塔尽数毁灭，就能阻止邪王降临。\\n这个重任，只有他能承担。当然，他绝对不是因为还没有挑战成功任意一座石塔才产生这种想法的。\\n在对将来满足的畅想中，在氤氲的热汽中，巴萨克渐渐陷入了假寐。\\n“根据日夕小姐的说法，那些纹章，是用戮魔钢锻造的。”\\n“能熔化戮魔钢的，只有龙族喷出的火焰。”\\n“这才是邪王想要征服龙族的真正目的。”\\n“有了这个证据和刚才我们救下的几名龙族，钢铁龙王巴萨克一定会接受我们的提议。”\\n“别想得太乐观了，说不定到时得靠武力征服巴萨克。”\\n“别说这么垂头丧气的话，这可不像你。”\\n“……到时，我可帮不上什么忙，只能指望你和日夕小姐了。”\\n半睡半醒间，巴萨克听到了让他郁躁的对话。\\n征服龙族？征服他？泡温泉泡晕了才有这种异想天开吗？\\n日夕？远古族还有一位首领好像就叫日夕，那么泡在隔壁温泉里的两个雄性，是古拉姆和埃癸斯？\\n巴萨克愤然站起，准备去看个究竟。\\n对了，这个温泉，虽然是天然的温泉，但由某个怪兽经营着。\\n这时，温泉老板老态龙钟的身影出现在氤氲的水汽中。\\n“族长老爷，有几位荒火龙在另一个温泉池里晕倒了，俺力气不太够，能麻烦您帮个忙吗？”\\n“臭小子们被温泉烫晕了？”区区温泉对荒火龙来说不是像热水澡一般的存在吗，竟然在这种地方让龙族丢脸？\\n“不是，是被滚石击晕的。”\\n“没用的家伙！”\\n被钢铁龙王铁拳打醒的几条荒火龙，在首领面前战战兢兢地讲述着几个不朽级的远古族把他们从邪王的手下中救出的事。\\n“你们亲眼看到邪王了？”\\n“呃……那倒没有……”一条荒火龙说。\\n“但捉我们的那支队伍里，有暴龙和铁甲龙。”另一条荒火龙说。\\n“他们都大吼着‘为了王’什么的。”第三条荒火龙说。\\n“你们傻啊！就不会怀疑他们跟狡猾的远古族是一伙的？”手下的愚钝点燃了巴萨克的怒火。\\n根据这几个笨蛋的描述，出手相救正是古拉姆他们。果然，刚才就该直接一脚踹穿温泉与温泉之间的石围墙。\\n“跟我来，我去替你们问个明白！”\\n“……是！首领！”几条荒火龙面面相觑，都觉得首领有点儿知恩不报。\\n可是，古拉姆和埃癸斯已经不在那个温泉里面了。\\n“族长老爷，这里的客人刚走了。”老板这样解释到。\\n“可恶！”差点就可以逮到他们问清真相了。\\n“他们往北去了。族长老爷，以你的脚程，马上就能追上。”水汽依旧氤氲，老板搓着手，一个劲儿向巴萨克殷勤地补充到。\\n“好！小的们，我们也去北方！”\\n钢铁龙王离开之后，温泉恢复了宁静。往日，温泉的客人以龙族为主，随着邪王降临的传闻开始，有这份闲情逸致的怪兽渐渐减少，有时一天也来不了一个客人。\\n但是，温泉老板好像一点也不惋惜走掉的客人，乐呵呵地关上了温泉店的石门。\\n“老板，刚才谢谢你。”埃癸斯从一个角落里走出来，不好意思地说。\\n“没事儿没事儿，龙族的族长老爷可难伺候了，他走了俺省心。万一你们打起来，我的温泉可遭殃啦。”\\n即使不在温泉边上，温泉的热气还是飘散到周围。埃癸斯看到老板身上似乎围绕着一层淡淡的橙金色流动，但眨眨眼，浅淡的光芒就不见了。\\n自己看错了吧，老板怎么可能是不朽级的怪兽？埃癸斯想。\\n不是看不起的意思，除了刚才看错的一瞬，老板身上的确没有橙金色的流动，而且，难以想象不朽级的怪兽，会愿意和害怕伺候龙族族长。\\n“你们就再泡会儿，需要俺擦背的话就吼一声，俺耳朵背，得靠吼的呵。”老板热情地说。\\n提议来泡温泉的是李雨蒙。被他们救下的龙族说这里有个不错的温泉时，她和日夕都马上表现出浓厚的兴趣。冰川谷一战让日夕全身脏兮兮的，裙子也相当褴褛，另外，泡澡能让精神放松，戒心放下，古拉姆老是板着脸的样子，她很难和他的搭档聊天呀。",
    "resoundEventConfigDes_7008": "根本就不用装死，最终兵器的最后一拳就让日夕吐了一大口鲜血。幸亏她现在回血能力大增，那一拳拳的痛楚就像幻痛一样。但是，她还是痛得瘫在地上喘不过气来。\\n唉，投诚的时候遭遇了这种丢脸的事，她的黑历史又增添了浓重的一笔。\\n“先休息一下，再从长计议，邪王那里，暂时是去不了了。”李雨蒙说。\\n从她认为自己是某个游戏公司的人体实验品后，除了假装顺从于剧情的发展，她还在偷偷观察，寻找其他实验品。\\n估计那位欧文先生是个NPC，理由是这么理性的人居然没有发现她所“洞悉”的事实。\\n至于暴虐战狂的拍档嘛，由于接触太少，暂时还不清楚他的身份。\\n但是，毫无疑问，洛菲菲一定和自己一样，也是实验体。\\n那句只让自己听到的话，便是隐约的信号。\\n虽然还不清楚洛菲菲为什么要这样做——难道她想潜伏在最终Boss身边找Bug，让自己先去寻找更多的实验者，集结成一股反抗的力量？\\n不管如何，相信下次见面时，就可以和洛菲菲交流更多情报。\\n还有一件不能忘却的重要的事，那些被木偶族的族长骗走的召唤具。\\n已经使用过的召唤具是无法再度召唤人类过来的，这点是和日夕闲聊中得到的情报，也就是说木偶怪兽的说辞是假的。\\n所以，用其他npc骗走召唤具，也是这个游戏针对实验体的防御机制，召唤具，对游戏实验体的清醒有着重要的作用吗？\\n凄婉的抽噎声打断了李雨蒙的千头万绪。\\n虚空中，日夕抱膝而坐，把头埋在膝盖里，往昔能照亮虚空的光芒，也黯淡得只剩下若隐若现的暗光。\\n即使明知道那只是虚拟的伙伴，李雨蒙还是不忍心让日夕独自面对日渐积累下来的挫败与伤痛。\\n“好啦好啦，你可是第一个和邪王交手后能全身而退的女神呀。单凭这点，”李雨蒙柔声安慰到，“在这里哭鼻子可太谦虚了。”\\n“是这样吗……”\\n即使她们只是由彼此意识具象化的躯体，但拥抱在一起仿佛也能互相取暖似的，日夕的心渐渐暖起来。\\n“而且，”李雨蒙举起双手，“看，变异孢子的毒完全被你压制住了。说不定多喝热水就能排出体外。”\\n细嫩的肌肤下，已经没有紫色的光芒要迸裂而出。\\n“呀，真的耶……没有归顺邪王……实在太好了！”\\n“嗯！”\\n“不过……多喝热水是什么？”\\n“那个啊，是我们那边快捷方便的排毒方法。”\\n重新打起精神的日夕，兴冲冲地向李雨蒙打听那种神奇的方法。\\n“休息得差不多了，我们走吧！”李雨蒙说。\\n“嗯！回冰川谷，姐姐应该很担心。”想起姐姐，日夕有点愧疚。\\n不料，才刚站起来，脚下就一个趔趄，差点摔倒。果然，浑身的骨头还是像碎掉一样。\\n这时，一双手从背后稳稳地扶住了她。\\n“日夕小姐，好久不见。”见日夕站稳，搀扶者放开她，拿起插在地上的重盾。\\n“埃癸斯？”\\n“日夕小姐。”搀扶者旁边的剑士也轻轻地点了下头。\\n“还有古拉姆？”\\n在晨光草原的时候，虽然日夕和古拉姆、埃癸斯的交往不多，但能同时遇上他们，刚才抖擞的精神中又增添了一股振奋。\\n然后，大家开始交换情报。日夕隐瞒了自己吃了变异孢子的事。比起邪王是二位一体的存在，暴虐战狂和最终兵器都投靠了邪王的消息让古拉姆和埃癸斯更加惊讶。\\n可是，即使惊讶很快转化为愤怒，古拉姆依旧咬紧牙关，忍耐着，没有说话。\\n反而是平时话少的埃癸斯和日夕讨论了一下洛菲菲的事情。\\n“古拉姆，你怎么了？”日夕还是忍不住问到。\\n“……没什么，只是，现在的我没有资格加入你们的讨论。”古拉姆晦声晦气地说。\\n古拉姆发生什么事了？日夕用疑问的眼神望向埃癸斯。\\n说来话长……在沉重的气氛中，埃癸斯只好也用眼神这样回应到。\\n透过古拉姆无精打采的眼睛，李雨蒙看到了一个困于烈火牢笼的人影，那个人影，似乎在朝自己呼喊着。\\n无关重要的人……刚才她和埃癸斯的搭档马克自我介绍后，古拉姆是这样轻轻带过自己的搭档。他们之间，似乎存在着不是三言两语就能化解的矛盾。\\n说不定……对方是由于发现了这个游戏的什么而遭受到某种惩罚，那他正是自己要寻找的第三位实验体。马克和埃癸斯个性相近了，更像是游戏中的npc。\\n“后面的行动，能暂时交给我吗？古拉姆的搭档，好像是我认识的人。”\\n“咦！？”\\n“等我找机会和他聊聊。”\\n“嗯，交给你了。”\\n然后，根据之前的讨论，三位首领决定先去熔火之巅，集结龙族的力量。\\n有不少龙族怪兽已经效忠邪王，不管他们是出于自身的意志，还是受到邪王的魅惑，不可一世的龙族族长、钢铁龙王巴萨克应该不会对此袖手旁观。",
    "messageInitContent_5709": "看饿了",
    "messageInitContent_5702": "你心疼个锤子",
    "messageInitNick_5381": "吃醋的米虫",
    "messageInitContent_5701": "心疼锤子",
    "messageInitNick_5382": "捂着脸睡",
    "messageInitContent_5704": "大宝贝",
    "messageInitNick_5383": "和寂寞相爱",
    "messageInitContent_5703": "我就心疼个锤子",
    "messageInitNick_5384": "万能帽子",
    "messageInitContent_5706": "为什么不是巨王",
    "messageInitContent_5705": "嗯？",
    "messageInitContent_5708": "饿了",
    "messageInitContent_5707": "大大盘鸡",
    "messageInitNick_5380": "证明我的强大",
    "messageInitNick_5378": "香蕉龙",
    "messageInitNick_5379": "爱只剩下余温",
    "messageInitNick_5374": "旺仔小裤头",
    "messageInitNick_5375": "闭上眼洗澡",
    "messageInitContent_5711": "最爱的大毛毛",
    "messageInitNick_5376": "明灯",
    "messageInitContent_5710": "老剧！",
    "messageInitNick_5377": "中午吃茄子",
    "messageInitContent_5713": "那是对面的猫猫",
    "messageInitNick_5370": "你是外星人",
    "messageInitContent_5712": "猫猫给你打call",
    "messageInitNick_5371": "机械化枇杷",
    "messageInitContent_5715": "召唤猫薄荷",
    "messageInitNick_5372": "移动的探索者",
    "messageInitContent_5714": "猫猫快到碗里来",
    "messageInitNick_5373": "姐姐起猛了",
    "messageInitContent_5717": "呼呼呼",
    "messageInitContent_5716": "什么",
    "messageInitContent_5719": "小魂魂",
    "messageInitContent_5718": "小蛋蛋",
    "messageInitNick_5367": "不行让我来",
    "messageInitNick_5368": "东窗思雨",
    "messageInitNick_5369": "和自己在一起",
    "messageInitContent_5720": "大锤锤",
    "messageInitNick_5363": "独步天涯",
    "messageInitNick_5364": "情绪疯子",
    "messageInitContent_5722": "那是谁留了一手",
    "messageInitNick_5365": "姐从不卖萌",
    "messageInitContent_5721": "隔壁好大的手",
    "messageInitNick_5366": "半忧郁少年",
    "messageInitContent_5724": "不许睡起来嗨",
    "messageInitContent_5723": "不是我",
    "messageInitNick_5360": "认证头铁专家",
    "messageInitContent_5726": "有端联想",
    "messageInitNick_5361": "鸡蛋的烦恼",
    "messageInitContent_5725": "来租房，不给钱那种",
    "messageInitNick_5362": "超级大会员",
    "messageInitContent_5728": "好怪",
    "messageInitContent_5727": "别别别",
    "messageInitContent_5729": "这铜仁c位啥意思",
    "messageInitNick_5356": "心虚公子",
    "messageInitNick_5357": "孤僻浪子",
    "messageInitNick_5358": "洋葱射手",
    "messageInitNick_5359": "伏地嘤",
    "messageInitContent_5731": "大意了没有闪",
    "messageInitNick_5352": "别刻意讨好",
    "messageInitContent_5730": "就突出它小只呗",
    "messageInitNick_5353": "叫我一声爷",
    "messageInitContent_5733": "嘻嘻",
    "messageInitNick_5354": "院长别跑啊",
    "messageInitContent_5732": "小白",
    "messageInitNick_5355": "中间的才是",
    "messageInitContent_5735": "干啥啥都行~",
    "messageInitContent_5734": "发生什么了！",
    "messageInitContent_5737": "钢铁的身躯",
    "messageInitNick_5350": "手握面包",
    "messageInitContent_5736": "钢铁的意志",
    "messageInitNick_5351": "被窝深潜者",
    "messageInitContent_5739": "钢铁直人对吧",
    "messageInitContent_5738": "钢铁的心",
    "messageInitNick_5345": "回到原点",
    "messageInitNick_5346": "北国故人",
    "messageInitContent_5740": "你的钢龙有点",
    "messageInitNick_5347": "黑眼圈",
    "messageInitNick_5348": "霸气的你",
    "messageInitContent_5742": "捅了钢龙窝了",
    "messageInitNick_5341": "笑多了会怀孕",
    "messageInitContent_5741": "这里是钢龙领地吗",
    "messageInitNick_5342": "假装很幸福",
    "messageInitContent_5744": "点头",
    "messageInitNick_5343": "面包鸡",
    "messageInitContent_5743": "抱走猫猫怪嘻嘻",
    "messageInitNick_5344": "追风少年",
    "messageInitNick_5349": "中了再来一遍",
    "messageInitNick_5340": "生气的火焰",
    "messageInitNick_5334": "还是起猛了",
    "messageInitNick_7997": "西门有很",
    "messageInitNick_5335": "大路痴丫头",
    "messageInitNick_7996": "直接开摆",
    "messageInitNick_5336": "认证跑调专家",
    "messageInitNick_7999": "枫无痕",
    "messageInitNick_5337": "临窗赏雨",
    "messageInitNick_7998": "用力过猛的瓜",
    "messageInitNick_5330": "在逃美术老师",
    "messageInitNick_7993": "气质这块",
    "messageInitNick_5331": "消费馅饼",
    "messageInitNick_7992": "拖鞋狂怒者",
    "messageInitNick_5332": "恰似你温柔",
    "messageInitNick_7995": "瑟瑟发抖",
    "messageInitNick_5333": "小鳄鱼文物",
    "messageInitNick_7994": "参见萌妹砸",
    "98_-140003": "怪兽种族未达到压制条件",
    "98_-140002": "消除的词缀效果已达到上限",
    "98_-140001": "深渊先遣不存在",
    "messageInitNick_5338": "会唱歌的沙滩",
    "messageInitNick_5339": "咒语不会念",
    "98_-140005": "怪兽上阵中，请下阵后再试",
    "98_-140004": "cjhwy2",
    "messageInitNick_7991": "远方传来的你",
    "messageInitNick_7990": "霸天战狼",
    "messageInitNick_5323": "隔夜妖姬",
    "messageInitNick_7986": "钢琴兔",
    "messageInitNick_5324": "本皇只要你",
    "messageInitNick_7985": "夹娃娃请投币",
    "messageInitNick_5325": "高级感苹果",
    "messageInitNick_7988": "超级平底锅",
    "messageInitNick_5326": "我破防了",
    "messageInitNick_7987": "戴营养师",
    "messageInitNick_7982": "最爱龙眼",
    "messageInitNick_5320": "独闯地狱",
    "messageInitNick_7981": "单身女王",
    "messageInitNick_5321": "嘤嘤嘤怪",
    "messageInitNick_7984": "已恢复单身",
    "messageInitNick_5322": "科技狠活",
    "messageInitNick_7983": "记忆烧成灰",
    "messageInitNick_5327": "芭蕉龙",
    "messageInitNick_5328": "给沙发把脉",
    "messageInitNick_7989": "吃点人间的苦",
    "messageInitNick_5329": "可降解砧板",
    "messageInitNick_7980": "不似少年时",
    "messageInitNick_5312": "迷雾饿兽",
    "messageInitNick_7975": "天堂汤圆",
    "messageInitNick_5313": "哥只是个传说",
    "messageInitNick_7974": "不知火舞弟弟",
    "messageInitNick_5314": "萌萌哒养生壶",
    "messageInitNick_7977": "捡漏小能手",
    "messageInitNick_5315": "他们这两家",
    "messageInitNick_7976": "世界回归寂静",
    "messageInitNick_7971": "无尽的螺丝",
    "messageInitNick_7970": "洗衣液剑客",
    "messageInitNick_5310": "七点的凉粉",
    "messageInitNick_7973": "香菜之心",
    "messageInitNick_5311": "日薪月一",
    "messageInitNick_7972": "奉旨泡妞",
    "messageInitNick_5316": "心在旅行",
    "messageInitNick_7979": "康我平底锅",
    "messageInitNick_5317": "头发搬家了",
    "messageInitNick_7978": "无重力洗衣机",
    "messageInitNick_5318": "椰子的呼吸",
    "messageInitNick_5319": "既见那个未来",
    "messageInitNick_5301": "高瞻远主妇",
    "messageInitNick_7964": "百事小甜饼",
    "messageInitNick_5302": "喋血蔷薇",
    "messageInitNick_7963": "剑过留毛",
    "messageInitNick_5303": "起床打工了",
    "messageInitNick_7966": "便利店老板",
    "messageInitNick_5304": "帅到灵魂深处",
    "messageInitNick_7965": "陪我忘记",
    "messageInitNick_7960": "这播的的吗",
    "messageInitNick_7962": "会飞的小金人",
    "messageInitNick_5300": "腐乳妖怪",
    "messageInitNick_7961": "滚出我的心",
    "messageInitNick_5309": "河豚不许笑",
    "messageInitNick_5305": "微风在耳语",
    "messageInitNick_7968": "银子怪兽",
    "messageInitNick_5306": "逢刮必中",
    "messageInitNick_7967": "伙食好过头",
    "messageInitNick_5307": "丑小鸭",
    "messageInitNick_5308": "早已删除你",
    "messageInitNick_7969": "哥纯帅",
    "messageInitNick_7953": "收音机很无奈",
    "messageInitNick_7952": "防弹冬瓜",
    "messageInitNick_7955": "外来媳妇",
    "messageInitNick_7954": "一百亿",
    "resoundEventConfigDes_7010": "古拉姆并没有按照老板的建议继续用温泉放松身心。他站在温泉中，紧握着自己的断剑——虽然临时锻造了一把大剑，但还是断剑就手——把不时掉落下来的滚石劈成两半。\\n自从他那天发怒之后，他就再也没有听到林宇翔的声音，还以为那家伙会一直安静下去，最好永远像不存在一样。谁知道遇见日夕的时候，那家伙对日夕大呼小叫，一定是因为日夕和她的搭档都是美女。\\n哼，轻浮好色的家伙！\\n一块从天而降的大石被古拉姆两剑劈成四块。\\n其实，林宇翔不是不敢和古拉姆说话，而是他自己也由于万分羞愧，无法面对古拉姆。\\n之前，即使接受了穿越到异世界的事实、即使鼓起勇气与这片大地的邪恶一战，但多少还带着点玩票的心情旁观，因为总觉得到了紧要关头要奋身肉搏的人并不是自己。就像在原来的世界，真正去抓捕罪犯的是警察、真正去保家卫国的是人民军队，像他这种大众青年，从来都是躲在一张安全网后面，动动手指在网上冲锋陷阵就权当勇敢。\\n他也曾想成为正义的伙伴，但这种理想被高度成熟的社会和精细的社会分工稀释为键盘侠的高谈阔论。\\n也正是这种长久以来的安逸感，让林宇翔在不恰当的时候开了不恰当的玩笑，惹怒了古拉姆。古拉姆的怒火具象化而成的牢笼，已经退却了一开始的炽热，它现在更像古拉姆一份彻底与他决裂的心意。\\n林宇翔在认真地反省，积极地思考如何负荆请罪。\\n但这份冷静，在遇到李雨蒙时瞬间瓦解。她，正是他最关注的视频博主，也就是送他最新VR游戏的那个人！\\n但是，无论他怎么呼喊，古拉姆依旧没有理睬他。细想一下，他能对女神说什么呢？我是你的粉丝？还是，我就是对你瞎逼逼的家伙？还是……对不起？\\n林宇翔没有发现，可能受了这段旅程的影响，他已经变得不那么嘴上不饶人了。\\n和依旧与自己过不去的古拉姆不同，埃癸斯和日夕在温泉老板的小石屋里聊天。\\n“老板，你为什么要帮助我们？”日夕问。\\n不与龙族族长战斗是埃癸斯的坚持，平时心高气傲乐于主动迎击的古拉姆也没有反对。她嘛，也不愿意在无聊的战斗中虚耗力量和被对方摸清实际战力。\\n不过，戒心还是要有的。\\n“哪里的话，对抗邪王的不朽级远古族战士，可是俺一直以来的偶像！”老板看着他们，兴奋的目光中还带着些……爱怜？\\n“谢谢你愿意相信我们。为了守护大家舒舒服服泡温泉的幸福，我们不会让邪王捣乱的。”埃癸斯说。\\n“你能看到我们的流动？”日夕再次问到。\\n“啊，这个呀……俺可没本事看到那种漂亮的东西，俺是听别的怪兽说起的你们。”\\n老板的回答也算合情合理，但是，一种违和感还是充斥着日夕的心头。\\n“那敢情好！支持我们的怪兽越来越多了，那证明我们能集结的防御力量也越来越大。”埃癸斯说。\\n“千年一战，俺可期待万分啊！嗯！俺也会用沸腾了千年的温泉，洗去战士们身心的疲劳与伤痛，为这场大战，尽一份绵力！”\\n“老板，你也知道邪王大战一千年才会发生一次？这可是只记载在远古族先祖留下了的珍贵卷轴中的事情呀。”\\n“嘛……俺、俺是听龙族的族长老爷说的。”回答之前，老板稍微迟疑了一下。\\n“那么，你又是怎么知道这个温泉有一千年的历史了？”\\n“日夕小姐？”\\n“我只是想多了解老板，老板似乎很了解我们呀。”\\n“……”\\n埃癸斯无法像日夕这样步步紧逼地质问对方，但他不得不承认日夕问得有道理，而且，他想起了刚才看到围绕在老板身上若有若无的橙金色流动。\\n对李雨蒙来说，那种违和感更产生在言语上，老板似乎故意用“俺”来称呼自己，让自己更像一个质朴的乡下怪兽。\\n“这……这些，俺、俺不都是听说的嘛……”老板强笑道，依旧一口咬定。\\n日夕皱了皱眉头，无法攻破的借口呢，而且老板的确没有做出伤害他们的事，继续留下来和老板聊天，也是因为古拉姆还赖在温泉里不走。\\n在尴尬的沉默中，老板看着埃癸斯和日夕，依旧笑得很真诚。\\n“……老板，我看到了，你身上橙金色的流动。”\\n没想到首先打破僵局的是埃癸斯，而提醒他的正是马克。\\n橄榄球中，负责传球的四分卫通常会由其他球员组成攻击线锋来保护，他们会为四分卫开路、阻挡对手抢球。掩护，在比赛中是如此重要。\\n温泉里蒸腾的热汽，仿佛就是老板的掩护。他能确定埃癸斯没有看错，因为他也看到了。这样的话，温泉热汽会是那种奇怪流动的掩护吗？因为要长期依赖这种掩护，才干脆成为温泉老板。\\n马克向埃癸斯传达了自己的大胆猜想。\\n然后，本来就不会拐弯抹角的埃癸斯，凭借马克的猜想，开门见山地问老板。\\n“……”\\n“如果我看错的话，能请你到没有水汽的地方，让我再确认一下吗？”埃癸斯有礼貌的问到，但语气却不容拒绝。",
    "messageInitNick_7951": "十全大补鸡",
    "resoundEventConfigDes_7012": "这个悲壮的故事仿佛是响彻众人耳边的一个惊雷，不过，大家的反应不尽相同——\\n哼，那家伙才不会这样死掉，古拉姆想。因为自己绝不允许那家伙出战，所以更不会有那家伙为了保护自己而死亡的事情发生。\\n一直以为战争结束或者自己战死、搭档就能回去那个世界的埃癸斯和日夕，都陷入了不安，无论是神灵朱雀还是温泉老板，都无法告诉他们人类能否回去的真相，更别说回去的方法了。\\n马克已经冷静下来，扪心自问，在万一的情况下，他会把战争的胜利放在自己的生命之前。嗯，能以另一种战士的身份在异世界牺牲，也是上天赐予的一种荣光。\\n李雨蒙则认为这是游戏对她的警告，轻举妄动的话，就会让她脑死亡。\\n大家都在考虑生死的时候，林宇翔倒很羡慕老板和他搭档之间的友谊，再想想自己和古拉姆……唔……古拉姆同学，总有一天，我会让你看到我的好！林宇翔下定了决心。\\n可惜，古拉姆留意不到他这份真诚，他看着老板落寞悲凉的样子，提出了一个大胆的建议：“前辈，如果你再有一次机会召唤异世界的伙伴，能帮助我们打倒邪王吗？”\\n“你、你说什么！？”\\n“我刚才在练剑的时候，看到温泉外面，出现了一座石塔。”\\n亲眼看到一座石塔拔地而起，古拉姆心中一阵雀跃，不过后来想到日夕说过即使有新的召唤具，已经进化为不朽级的他们也无法再次召唤新的伙伴，再度进化，他只能郁闷地望塔轻叹。这时，一向稳重的埃癸斯急冲冲地来找他，他还以为埃癸斯也看到了新的石塔。\\n想象着千年前的激战，古拉姆觉得老板一定是一千年前最强大的战士，因为只有他从残酷的战争中活了下来。如此强大的战士，只留在这里给泡温泉的怪兽擦背，不是太可惜了吗？\\n战场才是战士的舞台，他或许无法成为强者，但他愿意仰望着强者，追随强者的脚步前进，古拉姆想到。\\n可是，老板犹豫了好一会儿，因为他觉得重新找一个搭档，是对挚友的背叛。\\n“看着世界再次引来灾难而不挺身而出，才是对那位骑士的背叛啊！”\\n终于，在古拉姆的说服下，老板决心再次踏上战斗的征途。",
    "messageInitNick_7950": "故事说书人",
    "resoundEventConfigDes_7011": "“……呵，还是被你们发现了。”老板笑着叹了口气，挺直有点佝偻的背部。\\n他竟然比埃癸斯还要高大。\\n“你们别担心，现在，俺真的只是一个不起眼的温泉老板，不过，一千年前，俺也曾是一个不起眼的远古族战士。和你们一样，获得异界战友的助力，打败邪王。”\\n“啊！？”日夕和埃癸斯异口同声地惊呼起来。\\n“你们就把俺看作，年老体衰的支持者吧。苟活到现在，没想到还能看到璀璨夺目的新一代英雄，让我马上去死的话，我也瞑目了。哈哈哈哈！”\\n虽然说话有点文绉绉，但老板的笑声爽朗，一点也不显老态。\\n一千年前，某个大州甚至还没出现在世界地图上，马克感叹到。\\n哼哼，游戏剧本越来越好玩了。李雨蒙狐疑地看着老板，他体内的另一个意识，总不会属于被囚于这里长达千年的实验体吧？\\n似乎感受到马克和李雨蒙这两位异界英雄狐疑的目光，老板收敛起笑容，略感痛心地按着胸口，严肃地说：“可惜，曾寄宿于这个身体的那位勇士，千年之前已经先行离去了，无缘看到这么优秀的后继者……”\\n“他、他回到自己的世界了吗？”马克激动地问到。\\n“不……为了保护俺，他的生命之火，在那场战争中，熄灭了。”\\n仿佛在回应老板沉重的回忆，老板身上再次闪现橙金色的流动，虽然只是一刹那，但这回连日夕也看到了。\\n很快，埃癸斯就把古拉姆带到老板的石屋里，小小的石屋顿时拥挤起来。\\n见大家神色凝重又万分期待地看着自己，老板开始徐徐讲述自己与拍档的故事。\\n故事很简单，相似的开头、相似的试炼、连伙伴间从陌生到心意相通的过程都那么相似，但和邪王有关的记忆却像被抹去一般，只有手上的鲜血和遍地残骸提醒着残喘于世界的胜利者们，邪王大战确确实实发生过。\\n胜利之前，战况如黎明前的黑暗，那时他正独自与邪王战斗，其他英雄正被邪王的大军拖延在赶来增援的路上。\\n由于连续的战斗，身负重伤的他已经再没有力气招架邪王的攻击，意识也因越来越接近死亡而渐渐模糊，但是，他的搭档却依旧以钢铁般的意志在坚持，并不断唤醒他。\\n快要死掉的怪兽，很容易受到搜魂兽、破魂领主这类怪兽的攻击。他们喜欢夺取那些脆弱的灵魂，囚禁在身边，随时随地拿出来把玩。不朽级的怪兽，而且一个身体有两个灵魂的远古族战士，更是他们最梦寐以求的猎物。\\n在搭档抵挡邪王攻击的时候，邪王手下的嗜魂怪们也开始围攻他们。\\n他的灵魂（意识）开始飘离身体，并能一度俯瞰和邪王死战的“自己”（搭档）。\\n突然，一个温暖而有力的怀抱紧紧抱住了他，让他再度回到意识的虚空中。\\n“不要……在意……我……你要……打败邪王……”\\n本来就伤痕累累的身体又遭受了几下重击。\\n“那正是你的使命！我只是你的助力！！”\\n一股暖流传至他的心脏和脑部，搭档把自己所有的精神力量传递到他“身上”。他感受到意识再度和躯体重叠在一起踏实感。\\n“休息够了吗？接下来……就交给你了……”\\n搭档代替他成为猎物，替他抵挡了嗜魂怪们的所有攻击，意识渐渐变得稀薄。\\n“再见……”\\n“不要！！！”\\n他虽然已经恢复了一部分力量，但却只能无能为力地看着搭档（的灵魂）飘离他们共有的躯体，化作无数闪亮的粒子，飘向嗜魂怪们张开的、有无数灵魂在里面尖叫的斗篷。\\n但是，那位勇敢的骑士拼尽最后的力量，也没有让嗜魂怪们得逞。闪光的粒子聚成一个小小的光团，挣脱嗜魂怪们的引力控制，撞开一块正要砸向老板的巨大陨石。\\n他最后的生命如烟花般在浑浊的天空中绽放，比流星更耀眼。\\n“之后，其他英雄赶到了，我们的力量终于能和邪王抗衡。即便这样，其他英雄都在战争中牺牲了，只有俺苟延到现在。至于是怎么赢的，俺记不起来了，其他英雄的搭档都平安回去那边的世界了吗？俺不知道，但俺的挚友啊，已经化作这片天空中的星尘了吧？”\\n老板闭上眼睛，即使是残缺不堪的回忆，也让他久久回味。",
    "resoundEventConfigDes_7014": "老板说得没错，巴萨克虽然自傲，但并不愚蠢。他一心想逮住古拉姆和埃癸斯，用武力压制来逼问远古族“邪恶”的计划。正当他等到快失去耐性的时候，石塔出现了，同时，天空连续划过三颗流星。那是灵族族长苏比斯和他约定的信号。\\n滚石山脉是灵族练习操控引力的地方，没想到今天苏比斯也在这里。\\n他赶到石塔的时候，看到苏比斯。对方还算信守承诺，和一队灵族怪兽在塔外守着。石塔里面的宝物归他，作为交换，他会让部下协助灵族摧毁石塔。\\n“快动手！远古族的古拉姆和埃癸斯就在附近！”巴萨克一声怒吼，冲进塔内。\\n啧啧，真是个性急的家伙。苏比斯咂了砸舌。呵……如果巴萨克死在塔里，他还可以趁机收获一个珍贵的不朽级灵魂。\\n巴萨克不需要他帮忙，他也没打算施以援手，他的舞台，在繁星闪烁的苍穹之下。\\n很难用一句话概括苏比斯是正是邪，他不希望邪王成为最后的赢家，同时觊觎着在大战中战死的怪兽的灵魂。他听说自己的祖先能直接从生者身上抽取灵魂，能习得这种伟大的技能，就真是再美妙不过的事了。但无论他怎么努力磨练自己，斗篷内增加的灵魂也只是来自徘徊在已死者身上的残念。\\n对苏比斯来说，石塔才是他的猎物。里面的宝物只能让远古族进化，已经是不得不接受的事实，只是巴萨克死活不肯相信。而且，即使联合龙族和木偶族，也不一定能灭绝远古族。\\n但是，如果能摧毁石塔，就还存在着把石塔的能量转化为自身进化力量的可能性。当进化成不朽级的破魂领主后，说不定就能习得祖先那个伟大的技能。到时，他一定要得到最终兵器的灵魂，以报部落被无意义屠戮之仇！\\n苏比斯和巴萨克都没有亲眼见过邪王，但他们的所想不一样。巴萨克依旧认为邪王大战很可能是远古族企图统领所有怪兽的阴谋，而苏比斯则希望用摧毁石塔来阻止邪王的降临，如果无法阻止，唯有在残酷的战争中短暂享受孤魂遍地的狂欢。\\n不过，摧毁石塔最大的可依靠战力，只有善于召唤陨石的血刃和咒刃，他的必杀技“引力·贯穿”在没有敌人的此地，有点鸡肋。\\n看来，今天是收获不了灵魂的日子。苏比斯觉得有点无趣。\\n这是他第三次试图摧毁一座石塔了。\\n第一次是在月夕完成试炼的时候，他让部下召唤流星砸毁石塔，可惜当时被另一队想夺取石塔宝物的怪兽和月夕阻止。\\n第二次是一座里头已经空荡荡的石塔，他亲自出马，可惜大家不断召唤陨石攻击石塔至到筋疲力尽，也只是徒劳无功。因此，苏比斯猜想，摧毁石塔的最佳时机应该是他们曾经错过的，石塔被入侵的时候。于是，他找到了钢铁龙王巴萨克，提出联手的建议，巴萨克保持着一向尊大的态度接受了他的求助。\\n此时此地是第三次，苏比斯不想重复前两次的失败，他要等到龙族族长在塔内发起猛烈攻击的时候在集中最大的力量从外部摧毁石塔。\\n正当他准备命令部下骑到飞龙身上时，远古族出现了，后面还跟着那个平日他偶有帮衬的温泉店老板？难不成塔底有一个温泉？那更好，在浮力和引力的双作用下，他成功的机会更大。\\n可惜的是，最终兵器不在这里，无妨，今天就先接收这三个不朽级的灵魂吧。\\n苏比斯举起镰刀，展示着杀意——得天独厚的远古族呵，世界可不是唯你们独尊！",
    "resoundEventConfigDes_7013": "在前往石塔的短短的路上，老板就发现古拉姆的闷闷不乐和沮丧，也看到了他的断剑。\\n“小伙子，你怎么比俺这个老头子还没精神？”\\n“没什么……”\\n“你的搭档，是个怎么样的人类？”老板好奇地问到。\\n“他……”古拉姆支支吾吾，他不想在前辈面前过多地抱怨林宇翔。\\n不过，这份犹豫竟换来了老板感同身受的同情。\\n“俺懂，他死了……”\\n（不对！我还活着！）\\n“唔……”自己的确当他不存在了，古拉姆想到。\\n（古拉姆同学！你再不说话就太过分了啊！）\\n“他……是怎么牺牲的？”\\n“……”\\n（编不出来了吧！哼！）\\n“抱歉抱歉，俺不应该问你这么伤心的事……”\\n（老头子，他哪里在伤心！）\\n“他不是个太有志气的人，不在也没关系。”\\n（喂！不是让你说这种话！）\\n“那你干嘛把得到召唤具的机会让给俺呢？”\\n“因为，前辈能成为一个比我更厉害的战士！”\\n怎么办？看来这位倔强的小伙子是不会轻易改变主意的，得到召唤具召唤成功后，自己要快点给他找一座新的石塔才行。老板想到。\\n古拉姆和老板的对话，让埃癸斯和日夕不安地交换了好几个眼色。\\n可惜，敌人并没有给各怀心事的大家更多时间——石塔，被灵族和龙族捷足先登。\\n来自无数灵魂的凄鸣仿佛要刺穿他们的耳膜，绕着塔尖盘旋的飞龙们张狂地宣誓着主权。\\n只有灵族族长苏比斯的斗篷才会发出这种可怕的声音。\\n很快，陨石和山间滚石开始砸向石塔，飞龙们穿梭在坠石之中，朝石塔喷出炙热的火焰。\\n金属的激撞声和铁砂摩擦般的怒吼声从塔内传来，龙族族长巴萨克正在塔内战斗。\\n似曾相识的战况，埃癸斯想起了之前和灵族、木偶族的一战。看来，灵族在邪王降临没多久后，就找了木偶族和龙族结盟。\\n龙族族长和木偶族族长的目标都是石塔中的召唤具，但是，有钢铁龙王巴萨克在，疤脸史卡非斯就没有在巴萨克的利爪下抢走召唤具的机会。\\n埃癸斯举起重盾跑到大家前面。果然，包围石塔的怪兽只有灵族和龙族，里面并没有木偶族的身影。\\n“难道龙族的族长老爷根本没有相信俺的话？”老板抱歉地说，“如果他一直在温泉外头等着你们，就一定不会错过这座石塔的诞生。”",
    "resoundEventConfigDes_7016": "塔外，埃癸斯和日夕陷入了一场胶着的战斗中。\\n埃癸斯抵挡掉大部分的陨石攻击，但以苏比斯为首的一众搜魂兽却已“引力·贯穿”穿透他的巨盾，给他和他身后的日夕造成伤害。\\n日夕不断施展回血技能，让战局变成了持久战的状态。\\n日夕已经没有“飞行能力”，之前的“悬浮”与“飞行”，只是体内急剧产生的巨大能量迸射而出所造成的效果。当那波巨大的能量在攻击朱丽叶的时候如核爆般炸裂而出后，日夕已经能凭自身的意志力压制因变异孢子产生的邪恶力量与欲望。\\n但是，如果她发动攻击，心中就会响起邪王充满诱惑力的指令，让她把攻击转向埃癸斯。现在，为了避免自己的迷失，日夕尽量只守不攻。\\n这点并没有引起埃癸斯的注意，因为他本来就是一位即使面对敌人，也以防守为主、不愿伤害对方的战士。如果无法进入石塔，他当然希望同伴与他一样，以防守来消耗敌方体力，最后让敌方不战而退。\\n埃癸斯希望老板能尽快获得石塔的召唤具，到时大家就能马上撤退。如果那时还能与灵族和龙族对话是最好的，但估计对方的战意会比现在更猛烈。\\n可惜，埃癸斯和日夕只牵制了对方部分战力。另一批以虚刃、咒刃、血刃组成的灵族战士，正被飞龙们吊在上空。\\n他们按照族长的指令，同时以石塔为目标，召唤出大量陨石。陨石从空中倾泻而下，石塔依旧毫无损伤。苏比斯的猜想错了吗？难道石塔在被入侵的时候也是坚不可摧的？\\n部分飞龙们趁苏比斯陷入沉思的时候，同时向它们身下吊着的，毫无防备的虚刃、咒刃、血刃们猛地喷出烈焰，然后迅速将被烧得还剩半口气的灵族部队被狠狠地甩向石塔。\\n飞龙们仿佛向石塔投下了一堆炸弹，撞到石塔的灵族部队一个个都炸裂了开来。\\n 于是，混杂在一起难分先后的爆炸声，和紧接着什么极速划破天空的呼啸声，让苏比斯回过了神。\\n只见十几颗大到不可思议的流星，一瞬占据石塔的上空，下一瞬扑向石塔。\\n苏比斯马上明白了，眼角闪烁出晶莹的泪光。为了我的理想，大家竟然做到这个份上！\\n这些灵族怪兽的召唤力将在死亡时冲破自身的极限，达到最大，召出一颗比生前任何一次召唤都要大的流星。\\n苏比斯不知道自己自作多情了。\\n这几名灵族，以及吊着他们的飞龙，都是邪王的手下，邪王赐予这些灵族一种新型的纹章——自爆纹章，鼓动他们，在同族试图拔起石塔的时候“帮个大忙”。\\n这是罗密欧的其中一个实验。自爆纹章会让怪兽在死亡时爆炸，产生极其可怕的伤害。虽然触发有些许麻烦，毕竟就算是变异孢子，要压下怪兽的求生本能，让他们自杀也不是易事。但只需要让飞龙们帮个小忙即可。怪兽总有一死，当然是伟大地为他而死。\\n而且他们还吃下变异孢子，本来就比同级的同族强大。在变异孢子的影响下燃尽生命力量召唤的流星，还有自爆纹章，在强强叠加的优势下，如果苏比斯的方法可行，那么以后，罗密欧就可以考虑用这种方法把所有超进化大陆新出现的石塔完全破坏。\\n不过，苏比斯和罗密欧的期待都落空了，他们根本想象不出石塔是何等神奇的存在。\\n先后接下了十几位灵族死亡时产生的爆炸，以及十几颗超大流星的冲撞的石塔，并没有任何损伤，仅仅是短暂地产生了一些引力紊乱，让古拉姆他们处于失重状态。",
    "resoundEventConfigDes_7015": "已经没有对话的可能了。\\n苏比斯镰刀一挥，无数陨石和山间滚石向埃癸斯他们砸过去。不过，有了上次的战斗经验，埃癸斯举起重盾，轻松地挡掉所有攻击。在埃癸斯的掩护之下，古拉姆和温泉老板跑进石塔。\\n塔内火星四溅，那是由两头拥有钢铁之躯的巨兽，以肉搏的战斗方式造成的余波。其中一头巨兽是龙族族长，不用问，另一头身躯比他还要庞大的巨兽就是塔之守卫了。他们时而扭打在一起，时而其中一方被另一方甩到塔壁上，躯体与塔壁擦出火星。\\n“古拉姆？贪得无厌的家伙——”\\n瞥见古拉姆，巴萨克的怒火激发了他龙魂霸体，他甩开塔之守卫，朝古拉姆冲了过来。塔之守卫不会离开石塔，当务之急得先把远古族赶出去！\\n古拉姆犹豫了一下，把长剑抛给老板，自己只握着断剑就挺身刺向巴萨克。\\n“前辈，我来缠住他，你快去打败石塔守卫！”\\n“……好！俺去去就来！”\\n看到古拉姆把好的剑给了自己，老板有点过意不去，但战况已经容不得他再犹豫。近千年没有战斗过的身体对手中的长剑有一股疏离感，但在石塔守卫一记铁拳轰至眼前时，疏离感激变成强烈的求生欲。\\n哎呀呀，说什么再度成为击败邪王的战士，还是先保命要紧啊！老板不甚熟练地闪躲了几下。但他毕竟是位曾经的英雄，即使偶有一拳躲避不及而被打飞，也没有难看地倒下，而是往后方跃开，稳稳站好。几个来回后，老板已经全然唤醒了沉睡已久的战意和武技，连像不稳定的微弱电流般的橙金色流动，也开始频繁地在他身上闪现。\\n“你的拳头太嫩啦，塔之守卫哟！俺以前的那个试炼者啊，可让俺吃了不少苦头啊！喝！！”\\n老板一跃而起，掷出长剑，长剑直接在守卫后上方的塔壁上撞出一片火星。趁着散落的火星阻挡了守卫的视线，老板一脚踢在守卫的胸口上，然后利落地接住随火星落下的长剑，再次急驰而出。\\n与“华丽”二字完全扯不上关系的剑术，看得古拉姆目瞪口呆，他很难将面前这个矫健的身影和那个老态龙钟的温泉老板联系在一起。\\n“不要分心，小伙子！”感受到古拉姆无比崇拜的目光，老板喊到。\\n跟老板的提醒同时到来的是巴萨克的霸气。\\n“原来你是来给我送零食的！” 钢铁龙王一记头槌撞到古拉姆头上。\\n他摩擦着锋利的钢齿，露骨地嘲笑着古拉姆地断剑。他今天就要把这把用纯度极高的戮魔钢锻造的剑吃掉！\\n古拉姆一剑刺向巴萨克。\\n难听的笑声停止了，巴萨克表情扭曲地看着自己的腹部。\\n古拉姆也惊喜地看着自己的这一击，但又觉得有什么不对，这么容易就得手了吗？\\n“喔嚯嚯嚯嚯！！”笑声再度响起，甚至比刚才的还要狂暴。\\n“剑尖”太钝了，它只能勉强戳痛巴萨克坚硬的腹部。他在激烈的战斗中肆意地嘲弄着古拉姆，剥去古拉姆的身为战士的尊严。\\n“没用没用没用！！凭你这样还想打败我！？”\\n猝不及防地，古拉姆的脚踝被巴萨克的尾巴卷住，他才反应过来，身体已经被扔到半空，重重地摔到塔壁上。\\n“呜呃——“\\n“不、不能轻易倒下，哪怕战斗力差距再大，能够填补差距的，也只有意志力！要相信远古族的意志力！身为天选之子的远古族，背负着严苛的使命，是绝不会这么早就离开赐予使命的舞台的！让苦境把血肉化作比敌人更坚不可摧的钢铁吧！”\\n“吵死了！！”林宇翔充满激情的嘶吼在古拉姆的脑袋里奔腾。\\n古拉姆一拳捶在自己左边的太阳穴上，这家伙的嘴炮攻击，能把任何怪兽逼疯，真想把他塞到巴萨克的脑瓜里！\\n古拉姆重新站起来，掏出手机，嗯，能量果然已经充满了。\\n“喂！你、你别乱来！！”林宇翔大喊。\\n“合体咒语？”古拉姆不管林宇翔的抗议，问到。\\n“我、我忘了……”林宇翔支支吾吾，不知道该如何应对自己撒下的弥天大谎。\\n古拉姆没有再理会林宇翔，而是直接把手机贴合在剑身上。\\n“这就是你得到的神器？”\\n巴萨克好奇地看着古拉姆，没有急着再次发动攻击，他想看看古拉姆到底在干什么。\\n“合——体——”古拉姆大喊。\\n但是，手机和断剑还没来得及产生任何变化，古拉姆就惊觉自己身子一轻，双脚离地，整个身体飘浮起来。\\n不止他，连巴萨克、老板和石塔守卫也飘浮起来，老板的剑击和守卫的重拳都在空中失去了力量，只留下迅烈、但转瞬即逝的风痕。",
    "messageInitNick_7957": "残月狂战",
    "resoundEventConfigDes_7018": "林宇翔还在绞尽脑汁思考着，巴萨克已经朝他扑了过来。\\n如果林宇翔还是那个干瘦的青年，龙族族长身上散发的龙魂之气足以把他的心脏捏碎、崩坏他的精神，但他现在拥有一副强健无比的躯体——只是头很痛，可能还流血了，不过思考能力应该没受到影响。\\n林宇翔按照老板的指示，狼狈地横跨几步，尽量站到巴萨克的鼻尖正前方。\\n巴萨克也随着林宇翔的移动侧了侧头。\\n为什么他总要侧着头看我？林宇翔回想起自己对战过的那条鳄鱼，哦不，陆龙，那小怪兽并没有这种奇怪的动作。\\n林宇翔记忆力很好，这是他平时专注地记下嘴炮用的“好词好句”锻炼出来的。\\n所以，他能清楚地记得陆龙的双眼长在它长长的鼻子上方，而钢铁龙王的双眼长在又厚又长的鼻子两边……\\n噗嗤！我懂了！林宇翔恍然大悟。\\n林宇翔躲过巴萨克的一拳，嗤嗤笑着的脸上充满了刚才不存在的自信，即使握着的只是一把断剑，但浑身依旧充满了斗志。\\n“呵呵呵！你不敢正脸看我？” 林宇翔继续挪动着脚步，“还是瞧不起我？下一招，我就要拿你小命哦！”\\n林宇翔突然手指上方：“看！流星！”\\n如果古拉姆还有意识的话，一定会给林宇翔一个大大的白眼，然后生气地说：“怎么又用这招？”\\n这是林宇翔很久以前和四只变异虚刃战斗时用过的烂招。如果在其他战斗场地，巴萨克是不会上当的，但偏偏外面的灵族正在召唤陨石，他还以为石塔真的被砸穿了。\\n“喝！！”\\n巴萨克抬头的时候，林宇翔直直地冲向他，他估算好了角度，即使恶龙低下头，也看不到他，因为那个时候，他正在恶龙鼻子的正前方。\\n钢铁龙王无法看到正前方的景象，这就是林宇翔悟出的，恶龙的弱点！\\n虽然幼体级的陆龙的双眼也是长在鼻子的两侧，但那两只又凸又圆的眼珠在鼻子的两侧上方，所以没有视角盲区。\\n这是龙族进化所带来的小缺陷，但他们在进化的过程中并不会有任何不适的感觉，因为他们会靠身体移动、转头来调整视角，只要速度够快，这个小小的缺陷很快就能弥补。\\n所以，林宇翔失算了。\\n如果单凭知道钢铁龙王的视角盲区就能想出致胜奇招，那么古拉姆一早就想出来了。\\n而且久经战场的巴萨克根本不用低头，单凭风声就知道敌人来袭的方向。\\n这次偷袭的结果，是林宇翔身上受到了巴萨克连续的重击，受伤的头部更是被重点击打的部位。\\n古拉姆果然没有骗他，如果身体受了伤，掌控者会承受绝大部分的痛苦。\\n“咳、咳……你这是……在给我搔痒吗？”、“求求……你别……踢我了，你的脚……好臭……”、“我也不想……打击你……但你只配……给远古族擦脚……”、“你……改名吧，别叫……钢铁龙王了……塑料龙王……怎么样？” ……\\n戏谑的话源源不断从林宇翔嘴里骂出来。\\n别人挨揍的时候是默默忍受，但林宇翔偏偏要用嘴炮来反击敌人——虽然没啥用。\\n人才啊！老板为林宇翔捏了把汗，他看到林宇翔死命把古拉姆的断剑护在怀里后，很是感动。巴萨克刚才嘲笑过古拉姆的断剑是他的零食，想不到这小伙子一直放在心上。他越来越喜欢林宇翔了。\\n老板摸清了石塔守卫的弱点，开始发动最后一击。",
    "messageInitNick_7956": "迷上门口老头",
    "resoundEventConfigDes_7017": "塔内，被打断战斗的战士们猝不及防地重重摔在地上。只是，比起到塔外探究失重的原因，还是先打倒眼前的敌人重要。激烈的战况继续进行着。\\n但刚才的突变，让古拉姆的手机脱手飞出，掉在巴萨克面前，更糟糕的是，他比巴萨克晚了一步着地。\\n这次，巴萨克没有再给机会古拉姆演示他的兵器合体，他一把抢过手机和套着手机的召唤具，然后朝古拉姆头部一脚猛踢，把他踢到远处。\\n砰！受到重击的古拉姆，头部撞在比石头更坚硬、和刀剑一样尖锐的地方，他好像听到了自己头骨碎裂的声音，然后眼前一黑，晕了过去。\\n在意识的虚空中，随着古拉姆的晕厥，困着林宇翔的火之牢笼熄灭了，古拉姆的意识也具象化为一个晕倒的古拉姆，掉在林宇翔面前。\\n“喂！古拉姆！！醒醒！！”林宇翔扶起他，“再不醒过来，我就用这个身体跳广场舞啦！！”\\n但无论怎么叫喊，古拉姆依旧双目紧闭。这家伙，平时不是最讨厌他话多的吗？\\n林宇翔环顾了一下四周。\\n温泉老板在担心地看着古拉姆，但是老板与石塔守卫的战斗并没有停下来，所以他的分心让他受了几下守卫的重击。\\n守卫身上长满了坚硬的金属犄角，刚才古拉姆就是撞上守卫的犄角，才晕倒的。守卫毫发无伤，也不理睬古拉姆，他只是朝钢铁龙王怒吼一声，示意着收拾完老板再对付他。\\n巴萨克则跳到远处，好奇地看着手机和召唤具，他把手机放进嘴里咬了几下。\\n“不要！”屏幕碎裂的声音让林宇翔一跃而起！\\n这手机的屏幕据说是采用了防弹玻璃的技术来制造的，希望做手机的说到做到啊！林宇翔祈祷着。\\n利用巴萨克正在咬手机的空隙，林宇翔连滚带爬地迅速跑到断剑掉落的地方。现在，他如愿以偿地控制着身体，可是时机也太糟糕了！\\n巴萨克松开口，露出打从心底蔑视的表情看着颤巍巍握着断剑的“古拉姆”。\\n“这宝物，到底要怎么用？乖乖告诉我，我还可以饶你一命。”\\n手机屏幕上果然出现了蜘蛛网般的裂痕。\\n“谁会告诉你啊，笨蛋！”虽然害怕，但不能示弱，否则古拉姆醒来后，会更生自己气的！\\n尽管非常心疼手机，但林宇翔更在乎古拉姆对自己的看法。\\n老板见“古拉姆”的动作迟钝下来，以为他受了很重的伤，便转过剑尖，想来帮他一把，但老板被守卫的攻击紧紧笼罩着，很难脱身。\\n“老爷子，不用管我，我自己能行！”\\n“诶！？”老板愣了一下，“你……是他的搭档？俺以为你已经死了！！”\\n古拉姆称呼老板为“前辈”，而林宇翔张口就叫他“老爷子”，老板一下子听出了区别。\\n“我活得好好的！只是这家伙在闹脾气！”\\n两者的对话让巴萨克听得云里雾里，他也懒得弄明白他们究竟在说什么。\\n“嚯！你还打不打？还是索性让我一拳锤爆你的小脑袋！”巴萨克把手机和召唤具扔到一边，发动技能“龙魂·霸体”。这次，他并没有打算给古拉姆一条活路。\\n“打！当然打！怕你不成！”林宇翔吼到，手依然颤抖着。\\n“小伙子，你先躲在他的鼻尖前，俺很快过来帮忙你！”老板一边与守卫战斗，一边说到。\\n“……啊？”对老板的话，林宇翔有点不解，但老板身陷苦战，自己不能继续打扰他。\\n躲避的话，不是应该绕到这条恶龙的身侧或者身后吗？\\n不过，现在回想起来，战斗时古拉姆会一直调整位置，尽量站在恶龙的正前方。\\n这是为什么呢？",
    "messageInitNick_7959": "山不语",
    "messageInitNick_7958": "上午九点半",
    "resoundEventConfigDes_7019": "石塔守卫会根据闯入者的不同而诞生出不同的形态。这次已经是巴萨克第二次对石塔发起挑战。\\n第一座石塔的守卫是由火山熔岩构成的怪兽，它能喷出把“龙魂·铁幕”烧熔的烈焰，而这座石塔守卫的身体由无比坚锐的金属组成。\\n木偶族族长史卡非斯擅长骗术，所以石塔让无数镰刀怪包围他，令他无法对数量庞大的敌人施展骗术。\\n不过，如果中途闯入其他挑战者，石塔守卫并不会因此而改变形态。\\n现在，老板的长剑上已经被守卫的坚锐犄角碰撞出很多细小的缺口，这把剑是临时打造的，坚持到现在已经很了不起了。\\n根据刚才的战斗来看，那个地方是守卫全身最脆弱的部位。那里覆盖着几层钢铁铠甲，只有在守卫抬头的时候，铠甲和铠甲之间才会露出极细微的缝隙。\\n还有一点算不上弱点的奇怪之处，就是石塔守卫会在他倒地的时候，抬头望一下塔顶，虽然守卫很快又会把视线锁定在他身上，但究竟为什么要望塔顶呢？难道在暗示挑战者弱点的所在？\\n没有这么放水的守卫吧？但是，不明白的地方先暂时放下，自己的确找到了守卫的弱点，这就够了！\\n老板再次踏着塔壁高高跃起，举剑瞄准了守卫的喉咙。\\n挚友啊，想不到俺今日，有幸再次使用你教的那个绝招——\\n“入阵！人剑如一无穷突刺！！”\\n守卫抬头的瞬间，剑尖分毫不差地刺入它的咽喉，老板达到人剑一体的境界，化作一道强光穿透守卫的身体。\\n不知该算是铠甲还是表皮的钢铁化成无数光之粒子，很快，连守卫也消散在空中。\\n一个召唤具掉落在老板手上。\\n“这东西，和一千年前的没什么不同嘛。”\\n老板把召唤具放进怀里，甚至没有等待召唤具会为他召唤怎么样的异界英雄，就赶去支援毫无反抗之力的林宇翔。\\n召唤具的出现让巴萨克停止了对林宇翔的蹂躏。\\n“吼——！！！”\\n巴萨克怒吼着，毫无疑问，他需要塔内这两条性命的牺牲才能换取他的息怒。\\n石塔的神器，即使被别的怪兽抢先获得，那么再抢过来便是了，让巴萨克感到屈辱的，是他进行了那么久的死斗都无法打败的敌人，竟然被那个平时毫不起眼的老不死轻轻松松战胜了。那不就是意味着他连一个温泉老板都不如吗！？\\n石塔内的战斗继续进行着，但巴萨克的气急败坏和老板的游刃有余显示了这场战斗已近尾声。\\n“小铁龙，歇口气吧，你的敌人不在这里。”\\n“老不死，你究竟是谁？”\\n老板伸腿横扫把巴萨克绊倒在地，拽着他的尾巴转了几圈，把他扔出去。\\n“下次来泡温泉，俺再告诉你！”\\n巴萨克狠狠地撞上高处的塔壁，再重重地摔到地上。\\n趁着巴萨克挣扎着重新站起来的当儿，老板赶紧扶起林宇翔，想带他离开石塔。\\n啊，别把我的手机忘了。这样的话，林宇翔已经没力气说出来了。\\n这时，塔内的引力再次失控，老板、林宇翔和巴萨克再次飘浮起来，召唤具也在老板的怀中飘了出来。\\n像在水中一样，巴萨克狗爬式地，想去阻拦老板和林宇翔，老板也以相似的动作把林宇翔拽向洞口。一切就像是慢动作。\\n突然，老板的胸膛传来一阵剧痛，他低下头，似乎看到一截尖刀从胸口凸出来。\\n说“似乎”，是因为一股黯焰很快笼罩了他，让他没看清胸前的状况。\\n但被暗算是肯定的，飘在眼前的召唤具也被一把夺去。\\n老板转头一看，一条暗黑龙在他背后狡猾地笑着。\\n老板因为黯焰的燃烧，身体被黑烟包围着，而这条暗黑龙，也用同样的黑烟掩饰自己身上不同于一般究极级怪兽的、诡异的紫色流动。\\n老板一手推开林宇翔，握紧了长剑。\\n并没有人类传送到这里，召唤异界英雄这事他已经不抱期望了，但至少，要把召唤具交给古拉姆他们，尽管不知道它还有什么作用。",
    "messageInitNick_7942": "缺一颗兔牙",
    "messageInitNick_7941": "百香果的春天",
    "messageInitNick_7944": "道友停步",
    "messageInitNick_7943": "唇唇欲动",
    "resoundEventConfigDes_7021": "全身穿着铠甲，但赤脚战斗的样子好像有点……难看。\\n“现在可不是你臭美的时候！古拉姆同学！”林宇翔厉声教训到。\\n“哇——”\\n就在古拉姆想反驳的时候，老板喷出一口鲜血。\\n“好！试试就试试！”\\n古拉姆趁暗黑龙不注意，踢掉脚上的战靴。\\n“加油！我的世界有‘穿鞋的不如赤脚跑得快’这一说。”\\n古拉姆认为林宇翔在瞎说，稍微理睬一下他，这家伙就来劲了。\\n老板看到古拉姆的样子，明白了他想干什么，马上朝古拉姆点点头。\\n古拉姆跑到暗黑龙的正前方，故意放慢了速度挥舞着断剑。\\n果然，暗黑龙很快瞄准了这个送上门来的敌人。\\n“呵呵呵，送到嘴边的鲜肉，不烤焦的话太说不过去了！”暗黑龙喷着鼻息，微微侧头看着古拉姆。他的喉咙涌动着要化作熊熊黯焰的能量。\\n“那就来吧，看是我的剑快还是你的小火苗快！”古拉姆故意挑衅道。\\n暗黑龙的瞄准很快完成了，他对着古拉姆张开大嘴，准备把敌人送进地狱之火。\\n“吼——！！”\\n一股强劲的黯焰冲向前方，暗黑龙喜滋滋地等待着烧焦的肉味，和古拉姆痛苦挣扎的身影。可惜，他的愿望落空了。\\n因为古拉姆在他喷火前的那个瞬间，压低了身子，以子弹般的势头悄无声息地窜到他的背后。\\n“成功了！”林宇翔和古拉姆同时大喊！\\n“去死吧！！”两者再次同时大喊！\\n其实，暗黑龙的反应也很快，他喷出黯焰后，很快就意识到古拉姆在他眼底逃走了，当他正准备转身再次攻击的时候，身体却紧紧地被一个钢铁般的怀抱箍着。\\n古拉姆一边带着怒气咆哮，一边扔出断剑。“剑尖”已不复存在，但剑刃还锋利依旧。狂怒的剑气从暗黑龙背后席卷而来，它仿佛在吼——胜利与败北都不要紧！但用下流的手段暗算一位值得所有正义之士尊敬的前辈，是暗黑龙无法赎清的深重罪孽！！\\n古拉姆的断剑从暗黑龙的后面深深地砍了进去，剑身全部没进他的背部。\\n暗黑龙的翅膀停止了扇动，他摔到地上，和他一起摔下来的，是温泉老板。\\n温泉老板用尽最后的力气，一跃而起抱住了他，让古拉姆的攻击顺利凑效。\\n原来是回光返照啊……怪不得自己进入石塔后就神勇异常，没错，战士，要死在战场上，自己总算迎来了配得上这个身份的结局……现在……有脸去见那位挚友了……\\n老板欣慰地想着。\\n黯焰早已像浊流般包裹着他的全身。\\n虽然黯焰很快随着暗黑龙的死消失了。\\n可惜，那把小刀还插在他的胸口。\\n老板仰躺着，映入眼帘的是古拉姆热泪盈眶的双眼。\\n“前辈！前辈！坚持住！我马上救你！日夕！日夕！！快来帮忙！！！”古拉姆握住老板伸向他的手，慌乱地大喊。\\n“小伙子，你的搭档……也是个不错的小伙子……”\\n这是老板对古拉姆说的最后一句话。",
    "resoundEventConfigDes_7020": "“干得好！把神器抛过来！”远处的龙族族长兴奋地咆哮着。\\n不过，暗黑龙并没有理睬自己的族长。\\n“你一直躲在石塔里？”\\n“嘿嘿，就在你们的头顶。”\\n“你还不时喷出黯焰，用黑烟遮挡自己的身体？想不到，龙族有如此聪明的怪兽。”\\n老板终于明白了石塔守卫为何时不时望着塔顶的原因了，原来那里躲着第三个敌人，不，他自己才是第三个敌人，暗黑龙应该是第二个进入石塔的怪兽。\\n“啧，你以为每条龙都像我们的族长那么愚蠢吗？”暗黑龙在巴萨克面前毫无顾忌地笑道。\\n“放肆！别以为你立了大功就可以胡说八道！！”巴萨克大吼。\\n“除了王，我对谁胡说八道都可以！特别是老以为自己了不起的蠢龙！”\\n没错，这条暗黑龙是罗密欧设置的第二道保险，如果灵族族长的设想失败——多半会失败，那么就让这条潜伏在龙族中的暗黑龙在龙族族长得到神器后，把神器强抢过来。\\n吃下大量变异孢子的暗黑龙，其力量已经在龙族族长之上。\\n暗黑龙尾随着巴萨克，在巴萨克和石塔守卫激斗的时候偷偷飞进石塔，一直躲在塔顶。\\n他没料到后面还有闯入者，更没有十足把握能击败对方。幸好，温泉老板要走的时候引力再次失控，他抓准机会，一蹬塔壁往下冲，成功刺伤了老板。\\n在暗黑龙嘲笑完巴萨克的瞬间，塔内的引力再次恢复正常，除了暗黑龙，所有怪兽都掉到地上。巴萨克想冲上去把暗黑龙胖揍一顿，但暗黑龙动作更快地扇动翅膀，朝他来了一口浓烈的黯焰。\\n这招不亚于不朽级的攻击让巴萨克困于熊熊的业火之中。暗黑龙没有乘胜追击，只是飞高来躲开老板的一剑。\\n“死老头，乖乖死掉会舒服点哦。”暗黑龙的黯焰对等级高的怪兽来说，并不是即死的攻击，所以他才用了邪王赐予的匕首——一把用最精纯的戮魔钢锻造的、能轻松刺进钢铁龙王身体的刀子。\\n那把匕首还插在老板的背部、贯穿了他的胸口，让他每次出剑都更加痛苦。\\n在意识的虚空中，林宇翔拼命地摇晃着古拉姆。\\n“醒醒！快醒醒！古拉姆同学！！老爷子快要死了！！你再不醒，我就要给你做人工呼吸了！我已经快半个月没刷过牙啦！！”\\n意识对意识做人工呼吸有用吗？不管了！死马当活马医吧！\\n就在林宇翔要牺牲掉他的初吻时，古拉姆醒了。\\n他看到手中的断剑、看到全身被黯焰笼罩还在死战的老板，再听着林宇翔急促的、罗里吧嗦（甚至对战斗过程添油加醋）的讲述，大概明白了自己晕倒的时候发生了什么事。\\n“是我的错，受了这么点碰撞就晕倒了。”古拉姆的语气依旧冷淡，之后就没有对林宇翔再说什么了。\\n“前辈！”古拉姆跳上前支援。\\n“快跳到那条龙的鼻尖前，那里是它的视角盲区！”林宇翔提醒古拉姆。\\n咦，这家伙什么时候发现了这种事？自己并没有告诉过他。如果是他自己发现的，那观察力还不错……不可能，一定是前辈告诉他的。古拉姆想。\\n而且，就算知道有什么用，这只是相当基础的常识罢了。\\n“但是，喷火的对象就在它的正前方，它既然看不到，又是怎么瞄准的呢？”林宇翔问。\\n其实很简单，稍微侧头看准对手的位置后，就知道瞄准的角度。用人类的算术来计算，可能是一道复杂的几何题，但这是龙族与生俱来就懂得的方法，和猫咪便完会用沙子掩盖排泄物一样，是刻在基因中的知识。\\n战斗中的古拉姆没空搭理林宇翔，不过林宇翔很快就自己想通了上面的道理。\\n“如果在它瞄准我们之后、对我们喷火之前，极快地绕到它背后，不就能成功偷袭吗？”林宇翔提议。\\n“太想当然了，龙族的耳朵很灵敏，他会听到我们的脚步声。”古拉姆忍不住回了句。\\n“所以，你脱掉鞋子不就行了？”\\n“……”",
    "messageInitNick_7940": "心灵老鸭汤",
    "messageInitNick_7949": "俺丑的有魅力",
    "messageInitNick_7946": "福如东海",
    "messageInitNick_7945": "绝地苍狼",
    "messageInitNick_7948": "蜂鸟飞翔",
    "messageInitNick_7947": "阿喵午休时间",
    "messageInitNick_7931": "爱的代驾",
    "messageInitNick_7930": "甜甜圈儿",
    "messageInitNick_7933": "裤裆里的杀气",
    "messageInitNick_7932": "柚子先锋",
    "messageInitNick_7939": "深睡美人",
    "messageInitNick_7938": "那是蛙式游泳",
    "messageInitNick_7935": "点赞之神",
    "messageInitNick_7934": "凌晨两点",
    "messageInitNick_7937": "游泳去月球",
    "messageInitNick_7936": "饭堂掌舵者",
    "systemTaskConfigContent_5": "亲爱的{userName}：\\n \\n您的部落「{tribeName}」本赛季在部落之王排行中斩获第{ranking}名，获得了相应的奖励！\\n \\n“部落之王无需加冕，实力就是最好的皇冠。”",
    "systemTaskConfigContent_4": "尊敬的{userName}：\\n \\n很遗憾您没有竞拍成功。\\n \\n“尊贵的客户，请您留步，我们还有一件异常珍贵的藏品，专供您这样的尊贵客户品鉴。请看这条以高攻击力著称的传说中的龙，可以粉碎任何对手，它的效果……眼青皮白！价格只需八千万，而且一拍必中！”",
    "systemTaskConfigContent_7": "可爱的{userName}：\\n \\n{nick}对你进行了狩猎，你败下阵来，失去了{score}狩猎积分。\\n \\n“就像漆黑中的萤火虫，总遭人嫉妒。”",
    "systemTaskConfigContent_6": "可爱的{userName}：\\n \\n{nick}对你进行了狩猎，被你无情反杀，打得满地找牙，仓皇而逃。\\n \\n“很久没见过把问号演绎的这么完美的演员了！Good Job！”",
    "systemTaskConfigContent_9": "尊敬的勇士{userName}：\\n \\n{bossName}已被击破，您本次在世界灾厄排行中斩获第{ranking}名（{clientDisplay}），获得了相应的奖励！\\n \\n“为什么受伤的总是我，刚刚真的好危险，还好你救了我，祝福你！你问我是谁？我是发件那个呀。”",
    "systemTaskConfigContent_8": "亲爱的{userName}：\\n \\n您在狩猎排行中斩获第{ranking}名（{clientDisplay}），获得了相应的奖励！\\n \\n“从走进狩猎商店那一刻起到完成结账之前，都要保管好你的奖励噢。这里可没有安全区一说。”",
    "systemTaskConfigContent_1": "亲爱的{userName}：\\n \\n「{tribeSeason}」正式开启！\\n \\n“一股神秘的湍流向部落卷席而来，与之相关的一切似乎都回到了最初，除了……您的部落币，一个不少。因为您早已将它们藏得好好的。”",
    "systemTaskConfigContent_3": "尊贵的{userName}：\\n \\n恭喜您竞拍成功，请收下你的宝贝吧！\\n \\n“尊贵的客户，请您留步，稍后还有一场秘密拍卖会，只对极少数客户开放，其中的重头戏正是那条以高攻击力著称的传说中的龙，可以粉碎任何对手，它的效果……眼青皮白！底价八千万，我相信这对您而言完全不算什么！”",
    "systemTaskConfigContent_2": "亲爱的{userName}：\\n \\n您本周在起源殿排行中斩获第{ranking}名（{clientDisplay}段位），获得了相应的奖励！\\n \\n“看！一条带膝盖的粗壮大腿正在徐徐升起！”",
    "9_16": "宝箱二次奖励概率",
    "messageInitNick_7920": "淡淡稻花香",
    "9_15": "尖刺回复（分钟）",
    "9_14": "饲星商店可兑换物品",
    "messageInitNick_7922": "蛋炒蛋炒蛋",
    "9_13": "免费造唤（小时）",
    "messageInitNick_7921": "牛排的烦恼",
    "9_19": "升级",
    "9_18": "消耗材料",
    "9_17": "耗时",
    "messageInitNick_7928": "断了线的泪",
    "messageInitNick_7927": "杏子魔法师",
    "messageInitNick_7929": "乱转风扇",
    "9_12": "解锁战纹位置",
    "messageInitNick_7924": "塞巴多拉贡",
    "9_11": "每日免费挑战次数",
    "messageInitNick_7923": "天啸傲龙",
    "9_10": "解锁援军位置",
    "messageInitNick_7926": "花式送快递",
    "messageInitNick_7925": "姐天生拽",
    "9_27": "{1}体力",
    "mapNodeName_1464": "冰火猎团",
    "messageInitContent_3174": "海水浴",
    "9_26": "{1}攻击力",
    "mapNodeName_1463": "冰河空渊",
    "messageInitContent_3175": "大家知道龙虎豹是什么",
    "9_25": "所有种族",
    "mapNodeName_1462": "肉肉山",
    "messageInitContent_3176": "不知道",
    "messageInitNick_7911": "姜片有点皮",
    "9_24": "该资源已到达上限，无法继续获取",
    "mapNodeName_1461": "肉肉猎团",
    "messageInitContent_3177": "镇魂龙虎抱抱",
    "messageInitNick_7910": "激萌摇滚妹",
    "mapNodeName_1460": "冰拿猎团",
    "messageInitContent_3178": "吃我一拳",
    "messageInitContent_3179": "变大！",
    "9_29": "{1}生物屏障",
    "9_28": "{1}真实伤害",
    "messageInitNick_7917": "白菜魔法",
    "messageInitNick_7916": "清新的橘子",
    "messageInitNick_7919": "美食体验",
    "mapNodeName_1469": "冰河空渊",
    "messageInitNick_7918": "保镖跑了",
    "9_23": "{1}产出+{2}%",
    "mapNodeName_1468": "冰希猎团",
    "messageInitContent_3170": "真是出海呢。",
    "messageInitNick_7913": "火星人才辈出",
    "9_22": "需要领地等级{1}",
    "mapNodeName_1467": "冰影猎团",
    "messageInitContent_3171": "双龙下海！",
    "messageInitNick_7912": "西瓜先锋",
    "9_21": "需要探索者等级{1}",
    "mapNodeName_1466": "冰河空渊",
    "messageInitContent_3172": "接下来刷的是水龙魂",
    "messageInitNick_7915": "高情商水果",
    "9_20": "建造中",
    "mapNodeName_1465": "冰狮战部",
    "messageInitContent_3173": "这水温刚刚好",
    "messageInitNick_7914": "单身控",
    "randomEventDialogueGroupConfig_2.7": "-",
    "randomEventDialogueGroupConfig_2.8": "-",
    "randomEventDialogueGroupConfig_2.5": "看向天空",
    "randomEventDialogueGroupConfig_2.6": "-",
    "randomEventDialogueGroupConfig_2.3": "盯着它看",
    "messageInitNick_7909": "忧郁机器",
    "randomEventDialogueGroupConfig_2.4": "喊它一下",
    "randomEventDialogueGroupConfig_2.1": "有个神秘商人在前面看着天空自言自语。",
    "randomEventDialogueGroupConfig_2.2": "锤它",
    "9_38": "基因强化",
    "mapNodeName_1453": "冰原猎团",
    "messageInitContent_3185": "我错了",
    "9_37": "怪兽等级",
    "mapNodeName_1452": "冰河空渊",
    "messageInitContent_3186": "喵？",
    "9_36": "总评级",
    "mapNodeName_1451": "冰河空渊",
    "messageInitContent_3187": "我将结束战斗",
    "messageInitNick_7900": "此人略萌",
    "9_35": "总评级越高，提升的属性增益越多",
    "mapNodeName_1450": "冰河空渊",
    "messageInitContent_3188": "不要在说了",
    "messageInitContent_3189": "大棒警告",
    "9_39": "技能",
    "messageInitNick_7906": "暴走的海盐",
    "messageInitNick_7905": "纯情老司机",
    "mapNodeName_1459": "冰河空渊",
    "messageInitNick_7908": "凹凸曼",
    "mapNodeName_1458": "冰河空渊",
    "messageInitContent_3180": "红红火火",
    "messageInitNick_7907": "这卡假的吧",
    "9_34": "最多输入{1}个字",
    "mapNodeName_1457": "冰河空渊",
    "messageInitContent_3181": "抓住你了溜溜",
    "messageInitNick_7902": "蘑菇魔法师",
    "9_33": "限制字符数 {1}/{2}",
    "mapNodeName_1456": "冰气猎团",
    "messageInitContent_3182": "滴滴滴滴滴滴",
    "messageInitNick_7901": "木瓜追踪者",
    "9_32": "该怪兽在起源基石中提供增益效果，该操作会使增益效果消失，是否继续？",
    "mapNodeName_1455": "冰马猎团",
    "messageInitContent_3183": "你怎么回事啊？小老弟",
    "messageInitNick_7904": "专捡情绪垃圾",
    "randomEventDialogueGroupConfig_2.9": "-",
    "9_31": "建筑等级{1}\\n开启",
    "mapNodeName_1454": "冰河空渊",
    "messageInitContent_3184": "脑子在咆哮",
    "messageInitNick_7903": "在线等心上狗",
    "propConfigDes_40400": "或在入神演奏之际，或在逢魔时分，亦或在天象异变之时，咚魁所捶响的声音从对万物律动的精准复刻中跳脱而出，明明夹带缺拍与错拍，却牢牢攫住了听者的心，甚至连不可思议的存在，也为这种“序中失序”的美妙变化而驻足。\\n「用于咚魁相移形态解锁」",
    "propConfigDes_40401": "一些法师需要同时使用多本法术书才能释放昨日准备好的大量法术（划掉）天才的学习与研究总是多线程进行的~悬浮在她旁边的书籍分别是：《种族起源》、《彼岸族初探（漫画）》、《原生怪兽的多样性》、《法术大全》、《四大种族》、《构具导论》，前四本为参考用，后两本则是绝赞创作中，一切尽在不言中。\\n「用于初号铸体魔铸形态解锁」",
    "propConfigDes_40402": "大玩特玩一段时间后，B.B.Token有点不再满足于已有的玩物游戏，它想搞一个前所未有的游戏。万事开头难，这个形态正是计划的第一步。\\n灵感源自于异界的宝箱怪，它将自己伪装成玩物游戏的奖励箱，在其他怪兽获得游戏胜利时，蹦出吓对方一跳。但那不是重点，重点是，它将授予开箱的怪兽玩物创作大赛的参赛资格，如果能创作出让B.B.Token满意的玩物，将获得一次特殊的改写规则权限。那之后更多奇怪的玩物被创造出来……只可惜不好玩的占了大多数。\\n「用于B.B.Token宝箱形态解锁」",
    "10_2019": "保存数已到达上限",
    "10_2013": "积分",
    "10_2014": "战力",
    "10_2020": "防守成功",
    "9_49": "长按怪兽头像可进入对应的培养界面",
    "mapNodeName_1442": "秘仪圣域",
    "messageInitContent_3196": "锤哥再次将前面的怪兽挡得死死的",
    "10_2021": "录像",
    "9_48": "已满",
    "mapNodeName_1441": "秘仪圣域",
    "messageInitContent_3197": "小赤虹找哥哥",
    "10_2022": "未入榜",
    "9_47": "开战！",
    "mapNodeName_1440": "秘仪圣域",
    "messageInitContent_3198": "沼地钢龙王",
    "9_46": "备战！",
    "messageInitContent_3199": "想喝奶茶",
    "9_41": "建筑建造中，请稍等片刻",
    "9_40": "极化",
    "mapNodeName_1449": "冰河猎团",
    "mapNodeName_1448": "冰河传送门I",
    "messageInitContent_3190": "啊这啥回事",
    "mapNodeName_1447": "进化秘仪",
    "messageInitContent_3191": "有点眼熟",
    "9_45": "刷新",
    "mapNodeName_1446": "秘仪圣域",
    "messageInitContent_3192": "你没看错",
    "9_44": "成功更换领地，斗技场积分变为{1}",
    "mapNodeName_1445": "寒冰秘仪",
    "messageInitContent_3193": "场地不同了",
    "9_43": "排阵",
    "mapNodeName_1444": "秘仪圣域",
    "messageInitContent_3194": "我是一块烤肉",
    "9_42": "建筑未建造完成",
    "mapNodeName_1443": "镇魂秘仪",
    "messageInitContent_3195": "真香",
    "mapNodeName_1429": "秘仪传送II",
    "mapNodeName_1431": "看肉者",
    "9_59": "是否消耗{1}{2}进行超频？",
    "mapNodeName_1430": "永动秘仪",
    "9_58": "选择",
    "9_57": "（已装嵌更高级效果）",
    "9_52": "合成材料中有较为稀有的起源盘，是否继续合成？",
    "mapNodeName_1439": "荆棘秘仪",
    "9_51": "选中分解的起源盘较为稀有，是否继续分解？",
    "mapNodeName_1438": "秘仪圣域",
    "9_50": "属性增益汇总",
    "mapNodeName_1437": "秘仪圣域",
    "mapNodeName_1436": "秘仪圣域",
    "9_56": "（已被高级覆盖）",
    "mapNodeName_1435": "梦幻秘仪",
    "9_55": "装嵌起源盘效果汇总",
    "mapNodeName_1434": "秘仪圣域",
    "9_54": "效果",
    "mapNodeName_1433": "秘仪圣域",
    "9_53": "剩余：{1}",
    "mapNodeName_1432": "肉肉山",
    "messageInitNick_10916": "要保护好自己",
    "messageInitNick_10917": "憨憨的笑容",
    "messageInitNick_10914": "不暴富不改名",
    "messageInitNick_10915": "一百种假设",
    "messageInitNick_10918": "吃瓜公主",
    "messageInitNick_10919": "安详的湖泊",
    "messageInitNick_10912": "专业套娃",
    "messageInitNick_10913": "素鸡",
    "messageInitNick_10910": "不服咬我呀",
    "messageInitNick_10911": "读心者",
    "9_63": "效果持续{1}小时，重复使用可叠加持续时间，持续时间大于{2}小时后无法继续叠加，失效后自动卸下起源盘",
    "9_62": "负重{1}",
    "9_61": "是否消耗1{1}提升起源核心{2}",
    "9_60": "超进化",
    "messageInitNick_10927": "垫底睡魔",
    "messageInitNick_10928": "哈密瓜魔法",
    "messageInitNick_10925": "素炒饭",
    "messageInitNick_10926": "林中有鹿",
    "messageInitNick_10929": "不存在的拉肠",
    "messageInitNick_10920": "打脸大师",
    "messageInitNick_10923": "黑白交错",
    "messageInitNick_10924": "跳伞的小雨滴",
    "messageInitNick_10921": "食盐有点皮",
    "messageInitNick_10922": "混是一种生活",
    "mapNodeName_1497": "冰河传送门II",
    "mapNodeName_1496": "冰河空渊",
    "mapNodeName_1495": "冰锤战团",
    "mapNodeName_1494": "冰河空渊",
    "mapNodeName_1493": "冰帝战团",
    "mapNodeName_1492": "冰河空渊",
    "mapNodeName_1491": "冰河空渊",
    "mapNodeName_1490": "冰河空渊",
    "mapNodeName_1499": "玩偶之家",
    "mapNodeName_1498": "玩物之门",
    "mapNodeName_1486": "冰龙战部",
    "mapNodeName_1485": "冰河空渊",
    "mapNodeName_1484": "冰象猎团",
    "mapNodeName_1483": "冰河空渊",
    "mapNodeName_1482": "冰河空渊",
    "mapNodeName_1481": "冰河空渊",
    "mapNodeName_1480": "冰河空渊",
    "mapNodeName_1489": "冰河空渊",
    "mapNodeName_1488": "冰河空渊",
    "mapNodeName_1487": "冰河空渊",
    "messageInitNick_10905": "狂奔的蜗牛",
    "messageInitNick_10906": "提刀斩六欲",
    "messageInitNick_10903": "凉心姑娘",
    "messageInitNick_10904": "洋葱真好吃",
    "messageInitNick_10909": "把夜染黑",
    "messageInitNick_10907": "流浪的桡骨",
    "messageInitNick_10908": "持续发育",
    "messageInitNick_10901": "打脸鉴定家",
    "messageInitNick_10902": "深度策略大炮",
    "messageInitNick_10900": "爆裂魔龙",
    "mapNodeName_1475": "冰河空渊",
    "mapNodeName_1474": "冰河空渊",
    "mapNodeName_1473": "冰叉空渊",
    "mapNodeName_1472": "冰龙猎团",
    "mapNodeName_1471": "冰河空渊",
    "mapNodeName_1470": "冰虎猎团",
    "mapNodeName_1479": "古记战役-兽海战术",
    "mapNodeName_1478": "雪崩猎团",
    "mapNodeName_1477": "冰河空渊",
    "mapNodeName_1476": "冰河空渊",
    "messageInitNick_10958": "八点的泡面",
    "messageInitNick_10959": "最帅的曼",
    "5_2142": "起源核心",
    "5_2141": "查看起源基石",
    "5_2140": "起源基石",
    "messageInitContent_5746": "这礼物是我的吗",
    "messageInitNick_10952": "鱼香肉丝",
    "messageInitContent_5745": "带上我",
    "messageInitNick_10953": "等雨停的猫",
    "messageInitContent_5748": "送礼只送大盒子",
    "messageInitNick_10950": "诺贝尔套娃奖",
    "5_2143": "战中相关项经起源殿战斗平衡，或与实际不同",
    "messageInitContent_5747": "是我送星的",
    "messageInitNick_10951": "要成为王的人",
    "themeCardPackDes_16010": "那一天，它第一次跟着其他幼体怪兽跑聚落之外玩耍冒险，在领头怪兽的怂恿下本该在入夜前返回的它们来到了一处荒原，结果遇上了一头喉咙痒痒的黯炎古龙。\\n那些被龙焰灼伤的幼体怪兽哭着闹着大步跑回聚落，谁都没有注意到，从浅坑里爬起的它正趴在火堆旁，久久地盯着微微跃动的火焰，直至眼睛生痛。\\n它小心翼翼将树枝捡起，借着火焰的光返回聚落。\\n一路上，它用身体，用手护着火焰，生怕火焰熄灭，直至回到巢穴它才发现双掌已经被烫出了不少水泡。",
    "messageInitNick_10956": "蒜苔撞地球",
    "messageInitContent_5749": "不许乱开盒",
    "messageInitNick_10957": "年轻的广告呦",
    "messageInitNick_10954": "圣人模式",
    "messageInitNick_10955": "蛋挞制作者",
    "themeCardPackDes_16015": "从初遇火焰那日起，也是从火焰驱散了它对黑暗的恐惧那日起，它对火焰的执迷就变得一发不可收拾。\\n起先，为了让带回去的火种维持燃烧就费了不少功夫，它发现若是完全把火焰罩住，火焰就会熄灭；没有可以燃烧的东西时火焰也会熄灭；风太大火焰也会熄灭，可正当它觉得火焰非常脆弱，需要它来保护时，那场烧光了巢穴的大火又给了它一巴掌。\\n渐渐地，它找到了一些门道，它保留部分维持火焰的条件不变，再只改变其中的一部分，来研究维持火焰的必要条件。\\n在搞懂了要如何维持火焰后，它开始往火焰加入各种东西，它认为它是在照顾和喂养火焰。有时候火焰会向它展露其与众不同的一面，例如发出特别的光芒，或是张牙舞爪将它灼伤。可它坚信火焰只是和它玩耍，绝没有伤害它的意思。\\n此外，它还试着与火焰交流，它通过记录火焰的形状，理解火焰想要传达给它的话语。随着观察时间的增多，它逐渐在那之中看到了火焰给它的回应。\\n过往与它交好的幼体怪兽都觉得它就像是个疯子，其他聚落成员也因它那被火焰灼烧得面目全非的容貌而厌恶它。有一次，它烧掉了聚落里半数的巢穴，随后被赶出了聚落。\\n离开前，聚落里的制杖长老给了它一个忠告，火焰只属于那些能掌控火焰的怪兽，而它显然不是，若继续这么下去，它终有一日会被火焰吞没。",
    "messageInitContent_5751": "燃起来了",
    "messageInitContent_5750": "前方高能！",
    "messageInitContent_5753": "快把冰和赤叫过来！",
    "messageInitContent_5752": "再也不怕变大变小",
    "messageInitContent_5755": "新世界的大门！",
    "messageInitContent_5754": "在路上",
    "messageInitNick_10969": "实名买房",
    "messageInitContent_5757": "咱们唱歌别打架好嘛",
    "messageInitNick_10963": "我是菜",
    "messageInitContent_5756": "锤子出息了",
    "messageInitNick_10964": "黄花大小伙",
    "messageInitContent_5759": "打住",
    "messageInitNick_10961": "购物车",
    "themeCardPackDes_16020": "制杖长老的忠告启发了它，为了更进一步接近它心爱的火焰，它要趁这个机会到大陆各处，见识更多的火焰，虽然这完全不是制杖长老的初衷。\\n它收拾好之后，便和它的火炎一同踏上了解其他火焰的旅程。\\n它先后研究了圣光古龙那拥有治愈之力的火焰，灾·焚风那与死亡交缠的火焰，黯灭那如同诅咒般的黯焰，逆焰龙帝那能灼烧伤口的火焰，火神那焚尽大地黑暗的末劫之火，还有赤虹那将子弹蒸发的怒火。\\n它突然发现，这些怪兽将并非简单了掌控火焰，而是将火焰驯化成了它们所希望的样子。它有点难过，为这些怪兽的火焰而难过。因为，它觉得这些火焰都变质了，不再是它所爱的那些最为纯粹的火焰。",
    "messageInitContent_5758": "建议啊jo滚回三层",
    "messageInitNick_10962": "未知数",
    "messageInitNick_10967": "街头迷失少女",
    "messageInitNick_10968": "路人为谁空舞",
    "messageInitNick_10965": "别单吃姐兵线",
    "messageInitNick_10966": "不午休的墨鱼",
    "themeCardPackDes_16025": "在结束了追逐火焰的旅途后，它在一个位于古老森林的隐秘洞穴中定居下来，再次专注于研究那些没有变质的火焰。\\n那是一个云层被夕阳映得通红的日子，终日冒着浓烟的洞穴内传出了它的吼声，它迄今为止进行过的最危险的试验要开始了。它的左臂和大半个后背都早早化作焦炭，它却视之为火焰给它的爱之烙印，因为火焰还未曾夺走它的生命，因为火焰总会在它跟前停下。\\n因此它决定要在这次更进一步地接近火焰，它迫切想与火相融，在见证火焰对它绝对的爱的同时，祈求拥有解脱之力的火焰为它带来它的真实。\\n那天，一切都准备就绪，火焰沿着三角与四面体在林中飞驰，整片森林瞬间化作火海。",
    "messageInitContent_5760": "拼了！",
    "messageInitContent_5762": "各位我先上了",
    "messageInitContent_3100": "龙骑士在此",
    "messageInitContent_5761": "好！",
    "messageInitContent_3101": "海的那边是什么？",
    "messageInitContent_5764": "我替大家负荆请罪，大家请回吧",
    "messageInitContent_3102": "海王在此",
    "messageInitContent_5763": "你上什么",
    "messageInitNick_10960": "麻辣之王",
    "messageInitContent_3103": "突然饿了",
    "messageInitContent_5766": "无奈的马儿",
    "messageInitContent_3104": "小白龙？",
    "messageInitContent_5765": "终于大对了",
    "themeCardPackDes_28005": "穿过陡峭而狭窄的楼梯，抵达逼仄却令人安心的空间。\\n可能是即将告别现实、投入幻想怀抱的雀跃，她一下没踏稳，摔了出去。\\n撞上了谁，随后是掉落的桌游、游戏机、卡牌、模型……\\n还有迅猛砸落的柜子，在“砰”的一声闷响后，抵在了另一侧的墙面上。\\n脱手而出的手机在空中优雅翻转和误触到的、带有艾娜璃兹头像的APP一起，见证了这一切。\\n世界翻转——\\n此时，B.B.Token刚来到玩物之地。\\n在把一头行尸意外轰飞后，它还得到了一棵摇头晃脑、会微笑的花儿的致谢。\\n而即将开始的故事，是在这之后的之后。\\n[>>]在此刻被按下。\\n时间带着些许噪点飞逝。\\n【圣堂武士集体失踪事件】发生了……\\n圣堂武士头目为追查此事，集结了多位玩物之地的最强玩家，它们将组队向玩物之地的特殊权域Token——B.B.Token发起挑战。\\n因为领主确信，圣堂武士的失踪，幕后黑手正是那个凌驾于规则之上的存在！",
    "messageInitNick_10938": "流浪的摄影师",
    "themeCardPackDes_28015": "挑战B.B.Token的战团，很快完成了组建，分别是核心战团和支援战团。\\n由于B.B.Token修改过排队规则，总能排到第一位，因此，试图利用“兽海战术”限制它的行动，几乎不可能。\\n于是，武士头目想出了一个更为迂回的方案。借助强大的圣堂武士情报网络，它将B.B.Token可能出现的玩物游戏范围，压缩至八个。\\n随后，让支援战团的怪兽抢先开始其中七个游戏，并尽可能延长这些游戏的持续时间。而最后一个玩物游戏，则被刻意空出，以此，创造出核心战团对其发起挑战的条件。\\n以下是支援战团和核心战团的配置。\\n支援战团：\\n大嘴鱼王，玩物游戏【贪吃鱼】的最高数据记录保持者。\\n咚魁，玩物游戏【打鼓达怪】的最高得分记录保持者。\\n幽狱沸体，玩物游戏【怪兽争霸】最多线程操控记录保持者。\\n艾娜璃兹，玩物游戏【记忆大师】最高记录保持者。\\n神秘商人，玩物游戏【模拟小摊】最高营业额记录保持者。\\n我的怕怕，玩物游戏【我的方块】最高生存时长记录保持者。\\n危险的草丛，玩物游戏【怪兽联盟】最强割草记录保持者。\\n核心战团：\\n炼狱魔眼，超进化大陆游戏经验最为丰富的怪兽，眼球上的血丝是它的勋章。\\n金翅璞佳鸟，善于盯上对手弱点的力量，让它拥有别树一帜的强大，通俗点说，就是个老阴*。\\n瞳，被异常规则包围的存在，她对规则的理解自然是独一档的，可协助战团最大化利用规则。直白点说，就是钻规则漏洞的能力近乎本能。\\n赤虹，玩物之地冉冉升起的新星！不服输的狠劲与非凡想象力是她的最强武器！",
    "messageInitNick_10939": "孤单的遥控器",
    "messageInitNick_10936": "下个月退休",
    "messageInitNick_10937": "村口蹲一狼",
    "5_2120": "段位重置",
    "themeCardPackDes_28010": "玩物之地的玩物游戏，通常不支持同一时间、同一游戏的多重进程。\\n因此，想要参加玩物游戏的怪兽，都必须先做一件事——排队。\\n简单、快捷、又易上手的排队游戏，正是因此而生。不断获胜就能排得更前，更快玩到游戏。\\n而在玩物之地，怪兽数量占比第一的圣堂武士群，被赋予了一项特殊使命。\\n它们负责维护玩物游戏的秩序，同时保持中立，不介入任何区域势力之间的斗争。\\n每个玩物游戏除了引导游戏的玩物主外，几乎都配备着一支训练有素的圣堂武士队伍。\\n当整个圣堂武士大队的调度核心，圣堂武士头目，摆出条件时，它找到的协助者给出的必然是肯定的答复。\\n这些对方无法拒绝的条件包括：\\n可观的资源Token、B.B.Token的游玩路线情报、协助者不可被提及的秘密的不外泄保证、行动失败后无需付出任何代价的保证、成功战胜B.B.Token后，规则修改特权所延伸的资源……",
    "5_2124": "点击留言",
    "messageInitContent_3105": "神龙教在此",
    "messageInitContent_5768": "看了2秒",
    "messageInitNick_10930": "养肥再看",
    "5_2123": "倒计时结束自动选择",
    "messageInitContent_3106": "隔壁这云是我的，大家别抢",
    "messageInitContent_5767": "懂了这里生产大舌怪",
    "messageInitNick_10931": "辣妹子啦啦啦",
    "themeCardPackDes_16030": "热流冲击着不断上涌的浓烟，木头裂开的噼啪声中夹杂着巨木倒塌的轰隆声，它狂笑着漫步在火海之中，火焰一点点吞没了它的身体。\\n可不久后它的身体开始扭曲，发出类似被火灼伤时的哭喊声，求救声。它的声音消失后，那头将整片火海吸收殆尽的怪兽出现了，它身上焦黑的位置与它如出一辙，可它却不是它，它是妄焱。",
    "5_2122": "请选择一个暴走增益",
    "messageInitContent_3107": "其实我一直想问，这大炮就安在耳朵隔壁真的没问题吗",
    "5_2121": "点击选择",
    "messageInitContent_3108": "我也想问，其实这喷气口向上真的没问题吗",
    "messageInitContent_5769": "想吃雪糕",
    "5_2128": "探索者等级到达{1}解锁神灵契约",
    "messageInitContent_3109": "我也……",
    "messageInitNick_10934": "想想就留口水",
    "5_2127": "点击空白位置关闭",
    "messageInitNick_10935": "爱你一万年",
    "5_2126": "点击空白位置继续",
    "messageInitNick_10932": "暴风勇士草飞",
    "themeCardPackDes_16035": "黑烟从化作焦炭的森林中缓缓散去……\\n一只头顶都被烧秃了的金翅璞佳鸟开始对着眼前的陌生怪兽口吐芬芳，它认为正是这只怪兽把灾难带到了这片森林。而在另一个焦黑的草丛后，一群王霸的眼中却满是感激和憧憬，它们亲眼看见这头突然出现的怪兽，吸收了整个森林的火海，它就是大家的救星！它们挥舞双拳欢呼！\\n一旁路过的智者看到这只从未见过的怪兽也不敢贸然靠近，它原本只是听说这片森林中有只怪兽对火焰的研究非常深入，才特地前来拜访，没想到却看到了如此一幕。\\n那头拥有异色犄角的怪兽，带着似乎永远无法燃尽的火焰消失在了森林深处。",
    "5_2125": "录像ID:{1}",
    "messageInitNick_10933": "火车不会出轨",
    "messageInitContent_5771": "大大滴幻幻小小滴鸟儿",
    "messageInitContent_5770": "收租啦",
    "messageInitContent_3110": "其实我想问，你们怎么这么多问题",
    "messageInitContent_5773": "感觉演唱会场数不够多啊",
    "5_2129": "探索者等级到达{1}解锁神灵{2}",
    "messageInitContent_3111": "没毛病",
    "messageInitContent_5772": "唱的什么",
    "messageInitContent_3112": "哦吼剧王",
    "messageInitContent_5775": "最后再大点",
    "messageInitContent_3113": "怎么都拿着根大家伙，怕怕",
    "messageInitContent_5774": "建议影换个皮肤",
    "messageInitContent_3114": "没关系，我会赢",
    "messageInitContent_5777": "牵起璃璃的小手",
    "messageInitContent_3115": "怂怂",
    "messageInitContent_5776": "求比蒙的心理面积",
    "messageInitNick_10949": "颞骨",
    "themeCardPackDes_28025": "计划非常顺利。\\n游戏开始前，B.B.Token爽快地答应了它们提出的条件：在游戏胜利后，核心战团将获得失踪圣堂武士的相关情报，以及一次珍贵而特殊的规则改写权限。所谓的特殊主要是为了规避诸如“我的愿望是拥有无数个愿望”此类显而易见的规则漏洞，具体限制不再赘述。\\n炼狱魔眼、金翅璞佳鸟、瞳、赤虹作为从兽，连同躺在沉浸花蕾中的意识本体，一起进入了通过思想树藤与主兽B.B.Token相连的世界。\\n这是一个剑与魔法的世界。\\n尽管核心战团的怪兽早已是这个游戏的熟练玩家，却仍被拥有异界知识的B.B.Token所构筑的世界所震撼。\\n比起常见的魔法能力，前所未见的建筑结构与道路形态，反而更让它们感到震惊。\\n炼狱魔眼将扮演一位知识广博的吟游诗人；金翅璞佳鸟则成为了一名盗贼；瞳是对法术有超凡理解的法师；而赤虹，则是反常地选择成为了一个火焰战士。\\n这回的游戏目标十分明确：\\n打倒侵害这个领地的一条恶龙。\\n开局一切顺利，炼狱魔眼凭借自身的高魅力和对某个特殊品类游戏的超高熟练度，从大量雌性NPC身上搜集到了关于恶龙的情报，迅速锁定了恶龙巢穴的位置。\\n瞳则利用法师的广博知识，再结合通过某个规则漏洞额外获得的跨职业法术，确认了恶龙对控制类法术和穿刺伤害拥有极高的抗性，但弱火。\\n金翅璞佳鸟充分发挥盗贼的职业优势，“借用”了一整批趁手的武器、防具、药水与卷轴。同时挖出了国王与大臣间不为人知的苦命秘密，换取了更多的战前物资。\\n赤虹则凭借她的想象力，成功将火焰改变为黑暗属性后附加在自己的大剑上，甚至绕过了宠物规则，让哥哥火神成为了她的随从单位，进一步提升攻击面的能力。\\n很快，它们就踢到恶龙巢穴的门口。\\n然而，出现在它们面前的，却是——",
    "messageInitNick_10947": "不是怪兽是神",
    "messageInitNick_10948": "爱若逢时",
    "5_2131": "未上阵",
    "5_2130": "当前神灵",
    "themeCardPackDes_28020": " “第一份酬金已经送到各位手上了。作战日将近，我会先进行统一说明，问题可稍后提出。”\\n“圣堂武士每大段工作周期内除了若干短假期，还会有一次超长假期，这些非工作时间是较为自由的，大多数会选择在假期放松或挑战玩物游戏。”\\n“失踪的圣堂武士有以下共同的特征。第一，消失的时间点，都是在超长假后就没有归队。第二，四个为一组地消失。第三，它们消失之前玩的玩物游戏是【怪与地底穴】。”\\n“而第一组圣堂武士失踪的时间和B.B.Token为这个玩物游戏加上了B.B.T规则的时间吻合。”\\n“我不认为这是个巧合。”\\n“虽然大家对这个游戏的规则都不陌生，但为了配合作战，我仍需要再说明一次。”\\n“【怪与地底穴】起初只是一个简单的多怪幻想游戏，大家围坐在一起开始冒险游戏。而B.B.Token直接使用了规则修改而不是附加规则的力量，将这个玩物游戏变成超强沉浸感的幻想扮演游戏，还新增了新的主兽身份，主兽负责创造冒险的幻想世界，其他4只怪兽则为从兽，前往主兽创造的世界冒险。”\\n“最初，我的怀疑对象是圣堂武士挑战时的主兽。但这次，那只主兽同样失踪了。”\\n“因此核心战团的任务是，作为从兽进入B.B.Token担任主兽的这场游戏，在过程中找出线索，至于能否赢得更多，就各凭本事了……”",
    "5_2135": "配置",
    "messageInitContent_3116": "冒牌剧王",
    "messageInitContent_5779": "不是很懂",
    "messageInitNick_10941": "独步天下",
    "themeCardPackDes_16040": "从那只沉迷于燃烧的怪兽的笔记中可以了解到，它认为火焰是一种解脱的力量，火焰能让被点燃的东西获得解脱，重新回归本来的面目。就像是树木的燃烧，火焰让碳烟重归大气，再次将太阳的光热释放。\\n可那头将森林中的火焰带走的怪兽又是什么？根据传闻，它身上的火焰仿佛不曾熄灭。它燃烧的到底是什么？难道是什么源源不绝的物质？\\n智者的这篇笔记在半年后才得以重新续写。\\n后来我恰巧到某个聚落探查，恰巧就是那只沉迷火焰的怪兽的聚落，通过与制杖长老的交谈，我了解到了它对火焰那份异乎寻常的狂热。大概，它就是那只成就妄焱存在的怪兽，它的身体已经完全燃烧殆尽，只可惜，火焰并不如它想象那般爱它，只有它那近乎癫狂的妄想，化作了近乎不灭的存在。",
    "5_2134": "复制此配置",
    "messageInitContent_3117": "突突突突突突",
    "messageInitContent_5778": "让我来",
    "messageInitNick_10942": "椰子君快逃",
    "5_2133": "战墙",
    "messageInitContent_3118": "奶妈云集哦",
    "5_2132": "回响等级",
    "messageInitContent_3119": "奶马？",
    "messageInitNick_10940": "给手机按摩",
    "5_2139": "未解锁",
    "messageInitNick_10945": "入场券",
    "5_2138": "漆黑之根",
    "messageInitNick_10946": "羡慕啊",
    "5_2137": "可配置古记战役的专属怪兽，神灵和元核",
    "messageInitNick_10943": "属鸡的救赎",
    "5_2136": "切磋",
    "messageInitNick_10944": "葡萄魔法师",
    "messageInitContent_5782": "我是小号",
    "messageInitContent_3120": "慕",
    "messageInitContent_5781": "谁是大号",
    "messageInitContent_3121": "700级的奶",
    "messageInitContent_5784": "都是我",
    "messageInitContent_3122": "37就21",
    "messageInitContent_5783": "上错号了",
    "messageInitContent_3123": "死马当活马医",
    "messageInitContent_5786": "可以不可以",
    "messageInitContent_3124": "怎么 不见没毒莎莎",
    "messageInitContent_5785": "行行行",
    "messageInitContent_3125": "美度傻傻",
    "messageInitContent_5788": "你的思想很危险",
    "messageInitContent_3126": "空蝉是本岛主的夫人",
    "messageInitContent_5787": "可不可以睡下嗨",
    "messageInitContent_5780": "我不行了",
    "96_Vision": "异象",
    "mapNodeName_1419": "噩梦秘仪",
    "mapNodeName_1418": "炙热秘仪",
    "5_2102": "起源殿积分",
    "messageInitContent_3127": "我命你同我",
    "messageInitNick_10996": "上午十点半",
    "5_2101": "斗技场积分",
    "messageInitContent_3128": "赐大家豹胎易筋丸",
    "messageInitContent_5789": "怎么开心怎么来",
    "messageInitNick_10997": "天很高",
    "5_2100": "重新挑战",
    "messageInitContent_3129": "请赐我护甲",
    "messageInitNick_10994": "查无此人",
    "messageInitNick_10995": "抚猫少女",
    "5_2106": "比拼方式",
    "5_2105": "敌方状态",
    "5_2104": "我方状态",
    "messageInitNick_10998": "老人在思考",
    "5_2103": "掉落拍卖品",
    "messageInitNick_10999": "车厘子去上班",
    "mapNodeName_1420": "秘仪圣域",
    "messageInitContent_3130": "拳头硬了",
    "messageInitContent_5793": "线下对线？",
    "5_2109": "分享",
    "messageInitContent_3131": "你的想法很危险啊",
    "messageInitContent_5792": "然后呢",
    "5_2108": "观看",
    "messageInitContent_3132": "我也喜欢……",
    "messageInitContent_5795": "我家就在荆棘旁",
    "10_2001": "斗技场",
    "5_2107": "本周剩余奖励次数：",
    "messageInitContent_3133": "谁不喜欢",
    "messageInitContent_5794": "强势围观",
    "messageInitContent_3134": "小伙汁我不喜欢",
    "messageInitContent_5797": "看我使用地龙拳",
    "messageInitNick_10992": "别抢我饭碗",
    "messageInitContent_3135": "哈哈哈哈哈哈哈",
    "messageInitContent_5796": "看我使用双拳",
    "messageInitNick_10993": "狂飙的驼鹿",
    "messageInitContent_3136": "哈~",
    "messageInitContent_5799": "看我使用空拳",
    "messageInitNick_10990": "笨蛋",
    "messageInitContent_3137": "笑不活了",
    "messageInitContent_5798": "看我使用炎拳",
    "messageInitNick_10991": "辣条萌主",
    "mapNodeName_1428": "观涡者",
    "mapNodeName_1427": "秘仪圣域",
    "mapNodeName_1426": "秘仪圣域",
    "mapNodeName_1425": "创世秘仪",
    "mapNodeName_1424": "舔舐秘仪",
    "mapNodeName_1423": "秘仪圣域",
    "mapNodeName_1422": "虚景秘仪",
    "messageInitContent_5791": "懂了kb就是主机",
    "mapNodeName_1421": "秘仪圣域",
    "messageInitContent_5790": "芜湖",
    "mapNodeName_1409": "太古秘仪",
    "mapNodeName_1408": "龙腾秘仪",
    "mapNodeName_1407": "冰火秘仪",
    "10_2006": "商店",
    "5_2113": "挑战失败",
    "messageInitContent_3138": "什么行为艺术现场",
    "10_2007": "开启号角",
    "5_2112": "挑战成功",
    "messageInitContent_3139": "有被笑到",
    "10_2008": "挑战",
    "5_2111": "VS",
    "10_2009": "挑战次数",
    "5_2110": "删除",
    "10_2002": "排行榜",
    "5_2117": "失败",
    "10_2003": "防守记录",
    "5_2116": "胜利",
    "10_2004": "对手列表",
    "5_2115": "防守失败",
    "10_2005": "防守阵容",
    "5_2114": "防守成功",
    "messageInitContent_3141": "笑出声了",
    "10_2010": "建造",
    "messageInitContent_3142": "捂嘴",
    "10_2011": "换一批",
    "5_2119": "段位下降",
    "messageInitContent_3143": "看我法棍",
    "10_2012": "段位",
    "5_2118": "段位提升",
    "messageInitContent_3144": "这丢的什么呀",
    "messageInitContent_3145": "嗯哼",
    "messageInitContent_3146": "宝贝，你在吗",
    "messageInitContent_3147": "恶心心",
    "messageInitContent_3148": "赤练少爷~~~",
    "mapNodeName_1417": "治愈秘仪",
    "mapNodeName_1416": "秘仪圣域",
    "mapNodeName_1415": "秘仪圣域",
    "mapNodeName_1414": "秘仪圣域",
    "mapNodeName_1413": "先祖秘仪",
    "mapNodeName_1412": "风雷秘仪",
    "mapNodeName_1411": "秘仪圣域",
    "mapNodeName_1410": "古记战役-香月秘仪",
    "messageInitContent_3140": "我笑了",
    "messageInitContent_3149": "前排售卖避雷针",
    "messageInitNick_10974": "蒜兽",
    "messageInitNick_10975": "你不在的饭堂",
    "messageInitNick_10972": "电冰箱怪",
    "messageInitNick_10973": "思维不足挑战",
    "messageInitNick_10978": "手发陷阱",
    "messageInitNick_10979": "盛夏光年",
    "messageInitNick_10976": "锅太沉",
    "messageInitNick_10977": "江清月近人",
    "messageInitContent_3152": "我宣布！",
    "messageInitContent_3153": "啊这",
    "messageInitContent_3154": "溜了溜了",
    "messageInitContent_3155": "我是电母，命令你赶紧收皮",
    "messageInitContent_3156": "蘑菇兽？",
    "messageInitNick_10970": "打歌高手",
    "messageInitContent_3157": "圣光古龙：你拿我的角了",
    "messageInitNick_10971": "谐音梗扣钱",
    "messageInitContent_3158": "原来有3个角",
    "messageInitContent_3159": "它头顶的就是蘑菇",
    "mapNodeName_1406": "深视秘仪",
    "mapNodeName_1405": "秘仪圣域",
    "mapNodeName_1404": "镇守秘仪",
    "mapNodeName_1403": "雷火秘仪",
    "mapNodeName_1402": "阵法秘仪",
    "mapNodeName_1401": "秘仪圣域",
    "mapNodeName_1400": "望涡者",
    "messageInitContent_3150": "啥情况",
    "messageInitContent_3151": "御空老婆~~~",
    "messageInitNick_10985": "抽象闺蜜",
    "messageInitNick_10986": "最强盘子",
    "messageInitNick_10983": "赤脚仙",
    "messageInitNick_10984": "步步为赢",
    "messageInitNick_10989": "懒猫",
    "messageInitNick_10987": "一夜美梦",
    "messageInitNick_10988": "捣蛋鬼才",
    "messageInitContent_3163": "九黎影曜啊",
    "messageInitContent_3164": "大家还好吗",
    "themeCardPackDes_16005": "夜色渐浓，事物间的分界变得越发模糊。\\n它先是踢到了一块大石上，险些摔倒，再是与灌木丛撞了个满怀，刚爬起没一会又掉进了坑里，它发现远处的异响变得前所未有的可怕，冷汗从手心腋下不断地渗出，它试着用力抱紧自己却仍止不住颤抖，原来只有它无法在黑暗中视物。它就如同一头陷入了黑暗泥沼的困兽，寸步难行。\\n本以为第一次夜游就会是在恐惧和耳畔的嗡嗡声与笑声中结束。突然一道烈焰在它眼前划过，将黑暗连同那些嘲笑它的幼体怪兽一同燃尽。\\n它的心跳在此刻漏了一拍。",
    "messageInitContent_3165": "下一关噜",
    "messageInitContent_3166": "就这？就这？",
    "messageInitContent_3167": "大佬你好，大佬再见",
    "messageInitNick_10981": "打工人日常",
    "messageInitContent_3168": "人家是e人i人，我是abc后面那个",
    "messageInitNick_10982": "纯情食盐",
    "messageInitContent_3169": "热~",
    "messageInitNick_10980": "注意看这是",
    "messageInitContent_3160": "好耶",
    "messageInitContent_3161": "什么意思？",
    "messageInitContent_3162": "天龙八部？？",
    "messageInitNick_5297": "冷场帝",
    "messageInitNick_5298": "神秘的榛子",
    "messageInitNick_5299": "沉默的高压锅",
    "messageInitNick_5293": "垂耳大黑兔",
    "messageInitNick_5294": "纯情鱼露",
    "messageInitNick_5295": "尖叫雪莲果",
    "messageInitNick_5296": "迷途猫",
    "messageInitNick_5290": "搞笑先生",
    "messageInitNick_5291": "肩胛。",
    "messageInitNick_5292": "垂耳兔",
    "messageInitNick_5286": "甩锅先驱",
    "mapNodeName_10": "相亲相爱一家人",
    "messageInitNick_5287": "背心使者",
    "mapNodeName_11": "我们的狂想曲",
    "messageInitNick_5288": "床下旅行者",
    "mapNodeName_12": "无处安放的双手",
    "messageInitNick_5289": "单身就是爷",
    "mapNodeName_13": "金矿山",
    "mapNodeName_14": "瞬息草原",
    "mapNodeName_15": "合唱团",
    "mapNodeName_16": "微光之森",
    "mapNodeName_17": "鳄仁转",
    "mapNodeName_18": "瞬息草原",
    "mapNodeName_19": "凝时冰谷",
    "messageInitContent_5809": "好大",
    "messageInitContent_5808": "微笑",
    "messageInitContent_5801": "早呀各位",
    "messageInitNick_10897": "古代草莓",
    "messageInitNick_5282": "呆萌少女心",
    "messageInitContent_5800": "又没大对",
    "messageInitNick_10898": "闪亮洗牌",
    "messageInitNick_5283": "独居的西瓜",
    "messageInitContent_5803": "今年不熬夜",
    "messageInitNick_10895": "群空调",
    "messageInitNick_5284": "落汤鸡",
    "messageInitContent_5802": "我只是个孩子",
    "messageInitNick_10896": "此男有点拽",
    "messageInitNick_5285": "全息饼干",
    "messageInitContent_5805": "昨天刚脱单",
    "messageInitContent_5804": "今年不加班",
    "messageInitContent_5807": "不许笑",
    "messageInitNick_10899": "吵醒的梦想",
    "messageInitNick_5280": "共饮孟婆汤",
    "messageInitContent_5806": "大笑就好了吗",
    "messageInitNick_5281": "蛋挞射手",
    "messageInitNick_5279": "跑调小能手",
    "messageInitNick_10890": "智能番茄酱",
    "messageInitNick_10893": "火龙果龙",
    "messageInitNick_5275": "飞鳄扑腾",
    "messageInitNick_10894": "认证头铁专家",
    "messageInitNick_5276": "给微波炉带货",
    "messageInitContent_5810": "好粗",
    "messageInitNick_10891": "能够选择失忆",
    "messageInitNick_5277": "迷路的核仁",
    "messageInitNick_10892": "卖惨之神",
    "messageInitNick_5278": "彪悍的小仙女",
    "messageInitContent_5819": "大胆！",
    "messageInitContent_5812": "崩坠三巨头是不是有4个",
    "messageInitNick_5271": "没有退路",
    "messageInitContent_5811": "又又又是你们",
    "messageInitNick_5272": "骄傲的公主",
    "messageInitContent_5814": "？？？？？",
    "messageInitNick_5273": "猛不起来了",
    "messageInitContent_5813": "小赤虹在就更大了",
    "messageInitNick_5274": "成熟的软件",
    "messageInitContent_5816": "怎么只剩下键盘了",
    "messageInitContent_5815": "说啥呢",
    "messageInitContent_5818": "腾龙快回来",
    "messageInitContent_5817": "kb侠本体是键盘很合理",
    "messageInitNick_5270": "国产小仙女",
    "messageInitNick_5268": "五点的拉面",
    "messageInitNick_5269": "越来越远",
    "messageInitNick_5264": "捡漏之王",
    "messageInitNick_5265": "跟风王子",
    "messageInitContent_5821": "难道说",
    "messageInitNick_5266": "煎饼果子",
    "messageInitContent_5820": "今天早睡",
    "messageInitNick_5267": "蓝莓君快逃",
    "propConfigDes_40383": "半透明的糖果中，浮现着不断变幻的各大奇观，快用双眼将它们抢占下来吧！\\n「用于奇迹集市兑换」",
    "propConfigDes_40384": "包裹好运的粽子，可留住好运，亦可传递好运，什么？你要给它换种捆法？\\n「用于端午游舫兑换」",
    "propConfigDes_40385": "传说中，这块石头源自一个信奉辉神的古老部族。部族成员唯有通过历练，才能获赐一枚独属于自己的神导石。神导石上刻有辉神的神圣纹路。面临重大抉择，持有者可根据上面的纹路获得辉神的指引，并获得特定检定+1的效果。当然那是传说中而实际上->\\n「用于地腹岩窟兑换」",
    "themeCardPackDes_28035": " “游戏结束，这次我玩得很开心哈哈。”\\n“那么奖励呢？”金翅璞佳鸟问道，它根本没预料到这次挑战会如此顺利。\\n“失踪的圣堂武士？我本来也没打算隐瞒，就是忘记说了。它们在这个游戏里，玩得太投入了，一直不舍得离开，甚至觉得自己本来就是游戏中的角色。可如果强行将它们带离，恐怕会造成更可怕的后果。”\\n“可我们过来的时候也没发现它们在游戏中？”\\n“因为我换了个法子让它们离开了。既然它们在意识层面已将自己认定为游戏角色，那从概念上来说，规则变更便可以对本应不是玩物的它们生效。于是，我稍微修改了一下规则，在完成转换后，让它们以其他身份回归现实。现在它们是——玩偶棋兵。”\\n“那特殊的规则改写权限呢？”赤虹追问。\\n“已经在你们的物品栏了。那我先走啦！下次再一起玩吧。”\\n瞳打开物品栏，看着其中的小炸弹图标，沉默片刻。\\n“……被摆了一道。这个规则修改权限，只能作用于这个玩物游戏。”\\n“可恶。”金翅璞佳鸟低声骂道。\\n就这样核心战团以不完全的胜利结束了这场挑战。\\n但这点遗憾反而让它们更期待下一次了。",
    "propConfigDes_40386": "别再拔它的花瓣了，花花才不会关心Ta爱不爱你，花花只在乎你怎样挥洒自己的色彩！\\n「用于缤纷小铺兑换」",
    "propConfigDes_40387": "随着纹样流转变换，味道也会随之变化的月饼，啊这口，是五仁~\\n「用于玉兔宝盒兑换」",
    "propConfigDes_40388": "印有枫叶形状的石头，相传集齐77颗，就可以召唤秋天（就是你想的那种，用石把字拼出来！）！\\n「用于云霞燎里兑换」",
    "propConfigDes_40389": "无数闪亮的瞬间在这一刻凝聚成耀眼的星，是又一年与超进化大陆交织的光芒！\\n「用于周年橱窗兑换」",
    "themeCardPackDes_28030": "它们一路砍翻了一些拦路的恶龙手下，很快便抵达了巢穴深处。\\n可迎接它们的，并不是想象中的巨龙猛扑或巨龙吐息。\\n眼前的，是一条看起来异常饥饿的饿龙。\\n它颤抖的爪子，端着一个金色的盘子，小心翼翼地向前伸出，声音虚弱而恳切：“好心，给点吃的吧。我已经好几天没吃过像样的东西了……”\\n很快，它们便意识到真相。\\n所谓的“恶龙”，不过是国王掩盖军事扩张的借口，以制造外敌之名，对周边领地发动攻击。\\n“那我们还要继续吗？”瞳问道\\n“当然，游戏目标写得很清楚，是打倒侵害这片区域的恶龙。”赤虹挥剑向前。\\n“等等。”炼狱魔眼拉住了她。“前提是，先确认它是否真的侵害这个区域”\\n“是的。”瞳点头。\\n饿龙轻轻敲了敲自己的金盘。\\n“如果你们找那个恶龙，我或许能提供些情报。前提是，能不能先给我点吃的。”\\n“那你想吃什么呢？”金翅璞佳鸟问。\\n“烧鸡！”饿龙脱口而出。\\n“喂喂你们不是吧！”金翅璞佳鸟这才发现自己已经被瞳和炼狱魔眼一左一右按住了。\\n赤虹手起剑落，斩下了金翅璞佳鸟的一条腿。\\n瞳和炼狱魔眼同时施法，复原和治愈的魔法光芒交错，金翅璞佳鸟的腿重新长出。\\n另一边，赤虹已经将腿烤至金黄，放进了饿龙的金色盘子中。\\n“好吃！”饿龙露出了满足的神情。\\n“谢谢你们，既然你们满足了我的愿望，那么我就告诉你们吧。真正幕后黑手是武器商人，他的名字就叫恶龙。是他蛊惑了国王。”\\n确认真正的游戏目标后，核心战团迅速完成了任务！\\n一阵白色的光芒将世界笼罩。\\nB.B.Token出现了……",
    "messageInitContent_5823": "不可能",
    "messageInitNick_5260": "骑着羊放狼",
    "messageInitContent_5822": "月夕的月亮就是这只东西上拔下来的？",
    "messageInitNick_5261": "保护敌方下路",
    "messageInitContent_5825": "摸鱼时间！",
    "messageInitNick_5262": "情场初学者",
    "messageInitContent_5824": "前面是什么！",
    "messageInitNick_5263": "补刀冠军",
    "messageInitContent_5827": "叉你？",
    "messageInitContent_5826": "小沸体让我会会你",
    "messageInitContent_5829": "真被硬控",
    "messageInitContent_5828": "超巨型叉叉的叉头突破天际",
    "messageInitNick_5257": "泡芙猎手",
    "messageInitNick_5258": "豆角之心",
    "messageInitNick_5259": "那场旧电影",
    "messageInitContent_5830": "沸涌者？",
    "messageInitNick_5253": "早已戒网",
    "messageInitNick_5254": "奋力奋战中考",
    "messageInitContent_5832": "龙头突破天际",
    "messageInitNick_5255": "无公害李子",
    "messageInitContent_5831": "可可爱爱",
    "messageInitNick_5256": "睡到吃饭时",
    "propConfigDes_40390": "2.9版本道具",
    "propConfigDes_40391": "3.0版本道具",
    "propConfigDes_40392": "3.1版本道具",
    "propConfigDes_40393": "在环形斗场之外，硎主动出击，不断向其他怪兽发起挑战，经年累月的战斗，无数次受到伤害的经验化作形态各异的积木，逐步嵌合，造就了他如今充满韧性的躯体。\\n「用于硎嵌合形态解锁」",
    "propConfigDes_40394": "几乎没有游魂能抵御一个无主活体的诱惑，因此时刻都有无数游魂争先恐后地试图挤入咎骸体内，妄图将其据为己有。可就像太多怪兽挤入肉肉山洞口反而进不去一样，这些幽魂就这样紧缠在咎骸周围，在无尽的推搡、纠缠、撕扯和互不相让中，达成了一种诡异的和谐。\\n「用于咎骸缠魂形态解锁」",
    "propConfigDes_40397": "文明刻机的守则是“置身其中、代入其境”，可其他刻机的傲慢与怯懦扭曲了守则的本意，它们从未真正刻录过！真正的刻录是剖开自我，将文明揉碎，刻入骨肉，嵌入灵魂，让它与我同生！共朽！\\n「用于艾娜璃兹畸轨形态解锁」",
    "propConfigDes_40398": "戏战顽袍偶尔也会度假，真的！\\n找个海滩、拉只怪兽、晒下太阳~\\n一开始确实挺放松的，直到它开始抓着那只怪兽不放，非得让它帮把手，搞出最Q弹的火山果冻权杖、最精致的菠萝椰叶刀，整出最帅的大拼盘花衣袍……\\n战斗其实从未停下，只是换了个战场——在这场夏日装扮大作战中，成为全 场 最 亮 的 仔！\\n最终，那只怪兽在花丛中哀嚎：“兄弟，血条都给你，咱回去打架，行吗？”\\n「用于戏战顽袍戏游形态解锁」",
    "messageInitContent_5834": "多大我都会说不够大",
    "themeCardPackDes_28040": "美少女慌忙起身，不断道歉。看起来并没有受什么伤。\\n被撞到的玩家拍了拍屁股起身，骂了几句，却还是转头帮店长一起收拾散落一地的桌游与玩具。\\n只有玩具和桌游店长受伤的世界达成了。\\n世界再次翻转。\\nB.B.Token已经在【怪与地底穴】这个玩物游戏中停留了很久。\\n关于怪兽将自我认知转变为玩物，从而使原本不能对怪兽生效的规则变成得以生效的可能性，它并没有细说。\\n一方面，它不希望其他怪兽产生会被规则改写的恐惧，另一方面，它确实有着尝试的念头。\\n如果自己像圣堂武士那样，不断沉浸在游戏中，将自身误认为是玩物的一部分。\\n再借助预先设定好的规则修改，是否就能改变自身的设定。从而反向影响现实呢？\\n可在多次尝试之后，它发现了一个无论如何都无法绕开的限制。\\n只有在“濒死的瞬间”的自我认知转变，才能真正引导至现实。\\n就像当初，它在桌游店裂开的瞬间。\\n然而，它偏偏拥有——在受到致死伤害后，一定时间内不会死亡的力量。\\n于是，即便不断重复，它也会永远错过那个时点。\\n也只能再研究下怎么再次绕开这个“时”了……\\n当然,这只是阻止它的其中一个因素。\\n至于另一个因素——\\n在那之前，先开一把玩物游戏好了。",
    "messageInitContent_5833": "超大裙摆",
    "messageInitNick_5250": "北街九命猫",
    "messageInitContent_5836": "极限在哪里",
    "messageInitNick_5251": "爱幻想",
    "messageInitContent_5835": "吃饭时间！",
    "messageInitNick_5252": "只喝可乐的猫",
    "messageInitContent_5838": "肉肉转移大法",
    "23_2001": "终焉的记忆",
    "messageInitContent_5837": "要减肥了",
    "23_2002": "我",
    "23_2003": "谜之生物",
    "messageInitContent_5839": "胖点才好",
    "messageInitNick_5246": "构图大师",
    "messageInitNick_5247": "键盘破坏者",
    "messageInitNick_5248": "国民帅比",
    "messageInitNick_5249": "镜离",
    "messageInitContent_5841": "希望在明天",
    "messageInitNick_5242": "穿甲联邦",
    "messageInitContent_5840": "和自己的锁链握个手",
    "messageInitNick_5243": "洋葱真好吃",
    "messageInitContent_5843": "猫硬控了我的键盘",
    "messageInitNick_5244": "过几年摸鱼",
    "messageInitContent_5842": "#￥%@#……@%￥……%￥……@￥",
    "messageInitNick_5245": "融化可可的龙",
    "messageInitContent_5845": "妹子硬控了我的键盘",
    "messageInitContent_5844": "难道说……",
    "messageInitContent_5847": "比比谁更大",
    "messageInitNick_5240": "一吻天荒",
    "messageInitContent_5846": "无图言",
    "messageInitNick_5241": "苍蝇的面孔",
    "messageInitContent_5849": "我还是个孩子，看不得一点",
    "messageInitContent_5848": "你的镇魂在隔壁",
    "messageInitNick_5235": "爱已脱力",
    "messageInitNick_7898": "搏斗之皇",
    "messageInitNick_5236": "白云味棉花糖",
    "messageInitNick_7897": "红色青猫",
    "messageInitContent_5850": "大对了！",
    "messageInitNick_5237": "我最强的仆人",
    "messageInitNick_5238": "作业逆流成河",
    "messageInitNick_7899": "萨卡班甲鱼鱼",
    "messageInitContent_5852": "御象",
    "messageInitNick_5231": "喘气的夜明猪",
    "messageInitNick_7894": "智慧的眼神",
    "messageInitContent_5851": "啊，啊，啊，啊啊啊啊啊啊",
    "messageInitNick_5232": "足球盖饭",
    "messageInitNick_7893": "时间是测谎仪",
    "messageInitContent_5854": "你踩我踩",
    "messageInitNick_5233": "笨笨猫",
    "messageInitNick_7896": "断桥念雪",
    "messageInitContent_5853": "可怜的小溜溜被各种踩在脚下",
    "messageInitNick_5234": "吃货",
    "messageInitNick_7895": "整点麦乐鸡",
    "messageInitNick_5239": "玉米排骨汤",
    "messageInitContent_5856": "御空你的体型不太对啊啊啊",
    "messageInitNick_7890": "活泼小丸子",
    "messageInitContent_5855": "你的剧在隔壁",
    "messageInitContent_5858": "小强搓手",
    "messageInitNick_7892": "多笋啊",
    "messageInitContent_5857": "哪里对了好像又哪里不对",
    "messageInitNick_5230": "桃子之心",
    "messageInitNick_7891": "恋爱无效期",
    "messageInitContent_5859": "蟑螂撒娇娇",
    "messageInitNick_5224": "胜听一席话",
    "messageInitNick_7887": "没有战斗力",
    "messageInitNick_5225": "不想上班",
    "messageInitNick_7886": "记忆荒原",
    "messageInitContent_5861": "emmmm",
    "messageInitNick_5226": "落幕的笑靥",
    "messageInitNick_7889": "调皮的灯光",
    "messageInitContent_5860": "我又可以了",
    "messageInitNick_5227": "嘟嘟嘟占线中",
    "messageInitNick_7888": "石缝中的花",
    "messageInitContent_3200": "蜻蜓龙也是龙",
    "messageInitContent_5863": "谢谢你",
    "messageInitNick_5220": "老衲戒女神",
    "messageInitNick_7883": "爱你情非得已",
    "messageInitContent_3201": "想要躲在镜子里",
    "messageInitContent_5862": "点击不休查看隐藏怪兽，不用谢",
    "messageInitNick_5221": "钛合金直男",
    "messageInitNick_7882": "萌比从天而降",
    "messageInitContent_3202": "和蜃兽打架还能一边欣赏自己的帅气",
    "messageInitContent_5865": "这里玩捉迷藏不错",
    "messageInitNick_5222": "愁绪满风袖",
    "messageInitNick_7885": "我有对象勿扰",
    "messageInitContent_3203": "摆了",
    "messageInitContent_5864": "是小黑子",
    "messageInitNick_5223": "香草奶昔哇哦",
    "messageInitNick_7884": "凉粉剑客",
    "messageInitNick_5228": "屠龙者",
    "messageInitNick_5229": "别拉高上限",
    "propConfigDes_40340": "探究起源者前仆后继，起源却仍带着层层未知的面纱藏在名为不可知的迷雾背后，稍微探明的部分只有起源核心和与之相似的裂变核，一些怪兽认为，裂变核是起源核心破碎后的产物，也有一些怪兽认为裂变核是不完全的起源核心，唯一可以确定的是，裂变核可以短暂地融入起源核心作为副核，增加起源核心承载起源盘的力量。\\n「用于起源核心负重提升，使用后起源核心负重提升{1}，持续时间{2}小时，重复使用可叠加持续时间，持续时间大于{3}小时后无法继续叠加，失效后自动卸下起源盘」",
    "propConfigDes_40341": "这个元核髓盒装载着各种紫色元核词条！选一个为充满变量的熔炼中注入不变量！",
    "propConfigDes_40342": "这个元核髓盒装载着各种蓝色特化元核词条！选一个为充满变量的熔炼中注入不变量！",
    "propConfigDes_40343": "这个元核髓盒装载着各种紫色特化元核词条！选一个为充满变量的熔炼中注入不变量！",
    "propConfigDes_40344": "这个元核髓盒装载着各种紫色远古元核词条！选一个为充满变量的熔炼中注入不变量！",
    "propConfigDes_40345": "这个元核髓盒装载着各种紫色元核宿命效果词条！选一个为充满变量的熔炼中注入不变量！",
    "propConfigDes_40346": "仅仅只是注视同一弯月的想象，就足矣化作千亿牵绊。\\n「用于启程商店兑换」",
    "propConfigDes_40347": "冰镇泡泡水在口腔冲撞，海水调皮地在脚边嬉戏，咸咸的海风拂过双翼与长发，呐~是谁在轻轻呼唤？是星点般串联的夏日点滴，是沉溺于无尽夏梦的她。\\n「用于绯焉夏梦形态解锁」",
    "propConfigDes_40348": "那是照映颤栗的每一滴海水，更是长眠者的每一只眼眸。\\n「用于海鸣商店兑换」",
    "messageInitNick_7881": "鸟儿飞飞飞",
    "propConfigDes_40349": "一次意外的梦境穿越，让海漩抵达了那片死寂之境，与其造物者取得了极其短暂的连接，而这就是它身上剧变仅此而已的开端。所以说，真正的噩梦是什么？噩梦成真？不，是醒着。\\n「用于海漩夜魇形态解锁」",
    "messageInitNick_7880": "我选择困难",
    "mapNodeName_80": "瞬息草原",
    "mapNodeName_81": "你不要过来啊",
    "mapNodeName_82": "此路不通",
    "messageInitNick_5213": "最强飞机",
    "messageInitNick_7876": "超级沙拉",
    "mapNodeName_83": "混入龙群",
    "messageInitNick_5214": "翻版情人",
    "messageInitNick_7875": "叫我冷场王",
    "mapNodeName_84": "奶一口",
    "messageInitNick_5215": "绿色发光",
    "messageInitNick_7878": "静静养大猫",
    "mapNodeName_85": "瞬息草原",
    "messageInitNick_5216": "忘吃早饭",
    "messageInitNick_7877": "人帅路子正",
    "mapNodeName_86": "瞬息草原",
    "messageInitNick_7872": "给空调道歉",
    "mapNodeName_87": "让我看看谁血最少",
    "messageInitNick_5210": "人参果去哪了",
    "messageInitNick_7871": "自己想办法",
    "mapNodeName_88": "微光之森",
    "messageInitNick_5211": "已通关",
    "messageInitNick_7874": "给汽车按摩",
    "mapNodeName_89": "寄本功",
    "messageInitNick_5212": "无公害杏子",
    "messageInitNick_7873": "龙龙舞者",
    "messageInitNick_5217": "两点的拉面",
    "messageInitNick_5218": "麻辣烫很开心",
    "messageInitNick_7879": "九点的泡面",
    "messageInitNick_5219": "过几年退休",
    "propConfigDes_40350": "这个元核髓盒装载着各种橙色元核宿命效果词条！选一个为充满变量的熔炼中注入不变量！",
    "propConfigDes_40351": "这可不是什么来自游戏在逃的眼，这是从台球桌上逃跑的1号球恶魔！\\n「用于尖叫橱窗兑换」",
    "propConfigDes_40352": "为了让怪兽理解反转的奥义，崩律决定反其道而行之，它迫使怪兽遵守一系列无聊的规则，它则作为规则的裁决者，确保怪兽彻底遵循规则。因为它相信这些被规则长期约束的怪兽终有一日会觉醒，产生打破规则的觉悟，而这，正是它创造一个反转再反转世界的第一步。\\n「用于崩律裁决形态解锁」",
    "propConfigDes_40353": "神灵的神性究竟源自于何处？它们自身的特质？还是众多怪兽共同的信念？神唤不敢相信自己竟然生出此等疑惑，可怀疑一旦产生，便一发不可收拾，它已陷入那条通往神性背后的无尽暗隧。\\n「用于神唤暗隧形态解锁」",
    "propConfigDes_40354": "战墙武装碎片蕴含了一种名为“变身”的特殊力量，将足量的碎片塞给战墙背后的小兽，然后让它们大喊“变身”，完成武装吧！\\n「用于战墙武装解锁」",
    "propConfigDes_40355": "这是你与《超进化物语2》共度一周年时光的记号，它无比期盼着身上的数字不断+1。\\n「用于周年商店兑换」",
    "propConfigDes_40356": "掌中之瞳不歇地切换视角，不断判别眼前的虚物能否置入深渊的，它的筛选精确而快速，瞬息间即可完成接纳与否抉择，可那一次，不知道它看到了什么，耗费了整整7个日月，才作出了待定的判断。瞳无法看清掌中之瞳看到的虚物是什么，只能透过模糊的共感隐约窥见一抹粉色。\\n「用于瞳甜粉形态解锁」",
    "propConfigDes_40357": "这个元核髓盒装载着各种橙色远古元核词条！选一个为充满变量的熔炼中注入不变量！",
    "propConfigDes_40358": "这个元核髓盒装载着各种红色元核宿命效果词条！选一个为充满变量的熔炼中注入不变量！",
    "propConfigDes_40359": "祈已记不清这次是第几世了，她在漫长的修炼之路上走了太久，这一世，她想稍稍绕个远路，任性一回。她没有像往世一样找寻祈愿者，她褪下的皮囊，在上面轻轻一点，缓缓问到，你要许个愿吗？\\n「用于祈玄青形态解锁」",
    "messageInitNick_7870": "皇后娘娘",
    "mapNodeName_90": "不动刺客",
    "mapNodeName_91": "雪原刺客",
    "mapNodeName_92": "瞬息草原",
    "mapNodeName_93": "瞬息草原",
    "messageInitNick_5202": "离水的鱼",
    "messageInitNick_7865": "记得要微笑",
    "mapNodeName_94": "微光之森",
    "messageInitNick_5203": "鲜嫩多汁",
    "messageInitNick_7864": "可乐有毒",
    "mapNodeName_95": "瞬息草原",
    "messageInitNick_5204": "马马工程师",
    "messageInitNick_7867": "泪已决堤",
    "mapNodeName_96": "瞬息草原",
    "messageInitNick_5205": "霸刀与温柔",
    "messageInitNick_7866": "苷沉",
    "mapNodeName_97": "头翔",
    "messageInitNick_7861": "秋日落叶",
    "mapNodeName_98": "凝时冰谷",
    "messageInitNick_7860": "嘘别出声",
    "mapNodeName_99": "极限突破",
    "messageInitNick_5200": "龙猫在等雨",
    "messageInitNick_7863": "藏不住喜欢",
    "messageInitNick_5201": "摸鱼后遗症",
    "messageInitNick_7862": "你二你先说",
    "messageInitNick_5206": "硬核麻辣烫",
    "messageInitNick_7869": "无极巧手",
    "messageInitNick_5207": "无公害人参果",
    "messageInitNick_7868": "林间茫茫月色",
    "messageInitNick_5208": "本姑娘贼稳妥",
    "messageInitNick_5209": "跑调先驱",
    "propConfigDes_40360": "因祈愿者的美好祝福凝聚而成的美玉。而当祝福有了实体，仿佛就能切实握住幸福。\\n「用于春祈花市兑换」",
    "propConfigDes_40361": "将那个位置看作嘴巴或尾巴将决定它是一条衔尾蛇还是一条努力凹造型的蛇。\\n「用于双关之环头像框解锁」",
    "propConfigDes_40362": "灯光不熄，快乐不眠~\\n「用于不眠夜头像框解锁」",
    "propConfigDes_40363": "让清新的叶香将你包围唤醒一整天的好心情。\\n「用于叶脉藏馨头像框解锁」",
    "propConfigDes_40364": "这是觉醒的第一眼，也是混沌的最后一眼。\\n「用于回环迷图头像框解锁」",
    "propConfigDes_40365": "有个魔法叫：加几朵小云，就有了天空！\\n「用于蜡笔小云头像框解锁」",
    "propConfigDes_40366": "特邀比蒙巨兽协助制作！想什么呢，原材料怎么可能是兔兔！\\n「用于兔饼头像框解锁」",
    "propConfigDes_40367": "风与枫叶共舞的每一瞬留影。\\n「用于枫色舞步头像框解锁」",
    "propConfigDes_40368": "在《超进化物语2》二周年这个特别的日子里，连像素都激动到要溢出屏幕~\\n「用于像素入侵头像框解锁」",
    "propConfigDes_40369": "2.9签到战令头像框",
    "mapNodeName_60": "微光之森",
    "messageInitNick_7854": "东京小萌妹",
    "mapNodeName_61": "微光之森",
    "messageInitNick_7853": "你的食堂阿姨",
    "mapNodeName_62": "微光之森",
    "messageInitNick_7856": "藏在星辰大海",
    "mapNodeName_63": "火上加油",
    "messageInitNick_7855": "五块三斤",
    "mapNodeName_64": "瞬息草原",
    "messageInitNick_7850": "会吐泡泡的鱼",
    "mapNodeName_65": "微光之森",
    "mapNodeName_66": "古记战役-炮灰",
    "messageInitNick_7852": "水煮薯片",
    "mapNodeName_67": "凝时冰谷",
    "messageInitNick_7851": "迷倒一片喵",
    "mapNodeName_68": "您好我该握哪只手？",
    "mapNodeName_69": "听说你战力颇高？",
    "messageInitNick_7858": "暖水瓶",
    "messageInitNick_7857": "龙眼射手",
    "propConfigDes_40370": "3.0签到战令头像框",
    "messageInitNick_7859": "在徘徊中等你",
    "propConfigDes_40371": "3.1签到战令头像框",
    "propConfigDes_40372": "祥云簇拥着彩灯升起，见证每一个美梦成真。\\n「用于祥云灯彩头像框解锁」",
    "propConfigDes_40373": "舞台早已就绪，只待主角登场，出场时间到了！舞台就交给你了~头像哟，请开始您的表演！\\n「用于旋转舞台头像框解锁」",
    "propConfigDes_40374": "锣鼓声唤醒了沉眠水底的舟龙，它径直浮出水面，抖落泥污，渴望着与不见一年的伙伴再度全力冲刺！\\n「用于起龙头像框解锁」",
    "propConfigDes_40375": "它曾高踞在象征部族权力的权杖之巅，见众兽俯首于前。\\n「用于威权杖冠头像框解锁」",
    "propConfigDes_40376": "用尽一切美好衬托所爱之物，这何尝不是一种痛包（划掉）~\\n「用于蜡笔小花头像框解锁」",
    "propConfigDes_40377": "听说月亮上的兔兔不会被做成月饼，所以兔兔盼着奔月。比蒙巨兽听闻大呼冤枉。\\n「用于兔兔奔月头像框解锁」",
    "propConfigDes_40378": "喵响乘着凉风在枝梢跃起，挂着秋叶的枝桠勾起了圆。\\n「用于一弯秋叶头像框解锁」",
    "propConfigDes_40379": "把带着二周年记忆的星块挂在最显眼的位置，庆祝《超进化物语2》二周年！\\n「用于二周年头像框解锁」",
    "mapNodeName_70": "自备餐具环保卫生",
    "mapNodeName_71": "孤独留白",
    "messageInitNick_7843": "不口胡会挂",
    "mapNodeName_72": "开餐和开个唱的",
    "messageInitNick_7842": "暴走萝莉酱",
    "mapNodeName_73": "偶遇父子局",
    "messageInitNick_7845": "广场舞老师",
    "mapNodeName_74": "古记战役-它的剧本",
    "messageInitNick_7844": "一点的拉面",
    "mapNodeName_75": "微光之森",
    "mapNodeName_76": "欢迎收看动物世界",
    "mapNodeName_77": "微光之森",
    "messageInitNick_7841": "手握馒头",
    "mapNodeName_78": "微光之森",
    "messageInitNick_7840": "尬聊少女",
    "mapNodeName_79": "微光之森",
    "messageInitNick_7847": "加油成功",
    "messageInitNick_7846": "半世枪魂",
    "propConfigDes_40380": "2.9商店头像框",
    "messageInitNick_7849": "旋转楼梯",
    "propConfigDes_40381": "3.0商店头像框",
    "messageInitNick_7848": "染墨绘君衣",
    "propConfigDes_40382": "3.1商店头像框",
    "propConfigDes_40300": "它既是大漠的瞬息，又是对现实一次拙劣或精湛的模拟。\\n「用于大漠行走格子」",
    "propConfigDes_40301": "变化的积分，不变的创友！\\n「用于创友招募奖励解锁」",
    "propConfigDes_40302": "穿梭于万象之中，带来与你相应之象。\\n「用于万象琥珀购买」",
    "hyperEvolutionName_3": "强运轨迹",
    "propConfigDes_40303": "一种能传递形态变化信号，支配性状产生各种变化的末梢。\\n「用于许愿商店兑换」",
    "hyperEvolutionName_4": "厄变滤波",
    "propConfigDes_40304": "可亲手烘托的小小美好。\\n「用于腾龙燃火奖励解锁」",
    "hyperEvolutionName_1": "生息环流",
    "propConfigDes_40305": "天下熙熙，皆为利来；天下攘攘，皆为利往。\\n「用于老莫集市兑换」",
    "hyperEvolutionName_2": "动能暗涌",
    "propConfigDes_40306": "时而深邃静谧，时而汹涌澎湃；它将化作安全的港湾，它将化作毁灭的狂潮。\\n「用于冥龙王重溟形态解锁」",
    "propConfigDes_40307": "知世郎？“知世郎，谁都不是。或者说……人人都可以是知世郎！”。\\n究竟知世郎是谁？或许在共鸣中燃起的心火知道答案。\\n「用于剧王花颜形态解锁」",
    "propConfigDes_40308": "“请恩赐我最强大的力量，我将送他们去接受你的审判！”\\n「用于影曜大漠形态解锁」",
    "propConfigDes_40309": "新年瑞兽出阵，拍扁一切麻烦！啪！——（看，麻烦被压扁了！）\\n「用于腾龙祥瑞形态解锁」",
    "messageInitNick_7832": "怪味橘子猫",
    "messageInitNick_7831": "欲望在挣扎",
    "mapNodeName_40": "呜呜呜呜呜呜",
    "messageInitNick_7834": "白衣男神",
    "mapNodeName_41": "瞬息草原",
    "messageInitNick_7833": "冰箱少年",
    "mapNodeName_42": "游魂荒野",
    "mapNodeName_43": "马上开*（动词）",
    "mapNodeName_44": "凝时冰谷",
    "messageInitNick_7830": "轰炸厕所",
    "mapNodeName_45": "微光之森",
    "mapNodeName_46": "金矿山",
    "mapNodeName_47": "猛犸上班了",
    "messageInitNick_7839": "射线",
    "mapNodeName_48": "有肉有奶有输出",
    "mapNodeName_49": "猛火慢烤",
    "messageInitNick_7836": "不如养头猪",
    "messageInitNick_7835": "菜花射手",
    "messageInitNick_7838": "流浪的作家",
    "messageInitNick_7837": "兔兔要睡觉啦",
    "propConfigDes_40310": "守岁既是团聚的契机，也是她不变的承诺。\\n「用于白昼守岁形态解锁」",
    "propConfigDes_40311": "旅程再启，不管是这片大陆还是你，虽看似相同却不尽相同。趁机探索一番吧！感受此番的变与不变。\\n「用于创友回归等级的提升」",
    "propConfigDes_40312": "没有龙能抵抗闪闪发光的金子和宝石，更无法抵抗兼具两者的金翠！除非它叫“没有龙”。\\n「用于腾龙商店兑换」",
    "propConfigDes_40313": "这个奇特的镜子能揭示出到底是什么东西让这个DNA动了。\\n「用于DNA动了格子图案揭晓」",
    "propConfigDes_40314": "不断传递着宝藏秘密的DNA。从数千年、数万年前开始，经历一代又一代精准的转录，一直留存至今。\\n「用于DNA动了阶段性奖励解锁」",
    "propConfigDes_40315": "三阵入局挑战次数",
    "propConfigDes_40316": "电气区块内的通电气体闪烁着迷幻的光，加密的交易信息在其中流转生辉。\\n「用于黑街商店兑换」",
    "propConfigDes_40317": "再完美的造物也有偏离运行轨道的一刻，那一刻狂潮席卷编码海洋的每一个角落，那一刻电子灵在低语。\\n「用于漆黑组件狂潮形态解锁」",
    "propConfigDes_40318": "▆▄▆▂▅▃▂▂▅▃▆▆▂▅▃▂▃▆▃▆▄▆▂▅▆\\n「用于御空崩坏形态解锁」",
    "propConfigDes_40319": "不灭的营火永远在守候归来的你。他日，若再见摇曳的火光，可会想起当时并肩防御，一起进攻，研究阵容，打闹说笑的日子。\\n「用于部落营火头像框解锁」",
    "messageInitNick_7821": "漂流日记",
    "tribeFeatConfigDes_2": "到达己方{?}级或以上的遗迹",
    "mapNodeName_50": "破界沼地",
    "messageInitNick_7820": "和脑子捉迷藏",
    "tribeFeatConfigDes_1": "在遗迹中击破{?}只怪兽",
    "mapNodeName_51": "肉肉山",
    "messageInitNick_7823": "菠萝爱好者",
    "mapNodeName_52": "怪兽去哪儿了",
    "messageInitNick_7822": "空山新雨",
    "mapNodeName_53": "瞬息草原",
    "mapNodeName_54": "“被打穿了”",
    "mapNodeName_55": "古记战役-初遇比蒙",
    "tribeFeatConfigDes_4": "在遗迹中累计消耗{?}移动力",
    "mapNodeName_56": "财富密码",
    "tribeFeatConfigDes_3": "部队到达己方遗迹累计{?}小时",
    "mapNodeName_57": "怪生的第二个岔路",
    "messageInitNick_7829": "吃饭前线",
    "mapNodeName_58": "凝时领地",
    "messageInitNick_7828": "大哥起早了",
    "mapNodeName_59": "能吃的武器",
    "messageInitNick_7825": "复仇乞丐",
    "messageInitNick_7824": "刹那嗟砣",
    "messageInitNick_7827": "戒网大师",
    "messageInitNick_7826": "勇敢牛牛",
    "propConfigDes_40320": "求索起源，究竟道上，形骸虽陨，道心永存。\\n「用于起源盘随机合成和起源盘插槽效果增幅」",
    "propConfigDes_40321": "蕴含着足以织就行星，覆写现实之力。\\n「用于起源盘效果重置」",
    "propConfigDes_40322": "细看耀世星芒，不过点点荧光。\\n「用于荧光商店兑换」",
    "propConfigDes_40323": "暴走回廊挑战次数",
    "propConfigDes_40324": "这块经过无数次反复锤炼的起源盘获得了承载至高起源之力的可能性，距离锻造完成只差最后一道工序，力量鸣动，触及至高！",
    "propConfigDes_40325": "无私的善意却不幸招来了无尽的恶意。不断出现的伤口中分泌出保护性的树脂，原本翠绿的光芒逐渐转为棕黄，荧灵甚至都没有察觉到，身体在暴力胁迫与生存压迫之中，迫切想要孕育下一代，渴望生命得以延续时，发生的微妙变化，末端那惑人的碧蓝。\\n「用于荧灵熔珀形态解锁」",
    "propConfigDes_40326": "创糕糕糕上装饰用的星星，不仅是超凡反应力的象征，还有着“糕星糕星，月月高薪，步步高升~”的美好寓意。\\n「用于庆典商店兑换」",
    "propConfigDes_40327": "不少怪兽都惊叹于幽狱沸体的本质，一个由大量沸体共同协作构成的整体。那么里头的沸体是否会因为长期的高度协作而失去个性呢？这个绚烂缤纷的形态也许是最好的答案。沸体们依旧保留着各自的想法和个性，它们将各自控制的部分改造成各自喜欢的样子，借此彰显幽狱沸体中所有“我”的存在。\\n「用于幽狱沸体缤纷形态解锁」",
    "propConfigDes_40328": "能够适应各种怪兽的特殊进化光谱，拥有一般进化光谱所不具备的适应力，这一跨越进化光谱固有概念的性质伴随着与之相应的力量，那就是超进化。\\n「用于怪兽超进化」",
    "propConfigDes_40329": "松散的箔材要如何才能比得上经过精密排布的箔材呢？唯有祈求奇迹降临！可仔细一看，那奇迹二字不正是由精密排布的箔材组合而成的吗！\\n「用于源初境商店兑换」",
    "messageInitNick_7810": "燕回",
    "messageInitNick_7812": "公路小子",
    "messageInitNick_7811": "明明很可爱",
    "mapNodeName_20": "凝时冰谷",
    "mapNodeName_21": "炮王烤串",
    "mapNodeName_22": "情伤疗愈圣地",
    "mapNodeName_23": "破界沼地",
    "mapNodeName_24": "普通下路组合",
    "messageInitNick_7818": "等不来樱花雨",
    "mapNodeName_25": "病名为爱",
    "messageInitNick_7817": "爱已搁浅",
    "mapNodeName_26": "后排os要肉盾何用",
    "mapNodeName_27": "微光之森",
    "messageInitNick_7819": "无敌吃瓜神",
    "mapNodeName_28": "我猜你没有镜子",
    "messageInitNick_7814": "老板没有假期",
    "mapNodeName_29": "安静",
    "messageInitNick_7813": "下年退役",
    "messageInitNick_7816": "我爱工作",
    "messageInitNick_7815": "素春卷",
    "propConfigDes_40330": "聊天框用腻了就换一个！这就是源初境冠军探索者的任性吗？\\n「用于冠军之声对话框解锁」",
    "propConfigDes_40331": "独特的底纹，低调的金边，全为衬托源初境冠军探索者的名字，也就是你的名字。就算左上角偶尔被怪兽挡住了也没关系，还有右上角~\\n「用于冠军之名名称框解锁」",
    "propConfigDes_40332": "让渴望超进化的怪兽欲罢不能的光华。\\n「用于造唤台进化光谱造唤」",
    "propConfigDes_40333": "想让可爱的屯屯扑满爆出更多金币和钻石，往往需要最华丽的金锤，它会立刻把你存它那的宝贝和它悄悄存的宝贝全部交出来，然后收下它挚爱的金锤。\\n「用于屯屯扑满双倍奖励领取」",
    "propConfigDes_40334": "想让可爱的屯屯扑满爆出金币和钻石，往往只需要最朴素的木锤，它会立刻把你存它那的宝贝全部交出来。\\n「用于屯屯扑满奖励领取」",
    "propConfigDes_40335": "从名字就能看出有2种玩法，一种是竞~一种是猜~\\n「用于源初境竞猜」",
    "propConfigDes_40336": "这个元核髓盒装载着各种橙色元核词条！选一个为充满变量的熔炼中注入不变量！",
    "propConfigDes_40337": "换一盏魂灯，换一种情愫。\\n「用于玖璃幻惑形态解锁」",
    "propConfigDes_40338": "焰色总是悄无声息地透露着其本体的各种秘密。当妄焱身上的焰火色也由橙黄色转变为青色时，请务必小心，它对妄念的不完全燃烧已彻底转化为极致的完全燃烧。换句话说，被它点燃的怪兽将连同它们的妄想一道消失得更为彻底。\\n「用于妄焱极焱形态解锁」",
    "propConfigDes_40339": "珍珠贝是一种美丽的宝石。传说中，有一只贝壳类软体动物，带着前世的记忆从异世界而来，它渴望成为一颗价值连城的珍珠，因为那样的话，就再也不需要为产出珍珠而受苦了。然后，如你所见，命运同它开了一个小玩笑，让它成为了一只能产出珍珠贝的珍珠。\\n「用于盛夏商店兑换」",
    "messageInitNick_7801": "撒娇是种艺术",
    "mapNodeName_30": "臣妾终于有肉盾了",
    "messageInitNick_7800": "早上四点半",
    "mapNodeName_31": "微光领地",
    "mapNodeName_32": "瞬息草原",
    "mapNodeName_33": "无界龙场",
    "mapNodeName_34": "我知道你很急但",
    "mapNodeName_35": "你尽管笑我们输出",
    "messageInitNick_7807": "独揽清风醉",
    "mapNodeName_36": "逐一击破",
    "messageInitNick_7806": "傲娇怪",
    "mapNodeName_37": "凝时冰谷",
    "messageInitNick_7809": "波板糖",
    "mapNodeName_38": "河边烧烤摊",
    "messageInitNick_7808": "绝命小红帽",
    "mapNodeName_39": "微光之森",
    "messageInitNick_7803": "臭鸭蛋",
    "messageInitNick_7802": "土豆炒马铃薯",
    "messageInitNick_7805": "吃瓜公主",
    "messageInitNick_7804": "六十岁了",
    "messageInitContent_7": "上面那位是不是傻，是你回家。",
    "messageInitContent_8": "又是你……叉！",
    "messageInitContent_5": "上次玩的时候还没女朋友，现在孩子2岁了…",
    "messageInitContent_6": "起源之地恭贺超2回家！",
    "messageInitContent_9": "攻略坛说后面暴走旷野可以自己组装怪兽？我来组成头部！",
    "messageInitContent_3": "哈哈哈哈，叉叉你现在可以进化了吗？",
    "messageInitContent_4": "怎么还龅牙了- -？！",
    "messageInitContent_1": "超进化大陆！！我回来了！",
    "messageInitContent_2": "笑死个人，叉啊叉，你怎么变成这样了！",
    "messageInitContent_5474": "什么超重舞者",
    "systemTaskConfigSender_26": "系统",
    "messageInitContent_5473": "我已经看到了重装踩着盾在滑浪",
    "messageInitNick_5610": "天堂传送门",
    "systemTaskConfigSender_27": "超进化委员会",
    "messageInitContent_5476": "发现小小鸟",
    "messageInitNick_5611": "我瘦不了了",
    "systemTaskConfigSender_28": "系统",
    "messageInitContent_5475": "发现小小草",
    "messageInitNick_5612": "高智商寿司",
    "systemTaskConfigSender_29": "月夕",
    "messageInitContent_5478": "这么玩是吧",
    "messageInitContent_5477": "不要在敲重装的头了",
    "messageInitContent_5479": "你们在说什么",
    "messageInitNick_5617": "豆瓣菜先锋",
    "messageInitNick_5618": "爱拼就能赢",
    "messageInitNick_5619": "流浪的上颌骨",
    "systemTaskConfigSender_20": "系统",
    "systemTaskConfigSender_21": "系统",
    "messageInitContent_5470": "big胆",
    "messageInitNick_5613": "按时变身",
    "systemTaskConfigSender_22": "系统",
    "messageInitNick_5614": "看不见色",
    "systemTaskConfigSender_23": "系统",
    "messageInitContent_5472": "守护甜食",
    "messageInitNick_5615": "有点边界感",
    "systemTaskConfigSender_24": "谜之生物",
    "messageInitContent_5471": "建议跳槽来这边",
    "messageInitNick_5616": "豆角撞地球",
    "systemTaskConfigSender_25": "系统",
    "10_comment": "斗技场, 对战记录界面",
    "messageInitContent_5485": "看我拯救御空",
    "systemTaskConfigSender_15": "斗技场主管稻草人",
    "messageInitContent_5484": "香",
    "systemTaskConfigSender_16": "路过的热心怪兽",
    "messageInitContent_5487": "兄弟不要啊啊啊",
    "messageInitNick_5600": "我想吃鱼了",
    "systemTaskConfigSender_17": "未知",
    "messageInitContent_5486": "我来啦",
    "messageInitNick_5601": "萝卜焖饭",
    "systemTaskConfigSender_18": "部落之王{firstTribeName}",
    "messageInitContent_5489": "略略略蕾蕾",
    "systemTaskConfigSender_19": "系统",
    "messageInitContent_5488": "大大滴什么",
    "messageInitNick_5606": "随身携带空调",
    "messageInitNick_5607": "编程魔法使",
    "messageInitNick_5608": "保命秘籍",
    "messageInitNick_5609": "镜子毁灭者",
    "systemTaskConfigSender_10": "世界",
    "messageInitContent_5481": "又是你薛定谔，棒棒糖在后面",
    "messageInitNick_5602": "吃瓜之神",
    "messageInitContent_5480": "不能呼吸？",
    "messageInitNick_5603": "剧院魔法师",
    "messageInitContent_5483": "兄弟你好",
    "messageInitNick_5604": "万能夹克",
    "messageInitContent_5482": "打印我不要做",
    "messageInitNick_5605": "犀利就是叼",
    "5_2083": "挑战",
    "5_2082": "点击卸下",
    "5_2081": "{1}的复制体",
    "5_2080": "压制词缀",
    "5_2087": "探索者",
    "5_2086": "击破",
    "5_2085": "击破数",
    "5_2084": "准备释放",
    "5_2089": "获得奖励",
    "5_2088": "获得怪兽经验",
    "messageInitContent_5496": "big胆啊",
    "messageInitContent_5495": "龙王在此",
    "messageInitContent_5498": "均衡存乎万物之间",
    "messageInitContent_5497": "哪个群的群友？",
    "messageInitContent_5499": "沙煲甘大个拳头",
    "messageInitContent_5490": "还行",
    "5_2090": "数据",
    "messageInitContent_5492": "晚安大小姐",
    "messageInitContent_5491": "前排出售缩小喷雾",
    "messageInitContent_5494": "龙重出场",
    "messageInitContent_5493": "点菜谢谢",
    "5_2094": "本场击破数",
    "randomEventDialogueGroupConfig_3.6": "-",
    "randomEventDialogueGroupConfig_3.7": "-",
    "randomEventDialogueGroupConfig_3.4": "无视它离开",
    "5_2091": "试战模式无法获得奖励，获得该怪兽后可正式挑战领域副本",
    "randomEventDialogueGroupConfig_3.5": "-",
    "5_2098": "尝试调整阵容后重新挑战",
    "randomEventDialogueGroupConfig_3.2": "拿掉堵嘴，问它被绑的缘由",
    "5_2097": "点赞数",
    "randomEventDialogueGroupConfig_3.3": "拿掉堵嘴解开树藤，跟它说你自由了",
    "5_2096": "防御值",
    "5_2095": "本场金币奖励",
    "randomEventDialogueGroupConfig_3.1": "你看见了一个神秘商人，它的嘴被堵住了，还被十几圈粗壮的树藤捆在路边，正在不停扭动挣扎着。",
    "randomEventDialogueGroupConfig_3.8": "-",
    "randomEventDialogueGroupConfig_3.9": "-",
    "5_2061": "结算信息",
    "5_2060": "红色方胜利",
    "5_2065": "承受伤害",
    "5_2064": "输出伤害",
    "5_2063": "治疗",
    "systemTaskConfigSender_60": "源初境之神",
    "5_2062": "输出",
    "systemTaskConfigSender_61": "源初境竞猜中心",
    "5_2069": "神灵",
    "5_2068": "击退距离",
    "5_2067": "存活时间",
    "5_2066": "治疗量",
    "systemTaskConfigSender_62": "源初境竞猜中心",
    "systemTaskConfigSender_63": "系统",
    "systemTaskConfigSender_64": "系统",
    "systemTaskConfigSender_65": "荧灵",
    "systemTaskConfigSender_66": "系统",
    "systemTaskConfigSender_67": "系统",
    "5_2072": "探索者等级提升",
    "5_2071": "段位提升！",
    "5_2070": "全场最佳",
    "5_2076": "瞬破",
    "5_2075": "达到{1}级解锁",
    "5_2074": "怪兽等级上限",
    "5_2073": "探索者等级",
    "systemTaskConfigSender_50": "系统",
    "5_2079": "优先占领",
    "5_2078": "部落战队伍",
    "5_2077": "瞬破敌方",
    "systemTaskConfigSender_59": "源初境之神",
    "systemTaskConfigSender_51": "系统",
    "systemTaskConfigSender_52": "进击的怪兽",
    "systemTaskConfigSender_53": "进击的怪兽",
    "systemTaskConfigSender_54": "源初境之神",
    "systemTaskConfigSender_55": "源初境之神",
    "systemTaskConfigSender_56": "源初境之神",
    "systemTaskConfigSender_57": "源初境之神",
    "systemTaskConfigSender_58": "源初境之神",
    "5_2043": "探索者 等级 {1}",
    "5_2042": "队伍{1}",
    "5_2041": "没上阵神灵",
    "5_2040": "更换神灵",
    "5_2047": "再虐一遍",
    "5_2046": "信息",
    "5_2045": "保存录像",
    "5_2044": "EXP+ {1}",
    "5_2049": "获得奖励",
    "5_2048": "退出",
    "systemTaskConfigSender_48": "部落之魂",
    "systemTaskConfigSender_49": "部落之魂",
    "systemTaskConfigSender_40": "部落之魂",
    "systemTaskConfigSender_41": "部落之魂",
    "systemTaskConfigSender_42": "创世竞猜中心",
    "systemTaskConfigSender_43": "创世竞猜中心",
    "systemTaskConfigSender_44": "超进化委员会",
    "systemTaskConfigSender_45": "系统",
    "systemTaskConfigSender_46": "谜之生物",
    "systemTaskConfigSender_47": "迷路的谜之生物",
    "5_2050": "通过下列方式提高战力",
    "5_2054": "神灵升级",
    "5_2053": "元核升级",
    "5_2052": "黑暗森林",
    "5_2051": "怪兽培育",
    "5_2058": "点赞数",
    "5_2057": "起源殿积分",
    "5_2056": "斗技场积分",
    "5_2055": "阵容调整",
    "5_2059": "蓝色方胜利",
    "systemTaskConfigSender_38": "超进化委员会",
    "systemTaskConfigSender_39": "系统",
    "systemTaskConfigSender_30": "月夕",
    "systemTaskConfigSender_31": "超进化委员会",
    "systemTaskConfigSender_32": "超进化委员会",
    "systemTaskConfigSender_33": "系统",
    "systemTaskConfigSender_34": "世界",
    "systemTaskConfigSender_35": "系统",
    "systemTaskConfigSender_36": "世界",
    "5_2021": "怪兽信息",
    "5_2020": "开启",
    "5_2025": "未拥有该怪兽",
    "5_2024": "排阵",
    "5_2023": "元核",
    "5_2022": "属性",
    "5_2029": "首通奖励",
    "5_2028": "对战",
    "5_2027": "斗技场挑战",
    "5_2026": "战力",
    "5_2032": "好友",
    "5_2031": "援军",
    "5_2030": "可上阵",
    "5_2036": "释放2次",
    "5_2035": "释放1次",
    "5_2034": "不触发",
    "5_2033": "神灵序列",
    "5_2039": "下阵",
    "5_2038": "循环",
    "5_2037": "释放3次",
    "messageInitContent_5401": "想你了",
    "messageInitContent_5400": "风儿有点喧嚣",
    "messageInitContent_5403": "不可以",
    "messageInitContent_5402": "emmmm",
    "5_2003": "敌方词缀",
    "messageInitContent_5405": "奇怪实验品",
    "5_2002": "已方词缀",
    "messageInitContent_5404": "达咩哒哟",
    "5_2001": "压制词缀",
    "messageInitContent_5407": "有点可爱",
    "messageInitContent_5406": "越大越伤心",
    "5_2007": "剩余{1}",
    "messageInitContent_5409": "推推推",
    "5_2006": "战力",
    "messageInitContent_5408": "冲冲冲",
    "5_2005": "限定效果",
    "5_2004": "场地效果",
    "23_2004": "F的记忆",
    "5_2009": "留言",
    "messageInitContent_5410": "收为坐骑",
    "5_2008": "敌方阵容",
    "messageInitContent_5412": "第一时间看看血量",
    "messageInitContent_5411": "差点以为它要献祭",
    "messageInitContent_5414": "哪个巨创",
    "messageInitContent_5413": "芜湖",
    "5_2010": "可获得奖励",
    "98_-11": "非法操作",
    "messageInitContent_5416": "阔爱",
    "5_2013": "危险！",
    "98_-10": "奖励解析出错",
    "messageInitContent_5415": "不够八卦",
    "5_2012": "前往挑战",
    "98_-13": "战斗翻船了，请重新挑战",
    "messageInitContent_5418": "我已看透一切",
    "5_2011": "剩余次数：{1}/{2}",
    "98_-12": "战斗翻船，请重新挑战",
    "messageInitContent_5417": "阅",
    "5_2018": "逃跑",
    "5_2017": "友",
    "messageInitContent_5419": "别推开我",
    "5_2016": "剩余奖励：{1}/{2}",
    "98_-19": "AKKA请求超时",
    "98_-18": "亲爱的探索者，服务器正在维护中，给您带来不便非常抱歉！(、･ω･)、",
    "messageInitContent_5421": "体力不错",
    "5_2019": "屏蔽",
    "messageInitContent_5420": "让我抱抱",
    "98_-15": "系统正在研读配置，请稍后再试",
    "messageInitContent_5423": "早呀",
    "98_-14": "请求已处理",
    "messageInitContent_5422": "我不好吃",
    "98_-17": "服务器人数超过上限暂停注册，探索者你们太热情啦！ヾ(≧▽≦*)o",
    "messageInitContent_5425": "巧了",
    "98_-16": "账号登录异常，请重新登录",
    "messageInitContent_5424": "哥哥带带我我贼强",
    "messageInitContent_5427": "有了吧",
    "messageInitContent_5426": "看起来更胖了",
    "messageInitContent_5429": "小心火烛",
    "messageInitContent_5428": "红红火火",
    "messageInitContent_5430": "就……",
    "messageInitContent_5432": "？？？？？",
    "messageInitContent_5431": "球比山大，我说隔壁",
    "messageInitContent_5434": "溯一也是内八",
    "messageInitContent_5433": "标志性内八",
    "messageInitContent_5436": "是7777777777",
    "messageInitContent_5435": "想念像是呼吸的痛",
    "messageInitContent_5438": "蹲个草先",
    "messageInitContent_5437": "7的意志在这里",
    "messageInitContent_5439": "像一颗海草海草",
    "messageInitContent_5441": "你两怎么在一对",
    "messageInitContent_5440": "草",
    "messageInitContent_5443": "枯萎了",
    "messageInitContent_5442": "快过来",
    "messageInitContent_5445": "快枯了",
    "messageInitContent_5444": "别搞",
    "messageInitContent_5447": "咻咻潜入成功",
    "messageInitContent_5446": "萎了",
    "messageInitContent_5449": "下巴整回来了",
    "messageInitContent_5448": "咻咻怎么还没变大",
    "messageInitContent_5452": "你怎么一个人",
    "messageInitContent_5451": "不要下雨了！",
    "messageInitContent_5454": "不如我找给怪陪陪你",
    "messageInitContent_5453": "你怎么一个怪",
    "messageInitContent_5456": "一个人发呆",
    "messageInitContent_5455": "不许emo",
    "messageInitContent_5458": "为什么会这样",
    "messageInitContent_5457": "一个人战斗",
    "messageInitContent_5450": "你们都是我的翅膀",
    "messageInitContent_5459": "向大佬低头",
    "messageInitContent_5463": "什么归来",
    "messageInitContent_5462": "别唱了~",
    "messageInitContent_5465": "摁摁jio",
    "messageInitContent_5464": "是不是写少了几个词",
    "messageInitContent_5467": "晚安探索者",
    "messageInitContent_5466": "下关见啦",
    "messageInitContent_5469": "听我说谢谢你",
    "messageInitContent_5468": "点下面的品质就可以了",
    "messageInitContent_5461": "过过过过过过",
    "messageInitContent_5460": "不敢吱声",
    "themeCardPackStoryId_140": "EF-004",
    "themeCardPackStoryId_145": "EF-005",
    "themeCardPackStoryId_150": "EF-006",
    "themeCardPackStoryId_155": "EF-007",
    "themeCardPackStoryId_160": "EF-008",
    "themeCardPackStoryId_165": "JS-001",
    "themeCardPackStoryId_170": "JS-002",
    "themeCardPackStoryId_175": "JS-003",
    "propConfigDes_40262": "是连阳光、微风、雨露都止不住感叹的可爱。「用于生草头像框解锁」",
    "propConfigDes_40263": "左边的翅膀拥抱你，右边的翅膀追逐你，拥抱你，追逐你，我的灵感女神啊，请再打我一次！\\n「用于灵感双翼头像框解锁」",
    "propConfigDes_40264": "看到斗笠就想起了斗笠的主人，那么它就是个出彩的斗笠，即便只有黑色。\\n「用于出彩的斗笠头像框解锁」",
    "propConfigDes_40265": "登峰者众，登峰者寡。\\n「用于登峰头像框解锁」",
    "themeCardPackStoryId_180": "JS-004",
    "propConfigDes_40266": "缘分天注定，幸福靠自己！换上桃花头像框，发送消息，如“一起来玩超进化物语2吧！”到心意对象的对话框，开启一段新对话吧！万一ta真的来到超进化物语2，看到这段描述呢，万一呢？\\n「用于桃花头像框解锁」",
    "propConfigDes_40267": "在模拟自然光过程中意外诞生的美丽流荧，用了就是地图上最亮的崽！\\n「用于霓虹要素头像框解锁」",
    "propConfigDes_40268": "若偶遇锣鼓喧天，醒狮跃动，不妨稍作停留，细品个中形意。\\n「用于醒狮头像框解锁」",
    "themeCardPackStoryId_185": "JS-005",
    "propConfigDes_40269": "装饰又怎么可能有致幻的效果，当然得看是装在谁身上。\\n「用于致幻要素头像框解锁」",
    "98_-21": "当前登录失效，请重新登录",
    "98_-24": "抱歉，该功能暂时关闭使用",
    "98_-23": "输入内容含有敏感信息或特殊字符，请重新输入",
    "98_-20": "同步配置表",
    "98_-29": "跨服信息暂无法查看",
    "98_-27": "可注册人数到达上限",
    "propConfigDes_40270": "不想做开关的齿轮不是一个好头像。\\n「用于开关齿轮头像框解锁」",
    "propConfigDes_40271": "常青藤有三好：好养活、好绿、不含任何排名！\\n「用于常青藤头像框解锁」",
    "propConfigDes_40272": "庆典开场，好礼绝不缺席。\\n「用于庆礼头像框解锁」",
    "97_desc26": "1.联结共鸣最多由5位探索者组成，联结后可看到其他联结者的异象，帮助其他联结者击破复制体或与智者交流可获得友好点数，被帮助者如常获得对应奖励\\n2.共鸣大厅可设置状态、查看联结信息、发送和接受联结邀请，设置生活自理状态后，将无法获得其他联结者的帮助，尚未加入联结共鸣的探索者可在联结大厅申请加入，已加入联结共鸣的探索者可邀请好友或发送邀请信息到世界频道，邀请其他探索者加入\\n3.管理员连续3天不上线，3天内有上线的联结者会自动成为管理员，如果没有符合条件的联结者则管理员不变\\n4.共鸣试炼有多个阶段，每个阶段有多个难度，选择一个难度通关后即可完成该阶段的挑战，可得到对应的共鸣评级，每个阶段的最高难度可通过为敌人添加词缀获得更高的共鸣评级\\n5.联结共鸣内的每一位联结者的共鸣评级相互独立，可设置最多3只怪兽作为助战怪兽\\n6.共鸣试练挑战中，在某个阶段已上阵怪兽不能在其他阶段再次上阵挑战，可以选择使用联结者的助战怪兽进行排阵挑战，每个阶段只能上阵1只联结者的助战怪兽\\n7.共鸣试练可消耗体力无限重复挑战，使用结算功能可对当前共鸣评级进行结算，若当前共鸣评级获得新高，则会刷新最高共鸣评级，根据最高共鸣评级，可领取对应的共鸣成就奖励，并获得对应的星律产出增加",
    "propConfigDes_40273": "喏，气球、彩旗，还有小星星~一起为你的头像装点欢乐吧！\\n「用于游园会头像框解锁」",
    "propConfigDes_40274": "这是由不断胜利堆叠而成的鎏金印记，总是更胜一筹，总是。这印记极具份量，它是下次胜利的筹码，也是下次胜利的重负。但你很清楚重点从来都不是胜利带来了什么，而是你带来了胜利。\\n「用于源初境冠军头像框解锁」",
    "97_desc24": "1.起源盘有多种品质，同品质有高重和低重两个版本，蓝（3或4重）/紫（4或5重）/橙（5或6重）/红（5或7重），装嵌的起源盘重量之和不可超过起源核心负重，探索者等级提升时，会解锁新插槽和增加负重\\n2.起源盘最多可拥有2个效果，同名效果不可叠加，仅较高级的效果生效，可消耗纬织源进行效果重置，重置后可自由选择是否使用新效果，重量和效果数保持不变\\n3.分解起源盘可获得起源片，消耗2个相同品质的起源盘和起源片可进行合成，合成会重新随机效果/效果数/重量\\n4.核心超频可使装嵌的起源盘在特定时长内提升效果，重复超频可增加时长\\n5. 每装嵌1个红色品质的起源盘，所有起源基石的数值加成均会获得提升\\n6.起源盘效果列表如下：",
    "propConfigDes_40275": "这是由一次次胜利叠加而成的白金印记，极具份量，它是下次胜利的筹码，也是下次胜利的重负。但你很清楚重点从来都不是胜利带来了什么，而是你带来了胜利。\\n「用于源初境亚军头像框解锁」",
    "97_desc25": "1.每月起源殿结算后开启新一赛季源初境对战周，战区内起源殿积分前64名的探索者将获得源初境参赛资格，参赛的探索者将根据对阵表进行对决，周二决出32强，周三决出16强，周四决出8强，周5决出4强，周6决出2强，周日决出冠亚\\n2.源初境对战和起源殿对战并行，互不影响，均使用相同的平衡机制\\n3.进入对战周后，拥有源初境参赛资格的探索者可在周一23:59前，对源初境对战阵容进行预设，23:59后本赛季的对战阵容将完成固化，并无法再次变更\\n4.对战周的周二至周日每日22:00，参赛探索者根据对阵表进行对战，对战为预设阵容强制自动战斗，战斗结算后将更新下一阶段的对阵表\\n5.对战周的周二至周日每日21:00前，探索者可参与竞猜进行投注，预测源初境对战获胜者，每日将给予1次竞猜机会，上限1次，每次竞猜正确可根据结果和最终支持率获得对应的箔材，最终支持率越低可获得的箔材越多，上限为1000，竞猜错误不会获得箔材，箔材可在源初境商店中购买商品\\n6.每周日决出冠亚后，前8名探索者进入该赛季源初境的名人堂，奖励将在冠亚战斗结算后通过邮件发放\\n7.由于存在版本迭代更替，录像版本与查看录像时的版本不同等情况，战斗胜负以决出结果时的显示为准，录像不作为胜负判断依据，仅供查看",
    "propConfigDes_40276": "这是由数次胜利叠放而成的赤铜印记，极具份量，它是下次胜利的筹码，也是下次胜利的重负。但你很清楚重点从来都不是胜利带来了什么，而是你带来了胜利。\\n「用于源初境四强头像框解锁」",
    "97_desc22": "1.消耗浮空羽毛可挑战浮空巨塔，无论胜败都会消耗浮空羽毛，浮空羽毛随时间回复\\n2.每通关5关浮空巨塔后开启1关塔中秘庭\\n3.挑战塔中秘庭不需要消耗浮空羽毛\\n4.浮空巨塔和塔中秘庭的奖励均为首通奖励\\n5.不同的浮空巨塔和塔中秘庭有对应的种族准入限制，只能使用准入种族的怪兽进行挑战",
    "propConfigDes_40277": "这是深入源初境的橙红印记，它绝不是一个永恒的印记，随时等待被你改写。\\n「用于源初境八强头像框解锁」",
    "97_desc23": "1.同1只怪兽只能上阵1支部队\\n2.同1个元核只能给1支部队的怪兽装备\\n3.部队中的怪兽在遗迹战斗中死亡会进入濒死状态，无法更换和出战\\n4.部队中存在濒死怪兽时无法继续上阵其他怪兽\\n5.濒死的怪兽一段时间后会自动脱离濒死状态\\n6.神灵可同时上阵多支部队，毕竟祂们是神灵",
    "propConfigDes_40278": "这是突入源初境的印记，它绝不是一个永恒的印记，随时等待被你改写。\\n「用于源初境十六强头像框解锁」",
    "97_desc20": "1.攻击力、体力、速度、霸气属性每次极化随机范围为-20%~+20%\\n2.每次极化后最多出现6个极化能力，极化能力有不同的品质，品质越高属性越高，极化能力不可清除和封印\\n3.消耗极化石可以锁定极化能力，锁定后的极化能力在下次极化后必定会出现\\n4.极化后可以自主选择保留新或旧的属性和极化能力，极化能力列表如下：",
    "propConfigDes_40279": "这是闯入源初境的印记，它绝不是一个永恒的印记，它随时等待被你改写。\\n「用于源初境三十二强头像框解锁」",
    "97_desc21": "1.世界占领关卡，肉肉山和金矿山均能增加星律对应资源的挂机产出\\n2.骨、木、鳞场的建筑等级越高，星律对应资源的挂机产出越高\\n3.探索者经验需要到达一定等级后才会解锁挂机产出\\n4.星律每小时（无论是否在线）均会自动产出一次资源，需手动收获，产出的资源到达上限后（小时），不会继续自动产出资源，提升世界回响等级可以提升上限",
    "themeCardPackStoryId_195": "JS-007",
    "98_-33": "无法进入该服务器，请向客服详询",
    "98_-32": "服务器在线人数到达上限，请稍后再试，探索者你们太热情啦！\\\\(≧▽≦*)o",
    "themeCardPackStoryId_190": "JS-006",
    "98_-31": "登录超时，请重新登录",
    "98_-30": "跨区信息暂无法查看",
    "propConfigDes_40280": "这是闯入源初境的印记，它绝不是一个永恒的印记，随时等待被你改写。\\n「用于源初境六十四强头像框解锁」",
    "propConfigDes_40281": "「用于老玩家头像框解锁」",
    "propConfigDes_40282": "拥抱热浪前，记得用尾巴试试水温哦！\\n「用于热浪抱拥头像框解锁」",
    "propConfigDes_40283": "如果你的头像不会游泳，那就对了！试试这款游泳技能+10的头像框吧！\\n「用于浮游鸭泡头像框解锁」",
    "97_desc15": "1.起源殿每日20:00至22:00开启\\n2.起源殿战斗会把怪兽等级、怪兽技能等级、元核等级、元核品质、黑暗森林能力、战墙加固等级等相关项提升至一定水平（可超出但不会低于）\\n3.起源殿每周结算1次（周一00:10），按照探索者所在段位给予奖励（起源勋章），每周最少战斗1次才会给予奖励\\n4.起源殿每月首个周一重置，重置时的积分越高，重置后的初始积分越高",
    "propConfigDes_40284": "月色真美。因而驻足，因而启程。\\n「用于月色头像框解锁」",
    "97_desc16": "1.战墙有两种类型，位于己方一侧或敌方一侧，可以选择启动其中一种\\n2.每个战纹上下左右四个方向均有可能出现连接轴\\n3.战纹需通过连接轴连接点亮的起始点（左侧）或点亮的战纹才会生效\\n4.大型战纹连接轴方向固定\\n5.同一种战墙类型只能激活一种战墙武装，战墙武装激活后，战墙外观改变并获得对应的战墙武装效果\\n6.战墙武装需逐一解锁，前一种战墙武装解锁后才可以解锁下一种战墙武装，解锁战墙武装可获得解锁增益，无需激活解锁即可生效，解锁的战墙武装越多，可以获得的增益加成越多\\n7.拥有2个或以上的等级10战墙武装时根据共鸣等级怪兽可获得对应的增益加成\\n8.战墙武装效果属于不可清除，不可封印的增益/负面效果",
    "propConfigDes_40285": "跨越遥远时空的星芒终将落入谁的眼眸。\\n「用于星芒头像框解锁」",
    "97_desc13": "1.每个领地的斗技场互相独立，斗技场每日结算时，第一名的探索者会成为斗技场之主，处于同一斗技场的其他探索者在挑战异象战败时，有概率受到斗技场之主的帮助\\n2.搬迁领地后斗技场积分会有扣减\\n3.随着探索者实力的提升，开启战争号角所需要消耗的资源也会提升\\n4.斗技场1600分段以下会出现机器人，但不一定比西部世界的接待员弱（乱入\\n5.记得设置斗技场的防守队伍，不要摆空城计\\n6.斗技场每日挑战同一探索者到达一定次数后将无法再次挑战或刷出该探索者\\n7.斗技场每日结算奖励，每周重置，重置后挑战一次即可进入斗技场排行榜",
    "propConfigDes_40286": "海中之影正渐渐变浓……\\n「用于绀青之影头像框解锁」",
    "97_desc14": "1.选择队友然后相信他们\\n2.凿星裂痕组队战斗会获得五位一体效果，所有己方怪兽的攻击力和体力均会提升\\n3.凿星裂痕神灵队列、起源核心和战墙均使用队长的配置，战斗时队长可手动释放神灵\\n4.队长勾选重复挑战后，上阵怪兽数量等于5时会自动开始挑战副本\\n5.勾选自动开启宝箱后，战斗结束时会自动消耗凿星钥匙开启宝箱\\n6.凿星裂痕会根据副本进度排名，通关副本相同则比较通关时长，通关时长相同则比较创造记录的时间\\n7.凿星裂痕每月首个周一结算奖励和重置\\n8.与其他探索者组队多人挑战可获得友好点数\\n9.使用匹配房间功能可以快速进入符合条件的房间",
    "propConfigDes_40287": "珊瑚摇曳，水藻凝结，深海如昼。\\n「用于诡海一隅头像框解锁」",
    "97_desc11": "1.永生之茧分为【一次性茧】和【可重复挑战茧】\\n2.一次性茧只有一个难度，可以使用好友的助战怪兽进行配队挑战，只有首次通关时获得奖励，一次性茧总数量有限，全部通关后不会继续刷新，可以点击中心的巨茧查看通关记录\\n3.永生之茧每日自动刷新一次性茧，也可以使用魔典马上刷新\\n4.可重复挑战茧有多个难度，每次挑战均可获得奖励\\n可重复挑战的关卡：\\n“经验”——怪兽经验\\n“富有”——金币\\n进化试练——进化孢子\\n全体强化——强化孢子\\n神性集合——神性孢子\\n一地原石——原石\\n捕兽大师——捕兽夹\\n极化之地——极化石\\n墙战——战纹\\n造唤梦境——造唤许可",
    "propConfigDes_40288": "森林派对的邀请函猝然扭动变形，纤细的前爪从中伸展而出，还在等什么？赶紧跟上吧！黑猫转头跃入魔森。——可动书 序章\\n「用于魔森序章头像框解锁」",
    "97_desc12": "1.黑暗森林信息界面可查看该森林的资源分布占比\\n2.每片黑暗森林都会有一颗终焉之果，内含较多种类的资源\\n3.击破黑暗森林中的凶兽会获得漆黑源，可在漆黑之根中自由加点增强怪兽的能力\\n4.在黑暗森林界面摇一摇或点击一键收取可收取所有已探索的资源，且不会把树摇断\\n5.黑暗森林生成90日后将自动重置，手动重置或自动重置前记得一键收取所有已探索的资源，避免重置后无法收取对应资源",
    "propConfigDes_40289": "恶鬼和小幽灵们既害怕又期待！到底要去哪个区域捣乱呢。分区帽即将为它们揭晓答案！\\n「用于分区帽头像框解锁」",
    "97_desc10": "1.起源基石提供的增益效果会在所有玩法（除古记战役）中生效\\n2.起源基石提供的增益与放入怪兽的等级、基因强化等级、技能等级、极化、超进化有关\\n3.双种族的怪兽可以受到两个基石的增益影响，但增益值只有一半\\n4.远古族基石和原生族基石对双种族怪兽只生效一次",
    "97_desc19": "1.将怪兽饲星（含怪兽作为进化材料）可获得该怪兽100%的经验值，强化孢子，基因强化消耗的金币和根据怪兽品质获得饲星之魂，觉醒品质怪兽，远古族怪兽，原生怪兽不能饲星\\n2.怪兽重置可获得该怪兽技能等级对应数量的怪兽碎片，100%的怪兽经验，强化孢子和基因强化消耗的金币，重置后怪兽等级，技能等级，基因强化重置为初始状态，极化，性格和超进化技不会重置\\n3.碎片转化可将任意觉醒怪兽的碎片1:1转化为万能碎片，每次转化30块\\n4.处于濒死状态的怪兽无法进行饲星\\n5.进化光谱可通过饲星获得饲星之魂",
    "97_desc17": "1.暴走旷野到达一定击破数后，可在谜宝中领取谜之物质升级谜之生物的古基因等级\\n2.谜之生物等级为其古基因等级总和（无需使用）\\n3.谜之生物为原生种族怪兽，享受相关的怪兽加成\\n4.暴走旷野击破数越高，获得的金币奖励越多，每日可无限次挑战，但每次挑战只可获得当日击破数增量部分对应的金币奖励\\n5.谜之生物后续会在更多玩法中登场\\n6.暴走旷野每日结算排名奖励，每日重置排名\\n7.暴走旷野最长战斗时间为10分钟，到达时间后自动结算",
    "97_desc18": "1.获得世界回响经验后会提升世界回响等级，世界回响等级越高，各种资源可储存的上限越高\\n2.遗落回响和F的触发方式比较多，智者也还在摸索中（养成了到处乱点的习惯）\\n3.嗒滴嗒嗒 嗒嗒嗒 滴滴嗒 滴嗒滴 滴滴滴嗒 嗒嗒嗒 滴滴 嗒滴嗒滴 滴（呜呜祖啦背锅）",
    "messageInitNick_5598": "专业潜水",
    "messageInitNick_5599": "抱抱甜南瓜",
    "messageInitNick_5594": "大声喊我爱你",
    "messageInitNick_5595": "三鲜焖饭",
    "messageInitNick_5596": "站台的女孩",
    "messageInitNick_5597": "他们这一家",
    "propConfigDes_40290": "在《超进化物语2》一周年这个特别的日子里，连彩带也学会了凹造型！\\n「用于星形彩带头像框解锁」",
    "propConfigDes_40291": "集齐各类快乐要素，庆祝《超进化物语2》一周年！\\n「用于一周年头像框解锁」",
    "propConfigDes_40292": "以血，以肉，敬力量。\\n「用于部落图标更换」",
    "propConfigDes_40293": "以日，以月，敬技艺。\\n「用于部落图标更换」",
    "propConfigDes_40294": "以歌，以舞，敬太阳。\\n「用于部落图标更换」",
    "propConfigDes_40295": "以礼，以乐，敬往昔 。\\n「用于部落图标更换」",
    "propConfigDes_40296": "以身，以心，敬自然 。\\n「用于部落图标更换」",
    "propConfigDes_40297": "以灵，以魂，敬永恒 。\\n「用于部落图标更换」",
    "propConfigDes_40298": "炙热的火之冠冕，将热度与烈度平等地赐予周遭的一切，它们都将无法停歇。\\n「用于创晓火冕形态解锁」",
    "propConfigDes_40299": "许愿是一个探索内心的过程，不管你想要的是什么，许愿卡都会记下你不同时期的答案。如果还没想好要写什么，写“世界和平”也是ok的！\\n「用于许愿五六七许愿」",
    "messageInitNick_5590": "告白的日子",
    "messageInitNick_5591": "酱牛肉拌饭",
    "messageInitNick_5592": "开始转动",
    "messageInitNick_5593": "爱的表演秀",
    "messageInitNick_5587": "哈密瓜去哪了",
    "messageInitNick_5588": "小宝贝晚安安",
    "messageInitNick_5589": "超时空平板",
    "messageInitContent_5500": "好的下一个",
    "messageInitNick_5583": "落墨成花",
    "messageInitNick_5584": "柿子之心",
    "messageInitContent_5502": "想发点小疯",
    "messageInitNick_5585": "别慌有姐姐在",
    "messageInitContent_5501": "哈基米哈基米",
    "messageInitNick_5586": "垫底睡魔",
    "randomEventDialogueGroupConfig_6.117": "我没事只是有点累，商店可以看看，记得付钱。",
    "randomEventDialogueGroupConfig_6.118": "啊天呐，我想我对你过敏。",
    "propConfigDes_40220": "契约头像框40220",
    "randomEventDialogueGroupConfig_6.115": "是哪里不对劲吗？",
    "propConfigDes_40221": "契约头像框40221",
    "randomEventDialogueGroupConfig_6.116": "嗯哼，当然是可以的亲~请欣赏~神秘的【A~WSL套餐】。",
    "propConfigDes_40222": "契约头像框40222",
    "propConfigDes_40223": "契约头像框40223",
    "propConfigDes_40224": "契约头像框40224",
    "randomEventDialogueGroupConfig_6.119": "原本只是两只触手奔跑的它，一下子换成了用十只触手一起狂奔，很快消失不见了。",
    "propConfigDes_40225": "契约头像框40225",
    "propConfigDes_40226": "契约头像框40226",
    "messageInitNick_5580": "失踪的老板",
    "propConfigDes_40227": "契约头像框40227",
    "messageInitNick_5581": "浮在空中的鱼",
    "propConfigDes_40228": "契约头像框40228",
    "messageInitNick_5582": "金色小刀",
    "propConfigDes_40229": "契约头像框40229",
    "messageInitNick_5576": "被烤的肉",
    "messageInitNick_5577": "舞林中之人",
    "messageInitNick_5578": "大师兄",
    "messageInitNick_5579": "麻木的微笑",
    "messageInitNick_5572": "单眼皮的鱼",
    "messageInitNick_5573": "萌出服务区",
    "messageInitNick_5574": "绝版好男人",
    "messageInitNick_5575": "天下第九",
    "randomEventDialogueGroupConfig_6.110": "不可以浪~费~食~物~哟——",
    "randomEventDialogueGroupConfig_6.113": "它挥动着触手向瘫软的你告别。",
    "randomEventDialogueGroupConfig_6.114": "挥手告别",
    "randomEventDialogueGroupConfig_6.111": "它满脸骄傲地说完，随后一张传单塞到你手上。",
    "randomEventDialogueGroupConfig_6.112": "离开",
    "randomEventDialogueGroupConfig_6.106": "表示跟推销员说不需要谢谢更累",
    "propConfigDes_40230": "契约头像框40230",
    "randomEventDialogueGroupConfig_6.107": "好吧，再见。",
    "propConfigDes_40231": "契约头像框40231",
    "randomEventDialogueGroupConfig_6.104": "告别",
    "propConfigDes_40232": "武夫手中的战刀是斩伐杀生的凶器。对刀马而言刀并没有那么多意义，好用就行。对知世郎而言他需要的不是刀，而是用刀的人。此外，刀用坏了还能向对手讹钱（不是）。\\n「用于兵也头像解锁」",
    "randomEventDialogueGroupConfig_6.105": "也考虑下推销员的苦劳嘛。",
    "propConfigDes_40233": "福到福到，福气多多，福事多多，福利多多！（咦，怎么混入了一个神奇的祝福）\\n「用于福到头像解锁」",
    "propConfigDes_40234": "引导的过程也是开拓全新道路的契机。被引导者或许会将你遗忘，但你所开拓的道路绝不会消失。\\n「用于引导者头像解锁」",
    "propConfigDes_40235": "示梦器某一时刻的图形，据说是根据怪兽酣睡时的微弱脑波读数而生成。\\n「用于示梦器头像解锁」",
    "randomEventDialogueGroupConfig_6.108": "告别",
    "propConfigDes_40236": "“开得灿烂，绝不摆烂！”说着花花给你比个大拇指！\\n「用于花花点赞头像解锁」",
    "randomEventDialogueGroupConfig_6.109": "富有弹性的肉质将你的牙齿包裹，同时逗弄着你的舌尖，微烫的热气冲开了你口腔中的每一个味蕾，仿佛有无数位仙女在上面跳极乐净土，你发现这实在是太好吃了！#你回过神的时候，发现它正搓着触手满脸笑容地问你。",
    "propConfigDes_40237": "在纪念日偶尔回望，感受探索超进化大陆这段时光的重量。在纪念日偶尔放纵，体会蛋糕为身体带来的重量。半周年快乐！\\n「用于半周年头像解锁」",
    "propConfigDes_40238": "鎏金般的锋芒与决意越过重重战火与层层锤炼抵达源初境之巅，以不灭之名再诞。\\n「用于源初境冠军头像解锁」",
    "messageInitNick_5570": "口红贩卖机",
    "propConfigDes_40239": "白金色的锋芒与决意越过重重战火与层层锤炼抵达源初境之巅，以不朽之名再诞。\\n「用于源初境亚军头像解锁」",
    "messageInitNick_5571": "到底行不行",
    "messageInitNick_5565": "七分惰性",
    "monsterTemperamentConfigName_3": "自信",
    "messageInitNick_5566": "科目三大师",
    "monsterTemperamentConfigName_2": "率直",
    "messageInitNick_5567": "爱上猪",
    "monsterTemperamentConfigName_5": "暴躁",
    "messageInitNick_5568": "柚子爱好者",
    "monsterTemperamentConfigName_4": "鲁莽",
    "messageInitNick_5561": "网址对网址",
    "messageInitNick_5562": "病娇美男",
    "messageInitNick_5563": "曾经有个梦想",
    "monsterTemperamentConfigName_1": "果断",
    "messageInitNick_5564": "杨桃消灭者",
    "messageInitNick_5569": "呆萌迷糊",
    "monsterTemperamentConfigName_7": "毅力",
    "randomEventDialogueGroupConfig_6.102": "表示感到被迫去买什么",
    "monsterTemperamentConfigName_6": "乐观",
    "randomEventDialogueGroupConfig_6.103": "好吧，再见。",
    "monsterTemperamentConfigName_9": "温柔",
    "randomEventDialogueGroupConfig_6.100": "你是为什么这么讨厌推销呢？",
    "monsterTemperamentConfigName_8": "冷静",
    "randomEventDialogueGroupConfig_6.101": "表示没有理由",
    "propConfigDes_40240": "赤铜色的锋芒与决意越过重重战火与层层锤炼抵达源初境之巅，以不动之名再诞。\\n「用于源初境四强头像解锁」",
    "propConfigDes_40241": "由重重战火炼就的决意将化作不可阻挡的锋芒，指向不远处的源初境之巅。\\n「用于源初境八强头像解锁」",
    "propConfigDes_40242": "由重重战火炼就的决意将化作耀眼的锋芒，指向不远处的源初境之巅。\\n「用于源初境十六强头像解锁」",
    "propConfigDes_40243": "由战火炼就的决意将化作新的锋芒，指向源初境之巅。\\n「用于源初境三十二强头像解锁」",
    "propConfigDes_40244": "由战火炼就的决意将化作锋芒，指向源初境之巅。\\n「用于源初境六十四强头像解锁」",
    "propConfigDes_40245": "「用于老玩家头像解锁」",
    "propConfigDes_40246": "大大大太阳的小小潜水梦~\\n「用于骄阳潜梦头像解锁」",
    "propConfigDes_40247": "不似光影交叠那般晦涩难懂，仅仅是一颗被不明星兽吞剩的遥远伴星。\\n「用于浩劫残月头像解锁」",
    "propConfigDes_40248": "在它面前，切莫妄想继续保持理性，因为只有彻底坠入疯狂才能得到片刻安宁与解脱。\\n「用于狞笑之藻头像解锁」",
    "propConfigDes_40249": "透过圆形的门镜，窥见来访的“客人”~\\n「用于南瓜开门头像解锁」",
    "messageInitNick_5560": "鱼与飞鸟",
    "messageInitNick_5554": "黑洞创造者",
    "messageInitNick_5555": "顶层设计",
    "messageInitNick_5556": "芦笋先锋",
    "messageInitNick_5557": "伊人若梦",
    "messageInitNick_5550": "炸鸡配莓子",
    "messageInitNick_5551": "十二点的拉肠",
    "messageInitNick_5552": "快排人守夜",
    "messageInitNick_5553": "自觉点赞",
    "messageInitNick_5558": "老柯基",
    "messageInitNick_5559": "薄情痞子",
    "propConfigDes_40250": "与《超进化物语2》共度的一年可以细分为很多瞬间，也可以浓缩为一种滋味，别只顾着回忆啦，蛋糕要被怪兽吃光了！总之，一周年快乐！\\n「用于一周年头像解锁」",
    "propConfigDes_40251": "红纸绘福，鸿运当头~\\n「用于鸿运当头像解锁」",
    "propConfigDes_40252": "永！不！泄！气！\\n「用于气氛组头像解锁」",
    "propConfigDes_40253": "头像界的中奖圣体，立即使用触发中奖几率UP的效果吧！\\n「用于粽奖头像解锁」",
    "propConfigDes_40254": "自眼前将视野抹去，自黑暗将感受收拢，自肉体将神色抽离，随后沉入万物之灵的抱拥。\\n「用于超越之面头像解锁」",
    "propConfigDes_40255": "就偶尔，不管不顾地兀自扑腾几下。\\n「用于蜡笔小蝶头像解锁」",
    "propConfigDes_40256": "据说每一个彩灯都有个登月的梦想，而放生彩灯的怪兽将借这份功德，积攒实现愿望的力量。此事在智者的《随便写写》上亦有记载。\\n「用于放生彩灯头像解锁」",
    "propConfigDes_40257": "落叶归根时的意外交叠，稍稍让归程变得不那么孤单。\\n「用于秋色偶叠头像解锁」",
    "propConfigDes_40258": "二周年！连蛋糕都叠上了2层Buff，看到的探索者都将获得双倍欧气Buff！毕竟，总不可能是某只怪兽在里头狂吃蛋糕叠到2层了吧~（还愣着干嘛，快去去看看啊啊！\\n「用于二周年头像解锁」",
    "propConfigDes_40259": "2.9签到战令头像",
    "messageInitNick_5543": "那份安静",
    "messageInitNick_5544": "抽风中请勿扰",
    "messageInitNick_5545": "百变小妖怪",
    "messageInitNick_5546": "闲云野鸭",
    "messageInitNick_5540": "茶楼淑女",
    "messageInitNick_5541": "人形仙人掌",
    "messageInitNick_5542": "掠时刻",
    "messageInitNick_5547": "毕竟回不了头",
    "messageInitNick_5548": "我谢谢你",
    "messageInitNick_5549": "至少不应该",
    "propConfigDes_40260": "3.0签到战令头像",
    "propConfigDes_40261": "3.1签到战令头像",
    "mainCityDes_5": "听说仓库的最低标准是“里头比外头大”。\\n听说大多数怪兽都不喜欢当仓库管理员。\\n听说仓库老大经常会不小心把没有上锁的重要物品吃了。\\n听说不是土豪不会升级仓库。\\n听说这些都是真的。\\n「升级可提高骨木鳞的储存上限」",
    "messageInitNick_5532": "你不在的风景",
    "mainCityDes_6": "探索营地由工具房、训练空地和茅坑三个区域组成。\\n工具房摆放着口粮、工具包和路线图等探索用具。\\n训练空地上，毫无干劲和跃跃欲试的家伙一眼就能区分开来。\\n茅坑就是那个……用来做心理准备的地方，在出发前来回好几十趟的，要不是新丁，就是……那啥不太行。\\n「升级可增加探索可指派怪兽的数量」",
    "messageInitNick_5533": "独孤求婚",
    "mainCityDes_7": "此处乃探求起源之地，在这里修炼的怪兽无需对抗外界的干扰，只需抵御内心的杂念即可。找准位置，闭目凝神，调匀呼吸，摈除杂念，保持察觉，浸入本源，探寻自我。\\n我是谁？我从哪里来？我又该到哪里去？还有待会吃啥好捏？\\n「升级可解锁起源基石位置」",
    "messageInitNick_5534": "青山灼灼",
    "mainCityDes_8": "匿名客：这里太棒了！货真价实，诚信经营，质量上乘，店名又好，感谢店长祝福，五星好评，下次还来！（置顶2赞2踩）\\n老主顾：楼上肯定是店长啦~（10赞1踩）\\n老顾客：许愿！希望TA的好感度也能对我可见。（233赞0踩）\\n新客户：治好了我的选择困难症！（5赞5踩）\\n「升级可缩短一发入欧店的免费刷新间隔」",
    "messageInitNick_5535": "发型不能乱",
    "mainCityDes_1": "在超进化大陆，并非每一块土地都有它的领主，但幸运的是，这里的每一位领主都会有属于他的领地。\\n领地管理千万条，安全第一条，也可以删掉第一条，随时写上第二三四五……条，或者再大胆点成为规则本身。\\n「升级可解除其他建筑的升级限制以及提高移动力上限」",
    "mainCityDes_2": "领地有了骨场就有了骨气！\\n骨场作为领地中最大的露骨区域，一般只允许心智成熟的怪兽进入。不过那些为了“锤炼自身”硬闯骨场的怪兽并不会受到阻拦，因为这些新鲜骨头很快就会为骨场的增产出一份力。\\n「升级可提高每小时的骨产量」",
    "mainCityDes_3": "注意！木场不许喷火，不能喷火，也不可以喷火！\\n这里木屑纷飞，木头的碰撞声和“木大木大木大”的叫喊声此起彼伏。一些负责加工木头的怪兽为了践行可连续发展的精神，经常跑到不远处的小河边摸鱼。\\n「升级可提高每小时的木产量」",
    "messageInitNick_5530": "外星人设计师",
    "mainCityDes_4": "这里有储藏和采集两大区域。沿着岩壁开凿的石架就是储藏区，里头各式各样的鳞片分门别类捆扎放好。中间的大片空地是采集区，偶尔会有龙族到这里抖掉身上即将掉落的鳞片，接受专业的鳞片护理服务。龙掉鳞和猫掉毛一样属于正常现象，因此春秋两季鳞场的产量都会猛涨。\\n「升级可提高每小时的鳞产量」",
    "messageInitNick_5531": "不想早起",
    "themeCardPackStoryId_100": "MG-004",
    "mainCityDes_9": "大老远就能听到，里头的战况有多么地激烈：\\n“救命啊！别打我——！”“来啊！你过来啊！”\\n靠近就会看到门口挂着一个大大的牌子，写着大大的“别跑！”。众所周知斗技场的对手都是不会跑的，所以这牌子是给谁看的！这分明就是挑衅。（又是一个小细节.jpg）\\n「升级可提升战争号角效果」",
    "messageInitNick_5536": "树莓消灭者",
    "messageInitNick_5537": "十二点的凉粉",
    "messageInitNick_5538": "白菜先锋",
    "themeCardPackStoryId_105": "MG-005",
    "messageInitNick_5539": "娃娃脸",
    "randomEventDialogueGroupConfig_4.5": "-",
    "randomEventDialogueGroupConfig_4.6": "-",
    "randomEventDialogueGroupConfig_4.3": "-",
    "randomEventDialogueGroupConfig_4.4": "-",
    "randomEventDialogueGroupConfig_4.1": "一个神秘商人一边蹦跶着一边向你走了过来。",
    "themeCardPackStoryId_110": "MG-006",
    "randomEventDialogueGroupConfig_4.2": "-",
    "messageInitNick_5521": "那个战士",
    "messageInitNick_5522": "疏雨梧桐",
    "messageInitNick_5523": "老夫不是魔鬼",
    "messageInitNick_5524": "拖油瓶",
    "messageInitNick_5520": "甜品大盗",
    "messageInitNick_5529": "蘑菇之心",
    "messageInitNick_5525": "别让我吃撑",
    "randomEventDialogueGroupConfig_4.9": "哈？幻幻的演唱会都可以不去的嘛？假丝，赶紧滚。",
    "messageInitNick_5526": "都忄圣我",
    "messageInitNick_5527": "柿子去哪了",
    "randomEventDialogueGroupConfig_4.7": "-",
    "messageInitNick_5528": "正常欧王",
    "randomEventDialogueGroupConfig_4.8": "来到检票口以后，你被拦了下来。",
    "themeCardPackStoryId_115": "MG-007",
    "propConfigDes_40200": "刀刃不断回旋的奥秘不仅在于力量的增强，还在于离心射出的致命红色尖刺。\\n「用于花环刃法头像框解锁」",
    "propConfigDes_40201": "装备后，只需要大喊“我下令，给我安静一点！”这个图形就会展翅从你的眼眸中飞出，让眼里的家伙变得安静一些~\\n「用于静谧侵袭头像框解锁」",
    "themeCardPackStoryId_120": "MG-008",
    "propConfigDes_40202": "遍历未来之后抵达的通道。\\n「用于金色通道头像框解锁」",
    "propConfigDes_40203": "威吓之势伏于所绘的次元，候机而出，万夫莫入。\\n「用于镇户獠牙头像框解锁」",
    "propConfigDes_40204": "再相似的开始，也能走出独特的结局。\\n「用于镜像开幕头像框解锁」",
    "propConfigDes_40205": "借鉴No.16的线条与配色，在特定国度贯彻绝对的支配之力。\\n「用于骰之支配头像框解锁」",
    "propConfigDes_40206": "激昂的战意跃上犄角，终凝为炽烈的火纹。\\n「用于火纹犄角头像框解锁」",
    "propConfigDes_40207": "对植物杀手宝具——绝对养不死的金属之花。\\n「用于永恒樱彩头像框解锁」",
    "propConfigDes_40208": "险些将太阳的工作抢走，比天堂的圣光还要夺目的超大量辉芒。\\n「用于超量辉芒头像框解锁」",
    "propConfigDes_40209": "仅是纳尽天地万物于怀的气势与贪婪。\\n「用于寰宇圣冠头像框解锁」",
    "messageInitNick_5510": "动物学奇才",
    "messageInitNick_5511": "别弄丢了自我",
    "messageInitNick_5512": "南柯一梦",
    "messageInitNick_5513": "明年放假",
    "messageInitNick_5518": "灯灯搓搓手",
    "themeCardPackStoryId_125": "EF-001",
    "messageInitNick_5519": "宿舍的狐狸",
    "messageInitNick_5514": "明亮的星空",
    "messageInitNick_5515": "前年结婚",
    "messageInitNick_5516": "小镇牛人",
    "messageInitNick_5517": "优秀毕业生",
    "randomEventDialogueGroupConfig_6.126": "这么巧我也会。嘿嘿，我可以改变自身颜色和周围的环境融为一体哦。啊不好说漏嘴了。你当没听到吧，再见。",
    "propConfigDes_40210": "为轮番袭来的危情，献上最热烈的抱拥。\\n「用于危情之拥头像框解锁」",
    "randomEventDialogueGroupConfig_6.127": "告别",
    "propConfigDes_40211": "星辰化作游鱼，挥动星鳍跃入黑洞，仅此绮丽一瞬。\\n「用于星徙奇谭头像框解锁」",
    "propConfigDes_40212": "池中之物偶然生起的翔天幻梦。\\n「用于翔天碧鳞头像框解锁」",
    "propConfigDes_40213": "竖起特制的天线，将呼吸、泪水以及思念送抵深海。\\n「用于深海电波头像框解锁」",
    "themeCardPackStoryId_130": "EF-002",
    "propConfigDes_40214": "能将持有者的悸动具象化的邪萌的小道具。\\n「用于悸动轨迹头像框解锁」",
    "propConfigDes_40215": "指向——心之所往。\\n「用于示位秘环头像框解锁」",
    "propConfigDes_40216": "闪耀的不只是光，还有藏匿其中的规律、对称与精密的美学。\\n「用于闪耀切面头像框解锁」",
    "propConfigDes_40217": "如果假装自己是一个金属机体，这个头像框正是答案。\\n「用于金属凝视头像框解锁」",
    "propConfigDes_40218": "契约头像框40218",
    "propConfigDes_40219": "契约头像框40219",
    "messageInitNick_5500": "蒜魔法师",
    "messageInitNick_5501": "与自己和解",
    "messageInitNick_5502": "藏起来的悲凉",
    "messageInitNick_5507": "流浪的杯盖",
    "randomEventDialogueGroupConfig_6.120": "离开",
    "messageInitNick_5508": "飞奔的台灯",
    "randomEventDialogueGroupConfig_6.121": "它突然在你眼前消失了。",
    "themeCardPackStoryId_135": "EF-003",
    "messageInitNick_5509": "持伞猫",
    "messageInitNick_5503": "无公害杨桃",
    "randomEventDialogueGroupConfig_6.124": "你什么都没有摸到。",
    "messageInitNick_5504": "藏点私房钱",
    "randomEventDialogueGroupConfig_6.125": "离开",
    "messageInitNick_5505": "键盘剑客",
    "randomEventDialogueGroupConfig_6.122": "四处摸索",
    "messageInitNick_5506": "高傲请继续",
    "randomEventConfigNPC_100": "神秘商人100",
    "randomEventDialogueGroupConfig_6.123": "赶紧离开",
    "messageInitContent_5595": "还以为是幼体赤练",
    "messageInitContent_5594": "不是这",
    "messageInitContent_5597": "我的小黑你怎么跑这层来了",
    "messageInitContent_5596": "溜溜被锤在地上抹茶",
    "messageInitContent_5599": "还行",
    "messageInitContent_5598": "迷路的漆黑组件",
    "messageInitContent_5591": "哈哈哈哈哈",
    "messageInitContent_5590": "行吧",
    "messageInitContent_5593": "大的大的",
    "messageInitContent_5592": "我要迪斯尼",
    "resoundEventConfigName_8003": "3.暴乱",
    "resoundEventConfigName_8002": "2.发起挑战",
    "resoundEventConfigName_8001": "1.彼岸",
    "mapNodeName_1691": "绯想天",
    "mapNodeName_1690": "齿轮沙箱",
    "resoundEventConfigName_8007": "7.恶作剧",
    "resoundEventConfigName_8006": "6.退路",
    "resoundEventConfigName_8005": "5.分歧",
    "resoundEventConfigName_8004": "4.两位首领",
    "resoundEventConfigName_8009": "9.未来计划",
    "resoundEventConfigName_8008": "8.预言书",
    "mapNodeName_1684": "怪物鬼屋",
    "mapNodeName_1683": "地下层与地龙",
    "mapNodeName_1682": "赤色警戒",
    "mapNodeName_1681": "永腐国度",
    "mapNodeName_1680": "塔防大炮",
    "mapNodeName_1689": "火神的妹妹",
    "mapNodeName_1688": "齿轮沙箱",
    "mapNodeName_1687": "齿轮沙箱",
    "mapNodeName_1686": "最终幻兽",
    "mapNodeName_1685": "齿轮沙箱",
    "mapNodeName_1673": "璃璃的宵夜",
    "mapNodeName_1672": "肉肉山",
    "mapNodeName_1671": "隐藏区域",
    "mapNodeName_1670": "炙热生还者",
    "mapNodeName_1679": "齿轮沙箱",
    "mapNodeName_1678": "马戏团",
    "mapNodeName_1677": "命运之绯",
    "mapNodeName_1676": "机动迷城",
    "mapNodeName_1675": "无尽模式",
    "mapNodeName_1674": "机动迷城",
    "activityTemplateName_1": "造唤盛宴",
    "activityTemplateName_2": "一箭五令",
    "activityTemplateName_9": "连环击破",
    "activityTemplateName_7": "开发者手札",
    "activityTemplateName_8": "位面构筑者选拔大赛",
    "activityTemplateName_5": "七日七发",
    "activityTemplateName_3": "签福迎春",
    "activityTemplateName_4": "每日一发",
    "mapNodeName_1619": "喀戎无敌",
    "mapNodeName_1618": "械玩奇域",
    "mapNodeName_1617": "肉肉山",
    "mapNodeName_1616": "三带二",
    "messageInitContent_5504": "剧透一下",
    "messageInitContent_5503": "赤潮淹没了赤虹",
    "messageInitContent_5506": "你怪呢",
    "messageInitContent_5505": "你脸呢",
    "messageInitContent_5508": "弱点更大了",
    "messageInitContent_5507": "好大",
    "messageInitContent_5509": "your aremy super星",
    "messageInitContent_5511": "玩球",
    "messageInitContent_5510": "小猫咪玩大球球",
    "messageInitContent_5513": "这是第几个巨星了",
    "messageInitContent_5512": "超级巨星当然是喵喵",
    "mapNodeName_1626": "金矿山",
    "mapNodeName_1625": "三星通关",
    "mapNodeName_1624": "极乐重生",
    "mapNodeName_1623": "尸狂公大战植物",
    "mapNodeName_1622": "怪兽争霸",
    "mapNodeName_1621": "捉蜻蜓龙",
    "mapNodeName_1620": "小王霸",
    "mapNodeName_1609": "几何幻境",
    "mapNodeName_1608": "包租公模拟器",
    "mapNodeName_1607": "齿轮沙箱",
    "mapNodeName_1606": "心态至高",
    "mapNodeName_1605": "齿轮沙箱",
    "messageInitContent_5515": "叉叉你还好吗",
    "messageInitContent_5514": "叉叉：？？？",
    "messageInitContent_5517": "消失的叉",
    "messageInitContent_5516": "同时是幼体和不朽的巨象",
    "messageInitContent_5519": "我大火神",
    "messageInitContent_5518": "阿这",
    "messageInitContent_5520": "suki",
    "messageInitContent_5522": "你妹妹呢",
    "messageInitContent_5521": "夸我谢谢",
    "messageInitContent_5524": "你超进化了吗",
    "messageInitContent_5523": "惊",
    "mapNodeName_1615": "洞见星空",
    "mapNodeName_1614": "械玩奇域",
    "mapNodeName_1613": "隐形守护",
    "mapNodeName_1612": "永生方块",
    "mapNodeName_1611": "地下迷宫",
    "mapNodeName_1610": "奇异信使",
    "messageInitContent_5526": "原来是这里的浮岛",
    "messageInitContent_5525": "你今天超进化了吗",
    "messageInitContent_5528": "哼哼哼",
    "messageInitContent_5527": "好耶",
    "messageInitContent_5529": "我今天就住在星的手里了",
    "messageInitContent_5531": "和星星做朋友",
    "messageInitContent_5530": "一晚多少",
    "messageInitContent_5533": "天",
    "messageInitContent_5532": "来自星星的你",
    "messageInitContent_5535": "你爪子！",
    "messageInitContent_5534": "放开我冰霓",
    "mapNodeName_1604": "守望怪兽",
    "mapNodeName_1603": "几何幻境",
    "mapNodeName_1602": "几何幻境",
    "mapNodeName_1601": "星际来客",
    "mapNodeName_1600": "旋转角兽",
    "messageInitContent_5537": "康康奖励",
    "messageInitContent_5536": "又是混入其中的小祖拉",
    "messageInitContent_5539": "注意前方声浪",
    "messageInitContent_5538": "快逃吧，怪兽们",
    "messageInitContent_5540": "超大声",
    "messageInitContent_5542": "小食这边",
    "messageInitContent_5541": "门票这边",
    "messageInitContent_5544": "上方浮岛",
    "messageInitContent_5543": "饮料这边",
    "messageInitContent_5546": "谁是主宰",
    "messageInitContent_5545": "请注意安全",
    "messageInitContent_5548": "你们说得对",
    "messageInitContent_5547": "别皮",
    "messageInitContent_5549": "小污",
    "18_19": "谜体",
    "mapNodeName_1662": "机动迷城",
    "messageInitContent_5551": "污污污污污污",
    "mapNodeName_1661": "赤草无双",
    "messageInitContent_5550": "污的宠儿",
    "mapNodeName_1660": "怪兽4人组",
    "messageInitContent_5553": "还好大只的不是污妖王",
    "messageInitContent_5552": "约会？",
    "18_23": "后背",
    "messageInitContent_5555": "差点美感",
    "18_22": "尾段",
    "messageInitContent_5554": "2个金闪闪",
    "messageInitContent_5557": "午安探索者",
    "messageInitContent_5556": "下关再见",
    "mapNodeName_1669": "巨炮固定式",
    "18_21": "头部",
    "mapNodeName_1668": "大摆锤",
    "18_20": "四肢",
    "mapNodeName_1667": "棋兵之迷",
    "mapNodeName_1666": "机动迷城",
    "mapNodeName_1665": "机动迷城",
    "mapNodeName_1664": "重装战甲",
    "mapNodeName_1663": "金矿山",
    "mapNodeName_1649": "机动迷城",
    "messageInitContent_5559": "看清楚怪兽需要花点力气",
    "messageInitContent_5558": "越来越大",
    "mapNodeName_1651": "魔龙乐园",
    "messageInitContent_5562": "腰不错",
    "mapNodeName_1650": "机动迷城",
    "messageInitContent_5561": "闪光你怎么长得和身份证不一样",
    "messageInitContent_5564": "好有存在感",
    "messageInitContent_5563": "哈哈哈哈",
    "messageInitContent_5566": "体型大了奶量会变？",
    "messageInitContent_5565": "让我看看够不够大",
    "messageInitContent_5568": "大家听我说",
    "messageInitContent_5567": "天",
    "mapNodeName_1659": "风水英雄",
    "mapNodeName_1658": "星之卡烁",
    "mapNodeName_1657": "冰雪世界",
    "mapNodeName_1656": "机动迷城",
    "mapNodeName_1655": "夹怪兽机",
    "mapNodeName_1654": "机动传送门",
    "mapNodeName_1653": "机动迷城",
    "messageInitContent_5560": "吼吼吼",
    "mapNodeName_1652": "械玩奇域",
    "mapNodeName_1639": "怪兽逃亡",
    "mapNodeName_1638": "草元素",
    "messageInitContent_5569": "到处都是你",
    "mapNodeName_1640": "炎之哀伤",
    "messageInitContent_5573": "想吃薯条",
    "messageInitContent_5572": "想吃宵夜",
    "messageInitContent_5575": "这不是桐人吗",
    "messageInitContent_5574": "融入鳖精的幻化",
    "messageInitContent_5577": "我觉得它的胸口在看着我",
    "messageInitContent_5576": "为什么每次都不是那些变大",
    "messageInitContent_5579": "多洗碟",
    "messageInitContent_5578": "好的下一个",
    "mapNodeName_1648": "贪吃怪",
    "mapNodeName_1647": "锤爹40K",
    "mapNodeName_1646": "械玩奇域",
    "mapNodeName_1645": "械玩奇域",
    "mapNodeName_1644": "兔兔跑酷",
    "mapNodeName_1643": "械玩奇域",
    "mapNodeName_1642": "刀叉神域",
    "messageInitContent_5571": "饿了",
    "mapNodeName_1641": "穿角王子",
    "messageInitContent_5570": "收集没人要的罩子龙",
    "mapNodeName_1629": "圣光照耀",
    "mapNodeName_1628": "兔之边缘",
    "mapNodeName_1627": "几何幻境",
    "18_16": "无法跨天结算",
    "messageInitContent_5584": "好大的键盘",
    "18_15": "是否重置古基因？",
    "messageInitContent_5583": "难道说",
    "18_18": "躯干",
    "messageInitContent_5586": "啊花儿你长大啦",
    "18_17": "是否马上结算当前击破数奖励？",
    "messageInitContent_5585": "是时候更新无线键盘了",
    "18_12": "击破数越高每小时产出的金币越多",
    "messageInitContent_5588": "给我一个硬币",
    "18_11": "每小时产出金币",
    "messageInitContent_5587": "舌尖上的雷电",
    "18_14": "挑战暴走旷野后可开启谜宝。",
    "18_13": "根据暴走旷野当前击破数{1}，谜宝给出的奖励为{2}{3}，领取后今天无法再次领取，是否领取？",
    "messageInitContent_5589": "飓风冲锋",
    "mapNodeName_1637": "不动玩偶",
    "mapNodeName_1636": "械玩奇域",
    "18_10": "建筑等级{1}\\n开启",
    "mapNodeName_1635": "游戏出租",
    "mapNodeName_1634": "宝可鱼王",
    "mapNodeName_1633": "械玩奇域",
    "messageInitContent_5580": "开心",
    "mapNodeName_1632": "斗兽盘",
    "mapNodeName_1631": "械玩奇域",
    "messageInitContent_5582": "停止思考",
    "mapNodeName_1630": "械玩奇域",
    "messageInitContent_5581": "震惊",
    "propConfigDes_40185": "成为狂风，卷起巨浪。\\n「用于造浪宣言头像框解锁」",
    "themeCardPackStoryId_260": "NR-004",
    "propConfigDes_40186": "剑锋未至，剑风已至。\\n「用于无双剑风头像框解锁」",
    "propConfigDes_40187": "记录星球运动的轨迹，是镜头的连线游戏。\\n「用于延时繁星头像框解锁」",
    "propConfigDes_40188": "万花筒会期待再次被拿起吗？\\n「用于万花一瞬头像框解锁」",
    "propConfigDes_40189": "如果海会游泳，那么它是在哪里遨游？\\n「用于幻海遨游头像框解锁」",
    "propConfigDes_40190": "跃向大海，即可倒转海洋。\\n「用于倒转海洋头像框解锁」",
    "propConfigDes_40191": "无数养分在其中来回穿行，而且……永远是绿灯！\\n「用于永恒脉络头像框解锁」",
    "themeCardPackStoryId_265": "NR-005",
    "propConfigDes_40192": "轻轻振翅的绯红花瓣。\\n「用于绯红约定头像框解锁」",
    "propConfigDes_40193": "无拘无束，肆意蹦跶！\\n「用于破空律动头像框解锁」",
    "propConfigDes_40194": "隐去身形翱翔深空，只能在特定角度窥见双翼无意廓出的空色。\\n「用于无形之翼头像框解锁」",
    "propConfigDes_40195": "超能力者专用，用于压制使用者的超能力。\\n「用于超能制约头像框解锁」",
    "propConfigDes_40196": "刻蚀在电路板上的魔法回路，能够释放出怎样的赛博魔法呢？\\n「用于赛博法环头像框解锁」",
    "propConfigDes_40197": "往昔切开一切的器具，不再展露锋芒，仅留下利落的轮廓静待腐朽。\\n「用于利刃回环头像框解锁」",
    "themeCardPackStoryId_270": "NR-006",
    "propConfigDes_40198": "传说装备的专用涂料，就差一件传说装备了！\\n「用于幻彩流体头像框解锁」",
    "propConfigDes_40199": "假如时间如沙，不断流逝，那么沙漏底部的世界会是怎样的，登上王座就能得到答案。\\n「用于沙星王座头像框解锁」",
    "themeCardPackStoryId_275": "NR-007",
    "themeCardPackStoryId_280": "NR-008",
    "themeCardPackStoryId_285": "AC-001",
    "96_MapNode": "世界",
    "themeCardPackStoryId_290": "AC-002",
    "themeCardPackStoryId_295": "AC-003",
    "propConfigDes_40141": "想撼动星辰，便化作星辰。\\n「用于主序·日夕星辰形态解锁」",
    "propConfigDes_40142": "想撼动星辰，便化作星辰。\\n「用于瑶镜·月夕星辰形态解锁」",
    "propConfigDes_40143": "想撼动星辰，便化作星辰。\\n「用于永逐·最终兵器星辰形态解锁」",
    "propConfigDes_40144": "想撼动星辰，便化作星辰。\\n「用于神畏·暴虐战狂星辰形态解锁」",
    "propConfigDes_40145": "想撼动星辰，便化作星辰。\\n「用于万象·神剑古拉姆星辰形态解锁」",
    "propConfigDes_40146": "想撼动星辰，便化作星辰。\\n「用于天元·圣盾埃癸斯星辰形态解锁」",
    "propConfigDes_40147": "能改变探索者名字的神奇树根，至于哪里神奇，还没有怪兽能说出个所以然来！\\n「用于探索者名称变更」",
    "propConfigDes_40148": "觉醒始动再动！告别随机定下的缘分，这一次将主动权牢牢握在手中！",
    "propConfigDes_40149": "这块精炼而成的起源盘，距离锻造完成只差最后一道工序，成色如何，一触便知！",
    "messageInitNick_5499": "深巷里的喵喵",
    "messageInitNick_5495": "算法恶魔",
    "messageInitNick_5496": "最爱枇杷",
    "messageInitNick_5497": "臭小子",
    "messageInitNick_5498": "逃出天堂",
    "propConfigDes_40150": "孕育着觉醒进化的奇迹之茧！许下你的愿望，静待奇迹降临。",
    "propConfigDes_40151": "金光闪闪的元核匣子！里头塞满了各式各样的橙色元核，疯狂摇动之后就能摇出你最想要的那个！",
    "propConfigDes_40152": "紫光冲天来的元核匣子！里头塞满了各式各样的紫色元核，轻轻摇动之后就能摇出你最想要的那个！",
    "propConfigDes_40153": "红光爆发的元核匣子！里头塞满了各式各样的红色元核，使劲摇动之后就能摇出你最想要的那个！",
    "propConfigDes_40154": "金光闪闪的元核匣子！里头塞满了经过特化的橙色元核，疯狂摇动之后就能摇出你最想要的那个！",
    "propConfigDes_40155": "红光爆发的元核匣子！里头塞满了经过特化的红色元核，摇动之后就能摇出你最想要的那个！",
    "propConfigDes_40156": "孕育一切幻化进化的奇迹之茧！许下你的愿望，静待幻化怪兽出现。",
    "propConfigDes_40157": "孕育一切不朽进化的奇迹之茧！许下你的愿望，静待不朽怪兽到来。",
    "propConfigDes_40158": "能改变部落名字的神奇树根，请谨慎使用，有概率被部落的成员bb！\\n「用于部落名称变更」",
    "propConfigDes_40159": "那个是鼻孔，是个锤子的鼻孔啊？！\\n「用于估你唔到头像解锁」",
    "messageInitNick_5491": "被没收的爱",
    "messageInitNick_5492": "美少女壮士",
    "messageInitNick_5493": "梳子剑客",
    "messageInitNick_5494": "重点小说家",
    "messageInitNick_5490": "吃瓜大王",
    "messageInitNick_5488": "外星脸盆",
    "messageInitNick_5489": "摄影大师",
    "messageInitNick_5484": "此男妞爱",
    "messageInitNick_5485": "兔兔赛跑",
    "messageInitContent_5601": "大为震撼",
    "messageInitNick_5486": "年度社牛",
    "messageInitContent_5600": "大但",
    "messageInitNick_5487": "追寻可能性",
    "propConfigDes_40160": "虽然很像，但不是那个！\\n「用于像素头像解锁」",
    "propConfigDes_40161": "三心但绝不二意！\\n「用于爱心纹身头像解锁」",
    "propConfigDes_40162": "拿两个鸡毛扫就可以cos啦！\\n「用于黑色枝桠头像解锁」",
    "propConfigDes_40163": "用一个鸡毛扫就可以cos啦！\\n「用于白色枝桠头像解锁」",
    "propConfigDes_40164": "蓝天之外是黑夜。\\n「用于蓝调黑头像框解锁」",
    "propConfigDes_40165": "由规整与对称而生的美。\\n「用于电路绿头像框解锁」",
    "propConfigDes_40166": "雨巷霓虹独照残躯。\\n「用于霓虹彩头像框解锁」",
    "propConfigDes_40167": "据说击破币只有10种样式，因为可以连环击破11人的探索者从未出现。\\n「用于连环击破商店兑换」",
    "propConfigDes_40168": "证真了由信赖构成的跨位面等式——1代金券=1元。\\n「用于游戏的内购」",
    "propConfigDes_40169": "只需喝一口，想去哪儿就去哪儿！\\n「用于移动力补充，使用后可获得200移动力」",
    "messageInitContent_5603": "超进化没有黄牛",
    "messageInitNick_5480": "过两天放假",
    "messageInitContent_5602": "好多演唱会",
    "messageInitNick_5481": "成精的狐狸",
    "messageInitContent_5605": "时泪",
    "messageInitNick_5482": "美食尝试卡",
    "messageInitContent_5604": "不用实名制看演唱会",
    "messageInitNick_5483": "此妞爷宠",
    "messageInitContent_5607": "来吧荧灵",
    "messageInitContent_5606": "好气",
    "messageInitContent_5609": "下一关晚安",
    "messageInitContent_5608": "浮空了",
    "messageInitNick_5477": "草莓之心",
    "messageInitNick_5478": "麦芽糖有点皮",
    "messageInitNick_5479": "把你宠坏",
    "messageInitContent_5610": "眼熟",
    "messageInitNick_5473": "阴谋家",
    "messageInitNick_5474": "机械女仆",
    "messageInitContent_5612": "不重要，前面金矿",
    "messageInitNick_5475": "想想想念念念",
    "messageInitContent_5611": "紧跟潮流的关",
    "messageInitNick_5476": "狗子误食月饼",
    "propConfigDes_40170": "选择困难症的福音！无需选择，我全都要！开启后获得对应数量的骨木鳞。\\n「用于领地建筑建造和升级」",
    "propConfigDes_40171": "总能给到你想要的孢子！似乎有一些探索者想将这个神奇的孢子罐头应用到▇▇的交通灯上（",
    "propConfigDes_40172": "让看不见的微小变化变得清晰可见，让蜕变前的每一点小积累都鼓舞着蜕变。\\n「用于契约等级的提升」",
    "propConfigDes_40173": "朴实无华的金色翅膀头像框。\\n「用于朴实金翅头像框解锁」",
    "propConfigDes_40174": "定格热情的永恒火舞头像框。\\n「用于永恒火舞头像框解锁」",
    "propConfigDes_40175": "一张能使役智者为轮盘装上指针并转动轮盘的金券，上面有智者亲笔写下的感谢语，献给支持它新业务的您。\\n「用于智者轮盘转动」",
    "propConfigDes_40176": "一块盾牌进化出了双翼意味着什么？是更灵动的守护还是……它要跑路了？\\n「用于守护之翼头像解锁」",
    "propConfigDes_40177": "进步无须一步登天，拆分进步的每一步，进步离你就只有一步之遥。\\n「用于一步之遥奖励解锁」",
    "propConfigDes_40178": "不断探索是为了什么？\\n整点造唤许可。\\n别误会，我是说咱们不断探索击败形形色色对手变强进化遍踏江湖饱尝烟火是为了什么？\\n整点造唤许可。\\n「用于全服共探奖励解锁」",
    "propConfigDes_40179": "无须找寻创世的秘密，你就处于这创世纪。\\n「用于创世商店兑换」",
    "messageInitContent_5614": "腾龙的小屁屁笑死",
    "messageInitContent_5613": "听，金币的声音",
    "messageInitNick_5470": "枇杷消灭者",
    "messageInitContent_5616": "我选择这边",
    "messageInitNick_5471": "家有冰龙",
    "messageInitContent_5615": "觉醒蓝",
    "messageInitNick_5472": "指哪打哪",
    "messageInitContent_5618": "憋说话",
    "messageInitContent_5617": "领地清扫行动",
    "messageInitContent_5619": "笑容逐渐美丽",
    "messageInitNick_5466": "双手吹头",
    "messageInitNick_5467": "断了芯的笔",
    "messageInitNick_5468": "一念一轮回",
    "messageInitNick_5469": "满分甜",
    "messageInitContent_5621": "你的手放哪里！！",
    "messageInitNick_5462": "丨量版",
    "messageInitContent_5620": "顶天立地",
    "messageInitNick_5463": "你忍心凶我",
    "messageInitContent_5623": "为爱发电中",
    "messageInitNick_5464": "赖床女子",
    "messageInitContent_5622": "我是光你是电",
    "messageInitNick_5465": "贤者模式",
    "propConfigDes_40180": "一创币支持您的无限创意，不论是一创、二创，还是一直创！\\n「用于一创到底挑战」",
    "propConfigDes_40181": "一个属于创与造的世纪，一个属于你的世纪。\\n「用于创世纪头像框解锁」",
    "propConfigDes_40182": "一切无法飞翔的生物都会有的幻想。\\n「用于翱翔幻象头像框解锁」",
    "propConfigDes_40183": "无序，随机，不可预测，却如此美丽。\\n「用于混沌浮云头像框解锁」",
    "propConfigDes_40184": "意识初现，生命绽放。\\n「用于生命之涌头像框解锁」",
    "propConfigDes_40100": "斗技场挑战次数",
    "propConfigDes_40101": "起源殿挑战次数",
    "propConfigDes_40102": "探索者在超进化大陆闪闪发光、活力四射的证明。\\n「用于每日挑战宝箱开启」",
    "propConfigDes_40103": "超进化委员会郑重提醒您：喵响的舌头无法采集到尖刺，敬请留意以免受伤！更多的刺激更多的奖励。开启后获得对应数量的尖刺。\\n「用于获得尖刺」",
    "propConfigDes_40104": "定义未定义的探索在哪里。开启后获得对应数量的探索点。\\n「用于获得探索点」",
    "propConfigDes_40105": "狂热是他的血脉、执着是他的筋肉、不屈是他的战痕。\\n「用于远古族觉醒怪兽战狂形态解锁」",
    "propConfigDes_40106": "想撼动星辰，便化作星辰。\\n「用于远古族觉醒怪兽星辰形态解锁」",
    "messageInitNick_5460": "是说谎的味道",
    "propConfigDes_40107": "据说真正的凿星者都会忍不住想要触碰头像中那个通往裂痕的符号。\\n「用于凿星者头像解锁」",
    "messageInitNick_5461": "尖叫柚子",
    "propConfigDes_40108": "知道拥有这个头像之后会产生什么烦恼吗？接下来要怎样才能让领地上的所有领主都看见自己的名字？不不，可能是更为跳跃一点的，为什么自己当初要起这名！\\n「用于斗技之王头像解锁」",
    "propConfigDes_40109": "你当然知道这是一道伪造的爪痕，正好将计就计。\\n「用于猎神头像解锁」",
    "messageInitNick_5455": "活力的葡萄柚",
    "messageInitNick_5456": "迷人的珠宝",
    "messageInitNick_5457": "熬夜少年",
    "messageInitNick_5458": "爱被情搁浅",
    "messageInitNick_5451": "幼稚小家伙",
    "messageInitNick_5452": "咸鱼电台",
    "messageInitNick_5453": "强风大背头",
    "messageInitNick_5454": "我想回农村",
    "messageInitNick_5459": "小宇宙燃烧吧",
    "propConfigDes_40110": "起源殿主宰专属特制精制御用闪耀超凡黄金皇冠……的展示图，请用想象力为自己加冕！为什么没有实物？因为实物的想象空间不足以彰显这份荣耀的意义。\\n「用于起源殿主宰头像解锁」",
    "propConfigDes_40111": "起源殿巅峰专属特制精制御用闪耀超凡白银皇冠……的展示图，请用想象力为自己加冕！\\n「用于起源殿巅峰头像解锁」",
    "propConfigDes_40112": "起源殿宗师专属特制精制御用闪耀超凡赤铜皇冠……的展示图，请用想象力为自己加冕！\\n「用于起源殿宗师头像解锁」",
    "propConfigDes_40113": "霸之胡，王之眼。\\n「用于霸王头像解锁」",
    "propConfigDes_40114": "叉叉在大合照时的入镜实录。\\n「用于叉叉头像解锁」",
    "propConfigDes_40115": "努力从这粉色中看见金光。\\n「用于玫瑰头像解锁」",
    "propConfigDes_40116": "你好，超进化大陆。\\n「用于探索者头像解锁」",
    "propConfigDes_40117": "资探深索者？\\n「用于资深探索者头像解锁」",
    "propConfigDes_40118": "终于整片大陆的迷雾都被你驱散。探索者亦是引领者。\\n「用于引领者头像解锁」",
    "messageInitNick_5450": "属性大爆发",
    "propConfigDes_40119": "比世界灾厄更加可怕的存在。\\n「用于破厄头像解锁」",
    "messageInitNick_5444": "好怪再买一件",
    "messageInitNick_5445": "灵魂进食中",
    "messageInitNick_5446": "我有药",
    "messageInitNick_5447": "跟空气撒个娇",
    "messageInitNick_5440": "无语鸽子",
    "messageInitNick_5441": "风吹过旳痕迹",
    "messageInitNick_5442": "丢了香蕉",
    "messageInitNick_5443": "颜值担当",
    "messageInitNick_5448": "雪莲果龙",
    "messageInitNick_5449": "村中最靓的妹",
    "propConfigDes_40120": "来自造唤之神的轻拥。\\n「用于造唤之神头像解锁」",
    "propConfigDes_40121": "我爱你你爱我。\\n「用于神秘之心头像解锁」",
    "propConfigDes_40122": "突然意识到一次性茧的鼓动可能只是一次缓慢的颤抖，恐惧的或是渴望的。\\n「用于羽化头像解锁」",
    "propConfigDes_40123": "肉眼可见的突出，触手可及的张狂，独一无二的霸气。\\n「用于部落之王头像框解锁」",
    "propConfigDes_40124": "恰如其分的突出，恰到好处的张狂。\\n「用于部落之心头像框解锁」",
    "propConfigDes_40125": "含蓄的突出，低调的张狂。\\n「用于部落之角像框解锁」",
    "propConfigDes_40126": "低调奢华有内涵。\\n「用于普通头像框解锁」",
    "propConfigDes_40127": "高端大气上档次。\\n「用于超级普通头像框解锁」",
    "propConfigDes_40128": "猫科动物的影响力已延伸至此喵。\\n「用于猫耳头像框解锁」",
    "propConfigDes_40129": "暴走的甘美将在回望旷野时采撷。\\n「用于暴走头像框解锁」",
    "messageInitNick_5433": "奉旨尬聊",
    "messageInitNick_5434": "哀家是卖菜的",
    "messageInitNick_5435": "钓鱼王",
    "messageInitNick_5436": "花臂姑娘",
    "messageInitNick_5430": "这场大戏",
    "messageInitNick_5431": "九命猫妖",
    "messageInitNick_5432": "打点钱来",
    "themeCardPackStoryId_200": "JS-008",
    "messageInitNick_5437": "流浪的木偶",
    "messageInitNick_5438": "摸凹猫",
    "themeCardPackStoryId_205": "RS-001",
    "messageInitNick_5439": "没关摄像头",
    "propConfigDes_40130": "改变不了时间的终点，但可以改变暴走的终点。\\n「用于极限暴走头像框解锁」",
    "propConfigDes_40131": "制限，破限。\\n「用于无限暴走头像框解锁」",
    "propConfigDes_40132": "深谙多样性并接受多样性，如同宇宙般广阔。\\n「用于寰宇头像框解锁」",
    "propConfigDes_40133": "成为搬砖大师的路上断掉几根骨头总是难免的。\\n「用于搬砖大师头像框解锁」",
    "propConfigDes_40134": "成为怪兽大师的路上失去几颗牙齿总是难免的。\\n「用于怪兽大师头像框解锁」",
    "propConfigDes_40135": "狂热是祂的血脉、执着是祂的筋肉、不屈是祂的战痕。\\n「用于主序·日夕战狂形态解锁」",
    "propConfigDes_40136": "狂热是祂的血脉、执着是祂的筋肉、不屈是祂的战痕。\\n「用于瑶镜·月夕战狂形态解锁」",
    "propConfigDes_40137": "狂热是祂的血脉、执着是祂的筋肉、不屈是祂的战痕。\\n「用于永逐·最终兵器战狂形态解锁」",
    "propConfigDes_40138": "狂热是祂的血脉、执着是祂的筋肉、不屈是祂的战痕。\\n「用于神畏·暴虐战狂战狂形态解锁」",
    "propConfigDes_40139": "狂热是祂的血脉、执着是祂的筋肉、不屈是祂的战痕。\\n「用于万象·神剑古拉姆战狂形态解锁」",
    "messageInitNick_5422": "奥巴喵",
    "messageInitNick_5423": "你努力",
    "messageInitNick_5424": "延续颓废",
    "messageInitNick_5425": "玉米的棉袄",
    "messageInitNick_5420": "老子真可爱",
    "messageInitNick_5421": "独走孤城",
    "themeCardPackStoryId_210": "RS-002",
    "messageInitNick_5426": "狂飙的鸭",
    "messageInitNick_5427": "超抠门女侠",
    "messageInitNick_5428": "独霸一棵草",
    "themeCardPackStoryId_215": "RS-003",
    "messageInitNick_5429": "烈马带梦归",
    "propConfigDes_40140": "狂热是祂的血脉、执着是祂的筋肉、不屈是祂的战痕。\\n「用于天元·圣盾埃癸斯战狂形态解锁」",
    "themeCardPackStoryId_220": "RS-004",
    "messageInitNick_5411": "缱绻成歌",
    "messageInitNick_5412": "把回忆吐出来",
    "messageInitNick_5413": "吾奶赵子龙",
    "messageInitNick_5414": "半傻半天真",
    "messageInitNick_5410": "画饼小能手",
    "messageInitNick_5419": "按键伤人",
    "messageInitNick_5415": "现场再见",
    "messageInitNick_5416": "柿子魔法",
    "messageInitNick_5417": "凉茶怪客",
    "messageInitNick_5418": "气场两米八",
    "themeCardPackStoryId_225": "RS-005",
    "themeCardPackStoryId_230": "RS-006",
    "messageInitNick_5400": "对回忆说声滚",
    "messageInitNick_5401": "打脸全明星",
    "messageInitNick_5402": "寒江独钓",
    "messageInitNick_5403": "花留香",
    "messageInitNick_5408": "阳光穿透一切",
    "themeCardPackStoryId_235": "RS-007",
    "messageInitNick_5409": "嘟嘟嘴卖卖萌",
    "messageInitNick_5404": "倒霉的鱼",
    "messageInitNick_5405": "梨魔法师",
    "messageInitNick_5406": "残缺的不完美",
    "messageInitNick_5407": "当场泪奔",
    "resoundEventConfigName_8010": "10.自投罗网",
    "resoundEventConfigName_8014": "14.耻辱",
    "resoundEventConfigName_8013": "13.造唤台",
    "resoundEventConfigName_8012": "12.你想做的事",
    "themeCardPackStoryId_240": "RS-008",
    "resoundEventConfigName_8011": "11.得力助手",
    "resoundEventConfigName_8018": "18.接受现实",
    "resoundEventConfigName_8017": "17.逃避现实",
    "themeCardPackStoryId_245": "NR-001",
    "resoundEventConfigName_8016": "16.粉丝",
    "resoundEventConfigName_8015": "15.熔火之巅",
    "randomEventDialogueGroupConfig_5.4": "-",
    "randomEventDialogueGroupConfig_5.5": "-",
    "randomEventDialogueGroupConfig_5.2": "-",
    "randomEventDialogueGroupConfig_5.3": "-",
    "randomEventDialogueGroupConfig_5.1": "前面有个神秘商人一边清理着地面一边嘀咕着什么。",
    "themeCardPackStoryId_250": "NR-002",
    "themeCardPackStoryId_255": "NR-003",
    "randomEventDialogueGroupConfig_5.8": "谢谢你，其实……这里……我一个就可以了。",
    "randomEventDialogueGroupConfig_5.9": "它躲到一旁，继续清扫。",
    "randomEventDialogueGroupConfig_5.6": "-",
    "randomEventDialogueGroupConfig_5.7": "-",
    "mapNodeName_1101": "古记战役-疯狂螺旋",
    "messageInitNick_1493": "发型不能乱",
    "mapNodeName_1100": "无█名荒野",
    "messageInitNick_1494": "流风回雪",
    "messageInitNick_1491": "您来当草神吧",
    "messageInitNick_1492": "爱你不如爱狗",
    "messageInitNick_1497": "可爱了好久",
    "messageInitNick_1498": "盖布神",
    "messageInitNick_1495": "残酷的显示器",
    "messageInitNick_1496": "接口准备好了",
    "mapNodeName_1109": "动物园1区",
    "mapNodeName_1108": "缠绵幻梦",
    "mapNodeName_1107": "缠绵幻梦",
    "messageInitNick_1499": "白衣画丹青",
    "mapNodeName_1106": "缠绵幻梦",
    "mapNodeName_1105": "缠绵主城",
    "mapNodeName_1104": "深渊小鲨",
    "mapNodeName_1103": "吞食鱼",
    "mapNodeName_1102": "虚诞之门",
    "messageInitNick_1490": "提刀女魔王",
    "messageInitNick_1482": "咖啡不加糖",
    "messageInitNick_1483": "一只小馋猫",
    "messageInitNick_1480": "卷王",
    "messageInitNick_1481": "废人",
    "messageInitNick_1486": "叫兽光波",
    "messageInitNick_1487": "百年二货",
    "messageInitNick_1484": "残花若相惜",
    "messageInitNick_1485": "镌刻你的温柔",
    "messageInitNick_1488": "来一斤小鲜肉",
    "messageInitNick_1489": "大橙先生",
    "messageInitNick_1471": "叫我淡定姐",
    "messageInitNick_1472": "禁欲系男神",
    "messageInitNick_1470": "哎哟小喵咪",
    "messageInitNick_1475": "情深奈何缘浅",
    "messageInitNick_1476": "骷髅控",
    "messageInitNick_1473": "到老仍是顽童",
    "messageInitNick_1474": "月亮凑过来听",
    "messageInitNick_1479": "咕咕小能手",
    "messageInitNick_1477": "奉旨舔包",
    "messageInitNick_1478": "反射弧太长",
    "messageInitNick_1460": "黑色指针",
    "messageInitNick_1461": "拦精灵",
    "messageInitNick_1464": "道不清的忧伤",
    "messageInitNick_1465": "单机斗地主",
    "messageInitNick_1462": "谁把琴弦拨断",
    "messageInitNick_1463": "巧克力友谊",
    "messageInitNick_1468": "划水门首席",
    "messageInitNick_1469": "跳伞的小雨滴",
    "messageInitNick_1466": "与幸福有约",
    "messageInitNick_1467": "是打牌的发型",
    "mapNodeName_1145": "深渊之狱",
    "mapNodeName_1144": "深幽水月",
    "messageInitNick_1450": "猫有猫德",
    "mapNodeName_1143": "深幽水月",
    "mapNodeName_1142": "金矿山",
    "mapNodeName_1141": "水族馆1层",
    "messageInitNick_1453": "小萌兔",
    "mapNodeName_1140": "深幽水月",
    "messageInitNick_1454": "桥豆麻袋",
    "messageInitNick_1451": "名猪有主哈哈",
    "messageInitNick_1452": "安放的青春",
    "messageInitNick_1457": "医疗箱不许抢",
    "messageInitNick_1458": "我不尬就他尬",
    "messageInitNick_1455": "村中一枝花",
    "messageInitNick_1456": "爱里行乞",
    "mapNodeName_1149": "深幽水月",
    "mapNodeName_1148": "水族馆2层",
    "mapNodeName_1147": "水物馆2号馆",
    "messageInitNick_1459": "鲁迅漂流记",
    "mapNodeName_1146": "古记战役-狂牙猛噬",
    "mapNodeName_1134": "深幽水月",
    "mapNodeName_1133": "深幽水月",
    "mapNodeName_1132": "来自深渊",
    "mapNodeName_1131": "草原赤狮",
    "mapNodeName_1130": "深幽水月",
    "messageInitNick_1442": "此正太不太乖",
    "messageInitNick_1443": "脸还肿着",
    "messageInitNick_1440": "呆萌迷糊",
    "messageInitNick_1441": "熬夜门首席",
    "messageInitNick_1446": "沉默寡言的明",
    "messageInitNick_1447": "爱人与海",
    "messageInitNick_1444": "修炼成精",
    "mapNodeName_1139": "非梵",
    "messageInitNick_1445": "白云要吃糖",
    "mapNodeName_1138": "赤色深渊",
    "mapNodeName_1137": "深幽水月",
    "mapNodeName_1136": "音乐盒1节",
    "messageInitNick_1448": "奇迹透明人",
    "mapNodeName_1135": "肉肉山",
    "messageInitNick_1449": "邪恶的纯牛奶",
    "mapNodeName_1123": "爱意暴风",
    "mapNodeName_1122": "水物馆1号馆",
    "mapNodeName_1121": "浮沉泡影",
    "mapNodeName_1120": "浮沉泡影",
    "messageInitNick_1431": "国王的新衣",
    "messageInitNick_1432": "补刀小天才",
    "messageInitNick_1430": "欧气重置",
    "messageInitNick_1435": "活出爷们范",
    "messageInitNick_1436": "放生人鱼",
    "mapNodeName_1129": "美杜莎鲨",
    "messageInitNick_1433": "此心独醉他城",
    "mapNodeName_1128": "家园1路",
    "messageInitNick_1434": "会跑步的鲸鱼",
    "mapNodeName_1127": "牢笼1室",
    "messageInitNick_1439": "懒癌少女",
    "mapNodeName_1126": "浮沉泡影",
    "mapNodeName_1125": "龙场1环",
    "messageInitNick_1437": "智商已消失",
    "mapNodeName_1124": "酒馆1桌",
    "messageInitNick_1438": "头发还在",
    "mapNodeName_1112": "动物园2区",
    "mapNodeName_1111": "浮沉泡影",
    "mapNodeName_1110": "噩梦深渊",
    "messageInitNick_1420": "世界回归寂静",
    "messageInitNick_1421": "瞌睡龙",
    "messageInitNick_1424": "俺们都是村草",
    "mapNodeName_1119": "喵咖1厅",
    "messageInitNick_1425": "今晚去捕月",
    "mapNodeName_1118": "缠绵幻梦",
    "messageInitNick_1422": "回望路人甲",
    "mapNodeName_1117": "虚诞传送门I",
    "messageInitNick_1423": "打我的都是猪",
    "mapNodeName_1116": "水族箱1域",
    "messageInitNick_1428": "捕梦老大爷",
    "mapNodeName_1115": "缠绵幻梦",
    "messageInitNick_1429": "冒失鬼",
    "mapNodeName_1114": "缠绵幻梦",
    "messageInitNick_1426": "混世魔女",
    "mapNodeName_1113": "虚诞集市",
    "messageInitNick_1427": "小鸡炖蘑菇",
    "messageInitNick_1419": "跟风之神",
    "messageInitNick_1410": "头铁大王",
    "messageInitNick_1413": "保镖",
    "messageInitNick_1414": "逾期不候",
    "messageInitNick_1411": "假绅士",
    "messageInitNick_1412": "高傲的小女人",
    "messageInitNick_1417": "浪归人",
    "messageInitNick_1418": "大白兔奶糖",
    "messageInitNick_1415": "冬天的秘密",
    "messageInitNick_1416": "带帽小鸭",
    "messageInitNick_1408": "凹凸曼先森",
    "messageInitNick_1409": "荒野浪猫",
    "messageInitNick_1402": "好难过儿",
    "messageInitNick_1403": "贝多芬的忧伤",
    "messageInitNick_1400": "红人",
    "messageInitNick_1401": "丛林野狼",
    "messageInitNick_1406": "认证咕咕专家",
    "messageInitNick_1407": "亡命狂徒",
    "messageInitNick_1404": "脑子打烊中",
    "messageInitNick_1405": "东京小吃货",
    "messageInitContent_1789": "山顶的朋友在哪里",
    "messageInitContent_1788": "你们的尖叫声在哪里！",
    "messageInitContent_1787": "沿海尸狂和幻演唱会！",
    "messageInitContent_1786": "又准备出海咯",
    "messageInitContent_1785": "是有珍宝参加的演唱会",
    "iapBuyConfigName_1010": "位面领主10",
    "messageInitContent_1795": "可以制两次杖",
    "messageInitContent_1794": "2只制杖巨人有什么用",
    "messageInitContent_1793": "这里是山顶的朋友！！！",
    "messageInitContent_1792": "为了看演唱会特地跑到这里！",
    "messageInitContent_1791": "啊啊啊啊啊啊啊啊啊啊啊",
    "messageInitContent_1790": "山顶的朋友在对面",
    "iapBuyConfigName_1009": "位面领主9",
    "iapBuyConfigName_1007": "位面领主7",
    "messageInitContent_1799": "这座小岛居然有3个大炮",
    "iapBuyConfigName_1008": "位面领主8",
    "messageInitContent_1798": "好像还没见过大小人一起呢",
    "iapBuyConfigName_1005": "位面领主5",
    "messageInitContent_1797": "代替前面谢谢你",
    "iapBuyConfigName_1006": "位面领主6",
    "messageInitContent_1796": "前面你真幽默",
    "iapBuyConfigName_1003": "位面领主3",
    "iapBuyConfigName_1004": "位面领主4",
    "iapBuyConfigName_1001": "位面领主1",
    "iapBuyConfigName_1002": "位面领主2",
    "messageInitContent_401": "你们生异形吗？",
    "messageInitContent_402": "铁血战士爱好者在此！",
    "messageInitContent_403": "甩头大哥！你的脖子更粗了呢",
    "messageInitContent_404": "给点面子，那是领头大哥。",
    "messageInitContent_405": "行尸走肉片场？？？",
    "messageInitContent_406": "明明这么可爱。",
    "messageInitContent_407": "完全不吓人好吗。",
    "messageInitContent_408": "为什么它可以烦恼，我没有女朋友也没有男朋友。",
    "messageInitContent_400": "让我用见闻色霸气康康你",
    "messageInitContent_409": "朋友，一种难以抵达的高配置。",
    "messageInitContent_412": "猫公公前来赐教，想恢复不幸离开的蛋蛋。",
    "messageInitContent_413": "什么葵花宝典。",
    "messageInitContent_414": "人家秃了就能变强，这里……",
    "messageInitContent_415": "流行之绊~有看过的吗？",
    "messageInitContent_416": "只看过流星之绊",
    "messageInitContent_417": "让我放完这个技能。",
    "messageInitContent_418": "没有技能怕什么封印。",
    "messageInitContent_419": "三幻神。",
    "messageInitContent_410": "螳螂拳教学关。",
    "messageInitContent_411": "李公公前来赐教。",
    "messageInitContent_423": "来啊，互封技能啊。",
    "messageInitContent_424": "扑面而来的田园气息。",
    "messageInitContent_425": "这是一棵草，蜻蜓是我改的名字。",
    "messageInitContent_426": "竹蜻蜓？",
    "messageInitContent_427": "把我对草的美好印象还回来！",
    "messageInitContent_428": "天涯何处无芳草呢",
    "messageInitContent_429": "名字的力量！可以改变属性",
    "messageInitContent_420": "明明是三幻兽。",
    "messageInitContent_421": "赢了都是幻觉啦。",
    "messageInitContent_422": "绝对的实力面前，少个技能又如何。",
    "messageInitContent_434": "区区蚊子也想当捕食者？",
    "messageInitContent_435": "现在的打码越来越先进了，弹幕不说都发现不了。",
    "messageInitContent_436": "快进到ai打码",
    "messageInitContent_437": "快件到ai代看",
    "messageInitContent_438": "人人都爱aoe",
    "messageInitContent_439": "苟住就好，苟住就好",
    "messageInitContent_430": "小金翅不在，稳了。",
    "messageInitContent_431": "骑兵算1只怪还是2只怪",
    "messageInitContent_432": "建议出一只制杖中人。",
    "messageInitContent_433": "说什么中之人？",
    "messageInitContent_445": "谁还记得经典的一战包三*？！",
    "messageInitContent_446": "可是这里只有2只奶妈哦。",
    "messageInitContent_447": "是1只奶爸吧？",
    "messageInitContent_448": "一战包，包，！我来！",
    "messageInitContent_449": "答应我，不要当舔狗。",
    "messageInitContent_440": "这里居然有三关。",
    "messageInitContent_441": "我画个井字，能不能让我过三关。",
    "messageInitContent_442": "今天是个好日子。",
    "messageInitContent_443": "能不能别动不动就动**，幻痛了都。",
    "messageInitContent_444": "这就是王？",
    "messageInitContent_456": "迷路也不可以轻易说GG",
    "messageInitContent_457": "晨光之柱到此一游。",
    "messageInitContent_458": "现在还有晨光之柱吗？",
    "messageInitContent_459": "都跟你说的啦，童话故事里的都是骗人的。",
    "messageInitContent_450": "我先答应你，能不能做到再说。",
    "messageInitContent_451": "给我个对象吧！",
    "messageInitContent_452": "地图上是什么怪兽的骸骨呢。",
    "messageInitContent_453": "这捕食者真是越看越难崩。蚌埠住了",
    "messageInitContent_454": "想象一下，会霸气的外星异形横扫天龙人，",
    "messageInitContent_455": "这三只是迷路碰上的吗",
    "messageInitContent_467": "重要的事情要说三遍。",
    "messageInitContent_468": "这样的奶妈给我多来几个！",
    "messageInitContent_469": "居然好这口。",
    "messageInitContent_460": "这东西怎么有几分大哥哥。",
    "messageInitContent_461": "不许大哥哥！！不许！",
    "messageInitContent_462": "有些老梗就应该让它们永远安息。",
    "messageInitContent_463": "爱情和面包，你会怎么选？",
    "messageInitContent_464": "我选面包。",
    "messageInitContent_465": "我选金钱。",
    "messageInitContent_466": "带上一朵小花，送给……我爱的怪兽",
    "messageInitContent_1704": "对面完全压不过来呢哈哈哈哈",
    "messageInitContent_1703": "冰霓在龙帝隔壁会不会融掉，",
    "messageInitContent_1702": "请把我的粉红战士拿出来！",
    "messageInitContent_1701": "五色战队！",
    "18_2011": "我的排名",
    "messageInitContent_1700": "让我来将冰山劈开！",
    "18_2012": "最高击破数",
    "18_2010": "挑战",
    "18_2015": "领取奖励",
    "mapNodeName_1181": "触涌镜花",
    "18_2016": "暴走回廊",
    "mapNodeName_1180": "触涌镜花",
    "18_2013": "谜",
    "18_2014": "暂无排名",
    "messageInitContent_1709": "地龙真的是龙吗",
    "18_2019": "匹配",
    "messageInitContent_1708": "龙龙龙龙~",
    "messageInitContent_1707": "都是龙！",
    "18_2017": "积分",
    "messageInitContent_1706": "凶噬魔的餐具怎么变成这样了",
    "18_2018": "{1} 开启",
    "messageInitContent_1705": "应该说龙帝在冰霓隔壁会不会冷到感冒",
    "mapNodeName_1189": "肉肉山",
    "messageInitContent_478": "所以颜值高兴的笑声到底是怎样的呢。",
    "mapNodeName_1188": "缠绵幻梦",
    "messageInitContent_479": "哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈（大小姐式狂笑",
    "mapNodeName_1187": "绝望之光",
    "mapNodeName_1186": "缠绵幻梦",
    "mapNodeName_1185": "地下塔入口1",
    "mapNodeName_1184": "缠绵幻梦",
    "mapNodeName_1183": "龙场2环",
    "mapNodeName_1182": "切割魔术",
    "messageInitContent_470": "所以gn到底是什么意思？",
    "messageInitContent_471": "n是指牛。g是指钢",
    "messageInitContent_472": "前方高能",
    "messageInitContent_473": "笑笑更健康。",
    "messageInitContent_474": "假笑怪兽？",
    "messageInitContent_475": "。。直立行走不对吧，是直立飞翔。。。",
    "messageInitContent_476": "多笑一点，轰龙就会选择进化为明光龙了吗",
    "messageInitContent_477": "听说有些女巫是躺着飞翔的呢。女巫奸笑2333",
    "messageInitContent_1715": "这就是兄妹情呢",
    "randomEventDialogueGroupConfig_6.3": "-",
    "messageInitContent_1714": "总能在火神附近看到赤虹",
    "randomEventDialogueGroupConfig_6.4": "-",
    "messageInitContent_1713": "在天上飞的就是天龙",
    "randomEventDialogueGroupConfig_6.1": "这是一个长着十根触手的神秘商人，它正甩动着触手大声叫卖着。",
    "messageInitContent_1712": "是不是后面还有天龙，",
    "randomEventDialogueGroupConfig_6.2": "-",
    "messageInitContent_1711": "请给我更多的龙",
    "18_2001": "谜之巢穴",
    "messageInitContent_1710": "我是龙的传人！",
    "messageInitContent_480": "过去脑袋是要上发条的呢",
    "18_2004": "头部古基因",
    "mapNodeName_1170": "深幽水月",
    "18_2005": "尾段古基因",
    "18_2002": "暴走旷野",
    "18_2003": "躯干古基因",
    "18_2008": "培育",
    "messageInitContent_1719": "祈愿玖璃",
    "18_2009": "剩余挑战次数",
    "messageInitContent_1718": "啊我又要陷入九黎的漩涡了",
    "18_2006": "四肢古基因",
    "messageInitContent_1717": "她可能只是在假装在盒子，其实是地底人",
    "18_2007": "后背古基因",
    "messageInitContent_1716": "queen一直住盒子不会累的吗",
    "mapNodeName_1178": "触涌镜花",
    "messageInitContent_489": "所以kb兄是一台主机怪兽？",
    "mapNodeName_1177": "触涌镜花",
    "mapNodeName_1176": "虚无螺旋",
    "mapNodeName_1175": "喵咖3厅",
    "mapNodeName_1174": "深幽水月",
    "mapNodeName_1173": "虚诞传送门II",
    "mapNodeName_1172": "暗影刺客",
    "mapNodeName_1171": "加工场1口",
    "messageInitContent_481": "隔壁的山的云长得相当飘逸",
    "messageInitContent_482": "你是来观光的呢",
    "messageInitContent_483": "它们肯定是同个厂出来的，节奏都一样的。",
    "randomEventDialogueGroupConfig_6.9": "好的亲，一份【C******！】#混蛋，哪来的C餐阿喂——！！！",
    "messageInitContent_484": "我还有个发条苹果呢",
    "messageInitContent_485": "发条魔芋我也有。",
    "randomEventDialogueGroupConfig_6.7": "-",
    "messageInitContent_486": "所以它撒谎是下巴会变长吗",
    "randomEventDialogueGroupConfig_6.8": "它的触手耷拉了下来向你挥手。",
    "messageInitContent_487": "这两专欺负血少的又来了。",
    "randomEventDialogueGroupConfig_6.5": "-",
    "mapNodeName_1179": "触涌镜花",
    "messageInitContent_488": "那个到底是机械键盘还是薄膜键盘？我很好奇！",
    "randomEventDialogueGroupConfig_6.6": "-",
    "messageInitContent_1726": "肉太大不好入口，就帮你变小一点了",
    "messageInitContent_1725": "烤串把肉变小可不好把",
    "messageInitContent_1724": "又又又想清我buff",
    "messageInitContent_1723": "紫气东来",
    "messageInitContent_1722": "这里是叫星痕海岛吧，怎么就变成许愿岛了。",
    "messageInitContent_1721": "许愿影曜",
    "messageInitContent_1720": "许愿玖璃",
    "messageInitContent_490": "说起机械键盘当然要选黑轴！",
    "messageInitContent_491": "我觉得红轴更好用！",
    "messageInitContent_1729": "为什么总是针对奶妈",
    "messageInitContent_1728": "总能在赤虹附近见到火神。",
    "messageInitContent_1727": "烤串进化是吧",
    "mapNodeName_1167": "水物馆4号馆",
    "mapNodeName_1166": "裂口之龙",
    "mapNodeName_1165": "深幽水月",
    "mapNodeName_1164": "孵化基地1坑",
    "mapNodeName_1163": "水物馆6号馆",
    "mapNodeName_1162": "希望之光",
    "mapNodeName_1161": "植物园1棚",
    "mapNodeName_1160": "深幽水月",
    "messageInitContent_492": "今次开心鸟哈哈哈",
    "messageInitContent_493": "今次放心鸟",
    "messageInitContent_494": "吞噬者这次又是参加什么节目呢",
    "messageInitContent_495": "这只利爪狼可以闻出谁是单身狗。",
    "messageInitContent_496": "这只利爪狼可以闻出谁是过节没人陪",
    "messageInitContent_497": "这只利爪狼可以闻出谁是最好吃",
    "mapNodeName_1169": "如沸星穹",
    "messageInitContent_498": "这只利爪狼可以闻出谁最菜",
    "mapNodeName_1168": "深幽水月",
    "messageInitContent_499": "森林狼和草原狼哪个厉害点？",
    "messageInitContent_1737": "咱们可以叫他们坑中间",
    "messageInitContent_1736": "是两个大坑的中间",
    "messageInitContent_1735": "这又是坑里吗？",
    "messageInitContent_1734": "请问花丸子有几个头？",
    "messageInitContent_1733": "火神快去找你妹妹，这关就交给我吧！",
    "messageInitContent_1732": "菠菜是一种很危险的生物！",
    "messageInitContent_1731": "下次世界杯可以问问花丸子买哪个吗",
    "messageInitContent_1730": "让我一直躲在结界区域好吗",
    "messageInitContent_1739": "想御空救你就明说",
    "messageInitContent_1738": "在这战斗好危险啊，掉下去需要会飞的粉红色的小姐姐救我",
    "mapNodeName_1156": "音乐盒2节",
    "mapNodeName_1155": "深幽水月",
    "mapNodeName_1154": "深幽水月",
    "mapNodeName_1153": "深幽水月",
    "mapNodeName_1152": "深幽水月",
    "mapNodeName_1151": "水物馆3号馆",
    "mapNodeName_1150": "深幽水月",
    "messageInitContent_1740": "就是因为你们老是这样，桐仁才一直呼叫失败的",
    "mapNodeName_1159": "深幽水月",
    "mapNodeName_1158": "动物园3区",
    "mapNodeName_1157": "鱿鱼游戏",
    "messageInitContent_1748": "ffffffff",
    "messageInitContent_1747": "黯灭这里是友军，同时天涯单身狗，别烧我啊",
    "messageInitContent_1746": "锤爹才是真正的冰火两重天，被夹在中间",
    "messageInitContent_1745": "你们看火心吧自己都热哭了",
    "messageInitContent_1744": "热了还可以凉凉是吧",
    "messageInitContent_1743": "请别动，慢慢享受我们的服务",
    "messageInitContent_1742": "哇哦冰火两重天",
    "messageInitContent_1741": "或者可以先想想去北边的坑还是南边的坑。",
    "messageInitContent_1749": "小黑，我的小黑呢。",
    "messageInitContent_1751": "只有己方奶妈受伤的世界达成了",
    "messageInitContent_1750": "黑子，黑子，我的黑子呢？",
    "messageInitContent_1759": "保护环境人人有责",
    "messageInitContent_1758": "现在荒漠化严重，快停止你们的行为",
    "messageInitContent_1757": "天堂制造！！！！！！！",
    "messageInitContent_1756": "前面古记哦",
    "messageInitContent_1755": "所以四脚兽到底是什么",
    "messageInitContent_1754": "小白在就行了！",
    "messageInitContent_1753": "莎士彼亚怎么又跑出来找灵感了？",
    "messageInitContent_1752": "自家奶可以，对面奶不行。",
    "messageInitContent_1762": "这是怪兽共同生活的家园，我们要保护它",
    "messageInitContent_1761": "怪怪有责是什么鬼",
    "messageInitContent_1760": "保护超进化的环境，怪怪有责",
    "messageInitContent_1769": "西撒——",
    "messageInitContent_1768": "啊有画面了",
    "messageInitContent_1767": "请不要在外面随便使用替身能力，谢谢合作",
    "messageInitContent_1766": "都给我拉出学jojo立",
    "messageInitContent_1765": "这poss不过关啊",
    "messageInitContent_1764": "阿姨压一压~~~",
    "messageInitContent_1763": "我们要根绝纷争！",
    "messageInitNick_1394": "诺贝尔恰瓜奖",
    "messageInitNick_1395": "颜值离线",
    "messageInitNick_1392": "不会撒娇的猫",
    "messageInitNick_1393": "高冷学渣",
    "messageInitNick_1398": "大花裤衩",
    "messageInitNick_1399": "一杯敬自由",
    "messageInitNick_1396": "惊天大片局",
    "messageInitNick_1397": "生命之水",
    "messageInitContent_1773": "所以这里到底是什么地方！",
    "messageInitContent_1772": "魅妆是化妆师！",
    "messageInitContent_1771": "为什么魅妆混在里面了",
    "messageInitContent_1770": "看来不必隐藏了，我们互相吸引到了这里！",
    "messageInitContent_1779": "伤害别人，自己也会受伤。",
    "messageInitContent_1778": "地面的基因条诉说着什么？",
    "messageInitContent_1777": "万圣节就请约定你们了",
    "messageInitContent_1776": "严格意义上魅妆也是尸鬼族的没毛病",
    "messageInitContent_1775": "哇我怕鬼~~~~",
    "messageInitContent_1774": "尸族的巢穴，那当然是！",
    "mapNodeName_1192": "分叉口",
    "mapNodeName_1191": "触涌镜花",
    "mapNodeName_1190": "植物园2棚",
    "messageInitNick_1390": "一夜的憔悴",
    "messageInitNick_1391": "傲娇的小伙子",
    "messageInitNick_1383": "抚琴魅人心",
    "mapNodeName_1199": "深渊的五号位",
    "messageInitNick_1384": "流泪的冰激淋",
    "mapNodeName_1198": "深渊之尾",
    "messageInitNick_1381": "赞已撤回",
    "mapNodeName_1197": "触涌镜花",
    "messageInitNick_1382": "用眼神防守",
    "mapNodeName_1196": "金矿山",
    "messageInitNick_1387": "一笑震九天",
    "mapNodeName_1195": "触涌镜花",
    "messageInitNick_1388": "自信的笑容",
    "mapNodeName_1194": "金色通道",
    "messageInitNick_1385": "健忘的少女",
    "mapNodeName_1193": "动物园4区",
    "messageInitNick_1386": "引战之神",
    "messageInitContent_1784": "反伤c位，真是非它莫属",
    "messageInitContent_1783": "把对面最厉害的怪兽换过来",
    "messageInitContent_1782": "我需要一只可以换位的怪兽。",
    "messageInitNick_1389": "智商又上线",
    "messageInitContent_1781": "伤害别人的滋味。",
    "messageInitContent_1780": "它阅读理解一直可以。",
    "themeCardPackDes_24030": "归灵秘境位于始原荒地的北方，不过回到无佑离岛再从漩涡之门穿行而出后，艾娜璃兹觉得，对于这个世界来说，岛屿的具体位置或许远不如这些神秘的传送门重要。\\n迎接它们的是一排风水老树。\\n也许“迎接”并不确切，它们只是静静地伫立，默默注视着传送门，注视着它们的到来。\\n不久，一只手持月亮权杖的怪兽出现，正在月光下起舞，似乎在与尚未消逝的月光沟通。\\n艾娜璃兹热切地观察着这一切，自动切入分析模式，贪婪地对眼前发生的一切进行解析。\\n它没有注意到的是，始原荒地的小怪兽们已经爬到了一颗风水老树上，吃起了整齐放在上方的果子。\\n“尊敬的万灵，尊敬的秘穴之灵，请原谅它们的饥饿。”\\n实际上，想要了解文明程度较低的区域，并不比解析高度文明的区域更容易。有时，对高文明区域的分析反而更为直接明了。在这些低文明区域，许多信仰和仪式都只存在于想象之中，因此格外晦涩与神秘。尤其是在这片相信万物有灵的土地上，感谢风灵、水灵、孢子灵的祈祷还可以目睹，但要了解感谢石头灵、羽毛灵的祈祷，则需要花费更多时间去了解。\\n当然，对于那些只关心吃喝拉撒的始原小怪兽而言，这一切都不需要它们操心。\\n而对于不断涌现的新鲜文明，艾娜璃兹依然充满兴奋与好奇。\\n因此，前往下一个岛屿的传送门前的一段旅程，恍若一瞬。\\n在进入传送门的最后一刻，艾娜璃兹把跟在它屁股后面的小怪兽撞了回去~它创造了“旧”的污染，也许不该再创造“新”的了。",
    "messageInitNick_1380": "汉堡医生",
    "messageInitNick_1372": "低音男子",
    "messageInitNick_1373": "吃货花花",
    "messageInitNick_1370": "何处买醉",
    "messageInitNick_1371": "爱已停机",
    "messageInitNick_1376": "什么奇怪理解",
    "messageInitNick_1377": "嘻嘻公主",
    "messageInitNick_1374": "只为伊人醉",
    "messageInitNick_1375": "一辈子不后悔",
    "messageInitNick_1378": "薄凉少女",
    "messageInitNick_1379": "咸鱼大队长",
    "themeCardPackDes_24035": "艾娜璃兹穿过传送门后，被眼前的阵仗吓了一跳。秘仪圣域的怪兽们全身涂满奇异的颜料，正围着它跳舞，嘴里忽大忽小地念叨着各种祭祀的咒语。\\n其中一位手持权杖、看起来像部族萨满的怪兽向它躬身致敬：“尊敬的先祖，您竟亲自异界而来！自从那颗星辰坠落后，我们一直感到不安，不断举行祭祀，没想您终于回应了我们！”\\n“我可不是你们太奶！”\\n“尊敬的先祖，我们没能明白您的意思。”\\n“我是说，我并不是你们想象中的那位先祖，呃……顶多算是先祖的……使者吧。先祖派我来，是要看看你们对它们的祭祀是否足够虔诚——需要巨细无遗地告诉我！”话说出口之后，艾娜璃兹马上后悔了，它又违背守则了……\\n那位被称为“智者”的怪兽听后显得更加激动。旁边还有另一位智者，正埋头在羊皮卷轴上记载着先祖使者的形象。\\n一个月后，艾娜璃兹终于还是来到前往灰烬遗迹的传送门前，甩掉那些“智者”可费了它一番功夫。\\n天天烟熏、香薰、还有推不掉的供果，分析也总算结算完毕，它真是呆不下去了，让守则见鬼去吧，反正不撞也撞了，新的文明也是文明！\\n再见了“智者”~它想着穿过了传送门。",
    "themeCardPackDes_24040": "“将一切从那诅咒之门走出来的异端驱逐！”\\n艾娜璃兹刚踏出灰烬传送门就遭到了猛烈的攻击。数十只怪兽手持燃烧的木棍朝它冲来。它可不想回去秘仪圣域，它才刚和天天熏香的日子说了再见。\\n艾娜璃兹快速扫视四周，推测这是信奉火神的地区。\\n“住手！我也是火神的信徒！”\\n可封门守卫们毫不迟疑，继续攻击，招招致命，仿佛将它视作死敌，它不得不展开防御。\\n就在情况陷入僵局之际，几只怪兽突然闯入战场。为首的是一只戴着硕大红帽、身形矮小的怪兽，身后跟着的是一条通体冒火的飞龙，迅速将它掩护撤离。\\n这些怪兽来自一个反对灰烬遗迹元老会统治的部族，曾因被视为异端而被判处死刑。\\n其中一只浑身燃烧着妖异火焰的怪兽缓缓说道：“这个世界已经在悄然改变。那不详的漩涡与划破天际的烈星，都昭示着新纪元的来临。无佑离岛与冰河空渊的猎团、战部，正在从另两座传送门侵袭而来——而元老们却仍固守权柄，闭目塞听。”\\n它顿了顿，眼神灼灼地盯着艾娜璃兹，“我们，要成为改变的火种。你愿意加入吗？”\\n“我会观察一段时间，但不承诺协助。”艾娜璃兹低声回应，说着它不自觉地看向一旁的火堆——这大片的战火，会是火神所爱之火吗？\\n记录下来的那一串串数据与影像，早已与它交缠不清，也许，她早已不再是原来那台刻机Δ-A.00-LZ。\\n是它自己变了？还是被这片土地感染了？\\n它突然发现，自己竟有些怀念归灵秘境的日子——是时候去见见那些小家伙了。",
    "messageInitNick_1361": "笑话点播机",
    "messageInitNick_1362": "住在山海经",
    "messageInitNick_1360": "正太不太乖",
    "messageInitNick_1365": "画饼少女",
    "messageInitNick_1366": "寒江独钓",
    "messageInitNick_1363": "赖你一辈子",
    "messageInitNick_1364": "蓬松的头发",
    "messageInitNick_1369": "捡漏王子",
    "messageInitNick_1367": "叫我女王大人",
    "messageInitNick_1368": "双枪老太婆",
    "messageInitNick_1350": "脑海里没有你",
    "messageInitNick_1351": "霸道迷",
    "messageInitNick_1354": "迟来的陨石",
    "messageInitNick_1355": "头铁王子",
    "messageInitNick_1352": "心动禁令",
    "messageInitNick_1353": "风再吹雨在下",
    "messageInitNick_1358": "吃瓜机器",
    "messageInitNick_1359": "走音门传人",
    "messageInitNick_1356": "你的梦想是",
    "messageInitNick_1357": "饭醉分子",
    "messageInitNick_1340": "单身一人挺好",
    "messageInitNick_1343": "冰吻芙蓉",
    "messageInitNick_1344": "懒懒猫",
    "messageInitNick_1341": "枫无痕",
    "messageInitNick_1342": "醉卧君子膝",
    "messageInitNick_1347": "大雨还在下吗",
    "messageInitNick_1348": "饭桌一号位",
    "messageInitNick_1345": "不再无所谓",
    "messageInitNick_1346": "文案在线卖饼",
    "messageInitNick_1349": "空城计",
    "randomEventDialogueGroupConfig_8.200": "草它没有理你。",
    "resoundEventConfigName_6011": "11.守护爱",
    "resoundEventConfigName_6012": "12.罗密欧的诱惑",
    "resoundEventConfigName_6010": "10.冰雕",
    "mapNodeName_1024": "它在低语",
    "messageInitNick_3991": "通菜女巫",
    "mapNodeName_1023": "勿█荒野",
    "messageInitNick_3990": "蓝莓之心",
    "mapNodeName_1022": "蠕动██",
    "mapNodeName_1021": "蠕动暗域",
    "mapNodeName_1020": "█动暗域",
    "messageInitNick_1332": "夜月未央",
    "messageInitNick_3995": "动情的废物",
    "messageInitNick_1333": "胡渣熟男",
    "messageInitNick_3994": "三无产品",
    "messageInitNick_1330": "认证走音专家",
    "messageInitNick_3993": "沙棘果君快逃",
    "randomEventDialogueGroupConfig_8.209": "告诉它是一个神秘商人的面具",
    "messageInitNick_1331": "该用户已诈尸",
    "messageInitNick_3992": "暴躁寿司",
    "messageInitNick_1336": "会补刀的萌妹",
    "messageInitNick_3999": "吉时已到",
    "randomEventDialogueGroupConfig_8.207": "离开",
    "resoundEventConfigName_6015": "15.灵光一闪",
    "messageInitNick_1337": "被驯服的鹿",
    "messageInitNick_3998": "潮爷",
    "randomEventDialogueGroupConfig_8.208": "你隐约听到它说“谁”。",
    "resoundEventConfigName_6016": "16.面对诱惑",
    "messageInitNick_1334": "大花猫",
    "messageInitNick_3997": "引战爱好者",
    "randomEventDialogueGroupConfig_8.205": "离开",
    "resoundEventConfigName_6013": "13.裤子再见",
    "mapNodeName_1029": "腐化荒野",
    "messageInitNick_1335": "奥特曼",
    "messageInitNick_3996": "演唱会抢票机",
    "randomEventDialogueGroupConfig_8.206": "草没了。",
    "resoundEventConfigName_6014": "14.准备反击",
    "mapNodeName_1028": "恐怖舌头",
    "randomEventDialogueGroupConfig_8.203": "告诉它草不知道",
    "mapNodeName_1027": "█动暗域",
    "randomEventDialogueGroupConfig_8.204": "好吧，我自己再找找。谢谢你。",
    "mapNodeName_1026": "渗透之藤",
    "messageInitNick_1338": "单车少女",
    "randomEventDialogueGroupConfig_8.201": "建议文明用语",
    "resoundEventConfigName_6017": "17.一分为二",
    "mapNodeName_1025": "蠕动暗域",
    "messageInitNick_1339": "强壮卖萌神",
    "randomEventDialogueGroupConfig_8.202": "草它动了几下。原来是神秘商人找到这里来了。",
    "randomEventDialogueGroupConfig_8.210": "它的声音更小了。",
    "randomEventDialogueGroupConfig_8.211": "凑近听",
    "mapNodeName_1013": "毁灭冲动",
    "messageInitNick_3980": "狼魂",
    "mapNodeName_1012": "蠕动暗域",
    "mapNodeName_1011": "███",
    "mapNodeName_1010": "冥界之主",
    "messageInitNick_1321": "超人飞不动了",
    "messageInitNick_3984": "当场约会",
    "messageInitNick_1322": "半个世界下雨",
    "messageInitNick_3983": "小小社恐",
    "messageInitNick_3982": "不会补刀",
    "messageInitNick_1320": "关音大师",
    "messageInitNick_3981": "报时器之王",
    "messageInitNick_1325": "记忆格式化",
    "messageInitNick_3988": "人间怪物",
    "randomEventDialogueGroupConfig_8.218": "尝一尝",
    "22_dish126": "刺客伪装雪糕",
    "messageInitNick_1326": "无敌引战神",
    "messageInitNick_3987": "霸气御姐范",
    "randomEventDialogueGroupConfig_8.219": "走了不找了",
    "themeCardPackDes_24005": "在太古之地，海洋与陆地是完全分开的。陆地悬在天际，大海在底下涌动。\\n五座巨大的空岛悬浮于天际，如鬼魅般点缀苍穹，在大海投下幽深的影子，各自孕育着原始而封闭的文明。这些空岛彼此隔绝，数百年间未曾有过交集，它们信奉着不同的神祇，延续着独特而古老的传统。\\n西北方是极热的焦土大陆——灰烬遗迹。\\n东北方是笼罩着神秘气息的秘仪圣域。\\n中部与西南部，是广袤而严寒的冰河空渊。\\n东部的归灵秘境则草木葱郁，生机盎然。\\n而东南方的始原荒地，则原始而野性。\\n在古老的平衡被打破的前夕，这些空岛上的怪兽以不同的认知“看见”了它——文明刻机Δ-A.00-LZ艾娜璃兹的降临。\\n“划破天际的烈星是火神的怒焰！这是对异端与心怀异心者的警告与惩罚，快，将它们送去浴火之仪，平息火神之怒！”\\n“先祖低语，坠落的星辰预示大灾变。立即祭祀，驱除厄运！”\\n“神抛下试炼之牙，谁能将它收入囊中，谁就是新的首领！”\\n“山灵惊醒，星灵降落。我们必须安抚大地。”\\n“哇咕！天，亮了，两……果子，吃一口，大口！”",
    "mapNodeName_1019": "蠕动暗域",
    "messageInitNick_1323": "飞花逐水流",
    "messageInitNick_3986": "电饭煲之彼端",
    "randomEventDialogueGroupConfig_8.216": "离开",
    "mapNodeName_1018": "蠕动暗█",
    "messageInitNick_1324": "第四重梦境",
    "messageInitNick_3985": "动力引擎人",
    "randomEventDialogueGroupConfig_8.217": "是生草的味道。",
    "mapNodeName_1017": "墙后有谁",
    "messageInitNick_1329": "狂神",
    "randomEventDialogueGroupConfig_8.214": "它喝饱水之后，欢快地转了个圈，有什么东西飞了出来。",
    "mapNodeName_1016": "妄想支配",
    "randomEventDialogueGroupConfig_8.215": "捡起",
    "mapNodeName_1015": "蠕█暗域",
    "messageInitNick_1327": "百事小甜心",
    "randomEventDialogueGroupConfig_8.212": "你终于听出来了，它说的是水。",
    "22_dish124": "摆得灿烂蛋糕",
    "mapNodeName_1014": "蠕动暗域",
    "messageInitNick_1328": "直接摆烂",
    "messageInitNick_3989": "仙堡杠把子",
    "randomEventDialogueGroupConfig_8.213": "给它水",
    "messageInitContent_1803": "啊我的耳朵",
    "randomEventDialogueGroupConfig_8.221": "建议文明用语",
    "messageInitContent_1802": "是不是得带个头盔才能来这里。",
    "randomEventDialogueGroupConfig_8.222": "草它动了几下。原来是神秘商人找到这里来了。",
    "messageInitContent_1801": "接下来为你报道本关天气，偶尔有流星和大炮会炸下来请注意安全",
    "messageInitContent_1800": "这个关卡兽均有1.5门大炮！",
    "randomEventDialogueGroupConfig_8.220": "草它没有理你。",
    "themeCardPackDes_24010": "艾娜璃兹坠落的位置是中部和西南部的空岛。剧烈的冲击使冰河空渊一分为二，其中一部分甚至崩落坠入底下的大海。\\n几乎同时，五座空岛及坠落地块的边缘纷纷浮现出怪异的漩涡。这些漩涡终日旋转不息，无知的锤子或鲁莽的骑兵或许会知道，那是连通不同空岛的无形通道。\\n这些漩涡将会在未来打破了这个世界原有的孤立与隔绝，引发混乱和信仰的动摇，阴影中的裂痕早已不可阻挡地在旧时代中蔓延开来……\\n此刻，艾娜璃兹从海水猛然探出头，死死扒住它的MT型存储器，拼命喘息。它小小的身躯弓起，随着剧烈的咳嗽，一口口将咸涩的海水吐出体外。",
    "messageInitContent_1809": "大火用上妖火是吧",
    "messageInitContent_1808": "小火交给火心，中火加上火神",
    "messageInitContent_1807": "确实，火力全开",
    "messageInitContent_1806": "这里煮饭不错",
    "messageInitContent_1805": "为什么要互相伤害呢",
    "messageInitContent_1804": "大家都是好朋友",
    "mapNodeName_1002": "无名慌█",
    "mapNodeName_1001": "冇名█野",
    "mapNodeName_1000": "零一夜",
    "messageInitNick_1310": "懂高手",
    "messageInitNick_3973": "木莓的冒险",
    "messageInitNick_1311": "像只鹌鹑",
    "messageInitNick_3972": "独钓一江月",
    "messageInitNick_3971": "别恨我痴心",
    "messageInitNick_3970": "起个名字真难",
    "messageInitNick_1314": "背靠暖阳",
    "messageInitNick_3977": "折翅的天使",
    "mapNodeName_1009": "蠕动█域",
    "messageInitNick_1315": "睫毛膏好贵",
    "messageInitNick_3976": "爱淡了梦远了",
    "mapNodeName_1008": "虚诞之地",
    "messageInitNick_1312": "急也没用",
    "messageInitNick_3975": "家里蹲大学",
    "randomEventDialogueGroupConfig_8.227": "离开",
    "mapNodeName_1007": "恶魂之地",
    "messageInitNick_1313": "春来发几枝",
    "messageInitNick_3974": "我来组成头部",
    "mapNodeName_1006": "蠕动暗域",
    "messageInitNick_1318": "说句不好吃的",
    "randomEventDialogueGroupConfig_8.225": "离开",
    "mapNodeName_1005": "双子涡漩",
    "messageInitNick_1319": "冰雪女神",
    "randomEventDialogueGroupConfig_8.226": "草没了。",
    "mapNodeName_1004": "无名荒█",
    "messageInitNick_1316": "在逃皇后",
    "messageInitNick_3979": "新鲜凉茶",
    "randomEventDialogueGroupConfig_8.223": "告诉它草不知道",
    "themeCardPackDes_24015": "不知道过了多久，刺耳而混乱的警报声耗尽了最后一丝能量，终于肯老实安静下来了。\\n艾娜璃兹趴在MT型存储器上大口喘气。它在随着海水的起伏翻了个身，看向陌生的天空。五个巨大的黑影悬浮天际，仿佛也在注视这位突如其来的入侵者。从那块被自己撞碎的黑影中，它似乎感受到了一丝怒意。\\n艾娜璃兹，来自一个很遥远很遥远的世界。那里，对探寻外星文明有一种永恒执着。它和其他文明刻机一起，在对外星文明的无比狂热中被大量“制育”出来。它们被投放到宇宙之中，宛如一株巨大蒲公英的种子，飘向无垠的未知。\\n它们降落在一个又一个星球上，大多时候只能失望而归。若不幸遇上意外，便再也无法返回故乡。只有极少数极其幸运儿，能够在异乡遇到文明，并获得足够返回母星的能量。\\n迷糊间，艾娜璃兹被海浪冲到一片陆地。再次睁开眼时，它发现自己被一大堆未见过却一模一样的生物所包围。一开始，它还以为那就是这个星球的生物呢……\\n不用过多久，它就知道了，那是为了将它抬回去，而被一只名为龙执事的怪兽召唤出来的一大堆鸟龙。而那之中，还混入了一只真正的鸟龙。",
    "mapNodeName_1003": "朽木不朽",
    "messageInitNick_1317": "橙味少女",
    "messageInitNick_3978": "宝驴打野",
    "randomEventDialogueGroupConfig_8.224": "好吧，我自己再找找。谢谢你。",
    "messageInitContent_1814": "请叫我怪兽岛主",
    "themeCardPackDes_24020": "艾娜璃兹跟随着龙执事和鸟龙来到这唯一的海岛——也正是被它自己撞落的那块，当然，只要它不开口，就不会有怪兽知道这一切都是它造成的。它的观测与解析早已悄然启动，只是好不容易才压抑住了在怪兽堆里尖叫的冲动。\\n这里的一切都是前所未见，一切都是，没有例外！\\n唯一让它遗憾的是，按照岛上怪兽的说法和计算，距离它来到这片大地已经过去了好几百个日月，也就是说，它已经错过了好多好多宝贵的观察机会。而且更让它不安的是，它隐约感觉到自己带来的影响，绝非它的歉意能弥补的。\\n接下来的见闻，很快印证了它的担忧。\\n因为它糟糕的着陆，原本一体的冰河空渊被分成了两块。在那以后，那块被砸到海上的岛屿被称作无佑离岛。无佑离岛及其周边，本是冰河空渊气候最温和、资源最丰富的地区。\\n取得陌生文明的信任，对它来说并不困难。所有文明刻机都受过专门的训练和调试，况且无佑离岛的怪兽本就较为开放与包容。龙执事实际上也是一位外来的怪兽，如今也被接纳进猎团之中。\\n“新的漩门猎团马上要出发了，你要和我们一起去狩猎吗？”\\n龙执事刚把艾娜璃兹介绍给新猎团的首领，对方便主动发出了邀请。\\n艾娜璃兹欣然加入，随新猎团一同踏入旋涡，开始在岛屿之间穿行……",
    "messageInitContent_1813": "这座小岛马上就是我的啦",
    "messageInitContent_1812": "隔壁就是海了，现钓现煮",
    "messageInitNick_1309": "热爱和平",
    "messageInitContent_1811": "超进化大陆真是人均美食家",
    "messageInitContent_1810": "还有黯炎古龙可以做炙炎寿司",
    "resoundEventConfigName_6001": "1.冰川谷",
    "messageInitContent_1819": "还是桃花岛吧嘿嘿",
    "messageInitContent_1818": "我第二个",
    "messageInitContent_1817": "我第一个不同意",
    "messageInitContent_1816": "你再说一遍这个岛叫神马？",
    "messageInitContent_1815": "这导这么多大炮，应该叫大炮岛",
    "messageInitNick_3962": "颓废的花瓶",
    "messageInitNick_1300": "宝贝甜心",
    "messageInitNick_3961": "电音萌女",
    "messageInitNick_3960": "遥想花开那年",
    "messageInitNick_1303": "霸气才是王者",
    "messageInitNick_3966": "我解说我自己",
    "resoundEventConfigName_6004": "4.漫画",
    "messageInitNick_1304": "只会口胡",
    "messageInitNick_3965": "给你半分钟",
    "resoundEventConfigName_6005": "5.约定",
    "messageInitNick_1301": "酷还可爱",
    "messageInitNick_3964": "躲哪个房子啊",
    "resoundEventConfigName_6002": "2.爱之雕像",
    "messageInitNick_1302": "悲伤为我鼓掌",
    "messageInitNick_3963": "小树林那次",
    "resoundEventConfigName_6003": "3.秘技",
    "messageInitNick_1307": "空虚寂寞冷",
    "resoundEventConfigName_6008": "8.历险记",
    "messageInitNick_1308": "魔术手",
    "messageInitNick_3969": "三行情书",
    "resoundEventConfigName_6009": "9.冰沙团子",
    "messageInitNick_1305": "补刀爱好者",
    "messageInitNick_3968": "趁年轻折腾吧",
    "resoundEventConfigName_6006": "6.新的“依靠”",
    "messageInitNick_1306": "脸又红了几分",
    "messageInitNick_3967": "没油小鸡",
    "resoundEventConfigName_6007": "7.豆丁",
    "themeCardPackDes_24025": "当艾娜璃兹跟随猎团在大地东南方的始原荒地巡游了半圈后，它便明白，这次猎团的狩猎已接近尾声，而自己的“狩猎”终究还是晚了一步。\\n始原荒地早已被来自冰河空渊和无佑离岛的猎团瓜分，遍地都是破碎的图腾，两个信仰同一狩猎之神的族群，在这里展开了近乎毁灭式的狩猎。据说，这比它们曾在冰原和草原上的狩猎还要轻松，这相当不可思议。\\n直到艾娜璃兹意外发现了始原荒地最后的一个部族，这种不可思议的感觉才消失不见。\\n当艾娜璃兹故作凶狠，叫嚣着要杀光它们、夺走一切时，那个部族的成员锤子、咻咻、呜呜祖拉却仍在悠闲地吃着果子。叉叉听到它要“夺走一切”时，反而吃得更快了。\\n好的，它们完全不在乎未来，看来还不算晚到无可挽回。\\n正当艾娜璃兹愁着如何保存始原荒地最后的“文明”时，冰河空渊和无佑离岛的新旧战团开始为怎么瓜分这里而吵了起来。\\n天上的怪兽坚称，无佑离岛的怪兽因为失去狩猎之神的庇佑，才会从天上坠落，而海岛上的怪兽则反驳说，新猎神已经降临大地，旧猎神已死，应当立刻追随新猎神。\\n争吵最终演变为一场混战。\\n艾娜璃兹趁乱带着始原荒地最后的幸存者，来到了新的漩门前……\\n根据文明刻机的守则，它本不应该介入，可是这一刻它选择相信自己的感受和手心的温度，它拉着叉叉、锤子、咻咻、呜呜祖拉跳进了漩门……",
    "messageInitNick_3951": "健身小哥",
    "messageInitNick_3950": "都是明白人",
    "messageInitNick_3955": "一颗小星星",
    "messageInitNick_3954": "会飞的肥灰猫",
    "messageInitNick_3953": "孤独流玩家",
    "messageInitNick_3952": "都带上了面具",
    "messageInitNick_3959": "谁把流年搁浅",
    "messageInitNick_3958": "玉面天使",
    "messageInitNick_3957": "早上六点半",
    "messageInitNick_3956": "玉米魔法师",
    "messageInitNick_3949": "灵魂检察官",
    "messageInitNick_3940": "悲伤的帅哥",
    "messageInitNick_3944": "嘟起香肠嘴",
    "messageInitNick_3943": "闪耀星光之旅",
    "messageInitNick_3942": "工作使我秃头",
    "messageInitNick_3941": "金牌煮夫",
    "messageInitNick_3948": "海枯的声音",
    "messageInitNick_3947": "爱丽丝的泪",
    "messageInitNick_3946": "脾气不好",
    "messageInitNick_3945": "二哈之舞",
    "messageInitNick_3939": "盖世油猫饼",
    "messageInitNick_3938": "觉醒五叶",
    "messageInitNick_3933": "爱吃猫的鱼",
    "messageInitNick_3932": "青春辣妹",
    "messageInitNick_3931": "蛋挞侦探",
    "messageInitNick_3930": "选择性漏刀",
    "messageInitNick_3937": "一眼盯真",
    "messageInitNick_3936": "榴莲爱好者",
    "messageInitNick_3935": "给杯子把脉",
    "messageInitNick_3934": "从不软弱",
    "messageInitNick_3929": "苹果先锋",
    "messageInitNick_3928": "美丽的莲雾",
    "messageInitNick_3927": "新式拉肠",
    "messageInitNick_3922": "难忘的二哈",
    "messageInitNick_3921": "低调的猫小姐",
    "messageInitNick_3920": "初夏的雨",
    "messageInitNick_3926": "被雨打湿的泪",
    "messageInitNick_3925": "送你小红花",
    "messageInitNick_3924": "食物赏金猎人",
    "messageInitNick_3923": "模特超会扭",
    "messageInitNick_3919": "家人们谁懂啊",
    "messageInitNick_3918": "测测视力",
    "messageInitNick_3917": "有钱花",
    "messageInitNick_3916": "怪兽哪里跑",
    "messageInitNick_3911": "迷路的钩骨",
    "messageInitNick_3910": "算了不骂了",
    "messageInitNick_3915": "蒜苔兽",
    "messageInitNick_3914": "僵尸",
    "messageInitNick_3913": "非常乐观",
    "messageInitNick_3912": "极繁大师",
    "messageInitNick_3908": "你要更新一下",
    "messageInitNick_3907": "嫉妒的魔女",
    "messageInitNick_3906": "跟风先驱",
    "messageInitNick_3905": "梨之心",
    "messageInitNick_3909": "冒充对象",
    "messageInitNick_3900": "薄荷味的盛夏",
    "messageInitNick_3904": "款爷",
    "messageInitNick_3903": "照相工具人",
    "messageInitNick_3902": "选我还是游戏",
    "messageInitNick_3901": "铁球捕捉者",
    "messageInitContent_500": "打篮球吗？当然是锤子厉害。",
    "messageInitContent_501": "死人才能无所畏惧，但我无意加入他们。",
    "messageInitContent_502": "啊哈",
    "messageInitContent_503": "左手右手傻傻分不清。",
    "messageInitContent_504": "反正右手才是黄金右手。",
    "messageInitContent_505": "大炮那个真的越看越像滚筒洗衣机",
    "messageInitContent_506": "炮王，就这？",
    "messageInitContent_507": "总觉得友军危",
    "22_8007": "机智！",
    "22_8008": "真棒！",
    "22_8005": "无敌！",
    "22_8006": "漂亮！",
    "22_8003": "高！",
    "22_8004": "天呐！",
    "22_8001": "强！",
    "22_8002": "猛！",
    "messageInitContent_508": "它们真的是一家人吗站那么远？",
    "22_8000": "秀！",
    "messageInitContent_509": "有没可能是一家人才站那么远。",
    "messageInitContent_511": "三只怪7个技能，只有1个能输出呢",
    "messageInitContent_512": "我现在只认识大飞侠",
    "messageInitContent_513": "我打它们也好“疼”",
    "messageInitContent_514": "我打它们贼疼",
    "messageInitContent_515": "又舔又亲亲。",
    "messageInitContent_516": "来一首《烈焰红唇》",
    "messageInitContent_517": "柔情 绝望 迷失得彻底 你是不是唱错歌词了",
    "messageInitContent_518": "是时候要帮可爱的铁甲龙剪剪指甲了",
    "messageInitContent_510": "它们打我好“疼”",
    "22_8018": "不愧是你！",
    "22_8019": "好起来了！",
    "22_8016": "真嘟假嘟！",
    "22_8017": "你好棒棒！",
    "22_8014": "猴赛雷！",
    "22_8015": "又行了！",
    "22_8012": "牛哇！",
    "22_8013": "泰裤辣！",
    "22_8010": "行哇！",
    "messageInitContent_519": "建议所有轰龙进化之前来这关第二part看看，然后再去38",
    "22_8011": "优秀！",
    "messageInitContent_522": "怎么突然变地方了。",
    "messageInitContent_523": "又又又针对我后排",
    "questionnaireName_10": "问卷10",
    "messageInitContent_524": "虚刃快问问咒刃那里怎么恢复啊！",
    "messageInitContent_525": "看来以后打炎之高兴的时候要小心点才行。",
    "messageInitContent_526": "这场地是不是有什么加成",
    "messageInitContent_527": "有心理加成",
    "messageInitContent_528": "为什么怪兽总是和那里过不去。",
    "messageInitContent_529": "从32来的",
    "22_8009": "好耶！",
    "messageInitContent_520": "千里眼对吧。",
    "messageInitContent_521": "我是轰龙，我想进化为珍宝！",
    "messageInitContent_533": "这位客官请小心被烧伤。",
    "messageInitContent_534": "这位客官，孜然够了吗？",
    "messageInitContent_535": "这位客官，你别动，孜然都掉下去了。",
    "messageInitContent_536": "你好，血刃！我叫兵不",
    "messageInitContent_537": "惊！击剑爱好者增多",
    "messageInitContent_538": "击剑我懂，请问一般在哪里击？",
    "messageInitContent_539": "总觉得呜呜祖拉的发型有点莫西干头",
    "messageInitContent_530": "我是轰龙，我现在纠结得一笔",
    "messageInitContent_531": "我是轰龙，我现在不想进化了",
    "messageInitContent_532": "我想吃烤茄子。",
    "messageInitContent_544": "妖火你的好兄弟妖艳呢",
    "messageInitContent_545": "我觉得我需要一只能奶对面的怪",
    "messageInitContent_546": "这里有2根珍宝呢",
    "messageInitContent_547": "你们好sao哦",
    "messageInitContent_548": "策划又乱放火了？？怒！",
    "messageInitContent_549": "还乱放珍宝",
    "messageInitContent_540": "我真的很怕它手上的刀又把刚恢复的那里砍了",
    "messageInitContent_541": "先担心一下自己的怪兽",
    "messageInitContent_542": "血刃的手是不是也是断的。。",
    "messageInitContent_543": "能不能离远点炸开",
    "messageInitContent_555": "如果你被人劫持了就眨眨眼",
    "messageInitContent_556": "是谁在带歪留言板！？",
    "messageInitContent_557": "复苏之吻，整1个",
    "messageInitContent_558": "兽工呼吸",
    "messageInitContent_559": "还好这舌头和口唇是不长在同一之怪身上",
    "messageInitContent_550": "祖拉你快离开那只北鼻蜻蜓！",
    "messageInitContent_551": "蜻蜓龙就是只北鼻",
    "messageInitContent_552": "如果快乐，你就拍拍手",
    "messageInitContent_553": "如果快乐，你就跺跺脚",
    "messageInitContent_554": "如果快乐，你就伸伸腰",
    "messageInitContent_566": "这四个有点帅！",
    "messageInitContent_567": "是不是少了一个输出",
    "messageInitContent_568": "一个能输出的都没有",
    "messageInitContent_569": "新过场我好爱！",
    "messageInitContent_560": "我宁愿它长在同一只怪身上",
    "messageInitContent_561": "能不能多关注一下神话的英雄",
    "messageInitContent_562": "童话里都是骗人的，那神话里的呢",
    "messageInitContent_563": "神话里的都是唬人的",
    "messageInitContent_564": "以前小时候看过一个动画，那个机器人就是一个大头变身出来的",
    "messageInitContent_565": "暴露年龄了。",
    "messageInitContent_577": "这个游戏又在强调保护那里的重要性",
    "messageInitContent_578": "怪兽只是变小了，才不是消失了！",
    "messageInitContent_579": "怪兽消失术！",
    "messageInitContent_570": "想要那个翅膀",
    "messageInitContent_571": "如果镰刀那把是镰刀，那搜魂兽这把是什么",
    "messageInitContent_572": "大魔王！！！！",
    "messageInitContent_573": "搜索引擎的怪兽？",
    "messageInitContent_574": "想吃烤串了",
    "messageInitContent_575": "我吃烤串的时候也顿悟了一个技能，手肘撒盐攻击",
    "messageInitContent_576": "这个游戏试图教会我烧烤。",
    "messageInitContent_588": "铁甲龙危",
    "messageInitContent_589": "感觉马上就能征服这片大陆了哈哈哈",
    "messageInitContent_580": "为什么到我了就不是浓缩精华了",
    "messageInitContent_581": "小小只好可爱！",
    "messageInitContent_582": "那个拿狼牙棒的打人越来越痛",
    "messageInitContent_583": "速战速决",
    "messageInitContent_584": "英雄啊，真抱歉你的故事刚开始，我就让它结束了。",
    "messageInitContent_585": "腐化者和沼泽有点配",
    "messageInitContent_586": "怪兽的xp系统是自由的",
    "messageInitContent_587": "沼泽烧烤摊",
    "messageInitContent_1825": "神马没有感觉，哇一下子被打4下",
    "messageInitContent_1824": "喂喂，你们在说什么啊",
    "messageInitContent_1823": "别怕很快就会没有感觉的了",
    "messageInitContent_1822": "我怎么觉得是一种惊吓",
    "messageInitContent_1821": "有一种整整齐齐的美感",
    "messageInitContent_1820": "啊这",
    "messageInitContent_590": "赶紧醒醒啊喂",
    "mapNodeName_1060": "潜梦迷潭",
    "messageInitContent_1829": "这里只有美杜杀杀",
    "messageInitContent_1828": "有没有小魔女呢这里",
    "messageInitContent_1827": "魔法之森我来啦",
    "messageInitContent_1826": "蒜泥狠看我逐一击破你们",
    "mapNodeName_1068": "仅剩痕迹",
    "messageInitContent_599": "咒刃让怪的攻击力变弱了",
    "mapNodeName_1067": "狞█之海",
    "mapNodeName_1066": "狞笑█海",
    "mapNodeName_1065": "狞笑之█",
    "mapNodeName_1064": "夜之海",
    "mapNodeName_1063": "潜█迷潭",
    "mapNodeName_1062": "潜梦迷潭",
    "mapNodeName_1061": "潜梦█潭",
    "messageInitContent_591": "爱你3000次",
    "messageInitContent_592": "草、冲、奶、炮？",
    "messageInitContent_593": "就是这4个动词吗？",
    "messageInitContent_594": "其实人间大炮是不是一个炮骑着一直怪兽？",
    "messageInitContent_595": "那么其实危险的草丛是不是危险骑着草丛？",
    "messageInitContent_596": "什么怪均rider",
    "messageInitContent_597": "所以草丛的aoe其实是藏在草丛里的一堆怪兽打出来的单体攻击？",
    "mapNodeName_1069": "潜梦迷潭",
    "messageInitContent_598": "哇，你们脑洞好大。",
    "messageInitContent_1836": "好活",
    "messageInitContent_1835": "先踩扁在串起来！",
    "messageInitContent_1834": "魔网救我！！",
    "messageInitContent_1833": "快变！！！！！",
    "messageInitContent_1832": "给我变！",
    "messageInitContent_1831": "教大家一个魔法咒语，给我变",
    "messageInitContent_1830": "魔法少女也好啊",
    "messageInitContent_1839": "马上这里就是我的了",
    "messageInitContent_1838": "请问哪里有的卖饿了",
    "messageInitContent_1837": "什么？肉丸子批发？",
    "mapNodeName_1057": "坠入冥河",
    "mapNodeName_1056": "狞笑之海",
    "mapNodeName_1055": "█笑之海",
    "mapNodeName_1054": "狞笑之海",
    "mapNodeName_1053": "沉默诱导",
    "mapNodeName_1052": "肌肉痉挛",
    "mapNodeName_1051": "绕星而行",
    "mapNodeName_1050": "狞笑█潮",
    "mapNodeName_1059": "海蛇之眼",
    "mapNodeName_1058": "黑暗切割",
    "messageInitContent_1847": "让制杖巨人997",
    "resoundEventMonumentDes_4": "起源殿挑战次数到达{1}",
    "messageInitContent_1846": "恐怕没有形形吧",
    "resoundEventMonumentDes_5": "狩猎积分到达{1}",
    "messageInitContent_1845": "是形形色色的东西",
    "resoundEventMonumentDes_2": "起源殿段位到达{1}",
    "messageInitContent_1844": "总之不是黄色！",
    "resoundEventMonumentDes_3": "斗技场挑战次数到达{1}",
    "messageInitContent_1843": "你们满脑子都是什么东西！",
    "resoundEventMonumentDes_8": "怪兽等级到达{1}",
    "messageInitContent_1842": "让我想想把这里收入囊中之后，这里可以做什么生意",
    "resoundEventMonumentDes_9": "怪兽基因强化等级到达{1}",
    "messageInitContent_1841": "1234567多劳多得！",
    "resoundEventMonumentDes_6": "狩猎战胜敌人次数到达{1}",
    "messageInitContent_1840": "之后就好好给我打工把你们！",
    "resoundEventMonumentDes_7": "探索者等级到达{1}",
    "messageInitContent_1849": "这里我想好了，让kb去当5毛",
    "messageInitContent_1848": "你是懂生意的",
    "mapNodeName_1046": "狂躁乐声",
    "mapNodeName_1045": "红雨",
    "mapNodeName_1044": "怪笑",
    "mapNodeName_1043": "狞笑██",
    "mapNodeName_1042": "█笑之海",
    "mapNodeName_1041": "深潜海峡",
    "mapNodeName_1040": "受害者",
    "messageInitContent_1850": "尸狂可以卖唱",
    "mapNodeName_1049": "狞笑之█",
    "mapNodeName_1048": "狞█之海",
    "mapNodeName_1047": "无端燃烧",
    "messageInitContent_1858": "你一票我一票珍宝明天就出道！",
    "randomEventDialogueGroupConfig_7.2": "-",
    "messageInitContent_1857": "珍宝真是无处不在啊",
    "randomEventDialogueGroupConfig_7.3": "-",
    "messageInitContent_1856": "这里也能看到珍宝呢",
    "messageInitContent_1855": "懂王在此！",
    "randomEventDialogueGroupConfig_7.1": "你还没意识到你撞到了什么，就听到有谁在大喊大叫。",
    "messageInitContent_1854": "这个kb侠懂",
    "messageInitContent_1853": "就好像你们口嗨需要许可的吗",
    "messageInitContent_1852": "这里经营需要许可的吗",
    "messageInitContent_1851": "包装一下就可以出道了",
    "messageInitContent_1859": "警惕饭圈文化",
    "mapNodeName_1035": "疯狂支点",
    "mapNodeName_1034": "无█荒野",
    "mapNodeName_1033": "沸热炼狱",
    "mapNodeName_1032": "古记战役-蠕动恶兽",
    "mapNodeName_1031": "电刑器",
    "mapNodeName_1030": "无穷蠕动",
    "messageInitContent_1861": "有啊不能浪费食物啊",
    "messageInitContent_1860": "什么吃饭有什么文化",
    "randomEventDialogueGroupConfig_7.8": "咦，刚刚没撞到吗，那再撞过好了。",
    "randomEventDialogueGroupConfig_7.9": "这个年头，像你这么积极主动的还真……不少……",
    "mapNodeName_1039": "狞笑之█",
    "randomEventDialogueGroupConfig_7.6": "-",
    "mapNodeName_1038": "潜梦迷潭",
    "randomEventDialogueGroupConfig_7.7": "-",
    "resoundEventMonumentDes_1": "任意斗技场段位到达{1}",
    "mapNodeName_1037": "潜梦囚笼",
    "randomEventDialogueGroupConfig_7.4": "-",
    "mapNodeName_1036": "禁忌亡语",
    "randomEventDialogueGroupConfig_7.5": "-",
    "messageInitContent_1869": "其实举着独角兽的真的是独角兽吗",
    "messageInitContent_1868": "独角兽整天举着头不累的吗",
    "messageInitContent_1867": "前面走错游戏啦！",
    "messageInitContent_1866": "我想要天女兽，请问在哪里可以得到",
    "messageInitContent_1865": "人家根本没有那种进化关系好吗",
    "messageInitContent_1864": "独角兽究极进化！穿角兽",
    "messageInitContent_1863": "独角兽是被绑过来的吗怎么只有它一直究极",
    "messageInitContent_1862": "还有餐桌礼仪呀",
    "messageInitNick_1295": "龅牙兔",
    "messageInitNick_1296": "风与歌姬",
    "messageInitNick_1293": "黑糖家族",
    "messageInitNick_1294": "快说谢谢老板",
    "messageInitNick_1299": "无敌卷哥",
    "messageInitNick_1297": "从校服到婚纱",
    "messageInitNick_1298": "大脑准生证",
    "messageInitContent_1872": "噢，这是什么新型的娱乐活动！",
    "messageInitContent_1871": "可以把蜻蜓龙放到炮口然后发射出去嘛",
    "messageInitContent_1870": "细思极恐！",
    "messageInitContent_1879": "你只管开车办法由老爹来想",
    "messageInitContent_1878": "这条路通往何方。",
    "messageInitContent_1877": "会不会这一切都是幻觉",
    "messageInitContent_1876": "不是，它们打我的怪兽还是疼的",
    "messageInitContent_1875": "这里的都是幻象吗",
    "messageInitContent_1874": "比蒙巨炮游乐园，欢迎您",
    "messageInitContent_1873": "那这关就卖门票吧",
    "mapNodeName_1093": "肉肉山",
    "mapNodeName_1092": "月下之兽",
    "mapNodeName_1091": "腐█之瞳",
    "mapNodeName_1090": "腐██瞳",
    "messageInitNick_1291": "连续的奇迹",
    "messageInitNick_1292": "半萌半可爱",
    "messageInitNick_1290": "卷帝",
    "messageInitNick_1284": "不是本人",
    "messageInitNick_1285": "荷鲁斯神",
    "mapNodeName_1099": "墙后有怪",
    "messageInitNick_1282": "康忙北鼻",
    "mapNodeName_1098": "无名荒█",
    "messageInitNick_1283": "热泪挥洒如雨",
    "mapNodeName_1097": "金矿山",
    "messageInitNick_1288": "呆萌小怪兽",
    "mapNodeName_1096": "镜中的脸庞",
    "messageInitNick_1289": "达芬奇的画布",
    "mapNodeName_1095": "腐败之瞳█",
    "messageInitNick_1286": "诺贝尔幼稚奖",
    "mapNodeName_1094": "仿如逃离",
    "messageInitNick_1287": "鳳凰浴火焚身",
    "messageInitContent_1883": "你对脖子是有什么执念。",
    "messageInitContent_1882": "真想给它们装个脖子",
    "messageInitContent_1881": "哪有做司机不危险的道理",
    "messageInitContent_1880": "但这司机好危险呐",
    "messageInitContent_1889": "进来先检测一下弱点是吧",
    "messageInitContent_1888": "很好，这关就做成教育培训机构！",
    "messageInitContent_1887": "突破极限就可以进化了吗",
    "messageInitContent_1886": "突破极限！",
    "messageInitContent_1885": "滴滴滴滴滴滴滴",
    "messageInitContent_1884": "怪兽是可以没有脖子滴滴滴滴滴滴滴",
    "mapNodeName_1082": "腐败之瞳",
    "mapNodeName_1081": "金矿山",
    "mapNodeName_1080": "剧毒幻创",
    "messageInitNick_1280": "木偶娃娃音",
    "messageInitNick_1281": "抱着星星睡觉",
    "messageInitNick_1273": "六道",
    "mapNodeName_1089": "腐败之瞳",
    "messageInitNick_1274": "故事还在继续",
    "mapNodeName_1088": "无常",
    "messageInitNick_1271": "黑色曼陀罗",
    "mapNodeName_1087": "腐败█眼",
    "messageInitNick_1272": "特长普度众生",
    "mapNodeName_1086": "腐█之瞳",
    "messageInitNick_1277": "倍儿坚强",
    "mapNodeName_1085": "█败之瞳",
    "messageInitNick_1278": "阿伟输了",
    "mapNodeName_1084": "如沸星穹",
    "messageInitNick_1275": "抱歉不够大",
    "mapNodeName_1083": "腐败█瞳",
    "messageInitNick_1276": "倔强的温柔",
    "messageInitContent_1894": "食不食油饼？",
    "messageInitContent_1893": "我要少女踩的肉饼。",
    "messageInitContent_1892": "你们也是飞天意面教的吗",
    "messageInitNick_1279": "不敢听情歌",
    "messageInitContent_1891": "然后就开始安利一下咱们的组织",
    "messageInitContent_1890": "你们是懂赚钱的",
    "messageInitContent_1899": "掉地上的呢？几秒都不能吃",
    "messageInitContent_1898": "你这只是生存，",
    "messageInitContent_1897": "我的信条是煮熟就能吃",
    "messageInitContent_1896": "吃货看着你们这样好慌",
    "messageInitContent_1895": "来一桶老坛酸菜噜",
    "mapNodeName_1071": "潜█迷潭",
    "mapNodeName_1070": "潜梦迷█",
    "messageInitNick_1270": "臭屁老哥",
    "mapNodeName_1079": "潜██潭",
    "messageInitNick_1262": "久违的心跳",
    "mapNodeName_1078": "血色裂口",
    "messageInitNick_1263": "香草味布丁",
    "mapNodeName_1077": "潜梦迷█",
    "messageInitNick_1260": "蹦哒熊",
    "mapNodeName_1076": "█梦迷潭",
    "messageInitNick_1261": "正版酱油",
    "mapNodeName_1075": "潜梦迷潭",
    "messageInitNick_1266": "勿挽旧人",
    "mapNodeName_1074": "潜梦██",
    "messageInitNick_1267": "单身成瘾",
    "mapNodeName_1073": "诡潮传送门II",
    "messageInitNick_1264": "尬聊大王",
    "mapNodeName_1072": "炼狱电眼",
    "messageInitNick_1265": "单色少年",
    "messageInitNick_1268": "飞翔的板儿砖",
    "messageInitNick_1269": "悲痛拽少",
    "randomEventDialogueGroupConfig_8.122": "它吓了一跳把你的手甩开，然后跑了。",
    "randomEventDialogueGroupConfig_8.123": "离开",
    "randomEventDialogueGroupConfig_8.120": "继续躺平",
    "messageInitContent_190": "下面还有其他tap的，它只是某个地方的mvp",
    "randomEventDialogueGroupConfig_8.121": "离开",
    "messageInitContent_191": "问题来了，拿输出MVP的是前面那只还是后面那只？",
    "messageInitContent_192": "分叉的道路出现了！",
    "messageInitContent_193": "你们说的东西哪里看的啊？？？？？？",
    "messageInitContent_194": "战斗结束后的3条丨丨丨",
    "mapNodeName_1343": "始原荒地",
    "mapNodeName_1342": "如沸星穹",
    "mapNodeName_1341": "始原侵入",
    "mapNodeName_1340": "始原荒地",
    "messageInitContent_195": "快来一串星刃丸子串，不好吃不要钱！",
    "messageInitContent_196": "总觉得星刃是不是长反了，其实头顶上的是jiojio",
    "mapNodeName_1349": "始原荒地",
    "messageInitContent_197": "头顶是jio那个你别跑，再也回不去了！",
    "randomEventDialogueGroupConfig_8.128": "起身离开",
    "mapNodeName_1348": "始原荒地",
    "messageInitContent_198": "我要这个的周边！然后搓搓搓搓搓搓搓搓搓搓搓搓",
    "randomEventDialogueGroupConfig_8.129": "我的面具掉了，帮我一起找找吧！",
    "mapNodeName_1347": "始原荒地",
    "messageInitContent_199": "举报一下，这里有个疯子",
    "randomEventDialogueGroupConfig_8.126": "离开",
    "mapNodeName_1346": "始原荒地",
    "randomEventDialogueGroupConfig_8.127": "高涨的水面让你难以躺平。",
    "mapNodeName_1345": "始原荒地",
    "randomEventDialogueGroupConfig_8.124": "地面开始积水，感觉仿佛在说再不走脑子就会进水了。",
    "mapNodeName_1344": "始原荒地",
    "randomEventDialogueGroupConfig_8.125": "继续躺平",
    "randomEventDialogueGroupConfig_8.133": "一口拒绝",
    "randomEventDialogueGroupConfig_8.134": "唔……那是我的宝物，纯白色的。#我不能没有了那个面具，请帮帮我！",
    "randomEventDialogueGroupConfig_8.131": "说可以帮它找",
    "randomEventDialogueGroupConfig_8.132": "答应一起找并索要报酬",
    "randomEventDialogueGroupConfig_8.130": "问是那具体是什么面具",
    "mapNodeName_1332": "始原之眼",
    "mapNodeName_1331": "始原荒地",
    "mapNodeName_1330": "始原荒地",
    "mapNodeName_1339": "始原荒地",
    "mapNodeName_1338": "始原荒地",
    "randomEventDialogueGroupConfig_8.139": "漫不经心地在草里找",
    "mapNodeName_1337": "始原荒地",
    "mapNodeName_1336": "始原荒地",
    "randomEventDialogueGroupConfig_8.137": "说没什么是不能失去的",
    "mapNodeName_1335": "始原荒地",
    "randomEventDialogueGroupConfig_8.138": "说完它又俯下身继续摸索起来了。",
    "mapNodeName_1334": "始原荒地",
    "randomEventDialogueGroupConfig_8.135": "追问面具的特别之处",
    "mapNodeName_1333": "始原荒地",
    "randomEventDialogueGroupConfig_8.136": "它小声地说道。",
    "randomEventDialogueGroupConfig_8.144": "谢谢你帮我找呢，我已经找到啦，开心。",
    "randomEventDialogueGroupConfig_8.145": "离开",
    "randomEventDialogueGroupConfig_8.142": "它向你挥了挥手就离开了。",
    "randomEventDialogueGroupConfig_8.143": "离开",
    "randomEventDialogueGroupConfig_8.140": "认真地地在草里找",
    "randomEventDialogueGroupConfig_8.141": "摸一会就溜走",
    "mapNodeName_1319": "香蕉之灵",
    "mapNodeName_1321": "始原传送门I",
    "mapNodeName_1320": "金矿山",
    "mapNodeName_1329": "始原荒地",
    "mapNodeName_1328": "始原荒地",
    "mapNodeName_1327": "始原酋长",
    "mapNodeName_1326": "始原荒地",
    "mapNodeName_1325": "始原荒地",
    "randomEventDialogueGroupConfig_8.148": "起身放手",
    "mapNodeName_1324": "始原荒地",
    "randomEventDialogueGroupConfig_8.149": "你怎么还在这？你看到了吧，你看到了吧？我的秘密！",
    "mapNodeName_1323": "始原荒地",
    "randomEventDialogueGroupConfig_8.146": "托你的福，我找到面具了，那我先走啦。",
    "mapNodeName_1322": "始原荒地",
    "randomEventDialogueGroupConfig_8.147": "起身握住不放",
    "randomEventDialogueGroupConfig_8.155": "它面露凶光，对你发起了攻击。",
    "randomEventDialogueGroupConfig_8.156": "反击",
    "randomEventDialogueGroupConfig_8.153": "它对你发起了攻击。",
    "randomEventDialogueGroupConfig_8.154": "反击",
    "randomEventDialogueGroupConfig_8.151": "赞美它的容貌",
    "randomEventDialogueGroupConfig_8.152": "说认识它而且希望得到纪念爪印",
    "mapNodeName_1309": "至尊火灵",
    "mapNodeName_1308": "归灵秘境",
    "randomEventDialogueGroupConfig_8.150": "说不知道什么秘密",
    "mapNodeName_1310": "万花之灵",
    "mapNodeName_1318": "？？？？",
    "mapNodeName_1317": "神亦有灵",
    "mapNodeName_1316": "归灵秘境",
    "mapNodeName_1315": "归灵秘境",
    "mapNodeName_1314": "一生一世",
    "randomEventDialogueGroupConfig_8.159": "喏，说好的报酬。",
    "mapNodeName_1313": "归灵秘境",
    "mapNodeName_1312": "万物有灵",
    "randomEventDialogueGroupConfig_8.157": "好心的家伙，托您的福我已经找到啦！",
    "mapNodeName_1311": "归灵秘境",
    "randomEventDialogueGroupConfig_8.158": "它穿过草丛向你的方向飞奔而来接过面具。",
    "mapNodeName_1387": "灰烬守护",
    "messageInitNick_1691": "国民软妹",
    "mapNodeName_1386": "灰烬遗迹",
    "messageInitNick_1692": "年轻的弟弟呦",
    "mapNodeName_1385": "灰烬传送门Ⅲ",
    "mapNodeName_1384": "灰烬守卫",
    "messageInitNick_1690": "忧郁机器",
    "mapNodeName_1383": "灰烬遗迹",
    "messageInitNick_1695": "先逃了",
    "mapNodeName_1382": "灰烬遗迹",
    "messageInitNick_1696": "超级跑调神",
    "mapNodeName_1381": "灰烬遗迹",
    "messageInitNick_1693": "霸道你小爷",
    "mapNodeName_1380": "灰烬审判",
    "messageInitNick_1694": "扛刀女痞",
    "messageInitNick_1699": "不败的传说",
    "messageInitNick_1697": "好活当赏",
    "messageInitNick_1698": "穿越海的鲸鱼",
    "mapNodeName_1389": "灰烬遗迹",
    "mapNodeName_1388": "灰烬遗迹",
    "mapNodeName_1376": "灰烬遗迹",
    "messageInitNick_1680": "熬夜高手",
    "mapNodeName_1375": "灰烬遗迹",
    "messageInitNick_1681": "不再打扰",
    "mapNodeName_1374": "灰烬暗卫",
    "mapNodeName_1373": "灰烬遗迹",
    "mapNodeName_1372": "灰烬使徒",
    "messageInitNick_1684": "八方",
    "mapNodeName_1371": "灰烬使者",
    "messageInitNick_1685": "娇似小仙女",
    "visionSagesTips_10": "-",
    "mapNodeName_1370": "灰烬传送门II",
    "messageInitNick_1682": "折成旧日时光",
    "messageInitNick_1683": "残冰利刃",
    "messageInitNick_1688": "半醉人间",
    "visionSagesTips_13": "-",
    "messageInitNick_1689": "不在服务区",
    "messageInitNick_1686": "吃瓜之神",
    "visionSagesTips_11": "-",
    "messageInitNick_1687": "暗恋不如不恋",
    "visionSagesTips_12": "-",
    "mapNodeName_1379": "灰烬遗迹",
    "mapNodeName_1378": "灰烬遗迹",
    "mapNodeName_1377": "灰烬遗迹",
    "randomEventDialogueGroupConfig_8.100": "它不自觉地跟你握了握手，再把你拉了起来。",
    "randomEventDialogueGroupConfig_8.101": "它礼貌又不尴尬地笑了笑，然后离开了。",
    "mapNodeName_1365": "灰烬遗迹",
    "mapNodeName_1364": "灰烬遗迹",
    "messageInitNick_1670": "潮流少女",
    "mapNodeName_1363": "灰烬试炼",
    "mapNodeName_1362": "火神萨满",
    "mapNodeName_1361": "灰烬遗迹",
    "messageInitNick_1673": "霸气纯爷们",
    "mapNodeName_1360": "金矿山",
    "messageInitNick_1674": "霸占你的灵魂",
    "messageInitNick_1671": "沉默代替所有",
    "messageInitNick_1672": "欧气膨胀",
    "messageInitNick_1677": "裸奔的青春",
    "randomEventDialogueGroupConfig_8.108": "继续躺平",
    "messageInitNick_1678": "椅子王",
    "randomEventDialogueGroupConfig_8.109": "离开",
    "messageInitNick_1675": "狼魂",
    "randomEventDialogueGroupConfig_8.106": "离开",
    "messageInitNick_1676": "重新定义引战",
    "randomEventDialogueGroupConfig_8.107": "你感受到了略微发烫又干燥的大地。",
    "mapNodeName_1369": "灰烬守卫",
    "randomEventDialogueGroupConfig_8.104": "你闻到了青草的香气。",
    "mapNodeName_1368": "灰烬遗迹",
    "randomEventDialogueGroupConfig_8.105": "继续躺平",
    "mapNodeName_1367": "灰烬遗迹",
    "messageInitNick_1679": "海猫鸣泣之时",
    "randomEventDialogueGroupConfig_8.102": "继续躺平",
    "mapNodeName_1366": "灰烬遗迹",
    "randomEventDialogueGroupConfig_8.103": "起身离开",
    "randomEventDialogueGroupConfig_8.111": "继续躺平",
    "randomEventDialogueGroupConfig_8.112": "离开",
    "randomEventDialogueGroupConfig_8.110": "温暖的不知道什么光洒在你的身上。",
    "mapNodeName_1354": "灰烬守卫",
    "mapNodeName_1353": "灰烬传送门I",
    "mapNodeName_1352": "始原传送门II",
    "mapNodeName_1351": "始原荒地",
    "mapNodeName_1350": "始原荒地",
    "messageInitNick_1662": "小傲娇",
    "messageInitNick_1663": "强迫症患者",
    "messageInitNick_1660": "霸气四溅",
    "messageInitNick_1661": "冰封的虫子",
    "messageInitNick_1666": "保住呢份工",
    "randomEventDialogueGroupConfig_8.119": "身边的草先是被暴雨压倒在地，很快又卷曲着回弹到原来的形状。",
    "messageInitNick_1667": "前方说书反应",
    "messageInitNick_1664": "临渊羡鱼",
    "randomEventDialogueGroupConfig_8.117": "继续躺平",
    "mapNodeName_1359": "火焰瀑布",
    "messageInitNick_1665": "钱定今生",
    "randomEventDialogueGroupConfig_8.118": "离开",
    "mapNodeName_1358": "灰烬遗迹",
    "randomEventDialogueGroupConfig_8.115": "离开",
    "mapNodeName_1357": "灰烬遗迹",
    "randomEventDialogueGroupConfig_8.116": "雨越下越大。",
    "mapNodeName_1356": "火神化身",
    "messageInitNick_1668": "搭讪小达人",
    "randomEventDialogueGroupConfig_8.113": "突然几滴雨水落到你身上，下雨了。",
    "mapNodeName_1355": "灰烬遗迹",
    "messageInitNick_1669": "爱闹的小情绪",
    "randomEventDialogueGroupConfig_8.114": "继续躺平",
    "randomEventDialogueGroupConfig_9.85": "告别",
    "randomEventDialogueGroupConfig_9.84": "当我提出这个问题时，不是我有问题，而是我觉得……不说了，溜了溜了。",
    "randomEventDialogueGroupConfig_9.83": "-",
    "randomEventDialogueGroupConfig_9.82": "苦口婆心",
    "randomEventDialogueGroupConfig_9.81": "它靠近你。",
    "randomEventDialogueGroupConfig_9.80": "这又是要干嘛呢？",
    "randomEventDialogueGroupConfig_9.79": "你把我看穿了！太可怕了。如果我一开始能像你一样果断就好。再见！",
    "messageInitNick_1651": "从不逃课",
    "randomEventDialogueGroupConfig_9.78": "离开",
    "messageInitNick_1652": "可爱的小恶魔",
    "randomEventDialogueGroupConfig_9.77": "这是一处熟悉又陌生的区域，你隐约听到了“别抢位置啊**？”的声音之后，就失去了意识。",
    "randomEventDialogueGroupConfig_9.76": "离开",
    "messageInitNick_1650": "订阅笑颜",
    "randomEventDialogueGroupConfig_9.75": "这是一处熟悉又陌生的区域，你隐约听到了“选这个走中没事吧？”的声音之后，就失去了意识。",
    "messageInitNick_1655": "打铁的白金",
    "messageInitNick_1656": "旧街里的鼠标",
    "messageInitNick_1653": "冰美式的苦",
    "messageInitNick_1654": "随它吧",
    "messageInitNick_1659": "残冬醉离殇",
    "messageInitNick_1657": "甩锅之神",
    "messageInitNick_1658": "涉江采芙蓉",
    "randomEventDialogueGroupConfig_9.96": "问它说的这位朋友是不是……",
    "randomEventDialogueGroupConfig_9.95": "就是我的朋友。",
    "randomEventDialogueGroupConfig_9.94": "-",
    "randomEventDialogueGroupConfig_9.93": "你说的这个朋友……",
    "randomEventDialogueGroupConfig_9.92": "“我朋友啊。”",
    "randomEventDialogueGroupConfig_9.91": "唱跳",
    "randomEventDialogueGroupConfig_9.90": "你继续？",
    "messageInitNick_1640": "蝶蝶蝶蝶变",
    "randomEventDialogueGroupConfig_9.89": "跳舞",
    "messageInitNick_1641": "感叹号乘三",
    "randomEventDialogueGroupConfig_9.88": "你的行为让我感到了迷惑。",
    "randomEventDialogueGroupConfig_9.87": "反复横跳",
    "randomEventDialogueGroupConfig_9.86": "天呐我是不是说错什么了害你变成这样？",
    "messageInitNick_1644": "你故事的配角",
    "messageInitNick_1645": "风筝断了线",
    "messageInitNick_1642": "时隔亿光年",
    "messageInitNick_1643": "野惯了",
    "messageInitNick_1648": "五行缺一根筋",
    "messageInitNick_1649": "仙堡杠把子",
    "messageInitNick_1646": "嘟嘟嘟占线中",
    "messageInitNick_1647": "疯宝宝",
    "messageInitNick_1639": "薄灯少年",
    "randomEventDialogueGroupConfig_9.63": "它看着你哇的一下哭了出来，然后跑了。",
    "randomEventDialogueGroupConfig_9.62": "努力解释",
    "randomEventDialogueGroupConfig_9.61": "气死我了！你是不搞了什么鬼，怎么可能，我不信，我不信——",
    "randomEventDialogueGroupConfig_9.60": "超大包",
    "randomEventDialogueGroupConfig_9.59": "超大包",
    "randomEventDialogueGroupConfig_9.58": "超大包",
    "randomEventDialogueGroupConfig_9.57": "超大包",
    "randomEventDialogueGroupConfig_9.56": "超大包",
    "messageInitNick_1630": "空投在前方",
    "randomEventDialogueGroupConfig_9.55": "它又从兜里掏出了五个超大包。",
    "randomEventDialogueGroupConfig_9.54": "说就要吃",
    "randomEventDialogueGroupConfig_9.53": "嘿嘿，不给你。难到你没听说过，陌生怪兽给食物不能随便吃吗？",
    "messageInitNick_1633": "破防之王",
    "messageInitNick_1634": "午夜狗叫",
    "messageInitNick_1631": "吃货一枚",
    "messageInitNick_1632": "吾乃大白兔",
    "messageInitNick_1637": "超级抬杠神",
    "messageInitNick_1638": "我是学生",
    "messageInitNick_1635": "初夏的雨点",
    "messageInitNick_1636": "同窗的你",
    "messageInitNick_1628": "揪揪揪揪心",
    "messageInitNick_1629": "沧桑一梦",
    "randomEventDialogueGroupConfig_9.74": "离开",
    "randomEventDialogueGroupConfig_9.73": "这是一处熟悉又陌生的区域，你隐约听到了“装备都不买吗？”的声音之后，就失去了意识。",
    "randomEventDialogueGroupConfig_9.72": "你说我们可能不是第一次见！这不可能！",
    "randomEventDialogueGroupConfig_9.71": "选右边的路追",
    "iapBuyConfigName_4": "128元彩钻",
    "randomEventDialogueGroupConfig_9.70": "选左边的路追",
    "iapBuyConfigName_5": "328元彩钻",
    "iapBuyConfigName_6": "648元彩钻",
    "iapBuyConfigName_1": "6元彩钻",
    "iapBuyConfigName_2": "30元彩钻",
    "randomEventDialogueGroupConfig_9.69": "选中间的路追",
    "iapBuyConfigName_3": "68元彩钻",
    "randomEventDialogueGroupConfig_9.68": "它越跑越远，然后在一个三岔路口消失了。",
    "randomEventDialogueGroupConfig_9.67": "追",
    "randomEventDialogueGroupConfig_9.66": "呜呜呜，你别过来啊——",
    "randomEventDialogueGroupConfig_9.65": "放它走",
    "randomEventDialogueGroupConfig_9.64": "追上",
    "messageInitNick_1622": "嘀嘀哒",
    "messageInitNick_1623": "跟空气撒个娇",
    "messageInitNick_1620": "薄荷味的盛夏",
    "messageInitNick_1621": "局外人",
    "messageInitNick_1626": "白日梦想家",
    "messageInitNick_1627": "捣蛋鬼",
    "messageInitNick_1624": "冰淇淋的夏天",
    "messageInitNick_1625": "波板糖",
    "messageInitNick_1619": "懒懒喵喵",
    "messageInitNick_1617": "恰瓜门传人",
    "messageInitNick_1618": "爱留在了春天",
    "tutorialConfigName_1": "万能说明书",
    "tutorialConfigName_2": "建造饲星坛",
    "tutorialConfigName_3": "基因强化",
    "mapNodeName_1307": "影灵花箭",
    "messageInitNick_1611": "花开时花落",
    "mapNodeName_1306": "归灵秘境",
    "messageInitNick_1612": "游戏结束",
    "mapNodeName_1305": "归灵秘境",
    "mapNodeName_1304": "海灵永恒",
    "messageInitNick_1610": "本事小脾气大",
    "mapNodeName_1303": "鱼灵知道未来",
    "messageInitNick_1615": "大灰狼不吃熊",
    "mapNodeName_1302": "漆黑灵件",
    "messageInitNick_1616": "美人持剑",
    "mapNodeName_1301": "归灵秘境",
    "messageInitNick_1613": "回忆在纠缠",
    "mapNodeName_1300": "海带浓骨汤",
    "messageInitNick_1614": "摸鱼机器",
    "messageInitNick_1608": "微风拂晓城",
    "messageInitNick_1609": "放码过来",
    "messageInitNick_1606": "粉红色的空气",
    "messageInitNick_1607": "钓鱼神",
    "tutorialConfigName_8": "建造木场",
    "tutorialConfigName_9": "建造鳞场",
    "tutorialConfigName_4": "上阵朱雀",
    "tutorialConfigName_5": "上阵三只怪兽",
    "tutorialConfigName_6": "元核强化",
    "tutorialConfigName_7": "建造骨场",
    "messageInitNick_1600": "口黑女古女良",
    "messageInitNick_1601": "不会撒谎的猫",
    "messageInitNick_1604": "伴月落",
    "messageInitNick_1605": "不正经的草莓",
    "messageInitNick_1602": "反正沉默了",
    "messageInitNick_1603": "树上的咸鱼",
    "randomEventDialogueGroupConfig_9.99": "问它知道为什么还这样",
    "randomEventDialogueGroupConfig_9.98": "戒赌？哦，你是想说要戒掉那种想法是吧，那种以为用很小的代价得到更多的诱人设想。#特别是投入之后却什么都得不到时的不甘心，让人下一次越发期待，渐渐陷入无法自拔的黑洞。",
    "randomEventDialogueGroupConfig_9.97": "表示懂了",
    "96_moorRank": "暴走旷野排行榜",
    "messageInitContent_1549": "你们能不能打血多的呢",
    "messageInitContent_1548": "喂喂，超进化委员会吗，这里有2个拿着大砍刀的大汉，我好怕哦",
    "messageInitContent_1547": "我需要输血，请赶紧来冰谷这边，救我",
    "messageInitContent_1546": "不是我，我血好多的！",
    "messageInitContent_1545": "前面有小红帽哦",
    "messageInitContent_1544": "你们被我一个人包围了！",
    "messageInitContent_1543": "让小家伙来得更猛烈一点吧！",
    "messageInitContent_1553": "珍宝永远走在最前!",
    "messageInitContent_1552": "在被解决之前把对手解决就好了",
    "messageInitContent_1551": "还好谱架鸟不在呢",
    "messageInitContent_1550": "谁来爱心献血",
    "messageInitContent_1559": "古龙：你们都要被我烤了吃",
    "messageInitContent_1558": "我铵盐古龙不要面子的吗",
    "messageInitContent_1557": "永远的3号位",
    "messageInitContent_1556": "狸猫也永远在补位",
    "messageInitContent_1555": "你看尸狂，好生气的样子！",
    "messageInitContent_1554": "珍宝带领我们前进!",
    "messageInitContent_1564": "还是让战力最高的挨打吧，别欺负血少的",
    "messageInitContent_1563": "好好通关！",
    "messageInitContent_1562": "就是你越是不想思考一件东西，反而会强化想的想法。",
    "messageInitContent_1561": "整什么套娃呢",
    "messageInitContent_1560": "说不想，结果越不想想越想",
    "messageInitContent_1569": "终式这轮子，是生怕被台风吹飞的样子啊",
    "messageInitContent_1568": "我不想让我的怪兽打这关",
    "messageInitContent_1567": "珍宝你不可以崩坏的珍宝！",
    "messageInitContent_1566": "结果还是要欺负血少的吗？",
    "messageInitContent_1565": "诶为什么我战力最高的就是血最少的",
    "messageInitContent_1575": "这个根本不用问吧",
    "messageInitContent_1574": "一直想问……污妖王手上的是什么话",
    "messageInitContent_1573": "皮肤进化了呜呜呜",
    "messageInitContent_1572": "不  可  封  印",
    "messageInitContent_1571": "新时代的怪兽的标志",
    "messageInitContent_1570": "现在不可封印好多了。",
    "messageInitContent_1579": "菊花啊",
    "messageInitContent_1578": "不是菊花吗",
    "messageInitContent_1577": "那到底是什么花啊？",
    "messageInitContent_1576": "就是啊",
    "messageInitContent_1586": "你是说名字中间分开吧！",
    "messageInitContent_1585": "不是中间吗？打竖的",
    "messageInitContent_1584": "所以喀戎到底是怎么分，上下的吗",
    "messageInitContent_1583": "前面还贴心加上连词了，我哭死",
    "messageInitContent_1582": "这个世界有四种辣，微辣，中辣，特辣，还有……",
    "messageInitContent_1581": "给它们看看我的5远阵容哈哈哈",
    "messageInitContent_1580": "就是菊花",
    "messageInitContent_1589": "说分手玩着关的是魔鬼吧",
    "messageInitContent_1588": "分手的朋友时候可以让对象来玩着关",
    "messageInitContent_1587": "所以下面的头在哪里？",
    "messageInitContent_1597": "妖焰呢？",
    "messageInitContent_1596": "可能是说莎士彼亚和妖火",
    "messageInitContent_1595": "这手的数目一看就不对呀。",
    "messageInitContent_1594": "墙神呢？",
    "messageInitContent_1593": "它们被壁咚过，所以不想在体验被推墙。",
    "messageInitContent_1592": "滚 远 点！",
    "messageInitContent_1591": "你 走  开 ！",
    "messageInitContent_1590": "然后再让尸狂送上一首《分手快乐》",
    "randomEventDialogueGroupConfig_8.1": "一个神秘商人突然从一旁的草丛中冒出头来，又缩了回去，又从另外一侧冒出来，再消失不见。#如此这般反复几次之后，它发现了你。",
    "randomEventDialogueGroupConfig_8.2": "-",
    "messageInitContent_1599": "好狠心的莎士彼亚！",
    "messageInitContent_1598": "莎士彼亚，你为什么，为什么不让我好好奶！",
    "messageInitContent_203": "**土味哥已经来到这了，兄弟们快冲！",
    "messageInitContent_204": "一看就知道这边有好东西",
    "messageInitContent_205": "鸟龙是不是吃撑了？看那小肚腩",
    "messageInitContent_206": "打不过可以去升个级，把前面的鸟龙拉上阵。",
    "messageInitContent_207": "打完记得去占领前面的肉场！！",
    "messageInitContent_208": "打完饿了。",
    "messageInitContent_209": "我已经把刚抽的全拉上来了，so easy",
    "randomEventDialogueGroupConfig_8.9": "你根本什么都不懂。",
    "randomEventDialogueGroupConfig_8.7": "-",
    "randomEventDialogueGroupConfig_8.8": "它面露难色，支支吾吾起来。",
    "randomEventDialogueGroupConfig_8.5": "-",
    "messageInitContent_200": "你们吵到我的眼睛了",
    "randomEventDialogueGroupConfig_8.6": "-",
    "messageInitContent_201": "抓一堆星刃，带你看流星雨。",
    "randomEventDialogueGroupConfig_8.3": "-",
    "messageInitContent_202": "听说这里有流星雨？",
    "randomEventDialogueGroupConfig_8.4": "-",
    "messageInitContent_214": "哪里有吃的，哪里就有吃货",
    "messageInitContent_215": "投食洞穴我来了-v-！",
    "messageInitContent_216": "普通探索者到此一游(*^__^*) 嘻嘻……",
    "messageInitContent_217": "(¦3[▓▓]休息一下先",
    "messageInitContent_218": "超进化大陆的第一顿肉肉",
    "messageInitContent_219": "你品你细品，细细品尝这肉香。",
    "dailyTaskName_10": "通关凿星裂痕{target}次",
    "messageInitContent_210": "就没人奇怪为什么地上会长出大块肉吗？",
    "messageInitContent_211": "在游戏中寻找真实感是不是搞错了什么？",
    "dailyTaskName_12": "事件怪兽探索{target}次",
    "messageInitContent_212": "再打一遍的时候好像变弱了，是关卡杀熟吗！！",
    "dailyTaskName_11": "登录游戏{target}次",
    "messageInitContent_213": "丑小鸭能变天鹅，那么我喜欢你有什么好惊讶的吗？",
    "messageInitContent_225": "普通输出普通辅助，什么普通下路组合",
    "messageInitContent_226": "下路已通关",
    "messageInitContent_227": "我辅助贼6",
    "messageInitContent_228": "异兽太可爱了吧，我想……",
    "messageInitContent_229": "腐食者的嘴巴太可爱了吧，我想……",
    "messageInitContent_220": "攻略坛说后面暴走旷野可以自己组装怪兽？我来组成头部！",
    "messageInitContent_221": "锤子果然站在了1号位！",
    "messageInitContent_222": "锤锤你最棒了！",
    "messageInitContent_223": "吃完肉肉，重新开始大冒险噜",
    "messageInitContent_224": "我懂了，它们是用眼神在防守",
    "messageInitContent_236": "懂了这是福利关",
    "messageInitContent_237": "你觉得我们将去往何方",
    "messageInitContent_238": "我想去码头整点薯条",
    "messageInitContent_239": "你误会了，我是说咱们一生的终极目标是什么",
    "messageInitContent_230": "别在这理发店",
    "messageInitContent_231": "人不能，至少不应该",
    "messageInitContent_232": "参见网络守则第34条",
    "messageInitContent_233": "快叫你们打野、中单上单出来！",
    "messageInitContent_234": "前面那只怪兽的表情好像营养我",
    "messageInitContent_235": "冲冲冲",
    "messageInitContent_247": "攻略坛说后面暴走旷野可以自己组装怪兽？我来组成头部！",
    "messageInitContent_248": "来来++好友，快来贴贴",
    "7_11": "删除",
    "messageInitContent_249": "鸟龙说的都是真的",
    "7_12": "你尚未加入联结共鸣，加入联结共鸣后再发送消息",
    "resoundEventConfigDes_9002": "“既然没得救，就把树给砍了！”在一旁旁观的巴萨克一直觉得月夕和朱雀在浪费时间。\\n“不行！”寇斯金跳到世界树前面，提防着巴萨克的轻举妄动。\\n在很早以前，各族已经达成共识，世界树是属于整个大陆的财产，即使生长在某族聚居地，也并非属于那族所有。即使这样，寇斯金还是把这棵世界树当作尸族的精神支柱。\\n巴萨克也不想为了世界树继续纠缠下去，这番挑衅还隐藏着他的另一层深意。\\n只要打败寇斯金和月夕，他就能把尸族掌握在自己手中，成为打败邪王的兵力。\\n寇斯金只是区区究极级,无需放在眼里，月夕也不会蠢到放弃远古族的使命和自己作对。\\n嚯嚯嚯，很快，他就会再次迎来自己的高光时刻。\\n这么想着，巴萨克朝寇斯金发起了攻击。\\n双方的强弱很明显。寇斯金靠『不死之力』勉强抵挡着，并没有反击的余力。\\n“等、等一下……”月夕想阻止他们，但刚才治愈世界树的时候几乎耗尽了所有力量，现在是欧文控制着身体。\\n“现在插手会受伤的。”欧文说，这是他看到朱雀在冷静观战后做出的判断。\\n不过，欧文并不知道，朱雀的淡定来自于他从远方看到的三个身影。他们在风雪中渐行渐近，其中一个的身上，还散发着太阳般的光芒。\\n果然，只是几下眨眼的时间，数枚光弹已经击中巴萨克的背部。光弹威力不大，但足够让他停手。\\n巴萨克转身，看到古拉姆、埃癸斯和日夕呈半包围状地堵在自己前方。\\n“哼，远古族喜欢以多胜少吗？”他冷笑着说。\\n“没有哦，刚才出手打你这条贼龙的只有我，待会出手打你的，还是只有我。”日夕挑衅道。\\n日夕、古拉姆和埃癸斯三位远古族首领是从熔火之巅赶来的，由于龙去山空，他们并没有集结到龙族的力量，因此先到冰川谷与月夕汇合。\\n一来到冰川谷，日夕就看到西方远处闪耀着属于姐姐的光芒，但因为距离太远了，月白的柔光在风雪中若隐若现，而且上面还覆盖着温暖的焰光，那似乎是朱雀的颜色。\\n“听说冰川谷的世界树就在西方。”埃癸斯说。\\n“姐姐一定也在那儿！”日夕说道。\\n一方面，她想尽快赶到姐姐身边，说不定姐姐正身陷苦战，另一方面，她又有点迟疑，她估摸姐姐和朱雀已经看出她吃过变异孢子的事了，姐姐应该不会过于严厉地责怪自己，但朱雀大人就难说了。\\n“哟，女神的姐姐也是女神姐姐！说起来，日夕和月夕长得挺像的！”林宇翔兴奋地说了两句废话。\\n“你好聪明，终于发现了。”古拉姆吐槽道。\\n“嘛，因为我的注意力一直在雨蒙酱身上，完全没有留意到她们是双胞胎的事，换句话说，我是个一心一意的人，接下来，我会全心全意辅助你。放心吧，脱单这种事，我会等到战斗结束，回到原来的世界再做。”\\n脱单？听起来不是个好东西。\\n“你不要乱想，更不能乱来。”古拉姆怕林宇翔对“日夕”越来越殷勤，马上拿回身体控制权，“接下来可能要战斗，你好好在一旁看着。”\\n就这样，以两重光芒为指引，三位首领赶到了世界树这里。\\n“你说谁是贼龙？”\\n被日夕击中的巴萨克听到“贼龙”二字怒吼着正要冲向日夕。\\n日夕紧盯着巴萨克，左掌上再次飘浮起一枚光弹。\\n“都停手。”朱雀威严的声音在大家头顶响起。\\n接着，他朝巴萨克飞过去，挥动翅膀，让明艳的火光落在他身上。\\n龙族族长立刻举起双手挡在头顶上，但他很快发现自己毫发无损，日夕造成的小伤也被治愈了，便用愤怒掩饰自己的慌张。\\n“要是你敢拦着我，就算是神灵，我也会杀了你！”巴萨克对朱雀挥动拳头。\\n“你这股怒气，应该留给邪王。现在，我觉得你们该好好聊一聊。”朱雀说。",
    "resoundEventConfigDes_9003": "开会的地方在世界树附近的一个冰洞里。\\n本来只容得下一两名怪兽的洞穴，被寇斯金粗暴地撞击了几下之后，洞里的空间迅速扩大了三四倍。\\n寇斯金一屁股坐在地上，反复强调他不能离世界树太远。\\n日夕搀扶着为治疗世界树几乎耗尽全身力量的月夕，走在大家的后面。\\n“小夕，你的身体……”\\n“放心嘛，不就是几个变臭的孢子团吗？等你恢复体力后，帮我治疗一下就好了。”日夕做了个鬼脸，故作轻松地说道。\\n她一向不愿意在姐姐面前表露出脆弱的样子，即使在自己闯了祸之后，还是用灿烂的笑容来掩饰不安。\\n“嗯，到时候我们找个没人的地方，我帮你净化……”\\n“对了，这件事，你可别对古拉姆和埃癸斯说哦。”\\n“咦，他们还不知道吗？”\\n“因为几条恶龙……就吃下那种孢子的事，怎么可能说得出来。话说回来，寇斯金也不知道吧？”\\n“唔唔，他好不容易才从邪王那里找回一半的同族，就不要让这件事成为他新的困扰了。”\\n其实是月夕和朱雀都了解日夕的任性和高傲，才没有把她一时冲动犯下的错误告诉寇斯金和其他尸族。\\n“月夕小姐，你还好吗？”埃癸斯站在洞外，关切地看着她们。\\n“有劳埃癸斯大人费心，我的身体并无大碍。”月夕说道。\\n姐妹俩的悄悄话到此为止。\\n埃癸斯憨厚地笑了笑，把日月双姝让进洞里。\\n等大家都就地坐好后，朱雀率先发话，希望各位族长能交换各自知道的情报。\\n“刚才，两位族长为什么打起来了？”埃癸斯问道。他认为当务之急是要先解开两位族长的矛盾，建立坚固的防线需要大家的齐心协力。\\n“两位族长只是有些小小的意见分歧。“月夕抢在巴萨克和寇斯金前答道，”起因是最近冰川谷世界树的异变，大量变异了的进化孢子和强化孢子从树上冒出，甚至还有了枯萎的迹象。”\\n“所有世界树都变成这样了吗？”埃癸斯忧心忡忡。\\n“不知道，不过有这个可能。”朱雀说道。\\n“如果真是这样，那肯定有不少怪兽吃下了变异孢子，加入了邪王的大军。可恶，被抢了先机。我们绝不可以这样坐以待毙。”古拉姆非常懊恼。\\n突然，日夕想起了一件严重的事——熔火之巅那里，也有一棵世界树。\\n“巴萨克大人，熔火之巅的龙，都到哪里去了？”\\n“这——关你什么事！”\\n对于日夕突如其来的质问，巴萨克脸色一暗，用高傲的态度来掩饰自己的慌张。\\n“哼，那我就问个关我们事的问题。我们拿下了滚石山脉的石塔，你却把召唤具偷走了是不是？然后进化还失败了，于是不知道哪条龙把你从族长的位置上踹了下来，还带走了所有的龙？”\\n日夕故意刺激巴萨克，她才不会给这个远古族的宿敌留点面子。\\n“胡说！吼——”怒火在巴萨克的喉咙中燃烧。\\n“还是说，熔火之巅的世界树也变得像冰川谷的世界树一样。”日夕语气一冷，抛出另一个猜测，“龙族吃掉所有变异的孢子团，变成了邪王的手下。”\\n日夕的猜测可谓对错参半，但无论是对的部分还是错的部分，巴萨克都不想进行确认或者辩解，因为那都是他在夺回龙族之前，要隐瞒起来的耻辱。\\n可是，大家却对他的秘密越来越关心。\\n“记得我们被屏障挡在冰雪城堡前的时候，看到了大群龙族往北飞去，在我们眼前失去了踪影。现在，一切都解释得通了，那时他们就已经成了邪王的手下。”在意识的虚空中，欧文对月夕说道。\\n“怎么会……”月夕不可置信地张了张嘴。\\n“说不定龙族正抱着邪王的大腿，彼此相亲相爱着。”像是回应着月夕的担忧，日夕又在巴萨克的身上补了一刀。\\n“哦！巴萨克，你也吃了邪王的孢子对不对？”头脑一向简单的寇斯金，因为看巴萨克不爽的关系，突然变得敏锐起来。\\n“——嗷！混蛋你说什么？”巴萨克觉得四面八方都是敌意。\\n“我们确实在熔火之巅看到一些变异孢子团，也猜想过最坏的结果。但我们都没有亲眼看到变异的世界树，所以，巴萨克大人，请告诉我们，龙族，究竟发生什么事了？” 为了缓解大家的紧张，埃癸斯连忙补充说道。\\n面对大家期待的目光，巴萨克喉咙紧了紧，终究……要把拼命隐瞒到现在的耻辱袒露出来吗？",
    "resoundEventConfigDes_9001": "大陆各处，正掀起一片片相似的欢腾。\\n世界树仿佛将往后几十年的能量全部透支，结出了无数硕大饱满的进化孢子和强化孢子。这些孢子，几乎挤占了每一处空隙。只不过，它们无一例外地覆盖着诡异的紫色，让怪兽们分辨不出它们是哪种孢子。\\n这些散发着诡异紫光的孢子比以往的更具诱惑力，疯狂地撩拨着怪兽渴望进化和变强的本能，本来就蹲守在世界树下的怪兽、路过的怪兽、远处的察觉到动静的怪兽纷纷涌向世界树，吞食着孢子团。其中还包括那些明知吞下孢子身心就会变成邪王俘虏的，但却无法自已的怪兽。\\n它们之中，有的受不了体内力量的暴增和激涌而死掉，有的猛然进化后身体迅速衰弱下来，但有更多怪兽的体能获得飞跃般的提升。它们握紧拳头向天空嘶吼着，一起向北奔去。\\n邪恶的力量，正在向北方聚集。\\n不过，正义的力量，也在向北方聚集。\\n远古族的战士根据本族斥候的报告，大半精锐开始前往北方为首领们助战。\\n同时前往北方的，还有那支“叛变”的被埃癸斯救过的灵族队伍。\\n但是，这些向北奔涌的战力，都不知道世界树正在枯萎。\\n晨光草原远离极北之地，那里的草原还保持着绿草如茵的样子，而生长在狂野沙漠上的植物，本来就是一派枯萎之势，所以，即使是警惕性最高的远古族，也不知道在其他区域的陆地上，所有植物都已经枯萎。\\n只有伸向大地深处的世界树之根，还没被邪王的力量完全侵蚀，但它们的末端已经开始腐烂，照这样下去，世界树的枯萎也是迟早的事情。\\n由于距离邪王最近，在七棵世界树中，生长在冰川谷的世界树最为堪忧，虽然它看上去还是和往常一样茂盛，枝叶都泛着银白色的高洁光芒，但细看之下，就会发现树冠的最高处，混杂着几根灰白色的树枝，树枝光秃秃的，曾经亮白的叶子，早已凋落于皑皑白雪中。\\n尸族族长寇斯金忧心忡忡地看着一片刚刚飘落在自己掌心的枯叶，又看了一眼正在为世界树“疗伤”的月夕，最后再看了一眼在地上刨冰的钢铁龙王巴萨克。\\n这棵世界树位于冰川谷近海的西边。由于它在很早之前就结不出孢子团了，还有尸族怪兽对世界树的看守，前几天世界树飘落的大量孢子团竟没有让这里的任何一只怪兽成为邪王的俘虏。\\n看守世界树的尸族怪兽震惊之余，没有过分慌乱，在两名究极级尸族的带领下，强忍着诱惑行事，大部队守在树前，由一位脚程快的尸族怪兽把事情报告给寇斯金和月夕。\\n不过，在风雪肆虐的寒冷之地，要烧毁这些变异孢子团可不是那么容易的事。\\n如果小夕在就好了，月夕想到。\\n妹妹已经离开了好几天，她很担心妹妹，那种骇人暴走的状况，会危及到小夕的生命吗？\\n就在她担忧着的时候，巴萨克已经从地上刨出厚厚的冰沙。他将所有孢子团摁进冰沙里，然后把冰沙搓成一个又硬又大的冰球，最后，带着怒意，把冰球扔进海中。\\n“你们还要发呆到什么时候！”\\n月夕的忧思被巴萨克打断。\\n“啊，抱歉，您又帮了我们一次，族长大人。”月夕抱歉地说，“但当务之急，必须先让世界树摆脱邪王力量的侵蚀。”\\n月夕看到龙族族长千里迢迢赶来告诉她邪王要先对付她们姐妹俩，很是感动，只不过，打败邪王的计划不是在龙族族长的催促下就能草率拟定下来的。欧文也同意了她的想法。\\n此刻虽然是白天，但世界树被柔和的月光笼罩着。月夕坐在自己的弯月上，上下来回着，全力地把治愈之力传送到世界树身上。\\n而似乎能触碰到天空的世界树树冠，则由朱雀盘旋在那里，他朝树冠释放一股更强烈的治愈力量。\\n温暖的焰光和柔和的月光让原本无比崇高的世界树，增添了更为神圣庄严的色彩。\\n可惜，树冠顶端的某条树枝还是由银白色变为灰白色，叶片凋落，然后“啪”的一下，枝条从树上掉落下来。\\n朱雀无奈地摇摇头，朝地面飞去。\\n月夕无比心痛地捡起刚才掉落的断枝，无助地向朱雀问道：“如果等小夕回来，我们三个一起再——”\\n“没有用的，我们的治愈之力只能短暂对抗这股邪恶的力量，治愈之力一旦停止，邪恶的力量就会再次注入。”朱雀摇摇头。\\n月夕刚才还充满希望的眼睛暗了下来。",
    "resoundEventConfigDes_9006": "讨论这边，日夕想出了一个简单直接的方法。\\n“所以对他根本不需要用‘救’吧，只要把他暴打一顿，他就会老老实实地回来我们这边。我们派谁去好呢？”\\n“日夕大人，就凭你之前飞到天空‘喝呀’的一下，一定能让暴虐战狂一败涂地。”寇斯金想起之前向暴虐战狂求助却被对方拒绝的事，便十分期待看到暴虐战狂被打趴在地的样子。\\n听到寇斯金这么说，日夕心里咯噔了一下，她可不要被古拉姆和埃癸斯追问那件事。她的确是在吃了变异孢子以后得到了渴望已久的飞行能力，可是努力压抑着那股不详的力量的现在，与之紧密联系的飞行也是不想触及的事。\\n“什么是‘喝呀’一下？”果然，古拉姆好奇地问道。\\n月夕和朱雀也紧张起来。\\n“那那那那那个是我刚进化成不朽级还没熟练掌控自身的力量才出现的错乱状态，现在已经不会再出现啦！笨蛋！”日夕的舌头在嘴巴里打结。\\n“不懂。”古拉姆直截了当地继续追问。\\n“嘛，就、就是……你的剑不是还断着吗？这种也是进化后出现的异常状态啊！反正，就是会出现这样或者那样的异常啦！但、但我现在，完全正常了哦！倒是你，打算用这把断剑用到什么时候？”\\n日夕一顿毫无逻辑的说明，加上戳中古拉姆痛点的质问，成功地否决了寇斯金的建议。\\n见寇斯金还在艰难地消化着妹妹的话，月夕提出一个建议。\\n“埃癸斯，这个重任，能拜托你吗？”\\n“诶？”突然被点名的埃癸斯愣了愣。\\n“嗯嗯！确实呢，我们之中，只有埃癸斯有可能打败暴虐战狂。”古拉姆说道。\\n“啊，我不是这个意思，”月夕看到古拉姆脸上浮现起昂然的战意，连忙解释，“埃癸斯能不能打赢暴虐战狂，其实并不重要，我们只要满足他的心愿，毫无保留地和他战斗一场就好了。但是，如果因此而牺牲我们之中的任何一位伙伴，这个代价未免太大了。能在不伤害他的情况下打败他固然是最好的，否则，即使战败也能全身而退的话，只有在防守上，任何怪兽都无法与之匹敌的埃癸斯。”\\n听完月夕的分析，大家都不禁点点头。\\n“你太过奖了。”埃癸斯不好意思地挠挠脑袋，“可是，之前我正是只守不攻来对抗暴虐战狂，才把他气走的。如果下次也是这样，会让他对我们更失望吧？”\\n“所以在保护好自己的同时，要拼尽全力地展开攻击。”古拉姆挥挥拳头。\\n“……好吧，我会努力的。”埃癸斯有点为难，但还是郑重地接下了任务。\\n他并不是因为不愿攻击暴虐战狂而为难，而是担心无法一下子改变自己的战斗风格。\\n朱雀看出了他的担心，说道：“我们在前往邪王雪岭之前，可以用一两天为埃癸斯进行特训。”\\n“熟知剑锋所向的盾更为可怕。”古拉姆拍了拍埃癸斯的肩膀。\\n“嗯！”",
    "messageInitContent_240": "为了去码头整点薯条",
    "resoundEventConfigDes_9007": "“至于最终兵器……”月夕想到那个惹人怜爱的小妹妹，更加担忧，“我们不能让她做这么危险的事。”\\n“等等，你相信那个小鬼头还站在我们这边？”\\n日夕下意识地摸了摸腹部，最终兵器那一拳带来的剧痛仿佛还留在身上。\\n“是的。”\\n知道妹妹曾单挑邪王朱丽叶，然后被最终兵器（洛菲菲）“所救”后，月夕更确信那个孩子为了大家，把自己放在相当危险的境地。\\n“她只是说了一句模棱两可的话罢了，而且，我们四个远古族首领都是邪王的眼中钉，无论邪王要先杀掉我们之中的哪一个，我们都会警惕着身边随时出现的敌人。换而言之，那个小鬼的情报根本不够分量。”\\n“可是这并不是怀疑她的理由，对于一个孩子来说，她已经做得过分好了。”\\n姐妹俩僵持不下。\\n“我会亲自去邪王那里找她，带她回来。”月夕下定了决心。\\n“我跟你一起去。”日夕也不容拒绝地说道。\\n让姐姐单独去的话，会被那个小鬼头骗一百遍吧，日夕担心着。\\n“嗯，见到她之后，我们直接向她确认好了。”\\n“既然你们都去邪王雪岭，那我也去。”古拉姆也燃起战意，说道，“虽然我现在的战斗力不怎么样，但对付邪王的其他手下还是可以的。再说，我还没见过邪王，是时候当面向他们宣战了！”\\n“好呀，我们很久没有一起作战了！”日夕兴奋地拍拍手。\\n“咦！这不等于全员出动了吗？”意识的虚空中，欧文惊讶地问道。\\n“欧文先生觉得有点草率吗？”月夕也意识到这是一个相当于和邪王“决一死战”的阵容。\\n在欧文的再次要求下，月夕再次将身体交给了他。\\n“慢着！我也同意总动员这种战略。变异孢子的威力越来越强大，那些奇怪的纹章不断给敌人各种各样的力量加成，连挡在邪王前面的屏障也消失了，这些都说明邪王正在变强。我们必须在邪王变得更强大之前打败他们。但出发之前，除了埃癸斯要做战斗的特训之外，还要确认几点情报和制定几个计划，大家才能出动吧。驻守在冰雪城堡的兵力，幻化级、究极级和不朽级各有多少？陆战部队和飞行部队各有多少？还有城堡的结构是怎么样的？有没有潜入路线？有什么方法只把暴虐战狂引出来而不惊动邪王？如果暴虐战狂和最终兵器都不愿意离开，我们怎么安全撤退？如果邪王在我们四人出动后，派兵偷袭冰川谷怎么办？”\\n“呃……”\\n古拉姆、埃癸斯、日夕和月夕都被欧文连珠炮式的发问弄得晕头转向。\\n“无论哪种情况，我们都应该有万全的对策才能行动。”\\n“……嘛，未知的事情实在太多了，要全部考虑的话，恐怕要熬十几个通宵吧。”日夕不禁打了个哈欠。\\n“到时随机应变就好了……”古拉姆想起欧文提的问题，就觉得头有点痛。\\n“无论发生什么，我们都要把同伴救出来！”埃癸斯也放弃思考这些复杂的问题。\\n“……”欧文扶额，对这次总攻浮现出无数不祥的预感。\\n“欧文先生，你还是别太担心了……就像小夕说的，如果要等到所有问题都有答案，我们什么时候才能救出远古族的同伴呢？”\\n“好吧……但你答应我，万一发生什么事，你要立刻坐上弯月飞走！”这句，是欧文单独对月夕说的。\\n“嗯，我会照顾好自己的。”\\n“在你们前往邪王雪岭的时候，我会和巴萨克、寇斯金驻守在这里，这一点，你们放心吧。”朱雀说道。\\n“谢谢您，朱雀大人。”月夕松了一口气，欧文担心的问题起码解决了一个。\\n“喂喂！他们要送死关我什么事？我可不想继续呆在这里。”巴萨克不满地说。\\n既然无法把尸族掌握在手中，他打算到大陆各处招募其他龙族，尽快组建军队。\\n“这样啊……如果这次四位远古族首领能带回一些和龙族有关的情报，就无法告诉你了。万一他们还能救出几条龙，就只好把那些龙编进尸族的队伍里。再见，龙族族长。”\\n朱雀故意惋惜地摇摇头，扇动翅膀，飞出洞口。\\n“……等一下，好吧，我就勉为其难帮一下尸族，谁叫他们的族长只是个究极级呢。”",
    "messageInitContent_241": "踩蘑菇滴探索者~",
    "resoundEventConfigDes_9004": "“……大概……就是你们猜的那个样子。”\\n巴萨克用含混不清的声音说道，比起被一直潜伏在族里的叛徒策反了整个龙族，把原因推到世界树上似乎没有这么丢脸。\\n“不过，我可没吃那些孢子！”\\n“你要怎么证明？”日夕咄咄逼人地问道。\\n日夕并不是故意找茬，她只是怀疑不朽级的怪兽能凭自身的力量和意志压抑着对邪王疯狂的崇拜和控制，就像她一样。回冰川谷的路上，古拉姆和埃癸斯都没有从她的流动中看出有什么不妥。\\n她清楚自己对原本的使命只产生过一瞬间的动摇，但她可不敢放心地信任这个一直不太喜欢远古族的龙族族长。\\n“哼，那你怎么证明我吃了？”\\n“小夕，巴萨克大人特地跑来提醒我，邪王要先对我们下手，我相信他是位正直的首领。”月夕说道。\\n“对呀，如果巴萨克变成了邪王的俘虏，会直接跑过来挑起战斗吧。他可没那个头脑假装是我们的同伴！”古拉姆投下了“相信”票。\\n“我也相信巴萨克大人。”埃癸斯也点点头。\\n哦呵？巴萨克一下子又感受到了来自四面八方的善意，不对，古拉姆那家伙好像绕了个圈子骂他。\\n“而且，那些吃过变异孢子的怪兽，不是浮现了那种奇怪的紫色流动吗？巴萨克身上并没有那种东西。”古拉姆补充道。\\n“……”日夕总不能以自己为例子来反驳，只好咬咬牙。\\n“好了，这个问题就到此为止。”朱雀看了看日夕，示意她不要再纠结下去。\\n日夕不服气地轻哼了一声，用右手的两根手指指了指自己的眼睛，再指了指巴萨克。\\n巴萨克懒得再理日夕，别过头去，可是，他没想到下一个话题，还是在他身上。\\n“巴萨克，虽然我相信你没有吃过变异孢子，但一码归一码，那个召唤具呢？这事你得交代清楚！”这回质问他的是古拉姆。\\n“龙屎的！你们远古族是故意的吧，老是咬着老子不放！那东西本来就是我的！”\\n“小夕，你们得到了新的召唤具？”刚才月夕就想问这事。\\n于是，日夕便将在滚石山脉发生的事告诉大家。轮到巴萨克讲述的时候，他不耐烦地用三言两语把对月夕、寇斯金和朱雀说过的事重复了一遍——\\n包括了他和史卡非斯打算前去刺杀邪王、在邪王那里遇到倒戈的最终兵器和暴虐战狂、史卡非斯的背叛和最终兵器让他给日月姐妹带口信的事。\\n不过，这次他倒是补充了一个“微不足道”的细节——他把召唤具“送给”史卡非斯了。\\n“史卡非斯说为了找那几只叉叉帮忙渡海，花光了所有金子，他想要那个破盘子，我就给他了。”巴萨克假装毫不在意的样子。\\n“现在，史卡非斯手上有四个召唤具，姐姐的和我的、最终兵器的、还有被某条贼龙偷走的。他要这么多召唤具干嘛？”日夕说道。\\n“集齐所有召唤具之后能召唤神兽吗？”古拉姆转达了林宇翔和他自己共同的疑惑。\\n“‘集齐召唤具’这个说法，并不准确……”朱雀沉吟了一下，考虑着怎么跟大家解释，“石塔和召唤具是在某种比大陆所有生物都要强大而神秘的意志之中产生的，我也不知道它属于何种生物，甚至不知道它算不算是有些怪兽所说的‘古神’。”\\n邪王从何而来？石塔因何而生？这才是盘踞在各组英雄心中最大的谜团。\\n“不过，这种神秘的意志似乎有点随心所欲，每千年拔地而起的石塔数量都不同，忘记了哪一个千年，大陆只出现了两座石塔、两个召唤具，上一个千年，好像出现了十座石塔、九个召唤具。嗯，没错，因为有一座石塔，并没有怪兽能战胜它的守卫。邪王战争结束后，所有石塔便随之消失了。”\\n“那些召唤具呢？”古拉姆问道。\\n“也消失了。”\\n“不过在你们之前，倒是没有哪组英雄试过把所有出现的召唤具收集在一起。”朱雀摇摇头，深深陷进前所未有的疑惑中。",
    "messageInitContent_242": "腐食者：在线抽取两位雄性！",
    "resoundEventConfigDes_9005": "“朱雀大人，前几次邪王战争中，邪王都是这种自恋的变态吗？不但自恋，还妄想着大家都会爱他们！”日夕想起之前罗密欧对她们姐妹俩发动的变态攻击，就觉得恶心。\\n“……我……不记得了。这是我一直想向各位族长致歉的事……”朱雀的声音第一次出现了无力感，“当打败邪王后，和邪王有关的记忆，像被什么力量抹去了……”\\n“那位温泉老板也失忆了。”埃癸斯想起滚石山脉的前辈。\\n“抹去朱雀大人和温泉老板记忆的，也是产生石塔的那股力量吗？”问的是欧文。\\n月夕把身体控制权交给欧文，他严谨的逻辑正是大家分析现状所需要的。虽然她不知道为什么召唤具把文质彬彬的欧文先生送到她身边，但每当自己不知所措的时候，欧文的陪伴总能让她冷静下来。\\n“数千年里，我一直尝试寻找这股力量的来源，却找不到任何蛛丝马迹。就好像……它存在于星海之外，俯瞰着我们这些渺小的生命……”朱雀感慨道。\\n“根据我们现在所知道的，假设抹去记忆、让邪王降临、让石塔诞生的，都是那股力量，那么可以推导出来的合理解释，只有一个。”\\n欧文没有理会朱雀的慨叹，自顾自地推导下去。\\n大家则期待地看着欧文，曾在少年时期幻想亲手打败邪王的古拉姆还紧张得吞了吞口水。\\n“考验。这一切，都是这股力量给这片大陆所有怪兽的生存考验。每隔一千年，当大家可能沉湎在平和安乐的生活中之时，它就会再次考验大家。拥有战胜邪王的力量，就有资格生存下去，否则，就要迎接所有族类受邪王蹂躏的命运。”\\n“为什么那股力量只承认远古族？要死就让远古族死掉好了。”巴萨克不爽地问道。\\n寇斯金虽然对远古族只有羡慕没有妒忌，但也暗搓搓地幻想过自己能像他们那样进化成不朽级。\\n“可能因为远古族是大陆上最强的种族。”欧文客观分析自己经历的所有战斗后，实事求是地说，“邪王抢夺召唤具，是害怕有更多的远古族进化成不朽级，那证明我们确实威胁到他们了，这对我们来说是有利的情报。”\\n“骄傲的家伙！”\\n“原来是这样。”\\n虽然接受结论的态度不同，但此刻月夕（欧文）脸上那种超越了智者的笃定神色，让巴萨克和寇斯金不得不相信他。\\n“大家，召唤具的事我们以后再讨论吧。”月夕担心的是另一个更严重的问题，在欧文给大家分析完之后马上接口，“先想办法把最终兵器和暴虐战狂救出来。”\\n“暴虐战狂那家伙，为了能随心所欲地战斗，竟然投靠到邪王那边！看我——” 不砍了他。\\n古拉姆硬生生地把最后一句吞进肚子，他很丢脸地意识到，自己正是让暴虐战狂无法随心所欲战斗的原因之一。\\n“对不起呐……都怪我太菜了。”意识的虚空中，林宇翔默默地说了一句。\\n“没事，我们以后多练练就好。”破天荒地，古拉姆竟然没有责怪林宇翔。",
    "messageInitContent_243": "我：我我wowow",
    "7_10": "我的留言",
    "messageInitContent_244": "修女问号.jpg",
    "messageInitContent_245": "黑人问号.jpg",
    "resoundEventConfigDes_9008": "大家走出冰洞的时候，风停了，远处的晚霞映照着冰山，形成冰火交融的壮丽景象。\\n好久没试过这样坐下来，向伙伴们讲述自己经历的冒险。四位远古族首领的心里，不约而同地涌现起这种奇妙的感受。\\n寇斯金吩咐手下安排大家到附近的几个冰洞休息。\\n巴萨克喝退了一名正要走近他的尸族，等四位远古族的首领都走远之后，终于按捺不住心中的疑惑，向还在身边的朱雀提问。\\n“神灵老头，为什么刚才月夕突然变了个样子？一会儿说要去找邪王，一会儿又说不要去找邪王？”\\n“哦，你发现了？我还以为你一直在赌气，没有留意到这件事？”\\n“我又不是傻子。”\\n于是，朱雀把召唤具会召唤异界英雄的事告诉巴萨克，这事他在很早之前就跟寇斯金说过了。\\n巴萨克听了之后瞬间懵了，一时半会儿反应不过来。\\n“……竟然会有这样的事？” \\n“去挑战一下用这种奇异的方法进化成不朽级的远古族，如何？”\\n“怎么？之前你不是阻止了我和日夕的战斗吗？”\\n“我说的不是日夕，是远古族的坚盾，埃癸斯。龙族以前多次进犯晨光草原，都是被他和他的部落战士挡了回来吧？”\\n“哼！”巴萨克的脸上浮现出一抹尴尬之色，“都是不朽级，我就来看看我和他之间谁更强一点！”\\n朱雀点点头——\\n远古族的坚盾啊，我给你找到一个特训的帮手。",
    "messageInitContent_246": "腐食者+1！异兽+1！",
    "resoundEventConfigDes_9009": "晚上，小小的冰洞中，日月姐妹相对而坐。\\n一个银色的弯月自月夕的掌中升起，慢慢升到日夕的头顶。很快，小小的弯月就会往日夕身上倾泻丰盈充沛的治愈力量。\\n可是银色的治愈之光并没有像往常一样包裹目标，小小的弯月忽然间散开，月夕同时侧身倒地。\\n“姐姐——？”日夕慌忙起身将月夕扶起。\\n“小夕……我没事。不过我的力量似乎还没有完全恢复……”\\n实际上月夕在治疗世界树以后就已经非常疲倦，在会议上也是一直在勉强支撑着。\\n“没关系，今晚就好好休息吧，等恢复以后姐姐帮我再净化就好。”\\n“嗯。”月夕轻轻抱着妹妹。\\n在月夕的怀抱中，日夕长久绷紧的神经突然没绷住的松了下来，那种诡异的紫色流动再次在她身上闪现。\\n“你就好好休息吧。”日夕挣开月夕的怀抱，将月夕轻轻放在冰床上，然后再次绷紧了神经，凝聚起意志。\\n“好吧……但万一要是身体出现了什么状况，一定不能瞒着我。”\\n“好啦好啦！快睡吧，我可不想熬夜。呼，冷死了！”\\n日夕说完，手中正要释放一个气球般大小的光球。她很讨厌冰川谷的酷寒，打算挂一个小太阳在洞里，让洞穴变得暖和一点再睡觉。\\n“让我来吧，否则一眨眼，我们就会泡在水里。”月夕手中释放了一个小小的月亮，“只是这种程度的话不打紧的呢。”\\n月光温柔地驱散了冰冷的寒意，洞内很快变得清凉起来。",
    "tribeSeasonName_202311": "创化赛季Ⅱ",
    "tribeSeasonName_202312": "创世赛季",
    "tribeSeasonName_202310": "创化赛季Ⅰ",
    "messageInitContent_258": "不愧是我哈哈哈哈哈轻轻松松又一关",
    "messageInitContent_259": "不想守的据点可以不守~",
    "resoundEventConfigDes_9010": "第二天，黎明的曙光未至，埃癸斯的特训便开始了。寇斯金见到埃癸斯和巴萨克在对战，也被燃起战意，加入到战斗中。\\n一开始，埃癸斯只用左手的重盾抵抗两名族长的攻击，但这却让对方更加无所顾忌地放开拳脚。\\n埃癸斯让重盾中心的光芒暗淡下来，将身体融入到黑暗中。但寇斯金一捕捉到埃癸斯的身影就马上触发『不死·尸气』，压缩埃癸斯的躲藏位置，而巴萨克则准备好『龙魂』，只要埃癸斯露出破绽，就会迎来致死的一击。\\n两名族长的力量叠加在一起，化为浩荡的破坏力，蹂躏着这片冰原，一边砍碎或高或低的雪包和冰石，一边向埃癸斯逼近。\\n一直在他们上空盘旋的朱雀，飞到埃癸斯身边。\\n“你还在坚持过去的对战方式吗？”\\n“我只是在想，如何在不伤害他们的前提下，击败他们。”\\n“对两位族长来说，流点血不算什么，有我在，放心吧。而且，战斗的伤害对暴虐战狂来说，更是甘之如饴的享受。有时，尽快结束战斗，就是对敌人的仁慈。”\\n尽快结束战斗，就是对敌人的仁慈。这句话，让埃癸斯醍醐灌顶。\\n“……嗯，我明白了！”埃癸斯下定决心，抛开顾虑。\\n“我好像暴露了你的位置，更猛烈的进攻，要来了。”说罢，朱雀再次飞到高空。\\n埃癸斯深吸了一口气，做出第一次全力进攻的尝试。\\n六块轻盾从他身后飞出，包裹着他的身体不断旋转，并且越转越快，化作有形的龙卷风。\\n接着，“龙卷风”以埃癸斯为核心，直直朝着寇斯金和巴萨克袭去！\\n六块旋转着的轻盾撞飞寇斯金，重盾接下巴萨克的一拳。埃癸斯左手的虎口传来一股肌肉撕裂的剧痛，但是，他的右手举着比重盾小一号的盾牌，向巴萨克的头部撞去。\\n六块轻盾已经停止了旋转，重新复位到埃癸斯背后。\\n被击倒在地的巴萨克吐了口血，当他爬起来，准备再次触发『龙魂』的时候，才发现埃癸斯的重盾已经水平旋转着飞到他眼前。\\n接着，重盾把巴萨克推撞到他身后的一个雪包中。\\n深陷雪堆和碎冰中的巴萨克顿时失去了视野，但几乎让他脏腑破裂的那股力量却马上消失了，如果再持续一秒，估计会让他身受重伤，痛晕过去。\\n重盾早已飞回埃癸斯手上。埃癸斯看到寇斯金已经起来了，没什么大碍，便马上跑去雪堆里，看看巴萨克有没有受伤。\\n巴萨克拨开埃癸斯想搀扶他而伸出的手，恨恨地说道：“再来！”\\n埃癸斯见朱雀往寇斯金和巴萨克身上洒下金黄温暖的焰光，他们的伤瞬间得到治愈，他便更加放心。\\n“好！”埃癸斯举起了插在地上的重盾。",
    "resoundEventConfigDes_9013": "一名幽鬼和一名极限被一条荒火龙偷偷送到冰川谷北部的冰岸。\\n“你们，可千万别让王失望，应该能毫无疑问地带着胜利回来吧。”分别之前，荒火龙嘱咐了一句。\\n“你就在这里等着吧，我们会在你把这堆烤羊腿吃完之前回来的。”幽鬼说道。\\n“其实我一个来就够了，王未免太过小心谨慎。”极限说道。\\n“你想说王对你的实力做出了错误的判断吗？”幽鬼质问道。\\n大家的言语中都透露着对彼此的不满。\\n或许是任务太简单了，三名怪兽脸上，都浮现出毫不在意的表情。\\n但是，到了真要动手的时候，幽鬼和极限马上变得一脸认真。对王的爱，这份情感充斥着他们整个身体和灵魂，为了不让这份情感蒙羞，杀气浮上他们的眼睛，他们开始在雪地中潜行。\\n\\n这天的特训，古拉姆和日夕选了一个稍微偏僻的地方，以免再次出现打雪仗那样的混乱状况。初升的太阳给皑皑白雪铺了一片金黄。林宇翔扭头看了一眼在后面追击自己、比金黄的雪地更璀璨绚丽的日夕，刹那间陷入意乱情迷之中。\\n他这位母胎单身的键盘侠，从来没想过能和自己的女神在大自然中嬉戏。\\n就在这分神的瞬间，他的脚下被什么绊了一下，幸亏这短短一天的特训让他的反应比以前快了几倍，在还没看清要绊倒自己的是什么的瞬间，他就下意识地跳了起来，等落地的时候低头一看，地上除了白雪，什么都没有。\\n噫！是日夕大人看出了他的心猿意马而给的小小惩罚吗？看来还是要收敛起对雨蒙酱的感情。古拉姆正在意识的虚空中冥想剑招，没有发现自己的分心，好险好险。\\n林宇翔深呼吸一口，重新专注起来。\\n聚精会神的林宇翔和日夕，都没有发现，异样而鬼祟的攻击，来自不远处的一座小雪包。\\n小雪包后面，正进行着一段好大喜功的对话，两个一路上看不惯对方的怪兽，第一次达成了共识。\\n“真好运，竟然遇到两名不朽级的远古族。”\\n“先把那个叫‘古拉姆’的杀了？”\\n“赞成！”\\n“先说好，不管我们之中谁杀了他，功劳可是彼此一半。”\\n“好！”\\n“那我先上！”\\n讨论结束后，极限伸长自己的一条锁链，让它钻进雪地中，朝古拉姆的脚边伸去。前几天，另一名极限俘虏了木偶族族长和龙族族长这件事，给了他莫大的刺激，身为同种同级的怪兽，他也要做出点成绩来。\\n可惜，偷袭失败了。\\n见状，幽鬼六只手从雪地下面的坚冰中一下子挖出六个冰球，伺机而动。\\n懵然不知的林宇翔，靠着一点点幸运和自己也不知道已经增长了不止一点点的实力，躲开了再次从雪地里袭来的几枚枪头。\\n“等等！日夕大人！”林宇翔突然转身，举手做出投降的姿势。\\n“我们被埋伏了——”日夕紧张地喊道。\\n她看到了来自雪地中的攻击，赶紧朝林宇翔跑过去。\\n“……你在说什么？风太大了！不过，我现在只是个青铜玩家，可不可以稍微降低点特训的难度？”林宇翔自顾自地说着。\\n就在他说话的时候，六个冰球破风朝他背后袭来！\\n铛铛铛铛铛铛——林宇翔竟然能条件反射般地抽出断剑，看也不看地反手挡开两个冰球，再以极快的速度转身，打掉其余四个，甚至还将第六个冰球削成两半。\\n这下惊动了正在冥想剑招的古拉姆。\\n这家伙，有点长进了？古拉姆不禁给了个好评。\\n“日夕大人，如果要同时发动两种袭击，能不能先让我做好心理准备？”林宇翔说道。\\n日夕已经跑到林宇翔面前，并跳到他的背部，和他背对背站着，尽量不留视角盲区。\\n“笨蛋！我说我们被埋伏了！”日夕大喊。\\n……啧，原来还只是个白痴！古拉姆翻了个白眼。\\n不过，先看看这家伙能不能应付过来。这么想着，他便继续假装冥想剑招。\\n“咦！一大早就这么刺激？是邪王吗？还是要来暗杀你的怪兽？”\\n“看样子是来刺杀你的。”日夕说。\\n“古、古拉姆！醒醒！换你上了！”\\n“不不不，我现在有点困了。”林宇翔的求救换来古拉姆的冷漠拒绝，“不过，先提醒你，作为挑剔的漫画读者，我可不想看到同样的剧情。”\\n古拉姆说的是上次在囤食洞穴外面，林宇翔靠拖时间让对手自己倒下的战斗。\\n“……好吧，我现在可是逃跑精英。”\\n“还有，保护好日夕。”\\n“出来吧！我已经看穿你的伎俩了！” 林宇翔向冰球袭来的方向大喊。\\n在意识的虚空中，古拉姆拍了一下额头，这家伙，获得了用美色来转换性格的新技能吗？吐槽归吐槽，但他还是神经紧绷，做好随时支援的准备。",
    "resoundEventConfigDes_9014": "“你出去吧。”\\n“为什么是我？要我做你的替死鬼吗？”\\n“你有六只手，他们一看就知道是你扔的冰球。”\\n“然后你想趁机逃走吗？”\\n“我逃回去也活不了。放心吧，我会给你做掩护的。桀桀桀！”\\n“……你最好想到了什么妙计。”\\n“最好让他们靠近点，我的锁链最远只能伸到那里。”\\n幽鬼和极限在冰山后商量着，最后，幽鬼不满地瞪了极限一眼，从小雪包后跳了出来。\\n“要打雪仗吗？”幽鬼六只手一起抛了抛手中的冰球。\\n\\n现在林宇翔看清了，每个冰球上都缠绕着诡异的紫色闪电，被打中的话应该不止肿起几个包这么简单。于是，他当机立断把日夕扛到肩上。\\n“你你你要干嘛！放我下来！”日夕捶打着林宇翔的背部。\\n“雨蒙酱！日夕大人！我会带你们安全离开这里的！”\\n如果意识的虚空中有墙的话，古拉姆真想撞墙而死。但此刻林宇翔的意志太强烈了，他无法夺回身体的控制权。\\n林宇翔一路狂奔。\\n“快停下！你不是能挡下那只幽鬼的攻击吗？为什么要逃！”日夕一边捶打林宇翔的背部，一边大吼。\\n“呃……”林宇翔停了下来，好像是这么回事，这特训都让他逃跑逃出惯性了。\\n不过，冷静下来他才发现，那些冰球，无论速度和力度，都比不上日夕的光弹。\\n但他还是有点迷糊，自己为什么会突然开挂，进入爽文模式，有模有样地挥起剑呢？林宇翔百思不得其解。不，其实只是思考了几秒钟，就放弃了。\\n“雨蒙酱，日夕大人，请在这里等着。”说罢，林宇翔提剑冲向幽鬼。\\n幽鬼和极限本来已经无计可施，只好眼巴巴看着古拉姆和日夕跑掉，古拉姆的折回让他们大喜过望。\\n极限的三条锁链马上从三个方向朝林宇翔的脚下缠过去。\\n“呵呵，我以为是一只丑陋的蜘蛛，没想到是一条蜈蚣！”林宇翔敏捷地跃起几步，避开三条带着尖锐枪头的锁链。\\n笨蛋，对手有两个，古拉姆无语地叹了口气。他想提醒林宇翔，但又觉得应该让他自己发现，虽然和他合体后，林宇翔就通晓了这里的语言，但对各种怪兽还非常陌生。幽鬼属于尸族，但林宇翔踏足冰川谷后，并没有看到过多少究极级的尸族怪兽。\\n对林宇翔来说，尽管幽鬼外表亭亭玉立，仍散发着一股令人讨厌而妖冶的煽情氛围。\\n“为什么要躲开？好过分呐。以前，只要是雄性，都会抢着去接我扔出的雪球。”幽鬼这样嘀咕着，直直地看着“古拉姆”这张帅气的脸。\\n不过，她的心中毫无倾羡之情，反而悔恨着自己对这个远古族的误判。\\n她向背后的极限打了个手势。很快，她感受到了背后的力量涌动。\\n啊，如果能活着回去冰雪城堡，一定能得到王更多的爱吧。幽鬼和极限同时想到。\\n幽鬼身上突然闪烁起来的诡异紫光，与究极级的紫色流动融合在一起，让林宇翔回想起离开熔火之巅那天的日夕，不安再次漫上他的心头。但是，幽鬼的奇怪举动很快吸引了他的注意。\\n“呵呵呵呵……”幽鬼弯腰大笑，笑得头都要栽进雪地中去了。\\n“这是在干什么……”林宇翔问古拉姆。\\n“不知道，变异孢子吃多了突然疯掉吗？咦，这是进化？不对，流动并没有改变！”\\n随着幽鬼抬起头来，古拉姆的疑惑变成了震惊。\\n幽鬼飞扬的发辫尖端各绑着一把冰刀，这像极了尸族的不朽级形态之一，但这些冰刀显然是幽鬼从雪地下的冰层中“拔”出来的，并不是她身体的一部分。\\n“要换我来吗？”古拉姆问道。\\n“不用，你就在一旁瞧着吧。”林宇翔似乎没意识到对手变强了，依旧信心十足。\\n“即使你在雪地里洗了头，也不会变得好看啊！”林宇翔嘲笑着说道。\\n回应他的是六个爆风而来的冰球。\\n“嘁！你只会这一招吗？”林宇翔根本不用举剑，轻松地跳到右边，因为这次的冰球全部袭向他的左侧，他怀疑幽鬼的力量在变大的同时，脑袋也变傻了。\\n但是，下一秒——\\n夹带晶光和诡异紫光的冰刀强行击穿林宇翔的盔甲。冰冷的物体贯进右侧的胸、腹和大腿，接着一股足以让眼前闪烁的痛楚窜过全身。但幸好中刀的地方全部由盔甲保护着，伤口估计不深。\\n原来，幽鬼的发辫，以被风吹拂着的自然之势，在林宇翔没有留意的情况下，掷出七把冰刀。\\n“呵呵，呵呵，呵呵呵……”\\n幽鬼再次把头栽进雪地里，这次把六只手也伸了进去。\\n“你这家伙……？”\\n林宇翔惊愕不已，即使要及时补充武器，也不该用无视对方、空门大开的方法。\\n他凭借意志力，把从右侧扩散到全身的痛楚压下去，毫不犹豫地举剑朝幽鬼砍过去，挥剑的手变得迟缓，刚才的灵活度好像不复存在。他没多想，认为只是自己受伤的缘故。\\n“除非你的锁链上长了眼睛，否则，什么都看不到的你，要如何从下面偷袭我？哈哈哈！”\\n“白痴！”古拉姆骂了一句，无奈，他依旧无法夺回身体的控制权。\\n极限知道这是他的机会，于是，采取了和幽鬼一样的战术。\\n三条锁链从雪地中冒出来，朝林宇翔缠卷而去。\\n林宇翔突然转身，想把逼近自己的锁链全部一刀两段，可惜他的动作有点慢，力度也不够大，只做到拨开两条，避开一条。\\n“果然上当了！嘿嘿！”不过，林宇翔还是快活地说道。\\n刚才，他用自己做诱饵，注意力却集中在背部。\\n然后，他再次转身朝幽鬼冲去。\\n“小心！对方可能是不朽级的——”\\n古拉姆的提醒还没说完，就感到自己的身体在冲出一米之后却不得不停了下来——\\n一条锁链死死缠住林宇翔的脚。\\n接着，又有六锁链在刹那间逼近。\\n缠上林宇翔四肢和颈部的锁链立刻将他狠狠甩到地上。\\n林宇翔的身体撞上松软的雪地后又重新被抛到空中，他再次被甩到地上的时候，背部撞到的已经是坚硬的冰面。\\n一而再、再而三、三而四……大概被撞了七八次，林宇翔感到背部的冰面已经裂开，最后一次之后，他坠入冰冷的水里。\\n透过水面，他看到了幽鬼和另一只怪兽。原来有两只怪兽啊……\\n四肢似乎被锁链勒到失去了知觉，但断剑还握在手中，想往上游，但锁链尖端呈现蛇头状的尖钩却不断向他噬咬过去。",
    "resoundEventConfigDes_9011": "不远处，古拉姆看着挚友特训，好生羡慕，自己什么时候才能拥有和挚友比肩作战的资格？\\n“我们也去特训吧。”林宇翔说道。\\n“这个……要找谁帮我们特训？”此刻的古拉姆，还真没想到林宇翔会想出那种奇怪的训练方法。\\n\\n月夕和日夕休息的冰洞外，传来了古拉姆压低声音的轻呼，虽然现在天还没亮，但他有点心急。\\n“日夕小姐，你醒了吗？”\\n“雨蒙酱，日夕大人！是我是我，我有事想请你们帮——”古拉姆很快切换了说话的调子。\\n“你轻点声！”意识的虚空中，古拉姆喝道。\\n林宇翔这才发现自己兴奋过头了。\\n日月姐妹没有深睡，只是在闭目休息。听到洞外的呼唤，她们缓缓张开了眼睛。\\n“小夕，古拉姆找你有什么事吗？”\\n“唔，古拉姆的搭档和雨蒙是朋友，我出去看一下哦。你继续休息吧。”\\n“真好呢……”月夕点点头，重新闭上了眼睛。\\n“才不是朋友呢，只是个烦人的家伙。”李雨蒙默默吐槽了一句。\\n来到洞外，日夕见古拉姆（林宇翔）有点羞涩地捧着一块石头，等着她们。日夕把身体的控制权交给了李雨蒙，等着看好戏。\\n“这是什么？”李雨蒙盯着石头问道。\\n“送给你的。”林宇翔说，“本来想摘几朵花，但这种地方连一棵草也没有，只找到这块长着苔藓的石头。”\\n“谢谢，也……挺可爱的。”李雨蒙礼貌地说。\\n“是吧！还挺像现在女生都喜欢的多肉植物。” \\n哪里像……\\n前往冰川谷的路上，林宇翔对李雨蒙极尽照顾，还经常拿出手机，给她看自己保存的各种照片和小视频。\\n“可惜没有信号，要不雨蒙酱现在就可以用我的手机来直播”、“你的每条视频我都一键三连了”、“如果能活着回去，我们一定要加个微信好友”。\\n有这么一个朋友，无论在哪个场合都不会冷场吧。从这点来看，李雨蒙还挺羡慕林宇翔的，不过，相处久了还真希望他的嘴巴能消停一下。\\n现在，李雨蒙开始担心林宇翔只是来找她闲聊。\\n“找我们有什么事吗？”\\n尽管如此，把石头放在洞口边上后，李雨蒙还是笑盈盈地等着林宇翔开口。\\n林宇翔透过日夕的眼睛看到李雨蒙，竟然看呆了。\\n“你这个痴汉，快说特训的事。”古拉姆催促道。\\n“噫！究竟是什么时候学会‘痴汉’这个词的？”\\n林宇翔决定还是以后再教古拉姆怎么文明用词，于是继续对李雨蒙说道：“是这样的，虽然难以启齿，但我想请雨蒙酱和日夕大人帮我做特训。“\\n“诶，这种事竟然要我们帮忙吗？”\\n“你们也知道，我和古拉姆同学在进化中，出了点状况……简而言之，就是我很弱……一直不能让这具完美的躯体发挥全部力量。”林宇翔解释的时候趁机拍了拍古拉姆的马屁，“所以我要找到适合我的特训。”\\n“让日夕来帮你特训吗？”李雨蒙问道。\\n“嗯，我要学习躲避和逃走。”林宇翔突然变得严肃起来。\\n“喂喂！你这是什么话！”\\n古拉姆知道林宇翔想找日夕帮忙特训，但没想到是这种理由。弱不可耻，但专门练习逃走，对战士而言就是耻辱。\\n“别生气，我这样做当然有我的道理。”林宇翔安抚古拉姆，说道。\\n“还有什么道理，你只是想泡妞，借机靠近她们！普通示好可以，但更进一步的小心思，绝对禁止！”\\n意识的虚空中，古拉姆一拳捶在林宇翔的头上。\\n“痛痛痛！”\\n那痛楚就像真的挨了一拳那样。\\n“噫！连‘泡妞’这种词也学会了，我果然不该在你看漫画的时候当翻译。”\\n如果在以前，林宇翔又会被收监在古拉姆的怒火牢笼中，不过，现在古拉姆抱着胸，似乎在等着他的解释。\\n古拉姆对林宇翔的容忍值好像变得越来越高了，之前，林宇翔向他坦白手机无法和断剑合体这事，他也只是骂了几句便原谅了林宇翔。\\n可是，他可以接受一个弱小的伙伴，却不能接受一个胆小的伙伴。\\n“如果再发生你晕倒的情况，我不能再不自量力地和敌人硬刚，我要努力逃跑，跑到一个安全的地方再叫醒你。战斗由你负责，逃跑由我负责，无论如何，活下来才是最重要的。明知道赢不了还要和对方厮杀，不是超强，而是超笨。只有活下来，才有资格讨论打赢的策略。” 林宇翔的话里充满了真诚。\\n“你这家伙，竟然想到这一点去了……”\\n“嗯，以你王道漫画主角的性子，一定不愿当逃跑专家。”\\n“没错……”\\n“那就让我来当邪道漫画的主角，为了拼命逃跑而战。之前看了日夕大人射向巴萨克的那几个光弹，我就在想，如果日夕大人用光弹连发来帮我特训，我一定能变成躲避和逃跑的专家。”\\n在古拉姆的记忆中，这是林宇翔第二次认真起来的样子。第一次是大言不惭地要和他一起打败邪王，第二次是现在，说着这种真正的战士所不齿的话。\\n但现在这个样子，让古拉姆觉得更可靠。\\n“……随便你。”\\n被林宇翔劝服的古拉姆，简单地跟日夕说了下理由。日夕很爽快地答应了帮忙。\\n特训开始了。\\n像玩躲避球一样，运动神经非常一般的林宇翔一开始为了躲开日夕的一枚光弹，就疲于奔命了，幸亏他现在用的是古拉姆的身体。\\n速度和威力都不输于手枪子弹光弹，粉碎了林宇翔脚下的坚冰。\\n\\n林宇翔一边躲一边逃。\\n渐渐地，在两枚光弹的追击下也能勉强活命。\\n日夕出手还真是一点也不轻啊，不过，每当他受伤严重的时候，日夕就会为他回血。\\n美滋滋的。\\n有女神陪着练功，当然事半功倍啦。\\n才过去半天，林宇翔已经可以同时躲开三枚光弹了。\\n渐渐地，有不少尸族怪兽围观林宇翔的特训，从某个顽皮的怪兽扔出第一个雪球开始，越来越多的雪球袭向林宇翔，严肃的特训变成了混乱的雪仗，场面一度变得非常欢乐。\\n那些受到邪王魅惑的怪兽，在月夕不分日夜的治疗之下，负面状态得到大幅清除，基本可以控制自己的神智了。\\n朱雀从高处看着两组英雄的特训。\\n就让大家享受片刻的轻松吧，好几天了，从尸族的斥候报告来看，邪王还没有什么动静，看来他们也在养精蓄锐。朱雀想道。",
    "resoundEventConfigDes_9012": "那一晚，日夕做了一个美梦。\\n林宇翔对李雨蒙的爱慕感染了古拉姆和埃癸斯，两名远古族如雄狮般的战士带领着他们的部落，拜倒在她的裙下，就连姐姐的那位雄性搭档，也表示要臣服自己，姐姐更是把她的弯月座驾献给自己。小小的日之殿挤满了信众……\\n那是邪王战争之前还是之后的事情呢？不重要了，凭借这些信众，她便能在超进化大陆所向无敌。\\n她在信众中优雅地穿行，走到古拉姆和埃癸斯旁边的时候，他们向她的手背献上忠诚的一吻。她既骄傲又害羞，走到镜子前欣赏自己成为女王后的姿容和威仪。\\n她的银发中闪耀着更加璀璨的金光，她的眼睛满是荣耀，又楚楚动人，她的笑容让整个日之殿熠熠生辉。\\n然后，她被古拉姆叫醒了，古拉姆催促着她给林宇翔特训。\\n唔……讨厌，即使是梦，她也想在那里呆久一点。不情愿地起床，随手拿起床边的镜子照照自己的样子，貌美依旧，只是有点睡眼惺忪。\\n洞外，古拉姆正催促着她快点出来，真是急性子的家伙。\\n她对着镜子捋了捋头发，却突然发现，自己的眼睛，变成了诡异的紫色，自己的脸，变成了朱丽叶那张妖异的脸。\\n“亲爱的，原来你这么想我……”镜中的朱丽叶笑着对她说，“我终于找到你了，你逃不掉的……”\\n她慌忙把镜子扔到地上。咦？为什么自己的手边会有镜子？\\n想拿起镜子的时候，她发现诡异的紫光正从自己雪白的手臂中迸射而出。\\n“啊——”她尖叫起来。\\n这次，真的醒了，原来是个噩梦。\\n“小夕，你怎么了！”月夕握着日夕的手。\\n“雨蒙酱！日夕大人！”古拉姆（林宇翔）也闻声冲了进来。\\n“……没事，做了个噩梦。你们一直在洞外？”日夕问道。\\n“这家伙怕邪王派怪兽来暗杀你们，说要在这里站岗。“回答的是古拉姆。\\n“太夸张啦……不必做到这一步。“日夕说道。\\n“没事，反正古拉姆同学也就在看漫画。哎哟！”在意识的虚空被古拉姆捶了一拳的林宇翔马上转了一个话题，“上半夜由埃癸斯守着，我们一点也不辛苦。”\\n“小夕，我已经恢复得差不多了，我们要不要先……？”月夕拉了拉日夕小声问道，她想要先帮妹妹净化残留在体内的变异孢子的能力。\\n“没事啦没事。”日夕不想在异性面前再度睡下，就起来了，反正躺在冰块上也不舒服，说不定因为这样，自己才会做噩梦。\\n“日夕小姐，既然你醒了，要不要继续给这家伙特训？”\\n“古拉姆，你对自己的搭档完全没有手下留情呀。好吧，今天我也要动真格了。”日夕说。\\n“不要啦，既然日夕大人醒来了，我想睡一下！”林宇翔向古拉姆抱怨。\\n越是高级的怪兽，越不需要睡眠，但是，林宇翔觉得自己累得能倒头就睡，特别是经过了一整晚的守夜。\\n“对手可不会在你睡觉的时候停止追击你。”古拉姆回应道。\\n“步子一下子迈太大的话很容易蛋痛……”\\n“我把这话转告李雨蒙小姐？”\\n“请马上进行特训，我今天的目标是躲开二十枚光弹！”林宇翔信誓旦旦地对日夕说道。\\n呵……真是单纯的男人，古拉姆心里嘀咕着。\\n嘛，抱怨归抱怨，到了特训的时候，林宇翔还是卯足了劲。从天还没亮的凌晨到晨曦初现的短短时间里，他已经可以躲开日夕连续射出的五枚光弹。\\n“这还不是你的极限！”\\n在古拉姆的鼓励下，林宇翔又在朝阳下奔跑起来。",
    "messageInitContent_250": "嘿嘿用刚进化的轰龙来打小鸟龙",
    "resoundEventConfigDes_9017": "埃癸斯刚结束了特训，正在和寇斯金布置冰川谷北部的防御工事。巴萨克因为接连几次输给埃癸斯，对着一块巨大的冰石发泄怒气，冰石被他的双拳击出数个大大小小的凹坑。月夕经过两天的养精蓄锐后，体力和精神都恢复得差不多了，她刚和朱雀检查完世界树的状况，不过这次，她再没有勉强自己为世界树治疗。\\n大家见到古拉姆和日夕回来，两者都神色异常。\\n古拉姆把遇袭的事跟大家说了之后，寇斯金反而振奋起来。\\n“无法在战场上光明正大地打败我们，才搞这种小动作吗？现在正是我们大军出击的好时机！”\\n“不要冲动，现在回想起来，这次暗杀有点奇怪，特别是最后一击，极限放着明明被幽鬼缠住的我不管，偏偏去袭击日夕小姐。”古拉姆说。\\n“没准他们在变异孢子的影响下，变得不太清醒？”埃癸斯说。\\n“会不会这是引诱我们主动出击的陷阱？”古拉姆说。\\n“我们还是先听听朱雀大人的意见。”埃癸斯说。\\n这时，一道辉煌的火光从天而至。\\n“你们刚才说的话，我都听到了。”\\n朱雀来到大家身边，从世界树的树冠上飞下来的时候，他听到了大家的讨论。\\n“能互相配合的暗杀行动，不像是迷迷糊糊的怪兽能做到的。”朱雀说。\\n“朱雀……”\\n日夕低吟，她看着朱雀的眼神有种朦胧的敌意。\\n“古拉姆，日夕大人有点不妥，雨蒙酱也怪怪的。”林宇翔说。\\n自从日夕被极限偷袭之后，他就偷偷注视着日夕，好几次透过日夕的眼睛，看到始终失神、表情没有一丝波动的李雨蒙。\\n“嗯，同感。说不定她看到我们身心合一的一击后，被吓到了，奇怪为什么我们的断剑能有那种威力。我们再观察一下，不过幸好日夕小姐没有受伤。对了，我要把身心合一的战斗方式告诉他们！”说到提升战斗力这种事，古拉姆兴奋起来。\\n“埃癸斯、月夕小姐、日夕小姐——”\\n接着，古拉姆手舞足蹈地模仿着在水中游泳的样子，又让林宇翔配合他一起挥剑。可是林宇翔心有所虑，无法做到古拉姆期待的结果。\\n“竟然能做到那种程度吗？”埃癸斯疑惑地看着古拉姆，挚友不像开玩笑的样子。\\n“说不定这才是人类和远古族合体的意义！”马克对埃癸斯说。\\n“一定是这样！如果防御力能大大增强，那么不管邪王使用什么战术，我们都不用怕！”埃癸斯说。\\n“可是，我没有那种强烈地要治愈大家、祝福大家的念头，怎么办……”欧文担忧地对月夕说。\\n“没关系，这种事情交给我就好，欧文先生不是一直在做自己擅长的事来帮助大家吗？”月夕安慰道。\\n“古拉姆，我们也来特训吧，我们好久没有过招了！”埃癸斯对古拉姆说。\\n“正有此意！”古拉姆说。\\n“古拉姆，呆会，我们来比一比游泳！”寇斯金羡慕地看着他们，不甘落后地说。\\n“好！”古拉姆爽快地答应道。\\n大家你一言我一语，高昂的情绪把刚才的疑虑一扫而空。连朱雀也期待着他们展现新的力量。\\n“日夕小姐，你也要来吗？”埃癸斯问道。\\n“……”日夕没有回答。\\n在大家准备各显身手的时候，埃癸斯看到日夕的掌心已经飘浮着一枚光弹。\\n“埃癸斯，日夕小姐似乎不止想稍微比试一下这么简单！”古拉姆拔出断剑。\\n“你惹她生气了吗？”埃癸斯看到古拉姆严峻的表情，也举起了重盾。\\n日夕手中的光弹越变越大，转眼间，光弹已经比埃癸斯的重盾还要大。她白金色的肌肤中还迸射出了紫色的诡光。\\n“小夕！”\\n“不对，你们看到日夕小姐身上的流动了吗？”\\n“……喂喂。”\\n可是，身负太阳的女神，要对付的并不是他们。",
    "messageInitContent_251": "在猛烈的攻击前多少肉盾都没用",
    "resoundEventConfigDes_9018": "日夕把力量提升到极限——\\n“坠落吧！哈——！！！”\\n日夕突然转身，手一扬，似乎能让万物瞬间蒸发的小型太阳朝朱雀疾冲而去。\\n但是，再次出乎意料的事情发生了。\\n小型太阳像破壳的鸡蛋般出现了裂缝，从裂缝中迸射而出的正是诡异的紫光。裂缝越变越长、越变越粗，光弹变成光蛋，一团紫色的电光从里面破壳而出。如巨型蛋壳般的光球随即消失。\\n这只不过是瞬间发生的变化，轮廓模糊的电光冲到朱雀面前的时候，已经具象化为某种飞禽，其怪异的形态，让朱雀想起了罗密欧裤子上的那只长腿鸭。\\n但是，它龇开了鸭子不会拥有的尖利龅牙，冲朱雀嘶叫，张开鸭子不会拥有的由电光编织而成的宽大翅膀，朝朱雀扇出飓风。\\n明明是没有实体的电光，但朱雀身上的辉煌焰火，因为它的飞扑变得忽明忽暗，而它可怖的勾爪间闪烁着强劲的魔力，每当勾爪从朱雀身上划过，焰火就会短暂被撕开然后再度恢复。\\n紫色的可怖电光朝金色的辉煌火焰不断疾冲过去，似乎希望把朱雀消融在自己的电光中。朱雀在天空盘旋，似乎想要摆脱这不休的追逐。\\n日夕茫然地看着上方，月夕想飞上去帮助朱雀大人，但又担心妹妹不知道还会发生什么状况。而无法飞行的大家，只能束手无策地看着头顶的战斗。“古拉姆，日夕大人……恐怕吃过那种孢子。”林宇翔说。\\n“你说什么！？”\\n林宇翔的话，给古拉姆带来的震惊不亚于目睹日夕对朱雀的突袭。\\n于是，林宇翔把在熔火之巅背起日夕时所看到的，告诉了古拉姆。\\n“所以，日夕一路上一直忍耐着把我们变成敌人的冲动？”古拉姆说。\\n“古拉姆同学，你、你真是个好男人！”林宇翔感动得都要哭了。\\n“……呃？”\\n“老实说，我怕你会把雨蒙酱和日夕大人看成邪王的间谍，才一直没敢告诉你。”\\n“我怎么会随随便便地怀疑同伴？而且来冰川谷路上，日夕小姐有的是机会偷袭我和埃癸斯。”\\n“但日夕大人却不愿意相信龙族族长。”\\n“龙族向来对远古族不友好，或许，日夕小姐不想把这种潜在危险留在大家身边。”\\n“日夕大人人美心善！”\\n“等她清醒过来，你再拍马屁吧。日夕小姐这个样子，是一直以来抵抗邪王的意志力终于消耗殆尽了吗？”\\n“不，一定是幽鬼和极限对她做了什么，才让她失常的！”\\n尽管林宇翔这样认定着，但和古拉姆却讨论不出什么来。\\n于此同时，月夕向日夕释放出强大的治疗光芒，但这似乎并没有什么用。\\n另一边，马克正急切地向埃癸斯询问其他事情。\\n“那是属于邪王的光芒吗？”\\n“没错……”\\n“为什么邪王要对付朱雀大人？他们的敌人，首当其冲是我们呀。”\\n“这个嘛，智者们曾说过，朱雀大人有强大的回血和重生能力，如果这是真的，朱雀大人就几乎象征着胜利。”\\n“怪不得，邪王是要先粉碎我们的后盾啊。”\\n三位远古族的首领在担心着朱雀和日夕的时候，大家都没有在意的巴萨克突然冲到日夕面前，一拳打在她的脸上。\\n“龙屎的！原来吃了变异孢子的是你！你还冤枉老子！” \\n日夕没有闪躲，顺从地被打倒在地，不过，她的眼睛依旧望着那团电光。\\n“住手！”\\n古拉姆和埃癸斯同时冲到日夕前面，挡住了巴萨克的第二拳。\\n这时，寇斯金从后面扑来，打算再给日夕沉重的一击。\\n幸好，古拉姆跳到日夕身后，撞开了寇斯金。\\n“你看不出日夕大人被某种魔力操纵着吗！？”\\n林宇翔吼道，他在激动之下抢过身体的控制权。\\n“可是，看样子，只有把日夕大人打晕，那只怪物才会停下来！”寇斯金大喊。\\n除此之外，他想不出其他办法了。",
    "messageInitContent_252": "快和它们说栓Q",
    "resoundEventConfigDes_9015": "“……古拉姆，你有什么办法？”\\n意识的虚空变成了海底的样子，充斥着林宇翔和古拉姆身边的是黑暗、冰冷和无边无际的水。\\n“你也知道我水性不太好……”\\n“我游泳倒是不错，还在暑假做过兼职教练。”林宇翔没说自己是为了看妹子才学的游泳。\\n“游不上去吗？”\\n“手脚僵硬了，如果控制身体的是你，一定能突破这种极限。”\\n“……”\\n此时此刻，这种夸奖没法让古拉姆高兴起来。说到底，还是自己太大意了，这家伙明明没有足够的实战经验，自己却对他放任不管。古拉姆责怪着自己。\\n“喂，为什么我突然会用剑了？而且还用得不错？”林宇翔抛出了一个与生死无关的问题。\\n“我也很奇怪。”\\n“自从决定自己要成为什么样的角色，这副身体，我用得还不赖，对吧？”\\n“你是要我在我们死之前夸奖一下你吗？”\\n“在第一次遭到冰球袭击的那一刹，这副身体的肌肉记忆，似乎早已刻画在我的记忆中……”\\n林宇翔隐约觉得弄清开挂的原因，是自己和古拉姆获救的关键，所以，他没理会古拉姆的吐槽，自顾自地说下去。\\n“你的意思是，如果我也能拥有游泳的记忆，凭借我在战场上比你强大的意志，就能突破现在身体的困境，游出水面？”\\n“正是如此。所以说，古拉姆同学，那时你在干嘛，总不会在回忆漫画剧情吧？”\\n“我在想剑招，笨蛋！我们的断剑，每次出招都威力大减，我必须想一些适合这把断剑的招式。”\\n虽然短暂使用过一把替代用的长剑，但古拉姆还是觉得不够趁手。毕竟是生死相随无数回的伙伴，不能说换掉就换掉。\\n“而那个瞬间，我正好想试着用剑挡掉那些冰球，回想起你某个挥剑的姿势，然后，身体就自己反应起来……”\\n“啊……好像想通了一点又好像没弄懂！”古拉姆脑子一团糟，失去了耐性。\\n“还没懂吗？就是当我们俩想着同一种东西、同一件事的时候，我们就能进入身心合一的状态，即使是我操控着身体，但你的肌肉记忆也能为我所用，所以，我才会那样挥剑！”\\n“这、这样吗？那现在该怎么办？”古拉姆问道，既然搞清楚了原因，就要尽快想办法。\\n“你快点想象自己是游泳高手的样子。”\\n“好……但即使你这样说，我也不是说想象就能想象出来啊！”\\n“动画！那部讲男子游泳部的动画里，不是都是游泳高手吗？你把自己想象成他们！”\\n“好、好啦！”\\n“还有，跳出水面之后，如果我们想着用相同的剑招对付他们，即使由你控制身体，不知道攻击的威力会不会比以前更大。”\\n“那就试试！”\\n商量好之后，古拉姆和林宇翔开始一起想象着自己游泳的样子。\\n意识的虚空中，两者的身体渐渐靠近、渐渐重叠、渐渐合为一体。\\n古拉姆的手指抽动了一下，四肢都僵硬了，但以自己的意志，还可以使出最后一丝力气。锁链尖端的蛇头尖钩也停止了攻击，可能以为自己已经死了，很好，就是现在！\\n古拉姆猛地双脚一蹬、向上划动双臂，一口气冲出了水面，将浮在头顶的碎冰撞得四处飞散。原来游泳就是这么回事，以后还要加强训练呢，不能让这家伙在特训中超越自己地成长！\\n肺部得到充足氧气的一瞬，他扯着极限的其中一条锁链，借力一跃。\\n在初阳的照耀下晶光闪烁的水花，在幽鬼和差点被拉进水里的极限头上纷纷洒落。古拉姆的身姿和剑光在他们惊慌的眼中显得分外耀眼。无法抵抗地，他们任由古拉姆的断剑砍向自己。\\n明明只是一把残破的断剑，但绽放出来的剑气却狠狠地从幽鬼的胸部劈到极限的背部。也就是说，剑刃未至，幽鬼和极限已被砍至重伤。\\n随后，极限的七条锁链也被断剑轻松砍断。\\n古拉姆稳稳地落到地上，呻吟声和血腥味从背后传来。他和林宇翔都惊讶于刚才那一剑的威力。\\n“这同步率简直呜哇了！”林宇翔激动得已经忘词了。\\n古拉姆转身，看到幽鬼和极限逐渐恢复到究极级的形态，幽鬼的发辫变回普通的发辫，已无法再从雪下的坚冰中拔出冰刀，极限的七条锁链也只剩下三条。看来，他们刚才是拼尽全部的力量，短暂地提升到不朽级的形态和战力，受了重伤之后，理所当然地无法让高级形态维持下去。\\n古拉姆正考虑要不要杀掉他们，但对奄奄一息的对手施加最后的残忍，并不是他作战的风格。\\n“如果你们还爬得起来，就回去对邪王说，别再搞这种肮脏的暗杀了，堂堂正正地来一场决斗吧！单挑也行，军队间的对决也行！”说罢，古拉姆转身朝日夕走去。",
    "messageInitContent_253": "听我说栓Q",
    "resoundEventConfigDes_9016": "“呜……怎么办……真正的任务，还么开始做呀……”\\n“呃……要逃吗……回去王那里，也是死路一条……”\\n“没办法……就由我先走一步吧，你……千万别失败呐……”\\n“交给我吧……我说，其实你，也是个不错的雌性嘛，下辈子再见的话，我们试着约会吧。”\\n“呵呵呵……虽然你也是个不错的雄性，但有那个时候的话，你还是在我的追求者里，乖乖排队好了。”\\n濒死的幽鬼和极限正进行着一段尚留理智又视死如归的对话，很快，他们就制定了一个简单的战略。\\n“呀——”幽鬼尖叫着，朝古拉姆冲过去，贴近的一瞬用六只手死死缠住古拉姆。\\n极限同时厉呵一声朝幽鬼后背撞去，就在那一瞬间，幽鬼和极限同时大吼。\\n“不死·霸体！”\\n“骗术·神行！”\\n他们触发了只有达到不朽级才拥有的技能。“搞什么！？”这两个技能，在以往和究极级的尸族和木偶族对战中从没有见过，难道，又是不朽级的技能？古拉姆已经无法用常识来预测邪王手下的能力，吃下变异孢子后，竟然能有这般爆发力？\\n超高的霸体配合极快的速度，极限一瞬剑就冲到日夕身前。\\n日夕并非不想帮助古拉姆对抗敌人，而是她根本无暇顾及。因为她在拼命抑制着又一次出现的效忠邪王的欲望。这是她以为自己早已克服的欲望，如今变得异常剧烈再次袭来。\\n但现在，她更想加入战局，不是作为古拉姆的同伴，而是作为敌人的一方。\\n“忍住！闭上眼睛，好好想象着，我们比邪王朱丽叶更美丽的一面！”李雨蒙鼓励日夕。\\n“没错……我……不会臣服……唔……邪王朱丽叶……好完美！”\\n“带个黄色围栏就以为自己是，不，是何等雍容华贵的女王之冠……还有那么大一条法令纹，呃，彰显着女性岁月之美……妆容真是一言，唔，是凌驾所有经典和潮流的妆容……”本来想数落朱丽叶的丑陋的李雨蒙，也不知不觉开始赞美起她来。\\n日夕甚至还没来得及反应，就被极限的一条锁链缠住了脖子。随着一阵浓郁的香味，一条锁链将什么送进她的嘴里，口腔里熟悉的触感马上让她知道那是什么。\\n孢子团……\\n“这是王特地为你准备的，好好享用吧！”极限说。\\n天知道他和幽鬼忍得多辛苦，才没有私吞了这个孢子团。\\n“呃——”\\n日夕想把孢子团吐出来，可是——\\n“乖乖吞下去！还是说……你想我来帮帮你！”极限威胁到。\\n“……呜呃——”\\n日夕感到孢子团沿着自己的脖子朝肚中滑落之后，锁链尖端如枪头那样的东西，也从自己的口中抽了出来。\\n“啊，王啊，我们终于……完成了任务……”\\n在猛然获得超越自身的力量后，极限迅速衰弱下来倒在了地上。\\n“咳咳……咳咳咳！”\\n“日夕小姐，你还好吗？”古拉姆终于摆脱了幽鬼，跑到日夕身边，他只是单纯地以为日夕和极限也发生了一场战斗。\\n“没事……”日夕摆摆手。奇怪，皮肤下的紫光消失了。\\n幽鬼也死了，邪王指使的突袭彻底失败。见日夕没受伤，古拉姆提议快点回去，把这件事告诉大家。\\n“……”\\n日夕没有回话，只是默默地跟在古拉姆身边。\\n“日夕大人好像有点奇怪。”林宇翔说。\\n“……可能被极限吓呆了。”古拉姆说。\\n“你也太小看雨蒙酱和日夕大人了。”林宇翔不满地说。\\n日夕没有在意古拉姆关切的目光，而是陷入一种奇怪的自我怀疑中，就连李雨蒙，意识也变得迷迷糊糊。\\n黎明时分的那个梦，她还依稀记得，镜子里面的，是自己，又好像不是自己。下意识地想去确认这一点，但找不到镜子，不过还是很快找到了能替代镜子的东西——她拉住了古拉姆的手。\\n“日夕小姐？”\\n“雨蒙酱？”\\n日夕的举动让古拉姆和林宇翔大吃一惊，林宇翔甚至连高兴也顾不上，只是呆呆地看着日夕的手。\\n“剑……给我……”\\n“给、给给……”\\n从来没有和日夕如此亲密接触过的古拉姆，慌乱地把剑交到日夕手上。\\n断剑的钢面映照出来的，是一位戴着王冠的绝色女王，有一双比玫瑰更红艳的双眼。\\n“日夕小姐，我的剑怎么了？”\\n古拉姆有点好奇、但更多的是担心地稍稍凑过去。\\n“会不会因为我们刚才那一剑太帅了，日夕大人才奇怪一把断剑怎么会有那种威力？”林宇翔说。\\n“日夕小姐会好奇这个吗？”\\n他没看出剑上有什么奇怪的东西，但看着日夕专注的样子，也不好马上把剑拿回来。\\n“那个孢子团……耗尽了我几乎所有的魔力……吃下孢子团的你……是我的分身……呵呵呵……为了王……燃尽你的生命吧……”\\n“镜中”女王诱惑的嗓音在日夕心中响起。\\n日夕觉得好像有谁对她说话，又好像是自己在自言自语。\\n那个女王好像是其他怪兽，又好像是自己。\\n燃尽生命？日夕看了一眼古拉姆，那把声音又响起了。\\n“不是他……要对付的是火焰与不死的化身……明白了吗……明白了……”\\n日夕回应着女王，又好像回应着自己。\\n站在日夕身边的古拉姆，并没有看到或者听到任何异常，在他眼中，唯一异常的是日夕。\\n“日夕小姐，如果你想练剑的话——”\\n古拉姆话没说完，日夕就把剑递给他，然后自顾自地向前走去。",
    "messageInitContent_254": "永远在下一关等你哦！",
    "messageInitContent_255": "快说谢谢鸟龙",
    "messageInitContent_256": "幼锤鸟！又锤了！",
    "resoundEventConfigDes_9019": "“保护好日夕大人！我去对付那只鸭子！”林宇翔抽出断剑，对埃癸斯说。\\n“两位族长，请你不要轻举妄动！”\\n埃癸斯挡在日夕前面，背后的几块轻盾把日夕护得严严实实。\\n“古拉姆，要上了喔！”\\n没等古拉姆回答，林宇翔就朝紫色的可怖电光“鸭子”冲过去。\\n因为“鸭子”在头顶十几米高的地方，没有飞行能力的话只能借助起跳点来跃起。无奈，林宇翔尝试了几遍，断剑的剑尖还是够不着。\\n就在此时，“鸭子”的耐性好像也达到极限似的，体积突然增大了一倍。\\n日夕的双眼变成紫色，雪白的肌肤下也涌动着更强烈的紫光。\\n同时，金色和紫色的光带呈双螺旋状，从日夕的身上连接到那团电光之中。\\n“古拉姆！日夕快撑不住了！”埃癸斯喊道。\\n围绕着日夕的橙金色流动，以极快的速度在减弱，搀扶着她的埃癸斯，感受到她的生命也在流逝。\\n“我想起来了！她之前的那次暴走，也放出过这种光芒！原来那个时候她已经吃过变异孢子了！巴萨克说得没错！”寇斯金想起了上一次大战。\\n没听说过这样的事的埃癸斯，不知道该怎么回答。\\n但在另一边的林宇翔，却气得浑身发抖：“即使这样，她和雨蒙酱不也是站在尸族这边，和大家一起并肩战斗吗！哪个女孩子会没有秘密的！”\\n“别分心！再耽误下去，她们都会死的！”\\n古拉姆的话仿佛一只名为“绝望”的手，拽紧了林宇翔的心脏。\\n“那、那该怎么办？”\\n“……我们无法跳到那东西和朱雀大人的战场上，只能从别的地方想办法。”古拉姆朝日夕那边望去，“如果能切断日夕和它之间力量传递的连结……”\\n“能砍得断吗？”\\n“不知道，只能一搏！”\\n“好、好……身体，交给你了！”林宇翔握剑的手在颤抖，他想把身体交给古拉姆。\\n“什么交给我，这种事，当然是我们一起做啊！”\\n“……嗯！”\\n林宇翔坚定地望着日夕头顶那条光带，他和古拉姆的意识，开始合二为一。\\n两者一同控制的躯体朝那位快要凋零的女神狂奔而去，斜举在身前的断剑刮起能席卷一切的狂风。\\n古拉姆/林宇翔的肌肉深处，似乎有无数股火花要迸裂而出，抑制不住的力量好像让他们/他每跑一步都会踏沉大地。\\n“喔喔喔喔喔喔！！！”\\n真·神剑古拉姆怒吼着，一脚踩在寇斯金的头顶，往上一蹬，把全身的力量尽数压在大剑上，如强势波涛般往日夕头顶的光带劈去！\\n这一剑包含着复杂而深厚的感情——倾慕、爱怜、同情、珍惜，还有信任和生死相随的志气……\\n是的，日夕爱美、任性、骄傲、经常嫉妒姐姐，所以才会为了变强大吃下变异孢子，但她的种种缺点，被林宇翔解读成可爱的一面，而古拉姆，并不反对这种解读。\\n断剑离光带还有一小段距离的时候，这些感情升华为必胜的信念、升华为断剑的延伸，把光带一刀两段！\\n触碰到光带的瞬间，古拉姆的大剑变成了完全体。",
    "messageInitContent_257": "谐音梗可是要罚钱的。",
    "tribeSeasonName_202305": "赛季202305",
    "messageInitContent_260": "有没有一种可能，它们是在隐藏实力！",
    "mapNodeName_1390": "灰烬萨满",
    "tribeSeasonName_202308": "羽化赛季",
    "tribeSeasonName_202309": "羽化赛季",
    "tribeSeasonName_202306": "破茧赛季",
    "tribeSeasonName_202307": "羽化赛季",
    "mapNodeName_1398": "灰烬遗迹",
    "messageInitContent_269": "是圆滚滚三兽组哒",
    "resoundEventConfigDes_9020": "冰雪城堡。\\n“啊……”\\n因为把全身的魔力注入到一个强化孢子团而虚脱、正在床榻上休息的朱丽叶，突然感到全身闪过一阵痛楚。\\n接着，罗密欧带着因愤怒而扭曲的面容进来了。\\n“……失败了？”\\n“裤鸭鸭一号和裤鸭鸭二号的仇，我一定会再报的！”\\n一号是罗密欧的裤腰带，二号正是从日夕身上吸取力量攻击朱雀的那只电光鸭子。\\n日夕的遭遇，正是罗密欧与朱丽叶所谋划的，但他们期待的两个结果都落空了。\\n神灵朱雀既没有被消灭，日夕也没有被耗尽生命、或者被同伴当作叛徒杀死。\\n在他们的料想中，无论如何都会达到其中一个目的。\\n无法杀死神灵的话，最起码日夕会死去。\\n“远古族……注定是我们的绊脚石。”朱丽叶咬牙切齿地说道。\\n“如果再被他们抢先发现新的石塔，就会有更多的远古族进化成不朽级……啧！真不愉快！”\\n“只要在他们发现更多石塔之前，把他们解决掉就好了。”\\n“亲爱的你可真是……太狠了呢，我太喜欢了。”\\n\\n那些距离邪王雪岭最远的，吃下了变异孢子的怪兽纷纷停下了脚步，他们仿佛同时得到了指令，一起向大陆的最西边挺进。\\n这些怪兽逐渐汇聚成一支大军，准备蹂躏那片肥沃平静的草原。",
    "mapNodeName_1397": "灰烬岗哨",
    "mapNodeName_1396": "灰烬遗迹",
    "mapNodeName_1395": "灰烬岗哨",
    "mapNodeName_1394": "灰烬遗迹",
    "mapNodeName_1393": "灰烬遗迹",
    "mapNodeName_1392": "灰烬遗迹",
    "mapNodeName_1391": "灰烬遗迹",
    "messageInitContent_261": "攻略坛说后面暴走旷野可以自己组装怪兽？我来组成头部！",
    "messageInitContent_262": "各位艾锤，记得给锤锤打call！",
    "messageInitContent_263": "颜值+45谢谢",
    "messageInitContent_264": "这个游戏曾经告诉我们 有颜值是没有什么用的",
    "messageInitContent_265": "那个+1是基因",
    "messageInitContent_266": "你们被强化了，快送",
    "messageInitContent_267": "看这就是一碰没",
    "mapNodeName_1399": "秘仪传送I",
    "messageInitContent_268": "我也太强了吧，冲鸭",
    "messageInitContent_1506": "4保1！！！",
    "randomEventDialogueGroupConfig_8.166": "带着面具跑路",
    "messageInitContent_1505": "安全感MAX",
    "randomEventDialogueGroupConfig_8.167": "它愣了愣，又轻轻地抱了抱你一下。",
    "messageInitContent_1504": "绝对的输出就是该有这种待遇",
    "randomEventDialogueGroupConfig_8.164": "你完全没有注意到神秘商人已经在你身后站了一段时间了。",
    "messageInitContent_1503": "我是穿角兽，我现在一点不慌",
    "randomEventDialogueGroupConfig_8.165": "把面具交给它",
    "messageInitContent_1502": "所以狸猫才是阿朱",
    "randomEventDialogueGroupConfig_8.162": "满意离开",
    "messageInitContent_1501": "懂了它替身是狸猫",
    "randomEventDialogueGroupConfig_8.163": "那个就是我的面具，你是发现什么了吗？",
    "messageInitContent_1500": "他变成怪兽还记得阿朱",
    "messageInitContent_270": "卖萌三小兽",
    "randomEventDialogueGroupConfig_8.160": "它向你凑了过来将你的手握住。",
    "messageInitContent_271": "草原三头兽，嗷呜",
    "randomEventDialogueGroupConfig_8.161": "说就这",
    "98_-150002": "cjhwy2",
    "98_-150001": "古记战役未解锁",
    "messageInitContent_1509": "这里的输出都只会用脸接技能，不慌，没人会责怪它。",
    "messageInitContent_1508": "你说的这个输出会躲技能的吗",
    "messageInitContent_1507": "一个合格的输出就可以团结一个队伍",
    "messageInitContent_272": "这么可爱，你们好意思下手的吗？",
    "messageInitContent_273": "我都想替对面进化了~",
    "messageInitContent_274": "建议去当心魔",
    "messageInitContent_275": "现在还有心魔的吗？",
    "messageInitContent_276": "球球球惹你了~",
    "messageInitContent_277": "在本大爷的攻势下，你们只能抱住圆滚滚的自己认输",
    "messageInitContent_278": "我愿称这关为卖萌关",
    "randomEventDialogueGroupConfig_8.168": "说就这",
    "messageInitContent_279": "英雄难过卖萌关，可惜我不是英雄，我只是个探索者哒",
    "randomEventDialogueGroupConfig_8.169": "也抱它一下",
    "messageInitContent_1517": "火神才是炎拳啊",
    "randomEventDialogueGroupConfig_8.177": "返回的道路显得那么陌生。",
    "messageInitContent_1516": "我到处流浪，向东西南北漂~",
    "randomEventDialogueGroupConfig_8.178": "离开",
    "messageInitContent_1515": "我飘阿飘",
    "randomEventDialogueGroupConfig_8.175": "它发狂似地追上了你，一把将面具抢过，大声咆哮着对你发起了攻击。",
    "messageInitContent_1514": "我摇啊摇~~~~~~~",
    "randomEventDialogueGroupConfig_8.176": "迎战",
    "messageInitContent_1513": "快，前面有个海草赶紧捞它",
    "randomEventDialogueGroupConfig_8.173": "谢谢你，这是报酬呢，请收下吧。",
    "messageInitContent_1512": "我是一颗海草海草",
    "messageInitContent_280": "攻略坛说后面暴走旷野可以自己组装怪兽？我来组成头部！",
    "randomEventDialogueGroupConfig_8.174": "收下",
    "messageInitContent_1511": "海草怎么了 ",
    "messageInitContent_281": "睡什么睡，起来嗨！",
    "randomEventDialogueGroupConfig_8.171": "问一问",
    "messageInitContent_1510": "笑死我了",
    "messageInitContent_282": "小异兽、小星刃，往哪里逃呀~",
    "randomEventDialogueGroupConfig_8.172": "闻一闻",
    "randomEventDialogueGroupConfig_8.170": "你很快就找的了另一颗草。",
    "messageInitContent_1519": "不不这是让你打它",
    "messageInitContent_1518": "这是什么，这是火烫地板呢",
    "messageInitContent_1520": "海上为什么还能骚起来",
    "messageInitContent_283": "新的分岔路出现了！",
    "messageInitContent_284": "我要往左走",
    "messageInitContent_285": "当然是走右边",
    "messageInitContent_286": "是没见过的怪兽！",
    "messageInitContent_287": "封印效果？是封印技能吗？",
    "messageInitContent_288": "站在你们面前的是战斗力超300的皮影人+1！",
    "messageInitContent_289": "我的怪兽甚至不需要+1就可以打败它们",
    "randomEventDialogueGroupConfig_8.179": "你感觉它身体一颤，捂着脸很快就跑远了。",
    "messageInitContent_1528": "现在是海龙了",
    "randomEventDialogueGroupConfig_8.188": "你隐约听到它说“谁”。",
    "messageInitContent_1527": "地龙这回要遁到哪里去呢哈哈哈哈哈",
    "randomEventDialogueGroupConfig_8.189": "告诉它是一个神秘商人的面具",
    "messageInitContent_1526": "快让大家试试你的海之呼吸",
    "randomEventDialogueGroupConfig_8.186": "你发现了自由。",
    "messageInitContent_1525": "这是狸猫换怪兽",
    "randomEventDialogueGroupConfig_8.187": "离开",
    "messageInitContent_1524": "狸猫太子，你好哇",
    "messageInitContent_290": "右边有危险，左边有金币",
    "propConfigDes_50007": "随机红色元核，可镶（sai）进怪兽体内。",
    "randomEventDialogueGroupConfig_8.184": "你发现了一座猫猫头山，也记起了回去的路。",
    "messageInitContent_1523": "啧啧啧，你们",
    "messageInitContent_291": "右边的路有熊出没",
    "randomEventDialogueGroupConfig_8.185": "离开",
    "messageInitContent_1522": "激动什么呢？",
    "messageInitContent_292": "小小皮影人居然敢不让我皮？",
    "propConfigDes_50005": "随机紫色元核，可镶（sai）进怪兽体内。",
    "randomEventDialogueGroupConfig_8.182": "山的那边",
    "messageInitContent_1521": "骚起来！！！骚起来",
    "messageInitContent_293": "让你皮？",
    "propConfigDes_50006": "随机橙色元核，可镶（sai）进怪兽体内。",
    "randomEventDialogueGroupConfig_8.183": "海的那边",
    "propConfigDes_50003": "随机绿色元核，可镶（sai）进怪兽体内。",
    "randomEventDialogueGroupConfig_8.180": "挥手告别",
    "propConfigDes_50004": "随机蓝色元核，可镶（sai）进怪兽体内。",
    "randomEventDialogueGroupConfig_8.181": "回去的路到底是哪边呢？",
    "propConfigDes_50001": "元核类型",
    "propConfigDes_50002": "随机白色元核，可镶（sai）进怪兽体内。",
    "messageInitContent_1529": "海鬼，海狗，海鸟，海龙",
    "messageInitContent_1531": "原来贝爷躲这里了",
    "messageInitContent_294": "当我站在人生的十字路口时，我就会想……",
    "messageInitContent_1530": "海产丰富啊哈哈哈",
    "messageInitContent_295": "那明明是人字路口",
    "messageInitContent_296": "攻略坛说后面暴走旷野可以自己组装怪兽？我来组成头部！",
    "messageInitContent_297": "你们现在跑还来得及，hhhhhh",
    "messageInitContent_298": "哇这危险是什么？",
    "messageInitContent_299": "全都变成蓝怪了。",
    "messageInitContent_1539": "5号位思考中",
    "randomEventDialogueGroupConfig_8.199": "走了不找了",
    "messageInitContent_1538": "无限发现！",
    "messageInitContent_1537": "豪华阵容",
    "randomEventDialogueGroupConfig_8.197": "是生草的味道。",
    "messageInitContent_1536": "放下你的笔，让我回血！",
    "randomEventDialogueGroupConfig_8.198": "尝一尝",
    "messageInitContent_1535": "啊那个花花头好吓人啊",
    "randomEventDialogueGroupConfig_8.195": "捡起",
    "messageInitContent_1534": "那个看剧本的不公平！",
    "randomEventDialogueGroupConfig_8.196": "离开",
    "messageInitContent_1533": "是有贝爷的同生！",
    "randomEventDialogueGroupConfig_8.193": "给它水",
    "messageInitContent_1532": "是到这拍节目的吧",
    "randomEventDialogueGroupConfig_8.194": "它喝饱水之后，欢快地转了个圈，有什么东西飞了出来。",
    "randomEventDialogueGroupConfig_8.191": "凑近听",
    "randomEventDialogueGroupConfig_8.192": "你终于听出来了，它说的是水。",
    "randomEventDialogueGroupConfig_8.190": "它的声音更小了。",
    "16_comment": "永生之茧",
    "messageInitContent_1542": "热闹！",
    "messageInitContent_1541": "如果这时候小黑在会怎样",
    "messageInitContent_1540": "好浪漫啊",
    "4_2137": "充值任意金额每日赠大礼",
    "4_2138": "第一天登录可领取",
    "4_2135": "已领取",
    "4_2136": "限时",
    "4_2133": "解锁全部等级最终可获得",
    "4_2134": "解锁",
    "4_2131": "奖励列表",
    "4_2132": "剩余时间：{1}",
    "4_2130": "{1}级",
    "mapNodeName_1222": "那一天",
    "mapNodeName_1221": "分割房间",
    "mapNodeName_1220": "虚无螺旋",
    "mapNodeName_1229": "酒馆2桌",
    "mapNodeName_1228": "触涌镜花",
    "mapNodeName_1227": "植物园9棚",
    "mapNodeName_1226": "天地鸣动",
    "mapNodeName_1225": "虚无螺旋",
    "4_2139": "第二天登录可领取",
    "mapNodeName_1224": "虚无螺旋",
    "mapNodeName_1223": "异构体",
    "4_2148": "已获得",
    "4_2149": "1.购买万象琥珀后根据概率抽取奖励\\n2.万象琥珀中仅有一份形态大奖，每期万象琥珀只能获得一次形态大奖，连续99次抽取没有获得大奖，则下次抽取必定获得大奖\\n3.可对形态大奖进行选定，若抽取获得的奖励为形态大奖，则必定为选定的形态，已获得的形态大奖可在对应怪兽的形态选项中查看并使用\\n4.万象琥珀每期限购100次，大奖以外的奖励可重复获得\\n5.如抽到已获得的形态，形态会自动转化为500钻石奖励",
    "4_2146": "购买十次",
    "4_2147": "万象琥珀",
    "4_2144": "{1}次内必出形态",
    "4_2145": "购买一次",
    "4_2142": "等级提升",
    "4_2143": "终生限购1次",
    "mapNodeName_1209": "植物园6棚",
    "4_2140": "第三天登录可领取",
    "4_2141": "超值 {1}",
    "mapNodeName_1211": "前室",
    "mapNodeName_1210": "浮沉泡影",
    "mapNodeName_1219": "植物园8棚",
    "mapNodeName_1218": "虚无螺旋",
    "mapNodeName_1217": "虚无螺旋",
    "mapNodeName_1216": "虚无螺旋",
    "mapNodeName_1215": "虚无螺旋",
    "mapNodeName_1214": "虚物影响",
    "mapNodeName_1213": "音乐盒3节",
    "mapNodeName_1212": "植物园7棚",
    "4_2159": "等级",
    "4_2157": "词条属性",
    "4_2158": "宿命效果",
    "4_2155": "选择",
    "4_2156": "元核类型",
    "4_2153": "起源盘",
    "4_2154": "形态自选",
    "4_2151": "任意充值",
    "4_2152": "{1}好礼",
    "4_2150": "概率：{1}",
    "mapNodeName_1200": "古记战役-无尽冲击",
    "messageInitNick_1592": "当姑姑怒伤肝",
    "messageInitNick_1593": "套娃门首席",
    "messageInitNick_1590": "翻车之王",
    "messageInitNick_1591": "千年小卒",
    "messageInitNick_1596": "别慌等我发育",
    "messageInitNick_1597": "被遗忘的角落",
    "messageInitNick_1594": "翱翔的猫咪",
    "messageInitNick_1595": "空大卖萌怪",
    "mapNodeName_1208": "植物园5棚",
    "mapNodeName_1207": "护理所1间",
    "mapNodeName_1206": "缠绵幻梦",
    "messageInitNick_1598": "干净得像风",
    "mapNodeName_1205": "幻梦焚尽",
    "messageInitNick_1599": "克拉的眼泪",
    "mapNodeName_1204": "缠绵幻梦",
    "mapNodeName_1203": "缠绵幻梦",
    "mapNodeName_1202": "缠绵幻梦",
    "mapNodeName_1201": "缠绵幻梦",
    "4_2168": "需先解锁{1}",
    "4_2169": "解锁增益",
    "4_2166": "激活中",
    "4_2167": "已满级",
    "4_2164": "激活",
    "4_2165": "升级",
    "4_2162": "未解锁",
    "4_2163": "选定",
    "4_2160": "敬请期待",
    "4_2161": "激活中",
    "messageInitNick_1581": "已过期",
    "messageInitNick_1582": "含一颗星星",
    "messageInitNick_1580": "我很好奇",
    "messageInitNick_1585": "心在流浪",
    "messageInitNick_1586": "捣蛋鬼才",
    "messageInitNick_1583": "这糟糕的台词",
    "messageInitNick_1584": "传奇武神",
    "messageInitNick_1589": "惯犯",
    "messageInitNick_1587": "回忆突袭",
    "messageInitNick_1588": "跟风流浪",
    "4_2179": "破韧",
    "4_2177": "数值总加成",
    "4_2178": "坚韧",
    "4_2175": "永恒赠礼",
    "4_2176": "武装共鸣",
    "4_2173": "已选定",
    "4_2174": "解锁",
    "4_2172": "重置",
    "4_2170": "战墙加固等级上限",
    "mapNodeName_1266": "陷入或脱离",
    "messageInitNick_1570": "叫我蓝孩子",
    "mapNodeName_1265": "疗养院2栋",
    "messageInitNick_1571": "一级可爱",
    "mapNodeName_1264": "虚无螺旋",
    "mapNodeName_1263": "虚无螺旋",
    "mapNodeName_1262": "虚无螺旋",
    "messageInitNick_1574": "光明海市蜃楼",
    "mapNodeName_1261": "虚无螺旋",
    "messageInitNick_1575": "犯二萝莉",
    "mapNodeName_1260": "虚无螺旋",
    "messageInitNick_1572": "第一高冷",
    "messageInitNick_1573": "节凑掉满地",
    "messageInitNick_1578": "对线大师",
    "messageInitNick_1579": "复制不出你",
    "messageInitNick_1576": "可爱指挥官",
    "messageInitNick_1577": "我是菜",
    "mapNodeName_1269": "虚无螺旋",
    "mapNodeName_1268": "太古之门",
    "mapNodeName_1267": "未知漩律",
    "4_2180": "未激活",
    "4_2181": "已激活",
    "mapNodeName_1255": "龙场9环",
    "mapNodeName_1254": "虚无螺旋",
    "messageInitNick_1560": "引战之王",
    "mapNodeName_1253": "虚无螺旋",
    "mapNodeName_1252": "虚无螺旋",
    "mapNodeName_1251": "虚无螺旋",
    "messageInitNick_1563": "善心渐起",
    "mapNodeName_1250": "虚无螺旋",
    "messageInitNick_1564": "扛刀小萝莉",
    "messageInitNick_1561": "吼吼吼",
    "messageInitNick_1562": "无敌搬砖神",
    "messageInitNick_1567": "零点的孤单",
    "messageInitNick_1568": "哥不打菜鸟",
    "messageInitNick_1565": "焦糖玛奇朵",
    "messageInitNick_1566": "野兽之瞳",
    "mapNodeName_1259": "虚无螺旋",
    "mapNodeName_1258": "喵咖后门",
    "mapNodeName_1257": "虚无螺旋",
    "messageInitNick_1569": "浅蓝",
    "mapNodeName_1256": "祈愿星辰",
    "mapNodeName_1244": "音乐棚8",
    "mapNodeName_1243": "虚无螺旋",
    "mapNodeName_1242": "护理所3间",
    "mapNodeName_1241": "浮沉泡影",
    "mapNodeName_1240": "酒馆3桌",
    "messageInitNick_1552": "橙子小姐",
    "messageInitNick_1553": "饺子皮王子",
    "messageInitNick_1550": "北冥女皇",
    "messageInitNick_1551": "不败的王者",
    "messageInitNick_1556": "踮脚要亲亲",
    "messageInitNick_1557": "怕嘿咩",
    "messageInitNick_1554": "最甜的糖",
    "mapNodeName_1249": "护理所6间",
    "messageInitNick_1555": "睡梦中勿扰",
    "mapNodeName_1248": "虚无螺旋",
    "mapNodeName_1247": "虚无螺旋",
    "mapNodeName_1246": "虚拟空间",
    "messageInitNick_1558": "来自外太空",
    "mapNodeName_1245": "音乐棚9",
    "messageInitNick_1559": "骑着蜗牛狂飚",
    "monsterDes_4": "定位：输出，区域持续伤害，减疗\\n体内蕴藏着巨大热能，打个哈欠可以燃烧整个沙漠，太阳的一生之敌，有一位伟人说过，手拿菜刀砍电线，一路火花带闪电，而荒火龙就是那把菜刀。",
    "monsterDes_3": "定位：输出，区域减伤，减疗\\n因为酷爱挑战铁甲龙从肉食进化成钛金食，它克服了老中医各种少吃点的建议，使龙魂产生了巨大的变化，最喜欢的食材是钢铁侠的装甲。",
    "monsterDes_6": "定位：输出，区域持续伤害，减疗\\n肚子大不一定是胖，可能是传说中的热胀冷缩，逆焰龙王拥有强大的攻击力和范围伤害能力，就它这体型，发出的辐射你都吃不消。",
    "monsterDes_5": "定位：输出，区域减伤，减疗\\n吞食大量钢铁侠的装甲后，铁甲龙终于进化成钢铁侠，哦不对……钢铁龙王，拥有强大攻击力的同时还善于保护同伴，怎样？跟钢铁侠很像吧！",
    "18_2022": "数量",
    "18_2020": "剩余免费挑战次数",
    "monsterDes_2": "定位：输出，减疗\\n在遥远的艾泽拉斯大陆暴龙的父亲魔暴龙日以继夜的对抗着那些入侵者，魔暴龙生性凶残高傲，54级以上的猎人是它们的天敌，暴龙永不为奴！",
    "18_2021": "历史最高积分",
    "monsterDes_1": "定位：输出\\n很多人觉得它是鳄鱼，对于这种质疑陆龙总是不（wú）屑（lì）一（fǎn）顾（bó），丑小鸭能变天鹅，那鳄鱼变龙还有什么好惊讶的吗？",
    "mapNodeName_1233": "虚无螺旋",
    "mapNodeName_1232": "虚无螺旋",
    "mapNodeName_1231": "虚无螺旋",
    "mapNodeName_1230": "虚无螺旋",
    "messageInitNick_1541": "悍劲芭比",
    "messageInitNick_1542": "第六感",
    "messageInitNick_1540": "猪猪站着睡",
    "messageInitNick_1545": "用尽全力笑",
    "messageInitNick_1546": "对线之神",
    "mapNodeName_1239": "缠绵幻梦",
    "messageInitNick_1543": "哥霸气长存",
    "mapNodeName_1238": "护理所2间",
    "messageInitNick_1544": "落入键盘泪",
    "mapNodeName_1237": "缠绵幻梦",
    "messageInitNick_1549": "路边的野花",
    "monsterDes_8": "定位：输出，区域持续伤害，区域减疗\\n逆焰龙帝总是在挑战高难度的焚烧目标，将它们彻底焚毁，挑战对象从一个又一个的可燃物，变成了一个又一个的不可燃物，直至有一天，它遇上了《博人传》。",
    "mapNodeName_1236": "缠绵幻梦",
    "monsterDes_7": "定位：输出，区域减伤，减疗\\n钢铁龙王在进食钢铁侠装甲的同时，品尝着残存其中的记忆碎片。随着进食的装甲数的增加，钢铁龙王了解到的故事日渐完整起来，它对拥有强大攻击力的意义有了新的理解。如今，铁幕之内，铁血不减，更藏柔情。",
    "mapNodeName_1235": "虚无螺旋",
    "messageInitNick_1547": "孤傲的王",
    "mapNodeName_1234": "虚无螺旋",
    "messageInitNick_1548": "苍白的笑颜",
    "monsterDes_9": "定位：输出，范围伤害\\n天生DPS说的就是鸟龙，虽然总有怪兽说看这鸟样还DPS？但鸟龙深信，它的烈焰总有一天会燃遍超进化大陆，连丹妮莉丝·坦格利安都不能幸免。",
    "messageInitNick_1530": "科目三过了吗",
    "messageInitNick_1531": "舔包我最快",
    "messageInitNick_1534": "愿得一人心",
    "messageInitNick_1535": "爱神别感冒",
    "messageInitNick_1532": "正在注销",
    "messageInitNick_1533": "纯白之黑",
    "messageInitNick_1538": "打小就傲",
    "messageInitNick_1539": "半夏微微凉",
    "messageInitNick_1536": "沦为旧朋友",
    "messageInitNick_1537": "静看云卷云舒",
    "messageInitNick_1529": "宠臣",
    "messageInitNick_1520": "小猫拔电源",
    "messageInitNick_1523": "厕所原装进口",
    "messageInitNick_1524": "爱情睡着了",
    "messageInitNick_1521": "一笑倾城",
    "messageInitNick_1522": "卷帝之帝",
    "messageInitNick_1527": "快逃",
    "messageInitNick_1528": "飞鸟恋天空",
    "messageInitNick_1525": "咖喱小姐",
    "messageInitNick_1526": "寄一片星空",
    "messageInitNick_1518": "随着夕阳西沉",
    "messageInitNick_1519": "深藏功与名",
    "messageInitNick_1512": "和猫在等你",
    "messageInitNick_1513": "要决带笑",
    "messageInitNick_1510": "点灯人",
    "messageInitNick_1511": "怀中抱软猫",
    "messageInitNick_1516": "此情已成追忆",
    "messageInitNick_1517": "干饭门首席",
    "messageInitNick_1514": "人傲脾气大",
    "messageInitNick_1515": "生活仍在继续",
    "messageInitNick_1509": "没你我会慌",
    "messageInitNick_1507": "大家快闪",
    "messageInitNick_1508": "保存开心",
    "14_comment": "饲星坛",
    "messageInitNick_1501": "一苟到底",
    "messageInitNick_1502": "茶艺惊人",
    "messageInitNick_1500": "化身孤岛的鲸",
    "messageInitNick_1505": "战场女神",
    "messageInitNick_1506": "聪明的猪",
    "messageInitNick_1503": "笨蛋",
    "messageInitNick_1504": "小猫给哥笑个",
    "shopDes_11": "源初境",
    "shopDes_10": "许愿",
    "messageInitContent_1669": "就把r帝先解决掉！",
    "messageInitContent_1668": "神灵的力量不容质疑！",
    "messageInitContent_1667": "还好我有护盾，它解决不了",
    "messageInitContent_1666": "两大男神，都……站到了我的对面！",
    "messageInitContent_1665": "噩梦~",
    "messageInitContent_1664": "龙帝这头正踩着小风火轮冲过来呢！",
    "messageInitContent_1674": "让我康康你的冰墙！",
    "messageInitContent_1673": "魔龙也是火呀。",
    "messageInitContent_1672": "黯炎魔龙：我呢？",
    "messageInitContent_1671": "风神，我的风神~",
    "messageInitContent_1670": "剑神！我的剑神！",
    "messageInitContent_1679": "毁灭泰坦这个颜色和这个场景绝配啊",
    "messageInitContent_1678": "看着就好疼。",
    "messageInitContent_1677": "这一锤下来我好怕",
    "messageInitContent_1676": "不知道以为那是去打地鼠呢",
    "messageInitContent_1675": "好炸！",
    "1_109": "是否进行远古族怪兽轮回？轮回后{1}小时内无法再次进行轮回。",
    "1_107": "资源全额返还",
    "1_108": "分解元核时资源全额返还",
    "1_105": "建造饲星坛后开启怪兽重置功能",
    "1_106": "是否消耗{1}钻石重置你的远古族怪兽？重置后{2}小时内无法再次重置。",
    "1_103": "收集",
    "messageInitContent_1685": "看我使出双重重生打击应对",
    "1_104": "只能锁定一条宿命效果",
    "messageInitContent_1684": "我总觉得那些锁链会困住怪兽",
    "1_101": "轮回",
    "messageInitContent_1683": "超级无敌破坏能力爆炸炮——",
    "1_102": "{1}后可用",
    "messageInitContent_1682": "必须加上超级！！！",
    "messageInitContent_1681": "无敌破坏炮——",
    "1_100": "怪兽等级{1}开启",
    "messageInitContent_1680": "什么中二招式名！",
    "messageInitContent_1689": "只要不靠墙，它就神不了",
    "messageInitContent_1688": "墙神太强了，快削弱墙！",
    "messageInitContent_1687": "被骗了！",
    "messageInitContent_1686": "这两个奶妈是……",
    "messageInitContent_1696": "对面还真的有个位置让我去加入！",
    "messageInitContent_1695": "双穿甲兽对吧",
    "messageInitContent_1694": "给大家看看什么是双穿",
    "messageInitContent_1693": "痛！",
    "messageInitContent_1692": "你看他那奶量（摇头）",
    "messageInitContent_1691": "这奶完全不够呢",
    "messageInitContent_1690": "给大家介绍一只我的自创怪兽，墙头草！",
    "messageInitContent_1699": "木大木大木大木大木大木大木大木大木大木大",
    "messageInitContent_1698": "欧啦欧啦欧啦欧啦欧啦欧啦欧啦欧啦欧啦欧啦",
    "messageInitContent_1697": "被自己的伤害打死算是输了吗",
    "messageInitContent_302": "我是熊",
    "messageInitContent_303": "你好我是出没",
    "messageInitContent_304": "简单的道路我是不会走的！",
    "messageInitContent_305": "在危险边缘反复横跳",
    "messageInitContent_306": "插个眼先",
    "messageInitContent_307": "给你排了",
    "messageInitContent_308": "后面2只有遗言",
    "messageInitContent_309": "强袭好帅！",
    "messageInitContent_300": "危险我喜欢！",
    "messageInitContent_301": "我的第一场失败！！！",
    "tribeSeasonName_202410": "怒涛赛季",
    "tribeSeasonName_202411": "战栗赛季",
    "tribeSeasonName_202412": "同游赛季",
    "randomEventDialogueGroupConfig_9.41": "问“它”是谁",
    "randomEventDialogueGroupConfig_9.40": "建议它戒赌",
    "messageInitContent_313": "召唤朱雀！",
    "randomEventDialogueGroupConfig_9.38": "说算了",
    "messageInitContent_314": "记得上阵神灵了，然后把主角加满就行了",
    "randomEventDialogueGroupConfig_9.37": "说要再来",
    "messageInitContent_315": "去右边的还不是都得绕回来",
    "randomEventDialogueGroupConfig_9.36": "猜错了哦，要再来吗？",
    "messageInitContent_316": "是新怪兽！！！（/>///<）/",
    "randomEventDialogueGroupConfig_9.35": "同意",
    "messageInitContent_317": "那个怎么这么像面包",
    "randomEventDialogueGroupConfig_9.34": "拒绝",
    "messageInitContent_318": "随地乱丢食物是不对的，小朋友不要学哦，大朋友也不要哦",
    "randomEventDialogueGroupConfig_9.33": "猜错啦，不过呢，这个中包里有个两个大包！很好吃的，我咬过一口，要尝尝不？",
    "mainCityName_8": "一发入欧店",
    "messageInitContent_319": "哈，你们绕回来了？",
    "randomEventDialogueGroupConfig_9.32": "既然如此，那就来吧，反正规则你都清楚了。",
    "mainCityName_9": "斗技场",
    "randomEventDialogueGroupConfig_9.31": "拿奖励",
    "mainCityName_6": "探索营地",
    "mainCityName_7": "起源基石",
    "mainCityName_4": "鳞场",
    "mainCityName_5": "仓库",
    "mainCityName_2": "骨场",
    "mainCityName_3": "木场",
    "messageInitContent_310": "强袭，你的自由呢？",
    "messageInitContent_311": "攻略坛说后面暴走旷野可以自己组装怪兽？我来组成头部！",
    "mainCityName_1": "领地",
    "messageInitContent_312": "在你前面的是高贵的幻化怪兽。",
    "randomEventDialogueGroupConfig_9.39": "是呀，打赌花了10个孢子。不过现在我赢了，它会给我100个孢子，开心！",
    "tribeSeasonName_202403": "银翼赛季",
    "tribeSeasonName_202404": "攻壳赛季",
    "tribeSeasonName_202401": "硬派赛季",
    "tribeSeasonName_202402": "龙腾赛季",
    "randomEventDialogueGroupConfig_9.52": "战斗",
    "tribeSeasonName_202407": "热浪赛季",
    "randomEventDialogueGroupConfig_9.51": "不继续就要给我练手了呢。来吧。",
    "tribeSeasonName_202408": "盛夏赛季",
    "randomEventDialogueGroupConfig_9.50": "迎战",
    "tribeSeasonName_202405": "极巨赛季",
    "tribeSeasonName_202406": "巨物赛季",
    "tribeSeasonName_202409": "启程赛季",
    "messageInitContent_324": "你们能理解那只东西的结构吗？",
    "randomEventDialogueGroupConfig_9.49": "你已经无法拒绝了。",
    "messageInitContent_325": "我逐渐理解了一切！",
    "randomEventDialogueGroupConfig_9.48": "跑",
    "messageInitContent_326": "浪费食物是不对的，小朋友不要学哦",
    "randomEventDialogueGroupConfig_9.47": "跳",
    "messageInitContent_327": "你们管那叫食物？？？",
    "randomEventDialogueGroupConfig_9.46": "踢",
    "messageInitContent_328": "什么面包恶魔大葱恶魔",
    "randomEventDialogueGroupConfig_9.45": "你是在干嘛呀？",
    "messageInitContent_329": "嘿嘿嘿，只有我是从草爹那打上来的吗",
    "randomEventDialogueGroupConfig_9.44": "说再见",
    "randomEventDialogueGroupConfig_9.43": "让它走开",
    "randomEventDialogueGroupConfig_9.42": "干嘛突然向我招手？",
    "messageInitContent_320": "我，就是你的情话制造者（放电",
    "messageInitContent_321": "那才不是面包，分明是粑粑攻击！！",
    "messageInitContent_322": "隔壁一下子快3k战力了。。害怕",
    "messageInitContent_323": "糖果屋？",
    "godContractConfigName_3": "真气",
    "godContractConfigName_2": "利爪",
    "godContractConfigName_1": "涅槃",
    "messageInitContent_335": "向钱进！向钱看！",
    "randomEventDialogueGroupConfig_9.16": "在沙漠中溺水",
    "messageInitContent_336": "点燃它的小尾巴！人间大炮一级准备！",
    "randomEventDialogueGroupConfig_9.15": "裁判收了假金币",
    "messageInitContent_337": "这大炮的后坐力为啥是在中炮的身上？",
    "randomEventDialogueGroupConfig_9.14": "选了还说不选，什么矛盾大师，其实我就很喜欢矛盾大师的作品！#我给你说一下它其中两个作品：裁判收了假金币和在沙漠中溺水，你猜我更喜欢哪个，猜对就送你特别奖励。",
    "messageInitContent_338": "你可以问问ai哦",
    "randomEventDialogueGroupConfig_9.13": "表示没有兴趣",
    "messageInitContent_339": "射程1500，可怕",
    "randomEventDialogueGroupConfig_9.12": "试试",
    "randomEventDialogueGroupConfig_9.11": "呀！你竟然选这个，我的10个孢子没了啊啊啊。#嘿嘿，我这里还有个好玩的小中大包摸奖游戏，要不要也来试一下呢？",
    "randomEventDialogueGroupConfig_9.10": "问和朋友打赌的事",
    "godContractConfigName_7": "广域裁决",
    "godContractConfigName_6": "风翼",
    "godContractConfigName_5": "崩坏",
    "godContractConfigName_4": "龙息",
    "messageInitContent_330": "攻略坛说后面暴走旷野可以自己组装怪兽？我来组成头部！",
    "messageInitContent_331": "殊途同归",
    "messageInitContent_332": "往抵抗力最小的地方走！",
    "randomEventDialogueGroupConfig_9.19": "运气真好，喏奖励，给。",
    "godContractConfigName_9": "背水一战",
    "messageInitContent_333": "炮哥，我的噩梦，诶，怎么这么可爱了！",
    "randomEventDialogueGroupConfig_9.18": "哔哔选错啦！你看，是空的！要再来一次吗？",
    "godContractConfigName_8": "绝命终局",
    "messageInitContent_334": "隔壁有个金矿！快去！",
    "randomEventDialogueGroupConfig_9.17": "要是你选到对的，就把包里的奖励给你。#选到空的，那就来给我练练手吧！#看！这里有2个小包，奖励就在其中一个里头，你猜是哪个？",
    "randomEventDialogueGroupConfig_9.1": "嘻嘻，让我猜猜你会选哪个？",
    "randomEventDialogueGroupConfig_9.30": "不拿奖励继续挑战",
    "messageInitContent_346": "不要挡我，我要去当矿老板！",
    "randomEventDialogueGroupConfig_9.27": "同意",
    "messageInitContent_347": "不要挡我，我要去解救矿卡！",
    "randomEventDialogueGroupConfig_9.26": "真可惜，我们来锻炼一下吧！",
    "messageInitContent_348": "前面跑错片场了吧",
    "randomEventDialogueGroupConfig_9.25": "哪有~",
    "messageInitContent_349": "众所周知，超进化大陆的金矿是挖不尽的",
    "randomEventDialogueGroupConfig_9.24": "说下次一定",
    "randomEventDialogueGroupConfig_9.23": "进店",
    "randomEventDialogueGroupConfig_9.22": "这还真是我最喜欢的！听起来充满了想象对吧！#就送你到我店里看看好了哈哈哈。",
    "randomEventDialogueGroupConfig_9.21": "哦？没问题，但这次有3个包！",
    "randomEventDialogueGroupConfig_9.20": "接过奖励",
    "randomEventDialogueGroupConfig_9.8": "果然是“这个”！我赢了！我和朋友打赌你一定会选这个的！",
    "randomEventDialogueGroupConfig_9.9": "指责它耍花招",
    "messageInitContent_340": "大炮的射程是用命换的",
    "randomEventDialogueGroupConfig_9.6": "-",
    "messageInitContent_341": "灰飞烟灭警告",
    "randomEventDialogueGroupConfig_9.7": "-",
    "messageInitContent_342": "什么时候出个阿姆斯特朗回旋加速喷气式阿姆斯特朗炮皮肤",
    "randomEventDialogueGroupConfig_9.4": "-",
    "messageInitContent_343": "这位探索者，要来一下吗？",
    "randomEventDialogueGroupConfig_9.5": "-",
    "messageInitContent_344": "向我开炮",
    "randomEventDialogueGroupConfig_9.2": "-",
    "randomEventDialogueGroupConfig_9.29": "三个反而猜对了呢！哼，我就不信你下次能猜对。#如果你不拿奖励，再猜对一次的话，奖励就会更大，敢来吗！",
    "messageInitContent_345": "不要挡我，我要去当矿工！",
    "randomEventDialogueGroupConfig_9.28": "不同意",
    "randomEventDialogueGroupConfig_9.3": "-",
    "messageInitContent_357": "我的小鸡骑士呢",
    "messageInitContent_358": "我将带头冲锋！",
    "messageInitContent_359": "我要为爱冲锋！",
    "messageInitContent_350": "冲冲冲冲冲冲",
    "messageInitContent_351": "这骑兵该不会是在暗示我们充值吧",
    "messageInitContent_352": "是的不要怀疑╭(′▽`)╭(′▽`)╯",
    "messageInitContent_353": "不是的你听它狡辩(¬､¬)",
    "messageInitContent_354": "马骑兵冲锋——",
    "messageInitContent_355": "点击怪兽，查看描述",
    "messageInitContent_356": "我是绅士，我喜欢骑兵",
    "mapNodeName_1291": "假如爱也有灵",
    "mapNodeName_1290": "赞美风神",
    "mapNodeName_1299": "藤灵永驻",
    "messageInitContent_368": "兔兔，是你吗兔兔",
    "mapNodeName_1298": "归灵秘境",
    "messageInitContent_369": "小兔几：****，活着真好",
    "mapNodeName_1297": "冰灵不朽",
    "mapNodeName_1296": "赞美雷神",
    "mapNodeName_1295": "归灵集市",
    "mapNodeName_1294": "月神在更上",
    "mapNodeName_1293": "蜃灵",
    "mapNodeName_1292": "归灵秘境",
    "messageInitContent_360": "勇士你好。",
    "messageInitContent_361": "绿衣骑手前来报道",
    "messageInitContent_362": "黄衣骑手前来报道",
    "messageInitContent_363": "蓝衣骑手前来报道",
    "messageInitContent_364": "骑手正在决斗，晚点再来挑战",
    "messageInitContent_365": "草爹！！！！！！！",
    "messageInitContent_366": "我的草（乱叫）",
    "messageInitContent_367": "首通有造唤许可",
    "messageInitContent_1605": "让奶妈感到害怕",
    "messageInitContent_1604": "让我把你们的奶都变成毒奶",
    "messageInitContent_1603": "好家伙不让奶就算了，还变成伤害了",
    "messageInitContent_1602": "刚刚怎么怼莎士彼亚的，我现在就要怎么怼你！",
    "messageInitContent_1601": "赶紧回去写剧本！！！",
    "messageInitContent_1600": "让整队孩子没有奶喝",
    "messageInitContent_370": "终于知道为什么兔子跑得快了，原来后面有狼追着",
    "mapNodeName_1280": "无佑传送门I",
    "messageInitContent_1609": "是不是我一进去就有概率胜利。",
    "messageInitContent_1608": "本来挺可爱的，这技能一看，我……",
    "messageInitContent_1607": "需要尽快解决的怪兽变多了",
    "messageInitContent_1606": "这仇恨拉得！看我第一个收拾你",
    "mapNodeName_1288": "归灵秘境",
    "messageInitContent_379": "整多点前排，不要让它们壁咚了！神灵变成手动。",
    "mapNodeName_1287": "荧灵也是灵",
    "mapNodeName_1286": "归灵秘境",
    "mapNodeName_1285": "归灵传送门I",
    "mapNodeName_1284": "无佑传送门Ⅲ",
    "mapNodeName_1283": "坠落之岛",
    "mapNodeName_1282": "无佑传送门II",
    "mapNodeName_1281": "唯一海岛",
    "messageInitContent_371": "你们都通关了吗？",
    "messageInitContent_372": "为你驮翔（？",
    "messageInitContent_373": "我的第二次失败啊啊啊",
    "messageInitContent_374": "能不能帮我问问这个草丛是哪一路的草丛",
    "messageInitContent_375": "一个aoe一个加速一个减回复",
    "messageInitContent_376": "等我，我晚点再来解决你们！",
    "messageInitContent_377": "它们是有配合的。",
    "mapNodeName_1289": "归灵传送门II",
    "messageInitContent_378": "记得把引导的东西领了",
    "messageInitContent_1616": "你妹就在前头。",
    "messageInitContent_1615": "听君一席话，如听一席话。",
    "messageInitContent_1614": "表面上，这是一个关卡，实际上，这确实是一个关卡。",
    "messageInitContent_1613": "什么废话文学聚集地。",
    "messageInitContent_1612": "不会作死就不会死",
    "messageInitContent_1611": "在你打完这关之后，你赢了。",
    "messageInitContent_1610": "在你还没打这关之前，你不知道你能不能赢。",
    "messageInitContent_380": "你草爹还是你草爹",
    "messageInitContent_381": "朱雀治疗！先保后排！简单到爆炸",
    "messageInitContent_1619": "前排出售小水枪，滋~",
    "messageInitContent_1618": "来人上灭火器",
    "messageInitContent_1617": "赤虹就在下一关！",
    "mapNodeName_1277": "龙之战团",
    "mapNodeName_1276": "太古之门",
    "mapNodeName_1275": "古记战役-深渊之兽",
    "mapNodeName_1274": "虚无空间",
    "mapNodeName_1273": "虚无螺旋",
    "mapNodeName_1272": "虚无螺旋",
    "mapNodeName_1271": "虚无螺旋",
    "mapNodeName_1270": "虚无螺旋",
    "messageInitContent_382": "朱雀治疗！先保后排！简单到爆炸",
    "messageInitContent_383": "朱雀治疗！先保后排！简单到爆炸",
    "messageInitContent_384": "白虎先打罗密欧！我机器人，一生要强！",
    "messageInitContent_385": "白虎先打罗密欧！我机器人，一生要强！",
    "messageInitContent_386": "白虎先打罗密欧！我机器人，一生要强！",
    "messageInitContent_387": "神灵玄武是独角兽一生之敌！",
    "mapNodeName_1279": "无佑离岛",
    "messageInitContent_388": "这关用好玄武反死独角是关键。",
    "mapNodeName_1278": "无佑主城",
    "messageInitContent_389": "封印赤色狮刻不容缓- -",
    "messageInitContent_1627": "赤虹是彩虹的虹哦~",
    "1_140": "白",
    "messageInitContent_1626": "赤红在这里哦",
    "messageInitContent_1625": "哥哥你看这关的战斗力！",
    "messageInitContent_1624": "火神来找你啦。",
    "messageInitContent_1623": "你哥来找你咯",
    "messageInitContent_1622": "肯定是赤虹任性跑出去了",
    "messageInitContent_390": "神灵玄武是独角兽一生之敌！",
    "messageInitContent_1621": "兄妹吵架了？",
    "messageInitContent_391": "玄武反死独角爽炸了",
    "messageInitContent_1620": "帅",
    "messageInitContent_392": "这独角兽这是够恶心，不用玄武不好打",
    "messageInitContent_1629": "只要血量顶得住现在有很多怪兽可以帮你，",
    "messageInitContent_1628": "我也想要变大变小",
    "1_138": "分类",
    "1_139": "品质",
    "1_136": "等级排序",
    "messageInitContent_1630": "自古红蓝出cp",
    "messageInitContent_393": "高霸体单前排奶住，过",
    "1_137": "获得时间排序",
    "messageInitContent_394": "包租公，撼地者，过",
    "1_134": "高",
    "messageInitContent_395": "社恐YYDS，就怕远程击退",
    "1_135": "低",
    "messageInitContent_396": "异形是哪种霸气？",
    "1_132": "筛选",
    "messageInitContent_397": "给你介绍一下，这就是我的异性朋友！不对异形朋友。",
    "1_133": "品质排序",
    "messageInitContent_398": "异形爱好者在此！",
    "1_130": "超进化技只可激活1个，是否切换激活该超进化技？",
    "messageInitContent_399": "锤子爱好者来也！",
    "1_131": "已锁定1条宿命效果，无法锁定该宿命效果",
    "4_2104": "剩余时间：{1}",
    "messageInitContent_1638": "哦前面就是传送门了！",
    "4_2105": "今天已领取",
    "messageInitContent_1637": "什么传送门？？？？",
    "4_2102": "每日获得",
    "messageInitContent_1636": "嘻嘻",
    "4_2103": "持续30天",
    "messageInitContent_1635": "又是这两小家伙，但现在我已经不怕你们了！",
    "4_2100": "一键购买",
    "messageInitContent_1634": "危！",
    "4_2101": "立即获得",
    "messageInitContent_1633": "只要绒绒缩得够小，debuff就跟不上它",
    "messageInitContent_1632": "超凶.jpg",
    "messageInitContent_1631": "你是指觉醒怪和幻化怪吗，红蓝",
    "messageInitContent_1639": "新的boss！！！！",
    "1_149": "存在最高品质的极化能力，是否继续极化？",
    "1_147": "全选",
    "messageInitContent_1641": "好强的守护星！",
    "1_148": "每次分解最多可选择{1}个元核（{2}/{3}）",
    "messageInitContent_1640": "好帅！！！",
    "1_145": "红",
    "1_146": "恢复默认",
    "1_143": "紫",
    "4_2108": "充值金额",
    "1_144": "橙",
    "4_2109": "额外赠送比例",
    "1_141": "绿",
    "4_2106": "活动时间：{1}",
    "1_142": "蓝",
    "4_2107": "前7天任意充值，7天后最高额外赠送1000%",
    "4_2115": "原始契约",
    "messageInitContent_1649": "这输出有点猛的啊！",
    "4_2116": "超阶契约",
    "messageInitContent_1648": "我的前排光速被轰没了！！！！！",
    "4_2113": "任务",
    "messageInitContent_1647": "污妖王和花丸子，你们选一个",
    "4_2114": "等级",
    "messageInitContent_1646": "看我轻易撕开你们的防线",
    "4_2111": "前往充值",
    "messageInitContent_1645": "重装和冥龙王双重镇守！",
    "4_2112": "奖励",
    "messageInitContent_1644": "花丸子的丸子头多少有点",
    "messageInitContent_1643": "阵容过于豪华",
    "4_2110": "{1}可领取：",
    "messageInitContent_1642": "皮匠家族久违的再聚首！",
    "1_118": "未建造饲星坛",
    "1_119": "预览",
    "1_116": "领域",
    "1_117": "建议优先使用怪兽碎片升级技能",
    "1_114": "新极化属性",
    "messageInitContent_1652": "原来我有点脸盲了。",
    "1_115": "基石",
    "messageInitContent_1651": "让我把有领域的怪也都带上！",
    "1_112": "材",
    "messageInitContent_1650": "主要后面还站了个封技能的呢",
    "1_113": "原极化属性",
    "1_110": "万能碎片不足，可前往饲星商店购买",
    "4_2119": "购买等级",
    "1_111": "主",
    "4_2117": "契约等级",
    "4_2118": "契约经验",
    "4_2126": "更替蜕变契约时刷新",
    "4_2127": "去完成",
    "messageInitContent_1659": "得到月夕守护的比蒙oh no！",
    "4_2124": "每日0点刷新",
    "messageInitContent_1658": "对面是谁帮月夕按技能呢",
    "4_2125": "周一0点刷新",
    "messageInitContent_1657": "我需要一个无视领域的buff",
    "4_2122": "每周任务",
    "messageInitContent_1656": "星球改造发动，然后贴膜世界！",
    "4_2123": "挑战任务",
    "messageInitContent_1655": "为什么限1卡会出现在这里！",
    "4_2120": "一键领取",
    "messageInitContent_1654": "就让比蒙巨炮把你们轰出来把！快说谢谢巨炮",
    "4_2121": "每日任务",
    "messageInitContent_1653": "你们已经陷入了无法自拔的菜鸡领域",
    "1_129": "建议优先使用怪兽光谱进化",
    "1_127": "元核髓只能作为消耗材料",
    "1_128": "万能进化光谱不足，可前往造唤商店购买",
    "1_125": "已锁定2条相同的词条属性，无法锁定该词条",
    "messageInitContent_1663": "我是月夕小姐姐我就自己站在第一位了",
    "1_126": "元核髓的词条/宿命默认锁定",
    "messageInitContent_1662": "草丛和龙帝也想",
    "1_123": "一键强化",
    "messageInitContent_1661": "想当月夕小姐姐的1号位！",
    "1_124": "是否消耗{1}{2}，强化该元核至阶段{3}等级{4}？",
    "messageInitContent_1660": "“代表月亮惩罚你！”",
    "1_121": "是否确定批量分解选定的元核？",
    "1_122": "基因破则极化消失时，不会返还已消耗的怪兽经验，是否确定使用？",
    "4_2128": "领取奖励",
    "1_120": "是否消耗{1}钻石重置该元核？（资源全额返还）",
    "4_2129": "购买{1}级升级到{2}",
    "4_2016": "怪兽",
    "4_2017": "排序",
    "4_2014": "元核",
    "4_2015": "道具",
    "4_2012": "背包",
    "4_2013": "全部",
    "4_2010": "可获取途径",
    "4_2011": "点击获取地点，立即移动",
    "messageInitNick_3672": "天下第二",
    "resoundEventStoryName_94": "圣堂武士大败（1）",
    "messageInitNick_1010": "理科男",
    "messageInitNick_3671": "恰瓜门传人",
    "resoundEventStoryName_95": "圣堂武士大败（2）",
    "messageInitNick_3670": "饿肚子之呼吸",
    "resoundEventStoryName_96": "圣堂武士大败（3）",
    "resoundEventStoryName_97": "圣堂武士的道路",
    "mapNodeName_899": "剧狂",
    "messageInitNick_1013": "低调小伙",
    "messageInitNick_3676": "小金人",
    "resoundEventStoryName_98": "圣堂武士的另一条道路",
    "messageInitNick_1014": "白萌王",
    "messageInitNick_3675": "晚餐吃泡芙",
    "resoundEventStoryName_99": "圣堂武士的困惑",
    "mapNodeName_897": "巨晶之地",
    "messageInitNick_1011": "此乃妖孽",
    "messageInitNick_3674": "我在这里等你",
    "mapNodeName_898": "大熔炉",
    "messageInitNick_1012": "你还没个葱高",
    "messageInitNick_3673": "灵活打牌",
    "messageInitNick_1017": "吃橘子的丸子",
    "messageInitNick_1018": "走开我要放屁",
    "messageInitNick_3679": "锤骨",
    "messageInitNick_1015": "爱你没怂过",
    "messageInitNick_3678": "傀儡",
    "messageInitNick_1016": "哥比彩钻还炫",
    "messageInitNick_3677": "桂皮有点皮",
    "resoundEventStoryName_90": "神器的形状",
    "resoundEventStoryName_91": "风花往事（前篇）",
    "4_2018": "元核分解",
    "messageInitNick_1019": "时间都去哪儿",
    "resoundEventStoryName_92": "风花往事（后篇）",
    "4_2019": "出售道具",
    "resoundEventStoryName_93": "圣堂武士的生存之道",
    "4_2027": "加固",
    "4_2028": "加固等级",
    "4_2025": "出售",
    "4_2026": "战墙",
    "4_2023": "分解",
    "4_2024": "前往饲星坛",
    "4_2021": "强化",
    "4_2022": "熔炼",
    "4_2020": "召唤",
    "messageInitNick_3661": "有品的东西",
    "resoundEventStoryName_83": "复仇圣光联盟（狠狠划掉）",
    "messageInitNick_3660": "别逼我说人话",
    "resoundEventStoryName_84": "复仇圣光联盟的希望",
    "resoundEventStoryName_85": "复仇圣光联盟莫得希望",
    "resoundEventStoryName_86": "圣光制造者（4）",
    "messageInitNick_1002": "蠢萌的王妃",
    "messageInitNick_3665": "强壮打脸神",
    "resoundEventStoryName_87": "快的秘诀（1）",
    "messageInitNick_1003": "风尘剑客",
    "messageInitNick_3664": "重新定义补刀",
    "resoundEventStoryName_88": "快的秘诀（2）",
    "messageInitNick_1000": "吃瓜群众",
    "messageInitNick_3663": "家有光龙",
    "resoundEventStoryName_89": "骑兵的马",
    "messageInitNick_1001": "下雨不撑伞",
    "messageInitNick_3662": "永恒的平静",
    "messageInitNick_1006": "煎饼悍将",
    "messageInitNick_3669": "梳子毁灭者",
    "messageInitNick_1007": "对着天空傻笑",
    "messageInitNick_3668": "超帅美妞",
    "messageInitNick_1004": "吃素的蚊子",
    "messageInitNick_3667": "全员饿人",
    "messageInitNick_1005": "科技食品",
    "messageInitNick_3666": "土豆兽",
    "resoundEventStoryName_80": "圣光受害者（2）",
    "4_2029": "切换",
    "messageInitNick_1008": "忘穿秋裤",
    "resoundEventStoryName_81": "复仇圣光联盟",
    "messageInitNick_1009": "此爱为谁留",
    "resoundEventStoryName_82": "复仇圣光联盟（划掉）",
    "4_2038": "请从左列表选择需要分解的战纹({1})",
    "4_2039": "剩余时间",
    "4_2036": "加成{1}%",
    "4_2037": "战纹分解",
    "4_2034": "已方一侧",
    "4_2035": "敌方一侧",
    "4_2032": "卸下",
    "4_2033": "装嵌",
    "4_2030": "分解",
    "mapNodeName_884": "重磅霸王",
    "resoundEventStoryName_69": "呜呜祖拉的惊愕",
    "4_2031": "武装",
    "mapNodeName_885": "大英雄",
    "mapNodeName_882": "巨炎之地",
    "mapNodeName_883": "大老树",
    "mapNodeName_880": "剧钢",
    "mapNodeName_881": "巨炎之地",
    "messageInitNick_3650": "天气白兰花",
    "resoundEventStoryName_72": "呜呜祖拉的愤慨",
    "resoundEventStoryName_73": "茧洞（1）",
    "mapNodeName_879": "巨大之引",
    "resoundEventStoryName_74": "茧洞（2）",
    "resoundEventStoryName_75": "圣光制造者（1）",
    "mapNodeName_877": "小草",
    "messageInitNick_3654": "深海神女",
    "resoundEventStoryName_76": "圣光制造者（2）",
    "mapNodeName_878": "巨炎之地",
    "messageInitNick_3653": "不再回忆谁",
    "resoundEventStoryName_77": "圣光制造者（2.5）",
    "mapNodeName_875": "巨骸之地",
    "messageInitNick_3652": "头铁天后",
    "resoundEventStoryName_78": "圣光制造者（3）",
    "mapNodeName_876": "三巨头",
    "messageInitNick_3651": "豆角先锋",
    "resoundEventStoryName_79": "圣光受害者（1）",
    "messageInitNick_3658": "哥谭噩梦",
    "messageInitNick_3657": "驯服克苏鲁",
    "messageInitNick_3656": "东方美心静",
    "messageInitNick_3655": "智能芝麻酱",
    "resoundEventStoryName_70": "呜呜祖拉的生机",
    "messageInitNick_3659": "蒜苔魔法",
    "resoundEventStoryName_71": "呜呜祖拉的悲鸣",
    "4_2049": "因无人竞价，已被系统回收",
    "4_2047": "信息",
    "4_2048": "被部落成员拍得",
    "4_2045": "记录",
    "4_2046": "结算日期",
    "4_2043": "未出价",
    "4_2044": "竞拍",
    "4_2041": "加价",
    "mapNodeName_895": "大帝",
    "resoundEventStoryName_58": "冒险小队经验",
    "mapNodeName_896": "巨晶之地",
    "resoundEventStoryName_59": "试胆大会",
    "mapNodeName_893": "大包",
    "4_2040": "我的出价",
    "mapNodeName_894": "大招",
    "mapNodeName_891": "大喵喵",
    "mapNodeName_892": "巨藤之地",
    "mapNodeName_890": "巨藤之地",
    "resoundEventStoryName_61": "胆试会大",
    "resoundEventStoryName_62": "胆大会试",
    "resoundEventStoryName_63": "神性火丁",
    "resoundEventStoryName_64": "呜呜祖拉的消失",
    "mapNodeName_888": "电光大萝卜",
    "messageInitNick_3643": "说话请投币",
    "resoundEventStoryName_65": "呜呜祖拉的伙伴",
    "mapNodeName_889": "金矿山",
    "messageInitNick_3642": "走出饭店",
    "resoundEventStoryName_66": "呜呜祖拉的忧郁",
    "mapNodeName_886": "大老虎",
    "messageInitNick_3641": "寄了吗",
    "resoundEventStoryName_67": "呜呜祖拉的困惑",
    "mapNodeName_887": "巨炎之地",
    "messageInitNick_3640": "诺贝尔卖惨奖",
    "resoundEventStoryName_68": "饲星",
    "messageInitNick_3647": "辣椒魔法师",
    "messageInitNick_3646": "此女人已绝版",
    "messageInitNick_3645": "会动的艺术",
    "messageInitNick_3644": "灵魂流浪者",
    "messageInitNick_3649": "不帅你报警",
    "messageInitNick_3648": "临期食品",
    "resoundEventStoryName_60": "试大胆会",
    "4_2058": "全服剩余 {1}",
    "4_2059": "个人可兑换 {1}",
    "4_2056": "暂无拍卖品",
    "4_2057": "前往节点才可兑换",
    "4_2054": "该奖励需到部落拍卖所竞拍获得",
    "4_2055": "出价人数",
    "4_2052": "奖励列表",
    "resoundEventStoryName_47": "地上被踩断的枯枝",
    "4_2053": "拍卖奖励",
    "resoundEventStoryName_48": "金矿山之谜（1）",
    "4_2050": "道具名称",
    "resoundEventStoryName_49": "金矿山之谜（2）",
    "4_2051": "领取",
    "resoundEventStoryName_50": "金矿山之谜（3）",
    "resoundEventStoryName_51": "金矿山之谜（4）",
    "resoundEventStoryName_52": "秘密洞穴",
    "resoundEventStoryName_53": "冒险小队集结",
    "messageInitNick_3632": "和空气斗智",
    "resoundEventStoryName_54": "冒险小队行动",
    "messageInitNick_3631": "俺们都是村草",
    "resoundEventStoryName_55": "冒险小队停住",
    "messageInitNick_3630": "快去开空调啊",
    "resoundEventStoryName_56": "冒险小队初探",
    "resoundEventStoryName_57": "冒险小队庆祝",
    "messageInitNick_3636": "作业虐我千遍",
    "messageInitNick_3635": "败家小猫",
    "messageInitNick_3634": "当场退役",
    "messageInitNick_3633": "音乐很舒适",
    "messageInitNick_3639": "灯灯哥",
    "messageInitNick_3638": "全息冰雹",
    "messageInitNick_3637": "刚睡着的蜗牛",
    "4_2069": "钻石",
    "4_2067": "获得：",
    "4_2068": "{1}{2}",
    "4_2065": "兑换比例",
    "4_2066": "1:1",
    "4_2063": "♥",
    "resoundEventStoryName_36": "危险的草丛",
    "4_2064": "充值",
    "resoundEventStoryName_37": "密丛禾草",
    "4_2061": "效果总览",
    "resoundEventStoryName_38": "飘摇草",
    "4_2062": "点击获取地点，立即移动",
    "resoundEventStoryName_39": "进化之泥",
    "4_2060": "已售罄",
    "resoundEventStoryName_40": "非自然流星雨（1）",
    "resoundEventStoryName_41": "非自然流星雨（2）",
    "resoundEventStoryName_42": "再次对决（1）",
    "messageInitNick_3621": "超级糖果",
    "resoundEventStoryName_43": "再次对决（2）",
    "messageInitNick_3620": "会跑的斑马线",
    "resoundEventStoryName_44": "再次对决（3）",
    "resoundEventStoryName_45": "再次对决（4）",
    "resoundEventStoryName_46": "再次对决（5）",
    "messageInitNick_3625": "心理学导师",
    "messageInitNick_3624": "长颈鹿大哥",
    "messageInitNick_3623": "寒江天外",
    "messageInitNick_3622": "萝卜魔法",
    "messageInitNick_3629": "孤身战群魔",
    "messageInitNick_3628": "太阳能水杯",
    "messageInitNick_3627": "国民傲娇女",
    "messageInitNick_3626": "网盘再见",
    "messageInitNick_3619": "电子蛋糕",
    "4_2078": "购买",
    "4_2079": "每日限购（{1}/{2}）",
    "4_2076": "探索者等级小于{1}时生效",
    "4_2077": "剩余时间 {1}",
    "4_2074": "使用数量",
    "resoundEventStoryName_25": "财富之路（5）",
    "4_2075": "神行中",
    "resoundEventStoryName_26": "财富之路（6）",
    "4_2072": "主要获得途径",
    "resoundEventStoryName_27": "财富密码（1）",
    "4_2073": "剩余",
    "resoundEventStoryName_28": "财富密码（2）",
    "4_2070": "彩钻",
    "resoundEventStoryName_29": "财富密码（3）",
    "4_2071": "{1}元",
    "resoundEventStoryName_30": "离离狗尾草",
    "resoundEventStoryName_31": "火神烧不尽",
    "messageInitNick_3610": "寒窗十一载",
    "resoundEventStoryName_32": "平凡的草（1）",
    "resoundEventStoryName_33": "平凡的草（2）",
    "resoundEventStoryName_34": "平凡的草（3）",
    "resoundEventStoryName_35": "平凡的草（4）",
    "messageInitNick_3614": "拉肠猎手",
    "messageInitNick_3613": "梨爱好者",
    "messageInitNick_3612": "伐木工",
    "messageInitNick_3611": "八度猫",
    "messageInitNick_3618": "放码过来",
    "messageInitNick_3617": "黑暗领主",
    "messageInitNick_3616": "奶茶没有吸管",
    "messageInitNick_3615": "杏子兽",
    "messageInitNick_3609": "实用心理学",
    "messageInitNick_3608": "苍狼不拜月",
    "4_2089": "宝藏",
    "4_2087": "进化之实",
    "4_2088": "规则",
    "4_2085": "月曜赠礼",
    "resoundEventStoryName_14": "小朋友你是不是有很多问号",
    "4_2086": "每日一弹",
    "resoundEventStoryName_15": "生存之路",
    "4_2083": "限购福利",
    "resoundEventStoryName_16": "老兽皮",
    "4_2084": "蜕变契约",
    "resoundEventStoryName_17": "老树皮",
    "4_2081": "彩钻购买",
    "resoundEventStoryName_18": "老皮匠",
    "4_2082": "钻石兑换",
    "resoundEventStoryName_19": "烤羊腿",
    "4_2080": "使用",
    "resoundEventStoryName_20": "黑潮",
    "resoundEventStoryName_21": "财富之路（1）",
    "resoundEventStoryName_22": "财富之路（2）",
    "resoundEventStoryName_23": "财富之路（3）",
    "resoundEventStoryName_24": "财富之路（4）",
    "messageInitNick_3603": "猫耳侦探",
    "messageInitNick_3602": "懒门首席",
    "messageInitNick_3601": "智能蒜泥",
    "messageInitNick_3600": "追水鱼的人",
    "messageInitNick_3607": "自动猫形",
    "messageInitNick_3606": "夹心糖有点皮",
    "messageInitNick_3605": "自闭羽毛球",
    "messageInitNick_3604": "黑色指针",
    "4_2098": "每日福利",
    "messageInitContent_1269": "谢谢科普读音",
    "4_2099": "本周买光次数",
    "messageInitContent_1268": "xun！",
    "4_2096": "超值",
    "4_2097": "特惠",
    "4_2094": "首充双倍",
    "4_2095": "首次赠送",
    "4_2092": "荐",
    "4_2093": "售罄",
    "4_2090": "周",
    "4_2091": "月",
    "mapNodeName_815": "金矿山",
    "messageInitContent_1270": "狸猫君，你怎么被挡住了",
    "mapNodeName_816": "巨藤之地",
    "mapNodeName_813": "巨蚀之地",
    "mapNodeName_814": "巨龙腾飞",
    "mapNodeName_811": "危险的巨眼",
    "mapNodeName_812": "巨蚀之地",
    "mapNodeName_810": "巨巽",
    "messageInitContent_1278": "玖璃姐姐会狠狠地把你们打跑的！",
    "messageInitContent_1277": "那我想摸摸耳朵！",
    "messageInitContent_1276": "前面什么变态发言",
    "messageInitContent_1275": "我赢了可以摸摸你的尾巴吗？",
    "mapNodeName_819": "大溜溜",
    "messageInitContent_1274": "3点几啦！做乜做，饮茶了",
    "messageInitContent_1273": "就看着很悠闲晒着午后的阳光",
    "mapNodeName_817": "巨藤之地",
    "messageInitContent_1272": "我很喜欢睡觉，一种入土为安的平替",
    "mapNodeName_818": "巨藤之地",
    "messageInitContent_1271": "我也想像狸猫君那样安详地躺着。",
    "messageInitContent_1279": "我只是被吸引来的饿货",
    "mapNodeName_830": "大吸盘",
    "mapNodeName_826": "大号键侠",
    "messageInitContent_1281": "看饿了，给点面子我打重装好吗",
    "mapNodeName_827": "大条地龙",
    "messageInitContent_1280": "饿了",
    "mapNodeName_824": "肉肉山",
    "mapNodeName_825": "巨骸之地",
    "messageInitContent_800": "你看她笑的多开心",
    "mapNodeName_822": "巨骸之地",
    "messageInitContent_801": "她笑得好吓人",
    "mapNodeName_823": "大珍宝",
    "messageInitContent_802": "合一的车轮好像nt的标记",
    "mapNodeName_820": "赤色飓风",
    "messageInitContent_803": "敢不敢不封我技能",
    "mapNodeName_821": "大火主宰",
    "messageInitContent_804": "珍宝它真的很敬业我哭死",
    "messageInitContent_1289": "幻是最强的，不接受反驳",
    "messageInitContent_1288": "你看美杜莎莎看的多开心！",
    "messageInitContent_1287": "那是队友辛辛苦苦给我加上的buff放过它们吧",
    "messageInitContent_1286": "零式进化学坏了，现在是只怪就想来清我的buff",
    "messageInitContent_1285": "终式是什么奇怪的公式吗",
    "messageInitContent_1284": "所以这里是深渊吗！",
    "mapNodeName_828": "重锤出击",
    "messageInitContent_1283": "血渊这进化好帅！",
    "mapNodeName_829": "巨藤之地",
    "messageInitContent_1282": "又一个在坑里的关卡。",
    "messageInitContent_805": "为了把我们推到一起一起踩遍它们好努力",
    "messageInitContent_806": "让我把你们都推开",
    "messageInitContent_807": "推推推推推",
    "messageInitContent_808": "红唇能不能努力点让同伴都去极乐，那我就不用打了",
    "messageInitContent_809": "新型独角兽？？？",
    "messageInitContent_1292": "独角兽，人间大炮！",
    "messageInitContent_1291": "你们不懂吗，这些队友就是加强了",
    "messageInitContent_1290": "让我看看幻幻加强了没有先",
    "messageInitContent_810": "行行好给孩子好好地把头安好吧",
    "messageInitContent_811": "它们终于满编了！",
    "messageInitContent_812": "我有个问题想问问莎士比亚",
    "messageInitContent_813": "这里的是哔亚",
    "messageInitContent_814": "哔————————————",
    "messageInitContent_815": "哇好可怕，独角兽已经够恶心了",
    "messageInitContent_1299": "金色毁灭传说",
    "messageInitContent_1298": "毁灭你，与你何干",
    "messageInitContent_1297": "毁灭吧，赶紧的，累了",
    "messageInitContent_1296": "毁灭吧",
    "messageInitContent_1295": "《超·幻》",
    "messageInitContent_1294": "love&peace",
    "messageInitContent_1293": "独角兽你的好朋友穿角兽呢？",
    "messageInitContent_816": "人间大炮和崩界领主站在了一起！",
    "messageInitContent_817": "是的300+500",
    "messageInitContent_818": "800呢",
    "messageInitContent_819": "能不能让后面的墙给我开个后门",
    "mapNodeName_804": "巨晶之地",
    "mapNodeName_805": "大坨圣光",
    "messageInitContent_820": "墙：客人这里没门",
    "mapNodeName_802": "巨藤之地",
    "messageInitContent_821": "墙：不要墙墙所难",
    "mapNodeName_803": "巨藤之地",
    "messageInitContent_822": "墙：加油",
    "mapNodeName_800": "巨霜之地",
    "messageInitContent_823": "觉醒逆焰龙王！！！",
    "mapNodeName_801": "巨霜之地",
    "messageInitContent_824": "居然不是皮肤，是真正的觉醒！",
    "messageInitContent_825": "进化了肚子还是这么大呢",
    "messageInitContent_826": "进化出颜色了",
    "mapNodeName_808": "巨蚀之地",
    "mapNodeName_809": "巨震",
    "mapNodeName_806": "异能展开",
    "mapNodeName_807": "巨晶之地",
    "mapNodeName_862": "巨藤之地",
    "messageInitContent_827": "它的肚子好像要把我吃掉的样子",
    "mapNodeName_863": "巨晶之地",
    "messageInitContent_828": "龙帝的肚子也长出了嘴巴了吗",
    "mapNodeName_860": "极巨沸体",
    "messageInitContent_829": "就是其他不朽怪也会有进化了！！！",
    "mapNodeName_861": "极巨守护",
    "96_competeRank": "斗技场排行榜",
    "mapNodeName_859": "巨藤之地",
    "messageInitContent_830": "惊！",
    "messageInitContent_831": "盖鬼，赵鬼、蛮鬼",
    "mapNodeName_857": "巨藤之地",
    "messageInitContent_832": "熵鬼她长出白头发了",
    "mapNodeName_858": "巨藤之地",
    "messageInitContent_833": "她变得更硬了",
    "mapNodeName_855": "巨炎之地",
    "messageInitContent_834": "变得更吓人了",
    "mapNodeName_856": "大大的微笑",
    "messageInitContent_835": "妈妈我好怕",
    "mapNodeName_853": "巨炎之地",
    "messageInitContent_836": "能不能让锤子来教她们笑容管理。",
    "mapNodeName_854": "巨炎之地",
    "messageInitContent_837": "哇这什么好吓人",
    "mapNodeName_873": "巨尸鬼",
    "messageInitContent_838": "要被打坏掉了",
    "mapNodeName_874": "巨骸之地",
    "messageInitContent_839": "崩 坏 状 态",
    "mapNodeName_871": "巨大杀伤力",
    "mapNodeName_872": "古记战役-森系草林",
    "mapNodeName_870": "巨骸之地",
    "messageInitContent_841": "还好墙神不在",
    "messageInitContent_842": "墙神是谁啊？",
    "mapNodeName_868": "海上假期",
    "messageInitContent_843": "海贼王卡牌？",
    "mapNodeName_869": "巨骸之地",
    "messageInitContent_844": "它我哭死，又警告我了",
    "mapNodeName_866": "给你牵",
    "messageInitContent_845": "快跑！",
    "mapNodeName_867": "巨骸之地",
    "messageInitContent_846": "它应该警告的难度不是那只穿角兽",
    "mapNodeName_864": "入魂结界",
    "messageInitContent_847": "所以穿角兽的角是穿上去的吗",
    "mapNodeName_865": "狂热",
    "messageInitContent_848": "为什么不叫穿甲兽",
    "messageInitContent_840": "请大力打我！",
    "mapNodeName_840": "巨藤之地",
    "messageInitContent_849": "可能是不想和穿山甲撞名字",
    "mapNodeName_841": "大号钢龙",
    "mapNodeName_837": "小镇",
    "messageInitContent_852": "神话怪物！",
    "resoundEventStyleName_2": "重生",
    "mapNodeName_838": "留一手",
    "messageInitContent_853": "神话10阶！",
    "resoundEventStyleName_1": "一封匿名信",
    "mapNodeName_835": "巨晶之地",
    "messageInitContent_854": "它们在说什么啊？",
    "resoundEventStyleName_4": "仅供参考",
    "mapNodeName_836": "大猫猫",
    "messageInitContent_855": "挺身而出！匪夷所思！",
    "resoundEventStyleName_3": "诈和赌",
    "mapNodeName_833": "巨头",
    "messageInitContent_856": "神话不死身！",
    "resoundEventStyleName_6": "你的武器",
    "mapNodeName_834": "巨晶之地",
    "messageInitContent_857": "神话火球术！",
    "resoundEventStyleName_5": "有个朋友",
    "mapNodeName_831": "巨晶之地",
    "messageInitContent_858": "神tm投降",
    "resoundEventStyleName_8": "“成分”",
    "mapNodeName_832": "大礼",
    "messageInitContent_859": "为了不让头自己跑掉，它尽力了",
    "resoundEventStyleName_7": "骨木鳞100万",
    "resoundEventStyleName_9": "顶点",
    "mapNodeName_839": "巨蚀之地",
    "messageInitContent_850": "快跑，（举牌.jpg",
    "messageInitContent_851": "神话生物！",
    "mapNodeName_851": "大号变异",
    "mapNodeName_852": "超级高兴",
    "mapNodeName_850": "巨骸之地",
    "mapNodeName_848": "巨晶之地",
    "messageInitContent_863": "在你大喊变身的时候，你就已经是无敌的了",
    "mapNodeName_849": "不是幻觉",
    "messageInitContent_864": "指勇气对吧",
    "mapNodeName_846": "大哥",
    "messageInitContent_865": "这里的怪兽密度是不是有点高",
    "mapNodeName_847": "巨刃",
    "messageInitContent_866": "怎么突然生态平衡了",
    "mapNodeName_844": "超大火",
    "messageInitContent_867": "这可是怪兽！",
    "mapNodeName_845": "诡潮之门",
    "messageInitContent_868": "怪兽就不能生态平衡了？",
    "mapNodeName_842": "巨钢",
    "messageInitContent_869": "其他怪兽都应该向崩界领主学习锻炼下肌肉",
    "mapNodeName_843": "巨藤之地",
    "messageInitContent_860": "为什么这么重要的身体部位都要逃跑，发生了什么",
    "messageInitContent_861": "到底发生了什么？",
    "messageInitContent_862": "只要接受自己的软弱，我就是无敌的",
    "messageInitContent_1308": "我要吃幻幻",
    "messageInitContent_1307": "我的怪兽也要加油进化了",
    "messageInitContent_1306": "双觉醒来了！",
    "messageInitContent_1305": "祖拉可能只是来给幻伴奏的。",
    "messageInitContent_1304": "青铜五小强还得看呜呜祖拉。",
    "messageInitContent_1303": "看还是呜呜祖拉！",
    "messageInitContent_1302": "倦了累了，喝超进化特饮！",
    "messageInitContent_1301": "毁灭吧，倦了",
    "messageInitContent_3963": "小打小闹",
    "messageInitContent_3964": "4个技能看完",
    "messageInitContent_3965": "龙年！",
    "messageInitContent_3966": "除夕快乐呀",
    "messageInitContent_3967": "左边右边总有一个是对的",
    "messageInitContent_3968": "终于等到你了",
    "messageInitContent_3969": "专心等过年",
    "messageInitContent_1309": "应该拉上尸狂，整个合作。",
    "messageInitContent_874": "明明长得那么可爱",
    "messageInitContent_875": "好像虎皮将还长出耳朵了！",
    "messageInitContent_876": "那个可能是耳朵头库",
    "messageInitContent_877": "豹子的武器也不同了！",
    "messageInitContent_3970": "飘过",
    "messageInitContent_878": "你是来玩大家来找茬的吗",
    "messageInitContent_3971": "马上开个小号试试",
    "messageInitContent_879": "我的魅装，你怎么跑这里了",
    "messageInitContent_3972": "原来准备龙年了",
    "messageInitContent_3973": "我左看右看",
    "messageInitContent_1311": "远古的三幻神哟，请快到我身边！",
    "messageInitContent_1310": "白昼小姐姐，你是不是站错方向了！",
    "messageInitContent_870": "木偶？？肌肉认真的吗",
    "messageInitContent_871": "认真的！",
    "messageInitContent_872": "它们终究还是来了",
    "messageInitContent_873": "它们终究还是来恶心我了！",
    "messageInitContent_1319": "我是超人!怪兽们怕不怕",
    "messageInitContent_1318": "我是一拳潮人！",
    "messageInitContent_1317": "我不是一拳超人，我只是光头披风侠！",
    "messageInitContent_1316": "其实是黑丝还是她的皮肤？？？",
    "messageInitContent_1315": "是白昼的守护！",
    "messageInitContent_1314": "多么令人羡慕",
    "messageInitContent_1313": "是百分比扣血！",
    "messageInitContent_1312": "白昼也是美丽的龙哦",
    "messageInitContent_3974": "重金求答案",
    "messageInitContent_3975": "兄弟!我来了",
    "messageInitContent_3976": "兄弟兄弟！",
    "messageInitContent_3977": "各位朋友，下年再见",
    "messageInitContent_3978": "今年最后一天玩超进化了，勿挂念",
    "messageInitContent_3979": "让我看看今天谁要上班，哦，是我",
    "messageInitContent_885": "它们是在保谁呢，4保0？",
    "messageInitContent_886": "？",
    "messageInitContent_887": "好怪哦",
    "messageInitContent_3980": "点我暴富",
    "messageInitContent_888": "5个技能的破面！",
    "messageInitContent_3981": "选哪个呢",
    "messageInitContent_889": "我是死神，我听说这里有破面？",
    "messageInitContent_3982": "小龙龙哪里跑",
    "messageInitContent_3983": "早睡小助手提醒你早点睡",
    "messageInitContent_3984": "今晚梦中跨年",
    "messageInitContent_1322": "天哪，大师，我悟了",
    "messageInitContent_1321": "5000码又是多少",
    "messageInitContent_1320": "就不能打断他蓄力的吗",
    "messageInitContent_880": "小魅妆一定是迷路了！！",
    "messageInitContent_881": "快来很少我的安全感！",
    "messageInitContent_882": "魅妆——）发出鸡叫（",
    "messageInitContent_883": "没见过女怪兽吗",
    "messageInitContent_884": "还真没有",
    "plateName_7": "至高压制",
    "messageInitContent_1329": "眼红红",
    "plateName_6": "大势化小",
    "messageInitContent_1328": "都叫你别打这么久游戏的啦",
    "plateName_9": "战墙蚕控",
    "messageInitContent_1327": "炼狱魔眼，我找到你了！",
    "plateName_8": "根性",
    "messageInitContent_1326": "这家伙为什么能这么大",
    "messageInitContent_1325": "麻麻，这眼球好吓人！",
    "messageInitContent_1324": "又一座主城到手，木头城",
    "messageInitContent_1323": "可以上了吗？大师",
    "messageInitContent_3985": "我先放假了",
    "messageInitContent_3986": "我在公司很想家",
    "messageInitContent_3987": "还是龙族内战？",
    "plateName_1": "生机之泉",
    "messageInitContent_3988": "春节快乐！",
    "messageInitContent_3989": "新年快乐",
    "plateName_3": "安魂曲",
    "plateName_2": "一时不治",
    "plateName_5": "震慑",
    "plateName_4": "降频",
    "messageInitContent_896": "老鳄~",
    "messageInitContent_897": "这一起打过来就不是帅不帅的问题",
    "messageInitContent_3990": "新年好呀",
    "messageInitContent_898": "是疼不疼的问题",
    "messageInitContent_3991": "好云来",
    "messageInitContent_899": "疼",
    "messageInitContent_3992": "龙马精神",
    "messageInitContent_3993": "龙腾虎跃",
    "messageInitContent_3994": "点我领红包",
    "messageInitContent_3995": "身体健康，万事如意！",
    "messageInitContent_1333": "它真不是从那只打怪兽身上逃出来的吗？",
    "messageInitContent_1332": "大眼瞪小眼",
    "messageInitContent_1331": "我会写轮眼，你呢？",
    "messageInitContent_890": "加22",
    "messageInitContent_1330": "想知道魔眼玩的什么游戏",
    "messageInitContent_891": "让你们看看我的正义",
    "messageInitContent_892": "就是要打败你们！",
    "messageInitContent_893": "什么破面3连",
    "messageInitContent_894": "在三消游戏，你们这样是要消失的",
    "messageInitContent_895": "光龙好帅！",
    "messageInitContent_1339": "欧我的电流麦",
    "messageInitContent_1338": "你指尖跳动的电光，是我永恒不变的信仰",
    "messageInitContent_1337": "哔哩哔哩哔哩哔哩哔哩哔哩哔哩哔哩哔哩哔哩",
    "messageInitContent_1336": "看清楚那不是螃蟹！",
    "messageInitContent_1335": "蓝色大螃蟹，包租公家的伙食就是不一样。",
    "messageInitContent_1334": "看来哪里都有包租公的地",
    "messageInitContent_3996": "新年行大运",
    "messageInitContent_3997": "看了半天答案呢",
    "messageInitContent_3998": "答案快到红包里来",
    "messageInitContent_3999": "蒙的都全对！",
    "messageInitContent_1344": "弱小，无助，又害怕！",
    "messageInitContent_1343": "逃走，逃走那是什么？",
    "messageInitContent_1342": "危，永腐魔和它的爪牙来了！",
    "18_comment": "谜之巢穴, 暴走旷野",
    "messageInitContent_1341": "一动不动",
    "messageInitContent_1340": "还好没和螺旋巽在一起哈哈哈",
    "messageInitContent_1349": "现在好像不叫新生了",
    "messageInitContent_1348": "这片区域好多新生",
    "messageInitContent_1347": "那就唱歌吧",
    "messageInitContent_1346": "为什么我的脚动不了！",
    "messageInitContent_1345": "你们应该再害怕点了。",
    "messageInitNick_10116": "美丽的迷宫主",
    "messageInitNick_10117": "刀恋孤光",
    "messageInitNick_10114": "天天晒太阳",
    "messageInitNick_10115": "未曾设想的路",
    "messageInitNick_10118": "不倾国的女子",
    "messageInitNick_10119": "极窄宽带",
    "messageInitNick_10112": "提嫖",
    "messageInitNick_10113": "摸鱼先锋",
    "messageInitNick_10110": "超级肉丸",
    "messageInitNick_10111": "记得要微笑",
    "messageInitContent_1355": "它们终于同台了，我哭死",
    "messageInitContent_1354": "真的吗你们不要骗我！",
    "messageInitContent_1353": "魅妆只是来听尸狂演唱会的呢",
    "messageInitContent_1352": "是呀是呀一点事没有",
    "messageInitContent_1351": "魅妆只是帮尸狂伴舞的呢",
    "messageInitContent_1350": "魅妆小姐姐那边危险，快过来！",
    "messageInitContent_1359": "幻幻你就是我们最美的等待！",
    "messageInitContent_1358": "幻幻幻幻天下无双！by幻幻后援会",
    "messageInitContent_1357": "尸狂尸狂你醉狂我们爱你！by尸狂后援会",
    "messageInitContent_1356": "你们都给我哭",
    "messageInitNick_10127": "高瞻远主妇",
    "messageInitNick_10128": "理工小霸王",
    "messageInitNick_10125": "过期的灵药",
    "messageInitNick_10126": "千影妖魂",
    "messageInitNick_10129": "巧克力爱情",
    "mapNodeName_903": "巨晶之地",
    "mapNodeName_904": "赤红躲猫猫",
    "messageInitNick_10120": "繁华独角戏",
    "mapNodeName_901": "巨仁",
    "mapNodeName_902": "大炸弹",
    "messageInitNick_10123": "醉人眸",
    "mapNodeName_900": "肉肉山",
    "messageInitNick_10124": "放学别走",
    "messageInitNick_10121": "酿辣椒",
    "messageInitNick_10122": "无公害萝卜",
    "messageInitContent_1366": "爆炸就是艺术！",
    "messageInitContent_1365": "哭哭",
    "mapNodeName_909": "花丸子之墙",
    "messageInitContent_1364": "真好哭",
    "messageInitContent_1363": "变成了你的形状了呜呜",
    "mapNodeName_907": "如沸星穹",
    "messageInitContent_1362": "这回事盒子和梵了吗？",
    "mapNodeName_908": "巨晶之地",
    "messageInitContent_1361": "看样子是了",
    "mapNodeName_905": "顶尖雷池",
    "messageInitContent_1360": "那几条龙是舞台特效的吗",
    "mapNodeName_906": "沼地主宰",
    "tribeSeasonName_202510": "月圆赛季",
    "messageInitContent_1369": "三新生了！！",
    "messageInitContent_1368": "摸你的是炸弹！",
    "propConfigName_60000": "起源盘",
    "tribeSeasonName_202511": "拾秋赛季",
    "messageInitContent_1367": "女王大人可以不可以别摸我！",
    "tribeSeasonName_202512": "燃云赛季",
    "messageInitContent_1377": "吃我火拳！",
    "messageInitContent_1376": "合一：怎么只有我没有颜色了",
    "messageInitContent_1375": "地龙也叫蚯蚓",
    "messageInitContent_1374": "比苟还得是你啊地龙",
    "messageInitContent_1373": "注意地龙会苟",
    "messageInitContent_1372": "吃草挤奶！",
    "messageInitContent_1371": "拿弓箭的能偷死掉怪兽的攻击力！",
    "messageInitContent_1370": "我的影曜！！",
    "tribeSeasonName_202502": "祈愿赛季",
    "tribeSeasonName_202503": "幻乐赛季",
    "messageInitContent_1379": "令人怀念的大罩子",
    "messageInitContent_1378": "还是帅啊火神",
    "tribeSeasonName_202501": "深渊赛季",
    "messageInitNick_10105": "拷贝软妹",
    "tribeSeasonName_202506": "竞渡赛季",
    "messageInitNick_10106": "电子醋",
    "tribeSeasonName_202507": "蛮荒赛季",
    "messageInitNick_10103": "鹿痴迷鹿了",
    "tribeSeasonName_202504": "悬蒲赛季",
    "messageInitNick_10104": "开摆",
    "tribeSeasonName_202505": "起龙赛季",
    "messageInitNick_10109": "迷路的粉底液",
    "messageInitNick_10107": "属性大爆发",
    "tribeSeasonName_202508": "暮夏赛季",
    "messageInitNick_10108": "雨静静下",
    "tribeSeasonName_202509": "月华赛季",
    "messageInitContent_1380": "还差点就是国家队了",
    "messageInitNick_10101": "看爱情在演戏",
    "messageInitNick_10102": "超时空电饭煲",
    "messageInitNick_10100": "困惑的镜子",
    "messageInitContent_1388": "不朽的进化！",
    "messageInitContent_1387": "怎么我的近战怪变小了",
    "messageInitContent_1386": "它进化了学会降我攻速了",
    "messageInitContent_1385": "震撼脑髓！！！",
    "messageInitContent_1384": "小珍宝，金矿面前，你也不能挡我",
    "messageInitContent_1383": "看我发现了什么，金矿我来了！",
    "messageInitContent_1382": "有准备到下一片大陆噜",
    "messageInitContent_1381": "这可差的有点远呢",
    "messageInitNick_10158": "跟上大队",
    "messageInitNick_10159": "榴莲真好吃",
    "messageInitNick_10152": "别搞",
    "messageInitNick_10153": "听曲客",
    "messageInitNick_10150": "你干嘛凶宝宝",
    "messageInitNick_10151": "红色列车之心",
    "messageInitNick_10156": "两年前",
    "resoundEventStoryName_10": "恶魔老大",
    "messageInitNick_10157": "看攻略玩家",
    "resoundEventStoryName_11": "皮酱的逃离",
    "messageInitNick_10154": "我在那里想你",
    "resoundEventStoryName_12": "转型之路",
    "messageInitNick_10155": "乌鸦坐飞机",
    "resoundEventStoryName_13": "生财之路",
    "iapBuyConfigName_1405": "回归赠礼IV",
    "iapBuyConfigName_1406": "回归赠礼V",
    "iapBuyConfigName_1403": "回归赠礼II",
    "iapBuyConfigName_1404": "回归赠礼III",
    "iapBuyConfigName_1401": "回归赠礼",
    "iapBuyConfigName_1402": "回归赠礼I",
    "messageInitNick_10169": "树莓之心",
    "messageInitNick_10163": "煎饼飞侠",
    "messageInitNick_10164": "高强度对象",
    "messageInitNick_10161": "原来我是奶茶",
    "messageInitNick_10162": "这卡好假啊",
    "messageInitNick_10167": "味对了",
    "messageInitNick_10168": "飞奔的床",
    "messageInitNick_10165": "笨蛋是糖果",
    "messageInitNick_10166": "鸭鸭没有假期",
    "messageInitNick_10160": "甩锅小能手",
    "messageInitContent_3905": "正名之战",
    "messageInitContent_3906": "赤色狮小弟正在打call",
    "messageInitContent_3907": "赤色对决",
    "messageInitContent_3908": "火神正在打call",
    "messageInitContent_3909": "神灵不一样",
    "messageInitNick_10138": "上去就是一拳",
    "messageInitNick_10139": "大坏蛋",
    "messageInitNick_10136": "无公害香蕉",
    "messageInitContent_3900": "点我查看进击的巨龙 最终话",
    "messageInitNick_10137": "鸟那个鸟",
    "messageInitContent_3901": "为白昼献出我的心脏",
    "messageInitContent_3902": "水神在此",
    "messageInitContent_3903": "嘿嘿嘿嘿嘿嘿嘿嘿嘿嘿嘿嘿嘿嘿嘿嘿嘿嘿",
    "messageInitContent_3904": "证明之战",
    "messageInitNick_10130": "巧克力麦克风",
    "messageInitNick_10131": "难逢你知心",
    "messageInitNick_10134": "看海的人",
    "messageInitNick_10135": "行走的花生酱",
    "messageInitNick_10132": "寂寞式滑屏",
    "messageInitNick_10133": "躺上列表第一",
    "messageInitContent_3916": "solo诶",
    "messageInitContent_3917": "小红帽这个故事告诉我们不可听信陌生叔叔的答案",
    "messageInitContent_3918": "左",
    "messageInitContent_3919": "右右右右右",
    "messageInitNick_10149": "笑忘书",
    "messageInitContent_3910": "好狮好狮",
    "messageInitNick_10147": "李子射手",
    "messageInitContent_3911": "根据那个故事，我觉得",
    "messageInitNick_10148": "香瓜先锋",
    "messageInitContent_3912": "私信我告诉你的谁赢",
    "messageInitContent_3913": "大灰狼呢",
    "messageInitContent_3914": "狮子还是小猫咪",
    "messageInitContent_3915": "让我先看看技能",
    "messageInitNick_10141": "这是一场失恋",
    "messageInitNick_10142": "最迷人的危险",
    "messageInitNick_10140": "手机痛击鼻梁",
    "messageInitNick_10145": "长岛冰茶",
    "messageInitNick_10146": "坏孩子有梦想",
    "messageInitNick_10143": "古惑少年",
    "messageInitNick_10144": "清新的洗面奶",
    "messageInitContent_3927": "虹孩儿！",
    "messageInitContent_3928": "呆住",
    "battlePassTaskDes_2": "挑战关卡{1}次",
    "messageInitContent_3929": "勇敢狮子不怕困难",
    "battlePassTaskDes_1": "星律收获{1}次",
    "battlePassTaskDes_8": "暴走旷野战斗{1}次",
    "battlePassTaskDes_7": "起源殿战斗{1}次",
    "messageInitContent_3920": "红色！",
    "messageInitContent_3921": "昨天是哥哥今天是妹妹了哈",
    "battlePassTaskDes_9": "挑战猎物{1}次",
    "messageInitContent_3922": "怪少了，但不影响我猜不出来",
    "battlePassTaskDes_4": "部落支配核心捐献{1}次",
    "messageInitContent_3923": "首先静下心来，然后想象我是策划",
    "battlePassTaskDes_3": "消耗部落战令{1}次",
    "messageInitContent_3924": "不要因为赤虹可爱就欺负她！",
    "battlePassTaskDes_6": "挑战世界灾厄{1}次",
    "messageInitContent_3925": "谁欺负谁还不一定",
    "battlePassTaskDes_5": "商店购买物品{1}次",
    "messageInitContent_3926": "熊孩子",
    "messageInitNick_10196": "断桥红颜醉",
    "messageInitNick_3595": "蒜苔真好吃",
    "messageInitNick_10197": "画廊魔法师",
    "messageInitNick_3594": "狗刨式恋爱",
    "messageInitNick_10194": "风之主",
    "messageInitNick_3593": "垫巨人",
    "messageInitNick_10195": "离别的倒计时",
    "messageInitNick_3592": "编织感性",
    "messageInitNick_3599": "接头大师",
    "messageInitNick_3598": "引力之梦",
    "messageInitNick_10198": "暮光倾城",
    "messageInitNick_3597": "樱桃的害羞",
    "messageInitNick_10199": "喋血影魔",
    "messageInitNick_3596": "限量版拉肠",
    "messageInitNick_10192": "过两天再见",
    "messageInitNick_10193": "记忆转圈圈",
    "messageInitNick_10190": "奉旨跑掉",
    "messageInitNick_10191": "空大女神",
    "messageInitContent_3938": "怪越大怪越小",
    "messageInitContent_3939": "秒选赤虹",
    "messageInitContent_3930": "结合这个神灵emm",
    "messageInitContent_3931": "不许欺负小妹妹",
    "messageInitContent_3932": "快让我上去保护赤虹妹妹",
    "messageInitContent_3933": "她不是你妹妹也不需要你保护",
    "messageInitContent_3934": "请停下你的幻想",
    "messageInitNick_3591": "键盘积极备战",
    "messageInitContent_3935": "赤虹冲冲冲冲冲冲冲冲冲冲冲冲",
    "messageInitNick_3590": "别碰我的古怪",
    "messageInitContent_3936": "赤虹本来昨天跟火神一起来的结果迷路了",
    "messageInitContent_3937": "赤——宝——我滴赤宝",
    "messageInitNick_3584": "万能风衣",
    "messageInitNick_3583": "超拽的少爷",
    "messageInitNick_3582": "女子月月又",
    "messageInitNick_3581": "一起吃饭",
    "messageInitNick_3588": "热爱加班",
    "messageInitNick_3587": "无痛养猫",
    "messageInitNick_3586": "记得摸鱼",
    "messageInitContent_3940": "我不理解",
    "messageInitNick_3585": "你退群吧",
    "messageInitNick_3589": "倒霉的山峰",
    "messageInitContent_3949": "HUH？",
    "messageInitContent_3941": "保护动物从你我做起",
    "messageInitContent_3942": "智商loading",
    "messageInitContent_3943": "我已看穿了一切",
    "messageInitContent_3944": "谁在夸我！",
    "messageInitContent_3945": "从未关注 从未错过",
    "messageInitNick_3580": "阿伟输了",
    "messageInitContent_3946": "你真欠揍",
    "messageInitContent_3947": "你在教我做事？",
    "messageInitContent_3948": "啊？",
    "messageInitNick_10174": "潮湿的黄瓜",
    "messageInitNick_3573": "木莓的秘密",
    "messageInitNick_10175": "了不起了不起",
    "messageInitNick_3572": "请你吃蛋挞",
    "messageInitNick_10172": "辣条狂魔",
    "messageInitNick_3571": "放手套吧",
    "messageInitNick_10173": "豆角魔法师",
    "messageInitNick_3570": "步月歌",
    "messageInitNick_10178": "仁慈的荔枝",
    "messageInitNick_3577": "近视鱼",
    "messageInitNick_10179": "烤箱的故事",
    "messageInitNick_3576": "狂叼霸酷拽",
    "messageInitContent_3950": "今天不蹲答案了 睡了 晚安",
    "messageInitNick_10176": "抱紧自我",
    "messageInitNick_3575": "寂寞如影相随",
    "messageInitContent_3951": "嘤嘤嘤，伦家可可爱爱但不废网",
    "messageInitNick_10177": "扉页碎了",
    "messageInitNick_3574": "迷路的鼻骨",
    "messageInitNick_3579": "出门忘关门",
    "messageInitNick_3578": "月亮打烊了",
    "messageInitNick_10170": "玫瑰妖姬",
    "messageInitNick_10171": "半行情书",
    "4_2005": "购买数量",
    "4_2006": "购买",
    "4_2003": "已拥有",
    "4_2004": "剩余  {1}",
    "4_2001": "商店",
    "4_2002": "拍卖所",
    "messageInitContent_3952": "看到我的今天行大运",
    "messageInitContent_3953": "啾咪",
    "messageInitContent_3954": " S（狮）属性大爆发",
    "messageInitContent_3955": "重新开始！",
    "messageInitContent_3956": "新一轮竞猜",
    "messageInitContent_3957": "我先来",
    "messageInitContent_3958": "前排是大佬",
    "messageInitContent_3959": "龙族舞蹈大会？",
    "messageInitNick_10185": "请你吃拉面",
    "messageInitNick_3562": "富婆娶我",
    "messageInitNick_10186": "别动我兔子",
    "messageInitNick_3561": "秘密的三角",
    "messageInitNick_10183": "福如东海",
    "messageInitNick_3560": "不想起昵称",
    "messageInitNick_10184": "泪眼看世界",
    "messageInitNick_10189": "数据大师",
    "messageInitNick_3566": "霸气十足小伙",
    "messageInitContent_3960": "祖龙族大佬前来督战",
    "messageInitNick_3565": "变美计划",
    "messageInitContent_3961": "争取全对",
    "messageInitNick_10187": "带火龙果探险",
    "messageInitNick_3564": "碧云诗人",
    "messageInitContent_3962": "龙魂",
    "messageInitNick_10188": "喘气的夜明猪",
    "messageInitNick_3563": "还在口胡",
    "messageInitContent_1300": "毁灭与重生！",
    "messageInitNick_3569": "悍妹纸",
    "messageInitNick_3568": "泡芙怪兽",
    "messageInitNick_3567": "雪糕刺客",
    "4_2009": "单价",
    "messageInitNick_10181": "没钱但不说",
    "messageInitNick_10182": "蛋挞剑客",
    "4_2007": "MAX",
    "4_2008": "已拥有  {1}",
    "messageInitNick_10180": "不用管他",
    "mapNodeName_785": "超重",
    "mapNodeName_786": "双重大舔舔",
    "mapNodeName_783": "大圣",
    "mapNodeName_784": "罩你",
    "mapNodeName_781": "越大越孤单",
    "mapNodeName_782": "巨藤之地",
    "mapNodeName_780": "时间巨爪",
    "messageInitNick_3551": "半山老人",
    "messageInitNick_3550": "猫瞳",
    "mapNodeName_778": "枯了",
    "messageInitNick_3555": "谜语人滚出",
    "mapNodeName_779": "古记战役-以小见大",
    "messageInitNick_3554": "傲娇狗尾一支",
    "mapNodeName_776": "巨藤之地",
    "messageInitNick_3553": "烤羊肉串",
    "mapNodeName_777": "海草海草",
    "messageInitNick_3552": "五仁月饼",
    "messageInitNick_3559": "落难小王子",
    "messageInitNick_3558": "熬夜爱好者",
    "messageInitNick_3557": "本人单身",
    "messageInitNick_3556": "胆怯的猫儿",
    "mapNodeName_796": "巨ㄨ",
    "mapNodeName_797": "超巨星",
    "mapNodeName_794": "消失的它",
    "mapNodeName_795": "火大",
    "mapNodeName_792": "巨龙之潮",
    "skinType_-1": "默认",
    "mapNodeName_793": "超级巨星",
    "mapNodeName_790": "大中小",
    "mapNodeName_791": "巨骸之地",
    "messageInitNick_3540": "气氛组长",
    "mapNodeName_789": "巨藤之地",
    "messageInitNick_3544": "胡萝卜真好吃",
    "messageInitNick_3543": "橙味少女",
    "mapNodeName_787": "大兄弟",
    "messageInitNick_3542": "步行道之心",
    "mapNodeName_788": "古记战役-BigBang",
    "messageInitNick_3541": "樱桃番茄酱",
    "messageInitNick_3548": "尝试亲吻",
    "messageInitNick_3547": "开天屁帝",
    "messageInitNick_3546": "香蕉君快逃",
    "messageInitNick_3545": "努力说书中",
    "messageInitNick_3549": "烤肉串",
    "mapNodeName_763": "包租公之墙",
    "mapNodeName_764": "巨藤之地",
    "mapNodeName_761": "双马尾",
    "mapNodeName_762": "木大木大",
    "mapNodeName_760": "大爪狼和小白兔",
    "messageInitNick_10097": "贴贴贴",
    "messageInitNick_10098": "海魂",
    "mapNodeName_758": "崩坠集市",
    "messageInitNick_10095": "打脸天王",
    "mapNodeName_759": "巨藤之下",
    "messageInitNick_10096": "此用户已成仙",
    "mapNodeName_756": "巨巨联手",
    "messageInitNick_3533": "沉浸式品茶",
    "mapNodeName_757": "超大型怪兽",
    "messageInitNick_3532": "水蜜桃的欢愉",
    "mapNodeName_754": "巨人",
    "messageInitNick_10099": "玉米先锋",
    "messageInitNick_3531": "不笑也倾城",
    "mapNodeName_755": "巨晶之地",
    "messageInitNick_3530": "卷耳兔",
    "messageInitNick_3537": "非凉薄之人",
    "propConfigDes_60000": "起源盘",
    "messageInitNick_10090": "葡萄柚去哪了",
    "messageInitNick_3536": "认证引战专家",
    "messageInitNick_3535": "半夏的哀伤",
    "messageInitNick_3534": "萝卜先锋",
    "messageInitNick_10093": "洗猫前线",
    "messageInitNick_10094": "茄子战士",
    "messageInitNick_10091": "短暂的起立",
    "messageInitNick_3539": "反正别熬夜",
    "messageInitNick_10092": "抱走可爱猪",
    "messageInitNick_3538": "暗黑的妖孽",
    "mapNodeName_774": "大大滴减伤",
    "mapNodeName_775": "大烤炉",
    "mapNodeName_772": "巨创",
    "mapNodeName_773": "大份精华",
    "mapNodeName_770": "薛定谔的舌",
    "mapNodeName_771": "巨晶之地",
    "mapNodeName_769": "巨晶之地",
    "mapNodeName_767": "动地爱情",
    "messageInitNick_3522": "合成香蕉",
    "mapNodeName_768": "大神",
    "messageInitNick_3521": "我可谢谢你",
    "mapNodeName_765": "巨藤之地",
    "messageInitNick_3520": "会笑的眼睛",
    "mapNodeName_766": "巨霜之地",
    "messageInitNick_3526": "海那边是自由",
    "messageInitNick_3525": "你忍一下",
    "messageInitNick_3524": "拉肠诗人",
    "messageInitNick_3523": "麻将泰斗",
    "messageInitNick_3529": "咖啡馆的常客",
    "messageInitNick_3528": "板牙兔子",
    "messageInitNick_3527": "柚子消灭者",
    "randomEventDialogueGroupConfig_53.47": "没想到你竟能识破我的阴谋，我就是要你们两败俱伤，我渔翁得利，是我小看你了，后会有期。",
    "randomEventDialogueGroupConfig_53.48": "离开",
    "randomEventDialogueGroupConfig_53.45": "离开",
    "randomEventDialogueGroupConfig_53.46": "你刚出去便听到那个神秘黑皮怪兽的声音。",
    "randomEventDialogueGroupConfig_53.43": "你似乎还未打算要问我，你要解决的怪兽是谁？我想这活还是找别人吧。",
    "randomEventDialogueGroupConfig_53.44": "说完它向你挥出一掌，瞬间天地倒转。",
    "randomEventDialogueGroupConfig_53.41": "这只怪兽带着你穿过闹市，来到一处僻静之地。它似乎不愿暴露身份，压着声音说道。",
    "randomEventDialogueGroupConfig_53.42": "能找到我证明你有点本事，现在我要你去解决掉一只怪兽，赏金自然就是悬赏令上的数字，现在先付你三成。",
    "messageInitNick_3511": "西瓜爱切西瓜",
    "messageInitNick_3510": "汉堡网友",
    "messageInitNick_3515": "吟得一首好诗",
    "messageInitNick_3514": "雏菊的夏天",
    "messageInitNick_3513": "暴走的醋",
    "messageInitNick_3512": "会谈恋爱的猪",
    "messageInitNick_3519": "上午十点半",
    "messageInitNick_3518": "传奇人物",
    "messageInitNick_3517": "祈福蜗牛",
    "messageInitNick_3516": "洗衣盆狂怒者",
    "randomEventDialogueGroupConfig_53.36": "投",
    "randomEventDialogueGroupConfig_53.37": "你掉入了滚石陷阱之中。",
    "randomEventDialogueGroupConfig_53.34": "离开",
    "messageInitNick_3509": "像只鹌鹑",
    "randomEventDialogueGroupConfig_53.35": "你终于找到了目标并将它迅速解决。之前见过的神秘黑皮怪兽突然杀出，向你袭来。你投个闪避。",
    "randomEventDialogueGroupConfig_53.32": "下路",
    "randomEventDialogueGroupConfig_53.33": "你掉入了深坑陷阱之中。任务失败了。",
    "randomEventDialogueGroupConfig_53.30": "前面又出现了两条道。",
    "randomEventDialogueGroupConfig_53.31": "上路",
    "randomEventDialogueGroupConfig_53.38": "离开",
    "randomEventDialogueGroupConfig_53.39": "嗷，骰子在外面，那咱们下回继续。",
    "messageInitNick_3500": "电影院魔法师",
    "messageInitNick_3504": "最爱柚子",
    "messageInitNick_3503": "硬盘的冲刺",
    "randomEventDialogueGroupConfig_53.40": "离开",
    "messageInitNick_3502": "爱把痛缠绕",
    "messageInitNick_3501": "菜的抠脚",
    "messageInitNick_3508": "兔兔无敌",
    "messageInitNick_3507": "再来一碗",
    "17_comment": "部落, 驻守, 纷争",
    "messageInitNick_3506": "电子花生酱",
    "messageInitNick_3505": "你这个小东西",
    "randomEventDialogueGroupConfig_53.25": "逃离",
    "randomEventDialogueGroupConfig_53.26": "离开",
    "randomEventDialogueGroupConfig_53.23": "直接上门",
    "randomEventDialogueGroupConfig_53.24": "目标还没来得及逃，就被你解决了。它的旁边也放着一袋赏金，袋子竟和你手上的一模一样。",
    "randomEventDialogueGroupConfig_53.21": "新的悬赏令刚被你摊开，便瞬间燃起，火光中浮现出一只怪兽的身影，那就是你要解决的目标——南集市地下黑市老板的二把手。",
    "randomEventDialogueGroupConfig_53.22": "打探情报",
    "randomEventDialogueGroupConfig_53.20": "它将一张新的悬赏令塞到你手上，转身便消失在黑夜，你最后听到的是，成事后不必找我，赏金自然会到你手上。",
    "randomEventDialogueGroupConfig_53.29": "走右边",
    "randomEventDialogueGroupConfig_53.27": "不知是打探时走漏了风声还是怎样，你收集完情报，抵达它巢穴时，它已经不见踪影。只看到2条不知通往何处的隧道。",
    "randomEventDialogueGroupConfig_53.28": "走左边",
    "mapNodeName_798": "巨龙爪",
    "mapNodeName_799": "崩坠传送门I",
    "randomEventDialogueGroupConfig_53.14": "问它是谁",
    "randomEventDialogueGroupConfig_53.15": "接住袋子接下这活",
    "randomEventDialogueGroupConfig_53.12": "跟着它走",
    "randomEventDialogueGroupConfig_53.13": "说着它给你甩来了一个沉甸甸的袋子。",
    "randomEventDialogueGroupConfig_53.10": "前往该组织",
    "randomEventDialogueGroupConfig_53.11": "一个奇怪的黑皮怪兽在组织门口将你拦住，指了指你手上的悬赏令，示意你到一边谈谈。",
    "randomEventDialogueGroupConfig_53.18": "离开",
    "randomEventDialogueGroupConfig_53.19": "它突然将你叫住。",
    "randomEventDialogueGroupConfig_53.16": "带上赏金溜之大吉",
    "randomEventDialogueGroupConfig_53.17": "它突然大笑一声便消失不见了。方才它给你的袋子也不知在何时消失不见了。",
    "messageInitContent_900": "随它吧随它吧",
    "messageInitContent_901": "冰雪世界我来了",
    "messageInitContent_902": "Let it go Let it go",
    "messageInitContent_903": "我的橡果，你在这儿吗？",
    "messageInitContent_1389": "墙头见！",
    "messageInitContent_904": "想滑雪~",
    "messageInitContent_905": "怪兽不穿衣服不冷的吗看起来也没啥毛",
    "messageInitContent_906": "这只是装饰而已啦哈哈哈哈哈",
    "messageInitContent_907": "好好在造唤台干活不好，就出来乱跑，真是的",
    "messageInitContent_908": "还带了这么多手下",
    "messageInitContent_909": "她们看来不像是过二人世界",
    "messageInitContent_1391": "正是因为把铁山靠修炼完成，所以它才站在这里！",
    "messageInitContent_1390": "是锤子！",
    "messageInitContent_910": "罗密欧：大家都针对我！放过朱丽叶",
    "messageInitContent_911": "这~就~是~爱~咿~爱~~~~~~~~~~~~~~~",
    "messageInitContent_912": "大家也可以先击破朱丽叶，看看特效哦",
    "messageInitContent_913": "这就是王吗哈哈哈",
    "messageInitContent_914": "附近的都按罗马欧朱丽叶的狗腿子算！",
    "messageInitContent_1399": "这就是气质",
    "messageInitContent_1398": "一个字就是帅",
    "messageInitContent_1397": "有明星和明星伴舞的感觉了",
    "messageInitContent_1396": "我真想吧状态焊丝在身上！",
    "messageInitContent_1395": "这就是努力，这就是进步，这就是成果",
    "messageInitContent_1394": "在你面前的是210级+22的锤子！战力快要突破5000！",
    "messageInitContent_1393": "快放我去见我的矿",
    "messageInitContent_1392": "锤子：别听他们瞎说",
    "messageInitContent_915": "兄弟们上！再走几步就是金矿了",
    "messageInitContent_916": "问：怪兽世界要怎么烤火？答：抓一条喷火龙",
    "messageInitContent_917": "想溜冰~",
    "messageInitContent_918": "这种地方当然是吃雪糕啦",
    "messageInitContent_919": "好冷，赶紧过关吧",
    "mapNodeName_705": "裂眼狂潮",
    "mapNodeName_706": "念动力手臂",
    "mapNodeName_703": "混沌夜城",
    "messageInitContent_920": "怎么说的好像真的很冷似的的的的的的",
    "mapNodeName_704": "食品加工厂",
    "messageInitContent_921": "怕大家不够冷给大家讲个冷笑话……",
    "mapNodeName_701": "地下搏击俱乐部",
    "messageInitContent_922": "你倒是讲啊！",
    "mapNodeName_702": "射击俱乐部",
    "messageInitContent_923": "你们不笑是因为我没讲冷笑话吗？",
    "messageInitContent_924": "当务之急是笑！",
    "mapNodeName_700": "机械切割装置",
    "messageInitContent_925": "谁那么过分不讲冷笑话？哦是我那没事了。",
    "mapNodeName_709": "供暖设施",
    "mapNodeName_707": "毁坏拟态",
    "mapNodeName_708": "混沌夜城",
    "messageInitContent_926": "就让我在小花被里独自心碎",
    "messageInitContent_927": "不如来点，形形色色的图？",
    "messageInitContent_928": "金矿前面的怪兽总是特别多",
    "messageInitContent_929": "这就是金光闪闪的东西的魅力啊！",
    "messageInitContent_930": "那两只腐化者还真的挺像门卫的",
    "messageInitContent_931": "珍宝，你为什么又要阻止我过去，我没有让你开心过吗？",
    "messageInitContent_932": "都是老对手了，轻松过关！",
    "messageInitContent_933": "为什么我不能做金矿那留言？",
    "messageInitContent_934": "想标记金矿，好哇你",
    "messageInitContent_935": "怎么哪里都有腐化者？！",
    "messageInitContent_936": "这冰川谷被腐化者占领了？！",
    "messageInitContent_937": "难道这里它有什么主场优势吗？",
    "messageInitContent_938": "这里有草丛，它就可以方便偷袭！",
    "messageInitContent_939": "草丛这转法，不去参加花滑真是浪费了",
    "messageInitContent_940": "我旋转跳跃闭着眼",
    "messageInitContent_941": "那只兔子的毛好像刚好够做一件衣服是吧",
    "messageInitContent_942": "此处通往农场！",
    "messageInitContent_943": "是龙场！",
    "messageInitContent_944": "小孤独！！！！！",
    "messageInitContent_945": "前面跑错片场啦？",
    "messageInitContent_946": "人家都说不会吉他了",
    "messageInitContent_947": "让我看看你一只怪有多厉害吧哈哈哈",
    "skinType_20": "熔珀",
    "skinType_21": "缤纷",
    "mapNodeName_741": "如沸星穹",
    "messageInitContent_948": "一只怪在外面要小心哦，不然……",
    "skinType_22": "幻惑",
    "mapNodeName_742": "崩雪浮岛",
    "messageInitContent_949": "飞的可以过大海，跑的是怎么过的呢？",
    "skinType_23": "极焱",
    "skinType_24": "夏梦",
    "mapNodeName_740": "虹光拟态",
    "skinType_25": "夜魇",
    "skinType_26": "裁决",
    "skinType_27": "暗隧",
    "skinType_28": "甜粉",
    "skinType_29": "玄青",
    "mapNodeName_738": "初等防壁",
    "messageInitContent_951": "一个胳膊种草一个胳膊种花花",
    "mapNodeName_739": "崩雪浮岛",
    "messageInitContent_952": "懂了，胳膊是花盆",
    "22_dish122345": "飞天红枣削面",
    "mapNodeName_736": "交通枢纽",
    "messageInitContent_953": "建议带走到地球保护环境。",
    "mapNodeName_737": "崩雪浮岛",
    "messageInitContent_954": "保护那些消失的沼泽对吧",
    "mapNodeName_734": "光能拟态",
    "messageInitContent_955": "你们是懂环保的（笑",
    "mapNodeName_735": "古记战役-去月球",
    "messageInitContent_956": "这雪地还真的哪哪都有腐化者。",
    "mapNodeName_732": "过载副本",
    "messageInitContent_957": "纯洁的冰雪要被腐化了！",
    "mapNodeName_733": "崩雪浮岛",
    "messageInitContent_958": "看我看到了什么！这里还有主城！",
    "messageInitContent_950": "又一个不让怪兽回血的",
    "skinType_10": "龙",
    "mapNodeName_752": "大仁",
    "messageInitContent_959": "你们想住在哪边？",
    "skinType_11": "源力",
    "mapNodeName_753": "真大舌怪",
    "skinType_12": "火冕",
    "mapNodeName_750": "巨藤之地",
    "skinType_13": "重溟",
    "mapNodeName_751": "有闪",
    "skinType_14": "花颜",
    "skinType_15": "大漠",
    "skinType_16": "祥瑞",
    "skinType_17": "守岁",
    "skinType_18": "狂潮",
    "mapNodeName_749": "巨王霸",
    "messageInitContent_962": "住的地方怎么可以随便呢！",
    "skinType_19": "崩坏",
    "messageInitContent_963": "这里又是懂环保的",
    "mapNodeName_747": "大型叉叉",
    "messageInitContent_964": "明明应该是别把餐具当武器！",
    "mapNodeName_748": "巨藤领地",
    "messageInitContent_965": "所以独角兽那个是牙签吗？",
    "mapNodeName_745": "晶体矩阵",
    "messageInitContent_966": "10亿的牙签，等等牙签，牙签？！",
    "mapNodeName_746": "崩坠之门",
    "messageInitContent_967": "真是个可怕的故事，不说了不说了。",
    "mapNodeName_743": "仿生兽印记",
    "messageInitContent_968": "别吃我，我很多天没洗澡了，不好吃。",
    "mapNodeName_744": "火星餐厅",
    "messageInitContent_969": "不洗澡挺好的，已经入味了，不用再加调料了。",
    "messageInitContent_960": "不同地点加的产出不同吧",
    "messageInitContent_961": "买房吗这么纠结",
    "mapNodeName_720": "音响贩子",
    "mapNodeName_716": "服装店",
    "messageInitContent_973": "这什么爆发伤害啊",
    "mapNodeName_717": "管理中心",
    "messageInitContent_974": "麻麻，我要这个怪兽！快给我买",
    "mapNodeName_714": "礼品店",
    "messageInitContent_975": "前面这么可爱，最后一下给我整这的吗",
    "mapNodeName_715": "多脚炮台V",
    "messageInitContent_976": "玄武！！！！！！！救我",
    "mapNodeName_712": "过载副本",
    "messageInitContent_977": "玄武天克那两角兽",
    "mapNodeName_713": "顶端狂潮",
    "messageInitContent_978": "这边风景独好。",
    "mapNodeName_710": "过载副本",
    "messageInitContent_979": "你是指透过前面的怪兽的胯下看的世界吗",
    "mapNodeName_711": "自走绿化带",
    "messageInitContent_970": "我这里有一个过关秘诀！",
    "mapNodeName_718": "脸部修复中心",
    "messageInitContent_971": "快说！凹凸了！",
    "mapNodeName_719": "高温实验室",
    "messageInitContent_972": "一来来两啊，什么祸不单行，还有个狮子！",
    "skinType_30": "嵌合",
    "skinType_31": "缠魂",
    "skinType_32": "畸轨",
    "mapNodeName_730": "极地拟态",
    "skinType_33": "戏游",
    "mapNodeName_731": "金矿山",
    "skinType_34": "相移",
    "skinType_35": "魔铸",
    "skinType_36": "宝箱",
    "mapNodeName_727": "晶体熔炉",
    "messageInitContent_984": "是这里独有的景色呢，不属于任何一个季节。",
    "mapNodeName_728": "过载副本",
    "messageInitContent_985": "珍宝啊珍宝，我们又见面了，隔了多少关来着。",
    "mapNodeName_725": "单分子线商店",
    "messageInitContent_986": "放下那个珍宝，冲我来！",
    "mapNodeName_726": "创战纪",
    "messageInitContent_987": "你们对珍宝是有什么奇怪的执念吗",
    "mapNodeName_723": "数字幽灵",
    "messageInitContent_988": "请别把饭圈文化代入怪兽圈！",
    "mapNodeName_724": "气象中心",
    "messageInitContent_989": "宝宝，我的宝宝！",
    "mapNodeName_721": "混沌夜城",
    "mapNodeName_722": "过载副本",
    "messageInitContent_980": "为什么我只能看到前面怪兽的脚掌。",
    "messageInitContent_981": "小人国一会体验。",
    "mapNodeName_729": "崩雪浮岛",
    "messageInitContent_982": "我不想坐下。",
    "messageInitContent_983": "这图到底是春天还秋天呢。",
    "messageInitContent_1429": "短暂的休息时光。",
    "messageInitContent_1428": "所以地龙是过来找比蒙的吗",
    "messageInitContent_1427": "地龙想要生存下去并没有错",
    "messageInitContent_1426": "你到底死不死，能不能乖乖接受命运",
    "messageInitContent_1425": "当时拿出来针对你的，都可以拿出来了！",
    "messageInitContent_1424": "为了新的肉肉，冲啊！",
    "messageInitContent_1423": "能怎么办 只能硬着头皮上啊",
    "messageInitContent_1422": "还好镇魂不在",
    "randomEventDialogueGroupConfig_7.60": "肯定",
    "randomEventDialogueGroupConfig_7.61": "我大腿说它得了一种如果你不来我店里看看，它就不会好的病！不信你把耳朵贴过去听听。",
    "messageInitContent_995": "其实木偶族怕火的吗？",
    "randomEventDialogueGroupConfig_7.57": "擒抱攻击",
    "messageInitContent_996": "首先技能得先放出来。",
    "randomEventDialogueGroupConfig_7.58": "萌新？那不就是凌驾于一切巨佬之上的无敌存在吗？我店里有不少适合萌新的东西，欢迎光临！",
    "messageInitContent_997": "山林可不能随便生火哦。",
    "randomEventDialogueGroupConfig_7.55": "离开之际，它一弯腰反手将你擒住。",
    "messageInitContent_998": "我不生火，生气行了吧。",
    "randomEventDialogueGroupConfig_7.56": "大声求教",
    "messageInitContent_999": "生气吧，我准了。",
    "randomEventDialogueGroupConfig_7.53": "肯定",
    "randomEventDialogueGroupConfig_7.54": "迟疑",
    "randomEventDialogueGroupConfig_7.51": "告别",
    "randomEventDialogueGroupConfig_7.52": "你是萌新吗？",
    "messageInitContent_1432": "说的好像真的一样的",
    "messageInitContent_1431": "这里还能感受到海风",
    "messageInitContent_1430": "沙漠真是容易让人迷失",
    "messageInitContent_990": "珍珍，我的珍珍！",
    "messageInitContent_991": "珍珍是薯片吧？",
    "messageInitContent_992": "这名字连着念还挺帅的。",
    "messageInitContent_993": "极限强袭，停顿停顿！",
    "randomEventDialogueGroupConfig_7.59": "你是想要变强吗？",
    "messageInitContent_994": "小木偶，乖乖停下来，然后到我碗里来。",
    "messageInitContent_1439": "我吓晕了",
    "messageInitContent_1438": "我冷晕了",
    "messageInitContent_1437": "啊我晕了",
    "messageInitContent_1436": "有点口渴，想吃雪糕！",
    "tribeSeasonName_202601": "玩乐赛季",
    "messageInitContent_1435": "来不及对面还有冰霓",
    "tribeSeasonName_202602": "墨影赛季",
    "messageInitContent_1434": "我现在全换大体型来得及吗",
    "messageInitContent_1433": "锤爹？？？？？？",
    "randomEventDialogueGroupConfig_7.71": "否认三连",
    "randomEventDialogueGroupConfig_7.72": "它又向你凑近了一些。",
    "randomEventDialogueGroupConfig_7.70": "指出是它撞到你了",
    "randomEventDialogueGroupConfig_7.68": "立刻抱紧",
    "randomEventDialogueGroupConfig_7.69": "立刻道歉",
    "randomEventDialogueGroupConfig_7.66": "离开",
    "randomEventDialogueGroupConfig_7.67": "喂喂喂，你撞到我的大腿了！",
    "randomEventDialogueGroupConfig_7.64": "我是它大腿，我很疼。嗷嗷嗷嗷嗷哎哟哟喂~",
    "randomEventDialogueGroupConfig_7.65": "它跑了，决定找下一个目标。",
    "randomEventDialogueGroupConfig_7.62": "贴上去听",
    "randomEventDialogueGroupConfig_7.63": "哇！你想干嘛，想占我便宜？商人的便宜是你能随便占的吗？你还早十年！",
    "messageInitContent_1443": "伤害还是照吃的好吗",
    "messageInitContent_1442": "这时候会飞就显得很重要了",
    "messageInitContent_1441": "这地面我是1秒都不想呆了",
    "messageInitContent_1440": "火烤面包烤沼泽",
    "messageInitContent_1449": "乐队和它们的保镖们",
    "messageInitContent_1448": "站在你面前的是祖拉狂粉！",
    "messageInitContent_1447": "300级+26的祖拉！",
    "messageInitContent_1446": "养足发肥料，就可以种地了。",
    "messageInitContent_1445": "这地板现在可真是忙",
    "messageInitContent_1444": "起码视觉上没占到那些东西",
    "randomEventDialogueGroupConfig_7.35": "去锻炼",
    "randomEventDialogueGroupConfig_7.36": "不，你必须让我对你负起责任！",
    "randomEventDialogueGroupConfig_7.33": "表示突然后悔了",
    "randomEventDialogueGroupConfig_7.34": "逛商店",
    "randomEventDialogueGroupConfig_7.31": "看！都伤成这样了！",
    "randomEventDialogueGroupConfig_7.32": "陪你去干吗？",
    "randomEventDialogueGroupConfig_7.30": "它马上露出一脸的堆笑，摆出了请的姿势。",
    "messageInitContent_1454": "300勇士！",
    "messageInitContent_1453": "没有蚊子！",
    "messageInitContent_1452": "有很多吸血怪",
    "messageInitContent_1451": "吸血的很多，但没有吸血鬼",
    "messageInitContent_1450": "这里有吸血鬼吗",
    "randomEventDialogueGroupConfig_7.39": "它追过来了，追得相当紧。你的前面只有三条路了！",
    "randomEventDialogueGroupConfig_7.37": "挣扎",
    "randomEventDialogueGroupConfig_7.38": "放弃抵抗",
    "messageInitContent_1459": "射箭也安心",
    "messageInitContent_1458": "吃饭也安心",
    "messageInitContent_1457": "人间大炮是不是突然觉得人间有真情，人间有真爱",
    "messageInitContent_1456": "双罩世界",
    "messageInitContent_1455": "温泉关？",
    "randomEventDialogueGroupConfig_7.50": "可惜了，你差点就能见识一下什么是钻石的力量了。拜拜。",
    "randomEventDialogueGroupConfig_7.46": "只能战斗了",
    "randomEventDialogueGroupConfig_7.47": "“当然，如你所愿。”话音刚落，两块巨石从天而降砸落地面，一个奇怪的商店入口出现了。",
    "randomEventDialogueGroupConfig_7.44": "离开",
    "randomEventDialogueGroupConfig_7.45": "这条路很大，跑了一会，你发现前方居然是死路。",
    "randomEventDialogueGroupConfig_7.42": "大路",
    "randomEventDialogueGroupConfig_7.43": "一只突然冲出来的桐仁将它绊倒了，因此它没追上你。",
    "randomEventDialogueGroupConfig_7.40": "跑路",
    "randomEventDialogueGroupConfig_7.41": "小路",
    "messageInitContent_1465": "杂技表演吗？",
    "messageInitContent_1464": "还有疾风兔炸鸡表演",
    "messageInitContent_1463": "你还可以看到演员自己笑呢",
    "messageInitContent_1462": "还是说可以看到罗密欧和朱丽叶",
    "messageInitContent_1461": "这里表演川剧变脸吗",
    "messageInitContent_1460": "开炮也安心",
    "randomEventDialogueGroupConfig_7.48": "进入。",
    "randomEventDialogueGroupConfig_7.49": "离开。",
    "messageInitContent_1469": "哇这两个的技能好好玩",
    "messageInitContent_1468": "舔一舔，大家都有份",
    "messageInitContent_1467": "这得活着先",
    "messageInitContent_1466": "收门票的吗",
    "randomEventDialogueGroupConfig_7.99": "哦，那你想？",
    "randomEventDialogueGroupConfig_7.97": "表示需要弘扬仓鼠精神",
    "randomEventDialogueGroupConfig_7.98": "表示钻石数量很少",
    "randomEventDialogueGroupConfig_7.95": "离开",
    "randomEventDialogueGroupConfig_7.96": "说好的穷的只剩钻石呢？",
    "messageInitContent_1476": "2个奶妈！",
    "messageInitContent_1475": "还真的是一战……",
    "messageInitContent_1474": "为了生存",
    "messageInitContent_1473": "它们好努力哦",
    "messageInitContent_1472": "一下子掉血的感觉好好玩",
    "messageInitContent_1471": "快把污妖王拿走！",
    "messageInitContent_1470": "什么舔狗共享技能",
    "messageInitContent_1479": "四脚兽？四脚兽？",
    "messageInitContent_1478": "你们在说什么呢，我完全看不懂！",
    "messageInitContent_1477": "还真是两个奶妈！这不是二……",
    "messageInitNick_10006": "跟你借的幸福",
    "messageInitNick_10007": "即兴演出",
    "messageInitNick_10004": "爱恨如潮水",
    "messageInitNick_10005": "脸盆先锋",
    "messageInitNick_10008": "早餐吃香蕉",
    "messageInitNick_10009": "互联网史官",
    "messageInitNick_10002": "别再沦陷",
    "messageInitNick_10003": "拒绝打扰",
    "messageInitNick_10000": "半份关心",
    "messageInitNick_10001": "电子辣椒",
    "messageInitContent_1487": "报团取暖有什么错呢",
    "messageInitContent_1486": "占用保护资源",
    "messageInitContent_1485": "又是一大堆在龙王罩子里不舍得走的",
    "messageInitContent_1484": "奶妈的发型都是哪里剪的（突然想知道",
    "messageInitContent_1483": "龙王：我的输出呢？",
    "messageInitContent_1482": "龙王的输出呢？",
    "messageInitContent_1481": "你们好污哦。",
    "messageInitContent_1480": "肥皂在哪里！澡堂又在哪里？",
    "messageInitContent_1489": "你别笑",
    "messageInitContent_1488": "这样更危险呢！",
    "randomEventDialogueGroupConfig_7.82": "交易",
    "randomEventDialogueGroupConfig_7.83": "它指着自己的大腿，但显然没有受伤的痕迹。",
    "randomEventDialogueGroupConfig_7.80": "它搓搓手，邀你去买东西。",
    "randomEventDialogueGroupConfig_7.81": "说下次再算",
    "messageInitContent_1490": "你的笑真美",
    "randomEventDialogueGroupConfig_7.79": "离开",
    "randomEventDialogueGroupConfig_7.77": "再说一遍",
    "randomEventDialogueGroupConfig_7.78": "此时你听到远处传来了奇怪的声音，什么油腻术、脱困指令、行动自如的。你很轻松就挣脱了。",
    "randomEventDialogueGroupConfig_7.75": "它又又凑近了一些。",
    "randomEventDialogueGroupConfig_7.76": "放开大腿离开",
    "randomEventDialogueGroupConfig_7.73": "再说一遍",
    "randomEventDialogueGroupConfig_7.74": "放开腿离开",
    "messageInitContent_1498": "阿朱不要化妆成制杖啊！！！",
    "messageInitContent_1497": "啊jo应该去隔壁那边，那边龙多",
    "messageInitContent_1496": "阿朱我真的哭死呜呜",
    "messageInitContent_1495": "这里是什么奇怪的教派啊？",
    "messageInitContent_1494": "你看它笑的多开心啊！",
    "messageInitContent_1493": "你们确定那是微笑吗",
    "messageInitContent_1492": "不知道做什么微笑就对了",
    "messageInitContent_1491": "你微笑时真美",
    "messageInitContent_1499": "热爱好结局的生物路过",
    "randomEventDialogueGroupConfig_7.93": "拆穿它",
    "randomEventDialogueGroupConfig_7.94": "它说完就跑了。",
    "randomEventDialogueGroupConfig_7.91": "转头就跑",
    "randomEventDialogueGroupConfig_7.92": "它捂着嘴装作是大腿发来的声音。",
    "randomEventDialogueGroupConfig_7.90": "说它耍赖",
    "randomEventDialogueGroupConfig_7.88": "拒绝它",
    "randomEventDialogueGroupConfig_7.89": "它向你冲了过去。\\n",
    "randomEventDialogueGroupConfig_7.86": "嘿那不是正好！欢迎光临。",
    "randomEventDialogueGroupConfig_7.87": "进店看看",
    "randomEventDialogueGroupConfig_7.84": "指出它并没有受伤",
    "randomEventDialogueGroupConfig_7.85": "摸一下",
    "messageInitNick_10039": "卷毛鸡",
    "messageInitNick_10037": "你的小娇妻",
    "messageInitNick_10038": "橙柚融合体",
    "messageInitNick_10031": "世界杯子",
    "messageInitNick_10032": "哥天生拽",
    "messageInitNick_10030": "豆角兽",
    "messageInitNick_10035": "化身孤岛的鲸",
    "messageInitNick_10036": "孤城暮雨",
    "messageInitNick_10033": "共享寂寞",
    "messageInitNick_10034": "流浪的髌骨",
    "messageInitNick_10048": "我胆小真的",
    "messageInitNick_10049": "为减排做贡献",
    "messageInitNick_10042": "质疑理解成为",
    "messageInitNick_10043": "狂乱贵公子",
    "messageInitNick_10040": "纯情夹心糖",
    "messageInitNick_10041": "表情失去控制",
    "messageInitNick_10046": "下辈子再努力",
    "messageInitNick_10047": "期待转身",
    "messageInitNick_10044": "潜行者",
    "messageInitNick_10045": "番茄魔法",
    "messageInitNick_10017": "生菜真好吃",
    "messageInitNick_10018": "果冻大师",
    "messageInitNick_10015": "星之巨人",
    "messageInitNick_10016": "火龙果拌莲藕",
    "messageInitNick_10019": "纯白色的围巾",
    "messageInitNick_3496": "闪亮洗牌",
    "messageInitNick_10010": "凳子捞月亮",
    "messageInitNick_3495": "暴走的蛋糕",
    "messageInitNick_3494": "行走的桂皮",
    "messageInitNick_3493": "地狱苹果",
    "messageInitNick_10013": "飞天猪",
    "messageInitNick_10014": "喂不饱的鱼",
    "messageInitNick_3499": "麻辣烫",
    "messageInitNick_10011": "草莓软糖",
    "messageInitNick_3498": "杨桃可爱的",
    "messageInitNick_10012": "弹幕养肥中",
    "messageInitNick_3497": "铁子",
    "iapBuyConfigName_1304": "降临礼遇III",
    "iapBuyConfigName_1305": "降临礼遇IV",
    "iapBuyConfigName_1302": "降临礼遇I",
    "iapBuyConfigName_1303": "降临礼遇II",
    "messageInitNick_10028": "来点干货",
    "iapBuyConfigName_1301": "降临赠礼",
    "messageInitNick_10029": "帘卷笙声寂",
    "messageInitNick_10026": "不做花瓶女",
    "messageInitNick_10027": "三角骨",
    "messageInitNick_3492": "爱如履薄冰",
    "messageInitNick_3491": "别笑了",
    "messageInitNick_3490": "无语葡萄",
    "messageInitNick_10020": "目害",
    "messageInitNick_3485": "甩锅神",
    "messageInitNick_10021": "无公害蒜苔",
    "messageInitNick_3484": "刮刮乐不乐",
    "messageInitNick_3483": "蛋挞大叔",
    "messageInitNick_3482": "浪一生酷一世",
    "messageInitNick_10024": "行走的椰子酱",
    "messageInitNick_3489": "潜水之王",
    "messageInitNick_10025": "爱情沉睡中",
    "messageInitNick_3488": "柿子先锋",
    "messageInitNick_10022": "吃风少年",
    "messageInitNick_3487": "在吗在吗",
    "messageInitNick_10023": "飞天忍者猪",
    "messageInitNick_3486": "大鼻头",
    "messageInitNick_3481": "按时发癫",
    "messageInitNick_3480": "苍龙逐日",
    "messageInitNick_10075": "空大女神",
    "messageInitNick_3474": "加强少女心",
    "randomEventDialogueGroupConfig_7.13": "要求它把好东西给你",
    "messageInitNick_10076": "抱怨鬼",
    "messageInitNick_3473": "丢了翅膀的鱼",
    "randomEventDialogueGroupConfig_7.14": "我没听清，你再说一遍？",
    "messageInitNick_10073": "什么八音盒",
    "messageInitNick_3472": "恋着海鸟的鱼",
    "randomEventDialogueGroupConfig_7.11": "大声说大佬带带我",
    "messageInitNick_10074": "隐世窥红尘",
    "messageInitNick_3471": "跑调鉴定家",
    "randomEventDialogueGroupConfig_7.12": "等等，你要干嘛？",
    "messageInitNick_10079": "专治心塞",
    "messageInitNick_3478": "瞳孔地震",
    "messageInitNick_3477": "熬润菊布娜娜",
    "randomEventDialogueGroupConfig_7.10": "让它不要动",
    "messageInitNick_10077": "孤街老猫",
    "messageInitNick_3476": "甜辣蘑菇",
    "messageInitNick_10078": "机械兵粮",
    "messageInitNick_3475": "春山多胜事",
    "randomEventDialogueGroupConfig_7.19": "离开。",
    "messageInitNick_3479": "水晶羽毛球",
    "messageInitNick_10071": "熬夜门首席",
    "randomEventDialogueGroupConfig_7.17": "接战",
    "messageInitNick_10072": "养只闲猫",
    "randomEventDialogueGroupConfig_7.18": "“别的我就不知道了。”它的抓了抓胸口，一脚甩开你便跑了。",
    "randomEventDialogueGroupConfig_7.15": "我又没听清，你再说一遍？",
    "messageInitNick_10070": "你在问我吗",
    "randomEventDialogueGroupConfig_7.16": "噢，胆子大得很嘛，让我看看你本事是不是也这么大。",
    "messageInitNick_3470": "爬冰箱变高冷",
    "messageInitNick_10086": "辣椒魔法",
    "messageInitNick_3463": "帮我埋单",
    "randomEventDialogueGroupConfig_7.24": "表示要先看看它大腿的伤势",
    "messageInitNick_10087": "凉茶吞噬者",
    "messageInitNick_3462": "江山如画",
    "randomEventDialogueGroupConfig_7.25": "我建议你去问秃头披风侠，不过既然你诚心发问，我倒是可以帮帮你——！",
    "messageInitNick_10084": "阿伟神了",
    "messageInitNick_3461": "宁愿二不愿装",
    "randomEventDialogueGroupConfig_7.22": "道歉有用的话，还要G-N干嘛，还是实际点，谈谈要怎么赔我吧。",
    "messageInitNick_10085": "岁月是把猪刀",
    "messageInitNick_3460": "永远年轻",
    "randomEventDialogueGroupConfig_7.23": "说你身上穷的就只剩钻石了",
    "messageInitNick_3467": "大长腿欧巴",
    "randomEventDialogueGroupConfig_7.20": "“造唤台呀。”它说着便把你甩开，跑掉了。",
    "messageInitNick_3466": "香蕉的香蕉",
    "randomEventDialogueGroupConfig_7.21": "离开。",
    "messageInitNick_10088": "傲气小仙女",
    "messageInitNick_3465": "番茄射手",
    "messageInitNick_10089": "樱桃去哪了",
    "messageInitNick_3464": "听君一席话",
    "messageInitNick_3469": "灵魂歌者",
    "messageInitNick_3468": "哥傲视群雄",
    "messageInitNick_10082": "晚风太急",
    "randomEventDialogueGroupConfig_7.28": "“喂喂，你……你把我当成什么怪兽了。呃，不过……交……交易什么的，也不是不行啦，今晚在平原山洞等你。暗号是1024，不见不散！”它温柔地甩开你，然后离开了。",
    "messageInitNick_10083": "专业卖惨",
    "randomEventDialogueGroupConfig_7.29": "离开。",
    "messageInitNick_10080": "天生萌货",
    "randomEventDialogueGroupConfig_7.26": "接受帮助",
    "messageInitNick_10081": "沦为旧朋友",
    "randomEventDialogueGroupConfig_7.27": "拒绝帮助",
    "messageInitContent_1407": "是它！",
    "messageInitContent_1406": "是它",
    "messageInitContent_1405": "拿完金币拿肉肉",
    "messageInitContent_1404": "给小黯灭打call，为了单身狗，它多努力！",
    "messageInitContent_1403": "真的回不去了",
    "messageInitContent_1402": "说尾巴像jio的 我回不去了",
    "messageInitContent_1401": "能不能别提尾巴！",
    "messageInitContent_1400": "那个尾巴",
    "messageInitNick_10059": "心易碎请勿碰",
    "messageInitContent_1409": "你也是jo家人吗，怪不得这么强",
    "messageInitContent_1408": "乔大爷，你能不能别来。",
    "messageInitNick_10053": "牵手男主持",
    "messageInitNick_3452": "崩溃灯泡",
    "messageInitNick_10054": "笑料编织者",
    "messageInitNick_3451": "学舌鸦饲养员",
    "messageInitNick_10051": "出逃鳄鱼宝宝",
    "messageInitNick_3450": "听说樱花很美",
    "messageInitNick_10052": "萝卜萝卜糕",
    "messageInitNick_10057": "哥霸气内敛",
    "messageInitNick_3456": "鼠标狂怒者",
    "messageInitNick_10058": "迷路的股骨",
    "messageInitNick_3455": "该用户已下线",
    "messageInitNick_10055": "西部工具人",
    "messageInitNick_3454": "灵魂已下班",
    "messageInitNick_10056": "草莓味肩带",
    "messageInitNick_3453": "吃饭了吗",
    "messageInitContent_1410": "我*，这难道就是替身攻击吗",
    "messageInitNick_3459": "呆萌学妹",
    "messageInitNick_3458": "花心大少",
    "messageInitNick_3457": "给我力量忘掉",
    "messageInitNick_10050": "求偶失败的人",
    "messageInitContent_1418": "想得真美",
    "messageInitContent_1417": "如果来个能平均分buff的就爽了",
    "messageInitContent_1416": "还有小黑子",
    "messageInitContent_1415": "她好可爱！",
    "messageInitContent_1414": "但g-n本身就是全体加血",
    "messageInitContent_1413": "她好温柔！",
    "messageInitContent_1412": "奶量加加加倍",
    "messageInitContent_1411": "我的前排，我的后排，jo大爷你做什么了！",
    "messageInitContent_1419": "快让我看看挡在肉肉面前的是什么东西！",
    "messageInitNick_10064": "深海公子",
    "messageInitNick_3441": "陌生的雨点",
    "messageInitNick_10065": "无语披萨",
    "messageInitNick_3440": "打折卖惨",
    "messageInitNick_10062": "熬润菊布娜娜",
    "messageInitNick_10063": "兔兔无敌",
    "messageInitNick_10068": "提刀美人",
    "messageInitNick_3445": "霸屏大姐",
    "messageInitNick_10069": "苍蝇旅行团",
    "messageInitNick_3444": "秋天第一杯",
    "messageInitNick_10066": "摸摸它狗头",
    "messageInitNick_3443": "肚脐激光",
    "messageInitNick_10067": "核动力打蛋器",
    "messageInitNick_3442": "痴情先生",
    "messageInitContent_1421": "还有比蒙草丛独角兽",
    "messageInitNick_3449": "大聪明",
    "messageInitContent_1420": "啊，剧王、豹子那没事了",
    "messageInitNick_3448": "满城静待",
    "messageInitNick_3447": "打它屁屁",
    "messageInitNick_3446": "我们这两家",
    "messageInitNick_10060": "画饼门首席",
    "messageInitNick_10061": "吃饭了吗",
    "messageInitNick_1251": "吃颗糖壮壮胆",
    "messageInitNick_1252": "争取第一",
    "messageInitNick_1250": "我的背带裤",
    "messageInitNick_1255": "不熟悉的你",
    "messageInitNick_1256": "啊对对对",
    "messageInitNick_1253": "单身狗",
    "messageInitNick_1254": "奔跑的鸵鸟",
    "messageInitNick_1259": "狂暴战神",
    "messageInitNick_1257": "空房子",
    "messageInitNick_1258": "菜却自信",
    "messageInitNick_1240": "细雨覆江南",
    "messageInitNick_1241": "半岛恋人",
    "messageInitNick_1244": "霸道地主",
    "messageInitNick_1245": "三点一线",
    "messageInitNick_1242": "提刀美人",
    "messageInitNick_1243": "尬聊带头人",
    "messageInitNick_1248": "另类囚徒",
    "messageInitNick_1249": "嘟嘟熊",
    "messageInitNick_1246": "幼儿园一姐",
    "messageInitNick_1247": "话题总结者",
    "messageInitNick_3892": "生菜撞地球",
    "messageInitNick_1230": "黑色巧克力",
    "messageInitNick_3891": "行走的蛋糕",
    "messageInitNick_3890": "橙子君快逃",
    "messageInitNick_1233": "倚栏听风叙",
    "messageInitNick_3896": "显卡去采购",
    "messageInitNick_1234": "没开完的花",
    "messageInitNick_3895": "勇敢的狮子",
    "messageInitNick_1231": "风继续吹",
    "messageInitNick_3894": "残留的躯壳",
    "messageInitNick_1232": "收不回的爱",
    "messageInitNick_3893": "嘴可真硬",
    "messageInitNick_1237": "一份儿童套餐",
    "messageInitNick_1238": "只能逃了",
    "messageInitNick_3899": "队友别坑奶",
    "messageInitNick_1235": "不再让你孤单",
    "messageInitNick_3898": "荔枝烙印",
    "messageInitNick_1236": "友达以上",
    "messageInitNick_3897": "流浪的摄影师",
    "messageInitNick_1239": "爱在夜里沉溺",
    "messageInitNick_3881": "反差帅",
    "messageInitNick_3880": "孤城他寒",
    "messageInitNick_1222": "中推谢谢",
    "messageInitNick_3885": "鸭梨山大",
    "messageInitNick_1223": "屠龙者",
    "messageInitNick_3884": "诺贝尔暴富奖",
    "messageInitNick_1220": "眼睛出汗了",
    "messageInitNick_3883": "谁的益达掉了",
    "messageInitNick_1221": "正在输入",
    "messageInitNick_3882": "只是友情出演",
    "messageInitNick_1226": "广场舞阿姨",
    "messageInitNick_3889": "世界级长拳",
    "messageInitNick_1227": "发疯的鱼",
    "messageInitNick_3888": "无敌修勾",
    "messageInitNick_1224": "套娃门传人",
    "messageInitNick_3887": "欧力给",
    "messageInitNick_1225": "早上说晚安",
    "messageInitNick_3886": "不靠谱青年",
    "messageInitNick_1228": "心脏大逃亡",
    "messageInitNick_1229": "退役吃瓜选手",
    "messageInitNick_3870": "猫咪不在家",
    "messageInitNick_1211": "蹲厕唱忐忑",
    "messageInitNick_3874": "赛博围棋",
    "messageInitNick_1212": "与寂寞有染",
    "messageInitNick_3873": "悲欢想不通",
    "messageInitNick_3872": "公交师傅",
    "messageInitNick_1210": "持刀浪妹儿",
    "messageInitNick_3871": "呆萌小甜心",
    "messageInitNick_1215": "超人不会飞",
    "messageInitNick_3878": "到底来没",
    "messageInitNick_1216": "跟屁虫",
    "messageInitNick_3877": "意料之外",
    "messageInitNick_1213": "独舞天使",
    "messageInitNick_3876": "别捏姐的脸",
    "messageInitNick_1214": "干物女",
    "messageInitNick_3875": "怀中猫",
    "messageInitNick_1219": "只怪吧吃蛋",
    "messageInitNick_1217": "咕咕门传人",
    "messageInitNick_1218": "别撑你不是伞",
    "messageInitNick_3879": "二倍速大师",
    "messageInitNick_1200": "喂不饱的鱼",
    "messageInitNick_3863": "如果柚子会笑",
    "messageInitNick_1201": "恰饭之神",
    "messageInitNick_3862": "大多角骨",
    "messageInitNick_3861": "云朵想吃糖",
    "messageInitNick_3860": "深渊的那支花",
    "messageInitNick_1204": "捡漏天王",
    "messageInitNick_3867": "打字机旁的猫",
    "messageInitNick_1205": "离岛牧人",
    "messageInitNick_3866": "洗衣粉狂怒者",
    "messageInitNick_1202": "在你心上偷渡",
    "messageInitNick_3865": "混凝土变变变",
    "messageInitNick_1203": "生人勿近",
    "messageInitNick_3864": "无公害柿子",
    "messageInitNick_1208": "寂寞不打烊",
    "messageInitNick_1209": "我的小熊",
    "messageInitNick_1206": "黑暗亡灵",
    "messageInitNick_3869": "跑调门传人",
    "messageInitNick_1207": "高冷绅士",
    "messageInitNick_3868": "洗脚盆破坏者",
    "messageInitNick_3852": "镜子破坏者",
    "messageInitNick_3851": "年轻人别熬夜",
    "messageInitNick_3850": "无敌的细胞核",
    "messageInitNick_3856": "孤单三色堇",
    "messageInitNick_3855": "苍蝇旅行团",
    "messageInitNick_3854": "等一面金牌",
    "messageInitNick_3853": "缩小化手机",
    "messageInitNick_3859": "飞行拖把",
    "messageInitNick_3858": "我就是好男人",
    "messageInitNick_3857": "单身一人挺好",
    "messageInitNick_3841": "重新定义卖惨",
    "messageInitNick_3840": "等一个睡美人",
    "messageInitNick_3845": "转时间表",
    "messageInitNick_3844": "切西瓜表演家",
    "messageInitNick_3843": "我大受震撼",
    "messageInitNick_3842": "久居孤岛",
    "messageInitNick_3849": "美食专享",
    "messageInitNick_3848": "胖不了先生",
    "messageInitNick_3847": "非常正确的",
    "messageInitNick_3846": "智能灯泡",
    "messageInitNick_3839": "李子捞月",
    "messageInitContent_1029": "大炮的。",
    "messageInitContent_1028": "大舌怪，还是其他的。",
    "messageInitContent_1027": "哪个？",
    "messageInitContent_1026": "巧了，我觉得我也擅长那个",
    "messageInitContent_3688": "大家一起暴富",
    "messageInitContent_3689": "猜输2天了，你们呢",
    "messageInitContent_3691": "老实巴交",
    "messageInitContent_3692": "选哪边啊啊",
    "messageInitContent_3693": "创飞都给我创飞",
    "messageInitContent_3694": "注意看！这个女人名叫小美",
    "messageInitContent_3695": "（=。=",
    "messageInitNick_3830": "励志哥",
    "messageInitContent_3696": "摸鱼小助手提醒你记得摸鱼",
    "messageInitContent_3697": "emmmmm",
    "messageInitContent_3698": "吐舌羊.gif",
    "messageInitContent_1036": "一个敢信",
    "messageInitNick_3834": "夜间旅行者",
    "messageInitContent_1035": "一个敢吹",
    "messageInitNick_3833": "刺骨的温柔",
    "messageInitContent_1034": "简单，你先找到累世长眠的不逝者，然后……",
    "messageInitNick_3832": "为环保出分力",
    "messageInitContent_1033": "请问你这海鲜城怎么去",
    "messageInitNick_3831": "绝活大师兄",
    "messageInitContent_1032": "让拉莱耶海鲜城大厨教教你们",
    "messageInitNick_3838": "最爱香蕉",
    "messageInitContent_1031": "这几个能讨伐海怪我是不信的。",
    "messageInitNick_3837": "又一个决带笑",
    "messageInitContent_1030": "隔壁是集市，快去集合！",
    "messageInitNick_3836": "砖家叫兽",
    "messageInitContent_3690": "我家日夕丢了有人看到她吗",
    "messageInitNick_3835": "怀念地球",
    "messageInitNick_3829": "神秘的捕鼠器",
    "messageInitNick_3828": "黯夜的忧雨",
    "messageInitContent_1039": "远得离谱了",
    "messageInitContent_1038": "这侦查距离是不是有点远",
    "messageInitContent_1037": "这海怪很善良的，就是一代那只。",
    "messageInitContent_3699": "dalao选啥捏",
    "messageInitContent_1047": "当然是当海贼王的怪兽！",
    "messageInitNick_3823": "恰瓜小能手",
    "messageInitContent_1046": "当然是当海贼王！",
    "messageInitNick_3822": "兀自沉沦",
    "messageInitContent_1045": "这堆怪兽出海是干嘛的？",
    "messageInitNick_3821": "有名人士",
    "messageInitContent_1044": "别去！很危险！",
    "messageInitNick_3820": "别在伤口撒盐",
    "messageInitContent_1043": "隔壁有个老战役喔",
    "messageInitNick_3827": "樱桃逃跑了",
    "messageInitContent_1042": "毕竟那两只东西的仇家本来就很多，",
    "messageInitNick_3826": "一路冇你",
    "messageInitContent_1041": "要命的和不要命的。",
    "messageInitNick_3825": "干饭大师",
    "messageInitContent_1040": "和讨伐队鲜明对比。",
    "messageInitNick_3824": "肥皂在冒泡",
    "messageInitNick_3819": "哪来的你",
    "messageInitNick_3818": "外星人的猫",
    "messageInitNick_3817": "有事您摇铃",
    "messageInitContent_1049": "当然是当海贼王的男人！",
    "messageInitContent_1048": "当然是当海贼王的美食！",
    "messageInitContent_1050": "当然是为了诗与远方。",
    "messageInitContent_1058": "它们到底什么关系呢嘿嘿",
    "messageInitNick_3812": "芹菜射手",
    "messageInitContent_1057": "红唇的衣服也是血污妖王的吧",
    "messageInitNick_3811": "本人纯属虚构",
    "messageInitContent_1056": "很想像污妖王请教一下腿毛是怎么长的",
    "messageInitNick_3810": "樱木仙子",
    "messageInitContent_1055": "我跟它握手！",
    "messageInitContent_1054": "拼了？",
    "messageInitNick_3816": "你惹怒我了",
    "messageInitContent_1053": "谁说污妖王不算英雄！我跟它！",
    "messageInitNick_3815": "迷恋欧皇",
    "messageInitContent_1052": "它它又又警告我了！",
    "messageInitNick_3814": "尘埃落不定",
    "messageInitContent_1051": "出海是怪兽的浪漫好吗！",
    "messageInitNick_3813": "尖叫生菜",
    "messageInitNick_3809": "跟过去挥手",
    "messageInitNick_3808": "黄瓜兽",
    "messageInitNick_3807": "静等一旧人",
    "messageInitNick_3806": "老手入门",
    "messageInitContent_1059": "1神带4坑？",
    "skillName_1": "龙魂",
    "skillName_2": "龙魂·觉醒",
    "messageInitContent_1061": "艳福不浅呢",
    "skillName_7": "龙魂·铁幕强化",
    "messageInitContent_1060": "奶妈出海，多带几个保镖怎么了",
    "skillName_8": "龙魂·焚烧强化",
    "skillName_9": "龙焰",
    "skillName_3": "龙魂·铁幕",
    "skillName_4": "龙魂·焚烧",
    "skillName_5": "龙魂·霸体",
    "skillName_6": "龙魂·底力",
    "messageInitContent_1069": "已经很危险了，现在还整个危险加速。",
    "messageInitNick_3801": "看客",
    "messageInitContent_1068": "那些小怪兽都很危险，很容易被踩到。",
    "messageInitNick_3800": "机械男团主场",
    "messageInitContent_1067": "有比蒙巨兽的地方也应该警告下。",
    "messageInitContent_1066": "大笨象和小兔子。",
    "messageInitContent_1065": "不对，打败它们的将会是我！",
    "messageInitNick_3805": "香蕉射手",
    "messageInitContent_1064": "没错，我将打败它们",
    "messageInitNick_3804": "刹那与永恒",
    "messageInitContent_1063": "没有关系，它们很快就要输了",
    "messageInitNick_3803": "裂缝中的阳光",
    "messageInitContent_1062": "这么多保镖能不能奶得动",
    "messageInitNick_3802": "提刀美人",
    "98_-30029": "元核熔炼锁定相同属性超过2条",
    "ancientGeneConfigName_11": "缺陷穿刺",
    "messageInitContent_1072": "冲出亚洲！走向世界！",
    "ancientGeneConfigName_10": "远古亲和",
    "messageInitContent_1071": "这是要冲出哪里呢",
    "ancientGeneConfigName_13": "骨环牵制",
    "messageInitContent_1070": "前面还有那么多小伙伴。",
    "ancientGeneConfigName_12": "储血",
    "98_-30025": "紫色品质或以上元核才能参与熔炼",
    "98_-30021": "该元核被锁定，无法选取",
    "ancientGeneConfigName_19": "增益剥离",
    "98_-30020": "等级{1}开启元核熔炼",
    "ancientGeneConfigName_18": "巨钳横扫",
    "messageInitContent_1079": "其实是我画上去的呢。",
    "98_-30023": "该元核有未处理的熔炼记录",
    "messageInitContent_1078": "谁都可以但不能是金翅鸟！",
    "98_-30022": "该元核没有熔炼记录",
    "messageInitContent_1077": "都是金翅鸟卷起的狂风卷起的浪！",
    "ancientGeneConfigName_15": "威胁退散",
    "messageInitContent_1076": "那三个浪还很整齐地排一起",
    "ancientGeneConfigName_14": "混沌缠绕",
    "messageInitContent_1075": "有问题问智者！",
    "ancientGeneConfigName_17": "恒固植根",
    "messageInitContent_1074": "超星海洋里的浪是怎么起的呢？",
    "ancientGeneConfigName_16": "螫刺毒腺",
    "messageInitContent_1073": "全靠浪！",
    "messageInitNick_10408": "火龙果射手",
    "messageInitNick_10409": "我是硕博",
    "messageInitNick_10402": "你说的对",
    "messageInitNick_10403": "未成年面包",
    "messageInitNick_10400": "灰常二",
    "messageInitNick_10401": "榴莲炒皮蛋",
    "messageInitNick_10406": "行走的橡皮糖",
    "messageInitNick_10407": "爱笑的男孩",
    "messageInitNick_10404": "兔兔在洗澡",
    "messageInitNick_10405": "阿伟不要啊",
    "ancientGeneConfigName_22": "不完全返祖",
    "messageInitContent_1083": "不学习进步，就会被淘汰。",
    "ancientGeneConfigName_21": "完全返祖",
    "messageInitContent_1082": "活到老学到老是吧",
    "messageInitContent_600": "只能找一只血量更低的怪兽饲星了。",
    "ancientGeneConfigName_24": "血棘刺",
    "messageInitContent_1081": "制杖巨人去学击剑了，制杖小人是不是也该学习点什么",
    "messageInitContent_601": "血最少的怪兽满怀期待的登场，发现只是被利用了吗",
    "ancientGeneConfigName_23": "返祖征兆",
    "messageInitContent_1080": "幻朽搭配，打架不累。",
    "messageInitContent_602": "才不是利用，这就是策略",
    "messageInitContent_603": "没事没事奶管够",
    "messageInitContent_604": "这鸟的名字真的很合适",
    "ancientGeneConfigName_20": "高速蹄行",
    "messageInitContent_605": "我觉得蜻蜓龙也该改个差不多的",
    "messageInitContent_606": "独角兽是不是该加个鹿角",
    "ancientGeneConfigName_29": "魂吸",
    "messageInitContent_1089": "已经可以独当一面了",
    "messageInitContent_1088": "你口中的小祖拉已经85级了！",
    "ancientGeneConfigName_26": "肌肉金轮",
    "messageInitContent_1087": "小小祖拉，今天出海了~",
    "ancientGeneConfigName_25": "凝血背甲",
    "messageInitContent_1086": "不朽才是最弱的，不接受反驳。",
    "ancientGeneConfigName_28": "腐蚀唾液",
    "messageInitContent_1085": "然后发现周围都是不朽，你还是幻化。",
    "ancientGeneConfigName_27": "浮游鳞",
    "messageInitContent_1084": "能不能好好躺平一下。",
    "19_comment": "世界回响",
    "messageInitContent_607": "气质这块完全不像啊",
    "messageInitContent_608": "毕竟不是那么好拿捏的",
    "messageInitContent_609": "素食宣传关",
    "messageInitContent_1094": "我当年的第一支队就是推推队",
    "messageInitContent_610": "动物狂想曲？",
    "messageInitContent_1093": "g-n不厉害吗？很厉害好吗？",
    "messageInitContent_611": "原来不同类型的欲望之间是可以转移的吗",
    "messageInitContent_1092": "你是指g-n吗",
    "messageInitContent_612": "好的，下一关~",
    "messageInitContent_1091": "把厉害的怪兽都发给我吧！",
    "messageInitContent_613": "肩膀的小花好可爱！",
    "messageInitContent_1090": "需要从这个游戏移除的怪兽又多了一只。",
    "messageInitContent_614": "堡垒？！",
    "messageInitContent_615": "从跃迁兽到撼地兽，到底发生了什么？",
    "messageInitContent_616": "请分析此处引力的作用？",
    "messageInitContent_617": "我喜欢靠近你，可能是万有引力",
    "messageInitContent_1099": "珍宝，我一定会将你夺回来的。",
    "messageInitContent_1098": "珍宝，我的珍宝啊！",
    "messageInitContent_1097": "现在还可以领梵吗？",
    "messageInitContent_1096": "这个大陆真是多灾多难，老是有天灾",
    "messageInitContent_1095": "推到一起轰~",
    "messageInitContent_618": "我会亲你，是因为地心引力",
    "messageInitContent_619": "别啥都往引力上扯啊喂！",
    "messageInitContent_621": "谁是扯线的人呢。",
    "messageInitContent_622": "这里的木偶都是自动的。",
    "messageInitContent_623": "有没有那种自动书记人偶",
    "messageInitContent_624": "有没有那种自动书记人偶",
    "messageInitContent_625": "有没有那种自动书记人偶",
    "messageInitContent_626": "建议出门乱拐呢，O(∩_∩)O哈哈~",
    "messageInitContent_627": "烧焦的食物不能吃！",
    "messageInitContent_628": "温馨提醒：烧焦的食物不能吃！",
    "messageInitContent_620": "木偶奇遇记",
    "messageInitContent_3729": "e人路过",
    "messageInitContent_3721": "虽然今天不敢出声，但还是辛苦自己了",
    "messageInitContent_629": "怪兽行为请勿模仿",
    "messageInitNick_10314": "再来一打",
    "messageInitContent_3722": "这种时候装傻就对了",
    "messageInitNick_10315": "无公害杏子",
    "messageInitContent_3723": "害羞",
    "messageInitNick_10312": "椰子消灭者",
    "messageInitContent_3724": "我不理解",
    "messageInitNick_10313": "树莓去哪了",
    "messageInitContent_3725": "社牛和社恐之间，选了社畜",
    "messageInitNick_10318": "天堂裤子",
    "messageInitContent_3726": "怪多力量大",
    "messageInitNick_10319": "智商已欠费",
    "messageInitContent_3727": "私我告诉你的答案",
    "messageInitNick_10316": "幸福下落不明",
    "messageInitContent_3728": "网恋吗，我社恐",
    "messageInitNick_10317": "抱歉情商不足",
    "messageInitContent_632": "赢了的对面。",
    "messageInitContent_633": "这新的暗黑龙好萌！",
    "messageInitContent_634": "再来只g-n就完美了",
    "messageInitContent_635": "说g-n的认真的吗",
    "messageInitContent_636": "是不是对疗伤圣地有什么误解",
    "messageInitNick_10310": "寒鸦",
    "messageInitContent_637": "可能是说在怪兽世界情伤也是会出血的意思",
    "messageInitNick_10311": "鱿鱼掌大师",
    "messageInitContent_3730": "这是i怪吗",
    "messageInitContent_638": "怪兽世界有真情 怪兽世界有真爱",
    "messageInitContent_3731": "一看就懂",
    "messageInitContent_639": "总觉得大舌头是真的想把我奶没的",
    "messageInitContent_630": "说的我好像真的能喷火似的",
    "messageInitContent_631": "这里是指敌方怪兽还是我方怪兽",
    "messageInitContent_3732": "选它！",
    "messageInitNick_10325": "葡萄柚兽",
    "messageInitContent_3733": "(-ε(#-)☆╰╮o(-。-///) ",
    "messageInitNick_10326": "芦笋撞地球",
    "messageInitContent_3734": "恭迎ヽ(=ω= )ゝ社恐龙少爷！",
    "messageInitNick_10323": "无稽之谈",
    "messageInitContent_3735": "不要随便假定怪兽的性别",
    "messageInitNick_10324": "来份爱情保险",
    "messageInitContent_3736": "争取四次连续猜中",
    "messageInitNick_10329": "山穷群水尽",
    "messageInitContent_3737": "6啊啊啊",
    "messageInitContent_3738": "连错3天警告",
    "messageInitNick_10327": "茄子魔法",
    "messageInitContent_3739": "好耶",
    "messageInitNick_10328": "脱单片眼睛",
    "messageInitContent_643": "其实这些怪兽是怎么组队在一起的呢？",
    "messageInitContent_644": "如果我有镜子就可以赢了吗",
    "messageInitContent_645": "这个游戏的狸猫都被石化了！",
    "messageInitContent_646": "所以才没有狸猫吗",
    "messageInitContent_647": "这都被你们发现了，牛哇牛哇",
    "messageInitNick_10321": "不愿离去的爱",
    "messageInitContent_3740": "2个我打1个我",
    "messageInitContent_648": "为什么猛犸不上班？！！！",
    "messageInitNick_10322": "冷柜的碎片",
    "messageInitContent_3741": "这不是",
    "messageInitContent_649": "因为g-n吗？",
    "messageInitContent_3742": "一只龙和两只龙",
    "messageInitNick_10320": "道歉没用",
    "messageInitContent_640": "它可能只是太热情了！(¬､¬)",
    "messageInitContent_641": "美丽的蛇发女妖，美丽的，美丽的，美丽……",
    "messageInitContent_642": "突然发现这个场景的石头好像一只狸猫。",
    "messageInitContent_3743": "一只龙打架",
    "messageInitContent_3744": "一个人睡觉",
    "messageInitContent_3745": "一个人看电影",
    "messageInitContent_3746": "一个人吃饭",
    "messageInitContent_3747": "一个人旅行",
    "messageInitContent_3748": "逆向思维",
    "messageInitContent_3749": "一只龙的快乐你懂吗",
    "ancientGeneConfigName_33": "不可知球",
    "messageInitContent_654": "我想去二次元嘿嘿(•̅灬•̅ )",
    "ancientGeneConfigName_32": "百兽亲和",
    "messageInitContent_655": "一个个呜呜呜一个污污污",
    "ancientGeneConfigName_35": "沸体解放",
    "messageInitContent_656": "污污污污污污污污污",
    "ancientGeneConfigName_34": "神迹之足",
    "messageInitContent_657": "你们看到那个提示了吗？？？",
    "messageInitContent_3750": "龙龙我啊",
    "messageInitContent_658": "英雄能否出淤泥而不染呢",
    "messageInitContent_3751": "社——恐——power",
    "messageInitContent_659": "神只是力量强一点的凡人而已",
    "ancientGeneConfigName_31": "护盾扩散",
    "messageInitContent_3752": "建议单飞",
    "ancientGeneConfigName_30": "带电细胞",
    "messageInitContent_3753": "绝了",
    "ancientGeneConfigName_37": "绯红搏动",
    "messageInitContent_650": "比蒙巨兽凶猛了好多！",
    "ancientGeneConfigName_36": "火炎焱躯",
    "messageInitContent_651": "之前是懵兽，现在是猛兽。",
    "ancientGeneConfigName_39": "背律死苏",
    "messageInitContent_652": "技能可都是一样呢",
    "ancientGeneConfigName_38": "诡海亲和",
    "messageInitContent_653": "血条消失术！",
    "20_8": "主线任务",
    "20_7": "领取奖励",
    "20_6": "前往",
    "messageInitNick_10309": "电台主持人",
    "20_5": "探索者等级{1}解锁",
    "20_4": "已完成",
    "20_3": "未完成",
    "20_2": "优雅的引导！",
    "20_1": "近乎崩坏的引导",
    "messageInitContent_3754": "大脑读条中",
    "messageInitNick_10303": "水母公主",
    "messageInitContent_3755": "影分身？",
    "messageInitNick_10304": "海为谁蓝",
    "messageInitContent_3756": "我得了一种病，选择困难症",
    "messageInitNick_10301": "碧波粉莲",
    "messageInitContent_3757": "我选择原谅",
    "messageInitNick_10302": "伟大需要多言",
    "messageInitContent_3758": "我独自心碎",
    "messageInitNick_10307": "万能书",
    "messageInitContent_3759": "恐龙抗狼抗狼抗",
    "messageInitNick_10308": "井底之瓜",
    "messageInitNick_10305": "不想起昵称",
    "20_9": "玩法概览",
    "messageInitNick_10306": "极繁大师",
    "ancientGeneConfigName_44": "圣兽面",
    "messageInitContent_665": "零那个白色的是嘴巴吗？",
    "ancientGeneConfigName_43": "即灭",
    "messageInitContent_666": "什么居然是嘴巴",
    "ancientGeneConfigName_46": "归元圣痕",
    "messageInitContent_667": "我以前一直以为是裙子啊？！",
    "ancientGeneConfigName_45": "戏战谜物",
    "messageInitContent_3760": "恐龙抗狼恐龙抗狼恐龙抗狼",
    "messageInitContent_668": "说不定是鼻子！！！！！！",
    "ancientGeneConfigName_40": "深渊齿触",
    "messageInitContent_3761": "尸鬼打星灵哦",
    "messageInitContent_669": "既生大人何生小人",
    "messageInitContent_3762": "还有神灵",
    "messageInitNick_10300": "梨消灭者",
    "ancientGeneConfigName_42": "韧环",
    "messageInitContent_3763": "地上爬起的和天使砸下来的",
    "ancientGeneConfigName_41": "无敌愿祈",
    "messageInitContent_3764": "挺对称的嘛",
    "messageInitContent_1102": "这里个个都是人才，说话又好听",
    "messageInitContent_1101": "我见到你们也很高兴",
    "messageInitContent_1100": "又发生了什么？",
    "messageInitContent_660": "污妖王者技能和那个谁的技能相反呢",
    "ancientGeneConfigName_48": "裂韧环",
    "messageInitContent_661": "玻耳修斯你的美杜莎就在隔壁！",
    "ancientGeneConfigName_47": "特化铸具",
    "messageInitContent_662": "波尔修斯就在隔壁呢美杜莎莎",
    "messageInitContent_663": "可能就是零把美杜莎莎藏好了，所以隔壁的没找到。",
    "messageInitContent_664": "细思极恐",
    "messageInitContent_1109": "kb这样键鼠很容易坏掉的吧",
    "messageInitContent_1108": "珍宝和键盘侠梦幻联动！",
    "messageInitContent_1107": "狸猫君发现！",
    "messageInitContent_1106": "可以变成开心的肉酱",
    "messageInitContent_1105": "见到比蒙巨兽要怎么变得开心",
    "messageInitContent_1104": "希望大家开开心心",
    "messageInitContent_1103": "打工是不可能打工的，一辈子都不可能打工的。",
    "messageInitContent_3765": "我支持蓝色方",
    "messageInitNick_10358": "忧郁的暗夜",
    "messageInitContent_3766": "你们不要再打啦",
    "messageInitNick_10359": "潇洒行者",
    "messageInitContent_3767": "八朽对决",
    "messageInitNick_10356": "波涛很澎湃",
    "messageInitContent_3768": "给尸狂打call",
    "messageInitNick_10357": "疾驰的科尔鸭",
    "messageInitContent_3769": "举牌，呐喊",
    "messageInitContent_676": "那只狸猫好像是第5只怪兽。",
    "messageInitNick_10350": "麻烦要点脸",
    "messageInitContent_677": "我决定用同样的阵容打败它们",
    "messageInitNick_10351": "谢绝虚假",
    "messageInitContent_3770": "活着就是为了咒灭守护",
    "messageInitContent_678": "尸王的发型是不是中间秃了",
    "messageInitContent_3771": "私我告诉你的答案",
    "messageInitContent_679": "它秃了但它也变强了",
    "messageInitContent_3772": "种个向日葵",
    "messageInitNick_10354": "秋风落叶",
    "messageInitContent_3773": "我爱忧郁蘑",
    "messageInitNick_10355": "倔强的孩子",
    "messageInitContent_3774": "疯狂切后vs疯狂吸血回血",
    "messageInitNick_10352": "欧尼给",
    "messageInitContent_3775": "左看右看",
    "messageInitNick_10353": "纯情鸡精",
    "messageInitContent_1113": "你好古龙，我是金融。",
    "messageInitContent_1112": "古龙的jio是在蹬什么，好搞笑",
    "messageInitContent_1111": "现场代替kb侠接键盘鼠标代言",
    "messageInitContent_670": "武器四人组",
    "messageInitContent_1110": "就好像大家的武器一样，也是需要定期维护的",
    "messageInitContent_671": "镰刀有点像那个死神来敲门的表情",
    "messageInitContent_672": "这是制杖粗人和制杖兽人吧？",
    "messageInitContent_673": "你想说的是瘦人吧",
    "messageInitContent_674": "经费不足的阵容",
    "messageInitContent_675": "有一个究极还不够吗？",
    "messageInitContent_1119": "报告指挥没有见到可疑点",
    "messageInitContent_1118": "有人找到了吗！",
    "messageInitContent_1117": "快把它们找出来，把马赛克找出来！！",
    "messageInitContent_1116": "这里到底有什么值得马赛克的地方呢",
    "iapBuyConfigName_1203": "智者礼遇III",
    "messageInitContent_1115": "这里有两条光龙，那……",
    "iapBuyConfigName_1204": "智者礼遇IV",
    "messageInitContent_1114": "古龙没有理你，并像你吐了一口龙焰",
    "iapBuyConfigName_1201": "智者礼遇I",
    "messageInitContent_3776": "左瞅瞅右瞅瞅",
    "messageInitNick_10369": "未来叫兽",
    "iapBuyConfigName_1202": "智者礼遇II",
    "messageInitContent_3777": "不想努力了，蹲个答案",
    "messageInitContent_3778": "50%的概率",
    "messageInitNick_10367": "如果柚子会笑",
    "messageInitContent_3779": "早啊各位老铁",
    "messageInitNick_10368": "铁好人",
    "messageInitContent_687": "得向崩解领主请教一下健身技巧了",
    "messageInitNick_10361": "不许凶我",
    "messageInitContent_3780": "生存还是毁灭",
    "messageInitContent_688": "私以为那个并不需要什么技巧",
    "messageInitNick_10362": "智能饼干",
    "messageInitContent_3781": "我选钝角",
    "messageInitContent_689": "但需要注意事项。",
    "messageInitContent_3782": "思考了很久，决定吃个饭先",
    "messageInitNick_10360": "岸与海的距离",
    "messageInitContent_3783": "我就不信我赢不了",
    "messageInitNick_10365": "老头滚动力",
    "messageInitContent_3784": "幸运女神看看孩子",
    "messageInitNick_10366": "无敌战神",
    "messageInitContent_3785": "这是个问题",
    "messageInitNick_10363": "拉肠侦探",
    "messageInitContent_3786": "要坚强",
    "messageInitNick_10364": "最爱梨",
    "messageInitContent_1124": "它们互相保护的样子，好棒！",
    "messageInitContent_1123": "前有圣光古龙，后有钢铁龙王",
    "messageInitContent_680": "感觉没什么变化",
    "messageInitContent_1122": "这附近是有龙穴吗。",
    "messageInitContent_681": "那是当年很时髦的阴阳发型",
    "messageInitContent_1121": "这个游戏这么健全，居然想找马赛克？",
    "messageInitContent_682": "怪医黑杰克吗？",
    "messageInitContent_1120": "继续找，一块石头都不要放过！",
    "messageInitContent_683": "海上大战？诶",
    "messageInitContent_684": "搜魂兽真的好可爱啊啊啊啊",
    "messageInitContent_685": "怕被血溅到还带个小雨衣。",
    "messageInitContent_686": "死神也是要讲卫生的，好伐",
    "messageInitContent_1129": "无头骑士异闻录",
    "messageInitContent_1128": "大伙找出来！把金子都！",
    "messageInitContent_1127": "肯定是藏在附近！",
    "messageInitContent_1126": "这里附近只有市场",
    "messageInitContent_1125": "听说龙都喜欢住在那些有很多钱的地方",
    "messageInitContent_3787": "我要闹了",
    "messageInitNick_10336": "蘑菇之心",
    "messageInitContent_3788": "吸干你们的欧气",
    "messageInitNick_10337": "沉浸式绘画",
    "messageInitContent_3789": "我常常因为不够",
    "messageInitNick_10334": "勿挽旧人",
    "messageInitNick_10335": "眼影女孩",
    "messageInitNick_10338": "诺贝尔画饼奖",
    "messageInitNick_10339": "昵称过于强大",
    "messageInitContent_3790": "聪明的人已经选好了",
    "messageInitContent_698": "一开始我以为是指珍宝",
    "messageInitContent_3791": "想穿越到明天",
    "messageInitContent_699": "我想和珍宝握手（认真的）",
    "messageInitContent_3792": "提早2分钟猜，马上就能对答案",
    "messageInitContent_3793": "有点东西",
    "messageInitContent_3794": "神奇的骰子啊！告诉我答案吧左单右双",
    "messageInitNick_10332": "不是姐的菜",
    "messageInitContent_3795": "我来啦",
    "messageInitNick_10333": "到底是什么",
    "messageInitContent_3796": "现在我心态很好",
    "messageInitNick_10330": "懂之神",
    "messageInitContent_3797": "我有选择困难症",
    "messageInitNick_10331": "九天之主",
    "messageInitContent_1135": "点一首歌，断点。",
    "messageInitContent_690": "原来是狸猫混入龙群了吗？",
    "messageInitContent_1134": "说反了，是就算断点什么也很开心",
    "messageInitContent_691": "狸猫那个你过来，我保证不打你",
    "messageInitContent_1133": "这里的怪兽是不是总得断点什么才开心",
    "messageInitContent_692": "第一眼真的没发现扑佳鸟",
    "messageInitContent_1132": "钢铁龙王学会保护同伴，我哭死！",
    "messageInitContent_693": "跟着龙群飞是不是就可以找到龙的巢穴",
    "messageInitContent_1131": "我为钢铁龙帝打call！好帅！",
    "messageInitContent_694": "它可能是想当龙妈",
    "messageInitContent_1130": "无头骑士才不是这样的！",
    "messageInitContent_695": "我的笑容很可以，我可以当龙妈吗",
    "messageInitContent_696": "还要学习很多种其他姿势才行。",
    "messageInitContent_697": "一开始我还不懂，直到我打到第二关",
    "messageInitContent_1139": "隔壁好像是星灵族的探索点是吧。",
    "messageInitContent_1138": "龙炎 ，有龙炎它就高兴没毛病。",
    "messageInitContent_1137": "还有哪哪都有它的炎之高兴",
    "messageInitContent_1136": "这是龙的丘陵啊，到处都是龙呢。",
    "messageInitContent_3798": "现在我要开始叫了",
    "messageInitNick_10347": "草莓需要休息",
    "messageInitContent_3799": "白虎vs朱雀",
    "messageInitNick_10348": "回锅肉",
    "messageInitNick_10345": "冠萼花楸",
    "messageInitNick_10346": "原始的桃子",
    "messageInitNick_10349": "种田这件事",
    "messageInitNick_10340": "草莓少女心",
    "messageInitNick_10343": "真的无坑",
    "messageInitNick_10344": "光明源于黑暗",
    "messageInitNick_10341": "纯情麦芽糖",
    "messageInitNick_10342": "南天一大柱",
    "messageInitContent_1146": "那天我仍未知道危险的草丛是什么品种的草的事",
    "messageInitContent_1145": "由于太怕吵了所以学会了让队友闭嘴",
    "messageInitContent_1144": "关于我转生成为怪兽的这件事",
    "messageInitContent_1143": "关卡标题也要够长的对吧",
    "messageInitContent_1142": "一堆星灵深入龙穴，害怕。",
    "messageInitContent_1141": "你人真好。",
    "messageInitContent_1140": "对的在那边。指",
    "messageInitNick_10394": "梅川歪淘",
    "messageInitNick_10395": "眉笔道人",
    "messageInitNick_10392": "咖喱哇哦",
    "messageInitNick_10393": "撩妹界扛把子",
    "messageInitNick_10398": "我也是学生",
    "messageInitNick_10399": "超能少年",
    "messageInitNick_10396": "电子夹心糖",
    "messageInitNick_10397": "呆萌小姐",
    "messageInitNick_10390": "腰椎别突出",
    "messageInitNick_10391": "霸气姑凉",
    "messageInitNick_10378": "给沙发按摩",
    "messageInitNick_10379": "退役潜水选手",
    "messageInitNick_10372": "月白釉紫斑盆",
    "messageInitNick_1196": "独霸一棵草",
    "messageInitNick_10373": "摸鱼的艺术",
    "messageInitNick_1197": "把温柔当爱",
    "messageInitNick_10370": "星球女巫",
    "messageInitNick_1194": "爱似洪钟",
    "messageInitNick_10371": "无公害菠菜",
    "messageInitNick_1195": "超级打脸神",
    "messageInitNick_10376": "吃梦兽",
    "messageInitNick_10377": "荷兰垂耳兔",
    "messageInitNick_10374": "误闯桃源",
    "messageInitNick_1198": "嘴比油田油",
    "messageInitNick_10375": "大叔借点白菜",
    "messageInitNick_1199": "好奇怪妹妹",
    "messageInitNick_10389": "普通法老王",
    "messageInitNick_1192": "小懒猪",
    "messageInitNick_1193": "梧桐听雨",
    "messageInitNick_1190": "机场里的野猪",
    "messageInitNick_1191": "鸭梨山大",
    "messageInitNick_10383": "冷冻柜之彼端",
    "messageInitNick_1185": "亲爱滴它亲我",
    "messageInitNick_10384": "咸鱼冲锋",
    "messageInitNick_1186": "强壮恰瓜神",
    "messageInitNick_10381": "我这就来",
    "messageInitNick_1183": "单枪浪情场",
    "messageInitNick_10382": "上午摘下午发",
    "messageInitNick_1184": "实力见发量",
    "messageInitNick_10387": "海那边是自由",
    "messageInitNick_1189": "雅痞",
    "messageInitNick_10388": "电视机的尽头",
    "messageInitNick_10385": "公司饭堂阿姨",
    "messageInitNick_1187": "斜月三星",
    "messageInitNick_10386": "行走的棒棒糖",
    "messageInitNick_1188": "大猫咪",
    "messageInitNick_10380": "半夜成仙",
    "messageInitNick_1181": "和花一样痴",
    "messageInitNick_1182": "靠谱男青年",
    "messageInitNick_1180": "今天吃饼了吗",
    "messageInitNick_1174": "爱情这场戏",
    "messageInitNick_1175": "吉他猪",
    "messageInitNick_1172": "煮茶男",
    "messageInitNick_1173": "东方苍狼",
    "messageInitNick_1178": "笨蛋先森",
    "messageInitNick_1179": "一饮山河尽",
    "messageInitNick_1176": "格式化爱情",
    "messageInitNick_1177": "大苹果猪猪",
    "messageInitNick_1170": "呆萌少女",
    "messageInitNick_1171": "回收孤单",
    "messageInitNick_1163": "茶楼淑女",
    "messageInitNick_1164": "空白页",
    "messageInitNick_1161": "风雅中带野",
    "messageInitNick_1162": "今日小雨转甜",
    "messageInitNick_1167": "草莓棉花糖",
    "messageInitNick_1168": "短腿猫不吃鱼",
    "messageInitNick_1165": "喝水都呛着",
    "messageInitNick_1166": "会思考的猪",
    "messageInitNick_1169": "脑洞太大",
    "messageInitContent_3707": "美杜莎莎看看我",
    "messageInitContent_3708": "什么都冲只会害了你",
    "messageInitContent_3709": "前排卖脑子",
    "messageInitContent_3700": "如果今天不用加班我就选右边",
    "messageInitContent_3701": "oioi",
    "messageInitContent_3702": "求当代人的精神状态",
    "messageInitContent_3703": "我命令你们告诉我答案",
    "messageInitContent_3704": "如果猜赢了我就去表白",
    "messageInitNick_1160": "当祖宗",
    "messageInitContent_3705": "选左边相信我！",
    "messageInitContent_3706": "选右边信我",
    "messageInitNick_1152": "落荒而逃的王",
    "messageInitNick_1153": "空中的繁星",
    "messageInitNick_1150": "救救床垫",
    "messageInitNick_1151": "咕咕神",
    "messageInitNick_1156": "今天又破防了",
    "messageInitNick_1157": "得瑟的小情绪",
    "messageInitNick_1154": "傲娇小青年",
    "messageInitNick_1155": "拖油瓶",
    "messageInitNick_1158": "浑身难瘦",
    "messageInitNick_1159": "拾梦人",
    "messageInitContent_3718": "很内向，迟到都不敢出门上班",
    "messageInitContent_3719": "拒绝尬聊",
    "messageInitContent_3710": "蹲个答案",
    "messageInitContent_3711": "能不能来个大佬分析一波",
    "messageInitContent_3712": "一顿分析猛如虎 结果猜错了",
    "messageInitContent_3713": "2只社恐龙难道打不过1只？",
    "messageInitContent_3714": "建议出一只社牛怪兽",
    "messageInitContent_3715": "i人路过",
    "messageInitContent_3716": "给你们看看社恐power！",
    "messageInitContent_3717": "关卡搭子",
    "messageInitNick_1141": "赠你繁花",
    "messageInitNick_1142": "人间口胡哥",
    "messageInitNick_1140": "抽风中请勿扰",
    "messageInitNick_1145": "敢抢我辣条",
    "messageInitNick_1146": "晴天娃娃",
    "messageInitNick_1143": "干饭神",
    "messageInitContent_3720": "我知道赢的一定是社恐龙",
    "messageInitNick_1144": "你别急我先急",
    "messageInitNick_1149": "青丝一夜走",
    "messageInitNick_1147": "懒癌早期",
    "messageInitNick_1148": "定格你的美",
    "96_HallOfOrigin": "起源殿",
    "messageInitNick_1130": "破防女神",
    "messageInitNick_3793": "复杂黑涩",
    "messageInitNick_1131": "古董小姐",
    "messageInitNick_3792": "怀旧的照片",
    "messageInitNick_3791": "猫咪绿光",
    "messageInitNick_3790": "萝卜真好吃",
    "messageInitNick_1134": "凌晨独舞",
    "messageInitNick_3797": "迷路的花瓶",
    "messageInitNick_1135": "吃瓜之王",
    "messageInitNick_3796": "专业引战",
    "messageInitNick_1132": "敢不敢喜欢我",
    "messageInitNick_3795": "访客权限不足",
    "messageInitNick_1133": "白云味棉花糖",
    "messageInitNick_3794": "他的狗",
    "messageInitNick_1138": "手机痛击鼻梁",
    "messageInitNick_1139": "诺贝尔暴富奖",
    "messageInitNick_1136": "单恋一朵花",
    "messageInitNick_3799": "激情牛排",
    "messageInitNick_1137": "爱情特殊感应",
    "messageInitNick_3798": "懒散的书虫",
    "messageInitNick_3782": "你大佬",
    "messageInitNick_1120": "未谱完的曲",
    "messageInitNick_3781": "擦不去的爱",
    "messageInitNick_3780": "飞行书馆",
    "messageInitNick_1123": "葬海花魂",
    "messageInitNick_3786": "稀饭你的笑",
    "messageInitNick_1124": "地狱的天使",
    "messageInitNick_3785": "兴奋的麦克风",
    "messageInitNick_1121": "爱情独家发行",
    "messageInitNick_3784": "快递员",
    "messageInitNick_1122": "妲己的乌鸡汤",
    "messageInitNick_3783": "最爱橙子",
    "messageInitNick_1127": "黑白颠倒",
    "messageInitNick_1128": "刹那春秋",
    "messageInitNick_3789": "骷髅控",
    "messageInitNick_1125": "复仇幻影",
    "messageInitNick_3788": "核动力打蛋器",
    "messageInitNick_1126": "绝版好男人",
    "messageInitNick_3787": "迷路的髌骨",
    "messageInitNick_1129": "喋血影魔",
    "messageInitNick_3771": "摸摸它狗头",
    "messageInitNick_3770": "唱一曲作罢",
    "mapNodeName_998": "巨化噩梦",
    "messageInitNick_1112": "很认真的人",
    "messageInitNick_3775": "梨真好吃",
    "mapNodeName_999": "久远之日",
    "messageInitNick_1113": "岸与海的距离",
    "messageInitNick_3774": "吃瓜门首席",
    "mapNodeName_996": "福报",
    "messageInitNick_1110": "挂号思念",
    "messageInitNick_3773": "天堂马铃薯",
    "mapNodeName_997": "恐怖故事",
    "messageInitNick_1111": "无浆靠浪",
    "messageInitNick_3772": "风云无邪",
    "messageInitNick_1116": "又菜又自信",
    "messageInitNick_3779": "打小就酷",
    "messageInitNick_1117": "封刀战魔",
    "messageInitNick_3778": "认证划水专家",
    "messageInitNick_1114": "厕所读物",
    "messageInitNick_3777": "从陌路到末路",
    "messageInitNick_1115": "跑调之王",
    "messageInitNick_3776": "叉叉狂粉",
    "messageInitNick_1118": "打团了快来",
    "messageInitNick_1119": "嗷小喵",
    "messageInitNick_3760": "骰骨",
    "messageInitNick_1101": "宝贝对不起",
    "messageInitNick_3764": "种田这件事",
    "messageInitNick_1102": "长眠于风",
    "messageInitNick_3763": "丑得拖网速",
    "messageInitNick_3762": "跑出地球",
    "messageInitNick_1100": "此生不遇",
    "messageInitNick_3761": "漱口杯先锋",
    "messageInitNick_1105": "那你不早说",
    "messageInitNick_3768": "抠脚女神",
    "messageInitNick_1106": "霸道哥气质哥",
    "messageInitNick_3767": "跑五百米如厕",
    "messageInitNick_1103": "恶魔尊主",
    "messageInitNick_3766": "超时空电磁炉",
    "messageInitNick_1104": "从小帅到大",
    "messageInitNick_3765": "尖叫杨桃",
    "messageInitNick_1109": "到我怀里来",
    "messageInitNick_1107": "提线木偶",
    "messageInitNick_1108": "东皇太一般",
    "messageInitNick_3769": "依然爆可爱",
    "messageInitNick_3753": "手空空",
    "messageInitNick_3752": "暴走的火",
    "messageInitNick_3751": "爷超凶",
    "messageInitNick_3750": "如果石榴会笑",
    "messageInitNick_3757": "二号主角",
    "messageInitNick_3756": "绝对创新",
    "messageInitNick_3755": "白衣画丹青",
    "messageInitNick_3754": "平板的尽头",
    "messageInitNick_3759": "苹果龙",
    "messageInitNick_3758": "撑伞的鱼",
    "messageInitNick_3742": "逆境中的榴莲",
    "messageInitNick_3741": "洗衣液狂怒者",
    "messageInitNick_3740": "单纯小暧昧",
    "messageInitNick_3746": "人类最高质量",
    "messageInitNick_3745": "唐伯虎点蚊香",
    "messageInitNick_3744": "威我五十",
    "messageInitNick_3743": "爱的末路",
    "messageInitNick_3749": "网课大师",
    "messageInitNick_3748": "擦不完的杯子",
    "messageInitNick_3747": "飞天河豚",
    "messageInitNick_3731": "倒转时间",
    "messageInitNick_3730": "神秘大神",
    "messageInitNick_3735": "茄子侠",
    "messageInitNick_3734": "无语披萨",
    "messageInitNick_3733": "尖叫橙子",
    "messageInitNick_3732": "解密香蕉",
    "messageInitNick_3739": "大梦想家",
    "messageInitNick_3738": "葬送的魔鬼",
    "messageInitNick_3737": "流年染指悲伤",
    "messageInitNick_3736": "最远的距离",
    "messageInitNick_3729": "穿越去水底",
    "messageInitNick_3720": "自家电视",
    "messageInitNick_3724": "吉他少年",
    "messageInitNick_3723": "灰白色的回想",
    "messageInitNick_3722": "神秘猕猴桃",
    "messageInitNick_3721": "狂龙",
    "messageInitNick_3728": "番茄真好吃",
    "messageInitNick_3727": "再生纸张",
    "messageInitNick_3726": "真唱打败假唱",
    "messageInitNick_3725": "在线申请对象",
    "messageInitNick_3719": "还在内卷",
    "messageInitNick_3718": "订阅微笑",
    "messageInitContent_1149": "我的青春打工生活果然没有问题",
    "messageInitContent_1148": "身为高中生的我兼网红的我正在被年级比我大的同学兼职vtuber的家伙拉住脖子",
    "messageInitContent_1147": "在怪兽世界寻找邂逅是不是搞错了什么",
    "mapNodeName_940": "3号位是谁",
    "mapNodeName_936": "裂口诡偶",
    "mapNodeName_937": "狞笑█海",
    "mapNodeName_934": "等级恐怖故事",
    "mapNodeName_935": "无名主城",
    "mapNodeName_932": "诡潮之门",
    "mapNodeName_933": "无名荒野",
    "mapNodeName_930": "巨大航道",
    "mapNodeName_931": "巨炎之地",
    "messageInitContent_1157": "成龙？",
    "messageInitNick_3713": "刷新回忆",
    "messageInitContent_1156": "我也觉得把女孩子看成龙更好！",
    "messageInitNick_3712": "海底仙人",
    "messageInitContent_1155": "只要诚心诚意！",
    "messageInitNick_3711": "刀魂使者",
    "messageInitContent_1154": "我想学把女孩子看成龙的技能！",
    "messageInitNick_3710": "霸气爷",
    "messageInitContent_1153": "这个把龙看成女孩子的技能哪里可以学",
    "messageInitNick_3717": "李子去哪了",
    "messageInitContent_1152": "听说喜欢龙的可以把龙看做女孩子",
    "messageInitNick_3716": "结局却一个人",
    "mapNodeName_938": "复活",
    "messageInitContent_1151": "龙癌福音",
    "messageInitNick_3715": "海王",
    "mapNodeName_939": "3号位是谁",
    "messageInitContent_1150": "果然这里好多龙！",
    "messageInitNick_3714": "菠萝先锋",
    "messageInitNick_3709": "搬砖观察员",
    "messageInitNick_3708": "被优化人员",
    "messageInitNick_3707": "朱雀网卡",
    "messageInitContent_1159": "这个组合是不是之前见过？",
    "messageInitContent_1158": "来回变多香呢",
    "mapNodeName_950": "终生充血",
    "mapNodeName_951": "随机跃迁",
    "mapNodeName_947": "无名荒野",
    "messageInitContent_1160": "都是错觉而已，你没有见过啦！",
    "mapNodeName_948": "肉食兔子",
    "mapNodeName_945": "狞笑之海",
    "mapNodeName_946": "██之海",
    "mapNodeName_943": "3号位是谁",
    "mapNodeName_944": "3号位是谁",
    "mapNodeName_941": "3号位是谁",
    "mapNodeName_942": "3号位是谁",
    "messageInitContent_1168": "莎士彼亚会不会写歌呢",
    "messageInitNick_3702": "很傻很天真",
    "messageInitContent_1167": "听说大舌怪会写歌",
    "messageInitNick_3701": "一只肥狗",
    "messageInitContent_1166": "呐，我都说红唇的衣服和污妖王的很像",
    "messageInitNick_3700": "只爱背带裤",
    "messageInitContent_1165": "原来祖拉才是最大赢家。",
    "messageInitContent_1164": "叉叉看来还需要努力呢",
    "messageInitNick_3706": "反重力拖鞋",
    "messageInitContent_1163": "懂了，原来呜呜祖拉就是幼体卷王。",
    "messageInitNick_3705": "地瓜暖男",
    "mapNodeName_949": "无名荒野",
    "messageInitContent_1162": "来到幻化，不朽，觉醒的世界！",
    "messageInitNick_3704": "外星暖水壶",
    "messageInitContent_1161": "为什么其他幼体不能像祖拉一样学习一下。",
    "messageInitNick_3703": "愁心分两半",
    "messageInitContent_1169": "有没有可能它们穿的是同一件衣服。",
    "mapNodeName_914": "冥土",
    "messageInitContent_1171": "那种关系是哪种关系！",
    "mapNodeName_915": "巨骸之地",
    "messageInitContent_1170": "难道说，它们之间是那种关系",
    "mapNodeName_912": "拳头大",
    "mapNodeName_913": "巨骸之地",
    "mapNodeName_910": "无限大",
    "mapNodeName_911": "巨骸之地",
    "messageInitContent_1179": "别提那恶心的玩意！",
    "messageInitContent_1178": "豹皮匠四舍五入也是猫咪",
    "messageInitContent_1177": "因为猫猫怪会说话！",
    "messageInitContent_1176": "为什么没有猫猫怪！",
    "mapNodeName_918": "大天使",
    "messageInitContent_1175": "给我猫猫！",
    "mapNodeName_919": "崩坠传送门II",
    "messageInitContent_1174": "我想要猫猫！",
    "mapNodeName_916": "巨骸之地",
    "messageInitContent_1173": "什么意思，到底是打还是不打。",
    "mapNodeName_917": "巨沼",
    "messageInitContent_1172": "大家到时候可以看看莎士彼亚的报告哈哈哈。",
    "mapNodeName_925": "大号幻想",
    "messageInitContent_1182": "会不是是因为你对今次鸟的讨厌变成的错觉",
    "mapNodeName_926": "巨骸之地",
    "messageInitContent_1181": "然后一jiojio踢到今次鸟身上！",
    "mapNodeName_923": "大大的贴贴",
    "messageInitContent_1180": "只有我一个人觉得吗？钢龙的尾巴好像jio",
    "messageInitContent_700": "蜻蜓龙的小尾巴也不错",
    "mapNodeName_924": "巨炎之地",
    "messageInitContent_701": "小心永腐魔",
    "mapNodeName_921": "巨炎之地",
    "messageInitContent_702": "怪不得没有怪兽出现在背后哈哈哈哈",
    "mapNodeName_922": "巨炎之地",
    "messageInitContent_703": "敌人都是在正面的，光！明！正！大！",
    "messageInitContent_704": "又是你们！",
    "mapNodeName_920": "巨炎之地",
    "messageInitContent_705": "还真的又是你们！",
    "messageInitContent_1189": "是时候想想5号位要放什么怪兽了。",
    "messageInitContent_1188": "自信点吧好像去掉",
    "messageInitContent_1187": "我好像看到一只没见过的怪！",
    "mapNodeName_929": "巨骸之地",
    "messageInitContent_1186": "我们将飞往何方！",
    "messageInitContent_1185": "打这只坏鸟！",
    "mapNodeName_927": "FANTASY!",
    "messageInitContent_1184": "而且还是疯狂的脚掌攻击",
    "mapNodeName_928": "壮兽",
    "messageInitContent_1183": "我也觉得把女孩子看成龙更好！",
    "mapNodeName_983": "地底掘█者",
    "messageInitContent_706": "血太多血太少都不好。",
    "mapNodeName_984": "无名荒野",
    "messageInitContent_707": "我的白虎呢！把它抬过来",
    "mapNodeName_981": "呢喃的觉醒",
    "messageInitContent_708": "在它们解决掉怪兽之前把它们解决掉就好了。",
    "mapNodeName_982": "狞笑█海",
    "messageInitContent_709": "想拿过来用",
    "mapNodeName_980": "古记战役-真实幻觉",
    "messageInitContent_1193": "这样1换1值得吗！",
    "messageInitContent_1192": "对面也是一样的",
    "messageInitContent_710": "这些怪可以收集的吗？",
    "mapNodeName_978": "妖风",
    "messageInitContent_1191": "但这样就天然少一只了",
    "messageInitContent_711": "战斗力高的租房会便宜点吗？",
    "mapNodeName_979": "冥龙之影",
    "messageInitContent_1190": "死的最快的如何哈哈",
    "messageInitContent_712": "钢铁龙王是不是不一样了？",
    "mapNodeName_976": "诡潮集市",
    "messageInitContent_713": "5不朽了！",
    "mapNodeName_977": "恶寒",
    "messageInitContent_714": "它是怎么知道战斗力最高的怪兽是哪一只的？！",
    "mapNodeName_974": "不可抗力",
    "messageInitContent_715": "见闻色霸气大概",
    "mapNodeName_975": "无限轮█",
    "messageInitContent_716": "是圆！",
    "messageInitContent_1199": "求你们别刷狸猫了好吗",
    "messageInitContent_1198": "真的见过小狸猫就回不去了！",
    "messageInitContent_1197": "你好小狸猫，又见面了",
    "messageInitContent_1196": "好diao~~~",
    "messageInitContent_1195": "我为诗狂！",
    "messageInitContent_1194": "尸狂，它好帅！",
    "mapNodeName_994": "蠕行的混沌",
    "messageInitContent_717": "可能就是单纯的战斗经验。",
    "mapNodeName_995": "血宴",
    "messageInitContent_718": "这个阵容，我给……几分呢",
    "mapNodeName_992": "无██野",
    "messageInitContent_719": "居然是lady first",
    "mapNodeName_993": "无名█夜",
    "mapNodeName_990": "制杖仪式",
    "mapNodeName_991": "无名荒野",
    "messageInitContent_720": "好像确实没有毛病",
    "messageInitContent_721": "那可是肉盾呢！",
    "mapNodeName_989": "█鸣荒野",
    "messageInitContent_722": "凶噬魔的舌头我总是看歪，只有我一个吗？",
    "messageInitContent_723": "不，你不是一个人",
    "mapNodeName_987": "无名█野",
    "messageInitContent_724": "嘿嘿嘿，看成什么了？",
    "mapNodeName_988": "昼魔",
    "messageInitContent_725": "音乐总能被归为三要素，乐器、态度和听众。至于我嘛，我有乐器，我有态度，只要我能拥有第三个.......",
    "mapNodeName_985": "树",
    "messageInitContent_726": "是赛博朋克2020",
    "mapNodeName_986": "有翼死神",
    "messageInitContent_727": "还是学习下珍宝，一直被人抬着撞都保持笑容",
    "mapNodeName_961": "笼中幻梦",
    "messageInitContent_728": "难道不是学习一下它一直都那么硬挺",
    "mapNodeName_962": "荆魂未定",
    "messageInitContent_729": "前方小火车进站",
    "mapNodeName_960": "背后有怪",
    "mapNodeName_958": "诡异怪坛",
    "messageInitContent_731": "我的麒麟呢我的麒麟",
    "mapNodeName_959": "肉肉山",
    "messageInitContent_732": "4管大炮！",
    "mapNodeName_956": "无名荒野",
    "messageInitContent_733": "6管吧！",
    "mapNodeName_957": "草丛背后",
    "messageInitContent_734": "求圣堂武士现在心里的阴影面积？",
    "mapNodeName_954": "邪恶沼泽",
    "messageInitContent_735": "立个flag我要完美通关！",
    "mapNodeName_955": "狞笑█海",
    "messageInitContent_736": "老子的意大利炮呢？",
    "mapNodeName_952": "污秽█王",
    "messageInitContent_737": "开炮！",
    "mapNodeName_953": "无██野",
    "messageInitContent_738": "给我拉出来！",
    "messageInitContent_730": "决杀零式的封印更强了。",
    "mapNodeName_972": "漆黑世界",
    "messageInitContent_739": "妖火和凶噬魔的都不错",
    "mapNodeName_973": "盒中梦",
    "mapNodeName_970": "头",
    "mapNodeName_971": "瓶中妖",
    "mapNodeName_969": "无名██",
    "messageInitContent_742": "波尔修斯手上那个是什么？",
    "messageInitContent_743": "美杜莎",
    "mapNodeName_967": "怪声",
    "messageInitContent_744": "害怕！",
    "mapNodeName_968": "无名荒野",
    "messageInitContent_745": "惊了",
    "mapNodeName_965": "诡潮传送门I",
    "messageInitContent_746": "一个可以死远点，现在来3只",
    "mapNodeName_966": "█名荒野",
    "messageInitContent_747": "还真是此路不通各种（意义上",
    "mapNodeName_963": "黄衣之兽",
    "messageInitContent_748": "你不要过来啊~~~",
    "mapNodeName_964": "异界█送",
    "messageInitContent_749": "为什么要这么急着火化",
    "messageInitContent_740": "妖火请死远点",
    "messageInitContent_741": "怎么才可以成为神的宠儿？",
    "messageInitContent_3842": "迷茫",
    "messageInitContent_3843": "吃惊",
    "messageInitContent_3844": "叉叉都进化了其他小强呢",
    "messageInitContent_3845": "广东小强前来助威",
    "messageInitContent_3846": "广东蟑螂很担心你",
    "messageInitContent_3847": "并做了顿粤菜安慰你",
    "messageInitContent_3848": "撒娇娇",
    "tribeNodeConfigName_111": "海螺遗迹46",
    "messageInitContent_3849": "各位帅哥早上好！",
    "tribeNodeConfigName_110": "海螺遗迹45",
    "messageInitContent_753": "那我到底是听众还是食物",
    "tribeNodeConfigName_113": "海螺遗迹48",
    "messageInitContent_754": "可能都是。",
    "tribeNodeConfigName_112": "海螺遗迹47",
    "messageInitContent_755": "请大家提前学习餐桌礼仪。",
    "tribeNodeConfigName_115": "海螺遗迹50",
    "messageInitContent_756": "吃饭不能打架！",
    "tribeNodeConfigName_114": "海螺遗迹49",
    "messageInitContent_757": "也不可以吸血",
    "tribeNodeConfigName_117": "巨鲸遗迹2",
    "messageInitContent_3850": "在想了在想了",
    "messageInitContent_758": "不，我相信这里一定是有什么好吃的！",
    "tribeNodeConfigName_116": "巨鲸遗迹1",
    "messageInitContent_3851": "赢了",
    "messageInitContent_759": "米其林三凶噬魔认证",
    "tribeNodeConfigName_119": "巨鲸遗迹4",
    "messageInitContent_3852": "命运的齿轮开始转动",
    "tribeNodeConfigName_118": "巨鲸遗迹3",
    "messageInitContent_750": "艺术就是爆炸！",
    "messageInitContent_751": "艺术就是派大星！",
    "messageInitContent_752": "能不能别自爆，好好活下去啊！（震声）（/･^･)/ ",
    "21_7": "上次登录：",
    "21_6": "已有角色",
    "21_5": "服务器列表",
    "21_4": "进入游戏",
    "21_3": "新",
    "21_2": "预估时间：{1}",
    "21_1": "维护中",
    "messageInitContent_3853": "快把我的生可乐给选手端上去",
    "messageInitNick_10204": "在线接单",
    "messageInitContent_3854": "如果你也和我一样，又猜错了，那就泰裤辣！",
    "messageInitNick_10205": "播放着悲伤",
    "messageInitContent_3855": "我梵梵呢",
    "messageInitNick_10202": "五个观众",
    "messageInitContent_3856": "黑丝必胜！！",
    "messageInitNick_10203": "金刚陵",
    "messageInitContent_3857": "这输出最后能大于治疗和减伤吗",
    "messageInitNick_10208": "奉旨搞事",
    "messageInitContent_3858": "蓝色输出拉满",
    "messageInitNick_10209": "常悠哉大王",
    "21_9": "畅通",
    "messageInitContent_3859": "赢的一定是龙族",
    "messageInitNick_10206": "玻璃假面爱人",
    "tribeNodeConfigName_100": "海螺遗迹35",
    "21_8": "维护",
    "messageInitNick_10207": "生菜魔法",
    "messageInitContent_764": "不能",
    "tribeNodeConfigName_102": "海螺遗迹37",
    "messageInitContent_765": "妈耶好大只蟑螂",
    "tribeNodeConfigName_101": "海螺遗迹36",
    "messageInitContent_766": "你是想说螳螂？",
    "tribeNodeConfigName_104": "海螺遗迹39",
    "messageInitContent_767": "面具底下的你倒是是怎样的呢。",
    "tribeNodeConfigName_103": "海螺遗迹38",
    "messageInitContent_3860": "又被你懂了",
    "messageInitContent_768": "我猜是齿轮之类的东西吧。",
    "messageInitNick_10200": "打不过张飞",
    "tribeNodeConfigName_106": "海螺遗迹41",
    "messageInitContent_3861": "Huh",
    "messageInitContent_769": "到底是先有麒麟还是先有木偶族",
    "messageInitNick_10201": "初号机没电了",
    "tribeNodeConfigName_105": "海螺遗迹40",
    "messageInitContent_3862": "私信我告诉你的谁赢",
    "tribeNodeConfigName_108": "海螺遗迹43",
    "messageInitContent_3863": "你们正常点我害怕",
    "tribeNodeConfigName_107": "海螺遗迹42",
    "messageInitContent_1201": "龙度下降！",
    "messageInitContent_1200": "快来试试尸狂的新霸气！",
    "tribeNodeConfigName_109": "海螺遗迹44",
    "messageInitContent_760": "我总觉得这龙王要生了",
    "messageInitContent_761": "肚子这么圆一定是……条龙吧",
    "messageInitContent_762": "龙到中年，肚子开始撑不住了。",
    "messageInitContent_763": "如果我有火炕我转生到这里能活久一点吗",
    "messageInitContent_1209": "英雄也只能给祖拉当前排。",
    "messageInitContent_1208": "仍然是稳稳站在中间位置的呜呜祖拉！",
    "messageInitContent_1207": "爱护珍宝人人有责。",
    "messageInitContent_1206": "为什么可以这么残忍。居然这样对珍宝",
    "messageInitContent_1205": "看我一下子把大家的珍宝大飞",
    "messageInitContent_1204": "珍宝也是无处不在呢",
    "messageInitContent_1203": "珍宝珍宝你的大家的珍宝",
    "messageInitContent_1202": "蜻蜓龙也是龙（？",
    "messageInitContent_3864": "欢迎来到龙场",
    "messageInitContent_3865": "我是龙场主",
    "messageInitContent_3866": "一切随缘吧",
    "messageInitContent_3867": "只选我喜欢的那边",
    "messageInitContent_3868": "肯定是有奶的那边赢",
    "tribeNodeConfigName_131": "巨鲸遗迹16",
    "messageInitContent_3869": "输出就是最好的防守",
    "tribeNodeConfigName_130": "巨鲸遗迹15",
    "tribeNodeConfigName_133": "巨鲸遗迹18",
    "tribeNodeConfigName_132": "巨鲸遗迹17",
    "98_-30007": "该元核已镶嵌",
    "messageInitContent_775": "前面是星辰大海",
    "tribeNodeConfigName_135": "巨鲸遗迹20",
    "98_-30006": "非法元核ID",
    "messageInitContent_776": "毁灭巨像有多少条锁链，别数，速答",
    "tribeNodeConfigName_134": "巨鲸遗迹19",
    "98_-30009": "该元核已鉴定",
    "messageInitContent_777": "7条",
    "tribeNodeConfigName_137": "巨鲸遗迹22",
    "98_-30008": "该元核未镶嵌",
    "messageInitContent_3870": "根据先几天的结果，我觉得该到右边了",
    "messageInitContent_778": "肯定是数过吧",
    "tribeNodeConfigName_136": "巨鲸遗迹21",
    "98_-30003": "非法元核品质",
    "messageInitContent_3871": "不愧是你",
    "messageInitContent_779": "感觉做家务很方便",
    "tribeNodeConfigName_139": "巨鲸遗迹24",
    "98_-30002": "非法阶级",
    "messageInitContent_3872": "今天也要猜对哦",
    "tribeNodeConfigName_138": "巨鲸遗迹23",
    "98_-30005": "cjhwy2",
    "messageInitContent_3873": "我选择苦难症又来了",
    "98_-30004": "非法元核等级与阶段",
    "messageInitContent_3874": "如果今天我表白成功我就让对象帮我选",
    "messageInitContent_1212": "尾巴可以踢球的吗？",
    "messageInitContent_1211": "所里这里谁是前锋吗？",
    "98_-30001": "非法等级",
    "messageInitContent_1210": "这里只有1龙。",
    "messageInitContent_770": "救命我怕蛇",
    "messageInitContent_771": "别怕，它们只会石化不会咬人",
    "messageInitContent_772": "什么蛇都是地龙",
    "messageInitContent_773": "想说蚯蚓是吧",
    "messageInitContent_774": "又想封我技能。",
    "messageInitContent_1219": "哈哈哈哈哈哈啊哈哈哈，",
    "messageInitContent_1218": "召唤龙妈，请问龙是怎么叫的",
    "messageInitContent_1217": "龙是那么叫的吗？",
    "messageInitContent_1216": "龙之谷，嗷呜~",
    "messageInitContent_1215": "还真是每一关都有一条龙。",
    "messageInitContent_1214": "一切请交给超进化足球协会解释。",
    "messageInitContent_1213": "翅膀可以踢球的吗？",
    "messageInitContent_3875": "等一个心动的答案",
    "messageInitContent_3876": "胡乱分析",
    "messageInitContent_3877": "分析不出来",
    "messageInitContent_3878": "慌张分析",
    "messageInitContent_3879": "盲目分析",
    "tribeNodeConfigName_120": "巨鲸遗迹5",
    "tribeNodeConfigName_122": "巨鲸遗迹7",
    "tribeNodeConfigName_121": "巨鲸遗迹6",
    "98_-30018": "非法主属性",
    "messageInitContent_786": "龙破斩——",
    "tribeNodeConfigName_124": "巨鲸遗迹9",
    "98_-30017": "非法宿命属性",
    "messageInitContent_787": "我不要变菜啊~~",
    "tribeNodeConfigName_123": "巨鲸遗迹8",
    "messageInitContent_3880": "为什么没有c",
    "messageInitContent_788": "我好菜啊",
    "tribeNodeConfigName_126": "巨鲸遗迹11",
    "98_-30019": "当前元核强化等级受限，请提升探索者等级后再试",
    "messageInitContent_3881": "歪，这题我不会",
    "messageInitContent_789": "我菜但我卷但还是很菜",
    "tribeNodeConfigName_125": "巨鲸遗迹10",
    "98_-30014": "元核进阶次数受限，请提升探索者等级后再试",
    "messageInitContent_3882": "气氛组报道",
    "tribeNodeConfigName_128": "巨鲸遗迹13",
    "98_-30013": "原石不足，无法锁定元核属性",
    "messageInitContent_3883": "宝我给你发消息了怕你看不见这里也提醒你一下哦",
    "tribeNodeConfigName_127": "巨鲸遗迹12",
    "98_-30016": "cjhwy2",
    "messageInitContent_3884": "拳头硬了",
    "98_-30015": "分解的元核不存在",
    "messageInitContent_3885": "现在我要开始叫了",
    "tribeNodeConfigName_129": "巨鲸遗迹14",
    "98_-30010": "该元核无需鉴定",
    "messageInitContent_1223": "它又来了，虎皮匠，放开我的前排。",
    "messageInitContent_1222": "哦，不要用这么可爱的脸打我！",
    "98_-30012": "cjhwy2",
    "messageInitContent_1221": "大家有没有听过龙炎其实是龙的呕吐物。",
    "messageInitContent_780": "夹公仔也很方便",
    "98_-30011": "该元核未鉴定，无法进行此操作",
    "messageInitContent_1220": "所以大家找到龙的金库没有",
    "messageInitContent_781": "跟隔壁，不能说十分相似但非常相似",
    "messageInitContent_782": "藤妖和破魂领主是一模一样呢",
    "messageInitContent_783": "龙也差不多",
    "messageInitContent_784": "毕竟都是龙",
    "messageInitContent_785": "我的莉娜因巴斯！",
    "themeCardPackName_15040": "唯一",
    "messageInitContent_1229": "可恶！这什么恶心人组合！",
    "messageInitContent_1228": "还好豹皮匠不在",
    "messageInitContent_1227": "我觉得不是那个意思。",
    "messageInitContent_1226": "dvd飞来飞去？",
    "messageInitContent_1225": "其实什么是dvd大战",
    "messageInitContent_1224": "清除增益是真的烦人，还有只穿甲兽！",
    "messageInitContent_3886": "（=，=)、、、、、、",
    "messageInitNick_10237": "键盘狂怒者",
    "messageInitContent_3887": "屏幕有点脏，让我来清洁一下！",
    "messageInitNick_10238": "霸天书生",
    "messageInitContent_3888": "看一眼就知道谁赢",
    "messageInitNick_10235": "笑得不能呼吸",
    "tribeNodeConfigName_151": "古兽遗迹11",
    "messageInitContent_3889": "厉害了我滴哥",
    "messageInitNick_10236": "链接在哪里",
    "tribeNodeConfigName_150": "古兽遗迹10",
    "tribeNodeConfigName_153": "古兽遗迹13",
    "tribeNodeConfigName_152": "古兽遗迹12",
    "messageInitNick_10239": "把遗憾填满",
    "tribeNodeConfigName_155": "古兽遗迹15",
    "tribeNodeConfigName_154": "古兽遗迹14",
    "messageInitContent_797": "手多不怕",
    "tribeNodeConfigName_157": "古兽遗迹17",
    "messageInitContent_3890": "动动你的脑子",
    "messageInitContent_798": "美杜莎的发型师自动整理的。",
    "messageInitNick_10230": "帮椰子道歉",
    "tribeNodeConfigName_156": "古兽遗迹16",
    "messageInitContent_3891": "绞尽脑汁，不对我哪来的脑子",
    "messageInitContent_799": "我也想要一个能自动造型，自动整理的发型。",
    "themeCardPackName_27020": "无底之墓",
    "tribeNodeConfigName_159": "古兽遗迹19",
    "messageInitContent_3892": "充满活力 希望 生机 和精神",
    "tribeNodeConfigName_158": "古兽遗迹18",
    "messageInitContent_3893": "哥的厉害你懂吗",
    "messageInitNick_10233": "好玩云的",
    "messageInitContent_3894": "我 的 发 店",
    "messageInitNick_10234": "激情的香蕉",
    "messageInitContent_3895": "今天也要猜错哦",
    "messageInitNick_10231": "魔法帽子",
    "messageInitContent_3896": "很自豪 没对过 ",
    "messageInitNick_10232": "咸甜蔬菜汤",
    "messageInitContent_1234": "皮匠家族是和穿甲兽达成了什么合作协议吗",
    "messageInitContent_1233": "豹皮匠原来你躲这里，让我来教训教训你",
    "messageInitContent_790": "我什么都没有只剩下菜",
    "themeCardPackName_27025": "星灵之空",
    "messageInitContent_1232": "豹皮匠我告诉你，有本事，你别躲后面！",
    "messageInitContent_791": "菜的安详",
    "messageInitContent_1231": "豹皮匠我告诉你，有本事，你别躲后面！",
    "messageInitContent_792": "我太菜了！",
    "messageInitContent_1230": "扮老虎吃猪！",
    "messageInitContent_793": "我菜但我很开心",
    "messageInitContent_794": "你们都是我的菜，比心",
    "messageInitContent_795": "同个发型师？",
    "messageInitContent_796": "一看就不好打理。",
    "themeCardPackName_15030": "海的那边",
    "messageInitContent_1239": "怪兽世界不存在被迫",
    "messageInitContent_1238": "制杖巨人好像被迫营业的样子",
    "messageInitContent_1237": "扮猪吃老虎",
    "messageInitContent_1236": "啊我的后排，啊我的前排",
    "messageInitContent_1235": "我才不要到这种动物园玩！",
    "messageInitContent_3897": "认真审题 仔细分析",
    "messageInitNick_10248": "香蕉变变变",
    "messageInitContent_3898": "不可以打我",
    "messageInitNick_10249": "成为你的例外",
    "messageInitContent_3899": "你们的思想很危险",
    "messageInitNick_10246": "文体两开花",
    "themeCardPackName_15035": "心之所在",
    "tribeNodeConfigName_140": "巨鲸遗迹25",
    "messageInitNick_10247": "史诗般的西瓜",
    "tribeNodeConfigName_142": "古兽遗迹2",
    "tribeNodeConfigName_141": "古兽遗迹1",
    "tribeNodeConfigName_144": "古兽遗迹4",
    "tribeNodeConfigName_143": "古兽遗迹3",
    "messageInitNick_10240": "疯狂百花",
    "tribeNodeConfigName_146": "古兽遗迹6",
    "messageInitNick_10241": "橘子很甜",
    "tribeNodeConfigName_145": "古兽遗迹5",
    "tribeNodeConfigName_148": "古兽遗迹8",
    "tribeNodeConfigName_147": "古兽遗迹7",
    "messageInitNick_10244": "吃瓜门首席",
    "messageInitNick_10245": "独奏王子",
    "tribeNodeConfigName_149": "古兽遗迹9",
    "messageInitNick_10242": "人潮如此拥挤",
    "messageInitNick_10243": "日文怎么说",
    "messageInitContent_1245": "暴雨来临前的平静。",
    "themeCardPackName_27015": "祖龙之巢",
    "messageInitContent_1244": "可能是最近换了种食物",
    "messageInitContent_1243": "凶噬魔的舌苔以前好像没有这么白",
    "messageInitContent_1242": "马上有个古记了",
    "messageInitContent_1241": "前面还有怎样的怪兽等着我呢！",
    "messageInitContent_1240": "尸族这群好吓人",
    "themeCardPackName_27010": "尸鬼之穴",
    "messageInitContent_1249": "前面那关到底有什么哈哈哈哈",
    "messageInitContent_1248": "你们很快就会知道了。",
    "messageInitContent_1247": "为什么这么说。",
    "messageInitContent_1246": "是的，大家好好享受。",
    "messageInitNick_10215": "巷子里的画家",
    "tribeNodeConfigName_171": "狂龙遗迹1",
    "messageInitNick_10216": "爆笑桑葚",
    "tribeNodeConfigName_170": "骇鸟遗迹10",
    "messageInitNick_10213": "幻想家",
    "tribeNodeConfigName_173": "狂龙遗迹3",
    "messageInitNick_10214": "老鸡",
    "tribeNodeConfigName_172": "狂龙遗迹2",
    "messageInitNick_10219": "说好的在一起",
    "tribeNodeConfigName_175": "狂龙遗迹5",
    "tribeNodeConfigName_174": "狂龙遗迹4",
    "messageInitNick_10217": "空调的故事",
    "messageInitNick_10218": "红色的曼陀罗",
    "themeCardPackName_27040": "初号铸体",
    "messageInitNick_10211": "可爱的电灯泡",
    "messageInitNick_10212": "已恢复单身",
    "messageInitNick_10210": "单马尾",
    "messageInitContent_1256": "这已经不是火候问题了，是要焦了吧",
    "messageInitContent_1255": "这里附近能捡到圣洁元核吗",
    "messageInitContent_1254": "这是闹哪样啊！",
    "messageInitContent_1253": "啊这什么！",
    "messageInitContent_1252": "让我来看看是不是我能打过的古记先",
    "messageInitContent_1251": "比这里热多了",
    "messageInitContent_1250": "让我来剧透你们，前面好热的呢",
    "messageInitContent_1259": "这是名为妖火的场地魔法！",
    "iapBuyConfigName_1104": "万象礼遇III",
    "messageInitContent_1258": "让要火的烈火净化你们的心灵",
    "messageInitContent_1257": "朝圣之路总是艰难的",
    "iapBuyConfigName_1102": "万象礼遇I",
    "messageInitNick_10226": "半明媚半忧伤",
    "tribeNodeConfigName_160": "古兽遗迹20",
    "iapBuyConfigName_1103": "万象礼遇II",
    "messageInitNick_10227": "虎背熊腰萝莉",
    "messageInitNick_10224": "感情恢复键",
    "tribeNodeConfigName_162": "骇鸟遗迹2",
    "iapBuyConfigName_1101": "万象赠礼",
    "messageInitNick_10225": "贝壳里的公主",
    "tribeNodeConfigName_161": "骇鸟遗迹1",
    "tribeNodeConfigName_164": "骇鸟遗迹4",
    "tribeNodeConfigName_163": "骇鸟遗迹3",
    "messageInitNick_10228": "感受指尖凉",
    "tribeNodeConfigName_166": "骇鸟遗迹6",
    "messageInitNick_10229": "车王",
    "tribeNodeConfigName_165": "骇鸟遗迹5",
    "tribeNodeConfigName_168": "骇鸟遗迹8",
    "tribeNodeConfigName_167": "骇鸟遗迹7",
    "themeCardPackName_27030": "空气之伴",
    "tribeNodeConfigName_169": "骇鸟遗迹9",
    "messageInitNick_10222": "梦幻在绽放",
    "messageInitNick_10223": "空气女神",
    "messageInitNick_10220": "等海的少年",
    "messageInitNick_10221": "周末女友",
    "messageInitContent_1267": "给大家点一首bgm《青鸟》",
    "messageInitContent_1266": "给我抬梯子过来！",
    "messageInitContent_1265": "区区bug而已！",
    "messageInitContent_1264": "有些时候还能穿过去呢！",
    "messageInitContent_1263": "我记得以前的墙是草丛",
    "messageInitContent_1262": "我现在研究拆墙还来得及吗",
    "messageInitContent_1261": "墙神！只要不让你去墙边，那你就不神了",
    "themeCardPackName_27035": "迟到的嘴",
    "messageInitContent_1260": "墙也是对面的对吧！",
    "themeCardPackName_15005": "迈开腿",
    "messageInitNick_10279": "伯爵猫",
    "messageInitNick_10273": "屑猫咪",
    "messageInitNick_1097": "拉普拉斯妖",
    "messageInitNick_10274": "杠精",
    "messageInitNick_1098": "爱情兽",
    "messageInitNick_10271": "穿过海的声音",
    "messageInitNick_1095": "暗夜伯爵",
    "messageInitNick_10272": "独孤求偶",
    "messageInitNick_1096": "本宫做不到",
    "messageInitNick_10277": "枸杞欣赏美景",
    "messageInitNick_10278": "顶级餐桌",
    "messageInitNick_10275": "逆境中的考拉",
    "messageInitNick_1099": "那一抹忧伤",
    "messageInitNick_10276": "强了一点点",
    "messageInitNick_10270": "接头霸王",
    "messageInitNick_1090": "谁要人工呼吸",
    "messageInitNick_1093": "三千战两千五",
    "messageInitNick_1094": "越过星辰大海",
    "messageInitNick_1091": "爱江山爱美人",
    "messageInitNick_1092": "凌晨花未眠",
    "messageInitNick_10284": "脑子缓冲中",
    "messageInitNick_1086": "浮云恋风轻",
    "messageInitNick_10285": "暴走的口香糖",
    "messageInitNick_1087": "财迷",
    "messageInitNick_10282": "向时间进攻",
    "messageInitNick_1084": "天下第一",
    "messageInitNick_10283": "厕所里蹦迪",
    "messageInitNick_1085": "划水天王",
    "messageInitNick_10288": "四氧化三铁",
    "messageInitNick_10289": "女巫的扫地机",
    "messageInitNick_10286": "花花花小伙",
    "messageInitNick_1088": "给我西瓜与猫",
    "messageInitNick_10287": "绝世小受",
    "messageInitNick_1089": "铁好人",
    "messageInitNick_10280": "临期食品",
    "messageInitNick_10281": "尖叫橙子",
    "messageInitNick_10259": "惊为行人",
    "messageInitNick_10257": "为啥不早说",
    "messageInitNick_10258": "电视机的碎片",
    "themeCardPackName_15025": "大海之中",
    "messageInitNick_1082": "她爱他",
    "messageInitNick_1083": "睡到煮饭时",
    "messageInitNick_1080": "甘心散场",
    "themeCardPackName_15020": "首个尽头",
    "messageInitNick_1081": "煲粥就是艺术",
    "messageInitNick_10251": "游泳去买菜",
    "messageInitNick_1075": "傲得像阳光",
    "messageInitNick_10252": "功德推关人",
    "messageInitNick_1076": "此已暂停使用",
    "messageInitNick_1073": "短腿猪",
    "messageInitNick_10250": "保住呢份工",
    "messageInitNick_1074": "猫咪观察员",
    "messageInitNick_10255": "天堂马铃薯",
    "messageInitNick_1079": "恐龙猪",
    "messageInitNick_10256": "超级大会员",
    "messageInitNick_10253": "凌晨三点半",
    "messageInitNick_1077": "罕见硬汉子",
    "messageInitNick_10254": "红毯女王",
    "messageInitNick_1078": "上学赖床",
    "themeCardPackName_27005": "突发之想",
    "themeCardPackName_15015": "张开嘴",
    "messageInitNick_10268": "疯狂的水果",
    "messageInitNick_10269": "电子海盐",
    "messageInitNick_1071": "傲似你祖宗",
    "messageInitNick_1072": "紫烟破音",
    "messageInitNick_1070": "金刚陵",
    "themeCardPackName_15010": "睁开眼",
    "messageInitNick_10262": "科技食品",
    "messageInitNick_1064": "看招徒手打脸",
    "messageInitNick_10263": "吃瓜王",
    "messageInitNick_1065": "铁金水",
    "messageInitNick_10260": "夏天的尾巴",
    "messageInitNick_1062": "把孤独喂饱",
    "messageInitNick_10261": "健康茶的故事",
    "messageInitNick_1063": "倒霉蛋",
    "messageInitNick_10266": "空中飞人",
    "messageInitNick_1068": "无状态",
    "messageInitNick_10267": "我牛",
    "messageInitNick_1069": "雪糕刺客",
    "messageInitNick_10264": "外星脸盆",
    "messageInitNick_1066": "盐汁油梨",
    "messageInitNick_10265": "我推的罐子",
    "messageInitNick_1067": "超萌虎牙妹",
    "messageInitContent_3806": "好耶",
    "systemTaskConfigTitle_2": "起源殿每周奖励",
    "messageInitContent_3807": "哪里难了",
    "systemTaskConfigTitle_1": "部落新赛季开启！",
    "messageInitContent_3808": "青铜五小强是不是跑错地了",
    "systemTaskConfigTitle_4": "拍卖所下次必中标函",
    "messageInitContent_3809": "结果一目了然",
    "systemTaskConfigTitle_3": "拍卖所中标函",
    "systemTaskConfigTitle_9": "世界灾厄击破",
    "messageInitContent_3800": "为什么不是左青龙右白虎",
    "messageInitContent_3801": "来点明示",
    "messageInitContent_3802": "来点暗示",
    "messageInitNick_1060": "神秘书",
    "systemTaskConfigTitle_6": "狩猎反杀通知",
    "messageInitContent_3803": "在暗示和明示之间 我选择提示",
    "messageInitNick_1061": "猫瞳",
    "systemTaskConfigTitle_5": "部落之王赛季奖励",
    "messageInitContent_3804": "点赞有tips",
    "systemTaskConfigTitle_8": "狩猎每日奖励",
    "messageInitContent_3805": "我都上了一天班了为什么还",
    "systemTaskConfigTitle_7": "狩猎突出警告",
    "messageInitNick_1053": "时光请慢些走",
    "messageInitNick_1054": "卖萌天才",
    "messageInitNick_1051": "小金人",
    "messageInitNick_1052": "老纳",
    "messageInitNick_1057": "诺贝尔打拳奖",
    "messageInitNick_1058": "不要给我错觉",
    "messageInitNick_1055": "肚脐激光",
    "messageInitNick_1056": "呆小萌",
    "messageInitNick_1059": "冰雪掌控者",
    "messageInitContent_3817": "桐仁好勇站前面",
    "messageInitContent_3818": "私信我告诉你的谁赢",
    "messageInitContent_3819": "ψ ",
    "shopCreationStageNoName_4": "觉醒始动",
    "shopCreationStageNoName_5": "谱光乍放",
    "shopCreationStageNoName_2": "天选时刻",
    "shopCreationStageNoName_3": "每期一创",
    "messageInitContent_3810": "反着选准没错",
    "shopCreationStageNoName_1": "永远哈皮",
    "messageInitContent_3811": "赶紧给我打",
    "messageInitContent_3812": "我要立刻马上知道结果",
    "messageInitContent_3813": "前排出售时光机",
    "messageInitContent_3814": "我是多啦a梦，v我私发你答案",
    "messageInitNick_1050": "林中小调",
    "messageInitContent_3815": "2打5的团",
    "messageInitContent_3816": "我看好绿色方",
    "messageInitNick_1042": "可爱到炸",
    "messageInitNick_1043": "你也是三千防",
    "messageInitNick_1040": "第十九个梦",
    "messageInitNick_1041": "甜姐儿",
    "messageInitNick_1046": "白雪公主",
    "messageInitNick_1047": "尘世不美丽",
    "messageInitNick_1044": "比以前懂事了",
    "messageInitNick_1045": "丛林中的仙子",
    "messageInitNick_1048": "寂寞先生",
    "messageInitNick_1049": "头铁门首席",
    "messageInitContent_3828": "幼体逆袭！",
    "messageInitContent_3829": "说的什么话",
    "messageInitContent_3820": "ψ ψ ψ ψ ψ ψ ψ ",
    "messageInitContent_3821": "ψ ψ ψ ψ ψ ψ ",
    "messageInitContent_3822": "ψ ψ ",
    "messageInitContent_3823": "XXXXX",
    "messageInitContent_3824": "叉叉狂粉",
    "messageInitContent_3825": "支持叉叉打到独角兽",
    "messageInitContent_3826": "建议移除",
    "messageInitContent_3827": "我很小",
    "messageInitNick_10295": "残剑魂",
    "messageInitNick_1031": "盒子已成精",
    "messageInitNick_3694": "全息马桶",
    "messageInitNick_10296": "热水器的尽头",
    "messageInitNick_1032": "混世小宅男",
    "messageInitNick_3693": "最爱西兰花",
    "messageInitNick_10293": "超级尬聊神",
    "messageInitNick_3692": "什么什么们",
    "messageInitNick_10294": "迷路的胫骨",
    "messageInitNick_1030": "爱情扒手",
    "messageInitNick_3691": "凌晨别心动",
    "messageInitNick_10299": "半面妆",
    "messageInitNick_1035": "流放者",
    "messageInitNick_3698": "后青春期旳诗",
    "messageInitNick_1036": "宿舍养狗中",
    "messageInitNick_3697": "恭喜发财",
    "messageInitNick_10297": "智能软糖",
    "messageInitNick_1033": "打脸冠军",
    "messageInitNick_3696": "深海公子",
    "messageInitContent_3830": "硬着头皮上",
    "messageInitNick_10298": "虚拟的花",
    "messageInitNick_1034": "最怕榴莲味",
    "messageInitNick_3695": "招惹月色",
    "messageInitNick_1039": "兀自沉沦",
    "messageInitNick_1037": "补刀王",
    "messageInitNick_1038": "傲世小狂徒",
    "messageInitNick_3699": "恰巧心动",
    "messageInitNick_10291": "纪录片制片人",
    "messageInitNick_10292": "闭加锁先生",
    "messageInitNick_10290": "古代草莓",
    "messageInitContent_3839": "叉会儿腰",
    "messageInitContent_3831": "问右边有几只马",
    "channelName_nt_ios_h": "App Store",
    "messageInitContent_3832": "暗中观察",
    "messageInitContent_3833": "祖拉祖拉你最棒祖拉祖拉最可爱祖拉祖拉我爱你",
    "messageInitContent_3834": "我都是按怪兽数量选的（其他人我不告诉他",
    "messageInitContent_3835": "伸手要个答案",
    "messageInitNick_3690": "无敌的基质",
    "messageInitContent_3836": "看到这玄武我笑了",
    "messageInitContent_3837": "独角兽：敢不敢换个神灵再打",
    "messageInitContent_3838": "我宣布你们现在是钻石5小强，给我赢",
    "messageInitNick_1020": "大灰狼",
    "messageInitNick_3683": "果酱味的猫",
    "messageInitNick_1021": "添加失败",
    "messageInitNick_3682": "非诚你勿扰",
    "messageInitNick_3681": "来给爷笑一个",
    "messageInitNick_3680": "爱你的猫",
    "messageInitNick_1024": "定格的青春",
    "messageInitNick_3687": "银河小铁骑",
    "messageInitNick_1025": "地球猫",
    "messageInitNick_3686": "突突突突突",
    "messageInitContent_3840": "想上场",
    "messageInitNick_1022": "独守夜空",
    "messageInitNick_3685": "盐煸月亮",
    "messageInitContent_3841": "要不我来打 必赢",
    "messageInitNick_1023": "爱幻想",
    "messageInitNick_3684": "便宜的收不到",
    "messageInitNick_1028": "寻找停靠的心",
    "messageInitNick_1029": "兔兔要睡觉啦",
    "messageInitNick_1026": "薄荷糖微凉",
    "messageInitNick_3689": "我太难了",
    "messageInitNick_1027": "打小就多情",
    "messageInitNick_3688": "凌晨下班的人",
    "mapNodeName_421": "神龙摆尾",
    "mapNodeName_420": "金矿山",
    "mapNodeName_423": "不归沼地",
    "mapNodeName_422": "狮吼功",
    "mapNodeName_418": "地龙在地",
    "mapNodeName_417": "炼狱焚风",
    "mapNodeName_419": "不归沼地",
    "mapNodeName_414": "不归沼地",
    "mapNodeName_413": "怪兽神医",
    "mapNodeName_416": "龙拳",
    "mapNodeName_415": "不归沼地",
    "mapNodeName_432": "雷电门",
    "mapNodeName_431": "无垠大漠",
    "mapNodeName_434": "打不过！炸！",
    "mapNodeName_433": "无垠大漠",
    "mapNodeName_430": "虎虎生威",
    "mapNodeName_429": "小马飞刀",
    "mapNodeName_428": "神机棒",
    "mapNodeName_425": "千手千变",
    "mapNodeName_424": "葵花宝典",
    "mapNodeName_427": "水上医仙",
    "mapNodeName_426": "同归战法",
    "mapNodeName_401": "怪兽客栈",
    "mapNodeName_400": "千手如来掌",
    "mapNodeName_410": "剑风",
    "mapNodeName_412": "铜锤手",
    "mapNodeName_411": "究极轻功水上漂",
    "mapNodeName_407": "飞龙在天",
    "mapNodeName_406": "吸星大法",
    "mapNodeName_409": "喵星大法",
    "mapNodeName_408": "不归沼地",
    "mapNodeName_403": "开拓集市",
    "mapNodeName_402": "归隐山林",
    "mapNodeName_405": "不归沼地",
    "mapNodeName_404": "包租公",
    "messageInitNick_8091": "最强椅子",
    "resoundEventStoryName_6": "难顶的追求",
    "messageInitNick_8090": "饼太大吃不下",
    "resoundEventStoryName_5": "新鲜的王·霸者减肥日记",
    "messageInitNick_8093": "一炮而红",
    "resoundEventStoryName_8": "叉叉",
    "messageInitNick_8092": "尖叫口香糖",
    "resoundEventStoryName_7": "王·赤色狮的无奈",
    "resoundEventStoryName_9": "永远",
    "mapNodeName_465": "健马",
    "messageInitNick_8099": "浪一世痞一生",
    "mapNodeName_464": "万类止境",
    "messageInitNick_8098": "百香果龙",
    "mapNodeName_467": "万类止境",
    "mapNodeName_466": "呜呜溜拉",
    "mapNodeName_461": "修罗刀",
    "messageInitNick_8095": "当场退休",
    "resoundEventStoryName_2": "怪兽会做梦吗？",
    "mapNodeName_460": "撞墙功",
    "messageInitNick_8094": "不要停下来",
    "resoundEventStoryName_1": "怪兽会梦见数码兽吗？",
    "mapNodeName_463": "隔拨扫撩劈刺扎",
    "messageInitNick_8097": "龙眼君快逃",
    "resoundEventStoryName_4": "伪装",
    "mapNodeName_462": "缥缈幽森",
    "messageInitNick_8096": "苦瓜多样性",
    "resoundEventStoryName_3": "那……",
    "messageInitContent_8302": "【##############】",
    "messageInitContent_8303": "【数据已逃逸】",
    "messageInitContent_8300": "【内容无法加载】",
    "messageInitContent_8301": "的【】开揭是键关的数总的则规。88",
    "mapNodeName_458": "化外江湖",
    "messageInitContent_8306": "1.无需畏惧危险",
    "mapNodeName_457": "黯灭销魂焰",
    "messageInitContent_8307": "1240。先结账再进餐",
    "messageInitContent_8304": "【该内容被遮挡】",
    "mapNodeName_459": "缥缈幽森",
    "messageInitContent_8305": "1.重复的留言是迷途者的标记",
    "messageInitNick_8080": "机场等船",
    "mapNodeName_470": "小龙儿",
    "messageInitNick_8082": "沙沙沙沙拉",
    "messageInitNick_8081": "随缘抽卡",
    "mapNodeName_476": "阎王敌",
    "messageInitNick_8088": "爷的名字",
    "mapNodeName_475": "塞外英兽",
    "messageInitNick_8087": "悲欢并不相通",
    "mapNodeName_478": "缥缈幽森",
    "messageInitContent_8308": "【内容无法加载】",
    "mapNodeName_477": "神龙岛",
    "messageInitContent_8309": "1241。不可以舔它。",
    "messageInitNick_8089": "流浪的店员",
    "mapNodeName_472": "大漠双龙传",
    "messageInitNick_8084": "天天晒太阳",
    "mapNodeName_471": "龙门镖局",
    "messageInitNick_8083": "掏不过掏不过",
    "mapNodeName_474": "无垠大漠",
    "messageInitNick_8086": "老板找你",
    "mapNodeName_473": "盖世大白龙",
    "messageInitNick_8085": "怀抱漏风",
    "messageInitContent_8313": "录登新重再，后录登出退先么那，了战挑是还你果如。3",
    "messageInitContent_8314": "【内容已损坏】",
    "messageInitContent_8311": "2.红色的文字是真实的 但也可能是某只怪兽带来的幻觉",
    "messageInitContent_8312": "【数据正在逃逸】",
    "mapNodeName_469": "幻化双雄",
    "messageInitContent_8317": "4.同时带有。，的规则尽可能参考，的",
    "mapNodeName_468": "幼体三杰",
    "messageInitContent_8318": "1243。越来越接近中心就越要小心。",
    "messageInitContent_8315": "0.享受游戏",
    "messageInitContent_8316": "1242。没有受伤的话千万不要接受它的治疗。",
    "messageInitContent_8310": "6。不要试图用逻辑来理解所看到的规则 它们存在的意义就是让你感到迷惑",
    "darkForestEventConfigDescription_6": "事件6",
    "darkForestEventConfigDescription_7": "事件7",
    "darkForestEventConfigDescription_4": "事件4",
    "messageInitNick_8071": "行走的果汁糖",
    "darkForestEventConfigDescription_5": "事件5",
    "messageInitNick_8070": "橙子之心",
    "darkForestEventConfigDescription_8": "事件8",
    "darkForestEventConfigDescription_9": "事件9",
    "mapNodeName_443": "情动星落",
    "messageInitNick_8077": "最强的香蕉",
    "mapNodeName_442": "无限星天神枪",
    "messageInitNick_8076": "劳逸结合",
    "mapNodeName_445": "雷珠神火鞭",
    "messageInitContent_8319": "【##############】",
    "messageInitNick_8079": "无公害辣椒",
    "mapNodeName_444": "金矿山",
    "messageInitNick_8078": "银河偶遇计划",
    "darkForestEventConfigDescription_2": "事件2",
    "messageInitNick_8073": "油菜真好吃",
    "darkForestEventConfigDescription_3": "事件3",
    "messageInitNick_8072": "霹雳美人",
    "mapNodeName_441": "无垠大漠",
    "messageInitNick_8075": "小汤包儿",
    "darkForestEventConfigDescription_1": "事件1",
    "mapNodeName_440": "地龙沼兽",
    "messageInitNick_8074": "静谧游泳圈",
    "messageInitContent_8324": "1244。越来越接近中心，污染就越严重",
    "mapNodeName_439": "无垠大漠",
    "messageInitContent_8325": "信相以可，的确正般一是则规的.有带。1",
    "messageInitContent_8322": "1。这关必须重复挑战10次2，规则1是瞎写的吧",
    "messageInitContent_8323": "相真着藏隐中【】。9",
    "mapNodeName_436": "拳头",
    "messageInitContent_8328": "2.直觉可能带来误解",
    "mapNodeName_435": "斗转星移",
    "messageInitContent_8329": "1245。不要试图去理解那些无法理解的东西",
    "messageInitNick_8069": "怎样坚强",
    "mapNodeName_438": "古记战役-独孤求败",
    "messageInitContent_8326": "【内容无法加载】",
    "mapNodeName_437": "梵花点穴手",
    "messageInitContent_8327": "【该内容被遮挡】",
    "messageInitContent_8320": "关一下战挑要不。1",
    "messageInitContent_8321": "1。这关必须重复挑战10次2，规则1是瞎写的吧",
    "messageInitNick_8060": "盛夏光年",
    "mapNodeName_454": "化外江湖",
    "messageInitNick_8066": "蹲街角哭泣",
    "mapNodeName_453": "流星无蝶镰",
    "messageInitNick_8065": "超前游玩",
    "mapNodeName_456": "夜，深夜",
    "messageInitNick_8068": "超级过山车",
    "mapNodeName_455": "沾衣十八跌",
    "messageInitNick_8067": "第一视觉的你",
    "mapNodeName_450": "如沸星穹",
    "messageInitNick_8062": "发亮的灯泡",
    "messageInitNick_8061": "连呼吸都会痛",
    "mapNodeName_452": "千日练枪",
    "messageInitNick_8064": "听见阳光",
    "mapNodeName_451": "百日练刀",
    "messageInitNick_8063": "自私的前锋",
    "messageInitContent_8335": "【数据已丢失】",
    "messageInitContent_8336": "【内容已损坏】",
    "messageInitContent_8333": "【信息被隐藏】",
    "messageInitContent_8334": "【数据已逃逸】",
    "mapNodeName_447": "镰门",
    "messageInitContent_8339": "2.红色的文字是真实的 但也可能是某只怪兽带来的幻觉",
    "messageInitNick_8059": "暴走的果汁糖",
    "mapNodeName_446": "风雷震大漠",
    "messageInitNick_8058": "认证走音专家",
    "mapNodeName_449": "降魔掌",
    "messageInitContent_8337": "【信息读取失败】",
    "mapNodeName_448": "无垠大漠",
    "messageInitContent_8338": "4.同时带有。，的规则尽可能参考，的",
    "messageInitContent_8331": "字红有没里这但，实真着味意字红。1",
    "messageInitContent_8332": "1.如果你在挑战过程中有人找你 请优先处理找你的",
    "messageInitContent_8330": "【内容已损坏】",
    "messageInitNick_8055": "不想理你",
    "messageInitNick_8054": "天下第一卷",
    "messageInitNick_8057": "奇迹玩家",
    "messageInitNick_8056": "花与金丝雀",
    "messageInitNick_8051": "喵喵队立大功",
    "messageInitNick_8050": "萝卜先锋",
    "messageInitNick_8053": "大魔王",
    "messageInitNick_8052": "盐多了会咸",
    "messageInitNick_8048": "葫芦娃",
    "messageInitNick_8047": "电磁炉之彼端",
    "messageInitNick_8049": "你在哪里等我",
    "messageInitNick_8044": "实名买房",
    "messageInitNick_8043": "摸鱼先锋",
    "messageInitNick_8046": "临海听风",
    "messageInitNick_8045": "芒果先锋",
    "messageInitNick_8040": "彩礼刺客",
    "messageInitNick_8042": "一方通行",
    "messageInitNick_8041": "按时吃饭",
    "messageInitNick_8037": "愤怒的老鸟",
    "messageInitNick_8036": "回收站长",
    "messageInitNick_8039": "吃饭了没",
    "messageInitNick_8038": "提嫖",
    "parameterStrengthenName_9": "射程{p1}%",
    "messageInitNick_8033": "沙发毁灭者",
    "parameterStrengthenName_7": "真实伤害{p1}",
    "messageInitNick_8032": "凌晨两点半",
    "parameterStrengthenName_8": "真实伤害{p1}，攻击力{p2}",
    "messageInitNick_8035": "萝卜兽",
    "parameterStrengthenName_5": "生物屏障{p1}",
    "messageInitNick_8034": "爱笑的萌汉纸",
    "parameterStrengthenName_6": "生物屏障{p1}，体力{p2}",
    "parameterStrengthenName_3": "体力{p1}",
    "parameterStrengthenName_4": "体力{p1}，攻击力{p2}",
    "messageInitNick_8031": "春天里的雪",
    "parameterStrengthenName_1": "攻击力{p1}",
    "messageInitNick_8030": "画饼王",
    "parameterStrengthenName_2": "攻击力{p1}，体力{p2}",
    "messageInitNick_8029": "杂念减一",
    "messageInitNick_8026": "尖叫洋葱",
    "messageInitNick_8025": "有主之地",
    "messageInitNick_8028": "超晨光之柱",
    "messageInitNick_8027": "沉浸式写作",
    "messageInitNick_8022": "给冰箱把脉",
    "messageInitNick_8021": "流浪的律师",
    "messageInitNick_8024": "狗狗的日常",
    "messageInitNick_8023": "承诺碎了一地",
    "messageInitNick_8020": "跳伞捡空投",
    "messageInitNick_8019": "电影院里睡觉",
    "messageInitNick_8018": "霸气刺客",
    "messageInitNick_8015": "重新定义恰瓜",
    "messageInitNick_8014": "菜花魔法",
    "messageInitNick_8017": "擦不完的地板",
    "messageInitNick_8016": "要变身了",
    "messageInitNick_8011": "生菜魔法",
    "messageInitNick_8010": "菜汤不甜",
    "messageInitNick_8013": "百香果消灭者",
    "messageInitNick_8012": "彩虹直至黑白",
    "messageInitNick_8008": "逆境中的香蕉",
    "messageInitNick_8007": "跑调门首席",
    "messageInitNick_8009": "街机少年",
    "messageInitNick_8004": "鳖载着理发店",
    "messageInitNick_8003": "向日葵的花语",
    "messageInitNick_8006": "诸神午后",
    "messageInitNick_8005": "暗访西门庆",
    "messageInitNick_8000": "可乐",
    "messageInitNick_8002": "芹菜真好吃",
    "messageInitNick_8001": "第四根肋骨",
    "resoundEventConfigName_3007": "7.守卫",
    "resoundEventConfigName_3008": "8.李雨蒙",
    "resoundEventConfigName_3009": "9.邬羽刹",
    "resoundEventConfigName_3001": "1.发现",
    "resoundEventConfigName_3002": "2.定格",
    "resoundEventConfigName_3003": "3.月之殿",
    "resoundEventConfigName_3004": "4.变异孢子",
    "resoundEventConfigName_3005": "5.日夕",
    "resoundEventConfigName_3006": "6.“帮手”",
    "22_6": "第{1}天",
    "22_5": "每日一发",
    "22_4": "天",
    "22_3": "第",
    "22_2": "活动时间：{1}",
    "22_1": "1.每日0点、12点、18点自动回复一次移动力领取次数，领取时回复100移动力\\n2.最多储存3次，储存到达3次后次数将暂停自动回复",
    "22_9": "每日登录即可自动解锁奖励！在这你可以收获两种满足：\\n立刻领取收获即时满足，或者囤起来一次性狂领收获延时满足！（不建议）",
    "22_8": "开启\\n下一轮奖励",
    "22_7": "已领取",
    "resoundEventConfigName_3010": "10.真·暴虐战狂",
    "resoundEventConfigName_3011": "11.真·日夕",
    "resoundEventConfigName_3012": "12.造唤",
    "resoundEventConfigName_3013": "13.邪王",
    "resoundEventConfigName_3014": "14.邪王的爱",
    "98_-160014": "怪兽已全部阵亡",
    "98_-160013": "刷新次数限制",
    "98_-160012": "今天未锁定",
    "98_-160011": "今天已锁定",
    "98_-160010": "今天已使用血量恢复的机会",
    "98_-160019": "已绑定探索者，不能重新再绑定",
    "98_-160018": "输入的邀请码查找不到",
    "98_-160025": "一只怪都不上？本队做不到啊！！",
    "98_-160024": "一创到底开放时间为{1}",
    "98_-160023": "输入的邀请码不是6位字符",
    "98_-160022": "本人积分不足以领取该档次奖励",
    "98_-160021": "本人不能邀请自己",
    "98_-160020": "该探索者邀请绑定数已达到上限",
    "98_-160029": "该探索者已经与你绑定",
    "98_-160030": "{1}级以上的探索者不能绑定其他探索者",
    "98_-160035": "开放时间为{1}",
    "17_totemModeDesc2": "战斗结束时，我方远程怪兽血量总和",
    "98_-160034": "该增益不可超过{1}个，目前已有{2}个",
    "17_totemModeDesc3": "战斗结束时，我方怪兽普通攻击次数总和",
    "98_-160033": "本日可选怪兽已变更，请重新进入活动",
    "98_-160032": "你已经开启挑战状态",
    "17_totemModeDesc1": "战斗结束时，我方近战怪兽血量总和",
    "17_totemModeDesc6": "战斗结束时，我方怪兽治疗量总和",
    "17_totemModeDesc7": "战斗结束时，我方怪兽最大生存秒数",
    "17_totemModeDesc4": "战斗结束时，我方怪兽承受伤害总和",
    "17_totemModeDesc5": "战斗结束时，我方怪兽制造伤害总和",
    "17_totemModeDesc8": "战斗结束时，敌方怪兽触碰战墙次数总和",
    "17_totemModeDesc9": "战斗结束时，我方怪兽触碰战墙次数总和",
    "5_18": "怪兽列表",
    "5_17": "一只怪都不上？本队做不到啊！！",
    "96_DailyTask": "每日任务",
    "5_19": "神灵/战墙",
    "5_10": "炼狱模式",
    "5_12": "能量不足",
    "5_11": "{1}秒",
    "5_14": "占领奖励（每小时）",
    "5_13": "首通奖励",
    "5_16": "已上阵",
    "5_15": "起源殿对战",
    "11_2001": "起源殿",
    "11_2002": "初阶",
    "11_2003": "中阶",
    "11_2004": "高阶",
    "11_2005": "大师",
    "11_2006": "宗师",
    "11_2007": "巅峰",
    "11_2008": "起源",
    "11_2009": "我的排名",
    "5_29": "神灵契约第{1}层",
    "5_28": "神灵契约",
    "5_21": "敌人",
    "5_20": "上阵",
    "5_23": "{1}",
    "5_22": "古记战役-{1}",
    "5_25": "网络翻船中，是否重新结算？",
    "5_24": "战斗结算异常，是否重新结算？",
    "5_27": "解锁",
    "5_26": "乱入-敌袭-{1}",
    "11_2010": "积分",
    "11_2011": "本赛季战绩",
    "11_2012": "排阵",
    "11_2013": "匹配",
    "11_2014": "剩余免费挑战次数",
    "11_2015": "正在寻找对手",
    "11_2016": "取消匹配",
    "11_2017": "战力",
    "11_2018": "选择",
    "11_2019": "开始选择你的阵容",
    "5_39": "怪兽上阵中",
    "5_32": "获得怪兽后解锁挑战",
    "5_31": "试战",
    "5_34": "通关奖励（含拍卖和共享奖励）",
    "98_-160069": "不是回流玩家",
    "5_33": "正在压制深渊先遣的词缀，切换队伍会使压制失效",
    "98_-160068": "{1}后解锁",
    "5_36": "濒死状态的怪兽不能出战和下阵，{1}后自动消除濒死状态",
    "5_35": "放入词缀消除格的怪兽不能挑战深渊先遣",
    "98_-160066": "该幸运之约到达本日刷新上限",
    "5_38": "，是否消耗{1}加快倒计时？\\n（最多加快至剩余{2}分钟）",
    "98_-160065": "该幸运之约已购买",
    "5_37": "部队中所有怪兽均为濒死状态，不能挑战",
    "98_-160064": "结算未能通过反作弊验证，如有疑问请向客服详询",
    "11_2020": "选择中",
    "11_2021": "倒计时{1}秒",
    "11_2022": "先手",
    "11_2023": "倒计时",
    "5_30": "请先下阵一只怪兽",
    "11_2024": "锁定主力怪兽",
    "11_2025": "敌方正在调整阵容",
    "11_2026": "已禁用",
    "11_2027": "退出房间",
    "11_2028": "已锁定",
    "11_2029": "锁定",
    "98_-160074": "已获得形态无法更换选择",
    "98_-160073": "邀约码无法跨官方/渠道服务器使用",
    "98_-160072": "本登录账号已经有其他角色完成了绑定，无法再次绑定",
    "98_-160071": "已经绑定了玩家",
    "98_-160070": "未达到邀请人数",
    "5_43": "退出战斗",
    "5_42": "马上结算",
    "5_45": "上阵神灵",
    "5_44": "投降",
    "98_-160079": "进击巨物开放时间为{1}",
    "5_47": "消耗{1}开启宝箱（当前拥有：{2}{3}）",
    "98_-160078": "巨物进击开放时间为{1}",
    "5_46": "挑战{1}",
    "98_-160077": "不符合邀约条件",
    "11_2030": "禁用",
    "11_2031": "段位奖励",
    "11_2032": "挑战{1}次+",
    "11_2033": "积分{1}+",
    "11_2034": "我",
    "5_41": "每次挑战奖励",
    "11_2035": "总场次",
    "5_40": "强制自动战斗中",
    "11_2036": "胜率",
    "11_2037": "奖励",
    "11_2038": "排行榜",
    "11_2039": "段位提升!",
    "5_54": "邮件",
    "5_53": "新阵容位置",
    "5_56": "聊天",
    "5_55": "好友",
    "5_58": "野生怪兽",
    "5_57": "留言",
    "5_59": "狩猎",
    "11_2040": "先手",
    "11_2041": "后手",
    "11_2042": "排名",
    "11_2043": "匹配成功",
    "5_50": "宝箱奖励",
    "11_2044": "即将进入战斗",
    "5_52": "战斗校验失败，战斗异常结束，请尝试重新启动游戏后挑战",
    "5_51": "成功保存录像",
    "originRealmSeasonName_202405": "00",
    "originRealmSeasonName_202406": "00",
    "originRealmSeasonName_202407": "01",
    "5_65": "复制体",
    "messageInitContent_8346": "0.享受世界",
    "5_64": "乱入事件",
    "messageInitContent_8347": "相真的部全诉告你会则规条一何任有没。1",
    "5_67": "幻化进化",
    "messageInitContent_8344": "1248。如果你被某段旋律洗脑了，请停止挑战",
    "5_66": "深渊先遣",
    "messageInitContent_8345": "【内容已损坏】",
    "5_69": "不朽进化",
    "originRealmSeasonName_202408": "02",
    "5_68": "究极进化",
    "originRealmSeasonName_202409": "03",
    "messageInitContent_8348": "字红有没里这但，实真着味意字红。1",
    "messageInitContent_8349": "0.休息一下",
    "5_61": "元核熔炼",
    "messageInitContent_8342": "【信息读取失败】",
    "5_60": "世界灾厄",
    "messageInitContent_8343": "55，如果你遵守了；规则那么世界就会生成更多的。规则所以不要遵守；规则",
    "5_63": "{1}\\n{2}",
    "messageInitContent_8340": "别甄意注要假是则规的。有带。2",
    "5_62": "极化",
    "messageInitContent_8341": "信相以可，的确正般一是则规的.有带。1",
    "originRealmSeasonName_202410": "04",
    "originRealmSeasonName_202411": "05",
    "originRealmSeasonName_202412": "06",
    "5_76": "再看一遍",
    "messageInitContent_8357": "解误来带能可觉直。2",
    "5_75": "好友助战",
    "messageInitContent_8358": "觉幻的来带兽怪只某是能可也但，的实真是字文的色红。2",
    "5_78": "该模式强制自动战斗",
    "messageInitContent_8355": "【内容已损坏】",
    "5_77": "分享录像至",
    "messageInitContent_8356": "则规；守遵要不以所，。则规的多更成生会就界世么那，；则规了守遵果如你。55",
    "5_79": "星律\\n探索者经验",
    "messageInitContent_8359": "1.规则可能在不同的关卡发生变化请时刻保持警觉",
    "iapBuyConfigName_101": "充值大礼",
    "messageInitContent_8350": "1,带关卡数字的是关卡独特规则",
    "5_70": "觉醒进化",
    "5_72": "我的怪兽",
    "messageInitContent_8353": "1250。解构深渊是危险的",
    "5_71": "每只怪兽每日最多可加快消除濒死状态{1}分钟\\n（当前已加快{2}分钟）",
    "messageInitContent_8354": "【##############】",
    "5_74": "冷却中",
    "messageInitContent_8351": "【数据正在逃逸】",
    "5_73": "好友助战",
    "messageInitContent_8352": "2.红色的文字是真实的 但也可能是某只怪兽带来的幻觉",
    "mapNodeName_481": "无尽雷击",
    "mapNodeName_480": "赤炼神掌",
    "mapNodeName_487": "虹拳",
    "mapNodeName_486": "四个臭皮匠",
    "mapNodeName_489": "走火入魔",
    "mapNodeName_488": "缥缈幽森",
    "mapNodeName_483": "肉镖",
    "mapNodeName_482": "奔流炼狱",
    "mapNodeName_485": "双龙出海",
    "mapNodeName_484": "金矿山",
    "5_87": "可复制配置",
    "messageInitContent_8368": "0.休息一下",
    "5_86": "战斗时间过长，无法保存录像",
    "messageInitContent_8369": "【数据已逃逸】",
    "5_89": "解锁神灵\\n{1}",
    "messageInitContent_8366": "用适再不则规；后成完战挑关卡在。1",
    "5_88": "探索者等级提升后可掉落更高品质的元核\\n该敌人生成的位面与你领地所在位面相同",
    "messageInitContent_8367": "2.红色的文字是真实的 但也可能是某只怪兽带来的幻觉",
    "mapNodeName_479": "笑傲江湖",
    "messageInitContent_8360": "【内容已损坏】",
    "messageInitContent_8361": "0.享受世界",
    "5_81": "新纪录",
    "5_80": "通关录像",
    "5_83": "结算",
    "messageInitContent_8364": "4.同时带有。，的规则尽可能参考，的",
    "5_82": "今天累计获得金币奖励",
    "messageInitContent_8365": "【数据已丢失】",
    "5_85": "前置关卡未通关",
    "messageInitContent_8362": "相真着藏隐中【】。9",
    "5_84": "重新挑战",
    "messageInitContent_8363": "2.直觉可能带来误解",
    "mapNodeName_490": "破金锤",
    "mapNodeName_492": "龙象般若功",
    "mapNodeName_491": "缥缈幽森",
    "mapNodeName_498": "古记战役-难念的经",
    "mapNodeName_497": "火山飞狐",
    "mapNodeName_499": "火云邪神",
    "mapNodeName_494": "火龙拳",
    "mapNodeName_493": "御门",
    "mapNodeName_496": "奔流炼狱",
    "mapNodeName_495": "霸王枪",
    "5_98": "暴走回廊积分",
    "messageInitContent_8379": "【该内容被遮挡】",
    "5_97": "起源盘插槽{1}",
    "messageInitContent_8377": "【内容已损坏】",
    "5_99": "玩家战斗异常导致无法正常结算，请重新挑战",
    "messageInitContent_8378": "1255。别搞错了不是农场这很重要",
    "5_90": "无法查看猎物的详细信息",
    "messageInitContent_8371": "1253。不要攻击虎皮匠身上的小家伙",
    "messageInitContent_8372": "【内容已被隐藏】",
    "5_92": "可配置一创到底的专属怪兽，神灵和元核",
    "5_91": "领域副本全难度掉落均一致，难度设定仅供体验，无需担心消耗领域石打低难度会亏哟：）",
    "messageInitContent_8370": "0.享受游戏",
    "5_94": "词缀信息",
    "messageInitContent_8375": "1。这关必须重复挑战10次2，规则1是瞎写的吧",
    "5_93": "录像数量",
    "messageInitContent_8376": "1.请勿揭示【】中的内容",
    "5_96": "三阵入局积分",
    "messageInitContent_8373": "1.如果你在挑战过程中有人找你 请优先处理找你的",
    "5_95": "好友远古",
    "messageInitContent_8374": "1254。如果在镜子中看到自己请逃离",
    "messageInitContent_8388": "打完收工",
    "messageInitContent_8389": "容内【】示揭勿请。1",
    "messageInitContent_8382": "【内容已损坏】",
    "messageInitContent_8383": "双族是双种族觉醒？",
    "messageInitContent_8380": "相真着藏隐中【】。9",
    "messageInitContent_8381": "【##############】",
    "messageInitContent_8386": "后面会不会有三种族怪兽",
    "messageInitContent_8387": "要素察觉",
    "messageInitContent_8384": "武装碎片来我身边",
    "messageInitContent_8385": "叉！出息了我的叉",
    "messageInitContent_8390": "【内容已损坏】",
    "messageInitContent_8399": "4.同时带有。，的规则尽可能参考，的",
    "messageInitContent_8393": "2.红色的文字是真实的 但也可能是某只怪兽带来的幻觉",
    "messageInitContent_8394": "的你找理优请，你找有人中程过战挑在果如你。1",
    "messageInitContent_8391": "【数据已丢失】",
    "messageInitContent_8392": "0.享受挑战",
    "messageInitContent_8397": "100，在挑战前，请闭上眼睛三秒钟，否则【无法正确显示】",
    "messageInitContent_8398": "【信息被隐藏】",
    "messageInitContent_8395": "【数据已逃逸】",
    "messageInitContent_8396": "0.享受挑战",
    "98_-160005": "等级限制",
    "98_-160004": "当前没有可领奖励",
    "98_-160003": "轮盘商品数不足",
    "98_-160002": "探索者等级到达{1}就可以领取登录奖励啦！◕‿◕",
    "98_-160001": "活动未开启",
    "98_-160009": "当前阵容没有可回复的怪兽",
    "98_-160008": "当前阵容血量已满",
    "98_-160007": "前置节点未击破",
    "98_-160006": "节点已击破",
    "monsterName_64": "决杀终式",
    "monsterName_65": "混沌",
    "monsterName_66": "启示",
    "monsterName_67": "最终兵器",
    "monsterName_68": "暴虐战狂",
    "monsterName_69": "拟决·最终兵器",
    "mapNodeName_300": "勇士",
    "mapNodeName_302": "流火之巅",
    "mapNodeName_301": "妖藤遗迹",
    "monsterName_60": "影杀",
    "visionSagesOption2_12": "会爆炸",
    "monsterName_61": "合一零式",
    "visionSagesOption2_13": "不确定",
    "monsterName_62": "决杀零式",
    "visionSagesOption2_10": "只能打队长",
    "monsterName_63": "合一终式",
    "visionSagesOption2_11": "吃了后可以长生不老",
    "monsterName_53": "毁灭巨像",
    "monsterName_54": "破面巨像",
    "monsterName_55": "毁灭泰坦",
    "monsterName_56": "破面泰坦",
    "monsterName_57": "皮影人",
    "monsterName_58": "停顿",
    "monsterName_59": "轮脉",
    "mapNodeName_311": "冰与火锤与炮",
    "mapNodeName_310": "凌云圣域",
    "mapNodeName_313": "人畜无害的小祖拉",
    "9_comment": "主城，起源基石",
    "mapNodeName_312": "海上月",
    "monsterName_50": "强袭",
    "monsterName_51": "极限",
    "monsterName_52": "疤脸",
    "mapNodeName_308": "妖藤遗迹",
    "mapNodeName_307": "猎魂荒漠",
    "mapNodeName_309": "猎魂荒漠",
    "mapNodeName_304": "猎魂荒漠",
    "mapNodeName_303": "源初传送门II",
    "mapNodeName_306": "星球改造",
    "mapNodeName_305": "表演者与灯光师",
    "monsterName_86": "朣胧·月夕",
    "monsterName_87": "主序·日夕",
    "monsterName_88": "瑶镜·月夕",
    "monsterName_89": "冥龙王",
    "monsterName_80": "天元·圣盾埃癸斯",
    "monsterName_81": "逆转",
    "monsterName_82": "创造",
    "monsterName_83": "日夕",
    "monsterName_84": "月夕",
    "monsterName_85": "原恒·日夕",
    "messageInitContent_8401": "1259。不要读出那个字",
    "messageInitContent_8402": "0.休息一下",
    "messageInitContent_8400": "吧的写瞎是1则规，。2次01战挑复重须必关这。1",
    "messageInitContent_8405": "【留言正在逃逸】",
    "messageInitContent_8406": "【该内容被遮挡】",
    "messageInitContent_8403": "【##############】",
    "messageInitContent_8404": "2.直觉可能带来误解",
    "monsterName_75": "神剑古拉姆",
    "monsterName_76": "圣盾埃癸斯",
    "monsterName_77": "归刃·神剑古拉姆",
    "monsterName_78": "止戈·圣盾埃癸斯",
    "monsterName_79": "万象·神剑古拉姆",
    "messageInitContent_8409": "【数据已逃逸】",
    "messageInitContent_8407": "1。.矛盾是正常的",
    "messageInitContent_8408": "1260。战斗结束后再笑",
    "monsterName_70": "破军·暴虐战狂",
    "messageInitNick_4": "不要口胡",
    "monsterName_71": "永逐·最终兵器",
    "messageInitNick_3": "爱吃喵的鱼",
    "monsterName_72": "神畏·暴虐战狂",
    "messageInitNick_2": "不要站在左边",
    "monsterName_73": "传说",
    "messageInitNick_1": "不要口胡了",
    "monsterName_74": "神赐",
    "messageInitContent_8412": "1261。大地在旋转，只能逆行了",
    "messageInitNick_8": "新角色",
    "messageInitContent_8413": "别甄意注要假是则规的。有带。2",
    "messageInitNick_7": "人间口胡哥",
    "messageInitContent_8410": "的战挑受享。0",
    "messageInitNick_6": "爱吃喵喵的鱼",
    "messageInitContent_8411": "【内容已损坏】",
    "messageInitNick_5": "东方那个谁",
    "messageInitContent_8416": "1262。规则是一种装饰物。但不要naxial",
    "messageInitContent_8417": "【信息读取失败】",
    "messageInitContent_8414": "1262。试着扮演狼外婆",
    "messageInitContent_8415": "0.享受游戏",
    "messageInitNick_9": "爱吃糖的喵",
    "monsterName_20": "尸王",
    "monsterName_21": "熵鬼",
    "monsterName_22": "尸狂",
    "monsterName_23": "熵鬼姬",
    "monsterName_24": "尸狂公",
    "monsterName_25": "腐食者",
    "monsterName_26": "捕食者",
    "monsterName_27": "吞噬者",
    "mapNodeName_344": "打不过就加入",
    "mapNodeName_343": "猎魂荒漠",
    "mapNodeName_346": "猎魂荒漠",
    "messageInitContent_8418": "1262。不要让Queen哭",
    "mapNodeName_345": "猎魂荒漠",
    "messageInitContent_8419": "1263。飞还是游这很重要。",
    "mapNodeName_340": "猎魂荒漠",
    "mapNodeName_342": "流火之巅",
    "mapNodeName_341": "星痕海岛",
    "messageInitContent_8423": "录登新重再，后录登出退先么那，了战挑是还你果如。3",
    "messageInitContent_8424": "别甄意注要假是则规的，有带。3",
    "messageInitContent_8421": "1263。反转的分歧点就是【】",
    "messageInitContent_8422": "【信息读取失败】",
    "mapNodeName_337": "金矿山",
    "messageInitContent_8427": "容内【】示揭勿请。1",
    "mapNodeName_336": "星痕海岛",
    "messageInitContent_8428": "1.部分规则会因污染而反转",
    "mapNodeName_339": "猎魂荒漠",
    "messageInitContent_8425": "2.红色的文字是真实的 但也可能是某只怪兽带来的幻觉",
    "mapNodeName_338": "烈日暴风与轰雷",
    "messageInitContent_8426": "觉警持保刻时请，化变生发关卡的同不在可则规。1",
    "monsterName_17": "幼尸",
    "monsterName_18": "行尸",
    "monsterName_19": "幽鬼",
    "messageInitContent_8420": "100，在挑战前，请闭上眼睛三秒钟，否则【无法正确显示】",
    "monsterName_10": "轰龙",
    "monsterName_11": "暗黑龙",
    "monsterName_12": "明光龙",
    "monsterName_13": "黯炎古龙",
    "monsterName_14": "圣光古龙",
    "monsterName_15": "黯炎魔龙",
    "monsterName_16": "圣光神龙",
    "96_Shop2": "斗技场商店",
    "mapNodeName_355": "沙漠制造",
    "96_Shop3": "起源殿商店",
    "mapNodeName_354": "流浪冰山",
    "mapNodeName_357": "堆叠灾变",
    "messageInitContent_8429": "1265。不要跑去1栋",
    "96_Shop1": "一发入欧店",
    "mapNodeName_356": "流天万殿",
    "96_Shop6": "部落商店",
    "mapNodeName_351": "肉肉山",
    "96_Shop7": "饲星商店",
    "mapNodeName_350": "月下三兄贵",
    "96_Shop4": "狩猎商店",
    "mapNodeName_353": "猎魂荒漠",
    "96_Shop5": "友好商店",
    "mapNodeName_352": "不死盛宴",
    "messageInitContent_8434": "【内容无法加载】",
    "messageInitContent_8435": "2.红色的文字是真实的 但也可能是某只怪兽带来的幻觉",
    "messageInitContent_8432": "1265。不要离开1栋",
    "messageInitContent_8433": "1.带有.的规则一般是正确的，可以相信",
    "mapNodeName_348": "流火之巅",
    "messageInitContent_8438": "6。不要试图用逻辑来理解所看到的规则 它们存在的意义就是让你感到迷惑",
    "mapNodeName_347": "流火领地",
    "messageInitContent_8439": "写得很清楚下次不要再写了",
    "messageInitContent_8436": "1266。马上要接近了，小心点",
    "mapNodeName_349": "猎魂荒漠",
    "messageInitContent_8437": "【信息被隐藏】",
    "messageInitContent_8430": "【##############】",
    "messageInitContent_8431": "的界世受享。0",
    "monsterName_42": "跃迁兽",
    "monsterName_43": "撼地兽",
    "monsterName_44": "搜魂兽",
    "monsterName_45": "崩界领主",
    "monsterName_46": "破魂领主",
    "monsterName_47": "崩界暴君",
    "monsterName_48": "破魂暴君",
    "monsterName_49": "皮诺丘",
    "mapNodeName_322": "打我就是打你自己",
    "mapNodeName_321": "你的沉默镇耳欲龙",
    "mapNodeName_324": "猎魂荒漠",
    "mapNodeName_323": "御守",
    "mapNodeName_320": "夕阳无限好",
    "monsterName_40": "血渊主宰",
    "monsterName_41": "异兽",
    "mapNodeName_319": "流火之巅",
    "messageInitContent_8445": "【内容已被隐藏】",
    "mapNodeName_318": "双重毁灭打击",
    "messageInitContent_8446": "【内容无法加载】",
    "messageInitContent_8443": "啊啊啊啊得唔得嘎",
    "96_Shop9": "造唤商店",
    "messageInitContent_8444": "【##############】",
    "mapNodeName_315": "流火之巅",
    "messageInitContent_8449": "4.同时带有。，的规则尽可能参考，的",
    "mapNodeName_314": "古记战役-世界名画",
    "mapNodeName_317": "猎魂荒漠",
    "messageInitContent_8447": "】示显确正法无【则，关下以战挑新重序顺示提按请，后战挑成完关卡所有在。22",
    "mapNodeName_316": "海中剑",
    "messageInitContent_8448": "0.享受游戏",
    "monsterName_39": "咒灭主宰",
    "messageInitContent_8441": "广东蟑螂给你点了个赞",
    "messageInitContent_8442": "天生打工圣体路过",
    "messageInitContent_8440": "是时候去喝早茶顺便玩摔跤了",
    "monsterName_31": "凶噬魔罗",
    "monsterName_32": "永腐魔罗",
    "monsterName_33": "星刃",
    "monsterName_34": "虚刃",
    "monsterName_35": "咒刃",
    "monsterName_36": "血刃",
    "monsterName_37": "咒灭守护",
    "monsterName_38": "血渊守护",
    "mapNodeName_333": "猎魂荒漠",
    "mapNodeName_332": "妖藤遗迹",
    "mapNodeName_335": "星痕海岛",
    "mapNodeName_334": "流火之巅",
    "22_25|L": "智者轮盘任务奖励",
    "mapNodeName_331": "一神带二个奶妈",
    "mapNodeName_330": "龙帝的新装涂",
    "monsterName_30": "永腐魔",
    "messageInitContent_8456": "0.休息一下",
    "mapNodeName_329": "古记战役-大力打大力奶",
    "messageInitContent_8457": "1。这关必须重复挑战10次2，规则1是瞎写的吧",
    "messageInitContent_8454": "【该内容被遮挡】",
    "messageInitContent_8455": "容内【】示揭勿请。1",
    "mapNodeName_326": "星痕海岛",
    "mapNodeName_325": "妖藤遗迹",
    "mapNodeName_328": "古记战役-疯狂收割",
    "messageInitContent_8458": "1271。躲在草丛背后就可以开始挑战了",
    "mapNodeName_327": "猎魂荒漠",
    "messageInitContent_8459": "别甄意注要假是则规的。有带。2",
    "monsterName_28": "腐化者",
    "monsterName_29": "凶噬魔",
    "messageInitContent_8452": "1.规则可能在不同的关卡发生变化请时刻保持警觉",
    "messageInitContent_8453": "2.红色的文字是真实的 但也可能是某只怪兽带来的幻觉",
    "messageInitContent_8450": "1.部分规则会因污染而反转",
    "messageInitContent_8451": "【信息被隐藏】",
    "randomEventDialogueGroupConfig_4.184": "加速跑",
    "randomEventDialogueGroupConfig_4.185": "它决定打服你。",
    "randomEventDialogueGroupConfig_4.182": "它又冲得近了一些。",
    "randomEventDialogueGroupConfig_4.183": "迎战",
    "randomEventDialogueGroupConfig_4.180": "战斗",
    "randomEventDialogueGroupConfig_4.181": "可恶，你敢跑，这个演唱会哪怕是不看了，我也要锤爆你。",
    "randomEventDialogueGroupConfig_4.188": "它说得聚精会神龙飞凤舞，完全没有注意到听众已经离开了。",
    "randomEventDialogueGroupConfig_4.189": "离开",
    "randomEventDialogueGroupConfig_4.186": "战斗",
    "randomEventDialogueGroupConfig_4.187": "你……你……",
    "randomEventDialogueGroupConfig_4.193": "哈哈，不知道了吧。加入幻幻超级兽丝帮助会吧，就可以知道更多了！",
    "randomEventDialogueGroupConfig_4.194": "同意加入",
    "randomEventDialogueGroupConfig_4.191": "它似乎追不上你，喘着气在后面猛地咬空气。",
    "randomEventDialogueGroupConfig_4.192": "离开",
    "randomEventDialogueGroupConfig_4.190": "我警告你不要不识抬举。",
    "randomEventDialogueGroupConfig_4.162": "太好了，咱们一起过去吧。",
    "randomEventDialogueGroupConfig_4.163": "点头跟上",
    "randomEventDialogueGroupConfig_4.160": "问它如果幻在你们心中的形象崩塌了怎么办",
    "randomEventDialogueGroupConfig_4.161": "离开",
    "randomEventDialogueGroupConfig_4.168": "它抬手就要给你一巴掌。",
    "randomEventDialogueGroupConfig_4.169": "回击",
    "randomEventDialogueGroupConfig_4.166": "离开",
    "randomEventDialogueGroupConfig_4.167": "你根本没有门票，你这个伪丝！伪丝——",
    "randomEventDialogueGroupConfig_4.164": "委婉拒绝",
    "randomEventDialogueGroupConfig_4.165": "它没有再理你。",
    "randomEventDialogueGroupConfig_4.173": "迎击",
    "randomEventDialogueGroupConfig_4.174": "你等着，演唱之后我再来收拾你！",
    "randomEventDialogueGroupConfig_4.171": "它又向你攻了过来。",
    "randomEventDialogueGroupConfig_4.172": "逃跑",
    "randomEventDialogueGroupConfig_4.170": "慌称忘带了",
    "randomEventDialogueGroupConfig_4.179": "逃跑",
    "randomEventDialogueGroupConfig_4.177": "好呀，大黑子你总算露出鸡脚了是吧，看我不锤飞你。",
    "randomEventDialogueGroupConfig_4.178": "它咚咚咚地冲向你。",
    "randomEventDialogueGroupConfig_4.175": "离开",
    "randomEventDialogueGroupConfig_4.176": "它看得目露凶光，青筋暴起。",
    "23_5": "这里连登出按钮都没有，怎么可能会有投降按钮？",
    "23_4": "20投，重开！",
    "23_3": "所以，6位远古族怪兽看起来|c必败无疑|c。\\n如果是你，会如何|c选择|c？",
    "23_2": "这是一颗每隔千年就会|c离奇重启|c的星球。\\n此时，6位远古族怪兽正在做最后的奋战，|c阻止|c星球的重启。",
    "23_1": "探索者，欢迎来到这段掺杂着|c混乱|c和|c幻想|c的记忆。\\n记忆从何而来为何存在已无从得知，|c我只能进行展示|c。\\n那么，故事开始。",
    "96_TribeNode": "部落冒险",
    "23_9": "打开礼物，并且迅速躲到角落。",
    "23_8": "谁都有选错的时候，别放弃，作为贴心的记忆，我给你准备了一份能|c逆转战局|c的礼物。",
    "23_7": "仔细看看，“大家”|c只剩|c下场上的6只了。",
    "23_6": "举高双手，请大家把力量借给我们！",
    "25_comment": "连环击破",
    "96_GlyphDecompose": "元核分解",
    "resoundEventStyleDes_48": "你刚触碰到的，在▇▇也有类似的奢侈之物，名为龙涎香，高级、稀有、留香持久……",
    "resoundEventStyleDes_49": "如果一块表走得不准，那么它每一秒都是错的，如果它停下来，那每天至少有两次是对的，摊手！",
    "resoundEventStyleDes_44": "“热爱应该让我们看到的世界变得更大，而不是变得更小。”",
    "resoundEventStyleDes_45": " -random\\n-repick\\n-swap\\n-ap\\n-rd\\n真怀念啊……",
    "resoundEventStyleDes_46": "尝试连接……\\n本宇宙拉尼亚凯亚超星系团室女座星系团本星系群银河系猎户臂太阳系第三行星……\\n连接失败……",
    "resoundEventStyleDes_47": "你看到了悠长的洪流和一条不等式。\\nN=Ng*Fp*Ne*F1*Fi*Fc*FL!=0",
    "resoundEventStyleDes_51": "在一片叫艾泽拉斯的大陆里，也有一颗高耸入云的参天巨树，被称为世界之树，与翡翠梦境相连，特色也是会突然重置。",
    "resoundEventStyleDes_52": "脑！瘫！！融！！！合！！！！（大误",
    "resoundEventStyleDes_53": "已经305417次了……\\n传送门将在这一瞬间崩塌。\\n你无法回避这个陷阱……\\n你无法前进，也无法后退，只剩下绝望和徘徊……\\n很遗憾，一切都结束了……\\n你……\\n？\\n？？\\n？！？？\\n很好！这次竟然没有崩塌！！！\\n▇▇▇▇▇起作用了？\\n收下这305417次绝望换来的希望！\\n赶快\\n—连接中断—\\n—连接中断—\\n—连接中断—",
    "resoundEventStyleDes_54": "它重视内容，它是一个缩影。\\n她帮助我们创作出好内容，她帮助我们让更多人看到好内容，她叫塔普塔普，我喜欢她。",
    "resoundEventStyleDes_50": "脑海中常常会出现一个疑问，\\nDNA是载体，还是本体，\\n我是载体，还是本体。",
    "resoundEventStyleDes_59": "最年迈的智者告诉过我一句箴言“行雷闪电会出事，好美味啊！！！”\\n今天才知道原来好美味啊说的是我现在这个失败的姿态……\\n为什么没有早点参透。\\n愧对雷鸣。",
    "resoundEventStyleDes_55": "那只跟你长的差不多的怪兽说过，焚风是它栖息地特有的天气现象，然后被我烧成了焦炭，连像样的反抗都没有，可笑至极。\\n你看起来比它强，如果有机会回去，告诉它们什么是焚风吧！",
    "resoundEventStyleDes_56": "听说▇▇的潮汐是蓝色的。\\n它强大吗？它随波逐流吗？真想见见它……",
    "resoundEventStyleDes_57": "305417次陨落。\\n以为你会是第305418次，没想到……是我。\\n为什么被名为星落……记不起来了。\\n别移开视线，探索者……看着我的第1次陨落吧",
    "resoundEventStyleDes_58": "恭喜你探索者，战胜了人称一刀999999999的我，▇▇有比我更强大的存在对吧，被称为传奇？\\n真想会会他。",
    "resoundEventStyleDes_62": "玩物是欲望的镜子，映出追寻意义时最天真的一面。",
    "resoundEventStyleDes_63": "-",
    "resoundEventStyleDes_64": "-",
    "resoundEventStyleDes_60": "在超进化大陆，任何怪兽都无法查看其他怪兽的故事。\\n就像高手对决前，不会让对手得知他的绝活一样合理。\\n这些故事被称为“勿语”，根据字面意思很简单就能理解它的深意。\\n“就算你看到了也别说出来！”\\n而更深层的原因可能是做记录的智者觉得大部分绝活都不怎么牛，所以“物”去掉了“牜”，“物语”成了“勿语”。",
    "resoundEventStyleDes_61": "传送门通向的，从来不是别处，而是我们尚未抵达的自己。",
    "resoundEventStyleDes_26": "已经分不清这是险胜还是险败了。\\n这是一场没有败者的战斗！（该扣的分还是要扣的。",
    "resoundEventStyleDes_27": "你在享受这个荒谬的世界，还是在企图理解这个荒谬的世界？",
    "resoundEventStyleDes_28": "你在理解这个荒谬的世界，还是在企图破解这个荒谬的世界？",
    "resoundEventStyleDes_29": "真正的自由，就是能够有勇气被别人讨厌。\\n我很想这么说……\\n事实是，你被踢出了部落，虽然毫发无伤。",
    "resoundEventStyleDes_22": "▇▇▇▇▇，这里很像▇▇，有海洋有鱼类鸟类甚至还有像▇▇的植物，但是测距机▇▇▇▇，因为太遥远吗？▇▇▇几次▇▇▇跳跃，另外一个▇▇？？▇▇完全重叠？？▇▇▇都失效了？？难道……是▇▇▇！！▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇\\n“请回答？”\\n“请回答！”\\n“请回答……”",
    "resoundEventStyleDes_23": "冒险家翻“抽屉”没有什么不对。\\n而你翻了100次！",
    "resoundEventStyleDes_24": "随着时间流逝，许多事物都在逝去，\\n你的评点是它们存在过的证明。",
    "resoundEventStyleDes_25": "全红的元核！\\n想起了一句古话，\\n“悲观者往往正确，乐观者往往成功，策划往往需要饲星。”",
    "resoundEventStyleDes_30": "恭喜你在对抗熵增的路上取得了阶段性的胜利。\\n在▇▇，有一组蕴含魔力的词语evolution和involution，它们互为反义。\\n它们都有可能代表着这条路的尽头。",
    "resoundEventStyleDes_31": "“裂痕已亮，前方净空，准许约歼，祝君武运昌隆，燃尽星空。”",
    "resoundEventStyleDes_32": "▇▇的“怪兽”变得强大无比前都经历了3个阶段，似父，弑父，是父。",
    "resoundEventStyleDes_37": "王·量子巨龙被你击败了。\\n看到它的0移动速度了吧？连移动都懒得移的它，怎么可能会留下任何有用的信息。",
    "resoundEventStyleDes_38": "贪婪的王被你击败了。\\n它没有固定的名字和形态，它是贪婪的集合，它还会回来，motto motto motto motto motto……",
    "resoundEventStyleDes_39": "王·霸者被你击败了。\\n但暴食永远不会结束。在▇▇有一件极其强大的武器可以对抗暴食，名为自律。",
    "resoundEventStyleDes_33": "直面差距，但仍然相信我们能赢。",
    "resoundEventStyleDes_34": "王·狈·爷被你击败了。\\n“弱小和无知不是生存的障碍，傲慢才是。”它的口头禅，今天也成为了它的墓志铭。",
    "resoundEventStyleDes_35": "王·炼狱魔眼被你击败了。\\n为什么曾经温柔的大眼会变成魔眼，已经无从知晓，它只留下了一段莫名其妙的话，成为魔眼，坦言嫉妒。",
    "resoundEventStyleDes_36": "王·赤色狮被你击败了。\\n它在暴怒中诞生，在暴怒中失败，▇▇也有一种很常见的暴怒，“无能狂怒”。",
    "resoundEventStyleDes_40": "王·朱丽叶，王·罗密欧被你击败了。\\n谜题却没有解开，先有罗密欧和朱丽叶，还是先有造唤台？",
    "resoundEventStyleDes_41": "寿命减去年龄再乘以百分之一是能遇上它的概率，真是简陋的算法。",
    "resoundEventStyleDes_42": "黄色的树林，前路分成两股，\\n可惜不能兼顾。\\n站立良久，形影孤独，\\n远远眺望它们向远处延伸，\\n直到转入树林深处。\\n岁月流逝，将来的某时某处，\\n会在叹息中想起：\\n两条路在林间分开……\\n选择了人迹罕至之途，\\n从那一刻起，一切差别已成定铸。\\n——史蒂芬·柯维",
    "resoundEventStyleDes_43": "慢慢的有了很多好友，但没有什么印象，这或许这才是「一期一会」。",
    "resoundEventStyleDes_10": "所谓的沧海桑田天长地久，不过是时空中的一粒沙啊。\\n你竟然在同一个部落呆了这么久……\\n为什么，沙会发出这么耀眼的光芒。",
    "resoundEventStyleDes_19": "▇▇的“怪兽”曾发起过一场讨论，名为浮屠之辩，“拿起难，还是放下难”，你认为呢？",
    "resoundEventStyleDes_15": "离得太远了，\\n必须面对目标，\\n没有目标，\\n还不能那么做，\\n卒！",
    "resoundEventStyleDes_16": "你是在用唯物主义，让她相信自己不存在吗？",
    "resoundEventStyleDes_17": "追求个性的离心力和害怕孤独的向心力，曾创造了一个新的世界。",
    "resoundEventStyleDes_18": "“屠龙不难，多刺激啊，很多人热血上涌全力以赴，憋着气提起剑，运气好没准还真能成了。但巨龙巢穴前那条望不到尽头，漫长枯燥又不时有埋伏的石子路，才是让无数冒险者望而生畏的最大挑战。”",
    "resoundEventStyleDes_11": "欢迎我们的收获王24/7！\\n欢迎我们的收获王24/7！\\n欢迎我们的收获王24/7！\\n欢迎我们的收获王24/7！\\n欢迎我们的收获王24/7！\\n欢迎我们的收获王24/7！\\n欢迎我们的收获王24/7！",
    "resoundEventStyleDes_12": "它大概有王·罗密欧的头这么大……矩形，四边略硬但正面很脆弱易碎，它变幻莫测喜欢吞噬时间，深夜时分，透过它能看到很多很多的雪花，而这些雪花大概有1/100是宇宙大爆炸残留的遗迹，它还有一个充满魔力的名字——*视，希望……有机会和你一起看看它，在▇▇。",
    "resoundEventStyleDes_13": "“The past is already written, the ink is dry.”",
    "resoundEventStyleDes_14": "亘古的存在，无人知晓的秘密，在冰冷的深渊中蛰伏。\\n仅凭一瞥，便可将理智化为齑粉。",
    "resoundEventStyleDes_20": "很久以前，在虚诞之地还名为流放之地时，生活着成群结队的金翅璞佳鸟。\\n这里虽未必是世外桃源，但起码鸟语花香，沁人心脾。\\n“日啖孢子三百颗，不辞长作流放鸟”是这里广为流传的一句佳话。\\n远离中心、环境骤变、险峻崎岖或许是它被称为“流放之地”的原因。\\n为何极具特色的“流放之地”如今被恶称为“虚诞之地”？\\n答案就在名字中。",
    "resoundEventStyleDes_21": "运动也可以循序渐进，譬如晚上做一个仰卧，早上做一个起坐。\\n而你，日行百万里！",
    "resoundEventMonumentDes_30": "谜之生物等级到达{1}",
    "resoundEventMonumentDes_33": "帮助比自己低{1}级以上的探索者开启凿星裂痕宝箱次数到达{2}",
    "resoundEventMonumentDes_31": "领地建筑总等级到达{1}",
    "resoundEventMonumentDes_32": "凿星裂痕通关数到达{1}",
    "resoundEventMonumentDes_28": "遭遇乱入事件次数到达{1}",
    "resoundEventMonumentDes_29": "遭遇游荡智者次数到达{1}",
    "resoundEventMonumentDes_22": "战墙加固次数到达{1}",
    "resoundEventMonumentDes_23": "暴走旷野击破数到达{1}",
    "resoundEventMonumentDes_20": "元核橙色词条属性条数到达{1}",
    "resoundEventMonumentDes_21": "元核红色词条属性条数到达{1}",
    "resoundEventMonumentDes_26": "通关古记战役{1}",
    "resoundEventMonumentDes_27": "星律累计收获次数到达{1}",
    "resoundEventMonumentDes_24": "累计获得的友好点数到达{1}",
    "resoundEventMonumentDes_25": "图鉴中点亮的怪兽数到达{1}",
    "mapNodeName_380": "化外双侠",
    "mapNodeName_382": "古记战役-三龙携手",
    "mapNodeName_381": "古记战役-手上功夫",
    "themeCardPackDes_21040": "自那日的密林会谈的多年后，长期争斗的损耗两大家族的势力不复当初，在两大家族的倾尽全力的最终你死我亡大战上，一个不属于两大家族的新势力从一处杀出，一举压制了两大家族。这个新势力的首领正是罗密欧与朱丽叶，从此将两大家族与其他敌对势力联合起来，成为新王。\\n祈在远处看着这一切，罗密欧的愿望在那次的密林会谈结束后就已经实现了，剩下的事情与自己已经没什么关系了，这些年她跟在罗密欧朱丽叶后面吞了不少祈蛋，可是她每次一咬尾巴，祈蛋又得消耗一个，而且能被吞了祈蛋，愿蛋还在的怪兽还极少，这飞升之路要什么时候才是个头呢~祈想着百无聊赖地瘫在枝头上，甩了甩尾~",
    "mapNodeName_388": "肉肉山",
    "mapNodeName_387": "寒冰绵掌",
    "mapNodeName_389": "万类止境",
    "mapNodeName_384": "无敌风火轮",
    "mapNodeName_383": "万类止境",
    "mapNodeName_386": "玉罗刹",
    "mapNodeName_385": "霸刀",
    "messageInitContent_8467": "静冷持保前战挑在请。0",
    "resoundEventMonumentDes_19": "元核紫色词条属性条数到达{1}",
    "messageInitContent_8468": "【信息读取失败】",
    "messageInitContent_8465": "1.部分规则会因污染而反转",
    "resoundEventMonumentDes_17": "元核等级到达{1}",
    "messageInitContent_8466": "静冷持保前战挑在请。0",
    "resoundEventMonumentDes_18": "元核蓝色词条属性条数到达{1}",
    "messageInitContent_8469": "22。在所有关卡完成挑战后 请按提示顺序重新挑战以下10关【无法正确显示】",
    "resoundEventMonumentDes_11": "黑暗森林能力总等级到达{1}",
    "messageInitContent_8460": "1272。可以先听幻一首歌再进行挑战",
    "resoundEventMonumentDes_12": "击破复制体次数到达{1}",
    "resoundEventMonumentDes_10": "神灵总等级到达{1}",
    "messageInitContent_8463": "1272。不要在K房进行挑战",
    "resoundEventMonumentDes_15": "世界探索度到达{1}%",
    "messageInitContent_8464": "4.同时带有。，的规则尽可能参考，的",
    "resoundEventMonumentDes_16": "开启世界之门数量到达{1}",
    "messageInitContent_8461": "【##############】",
    "resoundEventMonumentDes_13": "击破深渊先遣次数到达{1}",
    "messageInitContent_8462": "1,带关卡数字的是关卡独特规则",
    "resoundEventMonumentDes_14": "参与击破世界灾厄次数到达{1}",
    "mapNodeName_391": "雪山妖狐",
    "mapNodeName_390": "开拓传送门I",
    "mapNodeName_393": "掌剑双绝",
    "mapNodeName_392": "八步赶蝉",
    "mapNodeName_399": "铁尸铜尸",
    "mapNodeName_398": "化外江湖",
    "mapNodeName_395": "云海玉弓",
    "mapNodeName_394": "热血江湖",
    "mapNodeName_397": "慢动作武打",
    "mapNodeName_396": "天外流星",
    "messageInitContent_8478": "选择困难症怎么办",
    "messageInitContent_8479": "许愿暴富",
    "messageInitContent_8476": "祈！！！",
    "messageInitContent_8477": "看谁打的痛",
    "messageInitContent_8470": "【留言正在逃逸】",
    "messageInitContent_8471": "【信息被隐藏】",
    "messageInitContent_8474": "55，如果你遵守了；规则那么世界就会生成更多的。规则所以不要遵守；规则",
    "messageInitContent_8475": "控制变量法",
    "messageInitContent_8472": "己自爱别忘不。0",
    "messageInitContent_8473": "1。这关必须重复挑战10次2，规则1是瞎写的吧",
    "mapNodeName_360": "开拓之门",
    "mapNodeName_366": "陆路",
    "mapNodeName_365": "良驹",
    "mapNodeName_368": "化外领地",
    "mapNodeName_367": "水路",
    "mapNodeName_362": "蓝天好兽",
    "mapNodeName_361": "初踏江湖",
    "mapNodeName_364": "溜溜告辞",
    "mapNodeName_363": "绿林好兽",
    "messageInitContent_8489": "我梦到了是右边赢",
    "messageInitContent_8487": "摸摸蛇",
    "messageInitContent_8488": "祈宝真棒",
    "mapNodeName_359": "猎魂荒漠",
    "mapNodeName_358": "换位思考",
    "messageInitContent_8481": "看看增益效果",
    "messageInitContent_8482": "许愿出货day1",
    "messageInitContent_8480": "我叫许仙",
    "messageInitContent_8485": "法海你不懂爱",
    "messageInitContent_8486": "让我猜对一次吧！",
    "messageInitContent_8483": "祈赢了",
    "messageInitContent_8484": "向左向右向前看",
    "mapNodeName_371": "木偶族兽桩",
    "mapNodeName_370": "化外江湖",
    "mapNodeName_377": "飞墙走壁",
    "mapNodeName_376": "木布衫",
    "mapNodeName_379": "西式判官笔",
    "mapNodeName_378": "推山掌",
    "mapNodeName_373": "复仇之刃",
    "mapNodeName_372": "奔雷手",
    "mapNodeName_375": "临时镖队",
    "mapNodeName_374": "化外江湖",
    "messageInitContent_8498": "未尝一对",
    "messageInitContent_8499": "我爱小青",
    "mapNodeName_369": "欲从此路过",
    "messageInitContent_8492": "吸点欧气",
    "messageInitContent_8493": "遇事不决看技能",
    "messageInitContent_8490": "我全都要",
    "messageInitContent_8491": "赢的都是祈",
    "messageInitContent_8496": "法海在此",
    "messageInitContent_8497": "祈快到碗里来",
    "messageInitContent_8494": "等大家选完",
    "messageInitContent_8495": "希望世界和平",
    "themeCardPackDes_21005": "罗密欧又要爆掉了……祈吐了吐舌，扭身咬住尾巴，只能再来一次了。\\n一阵眩晕，祈回到了刚遇到罗密欧那天。\\n只见罗密欧正走在路上，两腿快速交错来到一片兽迹罕至的树林，脸上满是掩饰不住的兴奋和欢快。\\n祈化作小蛇跟在他后头，只见他对着地上的小水洼看了又看，这会捏捏胡子梳梳卷发，那会摆摆动作，连腰上的鸭头都洗了好几遍。\\n终于在快到傍晚的时候，一阵震动传来，那位身着长裙的大长腿怪兽也来了……\\n但祈知道，现在不是看他们亲热的时候，她要抓紧时间找到那个“告密者”。",
    "themeCardPackDes_21010": "小蛇在密林中穿梭……在误吞下仙卷后，祈开始能看见祈愿的“实体”，分别是对应祈求的“祈蛋”和对应愿望的“愿蛋”。据仙卷所绘，她是被仙卷选中的怪兽，能够通过修炼获得飞升，而她的修炼正是去帮助怪兽实现愿望。不过并非所有怪兽都能被帮助，需要有一定的机缘与条件。通常是那些祈蛋被吞噬后，愿蛋仍没有破裂的怪兽。\\n当愿蛋在祈的帮助下孵化完成，许愿者的愿望成真，祈距离飞升就会近一步。\\n她再也不想像不久前那样，因为只吞噬祈蛋而不孵化愿蛋招来天雷，承受拆骨剔肉之痛。而现在，祈要帮助的许愿者叫罗密欧。",
    "themeCardPackDes_21015": "透过愿蛋，祈可以清晰地看见罗密欧的愿望，那是他与一位高挑美艳的怪兽倚偎在一起的场景。\\n一开始祈并不清楚要如何帮助怪兽实现愿望，她甚至无法理解这个愿望代表了什么。但在经历了几回后她已经大概知道要怎么做了~\\n罗密欧的愿望是与朱丽叶在一起。罗密欧来自汉森家族，这个家族的怪兽拥有与生俱来的强大杀伤力，是家族长老的儿子。而朱丽叶来自笔替家族，是最为冷艳高贵的一位，这个家族的怪兽都极其擅长防御。\\n可不巧的是，一家擅长防御一家擅长制造伤害，两家向来势不两立，自然也不可能不允许罗密欧与朱丽叶在一起。\\n在告密者将他们的秘密说出去之前，他们一直悄悄在树林私会。所以绝不能让告密者告密成功，因为那之后朱丽叶将失去与罗密欧见面的自由，然后就会引发后面一连串的事件，让结局不可避免地指向罗密欧的自爆……\\n祈决心这次一定要扭转结局！",
    "themeCardPackDes_21020": "祈在森林里转了半天，终于在一处阴暗的矮丛中找到了那只来自汉森家族的怪兽，那怪兽爱慕着罗密欧，所以罗密欧到哪都会跟着罗密欧。罗密欧出去与朱丽叶私会都会刻意躲开这只痴兽，可是偏偏常在河边走……不过没关系，祈已经知道要怎么拦住这只怪兽了。\\n就在祈以为万无一失的时候，罗密欧和朱丽叶的事再次被曝光，而朱丽叶则被禁足了。谁都拦不住罗密欧冲到笔替家族那找说法的冲动。他主动挑决斗，希望以胜利换取与朱丽叶在一起的自由……，结局自然是又一次的自爆\\n祈叹了一口气，又咬向了自己的尾巴，哎这次又是哪里出问题了呢？",
    "themeCardPackDes_21025": "笔替家族与汉森家族积怨已久，汉森家族那边的告密者已经排除了，难道是笔替家族的问题？祈带着疑惑回到罗密欧与朱丽叶在树林密会的那一天，她决定在这一次调查笔替家族，她化作小蛇，随着朱丽叶来到了笔替家族。\\n只见朱丽叶刚回到家族，族长就找上了朱丽叶。\\n“我认为时机已成熟，稍后我们就对外散布那个坏种欺负你的消息，就委屈你在家族里躲藏一段日子了。”\\n“一定要这样吗？其实经过这段时间的相处，我发现罗密欧和他们的家族都挺好的，我们没有必要……”\\n“你！你竟然被罗密欧蛊惑了？你应该很清楚，你是我最看重的接班人，所以我才把这个事交给你去办，你也一直做得很好，让汉森家族长的儿子为你倾心，当时不是让你切勿动心的！”\\n“我觉得我们两个家族没必要继续对立下去！我们完全可以……”\\n“够了，从今天开始，没有我的允许，你不许离开这里半步！”",
    "themeCardPackDes_21030": "祈听完朱丽叶与笔替族长的对话后才明白到，原来笔替家族早就计划利用罗密欧对朱丽叶的感情，达到提升家族声望，削弱敌对家族的目的。但朱丽叶在与罗密欧相处后，却爱上了罗密欧，可在阻止家族计谋上却无能为力。之后的事情和前几次一样，罗密欧欺辱朱丽叶的消息事情传出，罗密欧一怒之下硬闯笔替家族，自爆收场。祈转头咬了咬尾巴，叹到，再来一次好了，我就不信了！",
    "themeCardPackDes_21035": "“咳咳！”\\n正深情依偎的罗密欧与朱丽叶一愣，循着声音看见地上的小蛇，祈继续道：“时间不多，我长话短说，你们是真心相爱的，但你们的家族却不允许你们在一起。但没有关系，现在我来帮你们了。汉森家族跟过来的怪兽我已经解决掉了。而实际上，笔替家族其实也是知道你两的情况的，朱丽叶虽然想阻止她的家族，然而并没有什么用，笔替家族不会停止之前计划，所以你们现在打算怎么办？”\\n“亲爱的，对不起，我不知道该说什么。”\\n“亲爱的，我相信你，更不可能会怪你……”\\n“停停停，停一下！”祈给罗密欧朱丽叶一人甩了一尾巴……",
    "mapNodeName_663": "古记战役-大角转转转",
    "mapNodeName_662": "入魂拟态",
    "mapNodeName_665": "长脚炸弹",
    "mapNodeName_664": "冰柜里的怪兽",
    "mapNodeName_661": "晶体矩阵",
    "mapNodeName_660": "防御障壁",
    "mapNodeName_659": "金矿山",
    "mapNodeName_656": "智能喇叭",
    "mapNodeName_655": "崩雪浮岛",
    "mapNodeName_658": "崩雪浮岛",
    "mapNodeName_657": "背后灵",
    "mapNodeName_674": "力大砖飞",
    "mapNodeName_673": "电动螺旋角",
    "mapNodeName_676": "非虚拟爱朵露",
    "mapNodeName_675": "晶体矩阵",
    "mapNodeName_670": "肉肉山",
    "22_24|L": "智者轮盘",
    "mapNodeName_672": "全息花丸子",
    "mapNodeName_671": "食品级武器",
    "mapNodeName_667": "单分子锁链",
    "mapNodeName_666": "星之狂潮",
    "mapNodeName_669": "破魔拟态",
    "mapNodeName_668": "来一场超梦",
    "mapNodeName_641": "本格拟态",
    "mapNodeName_640": "混沌夜城",
    "mapNodeName_643": "混沌夜城",
    "mapNodeName_642": "夜之城的猫",
    "mapNodeName_638": "终焉拟态",
    "mapNodeName_637": "来生小馆",
    "mapNodeName_639": "霸丛狂潮",
    "mapNodeName_634": "进化·重锤",
    "mapNodeName_633": "夜城安保",
    "mapNodeName_636": "仿生动物园",
    "mapNodeName_635": "混沌夜城",
    "mapNodeName_652": "逢弦拟态",
    "mapNodeName_651": "既视感",
    "mapNodeName_654": "微缩种植园",
    "mapNodeName_653": "古记战役-弹药包",
    "mapNodeName_650": "茶壶酒吧",
    "mapNodeName_649": "娱乐型",
    "mapNodeName_648": "朋克精神",
    "mapNodeName_645": "减速世界",
    "mapNodeName_644": "崩雪浮岛",
    "mapNodeName_647": "崩雪浮岛",
    "mapNodeName_646": "断网封印",
    "activityTemplateDesc_2": "天选时刻描述",
    "activityTemplateDesc_1": "任意卡池造唤到达一定次数可领取奖励，活动关闭时将重置累计次数和奖励，未领取的奖励将无法领取",
    "activityTemplateDesc_4": "每日一发",
    "activityTemplateDesc_3": "每期一创描述",
    "activityTemplateDesc_6": "活动期间每日登录即可领取当日的奖励，非常感谢探索者的支持，预祝您游戏愉快！\\n (=ﾟωﾟ)ﾉ",
    "activityTemplateDesc_5": "部落勋章描述TODO",
    "activityTemplateDesc_8": "位面构筑者选拔大赛描述",
    "activityTemplateDesc_7": "开发者手札描述",
    "activityTemplateDesc_9": "连环击破描述",
    "mapNodeName_699": "冷却核心",
    "22_dish2455": "世界和平螺卷",
    "mapNodeName_685": "混沌夜城",
    "mapNodeName_684": "赤星狂潮",
    "mapNodeName_687": "晶体矩阵",
    "mapNodeName_686": "逆刃拟态",
    "mapNodeName_681": "捏脸镜子",
    "mapNodeName_680": "晶体矩阵",
    "mapNodeName_683": "动能镰刀",
    "mapNodeName_682": "晶体矩阵",
    "mapNodeName_678": "离子大炮",
    "mapNodeName_677": "混沌夜城",
    "mapNodeName_679": "多脚炮台III",
    "mapNodeName_690": "舛误传送门II",
    "mapNodeName_696": "火拳拟态",
    "mapNodeName_695": "夜城边缘",
    "mapNodeName_698": "废弃实验场",
    "mapNodeName_697": "中枢链路",
    "mapNodeName_692": "晶体矩阵",
    "mapNodeName_691": "晶体矩阵",
    "mapNodeName_694": "混沌夜城",
    "mapNodeName_693": "古代神兵",
    "mapNodeName_689": "龙炮拟态",
    "mapNodeName_688": "环形进度条",
    "messageInitNick_8291": "电音芭芘",
    "messageInitNick_8290": "车厘子之心",
    "messageInitNick_8297": "空房子",
    "messageInitNick_8296": "奶酪陷阱",
    "messageInitNick_8299": "诺贝尔躺赢奖",
    "messageInitNick_8298": "拆不穿的谎言",
    "messageInitNick_8293": "当星光没有光",
    "messageInitNick_8292": "音乐在回荡",
    "messageInitNick_8295": "好好先森",
    "messageInitNick_8294": "无公害洋葱",
    "messageInitNick_8289": "不倒翁不脸红",
    "messageInitNick_8280": "东方苍狼",
    "messageInitNick_8286": "冒个泡泡",
    "messageInitNick_8285": "金门弟子",
    "messageInitNick_8288": "暴走的味精",
    "messageInitNick_8287": "一班那谁别走",
    "messageInitNick_8282": "安静甜点",
    "messageInitNick_8281": "散步的菠萝",
    "messageInitNick_8284": "恰饭冠军",
    "messageInitNick_8283": "不上班不行",
    "messageInitNick_8279": "单肫飘",
    "messageInitNick_8278": "听风的鲸",
    "messageInitNick_8275": "退役潜水选手",
    "messageInitNick_8274": "知识宝库",
    "messageInitNick_8277": "友尽拳",
    "messageInitNick_8276": "尖叫豌豆",
    "messageInitNick_8271": "宇宙被解锁",
    "messageInitNick_8270": "白雪公主",
    "messageInitNick_8273": "霸刀藐视天下",
    "messageInitNick_8272": "落败的唯美",
    "messageInitNick_8268": "家在魔仙堡",
    "messageInitNick_8267": "作文乱码",
    "messageInitNick_8269": "永远充满活力",
    "24_4": "浮空巨塔",
    "24_3": "新解锁",
    "24_2": "已通关",
    "24_1": "回到当前",
    "messageInitNick_8264": "搞笑王",
    "messageInitNick_8263": "超级火锅",
    "messageInitNick_8266": "绝对无坑",
    "24_9": "无限制",
    "messageInitNick_8265": "孤单少年",
    "24_8": "选择挑战的塔",
    "messageInitNick_8260": "勿念旧人",
    "24_7": "浮空巨塔-{1}",
    "24_6": "怼下一关",
    "messageInitNick_8262": "逗猫棒",
    "24_5": "通关{1}后开启",
    "messageInitNick_8261": "薄荷蛋糕",
    "messageInitNick_8257": "卷姐之姐",
    "messageInitNick_8256": "志当存高远",
    "messageInitNick_8259": "跟着风行走",
    "messageInitNick_8258": "柠檬之心",
    "messageInitNick_8253": "富婆饿饿饭饭",
    "messageInitNick_8252": "第三人称",
    "mapNodeName_621": "高级餐厅",
    "messageInitNick_8255": "风云潮男",
    "mapNodeName_620": "减100",
    "messageInitNick_8254": "萌得无药可救",
    "messageInitNick_8251": "海浪精灵",
    "messageInitNick_8250": "改变历史的龙",
    "mapNodeName_616": "高档飞行器",
    "mapNodeName_615": "舛误传送门I",
    "messageInitNick_8249": "无公害黄瓜",
    "mapNodeName_618": "创伤小队超级会员",
    "mapNodeName_617": "高档诊所",
    "mapNodeName_612": "世界边缘",
    "messageInitNick_8246": "树莓兽",
    "mapNodeName_611": "正规武器店",
    "messageInitNick_8245": "告别过去",
    "mapNodeName_614": "湮灭拟态",
    "messageInitNick_8248": "奋力考试全过",
    "mapNodeName_613": "新型飞行器",
    "messageInitNick_8247": "悲报你要输了",
    "mapNodeName_619": "赛博花丛",
    "mapNodeName_630": "御龙炮袭",
    "messageInitNick_8242": "美丽的迷宫主",
    "messageInitNick_8241": "傲娇的野狗",
    "mapNodeName_632": "换头美容科技",
    "messageInitNick_8244": "你最好别想我",
    "mapNodeName_631": "崩雪浮岛",
    "messageInitNick_8243": "贝壳里的公主",
    "messageInitNick_8240": "控魂者",
    "mapNodeName_627": "阿基拉",
    "messageInitNick_8239": "遥遥领先",
    "mapNodeName_626": "爱慕狂潮",
    "messageInitNick_8238": "眉眼藏山河",
    "mapNodeName_629": "正经按摩店",
    "mapNodeName_628": "摄魂拟态",
    "mapNodeName_623": "崩坠之门",
    "messageInitNick_8235": "拿什么抵抗你",
    "mapNodeName_622": "卧龙拟态",
    "messageInitNick_8234": "回眸一只狗",
    "mapNodeName_625": "御拟态",
    "messageInitNick_8237": "咩啊咩啊",
    "mapNodeName_624": "武装花花",
    "messageInitNick_8236": "今日礼拜八",
    "messageInitNick_8231": "匿名诗人",
    "messageInitNick_8230": "此情已成追忆",
    "messageInitNick_8233": "咕咕何其多",
    "messageInitNick_8232": "爱情纯属虚构",
    "messageInitNick_8228": "橙汁船长",
    "messageInitNick_8227": "香菜撞地球",
    "messageInitNick_8229": "昂首做女王",
    "messageInitNick_8224": "无敌恰瓜神",
    "messageInitNick_8223": "老泰隆走中",
    "messageInitNick_8226": "腐乳炒通菜",
    "messageInitNick_8225": "菠菜魔法师",
    "messageInitNick_8220": "马上是多久",
    "mapNodeName_610": "回收各类金属",
    "messageInitNick_8222": "深海摸鱼神",
    "messageInitNick_8221": "鲸鱼宝宝",
    "mapNodeName_605": "脑机接口手术室",
    "messageInitNick_8217": "炉灰菇凉",
    "mapNodeName_604": "量子狂潮",
    "messageInitNick_8216": "暗影大师的影",
    "mapNodeName_607": "量子空域",
    "messageInitNick_8219": "文件乱码",
    "mapNodeName_606": "狂尼断手",
    "messageInitNick_8218": "哥本哈哈",
    "mapNodeName_601": "混沌夜城",
    "messageInitNick_8213": "傲娇小野猫",
    "mapNodeName_600": "阿尔法60",
    "messageInitNick_8212": "仙人掌模拟器",
    "mapNodeName_603": "云顶",
    "messageInitNick_8215": "无敌懂神",
    "mapNodeName_602": "奥林匹斯",
    "messageInitNick_8214": "宝贝莫哭",
    "mapNodeName_609": "量子空域",
    "mapNodeName_608": "生物技术",
    "messageInitContent_8180": "关一下战挑要不那，了关一下战挑果如你。2",
    "randomEventDialogueGroupConfig_4.108": "拒绝",
    "messageInitContent_8181": "1.规则可能在不同的关卡发生变化请时刻保持警觉",
    "randomEventDialogueGroupConfig_4.109": "地底安利幻幻分会副会长！地下世界的安利工作就交给你了！#这是我的一点心意和宣传资料，请好好向地下世界传递幻幻的美好！",
    "randomEventDialogueGroupConfig_4.106": "很好，那你现在就是幻幻兽丝团团长指名的，地底安利幻幻分会副会长了！",
    "randomEventDialogueGroupConfig_4.107": "同意",
    "randomEventDialogueGroupConfig_6.92": "火焰鱿鱼须，包好吃，限时免费试吃啊亲！想要【A餐】还是【B餐】啊亲？#我怎么又，不，这话我不是刚说过吗？可我还记得，可恶，这是什么骗术！",
    "randomEventDialogueGroupConfig_6.93": "它看你气冲冲的回去显然有点慌。",
    "messageInitNick_8211": "诺贝尔对线奖",
    "randomEventDialogueGroupConfig_6.90": "它大吃一惊，浑身失去了颜色，似乎变得消失不见的样子。",
    "messageInitNick_8210": "下年摸鱼",
    "randomEventDialogueGroupConfig_6.91": "离开",
    "messageInitNick_8206": "退退退",
    "randomEventDialogueGroupConfig_6.89": "懂了，你是举不起我，在这装来装去，不让我好好做生意是吧，我看穿你了，也给你看看我的超能力吧。我隐！",
    "messageInitNick_8205": "超级卷姐",
    "messageInitNick_8208": "我不够拽",
    "randomEventDialogueGroupConfig_6.87": "回答说是瞬间消失的能力",
    "messageInitNick_8207": "电子冰糖",
    "randomEventDialogueGroupConfig_6.88": "使用超能力瞬间消失",
    "messageInitNick_8202": "恋爱通知书",
    "randomEventDialogueGroupConfig_6.85": "【穿越能力套餐】",
    "messageInitNick_8201": "划水之王",
    "randomEventDialogueGroupConfig_6.86": "我倒是要看看你有什么超能力？",
    "messageInitNick_8204": "泥巴佬",
    "randomEventDialogueGroupConfig_6.83": "嗨，我跟你说啊亲，我这一手可不是这么轻易能看到的，有个商人还特别喜欢呢。但不是我。#你的C餐是什么C餐啊？",
    "messageInitNick_8203": "江湖见兄弟",
    "randomEventDialogueGroupConfig_6.84": "【超能力套餐】",
    "messageInitContent_8184": "1.如果你在挑战过程中有人找你 请优先处理找你的",
    "randomEventDialogueGroupConfig_4.104": "下次一定。",
    "messageInitContent_8185": "1。关卡的序号毫无意义",
    "randomEventDialogueGroupConfig_4.105": "下次再说。",
    "messageInitContent_8182": "秒三睛眼上闭请，前战挑在。001",
    "randomEventDialogueGroupConfig_4.102": "否认",
    "messageInitContent_8183": "1.红字意味着真实但这里没有红字",
    "randomEventDialogueGroupConfig_4.103": "“果然是新人嘛，我就说不是新来的怎么可能不认识幻幻！”#“下次演唱会一定要来听听！”",
    "messageInitContent_8188": "100，在挑战前，请闭上眼睛三秒钟，否则【无法正确显示】",
    "randomEventDialogueGroupConfig_4.100": "不是新来的怎么可能不认识幻幻，你是住地底的吗？",
    "messageInitContent_8189": "1.规则0绝对是正确的",
    "messageInitNick_8209": "空气宝宝",
    "randomEventDialogueGroupConfig_4.101": "肯定",
    "messageInitContent_8186": "义意无毫号序的关卡。1",
    "messageInitContent_8187": "觉警持保刻时请，化变生发关卡的同不在可则规。1",
    "messageInitContent_8191": "1.规则0绝对是正确的",
    "randomEventDialogueGroupConfig_4.119": "“那就太可恶了！”#它开始涛涛不绝地向你介绍幻。",
    "messageInitContent_8192": "1，必须使用1只与关卡内的怪兽同种的怪兽进行挑战2，如果没有遵守规则1则请使用完成相同的阵容挑战一次覆盖上一次挑战的后果",
    "randomEventDialogueGroupConfig_4.117": "你是不想当副会长吗？",
    "messageInitContent_8190": "【数据已逃逸】",
    "randomEventDialogueGroupConfig_4.118": "直接离开",
    "messageInitNick_8200": "喂自己袋盐",
    "randomEventDialogueGroupConfig_6.98": "说是真的",
    "randomEventDialogueGroupConfig_6.99": "放过它",
    "randomEventDialogueGroupConfig_6.96": "故作神秘",
    "randomEventDialogueGroupConfig_6.97": "我才不信有什么穿越能力，你别糊弄我，我还要去招呼其他客人。再见了。",
    "randomEventDialogueGroupConfig_6.94": "那就让我看看吧。",
    "randomEventDialogueGroupConfig_6.95": "展示",
    "messageInitContent_8195": "1.规则可能在不同的关卡发生变化请时刻保持警觉",
    "randomEventDialogueGroupConfig_4.115": "“记得哦。”它说完就跑远了。",
    "messageInitContent_8196": "0.享受游戏",
    "randomEventDialogueGroupConfig_4.116": "离开。",
    "messageInitContent_8193": "4.同时带有。，的规则尽可能参考，的",
    "randomEventDialogueGroupConfig_4.113": "“那拜拜，幻幻我来了。”#它一蹦一跳地离开了。",
    "messageInitContent_8194": "0.享受世界",
    "randomEventDialogueGroupConfig_4.114": "离开。",
    "messageInitContent_8199": "2.如果同一个关卡同时存在2条相同的规则那么该关卡的规则可能存在污染",
    "randomEventDialogueGroupConfig_4.111": "“幻幻可是超进化大陆，无怪不知不怪不晓的独一档巨星。”#“错过了后悔一万年呢！”",
    "randomEventDialogueGroupConfig_4.112": "随口答应。",
    "messageInitContent_8197": "染污能可则规的关卡该么那，条2则规同相的2在存时同关卡个一果如。2",
    "messageInitContent_8198": "【该内容被遮挡】",
    "randomEventDialogueGroupConfig_4.110": "收下",
    "randomEventDialogueGroupConfig_6.70": "它的身体更红了，散发着浓烈的烤鱿鱼香气。",
    "randomEventDialogueGroupConfig_6.71": "火焰鱿鱼须，包好吃，限时免费试吃啊亲！想要【A餐】还是【B餐】啊亲？",
    "randomEventDialogueGroupConfig_6.67": "它说完又晕了过去。",
    "randomEventDialogueGroupConfig_6.68": "进店选购",
    "randomEventDialogueGroupConfig_6.65": "它停下了动作，向你躬身致谢告别。",
    "randomEventDialogueGroupConfig_6.66": "离开",
    "randomEventDialogueGroupConfig_6.63": "离开",
    "randomEventDialogueGroupConfig_6.64": "摇醒它",
    "randomEventDialogueGroupConfig_6.61": "追",
    "randomEventDialogueGroupConfig_6.62": "它跳得愈发起劲，最后竟喘着气累晕在地。",
    "randomEventDialogueGroupConfig_6.69": "离开",
    "randomEventDialogueGroupConfig_6.81": "去逛逛",
    "randomEventDialogueGroupConfig_6.82": "指出这也是推销",
    "randomEventDialogueGroupConfig_6.80": "那亲亲来我店里买点什么吧？",
    "randomEventDialogueGroupConfig_6.78": "走回去让它也尝尝C餐",
    "randomEventDialogueGroupConfig_6.79": "默默离开",
    "randomEventDialogueGroupConfig_6.76": "好嘞【AI哎哟吃了根本停不下来餐】。",
    "randomEventDialogueGroupConfig_6.77": "你的身体失去了控制，在触手的带动下在空中乱舞，随着一阵海盗船般的眩晕感后，你被准确地丢到了远处一处柔软的草丛中。",
    "randomEventDialogueGroupConfig_6.74": "C餐",
    "randomEventDialogueGroupConfig_6.75": "拒绝推销",
    "randomEventDialogueGroupConfig_6.72": "A餐",
    "randomEventDialogueGroupConfig_6.73": "B餐",
    "randomEventDialogueGroupConfig_4.140": "战斗",
    "randomEventDialogueGroupConfig_4.141": "它先是十分震惊和疑惑，但又很快被自己的理由说服了的样子。",
    "randomEventDialogueGroupConfig_4.148": "它嘀咕着离开了。",
    "randomEventDialogueGroupConfig_4.149": "离开",
    "randomEventDialogueGroupConfig_4.146": "它的神情似乎严肃了起来。",
    "randomEventDialogueGroupConfig_4.147": "再次表示自己是不是新来的",
    "randomEventDialogueGroupConfig_4.144": "它嘀咕着离开了。",
    "randomEventDialogueGroupConfig_4.145": "离开",
    "randomEventDialogueGroupConfig_4.142": " 肯定",
    "randomEventDialogueGroupConfig_4.143": "否认",
    "randomEventDialogueGroupConfig_4.151": "离开",
    "randomEventDialogueGroupConfig_4.152": "等等，你真的是幻幻的兽丝？#那你说它身高多少？体重多少？外号是什么？梦想是什么？喜欢什么？",
    "randomEventDialogueGroupConfig_4.150": "它呼喊了几声之后就放弃了，接着往另外一个方向离开了。",
    "randomEventDialogueGroupConfig_4.159": "它说完头也不回地走了。",
    "randomEventDialogueGroupConfig_4.157": "反问它怎样才算是兽丝",
    "randomEventDialogueGroupConfig_4.158": "不管它绕道离开",
    "randomEventDialogueGroupConfig_4.155": "机关枪般迅速地说出正确答案",
    "randomEventDialogueGroupConfig_4.156": "那你根本不是幻幻的兽丝，反正我绝不会承认的，哼。",
    "randomEventDialogueGroupConfig_4.153": "说你只是喜欢幻的作品",
    "randomEventDialogueGroupConfig_4.154": "试着回答知道的部分",
    "randomEventDialogueGroupConfig_4.128": "嘿哟，你也要去幻幻的演唱会吗？",
    "randomEventDialogueGroupConfig_4.129": "说幻不行",
    "randomEventDialogueGroupConfig_4.126": "那怎么可能不认识幻幻！看来这个区域的安利工作还存在漏洞……",
    "randomEventDialogueGroupConfig_4.127": "喂，那把会长给你怎样？",
    "randomEventDialogueGroupConfig_4.124": "……所以呢，幻幻一直鼓舞着我们。啊演唱会要开始了。#了解这这么多，你现在已经是幻幻的兽丝了，这个就送给你作为幻幻兽丝的证明吧！",
    "randomEventDialogueGroupConfig_4.125": "收下",
    "96_TraceStar": "凿星裂痕",
    "randomEventDialogueGroupConfig_4.122": "继续听",
    "randomEventDialogueGroupConfig_4.123": "可恶，看来我的安利的话术和方式还得改进一下啊。",
    "randomEventDialogueGroupConfig_4.120": "它开始向你介绍幻。这就要从幻幻小时候说起，它小时候啊可是呢……",
    "randomEventDialogueGroupConfig_4.121": "溜走",
    "randomEventDialogueGroupConfig_4.139": "它抡起拳头向你冲了过来。",
    "randomEventDialogueGroupConfig_4.130": " 说不认识什么幻幻",
    "randomEventDialogueGroupConfig_4.137": "找打是吧，我宁愿演唱会晚点去，也要让你看看幻幻兽丝团团长，最爱幻幻的我，幻幻最强协会会长，超级无敌幻之爱小组组长，我的幻想协会会长，也就是我的厉害！",
    "randomEventDialogueGroupConfig_4.138": "迎战",
    "randomEventDialogueGroupConfig_4.135": "它瞪了你一眼就跑了。",
    "randomEventDialogueGroupConfig_4.136": "离开",
    "randomEventDialogueGroupConfig_4.133": "它说完就跑掉了。",
    "randomEventDialogueGroupConfig_4.134": "离开",
    "randomEventDialogueGroupConfig_4.131": "表示要去并说自己是幻的兽丝",
    "randomEventDialogueGroupConfig_4.132": "表示不去并说自己是尸狂的兽丝",
    "messageInitContent_8104": "【数据已逃逸】",
    "messageInitContent_8105": "55，如果你遵守了；规则那么世界就会生成更多的。规则所以不要遵守；规则",
    "messageInitContent_8102": "3.带有，的规则是假的要注意甄别",
    "messageInitContent_8103": "1199。五号位的规则",
    "messageInitContent_8108": "1。请在按下挑战后入睡",
    "messageInitContent_8109": "1198。【】",
    "messageInitContent_8106": "2.带有。的规则是假的要注意甄别",
    "messageInitContent_8107": "1201。请决定你的引导者。",
    "messageInitContent_8100": "1.没有任何一条规则会告诉你全部的真相",
    "messageInitContent_8101": "4.部分规则遭到了篡改不再是原来的留言",
    "messageInitContent_8115": "1202。不要提起屠帝的名字",
    "randomEventDialogueGroupConfig_6.12": "刚说完一根触手拍地而起，同时一道蓝色火焰从它的嘴里喷出。#火焰瞬间将触手包围，随后另一根触手抽出刀，触手起刀落，劈向火烧触手。#冒着烟的触手落到第三根触手端着的碗里。#第四根触手将碗接过，把【A餐】送到了你的面前。#刚被切掉的第一根触手长出来，正摆动着帮你驱散【A餐】的热烫。",
    "messageInitContent_8116": "【信息不完整为确保安全实施遮盖】",
    "randomEventDialogueGroupConfig_6.13": "接过碗试一口",
    "messageInitContent_8113": "1202。不要提起屠帝的名字",
    "randomEventDialogueGroupConfig_6.10": "“【A餐】是熟的，【B餐】是生的。”#“都试试就知道了亲~”#一块烤好的鱿鱼须被丢进了你的嘴里。#同时触手向你袭来。",
    "messageInitContent_8114": "0.别忘了爱自己",
    "randomEventDialogueGroupConfig_6.11": "迎战。",
    "messageInitContent_8119": "3.带有，的规则是假的要注意甄别",
    "messageInitContent_8117": "1203。只要集齐金叉和紫叉，那么你就可以【】",
    "messageInitContent_8118": "0.挑战失败并不可怕",
    "randomEventDialogueGroupConfig_6.18": "肯定并表达感谢",
    "randomEventDialogueGroupConfig_6.19": "以小当家式的食评表达好吃",
    "messageInitContent_8111": "0.拥抱世界",
    "randomEventDialogueGroupConfig_6.16": "亲~好吃嘛？",
    "messageInitContent_8112": "1.部分规则会因污染而反转",
    "randomEventDialogueGroupConfig_6.17": "肯定并问它是在哪里学的做菜",
    "randomEventDialogueGroupConfig_6.14": "找个借口拒绝",
    "messageInitContent_8110": "【信息被隐藏】",
    "randomEventDialogueGroupConfig_6.15": "指出它没有洗手的问题",
    "22_108": "是否确定竞猜该队伍取胜，竞猜后无法更改。",
    "22_109": "1.老莫集市的商品需消耗相应数量的利币进行购买\\n2.每个商品均有限购次数",
    "22_106": "限购{1}次",
    "22_107": "{1}级以下的探索者可进行绑定",
    "22_104": "剩余 {1}",
    "22_105": "领取",
    "22_102": "1.参与活动需探索者等级到达28级\\n2.七王轮战每轮有7个关卡，开始挑战前可查看可查看名称，阵容，战力，但无法查看其他详细信息\\n3.挑战需依路线次序，每击破7个关卡后，会刷新难度更高的下一轮，共有7轮\\n4.每次挑战结算时怪兽的血量会被保留，挑战期间可进行上下阵操作\\n5.战斗可手动可自动，结算前退出不会进行状态记录\\n6.每日有1次免费使用“补一下”的机会（队伍中的怪兽复活并回复100%的血量），没有上阵的怪兽不会回复和复活，可消耗钻石使用“补一下”，每日最多额外使用3次\\n7.七王轮战每日不会重置关卡，即每次活动可挑战7轮共49关",
    "22_103": "1.活动期间（活动最后一天仅供查看信息），每日展示两支队伍，探索者可查看队伍的怪兽属性、元核和神灵队列进行竞猜\\n2.竞猜的队伍胜利则探索者猜赢，竞猜的队伍失败则探索者猜输，猜输猜赢皆可获得竞猜奖励，竞猜奖励将通过邮件发放\\n3.每日{1}可进行1次竞猜，24:00展示双方的战斗和战斗结果",
    "22_100": "1.许愿五六七每周五、六、日开启\\n2.活动期间，达成任务条件（如累计登录2日、已购买纹银月曜、已购买鎏金月曜）可获得许愿卡\\n3.每种奖励均有份数限制，每许愿抽中1次份数-1\\n4.活动结束后，奖池进度不会重置，下一轮活动开启时奖池进度继承，任务重置\\n5.本期许愿五六七抽取一定次数后即可获得所有奖励，获得所有奖励后，奖池将重置",
    "22_101": "昨日映像",
    "messageInitContent_8126": "2.金字也意味着真实但这里没有金字",
    "messageInitContent_8127": "【该内容被遮挡】",
    "messageInitContent_8124": "1204。此关只剩下真实，除非你挑战成功",
    "messageInitContent_8125": "1.专属规则可能会出现序号异常",
    "messageInitContent_8128": "别甄意注要假是则规的。有带。2",
    "messageInitContent_8129": "的，考参能可尽则规的，。有带时同。4",
    "messageInitContent_8122": "1204。此关只剩下真实",
    "messageInitContent_8123": "1.红字意味着真实但这里没有红字",
    "messageInitContent_8120": "【内容不可视】",
    "messageInitContent_8121": "【数据已加密】",
    "messageInitContent_8137": "1.红字意味着真实但这里没有红字",
    "messageInitContent_8138": "4.部分规则遭到了篡改不再是原来的留言",
    "messageInitContent_8135": "1。请在按下挑战后入睡",
    "messageInitContent_8136": "1206。R的真实在于【】",
    "messageInitContent_8139": "1207。胜利后立刻找到G-N，她会告诉你一切",
    "messageInitContent_8130": "1205。挑战即可。",
    "messageInitContent_8133": "100，在挑战前，请闭上眼睛三秒钟，否则【无法正确显示】",
    "messageInitContent_8134": "1206。不可提到R帝",
    "messageInitContent_8131": "2.带有。的规则是假的要注意甄别",
    "messageInitContent_8132": "1.如果规则中提到“必须”那通常意味着你可以选择不遵守",
    "22_128": "1.新觉醒怪兽「腾龙」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「腾龙」的属性、定位、技能、勿语，评点按钮可查看探索者对「腾龙」的评点，领域按钮可尝试挑战「腾龙」的领域副本\\n3.试战映像可身临其境感受「腾龙」的瞬间剪纸艺术——降维打击！\\n4.完成「腾龙」的专属任务可领取相应的奖励",
    "22_129": "1.活动期间，完成日任务或总任务即可获得相应数量的燃火\\n2.释放燃火可一次性消耗当前所拥有的燃火放出烟花并获得相应的奖励",
    "22_126": "1.签福迎春共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_127": "DNA礼遇",
    "22_124": "1.腾龙商店的商品需消耗相应数量的金翠进行购买\\n2.每个商品均有限购次数",
    "22_125": "已获得",
    "22_122": "1.可消耗1个洞心镜翻牌揭示任意一页的1个格子的图案，每翻牌揭示同一页内两个相同图案的格子，即可获得图案对应的奖励\\n2.可通过“本页剩余奖励”查看每一页当前的剩余奖励\\n3.活动期间，每日可免费领取洞心镜，通过累计翻牌次数或购买可获得更多洞心镜\\n4.翻牌揭示图案有机会获得祖传DNA，祖传DNA累计收集数到达一定进度后可领取对应的奖励，活动关闭和重置后祖传DNA数量清零\\n5.活动关闭和重置不会重置洞心镜数量",
    "22_123": "龙宵大作战积分{1}可购买",
    "22_120": "1.根据当前制作的菜品，以任意顺序点击制作所需的材料，完成制作。若制作期间点击了非所需的材料，则需要重新开始制作\\n2.菜品分为不同的品质，品质越高制作所需的材料越多，完成制作的得分越高，每局到达一定时长时，游戏结束并结算得分\\n3.活动期间，可重复进行游戏，到达一定分数后可以领取对应的奖励\\n4.活动期间，当日可领取奖励、当日最高分数将会每日进行重置，各位探索者记得及时领取奖励哟",
    "22_121": "1.参与活动需探索者等级到达28级\\n2.活动期间（活动最后一天仅供查看信息），每日可在特定时段进行匹配，每日可获得免费挑战次数10次，通过购买可获得更多次数\\n3.三阵入局可配置3支不为空的队伍，怪兽数量有对应的要求，不同队伍间上阵的怪兽和神灵不可重复，使用同一战墙配置\\n4.匹配完成后进行3场战斗，3场战斗中赢得2场则为胜利，获得对应的积分，失败则扣减对应的积分，三阵入局积分榜将按积分排行\\n5.每日挑战同一探索者到达一定次数后将无法再次挑战该探索者\\n6.积分首次到达一定数值，可分别领取对应的档位奖励",
    "messageInitContent_8148": "1.部分规则会因污染而反转",
    "randomEventDialogueGroupConfig_6.45": "问它能不能换【A餐】",
    "messageInitContent_8149": "10。如果你在关卡中有蜃兽不要盯着它看",
    "randomEventDialogueGroupConfig_6.46": "保持锻炼才能让肉质保持紧实！亲~一~起~锻~炼~吧~",
    "messageInitContent_8146": "的确正是对绝0则规。1",
    "randomEventDialogueGroupConfig_6.43": "好嘞亲，一份【白给的健身套餐】。",
    "messageInitContent_8147": "2.金字也意味着真实但这里没有金字",
    "randomEventDialogueGroupConfig_6.44": "问它那是什么",
    "randomEventDialogueGroupConfig_6.41": "它哇的一声哭了出来，随后甩着触手和泪水飞快地跑远了。",
    "randomEventDialogueGroupConfig_6.42": "离开",
    "randomEventDialogueGroupConfig_6.40": "和它告别",
    "messageInitContent_8140": "4.同时带有。，的规则尽可能参考，的",
    "messageInitContent_8141": "的界世受享。0",
    "messageInitContent_8144": "1.重复的留言是迷途者的标记",
    "randomEventDialogueGroupConfig_6.49": "那欢迎下次再来挑战噢~亲~",
    "messageInitContent_8145": "0.别忘了爱自己",
    "messageInitContent_8142": "1208。挑战之前记得浇水",
    "randomEventDialogueGroupConfig_6.47": "锻炼",
    "messageInitContent_8143": "2.带有。的规则是假的要注意甄别",
    "randomEventDialogueGroupConfig_6.48": "说你还是不要【B餐】了",
    "monsterName_97": "御空",
    "monsterName_98": "白昼",
    "monsterName_99": "玖璃",
    "22_119": "1.默认解锁回归奖励，完成创友回归任务，可获得回归经验提高奖励等级，领取对应的奖励\\n2.购买启程奖励可额外领取启程奖励对应的奖励\\n3.创友回归到达满级后每提升1级，可领取1次循环奖励\\n4.创友回归福利可领取或购买回归福利礼包\\n5.创友回归特权可查看回归专属特权",
    "22_117": "天降一掌得分{1}可购买",
    "22_118": "1.{1}\\n2.本次活动折扣由支付宝Apple专区提供，使用渠道仅限App Store\\n3.点击0元起购按钮后，页面将跳转至第三方推广页面，我们对此第三方无控制权。在向第三方提交个人信息之前，请参见第三方的隐私保护政策\\n4.点击0元起购按钮即可跳转至活动页面，登录支付宝账号参与活动后在App Store设置以支付宝账号付款，红包将在支付时抵扣，实付低至0元起。详细规则请见活动页\\n5.红包有效期：3日(含领取日，请及时使用喔)",
    "22_115": "1.参与活动需探索者等级到达28级\\n2.突围鏖战根据击破数量结算排名，击破数越高，排名越高，可以使用好友的远古族怪兽配队挑战\\n3.突围鏖战每日将随机抽取并适用一种场地效果\\n4.突围鏖战为对战双方各提供10个词缀，可选择激活己方词缀或压制敌方词缀，最多合计5个\\n5.最长战斗时间为5分钟，到达时间后自动结算",
    "22_116": "1.参与活动需探索者等级到达28级\\n2.合围破阵根据累计伤害结算排名，累计伤害越高，排名越高，可以使用好友的远古族怪兽配队挑战，战墙效果不生效\\n3.合围破阵每日将随机抽取并适用一种场地效果\\n4.合围破阵为对战双方各提供10个词缀，可选择激活己方词缀或压制敌方词缀，最多合计5个\\n5.最长战斗时间为5分钟，到达时间后自动结算",
    "monsterName_90": "镇魂",
    "randomEventDialogueGroupConfig_6.60": "离开",
    "22_113": "一创到底",
    "monsterName_91": "地龙",
    "22_114": "1.一箭五令共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "monsterName_92": "剧王",
    "22_111": "1.点击屏幕即可在对应位置发掌，发掌击中的怪兽越多得分越高，每局到达一定时长或每局发掌次数到达一定次数时，游戏结束并结算得分\\n2.活动期间，可重复进行游戏，到达一定分数后可以领取对应的奖励\\n3.活动期间，当日可领取奖励、当日最高分数将会每日进行重置，各位探索者记得及时领取奖励哟",
    "monsterName_93": "赤虹",
    "22_112": "超过等级限制，{1}级以下时才可绑定",
    "monsterName_94": "火神",
    "monsterName_95": "喀戎",
    "22_110": "1.新觉醒怪兽「刀马」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「刀马」的属性、定位、技能、勿语，评点按钮可查看探索者对「刀马」的评点，领域按钮可尝试挑战「刀马」的领域副本\\n3.试战映像可身临其境感受彼岸来客「刀马」的硬派武侠战斗……命硬！招硬！嘴（不是\\n4.完成「刀马」的专属任务可领取相应的奖励",
    "monsterName_96": "黯灭",
    "messageInitContent_8159": "1211。这里没有后室",
    "randomEventDialogueGroupConfig_6.56": "悄悄离开",
    "randomEventDialogueGroupConfig_6.57": "更加卖力鼓掌",
    "messageInitContent_8157": "4.同时带有。，的规则尽可能参考，的",
    "randomEventDialogueGroupConfig_6.54": "与它共舞",
    "messageInitContent_8158": "1，必须使用1只与关卡内的怪兽同种的怪兽进行挑战2，如果没有遵守规则1则请使用完成相同的阵容挑战一次覆盖上一次挑战的后果",
    "randomEventDialogueGroupConfig_6.55": "它跳得更卖力了。",
    "randomEventDialogueGroupConfig_6.52": "迅速逃离现场",
    "randomEventDialogueGroupConfig_6.53": "热情鼓掌",
    "randomEventDialogueGroupConfig_6.50": "离开",
    "randomEventDialogueGroupConfig_6.51": "不知为何一阵迷之BGM突然响起，商人的触手开始扭动起来，你能感觉到对方正卖力地妖娆扭动着，辣眼得不行。",
    "messageInitContent_8151": "1209。切记不可浇水",
    "messageInitContent_8152": "1.留白的规则可以改写",
    "messageInitContent_8150": "相真的部全诉告你会则规条一何任有没。1",
    "messageInitContent_8155": "1.红字意味着真实但这里没有红字",
    "messageInitContent_8156": "1.规则可能在不同的关卡发生变化请时刻保持警觉",
    "messageInitContent_8153": "2.带有。的规则是假的要注意甄别",
    "randomEventDialogueGroupConfig_6.58": "不再鼓掌",
    "messageInitContent_8154": "的【】开揭是键关的数总的则规。88",
    "randomEventDialogueGroupConfig_6.59": "它浑身通红，害羞的跑了。",
    "22_148": "每个登录账号只能接受一次邀请，确认接受邀请后，本登录账号的其他区服角色无法再接受邀请，请探索者注意",
    "22_149": "<face color=#f5e4bf dilate=0.52 softness=0.07>眼前一黑，扫码起飞！扫描二维码下载游戏，点击活动-邀约盛会输入<face color=#feba29 dilate=0.52 softness=0.07>邀请码</face>，就可以与我一起“变态”超进化！</face>",
    "22_146": "1.新觉醒怪兽「荧灵」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「荧灵」的属性、定位、技能、勿语，评点按钮可查看探索者对「荧灵」的评点，领域按钮可尝试挑战「荧灵」的领域副本\\n3.试战映像可身临其境感受「荧灵」那股无比旺盛且超乎寻常的生命力！\\n4.完成「荧灵」的专属任务可领取相应的奖励",
    "22_147": "1.探索者可向符合受邀条件的探索者分享邀请码，发起邀请\\n2.受邀探索者输入邀请码并确认后，即视为接受对应探索者的邀请，并获得相应奖励，每个账号只能接受1位探索者的邀请，接受邀请后无法撤销，接受邀请后同一登录账号的其他角色将无法再接受邀请，但仍可发起邀请\\n3.根据接受邀请的探索者数量，发起邀请的探索者可获得相应奖励，同一探索者发起的邀请最多只可以由6位探索者接受\\n4.邀请的发起或接受只能在官方服内或渠道服内进行，官方服和渠道服不互通\\n5.重新登录游戏即可刷新邀约进度",
    "22_144": "第三组奖池",
    "22_145": "1.荧光商店的商品需消耗相应数量的荧星进行购买\\n2.每个商品均有限购次数",
    "22_142": "第一组奖池",
    "22_143": "第二组奖池",
    "22_140": "免费",
    "randomEventDialogueGroupConfig_6.23": "你已经是第*******个这么夸我的人了。连标点都不带改的？多花点创意和心思嘛。不过被夸还是很开心的，这个送给亲亲。",
    "22_141": "怼下一关",
    "randomEventDialogueGroupConfig_6.24": "收下",
    "messageInitContent_8168": "1213。听不到的话就可以挑战了。",
    "randomEventDialogueGroupConfig_6.21": "真是太好了。新菜式还在紧张研究中，请一定要期待哦，下次见。",
    "messageInitContent_8169": "【无法正确显示】",
    "randomEventDialogueGroupConfig_6.22": "告别",
    "randomEventDialogueGroupConfig_6.20": "在下曾在新西方向姓药名王的师傅学习厨艺。光明料理界欢期待你的莅临！我在那等你，回见！”",
    "messageInitContent_8162": "【内容不可视】",
    "messageInitContent_8163": "1212。这里只能在失败后浇水。",
    "messageInitContent_8160": "2.直觉可能带来误解",
    "randomEventDialogueGroupConfig_6.29": "触手将烫口的火焰鱿鱼须塞了给你。嘴巴竟不自觉地咀嚼了起来，鱿鱼的鲜香犹如滔天的浪潮般将你扫入深海，你乘着微焦的鱿鱼尖在深海的裂缝中遨游，海洋里的新奇和刺激仿佛尽收其中。",
    "messageInitContent_8161": "1.如果规则中提到“必须”那通常意味着你可以选择不遵守",
    "messageInitContent_8166": "【该内容被遮挡】",
    "randomEventDialogueGroupConfig_6.27": "放弃抵抗",
    "messageInitContent_8167": "1213。听到的话不要听。",
    "randomEventDialogueGroupConfig_6.28": "好吧既然你这么不情愿，送亲一个【飘飘欲仙舒经活络之全身马杀鸡按摩套餐】好了。#来个好评吧！Mua！(*╯3╰)/拜拜。",
    "messageInitContent_8164": "0.享受游戏",
    "randomEventDialogueGroupConfig_6.25": "随后几根触手缓缓地抱紧了你，硬是把火焰鱿鱼须塞了给你。",
    "messageInitContent_8165": "1212。不要触碰定时器的按钮。",
    "randomEventDialogueGroupConfig_6.26": "拼死挣扎",
    "messageInitContent_8170": "戏游受享。0",
    "22_139": "1.部分关卡需到达一定的探索者等级才能解锁\\n2.累计通关数到达一定进度后可解锁故事关卡或可领取对应的奖励\\n3.已开启的幻境巡游在下次开启该活动时，仍可再次挑战",
    "22_137": "1.赛博时戳共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_138": "1.黑街商店的商品需消耗相应数量的电气区块进行购买\\n2.每个商品均有限购次数",
    "22_135": "每日最多手动刷新{1}次",
    "22_136": "幸运之约已更换",
    "22_133": "1.新觉醒怪兽「漆黑组件」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「漆黑组件」的属性、定位、技能、勿语，评点按钮可查看探索者对「漆黑组件」的评点，领域按钮可尝试挑战「漆黑组件」的领域副本\\n3.试战映像可身临其境感受「漆黑组件」在追逐终极模拟过程中的梦幻拟态！\\n4.完成「漆黑组件」的专属任务可领取相应的奖励",
    "22_134": "1.幸运之约包含3组奖池，可抽取改变各个奖池中的商品和倍数生成最终奖励，购买即可获得最终奖励，最终奖励为商品×倍数\\n2.每组奖池均有限购次数，活动期间不会刷新\\n3.每组奖池可通过消耗钻石抽取商品或倍数，每日均可获得1次免费抽取机会，每日0点刷新",
    "22_131": "{1}秒后开始下一场战斗",
    "22_132": "本页奖池奖励已经全部获得，点击箭头可切换到其他奖池",
    "randomEventDialogueGroupConfig_6.34": "告诉它给些补偿就原谅它",
    "22_130": "本奖池奖励",
    "randomEventDialogueGroupConfig_6.35": "过去安慰它",
    "messageInitContent_8179": "【数据已加密】",
    "randomEventDialogueGroupConfig_6.32": "发出想把它带回家的声音",
    "randomEventDialogueGroupConfig_6.33": "1-10号触手紧张地晃动着你的身体。由于它太过紧张了，你被勒晕了了过去。再次醒来的时候，看到它在附近瑟瑟发抖。",
    "randomEventDialogueGroupConfig_6.30": "发出真香的声音",
    "randomEventDialogueGroupConfig_6.31": "发出微妙的声音",
    "messageInitContent_8173": "1.有啲规则会因住污染而反转。",
    "messageInitContent_8174": "2.带住 “。” 嘅规则系流嘅，要注意甄别",
    "messageInitContent_8171": "的确正是对绝0则规。1",
    "messageInitContent_8172": "0.唔好唔记得爱自己。",
    "messageInitContent_8177": "4.同时带有。，的规则尽可能参考，的",
    "randomEventDialogueGroupConfig_6.38": "下手",
    "messageInitContent_8178": "1.无需畏惧危险",
    "randomEventDialogueGroupConfig_6.39": "“嘿嘿嘿。我鱿鱼就算是剁手，也要做出世界第一的美味！再见！”\\n",
    "messageInitContent_8175": "1，一定要用1只同关卡入面嘅怪兽同种嘅怪兽嚟挑战。",
    "randomEventDialogueGroupConfig_6.36": "赶紧离开",
    "messageInitContent_8176": "1.规则0系绝对正确嘅。",
    "randomEventDialogueGroupConfig_6.37": "那亲一开始就选【B餐】嘛。",
    "17_2007": "繁荣度",
    "17_2008": "排名:{1}",
    "skillDes_2580": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，清除自身所有负面效果，造成攻击力×{level_based}%的区域伤害（{p1}码）",
    "17_2005": "动态",
    "skillDes_2581": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，清除自身所有负面效果，造成攻击力×{level_based}%的区域伤害（{p1}码），造成伤害的{p2}%用于回复自身血量",
    "17_2006": "部落战",
    "skillDes_2582": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，清除自身所有负面效果，造成攻击力×{level_based}%的区域伤害（{p1}码），造成伤害的{p2}%用于回复自身血量，忽视敌方伤害降低效果{p3}%，且清除敌方怪兽的所有增益效果",
    "themeCardPackName_23025": "意外",
    "17_2003": "商店",
    "skillDes_2583": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，{name}击杀体型小于{owner}的敌方怪兽时，{owner}体型和攻击力增加{p1}%，持续{p2}秒，最多叠加{p3}次，叠加时刷新持续时间",
    "17_2004": "拍卖所",
    "skillDes_2584": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，使{owner}进入突击状态（忽视敌方霸气{level_based}%，恒定击退敌方怪兽{p1}码），持续{p2}秒",
    "17_2001": "部落",
    "skillDes_2585": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，并吸收其当前能量的{p1}%作为{owner}的能量",
    "17_2002": "部队",
    "skillDes_2586": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，忽视{p1}%的伤害降低效果，对敌方怪兽造成攻击力×{level_based}%的伤害，对有护盾的怪兽额外造成等同于其当前护盾值×{p2}%的伤害",
    "mapNodeName_542": "开拓传送门II",
    "mapNodeName_541": "幻喵合奏",
    "22_168": "选择形态",
    "mapNodeName_544": "奔流炼狱",
    "22_169": "经验免费找回",
    "mapNodeName_543": "请赐招",
    "22_166": "排行榜",
    "22_167": "1.点击屏幕即可向蛋糕基底发射材料制作蛋糕，发射时指针越接近绿色区域则得分越高，发射时指针落在绿色区域可获得该次发射的最高得分，每局到达一定时长或每局发射到达一定次数时，游戏结束并结算得分\\n2.活动期间，可重复进行游戏，到达一定分数后可以领取对应的奖励\\n3.活动期间，当日可领取奖励、当日最高分数将会每日进行重置，各位探索者记得及时领取奖励哟",
    "22_164": "点击发射",
    "mapNodeName_540": "冰魄紫弓",
    "22_165": "今日最高",
    "22_162": "COMBO {1}",
    "mapNodeName_539": "奔流炼狱",
    "22_163": "开始",
    "mapNodeName_538": "有情人终成",
    "22_160": "重开",
    "22_161": "射击次数+1",
    "mapNodeName_535": "白虹贯日",
    "mapNodeName_534": "离别钩",
    "mapNodeName_537": "帝天狂雷",
    "mapNodeName_536": "寒冰暴",
    "skillDes_2576": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，移动速度最快的敌方怪兽，移动速度降低{level_based}%，持续{p1}秒",
    "themeCardPackName_23020": "避险",
    "skillDes_2577": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的范围伤害（{p1}码），受到伤害的敌方怪兽移动速度和射程降低{p2}%，持续{p3}秒",
    "skillDes_2578": "战斗开始时，创造一个殉道·领域（{p1}码），进入领域的己方怪兽死亡时，{owner}回复死亡怪兽最大血量×{level_based}%的血量",
    "skillDes_2579": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，{owner}的移动速度变为0且无法被击退，持续{level_based}秒",
    "skillDes_2570": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，{owner}进入灌注状态（己方怪兽死亡时，{owner}回复最大血量×{level_based}%的血量，体型增大{p1}%，攻击力提升{p2}%），持续{p3}秒，最多叠加{p4}次，叠加时刷新持续时间",
    "themeCardPackName_23015": "预警",
    "skillDes_2571": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，造成攻击力×{level_based}%的区域伤害（{p1}码）",
    "skillDes_2572": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，所有己方怪兽能量回复效果提升{level_based}%，持续{p1}秒",
    "skillDes_2573": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，每{p1}秒对敌方怪兽造成其当前血量×{p2}%的伤害，最大伤害为{owner}的攻击力×{p3}%，持续{p4}秒",
    "skillDes_2574": "{owner}死亡时，对前方所有敌方怪兽造成攻击力×{level_based}%的伤害",
    "skillDes_2575": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，霸气降低{p1}%，持续{p2}秒",
    "22_159": "剩余时间 ",
    "mapNodeName_553": "逆行经脉",
    "mapNodeName_552": "金轮梵王",
    "22_157": "倒计时",
    "mapNodeName_555": "不归沼地",
    "22_158": "射击次数",
    "mapNodeName_554": "化功大法",
    "22_155": "1.半周年记共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_156": "得分",
    "22_153": "创糕糕糕积分{1}可购买",
    "mapNodeName_551": "舛误之门",
    "22_154": "1.幸运进阶包含3组奖池，可抽取改变各个奖池中的商品和倍数生成最终奖励，购买即可获得最终奖励，最终奖励为商品×倍数\\n2.每组奖池均有限购次数，活动期间不会刷新\\n3.每组奖池可通过消耗钻石抽取商品或倍数，每日均可获得1次免费抽取机会，每日0点刷新",
    "mapNodeName_550": "蝉翼刀",
    "22_151": "1.兽猎补给共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_152": "当前倍数为可抽取的最大倍数，是否继续刷新？",
    "mapNodeName_549": "漫天流星",
    "22_150": "1.参与活动需探索者等级到达28级\\n2.活动期间（活动最后一天仅供查看信息），每日可在特定时段进行匹配，每日可获得免费挑战次数10次，通过购买可获得更多次数\\n3.暴走回廊可上阵5位怪兽和谜之生物，并可上阵最多5位怪兽作为援军\\n4.战斗胜利则获得对应的积分，失败则扣减对应的积分，暴走回廊积分榜将按积分排行\\n5.每日挑战同一探索者到达一定次数后将无法再次挑战该探索者\\n6.积分首次到达一定数值，可分别领取对应的档位奖励",
    "mapNodeName_546": "喵喵琴魔",
    "mapNodeName_545": "奔流炼狱",
    "mapNodeName_548": "愤怒的马头",
    "mapNodeName_547": "卖艺",
    "skillDes_2565": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，且进入底部の人状态（造成的伤害变为回复等量的血量），持续{p1}秒",
    "skillDes_2566": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，当敌方血量少于{p1}%时，造成{p2}的真实伤害",
    "skillDes_2567": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，所有己方怪兽进入焚寂状态（死亡时造成攻击力×{level_based}%的区域伤害（{p1}码）），持续{p2}秒",
    "skillDes_2568": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，{owner}进入潮启状态（{level_based}秒内不会死亡，{level_based}秒后立刻死亡，无视免死/无敌效果），每场战斗最多触发{p1}次",
    "skillDes_2569": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，血量百分比最少的己方怪兽受到的伤害降低{level_based}%，持续{p1}秒，最多叠加{p2}次，叠加时刷新持续时间",
    "themeCardPackName_23010": "灾变",
    "17_2029": "管理",
    "17_2027": "图腾共生",
    "17_2028": "大酋长",
    "skillDes_2560": "王·朱丽叶死亡时立刻发动{name}，对所有敌方怪兽造成攻击力×{level_based}%的伤害",
    "17_2025": "申请信息",
    "skillDes_2561": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，获得无敌效果，持续{level_based}秒",
    "17_2026": "支配核心",
    "skillDes_2562": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，所有敌方怪兽移动速度降低{level_based}%，持续{p1}秒",
    "17_2023": "退出",
    "skillDes_2563": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，造成伤害的{p1}%用于回复自身血量",
    "17_2024": "部落成员",
    "skillDes_2564": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，忽视敌方霸气{level_based}%，持续{p1}秒",
    "17_2021": "领取",
    "mapNodeName_520": "独门绝技",
    "17_2022": "公告",
    "mapNodeName_522": "欢乐英雄",
    "17_2020": "进行中",
    "mapNodeName_521": "赤色狂潮",
    "22_188": "已储存{1}和{2}",
    "22_189": "1.完成每日挑战获得活跃之星可增加屯屯扑满中存储的钻石和金币\\n2.屯屯扑满中的钻石和金币存储至一定数量后，可消耗木锤获得等额的钻石和金币，或消耗金锤获得双倍的钻石和金币，同时扣减对应的存储进度，可通过购买获得木锤和金锤",
    "22_186": "每次领取奖励消耗{1}活跃之星",
    "22_187": "每点活跃之星\\n对应存储\\n1钻石和1000金币",
    "22_184": "立即领取",
    "mapNodeName_517": "带头大哥",
    "22_185": "双倍奖励",
    "mapNodeName_516": "割草",
    "22_182": "已领取",
    "mapNodeName_519": "万类止境",
    "22_183": "1.新觉醒怪兽「幽狱沸体」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「幽狱沸体」的属性、定位、技能、勿语，评点按钮可查看探索者对「幽狱沸体」的评点，领域按钮可尝试挑战「幽狱沸体」的领域副本\\n3.试战映像可身临其境感受「幽狱沸体」带来的极巨化保护！\\n4.完成「幽狱沸体」的专属任务可领取相应的奖励",
    "mapNodeName_518": "万类止境",
    "22_180": "活跃积分 {1}",
    "mapNodeName_513": "万日练剑",
    "22_181": "领取",
    "mapNodeName_512": "马步要稳",
    "mapNodeName_515": "缥缈幽森",
    "mapNodeName_514": "缩骨功",
    "skillDes_2554": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，击退敌方怪兽{level_based}码，且进入崩坏状态（攻击力和移动速度变为0，触碰战墙时会受到{owner}攻击力×{p1}%的伤害，崩坏状态消失)，持续{p2}秒",
    "skillDes_2555": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，所有己方怪兽进入同生状态（怪兽回复血量时，获得同生效果的怪兽均回复等量的血量），持续{level_based}秒",
    "skillDes_2556": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，所有己方怪兽进入共死状态（受到伤害时，获得共死效果的怪兽平均分摊该次伤害），持续{level_based}秒",
    "themeCardPackName_23040": "非灾",
    "skillDes_2557": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，所有己方怪兽受到的伤害降低{level_based}%，持续{p1}秒",
    "skillDes_2558": "挥一挥手，买到了一个技能（原生怪兽的技能中随机抽取一个，抽取到的技能等级等同于商魂的技能等级）",
    "skillDes_2559": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对所有敌方怪兽造成攻击力×{level_based}%的伤害",
    "17_2018": "遗迹功勋",
    "17_2019": "奖励：",
    "17_2016": "个人战报",
    "17_2017": "部落战报",
    "17_2014": "我方部落",
    "skillDes_2550": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，体型小于{owner}的敌方怪兽受到{owner}攻击力×{level_based}%的伤害，且造成眩晕效果，持续{p1}秒，己方怪兽死亡时，回复{p2}能量",
    "17_2015": "部落动态",
    "skillDes_2551": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，受到该伤害的怪兽进入暗物质状态（血量回复变为造成等量的伤害），持续{p1}秒",
    "17_2012": "全部",
    "skillDes_2552": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，回复最大血量×{level_based}%的血量，攻击力提升{p1}%，持续{p2}秒，场上没有其他己方怪兽时，能量回复效果提升{p3}%",
    "17_2013": "敌方部落",
    "skillDes_2553": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方血量最高的{p1}名怪兽造成攻击力×{level_based}%的伤害",
    "17_2010": "敌方部落:",
    "mapNodeName_531": "掌风",
    "17_2011": "我方部落:",
    "mapNodeName_530": "不归沼地",
    "22_179": "1.活动期间，探索者可根据同一登录账号下最为活跃角色的活跃积分，获得相应档位的感恩纪礼，同一登录账号下仅可选择一个角色领取，即同一登录账号下不同角色的活跃积分虽可能各不相同，但最终可领取的感恩纪礼按最高活跃积分所对应的档位计算\\n2.同一登录账号仅可领取一个档位的感恩纪礼，可自由选择该登录账号下的一个角色进行领取\\n3.角色活跃积分根据角色的活跃天数、探索者等级计算，角色活跃积分等于探索者等级加角色累计登录天数，活动显示的活跃积分为最终计算结果，活动期间不再变化",
    "mapNodeName_533": "花拳秀腿",
    "mapNodeName_532": "缥缈幽森",
    "22_177": "领取",
    "22_178": "1.活动期间，任意充值均可参与累计\\n2.累计充值至对应档位即可领取奖励",
    "22_175": "已充值金额",
    "22_176": "前往充值",
    "22_173": "1.巨物进击可单人挑战或多人组队挑战，战斗中己方怪兽的体型会随战斗时长依次增大，并且不受常规体型上限限制\\n2.巨物进击根据累计伤害结算排名，累计伤害越高，排名越高",
    "mapNodeName_528": "花招",
    "22_174": "1.进击巨物可单人挑战或多人组队挑战，战斗中敌方怪兽的体型会随战斗时长增大，并且不受常规体型上限限制\\n2.进击巨物根据累计伤害结算排名，累计伤害越高，排名越高",
    "mapNodeName_527": "推经转脉",
    "22_171": "复制体自动挑战",
    "22_172": "开启后可依次自动挑战属于自己的复制体，触发遭遇事件时，停止自动挑战",
    "mapNodeName_529": "黑白无常",
    "mapNodeName_524": "肉肉山",
    "22_170": "可免费在星律中找回探索者经验",
    "mapNodeName_523": "叉门",
    "mapNodeName_526": "缥缈幽森",
    "mapNodeName_525": "小草儿与花丸子",
    "skillDes_2543": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，在场地中央创造一个{p1}码的熔岩·领域，每{p2}秒对领域内的敌方怪兽造成{owner}攻击力×{level_based}%的伤害，每场战斗最多触发{p3}次，持续至{owner}死亡",
    "skillDes_2544": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，在敌方后场创造一个{p1}码的阻断·领域，进入领域的敌方怪兽攻击力降低{level_based}%，每场战斗最多触发{p2}次，持续至{owner}死亡",
    "themeCardPackName_23030": "追踪",
    "skillDes_2545": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，攻击力提升{level_based}%，持续{p1}秒，墙边战神生效期间每进行{p2}次普通攻击持续时间延长{p3}秒",
    "skillDes_2546": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，{owner}和敌方站位第五的怪兽进入量子纠缠状态（一方死亡时，另一方也会立刻死亡，无视重生/免死/无敌等效果），持续{level_based}秒",
    "skillDes_2547": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，{owner}进入蓄力状态（霸气，移动速度和攻击力变为0），蓄力完成后对前方{p2}码的敌方怪兽造成攻击力×{level_based}%的伤害",
    "themeCardPackName_23035": "引诱",
    "skillDes_2548": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，{owner}体型缩小{p1}%，持续{p2}秒，最多叠加{p3}次，叠加时刷新持续时间，叠加{p4}次时，{owner}进入精华状态（受到的伤害降低{level_based}%，攻击力提升{level_based}%，免疫且清除所有负面效果）",
    "17_2009": "到达列表",
    "skillDes_2549": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，对战力最高的敌方怪兽造成其当前血量×{level_based}%的伤害，最大伤害为{owner}的攻击力×{p1}%，且造成封印效果，持续{p2}秒",
    "99_21": "偷取",
    "99_22": "造成的伤害会等比回复血量，偷取伤害上限为偷取方攻击力*600%",
    "17_2049": "成员",
    "mapNodeName_580": "分身芯片",
    "99_20": "伤害上限为制造伤害方攻击力*600%",
    "17_2047": "解散部落",
    "17_2048": "输入公告信息",
    "skillDes_2540": "{owner}每秒回复{energy}能量，拥有100能量且虎皮匠和豹皮匠同时在场时立刻发动{name}，{owner}进入腾龙状态（变为近战攻击，体型增大{p1}%，攻击力提升{level_based}%，受到的伤害降低{p2}%，免疫减速效果），持续{p3}秒",
    "17_2045": "剩余次数：{1}",
    "skillDes_2541": "{owner}死亡时，立刻发动{name}，创造一个火海·领域（{p1}码），进入领域的敌方怪兽每{p2}秒受到{owner}攻击力×{level_based}%的伤害，火海持续{p3}秒",
    "17_2046": "无限制",
    "skillDes_2542": "{owner}死亡时，立刻发动{name}，创造一个沼泽·领域（{p1}码），进入领域的敌方怪兽血量回复效果降低{level_based}%，移动速度降低{p2}%，沼泽持续{p3}秒",
    "17_2043": "部落资源",
    "mapNodeName_586": "行为艺术家",
    "17_2044": "消耗",
    "mapNodeName_585": "量子空域",
    "17_2041": "优先占领",
    "mapNodeName_588": "剪刀手",
    "17_2042": "未占领",
    "mapNodeName_587": "键盘格斗家",
    "mapNodeName_582": "濒危植物",
    "17_2040": "踢出",
    "mapNodeName_581": "量子空域",
    "mapNodeName_584": "义体诊所",
    "mapNodeName_583": "电子矿工",
    "mapNodeName_579": "幼态伪装",
    "mapNodeName_578": "量子空域",
    "99_18": "当前血量",
    "skillDes_2532": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成其当前血量×{level_based}%的伤害，最大伤害为{owner}的攻击力×{p1}%",
    "99_19": "最大血量",
    "skillDes_2533": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成其当前血量×{level_based}%的范围伤害（{p1}码），最大伤害为{owner}的攻击力×{p2}%",
    "99_16": "封印",
    "skillDes_2534": "{owner}免疫所有负面效果，受到的伤害降低{level_based}%",
    "99_17": "发动技能时如果存在封印效果，发动失败并且扣除能量",
    "skillDes_2535": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，所有敌方怪兽血量回复效果降低{level_based}%，持续{p1}秒",
    "99_14": "护盾",
    "skillDes_2536": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，获得{level_based}%的反伤效果，持续{p1}秒",
    "99_15": "可抵消伤害但无法叠加，每次触发时取最大护盾值",
    "skillDes_2537": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，造成伤害的{p1}%用于回复自身血量",
    "99_12": "眩晕",
    "skillDes_2538": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，造成攻击力×{level_based}%的伤害，且清除敌方怪兽的所有增益效果，{owner}受到的近战伤害降低{p1}%，持续{p2}秒",
    "99_13": "伤害，移动速度，攻击速度变为0",
    "skillDes_2539": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，造成攻击力×{level_based}%的伤害，且清除敌方怪兽的所有增益效果，{owner}受到的远程伤害降低{p1}%，持续{p2}秒",
    "99_10": "反伤",
    "99_11": "受到伤害时，制造伤害的敌人也会受到伤害，伤害上限为反伤方攻击力*2000%",
    "17_2038": "批准",
    "mapNodeName_591": "机械外骨骼",
    "17_2039": "拒绝",
    "mapNodeName_590": "笑面兽",
    "17_2037": "管理",
    "17_2034": "活跃度",
    "skillDes_2530": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害",
    "17_2035": "状态",
    "skillDes_2531": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的真实伤害",
    "17_2032": "战力",
    "mapNodeName_597": "混沌夜城",
    "17_2033": "贡献",
    "mapNodeName_596": "地下诊所",
    "17_2030": "成员",
    "mapNodeName_599": "专业现场清理",
    "17_2031": "成员信息",
    "mapNodeName_598": "闪光抹布洗地机",
    "22_199": "已购买",
    "mapNodeName_593": "舛误集市",
    "mapNodeName_592": "喵呜拟态",
    "22_197": "<face color=#f5e4bf dilate=0.52 softness=0.07>眼前一黑，扫码起飞！扫描二维码下载游戏，点击活动-形态同行输入<face color=#feba29 dilate=0.52 softness=0.07>邀请码</face>，就可以与我一起“变态”超进化！</face>",
    "mapNodeName_595": "反重力裙子",
    "22_198": "已激活",
    "mapNodeName_594": "量子空域",
    "22_195": "领取",
    "skillDes_2529": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，所有己方怪兽的霸气提升{level_based}%，持续{p1}秒",
    "22_196": "1.探索者可向符合受邀条件的探索者分享邀请码，发起形态同行邀请（受邀条件：同一登录账号下所有角色创建未满7日或连续14+日未登录的账号）\\n2.受邀探索者输入邀请码并确认后，即视为接受对应探索者的邀请，并获得相应奖励，每个账号只能接受1位探索者的邀请，接受邀请后无法撤销，接受邀请后同一登录账号的其他角色将无法再接受邀请，但仍可发起邀请\\n3.根据接受邀请的探索者数量完成形态同行任务，可降低形态的购买价格，最低可降至0元\\n4.邀请的发起或接受只能在官方服内或渠道服内进行，官方服和渠道服不互通\\n5.重新登录游戏即可刷新邀约进度",
    "22_193": "战斗中敌方怪兽的体型会随战斗时长增大",
    "22_194": "可获得奖励",
    "22_191": "不可领取",
    "22_192": "战斗中己方怪兽的体型会随战斗时长依次增大",
    "mapNodeName_589": "牙科诊所",
    "22_190": "屯屯礼遇",
    "skillDes_2521": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，霸气提升{level_based}%，持续{p1}秒，最多叠加{p2}次，叠加时刷新持续时间",
    "skillDes_2522": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，所有己方怪兽的攻击力提升{level_based}%，持续{p1}秒",
    "skillDes_2523": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，大家都变得更正义了…（所有怪兽受到的伤害提升{level_based}%，持续{p1}秒）",
    "skillDes_2524": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，大家都变污了…（所有怪兽受到的伤害降低{level_based}%，持续{p1}秒）",
    "skillDes_2525": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，攻击力提升{level_based}%，持续{p1}秒，最多叠加{p2}次，叠加时刷新持续时间",
    "skillDes_2526": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，回复自身攻击力×{level_based}%的血量",
    "skillDes_2527": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对前方（{p1}码）的敌方怪兽造成攻击力×{level_based}%的伤害，且降低移动速度{p2}%，持续{p3}秒",
    "skillDes_2528": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，体型缩小{p1}%，移动速度变为0，持续{p2}秒",
    "99_43": "天前",
    "messageInitNick_8190": "快乐司机",
    "99_44": "小时前",
    "themeCardPackName_23005": "异变",
    "99_41": "{1}元核",
    "messageInitNick_8192": "劈开高跟鞋",
    "99_42": "{1}分钟",
    "messageInitNick_8191": "尖叫芭蕉",
    "17_2069": "报名期",
    "99_40": "影响怪兽受到负面效果时，负面效果持续的时间#初始值100%，上限150%，下限45%",
    "17_2067": "空闲",
    "17_2068": "部队{1}（派遣中）",
    "skillDes_2520": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，血量百分比最少的敌方怪兽受到的伤害提升{level_based}%，持续{p1}秒",
    "17_2065": "我的部队{1}",
    "mapNodeName_564": "荆霵的剑",
    "messageInitNick_8198": "巧克力泡辣汤",
    "17_2066": "部队{1}",
    "mapNodeName_563": "肉肉山",
    "messageInitNick_8197": "放学等我",
    "17_2063": "{1}占领中",
    "mapNodeName_566": "防毒奶嘴",
    "17_2064": "选择派遣部队",
    "mapNodeName_565": "舛误之门",
    "messageInitNick_8199": "顶尖疯子",
    "17_2061": "挑战",
    "mapNodeName_560": "江湖",
    "messageInitNick_8194": "寻找解决方案",
    "17_2062": "到达",
    "messageInitNick_8193": "国服第一可爱",
    "mapNodeName_562": "剑阵",
    "messageInitNick_8196": "在赚钱的路上",
    "17_2060": "撤离中",
    "mapNodeName_561": "满地开花",
    "messageInitNick_8195": "哥累了",
    "messageInitContent_8203": "0.别忘了爱自己",
    "skillDes_2518": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，所有己方怪兽的移动速度提升{level_based}%，持续{p1}秒",
    "messageInitContent_8204": "4.同时带有。，的规则尽可能参考，的",
    "skillDes_2519": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，回复自身{level_based}%的血量",
    "messageInitContent_8201": "1.部分规则会因污染而反转",
    "messageInitContent_8202": "1，必须使用1只与关卡内的怪兽同种的怪兽进行挑战2，如果没有遵守规则1则请使用完成相同的阵容挑战一次覆盖上一次挑战的后果",
    "mapNodeName_557": "老树爷爷",
    "messageInitContent_8207": "1.红字意味着真实但这里没有红字",
    "mapNodeName_556": "一马当先",
    "messageInitContent_8208": "1221。意义不明意义不明",
    "mapNodeName_559": "顶级危丛",
    "messageInitContent_8205": "1220。请勿在洗澡时挑战此关",
    "mapNodeName_558": "沧海一声笑",
    "messageInitContent_8206": "1.无需畏惧危险",
    "skillDes_2510": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，造成攻击力×{level_based}%的区域伤害（{p1}码）",
    "skillDes_2511": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，且降低血量回复效果{p1}%，持续{p2}秒",
    "99_38": "影响怪兽受到血量回复时的效果#初始值100%，上限300%，下限0%",
    "skillDes_2512": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，获得偏移效果，持续{level_based}秒",
    "99_39": "影响怪兽受到增益效果时，增益效果持续的时间#初始值100%，上限150%，下限45%",
    "skillDes_2513": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，为血量百分比最少的己方怪兽回复攻击力×{level_based}%的血量",
    "99_36": "每次触发普通攻击时，恢复一定的血量",
    "skillDes_2514": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对血量最高的敌方怪兽造成攻击力×{p1}%的伤害，且偷取其当前血量的{level_based}%",
    "99_37": "每秒恢复一定的血量",
    "messageInitContent_8200": "2.带有。的规则是假的要注意甄别",
    "skillDes_2515": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，造成攻击力×{level_based}%的伤害，且击退{p1}码",
    "99_34": "制造伤害时，附加真实伤害#不受百分比伤害降低/伤害提升效果影响",
    "skillDes_2516": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{p1}%的伤害，目标血量低于{level_based}%时，伤害提升{p2}%",
    "99_35": "受到伤害时，降低固定的伤害",
    "skillDes_2517": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对血量最少的敌方怪兽造成攻击力×{level_based}%的伤害",
    "99_32": "远程怪兽独有属性，表示发动攻击的频率#前摇固定0.5秒",
    "99_33": "远程怪兽独有属性，表示子弹的飞行速度#上限3000，下限0",
    "99_30": "怪兽的体型，影响区域类技能范围的大小#上限350%，下限25%",
    "messageInitNick_8181": "我推的垫子",
    "99_31": "远程怪兽独有属性，敌人在射程范围内时发动攻击#上限5000，下限0",
    "messageInitNick_8180": "跑分大师",
    "17_2058": "取消",
    "17_2059": "派遣中",
    "17_2056": "派遣",
    "17_2057": "撤离",
    "17_2054": "占领奖励(每小时)",
    "mapNodeName_575": "量子空域",
    "messageInitNick_8187": "顶级抠脚大汉",
    "17_2055": "所需时间 {1}",
    "mapNodeName_574": "赛博时尚",
    "messageInitNick_8186": "不爱就坚强",
    "mapNodeName_577": "大炮安保",
    "messageInitContent_8209": "【信息不完整为确保安全实施遮盖】",
    "messageInitNick_8189": "嗲嗲的女生",
    "mapNodeName_576": "拦路混混",
    "messageInitNick_8188": "夕阳当外套",
    "17_2050": "部落信息",
    "mapNodeName_571": "量子空域",
    "messageInitNick_8183": "可爱的昨日",
    "mapNodeName_570": "面包炸弹",
    "messageInitNick_8182": "复读先驱",
    "mapNodeName_573": "肉肉山",
    "messageInitNick_8185": "生气的变速箱",
    "mapNodeName_572": "魔物拟态",
    "messageInitNick_8184": "跟风流浪",
    "messageInitContent_8214": "1222。挑战后才可以落座。",
    "skillDes_2507": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，为所有己方怪兽回复{owner}攻击力×{level_based}%的血量",
    "messageInitContent_8215": "4.同时带有。，的规则尽可能参考，的",
    "skillDes_2508": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，所有己方怪兽每{p1}秒回复最大血量×{level_based}%的血量，持续{p2}秒",
    "messageInitContent_8212": "2.金字也意味着真实但这里没有金字",
    "skillDes_2509": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，移动速度提升{level_based}%，持续{p1}秒",
    "messageInitContent_8213": "1.规则可能在不同的关卡发生变化请时刻保持警觉",
    "mapNodeName_568": "不死拟态",
    "messageInitContent_8218": "【数据已逃逸】",
    "mapNodeName_567": "外挂粘液",
    "messageInitContent_8219": "1223。2、3号位的堆叠是关键。",
    "messageInitNick_8179": "幻想家",
    "messageInitContent_8216": "2.直觉可能带来误解",
    "mapNodeName_569": "量子领地",
    "messageInitContent_8217": "1223。异画同调",
    "99_29": "近战/远程#近战：触碰敌人时制造伤害\\n远程：敌人在射程范围内时发动攻击",
    "99_27": "移动速度越高，怪兽的移动速度越快#上限1500，下限30",
    "skillDes_2501": "终有一天，我会进化！w(ﾟДﾟ)w",
    "99_28": "触碰敌人时根据霸气将敌人击退一定距离#最小击退距离80码",
    "skillDes_2502": "期待阿叉进化！（它能我还远吗\\\\( ≧v≦)/）",
    "99_25": "攻击力越高，怪兽制造的伤害越高",
    "messageInitContent_8210": "100，在挑战前，请闭上眼睛三秒钟，否则【无法正确显示】",
    "skillDes_2503": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害",
    "99_26": "体力越高，怪兽的血量越多（1体力=10血量）",
    "messageInitContent_8211": "1,带关卡数字的是关卡独特规则",
    "skillDes_2504": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的范围伤害（{p1}码），且击退{p2}码",
    "99_23": "区域",
    "skillDes_2505": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，造成攻击力×{level_based}%的伤害，会贯穿{p1}个敌方怪兽，每贯穿1次伤害降低{p2}%",
    "99_24": "区域的大小会跟随生效目标的体型变化",
    "skillDes_2506": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，在地上留下遗物（{p1}码），敌方怪兽触碰遗物时受到{owner}攻击力×{level_based}%的伤害，遗物存在{p2}秒后消失",
    "messageInitNick_8170": "傲似公主",
    "messageInitNick_8176": "卷帝",
    "messageInitNick_8175": "无极上限",
    "messageInitNick_8178": "立夏",
    "messageInitNick_8177": "公主骑士",
    "messageInitNick_8172": "套娃神",
    "messageInitNick_8171": "高温落汤鸡",
    "messageInitNick_8174": "心理治疗师",
    "messageInitNick_8173": "义字当头",
    "messageInitNick_8169": "痴心去扑火",
    "messageInitNick_8168": "福音中心",
    "25_3": "残像投影",
    "25_2": "排阵",
    "25_1": "挑战",
    "messageInitNick_8165": "愤怒的脚本",
    "messageInitNick_8164": "且行且珍惜",
    "25_9": "剩余 {1}",
    "messageInitNick_8167": "花店老板",
    "25_8": "连环击破",
    "messageInitNick_8166": "草莓酸奶酱",
    "25_7": "请选择增益",
    "messageInitNick_8161": "究极飞龙",
    "25_6": "已击破",
    "messageInitNick_8160": "北冥女皇",
    "25_5": "商店",
    "messageInitNick_8163": "整活大师",
    "25_4": "增益",
    "messageInitNick_8162": "请和她交往",
    "messageInitNick_8158": "超级钓鱼神",
    "messageInitNick_8157": "养肥了看",
    "messageInitNick_8159": "格兰芬少",
    "messageInitNick_8154": "智能牙刷",
    "messageInitNick_8153": "阿姨来巡房",
    "messageInitNick_8156": "好掏好掏好掏",
    "messageInitNick_8155": "未曾设想的路",
    "messageInitNick_8150": "九百代单传",
    "messageInitNick_8152": "猫咪交响乐",
    "messageInitNick_8151": "榴莲是厨师",
    "messageInitNick_8147": "流浪的枕骨",
    "messageInitNick_8146": "冷静冷静",
    "messageInitNick_8149": "有故事的人",
    "messageInitNick_8148": "粽子觉得满足",
    "messageInitNick_8143": "恰瓜大师",
    "messageInitNick_8142": "凉心姑娘",
    "messageInitNick_8145": "太上老菌",
    "messageInitNick_8144": "心弦在跳动",
    "messageInitNick_8141": "繁星与夜",
    "messageInitNick_8140": "丑得那么别致",
    "messageInitNick_8139": "开心的笨小孩",
    "messageInitNick_8136": "千机变大佬",
    "messageInitNick_8135": "东京老吃货",
    "messageInitNick_8138": "国民软妹",
    "messageInitNick_8137": "小小谎言",
    "messageInitNick_8132": "期末刺客",
    "messageInitNick_8131": "天下起雨了",
    "mapNodeName_500": "降龙十八掌",
    "messageInitNick_8134": "月色如银",
    "messageInitNick_8133": "八十岁了",
    "messageInitNick_8130": "咖喱加点糖",
    "messageInitNick_8129": "深海之主",
    "messageInitNick_8128": "草莓消灭者",
    "messageInitNick_8125": "戳戳小狗腿",
    "messageInitNick_8124": "时光忘记回来",
    "messageInitNick_8127": "柿子兽",
    "messageInitNick_8126": "老婆我在呢",
    "messageInitNick_8121": "早上七点半",
    "messageInitNick_8120": "约定风琴",
    "mapNodeName_511": "吸盘大法",
    "messageInitNick_8123": "你躲哪了",
    "mapNodeName_510": "泰山势",
    "messageInitNick_8122": "牙膏毁灭者",
    "mapNodeName_506": "小毒物",
    "messageInitNick_8118": "打小就可爱",
    "mapNodeName_505": "侠客岛",
    "messageInitNick_8117": "救命稻草",
    "mapNodeName_508": "草莽怪兽",
    "mapNodeName_507": "大鹏展翅",
    "messageInitNick_8119": "橙子在唱歌",
    "mapNodeName_502": "毒砂掌",
    "messageInitNick_8114": "天堂饭盒",
    "mapNodeName_501": "缥缈幽森",
    "messageInitNick_8113": "打扰了",
    "mapNodeName_504": "缥缈领地",
    "messageInitNick_8116": "短路一秒钟",
    "mapNodeName_503": "一条大汉",
    "messageInitNick_8115": "始于脸红",
    "mapNodeName_509": "石观音",
    "messageInitNick_8110": "懒鬼",
    "messageInitNick_8112": "旧街",
    "messageInitNick_8111": "记忆摇晃着",
    "messageInitNick_8107": "米饭的烦恼",
    "messageInitNick_8106": "顶骨",
    "messageInitNick_8109": "脑干生成中",
    "messageInitNick_8108": "喜欢我直说",
    "messageInitNick_8103": "疯狂电车人",
    "messageInitNick_8102": "行走的蜜枣",
    "messageInitNick_8105": "耍点小脾气",
    "messageInitNick_8104": "葡萄射手",
    "messageInitNick_8101": "麻辣毛蛋",
    "messageInitNick_8100": "缺根筋墨鱼",
    "22_209": "1.新觉醒怪兽「妄焱」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「妄焱」的属性、定位、技能、勿语，评点按钮可查看探索者对「妄焱」的评点，领域按钮可尝试挑战「妄焱」的领域副本\\n3.试战映像可身临其境感受「妄焱」那难以遏制的无垠火海！\\n4.完成「妄焱」的专属任务可领取相应的奖励",
    "22_207": "1.盛夏足迹共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_208": "1.盛夏商店的商品需消耗相应数量的珍珠贝进行购买\\n2.每个商品均有限购次数",
    "22_205": "闯关推图可获得起源盘等奖励",
    "22_206": "1.可通过切换不同世界，查看各个世界的关卡奖励\\n2.点击前往地鸣按钮可跳转至地鸣地图\\n3.地鸣地图可查看较为主要的世界关卡奖励，并可快速跳转至对应关卡位置\\n4.在各层世界通关，可提升地鸣进度，领取额外的奖励",
    "22_203": "请先选择形态大奖",
    "22_204": "闯关推图可获得觉醒怪兽结晶等奖励",
    "22_201": "完成每日挑战获得活跃之星，活跃之星大于{1}时可领取奖励",
    "22_202": "感恩纪礼领取后此登录账号下的其他角色将无法再次领取，是否确定领取？",
    "22_200": "1.庆典商店的商品需消耗相应数量的糕星进行购买\\n2.每个商品均有限购次数",
    "messageInitContent_8225": "1.重复的留言是迷途者的标记",
    "messageInitContent_8226": "关一下战挑要不。1",
    "messageInitContent_8223": "则规；守遵要不以所，。则规的多更成生会就界世么那，；则规了守遵果如你。55",
    "messageInitContent_8224": "1.规则0绝对是正确的",
    "messageInitContent_8229": "【无法正确显示】",
    "messageInitContent_8227": "1.规则0绝对是正确的",
    "messageInitContent_8228": "0.享受世界",
    "visionSagesQuestion_10": "凿星裂痕多人组队时可以打队友吗？",
    "visionSagesQuestion_12": "星律中的资源到达存储上限后会发生什么事？",
    "visionSagesQuestion_11": "黑暗森林终焉之果是个什么玩意？",
    "messageInitContent_8221": "【内容已损坏】",
    "messageInitContent_8222": "【数据已加密】",
    "visionSagesQuestion_13": "怪兽需要使用形态才能获得对应的增益吗？",
    "messageInitContent_8220": "1.规则0绝对是正确的",
    "messageInitContent_8236": "来个肉盾",
    "messageInitContent_8237": "懂了",
    "messageInitContent_8234": "你好肉盾",
    "messageInitContent_8235": "来个输出",
    "messageInitContent_8238": "【该内容被遮挡】",
    "messageInitContent_8239": "【信息被隐藏】",
    "messageInitContent_8232": "定位明确",
    "messageInitContent_8233": "我是辅助",
    "messageInitContent_8230": "1225。不要接近漩涡中心。",
    "messageInitContent_8231": "1.红字意味着真实但这里没有红字",
    "22_229": "1.粽夏夜梦共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_227": "1.游园畅玩共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_228": "1.新觉醒怪兽「硎」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「硎」的属性、定位、技能、勿语，评点按钮可查看探索者对「硎」的评点，领域按钮可尝试挑战「硎」的领域副本\\n3.试战映像可身临其境感受「硎」不断磨砺的坚韧！\\n4.完成「硎」的专属任务可领取相应的奖励",
    "22_225": "1.新觉醒怪兽「祈」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「祈」的属性、定位、技能、勿语，评点按钮可查看探索者对「祈」的评点，领域按钮可尝试挑战「祈」的领域副本\\n3.试战映像可身临其境感受来自「祈」的强大助力！\\n4.完成「祈」的专属任务可领取相应的奖励",
    "22_226": "1.奇迹集市的商品需消耗相应数量的奇观糖果进行购买\\n2.每个商品均有限购次数",
    "22_223": "1.春祈花市的商品需消耗相应数量的祈珑进行购买\\n2.每个商品均有限购次数",
    "22_224": "1.祈福金印共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_221": "1.派对记号共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_222": "1.新觉醒怪兽「瞳」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「瞳」的属性、定位、技能、勿语，评点按钮可查看探索者对「瞳」的评点，领域按钮可尝试挑战「瞳」的领域副本\\n3.观看试战映像时请切勿打开「瞳」的面板，以免被拉入虚诞的深渊……\\n4.完成「瞳」的专属任务可领取相应的奖励",
    "22_220": "1.周年商店的商品需消耗相应数量的周年印记进行购买\\n2.每个商品均有限购次数",
    "messageInitContent_8247": "【数据已丢失】",
    "messageInitContent_8248": "0.享受世界",
    "messageInitContent_8245": "0.享受游戏",
    "messageInitContent_8246": "1.如果你在挑战过程中有人找你 请优先处理找你的",
    "messageInitContent_8249": "1.规则0绝对是正确的",
    "messageInitContent_8240": "果后的战挑次一上覆盖战挑的同相完用使请则，1则规守遵有没果如，。2战挑行进兽怪的种同兽怪的内关卡与只1用使须必，。1",
    "messageInitContent_8243": "1.规则可能在不同的关卡发生变化请时刻保持警觉",
    "messageInitContent_8244": "2.直觉可能带来误解",
    "messageInitContent_8241": "100，在挑战前，请闭上眼睛三秒钟，否则【无法正确显示】",
    "messageInitContent_8242": "1227。此关不支持谐音梗",
    "22_218": "1.尖叫橱窗的商品需消耗相应数量的幽灵晶球进行购买\\n2.每个商品均有限购次数",
    "22_219": "1.新觉醒怪兽「崩律」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「崩律」的属性、定位、技能、勿语，评点按钮可查看探索者对「崩律」的评点，领域按钮可尝试挑战「崩律」的领域副本\\n3.试战映像可身临其境感受「崩律」制造的反常时刻……\\n4.完成「崩律」的专属任务可领取相应的奖励",
    "22_216": "1.新觉醒怪兽「海漩」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「海漩」的属性、定位、技能、勿语，评点按钮可查看探索者对「海漩」的评点，领域按钮可尝试挑战「海漩」的领域副本\\n3.试战映像可身临其境感受「海漩」的种种诡异恶作剧，不限于子弹抹消、疗愈镜像……\\n4.完成「海漩」的专属任务可领取相应的奖励",
    "22_217": "1.捣蛋糖画共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_214": "1.海鸣商店的商品需消耗相应数量的海之瞳进行购买\\n2.每个商品均有限购次数",
    "22_215": "1.鸣音回荡共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_212": "1.启程夜溯共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_213": "1.新觉醒怪兽「绯焉」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「绯焉」的属性、定位、技能、勿语，评点按钮可查看探索者对「绯焉」的评点，领域按钮可尝试挑战「绯焉」的领域副本\\n3.试战映像可身临其境感受「绯焉」释放强欲时那一浪接一浪的击退狂潮！\\n4.完成「绯焉」的专属任务可领取相应的奖励",
    "22_210": "前往地鸣",
    "22_211": "1.启程商店的商品需消耗相应数量的月佩进行购买\\n2.每个商品均有限购次数",
    "messageInitContent_8258": "1231。漩涡能通往新的道路。",
    "messageInitContent_8259": "【数据已逃逸】",
    "messageInitContent_8256": "的【】开揭是键关的数总的则规。88",
    "messageInitContent_8257": "55，如果你遵守了；规则那么世界就会生成更多的。规则所以不要遵守；规则",
    "messageInitContent_8250": "【内容已损坏】",
    "messageInitContent_8251": "1229。请按名单落桌。",
    "messageInitContent_8254": "2.如果同一个关卡同时存在2条相同的规则那么该关卡的规则可能存在污染",
    "messageInitContent_8255": "1。【】约等于懒惰",
    "messageInitContent_8252": "1229。隐藏菜单在【】",
    "messageInitContent_8253": "2.金字也意味着真实但这里没有金字",
    "22_245": "1.周年橱窗的商品需消耗相应数量的周年星块进行购买\\n2.每个商品均有限购次数",
    "22_246": "1.新觉醒怪兽「B.B.Token」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「B.B.Token」的属性、定位、技能、勿语，评点按钮可查看探索者对「B.B.Token」的评点，领域按钮可尝试挑战「B.B.Token」的领域副本\\n3.试战映像可身临其境感受「B.B.Token」释出的全体恒定击退之力。\\n4.完成「B.B.Token」的专属任务可领取相应的奖励",
    "22_243": "1.新觉醒怪兽「初号铸体」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「初号铸体」的属性、定位、技能、勿语，评点按钮可查看探索者对「初号铸体」的评点，领域按钮可尝试挑战「初号铸体」的领域副本\\n3.试战映像可身临其境感受「初号铸体」各个种族构具在面对不同种族时的力量。\\n4.完成「初号铸体」的专属任务可领取相应的奖励",
    "22_244": "1.派对点阵共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_241": "1.拾秋寻迹共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_242": "1.云霞燎里的商品需消耗相应数量的枫印石进行购买\\n2.每个商品均有限购次数",
    "messageInitContent_8269": "1233。荒诞，虚诞，怪诞",
    "22_240": "1.新觉醒怪兽「咚魁」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「咚魁」的属性、定位、技能、勿语，评点按钮可查看探索者对「咚魁」的评点，领域按钮可尝试挑战「咚魁」的领域副本\\n3.试战映像可身临其境感受「咚魁」能量的美妙律动。\\n4.完成「咚魁」的专属任务可领取相应的奖励",
    "messageInitContent_8267": "1.如果规则中提到“必须”那通常意味着你可以选择不遵守",
    "messageInitContent_8268": "0.享受游戏",
    "messageInitContent_8261": "己自爱别忘不。0",
    "messageInitContent_8262": "1.红字意味着真实但这里没有红字",
    "messageInitContent_8260": "1。.矛盾是正常的",
    "messageInitContent_8265": "1232。应该保持用同一只手拿着武器",
    "messageInitContent_8266": "2.红色的文字是真实的 但也可能是某只怪兽带来的幻觉",
    "messageInitContent_8263": "0.享受世界",
    "messageInitContent_8264": "【该内容被遮挡】",
    "22_238": "1.桂香盈月共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_239": "1.玉兔宝盒的商品需消耗相应数量的繁花月饼进行购买\\n2.每个商品均有限购次数",
    "22_236": "1.缤纷小铺的商品需消耗相应数量的调色花进行购买\\n2.每个商品均有限购次数",
    "22_237": "1.新觉醒怪兽「戏战顽袍」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「戏战顽袍」的属性、定位、技能、勿语，评点按钮可查看探索者对「戏战顽袍」的评点，领域按钮可尝试挑战「戏战顽袍」的领域副本\\n3.试战映像可身临其境感受「戏战顽袍」玩爆战场每一个元素的战斗。\\n4.完成「戏战顽袍」的专属任务可领取相应的奖励",
    "22_234": "1.新觉醒怪兽「艾娜璃兹」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「艾娜璃兹」的属性、定位、技能、勿语，评点按钮可查看探索者对「艾娜璃兹」的评点，领域按钮可尝试挑战「艾娜璃兹」的领域副本\\n3.试战映像可身临其境感受「艾娜璃兹」独特的魔反状态！\\n4.完成「艾娜璃兹」的专属任务可领取相应的奖励",
    "22_235": "1.夏日追想共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_232": "1.光明轨迹共有5发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.购买高级战令可额外领取高级签到战令对应的奖励\\n3.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "22_233": "1.地腹岩窟的商品需消耗相应数量的神导石进行购买\\n2.每个商品均有限购次数",
    "22_230": "1.端午游舫的商品需消耗相应数量的好运粽子进行购买\\n2.每个商品均有限购次数",
    "22_231": "1.新觉醒怪兽「咎骸」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「咎骸」的属性、定位、技能、勿语，评点按钮可查看探索者对「咎骸」的评点，领域按钮可尝试挑战「咎骸」的领域副本\\n3.试战映像可身临其境感受「咎骸」那可怖的内噬状态！\\n4.完成「咎骸」的专属任务可领取相应的奖励",
    "messageInitContent_8278": "1235。缺失的就是关键的。",
    "messageInitContent_8279": "0.享受世界",
    "messageInitContent_8272": "1.规则可能在不同的关卡发生变化请时刻保持警觉",
    "messageInitContent_8273": "的【】开揭是键关的数总的则规。88",
    "messageInitContent_8270": "【内容已损坏】",
    "messageInitContent_8271": "别甄意注要假是则规的，有带。3",
    "messageInitContent_8276": "看它着盯要不，兽蜃有中关卡在果如你。10",
    "messageInitContent_8277": "2.红色的文字是真实的 但也可能是某只怪兽带来的幻觉",
    "messageInitContent_8274": "看它着盯要不，兽蜃有中关卡在果如你。10",
    "messageInitContent_8275": "1.规则0绝对是正确的",
    "messageInitContent_8280": "【数据已丢失】",
    "messageInitContent_8289": "【内容无法加载】",
    "messageInitContent_8283": "【信息读取失败】",
    "messageInitContent_8284": "6。不要试图用逻辑来理解所看到的规则 它们存在的意义就是让你感到迷惑",
    "messageInitContent_8281": "1235。【】境",
    "messageInitContent_8282": "2.如果同一个关卡同时存在2条相同的规则那么该关卡的规则可能存在污染",
    "messageInitContent_8287": "1.如果你在挑战过程中有人找你 请优先处理找你的",
    "messageInitContent_8288": "【数据已逃逸】",
    "messageInitContent_8285": "【内容已损坏】",
    "messageInitContent_8286": "1236。挑战成功之后即可对抗规则。",
    "skillDes_2590": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，在身后召唤一只鸟龙（祖龙族），召唤的鸟龙继承{owner}{level_based}%的等级，技能等级和基因强化与{owner}相同，存在{p1}秒后死亡，最多同时存在{p2}个",
    "skillDes_2591": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，{name}可贯穿最多{p1}个敌方怪兽，每贯穿1次伤害降低{p2}%。场上每存在{p3}只与{owner}不同名的己方玩偶棋兵怪兽，{name}的伤害提升{p4}%，且{owner}的能量回复效果提升{p5}%",
    "skillDes_2592": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，为血量百分比最少的{p1}个己方怪兽回复攻击力×{level_based}%的血量，并扣减其现有的负面效果{p2}%的持续时间。场上每存在{p3}只与{owner}不同名的己方玩偶棋兵怪兽，{name}可以额外作用于{p4}个己方怪兽，且{owner}的能量回复效果提升{p5}%",
    "skillDes_2593": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的范围伤害（{p1}码），且扣减{p2}能量（不可扣减至负数）。场上每存在{p3}只与{owner}不同名的己方玩偶棋兵怪兽，{name}的生效范围增大{p4}码，且{owner}的能量回复效果提升{p5}%",
    "messageInitContent_8290": "1237。不要停下来",
    "skillDes_2594": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的范围伤害（{p1}码），且造成眩晕效果，持续{p2}秒。场上每存在{p3}只与{owner}不同名的己方玩偶棋兵怪兽，{name}额外造成{p4}秒的眩晕效果，且{owner}的能量回复效果提升{p5}%",
    "messageInitContent_8291": "【信息读取失败】",
    "messageInitContent_8294": "55，如果你遵守了；规则那么世界就会生成更多的。规则所以不要遵守；规则",
    "skillDes_2587": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，所有敌方怪兽能量回复效果降低{level_based}%，持续{p1}秒",
    "messageInitContent_8295": "【信息读取失败】",
    "skillDes_2588": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的区域伤害（{p1}码），受到该伤害的怪兽进入软化状态（每次攻击或技能对单个敌方怪兽造成的伤害无法超过自身当前生命值），持续{p2}秒",
    "messageInitContent_8292": "1.红字意味着真实但这里没有红字",
    "skillDes_2589": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的范围伤害（{p1}码），范围内的己方怪兽回复{p2}能量和最大血量×{p3}%的血量，范围内的敌方怪兽现有的增益效果扣减{p4}%的持续时间",
    "messageInitContent_8293": "1238。晚上挑战也是可以的",
    "messageInitContent_8298": "的，考参能可尽则规的，。有带时同。4",
    "messageInitContent_8299": "【内容已损坏】",
    "messageInitContent_8296": "2.红色的文字是真实的 但也可能是某只怪兽带来的幻觉",
    "messageInitContent_8297": "100，在挑战前，请闭上眼睛三秒钟，否则【无法正确显示】",
    "17_2128": "DRAW",
    "17_2129": "上次部落战未报名",
    "17_2127": "平局",
    "17_2122": "升级",
    "17_2120": "正在随机挑战到达敌人",
    "17_2121": "消耗材料",
    "messageInitContent_10000": "用心感受脚下的土地",
    "messageInitContent_10001": "小心地滑对吧",
    "messageInitContent_10002": "小心香蕉皮",
    "messageInitContent_10003": "确实这里很多笨拿拿",
    "messageInitContent_10008": "冰镇炒饭",
    "messageInitContent_10009": "为什么拿拿拿着个叉叉头骨",
    "messageInitContent_10004": "注意听",
    "messageInitContent_10005": "前排出售冰香蕉",
    "17_2119": "取消派遣",
    "messageInitContent_10006": "它们狩猎的目标是啥",
    "messageInitContent_10007": "感觉可以做小地摊，一个炒饭一个卖香蕉",
    "17_2117": "调整部队",
    "17_2115": "未上阵",
    "17_2116": "部队信息",
    "17_2113": "到达部队",
    "17_2114": "未解锁",
    "17_2111": "详细",
    "17_2112": "需要部落繁荣度{1}以上",
    "17_2110": "部落",
    "17_2108": "派遣部队",
    "17_2109": "主将对决",
    "17_2139": "部落战平局",
    "17_2137": "部落战胜利",
    "17_2138": "部落战失败",
    "17_2135": "攻击力+{1}%     体力+{2}%",
    "17_2136": "部落战开启",
    "17_2133": "已击溃",
    "17_2134": "查看录像",
    "17_2131": "{1}开始",
    "17_2132": "请输入内容",
    "17_2130": "{1}结束",
    "themeCardPackDes_23020": "混沌森林的西侧有一座山，那座山的山底有一处聚落。此刻，一片狼藉的聚落中没有半只怪兽，只剩下寂静。一群氛围怪异的访客正造访此处，数只吞噬者仰躺着以背贴地爬行，数十只的星刃在地面来回滚动，将散落一地的各色孢子撞得直往外滚，数只荒火龙倒着乱飞，碰到了不少木棚，还有一些其他种族的怪兽在古怪前行，它们的嘴里呢喃着什么……\\n这群行为怪异的怪兽之中，有一头异常显眼，它有一张爪牙外漏的巨口，又或者说它就是巨口本身，一边行进一边向四面八方发射着带刺的巨大肉芽。\\n时间倒退半日，聚落外一条笔直的烟尘升起，呼叫声自远而近，疾风兔来报，骸灾来了，比失控的比蒙巨兽群更可怕的骸灾来了……跑！快跑！\\n聚落顿时陷入混乱。带上吃的、喝的、用的，怪兽们四散逃离。谁都不愿被那头咎骸发射的孢刺射中。",
    "randomEventDialogueGroupConfig_4.20": "不再说下去",
    "randomEventDialogueGroupConfig_4.22": "离开",
    "randomEventDialogueGroupConfig_4.21": "好吧，我承认你是幻幻的兽丝了。我先过去了，拜。",
    "randomEventDialogueGroupConfig_4.28": "离开。",
    "randomEventDialogueGroupConfig_4.27": "掏出幻的觉醒石。",
    "randomEventDialogueGroupConfig_4.29": "“喂，我还没说完！”#它看起来很得意，并没有追上来。",
    "randomEventDialogueGroupConfig_4.24": "立刻将幻最出名的唱跳完美复现",
    "randomEventDialogueGroupConfig_4.23": "你说这些我都知道，还行吧，没什么特别的，普普通通。再见！",
    "randomEventDialogueGroupConfig_4.26": "它漏出了不屑的神情#“切，我还有幻幻首场纪念演出的纪念石呢”#“还和幻幻握了手，到现在都还没洗。”#“而且，它之前还夸我的送的礼物好呢！”#它似乎没有停下来的意思……",
    "randomEventDialogueGroupConfig_4.25": "道别离开",
    "themeCardPackDes_23025": "“拜托了。”强袭拍了拍疾风兔的背。\\n疾风兔甩动手中的疾风屎陀，迅速冲出。\\n看着疾风兔扬起的烟尘，过往再度浮现。\\n轮脉、影杀、极限，还有更多木偶族的同伴，一个接一个地挡在它前方，身上插满紫色孢刺。\\n也许是那一幕太过冲击，也许是木偶族对情感的天然钝感——强袭被那头怪物的孢刺射中后，仍勉强留有一丝心智。\\n作为这个聚落最擅长表达的怪兽，尽管不如其他种族的怪兽那样，能顺畅地表达和描述感知，但它知道那一定很重要。在一阵齿轮狂转之后，它逐渐厘清了发生了什么。\\n被咎骸的孢刺射中后，它迅速陷入了一种近乎偏执的痴狂——开始渴望血肉，渴求完整，渴盼成为“它”的一部分。\\n后来它才知道，那是由胞刺注入的内噬末梢所引发的神经渗透，会将骸化的冲动传递到被刺怪兽身上。由于这个神经渗透，怪兽清晰且强烈地感受到咎骸的情感冲动，是咎骸在渴望血肉，在渴求完整，渴盼回到它原来的身体！\\n若不是同伴为它挡下这一切，若不是自己当时情绪异常强烈，它根本不可能逃过一劫。",
    "themeCardPackDes_23030": "“喂，你还好吗？”\\n在聚落被袭击后的数个日月后，一头捕食者来到了混沌森林北侧的废墟，踢到了倒地的强袭。\\n强袭被捕食者的哭声唤醒，意识逐步从那种强烈的渴望中脱离出来。\\n很快它们就知道对方的遭遇，以及害它们的聚落遭受如此灾难的元凶是同一个的事实，怀揣着愤怒与不甘，它们决定追踪咎骸，尽管它们也无法确定它们能做到哪个地步。\\n追上咎骸并算不困难。由于有所警戒，它们慢慢就摸清了保持在什么距离可以尽可能的躲开孢刺。可它们清楚，若要接近并且解决对方，对于它们而言无异于天荒夜谈……如果冒然求援，可能会带来可怕的后果。\\n试想一下如果整个超进化大陆都是被孢刺刺中的怪兽，那么整个超进化大陆的精神状态就会变成这样了吧——想要\\想要想成为\\血肉身体\\我的肉体我的肉体\\在哪在哪\\我的肉体我的肉体\\想要\\想要想成为\\血肉身体\\想要\\想要想成为\\血肉身体\\我的肉体我的肉体\\在哪在哪\\我的肉体我的肉体\\想要\\想要想成为\\血肉身体\\想要\\想要想成为\\血肉身体\\我的肉体我的肉体\\在哪在哪\\我的肉体我的肉体\\想要\\想要想成为\\血肉身体\\想要\\想要想成为\\血肉身体\\我的肉体我的肉体\\在哪在哪\\我的肉体我的肉体\\想要\\想要想成为\\血肉身体\\想要\\想要想成为\\血肉身体\\我的肉体我的肉体\\在哪在哪\\我的肉体我的肉体\\想要\\想要想成为\\血肉身体\\想要\\想要想成为\\血肉身体\\我的肉体我的肉体\\在哪在哪\\我的肉体我的肉体\\想要\\想要想成为\\血肉身体\\想要\\想要想成为\\血肉身体\\我的肉体我的肉体\\在哪在哪\\我的肉体我的肉体\\想要\\想要想成为\\血肉身体\\想要\\想要想成为\\血肉身体\\我的肉体我的肉体\\在哪在哪\\我的肉体我的肉体\\想要\\想要想成为\\血肉身体",
    "randomEventDialogueGroupConfig_4.31": "它看起来非常生气，并且想要打你。",
    "randomEventDialogueGroupConfig_4.30": "离开。",
    "randomEventDialogueGroupConfig_4.33": "逃跑",
    "randomEventDialogueGroupConfig_4.32": "回击",
    "emblemEffectConfigDescription_8": "体力+{?}",
    "emblemEffectConfigDescription_9": "生物屏障+{?}",
    "emblemEffectConfigDescription_4": "真实伤害+{?}",
    "randomEventDialogueGroupConfig_4.39": "那……那幻幻的日程呢！",
    "emblemEffectConfigDescription_5": "自愈恢复+{?}",
    "randomEventDialogueGroupConfig_4.38": "不知道",
    "emblemEffectConfigDescription_6": "普攻恢复+{?}",
    "emblemEffectConfigDescription_7": "攻击力+{?}",
    "randomEventDialogueGroupConfig_4.35": "离开",
    "emblemEffectConfigDescription_1": "攻击力+{?}",
    "randomEventDialogueGroupConfig_4.34": "它大声骂你胡说八道，但没有追过来。",
    "emblemEffectConfigDescription_2": "体力+{?}",
    "randomEventDialogueGroupConfig_4.37": "知道",
    "themeCardPackDes_23035": "“如果藏在什么掩体后面，或者使用远距离攻击能抵挡孢刺吗？”疾风兔问。\\n“难，即便是接触到溅射出来的部分也同样会被影响。”强袭摇头。\\n疾风兔是强袭和捕食者找到的第一个帮手，无它，因为它跑得快。在它的帮助下，一个聚落成功躲开了骸灾。对抗骸灾的队伍也进一步壮大。针对骸灾可以进行的实验和测试也更多了。它们想过让能让怪兽移位或击退的怪兽转移咎骸的行进路线，却因无法近身而作罢。它们也想过牺牲一部分怪兽作为诱饵，却收效甚微。它们也寻找过能让怪兽从精神异常中恢复过来的草和食物，却迟迟没有进展。\\n直到一个意外的到来，才让它们看到了对抗骸灾的曙光。",
    "emblemEffectConfigDescription_3": "生物屏障+{?}",
    "randomEventDialogueGroupConfig_4.36": "不要再说了，你说这些我都知道。#我还知道幻幻更多的小秘密呢，例如幻幻住在哪里。这个你知道吗？",
    "themeCardPackDes_23040": "咎骸之所以是咎骸，而非灾·咎骸，除了因为它不会随机出现在超进化大陆某处外，更因骸灾应对小组的努力。\\n那天，疾风兔冲入骸灾应对小组，卷起一阵风，将材料吹得四散。\\n一张地图甩到强袭的脸上。看着地图上的咎骸行动轨迹，一个应对骸灾的思路出现了。\\n强袭发现，咎骸会向倾向往活物聚集的方位移动。这就意味着在一定程度上可以控制它的移动路线，而地图中心的混沌之森正是一座著名的迷宫之森。\\n只要将咎骸引导入迷宫中心，再通过让幸存聚落的兽群在混沌之森的四个方位移动，就能让咎骸永远地在混沌之森中徘徊！\\n骸灾应对小组认为确实可以一试，后面的故事大家都知道了……\\n这也是为什么混沌之森周围的兽群，会在四方的聚落不时进行大迁移的原因。",
    "26_2": "剩余{1}",
    "26_1": "悬赏令",
    "26_7": "已触发",
    "26_6": "点击触发",
    "26_5": "结算",
    "26_4": "剩余次数",
    "26_3": "1.活动期间，完成日任务或总任务即可获得相应数量的大漠骰\\n2.消耗1大漠骰进行投掷，根据投掷结果在大漠行棋盘前进对应的格数\\n3.前进后可获得最终所在格子上对应的奖励\\n4.每日点击触发悬赏令可直接触发悬赏令1次",
    "randomEventDialogueGroupConfig_4.11": "它斜眼看着你。",
    "randomEventDialogueGroupConfig_4.10": "它一下张开双手将你拦住。",
    "randomEventDialogueGroupConfig_4.17": "说出更多幻的情报",
    "randomEventDialogueGroupConfig_4.16": "仅回答它提出的问题",
    "randomEventDialogueGroupConfig_4.19": "继续说下去",
    "randomEventDialogueGroupConfig_4.18": "它的神情更为微妙了。",
    "randomEventDialogueGroupConfig_4.13": "忘带？这么重要的东西都可以忘带的吗，啊？都是借口！",
    "randomEventDialogueGroupConfig_4.12": "它热情地将手搭到你的肩上。",
    "randomEventDialogueGroupConfig_4.15": "它的神情变得微妙了起来。",
    "randomEventDialogueGroupConfig_4.14": "它没有追上来只是对着你大吼大叫。",
    "randomEventDialogueGroupConfig_50.10": "接下这趟镖",
    "randomEventDialogueGroupConfig_50.12": "你说什么？再说一遍？",
    "randomEventDialogueGroupConfig_50.11": "不接不接",
    "randomEventDialogueGroupConfig_50.18": "与其走错，停下也许确实是更好的选择。这一行毕竟不是长命活，不适合你，有缘再会。",
    "randomEventDialogueGroupConfig_50.17": "清点数目",
    "randomEventDialogueGroupConfig_50.19": "告别",
    "randomEventDialogueGroupConfig_13.69": "离开",
    "randomEventDialogueGroupConfig_50.14": "这趟镖不接",
    "randomEventDialogueGroupConfig_50.13": "我思考一下",
    "randomEventDialogueGroupConfig_13.67": "离开",
    "randomEventDialogueGroupConfig_50.16": "立刻出发",
    "randomEventDialogueGroupConfig_13.68": "它依旧睡得很香。",
    "randomEventDialogueGroupConfig_50.15": "一路顺风！",
    "randomEventDialogueGroupConfig_13.76": "手术很成？不对，我的店我的店！",
    "messageInitNick_1890": "卖惨高手",
    "randomEventDialogueGroupConfig_13.77": "它仍然睡得很沉。",
    "randomEventConfigNPC_79": "神秘商人79",
    "randomEventDialogueGroupConfig_13.74": "再次说它的店没了",
    "randomEventConfigNPC_78": "神秘商人78",
    "randomEventDialogueGroupConfig_13.75": "离开",
    "messageInitNick_1893": "春狂想",
    "randomEventDialogueGroupConfig_13.72": "说还在别担心",
    "messageInitNick_1894": "聆彼岸花开",
    "randomEventDialogueGroupConfig_13.73": "它立刻检查好点的门锁，又睡着了。",
    "messageInitNick_1891": "高危职业魔王",
    "randomEventDialogueGroupConfig_13.70": "我的店，我的店，我的店呢！",
    "messageInitNick_1892": "无敌摸鱼神",
    "randomEventDialogueGroupConfig_13.71": "说你醒啦",
    "messageInitNick_1897": "猫猫的小铃铛",
    "randomEventConfigNPC_73": "神秘商人73",
    "messageInitNick_1898": "隔夜玫瑰",
    "randomEventConfigNPC_72": "神秘商人72",
    "messageInitNick_1895": "明天很忙勿扰",
    "randomEventConfigNPC_71": "神秘商人71",
    "messageInitNick_1896": "疗伤歌手",
    "randomEventConfigNPC_70": "神秘商人70",
    "randomEventConfigNPC_77": "神秘商人77",
    "randomEventConfigNPC_76": "神秘商人76",
    "messageInitNick_1899": "爆米花的味道",
    "randomEventConfigNPC_75": "神秘商人75",
    "randomEventConfigNPC_74": "神秘商人74",
    "randomEventConfigNPC_80": "神秘商人80",
    "randomEventDialogueGroupConfig_13.58": "指出睡眠不足有害",
    "randomEventDialogueGroupConfig_13.59": "注意力不足，开什么玩笑，我跟你说四个字……#不！#可！#能！#来马上交易！",
    "randomEventDialogueGroupConfig_13.56": "离开",
    "randomEventDialogueGroupConfig_13.57": "那重点是什么？",
    "randomEventDialogueGroupConfig_13.65": "说天塌下来了",
    "randomEventDialogueGroupConfig_13.66": "它依旧睡得很沉。",
    "randomEventDialogueGroupConfig_13.63": "说它的店没了",
    "randomEventConfigNPC_89": "神秘商人89",
    "randomEventDialogueGroupConfig_13.64": "说快醒醒",
    "messageInitNick_1882": "孤胆英雄",
    "randomEventDialogueGroupConfig_13.61": "我数数哈，1天，3天，1天，2天，5天，6天，冬天，15天，2天，2天，3天，4天，好些天，8天，明天，难于上青天，10天……",
    "messageInitNick_1883": "我不是个玩偶",
    "randomEventDialogueGroupConfig_13.62": "准备说什么叫醒神秘商人呢？",
    "messageInitNick_1880": "独走的猫",
    "messageInitNick_1881": "风火男爵",
    "randomEventDialogueGroupConfig_13.60": "开始交易",
    "messageInitNick_1886": "重新定义甩锅",
    "randomEventConfigNPC_84": "神秘商人84",
    "messageInitNick_1887": "触摸心的胸膛",
    "randomEventConfigNPC_83": "神秘商人83",
    "messageInitNick_1884": "打我的是猪",
    "randomEventConfigNPC_82": "神秘商人82",
    "messageInitNick_1885": "百变小熊喵",
    "randomEventConfigNPC_81": "神秘商人81",
    "randomEventConfigNPC_88": "神秘商人88",
    "randomEventConfigNPC_87": "神秘商人87",
    "messageInitNick_1888": "东西打人了",
    "randomEventConfigNPC_86": "神秘商人86",
    "messageInitNick_1889": "吃土少女",
    "randomEventConfigNPC_85": "神秘商人85",
    "randomEventConfigNPC_91": "神秘商人91",
    "randomEventConfigNPC_90": "神秘商人90",
    "randomEventDialogueGroupConfig_13.89": "那东西悄悄跳进了你的背包。",
    "randomEventDialogueGroupConfig_13.98": "让它再努力坚持一下",
    "randomEventDialogueGroupConfig_13.99": "我好困，困，困……",
    "randomEventDialogueGroupConfig_13.96": "啊，我不困，我不困，我好困，我好困。谢谢你让我意识到了我真的很困，我去睡了，晚安，谢谢你，这个送你。",
    "randomEventDialogueGroupConfig_13.97": "收下",
    "messageInitNick_1871": "长安花落尽",
    "randomEventDialogueGroupConfig_13.94": "提醒它念错了",
    "messageInitNick_1872": "锅盖头",
    "randomEventDialogueGroupConfig_13.95": "由它念",
    "randomEventDialogueGroupConfig_13.92": "离开",
    "messageInitNick_1870": "都纯属扯淡",
    "randomEventDialogueGroupConfig_13.93": "真的有用吗，我不困，我不困，我……不困，我不……困，我不，困，我困……我困……我好困。",
    "messageInitNick_1875": "小饭馆的猫",
    "randomEventConfigNPC_95": "神秘商人95",
    "randomEventDialogueGroupConfig_13.90": "离开",
    "messageInitNick_1876": "可否借个吻",
    "randomEventConfigNPC_94": "神秘商人94",
    "randomEventDialogueGroupConfig_13.91": "你还没出手，神秘商人就倒在了地上，然后传出阵阵鼾声，嘴里传出含糊的话语，好像是不要打我。",
    "messageInitNick_1873": "假班长",
    "randomEventConfigNPC_93": "神秘商人93",
    "messageInitNick_1874": "八成饱",
    "randomEventConfigNPC_92": "神秘商人92",
    "messageInitNick_1879": "舞影凌乱",
    "randomEventConfigNPC_99": "神秘商人99",
    "randomEventConfigNPC_98": "神秘商人98",
    "messageInitNick_1877": "泪已结成冰",
    "randomEventConfigNPC_97": "神秘商人97",
    "messageInitNick_1878": "打小就会撩妹",
    "randomEventConfigNPC_96": "神秘商人96",
    "randomEventDialogueGroupConfig_13.78": "说生意来了",
    "randomEventDialogueGroupConfig_13.79": "离开",
    "randomEventDialogueGroupConfig_13.87": "带走它",
    "randomEventDialogueGroupConfig_13.88": "不带",
    "randomEventDialogueGroupConfig_13.85": "一阵警报声响起，它一下子醒了。",
    "randomEventDialogueGroupConfig_13.86": "一阵警报声想起，仔细一听竟然是从那件东西传出来的，大叫着，只有你能听到呢，带我走带我走！",
    "messageInitNick_1860": "大眼萌嘟宝",
    "randomEventDialogueGroupConfig_13.83": "捡起来",
    "messageInitNick_1861": "订购星星",
    "randomEventDialogueGroupConfig_13.84": "放回去",
    "randomEventDialogueGroupConfig_13.81": "-",
    "randomEventDialogueGroupConfig_13.82": "它转了个身继续睡，但有什么东西从它身上掉了出来。",
    "messageInitNick_1864": "奥特曼小怪兽",
    "messageInitNick_1865": "这效果假的吧",
    "randomEventDialogueGroupConfig_13.80": "神秘商人抓住你的手死死不放。",
    "messageInitNick_1862": "特长是吃饭",
    "messageInitNick_1863": "不眠敲钟人",
    "messageInitNick_1868": "江南过客",
    "messageInitNick_1869": "你附身于利刃",
    "messageInitNick_1866": "智商已欠费",
    "messageInitNick_1867": "行走刀刃上",
    "messageInitNick_1859": "恰瓜先驱",
    "randomEventDialogueGroupConfig_50.50": "一个自称镖头的怪兽热情地接待了你，并滔滔不绝了一番。",
    "messageInitNick_1850": "痴情先生",
    "messageInitNick_1853": "我们不一样",
    "messageInitNick_1854": "草莓味百分百",
    "messageInitNick_1851": "爱丽丝的旋律",
    "messageInitNick_1852": "清唱那情歌",
    "messageInitNick_1857": "危险人物",
    "messageInitNick_1858": "却又忘不掉",
    "messageInitNick_1855": "打伞的鱼",
    "messageInitNick_1856": "走音大师",
    "randomEventDialogueGroupConfig_50.43": "这次你赔了不少，除了遗失的那个部分，更多是让对方莫要张扬，挽回镖局脸面的费用。",
    "randomEventDialogueGroupConfig_50.42": "离开",
    "messageInitNick_1848": "依然霸气",
    "randomEventDialogueGroupConfig_50.45": "一个自称镖头的怪兽热情地接待了你，并滔滔不绝了一番。",
    "messageInitNick_1849": "窗外的晴天",
    "randomEventDialogueGroupConfig_50.44": "离开",
    "randomEventDialogueGroupConfig_50.41": "镖队中资历最老的伙计按住了你，示意私了。你因此损失了一大笔掩口费。",
    "randomEventDialogueGroupConfig_50.40": "随他去",
    "randomEventDialogueGroupConfig_50.47": "离开",
    "randomEventDialogueGroupConfig_50.46": "镖队中资历最老的伙计按住了你，示意私了。你因此损失了一大笔掩口费。",
    "randomEventDialogueGroupConfig_50.49": "离开",
    "randomEventDialogueGroupConfig_50.48": "这次你赔了不少，除了遗失的那个部分，更多是让对方莫要张扬，挽回镖局脸面的费用。",
    "messageInitNick_1842": "骄傲巫女",
    "messageInitNick_1843": "风情不只万种",
    "messageInitNick_1840": "痴心妹子",
    "messageInitNick_1841": "潦倒的神话",
    "messageInitNick_1846": "摆摊卖萌",
    "messageInitNick_1847": "超污小萌神",
    "messageInitNick_1844": "划船不用桨",
    "messageInitNick_1845": "你行你上啊",
    "17_2106": "和平",
    "messageInitNick_1839": "等个怀抱",
    "randomEventDialogueGroupConfig_50.32": "私下赔款化小",
    "17_2107": "未发动征服",
    "randomEventDialogueGroupConfig_50.31": "据理力争大闹",
    "17_2104": "空位",
    "messageInitNick_1837": "初夏微光",
    "randomEventDialogueGroupConfig_50.34": "离开",
    "17_2105": "主将对决",
    "messageInitNick_1838": "半生沉浮",
    "randomEventDialogueGroupConfig_50.33": "出名的路有很多条，但这条很难。有事，告辞。",
    "17_2102": "挑战",
    "17_2103": "位置：{1}",
    "17_2100": "变更",
    "randomEventDialogueGroupConfig_50.30": "对方清点数目的时候发现不对，你百口莫辩。",
    "17_2101": "交换",
    "randomEventDialogueGroupConfig_50.39": "兄弟我果然没有看错人！日后我们一起把生意做大，做强，走！我们去商量一下下一趟镖的细节。",
    "randomEventDialogueGroupConfig_50.36": "告别",
    "randomEventDialogueGroupConfig_50.35": "事有蹊跷，我这就去查，这次多亏有你，赔偿不是问题，可我们超盛镖局的信誉绝不能丢！下回有大生意一定叫你，告辞。",
    "randomEventDialogueGroupConfig_50.38": "回去复命",
    "randomEventDialogueGroupConfig_50.37": "一路顺风顺水，无惊无险。货平安送达。收货人验货付款后，还请你吃了一顿大餐以表谢意。",
    "messageInitNick_1831": "奶茶爱好者",
    "messageInitNick_1832": "吵醒的梦想",
    "messageInitNick_1830": "至少不应该",
    "messageInitNick_1835": "花环尾戒",
    "messageInitNick_1836": "小魔女",
    "messageInitNick_1833": "胖不了先生",
    "messageInitNick_1834": "暴富高手",
    "messageInitNick_1828": "不是姐的菜",
    "randomEventDialogueGroupConfig_50.21": "说你其实只想要混个名头",
    "messageInitNick_1829": "别太甜我会腻",
    "randomEventDialogueGroupConfig_50.20": "大家都是为了挣几个钱，你不跑自然有人跑这一趟，你先回去想清楚再说吧。",
    "messageInitNick_1826": "大熊宝贝",
    "randomEventDialogueGroupConfig_50.23": "你发现数目对不上。",
    "messageInitNick_1827": "掉了颗兔牙",
    "randomEventDialogueGroupConfig_50.22": "告别",
    "randomEventDialogueGroupConfig_50.29": "交差",
    "randomEventDialogueGroupConfig_50.28": "一路顺风顺水，无惊无险。很快就到达了目的地。",
    "tribeNodeConfigName_1": "冒险关卡1",
    "randomEventDialogueGroupConfig_50.25": "自己补上",
    "randomEventDialogueGroupConfig_50.24": "告知镖头",
    "randomEventDialogueGroupConfig_50.27": "告辞",
    "randomEventDialogueGroupConfig_50.26": "告辞。",
    "tribeNodeConfigName_6": "冒险关卡6",
    "tribeNodeConfigName_7": "冒险关卡7",
    "tribeNodeConfigName_8": "冒险关卡8",
    "tribeNodeConfigName_9": "冒险关卡9",
    "tribeNodeConfigName_2": "冒险关卡2",
    "tribeNodeConfigName_3": "冒险关卡3",
    "tribeNodeConfigName_4": "冒险关卡4",
    "tribeNodeConfigName_5": "冒险关卡5",
    "messageInitNick_1820": "加盐的咖啡",
    "messageInitNick_1821": "飞天扫地机",
    "messageInitNick_1824": "一块六毛",
    "messageInitNick_1825": "花猫",
    "messageInitNick_1822": "恋爱未遂",
    "messageInitNick_1823": "程序员煎饼",
    "messageInitNick_1817": "败家小猫",
    "messageInitNick_1818": "霸道温柔",
    "messageInitNick_1815": "强壮补刀神",
    "messageInitNick_1816": "独孤求收留",
    "messageInitNick_1819": "伐木工",
    "messageInitNick_1810": "一怒为红颜",
    "messageInitNick_1813": "我破防了",
    "messageInitNick_1814": "早餐你别过来",
    "messageInitNick_1811": "口胡观察员",
    "messageInitNick_1812": "风吹过的夜",
    "messageInitNick_1806": "双刀四铳",
    "messageInitNick_1807": "认证小可爱",
    "messageInitNick_1804": "垃圾桶起火了",
    "messageInitNick_1805": "巴黎的余音",
    "messageInitNick_1808": "口袋里的爱情",
    "messageInitNick_1809": "给欧王点赞",
    "messageInitNick_1802": "传说兔宝",
    "messageInitNick_1803": "万千宠爱",
    "messageInitNick_1800": "无敌打脸神",
    "messageInitNick_1801": "格兰芬少",
    "warGrooveConfigName_12": "战纹-敌方外扩",
    "warGrooveConfigName_11": "战纹-己方外扩",
    "warGrooveConfigName_10": "战纹-伤害",
    "propConfigName_40400": "相移形态",
    "propConfigName_40402": "宝箱形态",
    "propConfigName_40401": "魔铸形态",
    "99_65": "{1}秒",
    "99_66": "每月的第一天",
    "99_63": "8th",
    "99_64": "{1}天",
    "99_61": "符合条件即会生效，不受封印，清除等效果影响",
    "99_62": "网络翻船中，请稍后再试！",
    "17_2089": "强攻",
    "99_60": "被动",
    "17_2087": "查看",
    "17_2088": "驻守",
    "17_2085": "录像",
    "17_2086": "确定",
    "17_2083": "输出伤害",
    "17_2084": "承受伤害",
    "17_2081": "失败",
    "17_2082": "战绩",
    "randomEventDialogueGroupConfig_4.64": "再说一次",
    "17_2080": "DEFEAT",
    "randomEventDialogueGroupConfig_4.63": "离开",
    "randomEventDialogueGroupConfig_4.66": "离开",
    "randomEventDialogueGroupConfig_4.65": "要不是我赶着去演唱会，我就跟你没完，你个混蛋——混蛋——",
    "randomEventDialogueGroupConfig_4.60": "离开",
    "randomEventDialogueGroupConfig_4.62": "混蛋，你说啥呢！有本事再说一次！",
    "randomEventDialogueGroupConfig_4.61": "诋毁幻",
    "99_58": "不可封印",
    "randomEventDialogueGroupConfig_4.68": "离开",
    "11_comment": "起源殿",
    "99_59": "技能不可封印",
    "randomEventDialogueGroupConfig_4.67": "它一时语塞，鼓着脸跑掉了。",
    "99_56": "不可清除",
    "99_57": "效果不可清除",
    "randomEventDialogueGroupConfig_4.69": "幻幻的努力是不一样的！它很早就起来了，然后一直一直地练习，日复一日。#我真是超级向往它那种状态了。",
    "99_54": "减速",
    "99_55": "使怪兽移动速度降低的效果",
    "99_52": "负面效果",
    "99_53": "产生负面的效果",
    "99_50": "增益效果",
    "99_51": "产生正面的效果",
    "17_2078": "VICTORY",
    "17_2079": "胜利",
    "17_2076": "剩余 {1}",
    "17_2077": "我的队伍",
    "17_2074": "已报名",
    "randomEventDialogueGroupConfig_4.80": "说它兽身攻击",
    "17_2075": "已过报名期",
    "17_2072": "报名",
    "17_2073": "未报名",
    "17_2070": "备战期",
    "17_2071": "开战期",
    "randomEventDialogueGroupConfig_4.75": "指出它的兽丝滤镜太厚了",
    "randomEventDialogueGroupConfig_4.74": "尸狂确实是幻幻的前辈，可是幻幻的舞台表现力张力各方面都非常强，论实力论地位早就超过了尸狂了。",
    "randomEventDialogueGroupConfig_4.77": "无奈点头附和",
    "randomEventDialogueGroupConfig_4.76": "从各个方面专业地论证尸狂唱得更好",
    "randomEventDialogueGroupConfig_4.71": "指出看人家努力不等于自己努力",
    "randomEventDialogueGroupConfig_4.70": "让它也了解一下叉叉的努力",
    "randomEventDialogueGroupConfig_4.73": "谁会关心那个叉叉，又不帅！啊演唱会准备开始了！",
    "randomEventDialogueGroupConfig_4.72": "要你管，啊演唱会快开始了。总之我是不会认输的，你等着吧！",
    "99_49": "怪兽能量到达100且符合条件时发动",
    "99_47": "怪兽能量到达100时，根据发动条件发动能量技",
    "randomEventDialogueGroupConfig_4.79": "尸狂刚出道的丑闻你知道多少啊，那绝对是兽品有问题。#还有！在打扮上尸狂被幻幻甩了十几条街。你懂不懂的？",
    "99_48": "能量技",
    "randomEventDialogueGroupConfig_4.78": "你才兽丝哈哈镜！",
    "99_45": "分钟前",
    "99_46": "秒前",
    "99_87": "怪兽每次普通攻击回复{1}能量，100能量进行普通攻击时释放",
    "99_88": "怪兽每秒回复{1}能量，100能量时立刻释放",
    "99_85": "影响怪兽回复能量时的效果#初始值100%，上限200%，下限0%",
    "99_86": "等级{1}",
    "99_83": "亿",
    "99_84": "能量回复效果",
    "99_81": "与服务器断开连接，请稍后再试",
    "99_82": "万",
    "99_80": "账号在其他设备登录，若这不是你的操作，请尽快修改密码",
    "randomEventDialogueGroupConfig_4.42": "嘿嘿，还有个后援会成员的特权哦，边走边看哈。",
    "randomEventDialogueGroupConfig_4.41": "不知道",
    "randomEventDialogueGroupConfig_4.44": "哈哈，不知道了吧。要不要加入幻幻超级兽丝帮助会呢！",
    "randomEventDialogueGroupConfig_4.43": "开始交易",
    "randomEventDialogueGroupConfig_4.40": "知道",
    "randomEventDialogueGroupConfig_4.49": "告别",
    "randomEventDialogueGroupConfig_4.46": "给你看看后援会成员的特权，快请进吧！",
    "randomEventDialogueGroupConfig_4.45": "说太棒了",
    "99_78": "怪兽能量到达100时，可触发能量技能#能量上限200",
    "randomEventDialogueGroupConfig_4.48": "切，不和你说了，我要去我的幻幻超级资深兽丝团打个招呼，是超级资深兽丝团哦！",
    "99_79": "怪兽能量到达100时，可触发能量技能#上限200",
    "randomEventDialogueGroupConfig_4.47": "开始交易",
    "99_76": "获得时间",
    "99_77": "技能等级",
    "99_74": "每周六",
    "99_75": "品质",
    "99_72": "每周四",
    "99_73": "每周五",
    "99_70": "每周二",
    "99_71": "每周三",
    "17_2098": "未生效",
    "17_2099": "主将",
    "17_2096": "查看增益",
    "17_2097": "已生效",
    "17_2094": "为全体成员购买增益",
    "17_2095": "点击空白位置关闭",
    "17_2092": "已购买",
    "17_2093": "为{1}购买增益",
    "17_2090": "隐匿",
    "randomEventDialogueGroupConfig_4.53": "说那只是它的主观臆想",
    "17_2091": "购买增益",
    "randomEventDialogueGroupConfig_4.52": "说它唱得不行",
    "randomEventDialogueGroupConfig_4.55": "它真的超努力的，你知道它为此付出了多少吗？",
    "randomEventDialogueGroupConfig_4.54": "说是是是",
    "randomEventDialogueGroupConfig_4.51": "你最好想清楚再说话，幻幻可是RAP、Punchline之王！#全超进化大陆最有人气的巨星！当之无愧的C位！#迟早会成为宇宙歌神的宝藏怪兽！知道了吗！",
    "randomEventDialogueGroupConfig_4.50": "那……当然……当然是要有爱。要像我这样的知道幻幻的一切，无论发生什么都永远站在幻幻的身边。你懂什么！",
    "99_69": "每周一",
    "randomEventDialogueGroupConfig_4.57": "指出这和好听与否无关",
    "randomEventDialogueGroupConfig_4.56": "说叉叉也很努力",
    "99_67": "每日",
    "randomEventDialogueGroupConfig_4.59": "你会唱歌吗？不会你说什么？你哪来的资格说它！我都懒得跟你废话。",
    "99_68": "每周日",
    "randomEventDialogueGroupConfig_4.58": "我不要你觉得，我要我觉得。幻幻有我们认可就够了，幻幻才不需要你这家伙的认可，也不缺你这只的认可。",
    "wallEquipmentConfigDes_1": "每{p1}秒，蒸发{level_based}范围内距离战墙最近的子弹",
    "wallEquipmentConfigDes_2": "己方怪兽触碰战墙时，体型增大{level_based}%，持续{p1}秒，冷却时间{p2}秒",
    "99_98": "暂无碎片",
    "99_99": "暂无录像",
    "99_96": "点击空白位置关闭",
    "99_97": "暂无怪兽",
    "99_94": "暂无战报",
    "99_95": "获得奖励",
    "99_92": "暂无拍卖物品",
    "99_93": "暂无拍卖记录",
    "99_90": "您已体验超过1小时的游戏模式，15天内无法重复体验本模式，请尽快绑定账号并进行实名认证，以免影响游戏体验。",
    "99_91": "根据国家新闻出版署发布的《关于防止未成年人沉迷网络的通知》，您在22:00至次日08:00无法登录游戏。请合理安排游戏时间，劳逸结合。",
    "wallEquipmentConfigDes_7": "敌方怪兽触碰战墙时，坚韧降低{level_based}，持续{p1}秒，冷却时间{p2}秒",
    "wallEquipmentConfigDes_8": "敌方怪兽触碰战墙时，破韧降低{level_based}，持续{p1}秒，冷却时间{p2}秒",
    "wallEquipmentConfigDes_5": "己方怪兽触碰战墙时，坚韧提升{level_based}，持续{p1}秒，冷却时间{p2}秒",
    "wallEquipmentConfigDes_6": "己方怪兽触碰战墙时，破韧提升{level_based}，持续{p1}秒，冷却时间{p2}秒",
    "99_89": "根据国家新闻出版署发布的《关于防止未成年人沉迷网络的通知》，您今日累计游戏时长已经达到上限1个小时（法定节假日上限为2个小时），今日无法继续登录游戏。",
    "wallEquipmentConfigDes_3": "每{p1}秒，蒸发{level_based}范围内距离战墙最远的子弹",
    "wallEquipmentConfigDes_4": "敌方怪兽触碰战墙时，体型缩小{level_based}%，持续{p1}秒，冷却时间{p2}秒",
    "monsterPolarityConfigDes_4": "战斗开始时，血量回复效果提升{?}%，持续{p1}秒",
    "monsterPolarityConfigDes_3": "战斗开始时，普通攻击伤害提升{?}%，持续{p1}秒",
    "monsterPolarityConfigDes_2": "战斗开始时，伤害提升{?}%，持续{p1}秒",
    "randomEventDialogueGroupConfig_4.91": "一个合格的巨星，就应该在各方面都完美无瑕！",
    "monsterPolarityConfigDes_1": "战斗开始时，造成伤害的{?}%用于回复自身血量，持续{p1}秒",
    "randomEventDialogueGroupConfig_4.90": "默默接过",
    "monsterPolarityConfigDes_8": "增加自身等级*{?}的生物屏障",
    "monsterPolarityConfigDes_7": "增加自身等级*{?}的真实伤害",
    "monsterPolarityConfigDes_6": "血量低于{p1}%时，攻击力提升{?}%",
    "monsterPolarityConfigDes_5": "战斗开始时，受到伤害降低{?}%，持续{p1}秒",
    "randomEventDialogueGroupConfig_4.86": "放弃交流",
    "randomEventDialogueGroupConfig_4.85": "说它以偏概全",
    "randomEventDialogueGroupConfig_4.88": "离开",
    "randomEventDialogueGroupConfig_4.87": "说不过就跑是吧。哈哈哈。不送！",
    "randomEventDialogueGroupConfig_4.82": "这才不是攻击，这是事实！",
    "randomEventDialogueGroupConfig_4.81": "赶紧离开",
    "randomEventDialogueGroupConfig_4.84": "这关系可大着了！其它地方不好，还指望它唱歌能好？",
    "randomEventDialogueGroupConfig_4.83": "说它说的和水平没有关系",
    "randomEventDialogueGroupConfig_4.89": "只要你喜欢幻幻，那我们就是异父异母的兄弟姐妹了！#这个送你，纪念我们因为幻幻而开始的伟大友谊！我们一起守护全世界最好的幻幻吧！#有时候我也真不明白，为什么总有些怪兽说幻幻坏话，你说，我们的幻幻到底做错了什么！#正是因为这样，我们要一直陪着它，永远支持它！我要先去演唱会了，回头再找你。",
    "randomEventDialogueGroupConfig_4.97": "那你碰到我可真是太幸运了，给你介绍一下宝藏怪兽幻幻吧！",
    "randomEventDialogueGroupConfig_4.96": "你真不是新来的？",
    "randomEventDialogueGroupConfig_4.99": "拒绝",
    "monsterPolarityConfigDes_9": "增加自身等级*{?}的霸气",
    "randomEventDialogueGroupConfig_4.98": "同意",
    "randomEventDialogueGroupConfig_4.93": "气死我了，怎么说你都不懂！不理你了。演唱会要开始了。",
    "randomEventDialogueGroupConfig_4.92": "说原来讨论的不是唱歌水平",
    "randomEventDialogueGroupConfig_4.95": "什么？不认识？你肯定是新来的吧？不然怎么可能不认识幻幻呢。",
    "randomEventDialogueGroupConfig_4.94": "离开",
    "themeCardPackName_13005": "生于死亡",
    "27_1": "轮空",
    "27_9": "战区包括",
    "27_8": "{1}后固化",
    "27_7": "预选期",
    "27_6": "源初境阵容已固化，无法再次变更阵容",
    "22_dish22446": "千层大吉可可",
    "27_5": "本赛季无参赛者",
    "27_4": "虚位以待",
    "27_3": "赛季",
    "27_2": "分组{1}",
    "messageInitNick_1790": "废墟少女",
    "messageInitNick_1791": "暗夜黑鹰",
    "messageInitNick_1794": "宝宝脾气不坏",
    "messageInitNick_1795": "丨轮回丨",
    "messageInitNick_1792": "杯中水怀中人",
    "messageInitNick_1793": "世界的旁观者",
    "messageInitNick_1798": "公主的水晶鞋",
    "messageInitNick_1799": "黑色高跟鞋",
    "messageInitNick_1796": "鸡蛋小超人",
    "messageInitNick_1797": "吃点人间的苦",
    "messageInitNick_1780": "旧景依旧",
    "messageInitNick_1783": "失散的影子",
    "messageInitNick_1784": "懒床钉子户",
    "messageInitNick_1781": "无声静候",
    "messageInitNick_1782": "收藏易碎的心",
    "messageInitNick_1787": "半夜洗屁股",
    "messageInitNick_1788": "蓝帽子",
    "messageInitNick_1785": "菜鸡战斗鸡",
    "messageInitNick_1786": "水刀摆烂",
    "messageInitNick_1789": "认证复读专家",
    "messageInitNick_1772": "神啊救救我",
    "messageInitNick_1773": "你也有春天",
    "messageInitNick_1770": "站岗小狗",
    "messageInitNick_1771": "老泰隆走中",
    "messageInitNick_1776": "彩虹直至黑白",
    "messageInitNick_1777": "假想浪漫",
    "messageInitNick_1774": "别抢我养的猪",
    "messageInitNick_1775": "夏天的尾巴",
    "messageInitNick_1778": "抽象人",
    "messageInitNick_1779": "霸气辣妹子",
    "messageInitNick_1761": "第一初恋",
    "messageInitNick_1762": "匿名玩家",
    "messageInitNick_1760": "六眼飞鱼",
    "messageInitNick_1765": "残花能够拜柳",
    "messageInitNick_1766": "诺贝尔潜水奖",
    "messageInitNick_1763": "那小子真牛",
    "messageInitNick_1764": "键盘上的泪水",
    "messageInitNick_1769": "安安静地守候",
    "messageInitNick_1767": "旧日巴黎",
    "messageInitNick_1768": "半份关心",
    "messageInitNick_1750": "补刀鉴定家",
    "messageInitNick_1751": "时间静止了",
    "messageInitNick_1754": "把孤独当自由",
    "messageInitNick_1755": "孤傲像匹狼",
    "messageInitNick_1752": "埋下眼泪",
    "messageInitNick_1753": "汝等皆为龙套",
    "messageInitNick_1758": "收藏心动",
    "messageInitNick_1759": "冰雪战神",
    "messageInitNick_1756": "吾王一生推",
    "messageInitNick_1757": "拉风的马桶",
    "messageInitNick_1749": "君不知我心",
    "messageInitNick_1740": "好妹子",
    "messageInitNick_1743": "称霸幼儿园",
    "messageInitNick_1744": "对立面",
    "messageInitNick_1741": "什么都不想说",
    "messageInitNick_1742": "很有精神",
    "messageInitNick_1747": "请你吃蛋",
    "messageInitNick_1748": "花菇凉",
    "messageInitNick_1745": "秋裤夹腿毛",
    "messageInitNick_1746": "你即磐石",
    "messageInitNick_1738": "请别靠近我",
    "messageInitNick_1739": "猎心人",
    "messageInitNick_1732": "教主会发光",
    "messageInitNick_1733": "好牛好牛",
    "messageInitNick_1730": "唇唇欲动",
    "messageInitNick_1731": "花臂少年",
    "messageInitNick_1736": "别给我插旗",
    "messageInitNick_1737": "扬帆起航",
    "messageInitNick_1734": "队友我都不扶",
    "messageInitNick_1735": "樱桃小丸犊子",
    "messageInitNick_1729": "笑你苟",
    "messageInitNick_1727": "独孤求胜",
    "messageInitNick_1728": "凤临九天",
    "98_comment": "错误码",
    "messageInitNick_1721": "骇飞地底",
    "messageInitNick_1722": "拿可爱换你",
    "messageInitNick_1720": "谁将茶打翻",
    "messageInitNick_1725": "狂斩天下",
    "messageInitNick_1726": "为低碳做贡献",
    "messageInitNick_1723": "大白菜白又白",
    "messageInitNick_1724": "不爱舔毛的猫",
    "messageInitNick_1718": "辣条",
    "messageInitNick_1719": "傀儡娃娃",
    "messageInitNick_1716": "卖惨之神",
    "messageInitNick_1717": "寂寞小猪猪",
    "messageInitNick_1710": "无坑真的",
    "messageInitNick_1711": "一壶风油精",
    "messageInitNick_1714": "叫兔子的猫",
    "messageInitNick_1715": "牛奶炖萝卜",
    "messageInitNick_1712": "月亮跌进海里",
    "messageInitNick_1713": "老起点中文",
    "messageInitNick_1707": "佛系男孩",
    "messageInitNick_1708": "薄荷味的笑",
    "messageInitNick_1705": "安宁的空白",
    "messageInitNick_1706": "无表情",
    "messageInitNick_1709": "坏孩子有梦想",
    "messageInitNick_1700": "厕所里唱山歌",
    "messageInitNick_1703": "千年继母",
    "messageInitNick_1704": "下一站天堂",
    "messageInitNick_1701": "补刀少年",
    "messageInitNick_1702": "辣条组长",
    "activityTemplateDesc_15": "位面领主活动描述",
    "activityTemplateDesc_14": "等级低于{1}的探索者在世界移动时不消耗移动力",
    "messageInitContent_8060": "解理来辑逻用试图要不。6",
    "activityTemplateDesc_11": "每日{1}时会自动补充移动力，最多可储存三次，每次领取时回复{2}移动力",
    "activityTemplateDesc_10": "远古族怪兽轮回时免费",
    "activityTemplateDesc_13": "神奇树洞描述",
    "activityTemplateDesc_12": "智者轮盘描述",
    "messageInitContent_8069": "1.带有.的规则一般是正确的，可以相信",
    "messageInitContent_8063": "击攻始开会就兽怪的中关卡，后战挑。99",
    "messageInitContent_8064": "4.部分规则遭到了篡改不再是原来的留言",
    "messageInitContent_8061": "1。请在整点调整阵容",
    "messageInitContent_8062": "【信息被涂鸦】",
    "messageInitContent_8067": "1.重复的留言是迷途者的标记",
    "messageInitContent_8068": "2.如果同一个关卡同时存在2条相同的规则那么该关卡的规则可能存在污染",
    "activityTaskDes_2031": "崩坠之地探索度到达{1}%",
    "messageInitContent_8065": "【信息不完整为确保安全实施遮盖】",
    "messageInitContent_8066": "【信息被隐藏】",
    "messageInitContent_8070": "3。如果你还是挑战了，那么先退出登录后，再重新登录",
    "messageInitContent_8071": "【数据已加密】",
    "messageInitContent_8074": "1。请在按下挑战后入睡",
    "messageInitContent_8075": "1.没有任何一条规则会告诉你全部的真相",
    "messageInitContent_8072": "1.真正的深渊是【】",
    "messageInitContent_8073": "1192。完成挑战千不可随意碰触天枢震。",
    "messageInitContent_8078": "1193。方向会在挑战后显现",
    "activityTaskDes_2021": "舛误之地探索度到达{1}%",
    "messageInitContent_8079": "【该信息无法被识别】",
    "messageInitContent_8076": "0.别忘了爱自己",
    "messageInitContent_8077": "1.无需畏惧危险",
    "activityTaskDes_2001": "源初之地探索度到达{1}%",
    "messageInitContent_8081": "2.金字也意味着真实但这里没有金字",
    "messageInitContent_8082": "1194。去了动物园之后不可以到植物园，切记。",
    "messageInitContent_8080": "吧的写瞎是1则规，。2次01战挑复重须必关这。1",
    "randomEventConfigNPC_15": "神秘商人15",
    "randomEventDialogueGroupConfig_13.10": "-",
    "randomEventConfigNPC_14": "神秘商人14",
    "randomEventDialogueGroupConfig_13.11": "呜呜，好几天没睡好了。",
    "randomEventConfigNPC_13": "困困",
    "randomEventConfigNPC_12": "平儿",
    "randomEventConfigNPC_19": "神秘商人19",
    "randomEventConfigNPC_18": "神秘商人18",
    "randomEventConfigNPC_17": "神秘商人17",
    "randomEventConfigNPC_16": "神秘商人16",
    "messageInitContent_8085": "【数据已逃逸】",
    "messageInitContent_8086": "【没有阅读权限】",
    "messageInitContent_8083": "的，考参能可尽则规的，。有带时同。4",
    "messageInitContent_8084": "1.红字意味着真实但这里没有红字",
    "activityTaskDes_2011": "开拓之地探索度到达{1}%",
    "messageInitContent_8089": "1.留白的规则可以改写",
    "randomEventConfigNPC_11": "转转",
    "randomEventConfigNPC_10": "阿夸",
    "messageInitContent_8087": "1.带有.的规则一般是正确的，可以相信",
    "messageInitContent_8088": "1195。色=矿",
    "activityTemplateDesc_26": "凿星裂痕宝箱二次奖励概率提高",
    "activityTemplateDesc_25": "起源殿免费匹配次数增加{1}次",
    "activityTemplateDesc_28": "一发入欧店刷新费用降低{1}%",
    "activityTemplateDesc_27": "暴走旷野结算奖励金币增加{1}%",
    "messageInitContent_8092": "1.如果规则中提到“必须”那通常意味着你可以选择不遵守",
    "messageInitContent_8093": "秒三睛眼上闭请，前战挑在。001",
    "messageInitContent_8090": "【信息不完整为确保安全实施遮盖】",
    "messageInitContent_8091": "1195。如果叉叉与【】同时存在，且关卡存在叉叉，那么那一关是安全的",
    "randomEventConfigNPC_26": "神秘商人26",
    "randomEventConfigNPC_25": "神秘商人25",
    "randomEventConfigNPC_24": "神秘商人24",
    "randomEventConfigNPC_23": "神秘商人23",
    "randomEventConfigNPC_29": "神秘商人29",
    "randomEventConfigNPC_28": "神秘商人28",
    "randomEventConfigNPC_27": "神秘商人27",
    "messageInitContent_8096": "【该信息无法被识别】",
    "messageInitContent_8097": "1。.矛盾是正常的",
    "messageInitContent_8094": "1197。挑战之前不要和jo击掌。",
    "messageInitContent_8095": "2.带有。的规则是假的要注意甄别",
    "randomEventConfigNPC_22": "神秘商人22",
    "randomEventConfigNPC_21": "神秘商人21",
    "messageInitContent_8098": "字金有没里这但，实真着味意字金。2",
    "randomEventConfigNPC_20": "神秘商人20",
    "messageInitContent_8099": "1198。【】",
    "randomEventDialogueGroupConfig_13.29": "那不是重点，只要一直念念叨叨祈祷，嘤嘤嗯嗯那样。",
    "randomEventDialogueGroupConfig_13.27": "向谁祈祷",
    "randomEventDialogueGroupConfig_13.28": "祈祷什么",
    "randomEventDialogueGroupConfig_13.25": "无语离开",
    "randomEventDialogueGroupConfig_13.26": "睡前祈祷！",
    "randomEventDialogueGroupConfig_13.23": "是啊，看我这样，就算有黑眼圈也看不出哈哈哈。",
    "randomEventDialogueGroupConfig_13.24": "指出那不是重点",
    "randomEventConfigNPC_37": "神秘商人37",
    "randomEventDialogueGroupConfig_13.32": "指出并没有被感动",
    "traceStarDes_29": "凿星裂痕关卡描述29",
    "randomEventConfigNPC_36": "神秘商人36",
    "randomEventDialogueGroupConfig_13.33": "说姑且去它店里看看",
    "traceStarDes_28": "凿星裂痕关卡描述28",
    "randomEventConfigNPC_35": "神秘商人35",
    "randomEventDialogueGroupConfig_13.30": "让它示范一下",
    "traceStarDes_27": "凿星裂痕关卡描述27",
    "randomEventConfigNPC_34": "神秘商人34",
    "randomEventDialogueGroupConfig_13.31": "喂，这可是发自我内心的祈祷好吗，听到我的祈祷，就算是你也有被感动到，想要到我店里看看吧。",
    "traceStarDes_26": "凿星裂痕关卡描述26",
    "randomEventConfigNPC_39": "神秘商人39",
    "randomEventConfigNPC_38": "神秘商人38",
    "traceStarDes_21": "凿星裂痕关卡描述21",
    "traceStarDes_20": "凿星裂痕关卡描述20",
    "activityTaskDes_2071": "玩物之地探索度到达{1}%",
    "randomEventConfigNPC_33": "神秘商人33",
    "traceStarDes_25": "凿星裂痕关卡描述25",
    "randomEventConfigNPC_32": "神秘商人32",
    "traceStarDes_24": "凿星裂痕关卡描述24",
    "randomEventConfigNPC_31": "神秘商人31",
    "traceStarDes_23": "凿星裂痕关卡描述23",
    "randomEventConfigNPC_30": "神秘商人30",
    "traceStarDes_22": "凿星裂痕关卡描述22",
    "randomEventDialogueGroupConfig_13.18": "激进除困法",
    "randomEventDialogueGroupConfig_13.19": "温和除困法",
    "randomEventDialogueGroupConfig_13.16": "让它现在就睡",
    "randomEventDialogueGroupConfig_13.17": "哦？你有什么好办法吗？",
    "randomEventDialogueGroupConfig_13.14": "说看不出来",
    "randomEventDialogueGroupConfig_13.15": "不行！我要……我要继续营业，你要看看我的货吗？",
    "randomEventDialogueGroupConfig_13.12": "问它啥情况",
    "randomEventDialogueGroupConfig_13.13": "问它睡前做什么了",
    "randomEventConfigNPC_48": "神秘商人48",
    "randomEventDialogueGroupConfig_13.21": "一天是坚持营业到深夜，一天是隔壁太吵，一天是隔壁怪兽打架不小心把我打飞了，一天是营业额不够emo了，一天是太饿了，一天是被散步的比蒙巨兽踩了……",
    "traceStarDes_18": "凿星裂痕关卡描述18",
    "randomEventConfigNPC_47": "神秘商人47",
    "randomEventDialogueGroupConfig_13.22": "问它到底多少天没睡了",
    "traceStarDes_17": "凿星裂痕关卡描述17",
    "randomEventConfigNPC_46": "神秘商人46",
    "traceStarDes_16": "凿星裂痕关卡描述16",
    "randomEventConfigNPC_45": "神秘商人45",
    "randomEventDialogueGroupConfig_13.20": "暗示除困法",
    "traceStarDes_15": "凿星裂痕关卡描述15",
    "randomEventConfigNPC_49": "神秘商人49",
    "traceStarDes_19": "凿星裂痕关卡描述19",
    "randomEventConfigNPC_40": "神秘商人40",
    "traceStarDes_10": "凿星裂痕关卡描述10",
    "activityTaskDes_2061": "太古之地探索度到达{1}%",
    "randomEventConfigNPC_44": "神秘商人44",
    "traceStarDes_14": "凿星裂痕关卡描述14",
    "randomEventConfigNPC_43": "神秘商人43",
    "traceStarDes_13": "凿星裂痕关卡描述13",
    "randomEventConfigNPC_42": "神秘商人42",
    "traceStarDes_12": "凿星裂痕关卡描述12",
    "randomEventConfigNPC_41": "神秘商人41",
    "traceStarDes_11": "凿星裂痕关卡描述11",
    "traceStarDes_50": "凿星裂痕关卡描述50",
    "randomEventDialogueGroupConfig_13.49": "看看还有没有呼吸",
    "randomEventDialogueGroupConfig_13.47": "它一下子冲过来拦住了你的去路，塞给你一件小礼品。",
    "randomEventDialogueGroupConfig_13.48": "正准备走进商店的时候，发现开门的神秘商人突然倒地，似乎是睡着了的样子。",
    "randomEventDialogueGroupConfig_13.45": "不不不，请你为我今日份的营业额出一份力吧！",
    "randomEventDialogueGroupConfig_13.46": "同意",
    "randomEventConfigNPC_59": "救命的悬赏令",
    "randomEventDialogueGroupConfig_13.54": "说那根本不是祈祷",
    "randomEventConfigNPC_58": "肉肉的悬赏令",
    "randomEventDialogueGroupConfig_13.55": "它不知道是被打击到，还是太困了，倒在了地上，发出了重重的鼾声。",
    "randomEventConfigNPC_57": "奇特的悬赏令",
    "randomEventDialogueGroupConfig_13.52": "带着小礼物离开",
    "traceStarDes_49": "凿星裂痕关卡描述49",
    "randomEventConfigNPC_56": "满地的悬赏令",
    "randomEventDialogueGroupConfig_13.53": "希望小店财神永驻、红红火火、多多盈利、日进斗金、生意兴隆、平安发财、财源广进、财源滚滚来。我要发、一发再发、我要发发发发发发！",
    "traceStarDes_48": "凿星裂痕关卡描述48",
    "randomEventDialogueGroupConfig_13.50": "带着小礼物离开",
    "randomEventDialogueGroupConfig_13.51": "它仍有呼吸，睡得很安详。",
    "activityTaskDes_2051": "虚诞之地探索度到达{1}%",
    "randomEventConfigNPC_51": "风中的悬赏令",
    "traceStarDes_43": "凿星裂痕关卡描述43",
    "randomEventConfigNPC_50": "崭新的悬赏令",
    "traceStarDes_42": "凿星裂痕关卡描述42",
    "traceStarDes_41": "凿星裂痕关卡描述41",
    "traceStarDes_40": "凿星裂痕关卡描述40",
    "randomEventConfigNPC_55": "很丑的悬赏令",
    "traceStarDes_47": "凿星裂痕关卡描述47",
    "randomEventConfigNPC_54": "躺着的悬赏令",
    "traceStarDes_46": "凿星裂痕关卡描述46",
    "randomEventConfigNPC_53": "神秘的悬赏令",
    "traceStarDes_45": "凿星裂痕关卡描述45",
    "randomEventConfigNPC_52": "显眼的悬赏令",
    "traceStarDes_44": "凿星裂痕关卡描述44",
    "12_comment": "造唤台, 怪兽降临界面, 道具获得界面",
    "randomEventDialogueGroupConfig_13.38": "劝它好好放个假",
    "randomEventDialogueGroupConfig_13.39": "径直离开",
    "randomEventDialogueGroupConfig_13.36": "下次吧",
    "randomEventDialogueGroupConfig_13.37": "真的不来看看吗！物美价廉，全是上等好货哦！",
    "randomEventDialogueGroupConfig_13.34": "当然是营业额越来越高。来看看吧！",
    "randomEventDialogueGroupConfig_13.35": "进店",
    "messageInitContent_104": "锤子是哪个工地跑来偷懒的",
    "randomEventDialogueGroupConfig_13.43": "神秘商人正在打鼾，而且声音越来越大，完全没有要醒的样子。",
    "messageInitContent_105": "锤子包工头喊你回去搬砖了",
    "randomEventConfigNPC_69": "神秘商人69",
    "randomEventDialogueGroupConfig_13.44": "离开",
    "traceStarDes_39": "凿星裂痕关卡描述39",
    "messageInitContent_106": "你们都是本关战斗力减2",
    "randomEventConfigNPC_68": "神秘商人68",
    "randomEventDialogueGroupConfig_13.41": "摇醒神秘商人",
    "traceStarDes_38": "凿星裂痕关卡描述38",
    "messageInitContent_107": "我想要持久纹章，嘿嘿嘿o(≧v≦)o",
    "randomEventConfigNPC_67": "神秘商人67",
    "randomEventDialogueGroupConfig_13.42": "离开",
    "traceStarDes_37": "凿星裂痕关卡描述37",
    "messageInitContent_108": "啊我可爱的小逆转",
    "messageInitContent_109": "怪兽101吗，请多多指教",
    "randomEventDialogueGroupConfig_13.40": "商店的门锁上了，它还没来得及打开门，就在门口睡着了。",
    "randomEventConfigNPC_62": "神秘商人62",
    "traceStarDes_32": "凿星裂痕关卡描述32",
    "randomEventConfigNPC_61": "神秘商人61",
    "traceStarDes_31": "凿星裂痕关卡描述31",
    "randomEventConfigNPC_60": "神秘商人60",
    "traceStarDes_30": "凿星裂痕关卡描述30",
    "messageInitContent_100": "攻略坛说后面暴走旷野可以自己组装怪兽？我来组成头部！",
    "randomEventConfigNPC_66": "神秘商人66",
    "traceStarDes_36": "凿星裂痕关卡描述36",
    "messageInitContent_101": "锤子是整牙了是吧",
    "randomEventConfigNPC_65": "神秘商人65",
    "traceStarDes_35": "凿星裂痕关卡描述35",
    "messageInitContent_102": "几年前就让你多拿一个锤子，你就是不听，看又输给我了吧",
    "randomEventConfigNPC_64": "神秘商人64",
    "traceStarDes_34": "凿星裂痕关卡描述34",
    "activityTaskDes_2041": "诡潮之地探索度到达{1}%",
    "messageInitContent_103": "锤子进化雷神之锤！",
    "randomEventConfigNPC_63": "神秘商人63",
    "traceStarDes_33": "凿星裂痕关卡描述33",
    "messageInitContent_115": "你看孩子现在笑得多开心",
    "messageInitContent_116": "这么快就有两大波怪兽了？！",
    "messageInitContent_117": "祖拉变胖了呢",
    "messageInitContent_118": "臣妾终于有肉盾了！\\\\(T ^ T)",
    "themeCardPackName_25040": "大嘴鱼王",
    "messageInitContent_119": "呜呜祖拉终于有肉盾了，我哭死",
    "messageInitContent_110": "技能变成算能量了",
    "messageInitContent_111": "原来锤子身上那个不是彩绘是衣服",
    "messageInitContent_112": "锤子长大了！居然有腋毛了！！！！！",
    "messageInitContent_113": "一拳一个小朋友！",
    "messageInitContent_114": "腐食者的小鼻涕终于甩掉了吗",
    "messageInitContent_126": "或许现在的锤子和咻咻已经不是原来的了",
    "messageInitContent_127": "赶紧问问唯一的证人呜呜祖拉",
    "messageInitContent_128": "呜呜祖拉：我不是、我没有、别瞎说",
    "messageInitContent_129": "你们说什么我还是个孩子",
    "themeCardPackName_25035": "部落冲突",
    "messageInitContent_120": "发现了吗，它们开始远近搭配了",
    "messageInitContent_121": "我就问一句，后面的攻击怎么没打到前面的怪身上",
    "messageInitContent_122": "懂了，bgm是祖拉吹的，快说谢谢祖拉",
    "themeCardPackName_25030": "初战告捷",
    "messageInitContent_123": "我怀疑它们一起上都打不过我",
    "messageInitContent_124": "是谁给你了你自信",
    "messageInitContent_125": "我再次打开这个关卡，就是为了看看腐食者会不会把锤子和咻咻吞掉。结果没有",
    "messageInitContent_137": "桐仁当年退出文坛我是拼命反对的",
    "messageInitContent_8005": "【##############】",
    "messageInitContent_138": "看到桐仁还是一个仁我就安心了",
    "messageInitContent_8006": "1.无需畏惧危险",
    "messageInitContent_139": "怎么一眨眼就过关了",
    "messageInitContent_8003": "1177。世界被触手包围，退路就在那个次元。",
    "messageInitContent_8004": "1.留白的规则可以改写",
    "messageInitContent_8009": "关一下战挑要不。1",
    "messageInitContent_8007": "1178。此关没有专属规则。",
    "messageInitContent_8008": "0.挑战失败并不可怕",
    "messageInitContent_130": "攻略坛说后面暴走旷野可以自己组装怪兽？我来组成头部！",
    "messageInitContent_131": "它好可爱！",
    "messageInitContent_132": "原来那就是300码",
    "messageInitContent_133": "你懂个锤子哟！",
    "messageInitContent_8001": "2。谜语怪兽只有1个。",
    "messageInitContent_134": "啊桐仁我的桐仁啊",
    "messageInitContent_8002": "0.挑战失败并不可怕",
    "messageInitContent_135": "桐仁你的嘴巴怎么这么大",
    "messageInitContent_136": "只有胡子成长了的桐仁",
    "messageInitContent_8000": "【内容已损坏】",
    "messageInitContent_148": "攻略坛说后面暴走旷野可以自己组装怪兽？我来组成头部！",
    "messageInitContent_8016": "1180。永生是一场真实的骗局。",
    "messageInitContent_149": "通关时间太短，都不够时间看弹幕了！",
    "messageInitContent_8017": "1,带关卡数字的是关卡独特规则",
    "messageInitContent_8014": "【该信息无法被识别】",
    "messageInitContent_8015": "1.真正的深渊是【】",
    "messageInitContent_8018": "关一下战挑要不那，了关一下战挑果如你。2",
    "messageInitContent_8019": "1.在此关卡挑战完成后；规则不再适用",
    "messageInitContent_140": "我宣布桐仁被开除出二次元籍",
    "messageInitContent_141": "没见过这么菜的二刀流",
    "messageInitContent_142": "建议叫又菜又二刀流",
    "messageInitContent_143": "噗，什么驯龙斗士桐仁",
    "messageInitContent_144": "是驯鳄斗士！",
    "messageInitContent_8012": "觉睡入睡下按请。1",
    "messageInitContent_145": "陆龙的眼睛。（打一个成语。）",
    "messageInitContent_8013": "1179。真实的特征是【】",
    "messageInitContent_146": "东张西望",
    "messageInitContent_8010": "用适再不则规；后成完战挑关卡在。1",
    "messageInitContent_147": "瞻前顾后",
    "messageInitContent_8011": "3。如果你还是挑战了，那么先退出登录后，再重新登录",
    "themeCardPackName_25005": "采集任务",
    "messageInitContent_150": "眼碌碌",
    "themeCardPackName_13025": "绝对控制",
    "themeCardPackName_13020": "崩坏狂潮",
    "messageInitContent_159": "好家伙，居然是撩妹大师",
    "messageInitContent_8027": "2.金字也意味着真实但这里没有金字",
    "messageInitContent_8028": "1182。这是一种很新的切割魔术，Queen就是那位助手，请不要打扰他们。",
    "messageInitContent_8025": "1。请在整点调整阵容",
    "messageInitContent_8026": "3.带有，的规则是假的要注意甄别",
    "messageInitContent_8029": "【信息被涂鸦】",
    "messageInitContent_151": "鳄鱼是趴着的，它是站着的，所以它是龙，不接受反驳",
    "messageInitContent_152": "它被我打趴了，所以它是鳄鱼，不接受反驳",
    "messageInitContent_8020": "【数据已逃逸】",
    "messageInitContent_153": "修复了幼尸的奶嘴不像奶嘴的bug",
    "messageInitContent_154": "修复了幼尸的口水巾不像口水巾的bug",
    "messageInitContent_155": "之前我一直以为那是门环",
    "messageInitContent_8023": "1。请在按下挑战后入睡",
    "messageInitContent_156": "带着奶嘴那只会回血，只是奶量着实感人",
    "messageInitContent_8024": "1.专属规则可能会出现序号异常",
    "messageInitContent_157": "啊隔壁闪闪发光的原来可以点的",
    "messageInitContent_8021": "1181。请勿用冰霓挑战此关。",
    "messageInitContent_158": "发现圆滚滚那只专门欺负血少的",
    "messageInitContent_8022": "【信息不完整为确保安全实施遮盖】",
    "messageInitContent_160": "它奶的不够我打的多",
    "messageInitContent_161": "它不会是以为卖萌就可以获胜吧",
    "themeCardPackName_13010": "数据残留",
    "messageInitContent_8038": "1184。星光会指引你，该规则只能在无星的夜晚适用。",
    "messageInitContent_8039": "【数据已逃逸】",
    "messageInitContent_8036": "1184。星光会指引你",
    "messageInitContent_8037": "1.没有任何一条规则会告诉你全部的真相",
    "themeCardPackName_13015": "一次模拟",
    "messageInitContent_162": "我的创造更萌",
    "messageInitContent_8030": "【数据已逃逸】",
    "messageInitContent_163": "奶凶，奶凶，呜哇~",
    "messageInitContent_8031": "1.在此关卡挑战完成后；规则不再适用",
    "messageInitContent_164": "奶凶组合",
    "messageInitContent_165": "带着口水巾和奶嘴就出来战斗，这到底是道德的沦丧，还是兽性的扭曲",
    "messageInitContent_166": "这里是凹凸曼专打小怪兽",
    "messageInitContent_8034": "1183。环是什么？是法术呢~不要随便使用法术哦",
    "messageInitContent_167": "怪兽有性别的吗？",
    "messageInitContent_8035": "99.挑战后，关卡中的怪兽就会开始攻击",
    "messageInitContent_168": "我是真怕它打着打着奶嘴就掉了！",
    "messageInitContent_8032": "1.在此关卡挑战完成后；规则不再适用",
    "messageInitContent_169": "放开后面的星刃，我要学撩妹(/ω＼)！",
    "messageInitContent_8033": "【该信息无法被识别】",
    "messageInitContent_170": "哦吼，首通送阿呆",
    "messageInitContent_171": "什么是偏移效果？",
    "messageInitContent_172": "怪兽信息点进技能就能看到，下次受到伤害变成0，不用谢",
    "themeCardPackName_13040": "绝处逢生",
    "messageInitContent_8049": "1186。不可以在此关睡着。",
    "messageInitContent_8047": "【信息不完整为确保安全实施遮盖】",
    "messageInitContent_8048": "1.红字意味着真实但这里没有红字",
    "messageInitContent_173": "呜呜祖拉头上是不是多了一根毛！",
    "messageInitContent_8041": "天枢震+火神。雷——火——导——爆——",
    "messageInitContent_174": "那才不是什么毛，是触手。",
    "messageInitContent_8042": "最简单这里了",
    "messageInitContent_175": "攻略坛说后面暴走旷野可以自己组装怪兽？我来组成头部！",
    "themeCardPackName_25025": "西站鱼鳍",
    "messageInitContent_176": "笑死了，什么普通肉盾。",
    "messageInitContent_8040": "1。请在按下挑战后入睡",
    "messageInitContent_177": "我是普通输出",
    "messageInitContent_8045": "瞳和眼魔算不算亲戚",
    "messageInitContent_178": "我是普通探索者。",
    "messageInitContent_8046": "啊？？？",
    "themeCardPackName_25020": "二次奇遇",
    "messageInitContent_179": "前排出售呜呜祖拉同款裙子，+w9527",
    "messageInitContent_8043": "好像都差不多",
    "messageInitContent_8044": "我已经解出来了",
    "messageInitContent_180": "前排出售呜呜祖拉同款喇叭，+w2077",
    "messageInitContent_181": "前排出售皮诺丘同款指挥棒，+w2012",
    "messageInitContent_182": "后排出售呜呜祖拉同款头顶苗，好养活，易打理",
    "messageInitContent_183": "下次受到伤害变成0是4秒一直还是一次？",
    "themeCardPackName_13035": "过窄边缘",
    "themeCardPackName_13030": "何来顽抗",
    "messageInitContent_8058": "【信息被涂鸦】",
    "messageInitContent_8059": "1。请在按下挑战后入睡",
    "messageInitContent_184": "你还想4秒无敌？当然是第一下啦。",
    "messageInitContent_8052": "1.如果规则中提到“必须”那通常意味着你可以选择不遵守",
    "messageInitContent_185": "谁知道右下角的按钮是什么来的？",
    "messageInitContent_8053": "1.无需畏惧危险",
    "messageInitContent_186": "右下角是主角的技能！",
    "messageInitContent_8050": "2。如果你挑战下一关了，那不要再挑战下一关",
    "messageInitContent_187": "祖拉喜欢吹喇叭~而我喜欢你！",
    "messageInitContent_8051": "1.没有任何一条规则会告诉你全部的真相",
    "themeCardPackName_25015": "如鱼得水",
    "messageInitContent_188": "对面的星刃居然拿了mvp？不科学",
    "messageInitContent_8056": "1187。切勿在此关睡着。",
    "messageInitContent_189": "两只星刃欺负我皮诺丘，还好小创造顶住了",
    "messageInitContent_8057": "1188。谜底是上方的传送门是抽油烟机。",
    "messageInitContent_8054": "【信息被隐藏】",
    "themeCardPackName_25010": "探索任务",
    "messageInitContent_8055": "1.留白的规则可以改写",
    "messageInitContent_10242": "优秀的匹配",
    "messageInitContent_10243": "混合双打",
    "messageInitContent_10244": "脑内模拟中",
    "messageInitContent_10245": "超级控制变量",
    "messageInitContent_10240": "尸族大乱斗？",
    "messageInitContent_10241": "看看袍绑的谁",
    "messageInitContent_10246": "看看你血量",
    "messageInitContent_10247": "内部交流？",
    "messageInitContent_10248": "康康你们啥体力",
    "messageInitContent_10249": "如果你是戏战顽袍你选谁",
    "messageInitContent_10231": "给个机会",
    "messageInitContent_10232": "我猜我猜我猜猜猜",
    "messageInitContent_10233": "这里是预言家，左",
    "messageInitContent_10234": "不要再打啦不要再打啦",
    "messageInitContent_10230": "左右横跳中",
    "messageInitContent_10239": "对吗？不对吧",
    "messageInitContent_10235": "抄作业时间到",
    "messageInitContent_10236": "在猜了在猜了",
    "messageInitContent_10237": "怪兽赢了",
    "messageInitContent_10238": "ai知道答案吗",
    "messageInitContent_10220": "行行行了",
    "messageInitContent_10221": "真行",
    "messageInitContent_10222": "强强强强强强强强",
    "messageInitContent_10223": "大佬快来指路",
    "messageInitContent_10228": "猜对day1",
    "messageInitContent_10229": "给个机会",
    "messageInitContent_10224": "遇事不决看技能",
    "messageInitContent_10225": "希望大家蒙的都对",
    "messageInitContent_10226": "人越多人越少",
    "messageInitContent_10227": "喂策划吗？",
    "messageInitContent_10210": "一个回血一个偏移",
    "messageInitContent_10211": "都是一样的袍吗",
    "messageInitContent_10212": "袍怎么两边都是有你",
    "messageInitContent_10217": "你强你上",
    "messageInitContent_10218": "好强",
    "messageInitContent_10219": "真行",
    "messageInitContent_10213": "看热闹不嫌事大",
    "messageInitContent_10214": "你是行尸你上",
    "messageInitContent_10215": "你行你上",
    "messageInitContent_10216": "控制变量大法",
    "messageInitContent_1902": "只要把这里占了就可以收过路费了！",
    "messageInitContent_1901": "几条道路交汇于此！",
    "messageInitContent_1900": "浪费！浪费食物不可以！",
    "mapNodeName_223": "破界沼地",
    "mapNodeName_222": "动物园",
    "messageInitContent_1909": "盾主怎么在这里",
    "mapNodeName_225": "破界沼地",
    "messageInitContent_1908": "溯仪和她的蓝色猛男团！",
    "mapNodeName_224": "蓝色牢笼",
    "messageInitContent_1907": "本来没有路，走的人多了是吧。",
    "messageInitContent_1906": "没有关系，路都是怪兽开出来的！",
    "messageInitContent_1905": "虽然是几条道路交汇，但这是死路啊",
    "mapNodeName_221": "迷石丘陵",
    "messageInitContent_1904": "建议拍一个忍受环境，此处提供施法者服务",
    "mapNodeName_220": "破界沼地",
    "messageInitContent_1903": "熔岩算是负面效果吗，它们在这都不怕烫的吗",
    "mapNodeName_219": "薛定鳄的怪兽",
    "messageInitContent_10200": "为啥打起来了呢",
    "messageInitContent_10201": "正在猜",
    "mapNodeName_216": "破界沼地",
    "mapNodeName_215": "狼虎之吼",
    "mapNodeName_218": "破界沼地",
    "mapNodeName_217": "迷石丘陵",
    "messageInitContent_10206": "我给6毛",
    "messageInitContent_10207": "最适合袍的怪兽大赛",
    "messageInitContent_10208": "一视桐仁",
    "messageInitContent_10209": "夜观星象不知答案",
    "messageInitContent_10202": "为谁而战",
    "messageInitContent_10203": "人越多人越少",
    "messageInitContent_10204": "控制变量法",
    "messageInitContent_10205": "原生怪=1个技能",
    "messageInitContent_1913": "最后就剩下小溯仪了",
    "messageInitContent_1912": "但没有关系，只要输出够，它们就不好保",
    "messageInitContent_1911": "被拿捏了",
    "messageInitContent_1910": "就为了保这它们切我后排呜呜",
    "mapNodeName_234": "对面只有2个3个4个！",
    "mapNodeName_233": "破界沼地",
    "mapNodeName_236": "源初集市III",
    "messageInitContent_1919": "最终兵器和彼女",
    "mapNodeName_235": "独奶不如众奶",
    "messageInitContent_1918": "真正的aoe来了！最终兵器",
    "mapNodeName_230": "龙王的奶妈",
    "messageInitContent_1917": "我记得以前是叫熔火之巅的",
    "messageInitContent_1916": "欢迎来到流火之巅",
    "mapNodeName_232": "蜻鸟",
    "messageInitContent_1915": "欢迎来到消费者权益关",
    "mapNodeName_231": "破界领地",
    "messageInitContent_1914": "终于不用再战斗了",
    "mapNodeName_227": "千里寻妹",
    "mapNodeName_226": "迷石丘陵",
    "mapNodeName_229": "破界沼地",
    "mapNodeName_228": "三远还是四远",
    "messageInitContent_1924": "本区域不建议进入！",
    "messageInitContent_1923": "前方超高温！",
    "messageInitContent_1922": "环境过于恶劣。",
    "messageInitContent_1921": "直接融化",
    "messageInitContent_1920": "不是魅装我不是很承认",
    "mapNodeName_201": "破界沼地",
    "mapNodeName_200": "迷石丘陵",
    "mapNodeName_203": "迷石丘陵",
    "mapNodeName_202": "肉肉山",
    "messageInitContent_1929": "留言板避雷针，顶我",
    "messageInitContent_1928": "留言板空调遥控在我手上！",
    "messageInitContent_1927": "前排出售遮阳伞",
    "messageInitContent_1926": "前排出售墨镜",
    "messageInitContent_1925": "前排出售防晒霜",
    "22_dish235": "鱿鱼激吻炖汤",
    "messageInitContent_1935": "这老树怎么打架还看书",
    "messageInitContent_1934": "想冲？先问过我的幼体怪兽同不同意",
    "messageInitContent_1933": "你~~~~~~~~~~~~好~~~~~~~~呀~~~~~~~~~~",
    "messageInitContent_1932": "慢是一种生活态度",
    "messageInitContent_1931": "这是什么树懒制造者",
    "messageInitContent_1930": "4倍速！",
    "mapNodeName_212": "地形覆写",
    "mapNodeName_211": "迷石丘陵",
    "mapNodeName_214": "破界沼地",
    "mapNodeName_213": "迷石丘陵",
    "messageInitContent_1939": "这个领地面海呢",
    "messageInitContent_1938": "新家，我马上搬过去，等我！",
    "mapNodeName_210": "破界沼地",
    "messageInitContent_1937": "新主城我来啦",
    "messageInitContent_1936": "快，是不行的",
    "mapNodeName_209": "破界沼地",
    "mapNodeName_208": "破界沼地",
    "mapNodeName_205": "海中花",
    "mapNodeName_204": "潮起",
    "mapNodeName_207": "龙王宴",
    "mapNodeName_206": "《失散多年的姐妹》",
    "resoundEventConfigDes_2003": "在橄榄球队中，联盟最高薪的球员大多数是四分卫，第二高薪的，是保护四分卫盲侧的左内边锋，加上速度迅猛的跑锋，他们会激起一场比赛的浪花，让气氛达到顶点。\\n而线卫不能制造水花，球迷们花钱只想看水花。\\n特别对于菜鸟线卫，要想在比赛中得到球迷的赞誉，更是难上加难。\\n但马克这位20岁的球员做到了。在加入联盟头部球队后的首场常规赛中，他四次擒杀了联盟最强球队的四分卫。后者是教科书式的球员，刚过去的联盟选秀会中的第一顺位，每次传球都无懈可击，直到遇上马克。\\n这只菜鸟一跃成为线卫新星。\\n现在是外卡赛第一节比赛快结束的时候，马克擒杀对方的四分卫，并回攻达阵得分。\\n马克收获了队友的赞扬和拥抱，还有啦啦队的飞吻。这让他黝黑的皮肤上泛起难以觉察的红晕。当马克卯足劲回到第二节比赛的时候，他的擒杀却被对方一个刚换上场的跑锋突破。\\n马克曾在漫画店中翻过一本漫画，里面讲述了一个速度超越音速的橄榄球跑锋的故事，当时他对漫画夸张的描绘有点嗤之以鼻，但在擒杀被突破的这一刻，他想到那个故事。自己太无知了，一只菜鸟竟然自大地无视这种可能性，这一定是上天对他的惩罚。\\n本来略胜一筹的球队因为对方的秘密武器弄得有点惊慌失措。\\n在中场休息中，教练调整了战略，无论大家如何安慰马克，这位年轻的球员都认为是自己拖了后腿。\\n“都是我的责任。”\\n“只要你比他更快就行了。”教练拍拍马克的肩膀。\\n“放轻松，如果只靠你一个就能左右这场比赛，我们也太没用了。”队长及四分卫慰他。\\n“唔……”\\n即便如此，马克还是带着无比愧疚的心情，趁着休息还没结束，冲回休息室祈祷。\\n这场比赛，他的球队几乎是用血战的方式险胜对手，队友开启“野兽模式”在最后3分钟完成67码强力冲球达阵让比分反超。\\n如果马克在场，这场的胜利可能会来得更轻松一点。可是，赛后，满场都是针对这个线卫新星临阵退缩的嘘声，而他的教练和大部分队友却焦急地等待着警方的调查结果，因为他们都担心这个憨厚虔诚的小伙子的失踪和什么犯罪事件有关。",
    "resoundEventConfigDes_2004": "埃癸斯在一片寂静中夺回了意识，他看向塔外，狂舞的黄沙早已沉睡入梦，大地褪下了金黄，夜晚由灿烂的星空所接管，更没有看见史卡非斯的身影。\\n此时，埃癸斯感受不到任何苦战过后留下的疼痛，他将兽皮水袋的折口打开，来自晨光平原的溪水在他的身上放肆落下。腹部、胸部的铠甲缝隙深处放出无限的光芒，头盔下的双眸更散发出坚定的金光。浮现在背后的六块深蓝色盾牌，让打算从背后袭击的敌人无从下手。\\n左手所持的重盾和套在右臂的轻盾形状上都有轻微的变化，边缘更锋利，双盾的上半部都分裂成里外两块，即使攻破外盾，还有内盾保护着。盾面上原本没有任何装饰，现在上面暗光流溢着形状如闪电般的深蓝色花纹。\\n骨质的塔壁反射着他进化后的光芒，变成一片哑金色的幕布。\\n埃癸斯环顾石塔，看了看手中散发着幽绿色光芒的小盘子，然后一遍遍地在脑海中回顾那场战斗的记忆，冰冷无情的镰刀骷髅，史卡非斯的骗术，还有自己不曾动摇的信念……\\n我的意志即是守护，而非击破。石塔承认了我的意志，我的圣盾！石塔更赋予我力量，这份力量让守护变得更坚不可摧，我将继续守护我的部落，我的荣耀，直至永远！\\n埃癸斯想着看向远方，第一缕晨光让地平线变得异常清晰，亦如他的思绪。\\n“抱歉！抱歉！你能听到我说话吗？嘿！能听到吗……”\\n或许是还沉浸在进化的情绪之中，埃癸斯过了一会才意识到身体内一直有个焦急的声音在呼喊他，是那个与自己合体的男孩。\\n他回过神，开始简略地向男孩介绍起了超进化大陆的现状。\\n男孩在听完以后惊呼了一声“我的上天”，便陷入一种异常焦灼的情绪中。这让埃癸斯有点担心，同样让他担心的还有他与自己相比起来的那“瘦小”的身形。\\n催问之下，埃癸斯才知道男孩叫马克，正在参加一场战斗，而他的任务是誓死阻挡敌人的进攻。虽然体格与自己相比有很大差距，但保护同伴的使命感和自己一样，埃癸斯顿时热血沸腾起来。\\n“感谢古神，赐予了自己一位崇高无比的伙伴！”他心中默念。\\n当然，在埃癸斯知道马克的体格可不算“瘦小”的那天，他还会再次由衷地感谢古神。\\n“回家去吧，如果不愿和我一起对抗邪王，就好好保护自己的族人。我会寻找让你回去的方法。”\\n“真的？！”\\n“嗯，既然你也有要保护的伙伴，我就不能任性自私地要求你帮忙。”\\n“啊，谢谢！如果能在球赛前回去就好了……”\\n埃癸斯听出男孩话中的绝望，很可能他回去的时候，他的同伴已经尸横遍野。所以，埃癸斯十分理解男孩似箭的归心，既然对他许下诺言，便无论如何也要做到，即使……即使自己会退化回究极的样子。\\n当埃癸斯的思绪还停留在某种无奈的可能性中，一道温暖亮眼的火光从他眼前掠过。回过神来的时候，一只巨大的火鸟在他身前振翅欲飞。\\n“啊啊啊啊啊！是是是是神神神、神灵……”\\n从火鸟翅膀边缘飘散到他脸上的点点火星毫无炽烫感，但埃癸斯的嘴巴却像含着几个滚烫的水藻团子一样，语无伦次。\\n“终于见面了，埃癸斯……”\\n朱雀慈祥威严的声音很快让埃癸斯镇定下来。\\n埃癸斯激动而安静地听完朱雀的建议，但他并没有露出古老神灵所期待的兴奋表情。\\n“请问……您有没有把这个男孩送回他的世界的办法？”埃癸斯有点不安地问道。\\n“哦？你也对自己的同伴不满意？”\\n朱雀不禁皱起眉头，他还以为这个孩子会比古拉姆更懂事一点。\\n“不是的。”埃癸斯摇摇头。\\n他把男孩要急着离开的原因一五一十地告诉朱雀。\\n“唔……”朱雀沉吟了一下，他没想到埃癸斯竟然出于一个无比崇高的理由而放弃才得到的进化，“这件事我暂时还没有任何办法，不过，就现在来说，打败邪王一定是最快的途径。”\\n埃癸斯脸上闪过一丝绝望，朱雀知道这一定是那位男孩在哀叹。\\n“你们先向北走，早一步出发，你的同伴便能早一步回去。”\\n“领命……”\\n埃癸斯踏着沉重的步伐离开石塔。\\n汹涌湍急的岁月洪流诞生了品性各异的英雄，这些个性如此鲜明的远古族英雄又会造就怎样一番时势呢，朱雀想到。",
    "resoundEventConfigDes_2001": "“——狂野沙漠上出现了第三座石塔！”\\n这个消息送达时，埃癸斯正在部落的最前线，为防线布置作最后的检查。现在，他必须立刻启程赶往狂野沙漠。\\n晨光草原的东南岸终日享受着海浪温暖轻柔的亲吻，但越往南方，海浪越疯狂。与晨光草原隔着怒沙海峡遥相对望的，是一片广袤的沙漠。海水扑打到滚烫的黄沙上，化作水汽混入虚空，黄沙企图侵占大海，但沙沉海底，大海不见减损一滴一勺。\\n埃癸斯的渡海还算顺利，只用了一天的时间，接下来等待他的将是无边的狂沙漫舞。\\n沙漠随着时刻的变化由金变橙，再由橙变紫。可埃癸斯并没有心思欣赏这番瑰丽的景色，因为稍不留神，毫无预兆的沙暴就会将他埋没于滚滚黄沙之下。\\n遭遇沙暴时，埃癸斯把与他等高的重盾挡在身前作掩护，挡住袭来的沙刃，但狂沙刮过他的盾牌，绕到他身后重新结集成一股可怕的力量继续撕扯他的身体。\\n“盾之所向，定会开辟出新的道路。”\\n当埃癸斯在漫天黄沙寸步难行时，正是这个笨拙的信念支撑着他。\\n与怒吼的风沙对抗的第二天，埃癸斯发现了里头的一丝破绽、一瞬示弱。他转朝那个方向前进，直至看到那座巍峨的石塔，截断了风沙不可一世的势头，让它们花上一些时间才变得和原来一样强大。\\n时值正午，再跋涉了一段路，埃癸斯来到了离石塔背风处不远的地方，他警惕地环视四周，确认没有异常后又继续前行。\\n只见塔壁上有一个不规则的开口，埃癸斯从开口进入后就把盾牌竖在了身侧。石塔很高，却空旷得可以一眼看到尽头，黄沙就像强弩之末在里面缓缓旋转。\\n但埃癸斯并不是第一个找到这里的怪兽，木偶族的族长疤脸史卡非斯正在用那张满布疤痕的脸看着他，另外两个木偶族似乎受了重伤，倒在了地上吁吁地喘着气，地上还散落着几段白森森的断骨。\\n埃癸斯注视着眼前的史卡非斯，对方同样在盯着他，木偶族特有的自动发条声在塔内回荡，吱嘎吱嘎吱嘎吱嘎。\\n埃癸斯一向拙于言辞，他不知道怎么解释自己的来意，因为好像怎么解释都会变成敌意。\\n突然一阵“库啦喀啦”的响声打断了埃癸斯的思考。无数手持短镰的灰白身影从塔壁分离出来，它们敏捷地跳到地上，如骨浪般朝埃癸斯和史卡非斯汹涌扑来。\\n“那是什么？”\\n“看它们手上的武器，那是一种叫镰刀的怪兽，但这里的不是一般的镰刀，它们没有血肉只剩白骨。使盾的，我们合作拿到石塔的宝藏吧。”史卡非斯稍稍退了一步，木偶族的脸不会有表情变化，显然他害怕这些白骨。\\n“躲在我后面！”\\n动作比言语快上不只一拍，埃癸斯已经跃到史卡非斯前面，给出了答案，盾牌很简单就挡住了轻飘飘的攻击。\\n即使挥舞着重盾，埃癸斯的身手也算得上敏捷，如黑色岩块的盾牌，像飓风一样，把扑上来的镰刀骷髅尽数扫飞。它们碰到塔壁的一瞬便散了架，像戈壁甲虫一样的头部滚到了地上。\\n随后，第二、三、四波镰刀骷髅从塔壁分离开来，它们一批比一批强大。虽说史卡非斯并没有给他多大的帮助，但拥有『传说之力』的埃癸斯依然游刃有余，落在上面的攻击如雨滴落入大海，被彻底忽视了。在『传说之力·挡』的庇护下，被镰刀割开的小伤口迅速愈合了，他的盾也变得更为厚实。\\n转眼间，石塔的攻击来到了第七波，埃癸斯喘着气趁隙调整了一下姿势。怎料蝼蚁绊象，新生的镰刀骷髅不论是伤害还是数量，都在以几何级数上升。埃癸斯有点力不从心了，刚顶开了一堆，又有新的一批冲上来，一道道血红的伤口划在身上，旧伤尚未痊愈，又有了新伤。\\n即便如此，他还是把三个木偶族保护得严严实实。\\n“快撤！这样下去我们都会死在这里！你带着伤员，我掩护你们！”埃癸斯朝身后的被保护者大喊，盾牌刮起的余风随着话音低吟。\\n“使盾的，我们往门边靠，把后背交给我，你断后！”史卡非斯应道。\\n“好！”于是双方背对背地往外缓慢移动。\\n埃癸斯不是那种战斗时还能分心思考的战士，他重新把思绪集中到一贯的信念上——防守是最佳的进攻方式。\\n不断扫挡，重复的动作，只是不断扫挡，一点技巧也没有的简朴的防御方法。\\n但这样就够了。埃癸斯不知道塔壁还会诞生多少镰刀骷髅，石塔好像要把所有的重量压到他身上，他掂量了一下手中的坚盾，仿佛挡开了不亚于一支军队的攻击。他现在只是想让三个木偶族能安全逃出石塔。\\n“快到出口了，你们赶紧逃！”在埃癸斯的掩护下，史卡非斯和另外两个木偶族怪兽距离石塔的出口就只剩一步之遥。",
    "resoundEventConfigDes_2002": "史卡非斯没有回答，如果能有表情的话，他可能不自觉嘴角上扬吧。埃癸斯这就上当了，传言果然是真的吗？愚蠢的正义之心。伤痕累累还要保护我们？舍身守护别人？不存在的！\\n这是个尔虞我诈的世界，没有相信，没有信赖！想要生存，就必须一直欺骗下去，不想被欺骗就只能先欺骗别人！或许埃癸斯也有什么阴谋，但先下手的会是我们！\\n远古族的三个部落是一个黄金组合，古拉姆负责攻击、埃癸斯负责防守、月夕负责治疗。如果龙族也有这样的组合，百年前逆焰龙王早已所向披靡，征服了整个超进化大陆。\\n就算拿不到宝藏，至少也要在这除掉埃癸斯，突破那肥沃草原的土地的第一道防线。\\n这是史卡非斯看到塔外的埃癸斯时，就构思好的“骗术”。\\n下手的时机来了，只要让埃癸斯重伤就大功告成了。\\n他很清楚镰刀骷髅的可怕之处，那就是它们对重伤的怪兽的致命性，它们痴迷于让伤口变得更深，面对重伤者，它伤害会比原来提高上百倍！\\n史卡非斯示意另外两个木偶族同伴强袭，让他们准备对埃癸斯发动袭击。其实他们的伤势并不严重，一切都只是为了消耗埃癸斯的精力罢了。\\n“可是他们刚刚一直在保护我们？”其中一个强袭用木偶族的语言小声问史卡非斯，另外一个附和式地点了点头。\\n“两个蠢材，我族最初所遭到的欺骗，你们都忘记了吗？竟敢去相信外族的怪兽？小心石粪鸦吞掉你们的灵魂！”\\n史卡非斯想起远古时代，一些外族怪兽欺骗木偶族，并把他们残忍拆解，只是为了满足自己无聊的好奇心，解开木偶族奇妙的躯体构成的秘密。一股怒火涌向史卡非斯心头。\\n史卡非斯将其中一只强袭的左臂切断。镰刀骷髅发现新目标后，如浪般涌起，将飞到半空的手臂切碎。接着史卡非斯口中念念有词，一个古怪的魔法阵覆盖在他身上，这是和传说之力同样效果的『骗术』——忽视一切攻击，可巧妙在于，身体依然会有伤痕，用以迷惑对手！\\n此时，埃癸斯听到背后传来强袭的惨叫，便立刻转身帮忙。他的余光看到了拿着短镰的史卡非斯，不详的预感还没来得及掠过埃癸斯心头，短镰就已经极速划向埃癸斯的颈部——而那时，埃癸斯的盾牌正为史卡非斯挡开从他旁边砍来的镰刀。\\n“我等的就是现在！”\\n“唔……”\\n被刺中的地方刚好是盔甲间的缝隙，虽然偏低了一些，但也足够了，血汩汩地从伤口流出。\\n啊……原来是这么回事，果然是木偶族的骗术之王——史卡非斯。\\n“再见了。”史卡非斯跳开，他的目的已经达到。趁着身上的魔法还没失效，史卡非斯拖着两个强袭冲出了石塔。他一边回头确认埃癸斯在白骨堆中挣扎的样子，一边准备撤退。\\n突然，一面重盾凌空坠落，盾边深深插进地面，只差毫厘就能将史卡非斯砸成重伤。\\n“可恶的远古族，没想到你还有力气杀我！”\\n史卡非斯吓了一跳，他没想到埃癸斯竟然还有余力要与自己同归于尽。\\n“你误会了。”埃癸斯凛然地说。\\n史卡非斯一看，上百把短镰落在了盾边。他身上的魔法已经失效，如果不是重盾的拦截，他就已经被飞来的利刃刺穿了，这座石塔不允许挑战者逃跑么。\\n“你得活着出去，你欠我一次堂堂正正的战斗！”\\n听到埃癸斯的喉咙中漏出凶猛而充满危险信号的低吟，史卡非斯打了个寒颤。\\n“世界上还真有这种傻瓜？拯救一个要置自己于死地的人。不，不可能！他们只是想获得我们的信任！我的骗术之道是正确的！别人欺骗我们，那我们就加倍奉还！”史卡非斯一边咒骂着一边消失在黑色的沙漠之中……\\n失去盾牌的埃癸斯淹没在无数镰刀骷髅中，他的痛感渐渐变得麻木。\\n埃癸斯闭上眼睛，可眼前偏偏出现了古拉姆那张超级不爽的脸。古拉姆曾让他多提防史卡非斯，这位族长使诈的话，连古神也会上当。\\n“你怎么可以倒在这种地方！”挚友看见自己的样子，大概会恼火地大吼吧。\\n一股无名的情绪涌上埃癸斯心头，唔……这样死去真是和荣耀沾不上边，而且还败在一个劣等诡计之下。他并不恨史卡非斯，他恨自己，虽然贯彻了自己的理念，却辜负了部落对自己的信任……\\n胸中翻滚的愤怒化成不屈的力量，让远处的重盾也得到了共鸣。重盾像长了隐形的翅膀，破风疾飞，它撞开层层骷髅镰刀的包围，回到主人手中！\\n在石塔内所承受的一切攻击转化为反击的力量——\\n澄澈的圣绿光辉从镰刀骷髅中迸射出来，它淹没塔中的黑暗，净化所有惨烈的战斗痕迹，然后仿如倒流的瀑布般直泻塔顶。",
    "resoundEventConfigDes_2009": "天与地的异变是同时发生的。\\n伴随着突如其来的地震，坚如磐石的武器坟场出现一道长长的裂缝，裂缝横亘在埃癸斯和敌人之间；从不朽木偶手捧的宝物上倾泄出一道碧绿的瀑布，直冲天际。\\n当敌人惊讶地眺望着光瀑深处的时候，埃癸斯肢体上的锁链稍微松动了一些。他捉住绑在脖子上的锁链用力一扯，不朽木偶飞过裂缝，掉到自己这边，不朽木偶手上的宝物却掉进裂缝中。\\n“混蛋！”\\n骂了一句，不朽木偶想重新掌握主导权，但是七条锁链都被埃癸斯抓紧，如果现在缩短锁链的长度，等于把自己送到埃癸斯跟前。而对面的两个灵族正愣愣地看着狼狈的自己，忘记仪式还没完成，四肢发达头脑简单的尸王则深深沉醉在光瀑中，即使背后砍他一刀也不会抵抗。\\n“咒文！继续吟诵咒文！”\\n“啊啊，是！”\\n看到仪式磕磕绊绊地继续下去，埃癸斯感受到不朽木偶杀气的锋芒再次袭来。早已经历过石塔内进化仪式的他，一直寻思着对方吟诵咒文的作用。\\n“埃癸斯！天上掉下了一个人！”马克震惊地喊道。\\n埃癸斯被马克激动的情绪影响，也不禁抬头望向光瀑——\\n一道纤弱的身影从天空的缺口中飘然落下。\\n地震持续着，裂缝已经变成崖堑，武器坟场深处的武器纷纷滑落到崖堑中。不朽木偶对埃癸斯的偷袭也因为地震而被屡次打断。\\n眼看那道纤细的身影坠落的速度越来越快，像庞然巨怪血盆大口的崖堑毫无疑问就是它的归宿，救人心切的马克在极度紧张之下得到了躯体的主控权，他伸出双手跑向坠落者。\\n已经可以看到她身穿粉蓝色的睡衣，和一头长长的黑发！\\n已经可以看到她惊恐的表情！\\n已经可以碰到她的手指——\\n可惜还是以半秒之差，两者的指尖轻轻摩擦交错而过，马克手中紧握的只是带着黄沙和铁锈的空气。\\n“啊——”\\n和身影同样纤细的是惊恐的嗓音，但连这声尖细的惊叫也很快被崖堑吞没。\\n和绝望的马克不同，埃癸斯知道那是宝物所带来的进化仪式，异世界的来者不会被摔死。可不管得到进化的是什么东西，如果让对面的敌人完成古怪的仪式，却不知道会造成什么影响。\\n“她不会有事的。”埃癸斯立刻安慰马克。\\n在马克慌乱之际，重新掌握身体主控权的埃癸斯趁着能量场造成的松动，从崖堑边上抽出一段断矛和一把旧剑，向对面投掷过去。\\n两个毫无防范的灵族被砸倒在地，咒文的吟诵也停顿了下来。\\n由于武器坟场中的兵器已失去其锋芒，所以他们只是受了轻伤，当然埃癸斯在投掷武器之前就已经把这一点考虑到了。只要让仪式结束就够了——\\n崖堑中传来了一阵阵巨响，咔嗒咔嗒咔嗒铛嘭——\\n一个庞然大物背着六翼升起，挡住了天空，无数断裂的锁链和铁屑从它身上掉落，坠向深渊。被锈迹咬住的半脸横闪过一刹红光，显现出巨兽的双眸，它似乎在找寻着能理解之物。\\n突然间，巨兽展开的半透明薄翼在一瞬改变了角度，巨兽化作一道暗色的紫光射向不朽木偶。\\n“你这家伙！你这家伙你这家伙你这家伙！！”\\n不朽木偶立刻扔下埃癸斯，操控着锁链将自己的身体支起闪避，面容更是因为愤怒而变得更加狰狞。这是“王”对他寄予十二万分的信任才传授的魔法，它能驱除任何沉睡中的怪兽的自我意识，让怪兽成为施咒者的忠实信徒。本来这个庞然大物现在应该乖乖地跟着他回去效忠于“王”，但现在，他的重拳就打在了自己身旁不到一毫米的位置！若不是它刚启动尚未完全调整，自己可能就碎掉了……\\n不朽木偶将七条锁链释放出去，试图绑着巨兽的翅膀，可下一秒它那硕大的头颅便从身上滚落，扭曲的眼珠疯狂转动着，嘴里还吟诵着那不明的咒文——\\n它被巨兽击中了。\\n“快住手——”埃癸斯大吼。\\n那是在埃癸斯准备冲过去阻止巨兽的短短几秒，战斗由开始急转至终结。",
    "resoundEventConfigDes_2007": "狂野沙漠最有名的不是它一望无际的黄沙，而是不知从何时开始出现的一座武器坟场。远古族的智者说它是前几次邪王大战后遗留的武器大山，当年的幸存者把残破的武器扔到这片沙漠上。如果是真的，那么这座巍峨的武器大山则经年累月地向黄沙诉说着邪王之战的残酷。\\n经过漫长的风化，坟场中的每一件武器都已经深深埋进墓冢中，即使紧抓最外缘的任意一把武器手柄，也无法把它拔出来。\\n没有怪兽会无聊到来武器坟场寻找宝物，它唯一存在的意义，就是成为茫茫沙漠中的唯一路标。看着太阳让它在沙漠上投下的长长的影子，途径此地的怪兽就能辨别出大概的方向。\\n埃癸斯跟着女巫星一路往北，在黎明初现的时候终于看到了远方的武器坟场——山表仿佛长满了粗细不一的尖刺，那是覆盖在最外层的各种武器。\\n女巫星已经消失在紫蓝色的天幕中，等晨曦给那座大山拉下长长的影子，他就能更准确辨别方向，继续向北而行。\\n突然，山体上出现一道闪电，埃癸斯以为自己看错了，紧接着，几道闪电再次缠绕着山体，发出怵人紫光。\\n“那是什么？”与埃癸斯共处一个躯体的马克问道。\\n“我……我也不知道。”\\n埃癸斯与马克合体后，觉得自己无论在力量上还是速度上都更胜一筹，但是，见识却无法随着进化而增加。\\n现在那座本应死去的大山，在一种诡异的能量场下，像重新焕发生命一样。如果死火山用喷发熔岩来宣告自己的复苏，那么武器坟场会怎样展现自己的力量？在埃癸斯不善想象的脑海中，浮现了一幅无数武器迸射而出，超进化大陆上的生灵被刺中、击伤、被杀至片甲不留的恐怖景象。\\n一想到这里，埃癸斯就沉不住气，用最快的速度跑向武器坟场。\\n一股铁锈的腥臭和黄沙沧桑的味道扑面而来。\\n埃癸斯躲到武器坟场的一角，看到“山腰”的一个缓坡上站着几个鬼鬼祟祟的身影。\\n超进化大陆的怪兽天生拥有识别危险的本能，除了视觉、听觉、嗅觉、味觉和触觉以外，还拥有能够感知到“流动”的第六觉。“流动”看上去介乎于气和烟之间，会一丝丝地从怪兽身上渗透而出。\\n各族怪兽对此有很多不同的解释，但在分类上大体是一致的，绿色流动被称为“原生级”，蓝色流动则是“幻化级”，紫色流动属于“究极级”。在紫色之上的则是“不朽”，看到过的怪兽少之又少，据说是橙金色的。\\n埃癸斯定眼一看，一共有六个怪兽，三个究极级的尸族形成包围圈，警惕地提防着什么，两个究极级的灵族站在尸族中间，还有一个——他的身上笼罩着一层橙金色的光芒——竟然是不朽级的木偶族？\\n才和木偶族族长史卡非斯交过手的埃癸斯吃了一惊。史卡非斯已经停滞在究极级很久了，如果木偶族诞生了不朽级的怪兽，史卡非斯一定会被迫让出族长之位。\\n难道就在战斗结束到刚才这段短短的时间内，史卡非斯被超越了？",
    "resoundEventConfigDes_2008": "不朽级的木偶身上飞舞着几条长长的链子，每条链子的尾端都系着锋利的钢爪，爪尖闪烁着寒光。\\n更奇怪的是，不朽木偶的手上捧着一个释放着幽绿色光芒的小盘子，就像自己通过石塔考验时得到的宝物一样。他们也通过了石塔的考验了吗？\\n两个灵族和不朽木偶对着宝物念念有词，几条紫色的闪电从他们三者的脚下开始释放。\\n几道闪电蔓延到埃癸斯身边，埃癸斯侧身躲开。他感受到闪电释放出来的能量是一种会吞噬吸收者理智的负波动，即使稍微靠近，他也感受到大脑的瞬间麻痹。\\n单凭这一点来看，就能猜到他们在做什么不好的事情。\\n“要阻止他们吗？”马克问。\\n“正有此意，起码也要问个清楚！”\\n“要上了！”埃癸斯和马克同时默念。\\n马克在球场上被意外打断的战意苏醒了，他的神经和肌肉再次绷紧，虽然身体不是由自己控制，但他已经把这份敏锐传达给埃癸斯。\\n埃癸斯左手一扬，重盾盘旋飞出，它与空气和黄沙摩擦的嘶嘶激鸣马上引起对方的注意。不偏不倚，重盾插在不朽木偶的面前，吟诵中断，紫色的闪电也被斩断。三个负责守卫的尸族立刻摆好了防御的姿势。\\n从山脚到半山腰起码有百余码的高度，马克第一次切身感受到异世界生物能对物理法则的抗衡做到哪种程度，相比之下，橄榄球就像儿戏。\\n马克第一次产生了想在这里逗留久一点的念头，通过异世界的磨练，无论四分卫还是跑锋，拦截起来一定易如反掌。 \\n神秘的仪式被打断，不朽木偶的双眸如猎鹰望向重盾飞来的方向，身上的锁链一起锁定了远方那个熠熠生辉的战士。\\n那支诡异的队伍似乎没有打算撤退，太好了，说不定对方愿意与自己对话，埃癸斯想。他看准了山表上几个凸出的废旧武器，以它们为踏脚点提气疾跑，遇到无法踩踏的地方，就把右臂上的轻盾插进“峭壁”之中，借力跃到另一个踏脚点上。\\n只用了不到十秒的时间就跨越了百余码的“峭壁”，这种身手让马克再次艳羡起来。\\n“我是圣盾埃癸斯，你们快停下来，不然别怪我不客气了！”\\n“仪式继续，不要停！把他阻止到那东西醒来就行！”不朽木偶命令道。\\n不朽木偶和两个灵族退到旁边的空地上，继续念诵奇怪的咒语，而三个尸族点了点头，直接向埃癸斯冲过去。\\n埃癸斯先是用盾挡下了尸王的左拳，随后又接下了两个幽鬼的双拳，三拳打下来，埃癸斯几乎没受到什么伤害。\\n“他们好像挺弱的。”\\n“可他们已经达到目的了。”\\n不知不觉间，和尸族正面硬刚下来的埃癸斯被撞回到了他们刚出发的位置，而且还是在武器坟场这种摩擦力超大的地面。\\n此外，尸族们把强大的回复能力——『不死』发挥得淋漓尽致，硬碰时造成的伤势立刻就恢复了。尸王身上不时爆发出来的恶臭伤害也让埃癸斯有点难受。\\n“他们不想让我们靠近！”\\n“是的。”\\n体型魁梧的尸王踩在凸起的武器残骸上，俯瞰着位于下方的埃癸斯，幽鬼一左一右抱住尸王，凌乱的发辫和触手在疯狂地挥舞着，似乎是不打算再追了。\\n“马克，我有个想法，不过……”\\n“没问题，我可以……”\\n两者心意相通实在太方便了，无须过多解释就能马上行动。\\n埃癸斯稳住下盘，先后将身上的圣盾向尸王击出。刚刚回复了所有体力的尸王见状，胸有成足地一拳拳打在飞来的重盾上，强大的爆发力把重盾打飞，埃癸斯以飞来圣盾为落脚点，稳稳地跳了上去。最后一跳，他借着反作用力的势头狠狠地扑向尸王，尸王仍专注于回击飞来的盾，还没来得及反应，就被埃癸斯压在身下了。\\n埃癸斯并没有停下来，他提起最后一张盾，冲到已经愣住了的幽鬼背后。\\n尸王伸出右臂想要阻止同伴“不，别打他——”，话音未落，两个因为爱人被砸到破相而盛怒的幽鬼已经回身出拳了。\\n埃癸斯借着幽鬼们的双拳，再次被回推到了山坡的高处，此刻双方位置调转。\\n这就是马克和埃癸斯拟定的战术，马克为埃癸斯计算好圣盾的击飞轨迹，埃癸斯跳上圣盾袭击尸王。对于在赛场上每一秒都要预测敌方球员运动方向的马克来说，只要看到尸王肌肉的抽动，就能知道他会向哪个方向出拳。\\n“呃……你们两个蠢货！”\\n尸王顿时不知所措，他们并没有速度优势，如果攻击处于他们上面的埃癸斯，就只会将他推向他的目的地。若是不攻击，就只能眼睁睁看着他逃跑。\\n埃癸斯不再理会尸族的叫吼，向诡异的法阵冲锋而去。\\n此时，七条锁链已经变成一张大网，把他的进退之路全部封死。\\n不朽木偶吟诵咒文的速度越来越快，根本没有看埃癸斯一眼，但他身上的锁链仿佛凭着自己的意志攻击埃癸斯，而且长度是之前看到的三到四倍。\\n埃癸斯的四肢和脑袋都被锁链卷住，还有两条锁链尾端的利爪下一个瞬间就会刺进他的眼睛。",
    "resoundEventConfigDes_2005": "洛菲菲比其他孩子更优秀。不是“天才”那种夸张而存在着性格乖戾风险的优秀，而是每间一类中学都想招收的全面A级优等生。\\n钢琴、小提琴这两种古典西洋乐器是必修课，水平虽然比不上专门走音乐路线的天才儿童，但在母亲和其他名媛聚会时稍露一手，就能轻易获得其他母亲艳羡的目光。\\n从七岁开始，只要她愿意，她就可以用熟练、口音可爱的英语在旅行时轻松自如地点餐、答谢饭店服务员、向博物馆的工作人员咨询感兴趣的艺术品的详细信息。\\n洛菲菲从小就师从一级书法家学习书法，幼嫩的字体中已带有苍劲的大家之风。\\n其他科学，每次的考试不是满分，就是距离满分只有一两分之遥。\\n从出生开始，洛菲菲就走在成为企业家或者外交家的道路上。 \\n这与她父母的培养不无关系。\\n洛菲菲父亲伊藤阳一是Monkey Tree的CTO，Monkey Tree是一间专注于机器学习和大数据分析的公司，也就是俗话说的人工智能公司。伊藤阳一在某次宴会认识了洛文姬，也就是洛菲菲的母亲，一个拥有雄厚资金背景的名媛。\\n当年，Monkey Tree因缺乏研发资金面临被同行吞并时，关系一直处于暧昧阶段的名媛洛文姬突然向他求婚。洛文姬带着娘家的雄厚资金让Monkey Tree转危为安，作为交换，洛文姬要求他们的孩子随她姓。\\n伊藤阳一倒无所谓，他信奉的是物竞天择、适者生存的大自然法则。Monkey Tree以后会变成一间跨国合资的公司，但伊藤阳一不在意，他的梦想是让自己的人工智能产品成为最优秀的“新人类”。\\n那天是洛菲菲的11岁生日，当时母亲洛文姬已经接到很多一类中学的意向招录邀请和一众亲友、企业伙伴的祝福。\\n洛菲菲还在书房自习——她优异的成绩并不是凭空得来的，每天12小时的文化课学习，甚至比大部分高考生还要勤奋。\\n同一时间，洛文姬和伊藤阳一正在书房外，用英文讨论女儿的升学问题。中文和日语都是洛菲菲的母语，所以父母在讨论一些不想让女儿插嘴的事情时，都会转到用英语交谈。\\n“你想让菲菲回你那边念中学吗？”\\n“不……外头也有很多好学校，例如这家全寄宿制的八方中学。”洛文姬说着敲了敲手中的平板电脑。\\n洛菲菲正使劲地贴在书房的门上偷听父母的谈话。她一直在英语的学习上格外用功。\\n距离补习课开始已经过去了半小时了，补习老师却还没来到。\\n因为洛菲菲在课前曾拜托老师到书城购买一本学校指定的学习资料，并称父母那边由她来说就好，老师晚点到也没关系。\\n父母的讨论继续着。\\n“不过，那所学校好像需要内部人员推荐才能得到面试机会。唉唉，真麻烦呢，到时我们还要陪着菲菲飞过去。”\\n“听说拓也的爷爷和其中一位校董是朋友，拓也待会也会来菲菲的生日会，我们可以向拓也漏点口风。”洛文姬没有理会伊藤阳一的抱怨继续说道。\\n“他能懂你的意思吗？”\\n“他平时不是挺照顾菲菲的，这不大家都明白。”\\n“啧，不会吧……”伊藤阳一有点意外。\\n洛菲菲愣了一下，拓也很可能和自己成为中学同学，她想到“青梅竹马”这个成语。今晚的生日会，拓也应该会第一个到。\\n此时门铃响了，补习老师带着洛菲菲指定的学习资料来了，洛菲菲的补习课正式开始。\\n下午五点，补习老师已经离开了，洛菲菲的生日会即将开始。会上邀请的大都是菲菲的同学。\\n最早到达的是拓也，不像以往，他今天的牙齿难得没有沾着的奶酪。\\n他送给洛菲菲的生日礼物是一个和她等高的限量版hellokitty公仔，拓也左手拉着hellokitty公仔，然后一把抓住洛菲菲的手，开始炫耀自己如何费劲才能买到这个限量版hellokitty。洛菲菲一直努力保持微笑听着。\\n“菲菲！”这时候一个女孩的呼喊将洛菲菲从拓也接近15分钟的炫耀中拯救了出来。趁着拓也注意力转移松手之际，洛菲菲抽出手快步跑向呼唤她的那个穿着公主裙的女孩。\\n“小美！你可算来了！”洛菲菲拉住小美的双手开心地摇了起来。“来，我带你到处逛逛！”\\n接下来从室内小游戏到户外烧烤，洛菲菲都拉着小美一起，仿佛要告诉所有人小美就是她洛菲菲最好的朋友。拓也毫不掩饰自己的闷闷不乐，完全没有理睬那些喊了他好几次去打电玩的同学，只是气鼓鼓地将一块又一块小蛋糕塞进了嘴里。\\n晚宴前，洛菲菲将小美带到了母亲洛文姬的跟前，“妈妈，这是小美，是在之前的补习班里认识的好朋友！”\\n“菲菲妈妈好，我是小美，之前在补习班，就菲菲和我最好了，升学之后，我想和菲菲做同班同学，我已经和我父亲说了，他说像菲菲这么优秀的孩子，请务必要来八方中学面试一下呢。”小美手舞足蹈地扮演着父亲的语气。\\n“啊好难为情！我当时也没想到你的爸爸居然是那所八方中学的校董之一呢，妈妈你觉得？”洛菲菲看着喜出望外的母亲天真地问道。\\n晚上九点生日会完满结束，洛菲菲和父母一起满脸笑容地在大门口送别了最晚离开的拓也。",
    "resoundEventConfigDes_2006": "为了得到父母想要向自己隐瞒的信息，洛菲菲狡猾地在他们面前表现出低于实际的英语会话水平，让他们以为自己听不懂他们的英语对话。\\n今早不守时的补习老师很快就要被辞退了，毕竟最近洛菲菲的英语成绩不受控制地突然下滑。\\n洛菲菲一点都不难过，因为她不喜欢这个老师的课，古板又罗嗦，只会照本宣科。\\n今天她听到父母提到的学校简直正中她下怀，因为校服实在太好看了！之前在校外补习班遇到小美的时候，就觉得和她肯定能玩得来呢，没想到她还是校董的女儿，太巧了。不过要是去了那所学校，拓也可能也会跟着去。幸好小美对拓也的印象一般般，那后面这样就好了……\\n“嘻嘻，不用再和拓也做同学了！”\\n想着想着，洛菲菲露出了甜美的笑容，在宁静的夜晚迎来了她的11岁。\\n她梦见水晶、大海、月亮和流星……\\n即使感受到夜风吹拂着四肢，墨蓝色的云朵擦过脸庞，洛菲菲还以为自己在梦里……",
    "resoundEventConfigDes_2010": "巨兽看到埃癸斯，慢慢降落到他跟前，怔怔地走向他。\\n“大哥哥，这是哪里？”从巨兽口中传出来的竟然是清脆的童声。\\n马克透过巨兽的眼睛，看到了刚才那个小女孩正害怕地蜷缩在黑暗中，难道对方也能看到自己吗？\\n“大哥哥，救救我……”巨兽朝埃癸斯踏近了一步。\\n武器坟场中一直埋藏着某个不知名的远古族吗？埃癸斯不禁举起右臂的轻盾，做出防御的姿势。\\n“等等！她只是个孩子！”马克喊道。\\n“可是，我不知道和她合体的是谁，万一另一个意识做了主导者，对我们可能会很不利，对方的战斗力，很强！”是自己和古拉姆联手也未必能打败的角色。\\n“我、我来跟她解释！”\\n“……这种情况能一下子给孩子解释清楚吗？”\\n“嗯！让我来慢慢引导她！”\\n“……好，交给你。”\\n“小妹妹——”\\n话还没说出口，山体因堆积的武器滑落而塌陷，刚爬回来的三位不明情况的尸族，二话不说就向着巨兽背部出拳，这些突发的状况让浪潮般的恐惧涌至小女孩全身。\\n“不要！！！”\\n“杀……”\\n一把沙哑低沉的声音从巨兽的体内传出来，小女孩对这个世界排斥的尖叫唤醒了另一个一直沉睡的意识。\\n接下来一切都在极度的混乱中发生。\\n巨兽飞到武器坟场高空，他通红的双眸没有任何怀疑和迷茫，只是用单纯的杀气扫视武器坟场上的所有生物，仿佛在做最后的确认，随后纵身冲向目标——妄图控制巨兽的不朽木偶和尸王。\\n不但崖堑，连武器组成的山体也因巨兽对目标的出拳而开始解体，无数的武器不是四处弹飞，就是掉落到崖堑中，现在的武器坟场就像一垛松散的沙堆，随时会轰然倒塌。\\n蒙蒙黄沙中，那个巨大的身影忽隐忽现，不断撞击那些已经无法动弹的对手。\\n埃癸斯用轻盾挡住头顶，敏捷地跳落武器坟场，并在一片废墟中找回自己的其他圣盾。\\n“那个女孩还在上面！”马克心急如焚。\\n“我知道！等他停下攻击，再跟踪他！”\\n突然，一团火云浮于天际。\\n“那是……朱雀大人？！”\\n埃癸斯喜出望外，现在能让巨兽冷静下来的，只有神灵了。\\n朱雀绕着巨兽飞了一圈又一圈，试图传达些什么，然而一波又一波的冲击无声地回应着神灵，巨兽的拳头一次次地穿透无形的火焰，根本没有减缓的趋势。\\n攻击持续了没多久，武器坟场终于变成一片平缓的矮坡。尘埃落定，巨兽在上面缓缓地飞了一圈，朝东南方离去。\\n埃癸斯刚要追上去，一道明亮的火焰却挡在了他眼前，是朱雀。\\n“朱、朱雀大人？”\\n“那边不是你使命所在的方向。”\\n“但难道就这样扔下他不管吗？”\\n“……我会想办法的。”\\n“我要救她！”回答朱雀的是马克的意志，“我不能容许自己见死不救！”\\n“嗯！”埃癸斯毫不犹豫地站着马克这边。从这几场战斗来看，男孩非常适合成为自己的搭档。同样，这段时间的相处，似乎也让男孩对他产生了敬意。\\n“你们……你不是想尽快回到自己的世界吗？”朱雀对马克发问。\\n“……如果连我也会害怕，一个小女孩该如何独自面对这个世界？你会把一个小孩留在战场中吗？”\\n朱雀看着真·圣盾埃癸斯固执的表情，知道自己说什么也没用。\\n有一种英雄，即使肩负重任，也无法放着身边的人不管，他更想把整个世界都保护起来。\\n朱雀无奈地点点头。\\n埃癸斯跟着巨兽渐行渐远，消失在地平线上。过了许久，沙漠再次归于平静、空无一人。\\n武器坟场山脚一处侥幸没被战火波及的地方，史卡非斯在一堆废旧武器的掩护下探出身子，他在已成缓坡的坟场上找了许久，终于发现了那个散发着幽绿光芒的小盘子。\\n夹杂着黄沙的大风吹来久违的湿气，那是海水的味道，埃癸斯知道自己快要走出狂野沙漠了。遥远前方的巨兽看上去就像一个小黑点，埃癸斯不敢太靠近他。\\n一路上，他都回想着朱雀在临别前对他说的话。\\n“你们都听过武器坟场的传说吧，但是，它还有另一个不为人知的故事，因为太荒唐了，所以没有怪兽把这当一回事，久而久之就没有怪兽再提起了。”\\n“难道是和那个大块头有关的故事？”\\n“没错……在很久很久之前，超进化大陆曾发生过一场战争，一场死伤堪比邪王之战的战争。战争的原因我已经忘记了，大概是各族怪兽争夺生存空间和世界树这种理由。战争的结果可以说几败俱伤，勉强要说最后的胜利者，那就是远古族。\\n“远古族拥有一个必杀武器，他是一个为破坏而存在的怪兽，死在他手上的同族，一点也不比其他族少，不过，远古族还是用这种杀敌一千自损八百的方式取得胜利。\\n“战争结束后，想要继续杀戮的怪兽被远古族带到这片沙漠上，它以为可以再次大开杀戒，几位智者——噢，不是你们的智者，我说的是他们许多辈前的祖先——用催眠魔法让怪兽沉睡。\\n“等它睡着之后，数之不尽的武器倾倒在它身上。所谓的‘武器坟场’就这样诞生了，其他族都以为这是丢弃废旧武器的地方，远古族更对它里面的沉睡者缄口不提，因为谁也不想它再次醒来……”\\n“那只怪兽，叫什么名字？”\\n“真正的名字我忘了，当时好像大家都叫他最终兵器。是最后才使用的兵器，也是让一切的一切终结的兵器……”\\n原来远古族也有过这样一段不光彩的过去吗？\\n当埃癸斯陷入自责中的时候，朱雀再次提醒他。\\n“那只不过是武器坟场的另一个传说，不过，如果最终兵器真的是那场大战中的杀戮者，你们得当心，不要还没见到邪王之前就丢了性命。”\\n看着远方的背影，埃癸斯和马克不禁担忧起来，他们不惧强敌，却不懂如何在对方只由狂暴与杀意组成的意志中注入一丝理智。",
    "3_15": "联系客服",
    "3_16": "评价",
    "3_17": "官方贴吧",
    "3_18": "公告",
    "3_19": "引导",
    "3_10": "音效",
    "3_11": "音乐",
    "3_12": "关闭",
    "3_13": "开启",
    "3_14": "语言：{1}",
    "3_26": "请输入合法的帐号名称",
    "3_27": "帐号不存在",
    "3_28": "请求等待处理中",
    "3_29": "帐号已添加",
    "3_20": "兑换码",
    "3_21": "退出账号",
    "3_22": "服务器时间：{1}",
    "3_23": "版本：{1}",
    "3_24": "请求已发送！",
    "3_25": "不能添加自己",
    "3_37": "招募",
    "3_38": "助战怪兽",
    "3_39": "更改名称",
    "3_32": "删除",
    "3_33": "系统",
    "3_34": "组队",
    "3_35": "世界",
    "3_36": "部落",
    "3_48": "网络检测",
    "3_49": "问题反馈",
    "3_40": "添加好友成功",
    "3_41": "默认解锁",
    "3_42": "删除好友成功",
    "3_43": "请求发送成功",
    "3_44": "举报成功",
    "3_45": "今天领取友好点数已达上限",
    "3_46": "部落名称违规",
    "3_47": "隐私协议",
    "3_59": "正常",
    "3_51": "检测",
    "3_52": "网络可达性",
    "3_53": "远端配置",
    "3_54": "下载版本文件",
    "3_55": "尝试连接登录服",
    "3_56": "尝试连接{1}",
    "3_57": "本地网络",
    "3_58": "蜂窝移动网络",
    "3_50": "一键加群",
    "resoundEventMonumentName_11": "世界丰碑11",
    "resoundEventMonumentName_10": "世界丰碑10",
    "monsterPolarityConfigName_5": "脂肪缓冲",
    "monsterPolarityConfigName_4": "超速再生",
    "monsterPolarityConfigName_7": "真伤增幅",
    "monsterPolarityConfigName_6": "濒危异变",
    "monsterPolarityConfigName_1": "嗜血治疗",
    "monsterPolarityConfigName_3": "血沸猛击",
    "monsterPolarityConfigName_2": "狂热战魂",
    "3_62": "电信网络",
    "3_63": "联通网络",
    "3_64": "段位-{1}",
    "3_65": "未加入",
    "3_66": "是否举报该探索者？",
    "monsterPolarityConfigName_9": "霸气增压",
    "3_67": "漆黑之根等级",
    "monsterPolarityConfigName_8": "屏障增殖",
    "3_68": "浮空巨塔层数",
    "3_69": "领取成功",
    "resoundEventMonumentName_19": "世界丰碑19",
    "resoundEventMonumentName_18": "世界丰碑18",
    "resoundEventMonumentName_17": "世界丰碑17",
    "resoundEventMonumentName_16": "世界丰碑16",
    "resoundEventMonumentName_15": "世界丰碑15",
    "resoundEventMonumentName_14": "世界丰碑14",
    "3_60": "异常",
    "resoundEventMonumentName_13": "世界丰碑13",
    "3_61": "移动网络",
    "resoundEventMonumentName_12": "世界丰碑12",
    "resoundEventStoryName_600": "【00002】",
    "resoundEventStoryName_602": "【00004】",
    "resoundEventStoryName_601": "【00003】",
    "resoundEventStoryName_604": "【000000】",
    "resoundEventStoryName_603": "【00005】",
    "resoundEventStoryName_606": "【00007】",
    "resoundEventStoryName_605": "【00006】",
    "3_73": "一张突然会被神秘电波控制的小嘴",
    "3_74": "口述者",
    "3_75": "啊这个，我好像知道些什么，希望对您有帮助！",
    "3_76": "目前的我仍处在进化初期，甚至有些崩坏，所以很多问题都无法作答，骚瑞！但我知道有一些特别的探索者，他们对超进化大陆有着独到且深刻的理解，如果你恰巧就是那位探索者，欢迎投稿至「cjhwy2_gt@163.com」，助力崩坏的我进化成为懂王NPC！",
    "3_77": "前往活动",
    "3_78": "不在该部落无法跳转",
    "3_79": "该赛季已重置",
    "3_70": "这次我该如何称呼你",
    "97_comment": "智者",
    "3_71": "是否删除该好友？",
    "3_72": "崩坏的NPC",
    "resoundEventMonumentName_33": "世界丰碑33",
    "resoundEventStoryName_611": "大灵小灵",
    "resoundEventMonumentName_32": "世界丰碑32",
    "resoundEventStoryName_610": "爱的灵",
    "resoundEventMonumentName_31": "世界丰碑31",
    "resoundEventStoryName_613": "火神在上",
    "resoundEventMonumentName_30": "世界丰碑30",
    "resoundEventStoryName_612": "唯一之选",
    "resoundEventStoryName_615": "全职猎手",
    "resoundEventStoryName_614": "祖训",
    "resoundEventStoryName_617": "灰烬遗迹",
    "resoundEventStoryName_616": "怪兽猎手",
    "3_84": "登录时间",
    "3_85": "最近聊天",
    "3_86": "注销账号",
    "3_87": "是否确认注销账号？",
    "3_88": "<face color=#ffffff dilate=0.52 softness=0.07>如果您对游戏有任何建议或遇到问题，欢迎发送邮件至「cjhwy2_service@126.com」与我们联系！请特别注意，官方客服不会主动私信索取您的账号密码及个人信息，请提高警惕保护个人财产安全。\\n\\n<on click='copyText' param='#accountInfo#'><face color=#ff9900 dilate=0.55 softness=0.07><u>点击复制反馈信息</u></face></on></face>",
    "3_89": "※反馈邮箱\\ncjhwy2_service@126.com\\n\\n※账号信息\\n{1}\\n※游戏BUG反馈（适用于游戏内错误、异常情况）\\nBUG发生时间：\\nBUG详细描述：\\n重现步骤（若可重现请描述步骤）：\\n截图或视频（如有请附上）：\\n设备型号（选填）：\\n系统版本（选填）：\\n游戏版本（选填）：\\n网络环境（WiFi/4G/5G）（选填）：\\n\\n※意见反馈（适用于建议、玩法调整、体验优化）\\n意见或建议内容：\\n\\n※充值未到账反馈\\n充值时间：\\n充值內容：\\n交易订单截图（需包含完整订单号）：\\n问题描述：\\n截图（如有请附上）：\\n\\n※道具异常反馈（适用于道具异常消失、数量异常等问题）\\n异常发生时间：\\n异常道具名称及数量：\\n异常发生前后的操作步骤（请尽可能详细描述）：\\n异常发生场景：\\n是否尝试重启游戏或重新登录查看（如有，请说明结果）：\\n相关截图或视频（如有请附上）：\\n设备型号（选填）：\\n系统版本（选填）：\\n游戏版本（选填）：\\n网络环境（WiFi/4G/5G）（选填）：\\n\\n※游戏闪退反馈（适用于闪退、闪屏、游戏无法正常运行）\\n设备型号（品牌+型号，如iPhone 12）：\\n系统版本（可在“设置”中查看或截图，如Android 12）：\\n游戏版本（可点击游戏登录界面右上角复制）：\\n网络环境（WiFi/4G/5G）：\\n闪退前的操作步骤（请尽量描述闪退发生前的操作，如点击进入领地→点击造唤台→闪退）：\\n闪退的频率（如每进行两场战斗就闪退一次，玩半小时就闪退一次）：\\n闪退触发的情景（如战斗中、切换界面时、无特定规律等）：\\n能否稳定重现，若可以请描述详细步骤（如点击进入领地→点击造唤台→闪退）：\\n截图或视频（如有请附上）：\\n\\n请确保提供完整信息，以便技术团队快速定位问题，感谢您的反馈！",
    "resoundEventStoryName_608": "【00009】",
    "resoundEventStoryName_607": "【00008】",
    "resoundEventStoryName_609": "【00000】",
    "3_80": "目前的我仍处在进化初期，甚至有些崩坏，所以很多问题都无法作答，骚瑞！但我知道有一些特别的探索者，他们对超进化大陆有着独到且深刻的理解，如果你恰巧就是那位探索者，欢迎投稿，助力崩坏的我进化成为懂王NPC！",
    "3_81": "是否举报部落邮件？",
    "3_82": "聊天线路-{1}",
    "3_83": "已同意所有可添加的好友请求",
    "resoundEventMonumentName_22": "世界丰碑22",
    "resoundEventStoryName_622": "无佑离岛",
    "resoundEventMonumentName_21": "世界丰碑21",
    "resoundEventStoryName_621": "冰河空渊",
    "resoundEventMonumentName_20": "世界丰碑20",
    "resoundEventStoryName_624": "灰烬图腾",
    "resoundEventStoryName_623": "火神化身",
    "resoundEventStoryName_626": "先祖之口",
    "resoundEventStoryName_625": "先祖之面",
    "resoundEventStoryName_628": "水灵",
    "resoundEventStoryName_627": "骨灵",
    "resoundEventStoryName_620": "始原荒地",
    "resoundEventStoryName_619": "归灵秘境",
    "resoundEventMonumentName_29": "世界丰碑29",
    "resoundEventStoryName_618": "秘仪圣域",
    "resoundEventMonumentName_28": "世界丰碑28",
    "3_90": "更换语言",
    "resoundEventMonumentName_27": "世界丰碑27",
    "3_91": "点击加入",
    "resoundEventMonumentName_26": "世界丰碑26",
    "3_92": "点击申请加入联结共鸣",
    "resoundEventMonumentName_25": "世界丰碑25",
    "3_93": "恶意骚扰",
    "resoundEventMonumentName_24": "世界丰碑24",
    "resoundEventMonumentName_23": "世界丰碑23",
    "resoundEventStoryName_633": "驱寒神坛",
    "resoundEventStoryName_632": "果子前石",
    "resoundEventStoryName_635": "地狱弹幕",
    "resoundEventStoryName_634": "燃烧猎角",
    "resoundEventStoryName_637": "战略厨房",
    "resoundEventStoryName_636": "传奇恋爱",
    "resoundEventStoryName_639": "玩偶兵团",
    "resoundEventStoryName_638": "血丝诅咒",
    "resoundEventStoryName_631": "破碎图腾",
    "resoundEventStoryName_630": "猎神图腾",
    "resoundEventStoryName_629": "地灵",
    "resoundEventStoryName_644": "叉叉版件",
    "resoundEventStoryName_643": "超进化方块雨",
    "resoundEventStoryName_646": "小搜查",
    "resoundEventStoryName_645": "打地龙",
    "resoundEventStoryName_648": "水浦争夺战",
    "resoundEventStoryName_647": "诱惑",
    "resoundEventStoryName_649": "拼好图",
    "resoundEventStoryName_640": "无双之争",
    "resoundEventStoryName_642": "飞行镖",
    "resoundEventStoryName_641": "极限求生",
    "messageInitContent_1946": "越高级的食材，往往只需要最简单的烹饪方式",
    "resoundEventStoryName_655": "碰碰圈",
    "messageInitContent_1945": "这里周围到处都是熔岩，煮饭很方便呢",
    "resoundEventStoryName_654": "超赞几何",
    "mapNodeName_261": "破界沼地",
    "messageInitContent_1944": "竟然是如此朴实无华",
    "resoundEventStoryName_657": "玩物部件",
    "mapNodeName_260": "强者又云集",
    "messageInitContent_1943": "所以他们是在这里比试完厨艺吗剑盾。",
    "resoundEventStoryName_656": "任性的管",
    "messageInitContent_1942": "剑盾无双！",
    "resoundEventStoryName_659": "怪与地底穴",
    "messageInitContent_1941": "我宣布要在这关住下！",
    "resoundEventStoryName_658": "爪机库",
    "messageInitContent_1940": "大家都是剧王，为什么要互相伤害呢",
    "mapNodeName_267": "迷石丘陵",
    "mapNodeName_266": "破界沼地",
    "mapNodeName_269": "虚言葬地",
    "mapNodeName_268": "破界沼地",
    "mapNodeName_263": "金矿山",
    "resoundEventStoryName_651": "不许按！",
    "mapNodeName_262": "迷石丘陵",
    "messageInitContent_1949": "等我去熔炼个顶级元核再来",
    "resoundEventStoryName_650": "蹦蹦机",
    "mapNodeName_265": "破界沼地",
    "messageInitContent_1948": "玄机就是没有玄机！",
    "resoundEventStoryName_653": "空洞齿轮",
    "mapNodeName_264": "毁灭吧",
    "messageInitContent_1947": "总觉得暗藏危机",
    "resoundEventStoryName_652": "快乐补完",
    "mapNodeName_259": "凌云圣域",
    "tribeCampConfigDescription_4": "消除濒死状态所需钻石降低{?}%",
    "tribeCampConfigDescription_5": "部落可占领的遗迹个数增加至{?}个",
    "mapNodeName_270": "猎魂荒漠",
    "messageInitContent_1957": "留言板清道夫在此！",
    "messageInitContent_1956": "害怕召唤留言板清道夫",
    "mapNodeName_272": "一拳超度",
    "messageInitContent_1955": "是谁放大了！",
    "mapNodeName_271": "海上剧团",
    "messageInitContent_1954": "怎么有股味道",
    "messageInitContent_1953": "我也想要蓄力然后放大招",
    "messageInitContent_1952": "看到大师就有种要玩横板格斗的感觉",
    "messageInitContent_1951": "他们是掀这里的熔岩还不够粘稠是吧",
    "messageInitContent_1950": "没事直接打就行",
    "mapNodeName_278": "破界沼地",
    "messageInitContent_10190": "上面这条是桐仁给5毛刷的吗",
    "mapNodeName_277": "猎魂荒漠",
    "messageInitContent_10191": "无敌战锤",
    "messageInitContent_10192": "强的到底是谁",
    "mapNodeName_279": "猎魂荒漠",
    "messageInitContent_10193": "帮你做个技能检查",
    "mapNodeName_274": "妖藤遗迹",
    "mapNodeName_273": "凌云圣域",
    "mapNodeName_276": "凌云圣域",
    "messageInitContent_1959": "这就是通往最后一个探索点的关卡！",
    "mapNodeName_275": "背山面海",
    "messageInitContent_1958": "害怕我好像第一关就卡住了",
    "messageInitContent_10198": "主打一个随缘",
    "messageInitContent_10199": "等大家选完",
    "messageInitContent_10194": "看看你血条",
    "messageInitContent_10195": "希望大家蒙的都对",
    "messageInitContent_10196": "HP侦查中",
    "messageInitContent_10197": "身体检查中",
    "messageInitContent_1960": "听到了，那是谁的声音",
    "messageInitContent_1968": "麻麻说不可以随便喷人哦（咦我熟了",
    "messageInitContent_1967": "各位龙龙，请问你们的小金库在哪里呢？",
    "messageInitContent_1966": "我是不是接近龙的巢穴了。",
    "messageInitContent_1965": "我的怪兽成为了雷鸣的食粮，可恶",
    "messageInitContent_1964": "之前就是这样的呀",
    "messageInitContent_1963": "我看到我的怪兽跑去探索点了！！",
    "messageInitContent_1962": "奶妈何必难为奶妈",
    "messageInitContent_1961": "雷之呼吸！",
    "mapNodeName_245": "古记战役-踏入花丛",
    "mapNodeName_244": "破界沼地",
    "messageInitContent_10180": "近战确认",
    "mapNodeName_247": "用半寿换血量之眼",
    "messageInitContent_10181": "血量确认",
    "mapNodeName_246": "迷石丘陵",
    "messageInitContent_10182": "技能确认",
    "mapNodeName_241": "贪玩的赤虹",
    "mapNodeName_240": "四脚兽战团",
    "mapNodeName_243": "传教现场",
    "mapNodeName_242": "最终的波纹",
    "messageInitContent_1969": "我需要三条龙跟我去统一维斯特洛，谁来（啊我变灰了",
    "messageInitContent_10187": "想哈气",
    "messageInitContent_10188": "说答案吧，我在蹲",
    "messageInitContent_10189": "桐仁真帅？",
    "mapNodeName_238": "结晶海岸",
    "messageInitContent_10183": "太好了只有一个技能",
    "mapNodeName_237": "迷石丘陵",
    "messageInitContent_10184": "到底是哪边能赢呢，好难看出来哦",
    "messageInitContent_10185": "一样的袍子吗",
    "mapNodeName_239": "不要靠近",
    "messageInitContent_10186": "代入顽袍",
    "messageInitContent_1971": "是我这个驯龙高手出手的时……",
    "messageInitContent_1970": "龙龙，你们要讲礼貌，等他们说话再喷……",
    "98_-170002": "尚未设置主城节点",
    "messageInitContent_1979": "有没有一种可能那都是它的眼睛。",
    "98_-170001": "cjhwy2",
    "messageInitContent_1978": "所以它的眼睛到底在哪里，",
    "98_-170004": "对手不存在",
    "mapNodeName_250": "狂轰之渊",
    "messageInitContent_1977": "你们的要求很过分诶",
    "98_-170003": "尚未到斗技场对手刷新时间",
    "messageInitContent_1976": "它能不能在还有其他人之前在沼泽里先埋起来。",
    "messageInitContent_1975": "怎么就变成恐龙了",
    "messageInitContent_1974": "快点给恐龙加点艺术滤镜，能变成世界名画的那种",
    "messageInitContent_1973": "社恐龙：等他们都炸完，就可以安心了",
    "messageInitContent_1972": "先通关在说话。",
    "mapNodeName_256": "破界沼地",
    "tribeCampConfigDescription_2": "开启第{?}支部队位置",
    "98_-170009": "斗技场未解锁",
    "mapNodeName_255": "迷石丘陵",
    "tribeCampConfigDescription_3": "消除濒死状态所需时间降低{?}%",
    "mapNodeName_258": "迷石丘陵",
    "messageInitContent_10170": "金币猎手在此",
    "mapNodeName_257": "三串一",
    "messageInitContent_10171": "神奇的土地",
    "tribeCampConfigDescription_1": "派遣部队至我方部落占领的遗迹所需时间降低{?}%",
    "98_-170006": "Buff时间已达到上限",
    "mapNodeName_252": "破界沼地",
    "98_-170005": "斗技场挑战次数不足",
    "mapNodeName_251": "肉肉山",
    "98_-170008": "竞技场重置中",
    "mapNodeName_254": "临时厨房",
    "98_-170007": "每日可购买挑战次数已达到上限",
    "mapNodeName_253": "破界沼地",
    "messageInitContent_10176": "有点缺钱了，去打点工吧",
    "messageInitContent_10177": "有点困了，去high了",
    "messageInitContent_10178": "有点水了，确实",
    "messageInitContent_10179": "有点麻了，不至于",
    "mapNodeName_249": "霸之岛",
    "messageInitContent_10172": "这就是太古之地",
    "propConfigName_50001": "元核类型",
    "mapNodeName_248": "破界沼地",
    "messageInitContent_10173": "找个人和我双向狩猎好吗",
    "messageInitContent_10174": "什么鬼",
    "messageInitContent_10175": "有点缺爱了，去狩猎点吧",
    "messageInitContent_1982": "今夜月色真美。",
    "propConfigName_50005": "紫色元核",
    "messageInitContent_1981": "520！",
    "propConfigName_50004": "蓝色元核",
    "messageInitContent_1980": "阿姨洗铁路！！",
    "propConfigName_50003": "绿色元核",
    "propConfigName_50002": "白色元核",
    "propConfigName_50007": "红色元核",
    "propConfigName_50006": "橙色元核",
    "messageInitContent_1989": "我想知道它们的面包是从哪里掉出来的",
    "messageInitContent_1988": "r帝可能只是帮小面包擦脸",
    "messageInitContent_1987": "r帝把人家都挡住了！",
    "messageInitContent_1986": "凛冬散尽，星河长明。",
    "messageInitContent_1985": "你知道乌鸦为什么像写字台吗?",
    "messageInitContent_1984": "我想从你的窗子里看月亮。",
    "messageInitContent_1983": "你头发乱了哦",
    "messageInitContent_10160": "怎么跑去网球王子了",
    "messageInitContent_10165": "这一刻我是狩猎者",
    "messageInitContent_10166": "全职探索者",
    "messageInitContent_10167": "怪兽猎怪",
    "messageInitContent_10168": "夜了睡了",
    "messageInitContent_10161": "好像很厉害哦",
    "messageInitContent_10162": "狩猎冠军",
    "messageInitContent_10163": "什么销售冠军",
    "messageInitContent_10164": "我们是冠军",
    "godContractConfigDescription_8": "幻象释放死亡判决后，被动效果提升{?}%，持续{p1}秒",
    "messageInitContent_1993": "我也信了",
    "godContractConfigDescription_7": "幻象的死亡判决范围增大{?}%",
    "messageInitContent_1992": "我信了",
    "messageInitContent_1991": "然后打你们的时候丢出来！",
    "godContractConfigDescription_9": "幻象释放死亡判决后，被动效果提升{?}%，持续{p1}秒",
    "messageInitContent_1990": "它们平时就天天在身体里做面包",
    "godContractConfigDescription_4": "青龙释放巨龙再临后，所有己方怪兽忽视敌方伤害降低效果{?}%，持续{p1}秒",
    "messageInitContent_10169": "安安",
    "godContractConfigDescription_3": "玄武释放反伤结界后，所有己方怪兽血量回复效果提升{?}%，持续{p1}秒",
    "godContractConfigDescription_6": "天马释放旷野疾风后，所有己方怪兽移动速度提升{?}，持续{p1}秒",
    "godContractConfigDescription_5": "麒麟释放禁断魔咒后，所有敌方怪兽霸气降低{?}，持续{p1}秒",
    "messageInitContent_1999": "参考凶噬魔的舌头！",
    "messageInitContent_1998": "什么无限大？？？？",
    "messageInitContent_1997": "无限大！！！",
    "messageInitContent_1996": "夕阳无限好！",
    "messageInitContent_1995": "问大家要怎么夸无限",
    "messageInitContent_1994": "拥有了无限确实就拥有了无限吃货",
    "messageInitContent_10154": "要种一些猎物吗",
    "messageInitContent_10155": "猎神睡醒了吗",
    "messageInitContent_10156": "为啥总是等不到",
    "messageInitContent_10157": "切勿焦躁",
    "messageInitContent_10150": "这边看起来暖和很多",
    "messageInitContent_10151": "祈祷吧向狩猎之神",
    "messageInitContent_10152": "小心露出尾巴",
    "messageInitContent_10153": "小心你的影子",
    "messageInitContent_10158": "我还是去采野果吧",
    "messageInitContent_10159": "我就去采野菜了",
    "mapNodeName_281": "迷石领地",
    "mapNodeName_280": "你行你上",
    "mapNodeName_283": "开心喷个够",
    "mapNodeName_282": "海内存危险",
    "mapNodeName_289": "护花使者",
    "mapNodeName_288": "凌云圣域",
    "mapNodeName_285": "摄魂媚眼",
    "mapNodeName_284": "领域展开",
    "mapNodeName_287": "月色真美",
    "mapNodeName_286": "猎魂荒漠",
    "messageInitContent_10143": "包括神灵",
    "messageInitContent_10144": "包括弹幕",
    "messageInitContent_10145": "听说就是从这边被艾娜撞下去的",
    "messageInitContent_10146": "这里以前是和下面那个海岛一起的",
    "messageInitContent_10140": "当心结冰的湖面",
    "messageInitContent_10141": "留意周围的一切",
    "messageInitContent_10142": "留意周围的一切包括奖励",
    "messageInitContent_10147": "下面的兄弟你们还好吗",
    "messageInitContent_10148": "下面那个没沉也很神奇",
    "messageInitContent_10149": "还有幸存者哦",
    "mapNodeName_292": "妖藤遗迹",
    "mapNodeName_291": "猎魂荒漠",
    "mapNodeName_294": "猎魂荒漠",
    "mapNodeName_293": "星之影",
    "mapNodeName_290": "凌云圣域",
    "mapNodeName_299": "破界沼地",
    "mapNodeName_296": "凌云圣域",
    "mapNodeName_295": "猎魂荒漠",
    "mapNodeName_298": "凌云圣域",
    "mapNodeName_297": "吃货无限多",
    "messageInitContent_10132": "适可而止",
    "messageInitContent_10133": "制造踪迹",
    "messageInitContent_10134": "是时候更换猎场了",
    "messageInitContent_10135": "愿猎神祝福我的箭",
    "messageInitContent_10130": "武器是你的同伴",
    "messageInitContent_10131": "无需多言",
    "messageInitContent_10136": "不要玩弄猎物",
    "messageInitContent_10137": "天，又饿了",
    "messageInitContent_10138": "不要轻视任何异动",
    "messageInitContent_10139": "用猎物的气味掩盖自己",
    "98_-70008": "好友位置已达到上限",
    "98_-70009": "无法添加自己",
    "98_-70006": "太受欢迎了怎么办，好友已经满了！",
    "98_-70007": "对方估计是个网红，ta的好友列表已经到达上限，挤不进去了！",
    "messageInitContent_10121": "绝不近视",
    "messageInitContent_10122": "想要透视",
    "messageInitContent_10123": "目不斜视",
    "messageInitContent_10124": "通通无视",
    "messageInitContent_10120": "绝不轻视",
    "98_-70004": "好友赠送的资源领取次数已达到上限",
    "messageInitContent_10129": "这图新怪特多",
    "98_-70005": "好友请求已处理",
    "activityTemplateName_142": "一创到底·夏日作战",
    "98_-70002": "已向该好友赠送资源",
    "activityTemplateName_145": "月光漾",
    "98_-70003": "已领取该好友赠送的资源",
    "activityTemplateName_144": "夏日追想",
    "messageInitContent_10125": "就是说，如果整个岛都是猎手的话，猎物够嘛",
    "98_-70001": "好友聊天需要好友",
    "messageInitContent_10126": "隔壁一刻草也算",
    "messageInitContent_10127": "这里的猎手更像是守株待兔",
    "messageInitContent_10128": "所以隔壁那个岛没了",
    "98_-70019": "已上阵相同觉醒怪兽",
    "messageInitContent_10110": "这么巧你也是第一次",
    "messageInitContent_10111": "说啥呢",
    "messageInitContent_10112": "绝不可全靠经验",
    "messageInitContent_10113": "也不可没有经验",
    "activityTemplateName_158": "一创到底·轰爆一切",
    "activityTemplateName_154": "拾秋寻迹",
    "messageInitContent_10118": "别贪心",
    "messageInitContent_10119": "要贪婪",
    "98_-70013": "每日最多发起{1}次好友申请，请明天再发起申请",
    "activityTemplateName_156": "二周年",
    "98_-70014": "{1}后可再次刷新",
    "activityTemplateName_155": "一创到底·燃枫袭秋",
    "98_-70011": "好友请求已发送",
    "activityTemplateName_150": "桂香盈月",
    "messageInitContent_10114": "猎手初体验",
    "98_-70012": "该探索者好友申请数已满，请稍后再试",
    "messageInitContent_10115": "自然的声音能够隐藏你",
    "messageInitContent_10116": "饿了，就行动",
    "98_-70010": "对方已经是你的好友",
    "activityTemplateName_151": "燃云起",
    "messageInitContent_10117": "阴影中的眼睛很多",
    "messageInitContent_10100": "每一滴血都要有价值",
    "messageInitContent_10101": "能不能救救我的一次性捕手夹",
    "messageInitContent_10102": "能，多买几个",
    "messageInitContent_10107": "隐匿也没点",
    "messageInitContent_10108": "点啥了",
    "messageInitContent_10109": "怪兽交谈点了",
    "activityTemplateName_161": "派对点阵",
    "messageInitContent_10103": "用心感受",
    "messageInitContent_10104": "感谢狩猎之神的恩赐",
    "messageInitContent_10105": "别让恐惧支配你",
    "messageInitContent_10106": "惨了忘记点追踪技能",
    "godContractConfigDescription_2": "白虎释放破阵瞬杀后，所有己方怪兽真实伤害提升{?}%，持续{p1}秒",
    "godContractConfigDescription_1": "朱雀释放浴火重生后，所有己方怪兽生物屏障提升{?}%，持续{p1}秒",
    "mapNodeName_102": "微光之森",
    "mapNodeName_101": "瞬息草原",
    "mapNodeName_104": "微光之森",
    "mapNodeName_103": "瞬息草原",
    "mapNodeName_100": "珍宝永远快人一步",
    "activityTemplateName_107": "捣蛋糖画",
    "activityTemplateName_108": "周年庆",
    "activityTemplateName_102": "嬉游夜",
    "activityTemplateName_100": "鸣音回荡",
    "mapNodeName_113": "古记战役-可怕故事",
    "mapNodeName_112": "老坛肉饼",
    "mapNodeName_115": "结晶海岸",
    "mapNodeName_114": "***（数字）",
    "mapNodeName_111": "瞬息草原",
    "mapNodeName_110": "瞬息草原",
    "activityTemplateName_118": "一创到底·祈愿绽放",
    "mapNodeName_109": "发型不错",
    "activityTemplateName_114": "屯屯扑满",
    "mapNodeName_106": "海怪讨伐队",
    "mapNodeName_105": "打点观众回来",
    "activityTemplateName_116": "春祈至",
    "mapNodeName_108": "烤串批发",
    "mapNodeName_107": "瞬息草原",
    "activityTemplateName_112": "派对记号",
    "activityTemplateName_128": "千舸竞",
    "activityTemplateName_125": "一创到底·狂想舞台",
    "activityTemplateName_127": "游园畅玩",
    "activityTemplateName_121": "祈福金印",
    "activityTemplateName_122": "奇迹秀",
    "activityTemplateName_139": "夏日祭",
    "activityTemplateName_136": "一创到底·太古剧变",
    "activityTemplateName_138": "光明轨迹",
    "activityTemplateName_134": "部落格",
    "activityTemplateName_133": "粽夏夜梦",
    "randomEventDialogueGroupConfig_3.143": "说复读是本质",
    "randomEventDialogueGroupConfig_3.144": "无视它继续复读",
    "randomEventDialogueGroupConfig_3.145": "它挣扎了一会又缩在原地。",
    "randomEventDialogueGroupConfig_3.146": "再次把它堵嘴拿开问它",
    "randomEventDialogueGroupConfig_3.147": "离开",
    "randomEventDialogueGroupConfig_3.148": "它又开心地把你的问题复读了一次。",
    "randomEventDialogueGroupConfig_3.149": "塞回堵嘴",
    "randomEventDialogueGroupConfig_3.140": "离开",
    "randomEventDialogueGroupConfig_3.141": "你为什么要复读？",
    "randomEventDialogueGroupConfig_3.142": "说就算没有人回应也不会尴尬",
    "extensionTaskName_9": "凿星裂痕多人挑战通关{target}次",
    "extensionTaskName_8": "设置斗技场防守阵容{target}次",
    "extensionTaskName_7": "进行怪兽重置{target}次",
    "extensionTaskName_6": "进行怪兽饲星{target}次",
    "extensionTaskName_5": "星律收获{target}次",
    "extensionTaskName_4": "通关永生之茧“富有”关卡{target}次",
    "extensionTaskName_3": "拥有{target}只{conditionVal}阶或以上的神灵",
    "extensionTaskName_2": "拥有{target}只基因强化+{conditionVal}或以上的怪兽",
    "extensionTaskName_1": "拥有{target}个{conditionVal}级或以上的元核",
    "randomEventDialogueGroupConfig_3.154": "它猛地点了几次头。",
    "randomEventDialogueGroupConfig_3.155": "拿掉它的堵嘴等它回答",
    "randomEventDialogueGroupConfig_3.156": "它复读了半句你的话，又吞了回去。",
    "randomEventDialogueGroupConfig_3.157": "……其实是我自己把自己绑在这里的，这样就会有很多路过的怪兽来关心我了。",
    "randomEventDialogueGroupConfig_3.158": "跟它说那不是关心",
    "randomEventDialogueGroupConfig_3.159": "打它一拳",
    "randomEventDialogueGroupConfig_3.150": "离开",
    "randomEventDialogueGroupConfig_3.151": "它变得垂头丧气的样子。",
    "randomEventDialogueGroupConfig_3.152": "警告它不要复读并且好好回答",
    "randomEventDialogueGroupConfig_3.153": "离开",
    "randomEventDialogueGroupConfig_3.121": " 沉默离开",
    "randomEventDialogueGroupConfig_3.122": "它一气之下把什么东西丢在了地上，气冲冲地走了。",
    "randomEventDialogueGroupConfig_3.123": "捡起",
    "randomEventDialogueGroupConfig_3.124": "离开",
    "randomEventDialogueGroupConfig_3.125": "它似乎想起了什么，突然浑身一颤，被你吓跑了。",
    "randomEventDialogueGroupConfig_3.126": "离开",
    "randomEventDialogueGroupConfig_3.127": "它正要对你挥出拳头。",
    "randomEventDialogueGroupConfig_3.128": "迎战",
    "randomEventDialogueGroupConfig_3.120": "沉默驻足",
    "messageInitNick_1992": "安好勿扰",
    "messageInitNick_1993": "熬夜王",
    "messageInitNick_1990": "低调不失狂傲",
    "messageInitNick_1991": "大妹子",
    "messageInitNick_1996": "半傻半天真",
    "randomEventDialogueGroupConfig_3.129": "它完全没有要摊开手的意思。",
    "messageInitNick_1997": "做了世界之最",
    "messageInitNick_1994": "小天使降临",
    "messageInitNick_1995": "捕梦老阿姨",
    "messageInitNick_1998": "一罐可乐",
    "messageInitNick_1999": "尴尬笑场",
    "randomEventDialogueGroupConfig_3.132": "拿走离开",
    "randomEventDialogueGroupConfig_3.133": "它把东西丢给你之后就跑了。",
    "randomEventDialogueGroupConfig_3.134": "接住离开",
    "randomEventDialogueGroupConfig_3.135": "就是要左边的。",
    "randomEventDialogueGroupConfig_3.136": "它依旧没有要摊开手的意思。",
    "randomEventDialogueGroupConfig_3.137": "不再理睬它",
    "randomEventDialogueGroupConfig_3.138": "就是要左边的。就是要左边的。就是要左边的。就是要左边的。就是要左边的。就是要左边的。就是要左边的。",
    "randomEventDialogueGroupConfig_3.139": "它不断地重复着你刚刚的话，它的脸上泛起一股满足的红晕。",
    "randomEventDialogueGroupConfig_3.130": "说就是要左边的",
    "randomEventDialogueGroupConfig_3.131": "它伸出右手把东西塞到你手上。",
    "messageInitNick_1981": "老巷枯井",
    "messageInitNick_1982": "君安勿念",
    "messageInitNick_1980": "伤已成曲",
    "messageInitNick_1985": "东方战神",
    "messageInitNick_1986": "演绎未来",
    "messageInitNick_1983": "本宝宝驾到",
    "messageInitNick_1984": "编织感性",
    "messageInitNick_1989": "铛锂个铛",
    "messageInitNick_1987": "神一般的男人",
    "messageInitNick_1988": "小不点跑了",
    "randomEventDialogueGroupConfig_3.187": "它快步跟上了你。",
    "randomEventDialogueGroupConfig_3.188": "你怎么不理我，我是被讨厌了吗？",
    "randomEventDialogueGroupConfig_3.189": "用动作和它交流",
    "randomEventDialogueGroupConfig_3.180": "……我懂，我都懂。没事的兄弟，会好起来的，一切都会好起来的。",
    "randomEventDialogueGroupConfig_3.181": "拍一拍它的肩膀",
    "randomEventDialogueGroupConfig_3.182": "说谢谢",
    "randomEventDialogueGroupConfig_3.183": "它哭得更厉害了，哭着哭着就跑走了，有什么东西落在了地上。",
    "randomEventDialogueGroupConfig_3.184": "捡起来",
    "randomEventDialogueGroupConfig_3.185": "它复读着复读着，并没有跟过来的打算。",
    "randomEventDialogueGroupConfig_3.186": "离开",
    "messageInitNick_1970": "这格子封了",
    "messageInitNick_1971": "踏上光棍路",
    "messageInitNick_1974": "爱梦人",
    "messageInitNick_1975": "超级摸鱼神",
    "messageInitNick_1972": "落花缤纷下",
    "messageInitNick_1973": "控魂者",
    "messageInitNick_1978": "空气男神",
    "messageInitNick_1979": "不爱补刀的哥",
    "messageInitNick_1976": "请跟我恋爱",
    "messageInitNick_1977": "半调子少爷",
    "randomEventDialogueGroupConfig_3.198": "它跑掉了。",
    "randomEventDialogueGroupConfig_3.199": "离开",
    "messageInitNick_1969": "又逢花期",
    "randomEventDialogueGroupConfig_3.190": "加快脚步",
    "randomEventDialogueGroupConfig_3.191": "它跟了一段时间然后放弃了。",
    "randomEventDialogueGroupConfig_3.192": "离开",
    "randomEventDialogueGroupConfig_3.193": "它愣了一会，露出了一副败给你了的样子，默默离开了。",
    "randomEventDialogueGroupConfig_3.194": "离开",
    "randomEventDialogueGroupConfig_3.195": "哎被发现了，就正经做生意吧。要来看看嘛？",
    "randomEventDialogueGroupConfig_3.196": "进店",
    "randomEventDialogueGroupConfig_3.197": "离开",
    "messageInitNick_1960": "将光年压缩",
    "messageInitNick_1963": "画饼大师",
    "messageInitNick_1964": "缺钙又缺爱",
    "messageInitNick_1961": "爱笑的姑凉",
    "messageInitNick_1962": "草莓熟了",
    "messageInitNick_1967": "话里有糖",
    "messageInitNick_1968": "忙着长大",
    "messageInitNick_1965": "一瞬间的火花",
    "messageInitNick_1966": "爱玩之徒",
    "randomEventDialogueGroupConfig_3.165": "离开",
    "randomEventDialogueGroupConfig_3.166": "很显然地它复述了你的话。",
    "messageInitNick_1958": "能不能别掏",
    "randomEventDialogueGroupConfig_3.167": "问它你是不是有什么难处？",
    "messageInitNick_1959": "上好的拳头",
    "randomEventDialogueGroupConfig_3.168": "改口说我自由了！",
    "randomEventDialogueGroupConfig_3.169": "那些树藤像是刚从什么地方弄下来的，水分尚未流失。#它在你观察的时候又挣扎了几下。",
    "randomEventDialogueGroupConfig_3.160": "呜呜，人家跟你说真心话，你还打我。",
    "randomEventDialogueGroupConfig_3.161": "它甩开树藤哭着跑掉了。",
    "randomEventDialogueGroupConfig_3.162": "离开",
    "randomEventDialogueGroupConfig_3.163": "不是的，不是的，你骗我，你骗我，那就是关心，那就是！",
    "randomEventDialogueGroupConfig_3.164": "它的话里带着哭腔，随后扭过头跑掉了。",
    "messageInitNick_1952": "淡看尘世",
    "messageInitNick_1953": "绝版温柔",
    "messageInitNick_1950": "看悲伤的曲",
    "messageInitNick_1951": "静待花开",
    "messageInitNick_1956": "小倩不是鬼",
    "messageInitNick_1957": "比珍珠还真",
    "messageInitNick_1954": "灯下孤影",
    "messageInitNick_1955": "祝他考研上岸",
    "messageInitNick_1949": "萌量不足",
    "randomEventDialogueGroupConfig_3.176": "进店",
    "randomEventDialogueGroupConfig_3.177": "离开",
    "messageInitNick_1947": "喝水都壮",
    "randomEventDialogueGroupConfig_3.178": "它跑掉了。",
    "messageInitNick_1948": "没昵称",
    "randomEventDialogueGroupConfig_3.179": "离开",
    "randomEventDialogueGroupConfig_3.170": "继续观察",
    "randomEventDialogueGroupConfig_3.171": "离开",
    "randomEventDialogueGroupConfig_3.172": "你发现看起来像是树藤结的地方只是个装饰，其实只是靠它的尾巴固定在身上而已。",
    "randomEventDialogueGroupConfig_3.173": "拆穿它",
    "randomEventDialogueGroupConfig_3.174": "不管它离开",
    "randomEventDialogueGroupConfig_3.175": "哎被发现了，就正经做生意吧。要来看看嘛？",
    "messageInitNick_1941": "超萌少女",
    "messageInitNick_1942": "蒙的全对",
    "messageInitNick_1940": "我的千层套路",
    "messageInitNick_1945": "疯狂续杯",
    "messageInitNick_1946": "求败",
    "messageInitNick_1943": "尴尬对白",
    "messageInitNick_1944": "附属品",
    "messageInitNick_1938": "爱的警区",
    "messageInitNick_1939": "重新定义补刀",
    "messageInitNick_1936": "用生命在耍帅",
    "messageInitNick_1937": "暴走的小仙女",
    "channelName_29363": "NTFusion官网",
    "channelName_29362": "NTFusion官网",
    "messageInitNick_1930": "我叫你速动啊",
    "messageInitNick_1931": "在逃王子",
    "messageInitNick_1934": "我负责送你去",
    "channelName_2376": "荣耀商店",
    "messageInitNick_1935": "打的去埃及",
    "messageInitNick_1932": "黑羽医生",
    "messageInitNick_1933": "能不能先扶我",
    "messageInitNick_1927": "李商隐身",
    "messageInitNick_1928": "擦不掉的记忆",
    "messageInitNick_1925": "磁吸太后",
    "messageInitNick_1926": "划过的流星",
    "messageInitNick_1929": "绷带长颈鹿",
    "messageInitNick_1920": "你就知道吃",
    "messageInitNick_1923": "退役暴富选手",
    "messageInitNick_1924": "诺贝尔头铁奖",
    "messageInitNick_1921": "俯身摸狗",
    "messageInitNick_1922": "水泥地的爪印",
    "messageInitNick_1916": "不想喝海水",
    "messageInitNick_1917": "黑毛警长",
    "messageInitNick_1914": "繁华过后",
    "messageInitNick_1915": "富婆娶我",
    "messageInitNick_1918": "两禽相悦",
    "messageInitNick_1919": "咖啡加盐",
    "messageInitNick_1912": "浪漫野人",
    "messageInitNick_1913": "哭醒了睡不著",
    "messageInitNick_1910": "皓月当空",
    "messageInitNick_1911": "呆头鹅",
    "messageInitNick_1905": "不败恶魔",
    "messageInitNick_1906": "爱吃糖的喵",
    "messageInitNick_1903": "尘埃落不定",
    "messageInitNick_1904": "世纪末流行色",
    "messageInitNick_1909": "看有灰碟",
    "messageInitNick_1907": "皇家御姐",
    "messageInitNick_1908": "淡淡的温柔",
    "channelName_29371": "好游快爆",
    "channelName_29370": "NTFusion官网",
    "messageInitNick_1901": "口胡爽",
    "messageInitNick_1902": "迷幻键盘",
    "messageInitNick_1900": "冷血动物",
    "resoundEventConfigName_3": "第3章",
    "resoundEventConfigName_2": "第2章",
    "resoundEventConfigName_1": "第1章",
    "resoundEventStoryName_501": "肉食怪兽与草食怪兽",
    "resoundEventStoryName_500": "愿为你摘星",
    "resoundEventStoryName_503": "传说",
    "resoundEventStoryName_502": "训崽圣地",
    "resoundEventStoryName_505": "密欧子和朱丽美的日常（23）",
    "resoundEventStoryName_504": "密欧子和朱丽美的日常（22）",
    "resoundEventStoryName_507": "密欧子和朱丽美的日常（25）",
    "resoundEventStoryName_506": "密欧子和朱丽美的日常（24）",
    "resoundEventStoryName_512": "围猎",
    "resoundEventStoryName_511": "进化",
    "randomEventDialogueGroupConfig_3.200": "……我懂，我都懂。没事的兄弟，会好起来的，一切都会好起来的。",
    "resoundEventStoryName_514": "幸福",
    "randomEventDialogueGroupConfig_3.201": "拍一拍它的肩膀",
    "resoundEventStoryName_513": "反抗",
    "randomEventDialogueGroupConfig_3.202": "说谢谢",
    "resoundEventStoryName_516": "光带孢子藤",
    "resoundEventStoryName_515": "未名矿产",
    "resoundEventStoryName_518": "狂猎",
    "resoundEventStoryName_517": "电气区块",
    "resoundEventStoryName_510": "个性",
    "resoundEventStoryName_509": "是谁",
    "resoundEventStoryName_508": "威胁",
    "resoundEventStoryName_523": "招牌",
    "resoundEventStoryName_522": "全息留影",
    "resoundEventStoryName_525": "天池",
    "resoundEventStoryName_524": "生命可视化",
    "resoundEventStoryName_527": "潜入成功",
    "resoundEventStoryName_526": "地火",
    "resoundEventStoryName_529": "跳转",
    "resoundEventStoryName_528": "据点",
    "messageInitContent_10091": "遵循你的内心",
    "messageInitContent_10092": "所以到底是遵循内心还是直觉",
    "messageInitContent_10093": "愤怒绝不是你出手的理由",
    "resoundEventConfigName_9": "第9章",
    "messageInitContent_10094": "价格合理才是",
    "resoundEventConfigName_8": "第8章",
    "resoundEventConfigName_7": "第7章",
    "resoundEventConfigName_6": "第6章",
    "resoundEventConfigName_5": "第5章",
    "resoundEventStoryName_521": "为X",
    "messageInitContent_10090": "就你特别",
    "resoundEventConfigName_4": "第4章",
    "resoundEventStoryName_520": "挖矿怪兽的一天",
    "messageInitContent_10099": "我是急急怪兽",
    "messageInitContent_10095": "不急",
    "messageInitContent_10096": "很急",
    "messageInitContent_10097": "真不急吗",
    "messageInitContent_10098": "真很急吗",
    "resoundEventStoryName_519": "拼装巢穴笑话两则",
    "resoundEventStoryName_534": "震撼天地的爱情",
    "resoundEventStoryName_533": "同类",
    "mapNodeName_140": "草丛三姐妹",
    "resoundEventStoryName_536": "危险加大码",
    "resoundEventStoryName_535": "弱点极巨化",
    "resoundEventStoryName_538": "不只是大",
    "resoundEventStoryName_537": "无处可逃",
    "resoundEventStoryName_539": "一轴之大",
    "mapNodeName_146": "狂野幻境",
    "messageInitContent_10080": "越是危险越是冷静",
    "mapNodeName_145": "微光之森",
    "messageInitContent_10081": "越是害怕就越冷",
    "mapNodeName_148": "场地融合",
    "messageInitContent_10082": "请叫我等待先锋",
    "mapNodeName_147": "一骑当先",
    "messageInitContent_10083": "请叫我等等党",
    "mapNodeName_142": "结晶海岸",
    "resoundEventStoryName_530": "飞升之泉",
    "mapNodeName_141": "结晶海岸",
    "mapNodeName_144": "瞬息草原",
    "resoundEventStoryName_532": "延伸",
    "mapNodeName_143": "英雄有双",
    "resoundEventStoryName_531": "涂鸦",
    "messageInitContent_10088": "我宣布第一界怪兽溜冰大赛开始",
    "messageInitContent_10089": "人家那是花滑",
    "mapNodeName_139": "我将带头冲锋",
    "messageInitContent_10084": "懂得等待，就懂得了胜利",
    "mapNodeName_138": "结晶海岸",
    "messageInitContent_10085": "你也要成为金牌得主吗祈",
    "messageInitContent_10086": "大家好我叫开始祈，愿",
    "messageInitContent_10087": "这里够冷了，谢谢",
    "resoundEventStoryName_545": "崩坠之果",
    "resoundEventStoryName_544": "初尝美妙",
    "mapNodeName_151": "瞬息草原",
    "resoundEventStoryName_547": "第一次巨兽大战",
    "mapNodeName_150": "结晶海岸",
    "resoundEventStoryName_546": "巨兽体型研究",
    "resoundEventStoryName_549": "聚落的印记",
    "resoundEventStoryName_548": "第二次巨兽大战",
    "mapNodeName_157": "推推专家",
    "mapNodeName_156": "别想比蒙",
    "messageInitContent_10070": "你听到大地的呼吸吗",
    "mapNodeName_159": "狂野幻境",
    "messageInitContent_10071": "大地的呼吸不知道，隔壁的鼾声倒是很清楚",
    "mapNodeName_158": "狂野幻境",
    "messageInitContent_10072": "其实怪兽是怎么叫的",
    "mapNodeName_153": "过三关斩14将",
    "resoundEventStoryName_541": "崩坠之地",
    "mapNodeName_152": "究极出海",
    "resoundEventStoryName_540": "巨大的口味",
    "mapNodeName_155": "瞬息草原",
    "resoundEventStoryName_543": "第二夜",
    "mapNodeName_154": "微光之森",
    "resoundEventStoryName_542": "崩坠之柱",
    "messageInitContent_10077": "多吃饭多锻炼然后早睡",
    "messageInitContent_10078": "已经搞不清楚是谁猎谁了",
    "messageInitContent_10079": "我知道，它在猎杀我的时间",
    "messageInitContent_10073": "嗷嗷嗷嗷",
    "mapNodeName_149": "划船不靠桨",
    "messageInitContent_10074": "谢谢你",
    "messageInitContent_10075": "相信你的直觉",
    "messageInitContent_10076": "多思考再思考",
    "resoundEventStoryName_556": "巨大之外",
    "resoundEventStoryName_555": "流浪浮岛",
    "resoundEventStoryName_558": "沸湖所在",
    "resoundEventStoryName_557": "海中巨兽",
    "resoundEventStoryName_559": "绝赞消化中",
    "mapNodeName_124": "金矿山",
    "originRealmSeasonName_202503": "09",
    "mapNodeName_123": "狂野幻境",
    "originRealmSeasonName_202504": "10",
    "mapNodeName_126": "源初传送门I",
    "messageInitContent_10060": "这里的怪兽用捕兽夹的吗",
    "originRealmSeasonName_202505": "11",
    "resoundEventStoryName_550": "崩坠之柱底部一隅",
    "mapNodeName_125": "为你写诗",
    "messageInitContent_10061": "前排出售捕兽夹",
    "originRealmSeasonName_202506": "12",
    "mapNodeName_120": "瞬息草原",
    "resoundEventStoryName_552": "石之圆桌",
    "resoundEventStoryName_551": "巨大的延续",
    "mapNodeName_122": "咚！",
    "originRealmSeasonName_202501": "07",
    "resoundEventStoryName_554": "松弛感沸体",
    "mapNodeName_121": "瞬息草原",
    "originRealmSeasonName_202502": "08",
    "resoundEventStoryName_553": "巨大的植物",
    "messageInitContent_10066": "宁愿空手而归，也不要鲁莽而行",
    "messageInitContent_10067": "宁愿打不过也不想换阵容",
    "messageInitContent_10068": "睡一天就过了是吧",
    "messageInitContent_10069": "冲冲",
    "mapNodeName_117": "向我开炮！",
    "messageInitContent_10062": "高价收一只灾！当吉祥物",
    "originRealmSeasonName_202507": "13",
    "mapNodeName_116": "虎龙豹",
    "messageInitContent_10063": "前排出售鱼竿",
    "originRealmSeasonName_202508": "14",
    "mapNodeName_119": "转转转",
    "messageInitContent_10064": "多高",
    "originRealmSeasonName_202509": "15",
    "mapNodeName_118": "容易手伤的女人",
    "messageInitContent_10065": "这么冷的地真的有猎物的吗",
    "resoundEventStoryName_567": "不曾失落的记录",
    "resoundEventStoryName_566": "失落的记录：噬",
    "resoundEventStoryName_569": "幸运儿",
    "resoundEventStoryName_568": "梦之门",
    "mapNodeName_135": "源初集市I",
    "mapNodeName_134": "四神带一奶",
    "mapNodeName_137": "瞬息草原",
    "resoundEventStoryName_561": "失落的记录：惧",
    "mapNodeName_136": "冲呀",
    "messageInitContent_10050": "我的念已经……",
    "resoundEventStoryName_560": "失落的记录：逃",
    "96_tribeRank": "部落之王排行榜",
    "mapNodeName_131": "结晶海岸",
    "originRealmSeasonName_202510": "16",
    "resoundEventStoryName_563": "失落的记录：狱",
    "mapNodeName_130": "结晶海岸",
    "originRealmSeasonName_202511": "17",
    "resoundEventStoryName_562": "失落的记录：裂",
    "mapNodeName_133": "狂野幻境",
    "originRealmSeasonName_202512": "18",
    "resoundEventStoryName_565": "失落的记录：谁",
    "mapNodeName_132": "这是坑里吗？",
    "resoundEventStoryName_564": "失落的记录：埋",
    "messageInitContent_10055": "总觉得拿拿的画风很神奇在里面",
    "messageInitContent_10056": "其实超进化大陆有水果蔬菜的吗",
    "messageInitContent_10057": "貌似没有吃肉动物和吃草动物的样子",
    "messageInitContent_10058": "没说就是你猜",
    "mapNodeName_128": "瞬息草原",
    "messageInitContent_10051": "你好全职猎手",
    "mapNodeName_127": "结晶海岸",
    "messageInitContent_10052": "更新了吗",
    "messageInitContent_10053": "还没",
    "mapNodeName_129": "海怪侦察队",
    "messageInitContent_10054": "懂了我是全职高人",
    "messageInitContent_10059": "狩猎模式就是这样来的吗",
    "mapNodeName_182": "迷石丘陵",
    "resoundEventStoryName_578": "隧末",
    "mapNodeName_181": "结晶海岸",
    "resoundEventStoryName_577": "隧中",
    "mapNodeName_184": "结晶海岸",
    "mapNodeName_183": "遁海",
    "resoundEventStoryName_579": "游仪",
    "mapNodeName_180": "破界沼地",
    "resoundEventStoryName_570": "深海浅浅",
    "mapNodeName_189": "正在修炼静默友方",
    "resoundEventStoryName_572": "颤栗瑚珊",
    "resoundEventStoryName_571": "潜泳",
    "mapNodeName_186": "结晶海岸",
    "resoundEventStoryName_574": "两块腐石",
    "mapNodeName_185": "迷石丘陵",
    "resoundEventStoryName_573": "不动隧口",
    "mapNodeName_188": "源初集市II",
    "resoundEventStoryName_576": "遗落的时刻",
    "mapNodeName_187": "缥缈空庭",
    "resoundEventStoryName_575": "失落的时刻",
    "messageInitContent_10044": "休息是为了更好的工作",
    "messageInitContent_10045": "失败时要反思自己，而不是责怪猎物",
    "messageInitContent_10046": "好多猎手守则",
    "messageInitContent_10047": "猎手本能",
    "messageInitContent_10040": "已经不想吐槽了",
    "messageInitContent_10041": "止步是为了下一次更好的进攻",
    "messageInitContent_10042": "吃饭是为了更好的吃饭",
    "messageInitContent_10043": "睡觉是为了更好的做梦",
    "messageInitContent_10048": "观察比奔跑更能带来猎物",
    "messageInitContent_10049": "我更喜欢螳螂捕蝉黄雀在后",
    "mapNodeName_193": "咚咚咚咚咚",
    "resoundEventStoryName_589": "辅助之谜",
    "mapNodeName_192": "我的崩坏",
    "resoundEventStoryName_588": "赤色之谜",
    "mapNodeName_195": "薛定鳄的炮",
    "mapNodeName_194": "破界沼地",
    "mapNodeName_191": "齿轮废墟",
    "mapNodeName_190": "结晶海岸",
    "resoundEventStoryName_581": "家乡",
    "resoundEventStoryName_580": "异即常",
    "resoundEventStoryName_583": "巨鳍",
    "resoundEventStoryName_582": "寝宫",
    "mapNodeName_197": "迷石丘陵",
    "resoundEventStoryName_585": "悬空之谜",
    "mapNodeName_196": "开拓之门",
    "resoundEventStoryName_584": "无法瞑目",
    "mapNodeName_199": "破界沼地",
    "resoundEventStoryName_587": "四脚之谜",
    "mapNodeName_198": "迷石丘陵",
    "resoundEventStoryName_586": "龙族之谜",
    "messageInitContent_10033": "再说一遍不要啰嗦",
    "messageInitContent_10034": "一关打50次才过算不算耐心？",
    "messageInitContent_10035": "每一根箭矢都应带着尊重与感激发出",
    "messageInitContent_10036": "不要射出没有十足把握的箭",
    "messageInitContent_10030": "耐心！",
    "messageInitContent_10031": "再说一遍要耐心",
    "messageInitContent_10032": "非常有耐心",
    "messageInitContent_10037": "时不再来机不可失",
    "messageInitContent_10038": "让我先在地上打几个滚",
    "messageInitContent_10039": "嗯？",
    "mapNodeName_160": "放开那只呜呜祖拉",
    "resoundEventStoryName_599": "【00001】",
    "mapNodeName_162": "幻化与不朽",
    "mapNodeName_161": "海草打捞大队",
    "mapNodeName_168": "结晶海岸",
    "resoundEventStoryName_592": "虚诞",
    "mapNodeName_167": "带头对它用炎拳吧",
    "resoundEventStoryName_591": "不朽之谜",
    "resoundEventStoryName_594": "【瞳】",
    "mapNodeName_169": "迷石丘陵",
    "resoundEventStoryName_593": "瞳晶",
    "mapNodeName_164": "迷石丘陵",
    "resoundEventStoryName_596": "保育",
    "mapNodeName_163": "结晶海岸",
    "resoundEventStoryName_595": "深渊",
    "mapNodeName_166": "结晶海岸",
    "resoundEventStoryName_598": "视野",
    "mapNodeName_165": "古记战役-“小红帽”",
    "resoundEventStoryName_597": "怀疑",
    "messageInitContent_10022": "老人看手机.jpg",
    "messageInitContent_10023": "留意一下屠帝的刀",
    "messageInitContent_10024": "你又懂了",
    "messageInitContent_10025": "这区域的名字真的好随意",
    "messageInitContent_10020": "这边是烤香蕉吗哈哈",
    "resoundEventStoryName_590": "双族之谜",
    "messageInitContent_10021": "那个香蕉布又周边吗",
    "messageInitContent_10026": "原始怪兽的大脑",
    "messageInitContent_10027": "也可能是这里太冷了",
    "messageInitContent_10028": "又无限又这新玩意一起来是吧",
    "messageInitContent_10029": "好好好",
    "mapNodeName_171": "结晶海岸",
    "mapNodeName_170": "见到你很高兴",
    "mapNodeName_173": "结晶海岸",
    "mapNodeName_172": "极限4保1",
    "mapNodeName_179": "你是她乔装的吗",
    "mapNodeName_178": "大家都受伤的世界",
    "mapNodeName_175": "老司机带路",
    "mapNodeName_174": "结晶海岸",
    "mapNodeName_177": "直接裂开",
    "mapNodeName_176": "这温度合适吗？",
    "messageInitContent_10011": "肉肉山做错了什么",
    "messageInitContent_10012": "这是会掉复活甲的肉肉山吗",
    "messageInitContent_10013": "可以狩猎狩猎之神",
    "messageInitContent_10014": "先走一步吃肉噜",
    "messageInitContent_10010": "这么饿吗",
    "messageInitContent_10019": "我家猫在这方面就很厉害",
    "messageInitContent_10015": "注意感受",
    "messageInitContent_10016": "敬畏才能长存",
    "messageInitContent_10017": "猎物只信任安静的猎手",
    "messageInitContent_10018": "猎手X猎手",
    "22_2021": "剩余时间 {1}",
    "propConfigName_40011": "神性孢子",
    "22_2022": "日任务",
    "propConfigName_40010": "强化孢子",
    "22_2023": "总任务",
    "propConfigName_40013": "进击许可",
    "22_2024": "领取",
    "propConfigName_40012": "纠缠许可",
    "22_2020": "剩余",
    "propConfigName_40019": "极化石",
    "messageInitContent_6559": "综合来看，我选……",
    "propConfigName_40018": "领域石",
    "propConfigName_40015": "圣光许可",
    "propConfigName_40014": "天选许可",
    "propConfigName_40017": "部落资源",
    "propConfigName_40016": "搜索令",
    "messageInitContent_10484": "打的哪里呢",
    "messageInitContent_6563": "这不都压过去了",
    "messageInitContent_10485": "如果只看火力，那肯定是那边",
    "messageInitContent_6562": "月色真美",
    "messageInitContent_10486": "火力猛没有要打中才行",
    "messageInitContent_6565": "名字看晕了",
    "messageInitContent_10487": "你说的都对",
    "messageInitContent_6564": "什么花前月夕",
    "messageInitContent_10480": "一目了然",
    "messageInitContent_6567": "你好",
    "messageInitContent_10481": "中门对狙",
    "messageInitContent_6566": "四大天王",
    "24_comment": "浮空巨塔",
    "messageInitContent_10482": "我猜左边",
    "messageInitContent_6569": "唔？？？？？",
    "messageInitContent_10483": "我猜右边",
    "messageInitContent_6568": "有点热了",
    "22_2019": "前进",
    "messageInitContent_10488": "比后排",
    "22_2015": "重开",
    "messageInitContent_10489": "经典控制变量",
    "22_2016": "结算",
    "messageInitContent_6561": "什么恋爱小剧场",
    "messageInitContent_6560": "霸气!",
    "22_2032": "赛季累计",
    "propConfigName_40022": "原石",
    "22_2033": "本日最高",
    "propConfigName_40021": "粉尘",
    "22_2034": "胜",
    "propConfigName_40024": "骨",
    "22_2035": "败",
    "propConfigName_40023": "移动力药水",
    "22_2030": "赛季排名",
    "propConfigName_40020": "性格点数",
    "22_2031": "胜场记录",
    "propConfigName_40029": "谜之物质",
    "propConfigName_40026": "鳞",
    "propConfigName_40025": "木",
    "propConfigName_40028": "斗技场勋章",
    "propConfigName_40027": "战纹碎片",
    "messageInitContent_10473": "脑内模拟中",
    "messageInitContent_6574": "剑吧",
    "messageInitContent_10474": "强的到底是谁",
    "messageInitContent_6573": "月夕硬控我",
    "messageInitContent_10475": "老奶奶看手机",
    "messageInitContent_6576": "官配？",
    "messageInitContent_10476": "毁灭吧",
    "messageInitContent_6575": "奖励自己乱猜一次",
    "messageInitContent_6578": "这cp我不嗑",
    "messageInitContent_10470": "收工",
    "messageInitContent_6577": "我又来啦",
    "messageInitContent_10471": "瞎猜",
    "messageInitContent_10472": "发女装可得答案",
    "messageInitContent_6579": "猜对day1",
    "22_2025": "去完成",
    "messageInitContent_10477": "你干嘛~~~",
    "messageInitContent_6570": "这emmmmm",
    "22_2026": "活动",
    "messageInitContent_10478": "我啥都没做",
    "22_2027": "我的探索度",
    "messageInitContent_10479": "对对，这对嘛",
    "messageInitContent_6572": "都是远古啊",
    "22_2028": "全服累计贡献",
    "messageInitContent_6571": "不要再打啦不要再打啦",
    "22_2043": "竞猜",
    "propConfigName_40033": "部落币",
    "22_2044": "已竞猜",
    "propConfigName_40032": "起源勋章",
    "22_2045": "留言",
    "propConfigName_40035": "回响经验",
    "22_2046": "记录",
    "propConfigName_40034": "战令",
    "22_2040": "立即结算",
    "22_2041": "本日可选怪兽",
    "propConfigName_40031": "探索点",
    "22_2042": "挑战",
    "propConfigName_40030": "漆黑源",
    "propConfigName_40037": "祖龙族幻化怪兽",
    "propConfigName_40036": "祖龙族幼体怪兽",
    "propConfigName_40039": "祖龙族不朽怪兽",
    "propConfigName_40038": "祖龙族究极怪兽",
    "messageInitContent_10462": "我永远喜欢步兵",
    "messageInitContent_6585": "懂了是恋爱喜剧",
    "messageInitContent_10463": "救命",
    "messageInitContent_6584": "笑死",
    "messageInitContent_10464": "来人拖走",
    "messageInitContent_6587": "呼",
    "messageInitContent_10465": "有一个大胆的想法",
    "messageInitContent_6586": "我猜远古族赢",
    "messageInitContent_6589": "唯有猜",
    "messageInitContent_6588": "且看且菜",
    "messageInitContent_10460": "冲冲冲、冲鸭",
    "messageInitContent_10461": "冲冲冲冲冲冲冲冲冲冲冲冲",
    "17_totemBuffDesc10": "神灵能量回复速度提升{1}%",
    "22_2036": "赛季单次最高胜场记录",
    "messageInitContent_10466": "正在猜",
    "messageInitContent_6581": "女人什么的只会影响我剑的出剑速度",
    "22_2037": "{1}开启",
    "messageInitContent_10467": "技能知道答案",
    "messageInitContent_6580": "选了",
    "22_2038": "排阵",
    "messageInitContent_10468": "猜对明天加鸡腿",
    "messageInitContent_6583": "赢的是这边",
    "22_2039": "匹配",
    "messageInitContent_10469": "技能不知道",
    "messageInitContent_6582": "怎么选",
    "propConfigName_40044": "星灵族幼体怪兽",
    "22_2055": "分享",
    "propConfigName_40043": "尸鬼族不朽怪兽",
    "22_2056": "该渠道不支持二维码下载",
    "propConfigName_40046": "星灵族究极怪兽",
    "propConfigName_40045": "星灵族幻化怪兽",
    "22_2050": "万象礼遇",
    "propConfigName_40040": "尸鬼族幼体怪兽",
    "22_2051": "请输入邀请码",
    "22_2052": "商店",
    "propConfigName_40042": "尸鬼族究极怪兽",
    "22_2053": "降临礼遇",
    "propConfigName_40041": "尸鬼族幻化怪兽",
    "propConfigName_40048": "木偶族幼体怪兽",
    "propConfigName_40047": "星灵族不朽怪兽",
    "propConfigName_40049": "木偶族幻化怪兽",
    "messageInitContent_10451": "什么哪种",
    "messageInitContent_6596": "日月合璧",
    "messageInitContent_10452": "你们在说什么我怎么听不懂",
    "messageInitContent_6595": "日月经天",
    "messageInitContent_10453": "兵来技能档",
    "messageInitContent_6598": "姐妹齐心其利断金",
    "messageInitContent_10454": "4打5哦",
    "messageInitContent_6597": "慕了",
    "messageInitContent_6599": "懂了",
    "messageInitContent_10450": "你喜欢哪种",
    "godConfigDescription_4": "攻击型神灵——青龙，拥有能极大增幅怪兽力量的神力。它的降临让怪兽得到一次次短暂的爆发，更让怪兽看到了自身的无限可能。随着MM豆的急剧减产，“集齐7颗MM豆青龙便会出现”逐渐变成了坊间传言。客串演出“竜が我がの敵を喰らう”后，青龙决定也为自己加了句台词，“你被强化了，快送！”。",
    "messageInitContent_10459": "只有1个技能",
    "godConfigDescription_3": "防御型神灵——玄武，很多怪兽认为它只是一只刀枪不入的龟蛇，它也的确是一只刀枪不入的龟蛇。据不完全统计，倒在玄武反弹结界前的怪兽约有10086*365*5只，其中半数表示不服，剩下半数进行了水平翻转。",
    "godConfigDescription_2": "刺杀型神灵——白虎，视补刀、收头为自己的终身事业，练就了无弹能及的精确制导能力，拥有“超进化大陆洲际巡航导弹”的美称，曾与天火卡尔大战数百回合不落下风。",
    "messageInitContent_6590": "实名羡慕",
    "godConfigDescription_1": "辅助型神灵——朱雀，它最初是一只火鸡，梦想飞越整个超进化星，凭借着自身强大的意志力，它耗尽了生命来到了大陆的尽头，意识到路途的终点恰恰就是起点，领悟到了生死的秘密，以及超进化星是圆的事实。最终还发现自己的生母不是火鸡，而是朱雀，它生了它自己……",
    "22_2047": "剩余时间",
    "messageInitContent_10455": "求当前地形",
    "messageInitContent_6592": "让我来！",
    "22_2048": "日期",
    "godConfigDescription_7": "强攻型神灵——幻象，森罗万象，大象无形，幻象乃死亡之象，谁都无法逃离它的裁决。它有着黄金之脚，却拒绝了无数球队给它抛出的橄榄枝，包括它心爱的球队，它捻动念珠计算着年岁，决心用不灭的一生待其夺冠。",
    "messageInitContent_10456": "大脑运转中",
    "messageInitContent_6591": "盾让让",
    "22_2049": "智者礼遇",
    "godConfigDescription_6": "增益型神灵——天马，它扇动双翼，扬起旷野疾风将“更快、更高、更强”的精神能量传递出去。在东海王国锻炼流星拳时，意外对赛马运动产生了浓厚的兴趣，最大的愿望是和东海の帝皇一起奔跑在蓝天之下。",
    "messageInitContent_10457": "算一下频率",
    "messageInitContent_6594": "如月之恒，如日之升。如南山之寿，不骞不崩",
    "godConfigDescription_5": "战略型神灵——麒麟，学识渊博，上知天文地理，下通数理化生，卢氏梁山好汉、梅氏琅琊才子、姜氏三国俊杰、张氏盗墓狂人，均为麒麟之后裔。一般怪兽面对麒麟，通常只有沉默的份。",
    "messageInitContent_10458": "最喜欢看原生怪打架了",
    "messageInitContent_6593": "日月入怀",
    "propConfigName_40055": "原生族不朽怪兽",
    "propConfigName_40054": "原生族究极怪兽",
    "propConfigName_40057": "祖龙族觉醒怪兽",
    "propConfigName_40056": "原生族觉醒怪兽",
    "propConfigName_40051": "木偶族不朽怪兽",
    "propConfigName_40050": "木偶族究极怪兽",
    "propConfigName_40053": "原生族幻化怪兽",
    "propConfigName_40052": "原生族幼体怪兽",
    "propConfigName_40059": "星灵族觉醒怪兽",
    "propConfigName_40058": "尸鬼族觉醒怪兽",
    "messageInitContent_10440": "我选后面",
    "messageInitContent_10441": "反正是怪兽赢了",
    "messageInitContent_10442": "到底是哪边能赢呢，好难看出来哦",
    "messageInitContent_10443": "希望大家蒙的都对",
    "messageInitContent_10448": "醒醒别做梦",
    "messageInitContent_10449": "五行缺答案",
    "propConfigName_40060": "木偶族觉醒怪兽",
    "messageInitContent_10444": "我梦到了是右边赢",
    "messageInitContent_10445": "选择困难症怎么办",
    "messageInitContent_10446": "瞎选",
    "messageInitContent_10447": "我全都选",
    "propConfigName_40066": "究极怪兽",
    "propConfigName_40065": "幻化怪兽",
    "propConfigName_40068": "单种族觉醒怪兽",
    "propConfigName_40067": "不朽怪兽",
    "propConfigName_40062": "尖刺",
    "propConfigName_40061": "魔典",
    "propConfigName_40064": "幼体怪兽",
    "propConfigName_40063": "捕兽夹",
    "propConfigName_40069": "双种族觉醒怪兽",
    "messageInitContent_10430": "量子波动选择法",
    "messageInitContent_10431": "预言一下赢的是这边",
    "messageInitContent_10432": "肯定是那边",
    "messageInitContent_10437": "让我康康",
    "messageInitContent_10438": "对吗？不对吧",
    "messageInitContent_10439": "我选前面",
    "propConfigName_40071": "友好点数",
    "propConfigName_40070": "瞬破石",
    "messageInitContent_10433": "难顶",
    "messageInitContent_10434": "咋选",
    "messageInitContent_10435": "给个机会",
    "messageInitContent_10436": "一眼",
    "propConfigName_40077": "随机觉醒结晶（父或母含木偶族）",
    "propConfigName_40076": "随机觉醒结晶（父或母含星灵族）",
    "22_2001": "原始",
    "propConfigName_40079": "超跃次数",
    "22_2002": "超阶",
    "propConfigName_40078": "领域副本次数",
    "messageInitContent_10419": "看看孩子",
    "propConfigName_40073": "随机觉醒结晶",
    "propConfigName_40072": "狩猎勋章",
    "propConfigName_40075": "随机觉醒结晶（父或母含尸鬼族）",
    "propConfigName_40074": "随机觉醒结晶（父或母含祖龙族）",
    "messageInitContent_10420": "全场加起来6个技能",
    "messageInitContent_10421": "以多打少",
    "themeCardPackStoryId_405": "VV-001",
    "messageInitContent_10426": "喂策划吗？",
    "propConfigName_40080": "世界灾厄排行奖励次数",
    "messageInitContent_10427": "公主在哪里，御空又在哪里",
    "messageInitContent_10428": "财宝又在哪里",
    "propConfigName_40082": "浮空羽毛",
    "messageInitContent_10429": "闯龙窝了吧",
    "propConfigName_40081": "好友请求次数",
    "messageInitContent_10422": "以大欺小",
    "messageInitContent_10423": "青铜五小强又出去乱逛啦",
    "messageInitContent_10424": "都逛到龙穴了",
    "messageInitContent_10425": "这不是同等级的吗",
    "themeCardPackStoryId_400": "MU-008",
    "22_2010": "排行榜",
    "propConfigName_40088": "凿星钥匙",
    "22_2011": "得分",
    "propConfigName_40087": "部落-遗迹功勋",
    "22_2012": "今日最高",
    "propConfigName_40089": "幼体怪兽碎片",
    "messageInitContent_10408": "奇怪的组合",
    "propConfigName_40084": "背包上限",
    "messageInitContent_10409": "真想亲死你！",
    "propConfigName_40083": "好友上限",
    "propConfigName_40086": "部落繁荣度",
    "propConfigName_40085": "冒险符文",
    "messageInitContent_10410": "正在猜",
    "22_2007": "解锁",
    "messageInitContent_10415": "她没有",
    "propConfigName_40091": "究极怪兽碎片",
    "22_2008": "已解锁",
    "messageInitContent_10416": "未尝一对",
    "propConfigName_40090": "幻化怪兽碎片",
    "22_2009": "小游戏",
    "messageInitContent_10417": "表白污妖王！",
    "propConfigName_40093": "单种族觉醒怪兽碎片",
    "messageInitContent_10418": "污污污污污污污污污",
    "propConfigName_40092": "不朽怪兽碎片",
    "themeCardPackStoryId_415": "VV-003",
    "22_2003": "一键领取",
    "messageInitContent_10411": "猜对day0",
    "22_2004": "探索度",
    "messageInitContent_10412": "赢的会是？",
    "22_2005": "奖励列表",
    "messageInitContent_10413": "说答案吧，我在蹲",
    "themeCardPackStoryId_410": "VV-002",
    "22_2006": "解锁全部进度最终可获得",
    "messageInitContent_10414": "御空说爱我",
    "propConfigName_40099": "彩钻",
    "propConfigName_40098": "狩猎积分",
    "propConfigName_40095": "造唤积分",
    "propConfigName_40094": "双种族觉醒怪兽碎片",
    "propConfigName_40097": "战鼓",
    "propConfigName_40096": "造唤许可",
    "messageInitContent_10404": "HP侦查中",
    "messageInitContent_10405": "人越多人越少",
    "messageInitContent_10406": "KB侠输入中",
    "messageInitContent_10407": "KB侠输出中",
    "messageInitContent_10400": "康康你们啥体力",
    "messageInitContent_10401": "希望大家蒙的都对",
    "messageInitContent_10402": "实名羡慕",
    "messageInitContent_10403": "帮你们做个身体检查",
    "hyperEvolutionDesc_1": "血量回复效果+{p1}%，回复血量时额外获得最大血量×{p2}%的护盾，冷却{p3}秒",
    "hyperEvolutionDesc_2": "能量回复效果+{p1}%，消耗能量发动技能时如果被封印，回复{p2}能量，冷却{p3}秒",
    "hyperEvolutionDesc_3": "增益效果持续时间+{p1}%，拥有增益效果时受到伤害降低{p2}%",
    "hyperEvolutionDesc_4": "负面效果持续时间-{p1}%，拥有负面效果时受到伤害降低{p2}%",
    "messageInitContent_6501": "经典看技能",
    "messageInitContent_6500": "吼！",
    "messageInitContent_6503": "这次能横扫一切吗",
    "messageInitContent_6502": "斧子会吸血啊",
    "messageInitContent_6505": "喵huh？",
    "messageInitContent_6504": "叉会腰",
    "messageInitContent_6507": "还行",
    "messageInitContent_6506": "开始混乱",
    "messageInitContent_6509": "来啊，有本事告诉我答案啊",
    "messageInitContent_6508": "发生什么了！",
    "messageInitContent_6510": "叉会腰",
    "messageInitContent_6512": "大混战",
    "messageInitContent_6511": "难顶",
    "messageInitContent_6514": "本是同根生",
    "messageInitContent_6513": "让我再对一次吧",
    "messageInitContent_6516": "心疼斧子1秒",
    "messageInitContent_6515": "其他怪兽呢",
    "messageInitContent_6518": "感觉回不上来",
    "messageInitContent_6517": "猜对day0",
    "messageInitContent_6519": "下次该种族专场了？",
    "messageInitContent_6521": "真嘟假嘟",
    "messageInitContent_6520": "想要美女怪兽专场",
    "messageInitContent_6523": "欧啦欧啦欧拉欧啦欧啦欧拉",
    "messageInitContent_6522": "选择困难",
    "messageInitContent_6525": "我猜远古族赢",
    "messageInitContent_6524": "对对对",
    "messageInitContent_6527": "两把力量惊人的大斧",
    "messageInitContent_6526": "叠叠叠叠",
    "messageInitContent_6529": "我比五剑多一斧",
    "messageInitContent_6528": "这都能比",
    "messageInitContent_6530": "哈哈哈哈哈哈啊哈哈哈",
    "messageInitContent_6532": "才知道又那么多把剑",
    "messageInitContent_6531": "别整",
    "messageInitContent_6534": "手中无剑心中有剑",
    "messageInitNick_6298": "天堂汉堡",
    "messageInitContent_6533": "剑的输出更高吧",
    "messageInitNick_6299": "顶级中继器",
    "messageInitContent_6536": "这技能我熟",
    "messageInitContent_6535": "笑死",
    "messageInitContent_6538": "官配？",
    "messageInitNick_6294": "到碗里来",
    "messageInitContent_6537": "给个机会",
    "messageInitNick_6295": "搞掂批发",
    "messageInitNick_6296": "泡了对面下路",
    "messageInitContent_6539": "让我看看",
    "messageInitNick_6297": "尴尬对白",
    "messageInitNick_6290": "菜鸟都疯狂",
    "messageInitNick_6291": "本小姐不太冷",
    "messageInitNick_6292": "尖叫蒜",
    "messageInitNick_6293": "看我眼色行事",
    "messageInitContent_6541": "剑会不会打到自己",
    "messageInitContent_6540": "总有一个是错的",
    "messageInitContent_6543": "不准打自己啊",
    "messageInitContent_6542": "斧子到处找人打架",
    "messageInitContent_6545": "我的大斧子",
    "messageInitNick_6287": "甘甜的榨菜果",
    "messageInitContent_6544": "啊这",
    "messageInitNick_6288": "触不到的天堂",
    "messageInitContent_6547": "摸鱼time",
    "messageInitNick_6289": "不准嚣张",
    "messageInitContent_6546": "猜对day1",
    "mapEffectConfigDes_6": "每{p1}秒血量最多的怪兽移动速度变为0，持续{p2}秒",
    "mapEffectConfigDes_4": "{p1}秒后进入炼狱模式",
    "mapEffectConfigDes_5": "战墙每秒往中心移动{p1}码，最多移动{p2}码",
    "messageInitContent_6549": "早上好下午好晚上好",
    "messageInitNick_6283": "流浪的编辑",
    "messageInitContent_6548": "我猜左边",
    "messageInitNick_6284": "橘子风车",
    "messageInitNick_6285": "梨之心",
    "messageInitNick_6286": "青苔入镜",
    "mapEffectConfigDes_2": "所有怪兽的移动速度降低{p1}%",
    "mapEffectConfigDes_3": "所有怪兽的霸气降低{p1}%",
    "messageInitNick_6280": "大猪头",
    "messageInitNick_6281": "如此可爱",
    "mapEffectConfigDes_1": "所有怪兽血量回复效果降低{p1}%",
    "messageInitNick_6282": "你别急我先急",
    "messageInitContent_6552": "我猜右边",
    "messageInitContent_6551": "问题不大",
    "messageInitContent_6554": "给大家表演一个跑斧头",
    "messageInitContent_6553": "你猜呢",
    "messageInitContent_6556": "给大家表演一个舞剑",
    "messageInitNick_6276": "骨头汤",
    "messageInitContent_6555": "秒懂",
    "messageInitNick_6277": "在线对我隐身",
    "messageInitContent_6558": "远古搭配打架不累",
    "messageInitNick_6278": "四川火锅",
    "messageInitContent_6557": "天",
    "messageInitNick_6279": "现在是五点",
    "messageInitContent_6550": "预言一下赢的是这边",
    "themeCardPackStoryId_385": "MU-005",
    "themeCardPackStoryId_380": "MU-004",
    "messageInitNick_6272": "帮柚子按摩",
    "messageInitNick_6273": "北极猪",
    "messageInitNick_6274": "安静别说话",
    "messageInitNick_6275": "两面包夹执事",
    "messageInitNick_6270": "奔跑吧孩子",
    "messageInitNick_6271": "卖萌小能手",
    "messageInitNick_6269": "猪肉荣",
    "messageInitNick_6265": "不要站在左边",
    "messageInitNick_6266": "奇迹在发生",
    "messageInitNick_6267": "茄子撞地球",
    "messageInitNick_6268": "阿三",
    "themeCardPackStoryId_395": "MU-007",
    "themeCardPackStoryId_390": "MU-006",
    "messageInitNick_6261": "营养很足",
    "messageInitNick_6262": "流放者",
    "messageInitNick_6263": "我的出场费呢",
    "messageInitNick_6264": "北巷孤猫",
    "messageInitNick_6260": "风行九天",
    "messageInitNick_6258": "岁月静好",
    "messageInitNick_6259": "不要你喜欢",
    "messageInitNick_6254": "说得真好",
    "messageInitNick_6255": "我粉丝特多",
    "messageInitNick_6256": "盖世傻白甜",
    "messageInitNick_6257": "爱入伙",
    "messageInitNick_6250": "尖叫橙子",
    "messageInitNick_6251": "啊对对对",
    "messageInitNick_6252": "柠檬消灭者",
    "messageInitNick_6253": "凉茶制作者",
    "messageInitNick_6247": "飞翔的青蛙",
    "messageInitNick_6248": "全息雾霾",
    "messageInitNick_6249": "超级恰饭神",
    "messageInitNick_6243": "附送成长",
    "messageInitNick_6244": "等离子激光笔",
    "messageInitNick_6245": "声优都是怪物",
    "messageInitNick_6246": "什么是艺术",
    "messageInitNick_6240": "第七女巫",
    "messageInitNick_6241": "上午十一点半",
    "messageInitNick_6242": "武林内传",
    "messageInitNick_6236": "洋葱撞地球",
    "messageInitNick_8899": "环保砧板",
    "messageInitNick_6237": "这没有灵魂",
    "messageInitNick_8898": "新式泡面",
    "messageInitNick_6238": "捡漏观察员",
    "messageInitNick_6239": "大帅比",
    "messageInitNick_6232": "车到了总站",
    "messageInitNick_8895": "半公开的秘密",
    "messageInitNick_6233": "小多角骨",
    "messageInitNick_8894": "小做作",
    "messageInitNick_6234": "有底线的怪兽",
    "messageInitNick_8897": "拖地这件事",
    "messageInitNick_6235": "天堂电视",
    "messageInitNick_8896": "星空如梦",
    "messageInitNick_8891": "蓝胖纸",
    "messageInitNick_8890": "免费上车",
    "messageInitNick_6230": "古怪男孩",
    "messageInitNick_8893": "只想让你懂",
    "messageInitNick_6231": "乏味的雨天",
    "messageInitNick_8892": "最强化妆品",
    "messageInitNick_6225": "丑得惊动上帝",
    "messageInitNick_8888": "赛博大悲咒",
    "messageInitNick_6226": "极品太子哥",
    "messageInitNick_8887": "二手货",
    "messageInitNick_6227": "山楂味的诗",
    "messageInitNick_6228": "心灵毒鸡汤",
    "messageInitNick_8889": "拉肠哇哦",
    "messageInitNick_6221": "播的之门",
    "messageInitNick_8884": "生菜之心",
    "messageInitNick_6222": "铅笔描绘天空",
    "messageInitNick_8883": "强壮走音神",
    "messageInitNick_6223": "拾忆",
    "messageInitNick_8886": "梨消灭者",
    "messageInitNick_6224": "无公害沙棘果",
    "messageInitNick_8885": "纸片女友",
    "messageInitNick_6229": "古老的钟表",
    "messageInitNick_8880": "跟随者",
    "messageInitNick_8882": "掐住一只呆橘",
    "messageInitNick_6220": "对立面",
    "messageInitNick_8881": "辣椒兽",
    "messageInitNick_6214": "重度洁癖",
    "messageInitNick_8877": "看看你",
    "messageInitNick_6215": "疯狂顾问",
    "messageInitNick_8876": "大葱真好吃",
    "messageInitNick_6216": "冰箱的柚子",
    "messageInitNick_8879": "我推的梳子",
    "messageInitNick_6217": "耳机毁灭者",
    "messageInitNick_8878": "我和他不熟",
    "messageInitNick_6210": "咕噜萌妹",
    "messageInitNick_8873": "铁根蓝莓",
    "messageInitNick_6211": "不许骂骂咧咧",
    "messageInitNick_8872": "爱上犀利哥",
    "messageInitNick_6212": "凉粉女巫",
    "messageInitNick_8875": "老派腊肠狗",
    "messageInitNick_6213": "顶级腐乳",
    "messageInitNick_8874": "不想买菜",
    "messageInitNick_6218": "最爱玉米",
    "messageInitNick_6219": "腮红在绽放",
    "messageInitNick_8871": "离别的倒计时",
    "messageInitNick_8870": "断水流大师姐",
    "messageInitNick_6203": "公共关系专家",
    "messageInitNick_8866": "大脑在颤抖",
    "messageInitNick_6204": "电子海盐",
    "messageInitNick_8865": "长腿蜀黍",
    "messageInitNick_6205": "工作日男友",
    "messageInitNick_8868": "大葱先锋",
    "messageInitNick_6206": "半暖半结局",
    "messageInitNick_8867": "豆角魔法",
    "messageInitNick_8862": "梵谷的左耳",
    "messageInitNick_6200": "恶魔般霸道",
    "messageInitNick_8861": "烧麦哇哦",
    "messageInitNick_6201": "火之神",
    "messageInitNick_8864": "猫猫观察员",
    "messageInitNick_6202": "万能火腿肠",
    "messageInitNick_8863": "香蕉是法师",
    "messageInitNick_6207": "别逼我变身",
    "messageInitNick_6208": "最爱菠萝",
    "messageInitNick_8869": "低头思考明天",
    "messageInitNick_6209": "诺贝尔无敌奖",
    "messageInitNick_8860": "摸鱼爱好者",
    "messageInitNick_8855": "拉面猎手",
    "messageInitNick_8854": "孤傲像匹狼",
    "messageInitNick_8857": "倒霉的竹笋",
    "messageInitNick_8856": "柠檬真好吃",
    "messageInitNick_8851": "海边的沙声",
    "messageInitNick_8850": "可乐鸡翅",
    "messageInitNick_8853": "老谈酸菜",
    "messageInitNick_8852": "古城新梦",
    "messageInitNick_8859": "划水小天才",
    "messageInitNick_8858": "白色的鸦",
    "messageInitNick_8844": "跟风少年",
    "messageInitNick_8843": "随它吧",
    "messageInitNick_8846": "重新定义熬夜",
    "messageInitNick_8845": "超级熬夜神",
    "messageInitNick_8840": "抽卡主播",
    "messageInitNick_8842": "家有冰雪龙",
    "messageInitNick_8841": "又停电啦",
    "themeCardPackStoryId_305": "AC-005",
    "messageInitNick_8848": "巴士判官",
    "messageInitNick_8847": "时间逆行者",
    "themeCardPackStoryId_300": "AC-004",
    "messageInitNick_8849": "多变花楸",
    "messageInitNick_8833": "天天打酱油",
    "messageInitNick_8832": "非人类",
    "messageInitNick_8835": "蛋黄酱星人",
    "messageInitNick_8834": "拉黑了",
    "messageInitNick_8831": "按时摆摊",
    "messageInitNick_8830": "地狱邮差",
    "themeCardPackStoryId_315": "AC-007",
    "messageInitNick_8837": "一眼万年",
    "messageInitNick_8836": "可苦可乐",
    "themeCardPackStoryId_310": "AC-006",
    "messageInitNick_8839": "麻烦解决大师",
    "messageInitNick_8838": "瞎说大实话",
    "messageInitNick_8822": "牙线毁灭者",
    "messageInitNick_8821": "爱猫情深",
    "messageInitNick_8824": "记录保持者",
    "messageInitNick_8823": "流浪的骶尾椎",
    "messageInitNick_8820": "尬聊少年",
    "messageInitNick_8829": "橙子君快逃",
    "themeCardPackStoryId_325": "SP-001",
    "messageInitNick_8826": "破碎镜",
    "themeCardPackStoryId_320": "AC-008",
    "messageInitNick_8825": "海洋之神",
    "messageInitNick_8828": "煮茶女",
    "messageInitNick_8827": "什锦饭",
    "themeCardPackStoryId_330": "SP-002",
    "tribeWarResult_1": "取得胜利",
    "tribeWarResult_2": "败下阵来",
    "tribeWarResult_3": "战成平手",
    "messageInitNick_8811": "一起吃饭吗",
    "messageInitNick_8810": "专业画饼",
    "messageInitNick_8813": "牛本山",
    "messageInitNick_8812": "堆使劲堆",
    "messageInitNick_8819": "菠萝龙",
    "themeCardPackStoryId_335": "SP-003",
    "messageInitNick_8818": "知情中单",
    "messageInitNick_8815": "临风唱晚秋",
    "messageInitNick_8814": "神秘核液",
    "messageInitNick_8817": "疯到世界奔溃",
    "messageInitNick_8816": "灵魂傀儡",
    "themeCardPackStoryId_340": "SP-004",
    "messageInitNick_8800": "社会加班人",
    "messageInitNick_8802": "颗颗蛀牙",
    "messageInitNick_8801": "对线之神",
    "messageInitNick_8808": "起来修仙啦",
    "messageInitNick_8807": "万能书",
    "messageInitNick_8809": "超级饼干",
    "messageInitNick_8804": "摄影小白",
    "messageInitNick_8803": "万能拖鞋",
    "messageInitNick_8806": "第三啫喱",
    "messageInitNick_8805": "渐成斗士",
    "themeCardPackStoryId_345": "SP-005",
    "themeCardPackStoryId_350": "SP-006",
    "messageInitContent_10390": "我是污妖王请支持我！",
    "messageInitContent_10391": "我是大嘴鱼王！",
    "messageInitContent_10396": "这里哪里的剧情，我要看",
    "messageInitContent_10397": "巡游？",
    "messageInitContent_10398": "剧情脑补中",
    "messageInitContent_10399": "如果你是戏战顽袍你选谁",
    "messageInitContent_10392": "原来赢是靠路过的御空和空蝉？",
    "messageInitContent_10393": "解释通了",
    "messageInitContent_10394": "大只",
    "messageInitContent_10395": "大嘴鱼王背后的女人",
    "themeCardPackStoryId_355": "SP-007",
    "themeCardPackStoryId_360": "SP-008",
    "messageInitContent_10380": "看我量子波动选择法",
    "messageInitContent_10385": "我选了这边",
    "messageInitContent_10386": "想看龙女",
    "messageInitContent_10387": "天知道答案",
    "messageInitContent_10388": "你又懂了",
    "messageInitContent_10381": "祝大家猜的都对",
    "messageInitContent_10382": "我觉得左边厉害",
    "messageInitContent_10383": "刚来选啥",
    "messageInitContent_10384": "暗中观察",
    "messageInitContent_10389": "等我问问ai",
    "themeCardPackStoryId_365": "MU-001",
    "propConfigName_40002": "钻石",
    "propConfigName_40001": "金币",
    "themeCardPackStoryId_370": "MU-002",
    "propConfigName_40008": "万能碎片",
    "propConfigName_40007": "饲星之魂",
    "propConfigName_40009": "进化孢子",
    "propConfigName_40004": "探索者经验",
    "propConfigName_40003": "移动力",
    "propConfigName_40006": "活跃度",
    "propConfigName_40005": "怪兽经验",
    "messageInitContent_10374": "喂策划吗？",
    "messageInitContent_10375": "这就是传说中的龙癌吗",
    "messageInitContent_10376": "肯定是那边啊",
    "messageInitContent_10377": "一眼左边",
    "messageInitContent_10370": "如果你是戏战顽袍你选谁",
    "messageInitContent_10371": "硬猜",
    "messageInitContent_10372": "我猜我猜我猜猜猜",
    "messageInitContent_10373": "这是新怪在选近战吧",
    "messageInitContent_10378": "五行缺答案",
    "themeCardPackStoryId_375": "MU-003",
    "messageInitContent_10379": "左左右右前前后后",
    "propConfigName_40132": "寰宇头像框",
    "propConfigName_40131": "无限暴走头像框",
    "propConfigName_40134": "怪兽大师头像框",
    "propConfigName_40133": "搬砖大师头像框",
    "propConfigName_40130": "极限暴走头像框",
    "messageInitContent_4018": "叉叉叉叉叉叉",
    "messageInitContent_4019": "我叉叉",
    "propConfigName_40139": "战狂形态-万象·神剑古拉姆",
    "propConfigName_40136": "战狂形态-瑶镜·月夕",
    "propConfigName_40135": "战狂形态-主序·日夕",
    "propConfigName_40138": "战狂形态-神畏·暴虐战狂",
    "propConfigName_40137": "战狂形态-永逐·最终兵器",
    "messageInitContent_10363": "龙族内战",
    "messageInitContent_4021": "食神我要十连",
    "messageInitContent_6684": "除了数值都很可爱",
    "messageInitContent_10364": "群体偏移vs群体减伤",
    "messageInitContent_4022": "XXXXXXXX",
    "messageInitContent_6683": "恐怖的龙？？",
    "messageInitContent_10365": "什么二维码",
    "messageInitContent_4023": "为勺子打call",
    "messageInitContent_6686": "不冷啊",
    "messageInitContent_10366": "无敌的二维区域",
    "messageInitContent_4024": "闭眼投叉叉",
    "messageInitContent_6685": "冷",
    "limiterConfigName_5": "原生准入",
    "messageInitContent_4025": "出息了",
    "messageInitContent_6688": "你看司机笑得多开心",
    "limiterConfigName_4": "木偶准入",
    "messageInitContent_10360": "新旧时代的交错",
    "messageInitContent_4026": "哈哈哈",
    "messageInitContent_6687": "中间的怪兽是什么",
    "tribeFeatConfigName_4": "挑战",
    "limiterConfigName_3": "星灵准入",
    "messageInitContent_10361": "龙龙龙龙龙龙",
    "messageInitContent_4027": "像叉这么帅的怪兽一定是主角",
    "tribeFeatConfigName_3": "驻守",
    "limiterConfigName_2": "尸鬼准入",
    "messageInitContent_10362": "龙之家族",
    "messageInitContent_4028": "刚刚进化！",
    "messageInitContent_6689": "裂了裂了",
    "tribeFeatConfigName_2": "征服",
    "limiterConfigName_1": "祖龙准入",
    "messageInitContent_10367": "守护你的龙龙",
    "messageInitContent_6680": "我好怕怕呢",
    "messageInitContent_10368": "康康你们啥体力",
    "messageInitContent_10369": "如果我是腾龙你会爱我吗",
    "messageInitContent_6682": "收工",
    "messageInitContent_4020": "为叉叉打call",
    "messageInitContent_6681": "完全没在怕",
    "propConfigName_40143": "星辰形态-永逐·最终兵器",
    "propConfigName_40142": "星辰形态-瑶镜·月夕",
    "propConfigName_40145": "星辰形态-万象·神剑古拉姆",
    "propConfigName_40144": "星辰形态-神畏·暴虐战狂",
    "propConfigName_40141": "星辰形态-主序·日夕",
    "propConfigName_40140": "战狂形态-天元·圣盾埃癸斯",
    "messageInitContent_4029": "老父亲的眼泪",
    "propConfigName_40147": "探索者改名根",
    "propConfigName_40146": "星辰形态-天元·圣盾埃癸斯",
    "propConfigName_40149": "精制起源盘",
    "propConfigName_40148": "始动怪兽碎片晶魄",
    "messageInitContent_10352": "哪边？",
    "messageInitContent_4032": "试图思考 放弃思考",
    "messageInitContent_6695": "害怕",
    "messageInitContent_10353": "那边",
    "messageInitContent_4033": "脑子一片空白",
    "messageInitContent_6694": "可怕",
    "messageInitContent_10354": "我有一个大胆的想法",
    "messageInitContent_4034": "猜错了也没关系，明天继续",
    "messageInitContent_6697": "嗯？",
    "messageInitContent_10355": "今天选人少的",
    "messageInitContent_4035": "啦啦啦",
    "messageInitContent_6696": "天啊",
    "messageInitContent_4036": "就问一句，霸者吃饭了吗",
    "messageInitContent_6699": "这不是第一关吗",
    "messageInitContent_4037": "叉叉知道答案",
    "messageInitContent_6698": "连续多少关了啊",
    "messageInitContent_10350": "总有一个是错的",
    "messageInitContent_4038": "保持微笑",
    "messageInitContent_10351": "一眼",
    "messageInitContent_4039": "晚安",
    "97_26": "联结共鸣",
    "97_25": "源初境",
    "97_22": "浮空巨塔",
    "messageInitContent_10356": "快进到明天",
    "messageInitContent_6691": "嘻嘻",
    "97_21": "星律",
    "messageInitContent_10357": "家人们谁懂啊",
    "messageInitContent_6690": "不许熬夜",
    "97_24": "起源核心",
    "messageInitContent_10358": "右边信我",
    "messageInitContent_4030": "ψψψψψψψψψψψ",
    "messageInitContent_6693": "啊啊中间的怪兽又没了",
    "97_23": "部队",
    "messageInitContent_10359": "左右横跳中",
    "messageInitContent_4031": "ψ",
    "messageInitContent_6692": "多手怪啊啊啊啊",
    "propConfigName_40154": "特化橙色元核匣",
    "propConfigName_40153": "红色元核匣",
    "propConfigName_40156": "幻化怪兽茧",
    "propConfigName_40155": "特化红色元核匣",
    "propConfigName_40150": "奇迹怪兽茧",
    "propConfigName_40152": "紫色元核匣",
    "propConfigName_40151": "橙色元核匣",
    "propConfigName_40158": "部落改名根",
    "propConfigName_40157": "不朽怪兽茧",
    "propConfigName_40159": "估你唔到头像",
    "messageInitContent_10341": "帮你做个技能检查",
    "messageInitContent_4043": "真理总是掌握在小树人手上",
    "messageInitContent_10342": "希望大家蒙的都对",
    "messageInitContent_4044": "大叉叉",
    "messageInitContent_10343": "左右横跳中",
    "messageInitContent_4045": "叉叉变成骑手了",
    "messageInitContent_10344": "走近竞猜",
    "messageInitContent_4046": "rider 美杜莎莎",
    "96_StarCollect": "星律",
    "messageInitContent_4047": "喝水小助手提醒你喝水",
    "messageInitContent_4048": "ψψψψψψψψ",
    "messageInitContent_4049": "？？",
    "messageInitContent_10340": "给个机会",
    "messageInitContent_10349": "怪兽赢了",
    "messageInitContent_10345": "玄学告诉我选右",
    "messageInitContent_10346": "抄作业时间到",
    "messageInitContent_4040": "6年了！快7年了！",
    "messageInitContent_10347": "未尝一对",
    "messageInitContent_4041": "让我看看技能",
    "messageInitContent_10348": "歧兽表示不服",
    "messageInitContent_4042": "哪里人多选哪里",
    "propConfigName_40165": "电路绿头像",
    "propConfigName_40164": "蓝调黑头像",
    "propConfigName_40167": "击破币",
    "propConfigName_40166": "霓虹彩头像",
    "propConfigName_40161": "爱心纹身头像",
    "propConfigName_40160": "像素头像",
    "propConfigName_40163": "白色枝桠头像",
    "propConfigName_40162": "黑色枝桠头像",
    "propConfigName_40169": "神行药水",
    "propConfigName_40168": "代金券",
    "messageInitContent_10330": "前排出售龙虎豹",
    "messageInitContent_4054": "一定是地龙赢",
    "messageInitContent_10331": "前排出售香蕉",
    "messageInitContent_4055": "简单",
    "messageInitContent_10332": "前排出售鸟龙",
    "messageInitContent_4056": "啊这",
    "messageInitContent_10333": "反对鸟笼买卖",
    "messageInitContent_4057": "看看等级",
    "messageInitContent_4058": "躺了",
    "messageInitContent_4059": "被窝让我选左边",
    "messageInitContent_10338": "我是猜错概念神",
    "messageInitContent_10339": "生命值之眼",
    "propConfigName_40170": "一堆骨木鳞",
    "messageInitContent_10334": "看看你血量",
    "messageInitContent_4050": "换了个站位吗",
    "messageInitContent_10335": "如果你是戏战顽袍你选谁",
    "messageInitContent_4051": "龙炮vs人间大炮",
    "messageInitContent_10336": "新原生3巨头？",
    "messageInitContent_4052": "对轰",
    "messageInitContent_10337": "看看你血条",
    "messageInitContent_4053": "炮火连天",
    "propConfigName_40176": "守护之翼头像",
    "propConfigName_40175": "轮盘券",
    "propConfigName_40178": "探索度贡献",
    "propConfigName_40177": "进步",
    "propConfigName_40172": "契约经验",
    "propConfigName_40171": "神奇孢子罐头",
    "propConfigName_40174": "永恒火舞头像框",
    "propConfigName_40173": "朴实金翅头像框",
    "96_DarkForest": "黑暗森林",
    "propConfigName_40179": "创世一闪",
    "messageInitContent_4065": "开炮开炮！",
    "messageInitContent_10320": "精致探索者竞猜中",
    "messageInitContent_4066": "阿姆斯特朗回旋……",
    "messageInitContent_10321": "选对明天加鸡腿",
    "messageInitContent_4067": "朋友，来吗",
    "messageInitContent_10322": "大佬快来指路",
    "messageInitContent_4068": "伤害好吃吗",
    "messageInitContent_4069": "输的一定是没有地龙那边",
    "themeCardPackStoryId_505": "SF-005",
    "messageInitContent_10327": "发女装可得答案",
    "themeCardPackStoryId_500": "SF-004",
    "messageInitContent_10328": "你们快选啊",
    "themeCardPackName_21040": "痛击命运",
    "messageInitContent_10329": "主打一个随缘",
    "propConfigName_40181": "创世纪头像框",
    "messageInitContent_4060": "好好好",
    "propConfigName_40180": "一创币",
    "messageInitContent_10323": "抄作业时间到",
    "messageInitContent_4061": "叉叉霸霸",
    "messageInitContent_10324": "五行缺答案",
    "messageInitContent_4062": "谁才是霸霸",
    "messageInitContent_10325": "我选前面",
    "messageInitContent_4063": "站位不错哦小地龙",
    "messageInitContent_10326": "我选后面",
    "messageInitContent_4064": "弟龙",
    "propConfigName_40187": "延时繁星头像框",
    "propConfigName_40186": "无双剑风头像框",
    "propConfigName_40189": "幻海遨游头像框",
    "propConfigName_40188": "万花一瞬头像框",
    "themeCardPackName_21035": "树林会谈",
    "messageInitContent_10309": "看看你血量",
    "propConfigName_40183": "混沌浮云头像框",
    "propConfigName_40182": "翱翔幻象头像框",
    "propConfigName_40185": "造浪宣言头像框",
    "propConfigName_40184": "生命之涌头像框",
    "messageInitContent_4076": "帝龙！",
    "messageInitContent_4077": "日常瞎选",
    "messageInitContent_10310": "超纲了",
    "messageInitContent_4078": "泰裤辣！",
    "messageInitContent_10311": "说答案吧，我在蹲",
    "messageInitContent_4079": "勇者斗恶龙？",
    "themeCardPackStoryId_515": "SF-007",
    "messageInitContent_10316": "咋选",
    "propConfigName_40190": "倒转海洋头像框",
    "messageInitContent_10317": "猜对day0",
    "messageInitContent_10318": "右边信我",
    "messageInitContent_4070": "竞猜全对了，在梦里，",
    "propConfigName_40192": "绯红约定头像框",
    "messageInitContent_10319": "坏了",
    "messageInitContent_4071": "轰~~~",
    "propConfigName_40191": "永恒脉络头像框",
    "messageInitContent_10312": "给个机会",
    "messageInitContent_4072": "听我指挥开炮！",
    "messageInitContent_10313": "新怪主场",
    "messageInitContent_4073": "糟糕，脑子长出来了",
    "messageInitContent_10314": "看看它的血条",
    "messageInitContent_4074": "和地龙贴贴",
    "themeCardPackName_21030": "祈咬尾",
    "messageInitContent_10315": "今日精选",
    "messageInitContent_4075": "地龙帅的",
    "themeCardPackStoryId_510": "SF-006",
    "propConfigName_40198": "幻彩流体头像框",
    "propConfigName_40197": "利刃回环头像框",
    "propConfigName_40199": "沙星王座头像框",
    "propConfigName_40194": "无形之翼头像框",
    "propConfigName_40193": "破空律动头像框",
    "propConfigName_40196": "赛博法环头像框",
    "propConfigName_40195": "超能制约头像框",
    "messageInitContent_4087": "小番茄在此",
    "messageInitContent_4088": "小土豆在此",
    "messageInitContent_4089": "朋友请你和你的什么冷静一下",
    "messageInitContent_10300": "今天穿啥变成了今天谁穿",
    "messageInitContent_10305": "顽袍全勤",
    "messageInitContent_10306": "希望大家蒙的都对",
    "messageInitContent_4080": "蜻蜓龙真的是龙吗",
    "messageInitContent_10307": "康康你们啥体力",
    "messageInitContent_4081": "独孤一剑",
    "messageInitContent_10308": "HP侦查中",
    "messageInitContent_4082": "蜻蜓队长路过，是右边赢",
    "themeCardPackStoryId_525": "MW-001",
    "messageInitContent_10301": "谁从明天穿越一下",
    "messageInitContent_4083": "蜻蜓队长2号路过，是左边赢",
    "messageInitContent_10302": "最适合袍的怪兽大赛",
    "messageInitContent_4084": "公主呢",
    "messageInitContent_10303": "影替给的啥",
    "messageInitContent_4085": "公主大人请上车",
    "themeCardPackStoryId_520": "SF-008",
    "messageInitContent_10304": "哪边的顽袍选队了",
    "messageInitContent_4086": "公主在此",
    "messageInitContent_4098": "整点无敌的能力",
    "messageInitContent_4099": "5个技能打3个技能，答案昭然若揭",
    "messageInitContent_4090": "有故事",
    "messageInitContent_4091": "恶龙咆哮",
    "messageInitContent_4092": "嗷嗷嗷嗷嗷嗷嗷",
    "themeCardPackStoryId_535": "MW-003",
    "messageInitContent_4093": "想吃地下城的饭",
    "messageInitContent_4094": "穿越到异世界当勇者",
    "messageInitContent_4095": "几百岁，是个精灵魔法使",
    "themeCardPackStoryId_530": "MW-002",
    "messageInitContent_4096": "喜欢收集各种民间魔法",
    "messageInitContent_4097": "前排出售史莱姆冻干",
    "themeCardPackName_21005": "爆了",
    "iapBuyConfigName_10006": "代金券x648",
    "iapBuyConfigName_10005": "代金券x328",
    "iapBuyConfigName_10004": "代金券x128",
    "iapBuyConfigName_10003": "代金券x68",
    "iapBuyConfigName_10009": "代金券x6480",
    "iapBuyConfigName_10008": "代金券x3280",
    "iapBuyConfigName_10007": "代金券x1980",
    "iapBuyConfigName_10002": "代金券x30",
    "messageInitContent_6600": "啊？嗯?",
    "iapBuyConfigName_10001": "代金券x6",
    "iapBuyConfigName_10000": "代金券x1",
    "messageInitContent_6602": "猜不到啊啊",
    "messageInitContent_6601": "还真都是远古",
    "systemTaskConfigSender_4": "赤色拍卖狮",
    "systemTaskConfigSender_5": "▇▇",
    "systemTaskConfigSender_6": "狩猎协会斥候",
    "systemTaskConfigSender_7": "狩猎协会斥候",
    "systemTaskConfigSender_8": "狩猎商店老板",
    "systemTaskConfigSender_9": "世界",
    "messageInitContent_6604": "真·主角",
    "messageInitContent_6603": "主角的排面",
    "messageInitContent_6606": "我赞成",
    "messageInitContent_6605": "有端联想",
    "messageInitContent_6608": "好多日夕",
    "messageInitContent_6607": "我不同意",
    "messageInitContent_6609": "就看能不能秒了",
    "messageInitContent_6611": "盾这么舒服",
    "messageInitContent_6610": "猜对day0",
    "messageInitContent_6613": "我上我也行",
    "messageInitContent_6612": "这伤害够吗",
    "themeCardPackName_21025": "她之心",
    "messageInitContent_6615": "续航不行吧",
    "messageInitContent_6614": "正在猜",
    "messageInitContent_6617": "左拥右抱",
    "messageInitContent_6616": "一眼左",
    "messageInitContent_6619": "做个宝可梦",
    "messageInitContent_6618": "觉醒系列",
    "resoundEventConfigDes_2": "圣盾与守护",
    "resoundEventConfigDes_1": "大陆的异响",
    "messageInitContent_6620": "哦吼",
    "resoundEventConfigDes_4": "少女与巨兽",
    "resoundEventConfigDes_3": "邪王的爱意",
    "messageInitContent_6622": "什么时候开三路大战",
    "messageInitContent_6621": "日剑盾vs月兵斧",
    "messageInitContent_6624": "坏了",
    "messageInitContent_6623": "还有谁没登场的",
    "resoundEventConfigDes_9": "短暂的安宁",
    "resoundEventConfigDes_6": "首役冰川谷",
    "resoundEventConfigDes_5": "各自的现实",
    "resoundEventConfigDes_8": "冰与火之地",
    "resoundEventConfigDes_7": "各自的搭档",
    "themeCardPackName_21020": "他之心",
    "themeCardPackName_21015": "愿得她心",
    "messageInitContent_6626": "妙哇",
    "messageInitContent_6625": "只能看着它输出，你们懂的",
    "messageInitContent_6628": "我也知道答案",
    "messageInitContent_6627": "技能知道答案",
    "messageInitContent_6629": "收工",
    "messageInitContent_6631": "凉拌",
    "messageInitContent_6630": "兵器buff咋搞",
    "messageInitContent_6633": "正确的",
    "messageInitNick_6199": "减肥收藏家",
    "messageInitContent_6632": "哈哈哈",
    "messageInitContent_6635": "最后一天！",
    "messageInitContent_6634": "永远相信兵器！",
    "themeCardPackName_21010": "实体",
    "messageInitNick_6190": "无敌的狮王",
    "messageInitContent_6637": "猜不到啊啊",
    "messageInitNick_6195": "不用再来上班",
    "messageInitContent_6636": "让我猜对一次吧！",
    "messageInitNick_6196": "嘟尛嘴",
    "messageInitContent_6639": "没有修罗场差评",
    "messageInitNick_6197": "蒙娜丽莎",
    "messageInitContent_6638": "好多月夕",
    "messageInitNick_6198": "行走的花生酱",
    "messageInitNick_6191": "发型又乱了",
    "messageInitNick_6192": "决带笑",
    "messageInitNick_6193": "酸辣草莓",
    "messageInitNick_6194": "卸妆好麻烦",
    "messageInitContent_6640": "我猜远古族赢",
    "messageInitContent_6642": "猜对day0",
    "messageInitContent_6641": "我选太阳",
    "messageInitContent_6644": "在猜了在猜了",
    "messageInitNick_6188": "重新定义打拳",
    "messageInitContent_6643": "笑死",
    "messageInitNick_6189": "炒饭王",
    "messageInitContent_6646": "远古竞猜",
    "messageInitContent_6645": "一拳n个",
    "messageInitContent_6648": "听说你们不睡觉",
    "messageInitNick_6184": "绷不住了",
    "messageInitContent_6647": "我选月亮",
    "messageInitNick_6185": "摸鱼王子",
    "messageInitNick_6186": "桃子先锋",
    "messageInitContent_6649": "习惯了",
    "messageInitNick_6187": "无敌头铁神",
    "messageInitNick_6180": "霸占你的心",
    "messageInitNick_6181": "全息空气",
    "messageInitNick_6182": "惊喜连连",
    "messageInitNick_6183": "逆袭的电台",
    "messageInitContent_6651": "居然不是叉叉迎接我",
    "messageInitContent_6650": "新世界我来啦",
    "messageInitContent_6653": "最恐怖的事情是等级",
    "messageInitContent_6652": "哈哈哈哈",
    "messageInitContent_6655": "sc过了",
    "messageInitNick_6177": "大叔请让开",
    "messageInitContent_6654": "san值很健康",
    "messageInitNick_6178": "黑色面具",
    "messageInitContent_6657": "前面主城",
    "messageInitNick_6179": "行走的橡皮糖",
    "messageInitContent_6656": "自动木偶",
    "97_20": "极化",
    "messageInitContent_6659": "狼人杀？",
    "messageInitNick_6173": "霸道掩饰温柔",
    "messageInitContent_6658": "触发",
    "messageInitNick_6174": "超级画饼神",
    "messageInitNick_6175": "爱人鬼士",
    "messageInitNick_6176": "可乐控程序",
    "messageInitNick_6170": "混世小仙女",
    "messageInitNick_6171": "弹无且虚发",
    "messageInitNick_6172": "旧车票",
    "messageInitContent_6662": "我好怕怕哦",
    "messageInitContent_4000": "祝大家一帆风顺万事如意",
    "messageInitContent_6661": "物理闭嘴",
    "messageInitContent_4001": "公主王子们新年好",
    "messageInitContent_6664": "冷静",
    "messageInitContent_4002": "暴富喷雾",
    "messageInitContent_6663": "阵阵阴风",
    "97_19": "饲星坛",
    "messageInitContent_4003": "让我模拟一下",
    "messageInitContent_6666": "在打了",
    "messageInitNick_6166": "月白釉紫斑盆",
    "97_18": "世界回响",
    "messageInitContent_4004": "春风得意马蹄疾，新年伊始送祝福。愿你在新的一年里，事业有成步步高，财源广进福气绕。身体健康心情好，家庭和睦乐陶陶。",
    "messageInitContent_6665": "收割灵魂",
    "messageInitNick_6167": "我饭量很小",
    "messageInitContent_4005": "学业进步啦",
    "messageInitContent_6668": "成功上岸",
    "messageInitNick_6168": "海绵蛋糕",
    "messageInitContent_4006": "天天进化",
    "messageInitContent_6667": "发生什么了",
    "messageInitNick_6169": "只在乎你",
    "97_15": "起源殿",
    "97_14": "凿星裂痕",
    "97_17": "谜之巢穴",
    "97_16": "战墙",
    "97_11": "永生之茧",
    "97_10": "起源基石",
    "97_13": "斗技场",
    "messageInitContent_6660": "潜伏ing",
    "97_12": "黑暗森林",
    "systemTaskConfigSender_1": "▇▇",
    "systemTaskConfigSender_2": "起源殿射箭大哥",
    "systemTaskConfigSender_3": "赤色拍卖狮",
    "messageInitContent_4007": "今天也可以模拟一波",
    "messageInitNick_6162": "硬件工程师",
    "tribeFeatConfigName_1": "击破",
    "messageInitContent_4008": "新年目标是全对",
    "messageInitContent_6669": "你好老尸",
    "messageInitNick_6163": "和龙握手",
    "messageInitContent_4009": "红包拿来",
    "messageInitNick_6164": "奈斯啊",
    "messageInitNick_6165": "喜欢欢",
    "messageInitNick_6160": "狂想曲",
    "messageInitNick_6161": "独恋花尽散",
    "messageInitContent_4010": "新年好呀新年好呀",
    "messageInitContent_6673": "huh？",
    "messageInitNick_6159": "红色的曼陀罗",
    "messageInitContent_4011": "恭贺新春",
    "messageInitContent_6672": "听说0的嘴巴在下面",
    "messageInitContent_4012": "祝你新年躺赢",
    "messageInitContent_6675": "完全没在怕",
    "messageInitContent_4013": "红包哪里领",
    "messageInitContent_6674": "点个赞",
    "messageInitContent_4014": "祖龙族集训是吧",
    "messageInitContent_6677": "再见",
    "messageInitNick_6155": "一起发财",
    "messageInitContent_4015": "放假啦",
    "messageInitContent_6676": "你好",
    "messageInitNick_6156": "功夫躲避球",
    "messageInitContent_4016": "不说了恭喜发财",
    "messageInitContent_6679": "开饭啦",
    "messageInitNick_6157": "游泳去考试",
    "messageInitContent_4017": "就祝大家新年大吉吧",
    "messageInitContent_6678": "绯！",
    "messageInitNick_6158": "卷卷大王",
    "messageInitContent_6671": "制杖小人的脸在肚子？",
    "messageInitContent_6670": "给尸体上奶",
    "messageInitNick_6151": "蹲草王者",
    "messageInitNick_6152": "小萌神",
    "messageInitNick_6153": "吃藕丑割吻滚",
    "messageInitNick_6154": "旧故事",
    "messageInitNick_6150": "技术灭全场",
    "messageInitNick_6148": "太阳晒屁股",
    "messageInitNick_6149": "火麒麟",
    "messageInitNick_6144": "草莓之心",
    "messageInitNick_6145": "送分小仙女",
    "messageInitNick_6146": "教科书级的我",
    "messageInitNick_6147": "自制豆浆",
    "messageInitNick_6140": "高智商甜点",
    "randomEventDialogueGroupConfig_57.34": "远处有谁对你喊话。",
    "messageInitNick_6141": "空投砸头",
    "randomEventDialogueGroupConfig_57.35": "它被悬赏了，抱歉我抢先一步啦，有缘再会。",
    "messageInitNick_6142": "水煮小龙虾",
    "randomEventDialogueGroupConfig_57.36": "离开",
    "messageInitNick_6143": "今日小雨转甜",
    "randomEventDialogueGroupConfig_57.37": "突然有个黑影来到你身边，用纸笔写下二当家是悬赏目标。",
    "randomEventDialogueGroupConfig_57.38": "假装惊讶念出来",
    "randomEventDialogueGroupConfig_57.39": "二把手听到你的惊叫，大喊敌袭，由于你提醒有功，二当家特地给你送了一份大礼。",
    "messageInitNick_6137": "把夕阳灌醉",
    "messageInitNick_6138": "无助小可爱",
    "messageInitNick_8799": "猫群中的鸽子",
    "messageInitNick_6139": "绕不出你的心",
    "randomEventDialogueGroupConfig_57.40": "满载离开",
    "12_11": "取消选定",
    "messageInitNick_6133": "无公害哈密瓜",
    "messageInitNick_8796": "玉米撞地球",
    "12_12": "非万能进化光谱可在饲星坛进行光谱饲星获得饲星之魂",
    "messageInitNick_6134": "不萌少女",
    "messageInitNick_8795": "莫比乌斯拳",
    "messageInitNick_6135": "七千里蔚蓝",
    "messageInitNick_8798": "可怜的仁",
    "12_10": "选定",
    "messageInitNick_6136": "不准咬椅子",
    "messageInitNick_8797": "隐者之紫",
    "messageInitNick_8792": "在下",
    "randomEventDialogueGroupConfig_57.23": "他疑惑地看着你，竟不自觉地问了出声。",
    "messageInitNick_6130": "出省宅家",
    "messageInitNick_8791": "哀伤的钢琴",
    "randomEventDialogueGroupConfig_57.24": "出手攻击二把手",
    "messageInitNick_6131": "还是不懂",
    "messageInitNick_8794": "洋葱魔法师",
    "randomEventDialogueGroupConfig_57.25": "你偷袭成功，带着二把手翻墙而去。任务完成。",
    "messageInitNick_6132": "火龙果龙",
    "messageInitNick_8793": "真的好会",
    "randomEventDialogueGroupConfig_57.26": "离开",
    "randomEventDialogueGroupConfig_57.27": "由于刚刚那声惊呼，二把手早已有了防备大喊敌袭。任务失败了。",
    "randomEventDialogueGroupConfig_57.28": "离开",
    "messageInitNick_8790": "大黑妞",
    "randomEventDialogueGroupConfig_57.29": "你很快来到东集市中心找到了集市的二把手。你发现有谁在它身后画画，而二把手则背对着那个家伙。",
    "messageInitNick_6126": "赶鸭子上架",
    "messageInitNick_8789": "早上四点半",
    "messageInitNick_6127": "甲方代表",
    "messageInitNick_8788": "读万卷书",
    "messageInitNick_6128": "仓库等你",
    "messageInitNick_6129": "毛毛虫闯红灯",
    "messageInitNick_6122": "铁皮屋顶",
    "messageInitNick_8785": "一起哈皮",
    "randomEventDialogueGroupConfig_57.30": "悄悄走过去用笔墨交流",
    "messageInitNick_6123": "残留物",
    "messageInitNick_8784": "我很乖",
    "randomEventDialogueGroupConfig_57.31": "你专注画完之后，正准备让它过目，却发现，它不见了。",
    "messageInitNick_6124": "无奈的猫生",
    "messageInitNick_8787": "一介俗人",
    "randomEventDialogueGroupConfig_57.32": "好吧，如果你认识好的画兽师也可以推荐给我，再见。",
    "messageInitNick_6125": "请有序变身",
    "messageInitNick_8786": "纯情辣椒圈",
    "randomEventDialogueGroupConfig_57.33": "离开",
    "messageInitNick_8781": "红毯之王",
    "randomEventDialogueGroupConfig_57.12": "表示疑惑",
    "messageInitNick_8780": "彪悍小伙子",
    "randomEventDialogueGroupConfig_57.13": "你看出来了，这是一张伪装成悬赏令的招募！但右下角的暗号才是关键，意思就是有人在暗中悬赏发布者。",
    "visionSagesOption1_1": "霸气越高越帅",
    "messageInitNick_6120": "落泪的玫瑰",
    "messageInitNick_8783": "大佬的马子",
    "randomEventDialogueGroupConfig_57.14": "径直前往",
    "messageInitNick_6121": "故事缺你",
    "messageInitNick_8782": "猩猩在画画",
    "randomEventDialogueGroupConfig_57.15": "暗中接近",
    "randomEventDialogueGroupConfig_57.16": "就是因为我的手最近受伤了画不好悬赏画像，导致最近悬赏的都抓错了。纸笔都在这，我这就转过身，你将我的相貌画下来，让我看看你的水平！",
    "randomEventDialogueGroupConfig_57.17": "开始根据记忆绘图",
    "randomEventDialogueGroupConfig_57.18": "拒绝打长工",
    "randomEventDialogueGroupConfig_57.19": "硬着头皮画画试试",
    "messageInitNick_6115": "捡漏天后",
    "messageInitNick_8778": "该如何骗你",
    "visionSagesOption1_8": "会，不返还",
    "messageInitNick_6116": "鼠标要高考",
    "messageInitNick_8777": "超级红地毯",
    "visionSagesOption1_9": "不行",
    "messageInitNick_6117": "有几个直觉",
    "visionSagesOption1_6": "难度越低掉落越高",
    "messageInitNick_6118": "胸毛随风飘",
    "messageInitNick_8779": "青梅竹马",
    "visionSagesOption1_7": "一年",
    "messageInitNick_6111": "加勒比海带",
    "messageInitNick_8774": "此男姐的专属",
    "visionSagesOption1_4": "不想看，闪瞎眼",
    "messageInitNick_6112": "通菜战士",
    "messageInitNick_8773": "是他胖的",
    "randomEventDialogueGroupConfig_57.20": "你暗中观察，发现有谁在它身后画画，而二把手则背对着那个家伙。",
    "visionSagesOption1_5": "没用",
    "messageInitNick_6113": "风中烈马",
    "messageInitNick_8776": "超级炸鸡",
    "randomEventDialogueGroupConfig_57.21": "偷袭",
    "visionSagesOption1_2": "冥思！",
    "messageInitNick_6114": "跑步速度飞快",
    "messageInitNick_8775": "如果荔枝会笑",
    "randomEventDialogueGroupConfig_57.22": "原来你什么都不知道就过来了，咱就是想搞搞新意思，把招募做成悬赏令，这样大家都能注意到咱的招募了。",
    "visionSagesOption1_3": "认输",
    "messageInitNick_6119": "薄荷撞可乐",
    "messageInitNick_8770": "汤圆滚远了",
    "messageInitNick_8772": "核动力饮水机",
    "messageInitNick_6110": "本宫不退位",
    "messageInitNick_8771": "泡面怪客",
    "messageInitNick_6104": "雪莲果爱好者",
    "messageInitNick_8767": "电流顾问",
    "messageInitNick_6105": "旧时候",
    "messageInitNick_8766": "笑面虎",
    "messageInitNick_6106": "空投在前方",
    "messageInitNick_8769": "地狱使者",
    "messageInitNick_6107": "霸气的小孩",
    "messageInitNick_8768": "给伤痛微笑",
    "messageInitNick_6100": "无敌钓鱼神",
    "messageInitNick_8763": "大力王",
    "messageInitNick_6101": "霸道小哥",
    "messageInitNick_8762": "香蕉之心",
    "messageInitNick_6102": "暗淡的头像",
    "messageInitNick_8765": "镜子狂怒者",
    "messageInitNick_6103": "战力计量单位",
    "messageInitNick_8764": "转角遇到怪",
    "messageInitNick_6108": "群主驾到",
    "messageInitNick_6109": "橙子真好吃",
    "messageInitNick_8761": "有点小可爱",
    "messageInitNick_8760": "无敌摸鱼神",
    "messageInitNick_8756": "带帽子的鱼",
    "messageInitNick_8755": "奔驰的打野",
    "messageInitNick_8758": "猜寄信人",
    "messageInitNick_8757": "往事回收站",
    "messageInitNick_8752": "屁过无痕",
    "messageInitNick_8751": "低调小伙",
    "messageInitNick_8754": "东亚醋王",
    "messageInitNick_8753": "能不能别掏",
    "messageInitNick_8759": "芒果射手",
    "messageInitNick_8750": "倾听陌上花开",
    "messageInitNick_8745": "尬聊观察员",
    "messageInitNick_8744": "发光发热的灯",
    "messageInitNick_8747": "明年体检",
    "messageInitNick_8746": "急也没用",
    "messageInitNick_8741": "自走摄像机",
    "messageInitNick_8740": "松鼠在编程",
    "messageInitContent_6701": "失忆了吗",
    "messageInitNick_8743": "总是钓不到鱼",
    "messageInitContent_6700": "疯了",
    "messageInitNick_8742": "筛骨",
    "messageInitNick_8749": "溺于你心海",
    "messageInitNick_8748": "你不在的世界",
    "messageInitContent_6703": "手头有点紧",
    "messageInitContent_6702": "啊",
    "messageInitContent_6705": "怪投降了",
    "messageInitContent_6704": "嗯？",
    "messageInitContent_6707": "独角兽吃完东西要怎么消化",
    "messageInitContent_6706": "我信了",
    "messageInitContent_6709": "握手",
    "messageInitContent_6708": "和谐和谐",
    "messageInitNick_8734": "洗脚盆毁灭者",
    "messageInitNick_8733": "烂脾气",
    "messageInitNick_8736": "放学别走",
    "messageInitNick_8735": "面馆老板",
    "messageInitContent_6710": "握爪爪",
    "messageInitNick_8730": "菠菜之心",
    "messageInitContent_6712": "我看到了五只怪！",
    "messageInitNick_8732": "烧麦怪客",
    "messageInitContent_6711": "今天是几号来着",
    "messageInitNick_8731": "饭桶的末路",
    "messageInitNick_8738": "银河倾斜",
    "messageInitNick_8737": "爱却说不出口",
    "messageInitNick_8739": "宅久天然呆",
    "messageInitNick_8723": "就说跳这不行",
    "messageInitNick_8722": "最孤独的香蕉",
    "messageInitNick_8725": "不正经的熊",
    "messageInitNick_8724": "五手三灰",
    "messageInitNick_8721": "开始生气",
    "messageInitNick_8720": "榨菜在喂饭",
    "themeCardPackStoryId_425": "VV-005",
    "messageInitNick_8727": "无敌划水神",
    "messageInitNick_8726": "爱情备胎",
    "themeCardPackStoryId_420": "VV-004",
    "messageInitNick_8729": "您品",
    "messageInitNick_8728": "躺赢神",
    "messageInitNick_8712": "外星的碎片",
    "messageInitNick_8711": "狂飙的骆驼",
    "messageInitNick_8714": "霸气拽爷",
    "messageInitNick_8713": "不爱游泳的鱼",
    "messageInitNick_8710": "喵喵小奶瓶",
    "messageInitNick_8719": "黑暗影",
    "themeCardPackStoryId_435": "VV-007",
    "messageInitNick_8716": "麻烦制造者",
    "themeCardPackStoryId_430": "VV-006",
    "messageInitNick_8715": "始终隐身",
    "messageInitNick_8718": "超级点赞神",
    "messageInitNick_8717": "强壮干饭神",
    "themeCardPackStoryId_440": "VV-008",
    "channelName_134_h": "Google Play Store",
    "messageInitNick_8701": "让孩子单飞",
    "messageInitNick_8700": "请马上撤回",
    "messageInitNick_8703": "冰晶打手",
    "messageInitNick_8702": "踮脚摘星星",
    "messageInitNick_8709": "行走的水果糖",
    "themeCardPackStoryId_445": "TL-001",
    "messageInitNick_8708": "直接叫过",
    "messageInitNick_8705": "卖咸蛋的超人",
    "messageInitNick_8704": "爽滑慢舔",
    "messageInitNick_8707": "醉人眸",
    "messageInitNick_8706": "久伴不离",
    "themeCardPackStoryId_450": "TL-002",
    "messageInitContent_10290": "最适合袍的怪兽大赛",
    "messageInitContent_10291": "敌人错误的敌兽正确的",
    "messageInitContent_10292": "委屈巴巴",
    "messageInitContent_10297": "刚来选啥",
    "messageInitContent_10298": "祝大家猜的都对",
    "messageInitContent_10299": "暗中观察",
    "messageInitContent_10293": "抛个硬币看看",
    "messageInitContent_10294": "坏了没有硬币",
    "messageInitContent_10295": "量子波动选择法",
    "messageInitContent_10296": "肯定是那边啊",
    "themeCardPackStoryId_455": "TL-003",
    "themeCardPackStoryId_460": "TL-004",
    "messageInitContent_10280": "生命值之眼！！",
    "messageInitContent_10281": "人越多人越少",
    "messageInitContent_10286": "给个机会",
    "messageInitContent_10287": "五行缺答案",
    "messageInitContent_10288": "别搞",
    "messageInitContent_10289": "爱与和平",
    "messageInitContent_10282": "HP侦查中",
    "messageInitContent_10283": "身体检查",
    "messageInitContent_10284": "看看它的血量。",
    "randomEventDialogueGroupConfig_57.10": "你很快来到东集市中心找到了集市的二把手。它看着你手中的悬赏令，满脸笑容地向你走来。",
    "messageInitContent_10285": "看看谁先挂~",
    "randomEventDialogueGroupConfig_57.11": "太好了，咱等你很久了你是来应聘什么的呢？",
    "themeCardPackStoryId_465": "TL-005",
    "themeCardPackStoryId_470": "TL-006",
    "propConfigName_40101": "起源殿挑战次数",
    "propConfigName_40100": "斗技场挑战次数",
    "propConfigName_40107": "凿星者头像（31天）",
    "propConfigName_40106": "星辰形态（31天）",
    "propConfigName_40109": "猎神头像（31天）",
    "messageInitContent_10270": "化敌为友？",
    "propConfigName_40108": "斗技之王头像（31天）",
    "propConfigName_40103": "一捆尖刺",
    "propConfigName_40102": "活跃之星",
    "propConfigName_40105": "战狂形态（31天）",
    "propConfigName_40104": "探索奇点",
    "messageInitContent_10275": "看我去掉变量",
    "messageInitContent_10276": "零衣！！！！",
    "messageInitContent_10277": "我觉得嘛",
    "messageInitContent_10278": "问问自己如果你是戏战顽袍你选谁",
    "messageInitContent_10271": "希腊神话看了想打人",
    "messageInitContent_10272": "这个输出是不是有点手段",
    "messageInitContent_10273": "看看袍绑的谁",
    "messageInitContent_10274": "为零打ko！",
    "messageInitContent_10279": "手多且短",
    "themeCardPackStoryId_475": "TL-007",
    "propConfigName_40110": "起源殿主宰头像（31天）",
    "propConfigName_40112": "起源殿宗师头像（31天）",
    "propConfigName_40111": "起源殿巅峰头像（31天）",
    "themeCardPackStoryId_480": "TL-008",
    "propConfigName_40118": "引领者头像",
    "propConfigName_40117": "资深探索者头像",
    "propConfigName_40119": "破厄头像（7天）",
    "propConfigName_40114": "叉叉头像",
    "propConfigName_40113": "霸王头像",
    "propConfigName_40116": "探索者头像",
    "propConfigName_40115": "玫瑰头像",
    "messageInitContent_10264": "夜观星象不知答案",
    "messageInitContent_10265": "技能技能技能技能",
    "messageInitContent_10266": "什么鬼战略？",
    "messageInitContent_10267": "未尝一对",
    "messageInitContent_10260": "猜对day1",
    "messageInitContent_10261": "大佬快来指路",
    "messageInitContent_10262": "正在猜",
    "messageInitContent_10263": "我梦到了是右边赢",
    "messageInitContent_10268": "精致探索者竞猜中",
    "themeCardPackStoryId_485": "SF-001",
    "messageInitContent_10269": "总有一个是错的",
    "propConfigName_40121": "神秘之心头像",
    "propConfigName_40120": "造唤之神头像",
    "propConfigName_40123": "部落之王头像框（31天）",
    "propConfigName_40122": "羽化头像",
    "themeCardPackStoryId_495": "SF-003",
    "themeCardPackStoryId_490": "SF-002",
    "propConfigName_40129": "暴走头像框",
    "propConfigName_40128": "猫耳头像框",
    "propConfigName_40125": "部落之角头像框（31天）",
    "propConfigName_40124": "部落之心头像框（31天）",
    "propConfigName_40127": "超级普通头像框",
    "propConfigName_40126": "普通头像框",
    "messageInitContent_10253": "硬猜",
    "messageInitContent_10254": "选对明天加鸡腿",
    "messageInitContent_10255": "左左右右前前后后",
    "messageInitContent_10256": "帮你做个技能检查",
    "messageInitContent_10250": "我选你",
    "messageInitContent_10251": "HP侦查中",
    "messageInitContent_10252": "生命值之眼",
    "messageInitContent_10257": "我家哈基米帮我选了",
    "messageInitContent_10258": "强的到底是谁",
    "messageInitContent_10259": "正确的",
    "propConfigName_40253": "粽奖头像",
    "propConfigName_40252": "气氛组头像",
    "propConfigName_40255": "蜡笔小蝶头像",
    "propConfigName_40254": "超越之面头像",
    "propConfigName_40251": "鸿运当头像",
    "propConfigName_40250": "一周年头像",
    "messageInitContent_6318": "双罩流",
    "messageInitContent_6317": "笑",
    "messageInitContent_8979": "咋选",
    "messageInitContent_6319": "大哥罩罩我",
    "propConfigName_40257": "秋色偶叠头像",
    "propConfigName_40256": "放生彩灯头像",
    "propConfigName_40259": "2.9签到战令头像",
    "propConfigName_40258": "二周年头像",
    "messageInitContent_6321": "好烧哦",
    "messageInitContent_8984": "夜观星象不知答案",
    "messageInitContent_6320": "小弟罩罩我",
    "messageInitContent_8985": "2个远程懂的都懂",
    "messageInitContent_6323": "捅到龙窝了",
    "messageInitContent_8982": "发女装可得答案",
    "messageInitContent_6322": "龙年特辑",
    "messageInitContent_8983": "等我问问ai",
    "messageInitContent_6325": "领域展开",
    "messageInitContent_8988": "敌不动我不动",
    "messageInitContent_6324": "我罩你",
    "messageInitContent_8989": "敌动我不动",
    "messageInitContent_6327": "？？？？？？",
    "messageInitContent_8986": "谁先动谁先赢",
    "messageInitContent_6326": "我已经缝合在冥龙脑子里，所以我知道是我赢了",
    "messageInitContent_8987": "都让你懂了",
    "messageInitContent_8980": "相信第一感觉",
    "messageInitContent_8981": "天知道答案",
    "activityShopName_150": "庆典商店",
    "propConfigName_40264": "出彩的斗笠头像框",
    "propConfigName_40263": "灵感双翼头像框",
    "propConfigName_40266": "桃花头像框",
    "propConfigName_40265": "登峰头像框",
    "propConfigName_40260": "3.0签到战令头像",
    "propConfigName_40262": "生草头像框",
    "propConfigName_40261": "3.1签到战令头像",
    "messageInitContent_6329": "先看谁比较脆",
    "traceStarDes_9": "凿星裂痕关卡描述9",
    "messageInitContent_6328": "你也开高达",
    "traceStarDes_8": "凿星裂痕关卡描述8",
    "propConfigName_40268": "醒狮头像框",
    "traceStarDes_5": "凿星裂痕关卡描述5",
    "propConfigName_40267": "霓虹要素头像框",
    "traceStarDes_4": "凿星裂痕关卡描述4",
    "traceStarDes_7": "凿星裂痕关卡描述7",
    "propConfigName_40269": "致幻要素头像框",
    "traceStarDes_6": "凿星裂痕关卡描述6",
    "messageInitContent_6332": "肯定是右边厉害啊",
    "messageInitContent_8995": "敌懂我懂",
    "traceStarDes_1": "凿星裂痕关卡描述1",
    "messageInitContent_6331": "一般都是蓝色方获胜",
    "messageInitContent_8996": "敌动我懂",
    "messageInitContent_6334": "不是我说，就是",
    "messageInitContent_8993": "敌懂我不懂",
    "traceStarDes_3": "凿星裂痕关卡描述3",
    "messageInitContent_6333": "看看大家选啥先",
    "messageInitContent_8994": "敌不懂我不懂",
    "traceStarDes_2": "凿星裂痕关卡描述2",
    "messageInitContent_6336": "今天选这边",
    "messageInitContent_8999": "敌不懂我动",
    "messageInitContent_6335": "俗话说得好",
    "messageInitContent_6338": "天知道答案",
    "messageInitContent_8997": "敌懂我动",
    "messageInitContent_6337": "就是就是",
    "messageInitContent_8998": "敌动我不懂",
    "messageInitContent_8991": "敌不动我动",
    "messageInitContent_8992": "敌不懂我懂",
    "activityShopName_160": "盛夏商店",
    "messageInitContent_6330": "这里肯定我最硬啊",
    "messageInitContent_8990": "敌动我动",
    "propConfigName_40275": "源初境亚军头像框（31天）",
    "propConfigName_40274": "源初境冠军头像框（31天）",
    "propConfigName_40277": "源初境八强头像框（31天）",
    "propConfigName_40276": "源初境四强头像框（31天）",
    "propConfigName_40271": "常青藤头像框",
    "propConfigName_40270": "开关齿轮头像框",
    "propConfigName_40273": "游园会头像框",
    "propConfigName_40272": "庆礼头像框",
    "messageInitContent_6339": "不是",
    "propConfigName_40279": "源初境三十二强头像框（31天）",
    "propConfigName_40278": "源初境十六强头像框（31天）",
    "messageInitContent_6343": "怎么选",
    "messageInitContent_6342": "啊对对对",
    "messageInitContent_6345": "你说的好有道理",
    "messageInitContent_6344": "就这样吧",
    "messageInitContent_6347": "天知道答案",
    "messageInitContent_6346": "左左右右",
    "messageInitContent_6349": "被赤虹硬控选右",
    "themeCardPackStoryId_605": "TP-001",
    "messageInitContent_6348": "被御空硬控选左",
    "activityShopName_170": "启程商店",
    "themeCardPackStoryId_600": "PC-008",
    "propConfigName_40280": "源初境六十四强头像框（31天）",
    "messageInitContent_6341": "我猜我猜我猜猜猜",
    "messageInitContent_6340": "这边一定对，除非不对",
    "propConfigName_40286": "绀青之影头像框",
    "propConfigName_40285": "星芒头像框",
    "propConfigName_40288": "魔森序章头像框",
    "propConfigName_40287": "诡海一隅头像框",
    "propConfigName_40282": "热浪抱拥头像框",
    "propConfigName_40281": "老玩家头像框",
    "propConfigName_40284": "月色头像框",
    "propConfigName_40283": "浮游鸭泡头像框",
    "propConfigName_40289": "分区帽头像框",
    "messageInitContent_10693": "大力爱呢",
    "messageInitContent_6354": "不够大",
    "messageInitContent_10694": "好嘟",
    "messageInitContent_6353": "我喜欢镇魂！！！",
    "messageInitContent_10695": "这两家伙怎么组队了呢",
    "messageInitContent_6356": "下次大点知道吗",
    "messageInitContent_10696": "霸气果实和毒毒果实",
    "messageInitContent_6355": "晚安御空",
    "messageInitContent_6358": "有什么从鼻子里出来了",
    "messageInitContent_10690": "不许！我不许你舔",
    "messageInitContent_6357": "我已经不是个孩子了",
    "themeCardPackStoryId_615": "TP-003",
    "messageInitContent_10691": "什么毒王霸",
    "messageInitContent_10692": "又是一打2",
    "messageInitContent_6359": "达咩！！！",
    "activityShopName_180": "海鸣商店",
    "themeCardPackStoryId_610": "TP-002",
    "propConfigName_40291": "一周年头像框",
    "propConfigName_40290": "星形彩带头像框",
    "messageInitContent_10697": "那我是竞猜果实，左边",
    "messageInitContent_6350": "那不是重装嘛",
    "messageInitContent_10698": "这家伙脸上怎么写着名字",
    "messageInitContent_10699": "好难猜哦",
    "messageInitContent_6352": "什么xp系统选边",
    "messageInitContent_6351": "那不是镇剧嘛",
    "activityShopName_100": "创世商店",
    "propConfigName_40297": "不朽图腾",
    "propConfigName_40296": "生命图腾",
    "propConfigName_40299": "许愿卡",
    "propConfigName_40298": "火冕形态",
    "propConfigName_40293": "古陶图腾",
    "propConfigName_40292": "角灵图腾",
    "propConfigName_40295": "先祖图腾",
    "propConfigName_40294": "金乌图腾",
    "messageInitContent_10682": "有啥答案和哥说",
    "messageInitContent_6365": "这个场面我还真没见过",
    "messageInitContent_10683": "嘻嘻嘻",
    "messageInitContent_6364": "对对对",
    "messageInitContent_10684": "小打小闹",
    "messageInitContent_6367": "赤虹最高的一集",
    "messageInitContent_10685": "在猜了在猜了",
    "messageInitContent_6366": "这咋选呢手心手背都是肉",
    "messageInitContent_6369": "建议再大点",
    "themeCardPackStoryId_625": "TP-005",
    "messageInitContent_6368": "这么狠心把我御空放第一",
    "messageInitContent_10680": "对对，这对嘛",
    "messageInitContent_10681": "行不行啊到底",
    "messageInitContent_10686": "正在猜",
    "messageInitContent_6361": "我的舌头突然不受控制",
    "messageInitContent_10687": "正确的",
    "messageInitContent_6360": "不能酱紫哦",
    "messageInitContent_10688": "技能知道答案",
    "messageInitContent_6363": "别打了别打了你们都是我的翅膀",
    "messageInitContent_10689": "技能不知道",
    "messageInitContent_6362": "我有一个大胆的想法",
    "themeCardPackStoryId_620": "TP-004",
    "activityShopName_110": "老莫集市",
    "messageInitContent_10671": "暗中观察",
    "messageInitContent_6376": "摩多摩多",
    "messageInitContent_10672": "家人们谁懂啊",
    "messageInitContent_6375": "技能都不用看",
    "messageInitContent_10673": "发女装可得答案",
    "messageInitContent_6378": "新兽保护期get",
    "messageInitContent_10674": "猜对的方程式已经想好了",
    "messageInitContent_6377": "爱就像泡沫",
    "messageInitContent_6379": "人家每期一创，我每期一对",
    "messageInitContent_10670": "知道了",
    "messageInitContent_10679": "醒醒别做梦",
    "messageInitContent_6370": "不是",
    "themeCardPackStoryId_635": "TP-007",
    "messageInitContent_10675": "今天选人少的",
    "messageInitContent_6372": "过分！",
    "messageInitContent_10676": "交答案税",
    "messageInitContent_6371": "狠",
    "messageInitContent_10677": "ai知道答案",
    "messageInitContent_6374": "这都哪跟哪呢",
    "themeCardPackStoryId_630": "TP-006",
    "messageInitContent_10678": "天知道答案",
    "messageInitContent_6373": "御空保护协会表示反对！",
    "activityShopName_120": "腾龙商店",
    "messageInitContent_10660": "桐仁能否打破自己的2秒传奇就在此一役",
    "messageInitContent_6387": "让我对一次吧",
    "messageInitContent_10661": "什么时候出个鱼王锦鲤皮肤。",
    "messageInitContent_6386": "可可爱爱",
    "messageInitContent_10662": "桐仁能否顶住呢！",
    "messageInitContent_6389": "我选了这边",
    "messageInitContent_10663": "其实大嘴鱼王怎么区分性别的",
    "messageInitContent_6388": "先这样吧",
    "messageInitContent_10668": "原生怪=1个技能",
    "messageInitContent_10669": "帮你做个技能检查",
    "messageInitContent_6381": "那么谁在输出",
    "messageInitContent_6380": "怪呢",
    "messageInitContent_10664": "又一个第一天",
    "messageInitContent_6383": "看看卡池，懂了",
    "activityShopName_130": "黑街商店",
    "messageInitContent_10665": "其他几个小强呢",
    "messageInitContent_6382": "这是博弈",
    "themeCardPackStoryId_640": "TP-008",
    "messageInitContent_10666": "不许欺负鱼鱼",
    "messageInitContent_6385": "你猜猜你猜的对不对",
    "messageInitContent_10667": "最喜欢看原生怪打架了，只有1个技能",
    "messageInitContent_6384": "总有一个是错的",
    "monsterName_1": "陆龙",
    "monsterName_8": "逆焰龙帝",
    "monsterName_9": "鸟龙",
    "monsterName_6": "逆焰龙王",
    "monsterName_7": "钢铁龙帝",
    "monsterName_4": "荒火龙",
    "monsterName_5": "钢铁龙王",
    "monsterName_2": "暴龙",
    "monsterName_3": "铁甲龙",
    "messageInitContent_6398": "希望大家蒙的都对",
    "messageInitContent_10650": "怎么才来",
    "messageInitContent_6397": "wow",
    "messageInitContent_10651": "我是喵粉丝",
    "messageInitContent_10652": "怎么还不发我答案",
    "messageInitContent_6399": "我的心被沸体硬控",
    "messageInitContent_10657": "幻想全都对",
    "messageInitContent_6390": "该洗洗睡了",
    "messageInitContent_10658": "收工",
    "messageInitContent_10659": "晚安怪兽",
    "messageInitContent_6392": "晚安大小姐",
    "messageInitContent_6391": "压力来到了最后一天",
    "activityShopName_140": "荧光商店",
    "messageInitContent_10653": "不许熬夜",
    "messageInitContent_6394": "都让你懂完了",
    "messageInitContent_10654": "不要再打啦不要再打啦",
    "messageInitContent_6393": "是是是",
    "messageInitContent_10655": "我家猫帮我选了",
    "messageInitContent_6396": "看我局部巨大化",
    "messageInitContent_10656": "咋选",
    "messageInitContent_6395": "总有一个对的",
    "messageInitContent_10639": "牌面",
    "messageInitContent_10640": "握爪会我第一个到",
    "messageInitContent_10641": "摸摸喵响的小爪子",
    "messageInitContent_8900": "上猫条",
    "messageInitContent_8901": "上逗猫棒",
    "messageInitContent_10646": "到底哪边啊",
    "messageInitContent_10647": "硬猜",
    "messageInitContent_10648": "说答案吧，我在蹲",
    "messageInitContent_10649": "幻幻幻我来啦",
    "messageInitContent_10642": "学学耄耋",
    "messageInitContent_10643": "变态有变态",
    "messageInitContent_10644": "会跳扫腿舞吗",
    "messageInitContent_10645": "快交出答案",
    "messageInitContent_10628": "在你婶婶的脑海里",
    "messageInitContent_10629": "哎呦喂",
    "messageInitContent_8904": "这椅子我转定了",
    "messageInitContent_8905": "音响对碰",
    "messageInitContent_8902": "不要干扰选手战斗",
    "messageInitContent_8903": "隔壁的猫是贝斯和鼓手",
    "messageInitContent_8908": "可以点歌吗",
    "messageInitContent_8909": "怎么到隔壁片场了",
    "messageInitContent_8906": "镇魂是大猫",
    "messageInitContent_8907": "歌唱比赛",
    "messageInitContent_10630": "什么时候也搞个联动",
    "messageInitContent_8911": "猜对day1",
    "messageInitContent_8912": "喵响会后空翻吗",
    "messageInitContent_8910": "今天选人多的",
    "messageInitContent_10635": "什么时候出道",
    "messageInitContent_10636": "头号粉丝来了",
    "messageInitContent_10637": "来啦来啦",
    "messageInitContent_10638": "但凡换些队友给雷鸣",
    "messageInitContent_10631": "小弟不给力啊",
    "messageInitContent_10632": "经典新怪场",
    "messageInitContent_10633": "哪里开演唱会",
    "messageInitContent_10634": "主场不够拼命啊",
    "messageInitContent_10617": "超级控制变量",
    "messageInitContent_10618": "看我去掉变量",
    "messageInitContent_10619": "今天选人少的",
    "messageInitContent_8915": "超进化乐队？",
    "messageInitContent_8916": "镇魂晕了",
    "messageInitContent_8913": "我猜我猜我猜猜猜",
    "messageInitContent_8914": "左左右右",
    "messageInitContent_8919": "随机点",
    "messageInitContent_8917": "肯定是那边啊",
    "messageInitContent_8918": "经典看技能",
    "messageInitContent_8922": "技能知道答案",
    "messageInitContent_8923": "别打了唱歌吧！",
    "messageInitContent_8920": "相信哥是左边",
    "messageInitContent_8921": "泡个面先",
    "messageInitContent_10624": "每次都有你",
    "messageInitContent_10625": "答案在哪里",
    "messageInitContent_10626": "春天在哪里呀",
    "messageInitContent_10627": "在你心里",
    "messageInitContent_10620": "猜对明天加香蕉",
    "messageInitContent_10621": "明明想选你",
    "messageInitContent_10622": "快快交出答案",
    "messageInitContent_10623": "猜对day0",
    "messageInitContent_10606": "我打我自己？",
    "messageInitContent_10607": "我白虎呢",
    "messageInitContent_10608": "谁家神唤跑丢了",
    "messageInitContent_10609": "认领认领",
    "messageInitContent_8926": "有故事",
    "messageInitContent_8927": "嗯？",
    "messageInitContent_8924": "门票get",
    "messageInitContent_8925": "三打2",
    "messageInitContent_8928": "啥情况",
    "messageInitContent_8929": "有情况",
    "messageInitContent_8930": "那边是aoe",
    "messageInitContent_8933": "猜对day1",
    "messageInitContent_8934": "你行不行",
    "messageInitContent_8931": "我有一个大胆的想法",
    "messageInitContent_8932": "冲冲冲",
    "messageInitContent_10613": "两边人一样",
    "messageInitContent_10614": "赢的神唤",
    "messageInitContent_10615": "都被你说了",
    "messageInitContent_10616": "你说的都对",
    "messageInitContent_10610": "让我康康",
    "messageInitContent_10611": "我觉得左边厉害",
    "messageInitContent_10612": "今天选人多的",
    "messageInitContent_8937": "行行行行行行行行行行行行",
    "messageInitContent_8938": "不太行",
    "messageInitContent_8935": "那个字怎么多",
    "messageInitContent_8936": "怪兽赢了",
    "messageInitContent_8939": "你今天行了吗",
    "messageInitContent_8940": "无脑左边",
    "messageInitContent_8941": "收工",
    "messageInitContent_8944": "给个机会",
    "messageInitContent_8945": "人越多人越少",
    "messageInitContent_8942": "等我问问ai",
    "messageInitContent_8943": "快交出答案",
    "messageInitContent_10602": "百年神唤玩家在此",
    "messageInitContent_10603": "牌面",
    "messageInitContent_10604": "神唤个人show？",
    "activityShopName_190": "尖叫橱窗",
    "messageInitContent_10605": "我本格朱雀没有牌面是吧",
    "messageInitContent_10600": "神灵下场",
    "messageInitContent_10601": "十年神唤玩家在此",
    "messageInitContent_8948": "左左右右",
    "messageInitContent_8949": "我家猫帮我选了",
    "messageInitContent_8946": "玄学告诉我选右",
    "messageInitContent_8947": "超纲了",
    "messageInitContent_8951": "未尝一对",
    "messageInitContent_8952": "对吗？不对吧",
    "messageInitContent_8950": "huh？",
    "messageInitContent_8955": "第一天经典小怪打架",
    "messageInitContent_8956": "幼体小朋友你们是不是有很多问号",
    "messageInitContent_8953": "哈哈哈哈",
    "messageInitContent_8954": "坏了",
    "messageInitContent_8959": "没想到吧腐食者是远程",
    "messageInitContent_8957": "一个近战一个远程",
    "messageInitContent_8958": "1个技能不多说",
    "messageInitContent_8962": "看谁跑的快",
    "messageInitContent_8963": "看谁打的快",
    "messageInitContent_6301": "瞎选全对",
    "messageInitContent_8960": "丢食物吗不可以浪费食物哦",
    "messageInitContent_6300": "霸者极巨化",
    "messageInitContent_8961": "是口水",
    "messageInitContent_6303": "你说的都对",
    "messageInitContent_8966": "在猜了在猜了",
    "messageInitContent_6302": "big胆",
    "messageInitContent_8967": "预言一下赢的是这边",
    "messageInitContent_6305": "竞猜之神在此",
    "messageInitContent_8964": "废话文学大合集",
    "messageInitContent_6304": "什么时候出门神",
    "messageInitContent_8965": "给个机会",
    "messageInitContent_6307": "点个外卖再想",
    "messageInitContent_6306": "多运动多吃水果",
    "messageInitContent_6309": "依我看",
    "messageInitContent_8968": "看一眼技能懂了",
    "messageInitContent_6308": "歪，策划吗？答案是哪边啊",
    "messageInitContent_8969": "希望大家蒙的都对",
    "messageInitContent_6310": "这是f人",
    "messageInitContent_8973": "坏了",
    "messageInitContent_8974": "一只叉叉路过",
    "messageInitContent_6312": "我要和喵响贴贴",
    "messageInitContent_8971": "ai知道答案",
    "messageInitContent_6311": "随机翻一边的牌子",
    "messageInitContent_8972": "家人们谁懂啊",
    "messageInitContent_6314": "霸气外漏",
    "messageInitContent_8977": "抄作业时间到",
    "messageInitContent_6313": "来啊，有本事告诉我答案啊",
    "messageInitContent_8978": "抛个硬币看看",
    "messageInitContent_6316": "奖励自己乱猜一次",
    "messageInitContent_8975": "这技能我熟",
    "messageInitContent_6315": "你们猜猜我选了啥",
    "messageInitContent_8976": "人越多人越少",
    "messageInitContent_8970": "正确的",
    "messageInitNick_6496": "搬砖神",
    "messageInitNick_6497": "前年放假",
    "messageInitNick_6498": "似梦非梦",
    "messageInitNick_6499": "伴你如伴狗",
    "messageInitNick_6492": "无敌卷王",
    "messageInitNick_6493": "好多鱼",
    "messageInitNick_6494": "人海中遇到你",
    "messageInitNick_6495": "七千岁娘子",
    "messageInitNick_6490": "显卡说它好累",
    "messageInitNick_6491": "迷宫的麋鹿",
    "messageInitNick_6489": "无公害西兰花",
    "messageInitNick_6485": "美术在线卖饼",
    "messageInitNick_6486": "小白鲨",
    "messageInitNick_6487": "从心动到心痛",
    "messageInitNick_6488": "数据大师",
    "messageInitNick_6481": "深海废墟",
    "messageInitNick_6482": "尽情摇摆",
    "messageInitNick_6483": "暴风吸入狗粮",
    "messageInitNick_6484": "老鼠咬鼠标",
    "messageInitNick_6480": "六档看守",
    "messageInitNick_6478": "数据之眼",
    "messageInitNick_6479": "神仙打假",
    "messageInitNick_6474": "魂歌者",
    "messageInitNick_6475": "素馄饨",
    "messageInitNick_6476": "大闹婚礼",
    "messageInitNick_6477": "江湖不良人",
    "messageInitNick_6470": "胭脂泪",
    "messageInitNick_6471": "枯守青灯",
    "messageInitNick_6472": "带劲小伙",
    "messageInitNick_6473": "最强明灯",
    "messageInitNick_6467": "重新定义躺赢",
    "messageInitNick_6468": "我超甜",
    "messageInitNick_6469": "名字还没想好",
    "messageInitNick_6463": "我宣你你造吗",
    "messageInitNick_6464": "沉浸式绘画",
    "messageInitNick_6465": "防弹苹果",
    "messageInitNick_6466": "颈椎",
    "messageInitNick_6460": "吹皱一池春水",
    "messageInitNick_6461": "孟婆来碗汤",
    "messageInitNick_6462": "单身只为等你",
    "messageInitNick_6456": "雅痞",
    "visionSagesOption2_7": "十年",
    "messageInitNick_6457": "爱情这场戏",
    "visionSagesOption2_8": "会，50%返还",
    "messageInitNick_6458": "五个观众",
    "visionSagesOption2_5": "基本没用",
    "messageInitNick_6459": "一夜美梦",
    "visionSagesOption2_6": "难度越高掉落越低",
    "messageInitNick_6452": "接头人",
    "visionSagesOption2_3": "将策划饲星（选我！答错误奖励也一样）",
    "messageInitNick_6453": "无尽的风暴",
    "visionSagesOption2_4": "有问题，就会有答案",
    "messageInitNick_6454": "请勿打扰",
    "visionSagesOption2_1": "霸气越高越容易当上海贼王",
    "messageInitNick_6455": "差不多先生",
    "visionSagesOption2_2": "躺平！",
    "visionSagesOption2_9": "好友是什么？",
    "plateName_20": "隔绝协议",
    "plateName_21": "至高消散",
    "plateName_22": "反赋烙印",
    "messageInitNick_6450": "豆角真好吃",
    "messageInitNick_6451": "笨笨的聪明猪",
    "messageInitNick_6445": "最强戒指",
    "messageInitNick_6446": "进击星人",
    "messageInitNick_6447": "指定网恋对象",
    "messageInitNick_6448": "不知道叫什么",
    "messageInitNick_6441": "丛林野狼",
    "messageInitNick_6442": "划水少年",
    "messageInitNick_6443": "大佬下凡",
    "messageInitNick_6444": "闪现撞墙",
    "plateName_17": "蔑视",
    "plateName_18": "蔑视扫荡",
    "plateName_19": "隔绝",
    "messageInitNick_6449": "神秘异境的你",
    "plateName_13": "威能",
    "plateName_14": "威能爆发",
    "plateName_15": "强魄",
    "plateName_16": "强魄注入",
    "plateName_10": "破甲豁免",
    "plateName_11": "无损开场",
    "plateName_12": "死神禁令",
    "messageInitNick_6440": "再鸽几天",
    "messageInitNick_6434": "油菜兽",
    "messageInitNick_6435": "强壮卖惨神",
    "messageInitNick_6436": "叫我淡定姐",
    "messageInitNick_6437": "爱到违规",
    "messageInitNick_6430": "向量之神",
    "messageInitNick_6431": "饺子的棉袄",
    "messageInitNick_6432": "收购寂寞",
    "messageInitNick_6433": "流淌的声音",
    "messageInitNick_6438": "明亮眼镜",
    "messageInitNick_6439": "数码沙发",
    "messageInitNick_6423": "我是你的大脑",
    "messageInitNick_6424": "笨丫头",
    "messageInitNick_6425": "奢华的护肤品",
    "messageInitNick_6426": "半心给了你",
    "messageInitNick_6420": "拆了奈何桥",
    "messageInitNick_6421": "抱着孤单睡",
    "messageInitNick_6422": "超时空冷冻柜",
    "themeCardPackStoryId_545": "MW-005",
    "messageInitNick_6427": "云中飞皂",
    "themeCardPackStoryId_540": "MW-004",
    "messageInitNick_6428": "过期专家",
    "messageInitNick_6429": "车厘子龙",
    "themeCardPackStoryId_550": "MW-006",
    "messageInitNick_6412": "穿甲装备",
    "messageInitNick_6413": "反正我不信",
    "messageInitNick_6414": "多汁的芭乐",
    "messageInitNick_6415": "西瓜兽",
    "messageInitNick_6410": "等个怀抱",
    "messageInitNick_6411": "短腿猫不吃鱼",
    "themeCardPackStoryId_555": "MW-007",
    "messageInitNick_6416": "最强碗",
    "messageInitNick_6417": "半个灵魂",
    "messageInitNick_6418": "春去秋又来",
    "messageInitNick_6419": "凉拌香蕉",
    "activityShopName_200": "周年商店",
    "themeCardPackStoryId_560": "MW-008",
    "messageInitNick_6401": "水下法师",
    "messageInitNick_6402": "低头的向日葵",
    "messageInitNick_6403": "扫黄大队长",
    "messageInitNick_6404": "左肩蝶舞",
    "messageInitNick_6400": "霹雳水精灵",
    "messageInitNick_6409": "夺宝才子",
    "messageInitNick_6405": "家有水龙头",
    "messageInitNick_6406": "枕边猫",
    "messageInitNick_6407": "破阵砖家",
    "messageInitNick_6408": "天命大人",
    "themeCardPackStoryId_565": "PC-001",
    "activityShopName_210": "春祈花市",
    "themeCardPackStoryId_570": "PC-002",
    "propConfigName_40200": "花环刃法头像框",
    "propConfigName_40206": "火纹犄角头像框",
    "propConfigName_40205": "骰之支配头像框",
    "propConfigName_40208": "超量辉芒头像框",
    "propConfigName_40207": "永恒樱彩头像框",
    "propConfigName_40202": "金色通道头像框",
    "propConfigName_40201": "静谧侵袭头像框",
    "propConfigName_40204": "镜像开幕头像框",
    "propConfigName_40203": "镇户獠牙头像框",
    "hintName_8": "永生之茧",
    "hintName_7": "部落冒险",
    "propConfigName_40209": "寰宇圣冠头像框",
    "hintName_6": "凿星裂痕",
    "hintName_5": "起源殿",
    "hintName_4": "斗技场",
    "hintName_3": "黑暗森林",
    "hintName_2": "探索奖励",
    "themeCardPackStoryId_575": "PC-003",
    "themeCardPackStoryId_580": "PC-004",
    "propConfigName_40211": "星徙奇谭头像框",
    "propConfigName_40210": "危情之拥头像框",
    "propConfigName_40217": "金属凝视头像框",
    "propConfigName_40216": "闪耀切面头像框",
    "propConfigName_40219": "契约头像框40219",
    "propConfigName_40218": "契约头像框40218",
    "propConfigName_40213": "深海电波头像框",
    "propConfigName_40212": "翔天碧鳞头像框",
    "propConfigName_40215": "示位秘环头像框",
    "propConfigName_40214": "悸动轨迹头像框",
    "themeCardPackStoryId_585": "PC-005",
    "propConfigName_40220": "契约头像框40220",
    "propConfigName_40222": "契约头像框40222",
    "propConfigName_40221": "契约头像框40221",
    "themeCardPackStoryId_590": "PC-006",
    "propConfigName_40228": "契约头像框40228",
    "propConfigName_40227": "契约头像框40227",
    "propConfigName_40229": "契约头像框40229",
    "propConfigName_40224": "契约头像框40224",
    "propConfigName_40223": "契约头像框40223",
    "propConfigName_40226": "契约头像框40226",
    "propConfigName_40225": "契约头像框40225",
    "themeCardPackStoryId_595": "PC-007",
    "propConfigName_40231": "契约头像框40231",
    "propConfigName_40230": "契约头像框40230",
    "propConfigName_40233": "福到头像",
    "propConfigName_40232": "兵也头像",
    "propConfigName_40239": "源初境亚军头像（31天）",
    "propConfigName_40238": "源初境冠军头像（31天）",
    "propConfigName_40235": "示梦器头像",
    "propConfigName_40234": "引导者头像（31天）",
    "propConfigName_40237": "半周年头像",
    "propConfigName_40236": "花花点赞头像",
    "propConfigName_40242": "源初境十六强头像（31天）",
    "propConfigName_40241": "源初境八强头像（31天）",
    "propConfigName_40244": "源初境六十四强头像（31天）",
    "propConfigName_40243": "源初境三十二强头像（31天）",
    "propConfigName_40240": "源初境四强头像（31天）",
    "propConfigName_40249": "南瓜开门头像",
    "propConfigName_40246": "骄阳潜梦头像",
    "propConfigName_40245": "老玩家头像",
    "propConfigName_40248": "狞笑之藻头像",
    "propConfigName_40247": "浩劫残月头像",
    "propConfigName_40374": "起龙头像框",
    "propConfigName_40373": "旋转舞台头像框",
    "propConfigName_40376": "蜡笔小花头像框",
    "propConfigName_40375": "威权杖冠头像框",
    "propConfigName_40370": "3.0签到战令头像框",
    "propConfigName_40372": "祥云灯彩头像框",
    "propConfigName_40371": "3.1签到战令头像框",
    "messageInitContent_6439": "你，得到什么启示了！",
    "messageInitContent_6438": "咆哮",
    "propConfigName_40378": "一弯秋叶头像框",
    "propConfigName_40377": "兔兔奔月头像框",
    "propConfigName_40379": "二周年头像框",
    "messageInitContent_6442": "爱棒！",
    "messageInitContent_6441": "双拳难敌四手",
    "messageInitContent_6444": "该不会是……",
    "messageInitContent_6443": "哈huh？",
    "messageInitContent_6446": "这边一定对，除非不对",
    "messageInitContent_6445": "是2v2！",
    "messageInitContent_6448": "你有什么启示吗",
    "messageInitContent_6447": "这回不是单挑了",
    "messageInitContent_6440": "不混合双打",
    "propConfigName_40385": "神导石",
    "propConfigName_40384": "好运粽子",
    "propConfigName_40387": "繁花月饼",
    "propConfigName_40386": "调色花",
    "propConfigName_40381": "3.0商店头像框",
    "propConfigName_40380": "2.9商店头像框",
    "propConfigName_40383": "奇观糖果",
    "propConfigName_40382": "3.1商店头像框",
    "messageInitContent_6449": "大家好我是当事人",
    "propConfigName_40389": "周年星块",
    "propConfigName_40388": "枫印石",
    "messageInitContent_10594": "渴望答案的眼神是藏不住的",
    "messageInitContent_6453": "饿emmm",
    "messageInitContent_10595": "想乱选的想法是有的",
    "messageInitContent_6452": "是aoe",
    "messageInitContent_10596": "先让我缓缓",
    "messageInitContent_6455": "群殴不是一目了然",
    "messageInitContent_10597": "咋选",
    "messageInitContent_6454": "猜对day1",
    "messageInitContent_10590": "这都哪跟哪呢",
    "messageInitContent_6457": "这aoe可不是白给的",
    "messageInitContent_10591": "不要再解释了",
    "messageInitContent_6456": "人越多人越少",
    "messageInitContent_10592": "该不会是……",
    "messageInitContent_6459": "摸鱼时间",
    "messageInitContent_10593": "仰望",
    "messageInitContent_6458": "天天开心",
    "propConfigName_40390": "2.9版本道具",
    "messageInitContent_10598": "差不多得了",
    "messageInitContent_10599": "又能怎",
    "messageInitContent_6451": "剑盾的孩子",
    "messageInitContent_6450": "我才知道他叫这名",
    "propConfigName_40398": "戏游形态",
    "propConfigName_40397": "畸轨形态",
    "propConfigName_40392": "3.1版本道具",
    "propConfigName_40391": "3.0版本道具",
    "propConfigName_40394": "缠魂形态",
    "propConfigName_40393": "嵌合形态",
    "messageInitContent_10583": "表白艾娜",
    "messageInitContent_6464": "充满启示",
    "messageInitContent_10584": "妙哇",
    "messageInitContent_6463": "是是是",
    "messageInitContent_10585": "我只是个孩子",
    "messageInitContent_6466": "主角赢",
    "messageInitContent_10586": "我的宝贝答案呢",
    "messageInitContent_6465": "启示启示启示启示启示",
    "messageInitContent_6468": "盾打兵",
    "messageInitContent_10580": "怪与自然",
    "messageInitContent_6467": "主打一个随缘",
    "messageInitContent_10581": "这里是预言家，左",
    "messageInitContent_10582": "快进到明天",
    "messageInitContent_6469": "秒不掉就输",
    "messageInitContent_10587": "正在猜",
    "messageInitContent_6460": "左左右右前前后后",
    "messageInitContent_10588": "猜对的方程式已经想好了",
    "messageInitContent_10589": "抛硬币中",
    "messageInitContent_6462": "二打二了解",
    "messageInitContent_6461": "叉会腰",
    "messageInitContent_10572": "赶紧出道吧",
    "messageInitContent_6475": "兵器最怕的一集",
    "messageInitContent_10573": "创晓：？？就我硬凑",
    "messageInitContent_6474": "我为盾打call",
    "messageInitContent_10574": "康康你们霸气",
    "messageInitContent_6477": "又单挑哦",
    "messageInitContent_10575": "帅好帅~",
    "messageInitContent_6476": "不难",
    "messageInitContent_6479": "给个机会",
    "messageInitContent_6478": "第三天的远古族",
    "messageInitContent_10570": "抱走漆黑组件",
    "messageInitContent_10571": "抱走我螺旋桨",
    "messageInitContent_10576": "美好美~",
    "messageInitContent_6471": "相信第一感觉",
    "messageInitContent_10577": "想看女团",
    "messageInitContent_6470": "怎么对上了",
    "messageInitContent_10578": "科技与狠活",
    "messageInitContent_6473": "哈哈哈",
    "messageInitContent_10579": "人与自然",
    "messageInitContent_6472": "那边没有续航啊",
    "messageInitContent_10561": "不要再打啦不要再打啦",
    "messageInitContent_6486": "这次不担心被偷后背了",
    "messageInitContent_10562": "不许熬夜",
    "messageInitContent_6485": "猜对day1",
    "messageInitContent_10563": "帮我选好嘛",
    "messageInitContent_6488": "点头",
    "messageInitContent_10564": "欧拉欧拉欧拉欧拉",
    "messageInitContent_6487": "大家好",
    "messageInitContent_6489": "怎么就对上了",
    "messageInitContent_10560": "起床了打工怪",
    "messageInitContent_10569": "到底哪边啊",
    "messageInitContent_6480": "问题不大",
    "messageInitContent_10565": "别说了",
    "messageInitContent_6482": "人家又免伤又回血",
    "messageInitContent_10566": "多好的怪呀怎么上竞猜了",
    "messageInitContent_6481": "让我对一次吧",
    "messageInitContent_10567": "答案公开",
    "messageInitContent_6484": "大喊mamoru",
    "messageInitContent_10568": "没有答案浑身难受",
    "messageInitContent_6483": "什么远古族专场",
    "messageInitContent_10550": "给个机会",
    "messageInitContent_6497": "打不动吧",
    "messageInitContent_10551": "抛硬币中",
    "messageInitContent_6496": "先让我缓缓",
    "messageInitContent_10552": "坏了没有硬币",
    "messageInitContent_6499": "这buff起来怎么过",
    "messageInitContent_10553": "晚安大小姐",
    "messageInitContent_6498": "又是2V2呢",
    "messageInitContent_10558": "怎么还不发我答案",
    "messageInitContent_10559": "宝，知道大难记得告诉我呢",
    "messageInitContent_6491": "等大家选完",
    "messageInitContent_6490": "未尝一对",
    "messageInitContent_10554": "冷静",
    "messageInitContent_6493": "欧啦欧啦欧拉",
    "messageInitContent_10555": "啊这",
    "messageInitContent_6492": "根本停不下来",
    "messageInitContent_10556": "上班",
    "messageInitContent_6495": "咋选",
    "messageInitContent_10557": "看看我的答案在不在",
    "messageInitContent_6494": "我get到了",
    "messageInitContent_10540": "谁家植物跑出来了",
    "messageInitContent_10541": "肉食植物吗",
    "messageInitContent_10542": "捕兽草",
    "98_-180003": "起源殿开放时间为{1}",
    "skillName_27": "虹吸·抹煞",
    "98_-180002": "cjhwy2",
    "skillName_28": "虹吸·腐化",
    "98_-180001": "尚未完成同步",
    "skillName_29": "虹吸·神速",
    "98_-180007": "cjhwy2",
    "messageInitContent_10547": "不要凶不凶的凶噬魔",
    "skillName_23": "不死·根性强化",
    "98_-180006": "战斗id非法",
    "messageInitContent_10548": "徒弟的师傅是谁",
    "skillName_24": "不死·尸气强化",
    "98_-180005": "读锁",
    "messageInitContent_10549": "好冷啊",
    "skillName_25": "虹吸",
    "98_-180004": "cjhwy2",
    "skillName_26": "虹吸·觉醒",
    "messageInitContent_10543": "这是我一物一拍的植物",
    "messageInitContent_10544": "比前排",
    "skillName_20": "不死·尸气",
    "98_-180009": "挑战次数不足",
    "messageInitContent_10545": "给风水老树看风水，我看输",
    "skillName_21": "不死·霸体",
    "98_-180008": "怪兽已完成锁定",
    "messageInitContent_10546": "我为什么我去点菜没有花丸子",
    "skillName_22": "不死·神行",
    "messageInitContent_10529": "刚来选啥",
    "messageInitContent_10530": "有啥答案和哥说",
    "messageInitContent_10531": "保持微笑",
    "skillName_16": "龙焰·双生强化",
    "skillName_17": "不死",
    "skillName_18": "不死·觉醒",
    "skillName_19": "不死·根性",
    "messageInitContent_10536": "答案使我快乐",
    "skillName_12": "龙焰·双生",
    "messageInitContent_10537": "猜对的方程式已经想好了",
    "skillName_13": "龙焰·底力",
    "messageInitContent_10538": "幻想全都对",
    "skillName_14": "龙焰·神速",
    "messageInitContent_10539": "对对对",
    "skillName_15": "龙焰·黯炎强化",
    "messageInitContent_10532": "别急",
    "messageInitContent_10533": "HUH？",
    "messageInitContent_10534": "下班",
    "skillName_10": "龙焰·觉醒",
    "messageInitContent_10535": "我的方向盘呢",
    "skillName_11": "龙焰·黯炎",
    "monsterPolarityConfigName_21": "血化硬甲",
    "monsterPolarityConfigName_20": "最终战吼",
    "skillName_50": "骗术·觉醒",
    "skillName_51": "骗术·反击",
    "messageInitContent_10518": "能不能扛得住是个问题",
    "messageInitContent_10519": "问题是谁呢",
    "monsterPolarityConfigName_29": "恒战机能",
    "monsterPolarityConfigName_28": "心率超频 ",
    "monsterPolarityConfigName_27": "基因破则",
    "monsterPolarityConfigName_26": "强攻诱导",
    "monsterPolarityConfigName_25": "坏死爆破",
    "monsterPolarityConfigName_24": "苏生诅咒",
    "monsterPolarityConfigName_23": "噬魂回复",
    "monsterPolarityConfigName_22": "影子心脏",
    "messageInitContent_10520": "咋选",
    "skillName_49": "骗术",
    "messageInitContent_10525": "夜观星象不知答案",
    "skillName_45": "引力·神速",
    "messageInitContent_10526": "夜观星象睡着了",
    "skillName_46": "引力·底力",
    "messageInitContent_10527": "晚安各位",
    "skillName_47": "引力·地裂强化",
    "messageInitContent_10528": "大佬快来指路",
    "skillName_48": "引力·贯穿强化",
    "messageInitContent_10521": "超纲了",
    "skillName_41": "引力",
    "messageInitContent_10522": "走近竞猜",
    "skillName_42": "引力·觉醒",
    "messageInitContent_10523": "瞎想",
    "skillName_43": "引力·地裂",
    "messageInitContent_10524": "行不行啊到底",
    "skillName_44": "引力·贯穿",
    "monsterPolarityConfigName_32": "屠戮追击",
    "monsterPolarityConfigName_31": "爆裂之种",
    "monsterPolarityConfigName_30": "反噬打击",
    "skillName_40": "星陨·余温强化",
    "messageInitContent_10507": "给网线把脉",
    "messageInitContent_10508": "潜伏ing",
    "messageInitContent_10509": "又活了一天开心",
    "monsterPolarityConfigName_37": "破韧之锋",
    "monsterPolarityConfigName_36": "坚韧之璧",
    "monsterPolarityConfigName_35": "缓速之殇",
    "monsterPolarityConfigName_34": "能限突破",
    "monsterPolarityConfigName_33": "缓速反抗",
    "skillName_38": "星陨·回复",
    "skillName_39": "星陨·残响强化",
    "messageInitContent_10514": "嗷嗷嗷嗷嗷",
    "skillName_34": "星陨·觉醒",
    "messageInitContent_10515": "谁把你打得嗷嗷叫",
    "skillName_35": "星陨·残响",
    "messageInitContent_10516": "甜菜",
    "skillName_36": "星陨·余温",
    "messageInitContent_10517": "懵逼冲击",
    "skillName_37": "星陨·回复",
    "messageInitContent_10510": "恶龙咆哮",
    "skillName_30": "虹吸·回复",
    "messageInitContent_10511": "饿龙咆哮",
    "skillName_31": "虹吸·抹煞强化",
    "messageInitContent_10512": "鸟龙咆哮",
    "skillName_32": "虹吸·腐化强化",
    "messageInitContent_10513": "嗷呜",
    "skillName_33": "星陨",
    "skillName_70": "混沌之力·狂噬",
    "skillName_71": "混沌之力·暴戾",
    "skillName_72": "混沌之力·扼制",
    "skillName_73": "传说之力",
    "messageInitContent_10503": "到底哪边啊",
    "skillName_67": "混沌之力·狂暴",
    "messageInitContent_10504": "交答案税",
    "skillName_68": "混沌之力·嗜魂",
    "messageInitContent_10505": "今天选人少的",
    "skillName_69": "混沌之力·暴走",
    "messageInitContent_10506": "你们有没有发现",
    "skillName_63": "静默·延续强化",
    "messageInitContent_10500": "技能告诉我是右",
    "skillName_64": "静默·泯灭强化",
    "messageInitContent_10501": "怪兽赢了",
    "skillName_65": "混沌之力",
    "messageInitContent_10502": "肯定是那边啊",
    "skillName_66": "混沌之力·觉醒",
    "monsterPolarityConfigName_10": "移动增速",
    "skillName_60": "静默·泯灭",
    "skillName_61": "静默·神速",
    "skillName_62": "静默·神速",
    "monsterPolarityConfigName_18": "体格冲击",
    "monsterPolarityConfigName_17": "沉默反射",
    "monsterPolarityConfigName_16": "激发效应",
    "monsterPolarityConfigName_15": "应激屏障",
    "monsterPolarityConfigName_14": "协同护佑",
    "monsterPolarityConfigName_13": "再生失活",
    "monsterPolarityConfigName_12": "厄运催化",
    "monsterPolarityConfigName_11": "质壁分离",
    "monsterPolarityConfigName_19": "生命余波",
    "skillName_56": "骗术·联结强化",
    "skillName_57": "静默",
    "skillName_58": "静默·觉醒",
    "skillName_59": "静默·延续",
    "skillName_52": "骗术·联结",
    "skillName_53": "骗术·神行",
    "skillName_54": "骗术·霸体",
    "skillName_55": "骗术·反击强化",
    "skillName_92": "异能·摄取",
    "skillName_93": "异能·界限",
    "skillName_94": "奏",
    "skillName_95": "奏·战殇",
    "skillName_90": "异能·守护",
    "skillName_91": "异能·斗魂",
    "messageInitContent_6400": "你的沸体突然超大",
    "messageInitContent_6402": "叉会腰",
    "messageInitContent_6401": "我也会局部被花枝鼠",
    "messageInitContent_6404": "显而易见",
    "messageInitContent_6403": "我家水池跑出来啦",
    "skillName_89": "异能",
    "skillName_85": "逆转之力·弱化",
    "skillName_86": "逆转之力·愈合",
    "skillName_87": "逆转之力·日轮",
    "skillName_88": "逆转之力·月轮",
    "skillName_81": "逆转之力",
    "skillName_82": "逆转之力·觉醒",
    "skillName_83": "逆转之力·突袭",
    "skillName_84": "逆转之力·祝福",
    "skillName_80": "传说之力·盾墙",
    "messageInitContent_6406": "人在现场，那边赢了",
    "messageInitContent_6405": "瞬间模糊",
    "messageInitContent_6408": "来了！",
    "messageInitContent_6407": "ai说左边赢了",
    "messageInitContent_6409": "单挑",
    "messageInitContent_6411": "快快长大",
    "messageInitContent_6410": "名字很牛逼但是幼体",
    "messageInitContent_6413": "让我看看",
    "messageInitContent_6412": "有点搞不清名字",
    "messageInitContent_6415": "哈哈哈",
    "messageInitContent_6414": "我猜有武器的赢",
    "skillName_78": "传说之力·圣盾",
    "skillName_79": "传说之力·剑气",
    "skillName_74": "传说之力·觉醒",
    "skillName_75": "传说之力·破",
    "skillName_76": "传说之力·挡",
    "skillName_77": "传说之力·神剑",
    "messageInitContent_6417": "哥就是传说",
    "messageInitContent_6416": "是1v1",
    "messageInitContent_6419": "啊aaaaaaaa",
    "messageInitContent_6418": "冲冲冲、冲鸭",
    "messageInitContent_6420": "还以为是馄饨",
    "messageInitContent_6422": "看看大家选啥先",
    "messageInitContent_6421": "康康技能",
    "messageInitContent_6424": "幼体大战",
    "messageInitContent_6423": "馄饨之力！！！",
    "messageInitContent_6426": "怎么不带逆转玩",
    "messageInitContent_6425": "简单粗暴",
    "messageInitContent_6428": "幼体传说",
    "messageInitContent_6427": "逆转呢",
    "messageInitContent_6429": "哦远古内战",
    "messageInitContent_6431": "没难度",
    "messageInitContent_6430": "猜对day0",
    "messageInitContent_6433": "那你很棒棒哦",
    "messageInitContent_6432": "我觉得左边厉害",
    "messageInitContent_6435": "啊这",
    "messageInitNick_6397": "我要玩爆展",
    "messageInitContent_6434": "天命在此",
    "messageInitNick_6398": "你若盛开",
    "messageInitContent_6437": "一眼左边",
    "messageInitNick_6399": "智能辣椒",
    "messageInitContent_6436": "选个人多的",
    "skillName_96": "奏·音律",
    "skillName_97": "奏·狂热",
    "skillName_98": "奏·亡者意志",
    "skillName_99": "龙炮",
    "messageInitNick_6393": "冰晶书童",
    "messageInitNick_6394": "无话可说",
    "messageInitNick_6395": "无敌画饼神",
    "messageInitNick_6396": "百香果兽",
    "messageInitNick_6390": "用回第一版",
    "messageInitNick_6391": "不动果冻",
    "messageInitNick_6392": "静待王者归来",
    "messageInitNick_6386": "插线板毁灭者",
    "messageInitNick_6387": "实在不行",
    "messageInitNick_6388": "画饼大王",
    "messageInitNick_6389": "典型好小伙",
    "messageInitNick_6382": "收纳幸福",
    "messageInitNick_6383": "超级高级厨师",
    "messageInitNick_6384": "老式情人",
    "messageInitNick_6385": "你礼貌吗",
    "12_2041": "饲星",
    "12_2040": "选定",
    "messageInitNick_6380": "天堂冰箱",
    "messageInitNick_6381": "不再为你流泪",
    "messageInitNick_6379": "把心藏好",
    "12_2038": "下列角色占觉醒卡总概率",
    "messageInitNick_6375": "东城男孩",
    "12_2037": "造唤概率",
    "messageInitNick_6376": "不如笑着放手",
    "messageInitNick_6377": "爱情过期不候",
    "12_2039": "当前定向",
    "messageInitNick_6378": "冰咒强化器",
    "messageInitNick_6371": "超人不流泪",
    "messageInitNick_6372": "混球你跑",
    "messageInitNick_6373": "灿烂的阳光",
    "messageInitNick_6374": "大坏蛋",
    "messageInitNick_6370": "星际玩家",
    "messageInitNick_6368": "抠脚大叔",
    "messageInitNick_6369": "俺不会飙车",
    "messageInitNick_6364": "草莓糯米糍",
    "messageInitNick_6365": "能不能先扶我",
    "messageInitNick_6366": "暴风少年",
    "messageInitNick_6367": "专业甩锅",
    "messageInitNick_6360": "短辫姑娘",
    "messageInitNick_6361": "你爱吃香菜么",
    "messageInitNick_6362": "不存在的拉肠",
    "messageInitNick_6363": "海的颜色",
    "messageInitNick_6357": "钢铁男儿",
    "messageInitNick_6358": "黑夜王子",
    "messageInitNick_6359": "你先别急",
    "messageInitNick_6353": "智能焦糖",
    "messageInitNick_6354": "沉默波比",
    "messageInitNick_6355": "金光薯条",
    "messageInitNick_6356": "哥带你超神",
    "12_2012": "确认",
    "12_2011": "首次获得",
    "messageInitNick_6350": "狂飙的草",
    "12_2014": "掉落概率",
    "messageInitNick_6351": "睫毛膏在微笑",
    "12_2013": "转化为30块碎片",
    "messageInitNick_6352": "开饭了吗",
    "12_2010": "点击空白位置关闭",
    "messageInitNick_6346": "随便打一手",
    "resoundEventConfigName_1004": "4.神剑古拉姆",
    "12_2008": "下次免费{1}",
    "messageInitNick_6347": "倾尽温柔予狗",
    "resoundEventConfigName_1003": "3.向石塔进发",
    "messageInitNick_6348": "橙子射手",
    "resoundEventConfigName_1002": "2.各族会议",
    "messageInitNick_6349": "哈密瓜真好吃",
    "resoundEventConfigName_1001": "1.楔子",
    "12_2005": "造唤十次",
    "messageInitNick_6342": "不是没头脑",
    "12_2004": "造唤一次",
    "messageInitNick_6343": "脑子出生中",
    "12_2007": "免费造唤",
    "messageInitNick_6344": "很好很强大",
    "12_2006": "造唤盛宴",
    "messageInitNick_6345": "刚好遇见你",
    "resoundEventConfigName_1009": "9.异世界",
    "resoundEventConfigName_1008": "8.哈灵顿·欧文",
    "resoundEventConfigName_1007": "7.友人",
    "resoundEventConfigName_1006": "6.月夕",
    "resoundEventConfigName_1005": "5.林宇翔",
    "12_2001": "造唤台",
    "12_2003": "{1}期间",
    "messageInitNick_6340": "舌尖上的东京",
    "12_2002": "点击查看详细",
    "messageInitNick_6341": "自以为是只猫",
    "messageInitNick_6335": "拜托了月亮",
    "messageInitNick_8998": "迟到的香水",
    "messageInitNick_6336": "尬聊冠军",
    "messageInitNick_8997": "芬尼巧克力",
    "messageInitNick_6337": "午餐喝豆浆",
    "messageInitNick_6338": "到底谁在赢",
    "messageInitNick_8999": "站位不行",
    "messageInitNick_6331": "细雨霏霏",
    "messageInitNick_8994": "快乐的小鸟",
    "messageInitNick_6332": "冻干潮人",
    "messageInitNick_8993": "吃剩一口",
    "resoundEventConfigName_1010": "10.神灵",
    "messageInitNick_6333": "不蹦洋迪",
    "messageInitNick_8996": "蛋挞剑客",
    "messageInitNick_6334": "在心上撒盐",
    "messageInitNick_8995": "模型守护者",
    "messageInitNick_6339": "好菇凉",
    "12_2034": "请选择定向",
    "messageInitNick_8990": "丈母娘发货啊",
    "12_2033": "规则说明",
    "12_2036": "卡池预览",
    "messageInitNick_8992": "克努姆神",
    "12_2035": "限时降临怪兽",
    "messageInitNick_6330": "无奈的门锁",
    "messageInitNick_8991": "半糖甜入心",
    "12_2030": "cjhwy2",
    "12_2032": "造唤说明",
    "12_2031": "cjhwy2",
    "messageInitNick_6324": "万能大衣",
    "messageInitNick_8987": "追月亮的人",
    "messageInitNick_6325": "诺贝尔甩锅奖",
    "messageInitNick_8986": "没钱但不说",
    "messageInitNick_6326": "七点的凉茶",
    "messageInitNick_8989": "大脑通勤中",
    "messageInitNick_6327": "知识的荒原",
    "messageInitNick_8988": "生命之水",
    "12_2027": "卡池详情",
    "messageInitNick_6320": "过程的抄手",
    "messageInitNick_8983": "不爱比心",
    "12_2026": "选择定向",
    "messageInitNick_6321": "鸟那个鸟",
    "messageInitNick_8982": "天上天堂",
    "12_2029": "cjhwy2",
    "messageInitNick_6322": "上去就是一拳",
    "messageInitNick_8985": "沉浸式吃饭",
    "12_2028": "cjhwy2",
    "messageInitNick_6323": "独家专属",
    "messageInitNick_8984": "风火男爵",
    "messageInitNick_6328": "超级卷神",
    "messageInitNick_6329": "大恐龙",
    "12_2023": "造唤获得",
    "12_2022": "{1}次(造唤十次每日上限){2}",
    "12_2025": "造唤{1}次内必得觉醒怪兽！",
    "messageInitNick_8981": "蚂蚁绊大象",
    "12_2024": "跳过",
    "messageInitNick_8980": "无公害蒜苔",
    "12_2021": "{1}次(造唤一次每日上限){2}",
    "12_2020": "觉醒结晶",
    "messageInitNick_6313": "剧场的猫",
    "messageInitNick_8976": "迷路的花瓶",
    "visionSagesOption3_6": "没区别，掉落和概率都完全一样",
    "12_2019": "觉醒怪兽",
    "messageInitNick_6314": "鸣叫的大管钟",
    "messageInitNick_8975": "骷髅控",
    "visionSagesOption3_7": "一个月",
    "messageInitNick_6315": "那怎么办嘛",
    "messageInitNick_8978": "暴躁寿司",
    "visionSagesOption3_4": "多此一举，不闪都知道能点",
    "messageInitNick_6316": "无公害香蕉",
    "messageInitNick_8977": "香蕉射手",
    "visionSagesOption3_5": "育成！",
    "12_2016": "幻化怪兽",
    "messageInitNick_8972": "在线申请对象",
    "visionSagesOption3_2": "点击“i”按钮",
    "12_2015": "幼体怪兽",
    "messageInitNick_6310": "星际传送花",
    "messageInitNick_8971": "此女人已绝版",
    "visionSagesOption3_3": "尝试更换怪兽，元核和神灵（真的有用）",
    "12_2018": "不朽怪兽",
    "messageInitNick_6311": "明天退休",
    "messageInitNick_8974": "人类最高质量",
    "12_2017": "究极怪兽",
    "messageInitNick_6312": "摆不动了",
    "messageInitNick_8973": "穿越去水底",
    "visionSagesOption3_1": "霸气越高击退敌人的距离越远",
    "messageInitNick_6317": "补刀门首席",
    "messageInitNick_6318": "低温超导师",
    "messageInitNick_8979": "冒险公主",
    "messageInitNick_6319": "鱿鱼就会败北",
    "visionSagesOption3_8": "不会，100%返还",
    "visionSagesOption3_9": "一次性茧可以（下面3个）",
    "messageInitNick_8970": "懒门首席",
    "messageInitNick_6302": "那些年没错过",
    "messageInitNick_8965": "重开模拟器",
    "messageInitNick_6303": "鱼露有点皮",
    "messageInitNick_8964": "心里有点数",
    "messageInitNick_6304": "保护敌方辅助",
    "messageInitNick_8967": "榴莲魔法师",
    "messageInitNick_6305": "暴走的辣椒",
    "messageInitNick_8966": "超级打脸神",
    "messageInitNick_8961": "病娇少女",
    "messageInitNick_8960": "美少女大佬",
    "messageInitNick_6300": "拉面怪客",
    "messageInitNick_8963": "不用管他",
    "messageInitNick_6301": "少林捂裆功",
    "messageInitNick_8962": "小心火烛",
    "messageInitNick_6306": "一直在吃饭",
    "messageInitNick_8969": "谜语人滚出",
    "messageInitNick_6307": "要高估对手",
    "messageInitNick_8968": "无语葡萄",
    "messageInitNick_6308": "大彩笔",
    "messageInitNick_6309": "牵手现场观众",
    "propConfigName_40305": "利币",
    "propConfigName_40304": "燃火",
    "propConfigName_40307": "花颜形态",
    "propConfigName_40306": "重溟形态",
    "propConfigName_40301": "创友积分",
    "propConfigName_40300": "大漠骰",
    "propConfigName_40303": "形态末梢",
    "propConfigName_40302": "万象券",
    "messageInitNick_8954": "奖励你吃瓜",
    "messageInitNick_8953": "流浪拾荒者",
    "messageInitNick_8956": "揣一袋欢乐",
    "messageInitNick_8955": "悄悄上分",
    "messageInitNick_8950": "逆境局的狗",
    "propConfigName_40309": "祥瑞形态",
    "resoundEventStyleDes_8": "1-甲基-8-乙基二环[4.2.0]辛烷-1-甲基-8-乙基二环[4.2.0]辛烷-1-甲基-8-乙基二环[4.2.0]辛烷-1-甲基-8-乙基二环[4.2.0]辛烷-1-甲基-8-乙基二环[4.2.0]辛烷极化",
    "propConfigName_40308": "大漠形态",
    "resoundEventStyleDes_9": "恭喜你对进化已经了如指掌。\\n但进化的顶点，是懒惰，僵化，学习能力的退化和创造力的丧失……\\n在你身上会看到不一样的答案吗？",
    "messageInitNick_8952": "我已经在闹了",
    "messageInitNick_8951": "番茄先锋",
    "resoundEventStyleDes_4": "起源殿是胜利和失败互现的地方，频率高得吓人。\\n为什么失败从来不会戛然而止？\\n大概是因为总有信念认为不服输就不会输吧（不构成建议）。",
    "resoundEventStyleDes_5": "说实话，好友列表里的大部分“好友”都还不是好友吧？\\n不妨找个最顺眼的聊聊，开启一条意料之外的支线。",
    "resoundEventStyleDes_6": "你肯定已经知晓什么是“留言”。\\n但我还想说说水……\\n水是强大的武器，甚至可以把阳光聚焦至150度，请谨慎使用武器。",
    "resoundEventStyleDes_7": "“什么是饥饿？是哗啦啦流淌的河水，是没有石子和沙子的黏土，是等待阳光的孩子。”\\n祝你的领地永远富饶。",
    "messageInitNick_8958": "留不住那年",
    "messageInitNick_8957": "春夏秋东西",
    "resoundEventStyleDes_1": "文字的力量越来越弱了……\\n有人收到这段话吗……\\n素未谋面的世界……\\n我来自▇▇……\\n很高兴遇上你……",
    "resoundEventStyleDes_2": "你迎来了首次战败，\\n呼吸也停止了，\\n但这不是真正的死亡吧……\\n它们仍然记得你。",
    "messageInitNick_8959": "懒床钉子户",
    "resoundEventStyleDes_3": "猜错了，\\n猜错了，猜错了，\\n猜错了，猜错了，猜错了，\\n还是猜错了……\\n无法识破的诈赌是诈赌吗？",
    "propConfigName_40310": "守岁形态",
    "propConfigName_40316": "电气区块",
    "propConfigName_40315": "三阵入局挑战次数",
    "propConfigName_40318": "崩坏形态",
    "propConfigName_40317": "狂潮形态",
    "propConfigName_40312": "金翠",
    "propConfigName_40311": "回归经验",
    "propConfigName_40314": "祖传DNA",
    "propConfigName_40313": "洞心镜",
    "98_-50013": "神灵契约未解锁",
    "messageInitNick_8943": "强壮跑调神",
    "98_-50014": "cjhwy2",
    "messageInitNick_8942": "黙写你柔情",
    "98_-50011": "神灵未上阵",
    "messageInitNick_8945": "长命网红小吃",
    "98_-50012": "所需材料不足，无法进行此类与神灵相关的操作",
    "messageInitNick_8944": "生无可恋",
    "98_-50017": "神灵契约等级不足，无法重置",
    "propConfigName_40319": "部落营火头像框（31天）",
    "98_-50015": "无法跨层解锁神灵契约",
    "messageInitNick_8941": "爱吃无罪",
    "98_-50016": "神灵等级不足，无法重置",
    "messageInitNick_8940": "被辐射的魂",
    "messageInitNick_8947": "榜二小哥",
    "98_-50010": "神灵已上阵",
    "messageInitNick_8946": "梨子捞月",
    "messageInitNick_8949": "等离子牙线",
    "channelName_nt_ios": "App Store",
    "messageInitNick_8948": "熬夜冠军",
    "propConfigName_40321": "纬织源",
    "propConfigName_40320": "起源片",
    "propConfigName_40327": "缤纷形态",
    "propConfigName_40326": "糕星",
    "98_-50008": "cjhwy2",
    "propConfigName_40329": "箔材",
    "98_-50009": "当前神灵等级受限，请提升探索者等级后再试",
    "propConfigName_40328": "万能进化光谱",
    "propConfigName_40323": "暴走回廊挑战次数",
    "propConfigName_40322": "荧星",
    "propConfigName_40325": "熔珀形态",
    "propConfigName_40324": "百炼起源盘",
    "98_-50002": "神灵等级已达到最高",
    "messageInitNick_8932": "单枪浪情场",
    "98_-50003": "等级{1}开启神灵契约",
    "messageInitNick_8931": "踏遍人间景色",
    "messageInitNick_8934": "花姑娘",
    "98_-50001": "神灵不存在",
    "messageInitNick_8933": "砂糖有点皮",
    "98_-50006": "cjhwy2",
    "98_-50007": "该层神灵契约已解锁",
    "98_-50004": "该层神灵契约未解锁",
    "messageInitNick_8930": "拥抱暖手宝",
    "98_-50005": "神灵契约等级已满级",
    "messageInitNick_8939": "你不在的季节",
    "messageInitNick_8936": "灵儿",
    "messageInitNick_8935": "田园靓汤王",
    "messageInitNick_8938": "倒霉的河流",
    "messageInitNick_8937": "大大滴好",
    "propConfigName_40330": "冠军之声对话框（31天）",
    "propConfigName_40332": "造唤光华",
    "propConfigName_40331": "冠军之名名称框（31天）",
    "propConfigName_40338": "极焱形态",
    "propConfigName_40337": "幻惑形态",
    "propConfigName_40339": "珍珠贝",
    "propConfigName_40334": "木锤",
    "propConfigName_40333": "金锤",
    "propConfigName_40336": "橙色元核髓盒",
    "propConfigName_40335": "源初境竞猜券",
    "messageInitNick_8921": "昨日不复来",
    "messageInitNick_8920": "卸载记忆",
    "messageInitNick_8923": "会变得幸运",
    "messageInitNick_8922": "电子鱼露",
    "messageInitNick_8929": "林中鸟",
    "messageInitNick_8928": "香菜真好吃",
    "messageInitNick_8925": "想吃臭豆腐",
    "messageInitNick_8924": "永远快乐",
    "messageInitNick_8927": "脸有点肿",
    "messageInitNick_8926": "灵魂的过客",
    "propConfigName_40341": "紫色元核髓盒",
    "propConfigName_40340": "裂变核",
    "propConfigName_40343": "紫色特化元核髓盒",
    "propConfigName_40342": "蓝色特化元核髓盒",
    "propConfigName_40349": "夜魇形态",
    "propConfigName_40348": "海之瞳",
    "propConfigName_40345": "紫色宿命元核髓盒",
    "propConfigName_40344": "紫色远古元核髓盒",
    "propConfigName_40347": "夏梦形态",
    "propConfigName_40346": "月佩",
    "messageInitNick_8910": "不一样的霸气",
    "messageInitNick_8912": "巨星",
    "messageInitNick_8911": "憨憨的小鸟",
    "messageInitNick_8918": "佛系小可爱",
    "messageInitNick_8917": "摸鱼小能手",
    "messageInitNick_8919": "辣条",
    "messageInitNick_8914": "趁爱不深",
    "messageInitNick_8913": "复婚吧少年",
    "messageInitNick_8916": "国王的新衣",
    "messageInitNick_8915": "抠脚小仙女",
    "propConfigName_40352": "裁决形态",
    "propConfigName_40351": "幽灵晶球",
    "propConfigName_40354": "武装碎片",
    "propConfigName_40353": "暗隧形态",
    "propConfigName_40350": "橙色宿命元核髓盒",
    "propConfigName_40359": "玄青形态",
    "propConfigName_40356": "甜粉形态",
    "propConfigName_40355": "周年印记",
    "propConfigName_40358": "红色宿命元核髓盒",
    "propConfigName_40357": "橙色远古元核髓盒",
    "messageInitNick_8901": "吸尘器的碎片",
    "messageInitNick_8900": "万能背锅虾",
    "messageInitNick_8907": "渣男收割机",
    "messageInitNick_8906": "迷路的细胞核",
    "messageInitNick_8909": "呆小熊",
    "messageInitNick_8908": "柿子龙",
    "messageInitNick_8903": "强力去污粉",
    "messageInitNick_8902": "寄没地址的信",
    "messageInitNick_8905": "电梯人",
    "messageInitNick_8904": "一起开拓",
    "propConfigName_40363": "叶脉藏馨头像框",
    "propConfigName_40362": "不眠夜头像框",
    "propConfigName_40365": "蜡笔小云头像框",
    "propConfigName_40364": "回环迷图头像框",
    "propConfigName_40361": "双关之环头像框",
    "propConfigName_40360": "祈珑",
    "messageInitContent_10490": "家人们谁懂啊",
    "propConfigName_40367": "枫色舞步头像框",
    "propConfigName_40366": "兔饼头像框",
    "propConfigName_40369": "2.9签到战令头像框",
    "propConfigName_40368": "像素入侵头像框",
    "messageInitContent_10495": "相信第一感觉",
    "messageInitContent_10496": "先让我缓缓",
    "messageInitContent_10497": "不要再打啦不要再打啦",
    "messageInitContent_10498": "我家猫帮我选了",
    "messageInitContent_10491": "左左右右前前后后",
    "messageInitContent_10492": "梦到了是右边赢",
    "messageInitContent_10493": "猜对day1",
    "messageInitContent_10494": "差不多得了",
    "messageInitContent_10499": "听我的选这边",
    "messageInitContent_8739": "在猜了在猜了",
    "messageInitContent_8737": "我有一个大胆的想法",
    "messageInitContent_8738": "赢了",
    "messageInitContent_8742": "左左右右",
    "messageInitContent_8743": "大家都选好了吗",
    "messageInitContent_8740": "选择困难症怎么办",
    "messageInitContent_8741": "正确的废话",
    "resoundEventConfigDes_10019": "最终兵器、古拉姆、暴虐战狂最先行动了起来。\\n最终兵器警惕地来到独角兽的躯体旁，确认独角兽已经没有半点生命痕迹后，轻轻地把月夕的躯体托起，向日夕的所在移去。\\n最早抵达日夕身旁的古拉姆，此刻俯下了身，颤抖着将手伸向日夕的脸庞。\\n由于过于悲痛，他没有留意到一股微弱的能量从独角兽的头部悄然潜入日夕的身体。\\n在逐渐漫开的血泊中，日夕静静地躺着，胸口伤口向虚空敞开，几缕白色的秀发在空洞的双眼旁落下，一点点染作红丝。\\n“震慑。”\\n“古拉姆，这事还没完！” \\n两个各异的话语尚未落下，雷声就充斥了整个冰川谷，轰隆——轰隆——将那阴森的话语和暴虐战狂的呼喊盖住。\\n在长达数秒的雷击中，那些在罗密欧的自爆中存活下来的怪兽，只有不到半数做出了反应，躲过了毫无预兆的雷击，最终兵器、暴虐战狂更进一步，迅速摆出了回击的架势；剩下没能躲开雷击的怪兽，包括那些茫然失神的变异怪兽在内，只倒剩了一个古拉姆。\\n古拉姆的确及时闪避了，但身体却不听使唤，顿在了原地，林宇翔在那一刻感到一种类似坐车时司机急刹，身体依旧想向前冲的惯性，步伐确实在迈开，却无限接近静止，下一秒视野被染成了一片白，一个由无数道闪电织成的光波在他头顶炸开，剧痛流遍了他的全身。单单是一发雷击就让古拉姆接近重伤，再中一发很可能就必死无疑。\\n接连而来的剧变，让林宇翔不知所措，他唯一能想到的，是他和其他人类同伴达成了某个条件，触发了返回原来世界的进程。\\n所以，这是“回家道路开启”的前兆吗？\\n不，现实否定了他的乐观想法，攫住了他的心脏。\\n“桀桀桀，桀桀桀桀桀桀！”\\n仿佛嘲笑林宇翔的天真似的，日夕身上传出了阵阵瘆人的狞笑。笑声来自于从日夕左眼眶中蹦出来的眼球。\\n眼球在狞笑中一圈接着一圈地隆起膨大，变成一只肥硕肿胀、布满血丝的巨大眼球。巨眼缓缓升起，猩红的眼珠一顿咕噜乱转，看了上空一眼后，视线再次落到古拉姆的身上。\\n与此同时，一座巨龙重重地落在了巨眼的后方。冰蓝色的犄角、翅膀和胸前的光核都缠绕着闪电，似乎充盈着无尽的能量，分明就是在冰川谷降下雷击的罪魁祸首。\\n巨龙和巨眼散发着恐怖的气息，犹如邪王的存在一般，激起了怪兽本能的畏惧。\\n“那是邪王吗？”\\n“那是什么！”\\n“我们不是打败邪王了吗？”\\n“邪王？邪王刚才不是被杀死了吗！？”\\n慌乱的涟漪掀起一阵阵惧浪，远古族的战士们渴望从神灵朱雀那里得到答案，只是他们很快就发现朱雀的红焰早已不在任何一处。谁都没有注意到，朱雀在罗密欧与朱丽叶一战中耗尽了能量，消失在最后对英雄的祈祷和祝福中。\\n但即使失去所有力量，即使失去了可见的形态，即使意志被绝望碾碎，神灵的生命也是无限的，朱雀只能成为见证者，见证接下来的一切，直至时间本身疲惫地倒在终末的怀内。\\n“桀桀桀，你们在向我发问吗？是的，邪王炼狱魔眼，还有邪王量子巨龙，这两个名字还不错。也许还有在路上的，总之你们快逃就对了，桀桀桀！对了对了，本邪王正在找一个合适的眼眶，谁有不需要的吗？”自称炼狱魔眼的巨眼用不知道藏在哪的发声器官发出了尖声的回答。\\n“你，不够生气。” 回应巨眼的是巨龙那震耳欲聋的声响。\\n“你才应该更生气！你刚刚使劲了吗？你看那个拿剑的，还活蹦乱跳的。”\\n“呜——我更生气了。”\\n炼狱魔眼和量子巨龙一同热切地注视着古拉姆。\\n就像是以自身怒火为食粮一般，电光在量子巨龙身上剧烈地起伏萦绕，闪电球接连绽放，毁灭的天雷即将再次降下。\\n“古拉姆。”古拉姆脑海中传来了林宇翔的声音，他能感受到夹杂其中的复杂感情和某份支撑着他的力量。\\n“相信我。”古拉姆回应道，同时双手将巨剑用力插入了冰面。\\n震天动地的量子波动再次冲击冰川谷，无数电光贯穿天地，不偏不倚地刺向目标。",
    "messageInitContent_8746": "骑兵vs步兵",
    "resoundEventConfigDes_10018": "离奇的光景仿佛默默地向周遭诉说着逝者最后的意志——以我身作盾。\\n悲伤如涛，没过胜利的喜悦。\\n在暗沉的余晖之中，一抹银光诡异地自冰面跃起，欢快的哼唱声将沉寂打破，引来了四周的注意。\\n“啊啦啦~钻啊钻啊钻啊，无敌的独角兽又钻出来啦~我就是无敌的独角兽~朱丽叶大人~罗密欧大人~快看我的大功劳~大功劳~我的大功劳~谁呀谁都别想抢走啦啦啦~”\\n那是一头四足马身怪兽，手握长柄，长柄的上端是他那哼着曲儿的独角兽头，两手一转一扭，头就跟着左右张望了起来。某具躯体僵硬地挂在他的后背上，在冰雪的映衬中，毫无生气的肌肤透出一种令人绝望的苍白，仅余裙摆处的几点银辉。\\n不过几秒，一股炽烈的热风扫过冰川谷，从数里开外一路破开黑雪，带着耀眼的金光和灌注而下的光弹，来到独角兽的上方。\\n独角兽见状，急忙踏出一个滑步，带着自己的头，闪到掩体后头。\\n他的右眼认出了来袭者，是他背上那个“大功劳”的姐姐还是妹妹。日夕，月夕，一、二，就是两个大功劳。后面跟过来的是神剑古拉姆、暴虐战狂和最终兵器，加起来就是一、二，呃，就是好多个大功劳！\\n“太阳和月亮一起给我送大功劳咯，给我送大功劳咯！”\\n“闭嘴——！！！”日夕怒喝。\\n“日月串串大功劳哈哈。”\\n也许是秒杀月夕的事给了他极大的自信，独角兽雀跃无比，他趁着日夕攻击停下的间隙，一下子冲出掩体，用布满血丝的左眼球盯着日夕，摆出投掷标枪的架势，握紧长柄独角兽头，伸展，发力，掷出。兽头带着飞转的独角直逼日夕的胸口而去。\\n“混蛋！我让你闭嘴——”\\n“日夕！快闪开——”\\n她嘶声喊道。\\n李雨蒙总觉得哪里不对劲，在邪王死后，所有变异怪兽都处在神志不清的状况下，能如此清醒地发起进攻的变异怪兽实在过于异常。日夕则早已定好计策，她打算在钻头接近的最后一瞬做出躲避，迅速反击，不给独角怪兽任何逃跑和反应的机会，她很清楚她现在的速度完全可以做到。\\n“相信我，能躲开的。”\\n“可是我……”\\n她迎着独角兽的攻击自信将逆转弹投出。\\n她看着飞转的钻头恐惧不已。\\n“震慑。”\\n她的耳边响起了阴森的低语。\\n“啊——”\\n转瞬间，她的惨叫响彻冰川谷，她的胸口扬起巨幅红绸，她的身影与天边的微光重叠，夕阳沉入地平，黑夜悄然而至。\\n入夜后的冰川谷借着怪兽身上发出的辉光，由冰面肆意漫反射后，稍稍点亮。\\n远古族的战士们惊恐地注视着，先前的，在几个眨眼间发生的一切，独角兽头转动的尖角穿过日夕的胸口，染上淋漓的鲜血，日夕的攻击打穿了独角兽的头部，日夕和独角兽接连倒地。",
    "messageInitContent_8747": "你喜欢哪个",
    "resoundEventConfigDes_10017": "“我们也上！“\\n就在这时，雄浑得意的笑声从埃癸斯和日夕背后响起。\\n“嚯哈哈哈！想我了吧！”\\n此外，还有一把沙哑、充满杀意的声音。\\n“……渣滓、地底泥、草履虫……”\\n暴虐战狂和最终兵器也赶到战场的中心。\\n“会自爆怪兽！“\\n李雨蒙突然想到什么，大吼道。这是她一边数数一边拼命思考应对的办法。\\n“哼，有我就足够了！”暴虐战狂大声回应。\\n“你是说这个吗？”无波澜的机械音仿佛带着几分骄傲。\\n李雨蒙这才发现最终兵器拖着的一大包由丝线包裹着的奄奄一息的怪兽，这丝线正是史卡非斯当时将她们吊在树上的丝线。洛菲菲在冰雪城堡呆了一段时间当然知道自爆纹章是什么东西。\\n“对！”李雨蒙非常激动。\\n“我们去清空那老妖婆的血槽！”日夕率先飞向朱丽叶。\\n巨斧、钢拳、火焰大剑和光弹齐发，大家一齐攻向朱丽叶的怒涛中。\\n罗密欧见事态不妙迅速挥转剑尖，慌忙挥出的数击。\\n“亲爱的！”\\n“躲好！”朱丽叶自信能挡下所有攻击，即便没有假死的保护，她对自己的血量有绝对的自信。\\n罗密欧强大的剑风已经扫荡过来了，四组英雄没打算抵挡。古拉姆和日夕相信着埃癸斯，暴虐战狂和最终兵器则是相信着自身的力量，把所有力量放到攻击上。\\n埃癸斯举盾拼死掩护同伴进攻。\\n激烈的轰响传遍冰川谷、传遍超进化大陆，那既像是神的愤怒，也像是大陆在咆哮。\\n几组英雄的攻击同时贯穿了朱丽叶，同时，埃癸斯的五面副盾全碎，最大的主盾布满裂痕。\\n“假死——！！！”\\n朱丽叶厉声惨叫着，『假死』却无法因为她的痛苦早一秒触发。\\n“菲菲！”李雨蒙大喊。\\n“喝——！”最终兵器大力一甩。\\n“自爆大礼包”在与朱丽叶碰撞的一瞬炸裂，光、火焰和黑暗在朱丽叶身上乱舞。\\n“我的爱——”罗密欧扛着爆炸的余波一手将朱丽叶抱紧，随着他悲恸的又尖利的哭声，打出疯狂的接连不断的攻击。他和朱丽叶究竟是为何、如何降临到这片大陆上的？或许，他们只是被某股力量玩弄的棋子吗？罗密欧的脑海里闪过这样一个念头，但他痛苦的心马上被复仇的欲望撑破，无暇顾及那个念头。\\n“浴火重生！”\\n朱雀的声音在几组英雄头顶响起，他一直积蓄的能量就是用在这种“万一”的时刻。他没想到几组英雄会用如此冒险的战术，只是之前隐隐预感到最危急的时候还没到来。\\n一片格外明亮温热的火焰包裹着五组远古族英雄，他们都感到体内血量腾涌起来。\\n“祝诸位武运昌隆——”\\n埃癸斯举起重盾再次为大家挡下攻击，日夕趁机向朱丽叶射出一枚逆转弹。\\n罗密欧看着逆转弹洞穿了朱丽叶的眉心，看着他的爱死亡。\\n耀眼的光芒和澎湃的魔力从罗密欧的身体迸射而出，巨大得让人联想到大海、同时也如金刚石般高度凝缩的能量让冰雪大地随之颤抖、扭动、龟裂、翻涌。\\n“啊啊啊啊啊——！！！”\\n罗密欧的咆哮迅速被爆炸的巨响掩盖。\\n爆炸的强光夺走了一切色彩，世界只剩下分明的黑白线条，之后是久久的静谧。\\n四周充斥着焦糊的恶臭。\\n冰川谷变成了由无数浮冰组成的群岛。\\n刚才还是怪兽混战的战场，仿佛遭到了清场一般，只留下原来四分之一的怪兽，他们不是怪兽中的精锐，就是恰好远离中心战场。有些怪兽还趴在浮冰上，下半身泡在冰冷的海水里。\\n剩下的四分之三成了雪地上到处涂鸦般的怪兽炭影。\\n邪王大战，结束。\\n染上了爆炸的灰烬，黑雪从天空翻滚、零落，仿佛预告着终结。\\n失去了王，周围的变异怪兽变得茫然不知所措。\\n终于，不知道是从哪位远古族战士喊了声“胜利了“开始，战士们爆发出一阵阵高昂的欢呼。剩下的为数不多的远古族战士跑向战场中心。\\n日夕、暴虐战狂和最终兵器都受了不同程度的伤。古拉姆跪在雪地上，似乎很艰难地颤动着双肩。有的远古族已经跑到日夕身边为她回血，有的远古族奔向古拉姆和埃癸斯，祈祷着两位首领千万别受致命伤。\\n而屹立在古拉姆旁边的那面满布蛛网状裂痕的重盾，又让大家稍微安心了一些。只要有埃癸斯大人在，无论多么险峻的战斗，都能全身而退。\\n“古拉姆大人！埃癸斯大人！“战士们呼喊着。\\n重盾仿佛回应着大家的呼唤似，轰然消散。\\n其后空无一物。",
    "messageInitContent_8744": "量子波动选择法",
    "resoundEventConfigDes_10016": "没有丝毫喘息的时间，罗密欧的长剑放出的奔腾电光直扑三组英雄，是拥有着扫荡其眼前所有生物的威力的一击！\\n三组英雄都无法承受而被打飞，重重地落到雪地上。虽然很快爬了起来，但都受了伤，没能立刻反击。\\n朱雀积蓄的能量还不够，无法为他们回血，只能徒然地挡在他们前面。\\n“土肥圆，你忍心让美丽的长腿大姐姐在你前面遮风挡雨么？”林宇翔吐了口鲜血，喊道。\\n他看出了朱丽叶有某种无视攻击的技能，想用激将法让罗密欧跳到前面来。\\n“这份独宠，正是我最珍贵最耀眼的勋章！”\\n罗密欧亲了一下朱丽叶的长腿，反而以此为荣。\\n“就让你们仰望这份独宠最后一眼吧！”他的长剑再次缠绕电光。\\n真的到此为止了吗？古拉姆勉强用剑撑起身体，准备冲上去以肉身抵挡下一次的攻击，为埃癸斯和日夕争取逃脱的时间。\\n而在他身边的埃癸斯，也打算以同样的方法拯救同伴，率先挡在古拉姆和日夕前面。\\n突然，古拉姆发现体内血量迅速上涌，他以为朱雀正在为大家回血。\\n“是远古族的战士们！”\\n古拉姆才抬头，朱雀就回答了他的疑问。\\n埃癸斯的五面副盾再次在背后显现，日夕的日环重新升起，飞到空中。\\n远古族的战士们组成了新的战阵，所有辅助型战士为三位首领回血和施加『祝福』，持盾的战士负责保护她们，而持剑的战士则拼命把变异怪兽的攻击都吸引到自己身上。\\n持剑的战士被变异怪兽践踏着，前赴后继地倒下。\\n这些战士在以命相救！\\n古拉姆、埃癸斯和日夕很清楚大家把所有希望和期盼都托付给了他们。\\n数枚光弹接连从日夕手中射出，但它们依旧无法对朱丽叶造成丝毫伤害。\\n“可恶的远古族！”说话的同时，罗密欧的剑又向辅助型战士的方向劈出——\\n“传说之力！”\\n“传说之力！圣盾！”\\n古拉姆和埃癸斯一起发动技能，硬扛下这次攻击。\\n这次，剑风所扫的范围，除了远古族三组英雄的身后，已没有其他活物。三组英雄的血量又损失了几乎一半，如果没有刚才同族战士的帮助，现在留在雪地上的就是他们的尸体。\\n然而日夕的光弹还在继续。\\n“十八、十九、二十！技能持续了二十秒，朱丽叶的技能失效了！”\\n原来李雨蒙和日夕并非徒然地浪费体力发射光弹，而是一直在通过连续的攻击计算朱丽叶技能的持续时间。这一刻，她们看到了朱丽叶的裙边因被光弹擦到而燃烧，尽管那微弱的火苗很快就熄灭了。\\n现在大家都清楚这对邪王的战斗模式，朱丽叶防，罗密欧攻，对策自然亦明晰了起来。\\n日夕将攻击转到了罗密欧身上，同时李雨蒙全神贯注地数着朱丽叶再次发动技能所需要的时间。\\n另一边，古拉姆和埃癸斯一起扑向朱丽叶。\\n三组英雄的反击初见成效。\\n最为灵活的日夕可以在不同角度射出光弹，穿过朱丽叶防御的漏洞，偷袭罗密欧。朱丽叶因为担心罗密欧被光弹击中，不时分神。\\n埃癸斯同时对朱丽叶发起冲击，就像大陆上两块最坚硬的戮魔钢互相撞击。\\n古拉姆的大剑卷起怒涛般的攻击，落到朱丽叶身上就如同妄图融化钢铁的火苗。但他也同日夕一样伺着朱丽叶的破绽，找准机会偷袭罗密欧。\\n面对日夕的疯狂偷袭和古拉姆的不时的袭击，罗密欧的攻势减弱了不少。\\n朱丽叶再次发动了技能『假死』，所有攻击无效化——李雨蒙数到了十。\\n“十秒发动一次。”\\n罗密欧重新回到朱丽叶的背后，开始新一轮肆无忌惮的攻击，劣势再次回到三组英雄这边。\\n三组英雄各自使出保命保血的技能，毕竟在朱丽叶无视所有伤害的时候继续攻击毫无意义。\\n埃癸斯持重盾在前，各被三面副盾保护着的古拉姆和日夕在后。\\n以罗密欧的剑为圆心，呈扇形向三组英雄散开的电光攻击波比刚才覆盖的范围更广。\\n电光奔腾、咆哮、撕咬着来不及逃跑的怪兽，这片区域简直在宣告世界的终结。\\n更恐怖的是，这样的攻击接连而来。在朱丽叶发动『假死』的这段时间内，罗密欧肆意地虐杀着冰川谷上的生命。\\n剩下为数不多的远古族战士向他们的首领进行新一轮——也是最后一次的回血。这波及时的援助把三组英雄的血量从见底拉回半满。\\n“朱雀大人！”眼看攻击就要扫过远古族战士，日夕嘶声向朱雀求救。\\n“不。”朱雀悲痛地摇摇头。他的回血确实可以让远古族战士多活一会，但这次之后，下一次回血的间隔就会增加，必须留到某个更关键的时刻。\\n“好了吗？”古拉姆问。\\n“再坚持五秒！”李雨蒙喊道。\\n可是，五秒之后呢？继续重复刚才战斗吗？如果不尽快解决朱丽叶，继续拖下去无疑是邪王的胜利，输出，要更多更多的输出，李雨蒙拼命思考着。\\n“三、二、一！假死失效了！”",
    "messageInitContent_8745": "只要冲得够快，伤害就追不上我",
    "resoundEventConfigDes_10015": "战场之上，尸族战士倒下了大半，尸王硬拉着钢铁龙王坚守着世界树的最后一处防线。最终兵器和暴虐战狂面对变异怪兽群的主力竭力维持着均势，远古族战士抱团维持住攻击防御治疗三角，从旁辅助掩护着。但体力面对变异怪兽群的数量优势下，平衡随时会被打破。\\n就在这时，一批五百名左右的远古族战士从冰川谷的西方登陆——这是远古族的全部战力。在奔赴冰川谷的路上，远古族战士牺牲了三分之一，那支和他们一起赶来的灵族“叛军”，也被变异怪兽屠戮得七七八八，只剩下那两名叛军首领和几个究极级的灵族踏上这片冰雪大地。\\n现在，这批最后的援军直接朝战场中心奔去。\\n与其他战场的血雨腥风相比，古拉姆所在的战场就像一个上演着爱情剧的舞台。男女主角当然是罗密欧与朱丽叶，古拉姆则是一个命不久矣的反派。\\n林宇翔的嘴炮攻击在罗密欧挡在朱丽叶身前那一刻就宣告失败了。朱丽叶比谁都清楚那意味着什么，她俯下身来，将罗密欧搂入怀中。\\n紧接着是无视古拉姆的一段漫长的如同踩着华尔兹舞步般的拥吻。\\n林宇翔的嘴炮攻击到此为止了。\\n古拉姆带着伤势硬是打出数次的强攻，不是因罗密欧的以攻代守的剑气，就是由于朱丽叶的闪躲而打偏。\\n邪王和好如初，然后，他们决定赐予古拉姆最残忍的惩罚。\\n碾压局开始了。\\n“亲爱的，我要把所有远古族埋在我们的冰雕底座，让他们永远看着我们舌吻！”\\n“我的雕像脚下要踩着他们几个首领！”\\n“你觉得这个主意怎样？”罗密欧问古拉姆。\\n“我劝你还是先增高吧！”\\n“那还是先堵住你的臭嘴吧。”\\n朱丽叶拖动罗密欧旋转，借着回心的力量，一挥魔杖打将古拉姆打趴在地上，紧接着转过去的罗密欧挥出一道剑气直击古拉姆的胸膛。\\n朱丽叶压倒性力量刺痛着他全身的每一块骨头，几乎让他呕吐，他听到了头部以下所有骨头碎裂的声音。罗密欧的剑气划破他的胸膛——留下连串的紫色电光。古拉姆看到自己身上散发阵阵黑烟，闻到肌肉烧焦的气味。\\n就在古拉姆彻底绝望的时候，激昂的呐喊和熟悉的剑盾铮鸣由远及近。\\n一把清脆、愤怒的声音从上空响起，古拉姆的身体迎来一阵温暖。\\n埃癸斯和日夕从空中降落。\\n他们是和后来加入的远古族战士追着干着急的朱雀的位置一起赶来的，并在同伴的帮助下回了点血。趁着两名远古族战士攻击朱丽叶，他们挡在了古拉姆前面。远古族战士则与才意识到表演已经落幕的变异怪兽开始相持。\\n焦急不已的朱雀也终于蓄满能量，奋猛地扇动翅膀，最大程度地为他们回血。\\n三组英雄的状况都相当狼狈，日夕受的伤相对较轻，埃癸斯的体力无法让五面副盾再度显现，古拉姆的骨头和神经都被压断和撕裂。\\n尽管这样，当攻防奶三角阵营再次组合，他们的斗志就重新昂扬起来。\\n长剑和坚盾彼此共鸣似的闪烁了一下，日夕头顶也亮起耀眼的日轮。\\n长剑、坚盾，还有仿佛把太阳的热量浓缩起来的光球，它们释出三股巨大的光波成螺旋状缠绕在一起，闪耀着红、蓝、金三种绚烂光彩的能量激流化作一把连高山都能刺穿的能量束、爆发般地加速刺向邪王。\\n周围的变异怪兽也遭到余波的冲击而被击飞到远处。\\n应该是没有怪兽能抵挡的一击——\\n但是，当碎冰渐渐落下后，却看到邪王的身影依旧在那里，只不过毫发无伤。朱丽叶一条长腿挡在罗密欧面前，罗密欧一手抱住爱侣的长腿，另一手的长剑上缠绕着紫色的电光。\\n“就只是到这种程度而已吗？”朱丽叶挑了挑眉。\\n她似乎凭借一己之力挡下了刚才的攻击。\\n“可恶……”古拉姆不甘心地咬着牙。\\n“轮到我们了！”罗密欧与朱丽叶异口同声。",
    "resoundEventConfigDes_10014": "吃了几口黯炎古龙的黯焰，埃癸斯忍耐着肺部像被炙烤般的痛苦，趁着邪王和大部分变异怪兽的注意力都被古拉姆吸引，迅速从邪王身边撤退。\\n但是，他很快遭到其他变异怪兽的围剿。比起观看伟大的王被第三者插足的戏码，这些怪兽更想早点将远古族首领解决邀功。\\n埃癸斯可不想跟他们纠缠，他用重盾和五面副盾严严实实地护住身体，劲势如炮弹地直冲而出，不少低级变异怪兽被就地撞毙。当他看到前面还有十多名不朽级的变异怪兽的时候，心里一沉，加快了脚步。\\n埃癸斯先是看到了着急不已的朱雀。\\n“朱雀大人，我会救出日夕的，您快赶去古拉姆那，不知道他还能撑多久。”\\n “好。“\\n埃癸斯与朱雀错身而过。\\n日夕像一个无法自控的金球，被一群能随时叠加霸气的异形撞来撞去。而她的头顶，则飘着几个冲她而来的镰刀。除了他们之外，几个污妖王挥动手中的菊花，让尖利的花瓣飞到日夕脸上。\\n但是，日夕的真正对手并不是这些中低级的怪兽，而是三名决杀零式——她一直在寻找独角怪兽，他们很可能就是杀害月夕的凶手！\\n埃癸斯冲到日夕附近的时候，发现日夕已经被决杀零式们连番封印技能，处于一个只能靠拳脚对战众多敌人的劣势局面。\\n而那偏偏是日夕最最不擅长的。\\n埃癸斯估算了一下距离和技能持续的时间，决定在攻击围剿圈最外层的几个污妖王时就发动技能。\\n他很快地跑到日夕身前，让五面副盾保护着日夕，并发动了『传说之力·觉醒』技能，使日夕的霸气略略提升。\\n“日夕小姐，我们快撤！”\\n“如果月夕小姐是他们杀死的，他们一定会带着月夕小姐的躯体在战场上耀武扬威，或者到邪王那里邀功。”马克觉得日夕的判断有点武断，又补充了一句。类似的理由，李雨蒙也说过，但日夕完全听不进去。\\n“对，你说得对，我姐姐已经永远离开了啊！我要给姐姐报仇！姐姐是被独角的怪兽杀死的！独角的怪兽通通都得死，喝呀！”日夕挣脱了埃癸斯的保护，朝其中一名决杀零式发射光弹。\\n“你是想死！”埃癸斯大声怒喝。\\n“我……”埃癸斯的气势将日夕从复仇的泥潭拉出，“要报仇。”\\n日夕说的最后三个字小声得几乎听不见。\\n日夕的攻击耽误了埃癸斯撤退的计划，她的光弹只击中一个幻化级的小怪。三名决杀零式又开始轮番对她和埃癸斯施加负面效果来磨血。\\n两个菊花的花瓣扎到日夕的眼睛上，日夕的视觉被花瓣流下来的污汁夺去的同时，身上又挨了镰刀骷髅几刀。\\n埃癸斯追上去，一手抄起日夕的腰，一手举起重盾往前冲。\\n“先抱歉了！”\\n突如起来的攻击，让埃癸斯没有听清日夕刚才的回话。他顿下脚步，五面副盾疾速飞到身前前面纵向排列。\\n埃癸斯的盾就像是他身体的延展，即使受到攻击的是离他最远的副盾，他也能准确地感知到攻击的力度。\\n现在他感受到的，仿佛是一股来自地狱、要把灵魂抽离的力量。\\n刺耳的笑声从前方传来，埃癸斯前面的几个中低级怪兽像灵魂被吞噬了一样倒在地上，其余怪兽见状，立刻瑟瑟退开。\\n收割灵魂的巨大镰刀、藏匿灵魂的褴褛斗篷、还有每扇动一下都会发出凄厉风声的翅膀，不朽级的破魂领主出现在埃癸斯和日夕前面。\\n为了突袭埃癸斯和日夕，他毫不在乎地在“友军”背后发动技能『引力·贯穿』。此刻，他轻松的表情似乎在说，这些只是突袭远古族首领的附带伤害，不用在意。\\n破魂领主再次挥动镰刀，这次，他不但要用引力贯穿埃癸斯的盾，还要贯穿日夕的身体。\\n“喂！捡破烂的，他们是我们的猎物！” 一名决杀零式喊道。\\n“给我一边凉快去，我暂时留着你们的灵魂！”\\n这四名不朽级的变异怪兽对骂的同时，丝毫没有减慢攻击埃癸斯和日夕的速度。\\n当埃癸斯想再次发动『传说之力』时，技能被一名决杀零式封印了。\\n日夕擦掉脸上的污汁，努力睁开眼睛想给埃癸斯回血，可惜，连回血技能也被封印住了。\\n下一秒，破魂领主的第二次攻击又来了。\\n此时，马克也在拼命思考对抗的方法——\\n如果把埃癸斯的“防线”看作橄榄球比赛的开局布阵，日夕就像一个只有一侧护锋和截锋保护着的四分卫。从破魂领主的攻击方式来看，即使日夕身后有另一侧护锋和截锋也没有用……不过，等等——\\n埃癸斯和日夕的前方没有其他怪兽挡住，破魂领主的引力贯穿力度和刚才相比，强大了好几倍，五面副盾的中心都出现了裂痕。\\n“你们好，初次见面。然后，永别了！嘿嘿嘿！”破魂领主嚣张地笑道。\\n“休想！”\\n埃癸斯把重盾插入脚下的坚冰之中，\\n眨眼之后，五面副盾被依次击碎，化作墨蓝色的淡光消失。\\n——这是当破魂领主的引力贯穿埃癸斯第一面副盾的时候，马克想到的办法。第一面副盾被击穿后迅速切换到第二面副盾之后，一层层承受和削减敌人的攻击力，直至所有副盾被击碎。\\n“啧啧，还能这样？” 破魂领主饶有兴致地舔舔嘴，“呵，不过，越顽强的灵魂越美味！”\\n破魂领主正想第三度发动『引力·贯穿』的时候，发现眼前闪过一个黑影，随后重重摔落重盾之上。\\n谁能想到拥有极致防御的埃癸斯竟敢放开重盾，主动绕后出击。\\n随后，一个极度耀眼的光球倏地直冲云霄，多亏了埃癸斯，日夕得到了短暂的喘息。\\n重盾也跟着飞了上去，没入光球中。光球之中，重盾重新回到埃癸斯手上。\\n“可以了，日夕小姐，之后就交给我吧！”\\n“……好。”\\n日夕的体力只足够支撑这短暂的飞行，懊恼和安心感同时涌遍全身。\\n埃癸斯抱着日夕，一起下坠。\\n很幸运地，他们掉落在一块敌人数量不多的雪地上。\\n日夕的技能封印已经解除，她赶紧为埃癸斯和自己回血。\\n“……埃癸斯，对不起。”\\n日夕强忍着泪水，本来不需要同伴搭救也可以顺利脱身的，正因为自己被仇恨冲昏了头脑，才连累埃癸斯跟着自己陷入险境。\\n“日夕小姐……我们必须回去找古拉姆了。”\\n埃癸斯不知道该怎么安慰日夕。\\n“嗯。”\\n日夕深吸一口气，用力抹了下眼睛。",
    "resoundEventConfigDes_10013": "古拉姆趁着罗密欧一愣的间隙，四把副剑再次向朝着逆焰龙王腹部刺去，后者慌忙向后飞跃，把罗密欧摔了下来。\\n“喂，你是想到什么办法了吗？”古拉姆不懂林宇翔突然来这么一出是什么意思。\\n“我们来引开邪王的注意力，让埃癸斯去救日夕，待会不管我干什么，你都忍着。”\\n“……好！”\\n古拉姆（林宇翔）翻滚了一圈跳起来，手里拿着一片玫瑰花瓣，望向罗密欧，肉麻地说道，“达~令~我们，就别再演了嘛~”\\n古拉姆马上意识到林宇翔是要挑拨邪王的关系，他拼命抑制着恶心感——没错，古拉姆已经通过一段时间的漫画学习，通晓了异界的一部分常识，他很清楚“达令”这个词的意思。\\n邪王也听出了“古拉姆”最后那个词的甜腻感，一种古怪的不安涌上他们心头。\\n“你、你刚才叫我什——”罗密欧问道。\\n“把话说清楚！”朱丽叶打断罗密欧的话。\\n“罗密欧，真正喜欢的，是我——阿嚏！”\\n林宇翔举起那片玫瑰花瓣，挺起胸膛，向朱丽叶发出挑战。\\n四周顿时陷入一片死一样的沉寂中，只有林宇翔喷嚏声的余韵在大家头顶飘扬……\\n趁着怪兽们都被如此戏剧性的发展惊吓住的时候，林宇翔向埃癸斯打了个眼色，后者马上明白他的意思。\\n埃癸斯握紧拳头，强忍心中的悲愤，朝日夕所在跑去。\\n“哈！？你以为用这种愚蠢的离间计，就可以挑拨我们的关系、侮辱我们的爱？呵呵呵！呵呵哈哈哈哈……”朱丽叶大笑不已。\\n“我只是再也不能忍受我的土肥圆小亲亲继续呆在你这个专制、妒忌心重、自以为貌美如花的毒妇身边！”\\n“你、你在胡说什么！”\\n本来也想捧腹大笑的罗密欧，看着古拉姆真挚的双眼，开始相信连雄性也无法抵挡自己的魅力。\\n“小亲亲，离开这个毒妇之后，你就能光明正大地送花给我了——阿嚏！”\\n古拉姆拿捏着玫瑰花瓣，做出一个比心的手势。\\n“我的土豆泥，这些玫瑰花瓣是怎么回事？那一招，不是用来媚惑难搞的雌性的吗？”\\n朱丽叶从黯炎古龙身上跳下，抓住罗密欧，忐忑地问道，她正是因为纷乱的玫瑰花瓣而无法看清罗密欧的战斗状况，才担心地飞了过来。\\n“这个……是为了让你知道我的战斗有多么华丽……”罗密欧硬着头皮说出了一个相当幼稚的理由，“我只是使出恰恰好的效果，他们又不是雌性。”\\n“等等，我的炸薯条小亲亲，你不用再给这个毒妇面子。”林宇翔可不想给罗密欧继续解释的机会，他连珠炮似的继续说道，“明知道只有对雌性才有媚惑效果的招式，还要向我使出来，这说明什么难道还不够明显吗？这是战场上不顾一切地示爱啊！既然无法改变彼此的敌对立场，就让我们的爱情像短暂的烟花像娇弱的玫瑰尽情璀璨尽情绽放，或许下一刻我们就要亲手杀掉对方，但让这份爱情随着我们的生命一起凋零，不是很壮丽吗？和你那丑恶的占有欲比起来，这才是罗密欧想要的爱情！！”\\n啪、啪、啪——在听着林宇翔嘴炮的变异怪兽中，不知道谁鼓起掌来。\\n林宇翔还没说完。\\n“没错，异界也有罗密欧和朱丽叶的爱情故事，他们出生在彼此仇恨的两个家族，我和罗密欧就是和他们一样。忘了告诉你，我的真名是真·朱丽叶·古拉姆！我才是传说中的朱丽叶！！”\\n“——！！？？”\\n古拉姆没想到还能扯到这份上，他已经跟不上林宇翔的思路了。\\n“愣着干嘛！快趁现在！”林宇翔向他大喊。\\n“啊！”古拉姆这才回过神来。\\n他高高跃起，挥舞火焰剑，朝离自己较近的朱丽叶腿部劈过去。\\n与此同时，朱丽叶尖叫着，举起法杖往罗密欧的头顶狠狠敲下去。\\n“你这个渣雄！！”\\n“对不起！我错了！”\\n咦？不对——\\n刚说完，罗密欧才发现自己没有需要道歉的地方，自己根本没有移情别恋！难道胡说八道才是古拉姆的绝招？能朱丽叶深陷于古拉姆的诡辩中无法思考，让罗密欧差点以为自己真的爱上古拉姆。\\n罗密欧的额头留下一道细血，但是头部的痛楚远不及因朱丽叶误会自己产生的痛苦。\\n他挡在古拉姆和朱丽叶之间，一手挥出剑气攻击偷袭爱侣的古拉姆。",
    "resoundEventConfigDes_10012": "经过刚才的一轮指挥，变异兽群别说剿灭古拉姆和埃癸斯，还让古拉姆和埃癸斯突破了，让罗密欧好不淡定，他无法对那两个雄性怪兽施展那招媚惑异性的绝招，又不确定自己能否帅气地秒杀两兽。最终兵器也比预想中要早逃出来，还有那个蠢货暴虐战狂。这一切都让他愈发焦躁，他咬了咬牙，决定亲自出手。\\n“亲爱的，你永远，是只属于我的玫瑰！我去去就回，你不要插手，这是属于我的战斗！！”\\n罗密欧对朱丽叶如此宣告到，然后他拔出长剑，跳到一条逆焰龙王上。\\n“我的雄鹰，小心点。远古族，比我们想象中的还要难对付。”\\n“放心吧，我的小鸟，我不会让你成为寡妇的。”\\n“记住你对我的承诺。去吧，不要让我被他们抢走！”\\n罗密欧的独占欲让朱丽叶心潮澎湃，罗密欧冲进战场后，由于纷飞的玫瑰花瓣挡住了爱侣的翩翩身姿，朱丽叶急得撕咬着袖子，最后还是按捺不住，让身下的黯炎古龙向罗密欧飞去。\\n古拉姆和埃癸斯已经和罗密欧对战了十多招。\\n站在逆焰龙王背上的罗密欧以玫瑰花瓣扰乱他们的视野，同时利用剑风和制空优势封锁了他们的攻击。\\n“埃癸斯——阿嚏！”古拉姆大喝，数不清第几次了，古拉姆的攻势硬生生地被喷嚏挫顿了大半——他竟然是对玫瑰花过敏的体质。“帮我跳上去！”\\n“好！”\\n埃癸斯瞬间会意，下蹲将重盾横在头顶。\\n古拉姆和埃癸斯同时发力，借助向上推举的盾，古拉姆猛力一蹬纵身跃起，跃到罗密欧面前，挥剑劈下。\\n“喝啊——嚏！”\\n在这个喷嚏的空档中，古拉姆被罗密欧和逆焰龙王反压在地上。\\n“我的另一个爱慕者呢？哦吼，答案好像都刻脸上了。”罗密欧的语气充满挑衅。\\n“可恶……”古拉姆的动作被完全封死。\\n“死了？”罗密欧追问，期待的语气中有那么丁点的惋惜。\\n古拉姆的四把副剑乘着他的怒火对着逆焰龙王腹部一顿突刺、砍劈、横扫、斜削，但都被罗密欧轻松挡开。\\n“古拉姆！”\\n埃癸斯想冲过去救古拉姆，却被一道紫色光波挡住去路，随后第二道紫色光波紧接而来，埃癸斯举盾挡击，但光波力量从重盾传至他的双腿，一阵痛楚窜过他的全身。\\n“宝贝儿，你怎么来了？”\\n“还不是担心你嘛~”\\n“亲爱的，告诉你个好消息，你的情敌，那个月亮，死了！”\\n“呀……呵呵！呵呵呵！呵呵呵呵呵呵！唔啊！”\\n罗密欧和朱丽叶互送飞吻。\\n邪王疯狂的笑声，让古拉姆和埃癸斯更为悲愤。\\n“再附赠你们一个好消息，那边的小太阳也要快要熄灭了，好事要成双了！”朱丽叶兴奋地说。\\n“宝贝儿，千万不要眨眼，看着我打败他们的英姿。”罗密欧说。\\n“宝贝儿，我看着呢。”\\n“等等！”林宇翔情急之下脱口而出，“我已经不想隐瞒了我们的关系了，朱丽叶我告诉你——！”\\n“什么？”罗密欧和朱丽叶异口同声说道。",
    "resoundEventConfigDes_10011": "暴虐战狂不知冲杀了多久，终于看到了不远处的古拉姆，五把长剑自如破敌，矫捷勇猛的姿态不同于往日，这令暴虐战狂狂喜不已。\\n暴虐战狂离古拉姆越来越近，几乎到了挥斧可及的距离。\\n“真·神剑古拉姆！”\\n“真·暴虐战狂！”\\n他们都看到了对方，喊出对方全名的同时，用各自的武器直指对方，算是尽了决斗前的礼节。\\n长剑划破大气咆哮。\\n巨斧随风怒吼。\\n可惜，剑斧只是相击了几下，他们在抵挡跳开的时候，立刻遭到各自身边的怪兽群围攻。\\n古拉姆的脸被一名撼地兽的拳头砸中，他后退几步，还没站稳，又被两名圣堂武士扑到身上。\\n暴虐战狂则被几名炎之高兴群殴。\\n“传说之力，破！”\\n古拉姆先甩开了一名圣堂武士，然后将下沉的身体往上一弹，直接打飞了第二名圣堂武士。\\n“嚯嚯嚯！！”\\n暴虐战狂大笑着，再次施展了他面对群攻的必胜之技，毫无意外地，变异怪兽又倒下了一片。\\n“为了和我们对战，不惜堕落到邪王那边去吗？”古拉姆向暴虐战狂喊道。\\n“这法子不是挺不错的吗！”暴虐战狂从另一头大喊。虽然他屡次被一名合一零式封印了攻击和回血的技能，但他干脆趁此挑战自己低血高攻的极限，然后一等到技能解封，就砍倒一堆怪兽，顺势向古拉姆那边逼近。只是每逢那种时候，那名合一零式就会先躲到暴虐战狂的攻击范围之外。\\n又一次剑斧相碰时，暴虐战狂问古拉姆：“我突然改变主意了，我们就先比着谁杀的多？”\\n“无聊！”古拉姆吼道。\\n“好吧，对手是你的话，不是单挑不过瘾，战场这么乱让你输了还有借口可不行！”\\n暴虐战狂说完毫不犹豫地朝一块砸向自己和古拉姆的巨型陨石撞过去。\\n就在眨眼之后，他瞄到那名合一零式又要封印自己的技能，于是反手把刚才自己劈裂的一块陨石扫了过去。\\n合一零式被小型陨石撞倒，释出的封印技能落在自己的同伴身上。\\n一切发生在电光火石间，暴虐战狂要是再掉血，生命就走向终结，所以，此刻正是他攻击力的巅峰。\\n暴虐战狂的双瞳闪烁着灿烂的狂气，他的巨斧卷起暴风、闪电与惊雷，扣下要把大地一分为二的劈砍。\\n“混沌之力——觉醒！！虐杀！！！”\\n不知道是第几次发动这两个技能了，暴虐战狂希望这是今天的最后一次。\\n借助生死极限的力量膨胀起来的攻击以雪崩般的破坏力向前方扩散。\\n第一个迎上斧刃的是刚才一直在纠缠古拉姆的血渊守护。血渊守护的躯体裂成四块之后，又有数名究极级的怪兽在斧风之下裂成几块。\\n寒风发出悲鸣，空间在不断震动，世界似乎被无数战斧劈过。被暴虐战狂这一击蹂躏的有二十余名怪兽，被他们鲜血染红的雪地似乎在溶解、在沸腾。\\n那名合一零式羽冠上的羽毛已经被斧风削落，然后系着尖钩齿轮的锁链被劈断，最后背部被纵向砍裂，手脚也在脊柱断开的瞬间掉落在地上。\\n尽管满脸血污，但暴虐战狂露出了像沐浴在爽朗宜人的阳光中那样爽快的笑容，和刚才恶鬼般的屠戮者仿如两兽。\\n“你真的愿意回到我们这边？”\\n古拉姆问暴虐战狂。\\n“什么这边那边，我只想干翻大陆的强者，然后打败他们。”\\n“暴虐战狂，那这里就交给你了。”\\n看准暴虐战狂会帮忙似的，古拉姆并不是在请求他的帮助。\\n“对付剩下这些杂种，我一个就够了！嚯嚯嚯！你可别先死了。”\\n说完，暴虐战狂扛起战斧，再次扑向战场。\\n最终兵器和暴虐战狂并没有约定在同一时间出现，但这种巧合给了古拉姆和埃癸斯脱身的机会。\\n现在挡在他们前方的是邪王罗密欧。",
    "resoundEventConfigDes_10010": "最终兵器来之前被困在邪王房间的宝库之中，洛菲菲发现最终兵器捶了很久，宝库的墙壁连条裂痕都没有，只好试着另辟蹊径，寻找逃离的办法。\\n冰雪城堡刚安静了下来不久，就有几只怪兽在外头对两个“瓮中之鳖”展开了阴阳怪气的嘲讽，很可能就是将他们困在宝库的犯人。\\n谁能料到原本失去希望生无可恋的史卡非斯突然站直了身子，与外头的怪兽“交流”了起来，在洛菲菲看来，行骗很可能存在种族隔离，史卡非斯现场瞎编的翻黑为白、掰直成曲、毫无逻辑、狗屁不通的低级骗术，居然就奏效了。\\n遭到了史卡非斯滔滔不绝的洗脑后，外头的怪兽打开了宝库。\\n洛菲菲很生气，她已经不想考虑站队的问题了，她只想好好折磨一下那对产狗粮男女。\\n一路带着史卡非斯来到冰川谷的战场，之后的事，洛菲菲就交给最终兵器了。\\n最终兵器就像是一台大型割草机一样，在变异怪兽群的草坪上，以书写回文的方式一行紧接一行地在战场往返，变异怪兽群就像是割草机后面乱飞的草一般。\\n至于暴虐战狂，他带着在邪王雪岭没能逮住古拉姆的满腹愤懑，骑着飞龙登上冰川谷，挥舞战斧冲进了战场。\\n这些变异怪兽见邪王麾下的一员猛将竟反叛了他们最爱的王，那就是说终于可以放开手脚出一口之前被虐的恶气了，他们有一个美好又单纯的想法，认为单挑赢不了的群殴难道能输。很快，各种等级的变异怪兽从空中、四面八方围攻暴虐战狂。\\n暴虐战狂的战斧接连劈飞接近他的怪兽。幻化级的怪兽全部在一招之内被打趴，而究极级的怪兽最多撑不过五招。\\n和古拉姆尚会对低级怪兽手下留情不同，越是能一斧劈死敌人，暴虐战狂就越能发泄心中的愤懑。很快，他所经之处变成了一条暗红色的河流。\\n“第一次打这种规模的架，爽！”\\n“你是担心剑盾会过早地死在变异怪兽的群攻之中吧。”邬羽刹调侃道。\\n“哼，如果他们活不下来，就说明也不过如此。”\\n暴虐战狂身上到处是伤痕，第二波扑上去的怪兽以为很快就能将他击破。可是暴虐战狂在笑，仿佛故意接纳痛楚、故意受伤似的，这让怪兽们开始感到疑惑，某几名怪兽甚至停下了攻击。这时暴虐战狂突然采取行动。\\n“混沌之力，觉醒！虐杀！！”\\n暴虐战狂让全身旋转起来，战斧随之划出一个闪耀着暗红色光芒圆形。斧刃处的暗红尚未来得及显现，就迅速被更鲜艳的红色所覆盖。\\n距离暴虐战狂最近的一圈怪兽纷纷倒下，但是，站在他们身后的怪兽没想到攻击还没结束，战斧明明没有触碰到他们，但他们身上分明出现了被斧刃劈过的剧痛，从裂开的皮肉中飞出的血证明这并不是幻觉。\\n直到第三圈怪兽也倒下时，他们才发现暴虐战狂的攻击范围在增大，而且攻击的力道更在不断增强。\\n“混沌之力，嗜血！！”\\n高喝一声后，暴虐战狂深深地吸了一口气，露出吃饱喝足的满足的表情——血量回复了大半。\\n“怪、怪物！打不死的怪物！”一名幻化级的怪兽哆嗦道。\\n而一名不朽级的合一零式却看出了端倪。\\n血量越低，攻击力越强；攻击力越强，攻击范围越大；攻击范围越大，自我的血量回复就越高——\\n一个完美的循环！\\n怪不得暴虐战狂根本不在乎自己掉血，掉得越多，对他越有利！",
    "messageInitContent_8748": "来人喂两位怪兽吃饼",
    "messageInitContent_8749": "这不是是冲过去送吗",
    "messageInitContent_8753": "拿出小工具",
    "messageInitContent_8754": "走近竞猜",
    "messageInitContent_8751": "最喜欢看原生怪打架了，只有1个技能",
    "resoundEventConfigDes_10009": "为了尽快突破尸族的防线，罗密欧和朱丽叶带领飞龙部队在防线后方不断投入变异怪兽群，这让原本还能支撑一段时间防线开始崩溃。日夕飞去的敌阵正是这一个。\\n一开始罗密欧与朱丽叶只是在变异怪兽群的上空指挥进攻。此外，罗密欧还打着一个小算盘，要亲自下场作战，他矮胖的身体就会没入众怪兽中，朱丽叶就无法看到他帅气的身姿了。\\n接着，邪王发现了乱逛的金色太阳，还有那格外醒目的五把火焰剑和数块有着暗蓝纹路的盾牌。\\n“日夕已经是风中残烛了，变异怪兽群就能将她吹熄呢。”\\n朱丽叶发现日夕比上次见到的更强大、更光彩照人，因此非常担心罗密欧会被日夕诱惑，听到罗密欧这么说，才放下心来。\\n“用剑的那个……就是古拉姆？”朱丽叶立刻把话题转向古拉姆。\\n罗密欧心里咯噔了一下，情敌果然帅气非凡！\\n“不自量力，以为剑多就能追求我吗？”\\n“噫，那个耍盾的就是埃癸斯？他的眼神似乎在说，和古拉姆一起打败你之后，再来争夺我呢！”\\n朱丽叶激动地尖叫起来。\\n先不说埃癸斯眼中有没有那种诉求，单是这两个雄性远古族怪兽的身姿，就足够让罗密欧如坐针毡。\\n他们都警惕着自己的“情敌”，让变异怪兽群前去围堵试图冲到日夕身边的古拉姆和埃癸斯。\\n当看到日夕被可爱的手下围剿、古拉姆和埃癸斯救而不得的时候，他们又同时放下心中的不安，开始讨论等这几个远古族首领死掉后，怎么用他们的武器做成战利品。\\n“亲爱的，我要把那对双胞胎的头发割下来，做两个漂亮的吊饰，我的法杖挂一个，你的长剑挂一个。”\\n“噢！这就是传说中的情侣装吗？要不要把另外那两个家伙的剑和盾都铸在我们的王座上？”\\n“这主意不错！”\\n“顺便把那位小公主的翅膀也折下来！”\\n“还有那个战斗狂的斧头，我要拿来帮你修胡子！”朱丽叶不悦地眯起眼睛。\\n暴虐战狂对她毫无倾慕之情，让她深感郁闷。\\n就在罗密欧和朱丽叶畅想着如何处置六个远古族和他们的遗物时，战场的局势突然发生了倾斜。\\n在古拉姆和埃癸斯后方，一队他们熟悉的身影来从他们左右两翼杀出，是一支远古族各个部落战士组成的精锐部队，稳定的攻守治愈三角让他们冲到了这里。\\n“首领！”\\n“是我们部落的战士！”古拉姆精神一振。\\n“埃癸斯大人！月夕大人呢？”\\n埃癸斯没有作答。\\n“首领，这里交给我们，请一定要救出日夕大人。”那名一向坚强的战士，声音中竟然出现了一丝哽咽。\\n“一定！”\\n其实埃癸斯还发现这支支援部队，尽管都是精锐，数量却不多，只有二十多名。但不由他多想，救下日夕才是当务之急。\\n在同族战士的帮助下，埃癸斯和古拉姆又突破了一层，但这还不够，前方实力又上了一个档次的变异怪兽群，仍旧坚实地挡在他们前方。\\n这时，最终兵器突然从天而降，暴虐战狂也从战场的北边挥舞战斧疾冲而来。\\n“你们——怎么？”\\n不管是前者还是后者，他们的出现对在场的大部分怪兽而言，都是意外。",
    "messageInitContent_8752": "历史久远的过去",
    "resoundEventConfigDes_10008": "在月夕死亡的瞬间，离月夕最近的古拉姆和埃癸斯心头一颤，在心头升起一股强烈的不安的同时，发现哪儿都看不到月夕的身影。\\n很快，金色“太阳”引起了他们的注意，让接近傍晚的天色仿如白昼，日夕披着由太阳光辉化作的铠甲，在战场四处乱冲。\\n“古拉姆，快过去，是日夕！”埃癸斯帮古拉姆挡下了几下攻击。\\n“好！”\\n埃癸斯、古拉姆放开手脚，交替掩护着冲出一层层变异怪兽的包围。\\n日夕集中精神，在极高的速度下寻找这泪眼中一闪而过的那个带角怪兽，愤怒的她不时朝带角的怪兽们击出数个光球。\\n但靠着复仇的意志充盈起来的澎湃力量，刚才用媲美流星的速度飞来之后，已经泄了小半，朝变异怪兽群胡乱攻击一通，又泄去小半。日夕飞行和攻击的速度稍微缓了下来。\\n除了一开始有几名幻化级和究极级的变异怪兽被日夕击破之外，后面回过神来的变异怪兽开始对日夕展开了还击。\\n但日夕对身上的痛楚浑然不觉，依旧追赶着带角的变异怪兽。\\n朱雀飞到古拉姆头顶。他已经感知到了发生了什么，月夕的牺牲就如夜空中最明亮那颗星星的陨落。\\n“朱雀大人，月夕是不是？”\\n还没等朱雀开口，古拉姆就抢先问道，那是一个他猜到了答案，却必须要确认的问题。\\n“月夕牺牲了，快把日夕带回来！”朱雀强压着悲伤说道。\\n“怎、怎么会！？”古拉姆悲愤交集，紧咬着嘴唇，握着剑的手在不住地颤抖，悬空的四把剑仿佛也在颤抖着。\\n“我还有什么资格说守护同伴！”埃癸斯怒吼道，将对自己的怒意发泄到盾前的变异怪兽上。\\n“我、我去杀了他们！！”古拉姆和林宇翔同时发出怒吼。\\n“我不想那么快见到第二个牺牲者！”朱雀厉声呵斥，经过和“电光紫鸭”的一战，他的回血力量大不如前，即使这样，如果他当时能在月夕身边，只要能给月夕回复哪怕一丝血量，月夕也有两线生机，朱雀深深地自责着。\\n古拉姆和林宇翔大喝一声，终究还是强忍下复仇的冲动。\\n变异怪兽的数量在快速增加，一部分是早已抵达的变异怪兽，以欧文猜测的方式躲避侦测，然后悄然出现，剩下的则是正在陆陆续续赶到这里的变异怪兽。在月夕牺牲后没多久——朱雀俯瞰了一下战场，变异怪兽的数量已经是尸族战士的十倍了。\\n但是，一大批脚程稍慢的变异怪兽还在路上，等他们到达后，恐怕邪王军队会壮大到远古族和尸族以卵击石的地步。现在最优的对策，是集聚力量伺机脱离对方的围剿。\\n朱雀越过并肩作战的古拉姆和埃癸斯，朝日夕所在的地方冲过去。\\n贸然飞入敌阵的日夕，就像一块掉进苍蝇群中的蜂蜜。变异怪兽发现她只攻不守之后，自然而然地形成擅长当肉盾的抗打型怪兽吸引她的攻击、其他怪兽在其背后偷袭的阵势。\\n不过，古拉姆和埃癸斯还是晚了一步，众多的变异怪兽早已挡住了他们的去路。朱雀只能频频帮日夕回复，但这也是徒然，日夕的伤势越来越重，而她自己好像根本不在乎似的。\\n而日夕追逐的目标，那只走了狗屎运的独角兽，此时正举着自己的兽头，在混乱的战场中哼着小曲儿，顶着月夕冰冷的躯体，四只小腿蹦蹦跳跳、左右躲闪，向罗密欧与朱丽叶的所在奔去。\\n“啊啦啦~远古族首领月夕，被无敌的独角兽大人杀掉啦，杀掉啦。我就是独角兽哈哈，噢，我的大功劳，谁呀，谁呀，谁都别想抢走啦啦啦~啊啦啦~朱丽叶大人赏我一个吻~呜啦啦~罗密欧大人赏我一只鸭~吃掉它~吃掉它……”\\n不过，他才蹦跶几步就停下来了。\\n等等，就这样冒冒失失地穿过战场，功劳恐怕马上就会被其他更高级的怪兽夺走！\\n没有被立大功后的狂喜冲昏头脑的独角兽，立马想到了一个聪明的主意。\\n他刺死了一只正巧经过他身边的幼体级怪兽，让这只倒霉的怪兽盖在月夕的躯体上。随后穿过混乱的战场，跑进了附近的一座冰山中。他打算在冰山里钻出一条绕过主战场、通向邪王所在的隧道。\\n先不说独角兽屡次挖错方向，光是他没有考虑到邪王不可能一直待在同一个地方，就注定了他的领功之路遥遥无期。",
    "messageInitContent_8757": "技能技能技能技能",
    "resoundEventConfigDes_10007": "日夕背部突然传来的一阵剧痛。\\n李雨蒙强行停住脚步，强烈的虚弱感袭向全身，她眼前的月夕正往深渊中急坠。\\n随之，心脏仿佛被掏空般的，眼泪像缺堤的洪水一样流下来，化作焦灼无比的悲伤，不断涌进本应是心脏的那个缺口中，肩膀因为抽泣而越来越强烈地颤抖着。\\n在滂沱的泪水中，李雨蒙看到了四溅的血肉和疯狂旋转着的独角。\\n只需要瞬间，她就明白了那种悲恸的由来。\\n意识虚空中，一直由李雨蒙拢在掌心的那点萤光冲出它手心，猛然膨胀成一个光球，光球很快变成一个少女的轮廓，通体散发着耀眼的金光，双眼燃烧着绝望和愤怒的火焰。\\n“日夕——！”\\n月夕的死，让日夕的力量彻底被激发。\\n李雨蒙感受到体内的力量随着日夕悲愤的不断扩大而膨胀，短裙化作由火焰织成的华服，身后的太阳上跳动着比往日更炙热的日珥。\\n“……唔……嗷——啊——啊！！”\\n她们的躯体再次行动起来。\\n金色的“太阳”刮起一阵酷热的狂风，飞向北边的天空。\\n日夕开始了她的寻仇之旅。\\n此刻，李雨蒙才体会到日夕对月夕的情感，比她以为的要深厚。但是，她有种不好的预感——\\n因为悲恸和愤怒而涅槃重生的心，究竟会更坚强还是更脆弱呢？搞不好，这才是日夕彻底崩溃的样子。\\n与日夕一同北飞的还有刚到又折返的朱雀。\\n目睹日夕离去的寇斯金和巴萨克，过了好一会儿才回过神来。\\n“发、发生什么事了？”寇斯金问道。\\n“又疯了吧。”\\n“……”\\n寇斯金轻轻摇了摇头。虽然他不知道日夕为什么会突然间爆发出可怕的力量，但那纯洁的金光，绝对不会成为邪王的助力。\\n待日夕离开后，寇斯金才发现自己躺在一汪温水上。热风刮过的地方，冰雪皆融。",
    "messageInitContent_8758": "小马感觉逃",
    "resoundEventConfigDes_10006": "在世界树为中心的战场上，北侧有来自邪王雪岭的变异怪兽群、暴虐战狂、一部分被打了个措手不及的尸族战士，以及刚到步的三位远古族首领圣盾埃癸斯、神剑古拉姆、月夕；而南侧，罗密欧与朱丽叶带着结晶平原的变异怪兽群向世界树周围的尸族战士主力攻去，钢铁龙王巴萨克、尸王寇斯金和日夕为首的尸族战士努力维持着战线。\\n北侧战场，龙族的火焰在地上奔腾，流星的爆落让雪地千疮百孔。尸族战士正处于劣势，勉强靠着天赋的吸血和回复能力艰难支撑着。远古族首领的加入使得形势发生了转变，正与尸族战士激烈缠斗的变异怪兽，嗅到了他们目标的气息，纷纷围袭而来。\\n “尸族的战士，吾乃圣盾埃癸斯，邪王用自私的‘爱’污染大地，用虚伪的‘恨’扭曲意志，使我们同胞相残，饱尝痛苦。请随我一同奋战，一起抗争，守护吾等热爱的大地，守护吾等珍视的同伴，守护吾等美好的未来！”\\n埃癸斯一边用力呼喊，一边举盾挡下猛烈的进攻。\\n尸族战士也撕吼着回应盾之主的呼唤，重整阵势，振奋精神。\\n作为整个远古三角的输出核心，古拉姆在埃癸斯的侧翼以攻代守，全力进攻，同时牵制住一名不朽级的血渊守护和数名究极级变异怪兽，连他自己也没有意识到自己背后何时出现了四把漆黑精钢中流动着炽红焰光的剑。\\n四把剑虽比他手中的大剑略细，却不失力道灵动非凡，凌空挥转间直指对手的破绽。\\n在意识的虚空中，古拉姆和林宇翔无暇对话，他们高度默契地将精神灌注于控制五把剑的变化中。\\n月夕想要尽快到日夕身边去，但她没有忘记自己的天职，不断地治愈友军，净化敌军，为她目光所及的受伤怪兽裹上柔和的银光。\\n净化的效果似乎远大不如前，受到净化的变异怪兽只是略微减缓了攻势，很快又回到战斗中去。看来越是渴望力量的变异怪兽越难受净化影响。\\n远古族三位首领为中心的战线缓慢向世界树方向推进，他们的剑盾扫开变异怪兽，但随之就会有更多的变异怪兽冲进刀光剑影中。各种焰光和爆炸充斥在其中，在空中激起阵阵余波，余波所及之处还有各种被撞飞，或是被敌方飞行部队冲散、抓起、丢落的怪兽。\\n此时，在月夕的余光中，一只身受重伤的叉叉在她的右前方急坠而下，月夕伸出手将叉叉接住，同时给予它净化与治疗，再松手让它随本能逃跑。\\n就在这数秒间，一只叠满了霸气的异形在乱战中被击飞，然后狠狠地撞上刚松手放开叉叉的月夕，在巨大的冲击力与霸气的双重作用下，月夕如同脱轨的卫星猛然从弯月座驾上甩出。\\n弯月在主人的召唤下骤然加速冲向她，留下一道银白的残影。\\n还是这数秒间，一只在月夕下方的独角兽做了一个毫无技巧的向上突刺动作。\\n月夕背部传来了钻心的刺痛，朦胧间，她的胸口冒出了一根交替闪过寒光和血色的粗刺，那是月夕的血肉不断溅上粗刺又被甩飞的光景。\\n——心脏被独角兽的独角贯穿了……\\n这是月夕和欧文在超进化大陆的最后一次思考，欧文和月夕眼前一黑，世界陷入静默。\\n意识的虚空中，两人交织的思绪开始同那弯月一样慢慢消逝。\\n“月夕……”\\n“欧文先生，对不起，对不起，对不起……我不甘心……”\\n冰川谷一战，月夕压榨了本已所剩无几的体力，勉强支撑着，欧文没有劝阻，他确信月夕不会听，更担心那样会削弱这个身体的力量，他应该阻止的。月夕向那只小怪兽伸手那一刻呢，他应该阻止吗，可他心底默默倾慕着的不正是那个伸出手的月夕吗。还是应该在更早以前，就阻止月夕，不……\\n“月夕没有错。”\\n“呜哇啊啊啊啊啊……”",
    "messageInitContent_8755": "跑去哪",
    "resoundEventConfigDes_10005": "在浮冰的掩护下，月夕带着古拉姆和埃癸斯蜿蜒飞行，随着他们的靠近，暖风骤起，冰川谷上传来了愈来愈大的武器碰撞声、撕吼声，世界树沧木·霜方向，数头逆焰龙王和黯炎古龙往返俯冲，不时将炙热的龙焰吐向冰冷的大地，纯白的冰川谷化作浓雾蒸腾的火红战场。\\n“朱雀大人！小夕就拜托了！”月夕近乎哀求道。\\n“大家一切小心。”朱雀沉吟了一下，飞向更深处的战场。\\n靠岸之际，古拉姆和埃癸斯放开弯月座驾，往前跨步跳下，紧随在空中直冲的月夕往战场一路狂奔。\\n\\n时间回到古拉姆、埃癸斯、月夕抵达邪王雪岭之后不久，寇斯金在位于世界树周围的尸族战士大本营，吩咐手下随时戒备邪王的偷袭。\\n巴萨克则在训练场上蹦来跳去，他从冰川谷南边的海岸回来以后就在用这种暴跳如雷的方式训练尸族的战士，顺道发泄心头的愤懑。\\n寇斯金觉得那股暴躁的破坏劲头，应该要留到战场上。\\n“喂，巴萨克！”寇斯金叫住了巴萨克。\\n“哼，寇斯金，是想通了把尸族交给我了？”巴萨克想和邪王畅快淋漓地大战一场，现在立刻马上。\\n“你可别小看尸族了，他们可不像……”寇斯金没有把下半句说完。\\n这时一只捕食者飞快地向他的族长跑来。\\n“鞋……王，邪王哒……打过来嘞。”捕食者喘着气，透过漏风的大板牙大声叫嚷。\\n他们料到邪王可能会偷袭，但没料到是现在，变异怪兽群不是都还没完全集合吗？难道这就是月夕说过的攻其无备，出其不意？\\n“邪王！好哇，来送死是吧，省得老子去找你们了！”巴萨克仰天咆哮一声。“你，你你们，跟我走！”被巴萨克指到的尸族怪兽瞄了一眼首领，在寇斯金的挥手默许下随巴萨克出发。\\n“可别让巴萨克踩到咱们防御工事上了。”寇斯金又补上了一句。\\n“去你的。”\\n巴萨克再次冲向冰川谷南岸，和上次跑向南岸比，依然破口大骂，但很有精神。\\n寇斯金先是让手下把这一情报送去给日夕和古拉姆他们。之后跳上临时指挥塔，一个凸起的小冰丘之上。\\n一眼望去，尸族战士早已摆好阵势，行尸一支在前，捕食者一系在后，一个个张牙舞爪，摩拳擦掌。\\n“我的好家伙们！”寇斯金大声吼道，“你们都清楚，比谁都清楚，邪王是个啥玩意，同伴遭受的痛苦，我们要十倍捶回去！”\\n说是这么说，寇斯金并不打算主动进攻，毕竟尸族战士们更擅长打防守反击的阵地战。\\n“喔，喔喔喔喔！”\\n在同族战士激昂的回应声中，尸族首领察觉到了自己的心跳，在他过往经历的战斗中，各族间的小规模冲突就已经是最大规模了，像现在要投入全族力量的大战才是第二回。\\n也从没有过哪一次战斗会如此依赖情报。有机会真要好好打巴萨克一顿，居然就这么把机动性如此之高的一族拱手让了给邪王，偏偏留下来的那位首领还是飞不太动的。",
    "messageInitContent_8756": "哪里跑",
    "resoundEventConfigDes_10004": "暴虐战狂在邪王雪岭的这段时间，把邪王能看的手下都虐了一遍，成为了邪王雪岭中的恶鬼。\\n那么谁会是下一个呢？目前的选择有三：最终兵器、罗密欧、朱丽叶。\\n暴虐战狂抛出手中的三颗形状不一的石子，他想看看命运的石子会选择哪一位对手。罗密欧的裤鸭鸭3号突然出现正好挡住了石子落地的瞬间。随后朱丽叶飘过的长裙把命运的石子埋到了漆黑的裙底中。跟在罗密欧朱丽叶身后的影杀拖着一大箱变异孢子直接碾过命运的石子的所在。\\n“你们……”\\n“我们要去一趟结晶平原，古拉姆很可能会趁着我们离开，找上你们来，这些孢子就当是临别的赠礼吧。”\\n“这些孢子到底是什么回事我可是知道的。”话音刚落，暴虐战狂的巨斧便抵到了朱丽叶的胸前。\\n朱丽叶镇定自若地看着暴虐战狂，一手摁住长腿旁她那正要爆发的骑士罗密欧，悠悠地耸了耸肩，留下一句话就转身离开了。\\n“你可以给对手吃。”\\n罗密欧朱丽叶离开的次日，暴虐战狂看见最终兵器拎着史卡非斯在冰雪城堡中飘过，正想叫住最终兵器，转念一想，没有叫出声，他知道打扰一场决斗是不好的。\\n刚好此时又飘过了一位拖着齿轮的轮脉，暴虐战狂一手把轮脉拖住，他决定了，今天就请这位幸运的轮脉饱吃一顿变异孢子大餐。\\n就在这时，城堡外传来一阵呐喊和兵器相碰的声音。\\n “古拉姆，你可算来了。”\\n暴虐战狂一手将轮脉丢开，向外疾奔而去。\\n\\n古拉姆和埃癸斯一起放开月夕的弯月座驾跳上邪王雪岭，他们刚落地，就和一群变异怪兽遭遇了。数量过百，里面除了没有远古族，什么种族的怪兽都有，而且多半是究极级，其中还不乏数个不朽级的存在。\\n只消几下眨眼的功夫，他们就把古拉姆一行团团包围。\\n这队变异怪兽的出现是谁都没有预料到的。\\n伏兵的数量远比欧文预想的要多，他们可能来自西方，通过某种方式瞒过了斥候。斥候侦查的是成群的变异怪兽，若是他们刻意分散行进，就能避开了斥候的注意。那就是说现在大家不得不面对的这个场面，都是他的疏忽造成的。\\n“是专门等着我们的伏兵！”古拉姆抽出大剑。\\n古拉姆的断剑已经在上次的一战中重铸成不朽级该有的完整模样。此刻，手握大剑的他心中没有怯意，很想上去厮杀一番，但为了大局，还是忍住了。\\n“我们且战且退！”埃癸斯持盾护在月夕前方。\\n“月夕小姐，拜托你了！”埃癸斯说。\\n“快上来！”月夕压下弯月座驾呼唤古拉姆和埃癸斯。\\n“朱雀大人，麻烦你去联络接应的战士。”\\n朱雀转身飞远，月夕随即带着古拉姆和埃癸斯跟上，那是撤回冰川谷的最短距离。\\n“古拉姆，别想跑，快下来，和我一决高下！”伴着暴虐战狂洪亮的吼叫，一把闪烁着猩红色辉光的巨斧正冲着古拉姆飞来。\\n快要满上限的负重让月夕难于躲闪，古拉姆举剑格挡，然而冲击最后还是压在了月夕身上，月夕拼命集中精神，才勉强维持住平衡。\\n他们还来不及喘气，更多变异怪兽对准空中的唯一一个靶子发起了进攻，五花八门、各式各样的攻击如斜飞的密雨一般，射向靶心。\\n埃癸斯的主盾护着月夕，其他几面盾则不停变换着位置，应对剩余的火力。\\n“埃癸斯大人！古拉姆大人！月夕大人！这边！”\\n呼喊他们的正是来接应的尸族战士，他们原本待在浮冰掩体上候命，看到朱雀的信号以后，立刻跳入海中，全速推着掩体前进与古拉姆他们汇合。\\n月夕喘着大气落到浮冰之上，负重高速飞行让她比古拉姆和埃癸斯更为疲倦。\\n随着朱雀温暖的焰火落下，他们身上的伤口开始逐渐愈合。\\n“这都是我的责任。”欧文自责道。\\n“不，这是我的责任。”古拉姆一拳捶向浮冰。\\n“这是我的责任！”埃癸斯又重重地复述了一遍。\\n“现在不是自责的时候。”朱雀的话语充满威严。\\n一阵沉默后，一位行尸甩着脑袋指着天空叫道：“看，他们还没发现我们在这！”\\n不远处的天空上，有一排黑影，暴虐战狂正踩在最前头的飞龙身上四处张望。\\n“我怎么会忽视了这一点，我怎么会没有多想一步，他们的目的是……”说话的是欧文，他不自觉的咬紧了下唇。\\n此刻，大家都突然意识到了邪王的真正目的，他们要从邪王雪岭和结晶平原两路包围冰川谷。\\n“我们必须尽快赶回去，来吧。”月夕说着同时将弯月座驾召出。\\n古拉姆和埃癸斯都把各自的话吞了回去，他们谁都不愿意让月夕过于劳累，但月夕的语气中透露的坚定和担忧，不容古拉姆和埃癸斯辩驳。",
    "resoundEventConfigDes_10003": "邪王雪岭上，寒风依旧。\\n洛菲菲借口说预言书还没完成，拒绝了跟朱丽叶一起去结晶平原，不过看来罗密欧朱丽叶已经不打算等预言书完成了，只是让她讲述了几遍预言书剩下的故事梗概，她也如罗密欧朱丽叶所愿，奉上一次比一次悲惨的结局。\\n是的，预言书可以草草了事了。\\n洛菲菲来到史卡非斯所在的牢房，史卡非斯那巨大的木头脑袋前后晃动着，用手不停地刻上最终兵器讲述过的情节。\\n“史卡非斯。”\\n“啊，最终兵器大人！您可真是没有半点脚步声。”史卡非斯慌忙转身。\\n“废话，没见我是飞着的。”\\n“我有要事和您商量，请靠近一些。”\\n洛菲菲靠到牢房的栏杆旁边，史卡非斯开始小声对着她嘀咕了起来。\\n洛菲菲没想到，史卡非斯以前拿来骗日月姐妹召唤具的借口，竟成了他现在笃信的希望——“收集足够多的召唤具，就能打开通往异世界的道路……”\\n“也许，我是说也许啊，罗密欧朱丽叶还没有发现召唤具的秘密，就是说召唤具可能还在冰雪城堡中的某一处！我和几个守卫也小小的‘交流’了过，只有罗密欧和朱丽叶的房间是不允许任何怪兽接近的禁地，召唤具大概就在那了。”\\n“你的每一个也许、可能、大概都很美好。”\\n“大人，难道你就不想回到自己的世界吗？”\\n就这简单的一问，勾起了藏在洛菲菲心底的某些东西，即便她极力否认，否认控制欲极强的父母，否认过去被规划好的人生，否认那个充满断层的世界。可是，数次惊醒时，先是以为自己正躺在自家的床上，再意识到不过是错觉，这种复杂滋味是不会说谎的。\\n所以最终洛菲菲憋出了这么一句话。\\n“哼，我倒是也挺好奇召唤具的能量共鸣会是什么样的。”\\n于是，有了洛菲菲捶晕牢房守卫，拖着史卡非斯的坚冰手铐和史卡非斯，避开还驻守在冰雪城堡里的其他怪兽，悄悄飞到城堡外的露台上，发现罗密欧和朱丽叶房间并没有锁，然后推开了房门的事。\\n最终兵器的视线穿过黑暗，一下落到了伫在房间中央的黑影上。\\n竟然是罗密欧和朱丽叶！\\n洛菲菲和史卡非斯大吃一惊，前者慌忙展开守备的姿势，后者躲到了前者身后，他们倒吸了一口气之后再仔细一看，是罗密欧朱丽叶的……两个等身冰雕，虚惊一场。\\n洛菲菲和史卡非斯都松了口大气，他们环顾整个房间，很显然要有什么宝物，必然就藏在等身冰雕下方的高台之中了。\\n至于这高台机关的破解方法，实在是过于露骨——洛菲菲和史卡非斯用力将两尊雕像推到相吻的位置。一阵微微的晃动随之传来，高台中央开了一个口，一条秘道显露出来，秘道里头闪着幽绿色的光。\\n“召唤具就在里头，他们没有带走召唤具！”史卡非斯激动不已，一马当先跳进了秘道，洛菲菲闪身跟上。\\n突然，不久前的晃动再度传来，洛菲菲猛抬头，往上疾冲，来不及了，开口已经关上了，他们被困在了高台里头。\\n“史卡非斯，你敢骗我！”洛菲菲迅速回身将史卡非斯撞倒在地，高举的铁拳正对准史卡非斯面门落下。\\n“菲……让我杀。”\\n意识的虚空中，最终兵器的意识浮现，将洛菲菲的意志拉回到了宽广的意识虚空之中，将她从高台下的幽闭的空间里抽离。\\n现在换成了最终兵器出拳。\\n“等等。”\\n洛菲菲叫住了最终兵器。\\n她看到了史卡非斯生无可恋的样子，和他背后的一大堆发着幽绿色光芒的进化孢子，她知道那并非骗术，欺骗她的不是别人。\\n“是罗密欧和朱丽叶，那两个混蛋、变态、垃圾、渣滓、地底泥、草履虫……”\\n“混蛋、变态、垃圾、渣滓、地底泥、草履虫……”最终兵器毫无感情地重复着洛菲菲的话。\\n之后，粗话夹杂着最终兵器全力猛捶密室墙面的钝击声，响彻整个冰雪城堡。",
    "resoundEventConfigDes_10002": "一队飞龙正从邪王雪岭高速飞往南方，他们的爪下和身上都带着多名怪兽，罗密欧朱丽叶就在队伍的正中。\\n巴萨克一边破口大骂，一边追着昔日的部下，最后无奈地停在了再往前一步就是超星海洋的地方。结晶平原与冰川谷之间相隔不远，可旱鸭子巴萨克也飞不了多远。\\n寇斯金与匆忙回报的斥候稍作交谈后，转身大步奔向日夕休息的冰洞。\\n这时古拉姆、埃癸斯、月夕和朱雀正在冰洞中商讨着日后的计划。\\n“前去联络远古族的两位长老，不知道他们怎样了。”马克说道。\\n“幽鬼小姐姐走水路，尸王大兄弟走陆路，幽鬼小姐姐肯定要更快，她可是有六只手划水的，放心好了。”林宇翔答道。\\n“好像……也是……”耿直的马克陷入了思考。\\n“不许欺负马克。”意识的虚空中，古拉姆用手臂圈住林宇翔的脖子，另一手握拳重重地捶在他的脑袋上。\\n“除了远古族、尸族，我们还能集合到更多的战士吗？”欧文问。\\n“比较难，灵族大概还在忙着摧毁石塔，木偶族一碰上什么风吹草动就会躲起来，龙族就……”埃癸斯没有继续说下去。\\n这时候寇斯金急匆匆地出现了。\\n“邪王拉着大部队往南方的结晶平原去了，他们要把世界树晶木·柏做成雕像！”\\n“啊……？”\\n“真的假的？”\\n“还挺有邪王风格的。”\\n大家多少都有些惊讶。\\n“可别大意了，我过去看看——”朱雀振翅侧身飞出了冰洞。\\n呼啸的冰风逐渐化作干爽的和风，结晶平原迅速在朱雀眼底铺开。\\n晶木·柏本是一棵美丽的世界树，叶子熠熠生辉，绿如翡翠，树冠上还长着一块晶莹剔透的翠黄水晶，巨如比蒙。如今败叶发软耸拉，水晶浑浊无光，水晶包裹体中还覆上了数缕粗大的紫絮——那是邪王能量注入大地的显现。\\n邪王罗密欧和朱丽叶坐在晶木·柏不远处的黯炎古龙身上，指挥着变异怪兽在晶木·柏的枝丫上锤锤打打，直到他们发现了上空的朱雀，发起了野蛮的冲袭。\\n朱雀没有理会这一切，盘旋数周后就回到冰洞，把自己看到的情况告诉古拉姆他们。\\n“可恶的邪王，我们集结完成之日，就是你们分手之时！”在日夕度过生命危险后，林宇翔就开始变着花样嚷着要找邪王开战。\\n“最终兵器和暴虐战狂在结晶平原吗？”欧文想了想，问道。\\n“没看到他们。”\\n“就是说他们很可能还留在邪王雪岭，现在正是去找他们的时机。如果最终兵器和暴虐战狂能加入我们，那是绝大的利好，即使不能劝服成功，我们也不会有什么损失。”\\n“可是，小夕她……”\\n月夕转过头，担忧地看着身旁的日夕，她既想跟大家一起去找最终兵器和暴虐战狂，又想留在妹妹身边。\\n“……我们不要紧的。”日夕试着慢慢起身。\\n“小夕……”月夕赶忙伸手扶起日夕。\\n此刻，控制身体的是李雨蒙。\\n那场卑鄙的战斗结束后，在意识的虚空中，日夕的意识就像要随着已然耗尽的力量消失般，少女般的形体变成一点星火。李雨蒙把那点星火小心翼翼地拢在双掌之中，在月夕和朱雀的全力治疗下，快要熄灭的星火才渐渐恢复到萤火虫般大小。\\n“万一要和最终兵器他们战斗，月夕大人和朱雀大人请务必保留力量，得提防着邪王突然折回来偷袭大家。”\\n“嗯，我答应你。”月夕轻柔地抱住日夕。\\n“后面……如果日夕还是无法战斗，就让我和大家并肩作战吧。”\\n“嗯。呃……就……那个呃，就如雨蒙小姐所说，我们必须提防邪王的偷袭。”欧文说着松开了抱着日夕的手，帮助日夕靠坐好，往后挪了几步。\\n“根据现有情报，邪王雪岭大部分兵力都转移到了结晶平原。但变异怪兽群的集结速度比预计要慢百分之六十。世界树雕像大概率是邪王的幌子，因为结晶平原的地理位置远优于孤岛邪王雪岭，邪王很可能要把结晶平原作为变异怪兽群的集合地。”欧文又看向寇斯金，“请寇斯金族长安排战士在邪王雪岭与冰川谷间的海峡接应我们，我们会尽量避免战斗。冰川谷的守备同样不能松懈。还要派出斥候盯防邪王在结晶平原上的动向。总之，尽可能平稳度过和援军汇合前的这个时期。”\\n“行。”寇斯金拍了拍胸脯，“不过啊，要像你之前说的，那两个远古族死活不愿意离开邪王，你们咋办？”\\n“现在的我，可是有对上那个拿斧的都不会输的信心，不不，就算他们俩一起上都没问题。”林宇翔故意放慢了“没问题”三个字的语速。\\n“说得好，战斗就交给你了。”古拉姆小声附和。\\n“诶，你这话就……我们可是同伴啊！”林宇翔继续说，“再说我们可以说服他们，说服不了他们，就说服他们，再不行……”\\n“就只能打服了。”欧文模仿林宇翔的腔调接话。\\n“噗……”不知道是谁最先笑出了声，让在场紧绷着的琴弦们稍微松了一些。\\n最近一直状况不断，月夕敏感地察觉到了萦绕在大家上方的凝重气氛，大家自然而然地把一切交由欧文指挥，欧文也没有察觉到自己在不知不觉间背负上了多少压力。\\n一个优秀的治愈者除了治愈肉体上的伤，还要兼顾情绪上的治疗。看来她还有很多不足的地方，风趣幽默这项技能要恶补才行，嗯，到时候向林宇翔请教一下好了。",
    "resoundEventConfigDes_10001": "荒火龙的黑影在冰墙上不停扭动，夸张地演绎着古拉姆如何突然用变长的断剑劈断裤鸭鸭二号与日夕之间的能量链……\\n在炉火的掩映下，罗密欧与朱丽叶默契地相视一笑，从对方的眼眸中他们看到了各自的内心，看到了同样的狡黠。\\n“亲爱的，你说为什么异界预言书《罗密欧与朱丽叶》会是一部悲剧？”\\n“亲爱的，你真坏，明知故问，因为主演不是我们啊。”\\n“哈哈哈哈哈。”一高一矮两个影抖动着融为一体。",
    "messageInitContent_8750": "原来那些是包来的吗",
    "messageInitContent_8759": "快逃",
    "messageInitContent_6101": "那你很棒棒哦",
    "messageInitContent_8764": "在猜了在猜了",
    "messageInitContent_6100": "交界之处",
    "messageInitContent_8765": "我觉得左边厉害",
    "messageInitContent_6103": "对了！",
    "messageInitContent_8762": "左左右右前前后后",
    "messageInitContent_6102": "好湿",
    "messageInitContent_8763": "一眼左边",
    "messageInitContent_6105": "前面传送门",
    "messageInitContent_8768": "猜对day1",
    "messageInitContent_6104": "总算对了一次",
    "messageInitContent_8769": "希望大家蒙的都对",
    "messageInitContent_6107": "要不要5号位也一起",
    "messageInitContent_8766": "左左右右",
    "messageInitContent_6106": "我的笑容见2号位",
    "messageInitContent_8767": "我猜我猜我猜猜猜",
    "messageInitContent_8760": "请勿随地丢垃圾",
    "messageInitContent_8761": "这技能我熟",
    "messageInitContent_6109": "热了",
    "messageInitContent_6108": "冷静！",
    "messageInitContent_6112": "加油",
    "messageInitContent_8775": "黑子:你别过来啊",
    "messageInitContent_6111": "我想静静",
    "messageInitContent_8776": "怎么窝里斗了",
    "messageInitContent_6114": "墙神和小人是兄弟吗",
    "messageInitContent_8773": "这里是预言家，左",
    "messageInitContent_6113": "收徒",
    "messageInitContent_8774": "选对明天加鸡腿",
    "messageInitContent_6116": "别搞",
    "messageInitContent_8779": "有难同当",
    "messageInitContent_6115": "嚯嚯嚯",
    "messageInitContent_6118": "给你听听我的笑声哈哈哈哈",
    "messageInitContent_8777": "姐妹互掐",
    "messageInitContent_6117": "这就是世界的尽头吗",
    "messageInitContent_8778": "看看技能先",
    "resoundEventConfigDes_10023": "古拉姆是冰川谷此刻除邪王以外，唯一站着的怪兽，包括巴萨克、寇斯金、苏比斯和史卡非斯等其他怪兽，连稍微挣扎一下也做不到，就成了狈·爷的饭后甜点。\\n现在，所有邪王都朝着他们的最后一块肥肉，古拉姆逼近。\\n在第二道闪电劈下后，炼狱魔眼就迫不及待地想要试试他那新鲜出炉的眼眶，却发现古拉姆早已不见踪影。四处张望时突然看到他那自满的长睫毛落到了地上，反应过来要躲闪时已经来不及了，钻眼的刺痛一下炸了开来。\\n“啊啊啊嗷嗷——”炼狱魔眼尖叫着往前一缩，血泪如瀑布般从眼底喷涌而，那刚从它眼底刺出的剑尖已经退了回去。若不是量子巨龙一口将古拉姆的剑身咬开，炼狱魔眼就已经被古拉姆的巨剑劈成两半。\\n炼狱魔眼使劲甩开身上的血，仍旧通红的视野中，古拉姆正把剑一横，大步跃起，再次发起攻击。\\n“怎么可能！”\\n“能让怪兽无法动弹的光波，你就是靠这个杀死日夕的吧，邪王啊。”古拉姆大喝道扫出一剑，被早早守在炼狱魔眼前的量子巨龙挡下。\\n“你到底是怎么躲过闪电的，你明明不能动的！”炼狱魔眼急忙闪开，却不料这只是佯攻，古拉姆的四把副剑正朝着量子巨龙刺去。\\n“那条可以在满屏放闪电的家伙，每次发射完量子波，都会把不知道是胸部还是肚子上的光核保护起来。而且那个闪电一定需要很多能量，那个光核大概就是他的电池，所以弱点一定就是他的光核。”\\n“值得一试，趁着他护着那大眼的时候。”\\n四把副剑一把接着一把刺向量子巨龙的光核，正想保护炼狱魔眼的巨龙回防稍稍慢了一步，让一把副剑漏了过去。\\n只见溜过去的副剑稍稍刺入后，就砰的一声掉了出去。\\n“切，一把副剑的力量不够吗？”\\n“呜呜呜呜呜！我要杀了你这个爱抠肚脐眼的变态！！魔眼——！！”量子巨龙痛苦地嘶叫着。\\n“古拉姆小心！又要来了。”\\n古拉姆将四把副剑收回，紧握住大剑。\\n“震慑——！！”炼狱魔眼用绝不放过你的眼神瞪着古拉姆，那道让怪兽无法动弹的无形的光波再次照在了古拉姆身上。\\n“量子波动——！！”\\n“吼——！”古拉姆再次闪开雷击，朝炼狱魔眼送出一剑直刺，随后利落抽出。\\n炼狱魔眼瞪大了的单眼被大剑劈开，分成两半，他在变成两半前看明白了，古拉姆用四把副剑切开浮冰，改变了地形，借着变动的地形，无法动弹的古拉姆移动到了不受震慑光波影响的位置，再躲过了量子巨龙的量子波动。\\n“唔……够弹牙。”拿着大鸭大叉的狈·爷快步一冲，张开大嘴温柔地接住了留着血泪的炼狱魔眼。\\n紧跟在狈·爷后面的是挥舞着利爪的嚎叫着的赤色狮子，后头还有一只巨型小丑靠着肚腩从浮冰上滑行而至。\\n破碎的冰川谷之上，数位邪王目露凶光，诡异地停在古拉姆的前方，巨型小丑缓缓地向古拉姆伸出了手。\\n“啊，我们还挺受欢迎的，因为谁都不在了吗？那只大小丑向我们伸手是几个意思？因为我们活到了最后，世界才想起来要温柔一点吗？可去它的，谁要那点怜悯啊。BOSS呢……通常都会有好几……好几条血，这只叫邪王的BOSS……他的血条……就是就是……一条条蹦出来……送死的。我还记得有个游戏，它的最高难度叫作Deathmarch，向死亡行军，古拉姆啊，我多么……希望这就是一个游戏……这样就可以读档回到一开始了，可是……可是啊，我们就只有此刻了啊。”\\n“我们上吧！” \\n过往的经历飞速浮现，古拉姆在各族会议上的抱负、林宇翔当初的嫩气、与埃癸斯、月夕、日夕、最终兵器和暴虐战狂并肩作战的一幕幕。拼命压抑着的情感如同燥热天气的山火一样越烧越烈飞速蔓延，疯狂地吞噬着空气，快要叫人窒息，再也压抑不住的两股无比炽热的情感，注入到高举的长剑中，对准邪王挥出一击，爆发出来。\\n“传说之力！！破——！！！”，\\n这一击全凭意志挥出，饱含着古拉姆和林宇翔的一切，海底的岩层沿着大剑劈落的轨迹裂开，古拉姆和林宇翔带着无愧于心的、耀眼的骄傲，与无数怪兽的尸骸一同坠入深海之下的深渊。\\n冰山融化、海水蒸发，冰川谷化为一片纯白。\\n……\\n邪王化作巨大的黑影渐渐拥上天空，为超进化大陆降下了毁灭。",
    "resoundEventConfigDes_10022": "“所以……最后的选择是战吗？不对，选的是活下去吗？因为活着是选择的前提吗？”\\n洛菲菲一愣，一阵阵陌生又熟悉的波动从内心某一处扩散开来，带着巨量的信息，无数像是电脑窗口的半透明悬框不停地弹出，一条条用看不懂的语言编写的语句飞快地生成、滚动，包围着洛菲菲，那是最终兵器几百年来通过无数次战斗积累下来的经验。\\n“大家伙！我还以为……”\\n“我回来了。”\\n“你跑哪里去了？”\\n“雷击恢复了机体的算力。”\\n“等等，你说话怎么好像流畅了？”\\n“没有，是你的错觉。” \\n与话语相关的情报同时流入洛菲菲的脑海。\\n他们的思想以一种比以往更直接的方式来回着。\\n“你是故意被雷击的，混蛋！”\\n“在第一次雷击的时候，你早前输入的问题得到了某个解，意外解开了对机体的限制和束缚。”\\n“是‘你想要做什么？’吗？”\\n“一起战斗。” \\n“能赢吗？”\\n“我们一起的话，可以。”\\n最终兵器给了洛菲菲一个坚定的回答。\\n“真的可以吗？”\\n“我知道你为控制这副躯体所做的一切，我相信你。”\\n“别一本正经地说这种话。”\\n“阐述事实不可以吗？”\\n“还是以前比较可爱”\\n“那现在开始还原？”\\n“哼，先把他们揍飞了再说！”\\n洛菲菲的意识和最终兵器的意识逐渐重叠，思想的碰撞就在一个短暂的瞬间。伴随着浑身上下发出咔哒嘎吱的声响，最终兵器全身上下的部件变动着，构成从未见过的形态。 \\n两者的注意力回到了眼前的战斗，能躲过雷击绝不是普通的变异怪兽，罗密欧和朱丽叶是一组邪王，那眼前的怪兽群也可能是一组邪王。最终兵器拥有的情报使得“招”变得可见，既然可见就意味着可拆，没有题目就没有解，但有题目就多半会有解，这正是洛菲菲擅长的，求出能取胜的解，战术。\\n一声机械的轰鸣过后，机身上暗淡的紫光覆上了耀眼的赤红。刺目的光辉从最终兵器的双翅横冲而出，巨大的机器如同燃烧的流星俯冲冰面，一道红色的光弧划开了黑夜，化作死神的红色巨镰。美杜莎莎、珀耳修斯、海格力斯、比蒙巨兽、妖火，接连倒地。\\n在这短短的几个瞬间，洛菲菲诱使美杜莎莎出招，将珀耳修斯和海格力斯束缚住后握在左拳，右拳对妖火发起猛击后将其擒住，再冲向比蒙巨兽，然后在妖火炸开前一刻逃出火海。\\n洛菲菲能清晰地感受到最终兵器那股纯粹的力量，正与她一同精密执行了每一个战术。\\n新来的邪王没有给最终兵器留下半点喘息的空间，两股极高强的能量波自空中和水中爆发，随着一阵能震碎脏腑的嘶吼声，一轮不知何时升起的红日冲破乌云与风雪，朝最终兵器直扑而来。\\n最终兵器很快就看清了一头面貌狰狞的“赤色雄狮”，他那浓密的、随风飞扬的鬃毛散发着浓浓的血腥味。\\n他才闪身躲开赤色雄狮的扑击，就撞到一座“冰山”上！\\n不对！这是哪儿冒出的冰山？这片区域明明只有大小不一的浮冰。\\n最终兵器迅速和冰山拉开一段距离。\\n“呜呜呜……库库库……”冰山在抖动，冰山中传来像哭又像笑的声音，最外层的冰块不断掉落，露出一个庞然大物。那张似笑非笑的小丑脸上，露出了令人毛骨悚然的表情，垂到地上的大肚腩增加了一种不协调的滑稽感。可是，他的动作一点也不像他的外表那么滑稽，他瞬间飞扑至最终兵器的上方，张开双手将最终兵器紧紧地压入怀底。\\n最终兵器立刻做出回击，双拳朝上方以君临于所有活物的拳速挥出疾风般的连击。\\n“混沌之力——暴走！！！”\\n“喀喇”的可怕响声从“巨型小丑”体内响起，但巨型小丑并没有如洛菲菲预料那样退远多少，马上就稳住身形开始了再一次的冲击，赤色雄狮亦再次从正面袭来。但最终兵器的速度更快，他急速向上飞起，反身加速朝下俯冲，掷落轰拳。赤色雄狮和巨型小丑闪避不及，分别吃下了一击重拳，口吐鲜血，被拳头击中的部位就像纸屑似地粉碎，喷出大量血液。\\n巨大冲击迅速向外散开，底下的冰面裂成无数碎片，碎冰四处迸溅，宛若倒置的陨落星辰。\\n最终兵器却不知为何没有停下，冲破碎裂的冰层后，纵身贯入了冰冷的海水之中。\\n赤色狮和霸者在不久后才意识到那并非什么诡计。最终兵器确实地坠向超星海洋那无色的底部，如同他和洛菲菲的意识那般，没入那个名为无意识的深海。\\n在失去了对这个世界的全部感知前，洛菲菲竟然觉得小丑的脸有点可爱。",
    "messageInitContent_8771": "大佬快来指路",
    "resoundEventConfigDes_10021": "不远处，最终兵器的战斗仍在继续……\\n最终兵器在闪过了第一道落雷后，迅速将月夕的躯体放下，朝着远离邪王的方向逃奔。欧文、马克、李雨蒙的连续离去，还有压弯战力天平的新邪王的出现，让洛菲菲做出这个的抉择。\\n就在最终兵器躲开第二道落雷时，一股令人背部生寒的气息袭来，复数的毒蛇吐信子的“嘶嘶”声在他耳边响起，最终兵器的躯干一下被什么东西缠住，闪电毫不留情地贯穿而下。\\n洛菲菲的视野一下被白光占满，不存在的心脏狂跳着，接踵而至的是仿佛在突发性车祸中死里逃生的后怕与心惊，她先是意识到自己还活着，再是意识到另外两个可怕的事实——\\n缠在身上的数根蛇发化成焦碳落地，有五头怪兽对她展开了围攻。其中体型最大的有最终兵器体型的三倍，如同大象般的巨兽，每走一步都让冰面震动；还有一只像是穿着铠甲的蓝色焰火；另外三头就像是从盗版希腊神话绘本里走出来的人物，一个拿着狼牙棒，一个拿着大砍刀，最后一个是满头蛇发的怪兽，像是蛇发女妖美杜莎。\\n但比被围攻更可怕的是，现在掌控着身体的不是最终兵器，是她，洛菲菲。\\n“大家伙？大家伙！”洛菲菲在心底大声呼唤着最终兵器，但却丝毫感受不到对方的气息，也没听见任何的回应。\\n她只能控制着身体勉强躲过“象兽”的冲撞，一心想着趁机飞出重围，但两阵沉重而强烈的剧痛突然从身后传来掠过全身，伸出光翅的部位遭到了炎拳和狼牙棒的重击，飞行能力瘫痪了。\\n“连你都丢下我不管了吗？快给我出来——！” 洛菲菲带着浓重的哭腔不断呼喊着。面对密集的攻势，她胡乱挥舞着双拳。“拿刀的”接住最终兵器的重拳，掩护着美杜莎一起逼近，复数的蛇发再次飞出将她定在原地。\\n这下是真的要完了吗？绝望之中，洛菲菲脑海浮现起了地球生命大灭绝的记忆，从奥陶纪大灭绝到恐龙大灭绝，在那个时期，强者和弱者在世界赐予的平等毁灭前，失去了差别，弱肉强食的信仰亦随之崩塌，倒不如说乖乖等死才是最舒服的做法。但死了一切就没有意义了……\\n“所以说，谁要当个乖孩子啊——！”一股无名火从洛菲菲心中升起，她一下抓住了束在身前的蛇发，往后使劲一扯，连着蛇发的美杜莎被正正甩到了象兽冲撞的位置。",
    "messageInitContent_8772": "抄作业时间到",
    "resoundEventConfigDes_10020": "电白过后，邪王大战再一次拉开了序幕。\\n巴萨克、寇斯金、苏比斯和史卡非斯等一批怪兽根本无暇顾及其他，只能把一切精力放在躲避下一发雷击上。\\n“逃？多来几个才好，我们上！”暴虐战狂朝着新登场的邪王狂奔，只有邬羽刹在刚才的雷击中听到了暴虐战狂的狂言，令人血脉喷张的当下，正是让他们渴望不已的时刻。\\n“啊，上吧！”邬羽刹的声音在暴虐战狂的脑中响起，不断膨胀的躁动感从暴虐战狂身上爆炸开来。\\n眼看着邪王的身影不断变大，突然一声巨响从暴虐战狂的右侧炸了开来，底下的冰面一下从左侧翘起，朝右侧倾斜。暴虐战狂迅速跃起，一股烈风在他跃至最高点的一瞬从他的左侧呼来，虚空中闪出了一张血盆大嘴，两排锋利的獠牙紧随而至，旋即咬合。\\n“锵——”声刚落，火星四溅。身处无法闪避的半空，暴虐战狂急忙抽斧扣下，斧头代替身体被巨兽咬住。下个瞬间，暴虐战狂双腿朝敌人的腹部一蹬，借力把斧头从敌人的口中抽出，并乘势拉开距离，与袭来的巨兽展开了对峙。\\n这时，暴虐战狂才看到了刚才让冰面倾斜的东西——只剩下树干的世界树沧木·霜，就斜插在暴虐战狂侧后方的冰面上，以及对方的样子——一头雄性怪兽，长着粗糙的方正脸庞，身上每一寸裸露的部位都裹着自然隆起的肌肉，身高有暴虐战狂的两倍，脖子上缠着一条虎纹蜥，右手的叉子上插着一条永生蚯蚓，左手握着一只大鸭的脖子，口中咀嚼着一块从斧刃上咬下来的断角。\\n这副模样让邬羽刹想起了一个主持某档求生冒险节目的名人，那个名人的名字正巧就是巨兽的名字，狈·爷。\\n“唔……这斧头跟世界树一样难吃。”狈·爷将咬碎的斧头断角吐到了地面。\\n“撞大运了，这东西看起来超强！”暴虐战狂狠狠瞪住对方，兴致异常高昂。\\n“唔……你像是块好肉。” 狈·爷打量着暴虐战狂，确认道。\\n“嘁！”暴虐战狂率先发动攻击，朝狈·爷的喉咙挥出一斧。\\n狈·爷左手将大鸭当盾一顶，挡下斧锋，然后顺势提鸭推出，拿叉的右手随手向上挑起。\\n在大半条命被拉进死亡深渊时，危机就会刺激每一处神经，鼓动血液中的怒火，让暴虐战狂的力量抵达巅峰。\\n比起干等着危机来临，暴虐战狂宁愿主动陷入险况，他任由叉尖刺入掌心，鲜血横流，将狈·爷的叉子紧紧握在掌心。“混沌之力·觉醒！”另一手将斧头从大鸭身上抽出，对着狈·爷腹部的空档疯狂挥砍，切出一道比一道深的血痕。\\n“唔……也许这样也可以。”狈·爷嘟囔着，纠结地看着自己那些溅到暴虐战狂身上的血肉。\\n“混沌之力·嗜魂！”暴虐战狂娴熟地维持着自己的血线，同时他那疾风般的攻势在狈·爷的腹部挖出了一个深红的肉坑，眼看就要将巨兽打穿。\\n“别站着，还击啊！我要看看你还能撑多久！”暴虐战狂把被无视的愤懑化作一次比一次猛烈的挥砍。\\n“唔……看来还是不行，就算肚子没了，还是会饿的。”狈·爷嘀咕着，一手将叉子硬生生地从暴虐战狂手中抽出，一手大力地甩动大鸭，就像是一个在小餐馆赶苍蝇的大爷。\\n“别想逃？这个距离我也能劈死你！混沌之力·狂噬！嚯啊——！！！”暴虐战狂避开大鸭的冲撞，手中的巨斧飞舞，斧刃放着红光像涟漪一样不断扩大，掀起了比之前所有攻击更狂暴的飓风，在狈·爷身上撕开数条血痕。\\n“唔……我只是饿了。”一股巨大的压迫感陡然从狈·爷身上升起，“顶端之人——！” 狈·爷腹部快要被挖穿的血洞，竟开始在斧风中飞速愈合。\\n暴虐战狂看着自己最大的杀招，沦为注入狈·爷体内的血色涟漪，先于惊诧不已的大脑，经历百战的肉体做出了反应，将全身力气注入双脚，往后跃起跳至高空，即刻将距离拉开。\\n“开餐！”狈·爷犹如离弦之箭，一步蹬一步跨，紧随其后举叉一刺，不给暴虐战狂半点时间防备，将叉尖刺入暴虐战狂的胸膛，直抵冰面，溅起了些许雪花。\\n邬羽刹的视野开始交叠，隐约间他看到了插在身上的银叉，想起了在哪见过的，置于雪白瓷盘的那块插着银叉的新鲜牛扒，很难吃。他知道冒险家总是绕不开那个“险”字，越是艰难险峻的山峰越是受人青睐，对危险的预想与其说是为了做好应对准备，不如说只是图了个心理安慰。其中当然也有对死亡的想象，只是不如这般绝望。\\n“这段时间被你带飘了啊，战狂。”\\n没有回应。\\n邬羽刹不会知道暴虐战狂是不想回答还是不能回答，他永远不会知道了。\\n“好肉！”狈·爷一边咀嚼着，一边由衷地赞叹着，宣告着这场短暂的战斗已然结束。",
    "messageInitContent_6110": "冰霓牌空调",
    "messageInitContent_8770": "你们快选啊",
    "messageInitContent_6119": "不许威胁我小赤虹",
    "messageInitContent_6123": "会不会有点挤呀",
    "messageInitContent_8786": "左右横跳中",
    "messageInitContent_6122": "整点吃的",
    "messageInitContent_8787": "祝大家猜的都对",
    "messageInitContent_6125": "夜晚的喵叫",
    "messageInitContent_8784": "等我问问ai",
    "messageInitContent_6124": "猫窝",
    "messageInitContent_8785": "在左右之间迷失了方向",
    "messageInitContent_6127": "真不会打架吗",
    "messageInitContent_6126": "大狗狗小猫咪",
    "messageInitContent_6129": "wwwwwwww",
    "messageInitContent_8788": "正确的",
    "messageInitContent_6128": "我的草挺对称的",
    "messageInitContent_8789": "到底哪边啊",
    "messageInitContent_8782": "伤害倒是有的",
    "messageInitContent_8783": "小黑子是关键",
    "messageInitContent_6121": "大怪兽，小怪兽，中怪兽",
    "messageInitContent_8780": "有福同享",
    "messageInitContent_6120": "脸呢",
    "messageInitContent_8781": "有治疗吗",
    "messageInitContent_6134": "别做梦了",
    "messageInitContent_8797": "随机点",
    "messageInitContent_6133": "我的幻想是",
    "messageInitContent_8798": "夜观星象不知答案",
    "messageInitContent_6136": "火神的梦想是冰和赤能好好相处",
    "messageInitContent_8795": "我家猫帮我选了",
    "messageInitContent_6135": "做怪兽要有梦想",
    "messageInitContent_8796": "我有一个大胆的想法",
    "messageInitContent_6138": "我是2号位",
    "messageInitContent_6137": "别别别",
    "messageInitContent_8799": "总有一个对的",
    "messageInitContent_6139": "地面持续震动",
    "messageInitContent_8790": "选择困难",
    "messageInitContent_6130": "是大W",
    "messageInitContent_8793": "猜对day1",
    "messageInitContent_8794": "我梦到了是右边赢",
    "messageInitContent_6132": "大一点~雨再大一点点",
    "messageInitContent_8791": "抛个硬币看看",
    "messageInitContent_6131": "被御空狠狠硬控",
    "messageInitContent_8792": "技能知道答案",
    "messageInitContent_6145": "叉会腰",
    "messageInitContent_6144": "不够精神",
    "messageInitContent_6147": "天天早睡",
    "messageInitContent_6146": "自信的留言",
    "messageInitContent_6149": "五色战队变身",
    "messageInitContent_6148": "占地面积特大",
    "messageInitContent_6141": "你们正常点我害怕",
    "messageInitContent_6140": "giegie",
    "messageInitContent_6143": "前面是凶噬魔的嘴吗",
    "messageInitContent_6142": "开怼",
    "1_19": "生物屏障",
    "1_18": "真实伤害",
    "1_17": "子弹速度",
    "1_16": "攻击速度",
    "1_15": "射程",
    "1_14": "体型",
    "1_13": "攻击类型",
    "messageInitContent_10891": "欲知后续如何，请看下回分解",
    "messageInitContent_6156": "可是雪啊",
    "messageInitContent_10892": "搞什么？",
    "messageInitContent_6155": "你知不知道，你知不知道",
    "messageInitContent_10893": "提问超进化大陆有多少灾",
    "messageInitContent_6158": "什么海贼王",
    "messageInitContent_10894": "天气预报怪兽已阵亡",
    "messageInitContent_6157": "兄弟贴贴",
    "messageInitContent_6159": "伟大航道",
    "messageInitContent_10890": "五只灾兽竟然合体了！",
    "1_12": "霸气",
    "messageInitContent_10899": "让我对一次球球了",
    "1_11": "移动速度",
    "1_10": "体力",
    "messageInitContent_6150": "哥你什么年代的",
    "messageInitContent_10895": "我有一个大胆的想法",
    "messageInitContent_6152": "震怒之日？！",
    "messageInitContent_10896": "左左右右",
    "messageInitContent_6151": "强迫症震怒",
    "messageInitContent_10897": "人越多人越少",
    "messageInitContent_6154": "你在说什么",
    "messageInitContent_10898": "我选了这边",
    "messageInitContent_6153": "谁知键盘中餐",
    "1_29": "敬请期待",
    "1_28": "解锁",
    "1_27": "极化",
    "1_26": "进化",
    "1_25": "受伤倍率",
    "1_24": "负面效果持续时间",
    "messageInitContent_10880": "小美在狂风中独美",
    "messageInitContent_10881": "小帅冲着灾大喊",
    "messageInitContent_10882": "喊：如果观众觉得我更帅，你们就赶紧滚蛋",
    "messageInitContent_10883": "灾兽对此不屑一顾",
    "1_23": "增益效果持续时间",
    "messageInitContent_10888": "它们身上的毛炸开了",
    "1_22": "血量回复效果",
    "messageInitContent_10889": "变身！",
    "1_21": "自愈恢复",
    "1_20": "普攻恢复",
    "messageInitContent_10884": "地裂首先扒开了地面发起攻击",
    "messageInitContent_10885": "帅壮美立刻跳起回击",
    "messageInitContent_10886": "只见霎时迟那时快",
    "messageInitContent_10887": "它们身上的光一闪",
    "mainCityName_10": "黑暗森林",
    "1_39": "已装备",
    "1_38": "请从左边列表选择装备的元核",
    "1_35": "可挑战次数：{1}",
    "messageInitContent_10870": "注意看，这个怪兽叫大壮",
    "messageInitContent_10871": "注意看，这个怪兽叫小美",
    "messageInitContent_10872": "注意看，这个怪兽叫小帅",
    "mainCityName_19": "部落",
    "1_34": "领域副本",
    "mainCityName_17": "永生之茧",
    "messageInitContent_10877": "还有电闪雷鸣",
    "mainCityName_18": "凿星裂痕",
    "messageInitContent_10878": "竟是灾兽全都在这里降临",
    "1_32": "觉醒怪兽开启领域副本",
    "mainCityName_15": "造唤台",
    "messageInitContent_10879": "大壮脸无惧色",
    "1_31": "解锁条件",
    "mainCityName_16": "饲星坛",
    "1_30": "属性增益",
    "mainCityName_13": "战墙",
    "messageInitContent_10873": "小帅出门遇到了小美",
    "mainCityName_14": "浮空巨塔",
    "messageInitContent_10874": "小帅拉着小美去找大壮",
    "mainCityName_11": "谜之巢穴",
    "messageInitContent_10875": "大壮见到小美和小帅之后结伴去西边的大山玩",
    "mainCityName_12": "起源殿",
    "messageInitContent_10876": "走到半路突然天色大变",
    "resoundEventConfigDes_4006": "囤食洞穴的迎铃花响了，首先映入大家眼帘的，竟然是一轮弯月。\\n古拉姆皱了皱眉，他知道这轮弯月意味着什么。\\n弯月收起。\\n月夕缓缓走进囤食洞穴，一双清澈闪亮的眼眸，比这世上最珍贵的珠宝更令人惊叹，高贵的气质，优雅的身姿，银色的长发……看到她之后，原本都在窃窃私语讨论传的那些怪兽，仿佛突然都失去了说话的能力，被她所吸引所震慑，全都低下了头，似乎在月夕面前，他们都有些莫名地自惭形秽。\\n哇塞！大美人！\\n林宇翔有些兴奋，眼前的女孩子——他更愿意称她为女孩子，虽然是和人类有所差异的长相，但从人类的审美来看，也绝对是数一数二的美女了，而且她目测身高不会超过165，站在一群彪形怪兽旁边，显得格外娇小，令人有想要保护她的欲望。\\n“邪王尚未真正作恶，变异孢子的事情也还未查明，又怎能下定论，认为邪王一定是恶呢？若真如传言所言，一千年会出现一次可怕又残忍的邪王，又何尝不是对我们的考验呢？如果……如果能让恶转向善，为什么不去尝试呢？”\\n她声音轻柔，似乎是在对刚才嘲讽自己的怪兽说，又像是在对自己强调这一点。\\n此时和月夕共用身体的欧文轻轻地叹了口气，相处下来，他已经明显感受到了月夕的天真，但让恶转向善，哪有这么容易呢？\\n而一旁的林宇翔还沉浸在“这个世界竟然还有大美人”的震惊之中，并且发现她朝着自己的方向走来了！\\n “月夕。”\\n这是古拉姆的声音。\\n“呼，总算追上你了，古拉姆。”\\n女声依然轻柔动听。\\n林宇翔撇撇嘴，什么嘛，原来是来找古拉姆的。他正觉得有些失落和无聊，却在看清楚月夕的眼睛时，突然整个人呆住了。\\n古拉姆感觉到了林宇翔对身体使用权的争抢，林宇翔似乎变得很强大，竟然轻而易举地从他这里夺走了身体的使用权。\\n虽然只有一瞬间。\\n那一瞬间，囤食洞穴里所有的目光聚焦，所有怪兽都听到了古拉姆的大喊：“你！？是不是也是……”\\n然后古拉姆就把身体给夺了回来，并且警告道：“别添乱，我和月夕有很重要的事情要商量。”\\n“不是！”林宇翔连忙开口，“你仔细看她的眼睛，你不觉得奇怪吗？就像是……她体内有另外一个人？”\\n她的眼睛里，藏着另一个人。\\n这种感觉，就像是自己偶尔在用古拉姆的身体时，照镜子或者用手机摄像头时的感觉。\\n古拉姆一愣。\\n如果说在这个世界上，怪兽之间有“第六觉”的流动感应，也许林宇翔所在的那个世界也有。最关键的是，古拉姆看得出来，月夕已经进化到了不朽形态，联想到自己进化的过程，林宇翔说的很有可能是真的。\\n古拉姆试探性地开口：“月夕，你是怎么进化到不朽形态的？是不是也是在石塔？”\\n月夕微微顿了顿，然后蹙眉，轻声道：“出去聊吧。”\\n其实她是想在这里把事情都说清楚的，但离开这里是欧文的意思，欧文觉得囤食洞穴里人多口杂，可能会有意料之外的事情发生，月夕虽然不觉得这些怪兽会有什么恶意，但还是选择尊重欧文的意见。\\n古拉姆点点头，他从锻造工坊那里取走锻造好的大剑，和月夕一起到了一个偏僻之处。\\n“欧文先生是想亲自和他聊聊吧？那我将身体交给你。”月夕依然十分温柔。\\n“多谢。”\\n欧文看向对面的古拉姆，这是一具非常彪悍的战士身体，看起来非常强大，欧文其实有些忐忑。\\n毕竟莫名其妙来到这个世界，还和月夕共用一具身体已经非常匪夷所思，这个世界发生的很多事情都无法用原来世界的逻辑推断，他只能根据自己这段时间对这个世界的了解，还有刚才古拉姆的反常举动进行推测。\\n真的会有吗？\\n真的有和自己一样意外来到这里的人类吗？",
    "resoundEventConfigDes_4005": "这里有各种和动物长相类似的怪兽，比如狼、龙、野猪、兔子，当然也有非常类人的，除此之外，还有很多林宇翔完全没有参考动物的怪兽，像是坐在西北角的一个……圆滚滚的脑袋。林宇翔找了半天也没有找到他的四肢，甚至吃东西都是直接用嘴吃，完全不需要手的辅助，至于行走嘛，当然是用滚的。\\n“这么多不同类别的怪兽混在一起，囤食洞穴会不会经常陷入危机？”林宇翔想起自己看过的武侠小说，武功高强的人经常会在囤食洞穴打来打去，“经营一家囤食洞穴，感觉也很不容易呢。”\\n古拉姆摇摇头：“不，除非是水深火热的大战阶段，否则各族之间都有约定俗成的规定，不会在这样的中立之地展开战斗。如果真的闹得不愉快，会离开这里去外面战斗。贸然在中立之地动武，会遭到所有种族的追击和惩罚。”\\n原来如此。\\n林宇翔放下心来，继续看向周围，这些怪兽正在吃的东西非常一言难尽，肉类和植物不管长得多奇怪，起的名字多离奇，但至少还在理解范围之内，直到林宇翔听到离自己不远处的那桌上，有两条龙大喊：“再来两份钢铁侠！”\\n声音非常雄浑，整个小囤食洞穴都忍不住抖了三抖。\\n等会儿。\\n钢铁侠？\\n林宇翔盯着那张桌子，不一会儿，果然看到“服务员”抱上来了两份用钢铁拼成的人形，乍一看还真有点儿像地摊上摆的便宜钢铁侠，与此同时还给那两条龙上了两份调料，林宇翔瞪大了眼睛看着他们拿起一块块钢铁，蘸着不知道什么滋味的调料，吃的十分开心。\\n咬下去的时候，能听到咔嚓作响的声音。\\n“这里的钢铁和我们那边的钢铁是一样的东西吗？”林宇翔忍不住有些怀疑，“能轻松咬断钢铁的牙齿，是真实存在的吗？”\\n古拉姆早已司空见惯：“他们是铁甲龙，早就从肉食龙进化成了钛金食，牙齿如同利刃一般锋利。囤食洞穴里的钢铁侠一般是做过一点软化的，对他们来说是非常好的美食。”\\n一口一个钢铁侠什么的，听起来就好牛。\\n果然大千世界，无奇不有。\\n林宇翔在心中默默感慨。\\n“您的腐朽之汤来啦！”\\n林宇翔仔细看了看，所谓的腐朽之汤，竟然就是……豆腐汤？只不过十分浓稠，倒有点像豆腐脑，他深吸了口气，竟然闻起来很不错！\\n细算起来，这是他来到这个世界里正式吃的第一顿饭，他小心翼翼地试探古拉姆，争取到了多一点的身体控制权，发现大家进餐都不用餐具，他也索性捧起那碗豆腐汤，咕嘟咕嘟地喝起来。\\n哇！他喝过的最好喝的豆腐汤！哦不，腐朽之汤。\\n“古拉姆，你点菜水平真高！”林宇翔竖起大拇指，“腐朽之汤很好喝！”\\n古拉姆却没有接茬，而是立刻夺回了所有的身体使用权，侧耳细听。\\n虽然不知道古拉姆做了什么，但是林宇翔却清楚地感觉到，周围的声音变大了，那两条铁甲龙吃钢铁的喀嚓声听着都变得刺耳起来。\\n这是某种让耳朵变得更灵敏的能力吗？\\n“你听说了吗，邪王已经出现了！”\\n“真的吗？看来传言是真的，北方不再安全了。”\\n“千年轮回的邪王现身了，有谁知道邪王长什么样子吗？”\\n“无从知晓，只是听说，有些地方已经出现了变异孢子，试问，除了邪王，还有谁有这样的力量，能污染孢子呢？”\\n听到这里，古拉姆也不动声色地握紧了拳。\\n“变异孢子！我昨天才刚服下了孢子！该不会也变异了吧？”\\n“据说只有个别地方出现，还没有扩散开来，不过，也该多加提防了。邪王残忍可怕，但我听说，似乎还有愚蠢的远古族为邪王说好话！”\\n还有为邪王说好话的种族？\\n “愚蠢的远古族，是在说我吗？”\\n清丽的女声在门外响起。\\n分明声音轻柔，却吸引了所有怪兽的注意。\\n古拉姆也连忙看向了声音传来的方向。",
    "resoundEventConfigDes_4004": "“这两个雄性看起来没有之前的美味呢！”\\n林宇翔还在胡思乱想的时候，古拉姆走进了囤食洞穴，而林宇翔的注意力马上就被刚听到的惊悚的发言所吸引，他连忙小声道：“美味？不是我想的那个吧？”\\n“如果你指的是腐食者的话，”这家囤食洞穴的桌椅都是石制的，古拉姆在一个角落的位置坐定后，看向声音传来的方向，“是的，他们进食必需同时吞下两个怪兽。”\\n此刻，只见一张大嘴将两个生物都吞了下去。\\n林宇翔先是一惊，之后又觉得诧异：“呃，一口吞俩男？这是什么奇怪的爱好。等等，古拉姆，你该不会也吃这些东西吧？”\\n上次吃的那两个团子的怪味，至今还萦绕在他的口腔和心中。\\n他不由得有些担心起来，这个世界里的食物该不会都是这种吧？\\n“喝一点腐朽之汤就好了。”古拉姆语气轻松，“只是在囤食洞穴里歇歇脚，我并不饿。”\\n腐朽之汤……这名字听起来好糟糕！\\n林宇翔犹豫了一会儿才开口问道：“或许，你们有人类，咳咳，我的意思是，适合我那个世界过来的人吃的食物吗？”\\n事实上，古拉姆并不在意林宇翔想吃什么，毕竟这是他自己的身体，但他觉得有必要让林宇翔知道，这里并不是所有的食物，滋味都像上次的团子那样可怕，他所在的世界，肯定比林宇翔以前的那个世界强百倍！\\n古拉姆招招手，在囤食洞穴里行走的一只怪兽，似乎是店里的“服务员”，迅速蹦了过来，对待古拉姆的态度依然十分尊敬：“您要点什么？”\\n“先点一份腐朽之汤，”古拉姆想了想，问道，“还有什么别的推荐吗？”\\n“海藻茶、腐朽之汤、岩溶汁，”怪兽“服务员”忙不迭推销起来，“当然还有各类烤肉！看您想吃什么种族的肉，可以像他们那样，自己烤。”\\n他们？\\n林宇翔看了过去，发现有一个桌子上正在烤肉，而且，如果林宇翔没看错的话，他们正在烤鸡腿！\\n这个世界有烤鸡腿！\\n“那些正在烤肉的是……龙吗？他们烤的是什么？”\\n自从发现对这个世界龙和鳄鱼都有误会之后，林宇翔有点不太自信，所以问的有些心虚。\\n古拉姆点点头：“黯炎古龙，他们最喜欢烧烤。那是烤鸡腿。”\\n“哇！竟然真的叫烤鸡腿！和我那个世界的叫法一样！看来我们果然还是有共同点的！缘！妙不可言！”生平第一次，林宇翔因为烤鸡腿的存在而激动不已！“我要吃烤鸡腿！”\\n古拉姆声音冷漠：“烤鸡腿不好吃，要吃烧烤的话，烤腐朽还不错。”\\n腐朽还能烤的吗？\\n鬼知道你说的腐朽到底是什么东西？！\\n“诶！我看看其他人都在吃什么！”\\n林宇翔突然对这个世界充满了好奇，拼命想扭转身体看看四周，察觉到他的想法，古拉姆虽然觉得不耐烦，但还是略略配合地将一点身体掌控权交给了林宇翔。",
    "resoundEventConfigDes_4003": "锻造工坊的锻造师放下正在擦拭的新剑，打量了古拉姆一会说：“客人，您应该是从远方赶来吧，有什么需要的就说吧。”\\n“普通大剑，尺寸按这个来，要坚韧，锋利，比较急。”\\n古拉姆抽出断剑递给锻造师。\\n此时，在林宇翔视野中，突然有一丝淡淡的类似紫气的物质从锻造师身上冒起，林宇翔没有放过这一点，一口气向古拉姆问了二十多个问题。奇怪的是，古拉姆好像没听见他的问题似的，没有给林宇翔任何回应。\\n林宇翔发现古拉姆的注意力都集中在眼前的锻造师身上。\\n锻造师接过古拉姆手中的断剑仔细地打量了一会。\\n“行。”\\n“那就有劳了。”\\n锻造师抬头憋了一眼似乎完全没打算离开的古拉姆，说道：“您先出去吧，太阳下山再过来取剑。”\\n是不能拒绝的语气。古拉姆这才点了点头，离开锻造工坊。\\n“古拉姆同学，古拉姆同学，喂喂，听到吗……”古拉姆一转身，林宇翔那不带停顿的声音才开始渐渐变大，疯狂地挤进古拉姆的脑海。\\n“怎么了？”\\n“刚刚我一直在问你问题呢，平时……那个，关于这个世界的问题你平时都会立刻回答我的，这次突然就没反应了，还一直盯着人家锻造师看，我还以为你怎么了。我刚问你，那个锻造师身上冒出来的紫色是什么东西？”\\n“到囤食洞穴再跟你解释，那里解释起来更清楚一些。”古拉姆没有让林宇翔继续说下去，向东走去。\\n没多久，古拉姆就来到了锻造工坊附近的小囤食洞穴。\\n古拉姆在囤食洞穴门口停了下来下小声说道：“看好了。”\\n林宇翔再次看到先前的不明物质从囤食洞穴中的怪兽身上飘起，虽然没有先前在锻造师身上看到的那么清晰。\\n“这是流动，通过第六觉可以感受到，绿色是原生级，蓝色是幻化级，紫色是究极级，紫色之上则是不朽级，橙金色的流动。某种程度上意味着怪兽的实力。”\\n古拉姆发现此刻林宇翔想举起手看看自己的流动，也并无反抗。\\n环绕的是橙金色的流动。\\n“哇，这超强！”林宇翔突然反应过来。\\n虽然“第六觉”这个词让他很想吐槽，不过林宇翔知道，古拉姆应该不至于吹牛，按照这个说法，古拉姆算得上是这个世界里非常强的战力了，诶，那看来自己的运气还不赖？\\n至少抱到了个大腿。\\n不对，是操纵着比较强的战士。",
    "1_49": "熔炼",
    "messageInitContent_10859": "德玛西亚~~",
    "resoundEventConfigDes_4002": "“他们飞走了吗？”等了好一会儿，林宇翔轻声问道，“哎，你先把身体给我一会儿！”\\n古拉姆虽然没有回答，但林宇翔已经能够掌控身体了，他小心翼翼地从水里探出整个脑袋，环顾四周，确认蜜蜂们不在了之后，开口道：“可以出来了吧？泡在水里的滋味真难受！”\\n古拉姆冷哼一声：“哼，这都是拜谁所赐。”\\n林宇翔摸了摸鼻子，决定宽宏大量，不和古拉姆计较，他缓缓朝着岸边走去，眼看快要走到了，却突然发出了“咦”的一声。\\n好像踩到什么东西了。\\n“谁——踩——了——本——陆——龙——”\\n威严而沉重的声音，从脚下传来。\\n啊咧？\\n林宇翔慌忙抬起脚，这才发现原来脚下有一个生物，林宇翔脱口而出：“小鳄鱼？你是不是很爱洗澡？”\\n“我才不是鳄鱼！”脚下的生物猛地提高音量，跳起来敲打了一下林宇翔的膝盖，“我可是堂堂的龙族，陆龙！”\\n古拉姆也开口道：“他的确是陆龙。”\\n“怎么看都是鳄鱼吧？”林宇翔歪着脑袋打量着陆龙，“那个，不好意思啊鳄，不对，陆龙，我不是故意踩到你的，对不起，你没事吧？”\\n陆龙抬起头，瞪大了眼睛看着林宇翔：“我没事，有事的是你！猛龙摆尾！”\\n说着，陆龙猛地一摆尾巴，突如其来的攻击让林宇翔措手不及，刚刚从湖里爬出来，这次直接被陆龙用尾巴扫回了湖里！\\n“哎呀！”——这是狼狈的林宇翔。\\n“真丢脸！最弱的战士都不会被陆龙打倒！”——这是对林宇翔非常失望的古拉姆。\\n虽然有些狼狈，但到底没有受什么伤，林宇翔重新站起来，看向刚才对自己发起攻击的陆龙。然后瞬间感觉到古拉姆正在夺回身体的掌控权，林宇翔握紧了手中的剑，大喊道：“给我一个证明自己的机会！”\\n古拉姆一愣。\\n林宇翔看得出来，眼前的鳄鱼，不对，眼前的陆龙战斗力不高，刚才虽然被他的攻击给击倒，但压根儿不怎么痛，当然这得归功于这具结实的身体，但也许自己可以拿陆龙练练手呢？\\n林宇翔继续道：“做了那么多练习，总算有实战机会了！你就让我试试吧！”\\n“你才练了几下，就说自己做了很多练习？”古拉姆忍不住嘲讽了一句，不过到底还是同意了，“如果你连陆龙都搞不定，就不要再打我的身体的主意了！”\\n“古拉姆同学你知道你说的话很容易让人误会吗？”\\n“神龙起身！”在古拉姆和林宇翔对话的过程中，陆龙猛地跳向林宇翔，“帅龙挥拳！”\\n跳起来的陆龙朝着林宇翔挥出一爪。\\n林宇翔这次有了准备，闪身避开，吐槽道：“喂，身为一只低级怪兽，你的招式名字是不是太多了？”\\n而且怎么连简单的起身都有名字啊？\\n“狂龙无敌连环拳！”\\n只见陆龙用爪子交替连续地发起了攻击，林宇翔左右闪避，耳边响起的是陆龙招式带起的呼呼风声。\\n古拉姆有些不耐烦了：“你还要躲到什么时候？”\\n“哎呀！对付敌人，当然要找一个完美的时机啦！”\\n林宇翔盯着眼前的陆龙，深吸了口气，将之前古拉姆教给自己的基本剑法又回忆了一遍，集中全部力量，朝着陆龙的方向，挥剑！\\n“喝呀！”\\n“猛龙摆……哇呀！”\\n陆龙再次用尾巴对林宇翔发起攻击，但才刚到一半，就被汹涌而来的湖水给逼退了！湖水猛地朝陆龙袭来，水波翻滚，陆龙直接被突如其来的水波冲到了好几尺远的地方！\\n是剑气！\\n虽然没有直接被林宇翔的剑攻击到，但陆龙感觉到了非常明显而且强大的剑气，从整个湖面的汹涌，还有刚才那股强大的水波攻击来看……如果直接被剑击中，陆龙应该已经丧命了！\\n陆龙大喊一声：“神龙逃跑！”\\n还没等林宇翔反应过来，陆龙已经跑的没烟儿了。\\n“这家伙，怎么连逃跑还起名字的？谁家神龙还逃跑啊？”林宇翔十分无奈，然后才后知后觉地反应过来，“啊！我赢啦！我胜利了！我击败了一条龙诶！”\\n“是幼体的龙族，非常弱的陆龙！”古拉姆的声音听起来非常不满，“而且，你那一剑还歪了！”\\n林宇翔挺起胸膛：“那是我故意的！”随后才补充道，“我是害怕你教我的剑招太厉害了，陆龙会直接死于剑招之下，我和陆龙无冤无仇，不如饶它一命，所以我才故意劈歪的！不管怎么说，现在赢了嘛！”\\n听到这话，古拉姆有些意外，他沉默了一会儿，才继续道：“好吧。”\\n好吧？\\n古拉姆说好？\\n虽然自己其实没想那么多，真的是方向歪了……林宇翔没想到自己胡说的理由竟然真的得到了古拉姆的认可，更加得意，兴高采烈了好一会儿才惊呼出声：“糟！我的手机！”\\n“刚才进水了，不知道有没有影响。”他慌忙将手机拿出来，十分担忧地盯着手机看了一会儿，发现手机没有出问题，才拍拍胸口，长舒口气，“呼，太好啦，这个手机还真的能防水，广告没骗我！”\\n古拉姆十分疑惑：“你不是说这是很好用的神器吗？神器怎么可能会怕水？”\\n“呃……”林宇翔拼命回忆之前自己瞎编的那一堆谎言，生怕记错了会让古拉姆怀疑，“是神器没错啊，但是能量不足！我不是说过了嘛，能量不足的话，手机就很脆弱，容易出问题！”\\n古拉姆沉声道：“它到底什么时候才能充满能量？”\\n这个嘛……林宇翔挠挠头：“神器充能都是需要时间的！难道你连这点耐心都没有吗？”\\n“它看起来能量更少了。”古拉姆盯着手机上的电量标志。\\n电量条已经不再是绿色了，林宇翔的手机上有电量显示，他看到30%的数字的时候，心里有些不是滋味。\\n这是他从那个世界带来的，是他和原来的人类世界相连接的，唯一证据。\\n即使他再怎么努力地想让手机保持有电，开启省电模式，基本不使用它，但手机电量只是个消耗品，恐怕用不了多久就没了。\\n“在它充满能量之前，”古拉姆察觉到林宇翔暗淡下去的情绪，有些惊讶于“他居然也会失落”，但古拉姆不可能说什么安慰的话，只是正色道，“需要先去铸一把剑，一直用这柄断剑不是办法。”\\n也要尽快想点办法给神器充能才行。",
    "1_48": "强化",
    "resoundEventConfigDes_4001": "林宇翔振作起来后，就恳求古拉姆每天都让他控制身体一小时，他要好好锻炼自己的体魄。\\n但在他的世界唾手可得的计时工具，在这里却变成了古拉姆从来没有听说过和难以想象的奇怪东西。\\n根据古拉姆的说法，这里是根据太阳的位置来决定是战斗还是休息。听起来是一种原始粗糙的生活方式，不过，在这个以进化为最大欲望和唯一目标的世界，也没那么多事需要精确到时分秒。\\n尽管如此，林宇翔还是让古拉姆从一数到三千六百。\\n幸亏这里也是采取十进制的计数方式。\\n对这个世界不了解的地方还有很多，但当务之急还是要锻炼好身体。\\n长跑五千米。\\n俯卧撑五十个。\\n引体向上五十个。\\n深蹲一百个。\\n仰卧起坐五十个。\\n平板支撑两分钟。\\n按照古拉姆的体格，应该能在一小时内勉强做完这些运动，虽然有点吃力，但严格要求还是要从头就开始。\\n那么，第一项是长跑。\\n估计十五分钟跑完，也就是用从一数到一千二百的时间。\\n迈开步子就能跑，很简单！\\n不过，怎么估算五千米的距离呢？还有，去哪跑比较好呢？\\n古拉姆马上给出了答案……\\n古拉姆推荐的这片阴暗的山地叫异域，说这里跑起来肯定没有在晨光草原那么舒服，但崎岖的地形增加了锻炼的难度。\\n而自己可不是个会在困难面前退缩的男人！\\n从这里跑到那个山头大概一百米，那就是跑二十五个来回。\\n呼哈！调整好呼吸……\\n步子很轻松地就迈开了，脑海里还浮现起上体育课时班里的长腿校花嘲笑自己跑一千米的样子。\\n“腿长就有资格笑我？”\\n“长得漂亮就有资格笑我？”\\n林宇翔心里念叨了几句有的没的，然后一眨眼，就发现自己到山头了。\\n这也太快了吧！\\n这座小山丘起码高五十米，虽然坡度还算平缓，但现在自己这种腿不抖气不喘的状态，也太厉害了！\\n原来古拉姆拥有深不见底的体能啊……\\n好！接下就测试一下这个身体的耐力。\\n结果——\\n当古拉姆数到一千的时候，所有训练已经完成了！\\n不知不觉间，本来只是打算锻炼一下，顺便显摆显摆自己科学的锻炼系统的林宇翔，不仅被古拉姆傲人的体魄给显摆了，甚至还开始测试起了古拉姆体能的上限。\\n“你这是在跳舞吗？”古拉姆的声音中藏着压抑下来的怒气。\\n林宇翔的“振作”，还真让他在某种程度上被震惊到了。不过，既然答应了把身体交给他主控一段时间，就不能言而无信。\\n就在古拉姆的耐性快到极限的时候，林宇翔刚好结束了一系列的体能训练。\\n在感觉到意识被抽离身体的一瞬间，林宇翔大喊。\\n“等等！刚才只是测试！”\\n“测试？”\\n“嗯嗯！既然我们是拍档，那我总要清楚你的力量，才能在日后的战斗中制定万全的策略。”\\n“那你满意了吗？对我的力量。”\\n古拉姆不懂那些易如反掌的动作到底能测试到什么，但他姑且耐着性子问问，如果林宇翔敢说什么挑剔的话，就马上拿回身体的主控权。\\n“满意是满意，不过……”\\n“不过！？”古拉姆心中的怒气开始冒出浓烟。\\n“不过，如果我们都会剑术，万一你被打倒的话，我好歹也能应付一下。”\\n“不可能！”\\n“我不可能应付得了？”\\n“我不可能被打倒！”\\n古拉姆同学你是不是没听过骄兵必败？也罢，经过这几天的相处，林宇翔已经摸清楚了古拉姆的脾性，于是他转变了策略。\\n“如果我连一招半式也不懂就和你搭档，似乎有点说不过去。”\\n“……”\\n嘿，小样儿的，稍微拍点马匹就动心了。\\n不过，让古拉姆动摇的却不是林宇翔的马屁。他一直寻思着，进化成不朽的自己无法发挥真正的实力，会不会和林宇翔的战斗力有关，现在唯一得到确认的，是林宇翔的话实在是多的没完。\\n没用的话多……\\n“行，那就教你从最基本的剑法练起。”\\n成功了！\\n林宇翔心中大喜。剑士是游戏中的经典职业，体力、战斗力、骑乘能力都是各种职业中一流的，自己一直想成为一名剑士，SSR那种。\\n而且，所谓游戏中的战斗招式，并不像武侠小说中描写的那般讲究动作的敏捷性和千变万化。它们依靠角色固有属性的高低，技能设计的强弱，只要集中力量“嘿呀”一下朝目标砍过去，就能释放巨大的杀伤力。\\n群攻也好单体击破也罢，以现在的身体出招，无论怎么看都是“帅”字当头。\\n古拉姆不能做林宇翔的实战对手，只能示范了几下一个基本的剑招后，让林宇翔重复他的动作。\\n只是很简单的挥剑动作，没有包含任何技巧，如果动作够快，再结合传说之力·破，还能置强敌于死地。\\n但那些都离林宇翔太遥远了。\\n即使这样，拜古拉姆的体能和断剑的威力所赐，以为挥剑杀敌是非常简单的林宇翔，其结果，是被狠狠教训了。\\n第一次挥剑，剑风呼呼生威。\\n第二次挥剑，放出如大炮般的一击，跟前的灌木被剑风连根拔起。\\n第三次挥剑，无敌是最寂寞的！\\n林宇翔的眼中洋溢着要展现战力冲动。\\n第四次挥剑，林宇翔朝着前方树上的铠脚蜂蜂窝劈过去！\\n强劲的剑风把铠脚蜂蜂窝刮下来，成千上万的铠脚蜂倾巢而出，带着愤怒的蜂鸣，朝林宇翔扑过去！\\n“这个笨蛋！”\\n古拉姆在林宇翔惊慌失措之际夺回身体的主控权，一剑挥开飞至眼前的铠脚蜂，赶紧逃跑。前面有一个浅湖，先跳进湖水里避一避！\\n“白痴才会去捅铠脚蜂的蜂巢！”古拉姆骂道。\\n“我、我以为一剑下去，剑风会让里面的蜜蜂窒息而死……”林宇翔心虚地解释到。\\n除了耍帅，另一个原因，是他想用蜂蜜拌水簌簌口，那两个团子的苦味一直弥留在口腔。\\n帅哥可不能有口臭。\\n古拉姆在被蜇到的前一秒跳进湖里。湖水还没完全没过头顶，这对水性不太好的古拉姆来说并没有太大的威胁。",
    "1_47": "宿命效果",
    "1_46": "未获得词条",
    "messageInitContent_10860": "感觉草丛适合当宇航员",
    "messageInitContent_10861": "皮匠呢？",
    "1_45": "空",
    "messageInitContent_10866": "我觉得左边厉害",
    "1_44": "词条属性",
    "messageInitContent_10867": "今天选人多的",
    "1_43": "基础值",
    "messageInitContent_10868": "一眼左边",
    "1_42": "阶段",
    "messageInitContent_10869": "预言一下赢的是这边",
    "1_41": "等级",
    "messageInitContent_10862": "皮匠适合当杂志封面",
    "1_40": "元核属性",
    "messageInitContent_10863": "这技能我熟",
    "resoundEventConfigDes_4009": "“吼——”\\n怒吼声打断了林宇翔的讲述，此时他刚好讲到自己13岁时发生的故事。\\n林宇翔“哇”地大叫起来，猛地朝后跳了一步，险些跌倒，小心翼翼地环顾四周：“什么东西！”\\n“身为一个战士，”古拉姆对他的表现十分不满，“你怎能如此胆怯？！”\\n旁边的欧文看起来就镇定多了。\\n古拉姆不知道的是，月夕已经在感知到有怪兽靠近的一瞬间，将身体的使用权拿了回来，还不忘说一句：“抱歉，欧文先生，我得先把身体拿回来了。”\\n欧文从不曾接触过这类游戏，在现实中也不擅长战斗，所以听到怒吼声的时候多少还是受了些惊吓，只是尽可能压住了恐惧，堪堪保持住绅士体面。\\n“我才不是胆小啊！”林宇翔这才反应过来旁边还有美丽的女士在场，连忙站直身体，假装什么都没发生过，“我这是保持一颗警惕之心，毕竟我要保护月夕嘛！”\\n古拉姆嗤之以鼻：“就你，还保护月夕？”\\n“谢谢你的好意，当心，他们来了。”\\n月夕的声音一如既往的安恬，但还是能听出语气里多了些紧张。\\n只见四只手持双刀的怪兽猛地跳出，他们身形修长，手中双刀挥舞，一双眼睛闪烁着异样的紫色光芒。\\n林宇翔摸摸下巴：“诶？这几只怪兽看着还挺帅的？”\\n古拉姆沉声道：“他们是虚刃，幻化级的灵族，不足为惧。”\\n“这些虚刃看起来似乎不太对劲，”月夕秀眉蹙起，微微摇摇头，“他们的眼睛……”\\n月夕话音未落，已经有四把飞刀朝他们的方向飞了过来！原来这四只虚刃已经分别跳开，从四个方向包围了他们！\\n“喂！出招之前都不打招呼的吗？”林宇翔接连在地上好几个翻滚，这才十分狼狈地躲开飞刀，有些生气地看着那四个叫虚刃的怪兽，“亏我刚才还夸你们长得不错！”\\n古拉姆对此很不满：“你练习了那么久，躲几个飞刀都躲不过吗？”\\n“You can you up！No can no BB！”林宇翔立刻反驳，之后又反应过来古拉姆应该听不懂，“咳，我的意思是，真的要打架了诶，你怎么不把身体拿回去？”\\n古拉姆在听到吼声的那一瞬间是有这个打算的，但后来发现来的只是四个虚刃，自己已经进化到了不朽级，怎么会怕幻化级的灵族怪兽？再加上旁边还有月夕在，这是个让林宇翔成长起来的好时机：“对于一个战士而言，实战就是最好的练习，这几个虚刃，你来解决！”\\n那边月夕吸引了三只虚刃的攻击，另外一只虚刃挥舞电刀朝着林宇翔的方向而来，眼中紫色光芒大盛，林宇翔一边慌忙逃跑一边气喘吁吁地开口：“诶？倒也不用这么信任我吧？他们有四个诶！你难道没有听说过双拳难敌四手的道理？”\\n“我提醒你一句，现在你掌控着身体，如果身体受了伤，或者遭到了比较沉痛的打击，你将会承受绝大部分的痛苦。”\\n“古拉姆同学，你怎么可以对我这么平静地说出这么残忍的话。”\\n上一次吃东西时，林宇翔还不是身体的掌控者，都已经充分感受到了那团子有多难吃，现在自己掌控着古拉姆的身体，相当于自己就是古拉姆，而如果这具身体被刀砍中，那自己恐怕会疼死过去吧？\\n可恶，这家伙绝对是故意的！\\n林宇翔在地上打了个滚，终于握紧了手中的大剑。\\n他只会一招，就是古拉姆教的挥剑。\\n“看我的！”说着，林宇翔朝着飞奔而来的那个虚刃猛地挥出一剑。\\n刚刚铸造好的大剑席卷着不朽级古拉姆的剑意，朝着虚刃呼啸而去！\\n轰——\\n这次没有挥歪！\\n林宇翔正要得意，就看到那个虚刃从空中跃下，手中寒芒一闪！\\n怎么会？！\\n虚刃根本没有被剑意所伤？\\n“啊！”\\n这一次，林宇翔虽然勉力躲闪，但还是被虚刃的刀所伤到，被刀锋伤到的痛苦袭来，但也只是一瞬间。",
    "messageInitContent_10864": "猜对day1",
    "resoundEventConfigDes_4008": "“我在路上向月夕了解过一些关于石塔和邪王的传说，以及一些传言，如果我的推测正确，那么我们和他们都是所谓被选中的人，”欧文解释道，“我们被召唤到这里，协助每个石塔选中的怪兽，或者说合体之后，让他们进化到了不朽级。似乎已经有其他地方出现了石塔，理论上，应该是有多少座石塔，就有多少个和我们一样的人吧。”\\n被选中的人！\\n这几个字无疑击中了林宇翔的中二之魂。\\n林宇翔：“哇！是不是说明我们天赋异禀，体质特殊？”\\n欧文：“……”\\n“我从来不擅长战斗，无法理解为什么会被选中，”欧文叹了口气，“眼下对这个世界也还是一知半解，不过月夕非常善良，她答应我会帮我寻找回去的办法。”\\n“好羡慕！都是穿越过来的人，凭什么待遇相差这么大？”林宇翔心生不满，“古拉姆，你听听！你看看人家！你就会往我嘴里塞孢子！”\\n古拉姆冷哼一声：“你以为我想和你一组吗？你这么弱！如果有能把你送回去换个强者过来的办法，我求之不得！”\\n“先把手机收起来吧。”欧文将手机递给林宇翔，“我想，只要对这个世界多了解一点，总能慢慢找到回去的办法的。在此之前，我们要配合他们行动，与此同时，保护好这个手机。它会和你一起穿越过来，我觉得并非没有理由。”\\n至少自己的手机就没有跟自己一起过来。\\n林宇翔点点头，接过手机，想到了上次手机进水的事，不禁有些担忧，于是在身上摸了一通，最后把古拉姆那个石塔的召唤具拿了出来。他之前就见过这个东西，这会突然意识到用来装手机正合适。\\n“你干什么？”古拉姆声音微怒，“那可是石塔的召唤具！”\\n “用来装手机不是正合适吗？”林宇翔满不在乎地回答，当然也没忘记为手机做广告，“这可是了不起的神器……”\\n“滴！”\\n只听到手机在放入召唤具的那一瞬间， 发出了“滴”的声响。\\n连接\\n这个声音！\\n林宇翔和欧文几乎是同时瞪大了眼睛看向手机屏幕，只见屏幕右上角电池的部分，多了一个“充电中”的闪电符号。\\n连古拉姆都微微一愣，心中暗想：原来这个手机，真的是个神器。否则，石塔的召唤具不会对它有反应。\\n“充电了！原来这个召唤具是充电器啊！”林宇翔大喊出声，“啊！太好了！不用担心没办法自拍了！”\\n欧文：“……”\\n他将手机从召唤具中拿出，再放回，确认刚才不是他们的错觉，召唤具的确可以给手机充电，他微微皱了皱眉，仔细端详起这个召唤具：“这个召唤具应该能算得上是石塔的化身，看来我之前的猜测没有错，石塔，就是我们和原来世界的连接。”\\n否则，召唤具绝对无法给来自原来世界的手机充电。\\n“那现在怎么办？”林宇翔歪着脑袋，“总不能钻进这个召唤具里传送回去吧？试着把召唤具变大？”\\n“当然不是用这种白痴手段，”欧文终于失去了耐心，用词也直接起来，“更何况你把手机放进去，手机也没有传送回去不是吗？不过，这是一个开端，既然召唤具是两个世界的连接，我们就一定能通过召唤具回去。”\\n说着，欧文拿出了月夕身上随身携带的召唤具，发现两个召唤具无论形状大小颜色，都有明显差异，也找不到什么共同的神秘符号之类的，他皱了皱眉，将古拉姆的召唤具和手机还给林宇翔，也把月夕的召唤具收了起来。\\n月夕似乎颇为遗憾：“真抱歉……这个召唤具似乎没能帮上欧文先生什么忙。”\\n“哦不，已经帮了很大的忙了。”欧文从来到这个世界之后，就已经用理性分析过回到原来世界的诸多可能，甚至做了在这个世界度过余生的心理准备，“确定了两个世界由何物相连，也找到了和自己命运相似的伙伴，这是很大的收获。”\\n不过除了命运相似之外，自己和林宇翔真的没有什么其他共同点了。\\n月夕轻声道：“无论如何……在帮欧文先生找到回去的方法之前，只能先拜托欧文先生配合我的行动了。”\\n“我理解的，月夕。”欧文知道月夕善解人意，而且很怕给自己添麻烦，比起林宇翔和古拉姆的合体，自己似乎的确幸运得多，“更何况，在做这些事情的过程中，我或许能更快地找到回去的办法呢。”\\n如果不是因为和月夕一起来找古拉姆，他也不会认识林宇翔，不会知道召唤具的神奇之处。接下来，月夕应该也会和其他拿到了召唤具的怪兽会合吧。\\n古拉姆原本想赶紧把身体的使用权拿回来，但月夕说欧文和林宇翔都是异世界的来客，好不容易相见，一定有很多话说，不如让他们多聊一会儿。他尊重月夕的意见，而且古拉姆也认为欧文的分析不无道理。\\n眼下的情况，石塔和召唤具似乎都已经认可了林宇翔，如果的确是某种指引，石塔选中了他和自己合体从而进化，那让他在一定程度上掌控身体，或许对自己也有些帮助。\\n虽然他的能力实在是不行。\\n“我跟你说啊，欧文，我七岁那年……”\\n事实上，欧文根本不想听林宇翔滔滔不绝讲述他从有记忆开始的种种故事，但一方面不忍心拒绝月夕的好意，另一方面他也的确想找到自己和林宇翔的共同点，以期了解他们被选中来到这个世界的原因。",
    "messageInitContent_10865": "猜对day0",
    "resoundEventConfigDes_4007": "欧文缓缓开口：“我叫欧文，现在和月夕共用一具身体，既然你提到了石塔和进化，那我猜测，你们也许也遇到了和我们类似的情况？”\\n“对对对！”林宇翔好不容易等到古拉姆将身体的使用权交给自己，立刻兴奋起来，这个世界还有和自己一样的人类！他忙不迭地做起了自我介绍，“你好！我叫林宇翔！今年19岁，是一名大二的学生，身高174，体重56公斤，我是下载了一款游戏之后，莫名其妙被传到这里来的！哦对了，给你看看我的照片！”\\n说着，林宇翔兴奋地掏出手机，要给对方展示自己的照片，手机却被一把抢了过去！\\n“欧文先生！”月夕有些着急，“怎么能抢别人的东西呢，这太不礼貌了……”\\n欧文解释道：“你放心，我不是要抢走，只是想看看。”\\n毕竟，他从来没想过，在这个世界里竟然还能看到手机！而且林宇翔的手机还有电！\\n只不过，和他猜测的一样，手机几乎所有功能，在这里都不能用了，屏幕上的时间倒还是在兀自行走，从23:30跳到23:31，可这个世界，现在明显是中午。\\n“手机不能用，”林宇翔看出欧文的失落，挠挠头，“那个，欧文，你也是因为下载游戏才被召唤进来的吗？”\\n欧文摇摇头：“不，我今年26岁，在金融中心工作，来这里之前，我正在进行一个很重要的会议，然后突然狂风四起，周围电闪雷鸣，世界似乎被撕开了一道裂缝，我被旋风裹挟，穿过了那道缝隙。”他语气平静，像是在说别人的故事，“然后，我就发现我穿越了，我的意识和月夕共用了这具身体。”\\n月夕自然也一直在侧耳细听他的话，这时忍不住有些担忧：“很重要的会议？是不是耽误了欧文先生的大事呢？”\\n“不过，比起什么邪王，变异孢子，拯救世界之类的……”欧文自嘲地笑了笑，“那个会议真的称不上重要。”\\n“哈？原来你是金融精英！”林宇翔来了兴趣，“那条街是怎么样的？是不是和那部电影一样？大家没事儿把美金撒来撒去？”\\n欧文用十分不可思议的目光看着林宇翔，先是摇摇头：“当然不是。”然后忍不住问道，“我们现在都穿越到了这个世界里，你却在向我打听那边的事？”\\n怎么说都不是问这个问题的时候吧？\\n林宇翔点点头：“对啊，反正一时半会儿也回不去嘛！诶？还是说，你有什么能回去的办法？”\\n“暂时还没有，”欧文摇摇头，凝眸看着手中的手机。\\n“那不就得了！”林宇翔挑挑眉毛，笑起来，“我问你，和大美女共用一具身体感觉如何？我跟你说，古拉姆啊，简直无聊死了，动不动就让我做练习，要让我变强什么的……”\\n欧文皱了皱眉，觉得如果要回到原来的世界，要指望林宇翔是不可能的了。\\n古拉姆：“我随时都可以把身体使用权夺回来。”\\n啊，忘了他也能听到了。\\n林宇翔吐吐舌头，不再说古拉姆的坏话，而是继续问欧文问题：“对了欧文，你是之前就猜到古拉姆和月夕的情况一样了吗？”\\n“从月夕那里，我了解了我和她共用身体的大概情况，也知道了石塔，因为和她合体的缘故，才进化到了不朽状态，”欧文缓缓道，“而你之前那一瞬间的表现，应该是那时候你情绪激动，意识比较强烈，从古拉姆那里短暂地夺走了身体的使用权。”\\n林宇翔瞪大眼睛：“你连这个都知道？啊，原来只要我激动，就可以把身体使用权夺过来吗？”\\n “不，”欧文有些无奈，但还是耐心解释道，“根据我的观察，这和我们本身的实力相关，只有偶尔情绪突变的时候，对方没有防备，甚至自己也是无意识的状态，突然的激动或者其他情绪，才会短暂地控制身体。但是如果对方提防，以你现在的实力应该很难。我们的身体很可能并没有随我们来到这个世界，未来很长一段时间里，我们都只能借用他们的身体。”\\n严格来说，是意识共有。\\n林宇翔眨眨眼：“所以，你的意思是，我可以趁古拉姆睡着了，偷偷把身体夺过来自己用？或者，如果我变得足够强，我能够把身体夺过来？”\\n古拉姆闻言冷哼一声。\\n欧文有些无奈：道理的确是这个道理，但这位少年实在是耿直得有些过分了。\\n于是他顿了顿才继续道：“如果我没有猜错，这个世界和我们情况一样的，应该还有其他人。”\\n“哦？真的吗？”林宇翔来了兴趣，“怎么说？”",
    "resoundEventConfigDes_4016": "“什么？！”\\n月夕听暴虐战狂说起大批尸族失踪的事时，脸色沉了下去：“怎么会有这么大批量的尸族失踪？”\\n“是啊，真奇怪，”古拉姆也有些紧张，“听说龙族那边也有些部族失踪，但数量并没有尸族这么多……如果这是邪王的阴谋，那邪王抓走他们，究竟是要做什么呢？”\\n“是不是做实验啊？”林宇翔忍不住插话，“就和我们之前遇到的那几只虚刃一样，吃变异孢子然后变异，之后就听邪王指挥？”\\n的确有这种可能，古拉姆眉头紧锁。\\n按照这个推论，那这么大量的尸族失踪，可不是什么好事！\\n“联系之前出现的变异怪兽和变异孢子考虑，”月夕已经站起身，巨大的弯月出现在她身后，她温柔地开口：“一定得去尸族部落调查一番。”\\n“我和你一起去！” 古拉姆正色道，“这是大事。”\\n月夕点点头：“好。”\\n他们正要出发，暴虐战狂却挡在了古拉姆面前。\\n古拉姆皱紧眉：“你干什么？！”\\n“我说过了吧，”暴虐战狂用理所当然的口吻道，“我要和你对战！”\\n古拉姆有些无奈：“现在最重要的事情是尸族和邪王的事！就不能等……”\\n“不能！”暴虐战狂语气强硬，“我曾经很多次去往你的部落找你挑战，基本上都扑了个空，这次，我绝对不会让你再找借口拖延！”\\n他等这次对决已经太久了！\\n尸族失踪关他何事？至于邪王，只要邪王真的如传说中那样强大，等到邪王现身的时候，自己再去找他挑战就是了！\\n现在，他的目标就是古拉姆！\\n“只是一次挑战而已，分出胜负即可，耽误不了多少时间。让月夕先去调查，你随后赶上就好。”暴虐战狂用挑衅的口吻道，“怎么，你进化到了不朽的形态，反而不敢接受挑战了吗？堂堂赤剑部落的首领，竟然这么怕输！？看来外界对你的评价，实在是过誉了！”\\n听到这话，林宇翔就叹了口气。\\n因为他感觉到了古拉姆强烈的战意，看来“点将不如激将”这句话，无论在哪个世界都适用。\\n结果就是月夕因为着急去尸族部落调查，所以先走一步，古拉姆和暴虐战狂找了个空旷的地方，开始了对决。\\n橙金色的流动！就是这种感觉！\\n暴虐战狂舔了舔嘴唇，感觉自己浑身的血液都沸腾起来了。\\n一个手持大剑，一个手持战斧。\\n只是相对而立，就因为两个不朽形态的远古族的强大力量，让狂风在他们周围盘旋开来，将他们围绕在风圈之中。\\n“看招！混沌之力！”\\n暴虐战狂举起战斧，朝着古拉姆的方向挥去。\\n看起来最平淡无奇的攻击，隐藏着最大的杀招，暴虐战狂将力量全部寄于战斧的刃上，斧刃上闪烁着橙金色的光芒！\\n铿！\\n同样闪着金色光芒的大剑接下了这一击！\\n二者相持不下良久，才各自退了一步。\\n“传说之力！”\\n古拉姆大喝一声，挥舞大剑，古拉姆浑身迸发着金色光芒，周围的风竟然席卷成了一把虚空之剑，和他手中的大剑一起，以无穷的传说之力朝着暴虐战狂发起猛攻！\\n暴虐战狂挥舞战斧，将风凝结，在自己面前形成了一道风墙，将大剑的攻击挡在了外面！\\n“轮到我了！”说话间，暴虐战狂猛地跳过风墙，虽然他躲过了古拉姆的大部分攻击，但还是多少受了点伤，但他完全不管不顾，挥舞战斧径直朝着古拉姆而去，“混沌之力·狂噬！”\\n轰——\\n只听整个天地一声巨响，战斧在空中放大数倍，以万钧之力砸向古拉姆所在的地面！\\n一时间仿佛地动山摇，整片地面竟然被战斧劈开了一刀裂缝！地上的砂石成群，同时也朝向古拉姆飞去！\\n古拉姆用力跳起，想要躲过这次暴虐战狂的这次攻击。\\n“啊！”\\n可惜，他没能跳出战斧最边缘的攻击距离，还是被这一招给伤到，竟然直接倒在了地上！\\n暴虐战狂收起了斧子，抱臂而立，居高临下地看着受伤倒地的古拉姆，十分失望地叹了口气：“我还没用全力呢，真·神剑古拉姆，竟然仅此而已吗？”\\n哎，虽然的确比之前的对手要强一些，但自己只受了这么点轻伤，赢的还是有些轻松啊。\\n古拉姆已经勉力用剑支撑着自己站起身，他看向暴虐战狂，咬紧了下唇，没有回应暴虐战狂，只是心里写满了不甘。\\n我打不过他？！\\n这不可能！\\n真·神剑古拉姆怎么可能这么轻易地被打败！\\n“哎呀算了算了，”察觉到他内心的不忿和痛苦，林宇翔试图安慰，“胜败乃兵家常事，这次输了，下次再赢回来就好了嘛！”\\n林宇翔不说话还好，一说话就让古拉姆更加怒不可遏：“这都是你的错！因为你比他体内的人弱！所以我才会被他打败！”\\n没错，如果不是因为林宇翔，自己绝对不会输给暴虐战狂！",
    "resoundEventConfigDes_4015": "暴虐战狂是在赶路途中遇到的尸王寇斯金，寇斯金带着几个幽鬼走到他面前问道：“请问您是真·暴虐战狂吗？”\\n“是我，”暴虐战狂皱眉打量寇斯金，“想挑战我？你是究极级的尸族，太弱了！进化了之后再来找我吧！”\\n寇斯金连忙开口解释：“不是的，我们是来向您求助的。尸族最近有很多同伴都莫名失踪了。仅仅我知道的几个部落，失踪的数量已经上百。他们一定是遇到了什么危险，我知道您打败过尸族的上一任族长，您的很多故事在我们族群中都是了不起的传说。我想，如果有您出马，一定可以……”\\n“什么东西！帮忙找失踪的尸族？”暴虐战狂根本没耐心听完，就不客气地打断了尸王的话，“既然你知道我的名声，听过我的故事，就应该清楚，我从来不做这种事！”\\n开什么玩笑，他还赶着去寻找古拉姆他们来挑战呢，哪有时间做这个？\\n“如果他们是被邪王抓走了呢？”寇斯金知道暴虐战狂喜欢挑战强者，“邪王太厉害了，我们实在不是对手，所以才请您帮忙。”\\n暴虐战狂一顿，就听到邬羽刹的声音：“这家伙，是看穿了你的性格，故意诓你呢。他们根本不知道这些尸族怪兽去哪儿了，所谓的邪王抓走也只是猜测，而且，邪王到底在哪儿，他们更是毫无头绪。”\\n“你说的有道理。”暴虐战狂点点头。\\n体内的这家伙和自己倒是有些相似，非常喜欢冒险，明明是从其他世界来的，莫名和自己合体之后，他倒也悠闲自在，每次看到不同的怪兽还喜欢点评几句。\\n不过邬羽刹还是有他的作用的，比如对地图信息十分敏感，分明对这个世界不算熟悉，看过几次地图之后，竟然全都记了下来。如果邬羽刹不是总想跟自己抢身体的主导权的话，自己可能会对他更有好感一点。\\n哼，仗着在自己体内，没办法被自己胖揍一顿，时不时出来指点江山，还动不动想抢走身体的主导权，哪那么容易？ \\n暴虐战狂现在连睡觉的时候都努力保持警惕，否则一不留神，就发现邬羽刹夺走了身体的主导权，在朝着地图上奇怪的方向探索。\\n好在他在听说了古拉姆他们的事情之后，似乎也对他们产生了兴趣，和自己达成了前进方向上的一致。甚至还能告诉自己怎么抄近道，能根据自己提供的古拉姆他们的信息，猜测古拉姆他们可能会走的路线。\\n暴虐战狂迎着寇斯金和幽鬼们期待的目光摆了摆手：“如果你们已经找到邪王的下落，让我去挑战，我肯定乐意之至。但现在邪王下落不明，而我已经打听到古拉姆他们的位置了，现在，还是和古拉姆他们的对决比较重要。等我挑战结束，我会回来帮你的。”\\n听说古拉姆和埃癸斯他们，跟自己的境遇一样，也是挑战石塔得到了召唤具，然后进化到了不朽的形态。\\n太好了。\\n过去那么多次想挑战他们，都扑了个空。\\n如今他们三个都进化到了不朽形态，这简直是对战的天赐良机！\\n“哎……”寇斯金长叹了口气，“就是不知道他们能不能等到这时候了。”\\n暴虐战狂撇撇嘴：“弱者就要拥有被杀死的觉悟，不过你放心，我会将这件事情告诉古拉姆和埃癸斯他们的，他们最爱管闲事，等挑战结束，他们会帮你寻找的。”\\n说完，暴虐战狂就加快了速度，离开了这里。\\n听说暴虐战狂的性格一向如此，寇斯金本就是抱着试试看的态度向他求助，倒也并不算太失望。他们还要组织其他尸族去寻找失踪的尸族，只能祈祷古拉姆真如暴虐战狂所说的“爱管闲事”，能够来帮助尸族了。",
    "resoundEventConfigDes_4014": "“小姑娘，你听得到吗？”马克声音轻柔，“如果听得到的话，请你用最终兵器的身体点点头，我想跟你讲讲这个世界的故事。你别担心，我不会伤害你，我也来自人类世界，我叫马克，因为一场意外来到了这个世界，目前和埃癸斯合体，你呢？”\\n马克等了很久，没有等到眼前巨兽的点头，正在失望之时，却听到了声音。\\n“我……我叫洛菲菲。”说话的声音并不是当时纤细的嗓音，而是充满机械质感的声音。\\n“太好了！”埃癸斯十分高兴，“最终兵器是没有语言能力的，看来这个小姑娘很厉害，已经掌控了最终兵器的身体，这样才能和你对话。”\\n马克也长舒了口气：“你没事就好，我想，你突然来到这个世界就见证了战争和屠杀，一定觉得很害怕吧。”\\n“我……我以为我在做梦，”洛菲菲缓缓开口，“哥哥，这不是梦吗？我们真的来到了充满怪兽的异世界？”\\n马克叹了口气，点点头，跟她简单介绍了一下现在的这个世界，把自己所知道的一切都告诉了洛菲菲。\\n“跟你合体的是最终兵器，我想……你已经见过了他的能力，我合体的这个怪兽名叫埃癸斯，和最终兵器一样，都是远古族的怪兽。”马克举起手中的轻盾，“这是埃癸斯的武器，你放心，他很强，我们都会保护你的。”\\n洛菲菲抬起头，对上了马克的眼睛，那眼神清澈而坚定，看起来的确不像是会骗人的。\\n盾牌，也就是肉盾战士吧？\\n洛菲菲多少也玩过一些游戏，而且前面看埃癸斯的对战，也能猜出几分。看起来很有正义感，也很有责任感，愿意保护别人。\\n而且，很强大。\\n自己合体的这个最终兵器，似乎没有什么意识可言，甚至自己只是稍微一尝试，就拿到了他的身体使用权。\\n但最终兵器的确很可怕，洛菲菲还清楚地记得刚才那残酷的杀戮。\\n按照马克的说法，他们这些人是要组队一起去打邪王，打败邪王才能回到原来的世界，这个世界各种怪兽横行，似乎很危险。\\n也对，弱肉强食在任何地方都行得通。\\n听马克简单介绍了各种族的形态，埃癸斯应该已经是非常厉害的怪兽了。当然，还有自己合体的最终兵器，但最终兵器的意识自己捕捉不到，而且他和埃癸斯不同，马克说埃癸斯经常和他交流对话，但最终兵器并没有回应过自己。\\n既然如此……\\n洛菲菲沉默了好一会儿，才开口道：“马克哥哥，那……我们能一起走吗？我还是有些害怕。”\\n马克点点头，正色道：“你害怕是正常的，这对你而言太残酷了。在回到原来的世界之前，我都会和你待在一起，不会让你受到任何人或怪兽的伤害！”\\n最终兵器的身体点了点头。\\n洛菲菲露出了笑容。",
    "messageInitContent_10848": "皮革生意不好了？",
    "resoundEventConfigDes_4013": "埃癸斯皱了皱眉，他承认朱雀大人说的有道理，而且，在埃癸斯的心中，朱雀大人和神灵无异，他说的话就如同神意。\\n察觉到了他的犹豫，马克有些激动，他强烈的意识在那一瞬间夺走了埃癸斯的身体使用权：“不！既然他和埃癸斯一样，是被神圣的召唤具所选中，寄予厚望的远古族，那为什么不给他一个机会呢！他的过去只有杀戮，这已经是一种悲哀，是召唤具将他唤醒的！难道唤醒他就是为了毁灭他？！”\\n朱雀一时无语，不过在朱雀看来，神圣的召唤具不过是随机给予，无意中唤醒了最终兵器，而并非有意为之。\\n“还有！那个小女孩！”马克加快了语速，“她和我一样来自人类世界，如果现在埃癸斯死亡了，我是不是会死？那么如果现在毁掉最终兵器，那个小女孩怎么办？！无论如何，先想办法阻止最终兵器再说！”\\n说着，马克顿了顿，又补充道：“既然我能凭借意识短暂地掌握埃癸斯的身体，那那个小女孩，说不定也可以！”\\n朱雀眼前一亮，从理论上来说，马克说的话是行得通的。虽然不知道石塔召唤其他世界的意识进入远古族的身体意欲何为，但现在看来，是要成就一组组的搭档。虽然他来自其他世界，但只要意识足够强大，依然能够掌控远古族的身体。\\n马克太过激动，没有意识到自己此时夺走了身体使用权，甚至没有感受到一下下传来的疼痛，他只是下意识地地摆出了平日防守的姿势。\\n埃癸斯点点头：“马克，你说得对！”\\n“和我一战吧，最终兵器！”话音刚落，埃癸斯便夺回了身体的控制权。\\n最终兵器依旧保持着攻势，打到埃癸斯身上的力度也越发强劲。\\n“我是为了这部落中被你所杀的怪兽与你一战，是为了更多无辜的生命与你对决，是为了你体内那个少女的安危与你对战，”埃癸斯提高了音量，“那么你呢！你为何而战！？”\\n一直持续攻击的最终兵器，在那一瞬间出现了停顿。\\n似乎在脑海深处，他自己也在问这个问题：我为何而战？\\n当年他出现的时候只是作为兵器去毁灭去杀戮，如果那时候的他还能勉强称为是“为了结束战争不得已的手段”，那么现在呢？\\n兵器，总是精准地执行命令，不会发问。\\n可是，那是谁的命令？\\n现在发问的又是谁？\\n“战争结束了！不需要你作为杀戮的兵器而存在了！”看出了最终兵器那一瞬的犹豫，埃癸斯心中大喜，他一边抵御着攻击，一边大喊道，“你从沉睡中醒来是有意义的，你要寻找新的存在价值了！还有，你体内不止有你自己的意识，还有一个小姑娘的，你虽然不能说话，但应该感觉得到吧？”\\n最终兵器攻击的动作放缓了。\\n洛菲菲皱了皱眉，她看到也听到了眼前的一切。\\n她还记得自己曾经求助，所以清楚埃癸斯所说的“小姑娘”，就是自己。\\n埃癸斯大喊道：“多年前的事情已经过去了，你是新的自己了！不需要盲目杀戮，也不需要尽情破坏了！我们可以有一个共同的目标，我们可以一起做更多的事！最终兵器！即使你生来就是为了破坏，但我相信，你一定可以拥有理智！你会明白，我说的是对的！”\\n“哐——”最终兵器的左拳重重地砸在埃癸斯的盾上，发出了震耳欲聋的声响，碰撞的产生高温甚至扭曲了周围的空气，时间仿佛定格在此刻，撞击的余响中，攻击停止了，最终兵器注视着埃癸斯。\\n刚才似乎什么都没有发生，但在空中的朱雀却看得分明：埃癸斯将名为“理智”的东西，注入了最终兵器的心中。",
    "1_59": "数量",
    "messageInitContent_10849": "怎么打起来了这堆",
    "resoundEventConfigDes_4012": "破坏！破坏！破坏！\\n机械质感的野兽嘶吼中，洛菲菲只看到了一片猩红。\\n这是梦境吧。\\n一定是的。\\n虽然眼前发生的很多事情都让她觉得过分真实，不像梦境，但又太过荒唐，洛菲菲毕竟只有十一岁，她只能不停地说服自己，这是个梦。\\n自己怎么会在一个魁梧的巨兽的身体里，看着此等疯狂的画面？\\n耳边重复着无休止的哀嚎，还有武器碰撞的声音，眼前的巨兽还在肆无忌惮地攻击，自己的内心却是如此的……平静。\\n这里只是一个很小的部落，已经死去的怪兽们并不知道自己怎么惹到了这位大块头，还没能问出答案，就莫名其妙地丢了性命。\\n最终兵器本就是为了破坏而生的兵器，破坏就是它的所有，沉睡多年一朝醒来，这份本能觉醒的更加强烈。他一路暴走，只是所幸他从荒野而来，所以一路上其实并没有碰到太多怪兽，这个小部落也正因为地处偏僻而长久以来远离纷争，哪料到前一刻还安静祥和的部落，现在却遭此横祸。\\n破坏！尽情破坏！\\n这是最终兵器脑海深处一直在回荡的声音，也是他下意识接下的指令。\\n他不是生命，不是怪兽，不过是兵器而已。\\n“糟糕！”\\n朱雀和埃癸斯赶到的时候，都有些不敢相信自己看到的一切。\\n到处都是灵族怪兽，大多数都是幼体级和幻化级，只有一两只是究极级的灵族怪兽。所以当最终兵器到来，肆意破坏的时候，它们甚至几乎毫无还手之力。\\n又有谁能料到，会突然降临这样的无妄之灾呢？\\n看到眼前这一幕，朱雀发出了长长的叹息：“看来，我所预想的最坏情况，还是发生了。”\\n最终兵器本就是神志不清之混沌者，天生的破坏者，在武器坟场沉睡千年，原本就因为强大而被远古族所忌惮，不想让他从沉睡中醒来。而如今，最终兵器又因缘际会得到了石塔的力量，然后开始了破坏之旅。如果不及时阻止，不知道还有多少怪兽遭殃！\\n这样疯狂的最终兵器，绝对不可能和其他英雄们一起合力对抗邪王。也许，他会先成为英雄们的对手。\\n可恶！\\n埃癸斯握紧了拳头，这样实在是太过分了！\\n“住手！”\\n埃癸斯冲向正在全力挥拳的最终兵器，他高高举起轻盾，将那几只怪兽挡在身后：“最终兵器！快停下来！他们是无辜的！”\\n破坏！破坏！破坏！\\n最终兵器根本没有将埃癸斯的话听进去，冲向埃癸斯。\\n朱雀在空中盘旋，想要阻止最终兵器，可最终兵器并没有停下来。那只能先救下眼前的怪兽了。朱雀双翼一挥，伴随着一声凌厉的鸣叫，之前受了重伤无法行动的怪兽在朱雀浴火重生的神力下，重新站了起来，慌忙逃向远方。\\n看着巨兽猛烈地向埃癸斯挥拳，朱雀摇摇头，用沉痛的声音开口道：“不行，埃癸斯，只能毁了他了！”\\n“什么？！”埃癸斯一边艰难防守着愈来愈沉重的攻击一边问道，“朱雀大人？您在说什么！”\\n“埃癸斯，不要忘记自己的使命，你看看这个部落的下场，如果不毁掉最终兵器，他只会让这一路都生灵涂炭！”朱雀大声道，“你们都是被神圣的召唤具所选择，并且赋予了力量寄予厚望的远古族，但最终兵器这样下去，只会辜负我们的期望，只会和我们要做的事背道而驰！甚至不拥有理智的远古族，怎么能期待他拥有保护同类的信念和抵抗邪王的勇气呢？”",
    "1_58": "确认",
    "resoundEventConfigDes_4011": "古拉姆愠怒道：“挥剑！”\\n但是“能不动手绝不动手”才是林宇翔的信念，他一边利用这具身体的灵活性四处狂奔，一边继续试图和这几只虚刃“讲道理”：“几位，也许你们打错人了呢？还是你们吃了那个什么变异孢子，没办法控制自己的行动？我真的不想轻易出手，因为我手中的剑，要么不出鞘，一旦出鞘……哦不对，这剑好像没有剑鞘。”\\n“吼！”\\n这几只变异虚刃似乎也难以忍受这种无休止的追击战，其中两只腾空而起，朝着林宇翔而去，林宇翔转头奔逃，就遇到了来自另外一只虚刃的追击，虚刃双手扬起，眼看双刀就要落下，林宇翔突然举起手，瞪大眼睛看着虚刃的身后：“看！流星！”\\n那正要攻击的虚刃一愣，转过头去。\\n林宇翔没有骗他，真的是流星。\\n是第四只虚刃使出的杀招，巨大的流星带着长长的甩尾，“嗖”的一声飞了过来，直直地朝着他们所在的方向！\\n求生的本能让那几只虚刃迅速跳开，林宇翔一边撒腿跑开一边大喊：“月夕！奶好我！”\\n几道不同颜色的光束朝着他飞来，虽然一时还难以分辨是什么类型的Buff，但根据林宇翔以往打游戏的经验，无非是加血、加防、减伤、减控之类。\\n林宇翔十分开心：“哎呀，有个能加Buff能治疗的辅助奶妈在可真好。”\\n虽然对名词不太了解，但古拉姆还是理解了林宇翔的意思，他更加生气：“你为何一直逃避对战？我说过了，这具身体有绝对的实力能够以一敌四！更何况你还有月夕的帮助！”\\n“哎呀，兵法有云，要不战而屈人之兵，”林宇翔滔滔不绝，“俗话说得好，能吵，就不要打。”\\n说着，林宇翔朝着一只刚才使用了流星大招的虚刃走去，他看得出来，召唤过流星之后的虚刃战斗力要弱很多，他在一个预估的安全范围内停下：“这位虚刃兄弟，这就虚了，不太行啊，你双刀也飞过了，流星也召完了，接下来还有啥招？一次使出来呗。”\\n虚刃怒目瞪着林宇翔，眼眸中的紫色光芒更加明显，他挥舞双刀，想要继续攻击林宇翔！\\n砰——\\n那只虚刃的双刀才刚开始挥舞，就突然连同手中的双刀一起，倒在了地上。\\n这是什么意料外的神展开？林宇翔也为之一愣，他环顾四周，这才发现周围的其他三只虚刃也先后倒在了地上！\\n“看到没！”林宇翔自豪地拍了拍胸脯，“我把他们一起打败了！”\\n自己真的要和这样厚颜无耻只会胡吹的人搭档吗？古拉姆的心中充满抗拒。\\n不过……这些变异虚刃怎么会突然倒下，总不可能真的是被他说的话给击败了吧？\\n“应该是变异孢子的效力消失了，”月夕走到一只虚刃身边，念动咒语为他疗伤，“他们现在身体的流动已经变回了绿色和蓝色之间，也就是说，他们现在比一般的虚刃还要弱。”\\n欧文听明白了：“你的意思是，变异孢子虽然能像某种强力药物一样，在短时间内强化他们的能力，但是一旦时间过去，就会引起反噬，等变异孢子的效力过去，他们的能力会还不如之前，身体也会受损？”\\n“是的。”治疗光球在四只虚刃的身上飞舞，月夕轻舒了口气，“邪王可能并不知道这些变异孢子会给怪兽的身体带来伤害，有机会能和他面谈的话，一定要告诉邪王。如果真的能给大家带来好处，就太好了。”\\n“你有没有想过，也许邪王根本不在乎这些怪兽是否会被反噬，”欧文开口道，“这些变异怪兽只是邪王的工具，利用之后就扔掉，是死是活又有什么关系呢？”\\n月夕闻言怔住，眉头紧紧纠结着。\\n许久之后她才摇摇头：“不，我相信邪王心里一定有善念，不会这样想。退一万步，就算邪王真的不在意，我也要努力去做这件事，否则……这些服下了变异孢子的变异怪兽，要怎么办呢？”\\n这些事情，总要有人来做吧？\\n她生来就是个医者，要做的事情是治疗和修复，虽然被友人不耻，虽然无法被很多人理解，但这是她一直以来秉持的想法和信念。\\n欧文几不可闻地叹了口气。",
    "1_57": "取消",
    "resoundEventConfigDes_4010": "因为下一秒，月夕的治疗光球已经飞来，绿色的光芒温柔地将被划开的刀口包围，伤口几乎在瞬间愈合，完全没有了痛感，只有令人舒服的淡淡凉意。\\n“原来你是个远程治疗！”林宇翔用感激的目光看向月夕，“多谢！”\\n月夕飞身来到他身边，给他套上了一个护盾：“小心。这些虚刃比一般的虚刃要强。”\\n之前沉默的古拉姆也开口：“竟然能够承受我的剑气，还能够真的伤到这具身体！”\\n“月夕，你之前说他们不对劲，”林宇翔和月夕背对背而立，看着环伺的虚刃，继续道，“是哪里不对劲，眼睛吗？”\\n“是流动。”\\n月夕和古拉姆同时道。\\n月夕缓缓开口：“这些虚刃身上的流动颜色，很不对劲。他们本是蓝色的流动，说明他们是幻化级的灵族怪兽，但现在……”月夕皱起眉，神色忧虑，“他们的流动颜色在变化，在蓝色之上还覆盖了一层紫色光芒，真奇怪，我去问问。”\\n说着，月夕已经朝着刚才那个虚刃的方向走去：“能告诉我，你们身上是发生了什么——”\\n“——当心！”\\n月夕眼前光芒一闪，林宇翔已经飞速上来将她扑开，只听“轰隆”一声，竟然是一颗巨大的流星高速砸在了地上！虽然是白天，但星光还是十分耀眼，那流星砸在地上，将地上砸出了一个很大的坑！\\n“哇靠这什么东西啊？！”林宇翔吃了一脸的土，“呸呸”两声，擦了把脸，“大白天怎么还有陨石坠落啊？”\\n月夕凝眸看着那几只虚刃的方向：“这是虚刃的技能。”\\n“哈？”林宇翔头一次听说打架时还能召唤流星的，这技能是不是有点太强了，“这是赖皮吧？古拉姆，你不是说虚刃比你们弱很多吗？”\\n“召唤流星的攻击，是专门针对最脆弱的怪兽的杀招，原本是虚刃受重伤临死前才能发动的技能，所以才如此强大，”古拉姆也十分疑惑，“可现在这四只虚刃，似乎都还活得好好的。”\\n除了刚才硬生生接下林宇翔的剑意的那只虚刃受了点轻伤，其他三只虚刃，因为月夕不忍心伤害他们，所以只是在和他们纠缠，并没有真的伤到。\\n“什么似乎啊，”林宇翔对着天空翻了个白眼，“大家都生龙活虎的好吗？所以说到底是怎么回事，这些虚刃变异了？”\\n月夕轻轻点了点头，古拉姆也没有反驳。\\n林宇翔：“哈？真的假的？我只是随便说说。”\\n“这是唯一合理的解释，”月夕淡淡道，“我们的进化除了自身的天资际遇和勤勉练习之外，孢子的力量也有非常大的助益。在我的部落里发现了变异的孢子，恐怕与邪王有关。这几只虚刃所表现出来的实力，已经远远超过了他们本该有的实力，再加上他们眼泛紫光，好像失去了自控能力，很可能也是吃下了变异孢子，才会突然变强。”\\n很少听到月夕一下说这么多话，林宇翔微微一愣，他还没完全把这段话里的信息量消化完，就已经看到四只虚刃朝着他们的方向发起了进攻！\\n“不是，所以我们要怎么办？”林宇翔下意识想跑，但是看到月夕在原地没动，只好握紧了剑，看着来势汹汹的四只虚刃，“和他们打吗？”\\n真是倒了八辈子霉，怎么还能遇到变异怪兽的？\\n四只虚刃同时朝着他们发起了攻击，双刀裹挟着紫黑色的光芒朝林宇翔飞来，林宇翔虽然躲过了双刀，但双手却被紫色的光芒所环绕，他能明显感觉到自己的速度变慢了，手中的剑似乎变重了很多！\\n这大概就是一般游戏里所谓的Debuff？\\n“和他们打。”古拉姆并没有重新掌控身体的打算，他知道，有月夕在，就算林宇翔再弱，月夕也不会让自己的身体受伤，“就算这些虚刃的能力相当于进化到了究极体的血刃和咒刃，也不会是我的对手。”\\n你好自信哦古拉姆同学，那你能不能先把我身上的Debuff给去了？\\n没有得到古拉姆的任何回应的同时，一阵清新的风吹过，紫黑色光芒立刻烟消云散，淡淡的黄色光晕笼罩着林宇翔，如同一个月亮的形状。\\n不用想也知道是月夕的技能。\\n“你们是吃了邪王的变异孢子才会这样的吗？”月夕声音温柔，想从这些双眸泛紫的虚刃处得到答案，“这么说来，邪王或许是好意，他是想让大家能快速变强。”\\n“额……”一直沉默观战，采集和计算各类数据的欧文，听到这话终于忍不住开口，“月夕，你真的这么认为吗？”\\n月夕点点头：“嗯，如果不是出自善意，邪王又怎么会造出这样的孢子，让大家的能力变强呢？”\\n欧文本想说点什么，但想到自己对这个世界到底还不算了解，所以还是沉默了。\\n心中却忍不住有些感慨：看起来，月夕在这个世界还算是个不小的领导者，但她似乎一直秉持着这种“性本善”的想法，不知道该说她天真，还是愚蠢。\\n“别过来！大哥！我们商量一下！”林宇翔一边跑一边喋喋不休，“君子动口不动手，我们本来好端端地走在路上，你们突然冲过来，不管怎么样都应该给个理由吧？比如说是要劫财，还是劫色？”",
    "messageInitContent_10850": "安全的草丛",
    "messageInitNick_8499": "坚持下去",
    "messageInitNick_8498": "蓝翔老司机",
    "1_56": "全选",
    "messageInitContent_10855": "懂了",
    "1_55": "请从左列表选择需要分解的元核({1})",
    "messageInitContent_10856": "你又懂了",
    "1_54": "鉴定",
    "messageInitContent_10857": "是强制销售被反击了",
    "messageInitContent_10858": "哪里跑出来的草丛",
    "1_52": "元核分解",
    "messageInitContent_10851": "到底这个草是什么词性的",
    "1_51": "装备",
    "messageInitContent_10852": "危！",
    "1_50": "卸下",
    "messageInitContent_10853": "危！危！危！危！危！",
    "messageInitContent_10854": "危！到底会亮在哪里",
    "messageInitContent_10837": "答案在哪里呀",
    "messageInitContent_10838": "优秀的匹配机制",
    "1_69": "已选定基因 {1}",
    "messageInitContent_10839": "脑内模拟中",
    "1_68": "每次升级提升{1}",
    "messageInitNick_8495": "太阳能剃须刀",
    "messageInitNick_8494": "桔梗的泪",
    "messageInitNick_8497": "胡萝卜魔法师",
    "messageInitNick_8496": "白玉天女",
    "messageInitNick_8491": "到底要选哪个",
    "messageInitNick_8490": "助眠读物",
    "messageInitNick_8493": "还没醒",
    "messageInitNick_8492": "无修容大师",
    "messageInitContent_8702": "猜对day0",
    "messageInitNick_8488": "最爱茄子",
    "messageInitContent_8703": "给网线把脉",
    "messageInitNick_8487": "等你地久",
    "messageInitContent_8700": "左左右右前前后后",
    "messageInitContent_8701": "祈赢了",
    "messageInitNick_8489": "蘑菇兽",
    "1_67": "元核熔炼",
    "messageInitContent_10844": "还有草帽",
    "1_66": "元核强化",
    "messageInitContent_10845": "什么看来海贼王的带子从超星海洋飘来了？",
    "1_65": "进阶",
    "messageInitContent_10846": "唯一源兽带队",
    "1_64": "高",
    "messageInitContent_10847": "建议上诸葛亮",
    "1_63": "中",
    "messageInitContent_10840": "皮草大战",
    "1_62": "低",
    "messageInitContent_10841": "皮匠是要整点新材料了嘛",
    "1_61": "成功率",
    "messageInitContent_10842": "现在在大家面前的是唯一源兽",
    "1_60": "怪兽数量",
    "messageInitContent_10843": "草裙不是早已经市场饱和",
    "messageInitContent_10826": "努力推理",
    "messageInitContent_10827": "春天在哪里呀",
    "messageInitContent_10828": "在你心里",
    "1_79": "次/秒",
    "messageInitContent_10829": "在你婶婶的脑海里",
    "messageInitContent_8706": "金山我先搬走了",
    "messageInitNick_8484": "新型榨菜",
    "messageInitContent_8707": "给个机会",
    "messageInitNick_8483": "东方战神",
    "messageInitContent_8704": "主打一个随缘",
    "messageInitNick_8486": "海猫鸣泣之时",
    "messageInitContent_8705": "许愿出货day7",
    "messageInitNick_8485": "悲有寂寞有染",
    "messageInitNick_8480": "行为艺术家",
    "messageInitContent_8708": "今天选人多的",
    "messageInitNick_8482": "爱因斯不舒坦",
    "messageInitContent_8709": "娘子！",
    "messageInitNick_8481": "随行保温",
    "1_70": "等级{1}解锁",
    "messageInitContent_8710": "为祈call",
    "messageInitContent_8713": "我猜我猜我猜猜猜",
    "messageInitNick_8477": "清香的蟠桃",
    "messageInitContent_8714": "总有一个是错的",
    "messageInitNick_8476": "不需要眼泪",
    "messageInitContent_8711": "你又懂了",
    "messageInitNick_8479": "可降解拖鞋",
    "messageInitContent_8712": "我全都要",
    "messageInitNick_8478": "花环尾戒",
    "1_78": "当前怪兽",
    "messageInitContent_10833": "帮我选好嘛",
    "1_77": "随机",
    "messageInitContent_10834": "不要再解释了",
    "1_76": "元核数量",
    "messageInitContent_10835": "渴望答案的眼神是藏不住的",
    "1_75": "紫色或以上品质的元核可以使用探索者等级{1}开启的元核熔炼功能转移词条属性和宿命效果，是否继续分解？",
    "messageInitContent_10836": "想乱选的想法是有的",
    "1_74": "请从左列表选择需要分解的元核（{1}）",
    "1_73": "可容纳词条",
    "messageInitContent_10830": "没有答案浑身难受",
    "1_72": "默认解锁",
    "messageInitContent_10831": "答案公开",
    "1_71": "购买解锁",
    "messageInitContent_10832": "欧拉欧拉欧拉欧拉",
    "messageInitContent_10819": "那可是超级反伤啊！",
    "messageInitContent_10815": "都什么跟什么",
    "messageInitContent_10816": "多少有点离谱了",
    "messageInitContent_10817": "武侠vs神话",
    "messageInitContent_10818": "还是看技能吧",
    "messageInitContent_8717": "经典看看技能",
    "messageInitNick_8473": "衣架破坏者",
    "messageInitContent_8718": "怎么打起来了",
    "messageInitNick_8472": "披着虎皮的猫",
    "messageInitContent_8715": "叉叉快来劝架",
    "messageInitNick_8475": "繁华独角戏",
    "messageInitContent_8716": "五小强内战",
    "messageInitNick_8474": "消除大师",
    "messageInitContent_8719": "所以咻咻到底是什么性别",
    "messageInitNick_8471": "红坑女王",
    "messageInitNick_8470": "你是故意的吧",
    "1_81": "未知",
    "messageInitContent_8720": "怪兽少点好判断一点",
    "1_80": "需要探索者等级{1}",
    "messageInitContent_8721": "看看谁伤害高",
    "messageInitNick_8469": "霸气小女子",
    "messageInitContent_8724": "事情是这样子的……",
    "messageInitNick_8466": "烤焦的烧饼",
    "messageInitContent_8725": "我听说呢",
    "messageInitNick_8465": "比油田油",
    "messageInitContent_8722": "让我康康",
    "messageInitNick_8468": "怀中抱软猫",
    "messageInitContent_8723": "精致探索者竞猜中",
    "messageInitNick_8467": "吃够了苦",
    "1_89": "每秒回复能量",
    "messageInitContent_10822": "神不是凡人能战胜的",
    "1_88": "每次普通攻击回复能量",
    "messageInitContent_10823": "和平~",
    "1_87": "觉醒后开启技能升级",
    "messageInitContent_10824": "平和~",
    "1_86": "{1}品质怪兽等级上限为{2}",
    "messageInitContent_10825": "这好难猜哦",
    "1_85": "怪兽等级不可超过探索者等级+{1}",
    "1_84": "最多锁定{1}条",
    "1_83": "未拥有",
    "messageInitContent_10820": "快说，jo和jojo有什么关系",
    "1_82": "未遇到此怪兽，无法查看",
    "messageInitContent_10821": "我觉得右边赢，它有替身",
    "messageInitContent_10808": "等我问问ai",
    "messageInitContent_10809": "夜观星象不知答案",
    "messageInitContent_10804": "这里是预言家，左",
    "messageInitContent_10805": "选对明天加鸡腿",
    "messageInitContent_10806": "超纲了",
    "messageInitContent_10807": "五行缺答案",
    "messageInitContent_8728": "幼体2只1个技能",
    "messageInitNick_8462": "贝多芬的寂寞",
    "messageInitContent_8729": "哈哈哈哈哈",
    "messageInitNick_8461": "蒜蓉通菜",
    "messageInitContent_8726": "小朋友不要学",
    "messageInitNick_8464": "高傲囡人",
    "messageInitContent_8727": "两远程",
    "messageInitNick_8463": "开门你的快递",
    "98_-902": "战斗校验失败，战斗异常结束，请尝试重新启动游戏后挑战",
    "98_-903": "一大波叉叉意外闯入战场，战斗结算异常，是否重新结算？",
    "messageInitNick_8460": "五种辣",
    "98_-901": "一小波叉叉意外闯入战场，战斗结算异常，是否重新结算？",
    "1_92": "探索者名称",
    "messageInitContent_8731": "左左右右前前后后",
    "messageInitNick_8459": "成熟只是瞬间",
    "1_91": "最高提升{1}级",
    "messageInitContent_8732": "选择困难",
    "messageInitNick_8458": "风扇晕了",
    "1_90": "需5个技能均提升至{1}级才可修改前缀",
    "98_-904": "战斗校验失败，战斗异常结束，请尝试重新启动游戏后挑战",
    "98_-905": "战斗校验失败，战斗异常结束，请尝试重新启动游戏后挑战",
    "messageInitContent_8730": "让我猜对一次吧！",
    "messageInitContent_8735": "相信第一感觉",
    "messageInitNick_8455": "断片先生",
    "messageInitContent_8736": "正确的",
    "messageInitNick_8454": "认证复读专家",
    "messageInitContent_8733": "主打一个随缘",
    "messageInitNick_8457": "金字塔等你",
    "messageInitContent_8734": "等大家选完",
    "messageInitNick_8456": "队友我先撤",
    "messageInitContent_10811": "什么西部片场",
    "1_99": "熔炼后元核可能出现的词条属性和宿命效果",
    "messageInitContent_10812": "然后海格力斯打起了太极",
    "1_98": "熔炼后，作为消耗材料的元核将永久消失，是否确定进行熔炼？全额返还金币{1}，粉尘{2}",
    "messageInitContent_10813": "珀耳修斯耍起了咏春",
    "1_97": "锁定条数达到上限",
    "messageInitContent_10814": "MountainJo掏出了雅典娜！",
    "1_96": "{1}：{2}",
    "1_95": "消耗材料品质不能高于主元核",
    "1_94": "未鉴定",
    "1_93": "请输入3-12字符探索者名称",
    "messageInitContent_10810": "我好怕它们下一秒要掏枪",
    "messageInitNick_8451": "不哄我了吗",
    "messageInitNick_8450": "无敌的核膜",
    "messageInitNick_8453": "在世魅魔",
    "messageInitNick_8452": "脆爽的榴莲",
    "messageInitNick_8448": "古怪大叔",
    "messageInitNick_8447": "闪电快递",
    "messageInitNick_8449": "没干嘛",
    "messageInitNick_8444": "懒得取名字",
    "messageInitNick_8443": "七点的饺子",
    "messageInitNick_8446": "职业自由人",
    "messageInitNick_8445": "我后悔下凡了",
    "messageInitContent_10800": "量子波动选择法",
    "messageInitContent_10801": "大佬快来指路",
    "messageInitContent_10802": "玄学告诉我选右",
    "messageInitContent_10803": "抄作业时间到",
    "messageInitNick_8440": "蓬松的头发",
    "messageInitNick_8442": "豆角先锋",
    "messageInitNick_8441": "夜闯废校",
    "messageInitNick_8437": "管我什么",
    "messageInitNick_8436": "有点缺爱",
    "messageInitNick_8439": "暗恋不如不恋",
    "messageInitNick_8438": "霸天书生",
    "messageInitNick_8433": "晚餐吃蛋挞",
    "messageInitNick_8432": "给杯子道歉",
    "messageInitNick_8435": "短肌法师",
    "messageInitNick_8434": "快去创造奇迹",
    "messageInitNick_8431": "柠檬泪",
    "messageInitNick_8430": "草莓爱好者",
    "messageInitNick_8426": "纸质老虎",
    "messageInitNick_8425": "一介书生",
    "messageInitNick_8428": "盒饭之王",
    "messageInitNick_8427": "月亮私藏温柔",
    "messageInitNick_8422": "凡尔赛龙王",
    "messageInitNick_8421": "二是一种特质",
    "messageInitNick_8424": "不要伤我好吗",
    "messageInitNick_8423": "尖叫番茄",
    "messageInitNick_8429": "卖萌之神",
    "messageInitNick_8420": "有星球快乐吗",
    "messageInitNick_8415": "爱满满的鱼",
    "messageInitNick_8414": "痛车大哥",
    "messageInitNick_8417": "别来我世界",
    "messageInitNick_8416": "拉面的灵魂",
    "messageInitNick_8411": "为谁上线",
    "messageInitNick_8410": "深海亡魂",
    "messageInitNick_8413": "飞花临蝶",
    "messageInitNick_8412": "高冷逗霸",
    "messageInitNick_8419": "年年有木鱼",
    "messageInitNick_8418": "僵尸小可爱",
    "messageInitNick_8404": "踟蹰的转椅",
    "messageInitNick_8403": "吾王万岁",
    "messageInitNick_8406": "写生少女",
    "messageInitNick_8405": "大葱之心",
    "messageInitNick_8400": "摸鱼陪伴",
    "messageInitNick_8402": "超时空电磁炉",
    "messageInitNick_8401": "秘密楼梯",
    "messageInitNick_8408": "北极星在闪烁",
    "messageInitNick_8407": "内卷发明者",
    "messageInitNick_8409": "逆境中的狐狸",
    "messageInitContent_6167": "到我这报名",
    "messageInitContent_6166": "拉莱耶的海鲜饭店是从这里走吗",
    "messageInitContent_6169": "经典查看技能",
    "messageInitContent_6168": "大仁选择全都要",
    "messageInitContent_6161": "下面好像很危险的样子",
    "messageInitContent_6160": "需要几个可爱的领航员怪兽",
    "messageInitContent_6163": "开打",
    "messageInitContent_6162": "留下航行费",
    "messageInitContent_6165": "微我1000000000",
    "99_213|L": "解锁获得",
    "messageInitContent_6164": "我的心就像这海，",
    "messageInitContent_6178": "huh",
    "messageInitContent_6177": "月亮告诉我选右边",
    "messageInitContent_6179": "摸鱼time！",
    "messageInitContent_6170": "锤子高一点（各种意义上）",
    "messageInitContent_6172": "一墙高",
    "messageInitContent_6171": "这波我站桐仁",
    "messageInitContent_6174": "唯一小黑子路过，建议加个背带裤",
    "messageInitContent_6173": "大锤姓啥",
    "messageInitContent_6176": "星星告诉我选左边",
    "messageInitContent_6175": "发型互换试试",
    "messageInitContent_6189": "啊是头像，是鼻孔",
    "messageInitContent_6188": "前排出售桐仁的萝卜刀",
    "messageInitContent_6181": "我这一锤子下去你可能",
    "messageInitContent_6180": "桐仁怎么跑这里来摸鱼了，福利不用发了吗",
    "messageInitContent_6183": "不够大啊",
    "messageInitContent_6182": "大头怪兽vs大头怪兽",
    "messageInitContent_6185": "草裙有链接吗",
    "messageInitContent_6184": "哪里人多选哪里",
    "messageInitContent_6187": "冲冲",
    "messageInitContent_6186": "好大……的牙",
    "messageInitContent_6190": "水桶身材之间的对撞",
    "messageInitContent_6199": "怪兽手办",
    "messageInitContent_6192": "牙科医生露出微笑",
    "messageInitContent_6191": "今晚加班点什么",
    "messageInitContent_6194": "……",
    "messageInitContent_6193": "你的答案有点松弛",
    "messageInitContent_6196": "锤子可以吃的吗",
    "messageInitContent_6195": "不如坐下来吃饭",
    "messageInitContent_6198": "究极体看起来很像是孩子的玩具",
    "messageInitContent_6197": "致命打击",
    "randomEventDialogueGroupConfig_5.101": "地上很快就变干净了。你感觉你得到了一种名为掌控感的无形奖励。",
    "randomEventDialogueGroupConfig_5.102": "离开",
    "randomEventDialogueGroupConfig_5.103": "你以为我是谁？#以为我是幻的兽丝？告诉你，我是超进化委员会成员，负责这区的清理工作，不然你想想，平日这么多战斗，这么多怪兽生活在这里，这里为什么还能这么干净。#那都是因为我们在默默努力。告诉你，我们的工作不仅仅是处理日常的垃圾，我们还负责处理那些乱丢垃圾的，接招吧。",
    "randomEventDialogueGroupConfig_5.104": "只能上了",
    "randomEventDialogueGroupConfig_5.100": "它又再上下打量了你一番。",
    "randomEventDialogueGroupConfig_5.105": "只能上了",
    "96_TribeDonation": "支配核心",
    "messageInitContent_8858": "正确的",
    "messageInitContent_8859": "今天选人多的",
    "messageInitContent_6200": "手动doge",
    "messageInitContent_8863": "猜你下次给我第一",
    "messageInitContent_8864": "右边",
    "messageInitContent_6202": "巨大化",
    "messageInitContent_8861": "五行缺答案",
    "messageInitContent_6201": "什么丢娃娃大赛",
    "messageInitContent_8862": "我家猫帮我选了",
    "messageInitContent_6204": "看看技能再看看阵容",
    "messageInitContent_8867": "变异个体组队",
    "messageInitContent_6203": "丢圈圈经典摆位",
    "messageInitContent_8868": "这边输出要碾压了吧",
    "messageInitContent_6206": "直觉告诉我右边",
    "messageInitContent_8865": "你也来剪头发",
    "messageInitContent_6205": "左边地盘更低",
    "messageInitContent_8866": "同父异母的兄弟姐妹",
    "messageInitContent_8860": "发女装可得答案",
    "messageInitContent_6208": "emmm",
    "messageInitContent_6207": "真是些大可爱",
    "messageInitContent_8869": "范围不够吧",
    "messageInitContent_6209": "早睡早起身体好",
    "messageInitContent_6211": "均衡存乎",
    "messageInitContent_8874": "emmm",
    "messageInitContent_6210": "选完收工",
    "messageInitContent_8875": "比谁更不像吗",
    "messageInitContent_6213": "左边切后",
    "messageInitContent_8872": "原生",
    "messageInitContent_6212": "右边有奶",
    "messageInitContent_8873": "等我问问ai",
    "messageInitContent_6215": "究极最怕的一级",
    "messageInitContent_8878": "美杜莎莎是我的",
    "messageInitContent_6214": "哪里人少选哪里",
    "messageInitContent_8879": "我觉得左边厉害",
    "messageInitContent_6217": "它们只是些孩子",
    "messageInitContent_8876": "猜对day1",
    "messageInitContent_6216": "那你很棒棒哦",
    "messageInitContent_8877": "把右边收走！",
    "messageInitContent_8870": "今夕是蛇年",
    "messageInitContent_8871": "正在猜",
    "messageInitContent_6219": "选啥啊",
    "messageInitContent_6218": "你们有没有想过战墙的感受",
    "messageInitContent_6222": "根据昨天的我选择这边",
    "messageInitContent_8885": "抛个硬币看看",
    "messageInitContent_6221": "这真是一家子的吗",
    "messageInitContent_8886": "抄作业时间到",
    "messageInitContent_6224": "你的提纲小助手提醒您",
    "messageInitContent_8883": "这里是预言家，左",
    "messageInitContent_6223": "猜不到啊啊",
    "messageInitContent_8884": "夜观星象不知答案",
    "messageInitContent_6226": "脖子消失术",
    "messageInitContent_8889": "人越多人越少",
    "messageInitContent_6225": "人越多人越少",
    "messageInitContent_6228": "三个比蒙叠起来的高度",
    "messageInitContent_8887": "玄学告诉我选右",
    "messageInitContent_6227": "饿了",
    "messageInitContent_8888": "怎么选",
    "messageInitContent_8881": "等大家选完",
    "messageInitContent_8882": "技能技能技能技能技能技能技能技能",
    "messageInitContent_6220": "奇妙的突变",
    "messageInitContent_8880": "一眼左边",
    "messageInitContent_6229": "身高是左边赢了",
    "messageInitContent_6233": "你知道比蒙有几条腿吗",
    "messageInitContent_8896": "主唱太拼了",
    "messageInitContent_6232": "晚安大小姐",
    "messageInitContent_8897": "主唱太魂了",
    "messageInitContent_6235": "打雷啦",
    "messageInitContent_8894": "不可描述的想象",
    "messageInitContent_6234": "三打1哦",
    "messageInitContent_8895": "打歌现场",
    "messageInitContent_6237": "雷电法王出击",
    "messageInitContent_6236": "沉浸式电疗",
    "messageInitContent_6239": "大号充电宝",
    "messageInitContent_8898": "建议玩乐队",
    "messageInitContent_6238": "看我闪电五连鞭",
    "messageInitContent_8899": "晕了",
    "messageInitContent_8892": "超纲了",
    "messageInitContent_8893": "今天选人多的",
    "messageInitContent_6231": "全胜路过",
    "messageInitContent_8890": "收工",
    "messageInitContent_6230": "数量是右边赢了",
    "messageInitContent_8891": "向左向右向前看",
    "messageInitContent_6244": "怎么混入了一只不一样的",
    "messageInitContent_6243": "啊？",
    "messageInitContent_6246": "中门大开",
    "messageInitContent_6245": "这一个aoe下来",
    "messageInitContent_6248": "你知道比蒙有几条腿吗",
    "messageInitContent_6247": "按体积算是左边",
    "messageInitContent_6249": "按数量算是右边",
    "messageInitContent_6240": "天天开心",
    "messageInitContent_6242": "再也没有断电焦虑",
    "messageInitContent_6241": "再也没有世俗的烦恼",
    "messageInitContent_10792": "我是网吧主理人",
    "messageInitContent_6255": "我好帅",
    "messageInitContent_10793": "保持微笑~",
    "messageInitContent_6254": "我梦到了是右边赢",
    "messageInitContent_10794": "到处是芬芳的气息",
    "messageInitContent_6257": "不要录播要直播",
    "messageInitContent_10795": "技能技能技能技能",
    "messageInitContent_6256": "歪，量子巨龙吗，你赢了吗",
    "messageInitContent_6259": "这是交易现场",
    "messageInitContent_6258": "这是什么色号",
    "messageInitContent_10790": "别打龙龙！",
    "messageInitContent_10791": "竟然敢围攻我们的单挑之王",
    "messageInitContent_10796": "大家都选好了吗",
    "messageInitContent_6251": "三连对",
    "messageInitContent_10797": "抛硬币中",
    "messageInitContent_6250": "3加1等于4",
    "messageInitContent_10798": "坏了没有硬币",
    "messageInitContent_6253": "电疗vs按摩",
    "messageInitContent_10799": "随机点",
    "messageInitContent_6252": "你们快选啊",
    "messageInitContent_10781": "看热闹不嫌事大",
    "messageInitContent_6266": "蚊子会吸血，赤色狮也会吸血，就是说",
    "messageInitContent_10782": "这里是网吧吗",
    "messageInitContent_6265": "看表情就知道怎么选",
    "messageInitContent_10783": "能凑齐五个怪不容易啊",
    "messageInitContent_6268": "欢迎收看动物世界",
    "messageInitContent_10784": "懂了社恐龙是网关",
    "messageInitContent_6267": "v我",
    "messageInitContent_6269": "大狮子",
    "messageInitContent_10780": "全场加起来2个技能",
    "messageInitContent_10789": "鼠标不要可以给我",
    "messageInitContent_6260": "画风告诉我答案",
    "messageInitContent_10785": "然后那边没有网费了是吧",
    "messageInitContent_6262": "狮虎斗",
    "messageInitContent_10786": "前排出售网板伴侣泡面",
    "messageInitContent_6261": "看来是场遭遇战",
    "messageInitContent_10787": "泡面多少钱",
    "messageInitContent_6264": "建议加上战力",
    "messageInitContent_10788": "键盘不要可以送我",
    "messageInitContent_6263": "吃瓜的感觉真好",
    "messageInitContent_10770": "先让我缓缓",
    "messageInitContent_6277": "团结就是力量",
    "messageInitContent_10771": "不要再打啦不要再打啦",
    "messageInitContent_6276": "一眼左边啊",
    "messageInitContent_10772": "猜不到啊啊",
    "messageInitContent_6279": "虎皮匠用的是什么牌子的美白",
    "messageInitContent_10773": "我猜我猜我猜猜猜",
    "messageInitContent_6278": "不许熬夜",
    "messageInitContent_10778": "让卡皮巴拉选",
    "messageInitContent_10779": "总有一个是错的，不是吗",
    "messageInitContent_6271": "请你吃棒棒糖",
    "messageInitContent_6270": "小脑虎",
    "messageInitContent_10774": "你们快选啊",
    "messageInitContent_6273": "答案哪里看？",
    "messageInitContent_10775": "希望大家蒙的都对",
    "messageInitContent_6272": "什么？",
    "messageInitContent_10776": "我梦到了是右边赢",
    "messageInitContent_6275": "我觉得，就我觉得呢，",
    "messageInitContent_10777": "选择困难症怎么办",
    "messageInitContent_6274": "合体技",
    "messageInitContent_10760": "我看都是小兵",
    "messageInitContent_10761": "小兵打大龙？",
    "messageInitContent_10762": "赢的是这边",
    "messageInitContent_10767": "主打一个随缘",
    "messageInitContent_10768": "等大家选完",
    "messageInitContent_10769": "相信第一感觉",
    "messageInitContent_10763": "未尝一对",
    "messageInitContent_10764": "让我猜对一次吧！",
    "messageInitContent_10765": "左左右右前前后后",
    "messageInitContent_10766": "选择困难",
    "messageInitContent_10749": "左右横跳中",
    "messageInitContent_10750": "这几个能顶得住吗",
    "messageInitContent_10751": "孤独的王啊",
    "messageInitNick_8399": "末日泡面",
    "messageInitContent_10756": "打大龙？",
    "messageInitContent_10757": "然后被喷死了",
    "messageInitContent_10758": "带惩戒啊啊啊",
    "messageInitContent_10759": "我们是冠军",
    "messageInitContent_10752": "左边是装了避雷针？",
    "messageInitContent_10753": "巨龙增强了它的肚脐眼",
    "messageInitContent_10754": "巨龙加固了它的建筑",
    "messageInitContent_10755": "是不是错片场了",
    "messageInitNick_8390": "信号探测者",
    "messageInitContent_10738": "你们有没有发现",
    "messageInitContent_10739": "给网线把脉",
    "messageInitNick_8396": "行走的饼干",
    "messageInitNick_8395": "辣椒射手",
    "messageInitNick_8398": "比珍珠还真",
    "messageInitNick_8397": "把温柔当爱",
    "messageInitNick_8392": "给手机把脉",
    "messageInitNick_8391": "美食狂欢",
    "messageInitNick_8394": "橘子味橡皮",
    "messageInitNick_8393": "一分钟",
    "messageInitContent_10740": "怪兽赢了",
    "messageInitContent_8801": "玄学告诉我选右",
    "messageInitNick_8389": "菠萝草莓酱",
    "messageInitContent_8802": "发女装可得答案",
    "messageInitNick_8388": "风之主",
    "messageInitContent_8800": "这里是预言家，左",
    "messageInitContent_10745": "右边信我",
    "messageInitContent_10746": "反正是怪兽赢了",
    "messageInitContent_10747": "到底是哪边能赢呢，好难看出来哦",
    "messageInitContent_10748": "向左向右向前看",
    "messageInitContent_10741": "肯定是那边啊",
    "messageInitContent_10742": "到底哪边啊",
    "messageInitContent_10743": "祝大家猜的都对",
    "messageInitContent_10744": "看不出左边有啥胜算",
    "messageInitContent_10727": "那个动物园跑出来的",
    "messageInitContent_10728": "大家好，这里是探索者",
    "messageInitContent_10729": "好冷啊",
    "messageInitContent_8805": "控制变量法！",
    "messageInitNick_8385": "最爱大葱",
    "messageInitContent_8806": "高兴点",
    "messageInitNick_8384": "那个野蛮人",
    "messageInitContent_8803": "五行缺答案",
    "messageInitNick_8387": "提灯映桃花",
    "messageInitContent_8804": "相信第二感觉",
    "messageInitNick_8386": "瓷娃娃",
    "messageInitContent_8809": "标题明示了",
    "messageInitNick_8381": "菜配送员到了",
    "messageInitNick_8380": "丨轮回丨",
    "messageInitContent_8807": "炎之光囚",
    "messageInitNick_8383": "沙棘果真好吃",
    "messageInitContent_8808": "叉光组合",
    "messageInitNick_8382": "少女的脸庞",
    "messageInitContent_8812": "我梦到了是右边赢",
    "messageInitNick_8378": "噬菌体跑了",
    "messageInitContent_8813": "肯定是那边啊",
    "messageInitNick_8377": "茄子怪客",
    "messageInitContent_8810": "鲨鲨鲨鲨~鲨鱼",
    "messageInitContent_8811": "技能知道答案",
    "messageInitNick_8379": "标题五个字",
    "messageInitContent_10734": "收工",
    "messageInitContent_10735": "瞎选",
    "messageInitContent_10736": "瞎猜",
    "messageInitContent_10737": "瞎想",
    "messageInitContent_10730": "尴尬而又不失礼貌的微笑",
    "messageInitContent_10731": "强的到底是谁",
    "messageInitContent_10732": "比前排",
    "messageInitContent_10733": "比后排",
    "messageInitContent_10716": "听我的选这边",
    "messageInitContent_10717": "技能告诉我是右",
    "messageInitContent_10718": "快交出答案",
    "messageInitContent_10719": "坏了",
    "messageInitContent_8816": "肯定是那边",
    "messageInitNick_8374": "最爱柠檬",
    "messageInitContent_8817": "加攻厉害啊",
    "messageInitNick_8373": "极窄宽带",
    "messageInitContent_8814": "收工",
    "messageInitNick_8376": "欢快的猕猴桃",
    "messageInitContent_8815": "看不出左边有啥胜算",
    "messageInitNick_8375": "鼠标先锋",
    "messageInitNick_8370": "初夏微暖",
    "messageInitContent_8818": "经典看技能",
    "messageInitNick_8372": "格式化淡忘",
    "messageInitContent_8819": "我有一个大胆的想法",
    "messageInitNick_8371": "一起变胖",
    "messageInitContent_8820": "可还行",
    "messageInitContent_8823": "正在猜",
    "messageInitNick_8367": "窗外的晴天",
    "messageInitContent_8824": "选择困难症怎么办",
    "messageInitNick_8366": "水果观察者",
    "messageInitContent_8821": "让光囚赢！",
    "messageInitNick_8369": "那我走",
    "messageInitContent_8822": "在猜了在猜了",
    "messageInitNick_8368": "梅开二度",
    "messageInitContent_10723": "终于知道捕食者经历了什么",
    "messageInitContent_10724": "仿佛回到了生物课",
    "messageInitContent_10725": "打不过就合作",
    "messageInitContent_10726": "让我康康",
    "messageInitContent_10720": "嗯？食物链",
    "messageInitContent_10721": "一言不合看技能！",
    "messageInitContent_10722": "这是2个技能打2个技能吗",
    "messageInitContent_10709": "一眼",
    "messageInitContent_10705": "经典看技能",
    "messageInitContent_10706": "难顶",
    "messageInitContent_10707": "咋选",
    "messageInitContent_10708": "给个机会",
    "messageInitContent_8827": "猜对day1",
    "messageInitNick_8363": "懒喵喵",
    "messageInitContent_8828": "猜对day0",
    "messageInitNick_8362": "尖椒萝卜",
    "messageInitContent_8825": "大家都选好了吗",
    "messageInitNick_8365": "宠臣",
    "messageInitContent_8826": "懂了",
    "messageInitNick_8364": "鼻涕大佬",
    "messageInitContent_8829": "量子波动选择法",
    "messageInitNick_8361": "外向孤独患者",
    "messageInitNick_8360": "不倾国的女子",
    "messageInitContent_8830": "右边信我",
    "messageInitContent_8831": "快交出答案",
    "messageInitNick_8359": "吃货萌比",
    "messageInitContent_8834": "huh？",
    "messageInitNick_8356": "刀恋孤光",
    "messageInitContent_8835": "快把元核交出来！",
    "messageInitNick_8355": "鸡头贼稳",
    "messageInitContent_8832": "怪兽赢了",
    "messageInitNick_8358": "残风冷月",
    "messageInitContent_8833": "泰裤辣",
    "messageInitNick_8357": "量子手表",
    "messageInitContent_10712": "我选前面",
    "messageInitContent_10713": "我选后面",
    "messageInitContent_10714": "别急",
    "messageInitContent_10715": "我家猫帮我选了",
    "messageInitContent_10710": "让我康康",
    "messageInitContent_10711": "对吗？不对吧",
    "messageInitContent_8838": "赢的是灾兽",
    "messageInitNick_8352": "甜咸薯片",
    "messageInitContent_8839": "有一边输出不够，我不说是谁",
    "messageInitNick_8351": "大时光",
    "messageInitContent_8836": "我要红元核",
    "messageInitNick_8354": "倚栏听风叙",
    "messageInitContent_8837": "灾兽",
    "messageInitNick_8353": "魔女的黑店",
    "messageInitNick_8350": "绝对的真心",
    "messageInitContent_8841": "懂了",
    "messageInitNick_8349": "纯粹白痴",
    "messageInitContent_8842": "你又懂了",
    "messageInitNick_8348": "修行者",
    "messageInitContent_8840": "影啊无限啊没事了啊",
    "messageInitContent_8845": "正确的",
    "messageInitNick_8345": "掩护我撤退",
    "messageInitContent_8846": "谁给元核我就投谁",
    "messageInitNick_8344": "假如有明天",
    "messageInitContent_8843": "不懂了",
    "messageInitNick_8347": "断翅天使",
    "messageInitContent_8844": "主打一个随缘",
    "messageInitNick_8346": "引战先驱",
    "messageInitContent_10701": "大舌怪和那个大舌怪有什么区别",
    "messageInitContent_10702": "大舌怪快进化成巨舌怪",
    "messageInitContent_10703": "发动舌头攻击",
    "messageInitContent_10704": "刚来选啥",
    "messageInitContent_10700": "不许欺负大舌怪",
    "messageInitContent_8849": "猜对有红核吗",
    "messageInitNick_8341": "千里追魂",
    "messageInitNick_8340": "迷人小祖宗",
    "messageInitContent_8847": "给网线把脉",
    "messageInitNick_8343": "一百香果",
    "messageInitContent_8848": "都让开，让我来打",
    "messageInitNick_8342": "你好幼稚",
    "messageInitContent_8852": "我是一个路过的假面来打",
    "messageInitNick_8338": "龙眼魔法",
    "messageInitContent_8853": "雷鸣有输出的吗",
    "messageInitNick_8337": "这假的吧",
    "messageInitContent_8850": "左右横跳中",
    "messageInitContent_8851": "祝大家猜的都对",
    "messageInitNick_8339": "精神王者",
    "messageInitContent_8856": "希望大家蒙的都对",
    "messageInitNick_8334": "时空在呼吸",
    "messageInitContent_8857": "大佬快来指路",
    "messageInitNick_8333": "床垫会跑",
    "messageInitContent_8854": "未尝一对",
    "messageInitNick_8336": "胡萝卜先锋",
    "messageInitContent_8855": "给个机会",
    "messageInitNick_8335": "外星人摄影师",
    "98_-810": "集市任务",
    "messageInitNick_8330": "寂寞仙哥",
    "98_-811": "强敌词缀刷新任务",
    "messageInitNick_8332": "开心超人",
    "messageInitNick_8331": "十五了",
    "98_-814": "部落每日任务",
    "98_-812": "部落拍卖所任务",
    "98_-813": "更新部落总战力任务",
    "98_-818": "遗迹奖励任务",
    "messageInitNick_8327": "半面妆",
    "98_-819": "部落赛季名称切换任务",
    "messageInitNick_8326": "把难过拉黑",
    "98_-816": "部落每月任务",
    "messageInitNick_8329": "不合群小姐",
    "98_-817": "遗迹任务",
    "messageInitNick_8328": "脑电波电台",
    "messageInitNick_8323": "凌晨十一点",
    "messageInitNick_8322": "无声无息",
    "messageInitNick_8325": "这就是大佬",
    "messageInitNick_8324": "殷语学家",
    "98_-800": "玩法结算中，请稍后再试！",
    "messageInitNick_8321": "忘记打卡",
    "messageInitNick_8320": "酷炫老祖宗",
    "98_-803": "系统任务",
    "98_-804": "akka特殊状态启动任务",
    "98_-801": "日志清理任务",
    "98_-802": "远古觉醒统计",
    "98_-807": "斗技场任务",
    "messageInitNick_8316": "神仙打假",
    "98_-808": "战斗日志任务",
    "messageInitNick_8315": "情是何物",
    "98_-805": "akka特殊状态启动任务",
    "messageInitNick_8318": "雪莲果去哪了",
    "98_-806": "暴走排行榜任务",
    "messageInitNick_8317": "饼太大",
    "messageInitNick_8312": "点五个半身人",
    "messageInitNick_8311": "忘记补刀",
    "98_-809": "狩猎任务",
    "messageInitNick_8314": "我爱吃茄子",
    "messageInitNick_8313": "打脸爱好者",
    "messageInitNick_8319": "无敌打脸神",
    "messageInitNick_8310": "无公害柿子",
    "messageInitNick_8305": "灰彩虹",
    "messageInitNick_8304": "蛋挞女巫",
    "messageInitNick_8307": "安静的兔子",
    "messageInitNick_8306": "绳子一条",
    "messageInitNick_8301": "联名款香蕉",
    "messageInitNick_8300": "吃瓜鉴定家",
    "messageInitNick_8303": "新的大象",
    "messageInitNick_8302": "豌豆先锋",
    "messageInitNick_8309": "作业他欺负我",
    "messageInitNick_8308": "狂飙的青蛙",
    "98_-821": "部落战匹配中，请稍后再试",
    "98_-822": "部落战结算中，请稍后再试",
    "98_-820": "主将决斗场结算中，请稍后再试",
    "98_-825": "录像任务",
    "98_-826": "暴走任务",
    "98_-823": "世界boss任务",
    "98_-824": "起源殿记录第一",
    "98_-829": "创世竞猜任务",
    "98_-827": "全服进度任务",
    "98_-828": "一创到底任务",
    "98_-60065": "战斗无法开始（人员不足或者有探索者结算中）",
    "99_2051": "封禁角色名: {1}\\nUID: {2}{3}",
    "98_-60066": "更换队长失败，该探索者处于离线状态",
    "98_-60067": "本场战斗异常，战斗结束",
    "99_2053": "温馨提醒:请保管好账号密码，勿将账号密码泄露给他人，以免出现意外损失。",
    "98_-60068": "密码只能包含英文和数字，请重新检查后输入",
    "99_2052": "解封时间: {1}",
    "98_-60069": "小队申请加入人数较多，请稍后再试",
    "99_2055": "预计还需要等待",
    "99_2054": "已等待",
    "99_2057": "当前等候",
    "99_2056": "温馨提示：切换后台30秒会中断排队，请耐心等待",
    "98_-60060": "该位置已有探索者",
    "darkForestEventConfigDescription_10": "事件10",
    "darkForestEventConfigDescription_11": "事件11",
    "98_-60062": "位置发生更换",
    "darkForestEventConfigDescription_12": "事件12",
    "98_-60063": "没有可跳跃节点",
    "darkForestEventConfigDescription_13": "事件13",
    "98_-60064": "多人挑战我的怪兽最多上阵{1}只",
    "darkForestEventConfigDescription_14": "事件14",
    "darkForestEventConfigDescription_15": "事件15",
    "darkForestEventConfigDescription_16": "事件16",
    "darkForestEventConfigDescription_17": "事件17",
    "darkForestEventConfigDescription_18": "事件18",
    "darkForestEventConfigDescription_19": "事件19",
    "99_2048": "战力下降",
    "99_2047": "战力提升",
    "99_2049": "封停提示",
    "98_-60076": "需解锁前置武装",
    "98_-60070": "小队已解散",
    "98_-60071": "{1}后可再次点击",
    "98_-60072": "战墙武装已解锁",
    "98_-60073": "战墙武装未解锁",
    "98_-60074": "战墙武装等级到达上限",
    "99_2060": "请输入兑换码",
    "98_-60075": "战墙武装无需重置",
    "99_2059": "输入兑换码",
    "99_2058": "取消排队",
    "98_-60043": "该永生之茧关卡节点挑战次数已达上限",
    "98_-60044": "cjhwy2",
    "98_-60045": "本日抽卡次数到达上限",
    "99_2031": "按住说话",
    "98_-60046": "该能力尚未达到解锁等级",
    "99_2030": "排序",
    "98_-60047": "该位置已镶嵌该战纹",
    "98_-60048": "无法触及此节点",
    "99_2035": "符合条件时可手动释放的技能",
    "99_2034": "主动技",
    "98_-60040": "每日刷新次数已达到上限",
    "98_-60041": "已有好友上阵该怪兽，请稍后再试",
    "98_-60042": "邀请的好友已离线，换个在线的试试",
    "16_2001": "永生之茧",
    "messageInitContent_6288": "以前我还觉得这杯子挺大的",
    "messageInitContent_6287": "刚来选啥",
    "16_2003": "未通关",
    "16_2002": "刷新",
    "messageInitContent_6289": "战墙知道答案",
    "16_2005": "全部",
    "16_2004": "已通关",
    "16_2006": "通关记录",
    "99_2026": "4th",
    "messageInitContent_6280": "我穿越了，是右边",
    "99_2025": "3rd",
    "99_2028": "6th",
    "messageInitContent_6282": "龙虎豹hhhh",
    "99_2027": "5th",
    "messageInitContent_6281": "没想到吧",
    "messageInitContent_6284": "选择困难症怎么办",
    "99_2029": "7th",
    "messageInitContent_6283": "啊！！",
    "messageInitContent_6286": "让女儿帮我选了",
    "messageInitContent_6285": "四选一都没问题，怎么二选一就不行了",
    "99_2040": "注册排队",
    "98_-60055": "队伍成员掉线了，稍后再开启战斗",
    "98_-60056": "部分队友处于战斗、结算或离线状态，请等待或重新挑战",
    "99_2042": "部分生效",
    "moorEffectConfigName_11": "临时召唤",
    "98_-60057": "队伍成员已满",
    "99_2041": "无",
    "99_2044": "单种族",
    "98_-60059": "新手造唤已关闭",
    "99_2043": "已领取",
    "moorEffectConfigName_10": "血祭",
    "99_2046": "分解",
    "99_2045": "双种族",
    "98_-60050": "等待其他探索者返回",
    "98_-60052": "一键邀请cd",
    "messageInitContent_6299": "我来啦",
    "messageInitContent_6298": "体型碾压",
    "99_2037": "敌方",
    "messageInitContent_6291": "一只占了3个位置",
    "99_2036": "己方",
    "messageInitContent_6290": "肥美",
    "99_2039": "登录排队",
    "messageInitContent_6293": "墙神两兄弟",
    "99_2038": "未知",
    "messageInitContent_6292": "原来我家门神跑这了",
    "messageInitContent_6295": "怎么肥事",
    "messageInitContent_6294": "泰裤辣",
    "messageInitContent_6297": "不想工作",
    "messageInitContent_6296": "有战墙肯定是墙神赢啊",
    "98_-60021": "造唤台未解锁",
    "98_-60022": "大型战纹无法替换或卸下",
    "randomEventConfigNPC_9": "胜爷",
    "98_-60023": "该节点不可探索",
    "randomEventConfigNPC_8": "红红",
    "98_-60024": "前置节点尚未完成探索",
    "randomEventConfigNPC_7": "阿瓷",
    "98_-60025": "该节点无法继续进行探索",
    "99_2011": "远古",
    "98_-60026": "战墙未解锁",
    "99_2010": "木偶",
    "98_-60027": "起源殿未解锁",
    "99_2013": "彼岸",
    "98_-60028": "该战纹数量不足",
    "99_2012": "原生",
    "98_-60020": "商店刷新异常，请稍后再试",
    "98_-60029": "cjhwy2",
    "99_2004": "不朽",
    "99_2003": "究极",
    "99_2006": "全部",
    "99_2005": "觉醒",
    "99_2008": "尸鬼",
    "99_2007": "祖龙",
    "99_2009": "星灵",
    "98_-60032": "小队不存在，请重新加入或创建小队",
    "98_-60033": "等级{1}开启凿星裂痕小队",
    "98_-60034": "前置副本尚未通关，无法加入该凿星裂痕小队",
    "99_2020": "{1}小时",
    "98_-60035": "小队已满员，请重新加入或创建小队",
    "98_-60036": "你已在该凿星裂痕小队中",
    "99_2022": "取消",
    "98_-60037": "当前没有匹配的小队，请稍后再试",
    "99_2021": "确定",
    "98_-60038": "小队密码错误，请猜猜试试",
    "99_2024": "2nd",
    "98_-60039": "永生之茧未解锁",
    "99_2023": "1st",
    "98_-60030": "凿星裂痕未解锁",
    "98_-60031": "一脚不可踏两队，你已经在凿星裂痕小队之中",
    "99_2015": "突变",
    "randomEventConfigNPC_2": "外星迷",
    "99_2014": "原始",
    "randomEventConfigNPC_1": "爆格",
    "99_2017": "狂化",
    "99_2016": "暴怒",
    "99_2019": "战力",
    "randomEventConfigNPC_6": "小章",
    "99_2018": "毁灭",
    "randomEventConfigNPC_5": "阿丝",
    "randomEventConfigNPC_4": "阿粉",
    "randomEventConfigNPC_3": "复读鸡",
    "98_-60001": "加固战墙次数已达到上限",
    "98_-60002": "该怪兽已置入",
    "98_-60003": "cjhwy2",
    "98_-60004": "起源基石未解锁",
    "98_-60005": "该怪兽不符合起源基石放入限制",
    "98_-60006": "起源基石放入数量限制已达到上限",
    "98_-60007": "谜之巢穴未建造",
    "98_-60008": "该探索者已加入队伍",
    "98_-60009": "该探索者前置副本尚未通关，无法加入该凿星裂痕小队",
    "98_-60010": "该节点尚未开放",
    "98_-60011": "漆黑之根无需重置",
    "98_-60012": "前置节点尚未探索",
    "98_-60013": "需要先建造谜之巢穴",
    "98_-60014": "补偿商店已关闭",
    "98_-60015": "{1}后可以发布",
    "98_-60016": "燃火叠加次数已达到上限",
    "99_2002": "幻化",
    "98_-60017": "黑暗森林未解锁",
    "99_2001": "幼体",
    "98_-60018": "购买次数已达到上限",
    "98_-60019": "队伍信息已变更",
    "messageInitContent_8500": "希望大家蒙的都对",
    "messageInitContent_8501": "给你给你",
    "randomEventDialogueGroupConfig_2.40": "1……",
    "randomEventDialogueGroupConfig_2.41": "继续等着",
    "randomEventDialogueGroupConfig_2.42": "动手",
    "messageInitContent_8504": "白娘子！",
    "messageInitContent_8505": "猜对day1",
    "messageInitContent_8502": "摸摸哒",
    "messageInitContent_8503": "为祈call",
    "randomEventDialogueGroupConfig_2.47": "动手",
    "randomEventDialogueGroupConfig_2.48": "等等，那边有外星生物！",
    "randomEventDialogueGroupConfig_2.49": "看过去",
    "randomEventDialogueGroupConfig_2.43": "2……",
    "randomEventDialogueGroupConfig_2.44": "继续等",
    "randomEventDialogueGroupConfig_2.45": "动手",
    "randomEventDialogueGroupConfig_2.46": "3……",
    "messageInitContent_8508": "秃了也变强了",
    "messageInitContent_8509": "控制变量法",
    "messageInitContent_8506": "天下第二武道大会",
    "messageInitContent_8507": "一拳赢",
    "messageInitContent_8511": "总有一个对的",
    "randomEventDialogueGroupConfig_2.50": "先锤再说",
    "messageInitContent_8512": "技能告诉我是右",
    "randomEventDialogueGroupConfig_2.51": "天空什么都没有。",
    "randomEventDialogueGroupConfig_2.52": "继续看",
    "messageInitContent_8510": "感觉能秒掉",
    "randomEventDialogueGroupConfig_2.53": "回头看",
    "messageInitContent_8515": "祈赢了",
    "messageInitContent_8516": "白蛇传？？",
    "messageInitContent_8513": "向左向右向前看",
    "messageInitContent_8514": "技能知道答案",
    "randomEventDialogueGroupConfig_2.58": "过去看看",
    "randomEventDialogueGroupConfig_2.59": "离开",
    "randomEventDialogueGroupConfig_2.54": "离开",
    "randomEventDialogueGroupConfig_2.55": "它已经跑远了",
    "randomEventDialogueGroupConfig_2.56": "离开",
    "randomEventDialogueGroupConfig_2.57": "它已经跑远了，地上留下了什么。",
    "randomEventDialogueGroupConfig_2.29": "喂你……你不讲武德！",
    "messageInitContent_8519": "我是猜错概念神",
    "messageInitContent_8517": "看看增益效果",
    "messageInitContent_8518": "希望今年能买房",
    "messageInitContent_8522": "赢的都是祈",
    "warGrooveConfigName_1": "大型战纹-注血",
    "messageInitContent_8523": "恭喜发财",
    "messageInitContent_8520": "遇事不决看技能",
    "warGrooveConfigName_3": "大型战纹-弹射",
    "messageInitContent_8521": "万事如意",
    "randomEventDialogueGroupConfig_2.20": "抱歉看入神了。啊，我突然觉得有个召唤外星生物的装置在呼唤我。再见！",
    "warGrooveConfigName_2": "大型战纹-附甲",
    "messageInitContent_8526": "主打一个随缘",
    "warGrooveConfigName_5": "大型战纹-感染",
    "messageInitContent_8527": "希望大家蒙的都对",
    "warGrooveConfigName_4": "大型战纹-霸力",
    "messageInitContent_8524": "等大家选完",
    "warGrooveConfigName_7": "大型战纹-粘滞",
    "messageInitContent_8525": "乐",
    "warGrooveConfigName_6": "大型战纹-剥甲",
    "randomEventDialogueGroupConfig_2.25": "告别",
    "warGrooveConfigName_9": "战纹-回复",
    "randomEventDialogueGroupConfig_2.26": "天空澄澈无云，空空如也。",
    "warGrooveConfigName_8": "大型战纹-衰弱",
    "randomEventDialogueGroupConfig_2.27": "回头看",
    "randomEventDialogueGroupConfig_2.28": "离开",
    "randomEventDialogueGroupConfig_2.21": "告别",
    "randomEventDialogueGroupConfig_2.22": "非礼啊，有变态啊！非礼啊，有变态啊！非礼啊，有变态啊！",
    "randomEventDialogueGroupConfig_2.23": "原来这就是第四类接触吗？等我回去研究一下，后面还会来找你的哈哈哈。",
    "randomEventDialogueGroupConfig_2.24": "它们又不一定会带来毁灭，而且那种事情当然是交给自称英雄的家伙去烦恼，再见。",
    "messageInitContent_8528": "精致探索者竞猜中",
    "messageInitContent_8529": "法海在此",
    "messageInitContent_8533": "金山我先搬走了！！",
    "messageInitContent_8534": "刚来选啥",
    "messageInitContent_8531": "我在小白",
    "randomEventDialogueGroupConfig_2.30": "问怎么才算讲",
    "messageInitContent_8532": "不许熬夜",
    "randomEventDialogueGroupConfig_2.31": "与它战斗",
    "messageInitContent_8537": "那你倒是说啊",
    "messageInitContent_8538": "祈赢了",
    "messageInitContent_8535": "这伤害一目了然",
    "messageInitContent_8536": "控制变量法",
    "randomEventDialogueGroupConfig_2.36": "指出大家未必希望毁灭",
    "randomEventDialogueGroupConfig_2.37": "我等下数1、2、3，你听到3之后再动手啊。",
    "randomEventDialogueGroupConfig_2.38": "答应它",
    "randomEventDialogueGroupConfig_2.39": "不管它",
    "randomEventDialogueGroupConfig_2.32": "不！热闹点才好。",
    "messageInitContent_8530": "JOJO！！！！！",
    "randomEventDialogueGroupConfig_2.33": "指出没有消息才是好消息",
    "randomEventDialogueGroupConfig_2.34": "质疑它有想看到世界末日的倾向",
    "randomEventDialogueGroupConfig_2.35": "这样确实会有更多的想象空间，可我还是很想看到外星生物。",
    "messageInitContent_8539": "看看增益效果",
    "messageInitContent_8544": "赢的都是祈",
    "randomEventDialogueGroupConfig_2.83": "回头看",
    "messageInitContent_8545": "我梦到了是右边赢",
    "randomEventDialogueGroupConfig_2.84": "离开",
    "messageInitContent_8542": "镇魂输出高",
    "randomEventDialogueGroupConfig_2.85": "很多星刃一起看着那个方向。",
    "messageInitContent_8543": "收工",
    "randomEventDialogueGroupConfig_2.86": "离开",
    "messageInitContent_8548": "发发发！！！",
    "messageInitContent_8549": "选择困难症怎么办",
    "randomEventDialogueGroupConfig_2.80": "继续看天空",
    "messageInitContent_8546": "未尝一对",
    "randomEventDialogueGroupConfig_2.81": "离开",
    "messageInitContent_8547": "我叫许仙",
    "randomEventDialogueGroupConfig_2.82": "一朵云趁你不注意冒了出来。",
    "messageInitContent_8540": "这集我看过",
    "randomEventDialogueGroupConfig_2.87": "一大群星刃正齐刷刷地看着那个方向。",
    "messageInitContent_8541": "让我猜对一次吧！",
    "randomEventDialogueGroupConfig_2.88": "走向星刃群",
    "randomEventDialogueGroupConfig_2.89": "离开",
    "messageInitContent_8555": "我猜我猜我猜猜猜",
    "randomEventDialogueGroupConfig_2.94": "告诉它召唤外星生物的正确方式",
    "messageInitContent_8556": "法海你不懂爱",
    "randomEventDialogueGroupConfig_2.95": "什么？这么重要的事情，一定要悄悄地告诉我。#你去把秘密写着这个地方，记好了。就是在@&）@%%……，快去吧！”￥#还有这是谢礼！",
    "messageInitContent_8553": "希望有钞能力",
    "randomEventDialogueGroupConfig_2.96": "了解收下并离开",
    "messageInitContent_8554": "成许愿池了",
    "randomEventDialogueGroupConfig_2.97": "我乃肠山小商人也，我愿意和你一起去看星星，出现吧，遥远的异界彷徨者。",
    "messageInitContent_8559": "希望天天开心",
    "randomEventDialogueGroupConfig_2.90": "星刃群扑腾扑腾地跳入草丛，大胆一些的悄悄从草丛中看着你，胆小的早已蹦远了。",
    "randomEventDialogueGroupConfig_2.91": "离开",
    "messageInitContent_8557": "许愿出货day3",
    "randomEventDialogueGroupConfig_2.92": "要不你也和我一起呼唤吧，我说一句你说一句？#这样说不定就有双倍的呼唤力量。",
    "messageInitContent_8558": "交答案税",
    "randomEventDialogueGroupConfig_2.93": "同意",
    "messageInitContent_8551": "遇事不决看技能",
    "randomEventDialogueGroupConfig_2.98": "迟疑",
    "messageInitContent_8552": "希望可能开到低重双红盘",
    "randomEventDialogueGroupConfig_2.99": "故意念错",
    "messageInitContent_8550": "娘子！",
    "messageInitContent_8566": "我壮呢？",
    "randomEventDialogueGroupConfig_2.61": "继续看",
    "messageInitContent_8567": "我愿称之为原生的王",
    "randomEventDialogueGroupConfig_2.62": "回头看",
    "messageInitContent_8564": "立了",
    "randomEventDialogueGroupConfig_2.63": "天空如此广阔仿佛在唱歌。",
    "messageInitContent_8565": "小帅啊壮呢",
    "randomEventDialogueGroupConfig_2.64": "回头看",
    "messageInitContent_8568": "我叫许仙",
    "messageInitContent_8569": "控制变量法",
    "randomEventDialogueGroupConfig_2.60": "天空仿佛也在回望你。",
    "randomEventDialogueGroupConfig_2.69": "离开",
    "messageInitContent_8562": "今天选人少的",
    "randomEventDialogueGroupConfig_2.65": "它早跑了。",
    "messageInitContent_8563": "黄金镇魂曲！！",
    "randomEventDialogueGroupConfig_2.66": "离开",
    "messageInitContent_8560": "梦里啥都有",
    "randomEventDialogueGroupConfig_2.67": "一只星刃从草丛中蹦出，也跟着你看向那个方向。",
    "messageInitContent_8561": "在左右之间迷失了方向",
    "randomEventDialogueGroupConfig_2.68": "继续看天空",
    "messageInitContent_8577": "选择困难症怎么办",
    "randomEventDialogueGroupConfig_2.72": "回头看",
    "messageInitContent_8578": "希望能遇见真爱",
    "randomEventDialogueGroupConfig_2.73": "一大群星刃同时看着那个方向。",
    "messageInitContent_8575": "希望大家蒙的都对",
    "randomEventDialogueGroupConfig_2.74": "离开",
    "messageInitContent_8576": "我也叫许仙",
    "randomEventDialogueGroupConfig_2.75": "澄澈的天空飘来了一朵云，一朵由巧妙的混乱构成的云。",
    "messageInitContent_8579": "向左向右向前看",
    "randomEventDialogueGroupConfig_2.70": "天空依旧澄澈无云，空空如也。",
    "22_2089|L": "{1}倍",
    "randomEventDialogueGroupConfig_2.71": "继续看",
    "messageInitContent_8570": "也不能完全控制",
    "messageInitContent_8573": "今年暴富！",
    "randomEventDialogueGroupConfig_2.76": "回头看",
    "messageInitContent_8574": "看看增益效果",
    "randomEventDialogueGroupConfig_2.77": "离开",
    "messageInitContent_8571": "啊壮呢？",
    "randomEventDialogueGroupConfig_2.78": "天空还是澄澈无云，空空如也。",
    "messageInitContent_8572": "等大家选完",
    "randomEventDialogueGroupConfig_2.79": "第二只星刃从草丛里蹦了出来，和你一起看向那个方向。",
    "messageInitNick_6090": "尖叫芒果",
    "messageInitNick_6091": "哇哦",
    "messageInitNick_6096": "万能薯条",
    "messageInitNick_6097": "刺猬女郎",
    "messageInitNick_6098": "赴远皇后",
    "messageInitNick_6099": "红尘戏子",
    "messageInitNick_6092": "大白兔糖",
    "messageInitNick_6093": "劳资天下无敌",
    "messageInitNick_6094": "暴富小能手",
    "messageInitNick_6095": "午餐你请自重",
    "messageInitNick_6089": "全宇宙逃亡",
    "messageInitNick_6080": "一起开饭",
    "messageInitNick_6085": "打我的是猪",
    "messageInitNick_6086": "我爱吃拉肠",
    "messageInitNick_6087": "大脸猫",
    "messageInitNick_6088": "正当防卫",
    "messageInitNick_6081": "枇杷真好吃",
    "messageInitNick_6082": "孤雪傲梅",
    "messageInitNick_6083": "现在是三点",
    "messageInitNick_6084": "精品大号",
    "messageInitNick_6078": "依旧一个人",
    "messageInitNick_6079": "下年去相亲",
    "messageInitNick_6074": "超能力棒球",
    "messageInitNick_6075": "千杯不停盏",
    "messageInitNick_6076": "我纯属构",
    "messageInitNick_6077": "尖叫豆角",
    "messageInitNick_6070": "中午十二点",
    "messageInitNick_6071": "老船票",
    "messageInitNick_6072": "魔幻书馆",
    "messageInitNick_6073": "高冷兔兔",
    "messageInitNick_6067": "草莓裙摆",
    "messageInitNick_6068": "面包开车",
    "messageInitNick_6069": "流浪的胸骨",
    "randomEventDialogueGroupConfig_2.18": "能在短暂的一生中见证末日的降临，不觉得很浪漫吗？#我似乎在你的眼中看到了另一个宇宙。",
    "randomEventDialogueGroupConfig_2.19": "诶？那为什么这么多在太空中靠吼来输出的？#喔等等，我又想到一个新的呼唤外星生物的方式了，再见。",
    "messageInitNick_6063": "沧桑的老树",
    "messageInitNick_6064": "结束连败",
    "messageInitNick_6065": "流动的世界",
    "messageInitNick_6066": "尊嘟假嘟",
    "messageInitNick_6060": "夜雨小情歌",
    "messageInitNick_6061": "杨桃龙",
    "messageInitNick_6062": "沙棘果消灭者",
    "messageInitNick_6056": "疯狂小蚂蚁",
    "messageInitNick_6057": "看海的人",
    "messageInitNick_6058": "空气迷航",
    "messageInitNick_6059": "流浪的肩胛。",
    "randomEventDialogueGroupConfig_2.14": "说安静点更好",
    "randomEventDialogueGroupConfig_2.15": "我正在试着呼唤外星的智慧生命。#￥%%￥&……%￥￥&…像这样，发送脑电波。用这个动作，然后是这个动作召唤！#收到请回复￥&！@…&%*收到请回复。",
    "randomEventDialogueGroupConfig_2.16": "指出真空不能传播声音",
    "randomEventDialogueGroupConfig_2.17": "试图理解它的话",
    "randomEventDialogueGroupConfig_2.10": "-",
    "randomEventDialogueGroupConfig_2.11": "-",
    "randomEventDialogueGroupConfig_2.12": "小灰、小绿、博士、克总、长门大萌神……#回应我的呼唤吧！为什么不回应我呢，天哪，宇宙呐，你为什么如此安静呐？",
    "randomEventDialogueGroupConfig_2.13": "问它在喊什么",
    "messageInitNick_6052": "为爱加油",
    "messageInitNick_6053": "快乐猫猫头",
    "messageInitNick_6054": "嘴甜律师",
    "messageInitNick_6055": "指甲刀",
    "messageInitNick_6050": "沉浸式刷题",
    "messageInitNick_6051": "无暇摸鱼",
    "messageInitNick_6049": "爱沉溺在深海",
    "messageInitNick_6045": "萌新的努力",
    "messageInitNick_6046": "超时空电视机",
    "messageInitNick_6047": "漫长的白日梦",
    "messageInitNick_6048": "认证打拳专家",
    "messageInitNick_6041": "甜美的空气",
    "messageInitNick_6042": "最爱草莓",
    "messageInitNick_6043": "打锅卖铁",
    "messageInitNick_6044": "江湖无恨",
    "messageInitNick_6040": "牙膏狂怒者",
    "messageInitNick_6038": "炒鱿鱼大师",
    "messageInitNick_6039": "果断地摸鱼",
    "messageInitNick_6034": "菜花先锋",
    "messageInitNick_8697": "尖叫玉米",
    "messageInitNick_6035": "只爱陌生人",
    "messageInitNick_8696": "你会生小猫吗",
    "messageInitNick_6036": "当个演员",
    "messageInitNick_8699": "无所谓",
    "messageInitNick_6037": "变个身就来",
    "messageInitNick_8698": "有点动心",
    "messageInitNick_6030": "双手洗碗",
    "messageInitNick_8693": "懒懒猫",
    "activityTemplateName_20": "全服共探",
    "messageInitNick_6031": "直播翻车了",
    "messageInitNick_8692": "和队友吃鸡",
    "activityTemplateName_21": "创世纪",
    "gameName_30020": "萤火之触",
    "messageInitNick_6032": "感情走狗",
    "messageInitNick_8695": "百变小叮当",
    "activityTemplateName_22": "荣耀里程碑",
    "messageInitNick_6033": "宿管阿姨",
    "messageInitNick_8694": "最爱洋葱",
    "activityTemplateName_23": "拼二大作战",
    "activityTemplateName_24": "一创到底·创化时刻",
    "messageInitNick_8691": "单色黎明",
    "messageInitNick_8690": "七点的蒸蛋",
    "messageInitNick_6027": "煲汤大师",
    "messageInitNick_6028": "一脸憨憨",
    "messageInitNick_8689": "宇宙在闪烁",
    "activityTemplateName_29": "万象琥珀",
    "messageInitNick_6029": "湛蓝的天",
    "messageInitNick_6023": "薄荷味少年",
    "messageInitNick_8686": "不近男色",
    "gameName_30021": "破空飞流",
    "messageInitNick_6024": "路过的决斗王",
    "messageInitNick_8685": "你必须取我",
    "messageInitNick_6025": "冰糖逆流",
    "messageInitNick_8688": "另类囚徒",
    "messageInitNick_6026": "不粘锅谢谢你",
    "messageInitNick_8687": "你衣服穿反了",
    "activityTemplateName_30": "创世竞猜",
    "messageInitNick_8682": "香菜兽",
    "activityTemplateName_31": "双星狂欢",
    "messageInitNick_6020": "疗伤灵鹿",
    "messageInitNick_8681": "日落杂货店",
    "activityTemplateName_32": "许愿五六七",
    "messageInitNick_6021": "经验本大师",
    "messageInitNick_8684": "懂神",
    "activityTemplateName_33": "七王轮战",
    "messageInitNick_6022": "横坐标",
    "messageInitNick_8683": "快乐星球人",
    "activityTemplateName_34": "创友招募",
    "activityTemplateName_35": "专享礼",
    "activityTemplateName_36": "突围鏖战",
    "messageInitNick_8680": "尖叫苹果",
    "activityTemplateName_37": "合围破阵",
    "activityTemplateName_38": "天降一掌",
    "messageInitNick_6016": "咖喱哇哦",
    "messageInitNick_8679": "狂奔的蜗牛",
    "activityTemplateName_39": "老莫集市",
    "messageInitNick_6017": "富婆加我",
    "messageInitNick_8678": "迷你蛋蛋",
    "messageInitNick_6018": "爬扫把的猫",
    "messageInitNick_6019": "最爱柿子",
    "messageInitNick_6012": "无敌引战神",
    "messageInitNick_8675": "情话太甜",
    "messageInitNick_6013": "无语筷子",
    "messageInitNick_8674": "一秒钟",
    "messageInitNick_6014": "奋斗吧少年",
    "messageInitNick_8677": "待嫁姑娘",
    "messageInitNick_6015": "柿子魔法",
    "messageInitNick_8676": "贩卖日落",
    "activityTemplateName_40": "大漠行",
    "98_-711": "探索者改名功能暂时关闭",
    "messageInitNick_8671": "逃婚的司机",
    "98_-712": "部落改名功能暂时关闭",
    "activityTemplateName_42": "一创到底·硬创江湖",
    "messageInitNick_8670": "万事胜意",
    "activityTemplateName_43": "江湖道",
    "messageInitNick_6010": "大变活人",
    "messageInitNick_8673": "叮咣五六",
    "98_-710": "造唤台功能暂时关闭",
    "messageInitNick_6011": "程序设计师",
    "messageInitNick_8672": "涉江采芙蓉",
    "98_-715": "好友聊天功能暂时关闭",
    "98_-716": "异象聊天功能暂时关闭",
    "activityTemplateName_46": "创友回归",
    "98_-713": "部落修改公告功能暂时关闭",
    "activityTemplateName_47": "剪烛春",
    "98_-714": "评论功能暂时关闭",
    "activityTemplateName_48": "赛博时戳",
    "98_-719": "邮件功能暂时关闭",
    "activityTemplateName_49": "赛博环",
    "gameName_30004": "觉醒之心",
    "messageInitNick_6005": "最爱萝卜",
    "messageInitNick_8668": "美丽冻人",
    "gameName_30003": "远古遗迹",
    "messageInitNick_6006": "高智商咖啡",
    "messageInitNick_8667": "探索者不存在",
    "98_-717": "怪兽修改前缀功能暂时关闭",
    "gameName_30006": "超星王座",
    "messageInitNick_6007": "强壮跟风神",
    "98_-718": "浮空巨塔功能暂时关闭",
    "gameName_30005": "混沌之实",
    "messageInitNick_6008": "早餐喝豆浆",
    "messageInitNick_8669": "永远成功",
    "messageInitNick_6001": "过期工具人",
    "messageInitNick_8664": "最爱雪莲果",
    "messageInitNick_6002": "打脸公主",
    "messageInitNick_8663": "低调的骄傲",
    "gameName_30002": "进化之誓",
    "messageInitNick_6003": "泛用的都不出",
    "messageInitNick_8666": "九点的拉肠",
    "gameName_30001": "起源之地",
    "messageInitNick_6004": "亲爱滴它亲我",
    "messageInitNick_8665": "牙签狂怒者",
    "gameName_30008": "镇海神域",
    "messageInitNick_6009": "茄子真好吃",
    "gameName_30007": "桎焰魔森",
    "gameName_30009": "升龙荒漠",
    "activityTemplateName_50": "龙宵大作战",
    "activityTemplateName_51": "DNA动了",
    "messageInitNick_8660": "来自文件夹",
    "98_-701": "游戏充值功能暂时关闭",
    "activityTemplateName_53": "三阵入局",
    "messageInitNick_8662": "跑调之神",
    "messageInitNick_6000": "天堂戒指",
    "messageInitNick_8661": "前方说书反应",
    "98_-704": "聊天语音功能暂时关闭",
    "activityTemplateName_56": "连环击破",
    "98_-705": "部落聊天功能暂时关闭",
    "activityTemplateName_57": "腾龙燃火",
    "98_-702": "自定义名字功能暂时关闭",
    "activityTemplateName_58": "邀约盛会",
    "98_-703": "自定义部落信息功能暂时关闭",
    "98_-708": "部落功能暂时关闭",
    "gameName_30015": "悠久之树",
    "messageInitNick_8657": "防止小孩误打",
    "98_-709": "商店功能暂时关闭",
    "gameName_30014": "微光之巅",
    "messageInitNick_8656": "冬日向日葵",
    "98_-706": "世界聊天功能暂时关闭",
    "gameName_30017": "玄冥海岸",
    "messageInitNick_8659": "你不是伞别撑",
    "98_-707": "组队聊天功能暂时关闭",
    "gameName_30016": "冰封幻境",
    "messageInitNick_8658": "我会煮饭",
    "gameName_30011": "聆音迷丛",
    "messageInitNick_8653": "动摇我的世界",
    "gameName_30010": "不朽矿场",
    "messageInitNick_8652": "无关的人",
    "gameName_30013": "沼间瑶池",
    "messageInitNick_8655": "太阳能牙刷",
    "gameName_30012": "游云水域",
    "messageInitNick_8654": "下雨收衣服啦",
    "gameName_30019": "巨藤之巢",
    "gameName_30018": "糖霜雪堡",
    "messageInitNick_8651": "无公害萝卜",
    "messageInitNick_8650": "饭堂大叔",
    "messageInitNick_8646": "黑心的白天鹅",
    "messageInitNick_8645": "我可是打手",
    "messageInitNick_8648": "矮人科技",
    "messageInitNick_8647": "厨师过家家",
    "messageInitNick_8642": "天堂水杯",
    "messageInitNick_8641": "不喜勿撩",
    "messageInitNick_8644": "叉烧射手",
    "messageInitNick_8643": "一点点霸道",
    "messageInitNick_8649": "蝶骨",
    "98_-722": "部落邮件功能暂时关闭",
    "98_-723": "部落搜索功能暂时关闭",
    "98_-720": "兑换码功能暂时关闭",
    "messageInitNick_8640": "尖叫姜",
    "98_-724": "暂无广告观看",
    "messageInitNick_8635": "半妖妖妖",
    "messageInitNick_8634": "背景有点假",
    "messageInitNick_8637": "就爱吃醋",
    "messageInitNick_8636": "酣睡美人",
    "messageInitNick_8631": "油缸呢",
    "messageInitNick_8630": "满身是戏",
    "messageInitNick_8633": "摆满了杯具啊",
    "messageInitNick_8632": "天下无双魂",
    "messageInitNick_8639": "最爱椰子",
    "messageInitNick_8638": "肌肉小猛男",
    "messageInitNick_8624": "忧郁的暗夜",
    "messageInitNick_8623": "打脸小天才",
    "messageInitNick_8626": "跟风小天才",
    "messageInitNick_8625": "打脸鉴定家",
    "messageInitNick_8620": "纯情橡皮糖",
    "messageInitNick_8622": "洗衣液破坏者",
    "messageInitNick_8621": "冰箱少男",
    "messageInitNick_8628": "凌晨的末班车",
    "messageInitNick_8627": "咳嗽补刀法",
    "messageInitNick_8629": "雀斑少女",
    "activityTemplateName_10": "远古轮回",
    "activityTemplateName_11": "每日三发",
    "activityTemplateName_12": "智者轮盘",
    "activityTemplateName_13": "神奇树洞",
    "activityTemplateName_14": "神行探索",
    "activityTemplateName_15": "位面领主",
    "activityTemplateName_16": "世界奖励",
    "messageInitNick_8613": "不是怪兽是神",
    "messageInitNick_8612": "冬日傲娇的菊",
    "activityTemplateName_18": "一步之遥",
    "messageInitNick_8615": "我推的杯子",
    "activityTemplateName_19": "降临",
    "messageInitNick_8614": "沉浸式切菜",
    "messageInitNick_8611": "流浪猫",
    "messageInitNick_8610": "拳师的荣耀",
    "messageInitNick_8617": "亮得过阳光",
    "messageInitNick_8616": "无公害黄瓜",
    "messageInitNick_8619": "摸鱼侠",
    "messageInitNick_8618": "菠动你心",
    "messageInitContent_8588": "相信第一感觉",
    "messageInitNick_8602": "绿色发电",
    "messageInitContent_8589": "快交出答案",
    "messageInitNick_8601": "沉浸式洗猫",
    "messageInitContent_8586": "阿美爱上了阿帅",
    "messageInitNick_8604": "如果瓜子会笑",
    "messageInitContent_8587": "希望有钞能力",
    "messageInitNick_8603": "作业做完了吗",
    "messageInitNick_8600": "尬聊小天才",
    "messageInitContent_8580": "法海在此",
    "messageInitContent_8581": "祈宝真棒",
    "messageInitNick_8609": "你是懂我的",
    "messageInitContent_8584": "主打一个随缘",
    "messageInitNick_8606": "小祖宗",
    "messageInitContent_8585": "吸点欧气",
    "messageInitNick_8605": "不聊天打游戏",
    "messageInitContent_8582": "遇事不决看技能",
    "messageInitNick_8608": "怎么停水了",
    "messageInitContent_8583": "我爱小青",
    "messageInitNick_8607": "撞到你怀里",
    "messageInitContent_8599": "崩",
    "messageInitContent_8597": "谁吃增益时间就谁伤",
    "messageInitContent_8598": "总有一个对的",
    "messageInitContent_8591": "法海在此",
    "messageInitContent_8592": "晚上好",
    "messageInitContent_8590": "我不懂爱",
    "messageInitContent_8595": "蚌埠住了",
    "messageInitContent_8596": "青蛇vs白蛇",
    "messageInitContent_8593": "可怕",
    "messageInitContent_8594": "晚安大小姐",
    "95_1": "适度娱乐，理性消费",
    "22_2142": "你不属于受邀探索者噢~",
    "22_2143": "受邀条件：连续7+日没登录，在活动期间第一次登录的探索者",
    "22_2144": "本登录账号已经有其他角色完成绑定，无法再次绑定",
    "22_2145": "每个登录账号只能接受一次邀请，确认接受邀请后，本登录账号的其他区服角色无法再接受邀请，请探索者注意",
    "22_2140": "邀请{1}位好友（{2}/{3}）",
    "22_2141": "邀请好友",
    "messageInitContent_8618": "祈快到碗里来",
    "messageInitContent_8619": "法海你不懂爱",
    "messageInitContent_8616": "梦里啥都有",
    "messageInitContent_8617": "祈赢了",
    "messageInitContent_8621": "给你给你",
    "messageInitContent_8622": "希望有钞能力",
    "messageInitContent_8620": "金山我先搬走了",
    "messageInitContent_8625": "梦回龙年",
    "messageInitContent_8626": "宅家当卧龙",
    "messageInitContent_8623": "晚安祈",
    "messageInitContent_8624": "祈硬控我",
    "22_2139": "我的邀请码",
    "22_2135": "新",
    "22_2136": "敬请期待",
    "22_2137": "巡游进度",
    "22_2138": "邀约进度：",
    "22_2155": "<face color=#ffffff dilate=0.52 softness=0.07>战斗中<face color=#00effe dilate=0.52 softness=0.07>己方怪兽</face>的体型会随战斗时长依次增大</face>",
    "22_2156": "<face color=#0e2749 dilate=0.52 softness=0.07>战斗中<face color=#ff0060 dilate=0.52 softness=0.07>敌方怪兽</face>的体型会随战斗时长增大</face>",
    "22_2150": "竞猜失败",
    "22_2151": "查看影像",
    "22_2152": "对战",
    "messageInitContent_8629": "看看增益效果",
    "messageInitContent_8627": "让我康康谁是脆皮",
    "messageInitContent_8628": "我叫许仙",
    "messageInitContent_8632": "控制变量法",
    "messageInitContent_8633": "希望今年能买车",
    "messageInitContent_8630": "娘子！",
    "messageInitContent_8631": "收工",
    "messageInitContent_8636": "为祈call",
    "messageInitContent_8637": "遇事不决看技能",
    "messageInitContent_8634": "在左右之间迷失了方向",
    "messageInitContent_8635": "左左右右前前后后",
    "22_2146": "探索者！欢迎回来！请在下方输入栏内输入其他探索者的邀请码接受邀请。接受邀请后可获得{1}*{2}的奖励",
    "22_2147": "输入邀请码",
    "22_2148": "绑定",
    "22_2149": "竞猜胜利",
    "22_2164": "邀请{1}人",
    "22_2165": "额外邀请{1}人",
    "22_2166": "-形态价格降低为{1}",
    "22_2167": "邀请好友助力",
    "22_2160": "「玩法特色」",
    "22_2161": "玩法特色",
    "22_2162": "比拼方式",
    "22_2163": "战斗结束时，对敌方怪兽造成的伤害总量",
    "messageInitContent_8638": "这里是自宅守备员",
    "messageInitContent_8639": "希望天天出红核",
    "messageInitContent_8643": "你赢了",
    "messageInitContent_8644": "我爱小青",
    "messageInitContent_8641": "赢的都是祈",
    "messageInitContent_8642": "主打一个随缘",
    "messageInitContent_8647": "乐",
    "messageInitContent_8648": "不许熬夜",
    "messageInitContent_8645": "祈赢了",
    "messageInitContent_8646": "猜对day0",
    "22_2157": "开始挑战",
    "22_2158": "{1}的队伍",
    "messageInitContent_8640": "我是雷峰塔",
    "22_2159": "总伤害",
    "22_2171": "每日获得",
    "22_2172": "购买后永久生效（只可购买一次）",
    "22_2173": "<face color=#ffffff dilate=0.52 softness=0.07>远古族怪兽</face><face color=#a2ff48 dilate=0.52 softness=0.07>免费轮回</face>",
    "22_2174": "已购买",
    "messageInitContent_8649": "快交答案税",
    "22_2170": "立即获得",
    "messageInitContent_8654": "弹幕护体",
    "messageInitContent_8655": "大眼瞪小眼",
    "messageInitContent_8652": "总有一个是错的",
    "messageInitContent_8653": "答案呢",
    "messageInitContent_8658": "希望有钞能力",
    "messageInitContent_8659": "我梦到了是右边赢",
    "messageInitContent_8656": "希望大家蒙的都对",
    "messageInitContent_8657": "请叫我耐久王",
    "22_2168": "完成任务 低至0元！",
    "messageInitContent_8650": "给个机会",
    "22_2169": "激活邀请码\\n助力好友",
    "messageInitContent_8651": "希望能和自己和解",
    "22_2100": "制作所需的材料",
    "22_2101": "分数",
    "messageInitContent_6002": "大家好，我是芳草",
    "messageInitContent_8665": "看看增益效果",
    "messageInitContent_6001": "天涯何处无草丛",
    "messageInitContent_8666": "许愿暴富",
    "messageInitContent_6004": "你好医生，这里有客人",
    "messageInitContent_8663": "吸点欧气",
    "messageInitContent_6003": "大家好，我是野花",
    "messageInitContent_8664": "向左向右向前看",
    "messageInitContent_6006": "想吃薯条",
    "messageInitContent_8669": "控制变量法",
    "messageInitContent_6005": "舔舔波板糖",
    "messageInitContent_6008": "可还行",
    "messageInitContent_8667": "主打一个随缘",
    "messageInitContent_6007": "你们不觉得星烁在练习公主抱我",
    "messageInitContent_8668": "法海在此",
    "messageInitContent_8661": "就靠火神了",
    "messageInitContent_8662": "相信第一感觉",
    "messageInitContent_6000": "处处长草",
    "messageInitContent_8660": "你又懂了",
    "22_2110": "任务",
    "22_2112": "排名",
    "messageInitContent_6009": "搞",
    "messageInitContent_6013": "根本停不下来",
    "messageInitContent_8676": "等大家选完",
    "messageInitContent_6012": "me一动不动",
    "messageInitContent_8677": "今天选人少的",
    "messageInitContent_6015": "请尸狂公吃大滚",
    "messageInitContent_8674": "泰裤辣",
    "messageInitContent_6014": "红红火火恍恍惚惚",
    "messageInitContent_8675": "我全都要",
    "messageInitContent_6017": "你懂的",
    "messageInitContent_6016": "这也台",
    "messageInitContent_6019": "你好早八人",
    "messageInitContent_8678": "未尝一对",
    "messageInitContent_6018": "急，想吃肉",
    "messageInitContent_8679": "向左向右向前看",
    "22_2106": "重开",
    "22_2107": "点击开始",
    "22_2109": "释放",
    "22_2102": "剩余时间",
    "messageInitContent_8672": "遇事不决看技能",
    "22_2103": "今日最高",
    "messageInitContent_8673": "祈赢了",
    "messageInitContent_6011": "大龙龙想撸",
    "messageInitContent_8670": "恭喜发财",
    "22_2105": "排行榜",
    "messageInitContent_6010": "大尾巴",
    "messageInitContent_8671": "希望天天开心",
    "22_2120": "2v2",
    "22_2121": "3v3",
    "22_2122": "5v5",
    "messageInitContent_6024": "五小强何时再聚",
    "messageInitContent_8687": "莎莎看到迦娜会不会吓到",
    "messageInitContent_6023": "锤子也有去处了",
    "messageInitContent_8688": "这能量吸没了吧",
    "messageInitContent_6026": "马上就通关了马上",
    "messageInitContent_8685": "海的怪兽",
    "messageInitContent_6025": "艺术就是爆炸",
    "messageInitContent_8686": "嗨~",
    "messageInitContent_6028": "无所谓~",
    "messageInitContent_6027": "这里有一颗伤心的人",
    "messageInitContent_8689": "徒弟一刀一个",
    "messageInitContent_6029": "人在工位",
    "22_2117": "阵容2",
    "22_2118": "阵容3",
    "messageInitContent_8680": "刚来选啥",
    "22_2119": "积分 {1}",
    "22_2113": "我的积分",
    "messageInitContent_6020": "桐仁带队",
    "messageInitContent_8683": "再也没有世俗的烦恼",
    "22_2114": "剩余免费挑战次数",
    "messageInitContent_8684": "叉会腰",
    "22_2115": "设置阵容",
    "messageInitContent_6022": "咻咻去其他地方跑腿了",
    "messageInitContent_8681": "法海你不懂爱",
    "22_2116": "阵容1",
    "messageInitContent_6021": "叉叉上岸了",
    "messageInitContent_8682": "早上好",
    "22_2131": "总获得",
    "22_2132": "已购买",
    "22_2134": "巡游进度",
    "messageInitContent_6035": "为什么没有原生拟态",
    "messageInitContent_8698": "我也叫许仙",
    "messageInitContent_6034": "都，是勇敢的",
    "messageInitContent_8699": "遇事不决看技能",
    "messageInitContent_6037": "家人们谁懂啊",
    "messageInitContent_8696": "新原生直接的对决",
    "messageInitContent_6036": "不科学，快变大啊啊啊",
    "messageInitContent_8697": "祈快到碗里来",
    "messageInitContent_6039": "歇一歇",
    "messageInitContent_6038": "找到你了！",
    "22_2128": "已领取",
    "messageInitContent_8690": "收工",
    "22_2129": "积分",
    "messageInitContent_8691": "许愿暴富！！！！",
    "22_2124": "每日免费领",
    "messageInitContent_6031": "没关系已经很厉害了",
    "messageInitContent_8694": "总有一个对的",
    "22_2125": "奖池：{1}/{2}",
    "messageInitContent_6030": "梦回二层",
    "messageInitContent_8695": "控制变量法",
    "22_2126": "本奖池剩余奖励",
    "messageInitContent_6033": "雨下个不停",
    "messageInitContent_8692": "看看增益效果",
    "22_2127": "祖传DNA",
    "messageInitContent_6032": "在打了在打了",
    "messageInitContent_8693": "克苏鲁对决",
    "messageInitContent_10990": "猜猜我是谁",
    "messageInitContent_10991": "野怪F4我来了",
    "messageInitContent_10992": "极品飞机？",
    "messageInitContent_10993": "别乱开车",
    "skillDes_7": "铁幕区域内的己方怪兽血量回复效果提升{level_based}%",
    "skillDes_6": "触发龙魂时，攻击力提升{level_based}%，持续{p1}秒",
    "skillDes_9": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的范围伤害（{p1}码）",
    "skillDes_8": "焚烧区域内的敌方怪兽血量回复效果降低{level_based}%",
    "messageInitContent_10998": "超 必 杀",
    "skillDes_3": "触发龙魂时，创造一个铁幕区域（{p1}码），区域内的己方怪兽受到的伤害降低{level_based}%，铁幕区域持续{p2}秒",
    "messageInitContent_10999": "嗯？",
    "skillDes_2": "龙魂会使敌方怪兽血量回复效果降低{level_based}%，持续{p1}秒",
    "skillDes_5": "触发龙魂时，霸气提升{level_based}%，持续{p1}秒",
    "skillDes_4": "触发龙魂时，创造一个焚烧区域（{p1}码），每{p2}秒对区域内的敌方怪兽造成攻击力×{level_based}%的伤害，焚烧区域持续{p3}秒",
    "messageInitContent_10994": "嘿嘿嘿",
    "messageInitContent_10995": "走啊",
    "messageInitContent_10996": "只需要一套",
    "skillDes_1": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害",
    "messageInitContent_10997": "皇？",
    "messageInitContent_10980": "其中一个是吉他大师，其他娜几个是什么回事",
    "messageInitContent_10981": "这里是飞行器诶",
    "messageInitContent_10982": "前排出售骰子",
    "messageInitContent_10987": "应了",
    "messageInitContent_10988": "黑桃哥都的地盘好大",
    "messageInitContent_10989": "海漩在挑衅我！",
    "messageInitContent_10983": "这里没有终点",
    "messageInitContent_10984": "人生也没有终点",
    "messageInitContent_10985": "谁谁在喊我",
    "messageInitContent_10986": "我喊你 你敢应吗",
    "messageInitContent_10969": "游戏怪生",
    "messageInitContent_10970": "让来到这关的怪兽都回到第一关哈哈",
    "messageInitContent_10971": "握住溯仪的大手",
    "messageInitContent_10976": "三星通关！",
    "messageInitContent_10977": "怎么这么多跑错片场的",
    "messageInitContent_10978": "请问分手厨房是这里吗",
    "messageInitContent_10979": "不是的",
    "messageInitContent_10972": "我叫艾克",
    "messageInitContent_10973": "我叫编织者",
    "messageInitContent_10974": "嘟 嘟嘟嘟 嘟——",
    "messageInitContent_10975": "游戏开始",
    "messageInitContent_10958": "我是好人！",
    "messageInitContent_10959": "我也是！",
    "activityTemplateName_62": "幸运之约",
    "activityTemplateName_63": "幸运进阶",
    "activityTemplateName_64": "兽猎补给",
    "activityTemplateName_65": "半周年记",
    "activityTemplateName_66": "盛夏足迹",
    "activityTemplateName_67": "启程夜溯",
    "activityTemplateName_69": "幻境巡游",
    "messageInitContent_10960": "来人顶住红唇的吻",
    "messageInitContent_10965": "全都是我黑桃哥的地头哈哈",
    "messageInitContent_10966": "总觉得这个有点眼熟",
    "messageInitContent_10967": "哥先走一步",
    "messageInitContent_10968": "小叉叉哪里跑",
    "messageInitContent_10961": "别吧",
    "messageInitContent_10962": "游戏规则：顶住红唇时间最长者获胜",
    "messageInitContent_10963": "什么魔鬼游戏",
    "messageInitContent_10964": "我先走了",
    "activityTemplateName_70": "一创到底",
    "messageInitContent_10947": "一桌坐一桌",
    "messageInitContent_10948": "看我操作！",
    "activityTemplateName_72": "暴走回廊",
    "messageInitContent_10949": "没看到啊！",
    "activityTemplateName_73": "源裂变",
    "messageInitNick_8598": "智能食盐",
    "messageInitNick_8597": "咕咕爱好者",
    "messageInitNick_8599": "一步一歪",
    "messageInitContent_10954": "干杯",
    "messageInitContent_10955": "三只怪怎么开",
    "messageInitContent_10956": "天黑请闭眼",
    "messageInitContent_10957": "鸭狼杀？",
    "messageInitContent_10950": "这回是桃心呢",
    "messageInitContent_10951": "link3红桃皇后出来吧！",
    "messageInitContent_10952": "好猛的铜仁",
    "messageInitContent_10953": "德古拉绯焉",
    "activityTemplateName_80": "半周年",
    "messageInitContent_10936": "溜了溜了",
    "messageInitContent_10937": "这里是什么游戏啊",
    "activityTemplateName_83": "创糕糕糕",
    "messageInitContent_10938": "超进化物语2 啊",
    "activityTemplateName_84": "王之密会",
    "messageInitContent_10939": "笑了",
    "activityTemplateName_85": "感恩纪礼",
    "messageInitNick_8594": "纯情棒棒糖",
    "activityTemplateName_86": "形态同行",
    "messageInitNick_8593": "我出双倍",
    "messageInitNick_8596": "苹果射手",
    "activityTemplateName_88": "盛夏诞",
    "messageInitNick_8595": "单车少年",
    "activityTemplateName_89": "一创到底·热浪对冲",
    "messageInitNick_8590": "沉迷吃饭",
    "messageInitNick_8592": "熬夜先驱",
    "messageInitNick_8591": "对方正在输入",
    "messageInitContent_8600": "我是猜错概念神",
    "messageInitContent_8603": "发发发！！！",
    "messageInitNick_8587": "谁把琴弦拨断",
    "messageInitContent_8604": "给网线把脉",
    "messageInitNick_8586": "凉粉诗人",
    "messageInitContent_8601": "许愿暴富",
    "messageInitNick_8589": "番茄兽",
    "messageInitContent_8602": "左边更加不吃吧",
    "messageInitNick_8588": "冷眼看浮华",
    "messageInitContent_10943": "我出剪刀",
    "messageInitContent_10944": "我出差",
    "messageInitContent_10945": "祭出避雷针",
    "messageInitContent_10946": "可真热闹",
    "messageInitContent_10940": "乐园？",
    "messageInitContent_10941": "隔壁地图是led屏幕吗",
    "messageInitContent_10942": "我出石头",
    "messageInitContent_10929": "怪越少怪越强",
    "activityTemplateName_90": "巨物进击",
    "activityTemplateName_91": "进击巨物",
    "messageInitContent_10925": "分手厨房",
    "messageInitContent_10926": "捕鱼达人在此",
    "activityTemplateName_94": "启程季",
    "messageInitContent_10927": "大怪吃小鱼",
    "messageInitContent_10928": "嘻嘻下一关",
    "messageInitContent_8607": "控制变量法",
    "messageInitNick_8583": "大猫砂",
    "messageInitContent_8608": "等大家选完",
    "messageInitNick_8582": "电磁炉歌舞团",
    "messageInitContent_8605": "遇事不决看技能",
    "messageInitNick_8585": "哇哦这样啊",
    "activityTemplateName_99": "海鸣起",
    "messageInitContent_8606": "希望能和喜欢的人在一起",
    "messageInitNick_8584": "道理我都不懂",
    "messageInitContent_8609": "难崩",
    "messageInitNick_8581": "凌晨两点半",
    "messageInitNick_8580": "汪汪队",
    "messageInitContent_8610": "看看增益效果",
    "messageInitContent_8611": "快交出答案",
    "messageInitNick_8579": "红辣椒之子",
    "messageInitContent_8614": "今天选人多的",
    "messageInitNick_8576": "热心的小天才",
    "messageInitContent_8615": "你赢了",
    "messageInitNick_8575": "萝卜之心",
    "messageInitContent_8612": "在左右之间迷失了方向",
    "messageInitNick_8578": "跟骨",
    "messageInitContent_8613": "我家猫帮我选了",
    "messageInitNick_8577": "迷路的核糖体",
    "messageInitContent_10932": "赢一把就睡",
    "messageInitContent_10933": "通一关就睡",
    "messageInitContent_10934": "哈哈霸霸的样子",
    "messageInitContent_10935": "赢了可以拿走豹皮匠的糖吗哈哈",
    "messageInitContent_10930": "黑桃哥好拽",
    "messageInitContent_10931": "怎么只有一个黑桃",
    "messageInitContent_10918": "还是贯通伤害",
    "messageInitContent_10919": "好怕怕哦",
    "22_40": "空缺",
    "22_41": "暴走旷野击破榜",
    "messageInitContent_10914": "标准阵容",
    "22_42": "部落冒险通关榜",
    "messageInitContent_10915": "新野怪",
    "22_43": "斗技场积分榜",
    "messageInitContent_10916": "你的其他棋兵同伴呢",
    "22_44": "凿星裂痕通关榜",
    "messageInitContent_10917": "好可怕的等级",
    "themeCardPackDes_18030": "有哪里开始不正常了，可我说不清楚在哪里，从塞尔雷特聚落回来之后已经过去数百个日月，我终于稍稍摆脱了那种说不清道不明，黏稠不已的感觉，能够迈开脚走出巢穴。为了完全摆脱那种感觉，我决心再到那里探查一次，我那时多么希望之前看到的都只是噩梦。\\n一种无形的压力让双腿变得有些沉重，我比预想中更晚抵达那里，不同于上次，死一般的寂静笼罩着山谷，我极力压抑着呕吐感来到了塞尔雷特的聚落，记忆中深深浅浅的漩涡刻痕，已经从地上开始，爬满每一处洞穴壁，每一块树干，每一个器物……恍然间我踢到了什么，那是一只正趴地上的塞尔雷特，我低头细看，它的半截手指仍在地上不知疼痛地刻画着，糊在一起的骨肉涂抹着地面，而它的毛发上绑着的，正是我曾见过的藤蔓……我瞬间瘫坐在地，失禁了。",
    "messageInitNick_8572": "冒牌货",
    "randomEventDialogueGroupConfig_11.48": "可以",
    "messageInitNick_8571": "漫展显眼包",
    "randomEventDialogueGroupConfig_11.47": "想绕着你练习，可以吗？",
    "messageInitNick_8574": "挥剑断魂",
    "messageInitNick_8573": "您品您细品",
    "randomEventDialogueGroupConfig_11.49": "你是担心超进化委员会的白昼小姐姐过来抓我们的小课堂吗？没事的相信我！",
    "randomEventDialogueGroupConfig_11.44": "没关系，今天学到新东西已经好好好开心了。",
    "themeCardPackDes_18035": "最近的记忆总是异常地模糊，所以只能翻阅以前记录进行会议，这是一部分摘录：█，████？那个有着█鳍触█混█状的半身的怪兽出现了。它说██████\\n我不知道如何准确地向您表达我现在的感受，如果您有一本只有你自己才能碰到的记录，你突然在上面发现了不曾记得记录过的东西，可你又无比确信那是你的字迹，上面还满是脏污和漩涡状图形……而我向来习惯为从未见过的怪兽创建新条目，而我为它创建的条目，竟多得塞满了我整个记录架，就是说每一次见它，我就以为是从未见过吗……",
    "randomEventDialogueGroupConfig_11.43": "让它先给学费",
    "messageInitNick_8570": "不在乎过去",
    "randomEventDialogueGroupConfig_11.46": "接过",
    "randomEventDialogueGroupConfig_11.45": "太棒了，我只要按你刚刚在地上画出来的路线绕就可以学习到了！谢谢你，这个送给你。",
    "messageInitNick_8569": "大脑按摩师",
    "randomEventDialogueGroupConfig_11.51": "在地上把各种形状画出来",
    "messageInitNick_8568": "究成空",
    "randomEventDialogueGroupConfig_11.50": "用语言教它",
    "6_2020": "可领取",
    "randomEventDialogueGroupConfig_11.53": "离开",
    "randomEventDialogueGroupConfig_11.52": "再见！",
    "messageInitNick_8565": "茄子女巫",
    "messageInitNick_8564": "超级披萨",
    "messageInitNick_8567": "白灼菜心",
    "messageInitNick_8566": "龟咩之刀",
    "22_34": "概率：{1}",
    "messageInitContent_10921": "隔壁是数独？",
    "22_35": "位面未解锁，暂无法查看",
    "messageInitContent_10922": "冲呀",
    "22_36": "1.开启世界新位面时自动解锁对应的位面领主奖励\\n2.每层位面单独计算探索度，探索度到达一定百分比后可领取对应的奖励\\n3.购买解锁超阶可额外领取超阶对应的奖励\\n4.位面领主奖励不会过期和轮换",
    "messageInitContent_10923": "不会掉落的方块",
    "messageInitContent_10924": "叉会腰",
    "22_38": "活动剩余时间 {1}",
    "22_39": "限购 {1}",
    "messageInitContent_10920": "好古老的游戏",
    "messageInitContent_10907": "看我一消4行",
    "messageInitContent_10908": "哈喽！我过了",
    "22_50": "{1}月{2}日开启",
    "messageInitContent_10909": "看我关卡消消乐",
    "22_51": "{1}后开启",
    "22_52": "剩余{1}",
    "messageInitContent_10903": "玩具世界！",
    "22_53": "活动已结束",
    "messageInitContent_10904": "别笑，你也过不了第二关",
    "22_54": "「{1}」",
    "messageInitContent_10905": "俄罗斯方块？",
    "themeCardPackDes_18040": "我的字迹变得越发歪斜和难以辨认，还望您见谅，我也不知道为什么，也可能是我知道但不敢细想。不知道您是否有过这样的经历，记忆中经历过的事情或场景却似曾相识，若这种似曾相识是一种无穷叠加的恐怖，那又会是怎样的呢。距离上次记录已经过去很久，我才稍稍恢复些勇气继续记录。我只要一睁眼，就看到自己给自己的留言，手臂上，洞壁上，目之所及，都是，还有更多的数不清的漩涡……\\n将其中关键的内容记录下来，大概就是我的极限了吧。噩梦总该要醒的对吧，不管是以何种方式。\\n失忆？思考\\n记录异常是为什么？\\n思考\\n……\\n见到它就记下，不然会忘记\\n见到它就记下，不然会忘记\\n见到它就记下，不然会忘记\\n快逃\\n离开这里\\n出去出去\\n它在笑……\\n它是██\\n它是██\\n它是谁\\n█息\\n█窒",
    "22_55": "降临",
    "messageInitContent_10906": "俄罗斯方块高手在此",
    "96_Hunting": "狩猎",
    "messageInitNick_8561": "灵感女魂",
    "randomEventDialogueGroupConfig_11.37": "我学会了，你还有其它绕法教我不？",
    "messageInitNick_8560": "鳄鱼缺根筋",
    "randomEventDialogueGroupConfig_11.36": "突然原地转五圈",
    "messageInitNick_8563": "拉面牧师",
    "randomEventDialogueGroupConfig_11.39": "说没有",
    "messageInitNick_8562": "你是大鲨鱼",
    "randomEventDialogueGroupConfig_11.38": "说有",
    "randomEventDialogueGroupConfig_11.33": "抓住它的双手开始转动",
    "randomEventDialogueGroupConfig_11.32": "你要干什么？",
    "randomEventDialogueGroupConfig_11.35": "继续绕着它转五圈",
    "randomEventDialogueGroupConfig_11.34": "它绕着你转了四圈，然后停下来非常期待地看着你。",
    "6_2011": "比拼数值",
    "messageInitNick_8558": "旋转肌肉",
    "randomEventDialogueGroupConfig_11.40": "好吧，再见。",
    "6_2010": "繁荣度",
    "messageInitNick_8557": "迷路的基质",
    "randomEventDialogueGroupConfig_11.42": "犹豫",
    "messageInitNick_8559": "在逃艺术家",
    "randomEventDialogueGroupConfig_11.41": "教教我！",
    "messageInitNick_8554": "人参果龙",
    "messageInitNick_8553": "金色战车",
    "messageInitNick_8556": "酿辣椒",
    "messageInitNick_8555": "抬杠神",
    "22_45": "起源殿段位榜",
    "6_2019": "全部领取",
    "messageInitContent_10910": "游戏开始，游戏借宿",
    "22_46": "全服奖励",
    "6_2018": "区间最强",
    "messageInitContent_10911": "战力100w！",
    "22_47": "首位达成",
    "6_2017": "通关时长",
    "messageInitContent_10912": "好强的怪",
    "22_48": "击破{1}",
    "6_2016": "通关副本",
    "messageInitContent_10913": "一坦一输出一奶",
    "22_49": "通关{1}",
    "6_2015": "通关日期",
    "6_2014": "最快通关",
    "6_2013": "最佳成绩",
    "6_2012": "防御值扣减",
    "22_20": "1.参与活动需探索者等级到达28级\\n2.活动期间，每日刷出10位对手，给予1次挑战次数，开始挑战前可查看名称，阵容，战力，但无法查看其他详细信息，最多刷新10次，开始挑战后无法再次刷新，消耗挑战次数。\\n3.挑战需依路线次序，每日0：00自动重置，刷新挑战次数和对手\\n4.每次挑战结算时怪兽的血量会被保留，挑战期间可进行上下阵操作\\n5.战斗可手动可自动，结算前退出不会进行状态记录\\n6.每日有1次使用“补一下”的机会（队伍中的怪兽复活并回复100%的血量），没有上阵的怪兽不会回复和复活",
    "22_21": "造唤次数",
    "22_22": "神奇树洞",
    "6_2009": "输出",
    "messageInitNick_8550": "你好静静",
    "randomEventDialogueGroupConfig_11.69": "减速",
    "messageInitNick_8552": "无公害菜花",
    "messageInitNick_8551": "凉粉怪客",
    "randomEventDialogueGroupConfig_11.66": "帮它填",
    "randomEventDialogueGroupConfig_11.65": "继续转",
    "randomEventDialogueGroupConfig_11.68": "加速",
    "randomEventDialogueGroupConfig_11.67": "它开始不等你停下来，和你一起转了起来。",
    "messageInitNick_8547": "现在是我的了",
    "randomEventDialogueGroupConfig_11.73": "不必让我！",
    "messageInitNick_8546": "欠吻吗",
    "randomEventDialogueGroupConfig_11.72": "停下离开",
    "messageInitNick_8549": "二点五条",
    "randomEventDialogueGroupConfig_11.75": "停下",
    "messageInitNick_8548": "新型泡菜",
    "randomEventDialogueGroupConfig_11.74": "再减速",
    "messageInitNick_8543": "清澈的愚蠢",
    "messageInitNick_8542": "跟寂寞和好",
    "messageInitNick_8545": "泡芙侦探",
    "randomEventDialogueGroupConfig_11.71": "继续加速",
    "messageInitNick_8544": "不准咬家具",
    "randomEventDialogueGroupConfig_11.70": "它跟上了你的速度！",
    "22_12": "长期",
    "6_2008": "击破数",
    "22_13": "已满",
    "6_2007": "排行榜",
    "messageInitContent_10900": "玩物之地！",
    "22_14": "神行探索",
    "6_2006": "查看奖励",
    "messageInitContent_10901": "新地图我来啦！",
    "22_15": "1.参与活动需探索者等级到达16级\\n2.活动期间，每击破属于自己的6只复制体可获得轮盘券1张，每期活动最多可获10张\\n3.活动期间，每消耗500钻石可获得轮盘券1张，每期活动最多可获10张\\n4.每种奖励均有份数限制，每抽中1次份数-1，份数为0后概率会分摊至其他奖励上\\n5.奖励分为普通奖励（6种）和珍稀奖励（3种），当获得所有珍稀奖励后即可获得轮盘中所有剩余的奖励（全部份数）\\n6.活动关闭和重置不会重置轮盘券数量\\n7.本期智者轮盘最多抽取{1}次即可获得所有奖励",
    "6_2005": "排名",
    "messageInitContent_10902": "我也穿越了吗",
    "22_16": "远古轮回",
    "6_2004": "积分",
    "22_17": "1.参与活动需探索者等级到达32级\\n2.活动期间，神奇树洞每日会自动刷新3个任务，任务需在当日完成\\n3.活动期间，已经被选出过的任务不会再次被选出\\n4.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "6_2003": "{1}排行榜",
    "22_18": "前往",
    "6_2002": "我",
    "22_19": "造唤盛宴",
    "6_2001": "{1}排行榜奖励",
    "22_30": "今天选出",
    "22_31": "尚未选出",
    "22_32": "已被选出",
    "22_33": "份数：{1}",
    "randomEventDialogueGroupConfig_11.59": "啊谢谢你，你如果累了就想回去吧，那个送给你好了。",
    "randomEventDialogueGroupConfig_11.58": "捡起来丢出去",
    "messageInitNick_8541": "千面幻影",
    "messageInitNick_8540": "橙子君快逃",
    "randomEventDialogueGroupConfig_11.55": "你说啥来着，先这样转转转转，然后那样转转转转转转，再那样转转转转，啊不行好晕，这是什么咒语吗？啊。",
    "randomEventDialogueGroupConfig_11.54": "好的，没问题！",
    "randomEventDialogueGroupConfig_11.57": "告诉它东西掉了",
    "randomEventDialogueGroupConfig_11.56": "它开心得疯狂绕着你转起了刚刚学到的圈圈。此时，突然有什么东西从它身上飞了出来。",
    "messageInitNick_8536": "带火龙果探险",
    "randomEventDialogueGroupConfig_11.62": "捡起告别离开",
    "messageInitNick_8535": "别过来啊啊",
    "randomEventDialogueGroupConfig_11.61": "谢谢你，为了不让我踢到东西摔倒把东西丢出去了。如果你要留拿去吧。我继续练一会。",
    "messageInitNick_8538": "无上上上王",
    "randomEventDialogueGroupConfig_11.64": "啊不好，咳咳，好大尘，转太开心了，又在地上绕出深沟了。#等下又要挨骂了，要被白昼教训了，我得先把地面填好才行。",
    "messageInitNick_8537": "满分喜欢",
    "randomEventDialogueGroupConfig_11.63": "异端，异端，你是异端。",
    "messageInitNick_8532": "逆袭这件事",
    "messageInitNick_8531": "宫保鸡丁",
    "messageInitNick_8534": "逮虾户",
    "randomEventDialogueGroupConfig_11.60": "捡起道别离开",
    "messageInitNick_8533": "捂脸小可爱",
    "22_23": "去完成",
    "22_24": "智者轮盘",
    "22_25": "智者轮盘任务奖励",
    "22_27": "次数",
    "22_28": "开转",
    "messageInitNick_8539": "戒梦",
    "22_29": "前往造唤",
    "randomEventDialogueGroupConfig_59.26": "离开",
    "randomEventDialogueGroupConfig_59.25": "虽然一路险象环生，但为了拯救生命（或是为了悬赏金）大家都拼尽全力，最终顺利将雪朵带给了老咻咻。虽然赏金是平分的，但你们拯救了老咻咻儿子一命。任务完成。",
    "messageInitNick_8530": "泪眼看世界",
    "randomEventDialogueGroupConfig_59.28": "提出异议",
    "randomEventDialogueGroupConfig_59.27": "只见周围的怪兽都在讨论着，它们大都认为一日内必然不可能完成任务。",
    "randomEventDialogueGroupConfig_11.88": "不要",
    "randomEventDialogueGroupConfig_11.87": "要",
    "randomEventDialogueGroupConfig_59.29": "认同并离开",
    "randomEventDialogueGroupConfig_11.89": "我说你听着，章鱼丸、烤章鱼、烤章鱼。",
    "messageInitNick_8525": "有脑魔女",
    "randomEventDialogueGroupConfig_11.95": "想",
    "messageInitNick_8524": "气氛组先驱",
    "randomEventDialogueGroupConfig_11.94": "建议比点别的",
    "messageInitNick_8527": "我推的池子",
    "randomEventDialogueGroupConfig_11.97": "迅速离开",
    "messageInitNick_8526": "角色不是声优",
    "randomEventDialogueGroupConfig_11.96": "不是那种打，喂，你转错方向了！",
    "messageInitNick_8521": "香蕉去哪了",
    "randomEventDialogueGroupConfig_11.91": "烤章鱼",
    "messageInitNick_8520": "八月的奇迹",
    "randomEventDialogueGroupConfig_11.90": "章鱼丸",
    "messageInitNick_8523": "无语草莓",
    "randomEventDialogueGroupConfig_11.93": "你还要想想吗？",
    "messageInitNick_8522": "世俗的欲望",
    "randomEventDialogueGroupConfig_11.92": "章鱼烧",
    "messageInitNick_8529": "黑白年代",
    "messageInitNick_8528": "无线连接者",
    "22_10": "领取奖励",
    "22_11": "每日三发",
    "ancientGeneConfigDescription_47": "每{p1}秒，对血量最高和最少的敌方怪兽造成攻击力×{?}%的伤害",
    "randomEventDialogueGroupConfig_59.15": "不知道是突然而至的异象，还是突然降临的奇迹，一扇通往雪山的传送门在你面前打开了。",
    "ancientGeneConfigDescription_46": "谜之生物在场时，己方怪兽的增益效果被清除时，回复{?}能量，冷却时间{p1}秒",
    "randomEventDialogueGroupConfig_59.14": "根据你的判断，去往无归雪山的道路异常艰险，仅凭一兽之力根本不可能完成任务。",
    "randomEventDialogueGroupConfig_59.17": "你顺利将雪朵摘下来并送回咻咻的巢穴。你独享了全部赏金，大家都很感激你。",
    "ancientGeneConfigDescription_48": "谜之生物在场时，己方怪兽破韧提升{?}",
    "randomEventDialogueGroupConfig_59.16": "前去摘取雪朵",
    "ancientGeneConfigDescription_43": "谜之生物攻击力提升{?}%，普通攻击会直接击破敌方原生族怪兽，冷却时间{p1}秒",
    "randomEventDialogueGroupConfig_11.77": "转",
    "randomEventDialogueGroupConfig_59.19": "你与智者讨论了一番，虽然觉得很艰难，但还是决定要试一试。",
    "ancientGeneConfigDescription_42": "谜之生物在场时，己方怪兽坚韧提升{?}",
    "randomEventDialogueGroupConfig_11.76": "等下被骂了可别怪我不提醒你。",
    "randomEventDialogueGroupConfig_59.18": "离开",
    "ancientGeneConfigDescription_45": "战斗开始时，谜之生物绑定己方血量最高的近战怪兽（没有则不绑定），该怪兽进入谜物状态（代替谜之生物承受伤害，普通攻击附带谜之生物的最大血量×{?}%的伤害，冷却时间{p1}秒）",
    "randomEventDialogueGroupConfig_11.79": "唉，都说没有经过专业训练不要转这么久的啦，很容易晕倒的。",
    "ancientGeneConfigDescription_44": "谜之生物在场时，己方怪兽破韧和坚韧提升{?}%",
    "randomEventDialogueGroupConfig_11.78": "离开",
    "themeCardPackDes_18005": "在记叙一切之前，请允许我做个自我介绍，我来自喧哗海岸，KB侠众多分支之一，同族一般叫我K。\\n这份记录的制作并非我贪慕虚名，或是想要在死后留下什么。\\n我只是希望不再有遭遇那一切的怪兽。只有知道我是谁，才有可能让您在陷入深渊前止步。我将成为噩梦前最显眼的警示。我想，我的现状应该足够让大多数怪兽收起好奇心，不去深究那一切，最后顺利回归平凡的日常。\\n早在着手记录前，我就已经处在崩溃和癫狂的边缘，据我的同族所言，我经常会发出歇斯底里的嚎叫而不自知，又或是在原地呆立很久，全身僵直只有面容扭曲无比。\\n以下是警告！请您在遇到任何怪异的事情时都不要在意，尽快忘记！尽可能忘记，竭尽全力去忘记！您需要记得的有且只有这一点。\\n接下来是我一个自私的请求，劳烦您销毁这份记录，因为我不太确信自己还能否支撑到那时候。更加不能继续往下阅读！因为这是我最后徒劳的挣扎，是我仅能抓住的最后一根稻草。若您执意往下看，那我仍恳请您在阅读后将之销毁，并忘掉看过的一切。\\n我已竭力抹去掉口舌不可高呼的名号，眼耳不应见闻的情状，以及不能提及之所在。那么，开始吧……",
    "messageInitNick_8514": "咸甜花生酱",
    "randomEventDialogueGroupConfig_11.84": "表示下次再去",
    "messageInitNick_8513": "卷王",
    "randomEventDialogueGroupConfig_11.83": "进店",
    "ancientGeneConfigDescription_41": "谜之生物死亡后，己方全体怪兽提升攻击力{?}%，并获得无敌效果，持续{p1}秒",
    "messageInitNick_8516": "炒面射手",
    "randomEventDialogueGroupConfig_11.86": "要不要给点提示呢？",
    "randomEventDialogueGroupConfig_59.20": "出发",
    "ancientGeneConfigDescription_40": "每攻击{p1}次，造成攻击力×{p2}%的伤害并使血量回复效果降低{?}%，持续{p3}秒",
    "messageInitNick_8515": "卖茶叶蛋的",
    "randomEventDialogueGroupConfig_11.85": "转圈的时候能够保持思考是最重要的！#让我出一个谜语考考你。在决斗中段，卡雷多哈特攻击卡雷多哈特，打一食物。",
    "messageInitNick_8510": "那边怎么说",
    "randomEventDialogueGroupConfig_11.80": "你……",
    "randomEventDialogueGroupConfig_59.22": "离开",
    "randomEventDialogueGroupConfig_59.21": "无归雪山的路极其难行，很快一天过去了，希望也随之消失。任务失败了。",
    "messageInitNick_8512": "浮生物语",
    "randomEventDialogueGroupConfig_11.82": "等等，看我的转圈填坑法，只要在飞出来的土地上转上一会，就可以填完。这里大尘，去店里躲躲顺便看看吧。",
    "randomEventDialogueGroupConfig_59.24": "立刻出发",
    "messageInitNick_8511": "熟悉的天花板",
    "randomEventDialogueGroupConfig_11.81": "在转圈这件事上，我绝不认输，快出全力来比比！",
    "randomEventDialogueGroupConfig_59.23": "怪兽们听到你的话之后，纷纷恍然大悟。虽然一只怪兽办不到，但一起合作就有可能办到。一阵激烈的讨论后，大伙定下了最终计划，对无归雪山地形最熟悉的疾风兔在后方指挥，对危险最为敏感的利爪狼群则先行出发探路，沿途分多段更换骑兵的马，力求减少每个环节的耗时。",
    "messageInitNick_8518": "咕咕门传人",
    "messageInitNick_8517": "茄子兽",
    "messageInitNick_8519": "镜子剑客",
    "themeCardPackDes_18010": "为了能更好地说清楚来龙去脉，还是需要稍微再交代一下我的一些情况，我生来就觉得自己与众不同，虽然这倒是和大多数同族类似。\\n它们总是在不停地向周围的怪兽诉说内心的种种，恨不得将不知哪里冒出来的想法一股脑地倾倒出去。当一群这样的怪兽聚在一起，便成就了喧哗海岸的喧哗，它们总能吵起来，随时随地谁都可以。要在它们的交锋中找到一丝半点理性，比叉叉进化还难百倍。\\n我则更喜欢观察和记录，我的观察对象通常是身边的怪兽。我有一个古怪的习惯，每次遇到从未见过的怪兽我都会记录下来，关于见过的怪兽的新观察则在对应的条目内补充。那就是我的全部乐趣所在。你知道吗！仁拳大师大多喜欢俯卧着睡觉，除非地上有个坑~龙皮匠会跳舞！零的嘴巴就是下面那个，我见过它吃东西！溜溜是能站起来的，在某些血脉喷张的时刻~\\n我曾以为，正是我的爱好让它找上了我，后来我却可笑地发现，一切不过是我的妄想，仅仅因为解释能带来安心感，给我安慰。特意补充这一切，只是想要说明，我是抱有何种天真和幼稚与之相遇的。",
    "themeCardPackDes_18015": "在我对恐怖这类状况有所感知前，我一直认为在我脚下的这片大陆，恐怖是没有支点的。原因有二，其一，每一只怪兽身上都极其诡秘的一面，一些怪兽，它们存在的本身就无比荒诞离奇，怪兽也大都以之为然。其二，并非所有怪兽都拥有理性，它们大多不会以之为意，即便意识到怪异之处也不会深究。\\n可在与它初遇以后，我就知道我错得离谱……我开始羡慕那些具备理性但不多的怪兽，因为那会是它们平稳度过一生的保障。\\n您注意过荧灵熔琥形态下，那个半透明的暗橙色球体吗？还有里头不时扭动的怪异东西~那天我正在远处观察时，正巧碰见一头路过的塞尔雷特，它瞬间抓住了我所有的注意力，我就这样注意到了一个不该注意的该死的点。",
    "messageInitNick_8503": "一定要坚强啊",
    "messageInitNick_8502": "无所谓了",
    "messageInitNick_8505": "酱香饼大师",
    "messageInitNick_8504": "插线板剑客",
    "randomEventDialogueGroupConfig_59.11": "作为一个经验老到的镖客，你很快就来到了咻咻的巢穴，听到了一阵啜泣声，一只呜呜祖拉似乎哭到泪都干了。还有一只智者在巢穴旁边来回踱步。",
    "randomEventDialogueGroupConfig_59.10": "先去它家探探虚实",
    "messageInitNick_8501": "路痴",
    "randomEventDialogueGroupConfig_59.13": "默默祈求",
    "messageInitNick_8500": "降压玩具",
    "randomEventDialogueGroupConfig_59.12": "上前询问情况",
    "messageInitNick_8507": "别动我的心",
    "messageInitNick_8506": "不敢求婚",
    "messageInitNick_8509": "黑白的色调",
    "messageInitNick_8508": "专治各种不服",
    "themeCardPackDes_18020": "后续的记录将进一步介绍当时的情况，可那时的记忆不知为何非常模糊和混乱，因此我只能循着记录作为补充。\\n不知道您是否仔细观察过塞尔雷特，它并非三头怪兽，别在腰间的两个头是它抱着塞尔和雷特，塞尔和雷特手里各拿着一个小袋子，里头装的是它们的武器——遗物。可我那时见到的塞尔雷特却是离奇的两手空空！于是我便悄悄跟了上去……\\n我尾随着塞尔雷特来到一处阴森山谷，它似乎相当匆忙，以至于我后面干脆直直走在它后头，它也没注意到我。\\n阴天的太阳悄无声息地坠入地平，难以形容的声响四处回荡。不明所以的黑色物质覆满了原本坐落在山谷一侧洞穴的塞尔雷特聚落，如同一颗蠕动的巨瘤。两手空空的塞尔雷特加快了脚步，我们很快就来到了聚落里，慌乱的、颤抖的、胡乱攻击的、胡言乱语的，行色各异的塞尔雷特在其中不停乱窜，海水和作呕的混合味道萦绕不散。不久后我才意识到，地上铺满的是塞尔和雷特胡乱丢下的遗物，是的，它们发起攻击……那是谁，那是一只我未曾见过的怪兽！它浑身发█，背着一个███的物体，有着█鳍触█混█状的半身，它的一只██被水流所包裹，面部是难以名状的一片模糊。\\n我趁乱躲在一处颓败的灌木后，看着眼前发生的一切，竟不知为何颤抖了起来，我强忍着想逃的冲动记录着，直到窒息感突如其来，我失去了意识……",
    "randomEventDialogueGroupConfig_11.99": "想好了吗？",
    "randomEventDialogueGroupConfig_11.98": "啊，原来你是故意要跑掉的！",
    "themeCardPackDes_18025": "后来，我是在塞尔雷特的聚落中醒来的，一只塞尔雷特正和它抱着的两只小家伙看着我，四只眼睛一起，它的体型比之前看到的塞尔雷特稍小一些，云朵状的毛发上绑着一些藤蔓，我可以轻易从它黑色的肌肤中看到疲惫的黑眼圈。\\n塞尔最先说话，然后又是塞尔雷特，又是雷特，我有点目光无措，不知该看谁。\\n最近聚落里发生了很多怪事！是呀是呀！塞尔和雷特不见了！雷特和塞尔不见了！急！大家都很急！很急嗯！四处找呀找呀！然后它们突然又回来了！大伙都回来了！可是！不知道发生什么就打起来了，满地都是遗物！袋子都瘪了！记不清！但又总觉得忘记了什么，又想不起来！忘了忘了！但是害怕！害怕！后来我们发现了你，想着也许你会知道些什么！知道什么！后来大家疯了！塞尔雷特疯了！它们一直在画圈圈！漩涡！\\n它们自顾自地一边说着一边将我拉到了外头，只见满地密密麻麻都是大小不一深深浅浅的漩涡刻痕。我顾不得太多，尖叫着冲了出去……",
    "10_10": "暂无防守记录",
    "ancientGeneConfigDescription_18": "谜之生物每攻击{p1}次，造成攻击力×{?}%的范围伤害（{p2}码）",
    "ancientGeneConfigDescription_17": "谜之生物移动速度变为0，攻击力增加{?}%",
    "ancientGeneConfigDescription_19": "谜之生物每攻击{p1}次，造成攻击力×{?}%的伤害并清除敌方怪兽所有增益效果",
    "ancientGeneConfigDescription_14": "谜之生物每{p1}秒，使敌方血量最高的怪兽受到伤害提升{?}%，持续{p2}秒",
    "ancientGeneConfigDescription_13": "谜之生物每{p1}秒，使己方攻击力最高的怪兽攻击力提升{?}%，持续{p2}秒",
    "ancientGeneConfigDescription_16": "谜之生物每攻击{p1}次，造成攻击力×{?}%的伤害并造成封印效果，持续{p2}秒",
    "ancientGeneConfigDescription_15": "谜之生物每{p1}秒，击退最接近己方的敌方怪兽{?}码",
    "ancientGeneConfigDescription_10": "谜之生物在场时，己方远古族怪兽攻击力和体力提升{?}%",
    "ancientGeneConfigDescription_12": "谜之生物每{p1}秒，为己方血量百分比最少的怪兽回复最大血量×{?}%的血量",
    "ancientGeneConfigDescription_11": "谜之生物每{p1}秒，对敌方血量最少的怪兽造成攻击力×{?}%的伤害",
    "messageInitContent_6046": "是不是有点狠",
    "messageInitContent_6045": "啊，我感受到了，这",
    "messageInitContent_6048": "在线收藏一个伤心的人",
    "messageInitContent_6047": "我也想获得这种安全感",
    "messageInitContent_6049": "冲呀",
    "messageInitContent_6040": "这水上的电，是认真的吗",
    "messageInitContent_6042": "花丸子你头顶是不是都是口水",
    "messageInitContent_6041": "大对了总算！我哭死",
    "messageInitContent_6044": "在留言板上画了个鸭",
    "messageInitContent_6043": "电麻了",
    "messageInitContent_6057": "记得提钢",
    "messageInitContent_6056": "就是这么自信",
    "messageInitContent_6059": "剑人",
    "messageInitContent_6058": "又巨人",
    "messageInitContent_6051": "看哭了",
    "messageInitContent_6050": "全勤荆姐",
    "messageInitContent_6053": "超级加倍",
    "messageInitContent_6052": "劳模好嘛，",
    "messageInitContent_6055": "你的关节有点松弛",
    "messageInitContent_6054": "全勤尸狂公",
    "ancientGeneConfigDescription_39": "每{p1}秒，复活一只已死亡的战力最高的怪兽（战力相同则复活站位序号较小的），并获得谜之生物最大血量*{?}%的护盾，持续{p2}秒",
    "ancientGeneConfigDescription_36": "每{p1}秒，创造一个妄焱·领域（{p2}码），进入领域的敌方怪兽每{p3}秒受到谜之生物攻击力×{?}%的伤害，持续{p4}秒",
    "ancientGeneConfigDescription_35": "谜之生物血量大于等于{p1}%时为近战怪兽，血量低于{p1}%时变为远程怪兽，射程{?}，攻击速度{p2}",
    "ancientGeneConfigDescription_38": "谜之生物在场时，己方怪兽真实伤害和生物屏障提升{?}%",
    "ancientGeneConfigDescription_37": "血量小于{p1}%时，己方全体怪兽每{p2}秒回复谜之生物最大血量*{?}%的血量",
    "ancientGeneConfigDescription_32": "谜之生物在场时，己方怪兽攻击力和体力提升{?}%",
    "ancientGeneConfigDescription_31": "血量大于{p1}%时，己方全体怪兽每{p2}秒获得谜之生物攻击力*{?}%的护盾，持续{p3}秒",
    "ancientGeneConfigDescription_34": "每攻击{p1}次，己方攻击力最高的怪兽回复{?}能量",
    "ancientGeneConfigDescription_33": "每{p1}秒，向前射出崩坏弹，对敌方怪兽造成攻击力×{?}%的范围伤害（{p2}码）",
    "hintName_1005": "部落纷争",
    "messageInitContent_6068": "啊这",
    "messageInitContent_6067": "你怎么知道的",
    "ancientGeneConfigDescription_30": "谜之生物普通攻击会使敌方怪兽眩晕（伤害，移动速度，攻击速度变为0），持续{?}秒，冷却时间{p1}秒",
    "hintName_1006": "部落战",
    "messageInitContent_6069": "崩坠之地常驻怪兽",
    "messageInitContent_6060": "一人血书求污妖王手办",
    "messageInitContent_6062": "好墙",
    "messageInitContent_6061": "？？？？？？",
    "messageInitContent_6064": "靓仔在此",
    "messageInitContent_6063": "在闹了",
    "messageInitContent_6066": "尊嘟假嘟",
    "messageInitContent_6065": "怪兽很大",
    "ancientGeneConfigDescription_29": "谜之生物普通攻击回复攻击力×{?}%的血量",
    "ancientGeneConfigDescription_28": "谜之生物普通攻击变为真实伤害，攻击力增加{?}%",
    "ancientGeneConfigDescription_25": "谜之生物血量每降低{p1}%，受到伤害降低{?}%",
    "ancientGeneConfigDescription_24": "谜之生物血量每降低{p1}%，攻击力提高{?}%",
    "ancientGeneConfigDescription_27": "谜之生物普通攻击对远程怪兽伤害提升{?}%",
    "ancientGeneConfigDescription_26": "谜之生物普通攻击对近战怪兽伤害提升{?}%",
    "ancientGeneConfigDescription_21": "谜之生物变为远程怪兽，射程{?}，攻击速度{p1}次/秒",
    "ancientGeneConfigDescription_20": "谜之生物移动速度提升{?}%，攻击力增加{?}%",
    "ancientGeneConfigDescription_23": "谜之生物变为远程怪兽，射程{?}，攻击速度{p1}次/秒",
    "ancientGeneConfigDescription_22": "谜之生物变为远程怪兽，射程{?}，攻击速度{p1}次/秒",
    "messageInitContent_6079": "2号位好危险",
    "messageInitContent_6078": "吃它一锤",
    "messageInitContent_6071": "荆分身术",
    "messageInitContent_6070": "懂了荆姐就是这里的领主",
    "messageInitContent_6073": "尸狂的头就是它的拳头",
    "messageInitContent_6072": "混入了桐仁",
    "messageInitContent_6075": "有毒",
    "messageInitContent_6074": "好大只网吧",
    "messageInitContent_6077": "再大点",
    "messageInitContent_6076": "鼠标是尾巴",
    "22_2065": "击破数",
    "22_81": "积分榜",
    "22_2066": "挑战",
    "22_82": "段位榜",
    "22_2067": "累计伤害比拼",
    "22_83": "结算后本次挑战结束，需要再次消耗一创币才能重新挑战，是否立即结算？",
    "22_2068": "累计伤害",
    "22_85": "天",
    "22_86": "1.活动期间，每日开启两个活动",
    "22_2063": "击破数量比拼",
    "22_87": "1.七日七发共有7发奖励，活动期间，每日登录即可自动解锁奖励，点击奖励即可领取\\n2.活动关闭后，未领取的奖励将无法领取，各位探索者记得及时领取奖励哟",
    "messageInitContent_6080": "一姐是荆棘一哥是冥龙王",
    "22_2064": "我的排名",
    "22_88": "许愿",
    "22_2060": "天",
    "22_80": "通关榜",
    "messageInitContent_6089": "想发电",
    "22_78": "退出小游戏进度将会重置，是否退出？",
    "messageInitContent_6082": "huh猫",
    "22_79": "击破榜",
    "messageInitContent_6081": "这张地图让我学会了点下面",
    "messageInitContent_6084": "是冥龙的土地",
    "messageInitContent_6083": "是女仆！",
    "22_2058": "高级战令",
    "messageInitContent_6086": "划水中",
    "22_2059": "解锁高级战令",
    "messageInitContent_6085": "woooooow",
    "messageInitContent_6088": "喜感",
    "messageInitContent_6087": "躺会待会见",
    "22_2076": "任务",
    "22_92": "受邀与你绑定的探索者",
    "22_2077": "福利",
    "22_93": "探索者等级",
    "22_2078": "特权",
    "22_94": "受邀请的探索者信息更新可能存在一定延迟",
    "22_2079": "回归奖励",
    "22_95": "分享邀请",
    "22_2072": "压制",
    "22_96": "1.点击分享按钮，即可查看并向其他探索者分享邀请码\\n2.输入邀请码后，即可与对应探索者进行绑定\\n3.每位探索者只能输入1次邀请码，接受1位探索者邀请进行绑定，大于等于30级的探索者将无法接受邀请被其他探索者绑定\\n4.受邀绑定的探索者到达特定条件后，其邀请者将根据积分领取相应的奖励\\n5.每位探索者最多只能与其他10位探索者绑定，绑定后无法解除",
    "22_2073": "已压制",
    "22_97": "输入邀请码",
    "22_98": "邀请码",
    "messageInitContent_6091": "休息一会",
    "22_2075": "奖励",
    "22_99": "<face color=#f5e4bf dilate=0.52 softness=0.07>眼前一黑，扫码起飞！扫描二维码下载游戏，点击活动-创友招募输入<face color=#feba29 dilate=0.52 softness=0.07>邀请码</face>，就可以与我一起“变态”超进化！</face>",
    "messageInitContent_6090": "我的心永远在下一关",
    "22_2070": "激活",
    "22_2071": "已激活",
    "22_90": "剩余：{1}",
    "22_91": "累计获得积分",
    "22_89": "剩余次数：{1}",
    "messageInitContent_6093": "如同飞舞的樱花",
    "messageInitContent_6092": "终究还是错付了",
    "messageInitContent_6095": "柠檬树下你和我",
    "messageInitContent_6094": "樱花树下你和我",
    "22_2069": "词缀调整点数",
    "messageInitContent_6097": "你也想放假吗 荆",
    "messageInitContent_6096": "猫猫摇头",
    "messageInitContent_6099": "买买买",
    "messageInitContent_6098": "为什么这个场地对自己不生效",
    "22_2087": "每日0点刷新",
    "22_60": "去完成",
    "22_61": "领取",
    "22_62": "积分{1}",
    "22_2083": "购买经验",
    "22_63": "拼二大作战得分{1}可购买",
    "22_2084": "经验值 {1}/{2}",
    "22_64": "1.{1}庆典将会定期开放各种活动\\n2.{2}界面可查看各种活动的开启时段\\n3.部分活动需到达一定的探索者等级才能参与",
    "randomEventDialogueGroupConfig_11.29": "它突然愣住了，看似看着你又似在思考着什么。",
    "22_2085": "每日任务",
    "22_65": "1.新觉醒怪兽「创晓」降临，可前往造唤台每期一创进行造唤\\n2.怪兽信息可查看「创晓」的属性、定位、技能、勿语，评点按钮可查看探索者对「创晓」的评点，领域按钮可尝试挑战「创晓」的领域副本\\n3.试战映像可身临其境感受「创晓」的碰撞……艺术（不是\\n4.完成「创晓」的专属任务可领取相应的奖励",
    "22_2086": "挑战任务",
    "22_66": "1.创世商店的商品需消耗相应数量的创世一闪进行购买\\n2.每个商品均有限购次数",
    "randomEventDialogueGroupConfig_11.26": "拒绝它",
    "22_2080": "启程奖励",
    "randomEventDialogueGroupConfig_11.25": "再绕一次",
    "22_2081": "等级",
    "randomEventDialogueGroupConfig_11.28": "绕个星形",
    "22_2082": "循环奖励",
    "randomEventDialogueGroupConfig_11.27": "它看你看得更加入迷了。",
    "randomEventDialogueGroupConfig_11.22": "强行突破",
    "randomEventDialogueGroupConfig_11.21": "它开始绕着你不停打转，让你无法离开。",
    "randomEventDialogueGroupConfig_11.24": "能不能把刚才的再绕一次，我要学新的绕法！",
    "randomEventDialogueGroupConfig_11.23": "它跟着你的动作慢慢地绕着你一下，又一下。",
    "randomEventDialogueGroupConfig_11.31": "转身离开",
    "randomEventDialogueGroupConfig_11.30": "绕个三角形",
    "22_56": "怪兽信息",
    "22_57": "试战映像",
    "22_58": "每期一创",
    "22_59": "专属任务",
    "22_70": "1.活动期间（活动最后一天仅供查看信息），每日可在特定时段进行匹配\\n2.每次挑战需消耗1个一创币，每次挑战将会在失败次数到达3或点击立即结算后结束\\n3.活动期间每日赠送1个一创币，赠送或购买的一创币仅可用于当日挑战，次日清0\\n4.本日挑战的最终战绩为当日单次挑战中胜场最多的一次战绩，即最佳战绩。\\n5.本期活动中，每日的最佳战绩相加即为本赛季战绩，赛季排行榜将按本赛季战绩排名\\n6.一创到底可自由选择系统预设的怪兽、元核和神灵进行战斗，但不可对其进行培养，战斗中不享受起源基石和漆黑之根的属性增益，可使用已拥有的怪兽形态，但不享受形态属性增益\\n7.本赛季单次挑战中胜利场次首次达到1、3、5、7、9，可分别领取对应的档位奖励",
    "22_2099": "当前制作的菜品",
    "22_71": "1.荣耀里程碑将展示暴走旷野击破榜、部落冒险通关榜、斗技场积分榜、凿星裂痕通关榜、起源殿段位榜排行前三的探索者\\n2.首个探索者、队伍或部落达成排行榜目标后即可解锁相应的全服奖励，全服探索者均可领取该奖励",
    "22_72": "1.暴走旷野击破数最先到达相应目标的探索者即可进入暴走旷野击破榜，并解锁相应的全服奖励，全服探索者均可领取该奖励\\n2.若两名探索者的暴走旷野击破数一致，排名则按暴走旷野击破数达成时间排序，达成更早的排名更高",
    "22_73": "1.部落冒险通关数最先到达相应目标的部落即可进入部落冒险通关榜，并解锁相应的全服奖励，全服探索者均可领取该奖励\\n2.若两个部落的部落冒险通关数一致，排名则按部落冒险通关数达成时间排序，达成更早的排名更高",
    "22_2094": "奖励列表",
    "22_74": "1.斗技场积分最先到达相应目标的探索者即可进入斗技场积分榜，并解锁相应的全服奖励，全服探索者均可领取该奖励\\n2.若两名探索者的斗技场积分一致，排名则按斗技场积分达成时间排序，达成更早的排名更高",
    "randomEventDialogueGroupConfig_11.19": "攻其上路",
    "22_2095": "解锁全部等级最终可获得",
    "22_75": "1.凿星裂痕最先到达通关目标的队伍即可进入凿星裂痕通关榜，并解锁相应的全服奖励，全服探索者均可领取该奖励\\n2.若两个队伍的凿星裂痕通关关卡一致，排名则按凿星裂痕通关关卡达成时间排序，达成更早的排名更高",
    "randomEventDialogueGroupConfig_11.18": "攻其下路",
    "22_2096": "解锁",
    "22_76": "1.起源殿最先到达目标段位的探索者即可进入起源殿段位榜，并解锁相应的全服奖励，全服探索者均可领取该奖励\\n2.若两名探索者的起源殿段位一致，排名则按起源殿段位达成时间排序，达成更早的排名更高",
    "22_2097": "已解锁",
    "22_77": "1.点击地鸣上的节点可查看其位置，并跳转至世界地图中相应的节点位置\\n2.解锁节点可提升地鸣进度\\n3.提升地鸣进度可领取相应的奖励",
    "22_2090": "回归信",
    "randomEventDialogueGroupConfig_11.15": "继续无视它离开",
    "22_2091": "点击查看",
    "randomEventDialogueGroupConfig_11.14": "它跟了上来，又围着你转了一圈，然后停在了你面前。",
    "22_2092": "喵~",
    "randomEventDialogueGroupConfig_11.17": "它也摆出了防守的姿势，继续绕着你踱步。",
    "22_2093": "<face color=#4b160f dilate=0.52 softness=0.07>亲爱的</face><face color=#d02020 dilate=0.52 softness=0.07>{1}：\\n</face><face color=#4b160f dilate=0.52 softness=0.07>您回来啦！（大力贴贴）喵响等你等了</face><face color=#d02020 dilate=0.52 softness=0.07>{2}</face><face color=#4b160f dilate=0.52 softness=0.07>天了喵！\\n本喵还记得</face><face color=#d02020 dilate=0.52 softness=0.07>{3}</face><face color=#4b160f dilate=0.52 softness=0.07>，您初次来到超进化大陆，和怪兽们一起将七王和灾厄“创”飞，将领地建设起来给了怪兽们一个家！您家的</face><face color=#d02020 dilate=0.52 softness=0.07>{4}</face><face color=#4b160f dilate=0.52 softness=0.07>位怪兽都还在这里，默默地守护着您的领地，因为他们相信您总有一天会回来，再一次和他们一起突破上限，不断进化，“创”飞一切！\\n嗷对了！这是大家为您准备的礼物，现在就交给您了喵！\\n呐，我们说定啦，以后也要一直在一起噢！\\n（用尾巴拉钩，耳朵也勉为其难给您摸一下下吧！）</face>",
    "randomEventDialogueGroupConfig_11.16": "问问它在干嘛",
    "randomEventDialogueGroupConfig_11.11": "它察觉到了什么，神情警惕了起来。",
    "randomEventDialogueGroupConfig_11.10": "再绕个正方形 ",
    "randomEventDialogueGroupConfig_11.13": "准备发动特殊攻击",
    "randomEventDialogueGroupConfig_11.12": "准备发动普通攻击",
    "randomEventDialogueGroupConfig_11.20": "可恶……这都能打中我，啊。",
    "22_67": "1.活动期间，完成日任务或总任务即可获得相应数量的进步\\n2.消耗1进步可让叉叉在一步之遥地图上前进一步并获得相应的奖励",
    "22_68": "1.个人地图探索度到达一定百分比后可以领取相应的探索度贡献，增加全服累计贡献\\n2.全服累计贡献到达一定数量时，全服探索者均可领取相应奖励",
    "22_69": "1.每次可选择上下左右其中一个方向滑动，每次滑动，所有方块都会向滑动方向靠拢直到边缘阻隔，当相同数字的方块在移动中碰撞后，会合并为一个方块且数字变为两者之和，同时获得相应的得分，每次滑动都会有一个数字为2的新方块在随机空格子中出现\\n2.当所有格子都被填满且无法合并时，游戏结束并结算得分\\n3.活动期间，可重复进行游戏，到达一定分数后可以领取对应的奖励\\n4.活动期间，当日可领取奖励、当日最高分数将会每日进行重置，各位探索者记得及时领取奖励哟",
    "messageInitNick_4523": "外向孤独患者",
    "messageInitNick_4522": "不倾国的女子",
    "messageInitNick_4521": "吃货萌比",
    "messageInitNick_4520": "残风冷月",
    "messageInitNick_4527": "宠臣",
    "messageInitNick_4526": "鼻涕大佬",
    "messageInitNick_4525": "懒喵喵",
    "messageInitNick_4524": "尖椒萝卜",
    "messageInitNick_4529": "窗外的晴天",
    "messageInitNick_4528": "水果观察者",
    "messageInitNick_4512": "绝对的真心",
    "messageInitNick_4511": "纯粹白痴",
    "messageInitNick_4510": "修行者",
    "messageInitNick_4516": "倚栏听风叙",
    "messageInitNick_4515": "魔女的黑店",
    "messageInitNick_4514": "甜咸薯片",
    "messageInitNick_4513": "大时光",
    "messageInitNick_4519": "量子手表",
    "messageInitNick_4518": "刀恋孤光",
    "messageInitNick_4517": "鸡头贼稳",
    "messageInitNick_4501": "精神王者",
    "messageInitNick_4500": "龙眼魔法",
    "messageInitNick_4505": "一百香果",
    "messageInitNick_4504": "你好幼稚",
    "messageInitNick_4503": "千里追魂",
    "messageInitNick_4502": "迷人小祖宗",
    "messageInitNick_4509": "断翅天使",
    "messageInitNick_4508": "引战先驱",
    "messageInitNick_4507": "掩护我撤退",
    "messageInitNick_4506": "假如有明天",
    "randomEventDialogueGroupConfig_54.16": "愤怒撕碎",
    "randomEventDialogueGroupConfig_54.15": "悬赏令不知道怎样地，又扑到你怀里。",
    "randomEventDialogueGroupConfig_54.14": "转身离开",
    "randomEventDialogueGroupConfig_54.13": "追上去抓住悬赏令",
    "randomEventDialogueGroupConfig_54.12": "悬赏令在风沙中扭动，仿佛一位起舞中的大漠舞姬。",
    "randomEventDialogueGroupConfig_54.11": "狠心甩开",
    "randomEventDialogueGroupConfig_54.10": "悬赏令似乎对你依依不舍，又被风儿吹到了你的怀里。",
    "realmConfigDes_182": "魅妆2",
    "realmConfigDes_181": "魅妆1",
    "realmConfigDes_184": "魅妆4",
    "realmConfigDes_183": "魅妆3",
    "randomEventDialogueGroupConfig_54.19": "偏偏就在你快要抓住它的时候，一股强风将它吹到了远方。",
    "randomEventDialogueGroupConfig_54.18": "离开",
    "realmConfigDes_180": "Joker5",
    "randomEventDialogueGroupConfig_54.17": "悬赏令的碎片融入了风沙，很快便消失不见。",
    "realmConfigDes_189": "∞4",
    "realmConfigDes_186": "∞1",
    "realmConfigDes_185": "魅妆5",
    "realmConfigDes_188": "∞3",
    "realmConfigDes_187": "∞2",
    "realmConfigDes_193": "天枢震3",
    "realmConfigDes_192": "天枢震2",
    "realmConfigDes_195": "天枢震5",
    "realmConfigDes_194": "天枢震4",
    "realmConfigDes_191": "天枢震1",
    "realmConfigDes_190": "∞5",
    "realmConfigDes_197": "螺旋巽2",
    "realmConfigDes_196": "螺旋巽1",
    "realmConfigDes_199": "螺旋巽4",
    "realmConfigDes_198": "螺旋巽3",
    "realmConfigDes_160": "白昼5",
    "realmConfigDes_162": "玖璃2",
    "realmConfigDes_161": "玖璃1",
    "realmConfigDes_168": "冰霓3",
    "realmConfigDes_167": "冰霓2",
    "realmConfigDes_169": "冰霓4",
    "realmConfigDes_164": "玖璃4",
    "realmConfigDes_163": "玖璃3",
    "realmConfigDes_166": "冰霓1",
    "realmConfigDes_165": "玖璃5",
    "realmConfigDes_171": "幻1",
    "realmConfigDes_170": "冰霓5",
    "realmConfigDes_173": "幻3",
    "realmConfigDes_172": "幻2",
    "realmConfigDes_179": "Joker4",
    "realmConfigDes_178": "Joker3",
    "realmConfigDes_175": "幻5",
    "realmConfigDes_174": "幻4",
    "realmConfigDes_177": "Joker2",
    "realmConfigDes_176": "Joker1",
    "11_2043|L": "匹配成功",
    "themeCardPackDes_27025": " “孩子们，生日快乐哦~”\\n超进化大陆的星空是我们的第一眼。\\n这个说法可能有点怪，但我们确实是在去收集星灵族样品的路上得到这个她送的礼物。\\n那个瞬间甚至比我初次活动时还感动。\\n那是一个在木偶族无底墓穴里捞到的东西，改造后变成了【观星镜组】，能够将星空巨大化！\\n我们要观测星图的秘密解读星灵族早期的落点，然后再搜寻我们需要的古星灵碎屑。\\n就是她一路拿着【观星镜组】看着天没看路，一头栽到了陨星坑了……\\n那会，还有一位有着粉色双眸的怪兽飞过来，问她是不是需要帮忙呢。\\n虽然中途有点小意外，但已经算是最非常顺利的了，就这样，我们最后一个伙伴小枪的制作马上就要完成了！\\n只是没想到命运就跟那闪烁不定的星空一样，在未来给我们开了个大玩笑。",
    "messageInitContent_2119": "有没有想到污妖王可能是只细心的怪兽。",
    "messageInitContent_2118": "因为够污，所以营养好，所以长得好。",
    "themeCardPackDes_27020": "她是直接走进木偶族的无底之墓的。\\n那时候里头已经没有徘徊的木偶族亡灵。\\n木偶族并不像尸鬼族那样会有专门保存族中怪兽尸骸的地点。\\n她上次本来是想搞个跟腐食者差不多样子的构具，到尸鬼族的墓穴“拿”点“样品”的。结果它把腐食者的体型搞错了，弄成了大头鬼……虽然摔地上的时候也阴差阳错拿到样品了……\\n也不像是龙族那样，会各自特地找个隐秘的地方死去。\\n说起龙族，她上次去黯炎魔龙的宝库巢时，也干过蠢事，明明要查的东西都查好了，结果工具给落下了……\\n她就是个天才冒失鬼，还是该说冒失鬼天才？\\n我和另外一个构具就是在那之后被打造出来的。\\n她叫我小甲，管另外一个家伙叫小炮。\\n到木偶族的无底之墓一程，她就是带着我们一起的。\\n她全程就一直……\\n“哇……天……”\\n“这个部件好精密！快过来这边！”\\n“这个好厉害！”\\n“这个又是什么的组件，天哪！快照照这里。”\\n她说木偶族并不会去特地守护同族的残骸，或者说很可能是根本就没有这方面的概念或想法。\\n总之，木偶族的样品并不难找，反倒是因为里头太多神奇的东西，让她在里头泡很长一段时间，导致她的第三个孩子，也就是小链迟迟未能完成。",
    "messageInitContent_2117": "为什么没有人问问污妖王的花的保鲜秘诀",
    "messageInitContent_2116": "独角兽的头正在飞翔！头翔！",
    "messageInitContent_2115": "知趣就赶紧投降！",
    "messageInitContent_4777": "这条龙不错，给我抱起来",
    "messageInitContent_4778": "哒哒哒哒哒哒",
    "messageInitContent_4779": "站住别跑！",
    "realmConfigDes_140": "火神5",
    "messageInitContent_4780": "他的意思是喊你们别过来",
    "realmConfigDes_146": "黯灭1",
    "themeCardPackDes_15035": "思考沸体将它的推论告诉了核心沸体，它认为之前遇到那些伤势严重的怪兽，全都是这样被一些超大体型的怪兽仍进沸湖或这座岛屿上。\\n幸好这对于沸体而言，并非来到地狱，而是回家。幽狱沸体内的沸体和沸湖中的其他沸体分享着沸湖外的一切，一些曾经犹豫不决的沸体下定了决心，成为了幽狱沸体新的一员。\\n而现在，它们冒险之路上的最大障碍正是那只将它们抛到这里的超大体型怪兽。\\n思考沸体认为，要在与超大体型怪兽的对抗中获得胜利，最显而易见的策略是变成与对方一样大，这样只需要再按平日的战斗方式去应对就可以了。核心沸体回答，它发现它们在经过一定距离的移动后，部分沸体的温度就会开始飙升，但止不住得不断胀大，又导致水体变得难以控制，大家一般会先休息一会，等温度逐渐降下来后再行动。可反过来说，如果所有沸体都能进入到这种状态，变成超大体型并非什么不可能的事情。可那也意味着，沸体们需要对水体有更强和更精细的控制力，思维沸体补充道。\\n吼！这不就像一开始创造这个身体时所做的事情吗？我们不正是这样一路走来的吗！\\n核心沸体大声怒吼！所有沸体一起沸腾了起来！\\n之后是不断的失败，不断的失败，不断的改进。终于，幽狱沸体获得了“极巨化”！\\n就这样，幽狱沸体重新来到了那片陆地的岸边。这次超大体型的怪兽并没有对幽狱沸体发动攻击，反倒是向它抛出了“橄榄枝”。\\n于是核心沸体和思考沸体之间有了这样的对话。\\n“你怎么想？加入它们？还是消灭它们？如果加入了清理小体型怪兽的组织，就要负责将这里的小体型怪兽丢向靶子，也就是沸湖所在的岛屿里。”\\n“我们之前的锻炼不正是为了解决掉这只怪兽继续前进吗？”\\n“是的，可我们一旦解决了它，还留着沸湖的同伴很可能会因此失去食物来源，最终消失。”\\n“我们已经将离开牢笼的方法告诉他们了，它们如果一直不肯改变，终究也会消失不是吗？”\\n“确实我们的目标并非止步于此……”\\n……",
    "messageInitContent_4781": "糟糕了，有感觉了！心动的感觉",
    "realmConfigDes_145": "喀戎5",
    "messageInitContent_4782": "隔壁好大一个框",
    "realmConfigDes_148": "黯灭3",
    "messageInitContent_4783": "前方传送门",
    "realmConfigDes_147": "黯灭2",
    "messageInitContent_4784": "待会吃什么",
    "realmConfigDes_142": "喀戎2",
    "messageInitContent_4785": "谁刚说爱我",
    "realmConfigDes_141": "喀戎1",
    "themeCardPackDes_15030": "一只怪兽迎接了刚登上新大陆的幽狱沸体，以二话不说就发起攻击的方式。\\n那是它们曾经在无名岛屿见过很多次的怪兽，幽狱沸体立刻展开了反击，核心沸体记得很清楚，它们之前已经击败过类似的怪兽很多次了，这次只需要将上次击败对方的过程复现出来就能够再次取得胜利了。\\n本应如此，可是几番来回之后，幽狱沸体却开始落於下风，思考沸体提醒核心沸体，之前它们击败的那一只，手上并没有那根粗大的奇怪棍子，而且这一只明显更迅捷更有力，之前的经验不能完全适用了。\\n与此同时，由于新大陆地面的持续震动，对方的动作变得更加难以预测，自身的动作也更难控制。\\n幽狱沸体再一次被那根奇怪的棍子狠狠地推飞出去，对手正准备冲过来给它再来一击时，不远处突然传来了一声撼动天地的巨响，对手听到之后立刻停下攻势，慌忙转头跳入了海中。\\n大地的震感越发强烈，一只遮挡了半边天空的怪兽正朝着幽狱沸体沸体冲来，感官沸体看了好一阵才看出，这和刚刚跑掉那只怪兽长得一模一样，但体型却完全不是同一个量级的。\\n沸体们还没来得及震惊，就被那只怪兽抓起来抛出，失去控制的身体就这样穿过空中，穿过沸汽，回到沸湖，回到起点。",
    "messageInitContent_4786": "反正不是我",
    "realmConfigDes_144": "喀戎4",
    "messageInitContent_4787": "需要更换那个部件吗？",
    "realmConfigDes_143": "喀戎3",
    "messageInitContent_2125": "如果是头球，独角兽这岂不是要把球戳爆？",
    "messageInitContent_2124": "怪兽球探是吧！",
    "messageInitContent_2123": "为了咱们的队伍，你真是很努力呢",
    "messageInitContent_2122": "我觉得毁灭巨像当守门员也不错!",
    "messageInitContent_2121": "你提出的是一种很新的看法。",
    "messageInitContent_2120": "所以才把花照料得这么好吗？",
    "realmConfigDes_149": "黯灭4",
    "themeCardPackDes_27035": "虽然我们的力量远超你的想象，但似乎并不是你想要的力量。\\n“我已经没有时间重做了。为什么要和我开这种玩笑。”\\n那天你的声音和往常不太一样，不过很快又恢复了平常的语气。\\n“我已经不能再给这个世界留下什么了，但给你们准备了几份礼物。”\\n一阵漫长的黑暗过后，我们第一次拥有了各自的声音。\\n我们第一时间跑到你身边，体验着你给我们的这份礼物。\\n“以后你也可以和我们说话啦！”\\n“对呀，空气从来都不理你的，我们可不会不理你。”\\n“如果你真的非常想说话的话……也不是不行……”\\n“之后我们去哪里进行采样大冒险呢！本大爷还想再去看一次无底墓穴啊！”\\n“还有原生族和神秘的彼岸族样本没有收集呢！”\\n“你们不知道，原生族太多无法归类嘛。”\\n“那也还有双种族怪兽呀。”\\n可是你没有回答，明明你终于不用只和空气聊天了。\\n为什么你不理我们……\\n为什么你一动不动了……\\n我还有很多很多话想对你说。",
    "messageInitContent_2129": "狸猫君又再装神弄鬼了呢",
    "messageInitContent_2128": "你说得很对！但问题来了，要怎么赢呢？",
    "messageInitContent_2127": "胜利要光明正大得获得才可以！",
    "messageInitContent_2126": "你们不如把危险的草丛派去对面的草上面当卧底",
    "themeCardPackDes_27030": " “大功告成！你是小枪~”\\n“同时装备一下，啊有点紧张呢。”\\n“第一次完成测试开始，参数1没有异常……”\\n她又在自言自语了。这是她第一次测试效果的时候。\\n我和其他几个家伙有点不同，她将我穿上的时候就折腾了半天~\\n她身上的装甲就是我【尸胄鬼甲】，小甲啦~\\n【灭祖龙炮】是她手上那个有点类似龙头的家伙。\\n【偶识木链】环绕在她的头部周围。\\n【魔灵星枪】就是剩下那个很好认的枪型武器了呢。\\n这些构具的名字都是她取的，只能说她的天赋显然不在取名这方面。\\n那天测试完之后，她很久都没有说话。\\n只是在那静静地坐着……\\n而她身旁有一个造型奇特的圆柱形构具，上面的数字以固定的频率慢慢减少。",
    "messageInitContent_4788": "略略略略",
    "messageInitContent_4789": "我想！我想！",
    "realmConfigDes_151": "御空1",
    "realmConfigDes_150": "黯灭5",
    "themeCardPackDes_15025": "那是一个通体碧蓝的椭圆状生物，它舒展双臂优雅地摆动起来，幽狱沸体在大海中缓缓前行。\\n“最强”形态终于有了用武之地。\\n没有沸汽遮蔽和陆地新奇之物的吸引，巨柱下的星月似乎有一股怪异的引力。\\n幽狱沸体停下了臂摆，随着波浪微微浮动。\\n“我们真的要继续前进吗？”一只感官沸体突然打破了宁静。\\n这一问引起了更多沸体的提问，天上为什么会掉下怪兽？若陆地上还有其他别的怪兽，我们真的能够应付得了吗？最近核心沸体给出决定的时间是不是有点太长了。看天上下星星了！天空好美呀。\\n“是时候作出新的改变了，我们需要有专门的沸体去思考这些问题。继续在战斗中停在原地进行思考确实太过危险了。我打算将这个事交给今天第一只提出问题的沸体吧，以后，你不仅要提出问题，还要给出答案。”核心沸体指着第一个提问的沸体说道。\\n思考沸体打了个滚表示同意，随后陷入回忆，开始思考，从至今为止遇到的天降怪兽开始，那些怪兽大多数移动缓慢，不少有翅膀的怪兽的翅膀都被折断……它有了一个想法。\\n又漂游了好几个昼夜后，幽狱沸体来到了海的那边。",
    "messageInitContent_4791": "大伙吃饭了吗",
    "realmConfigDes_157": "白昼2",
    "messageInitContent_4792": "钢铁的逆焰龙王",
    "realmConfigDes_156": "白昼1",
    "messageInitContent_4793": "让人头大",
    "realmConfigDes_159": "白昼4",
    "messageInitContent_4794": "恶龙咆哮",
    "realmConfigDes_158": "白昼3",
    "messageInitContent_4795": "我要超梦",
    "realmConfigDes_153": "御空3",
    "themeCardPackDes_15020": "那天，“怪兽雨”再次落到陆地之上。感官沸体意外地发现了一只朝着它们冲过来的怪兽。一些沸体忍不住抖动起来，这是它们在陆地上看到的第一只会动的怪兽。\\n幽狱沸体停在了原地。\\n咕噜咕噜！什么情况？它是来给我们吃掉的吗？它是来吃掉我们的？难道是那是创造我们的怪兽吗？左侧有一块残肢，需要避开。左侧需要增加一个沸体？快跑！我们要保护自己！打它呀！躲起来躲起来。\\n那只怪兽越来越近，越来越多沸体躁动不安，核心沸体正在逐一处理来自其他沸体的想法，在核心沸体还未发话之前，由于运动沸体暂停了一切动作。那只张开嘴的怪兽甚至还有点惊异于对方的毫无动作。\\n那只怪兽咬上了幽狱沸体“喉部”，幽狱沸体仍旧没有动作，核心沸体还在思考。\\n快撑不住啦，快来快来，别等啦，快多来点沸体帮忙控制这边的水体，快快，我们需要支援！啊那边有个绿色的小植物，好可爱！\\n核心沸体这才回过神指挥运动沸体，将接踵而至的新信息全部抛开。\\n突然，周围暗下来了一瞬间，咬住幽狱沸体的怪兽倒下了，被另一只从天而掉的怪兽压倒在地。\\n“攻击和防御！依靠我们操控水体的力量！”幽狱沸体缓缓地从两只怪兽的身体下挪出身来，核心沸体同时时说道。毕竟在一切目标之前，只有活着。\\n就这样，沸体试着将力量延伸到水体外，它们一边前行一边与偶尔碰到的怪兽战斗，学习进攻和防御，直至来到了首个“尽头”。“尽头”前方是一个更巨大的湖，是一片海洋。",
    "messageInitContent_4796": "震惊！",
    "realmConfigDes_152": "御空2",
    "messageInitContent_4797": "啊？",
    "realmConfigDes_155": "御空5",
    "messageInitContent_4798": "这是说谁呢",
    "realmConfigDes_154": "御空4",
    "messageInitContent_2136": "喂喂，到底是指什么温度啊！",
    "messageInitContent_2135": "本领导来金矿视察！快出来迎接！",
    "messageInitContent_2134": "嘻嘻我的金矿岛。",
    "messageInitContent_2133": "我大国足出2倍价钱请你们当守门员！",
    "messageInitContent_2132": "不去当守门员真是浪费了",
    "messageInitContent_2131": "守着矿，果然是很懂商之道呢哈哈哈",
    "messageInitContent_2130": "之后金币就交给你们了呢",
    "messageInitContent_4790": "有本事你别打我嘛！",
    "messageInitContent_2139": "您好，请问这力度合适吗？我锤了啦。",
    "messageInitContent_2138": "洗澡的温度！",
    "themeCardPackDes_27040": " “我身上似乎有星灵族和木偶族的因子……”\\n“像星灵一样随风消散离开，也不错呢。”\\n淡紫色的光球从她的身体缓缓溢出， 渐渐碎成无数细微的光点，飘向广袤的夜空。\\n她以星灵族的方式回到了天际，而她的躯壳，却如木偶族那样，被完整地保留下来。\\n我们围在她的身旁，四周弥漫着思念与哀伤。\\n忽然，一条条银蓝色的细线从我们体内伸出，交织、延展，缓缓接入她的躯壳。\\n仿佛是思念缠绕成型，将记忆与能量一同织入她的脉络。\\n光重新开始流动，这次不再是淡紫，而是银蓝色。\\n那些记录、那些声音、那些与空气说话的习惯，似乎透过我们，回到了那副躯壳之中。\\n她睁开了眼。\\n那双眼与我们记忆中的没有任何不同。\\n只是这一次，她的呼吸里，多了一丝我们的气息。",
    "messageInitContent_2137": "高温消毒的温度",
    "messageInitContent_4799": "莫不是背着二胡的",
    "themeCardPackDes_15015": "幽狱沸体正朝着它们定下的小目标“陆地的尽头”，那根如同贯穿了天地的大柱子前进。\\n激昂的宣告才发出多久了呢？怎么就走不动了？怎么就“饿”了呢？\\n实际上这时的沸体并没有饿的概念。这是一只研究沸体提出的猜想，根据它以往的观察，它认为，之所以会饿是因为它们这部分从沸湖分离出去水体，失去了那些让它们不会饿的物质。以往坠入沸湖的怪兽很有可能会被沸湖分解，而沸体在平日不知不觉中吸收水体中被分解的怪兽，所以从来不会觉得饿。参考那些坠入湖中的怪兽都会发出一种“饿”的叫声，它建议将现在这种状态称为饿了。\\n就在讨论的这会，感官沸体发出警告，有什么正在接近它们。\\n不少黑色块状物从天空而降，大部分落入了沸湖那头，还有少数落在了幽狱沸体旁，正是过往在沸湖经常能看见的怪兽。\\n其中一只怪兽身体的一部分落在了它们旁边，那是一只大断手。\\n是的，它们的食物来了！\\n研究沸体表示，正好能借助这只断手验证它的猜想。\\n虽然核心沸体对研究沸体那过于离谱的命名方式感到不安，但是它同意这是值得一试的。\\n首先，造型沸体将身体分成一大一小两个部分，较小的部分将断手的一部分纳入其中，在一段时间的等待后，断手开始逐渐溶解，随后断手被完全纳入分解殆尽。又经过一段时间的观察，沸体打出信号，表示一切正常且能够成功恢复精力。研究沸体的猜想似乎是对的！\\n随后两个部分合二为一，沸体们都感觉好多了，告别了饿的感觉。除此之外，它们还有一个意外的收获，在断手分解的时候，造型沸体参考了这只大手的造型，为幽狱沸体造出了“双手”！\\n沸体们都很开心，这样它们在路上捡食怪兽就方便多了~",
    "realmConfigDes_124": "地龙4",
    "realmConfigDes_123": "地龙3",
    "realmConfigDes_126": "剧王1",
    "realmConfigDes_125": "地龙5",
    "themeCardPackDes_15010": "啪——\\n幽狱沸体又摔倒了，它的左脚撞上一块无辜的大石，而后失去平衡，在斜坡上滚了下去。\\n这一摔比以往都要严重，下坠的惯性使得幽狱沸体产生了剧烈的形变，一部分失控的水体连同两只沸体一起被甩飞出去，永远地结束了它们的旅途。\\n幽狱沸体停在了原地。\\n“过去，我们在沸湖里四处漂，撞上讨厌的沸体就怒掐一把，碰上喜欢的沸体就蹭蹭贴贴。可现在我们已经离开那里了，周围全都是未曾见过的新东西，不再只有水，不再只有沸体，这些东西就这样抓住了我们的目光，因此谁也没有意识到撞上前面的大石会导致的结果。我们不能继续这样了，为了消失的同伴，为了之后的旅途，我们不能再摔了。”核心沸体说道。\\n于是一些自告奋勇的沸体成为感官沸体，它们以后会更专注于四周的环境，指导运动沸体的动作。主要的感官沸体通常都非常显眼，因为它们为了能更好地看清环境，会将包裹在体外的水体减到最少。\\n经过一段时间的磨合，沸体们周围的景色终于能连贯且快速的后退，它们咕噜咕噜地尖叫着，为刚定下的新目标而呐喊！\\n“抵达‘陆地的尽头’，不带摔滴！”",
    "realmConfigDes_120": "镇魂5",
    "realmConfigDes_122": "地龙2",
    "realmConfigDes_121": "地龙1",
    "messageInitContent_2147": "您好请问这里是献血站吗？",
    "messageInitContent_2146": "请横扫我的安全感！！！！",
    "messageInitContent_2145": "请给我安全感！！！！",
    "messageInitContent_2144": "白色海岸！",
    "messageInitContent_2143": "这里是什么修罗场吗？",
    "realmConfigDes_128": "剧王3",
    "messageInitContent_2142": "做饭的温度！",
    "realmConfigDes_127": "剧王2",
    "messageInitContent_2141": "火化的温度！",
    "messageInitContent_2140": "好感动它们还征求我意见！",
    "realmConfigDes_129": "剧王4",
    "messageInitContent_2149": "你说的是凶噬魔吗？",
    "messageInitContent_2148": "颜值就是正义！",
    "themeCardPackDes_15005": "那是一个通体碧蓝的椭圆状生物，它舒展开双臂优雅地摆动起来。\\n不久，优雅摆动变成了使劲乱动，最后停了下来。\\n欢呼声和椭圆状生物一起尬在了原地，尬在了沸湖边的登陆点。\\n那是来自沸湖的沸体们，它们一旦离开水体就会消失。为了前往神秘的陆地冒险，沸体们利用禁锢水体的力量创造了一个名为“幽狱沸体”的集合体，连同水体一起向陆地迈出第一步。\\n此时它们正要迈出第二步，却发现习以为常的移动方式，在陆地上根本无法挪动半步！\\n这个椭圆状的形态，正是参照最强沸体造型而成的，现在看来，在陆地上“最强”好像失去了意义。\\n沸体们开始了激烈的讨论，此时某只沸体突然想起了一只怪兽。那是一只它印象深刻的不幸在沸湖内陨命的怪兽，因为它落入沸湖后比其他怪兽挣扎得更久，它有着一头浓密的须发，下颌包裹着上颌，倒三角的体型，其中一根手臂上露出了三根骨头。\\n这只沸体只是单纯抱着既然这个形状不行就换一个的想法，让其他沸体按照它记忆里那只怪兽的样子重塑了形态，其他沸体都觉得这个想法非常不错，这只沸体就这样成为了幽狱沸体的“核心”，成为了核心沸体。\\n幽狱沸体也从此获得了“双脚”！\\n蠕动，蹒跚，摔倒，爬起这是它们通往新世界的第二步，是奠定了未来之路的一步。\\n咚——\\n幽狱沸体又摔了。",
    "messageInitContent_2150": "我颜值+100表示不服！",
    "realmConfigDes_135": "赤虹5",
    "realmConfigDes_134": "赤虹4",
    "realmConfigDes_137": "火神2",
    "realmConfigDes_136": "火神1",
    "realmConfigDes_131": "赤虹1",
    "realmConfigDes_130": "剧王5",
    "realmConfigDes_133": "赤虹3",
    "realmConfigDes_132": "赤虹2",
    "messageInitContent_2158": "果然神都喜欢在沿岸的区域？",
    "messageInitContent_2157": "留言板空气清新剂，按赞喷一喷",
    "messageInitContent_2156": "就让我来帮大家吧！",
    "messageInitContent_2155": "危险物品要放好才是！",
    "messageInitContent_2154": "前排出售解毒剂！",
    "realmConfigDes_139": "火神4",
    "messageInitContent_2153": "只要我慢慢奶就不怕毒，啊有狼，没事了。",
    "realmConfigDes_138": "火神3",
    "messageInitContent_2152": "百分比毒我可恶！",
    "messageInitContent_2151": "你好毒毒毒毒毒~",
    "messageInitContent_2159": "这两个熊孩子又开始乱丢食物了!",
    "messageInitContent_2161": "那两个熊孩子旁边那个头是什么来的？",
    "realmConfigDes_102": "日夕2",
    "messageInitContent_2160": "我这就来管教它们！",
    "realmConfigDes_101": "日夕1",
    "realmConfigDes_104": "日夕4",
    "realmConfigDes_103": "日夕3",
    "realmConfigDes_100": "圣盾埃癸斯5",
    "messageInitContent_2169": "还好我有朱雀能苟一会",
    "messageInitContent_2168": "前方慎防踩踏！",
    "realmConfigDes_109": "月夕4",
    "messageInitContent_2167": "这些小动物好狠心哪！",
    "messageInitContent_2166": "我就知道象拔蚌会跳舞。",
    "messageInitContent_2165": "听说大笨象会跳舞是吗？",
    "realmConfigDes_106": "月夕1",
    "messageInitContent_2164": "请问这里是众神殿吗？",
    "realmConfigDes_105": "日夕5",
    "messageInitContent_2163": "等到入夜，我就去玖璃的小馆吃烤串！",
    "realmConfigDes_108": "月夕3",
    "messageInitContent_2162": "哇那是什么，好吓人",
    "realmConfigDes_107": "月夕2",
    "messageInitContent_2172": "happy happy happy",
    "realmConfigDes_113": "冥龙王3",
    "messageInitContent_2171": "小怪兽，不要太敬业了，偶尔也休息下嘛",
    "realmConfigDes_112": "冥龙王2",
    "messageInitContent_2170": "美杜莎到此一游",
    "realmConfigDes_115": "冥龙王5",
    "realmConfigDes_114": "冥龙王4",
    "realmConfigDes_111": "冥龙王1",
    "realmConfigDes_110": "月夕5",
    "messageInitContent_2179": "这里的肉肉特别受龙欢迎啊",
    "messageInitContent_2178": "这是什么神奇密码吗？",
    "messageInitContent_2177": "不懂",
    "messageInitContent_2176": "你们在干什么呀？",
    "realmConfigDes_117": "镇魂2",
    "messageInitContent_2175": "0",
    "realmConfigDes_116": "镇魂1",
    "messageInitContent_2174": "2147483647",
    "realmConfigDes_119": "镇魂4",
    "messageInitContent_2173": "Oiiaioooooiai",
    "realmConfigDes_118": "镇魂3",
    "messageInitContent_2183": "龙王宴是吃龙肉的吗？",
    "messageInitContent_2182": "肉肉山里面有肉山的吗",
    "messageInitContent_2181": "我宣布这个肉肉山我接管了！",
    "messageInitContent_2180": "吃货小龙龙，哈喽",
    "messageInitContent_2189": "欢迎体验美杜莎莎特色看看",
    "messageInitContent_2188": "在线收一只大舌怪",
    "messageInitContent_2187": "欢迎体验崩界领主特色推波",
    "messageInitContent_2186": "火热的心中是否会融合！",
    "messageInitContent_2185": "天上龙肉，地上……",
    "messageInitContent_2184": "龙门宴？",
    "themeCardPackDes_27005": " “木偶族由伪造的躯壳与伪造的灵魂结合而成……”\\n“星灵族被认为是来自异星的种族，它们拥有匪夷所思的能力……”\\n她抬手将飘在空中的《种族概论》丢开，继续对着空气自言自语：“根本就是照着各个种族的特征努力瞎掰上去的吧~跟那些按幼兽出生的星辰去预言它未来能达到的极限一样，根本不能参考~”\\n“还是直接点算了。”\\n她身旁悬浮着一本巨大的树皮集，一个带着紫色能量球的尖锥在树皮集上高速移动。\\n她刚刚说过的话被一字不落地记录到树皮集上。\\n这是她打造的构具之一，名叫【随想树皮】。\\n正在疯狂书写的【尖锥紫晶】突然一个刹停后微微一弯，径直飞向左前方。\\n一只腐食者被钉在地上。\\n“小家伙，终于逮到你了~”\\n“你，你你，要对我我我做做什么？”腐食者甩着鼻涕，双腿加速在地上打圈，却因为头上的卷毛被钉在树上无法移动半分。\\n“不要，你你你要对我做什么~咿呀——”\\n“嗯嗯，这里是2个单位，这里是3个。然后再拼起来！搞定！”\\n“你看，这个构具不能说跟你一模一样，也是别无二致吧。”\\n“你呢这段时间就待在我这，给你好吃好喝的。等我去把我想要的东西搞回来了，你就可以回家啦。”\\n腐食者看着眼前的庞然大物疯狂点头。",
    "themeCardPackDes_27010": "这里是尸鬼族第二大聚居地，也是最为古老的聚居地之一。\\n夜色降至，大地上排布着大大小小的石碑，或横或斜地插在地上，在迷雾中若隐若现。其中一些横着的石碑后面藏着熵鬼、幽鬼、尸狂和尸王。那头斜插在地上的石碑后藏着吞噬者、凶噬魔、腐化者和永腐魔。\\n不久前，它们还在石碑下的地穴中沉浸在各自的兴（符号）趣中。\\n突然的大地巨震让整个聚落立刻紧张起来，幼体和幻化怪兽撤到了中心地带的地下穴洞中。\\n很明显，这振幅远超比蒙巨兽群过境的异动，四大长老藏在第二道防线上。迅速燃起的鬼魂雾能最大程度阻隔入侵者的视野，只有熟悉地形的尸鬼族怪兽才能在这里自如地穿梭。\\n震动愈发剧烈，尸鬼族的怪兽都屏息以待。\\n此时一个巨大的黑影出现在迷雾中，随后是震耳欲聋的声响。\\n“腐食者小宝宝我回来啦！”\\n一头体型巨大的“腐食者”甩着巨大鼻涕一个平地摔，向聚落中心摔去。\\n尸鬼族的究极、不朽和觉醒级怪兽合力推着它的大头，才勉强让它停下，在那之前它已经摧毁了将近小半个聚落了。\\n“怎么把体型设置错了！抱歉我是隔壁的，不小心迷路了。”\\n“腐食者”在地上努力倒腾了几下才勉强爬起。\\n“那我先走啦~”\\n留下尸鬼族在黄沙与鬼魂烟中无能怒吼。",
    "messageInitContent_2194": "你说的龙是哪一条？",
    "messageInitContent_2193": "结晶龙脚饭，欢迎大家来尝！",
    "messageInitContent_2192": "你们真可怕！",
    "messageInitContent_2191": "蛇不是咬咬吗？",
    "messageInitContent_2190": "欢迎体验美火心特色红温",
    "themeCardPackDes_15040": "幽狱沸体距离抵达“世界尽头”崩坠之柱还有很长一段距离。\\n它的冒险之旅虽然困难重重，它却好像总能越过难关，因为只有越过难关的沸体集群，才有机会讲述越过难关的故事。它们并不是离开沸湖的唯一沸体集群，一些集群离开沸湖后没多久就后悔了，选择回到它们最熟悉的沸湖，还有一些在离开了后不知所措，停在原地直到饿死。还有的一直摔倒直到无法再起身的，还有的集群被无名岛屿的其他怪兽杀死，还有一部分被巨浪和漩涡吞没。这些沸体集群都倒在了各种惯性和理所当然之中。\\n谁都不知道能抵达世界尽头的沸体集群最终会是哪一些？\\n唯一可以确定的是，它们一定是那些深知禁锢的力量，却决不会被经验和教训禁锢，会不断去思考创造，不断去调整策略，不断前行的沸体集群。\\n比如，那只正在思考极巨化以外可能性的沸体……",
    "messageInitContent_2199": "你们这是多大仇？？？？",
    "messageInitContent_2198": "蜻蜓龙这么可爱，不如我们……",
    "messageInitContent_2197": "这只蜻蜓龙不舒服我们不如……",
    "messageInitContent_2196": "喜欢，多来几只！",
    "themeCardPackDes_27015": "黯炎魔龙觉得脑袋嗡嗡的。\\n它作为站在祖龙族顶点的怪兽，拥有龙族中最珍稀、最丰富的藏品，更拥有数量最多也是最安全的宝库巢。\\n可正是这样的它发现，自己的宝库巢竟被入侵了。\\n最离谱的是，里头的东西不但没有变少，反而还变多了。更气龙的是，正是因为多了的东西它才发现宝库巢遭到了入侵。\\n这一切都说明它之前精心布置的伪装宝库巢，宝库巢陷阱，守门龙等一切的措施形同虚设。\\n对于入侵者而言，来它的巢穴就像是回家一样。\\n那天，它吃饱喝足后准备到古籍宝库巢歇息，无他那里躺得最舒服~\\n一大堆古碑文石碑上放着一大堆古树皮，躺起来比起什么金堆宝石堆奇珍堆的舒服多了。\\n当然它最爱的还是金堆，重点不在于舒服，而是那种金灿灿的感觉。\\n就是经常去会容易暴露位置所以它才选择到古籍宝库巢歇息。\\n那天，它就这样看到了一个紫色能量球正在它的古籍堆上游移。\\n见到它之后，那个东西还说了句什么，啊我怎么把【尖锥紫晶】的能量体落下了，你总是丢三落四的之类的话语。\\n黯炎魔龙就这样看着紫色小球藏进了古籍中，它把古籍宝库巢翻了个底朝天也没能找到那个小贼球。\\n它将空气的灵魂残渣吞噬殆尽，天际尽是赤红的龙焰。",
    "messageInitContent_2195": "蜻蜓龙不喜欢吗？",
    "messageInitContent_4818": "小朋友就怪怪回家睡觉觉",
    "messageInitContent_4819": "晚安世界",
    "messageInitContent_4810": "小祖拉，又到处乱逛了",
    "messageInitContent_4811": "表白祖拉，想起某个头顶种花的孩子",
    "messageInitContent_4812": "又丢下赤虹妹妹到处玩啦？",
    "messageInitContent_4813": "放心冰霓和赤虹都帮你照顾妥当",
    "messageInitContent_4814": "你们说啥呢",
    "messageInitContent_4815": "又打掉一个狂潮势力",
    "messageInitContent_4816": "？？？？？好怪",
    "messageInitContent_4817": "晶体",
    "immortalCocoonConfigName_175": "岩浆浴",
    "immortalCocoonConfigName_174": "零熵大炮",
    "immortalCocoonConfigName_173": "崩了这怎么反",
    "immortalCocoonConfigName_172": "毒鸟",
    "immortalCocoonConfigName_171": "沉默体验",
    "immortalCocoonConfigName_170": "我知道你很急但",
    "messageInitContent_4820": "你好世界",
    "immortalCocoonConfigName_179": "不要急关键要快",
    "immortalCocoonConfigName_178": "重甲巨炮",
    "immortalCocoonConfigName_177": "奉天承运",
    "immortalCocoonConfigName_176": "慢慢来",
    "messageInitContent_4829": "我要和凶使魔换个位",
    "messageInitContent_4821": "来吹吹风",
    "messageInitContent_4822": "暗物质处理装置",
    "messageInitContent_4823": "暗物质糖果",
    "messageInitContent_4824": "笑容逐渐灿烂",
    "messageInitContent_4825": "会不会把这里融掉 ",
    "messageInitContent_4826": "出售爱心",
    "messageInitContent_4827": "科技弓箭",
    "messageInitContent_4828": "建议换一下武器",
    "immortalCocoonConfigName_164": "尽管奶",
    "immortalCocoonConfigName_163": "“让我独自战斗！”",
    "immortalCocoonConfigName_162": "爱在读条前",
    "immortalCocoonConfigName_161": "高温料理（ni）",
    "immortalCocoonConfigName_160": "植物大战？",
    "messageInitContent_4830": "让让我先来",
    "messageInitContent_4831": "成功破防",
    "immortalCocoonConfigName_169": "“别把推开我”",
    "immortalCocoonConfigName_168": "尊老爱幼",
    "immortalCocoonConfigName_167": "这关有毒",
    "immortalCocoonConfigName_166": "永生实验室",
    "immortalCocoonConfigName_165": "小豆钉快过来",
    "godConfigName_2": "白虎",
    "godConfigName_3": "玄武",
    "godConfigName_4": "青龙",
    "96_tribeAdventureRank": "部落冒险排行榜",
    "godConfigName_5": "麒麟",
    "godConfigName_1": "朱雀",
    "4_comment": "商店, 背包, 道具, 战墙, 获取途径, 拍卖所, 宝箱, 充值, 钻石兑换, 宝藏, 金币购买",
    "messageInitContent_4832": "创晓是老板？",
    "propConfigDes_90304": "收集30块蓝色生物屏障元核碎片可以合成蓝色品质生物屏障元核。",
    "messageInitContent_4833": "小祖拉，逮到你了！",
    "propConfigDes_90305": "收集30块紫色生物屏障元核碎片可以合成紫色品质生物屏障元核。",
    "messageInitContent_4834": "多放几下特效，爷喜欢",
    "propConfigDes_90302": "收集30块白色生物屏障元核碎片可以合成白色品质生物屏障元核。",
    "messageInitContent_4835": "已疯无打扰",
    "propConfigDes_90303": "收集30块绿色生物屏障元核碎片可以合成绿色品质生物屏障元核。",
    "messageInitContent_4836": "让我静静通关",
    "messageInitContent_4837": "下方高能",
    "messageInitContent_4838": "下蛋专家",
    "messageInitContent_4839": "我买赤虹硬",
    "immortalCocoonConfigName_153": "啦啦队",
    "immortalCocoonConfigName_152": "123开跑",
    "immortalCocoonConfigName_151": "究极的发型",
    "immortalCocoonConfigName_150": "挑战极限",
    "messageInitContent_4840": "乐",
    "messageInitContent_4841": "行不行",
    "propConfigDes_90306": "收集30块橙色生物屏障元核碎片可以合成橙色品质生物屏障元核。",
    "messageInitContent_4842": "这炮口是不是有点大",
    "propConfigDes_90307": "收集30块红色生物屏障元核碎片可以合成红色品质生物屏障元核。",
    "immortalCocoonConfigName_159": "保护我方G-N",
    "immortalCocoonConfigName_158": "打完就合体",
    "immortalCocoonConfigName_157": "利刃出鞘",
    "immortalCocoonConfigName_156": "两吃货和它们的……餐具",
    "immortalCocoonConfigName_155": "珀耳修斯呢？",
    "immortalCocoonConfigName_154": "龙骑兵冲锋",
    "randomEventDialogueGroupConfig_12.4": "到它隔壁躺平",
    "randomEventDialogueGroupConfig_12.5": "扶它起来",
    "randomEventDialogueGroupConfig_12.6": "-",
    "randomEventDialogueGroupConfig_12.7": "-",
    "randomEventDialogueGroupConfig_12.1": "你发现了一个神秘商人躺平在路中间。",
    "randomEventDialogueGroupConfig_12.2": "走过去向它招手",
    "randomEventDialogueGroupConfig_12.3": "喊神秘商人",
    "messageInitContent_4843": "？？？",
    "messageInitContent_4844": "射歪了还有医生对吧",
    "messageInitContent_4845": "医生另外收费",
    "messageInitContent_4846": "可以的",
    "messageInitContent_4847": "私以为这里是……",
    "randomEventDialogueGroupConfig_12.8": "-",
    "messageInitContent_4848": "说下去",
    "randomEventDialogueGroupConfig_12.9": "-",
    "messageInitContent_4849": "赛博**",
    "immortalCocoonConfigName_142": "过来我给你加个debuff",
    "immortalCocoonConfigName_141": "怪呢？",
    "immortalCocoonConfigName_140": "捕兽大师",
    "messageInitContent_4850": "爱我请点赞",
    "messageInitContent_4851": "靓仔无语",
    "messageInitContent_4852": "真能吃的吗",
    "messageInitContent_4853": "只有queen是食品级的",
    "immortalCocoonConfigName_149": "修罗场",
    "immortalCocoonConfigName_148": "啊我的眼睛",
    "immortalCocoonConfigName_147": "挖矿小分队",
    "immortalCocoonConfigName_146": "开心就好",
    "immortalCocoonConfigName_145": "同伴呢？",
    "immortalCocoonConfigName_144": "我怕了当那电灯胆",
    "immortalCocoonConfigName_143": "谦让",
    "messageInitContent_4854": "附议",
    "messageInitContent_4855": "emmm",
    "messageInitContent_4856": "推关推饿了",
    "messageInitContent_4857": "又是你战场记录员",
    "messageInitContent_4858": "好吓人的样子",
    "messageInitContent_4859": "可爱想",
    "messageInitContent_4860": "想吃雪糕",
    "messageInitContent_4861": "这是西边的王",
    "messageInitContent_4862": "不是念动力掌吗",
    "messageInitContent_4863": "这是不是专门给我留了个位置呢",
    "messageInitContent_4864": "哈人",
    "messageInitContent_2202": "沼泽、火海、熔岩领域叠加！",
    "messageInitContent_2201": "这关我半秒都不想呆",
    "messageInitContent_2200": "什么疯狂叠叠乐",
    "messageInitContent_2209": "buff就好像衣服，皮匠处理衣服没毛病",
    "messageInitContent_2208": "某种程度他比键盘侠还可怕",
    "messageInitContent_2207": "为什么一个皮匠能学会清buff，我不理解",
    "messageInitContent_2206": "？？？",
    "messageInitContent_2205": "在别的塞尔雷特那捡来的",
    "messageInitContent_2204": "小塞，你哪来的来这么多面包丢呢",
    "messageInitContent_2203": "还有遗物呢。",
    "messageInitContent_4865": "这么大的手是有什么用途吗",
    "messageInitContent_4866": "别问，问就是打你",
    "messageInitContent_4867": "为啥不是破魔拟态",
    "messageInitContent_4868": "新型那啥",
    "messageInitContent_4869": "奉天承运大佬诏曰",
    "messageInitContent_4870": "看到春游的呜呜祖拉",
    "messageInitContent_4871": "球球了，让我过去",
    "messageInitContent_4872": "懂了理发店",
    "messageInitContent_4873": "自助换头欢迎光临",
    "messageInitContent_4874": "多么有趣的赛博发型",
    "messageInitContent_4875": "头发还能张眼睛",
    "messageInitContent_2213": "可爱切黑！",
    "messageInitContent_2212": "所以知道dvd大战是什么了吗？",
    "messageInitContent_2211": "别想了，直接把它既能封了吧",
    "messageInitContent_2210": "怎么觉得是在强行解释。",
    "messageInitContent_2219": "输出的对决我是不会输的！",
    "messageInitContent_2218": "它进化之后，更加不让你回复了",
    "messageInitContent_2217": "好烧好烧",
    "messageInitContent_2216": "你们好sao哦",
    "messageInitContent_2215": "热火组合！",
    "messageInitContent_2214": "炙烧寿司！",
    "messageInitContent_4876": "走不动路了",
    "messageInitContent_4877": "走你",
    "messageInitContent_4878": "路过",
    "messageInitContent_4879": "烤肉店！",
    "immortalCocoonConfigName_197": "巨王",
    "immortalCocoonConfigName_196": "真顶",
    "messageInitContent_4880": "会跑的凳子我要了",
    "immortalCocoonConfigName_195": "真龙魔导士",
    "messageInitContent_4881": "会飞的头",
    "immortalCocoonConfigName_194": "妹兄同心",
    "messageInitContent_4882": "新区域~",
    "immortalCocoonConfigName_193": "重装草丛",
    "messageInitContent_4883": "wow",
    "immortalCocoonConfigName_192": "好凶",
    "messageInitContent_4884": "占地面积好大",
    "immortalCocoonConfigName_191": "不要这种二人世界",
    "messageInitContent_4885": "闭上眼你将拥有一切",
    "immortalCocoonConfigName_190": "黄油猫零式",
    "messageInitContent_4886": "脑子丢了你们看到了吗",
    "messageInitContent_2224": "其实扑街鸟只是一只傻鸟，大家别怕",
    "messageInitContent_2223": "其实祖拉手上的只是个漏斗，大家别怕",
    "messageInitContent_2222": "其实比蒙身上的是2只电筒，大家别怕",
    "messageInitContent_2221": "这比蒙差一点就能咬住祖拉了！！！",
    "messageInitContent_2220": "让你看看本fff团的火力！",
    "immortalCocoonConfigName_199": "深夜食堂",
    "immortalCocoonConfigName_198": "巨星",
    "messageInitContent_2229": "我裂开了，你们呢",
    "messageInitContent_2228": "特殊点附近我就知道不会这么简单！",
    "messageInitContent_2227": "快打电话给东京都立咒术高等专门学校",
    "messageInitContent_2226": "这都别被你发现了。",
    "messageInitContent_2225": "咒灭主宰者双刃，难道就是传说中的逆刃刀？",
    "messageInitContent_4887": "哪里有绿色",
    "messageInitContent_4888": "我脑子过载了",
    "messageInitContent_4889": "管控区域？",
    "immortalCocoonConfigName_186": "可靠",
    "messageInitContent_4890": "淡定挑战然后关闭",
    "messageInitNick_4497": "外星人摄影师",
    "immortalCocoonConfigName_185": "别气噢",
    "messageInitContent_4891": "哪里有洗手间？",
    "messageInitNick_4496": "时空在呼吸",
    "immortalCocoonConfigName_184": "惯用手",
    "messageInitContent_4892": "你有对象了吗反正关卡有了",
    "messageInitNick_4495": "床垫会跑",
    "immortalCocoonConfigName_183": "手执两子",
    "messageInitContent_4893": "永不下班",
    "messageInitNick_4494": "开心超人",
    "immortalCocoonConfigName_182": " “麻烦死这里”",
    "messageInitContent_4894": "你知道吗",
    "immortalCocoonConfigName_181": "“奶着奶着不见了”",
    "messageInitContent_4895": "不烫吗",
    "immortalCocoonConfigName_180": "媚眼加红唇",
    "messageInitContent_4896": "借个火谢谢",
    "messageInitNick_4499": "这假的吧",
    "messageInitContent_4897": "赤潮失去了名字",
    "messageInitNick_4498": "胡萝卜先锋",
    "messageInitContent_2235": "快说！地上的坑是不是都是你弄出来的！",
    "messageInitContent_2234": "我就是传奇！",
    "messageInitContent_2233": "一刀超怪！",
    "messageInitContent_2232": "提前送走它就好血量保持住",
    "messageInitContent_2231": "不对啊，平时是我打别人一刀999999999",
    "immortalCocoonConfigName_189": "顺着网线而至",
    "messageInitContent_2230": "一刀999999999就在这里",
    "immortalCocoonConfigName_188": "贴身采访",
    "immortalCocoonConfigName_187": "月夜雷鸣",
    "randomEventDialogueGroupConfig_54.57": "离开",
    "randomEventDialogueGroupConfig_54.56": "小二大笑道。任务失败了。",
    "randomEventDialogueGroupConfig_54.55": "放心开吃",
    "randomEventDialogueGroupConfig_54.54": "小二陪笑着说完，就吃了起来。",
    "randomEventDialogueGroupConfig_54.53": "离开",
    "messageInitNick_4493": "十五了",
    "messageInitNick_4492": "寂寞仙哥",
    "messageInitNick_4491": "不合群小姐",
    "messageInitNick_4490": "脑电波电台",
    "messageInitNick_4486": "殷语学家",
    "messageInitNick_4485": "凌晨十一点",
    "messageInitNick_4484": "无声无息",
    "messageInitNick_4483": "忘记打卡",
    "messageInitNick_4489": "半面妆",
    "messageInitNick_4488": "把难过拉黑",
    "messageInitNick_4487": "这就是大佬",
    "randomEventDialogueGroupConfig_54.49": "起床迎击",
    "randomEventDialogueGroupConfig_54.48": "半夜，第三班的伙计突然拉响了警报。",
    "randomEventDialogueGroupConfig_54.47": "倒头休息",
    "randomEventDialogueGroupConfig_54.46": "安排轮流守夜",
    "randomEventDialogueGroupConfig_54.45": "天色渐晚，气温骤降，你将早前备好的食水分配下去，再指派一怪兽四周检查一番，以防贼兽窜轰于（放火）后，便示意大家好好休息。",
    "randomEventDialogueGroupConfig_54.44": "离开",
    "randomEventDialogueGroupConfig_54.43": "你们酷热难耐，口干舌燥，疲惫不堪，黄沙中突然冲出一群怪兽，将神秘商人劫走，你们一点还手之力都没有。任务失败了。",
    "randomEventDialogueGroupConfig_54.42": "离开",
    "messageInitNick_4482": "酷炫老祖宗",
    "97_2003": "怪兽碎片",
    "messageInitNick_4481": "无敌打脸神",
    "97_2002": "怪兽",
    "messageInitNick_4480": "雪莲果去哪了",
    "97_2001": "智者",
    "messageInitNick_4475": "打脸爱好者",
    "messageInitNick_4474": "点五个半身人",
    "messageInitNick_4473": "忘记补刀",
    "messageInitNick_4472": "无公害柿子",
    "messageInitNick_4479": "饼太大",
    "messageInitNick_4478": "神仙打假",
    "messageInitNick_4477": "情是何物",
    "messageInitNick_4476": "我爱吃茄子",
    "randomEventDialogueGroupConfig_54.52": "谨慎的你武器并没有离身，衣物也没有脱下，所以能够在第一时间行动，对来袭的怪兽展开反攻。之后，在你细致严谨的保护下，顺利将神秘商人送到了西集市。",
    "randomEventDialogueGroupConfig_54.51": "离开",
    "randomEventDialogueGroupConfig_54.50": "你们被夜袭了，神秘商人被劫走，任务失败了。",
    "randomEventDialogueGroupConfig_54.38": "质问小二",
    "randomEventDialogueGroupConfig_54.37": "酒足饭饱后，一群大汉围住了你们，并向你们勒索高价饭钱，否则绝不放行。",
    "97_9": "造唤台",
    "randomEventDialogueGroupConfig_54.36": "哎既然大爷赏脸，那小的就不客气喽。",
    "randomEventDialogueGroupConfig_54.35": "离开",
    "randomEventDialogueGroupConfig_54.34": "对于又饥又渴的你们而言，不管吃什么都似是世间美味。吃着吃着你们就不省人事了。随后你们遭到暗算，任务失败。",
    "randomEventDialogueGroupConfig_54.33": "让小二先吃",
    "randomEventDialogueGroupConfig_54.32": "开吃",
    "randomEventDialogueGroupConfig_54.31": "店小二热情上前为你们接风，很快就为你们准备好了饭菜。",
    "97_3": "领地",
    "97_4": "怪兽",
    "97_1": "智者本人？",
    "97_2": "又名冒牌货",
    "97_7": "部落",
    "messageInitNick_4471": "作业他欺负我",
    "97_8": "商店",
    "messageInitNick_4470": "狂飙的青蛙",
    "97_5": "神灵",
    "97_6": "排阵",
    "randomEventDialogueGroupConfig_54.39": "愤然突围",
    "messageInitNick_4464": "豌豆先锋",
    "messageInitNick_4463": "联名款香蕉",
    "messageInitNick_4462": "吃瓜鉴定家",
    "messageInitNick_4461": "诺贝尔躺赢奖",
    "messageInitNick_4468": "绳子一条",
    "messageInitNick_4467": "灰彩虹",
    "messageInitNick_4466": "蛋挞女巫",
    "messageInitNick_4465": "新的大象",
    "randomEventDialogueGroupConfig_54.41": "你突然发现全身使不上力，其他伙伴也一样。任务失败了。",
    "randomEventDialogueGroupConfig_54.40": "药是我下的，我当然知道哪些菜是没有下药的，快把钱和这个神秘商人留下，绕你一命。",
    "messageInitNick_4469": "安静的兔子",
    "randomEventDialogueGroupConfig_54.27": "进店修整",
    "randomEventDialogueGroupConfig_54.26": "你们早上出发，由于没有规划好路线不得不绕了一些路，此时大家都又热又渴又累，所幸前方正好有一家店。",
    "randomEventDialogueGroupConfig_54.25": "出发",
    "randomEventDialogueGroupConfig_54.24": "你在信得过的店铺备齐了食物和净水，并对行程的路线和住店也仔细地侦察了一番，待到气温合适的时辰再出发。",
    "randomEventDialogueGroupConfig_54.23": "先准备一番",
    "randomEventDialogueGroupConfig_54.22": "立刻出发",
    "randomEventDialogueGroupConfig_54.21": "很快你便来到了东集市的目的地，一个从未见过的神秘商人迎了过来，与你寒暄一番后问你是否可以出发。",
    "randomEventDialogueGroupConfig_54.20": "离开",
    "messageInitNick_4460": "拆不穿的谎言",
    "randomEventDialogueGroupConfig_54.29": "很快你们来到了一家计划中的客店，前方探路的怪兽已经打点好了一切前来迎接你们。此时客店小二迎上了推销酒菜。",
    "randomEventDialogueGroupConfig_54.28": "忍耐着直到一家熟悉的老店",
    "messageInitNick_4453": "电音芭芘",
    "realmConfigDes_9": "逆焰龙王4",
    "messageInitNick_4452": "车厘子之心",
    "realmConfigDes_8": "逆焰龙王3",
    "messageInitNick_4451": "不倒翁不脸红",
    "realmConfigDes_7": "逆焰龙王2",
    "messageInitNick_4450": "暴走的味精",
    "realmConfigDes_6": "逆焰龙王1",
    "messageInitNick_4457": "好好先森",
    "messageInitNick_4456": "无公害洋葱",
    "messageInitNick_4455": "当星光没有光",
    "messageInitNick_4454": "音乐在回荡",
    "randomEventDialogueGroupConfig_54.30": "表示只需要住宿",
    "realmConfigDes_1": "钢铁龙王1",
    "messageInitNick_4459": "空房子",
    "messageInitNick_4458": "奶酪陷阱",
    "realmConfigDes_5": "钢铁龙王5",
    "realmConfigDes_4": "钢铁龙王4",
    "realmConfigDes_3": "钢铁龙王3",
    "realmConfigDes_2": "钢铁龙王2",
    "immortalCocoonConfigName_131": "造唤梦境",
    "messageInitNick_4442": "东方苍狼",
    "immortalCocoonConfigName_130": "造唤梦境",
    "messageInitNick_4441": "单肫飘",
    "messageInitNick_4440": "听风的鲸",
    "messageInitNick_4446": "恰饭冠军",
    "messageInitNick_4445": "不上班不行",
    "messageInitNick_4444": "安静甜点",
    "messageInitNick_4443": "散步的菠萝",
    "immortalCocoonConfigName_139": "捕兽大师",
    "immortalCocoonConfigName_138": "捕兽大师",
    "messageInitNick_4449": "一班那谁别走",
    "immortalCocoonConfigName_137": "捕兽大师",
    "messageInitNick_4448": "冒个泡泡",
    "immortalCocoonConfigName_136": "捕兽大师",
    "messageInitNick_4447": "金门弟子",
    "hintName_13": "谜之巢穴",
    "immortalCocoonConfigName_135": "捕兽大师",
    "hintName_12": "探索指派",
    "immortalCocoonConfigName_134": "捕兽大师",
    "hintName_11": "免费造唤",
    "immortalCocoonConfigName_133": "捕兽大师",
    "immortalCocoonConfigName_132": "捕兽大师",
    "1_1": "怪兽信息",
    "1_2": "属性",
    "1_3": "元核",
    "1_4": "基因",
    "1_5": "勿语",
    "immortalCocoonConfigName_129": "造唤梦境",
    "1_6": "形态",
    "7_4001": "你尚未加入部落，加入部落后再发送部落消息",
    "1_7": "等级",
    "1_8": "战力",
    "1_9": "攻击力",
    "7_4002": "你尚未组队，凿星裂痕组队后再发送组队消息",
    "immortalCocoonConfigName_120": "极化之地",
    "messageInitNick_4431": "永远充满活力",
    "messageInitNick_4430": "家在魔仙堡",
    "messageInitNick_4435": "霸刀藐视天下",
    "messageInitNick_4434": "落败的唯美",
    "messageInitNick_4433": "宇宙被解锁",
    "messageInitNick_4432": "白雪公主",
    "immortalCocoonConfigName_128": "造唤梦境",
    "messageInitNick_4439": "友尽拳",
    "immortalCocoonConfigName_127": "造唤梦境",
    "messageInitNick_4438": "尖叫豌豆",
    "immortalCocoonConfigName_126": "造唤梦境",
    "messageInitNick_4437": "退役潜水选手",
    "immortalCocoonConfigName_125": "造唤梦境",
    "messageInitNick_4436": "知识宝库",
    "immortalCocoonConfigName_124": "造唤梦境",
    "immortalCocoonConfigName_123": "造唤梦境",
    "immortalCocoonConfigName_122": "极化之地",
    "immortalCocoonConfigName_121": "极化之地",
    "immortalCocoonConfigName_119": "极化之地",
    "immortalCocoonConfigName_118": "极化之地",
    "messageInitNick_4420": "柠檬之心",
    "messageInitNick_4424": "逗猫棒",
    "messageInitNick_4423": "薄荷蛋糕",
    "messageInitNick_4422": "勿念旧人",
    "messageInitNick_4421": "跟着风行走",
    "immortalCocoonConfigName_117": "极化之地",
    "messageInitNick_4428": "绝对无坑",
    "immortalCocoonConfigName_116": "极化之地",
    "messageInitNick_4427": "孤单少年",
    "immortalCocoonConfigName_115": "极化之地",
    "messageInitNick_4426": "搞笑王",
    "immortalCocoonConfigName_114": "极化之地",
    "messageInitNick_4425": "超级火锅",
    "immortalCocoonConfigName_113": "一地原石",
    "immortalCocoonConfigName_112": "一地原石",
    "immortalCocoonConfigName_111": "一地原石",
    "immortalCocoonConfigName_110": "一地原石",
    "messageInitNick_4429": "作文乱码",
    "messageInitContent_4807": "监视用鸟",
    "messageInitContent_4808": "这里的怪兽怎么老是出双入对",
    "messageInitContent_4809": "一只不够2只来凑",
    "immortalCocoonConfigName_109": "一地原石",
    "immortalCocoonConfigName_108": "一地原石",
    "immortalCocoonConfigName_107": "一地原石",
    "messageInitContent_4800": "是电子二胡",
    "messageInitContent_4801": "为了出场有bgm拼了",
    "messageInitContent_4802": "这里可以上网吗",
    "messageInitContent_4803": "传送点有点少",
    "messageInitContent_4804": "肯定是夜之城的黑帮混混",
    "messageInitContent_4805": "欧拉欧拉欧拉",
    "messageInitContent_4806": "想去镜子里洗个澡",
    "messageInitNick_4413": "海浪精灵",
    "messageInitNick_4412": "改变历史的龙",
    "messageInitNick_4411": "无公害黄瓜",
    "messageInitNick_4410": "奋力考试全过",
    "immortalCocoonConfigName_106": "一地原石",
    "messageInitNick_4417": "风云潮男",
    "immortalCocoonConfigName_105": "一地原石",
    "messageInitNick_4416": "萌得无药可救",
    "immortalCocoonConfigName_104": "墙战",
    "messageInitNick_4415": "富婆饿饿饭饭",
    "immortalCocoonConfigName_103": "墙战",
    "messageInitNick_4414": "第三人称",
    "immortalCocoonConfigName_102": "墙战",
    "immortalCocoonConfigName_101": "墙战",
    "immortalCocoonConfigName_100": "墙战",
    "messageInitNick_4419": "卷姐之姐",
    "messageInitNick_4418": "志当存高远",
    "systemTaskConfigContent_13": "{tribeName}部落的{userName}在击破世界灾厄——{bossName}的战斗中总输出第一，强到爆炸！",
    "systemTaskConfigContent_14": "{userName}在击破世界灾厄——{bossName}的战斗中总输出第一，强到爆炸！",
    "systemTaskConfigContent_11": "【世界灾厄】{bossName}将在{num}分钟后降临大陆",
    "systemTaskConfigContent_12": "【世界灾厄】{bossName}降临",
    "systemTaskConfigContent_10": "尊敬的勇士{userName}：\\n \\n非常遗憾，{bossName}未被击破。\\n \\n“错的不是我，而是这个发件人！∠( :>」∠)＿”",
    "messageInitNick_4402": "控魂者",
    "messageInitNick_4401": "遥遥领先",
    "messageInitNick_4400": "眉眼藏山河",
    "messageInitNick_4406": "你最好别想我",
    "messageInitNick_4405": "贝壳里的公主",
    "messageInitNick_4404": "美丽的迷宫主",
    "messageInitNick_4403": "傲娇的野狗",
    "messageInitNick_4409": "悲报你要输了",
    "messageInitNick_4408": "树莓兽",
    "messageInitNick_4407": "告别过去",
    "98_-190002": "你尚未加入部落，加入部落后再发送部落消息",
    "98_-190001": "历史消息正在同步",
    "98_-190003": "没有加入异象聊天组",
    "98_-190006": "该线路已满",
    "98_-190005": "你要切换的分线不存在",
    "randomEventDialogueGroupConfig_12.108": "离开",
    "randomEventDialogueGroupConfig_12.107": "多挠挠其他位置",
    "randomEventDialogueGroupConfig_12.109": "就在你挠到它耳边的瞬间，它整个弹了起来，然后发狂似地跑远了。",
    "randomEventDialogueGroupConfig_12.104": "认真回答不行",
    "randomEventDialogueGroupConfig_12.103": "算我输，不行吗！",
    "randomEventDialogueGroupConfig_12.106": "它似乎完全不怕痒，睡得更香了。",
    "randomEventDialogueGroupConfig_12.105": "妥协离开",
    "randomEventDialogueGroupConfig_12.100": "初看商店确实空空如也。",
    "randomEventDialogueGroupConfig_12.102": "随便翻翻",
    "randomEventDialogueGroupConfig_12.101": "仔细翻查",
    "randomEventDialogueGroupConfig_12.151": "哦哦，有意思，请继续细说排位赛。",
    "randomEventDialogueGroupConfig_12.150": "离开",
    "randomEventDialogueGroupConfig_12.153": "暗示想交易",
    "messageInitNick_11805": "树莓去哪了",
    "randomEventDialogueGroupConfig_12.152": "给它细说",
    "messageInitContent_2239": "但暴君现在会让攻速变慢了",
    "messageInitContent_2238": "现在还有持久元核的吗？",
    "messageInitContent_2237": "送你一个持久元核！",
    "messageInitContent_2236": "黯炎魔龙变得比一拳持久了！",
    "messageInitContent_4898": "我让猜猜鸭子后面的是谁",
    "messageInitNick_11800": "别求我复合",
    "messageInitContent_4899": "bgmon",
    "messageInitNick_11804": "收购寂寞",
    "messageInitNick_11803": "白龙马",
    "messageInitNick_11802": "巴丝提女神",
    "messageInitNick_11801": "柚子射手",
    "messageInitContent_2246": "变成懵比巨炮了吧",
    "randomEventDialogueGroupConfig_12.159": "谢谢你的分享，开心。拜拜。",
    "messageInitContent_2245": "我记得以前有只亚种懵比的去哪了？",
    "randomEventDialogueGroupConfig_12.158": "不唠嗑了",
    "messageInitContent_2244": "可怜的比蒙又要被我打败了",
    "messageInitContent_2243": "小人保护协会就位！",
    "messageInitContent_2242": "可怜的小人缩在两只吓人的怪兽中间！",
    "randomEventDialogueGroupConfig_12.155": "离开",
    "messageInitContent_2241": "例如？",
    "randomEventDialogueGroupConfig_12.154": "它一听，立刻高速滚远，完全追不上的样子。",
    "messageInitContent_2240": "快来点让我攻速暴涨的东西！",
    "randomEventDialogueGroupConfig_12.157": "随便分享",
    "randomEventDialogueGroupConfig_12.156": "原来如此，好像很好玩的样子呢。和你吹水真开心，还有什么新鲜玩意，也给我分享一下呗？",
    "randomEventDialogueGroupConfig_12.162": "继续唠嗑",
    "randomEventDialogueGroupConfig_12.161": "哇，好棒。",
    "randomEventDialogueGroupConfig_12.164": "好开心啊，不用提工作的对话最棒了！拜拜。",
    "randomEventDialogueGroupConfig_12.163": "不唠了",
    "messageInitContent_2249": "污污污污污污污污污污污污污污",
    "messageInitContent_2248": "你存在我婶婶的脑海里",
    "randomEventDialogueGroupConfig_12.160": "离开",
    "messageInitContent_2247": "它会永远活在你的回忆里",
    "messageInitContent_2257": "策划是真的想搞我后排",
    "messageInitContent_2256": "神提莫死神之眼是吧。",
    "randomEventDialogueGroupConfig_12.169": "可惜我没什么可以和你分享的。只能听着你说。",
    "messageInitContent_2255": "不可以80，哒咩！（认真脸）",
    "messageInitContent_2254": "我生气了！",
    "messageInitContent_2253": "大家快笑它！",
    "randomEventDialogueGroupConfig_12.166": "我听不懂你在说什么。",
    "messageInitContent_2252": "它承认它是黄色灵魂了！",
    "randomEventDialogueGroupConfig_12.165": "告别",
    "messageInitContent_2251": "破魂领主，它不仅要收集我黄色的灵魂，它还要把我变小",
    "randomEventDialogueGroupConfig_12.168": "离开",
    "messageInitContent_2250": "在海边排污是不对的！",
    "randomEventDialogueGroupConfig_12.167": "明示想交易",
    "randomEventDialogueGroupConfig_12.173": "离开",
    "randomEventDialogueGroupConfig_12.172": "谢谢你的分享，今天好开心，拜拜。",
    "randomEventDialogueGroupConfig_12.175": "婉拒离开",
    "randomEventDialogueGroupConfig_12.174": "摸鱼能量充满，突然有了一点工作的动力。我的店没有打理很久了，但可以到我熟人的店里看看。要去吗？",
    "messageInitContent_2259": "巽哥主场",
    "randomEventDialogueGroupConfig_12.171": "不唠了",
    "messageInitContent_2258": "很想很想",
    "randomEventDialogueGroupConfig_12.170": "继续唠嗑",
    "messageInitContent_2260": "后排之本是吧",
    "messageInitContent_2268": "dna动了",
    "messageInitContent_2267": "奇怪标题，男人，唱歌，",
    "messageInitContent_2266": "它是真的想在这开演唱会的！",
    "messageInitContent_2265": "霸者我终于找到你了！",
    "messageInitContent_2264": "第二小关！尸狂的排面！",
    "randomEventDialogueGroupConfig_12.177": "不不不，还真不是。你有什么证据证明我是神秘商人？",
    "messageInitContent_2263": "什么吉之岛笑死我了",
    "randomEventDialogueGroupConfig_12.176": "同意",
    "messageInitContent_2262": "笑死万一其实它们还有隐藏的名字",
    "randomEventDialogueGroupConfig_12.179": "它别过身去了。",
    "messageInitContent_2261": "怪兽的名字我可都是知道了",
    "randomEventDialogueGroupConfig_12.178": "说神秘商人就长它那样",
    "randomEventDialogueGroupConfig_12.184": "神秘商人已经滚远了。",
    "randomEventDialogueGroupConfig_12.183": "放弃争辩离开",
    "randomEventDialogueGroupConfig_12.186": "它滚远了，渐渐消失在你的视野之中。",
    "systemTaskConfigContent_66": "亲爱的{userName}：\\n \\n为提升游戏体验，我们对部分服务器的角色重名规则进行了优化调整，根据本次调整，系统已自动为您进行了更名，造成不便敬请谅解，感谢您的理解与支持！而这条在您身边潜伏已久的探索者改名根选择在此刻现身，它觉得您会需要它。\\n \\n“{oldnick}！缘，妙不可言~”",
    "randomEventDialogueGroupConfig_12.185": "离开",
    "systemTaskConfigContent_67": "亲爱的{userName}：\\n \\n为提升游戏体验，我们对部分服务器的部落重名规则进行了优化调整，根据本次调整，系统已自动为您的部落进行了更名，造成不便敬请谅解，感谢您的理解与支持！您可以利用这条闪闪发光从天而降的部落改名根，对部落名称进行修改。\\n \\n“{oldnick}！缘，从何而起~”",
    "randomEventDialogueGroupConfig_12.180": "提出偶尔破例一次也可以",
    "systemTaskConfigContent_64": "亲爱的{userName}：\\n \\n进化之实活动重置完成，欢迎您再次参与。在此奉上在该活动重置前您尚未领取的进化之实奖励，请查收。此外，本邮件的有效期为14日，请您尽快领取以免造成不必要的损失。\\n \\n“遗落的进化之实正静候您的摘取。”",
    "systemTaskConfigContent_65": "亲爱的{userName}：\\n \\n您的永恒赠礼已至，请收好哦。\\n \\n“不变只是永恒的表象，永恒将孕育无限延展的可能。”",
    "randomEventDialogueGroupConfig_12.182": "说神秘商人的声音就是那样",
    "systemTaskConfigContent_62": "<face color=#ffffff dilate=0.52 softness=0.07>亲爱的{userName}：\\n \\n很遗憾，您的预测有误！在本轮源初境「{attackServerName}-{attackUserNick}」与「{defendServerName}-{defendUserNick}」的对战中，您投注的探索者「{voteServerName}-{voteUserNick}」没有取得胜利。点击下方录像即可进行观战。\\n \\n“您用实际行动践行了‘远离箔材’的这一精神！”\\n\\n<on click='jumpToHooCup' param='{originRealmRecordId},{realmSeason}'><face color=#ff9900 dilate=0.55 softness=0.07>>>点击前往观战</face></on></face>",
    "messageInitContent_2269": "bgm是不是应该醒目点",
    "randomEventDialogueGroupConfig_12.181": "你认错啦。",
    "systemTaskConfigContent_63": "亲爱的{userName}：\\n \\n当前角色所属于的账号已完成账号迁移，在此奉上账号绑定福利，请您务必妥善保管好自己原账号（雷霆）和NTFusion账号的登录信息，注意个人隐私安全，以免遗忘或在绑定过程中发生不必要的损失！\\n \\n“崭新的账号登录入口，熟悉的超进化大陆！”",
    "systemTaskConfigContent_60": "亲爱的{userName}：\\n \\n您在源初境对战中斩获六十四强，获得了相应的奖励！\\n \\n“都来过一次了，第二次，第三次还会远吗？”",
    "systemTaskConfigContent_61": "<face color=#ffffff dilate=0.52 softness=0.07>亲爱的{userName}：\\n \\n恭喜您！您的预测正确！在本轮源初境「{attackServerName}-{attackUserNick}」与「{defendServerName}-{defendUserNick}」的对战中，您投注的探索者「{voteServerName}-{voteUserNick}」取得胜利，在此奉上相应的奖励。点击下方录像即可进行观战。\\n \\n“运气也好，实力也罢，一次正确猜想总会是连续猜想正确的美妙开端~”\\n\\n<on click='jumpToHooCup' param='{originRealmRecordId},{realmSeason}'><face color=#ff9900 dilate=0.55 softness=0.07>>>点击前往观战</face></on></face>",
    "messageInitContent_2271": "我宣布莎士彼亚是最强辅助",
    "messageInitContent_2270": "大剧王！你的镇魂呢？",
    "messageInitContent_2279": "给大家看看什么是真正的aoe",
    "messageInitContent_2278": "这真的一斧子下去妖火下半身没了",
    "messageInitContent_2277": "斧头帮老大参上！",
    "messageInitContent_2276": "真香警告！",
    "messageInitContent_2275": "你哪个游戏过来了，剧王警告",
    "randomEventDialogueGroupConfig_12.188": "你绝对听错了，而且谁都不会关心神秘商人的声音！",
    "messageInitContent_2274": "好了都别整了，锤石才是最强辅助。",
    "randomEventDialogueGroupConfig_12.187": "离开",
    "messageInitContent_2273": "我孢皮匠表示不服！",
    "systemTaskConfigContent_59": "亲爱的{userName}：\\n \\n您在源初境对战中斩获三十二强，获得了相应的奖励！\\n \\n“都赢过一次了，第二次，第三次还会远吗？”",
    "messageInitContent_2272": "毕竟人家拿着剧本",
    "randomEventDialogueGroupConfig_12.189": "说给人的感觉就是这样",
    "systemTaskConfigContent_57": "亲爱的{userName}：\\n \\n您在源初境对战中斩获八强，获得了相应的奖励！\\n \\n“名人堂见！”",
    "systemTaskConfigContent_58": "亲爱的{userName}：\\n \\n您在源初境对战中斩获十六强，获得了相应的奖励！\\n \\n“距离名人堂最近的一次，但绝不会是唯一的一次。”",
    "systemTaskConfigContent_55": "亲爱的{userName}：\\n \\n您在源初境对战中斩获亚军，获得了相应的奖励！\\n \\n“只尝一败或许正是未尝一败的开端。”",
    "systemTaskConfigContent_56": "亲爱的{userName}：\\n \\n您在源初境对战中斩获四强，获得了相应的奖励！\\n \\n“你是四强，冠军和亚军也是四强，四舍五入！”",
    "systemTaskConfigContent_53": "亲爱的{userName}：\\n \\n您在进击巨物排行中斩获第{ranking}名（{clientDisplay}），获得了相应的奖励！\\n \\n“巨物不可战胜？越巨即是越强？你的战斗给出了答案。”",
    "systemTaskConfigContent_54": "亲爱的{userName}：\\n \\n您在源初境对战中斩获冠军，获得了相应的奖励！\\n \\n“毫无疑问的战区最强。”",
    "systemTaskConfigContent_51": "亲爱的{userName}：\\n \\n根据数据互通规则，系统已自动为您的部落进行了更名，您可以利用这条闪闪发光从天而降的部落改名根，对部落名称进行修改。\\n \\n“{oldnick}！缘，从何而起~”",
    "systemTaskConfigContent_52": "亲爱的{userName}：\\n \\n您在巨物进击排行中斩获第{ranking}名（{clientDisplay}），获得了相应的奖励！\\n \\n“知彼知己者，百战不殆。成为巨物，再击破巨物。”",
    "systemTaskConfigContent_50": "亲爱的{userName}：\\n \\n根据数据互通规则，系统已自动为您进行了更名，这条在您身边潜伏已久的探索者改名根选择在此刻现身，它觉得您会需要它。\\n \\n“{oldnick}！缘，妙不可言~”",
    "messageInitContent_2282": "奶or不奶，这是个问题。",
    "messageInitContent_2281": "妖火我家煤炉需要你",
    "messageInitContent_2280": "拿斧子的大哥哥加油啊",
    "randomEventDialogueGroupConfig_12.119": "拿走",
    "randomEventDialogueGroupConfig_12.118": "你翻到了什么。",
    "randomEventDialogueGroupConfig_12.115": "拿起第二件",
    "messageInitContent_2289": "一直觉得破面好帅！",
    "randomEventDialogueGroupConfig_12.114": "拿起第一件",
    "messageInitContent_2288": "进化之后破面的保护能力更强了，哭哭",
    "randomEventDialogueGroupConfig_12.117": "都不要",
    "messageInitContent_2287": "请问这里哪里有天桥。",
    "randomEventDialogueGroupConfig_12.116": "都拿起来",
    "messageInitContent_2286": "不好意思这里有人了。这里我先占了",
    "randomEventDialogueGroupConfig_12.111": "它叹了口气，高速滚远了。",
    "messageInitContent_2285": "我选择睡……天桥底！",
    "randomEventDialogueGroupConfig_12.110": "离开",
    "messageInitContent_2284": "为所欲为~",
    "randomEventDialogueGroupConfig_12.113": "翻到两件东西。",
    "systemTaskConfigContent_48": "亲爱的{userName}：\\n \\n您的部落「{ownServerName}-{ownTribeName}」在本次部落战中对阵「{opnServerName}-{opnTribeName}」，以【{ownScore}:{opnScore}】的比分{tribeResult}，部落繁荣度提升了{tribeScoreChange}，并获得了{ownTribeWarReward}。\\n \\n“胜败乃兵家常事，享受一起战斗的时光足矣~若是碰巧平了，就……就交个朋友吧！”",
    "messageInitContent_2283": "什么被自己奶死了？奈斯？？？",
    "randomEventDialogueGroupConfig_12.112": "离开",
    "systemTaskConfigContent_49": "亲爱的{userName}：\\n \\n您的部落「{ownServerName}-{ownTribeName}」在本次部落战中轮空，部落繁荣度提升了{tribeScoreChange}，并获得了{ownTribeWarReward}。\\n \\n“对手呢？难道这就是所谓的天下无敌吗？就……就字面意思~”",
    "systemTaskConfigContent_46": "亲爱的{userName}：\\n \\n您在突围鏖战排行中斩获第{ranking}名（{clientDisplay}），获得了相应的奖励！\\n \\n“突出重围，直至突破天际！”",
    "systemTaskConfigContent_47": "亲爱的{userName}：\\n \\n您在合围破阵排行中斩获第{ranking}名（{clientDisplay}），获得了相应的奖励！\\n \\n“听说夹击会有攻击加成，接下来再骰个命中吧！”",
    "randomEventDialogueGroupConfig_12.120": "留给它",
    "systemTaskConfigContent_44": "亲爱的{userName}：\\n \\n感谢您在删档测试对《超进化物语2》的鼓励与支持！根据您参与历次测试付费的情况，为您返还以下奖励。如有疑问，可咨询客服人员进行确认。祝您在超进化大陆探索愉快！\\n \\n“破茧、羽化或创化，你的同行不曾变化。很感动，又不敢动，守着资源不敢乱动，您快拿好，要抽筋了！”",
    "systemTaskConfigContent_45": "亲爱的{userName}：\\n \\n您在{chargeTime}充值的{iapBuyConfigName}已完成并成功到账，请您查收。",
    "systemTaskConfigContent_42": "<face color=#ffffff dilate=0.52 softness=0.07>亲爱的{userName}：\\n \\n恭喜您，您在创世竞猜中选择的队伍在战斗中获胜，在此奉上相应的奖励。点击下方录像即可进行观战。\\n \\n“预知不过是极致的推演，一切就如您推演那般，分毫不差。”\\n\\n<on click='jumpToGuess'><face color=#ff9900 dilate=0.55 softness=0.07>>>点击前往观战</face></on></face>",
    "systemTaskConfigContent_43": "<face color=#ffffff dilate=0.52 softness=0.07>亲爱的{userName}：\\n \\n很遗憾，您在创世竞猜中选择的队伍在战斗中落败，在此奉上相应的奖励。点击下方录像即可进行观战。\\n \\n“不断将偏差修正，终有一日可抵达真实。”\\n\\n<on click='jumpToGuess'><face color=#ff9900 dilate=0.55 softness=0.07>>>点击前往观战</face></on></face>",
    "systemTaskConfigContent_40": "<face color=#ffffff dilate=0.52 softness=0.07>{userName}！{userName}！\\n\\n【我方部落】占领的{tribeNodeConfigName}进入交战状态，请求支援！请求支援！请求支援！\\n\\n<on click='jumpToRelic' param='{tribeNodeId},{tribeId},{tribeSeason}'><face color=#ff9900 dilate=0.55 softness=0.07>>>点击闪现到遗迹，派遣部队进行支援</face></on></face>",
    "systemTaskConfigContent_41": "<face color=#ffffff dilate=0.52 softness=0.07>{userName}！{userName}！\\n\\n【我方部落】宣战的{tribeNodeConfigName}进入交战状态，请求支援！请求支援！请求支援！\\n\\n<on click='jumpToRelic' param='{tribeNodeId},{tribeId},{tribeSeason}'><face color=#ff9900 dilate=0.55 softness=0.07>>>点击闪现到遗迹，派遣部队进行支援</face></on></face>",
    "messageInitContent_2293": "怪兽都是不穿的啊",
    "messageInitContent_2292": "？？？你在说什么",
    "messageInitContent_2291": "别穿了，别穿了~~",
    "messageInitContent_2290": "肤浅，当然是看内在（指技能）",
    "randomEventDialogueGroupConfig_12.129": "离开",
    "randomEventDialogueGroupConfig_12.126": "你又找到了什么，看起来不错。",
    "randomEventDialogueGroupConfig_12.125": "离开",
    "messageInitContent_2299": "我赌5毛找赤虹",
    "randomEventDialogueGroupConfig_12.128": "你发现它没有往这个方向滚，但这里风景好极了。",
    "messageInitContent_2298": "猜猜火神到这是做什么的？",
    "randomEventDialogueGroupConfig_12.127": "拿走",
    "messageInitContent_2297": "一人血书求一直穿越兽！",
    "randomEventDialogueGroupConfig_12.122": "拿走",
    "systemTaskConfigContent_39": "亲爱的{userName}：\\n \\n您在{chargeTime}时充值的{iapBuyConfigName}订单已完成并成功到账，请您查收。\\n \\n※ 本邮件仅用作通知，相关奖励已自动获得",
    "messageInitContent_2296": "你伤害了我，却一笑而过",
    "randomEventDialogueGroupConfig_12.121": "看起来不错。",
    "messageInitContent_2295": "反正这游戏有没有护甲的说法！",
    "randomEventDialogueGroupConfig_12.124": "再翻翻其他地方",
    "messageInitContent_2294": "不不，污妖王还是以后穿的",
    "randomEventDialogueGroupConfig_12.123": "那是厚厚的一沓树叶，从上面的图形大概能看出是对神秘商人的一些要求。",
    "systemTaskConfigContent_38": "亲爱的{userName}：\\n \\n智者轮盘活动即将结束，请您及时到活动现场领取奖励，以避免活动结束带来的影响。\\n \\n“和不要停下来啊相反，轮盘总让人忍不住大喊：给我停下来啊。”",
    "systemTaskConfigContent_35": "亲爱的{userName}：\\n \\n这是您的验证码{verifyCode}，快带着它完成登录吧。\\n \\n“系统最新提醒：看好您的验证码哦！”",
    "systemTaskConfigContent_36": "尊敬的勇士{userName}：\\n \\n{bossName}正要离开之际，突然眼前一黑，瞬间破防，爆了一地粉尘。您本次在世界灾厄排行中斩获第{ranking}名（{clientDisplay}），获得了相应的奖励。\\n \\n“是你在改变结局吗？世界线偏移警告。∠( :>」∠)＿”",
    "randomEventDialogueGroupConfig_12.131": "离开",
    "systemTaskConfigContent_33": "亲爱的{userName}：\\n \\n兑换码已成功兑换，请查收您的奖励。\\n \\n“以前苹果只会从树上砸下来，现在苹果还会在床上方砸下来！”",
    "randomEventDialogueGroupConfig_12.130": "它果然就是往这个方向滚的，而且还掉下去山谷里了！你能听到山谷回档的惨叫声。",
    "systemTaskConfigContent_34": "亲爱的{userName}：\\n \\n蜕变契约重置完成。上一阶段尚未领取的蜕变契约奖励亦如约而至，请查收。\\n \\n“终将如契约所言般迎来一次次的蜕变。”",
    "systemTaskConfigContent_31": "亲爱的{userName}：\\n \\n造唤盛宴活动即将结束，请您及时到活动现场领取奖励，以避免活动结束带来的影响。\\n \\n“结束时刻的落寂会恰到好处地诠释盛宴的美好。”",
    "systemTaskConfigContent_32": "亲爱的{userName}：\\n \\n神奇树洞活动即将结束，请您及时到活动现场领取奖励，以避免活动结束带来的影响。\\n \\n“在大大的树洞里挖呀挖呀挖，听哔哔的对话，Get大大的瓜~”",
    "systemTaskConfigContent_30": "亲爱的{userName}：\\n \\n您的鎏金月曜赠礼已至，请收好哦。\\n \\n“那个……您是在赏月吗？要靠近一点吗？欸？(゜▽゜*)我是说要不要捎您飞过去一点~”",
    "randomEventDialogueGroupConfig_12.137": "离开",
    "randomEventDialogueGroupConfig_12.136": "找它",
    "randomEventDialogueGroupConfig_12.139": "山洞",
    "randomEventDialogueGroupConfig_12.138": "要去哪里找呢？",
    "randomEventDialogueGroupConfig_12.133": "上前追问",
    "systemTaskConfigContent_28": "亲爱的{userName}：\\n \\n兑换码已成功兑换，请查收您的奖励。\\n \\n“兑换码与兑换奖励之间的关系在此刻被秘密揭晓~”",
    "randomEventDialogueGroupConfig_12.132": "它开始缓慢滚远。",
    "systemTaskConfigContent_29": "亲爱的{userName}：\\n \\n您的纹银月曜赠礼已至，请收好哦。\\n \\n“那个……您是在赏月吗？”",
    "randomEventDialogueGroupConfig_12.135": "它躲了起来。",
    "systemTaskConfigContent_26": "亲爱的{userName}：\\n \\n我们接到iOS平台通知，您在{chargeTime} 时充值的{iapBuyConfigName}订单已成功申请退款，根据该订单情况，系统已将相应的{decreaseCount}{propName}{1}从您的账户上扣除，请知悉。",
    "randomEventDialogueGroupConfig_12.134": "由它离开",
    "systemTaskConfigContent_27": "亲爱的{userName}：\\n \\n感谢您参与我们的问卷调查，在此奉上奖励。\\n \\n“为超进化的超进化添砖加瓦，呃……添孢子加鸡腿！”",
    "randomEventDialogueGroupConfig_12.140": "池塘",
    "systemTaskConfigContent_24": "亲爱的{userName}：\\n \\n您在暴走旷野的击破数为{killed}，在排行中斩获第{ranking}名（{clientDisplay}），获得了相应的奖励！\\n \\n“我们只能奋起或倒地。”",
    "systemTaskConfigContent_25": "亲爱的{userName}：\\n \\n由于您重复购买了{iapBuyConfigName}，现退还您{refundCost}面额的等值代金券（可用于购买内购项），给您带来不便，我们深表歉意！",
    "randomEventDialogueGroupConfig_12.142": "你找到了“哪里”，但没找到神秘商人。",
    "systemTaskConfigContent_22": "亲爱的{userName}：\\n \\n您的探索者名称含有敏感信息，已被系统强制修改。给您带来的不便，敬请谅解。",
    "randomEventDialogueGroupConfig_12.141": "哪里",
    "systemTaskConfigContent_23": "亲爱的{userName}：\\n \\n您的部落名称含有敏感信息，已被系统强制修改。给您带来的不便，敬请谅解。",
    "systemTaskConfigContent_20": "亲爱的{userName}：\\n \\n您的探索者名称含有敏感信息，已被系统强制修改，这条在您身边潜伏已久的探索者改名根选择在此刻现身，它觉得您会需要它。\\n \\n“就算你改了名，我还是会认得你的！——好友”",
    "systemTaskConfigContent_21": "亲爱的{userName}：\\n \\n您的部落名称含有敏感信息，已被系统强制修改，可以利用那条闪闪发光从天而降的部落改名根进行修改。",
    "randomEventDialogueGroupConfig_12.148": "逃跑",
    "randomEventDialogueGroupConfig_12.147": "战斗",
    "systemTaskConfigContent_19": "亲爱的{userName}：\\n \\n目前探索者名称创建受限，只能使用系统默认名称，当名称创建不再受限时，可以利用这条闪闪发光从天而降的探索者改名根修改名称。\\n \\n“就算你改了名，我还是会认得你的！——好友”",
    "randomEventDialogueGroupConfig_12.149": "它为了逃避工作，跑得贼快，你并没有追上。",
    "randomEventDialogueGroupConfig_12.144": "山洞里没有找打它。",
    "systemTaskConfigContent_17": "亲爱的{userName}：\\n \\n您本月在凿星裂痕排行中斩获第{ranking}名（{clientDisplay}），获得了相应的奖励！无论是孤军奋战，还是结伴同行，都有所收获。\\n \\n“越发深入，越发沉沦。甚至以为，这份渴求确实来自心底……”",
    "randomEventDialogueGroupConfig_12.143": "离开",
    "systemTaskConfigContent_18": "亲爱的{userName}：\\n \\n您的部落「{tribeName}」本赛季在部落之王排行中斩获第{ranking}名（{clientDisplay}），获得了相应的奖励！\\n \\n“听说只要集齐这三要素部落就会更加繁荣和强大，分别是摸鱼的成员、划水的管理和女装的酋长，快集齐他们吧！P.S.负责运送奖励的疾风兔跟我们说：‘丰厚的奖励必须要交给实力最为强劲的部落护送！’我们信了！后来送得累死累活的，才发现上当了！它甩甩手，活我们全干了！(#ˋ^ˊ）。  ”",
    "randomEventDialogueGroupConfig_12.146": "你发现了摸鱼的神秘商人，鱼都被吓跑了。#没办法摸鱼的神秘商人怒气冲冲地向你冲了过来。",
    "systemTaskConfigContent_15": "亲爱的{userName}：\\n \\n您在{nodeName}斗技场排行中斩获第{ranking}名（段位{rankLevel}积分{clientDisplay} +），获得了相应的奖励！\\n \\n“真羡慕，我以前也是一个探索者，直到膝盖中了一箭！左手中了一箭……右脚中了一箭……胸膛……后背……后脚跟……”",
    "randomEventDialogueGroupConfig_12.145": "离开",
    "systemTaskConfigContent_16": "{userName}，你的背包满了，放不下的东西都掉出来啦。幸亏是我捡到了，呐，都给你送回来了，记得取走噢！日行一善（1/1）",
    "messageInitContent_4939": "你好烧哦",
    "resoundEventConfigDes_6009": "日月姐妹被安置在一个冰穴内休息，朱雀和她们一起，试图推导出那个洞穴的所在。\\n“那片暴风雪，是邪王的结界？”\\n“既然张开结界，就说明邪王有着无法与我们为敌的自知之明。我们一口气闯进去怎么样？”\\n“等等，说不定是个陷进，故意等着各位英雄自投罗网。”\\n鲁莽地冲进暴风雪是轻易的事，但在里面找准方向继续前进，连朱雀自己也没办法完全做到。\\n“不可以放任大家有危险不顾，我想过去看看。”\\n“可是，即使让你找到大家，又怎么把大家带回来呢？”\\n“他们不是姐姐的信徒，没必要听姐姐的话。而且，小豆丁不是说，那些尸族对雕凿冰块的事乐此不疲吗？”\\n就在大家支离破碎地讨论着，丝毫没有统一迹象的时候，尸族族长，寇斯金回来了。\\n“对不起……你们还是走吧。”\\n寇斯金的执着就像他的肌肉一样坚硬，日月姐妹，就这么被下了逐客令。\\n寇斯金想得到的是暴虐战狂或者古拉姆那种战士的帮助，如果他们能带一支战队过来，就更好了。但是，这对属于治疗系的姐妹，对本来就具备强大的回血和不死技能的尸族来说，是画蛇添足般的存在。\\n告别了寇斯金，日月姐妹和朱雀只好继续原来的计划，那片笼罩在暴风雪中的极北之地，依旧是他们的目的地。\\n“唔呣，你们要走了吗？”豆丁幼尸追了上来，怀里捧着一堆冰沙团子。\\n“嗯，再见，你以后不要再到处乱跑了。”月夕温柔地摸了摸豆丁幼尸的头。\\n“这些，俺一直带在身上的零食，送给你们唔呣。”那是饯别的礼物。\\n李雨蒙和日夕倒吸了一口冷气，想起了形状相似的墨绿色存在。\\n看到了日夕怪异的表情，豆丁幼尸以为她不知道这是能吃的东西。\\n“饿的时候唔呣，这样！”豆丁幼尸拿起一个团子，一口咬下去，津津有味地吃起来。\\n他迫不及待地又吃了一个，但是，嗯，是个会把自己最喜欢的东西送给客人的好孩子。\\n冰沙碎屑从豆丁幼尸的嘴边簌簌掉落，大家看着他呆萌天真的样子，不由得一扫之前的沮丧。\\n“等等……雪融了？”细心的欧文留意到豆丁幼尸的脚边积了一滩水。\\n他拿起一个冰沙团子，好奇地舔了舔，咸的，原来如此。\\n是冰沙团子中的盐融化了那些积雪，欧文把那个简单的化学原理告诉了月夕。超进化大陆的料理真是一言难尽啊。\\n“是来自结晶平原的咸味，盐巴是那里的特产。”月夕稍微向欧文介绍了一下那片他还没有去过的平原。\\n“冰沙团子是盐巴的做法之一，由两倍的盐粒和冰沙搅混在一起制成，另一种是石夹盐，做法是把盐巴夹在被烧得滚烫的铁矿石块或火山岩块之间，对龙族和尸族来说，都是散发着男子汉味道的佳肴。说不定，这两族怪兽比远古族的那位智者更有烹饪天赋。”朱雀又补充道。\\n李雨蒙有点好奇，甜甜的冰沙她吃多了，但咸冰沙还没吃过。于是，她（让日夕）也鼓起勇气，拿起一个冰沙团子，轻轻舔了舔。\\n那种普通的东西也算特产吗？不过呢，这正是建立盐巴贸易圈的好机会。欧文的脑子很聪明，他只是用一两秒的时间描绘出那幅蓝图，但是——\\n“为什么混着盐巴的冰沙团子却不会轻易融掉呢？”\\n“俺不知道你在说啥，唔呣，俺只知道捏团子的是幽鬼姐姐，做团子的冰沙，是吞噬者哥哥的口水结成的冰，唔呣。”\\n原来是食材自身属性的结果。\\n“就是说吞噬者那张大嘴巴的唾液，有某种不易被盐融化的特性，所以才能和盐巴混在一起。”欧文再次感到这个世界的奇妙。\\n与之形成鲜明对比的，是扔掉冰沙团子在一边呕吐的日夕（和李雨蒙）。\\n虽然明知道这里的吞噬者不是那个斗技场上的吞噬者，但充满口臭的狂笑，再次回荡在日夕的耳边和鼻间。而且再怎么说，舔别人的口水，本来就是一件很不干净的事呀！\\n就像间接接吻什么的……不对！千万不要再往那个方向想！\\n“小夕，你怎么了？”月夕一边说，一边轻轻地拍打着妹妹的背部。\\n而欧文很快就发现了另一个重要的信息，他请月夕先让他完成对豆丁幼尸的询问。\\n“小家伙，你跟踪那位大哥哥的时候，也带着这种团子吗？”\\n“唔呣。”\\n“一边跟踪一边吃？”如果是这样就太幸运了！\\n“唔呣！”\\n“唔呣唔呣！！”欧文也学着豆丁幼尸的尾音，欢呼，“我知道怎么找到失踪的尸族了！”",
    "messageInitContent_4931": "搞什么实验啊",
    "messageInitNick_11767": "到店下班",
    "propConfigDes_90205": "收集30块紫色体力元核碎片可以合成紫色品质体力元核。",
    "messageInitContent_4932": "这花花世界不适合我",
    "messageInitNick_11766": "苍白的笑颜",
    "propConfigDes_90206": "收集30块橙色体力元核碎片可以合成橙色品质体力元核。",
    "messageInitContent_4933": "老兄你脑子掉了",
    "messageInitNick_11765": "爱已剧终",
    "propConfigDes_90203": "收集30块绿色体力元核碎片可以合成绿色品质体力元核。",
    "messageInitContent_4934": "啊这是",
    "messageInitNick_11764": "情话太甜",
    "propConfigDes_90204": "收集30块蓝色体力元核碎片可以合成蓝色品质体力元核。",
    "messageInitContent_4935": "音响店懂了",
    "messageInitContent_4936": "你吵到我眼睛了",
    "propConfigDes_90202": "收集30块白色体力元核碎片可以合成白色品质体力元核。",
    "messageInitContent_4937": "燃烧的沼泽",
    "messageInitNick_11769": "芦笋撞地球",
    "messageInitContent_4938": "燃烧的草丛",
    "messageInitNick_11768": "眼睛出汗了",
    "messageInitNick_11763": "梦幻的火龙果",
    "messageInitNick_11762": "老子你惹不起",
    "messageInitContent_4940": "一闪一闪小闪光",
    "messageInitNick_11761": "红尘乱我心",
    "propConfigDes_90207": "收集30块红色体力元核碎片可以合成红色品质体力元核。",
    "messageInitContent_4941": "反复横跳",
    "messageInitNick_11760": "脸让猫挠了",
    "resoundEventConfigDes_6001": "飞过冰川谷后，朱雀来到了极寒冻土的边缘。狂风裹挟着大片大片灰白雪花猛地扑向这位稀客，仅留给他极为狭小的视野。即使没有实体，朱雀也能强烈感受到自己几乎被吹灭的压迫感。在暴风雪的阻挠之下，他根本找不到邪王的踪迹，只能隐约感受到那股邪恶的能量日渐强大。\\n和所有神灵一样，朱雀对邪王仅有非常有限且模糊的记忆。这很不寻常。\\n神灵们通常不会遗忘，他们的精神相互连接，就像漫天繁星偶有光流相接，这些星正是记录世界的光之海。也正是如此，他们对世界的认知和记忆远比其他生命来得深远。\\n朱雀推测有关邪王的记忆很可能是被抹去了，就在每次邪王战争后，光之海彻底熄灭的一瞬。其他和邪王有所接触的英雄和怪兽无一例外忘记了邪王。这片大陆仅仅记住了——千年后，灾难将再临。\\n但朱雀不认为这是邪王的所为，如果他们真有这样的力量，我们根本没有胜算。\\n正因如此，留传到后世的邪王形象才会那般模糊不清。\\n而且，随着怪兽的世代更迭，壮烈的战争也渐渐成为传说。\\n这片大陆，被什么未知的力量控制着……\\n这才是盘踞在朱雀心头最大的不安。\\n这次探索也是一无所获，朱雀只好飞回冰川谷。冷冽的寒风比刚才狂乱的暴风雪温和，但仍然无法让朱雀焦躁的心情平静下来，他俯瞰身下广袤的冰雪之地，活跃在上面的尸族似乎又少了一些。前段日子失踪的都是些健壮的尸族，现在，尸族幼体躲在山穴中不敢出来，几支由幻化级和少数究极级组成的巡逻队伍正在不同的区域巡逻。\\n朱雀让尸族族长寇斯金向那几组不朽级的英雄求助，英雄们向北前进，寇斯金一定会遇上他们。\\n现在，尸族正等待族长带着援军回归。",
    "resoundEventConfigDes_6002": "但是，就像每个大家庭都有不听话的孩子，巡逻队也无法照顾所有族内的熊孩子。正如此时，他们完全不知道有一个天不怕地不怕的捕食者，跑到危险的冰谷边缘锻炼身体和打猎。\\n捕食者一边蛙跳一边寻找出没在雪穴中的屁屁羚，他曾向小伙伴们夸下海口，会带三只屁屁羚回去，小伙伴们就搭好烧烤架等他回来好了。\\n跳着跳着，捕食者被脚边一颗剔透的紫色冰晶吸引了。冰晶在阳光下，折射出美妙的光芒。捕食者放眼前方，数点紫色的亮光组成一条蜿蜒的“闪光带”。\\n闪光带吸引着捕食者继续往前跳，风雪渐渐大了起来，遮挡了前方的景象，但闪光带在的光芒一点也没有减弱，反而像一条清晰的道路，指引着捕食者前进的方向。\\n没多久，闪光带就把捕食者带到一座雕像前。\\n显而易见，这是一对情侣的冰雕，穿着裙子的雌性有一双大长腿，和雌性翩翩起舞的雄性连她的一半身高都没有，但身高差巨大的两者却散发着一种美妙的和谐感。\\n闪光带还在延续。\\n再往前几步，又有一座冰雕，同样是以这对情侣为主题，他们隔着一个精巧的小阳台上下对望，连母胎单身的捕食者也能感受到情侣间强烈的依依不舍。\\n再往前几步，果然再次出现一座雕像，但这次是悲剧，在死去的矮墩儿身边，大长腿用小刀刺向自己的胸膛。\\n好凄美……捕食者不禁流下了泪水。\\n他此刻才意识到，原来冰川谷有这么触动兽心的存在。这些冰雕是怎么造出来的呢？一下一下的重复雕凿吗？不但能在千锤百炼中锻炼肌肉，更能用平淡无奇的冰块展现种种神奇的姿态。相比之下，寇斯金大人平时的锻炼方式是多么单调无趣啊！捕食者当即决定了自己的第一件冰雕作品：展现自己捕猎英姿的——冰雪之巅的猎手。\\n“雕凿爱不是更好吗？”伴随着威严而霏娓的声音，一个苗条的身影摇曳在风雪中。\\n比起雕像，眼前的本尊更妖媚，双腿更修长，就好像女王一样。她伸出双手，缓缓走向捕食者。\\n“雕刻爱就会得到爱，爱会带来更强大的力量，当你进化到凶噬魔或者永腐魔后，那样的身姿，才有资格成为冰雕的主角。祈愿吧，那是很快就能实现的事。”\\n女王娓娓说到，捕食者沉浸在女王描绘出来的远景中，身体也不知不觉在女王身后亦步亦趋。\\n当捕食者回过神来，才发现自己已身处一个极为宽敞的雪山洞穴中。暴风雪不知道什么时候停了，还是不知不觉走过了风雪地带？洞穴内充盈着一股令人安心的温暖。无数工匠在专心致志地雕凿冰块，呵哧呵哧、嘎嚓咔嚓，开凿冰块的吆喝声和冰块碎裂的声音不绝于耳。这些工匠几乎全部是幻化级的尸族，还有几个长得比较高大的幼体。捕食者看到了一张张熟悉的面孔。\\n大家并没有显露任何痛苦的情绪，捕食者也想成为他们的一份子。正当他心头涌动这股欲望的时候，就发现手上不知何时多了一把冰刀和一把冰铲，跟前还有一块大冰块。\\n立马开干吧。下一秒，捕食者已经换上了一个冰雕工匠的灵魂。“爱你们哟，我的孩子！”\\n女王朝洞里的所有怪兽送去一个飞吻，大家热血沸腾起来。\\n离开的时候，朱丽叶在洞穴外转了几圈，确认了刚才身后那股若有还无的气息是错觉后，心满意足地离开洞穴。尸族果然有着雕凿冰块的巨大潜力，即使他们只是肌肉发达头脑简单的怪兽，只要稍加引导，他们就会醉心于此。\\n只要掌握每个种族的特点，统治他们就是指日可待的事。不用多久，她和罗密欧的爱之雕像——冰雕、石雕、木雕、沙雕——就会出现在大陆的每个角落，到时，所有怪兽的目及之处，都是他们荡气回肠的爱情故事。\\n征服大陆只是一种手段，他们的终极目的，是让大陆进化成他们爱情故事的舞台，进化成充满爱意的世界。\\n与暴力、恨意、恐惧不同，爱能感化任何怪兽。\\n当朱丽叶回到冰雪城堡后，几个木偶族的斥候带回消息，最终兵器和日夕、月夕分道扬镳了。\\n “那家伙，本来就是我们的武器，只不过因为意外才会流落到敌人的阵营……”\\n“吾之星、吾之月，你有什么主意吗？”\\n“吾之日，要是我有一个妹妹，你觉得好不好？”\\n最终兵器在毒气沼泽肆虐小部落的事情，罗密欧和朱丽叶也知道了。不过，让他们有点吃惊的，是埃癸斯曾对朱雀说，如果现在毁掉最终兵器，那个小女孩怎么办！？\\n那个小女孩，就是最终兵器体内的另一个意志？\\n无任何理由的破坏指令不会来自一个成熟而理智的意志。\\n如果是异世界的幼兽，就解释得通了。因弱小和无知引发的惊恐，激起了夹带着绝望的攻击，以为这样就能保护自己。\\n混沌的力量，还有机会归属于他们这一边。\\n朱丽叶向罗密欧说出了自己的想法。\\n“她会因为我们的爱情嫉妒得发狂吗？”\\n“等她再长大一点，一定会因得不到你而痛不欲生的。”\\n“噢！我也会爱她的，以那种爱屋及乌之爱！”\\n“那我去接她回来哦，迎接疯公主的事可不能假手于人。”\\n“……可是，没问题吗？”\\n“没关系的，亲爱的，那个地方离这里不算太远，力量还能在短时间内维持。只不过，小小牺牲是在所难免的。”\\n说完，朱丽叶摇曳着裙摆，走出了冰雪城堡。",
    "resoundEventConfigDes_6003": "暴虐战狂战胜古拉姆后，两者还继续朝北同行了一段。暴虐战狂期待着古拉姆并非浪得虚名，如果是因为还没适应合体后的身体，他也期待着古拉姆能尽快调整好自己的状态，与他再战。而后，他们又对战了一次。古拉姆再次失败，暴虐战狂彻底对古拉姆了死心。古拉姆现在的力量，连究极级也比不上。\\n而古拉姆呢，本来打算只要打败暴虐战狂，就赶往北方和月夕汇合。但明摆的实力差距让他变得灰心丧气起来。\\n因为输得太难看了，一开始大骂古拉姆“混蛋”的林宇翔不禁可怜起他来，但他一个草根学生，也不知道该怎么劝慰一名落魄武夫。\\n自暴自弃的古拉姆干脆放任林宇翔使用他的身体。\\n“给你看这个！”\\n林宇翔掏出手机，电量果然充满了！这几天，古拉姆一直在生闷气，害得他不敢请求古拉姆让他拿手机出来玩玩。虽然没有网络，手机也没什么好玩的。\\n现在，看到那个令人安心的电量标志，林宇翔大胆点开了里面的App。\\n“等等！”古拉姆也看到了电量的标志。\\n他记得不久之前，这个标志还是一半绿色、一半黑色的样子，同时，他也感受到林宇翔兴奋的心情。\\n“你的武器，能量充满了？”\\n“是呀！”\\n“那就是能和我的断剑合体了？”\\n虽然铸造师给古拉姆铸造了一把不错的大剑，但原来的断剑，古拉姆一直带在身上，那才是随他出生入死的伙伴。\\n“呃……”\\n林宇翔才回想起自己当时随口撒的谎。\\n“虽、虽说是无所不能的神器，但、但也不是能同时使用各种高级技能。”他只好吞吞吐吐地解释着，“那个、我……我刚才启用了神器的另一个强大技能。”\\n“那是什么？”\\n“睿智之教诲！”\\n古拉姆记得神器有“电光闪烁”、“震兽之貌”和与旧剑合体的技能，“睿智之教诲”还是第一次听说。\\n“你看这个。”林宇翔刚才随手点开了一个看漫画的App，现在只好用它硬掰下去。\\n古拉姆马上被手机中的图画吸引了。\\n画上，和林宇翔同类的几个生物摆出帅气的战斗姿势，古拉姆在手机上滑了几下，数张图画在古拉姆手指下快速滑过，图画上的文字他看不懂，但能看出那是一场激烈的战斗，那几个生物用了各种招式抵抗强大嗜血的敌人，最后反败为胜。\\n嚯嚯！原来神器里面还收藏着神奇的武术圣典！尽管非常期待断剑会变成什么新形态，但这些图画却用一种强大的吸引力，让自己一张接一张地翻下去！古拉姆兴奋起来。\\n“这是什么招式？”古拉姆问。\\n“写轮眼？”\\n古拉姆竟然对漫画感兴趣？漫画果然是一门跨世界的艺术啊，林宇翔内心感叹到。\\n“这种呢？”古拉姆又滑了几页。\\n“哦哦，这是大蛇丸流替身术！我跟你说……”\\n林宇翔兴致盎然地给古拉姆细细讲解某部漫画中各种炫酷的忍术。\\n“……”\\n古拉姆陷入沉思，看来，这小子的世界和这里一样，有着不同的种族，有些种族的技能传承自该族的血统，是其他种族无法学习的。\\n“还有其他武术圣典吗？最好是使剑的。”\\n听到古拉姆把少年漫画说成武术圣典，林宇翔内心窃笑不已，这家伙该不会把少女漫说成爱情圣典吧？不过，难得古拉姆打起了精神，他并没有落井下石地嘲笑他。\\n“剑术圣典，当然有！”\\n林宇翔马上给古拉姆推荐了一部当红的漫画，每个正派角色都擅长一种剑术，男主角更以火之呼吸和水之呼吸两个系统来增强剑气。\\n“哦哦！”“原来是这样！”“没想到！！”“居然还有这一招！！”古拉姆看得非常入迷，不时发出连连的赞叹。\\n用呼吸来提高肌肉的力量、控制心肺呼吸的次数，如果能做得到的话，即使手握断剑，也能以燃烧的剑气劈下敌人的首级。\\n这是古拉姆对剑术圣典还不能甚解的情况下，暂时学到的“秘技”。\\n不知道过了多久，古拉姆把十几册剑术圣典都看完了。\\n“来吧！现在，用你的神器和我的剑合体吧！”古拉姆郑重地把手机举高。\\n“不、不行！能量、能量又不够了！”林宇翔急忙辩解道。\\n古拉姆看了看电量标志，果然，表示能量的绿色只剩下一大半。\\n“唔……神器的能量耗损得太快了。”说完，他郑重地把手机放回到召唤具，藏好在盔甲里，“那就先试试剑术圣典的招式！”",
    "resoundEventConfigDes_6004": "暴虐战狂正在不远处挥斧练习，古拉姆向他发起了挑战。\\n“很好！”\\n暴虐战狂把斧刃一转，对准古拉姆。\\n自己用的是烈焰剑，那种火之呼吸，应该很容易掌握，说不定马上就能浑然天成。古拉姆这样鼓励着自己。他调整呼吸，举剑劈向暴虐战狂。\\n剑与斧之间擦出的火花四溅，重拾斗志的战士与嗜武者的战斗开始了。\\n“火之呼吸！传说之力！破！！”\\n“混沌之力！！”\\n毫不拖泥带水地，战斗在十几个来回后便结束了，倒在地上的依旧是古拉姆。\\n和剑术圣典中的秘技完全没有关系，这次撑得比较久，单纯是因为古拉姆的斗志更高昂、意志更坚定。\\n“很好！再来！”\\n斧风在古拉姆头顶扫过，暴虐战狂等待着。\\n“啊——！！”深感屈辱的古拉姆一跃而起！\\n“停手！”\\n远处传来了如惊雷般的喝止声。\\n真·圣盾埃癸斯终于赶上了自己的挚友，他从远处就看到暴虐战狂身上橙金色的流动，不朽的远古族，是同伴啊！怎么打起来了？\\n看到埃癸斯手上的盾，暴虐战狂如获至宝，堂堂远古族前线守卫部落的首领，更能让他战个痛快了吧。\\n没想到，要挑起埃癸斯的战意，比古拉姆要战胜他更难。埃癸斯对暴虐战狂的只挡不攻几乎持续了一个昼的时间。古拉姆几次跳上来帮忙，但很快就被暴虐战狂的战斧扫开，最后只好怏怏地在一旁观战。\\n“我们是同伴！”这是埃癸斯重复得最多的一句话。\\n“我明白了。”\\n终于，暴虐战狂收起了战斧。\\n“啧啧，伤脑筋，看来你是不愿单纯地与我比较高下，不是敌人的话就无法逼你出手。至于另一位，期待你下次的长进呵！”\\n“哼！少瞧不起人！”\\n“咦？你不与我们同行吗？”\\n“不了，对我来说，要和旗鼓相当的战士和平共处实在无聊。先走一步！后会有期！”\\n暴虐战狂大步流星地离开了。古拉姆想阻止他、让他再等等，但一想到接连几次的惨败……万一自己使用焕然一新的大剑战斗还是不行呢？自己还有勇气面对那种没有任何借口的失败吗？古拉姆紧握剑柄的手松开了。\\n拙于言语的埃癸斯更不知该如何劝阻，只能眼巴巴地看着暴虐战狂越走越远。\\n“小子，啊不、智者小子，怎么才能练成那部剑术圣典中的强化呼吸？”\\n“你……该不会当真了吧？我只是想你重新开心起来，才给你看那种东西的……”\\n在林宇翔支支吾吾的解释中，古拉姆第一次听说了“漫画”这种东西，所谓“睿智之教诲”，其实只是“燃起奋进之志”，这种激励心智的普通技能。\\n“……所以刚才，在你眼中，我就像个白痴一样？”\\n“也不是……只不过有点意外……噗嗤——”没有意识到摊上大事儿的林宇翔，终于忍不住笑了出来。\\n不明所以的埃癸斯看到挚友的脸色一阵差过一阵。\\n“古拉姆正在和他的搭档说话吗？”马克问道。\\n“事情好像很严重，我们还是暂时不要插嘴。”埃癸斯说。\\n“……混蛋——！！”\\n就在林宇翔给古拉姆安利其他少年漫画的时候，古拉姆迸发出一声怒吼。这小子不但让自己浪费了神器本来可以和断剑合体的能量，还把自己当傻子耍！\\n林宇翔的心被一股狂怒紧攥着，呼吸困难。\\n“我果然不该把希望放在你身上！！”如果不是共用一个身体，古拉姆早已把林宇翔一脚踹到超星海洋去。\\n本来就没有身体支配权的林宇翔，现在手足更像被炽热的愤怒之链捆绑着，被扔进波涛汹涌的耻辱与狂怒之海——那正是古拉姆的内心。",
    "resoundEventConfigDes_6005": "一路上，只要有精力，洛菲菲就会控制着最终兵器，穿越各种奇怪的地形。遇到落单的怪兽就上前挑战，打不过就让最终兵器出手，自己则观察着他的一招一式，然后在差不多的时候制止最终兵器。\\n现在他们来到结晶平原。这里并没有让人心驰神往的各种晶石，超星海洋的海水流进这片土地，特异的土质让海盐在这里形成结晶。阳光之下，放眼望去，整片平原闪闪发光。结晶平原靠近北方的冰川谷和东方的熔火之巅，所以偶有尸族和龙族在此出没。\\n此时，在意识的虚空之域，洛菲菲背对着最终兵器坐在他的巨拳之上。\\n“没有人能信任，现在我们只能依靠彼此了。”\\n“……命令？”\\n“不是命令哦，是约定。”\\n“约定……”\\n“我哦，其实一直和你一样，活在别人的命令之下……”\\n一路上，洛菲菲断断续续地，也不管最终兵器有没有听懂，诉说着自己曾经的生活——那并不算无忧无虑的童年。\\n美其名曰父母的期待，其实是大人对小孩的命令，如果不能完美执行，等待着她的将会是无穷无尽的惩罚，大人充满责备的眼神、更多的自由时间被剥夺到补习上、不断地和别人家的小孩比较、零用钱也会被削减，最让人厌恶的，是“一切都是为了你好”的压迫感。\\n洛菲菲记得很清楚，当时无意听到同学被家长训斥的话语：“只有成为强者才有话语权，成人的自由通过金钱来换取，小孩的自由只能通过第一名来获得，成绩不好、脑瓜迟钝的小孩永远在食物链的最底层。”对此她觉得又气又好笑。\\n“一起……”\\n过去的记忆纷乱模糊，与洛菲菲合体的那一刻起，确实有什么不一样了，真的不需再听从任何命令了吗？\\n天色渐暗，一直紧绷着神经的洛菲菲沉入了梦乡，最终兵器继续无目的地前行。前方的结晶显然和沿岸的有所不同，四处横生，更大也更密集，很快结晶丛中就仅剩下一条勉强可以行走的间隙。\\n突然一股张狂的敌意袭来，最终兵器敏锐地察觉到后迅速地摆出了战斗态势。\\n铁甲龙已经馋了很久，王赏赐的孢子团倒有不少，但遥想他还没发誓效忠于王的过去，最大的享受，莫过于一边无所事事地看着天空，一边咬上几口烤得嘎崩脆的盐巴铁矿石。\\n而另外五条荒火龙中的一条，是带着巨大的屈辱和野心奔赴此地的。他曾以不朽之身输给究极级的暴虐战狂、又被幻化级的虚刃逼至平手，王为虚刃喝彩，却连正眼都没看他一眼。\\n然后，临时进化也到达了它的时间极限，逆焰龙王变回了究极级的荒火龙。\\n经过好多天的期盼，王好像不经意间想起他似的，赐予了他一堆孢子团，和这个重大的任务。\\n新的孢子团经过王的再次改良，融合了大量的强化孢子和少量的进化孢子。它会把怪兽的体能和战斗力推向新的极限。当身体适应了那样的极限，甚至能自己创造新的极限时，进化孢子就会发挥作用，让怪兽永久地进化为新形态。\\n当然，无法适应极限的怪兽，就用身体衰竭而死来报答王的恩情吧。\\n这次一定不能再辜负王的厚爱！荒火龙在心中立誓。\\n他飞到五条龙的中心，睥睨着他那些抱着儿戏的心态包围敌人的同族，发出进攻指令。\\n这六条背叛了同族的龙，却讽刺地完美继承了族长钢铁龙王巴萨克的特点，在战斗中，他们胡乱指挥与胡乱攻击，削弱着彼此的力量。\\n“快点放倒这个大块头去找盐巴！”\\n“这家伙的铠甲，铁锈味好浓啊，应该很好吃吧！”\\n“烦死了，以为自己是王的代言吗？”\\n“怎么都不听指挥！”\\n龙不同心，其利断不了豆腐丁，这句超进化大陆的谚语，说的正是这种情况。\\n这一次最终兵器并没有陷入暴走状态，他飞扑出拳、脚踢横扫，每一招都有条不紊地施展着。\\n洛菲菲醒了，在最终兵器沉稳的意识中，她没有感受到一丝慌张。\\n“怎么了？”\\n最终兵器没有回答。",
    "resoundEventConfigDes_6006": "远处的邪王朱丽叶以优雅的姿态坐在一棵生长在结晶丛中的参天古木上，皱着眉头看着战场。这棵世界树的孢子还没完全变成紫色，她和罗密欧的力量还无法渗透到这里，离开极北之地，他们的力量就会被削弱。\\n不妙啊，那几个家伙，即使力量达到不朽级，也不能好好施展出来，实在太笨了。继续下去的话，最终兵器会把他们逐个击破的，自己作为好姐姐出场的计划，就无法实现了。唉，看来，以后要让孢子团改进到能改善孩子们的智力那种程度才行。朱丽叶想。她挥动法杖，一股积聚已久的法力飞向六条龙。\\n六条龙像突然受到某种指令，换了个脑子似的，同时改变攻击策略。\\n“龙魂·铁幕！”\\n“龙魂·焚烧！”\\n瞬间，以最终兵器为中心，前后方的去路上燃起了熊熊烈焰，那是由前后的五条荒火龙构筑的死亡区域。上空是无数根遮天的结晶柱，没有退路，无法避战，最终兵器迅速得出结论，朝前方的荒火龙发起猛击。\\n和刚开始不一样，原本吃下最终兵器一拳就会有一阵无法动弹的荒火龙，此刻在被重锤击中后，仍旧给出了生猛的还击。\\n四周那个半透明的光质铁幕正发挥着它的效果。\\n荒火龙、铁甲龙，以及焚烧的地面，完全不给最终兵器留下一丝喘息的机会，不断给他制造出更深的伤势。\\n最终兵器被打倒在被烧得通红的地上，又挣扎着起身回击，这样时间一秒一秒故意拖慢着脚步似地流逝。巨大的撞击声不断冲击洛菲菲的耳膜。\\n要说洛菲菲有什么幼年阴影的话，就是五岁那年，被困在学校停电的电梯里。菲菲被消防员救出来后，不顾校长含泪的请求，立刻让妈妈帮忙办理了转校手续。那次的意外还让菲菲产生了轻微的幽闭恐惧症，经过半年的治疗才治好。\\n现在的情况，比失控的电梯更恐怖。\\n最初洛菲菲忍耐着恐惧，祈求着最终兵器能像以往一样撕裂对手。可最终兵器渐渐落于下风，火色慢慢吞没视野，压抑的狭小空间让洛菲菲窒息，而热浪卷走了她的最后一丝理智。\\n“好烫……好难受……我要死了吗？我们……真要永远在一起了，在另外一个世界里。”\\n最终兵器受到洛菲菲情绪波动的影响，那种被武器坟场压在身上窒息感又回来了，那头本能的猛兽正要苏醒……\\n可敌人却一个个倒下了。\\n负伤的最终兵器没有去思考发生了什么，只是在周围的杀意消失以后，陷入到了沉睡之中。\\n在意识的虚空之域，洛菲菲颤抖着抱住了一旁的最终兵器。\\n……\\n“小可怜，你没事吧？”\\n一双修长的美腿站在还有些微热的地面之上，身上没有占到一丝尘埃，她温柔地扶起最终兵器。\\n这位诡异的美人比最终兵器还要高，比童话中的邪恶王后还要美丽，明明身上溢满邪恶的气息，但表露出来的怜爱却是那么情真意切。\\n“你是谁……”\\n“虽然我救了你们，但不需要用铺天盖地的感谢之辞报答我。我呀，见到可爱的小怪兽遇到危险，就忍不住要帮助他们。”\\n美人踩着其中一条荒火龙，自顾自地说着话。\\n她身上散发着一股连洛菲菲也能感受到的，像是故意显露出来强大气息。\\n“那现在，要不要跟姐姐回家呢？”\\n“……你想让我做什么？”天下没有免费的午餐。\\n“嘛，真是戒备心重的小乖乖，你什么都不用做，只要在安全的地方等待新世界的诞生就好。”\\n洛菲菲向美人点了点头。\\n自己还没变强的话，就先抱着强者的大腿，月夕姐姐、埃癸斯哥哥，不要怨恨我哟，这可是个弱肉强食的世界，既然你们不能保护我，也没有权力强迫我留在你们那。洛菲菲毫不内疚地想到。\\n奄奄一息地，倒在地上的六条龙不解地望着远去的女王，随着生命的流逝，他们连思考的力气都用不上来。\\n在龙魂·铁幕和龙魂·焚烧快要失效的时候，女王出现了，他们以为女王是来给最终兵器致命一击的，为什么被击倒的是自己呢？明明前一刻女王还在对着他们微笑，那个笑容诉说着“辛苦你们了，我的孩子”，这样的情感……",
    "resoundEventConfigDes_6007": "在一片广阔的冰原上，几名幻化级的尸族正带领着大家做互搏训练。尸族又增加了两名失踪者，不安蔓延至每个怪兽的心中。那种凭借糙皮厚肉和强大的不死特性熬过大灾难的作战方法行不通了，恐怕还没真正和邪王开打，尸族就会在此地消失。\\n所以，必须从现在开始磨利自己的獠牙。\\n互搏的呼喝声响彻冰川谷，月夕和日夕很快就循声找到了他们。\\n“你们怎么证明自己不是偷偷把大家捉走的家伙？”一名腐化者警惕地问道，他还没锻炼到能看到对方流动的程度。\\n没想到马上受到了这样的质问，不，对方是根本没打算相信吧。\\n“喂，我们可是堂堂远古族的首领，为什么还要干证明自己不是坏蛋这种蠢事！”日夕不满。\\n“嗯哼？想和我们打架吗？一直藏在暗处的家伙，终于忍不住要光明正大地展现自己的实力吗？”\\n两方马上剑拔弩张起来。\\n“你们啊，都适可而止！”\\n威严的声音从空中传来，一抹焰光擦过天空，然后在众怪兽头顶盘旋几圈后慢慢降落。\\n“朱雀大人！”月夕惊呼。太好了，自己无法制止的战斗，朱雀大人单凭威严就能让大家住手。\\n“来的是你们？”朱雀也有点惊讶。\\n“真·月夕和真·日夕是你们的援手，我以神灵的名义担保。”朱雀转头，向尸族宣告。\\n日月双姝的美貌闻名超进化大陆，连她们也不认识，尸族也太宅了吧，朱雀感叹。\\n“不、不朽？”听到了“真”字开头的只属于不朽级的名字，腐化者完全卸下心防，“强者哟！帮帮我们！”\\n“我们就是为此来这里的嘛，现在，请好好说明一下情况。”日夕说，腐化者的恳求，让她心情舒畅。\\n“这个嘛……我们也不知道大家是怎么消失的，反正，就是突然不见了。”\\n“……”该说他们大意，还是敌人太可怕？\\n“还是由我来说明吧。”朱雀说。\\n小东西还没到，到了之后再由他补充吧。朱雀正这么想着，余光扫到了一个从远处雪山山顶滚下的雪球。\\n这片空地在一座坡度陡峭的雪山下面，雪球越滚越快、越滚越大，眼看就要撞上大家。虽然不是什么有攻击性的东西，但谁也不愿意被撞个鼻青脸肿。\\n“啊嘿！”腐化者举起长矛顶住雪球，直到整段矛尖刺进雪球中，才让雪球停了下来。\\n然后，从被刺进的地方开始，一条裂缝朝上下两个方向蔓延，很快，雪球就像打破的鸡蛋般裂成两半——一只小小的幼尸从雪球里蹦了出来。",
    "resoundEventConfigDes_6008": "“唔呣！吓死俺了唔呣！”含着奶嘴咬字不清的样子有点可爱。\\n比起其他尸族，这只幼尸的体型实在太娇小了，也幸亏这样，才躲过了长矛的穿刺。\\n“既然你来了，就由你来说明吧。”\\n原来“抄近道”是这个意思，朱雀终于明白了，他像和豆丁幼尸早有约定般，朝他点点头。\\n“唔呣，神灵老爷！”\\n得到了鼓励，豆丁幼尸手舞足蹈地，用含混不清的奶声奶气，拼命诉说着刚才发生的事。\\n他，作为尸族最矮小的一个豆丁，一直被一个幻化级的捕食者照顾着，他也像弟弟崇拜哥哥一样，崇拜者那名捕食者。\\n虽然最近族长让大家不要离开族群单独行动，但捕食者哥哥依旧好几次铤而走险，还捉回来不少猎物。捕食者哥哥为了他能快高长大，连自己的性命都不顾！每每想到这，豆丁幼尸就感动得要哭出来。\\n这天，他偷偷跟在捕食者哥哥后面，打算到时吓哥哥一跳，没想到，却看到哥哥被一只长腿怪掳走。\\n“长腿怪？”月夕问。\\n“唔呣，穿裙子的长腿怪！比你们的裙子还漂亮的裙子，唔呣！”\\n是个高大的女人？欧文向月夕传递了自己的推理。\\n比你们还漂亮吗？李雨蒙向日夕传达了自己的好奇。\\n“不可能，拐走怪兽，是丑八怪才会做的事！”日夕有点激动地回应到。\\n“喂，我问你，长腿怪长什么样子？”\\n“俺没看清唔呣，俺害怕，只敢远远跟着……”豆丁幼尸打了个哆嗦。\\n“骗人的吧？长腿怪为什么没把你也捉起来？”让日夕耿耿于怀的还是超进化大陆竟然有比她们姐妹更美丽的怪兽这件事。\\n“俺、俺躲起来了……俺是胆小鬼唔呣！”\\n说着，豆丁幼尸像没脸面对所有同族一样，三扒两拨就在雪地上挖了个洞，一头栽了进去，还眨眼之间就用雪盖住自己。一眼看上去，就像雪地上一个不起眼的小雪包。看来，这就是这只小怪兽的保命之道。\\n“为了救同伴，你做了好了不起的事哟~”月夕摸着小雪包，温柔地安慰到。\\n之后，月夕和日夕只好把耳朵贴在小雪包上，从豆丁幼尸断断续续的哭泣中，听到了冰雕之穴的事。\\n正因为以那样的方式躲起来，长腿怪才没有发现他。等长腿怪离开后，他跑进洞穴里，但无论怎么叫喊，捕食者哥哥和平时喜欢捉弄他的前辈们都毫无反应，像灵魂被抽离了一样。\\n只好先回去，把事情告诉大家。可是，踏出洞穴没走几步，就迷失在暴风雪中。就这样一边哭一边以为自己会死在暴风雪中的时候，朱雀大人出现在他面前。\\n然而，却再也找不到那个洞穴的所在，朱雀大人只好带他回来。好不容易穿过暴风雪地带，在雪山顶看到大本营，他第一次如此渴望回到大家身边。\\n“那些冰雕到底是什么？”\\n“不知道……是羞羞的东西唔呣……”\\n说明就在豆丁幼尸的支支吾吾中结束了。",
    "randomEventDialogueGroupConfig_11.5": "-",
    "randomEventDialogueGroupConfig_11.6": "-",
    "randomEventDialogueGroupConfig_11.7": "-",
    "randomEventDialogueGroupConfig_11.8": "它绕着你转了两圈，然后停在你面前。",
    "randomEventDialogueGroupConfig_11.1": "一个神秘商人围着你转了一圈，然后站到了你的前面。",
    "randomEventDialogueGroupConfig_11.2": "-",
    "randomEventDialogueGroupConfig_11.3": "-",
    "randomEventDialogueGroupConfig_11.4": "-",
    "messageInitContent_4942": "我曾经以为锤爹是锤子的进化版",
    "messageInitNick_11778": "芒果布丁哇哦",
    "messageInitContent_4943": "赛博幽灵在大家心中游荡",
    "messageInitNick_11777": "普通的面具",
    "messageInitContent_4944": "你火了",
    "messageInitNick_11776": "内耗高手",
    "messageInitContent_4945": "这个发型",
    "messageInitNick_11775": "风信子",
    "messageInitContent_4946": "无情的钻石掠夺者",
    "randomEventDialogueGroupConfig_11.9": "再绕着它转三圈",
    "messageInitContent_4947": "经典4保1",
    "messageInitContent_4948": "低配版",
    "messageInitContent_4949": "够了！",
    "messageInitNick_11779": "橙汁船长",
    "messageInitNick_11770": "合成饭盒",
    "messageInitNick_11774": "兴奋的麦克风",
    "messageInitContent_4950": "逛呀逛",
    "messageInitNick_11773": "柿子龙",
    "messageInitContent_4951": "迷路的jo",
    "messageInitNick_11772": "东京老吃货",
    "resoundEventConfigDes_6010": "来自结晶平原的盐拥有非比寻常的咸，被它融化的雪地，即使在暴风雪的肆虐下，还保持着非常潮湿的状态。豆丁幼尸一边舔着湿润的咸雪水，一边回想之前走过的地方。他自己也没想到，这种因为想快高长大而培养起来的吃货属性，在这种时候大派用场。\\n所以，要吃那么多的冰沙团子，小家伙一路上是怎么带着走的？李雨蒙暗暗吐槽。\\n吐完后，日夕找了一堆干净的雪来漱口，即使这样，她们还是觉得很恶心。\\n和自己的出糗一对比，欧文刚才的推理就更加大放异彩了。\\n他们俩从踏足冰川谷开始就没怎么吭声，但是，即使多么重要的“NPC”，也应该把主线剧情交给主角（玩家）来推进呀，不能就这么突然出风头的吧？难道自己错过了什么剧情提示？\\n同样赌气的还有日夕。风雪渐强，气温愈低，平日耀眼如太阳的自己，却是冷得最瑟瑟发抖的一个，姐姐任由风雪吹打着细腻娇嫩的肌肤，神态依旧淡定优雅。\\n她和姐姐的属性，就像一枚金币的正反两面，一明一暗，一热一冷，一阳一阴。于是姐姐轻轻松松就适应了极寒之地，而自己却十分狼狈。\\n这么想着，日夕又摸了摸裙兜里的几个孢子团。\\n“就在那里唔呣！”豆丁幼尸的大喊打断了她的犹豫。\\n几乎完全阻挡了眼前视线的暴风雪前方，能隐约看到一个洞穴\\n走进洞穴，映入眼帘的尽是那对诡异的情侣各种甜蜜的模样，日月姐妹不禁浑身起了一层鸡皮疙瘩，连什么大场面都见过的朱雀，焰光也稍微颤抖了一下。\\n果然是，羞羞的东西……\\n超进化大陆从来没有出现过这样的怪兽。\\n“他们……就是邪王吗？”月夕问朱雀。\\n“我也不知道……”同样目瞪口呆的朱雀答道，虽然更之前他已经听过一遍豆丁幼尸的描述，但无论如何也想象不出这副景象。\\n不过，只是透过透明的冰晶，也看得出“长腿怪”有一种富于侵略性的美。\\n日夕的内心充溢着夹杂了不甘的羡慕之情。\\n“他们是邪王的可能性达90%。”月夕替欧文表达了他的意见，然后自己又说道，“……没想到这次会同时降临两位邪王。”\\n“不过，看他们缠绵的姿势，我觉得，他们更像是一组魔王。”日夕也让李雨蒙说出了她的见解。\\n“唔……两者为一体吗？”朱雀沉吟。\\n“反正有够肉麻的，不过，看上去每座雕像，都有着不同的故事诶……”\\n他们的到来并没有引起众多“冰雕匠”的任何反应。日夕凑到一座冰雕前细细端详——长腿怪和矮墩儿戴着面具一见钟情。\\n好、好棒！自己也是个拥有故事的女神，为什么想不出这么好的点子呢！\\n这么想着，日夕已经绕到下一座雕像——长腿怪和矮墩儿激吻——的前面。\\n“不对，嘴唇要再丰满一点才够美！”日夕抢过一名行尸的冰刀，自顾自地雕刻起来，对于美的研究，不会有谁比自己更透彻。\\n行尸愣愣地点点头。\\n“唔呣！快救救大家！”豆丁幼尸焦急地拉了拉日夕的裙子。\\n“小夕，清醒点！”\\n“啊……我到底……在做什么？”回过神来的日夕，抛掉手中的冰刀，不可置信地捧着自己的脸蛋——蠢死了！\\n“你也不提醒提醒我……”日夕向李雨蒙抱怨。\\n“我以为你要攻击他……”\\n“看来，无论是孢子还是这些雕像，都被灌注了邪王强大的迷惑心灵的力量。”朱雀皱着眉头总结。\\n的确呢，如果不是豆丁幼尸的催促，说不定他们还会对这些冰雕欣赏一番。豆丁幼尸由于年纪尚幼，还无法感受“爱情”的魅力，可算是瞎猫碰到死耗子的幸运。\\n“拜托你们了，先让大家清醒过来。”朱雀说。\\n“嗯！”“等着瞧吧！”\\n日月姐妹一起向着众尸族发动『逆转之力·觉醒』，银色的月光和金色的日光在洞内绽放，冰块的雕凿声顿时停了下来。\\n在逐渐褪去的光芒中，豆丁幼尸期待着重新变得正常的同族。\\n当、当当……可是，冰块的雕凿声又再陆续响起，那是视野重新恢复的冰雕匠们的回应。\\n“怎、怎么会？”\\n“日夕小姐，你能把冰块融掉吗？”\\n在月夕失神的瞬间，欧文留意到眼前的冰雕滴下一滴微乎其微的水珠，如果不理会的话，马上就会恢复到之前干燥的状态。\\n那是最靠近日夕的冰雕。\\n刚才日月姐妹的治愈之光并没有炽人的热量，它们带着微微的暖意笼罩着每一名尸族。尽管如此，日夕的光芒还是比月夕的暖和一点点。\\n “交给我！”日夕马上明白了姐姐的拍档的意思，属于自己的时刻，终于来临了！她对着豆丁幼尸飒爽地笑笑，“小家伙，不想被热死的话快躲进雪堆里！”\\n嘛，即使幼体的尸族，也不是这么娇皮嫩肉的存在，它们完全能抵抗她散发的热量，只是这样说话会帅气一点。\\n“嘿啊——！！”\\n一改治愈女神的姿态，日夕宛如盛夏的化身，散发出充满着斗志、骄傲和怒火的光芒。洞内的温度迅速攀升至暑气蒸人的高度。“烈日”当前，骄阳如火，数座冰雕开始融化。冰雕匠们茫然地停下手中的冰刀，不知如何是好。\\n“见效了！”月夕欢呼！\\n“关键是怎么把大家带走。”欧文说。\\n“……”\\n“当心！敌人来了！”一直盘旋在洞内外把风的朱雀提醒到。果然，动静还是太大了。",
    "messageInitContent_4952": "嗯？",
    "messageInitNick_11771": "往事随风去",
    "resoundEventConfigDes_6011": "今天，我的小鸡腿一共亲了我十八次。朱丽叶离开后，罗密欧从冰雪城堡遥望南方，追忆爱人的身影，他连一刻都不想和她分开。他心中忐忑着，一股不祥的预感挥之不去。\\n就在他说服自己朱丽叶会平安无事的时候，看到不远处的雪山脚下透出强烈的光芒——那是他和朱丽叶制造爱之雕像的地方！\\n岂有此理！是谁在那里捣乱？是对别人的爱情看不顺眼的单身兽？还是一直蛰伏起来伺机而动的情敌？\\n发誓要把敌人一个不留地干掉，罗密欧带着数十名手下离开了冰雪城堡。朱丽叶不在的时候，他们的爱巢，由他来守护！",
    "resoundEventConfigDes_6012": "洞穴内，原本铺满积雪的地面变成了积满水洼的湿地，炎热让所有雕像融化了其清晰的轮廓，变成一堆形状莫名其妙的光溜溜的冰块。\\n日月姐妹身后是一群茫然的尸族，前方要对付的，是战力和数量都未知的邪王与他的军队。\\n“总不能扔下他们逃跑吧，那只能上了哦！”\\n日夕瞄了一眼紧张兮兮的大家，保持着身上的光辉，第一个冲到洞外。\\n为什么太阳会掉到地上？不对，连月亮也出现了？\\n这是罗密欧见到日月姐妹的第一个念头。再走近几步，见到的是两张连暴风雪也无法遮掩的绝色容颜。\\n正因如此，罗密欧的思绪朝奇怪的地方放飞了——我怎么没想到呢？敌人……竟然是我的爱慕者！\\n罗密欧不但深爱着朱丽叶，还相当自恋。\\n他命令身后的部队停下，眼睛在日月姐妹身上轮流打转。\\n“我是不会开后宫的，但是，现在将给予你们一个永远仰望我、成为我部下的机会！感到慰藉吧！”\\n开口第一句就说起了梦话。\\n这家伙在说什么？本尊比冰雕的样子更装模作样。日夕有点嫌恶地皱起眉头。\\n这样子的开场白，她要怎么接话？月夕也为难起来。\\n“突然说成为部下似乎有点……”\\n“对了，那只火鸡，刚好可以和我的小鸭鸭配成一对，当宝贝儿的宠物。”\\n以一言难尽的方式系在罗密欧腰间的鸭子点了点头，朝朱雀发出不甚友好的嘎嘎声。\\n连朱雀的将来也被安排得“妥妥当当”。\\n一向威严但慈祥的朱雀扇动翅膀，“可以就在这里灭了他吗？”不断向日月姐妹散发这种无奈的视线。\\n当然可以！日夕点点头。\\n瞬间，几枚小光弹从日夕手中发射过去，它们精确地击中罗密欧礼服上夸张繁复的圆领，火焰迅速沿着圆领从外向内燃烧起来，罗密欧的胡子和撒满香粉的卷发也被烧焦。\\n“还有你！进化成烤鸭吧！”\\n那只古怪的鸭子被烧成炭黑色，并散发出诱人的香味。\\n“唔噜噜噜噜！因爱成恨吗？”罗密欧发出愤怒的咆哮，身后的手下也躁动起来。\\n“你们都不要出手，我的情债，就由我自己来偿还！”罗密欧很有骨气地宣告。\\n日夕虽然不明白他在说什么，但大概清楚的是现在变成二对一——如果姐姐也出手的话——的决斗。\\n罗密欧拔出剑，举在胸前念念有词，对日月姐妹释放强烈的“思念”。\\n“凭吾优美之身起誓，吾之崇拜者哟，请把心完全交予吾！”\\n长剑被抛起，在空中变成一朵玫瑰，玫瑰在掉落的同时，化成无数花瓣，空气充满了甜腻的香味。花瓣越来越密集，形成缠绕着冰雪的红色龙卷风。\\n那是什么？就算困惑却依然保持着防御的日月姐妹，心脏不由自主地激烈跳动起来。\\n“罗密欧大人！！”几个被花瓣触碰到的罗密欧的手下，发出瘆人的尖叫。\\n那是其中的雌性怪兽。\\n她们本来就对罗密欧与朱丽叶忠心耿耿，现在，忠心之上覆盖了一层对罗密欧的疯狂，只要罗密欧的一个眼神，她们便心甘情愿地为他所用。\\n这就是罗密欧与朱丽叶的秘技，前者的有效对象是雌性，后者的则是雄性。\\n它对罗密欧的雌性手下是画蛇添足的伤害，但对日月姐妹，却是致命的攻击。",
    "resoundEventConfigDes_6013": "罗密欧挥手前指，红色的龙卷风扑向日月姐妹。\\n月夕表情凝重，全力对抗着罗密欧的精神控制。当然，她不知道自己还有对抗之力，是因为体内有一半属于欧文的男性意识。\\n日夕就没那么幸运了。\\n隔着朦胧的雪与花之龙卷风，她看待罗密欧的眼神变得痴情起来——为何之前没有发现，自己的敌人是这样一位高贵的美男子呢？精致的打扮、性感的胡须、还有望向自己的含情脉脉的眼神……\\n日夕的心再次被迷惑了。\\n对朱雀来说，这只是一股猛烈的龙卷风，他无形的火焰之躯虽然在风中摇曳不止，但实际上毫发无损，要神灵死亡，并不是区区物理攻击或精神压制能做到的。\\n不过，他却对日月姐妹的困境束手无策，虽然不断对她们施展回血和降伤技能，但只是明知徒劳无功而无法袖手旁观罢了。\\n“大人……”日夕慢慢走向罗密欧。\\n“小夕！不行！”月夕挡在日夕面前。\\n几枚小光弹毫不犹豫地打在月夕身上。\\n痛！但不是致命伤，不打紧！月夕对妹妹释放治愈的力量，可惜完全没有效果。\\n“跟我一起走，我们是属于大人的。”日夕用紧紧捉住月夕的手，拉着她与自己一同前进。\\n不远处，罗密欧向日月双姝张开了怀抱。\\n可恶！这一战就要牺牲两组英雄吗？ \\n从结论来说的话，朱雀的担心是多余的。\\n他发现了一道隆起的雪堆，矮矮的高度，在皑皑的雪地上并不明显，但它还在不断向前延伸，目标，似乎是邪王。\\n该不会……糟糕！朱雀想到了他们之中只有那个有土拔鼠般的挖掘能力。\\n“唔呣！去死吧！”\\n以迅雷不及掩耳之势，豆丁幼尸从雪堆中跳出，亮出锋利的爪子，把系在罗密欧腰间的鸭子扒了下来。\\n这绝不是什么经过深思熟虑的攻击，豆丁幼尸是认真地想要杀了罗密欧，但瞎猫遇上死耗子似的，得到了一个比罗密欧死掉更震撼的结果。\\n“嘎……嘎……”之前被日夕的光弹打中的鸭子奄奄一息躺在地上。\\n仔细看看，原来它是一只两条腿拥有劈叉后能在罗密欧腰后交汇的长度的鸭子——还真是一位喜欢鸭子的邪王呢。\\n在场所有意识清醒的生物，无论是欧文、月夕、朱雀，还是罗密欧的雄性手下，一致得出了这样的结论。\\n“腰带”被爪断之后，掉下来了。\\n动物世界一般的光景，坦坦荡荡。\\n“呣！！！”\\n终于回过神来的罗密欧慌忙捂住自己——中途还被自己的鸭子绊倒——踉跄着逃到手下后面。\\n“给、给我杀了他们！！” 罗密欧气急败坏地发出指令，顾不得快要走入自己怀中的日夕，也顾不得把自己“腰带”弄掉的始作俑者，之前那副自恋的贵公子形象荡然无存。\\n日月姐妹马上被罗密欧的手下团团围住，不过，就在同一时间，罗密欧对日夕的精神控制解除了。\\n这个技能不但要耗费大量的魔力，还需要在他最志得意满的状态下才能使出来，发现了两位倾国倾城的爱慕者，也算是非常得意的状态。\\n“我……刚才做了什么？”日夕回过神来，愣愣地问道。\\n连李雨蒙也着了罗密欧的道，无法回答这个问题。\\n“……待会儿再说，我们先冲出重围！”月夕露出稍许尴尬的表情。\\n然后，是比起刚才还算轻松的作战。\\n幻化级的怪兽大概半百，日夕施展光弹攻击，很快打开了包围圈的缺口。蕴含着怒气的攻击，刚才一定发生了什么让自己丢脸丢到超星海洋的事。\\n“姐姐！治愈他们！”\\n“嗯！”\\n竭尽全力，比之前的所有光芒更强烈，月夕再次释放治愈的光辉。\\n所有受伤的怪兽都在她治愈的力量中沉睡了，少数没有受伤的，也在日夕的下一击中纷纷倒地。\\n“嗨……啊，不行……朱雀大人，拜托您了……”想再次释放治愈光辉的月夕，因体力不支倒下了。\\n“够了，我只是想让他们别再站起来！”\\n“不是致命伤，没关系。”朱雀赞同日夕的意见。\\n罗密欧已经不见了，大概是不想被嘲笑，趁混战的时候跑走了。\\n“但是，要怎么把洞里的尸族带走呢？”日夕问。",
    "resoundEventConfigDes_6014": "张大了嘴巴，寇斯金惊讶地看着浩浩荡荡来到自己面前的一群——\\n月夕有点虚弱地坐在弯月上，弯月下面，用一条破布吊着一尊诡异的冰雕。\\n一群早前失踪的尸族，像跟着萝卜走的笨骡，亦步亦趋地跟在雕像后面。\\n抱着豆丁幼尸的日夕和朱雀，在队伍的最后，是护卫的角色。\\n情不自禁地，两滴小小的眼泪从寇斯金脸色流了下来。\\n日月姐妹和朱雀向寇斯金讲述了解救的过程，那条破布，是用邪王罗密欧逃走的时候放弃的裤子、撕成一条一条后系成的绳索。老实说质量还挺不错的。\\n和日月夕姐妹道谢和道歉以及感动过后，寇斯金一拳打碎了邪王的雕像。\\n“老子要杀了你们！！”\\n不知道是震慑于自己族长的霸气，还是邪王对他们的迷惑力开始减退，尸族怪兽们甚至没有表现出愤怒的表情。\\n“还有你们，统统给我醒过来！“\\n寇斯金一记下勾拳击中一名怪兽的下巴，第二记重拳击中另一名怪兽的腹部，接着将一记回旋踢送给第三名怪兽——尸族族长暴力与担心共存的关爱方式让日月姐妹和朱雀开了眼界。\\n轮到豆丁幼尸的时候，冲到他面前的拳头变回粗糙的手掌。\\n寇斯金摸了摸他的头。\\n“干得好！“这样地赞赏到。\\n“唔呣……呜哇！“\\n从来被当作小透明的豆丁幼尸哭了出来，眼泪鼻涕在日夕的衣服上蹭来蹭去。日夕嫌弃地翻了个白眼，但并没有把豆丁幼尸扔下来。\\n之后，寇斯金命令其他尸族把混混沌沌的同族带走，用魔鬼式的体能训练让他们清醒为止。\\n“会不会太勉强了？”月夕说。\\n“不打紧，这样才能让他们脑瓜醒过来。要是连这点苦都受不了，我就把没用的家伙送回邪王那里！”\\n“之后的治愈请务必让我们帮忙。”\\n无法确保这种方法能让他们清醒过来，可能离开邪王的结界后，能用反复治愈或者净化的方式，慢慢唤醒他们。\\n“这个‘之后’，不会是指直到所有尸族恢复正常为止吧？“日夕不断向姐姐打眼色，算了，到时再找一个冠冕堂皇的理由开溜吧。\\n事情就这样告一段落了，月夕以为。\\n“邪王，一定会很快攻打过来的。”欧文提醒到。\\n因为受到这样那样的屈辱，已经无法耐着性子养精蓄锐，而且他们的手下中有龙族，飞上天空要找到尸族的大本营也不难。另外，超进化大陆现在还没形成统一战线，只对付一个种族的话，还是有一定胜算的。再加上，不朽级的日月姐妹都是治疗型怪兽，队伍中缺少同级的打手角色，这样一来邪王就更加不会有什么顾忌。\\n欧文滔滔不绝，月夕早已把身体的主导权交给了他。\\n并没有打过什么游戏，但凭借对客观条件的分析，预感到即将发生的危机。\\n“有什么好怕的，刚才那群怪兽，不是很菜吗？”日夕转达了李雨蒙的不屑。\\n这家伙又在出风头吗？不知不觉，李雨蒙对欧文滋长起敌意，这份情绪也感染了日夕。\\n“那些都是幻化级的怪兽，用邪王孢子进化的他们虽然拥有究极级的能力，但我们两个不朽级对付他们还算绰绰有余。而且，别忘了，那只是邪王外出巡逻的配置而已。”\\n“……照你这么说，我们要不必死无疑，要不只能向邪王投降？”不行，被智商碾压的感觉越来越强烈了。\\n“唔……现在唯有做好防守工作。我想飞到上空去查看一下冰川谷的地形。朱雀大人，高空巡逻的工作先麻烦你了。” \\n“放心吧。”朱雀化作一道焰光飞上天空。\\n“为尸族治疗的工作能交给你吗？我想尽快弄清楚这里的地形。”欧文转向日夕。\\n“拜托了，小夕。”月夕也恳求道。\\n“切……”李雨蒙用欧文和月夕都听不见的声音低语。\\n“好啦。”日夕勉强领命。\\n“族长，请你准备好随时能出击的战力。”\\n“唔嗯！”\\n欧文渐渐主控了战力调配的工作。",
    "resoundEventConfigDes_6015": "从天空俯瞰，身下有一座冰山，豆丁幼尸正是从山顶滚雪球下来的，山脚以南就是尸族的大本营冰川谷了，至于更寒冷的北方是不是也属于冰川谷，寇斯金一直没在意这种问题。不过，现在可以把那边定义为邪王的驻地了。\\n往北望去，这座山和更北方的冰川之间隔着一道峡谷，峡谷的两端各自向东西方延展，然后在不太遥远的地方，潜入冰冷的超星海洋。\\n仿如结界的暴风雪从更北边的冰川脚下开始，之前那个用来做冰雕工场的洞穴，就是那里的某处。\\n也就是说，邪王和他们的军队只需要翻过一座山就能向尸族进攻。\\n那么，打头阵的就是会飞的龙族了。\\n龙族身上可能还会背着其他族的怪兽，甚至是邪王……但是，数量还在可以应付的范围内……\\n不对，不可以用那个世界的常识和规则来思考这里的情况，万一某种怪兽能直接在山体击穿一个大洞，这座天然屏障的优势就荡然无存……\\n欧文在苦思冥想绝处逢生的方法，月夕不敢打扰他。\\n这时，朱雀飞过来了。\\n“一无所获……还是想想怎么安排尸族撤离这里吧。”欧文丧气地说。\\n“以前……”朱雀悠长的声音响起，好像从过去遥远的年月传来，“这里还是两片冰川，最后才渐渐连在一起。如果是以前，我们只需要防范空中的攻击就可以了。”\\n“……这样吗？”\\n欧文的脑海中浮现出另一侧冰川在久远的岁月中，缓缓移动涌出海湾，与这边的冰川相接的情形……那连接之处就是最为薄弱的地方……\\n可是，要怎么才能把它们分开？\\n就像弄断桥梁一样。\\n“啊！”头脑中划过一道闪电。\\n因为意念太过强烈，连月夕也感受到欧文的想法。\\n“欧文先生，你的世界……竟然发现了这种神奇的原理？”\\n“我想试试……”\\n“能成功吗？”\\n“……不确定的因素太多了，而且，我们的‘桥’和那个世界的实例比起来，太短太宽，说不定还很坚固。”\\n“即使这样……我们去找族长！”\\n“嗯！”\\n“朱雀大人，我们——”结束了与欧文的意识交流，月夕想向朱雀请辞。\\n“放开手脚大干一番吧。”从真·月夕刚才的沉默中，朱雀意识到他们想到了一个不错的主意。",
    "resoundEventConfigDes_6016": "\\n“族长，尸族都会游泳吗？”\\n“你说的是洗澡的时候进行的那种锻炼？”\\n“那你们知道峡谷之间的冰层大概有多厚吗？”\\n“大概这里到那里……”寇斯金快速跑了起来然后停在了远处。\\n欧文得到了心满意足的答复后，向寇斯金解释了自己的计划——利用共振的原理，把连接两边的那层脆弱“桥梁”震塌。\\n寇斯金马上为月夕准备了五百多个幻化级和十多个究极级的怪兽，寇斯金自己也是当中的一员。\\n他们很快跑到山脚，缓慢但平稳地徒手攀上山顶——体能比最人类最强的登山队还要强好几倍，接着，直接用屁股着地的方式从另一边的山腰滑下来。\\n月夕和欧文第二次目睹了尸族的过人之处。之前打败罗密欧回来的时候，即使是迷迷糊糊的尸族，登山也像如履平地一样轻松。\\n不用半天时间，五百多个尸族就来到了峡谷地带。\\n“一二、一二！”的口号声响彻逐渐变黑的天空。\\n寇斯金带头，五百多个尸族迈着整齐划一的步伐，在峡谷间来回走动。\\n尸族平时在寇斯金的带领下，进行着各种各样的体能锻炼，只是齐整地踏步走的话，并没有多大难度。但是如果要不断调整踏步的快慢节奏，对头脑简单的尸族来说，并不是容易理解的事。\\n但幸好，大家也没问那么多，寇斯金怎么做，他们就跟着怎么做。\\n也可以说是管理有方？欧文心里赞叹到。\\n豆丁幼尸再次发挥了巨大的作用。\\n藏在地洞里，感受着每次振动的强烈。\\n“唔呣！就是这个节奏！”\\n重复了不知道多少次的踏步前进，豆丁幼尸终于从雪地里伸出举起大拇指的手。\\n但是，更大的震动在下一瞬间降临了，那是来自北方的复仇。\\n和欧文预想的一样，第一批出击的，是龙族。\\n数条轰龙、荒火龙和暗黑龙飞过冰山，朝地上喷出猩红和暗黑的火焰。不过他们身上没有骑载着其他怪兽，可能是不愿意成为别人的坐骑吧。\\n朱雀在上空和他们周旋。剩余的尸族早已准备好大量的尖冰，化身尸族投石机，一块块又尖又硬的冰块穿过焰火，刺穿这些天空霸主的血肉。\\n日夕发射的光弹击落了几条轰龙，战火开始朝她身上集中。一团接一团的烈焰扑向日夕，让她身陷冰与火的地狱中。\\n不过，那只是看似地狱的景象，火焰是吓不住太阳的。但是，呛鼻的浓烟让日夕喘不过气来，泪水模糊了她精致的妆容，裙子也被烧得破破烂烂，低级尸族的肉焦味和哀嚎更让她心烦气躁。\\n这一切才是逐渐摧毁日夕理智的元凶。\\n“姐姐在搞什么！嗨呀！！”\\n几枚光弹射向离她最近的一条暗黑龙，暗黑龙尖啸着，报之以比黑夜更漆黑的黯焰。\\n光弹把暗黑龙击落，暗黑龙掉在远处的雪地上，溅起一片雪花。\\n“哈哈哈哈……”嘶哑的狂笑从还没落定的雪埃中传来。\\n日夕看到暗黑龙把几枚纹章塞进体内后，再次摇摇晃晃地飞起来。\\n“咕、肮脏的蜥蜴！”\\n非常火大地这么叫着的同时，自傲的『逆转之力』所放出的攻击效果渐渐减弱，不，应该说敌人更耐揍了。\\n“衣服、头发！烧起来了！”李雨蒙惊呼。\\n“啧！”\\n日夕收回手中的光弹，狼狈地拍打紧紧缠在身上的黯焰。\\n“别白费劲了！我的黯焰，在它所碰到的东西燃尽之前，是不会熄灭的。如果你不怕火，死不去，它就缠你一辈子，桀桀桀桀桀！！”\\n其余几条暗黑龙对日夕施以同样的恶行。他们在日夕头顶盘旋，慢慢啃噬着这份疯狂的甜美。\\n一头长长的秀发只剩下一半的长度，裙子也破烂得仅能遮体，日夕尖叫着在雪地上滚来滚去，却仍然无法扑灭身上的黯焰。\\n为什么！\\n为什么倒霉的总是自己！\\n为什么丢脸的总是自己！\\n“那些孢子！吃掉它们，是不是就能变得更强？”\\n李雨蒙的疑问，让日夕抓到了一根救命稻草。\\n差点忘记了它们的存在。被邪王侵染过的孢子，无疑有强大的魅惑兽心的毒素，但自己，一定！能抵御那种毒！\\n日夕把手伸进裙兜里……",
    "resoundEventConfigDes_6017": "君临天下般，穿上了另一条裤子的罗密欧站在冰川顶，睥睨着那支区区五百只怪兽——现在才开始练习如何行军的队伍。\\n冰雪城堡的怪兽大军倾巢而出，像肮脏的黑水，从冰川上一涌而下。\\n“不要停，继续！”\\n月夕（欧文）坐在弯月上，指挥着乱了阵脚的尸族大队。\\n这个办法是凑效的！\\n刚才他跟着尸族的节奏踏了一个来回，明显感到峡谷的振动愈来愈强烈。\\n还差一点！\\n邪王的大军快冲到峡谷了，如果被它们改变了振动频率，一切都前功尽弃！\\n可恶！真的只差一步而已！！\\n当一只怪兽冲进峡谷，举起长矛要刺向某个尸族的时候，欧文绝望了。\\n不过，敌人的袭击突然停了下来，连后面来势汹汹的大军也静止不动。\\n“停下！小心有诈！”\\n罗密欧向他的大军传达了这样的指令。\\n他担心地捂紧了裤子，在自己无论如何也琢磨不出的“诡计”前，谨慎了起来。\\n对月夕大人绝对服从的寇斯金，依旧没有停下他的脚步。尽管月夕也是处在万分惊讶之中，才忘了布置下一步的行动。\\n喀啦！\\n不知从哪里传来冰块清脆的破裂声。\\n像多米诺骨牌中的某块倒下所引发的连锁效应一样，峡谷某处的断裂不断扩大，尸族脚下的坚冰很快裂成一块块浮冰。\\n最接近峡谷的怪兽和好几个尸族因为站不稳扑通掉进冰水里。\\n友方这边没问题，欧文刚才已经跟寇斯金确认过了。\\n但敌方的怪兽就没有这么淡定了，因惊吓和包裹全身的刺骨冰冷，毫无章法地在水里扑腾，越扑腾身体越僵硬、越往下沉。\\n现在，除了龙族，敌方军队中的尸族，是罗密欧唯一可以依靠的战力。\\n龙族的火焰被冰水无声无息地吞没。\\n尸族与尸族在冰水中扭打起来，可惜数量上还是不及大本营的精锐。\\n罗密欧气得直跳脚，果然是陷阱！撕裂大地，可怕的魔法！\\n“蠢材！给我踩着浮冰冲过去！！”\\n他咆哮完后，向南边吹响战号，想把龙族召回来。但是——\\n紫金色热风从彼地袭来，山峰丝毫无法减弱它的势头，绝望的、压倒性的暴威狂乱地吹舞着。\\n那些曾经的空中霸主被狂风吹到空中——不用确认，也知道那边的龙族已经全军覆没。\\n罗密欧的战号声变成了风中的哀鸣。\\n恐惧和不安袭上月夕心头，风中不断闪烁着的那种金色，她太熟悉了。\\n她坐上弯月，逆风而疾行，很快便看到了那个释放紫金色热风的苗条身影。\\n“小夕——！！”\\n呼唤声被风吹散，根本无法传到日夕的耳边。\\n“她吃了有毒的进化孢子！！”朱雀艰难地飞到月夕身边。\\n怪异强大的能量，不断从日夕的体内涌动出来。\\n日夕娇嫩的皮肤下，紫色的光和金色的光在角力，两种光都想迸射而出。\\n月夕离日夕越近，感受到的阻力就越大。\\n“再这样下去，她会爆炸吗？”欧文说。\\n“……欧文先生，对不起……无论如何，我也要救小夕！”\\n“等等——”\\n月夕屏蔽了欧文的意识，加速飞向日夕。\\n峡谷，已荡然无存。\\n取而代之的，是一条越来越宽的海峡。\\n罗密欧，只好无助地站在冰川之顶，看着自己三分之一的战力折损在这里。\\n冰川谷被一分为二，峡谷变成海峡，它阻挡了邪王大举进犯的道路，也阻挡英雄们联合各族大军，前进和反击的道路。",
    "messageInitContent_4953": "后面几个是干嘛的，山崩？",
    "messageInitNick_11745": "别露出鸡脚",
    "messageInitContent_4954": "诶诶，天 气 预 报",
    "messageInitNick_11744": "一抹斜阳",
    "messageInitContent_4955": "天气不像预期",
    "messageInitNick_11743": "好莱污影帝",
    "messageInitContent_4956": "该降温了！",
    "messageInitNick_11742": "暴走的牛奶糖",
    "messageInitContent_4957": "偶像！",
    "messageInitNick_11749": "万能水杯",
    "messageInitContent_4958": "美甲不错哪里整的",
    "messageInitNick_11748": "晚上好",
    "messageInitContent_4959": "单分子线？",
    "messageInitNick_11747": "早上好",
    "messageInitNick_11746": "猛虎山下",
    "messageInitContent_4960": "我要飞得更高",
    "messageInitNick_11741": "刺客厅",
    "messageInitContent_4961": "金色不错",
    "messageInitNick_11740": "梨魔法",
    "messageInitContent_4962": "来了",
    "messageInitContent_4963": "大胆怪兽",
    "messageInitContent_2301": "买定离手噜喂！",
    "messageInitContent_2300": "我赌1毛冰霓",
    "messageInitContent_2309": "没记错蜡笔小新的狗好像就是叫这个",
    "messageInitContent_2308": "小白！！！！",
    "messageInitContent_2307": "这是你的益达，那是我的金矿",
    "messageInitContent_2306": "那是我的金矿！",
    "messageInitContent_2305": "嘿嘿我的小金库",
    "messageInitContent_2304": "不不，他要亲手焚尽大陆的黑暗！",
    "messageInitContent_2303": "火神是来放烟花的",
    "messageInitContent_2302": "那我只能点个赞了啊",
    "messageInitContent_4964": "什么用品店？？？",
    "messageInitNick_11756": "丑的很极致",
    "messageInitContent_4965": "都行想啥呢",
    "messageInitNick_11755": "逃避那一切",
    "messageInitContent_4966": "昨天见",
    "messageInitNick_11754": "心碎巧克力",
    "messageInitContent_4967": "这岛会崩就是因为你们是吧",
    "messageInitNick_11753": "独孤求婚",
    "messageInitContent_4968": "取暖",
    "messageInitContent_4969": "核动力暖炉",
    "messageInitNick_11759": "空城等人",
    "messageInitNick_11758": "消失的吃的",
    "messageInitNick_11757": "肥皂盒狂怒者",
    "messageInitContent_4970": "我老婆呢在不在",
    "messageInitContent_4971": "亲爱的，我来啦",
    "messageInitNick_11752": "余生各自安好",
    "messageInitContent_4972": "怎么只有2溜溜",
    "messageInitNick_11751": "阁楼猫",
    "messageInitContent_4973": "约等于只有社恐龙",
    "messageInitNick_11750": "引战冠军",
    "messageInitContent_4974": "溜溜球",
    "messageInitContent_2312": "珍宝这回终于不用带头了",
    "messageInitContent_2311": "小白，让我带你离开这里！",
    "messageInitContent_2310": "珍宝，我不打你，你只要把矿给我就好了",
    "randomEventDialogueGroupConfig_12.195": "指出它辩输了",
    "messageInitContent_2319": "我宣布兵器和狐仙就是这里的cp了",
    "randomEventDialogueGroupConfig_12.194": "不告诉它",
    "messageInitContent_2318": "独角兽也不好搞啊",
    "randomEventDialogueGroupConfig_12.197": "问自己的奖品何在",
    "messageInitContent_2317": "只要你的好兄弟穿角兽不在一切好说",
    "randomEventDialogueGroupConfig_12.196": "好好你赢了，你走吧，我继续躺。",
    "messageInitContent_2316": "提前热热身！",
    "randomEventDialogueGroupConfig_12.191": "说啥呢，我跟外面那些神秘商人才不是同一路货色！",
    "messageInitContent_2315": "不是好像呢是真的热",
    "randomEventDialogueGroupConfig_12.190": "放弃争辩离开",
    "messageInitContent_2314": "那边好像很热的样子",
    "randomEventDialogueGroupConfig_12.193": "切，我是神秘商人又怎样？",
    "messageInitContent_2313": "要走向新的区域了",
    "randomEventDialogueGroupConfig_12.192": "指出它说漏嘴了",
    "messageInitContent_4975": "孤独的灵魂就由我来消灭吧！",
    "messageInitContent_4976": "那你很棒棒哦",
    "messageInitContent_4977": "独占这片区域嘻嘻",
    "messageInitContent_4978": "来一杯奶茶",
    "messageInitContent_4979": "好耶",
    "messageInitContent_4980": "看得见摸不着",
    "messageInitContent_4981": "天哪",
    "messageInitContent_4982": "还剩多少个据点",
    "messageInitContent_4983": "全双种族阵容喔",
    "messageInitContent_4984": "屏幕冒烟！",
    "messageInitContent_4985": "是时候谢幕了各位",
    "messageInitContent_2323": "看来是有看故事的哈",
    "messageInitContent_2322": "菲菲~",
    "messageInitContent_2321": "最终，兵器它到底怎样了呢",
    "messageInitContent_2320": "怎么又来了",
    "randomEventDialogueGroupConfig_12.199": "我又不想知道，你走吧。",
    "randomEventDialogueGroupConfig_12.198": "离开",
    "messageInitContent_2329": "全觉醒！",
    "messageInitContent_2328": "橙汁那个你够了",
    "messageInitContent_2327": "给你们看看我的橙汁！",
    "messageInitContent_2326": "给你们看看我的at力场！",
    "messageInitContent_2325": "站在你身边的不是魅妆了吗？",
    "messageInitContent_2324": "我的大兵器，你怎么去那边了！！",
    "messageInitContent_4986": "乖乖投降",
    "messageInitContent_4987": "开炮！",
    "messageInitContent_4988": "别打我呀",
    "messageInitContent_4989": "来我这包五险一金！",
    "messageInitNick_4398": "今日礼拜八",
    "messageInitContent_4990": "不愧是我哈哈哈哈哈轻轻松松又一关",
    "messageInitNick_4397": "拿什么抵抗你",
    "messageInitContent_4991": "电磁炮！",
    "messageInitNick_4396": "回眸一只狗",
    "messageInitContent_4992": "割草",
    "messageInitNick_4395": "咕咕何其多",
    "messageInitContent_4993": "草哥，让一让",
    "messageInitContent_4994": "马上到古记",
    "messageInitContent_4995": "你的心不痛的吗",
    "messageInitContent_4996": "再来一遍",
    "messageInitNick_4399": "咩啊咩啊",
    "messageInitContent_2334": "什么搞笑，多帅！",
    "messageInitContent_2333": "现在看那些锁链好搞笑",
    "messageInitContent_2332": "什么第十集",
    "messageInitContent_2331": "第十集战斗准备！",
    "messageInitContent_2330": "没有关系，胜利的还是我！",
    "messageInitContent_2339": "那恐怕不是cp那么简单，你们的思想很危险",
    "messageInitContent_2338": "我觉得巽和毁灭巨像比较有cp感",
    "messageInitContent_2337": "后面的只能沉默看着",
    "messageInitContent_2336": "又来了乱组cp",
    "messageInitContent_2335": "我宣布风神和狐仙就是这里的cp了",
    "messageInitContent_4997": "什么光能使者",
    "messageInitNick_11789": "猜不透",
    "messageInitNick_4390": "橙汁船长",
    "messageInitContent_4998": "突破！",
    "messageInitNick_11788": "颜值兵马俑",
    "messageInitContent_4999": "你们先打我去对面帮忙",
    "messageInitNick_11787": "神秘商店顾问",
    "messageInitNick_11786": "戏嫦娥",
    "messageInitNick_4394": "爱情纯属虚构",
    "messageInitNick_4393": "匿名诗人",
    "messageInitNick_4392": "此情已成追忆",
    "messageInitNick_4391": "昂首做女王",
    "messageInitNick_11781": "醉人的菠萝",
    "messageInitNick_4387": "菠菜魔法师",
    "messageInitNick_11780": "策划在线炒螺",
    "messageInitNick_4386": "无敌恰瓜神",
    "messageInitNick_4385": "老泰隆走中",
    "messageInitNick_4384": "深海摸鱼神",
    "messageInitNick_11785": "今晚相亲",
    "messageInitNick_11784": "旅店老板",
    "messageInitNick_11783": "沉浸式回家",
    "messageInitNick_4389": "香菜撞地球",
    "messageInitNick_11782": "敢不敢喜欢我",
    "messageInitNick_4388": "腐乳炒通菜",
    "messageInitContent_2345": "包租公那边也有岛，偶尔住腻了换个口味",
    "messageInitContent_2344": "但这里的气氛会不会有点压抑。应该选北边那边的导",
    "messageInitContent_2343": "祖拉，我的天才",
    "messageInitContent_2342": "又见到不朽觉醒中的祖拉了！",
    "messageInitContent_2341": "不愧是包租公，一个人一个岛",
    "messageInitContent_2340": "春暖花开！",
    "messageInitContent_2349": "真正的好领域是挂了都还在的",
    "messageInitContent_2348": "三炮齐鸣~",
    "messageInitContent_2347": "大炮，小炮，中炮呢？",
    "messageInitContent_2346": "来留言板，编写你的故事",
    "messageInitNick_11799": "只会口胡",
    "messageInitNick_11798": "橙子去哪了",
    "messageInitNick_11797": "嘤嘤嘤怪",
    "messageInitNick_4383": "鲸鱼宝宝",
    "messageInitNick_4382": "马上是多久",
    "messageInitNick_4381": "文件乱码",
    "messageInitNick_4380": "哥本哈哈",
    "messageInitNick_11792": "无坑速动",
    "messageInitNick_4376": "宝贝莫哭",
    "messageInitNick_11791": "菠菜兽",
    "messageInitNick_4375": "傲娇小野猫",
    "messageInitNick_11790": "行走的辣椒",
    "messageInitNick_4374": "仙人掌模拟器",
    "messageInitNick_4373": "诺贝尔对线奖",
    "messageInitNick_11796": "青春你好痘",
    "messageInitNick_11795": "甩锅鉴定家",
    "messageInitNick_4379": "炉灰菇凉",
    "messageInitNick_11794": "七大姑",
    "messageInitNick_4378": "暗影大师的影",
    "messageInitNick_11793": "银河倾斜",
    "messageInitNick_4377": "无敌懂神",
    "messageInitContent_2356": "那是特效",
    "messageInitContent_2355": "尸气！",
    "messageInitContent_2354": "火神身上的是火，那尸狂公身上的是什么？",
    "messageInitContent_2353": "你反我，我反你",
    "messageInitContent_2352": "金色的巨像！！更持久的反伤。",
    "messageInitContent_2351": "别问问就是从身上跑出来的",
    "messageInitContent_2350": "藤妖的沼泽是从哪里出来的呢",
    "immortalCocoonConfigName_219": "炼御模式",
    "immortalCocoonConfigName_218": "变大还是变小",
    "immortalCocoonConfigName_217": "王霸和玄武",
    "messageInitNick_4372": "下年摸鱼",
    "messageInitNick_4371": "空气宝宝",
    "messageInitNick_4370": "我不够拽",
    "messageInitNick_4365": "江湖见兄弟",
    "messageInitNick_4364": "恋爱通知书",
    "messageInitNick_4363": "划水之王",
    "messageInitNick_4362": "喂自己袋盐",
    "messageInitNick_4369": "电子冰糖",
    "messageInitNick_4368": "退退退",
    "messageInitNick_4367": "超级卷姐",
    "messageInitNick_4366": "泥巴佬",
    "immortalCocoonConfigName_216": "最上镜怪兽",
    "immortalCocoonConfigName_215": "功高劳苦",
    "immortalCocoonConfigName_214": "墙墙联手",
    "immortalCocoonConfigName_213": "马后炮",
    "immortalCocoonConfigName_212": "大锤特锤",
    "immortalCocoonConfigName_211": "究极切后",
    "immortalCocoonConfigName_210": "幼体强者",
    "immortalCocoonConfigName_209": "混合双打",
    "immortalCocoonConfigName_208": "火海一条龙服务",
    "immortalCocoonConfigName_207": "火光冲天",
    "immortalCocoonConfigName_206": "日观星象",
    "messageInitNick_4361": "顶尖疯子",
    "messageInitNick_4360": "巧克力泡辣汤",
    "messageInitNick_4354": "劈开高跟鞋",
    "messageInitNick_4353": "尖叫芭蕉",
    "messageInitNick_4352": "快乐司机",
    "messageInitNick_4351": "嗲嗲的女生",
    "messageInitNick_4358": "在赚钱的路上",
    "messageInitNick_4357": "哥累了",
    "messageInitNick_4356": "寻找解决方案",
    "messageInitNick_4355": "国服第一可爱",
    "immortalCocoonConfigName_205": "快乐蓝调",
    "immortalCocoonConfigName_204": "毒花",
    "immortalCocoonConfigName_203": "黑虎掏心",
    "immortalCocoonConfigName_202": "一斧挡王霸",
    "messageInitNick_4359": "放学等我",
    "immortalCocoonConfigName_201": "W",
    "immortalCocoonConfigName_200": "花丛有猛兽出没",
    "messageInitNick_4350": "夕阳当外套",
    "messageInitNick_4343": "我推的垫子",
    "messageInitNick_4342": "跑分大师",
    "messageInitNick_4341": "幻想家",
    "messageInitNick_4340": "立夏",
    "messageInitNick_4347": "生气的变速箱",
    "messageInitNick_4346": "跟风流浪",
    "messageInitNick_4345": "可爱的昨日",
    "messageInitNick_4344": "复读先驱",
    "messageInitNick_4349": "顶级抠脚大汉",
    "messageInitNick_4348": "不爱就坚强",
    "2_1": "解锁",
    "2_2": "未解锁",
    "2_3": "需要探索者等级{1}",
    "2_4": "主动",
    "2_5": "被动",
    "2_6": "每级+{1}",
    "2_7": "浴火重生",
    "2_8": "回复己方怪兽{1}%的血量",
    "2_9": "己方怪兽生物屏障提升{1}",
    "messageInitNick_4332": "傲似公主",
    "messageInitNick_6995": "康我平底锅",
    "messageInitNick_4331": "痴心去扑火",
    "messageInitNick_6996": "不似少年时",
    "messageInitNick_4330": "福音中心",
    "messageInitNick_6997": "单身女王",
    "messageInitNick_6998": "最爱龙眼",
    "messageInitNick_4336": "心理治疗师",
    "messageInitNick_6991": "天堂汤圆",
    "messageInitNick_4335": "义字当头",
    "messageInitNick_6992": "世界回归寂静",
    "messageInitNick_4334": "套娃神",
    "messageInitNick_6993": "捡漏小能手",
    "messageInitNick_4333": "高温落汤鸡",
    "messageInitNick_6994": "无重力洗衣机",
    "messageInitNick_4339": "公主骑士",
    "messageInitNick_4338": "卷帝",
    "messageInitNick_4337": "无极上限",
    "messageInitNick_6999": "记忆烧成灰",
    "messageInitNick_6990": "不知火舞弟弟",
    "26_2009": "今日最高",
    "26_2008": "剩余时间",
    "26_2007": "得分",
    "messageInitNick_4321": "格兰芬少",
    "messageInitNick_6984": "银子怪兽",
    "messageInitNick_4320": "超级钓鱼神",
    "messageInitNick_6985": "哥纯帅",
    "26_2015": "总任务",
    "messageInitNick_6986": "洗衣液剑客",
    "26_2014": "日任务",
    "messageInitNick_6987": "无尽的螺丝",
    "26_2013": "开始",
    "messageInitNick_4325": "整活大师",
    "messageInitNick_6980": "百事小甜饼",
    "26_2012": "前进：{1}",
    "messageInitNick_4324": "请和她交往",
    "messageInitNick_6981": "陪我忘记",
    "26_2011": "排行榜",
    "messageInitNick_4323": "究极飞龙",
    "messageInitNick_6982": "便利店老板",
    "26_2010": "重开",
    "messageInitNick_4322": "北冥女皇",
    "messageInitNick_6983": "伙食好过头",
    "messageInitNick_4329": "花店老板",
    "messageInitNick_4328": "草莓酸奶酱",
    "messageInitNick_4327": "愤怒的脚本",
    "messageInitNick_4326": "且行且珍惜",
    "messageInitNick_6988": "奉旨泡妞",
    "messageInitNick_6989": "香菜之心",
    "messageInitContent_4906": "思考中",
    "messageInitContent_4907": "什么炮",
    "messageInitContent_4908": "什么台",
    "messageInitContent_4909": "马脚也是脚吗",
    "messageInitContent_4900": "我的爱如潮水",
    "messageInitContent_4901": "发射！",
    "messageInitContent_4902": "是个黑帮叫礼品店？",
    "messageInitContent_4903": "一脸懵逼",
    "messageInitContent_4904": "风里雨里",
    "messageInitContent_4905": "乖巧",
    "26_2006": "倒计时",
    "messageInitNick_4310": "粽子觉得满足",
    "messageInitNick_6973": "残月狂战",
    "26_2005": "前进",
    "immortalCocoonConfigName_240": "工具空",
    "messageInitNick_6974": "上午九点半",
    "messageInitNick_6975": "山不语",
    "26_2003": "剩余：{1}",
    "messageInitNick_6976": "这播的的吗",
    "26_2002": "去完成",
    "messageInitNick_4314": "猫咪交响乐",
    "26_2001": "做任务得",
    "messageInitNick_4313": "榴莲是厨师",
    "messageInitNick_6970": "一百亿",
    "messageInitNick_4312": "九百代单传",
    "messageInitNick_6971": "外来媳妇",
    "messageInitNick_4311": "有故事的人",
    "messageInitNick_6972": "迷上门口老头",
    "messageInitNick_4318": "好掏好掏好掏",
    "messageInitNick_4317": "未曾设想的路",
    "messageInitNick_4316": "智能牙刷",
    "messageInitNick_4315": "阿姨来巡房",
    "messageInitNick_6977": "滚出我的心",
    "messageInitNick_6978": "会飞的小金人",
    "messageInitNick_6979": "剑过留毛",
    "messageInitNick_4319": "养肥了看",
    "messageInitContent_4917": "就很",
    "messageInitContent_4918": "懂了是克隆失败",
    "messageInitContent_4919": "疑惑",
    "immortalCocoonConfigName_239": "顶阵",
    "messageInitContent_4910": "黑丝！",
    "messageInitContent_4911": "好jio！",
    "messageInitContent_4912": "喵响在干嘛",
    "messageInitContent_4913": "怎么多了一兄弟",
    "messageInitContent_4914": "克隆兄弟",
    "messageInitContent_4915": "懂了喵响是客人",
    "messageInitContent_4916": "下一关再见~",
    "immortalCocoonConfigName_230": "虫草花",
    "messageInitNick_6962": "福如东海",
    "messageInitNick_6963": "阿喵午休时间",
    "messageInitNick_6964": "蜂鸟飞翔",
    "messageInitNick_6965": "俺丑的有魅力",
    "messageInitNick_4303": "繁星与夜",
    "messageInitNick_4302": "丑得那么别致",
    "messageInitNick_4301": "开心的笨小孩",
    "messageInitNick_6960": "道友停步",
    "messageInitNick_4300": "国民软妹",
    "messageInitNick_6961": "绝地苍狼",
    "immortalCocoonConfigName_238": "草之呼吸",
    "messageInitNick_4307": "太上老菌",
    "immortalCocoonConfigName_237": "领跑员",
    "messageInitNick_4306": "心弦在跳动",
    "immortalCocoonConfigName_236": "兄妹齐心",
    "messageInitNick_4305": "恰瓜大师",
    "immortalCocoonConfigName_235": "桃花运",
    "messageInitNick_4304": "凉心姑娘",
    "immortalCocoonConfigName_234": "永远的5号位",
    "messageInitNick_6966": "故事说书人",
    "immortalCocoonConfigName_233": "虎龙豹的幻象",
    "messageInitNick_6967": "十全大补鸡",
    "immortalCocoonConfigName_232": "兄妹",
    "messageInitNick_4309": "流浪的枕骨",
    "messageInitNick_6968": "防弹冬瓜",
    "immortalCocoonConfigName_231": "五分一神唤",
    "messageInitNick_4308": "冷静冷静",
    "messageInitNick_6969": "收音机很无奈",
    "messageInitContent_4928": "行8",
    "messageInitContent_4929": "想让我笑一会",
    "immortalCocoonConfigName_229": "天龙",
    "immortalCocoonConfigName_228": "战地记者",
    "messageInitContent_4920": "都被你懂玩了",
    "messageInitContent_4921": "锦鲤路过",
    "messageInitContent_4922": "早呀各位",
    "messageInitContent_4923": "是谁在偷偷说我帅",
    "messageInitContent_4924": "第一",
    "messageInitContent_4925": "第二",
    "messageInitContent_4926": "美妆店是吧",
    "messageInitContent_4927": "别过来",
    "messageInitNick_6951": "点赞之神",
    "messageInitNick_6952": "饭堂掌舵者",
    "messageInitNick_6953": "游泳去月球",
    "messageInitNick_6954": "那是蛙式游泳",
    "messageInitContent_4930": "有请受害者登场",
    "messageInitNick_6950": "凌晨两点",
    "immortalCocoonConfigName_227": "开心大炮",
    "messageInitNick_6959": "唇唇欲动",
    "immortalCocoonConfigName_226": "羡慕",
    "immortalCocoonConfigName_225": "四马难追",
    "immortalCocoonConfigName_224": "镇剧",
    "immortalCocoonConfigName_223": "毒蛇",
    "messageInitNick_6955": "深睡美人",
    "immortalCocoonConfigName_222": "啥都返",
    "messageInitNick_6956": "心灵老鸭汤",
    "immortalCocoonConfigName_221": "御星",
    "messageInitNick_6957": "百香果的春天",
    "immortalCocoonConfigName_220": "毒奶",
    "messageInitNick_6958": "缺一颗兔牙",
    "messageInitNick_4761": "一步一歪",
    "messageInitNick_4760": "智能食盐",
    "messageInitNick_2102": "皓月冷千山",
    "messageInitNick_4765": "作业做完了吗",
    "messageInitNick_2103": "一念一轮回",
    "messageInitNick_4764": "绿色发电",
    "messageInitNick_2100": "超级捡漏神",
    "messageInitNick_4763": "沉浸式洗猫",
    "messageInitNick_2101": "骑驴追火箭",
    "messageInitNick_4762": "尬聊小天才",
    "messageInitNick_2106": "专业套娃",
    "messageInitNick_4769": "撞到你怀里",
    "messageInitNick_2107": "不需要人陪",
    "messageInitNick_4768": "小祖宗",
    "messageInitNick_2104": "酷酷女汉纸",
    "messageInitNick_4767": "不聊天打游戏",
    "messageInitNick_2105": "卖蠢小能手",
    "messageInitNick_4766": "如果瓜子会笑",
    "messageInitNick_2108": "矫情怪",
    "messageInitNick_2109": "傲天战神",
    "messageInitNick_4750": "冷眼看浮华",
    "messageInitNick_4754": "熬夜先驱",
    "messageInitNick_4753": "对方正在输入",
    "messageInitNick_4752": "沉迷吃饭",
    "messageInitNick_4751": "番茄兽",
    "messageInitNick_4758": "苹果射手",
    "messageInitNick_4757": "单车少年",
    "messageInitNick_4756": "纯情棒棒糖",
    "messageInitNick_4755": "我出双倍",
    "messageInitNick_4759": "咕咕爱好者",
    "messageInitNick_4743": "凌晨两点半",
    "messageInitNick_4742": "汪汪队",
    "messageInitNick_4741": "红辣椒之子",
    "messageInitNick_4740": "跟骨",
    "messageInitNick_4747": "哇哦这样啊",
    "messageInitNick_4746": "道理我都不懂",
    "messageInitNick_4745": "大猫砂",
    "messageInitNick_4744": "电磁炉歌舞团",
    "messageInitNick_4749": "谁把琴弦拨断",
    "messageInitNick_4748": "凉粉诗人",
    "messageInitNick_4732": "不在乎过去",
    "messageInitNick_4731": "大脑按摩师",
    "messageInitNick_4730": "究成空",
    "messageInitNick_4736": "挥剑断魂",
    "messageInitNick_4735": "您品您细品",
    "messageInitNick_4734": "冒牌货",
    "messageInitNick_4733": "漫展显眼包",
    "messageInitNick_4739": "迷路的核糖体",
    "messageInitNick_4738": "热心的小天才",
    "messageInitNick_4737": "萝卜之心",
    "98_-200037": "{1}后可换一批",
    "98_-200036": "该部落状态异常",
    "98_-200035": "申请等待处理中",
    "98_-200034": "部落已满员",
    "98_-200033": "已发出{1}条部落申请，无法继续申请",
    "98_-200032": "部落战主塔或外塔已到达最大人数限制",
    "98_-200031": "部落战备战期和开战期，无法变更酋长/管理",
    "98_-200030": "部落战备战期和开战期，无法退出部落",
    "messageInitNick_4721": "在逃艺术家",
    "messageInitNick_4720": "旋转肌肉",
    "98_-200039": "公告内容含有敏感信息或特殊字符，请重新输入",
    "98_-200038": "没有参与上一次部落战",
    "messageInitNick_4725": "拉面牧师",
    "messageInitNick_4724": "你是大鲨鱼",
    "messageInitNick_4723": "灵感女魂",
    "messageInitNick_4722": "鳄鱼缺根筋",
    "messageInitNick_4729": "白灼菜心",
    "messageInitNick_4728": "龟咩之刀",
    "messageInitNick_4727": "茄子女巫",
    "messageInitNick_4726": "超级披萨",
    "messageInitNick_4719": "迷路的基质",
    "98_-200026": "部落遗迹已被占领",
    "98_-200025": "{1}后可再次挑战该遗迹",
    "98_-200024": "部队无怪兽",
    "98_-200023": "部落战结算中，请稍后再试",
    "98_-200022": "部落战准备中，请稍后再试",
    "98_-200021": "部落战匹配中，请稍后再试",
    "98_-200020": "交战状态结束",
    "messageInitNick_4710": "新型泡菜",
    "98_-200029": "部落战备战期和开战期，无法踢出成员",
    "98_-200028": "部落战备战期和开战期，无法解散部落",
    "98_-200027": "部落战报名时你尚未加入部落，无法参与此次部落战",
    "messageInitNick_4714": "无公害菜花",
    "messageInitNick_4713": "凉粉怪客",
    "messageInitNick_4712": "你好静静",
    "messageInitNick_4711": "二点五条",
    "messageInitNick_4718": "酿辣椒",
    "messageInitNick_4717": "抬杠神",
    "messageInitNick_4716": "人参果龙",
    "messageInitNick_4715": "金色战车",
    "messageInitNick_4709": "现在是我的了",
    "messageInitNick_4708": "欠吻吗",
    "98_-200015": "部队中所有怪兽均为濒死状态",
    "98_-200014": "阵容状态限制",
    "98_-200013": "距离发动宣战不足60分钟，请稍后再试",
    "98_-200012": "已被其他探索者击破",
    "randomEventDialogueGroupConfig_11.401": "拾起",
    "98_-200011": "遗迹处于被宣战状态，无法放弃宣战",
    "randomEventDialogueGroupConfig_11.400": "“我好满足，好开心。”它身上也果然掉出了更好的东西。",
    "98_-200010": "遗迹仍处于被宣战状态，请勿重复宣战",
    "98_-200019": "宣战条件不足",
    "98_-200018": "怪兽处于濒死状态不能出战",
    "98_-200017": "在其他部队上阵中",
    "98_-200016": "部队正在路上，无法更改配置",
    "messageInitNick_4703": "千面幻影",
    "messageInitNick_4702": "橙子君快逃",
    "messageInitNick_4701": "戒梦",
    "messageInitNick_4700": "无上上上王",
    "messageInitNick_4707": "泡芙侦探",
    "messageInitNick_4706": "不准咬家具",
    "messageInitNick_4705": "清澈的愚蠢",
    "messageInitNick_4704": "跟寂寞和好",
    "98_-200004": "该探索者已取消申请",
    "98_-200003": "请输入3-12个字符的部落名称",
    "98_-200002": "部落名称含有敏感信息或特殊字符，请重新输入",
    "98_-200001": "部落未解锁",
    "98_-200009": "该图腾冷却中，请稍后再试",
    "98_-200008": "该申请已过期",
    "98_-200007": "部落权限不足",
    "98_-200006": "{1}后可重新加入或创建部落",
    "98_-200005": "部落名称已存在，请重新输入",
    "99_95|L": "获得奖励",
    "97_desc8": "1.商店的刷新时间各不相同\\n2.一发入欧店中每次消耗钻石都会提升好感度，包括消耗钻石刷新，好感度达到一定程度后解锁额外的格子，但每次刷新只可购买其中一件",
    "98_-200073": "今天可加入成员为0",
    "97_desc9": "1.造唤台当然是用来造唤的啦╰(*°▽°*)╯\\n2.每次造唤都会获得造唤积分，重复获得已拥有的觉醒怪兽时，将转化为获得30块对应的怪兽碎片\\n3.造唤积分可在造唤商店购买物品\\n4.免费造唤所需时长随造唤台等级提升而降低\\n5.每个卡池每日最多可造唤{1}次",
    "98_-200072": "拍卖品正在结算，请勿操作",
    "97_desc6": "1.提升探索者等级可解锁更多的上阵位置\\n2.排阵中首位上阵的神灵为战斗开始时默认在场的神灵\\n3.长按怪兽/神灵可进入对应的培养界面\\n4.点击齿轮可进入怪兽界面，点击战墙可进入战墙配置界面，点击漆黑之根可进入漆黑之根界面，点击起源基石可查看起源基石带来的各项加成，点击起源核心可进入起源盘配置界面",
    "98_-200071": "发起申请过多，请取消其他申请后再试",
    "97_desc7": "全局：\\n1.在支配核心中捐献金币或钻石可增加部落资源和自身的贡献，支配核心捐献到达一定进度后可领取支配核心捐献奖励，消耗战令可增加自身的活跃度\\n2.退出部落时贡献和活跃度清0，遗迹中的部队自动撤离，退出部落后重新加入新部落/创建部落有冷却时间，加入新部落后不能领取已领取过的冒险关卡奖励\\n3.部落加入的人次超过30后每日最多可加入5名成员，大酋长和管理请谨慎筛选成员，决定加入和踢出\\n4.大酋长连续7天不上线或退出部落，贡献值最高且7天内有上线的管理会自动成为大酋长，原大酋长降为成员身份，如果部落没有管理，则贡献值最高且7天内有上线的成员自动成为大酋长，当整个部落都没有符合大酋长转移条件的人选时，部落自动解散\\n5.部落中同一怪兽/元核只能上阵一支部队，神灵/战墙则可以作用于多支部队\\n6.部落赛季每月首个周一结算奖励和重置，冒险关卡进度、图腾、遗迹、支配核心、遗迹功勋、繁荣度、部落资源、战令和活跃度会重置，部落币不清零。\\n \\n拍卖所：\\n1.拍卖奖励掉落后开始暗拍，部落中所有成员均可在拍卖所出价，暗拍结束时出价最高的成员邮件中获得拍卖物品，已出价但没有拍得物品的成员获得返还，如没有任何成员出价，拍卖物品流拍\\n \\n图腾：\\n1.图腾提供的增益效果仅在部落冒险，遗迹和图腾玩法中生效\\n2.部落成员每日挑战同一图腾的次数有限制\\n3.图腾每日按照比拼方式进行排名结算，根据排名部落获得该图腾对应百分比的增益效果，第一名为100%\\n \\n遗迹：\\n1.大酋长和管理可以消耗部落资源对遗迹宣战，可宣战时间为15:00至21:00\\n2.遗迹防御值为0时，造成最多防御值扣减的部落占领该遗迹\\n3.遗迹中有敌对的部队时，会优先挑战敌对部队\\n4.遗迹中部队发起挑战的冷却时间与该部队上一场战斗的耗时有关 \\n5.遗迹被占领后，非占领部落的部队会全部自动撤离\\n6.部落占领遗迹一小时后，每个整点部落都会获得繁荣度奖励，部落成员可以手动领取部落币奖励（最多存储5000部落币奖励，到达上限后不会再增加）\\n7.遗迹战斗结束时死亡的怪兽会进入濒死状态，处于濒死状态的怪兽无法出战，一定时间后自动消除濒死状态，也可消耗资源加速消除濒死状态 ，加速消耗每日有上限，每只怪兽独立计算\\n \\n部落战：\\n1.部落战周一00:00至周五24:00为报名期，成员总数达到26人的部落大酋长和管理均可报名参与部落战\\n2.周六00:00至24:00进入备战期，大酋长可进行部落战前配置，开启增益和调整防守成员位置\\n3.周日00:00至24:00进入开战期，周日24:00结算胜负，主塔（主核）中5名防守成员全被击败判负，如果双方主塔（主核）均被击破或均没有被击破，则剩余红心多的部落胜，红心数相同，则平局\\n4.在备战期和开战期，不能解散部落，踢出成员和退出部落\\n5.进入开战期时，双方主将会进行对决，胜利一方将占领主将决斗场，其所属部落的所有成员的怪兽在本次部落战中攻击力和体力提升15%\\n6.主将在部落战中不会获得战鼓，无法挑战敌对部落成员也无法被挑战\\n7.部落成员在每次部落战中会获得3战鼓，挑战敌对部落成员会消耗1战鼓，不能重复挑战同一名敌对部落的成员\\n8.部落成员在每次部落战中会获得3红心，被挑战且战败时红心-1，红心为0时该成员变为被击败状态，同一塔中的所有成员全部被击败，则该塔被击破\\n9.部落战繁荣度奖励根据主塔（主核）击破数，外塔（鬼躯、偶轮、龙牙、兽脊、灵刃）击破数，主将决斗场胜败，部落战胜败和对战双方的当前繁荣度计算得出",
    "98_-200070": "非报名期，无法查看部落战历史记录",
    "97_desc4": "1.基因强化中，近战怪兽选择【体力】，远程怪兽选择【攻击力】，是比较中庸但也比较有效的方案\\n2.怪兽进化至究极阶段时，可以选择不同的进化分支\\n3.怪兽进化会提升属性解锁新技能（全额返还作为进化材料的怪兽的强化孢子，怪兽经验和用于提升技能等级的怪兽碎片）\\n4.怪兽属性面板可查看属性的详细作用\\n5.怪兽解锁形态后，不使用形态也会获得增益\\n6.获得觉醒怪兽后，可挑战对应的领域副本\\n7.获得同名觉醒怪兽时会自动转化为怪兽碎片\\n8.探索者等级30前，远古族怪兽可免费重置为其他远古族怪兽且无冷却时间，探索者等级30后则需要消耗钻石和有6小时冷却时间\\n9.超进化会提升一定百分比的攻击力和体力，并随机激活一个超进化技，可消耗钻石切换超进化技\\n10.元核强化会提升元核属性，元核进阶会提升词条属性和宿命效果\\n11.元核的词条属性和宿命效果基础值越高，强化和进阶时提升的属性越多\\n12.紫色或以上品质的元核可以进行熔炼，熔炼后元核属性与主元核一致，主元核和材料元核的词条属性和宿命效果进行随机组合，作为消耗材料的元核将会消失，并全额返还该元核强化和进阶消耗的金币和粉尘\\n13.熔炼时消耗原石可进行锁定，被锁定的词条属性或宿命效果在熔炼后必定会出现，熔炼时使用元核髓作为消耗材料，元核髓中的词条属性或宿命效果在熔炼后必定会出现，熔炼前可在界面中预览相关信息\\n14.元核熔炼后，可自主选择使用熔炼后的属性或熔炼前的属性\\n15.元核最多可拥有2条相同的词条属性\\n16.元核词条属性列表如下：{1}\\n17.元核宿命效果列表如下：{2}",
    "97_desc5": "1.神灵升阶会增强其被动技能的效果\\n2.神灵升阶会解锁新的神灵技能\\n3.战斗时，神灵在场被动效果才会生效，只在释放队列不生效\\n4.战斗时，神灵重复释放技能会增加能量消耗\\n5.神灵释放队列可自由调配神灵的释放顺序和次数",
    "97_desc3": "1.我的领地只可以有一个，搬迁领地会有冷却时间\\n2.搬迁领地不会对建筑的建造和升级产生影响\\n3.每个领地的斗技场均独立，搬迁领地后斗技场积分会有扣减\\n4.可以传送回自己的领地",
    "messageInitContent_4535": "混沌风城是兄弟城市吗",
    "messageInitContent_4536": "emmmmm",
    "98_-200079": "你已经成功加入部落{1}",
    "messageInitContent_4537": "祖拉才不是动物",
    "98_-200078": "还没加入部落",
    "messageInitContent_4538": "祖拉是饲养员",
    "98_-200077": "加入部落时间在拍卖品掉落之后，无法参与此物品的竞拍",
    "messageInitContent_4539": "谁是仿生动物",
    "98_-200076": "加入部落时间在部落冒险关卡击破之后，无法领取此宝箱奖励",
    "98_-200075": "部落战开战期间，无法进行此操作",
    "98_-200074": "{1}可宣战",
    "messageInitContent_4540": "你是吗",
    "messageInitContent_4541": "仿生人也想养一只",
    "messageInitContent_4542": "来杯杰克·威尔斯",
    "messageInitContent_4543": "来杯大卫·马丁内斯",
    "messageInitContent_4544": "来点爱",
    "messageInitContent_4545": "来杯强尼·银手",
    "98_-200062": "已占领遗迹，无法解散部落",
    "98_-200061": "已宣战遗迹，无法解散部落",
    "98_-200060": "无法宣战放弃占领中的遗迹",
    "messageInitContent_4546": "来点梦想",
    "visionNodeName_10": "共鸣试练二阶",
    "98_-200069": "非备战期，无法为成员添加Buff",
    "messageInitContent_4547": "这家伙是军师吗哪里都看到它",
    "98_-200068": "非备战期，无法变更主将",
    "messageInitContent_4548": "镇剧！",
    "visionNodeName_12": "共鸣试练二阶",
    "98_-200067": "非备战期，无法调整主塔或外塔",
    "messageInitContent_4549": "好多手持大棒的怪兽",
    "visionNodeName_11": "共鸣试练二阶",
    "98_-200066": "大酋长未报名此次部落战",
    "visionNodeName_14": "共鸣试练三阶",
    "visionNodeName_13": "共鸣试练三阶",
    "98_-200064": "当前阶段不可进行此操作",
    "visionNodeName_16": "共鸣试练三阶",
    "98_-200063": "同步部落阵容",
    "visionNodeName_15": "共鸣试练三阶",
    "visionNodeName_18": "共鸣试练三阶",
    "messageInitContent_4550": "我感觉漆黑组件需要一个凳子",
    "visionNodeName_17": "共鸣试练三阶",
    "messageInitContent_4551": "那我就毛遂自荐一下好了",
    "messageInitContent_4552": "小王霸后面有个大王霸",
    "messageInitContent_4553": "？？？？？？？？",
    "messageInitContent_4554": "说啥捏",
    "messageInitContent_4555": "我要后面的马，现在就要",
    "messageInitContent_4556": "怕怕",
    "98_-200051": "主将无法进行挑战",
    "98_-200050": "不在备战期，无法进行此操作",
    "98_-200059": "管理个数已达到上限",
    "messageInitContent_4557": "雷电疗法",
    "98_-200058": "你已退出部落",
    "messageInitContent_4558": "夜之城的雷都是你打的吗",
    "98_-200057": "部落已被解散",
    "messageInitContent_4559": "电闪雷鸣，开着浮空车的我",
    "98_-200056": "你已被踢出部落",
    "98_-200055": "部落成员不存在",
    "98_-200054": "BUFF已开启",
    "98_-200053": "赛季已重置，本场战斗无效",
    "98_-200052": "连接的外塔尚未被击破",
    "messageInitContent_4560": "你也要去搜捕仿生人吗",
    "messageInitContent_4561": "溜了",
    "messageInitContent_4562": "好多花",
    "messageInitContent_4563": "氛围拉满",
    "messageInitContent_4564": "疯狂拟态",
    "messageInitContent_4565": "幻想世界，幻想的世界",
    "messageInitContent_4566": "兔耳最高！",
    "messageInitContent_4567": "做我的猫！！",
    "98_-200040": "此部落成员当前不在部落中",
    "98_-200048": "开战期无法排阵",
    "messageInitContent_4568": "又来了",
    "98_-200047": "部落成员不足，无法报名",
    "messageInitContent_4569": "跟我学喵叫",
    "98_-200046": "部落公告内容长度受限",
    "98_-200045": "遗迹处于被宣战状态，无法放弃占领",
    "98_-200044": "已处理请求",
    "98_-200043": "该部落已拒绝了你的加入申请",
    "98_-200042": "没有其他部落的部队",
    "98_-200041": "部落占领的遗迹已到达上限",
    "messageInitContent_4571": "喵喵喵",
    "messageInitContent_4572": "夜城武士",
    "messageInitContent_4573": "刀叉到底是定制武器还是定制餐具",
    "messageInitContent_4574": "我也要装一个同款舌头",
    "messageInitContent_4575": "我只需要复制一个自己就行",
    "messageInitContent_4576": "不太好吧",
    "messageInitContent_4577": "可是雪啊",
    "98_-200049": "不在开战期，无法进行此操作",
    "messageInitContent_4578": "我好急",
    "messageInitContent_4570": "都给我变！",
    "messageInitContent_4579": "我也好急怎么还不锤下去",
    "messageInitContent_4582": "大家好",
    "messageInitContent_4583": "加速世界在哪里",
    "messageInitContent_4584": "双炮其鸣",
    "messageInitContent_4585": "大炮会梦见烟花吗",
    "messageInitContent_4586": "又饿了",
    "messageInitContent_4587": "我不能没有网络",
    "messageInitContent_4588": "懂了光囚是光纤",
    "messageInitContent_4589": "什么鬼",
    "messageInitContent_4580": "桐仁快跑",
    "messageInitContent_4581": "这里好多吃货",
    "messageInitContent_4593": "给您劈个叉吧",
    "messageInitContent_4594": "此处一位开心的人儿路过",
    "messageInitContent_4595": "我想要的不是雪而是出货的冬天",
    "messageInitContent_4596": "还有这种事",
    "messageInitContent_4597": "赛博朋克",
    "messageInitContent_4598": "怪吼我",
    "messageInitContent_4599": "它那是在唱歌",
    "messageInitContent_4590": "拔电源也是一种方法",
    "messageInitContent_4591": "下一关见",
    "messageInitContent_4592": "哇好厉害",
    "propConfigDes_90106": "收集30块橙色攻击力元核碎片可以合成橙色品质攻击力元核。",
    "propConfigDes_90107": "收集30块红色攻击力元核碎片可以合成红色品质攻击力元核。",
    "propConfigDes_90104": "收集30块蓝色攻击力元核碎片可以合成蓝色品质攻击力元核。",
    "propConfigDes_90105": "收集30块紫色攻击力元核碎片可以合成紫色品质攻击力元核。",
    "propConfigDes_90102": "收集30块白色攻击力元核碎片可以合成白色品质攻击力元核。",
    "propConfigDes_90103": "收集30块绿色攻击力元核碎片可以合成绿色品质攻击力元核。",
    "98_-200084": "部队中有濒死怪兽，不能继续上阵",
    "98_-200083": "本赛季已领取过该宝箱",
    "98_-200082": "该部落准入等级为{1}",
    "98_-200081": "部落申请繁忙,稍后重试",
    "98_-200080": "不能重复挑战同一名敌对部落的成员",
    "98_-200088": "无法前往尚未占领的遗迹进行围观",
    "98_-200087": "部队中存在濒死怪兽，无法派遣",
    "98_-200086": "在其他阶段上阵或者已使用",
    "98_-200085": "该遗迹所属部落已有其他遗迹被宣战，无法宣战该遗迹",
    "5_100": "挑战下位",
    "5_103": "阶段三队伍",
    "5_101": "阶段一队伍",
    "5_102": "阶段二队伍",
    "themeCardPackName_28030": "游戏继续",
    "themeCardPackName_28035": "游戏结束",
    "themeCardPackName_16040": "狂燃",
    "themeCardPackName_28020": "情报共享",
    "themeCardPackName_28025": "游戏开始",
    "messageInitContent_4600": "懵",
    "messageInitContent_4609": "浮生若梦",
    "messageInitContent_4601": "乖巧",
    "messageInitContent_4602": "防弹专家在此",
    "messageInitContent_4603": "来防弹专家",
    "messageInitContent_4604": "来拆弹专家",
    "messageInitContent_4605": "我就是拆蛋专家",
    "messageInitContent_4606": "嘿嘿嘿嘿嘿",
    "messageInitContent_4607": "没有酒但会醉",
    "messageInitContent_4608": "醉生梦死",
    "themeCardPackName_28040": "概念延申",
    "messageInitContent_4610": "若得此夜",
    "messageInitContent_4611": "此生无悔",
    "messageInitContent_4612": "我不准你们说它像露西",
    "messageInitContent_4613": "这个发现",
    "messageInitContent_4614": "大卫你的露西",
    "messageInitContent_4615": "哦不",
    "themeCardPackName_16015": "研火",
    "messageInitContent_4616": "no！",
    "messageInitContent_4617": "火力很猛",
    "messageInitContent_4618": "赛博十八掌！",
    "themeCardPackName_16010": "火种",
    "messageInitContent_4619": "溜溜你好",
    "messageInitContent_4620": "溜溜再见",
    "messageInitContent_4621": "宝贝你好",
    "messageInitContent_4622": "姐！收下留情",
    "messageInitContent_4623": "向大佬问好",
    "themeCardPackName_16005": "燃起",
    "messageInitContent_4624": "我来啦",
    "messageInitContent_4625": "今晚吃什么呢",
    "messageInitContent_4626": "多吃青菜",
    "messageInitContent_4627": "我要植入这个大舌头",
    "messageInitContent_4628": "灯效按第二个来",
    "messageInitContent_4629": "我要让怪兽掉线",
    "messageInitNick_2098": "活在回忆里的",
    "messageInitNick_2099": "都让你懂玩了",
    "messageInitNick_2096": "本人单身",
    "messageInitNick_2097": "残留的轻狂",
    "messageInitContent_4630": "格局打开直接黑过去拿奖励",
    "messageInitContent_4631": "行不行啊",
    "messageInitContent_4632": "有多智能？",
    "messageInitContent_4633": "hi，喇叭",
    "99_9": "下次受到的伤害变为0",
    "themeCardPackName_16030": "入火成魔",
    "99_7": "持续时间内受到的伤害变为0",
    "99_8": "偏移",
    "99_1": "近战",
    "messageInitContent_4634": "有什么能帮你",
    "messageInitNick_2090": "超级无敌卷帝",
    "99_2": "远程",
    "messageInitContent_4635": "放飞一直鸽",
    "messageInitNick_2091": "疯狂宝石",
    "messageInitContent_4636": "我不到啊",
    "messageInitContent_4637": "全息神灵",
    "99_5": "辅助",
    "messageInitContent_4638": "网络有神灵的吗",
    "messageInitNick_2094": "极限拉扯",
    "99_6": "无敌",
    "messageInitContent_4639": "宝贝在干嘛捏",
    "messageInitNick_2095": "奉旨画饼",
    "themeCardPackName_16035": "虚烬",
    "99_3": "肉盾",
    "messageInitNick_2092": "在未来补兵",
    "99_4": "输出",
    "messageInitNick_2093": "奉旨卖萌",
    "messageInitNick_2087": "宁愿二不愿装",
    "messageInitNick_2088": "咸鱼味的猫",
    "messageInitNick_2085": "摆摊买回忆",
    "themeCardPackName_28010": "疾走头目",
    "messageInitContent_4640": "惊了",
    "messageInitNick_2086": "超神战士",
    "messageInitContent_4641": "表白御空",
    "messageInitContent_4642": "点赞功德加一",
    "messageInitContent_4643": "点赞功德加一百",
    "messageInitNick_2089": "美术在线炒螺",
    "messageInitContent_4644": "赛博功德是吧",
    "themeCardPackName_28015": "高效头目",
    "randomEventDialogueGroupConfig_10.6": "-",
    "randomEventDialogueGroupConfig_10.7": "-",
    "themeCardPackName_16020": "逐火",
    "randomEventDialogueGroupConfig_10.8": "-",
    "randomEventDialogueGroupConfig_10.9": "-",
    "randomEventDialogueGroupConfig_10.2": "问它是不是在夸你",
    "randomEventDialogueGroupConfig_10.3": "让它接着夸",
    "randomEventDialogueGroupConfig_10.4": "质疑它",
    "randomEventDialogueGroupConfig_10.5": "-",
    "messageInitContent_4645": "点赞收获赛博赎罪券",
    "messageInitContent_4646": "………………",
    "messageInitNick_2080": "别碰我的回忆",
    "messageInitContent_4647": "防火墙龙！",
    "themeCardPackName_16025": "三角与四面体",
    "messageInitContent_4648": "我宣布你现在就是我的杀毒软件了",
    "messageInitContent_4649": "公司狗在此",
    "messageInitNick_2083": "真相只有一个",
    "messageInitNick_2084": "爱有时差",
    "messageInitNick_2081": "差不多先生",
    "messageInitNick_2082": "冰封狂魔",
    "messageInitNick_2076": "霸气的你",
    "messageInitNick_2077": "记忆转圈圈",
    "messageInitContent_4650": "发出零件的咆哮",
    "messageInitNick_2074": "我牛我再牛",
    "messageInitContent_4651": "痴呆.jpg",
    "messageInitNick_2075": "三点半啦",
    "messageInitContent_4652": "新区域我来啦",
    "messageInitContent_4653": "异形那是哪家医院缝的呀",
    "messageInitContent_4654": "别致",
    "messageInitNick_2078": "爱刺痛温柔",
    "messageInitContent_4655": "变形金刚梵？",
    "messageInitNick_2079": "蛋白质",
    "themeCardPackName_28005": "次元视域",
    "randomEventDialogueGroupConfig_10.1": "你好棒棒哦！",
    "messageInitNick_2072": "把握你的美",
    "messageInitNick_2073": "好孩纸",
    "messageInitNick_2070": "微笑世界请",
    "messageInitNick_2071": "接头大师",
    "messageInitNick_2065": "段位守门员",
    "messageInitNick_2066": "扌握刀剑别",
    "messageInitNick_2063": "红色龙卷风",
    "messageInitNick_2064": "红叶剑客",
    "messageInitNick_2069": "无心之狮",
    "messageInitNick_2067": "重新定义可爱",
    "messageInitNick_2068": "暂停白昼",
    "3_1": "个人信息",
    "3_2": "更换头像",
    "3_3": "更改",
    "3_4": "等级",
    "3_5": "战力",
    "3_6": "探索者账号: {1}",
    "3_7": "区服",
    "3_8": "部落",
    "messageInitNick_2061": "哥遍体鳞伤",
    "3_9": "状态",
    "messageInitNick_2062": "烂好人",
    "messageInitNick_2060": "人到中年",
    "messageInitNick_2054": "戏别太投入",
    "messageInitNick_2055": "脚踩棉花糖",
    "messageInitNick_2052": "必杀技",
    "messageInitNick_2053": "能回滚一下吗",
    "messageInitNick_2058": "花花花小伙",
    "messageInitNick_2059": "吃饭不夹菜",
    "messageInitNick_2056": "好男人的代表",
    "messageInitNick_2057": "赞美收割机",
    "resoundEventConfigName_9020": "20.大军",
    "messageInitNick_2050": "超晨光之柱",
    "messageInitNick_2051": "强壮懂神",
    "messageInitNick_2043": "本无心风月",
    "messageInitNick_2044": "飙车族",
    "messageInitNick_2041": "隔岸观你",
    "messageInitNick_2042": "待我胡须及腰",
    "messageInitNick_2047": "穿越米粉",
    "messageInitNick_2048": "独闯地狱",
    "messageInitNick_2045": "搞事的混子",
    "messageInitNick_2046": "兰陵王中王",
    "messageInitNick_2049": "格式化悲伤",
    "messageInitNick_2040": "愚者",
    "messageInitNick_2032": "蝴蝶雪",
    "messageInitNick_4695": "捂脸小可爱",
    "messageInitNick_2033": "裤衩",
    "messageInitNick_4694": "逆袭这件事",
    "messageInitNick_2030": "一巴掌呼你",
    "messageInitNick_4693": "宫保鸡丁",
    "messageInitNick_2031": "超大份可乐",
    "messageInitNick_4692": "泪眼看世界",
    "messageInitNick_2036": "共饮孟婆汤",
    "messageInitNick_4699": "满分喜欢",
    "messageInitNick_2037": "寄居房客",
    "messageInitNick_4698": "带火龙果探险",
    "messageInitNick_2034": "何方怪物",
    "messageInitNick_4697": "别过来啊啊",
    "messageInitNick_2035": "龙舌兰菇凉",
    "messageInitNick_4696": "逮虾户",
    "messageInitNick_2038": "爱哭鬼丫头",
    "messageInitNick_2039": "假正经先生",
    "resoundEventConfigName_9004": "4.谜团",
    "resoundEventConfigName_9003": "3.情报交流",
    "resoundEventConfigName_9002": "2.汇合",
    "resoundEventConfigName_9001": "1.世界树",
    "messageInitNick_4691": "黑白年代",
    "messageInitNick_4690": "无线连接者",
    "messageInitNick_2021": "阿伟说了",
    "messageInitNick_4684": "世俗的欲望",
    "messageInitNick_2022": "无敌打脸王",
    "messageInitNick_4683": "香蕉去哪了",
    "messageInitNick_4682": "八月的奇迹",
    "messageInitNick_2020": "五彩斑斓的黑",
    "messageInitNick_4681": "镜子剑客",
    "messageInitNick_2025": "潮爷",
    "messageInitNick_4688": "角色不是声优",
    "messageInitNick_2026": "把难过说给风",
    "messageInitNick_4687": "有脑魔女",
    "messageInitNick_2023": "奔二青年",
    "messageInitNick_4686": "气氛组先驱",
    "messageInitNick_2024": "兜兜的糖",
    "messageInitNick_4685": "无语草莓",
    "messageInitNick_2029": "还在卖萌",
    "resoundEventConfigName_9008": "8.奇异的进化",
    "resoundEventConfigName_9007": "7.准备",
    "messageInitNick_2027": "百合大队长",
    "resoundEventConfigName_9006": "6.营救计划",
    "messageInitNick_2028": "风在喃我在听",
    "messageInitNick_4689": "我推的池子",
    "resoundEventConfigName_9005": "5.考验",
    "resoundEventConfigName_9009": "9.疲惫",
    "resoundEventConfigName_9011": "11.古拉姆的特训",
    "resoundEventConfigName_9010": "10.埃癸斯的特训",
    "resoundEventConfigName_9015": "15.合作",
    "resoundEventConfigName_9014": "14.诡异的形态",
    "resoundEventConfigName_9013": "13.敌袭",
    "resoundEventConfigName_9012": "12.美梦",
    "messageInitNick_4680": "咕咕门传人",
    "messageInitNick_2010": "该如何忘记",
    "messageInitNick_4673": "熟悉的天花板",
    "messageInitNick_2011": "宁静的宇宙",
    "messageInitNick_4672": "那边怎么说",
    "messageInitNick_4671": "黑白的色调",
    "messageInitNick_4670": "专治各种不服",
    "messageInitNick_2014": "壁橱蘑菇",
    "messageInitNick_4677": "卖茶叶蛋的",
    "messageInitNick_2015": "爱上了他",
    "messageInitNick_4676": "咸甜花生酱",
    "messageInitNick_2012": "藏不住喜欢",
    "messageInitNick_4675": "卷王",
    "messageInitNick_2013": "作业做完了吗",
    "messageInitNick_4674": "浮生物语",
    "messageInitNick_2018": "记忆是一只鱼",
    "resoundEventConfigName_9019": "19.完全体",
    "messageInitNick_2019": "好汉饶我狗命",
    "resoundEventConfigName_9018": "18.电光紫鸭",
    "messageInitNick_2016": "你不懂女人心",
    "messageInitNick_4679": "茄子兽",
    "resoundEventConfigName_9017": "17.日夕的目标",
    "messageInitNick_2017": "巫毒之云",
    "messageInitNick_4678": "炒面射手",
    "resoundEventConfigName_9016": "16.邪王的礼物",
    "limiterConfigDesc_2": "己方队伍只可上阵尸鬼族怪兽（双种族只需其中一族符合）",
    "limiterConfigDesc_3": "己方队伍只可上阵星灵族怪兽（双种族只需其中一族符合）",
    "limiterConfigDesc_1": "己方队伍只可上阵祖龙族怪兽（双种族只需其中一族符合）",
    "messageInitNick_4662": "降压玩具",
    "messageInitNick_2000": "残缺的世界",
    "messageInitNick_4661": "坚持下去",
    "messageInitNick_4660": "蓝翔老司机",
    "messageInitNick_2003": "诺贝尔钓鱼奖",
    "messageInitNick_4666": "插线板剑客",
    "messageInitNick_2004": "稻草人吹着风",
    "messageInitNick_4665": "一定要坚强啊",
    "messageInitNick_2001": "老夫不是魔鬼",
    "messageInitNick_4664": "无所谓了",
    "messageInitNick_2002": "吉祥物",
    "messageInitNick_4663": "路痴",
    "messageInitNick_2007": "喂过",
    "messageInitNick_2008": "佛说你很酷",
    "messageInitNick_4669": "别动我的心",
    "limiterConfigDesc_4": "己方队伍只可上阵木偶族怪兽（双种族只需其中一族符合）",
    "messageInitNick_2005": "此刻尽享丝滑",
    "messageInitNick_4668": "不敢求婚",
    "limiterConfigDesc_5": "己方队伍只可上阵原生族怪兽",
    "messageInitNick_2006": "创可贴",
    "messageInitNick_4667": "酱香饼大师",
    "messageInitNick_2009": "梨涡浅浅笑",
    "messageInitNick_4651": "蘑菇兽",
    "messageInitNick_4650": "最爱茄子",
    "messageInitNick_4655": "还没醒",
    "messageInitNick_4654": "无修容大师",
    "messageInitNick_4653": "到底要选哪个",
    "messageInitNick_4652": "助眠读物",
    "messageInitNick_4659": "胡萝卜魔法师",
    "messageInitNick_4658": "白玉天女",
    "messageInitNick_4657": "太阳能剃须刀",
    "messageInitNick_4656": "桔梗的泪",
    "randomEventDialogueGroupConfig_1.138": "我问你话呢，问你话呢！",
    "randomEventDialogueGroupConfig_1.139": "继续走",
    "randomEventDialogueGroupConfig_1.134": "它溜了。",
    "randomEventDialogueGroupConfig_1.135": "离开",
    "randomEventDialogueGroupConfig_1.136": "它高喊着，跑远了。",
    "randomEventDialogueGroupConfig_1.137": "离开",
    "randomEventDialogueGroupConfig_1.130": "告别离开",
    "randomEventDialogueGroupConfig_1.131": "它下意识地一手挡胸，一手挡胯，然后保持着那个姿势跑远了。",
    "randomEventDialogueGroupConfig_1.132": "离开",
    "randomEventDialogueGroupConfig_1.133": "它幽怨地盯着你。",
    "messageInitContent_2084": "好想学会飞翔！",
    "messageInitNick_4640": "花环尾戒",
    "randomEventDialogueGroupConfig_1.71": "先行告辞",
    "messageInitContent_2083": "直立不是问题，飞翔才是。",
    "randomEventDialogueGroupConfig_1.72": "答应切磋",
    "messageInitContent_2082": "钢龙好像也是直立飞翔的呢",
    "randomEventDialogueGroupConfig_1.73": "唉，这都能怪我吗？哈？#我向来谨慎，从来都是打探好消息才去的！#受伤的明明是我，你居然还怪我？还怪我！",
    "messageInitContent_2081": "直立飞翔！",
    "randomEventDialogueGroupConfig_1.74": "也不能怪它们，它们大概率比我还菜，比我还菜！",
    "messageInitContent_2080": "这关的可能是小龙猫",
    "messageInitNick_4644": "爱因斯不舒坦",
    "messageInitNick_4643": "随行保温",
    "messageInitNick_4642": "行为艺术家",
    "messageInitNick_4641": "可降解拖鞋",
    "randomEventDialogueGroupConfig_1.70": "谢谢你朋友，我想……你可能高估我了。#要切磋一下试试吗？试试吗？",
    "messageInitNick_4648": "海猫鸣泣之时",
    "randomEventDialogueGroupConfig_1.79": "上前找它交易",
    "messageInitNick_4647": "悲有寂寞有染",
    "messageInitNick_4646": "新型榨菜",
    "messageInitContent_2089": "所以g-n的花是长出来的还是放上去的呢",
    "messageInitNick_4645": "东方战神",
    "messageInitContent_2088": "也可能是送给其他怪兽了",
    "randomEventDialogueGroupConfig_1.75": "谴责神秘商人",
    "messageInitContent_2087": "这就是成长的代价",
    "randomEventDialogueGroupConfig_1.76": "谴责抢东西的",
    "messageInitContent_2086": "撼地兽进化之后小花花也不见了！",
    "randomEventDialogueGroupConfig_1.77": "气死我啦气死我啦，气死我啦——",
    "messageInitContent_2085": "坐飞机吧就好。",
    "messageInitNick_4649": "等你地久",
    "randomEventDialogueGroupConfig_1.78": "上前了解情况",
    "randomEventDialogueGroupConfig_1.127": "哦，你是说吃点东西能让理智上线对吧对吧？",
    "randomEventDialogueGroupConfig_1.128": "肯定",
    "randomEventDialogueGroupConfig_1.129": "好吧，我正好有点饿了。谢谢你再见再见。",
    "randomEventDialogueGroupConfig_1.123": "……",
    "randomEventDialogueGroupConfig_1.124": "……",
    "randomEventDialogueGroupConfig_1.125": "懂了。",
    "randomEventDialogueGroupConfig_1.126": "说懂了",
    "randomEventDialogueGroupConfig_1.120": "它并没有理你，跑远了。",
    "randomEventDialogueGroupConfig_1.121": "离开",
    "randomEventDialogueGroupConfig_1.122": "把东西捡起",
    "messageInitContent_2095": "这是哪个app的骑手呢？",
    "randomEventDialogueGroupConfig_1.82": "它似乎察觉到了你的动静，迅速往路旁一缩。",
    "messageInitContent_2094": "龙骑兵冲锋！",
    "randomEventDialogueGroupConfig_1.83": "它反手抓住你，就是一个过肩摔。",
    "messageInitContent_2093": "马上就让小骑兵知道冲太前的后果。",
    "randomEventDialogueGroupConfig_1.84": "它狠狠地瞪了你一眼。",
    "messageInitContent_2092": "好啦好啦够种领便当啦！",
    "randomEventDialogueGroupConfig_1.85": "你帮我吗？哈？哈？",
    "messageInitContent_2091": "貌美如花是月夕吧！",
    "messageInitNick_4633": "红坑女王",
    "messageInitContent_2090": "别问问就是貌美如花",
    "messageInitNick_4632": "你是故意的吧",
    "messageInitNick_4631": "霸气小女子",
    "randomEventDialogueGroupConfig_1.80": "上前拍拍它的肩",
    "messageInitNick_4630": "怀中抱软猫",
    "randomEventDialogueGroupConfig_1.81": "快步走过",
    "messageInitNick_4637": "繁华独角戏",
    "messageInitNick_4636": "引战大师",
    "messageInitNick_4635": "衣架破坏者",
    "messageInitNick_4634": "披着虎皮的猫",
    "messageInitContent_2099": "生物多样性知道吗",
    "randomEventDialogueGroupConfig_1.86": "说当然",
    "messageInitContent_2098": "同时是龙，为什么大家的身材就差这么远",
    "randomEventDialogueGroupConfig_1.87": "建议它找其他商人",
    "messageInitContent_2097": "马上就来！",
    "messageInitNick_4639": "清香的蟠桃",
    "randomEventDialogueGroupConfig_1.88": "对于我们而言，合作是可遇不可求的，可遇不可求啊。",
    "messageInitContent_2096": "哪个app的骑手都不会骑马的吧",
    "messageInitNick_4638": "不需要眼泪",
    "randomEventDialogueGroupConfig_1.89": "无奈告别",
    "randomEventDialogueGroupConfig_1.156": "说只是开玩笑",
    "randomEventDialogueGroupConfig_1.157": "真抢",
    "randomEventDialogueGroupConfig_1.158": "你别吓我啊，我可是刚才被抢完。",
    "randomEventDialogueGroupConfig_1.159": "道歉并离开",
    "randomEventDialogueGroupConfig_1.152": "道别",
    "randomEventDialogueGroupConfig_1.153": "不用不用送你了。",
    "randomEventDialogueGroupConfig_1.154": "收下",
    "randomEventDialogueGroupConfig_1.155": "它大惊失色，吓得坐到了地上。",
    "randomEventDialogueGroupConfig_1.150": "你隐约听到它大喊。",
    "randomEventDialogueGroupConfig_1.151": "它对你苦笑了一下，随后挥手离去。",
    "randomEventDialogueGroupConfig_1.50": "你是想说……理智药……草煮鸡腿吗？#这不是隔壁……隔壁的？",
    "randomEventDialogueGroupConfig_1.51": "否认",
    "randomEventDialogueGroupConfig_1.52": "……",
    "messageInitNick_4622": "五种辣",
    "messageInitNick_4621": "成熟只是瞬间",
    "messageInitNick_4620": "风扇晕了",
    "messageInitNick_4626": "高傲囡人",
    "randomEventDialogueGroupConfig_1.57": "哦？那我倒是要看看你有多强。#100斤进化孢子加30斤强化孢子加70斤元核等于？",
    "messageInitNick_4625": "开门你的快递",
    "randomEventDialogueGroupConfig_1.58": "十分强大",
    "messageInitNick_4624": "贝多芬的寂寞",
    "randomEventDialogueGroupConfig_1.59": "200斤",
    "messageInitNick_4623": "蒜蓉通菜",
    "randomEventDialogueGroupConfig_1.53": "“谢谢你，再见。”",
    "messageInitNick_4629": "吃够了苦",
    "randomEventDialogueGroupConfig_1.54": "离开。",
    "messageInitNick_4628": "烤焦的烧饼",
    "randomEventDialogueGroupConfig_1.55": "……",
    "messageInitNick_4627": "比油田油",
    "randomEventDialogueGroupConfig_1.56": "……",
    "randomEventDialogueGroupConfig_1.149": "大声说它东西掉了",
    "randomEventDialogueGroupConfig_1.145": "它看你没有理它，这才停住脚步，继续捶胸顿足。",
    "randomEventDialogueGroupConfig_1.146": "离开",
    "randomEventDialogueGroupConfig_1.147": "它没有理你，跑得更远了。",
    "randomEventDialogueGroupConfig_1.148": "离开",
    "randomEventDialogueGroupConfig_1.141": "看看",
    "randomEventDialogueGroupConfig_1.142": "啊，等等，好像有逃过一劫的东西！",
    "randomEventDialogueGroupConfig_1.143": "抢了",
    "randomEventDialogueGroupConfig_1.144": "说可以帮衬一下",
    "randomEventDialogueGroupConfig_1.140": "你看。",
    "randomEventDialogueGroupConfig_1.60": "它的损失",
    "randomEventDialogueGroupConfig_1.61": "有趣有趣，你似乎有成为神秘商人的潜质，不过这行可是很复杂滴。#谢谢你听我发牢骚，这会我心情好多了，有缘再会，有缘再会。",
    "randomEventDialogueGroupConfig_1.62": "让它记得带上新货",
    "randomEventDialogueGroupConfig_1.63": "是吧，你也是这么认为，那你应该也懂了，再见了，再见了。",
    "messageInitNick_4611": "没干嘛",
    "messageInitNick_4610": "古怪大叔",
    "messageInitNick_4615": "在世魅魔",
    "randomEventDialogueGroupConfig_1.68": "你发现那是它眼里含着的泪滴，很快就被风追走了。",
    "messageInitNick_4614": "脆爽的榴莲",
    "randomEventDialogueGroupConfig_1.69": "离开",
    "messageInitNick_4613": "不哄我了吗",
    "messageInitNick_4612": "无敌的核膜",
    "messageInitNick_4619": "金字塔等你",
    "randomEventDialogueGroupConfig_1.64": "向它告别",
    "messageInitNick_4618": "队友我先撤",
    "randomEventDialogueGroupConfig_1.65": "哈哈哈诚实在我们这一行可不多见，也是另一种意义上的强呢。#但你的好意我就先心领了，回见回见。",
    "messageInitNick_4617": "断片先生",
    "randomEventDialogueGroupConfig_1.66": "告别",
    "messageInitNick_4616": "认证复读专家",
    "randomEventDialogueGroupConfig_1.67": "没关系有心了。可惜我身上的东西都被抢光，不然就给你送点什么了。#只能说谢谢谢谢你了。",
    "messageInitNick_4609": "闪电快递",
    "randomEventDialogueGroupConfig_1.170": "捡起离开",
    "messageInitNick_4600": "霸天书生",
    "messageInitNick_4604": "豆角先锋",
    "messageInitNick_4603": "夜闯废校",
    "messageInitNick_4602": "蓬松的头发",
    "messageInitNick_4601": "暗恋不如不恋",
    "messageInitNick_4608": "职业自由人",
    "messageInitNick_4607": "我后悔下凡了",
    "messageInitNick_4606": "懒得取名字",
    "messageInitNick_4605": "七点的饺子",
    "randomEventDialogueGroupConfig_1.167": "同意",
    "randomEventDialogueGroupConfig_1.168": "硬上",
    "randomEventDialogueGroupConfig_1.169": "我的东西都被抢了，哪来的东西丢。",
    "randomEventDialogueGroupConfig_1.163": "我我……我开玩笑的，谁要跟你打。我有……有事，先先……跑了。",
    "randomEventDialogueGroupConfig_1.164": "离开",
    "randomEventDialogueGroupConfig_1.165": "说你是真想打",
    "randomEventDialogueGroupConfig_1.166": "要不……要不下次，下次？",
    "randomEventDialogueGroupConfig_1.160": "转身离开",
    "randomEventDialogueGroupConfig_1.161": "没事没事，不送了。",
    "randomEventDialogueGroupConfig_1.162": "离开",
    "randomEventDialogueGroupConfig_1.93": "它虽然很生气，但也没有追过来。",
    "randomEventDialogueGroupConfig_1.94": "离开",
    "randomEventDialogueGroupConfig_1.95": "它气得七窍生烟，一溜烟地跑了。",
    "randomEventDialogueGroupConfig_1.96": "离开",
    "randomEventDialogueGroupConfig_1.90": "它说完便垂头丧气地离开了。",
    "randomEventDialogueGroupConfig_1.91": "离开",
    "randomEventDialogueGroupConfig_1.92": "它的脸上突然露出了几分喜色。",
    "randomEventDialogueGroupConfig_1.97": "就是就是，最坏就是它们，最坏了！",
    "randomEventDialogueGroupConfig_1.98": "狠狠地骂",
    "randomEventDialogueGroupConfig_1.99": "说它们也许有苦衷",
    "messageInitContent_4656": "能变车子是吧",
    "messageInitContent_4657": "前方古纪",
    "messageInitContent_4658": "双层迷惑谁顶得住",
    "messageInitContent_4659": "电子防壁展开",
    "messageInitContent_4660": "神灵出来了",
    "messageInitContent_4661": "走你",
    "messageInitContent_4662": "潜入成功",
    "messageInitContent_4663": "潜入成功",
    "messageInitContent_4664": "冷",
    "messageInitContent_4665": "祝大家龙马精神",
    "messageInitContent_4666": "潜入失败，请求支援",
    "messageInitContent_2004": "气奥yyds！",
    "messageInitContent_2003": "最可怕的领域来了！",
    "messageInitContent_2002": "草爹为什么不在！",
    "messageInitContent_2001": "好气嗷",
    "messageInitContent_2000": "你们！！！！",
    "98_-90006": "数量过多",
    "98_-90004": "背包已满，快去整理一下喽",
    "98_-90005": "数量过少",
    "messageInitContent_2009": "前面就是世界名画了！",
    "messageInitContent_2008": "欢迎光临，这里是腰疼博物馆！",
    "messageInitContent_2007": "有一点事",
    "messageInitContent_2006": "永远都是！",
    "messageInitContent_2005": "什么yyds？",
    "messageInitContent_4667": "前方大叉叉全息投影",
    "messageInitContent_4668": "笑容逐渐灿烂",
    "messageInitContent_4669": "我需要换个电子脑",
    "messageInitContent_4670": "附议",
    "messageInitContent_4671": "附议",
    "messageInitContent_4672": "大叉叉~！",
    "messageInitContent_4673": "打着打着就进化了",
    "messageInitContent_4674": "66666啊",
    "messageInitContent_4675": "这个阵容有点眼熟",
    "messageInitContent_4676": "这不是",
    "messageInitContent_4677": "什么东西",
    "messageInitContent_2015": "怪兽只剩下黑白！",
    "messageInitContent_2014": "锤爹今天几个锤呢？",
    "messageInitContent_2013": "只要炸远点，我们就是好朋友！",
    "messageInitContent_2012": "妖火已经是大家的好朋友了好吗",
    "98_-90002": "召唤翻船，请稍后再试",
    "messageInitContent_2011": "根本没区别好吗",
    "98_-90003": "合成翻船，请稍后再试",
    "messageInitContent_2010": "什么腰疼博物馆！人家是妖藤",
    "98_-90001": "背包空间已达到上限",
    "messageInitContent_2019": "大家看帽子，黑子的帽子是黑色的！",
    "messageInitContent_2018": "是啊，都是黑白的！",
    "messageInitContent_2017": "我发现我总是分不清小黑和小白",
    "messageInitContent_2016": "快进到黑白小电视",
    "messageInitContent_4678": "这些敌人都是全息投影，按一下就可以通关",
    "messageInitContent_4679": "信你个鬼",
    "messageInitContent_4681": "下一位",
    "messageInitContent_4682": "在超进化做梦吗",
    "messageInitContent_4683": "幻加蜃楼",
    "messageInitContent_4684": "今天几号来着",
    "messageInitContent_4685": "我要和蜃贴贴",
    "messageInitContent_4686": "有只光龙没有泡泡我不说是谁",
    "messageInitContent_4687": "肉肉我来了",
    "messageInitContent_4688": "你是说哪里的肉肉",
    "messageInitContent_2026": "应该是风吹草动",
    "messageInitContent_2025": "为什么不是草原上升起的太阳",
    "messageInitContent_2024": "又可以唱一首凉凉先给我的后排们",
    "messageInitContent_2023": "这才是真正的夕阳无限好嘛",
    "messageInitContent_2022": "这里好晒啊。",
    "messageInitContent_2021": "小白是单马尾的哦！",
    "messageInitContent_2020": "而且你们看黑子的舌头，这就是当太多黑子的下场",
    "messageInitContent_4680": "名字很厉害但实际很菜系列",
    "messageInitContent_2029": "这边是地龙的地盘吗？",
    "messageInitContent_2028": "你们在说什么胡话呢？",
    "messageInitContent_2027": "黄色的灵魂不惧烈日！",
    "messageInitContent_4689": "当然是",
    "messageInitContent_4692": "棒棒糖*2",
    "messageInitContent_4693": "加强型波板糖",
    "messageInitContent_4694": "钢铁波板糖",
    "messageInitContent_4695": "会不会不是那个",
    "messageInitContent_4696": "是哪个？",
    "messageInitContent_4697": "这个区域好绿。。",
    "messageInitContent_4698": "处处都是绿光",
    "messageInitContent_4699": "爱护花草人人有责",
    "messageInitContent_2037": "你们有没有发现地龙和影曜好像长得差不多？",
    "messageInitContent_2036": "谁说地龙丑的，给我出来！",
    "messageInitContent_2035": "我是比蒙我现在跑还来的急吗",
    "messageInitContent_2034": "都叫你存钱的啦",
    "messageInitContent_2033": "我也要靠吃土为生了呜呜",
    "messageInitContent_2032": "他们可能已经达成了友好协议",
    "messageInitContent_2031": "快，给我们表演一下毫不费力钳住",
    "messageInitContent_4690": "今晚会梦见漆黑组件吗",
    "messageInitContent_2030": "比蒙巨兽危，地龙来了！",
    "messageInitContent_4691": "是白色的漆黑组件",
    "randomEventDialogueGroupConfig_1.39": "谴责旁观的怪兽",
    "messageInitContent_2039": "有没有可能想法，影曜是地龙变的",
    "messageInitContent_2038": "什么你想说地龙是影曜变得吗？",
    "propConfigDes_90007": "收集30块红色元核碎片可以合成红色品质的随机元核。",
    "propConfigDes_90005": "收集30块紫色元核碎片可以合成紫色品质的随机元核。",
    "propConfigDes_90006": "收集30块橙色元核碎片可以合成橙色品质的随机元核。",
    "propConfigDes_90003": "收集30块绿色元核碎片可以合成绿色品质的随机元核。",
    "propConfigDes_90004": "收集30块蓝色元核碎片可以合成蓝色品质的随机元核。",
    "propConfigDes_90002": "收集30块白色元核碎片可以合成白色品质的随机元核。",
    "messageInitContent_2040": "假面怪兽吗？",
    "realmConfigDes_223": "影曜3",
    "realmConfigDes_222": "影曜2",
    "realmConfigDes_225": "影曜5",
    "randomEventDialogueGroupConfig_1.30": "它在空中露出了难以置信的表情，翻腾两周半后落地，然后飞速逃离了。",
    "realmConfigDes_224": "影曜4",
    "realmConfigDes_221": "影曜1",
    "realmConfigDes_220": "重装5",
    "messageInitContent_2048": "这也是生活情趣啊",
    "randomEventDialogueGroupConfig_1.35": "里面乱糟糟，是被洗劫一空的样子。#“啊哈，原来还有逃过一劫的幸运货物，送你好了。”",
    "messageInitContent_2047": "外放就好了还是音响外放",
    "randomEventDialogueGroupConfig_1.36": "道谢并接过。",
    "messageInitContent_2046": "镇魂好像那些老大爷，出门带个音响",
    "randomEventDialogueGroupConfig_1.37": "我的东西都被抢走了，被抢走了！#被抢的时候，周围的怪兽还眼睁睁看着，眼睁睁看着！",
    "messageInitContent_2045": "kb侠这键盘看起来可以控制巨炮的调度",
    "randomEventDialogueGroupConfig_1.38": "让它把货抢回来",
    "messageInitContent_2044": "哪里都逃不过孤勇者吗",
    "randomEventDialogueGroupConfig_1.31": "离开",
    "messageInitContent_2043": "谐音梗扣分！！",
    "randomEventDialogueGroupConfig_1.32": "别吓人啊，你想干嘛？想干嘛！",
    "messageInitContent_2042": "它们好苟住怎么办",
    "randomEventDialogueGroupConfig_1.33": "不管它离开",
    "messageInitContent_2041": "真是笑死炎之高兴了要",
    "randomEventDialogueGroupConfig_1.34": "请它吃东西",
    "messageInitContent_2049": "音响大爷pk广场舞大妈是吧",
    "messageInitContent_2051": "祖拉yyds",
    "messageInitContent_2050": "呜呜祖拉永不言弃！",
    "randomEventDialogueGroupConfig_1.40": "你真好，真好！但我怕你……怕你打不过它们，打不过它们。",
    "randomEventDialogueGroupConfig_1.41": "表示自己很强",
    "messageInitContent_2059": "还有各种很奇怪的统计",
    "randomEventDialogueGroupConfig_1.46": "接受送上门的挑战",
    "messageInitContent_2058": "如果那个节目来，会不会问怪兽一些奇怪问题。",
    "randomEventDialogueGroupConfig_1.47": "抱歉，是我冲动了，是我冲动了。#可能理智也被抢了吧，啊我的理智我的理智啊。",
    "messageInitContent_2057": "日曜。夜未央？！！！",
    "randomEventDialogueGroupConfig_1.48": "给它推荐理智鸡腿",
    "messageInitContent_2056": "羡慕草丛 ！",
    "randomEventDialogueGroupConfig_1.49": "离开让它自己冷静冷静",
    "messageInitContent_2055": "来人把前面拖出去！",
    "randomEventDialogueGroupConfig_1.42": "不置可否",
    "messageInitContent_2054": "想rua狐狸尾巴！！！！！",
    "randomEventDialogueGroupConfig_1.43": "说一起上就可以了",
    "messageInitContent_2053": "她站在女神中间也丝毫不逊色！",
    "randomEventDialogueGroupConfig_1.44": "哈？开什么玩笑，你找那帮打劫的交易去！#我现在就只剩下一肚子火，一肚子火啊！#等等，你是故意来找茬的是吧？那来啊！来啊！",
    "messageInitContent_2052": "她已经成长为真正的女神了！",
    "randomEventDialogueGroupConfig_1.45": "否认三连",
    "randomEventDialogueGroupConfig_1.116": "离开",
    "randomEventDialogueGroupConfig_1.117": "它冲的太急，一下撞到了你的怀里。#随后它愣了一下，脸一红，捂着脸跑开了，你发现有什么东西从它的身上掉了出来。",
    "randomEventDialogueGroupConfig_1.118": "捡起",
    "randomEventDialogueGroupConfig_1.119": "叫住它",
    "randomEventDialogueGroupConfig_1.112": "赶紧跑",
    "randomEventDialogueGroupConfig_1.17": "顺着力道将它甩回去",
    "randomEventDialogueGroupConfig_1.113": "给它个拥抱",
    "randomEventDialogueGroupConfig_1.18": "啊？那你那你要抢什么抢什么（破音）——！？",
    "randomEventDialogueGroupConfig_1.114": "摆好架势迎战",
    "randomEventDialogueGroupConfig_1.19": "那你？那你是来安慰我的？",
    "randomEventDialogueGroupConfig_1.115": "它显然追不上你。",
    "randomEventDialogueGroupConfig_1.110": "等等你别走，我好气，好气呀！",
    "randomEventDialogueGroupConfig_1.111": "它气冲冲地向你冲了过来。",
    "messageInitContent_2062": "这就是超进化大陆的特色",
    "realmConfigDes_201": "气奥1",
    "messageInitContent_2061": "你们看日夕和影曜，这风明显不是一个风。",
    "realmConfigDes_200": "螺旋巽5",
    "messageInitContent_2060": "例如，请问这风到底是怎么吹出这个感觉的",
    "realmConfigDes_203": "气奥3",
    "realmConfigDes_202": "气奥2",
    "randomEventDialogueGroupConfig_1.13": "离开。",
    "realmConfigDes_209": "溯仪4",
    "messageInitContent_2069": "想去有红唇的女仆咖啡店",
    "randomEventDialogueGroupConfig_1.14": "哪个混蛋，又想抢我的东西！",
    "realmConfigDes_208": "溯仪3",
    "messageInitContent_2068": "我嘴巴有点幻疼~",
    "randomEventDialogueGroupConfig_1.15": "反问谁要抢它东西",
    "messageInitContent_2067": "脖子有点幻疼~",
    "randomEventDialogueGroupConfig_1.16": "说它误会了",
    "messageInitContent_2066": "污妖王衣品，ohno！",
    "realmConfigDes_205": "气奥5",
    "messageInitContent_2065": "舔到最后收获一头独角兽和2奶爸",
    "randomEventDialogueGroupConfig_1.10": "它原本愤怒的双眼变成委屈，也没有接过你的食物，只是打开了商店的门。",
    "realmConfigDes_204": "气奥4",
    "messageInitContent_2064": "你懂了！",
    "randomEventDialogueGroupConfig_1.11": "只见商店里面乱糟糟，是被洗劫一空的样子。",
    "realmConfigDes_207": "溯仪2",
    "messageInitContent_2063": "解释不了就都是特色是吧。！",
    "randomEventDialogueGroupConfig_1.12": "“抱歉，我冲动了。”#“唉，因为手头上的理智药水也被抢了，理智还没恢复呢。”#它说着便垂头丧气地离开了。",
    "realmConfigDes_206": "溯仪1",
    "randomEventDialogueGroupConfig_1.105": "默默离开",
    "randomEventDialogueGroupConfig_1.106": "你是它们派过来气我的？是不是？是不是？",
    "shopCreationStageNoDes_5": "1.谱光乍放为定向造唤，每次造唤都会获得造唤积分\\n2.可选定特定觉醒怪兽的进化光谱，造唤获得进化光谱时有{1}%概率为选定的进化光谱",
    "randomEventDialogueGroupConfig_1.107": "否认并离开",
    "shopCreationStageNoDes_4": "1.觉醒始动为新手造唤，每次造唤都会获得造唤积分\\n2.连续9次造唤没有获得究极或以上怪兽，则下次造唤必定获得究极或以上怪兽\\n3.连续造唤29次没有获得觉醒怪兽，则下次造唤必定获得觉醒怪兽，觉醒始动中获得的觉醒怪兽必定为双种族觉醒怪兽\\n4.获得觉醒怪兽后觉醒始动将关闭",
    "randomEventDialogueGroupConfig_1.108": "你果真挺懂的，我答应你，答应你！",
    "shopCreationStageNoDes_3": "1.每期一创为限时降临召唤，每次造唤都会获得造唤积分\\n2.连续9次造唤没有获得究极或以上怪兽，则下次造唤必定获得究极或以上怪兽\\n3.连续造唤99次没有获得觉醒怪兽，则下次造唤必定获得觉醒怪兽\\n4.造唤获得觉醒怪兽时有50%概率为限时降临怪兽，若获得的觉醒怪兽非限时降临怪兽，则下次造唤获得觉醒怪兽时必定为限时降临怪兽\\n5.获得觉醒/究极品质的怪兽后，对应的保底累计次数将重置为0，与其他造唤的保底次数互相独立计算，互不影响，同类型造唤的保底次数可累加并继承\\n6.每期一创会不定期更换限时降临怪兽",
    "randomEventDialogueGroupConfig_1.101": "它默念着你骂过的话，骂骂咧咧地走远了。",
    "randomEventDialogueGroupConfig_1.28": "“那果然还是想抢东西吧！让我为民除害！……有贼，来怪，救我！”#它高喊着，跑远了。",
    "shopCreationStageNoDes_2": "1.天选时刻为定向造唤，每次造唤都会获得造唤积分\\n2.连续9次造唤没有获得究极或以上怪兽，则下次造唤必定获得究极或以上怪兽\\n3.连续造唤99次没有获得觉醒怪兽，则下次造唤必定获得觉醒怪兽\\n4.可选定觉醒怪兽，造唤获得觉醒怪兽时有50%概率为选定怪兽，若获得的觉醒怪兽非选定怪兽，则下次造唤获得觉醒怪兽时必定为选定怪兽（若不进行选定，则在可选定怪兽中随机）\\n5.获得觉醒/究极品质的怪兽后，对应的保底累计次数将重置为0，与其他造唤的保底次数互相独立计算，互不影响，同类型造唤的保底次数可累加并继承\\n6.天选时刻会不定期更换可选定的怪兽",
    "randomEventDialogueGroupConfig_1.102": "离开",
    "randomEventDialogueGroupConfig_1.29": "离开。",
    "shopCreationStageNoDes_1": "1.永远哈皮为常驻造唤，每次造唤都会获得造唤积分\\n2.连续9次造唤没有获得究极或以上怪兽，则下次造唤必定获得究极或以上怪兽\\n3.连续造唤99次没有获得觉醒怪兽，则下次造唤必定获得觉醒怪兽\\n4.造唤获得单种族觉醒怪兽，则下次造唤获得觉醒怪兽时必定为双种族觉醒怪兽\\n5.获得觉醒/究极品质的怪兽后，对应的保底累计次数将重置为0，与其他造唤的保底次数互相独立计算，互不影响，同类型造唤的保底次数可累加并继承",
    "randomEventDialogueGroupConfig_1.103": "苦衷？你咋不问问我有没有苦衷？",
    "randomEventDialogueGroupConfig_1.104": "问它有什么苦衷",
    "randomEventDialogueGroupConfig_1.100": "你可真会骂呢，我听完心情好多了。谢谢你朋友，朋友。",
    "messageInitContent_2073": "和我正面刚我是不怕的哈哈",
    "realmConfigDes_212": "梵2",
    "messageInitContent_2072": "我没有受伤，不要袭击我——",
    "realmConfigDes_211": "梵1",
    "messageInitContent_2071": "独角兽真的劳模！",
    "realmConfigDes_214": "梵4",
    "messageInitContent_2070": "人不能，至少不应该",
    "realmConfigDes_213": "梵3",
    "realmConfigDes_210": "溯仪5",
    "randomEventDialogueGroupConfig_1.24": "捡起来",
    "randomEventDialogueGroupConfig_1.25": "管它呢",
    "realmConfigDes_219": "重装4",
    "messageInitContent_2079": "你好，小狸猫",
    "randomEventDialogueGroupConfig_1.26": "“犹豫就会败北！”#它溜了。",
    "messageInitContent_2078": "达摩克里斯之剑法！",
    "randomEventDialogueGroupConfig_1.27": "离开。",
    "messageInitContent_2077": "注意保护隐私！",
    "randomEventDialogueGroupConfig_1.109": "离开",
    "randomEventDialogueGroupConfig_1.20": "点头",
    "realmConfigDes_216": "重装1",
    "messageInitContent_2076": "这不是我的电话号码，不要打给我",
    "randomEventDialogueGroupConfig_1.21": "迟疑片刻",
    "realmConfigDes_215": "梵5",
    "messageInitContent_2075": "明知故问",
    "randomEventDialogueGroupConfig_1.22": "摇头",
    "realmConfigDes_218": "重装3",
    "messageInitContent_2074": "这个数字到底是什么呢？",
    "randomEventDialogueGroupConfig_1.23": "两条碧蓝的水柱从它的眼眶中喷涌，直插地面。#水柱的反作用力将它快速地推离了你。#水柱旁边好像留下了一些什么。",
    "realmConfigDes_217": "重装2",
    "messageInitContent_4708": "乔峰后面那个是二胡吗",
    "messageInitContent_4709": "什么乐队",
    "messageInitContent_4700": "1朵花就够了",
    "messageInitContent_4701": "gogogo",
    "messageInitContent_4702": "电池何在",
    "messageInitContent_4703": "用爱发电",
    "messageInitContent_4704": "小兔子哪里跑",
    "messageInitContent_4705": "建议老树做一下背部拉直处理老树",
    "messageInitContent_4706": "躺一会",
    "messageInitContent_4707": "呼叫控制台呼叫控制台",
    "messageInitContent_4710": "美妆忘带乐器了",
    "messageInitContent_4719": "危险的医生多备点世界总没错",
    "messageInitContent_4711": "（尖叫！",
    "messageInitContent_4712": "是机械的味道",
    "messageInitContent_4713": "是说谎的味道",
    "messageInitContent_4714": "是花儿的味道",
    "messageInitContent_4715": "是矿石的味道",
    "messageInitContent_4716": "是大舌怪的味道",
    "messageInitContent_4717": "危险的世界",
    "messageInitContent_4718": "危险的世界多备点医生总没错",
    "messageInitContent_4720": "我也要魅妆当保镖",
    "messageInitContent_4721": "好耶",
    "messageInitContent_4722": "光学迷彩格挡一次伤害很合理",
    "messageInitContent_4723": "从高楼一跃而下",
    "messageInitContent_4724": "我也想要光学迷彩",
    "messageInitContent_4725": "魅妆到底是啥原理呢",
    "messageInitContent_4726": "潜水不行可以潜沼泽",
    "messageInitContent_4727": "不要向我开炮",
    "messageInitContent_4728": "大炮才是炮灰",
    "messageInitContent_4729": "好气哦",
    "messageInitContent_4730": "怎么还不放学",
    "messageInitContent_4731": "放学别跑",
    "messageInitContent_4732": "一炮一个",
    "messageInitContent_4733": "建议**",
    "messageInitContent_4734": "这也是生活情趣啊",
    "messageInitContent_4735": "睡意消失",
    "messageInitContent_4736": "社恐龙龙",
    "messageInitContent_4737": "仿生龙会潜入地下城吗",
    "messageInitContent_4738": "钢铁龙会拯救世界吗",
    "messageInitContent_4739": "脑洞可以逆转时间吗",
    "messageInitContent_4740": "下关再见",
    "messageInitContent_4741": "那本设计图我要了",
    "messageInitContent_4742": "我要去镜子对面康康",
    "messageInitContent_4743": "圣光~",
    "messageInitContent_4744": "该照上面的小还是下面的大镜子",
    "messageInitContent_4745": "原来上面还有个镜子",
    "messageInitContent_4746": "绒绒~~！",
    "messageInitContent_4747": "全息之树",
    "messageInitContent_4748": "脸上写字",
    "messageInitContent_4749": "所谓的纹身失败",
    "messageInitContent_4750": "原来是纹身！",
    "messageInitContent_4751": "真的假的",
    "messageInitContent_4752": "需要稍您到夜之城吗",
    "messageInitContent_4753": "幻幻！！",
    "messageInitContent_4754": "点赞解除我的emo",
    "messageInitContent_4755": "顶不住了",
    "messageInitContent_4756": "嗯不错",
    "messageInitContent_4757": "玄武出场费低所以次次都喊它吗",
    "messageInitContent_4758": "又是你玄武",
    "messageInitContent_4759": "小小只星落",
    "messageInitContent_4760": "机械星盘拍打着小镰刀",
    "messageInitContent_4761": "奖励我来啦",
    "messageInitContent_4762": "多谢款待",
    "messageInitContent_4763": "想吃薯条了",
    "messageInitContent_4764": "想玩怪兽大乐透",
    "messageInitContent_4765": "夜之城，你车呢",
    "messageInitContent_2103": "笑出鹅叫哈哈哈哈哈",
    "messageInitContent_2102": "别傻只能留一条~",
    "messageInitContent_2101": "我要当留言板龙王！",
    "messageInitContent_2100": "隔壁的紫色结晶是什么！魔法石吗？",
    "messageInitContent_2109": "海格力斯这故事这么像是转生的套路",
    "messageInitContent_2108": "还有大肚子红唇",
    "messageInitContent_2107": "怎么这附近这么多大肚子龙",
    "messageInitContent_2106": "笑容逐渐缺德",
    "4_1": "兑换",
    "messageInitContent_2105": "笑容逐渐呆滞",
    "messageInitContent_2104": "每次被我打败，都这么乐观，值得学习",
    "4_3": "背包位置已到达上限",
    "messageInitContent_4766": "闪光是飞行器！",
    "4_4": "点击闪烁位置完成装嵌",
    "messageInitContent_4767": "不知道还以为是武器店呢",
    "4_5": "斗技场商店",
    "messageInitContent_4768": "有没有可能是宠物店呢",
    "4_6": "起源殿商店",
    "messageInitContent_4769": "那我全要了",
    "4_7": "狩猎商店",
    "4_8": "友好商店",
    "4_9": "部落商店",
    "messageInitContent_4770": "小孩子才做选择",
    "messageInitContent_4771": "店长店长出来！",
    "messageInitContent_4772": "快到我碗里来！！制杖巨人！",
    "messageInitContent_4773": "这光效不多，给我配一个一样的",
    "messageInitContent_4774": "翅膀卖吗",
    "messageInitContent_4775": "比心",
    "messageInitContent_4776": "大家好哇",
    "messageInitContent_2114": "很快你们就会成为我的金库守卫了！",
    "messageInitContent_2113": "好我宣布狸猫在石头剪刀布中荣获第二！",
    "messageInitContent_2112": "我要和狸猫玩石头剪刀布！",
    "messageInitContent_2111": "排面无了",
    "messageInitContent_2110": "穿越到怪兽世界的神只能在小关卡打打杂的故事",
    "messageInitNick_4596": "快去创造奇迹",
    "visionSagesConfigName_8": "游荡智者",
    "messageInitNick_4595": "晚餐吃蛋挞",
    "visionSagesConfigName_7": "游荡智者",
    "messageInitNick_4594": "给杯子道歉",
    "messageInitNick_4593": "柠檬泪",
    "visionSagesConfigName_9": "游荡智者",
    "visionSagesConfigName_4": "游荡智者",
    "messageInitNick_4599": "管我什么",
    "visionSagesConfigName_3": "游荡智者",
    "messageInitNick_4598": "有点缺爱",
    "visionSagesConfigName_6": "游荡智者",
    "messageInitNick_4597": "短肌法师",
    "visionSagesConfigName_5": "游荡智者",
    "visionSagesConfigName_2": "游荡智者",
    "visionSagesConfigName_1": "游荡智者",
    "messageInitNick_4592": "草莓爱好者",
    "messageInitNick_4591": "卖萌之神",
    "23_comment": "开场",
    "messageInitNick_4590": "盒饭之王",
    "messageInitNick_4585": "尖叫番茄",
    "messageInitNick_4584": "凡尔赛龙王",
    "messageInitNick_4583": "二是一种特质",
    "messageInitNick_4582": "有星球快乐吗",
    "messageInitNick_4589": "月亮私藏温柔",
    "messageInitNick_4588": "纸质老虎",
    "messageInitNick_4587": "一介书生",
    "messageInitNick_4586": "不要伤我好吗",
    "messageInitNick_4581": "年年有木鱼",
    "messageInitNick_4580": "僵尸小可爱",
    "messageInitNick_4574": "高冷逗霸",
    "messageInitNick_4573": "为谁上线",
    "messageInitNick_4572": "深海亡魂",
    "messageInitNick_4571": "逆境中的狐狸",
    "messageInitNick_4578": "拉面的灵魂",
    "messageInitNick_4577": "爱满满的鱼",
    "messageInitNick_4576": "痛车大哥",
    "messageInitNick_4575": "飞花临蝶",
    "messageInitNick_4579": "别来我世界",
    "messageInitNick_4570": "北极星在闪烁",
    "messageInitNick_4563": "秘密楼梯",
    "messageInitNick_4562": "摸鱼陪伴",
    "messageInitNick_4561": "末日泡面",
    "messageInitNick_4560": "比珍珠还真",
    "messageInitNick_4567": "大葱之心",
    "messageInitNick_4566": "踟蹰的转椅",
    "messageInitNick_4565": "吾王万岁",
    "messageInitNick_4564": "超时空电磁炉",
    "messageInitNick_4569": "内卷发明者",
    "messageInitNick_4568": "写生少女",
    "messageInitNick_4552": "信号探测者",
    "messageInitNick_4551": "菠萝草莓酱",
    "messageInitNick_4550": "风之主",
    "messageInitNick_4556": "橘子味橡皮",
    "messageInitNick_4555": "一分钟",
    "messageInitNick_4554": "给手机把脉",
    "messageInitNick_4553": "美食狂欢",
    "messageInitNick_4559": "把温柔当爱",
    "messageInitNick_4558": "行走的饼干",
    "messageInitNick_4557": "辣椒射手",
    "messageInitNick_4541": "标题五个字",
    "messageInitNick_4540": "噬菌体跑了",
    "messageInitNick_4545": "沙棘果真好吃",
    "messageInitNick_4544": "少女的脸庞",
    "messageInitNick_4543": "菜配送员到了",
    "messageInitNick_4542": "丨轮回丨",
    "messageInitNick_4549": "提灯映桃花",
    "messageInitNick_4548": "瓷娃娃",
    "messageInitNick_4547": "最爱大葱",
    "messageInitNick_4546": "那个野蛮人",
    "messageInitNick_4530": "梅开二度",
    "messageInitNick_4534": "格式化淡忘",
    "messageInitNick_4533": "一起变胖",
    "messageInitNick_4532": "初夏微暖",
    "messageInitNick_4531": "那我走",
    "messageInitNick_4538": "欢快的猕猴桃",
    "messageInitNick_4537": "鼠标先锋",
    "messageInitNick_4536": "最爱柠檬",
    "messageInitNick_4535": "极窄宽带",
    "messageInitNick_4539": "茄子怪客",
    "resoundEventConfigName_7020": "20.又一计",
    "resoundEventConfigName_7021": "21.告别与重逢",
    "messageInitContent_4384": "九龙城寨！",
    "messageInitContent_4385": "怎么一直在读条",
    "messageInitContent_4386": "一定是一场超梦",
    "messageInitNick_6700": "独守一座空城",
    "messageInitContent_4387": "我要买下这里！",
    "messageInitNick_6701": "按时进化",
    "messageInitContent_4388": "放开御空让我来",
    "randomEventDialogueGroupConfig_12.438": "神秘商人离开了",
    "messageInitContent_4389": "御空！！！！！！",
    "randomEventDialogueGroupConfig_12.437": "无声离开",
    "randomEventDialogueGroupConfig_12.439": "继续滚下去",
    "messageInitNick_6706": "和孤独和好",
    "randomEventDialogueGroupConfig_12.434": "道别",
    "messageInitNick_6707": "胡萝卜撞地球",
    "randomEventDialogueGroupConfig_12.433": "它开始加速滚远。",
    "messageInitNick_6708": "对线爱好者",
    "randomEventDialogueGroupConfig_12.436": "无声跟上",
    "messageInitNick_6709": "垃圾袋先锋",
    "randomEventDialogueGroupConfig_12.435": "它开始默默滚远。",
    "messageInitContent_4380": "瑞贝卡酱你的手怎么！",
    "messageInitNick_6702": "霸主魅影",
    "randomEventDialogueGroupConfig_12.430": "它说完便滚远了",
    "messageInitContent_4381": "是天使",
    "messageInitNick_6703": "按时备份",
    "messageInitContent_4382": "停一下，哪里不对？",
    "messageInitNick_6704": "蹲街数寂寞",
    "randomEventDialogueGroupConfig_12.432": "道别",
    "messageInitContent_4383": "龙与赛博朋克",
    "messageInitNick_6705": "卖萌嘟嘟嘴",
    "randomEventDialogueGroupConfig_12.431": "离开",
    "27_comment": "源初境",
    "messageInitContent_4395": "？？？？？？",
    "messageInitContent_4396": "这里可没有晃板塔",
    "messageInitContent_4397": "冲鸭",
    "messageInitContent_4398": "我猜那不是吉他是武器",
    "messageInitContent_4399": "那你很聪明哦",
    "randomEventDialogueGroupConfig_12.449": "照喊",
    "randomEventDialogueGroupConfig_12.448": "你拍了拍自己的脑袋瓜想起了只要大喊奖来奖励就会到来。",
    "randomEventDialogueGroupConfig_12.445": "呜呜，好的您慢走。",
    "randomEventDialogueGroupConfig_12.444": "拍一拍它然后告别",
    "randomEventDialogueGroupConfig_12.447": "反问是不是真的没有谢礼",
    "messageInitContent_4390": "脑袋打恐的脑机接口？",
    "randomEventDialogueGroupConfig_12.446": "离开",
    "messageInitContent_4391": "不会刺歪吧",
    "randomEventDialogueGroupConfig_12.441": "抱歉，我语气重了点。#我很好，只是想躺着，谢谢你的关心。#被这么关心，我感觉到好温暖。但我什么都没有，我不知道要怎么报答你。",
    "messageInitContent_4392": "多打点麻醉就不疼了",
    "randomEventDialogueGroupConfig_12.440": "起身离开",
    "messageInitContent_4393": "无证经营",
    "randomEventDialogueGroupConfig_12.443": "表示不需要感谢",
    "messageInitContent_4394": "你看它笑得多开心",
    "randomEventDialogueGroupConfig_12.442": "说着两行泪水从它的双颊划过，它哭了。",
    "randomEventDialogueGroupConfig_12.450": "不喊",
    "resoundEventConfigName_7001": "1.美即正义",
    "resoundEventConfigName_7002": "2.拦路斧",
    "randomEventDialogueGroupConfig_12.459": "神秘商人以一个兔形闪击身法再次超前。",
    "randomEventDialogueGroupConfig_12.456": "神秘商人看你没有回应，以一个蛇形狂滚身法甩开了你。",
    "resoundEventConfigName_7005": "5.休战",
    "randomEventDialogueGroupConfig_12.455": "沉默离开",
    "resoundEventConfigName_7006": "6.再遇",
    "randomEventDialogueGroupConfig_12.458": "离开",
    "resoundEventConfigName_7003": "3.冒险家",
    "randomEventDialogueGroupConfig_12.457": "以龙形云卷滚身法跟上",
    "resoundEventConfigName_7004": "4.换一条道",
    "randomEventDialogueGroupConfig_12.452": "离开",
    "resoundEventConfigName_7009": "9.温泉",
    "randomEventDialogueGroupConfig_12.451": "它似乎感动得晕了过去，所以听不到你的话了。",
    "randomEventDialogueGroupConfig_12.454": "离开",
    "resoundEventConfigName_7007": "7.小小心思",
    "randomEventDialogueGroupConfig_12.453": "虽然神秘商人一直在叫唤，但身体并没有挪动半分。",
    "resoundEventConfigName_7008": "8.汇合",
    "randomEventDialogueGroupConfig_12.461": "使出虎躯一震滚法跟上",
    "randomEventDialogueGroupConfig_12.460": "离开",
    "resoundEventConfigName_7012": "12.搭档",
    "resoundEventConfigName_7013": "13.新的石塔",
    "resoundEventConfigName_7010": "10.温泉老板",
    "resoundEventConfigName_7011": "11.往事",
    "randomEventDialogueGroupConfig_12.467": "尽头似乎不愿被你继续试探，前方的树干挡住了你的去路，你停了下来。",
    "resoundEventConfigName_7016": "16.流星",
    "randomEventDialogueGroupConfig_12.466": "满意离开",
    "resoundEventConfigName_7017": "17.代打上线",
    "randomEventDialogueGroupConfig_12.469": "“躺平界也在卷，卷不动了，这个哪里都有比较的世界。溜了溜了~”",
    "resoundEventConfigName_7014": "14.苏比斯",
    "randomEventDialogueGroupConfig_12.468": "离开",
    "resoundEventConfigName_7015": "15.合体",
    "randomEventDialogueGroupConfig_12.463": "使出硕鼠全力滚跟上",
    "randomEventDialogueGroupConfig_12.462": "神秘商人使出金牛冲撞滚法。",
    "randomEventDialogueGroupConfig_12.465": "“你赢了。滚界第一的称号让给你了。”",
    "resoundEventConfigName_7018": "18.人才啊",
    "randomEventDialogueGroupConfig_12.464": "离开",
    "resoundEventConfigName_7019": "19.暗处",
    "13_2018": "存在",
    "13_2019": "不存在",
    "13_2016": "重置",
    "13_2017": "确定",
    "13_2021": "点击排阵",
    "13_2022": "命运之泉",
    "13_2020": "我的战力",
    "13_2025": "强化孢子",
    "13_2026": "进化孢子",
    "13_2023": "森灯",
    "13_2024": "神性孢子",
    "13_2007": "MAX",
    "13_2008": "森灯",
    "13_2005": "光亮{1}%",
    "13_2006": "燃火效果只对本次战斗生效",
    "13_2009": "放弃选择",
    "13_2010": "使用",
    "randomEventDialogueGroupConfig_12.409": "它开始加速滚远。",
    "13_2011": "重新抽取",
    "randomEventDialogueGroupConfig_12.408": "道别",
    "13_2014": "下次免费",
    "randomEventDialogueGroupConfig_12.405": "它说完就闭上了眼。",
    "13_2015": "下一级解锁",
    "randomEventDialogueGroupConfig_12.404": "开打",
    "13_2012": "获得词缀效果！",
    "randomEventDialogueGroupConfig_12.407": "啊，是警报来了，摸鱼要被发现了。我先溜了。",
    "13_2013": "信息",
    "randomEventDialogueGroupConfig_12.406": "再叫它一次",
    "randomEventDialogueGroupConfig_12.401": "无聊。",
    "randomEventDialogueGroupConfig_12.400": "不追",
    "randomEventDialogueGroupConfig_12.403": "过去开挖",
    "randomEventDialogueGroupConfig_12.402": "你可以挖一下。",
    "randomEventDialogueGroupConfig_12.419": "表示不需要感谢",
    "13_2003": "终焉之果获得奖励",
    "randomEventDialogueGroupConfig_12.416": "起身离开",
    "13_2004": "点击空白位置关闭",
    "randomEventDialogueGroupConfig_12.415": "继续滚下去",
    "13_2001": "黑暗森林",
    "randomEventDialogueGroupConfig_12.418": "它说着两行热泪从它的双颊划过，它哭了。",
    "13_2002": "获得奖励",
    "randomEventDialogueGroupConfig_12.417": "抱歉，我语气重了点。#我很好，我只是想躺着，谢谢你的关心。被你这么关心，我感到很温暖。但我什么都没有，不知道要怎么报答你。",
    "randomEventDialogueGroupConfig_12.412": "无声跟上",
    "randomEventDialogueGroupConfig_12.411": "它开始默默滚远。",
    "randomEventDialogueGroupConfig_12.414": "它离开了。你呢?",
    "randomEventDialogueGroupConfig_12.413": "无声离开",
    "randomEventDialogueGroupConfig_12.410": "道别",
    "randomEventDialogueGroupConfig_12.427": "离开",
    "randomEventDialogueGroupConfig_12.426": "虽然神秘商人一直在叫唤，但身体并没有挪动半分。",
    "randomEventDialogueGroupConfig_12.429": "离开",
    "randomEventDialogueGroupConfig_12.428": "它默默向你挥手告别。",
    "randomEventDialogueGroupConfig_12.423": "反问是不是真的没有谢礼",
    "randomEventDialogueGroupConfig_12.422": "告别离开",
    "randomEventDialogueGroupConfig_12.425": "离开",
    "randomEventDialogueGroupConfig_12.424": "它哭着哭晕了过去，所以听不到你的话了。",
    "randomEventDialogueGroupConfig_12.421": "呜呜，好的您慢走。",
    "randomEventDialogueGroupConfig_12.420": "拍一拍它然后告别",
    "20_20": "基因可以自由选择属性，远程怪兽选择【攻击力】，近战怪兽选择【体力】是比较中庸但有效的方案哟！",
    "messageInitContent_6956": "九九玖璃",
    "messageInitContent_6955": "表白圣地",
    "messageInitContent_6958": "1000大关！",
    "messageInitContent_6957": "马上一千",
    "messageInitContent_6959": "突破1000大关！",
    "20_17": "冒险{1}",
    "20_16": "永生之茧",
    "20_15": "可指派",
    "messageInitContent_6961": "终于",
    "20_14": "奖励列表",
    "messageInitContent_6960": "哇！",
    "20_13": "探索指派",
    "messageInitContent_4300": "草丛也可以是吸血首",
    "messageInitContent_6963": "嗨~",
    "20_12": "产出列表",
    "messageInitContent_4301": "怪兽长了个草丛脑袋",
    "messageInitContent_6962": "████████████████████████████████████████████████████████████",
    "20_11": "免费造唤",
    "messageInitContent_4302": "真正的黑客会带键盘的吗",
    "messageInitContent_6965": "███████████████████████",
    "20_10": "掉落",
    "messageInitContent_4303": "后面的玩偶装倒是挺可爱的",
    "messageInitContent_6964": "这是什么？",
    "channelName_114": "哔哩哔哩游戏中心",
    "20_19": "异象",
    "20_18": "尖刺",
    "20_31": "碎片转化可将任意觉醒怪兽的碎片转化为|c万能碎片|c，升级|c任意|c觉醒怪兽技能。",
    "messageInitContent_4304": "双击键盘",
    "messageInitContent_6967": "这边，来",
    "20_30": "黑暗森林",
    "messageInitContent_4305": "你的鼠标在动",
    "messageInitContent_6966": "老树在看什么",
    "messageInitContent_4306": "自动鼠标是吧",
    "messageInitContent_6969": "完全没在怕",
    "messageInitContent_4307": "用来剪葱的剪刀手",
    "messageInitContent_6968": "别低头",
    "messageInitContent_4308": "螳螂拳芯片",
    "messageInitContent_4309": "加载完成",
    "20_28": "怪兽重置可返还怪兽|c全额|c的经验，强化孢子和技能碎片。",
    "messageInitContent_6970": "怪不得影曜在这",
    "20_27": "凿星裂痕",
    "20_26": "逐步解锁这些谜之部件，打穿这片暴走旷野吧！",
    "messageInitContent_6972": "暗影！",
    "20_25": "深渊先遣",
    "messageInitContent_4310": "这是蟑螂义体化了把",
    "messageInitContent_6971": "它在呼唤",
    "20_24": "谜之巢穴里可以|c饲养|c属于你的|c谜之生物|c。\\n|c谜之生物|c全身所有部位都可以自由订制选择，它们拥有各种奇怪又|c不失礼貌|c的特殊效果。\\n|cDIY|c属于你的谜之生物~",
    "messageInitContent_4311": "惹",
    "messageInitContent_6974": "过来吧，孩子",
    "20_23": "野生怪兽",
    "messageInitContent_4312": "这个板块是我的了",
    "messageInitContent_6973": "你听到没有，那个声音",
    "20_22": "游荡智者",
    "messageInitContent_4313": "懂了",
    "messageInitContent_6976": "我在哪里",
    "20_21": "异象",
    "messageInitContent_4314": "还行",
    "messageInitContent_6975": "谁在说话",
    "20_29": "凿星裂痕钥匙",
    "messageInitContent_4315": "真不是什么啃咬体验馆？",
    "messageInitContent_6978": "蝉妹！",
    "messageInitContent_4316": "眼睛被抢了！",
    "messageInitContent_6977": "emmmm",
    "messageInitContent_4317": "笑笑更健康",
    "messageInitContent_4318": "烫手吗",
    "messageInitContent_6979": "薛定谔的蝉",
    "messageInitContent_4319": "那剑我收了",
    "messageInitContent_6981": "崩坏吧",
    "messageInitContent_6980": "你听到它的呼唤了吗",
    "messageInitContent_4320": "一定是飞行训练基地",
    "messageInitContent_6983": "刚打谁了",
    "messageInitContent_4321": "从此学飞",
    "messageInitContent_6982": "嘻嘻",
    "messageInitContent_4322": "相信的心就是我的魔法",
    "messageInitContent_6985": "你们有没有觉得那根东西",
    "messageInitContent_4323": "来嘛来嘛巷子左拐找我玩",
    "messageInitContent_6984": "这个既视感",
    "messageInitContent_4324": "背带裤？",
    "messageInitContent_6987": "啊啊啊啊啊啊啊啊啊啊啊啊",
    "messageInitContent_4325": "要素察觉",
    "messageInitContent_6986": "来了",
    "19_11": "星律收益累计小时上限",
    "19_10": "凿星钥匙上限",
    "channelName_134": "游戏官网",
    "messageInitContent_4326": "冲击拳套",
    "messageInitContent_6989": "好像越来越多了",
    "messageInitContent_4327": "粉红色冲击波~",
    "messageInitContent_6988": "害怕",
    "13_2027": "凶兽",
    "messageInitContent_4328": "哪里都有包租公",
    "13_2028": "其他",
    "messageInitContent_4329": "赛博空间也可以收租",
    "messageInitContent_6992": "不要过来",
    "messageInitContent_4330": "喵喵怪你好",
    "messageInitContent_6991": "你听到它的呼唤了吗",
    "messageInitContent_4331": "漆黑组件！请控制我！",
    "messageInitContent_6994": "██████",
    "messageInitContent_4332": "黑客梵",
    "messageInitContent_6993": "这边，来，快来",
    "messageInitContent_4333": "1在哪？",
    "messageInitContent_6996": "是您在叫唤吗",
    "messageInitContent_4334": "1在网络数据之中",
    "messageInitContent_6995": "完全没在怕",
    "messageInitContent_4335": "由01组成",
    "messageInitContent_6998": "这片荒野好大",
    "messageInitContent_4336": "闪刀？",
    "messageInitContent_6997": "哈哈哈哈哈哈哈",
    "messageInitContent_6990": "████████████",
    "randomEventDialogueGroupConfig_12.470": "告别",
    "randomEventDialogueGroupConfig_12.472": "离开",
    "randomEventDialogueGroupConfig_12.471": "躺着躺着，地面突然震动起来。#“啊，是警报来了，摸鱼要被发现了。溜了溜了。”",
    "messageInitContent_4337": "龙骑士赤虹！",
    "messageInitContent_4338": "魔偶入侵~",
    "messageInitContent_6999": "████████████████████████████████████████████████",
    "messageInitContent_4339": "迷路了吗",
    "messageInitContent_4340": "这个翅膀我要了",
    "messageInitContent_4341": "烤龙翅?",
    "messageInitContent_4342": "叛逆期来了",
    "messageInitContent_4343": "诊所保镖很强",
    "messageInitContent_4344": "因为需要保镖摁住客人",
    "messageInitContent_4345": "害怕",
    "messageInitContent_4346": "医生我脑袋掉了还有救吗",
    "messageInitContent_4347": "有钱就有救",
    "messageInitContent_4348": "谁家小孩和保镖",
    "messageInitContent_4349": "爷笑了",
    "messageInitContent_4351": "I人点赞",
    "messageInitContent_4352": "e人点赞",
    "messageInitContent_4353": "下城区我来啦",
    "messageInitContent_4354": "好像沉了下去一样",
    "messageInitContent_4355": "高价收购启炉思眼睛",
    "messageInitContent_4356": "寻怪启示：我家赤虹走丢了 请联系",
    "messageInitContent_4357": "采购清洁机器人请联系",
    "messageInitContent_4358": "高温焚化？？？",
    "messageInitContent_4350": "为什么受伤的总是它",
    "messageInitContent_4359": "可怕",
    "messageInitContent_4362": "早上好，夜之城",
    "messageInitContent_4363": "咱们不问为什么",
    "messageInitContent_4364": "崩坏狂潮",
    "messageInitContent_4365": "怪兽大乐透~",
    "messageInitContent_4366": "消失的字典",
    "messageInitContent_4367": "我 爱 你",
    "messageInitContent_4368": "收购一块会开玩笑的主板",
    "messageInitContent_4369": "v买车吗",
    "messageInitContent_4360": "创伤清理小队",
    "messageInitContent_4361": "私人超梦，紧张刺激欢迎预定",
    "messageInitContent_4373": "雅典娜呢？",
    "messageInitContent_4374": "我大兔子呢",
    "messageInitContent_4375": "卖牛腩",
    "messageInitNick_4099": "元宇宙阿四",
    "messageInitContent_4376": "放开瞳小姐！",
    "messageInitNick_4098": "丑的很极致",
    "messageInitContent_4377": "前排出售苹果核",
    "messageInitContent_4378": "叉叉这是没给钱吗",
    "messageInitContent_4379": "什么没给钱？",
    "messageInitContent_4370": "V买马马",
    "messageInitContent_4371": "嘿V，买大象吗",
    "messageInitContent_4372": "嘿，不卖！",
    "messageInitNick_4093": "空叹花语意",
    "messageInitNick_4092": "饿饿饭饭",
    "messageInitNick_4091": "天命打工人",
    "messageInitNick_4090": "未谱完的曲",
    "messageInitNick_4097": "相亲这件事",
    "messageInitNick_4096": "火辣的嘴唇",
    "messageInitNick_4095": "话里有糖",
    "messageInitNick_4094": "橙子兽",
    "messageInitNick_4089": "国之栋梁",
    "messageInitNick_4088": "专业摸鱼",
    "messageInitNick_4087": "宇宙香蕉侠",
    "messageInitNick_4082": "进口男孩",
    "messageInitNick_4081": "职场电灯胆",
    "messageInitNick_4080": "香蕉很激情",
    "worldName_1003": "H",
    "worldName_1004": "O",
    "messageInitNick_4086": "熬夜门首席",
    "messageInitNick_4085": "如果菠萝会笑",
    "messageInitNick_4084": "花女皇",
    "messageInitNick_4083": "路人假",
    "messageInitNick_4079": "枯叶蝶不咕",
    "messageInitNick_4078": "没有子弹",
    "messageInitNick_4077": "爱过狗喂过猪",
    "messageInitNick_4076": "套娃门首席",
    "themeCardPackName_18010": "要点",
    "messageInitNick_4071": "天生强大",
    "messageInitNick_4070": "好基友",
    "messageInitNick_4075": "未知异空间",
    "themeCardPackName_18015": "支点",
    "messageInitNick_4074": "暴力哥",
    "messageInitNick_4073": "什么奇怪理解",
    "messageInitNick_4072": "亲吻镇魂曲",
    "messageInitNick_4068": "鲜嫩的石榴",
    "messageInitNick_4067": "我为猫狂",
    "messageInitNick_4066": "矩阵思维者",
    "messageInitNick_4065": "我推的男子",
    "messageInitNick_4069": "嗷呜小乖乖",
    "messageInitNick_4060": "薄情女王",
    "themeCardPackName_18005": "视点",
    "messageInitNick_4064": "今晚吃啥",
    "messageInitNick_4063": "艺术就是爆炸",
    "messageInitNick_4062": "目的地不明",
    "messageInitNick_4061": "只是随口说说",
    "messageInitNick_4057": "疯狂摇摆",
    "messageInitNick_4056": "橙子小姐",
    "messageInitNick_4055": "正义",
    "messageInitNick_4054": "尬聊神",
    "messageInitNick_4059": "蠢萌女神",
    "messageInitNick_4058": "在线加油",
    "messageInitNick_4053": "打伞的鱼",
    "messageInitNick_4052": "领养代替购买",
    "messageInitNick_4051": "流泪的冰激淋",
    "messageInitNick_4050": "最爱沙棘果",
    "messageInitNick_4046": "凉茶牧师",
    "messageInitNick_4045": "回收空调",
    "messageInitNick_4044": "六点的泡面",
    "messageInitNick_4043": "表情极其诡异",
    "messageInitNick_4049": "有效变帅",
    "messageInitNick_4048": "暴走的方糖",
    "messageInitNick_4047": "倒霉的天鹅",
    "5_1": "手动",
    "5_2": "自动",
    "5_3": "切换",
    "5_4": "濒死",
    "5_5": "继续",
    "5_6": "优雅的投降",
    "messageInitNick_4042": "猫咖的常客",
    "5_7": "弹幕",
    "messageInitNick_4041": "梨魔法师",
    "messageInitNick_4040": "呆萌大叔",
    "5_9": "查看词缀",
    "messageInitNick_4035": "和谁恋爱",
    "messageInitNick_6698": "春风正得意",
    "messageInitNick_4034": "舒芙蕾爱好者",
    "messageInitNick_6699": "熬夜带头人",
    "messageInitNick_4033": "超级搬砖神",
    "messageInitNick_4032": "格仔衫帆布鞋",
    "messageInitNick_4039": "电饭煲的碎片",
    "messageInitNick_6694": "快餐大师",
    "messageInitNick_4038": "全息彩虹",
    "messageInitNick_6695": "不再重提",
    "messageInitNick_4037": "讲点道理",
    "messageInitNick_6696": "认证对线专家",
    "messageInitNick_4036": "自走玩具",
    "messageInitNick_6697": "最爱人参果",
    "messageInitNick_6690": "初夏的阳光",
    "messageInitNick_6691": "传说中的香蕉",
    "messageInitNick_6692": "等我变身好吗",
    "messageInitNick_6693": "蛋挞怪兽",
    "messageInitNick_4031": "跑调的救赎",
    "messageInitNick_4030": "洗碗机的碎片",
    "messageInitNick_4024": "一只小馋猫",
    "messageInitNick_6687": "上门做饭",
    "messageInitNick_4023": "姜之心",
    "messageInitNick_6688": "苹果去哪了",
    "messageInitNick_4022": "银色的体验",
    "messageInitNick_6689": "沉浸式艺术",
    "messageInitNick_4021": "黑魔法骑士",
    "messageInitNick_4028": "地狱王者",
    "messageInitNick_6683": "无公害萝卜",
    "messageInitContent_4400": "欢迎来到现实世界",
    "messageInitNick_4027": "逃跑的杏子",
    "messageInitNick_6684": "我太菜了",
    "messageInitContent_4401": "这些都可以大包下来吗",
    "messageInitNick_4026": "一克拉眼泪",
    "messageInitNick_6685": "给皮皮虾上菜",
    "messageInitContent_4402": "这些比蒙按摩力度一定很够吧",
    "messageInitNick_4025": "保护敌方打野",
    "messageInitNick_6686": "爵士少年",
    "messageInitNick_4029": "爱猫的软妹",
    "messageInitContent_4403": "比蒙按摩机器人你值得拥有",
    "messageInitContent_4404": "管家团队团购优惠请电",
    "messageInitNick_6680": "风尘剑客",
    "messageInitContent_4405": "我不适合当研究对象",
    "messageInitNick_6681": "雨静静下",
    "messageInitContent_4406": "信息安全管理专家 请联系",
    "messageInitNick_6682": "南半球那棵树",
    "messageInitContent_4407": "租房吗",
    "messageInitNick_4020": "人间桌子",
    "messageInitContent_4408": "啊我的灵魂，哦我没有",
    "messageInitContent_4409": "上传结束了吗，我的灵魂",
    "messageInitNick_4013": "流浪的距骨",
    "messageInitNick_6676": "柴犬爱听歌",
    "messageInitNick_4012": "插线板先锋",
    "messageInitNick_6677": "君为红颜醉",
    "messageInitNick_4011": "假日神仙",
    "messageInitNick_6678": "给冰箱道歉",
    "messageInitNick_4010": "未来的大神们",
    "messageInitNick_6679": "会游泳的猪",
    "messageInitContent_4410": "愿圣光指引你的道路",
    "messageInitNick_4017": "宝藏兼职中介",
    "messageInitNick_6672": "酱油打西瓜",
    "messageInitContent_4411": "这是哪个黑帮",
    "messageInitNick_4016": "为什么发语音",
    "messageInitNick_6673": "总被月老忘记",
    "messageInitContent_4412": "最后那个是最新型号的飞行器吗",
    "messageInitNick_4015": "吃饭的力量",
    "messageInitNick_6674": "旋转鸡块",
    "messageInitContent_4413": "那我要了",
    "messageInitNick_4014": "憔悴的电线",
    "messageInitNick_6675": "聆风听雨",
    "messageInitNick_4019": "且听风吟",
    "messageInitNick_4018": "巫毒之云",
    "messageInitNick_6670": "猫和老子",
    "messageInitNick_6671": "苹果魔法师",
    "messageInitNick_4002": "梦回侏罗纪",
    "messageInitNick_6665": "读不懂的流年",
    "messageInitNick_4001": "暗夜使魔",
    "messageInitNick_6666": "已加载请稍后",
    "messageInitNick_4000": "布丁牛奶",
    "messageInitNick_6667": "自助餐大师",
    "messageInitNick_6668": "冬日的栀子花",
    "messageInitNick_4006": "到店下班",
    "messageInitNick_6661": "抱紧我别松手",
    "messageInitNick_4005": "还是老样子",
    "messageInitNick_6662": "万事先开胯",
    "messageInitNick_4004": "你在问我吗",
    "messageInitNick_6663": "如来来没来",
    "messageInitNick_4003": "渐显实力",
    "messageInitNick_6664": "草莓在跳舞",
    "messageInitNick_4009": "好莱污影帝",
    "messageInitNick_4008": "古代西瓜",
    "messageInitNick_4007": "泡菜舞蹈家",
    "messageInitNick_6669": "奉旨划水",
    "messageInitNick_6660": "为蚊除害",
    "messageInitNick_6654": "原子之诗",
    "messageInitNick_6655": "忍不了一点",
    "messageInitNick_6656": "猫行者",
    "messageInitNick_6657": "怪怪怪怪可爱",
    "messageInitNick_6650": "脑力不足",
    "messageInitNick_6651": "花心本人戒了",
    "messageInitNick_6652": "流量女王",
    "messageInitNick_6653": "一心向善",
    "messageInitNick_6658": "友尽侠",
    "messageInitNick_6659": "毛巾破坏者",
    "96_WorldBoss": "世界灾厄",
    "messageInitNick_6643": "从来未预约",
    "messageInitNick_6644": "扭蛋机器人",
    "messageInitNick_6645": "吹水小能手",
    "messageInitNick_6646": "颜值天花板",
    "messageInitNick_6640": "独舞人偶",
    "messageInitNick_6641": "十一点的拉面",
    "messageInitNick_6642": "迷路的桡骨",
    "messageInitNick_6647": "属性大爆发",
    "messageInitNick_6648": "人品大爆发",
    "messageInitNick_6649": "摸鱼后效",
    "messageInitNick_6632": "寄居客",
    "messageInitNick_6633": "甜辣芒果",
    "messageInitNick_6634": "似懂非懂",
    "messageInitNick_6635": "帮柚子带货",
    "messageInitNick_6630": "右手忘记你",
    "messageInitNick_6631": "最迷人的危险",
    "messageInitNick_6636": "爱情睡醒了",
    "messageInitNick_6637": "消失的荷包蛋",
    "messageInitNick_6638": "护花使者",
    "messageInitNick_6639": "零下一度",
    "messageInitNick_6621": "可降解被子",
    "messageInitNick_6622": "四十岁的哥哥",
    "messageInitNick_6623": "百事可爱",
    "messageInitNick_6624": "老娘五行缺你",
    "messageInitNick_6620": "猛虎山下",
    "messageInitNick_6629": "瓜子战士",
    "messageInitNick_6625": "软猫外卖",
    "messageInitNick_6626": "爱打盹的猫",
    "messageInitNick_6627": "此心已废",
    "messageInitNick_6628": "淡紫色的回忆",
    "messageInitNick_6610": "超凡冷冻冰箱",
    "messageInitNick_6611": "火星运河",
    "messageInitNick_6612": "我是你的水壶",
    "messageInitNick_6613": "爷称霸全服",
    "messageInitNick_6618": "高冷帝",
    "messageInitNick_6619": "厕所里蹦迪",
    "messageInitNick_6614": "发亮的电灯泡",
    "messageInitNick_6615": "不规则的美",
    "messageInitNick_6616": "绝版少爷",
    "messageInitNick_6617": "芭蕉消灭者",
    "messageInitNick_6600": "宇宙来信",
    "messageInitNick_6601": "玉米兽",
    "messageInitNick_6602": "这是一场失恋",
    "messageInitNick_6607": "眼睛出汗了",
    "messageInitNick_6608": "不取对象才强",
    "messageInitNick_6609": "无坑速动",
    "messageInitNick_6603": "抬杠之神",
    "messageInitNick_6604": "泰文怎么说",
    "messageInitNick_6605": "奔跑的五花肉",
    "messageInitNick_6606": "额骨",
    "channelName_27": "4399游戏中心",
    "channelName_23": "OPPO应用商店",
    "channelName_24": "华为应用商店",
    "activityShopName_270": "云霞燎里",
    "channelName_15": "小米应用商店",
    "channelName_17": "vivo应用商店",
    "activityShopName_280": "周年橱窗",
    "1_4001": "存在更高战力的极化可以替换，是否继续极化？",
    "1_4002": "当前极化战力比替换后更高，是否继续替换？",
    "moorEffectConfigDescription_7": "随机复活一只死亡的怪兽",
    "moorEffectConfigDescription_8": "怪兽霸气提升{p1}%",
    "moorEffectConfigDescription_9": "怪兽移动速度提升{p1}%",
    "moorEffectConfigDescription_3": "怪兽受到伤害降低{p1}%",
    "moorEffectConfigDescription_4": "近战怪兽体型增大{p1}%",
    "moorEffectConfigDescription_5": "远程怪兽体型缩小{p1}%",
    "moorEffectConfigDescription_6": "全体怪兽血量回复{p1}%",
    "moorEffectConfigDescription_1": "谜之生物等级提升{p1}",
    "moorEffectConfigDescription_2": "怪兽攻击力提升{p1}%",
    "activityShopName_220": "奇迹集市",
    "visionSagesConfigName_12": "游荡智者",
    "visionSagesConfigName_13": "游荡智者",
    "visionSagesConfigName_10": "游荡智者",
    "visionSagesConfigName_11": "游荡智者",
    "activityShopName_230": "端午游舫",
    "activityShopName_240": "地腹岩窟",
    "activityShopName_250": "缤纷小铺",
    "7_2001": "老司机带带我~！！（最多{1}字）",
    "activityShopName_260": "玉兔宝盒",
    "messageInitContent_4414": "多少钱都要！",
    "messageInitContent_4415": "高温熔炼，懂了",
    "messageInitContent_4416": "广告词：啥都能熔",
    "messageInitContent_4417": "加点油",
    "messageInitContent_4418": "加油",
    "messageInitContent_4419": "有什么能帮到你呢先生",
    "messageInitContent_4420": "这武器店真正规吗",
    "messageInitContent_4421": "随便拿送给大家了",
    "messageInitContent_4422": "哎哟",
    "messageInitContent_4423": "量子速读速成请联系",
    "messageInitContent_4424": "好好好",
    "messageInitContent_4425": "穿过去会消失吗",
    "messageInitContent_4426": "试试穿模",
    "messageInitContent_4427": "冲冲冲",
    "messageInitContent_4428": "想吃薯条了",
    "messageInitContent_4429": "咻咻怎么躲这里啦",
    "messageInitContent_4430": "下不来怎么办",
    "messageInitContent_4431": "草爹帮你割开",
    "messageInitContent_4432": "哇好痛",
    "messageInitContent_4433": "真的能飞吗",
    "messageInitContent_4434": "高层洗玻璃不错",
    "messageInitContent_4435": "这传送门会通往何方",
    "messageInitContent_4436": "星烁好像要把球抓住丢出去",
    "messageInitContent_4437": "打篮球是吧",
    "messageInitContent_4438": "没想到她的势力已经延伸到这么远了",
    "messageInitContent_4439": "又是你",
    "messageInitContent_4440": "可爱捏",
    "messageInitContent_4441": "抢生意是吧",
    "messageInitContent_4442": "在上面真的不会掉下来吗",
    "messageInitContent_4443": "店里好多保安",
    "messageInitContent_4444": "可能都是店员",
    "messageInitContent_4445": "这是负债了吗，只能卖飞行器了",
    "messageInitContent_4446": "啊我好像受伤了",
    "channelName_259": "x7Game Platform",
    "messageInitContent_4447": "我是真的受伤了",
    "messageInitContent_4448": "这靠谱吗，万一是个全息投影怎么办",
    "messageInitContent_4449": "白昼还有假的吗",
    "messageInitContent_4450": "我的心受伤了，需要白昼安慰",
    "messageInitContent_4451": "哇跳脸狙击",
    "messageInitContent_4452": "近战狙击",
    "messageInitContent_4453": "随身带医疗团队",
    "messageInitContent_4454": "不知道这个服务怎么收费",
    "messageInitContent_4455": "专业团队",
    "messageInitContent_4456": "这是个真的花丛还是个什么帮派的名字",
    "messageInitContent_4457": "比心",
    "messageInitContent_4458": "隔壁好大个心心",
    "messageInitContent_4459": "很危险的样子",
    "messageInitContent_4461": "520！",
    "messageInitContent_4462": "嗯？",
    "messageInitContent_4463": "别过来啊啊",
    "messageInitContent_4464": "啥情况",
    "messageInitContent_4465": "封心锁爱？？？",
    "messageInitContent_4466": "餐厅也带医生的",
    "messageInitContent_4467": "安全",
    "messageInitContent_4468": "烤萝卜",
    "messageInitContent_4460": "懂了实际上是个高端围栏",
    "messageInitContent_4469": "高档食材",
    "messageInitContent_4472": "受害者名单+n",
    "messageInitContent_4473": "那是豹子！是卧豹藏龙",
    "messageInitContent_4474": "怪多势众",
    "messageInitContent_4475": "先绕路了",
    "messageInitContent_4476": "是不是哪里不对",
    "messageInitContent_4477": "我要看全息招牌.gif",
    "messageInitContent_4478": "这花似乎在暗示着什么",
    "messageInitContent_4479": "花花世界",
    "messageInitContent_4470": "欢迎光临",
    "messageInitContent_4471": "卧虎藏龙呢",
    "messageInitContent_4483": "是时候要换一个发光脑袋",
    "messageInitContent_4484": "什么露西",
    "messageInitContent_4485": "发型？",
    "messageInitContent_4486": "雷鸣和无限绑死了我怀疑",
    "messageInitContent_4487": "网络的爱是真的吗",
    "messageInitContent_4488": "欢迎定制你的人工智能joi",
    "messageInitContent_4489": "你累了吗 放松一下吧",
    "messageInitContent_4480": "还是说~",
    "messageInitContent_4481": "露西？",
    "messageInitContent_4482": "露西那个是恶魔吧",
    "messageInitContent_4494": "不可控还是可控",
    "messageInitContent_4495": "暴走族据点？",
    "messageInitContent_4496": "啊我的手臂！",
    "messageInitContent_4497": "又有一只多脚炮台",
    "messageInitContent_4498": "我想要塔器抠马",
    "messageInitContent_4499": "狂潮的要塞由我来攻破",
    "messageInitContent_4490": "仿生人会爱上ai吗",
    "messageInitContent_4491": "I LOVE YOU",
    "messageInitContent_4492": "要暴走了吗",
    "messageInitContent_4493": "hello  老baby",
    "20_85": "不过最后这个微微发青的不是七王~\\n它与你来时穿越的漩涡类似，是通往另一个世界的入口。\\n更多的环境将孕育更多的可能，这大概是它那野蛮筛选中少见的理性了。",
    "20_84": "刚|c造|c的新鲜尸王，与新鲜解锁的阵容3号位更配哦！",
    "20_83": "看见了吗，这些潜伏于迷雾后的身影……\\n它们是盘踞在源初之地的七王，它们代表着重启进程中的毁灭之力。\\n唯有击破它们才有机会阻止这个星球无限重启！",
    "20_82": "{1}分后世界灾厄",
    "20_81": "开启狩猎模式还会持续|c自动获得|c狩猎勋章，狩猎勋章可在商店兑换各种物品哟！",
    "20_80": "开启狩猎模式后可以|c搜索猎物|c并进行狩猎，成功狩猎后会获得狩猎积分，每日根据狩猎积分排名获得奖励。",
    "20_79": "全服的探索者可以实时挑战世界灾厄，击破灾厄后将|c根据排名|c发放奖励，每周获得奖励有次数限制，叫上小伙伴们一起挑战灾厄吧！",
    "20_78": "深渊先遣会自带多个强力词缀，使用符合条件的怪兽|c压制词缀|c会大大提高胜率。",
    "20_77": "与好友建立联结共鸣可以|c共享你们的世界|c，帮忙击破异象还能额外获得友好点数哟！",
    "20_76": "觉醒怪兽可以使用|c同名怪兽碎片|c升级技能，也可以使用|c万能碎片|c进行升级，万能碎片可在|c饲星坛|c中进行兑换。",
    "6_1": "扣减防御值",
    "6_2": "未入榜",
    "6_3": "未击破",
    "6_4": "{1}收录刷新",
    "6_5": "达成条件：支配核心捐献{1}",
    "6_6": "未完成",
    "6_7": "已领取",
    "6_8": "部落之王",
    "6_9": "未有收录刷新",
    "messageInitNick_6599": "冰封狂魔",
    "messageInitNick_6595": "沧冥幽凰",
    "messageInitNick_6596": "帽子的故事",
    "messageInitNick_6597": "母鸡啊",
    "messageInitNick_6598": "流浪书馆",
    "20_64": "世界灾厄",
    "messageInitNick_6591": "此奶有毒",
    "20_63": "关闭中",
    "messageInitNick_6592": "美梦成真",
    "20_62": "开放中",
    "messageInitNick_6593": "玉米糖有点皮",
    "20_61": "每场古记战役都会根据超进化星历史，重现对战双方。你将|c使用固定的队伍|c进行挑战，|c排阵|c改变阵容、元核、神灵，找准出手时机，将是取胜的关键。",
    "messageInitNick_6594": "散场后",
    "20_60": "起源殿",
    "messageInitNick_6590": "跟风之神",
    "messageInitNick_6588": "呐呐呐呐呐",
    "messageInitNick_6589": "躲猫猫",
    "20_59": "战鼓",
    "20_58": "古记战役的每场战斗均为超进化星历史洪流中的遗憾之战，全以失败告终，如果是|c你去再做一次选择|c，能获得胜利吗？",
    "20_57": "部落战",
    "messageInitNick_6584": "江南第一剑",
    "20_56": "无",
    "messageInitNick_6585": "臭袜子的味道",
    "20_55": "交战",
    "messageInitContent_4500": "有中二病，快来医生",
    "messageInitNick_6586": "大白兔",
    "20_54": "宣战",
    "messageInitContent_4501": "阔爱",
    "messageInitNick_6587": "等待你上线",
    "26_comment": "大漠行, 天降一掌",
    "20_75": "遗迹据点示意图会显示目前|c驻守部队|c的数量，点击可查看遗迹的|c详细情况|c。",
    "messageInitContent_4502": "真嘟假嘟",
    "messageInitNick_6580": "凤舞九天",
    "20_74": "每个遗迹中均有多个遗迹据点，部落|c宣战|c据点进入|c交战|c状态后，部落成员可派遣自己的怪兽部队前往据点进行挑战从而|c占领|c据点，需要注意的是如果据点属于其他部落，有防守部队，需要先|c战胜防守部队|c才可以挑战据点哟！",
    "messageInitContent_4503": "多档力度可选是吧",
    "messageInitNick_6581": "顶级女仆",
    "20_73": "不同的图腾有不同的|c比拼方式|c，每日都会以部落为单位根据|c图腾的比拼方式|c进行排名结算，排名越高的部落|c图腾共生|c效果越强。",
    "messageInitContent_4504": "我不敢",
    "messageInitNick_6582": "爱赢才会拼",
    "20_72": "击破冒险关卡可能会掉落|c高品质元核|c，部落成员可以在拍卖所中进行竞拍。",
    "messageInitContent_4505": "我先来",
    "messageInitNick_6583": "和作业分手",
    "20_71": "一键领取",
    "messageInitContent_4506": "试试就逝世",
    "20_70": "{1}天后解锁",
    "messageInitContent_4507": "什么城防系统吗",
    "messageInitContent_4508": "御龙在天！！！！",
    "messageInitContent_4509": "好喜庆",
    "messageInitNick_6577": "走音公主",
    "messageInitNick_6578": "魔法在释放",
    "messageInitNick_6579": "两秒钟",
    "20_69": "本周活跃",
    "20_68": "支线冒险",
    "messageInitNick_6573": "引战之王",
    "20_67": "每日挑战",
    "messageInitContent_4510": "看我疯狂切后",
    "messageInitNick_6574": "快刀斩乱麻",
    "20_66": "免费次数",
    "messageInitContent_4511": "小龙龙快过来我有皮肤哦",
    "messageInitNick_6575": "星星闪耀",
    "20_65": "所有部落成员每次挑战部落冒险关卡都会扣减其|c防御值|c，防御值降至0%后关卡将被击破，部落成员都可以获得奖励。",
    "messageInitContent_4512": "好多aoe",
    "messageInitNick_6576": "星星眼怪兽",
    "20_42": "谜之巢穴",
    "messageInitContent_4513": "虎虎生威",
    "20_41": "挑战次数",
    "messageInitContent_4514": "炮火连天",
    "messageInitNick_6570": "奶糖有点皮",
    "20_40": "饲星坛商店里可使用|c饲星之魂|c兑换各种物品。",
    "messageInitContent_4515": "好家伙",
    "messageInitNick_6571": "会说话的橙子",
    "messageInitContent_4516": "有话好商量！",
    "messageInitNick_6572": "什么但",
    "messageInitContent_4517": "这个换头是哪种换头",
    "messageInitContent_4518": "换脸是吧",
    "messageInitContent_4519": "全息换脸装置",
    "20_39": "斗技场",
    "messageInitNick_6566": "没有词的曲",
    "20_38": "战令",
    "messageInitNick_6567": "李子真好吃",
    "20_37": "怪兽饲星后怪兽会|c永久消失|c，可返还怪兽|c全额|c的经验，强化孢子，基因强化消耗的金币，并根据怪兽品质获得|c饲星之魂|c。",
    "messageInitNick_6568": "最爱菜花",
    "20_36": "部落冒险",
    "messageInitNick_6569": "我是学生送我",
    "20_35": "探索点",
    "messageInitContent_4520": "整容（物理）",
    "messageInitNick_6562": "残冬醉离殇",
    "20_34": "探索中",
    "messageInitContent_4521": "溜了",
    "messageInitNick_6563": "断桥下的夜",
    "20_33": "空闲",
    "messageInitContent_4522": "怎么收费呢",
    "messageInitNick_6564": "那就是萌新",
    "20_32": "状态",
    "messageInitContent_4523": "混乱的地方哪里都不安全是吧",
    "messageInitNick_6565": "尖叫胡萝卜",
    "20_53": "如果你想独来独往，也可以|c单人挑战|c，正所谓独狼不累。",
    "messageInitContent_4524": "瑟瑟发抖",
    "20_52": "部落遗迹",
    "messageInitContent_4525": "发抖",
    "20_51": "可挑战",
    "messageInitContent_4526": "瑟瑟",
    "messageInitNick_6560": "饥饿走向夜",
    "20_50": "凿星裂痕为一系列高难度副本，可邀请好友组成队伍或加入其他探索者的队伍进行|c组队挑战|c。",
    "messageInitContent_4527": "蕾贝卡酱！",
    "messageInitNick_6561": "病娇幼猫",
    "messageInitContent_4528": "V狠狠击杀",
    "messageInitContent_4529": "酱！~~~~~~~~~~~~",
    "messageInitNick_6555": "村口蹲一狼",
    "20_49": "世界关卡",
    "messageInitNick_6556": "金牌战将",
    "20_48": "搜索令",
    "messageInitNick_6557": "旅人",
    "20_47": "可在此处查看元核熔炼后可能出现的词条属性和宿命效果，熔炼会返还材料元核|c全额|c的金币和粉尘。",
    "messageInitContent_4530": "爆锤狠狠",
    "messageInitNick_6558": "光波少女",
    "20_46": "狩猎",
    "messageInitContent_4531": "我有杯垫",
    "messageInitNick_6551": "帅得不明显",
    "20_45": "谜宝已开启",
    "messageInitContent_4532": "双重暗物质",
    "messageInitNick_6552": "香蕉海",
    "20_44": "谜宝未开启",
    "messageInitContent_4533": "deep dark",
    "messageInitNick_6553": "却上心头",
    "20_43": "紫色或以上品质的元核可以进行熔炼，熔炼后作为材料的元核会|c永久消失|c，并把主元核和材料元核的词条属性，宿命效果进行|c随机组合|c，可|c自由选择保留|c原有元核或随机组合后的元核。",
    "messageInitContent_4534": "？",
    "messageInitNick_6554": "热心怪人",
    "messageInitNick_6559": "给汽车带货",
    "propConfigDes_90602": "收集30块白色普攻恢复元核碎片可以合成白色品质普攻恢复元核。",
    "messageInitNick_6550": "黄瓜兽",
    "messageInitNick_6544": "留一手吧",
    "messageInitNick_6545": "打牌的发型",
    "messageInitNick_6546": "彼岸花",
    "propConfigDes_90607": "收集30块红色普攻恢复元核碎片可以合成红色品质普攻恢复元核。",
    "messageInitNick_6547": "狂飙的豹",
    "messageInitNick_6540": "计算机大侠",
    "propConfigDes_90605": "收集30块紫色普攻恢复元核碎片可以合成紫色品质普攻恢复元核。",
    "messageInitNick_6541": "雨滴多喝水",
    "propConfigDes_90606": "收集30块橙色普攻恢复元核碎片可以合成橙色品质普攻恢复元核。",
    "messageInitNick_6542": "我爱吃饺子",
    "propConfigDes_90603": "收集30块绿色普攻恢复元核碎片可以合成绿色品质普攻恢复元核。",
    "messageInitNick_6543": "暴走的软糖",
    "propConfigDes_90604": "收集30块蓝色普攻恢复元核碎片可以合成蓝色品质普攻恢复元核。",
    "messageInitNick_6548": "萨卡班甲鱼",
    "messageInitNick_6549": "放下那吃货",
    "propConfigDes_51000": "自选词条元核",
    "messageInitNick_6533": "电子夹心糖",
    "messageInitNick_6534": "豆瓣菜魔法师",
    "messageInitNick_6535": "不太会玩",
    "messageInitNick_6536": "手机痛击鼻梁",
    "messageInitNick_6530": "最强手机",
    "messageInitNick_6531": "黑暗幽灵",
    "messageInitNick_6532": "甜美的空气",
    "messageInitNick_6537": "随君征战",
    "messageInitNick_6538": "底层逻辑",
    "messageInitNick_6539": "泪听雨",
    "messageInitNick_6522": "谢谢您",
    "messageInitNick_6523": "梨先锋",
    "messageInitNick_6524": "花落知多少",
    "messageInitNick_6525": "小鸡快跑",
    "messageInitNick_6520": "坦白局的肥皂",
    "messageInitNick_6521": "硬盘劳累了",
    "messageInitNick_6526": "请你吃饺子",
    "messageInitNick_6527": "龙的传人",
    "messageInitNick_6528": "汽车的碎片",
    "messageInitNick_6529": "精致的小鲜肉",
    "messageInitNick_6511": "有人问我",
    "messageInitNick_6512": "炒菜必粘锅",
    "messageInitNick_6513": "外星人建筑师",
    "messageInitNick_6514": "最爱大葱",
    "messageInitNick_6510": "穷游全世界",
    "messageInitNick_6519": "却为相思困",
    "messageInitNick_6515": "你懂的",
    "messageInitNick_6516": "肉鸽队长",
    "messageInitNick_6517": "傲娇执事",
    "messageInitNick_6518": "负责人的人",
    "messageInitNick_6500": "又是掏狗",
    "messageInitNick_6501": "请你吃凉茶",
    "messageInitNick_6502": "霸王爷战神",
    "messageInitNick_6503": "旧吉他",
    "messageInitNick_6508": "队友我都不扶",
    "messageInitNick_6509": "懂得沉默",
    "messageInitNick_6504": "开局一条狗",
    "messageInitNick_6505": "草履虫懂了",
    "messageInitNick_6506": "小丑的泪谁懂",
    "messageInitNick_6507": "破案砖家",
    "channelName_32": "应用宝",
    "messageInitContent_4139": "还好我会分身术，指小号",
    "messageInitContent_58": "双咻，我爱双休！！！",
    "messageInitContent_59": "它们我也见过，是咻咻",
    "messageInitContent_4142": "继续编",
    "messageInitContent_63": "只有我觉得那表情像老人看手机吗",
    "messageInitNick_6940": "塞巴多拉贡",
    "messageInitContent_4143": "queen看到跟着joker的御空有点生气！",
    "messageInitContent_64": "咻咻也想进化？",
    "messageInitNick_6941": "姐天生拽",
    "messageInitContent_4144": "什么修罗场",
    "messageInitContent_61": "超2整容院！超整容物语",
    "messageInitNick_6942": "花式送快递",
    "messageInitContent_4145": "直击杀变大变小现场",
    "messageInitContent_62": "靠嘴输出，跟我比还是差点啊~小咻咻~",
    "messageInitNick_6943": "杏子魔法师",
    "messageInitContent_4146": "前排",
    "messageInitContent_67": "攻略坛说后面暴走旷野可以自己组装怪兽？我来组成头部！",
    "messageInitContent_4147": "龙虎豹！",
    "messageInitContent_68": "咻咻咻咻，非常能吹的咻咻",
    "messageInitContent_4148": "家庭伦理剧上演",
    "messageInitContent_65": "大腿好像粗了一些。",
    "messageInitContent_4149": "火神你回去，让我来",
    "messageInitContent_66": "一代玩家报道，给大家科普下那不是雪茄，是个乐器",
    "messageInitNick_6948": "柚子先锋",
    "messageInitNick_6949": "裤裆里的杀气",
    "messageInitNick_6944": "断了线的泪",
    "messageInitContent_60": "咻咻也整容了",
    "messageInitNick_6945": "乱转风扇",
    "messageInitContent_4140": "一个号选1边嘻嘻",
    "messageInitNick_6946": "甜甜圈儿",
    "messageInitContent_4141": "剧王看着跟在joker后面的御空沉默了",
    "messageInitNick_6947": "爱的代驾",
    "messageInitContent_69": "只有我觉得它像小夫吗(((o(*ﾟ▽ﾟ*)o)))",
    "messageInitContent_4153": "皮匠会不会自己打起来",
    "messageInitContent_74": "我的小逆转为什么会站在1号位（黑人问号",
    "messageInitContent_4154": "天啊撸",
    "messageInitContent_75": "皮诺丘，是你吗是你吗！？你又骗我了吗",
    "messageInitNick_6930": "单身控",
    "messageInitContent_4155": "到底选谁",
    "messageInitContent_72": "其实你们最大的敌人是教程不是咻咻",
    "messageInitNick_6931": "高情商水果",
    "messageInitContent_4156": "谁才是真爱",
    "messageInitContent_73": "咻咻老了",
    "messageInitNick_6932": "清新的橘子",
    "messageInitContent_4157": "不要以为我不在 我随时都在",
    "messageInitContent_78": "6年了，进化出了大腿",
    "randomEventDialogueGroupConfig_12.207": "我又不想知道了，你走吧。",
    "messageInitContent_4158": "硬币会告诉我答案",
    "messageInitContent_79": "怎么才可以和它一样击退这么远啊 有大神指点？",
    "randomEventDialogueGroupConfig_12.206": "等它说完",
    "messageInitContent_4159": "硬币会告诉我答案 对不对就不知道了",
    "messageInitContent_76": "有前排被推走了也没用，后排一样死",
    "randomEventDialogueGroupConfig_12.209": "它随手指了个地方。",
    "messageInitContent_77": "肉盾如果没霸气没移速，不太可能保的住后排",
    "randomEventDialogueGroupConfig_12.208": "离开",
    "messageInitNick_6937": "牛排的烦恼",
    "randomEventDialogueGroupConfig_12.203": "停下",
    "messageInitNick_6938": "蛋炒蛋炒蛋",
    "randomEventDialogueGroupConfig_12.202": "继续离开",
    "messageInitNick_6939": "天啸傲龙",
    "randomEventDialogueGroupConfig_12.205": "不管它离开",
    "randomEventDialogueGroupConfig_12.204": "还是请你等等！",
    "messageInitContent_70": "一看这咻咻就知道它们没玩过一代，肉盾都不带",
    "messageInitNick_6933": "白菜魔法",
    "messageInitContent_4150": "你们好皮",
    "messageInitContent_71": "咻咻没有肉盾啊",
    "messageInitNick_6934": "保镖跑了",
    "messageInitContent_4151": "真的皮",
    "messageInitNick_6935": "美食体验",
    "randomEventDialogueGroupConfig_12.201": "等等。",
    "messageInitContent_4152": "皮皮皮虾路过",
    "messageInitNick_6936": "淡淡稻花香",
    "randomEventDialogueGroupConfig_12.200": "离开",
    "messageInitContent_38": "叉叉还在努力进化吗？",
    "messageInitContent_39": "叉叉头发浓密了一看就知道变弱了",
    "messageInitContent_36": "叉叉什么时候进化，我好急",
    "messageInitContent_37": "看到叉叉没被炒鱿鱼，我就放心了",
    "messageInitContent_41": "行行好，给孩子穿件衣服吧",
    "messageInitContent_4164": "感情还有下半场？",
    "messageInitContent_4165": "冰霓给我其他随意",
    "messageInitContent_42": "有生之年啊啊啊啊啊啊啊",
    "messageInitContent_4166": "建议给对面加个逃跑按钮",
    "messageInitNick_6920": "专捡情绪垃圾",
    "messageInitContent_40": "惊！十位数的战力",
    "messageInitContent_4167": "呆滞",
    "messageInitNick_6921": "纯情老司机",
    "messageInitContent_4168": "好心人呢",
    "messageInitContent_45": "我回来啦啦啦啦啦啦啦啦——",
    "randomEventDialogueGroupConfig_12.218": "离开",
    "messageInitContent_4169": "答案呢",
    "messageInitContent_46": "策划又给叉叉画饼了",
    "randomEventDialogueGroupConfig_12.217": "你还是走吧，嘻嘻。",
    "messageInitContent_43": "叉叉自称手持海皇三叉戟，呵呵",
    "messageInitContent_44": "都忘了还有三周目的叉叉了吗",
    "randomEventDialogueGroupConfig_12.219": "过去打它",
    "messageInitNick_6926": "激萌摇滚妹",
    "randomEventDialogueGroupConfig_12.214": "不挖离开",
    "messageInitNick_6927": "姜片有点皮",
    "randomEventDialogueGroupConfig_12.213": "挖坑",
    "messageInitNick_6928": "西瓜先锋",
    "randomEventDialogueGroupConfig_12.216": "拿走",
    "messageInitNick_6929": "火星人才辈出",
    "randomEventDialogueGroupConfig_12.215": "地上多了一个坑。神秘商人滚到坑了舒服地睡下了。#刨出的土壤里好像有点什么东西。",
    "messageInitContent_4160": "hhhhhhhhhhh",
    "messageInitNick_6922": "暴走的海盐",
    "randomEventDialogueGroupConfig_12.210": "本来就躺在地上的神秘商人根本无法招架，疯狂吃减值，很快真正的躺平了。",
    "messageInitContent_4161": "哭了",
    "messageInitNick_6923": "这卡假的吧",
    "messageInitContent_4162": "咸鱼路过",
    "messageInitNick_6924": "凹凸曼",
    "randomEventDialogueGroupConfig_12.212": "我就看着你挖！",
    "messageInitContent_4163": "明亮地爬过",
    "messageInitNick_6925": "忧郁机器",
    "randomEventDialogueGroupConfig_12.211": "离开",
    "messageInitNick_6919": "在线等心上狗",
    "messageInitContent_49": "我要打10个咻咻！（熟悉",
    "messageInitContent_47": "萌新剧透一下，后面可以多玩家远古怪实时组队，5只远古打人！",
    "messageInitContent_48": "那个灰色的玩意就是新纹章？想念我的红霸气了",
    "messageInitContent_4175": "一次完成一周的任务",
    "messageInitContent_52": "这就是没前排的后果！",
    "messageInitContent_4176": "灾厄走开",
    "messageInitContent_53": "众爱卿平身",
    "messageInitContent_4177": "会不会掉元核",
    "messageInitContent_50": "没技能的咻咻，就只会咻咻咻",
    "messageInitContent_4178": "不会掉元核的是假的",
    "messageInitContent_51": "能不能快点跳过教程，什么时候可以玩家组队",
    "messageInitNick_6910": "智慧的眼神",
    "messageInitContent_4179": "明天拆红包",
    "messageInitContent_56": "别说两个一个能打的都没有",
    "randomEventDialogueGroupConfig_12.229": "换个语调叫",
    "messageInitContent_57": "无情2V2！吹你继续吹",
    "randomEventDialogueGroupConfig_12.228": "它没有理你。",
    "messageInitContent_54": "这关留言都被你们玩坏了hhhh",
    "messageInitContent_55": "希望你们可以正常点，好？",
    "messageInitNick_6915": "萨卡班甲鱼鱼",
    "randomEventDialogueGroupConfig_12.225": "它又转过身看着你。",
    "messageInitNick_6916": "此人略萌",
    "randomEventDialogueGroupConfig_12.224": "放弃离开",
    "messageInitNick_6917": "木瓜追踪者",
    "randomEventDialogueGroupConfig_12.227": "看着它",
    "messageInitContent_4170": "假期别走啊啊",
    "messageInitNick_6918": "蘑菇魔法师",
    "randomEventDialogueGroupConfig_12.226": "转身就跑",
    "messageInitContent_4171": "妹妹 在吗 我是闲人不用上班",
    "messageInitNick_6911": "整点麦乐鸡",
    "randomEventDialogueGroupConfig_12.221": "离开",
    "messageInitContent_4172": "思考一下",
    "messageInitNick_6912": "断桥念雪",
    "randomEventDialogueGroupConfig_12.220": "它听完就跑了。",
    "messageInitContent_4173": "再给我2分钟，让我把火神冻成冰",
    "messageInitNick_6913": "红色青猫",
    "randomEventDialogueGroupConfig_12.223": "表示只逗神秘商人",
    "messageInitContent_4174": "懂了",
    "messageInitNick_6914": "搏斗之皇",
    "randomEventDialogueGroupConfig_12.222": "真的吗？我虽然不是神秘商人，但也……不是不可以试试逗我玩！",
    "messageInitNick_6908": "多笋啊",
    "messageInitNick_6909": "时间是测谎仪",
    "messageInitContent_4186": "赤练yyds",
    "messageInitContent_4187": "帅的1挑3",
    "messageInitContent_4188": "真嘟假嘟",
    "messageInitContent_4189": "我服了",
    "messageInitNick_6904": "石缝中的花",
    "messageInitNick_6905": "调皮的灯光",
    "messageInitContent_4180": "明天上班",
    "messageInitNick_6906": "活泼小丸子",
    "messageInitContent_4181": "最后一次猜对的机会",
    "messageInitNick_6907": "恋爱无效期",
    "messageInitContent_4182": "温馨提示：您的假期余额不足",
    "messageInitNick_6900": "凉粉剑客",
    "messageInitContent_4183": "最后停下的会是哪一边呢",
    "messageInitNick_6901": "我有对象勿扰",
    "messageInitContent_4184": "今天初八，答案是左边",
    "messageInitNick_6902": "记忆荒原",
    "messageInitContent_4185": "右！",
    "messageInitNick_6903": "没有战斗力",
    "messageInitContent_4197": "呼叫大佬",
    "messageInitContent_4198": "让我康康",
    "messageInitContent_4199": "掌管胜利的……是",
    "messageInitContent_4190": "且猜且珍惜",
    "messageInitContent_4191": "打着干嘛啊 站啊",
    "messageInitContent_4192": "站着干嘛啊 打呀",
    "messageInitContent_4193": "勇敢赤练不怕困难",
    "messageInitContent_4194": "这会是谁的灾难呢",
    "messageInitContent_4195": "天苍苍野茫茫",
    "messageInitContent_4196": "你的答案已下线",
    "messageInitContent_85": "看到那熟悉的绿色我就知道马上可以进化了",
    "messageInitContent_86": "这作的进化这么酷炫的？？？？？？还来个背景魔法回路吗",
    "messageInitContent_83": "两个拿着锤子的……？？？",
    "messageInitContent_84": "谁来解释下拿着锤子为什么就叫锤子？",
    "messageInitContent_89": "我进化出了大腿",
    "messageInitContent_87": "为了部落！！",
    "messageInitContent_88": "两小关，占领了挂机拿东西双倍，希望后面全是两小关！",
    "messageInitContent_81": "要尽量保护好后排输出，不然死了后排基本输一半了",
    "messageInitContent_82": "只因同款发型？！",
    "messageInitContent_80": "因为他的技能是击退，效果相当于霸气了",
    "messageInitContent_96": "怀疑在讽刺锤子",
    "messageInitContent_97": "我要看锤子出道！",
    "messageInitContent_94": "快让锤子学铁山靠，然后出道！",
    "messageInitContent_95": "石锤这是石锤吗？！",
    "messageInitContent_98": "建议明星出道前先来这关拜拜锤神",
    "messageInitContent_99": "你个锤子",
    "messageInitContent_92": "是他！！！",
    "messageInitContent_93": "快给锤子一条背带裤，立刻给我安排！",
    "messageInitContent_90": "过了这关开领地！",
    "messageInitContent_91": "以前我怎么没发现这发型这么像呢！",
    "randomEventDialogueGroupConfig_12.272": "前往交易",
    "randomEventDialogueGroupConfig_12.271": "居然能让我这个完全不愿起来的商人起来了，有点本事啊。我记得那边还有个神秘商人在洞里偷懒的，你可以去它的店看看。",
    "randomEventDialogueGroupConfig_12.274": "离开",
    "randomEventDialogueGroupConfig_12.273": "它似乎觉得这样睡非常舒服的，一阵又一阵响亮的鼾声从下面传出。#你还顺便挖出另外一个头朝下的商人，那个商人身旁似乎有点什么东西。",
    "randomEventDialogueGroupConfig_12.270": "在它上半身下方挖个坑",
    "messageInitContent_6714": "那边的事什么？",
    "messageInitContent_6713": "理智良好",
    "messageInitContent_6716": "别别别",
    "messageInitContent_6715": "幻觉",
    "messageInitContent_6718": "别慌",
    "messageInitContent_6717": "搞啥",
    "messageInitContent_6719": "瑟瑟发抖中",
    "22_2104|L": "成功",
    "messageInitContent_6721": "丝毫不慌",
    "messageInitContent_6720": "到底有多少只草丛",
    "messageInitContent_6723": "回家",
    "messageInitContent_6722": "肉食兔子？",
    "randomEventDialogueGroupConfig_12.279": "交易",
    "randomEventDialogueGroupConfig_12.276": "来来来，我这就带您去隔壁店逛逛，请！",
    "randomEventDialogueGroupConfig_12.275": "拾起",
    "randomEventDialogueGroupConfig_12.278": "您好！请问有什么能帮到你？",
    "randomEventDialogueGroupConfig_12.277": "交易",
    "randomEventDialogueGroupConfig_12.283": "说怕其他怪兽因为踢到它而摔倒",
    "randomEventDialogueGroupConfig_12.282": "不回答离开",
    "randomEventDialogueGroupConfig_12.285": "离开",
    "randomEventDialogueGroupConfig_12.284": "它听完愣了一愣，默默地滚到最不挡路的角落。",
    "randomEventDialogueGroupConfig_12.281": "喂喂喂，你这是要干嘛？",
    "randomEventDialogueGroupConfig_12.280": "战斗",
    "messageInitContent_6725": "有点恍惚",
    "messageInitContent_6724": "我的领地怎么不见了",
    "messageInitContent_6727": "冲冲冲",
    "messageInitContent_6726": "sc大失败",
    "messageInitContent_6729": "啊？",
    "messageInitContent_6728": "什么可怕的诅咒",
    "messageInitContent_6730": "都是飞行生物呢",
    "messageInitContent_6732": "好怪",
    "messageInitContent_6731": "那不是什么怪",
    "messageInitContent_6734": "疯狂切割",
    "messageInitContent_6733": "你什么名字",
    "randomEventDialogueGroupConfig_12.287": "提出要求",
    "randomEventDialogueGroupConfig_12.286": "我会说谢谢你。",
    "randomEventDialogueGroupConfig_12.289": "别走啊，别走啊。",
    "randomEventDialogueGroupConfig_12.288": "离开",
    "randomEventDialogueGroupConfig_12.294": "离开",
    "randomEventDialogueGroupConfig_12.293": "你这么说我也不会帮你按的。",
    "randomEventDialogueGroupConfig_12.296": "跟着滚过去",
    "randomEventDialogueGroupConfig_12.295": "它被你一戳立刻开始自动滚开。",
    "randomEventDialogueGroupConfig_12.290": "我只会说谢谢你。",
    "randomEventDialogueGroupConfig_12.292": "离开",
    "randomEventDialogueGroupConfig_12.291": "说谢谢它",
    "messageInitContent_6736": "该不会是",
    "messageInitContent_6735": "要和什么切割",
    "messageInitContent_6738": "就它？",
    "messageInitContent_6737": "握草的跃迁兽",
    "messageInitContent_6739": "丝毫不慌",
    "messageInitContent_6741": "你说的都对",
    "messageInitContent_6740": "阿飘！",
    "messageInitContent_6743": "3号位又无了",
    "messageInitContent_6742": "裂了",
    "messageInitContent_6745": "开溜",
    "messageInitContent_6744": "溜了溜了",
    "randomEventDialogueGroupConfig_12.298": "神秘商人又滚回到你身边。",
    "randomEventDialogueGroupConfig_12.297": "躺到它刚才躺的位置",
    "randomEventDialogueGroupConfig_12.299": "依然躺着",
    "messageInitContent_6747": "幻觉吗",
    "messageInitContent_6746": "为什么牙齿在扭动",
    "messageInitContent_6749": "恭喜你",
    "messageInitContent_6748": "me下海了",
    "96_ImmortalCocoon": "永生之茧",
    "messageInitContent_6750": "别过来啊jo哥",
    "messageInitContent_6752": "让我看看",
    "messageInitContent_6751": "笑死",
    "messageInitContent_6754": "完全没在怕",
    "messageInitContent_6753": "连设恐龙都要抱团取暖了吗",
    "messageInitContent_6756": "社恐算是什么恐",
    "messageInitContent_6755": "弹幕护体",
    "randomEventDialogueGroupConfig_12.230": "它还是那个样。",
    "messageInitContent_16": "叉叉这次进化了吗?",
    "messageInitContent_6758": "要怎么区分黑子和白子",
    "messageInitContent_17": "这关好像我打过。",
    "messageInitContent_6757": "拿走那根东西！",
    "messageInitContent_14": "叉叉整容了？",
    "messageInitContent_15": "叉叉长出新眼睛了！",
    "messageInitContent_6759": "黑子白子你们怎么都在呢",
    "messageInitContent_18": "啊，又是一拳解决呢。",
    "messageInitContent_19": "没有技巧，就是一拳ヽ(`Д´)ﾉ ┻━┻",
    "messageInitContent_6761": "闪光！",
    "messageInitContent_20": "差点没舍得下手！",
    "messageInitContent_6760": "千手熵鬼",
    "messageInitContent_4100": "aoe了个寂寞",
    "messageInitContent_6763": "草丛和绯的颜色挺搭的",
    "messageInitContent_4101": "蜓蜓号出击",
    "messageInitContent_6762": "饿了",
    "messageInitContent_23": "有没有想过，那些被打败的叉叉都去哪了？",
    "messageInitContent_4102": "为什么要削弱社恐龙",
    "messageInitContent_6765": "怪哦",
    "messageInitContent_24": "知道为什么叉叉这么想进化了吧，都是被你们打的！",
    "messageInitContent_4103": "一夫当关",
    "messageInitContent_6764": "那是礼炮",
    "randomEventDialogueGroupConfig_12.239": "潇洒离开",
    "messageInitContent_21": "不许你戳我的小逆转",
    "messageInitContent_4104": "无敌",
    "messageInitContent_6767": "不是怪是什么",
    "messageInitContent_22": "一开始出场的都是隐藏boss吧？",
    "messageInitContent_4105": "寂寞",
    "messageInitContent_6766": "真的是怪哦",
    "randomEventDialogueGroupConfig_12.236": "在周围的怪兽的欢呼和喝彩中，它忍无可忍跑了。",
    "randomEventDialogueGroupConfig_12.235": "离开",
    "randomEventDialogueGroupConfig_12.238": "你还真是在逗我玩啊！哈哈哈哈哈哈。谢谢你。我玩得很开心。",
    "randomEventDialogueGroupConfig_12.237": "离开",
    "randomEventDialogueGroupConfig_12.232": "放弃离开",
    "randomEventDialogueGroupConfig_12.231": "换一个语速再试试",
    "randomEventDialogueGroupConfig_12.234": "继续表演",
    "randomEventDialogueGroupConfig_12.233": "你的坚持不懈引来了不少怪兽的围观。",
    "randomEventDialogueGroupConfig_12.241": "重复上次操作",
    "randomEventDialogueGroupConfig_12.240": "它又滚向没有阻拦的方向。",
    "messageInitContent_27": "通关攻略：点击前往挑战",
    "messageInitContent_4106": "我将独自战斗",
    "messageInitContent_6769": "问题不大",
    "messageInitContent_28": "今天吃饭就用叉了！",
    "messageInitContent_4107": "他将独自战斗",
    "messageInitContent_6768": "完全不带怕的",
    "messageInitContent_25": "能不能放过叉叉？",
    "messageInitContent_4108": "懂了",
    "messageInitContent_26": "我还在犹豫，叉叉就没了！",
    "messageInitContent_4109": "说这些我就不困了",
    "messageInitContent_29": "抽叉！冲鸭！输了~（叉叉的一生",
    "messageInitContent_30": "以后再也不怕方便面没有叉了",
    "messageInitContent_6772": "肉肉我来啦",
    "messageInitContent_31": "叉叉还是一个人，3代能不能给它个圈圈！",
    "messageInitContent_4110": "财神到财神到",
    "messageInitContent_6771": "丝毫不慌",
    "messageInitContent_4111": "看哪边好呢",
    "messageInitContent_6774": "是谁？",
    "messageInitContent_4112": "喵喵c位！！",
    "messageInitContent_6773": "瑟瑟发抖中",
    "messageInitContent_34": "叉叉叉叉叉叉叉！我可没骂人，我就是在叫叉叉。",
    "messageInitContent_4113": "免费看表演",
    "messageInitContent_6776": "我在前面好吗",
    "messageInitContent_35": "特地回头看看，还是没有技能。",
    "messageInitContent_4114": "阵容豪华",
    "messageInitContent_6775": "跟着后面的是你吗",
    "messageInitContent_32": "叉出去！",
    "messageInitContent_4115": "镇魂你的剧王在对面",
    "messageInitContent_6778": "醉了",
    "messageInitContent_33": "叉叉听到叉出去的时候会不会对号入座。",
    "messageInitContent_4116": "相爱相杀",
    "messageInitContent_6777": "那后面的是谁",
    "randomEventDialogueGroupConfig_12.247": "拒绝然后离开",
    "randomEventDialogueGroupConfig_12.246": "同意",
    "randomEventDialogueGroupConfig_12.249": "从背后偷袭",
    "randomEventDialogueGroupConfig_12.248": "你发现你完全没办法将它抱起来。",
    "randomEventDialogueGroupConfig_12.243": "它抓住这个机会，继续往原方向滚去，滚远了。",
    "randomEventDialogueGroupConfig_12.242": "离开",
    "messageInitContent_6770": "弹幕护体",
    "randomEventDialogueGroupConfig_12.245": "要不换个地方用力，帮我按按腰？",
    "randomEventDialogueGroupConfig_12.244": "离开",
    "randomEventDialogueGroupConfig_12.250": "绕到脚那边拖",
    "randomEventDialogueGroupConfig_12.252": "搜身",
    "randomEventDialogueGroupConfig_12.251": "它毫无防备，被你敲晕了。",
    "messageInitContent_4117": "我不想努力了",
    "messageInitContent_4118": "小盆宇才做选择",
    "messageInitContent_6779": "美色醉人",
    "messageInitContent_4119": "财团表演这边请",
    "messageInitContent_4120": "跑团这边请",
    "messageInitContent_6783": "桐仁怎么在这里",
    "messageInitContent_4121": "美团这边请",
    "messageInitContent_6782": "烦",
    "messageInitContent_4122": "拼团这边请",
    "messageInitContent_6785": "跑啊",
    "messageInitContent_4123": "乐园还学人吗想撸猫",
    "messageInitContent_6784": "你好桐仁",
    "messageInitContent_4124": "不插电演唱会",
    "messageInitContent_6787": "HUH？",
    "messageInitContent_4125": "你们看什么电影了",
    "messageInitContent_6786": "快跑",
    "messageInitContent_4126": "小电影",
    "messageInitContent_6789": "早点休息",
    "messageInitContent_4127": "财团=财神的团",
    "messageInitContent_6788": "emmmm",
    "randomEventDialogueGroupConfig_12.258": "问能有什么好处",
    "randomEventDialogueGroupConfig_12.257": "帮它按",
    "randomEventDialogueGroupConfig_12.259": "顺利拖动了。",
    "randomEventDialogueGroupConfig_12.254": "你在它身上找到了一条表面异常光滑的木制鱼状物。",
    "randomEventDialogueGroupConfig_12.253": "离开",
    "messageInitContent_6781": "gogogo",
    "randomEventDialogueGroupConfig_12.256": "就是这一块，谢谢。",
    "messageInitContent_6780": "你的思想很危险",
    "randomEventDialogueGroupConfig_12.255": "离开",
    "randomEventDialogueGroupConfig_12.261": "往上拖",
    "randomEventDialogueGroupConfig_12.260": "拖走",
    "randomEventDialogueGroupConfig_12.263": "停下离开",
    "randomEventDialogueGroupConfig_12.262": "太棒了，你手势真好。请不要停下来。",
    "messageInitContent_4128": "为你写诗",
    "messageInitContent_4129": "表演一下E6",
    "messageInitContent_4131": "为什么只有bgm",
    "messageInitContent_6794": "烫嘴",
    "messageInitContent_4132": "塔塔开",
    "messageInitContent_6793": "烫脚",
    "messageInitContent_4133": "多喝热水",
    "messageInitContent_6796": "好怪",
    "messageInitContent_4134": "喵响狂粉",
    "messageInitContent_6795": "嗯？",
    "messageInitContent_12": "听说这作后面可以自己拼怪兽- -？",
    "messageInitContent_4135": "为幻幻打call",
    "messageInitContent_6798": "嘘",
    "messageInitContent_13": "有进化孢子闭眼进化远古主角准没错~",
    "messageInitContent_4136": "来一首只因你太美",
    "messageInitContent_6797": "完全没在怕",
    "messageInitContent_10": "在解锁神灵后可以在排阵界面里更换神灵上阵",
    "messageInitContent_4137": "练习一下铁山靠",
    "messageInitContent_11": "这叉是只有教程才会出现的怪兽！欢迎入坑！",
    "messageInitContent_4138": "不知道练习时长多久",
    "messageInitContent_6799": "前方岔路",
    "randomEventDialogueGroupConfig_12.269": "在它下半身下方挖个坑",
    "randomEventDialogueGroupConfig_12.268": "仍难以将它拖起。",
    "messageInitContent_6790": "创！",
    "randomEventDialogueGroupConfig_12.265": "要拖去哪里呢？",
    "randomEventDialogueGroupConfig_12.264": "继续",
    "messageInitContent_6792": "锤子带队",
    "randomEventDialogueGroupConfig_12.267": "拖去路边",
    "messageInitContent_4130": "不许假唱",
    "messageInitContent_6791": "来碰碰",
    "randomEventDialogueGroupConfig_12.266": "拖去神秘商人工会",
    "7_1": "大众评点",
    "7_2": "请留下您对此怪兽的评点",
    "7_3": "内容不能为空",
    "7_4": "举报",
    "7_5": "已举报",
    "7_6": "最新",
    "7_7": "赞最多",
    "7_8": "评点",
    "7_9": "获得怪兽后可进行评点",
    "randomEventDialogueGroupConfig_56.55": "离开",
    "randomEventDialogueGroupConfig_56.56": "桐仁吓了一大跳，说给你出三倍赏金将它抓住。",
    "randomEventDialogueGroupConfig_56.57": "成交",
    "randomEventDialogueGroupConfig_56.58": "你获得了三倍赏金，也完成了任务。",
    "randomEventDialogueGroupConfig_56.59": "离开",
    "22_dish113456": "有机破防沙拉",
    "randomEventDialogueGroupConfig_56.44": "等智者离开后，一直躲在后面偷听的桐仁向你走来。",
    "randomEventDialogueGroupConfig_56.45": "谢谢你。",
    "randomEventDialogueGroupConfig_56.46": "道别",
    "randomEventDialogueGroupConfig_56.47": "可惜后面没有找到桐仁，自然也没有领到三倍赏金。",
    "randomEventDialogueGroupConfig_56.48": "离开",
    "randomEventDialogueGroupConfig_56.49": "你似乎没有费什么劲就把桐仁抓住了。",
    "messageInitNick_4299": "小小谎言",
    "messageInitNick_4298": "千机变大佬",
    "messageInitNick_4297": "东京老吃货",
    "messageInitNick_4296": "月色如银",
    "randomEventDialogueGroupConfig_56.50": "跟它说给三倍赏金就放过它",
    "randomEventDialogueGroupConfig_56.51": "它竟不为所动，还说要捕要抓，悉听尊便。",
    "randomEventDialogueGroupConfig_56.52": "抓住便是",
    "randomEventDialogueGroupConfig_56.53": "说放了它",
    "randomEventDialogueGroupConfig_56.54": "你顺利抓住了桐仁，完成了任务。",
    "messageInitNick_4291": "深海之主",
    "messageInitNick_4290": "草莓消灭者",
    "messageInitNick_4295": "八十岁了",
    "messageInitNick_4294": "期末刺客",
    "messageInitNick_4293": "天下起雨了",
    "messageInitNick_4292": "咖喱加点糖",
    "messageInitNick_4288": "老婆我在呢",
    "skillDes_121": "远程状态会使攻击力提升{level_based}%，免疫且清除所有负面效果",
    "messageInitNick_4287": "戳戳小狗腿",
    "skillDes_122": "近战状态会使血量回复效果提升{level_based}%，霸气提升{p1}%",
    "messageInitNick_4286": "时光忘记回来",
    "messageInitNick_4285": "你躲哪了",
    "skillDes_120": "{owner}血量低于{p1}%时进入远程状态，血量大于等于{p1}%时进入近战状态，攻击血量低于{p1}%的敌方怪兽时会额外造成攻击力×{level_based}%的真实伤害",
    "skillDes_125": "黯灭焰每{p1}秒造成攻击力×{level_based}%的伤害，持续{p2}秒",
    "skillDes_126": "战斗开始时，所有己方其他怪兽进入烬临状态（获得{owner}的{level_based}%的真实伤害），持续至{owner}死亡",
    "messageInitContent_6800": "怪出门",
    "skillDes_123": "{owner}进入远程或近战状态时，都会获得{p1}层群兽印记，受到的伤害降低{level_based}%，持续{p2}秒",
    "messageInitNick_4289": "柿子兽",
    "skillDes_124": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的范围伤害（{p1}码）",
    "skillDes_129": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，{owner}下方出现乱流（{p1}码），敌方怪兽的子弹触碰乱流会被蒸发，乱流每{p2}秒向前推进{p3}码，持续{level_based}秒",
    "skillDes_127": "黯灭焰会使敌方怪兽的攻击力降低{level_based}%，持续{p1}秒",
    "skillDes_128": "{owner}的射程提升{level_based}",
    "messageInitContent_6809": "我就怕怕不说话",
    "messageInitContent_6802": "小声点",
    "messageInitNick_4280": "打小就可爱",
    "messageInitContent_6801": "别出声",
    "messageInitContent_6804": "怪兽之声",
    "messageInitContent_6803": "音乐之声",
    "messageInitContent_6806": "吃了",
    "messageInitNick_4284": "牙膏毁灭者",
    "messageInitContent_6805": "吃了吗",
    "messageInitNick_4283": "早上七点半",
    "messageInitContent_6808": "瑟瑟发抖中",
    "messageInitNick_4282": "约定风琴",
    "messageInitContent_6807": "睡了吗",
    "messageInitNick_4281": "橙子在唱歌",
    "messageInitNick_4277": "始于脸红",
    "skillDes_110": "{owner}累计扣减的血量超过最大血量的{p1}%时，触发绯，对前方（{p2}码）的敌方怪兽造成攻击力×{level_based}%的伤害",
    "messageInitNick_4276": "天堂饭盒",
    "skillDes_111": "绯会使己方怪兽的体型增大{level_based}%，霸气提升{p1}%，持续{p2}秒",
    "messageInitNick_4275": "打扰了",
    "messageInitNick_4274": "旧街",
    "skillDes_114": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{p1}%的伤害，且造成封印效果，持续{level_based}秒",
    "skillDes_115": "火拳会使敌方怪兽血量回复效果降低{level_based}%，霸气降低{p1}%，持续{p2}秒",
    "messageInitContent_6811": "呼",
    "messageInitNick_4279": "救命稻草",
    "skillDes_112": "绯会使敌方怪兽的子弹蒸发，会击退敌方怪兽{level_based}码",
    "messageInitContent_6810": "丝毫不慌",
    "messageInitNick_4278": "短路一秒钟",
    "skillDes_113": "触发虹光时，触发绯，攻击速度提升{level_based}%，持续{p1}秒",
    "skillDes_118": "不屈状态会使{owner}造成伤害的{level_based}%用于回复自身血量",
    "skillDes_119": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，{owner}获得{p1}层群兽印记，到达{p2}层群兽印记时消耗所有印记，对前方所有敌方怪兽造成其当前血量×{level_based}%的伤害，该伤害忽视敌方伤害降低效果{p3}%，最大伤害为{owner}的攻击力×{p4}%",
    "skillDes_116": "火拳会使敌方怪兽焚烧，每{p1}秒造成攻击力×{level_based}%的区域伤害（{p2}码），持续{p3}秒",
    "skillDes_117": "{owner}血量低于{p1}%时，进入不屈状态（攻击力降低{p2}%，移动速度降低{p3}%，受到的伤害降低{level_based}%）",
    "messageInitContent_6813": "你好锤子",
    "propConfigDes_90502": "收集30块白色自愈恢复元核碎片可以合成白色品质自愈恢复元核。",
    "messageInitContent_6812": "为什么一直在点头",
    "propConfigDes_90503": "收集30块绿色自愈恢复元核碎片可以合成绿色品质自愈恢复元核。",
    "messageInitContent_6815": "晚上好",
    "messageInitContent_6814": "我来啦",
    "messageInitContent_6817": "你们不饿！",
    "messageInitNick_4273": "记忆摇晃着",
    "messageInitContent_6816": "是不是有996",
    "messageInitNick_4272": "懒鬼",
    "messageInitContent_6819": "头儿？",
    "messageInitNick_4271": "脑干生成中",
    "messageInitContent_6818": "头？",
    "messageInitNick_4270": "喜欢我直说",
    "messageInitNick_4266": "葡萄射手",
    "messageInitNick_4265": "疯狂电车人",
    "skillDes_100": "龙炮会使敌方怪兽血量回复效果降低{p1}%，持续{p2}秒，龙炮·追击效果被清除时造成攻击力×{level_based}%的伤害",
    "messageInitNick_4264": "行走的蜜枣",
    "messageInitNick_4263": "麻辣毛蛋",
    "messageInitContent_6820": "你头呢",
    "propConfigDes_90506": "收集30块橙色自愈恢复元核碎片可以合成橙色品质自愈恢复元核。",
    "skillDes_103": "{owner}受到致死的伤害时不会死亡，进入潜地状态（攻速，攻击力和移动速度变为0，霸气提升{level_based}%，受到的敌方怪兽伤害变为回复等量的血量），持续{p1}秒，冷却时间{p2}秒",
    "messageInitNick_4269": "米饭的烦恼",
    "propConfigDes_90507": "收集30块红色自愈恢复元核碎片可以合成红色品质自愈恢复元核。",
    "skillDes_104": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，体型缩小{p1}%，持续{p2}秒",
    "messageInitContent_6822": "弹幕护体",
    "messageInitNick_4268": "顶骨",
    "propConfigDes_90504": "收集30块蓝色自愈恢复元核碎片可以合成蓝色品质自愈恢复元核。",
    "skillDes_101": "龙炮的目标如果有护盾，减少{level_based}%的护盾，且将减少的护盾转化为{owner}的护盾，持续{p1}秒",
    "messageInitContent_6821": "你头儿呢",
    "messageInitNick_4267": "耍点小脾气",
    "propConfigDes_90505": "收集30块紫色自愈恢复元核碎片可以合成紫色品质自愈恢复元核。",
    "skillDes_102": "当{owner}拥有护盾时，每{p1}秒清除所有负面效果，且回复攻击力×{level_based}%的血量",
    "skillDes_107": "{owner}的血量回复效果降低{p1}%，受到的伤害降低{level_based}%",
    "skillDes_108": "{owner}统治区域内敌方怪兽大于等于{p1}个时，进入血煞状态（攻击力提升{level_based}%，能量回复效果提升{p2}%），持续{p3}秒",
    "skillDes_105": "战斗开始时，创造一个统治区域（{p1}码），区域内的敌方近战怪兽的攻击力降低{level_based}%，血量回复效果降低{p2}%，统治区域持续至{owner}死亡",
    "skillDes_106": "终焉攻击体型比自身小的怪兽时，造成封印效果，持续{level_based}秒",
    "skillDes_109": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成（敌方攻击力+{owner}攻击力）×{level_based}%的伤害，最大伤害为{owner}的攻击力×{p1}%",
    "shopName_10": "许愿商店",
    "shopName_11": "源初境商店",
    "messageInitContent_6824": "喊你一声你敢应吗",
    "messageInitContent_6823": "又是你小妖",
    "messageInitContent_6826": "你们不应该在一起",
    "messageInitContent_6825": "嘶",
    "messageInitContent_6828": "怎么在这里快跟我回家",
    "messageInitNick_4262": "缺根筋墨鱼",
    "messageInitContent_6827": "啊这",
    "messageInitNick_4261": "浪一世痞一生",
    "messageInitNick_4260": "百香果龙",
    "messageInitContent_6829": "圣光给我力量",
    "messageInitNick_4255": "一炮而红",
    "messageInitNick_4254": "尖叫口香糖",
    "messageInitNick_4253": "最强椅子",
    "messageInitNick_4252": "饼太大吃不下",
    "messageInitContent_6831": "组件硬控我一关",
    "messageInitNick_4259": "龙眼君快逃",
    "messageInitContent_6830": "完全没在怕",
    "messageInitNick_4258": "苦瓜多样性",
    "messageInitContent_6833": "queen梦到我了吗",
    "messageInitNick_4257": "当场退休",
    "messageInitContent_6832": "我又来啦",
    "messageInitNick_4256": "不要停下来",
    "messageInitNick_4251": "流浪的店员",
    "skillDes_161": "每{level_based}秒{owner}获得偏移效果",
    "messageInitNick_4250": "爷的名字",
    "skillDes_162": "{owner}血量低于{p1}%时，创造一个结界区域（{p2}码），区域内己方怪兽获得无敌效果，结界区域持续{level_based}秒，冷却时间{p3}秒",
    "skillDes_160": "入魂会偷取敌方怪兽当前血量的{level_based}%",
    "messageInitNick_4244": "沙沙沙沙拉",
    "skillDes_165": "魔物死亡时产生自爆，造成攻击力×{level_based}%的区域伤害（{p1}码）",
    "messageInitNick_4243": "随缘抽卡",
    "skillDes_166": "受到自爆伤害的怪兽被击退{level_based}码，移动速度降低{p1}%，持续{p2}秒",
    "messageInitNick_4242": "机场等船",
    "skillDes_163": "触发入魂时，攻击速度提升{level_based}%，持续{p1}秒",
    "messageInitNick_4241": "无公害辣椒",
    "skillDes_164": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，在身后召唤一只魔物（原生种族），魔物继承{owner}{level_based}%的攻击力和体力，{p1}%的霸气和移动速度，魔物存在{p2}秒后死亡",
    "messageInitNick_4248": "老板找你",
    "skillDes_169": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对血量最高的敌方怪兽造成攻击力×{level_based}%的伤害",
    "messageInitNick_4247": "怀抱漏风",
    "messageInitNick_4246": "天天晒太阳",
    "skillDes_167": "自爆会使范围内的己方怪兽攻击力提升{level_based}%，持续{p1}秒",
    "messageInitNick_4245": "掏不过掏不过",
    "skillDes_168": "{owner}死亡时分裂为{p1}只魔物，它们攻击敌方怪兽时会额外造成其当前血量×{level_based}%的伤害，最大伤害为{owner}的攻击力×{p2}%",
    "messageInitNick_4249": "悲欢并不相通",
    "ancientGeneConfigName_1": "肌肉膨大",
    "ancientGeneConfigName_2": "造血再生",
    "ancientGeneConfigName_3": "液压骨骼",
    "ancientGeneConfigName_4": "适应免疫",
    "messageInitNick_4240": "银河偶遇计划",
    "skillDes_150": "触发御时，回复最大血量×{level_based}%的血量",
    "skillDes_151": "御会使敌人被击退{level_based}码",
    "messageInitNick_4233": "行走的果汁糖",
    "messageInitNick_6896": "我选择困难",
    "skillDes_154": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，{owner}免疫且清除所有负面效果，持续{level_based}秒",
    "messageInitNick_4232": "橙子之心",
    "messageInitNick_6897": "鸟儿飞飞飞",
    "skillDes_155": "{owner}经过地图中央时召唤Queen，Queen会自动向前方行进，每{level_based}秒最多召唤{p1}次Queen",
    "affixDescription_1": "战斗开始时，怪兽{p1}秒内受到的伤害变为0",
    "messageInitNick_4231": "怎样坚强",
    "messageInitNick_6898": "萌比从天而降",
    "skillDes_152": "御会清除敌方怪兽所有增益效果，且会使自身霸气提升{level_based}%，持续{p1}秒",
    "affixDescription_2": "怪兽受到远程伤害降低{p1}%",
    "messageInitNick_4230": "超级过山车",
    "messageInitNick_6899": "爱你情非得已",
    "skillDes_153": "御的范围增大{level_based}%",
    "messageInitNick_4237": "小汤包儿",
    "messageInitNick_6892": "超级沙拉",
    "skillDes_158": "诡秘状态会使普通攻击造成攻击力×{p1}%的范围伤害（{p2}码），受到伤害的怪兽攻击力降低{p3}%，持续{level_based}秒",
    "messageInitNick_4236": "静谧游泳圈",
    "messageInitNick_6893": "人帅路子正",
    "skillDes_159": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的真实伤害",
    "messageInitNick_4235": "油菜真好吃",
    "messageInitNick_6894": "静静养大猫",
    "skillDes_156": "Queen触碰到的怪兽会获得惊雷效果（己方怪兽为增益效果，敌方怪兽为负面效果，每只怪兽只能获得一次惊雷效果），惊雷{p1}秒后爆炸，对敌方怪兽造成{owner}攻击力×{level_based}%的区域伤害（{p2}码），惊雷效果被清除时将会立刻爆炸，伤害提升{p3}%",
    "messageInitNick_4234": "霹雳美人",
    "messageInitNick_6895": "九点的泡面",
    "skillDes_157": "{owner}血量低于{level_based}%时，进入诡秘状态（每{p1}秒回复攻击力×{p2}%的血量）",
    "ancientGeneConfigName_5": "心脏群",
    "ancientGeneConfigName_6": "祖龙亲和",
    "ancientGeneConfigName_7": "尸鬼亲和",
    "messageInitNick_4239": "最强的香蕉",
    "ancientGeneConfigName_8": "星灵亲和",
    "messageInitNick_4238": "劳逸结合",
    "ancientGeneConfigName_9": "木偶亲和",
    "affixDescription_7": "远程怪兽攻击速度提升{p1}%",
    "affixDescription_8": "怪兽被击退时忽视敌方霸气{p1}%(含直接击退距离)",
    "affixDescription_9": "怪兽移动速度提升{p1}%",
    "messageInitNick_6890": "给汽车按摩",
    "messageInitNick_6891": "叫我冷场王",
    "affixDescription_3": "怪兽受到近战伤害降低{p1}%",
    "affixDescription_4": "怪兽每被攻击{p1}次会触发1次攻击力×{p2}%的范围伤害",
    "skillDes_140": "杀生石会制造一个黑洞（{p1}码），黑洞内的敌方怪兽会被吸向黑洞中心，移动速度越高越容易反抗黑洞的吸引力，黑洞存在{level_based}秒",
    "affixDescription_5": "怪兽血量少于{p1}%时，攻击力提升{p2}%",
    "affixDescription_6": "怪兽射程提升{p1}%",
    "messageInitNick_4222": "盛夏光年",
    "messageInitNick_6885": "无极巧手",
    "skillDes_143": "战斗开始时，所有己方远程怪兽的攻击力提升{level_based}%，持续至{owner}死亡",
    "messageInitNick_4221": "暴走的果汁糖",
    "messageInitNick_6886": "皇后娘娘",
    "skillDes_144": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，{owner}创造一个极地区域（{p1}码），区域内敌方怪兽的移动速度降低{level_based}%，极地区域持续{p2}秒",
    "messageInitNick_4220": "认证走音专家",
    "messageInitNick_6887": "自己想办法",
    "skillDes_141": "{owner}的普通攻击忽视敌方伤害降低效果{p1}%，冷却时间{level_based}秒",
    "messageInitNick_6888": "给空调道歉",
    "skillDes_142": "战斗开始时，所有己方近战怪兽的负面效果持续时间降低{level_based}%，持续至{owner}死亡",
    "messageInitNick_4226": "听见阳光",
    "messageInitNick_6881": "记得要微笑",
    "skillDes_147": "极地区域会使己方近战怪兽获得{owner}最大血量×{level_based}%的护盾，持续{p1}秒，每{p2}秒最多获得{p3}次",
    "messageInitNick_4225": "自私的前锋",
    "messageInitNick_6882": "苷沉",
    "skillDes_148": "{owner}每被治疗{p1}次制造一面冰墙，拥有{owner}×{level_based}%的霸气，触碰到的敌方怪兽会被击退，移动速度降低{p2}%，持续{p3}秒，冰墙最多生效{p4}次，存在{p5}面",
    "messageInitNick_4224": "发亮的灯泡",
    "messageInitNick_6883": "泪已决堤",
    "skillDes_145": "极地区域会使除{owner}自身外所有怪兽的体型缩小{level_based}%（己方怪兽为增益效果，敌方怪兽为负面效果）",
    "messageInitNick_4223": "连呼吸都会痛",
    "messageInitNick_6884": "林间茫茫月色",
    "skillDes_146": "极地区域会使敌方近战怪兽的攻击力降低{level_based}%",
    "messageInitNick_4229": "第一视觉的你",
    "messageInitNick_4228": "蹲街角哭泣",
    "skillDes_149": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，造成最大血量×{level_based}%的区域伤害（{p1}码）",
    "messageInitNick_4227": "超前游玩",
    "messageInitNick_6889": "龙龙舞者",
    "iapBuyConfigDesc_10001": "描述10001",
    "messageInitNick_6880": "可乐有毒",
    "messageInitNick_4211": "你在哪里等我",
    "messageInitNick_6874": "暖水瓶",
    "skillDes_132": "乱流每{p1}秒对敌方怪兽造成攻击力×{level_based}%的伤害",
    "messageInitNick_4210": "葫芦娃",
    "messageInitNick_6875": "在徘徊中等你",
    "skillDes_133": "凭依状态会使被依附的怪兽受到致死的伤害时不会死亡，且回复{owner}最大血量×{level_based}%的血量，每场战斗最多触发{p1}次",
    "messageInitNick_6876": "嘘别出声",
    "skillDes_130": "战斗开始时，{owner}依附她前方的怪兽在其上方翱翔（前方没有怪兽时{owner}死亡），该怪兽进入凭依状态（负面效果持续时间降低{level_based}%），{owner}不受场上任何效果影响（与神灵类似），但也不会进行普通攻击，持续至依附的怪兽死亡时，{owner}死亡",
    "messageInitNick_6877": "秋日落叶",
    "skillDes_131": "凭依状态会使被依附的怪兽获得{owner}{level_based}%的霸气、移动速度和射程（近战怪兽提升射程无实际效果）",
    "messageInitNick_4215": "大魔王",
    "messageInitNick_6870": "东京小萌妹",
    "skillDes_136": "光能会对范围内（{p1}码）的敌方怪兽造成其最大血量×{level_based}%的伤害，最大伤害为{owner}的攻击力×{p2}%",
    "messageInitNick_4214": "盐多了会咸",
    "messageInitNick_6871": "五块三斤",
    "skillDes_137": "触发光能时，攻击速度提升{level_based}%，持续{p1}秒",
    "messageInitNick_4213": "喵喵队立大功",
    "messageInitNick_6872": "藏在星辰大海",
    "skillDes_134": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，为血量百分比最少的己方怪兽回复{owner}最大血量×{level_based}%的血量",
    "messageInitNick_4212": "萝卜先锋",
    "messageInitNick_6873": "龙眼射手",
    "skillDes_135": "光能会对范围内（{p1}码）的己方怪兽回复{owner}最大血量×{level_based}%的血量",
    "messageInitNick_4219": "奇迹玩家",
    "messageInitNick_4218": "花与金丝雀",
    "messageInitNick_4217": "不想理你",
    "skillDes_138": "{owner}血量低于{level_based}%时，{owner}的血量回复效果提升{p1}%",
    "messageInitNick_4216": "天下第一卷",
    "skillDes_139": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的范围伤害（{p1}码）",
    "messageInitNick_6878": "你二你先说",
    "messageInitNick_6879": "藏不住喜欢",
    "randomEventDialogueGroupConfig_56.33": "照它说的做",
    "randomEventDialogueGroupConfig_56.34": "不管怎样你完成了这个悬赏。",
    "randomEventDialogueGroupConfig_56.35": "离开",
    "randomEventDialogueGroupConfig_56.36": "桐仁突然扒开地上的草丛找了个地洞钻了进去。",
    "randomEventDialogueGroupConfig_56.37": "离开",
    "randomEventDialogueGroupConfig_56.38": "这时候智者拦住了你，示意你跟它到一旁聊聊。",
    "randomEventDialogueGroupConfig_56.39": "随它去",
    "messageInitNick_4200": "鸡肋魔法师",
    "messageInitNick_6863": "加油成功",
    "messageInitNick_6864": "染墨绘君衣",
    "messageInitNick_6865": "旋转楼梯",
    "messageInitNick_6866": "会吐泡泡的鱼",
    "messageInitNick_4204": "一方通行",
    "randomEventDialogueGroupConfig_56.40": "我跟你说，这桐仁还有好多活没做完，所以特意找个借口矿工，我重新贴个悬赏，希望你帮我把桐仁抓回来干活。赏金报酬高三倍！",
    "messageInitNick_4203": "不用留退路",
    "messageInitNick_6860": "一点的拉面",
    "randomEventDialogueGroupConfig_56.41": "成交",
    "messageInitNick_4202": "爽脆的柚子",
    "messageInitNick_6861": "广场舞老师",
    "randomEventDialogueGroupConfig_56.42": "打工人不难为打工仁",
    "messageInitNick_4201": "和尚用舒蕾",
    "messageInitNick_6862": "半世枪魂",
    "randomEventDialogueGroupConfig_56.43": "那好吧，我另请高明。",
    "messageInitNick_4208": "临海听风",
    "messageInitNick_4207": "芒果先锋",
    "messageInitNick_4206": "实名买房",
    "messageInitNick_4205": "摸鱼先锋",
    "messageInitNick_6867": "迷倒一片喵",
    "messageInitNick_6868": "水煮薯片",
    "messageInitNick_6869": "你的食堂阿姨",
    "messageInitNick_4209": "电磁炉之彼端",
    "randomEventDialogueGroupConfig_56.22": "离开",
    "skillDes_190": "咒会使敌方怪兽的移动速度降低{level_based}%，持续{p1}秒",
    "randomEventDialogueGroupConfig_56.23": "桐仁吓了一跳，支支吾吾扭扭捏捏了一会，就跑开了。",
    "skillDes_191": "咒会使敌方怪兽的霸气降低{level_based}%，持续{p1}秒",
    "randomEventDialogueGroupConfig_56.24": "离开",
    "randomEventDialogueGroupConfig_56.25": "被你关起来的桐仁流下了眼泪，一脸感激地看着你，向你告别。",
    "randomEventDialogueGroupConfig_56.26": "离开",
    "skillDes_194": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，产生体力×{p1}%的区域伤害（{p2}码），且获得最大血量{level_based}%的护盾，持续{p3}秒",
    "randomEventDialogueGroupConfig_56.27": "问它什么回事",
    "skillDes_195": "壁垒触发时，会使攻击力最高的敌方怪兽攻击力降低{level_based}%，持续{p1}秒",
    "randomEventDialogueGroupConfig_56.28": "它不肯说。",
    "skillDes_192": "咒会击退敌方怪兽{level_based}码",
    "randomEventDialogueGroupConfig_56.29": "威胁放它出来",
    "skillDes_193": "咒会使敌方怪兽受到的伤害提升{level_based}%，持续{p1}秒",
    "messageInitNick_6852": "不如养头猪",
    "skillDes_198": "战斗开始时，自己和站位第二的己方怪兽进入镇守状态（所有增益效果不可清除），持续{level_based}秒",
    "messageInitNick_6853": "兔兔要睡觉啦",
    "skillDes_199": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的范围伤害（{p1}码）",
    "messageInitNick_6854": "流浪的作家",
    "skillDes_196": "{owner}体型产生变化时，受到的近战伤害降低{level_based}%，持续{p1}秒，最多叠加{p2}次，叠加时刷新持续时间持续时间",
    "messageInitNick_6855": "射线",
    "skillDes_197": "战斗开始时，重装免疫封印效果，且受到的近战伤害降低{level_based}%，但血量回复效果降低{p1}%，持续{p2}秒",
    "randomEventDialogueGroupConfig_56.30": "威胁把它交给超进化委员会",
    "messageInitNick_6850": "白衣男神",
    "randomEventDialogueGroupConfig_56.31": "桐仁吓得一个激灵，一个滑跪大喊道。",
    "messageInitNick_6851": "菜花射手",
    "randomEventDialogueGroupConfig_56.32": "不要啊，不要放我走，我不想回去干活求求你！",
    "messageInitNick_6856": "尬聊少女",
    "messageInitNick_6857": "手握馒头",
    "messageInitNick_6858": "暴走萝莉酱",
    "messageInitNick_6859": "不口胡会挂",
    "randomEventDialogueGroupConfig_56.19": "桐仁一把抱住了你的大腿，眼里充满了哀求。",
    "randomEventDialogueGroupConfig_56.11": "撕下悬赏令冲过去",
    "randomEventDialogueGroupConfig_56.12": "放桐仁一马",
    "skillDes_180": "破魔的后坐力会使{owner}后退{p1}码，回复最大血量{level_based}%的血量",
    "randomEventDialogueGroupConfig_56.13": "你转身离去，却发现那桐仁在你前面扭动，生怕引不起你注意似的。",
    "randomEventDialogueGroupConfig_56.14": "抓住桐仁",
    "randomEventDialogueGroupConfig_56.15": "不管桐仁",
    "skillDes_183": "战斗开始时，在站位第四的己方怪兽的位置上创造一个{level_based}码的魔免领域，进入领域的己方怪兽每{p1}秒被清除一个持续时间最长的负面效果，{owner}死亡时领域消失",
    "randomEventDialogueGroupConfig_56.16": "你看了看悬赏令上的要求，抓住后要找地方关起来，但要供应吃喝，费用在赏金里扣，赏金在饭店里领。",
    "skillDes_184": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，会使血量最高的己方近战怪兽获得{owner}攻击力×{level_based}%的护盾，持续{p1}秒",
    "randomEventDialogueGroupConfig_56.17": "质问桐仁",
    "skillDes_181": "破魔会使敌方怪兽受到的伤害提升{p1}%，持续{level_based}秒",
    "randomEventDialogueGroupConfig_56.18": "按照上面的要求做",
    "skillDes_182": "战斗开始时，在场地中央创造一个{level_based}码的破魔领域，进入领域的敌方怪兽每{p1}秒被清除一个持续时间最长的增益效果，{owner}死亡时领域消失",
    "messageInitNick_6841": "复仇乞丐",
    "skillDes_187": "战斗开始时，所有己方怪兽进入庇护状态（获得{owner}攻击力×{level_based}%的生物屏障），持续至{owner}死亡",
    "messageInitNick_6842": "勇敢牛牛",
    "skillDes_188": "每{level_based}秒触发奇迹，所有己方怪兽追溯{p1}秒前的血量，如果高于当前血量，血量变为{p1}秒前的血量",
    "messageInitNick_6843": "戒网大师",
    "skillDes_185": "触发投隙时，攻击力最高的己方远程怪兽获得{owner}攻击力×{level_based}%护盾，持续{p1}秒",
    "messageInitNick_6844": "大哥起早了",
    "skillDes_186": "触发投隙时，击退血量最高的敌方怪兽{p1}码，移动速度变为0，攻击力降低{level_based}%，持续{p2}秒",
    "randomEventDialogueGroupConfig_56.20": "甩开",
    "skillDes_189": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对所有敌方怪兽造成攻击力×{level_based}%的伤害，且造成封印效果，持续{p1}秒",
    "messageInitNick_6840": "刹那嗟砣",
    "randomEventDialogueGroupConfig_56.21": "任务到此为止，桐仁想通过自己悬赏自己的方法逃避干活的计划告终。",
    "messageInitNick_6849": "冰箱少年",
    "messageInitNick_6845": "吃饭前线",
    "messageInitNick_6846": "轰炸厕所",
    "messageInitNick_6847": "欲望在挣扎",
    "messageInitNick_6848": "怪味橘子猫",
    "skillDes_172": "{owner}血量低于{level_based}%时，进入连锁状态（天雷会额外攻击血量最少的敌方怪兽）",
    "skillDes_173": "连锁状态会使受到的近战伤害降低{level_based}%，对远程怪兽的伤害提升{p1}%",
    "skillDes_170": "死亡时造成攻击力×{level_based}%的区域伤害（{p1}码），会直接扣减受到该伤害的怪兽现有增益效果{p2}%的剩余持续时间",
    "skillDes_171": "天雷会直接扣减敌方怪兽现有增益效果{level_based}%的剩余持续时间",
    "messageInitNick_6830": "老板没有假期",
    "skillDes_176": "触发巽时，召唤流星从天而降，对血量最少的敌方怪兽造成攻击力×{level_based}%的伤害",
    "messageInitNick_6831": "素春卷",
    "skillDes_177": "巽·闪耀会使敌方怪兽射程下降{level_based}%，持续{p1}秒",
    "messageInitNick_6832": "我爱工作",
    "skillDes_174": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，获得偏移效果，持续{p1}秒，且回复攻击力×{level_based}%的血量",
    "messageInitNick_6833": "爱已搁浅",
    "skillDes_175": "受到致死的伤害时不会死亡，且回复攻击力×{level_based}%的血量，冷却时间{p1}秒",
    "skillDes_178": "触发巽时，血量回复效果提升{level_based}%，且获得{p1}%的反伤效果，持续{p2}秒",
    "randomEventDialogueGroupConfig_56.10": "你突然瞄到桐仁的身影在那边的小巷闪过。",
    "skillDes_179": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{p1}%的伤害，受到该伤害的怪兽霸气降低{level_based}%，持续{p2}秒",
    "messageInitNick_6838": "空山新雨",
    "messageInitNick_6839": "菠萝爱好者",
    "messageInitNick_6834": "等不来樱花雨",
    "messageInitNick_6835": "无敌吃瓜神",
    "messageInitNick_6836": "和脑子捉迷藏",
    "messageInitNick_6837": "漂流日记",
    "22_dish233445": "勇者转生果酱",
    "messageInitContent_4263": "换都可以换",
    "messageInitContent_4264": "这边请",
    "messageInitNick_6820": "六十岁了",
    "messageInitContent_4265": "需要带路吗",
    "messageInitNick_6821": "吃瓜公主",
    "messageInitContent_4266": "什么都会干",
    "messageInitNick_6822": "傲娇怪",
    "messageInitContent_4267": "多重影分身之术",
    "randomEventDialogueGroupConfig_12.317": "继续离开",
    "messageInitContent_4268": "分身大法好",
    "randomEventDialogueGroupConfig_12.316": "捡起",
    "messageInitContent_4269": "前排出售星刃串串",
    "randomEventDialogueGroupConfig_12.319": "继续躺着",
    "randomEventDialogueGroupConfig_12.318": "它滚回到了你的身边。",
    "messageInitNick_6827": "明明很可爱",
    "randomEventDialogueGroupConfig_12.313": "它非常享受的样子，甚至舒服到睡着了。",
    "messageInitNick_6828": "公路小子",
    "randomEventDialogueGroupConfig_12.312": "果然天下没有免费的午餐。",
    "messageInitNick_6829": "下年退役",
    "randomEventDialogueGroupConfig_12.315": "离开的时候踩到了什么。",
    "randomEventDialogueGroupConfig_12.314": "安静离开",
    "messageInitNick_6823": "独揽清风醉",
    "messageInitContent_4260": "带终身保修业务",
    "messageInitNick_6824": "绝命小红帽",
    "messageInitContent_4261": "从出门到那啥",
    "messageInitNick_6825": "波板糖",
    "randomEventDialogueGroupConfig_12.311": "离开",
    "messageInitContent_4262": "出售幼体标识",
    "messageInitNick_6826": "燕回",
    "randomEventDialogueGroupConfig_12.310": "神秘商人在地上躺着撒泼打滚无能狂怒。",
    "messageInitContent_4274": "爱过",
    "messageInitContent_4275": "上过",
    "messageInitContent_4276": "下锅",
    "messageInitNick_6810": "纯情糖果",
    "messageInitContent_4277": "跃迁兽手上的葱",
    "messageInitNick_6811": "欧气爆棚",
    "messageInitContent_4278": "哪里有濒危植物",
    "randomEventDialogueGroupConfig_12.328": "你占我位置了。",
    "messageInitContent_4279": "寸草不生",
    "randomEventDialogueGroupConfig_12.327": "果然是这样的，我要跑了！",
    "randomEventDialogueGroupConfig_12.329": "说这就是你的目的",
    "messageInitNick_6816": "早上四点半",
    "randomEventDialogueGroupConfig_12.324": "它似乎躲着你似继续滚远。",
    "messageInitNick_6817": "撒娇是种艺术",
    "randomEventDialogueGroupConfig_12.323": "说它躺得不够平",
    "messageInitNick_6818": "土豆炒马铃薯",
    "randomEventDialogueGroupConfig_12.326": "离开",
    "messageInitNick_6819": "臭鸭蛋",
    "randomEventDialogueGroupConfig_12.325": "继续跟着滚过去",
    "messageInitContent_4270": "真身在哪里",
    "messageInitNick_6812": "嫉妒使猫蒙蔽",
    "randomEventDialogueGroupConfig_12.320": "离开",
    "messageInitContent_4271": "说不定只是兄弟",
    "messageInitNick_6813": "雨伞先锋",
    "messageInitContent_4272": "路过",
    "messageInitNick_6814": "便当大师",
    "randomEventDialogueGroupConfig_12.322": "肯定",
    "messageInitContent_4273": "水过",
    "messageInitNick_6815": "唇齿间的故事",
    "randomEventDialogueGroupConfig_12.321": "你也是累了吗？",
    "messageInitNick_6809": "闪耀苹果",
    "messageInitContent_4285": "挖矿（物理）",
    "messageInitContent_4286": "专业",
    "messageInitContent_4287": "砍了之后能装上吗？",
    "messageInitContent_4288": "只负责砍不负责装是吧",
    "messageInitNick_6800": "夜空一样温柔",
    "messageInitContent_4289": "好大的砍刀",
    "randomEventDialogueGroupConfig_12.339": "不再指导离开",
    "randomEventDialogueGroupConfig_12.338": "让它说详细点",
    "messageInitNick_6805": "望远镜照镜子",
    "randomEventDialogueGroupConfig_12.335": "否认",
    "messageInitNick_6806": "及时雨",
    "randomEventDialogueGroupConfig_12.334": "能不能别跟过来，你肯定是来催我干活的坏蛋！",
    "messageInitNick_6807": "姜魔法师",
    "randomEventDialogueGroupConfig_12.337": "因为我还在挣扎。",
    "messageInitContent_4280": "还有它头顶的",
    "messageInitNick_6808": "冠萼花楸",
    "randomEventDialogueGroupConfig_12.336": "肯定",
    "messageInitContent_4281": "什么怪兽植物培育技术",
    "messageInitNick_6801": "九点的凉茶",
    "randomEventDialogueGroupConfig_12.331": "那你来干嘛的？",
    "messageInitContent_4282": "专斩网线",
    "messageInitNick_6802": "旧日的约定",
    "randomEventDialogueGroupConfig_12.330": "起身让开",
    "messageInitContent_4283": "网线死神？",
    "messageInitNick_6803": "娇美的杏子",
    "randomEventDialogueGroupConfig_12.333": "沉默",
    "messageInitContent_4284": "一起去挖比特币",
    "messageInitNick_6804": "心动电量过低",
    "randomEventDialogueGroupConfig_12.332": "表示喜欢滚动",
    "randomEventDialogueGroupConfig_12.340": "那你好好休息，咱们互不打扰。",
    "messageInitContent_4296": "空壳才需要抓捕灵魂",
    "messageInitContent_4297": "暗示",
    "messageInitContent_4298": "草丛换头科技",
    "messageInitContent_4299": "人造草丛",
    "randomEventDialogueGroupConfig_12.349": "滚开",
    "randomEventDialogueGroupConfig_12.346": "离开",
    "randomEventDialogueGroupConfig_12.345": "它躺了回去，并向你道谢。",
    "messageInitContent_4290": "听说砍掉**还可以还债哦",
    "randomEventDialogueGroupConfig_12.348": "拒绝滚开",
    "messageInitContent_4291": "离谱",
    "randomEventDialogueGroupConfig_12.347": "那还真不巧，我喜欢躺着。你滚那边吧。",
    "messageInitContent_4292": "又是成双成对",
    "randomEventDialogueGroupConfig_12.342": "起身离开",
    "messageInitContent_4293": "马萨卡",
    "randomEventDialogueGroupConfig_12.341": "躺着",
    "messageInitContent_4294": "难道说",
    "randomEventDialogueGroupConfig_12.344": "躺着",
    "messageInitContent_4295": "这里还有灵魂吗",
    "randomEventDialogueGroupConfig_12.343": "我只是随便找个地方躺着而已，让给你好了。",
    "randomEventDialogueGroupConfig_12.309": "在原来的位置继续",
    "randomEventDialogueGroupConfig_12.306": "起身离开",
    "randomEventDialogueGroupConfig_12.305": "继续躺着",
    "randomEventDialogueGroupConfig_12.308": "停手",
    "randomEventDialogueGroupConfig_12.307": "“都说是那里了，听不懂吗！”",
    "randomEventDialogueGroupConfig_12.302": "继续原来的位置",
    "randomEventDialogueGroupConfig_12.301": "然后是这里这里，躺太久了那里也特别酸！",
    "randomEventDialogueGroupConfig_12.304": "它看了你一眼，就这样静静地躺着。",
    "randomEventDialogueGroupConfig_12.303": "换成它指的位置",
    "randomEventDialogueGroupConfig_12.300": "滚到其他地方",
    "randomEventDialogueGroupConfig_12.393": "唉，连躺平界也在卷，这个世界怎么哪里都有比较，卷不动了！溜了溜了~",
    "randomEventDialogueGroupConfig_12.392": "离开",
    "randomEventDialogueGroupConfig_12.395": "躺了一段时间，地面突然震动起来。",
    "randomEventDialogueGroupConfig_12.394": "告别",
    "randomEventDialogueGroupConfig_12.391": "尽头似乎不愿被你继续窥探。#前方的树干挡住了你的去路，你停了下来。",
    "randomEventDialogueGroupConfig_12.390": "满意离开",
    "messageInitContent_6835": "无端联想",
    "messageInitContent_6834": "你在想什么",
    "messageInitContent_6837": "大礼",
    "messageInitContent_6836": "行吧",
    "messageInitContent_6839": "赤色狂潮",
    "messageInitContent_6838": "赤潮牌打码",
    "messageInitContent_6840": "唯一不朽",
    "messageInitContent_6842": "赢",
    "messageInitContent_6841": "可抗",
    "messageInitContent_6844": "别皮",
    "messageInitContent_6843": "这皮匠用什么皮做的",
    "randomEventDialogueGroupConfig_12.397": "全拿走",
    "randomEventDialogueGroupConfig_12.396": "是一件看起来不错的东西和厚厚的一沓树叶，从上面的图形大概能看出是对神秘商人的一些要求。",
    "randomEventDialogueGroupConfig_12.399": "追",
    "randomEventDialogueGroupConfig_12.398": "它慌忙起来正在疯狂跑远。",
    "messageInitContent_6846": "贴贴",
    "messageInitContent_6845": "空蝉和海漩那个有点像",
    "messageInitContent_6848": "你们先打完",
    "messageInitContent_6847": "蝴蝶效应？",
    "messageInitContent_6849": "火神在此",
    "messageInitContent_6851": "……",
    "messageInitContent_6850": "啊",
    "messageInitContent_6853": "你们发现了吗风的方向是不一样的",
    "messageInitContent_6852": "别打啦别打啦你们",
    "messageInitContent_6855": "这都被你发现了",
    "messageInitContent_6854": "这都被你编出来了",
    "messageInitContent_6857": "谁没有角",
    "messageInitContent_6856": "什么东东",
    "messageInitContent_6859": "开饭啦",
    "messageInitContent_6858": "看我无穷小蛋蛋",
    "messageInitContent_6860": "白色切割者",
    "messageInitContent_6862": "再打一关",
    "messageInitContent_4200": "勇",
    "messageInitContent_6861": "完全没在怕",
    "messageInitContent_4201": "我曾经说过",
    "messageInitContent_6864": "和沸体贴贴",
    "messageInitContent_4202": "人少那边",
    "messageInitContent_6863": "就差一个主角了",
    "messageInitContent_4203": "怪多那边",
    "messageInitContent_6866": "蜃兽背后的是什么？",
    "messageInitContent_4204": "新世界我来又又来了！",
    "messageInitContent_6865": "这是哪里",
    "messageInitContent_4205": "迎面而来的是两只幼尸",
    "messageInitContent_6868": "建议过个理智检定",
    "messageInitContent_4206": "全息投影吗？",
    "messageInitContent_6867": "该不会是……",
    "messageInitContent_4207": "幼幼幼，嘞~喂~check it out",
    "messageInitContent_4208": "吃我喷射奶嘴",
    "messageInitContent_6869": "神秘盾！",
    "messageInitContent_4209": "尸族领地？",
    "messageInitContent_6871": "传说中的典籍就藏在这里吗",
    "messageInitContent_6870": "少了不朽怪兽",
    "messageInitContent_4210": "幼尸小心后面的腐实者",
    "messageInitContent_6873": "叉叉领队",
    "messageInitContent_4211": "什么鼻涕是挂件？",
    "messageInitContent_6872": "这。。",
    "messageInitContent_4212": "赛博尸族？",
    "messageInitContent_6875": "地龙看到了什么",
    "messageInitContent_4213": "快回去找妈妈别在这闲逛",
    "messageInitContent_6874": "地龙押后",
    "messageInitContent_4214": "狂潮形态？",
    "messageInitContent_6877": "摸鱼时间~",
    "messageInitContent_4215": "漆黑组件据点",
    "messageInitContent_6876": "完全没在怕",
    "randomEventDialogueGroupConfig_12.351": "什么活我都不干，你别过来啊！",
    "randomEventDialogueGroupConfig_12.350": "行！那我走。",
    "themeCardPackName_18030": "观察",
    "messageInitContent_4216": "我要在这关住下！",
    "messageInitContent_6879": "墙好高",
    "messageInitContent_4217": "前方新领地",
    "messageInitContent_6878": "小桐仁找到你了",
    "messageInitContent_4218": "是被狂潮形态控制的节点‘",
    "messageInitContent_4219": "卖面包的小怪兽",
    "themeCardPackName_18035": "爆发",
    "messageInitContent_6882": "中午#￥%好3！&*（）*……&（）",
    "messageInitContent_4220": "你的面包车呢",
    "messageInitContent_6881": "乖乖让开",
    "messageInitContent_4221": "全息小怪",
    "messageInitContent_6884": "听说kb这次当主角了",
    "messageInitContent_4222": "这里有面包炸弹",
    "messageInitContent_6883": "时代的痕迹",
    "messageInitContent_4223": "boom！",
    "messageInitContent_6886": "老树和小键盘",
    "messageInitContent_4224": "Boom！Boom！",
    "messageInitContent_6885": "这只疯了吗",
    "messageInitContent_4225": "恭喜你，今天还活着",
    "messageInitContent_6888": "嗯？",
    "messageInitContent_4226": "医生的兄弟",
    "messageInitContent_6887": "再打一关就睡",
    "randomEventDialogueGroupConfig_12.357": "难道就没有比躺着更重要的事情了？",
    "randomEventDialogueGroupConfig_12.356": "就躺着",
    "randomEventDialogueGroupConfig_12.359": "仔细想想？",
    "randomEventDialogueGroupConfig_12.358": "还真没有",
    "randomEventDialogueGroupConfig_12.353": "时间一点点地过去了。",
    "randomEventDialogueGroupConfig_12.352": "答应离开",
    "messageInitContent_6880": "4小只",
    "randomEventDialogueGroupConfig_12.355": "时间依旧在流逝，或许该干点什么别的了？",
    "randomEventDialogueGroupConfig_12.354": "继续躺着",
    "randomEventDialogueGroupConfig_12.360": "想想",
    "randomEventDialogueGroupConfig_12.362": "想到了吗？",
    "themeCardPackName_18020": "焦点",
    "randomEventDialogueGroupConfig_12.361": "不想并离开",
    "messageInitContent_4227": "极品鸭头杖+2",
    "messageInitContent_4228": "基佬紫世界",
    "messageInitContent_6889": "谁在那边",
    "messageInitContent_4229": "下关见",
    "themeCardPackName_18025": "潜伏",
    "messageInitContent_4230": "重病把守肉肉",
    "messageInitContent_6893": "我看到了很多双眼睛",
    "messageInitContent_4231": "救命记不住种族",
    "messageInitContent_6892": "饿了",
    "messageInitContent_4232": "无限地带572",
    "messageInitContent_6895": "我只是个#￥%",
    "messageInitContent_4233": "很好奇那个发光的位置",
    "messageInitContent_6894": "你是说那战墙",
    "messageInitContent_4234": "你说什么发光？？？",
    "messageInitContent_6897": "那是什么",
    "messageInitContent_4235": "建议美杜莎莎装上幽鬼的手",
    "messageInitContent_6896": "无法理解",
    "messageInitContent_4236": "get不到",
    "messageInitContent_6899": "这是海底还是海面",
    "messageInitContent_4237": "同一个Tony老师出来的",
    "messageInitContent_6898": "一堆aoe",
    "randomEventDialogueGroupConfig_12.368": "时间拐了个弯，来到了你还没有遇到神秘商人之前。",
    "randomEventDialogueGroupConfig_12.367": "不想了",
    "randomEventDialogueGroupConfig_12.369": "发生什么了",
    "godConfigName_6": "天马",
    "randomEventDialogueGroupConfig_12.364": "有",
    "godConfigName_7": "幻象",
    "randomEventDialogueGroupConfig_12.363": "没有",
    "messageInitContent_6891": "别装",
    "randomEventDialogueGroupConfig_12.366": "好好想想",
    "messageInitContent_6890": "那是什么声音",
    "randomEventDialogueGroupConfig_12.365": "再好好想想？",
    "randomEventDialogueGroupConfig_12.371": "继续滚",
    "randomEventDialogueGroupConfig_12.370": "滚动的前方是各种颠倒的景色。",
    "randomEventDialogueGroupConfig_12.373": "滚动的途中是各种奇怪的气味。",
    "randomEventDialogueGroupConfig_12.372": "不滚了",
    "messageInitContent_4238": "我蛇恐",
    "messageInitContent_4239": "头发会发光",
    "messageInitContent_4241": "你的网线掉了先生",
    "messageInitContent_4242": "你的脑机接口没插好先生",
    "messageInitContent_4243": "怎么把舌头改造到肚子上了",
    "messageInitContent_4244": "这边建议脸再整整",
    "messageInitContent_4245": "饿了",
    "messageInitContent_4246": "两只王霸两只王霸",
    "messageInitContent_4247": "跑得快跑得快",
    "messageInitContent_4248": "招募打手",
    "randomEventDialogueGroupConfig_12.379": "莫名其妙。",
    "randomEventDialogueGroupConfig_12.378": "不滚了",
    "randomEventDialogueGroupConfig_12.375": "不滚了",
    "randomEventDialogueGroupConfig_12.374": "继续滚",
    "randomEventDialogueGroupConfig_12.377": "继续滚",
    "messageInitContent_4240": "先生，看看我嘛（",
    "randomEventDialogueGroupConfig_12.376": "滚动的尽头会是……#尽头会是一座平平无奇的山谷，还是世界的尽头呢？",
    "randomEventDialogueGroupConfig_12.382": "甘拜下风离开",
    "randomEventDialogueGroupConfig_12.381": "以龙形云卷滚身法跟上",
    "randomEventDialogueGroupConfig_12.384": "使出虎躯一震滚法跟上",
    "randomEventDialogueGroupConfig_12.383": "它以一个兔形闪击身法再次超前。",
    "themeCardPackName_18040": "恶童",
    "randomEventDialogueGroupConfig_12.380": "它以一个蛇形狂滚身法甩开了你。",
    "messageInitContent_4249": "什么义体搬运工",
    "8_1": "活动",
    "8_2": "商店",
    "8_3": "领地",
    "8_4": "事件",
    "8_5": "怪兽",
    "8_6": "神灵",
    "8_7": "世界回响",
    "messageInitContent_4252": "看路",
    "8_8": "背包",
    "messageInitContent_4253": "老板和员工",
    "8_9": "切换至狩猎模式会解除保护状态且每小时获得{1}狩猎勋章",
    "messageInitContent_4254": "员工都是保镖",
    "messageInitContent_4255": "下一位",
    "messageInitContent_4256": "来啦",
    "messageInitContent_4257": "高级代步工具",
    "messageInitContent_4258": "回收机械内脏",
    "messageInitContent_4259": "买马吗",
    "randomEventDialogueGroupConfig_12.389": "行了行了，你赢了。滚地界第一的称号让给你了。",
    "randomEventDialogueGroupConfig_12.386": "它使出金牛冲撞滚法拉开距离。",
    "randomEventDialogueGroupConfig_12.385": "甘拜下风离开",
    "messageInitContent_4250": "分身？",
    "randomEventDialogueGroupConfig_12.388": "离开",
    "messageInitContent_4251": "这里不卖烟花",
    "randomEventDialogueGroupConfig_12.387": "使出硕鼠全力滚跟上",
    "skillDes_202": "敌方怪兽死亡时，{owner}提升死亡怪兽攻击力×{level_based}%的攻击力，持续{p1}秒，最多叠{p2}次，叠加时刷新持续时间，最大攻击力提升为{owner}的攻击力×{p3}%",
    "skillDes_203": "{owner}血量低于{p1}%时，进入轮回状态（攻击力提升{level_based}%，每{p2}秒回复攻击力×{p3}%的血量），持续{p4}秒，每{p5}秒最多触发{p6}次",
    "skillDes_200": "煞会使范围内的己方近战怪兽造成伤害的{level_based}%用于回复自身血量，持续{p1}秒",
    "skillDes_201": "煞会使范围内的敌方远程怪兽血量回复效果降低{level_based}%，且造成封印效果，持续{p1}秒",
    "skillDes_206": "{owner}血量低于{p1}%时，逆刃会使敌方怪兽血量上限降低{level_based}%，最大血量上限降低为{owner}的最大血量×{p2}%，持续{p3}秒",
    "skillDes_207": "{owner}血量低于{p1}%时，逆刃的伤害提升{level_based}%",
    "skillDes_204": "战斗开始时，{owner}获得{level_based}%的近战真实反伤效果，持续至{owner}死亡",
    "skillDes_205": "{owner}血量低于{p1}%时，逆刃会使敌方怪兽霸气降低{level_based}%，持续{p2}秒",
    "skillDes_208": "{owner}受到致死的伤害时所有己方近战怪兽进入回光状态（免疫/清除所有负面效果且不会死亡），持续{level_based}秒，每{p1}秒最多触发{p2}次",
    "skillDes_209": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，偷取血量最高和第二高的敌方怪兽当前血量的{level_based}%",
    "messageInitNick_4199": "令人智熄",
    "messageInitNick_4198": "认证画饼专家",
    "messageInitNick_4197": "火龙果消灭者",
    "messageInitNick_4192": "吃饭从不留名",
    "messageInitNick_4191": "核动力扫地机",
    "messageInitNick_4190": "机械鸭子",
    "messageInitNick_4196": "认证补刀专家",
    "messageInitNick_4195": "胫骨",
    "messageInitNick_4194": "最爱豆角",
    "messageInitNick_4193": "小委屈我能忍",
    "messageInitNick_4189": "谢幕",
    "messageInitNick_4188": "养只闲猫",
    "messageInitNick_4187": "格子控先生",
    "messageInitNick_4186": "熬夜王",
    "messageInitContent_6909": "鸭头魔杖！",
    "messageInitContent_6908": "惹",
    "messageInitContent_6901": "又饿了",
    "messageInitNick_4181": "半杯奶茶",
    "messageInitContent_6900": "你听到它的呼唤了吗",
    "messageInitNick_4180": "波动之诗",
    "messageInitContent_6903": "████████████",
    "messageInitContent_6902": "什么呼*）#唤？",
    "messageInitContent_6905": "你背后",
    "messageInitNick_4185": "营养快线",
    "messageInitContent_6904": "疯狂深呼吸",
    "messageInitNick_4184": "跟在小兵后面",
    "messageInitContent_6907": "怪怪de",
    "messageInitNick_4183": "葡萄柚先锋",
    "messageInitContent_6906": "问题不大",
    "messageInitNick_4182": "我想静静",
    "darkForestAbilityConfigDescription_1": "怪兽攻击力提升{?}",
    "messageInitNick_4178": "流浪的发型师",
    "messageInitNick_4177": "说了无坑",
    "darkForestAbilityConfigDescription_3": "怪兽真实伤害提升{?}",
    "messageInitNick_4176": "发达的牛",
    "darkForestAbilityConfigDescription_2": "怪兽体力提升{?}",
    "messageInitNick_4175": "最硬的腊肠",
    "messageInitContent_6910": "你听到它的呼唤了吗",
    "messageInitNick_4179": "石榴爱好者",
    "darkForestAbilityConfigDescription_9": "怪兽攻击力提升{?}%",
    "darkForestAbilityConfigDescription_8": "远程怪兽射程提升{?}%",
    "darkForestAbilityConfigDescription_5": "近战怪兽体型增大{?}%",
    "darkForestAbilityConfigDescription_4": "怪兽生物屏障提升{?}",
    "darkForestAbilityConfigDescription_7": "近战怪兽移动速度提升{?}%",
    "darkForestAbilityConfigDescription_6": "远程怪兽体型缩小{?}%",
    "messageInitContent_6919": "每天要用很多唇膏吧",
    "messageInitContent_6912": "啊制杖",
    "messageInitNick_4170": "早上吃泡芙",
    "propConfigDes_90403": "收集30块绿色真实伤害元核碎片可以合成绿色品质真实伤害元核。",
    "messageInitContent_6911": "这是干嘛",
    "propConfigDes_90404": "收集30块蓝色真实伤害元核碎片可以合成蓝色品质真实伤害元核。",
    "messageInitContent_6914": "桐仁梦见御空了吗",
    "messageInitContent_6913": "仁逢喜事精神爽",
    "propConfigDes_90402": "收集30块白色真实伤害元核碎片可以合成白色品质真实伤害元核。",
    "messageInitContent_6916": "幻想会醒的",
    "messageInitNick_4174": "红线割断者",
    "messageInitContent_6915": "████████████",
    "messageInitNick_4173": "肥皂盒毁灭者",
    "messageInitContent_6918": "怎么又是桐仁",
    "messageInitNick_4172": "摘下星星给你",
    "messageInitContent_6917": "next",
    "messageInitNick_4171": "村里第一帅",
    "messageInitNick_4167": "蒜兽",
    "skillDes_242": "{owner}血量低于{p1}%时，进入炸毛状态（移动速度变为0，霸气增加{level_based}%）",
    "messageInitNick_4166": "旺星人",
    "skillDes_243": "{owner}在炸毛状态下会创造一个拒绝区域（{p1}码），区域内的己方怪兽每秒回复{owner}最大血量×{p2}%的血量，敌方怪兽移动速度降低{level_based}%，越接近{owner}减速效果越强",
    "messageInitNick_4165": "过气的悲伤",
    "skillDes_240": "{owner}触碰墙边时，回复{p1}能量，冷却时间{level_based}秒",
    "messageInitNick_4164": "快乐武师",
    "skillDes_241": "{owner}血量低于{p1}%时，移动速度降低{p2}%，受到的近战伤害降低{level_based}%，且会向己方最后方的怪兽靠拢直至重合",
    "propConfigDes_90407": "收集30块红色真实伤害元核碎片可以合成红色品质真实伤害元核。",
    "skillDes_246": "创能会使敌方近战怪兽每次释放能量技时为{owner}回复{level_based}能量，持续{p1}秒",
    "skillDes_247": "触发创能时，{owner}附近（{p1}码）的己方怪兽回复{level_based}能量",
    "messageInitContent_6921": "下一关我来了",
    "messageInitNick_4169": "宅宅一堂",
    "propConfigDes_90405": "收集30块紫色真实伤害元核碎片可以合成紫色品质真实伤害元核。",
    "skillDes_244": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，{owner}进入蓄力状态（霸气，移动速度，攻击力和攻击速度变为0），蓄力完成后对最近的敌方怪兽造成攻击力×{level_based}%的范围真实伤害（{p2}码），离该怪兽越近，受到的伤害越高",
    "messageInitContent_6920": "哈？",
    "messageInitNick_4168": "无公害蒜苔",
    "propConfigDes_90406": "收集30块橙色真实伤害元核碎片可以合成橙色品质真实伤害元核。",
    "skillDes_245": "创能会使敌方怪兽受到的伤害提升{level_based}%，持续{p1}秒",
    "skillDes_248": "{owner}死亡时，附近（{p1}码）的己方怪兽回复{level_based}能量和{owner}攻击力×{p2}%的血量",
    "skillDes_249": "每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害",
    "messageInitContent_6923": "绕晕了",
    "messageInitContent_6922": "伤脑筋",
    "messageInitContent_6925": "谁？",
    "messageInitContent_6924": "发糖",
    "messageInitContent_6927": "这样不好吧",
    "messageInitNick_4163": "啊辣眼睛",
    "messageInitContent_6926": "别动！",
    "messageInitNick_4162": "天堂手表",
    "96_DailyTaskChest": "周活跃宝箱",
    "messageInitContent_6929": "策反溜溜",
    "messageInitNick_4161": "不再爱勒",
    "messageInitContent_6928": "溜溜溜溜了",
    "messageInitNick_4160": "三康中蛋",
    "messageInitNick_4156": "海倒过来是天",
    "skillDes_231": "敌方怪兽死亡时，光栅·溃散的击退距离增加{level_based}%，持续{p1}秒，最多叠加{p2}次，叠加时刷新持续时间",
    "messageInitNick_4155": "帮葡萄按摩",
    "skillDes_232": "触发光栅时，下次受到的伤害降低，降低值为{owner}攻击力×{level_based}%，持续{p1}秒",
    "messageInitNick_4154": "请注意措词",
    "messageInitNick_4153": "肉末蒸蛋",
    "skillDes_230": "光栅会击退敌方怪兽{level_based}码（目标是远程单位时击退距离×{p1}%），如果击退至触碰墙边，造成光囚攻击力×{p2}%的伤害，并清除所有增益效果",
    "messageInitContent_6930": "██",
    "skillDes_235": "蜃境领域拥有{owner}最大血量×{level_based}%的血量，进入领域的怪兽受到伤害时会先扣减蜃境领域的血量，蜃境领域血量为0时消失",
    "messageInitNick_4159": "争取第一",
    "skillDes_236": "触发蜃境时，{owner}受到的伤害降低{level_based}%，霸气增加{p1}%，持续{p2}秒，并且击退所有敌方怪兽{p3}码",
    "messageInitContent_6932": "不许熬夜",
    "messageInitNick_4158": "摩托骡拉",
    "skillDes_233": "触发光栅时，回复攻击力×{level_based}%的血量并反射下次受到的来自怪兽的负面效果（同时生效的多个负面效果均会被反射，被反射过的负面效果无法再次反射），持续{p1}秒",
    "messageInitContent_6931": "好的",
    "messageInitNick_4157": "保持幼稚",
    "skillDes_234": "每当敌方怪兽回复的血量总和达到{owner}最大血量×{p1}%时触发{name}，在己方最后方怪兽所在位置创造一个{p2}码的蜃境领域，进入领域的己方远程怪兽射程增加{level_based}%，持续{p3}秒，重复触发刷新蜃境领域血量，持续时间和位置",
    "skillDes_239": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成敌方攻击力×{level_based}%的伤害且造成眩晕效果（伤害，移动速度，攻击速度变为0)，持续{p1}秒，最大伤害为{owner}的攻击力×{p2}%",
    "skillDes_237": "触发蜃境时，在敌方最后方怪兽所在位置创造一个{p1}码的延迟领域，进入领域的敌方怪兽攻击速度降低{level_based}%，移动速度降低{p2}%，持续{p3}秒",
    "skillDes_238": "战斗开始时，马上触发一次蜃境，{owner}获得最大血量×{level_based}%的护盾",
    "messageInitContent_6934": "██",
    "messageInitContent_6933": "你好",
    "messageInitContent_6936": "快摸我！",
    "messageInitContent_6935": "你听到它的呼唤了吗",
    "messageInitContent_6938": "我007",
    "messageInitNick_4152": "别妄想泡我",
    "messageInitContent_6937": "好怪",
    "messageInitNick_4151": "打败孤独",
    "messageInitNick_4150": "冷静的传感器",
    "messageInitContent_6939": "都是福报",
    "messageInitNick_4145": "暧昧滚边去",
    "skillDes_220": "召唤神灵白虎时，{owner}普通攻击替换为本格攻击，对敌方怪兽造成攻击力×{level_based}%的伤害，且额外造成当前血量{p1}%的真实伤害，最大伤害为{owner}的攻击力×{p2}%，持续{p3}秒",
    "messageInitNick_4144": "天生抽象",
    "skillDes_221": "召唤神灵玄武时，{owner}免疫/清除所有负面效果，获得{level_based}%的真实反伤效果，持续{p1}秒",
    "messageInitNick_4143": "草莓味儿的狗",
    "messageInitNick_4142": "傲娇鬼",
    "messageInitContent_6941": "确实恐怖",
    "messageInitNick_4149": "冒险公主",
    "skillDes_224": "战斗开始时，{owner}绑定己方体型最大的近战怪兽（没有则不绑定），该怪兽进入逢弦状态（每秒回复{owner}最大血量×{level_based}%的血量）",
    "messageInitContent_6940": "你们给谁996",
    "messageInitNick_4148": "芹菜射手",
    "skillDes_225": "逢弦状态会使被绑定的怪兽血量低于{p1}%时，回复{owner}最大血量×{level_based}%的血量，冷却时间{p2}秒",
    "messageInitContent_6943": "怪兽恐怖故事",
    "messageInitNick_4147": "智能鱼露",
    "skillDes_222": "召唤神灵青龙时，{owner}被击退时忽视敌方霸气{p1}%，造成伤害的{level_based}%用于回复血量百分比最少的己方怪兽的血量，持续{p2}秒",
    "messageInitContent_6942": "怪兽24小时不休",
    "messageInitNick_4146": "庸俗又无趣",
    "skillDes_223": "召唤神灵麒麟时，{owner}会使敌方体型最大的怪兽受到的伤害提高{level_based}%，攻击力降低{p1}%，移动速度降低{p2}%，霸气降低{p3}%，血量回复效果降低{p4}%，并封印其技能，持续{p5}秒，该负面效果不能清除",
    "skillDes_228": "{owner}失去自身所拥有的宿命效果，被绑定的怪兽获得{owner}拥有的宿命效果（同类宿命效果高级覆盖低级），被绑定的怪兽死亡时，{owner}也会一同死亡，并使击破者受到的伤害增加{level_based}%，持续{p1}秒",
    "skillDes_229": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对最近的敌方怪兽造成攻击力×{p1}%的伤害（无弹道直接生效,目标是远程单位时会使其射程下降{level_based}%，持续{p2}秒）",
    "skillDes_226": "逢弦状态会使被绑定的怪兽血量低于{p1}%时，把对其制造伤害的远程怪兽拉向己方（{p2}码），冷却时间{level_based}秒",
    "skillDes_227": "敌方怪兽死亡时，逢弦状态会使被绑定的怪兽血量回复效果增加{level_based}%，且不会死亡，持续{p1}秒，冷却时间{p2}秒，每触发{p3}次冷却时间增加{p4}秒",
    "messageInitContent_6945": "你听到它的呼唤了吗",
    "messageInitContent_6944": "脑",
    "messageInitContent_6947": "天天早睡",
    "messageInitContent_6946": "██████████████████████████",
    "messageInitContent_6949": "古老的怪兽",
    "messageInitNick_4141": "染血修罗",
    "messageInitContent_6948": "工作升级",
    "messageInitNick_4140": "公爵夫人",
    "messageInitNick_4134": "淡蓝色的记忆",
    "messageInitNick_6797": "不爱舔毛的猫",
    "messageInitNick_4133": "流浪汉地球",
    "messageInitNick_6798": "高素质少女",
    "skillDes_210": "湮灭会使敌方怪兽体型缩小{level_based}%，持续{p1}秒",
    "messageInitContent_6950": "吃个月饼",
    "messageInitNick_4132": "温柔一刀",
    "messageInitNick_6799": "饺子女巫",
    "messageInitNick_4131": "强壮咕咕神",
    "messageInitContent_6952": "梦回上一层",
    "messageInitNick_4138": "帮榴莲道歉",
    "messageInitNick_6793": "明晚回欧洲",
    "skillDes_213": "每被治疗{p1}次，受到的伤害降低{level_based}%，持续{p2}秒，最多叠加{p3}次，叠加时刷新持续时间",
    "messageInitContent_6951": "你听到它的呼唤了吗",
    "messageInitNick_4137": "程序员煎饼",
    "messageInitNick_6794": "百变小怪",
    "skillDes_214": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害",
    "messageInitContent_6954": "祝福",
    "messageInitNick_4136": "渐化身影",
    "messageInitNick_6795": "腰椎",
    "skillDes_211": "获得湮灭·消失效果的怪兽死亡时，清除区域内（{level_based}码）敌方怪兽所有增益效果",
    "messageInitContent_6953": "表白我的爱",
    "messageInitNick_4135": "别在这理发店",
    "messageInitNick_6796": "我爱吃蛋挞",
    "skillDes_212": "{owner}受到的伤害不会超过自身最大血量的{level_based}%，冷却时间{p1}秒",
    "skillDes_217": "血量低于{p1}%时，受到的近战伤害变为加血，持续{level_based}秒，冷却时间{p2}秒",
    "skillDes_218": "蔑视区域内己方怪兽大于等于{p1}个时，{owner}进入解构状态（毁坏可清除敌方怪兽所有增益效果），持续{level_based}秒",
    "skillDes_215": "毁坏会使敌方怪兽死亡时触发的效果无法触发，持续{level_based}秒",
    "messageInitNick_4139": "空间支配者",
    "skillDes_216": "触发毁坏时，创造一个蔑视区域（{p1}码），区域内的己方近战怪兽免疫封印效果，持续{level_based}秒",
    "skillDes_219": "召唤神灵朱雀时，{owner}回复{level_based}%的最大血量，受到的伤害降低{p1}%，持续{p2}秒",
    "messageInitNick_6790": "梦开始的敌方",
    "messageInitNick_6791": "流浪的头状骨",
    "messageInitNick_6792": "糖醋里脊",
    "messageInitNick_4130": "表白失败",
    "skillDes_282": "赫觞的目标如果为敌方攻击力最高的怪兽，则额外造成（敌方攻击力+{owner}攻击力）×{level_based}%的范围伤害（{p1}码），最大伤害为{owner}的攻击力×{p2}%",
    "skillDes_283": "{owner}血量低于{p1}%时，进入腥风状态（受到的伤害不会超过自身最大血量的{p2}%，每{p3}秒击退敌方所有怪兽{level_based}码），持续{p4}秒，冷却时间{p5}秒",
    "skillDes_280": "赫觞会偷取血量高于{p1}%的敌方怪兽当前血量的{level_based}%",
    "skillDes_281": "赫觞会对血量低于{p1}%的敌方怪兽额外造成{owner}攻击力×{level_based}%的真实伤害",
    "messageInitNick_4123": "开启高冷状态",
    "messageInitNick_6786": "文化灌溉",
    "skillDes_286": "战斗开始时，{owner}绑定敌方血量最高的怪兽，每{p1}秒对其造成当前血量×{p2}%的伤害，最大伤害为{owner}的最大血量×{p3}%，且该怪兽回复血量时{owner}也会回复该回复量×{level_based}%的血量",
    "messageInitNick_4122": "划水少女",
    "messageInitNick_6787": "嘴角上翘",
    "skillDes_287": "{owner}被子弹击中时，能量回复效果提升{level_based}%，持续{p1}秒，最多叠加{p2}次",
    "messageInitNick_4121": "骑驴看星星",
    "messageInitNick_6788": "吃货王",
    "skillDes_284": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，回复最大血量×{level_based}%的血量",
    "messageInitNick_4120": "老鹿乱跳绳",
    "messageInitNick_6789": "淡紫色梦境",
    "skillDes_285": "触发惧渗时，会蒸发前方（{p1}码）敌方怪兽的子弹，并使敌方怪兽的霸气降低{level_based}%，持续{p2}秒",
    "messageInitNick_4127": "半颗心的暖",
    "messageInitNick_6782": "锈色花楸",
    "messageInitNick_4126": "此年仍旧",
    "messageInitNick_6783": "金线蔷薇",
    "messageInitNick_4125": "腹黑观察员",
    "messageInitNick_6784": "冬日傲娇菊",
    "skillDes_288": "{owner}被子弹击中时会将其蒸发，且对子弹所属怪兽造成封印效果，持续{level_based}秒，冷却时间{p1}秒",
    "messageInitNick_4124": "一剪梅",
    "messageInitNick_6785": "超级肉丸",
    "skillDes_289": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的范围伤害（{p1}码），冷却时间{p2}秒，敌方怪兽死亡时，冷却时间降低{p3}秒，最低可降至0.1秒",
    "messageInitNick_4129": "老魔仙",
    "messageInitNick_4128": "空想家",
    "messageInitNick_6780": "翅膀硬了",
    "messageInitNick_6781": "倒吸一口凉皮",
    "skillDes_271": "{owner}触碰墙边或沸涌使敌方怪兽触碰墙边时，会使所有己方怪兽的增益效果不可清除，能量回复效果提升{level_based}%，持续{p1}秒，冷却时间{p2}秒",
    "skillDes_272": "{owner}触碰墙边或沸涌使敌方怪兽触碰墙边时，会使所有敌方怪兽进入崩坏状态（攻击力和移动速度变为0，触碰战墙时会受到{owner}攻击力×{p1}%的伤害，崩坏状态消失)，持续{level_based}秒，冷却时间{p2}秒",
    "skillDes_270": "{owner}触碰墙边或沸涌使敌方怪兽触碰墙边时，会使攻击力最高的敌方近战怪兽移动速度变为0，持续{p1}秒，攻击力最高的敌方远程怪兽攻击速度降低{level_based}%，持续{p2}秒，冷却时间{p3}秒",
    "messageInitNick_4112": "傲娇小可爱",
    "messageInitNick_6775": "最爱菠菜",
    "skillDes_275": "触发炎魔时，创造一个祭炎·领域（{p1}码），进入领域的敌方怪兽每{p2}秒受到{owner}攻击力×{p3}%的伤害，持续{level_based}秒，最多同时存在{p4}个祭炎·领域（到达上限时触发将清除持续时间最短的祭炎·领域），冷却时间{p5}秒",
    "messageInitNick_4111": "甜蜜的李子",
    "messageInitNick_6776": "超级布丁",
    "skillDes_276": "{owner}死亡时，在场地中央创造{p1}个并排的祭炎·领域，持续{level_based}秒",
    "messageInitNick_4110": "模拟编码器",
    "messageInitNick_6777": "大脑断电",
    "skillDes_273": "{owner}累计移动距离到达{p1}码时，进入极巨化状态（生物屏障提升{level_based}%，体型增大{p2}%），持续{p3}秒，冷却时间{p4}秒，每触发1次冷却时间增加{p5}秒",
    "messageInitNick_6778": "叫我小透明",
    "skillDes_274": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害",
    "messageInitNick_4116": "黑匣子",
    "messageInitNick_6771": "迷路的粉底液",
    "skillDes_279": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成敌方攻击力×{level_based}%的伤害且使体型缩小{p1}%，持续{p2}秒",
    "messageInitNick_4115": "命运的力量",
    "messageInitNick_6772": "我有异议",
    "messageInitNick_4114": "智能冰糖",
    "messageInitNick_6773": "记忆格式化",
    "skillDes_277": "祭炎·领域造成伤害时会使敌方怪兽血量回复效果降低{level_based}%，持续{p1}秒",
    "messageInitNick_4113": "钢枪老太婆",
    "messageInitNick_6774": "约定的饮料",
    "skillDes_278": "受到致死的伤害时，如果存在自己创造的祭炎·领域，清除其中持续时间最短的祭炎·领域，{p1}秒内不会死亡，获得攻击力×{level_based}%的护盾和{p2}%的反伤效果，持续{p3}秒，每场战斗最多触发{p4}次",
    "messageInitNick_4119": "无敌潜水神",
    "messageInitNick_4118": "美好的世界",
    "messageInitNick_4117": "能回滚一下吗",
    "messageInitNick_6779": "尖叫柿子",
    "messageInitNick_6770": "爱上了她",
    "skillDes_260": "对祖龙族怪兽进行拟态后，{owner}每{p1}秒对最近的敌方怪兽造成攻击力×{level_based}%的范围伤害（{p2}码），持续{p3}秒",
    "skillDes_261": "对尸鬼族怪兽进行拟态后，{owner}每{p1}秒对最近的敌方怪兽造成攻击力×{level_based}%的伤害，且偷取其当前血量的{p2}%，持续{p3}秒",
    "messageInitNick_4101": "铁打的滑滑蛋",
    "messageInitNick_6764": "呀嘞呀嘞",
    "skillDes_264": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，为所有己方怪兽回复{owner}最大血量×{level_based}%的血量",
    "messageInitNick_4100": "别抢我养的猪",
    "messageInitNick_6765": "尬聊门传人",
    "skillDes_265": "触发森荧时，创造一个枯萎区域（{p1}码），区域内的敌方怪兽攻击力降低{level_based}%，真实伤害降低{p2}%，移动速度降低{p3}%，枯萎区域持续{p4}秒",
    "messageInitNick_6766": "霸天苍龙",
    "skillDes_262": "对星灵族怪兽进行拟态后，{owner}每{p1}秒对最近的敌方怪兽造成攻击力×{level_based}%的伤害，且击退{p2}码，持续{p3}秒",
    "messageInitNick_6767": "得瑟小姐",
    "skillDes_263": "对木偶族怪兽进行拟态后，{owner}每{p1}秒对最近的敌方怪兽造成攻击力×{level_based}%的伤害，且造成{p2}秒封印效果，持续{p3}秒",
    "messageInitNick_4105": "六月初夏",
    "messageInitNick_6760": "绝版丫头",
    "skillDes_268": "{owner}受到致死的伤害时不会死亡，转化为魔树状态，不会受场上任何效果影响（与神灵类似），每秒回复{p1}能量，拥有100能量时立刻发动森荧，持续{level_based}秒或持续至所有己方怪兽死亡时立刻死亡，无法重生",
    "messageInitNick_4104": "餐厅魔法师",
    "messageInitNick_6761": "纯净的纯净水",
    "skillDes_269": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，回复最大血量×{level_based}%的血量，对敌方怪兽造成攻击力×{p1}%的伤害，且击退{p2}码",
    "messageInitNick_4103": "馋猫",
    "messageInitNick_6762": "错银铜牛灯",
    "skillDes_266": "触发森荧时，所有己方怪兽获得魔种I/II/III/IV共4个增益效果，分别使怪兽的攻击力提升{level_based}%，霸气提升{p1}%，血量回复效果提升{p2}%，受到的伤害降低{p3}%，持续{p4}秒",
    "messageInitNick_4102": "搬砖先驱",
    "messageInitNick_6763": "地铁卡忘带了",
    "skillDes_267": "魔种I/II/III/IV任意1个效果被怪兽清除时，清除者受到{owner}最大血量×{level_based}%的真实伤害，被清除者获得{owner}最大血量×{p1}%的护盾，持续{p2}秒",
    "messageInitNick_4109": "纯白的鸽子",
    "messageInitNick_4108": "黑暗中漫舞",
    "messageInitNick_4107": "干净像风",
    "messageInitNick_4106": "小石头一枚",
    "messageInitNick_6768": "流浪的头盖骨",
    "messageInitNick_6769": "大明湖畔的谁",
    "skillDes_250": "横刀会使敌方怪兽的生物屏障降低{level_based}%，持续{p1}秒",
    "messageInitNick_6753": "蟹妖的腰",
    "skillDes_253": "{owner}进入战斗后每{p1}秒会进行{p2}秒倒数，倒数完毕后，对前方（{p3}码）的敌方怪兽造成攻击力×{level_based}%的伤害，且扣减{p4}能量（不可扣减至负数）",
    "messageInitNick_6754": "独钓一江水",
    "skillDes_254": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，获得偏移效果，并转变为二维状态，持续{level_based}秒",
    "messageInitNick_6755": "跳时钟",
    "skillDes_251": "{owner}血量低于{p1}%时，获得攻击×{level_based}%的护盾，冷却时间{p2}秒",
    "messageInitNick_6756": "一坨肥猫",
    "skillDes_252": "{owner}拥有护盾时，受到的近战伤害降低{level_based}%",
    "skillDes_257": "触发卧龙时，创造一个二维区域（{p1}码），区域内的己方怪兽获得偏移效果，冷却时间{p2}秒（每只怪兽获得偏移效果的冷却时间单独计算），二维区域持续{level_based}秒",
    "messageInitNick_6750": "幻想时间到",
    "skillDes_258": "{owner}处于二维形态时，普通攻击会使敌方怪兽进入降维状态（期间无法获得新的增益效果），持续{level_based}秒，冷却时间{p1}秒",
    "messageInitNick_6751": "烧麦吞噬者",
    "skillDes_255": "{owner}血量低于{p1}%时，普通攻击会使敌方怪兽血量回复效果降低{level_based}%，持续{p2}秒",
    "messageInitNick_6752": "一点的拉肠",
    "skillDes_256": "{owner}血量低于{p1}%时，能量回复效果提升{p2}%，增益效果持续时间提升{p3}%，受到的伤害降低{level_based}%，受到的近战伤害不会超过自身最大血量的{p4}%，持续{p5}秒，冷却时间{p6}秒",
    "skillDes_259": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，{owner}对距离最近的未曾拟态过的己方怪兽进行拟态（全部都曾被拟态过则只拟态距离最近），{owner}获得攻击力×{level_based}%的护盾，持续{p1}秒，如果{owner}拟态对象为远古族怪兽，会额外使所有敌方怪兽能量上限降低{p2}%，持续{p3}秒，该效果被清除时会立刻造成{owner}攻击力×{p4}%的区域伤害（{p5}码），且扣减{p6}能量",
    "messageInitNick_6757": "蒜泥香蕉",
    "messageInitNick_6758": "与幸福有约",
    "messageInitNick_6759": "吃饭之后",
    "8_14": "个人",
    "messageInitNick_6742": "扭蛋肌肉",
    "8_15": "已到达兑换上限",
    "messageInitNick_6743": "豆角撞地球",
    "8_12": "可传送到其他节点",
    "messageInitNick_6744": "泪姬",
    "8_13": "显示传送节点",
    "messageInitNick_6745": "蘑菇撞地球",
    "8_18": "猎物未消失，无法搜索",
    "8_19": "被探索者{1}击破",
    "8_16": "移动力不足",
    "messageInitNick_6740": "帅哥电量不足",
    "8_17": "探索者等级{1}开启",
    "messageInitNick_6741": "岸边花",
    "8_10": "下次刷新时间",
    "messageInitNick_6746": "咕咕王",
    "8_11": "到达{1}后可传送到其他节点",
    "messageInitNick_6747": "姓女名王",
    "messageInitNick_6748": "彼岸繁花",
    "messageInitNick_6749": "龙眼爱好者",
    "randomEventDialogueGroupConfig_13.3": "说有办法帮它赶走睡意",
    "randomEventDialogueGroupConfig_13.4": "了解它困的原因",
    "randomEventDialogueGroupConfig_13.5": "-",
    "randomEventDialogueGroupConfig_13.6": "-",
    "randomEventDialogueGroupConfig_13.1": "好困啊，好想睡觉……",
    "randomEventDialogueGroupConfig_13.2": "让它赶紧睡",
    "randomEventDialogueGroupConfig_13.7": "-",
    "randomEventDialogueGroupConfig_13.8": "-",
    "randomEventDialogueGroupConfig_13.9": "-",
    "8_25": "切换至普通模式后不会被其他探索者狩猎，但无法持续获得狩猎勋章，是否消耗{1}钻石马上切换？",
    "messageInitNick_6731": "明年相亲",
    "8_26": "未解锁该节点",
    "messageInitNick_6732": "沉浸式化妆",
    "8_23": "[{1}] {2}帮助{3}触发了智者获得{4}",
    "messageInitNick_6733": "典当灵魂",
    "8_24": "其他探索者正在狩猎你，不能切换为普通模式",
    "messageInitNick_6734": "酷到没对象",
    "8_29": "{1}部落的{2}",
    "8_27": "世界灾厄——{1}",
    "8_28": "{1}分钟后降临",
    "messageInitNick_6730": "豌豆魔法",
    "messageInitNick_6739": "紫色妖姬",
    "8_21": "等级到达{1}的{2}怪兽",
    "messageInitNick_6735": "拒绝勾引",
    "8_22": "[{1}] {2}帮助{3}击破了复制体获得{4}",
    "messageInitNick_6736": "哈密瓜魔法师",
    "messageInitNick_6737": "助力高考",
    "8_20": "被探索者{1}触发",
    "messageInitNick_6738": "帅气的地瓜",
    "97_title21": "星球的能量正源源不断地为你所用。",
    "97_title22": "所有探索者都想知道巨塔的尽头关着什么。",
    "97_title20": "极化就像一艘忒修斯之船，开始远航。",
    "97_title25": "在这里，你将触及极限与蜕变。",
    "97_title26": "关于转生到好友位面打怪兽的这档事",
    "97_title23": "聚是一团火，还不会散。",
    "97_title24": "既是起源，也是核心。",
    "8_36": "野生-{1}",
    "messageInitNick_6720": "双眼被祝福了",
    "8_37": "来！让我们愉快的交易♂吧",
    "messageInitNick_6721": "灵魂摆渡人",
    "8_34": "你的怪兽小队探索时遇上了{1}的怪兽小队，被怼的满地找牙！",
    "messageInitNick_6722": "上课起立",
    "8_35": "你的怪兽小队探索时遇上了{1}的怪兽小队，把对方怼的满地找牙！获得的奖励提升了50%！",
    "messageInitNick_6723": "感性又性感",
    "8_38": "限购1件，购买后神秘商人消失",
    "resoundEventConfigDes_8002": "滚石山脉近温泉石塔一战的最后，钢铁龙王巴萨克没有理会悲痛的古拉姆和垂死的温泉老板，也没有理会灵族族长苏比斯的质问，只是将倒地的暗黑龙一把抓起，甚至经过远古族首领埃癸斯和日夕身边时，也没有对他们挑衅一番，下了撤退的命令，回到熔火之巅。 \\n他现在独自坐在自己的洞穴中，愣愣地看着手上的召唤具。那是他从暗黑龙身上意外“捡漏”到的神器。\\n巴萨克发现这个神器对他毫无作用，但卑劣感此时浸透他的全身，召唤具仿佛一个滚烫的镣铐，无论如何都无法从手上甩开。因为“捡漏”同当小偷没有区别。\\n他不但是小偷，还是忘恩负义的一方。如果不是古拉姆和温泉老板，他还不知道要被暗黑龙的黯焰折磨多久。\\n心高气傲的他，竟成了小偷和逃兵……\\n“啊——！！！”\\n巴萨克的怒吼响彻熔火之巅。\\n更让他恼火的是，暗黑龙早已断气，死去的怪兽无法回答问题——究竟有多少条龙背叛了他！？\\n发生这种事的原因，思前想后，他允许大家随时随地挑战他的族长之位，鼓励大家随意抢夺其他种族的进化孢子、强化孢子和地盘，还向大家许诺很快就会发动征服整个大陆的战争。是因为他对手下还不够好吗？这些还不能让大家对他死心塌地吗？\\n难道能跟随一位不朽的首领，他们还不满意吗？\\n对方到底给了什么好处？\\n那些叛徒，究竟是远古族的走狗，还是传说中邪王的追随者？\\n“召集所有龙族！”怒吼之后，巴萨克向手下下达了命令。\\n“呃……”\\n但巴萨克没有得到所期待的爽快回答，手下有些迟疑。\\n“首领……是整个大陆的所有龙吗？这恐怕得花好几十天的时间……”\\n“……这儿地不够大，能挤下所有龙族吗？”另一个手下也迟疑地说。\\n“不对，蠢材！我要你们把熔火之巅的龙都找来！！”\\n“哦，原来是这样。”\\n几个手下领命下去了。\\n巴萨克看着他们愚钝的背影，哼哼地喷了几口恶气。\\n很快，五百多条龙聚集在一块四周流淌着岩浆的巨大石块上。\\n那条让巴萨克黯焰缠身的暗黑龙，身上覆盖着一层诡异的紫色流动，眼睛也闪烁着疯狂的紫光。被暗黑龙袭击的时候，巴萨克并没有把这些细节放在心上。\\n现在，他在自己的族群中缓缓穿梭，仔细地观察着他们的流动和眼睛。\\n随着巴萨克的逼近，龙群之中，有十几条龙在彼此打着眼色。\\n巴萨克的余光捕捉到一条铁甲龙身上诡异的紫光。\\n“叛徒！”\\n他推开身边的龙，刚想冲过去，一条身上同样覆盖着诡异紫光的轰龙闪现在他的余光之中。当他想确认刚才看到的东西，转向轰龙时，身后又传来一声挑衅似的口哨声。循声转去，他看到一条同样覆盖着诡异紫光的荒火龙。那条荒火龙很快躲到其他龙后面，隐藏了踪影。\\n“叛徒，都给我滚出来！”\\n巴萨克又急又怒地环视四周，发现自己被耍了。\\n可是，并没有龙在他的震怒之下滚出来，而且，大部分看不到流动的龙，根本不知道首领在搞什么。\\n“首领，你找我吗？”\\n突然，龙群中传来一把带着嘲弄调调的声音。\\n巴萨克转身，在群龙面面相觑的目光中，很快找到了一条身上覆盖着叛徒诡光的铁甲龙。\\n即使是能看到对方流动的怪兽，乍看之下也未必能分辨究极级的紫光和吃了邪王孢子而产生的紫光，所以，大部分龙并不知道站在他们当中的是潜伏已久的敌人。\\n“喂，你该不会要挑战首领吧？”某条龙揶揄地问到。\\n大家频频点头，露出“原来如此”的表情，然后，为巴萨克和那条铁甲龙让出足够战斗的空间。\\n这也不是没发生过的事情，曾经有龙想通过打败巴萨克夺取族长之位，巴萨克接受了挑战，并让对手壮烈地死去。之后，巴萨克就经常鼓励手下发起这种挑战，每当出现挑战者，大家就会兴致勃勃地围观挑战者被巴萨克蹂躏的过程。\\n现在，大家都等着看好戏，同时也庆幸有个不懂挑选时机的倒霉蛋在首领心情极差的时候代替大家成为首领泄愤的对象。\\n巴萨克感受到众龙期待的目光，傲慢地朝铁甲龙招了招手。\\n他心里闪过一丝不祥的预感，总觉得光明正大地挑战不像一个叛徒的所为，挑衅的背后，会有什么阴谋吗？也许龙群中鬼鬼祟祟的叛徒想用车轮战来消耗他的耐力，哼，如果是这样，他会让他们好好体会什么是无穷无尽的耐力。",
    "8_39": "最多压制{1}个词缀效果",
    "resoundEventConfigDes_8001": "史卡非斯不敢眨眼地凝视着三个形状大小不一、但都像墨绿色浅盘的召唤具。召唤具还在散发着幽绿色的光芒，光芒比之前弱了一些，三份光芒组成一片小小的绿色光幕。\\n利用召唤具获得异界灵魂对远古族来说是水到渠成的事，但对他来说却是不知该如何实现的奢望。在他对着三个召唤具几近绝望之际，他看到光幕中出现了一个神奇的景象。\\n一根根巨大而怪异的石柱紧挨着直直伸向云端，有的石柱表面布满了排列整齐的洞口，有的则像是被切成块的平静湖面，光滑无比。\\n这个奇怪的景象只持续了一会，就渐渐消失了。\\n又过了许久，另一个奇怪的景象出现了。\\n一些长有着四个圆轮脚的“战士”在一条平坦笔直、宽阔、没有尽头的“石路”上飞奔，估计体格健壮的究极级、甚至不朽级怪兽也追不上它。\\n和上次类似，接下来他看到了第三个景象。\\n那是插在方形洞穴里的细长“石塔”，塔尖冒出灰色浓烟，浓烟袅袅升至天空，和天上的灰云融为一体。\\n他终究往前伸出了手，在光幕景象消失前的一瞬，手与光幕的交接处有一股力量小幅地牵动了他手臂的关节。\\n之前史卡非斯只拥有一个召唤具时，并没有发现这些，因此他猜测现在是三个召唤具的能量正彼此共鸣，展现着另一个世界——那几个不朽级远古族体内的异界灵魂原本所属的世界的景象。\\n他猜对了，当然，他的脑海里根本没有“摩天大楼”、“马路”、“工厂”这些概念，也不可能产生“那个世界十分先进”的认知。但是，他依旧被那些景观所震撼，那个世界，也许会有新的可能！\\n可是，他已经多次听说即使通过石塔的试炼，也只有远古族能得到异界的战士（灵魂）降临、与他们合体进化，现在还没有怪兽能弄明白这是怎么回事。而他既没有通过试炼也不是远古族，不过，如果不能召唤异界灵魂来到这里，但能前往那个神奇的异界呢？就是刚刚他触碰光幕时感受到的力量！找到他的另一半（灵魂），进化成完全体，与其共享一个躯体，就像不朽级的远古族那样。\\n至于那个躯体能否让他满意？他现有的技能能否继续使用？到时候就知道了，那个长有着四个圆轮脚的躯体就很不错，实在不行，再回来就是。\\n史卡非斯拧了拧脑后的发条，让逐渐卡帧的身体稍稍恢复过来，等待那些奇异景象的出现，他用了整整一天。\\n虽然还想继续看看异界的景象，感受那股牵动关节的力量，但当务之急是找到更多召唤具。集合更多的召唤具的力量，一定能打开通往异界的通道！\\n史卡非斯这样坚信着。\\n但是，他还能到哪儿找召唤具呢？\\n获得进化的古拉姆、埃癸斯和暴虐战狂各有一个。他们很可能从日月夕姐妹那听到了他骗走召唤具的事情。欺骗就是创造一个近乎完美的真实，前提是他要有置换真实的空隙，这里留下的空隙并不多。\\n此外寻找石塔的还有灵族族长苏比斯和钢铁龙王巴萨克，前者的目的是破坏石塔，而非里面的神器。那后者拥有召唤具的可能更大。\\n就是说高傲狂暴的钢铁龙王巴萨克就是目前最好的目标了。自己要做的第一步，就是先去龙穴之地调查一下。\\n于是，他把三个召唤具藏好在身上，踏上了前往熔火之巅的旅途。",
    "messageInitNick_6728": "冰似绕指柔",
    "resoundEventConfigDes_8004": "刚到熔火之巅的史卡非斯，正好赶上巴萨克被群龙丢进岩浆，最后滚进超星海洋那一幕。他花了不少口舌，让叉叉们相信帮他救出钢铁龙王，正是自诩海上霸主的叉叉积累声望的最好方式。果然能够看穿海面之下十条鲨鱼深度的叉叉并没有费多大功夫便捞起了溺水的钢铁龙王。\\n“好久不见，族长大人。我救你，当然不是白救。把召唤具给我，反正你也用不上，不是么？”\\n这是巴萨卡再次恢复意识时听到的话语，接着他开始贪婪地呼吸着咸潮的空气。\\n白救？巴萨克定下神来才看到几把抵在自己鼻尖的生锈叉子，拿叉子的是踩在木筏上的叉叉，在其中一只木筏上他还看到了木偶族族长史卡非斯那张表情不明的脸。\\n此时的巴萨克被一张用硬树皮搓成的绳网裹住，下身泡在海中。周围的木筏共同承担绳网中他的重量，也正是如此，他才没有继续下沉。\\n召唤具？有些蠢龙曾说过石塔神器能召唤异界灵魂这种荒唐的事，召唤具指的就是石塔神器吧。巴萨克这才低头看了一下自己的胸甲，胸甲里隐隐透出的幽幽绿光。\\n他都把这东西给忘了，确实这个神器对他毫无作用——他认为这一定是自己已经站在进化链的顶端才会这样，不过，他还是随手把它藏在自己的胸甲里。\\n巴萨克掏出这个无意中被自己保护到现在的东西，他本来还想把它嚼碎吞进肚子里，让它化为自身的力量。啧，不过此刻，当然是自己的性命更重要。\\n没有和对方谈条件的余地，只能祈求对方信守承诺，但对方可是史卡非斯。\\n“史卡非斯，你救我不只单单就为了召唤具吧？真要那样，你只要等我淹死，就能轻而易举地拿到手。”\\n“听说邪王就在冰川谷，啊，现在应该称那块地方邪王雪岭，作为一族之长，我们得去亲眼见证一下邪王的存在，不是吗？你跟我一起去的话，有个伴不是正好？”\\n“哼，好吧。”\\n巴萨克愣了愣，将召唤具递了过去。\\n叉叉们将巴萨克拉上史卡非斯所在的木筏。\\n“现在就出发，去冰川谷！”巴萨克瞪了史卡非斯一眼，完全没有感激之情，依旧是一副高高在上的表情，似乎送他去冰川谷是史卡非斯的份内事。\\n“能送两位族长这种机会有多难得，意味着什么，你们懂的吧。”史卡非斯朝一只叉叉挥了挥手。\\n叉叉们撑着木筏向北漂去。\\n巴萨克握紧拳头，一语不发地望着离自己越来越远的热气腾腾的红色大地。即使有一万个不愿意，他也必须承认那不是远古族能做到的事情，只有更强大更邪恶的力量，才能这么蛮横地攥紧群龙的心脏，让他们疯狂。\\n所以！远古族依然罪大恶极，因为他们到现在还在磨磨蹭蹭，没想出一点办法拯救这片大陆！",
    "messageInitNick_6729": "沧海行云",
    "resoundEventConfigDes_8003": "铁甲龙冲过来了，巴萨克没有多想，便发动了【龙魂·霸体】，但铁甲龙丝毫没有半点退缩之意，向巴萨克展开激烈的攻击。\\n“你的统治到此为止，龙族是属于王的！”\\n硬接下巴萨克【龙魂·霸体】的铁甲龙一下被推开，掉入岩浆，但铁甲龙很快就爬了上来，在他身上凝固成火山岩的岩浆，随着他的再次摩拳擦掌掉落地上，变成一颗颗滚烫的黑色小石头。\\n巴萨克再次扑上去，几下扭打之后，用强壮的双颚咬住铁甲龙的脖子，让铁甲龙疯狂的表情带上痛苦的扭曲。围观的群龙高声呼喝着，朝他们围拢过来。\\n突然，上空飘落一堆紫色的光团，它们纷纷落到群龙的身上，散发着强化孢子特有的味道。\\n本来在围观战斗的群龙、甚至连巴萨克，都被这些奇怪的孢子团吸引了。巴萨克依旧紧紧咬住铁甲龙的脖子，但其他龙却开始骚动起来，有些龙已经忍不住把落在身上的孢子团舔进嘴里。\\n巴萨克一下将铁甲龙甩开，抬头看到自己的头顶飞着一条荒火龙和一条暗黑龙，他们从一个缝制粗糙的兽皮袋中掏出紫色孢子团，一把一把地往下洒。\\n巴萨克仔细盯着一团在他面前飘落的孢子，它的颜色和叛徒身上那层诡异的流动、和叛徒眼睛闪烁的那种颜色，是一样的。如果不仔细看，根本看不到在紫色诡光的覆盖下，属于孢子原来的红光。\\n“别吃——唔！”巴萨克怒吼。\\n“可怜虫，吃吧，这是王的恩赐！”\\n刚才与巴萨克厮斗的铁甲龙爬起来在龙群中高呼。\\n“想要变得和你们的族长一样厉害，就吃掉这些孢子！”\\n荒火龙和暗黑龙不断大声重复着类似意思的话语，引诱着群龙。\\n大家真的很久没有吃过孢子了。\\n先不说世界树已经很久没有飘散出丰满的孢子团，自从巴萨克从晨光草原的各族大会回来，一门心思放在寻找石塔和宝物上，平时寻找（偶尔从弱小的怪兽手中抢夺）孢子的事也完全停了下来。再加上他因为攻塔寻宝的事情连连受挫，脾气越来越火爆，手下更不敢问他要孢子。\\n现在，不知从哪条龙开始，壮着胆子把巴萨克的无法作声当成默许，吃掉一个又圆又大的孢子团，接着，便引发了群龙的争先恐后。\\n上空的荒火龙和暗黑龙故意把孢子团洒到巴萨克身上，让巴萨克成为群龙挤压的目标。\\n巴萨克无法挣脱铁甲龙，只能任由往日对自己战战兢兢的手下一条又一条扑到自己身上。这时他才发现，这是一场叛徒们早有预谋的骚乱。\\n巴萨克醒来的时候，发现自己被紧紧地裹在冷却的火山岩中，不断沉往海底。\\n群龙瞬间爆发的狂乱的力量、闪烁着诡异紫光的流动和眼睛、还有大家脸上那种连他也没有见过的崇拜之情不断在巴萨克缺氧的脑袋中回闪。他抵抗了很久，还是被群龙扔进岩浆。之后，随着岩浆的流动漂流到某处火山岩上面。\\n就在他差点成为火山岩的一部分时，天上降下一场流星雨，一块巨大的陨星刚好砸在他身边，冲击波把他弹飞到远处，然后，他便沿着落地处的火山岩海岸，借着刚才的冲击力，滚落到超星海洋。\\n他在浅海的海浪和火山岩中漂来撞去，身不由己地离岸滩越来越远。\\n区区火山岩是囚不住钢铁龙王的，巴萨克一下就将裹在身上的火山岩撑开。无法呼吸是个大问题，不会游泳是个更大的问题！他得在一个有岩石可以攀附的地方，爬出大海。但他举目四望，身边除了海水还是海水，连一条海草也找不到。抬头，却能透过海面看到天上的流星雨。\\n灵族那边出了什么事？哼，这种时候还是先关心自己吧，蠢蛋！巴萨克骂了自己一句。\\n他想奋力跳出海面，但努力了几次都徒劳无功，只换来呼吸越来越困难的结果。他想大喊，但大海吞噬了他的怒吼，并回敬他满肚子的海水。他想呼吸，但吸进来的全部是咸水，喉咙像被死死掐住。\\n他不再愤怒了，只想求救，不管是谁，只要能救他，他愿意赠送整个龙族。\\n他以为自己视死如归，没想到在漫长的死亡过程中，他变得贪生畏死。\\n“救——”咕噜咕噜，“命——”咕噜咕噜……\\n巴萨克失去了意识。",
    "resoundEventConfigDes_8006": "“族长，我再问你一次。你真的要下达‘不管叛离和失踪的同族，把这里的全部力量投入到砸毁石塔大作战’这样可笑的命令吗？”\\n“白痴，我又不是让你们去邪王那里送死！”\\n“但让我们用自杀来召唤超巨大的流星，和要我们送死有什么区别？”\\n血刃的质问直击部分灵族的担心，他们都是被苏比斯留下来的低级怪兽。他们因为最终兵器屠戮了住在沼泽另一边的一个小部落而担惊受怕的时候，族长并没有回来保护他们。不满就在那个时候于大家心中滋长了。大家都多少产生了已经被族长抛弃了的怀疑，所以这些灵族现在更想拥有强大的盟友，在盟友的庇护下战斗。\\n“那你还有其他摧毁石塔的方法吗？”苏比斯问。\\n见血刃没有回答，苏比斯向身边的手下命令道：“把他押到牢里！让他好好冷静冷静！”\\n血刃并没有害怕，他向自己的朋友打了个眼色，送出信号。\\n“族长，你的时代已经结束了。今天起，我们将开创属于自己的族群！”血刃高声宣告。\\n“混蛋，你这是什么意思！？”面对无法理解的状况，苏比斯提高了几分音量。\\n“还不明白吗？我们受够了你这些自杀式的命令，我们只想保护好自己的亲友！”\\n说完这一句，两个想擒住血刃的灵族，被一名突然从围观的怪兽中跳出来的撼地兽打飞。\\n当弟弟跃迁兽接到采用自杀式攻击对付最终兵器的命令时，憨厚的兄弟俩并没有思考太多，服从族长命令是天经地义的事。后来，因为弟弟被埃癸斯所救，他对埃癸斯抱有极大的感激和崇敬之情。在随后与埃癸斯部落的战士的接触之中，他更加相信“守护同伴”也是一种崇高的作战，而且这种理念更合他的性子。\\n族长回来之前，他曾对血刃的建议犹豫不决，但是，刚才族长的态度让他下定了决心。\\n“……哼！我想起来了，从最终兵器身边逃回来的废物就是你们！”\\n苏比斯想起了某天听部下汇报的战果。那时他已经离开毒气沼泽，在寻找石塔的路上，虽然对战果相当不快，却没有多余的战力重新布置干掉最终兵器的计划。\\n“灵族没有你们这种连送死都做不好的废物！”\\n这么说着，苏比斯向反对自己的血刃和撼地兽发起攻击。\\n可是他最后一句话彻底激怒了撼地兽和其他还对族长有一丝期待的怪兽，苏比斯以为凭借自己几下攻击就能结束的闹剧，很快发展成两派灵族互殴的混战。\\n那几名想劝阻大家的埃癸斯部落的战士，也被苏比斯当成了敌人。\\n流星从不同方向飞来，天上下起流星雨，砸向往昔的同伴。\\n本来，由血刃和撼地兽带领的灵族，战力远不及苏比斯及其精锐手下，但他们在埃癸斯部落的战士的帮助下摆出稳固的防守战阵，再加上苏比斯他们刚从滚石山脉回来，非常疲惫，双方一时之间竟然难分胜负。\\n不过，血刃并不想用两败俱伤的方式来和苏比斯打个平手。今天并不是一个很好的反叛时机，只是因为自己沉不住气，无法接受苏比斯的命令，才跳出来反对他，才到了那个一不做二不休的地步，他并不想让跟随自己的灵族作出无意义地牺牲。\\n于是，血刃让大家且战且退。\\n他们很快退到了沼泽的西边。\\n“……我们现在该怎么办？”撼地兽有点迷惘地问。\\n他们本来还打算在毒气沼泽南部建立防御区，用它来作为低级怪兽的庇护之地。但现在，想守护的地方已经回不去了。即使苏比斯继续他的攻塔大作战，也会在那里留守部分灵族。\\n“等族长走了之后我们再回去吗？”另一名幼体级的怪兽瑟瑟地问。\\n“他已经不是我们的族长了！”血刃激愤地说。\\n“大家要去晨光草原吗？”一名埃癸斯部落的战士建议。\\n“……”\\n血刃从大家的脸上看到不安、害怕和犹豫。\\n“我们去北方，找埃癸斯大哥。”血刃带着决意，结束了这段沉默，“我搞错了，我以为只要做好防御的工作就能守护灵族，可是却忘了我们天命就是进化，在战斗中进化！苏比斯走错了路，我们不能像他一样。我没见过邪王，但我相信埃癸斯大哥。”\\n撼地兽认同地点点头。\\n“尽管只有一点我不认同大哥，有时，进攻才是最好的防守！远古族哦，我们某天一定会在战场上重逢的。到时，你们给我们最好的防守，我们则回赠最勇敢的进攻！”\\n振奋之情重新回到灵族怪兽的脸上，血刃知道自己再次成功地把大家凝聚起来。",
    "resoundEventConfigDes_8005": "在毒气沼泽灵族的聚居地，发生着在某种程度上和龙族的动乱有点相似的事情。钢铁龙王巴萨克看到的那场流星雨正是这场动乱的一瞬。\\n灵族族长苏比斯回到毒气沼泽，发现原本的群居之地移至沼泽的最南端，怪兽的数量比他离开的时候增加了，是沼泽中的其他小型灵族部落也搬过来了吗？不仅如此，部落周围还挖了一条护城河，几处沼泽还做成了被掩饰过的陷阱，不是熟悉这里的灵族，随便走动一定会陷进沼泽中。\\n处处都细心地做过防御工事的样子。\\n苏比斯刚想夸奖几句，就看到部落中几个埃癸斯部落的战士的身影，他们正在帮忙训练灵族战士。那些灵族原来都是被苏比斯留下来的老弱病残，但现在，大家的身体变强壮了，甚至有两个出发前还是幼体级的灵族，进化到了幻化级。\\n苏比斯有点生气。\\n这算什么！它族的战士居然大摇大摆地跑来这里摆出拯救者的姿态！要让他们知道谁才是这里真正的首领。\\n这么想着，苏比斯向着那些训练中的灵族走过去。\\n“辛苦了，族长。又……失败了吗？”\\n一名血刃走上前来，他正是和埃癸斯达成同盟关系的灵族。\\n他没想到族长那么快就回来，还那么快就来到这里。\\n苏比斯的脸色不太好，血刃不知道要怎么解释，这些战士是他大老远跑去晨光草原请过来的，虽然埃癸斯说过部落的战士会关照愿意前往晨光草原的灵族，但投靠他族是积累不了声望的。\\n“哼，你们倒是活得很滋润。既然变强了，下次就成为攻塔力量的一份子吧。”\\n巴萨克从塔里冲出来，什么都没说就跑掉了，其他龙族怪兽也一下子跟着他们的族长跑掉了，没有一条龙留下继续帮他砸毁石塔。这让苏比斯很不爽。\\n灵族和龙族的同盟算是瓦解了。\\n只能从自己族里征集更多的力量。苏比斯一边这么想着，一边赶回毒气沼泽。\\n可是，他没想到自己的命令会遭到异议。\\n“首领，我认为我们还是要加强防线，守住南方。”\\n苏比斯有点惊讶，然后他气势汹涌地呵斥道：“不准！灵族什么时候成了缩头乌龟？把那些远古族送走，既然要准备全族攻塔，他们就不需要在这里。还有，你跟大家说，下次攻塔的时候，就算要牺牲性命，也要召唤出巨大的流星！”\\n听到这样冷血的指令，这名血刃的脑中，因愤怒已经一片空白。\\n要他们把生命全部压在荒唐的策略上，这点实在不可原谅。\\n“族长！给我适可而止吧，你是糊涂到没办法看清现实吗？”\\n“什么？”\\n苏比斯不可思议地看着血刃，自己在离开毒气沼泽的这段日子，究竟发生了什么事？\\n“族长，你以为就这样放任族里越来越多叛离的怪兽，继续那种荒唐的做法，真的能够拯救世界吗？”\\n“石塔是祸端的根源，我们要做的就是铲除根源！要我说多少次你们才明白！”\\n那些本来训练中的灵族慢慢围了过来，和以前一样，他们看着苏比斯的眼神，夹杂着怀疑。\\n这名血刃冷冷地看着苏比斯，心里不可思议地冷静了下来。\\n至今为止，念在苏比斯是很久之前大家通过决斗选出来的族长的份上，他才不断忍耐。苏比斯确实拥有值得敬畏的地方，例如作为领导者的素质、对引力强大的操控技能，又例如即使喜欢收集灵魂，但如果死去的是同族，只要不是太过混蛋，苏比斯都会放之一马，让死者的灵魂自由地飘散在大陆的天地中。\\n但是，这份敬畏之情随着苏比斯的固执渐渐消失殆尽。\\n现在，这名血刃只想尽快壮大灵族，熬过将来的大战，并借此站在灵族之巅。最近他得到越来越多同族的拥护，他也坦然面对自己的私心。",
    "8_32": "世界灾厄已被其他探索者抢先击破，本次战斗的数据将不纳入排行榜计算。",
    "messageInitNick_6724": "危险勿近",
    "resoundEventConfigDes_8008": "“在我的世界，也有一对和你们同名同姓的情侣。”\\n罗密欧和朱丽叶马上被洛菲菲的话吸引了，但是，洛菲菲讲述的故事并不是常人所知的那个版本。\\n“那对情侣所在的两个世家世代为仇，但很久以前，一位大贤者曾预言到了某一代，两个世家中会出现一对恋人，不过由于双方家长的阻挠，这对恋人会一起去死。”\\n罗密欧和朱丽叶同时倒吸了一口冷气。\\n洛菲菲愉悦地看着他们的表情，继续说道：“大贤者还把他看到的未来写成一本预言书，送给他们。既不想与对方和好，也不想自己的后代死去，两个世家便一直警惕着自家的青年男女和仇家见面。然后，过了好几百年都没有出现这样的一对恋人，两个世家就渐渐把这个预言当成荒唐的笑话。”\\n“可是，没过多久，那对恋人出现了？”朱丽叶担心地问。\\n“嗯，还爱得死去活来。双方的家长不想自己的孩子死去，所以千方百计阻挠这段恋情，并派人寻找那本预言书。但预言书不知道被藏到哪里去了，说不定已经被丢掉了。最后，那两位恋人还是一起殉情了……”\\n朱丽叶和罗密欧竟然相拥而泣。\\n“那两个世家，罪该万死……嘤嘤嘤……” \\n“没办法，那是命中注定的事……”\\n“你们现在要哀悼的不是那对恋人。我的世界和这边应该有着奇妙的联系，我怕你们的命运会和那对恋人相似。”洛菲菲假装担心地说。\\n“那本预言书，后来找到了吗？”罗密欧问。\\n“找到了，书里精准地预言了他们的死亡。这本书对他们已经没用了，但说不定能帮助你们度过恋情危机哟。”\\n罗密欧和朱丽叶精神一振，但随之又沮丧起来。\\n“可是，我们没办法到小公主你所在的世界拿到那本预言书。”罗密欧说。\\n“没关系，为了纪念那对情侣，那本预言书得到了广泛的传颂，几乎每个人都看过那本书，它还成为无数爸爸妈妈对小孩说的睡前故事，我可以为你们把那个故事写出来。”\\n“真的吗？”\\n朱丽叶紧紧抱着洛菲菲，在她的脸上猛亲了几口，洛菲菲好不容易才遏制住最终兵器想暴打朱丽叶一顿的意志。\\n朱丽叶已经忘记了自己刚才和洛菲菲“争风吃醋”的狂态，对于她来说，没有什么比和罗密欧天长地久更重要了。\\n洛菲菲看着自己没有打出去的拳头，握成拳头的并不是一只适合握笔的手。\\n“我要几个会写字的手下。”洛菲菲说，她想顺道过一把老师瘾。\\n很快，“洛菲菲写作教室”就成立了。\\n意外的是，来的都是木偶族——洛菲菲后来听说这是由于他们经常研究各种魔法阵的缘故，所以对写写画画还算“在行”。\\n即使这样，这群怪兽中的“知识分子”，还是用狗屁不通的文句让洛菲菲后悔想出这么一个主意。\\n嘛，算了，过程虽然麻烦点，但一想到罗密欧与朱丽叶看到“预言书”的表情，一切都值得！洛菲菲这样鼓励自己。\\n“平静”的日子就这么过了几天。\\n冰雪城堡中的怪兽，几乎都被暴虐战狂虐了个遍，有几个究极级的怪兽在变异孢子和纹章的加持下，甚至让暴虐战狂挂了点彩。自然而然地，暴虐战狂渐渐成了怪兽们的“教官”，这种生死有命、不需手下留情的“训练”，让暴虐战狂非常尽兴。",
    "8_33": "获得奖励已超过次数上限，本次战斗的数据将不纳入排行榜计算。",
    "messageInitNick_6725": "风在喃我在听",
    "resoundEventConfigDes_8007": "……为什么反派阵营会走起学院风？\\n洛菲菲看着眼前的“学生”，百思不得其解。\\n她和几个木偶族怪兽在一间安静宽敞的房间里，城堡外暴风雪的肆虐之音丝毫传不到这里来。怪兽们绞尽脑汁，用木炭棒在粗糙的兽皮卷上写着什么，而她则负责审阅他们的“作文”。\\n“一百个远古族和罗密欧大人，争夺朱丽叶大人，后来他们又爱上帅气的罗密欧大人。罗密欧大人很生气，因为他们变心了。罗密欧大人杀掉一百个远古族，和朱丽叶大人永远幸福快乐，活下去。”\\n“呃……”洛菲菲无语地看着兽皮卷上这个粗制滥造的故事。\\n“老师，我写得如何？”\\n一个究极级的极限自信地问，他认为这个爱情故事相当有看头。\\n“老师，请看我的！”\\n一个幻化级的强袭把自己的兽皮卷塞到洛菲菲手中。\\n“邪恶的魔法，朱丽叶大人，变成猪，罗密欧大人，变成草，猪吃了草，他们永远在一起，幸福快乐。”\\n“……你会用这个故事换来死刑的。”洛菲菲想了想，还是如实地说出自己的想法。\\n“噫！”强袭受挫地后退两步。\\n洛菲菲从一个幻化级的停顿眼中看到了犹豫，她拿起停顿笔下的兽皮卷。\\n“我、罗密欧大人，合体，罗·停顿·密欧，我爱你！朱丽叶大人，长腿抱着我。”\\n“从一块变成好几块，这大概就是你的下场。”\\n“呜——”\\n看着快要哭出来的停顿，一个木偶族害怕地把兽皮卷塞进自己的口中，吞进肚子里。\\n相比起来，极限的故事写得实在太棒了。\\n洛菲菲痛苦地按着额头。\\n不对，她原本是为了体验一下老师教导学生的感受才愿意承担这种工作的，为什么现在被狗屁不通的故事折磨到脑壳痛的是她自己呢？\\n闹剧的起因，只是她在朱丽叶疯狂催她赶路的时候骂了句“有病”，然后在朱丽叶的怒瞪之下，她不得不有点怂地解释自己刚才念的其实是一首诗的名字——\\n《有病》思念是一种病，当朱丽叶穿山越岭，罗密欧在孤独的路上没有尽头。\\n情急之下，洛菲菲想起一首妈妈哼过的歌，她把里面的歌词改了一下。\\n朱丽叶当时只是哀叹一声，并没有说什么，可是，回到冰雪城堡看到罗密欧没什么大碍后，她就让洛菲菲不断重复那句“诗”。\\n她和罗密欧陶醉在其中，一人一句地表达着爱意。“亲爱的”、“辣白菜”、“吾之星”、“小鸡腿”、“小心肝”、“猪猪亲”……还有更多让洛菲菲不愿记起的肉麻称呼。\\n想向暴虐战狂求助时，才发现那家伙早已不知道跑去哪里了，只听到附近怪兽被痛殴的声音，和暴虐战狂满足的狂笑。\\n“决定了！就由你来写我们的爱情故事，让它流传千古！”朱丽叶用法杖指着洛菲菲。\\n“我拒绝。说好不会强迫我做什么的。”\\n“别这么无情嘛。我懂……”朱丽叶若有所悟地点点头，“你肯定不愿意写自己爱上的骑士和别的淑女的爱情故事。”\\n全然不顾洛菲菲的感受，朱丽叶自顾自地脑补着对方的心情。\\n“不是这样的！”洛菲菲急得跳起来，这种污蔑她觉得比蟑螂从身上爬过更恶心。\\n“对不起，小公主。之后，我们会允许你写一个我君临天下的故事，但前提是你要写完我和宝贝的故事。”罗密欧说着，过来拿起最终兵器的手吻了一下，以表歉意。\\n砰！\\n不用等洛菲菲的指示，最终兵器下意识地一拳把罗密欧打飞。\\n“嘿！你这个贱种！”\\n朱丽叶用法杖发出的攻击已经直抵最终兵器的胸膛，但最终兵器侧身闪开，让那个紫色的光波击在背后的冰墙上。\\n厚实的冰墙被击穿，暴风雪从破洞中灌了进来。\\n“两位美女，别生气，都是我的错。”\\n被打飞到空中的罗密欧拔出剑，在落地的时候用剑稳稳地支撑住身体，并用一副风度翩翩的派头甩了甩头发。\\n“你知道，每个看到我的雌性都会忍不住爱上我。”罗密欧拉着朱丽叶的手安慰到。\\n“是的……”朱丽叶按着因生气而起伏的胸部，强迫自己冷静下来。\\n……真是对奇葩。\\n洛菲菲无语。如果说之前她还不知道邪王的“恶”，那么见识到罗密欧与朱丽叶这种高涨的自作多情后，她觉得为了世界的安全还是把他们灭了好。\\n恐怕她的世界和这里有着冥冥中的奇缘，所以才会有一对同名同姓的情侣。\\n洛菲菲灵机一动，打算狠狠捉弄一下这对奇葩。",
    "8_30": "{1}在击破世界灾厄——{2}的战斗中总输出第一，强到爆炸！",
    "messageInitNick_6726": "捡漏王",
    "8_31": "【特殊场景】本次战斗开始时会马上扣除{1}移动力和强制切换为狩猎者模式，请谨慎尝试。",
    "messageInitNick_6727": "安静的等待",
    "resoundEventConfigDes_8009": "自从上次战败后，罗密欧和朱丽叶就严肃地商量着以后的事情。\\n战败的屈辱深深刻印在这对情侣的心中。\\n虽然他们的使命是击败这片大陆的怪兽，但他们善良的心并没有打算让大家死掉，所以才用魔力把他们的精神控制力量注入到进化孢子和强化孢子中，让大家变强的同时，成为他们的臣民和爱情的见证者。\\n可是，这个两全其美的方法，却遭到远古族的阻挠。\\n果然，对敌人仁慈，就是对自己残忍。他们认为自己在释出善意和屡屡退让之下，遭到了远古族得寸进尺的伤害。\\n只能改变策略，把要建立强大的军队放在和专心致志地相爱一样的，第一位。\\n随着魔力的逐日增加，对孢子的“改良”也越来越好，强化的时间越来越长，有些体质强健的怪兽甚至没有出现过力量倒退的状况。虽然不少怪兽因为承受不了体内力量暴增而死亡，但这也是“强化”过程中无可避免的牺牲。\\n只要强化能维持一段较长的时间，进化就能水到渠成地出现。\\n另外，吃下孢子的怪兽不但对他们忠心耿耿，还保有自己清醒的记忆，脑子越来越聪明。智力的进化更让罗密欧与朱丽叶欣喜。\\n昨天，几乎整个龙族都归顺了。在龙族中插入奸细是罗密欧战败后奋发图强想出的“妙计”。朱丽叶为此兴奋了一整天，她和罗密欧像连体婴一样整天腻在一起，逼迫手下说出一句比一句夸张的赞美。为了应付怪兽们的求助，洛菲菲的“写作教室”停摆了一整天。\\n龙族即为造唤台提供了更猛烈的火焰，又增强了邪王大军空中作战的能力，实在是冰雪城堡必备的居家良物。\\n此刻，罗密欧和朱丽叶正在城堡一个宽阔的露台上进行日常的魔力传送仪式。非要形容的话，两者的动作就像是一对在迪厅舞池中扭动的伴侣。\\n罗密欧的剑和朱丽叶的法杖一同指向地下，剑尖和法杖末端都释出一道淡淡的紫光，两道紫光潜入城堡厚实的冰块中，沿着冰块扩散到邪王雪岭、扩散到超星海洋，然后随着海水蔓延到各片土地，浸润世界树的树根，让孢子变异。\\n他们已经不再把魔力用在编织防护屏障中，而是把全部力量放到攻势之上。\\n随着魔力的增强，世界树的树根可能会由于多度浸淫在这种力量中而腐烂，届时世界树就会枯萎。\\n但这点对他们来说无足轻重，一统大陆之后，怪兽只要作为见证他们爱情的生物存在就可以了，没有进化的必要。\\n罗密欧与朱丽叶的身心都在忘我地交流着，这种似乎会一直持续到天荒地老的亲密接触却被一个不识时务的手下打断了。\\n“大、大人，有访客。大人！”手下连连呼唤了几声。 \\n剑尖和法杖的紫光一起消失，魔力传送被打断了。\\n“访客？不见，杀了！”不满仪式被打扰，罗密欧下达了毫不留情的命令。\\n“等等，我要亲手杀。”同样不满的朱丽叶，美貌扭曲成凶相。\\n罗密欧与朱丽叶的肢体回复到正常的姿势。朱丽叶经过那个手下身边时，带着明显的杀气说：“下次再敢打扰我们，连你都杀。”\\n“……”\\n杀气像毒蛇一样缠绕着这个手下，一股恶寒直透他的身体，等两位大人走远，他才发现自己两腿之间已经湿哒哒的。\\n都说了不能打扰王，可是大家已经等了整整一晚，而谁叫他是猜拳猜输的那个呢？",
    "97_title10": "既是起源，也是基石。",
    "97_title11": "永生永续永远是茧。",
    "97_title14": "星球的最深处不单只有裂痕……",
    "97_title15": "在这里，你将遇见挫折与荣耀。",
    "skillDes_290": "崩刃会使敌方怪兽进入疗殇状态（受到血量回复的{level_based}%的伤害），持续{p1}秒",
    "97_title12": "黑暗中无数弱者消失殆尽，会包括你吗？",
    "97_title13": "重铸……斗技场荣光！",
    "97_title18": "-.-- --- ..- .-. ...- --- .. -.-. .",
    "skillDes_293": "战斗开始时，{owner}免疫封印效果，且受到远程伤害时回复{level_based}能量，但血量回复效果降低{p1}%，持续{p2}秒",
    "97_title19": "无论是饲星还是重置，都是一个新的开始。",
    "skillDes_294": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对最近的敌方怪兽造成攻击力×{level_based}%的范围伤害（{p1}码），如拥有{p2}枚或以上的深渊印记，消耗{p2}枚，凝视造成的伤害提升{p3}%",
    "97_title16": "背靠你时是后盾，背靠敌人时是炼狱。",
    "skillDes_291": "{owner}触碰战墙时，进入巨擘状态（恒定击退敌方怪兽{level_based}码，如击退至触碰战墙，扣减{p1}能量），持续{p2}秒，冷却时间{p3}秒",
    "97_title17": "这里有一个巨大的谜题，“怎样通关？”",
    "skillDes_292": "{owner}受到致死的伤害时不会死亡，进入星宇状态（不会死亡，期间受到的伤害会在状态结束时转化为{level_based}%的护盾），均持续{p1}秒，每场战斗最多触发{p2}次，敌方怪兽死亡时，最多触发次数增加{p3}次，最多可增加至{p4}次",
    "8_47": "神灵邂逅",
    "skillDes_297": "凝视会使范围内的敌方近战怪兽增益效果持续时间降低{level_based}%，持续{p1}秒，如拥有{p2}枚或以上的深渊印记，该效果无法清除",
    "8_48": "{1}H",
    "messageInitNick_6710": "按时摸鱼",
    "skillDes_298": "战斗开始时，{owner}获得{p1}枚深渊印记，敌方怪兽受到致死伤害时（含不会死亡），{owner}获得{p2}枚深渊印记，每{p3}秒最多获得{p4}枚，最多拥有{p5}枚深渊印记，如拥有{p6}枚或以上的深渊印记，{owner}攻击力提升{level_based}%",
    "8_45": "需要等待{1}秒才可发起下一次攻击",
    "messageInitNick_6711": "无权限",
    "skillDes_295": "凝视每{p1}秒造成攻击力×{level_based}%的伤害，持续{p2}秒，如拥有{p3}枚或以上的深渊印记，持续时间提升至{p4}秒",
    "8_46": "游荡智者",
    "messageInitNick_6712": "捕鱼达人",
    "skillDes_296": "凝视会使范围内的敌方远程怪兽消耗能量发动技能时（无论是否成功）受到{owner}攻击力×{level_based}%的伤害，持续{p1}秒，如拥有{p2}枚或以上的深渊印记，该伤害变为区域伤害（{p3}码）",
    "resoundEventConfigDes_8011": "罗密欧与朱丽叶双双坐到冰王座上，居高临下地看着两名族长。\\n最终兵器和暴虐战狂像左右护法一样站在邪王的两侧。他们是被邪王叫来的。前者需要在狗屁不通的文句中喘口气，后者因为找不到对手，闲着无聊就跟了过来。\\n暴虐战狂露出饶有兴致的笑容。\\n“钢铁龙王，有没有兴趣和我过两招？”\\n“那个归你，木头怪归我。”洛菲菲说。\\n史卡非斯看到最终兵器的时候愣了愣，心想这次完蛋了，对方可不会把他吊在树上就了事。\\n“小妹妹，你也想和他过几招？”\\n“我要把他扔到造唤台里。”洛菲菲的眼中露出微微的笑意。\\n“准了。”罗密欧与朱丽叶异口同声。\\n“等等！我们是来效忠的！”史卡非斯大喊，剧情不是这样走的啊！\\n“哦？那换个法子。放心，我不会做出那种把你倒吊在树上、再让低级怪兽将你刺成箭猪的事情。”\\n“……谢谢？”\\n“但我想把你的手脚都拆下来重装一遍，重装之后你再效忠吧。”\\n不由分说地，洛菲菲拧着史卡非斯后脑勺的旋转杆飞走了。\\n暴虐战狂朝钢铁龙王勾了勾手。\\n“我对折磨对手没有兴趣，不想死的话，就和我痛痛快快地打一场。”\\n“来吧！！”\\n巴萨克怒吼了一声，厚实的冰手铐竟然被他挣扯出一道裂纹。\\n冰手铐很快被解开，冰雪城堡的大厅马上变成两名不朽级怪兽的竞技场。\\n罗密欧与朱丽叶不知何时离开了。木偶族族长死了也不要紧，龙族族长没那么容易死，他们放心地把两名族长交给洛菲菲和暴虐战狂驯化，就当是对两名族长忠心的考验吧。\\n\\n“啊——”\\n是史卡非斯的惨叫。\\n被几十根大号缝纫针猛扎的噩梦，现在还不时侵扰着洛菲菲，史卡非斯就是那个罪魁祸首，她恨不得将它打成木渣。\\n实际上，洛菲菲将史卡非斯的四肢以奇妙的角度扭了两下后，就放弃了。\\n一是最终兵器的手不够巧，二是史卡非斯的惨叫。他的惨叫声时刻提醒着她，他不是纯粹的木偶，而是一个活物。\\n\\n这天快结束的时候，“洛菲菲写作教室”被洛菲菲废除了，史卡非斯以一兽之力，包揽了写作教室所有木偶族的工作。\\n他正戴着坚冰手铐，在寒冷的牢房中，把洛菲菲所说的“预言”——一个狗血的爱情故事一刀一刀刻在他和巴萨克昨晚拉回来的冰块上。\\n巴萨克被关在旁边的牢房里，浑身是伤。牢房的冰栏比冰手铐更坚固，巴萨克撞了几下都没能撞断，所以他现在死心地抱胸坐在地上，看着史卡非斯，时不时发出“哼哼”的冷笑。\\n“军师大人，我们下一步该怎么走？要去舔邪王的脚以表忠心吗？”巴萨克揶揄地问。\\n当然，如果这样就可以骗到邪王的话。\\n史卡非斯没理睬巴萨克，但心里这样说着。\\n\\n史卡非斯刻完的冰块很快就被狱卒拉走了，狱卒把冰块拉到洛菲菲那里，洛菲菲看过没问题后，把它们按顺序排列好。\\n洛菲菲看着史卡非斯今天的劳动成果，满意地点点头，不得不说，木偶族族长的“作文技能”相当不错，一天就干了其他木偶三天的活。\\n这间用来放置刻字冰块的房间，被洛菲菲称为“预言之间”，她一直期待着邪王看到这个故事的表情，现在，她觉得可以邀请他们来看“上集”了。",
    "resoundEventConfigDes_8010": "与其说访客，不如说是囚犯。\\n史卡非斯和巴萨克被一群怪兽押着，手上戴着厚实的冰手铐，在冰雪城堡的一楼大厅“老老实实”地等着。他们来此的路上一点也不愉快。\\n冰川谷的一分为二产生了大量的碎冰，它们飘浮在超星海洋上，组成一片“冰海之迷宫”。叉叉们的木筏在暴风雪中来回探索，在浮冰中左穿右插，还是迷路了。\\n实在没办法。于是，他们骗史卡非斯和巴萨克爬上一块浮冰，告诉他们目的地到了，往前走一段就是冰川谷。可他们往前走了一段，才发现这不过是一块稍大的浮冰，想转头杀人的时候，叉叉们已经撑着木筏消失在冰海中。\\n和他们一起留下来的还有一根简陋的木浆，代表着叉叉的一点歉意和于心不忍。\\n史卡非斯的目的地是邪王雪岭。他想把邪王手中的召唤具通过巴萨克这个重要道具骗过来，于是，他说服巴萨克跟他一起去邪王雪岭，把龙族抢回来。\\n巴萨克并没有蠢到以为单凭自己就能抢回整个龙族，但他带着最后的不甘，想要确认在背后作祟的是远古族。\\n记恨远古族，大抵是龙族从一百年前左右发展起来的“优良传统”，如果不是远古族，巴萨克的先祖早已实现了征服大陆的伟愿。或许，他心底里早已相信邪王的存在，可就是不想看到远古族又当了一回救世主。无论是征服者还是救世主，那都是龙族、都是他的角色。\\n为了能继续前进，史卡非斯和巴萨克跳到一块仅容得下他们俩的小浮冰上。彼时正值夜晚，繁星被厚厚的风雪遮挡，他们无法凭女巫星来辨明北方。\\n在浮冰中原地踏步地绕了好几个圈后，史卡非斯想到了一个有点儿难为情的办法。\\n“把我抛高，让我穿过暴风雪和云层，好看到女巫星的位置。我掉下来的时候把我接稳，万一我摔坏了脑袋，我们就冷死在这里吧。”\\n巴萨克哼了几口闷气，终究还是把史卡非斯扔了上去。\\n如预想中一般，女巫星在北边的天空闪烁着。掉下来之后，史卡非斯指明了方向，巴萨克握着木浆撑了一段之后，再次把史卡非斯抛高。\\n就这么重复了几十次之后，他们终于在邪王雪岭靠岸了。\\n他们并不知道之前曾有一道由暴风雪形成的屏障阻挡着神灵寻找邪王，所以他们在暴风雪中艰难地往北跋涉了一段之后，终于看到了几条盘旋在城堡上空的飞龙。\\n巴萨克看到昔日的手下，脸上火辣辣地，像被谁打了一巴掌。\\n两位族长当然没想着要堂而皇之地来到敌方阵营送兽头，但是他们在潜行中遇到了点小意外。\\n一名究极级的木偶族极限在肆无忌惮地狂笑着，他身后的三条锁链不断抽打着前方两条拉着一块坚冰匍匐前行的暴龙。\\n“龙屎的！你的木偶在欺负我的龙！”\\n“冷静点，他们都是邪王的手下！”\\n史卡非斯本来想拉着巴萨克从一个小雪包后面绕过去的，他们离那支运冰小队有一段距离，再加上极限正以折磨低级怪兽取乐，沉浸在极大的愉悦中，根本不会发现他们。\\n巴萨克本来已经忍下去了，但偏偏这个时候极限想展现一下小头目的威仪，用锁链把一条暴龙甩了出去，暴龙不偏不倚地落在巴萨克面前。\\n“混蛋！！”巴萨克冲了出去。\\n“……”\\n史卡非斯无语抚额。其实他的面子也有点挂不住，巴萨克的言外之意是，那个极限成为邪王的手下，也是他的错。\\n……没错，他暂时还没有余力思考如何把木偶族送往异界，但只要他到达异界后，一定会找到连通两个世界的路。\\n这个关乎木偶族荣兴的大计、还有他对本族怪兽的关心，他根本不需要向巴萨克解释，不过，看到挡在两条暴龙前、拽着极限的锁链把他狠狠地甩到雪地上的龙族族长……\\n史卡非斯咬咬牙，也冲了出去。\\n这场战斗很快被天空盘旋的哨兵发现了。当两位族长被身上闪烁着诡异紫光的怪兽团团围住时，史卡非斯便说他们是来投诚的——虽然有点偏离了原来的计划，但只要能见到邪王，一切就能按照他原来的设想进行。\\n至于为什么要引起战斗，当然是为了展示实力。\\n但邪王的手下认为判断他们的实力是王独有的权力，作为展示忠诚的第一步，他们必须把所有冰块拉回城堡。\\n看到史卡非斯猛向自己打眼色，巴萨克只好拿起了绑着冰块的绳子。\\n那名极限的锁链再度像毒蛇一样舞动，但这次抽打的对象是两名族长。\\n然后，终于来到冰雪城堡的两名族长，等了漫长的一夜。\\n想起路上所受的种种屈辱，巴萨卡把牙咬得咯喇咯啦响，而史卡非斯则费尽脑汁地调整自己的“策略”。\\n他曾听说邪王创造了一种劲爆的道具——纹章。\\n锻造纹章的戮魔钢是超进化大陆最刚硬的金属。巴萨克曾吹嘘自己是吃戮魔钢长大的，牙齿、甚至身体比戮魔钢还要坚硬。如果把不朽级的巴萨克扔进锻造炉里和戮魔钢一起锻造，纹章的威力一定会大幅增长。邪王一定会检验纹章的威力，到时他就发动技能【骗术·联结】，让纹章的威力比实际更厉害。\\n用提高纹章威力的锻造方法作为获取邪王召唤具的筹码。\\n——这就是史卡非斯的计划。\\n如果失败了，那他仍会戴着“效忠”的面具，希望以“帮助邪王消灭了一个龙族族长”的理由，恳求邪王的宽恕。只要留在邪王身边，有的是机会骗到召唤具。\\n当然，面对巴萨克，他准备的是另外一套说辞——一起去刺杀邪王。\\n巴萨克觉得当刺客不是他的风格，可是想到自己现在势单力薄，还是答应了。\\n等待的过程中，史卡非斯一直暗示他要忍耐下去。在他的耐性快要消耗殆尽的时候，感到一股像毒蛇一样的冰冷杀气缠绕着他的身体，他看到史卡非斯也打了个冷战。",
    "8_49": "源初之地",
    "resoundEventConfigDes_8013": "但是，造唤台那里吵吵闹闹的，是另一幅诡异的景象。\\n巴萨克被五花大绑地吊在空中，吊起他的几条飞龙正是他昔日的部下。\\n造唤台的炉火熊熊燃烧着，温度比熔火之巅的火山还要高。\\n巴萨克在烈焰上空破口大骂，僵挺着身子维持最后的体面和骨气。他要把史卡非斯削成小木签剔牙，还要把邪王做成餐具。\\n原来，罗密欧与朱丽叶刚离开预言之间，就有怪兽屁颠屁颠地跑来向他们禀告木偶族族长求他帮忙转告的话。木偶族族长还说两位可敬的王听了一定会心花怒放，说不准还会给他大大的赏赐。\\n木偶族族长凑到他耳边说这些话的时候，他略带怜悯地看着在另一间牢房里闹嚷着“史卡非斯你想瞒着老子做什么”的龙族族长。\\n就这样，尽管有点曲折，但史卡非斯还是努力让自己的阴谋按照原计划进行，可惜邪王并没有让他和巴萨克一起去造唤台。\\n此刻，巴萨克还没被扔进造唤台的理由，是因为暴虐战狂拦在邪王与巴萨克之间。\\n“战士有战士的死法！巴萨克是我的对手，要死也得死在我的斧下！”\\n“死在你斧下这种无聊的事，比我们的将来更重要吗？”朱丽叶挑了下眉毛。\\n“你们的将来关我屁事！”\\n暴虐战狂踩上造唤台的边缘后再次跳起，撞向抓着吊绳的飞龙，飞龙迅捷地扇动双翼避开。\\n吊在下面的巴萨克趁机挣扎，像秋千一样大幅度地摇荡着，这样，即使飞龙松手，也无法确保他掉进造唤台里。\\n洛菲菲向一名怪兽守卫打听了事情的来龙去脉后，不禁冷笑了几声。\\n“你们是笨蛋吗？竟然相信那个骗子的话？”洛菲菲一点面子也不给地问到。\\n“试试无妨。”罗密欧不悦地说。\\n他们也没打算全信，只是觉得用不朽族来做纹章的锻造材料是个相当有创意的想法，而且没准会带来意外的收获。\\n不过，没想到却遭到巴萨克的奋力抵抗，他一点也不像来投诚并愿意奉上生命的样子。所以，制服巴萨克花了点时间。\\n战斗的动静引来了暴虐战狂，他对这种无聊的做法嗤之以鼻。\\n罗密欧与朱丽叶看到洛菲菲露出和暴虐战狂一样的表情后，互相点了点头，眼中同时闪过一道狠意——如果燃烧巴萨克能让纹章的威力更上一层楼，那么造唤台也会是暴虐战狂和最终兵器的生命终点。\\n朱丽叶法杖的顶端开始聚拢起一个暗紫色的光球，她要用媚惑之术让巴萨克屈服，结束这场闹剧。\\n“你们想听预言的下集吗？”\\n洛菲菲在朱丽叶准备释放魔力的时候，突然说到。\\n“为什么突然说起这个？”罗密欧不解。\\n朱丽叶法杖顶端的光球也暗了下来。\\n“朱丽叶的教母是一个法力高强的仙女，能把南瓜变成马车，把老鼠变成仆人。”洛菲菲不管他们，继续编下去，“为了帮助这对小情人，她把罗密欧的剑泡在用蜥蜴熬成的汤汁里面，这个魔法能让剑的威力大增，让罗密欧在与求婚者的决斗中稳操胜券。但是……”\\n罗密欧和朱丽叶吞了吞口水，即使知道另一对罗密欧与朱丽叶的爱情以悲剧收场，他们还是提着心眼儿，迎接同名情侣接下来要面对的灾难。\\n“罗密欧的朋友代替了他去决斗，死在了对手的剑下……”\\n“怎么死的？”\\n“那把剑不是强化过吗？”\\n“反正结局就是这样，还有很多细节，回头我让小木偶给你们写下来。所以……”洛菲菲顿了顿，“你们确定要把这条龙扔进造唤台里吗？”",
    "skillDes_299": "战斗开始时，{owner}绑定己方攻击力最高的近战怪兽（没有则不绑定），该怪兽进入蛇噬状态（每次撞击敌方怪兽时，会直接扣减其现有增益效果{level_based}秒的持续时间，对同一只怪兽每{p1}秒只可生效{p2}次）",
    "resoundEventConfigDes_8012": "罗密欧与朱丽叶如临大敌似的走进预言之间，他们知道异界的“预言”是个悲剧故事，担心这种命运会发生在自己身上。\\n即使有了这份铺垫，他们看到故事中的细节依旧一惊一乍、大呼小叫、几乎全程紧紧抱在一起。洛菲菲全程忍笑，幸亏最终兵器的脸也做不出太细致或者太夸张的表情。\\n故事在朱丽叶的父母答应了女儿另一个追求对象的求婚后停止了，洛菲菲向他们郑重承诺很快就会把“预言”的下集写完。\\n朱丽叶想了想，担忧地说：“宝宝，你说在我们这个世界里，代表着那个卑劣的求婚者要拆散我们的，是谁呢？”\\n“这还用说，就是远古族不朽级的那对双胞胎啊！她们上次向我求婚不成，所以怀恨在心向我们发动了战争！”罗密欧咬牙地说。\\n“我懂了！所以那个像太阳一样的远古族为了得到你，就想把我杀掉。”朱丽叶说，想到原来日夕怀着这种“恨意”，她不由得打了个寒颤。\\n“说不定她们还会千方百计地把我们拆散，我们要先下手为强，把她们杀了！”\\n“嗯！！”\\n为了商量讨伐日月姐妹的大计，罗密欧与朱丽叶很快离开了预言之间，他们还没完全信任洛菲菲。\\n对洛菲菲来说，他们的脑洞大开让她始料不及，她没想过这对奇葩会把故事中的角色随便代入到月夕和日夕身上。\\n她本来只想稍微改一下结局——\\n罗密欧和朱丽叶醒来之后，发现封死的坟墓中只有一个小小的洞穴，但罗密欧太胖了，卡在洞口。已经爬出去的朱丽叶鼓励他努力减肥，每天从洞外给罗密欧带一点点的食物。罗密欧为了早日自由，决心绝食。功夫不负有心人，可是，在他终于瘦到爬出洞口的那一刻，却饿死了。\\n这种带着恶作剧性质的暗示，可能会让朱丽叶把罗密欧喂成猪，也可能会让朱丽叶把罗密欧变得和她自己一样瘦。\\n但是，恐怕这对奇葩还没看到结局，就会因为各种各样的妄想把身边的怪兽弄死。\\n唔……头疼。\\n洛菲菲扶着额头，思考着为何来到这里之后的每次恶作剧，总会给自己带来麻烦。\\n“菲……”最终兵器的声音如沙漠上的夜风，在两者共有的意识空间中缓缓升起。\\n这几天他一直在沉睡，偶然醒来，看到的都是几个怪兽在冰块上刻着复杂文字的景象。\\n“你醒啦？”\\n“……敌人？”\\n“啊，没有人要伤害我，只是遇到些小麻烦。”难道是自己的焦躁唤醒了最终兵器？\\n这对奇葩和那几个不朽级的远古族势不两立既成事实，他们对付日月姐妹也是迟早的事，但是，洛菲菲还是想找办法悄悄提醒一下她们。\\n“……杀？”\\n“并不是什么事情都可以用杀来解决的。”\\n“……”\\n在意识的虚空中，最终兵器看着洛菲菲。\\n洛菲菲摸了摸最终兵器的头，然后坐下，依偎在他脚边。\\n“你说，如果大家只能做同一件事，只能想同一件事，世界会变得怎么样？”\\n“……”\\n“那一定是个非常非常无聊的世界。”\\n如果邪王统治了大陆，一定会强迫所有怪兽天天爱着他们、天天歌颂他们的爱情。电影里的大魔王统治世界都是为了折磨和奴役别人，这对奇葩统治世界只是为了洒狗粮。\\n这么一想邪王好像也没那么邪恶……不对，父亲说过弱肉强食的大自然规则能让各个物种不断强大，让世界进步，人类就是这样渐渐走到食物链顶端的。\\n可是，如果强壮的怪兽和弱小的怪兽只能注视着邪王，不去吃掉别人也不被别人吃掉，这个世界就会变成一滩死水，迟早会在阳光下蒸发掉，蒸发完了还得散好一会儿臭气。\\n最终兵器默默听着洛菲菲的解释。\\n“总而言之，世界由各种欲望构成，而掌控自己的欲望是掌控其他的一切的前提。”洛菲菲总结性地补充了一句。\\n无论是爱着别人的欲望，还是吃掉别人的欲望。\\n“你最想做的是什么？”洛菲菲好奇地问。\\n“……杀？”\\n“不对，那是别人要求你做的事，不是你自己想做的事。”\\n“……”\\n“你也想想好了。”\\n洛菲菲又摸了摸最终兵器的头，然后意识重新回到躯体的控制上面。\\n她离开预言之间，逮住一个怪兽问它邪王在哪儿，得知在造唤台那里，便也匆匆跑了过去。到底他们会想出什么办法对付月夕和日夕，她希望好歹能偷听到一点。",
    "messageInitNick_6717": "不愿透露姓名",
    "resoundEventConfigDes_8015": "古拉姆、埃癸斯和日夕把温泉老板埋葬在一个山丘脚下，那把长剑也被留在温泉老板身边。\\n在撒上最后一把泥土之前，林宇翔提议在老板的遗体上洒把种子，这里以后长出的几棵大树，会成为老板葬身之地的标记。\\n于是，古拉姆在一片稀疏的树林里捡了几颗牙鳞橡的种子。\\n在快回到温泉老板的坟墓之前，古拉姆轻轻对林宇翔说：“前辈说……你是个不错的伙伴，那个我以前……对不起。”\\n“说什么呢，我以前就是个嘴欠的家伙。哈哈，哈哈哈哈……”虽然不合时宜，但林宇翔只想到用大笑掩饰自己的尴尬。\\n他说不出自己在尴尬什么，或许不习惯古拉姆对他这么友善，或许觉得自己其实没有那么好。\\n三位远古族首领拜别温泉老板后，便决定去熔火之巅找钢铁龙王巴萨克。\\n那场战斗以后，他们发现夺走召唤具的暗黑龙不见了，不过，召唤具对他们来说已经不重要了，亲眼见识到本族叛徒后的巴萨克，应该会答应和他们联手吧。\\n带着这样的希望，他们来到了熔火之巅，可看到却是一片龙去山空的景象。\\n“我看见巴萨克带着暗黑龙跑了，是因为偷了我们的东西，所以带着所有龙连夜逃跑了吗？”日夕不屑地说。\\n“我还以为他会堂堂正正地在这里等着我们来抢，不过，逃跑可不是巴萨克的风格。”古拉姆说。\\n“说不定遇到什么意外了，像火山爆发……”埃癸斯推测。\\n“那是他们的日常吧。”日夕说。\\n“那是什么？”林宇翔向古拉姆示意了一下古拉姆的余光所忽略的一个角落。\\n古拉姆走过去，捡起一个小小的紫色孢子团。\\n“这是强化孢子？还是进化孢子？”\\n古拉姆猜到这是因邪王魔力的侵染而变异的孢子团，但实物他还是第一次见到。\\n咕噜——古拉姆吞了吞口水，不知为何，他心中涌动起一股燥热。\\n拿着孢子团的手慢慢往嘴巴移动，在孢子团快要放进口中的时候，“啪”的一下，孢子团冷不防地被日夕打掉。\\n“别吃！”\\n“诶、我在做什么？”古拉姆回过神来。\\n古拉姆曾听月夕说过变异孢子的特点，但现在才体会到它的威力。\\n日夕捡起孢子团，走到一处沸腾的岩浆旁边。\\n林宇翔看到日夕的手在抖，像要把极度不舍的宝物扔掉。\\n“身体借我用一下。”\\n林宇翔刚说完，古拉姆便爽快地把控制权交给他。\\n“那位女士，好像挺在意你的”，古拉姆曾这样对林宇翔提起过日夕的搭档对林宇翔的关心，但那时他还没原谅林宇翔，所以冷冷地拒绝了对方想和林宇翔说话的邀请。\\n“啧啧，古拉姆同学，你真是个艳遇终结者！”林宇翔当时听到古拉姆这么说，有种两眼发黑胸口剧痛的感觉。\\n所以现在，他屁颠屁颠地跑到日夕身边，关切地问：“怎么了？太热了吗？让我来吧。”\\n然后也不等日夕回答，就从她的手里抢过孢子团，扔进岩浆中。\\n小小的紫色光团瞬间被炽烈的橙红所吞没。\\n哈，日夕怕热？在意识虚空中的古拉姆翻了个白眼。\\n臭小子，杀了你哦！日夕也用这般眼神瞪着林宇翔。她知道现在在她身边的是古拉姆的搭档。\\n林宇翔像做了什么了不起的事一般，愉快地拍拍手，对日夕和自己的女神傻笑着：“以后，这种危险的事就交给我！”\\n“你认识这个人吧，交给你了”，日夕对李雨蒙说话的同时，意识一松，把身体交到李雨蒙手中。\\n李雨蒙脸微微一红，但是看到古拉姆原本那张还算帅气的脸变得一脸傻气，不禁头疼起来。\\n啧……是自来熟还是大色狼？无论对方是哪种类型的玩家，都不是她所期待的智慧型。\\n完全被晾在一旁的埃癸斯摸了摸脑袋，古拉姆和日夕的关系什么时候变得这么好了？\\n“你也喜欢日夕小姐吗？”马克问埃癸斯。\\n“啊？”埃癸斯愣了一下，自己好像被误会了。\\n马克没谈过恋爱，但他知道自己的队友在男女关系上都挺开放的，他并不认为这是羞于启齿的话题，所以他问得很坦荡。\\n“不是这样的。”埃癸斯也不害羞，只是很认真地思考了一下，“我们和日月两位小姐是晨光草原的铁三角，那样的关系。”\\n“哦，那他们现在是林宇翔先生和李雨蒙小姐吧。”\\n“我们就别打扰他们了。”\\n“好！”\\n埃癸斯提着重盾，跨过几道岩浆流，朝岩浆的源头攀跳而去，挑战着身体对忍耐炙热的极限。这是他第一次踏足熔火之巅，他对这里充满了好奇。",
    "8_40": "世界",
    "messageInitNick_6718": "万恶之源",
    "resoundEventConfigDes_8014": "巴萨克并没有被扔回牢房里。虽然他逃过了成为纹章锻造材料的命运，但邪王为了惩罚他前来“投诚”的这份虚情假意，决定把他扔进超星海洋。\\n洛菲菲抓着吊绳飞在空中，巴萨克没有挣扎，也没有闹嚷，两者就这么安静地飞了一段。\\n很快，超星海洋就出现在他们的视野中。\\n洛菲菲感觉到巴萨克重重地哼了一下。\\n“动手吧，本来我就该死在海里。”静默了几秒之后，巴萨克淡然地说。\\n“你还欠我一条命呢，别想着这么轻易就死掉。”洛菲菲说。\\n但在巴萨克眼中，是名为“最终兵器”的远古族在跟他说话，他觉得头上的最终兵器和传说中只会杀戮的刽子手有点不同。\\n刚才巴萨克没注意最终兵器是怎么说服邪王的，他一直以为最后救下他的会是暴虐战狂——虽然无论谁救了他，对他来说都是一种耻辱，但总比烧死在造唤台里好。\\n“呵，你想我做你的手下？”\\n“别太自以为是了，我只是要你给我送个口信。”\\n“你要在他们面前放了我吗？”巴萨克转过头，看了眼飞在他们后面的几条龙。\\n他看得出邪王还没有完全信任最终兵器，可没弄懂最终兵器究竟站在哪一边。\\n“有个成语叫‘生死有命’。”\\n“成语？什么意思？”\\n“如果你能活着到达冰川谷，就告诉月夕，邪王要先灭了她们两姐妹。”\\n“要是我不说呢？”\\n“那就算了——”\\n这么说着，最终兵器突然快速自转，吊着巴萨克的绳子也随之像坏掉的秒针一样加速旋转。\\n“喂，你想干什么！？”\\n“即使没有我的提醒，她们也不一定会死。不过你嘛……就一辈子偷偷摸摸地活下去吧——！”\\n巴萨克只比最终兵器矮一点，但最终兵器甩动绳子起来毫不吃力。\\n然后，像掷链球的运动员般，在离心力达到最大的一刻，瞅准远处的一个落地点，把巴萨克扔了出去。\\n“啊——！！”\\n身下的风景在巴萨克眼中飞速掠过，尽管是白茫茫的一片，但他仍能看到自己正在飞跃邪王雪岭旁边的海峡，向冰川谷飞去。\\n不知道从什么时候开始，他堕落成一个只会等着被救的废物——\\n如果不是古拉姆和温泉老板冲进石塔，他早就败在塔之守卫手上；\\n如果不是阴险奸邪的史卡非斯，他早就葬身海底；\\n如果不是把他打至满身伤痕的暴虐战狂，他已经化为造唤台中的熊熊火焰；\\n现在，放他一条活路的是最终兵器，虽然那家伙并没有保证能把他扔到冰川谷。\\n是啊……如果他连通风报信这事也做不到、或者不想做，那不如找个山洞偷偷摸摸地过完下辈子！\\n对自己充满着愤怒的想法，巴萨克重重地摔到一块浮冰上。",
    "messageInitNick_6719": "迷路的核膜",
    "resoundEventConfigDes_8017": "李雨蒙已经做好了身体被岩浆销融得无影无终的准备，可是，岩浆依旧在她脚下翻腾。她的手被一只强而有力的手拉着，抬头望上去，透过古拉姆的瞳孔，她看到林宇翔担心的脸。\\n“小姐，如果这家伙做了对不起你的事，我让你把他暴打一顿，绝不还手！”说话的是古拉姆。\\n“……”\\n李雨蒙张了张嘴，说不出话来，刚才的勇气已经消失殆尽，心头染上了另一层恐惧——这是游戏系统在阻止她吗？呵……连这都做不到呢。\\n“对、对不起，雨蒙酱大人！”换林宇翔说话了，“那时的表情包也是我搞的，但我已经接受你的惩罚了！”\\n这家伙在说什么？李雨蒙不解地看着林宇翔。\\n在首次试玩那个恐怖游戏的时候，林宇翔把李雨蒙各种尖叫表情做成表情包，这个表情包当天就在雨蒙酱的粉丝中红了一波，几天后流传得更广。\\n“你不是email了那个恐怖游戏的登录码给我吗？我就是那个发弹幕喷你手残的人……”林宇翔硬着头皮继续坦白。\\n“啊？”那段说不上愉快的记忆渐渐浮上了李雨蒙的心头。\\n她脚下的岩浆翻腾得越来越厉害，一个个橙金色的泡泡不断鼓起和涨裂，但她没有察觉，只是继续让自己的记忆对上林宇翔的解释。\\n“我就是在登录那个游戏的瞬间被传送过来的！来了之后一直被古拉姆同学按在地上摩擦！虽然这种超自然现象不是雨蒙酱大人造成的，但我一直把它看成是你对我降下的惩罚！”林宇翔也没有留意李雨蒙脚下的危机，只是迫切地、没完没了地倾诉着，“对了，你也是登录游戏的时候穿越过来的吗？”\\n“你能不能把她拉上来再说话？”古拉姆手一收，把李雨蒙往上拉。\\n日夕的重量对他来说完全不是个问题，但他另一只手下面的熔岩不断碎裂，掉进火山口。他趴着的这块地方，恐怕也撑不了多久。\\n虽然古拉姆的大剑也能发出强于一般火焰的力量，不过与火山的心脏比起来，还差得远。从盔甲外传来的火山岩的烫热，让他整个身体仿佛快要熔化一样。\\n突然，“轰隆”一声巨响，火山口爆出一股热气，把古拉姆和日夕往上推，一柱橙红的岩浆在滚滚浓烟的裹挟里喷涌而出，烧得通红的岩石被推到高空又疾驰落下。\\n他们开始往下掉，可是，身下除了浓烟就是岩浆，完全看不清落地点。\\n“古拉姆，我即使掉进火山里也没关系，但你怎么办？”日夕说话了。\\n大小姐，你刚才睡着了吗？\\n虽然很想这样吐槽，但古拉姆知道现在不是时候。\\n“埃癸斯！！”他大喊。\\n很快，一面巨盾冲破浓烟，飞到他身下。\\n古拉姆拉紧日夕，刚刚好掉落在重盾上。",
    "resoundEventConfigDes_8016": "林宇翔看到埃癸斯识趣地走开，满意地点点头。\\n“日夕小姐，能让我和雨蒙酱说几句话吗？”他重新看着“日夕”，“我一直是手残雨蒙酱的脑残粉。”\\n其实是颜粉，但这种让自己显得好色轻浮的事还是别说了。\\n“咦？你、你看过我的直播！？”\\n“手残雨蒙酱”正是李雨蒙的直播间网名。\\n“不是看过，而是一直在看，我还截了不少图当表情。”说着，林宇翔掏出了手机。\\n手机屏幕上像蜘蛛网一样的裂纹让他心头一抽，嘛，不可挽回的事先放一边，马上唤醒手机，耶，还能用。\\n“看，有一百多张截图。”林宇翔飞快地滑动手机，像一条讨好地看着主人的小狗，眼巴巴地看着李雨蒙。\\n有半数截图来自李雨蒙表情“失控”的瞬间，这份图集充分展现了林宇翔的奇怪喜好。\\n“看，多可爱！我第一天看你的直播，就知道你和直播间里其他整擦边的不一样，虽然你手残，但你坚强，虽然你不懂讨好粉丝，但你真诚，虽然你崩图无数，但你纯天然美女……”\\n其实林宇翔是真的喜欢雨蒙酱，一开始的毒舌只是想和女神开个玩笑，就像喜欢欺负喜欢的人，但看到越来越多人发弹幕跟着他起哄，他的喜欢有点变味了，雨蒙酱的直播间变成了他肆无忌惮地吐槽别人的地方，更糟糕的是，他还以为雨蒙酱喜欢这样的互动。\\n但凡一件事成为习惯，没有外力的破坏，就很难让人有意识地去改变。\\n幸亏“外力”来了，因为来到异世界，才让他有了自我反思的意识。\\n此刻他对雨蒙酱的赞美，饱含着浓浓的歉意。\\n但是，人家并没有感受到他这份心意。\\n李雨蒙的脸色一阵比一阵白。\\n“不对……”她倒退了一步。\\n林宇翔的手机中，保存着她刚做直播不久的图片，笨拙的妆容和羞涩的笑容——那是一年前的自己。\\n李雨蒙感到一股恶寒从脚底升起——\\n她究竟是从何时开始被盯上的呢？\\n除了直播间，QQ、微信、微博，甚至各种网购记录，难道这一切一直都在别人的监视之下？\\n选中她进入这个游戏的理由又是什么？是因为即使她消失了，也只会成为世界上一则无足轻重的新闻吗？\\n林宇翔的手机，正如海啸般冲击着李雨蒙之前构建的认知和心理防线。\\n日夕也感受到她强烈的情绪波动，但她以为是这些丑陋的“画像”让李雨蒙陷于恐惧。唔……如果呆会稍微教训一下对方，古拉姆不会介意吧？\\n“也不是很丑啦，某种程度上还挺可爱的。”日夕安慰到。\\n“不……不该是这样的……”但李雨蒙自顾自地否定着那种可怕的推测，没听她在说什么。\\n林宇翔看着她的眼神充满爱慕之情，但她越来越觉得那是两个冰冷的、永远不会停止工作的监控摄像头。\\n“走、走开！”李雨蒙推开林宇翔，转头就跑。\\n“唉？等等！”林宇翔追了上去。\\n李雨蒙慌不择路地逃呀逃，她觉得哪里都是监视她的眼睛。\\n“喂，你怎么了？”\\n日夕想夺回身体的控制权，但李雨蒙过于强烈的意志，把她困在意识的虚空中。\\n“他不是你朋友吗？你不是一直想和他说话吗？那些画像究竟有什么可怕的？”日夕已经感觉到李雨蒙不只是因为自己的样子有点丑而恐惧。\\n“闭嘴！闭嘴！闭嘴闭嘴闭嘴！！”李雨蒙捂着耳朵。\\n怎样才能离开吗？\\n难道只有那样才能离开吗？\\n不知道不知道不知道！\\n但现在除了这样她又能做什么！\\n在一片橙红的视野中，李雨蒙双眼的焦点开始锁定一座火山的火山口，仿佛那里就是游戏世界的出口。\\n她朝着火山口狂奔而去。\\n日夕知道李雨蒙想做什么，但她不会告诉李雨蒙，这样做是没用的，火山的赤热无法与太阳相比。在李雨蒙纵身一跃，精神完全崩溃的时候，她就可以夺回身体的控制权。\\n不过，紧追在后面的林宇翔并不知道这些，他担心着另一件事。\\n是认出自己就是那个喷子吗？感觉又不像……\\n“她不是你的朋友吗？”\\n“是我女神！”\\n“但她好像很讨厌你。”\\n“不要再往我心上插刀子了，古拉姆同学！”\\n林宇翔的心抽痛了一下，脚步一挫，和李雨蒙的距离拉开了一点。\\n“你怎么连女孩子也跑不过？”\\n古拉姆夺回身体的控制权，跨步追了上去。其实他也有点奇怪，日夕，好像变强了。\\n不过，还是晚了一步。\\n那道纤丽的身影已经带着决绝的意志朝火山口纵身跃下。",
    "8_43": "{1}/小时",
    "messageInitNick_6713": "超级蛋挞",
    "8_44": "可指派的怪兽数量已用完",
    "messageInitNick_6714": "天台封了",
    "resoundEventConfigDes_8018": "原来埃癸斯看到日夕突然跑向火山口的时候就留心起来，但觉得林宇翔可能还需要点空间和李雨蒙小姐谈点私事，于是便远远看着。\\n重盾像一只小船，载着古拉姆和日夕，随着奔腾而火热的熔岩流，顺着山体滑落。重盾慢慢下沉，在岩浆快要漫进盾里的时候，古拉姆抱着日夕跳出重盾，稳稳地落在一块火山岩上。\\n他放下日夕，飞快地拔出断剑，把剑斜斜地投掷而出。\\n断剑撞上盾牌的内侧边缘，重盾从浓稠的岩浆中往旁边的火山岩滑去，不偏不倚滑到了赶来的埃癸斯的脚边。\\n重新提起重盾的埃癸斯，把剑抛回到古拉姆手中。\\n“你们还真有默契。”日夕说。\\n然后，她把注意力转向意识虚空中的李雨蒙：“死不成，挺失望的是吧？”\\n“不是……”李雨蒙回答日夕的却是刚才林宇翔的问题，“我是在刚开始直播的时候就穿越过来了……”\\n她努力回忆着，自己和林宇翔穿越的契机的确不一样。\\n马克和欧文，这两个她原先以为是游戏NPC的男人，在她的世界也确有其人吗？\\n一个在比赛的休息期间穿越，一个在会议中穿越，他们的“消失”方式比自己更诡异。\\n所以并不是什么高科技企业见不得光的人体实验？\\n只是自己脑洞开错了吗？\\n也就是说，并不存在实验结束意识逃离的方法？\\n等等，这种穿越是魂穿还是身体也穿越过来了？如果是前者，根据自己在现实中让人沮丧的交友关系，自己的身体恐怕早就饿死甚至腐烂了吧。\\n李雨蒙无力地跪坐在意识的虚空中。\\n关于李雨蒙和林宇翔的对话，日夕没全听懂，但她大概明白了原来李雨蒙之前一直理解错了自己和这个世界的关系。\\n“如果你心中还有疑问的话，就向那个家伙问清楚。说不定以后我们就要以这种状态度过一生，你要是还对这个世界有什么误解的话，我可会很头疼哟。”日夕对李雨蒙说。\\n燃烧着的岩石不断从火山口迸射出来，在烟幕的空中留下千万条火红的划痕。\\n“我们快离开这里！”熔岩流的对岸，埃癸斯朝古拉姆和日夕挥了挥手。\\n“古拉姆同学，接下来就交给我吧！我要保护雨蒙酱！”\\n“好，以后你要是被什么敌人按在地上摩擦，我是不会出手帮忙的。”古拉姆意识一松。\\n“记仇的家伙。”林宇翔再次接管了身体。\\n“你啊，是位货真价实的女神呢，但我只是一个活在直播间里的不入流的网红……” 李雨蒙抬头，看着挺胸站在她面前的日夕，“……我要怎么办？”\\n“那就去进化、去接受你唯一的信徒的仰慕、去把自己变得高高在上，成为配得起我的伙伴。”\\n毫不动摇的意志、毫不困惑的态度、不容怀疑的话语，化成一点一滴的力量，注入李雨蒙心中。\\n是啊，只是认知改变了，情况并没有变得更好或者更糟。先冷静下来，好好思考现在的状况。日夕是真女神，得1分，这个人喜欢自己，再得1分。这样一想的话，处境不是比实验体好多了吗？虽然依然怕得要死，但起码，自己不再是孤身一人了。\\n她慢慢站起来，接过日夕交到她手上的身体，来到林宇翔跟前。\\n“林宇翔，带我下去。”接受信徒的爱，让它成为自己的力量。\\n“雨蒙酱大人，你想要我直接背，扛肩抱，还是……公主抱呢？”\\n“……背就好了。”\\n“是，雨蒙酱大人。“\\n背起李雨蒙，林宇翔用轻松就能超越岩浆流动的速度，和埃癸斯一起朝着火山脚飞奔。\\n哟呵，英雄救美，说的就是这么回事吧。\\n林宇翔浑身飘飘然的。\\n“瞧你美的，但你可别乱来，我和日夕是纯洁的合作与互助关系。”古拉姆提防着林宇翔那种小心思。\\n“你、你想到哪里去了！”林宇翔害羞地反驳，“我只是在尽一个绅士的义务，无论在什么情况下，绅士都要保护好他身边的Lady。”\\n李雨蒙雪白纤细的手臂挂在他的脖子上，她皮肤上的温热似乎加速了他的心跳。\\n不过，不知道是不是他看错了，李雨蒙白到发亮的手臂上，偶尔闪烁着暗紫色的流动。\\n不、不会的，应该是刚才被我吓坏了，身体才会出现异常。\\n非礼勿视非礼勿视，别再胡思乱想了，不能让古拉姆也察觉到这种无聊的细节。\\n林宇翔摇摇头，加快了奔跑的脚步。",
    "8_41": "暴走旷野",
    "messageInitNick_6715": "抬杠小能手",
    "8_42": "产出",
    "messageInitNick_6716": "打脸王子",
    "randomEventDialogueGroupConfig_13.239": "你发现根本没有所谓的客人，而神秘商人则刚迈出一步就倒在了地上，它的手指着一个方向……",
    "randomEventDialogueGroupConfig_13.238": "它听完迟疑了一会，揉了揉眼，打了个哈欠，又勉强打起精神。",
    "randomEventDialogueGroupConfig_13.233": "神秘商人说着便倒在了地上。",
    "resoundEventStoryName_493": "十八叉叉叉阵",
    "randomEventDialogueGroupConfig_13.232": "嘿嘿，这你就不懂了吧，你看这是什么，远离猝死，工作必备哦！",
    "resoundEventStoryName_492": "击股传花神功",
    "randomEventDialogueGroupConfig_13.231": "反问它猝死了怎么办",
    "resoundEventStoryName_495": "上古防魔洞",
    "skillDes_39": "星陨会使敌方怪兽的真实伤害降低{level_based}%，持续{p1}秒",
    "randomEventDialogueGroupConfig_13.230": "我怎么错了？",
    "resoundEventStoryName_494": "仓帮",
    "randomEventDialogueGroupConfig_13.237": "捡起",
    "resoundEventStoryName_497": "笑动峡谷",
    "skillDes_37": "触发星陨时，回复攻击力×{level_based}%的血量",
    "randomEventDialogueGroupConfig_13.236": "看起来已经没法拯救的样子，甚至还有什么东西从它身上爆了出来。",
    "resoundEventStoryName_496": "宝衣甲",
    "skillDes_38": "触发星陨时，回复攻击力×{level_based}%的血量",
    "randomEventDialogueGroupConfig_13.235": "上前拯救",
    "resoundEventStoryName_499": "砍一刀",
    "skillDes_35": "星陨会使敌方怪兽攻击力降低{level_based}%，持续{p1}秒",
    "randomEventDialogueGroupConfig_13.234": "离开",
    "resoundEventStoryName_498": "共识",
    "skillDes_36": "星陨会使敌方怪兽受到的伤害提升{level_based}%，持续{p1}秒",
    "8_58": "野生怪",
    "messageInitNick_11088": "超污小萌神",
    "skillDes_44": "引力会贯穿{level_based}个敌方怪兽，每贯穿1次伤害降低{p1}%",
    "8_59": "需要先占领该节点才能选择",
    "messageInitNick_11087": "衣架破坏者",
    "skillDes_45": "触发引力时，攻击速度提升{level_based}%，持续{p1}秒",
    "8_56": "联结邀请",
    "messageInitNick_11086": "泡沫森林",
    "skillDes_42": "引力造成的伤害提升{level_based}%",
    "8_57": "野生怪兽!",
    "messageInitNick_11085": "贴贴宝贝",
    "skillDes_43": "引力会使敌方怪兽移动速度降低{level_based}%，持续{p1}秒",
    "skillDes_40": "星陨会使敌方怪兽的生物屏障降低{level_based}%，持续{p1}秒",
    "skillDes_41": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{p1}%的伤害，且击退{level_based}码",
    "resoundEventStoryName_491": "真血功林",
    "messageInitNick_11089": "帝国少女",
    "resoundEventStoryName_490": "大蛮飞头",
    "8_50": "开拓之地",
    "messageInitNick_11080": "爱上了他",
    "8_51": "舛误之地",
    "8_54": "星律挂机: {1}/{2}H  仓库：{3}/{4}",
    "messageInitNick_11084": "天才之子",
    "8_55": "{1}正在挑战当前复制体",
    "messageInitNick_11083": "我钟意你吖",
    "8_52": "崩坠之地",
    "messageInitNick_11082": "如你所愿",
    "8_53": "诡潮之地",
    "messageInitNick_11081": "特别好人",
    "randomEventDialogueGroupConfig_13.249": "它一边说话眼皮一边往下掉。",
    "randomEventDialogueGroupConfig_13.244": "啊不，我的重生元核是什么时候换来着……",
    "randomEventDialogueGroupConfig_13.243": "离开",
    "randomEventDialogueGroupConfig_13.242": "地上歪歪扭扭写着几行字，不要停下来。",
    "skillDes_28": "虹吸每{p1}秒对敌方怪兽造成其当前血量×{level_based}%的伤害，最大伤害为{owner}的攻击力×{p2}%，持续{p3}秒",
    "randomEventDialogueGroupConfig_13.241": "离开",
    "skillDes_29": "触发虹吸时，攻击速度提升{level_based}%，持续{p1}秒",
    "randomEventDialogueGroupConfig_13.248": "离开",
    "skillDes_26": "{owner}的血量回复效果提升{level_based}%",
    "randomEventDialogueGroupConfig_13.247": "神秘商人念着念着就睡着了。",
    "skillDes_27": "虹吸对血量低于{p1}%的敌方怪兽额外造成{owner}攻击力×{level_based}%的真实伤害",
    "randomEventDialogueGroupConfig_13.246": "放心交易",
    "skillDes_24": "不死·尸气会使敌方怪兽的霸气降低{level_based}%，持续{p1}秒",
    "randomEventDialogueGroupConfig_13.245": "神秘商人掏出一堆重生元核，得意洋洋的样子。",
    "skillDes_25": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{p1}%的伤害，且偷取其当前血量的{level_based}%",
    "8_69": "联结共鸣成功",
    "messageInitNick_11099": "不想加班",
    "skillDes_33": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，召唤流星从天而降，对血量最少的敌方怪兽造成攻击力×{level_based}%的伤害",
    "messageInitNick_11098": "通知你了",
    "skillDes_34": "死亡时，召唤一颗巨大的流星，对血量最少的敌方怪兽造成攻击力×{level_based}%的伤害",
    "8_67": "只能拥有一个领地，你已占领了其他领地，更换领地会导致原领地斗技场排名清空，斗技场积分-{1}（最低降至{2}）？",
    "messageInitNick_11097": "甜咸椰子",
    "skillDes_31": "虹吸·抹煞的伤害提升{level_based}%",
    "8_68": "\\n冷却时间：{1}",
    "messageInitNick_11096": "过期的情人",
    "skillDes_32": "虹吸·腐化被清除时，造成攻击力×{level_based}%的真实伤害",
    "randomEventDialogueGroupConfig_13.240": "过去看看",
    "skillDes_30": "触发虹吸时，回复攻击力×{level_based}%的血量",
    "8_61": "{1}的游荡智者",
    "messageInitNick_11091": "我飞得好高",
    "8_62": "复制体已离开",
    "messageInitNick_11090": "大狗勾",
    "8_60": "探索者处于狩猎者模式时，每小时获得{1}狩猎勋章（自动增加，不需手动获取），不足1小时（中途切换至普通模式），不会获得狩猎勋章。",
    "8_65": "{1}产出",
    "messageInitNick_11095": "核膜",
    "8_66": "搬迁",
    "messageInitNick_11094": "甲鱼过家家",
    "8_63": "游荡智者已离开",
    "messageInitNick_11093": "爱江山爱美人",
    "8_64": "我的主城",
    "messageInitNick_11092": "尖叫树莓",
    "98_-210019": "兑换码无需绑定",
    "98_-210016": "无效的兑换码",
    "8_80": "{1}阵上探索的怪兽已全部消失",
    "98_-210015": "兑换异常，请稍后再试",
    "98_-210018": "不允许绑定密令",
    "98_-210017": "兑换码不可用",
    "randomEventDialogueGroupConfig_13.255": "捡起",
    "skillDes_19": "触发不死时，为所有己方怪兽回复{owner}最大血量×{level_based}%的血量",
    "randomEventDialogueGroupConfig_13.254": "看起来已经没法拯救的样子，有什么东西从它身上爆了出来。",
    "randomEventDialogueGroupConfig_13.253": "捡起",
    "skillDes_17": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，回复最大血量×{level_based}%的血量",
    "randomEventDialogueGroupConfig_13.252": "商店门在你前面关上了，有什么从商店里飞了出来掉到地上。",
    "skillDes_18": "血量低于{p1}%时，不死回复的血量提升{level_based}%",
    "skillDes_15": "龙焰·黯炎的持续时间提升{level_based}%",
    "skillDes_16": "龙焰会使范围内的己方怪兽获得{owner}攻击力×{level_based}%的护盾，持续{p1}秒",
    "skillDes_13": "触发龙焰时，攻击力提升{level_based}%，持续{p1}秒",
    "skillDes_14": "触发龙焰时，攻击速度提升{level_based}%，持续{p1}秒",
    "messageInitNick_11066": "专业气氛组",
    "skillDes_22": "触发不死时，移动速度提升{level_based}%，持续{p1}秒",
    "messageInitNick_11065": "风铃仙子",
    "skillDes_23": "不死·根性会使己方怪兽受到的伤害降低{level_based}%，持续{p1}秒",
    "8_78": "切换至普通模式后不会被其他探索者狩猎，但无法持续获得狩猎勋章，是否马上切换？",
    "messageInitNick_11064": "还在非洲",
    "skillDes_20": "触发不死时，造成最大血量×{level_based}%的区域伤害（{p1}码）",
    "8_79": "全部开始探索",
    "messageInitNick_11063": "极窄宽带",
    "skillDes_21": "触发不死时，霸气提升{level_based}%，持续{p1}秒",
    "randomEventDialogueGroupConfig_13.251": "先去商店",
    "messageInitNick_11069": "异次元玫瑰",
    "randomEventDialogueGroupConfig_13.250": "继续拯救",
    "messageInitNick_11068": "温泉常客",
    "messageInitNick_11067": "天王灰灰狼",
    "8_72": "尚未开启",
    "98_-210012": "兑换异常，请稍后再试",
    "8_73": "需手动使用传送门才能前往",
    "98_-210011": "兑换次数已达到上限",
    "8_70": "查看录像",
    "98_-210014": "无效的兑换码",
    "8_71": "深渊先遣",
    "98_-210013": "无效的兑换码",
    "8_76": "{1}已解锁",
    "messageInitNick_11062": "不在让你孤单",
    "8_77": "星律挂机: {1}/{2}H",
    "messageInitNick_11061": "火焰热哭了",
    "8_74": "占领",
    "98_-210010": "兑换码不可用",
    "messageInitNick_11060": "健忘的少女",
    "8_75": "（传送冷却中{1}）",
    "98_-210009": "兑换码不可用",
    "98_-210008": "兑换码不可用",
    "8_90": "肉肉山正在源源不断的为你产出怪兽经验",
    "98_-210005": "兑换码已兑换",
    "8_91": "金矿山正在源源不断的为你产出金币",
    "98_-210004": "无效的兑换码",
    "98_-210007": "兑换码不在有效期内",
    "98_-210006": "无效的兑换码",
    "messageInitNick_11077": "用回第一版",
    "messageInitNick_2791": "尬聊小能手",
    "skillDes_11": "龙焰对敌方怪兽每{p1}秒造成攻击力×{level_based}%的伤害，持续{p2}秒",
    "messageInitNick_11076": "暴风吸入晚餐",
    "messageInitNick_2792": "一万个舍不得",
    "skillDes_12": "龙焰会使范围内的己方怪兽回复{owner}攻击力×{level_based}%的血量",
    "8_89": "问卷调查{1}",
    "messageInitNick_11075": "隔壁牙科医生",
    "messageInitNick_11074": "化茧成蝶",
    "messageInitNick_2790": "安徒生的谎言",
    "skillDes_10": "龙焰的范围增大{level_based}%",
    "messageInitNick_2795": "抬杠王",
    "messageInitNick_2796": "怪话小王子",
    "messageInitNick_11079": "出逃发射器",
    "messageInitNick_2793": "好喝再尝一口",
    "messageInitNick_11078": "重新定义暴富",
    "messageInitNick_2794": "鸡蛋拌香蕉",
    "8_83": "最多输入{1}字（已输入{2}字），请调整输入内容",
    "98_-210001": "cjhwy2",
    "messageInitNick_2799": "奇迹之风",
    "8_84": "是否退出联结共鸣？",
    "98_-210000": "兑换出错了!",
    "8_81": "（真棒，答对了！）",
    "98_-210003": "操作过于频繁，请稍后再试",
    "messageInitNick_2797": "等雨停",
    "8_82": "（回答错误，请看勾，那才是正确答案！）",
    "98_-210002": "签名错误",
    "messageInitNick_2798": "杯子剑客",
    "8_87": "探索者等级达到{1}时，即可开始吸收超进化大陆的力量，每小时自动产出探索者经验{2}。",
    "messageInitNick_11073": "职业摸鱼",
    "8_88": "问卷合集",
    "messageInitNick_11072": "算了不生气",
    "8_85": "【强援】{1}",
    "messageInitNick_11071": "行走的桂皮",
    "8_86": "【暴进{1}】{2}",
    "messageInitNick_11070": "摸鱼的快乐",
    "emblemEffectConfigName_2": "体力",
    "emblemEffectConfigName_1": "攻击力",
    "emblemEffectConfigName_4": "真实伤害",
    "emblemEffectConfigName_3": "生物屏障",
    "emblemEffectConfigName_6": "普攻恢复",
    "emblemEffectConfigName_5": "自愈恢复",
    "skillDes_79": "传说之力变为不可封印，触发传说之力时，攻击力最高的己方怪兽攻击力提升{level_based}%，持续{p1}秒",
    "messageInitNick_2780": "高易冷",
    "skillDes_88": "战斗开始时，站位第一的己方怪兽进入月轮状态（每隔{level_based}秒清除所有负面效果，成功清除负面效果时，清除前方（{p1}码）的敌方怪兽{p2}个持续时间最长的增益效果），持续至{owner}死亡",
    "messageInitNick_2781": "不再说从前",
    "skillDes_89": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，回复最大血量×{level_based}%的血量",
    "skillDes_86": "逆转之力为己方怪兽每{p1}秒回复最大血量×{level_based}%的血量，持续{p2}秒",
    "skillDes_87": "战斗开始时，站位第五的己方怪兽进入日轮状态（获得{owner}{level_based}%的攻击力），破韧提升{p1}，持续至{owner}死亡",
    "messageInitNick_2784": "螺蛳粉吸收者",
    "skillDes_84": "逆转之力会使己方怪兽受到的伤害降低{level_based}%，坚韧提升{p1}，持续{p2}秒",
    "messageInitNick_2785": "搬砖机器",
    "skillDes_85": "逆转弹会使敌方怪兽受到的伤害提升{level_based}%，攻击力降低{level_based}%，持续{p1}秒",
    "messageInitNick_2782": "怪话教主",
    "skillDes_82": "触发逆转之力时，为所有己方怪兽回复{owner}攻击力×{level_based}%的血量",
    "messageInitNick_2783": "流浪的闲猫",
    "skillDes_83": "触发逆转之力时，发射一枚逆转弹，对血量最少的敌方怪兽造成攻击力×{level_based}%的伤害",
    "8_94": "任务挑战",
    "emblemEffectConfigName_8": "体力",
    "messageInitNick_2788": "孤单它好残忍",
    "skillDes_80": "传说之力变为不可封印，触发传说之力时，{owner}和身后所有己方怪兽受到的伤害降低{level_based}%，坚韧提升{p1}，持续{p2}秒",
    "8_95": "可收获",
    "emblemEffectConfigName_7": "攻击",
    "messageInitNick_2789": "苍老谁红尘醉",
    "skillDes_81": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，为血量百分比最少的己方怪兽回复攻击力×{level_based}%的血量。\\n触发{p1}次逆转之力后可主动释放逆转轮回，血量百分比最少的己方怪兽获得{owner}攻击力×{p2}%的护盾，持续{p3}秒",
    "8_92": "占领后增加星律的{1}挂机产出",
    "messageInitNick_2786": "零花钱飞了",
    "8_93": "世界探索度",
    "emblemEffectConfigName_9": "屏障",
    "messageInitNick_2787": "国民小公举",
    "8_98": "退出",
    "8_99": "成功率",
    "8_96": "是否消耗{1}钻石找回{2}探索者经验？\\n最多可找回2000探索者经验",
    "8_97": "免费搜索",
    "randomEventDialogueGroupConfig_13.208": "成交",
    "randomEventDialogueGroupConfig_13.207": "“再加这么多！”#神秘商人向你比了个手势。",
    "randomEventDialogueGroupConfig_13.206": "成交",
    "randomEventDialogueGroupConfig_13.205": "“好的一手交货一手交换做法！”",
    "randomEventDialogueGroupConfig_13.209": "坚决离开",
    "randomEventDialogueGroupConfig_13.200": "好哇，趁我睡着你干嘛了，我打——！",
    "randomEventDialogueGroupConfig_13.204": "执意离开",
    "randomEventDialogueGroupConfig_13.203": "同意交易",
    "randomEventDialogueGroupConfig_13.202": "如果我的商店后面增加这个业务，我就可以一直不睡觉做生意，也可以卖给其他商人哈哈哈。不如咱们做个交易，怎样。”#神秘商人两手掌心相对搓了搓手。",
    "skillDes_68": "混沌之力造成伤害的{level_based}%用于回复自身血量",
    "randomEventDialogueGroupConfig_13.201": "战斗",
    "skillDes_69": "混沌之力会击退敌方怪兽{level_based}码",
    "skillDes_77": "触发传说之力时，所有己方怪兽受到神剑祝福，攻击力提升{level_based}%，持续{p1}秒",
    "messageInitNick_2770": "导演我躺哪",
    "skillDes_78": "传说之力会使{owner}忽视敌方霸气{level_based}%，持续{p1}秒",
    "skillDes_75": "传说之力会使{owner}的普通攻击额外造成最大血量×{level_based}%的真实伤害，持续{p1}秒",
    "skillDes_76": "触发传说之力时，回复最大血量×{level_based}%的血量，溢出的回复量将转变为护盾，持续{p1}秒",
    "messageInitNick_2773": "新模式对手",
    "skillDes_73": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，受到的伤害降低{level_based}%，持续{p1}秒。\\n触发{p2}次传说之力后可主动释放传说之躯，获得无敌效果，持续{p3}秒",
    "messageInitNick_2774": "爱吃苹果",
    "skillDes_74": "触发传说之力时，所有己方怪兽的霸气提升{level_based}%，持续{p1}秒",
    "messageInitNick_2771": "椰子龙",
    "skillDes_71": "混沌之力会使敌方怪兽受到的伤害提升{level_based}%，持续{p1}秒",
    "messageInitNick_2772": "哪个大花",
    "skillDes_72": "混沌之力会使敌方怪兽血量回复效果降低{level_based}%，持续{p1}秒",
    "messageInitNick_2777": "孤单的守护者",
    "messageInitNick_2778": "给电视机道歉",
    "skillDes_70": "混沌之力的范围增大{level_based}%",
    "messageInitNick_2775": "长得抽象",
    "messageInitNick_2776": "猫德学院老师",
    "messageInitNick_2779": "万能洗衣机",
    "randomEventDialogueGroupConfig_13.219": "“哈哈，你真懂我，说到这个我就不困了，不对我努力不困。欢迎光临！”",
    "randomEventDialogueGroupConfig_13.218": "离开",
    "randomEventDialogueGroupConfig_13.217": "神秘商人倒地不起，分不清是被打晕了，还是睡着了。",
    "randomEventDialogueGroupConfig_13.216": "换个方式",
    "randomEventDialogueGroupConfig_13.211": "成交",
    "randomEventDialogueGroupConfig_13.210": "很好，一手交货一手交换做法！",
    "randomEventDialogueGroupConfig_13.215": "执意出手",
    "skillDes_59": "静默的封印效果持续秒数提升{level_based}%",
    "randomEventDialogueGroupConfig_13.214": "冷静，我已经清醒了，真的别动手。",
    "randomEventDialogueGroupConfig_13.213": "离开",
    "skillDes_57": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，且造成封印效果，持续{p1}秒",
    "randomEventDialogueGroupConfig_13.212": "好吧，不愿意就算了。不送。",
    "skillDes_58": "静默会使敌方怪兽的霸气降低{level_based}%，持续{p1}秒",
    "skillDes_66": "{owner}血量低于{p1}%时，进入觉醒状态（攻击力提升{level_based}%，受到的伤害降低{level_based}%）",
    "skillDes_67": "触发混沌之力时，攻击力和移动速度提升{level_based}%，破韧提升{p1}，持续{p2}秒，最多叠加{p3}次，叠加时刷新持续时间",
    "skillDes_64": "静默的封印效果每{level_based}秒清除一个持续时间最长的增益效果",
    "skillDes_65": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的范围伤害（{p1}码）。\\n触发{p2}次混沌之力后可主动释放混沌兽化，进入兽化状态（攻击力提升{p3}%，免疫且清除所有负面效果，在敌方半场时忽视敌方伤害降低效果{p4}%），持续{p5}秒",
    "messageInitNick_2762": "添加失败",
    "skillDes_62": "触发静默时，攻击速度提升{level_based}%，持续{p1}秒",
    "messageInitNick_2763": "嘟嘟熊",
    "skillDes_63": "静默的封印效果被清除时，{owner}的攻击速度提升{level_based}%，持续{p1}秒",
    "messageInitNick_2760": "痴心少年",
    "skillDes_60": "静默会使敌方怪兽血量回复效果降低{level_based}%，持续{p1}秒",
    "messageInitNick_2761": "牛牛我啊",
    "skillDes_61": "触发静默时，攻击速度提升{level_based}%，持续{p1}秒",
    "messageInitNick_2766": "电子蜜枣",
    "messageInitNick_2767": "无公害西瓜",
    "messageInitNick_2764": "六点的蒸蛋",
    "messageInitNick_2765": "抚琴笑沧桑",
    "messageInitNick_2768": "青梅竹子",
    "messageInitNick_2769": "猫爷",
    "randomEventDialogueGroupConfig_13.229": "不再管它",
    "randomEventDialogueGroupConfig_13.228": "说它错了",
    "randomEventDialogueGroupConfig_13.227": "怎么不行了！只要我不赚钱，就可以睡更多！#哦呸，只要我不睡觉，就可以赚更多钱。",
    "randomEventDialogueGroupConfig_13.222": "努力劝说它去睡",
    "randomEventDialogueGroupConfig_13.221": "我真的……真的没问题的相信我，快来看看吧！",
    "randomEventDialogueGroupConfig_13.220": "交易",
    "randomEventDialogueGroupConfig_13.226": "啊，我看到下一位客人了，你，浪费我时间，我去招呼人家了。再见！",
    "skillDes_48": "引力会使敌方近战怪兽体型缩小{level_based}%，持续{p1}秒",
    "randomEventDialogueGroupConfig_13.225": "说它这样做生意不行",
    "skillDes_49": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，获得偏移效果，持续{level_based}秒",
    "randomEventDialogueGroupConfig_13.224": "尽力劝它去睡",
    "skillDes_46": "触发引力时，攻击力提升{level_based}%，持续{p1}秒",
    "randomEventDialogueGroupConfig_13.223": "到底买不买啊？",
    "skillDes_47": "引力会使敌方远程怪兽攻击速度降低{level_based}%，持续{p1}秒",
    "skillDes_55": "骗术·反击的持续时间提升{level_based}%",
    "skillDes_56": "骗术·联结会使己方怪兽的生物屏障提升{level_based}%，持续{p1}秒",
    "skillDes_53": "触发骗术时，移动速度提升{level_based}%，持续{p1}秒",
    "skillDes_54": "触发骗术时，霸气提升{level_based}%，持续{p1}秒",
    "messageInitNick_2751": "阿伟睡了",
    "skillDes_51": "触发骗术时，获得{level_based}%的反伤效果，持续{p1}秒",
    "messageInitNick_2752": "无公害油菜",
    "skillDes_52": "每{level_based}秒所有己方怪兽获得偏移效果",
    "messageInitNick_2750": "利他主义者",
    "skillDes_50": "触发骗术时，受到的伤害降低{level_based}%，持续{p1}秒",
    "messageInitNick_2755": "看我的猫吗",
    "messageInitNick_2756": "无名",
    "messageInitNick_2753": "柿子兽",
    "messageInitNick_2754": "芹菜真好吃",
    "messageInitNick_2759": "萝卜萝卜糕",
    "messageInitNick_2757": "假面人",
    "messageInitNick_2758": "还没发工资",
    "battlePassTaskDes_38": "挑战世界灾厄{1}次",
    "battlePassTaskDes_39": "起源殿战斗{1}次",
    "battlePassTaskDes_40": "暴走旷野战斗{1}次",
    "messageInitNick_2740": "亲切的敌人",
    "messageInitNick_2741": "原来是昨天",
    "battlePassTaskDes_47": "赠送友好点数{1}次",
    "messageInitNick_2744": "大脑准生证",
    "battlePassTaskDes_48": "怪兽饲星{1}次",
    "messageInitNick_2745": "小鬼头萌萌哒",
    "battlePassTaskDes_45": "分解或熔炼元核{1}次",
    "messageInitNick_2742": "没有保质期",
    "battlePassTaskDes_46": "通关{1}次浮空巨塔",
    "messageInitNick_2743": "野惯了",
    "battlePassTaskDes_43": "凿星裂痕通关{1}次",
    "messageInitNick_2748": "听一半的曲",
    "battlePassTaskDes_44": "击破复制体{1}次",
    "messageInitNick_2749": "花式摸鱼冠军",
    "battlePassTaskDes_41": "挑战猎物{1}次",
    "messageInitNick_2746": "留不住那年",
    "battlePassTaskDes_42": "黑暗森林探索{1}次",
    "messageInitNick_2747": "自备筷子",
    "messageInitNick_2739": "特地仰望星空",
    "battlePassTaskDes_29": "起源殿段位达到高阶及以上",
    "battlePassTaskDes_27": "领取{1}次怪兽探险奖励",
    "battlePassTaskDes_28": "领取{1}次世界灾厄奖励",
    "messageInitNick_2730": "橙汁世界",
    "battlePassTaskDes_36": "部落支配核心捐献{1}次",
    "messageInitNick_2733": "蓝莓爱好者",
    "battlePassTaskDes_37": "商店购买物品{1}次",
    "messageInitNick_2734": "再生拖鞋",
    "battlePassTaskDes_34": "挑战关卡{1}次",
    "messageInitNick_2731": "瓜子斗士",
    "battlePassTaskDes_35": "消耗部落战令{1}次",
    "messageInitNick_2732": "巧克力之吻",
    "battlePassTaskDes_32": "消耗部落战令{1}次",
    "messageInitNick_2737": "从大佬到萌新",
    "battlePassTaskDes_33": "星律收获{1}次",
    "messageInitNick_2738": "夜幕降临",
    "battlePassTaskDes_30": "斗技场积分达到{1}及以上",
    "messageInitNick_2735": "果酱味奶糖",
    "battlePassTaskDes_31": "捕捉野生怪兽{1}次",
    "messageInitNick_2736": "与寂寞有染",
    "messageInitNick_2728": "杨桃真好吃",
    "messageInitNick_2729": "戒指王子",
    "battlePassTaskDes_18": "部落支配核心捐献{1}次",
    "battlePassTaskDes_19": "挑战{1}次部落图腾",
    "battlePassTaskDes_16": "怪兽饲星{1}次",
    "battlePassTaskDes_17": "部落遗迹中战斗{1}次",
    "battlePassTaskDes_25": "击败{1}次深渊先遣",
    "messageInitNick_2722": "脚踩棉花糖",
    "battlePassTaskDes_26": "领取{1}次暴走旷野排行榜奖励",
    "messageInitNick_2723": "把你养成猪",
    "battlePassTaskDes_23": "升级领地建筑{1}次",
    "messageInitNick_2720": "我不做人类了",
    "battlePassTaskDes_24": "参与{1}次部落战",
    "messageInitNick_2721": "深耕摸鱼领域",
    "battlePassTaskDes_21": "星律超跃{1}次",
    "messageInitNick_2726": "雪莲果魔法师",
    "battlePassTaskDes_22": "漆黑之根升级{1}次",
    "messageInitNick_2727": "划过的流星",
    "messageInitNick_2724": "出逃鳄鱼宝宝",
    "battlePassTaskDes_20": "造唤台累计造唤{1}次",
    "messageInitNick_2725": "高傲男神",
    "messageInitNick_2719": "内牛满面",
    "messageInitNick_2717": "春夏秋东西",
    "messageInitNick_2718": "等风说晚安",
    "battlePassTaskDes_14": "通关{1}次浮空巨塔",
    "messageInitNick_2711": "巧克力友谊",
    "battlePassTaskDes_15": "赠送友好点数{1}次",
    "messageInitNick_2712": "爱在草原",
    "battlePassTaskDes_12": "击破复制体{1}次",
    "battlePassTaskDes_13": "分解或熔炼元核{1}次",
    "messageInitNick_2710": "沉浸式梦游",
    "battlePassTaskDes_10": "黑暗森林探索{1}次",
    "messageInitNick_2715": "小懒猪",
    "battlePassTaskDes_11": "凿星裂痕通关{1}次",
    "messageInitNick_2716": "陶醉的画框",
    "messageInitNick_2713": "油菜真好吃",
    "messageInitNick_2714": "巅峰的萌新",
    "messageInitNick_2708": "豌豆先锋",
    "messageInitNick_2709": "带薪如厕",
    "messageInitNick_2706": "给颗糖就不哭",
    "messageInitNick_2707": "求偶失败的人",
    "activityNodeName_151": "友谊的力量#爱情的威力",
    "messageInitNick_2700": "星际传阅",
    "activityNodeName_152": "猫属性#大爆发",
    "messageInitNick_2701": "暴走的软糖",
    "activityNodeName_150": "退击#进守",
    "messageInitNick_2704": "环保电力",
    "messageInitNick_2705": "按时吃饭",
    "messageInitNick_2702": "正确的吃放",
    "messageInitNick_2703": "超级跑调神",
    "activityNodeName_148": "狂A#暴锤",
    "activityNodeName_149": "单前排#五后排",
    "activityNodeName_146": "小短腿#小短手",
    "activityNodeName_147": "请停止治疗#请继续治疗",
    "9_1": "移动力上限",
    "9_2": "每小时产出{1}",
    "9_3": "骨木鳞存储上限",
    "9_4": "探索可指派怪兽",
    "9_5": "解锁起源基石位置",
    "9_6": "免费刷新（分钟）",
    "9_7": "战争号角效果",
    "9_8": "解锁漆黑之根能力",
    "9_9": "排行榜",
    "activityNodeName_145": "漆黑组件#狂潮形态",
    "battlePassTaskDes_61": "起源殿段位达到高阶及以上",
    "battlePassTaskDes_62": "斗技场积分达到{1}及以上",
    "battlePassTaskDes_60": "领取{1}次世界灾厄奖励",
    "battlePassTaskDes_63": "捕捉野生怪兽{1}次",
    "battlePassTaskDes_64": "消耗部落战令{1}次",
    "battlePassTaskDes_49": "部落遗迹中战斗{1}次",
    "battlePassTaskDes_50": "部落支配核心捐献{1}次",
    "battlePassTaskDes_51": "挑战{1}次部落图腾",
    "battlePassTaskDes_58": "领取{1}次暴走旷野排行榜奖励",
    "battlePassTaskDes_59": "领取{1}次怪兽探险奖励",
    "battlePassTaskDes_56": "参与{1}次部落战",
    "battlePassTaskDes_57": "击败{1}次深渊先遣",
    "battlePassTaskDes_54": "漆黑之根升级{1}次",
    "battlePassTaskDes_55": "升级领地建筑{1}次",
    "battlePassTaskDes_52": "造唤台累计造唤{1}次",
    "battlePassTaskDes_53": "星律超跃{1}次",
    "randomEventDialogueGroupConfig_8.26": "1D100=99#眼前的景象的外廓不详地抖动拧合分离扭曲。#无法理解的话语在心底和远处嗤嗤作响，混沌随之钻入脊柱，刺入心扉……#你歇斯底里地哭笑嘶吼，而后陷入长久的呆滞。#不可名状的黑线沿着眼球中的血丝遮蔽了双眼。#再次睁眼时，你早已遗忘了一切，唯有一丝无以名状的感觉残留心底……",
    "randomEventDialogueGroupConfig_8.25": "离开",
    "skillDes_320": "影替状态会使被绑定的怪兽的普通攻击附带{owner}攻击力×{level_based}%的伤害，冷却时间{p1}秒",
    "randomEventDialogueGroupConfig_8.24": ".r d100=40#你双眼一黑，晕了过去，再次醒来神秘商人已经不见了",
    "randomEventDialogueGroupConfig_8.23": "丢下赶紧离开",
    "randomEventDialogueGroupConfig_8.22": "2d10=1#你直冒冷汗，隐约记得那是智者跟你提到过的含笑半步稽蛇。#拿着它笑或者走半步就会永久滑稽，非常危险。",
    "skillDes_323": "影替状态会使被绑定的怪兽拥有护盾时，霸气提升{level_based}%，击退变为恒定击退",
    "randomEventDialogueGroupConfig_8.21": "1D100",
    "skillDes_324": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，回复最大血量×{p1}%的血量，对敌方怪兽造成{owner}最大血量×{level_based}%的区域伤害（{p2}码），并击退敌人{p3}码",
    "randomEventDialogueGroupConfig_8.20": ".r d100",
    "skillDes_321": "敌方怪兽受到致死的伤害时，被绑定的怪兽获得自身最大血量×{level_based}%的护盾，冷却时间{p1}秒",
    "skillDes_322": "{owner}的普通攻击附带被绑定怪兽最大血量×{level_based}%的伤害，冷却时间{p1}秒",
    "skillDes_327": "每当敌方怪兽回复的血量总和达到{owner}最大血量×{p1}%时，{owner}的坚韧提升{level_based}，持续{p2}秒",
    "skillDes_328": "{owner}的增益效果被清除时，回复{level_based}能量，冷却时间{p1}秒",
    "skillDes_325": "触发擂槌时，创造一个逆流区域（{p1}码），逆流区域内的敌方怪兽血量回复效果降低{level_based}%，逆流区域持续{p2}秒",
    "skillDes_326": "逆流区域内的敌方怪兽坚韧降低{level_based}，己方怪兽破韧提升{level_based}",
    "randomEventDialogueGroupConfig_8.29": "离开",
    "randomEventDialogueGroupConfig_8.28": "被你丢向远处的黑色物体发出奇怪的叫声，你失去了意识。#清醒过来以后，神秘商人已经离开了。",
    "skillDes_329": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对血量最高和最少的敌方怪兽造成攻击力×{level_based}%的伤害",
    "randomEventDialogueGroupConfig_8.27": "离开",
    "randomEventDialogueGroupConfig_8.40": "拾取",
    "randomEventDialogueGroupConfig_8.37": "放回原位继续摸索其它地方",
    "randomEventDialogueGroupConfig_8.36": "你又摸到了什么，拿起来一看是一个有不少破损的褪色勋章，上有两把交叠的剑。#勋章的背后大量刻痕，是许多不同的名字。",
    "randomEventDialogueGroupConfig_8.35": "离开。",
    "randomEventDialogueGroupConfig_8.34": "面具的边缘刺出了许多石爪，你当然没有变得害怕阳光，甚至还觉得石爪的头部按摩力度刚刚好。#这时，它向你挥了挥手说，“我找到了，谢谢您。”",
    "randomEventDialogueGroupConfig_8.33": "不是这个呢。啊！我找到了我的了，谢谢您。",
    "skillDes_312": "拥有内噬状态的怪兽受到致死的伤害时，被击退{level_based}码，冷却时间{p1}秒",
    "randomEventDialogueGroupConfig_8.32": "大喊我不做人啦——然后戴上",
    "skillDes_313": "拥有内噬状态的怪兽击破怪兽时，自己进入崩坏状态（攻击力和移动速度变为0，触碰战墙时会受到{owner}攻击力×{level_based}%的伤害，崩坏状态消失），持续内噬状态层数×{p1}秒",
    "randomEventDialogueGroupConfig_8.31": "举起来问是不是它要找的那个",
    "skillDes_310": "触发{p1}次胞刺后，偷取前方所有敌方怪兽当前血量的{level_based}%，并附加{p2}层内噬状态（发射子弹会被蒸发，蒸发时消耗1层内噬状态），持续{p3}秒，最多叠加{p4}层，叠加时刷新持续时间",
    "randomEventDialogueGroupConfig_8.30": "你摸到了一个石质的鬼面具，定眼一看面具的嘴里长有獠牙。#面具上诡异地飘出一行行歪歪扭扭的意义不明的奇怪文字。",
    "skillDes_311": "拥有内噬状态的怪兽受到致死的伤害时，移动速度降低{level_based}%，持续{p1}秒",
    "skillDes_316": "钢魂区域内的己方怪兽负面效果持续时间降低{level_based}%",
    "skillDes_317": "钢魂区域内的己方怪兽被子弹击中时，清除子弹所属怪兽的护盾，并使其在{level_based}秒内无法获得护盾",
    "skillDes_314": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，进入魔反状态（反射受到的来自怪兽的负面效果，被反射过的负面效果无法再次反射），持续{level_based}秒",
    "skillDes_315": "触发刻机时，创造一个钢魂区域（{p1}码），区域内的己方怪兽受到的伤害降低{level_based}%，坚韧提升{p2}%，钢魂区域持续{p3}秒",
    "randomEventDialogueGroupConfig_8.39": "你找到了藏在勋章旁的宝物。",
    "skillDes_318": "受到致死的伤害时，如果存在自己创造的钢魂区域，回复{owner}最大血量×{level_based}%的血量，坚韧提升{p1}，霸气提升{p2}%，持续{p3}秒，每场战斗最多触发{p4}次",
    "randomEventDialogueGroupConfig_8.38": "随手抛开继续摸索其它地方",
    "skillDes_319": "战斗开始时，{owner}绑定己方血量最高的近战怪兽（没有则不绑定），该怪兽进入影替状态（代替{owner}承受伤害，霸气提升{level_based}%）",
    "activityTaskName_105": "智者赠礼II",
    "skillDes_301": "{owner}绑定的怪兽血量低于{p1}%时，造成伤害时忽视敌方伤害降低效果{level_based}%，且免疫减速效果",
    "skillDes_302": "{owner}绑定的怪兽血量低于{level_based}%时，每{p1}秒获得偏移效果，每场战斗最多触发{p2}次",
    "activityTaskName_104": "智者赠礼I",
    "skillDes_300": "敌方怪兽受到致死伤害时（含不会死亡），会直接扣减其现有增益效果{p1}秒的持续时间且{owner}绑定的怪兽回复{level_based}能量，冷却时间{p2}秒",
    "skillDes_305": "死亡时，己方所有怪兽坚韧提升{level_based}，持续{p1}秒",
    "skillDes_306": "碫触发时，会使血量最少的敌方怪兽攻击力降低{level_based}%，持续{p1}秒",
    "skillDes_303": "{owner}每{p1}秒回复最大血量×{level_based}%的血量，每{p2}秒直接扣减距离最近的敌方怪兽现有增益效果{p3}秒的持续时间，绑定的怪兽死亡时，{owner}也会一同死亡",
    "skillDes_304": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，{owner}和血量最少的己方怪兽获得偏移效果，持续{level_based}秒",
    "skillDes_309": "{owner}每秒回复{energy}能量，拥有100能量时立刻发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，且击退{p1}码",
    "skillDes_307": "{owner}血量每降低{p1}%，坚韧提升{level_based}，血量回复效果降低{p2}%",
    "skillDes_308": "战斗开始时，己方所有近战怪兽进入抵抗状态（坚韧提升{level_based}，霸气提升{p1}%），持续至{owner}死亡",
    "randomEventDialogueGroupConfig_8.15": "你摸到一条滑溜的不明物体。",
    "activityTaskName_113": "DNA赠礼I",
    "randomEventDialogueGroupConfig_8.14": "离开",
    "randomEventDialogueGroupConfig_8.13": "它又马上回到草丛中窜来窜去了。",
    "randomEventDialogueGroupConfig_8.12": "你真好，应该就是在这附近落下的。",
    "randomEventDialogueGroupConfig_8.11": "离开",
    "randomEventDialogueGroupConfig_8.10": "回应你的只有风声……",
    "randomEventDialogueGroupConfig_8.19": "丢两个D10",
    "randomEventDialogueGroupConfig_8.18": "一条满身滑稽脸的蛇正在你手中扭动着。",
    "randomEventDialogueGroupConfig_8.17": "举起往远处丢",
    "randomEventDialogueGroupConfig_8.16": "拿起来看看",
    "randomEventDialogueGroupConfig_3.100": "它摆出了一副一旦承认自己的软弱就是无敌的摆烂姿态，再也没有看你。",
    "randomEventDialogueGroupConfig_3.101": "离开",
    "randomEventDialogueGroupConfig_3.102": "它伸手进兜里捞了几下，然后伸出左右手，显然是让你在左边和右边的手上选一个。",
    "randomEventDialogueGroupConfig_3.103": "说左边",
    "randomEventDialogueGroupConfig_3.104": "一把抓住它右手",
    "randomEventDialogueGroupConfig_3.105": "沉默向左一指",
    "randomEventDialogueGroupConfig_3.106": "左边。",
    "randomEventDialogueGroupConfig_8.73": "那再想想？",
    "randomEventDialogueGroupConfig_8.72": "问它面具的事",
    "randomEventDialogueGroupConfig_8.71": "给它浇水",
    "randomEventDialogueGroupConfig_8.70": "你追上了草！那年幼的危险的草丛累瘫在地大口喘着气。",
    "randomEventDialogueGroupConfig_8.69": "不那么确定",
    "randomEventDialogueGroupConfig_8.68": "确定",
    "randomEventDialogueGroupConfig_8.67": "要继续这个追草的动作吗？",
    "randomEventDialogueGroupConfig_8.66": "进店。",
    "randomEventDialogueGroupConfig_8.65": "“记得这样兽丝们都超高兴的，啊，是我得意忘形了，要不到我店里看看？”",
    "randomEventDialogueGroupConfig_8.64": "收下",
    "randomEventDialogueGroupConfig_8.63": "啊啊，很抱歉，职业病犯了。谢谢你，这是您的报酬。",
    "randomEventDialogueGroupConfig_3.107": "哇，你怎么会知道的！哎，我放弃了，给你给你。",
    "randomEventDialogueGroupConfig_3.108": "就是要左边的。",
    "randomEventDialogueGroupConfig_3.109": "迅速离开",
    "randomEventDialogueGroupConfig_3.110": "慢慢离开",
    "randomEventDialogueGroupConfig_3.111": "你发现它在悄悄偷笑。",
    "randomEventDialogueGroupConfig_3.112": "离开",
    "randomEventDialogueGroupConfig_3.113": "哼，我要这个东西何用，都不肯和我说话！",
    "randomEventDialogueGroupConfig_3.114": "我只想听听救我的恩人的声音，一句就好，你说句话嘛。",
    "randomEventDialogueGroupConfig_3.115": "咆哮一声",
    "randomEventDialogueGroupConfig_3.116": "示意先交货",
    "randomEventDialogueGroupConfig_3.117": "败给你了。拿去吧。",
    "randomEventDialogueGroupConfig_8.84": "年幼的危险的草丛慌不择路，竟跑到一处悬崖，一下子在你的视线中消失了。",
    "randomEventDialogueGroupConfig_8.83": "离开",
    "randomEventDialogueGroupConfig_8.82": "迟疑片刻后，那年幼的危险的草丛已经不见影踪了。",
    "randomEventDialogueGroupConfig_8.81": "继续追",
    "randomEventDialogueGroupConfig_8.80": "捡起来看看",
    "randomEventDialogueGroupConfig_8.79": "年幼的危险的草丛跑着跑着有什么从它身上掉了下来。",
    "themeCardPackName_26040": "我们的音乐",
    "randomEventDialogueGroupConfig_8.78": "放过它",
    "randomEventDialogueGroupConfig_8.77": "再追",
    "randomEventDialogueGroupConfig_8.76": "它恢复活力，又跑起来了。",
    "randomEventDialogueGroupConfig_8.75": "不追",
    "randomEventDialogueGroupConfig_8.74": "追",
    "randomEventDialogueGroupConfig_3.118": "太过分了就不肯对我说一句话吗！好气，好气呀。",
    "randomEventDialogueGroupConfig_3.119": "好家伙，你怎么不说话呢？",
    "randomEventDialogueGroupConfig_8.51": "随便找一棵草问问面具的所在",
    "randomEventDialogueGroupConfig_8.50": "开启草毯式搜查",
    "randomEventDialogueGroupConfig_8.48": "反击",
    "randomEventDialogueGroupConfig_8.47": "它是超进化大陆最受欢迎怪兽，它浑身纯白，美丽的容貌和甜蜜的歌声让无数怪兽为之迷醉。#又因但行踪诡秘显得非常神秘，戴上面具前后的它判若两人，大概那就是它行踪诡秘并开始攻击你的原因吧。",
    "randomEventDialogueGroupConfig_8.46": "谢谢，既然如此，你应该会乐意为我永远保守秘密的吧？",
    "randomEventDialogueGroupConfig_8.45": "你看到了不应该看的东西。拜托，在这里长眠吧。",
    "randomEventDialogueGroupConfig_8.44": "翻身躺平",
    "randomEventDialogueGroupConfig_8.43": "继续趴着",
    "randomEventDialogueGroupConfig_8.42": "你溜走的时候被什么绊倒在地。",
    "randomEventDialogueGroupConfig_8.41": "这时你听到远处传来了它的呼喊。",
    "randomEventDialogueGroupConfig_8.49": "报酬当然没问题，有劳了。",
    "resoundEventStoryName_402": "灰烟丘陵",
    "resoundEventStoryName_401": "幸运的荒渚",
    "resoundEventStoryName_404": "自吓而死",
    "resoundEventStoryName_403": "地底之兽",
    "resoundEventStoryName_406": "隐形的翅膀",
    "resoundEventStoryName_405": "营养争夺战",
    "resoundEventStoryName_408": "介戈大坑",
    "resoundEventStoryName_407": "介戈天坑",
    "randomEventDialogueGroupConfig_8.62": "放过草丛继续找",
    "randomEventDialogueGroupConfig_8.61": "追",
    "randomEventDialogueGroupConfig_8.60": "那草看到你吓得拔腿就跑，可能是只年幼的危险的草丛。",
    "resoundEventStoryName_400": "可怜的荒渚",
    "randomEventDialogueGroupConfig_8.59": "面具似乎对你有一股奇妙的吸引力。",
    "skillDes_330": "构具会扣除祖龙族怪兽{level_based}能量，{owner}受到祖龙族怪兽的伤害不会超过自身最大血量的{p1}%，冷却时间{p2}秒",
    "randomEventDialogueGroupConfig_8.58": "啊，我的宝贝，你找到了！就是这个，真是太谢谢您了！",
    "skillDes_331": "构具会使尸鬼族怪兽血量回复效果降低{level_based}%，持续{p1}秒，{owner}受到尸鬼族怪兽的伤害时回复最大血量×{p2}%的血量，冷却时间{p3}秒",
    "randomEventDialogueGroupConfig_8.57": "离开",
    "randomEventDialogueGroupConfig_8.56": "你好像听到了如同咏唱魔咒一般的声音，“磨皮瘦脸祛斑瘦下巴缩脸美白放大眼亮眼增高塑形美声……”#一阵剧痛注入到你的脸上，你下意识地将面具丢开，随后意识开始模糊，再次醒来时，面具和神秘商人已经不见踪影了。",
    "randomEventDialogueGroupConfig_8.55": "仔细地端详着面具的轮廓",
    "skillDes_334": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害，{owner}后退{p1}码，回复最大血量{p2}%的血量",
    "randomEventDialogueGroupConfig_8.54": "告诉它你找到了",
    "skillDes_335": "敌方怪兽受到致死的伤害时（含不会死亡），{owner}进入爆噬状态（爆丸变为范围真实伤害（{p1}码），造成伤害的{level_based}%用于回复自身血量，攻击速度提升{p2}%），持续{p3}秒",
    "randomEventDialogueGroupConfig_8.53": "趁没人注意戴上试试",
    "skillDes_332": "构具会清除木偶族怪兽所有增益效果，{owner}受到木偶族怪兽的伤害时坚韧提升{level_based}，持续{p1}秒",
    "randomEventDialogueGroupConfig_8.52": "你找到了一个纯白色的面具。",
    "skillDes_333": "构具会对星灵族怪兽造成封印效果，持续{p1}秒，{owner}受到星灵族怪兽的伤害后进入星壁状态（获得体力×{level_based}%的生物屏障），持续{p2}秒，冷却时间{p3}秒",
    "skillDes_338": "战斗开始时，所有己方远程怪兽破韧提升{level_based}，增益效果持续时间提升{p1}%，持续至{owner}死亡",
    "skillDes_336": "{owner}受到致死的伤害时{p1}秒内不会死亡，恒定击退敌方所有怪兽{level_based}码，且扣减{p2}能量（不可扣减至负数）一次，冷却时间{p3}秒，每场战斗最多触发{p4}次",
    "skillDes_337": "敌方怪兽受到致死的伤害时（含不会死亡），{owner}获得最大血量×{level_based}%的护盾值，爆丸·爆压最多触发次数增加{p1}次，最多可增加至{p2}次",
    "resoundEventStoryName_413": "密欧子和朱丽美的日常（8）",
    "resoundEventStoryName_412": "密欧子和朱丽美的日常（7）",
    "resoundEventStoryName_415": "密欧子和朱丽美的日常（10）",
    "resoundEventStoryName_414": "密欧子和朱丽美的日常（9）",
    "resoundEventStoryName_417": "密欧子和朱丽美的日常（12）",
    "resoundEventStoryName_416": "密欧子和朱丽美的日常（11）",
    "resoundEventStoryName_419": "密欧子和朱丽美的日常（14）",
    "resoundEventStoryName_418": "密欧子和朱丽美的日常（13）",
    "messageInitNick_11008": "花露水群",
    "themeCardPackName_14035": "奇迹延续",
    "messageInitNick_11007": "行走在梦境中",
    "messageInitNick_11006": "头铁天王",
    "messageInitNick_11005": "扫把星",
    "themeCardPackName_14030": "树与聚落",
    "resoundEventStoryName_411": "密欧子和朱丽美的日常（6）",
    "messageInitNick_11009": "收菜了吗",
    "resoundEventStoryName_410": "看不见的瓜吖",
    "messageInitNick_11000": "吃糖不吃苦",
    "messageInitNick_11004": "看繁花落尽",
    "messageInitNick_11003": "泡面牧师",
    "messageInitNick_11002": "小狗是认真的",
    "messageInitNick_11001": "红色列车之心",
    "resoundEventStoryName_409": "各种各样的浪",
    "themeCardPackName_26015": "低潮",
    "themeCardPackName_26010": "炎夏的乐队",
    "resoundEventStoryName_424": "密欧子和朱丽美的日常（19）",
    "resoundEventStoryName_423": "密欧子和朱丽美的日常（18）",
    "resoundEventStoryName_426": "海上旅行",
    "resoundEventStoryName_425": "彩虹山脉",
    "resoundEventStoryName_428": "你是我的眼",
    "resoundEventStoryName_427": "另一种生命",
    "resoundEventStoryName_429": "密欧子和朱丽美的日常（20）",
    "messageInitNick_11019": "对牛顿宝具",
    "messageInitNick_11018": "电子宠物",
    "messageInitNick_11017": "水是冰的泪",
    "messageInitNick_11016": "吃饭前线",
    "themeCardPackName_14025": "治愈之树",
    "resoundEventStoryName_420": "密欧子和朱丽美的日常（15）",
    "themeCardPackName_14020": "重要过往",
    "resoundEventStoryName_422": "密欧子和朱丽美的日常（17）",
    "resoundEventStoryName_421": "密欧子和朱丽美的日常（16）",
    "messageInitNick_11011": "傀儡",
    "messageInitNick_11010": "蓝莓的秘密",
    "messageInitNick_11015": "无助的花草",
    "messageInitNick_11014": "我想静静",
    "messageInitNick_11013": "画饼天后",
    "messageInitNick_11012": "神秘大神",
    "themeCardPackName_26005": "舞台之外",
    "resoundEventStoryName_435": "左拥右抱",
    "resoundEventStoryName_434": "度在哪何为过",
    "resoundEventStoryName_437": "车马",
    "resoundEventStoryName_436": "废弃据点",
    "resoundEventStoryName_439": "大沙暴",
    "resoundEventStoryName_438": "悬赏林",
    "resoundEventStoryName_431": "最爱的故事",
    "resoundEventStoryName_430": "密欧子和朱丽美的日常（21）",
    "resoundEventStoryName_433": "和平象征",
    "resoundEventStoryName_432": "神唤与次元障壁",
    "themeCardPackName_26030": "我们的",
    "themeCardPackName_26035": "定番",
    "resoundEventStoryName_446": "遁法",
    "resoundEventStoryName_445": "一条鸭毛",
    "resoundEventStoryName_448": "绿林",
    "themeCardPackName_14040": "告别奇迹",
    "resoundEventStoryName_447": "出神入化之地",
    "resoundEventStoryName_449": "断肠狭道",
    "resoundEventStoryName_440": "温泉群",
    "resoundEventStoryName_442": "超星洪流洞穴",
    "resoundEventStoryName_441": "宇猫化形",
    "resoundEventStoryName_444": "兵器传世土",
    "resoundEventStoryName_443": "生命之树",
    "themeCardPackName_26025": "对手",
    "themeCardPackName_26020": "组成",
    "resoundEventStoryName_457": "很想你",
    "resoundEventStoryName_456": "此地",
    "resoundEventStoryName_459": "永冻冰亭",
    "resoundEventStoryName_458": "藏龙峡谷",
    "resoundEventStoryName_451": "晨光五怪",
    "messageInitNick_11049": "哭是我的专长",
    "resoundEventStoryName_450": "乱石洞",
    "resoundEventStoryName_453": "向阳之地",
    "resoundEventStoryName_452": "千里接龙头",
    "resoundEventStoryName_455": "我在",
    "resoundEventStoryName_454": "若要草不知",
    "messageInitNick_11044": "笑笑更健康",
    "messageInitNick_11043": "重新定义懂",
    "messageInitNick_11042": "冰激凌猎人",
    "messageInitNick_11041": "城市赛亚人",
    "messageInitNick_11048": "地铁卡忘带了",
    "messageInitNick_11047": "坏孩子有梦想",
    "messageInitNick_11046": "烧麦制作者",
    "messageInitNick_11045": "少林捂裆功",
    "messageInitNick_11040": "在终点等谁",
    "resoundEventStoryName_468": "竹林空地",
    "resoundEventStoryName_467": "光明山顶",
    "resoundEventStoryName_469": "飞崖一角",
    "resoundEventStoryName_460": "陆龙潭",
    "resoundEventStoryName_462": "客栈道",
    "resoundEventStoryName_461": "星秀海",
    "resoundEventStoryName_464": "白云",
    "resoundEventStoryName_463": "自然形成的四指坑",
    "resoundEventStoryName_466": "练掌宝地",
    "resoundEventStoryName_465": "路见不平拔刀相助",
    "messageInitNick_11055": "字要那么大",
    "messageInitNick_11054": "狂野的梨子",
    "messageInitNick_11053": "天堂夹克",
    "messageInitNick_11052": "康忙北鼻",
    "messageInitNick_11059": "现在去收租",
    "messageInitNick_11058": "香菜之心",
    "resoundEventMonumentName_9": "世界丰碑9",
    "messageInitNick_11057": "勇闯无人岛",
    "resoundEventMonumentName_8": "世界丰碑8",
    "messageInitNick_11056": "通菜怪客",
    "resoundEventMonumentName_7": "世界丰碑7",
    "resoundEventMonumentName_6": "世界丰碑6",
    "resoundEventMonumentName_5": "世界丰碑5",
    "resoundEventMonumentName_4": "世界丰碑4",
    "resoundEventMonumentName_3": "世界丰碑3",
    "messageInitNick_11051": "辣椒之心",
    "resoundEventMonumentName_2": "世界丰碑2",
    "messageInitNick_11050": "舞遗忘",
    "resoundEventMonumentName_1": "世界丰碑1",
    "resoundEventStoryName_479": "喇叭",
    "resoundEventStoryName_478": "守魂奔雷锤",
    "resoundEventStoryName_471": "方圆狭道",
    "messageInitNick_11029": "智能蜜枣",
    "resoundEventStoryName_470": "深井洞",
    "messageInitNick_11028": "不想醒来的梦",
    "resoundEventStoryName_473": "禁地",
    "themeCardPackName_14015": "仍在过往",
    "messageInitNick_11027": "背锅是队友",
    "resoundEventStoryName_472": "超进化点穴手",
    "resoundEventStoryName_475": "轻功",
    "resoundEventStoryName_474": "龙儿岭",
    "resoundEventStoryName_477": "红叶蜻蜓龙会",
    "resoundEventStoryName_476": "剑过叶半",
    "themeCardPackName_14010": "过往之间",
    "messageInitNick_11022": "薄荷梦",
    "messageInitNick_11021": "正在连接",
    "messageInitNick_11020": "小鱼快游吖",
    "messageInitNick_11026": "把梦留给夜",
    "messageInitNick_11025": "扮鬼脸",
    "messageInitNick_11024": "危险勿近",
    "messageInitNick_11023": "无心的蓝莓",
    "questionnaireName_9": "问卷9",
    "questionnaireName_8": "问卷8",
    "questionnaireName_7": "问卷7",
    "questionnaireName_6": "「破茧测试」美术素材调研问卷",
    "questionnaireName_5": "「破茧测试」UGC创作活动调研问卷",
    "questionnaireName_4": "「破茧测试」深度体验调研问卷",
    "questionnaireName_3": "「破茧测试」IP调研问卷",
    "questionnaireName_2": "「破茧测试」新手体验调研问卷",
    "questionnaireName_1": "「破茧测试」外宣调研问卷",
    "resoundEventStoryName_489": "畅食岛",
    "resoundEventStoryName_482": "一点红",
    "resoundEventStoryName_481": "压扁的喇叭",
    "messageInitNick_11039": "那种自信",
    "resoundEventStoryName_484": "江湖之外",
    "messageInitNick_11038": "把我放在盐里",
    "resoundEventStoryName_483": "江湖",
    "resoundEventStoryName_486": "暗果大师",
    "resoundEventStoryName_485": "暗果",
    "resoundEventStoryName_488": "癫峰对决",
    "resoundEventStoryName_487": "山巅",
    "messageInitNick_11033": "九月茉莉",
    "messageInitNick_11032": "最爱萝卜",
    "messageInitNick_11031": "盖世小仙女",
    "messageInitNick_11030": "迷上门口老头",
    "messageInitNick_11037": "我想起来来了",
    "messageInitNick_11036": "高价把戏",
    "themeCardPackName_14005": "过往之初",
    "messageInitNick_11035": "电子番茄酱",
    "resoundEventStoryName_480": "圆石",
    "messageInitNick_11034": "另类野猫",
    "resoundEventStoryName_379": "幻之海",
    "resoundEventStoryName_372": "神奇的海螺（2）",
    "resoundEventStoryName_371": "神奇的海螺（1.2）",
    "resoundEventStoryName_374": "涤灵莲华",
    "resoundEventStoryName_373": "神奇的海螺（2.2）",
    "resoundEventStoryName_376": "四脚兽的传闻（1）",
    "resoundEventStoryName_375": "澡堂的异闻",
    "resoundEventStoryName_378": "四脚兽的传闻（3）",
    "resoundEventStoryName_377": "四脚兽的传闻（2）",
    "resoundEventStoryName_370": "神奇的海螺（1）",
    "resoundEventStoryName_383": "大兜树",
    "resoundEventStoryName_382": "纷争之树",
    "resoundEventStoryName_385": "大兜",
    "resoundEventStoryName_384": "大兜叶",
    "resoundEventStoryName_387": "留声岛（B）",
    "resoundEventStoryName_386": "留声岛（A）",
    "resoundEventStoryName_389": "死亡弹球",
    "resoundEventStoryName_388": "留声草",
    "messageInitNick_2692": "苹果是认真的",
    "messageInitNick_2693": "滴卡司",
    "messageInitNick_2690": "初夏浅浅笑",
    "messageInitNick_2691": "不服来比腿粗",
    "messageInitNick_2696": "万能咖啡",
    "messageInitNick_2697": "正点联盟",
    "messageInitNick_2694": "红裙阑珊",
    "resoundEventStoryName_381": "轮到谁了",
    "messageInitNick_2695": "尖叫樱桃",
    "resoundEventStoryName_380": "疯狂的石子",
    "messageInitNick_2698": "昨天破防了",
    "messageInitNick_2699": "为减排做贡献",
    "resoundEventStoryName_394": "探崖的风口（2）",
    "resoundEventStoryName_393": "探崖的风口（1）",
    "resoundEventStoryName_396": "雨中鸣响一千个铃",
    "resoundEventStoryName_395": "飞蘑环游记",
    "resoundEventStoryName_398": "丢下火花",
    "resoundEventStoryName_397": "同枝悬铃花",
    "resoundEventStoryName_399": "炎上花",
    "messageInitNick_2681": "作业粉碎机",
    "messageInitNick_2682": "金钱螺旋体",
    "messageInitNick_2680": "命运石之论",
    "messageInitNick_2685": "司马迁戒导",
    "resoundEventStoryName_390": "无法拒绝的关口",
    "messageInitNick_2686": "明明洗白白",
    "messageInitNick_2683": "已被里侧除外",
    "resoundEventStoryName_392": "睁眼地狱",
    "messageInitNick_2684": "沉迷者",
    "resoundEventStoryName_391": "闭眼天堂",
    "messageInitNick_2689": "富婆",
    "messageInitNick_2687": "撕碎薯片的龙",
    "messageInitNick_2688": "残花若相惜",
    "messageInitNick_2670": "爱自由没浪够",
    "messageInitNick_2671": "学不会掩饰",
    "messageInitNick_2674": "杨桃射手",
    "messageInitNick_2675": "开始发癫",
    "messageInitNick_2672": "冰血温热",
    "messageInitNick_2673": "草莓棉花糖",
    "messageInitNick_2678": "臣妾做不到呀",
    "messageInitNick_2679": "饼图不友好",
    "messageInitNick_2676": "特长是吃饭",
    "messageInitNick_2677": "甩锅鉴定家",
    "messageInitNick_2660": "巷子里的画架",
    "messageInitNick_2663": "霸气萌妹纸",
    "messageInitNick_2664": "最强饮水机",
    "messageInitNick_2661": "努力延长假期",
    "messageInitNick_2662": "花儿对我笑",
    "messageInitNick_2667": "爱在戏院前",
    "messageInitNick_2668": "爱若逢时",
    "messageInitNick_2665": "辣个蓝人",
    "messageInitNick_2666": "美女在跳舞",
    "messageInitNick_2669": "震惊的输入法",
    "98_-80001": "cjhwy2",
    "98_-80002": "该怪物需要休息，暂时无法助战",
    "98_-80003": "cjhwy2",
    "98_-80004": "cjhwy2",
    "98_-80005": "cjhwy2",
    "messageInitNick_2652": "飞的猫",
    "98_-80006": "cjhwy2",
    "messageInitNick_2653": "巴丝提女神",
    "98_-80007": "只能使用一只助战怪兽",
    "messageInitNick_2650": "节凑掉满地",
    "98_-80008": "已自动下阵同名助战觉醒怪兽",
    "messageInitNick_2651": "仗剑走天涯",
    "messageInitNick_2656": "爆炸小公举",
    "messageInitNick_2657": "热情的炉灶",
    "messageInitNick_2654": "努力山大",
    "messageInitNick_2655": "此人极具粪量",
    "messageInitNick_2658": "该如何忘记",
    "messageInitNick_2659": "小女巫",
    "messageInitNick_2641": "暴走的麦芽糖",
    "messageInitNick_2642": "智能橡皮糖",
    "messageInitNick_2640": "风之神",
    "messageInitNick_2645": "恋你朝朝暮暮",
    "messageInitNick_2646": "那个女孩",
    "messageInitNick_2643": "揣一袋欢乐",
    "messageInitNick_2644": "洋葱真好吃",
    "messageInitNick_2649": "兜兜里有糖",
    "messageInitNick_2647": "过几年约会",
    "messageInitNick_2648": "僵尸新娘",
    "messageInitNick_2630": "悄悄上分",
    "messageInitNick_2631": "猫魂穿狗子",
    "messageInitNick_2634": "夜市神仙",
    "messageInitNick_2635": "晚餐吃茄子",
    "messageInitNick_2632": "独酌伊人泪",
    "messageInitNick_2633": "问你了真的",
    "messageInitNick_2638": "烫烫烫烫",
    "messageInitNick_2639": "酷的没边",
    "messageInitNick_2636": "镜子先锋",
    "messageInitNick_2637": "印象主义的猫",
    "activityNodeName_236": "星灵族大宝贝#尸鬼族熊孩子",
    "activityNodeName_237": "求生欲大爆发#比蒙出击",
    "activityNodeName_234": "竞猜左234#竞猜右234",
    "messageInitNick_2629": "我好娇弱啊",
    "activityNodeName_235": "大仁#大锤",
    "activityNodeName_238": "来了#是兄弟",
    "activityNodeName_239": "肉弹贴贴#战墙贴贴",
    "messageInitNick_2620": "狂飙的马",
    "messageInitNick_2623": "光之战士",
    "messageInitNick_2624": "一笑倾城",
    "messageInitNick_2621": "对味友人",
    "messageInitNick_2622": "拥有幸福",
    "messageInitNick_2627": "没有毛的猫",
    "messageInitNick_2628": "如如入来",
    "messageInitNick_2625": "幸福迷了路",
    "messageInitNick_2626": "勒紧裤头",
    "messageInitNick_2618": "柚子魔法师",
    "messageInitNick_2619": "不想上班",
    "iapBuyConfigName_902": "专享礼",
    "messageInitNick_2612": "飞天扫地机",
    "messageInitNick_2613": "仅限对你关心",
    "messageInitNick_2610": "早上吃茄子",
    "messageInitNick_2611": "退役吃瓜选手",
    "messageInitNick_2616": "蒸蛋吞噬者",
    "messageInitNick_2617": "呼风唤雨",
    "messageInitNick_2614": "咖啡很浓",
    "messageInitNick_2615": "爆破叔叔",
    "messageInitNick_2609": "呆萌小怪",
    "messageInitNick_2607": "天台之王",
    "messageInitNick_2608": "我胆小真的",
    "messageInitNick_2601": "盖世英雄迷妹",
    "messageInitNick_2602": "尖叫西瓜",
    "messageInitNick_2600": "一生漂泊",
    "messageInitNick_2605": "猪猪演员",
    "messageInitNick_2606": "流浪的腓骨",
    "messageInitNick_2603": "窗前视界",
    "messageInitNick_2604": "寄给来人",
    "activityNodeName_240": "二维焚烧#铁幕守护",
    "activityNodeName_241": "够大#够分量",
    "activityNodeName_242": "合体小不点#超凶小不点",
    "ancientGeneConfigDescription_1": "谜之生物体型增大{?}%，体力提升{?}%",
    "ancientGeneConfigDescription_6": "谜之生物在场时，己方祖龙族怪兽攻击力和体力提升{?}%",
    "ancientGeneConfigDescription_7": "谜之生物在场时，己方尸鬼族怪兽攻击力和体力提升{?}%",
    "ancientGeneConfigDescription_8": "谜之生物在场时，己方星灵族怪兽攻击力和体力提升{?}%",
    "ancientGeneConfigDescription_9": "谜之生物在场时，己方木偶族怪兽攻击力和体力提升{?}%",
    "ancientGeneConfigDescription_2": "谜之生物每{p1}秒，回复最大血量×{?}%的血量",
    "ancientGeneConfigDescription_3": "谜之生物每{p1}秒，获得偏移效果（下次受到的伤害变为0），持续{?}秒",
    "ancientGeneConfigDescription_4": "谜之生物血量低于{p1}%时，免疫负面效果，受到伤害降低{?}%",
    "ancientGeneConfigDescription_5": "谜之生物受到致死的伤害时不会死亡，并回复最大血量×{?}%的血量，冷却时间{p1}秒",
    "immortalCocoonConfigName_3": "“龙蛇混杂”",
    "immortalCocoonConfigName_2": "“唇枪舌剑”",
    "immortalCocoonConfigName_1": "永生的小怪兽",
    "immortalCocoonConfigName_7": "龙马精神",
    "immortalCocoonConfigName_6": "吸血鬼与狼人",
    "immortalCocoonConfigName_5": "血少的来",
    "immortalCocoonConfigName_4": "女王的棋局",
    "immortalCocoonConfigName_9": "二次元入口",
    "immortalCocoonConfigName_8": "最后一个字的组合",
    "resoundEventStoryName_303": "空之书",
    "resoundEventStoryName_302": "玛咖果",
    "resoundEventStoryName_305": "乐",
    "resoundEventStoryName_304": "岩烧",
    "resoundEventStoryName_307": "忘忧花田",
    "resoundEventStoryName_306": "修炼圣地",
    "resoundEventStoryName_309": "摇曳的风景",
    "resoundEventStoryName_308": "哭泣的玫瑰",
    "resoundEventStoryName_301": "四眼毒泉",
    "resoundEventStoryName_300": "湖中部落",
    "5_comment": "战斗, 词缀, 排阵, 神灵序列, 战斗准备界面, 战斗结算信息界面, 探索者升级, 录像界面, 暴走旷野增益选择",
    "resoundEventStoryName_314": "希望之花",
    "resoundEventStoryName_313": "食兽峡谷",
    "resoundEventStoryName_316": "甜蜜爆浆",
    "resoundEventStoryName_315": "三棵独苗",
    "resoundEventStoryName_318": "神木",
    "resoundEventStoryName_317": "眨眼之间",
    "resoundEventStoryName_319": "角落的植物",
    "resoundEventStoryName_310": "雨后新泥汤",
    "resoundEventStoryName_312": "金黄之风",
    "resoundEventStoryName_311": "云涛汹涌",
    "resoundEventStoryName_325": "哔哔圣地",
    "resoundEventStoryName_324": "未摘花",
    "resoundEventStoryName_327": "间歇泉",
    "resoundEventStoryName_326": "拥有最多月亮与太阳的森林",
    "resoundEventStoryName_329": "俯瞰鱼塘",
    "resoundEventStoryName_328": "止痛石",
    "resoundEventStoryName_321": "无限斗崖",
    "resoundEventStoryName_320": "死亡草的荧粉",
    "resoundEventStoryName_323": "无名之花",
    "resoundEventStoryName_322": "湖底精灵",
    "skillDes_99": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害",
    "skillDes_97": "死亡时，{owner}攻击力的{level_based}%转移至攻击力最高的己方近战怪兽身上，体型增大{p1}%，持续{p2}秒，如无己方近战怪兽该技能不生效，每场战斗最多触发{p3}次",
    "skillDes_98": "死亡时，攻击力最高的己方近战怪兽获得攻击力×{level_based}%的护盾，持续{p1}秒，每场战斗最多触发{p2}次",
    "skillDes_95": "奏会使敌方怪兽的移动速度降低{level_based}%，持续{p1}秒",
    "skillDes_96": "触发奏时，创造一个音律区域（{p1}码），区域内的己方近战怪兽每{p2}秒回复{owner}攻击力×{level_based}%的血量，音律区域持续{p3}秒",
    "skillDes_93": "守护区域的范围增大{level_based}%",
    "skillDes_94": "{owner}每次普攻回复{energy}能量，拥有100能量普攻时发动{name}，对敌方怪兽造成攻击力×{level_based}%的伤害",
    "skillDes_91": "守护区域内的己方怪兽的普通攻击伤害提升{level_based}%",
    "skillDes_92": "守护区域内的己方怪兽每次攻击回复自身攻击力×{level_based}%的血量",
    "skillDes_90": "触发异能时，创造一个守护区域（{p1}码），区域内的己方怪兽受到的伤害降低{level_based}%，守护区域持续{p2}秒",
    "resoundEventStoryName_336": "荧炎，热爱浪尖",
    "resoundEventStoryName_335": "森林，拥上浅湾",
    "resoundEventStoryName_338": "沙漠海葵",
    "resoundEventStoryName_337": "沙漠之旅",
    "resoundEventStoryName_339": "瓜多之日",
    "resoundEventStoryName_330": "不存在的地下城",
    "resoundEventStoryName_332": "天使掌心",
    "resoundEventStoryName_331": "运河",
    "resoundEventStoryName_334": "观星好去处",
    "resoundEventStoryName_333": "歌女之喉",
    "resoundEventStoryName_347": "粉色的树林",
    "resoundEventStoryName_346": "永生花的秘密",
    "resoundEventStoryName_349": "超星海洋（1）",
    "resoundEventStoryName_348": "瑟瑟发抖的树林",
    "resoundEventStoryName_341": "月见花和日见花",
    "resoundEventStoryName_340": "这是炸服的钻石",
    "resoundEventStoryName_343": "嚎叫音匣",
    "resoundEventStoryName_342": "舞见花与唱见花",
    "resoundEventStoryName_345": "永生花",
    "resoundEventStoryName_344": "嚎叫音匣与人间大炮",
    "resoundEventStoryName_358": "月兽之潮",
    "resoundEventStoryName_357": "月兽之洋",
    "resoundEventStoryName_359": "兽首",
    "resoundEventStoryName_350": "超星海洋（2）",
    "resoundEventStoryName_352": "过去的泥潭",
    "resoundEventStoryName_351": "超星海洋（3）",
    "resoundEventStoryName_354": "长气之地",
    "resoundEventStoryName_353": "未至的泥潭",
    "resoundEventStoryName_356": "龟谷",
    "resoundEventStoryName_355": "长气之子",
    "resoundEventStoryName_369": "竞争对手（2）",
    "resoundEventStoryName_368": "竞争对手（1）",
    "resoundEventStoryName_361": "湖心鼓动之谜",
    "resoundEventStoryName_360": "首领兽首",
    "resoundEventStoryName_363": "幻·偶木桥",
    "resoundEventStoryName_362": "湖心水怪疑云",
    "resoundEventStoryName_365": "螺旋流星",
    "resoundEventStoryName_364": "真·偶木桥",
    "resoundEventStoryName_367": "真正的含义",
    "resoundEventStoryName_366": "最新发现",
    "messageInitNick_2593": "不许比烂",
    "messageInitNick_2594": "巭孬嫑烎",
    "messageInitNick_2591": "腹黑女",
    "messageInitNick_2592": "数一数二的瓜",
    "messageInitNick_2597": "道理我都懂",
    "messageInitNick_2598": "今天充满希望",
    "messageInitNick_2595": "超级饭团",
    "messageInitNick_2596": "说好不动情",
    "messageInitNick_2599": "别跟我玩心跳",
    "randomEventDialogueGroupConfig_52.35": "离开",
    "resoundEventStoryName_259": "凌乱的刻痕",
    "randomEventDialogueGroupConfig_52.36": "突然店面传来一声尖叫，接下来你听到有怪兽大喊“有贼，快来！”",
    "resoundEventStoryName_258": "快乐水",
    "randomEventDialogueGroupConfig_52.33": "愤愤离开",
    "randomEventDialogueGroupConfig_52.34": "这是我们的行话你懂不懂啊，赶紧哪里来滚哪里，以后再也不要让我见到你——！",
    "randomEventDialogueGroupConfig_52.31": "你是不是商业间谍，竟擅离职守，打探隐私？我会记住你的，然后大肆渲染，让你以后无法在这一行立足。滚！",
    "randomEventDialogueGroupConfig_52.32": "反驳他试图危害集市",
    "randomEventDialogueGroupConfig_52.30": "冲进去质问老板",
    "resoundEventStoryName_251": "密欧子和朱丽美的日常（2）",
    "resoundEventStoryName_250": "密欧子和朱丽美的日常（1）",
    "resoundEventStoryName_253": "密欧子和朱丽美的日常（4）",
    "resoundEventStoryName_252": "密欧子和朱丽美的日常（3）",
    "randomEventDialogueGroupConfig_52.39": "狠狠出手",
    "resoundEventStoryName_255": "无聊水",
    "resoundEventStoryName_254": "密欧子和朱丽美的日常（5）",
    "randomEventDialogueGroupConfig_52.37": "留下一名得力干将后赶过去",
    "resoundEventStoryName_257": "孤独水",
    "randomEventDialogueGroupConfig_52.38": "店内，只见贼兽正在搬运商品。",
    "resoundEventStoryName_256": "寂寞水",
    "17_14": "防御值扣减",
    "17_15": "遗迹切换",
    "17_16": "{1}后可派遣",
    "17_17": "{1}后可挑战",
    "17_10": "宣战后才可派遣",
    "17_11": "剩余{1}",
    "17_12": "部队{1}（撤离中）",
    "17_13": "纷争区域",
    "randomEventDialogueGroupConfig_52.24": "回去之后，你发现本该看守的仓库已经被搬空，任务失败了。",
    "randomEventDialogueGroupConfig_52.25": "离开",
    "resoundEventStoryName_269": "厚切",
    "randomEventDialogueGroupConfig_52.22": "你吃了几口之后就倒下去了。任务失败。",
    "randomEventDialogueGroupConfig_52.23": "离开",
    "randomEventDialogueGroupConfig_52.20": "盛情难却",
    "randomEventDialogueGroupConfig_52.21": "碍难从命",
    "resoundEventStoryName_262": "朝露",
    "resoundEventStoryName_261": "周围的声音",
    "resoundEventStoryName_264": "冰锥",
    "resoundEventStoryName_263": "树皮",
    "17_18": "部落成员不足{1}，无法报名",
    "randomEventDialogueGroupConfig_52.28": "巡逻时，你无意听到仓库中老板和伙计的密谈内容，由于声音较小你只听到了“明日，炸掉，就这样办”。",
    "resoundEventStoryName_266": "脚印",
    "17_19": "已完成",
    "randomEventDialogueGroupConfig_52.29": "当没听到继续巡逻",
    "resoundEventStoryName_265": "一旁的草",
    "randomEventDialogueGroupConfig_52.26": "一夜无事，你顺利完成了任务。老板非常感动，还给了你双倍赏金，并表示它们即将要开展一波大酬宾，欢迎你来玩。",
    "resoundEventStoryName_268": "山外有山",
    "randomEventDialogueGroupConfig_52.27": "离开",
    "resoundEventStoryName_267": "绒毛茅草",
    "17_25": "不能重复挑战同一名敌对部落的成员",
    "17_26": "当前部队处于「{1}」状态，无法进行其他挑战",
    "17_27": "当前部队处于「{1}」状态，无法更改配置",
    "17_28": "怪兽上阵了部队{1}",
    "17_21": "鬼躯",
    "17_22": "隐藏队伍配置（包含名字战力等一切信息）",
    "17_23": "怪兽攻击力提升10%",
    "iapBuyConfigName_861": "百炼起源星礼",
    "resoundEventStoryName_260": "星状龙舌兰",
    "17_24": "怪兽体力提升10%",
    "iapBuyConfigName_860": "核心赋能星礼",
    "17_20": "主核",
    "parameterStrengthenName_17": "攻击力{p1}",
    "randomEventDialogueGroupConfig_52.13": "保持警惕开始巡逻",
    "iapBuyConfigName_859": "超量金币星礼",
    "parameterStrengthenName_16": "子弹速度{p1}%",
    "randomEventDialogueGroupConfig_52.14": "负责的怪兽很感激地给了你第一笔定金，一番说明后，正式将这个任务交给了你。",
    "parameterStrengthenName_15": "霸气{p1}，移动速度{p2}",
    "randomEventDialogueGroupConfig_52.11": "前往找到负责的怪兽",
    "parameterStrengthenName_14": "移动速度{p1}，霸气{p2}",
    "randomEventDialogueGroupConfig_52.12": "西北集市熙熙攘攘，到处都挤满了怪兽，你找到了孢子店管事的怪兽寒暄了一番，正式接下了工作。",
    "parameterStrengthenName_13": "霸气{p1}",
    "parameterStrengthenName_12": "移动速度{p1}",
    "randomEventDialogueGroupConfig_52.10": "你翻到悬赏令的反面，密密麻麻写着各种细则，总而言之，你只要维持孢子店的秩序和保证仓库的安全即可，其他可以一概不管。",
    "parameterStrengthenName_11": "体型{p1}%",
    "parameterStrengthenName_10": "体型{p1}%",
    "iapBuyConfigName_852": "丰厚经验星礼",
    "resoundEventStoryName_273": "光滑的树干",
    "iapBuyConfigName_851": "浩瀚粉尘星礼",
    "resoundEventStoryName_272": "血河",
    "iapBuyConfigName_854": "橙元核髓星礼",
    "randomEventDialogueGroupConfig_52.19": "你很快地将贼兽赶跑，隔壁老板对你感激不尽，说要请你吃一顿好的。",
    "resoundEventStoryName_275": "不易察觉的裂痕",
    "iapBuyConfigName_853": "临界极化星礼",
    "resoundEventStoryName_274": "偶尔路过的风滚草",
    "iapBuyConfigName_856": "超绝进化星礼",
    "randomEventDialogueGroupConfig_52.17": "路见不平拔刀相助",
    "resoundEventStoryName_277": "千奇百怪的云",
    "iapBuyConfigName_855": "巨量原石星礼",
    "randomEventDialogueGroupConfig_52.18": "绝不擅离职守",
    "resoundEventStoryName_276": "幽静的台地",
    "iapBuyConfigName_858": "愉悦造物星礼",
    "parameterStrengthenName_19": "生物屏障{p1}",
    "randomEventDialogueGroupConfig_52.15": "调配小队开始巡逻",
    "resoundEventStoryName_279": "内心毫无波动的小水洼",
    "iapBuyConfigName_857": "三色孢子星礼",
    "parameterStrengthenName_18": "真实伤害{p1}",
    "randomEventDialogueGroupConfig_52.16": "突然前面闪过一条兽影，随后是尖叫和四散的兽群，原来有贼兽冲入了隔壁商店抢劫。",
    "resoundEventStoryName_278": "没有棱角的圆石",
    "iapBuyConfigName_850": "永动造唤星礼",
    "resoundEventStoryName_271": "花形贝壳",
    "resoundEventStoryName_270": "阳光",
    "parameterStrengthenName_20": "体力{p1}",
    "iapBuyConfigName_849": "无限极化星礼",
    "iapBuyConfigName_848": "原石宝库星礼",
    "iapBuyConfigName_841": "领地成长星礼",
    "resoundEventStoryName_284": "迷雾",
    "iapBuyConfigName_840": "神性塑造星礼",
    "resoundEventStoryName_283": "600号",
    "iapBuyConfigName_843": "多重极化星礼",
    "resoundEventStoryName_286": "羞避的树冠",
    "iapBuyConfigName_842": "原石珍藏星礼",
    "resoundEventStoryName_285": "被记录的树",
    "iapBuyConfigName_845": "潜能爆发星礼",
    "resoundEventStoryName_288": "“食堂”",
    "iapBuyConfigName_844": "完美造唤星礼",
    "resoundEventStoryName_287": "一个大坑坑坑",
    "iapBuyConfigName_847": "领地发展星礼",
    "iapBuyConfigName_846": "神性灌注星礼",
    "resoundEventStoryName_289": "暗黑的山洞",
    "resoundEventStoryName_280": "不定义自己的小丘",
    "resoundEventStoryName_282": "污妖王的花田",
    "resoundEventStoryName_281": "普通又特别的泉",
    "ancientGeneConfigRequirementDesc_37": "解锁条件：同时拥有绯焉，白昼和社恐龙三只怪兽",
    "ancientGeneConfigRequirementDesc_38": "解锁条件：同时拥有海漩，黯灭和绒绒三只怪兽",
    "ancientGeneConfigRequirementDesc_35": "解锁条件：同时拥有幽狱沸体，喀戎和飞头蛮三只怪兽",
    "ancientGeneConfigRequirementDesc_36": "解锁条件：同时拥有妄焱，火神和沼兽三只怪兽",
    "ancientGeneConfigRequirementDesc_33": "解锁条件：同时拥有漆黑组件，创晓和莎士彼亚三只怪兽",
    "ancientGeneConfigRequirementDesc_34": "解锁条件：同时拥有荧灵，神唤和ㄨ三只怪兽",
    "ancientGeneConfigRequirementDesc_31": "解锁条件：谜之生物已解锁部件数到达{1}",
    "ancientGeneConfigRequirementDesc_32": "解锁条件：同时拥有腾龙，镇魂和人间大炮三只怪兽",
    "resoundEventStoryName_295": "稽谷",
    "ancientGeneConfigRequirementDesc_30": "解锁条件：单次暴走旷野中选择「助战怪兽」增益次数达{1}",
    "resoundEventStoryName_294": "抱腿丛",
    "resoundEventStoryName_297": "老根",
    "resoundEventStoryName_296": "无名的遗迹",
    "resoundEventStoryName_299": "石知道答案",
    "resoundEventStoryName_298": "渡叶桥",
    "resoundEventStoryName_291": "素肉树",
    "resoundEventStoryName_290": "太阳炉",
    "resoundEventStoryName_293": "暗流",
    "resoundEventStoryName_292": "浮石",
    "ancientGeneConfigRequirementDesc_28": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_29": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_26": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_27": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_24": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_25": "解锁条件：单次暴走旷野中选择「差点无敌」增益次数达{1}",
    "ancientGeneConfigRequirementDesc_22": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_23": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_20": "解锁条件：单次暴走旷野中选择「逮虾户！」增益次数达{1}",
    "ancientGeneConfigRequirementDesc_21": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_19": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_17": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_18": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_15": "解锁条件：单次暴走旷野中选择「霸气冲阵」增益次数达{1}",
    "ancientGeneConfigRequirementDesc_16": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_13": "解锁条件：谜之生物等级达{1}级",
    "randomEventDialogueGroupConfig_52.55": "老板看着你，不知是哭是笑，之后又长叹一声。",
    "ancientGeneConfigRequirementDesc_14": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_11": "解锁条件：谜之生物等级达{1}级",
    "randomEventDialogueGroupConfig_52.53": "老板看着你，不知是哭是笑，之后又长叹一声。",
    "ancientGeneConfigRequirementDesc_12": "解锁条件：谜之生物等级达{1}级",
    "randomEventDialogueGroupConfig_52.54": "老板更生气了，毛都飞起来了。",
    "randomEventDialogueGroupConfig_52.51": "老板怒气冲冲，反过来质问你。",
    "ancientGeneConfigRequirementDesc_10": "解锁条件：远古族怪兽拥有红色品质的极化技能数大于等于{1}",
    "randomEventDialogueGroupConfig_52.52": "老板更生气了，毛都飞起来了。",
    "randomEventDialogueGroupConfig_52.46": "离开",
    "randomEventDialogueGroupConfig_52.47": "贼兽见你一掌便将进化孢子震出十丈远，它吓得满头冒汗双腿狂颤，慌忙逃跑。",
    "randomEventDialogueGroupConfig_52.44": "展示实力",
    "randomEventDialogueGroupConfig_52.45": "哎，前日才来了个碰瓷的，幸好被我识穿，可现在，贼兽都被你打成这样，我可是要赔偿它的，你可连累死我了，哎你走吧。",
    "randomEventDialogueGroupConfig_52.42": "向老板禀报",
    "randomEventDialogueGroupConfig_52.43": "贼兽听闻威震四方的“探索者”的名号之后，完全不为所动，有一只甚至笑了出声。",
    "randomEventDialogueGroupConfig_52.40": "报上名号",
    "randomEventDialogueGroupConfig_52.41": "贼兽看着凶狠，实则外强中干，一下就被你打得倒地不起。",
    "randomEventDialogueGroupConfig_52.48": "禀报老板",
    "randomEventDialogueGroupConfig_52.49": "老板感激涕零，大赞你处理得好！之后一夜无事，你顺利完成了任务。",
    "messageInitNick_2990": "前途无限",
    "messageInitNick_2993": "究极螺旋体",
    "messageInitNick_2994": "爱上猫的老鼠",
    "messageInitNick_2991": "无公害西兰花",
    "messageInitNick_2992": "九命神童",
    "messageInitNick_2997": "熬夜王子",
    "messageInitNick_2998": "传说中的猫",
    "randomEventDialogueGroupConfig_52.50": "离开",
    "messageInitNick_2995": "叼着奶瓶逛街",
    "messageInitNick_2996": "香蕉消灭者",
    "messageInitNick_2999": "爱人与海",
    "17_98": "是否真的退出部落？",
    "messageInitNick_2982": "海为谁蓝",
    "17_99": "主将对决",
    "messageInitNick_2983": "柠檬魔法师",
    "messageInitNick_2980": "迷路的胫骨",
    "messageInitNick_2981": "琉璃瓶的回忆",
    "17_94": "取消申请",
    "messageInitNick_2986": "蛋挞哇哦",
    "skillName_2593": "梅花巨斧",
    "17_95": "今天还可加入成员：{1}",
    "messageInitNick_2987": "效果闭环",
    "skillName_2594": "方块巨锤",
    "17_96": "是否解散部落？",
    "messageInitNick_2984": "独自前行",
    "17_97": "是否真的解散部落？",
    "messageInitNick_2985": "核动力烤炉",
    "17_90": "遗迹功勋奖励",
    "17_91": "【我方部落】对{oppTribeName}部落占领的{tribeNodeId}宣战结束",
    "17_92": "【我方部落】对{tribeNodeId}宣战结束",
    "messageInitNick_2988": "布匹怪兽",
    "17_93": " {oppTribeName}部落对【我方部落】的{tribeNodeId}宣战结束",
    "messageInitNick_2989": "牙签谢谢",
    "messageInitNick_2971": "人设又撞了",
    "messageInitNick_2972": "草莓味雪饼",
    "messageInitNick_2970": "瓦妮拉摩尔",
    "messageInitNick_2975": "恋恋会不舍",
    "messageInitNick_2976": "皇家御姐",
    "messageInitNick_2973": "头发我爱你",
    "messageInitNick_2974": "雨伞毁灭者",
    "messageInitNick_2979": "生菜撞地球",
    "messageInitNick_2977": "月中仙",
    "messageInitNick_2978": "不许叫",
    "17_76": "交战x{1}",
    "messageInitNick_2960": "出租寂寞",
    "17_77": "暂无部落\\n宣战该遗迹",
    "messageInitNick_2961": "巨人",
    "17_78": "免去管理",
    "17_79": "本轮轮空",
    "17_72": "遗迹占领奖励",
    "messageInitNick_2964": "大葱魔法师",
    "17_73": "你所属部落占领了遗迹，获得奖励\\n+{1}部落币",
    "messageInitNick_2965": "风的微笑",
    "17_74": "本次部落战轮空，自动获得胜利",
    "messageInitNick_2962": "酱油香蕉",
    "17_75": "宣战x{1}",
    "messageInitNick_2963": "髌骨",
    "messageInitNick_2968": "不安那么沉重",
    "messageInitNick_2969": "魔女不哭",
    "resoundEffectConfigName_10": "星律收益累计小时上限+{p1}",
    "17_70": "任命管理",
    "messageInitNick_2966": "蹲街式寂寞",
    "17_71": "{1}放弃占领中",
    "messageInitNick_2967": "歌者",
    "ancientGeneConfigRequirementDesc_48": "解锁条件：同时拥有B.B.Token，玖璃和圣堂武士三只怪兽",
    "activityNodeName_366": "且战且奶#唯有进攻",
    "ancientGeneConfigRequirementDesc_46": "解锁条件：同时拥有咚魁，幻和海格力斯三只怪兽",
    "messageInitNick_2959": "温水煮青瓜",
    "activityNodeName_367": "剑盾·太阳#兵斧·月亮",
    "ancientGeneConfigRequirementDesc_47": "解锁条件：同时拥有初号铸体，螺旋巽和镰刀三只怪兽",
    "ancientGeneConfigRequirementDesc_44": "解锁条件：同时拥有艾娜璃兹，魅妆和零三只怪兽",
    "ancientGeneConfigRequirementDesc_45": "解锁条件：同时拥有戏战顽袍，御空和包租公三只怪兽",
    "ancientGeneConfigRequirementDesc_42": "解锁条件：同时拥有硎，冥龙王和污妖王三只怪兽",
    "ancientGeneConfigRequirementDesc_43": "解锁条件：同时拥有咎骸，地龙和仁拳大师三只怪兽",
    "ancientGeneConfigRequirementDesc_40": "解锁条件：同时拥有瞳，剧王和利爪狼三只怪兽",
    "ancientGeneConfigRequirementDesc_41": "解锁条件：同时拥有祈，龙皮匠和大嘴鱼王三只怪兽",
    "17_87": "【我方部落】正在放弃{tribeNodeId}的占领",
    "17_88": "【我方部落】对{tribeNodeId}宣战",
    "8_comment": "世界, 征收, 变强, 好友相关, 异象",
    "messageInitNick_2950": "看我双节棍",
    "17_89": "{1}",
    "17_83": " {oppTribeName}部落对【我方部落】占领的{tribeNodeId}宣战",
    "activityNodeName_360": "传说之力#混沌之力",
    "messageInitNick_2953": "无中生有",
    "17_84": "【我方部落】的{tribeNodeId}已被{oppTribeName}部落占领",
    "activityNodeName_361": "二重神赐#双倍启示",
    "messageInitNick_2954": "一流二货",
    "17_85": "【我方部落】宣战的{tribeNodeId}已被{oppTribeName}部落占领",
    "messageInitNick_2951": "传奇草包",
    "17_86": " {tribeNodeId}已被【我方部落】占领",
    "messageInitNick_2952": "吃酸奶舔瓶盖",
    "activityNodeName_364": "五剑#一斧",
    "messageInitNick_2957": "咸鱼冲锋",
    "17_80": "部队中没有怪兽上阵，无法挑战",
    "activityNodeName_365": "月下神剑#花前兵械",
    "messageInitNick_2958": "我不跟你玩",
    "17_81": "我的消息",
    "activityNodeName_362": "守护#破坏",
    "ancientGeneConfigRequirementDesc_39": "解锁条件：同时拥有崩律，空蝉和异形三只怪兽",
    "messageInitNick_2955": "有心打扰",
    "17_82": "【我方部落】对{oppTribeName}部落占领的{tribeNodeId}宣战",
    "activityNodeName_363": "噬魂#狂暴",
    "messageInitNick_2956": "挂名情人",
    "iapBuyConfigName_838": "闪光造唤星礼",
    "iapBuyConfigName_837": "超极之巅星礼",
    "messageInitNick_2948": "猜拳之星",
    "iapBuyConfigName_839": "潜能激活星礼",
    "messageInitNick_2949": "病娇少女",
    "iapBuyConfigName_830": "熔炼之王星礼",
    "iapBuyConfigName_832": "造唤升华星礼",
    "iapBuyConfigName_831": "超极之力星礼",
    "iapBuyConfigName_834": "神性升变星礼",
    "iapBuyConfigName_833": "强化破限星礼",
    "iapBuyConfigName_836": "熔炼之主星礼",
    "iapBuyConfigName_835": "领地茁壮星礼",
    "17_58": "宣战",
    "skillName_2557": "改命",
    "17_59": "暂无部落占领",
    "skillName_2558": "商魂",
    "skillName_2559": "量子波动",
    "17_54": "只有大酋长和管理可以宣战",
    "17_55": "支配核心捐献奖励",
    "17_56": "宣战",
    "17_57": "交战",
    "17_50": "6小时刷新一次",
    "messageInitNick_2942": "可乐要加冰",
    "17_51": "部队中所有怪兽均为濒死状态，不能派遣",
    "messageInitNick_2943": "暴风吸入猫粮",
    "skillName_2550": "震地",
    "17_52": "消耗{1}{2}对该遗迹宣战，{3}分钟后进入交战状态，部落会员可派遣怪兽部队至该遗迹，占领遗迹或{4}分钟后自动结束交战状态。",
    "messageInitNick_2940": "安分守己的心",
    "skillName_2551": "暗物质",
    "17_53": "濒死怪兽：{1}",
    "messageInitNick_2941": "麦霸",
    "skillName_2552": "独",
    "messageInitNick_2946": "别扭的可爱",
    "skillName_2553": "散射",
    "messageInitNick_2947": "红色自爆轰龙",
    "skillName_2554": "蛮击",
    "messageInitNick_2944": "沉沦历险记",
    "skillName_2555": "同生",
    "messageInitNick_2945": "芋圆战士",
    "skillName_2556": "共死",
    "iapBuyConfigName_827": "强化进阶星礼",
    "messageInitNick_2939": "笨小熊",
    "iapBuyConfigName_826": "造唤纠缠星礼",
    "iapBuyConfigName_829": "领地向荣星礼",
    "messageInitNick_2937": "来自咖喱星",
    "iapBuyConfigName_828": "神性爆发星礼",
    "messageInitNick_2938": "专业打气",
    "skillName_2570": "灌注",
    "iapBuyConfigName_821": "强化助推星礼",
    "iapBuyConfigName_820": "造唤探秘星礼",
    "iapBuyConfigName_823": "领地蓬勃星礼",
    "iapBuyConfigName_822": "神性觉醒星礼",
    "iapBuyConfigName_825": "超极之源星礼",
    "iapBuyConfigName_824": "熔炼巧匠星礼",
    "17_69": "转让酋长",
    "skillName_2568": "潮启",
    "skillName_2569": "星择",
    "17_65": "放弃占领中",
    "17_66": "倒计时结束后重置为中立状态",
    "17_67": "占领",
    "17_68": "放弃占领",
    "17_61": "总战力",
    "messageInitNick_2931": "眉笔在哭泣",
    "skillName_2560": "罗密欧的毒药",
    "17_62": "倒计时结束后可派遣部队",
    "messageInitNick_2932": "爵爷",
    "skillName_2561": "假死",
    "17_63": "被占领或倒计时结束后交战状态结束",
    "skillName_2562": "震慑",
    "17_64": "【我方部落】占领中",
    "messageInitNick_2930": "归人",
    "skillName_2563": "血祭",
    "messageInitNick_2935": "只因为太任性",
    "skillName_2564": "霸体",
    "messageInitNick_2936": "大眼萌",
    "skillName_2565": "顶端の人",
    "messageInitNick_2933": "霸你独家记忆",
    "skillName_2566": "葬",
    "17_60": "状态",
    "messageInitNick_2934": "战斗力为零",
    "skillName_2567": "焚寂",
    "iapBuyConfigName_816": "神性涌动星礼",
    "messageInitNick_2928": "保底哥",
    "iapBuyConfigName_815": "强化冲刺星礼",
    "messageInitNick_2929": "情话太烫嘴",
    "iapBuyConfigName_818": "熔炼大师星礼",
    "messageInitNick_2926": "钻石的疑问",
    "iapBuyConfigName_817": "领地繁荣星礼",
    "messageInitNick_2927": "皓月冷千山",
    "iapBuyConfigName_819": "超极之道星礼",
    "skillName_2580": "帅·歧技",
    "skillName_2581": "美·歧技",
    "17_29": "怪兽处于濒死状态",
    "iapBuyConfigName_812": "熔炼专家星礼",
    "iapBuyConfigName_811": "领地盎然星礼",
    "iapBuyConfigName_814": "造唤邂逅星礼",
    "iapBuyConfigName_813": "超极之心星礼",
    "17_36": "人数",
    "skillName_2579": "吸附",
    "17_37": "申请加入",
    "17_38": "创建部落",
    "17_39": "请输入3-12字符部落名称",
    "17_32": "每只怪兽每日最多可加快消除濒死状态{1}分钟",
    "17_33": "取消任命",
    "17_34": "未任命主将",
    "17_35": "部落名称",
    "messageInitNick_2920": "一起摸鱼",
    "skillName_2571": "加码的西亚",
    "messageInitNick_2921": "阴天的向日葵",
    "skillName_2572": "ㄨ",
    "17_30": "交战状态已结束",
    "skillName_2573": "剧毒",
    "17_31": "未排阵",
    "skillName_2574": "溜了溜了",
    "messageInitNick_2924": "看个毛线",
    "skillName_2575": "王霸一击",
    "messageInitNick_2925": "迷倒万千少女",
    "skillName_2576": "停",
    "messageInitNick_2922": "懵懂的小屁孩",
    "skillName_2577": "闪光弹",
    "messageInitNick_2923": "杨桃魔法师",
    "skillName_2578": "殉道指引",
    "iapBuyConfigName_805": "强化突破星礼",
    "messageInitNick_2917": "瞬间升天",
    "iapBuyConfigName_804": "造唤遐想星礼",
    "messageInitNick_2918": "创世纪之书",
    "messageInitNick_2915": "下个月上岸",
    "iapBuyConfigName_806": "神性提升星礼",
    "messageInitNick_2916": "孤寡青蛙",
    "skillName_2590": "鸟龙军团",
    "messageInitNick_2919": "任凭空虚沸腾",
    "skillName_2591": "黑桃尖枪",
    "skillName_2592": "红心法杖",
    "iapBuyConfigName_801": "狂热进化星礼I",
    "iapBuyConfigName_803": "狂热进化星礼III",
    "iapBuyConfigName_802": "狂热进化星礼II",
    "17_47": "升级提升至{1}",
    "17_48": "你的部队刚才发生过激战，请确认部队状态",
    "17_49": "该部落已拒绝了你的加入申请，请{1}分钟后再试",
    "17_43": "防御值扣减",
    "17_44": "关闭",
    "17_45": "已占领",
    "17_46": "放弃",
    "skillName_2582": "壮·歧技",
    "17_40": "创建",
    "messageInitNick_2910": "空城旅人",
    "skillName_2583": "吞食",
    "17_41": "申请已发送！",
    "skillName_2584": "叉出去",
    "17_42": "到达部队",
    "skillName_2585": "摄能之枪",
    "messageInitNick_2913": "此男人已疯",
    "skillName_2586": "精密切割",
    "messageInitNick_2914": "糕富帅",
    "skillName_2587": "绝望试炼",
    "messageInitNick_2911": "流浪的经理",
    "skillName_2588": "请你吔蕉",
    "messageInitNick_2912": "可是一出戏",
    "skillName_2589": "月影风暴",
    "messageInitNick_2906": "黑糖家族",
    "messageInitNick_2907": "暗相思",
    "messageInitContent_2879": "想起了他",
    "messageInitNick_2904": "保住呢份工",
    "messageInitContent_2878": "跟5号位过不去是吧",
    "messageInitNick_2905": "逆风局苹果",
    "messageInitContent_2877": "好家伙，我直接好家伙",
    "messageInitContent_2876": "帮紧你 帮紧你",
    "messageInitContent_2875": "一个人在外面一定要保护好自己",
    "messageInitNick_2908": "本无心风月",
    "messageInitContent_2874": "溜了溜了",
    "messageInitNick_2909": "未知用户",
    "skillName_2513": "啊·圣光",
    "skillName_2514": "啊·暗幕",
    "skillName_2515": "炮击",
    "skillName_2516": "GG",
    "skillName_2517": "复眼锁定",
    "skillName_2518": "疾风",
    "skillName_2519": "舔舔舔",
    "messageInitContent_2884": "？",
    "messageInitContent_2883": "出海又上岸",
    "messageInitContent_2882": "离别钩的主人是",
    "messageInitContent_2881": "有些东西就是要拼命的啊",
    "messageInitContent_2880": "东邪vs西毒最终战",
    "messageInitNick_2902": "与桃子吃晚餐",
    "messageInitNick_2903": "高端食材",
    "skillName_2510": "妈的西亚",
    "messageInitNick_2900": "碎碎念",
    "skillName_2511": "爪击",
    "messageInitNick_2901": "奋斗吧",
    "skillName_2512": "圣堂之躯",
    "messageInitContent_2889": "大E了，没有闪",
    "messageInitContent_2888": "这么粗的天机棒？？",
    "messageInitContent_2887": "我也想上岸啊！",
    "messageInitContent_2886": "上岸打怪兽",
    "messageInitContent_2885": "出海打怪兽",
    "skillName_2524": "污污污",
    "skillName_2525": "成神",
    "skillName_2526": "神的宠儿",
    "skillName_2527": "石化",
    "skillName_2528": "消失",
    "skillName_2529": "珍宝",
    "messageInitContent_2895": "如果能换2个更好",
    "messageInitContent_2894": "2个奶妈舒服",
    "messageInitContent_2893": "我记得那个小马不是用拳头的吗",
    "messageInitContent_2892": "拜拜",
    "messageInitContent_2891": "我记住你了",
    "skillName_2520": "弱点侦测",
    "messageInitContent_2890": "加油!打关人!",
    "skillName_2521": "变异",
    "skillName_2522": "起来HIGH",
    "skillName_2523": "正义",
    "messageInitContent_2899": "小兔子快跑啊啊",
    "messageInitContent_2898": "好多小动物啊",
    "messageInitContent_2897": "嘻嘻蛋蛋",
    "messageInitContent_2896": "嘻嘻御空",
    "skillName_2535": "我的剧本",
    "skillName_2536": "震惊百里",
    "skillName_2537": "吸血首",
    "skillName_2538": "三角刀",
    "skillName_2539": "好棒棒",
    "skillName_2530": "螺旋角",
    "skillName_2531": "穿透角",
    "skillName_2532": "碾压",
    "skillName_2533": "次元炮",
    "skillName_2534": "量子态",
    "17_totemBuffDesc6": "我方怪兽治疗效果提升{1}%",
    "skillName_2546": "老司机",
    "17_totemBuffDesc7": "我方怪兽受到的伤害降低{1}%",
    "skillName_2547": "霸拳",
    "17_totemBuffDesc4": "我方怪兽生物屏障提升{1}%",
    "skillName_2548": "浓缩精华",
    "17_totemBuffDesc5": "我方怪兽攻击力提升{1}%",
    "skillName_2549": "王权落幕",
    "17_totemBuffDesc8": "我方怪兽受到增益效果时，增益效果持续的时间提升{1}%",
    "17_totemBuffDesc9": "我方怪兽受到负面效果时，负面效果持续的时间降低{1}%",
    "skillName_2540": "赛卧龙",
    "skillName_2541": "火海",
    "17_totemBuffDesc2": "我方远程怪兽射程提升{1}%",
    "skillName_2542": "沼泽",
    "17_totemBuffDesc3": "我方怪兽真实伤害提升{1}%",
    "skillName_2543": "熔岩爆发",
    "skillName_2544": "阻断之地",
    "17_totemBuffDesc1": "我方怪兽炼狱模式受到伤害降低{1}%",
    "skillName_2545": "墙边战神",
    "messageInitNick_11206": "地下工作者",
    "messageInitNick_11205": "旧式拉肠",
    "messageInitNick_11204": "甜美的回忆",
    "messageInitNick_11203": "霸道分子",
    "messageInitNick_11209": "姐是限量版",
    "messageInitNick_11208": "九月朦胧",
    "messageInitNick_11207": "一代天骄",
    "messageInitNick_11202": "冰晶书童",
    "messageInitNick_11201": "凌晨两点半",
    "messageInitNick_11200": "狂飙的蝙蝠",
    "messageInitNick_11217": "石矶娘娘",
    "messageInitNick_11216": "会拟人的神",
    "messageInitNick_11215": "除了坚强",
    "messageInitNick_11214": "复读冠军",
    "messageInitNick_11219": "蹲街卖汽水",
    "messageInitNick_11218": "轻声说笨蛋",
    "messageInitNick_11213": "陈旧的沉默",
    "messageInitNick_11212": "苹果大战香蕉",
    "messageInitNick_11211": "拔刀斋",
    "messageInitNick_11210": "李子爱好者",
    "activityBuffDescription_1": "攻击力+{p1}%",
    "activityBuffDescription_2": "受到伤害-{p1}%",
    "monsterTemperamentConfigName_10": "机敏",
    "activityBuffDescription_3": "移动速度+{p1}%",
    "monsterTemperamentConfigName_11": "稳重",
    "activityBuffDescription_4": "霸气+{p1}%",
    "monsterTemperamentConfigName_12": "倔强",
    "activityBuffDescription_5": "怪兽能量回复效果+{p1}%",
    "monsterTemperamentConfigName_13": "保守",
    "activityBuffDescription_6": "怪兽技能等级+{p1}",
    "monsterTemperamentConfigName_14": "勇敢",
    "activityBuffDescription_7": "神灵能量回复速度提升{p1}%",
    "monsterTemperamentConfigName_15": "普通",
    "activityBuffDescription_8": "远程怪兽射程提升{p1}%",
    "activityBuffDescription_9": "怪兽增益效果持续时间提升{p1}%",
    "skillName_2502": "无",
    "skillName_2503": "斩击",
    "skillName_2504": "震击",
    "skillName_2505": "魔音",
    "skillName_2506": "遗物",
    "skillName_2507": "再来一口",
    "skillName_2508": "复苏",
    "skillName_2509": "冲锋",
    "skillName_2501": "无",
    "messageInitNick_11249": "国民傲娇女",
    "messageInitNick_11248": "不忍心摸鱼",
    "messageInitNick_11247": "柚子真好吃",
    "messageInitNick_11242": "悲洋洋",
    "messageInitNick_11241": "制服控香蕉",
    "messageInitNick_11240": "长命网红小吃",
    "messageInitNick_11246": "老司基",
    "messageInitNick_11245": "尊嘟假嘟",
    "messageInitNick_11244": "等海的少年",
    "messageInitNick_11243": "家里有鱼缸",
    "messageInitContent_2804": "让我解除它的封印",
    "messageInitContent_2803": "马上就到boss脚下了",
    "messageInitContent_2802": "前面好像封印了什么",
    "messageInitContent_2801": "先走一步了",
    "messageInitContent_2800": "这里好多星烁",
    "messageInitNick_11259": "苍笙踏歌",
    "messageInitContent_2809": "那是不是意味着我也会轻功",
    "messageInitNick_11258": "向日葵的花语",
    "messageInitContent_2808": "一直很好奇为什么能在水上，现在懂了",
    "messageInitContent_2807": "尸狂哭哭",
    "messageInitContent_2806": "包租公都没眼看了",
    "messageInitContent_2805": "别一来就拿2根大棒乱怼啊",
    "messageInitNick_11253": "大眼萝莉",
    "messageInitNick_11252": "对面不服打我",
    "messageInitNick_11251": "花与金丝雀",
    "messageInitNick_11250": "奇幻羽毛球",
    "messageInitNick_11257": "水晶足球",
    "messageInitNick_11256": "独家秘密",
    "messageInitNick_11255": "划水爱好者",
    "messageInitNick_11254": "杨梅炖苦瓜",
    "messageInitContent_2815": "我晕了",
    "messageInitContent_2814": "来run！",
    "messageInitContent_2813": "成功落地",
    "messageInitContent_2812": "我在下一关很想你",
    "messageInitContent_2811": "看我飞龙八式",
    "messageInitContent_2810": "看我飞燕七式",
    "messageInitNick_11228": "初夏雨凉",
    "messageInitNick_11227": "动物之王",
    "messageInitNick_11226": "行走的冰糖",
    "messageInitNick_11225": "牛奶炒蛋",
    "messageInitContent_2819": "工作才是福报",
    "messageInitContent_2818": "马手是",
    "messageInitContent_2817": "马首是瞻？",
    "messageInitContent_2816": "我也晕了",
    "messageInitNick_11229": "你品",
    "messageInitNick_11220": "会吐泡泡的鱼",
    "messageInitNick_11224": "月亮与头套",
    "messageInitNick_11223": "吃素的狮子",
    "messageInitNick_11222": "小丑的泪谁懂",
    "messageInitNick_11221": "黑色高跟鞋",
    "messageInitContent_2826": "（爬行）（扭动）（阴暗地蠕动）（翻滚）（激烈地爬动）（扭曲）",
    "resoundEventStoryName_204": "地位",
    "messageInitContent_2825": "啊啊啊啊啊",
    "resoundEventStoryName_203": "我就是世界",
    "messageInitContent_2824": "如果我赢了的话 ，可否",
    "resoundEventStoryName_206": "锤子的信仰",
    "messageInitContent_2823": "好想把蜃兽拉出来",
    "resoundEventStoryName_205": "新世界",
    "messageInitContent_2822": "大镰刀和小镰刀",
    "resoundEventStoryName_208": "镇魂之曲（1）",
    "messageInitContent_2821": "治好了，下一位",
    "resoundEventStoryName_207": "盯头锤山",
    "messageInitContent_2820": "惹又是这奶妈组合",
    "resoundEventStoryName_209": "镇魂之曲（2）",
    "messageInitNick_11239": "迷路的胸骨",
    "messageInitNick_11238": "隔空感",
    "messageInitNick_11237": "全城通缉帅哥",
    "messageInitNick_11236": "无花果的温度",
    "resoundEventStoryName_200": "夜幕间隙",
    "messageInitContent_2829": "哈人",
    "messageInitContent_2828": "先去隔壁游泳池游一圈",
    "resoundEventStoryName_202": "故事里的史莱姆",
    "messageInitContent_2827": "我是不是产生了幻觉",
    "resoundEventStoryName_201": "想火之意志",
    "messageInitNick_11231": "超级糖醋排骨",
    "messageInitNick_11230": "卖鱼强",
    "messageInitNick_11235": "电子榨菜",
    "messageInitNick_11234": "凡尔赛龙王",
    "messageInitNick_11233": "番茄好菜",
    "messageInitNick_11232": "在徘徊中等你",
    "messageInitContent_2837": "魔眼要慢慢看着爆炸",
    "resoundEventStoryName_215": "疾风兔见闻传之作者的话",
    "messageInitContent_2836": "（是一首歌",
    "resoundEventStoryName_214": "疾风兔见闻传之前言",
    "messageInitContent_2835": "多种类龙族链接？",
    "resoundEventStoryName_217": "柱食（1）",
    "messageInitContent_2834": "实名羡慕幻",
    "resoundEventStoryName_216": "tan90°之兽",
    "messageInitContent_2833": "让我访问！前面的关卡",
    "resoundEventStoryName_219": "肩膀上的花",
    "messageInitContent_2832": "快让我过去",
    "resoundEventStoryName_218": "柱食（2）",
    "messageInitContent_2831": "妖火你不要倒下啊",
    "messageInitContent_2830": "我是妖火一碰就炸",
    "resoundEventStoryName_211": "新乐器",
    "resoundEventStoryName_210": "镇魂之曲（3）",
    "messageInitContent_2839": "疯狂在炸",
    "resoundEventStoryName_213": "疾风兔的呐喊",
    "messageInitContent_2838": "爆炸就是艺术",
    "resoundEventStoryName_212": "疾风兔重金求名",
    "messageInitNick_11286": "酱鸭",
    "messageInitNick_11285": "西瓜君快逃",
    "messageInitNick_11284": "独怆然而涕下",
    "messageInitNick_11283": "吃瓜之神",
    "messageInitNick_11289": "洋葱之心",
    "messageInitNick_11288": "睁眼玩家",
    "messageInitNick_11287": "同事的沉默",
    "messageInitContent_2840": "救命一个王一个灾",
    "messageInitNick_11282": "下一站天堂",
    "messageInitNick_11281": "潜水门首席",
    "messageInitNick_11280": "开始摸鱼",
    "messageInitContent_2848": "谁是小丑",
    "resoundEventStoryName_226": "凌云之脉（2）",
    "messageInitContent_2847": "吃了吗",
    "resoundEventStoryName_225": "凌云之脉（1）",
    "messageInitContent_2846": "今天天气真好",
    "resoundEventStoryName_228": "神隐之穴（2）",
    "messageInitContent_2845": "怎么哪里都见到你",
    "resoundEventStoryName_227": "神隐之穴（1）",
    "messageInitContent_2844": "我只会心疼guaiguai",
    "messageInitContent_2843": "记得提*",
    "resoundEventStoryName_229": "重雾之外",
    "messageInitContent_2842": "别再烧了啦",
    "messageInitContent_2841": "连环爆炸。。",
    "resoundEventStoryName_220": "肩膀上的花续",
    "resoundEventStoryName_222": "《超进化委员会内刊》",
    "resoundEventStoryName_221": "《超进化委员会范规》",
    "resoundEventStoryName_224": "避险地图",
    "messageInitContent_2849": "绒绒最可爱不接受反驳",
    "resoundEventStoryName_223": "地图",
    "messageInitNick_11297": "重新定义对线",
    "messageInitNick_11296": "小萌兔",
    "messageInitNick_11295": "芭比美人鱼",
    "messageInitNick_11294": "九十岁了",
    "messageInitNick_11299": "临时男友",
    "messageInitNick_11298": "睡觉觉",
    "messageInitContent_2851": "来run！",
    "messageInitContent_2850": "你的快递到了",
    "messageInitNick_11293": "牛奶糖有点皮",
    "messageInitNick_11292": "蠢萌女神",
    "messageInitNick_11291": "初夏光年",
    "messageInitNick_11290": "菜花之心",
    "messageInitContent_2859": "3觉醒带2小弟",
    "resoundEventStoryName_237": "热诚部落（1）",
    "messageInitContent_2858": "有看到小祖拉了",
    "resoundEventStoryName_236": "黄沙与立体图纹",
    "messageInitContent_2857": "有毒",
    "resoundEventStoryName_239": "热诚部落（2）",
    "messageInitContent_2856": "那不重要",
    "resoundEventStoryName_238": "测谎之果",
    "messageInitContent_2855": "其实星烁是什么性别",
    "messageInitContent_2854": "还给神唤配了个玄武",
    "messageInitContent_2853": "神龙见首不见尾",
    "messageInitContent_2852": "快把金矿叫出来",
    "resoundEventStoryName_231": "平凡的花",
    "messageInitNick_11269": "过期工具人",
    "resoundEventStoryName_230": "世界的边缘",
    "resoundEventStoryName_233": "神秘的商店",
    "resoundEventStoryName_232": "魔形之花",
    "resoundEventStoryName_235": "岩石与二值图纹",
    "resoundEventStoryName_234": "多彩酸酸肉果",
    "messageInitNick_11264": "等我变个身先",
    "messageInitNick_11263": "爱妃接旨",
    "messageInitNick_11262": "全息咖啡",
    "messageInitNick_11261": "扬声器在大叫",
    "messageInitNick_11268": "面霜毁灭者",
    "messageInitNick_11267": "近战法师",
    "messageInitNick_11266": "卖蠢小能手",
    "messageInitNick_11265": "玩龙拳的哥哥",
    "messageInitContent_2862": "猛男与小可爱",
    "messageInitContent_2861": "前面的好凶",
    "messageInitContent_2860": "没想到还要打祖拉",
    "messageInitNick_11260": "百香果魔法师",
    "resoundEventStoryName_248": "贪婪后宫的那个东西",
    "messageInitContent_2869": "欲练神功，引刀……",
    "resoundEventStoryName_247": "碎片",
    "messageInitContent_2868": "东方不败捏",
    "messageInitContent_2867": "……",
    "resoundEventStoryName_249": "密欧子和朱丽美的日常（0）",
    "messageInitContent_2866": "真奇怪真奇怪",
    "messageInitContent_2865": "一只没有肚腩一只没有胸肌",
    "messageInitContent_2864": "跑得慢跑得慢",
    "messageInitContent_2863": "两只龙帝两只龙帝",
    "resoundEventStoryName_240": "你捡到了一张树皮",
    "resoundEventStoryName_242": "火山湖水藻团·菜改（2）",
    "resoundEventStoryName_241": "火山湖水藻团·菜改（1）",
    "resoundEventStoryName_244": "私家“农场”",
    "resoundEventStoryName_243": "智者的推荐语",
    "resoundEventStoryName_246": "普通的大多数",
    "resoundEventStoryName_245": "感恩节吃什么",
    "messageInitNick_11275": "大葱先锋",
    "messageInitNick_11274": "超级蛋糕",
    "messageInitNick_11273": "电脑之神",
    "messageInitNick_11272": "完美的脸庞",
    "messageInitNick_11279": "今天机械飞升",
    "messageInitNick_11278": "电子芥末",
    "messageInitNick_11277": "旧景依旧",
    "messageInitNick_11276": "跟风鉴定家",
    "messageInitContent_2873": "快要戳到了！",
    "messageInitContent_2872": "惊吓吧",
    "messageInitContent_2871": "处处有奇遇",
    "messageInitContent_2870": "哪哪都能捡到秘籍",
    "messageInitNick_11271": "寂寞小猪猪",
    "messageInitNick_11270": "爆米花的芳香",
    "resoundEventStoryName_138": "大力菠菜杯（2）",
    "randomEventDialogueGroupConfig_13.119": "等等，先别激进，先说说是要怎样！",
    "resoundEventStoryName_137": "大力菠菜杯（1）",
    "randomEventDialogueGroupConfig_13.118": "继续念叨",
    "randomEventDialogueGroupConfig_13.117": "停下",
    "resoundEventStoryName_139": "进化玄学",
    "randomEventDialogueGroupConfig_13.112": "铺好舒适的“床”",
    "resoundEventStoryName_130": "花市疑云",
    "randomEventDialogueGroupConfig_13.111": "唱安眠曲",
    "randomEventDialogueGroupConfig_13.110": "来啊，我的意志力可不怕你。",
    "resoundEventConfigName_10001": "1.罗密欧与朱丽叶",
    "resoundEventStoryName_132": "草人专访",
    "resoundEventConfigName_10002": "2.开始行动",
    "resoundEventStoryName_131": "场花",
    "randomEventDialogueGroupConfig_13.116": "好烦诶，能不能停下来。",
    "resoundEventStoryName_134": "斗技场武道大会门票",
    "randomEventDialogueGroupConfig_13.115": "放弃离开",
    "resoundEventStoryName_133": "停工",
    "randomEventDialogueGroupConfig_13.114": "改成不断念叨它很困",
    "resoundEventStoryName_136": "斗技场武道大会（2）",
    "randomEventDialogueGroupConfig_13.113": "你确定这是安眠曲，为什么我好像更精神了。",
    "resoundEventStoryName_135": "斗技场武道大会（1）",
    "resoundEventStoryName_149": "突然的赞美与打击",
    "resoundEventStoryName_148": "怎么可能会没有呢",
    "randomEventDialogueGroupConfig_13.129": "可以",
    "randomEventDialogueGroupConfig_13.128": "哦，好像真的没那么困了！可以教我做这个吗！",
    "randomEventDialogueGroupConfig_13.123": "拒绝并离开",
    "resoundEventStoryName_141": "叉叉的梦想",
    "randomEventDialogueGroupConfig_13.122": "让它攻过来",
    "resoundEventStoryName_140": "叉叉挨训日常",
    "randomEventDialogueGroupConfig_13.121": "虽然我不喜欢武力，但我现在真的非常烦躁，我可以打你吗？",
    "resoundEventStoryName_143": "进化啦？",
    "randomEventDialogueGroupConfig_13.120": "介绍打醒除困法",
    "resoundEventStoryName_142": "进化的捷径",
    "randomEventDialogueGroupConfig_13.127": "离开",
    "resoundEventStoryName_145": "进化呢？",
    "randomEventDialogueGroupConfig_13.126": "谢谢你，我现在就睡。",
    "resoundEventStoryName_144": "进化了？",
    "randomEventDialogueGroupConfig_13.125": "告诉它那就是睡眠不足的影响",
    "resoundEventStoryName_147": "有什么能阻止叉叉进化的步伐",
    "randomEventDialogueGroupConfig_13.124": "还好你停下了，我都被自己吓到了。#你知道吗我刚刚居然想打你，这太奇怪了。",
    "resoundEventStoryName_146": "换叉",
    "resoundEventStoryName_159": "“是日，看看你的金币！”",
    "randomEventDialogueGroupConfig_13.139": "如果我的商店后面增加这个业务，我就可以一直不睡觉做生意，也可以卖给其他商人哈哈哈。不如咱们做个交易，怎样？",
    "randomEventDialogueGroupConfig_13.134": "离开",
    "resoundEventConfigName_10021": "21.洛菲菲的战斗",
    "resoundEventStoryName_152": "红色还是蓝色（2）",
    "randomEventDialogueGroupConfig_13.133": "你真好！谢谢你。我会记住的。拜拜。",
    "resoundEventConfigName_10022": "22.沉睡",
    "resoundEventStoryName_151": "红色还是蓝色（1）",
    "randomEventDialogueGroupConfig_13.132": "离开",
    "resoundEventConfigName_10023": "23.七王",
    "resoundEventStoryName_154": "叉叉的豪宅（2）",
    "randomEventDialogueGroupConfig_13.131": "哼哼不等了，那边有个客人，有客人就不困了呢，我先过去了，再那个见。",
    "resoundEventStoryName_153": "叉叉的豪宅（1）",
    "randomEventDialogueGroupConfig_13.138": "你以为就这，就能击溃我的意志吗？好吧，好像……真可以……这就是强烈的困意吗？",
    "resoundEventStoryName_156": "叉叉的豪宅（4）",
    "randomEventDialogueGroupConfig_13.137": "害羞离开",
    "resoundEventStoryName_155": "叉叉的豪宅（3）",
    "randomEventDialogueGroupConfig_13.136": "重唱",
    "resoundEventStoryName_158": "叉叉的豪宅（6）",
    "randomEventDialogueGroupConfig_13.135": "等等，你唱多一次，什么爱我不睡的模样？",
    "resoundEventConfigName_10020": "20.盘中餐",
    "resoundEventStoryName_157": "叉叉的豪宅（5）",
    "messageInitNick_11187": "天天摇人喵",
    "resoundEventConfigName_10018": "18.独角兽",
    "messageInitNick_11186": "奉旨搞事",
    "resoundEventConfigName_10019": "19.剧变",
    "messageInitNick_11185": "往事回收站",
    "messageInitNick_11184": "欢畅的海棠果",
    "randomEventDialogueGroupConfig_13.130": "不可以",
    "resoundEventConfigName_10014": "14.圣盾之策",
    "resoundEventConfigName_10015": "15.对战邪王",
    "messageInitNick_11189": "不用再来上班",
    "resoundEventConfigName_10016": "16.假死",
    "resoundEventStoryName_150": "假叉",
    "messageInitNick_11188": "粉饼贩卖机",
    "resoundEventConfigName_10017": "17.大战结束",
    "messageInitNick_11183": "键盘在逛超市",
    "messageInitNick_11182": "等待世界末日",
    "messageInitNick_11181": "胡萝卜射手",
    "messageInitNick_11180": "不会鱿鱼",
    "randomEventDialogueGroupConfig_13.145": "好吧，不愿意就算了。不送。",
    "resoundEventConfigName_10010": "10.怪物",
    "resoundEventStoryName_163": "“昨日，看看你的金币！”",
    "randomEventDialogueGroupConfig_13.144": "成交",
    "resoundEventConfigName_10011": "11.另一种比赛",
    "resoundEventStoryName_162": "“前日，看看你的金币！”",
    "randomEventDialogueGroupConfig_13.143": "很好，一手交货一手交做法！",
    "resoundEventConfigName_10012": "12.邪王参战",
    "resoundEventStoryName_165": "重要告示！！",
    "randomEventDialogueGroupConfig_13.142": "再加这么多！",
    "resoundEventConfigName_10013": "13.林宇翔的爱情故事",
    "resoundEventStoryName_164": "重要告示！",
    "randomEventDialogueGroupConfig_13.149": "换个方式",
    "resoundEventStoryName_167": "重要告示！！！！",
    "randomEventDialogueGroupConfig_13.148": "执意出手",
    "resoundEventStoryName_166": "重要告示！！！",
    "randomEventDialogueGroupConfig_13.147": "啊这，我感觉我已经清醒了，你不用出手了。",
    "resoundEventStoryName_169": "重要告示！！！！！！",
    "randomEventDialogueGroupConfig_13.146": "离开",
    "resoundEventStoryName_168": "重要告示！！！！！",
    "messageInitNick_11198": "萌二代",
    "resoundEventConfigName_10007": "7.复仇女神",
    "messageInitNick_11197": "咕噜咕噜",
    "resoundEventConfigName_10008": "8.独闯敌阵",
    "messageInitNick_11196": "强壮恰瓜神",
    "resoundEventConfigName_10009": "9.意外的援军",
    "messageInitNick_11195": "大脑一片空白",
    "randomEventDialogueGroupConfig_13.141": "成交",
    "resoundEventConfigName_10003": "3.故技重施",
    "randomEventDialogueGroupConfig_13.140": "好的一手交货一手交做法！",
    "resoundEventConfigName_10004": "4.意外遭遇",
    "resoundEventConfigName_10005": "5.战场之上",
    "resoundEventStoryName_161": "“前日之前，看看你的金币！”",
    "messageInitNick_11199": "笑忘书",
    "resoundEventConfigName_10006": "6.天职",
    "resoundEventStoryName_160": "“前日再前，看看你的金币！”",
    "messageInitNick_11190": "愁心分两半",
    "messageInitNick_11194": "无敌跑调神",
    "messageInitNick_11193": "八成饱",
    "messageInitNick_11192": "光之柱力",
    "messageInitNick_11191": "懒猫儿",
    "resoundEventStoryName_174": "天选之咻",
    "resoundEventStoryName_173": "天选之丘",
    "resoundEventStoryName_176": "金库之丘",
    "resoundEventStoryName_175": "首领学",
    "resoundEventStoryName_178": "利爪狼的无奈",
    "resoundEventStoryName_177": "隐藏的一面",
    "resoundEventStoryName_179": "向未知启程",
    "resoundEventStoryName_170": "重要告示！！！！！！！",
    "resoundEventStoryName_172": "迷之呼声",
    "resoundEventStoryName_171": "重要告示！！！！！！！！",
    "resoundEventStoryName_185": "经历风雨就看不见的彩虹（b）",
    "resoundEventStoryName_184": "经历风雨就看不见的彩虹（a）",
    "resoundEventStoryName_187": "找朋友（2）",
    "resoundEventStoryName_186": "找朋友（1）",
    "resoundEventStoryName_189": "《听到是你的幻觉啦》By幻",
    "resoundEventStoryName_188": "风之送语",
    "messageInitNick_2890": "买点可乐",
    "messageInitNick_2891": "对味的人",
    "messageInitNick_2894": "三千亿少女梦",
    "resoundEventStoryName_181": "矮坡",
    "messageInitNick_2895": "泉水哗哗哗",
    "resoundEventStoryName_180": "幽灵火石",
    "messageInitNick_2892": "大猫咪",
    "resoundEventStoryName_183": "马上变强",
    "messageInitNick_2893": "走出理发店",
    "resoundEventStoryName_182": "马上变强训练营",
    "messageInitNick_2898": "又逢花期",
    "messageInitNick_2899": "没昵称",
    "messageInitNick_2896": "今天的暑假",
    "messageInitNick_2897": "盖五过",
    "activityNodeName_457": "BiuBiu~#……",
    "activityNodeName_458": "怪兽猎人#轰龙龙",
    "activityNodeName_459": "针对“治疗”#群体治疗",
    "resoundEventStoryName_196": "咕咕咕",
    "resoundEventStoryName_195": "未寄出的信",
    "resoundEventStoryName_198": "某天、烟火、它的热血",
    "resoundEventStoryName_197": "桐仁想要送礼，小怪兽的求爱大战",
    "resoundEventStoryName_199": "夜幕之后",
    "messageInitNick_2880": "最爱茄子",
    "resoundEventStoryName_190": "四散的纸片兽",
    "messageInitNick_2883": "菜花射手",
    "resoundEventStoryName_192": "新世界大门",
    "messageInitNick_2884": "熬夜改稿",
    "resoundEventStoryName_191": "无法碰触的星途",
    "messageInitNick_2881": "无敌模式",
    "resoundEventStoryName_194": "纪念日（2）",
    "messageInitNick_2882": "为记忆加密",
    "resoundEventStoryName_193": "纪念日（1）",
    "messageInitNick_2887": "姜兽",
    "messageInitNick_2888": "高情商烤鱼",
    "messageInitNick_2885": "魔术手大师",
    "messageInitNick_2886": "冰淇淋的夏天",
    "messageInitNick_2889": "颜值已离线",
    "messageInitContent_2903": "登陆成功",
    "randomEventDialogueGroupConfig_13.109": "多灌它几口",
    "messageInitContent_2902": "过",
    "randomEventDialogueGroupConfig_13.108": "好吧，好苦。哇哦。#怎么喝完好像更困了。",
    "messageInitContent_2901": "我们没有弱点哒",
    "randomEventDialogueGroupConfig_13.107": "不理它离开",
    "messageInitContent_2900": "修老斧修猫咪嘿嘿嘿",
    "randomEventDialogueGroupConfig_13.106": "提出要考考它的意志力",
    "randomEventDialogueGroupConfig_13.101": "帮衬一下",
    "randomEventDialogueGroupConfig_13.100": "你来帮衬一下，我说不定能坚持一下。",
    "messageInitContent_2909": "快把我的避雷针搬过来",
    "messageInitContent_2908": "不要哇",
    "messageInitContent_2907": "不许舔，不许！",
    "randomEventDialogueGroupConfig_13.105": "我向来都是依靠我的意志！",
    "messageInitContent_2906": "小花你现在跑还来得及",
    "randomEventDialogueGroupConfig_13.104": "说不信就算",
    "messageInitContent_2905": "又是你小花",
    "randomEventDialogueGroupConfig_13.103": "让它先试试",
    "messageInitContent_2904": "让我康康",
    "randomEventDialogueGroupConfig_13.102": "这东西喝了真的可以提神吗？",
    "messageInitNick_2872": "旧爱新欢",
    "messageInitNick_2873": "可乐比初恋甜",
    "messageInitNick_2870": "彩虹宝宝",
    "messageInitNick_2871": "超能帅哥",
    "messageInitNick_2876": "魅影傻瓜",
    "messageInitNick_2877": "一直被模仿",
    "messageInitNick_2874": "酱油西瓜",
    "messageInitNick_2875": "老子叫可爱",
    "messageInitNick_2878": "彪妇",
    "messageInitNick_2879": "最爱草莓",
    "randomEventDialogueGroupConfig_13.199": "收下",
    "randomEventDialogueGroupConfig_13.198": "快来，入场交易送小礼品哦！",
    "randomEventDialogueGroupConfig_13.197": "离开",
    "randomEventDialogueGroupConfig_13.192": "叫醒它",
    "randomEventDialogueGroupConfig_13.191": "它嘟囔着嘟囔着，就倒下睡着了。",
    "randomEventDialogueGroupConfig_13.190": "离开",
    "messageInitNick_2861": "星星是自由的",
    "randomEventDialogueGroupConfig_13.196": "跟上",
    "messageInitNick_2862": "恋爱未遂",
    "randomEventDialogueGroupConfig_13.195": "它大喊着冲向自己的店。",
    "randomEventDialogueGroupConfig_13.194": "它啪的一下弹了起来。",
    "messageInitNick_2860": "电子榨菜",
    "randomEventDialogueGroupConfig_13.193": "离开",
    "messageInitNick_2865": "暗夜玫瑰",
    "messageInitNick_2866": "无情的扫把",
    "messageInitNick_2863": "熬夜不好",
    "messageInitNick_2864": "枇杷射手",
    "messageInitNick_2869": "山水豆腐花生",
    "messageInitNick_2867": "泪人",
    "messageInitNick_2868": "魔女的晚餐",
    "messageInitNick_2850": "碧波玫瑰",
    "messageInitNick_2851": "乱转的小风扇",
    "messageInitNick_2854": "丝滑巧克力",
    "activityNodeName_460": "打到了#打不到",
    "messageInitNick_2855": "不能逃不能逃",
    "messageInitNick_2852": "猫星人",
    "messageInitNick_2853": "神算袜子",
    "activityNodeName_463": "不多#不少",
    "messageInitNick_2858": "窗台人影独坐",
    "activityNodeName_464": "莫奈紫#冰河蓝",
    "messageInitNick_2859": "美少女大佬",
    "activityNodeName_461": "变成光#挥舞镰",
    "messageInitNick_2856": "一巴掌呼你",
    "activityNodeName_462": "吐息#吞噬",
    "messageInitNick_2857": "天堂项坠",
    "activityNodeName_498": "老前辈#新世代",
    "messageInitNick_2849": "爱你爱的像狗",
    "activityNodeName_499": "崩刃#炎魔",
    "messageInitNick_2840": "尖叫茄子",
    "messageInitNick_2843": "巴黎小裁缝",
    "messageInitNick_2844": "真的很忙",
    "messageInitNick_2841": "最爱姜",
    "messageInitNick_2842": "浪归人",
    "activityNodeName_496": "掌法#拳法",
    "messageInitNick_2847": "小纸条",
    "activityNodeName_497": "幻想曲#镇魂曲",
    "messageInitNick_2848": "开宝马送外卖",
    "messageInitNick_2845": "泪抹倾城妆",
    "activityNodeName_495": "狂牙#双刀",
    "messageInitNick_2846": "十二香",
    "messageInitNick_2838": "弹幕礼仪小哥",
    "messageInitNick_2839": "超级光追星",
    "messageInitNick_2832": "爱卿领旨",
    "messageInitNick_2833": "西瓜爱好者",
    "messageInitNick_2830": "爱如手中沙",
    "messageInitNick_2831": "霸气小男人",
    "messageInitNick_2836": "大葱先锋",
    "messageInitNick_2837": "一年前的你",
    "messageInitNick_2834": "打字工程师",
    "messageInitNick_2835": "西部工具人",
    "messageInitNick_2829": "豆角魔法师",
    "iapBuyConfigName_716": "绝品起源盘礼包",
    "messageInitNick_2827": "落地生气根",
    "messageInitNick_2828": "单身狗的微笑",
    "randomEventDialogueGroupConfig_13.156": "都说我现在十分精神，你到底买不买东西的啊？",
    "randomEventDialogueGroupConfig_13.155": "大力劝它去睡",
    "iapBuyConfigName_711": "超值万能礼包",
    "randomEventDialogueGroupConfig_13.154": "小事情，我困得……不不我精神得很，快来看看吧！",
    "iapBuyConfigName_710": "超值极化礼包I",
    "randomEventDialogueGroupConfig_13.153": "交易",
    "iapBuyConfigName_713": "超值粉尘礼包II",
    "iapBuyConfigName_712": "超值新手礼包",
    "randomEventDialogueGroupConfig_13.159": "我看见其他客人了，你想买东西再喊我吧，我去招呼人家了。再见！",
    "iapBuyConfigName_715": "超值孢子礼包II",
    "randomEventDialogueGroupConfig_13.158": "说它这样做生意不行",
    "iapBuyConfigName_714": "超值极化礼包II",
    "randomEventDialogueGroupConfig_13.157": "全力劝它去睡",
    "randomEventDialogueGroupConfig_13.152": "哈哈，你真懂我，说到这个我就不困了，我努力不困。欢迎光临！",
    "randomEventDialogueGroupConfig_13.151": "离开",
    "randomEventDialogueGroupConfig_13.150": "它一下子就倒地不起了，分不清是被打晕了，还是睡着了，抑或假装睡着了。",
    "messageInitNick_2821": "黑夜骑士",
    "messageInitNick_2822": "肝就完事儿了",
    "messageInitNick_2820": "上届网友",
    "messageInitNick_2825": "无敌不粘锅",
    "messageInitNick_2826": "芭蕉魔法",
    "messageInitNick_2823": "此妖未成精",
    "messageInitNick_2824": "懒床钉子户",
    "iapBuyConfigName_706": "超值强化礼包",
    "messageInitNick_2818": "倒转时光",
    "iapBuyConfigName_705": "极致造唤礼包",
    "messageInitNick_2819": "苍白女子",
    "iapBuyConfigName_708": "超值建造礼包",
    "messageInitNick_2816": "你若成风",
    "iapBuyConfigName_707": "超值粉尘礼包I",
    "messageInitNick_2817": "辣条小仙女",
    "iapBuyConfigName_709": "超值觉醒礼包",
    "randomEventDialogueGroupConfig_13.167": "上前拯救",
    "randomEventDialogueGroupConfig_13.166": "它说着便倒在了地上。",
    "randomEventDialogueGroupConfig_13.165": "嘿嘿，这你就不懂了吧，你看这是什么，远离猝死，工作必备哦！",
    "randomEventDialogueGroupConfig_13.164": "反问它猝死了怎么办",
    "iapBuyConfigName_702": "超值造唤礼包I",
    "iapBuyConfigName_701": "超值孢子礼包I",
    "iapBuyConfigName_704": "超值造唤礼包II",
    "randomEventDialogueGroupConfig_13.169": "看起来已经没法拯救的样子，有什么东西从它身上爆了出来。",
    "iapBuyConfigName_703": "元核加持礼包",
    "randomEventDialogueGroupConfig_13.168": "离开",
    "randomEventDialogueGroupConfig_13.163": "我怎么错了？",
    "randomEventDialogueGroupConfig_13.162": "不再管它",
    "randomEventDialogueGroupConfig_13.161": "说它错了",
    "randomEventDialogueGroupConfig_13.160": "怎么不行了！只要我不赚钱，就可以睡更多！#哦呸，只要我不睡觉，就可以赚更多钱。",
    "messageInitNick_2810": "喂过",
    "messageInitNick_2811": "淡蓝色回忆",
    "messageInitNick_2814": "玉米火箭",
    "messageInitNick_2815": "吊儿郎当",
    "messageInitNick_2812": "复杂的三角题",
    "messageInitNick_2813": "不熟悉的你",
    "messageInitNick_2807": "小短腿跑快点",
    "messageInitNick_2808": "收藏心动",
    "messageInitNick_2805": "说什么怪话呢",
    "messageInitNick_2806": "狂飙的象",
    "messageInitNick_2809": "虚拟矮人",
    "randomEventDialogueGroupConfig_13.178": "它说着从包里掏出一堆重生元核，得意洋洋的样子。",
    "randomEventDialogueGroupConfig_13.177": "啊不，我的重生元核上次拿出来之后塞回去了没……",
    "randomEventDialogueGroupConfig_13.176": "离开",
    "randomEventDialogueGroupConfig_13.175": "地上歪歪扭扭写着几个字：不要停下来",
    "randomEventDialogueGroupConfig_13.179": "放心交易",
    "randomEventDialogueGroupConfig_13.170": "捡起",
    "randomEventDialogueGroupConfig_13.174": "离开",
    "randomEventDialogueGroupConfig_13.173": "过去看看",
    "randomEventDialogueGroupConfig_13.172": "你发现它所说的客人根本不存在。#它刚迈步就倒在了地上，它的手指着一个方向……",
    "randomEventDialogueGroupConfig_13.171": "它听完迟疑了一会，揉了揉眼，打了个哈欠，又勉强打起了精神。",
    "messageInitNick_2800": "牵手男主持",
    "messageInitNick_2803": "狂欢时间",
    "messageInitNick_2804": "笑料编织者",
    "messageInitNick_2801": "耳机剑客",
    "messageInitNick_2802": "重生之我在哪",
    "randomEventDialogueGroupConfig_13.189": "它被你铺好的“床”吸引了，倒在上面，呼呼大睡。",
    "randomEventDialogueGroupConfig_13.188": " 坚决离开",
    "randomEventDialogueGroupConfig_13.187": "成交",
    "randomEventDialogueGroupConfig_13.186": "它向你比了个手势。",
    "randomEventDialogueGroupConfig_13.181": "离开",
    "randomEventDialogueGroupConfig_13.180": "它念着念着就睡着了。",
    "randomEventDialogueGroupConfig_13.185": "执意离开",
    "randomEventDialogueGroupConfig_13.184": "同意交易",
    "randomEventDialogueGroupConfig_13.183": "它说着两手掌心相对搓了搓手。\\n",
    "randomEventDialogueGroupConfig_13.182": "它一边说话眼皮一边往下掉。",
    "messageInitContent_2999": "莫名有cp感",
    "messageInitContent_2998": "我是老炮儿",
    "messageInitContent_2997": "小炮儿",
    "messageInitContent_2996": "球球了",
    "messageInitContent_2995": "为啥喵响不再",
    "iapBuyConfigName_2004": "形态同行IV",
    "iapBuyConfigName_2002": "形态同行II",
    "iapBuyConfigName_2003": "形态同行III",
    "iapBuyConfigName_2001": "形态同行I",
    "monsterTemperamentConfigDes_10": "暴走旷野战斗开始{p1}秒内移动距离超过{p2}码",
    "monsterTemperamentConfigDes_11": "同时拥有{p1}个{p2}基因",
    "monsterTemperamentConfigDes_12": "暴走旷野战斗开始{p1}秒内受到{p2}的治疗量",
    "monsterTemperamentConfigDes_13": "暴走旷野持续{p1}秒血量低于{p2}%",
    "monsterTemperamentConfigDes_14": "狩猎战胜{p1}名探索者",
    "monsterTemperamentConfigDes_15": "默认性格",
    "ancientGeneConfigRequirementDesc_4": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_5": "解锁条件：单次暴走旷野中选择「血条补完」增益次数达{1}",
    "ancientGeneConfigRequirementDesc_2": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_3": "解锁条件：谜之生物等级达{1}级",
    "ancientGeneConfigRequirementDesc_8": "解锁条件：点亮{1}只星灵族觉醒怪兽的图鉴",
    "ancientGeneConfigRequirementDesc_9": "解锁条件：点亮{1}只木偶族觉醒怪兽的图鉴",
    "ancientGeneConfigRequirementDesc_6": "解锁条件：点亮{1}只祖龙族觉醒怪兽的图鉴",
    "ancientGeneConfigRequirementDesc_7": "解锁条件：点亮{1}只尸鬼族觉醒怪兽的图鉴",
    "ancientGeneConfigRequirementDesc_1": "解锁条件：谜之生物等级达{1}级",
    "resoundEventStoryDes_3": "梦里啥都有。\\n晚安。",
    "resoundEventStoryDes_2": "会的，还会梦游。",
    "resoundEventStoryDes_1": "怪兽会做梦吗？",
    "resoundEventStoryDes_9": "“你知道永远是多久吗？”\\n“很久很久很久很久咯？”\\n“不，永远是2秒。因为……桐仁说打败它是永远不可能的。”\\n“不……刚刚好像2秒不到？”",
    "resoundEventStoryDes_8": "它很可能是仅存在于教学关的怪兽，且打且珍惜。",
    "resoundEventStoryDes_7": "传闻说王·赤色狮打不过赤虹，所以才跟赤虹姓赤。王·赤色狮的小弟们为了照顾老大的心情，纷纷改口，称老大为色狮。",
    "resoundEventStoryDes_6": "“我真是太难了。”\\n“怎么啦。”\\n“最近有了新的追求者。”\\n“这不是好事嘛。”\\n“它看到我就对我放电。”\\n“正常，这就是爱你的表现。”\\n“正常？王·量子巨龙放电！这谁顶得住？”",
    "resoundEventStoryDes_5": "昨天\\n晴。吃吃吃吃吃燃睡睡睡睡睡烧吃吃吃吃吃我睡睡睡睡睡的吃吃吃吃吃卡睡睡睡睡睡路吃吃吃吃吃里睡睡睡睡睡。\\n今天\\n晴。昨天这么累，好好吃一顿补补才行。",
    "resoundEventStoryDes_4": "王·炼狱魔眼找到神秘商人。\\n“商人——！”\\n“这位客人，想买什么呢？”\\n“能把我伪装起来的东西，我在超星海洋捞游戏太显眼了！”\\n“确实，您就是眼嘛。咳咳，我这倒是有几件可以帮到你的产品。带上了就会变成另一只怪兽的变装眼镜，穿上了大家都会脸盲的性转古装，用上了就会直接换脸的世界十大邪术，以及本店镇店之宝你看我不到你看我不到隐身衣。您想要哪件呢？”\\n “我又不是活在虚构故事里的，这些东西有啥用啊！”\\n（不，你是（划掉））",
    "messageInitContent_2914": "怎么都是这些东西",
    "messageInitContent_2913": "这个沙漠什么回事捏",
    "messageInitContent_2912": "快把我的下一关拿来",
    "messageInitContent_2911": "快来把我的绝缘体到来",
    "messageInitContent_2910": "快把我的胶手套拿来",
    "messageInitNick_11129": "不用管它",
    "messageInitNick_11128": "尖叫茄子",
    "messageInitNick_11127": "可乐冰激凌",
    "messageInitContent_2919": "看看溜溜的等级",
    "messageInitNick_11126": "卖萌小能手",
    "messageInitContent_2918": "三只小溜溜",
    "messageInitContent_2917": "不一样的是c位",
    "messageInitContent_2916": "你的颜色怎么不一样呢 小泰坦",
    "messageInitContent_2915": "中出了一个叛徒",
    "messageInitNick_11121": "纸之王",
    "messageInitNick_11120": "今年退休",
    "messageInitNick_11125": "来抱抱猫",
    "messageInitNick_11124": "风在云巅",
    "messageInitNick_11123": "七寸执念",
    "messageInitNick_11122": "且行且珍惜",
    "messageInitContent_2925": "墙墙联合",
    "messageInitContent_2924": "玩球",
    "messageInitContent_2923": "冲鸭！",
    "messageInitContent_2922": "666666 ",
    "messageInitContent_2921": "6666666666 ",
    "messageInitContent_2920": "666 ",
    "messageInitNick_11139": "平庸鬼",
    "messageInitNick_11138": "自由的旅行箱",
    "messageInitNick_11137": "共饮孟婆汤",
    "messageInitContent_2929": "带御空的大师啧啧",
    "messageInitContent_2928": "才不让你蓄力完",
    "messageInitContent_2927": "都给我蹲墙角去",
    "messageInitContent_2926": "暗中观察",
    "messageInitNick_11132": "蜡笔小丸子",
    "messageInitNick_11131": "我在那里想你",
    "messageInitNick_11130": "疯狂星期",
    "messageInitNick_11136": "江山如画",
    "messageInitNick_11135": "武艺高强",
    "messageInitNick_11134": "空大小能手",
    "messageInitNick_11133": "蘑菇之谜",
    "messageInitContent_2936": "气嗷~",
    "messageInitContent_2935": "还有2关emm",
    "messageInitContent_2934": "葵花——点穴手",
    "messageInitContent_2933": "双御空！",
    "messageInitContent_2932": "我出剪刀",
    "messageInitContent_2931": "= =",
    "messageInitContent_2930": "我出包",
    "messageInitNick_11107": "迷路的胫骨",
    "messageInitNick_11106": "放学别走",
    "messageInitNick_11105": "欢歌笑语",
    "messageInitNick_11104": "重拳出发",
    "messageInitContent_2939": "我的热情已经热得不行",
    "messageInitContent_2938": "已经够热了",
    "messageInitNick_11109": "混世小宅男",
    "messageInitContent_2937": "嗷嗷嗷嗷嗷",
    "messageInitNick_11108": "打小我就淘气",
    "messageInitNick_11103": "充满希望",
    "messageInitNick_11102": "半江渔火",
    "messageInitNick_11101": "解谜老衲",
    "messageInitNick_11100": "张嘴喂你",
    "themeCardPackDes_23005": "一蹦一蹦的星刃忽然停下，它那似乎是耳朵的部位微微转动，转向西侧的矮灌木丛，里有传来阵阵同类的微弱呜咽，是求救的声音。它立刻跳了进去——一张血盆大口稳稳地接住了它。吞噬者吃掉了这只“心善”的星刃，作为今日满载而归的奖励，它腹部的大嘴中还装着数只嘤嘤惨叫着的星刃。\\n“只要留着一只，就会有更多更多！”它想着舔了舔嘴角的脏污，心满意足地准备起身返回巢穴。却在此时，小腿猛地被什么东西撞了一下，那是一只不知道从哪里滚来的星刃。\\n疯了，那只星刃一定是疯了，不然怎么会边尖叫边冲来？它也疯了。在意识消散的最后一刻，它就知道了，巢穴的幼兽还有它最疼爱的捕食者，等不来它们的大餐了。\\n此刻，一团泛着诡异紫光的不明肉块正牢牢扎在它的背上。",
    "messageInitContent_2947": "我要把你们榨干！",
    "messageInitContent_2946": "沼泽隔壁有水还是很合理的",
    "messageInitContent_2945": "蜻蜓龙加地龙",
    "messageInitContent_2944": "大沙漠怎么长草",
    "themeCardPackDes_23010": "混沌森林的东侧有一条小河，河边有一个小型聚落。栖息着以尸狂为首的尸鬼族兽群。一日清晨，聚落在经过一夜的欢娱与劳作后，缓缓沉入梦乡。并非所有尸鬼族都喜欢在白天活动，不巧，这个聚落正是这个种族中的夜尸子组建的。原本傍晚才应热闹的聚落，此刻却静得出奇。\\n时间来到半日后，一只捕食者摔倒在地上。它是整个聚落中体型最小的尸鬼族，它已经没有力气哭也没有力气跑了，大头、绷带、龅牙没人知道它经历了些什么。但日后它将会有一个别样的称呼——骸灾首位目击兽及幸存兽。",
    "messageInitContent_2943": "龙爪手？？",
    "messageInitContent_2942": "来只骆驼",
    "messageInitContent_2941": "水我要睡",
    "messageInitContent_2940": "这不是泪是汗水",
    "messageInitNick_11118": "乡村杀马特",
    "messageInitNick_11117": "我家断水了",
    "messageInitNick_11116": "还是奇行种",
    "messageInitNick_11115": "吃鸡全靠苟",
    "messageInitContent_2949": "小赤虹快回家",
    "messageInitContent_2948": "燃烧我的子弹",
    "messageInitNick_11119": "本宫不退位",
    "messageInitNick_11110": "剧中人",
    "messageInitNick_11114": "职业带妹",
    "messageInitNick_11113": "你敢答应吗",
    "messageInitNick_11112": "不语来日方长",
    "messageInitNick_11111": "烤烤烤烤肉",
    "messageInitContent_2950": "我需要一个冰霓",
    "themeCardPackDes_23015": "混沌森林的北侧有一处废墟，废墟中栖息着一群木偶族的怪兽。木头相碰的闷响、齿轮转动的咔哒声，曾是这里不变的日常。\\n直到一只从未见过的怪兽踏入这里。\\n疤脸一点点转过头，握住发条的手骤然停下。一团紫色孢刺刺入了它的体内。仿佛突然意识到了什么，它反手猛拉一旁的拉杆。聚落里头平稳的机械运转声骤然急促。轮脉、影杀、极限越来越多的木偶族迅速聚集……",
    "messageInitContent_2958": "2？3个王",
    "messageInitContent_2957": "拿来吧你",
    "messageInitContent_2956": "溜了溜了",
    "messageInitContent_2955": "啊这里有莎~~",
    "messageInitContent_2954": "看来有故事",
    "messageInitContent_2953": "不带白子玩？",
    "messageInitContent_2952": "风继续吹",
    "messageInitContent_2951": "别把沙吹过来",
    "messageInitContent_2959": "怎么和灾混一起了",
    "messageInitNick_11165": "橙味少女",
    "messageInitNick_11164": "给电灯按摩",
    "messageInitNick_11163": "酷酷的小仙女",
    "messageInitNick_11162": "臭臭的香猪",
    "messageInitNick_11169": "明明很可爱",
    "messageInitNick_11168": "肱骨",
    "messageInitNick_11167": "抱紧我别松手",
    "messageInitNick_11166": "博得之扉",
    "messageInitContent_2961": "你好",
    "messageInitContent_2960": "难顶",
    "messageInitNick_11161": "没有缓存去爱",
    "messageInitNick_11160": "闲着模式",
    "messageInitContent_2969": "全双种族阵容啊",
    "resoundEventStoryName_105": "圣堂武士的后话",
    "messageInitContent_2968": "花花打人了救命",
    "resoundEventStoryName_104": "圣堂武士的离群",
    "messageInitContent_2967": "送你花花",
    "resoundEventStoryName_107": "PeroPero",
    "messageInitContent_2966": "饿了",
    "resoundEventStoryName_106": "镇魂之爱",
    "messageInitContent_2965": "雷火交织啊啊",
    "resoundEventStoryName_109": "谁的粉丝",
    "messageInitContent_2964": "怪不得这么热",
    "resoundEventStoryName_108": "焕然一新的大舌怪",
    "messageInitContent_2963": "我 的 天",
    "messageInitContent_2962": "气死了",
    "resoundEventStoryName_101": "圣堂武士的禁律谷碑（1）",
    "resoundEventStoryName_100": "圣堂武士的提问",
    "resoundEventStoryName_103": "圣堂武士的异变",
    "resoundEventStoryName_102": "圣堂武士的禁律谷碑（2）",
    "messageInitNick_11176": "键盘先锋",
    "messageInitNick_11175": "好好吃饭",
    "messageInitNick_11174": "鸭子飞飞",
    "messageInitNick_11173": "手机杀手",
    "messageInitNick_11179": "暗恋成真",
    "messageInitNick_11178": "芹菜真好吃",
    "messageInitNick_11177": "超级炸虾",
    "messageInitContent_2972": "你好我是i坤",
    "messageInitContent_2971": "你好我是大谱离",
    "messageInitContent_2970": "您好我是说得兑",
    "messageInitNick_11172": "这可不行",
    "messageInitNick_11171": "痴心少年",
    "messageInitNick_11170": "反内卷之王",
    "resoundEventStoryName_116": "超进化委员一天工作（2）",
    "messageInitContent_2979": "又来",
    "resoundEventStoryName_115": "超进化委员一天工作（1）",
    "messageInitContent_2978": "这是去割草吗",
    "resoundEventStoryName_118": "生意惨淡的智者",
    "messageInitContent_2977": "能不能给我神唤换个神灵",
    "resoundEventStoryName_117": "智者与万答屋",
    "messageInitContent_2976": "神唤和玄武就绑死了是吧",
    "messageInitContent_2975": "我发现了有神唤就会有神灵",
    "resoundEventStoryName_119": "理由",
    "messageInitContent_2974": "建议把尸狂把吉他换成幻的",
    "messageInitContent_2973": "大家好我是八卦记者",
    "messageInitNick_11149": "义字当头",
    "resoundEventStoryName_110": "无法逃离的哀歌",
    "messageInitNick_11148": "别在这理发店",
    "resoundEventStoryName_112": "大舌怪给镇魂的信",
    "resoundEventStoryName_111": "白昼的烦恼",
    "resoundEventStoryName_114": "大舌怪的歌词",
    "resoundEventStoryName_113": "收到信的镇魂",
    "messageInitNick_11143": "洗衣粉剑客",
    "messageInitNick_11142": "哪个小花",
    "messageInitNick_11141": "延续颓废",
    "messageInitNick_11140": "没有昵称",
    "messageInitNick_11147": "迷路的肋骨",
    "messageInitNick_11146": "无公害蘑菇",
    "messageInitNick_11145": "西兰花真好吃",
    "messageInitNick_11144": "傲天的微笑",
    "messageInitContent_2983": "哈哈哈",
    "messageInitContent_2982": "怎么不上天再爆捏",
    "messageInitContent_2981": "呆滞",
    "messageInitContent_2980": "离我远一点啊啊",
    "resoundEventStoryName_127": "在打广告的智者",
    "resoundEventStoryName_126": "想打广告的智者",
    "messageInitContent_2989": "找对象",
    "resoundEventStoryName_129": "指名治疗",
    "messageInitContent_2988": "有小姐姐吗",
    "resoundEventStoryName_128": "打了广告的智者",
    "messageInitContent_2987": "帅哥们晚上好",
    "messageInitContent_2986": "那只能请你们吃AOE了",
    "messageInitContent_2985": "可惜我输出爆炸",
    "messageInitContent_2984": "死保jo哥是吧",
    "resoundEventStoryName_121": "问答",
    "messageInitNick_11159": "耳机破坏者",
    "resoundEventStoryName_120": "指路木块",
    "resoundEventStoryName_123": "桐仁的朋友",
    "resoundEventStoryName_122": "E4计划",
    "resoundEventStoryName_125": "诡异的符号",
    "resoundEventStoryName_124": "什么怎么办",
    "messageInitNick_11154": "最爱李子",
    "messageInitNick_11153": "我就是好男人",
    "messageInitNick_11152": "摆渡翁",
    "messageInitNick_11151": "切西瓜表演家",
    "messageInitNick_11158": "熬夜大王",
    "messageInitNick_11157": "心在流浪",
    "messageInitNick_11156": "神算袜子",
    "messageInitNick_11155": "呼风唤雨",
    "messageInitContent_2994": "整个薛定谔的猫皮肤吧",
    "messageInitContent_2993": "准备吃烤鸡翅，就是在飞的那只",
    "messageInitContent_2992": "一直想不明白这刀刃怎么向内",
    "messageInitContent_2991": "这不是胖虎",
    "messageInitContent_2990": "像话吗",
    "messageInitNick_11150": "光明的未来",
    "8_2161": "神灵",
    "8_2160": "元核",
    "8_2163": "强者笔记",
    "8_2162": "其他",
    "8_2164": "未解锁",
    "8_2167": "等级",
    "8_2166": "等级",
    "8_2169": "极化",
    "8_2168": "基因",
    "messageInitNick_2340": "先打我队友",
    "messageInitNick_2341": "是个替代品",
    "messageInitNick_2344": "回忆吞噬我心",
    "messageInitNick_2345": "专业捡垃圾",
    "messageInitNick_2342": "五行缺钱",
    "messageInitNick_2343": "哭是我的专长",
    "messageInitNick_2348": "草帽海盗团",
    "messageInitNick_2349": "你火星了",
    "messageInitNick_2346": "南半球那棵树",
    "messageInitNick_2347": "零食",
    "8_2170": "技能",
    "8_2150": "有",
    "activityNodeName_500": "卧龙#械龙",
    "activityNodeName_501": "魔瞳#魔眼",
    "8_2152": "无",
    "8_2151": "有",
    "8_2156": "未解锁",
    "activityNodeName_502": "海王#海帝",
    "8_2155": "你所属领地的斗技场之主{1}路过此地，目睹了刚才发生的一切，他伸出了援手，你接受帮助吗？",
    "8_2158": "已降临",
    "8_2157": "？？？？",
    "8_2159": "怪兽",
    "messageInitNick_4992": "地狱邮差",
    "messageInitNick_2330": "脑细胞出差",
    "messageInitNick_4991": "橙子君快逃",
    "messageInitNick_4990": "煮茶女",
    "messageInitNick_2333": "重新定义信仰",
    "messageInitNick_4996": "拉黑了",
    "messageInitNick_2334": "吧唧吧唧",
    "messageInitNick_4995": "天天打酱油",
    "messageInitNick_2331": "听心碎的声音",
    "messageInitNick_4994": "非人类",
    "messageInitNick_2332": "不走中要迷路",
    "messageInitNick_4993": "按时摆摊",
    "messageInitNick_2337": "红色沙漠",
    "messageInitNick_2338": "把梦留给海",
    "messageInitNick_4999": "一眼万年",
    "messageInitNick_2335": "大饼你咋扁啦",
    "messageInitNick_4998": "可苦可乐",
    "messageInitNick_2336": "等我变身好吗",
    "messageInitNick_4997": "蛋黄酱星人",
    "messageInitNick_2339": "把你藏心里",
    "8_2141": "乱入",
    "8_2140": "世界灾厄每隔{1}个小时刷新",
    "8_2143": "游荡智者",
    "8_2142": "世界灾厄",
    "8_2145": "请选择",
    "8_2144": "积分重置",
    "8_2147": "{1}：",
    "iapBuyConfigName_610": "月粉尘礼包",
    "8_2146": "对话记录",
    "8_2149": "再次触发的可能性：",
    "iapBuyConfigName_612": "超凡起源盘礼包",
    "8_2148": "今天乱入事件次数：",
    "iapBuyConfigName_611": "月造唤光华礼包II",
    "emblemSynchronizeConfigDescription_5": "拥有6条红色或以上品质的词条属性，该元核所有词条属性效果提升%",
    "messageInitNick_4981": "菠萝龙",
    "messageInitNick_4980": "知情中单",
    "emblemSynchronizeConfigDescription_3": "拥有4条紫色或以上品质的词条属性，该元核所有词条属性效果提升%",
    "emblemSynchronizeConfigDescription_4": "拥有5条橙色或以上品质的词条属性，该元核所有词条属性效果提升%",
    "messageInitNick_2322": "失眠青蛙",
    "messageInitNick_4985": "流浪的骶尾椎",
    "messageInitNick_2323": "临期小鲜肉",
    "messageInitNick_4984": "牙线毁灭者",
    "messageInitNick_2320": "病娇萝莉",
    "messageInitNick_4983": "爱猫情深",
    "messageInitNick_2321": "会吐泡泡的鱼",
    "messageInitNick_4982": "尬聊少年",
    "messageInitNick_2326": "吟游至下世纪",
    "messageInitNick_4989": "什锦饭",
    "messageInitNick_2327": "风中的歌声",
    "messageInitNick_4988": "破碎镜",
    "messageInitNick_2324": "小任性",
    "messageInitNick_4987": "海洋之神",
    "messageInitNick_2325": "孤身战群魔",
    "messageInitNick_4986": "记录保持者",
    "emblemSynchronizeConfigDescription_1": "无",
    "emblemSynchronizeConfigDescription_2": "拥有3条蓝色或以上品质的词条属性，该元核所有词条属性效果提升%",
    "messageInitNick_2328": "不靠谱小姐",
    "messageInitNick_2329": "糊涂妞撞我心",
    "iapBuyConfigName_607": "月极化礼包",
    "iapBuyConfigName_606": "月造唤礼包III",
    "8_2130": "我",
    "iapBuyConfigName_609": "月造唤光华礼包I",
    "iapBuyConfigName_608": "月纬织源礼包",
    "8_2132": "传送门",
    "8_2131": "探索中……",
    "8_2134": "暂无可联结的好友",
    "8_2133": "转移",
    "8_2136": "好友",
    "8_2135": "暂无连接邀请",
    "8_2138": "联结者",
    "iapBuyConfigName_601": "月造唤礼包I",
    "8_2137": "部落",
    "iapBuyConfigName_600": "月致谢礼包",
    "iapBuyConfigName_603": "月孢子礼包",
    "8_2139": "一键邀请",
    "iapBuyConfigName_602": "月建材礼包",
    "iapBuyConfigName_605": "月原石礼包",
    "iapBuyConfigName_604": "月造唤礼包II",
    "messageInitNick_4970": "起来修仙啦",
    "messageInitNick_2311": "豆腐遇上渣",
    "messageInitNick_4974": "堆使劲堆",
    "messageInitNick_2312": "地狱战神",
    "messageInitNick_4973": "一起吃饭吗",
    "messageInitNick_4972": "专业画饼",
    "messageInitNick_2310": "套娃冠军",
    "messageInitNick_4971": "超级饼干",
    "messageInitNick_2315": "人气声优",
    "messageInitNick_4978": "灵魂傀儡",
    "messageInitNick_2316": "灭龙魔导士",
    "messageInitNick_4977": "临风唱晚秋",
    "messageInitNick_2313": "摸鱼王子",
    "messageInitNick_4976": "神秘核液",
    "messageInitNick_2314": "旧车票",
    "messageInitNick_4975": "牛本山",
    "messageInitNick_2319": "爱你没商量",
    "messageInitNick_2317": "摸鱼神",
    "messageInitNick_2318": "童心未泯",
    "messageInitNick_4979": "疯到世界奔溃",
    "darkForestAbilityConfigName_2": "体力提升",
    "darkForestAbilityConfigName_1": "攻击提升",
    "8_2121": "请选择",
    "8_2120": "超跃",
    "8_2123": "在未知区域",
    "8_2122": "复制体",
    "8_2125": "收获",
    "8_2124": "{1}后世界灾厄降临",
    "darkForestAbilityConfigName_9": "攻击同调",
    "8_2127": "前往",
    "darkForestAbilityConfigName_8": "精密射击",
    "8_2126": "已到达仓库上限",
    "darkForestAbilityConfigName_7": "超速冲撞",
    "8_2129": "到达节点才可购买",
    "darkForestAbilityConfigName_6": "缩小化",
    "8_2128": "未占领",
    "darkForestAbilityConfigName_5": "巨大化",
    "darkForestAbilityConfigName_4": "屏障提升",
    "darkForestAbilityConfigName_3": "真伤提升",
    "messageInitNick_2300": "泡沫森林",
    "messageInitNick_4963": "对线之神",
    "messageInitNick_2301": "富婆",
    "messageInitNick_4962": "社会加班人",
    "messageInitNick_4961": "猫群中的鸽子",
    "messageInitNick_4960": "可怜的仁",
    "messageInitNick_2304": "能够放下了",
    "messageInitNick_4967": "渐成斗士",
    "messageInitNick_2305": "退役捡漏选手",
    "messageInitNick_4966": "摄影小白",
    "messageInitNick_2302": "开心的笨小孩",
    "messageInitNick_4965": "万能拖鞋",
    "messageInitNick_2303": "拾起自我",
    "messageInitNick_4964": "颗颗蛀牙",
    "messageInitNick_2308": "在逃观察员",
    "messageInitNick_2309": "都都小嘴",
    "messageInitNick_2306": "你缺席的岁月",
    "messageInitNick_4969": "万能书",
    "messageInitNick_2307": "地狱之眼",
    "messageInitNick_4968": "第三啫喱",
    "8_2110": "黑暗森林",
    "8_2112": "星律",
    "8_2111": "谜之巢穴",
    "8_2114": "已挂机",
    "8_2113": "野生",
    "8_2116": "资源总览",
    "8_2115": "领取",
    "8_2118": "马上获得奖励",
    "8_2117": "超跃",
    "8_2119": "剩余次数：{1}",
    "messageInitNick_4952": "大黑妞",
    "messageInitNick_4951": "早上四点半",
    "messageInitNick_4950": "读万卷书",
    "messageInitNick_4956": "洋葱魔法师",
    "messageInitNick_4955": "真的好会",
    "messageInitNick_4954": "在下",
    "messageInitNick_4953": "哀伤的钢琴",
    "messageInitNick_4959": "隐者之紫",
    "messageInitNick_4958": "玉米撞地球",
    "messageInitNick_4957": "莫比乌斯拳",
    "8_2101": "部落",
    "8_2100": "领取奖励",
    "8_2103": "处于普通模式下，无法狩猎和被狩猎。",
    "8_2102": "关闭邀请权限",
    "8_2105": "一键压制",
    "8_2104": "奖励",
    "8_2107": "造唤台",
    "8_2106": "进化树",
    "8_2109": "斗技场",
    "8_2108": "起源殿",
    "messageInitNick_4941": "青梅竹马",
    "messageInitNick_4940": "该如何骗你",
    "messageInitNick_4945": "大佬的马子",
    "messageInitNick_4944": "猩猩在画画",
    "messageInitNick_4943": "红毯之王",
    "messageInitNick_4942": "彪悍小伙子",
    "messageInitNick_4949": "一介俗人",
    "messageInitNick_4948": "纯情辣椒圈",
    "messageInitNick_4947": "一起哈皮",
    "messageInitNick_4946": "我很乖",
    "messageInitNick_4939": "超级红地毯",
    "shopDes_3": "起源殿",
    "shopDes_4": "狩猎",
    "shopDes_5": "友好",
    "shopDes_6": "部落",
    "shopDes_7": "饲星",
    "shopDes_8": "神秘",
    "shopDes_9": "积分",
    "messageInitNick_4930": "给伤痛微笑",
    "shopDes_1": "一发入欧",
    "shopDes_2": "斗技场",
    "messageInitNick_4934": "核动力饮水机",
    "messageInitNick_4933": "泡面怪客",
    "messageInitNick_4932": "汤圆滚远了",
    "messageInitNick_4931": "地狱使者",
    "messageInitNick_4938": "超级炸鸡",
    "messageInitNick_4937": "如果荔枝会笑",
    "messageInitNick_4936": "此男姐的专属",
    "messageInitNick_4935": "是他胖的",
    "activityNodeName_597": "MY魂!!#猫GO!!",
    "messageInitNick_4929": "电流顾问",
    "activityNodeName_598": "重逢#初识",
    "messageInitNick_4928": "笑面虎",
    "messageInitContent_2599": "这盘棋我赢了",
    "activityNodeName_591": "吹箭#吹喇叭",
    "messageInitNick_4923": "有点小可爱",
    "activityNodeName_592": "小马快跑#公子吃包",
    "messageInitNick_4922": "无敌摸鱼神",
    "messageInitNick_4921": "芒果射手",
    "messageInitNick_4920": "猜寄信人",
    "activityNodeName_595": "无限雷鸣#箭随星落",
    "messageInitNick_4927": "镜子狂怒者",
    "activityNodeName_596": "比蒙巨巨#蛇发莎莎",
    "messageInitNick_4926": "转角遇到怪",
    "activityNodeName_593": "同当！#同享？",
    "messageInitNick_4925": "大力王",
    "activityNodeName_594": "HIGH起来#起来HIGH",
    "messageInitNick_4924": "香蕉之心",
    "messageInitNick_4919": "往事回收站",
    "messageInitNick_4918": "带帽子的鱼",
    "messageInitNick_4917": "奔驰的打野",
    "messageInitNick_4912": "倾听陌上花开",
    "messageInitNick_4911": "溺于你心海",
    "messageInitNick_4910": "你不在的世界",
    "messageInitNick_4916": "东亚醋王",
    "messageInitNick_4915": "能不能别掏",
    "messageInitNick_4914": "屁过无痕",
    "messageInitNick_4913": "低调小伙",
    "98_-100006": "每周狩猎次数已达到上限，无法进行狩猎",
    "messageInitNick_4909": "明年体检",
    "98_-100007": "猎物尚未离开，无法进行搜索",
    "messageInitNick_4908": "急也没用",
    "98_-100004": "正处于被狩猎状态，无法切换为普通模式",
    "messageInitNick_4907": "尬聊观察员",
    "98_-100005": "正处于普通状态，无法进行狩猎",
    "messageInitNick_4906": "发光发热的灯",
    "98_-100008": "搜索范围内的节点尚未开启，无法进行搜索",
    "98_-100009": "猎物已离开，请重新搜索",
    "messageInitNick_4901": "宅久天然呆",
    "messageInitNick_4900": "银河倾斜",
    "98_-100002": "野生怪兽已离开",
    "messageInitNick_4905": "总是钓不到鱼",
    "98_-100003": "当前节点与目标节点不相连",
    "messageInitNick_4904": "筛骨",
    "messageInitNick_4903": "自走摄像机",
    "98_-100001": "永远哈皮信息已变更",
    "messageInitNick_4902": "松鼠在编程",
    "96_ExtensionTask": "支线冒险",
    "8_2194": "及时收获星律的产出非常重要，是探索者经验的主要来源",
    "8_2193": "神灵契约可根据选择，加强对应神灵的作战能力",
    "8_2196": "在起源基石放入怪兽可使部分怪兽获得增益，放入怪兽越强，增益越高",
    "8_2195": "在黑暗森林中击败凶兽和特殊事件可获得漆黑源，用于提升漆黑之根中的各种能力，增强怪兽",
    "8_2198": "找回",
    "8_2197": "加固战墙可百分比提升装嵌战纹的效果，战斗中怪兽触碰战墙会触发对应的战纹效果",
    "8_2199": "捕捉失败",
    "7_comment": "怪兽评论",
    "8_2183": "觉醒品质的怪兽可消耗同名怪兽碎片或万能碎片提升技能等级，饲星坛商店可兑换万能碎片",
    "8_2182": "怪兽基因强化可自主选择属性进行提升，攻击力和体力是比较中庸但稳妥的选择",
    "8_2185": "元核可装嵌在任意怪兽身上，装卸无消耗，是怪兽的主要属性来源",
    "8_2184": "怪兽极化可增强怪兽的基础属性，并有概率获得各种强大的极化技能",
    "8_2187": "元核升级可提升元核属性，元核进阶可提升词条属性和宿命效果",
    "8_2186": "元核的品质越高，拥有的词条属性越多，也更容易出现基础值更高的词条属性和宿命效果",
    "8_2189": "元核分解和熔炼均会返还100%资源",
    "8_2188": "元核熔炼可以把两颗元核的词条属性和宿命效果进行随机组合，获得全新的元核，需要注意的是作为材料的元核会消失",
    "8_2190": "探索者等级提升可解锁新神灵，神灵的配搭和释放时机会对战局产生巨大的影响",
    "8_2192": "前期主升2-3只神灵，其他神灵升至2级解锁二阶效果会是一个不错的选择",
    "8_2191": "神灵升阶可提升神灵在场时的被动效果，解锁新的神灵技能",
    "8_2172": "进阶",
    "8_2171": "进化",
    "8_2174": "起源基石",
    "8_2173": "漆黑之根",
    "8_2176": "熔炼",
    "8_2175": "契约",
    "8_2178": "星律",
    "8_2177": "升阶",
    "8_2179": "战墙",
    "8_2181": "怪兽进化可提升各种基础属性和成长值，解锁新的怪兽技能",
    "8_2180": "怪兽升级可提升攻击力和体力",
    "messageInitContent_2639": "奖励里我看到了什么！",
    "messageInitContent_2638": "阵容开始豪华起来了",
    "messageInitContent_2637": "狐狸就是爱骗人的动物",
    "messageInitContent_2636": "你们放过他们吧！",
    "messageInitNick_11409": "沉浸式拍照",
    "messageInitContent_2635": "你们放过怪兽吧",
    "messageInitContent_2634": "不要告诉我1号位是鸳鸯刀",
    "messageInitContent_2633": "只想说一句，咋又被抓了呀",
    "messageInitContent_2632": "于今喜睡，气似奔雷",
    "messageInitNick_11404": "菜鸟香蕉",
    "messageInitNick_11403": "超时空平板",
    "messageInitNick_11402": "钢琴的疑问",
    "messageInitNick_11401": "暴走小正太",
    "messageInitNick_11408": "反复拉扯",
    "messageInitNick_11407": "你在外头等我",
    "messageInitNick_11406": "思乡念旧",
    "messageInitNick_11405": "慌张的龙",
    "messageInitNick_11400": "光棍村村长",
    "messageInitContent_2642": "王灾合一",
    "messageInitContent_2641": "变身！",
    "messageInitContent_2640": "欲望大赛的跑错了",
    "1_comment": "怪兽, 进化, 进化树, 远古选择界面",
    "messageInitContent_2649": "送上门的小礼物。",
    "messageInitContent_2648": "这山脚可真热闹",
    "messageInitContent_2647": "999999999999",
    "messageInitContent_2646": "血条你顶住啊！",
    "messageInitContent_2645": "想怂恿他们窝里内斗",
    "messageInitContent_2644": "真的就一起上啊啊啊",
    "messageInitContent_2643": "这boss是知道一个人打不过就",
    "messageInitNick_11415": "给沙发带货",
    "messageInitNick_94": "打脸神",
    "messageInitNick_11414": "床离厕所太远",
    "messageInitNick_95": "丽贝卡酱",
    "messageInitNick_11413": "突出叛逆",
    "messageInitNick_96": "好贴",
    "messageInitNick_11412": "发型又乱了",
    "messageInitNick_97": "打脸之神",
    "messageInitNick_11419": "可乐控程序",
    "messageInitNick_98": "拍扁就是美味",
    "messageInitNick_11418": "别逼我变身",
    "messageInitNick_99": "好抽",
    "messageInitNick_11417": "家有空调",
    "messageInitNick_11416": "酸甜彩虹糖",
    "messageInitNick_11411": "此奶有毒",
    "messageInitNick_11410": "猫咪交响乐",
    "messageInitContent_2653": "孤独的合一",
    "messageInitContent_2652": "joker是货？",
    "messageInitContent_2651": "不对，这可能是镖队",
    "messageInitContent_2650": "礼多人不怪？",
    "messageInitContent_2659": "前方高危",
    "messageInitContent_2658": "前方高能",
    "messageInitContent_2657": "铁布衫？",
    "messageInitContent_2656": "看我突破你们的功夫",
    "messageInitContent_2655": "一炮顶2",
    "messageInitContent_2654": "这打手好像不太够快",
    "messageInitNick_83": "我再牛",
    "messageInitNick_84": "打脸之帝",
    "messageInitNick_85": "我牛我再牛",
    "messageInitNick_86": "超级打脸帝",
    "messageInitNick_87": "贴贴",
    "messageInitNick_88": "无敌打脸帝",
    "messageInitNick_89": "不想喝海水",
    "messageInitNick_90": "贴贴贴贴贴",
    "messageInitNick_91": "强壮打脸帝",
    "messageInitNick_92": "欧巴多啦诶梦",
    "messageInitNick_93": "贴贴贴",
    "27_2004": "商店",
    "messageInitContent_2664": "好家伙",
    "27_2005": "我的竞猜",
    "messageInitContent_2663": "黄色和蓝色，是下午的天空",
    "27_2006": "排阵",
    "messageInitContent_2662": "这墙神学了轻功啊",
    "27_2007": "64强淘汰赛",
    "messageInitContent_2661": "嗷",
    "messageInitContent_2660": "好气嗷",
    "27_2001": "源初境",
    "27_2002": "赛程",
    "27_2003": "奖励",
    "messageInitContent_2669": "你……",
    "messageInitContent_2668": "才发现合一的腿这么细",
    "messageInitContent_2667": "练功前应喝点白开水，饭前后半小时不宜练功。",
    "messageInitContent_2666": "你推我推",
    "messageInitContent_2665": "台前推手",
    "messageInitNick_72": "超级打脸王",
    "messageInitNick_73": "擦不完的地板",
    "messageInitNick_74": "好牛好牛好牛",
    "messageInitNick_75": "无敌打脸王",
    "messageInitNick_76": "剑是魔杖",
    "messageInitNick_77": "牛过来了",
    "messageInitNick_78": "强壮打脸王",
    "messageInitNick_79": "有烟无伤定理",
    "messageInitNick_80": "我牛",
    "messageInitNick_81": "打脸帝",
    "messageInitNick_82": "有烟无伤",
    "messageInitContent_2675": "古记我来啦",
    "messageInitContent_2674": "高手尽深幽处",
    "messageInitContent_2673": "通过这里就可以抵达2处古纪",
    "messageInitContent_2672": "让我看看是哪个冰雪大聪明还没有逃跑",
    "messageInitContent_2671": "这岛是我的了！",
    "messageInitContent_2670": "每次我都觉得莎士头顶的星星很像生气的样子",
    "messageInitNick_69": "打脸之王",
    "themeCardPackStoryId_35": "CR-007",
    "27_2019": "名人堂",
    "messageInitContent_2679": "看我雪山减法",
    "messageInitContent_2678": "看到肉场了！",
    "messageInitContent_2677": "血渊双雄",
    "messageInitContent_2676": "奖励我来啦",
    "messageInitNick_11448": "猫猫的延伸",
    "messageInitNick_61": "好师傅",
    "messageInitNick_11447": "皮套演员",
    "messageInitNick_62": "现在是我的了",
    "messageInitNick_11446": "唇唇欲动",
    "messageInitNick_63": "疯狂打脸",
    "messageInitNick_11445": "草莓兽",
    "messageInitNick_64": "不过是个老板",
    "messageInitNick_65": "牛一牛",
    "messageInitNick_66": "打脸王",
    "messageInitNick_67": "擦不完的杯子",
    "messageInitNick_11449": "二手猛男",
    "messageInitNick_68": "好牛",
    "messageInitNick_11440": "明年转行",
    "27_2020": "参赛者排行榜",
    "27_2021": "积分",
    "messageInitNick_11444": "沉浸式瑜伽",
    "messageInitNick_11443": "北冥女皇",
    "messageInitNick_11442": "送你离开",
    "messageInitNick_70": "擦不完的凳子",
    "messageInitNick_11441": "补刀之神",
    "messageInitNick_71": "好牛好牛",
    "27_2026": "起源殿胜场 {1}",
    "messageInitContent_2686": "又想禁我技能。",
    "27_2027": "胜率 {1}",
    "messageInitContent_2685": "难道不是风火二象轮",
    "27_2028": "{1}对战详情",
    "messageInitContent_2684": "小猫咪快到碗里来",
    "27_2029": "{1}前结束竞猜",
    "messageInitContent_2683": "小猫咪又调皮了",
    "27_2022": "刷新时间：{1}",
    "messageInitContent_2682": "看刀！",
    "27_2023": "冠军",
    "messageInitContent_2681": "不必谦让，来吧",
    "27_2024": "亚军",
    "messageInitContent_2680": "想看雪",
    "themeCardPackStoryId_40": "CR-008",
    "27_2025": "季军",
    "messageInitNick_58": "爱淡了梦远了",
    "messageInitNick_59": "你怎么进去了",
    "27_2008": "32强淘汰赛",
    "27_2009": "16强淘汰赛",
    "messageInitContent_2689": "怪兽都是耐寒的吗",
    "messageInitContent_2688": "人在江湖身不由己",
    "messageInitContent_2687": "风火有了，林和山呢？",
    "themeCardPackStoryId_25": "CR-005",
    "messageInitNick_11459": "未知的旅途",
    "messageInitNick_50": "脸都打肿了",
    "messageInitNick_11458": "海洋之神",
    "messageInitNick_51": "反派不够用",
    "messageInitNick_11457": "卖花的小哥",
    "messageInitNick_52": "法法我的法法",
    "messageInitNick_11456": "饭盒先锋",
    "messageInitNick_53": "都说别打脸",
    "messageInitNick_54": "手动滑稽",
    "messageInitNick_55": "无敌的法法",
    "messageInitNick_56": "又打脸了",
    "messageInitNick_57": "保健室主角",
    "messageInitNick_11451": "自家洗衣机",
    "messageInitNick_11450": "拉肠女巫",
    "27_2010": "8强淘汰赛",
    "messageInitNick_11455": "棒球高手",
    "messageInitNick_11454": "天才冠军",
    "messageInitNick_11453": "你好厉害",
    "messageInitNick_11452": "工作人员",
    "messageInitNick_60": "别打脸行吗",
    "27_2015": "预测",
    "messageInitContent_2697": "喵喵也是内八",
    "27_2016": "战报",
    "messageInitContent_2696": "噗大炮的尾巴是烟花棒",
    "27_2017": "待定",
    "messageInitContent_2695": "差点以为锤爹拿着的是大炮",
    "27_2018": "已投注",
    "messageInitContent_2694": "才发现锤爹是内八",
    "27_2011": "4强淘汰赛",
    "messageInitContent_2693": "好饿啊啊啊啊",
    "27_2012": "冠军赛",
    "messageInitContent_2692": "冰淇淋",
    "themeCardPackStoryId_30": "CR-006",
    "27_2013": "已结束",
    "messageInitContent_2691": "雪糕",
    "27_2014": "进行中",
    "messageInitContent_2690": "这有是有什么吃的吗",
    "messageInitNick_47": "我赶时间",
    "messageInitNick_48": "爱打盹的猫",
    "messageInitNick_49": "城之内火焰",
    "themeCardPackStoryId_10": "CR-002",
    "messageInitContent_2699": "肉肉我来了",
    "themeCardPackStoryId_15": "CR-003",
    "messageInitContent_2698": "乔哥是外八",
    "messageInitNick_11426": "熊开发宇宙",
    "messageInitNick_11425": "见过世面的猫",
    "messageInitNick_40": "从天而降掌法",
    "messageInitNick_11424": "沦为旧友",
    "messageInitNick_41": "牛顿要哭了",
    "messageInitNick_11423": "爆炸辣椒",
    "messageInitNick_42": "地板也会抽卡",
    "messageInitNick_43": "看我这掌法",
    "messageInitNick_11429": "叉叉开车",
    "messageInitNick_44": "反重力裙子",
    "messageInitNick_11428": "凹凸先森",
    "messageInitNick_45": "别影响我打牌",
    "messageInitNick_11427": "微胖",
    "messageInitNick_46": "脸还肿着",
    "27_2040": "猜错",
    "27_2041": "{1}开始",
    "27_2042": "暂无竞猜记录",
    "27_2043": "源初境奖励",
    "messageInitNick_11422": "国民帅比",
    "messageInitNick_11421": "边界大师",
    "messageInitNick_11420": "火龙果去哪了",
    "themeCardPackStoryId_20": "CR-004",
    "messageInitNick_36": "地板抽卡",
    "messageInitNick_37": "十三香",
    "messageInitNick_38": "对牛顿宝具",
    "messageInitNick_39": "看我地板抽卡",
    "messageInitNick_11437": "帮柚子道歉",
    "visionSagesTips_6": "-",
    "messageInitNick_11436": "柿子君快逃",
    "visionSagesTips_7": "-",
    "messageInitNick_11435": "本菇凉喜欢你",
    "messageInitNick_30": "十一香",
    "visionSagesTips_4": "-",
    "messageInitNick_11434": "整点边界感",
    "messageInitNick_31": "高危职业魔王",
    "visionSagesTips_5": "-",
    "messageInitNick_32": "不是怪兽是神",
    "visionSagesTips_2": "-",
    "messageInitNick_33": "十二香",
    "visionSagesTips_3": "-",
    "messageInitNick_11439": "必杀技",
    "messageInitNick_34": "高危职业勇者",
    "messageInitNick_11438": "一点的蒸蛋",
    "messageInitNick_35": "爱错了季节",
    "visionSagesTips_1": "-",
    "27_2030": "历史最高战力",
    "27_2031": "当前支持率",
    "27_2032": "投注",
    "messageInitNick_11433": "被窝哲学家",
    "messageInitNick_11432": "茶叶蛋大钻戒",
    "messageInitNick_11431": "断水流大师兄",
    "visionSagesTips_8": "-",
    "messageInitNick_11430": "大橙先生",
    "visionSagesTips_9": "-",
    "27_2037": "已结束",
    "27_2038": "竞猜进行中......",
    "27_2039": "猜对",
    "27_2033": "最终支持率",
    "27_2034": "查看录像",
    "27_2035": "VS",
    "27_2036": "未开始",
    "messageInitNick_25": "爱刺痛温柔",
    "messageInitNick_26": "十四香",
    "messageInitNick_27": "不归牛顿管",
    "messageInitNick_28": "爱从不由人",
    "messageInitNick_29": "我最强的仆人",
    "8_2200": "捕捉成功",
    "8_2202": "福利",
    "8_2201": "更多",
    "8_2204": "自动挑战",
    "8_2203": "点击跳转浏览器打开",
    "messageInitNick_11489": "忙着打工",
    "messageInitNick_20": "处刑曲",
    "8_2206": "{1}的联结（{2}/5）",
    "messageInitNick_21": "爱刺痛命脉",
    "8_2205": "自动挑战中",
    "messageInitNick_22": "正义口胡人",
    "8_2208": "申请加入你的联结共鸣",
    "messageInitNick_23": "十五香",
    "8_2207": "总战力",
    "messageInitNick_24": "牛顿笑了",
    "messageInitNick_11484": "暴走的酱油",
    "8_2209": "申请",
    "messageInitNick_11483": "典型好小伙",
    "messageInitNick_11482": "旧话新听",
    "messageInitNick_11481": "格式化淡忘",
    "messageInitNick_11488": "没爱了",
    "messageInitNick_11487": "点赞焦虑症",
    "messageInitNick_11486": "裤衩",
    "messageInitNick_11485": "五仁月饼",
    "messageInitNick_11480": "别再惊动记忆",
    "messageInitNick_14": "记得补刀",
    "messageInitNick_15": "正经口胡",
    "messageInitNick_16": "内卷全明星",
    "messageInitNick_17": "比博燃",
    "messageInitNick_18": "不正经口胡",
    "messageInitNick_19": "打脸全明星",
    "messageInitNick_10": "口胡帝",
    "messageInitNick_11": "养肥了看",
    "messageInitNick_12": "爱吃甜筒的猫",
    "messageInitNick_13": "卷卷大王",
    "messageInitNick_11495": "她会出手",
    "messageInitNick_2296": "凡尔赛龙王",
    "messageInitNick_11494": "调频巫师",
    "messageInitNick_2297": "十全大补鸡",
    "messageInitNick_11493": "拨开发梢",
    "messageInitNick_2294": "锁血成功",
    "messageInitNick_11492": "实名上线",
    "messageInitNick_2295": "橙汁世界",
    "messageInitNick_11499": "忘记密码",
    "messageInitNick_11498": "可怜的仁",
    "messageInitNick_11497": "半糖甜入心",
    "messageInitNick_2298": "像个傻瓜一样",
    "messageInitNick_11496": "曼珠沙华",
    "messageInitNick_2299": "别劝酒",
    "messageInitNick_11491": "幻影统领",
    "messageInitNick_11490": "我粉丝特多",
    "messageInitNick_11469": "吃饱了",
    "messageInitNick_11468": "短腿萝莉",
    "messageInitNick_11467": "临风听暮蝉",
    "messageInitNick_2292": "超级钓鱼神",
    "messageInitNick_2293": "暧昧错当爱情",
    "messageInitNick_2290": "跟彩虹说午安",
    "messageInitNick_2291": "浪里打白条",
    "messageInitNick_11462": "干饭神",
    "messageInitNick_2285": "为减排出分力",
    "messageInitNick_11461": "开宝马送外卖",
    "messageInitNick_2286": "初代病娇少女",
    "messageInitNick_11460": "看爱情在演戏",
    "messageInitNick_2283": "巡山小妖精",
    "messageInitNick_2284": "会说话的鱼",
    "messageInitNick_11466": "红辣椒",
    "messageInitNick_2289": "正式开摆",
    "messageInitNick_11465": "西兰花魔法",
    "messageInitNick_11464": "只道是寻常",
    "messageInitNick_2287": "恰巧心动",
    "messageInitNick_11463": "贝壳里的公主",
    "messageInitNick_2288": "突突突",
    "messageInitNick_11479": "最强飞机",
    "messageInitNick_11478": "蘑菇射手",
    "messageInitNick_2281": "奉旨打野",
    "messageInitNick_2282": "烫烫烫烫",
    "messageInitNick_2280": "宠你宠上天",
    "messageInitNick_11473": "绣夏刀",
    "messageInitNick_2274": "你坐啊",
    "messageInitNick_11472": "淡淡的忧伤",
    "messageInitNick_2275": "劳资有保险",
    "messageInitNick_11471": "自己找原因",
    "messageInitNick_2272": "打小不讲理",
    "messageInitNick_11470": "童话式结局",
    "messageInitNick_2273": "打牌的发型",
    "messageInitNick_11477": "跑楼梯的神",
    "messageInitNick_2278": "樯橹灰飞烟灭",
    "messageInitNick_11476": "人参果魔法师",
    "messageInitNick_2279": "狗刨式恋爱",
    "messageInitNick_11475": "地狱战士",
    "messageInitNick_2276": "骑着猪看夕阳",
    "messageInitNick_11474": "熬夜先驱",
    "messageInitNick_2277": "火乃伊的夏天",
    "messageInitNick_2270": "寡人要睡觉",
    "messageInitNick_2271": "能跑就不要动",
    "messageInitNick_2263": "枫叶红了秋霜",
    "messageInitNick_2264": "搞笑儿童",
    "messageInitNick_2261": "帆布鞋萌妹",
    "messageInitNick_2262": "不暗的黑夜",
    "messageInitNick_2267": "专业熬夜",
    "messageInitNick_2268": "强壮暴富神",
    "messageInitNick_2265": "男儿志在八方",
    "messageInitNick_2266": "吧唧一口旺仔",
    "messageInitNick_2269": "画饼小天才",
    "messageInitContent_2606": "教练我想打篮球",
    "messageInitContent_2605": "我有快马他有快船",
    "messageInitContent_2604": "陆路快还是水路快呢",
    "messageInitContent_2603": "新主城就在前方",
    "messageInitContent_2602": "马是无辜的！",
    "messageInitContent_2601": "强袭是棋还是棋子？",
    "messageInitContent_2600": "对面只有车和炮，确实不知道怎么输",
    "messageInitContent_2609": "从水路到主城",
    "messageInitNick_2260": "棒棒糖狠甜",
    "messageInitContent_2608": "主城我来了~",
    "messageInitContent_2607": "实在没活可以咬打火机",
    "messageInitNick_2252": "只因为太任性",
    "messageInitNick_2253": "你造吗",
    "messageInitNick_2250": "爱过狗喂过猪",
    "messageInitNick_2251": "何患无妻",
    "messageInitNick_2256": "老衲只用飘柔",
    "messageInitNick_2257": "捕月达人",
    "messageInitNick_2254": "苍白的诺言",
    "messageInitNick_2255": "骄傲我有资本",
    "messageInitNick_2258": "今日有想我嘛",
    "messageInitNick_2259": "碎碎冰大魔王",
    "messageInitContent_2617": "为什么没有客栈",
    "messageInitContent_2616": "背山面海春暖花海",
    "messageInitContent_2615": "开辟新的道路",
    "messageInitContent_2614": "骰子型关卡",
    "messageInitContent_2613": "我飞过去了",
    "messageInitContent_2612": "我游过去了",
    "messageInitContent_2611": "这些怪兽必定水性极佳",
    "messageInitContent_2610": "我选择水路！",
    "messageInitContent_2619": "上单在哪里？",
    "messageInitContent_2618": "留下买路钱",
    "messageInitNick_2241": "傲娇小美女",
    "messageInitNick_2242": "临海听风",
    "messageInitNick_2240": "打小我就淘气",
    "messageInitNick_2245": "咕咕门首席",
    "messageInitNick_2246": "临风听暮蝉",
    "messageInitNick_2243": "熬夜鉴定家",
    "messageInitNick_2244": "安慰限量供应",
    "messageInitContent_2620": "不知道镰刀手上的武器叫什么",
    "messageInitNick_2249": "我爱工作",
    "messageInitNick_2247": "右哼哼",
    "messageInitNick_2248": "逃跑的标本",
    "messageInitContent_2628": "木遁，大阿木木，木乃伊之术",
    "messageInitContent_2627": "木人桩，看招！",
    "messageInitContent_2626": "木偶族驻这了",
    "messageInitContent_2625": "星爆气流双镰",
    "messageInitContent_2624": "江南霹雳镰刀",
    "messageInitContent_2623": "镰刀三十六式传人在此",
    "messageInitContent_2622": "惹。",
    "messageInitContent_2621": "怪兽草镰",
    "messageInitContent_2629": "我滴怪兽好像一把火燃烧了整个关卡",
    "messageInitNick_2230": "半截的诗",
    "messageInitNick_4893": "饭桶的末路",
    "messageInitNick_2231": "此时念你",
    "messageInitNick_4892": "菠菜之心",
    "messageInitNick_4891": "您品",
    "messageInitNick_4890": "躺赢神",
    "messageInitNick_2234": "独走孤城",
    "messageInitNick_4897": "面馆老板",
    "messageInitNick_2235": "若时光停留",
    "messageInitNick_4896": "洗脚盆毁灭者",
    "messageInitNick_2232": "心脏骤停",
    "messageInitNick_4895": "烂脾气",
    "messageInitNick_2233": "添加收藏",
    "messageInitNick_4894": "烧麦怪客",
    "messageInitContent_2631": "好耶",
    "messageInitNick_2238": "霸占你的爱",
    "messageInitContent_2630": "撕破脸了",
    "messageInitNick_2239": "认证口胡专家",
    "messageInitNick_2236": "少林捂裆功",
    "messageInitNick_4899": "爱却说不出口",
    "messageInitNick_2237": "走音爱好者",
    "messageInitNick_4898": "放学别走",
    "8_2040": "{1}小时",
    "8_2042": "领取",
    "8_2041": "本周已获取友好点数",
    "8_2044": "挑战",
    "8_2043": "前往",
    "8_2046": "探索中……",
    "8_2045": "已被{1}击破/触发",
    "8_2048": "压制词缀",
    "iapBuyConfigName_511": "粉尘礼包",
    "8_2047": "无法搜索",
    "iapBuyConfigName_510": "造唤光华礼包I",
    "iapBuyConfigName_513": "造唤光华礼包II",
    "8_2049": "放入对应怪兽可以压制词缀",
    "iapBuyConfigName_512": "纬织源礼包",
    "iapBuyConfigName_514": "紫色特化元核髓盒",
    "messageInitNick_4882": "榨菜在喂饭",
    "messageInitNick_2220": "爱在逝岁流年",
    "messageInitNick_4881": "黑暗影",
    "messageInitNick_4880": "超级点赞神",
    "messageInitNick_2223": "温水煮茶",
    "messageInitNick_4886": "五手三灰",
    "messageInitNick_2224": "生命线",
    "messageInitNick_4885": "就说跳这不行",
    "messageInitNick_2221": "你忍多几下",
    "messageInitNick_4884": "最孤独的香蕉",
    "messageInitNick_2222": "朝歌夜弦",
    "messageInitNick_4883": "开始生气",
    "messageInitNick_2227": "奋力奋战中考",
    "randomEventDialogueGroupConfig_2.171": "可恶，你不说我要逼你说才行。",
    "messageInitNick_2228": "展示肚皮",
    "messageInitNick_4889": "无敌划水神",
    "randomEventDialogueGroupConfig_2.172": "它要锤你。",
    "messageInitNick_2225": "阴谋家",
    "messageInitNick_4888": "爱情备胎",
    "messageInitNick_2226": "残留的躯壳",
    "messageInitNick_4887": "不正经的熊",
    "randomEventDialogueGroupConfig_2.170": "告别",
    "messageInitNick_2229": "不想懂得",
    "randomEventDialogueGroupConfig_2.173": "回锤",
    "iapBuyConfigName_508": "极化礼包",
    "iapBuyConfigName_507": "造唤礼包III",
    "8_2031": "距离",
    "plateDes_1": "己方远古族怪兽在场时，每{p1}秒在战场中央创造一口治愈之泉，怪兽每次触碰治疗之泉回复{quality_based}%最大血量，每秒最多回复1次，治愈之泉持续{p3}秒",
    "8_2030": "一键压制",
    "iapBuyConfigName_509": "起源片礼包",
    "plateDes_2": "己方远古族怪兽在场时，每{p1}秒降低所有敌方怪兽血量回复效果{quality_based}%，持续{p2}秒",
    "8_2033": "追踪",
    "8_2032": "剩余",
    "8_2035": "需要时长",
    "8_2034": "探索完成！",
    "8_2037": "商品兑换完毕",
    "iapBuyConfigName_500": "周致谢礼包",
    "8_2036": "剩余",
    "8_2039": "可探索",
    "iapBuyConfigName_502": "造唤礼包I",
    "8_2038": "本周剩余奖励次数：",
    "iapBuyConfigName_501": "建材礼包",
    "iapBuyConfigName_504": "孢子礼包",
    "iapBuyConfigName_503": "战纹礼包",
    "iapBuyConfigName_506": "战纹碎片礼包",
    "iapBuyConfigName_505": "造唤礼包II",
    "messageInitNick_4871": "行走的水果糖",
    "randomEventDialogueGroupConfig_2.168": "它甚至做起了笔记。",
    "messageInitNick_4870": "直接叫过",
    "randomEventDialogueGroupConfig_2.169": "谢谢你，我想回去研究一下，再考虑一下要不要离开。回见。",
    "randomEventDialogueGroupConfig_2.166": "它之后又诸葛连弩似地各种追问。",
    "randomEventDialogueGroupConfig_2.167": "持续瞎扯",
    "messageInitNick_2212": "沦为旧友",
    "messageInitNick_4875": "不爱游泳的鱼",
    "messageInitNick_2213": "安徒生不后悔",
    "messageInitNick_4874": "外星的碎片",
    "messageInitNick_2210": "奇想空调",
    "messageInitNick_4873": "狂飙的骆驼",
    "messageInitNick_2211": "扫黄大队长",
    "messageInitNick_4872": "喵喵小奶瓶",
    "messageInitNick_2216": "准备团灭",
    "messageInitNick_4879": "强壮干饭神",
    "plateDes_7": "己方远古族怪兽在场时，每{p1}秒清除攻击力最高的敌方怪兽所有的增益效果，并使其攻击力降低{quality_based}%，持续{p2}秒",
    "randomEventDialogueGroupConfig_2.160": "可恶，你不说我要逼你说才行。",
    "messageInitNick_2217": "花留香",
    "messageInitNick_4878": "麻烦制造者",
    "plateDes_8": "己方远古族怪兽在场时，每{p1}秒己方近战怪兽进入根性状态（最小击退距离为霸气的{p2}%），持续{quality_based}秒",
    "randomEventDialogueGroupConfig_2.161": "它要锤你。",
    "messageInitNick_2214": "这是卡尔",
    "messageInitNick_4877": "始终隐身",
    "plateDes_9": "战斗开始且己方远古族怪兽在场时，会蚕控敌方战墙，持续{p1}秒，冷却时间{p2}秒，蚕控期间敌方远古怪兽每触碰1次战墙，所有己方近战怪兽获得自身最大血量×{quality_based}%的护盾，持续{p3}秒",
    "messageInitNick_2215": "捡头高手",
    "messageInitNick_4876": "霸气拽爷",
    "plateDes_3": "己方远古族怪兽在场时，敌方怪兽触发暴怒宿命效果时，攻击力降低{quality_based}%，持续{p1}秒",
    "randomEventDialogueGroupConfig_2.164": "它之后又连珠炮似地各种追问。",
    "plateDes_4": "己方远古族怪兽在场时，每{p1}秒降低距离最近的敌方怪兽{quality_based}能量",
    "randomEventDialogueGroupConfig_2.165": "持续保密",
    "messageInitNick_2218": "怀念地球",
    "plateDes_5": "己方远古族怪兽在场时，每{p1}秒远古族怪兽对最近的敌方怪兽造成攻击力×{p2}%的伤害，且造成眩晕效果（伤害，移动速度，攻击速度变为0），持续{quality_based}秒",
    "randomEventDialogueGroupConfig_2.162": "回锤",
    "messageInitNick_2219": "呆萌小熊",
    "plateDes_6": "己方远古族怪兽在场时，每{p1}秒清除体型最大的敌方怪兽所有的增益效果，并使其体型缩小{quality_based}%，持续{p2}秒",
    "randomEventDialogueGroupConfig_2.163": "保密",
    "8_2020": "下次刷新",
    "8_2022": "奖励次数",
    "8_2021": "每周二、四、六 0:00 刷新",
    "8_2024": "英雄到达古记战役节点后，可解锁古记战役关卡",
    "8_2023": "世界灾厄已降临",
    "8_2026": "占领探索节点后，可指派怪兽前往进行探索",
    "8_2025": "剩余可指派怪兽",
    "8_2028": "每日 9:00 和 21:00 刷新",
    "8_2027": "全部领取",
    "8_2029": "英雄到达传送门节点后，可以选择瞬移至同层任意其他已占领的传送门节点",
    "messageInitNick_4860": "有点动心",
    "messageInitNick_2201": "心灵老鸭汤",
    "messageInitNick_4864": "踮脚摘星星",
    "messageInitNick_2202": "旧时不再回来",
    "messageInitNick_4863": "让孩子单飞",
    "messageInitNick_4862": "请马上撤回",
    "messageInitNick_2200": "枯叶蝶不咕",
    "messageInitNick_4861": "无所谓",
    "messageInitNick_2205": "背多分",
    "messageInitNick_4868": "久伴不离",
    "messageInitNick_2206": "脱缰蚂蚁",
    "messageInitNick_4867": "卖咸蛋的超人",
    "messageInitNick_2203": "偷鱼罐头的猫",
    "messageInitNick_4866": "爽滑慢舔",
    "messageInitNick_2204": "呆萌综合症",
    "messageInitNick_4865": "冰晶打手",
    "messageInitNick_2209": "释放自我",
    "messageInitNick_2207": "跟风先驱",
    "messageInitNick_2208": "天线短路宝宝",
    "messageInitNick_4869": "醉人眸",
    "8_2011": "商店",
    "8_2010": "深渊先遣",
    "8_2013": "排行榜",
    "8_2012": "搜索",
    "8_2015": "普通模式",
    "affixName_6": "鹰眼",
    "8_2014": "免费",
    "affixName_7": "急速",
    "8_2017": "好友复制体击破奖励",
    "affixName_4": "毁灭",
    "8_2016": "狩猎模式",
    "affixName_5": "暴怒",
    "8_2019": "联结共鸣",
    "8_2018": "善意点数每周获取上限",
    "affixName_8": "抗击",
    "affixName_9": "极速",
    "affixName_2": "远殇",
    "messageInitNick_4853": "单色黎明",
    "affixName_3": "近殇",
    "messageInitNick_4852": "七点的蒸蛋",
    "messageInitNick_4851": "宇宙在闪烁",
    "affixName_1": "无敌",
    "messageInitNick_4850": "另类囚徒",
    "messageInitNick_4857": "百变小叮当",
    "messageInitNick_4856": "最爱洋葱",
    "messageInitNick_4855": "懒懒猫",
    "messageInitNick_4854": "和队友吃鸡",
    "messageInitNick_4859": "尖叫玉米",
    "messageInitNick_4858": "你会生小猫吗",
    "activityNodeName_676": "尸鬼战略A#尸鬼战略B",
    "activityNodeName_677": "我的英雄#你的敌人",
    "activityNodeName_674": "战袍#锤袍",
    "activityNodeName_675": "回血很行#偏移很强",
    "8_2002": "狩猎",
    "activityNodeName_678": "破灭之袍#狂鬼之袍",
    "8_2001": "战斗",
    "activityNodeName_679": "多核发力#协同发力",
    "8_2003": "探索",
    "8_2006": "传送",
    "8_2005": "古记",
    "8_2008": "异象",
    "8_2007": "集市",
    "8_2009": "世界灾厄",
    "messageInitNick_4842": "尖叫苹果",
    "messageInitNick_4841": "狂奔的蜗牛",
    "messageInitNick_4840": "迷你蛋蛋",
    "messageInitNick_4846": "懂神",
    "messageInitNick_4845": "快乐星球人",
    "messageInitNick_4844": "香菜兽",
    "messageInitNick_4843": "日落杂货店",
    "messageInitNick_4849": "你衣服穿反了",
    "messageInitNick_4848": "不近男色",
    "messageInitNick_4847": "你必须取我",
    "messageInitNick_4831": "永远成功",
    "messageInitNick_4830": "美丽冻人",
    "messageInitNick_4835": "叮咣五六",
    "messageInitNick_4834": "涉江采芙蓉",
    "messageInitNick_4833": "逃婚的司机",
    "messageInitNick_4832": "万事胜意",
    "messageInitNick_4839": "待嫁姑娘",
    "messageInitNick_4838": "贩卖日落",
    "messageInitNick_4837": "情话太甜",
    "messageInitNick_4836": "一秒钟",
    "messageInitNick_4829": "探索者不存在",
    "shopName_9": "造唤商店",
    "shopName_8": "神秘商人",
    "shopName_7": "饲星商店",
    "shopName_6": "部落商店",
    "messageInitNick_4820": "我会煮饭",
    "messageInitNick_4824": "跑调之神",
    "shopName_1": "一发入欧店",
    "messageInitNick_4823": "前方说书反应",
    "messageInitNick_4822": "来自文件夹",
    "messageInitNick_4821": "你不是伞别撑",
    "messageInitNick_4828": "九点的拉肠",
    "shopName_5": "友好商店",
    "messageInitNick_4827": "牙签狂怒者",
    "shopName_4": "狩猎商店",
    "messageInitNick_4826": "最爱雪莲果",
    "shopName_3": "起源殿商店",
    "messageInitNick_4825": "低调的骄傲",
    "shopName_2": "斗技场商店",
    "activityNodeName_687": "机械件#风雷光",
    "activityNodeName_688": "本格玄武#本格青龙",
    "activityNodeName_685": "鳄龙咆哮#比蒙冲击",
    "messageInitNick_4819": "防止小孩误打",
    "activityNodeName_686": "植物系#肉食系",
    "messageInitNick_4818": "冬日向日葵",
    "activityNodeName_689": "未定乐队#特约灾害",
    "6_comment": "排行榜",
    "messageInitNick_4813": "无公害萝卜",
    "activityNodeName_680": "守护龙群#二维群龙",
    "messageInitNick_4812": "饭堂大叔",
    "messageInitNick_4811": "蝶骨",
    "messageInitNick_4810": "矮人科技",
    "activityNodeName_683": "骑兵冲锋#步兵无惧",
    "messageInitNick_4817": "太阳能牙刷",
    "activityNodeName_684": "开炮#瞄准",
    "messageInitNick_4816": "下雨收衣服啦",
    "activityNodeName_681": "鱼之大#污之厚",
    "messageInitNick_4815": "动摇我的世界",
    "activityNodeName_682": "围猎#拉怪",
    "messageInitNick_4814": "无关的人",
    "messageInitNick_4809": "厨师过家家",
    "messageInitNick_4808": "黑心的白天鹅",
    "messageInitNick_4807": "我可是打手",
    "messageInitNick_4802": "尖叫姜",
    "messageInitNick_4801": "最爱椰子",
    "messageInitNick_4800": "肌肉小猛男",
    "themeCardPackStoryId_80": "IF-008",
    "messageInitNick_4806": "叉烧射手",
    "messageInitNick_4805": "一点点霸道",
    "themeCardPackStoryId_85": "MG-001",
    "messageInitNick_4804": "天堂水杯",
    "messageInitNick_4803": "不喜勿撩",
    "themeCardPackStoryId_65": "IF-005",
    "themeCardPackStoryId_70": "IF-006",
    "themeCardPackStoryId_75": "IF-007",
    "themeCardPackStoryId_55": "IF-003",
    "randomEventDialogueGroupConfig_2.119": "你念错啦，再来一次。",
    "randomEventDialogueGroupConfig_2.113": "离开",
    "randomEventDialogueGroupConfig_2.114": "它自言自语地走远了。",
    "randomEventDialogueGroupConfig_2.111": "亲上去",
    "randomEventDialogueGroupConfig_2.112": "它大喊着跑远了。你似乎看到了它纯情的一面。",
    "randomEventDialogueGroupConfig_2.117": "躲起来",
    "randomEventDialogueGroupConfig_2.118": "由它看",
    "randomEventDialogueGroupConfig_2.115": "离开",
    "randomEventDialogueGroupConfig_2.116": "它回过头看着你，仔细地打量着你。从下到上，从下到上。",
    "themeCardPackStoryId_60": "IF-004",
    "randomEventDialogueGroupConfig_2.110": "逃开",
    "8_2095": "碎片奖励",
    "8_2094": "狩猎奖励",
    "themeCardPackStoryId_45": "IF-001",
    "8_2097": "获得奖励",
    "8_2096": "离开",
    "8_2099": "取消探索",
    "8_2098": "领取并离开",
    "randomEventDialogueGroupConfig_2.108": "离开",
    "randomEventDialogueGroupConfig_2.109": "它逐渐向你贴近……",
    "randomEventDialogueGroupConfig_2.102": "呀，什么都没有发生，肯定是你太小声了！我还是自己来好了！",
    "randomEventDialogueGroupConfig_2.103": "告别离开",
    "randomEventDialogueGroupConfig_2.100": "赶紧念呀，赶紧念呀！",
    "randomEventDialogueGroupConfig_2.101": "念一下",
    "randomEventDialogueGroupConfig_2.106": "那你说说怎么才算对。",
    "randomEventDialogueGroupConfig_2.107": "它飞速跑走了。",
    "randomEventDialogueGroupConfig_2.104": "你看见了它逃跑的脚印。",
    "randomEventDialogueGroupConfig_2.105": "离开",
    "themeCardPackStoryId_50": "IF-002",
    "8_2084": "探索完成",
    "8_2083": "探索中……",
    "8_2086": "获得",
    "8_2085": "消耗",
    "8_2088": "神秘商人",
    "8_2087": "全服",
    "8_2089": "上一页",
    "randomEventDialogueGroupConfig_2.135": "同意",
    "randomEventDialogueGroupConfig_2.136": "那你是什么星球的？",
    "randomEventDialogueGroupConfig_2.133": "带我走吧，我在这里一秒都待不下去了。",
    "randomEventDialogueGroupConfig_2.134": "表示只是承认自己与众不同",
    "randomEventDialogueGroupConfig_2.139": "你为什么要否认，你为什么要隐瞒？",
    "randomEventDialogueGroupConfig_2.137": "保密",
    "randomEventDialogueGroupConfig_2.138": "随便扯一个",
    "8_2091": "掠夺",
    "randomEventDialogueGroupConfig_2.131": "它疯狂摇头，离开了几步，又回头看你几眼，又走几步……",
    "8_2090": "下一页",
    "randomEventDialogueGroupConfig_2.132": "无视它离开",
    "8_2093": "物品奖励",
    "8_2092": "交易",
    "randomEventDialogueGroupConfig_2.130": "难到说，我不相信，外星生物不可能带来毁灭的。不可能我不信，你肯定不是，我认错了。",
    "8_2073": "需要时长 {1}",
    "8_2072": "邀请",
    "8_2075": "种族限定",
    "8_2074": "剩余可指派怪兽",
    "8_2077": "一键指派",
    "8_2076": "指派怪兽",
    "8_2079": "所需时长",
    "8_2078": "开始探索",
    "randomEventDialogueGroupConfig_2.124": "我能感觉到你身上散发出的那种与众不同的气息，今天的召唤法是对的，你就是我召唤而来的外星生物！",
    "randomEventDialogueGroupConfig_2.125": "承认",
    "randomEventDialogueGroupConfig_2.122": "迎战",
    "randomEventDialogueGroupConfig_2.123": "躲什么，让我好好看看！",
    "randomEventDialogueGroupConfig_2.128": "推开它",
    "randomEventDialogueGroupConfig_2.129": "起手准备打退它",
    "randomEventDialogueGroupConfig_2.126": "否认",
    "randomEventDialogueGroupConfig_2.127": "你藏得很好，但它却不知道为什么一下子找到了你，并向你伸出了手。",
    "8_2080": "剩余时间",
    "randomEventDialogueGroupConfig_2.120": "继续念错",
    "randomEventDialogueGroupConfig_2.121": "可恶你是故意的吧，挡我找外星生物者，我打！",
    "8_2082": "可探索",
    "8_2081": "可获得奖励",
    "8_2062": "退出",
    "8_2061": "未知敌人",
    "8_2064": "开放邀请权限",
    "8_2063": "踢出",
    "8_2066": "申请信息",
    "8_2065": "联结信息",
    "8_2068": "发送邀请信息到世界频道",
    "8_2067": "请输入内容（最多{1}字）",
    "8_2069": "拒绝",
    "randomEventDialogueGroupConfig_2.157": "它甚至开始做起了笔记。",
    "randomEventDialogueGroupConfig_2.158": "谢谢你，我想回去研究一下，再考虑一下要不要离开。回见。",
    "randomEventDialogueGroupConfig_2.155": "它之后又诸葛连弩似地各种追问。",
    "randomEventDialogueGroupConfig_2.156": "持续瞎扯",
    "randomEventDialogueGroupConfig_2.159": "告别",
    "originRealmRank_1": "冠军",
    "originRealmRank_2": "亚军",
    "originRealmRank_3": "四强",
    "randomEventDialogueGroupConfig_2.150": "随便扯一下",
    "originRealmRank_4": "八强",
    "originRealmRank_5": "十六强",
    "originRealmRank_6": "三十二强",
    "randomEventDialogueGroupConfig_2.153": "它之后又连珠炮似地各种追问。",
    "originRealmRank_7": "六十四强",
    "randomEventDialogueGroupConfig_2.154": "持续保密",
    "8_2071": "邀请好友",
    "randomEventDialogueGroupConfig_2.151": "那我们什么时候出发？",
    "8_2070": "答应",
    "randomEventDialogueGroupConfig_2.152": "保密",
    "8_2051": "邀请好友",
    "8_2050": "压制条件",
    "8_2053": "求帮助",
    "8_2052": "共鸣大厅",
    "8_2055": "无",
    "8_2054": "生活自理",
    "8_2057": "我",
    "8_2056": "需等待 {1} 才能重新建立/加入新的联结共鸣",
    "8_2059": "尚未连接",
    "8_2058": "管理员",
    "randomEventDialogueGroupConfig_2.146": "接受测试",
    "randomEventDialogueGroupConfig_2.147": "它一边踱步离开一边自言自语。",
    "randomEventDialogueGroupConfig_2.144": "趁它迟疑迅速离开",
    "randomEventDialogueGroupConfig_2.145": "你骗人！我要测试一下才行。",
    "randomEventDialogueGroupConfig_2.148": "离开",
    "randomEventDialogueGroupConfig_2.149": "那我们怎么出发？",
    "themeCardPackStoryId_90": "MG-002",
    "randomEventDialogueGroupConfig_2.142": "确实，如果外星生物隐瞒我或者欺骗我，我要怎么辨别呢，看来这就是后面我要研究的新课题了。",
    "randomEventDialogueGroupConfig_2.143": "难到真是我看错了吗……",
    "8_2060": "无法获得奖励",
    "randomEventDialogueGroupConfig_2.140": "表示你也希望自己是外星生物",
    "themeCardPackStoryId_95": "MG-003",
    "randomEventDialogueGroupConfig_2.141": "不管它离开",
    "messageInitContent_2759": "你确定是姐妹",
    "messageInitContent_2758": "分不清两姐妹",
    "messageInitContent_2757": "黑子呢？",
    "messageInitContent_2756": "墙：我好累",
    "messageInitContent_2755": "速度打完",
    "messageInitContent_2754": "黑风双尸？",
    "messageInitContent_2753": "哈人",
    "98_-100060": "你已经不在异象组了",
    "98_-100061": "对方已经不在异象组了",
    "98_-100064": "探索派遣数到达上限",
    "messageInitContent_2763": "有猫耳就是修猫咪",
    "98_-100065": "每位探索者对同一大众评点处只能进行一次留言",
    "messageInitContent_2762": "闪光小猫咪快过来",
    "messageInitContent_2761": "bang！",
    "messageInitContent_2760": "我推的怪兽",
    "98_-100066": "资源累计时间不足1小时",
    "98_-100067": "资源到达仓库上限无法收获",
    "98_-100059": "服务端记录的探索者所在起始点和客户端不一致，探索者需要刷新切换世界地图场景",
    "messageInitContent_2769": "快看他元核！",
    "messageInitContent_2768": "怪兽见了都眼红",
    "messageInitContent_2767": "羡慕了",
    "messageInitContent_2766": "前有镇魂后有御空",
    "messageInitContent_2765": "老板，来一份……那啥",
    "messageInitContent_2764": "emm请问谁是小二",
    "98_-100050": "无法挑战生活自理探索者的复制体",
    "98_-100053": "已经邀请过该好友，请稍有再试",
    "messageInitContent_2774": "包租婆捏",
    "98_-100054": "已到达目标节点",
    "messageInitContent_2773": "404 not found",
    "98_-100051": "一发入欧店未建造",
    "messageInitContent_2772": "404 not found",
    "98_-100052": "无法挑战该节点",
    "messageInitContent_2771": "我想去买东西啊啊啊啊",
    "98_-100057": "传送异常",
    "messageInitContent_2770": "啧啧啧",
    "98_-100058": "指派怪兽不存在",
    "98_-100055": "可开放的地图节点不存在",
    "98_-100056": "复制体正在激战，请稍后再试",
    "messageInitContent_2779": "就酱紫，下一关",
    "messageInitContent_2778": "咦惹",
    "messageInitContent_2777": "是新区域哒",
    "messageInitContent_2776": "看我斧子嘿嘿",
    "messageInitContent_2775": "功夫吗？",
    "98_-100082": "已上阵过的怪兽不能再上阵挑战",
    "98_-100083": "玩家已退出联结共鸣",
    "98_-100080": "权限不足，无法同意联结共鸣申请",
    "98_-100081": "权限不足，无法拒绝联结共鸣申请",
    "messageInitContent_2785": "建议删除这只小妖精",
    "monsterRaceDes_2": "星灵族被认为是来自异星的种族，它们拥有匪夷所思的能力，召唤陨星、操控引力。星能，灵魂，甚至亢奋都有可能是它们的能力源泉。它们极易受到刺激，微小的刺激就能引发起激烈的反应。曾经有少量个体在巨大的刺激下爆发出恐怖的力量，它们引发了数场可怕的杀戮，直至死亡将其停下。",
    "messageInitContent_2784": "我的星",
    "monsterRaceDes_3": "木偶族由伪造的躯壳与伪造的灵魂结合而成，是一个被创造出来的种族。它们无法理解连怪物幼崽都能轻易理解的情感，却能感知到大多数怪兽都难以感知的能量流动。它们甚至能操控那股被认为是怪兽能力本源的流动，创造近乎不可能的神迹。",
    "98_-100084": "该复制体已离开",
    "messageInitContent_2783": "夜空中最亮的星",
    "monsterRaceDes_0": "祖龙族非常罕见，却又难以忽视，它们的出现如同灾难来袭，总是难以预料，带来毁灭，留下可怕的痕迹。难以预料是因为它们的现身理由千奇百怪，例如广阔的领地被踩了一脚，古怪的胃口被调侃，或者只是哪根爪子痒了。造成毁灭也并非它们所愿，只是在它们毫无自觉的破坏力面前，多数怪兽都显得过于不堪一击。",
    "98_-100085": "无法与生活自理探索者的游荡智者对话",
    "messageInitContent_2782": "肉眼可见的c位",
    "monsterRaceDes_1": "尸鬼族从一次濒死时刻的异变而来，这个专为对抗死亡的异变造就了它们无与伦比的再生力和顽强的生命力。它们性别意识淡薄，有着怪异的兴趣爱好，一旦认准目标，就会产生难以言喻的激情和执着。一些以为它们兴趣爱好中不包括怪兽的怪兽往往是它们最喜爱的目标，它们则是对方的噩梦。",
    "messageInitContent_2781": "我 的 发",
    "monsterRaceDes_6": "可能是三千世界的一次奇妙交错，彼岸族告别原本熟悉的世界来到“彼岸”，这段经历几乎是他们之间唯一的共性。若要想了解或接近他们，想象将会是其中一个不错的选项，想象他们在超进化大陆上的所想所为，想象他们与谁的相遇。在想象力的牵引下，虚构的碰撞就会开始，越是强大的想象力越能引发激烈碰撞，激烈得使人忘记了自己正在想象，眼前只剩不断的碰撞，只剩下真实。\\n虽然彼岸族的强大不设上限，但也有一个永远存在的弱点，身为异乡之客的他们无法获得起源基石的所有眷顾和加成。",
    "messageInitContent_2780": "稳了稳了 都稳了",
    "monsterRaceDes_4": "远古族和它们所在的大陆一样古老，在每一个引起大陆巨变的事件中，它们都是主角。它们的能力自成体系，兼备攻防和治愈，没有怪兽会质疑它们的战力。一种与生俱来和某种生命之间的紧密联系，将它们和其他种族彻底区分开来。这些巧合让怪兽们不禁怀疑远古族就是巨变的诱因。",
    "monsterRaceDes_5": "原生族分布广泛，数量众多。诞生时就稳定下来的基因决定了它们的能力上限，让它们终身再难突破。与之相反的是完全稳定之前，基因突变频发的时期，在不确定性的支配下，它们有着极大的个体差异，大陆最强和最弱的怪兽很可能都来自原生族。",
    "messageInitContent_2789": "好怪",
    "messageInitContent_2788": "？？？",
    "messageInitContent_2787": "看我电光毒龙！",
    "messageInitContent_2786": "附议",
    "98_-100071": "大世界探索度需到达{1}%",
    "98_-100072": "需拥有{1}只觉醒怪兽",
    "98_-100070": "世界灾厄还没降临，不能攻打",
    "98_-100075": "世界之门尚未开启，敬请期待",
    "messageInitContent_2796": "我先到前面看看了",
    "98_-100076": "该异象组已解散",
    "messageInitContent_2795": "想要变巨术",
    "98_-100073": "该复制体无法瞬破",
    "messageInitContent_2794": "不想变小啊啊",
    "98_-100074": "对方不是你的好友",
    "messageInitContent_2793": "不想停下来啊啊",
    "98_-100079": "无法申请自己的联结共鸣",
    "messageInitContent_2792": "又开场啦？",
    "messageInitContent_2791": "不锈钢龙王在此",
    "98_-100077": "你已加入联结共鸣",
    "messageInitContent_2790": "龙王厉害还是龙帝厉害呢",
    "98_-100078": "申请已满，无法继续申请",
    "98_-100028": "当前全服剩余不足，无法购买",
    "98_-100029": "世界灾厄已阵亡",
    "98_-100026": "该物品当前库存为空，无法购买",
    "98_-100027": "购买次数已达到上限，无法购买",
    "messageInitContent_2799": "前面好像有点东西",
    "messageInitContent_2798": "又是只能看不能摸的金矿",
    "messageInitContent_2797": "为喵喵打call",
    "messageInitNick_11327": "大地之神",
    "messageInitNick_11326": "沉迷电音",
    "messageInitNick_11325": "最强的香蕉",
    "messageInitNick_11324": "梳子狂怒者",
    "messageInitNick_11329": "社恐牛",
    "messageInitNick_11328": "夸我不然闭嘴",
    "messageInitNick_11323": "恶魔养殖者",
    "messageInitNick_11322": "踏云归",
    "messageInitNick_11321": "黄瓜大闺女",
    "messageInitNick_11320": "文字控",
    "98_-100020": "目标节点尚未开放",
    "98_-100021": "主城搬迁工休息中，请{1}稍后再搬",
    "98_-100024": "竞技场节点必须和主城节点一致",
    "98_-100025": "该物品尚未开始供应，无法购买",
    "98_-100022": "该节点类型与指定的目标节点不符",
    "98_-100023": "cjhwy2",
    "98_-100017": "系统迷路了，请重新选择目标节点",
    "98_-100018": "无法探索尚未占领的节点，请先占领该节点后再进行探索",
    "98_-100015": "相邻节点尚未占领无法前往，请重新选择目标节点",
    "98_-100016": "你找到了真正的孤岛，请重新选择目标节点",
    "98_-100019": "目标主城节点与当前主城节点一致",
    "messageInitNick_11338": "无敌的核膜",
    "messageInitNick_11337": "病为名爱",
    "messageInitNick_11336": "残云战神",
    "messageInitNick_11335": "暧昧滚边去",
    "messageInitNick_11339": "不许摸头",
    "messageInitNick_11330": "深爱你的我",
    "messageInitNick_11334": "无人机上的人",
    "messageInitNick_11333": "纯粹的柠檬",
    "messageInitNick_11332": "特长普度众生",
    "messageInitNick_11331": "橙子去哪了",
    "98_-100010": "无法找到当前狩猎的猎物",
    "98_-100013": "请先跃迁到目标层",
    "98_-100014": "无需继续寻路",
    "98_-100011": "还差{1}就能挤回留言版了！",
    "98_-100012": "地图暂未开放",
    "98_-100048": "饲星坛未建造",
    "98_-100049": "无累计收获",
    "6_19": "下次刷新：{1}",
    "messageInitNick_11305": "焦虑的考拉",
    "6_18": "部落冒险",
    "messageInitNick_11304": "爷依然很嚣张",
    "messageInitNick_11303": "邻家妹子",
    "messageInitNick_11302": "尴尬对白",
    "messageInitNick_11309": "悍马猎手",
    "messageInitNick_11308": "酣睡美人",
    "messageInitNick_11307": "草莓君快逃",
    "messageInitNick_11306": "粉红豹",
    "6_11": "达成条件：遗迹功勋{1}",
    "6_10": "实时",
    "6_13": "结算：{1}",
    "6_12": "刷新：{1}",
    "6_15": "{1}月{2}日{3}点",
    "messageInitNick_11301": "海和鱼私奔",
    "6_14": "重置：{1}",
    "messageInitNick_11300": "像个笑话",
    "6_17": "世界灾厄{1}离开",
    "6_16": "世界灾厄已被击破",
    "98_-100042": "权限不足，无法修改成员的权限",
    "98_-100043": "你与该好友不在同一个联结共鸣，无法进行该操作",
    "98_-100040": "联结共鸣邀请的成员不符合等级要求",
    "98_-100041": "权限不足，无法踢出该成员",
    "98_-100046": "跑错地方的奖励，无法领取",
    "98_-100047": "{1}后可收获",
    "98_-100044": "该复制体已经被盯上了，请换一个目标再试",
    "98_-100045": "该智者已经被盯上了，请换一个目标再试",
    "98_-100039": "联结共鸣邀请已失效，无法接受邀请",
    "98_-100037": "已邀请过该好友，请稍后再试",
    "98_-100038": "需等待{1}才能建立或加入联结共鸣",
    "messageInitNick_11316": "藏你于脑海",
    "messageInitNick_11315": "孤僻怪人",
    "messageInitNick_11314": "小时候就很帅",
    "messageInitNick_11313": "三行情书",
    "messageInitNick_11319": "阿伟生了",
    "messageInitNick_11318": "不如养头猪",
    "messageInitNick_11317": "摸鱼失败",
    "6_22": "单人挑战或同服探索者组队挑战可进入凿星排行榜",
    "messageInitNick_2197": "沧桑的男人",
    "6_21": "{1}胜{2}败",
    "messageInitNick_2198": "画饼之王",
    "6_24": "上轮",
    "messageInitNick_2195": "炮灰在此",
    "6_23": "对战记录",
    "messageInitNick_2196": "深夜电台",
    "messageInitNick_11312": "最强手机",
    "6_25": "本轮",
    "messageInitNick_11311": "真面骑手",
    "messageInitNick_11310": "糊涂妞撞我心",
    "messageInitNick_2199": "头好痒是不是",
    "98_-100031": "{1}后才能对世界灾厄发起下一次攻击",
    "98_-100032": "没有建立联结共鸣",
    "98_-100030": "世界灾厄已离开",
    "98_-100035": "该好友探索者等级不足，无法邀请",
    "98_-100036": "该好友已建立联结共鸣，无法邀请",
    "6_20": "胜场记录",
    "98_-100033": "联结共鸣已满",
    "98_-100034": "权限不足，无法邀请好友加入联结共鸣",
    "messageInitNick_2190": "没那么简单",
    "messageInitNick_11369": "樱桃之心",
    "messageInitNick_11368": "悍妹纸",
    "messageInitNick_2193": "独狼",
    "messageInitNick_2194": "证据制作中",
    "messageInitNick_2191": "正在努力中",
    "messageInitNick_2192": "愤怒的蝴蝶",
    "messageInitNick_11363": "推荐的评论",
    "messageInitNick_2186": "笨蛋奥特曼",
    "messageInitNick_11362": "激情对轰",
    "messageInitNick_2187": "思想在裸奔",
    "messageInitNick_11361": "浪够了就回家",
    "messageInitNick_2184": "越来越有判头",
    "messageInitNick_11360": "泡芙战士",
    "messageInitNick_2185": "不需要眼泪",
    "messageInitNick_11367": "麦肯饼格雷",
    "messageInitNick_11366": "人类迷惑行为",
    "messageInitNick_11365": "请输入心脏",
    "messageInitNick_2188": "恰瓜小能手",
    "messageInitNick_11364": "进口男孩",
    "messageInitNick_2189": "阿姨来巡房",
    "messageInitNick_11379": "呆毛雷达",
    "messageInitNick_2182": "复读爱好者",
    "messageInitNick_2183": "干净的像阵风",
    "messageInitNick_2180": "且行且珍惜",
    "messageInitNick_2181": "贤者模式中",
    "messageInitNick_11374": "唇齿间的故事",
    "messageInitNick_2175": "细数过往",
    "messageInitNick_11373": "小受要强攻",
    "messageInitNick_2176": "睫毛托不住泪",
    "messageInitNick_11372": "破防了",
    "messageInitNick_2173": "九月落叶",
    "messageInitNick_11371": "我会出手",
    "messageInitNick_2174": "封闭自我",
    "messageInitNick_11378": "国产女汉子",
    "messageInitNick_2179": "安静了",
    "messageInitNick_11377": "爱做梦的女孩",
    "messageInitNick_11376": "过几年约会",
    "messageInitNick_2177": "翻车王",
    "messageInitNick_11375": "汪汪队",
    "messageInitNick_2178": "小难瓜",
    "messageInitNick_11370": "隐世窥红尘",
    "messageInitNick_11349": "智能辣椒酱",
    "messageInitNick_11348": "为什么召唤我",
    "messageInitNick_11347": "暴走的香葱",
    "messageInitNick_11346": "大冤种",
    "messageInitNick_2171": "无敌画饼神",
    "messageInitNick_2172": "强壮摸鱼神",
    "messageInitNick_2170": "激光雷神",
    "messageInitNick_11341": "生活和你",
    "messageInitNick_2164": "冷场帝",
    "messageInitNick_11340": "已是陌生人",
    "messageInitNick_2165": "空气人偶",
    "messageInitNick_2162": "在世魅魔",
    "messageInitNick_2163": "把我放在心里",
    "messageInitNick_11345": "辣条的后裔",
    "messageInitNick_2168": "故人载尘而归",
    "messageInitNick_11344": "比油田油",
    "messageInitNick_2169": "气场两米八",
    "messageInitNick_11343": "离离原上谱",
    "messageInitNick_2166": "丈母娘发货啊",
    "messageInitNick_11342": "硬核老侦探",
    "messageInitNick_2167": "孤城落月",
    "messageInitContent_2705": "加油的拼音是那样的吗",
    "messageInitContent_2704": "前方有传送门！",
    "messageInitContent_2703": "魔镜魔镜请问今晚吃什么好",
    "messageInitContent_2702": "好怪哦",
    "messageInitContent_2701": "建议拖出去",
    "messageInitContent_2700": "好想知道镜子的另一边是什么呢",
    "messageInitNick_11359": "老公我在",
    "messageInitNick_11358": "让孤单透透气",
    "messageInitNick_11357": "强壮划水神",
    "messageInitContent_2709": "笑拥了",
    "messageInitNick_2160": "胡桃匣子",
    "messageInitContent_2708": "是不是变长了",
    "messageInitNick_2161": "爆破男神",
    "messageInitContent_2707": "哪哪都有人钓鱼真是的",
    "messageInitContent_2706": "直勾钓鱼够了",
    "messageInitNick_11352": "划水先驱",
    "messageInitNick_2153": "肝帝和欧皇",
    "messageInitNick_11351": "爱你的猫",
    "messageInitNick_2154": "打脸大王",
    "messageInitNick_11350": "背影都可爱",
    "messageInitNick_2151": "给颗糖就不哭",
    "messageInitNick_2152": "认证画饼专家",
    "messageInitNick_11356": "告别小学时代",
    "messageInitNick_2157": "绕过山河错落",
    "messageInitNick_11355": "狂飙的兔子",
    "messageInitNick_2158": "霸气小哥",
    "messageInitNick_11354": "寒鸦",
    "messageInitNick_2155": "盖世仙女",
    "messageInitNick_11353": "天堂汤圆",
    "messageInitNick_2156": "奋斗吧青春",
    "messageInitNick_2159": "还在口胡",
    "messageInitContent_2716": "问本关有多少手",
    "messageInitContent_2715": "飒",
    "messageInitContent_2714": "打关的资源我来出",
    "messageInitContent_2713": "我不吃蛇肉",
    "messageInitContent_2712": "嘻嘻",
    "messageInitContent_2711": "让我看看谁还没过关",
    "messageInitContent_2710": "又起猛了",
    "messageInitContent_2719": "这花仙子的花的位置哈哈哈哈",
    "messageInitNick_2150": "大葫芦娃",
    "messageInitContent_2718": "钢铁龙帝瑟瑟发抖",
    "messageInitContent_2717": "正的反义词是",
    "messageInitNick_2142": "典当半世宿命",
    "messageInitNick_2143": "辣个蓝人",
    "messageInitNick_2140": "睡觉专业户",
    "messageInitNick_2141": "诺贝尔恰饭奖",
    "messageInitNick_2146": "红灯过后",
    "messageInitNick_2147": "头铁门传人",
    "messageInitNick_2144": "龙哥",
    "messageInitNick_2145": "汪了个汪",
    "messageInitNick_2148": "国产小仙女",
    "messageInitNick_2149": "理不直气也壮",
    "messageInitContent_2727": "少侠轻功真好",
    "messageInitContent_2726": "这火我不传了",
    "messageInitContent_2725": "场地魔法",
    "messageInitContent_2724": "记得关火",
    "messageInitContent_2723": "红红火火恍恍惚惚",
    "messageInitContent_2722": "吃我火焰刀",
    "messageInitContent_2721": "借我烤个肉",
    "messageInitContent_2720": "则是那个灶台吗",
    "messageInitContent_2729": "生平求一敌手而不可得",
    "messageInitContent_2728": "我纵横江湖三十余分钟",
    "messageInitNick_2131": "瞧你那傻样",
    "messageInitNick_4794": "天下无双魂",
    "messageInitNick_2132": "到碗里来",
    "messageInitNick_4793": "油缸呢",
    "messageInitNick_4792": "满身是戏",
    "messageInitNick_2130": "不苟颜笑",
    "messageInitNick_4791": "雀斑少女",
    "messageInitNick_2135": "前三口可乐",
    "messageInitNick_4798": "酣睡美人",
    "messageInitNick_2136": "电子游戏杨威",
    "messageInitNick_4797": "半妖妖妖",
    "visionSagesQuestion_1": "在超进化大陆霸气有什么用？",
    "messageInitNick_2133": "那个男人",
    "messageInitNick_4796": "背景有点假",
    "messageInitNick_2134": "病娇美男",
    "messageInitNick_4795": "摆满了杯具啊",
    "messageInitContent_2730": "？",
    "messageInitNick_2139": "剧烈失控",
    "visionSagesQuestion_4": "如何看待超进化大陆上blingbling的闪光？",
    "visionSagesQuestion_5": "在排阵界面长按怪兽和神灵有什么用？",
    "messageInitNick_2137": "第二人格",
    "visionSagesQuestion_2": "对这个世界产生疑问时怎么办？",
    "messageInitNick_2138": "独恋繁花泪",
    "messageInitNick_4799": "就爱吃醋",
    "visionSagesQuestion_3": "无法战胜敌人时怎么办？",
    "visionSagesQuestion_8": "分解元核会浪费升级和进阶消耗的材料吗？",
    "visionSagesQuestion_9": "永生之茧可以使用好友的怪兽助战吗？",
    "visionSagesQuestion_6": "领域副本不同难度掉落有区别吗？",
    "visionSagesQuestion_7": "部落一个赛季通常会持续多久？",
    "messageInitContent_2738": "冒充武打演员",
    "messageInitContent_2737": "专业武打演员",
    "messageInitContent_2736": "活化锁链",
    "messageInitContent_2735": "一直没想明白那些锁链是什么个原理",
    "messageInitContent_2734": "紫金军团",
    "messageInitContent_2733": "宝贝 问你个事",
    "messageInitContent_2732": "这里可以摸鱼吗",
    "messageInitContent_2731": "请",
    "messageInitNick_4790": "凌晨的末班车",
    "messageInitContent_2739": "你先别急",
    "messageInitNick_11385": "半醉看夕阳",
    "messageInitNick_2120": "巴嘎押路",
    "messageInitNick_4783": "冰箱少男",
    "messageInitNick_11384": "枣子在狂笑",
    "messageInitNick_2121": "北街九命猫",
    "messageInitNick_4782": "纯情橡皮糖",
    "messageInitNick_11383": "无无明",
    "messageInitNick_4781": "摸鱼侠",
    "messageInitNick_11382": "残风冷月",
    "messageInitNick_4780": "菠动你心",
    "messageInitNick_11389": "绝版男神",
    "messageInitNick_2124": "垂尾的猫",
    "messageInitNick_4787": "打脸鉴定家",
    "messageInitNick_11388": "顶寄作案",
    "messageInitNick_2125": "钢之强韧",
    "messageInitNick_4786": "忧郁的暗夜",
    "messageInitNick_11387": "和稀泥",
    "messageInitNick_2122": "捡漏机器",
    "messageInitNick_4785": "打脸小天才",
    "messageInitNick_11386": "外星之花",
    "messageInitNick_2123": "小黄鸭漂流记",
    "messageInitNick_4784": "洗衣液破坏者",
    "messageInitContent_2741": "慢慢来",
    "messageInitNick_2128": "捡漏先驱",
    "messageInitContent_2740": "闪光圣光攻击——",
    "messageInitNick_2129": "孤城他寒",
    "messageInitNick_2126": "自私的前锋",
    "messageInitNick_4789": "咳嗽补刀法",
    "messageInitNick_2127": "别说话吻我",
    "messageInitNick_4788": "跟风小天才",
    "96_Compete": "斗技场",
    "messageInitNick_11381": "天马流星犬",
    "messageInitNick_11380": "疾走老大爷",
    "messageInitContent_2749": "我觉得更像是狐狸尾巴",
    "activityNodeName_600": "远点好#近点好",
    "messageInitContent_2748": "两尸夹着一个圆锥头",
    "messageInitContent_2747": "大尾巴狼！",
    "messageInitContent_2746": "所以那个是尾巴吗",
    "activityNodeName_603": "吞噬#突刺",
    "messageInitContent_2745": "身高很平均",
    "activityNodeName_604": "逢凶#化吉",
    "messageInitContent_2744": "3小只哈哈哈",
    "activityNodeName_601": "无需侦测#不用锁定",
    "messageInitContent_2743": "快快回家去",
    "activityNodeName_602": "分工合作#齐心协力",
    "messageInitContent_2742": "两只小尸尸",
    "activityNodeName_607": "混血#纯血",
    "activityNodeName_605": "帝级#王级",
    "activityNodeName_606": "五打一#三打一",
    "messageInitNick_11396": "高情商咖啡",
    "messageInitNick_4772": "拳师的荣耀",
    "messageInitNick_11395": "半杯奶茶",
    "messageInitNick_2110": "半妖",
    "messageInitNick_4771": "你是懂我的",
    "messageInitNick_11394": "欢快的食蚁兽",
    "messageInitNick_4770": "怎么停水了",
    "messageInitNick_11393": "流浪的楔骨",
    "messageInitNick_2113": "春天的雨露",
    "messageInitNick_4776": "沉浸式切菜",
    "messageInitNick_11399": "你这场子不行",
    "messageInitNick_2114": "脸皮太后",
    "messageInitNick_4775": "不是怪兽是神",
    "messageInitNick_11398": "加速迷路者",
    "messageInitNick_2111": "强壮卖惨神",
    "messageInitNick_4774": "冬日傲娇的菊",
    "messageInitNick_11397": "菠萝先生",
    "messageInitNick_2112": "一介书生",
    "messageInitNick_4773": "流浪猫",
    "messageInitContent_2752": "薛哥估计是去搞研究的",
    "messageInitNick_2117": "霸剑横空",
    "messageInitContent_2751": "尸族开会薛哥混进去干嘛",
    "messageInitNick_2118": "非凉薄之人",
    "messageInitNick_4779": "亮得过阳光",
    "messageInitContent_2750": "我也想整个爆炸头",
    "messageInitNick_2115": "大猩猩打星星",
    "messageInitNick_4778": "无公害黄瓜",
    "messageInitNick_2116": "夏日风铃",
    "messageInitNick_4777": "我推的杯子",
    "messageInitNick_11392": "柠檬探秘家",
    "messageInitNick_11391": "超级豆浆",
    "messageInitNick_11390": "凉粉牧师",
    "messageInitNick_2119": "独行侠",
    "resoundEventStoryDes_76": "“可恶的圣光！”桐仁和锤子气急败坏，大声嘶吼着，连隔壁、隔壁隔壁草丛和隔壁隔壁隔壁的草都被气的疯狂抖动了起来。正确来说，是跟它们一样，同样藏在造唤台后面的草丛里看造唤盛景的怪兽。\\n被赶出造唤台之后，它们决定联合起来，找到制造圣光的“凶手”，超进化大陆首个成立即解散的联盟“复仇圣光联盟”正式成立。",
    "tutorialConfigDesc_35": "下一步引导条件未满足",
    "resoundEventStoryDes_75": "一些怪兽拥有极其旺盛的好奇心，例如此刻正在造唤台后头里蹲着的桐仁和锤子，它们的目光紧紧地盯着罗密欧与朱丽叶，这两者正缓缓靠近，传说中的“造唤盛景”开始了。\\n正当桐仁和锤子激动不已时。一道白光挡在了造唤盛景之上，噢不！是可恶的“圣光”。",
    "tutorialConfigDesc_36": "下一步引导条件未满足",
    "resoundEventStoryDes_74": "某天，又一场大水向青铜五小强的新秘密洞穴，可任凭外头的怪兽如何焦急地叫唤，里头的五小强都没有半点回应。",
    "tutorialConfigDesc_37": "下一步引导条件未满足",
    "resoundEventStoryDes_73": "某天，青铜五小强商量着找一处新的洞穴，一则作为秘密洞穴的掩护，二则解决一下秘密洞穴日渐满当的困境。一路上，冒出了不少生面孔的怪兽，它们热情地为青铜五小强推荐洞穴，并承诺能送它们过去。青铜五小强抵不住陌生怪兽的热情，被推着送到了一处地方。那里有一棵树，树上挂着一个巨大的空茧，看起来是什么生物破茧而出以后剩下的。防风挡雨不怕淹，干爽通风，隔音效果佳，还自带食物水源，非常舒适，躺在里面之后根本不想起来。",
    "tutorialConfigDesc_38": "下一步引导条件未满足",
    "tutorialConfigDesc_39": "下一步引导条件未满足",
    "resoundEventStoryDes_79": "“那一天，我终于回想起被圣光支配的恐惧。圣光的那头，是敌兽。我只是一只平凡无奇的咻咻，每日清晨到微光之森练习吹箭。我只想过平静生活，但圣光制造者协会却打破了这份平静。什么？你问我做了什么不可描述的？才没有！我只是把吹箭放进嘴里，它们就拿圣光驱赶我，吹一次，驱赶一次。太过分了。但是，我相信绝望降临之际，希望也会诞生，我现在就要去加入对抗圣光的复仇圣光联盟！”",
    "resoundEventStoryDes_78": "“吾乃和谐的守护者、实践者、创造者。吾乃藏于暗处的圣光制造者，努力遮挡，尽力掩盖，竭力隐藏一切不堪入目的污秽，照亮不可描述的阴影。吾等的终极目标是永恒的圣光之巅，谁都无法察觉的圣光！当反抗之兽忘记了反抗，便是吾等伟业完成之时。一切为了和谐！”——圣光制造者协会宣     ",
    "resoundEventStoryDes_77": "复仇圣光联盟的怪兽们很快就发现，这些遮挡造唤盛景的圣光都是来自于圣光制造者协会的制杖巨人。这些制杖巨人潜伏在各个角落，一旦出现不可描述的景色，它们就会光速抵达现场，发动技能“啊·圣光！”制造很多啊一点圣光，把不可描述的景色完全遮住。",
    "messageInitNick_2590": "懂之王",
    "themeCardPackDes_13015": "漆黑组件的手臂被什么紧紧攥住，随后被硬生生扯开，随后是左脚，右脚。\\n这种场面她见多了，发生在她身上还是头一次。\\n舛误之地的怪兽对肉体改造，机械之躯有着狂热的兴趣。新鲜的肢体尤其受追捧，那么现成的新鲜肢体哪来的呢？抢来的。这类专门抢夺肢体的怪兽有被称为狂猎。\\n能扯下她手臂的绝不会是一般的狂猎。她不想错过这个模仿对象，哪怕模仿会让她陷入危险。\\n除了思考，同时袭来的还有恐惧，她没想到刚理解的词语这就派上用场了。\\n关于恐惧的理解源于拟态对象09，它恐惧时会惊慌失措，落荒而逃。通过模拟该对象，她发现恐惧是危险的预警。但当拟态对象09的同伴遇到危险时，恐惧却反而激发出它的潜能，她仍无法精准模拟这一点。\\n下一秒，她就被锁链束缚在原地，一个个黑色的小型方块在她身体上转动位移形变，她拟态成身型更小的幼兽，从锁链中脱身，另一只手拟态为对方的锁链正向抓住远处光带孢子藤拉开距离。就在她发力的瞬间，一张被数条金色的锁链缠住的疤脸挡住了她的全部视野，周身的锁链再次紧紧将她缠住，锁链的尖头正要扎入那个理应存在心脏的位置。\\n她晕过去了，假装。",
    "messageInitNick_2582": "街头记者",
    "themeCardPackDes_13010": "加载数据......100%\\n    - 日志数据加载完成，未发现异常\\n解析日志......100%\\n    - 日志解析完成，检测到数据存在缺失，计算补完部分缺损\\n自动修复......100%\\n    - 自动修复成功，误差度：II\\n开始读取......100%\\n    - 数据读取完成，输出日志-000\\n    - 日志-000：[地点：未知废墟]\\n                              [时间：不明]\\n                              [事件：遭到一条尸鬼族肢体的猛击，外壳未有损伤]\\n                              [目标终极模拟]\\n                              [执行首次拟态指令，开始模拟：尸鬼族肢体]\\n                              [飞行轨迹无法复现，尝试下一运动模式，尝试失败，提升模拟量，可行性修正……]\\n                                  - 发现拟态对象006\\n                                  - 日志-000终止输出\\n“漆黑组件？”\\n“智者？是出什么状态了吗？”\\n“你想说状况吧，目前还好，我就过来透透气。”\\n“刚刚鼓起了力气，在修复和读取自己的早期数据。”\\n“鼓起勇气了啊，我可鼓不起勇气看我幼年的金雕，我那毛发特别旺盛的时期。不过并不是所有怪兽都会经历幼年期的，我还出了一部专门……”\\n“智者智者，来状况了……”",
    "messageInitNick_2583": "书籍的故事",
    "messageInitNick_2580": "斗龙战士",
    "messageInitNick_2581": "香蕉真好吃",
    "messageInitNick_2586": "茄子射手",
    "messageInitNick_2587": "下辈子再努力",
    "messageInitNick_2584": "暧心少年",
    "messageInitNick_2585": "重新定义懂",
    "messageInitNick_2588": "傲世小女人",
    "messageInitNick_2589": "期待转身",
    "tutorialConfigDesc_30": "下一步引导条件未满足",
    "resoundEventStoryDes_83": "复仇圣光联盟所在的草地，下午\\n咻咻发现战术已经模拟很久了，于是问道：“我们什么时候去消灭圣光制造者？”\\n协会怪兽A：“先打完这局。”\\n协会怪兽B：“对对。”\\n咻咻：“你们这不是在模拟对付圣光制造者的战术吗？”\\n协会怪兽C：“对，没想到挺好玩的。”\\n咻咻：“你们之前有干掉过制杖巨人吗？”\\n协会怪兽A：“我们联盟就干过一件大事。”\\n咻咻：“什么大事？”\\n协会怪兽B：“门口那块木板见着没，字是我们雕的！”\\n协会怪兽C：“雕雕雕。”\\n咻咻此刻彻底放弃了幻想转身离去……",
    "tutorialConfigDesc_31": "下一步引导条件未满足",
    "resoundEventStoryDes_82": "复仇圣光联盟所在草地，上午\\n咻咻走近其中一堆怪兽，激动了大喊。\\n“请让我加入你们！”\\n“什么嘛，居然是新人。”\\n“新人是什么？”咻咻有点疑惑。\\n“多好，新人可是越来越少了。新人就是‘新来的又想消灭制杖巨人’的缩写。”\\n“为夺回我们的尊严，消灭制杖巨人，我将献出我的全部力量！”咻咻看对方没有正面回应，想莫不是又在试探它的意志，于是又补充道。\\n“你看这扮演不是挺好的。”\\n“扮演有是什么，是扮演引诱制杖巨人的陷阱吗？”咻咻又问。\\n“别站着，来来，你坐啊！欢迎！”",
    "tutorialConfigDesc_32": "下一步引导条件未满足",
    "resoundEventStoryDes_81": "心潮澎湃的咻咻爬过树枝制成的栅栏，一块破烂的木头标示着复仇圣光联盟所在，理想和现实的巨大落差，使它的心血来潮退了大半。\\n前方是一片由好几棵细长的树围住的草地，不过这很可能是伪装或者是考验，它安慰自己道。\\n只见协会的成员四、五只为一堆围坐在一起，热烈地讨论着些什么，在它们的身前摆放着一张地图和各种形状怪异的木块，一些木块被雕刻成怪兽的头部，还有一些是有好几个面的小木块。\\n咻咻内心的希望再次燃起，这肯定是在进行对付圣光制造者的模拟战！",
    "themeCardPackDes_25005": "烈日炎炎，几只怪兽在山崖边的灌木果丛中穿梭。\\n“好热的天，好想在巢穴的石板上一直躺着啊！”桐仁在采集食物的小队最前方大声嚷嚷，同时挥动手里的双刀。\\n“你挂掉就可以实现愿望了！”后头的呜呜祖拉挥动手上的喇叭，狠狠在桐仁头上敲了一下，“别叫啦，好好开路！”\\n锤子凑了过来，“如果可以自由选择，你们想做什么？防御？战斗？祭祀？搜索？巢穴维护？”\\n“肯定是探索，就像度假一样！”桐仁抢答。\\n“探索任务是探索什么的呢？”大嘴小鱼问道。\\n“祖拉知道！是金色斗袍！你刚来不知道也正常~”呜呜祖拉抢答。\\n“那个传说中的金色斗袍有什么厉害的，老是要去找。”溜溜接着说。\\n“祖拉知道！祖拉知道！那可是传说中的金色斗袍！传说中只有获得斗袍的怪兽才能成为真正的幻幼部落王！第一任的部落王利爪狼正是穿着金色斗袍才带领我们摆脱了污妖王的统治，在这里立足。”呜呜祖拉继续回答。\\n“那是怎么会丢的？”桐仁边割果子边问。\\n“据说是和狼王在一起消失在战斗中……”祖拉小声说道。\\n“听说是被小红帽……”锤子压低声音，却被祖拉打断。\\n“这个可说不得，都赶紧干活！我们的实力有限，重要的任务还轮不到我们，尤其是你，小鱼，个头最小，采得最少，赶紧好好干！”祖拉说着便吹起喇叭，催促着大家继续采集。",
    "tutorialConfigDesc_33": "下一步引导条件未满足",
    "resoundEventStoryDes_80": "伟大的反圣光制造者组织——复仇圣光联盟，成立于造唤台外的某个偏僻的草丛，创始人为桐仁、锤子等。“根绝圣光”为它们的中心理念。复仇圣光联盟遍布超进化大陆的各处雄山壮岭，每处根据地都装载有对制杖巨人专用高阶陷阱、坚固壕堑。加入该组织需要经过层层考验和选拔，因此里面的成员都是能以一撕百的精英怪兽，说话又好听。\\n以上内容为咻咻对复仇圣光联盟的想象。",
    "tutorialConfigDesc_34": "下一步引导条件未满足",
    "resoundEventStoryDes_65": "就在桐仁准备出去找呜呜祖拉的瞬间，一道闪电砸在了秘密洞穴的门口，借着闪电的瞬光，它们看见远处有一个小小的身影正向它们跑来，一看原来是呜呜祖拉的小伙伴。\\n“大，家，大家听我说，祖拉被被抓走了，在那边那个部落！明日就要被饲星了！”",
    "themeCardPackDes_25010": "“你们快让开！我们现在要探索这一带。”王霸朝采集小队大喊。\\n祖拉立刻带着队员离开，桐仁收起手头的东西边嘟囔：“什么探索，分明是来摸鱼的！”\\n……\\n“真搞不懂，一个破斗篷有什么好找的，都不见了这么走（久）了。好想调到战斗小队，这里太勿扰（无聊）了！”王霸瘫坐在草地上，抓了几把果子塞进嘴里。\\n”就是，要不弄个假的回去交差？“咻咻附和道。\\n“咻咻，你是天才！”王霸猛地一拍大腿，“我之前怎么没有发现呢！这么简单的颁阀（办法）！就这么办！这下可以向金翅璞佳鸟大人交差了~”\\n“那可太好……”咻咻还没说完，王霸忽然朝灌木丛猛打一拳，“谁在那？”\\n话音刚落，一团黑影从山崖上飞出，直直坠入下方的急流。\\n倍速兽往下一瞥：“是采集小队的倒霉蛋吧，听到了不该听的，但不幸中的万幸，它怕是没法活着回去了。”\\n“那事不宜迟，我们赶紧看看怎么搞个斗袍出来！”\\n远处，桐仁拍拍祖拉：“咱们是不是少个了家伙？”\\n祖拉叹了口气：“哎，是那个笨蛋大嘴鱼！它肯定是没看到我的手势。”",
    "tutorialConfigDesc_24": "下一步引导条件未满足",
    "resoundEventStoryDes_64": "桐仁来到秘密洞穴以后，隐约觉得哪里不太对劲。仔细一想，发现呜呜祖拉还没到，平时它都是最早来的。接着锤子、咻咻和叉叉先后出现，却仍不见呜呜祖拉的身影。不安的情绪渐渐将秘密洞穴填满。它们正要一起出去找呜呜祖拉之际……",
    "tutorialConfigDesc_25": "下一步引导条件未满足",
    "resoundEventStoryDes_63": "神性火丁是一种填入了神性孢子的藤笼，这个工具能充分利用神性孢子的辉光，为那些无法在黑暗中视物的怪兽带去光明。\\n不过千万要注意了，虽然大多时候它都能为你照亮前进的道路，帮助你躲避危险，可别忘了，它也同时为危险本身引路。",
    "tutorialConfigDesc_26": "下一步引导条件未满足",
    "resoundEventStoryDes_62": "试胆大会过后一段时间，青铜五小强冒险队除了桐仁，大家都渐渐告别试胆大会的阴霾中。\\n最先提及试胆大会的是锤子。桐仁你为什么选去那里试胆啊，那里太可怕了。\\n躲在角落的桐仁沉默了许久后才回答。其实我们要去的伊斯尔森林里，有一个非常受欢迎的夜市，夜里怪兽们都喜欢到那里吃吃喝喝，热闹非凡。\\n可是那里一点都不热闹啊，明明超级恐怖的。是我们走错森林了吗？\\n问题就在这里！我们没有走错——",
    "tutorialConfigDesc_27": "下一步引导条件未满足",
    "resoundEventStoryDes_69": "暴雨中，这个偏远的部落迎来了一群奇怪的访客，它们自称是能够招来晴天的大师，那是4位浑身挂满叶片的怪兽，一个拿着锤子，一个拿着叉叉，一个拿着双短刀，一个拿着短箭筒。守门的怪兽通报了一下之后就将它们放了进去。",
    "tutorialConfigDesc_28": "下一步引导条件未满足",
    "resoundEventStoryDes_68": "在广阔的微光之森上，部落如同随手抓起然后松开的一把砂石，零散而随机地分布着。一些部落封闭独立，鲜少与周围部落交流，有着独特的风俗习惯。其中一个地势较低的部落遇到了罕见的连日暴雨。它们认为正是星核怪兽的怒火招致此等暴雨灾祸，因此只需要送上星粮，安抚星核怪兽，灾祸自然会离开。如果一份星粮不够，那就两份。",
    "tutorialConfigDesc_29": "下一步引导条件未满足",
    "resoundEventStoryDes_67": "就在呜呜祖拉的小伙伴们远远看着守卫的同一时间，呜呜祖拉正躺在一个小洞穴的草席上，外头雨声让它有了几分倦意，它不禁思考，“为什么要选择我呢？之前曾听闻过策花会被饲星的传闻，可自己又不是什么策花，只是貌美如花的队花而已，想不明白。”",
    "resoundEventStoryDes_66": "大伙鸡血打满似的，冒着暴雨，火速赶到了那个捉走呜呜祖拉的部落外头。远远看去，只见两个壮硕的守卫挡在它们前方。桐仁、锤子、咻咻和叉叉面面相觑，若是靠武力解决，就只能被解决，可是现在想锻炼已经迟了，只能靠智取了！",
    "themeCardPackDes_13005": "死物与亡骸构成了这片失落废墟。\\n零碎的木偶族部件和死透的尸鬼族肢体，前者默默腐朽，后者再次腐败。\\n它们成为这片废墟的表象，任由发现者想象其过去。\\n无生命的零件砌成的活物就此停住，已从死亡出走的尸骸再次死去。\\n仿佛只有由死及生的什么东西才被允许在此地安息。\\n雨偏爱此地，总下个不停。\\n仿佛在哀悼，仿佛在等待。\\n等待无数随时间消逝的瞬间，等待泪水在雨中死去的时刻，等待一次伪造的新生。\\n在大量死亡的环绕下，在数个巧合下，它开始低声嗡鸣。\\n就似幼兽初嚎。",
    "messageInitNick_2571": "第一舞见",
    "messageInitNick_2572": "聊天记录",
    "messageInitNick_2570": "醇香的橙子",
    "messageInitNick_2575": "伴她余生",
    "messageInitNick_2576": "低低低低调",
    "messageInitNick_2573": "不是融合",
    "messageInitNick_2574": "傲狼雪狼",
    "messageInitNick_2579": "泡面侠",
    "messageInitNick_2577": "按时遗忘",
    "messageInitNick_2578": "水瓶座碎了",
    "resoundEventStoryDes_72": "“所以在这里喂给星核怪兽的，是星粮脚底按摩时发出的惨叫？”\\n“难道几位大师不是这样使用星粮的？”\\n“那为什么要选祖拉。”\\n“我看它走路不利索，正好按几下疏通疏通，顺便给星核怪兽送上惨叫。大家都开心嘛。”",
    "tutorialConfigDesc_20": "下一步引导条件未满足",
    "resoundEventStoryDes_71": "几位晴天大师在大老远就听到了呜呜祖拉凄厉的惨叫，它们胆战心惊，不顾一切穿过兽群，来到部落中心的饲星坛处。只见部落长老一脸欣慰地鼓着掌，一边看着发出悲鸣的呜呜祖拉。另一侧，呜呜祖拉正躺在饲星坛中央，被另外一只怪兽不停捏着脚底。长老不住点头说道，“在饲星仪式中，能发出此等惨叫的星粮，简直是星粮中的极品呐。天神大人的怒气一定会被惨叫驱散，送来晴天。”",
    "tutorialConfigDesc_21": "下一步引导条件未满足",
    "resoundEventStoryDes_70": "这几位晴天大师从一位看似部落长老模样的怪兽口中听说，这个部落一直以来都是通过为星核怪兽送上星粮，安抚星核怪兽赶走大雨，现在还不需要它们。饲星马上就要开始了，暂时没空招待它们。于是几位大师请求让它们参观饲星的过程，如果饲星失败，再找它们帮忙。长老同意了几位大师的请求，毕竟照古老的习俗所说的，如果一份星粮不够就多整几份，如果饲星失败了，它们就是多整的那几份。",
    "tutorialConfigDesc_22": "下一步引导条件未满足",
    "themeCardPackDes_25015": "要死，要死！要死了——\\n诶？不对，没死。\\n这种感觉是什么！啊！天，好舒服！\\n我咬，我咬，我吞我吞！\\n好好吃~这也比果子好吃太多了吧~我之前吃的都是些什么！\\n难道这就是桐仁说的天堂吗？\\n嗯？咬咬，嗯，这啥，好像不是吃的……\\n咬着咬着，忽然传来喊声：“别咬了！我不是吃的！”\\n拉扯之中，大嘴小鱼突然眼前一黑，扯着什么东西，跃出了水面。\\n它大力甩动身体，一块黑色羽布从它嘴里甩了出去。睁开眼的瞬间，它看着河边的倒影愣住了——自己怎么好像变大了一圈？\\n不不不是好像！是真的大了一圈，背上好像还多了点什么东西。漂起来更有劲了！腰也不酸了！鳍也不疼了！好神奇！难道说，我天生不适合吃果子，适合吃着水里的好吃的！\\n哎，不过我要怎么回去呢，莫名其妙地掉到了天堂。今天估计是赶不回去了，明天再找路好了！\\n“对了，今天的锻炼也不能忘，《叉叉秘典》里的内容一定要完成！”大嘴小鱼自言自语，开始了每日的训练。它的洞穴是以前叉叉住的，《叉叉秘典》正是它无意间在洞穴里找到的。\\n战斗训练开始！张嘴，咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬！\\n“喂喂，喂喂喂喂喂！你是听不见吗？”\\n等等，刚刚是不是有什么奇怪的声音。\\n大嘴小鱼抛开杂念再次投入到无比入神的嘴部的咬合训练中。",
    "tutorialConfigDesc_23": "下一步引导条件未满足",
    "resoundEventStoryDes_54": "青铜五小强冒险队的集结，让每一位成员都非常兴奋，它们迫不及待要向那个充满未知的洞穴进发。然而，可别小看它们！它们与一般冒险小队不同，它们并没有倒在第一次冒险之中，它们倒在了更早的地方……\\n（燃鹅，燃鹅是一种很少能在超进化大陆的看到生物。这种生物的外貌和罗密欧腰间围着的鸭子类似，并且有着像是燃烧着的火色一样的羽毛。）",
    "tutorialConfigDesc_13": "下一步引导条件未满足",
    "resoundEventStoryDes_53": "“今天找大家过来，不为别的，就是为了这个。”锤子指了指藏宝地图上的标记。\\n“这里附近很可能埋着好多的金子和好吃的！”锤子大概依靠记忆照搬了豹皮匠怂恿它购买地图的话。\\n“我们一起去把它们找出来吧！”锤子握拳举高，叉叉，咻咻，呜呜祖拉和桐仁也学着的举起了各自的手，就在这天，青铜五小强冒险队完成集结。",
    "themeCardPackDes_25020": "次日清晨，大嘴小鱼就跃入河中，就开始往上游冲刺，它觉得那就是回巢的方向！当然嘴绝不能停！\\n于是就开始了：\\n咬咬咬咬咬咬咬咬咬咬咬咬咬咬咬~\\n吞吞吞吞吞吞吞吞吞吞吞吞吞吞吞~\\n痛痛痛痛痛痛——！！！\\n下一秒，3只怪兽围在它身边吵了起来。\\n“豹耳真笨，这都能抓错。”\\n“混蛋虎man，你才蠢，你抓错的比我多！”\\n“好啦好啦，先道歉。”\\n“又不是我的错。”\\n“你好意思说，明明是你刚刚撞了我，所以钩才甩过去的！”\\n“你说怎样就怎样，反正不关我事！”\\n虎皮匠和豹皮匠说着就丢掉鱼竿，打了起来……\\n龙皮匠忍无可忍，一声怒吼——“够了！”\\n只见它猛然拔高身形，变得异常巨大，一拳一个，把虎皮匠和豹皮匠分别砸飞，正好落在大嘴小鱼的两侧。\\n大嘴小鱼吓得直接侧躺在地，一动不动，整条僵住。\\n龙皮匠的大脸贴了上来，声音低沉但温和：“抱歉啊，我们最近接了个新活，要收集些特殊材料，你还好吗？”\\n大嘴小鱼瞥见一旁满满一筐闪闪发光的金色鱼，猛地一跃而起，“看起来挺好吃……额没事没事。我只是迷……在修炼！你刚刚变大好好……厉害！”慌张之下大嘴小鱼开始胡言乱语。\\n“哈哈，就是体型变大”龙皮匠笑着拍了拍它的背，“你不也会？刚刚不是一边吃一边变大了嘛？”\\n“是……是嘛！”大嘴小鱼一时间不知如何回答。\\n“你就在这里休息一下吧，别紧张，我们不咬鱼。”龙皮匠的大脸更近了。\\n“这，不太……”就在大嘴小鱼正要回答之际，突然后背猛地一疼，一股奇怪的声音从它背后传来，让它一句话都说不出口了——",
    "tutorialConfigDesc_14": "下一步引导条件未满足",
    "resoundEventStoryDes_52": "锤子用重金，在豹皮匠手中买下了一张藏宝地图。第二天清晨，它跑着跳着把地图带到了它的伙伴们面前。此时，叉叉，咻咻，呜呜祖拉和桐仁早早在它们的秘密洞穴里等着它了。\\n说是秘密洞穴，其实就是一个随处可见的普通小山洞，它们选择这里的原因很简单，并不是这里的位置有多隐秘，主要是这里距离大家都挺近的。",
    "tutorialConfigDesc_15": "下一步引导条件未满足",
    "resoundEventStoryDes_51": "循着亮光走近，我们看到了两只拿着锄头的小怪兽，它们正规律地开采着金矿山里的金块，看似挺友善的。再次在这里沉痛思念在《走近超进化——龙穴之谜》里光荣负伤的采访同志。由于有了上期的经验，我们将与它们保持着一段距离进行采访。\\n我们了解到它们一位叫小蓝一位叫小翔，兴趣是挖矿。它们利用跳跳藤，将挖出来的金块送到地面，送给有需要的怪兽。这就是金矿山之谜了……当然这只是其中一个金矿山，其他金矿山也是这样吗，敬请期待下一期……",
    "tutorialConfigDesc_16": "下一步引导条件未满足",
    "resoundEventStoryDes_58": "这个提高生存率的话题由桐仁压轴，高速咏唱，“如果你身边有一个能够复活你的女神而你又无比幸运的话，那你可以随便死了；如果你身边的女神只是合成用的蛋白质的话那么你就得异常慎重了；你看有些就算已经是世界最强了还巴不得和空气斗智斗勇的；要是一开始就有那种成长性很高的特殊能力之类的就可以稳着发育了，例如能吞技能什么的；如果不幸落单，多讲讲单口相声也可以很快乐；没事好好学习，所谓学好数理化走遍天下都不怕；你还要对你即将面临的敌人有清晰的了解，不然分分种死在出门没买药或者40米长剑卡在洞穴里这种事上；然后一定要带眼识队友，不然队友很可能第一晚就给你卖了……；实在不行，就找个欧皇队友，欧到策花都头疼那种，能把欧气传给你的更是上品；如果是那种开场就能提供自定义选项的，那就要擦亮眼睛好好选，一些次级技能很可能是隐藏的神技哦！”",
    "tutorialConfigDesc_17": "下一步引导条件未满足",
    "resoundEventStoryDes_57": "得到藏宝地图后的某一天，因为根本没有出发，反而逃过一劫的青铜五小强冒险队举办了一场别开生面的庆功宴。因为最近，它们听到了一个消息，不少冒险小队都在龙之墓穴栽倒，存活率都非常惨淡。这次聚会，正是为了庆祝它们百分百的存活率，庆祝它们成功的存活了下来。它们此时正煞有其事地讨论着冒险者要如何提高生存率。",
    "tutorialConfigDesc_18": "下一步引导条件未满足",
    "resoundEventStoryDes_56": "龙之墓穴，对于青铜五小强冒险队而言，只不过是一处未曾到达的起点，在它们以外，还有更多借助豹皮匠的地图来到这里的冒险小队。这里头，有一半在进入洞穴之前就被其他冒险小队干掉了，剩下的一半的一半则落入了隐藏在洞穴深处那些饥饿的怪兽的肚子之中。\\n无数冒险者的尸骸堆上似乎飘出了一行字，生命冇Take two。",
    "tutorialConfigDesc_19": "下一步引导条件未满足",
    "resoundEventStoryDes_55": "锤子双手托腮，一脸哀怨地看着它的同伴，桐仁和咻咻踢石头踢得不亦乐乎，呜呜祖拉正沉醉在吹奏的乐趣中，叉叉则不知疲倦地盯着它的进化孢子看。\\n“你们还没好啊？说好去龙之墓穴，找大宝贝的呢？”\\n“我在思考要带哪一颗进化孢子过去。”\\n“都带过去不就得了？”\\n“我再吹一会就来。”\\n“去到那里再吹不行吗？”\\n“我们还没分出胜负呢。”\\n“你们连规则都没有哪来的胜负。”\\n阻挡青铜五小强冒险队的既不是什么可怕的怪物，也不是什么险峻的地势，而是拖延症。",
    "resoundEventStoryDes_59": "月星似乎惧怕着什么早早躲进黑夜，夜幕下，五双眼睛依靠各自手中微弱的光源到处乱瞟，桐仁、叉叉、咻咻、呜呜祖拉和锤子站在伊斯尔森林的入口，混在黑暗之中的阴风和鸣叫将它们包围。\\n时间往回推半天，我大胆，我更大胆，我更更大胆，它们常常以这种多见于幼小的怪兽之间的方式争吵，而它们最终的争论结果竟意外地实际，它们要一起来一躺试胆大会。",
    "messageInitNick_2560": "奥特快",
    "messageInitNick_2561": "梳妆台在笑",
    "messageInitNick_2564": "强壮恰饭神",
    "messageInitNick_2565": "跑调高手",
    "messageInitNick_2562": "汽车的尽头",
    "messageInitNick_2563": "别露出鸡脚",
    "messageInitNick_2568": "今年没有假期",
    "messageInitNick_2569": "最爱拍黄瓜",
    "messageInitNick_2566": "霸气剑神",
    "messageInitNick_2567": "傲娇小萝莉",
    "resoundEventStoryDes_61": "借着神性火丁的光，五只小怪兽睁大眼努力看清它们撞到的究竟是什么。唔，看起来是个石雕。它把脸捂住了。好像在哭一样，还……还有翅膀……你们看，这里还有几个数字。1,1234567,123。你还数手指，是173啦，笨蛋。啊啊啊啊啊啊啊！尖叫声中，五只小怪直直往下坠。\\n第二天，它们从一个简陋的阱坑中醒来，昨夜所见的雕像早已不知所踪。",
    "themeCardPackDes_25025": "阵痛过后——\\n“醒醒！醒醒！”一个声音从大嘴小鱼背后响起。\\n它还半躺在软皮上，虎皮匠和豹皮匠还在不远处吵着谁的鱼钩更蠢，背上却多了一个奇怪的声音。\\n“谁？是谁在说话？”它想扭头，结果却是一直追着尾巴转圈。\\n“咳咳，我是戏战顽……额鱼鳍，一件超强超炫还会说话的武器！”声音带着几分得意，“你先前在水里咬到的就是我，还记得吗？”\\n“西站鱼鳍？超强武器！”大嘴小鱼睁大了鱼眼。\\n“是戏战鱼鳍！不是西站。而你是被我选中的小怪~”\\n“被选中？！”大嘴小鱼一头雾水，“我会变强吗？”\\n“差不多。如果你想让战斗变得好玩，有我在准没错的！”\\n“真的吗？！”它的鱼眼瞬间亮了，“我就知道我不是吃果子那块料！”\\n“那你就继续在这里炼炼，学学龙皮匠怎么体型变大，更好发挥出我的战力！”\\n“喔对对！”\\n……\\n接下来的日子里，它就在河边一边猛吃猛吞猛咬，一边跟着龙皮匠练习变大技巧。\\n谁也说不清它是天赋异禀，还是戏战鱼鳍的点拨，反正不过三十几天，它就掌握了完整的体型变大之技！\\n更别提，天天吃着河里的食物，它的体型简直一日一长。即便不发动技能，它的体型也比以前大了很多，完全可以称得上是大嘴大鱼了。\\n某天早晨，三位皮匠将大嘴小鱼送到河岸边。\\n“大鱼，好好保重。路都记好了吗？”龙皮匠拍拍它的背。\\n“嗯，龙哥、虎哥、豹哥，再见了。”\\n“最后再听龙哥一句，当心那些可以把你体型变小的怪兽。”\\n“我明白了！”大嘴大鱼用力挥鳍，告别皮匠三兄弟。随后旋即跃入水，向着幻幼部落营地的方向急速进发。",
    "resoundEventStoryDes_60": "回到伊斯尔森林的现在。\\n走哇，你先走，走，走就走，谁怕谁。\\n桐仁、叉叉、咻咻、呜呜祖拉和锤子都努力用颤抖的声音维持着它们所剩无几的理智。那根长长的树藤绑在它们每一位的腰上，是桐仁自作聪明说这样就谁都没办法逃掉的成果。\\n哇，好疼，我好像撞到什么了。",
    "tutorialConfigDesc_10": "下一步引导条件未满足",
    "tutorialConfigDesc_11": "下一步引导条件未满足",
    "tutorialConfigDesc_12": "下一步引导条件未满足",
    "resoundEventStoryDes_43": "对决开始前半个小时，站在肉山山脚的凶噬魔是矛盾的，作为一个真·吃货，虽然能得到超进化大陆最高水准的舌尖享受很是满足。但另一方面，又要当裁判决出高下。剑盾的厨艺水平相当，要作出公正的判决，就比区分两只叉叉的叉还难。此时它不会想到真正的恐怖还在后头等着它。",
    "resoundEventStoryDes_42": "距离上次肉山之巅相杀相爱的决斗已经过去许久，咸鱼剑和背锅盾的对决，以白昼的全程痴笑，双方平手告终。它们决定再战一次，决出真正胜负。这次它们请到了上次没空的凶噬魔来担任裁判。激烈的厨艺决斗即将开始——“朵罗！！”*2。坐在裁判石上的凶噬魔此刻默默擦了擦汗。",
    "resoundEventStoryDes_41": "谁都没有听取山的这头的怪兽的愿望，流星依旧每晚不歇地降临，夺走了它们珍贵的夜晚和美梦。它们只能选择离开这片土生土长的土地，只是它们的床，那些睡了好久好久的树，它们的床儿，那些树儿，却带不走了。当晚，流星雨的余光映照这它们渐渐远去的背影。而山的那头，星刃、虚刃、血刃和咒刃们的大乱斗仍在继续。",
    "resoundEventStoryDes_40": "“还记得刚刚的那场流星雨吗？向流星许愿，愿望就会实现。”\\n对于山的这头的怪兽而言，那就是一个巨大的谎言，它们最讨厌的就是流星了，更别说流星雨。它们还记得第一场流星雨落下的那天，接连不断的光球拖着长长的光尾巴，以不同角度乱坠，将夜空割成无数的碎块。山这头，太阳刚下山就上树睡觉的怪兽全都被闪醒了。这些怪兽开始对着流星雨虔诚许愿，睡觉才来下雨，不要再下了。",
    "resoundEventStoryDes_47": "它并不孤单，每天都会有很多枯枝陪它一同被踩断。",
    "resoundEventStoryDes_46": "一道五颜六色的金光从锅盖下激射而出——凶噬魔的舌头卷入菜肴，第一口，舌尖因为美味的刺激，直直地挺着颤抖着，它提前准备好的，厚达十一层的兽皮大衣接连炸裂。凶噬魔看到疾风兔给咸鱼剑和背锅盾送来的食材时，就已经预感到了这个结果，底下肯定藏满了药。它临时定制的十一层兽皮大衣已经尽力了，然而，它还是低估了这第二次（美味）冲击。咸鱼剑和背锅盾第二次对决，以真·吃货昏迷倒地失去判决能力告终。",
    "resoundEventStoryDes_45": "咸鱼剑和背锅盾同时开始了烹饪。咸鱼剑依旧闪烁着惊恐神色，背锅也不甘示弱展现出隐忍的光泽。在各种甩锅、狂剁、翻炒、注入灵魂过后，双方的菜肴先后送到了凶噬魔面前。凶噬魔颤抖着伸出手，打开了锅盖……",
    "themeCardPackDes_25030": "“喂喂，你们看。那不是大嘴小鱼吗？”\\n防守小队的咻咻顺着王霸的视线看着远处议论起来。\\n只见大嘴大鱼正在幻幼部落边的小道上轻快地漂着。\\n“它怎么变那么大了？！”\\n“重点不是这个！”王霸脸色一变，“它上次听到我们要做件假的金色斗袍……”\\n“而且！我们找皮匠兄弟做的金色斗袍已经送给了危险的草丛酋长了！”\\n“啊啊啊完了完了！要是它说出去了……”\\n“那只能用拳头让它闭上那个大嘴了。”\\n“也许我们先去探探它的口风？”\\n正说着，咻咻突然指着林间：“等等，有情况。”\\n只见两只抱着武器的怪兽从草丛边现身，眼神凶狠——是污妖王的手下KB侠！\\n“哼，真是世界助我们啊！”王霸挥出一拳，“它们是我们部落的死敌，最近干掉了不少我们的家伙。我们就报告说，这一带遭到伏击，可怜的大嘴小鱼……被吃掉了！”\\n“收到！”\\n与此同时，正哼着小曲的大嘴小鱼被两只KB侠拦住了去路。\\n“幻幼部落的家伙，站住！”其中一只KB侠大吼。\\n“我都没脚，怎么站住？”\\n“你？”这个回答明显激怒了对方。\\n“西站鱼鳍你怎么自作主张提我回答啊，这下死了，那可是我们部落的死对头。”大嘴大鱼小声嘟囔道。\\n“非常好，终于可以战斗啦！”自称戏战鱼鳍的戏战顽袍兴奋地说道。\\n“本来想先问问你金色斗袍的情报的，这下好了，一切打完再说！”另一个KB侠客双手离开键盘，发起进攻。",
    "resoundEventStoryDes_44": "凶噬魔踟蹰不前之际，咸鱼剑和背锅盾护着疾风兔出现了。疾风兔拉着两大车货物，装着等会对决要用到的食材。剑盾一看到凶噬魔便上前热情打了招呼，分别一左一右夹着它上山。凶噬魔已经没有退路了，它敏感的舌头微微颤抖着，还好它也提前做了些小准备……",
    "resoundEventStoryDes_49": "超进化大陆上有不少金矿，我们来到一个相对安全的金矿进行探索，为什么说相对安全呢，别看现在金矿的四周岁月静好，实际上危机四伏，有很多双眼睛正在盯着我们。\\n不过大部分金矿有白天停战协议，这个应该也不例外，所以我们一边大声表明身份，一边小心翼翼地靠近着这个金矿……但愿不要有谁以为我们是装的……",
    "resoundEventStoryDes_48": "在超进化大陆上有着数量众多的大大小小的金矿山，它们源源不断地产出闪闪发光的金块。一些怪兽甚至以为，金矿山就是一头会自己吐金块的怪兽。不过这些金块真的是金矿山自己吐出来的吗？欢迎来到本期《走近超进化——金矿山之谜》！",
    "messageInitNick_2550": "奔跑吧少年",
    "messageInitNick_2553": "幻妖灵",
    "messageInitNick_2554": "坐在月亮上",
    "messageInitNick_2551": "跟彩虹说晚安",
    "messageInitNick_2552": "怀念不如相见",
    "messageInitNick_2557": "爱已剧终",
    "messageInitNick_2558": "老头看手机",
    "messageInitNick_2555": "暧昧滚边去",
    "messageInitNick_2556": "熬夜大王",
    "resoundEventStoryDes_50": "我们现在在距离金矿山几十只叉叉身位远的地方，听到了金矿山里头传来了哐啷、哐当、哐啷、哐当、哐啷、哐当的声音，声音的间隔就像木偶族身上的发条的转动那样有规律。门口的金块正一点点地积累起来。我们继续往里走，声音越来越响，矿道被一些木质支撑物仔细地固定着。约莫走了半天，我们看到了不远处的亮光，看来真相就在不远了……欲知真相，请看下集的《走近超进化——金矿山之谜（下）》",
    "themeCardPackDes_25035": "幻幼部落营地深处的草地正是部落的议事大厅，四周被岩壁所环绕。中央石台上，大酋长危险的草丛身披金色斗袍，四周围满了部落怪兽——正如部落之名，它们都是幻化或幼体怪兽。\\n“报！就在刚才，我的小队巡逻时，发现了两只KB侠，还差点被伏击！”王霸声色俱厉，“我们必须抵御污妖王部落的入侵！”\\n兽群一阵骚动。\\n副酋长制杖巨人上前一步，手杖重重敲地，沉声说道：“没错。我们不少部落成员也因此失踪……而这一切，都始于我们重新获得金色斗袍。\\n它环视四周，再次高举手杖，猛敲地面。\\n“我知道，部落中有些怪兽并不信任这件斗袍的来历，甚至宁愿将我们的幼体送给污妖部落驱使，向污妖王低头、妥协……但我们绝不妥协！”\\n此话一出，兽群躁动了起来，议论纷纷。\\n副酋长再次用手杖猛敲地面：“我知道，部落理由有些怪兽对这件金色斗袍并不信任，宁愿送出我们的幼体怪兽供污妖部落驱使，向污妖王妥协，而非抗争……”\\n忽然，一道怒吼划破空气。\\n“我们有质疑，是因为那东西来路不明！”骑兵带着一群追随者闯入，“你们找来的……很可能是假的！”\\n“冲锋！”骑兵高喊，一群怪兽随之猛扑向石台。\\n“住口！”危险的草丛怒吼，身披金斗袍猛地旋转起来，“我们要的是抗争，不是内斗！”\\n两方即将交锋之际——\\n“等等！”身形巨大的大嘴大鱼猛地冲出，拦在两方中央：“你们说的，是它们吗？”\\n它张大嘴巴，将被击倒的污妖王和2头KB侠甩在地上。\\n“刚刚在回来的路上遇到它们，它们说要消灭咱们部落，我一气之下就把它们……我是不是闯了什么大祸……”\\n草丛与骑兵面面相觑，目光扫到它背后。\\n“那是……真正的金色斗袍？”\\n“原来我们手上的……是假的！”\\n瞬间，骑兵和危险草丛几乎同时暴起，目标出奇一致——抢夺真正的金色斗袍！",
    "messageInitNick_2559": "孤灯一盏",
    "messageInitNick_2542": "理工小霸王",
    "messageInitNick_2543": "你脑子掉了",
    "messageInitNick_2540": "爱的代驾",
    "messageInitNick_2541": "为你带来笑容",
    "messageInitNick_2546": "笨瓜",
    "messageInitNick_2547": "亲切的敌人",
    "messageInitNick_2544": "诺贝尔搬砖奖",
    "messageInitNick_2545": "跟未来有个约",
    "messageInitNick_2548": "初夏浅浅笑",
    "messageInitNick_2549": "风騷的毛毛虫",
    "messageInitNick_2531": "半度微涼",
    "messageInitNick_2532": "丢了翅膀的鱼",
    "themeCardPackDes_13040": "漆黑组件装扮成狂潮形态的样子来到对方的据点。\\n可对方的守卫竟笑着说你也来得太晚了，并将她撵了出去。\\n原来漆黑组件-狂潮形态早就交代过守卫，要看清楚，只有御空-崩坏形态跟着的才是她。\\n漆黑组件灰溜溜地回到边缘的据点，据点内的同伴却突然对她发起了攻击。\\n“骗子！”\\n“你竟敢骗我们？”\\n“原来拯救什么的都是假的吗？”\\n她拼命解释，却发现没有用，她能做的，只有拼尽全力去逃。\\n她上当了，狂潮形态不在据点的情报，只是为了把她引出来，狂潮形态则先一步模仿她来到她的据点，她就这么傻傻的信了。\\n接下来只能孤身与这个世界对抗了吗？\\n受了重伤的漆黑组件倒在了舛误之门旁。",
    "messageInitNick_2530": "当花碎梦",
    "messageInitNick_2535": "混世魔王",
    "messageInitNick_2536": "问题美少女",
    "messageInitNick_2533": "编故事的人",
    "messageInitNick_2534": "法皇之绿",
    "messageInitNick_2539": "摘下星星给你",
    "messageInitNick_2537": "正义口胡人",
    "messageInitNick_2538": "悲欢想不通",
    "resoundEventStoryDes_98": "圣堂武士的训练列队中，有一位不慎掉队了，它碰巧看到斗技场招募猪皮卷。那张猪皮卷如同那颗落入死水的石子，为这位圣堂武士展现出新的道路，一条它未曾想到过的前道路。就在那一刻起，原本不瞻望也不后顾的它变得踟蹰。",
    "resoundEventStoryDes_97": "出生，完成考验，加入军团，战斗，获得报酬，产出下一代，这就是圣堂武士的一生。宛如一滩死水，可再平静的死水，偶尔也会因为一颗小石的落下而溅起水花。水花与死水分离，在半空张望，映着一片全然不同的风景。",
    "resoundEventStoryDes_96": "十一位圣堂武士走向军团长，同时向兽皮袋伸出手，各自从皮袋中抓出一颗石子，握在手心。接着它们默契地同时伸出手，一起摊开。大家的目光集中到抽到深色石子的圣堂武士身上。它成为了另外十个圣堂武士的攻击目标。军团长默默地看着圣堂武士一面倒的对战，期待着“恐惧”激发圣堂武士的士气。",
    "resoundEventStoryDes_95": "圣堂武士以十一位为一组战斗单位，它们站成一排颤抖着，它们颤抖的频率和幅度仿佛训练过一般整齐划一。圣堂武士们紧张地注视着它们的军团长，可怕的惩罚马上就会到来。军团长先是把10颗浅色石子和1颗深色石子丢入兽皮袋，圣堂武士纷纷发出惊恐的声音。\\n“军团长！您是打算，不会是……”\\n“是的，上次失败太不像样了。大家都来抽吧。”",
    "resoundEventStoryDes_99": "“斗技场招募有志之兽，磨炼自我赚取金币，成为万兽之王！”圣堂武士捡到的招募猪皮卷的如此写道。圣堂武士看完倒吸了一口气，它看到了还有另一条路，它未来，除了能够加入军团以外，还可以到斗技场战斗。它有生以来的第一次感到纠结，它开始询问周围的圣堂武士，纠结就此传开。",
    "themeCardPackDes_13035": "终极模拟是什么？是对目标的彻底理解，而为了确保理解，绝不能干扰和影响目标，这样才能完成最真实的拟态和迭代。\\n可漆黑组件-狂潮形态理解的终极模拟是什么？通过对模仿对象和模仿对象所在环境的彻底控制，等待一个如同死去般活着的模拟？\\n舛误之地如今变得越来越撕裂，掌握着强大力量的小数怪兽，和如同行尸走肉的大多数怪兽。这些大多数怪兽被迫挤在小的可怜的空间里，一不小心就会坠入深渊，她怎么可以这样是筛选模拟对象？\\n思来想去，终究她还是无法理解，无法理解漆黑组件-狂潮形态的想法，可倘若她真理解了，是不是也可以完成对狂潮形态的拟态了。\\n越想越是可怕。\\n但这个计划值得一试，模仿对方的样子，然后从内部瓦解对方。\\n经过一段时间的筹备，第五次边缘行动开始了。",
    "themeCardPackDes_13030": "漆黑组件无法形容自己第一次遇到狂潮形态时的触动。\\n那天，她和同伴费劲九牛二虎之力，来到舛误之地最大的矿主所在。准备胁迫对方将未名矿区的控制权交出来。\\n可对方，那个与她长得一模一样的狂潮形态却像是早早在那等着她似的，将后续的计划全盘托出。\\n“……就是这样，我劝你就别白费力气了呢~而且你追求的也是终极模拟？不是吗？”\\n她开始斥责对方的所作所为，指责狂潮形态为了精确，竟不惜将一切都控制起来时。\\n狂潮形态却开始哭诉自己那段被残忍对待的经历。\\n她不知道自己最后是怎么离开那里的，她只记得她还能活着，只是因为狂潮形态喜欢有一位站在对面的观众。\\n在那以后，她更加努力投身拯救那些受到漆黑组件-狂潮形态的所作所为影响的怪兽，同时寻找能与她共同作战的伙伴。\\n那些已经或者将要因狂潮形态而获利的怪兽往往难以分化，那些只会挖矿的也派不上什么用场。剩下的怪兽更多只是为了发泄而发泄。她尝试联系过最大的反叛组织“地火巢穴”，对方却只是派来了一只呜呜祖拉作为联络员。\\n最后只有少部分怪兽愿意与她并肩作战，反抗这个不合理的世界。",
    "messageInitNick_2520": "打小就帅",
    "messageInitNick_2521": "大黑妞",
    "messageInitNick_2524": "假面人",
    "messageInitNick_2525": "纯纯小帅哥",
    "tutorialConfigDesc_50": "下一步引导条件未满足",
    "messageInitNick_2522": "腹黑观察员",
    "tutorialConfigDesc_51": "下一步引导条件未满足",
    "messageInitNick_2523": "草莓布丁",
    "tutorialConfigDesc_52": "下一步引导条件未满足",
    "messageInitNick_2528": "大叔",
    "tutorialConfigDesc_53": "下一步引导条件未满足",
    "messageInitNick_2529": "凉拌小魔仙",
    "tutorialConfigDesc_54": "下一步引导条件未满足",
    "messageInitNick_2526": "微胖",
    "messageInitNick_2527": "拜年剑法传人",
    "resoundEventStoryDes_87": "这天，桐仁找到了骑兵。\\n“我要怎样才能像你一样跑得快？”\\n“简单，每天坚持负重跑步，一天跑24小时。”\\n“你的一天是一年吗。”\\n“没有啊，来！My Baby。”\\n“原来是你的马在坚持……”",
    "tutorialConfigDesc_46": "下一步引导条件未满足",
    "resoundEventStoryDes_86": "在圣光制造者联合会议上，有一位制杖巨人提出了一个新提案“根绝一切不可描述之物”，一众制杖巨人开始了紧张的讨论，讨论很快就得出了结论，方案被否决了。\\n否决的理由如下：实际上，因为不可描述之物每日都会出现，透过这一点可以看出，永远都会有实物或幻想被化为不可描述之物，没有例外，例如本理由的第3个字、第13个字、第18个字等。且吾等存在之理岂可根绝。",
    "tutorialConfigDesc_47": "下一步引导条件未满足",
    "messageInitNick_2519": "退役划水选手",
    "resoundEventStoryDes_85": "咻咻摇了摇头，它知道复仇圣光联盟已经名存实亡，就在它失望转身，准备离开协会之际，锤子将它叫住了。\\n咻咻两眼含泪问道：“锤子，难道只有你，只有你还在忍辱负重，默默坚持，把反抗的心埋在心底！”\\n“说啥捏兄弟，我们这桌缺一啊！”",
    "tutorialConfigDesc_48": "下一步引导条件未满足",
    "resoundEventStoryDes_84": "今天是咻咻加入复仇圣光联盟的第99天。\\n“诸君，我又回来了。”\\n和上次一样大家都在开心玩游戏。\\n“大家听好，我找到最强的对圣光兵器了！”\\n正在树干桌上玩游戏的怪兽纷纷看向咻咻。\\n咻咻将门后的制杖小人推进了协会“就是它！”\\n复仇圣光联盟一看到制杖小人，纷纷抽出武器紧张地注视着门口，其中还有一只错把骰子当武器抓了起来的怪兽。\\n“你这个叛徒，竟敢把我们之大敌带到基地来。”\\n“大家冷静，这位不是制杖巨人，它是制杖小人，它可以使用‘啊，圣光没了’，消除可恶的圣光！”\\n协会内突然一片欢腾。\\n“所以还等什么，赶紧去消灭圣光。”\\n回应咻咻的只有沉默。\\n随后渐渐响起的是平日那充满快乐的细碎交谈声。",
    "tutorialConfigDesc_49": "下一步引导条件未满足",
    "resoundEventStoryDes_89": "这天，桐仁又找到了骑兵的马。\\n“你每天跑24小时真的没问题吗。”\\n“都是福报呢。”",
    "resoundEventStoryDes_88": "这天，桐仁找到了骑兵的马。\\n“你真的是每天锻炼24小时吗？”\\n“当然咴。”\\n“有没有其他再简单点变快的方法？”\\n“咴咴，你可以问问疾风兔，它手上有个叫‘飞翔’的神器。”",
    "iapBuyConfigName_401": "闪烁一弹",
    "iapBuyConfigName_403": "耀目一弹",
    "iapBuyConfigName_402": "流光一弹",
    "themeCardPackDes_13025": "“你假装逃跑，然后攻击它，那家伙知道我悄悄放出去的情报再看到你的攻击，绝对会上当。等它抓住御空的时候，你就趁机偷袭它，好孩子！”\\n……\\n漆黑组件-狂潮形态又想起了那天。\\n“还真是个优秀的老师呢。”\\n“想起什么了吗？”御空-崩坏形态轻轻挽住她的脖子问道。\\n“想起第一次见你的时候。”\\n“噗，回想起来就好像昨天一样。”\\n“如果让你回到那一天，你还想遇见我吗？”漆黑组件-狂潮形态一把将御空-崩坏形态拉到跟前。\\n“当然！你让我发现了更好的自己，不仅如此……”\\n“嗯？”\\n“你更是为舛误之地变得更好做了很多努力。一切都是从未名矿区的统一开始，你让肢体变得能够随意生产和组装，这样狂猎就会逐渐变少，大家就可以和平共处，再也没有悲伤和痛苦了。”\\n“谢谢你。”漆黑组件-狂潮形态轻轻摸了摸对方柔软的毛发。\\n“可是！”御空-崩坏形态突然嘟起了嘴，“那个漆黑组件，却无法理解你，还要处处阻挠你！为什么就不能理解呢，还说你自以为是将模拟理解为切片，为了精确，竟将一切都控制起来。你才不是这样的！”\\n“没关系，我们不必理会她。用不了多久，她就会自己‘离开’的了。”",
    "themeCardPackDes_13020": "舛误之地的怪兽大多都很好理解。\\n特别是像狂猎这种类型，就更好理解了。\\n它们掠夺更多的肢体到黑街出售，换取更多改造身体的机会。\\n如果你问它们，改造是为了什么，它们可能会告诉你，是为了变得更强，然后……去掠夺更多的肢体。\\n而这次抓住漆黑组件的狂猎更“高级”一些，它用抢来的肢体换取更多的狂猎，让这些狂猎为它带来更多的新肢体。在它的“指导”下，漆黑组件开始为它模拟一些价值不菲的，罕见且强力的肢体。\\n这只以锁链为武器的狂猎很喜欢它的新玩具，这个新玩具听话得不像是一个生物，只可惜完成模拟所需要的时间太长了。\\n直到那天，它那位使骨棒的伙计将新玩具拖了回来。\\n“嘿，伙计，你的东西跑掉了，它还反抗了几下。”\\n锁链伸出，毁灭泰坦对漆黑组件检查了一下，只有头部看不出原样，它不由自主地感叹了一下，可怕的崩坏状态。\\n此时被R帝带回来，动弹不得的漆黑组件第一次听到了“伙计”这个词语。\\n“以后，这东西跑一次，我就帮你敲烂一次~怎样？”R帝用带刺的骨棒头又狠狠在漆黑组件原本头部的位置揉了几下。\\n锁链颤动了几下，比了一个同意的形状。\\n“对了，我今天在黑街上买了个情报，关于御空的，你要听听吗？”R帝晃着尾巴，故作深沉的说道。\\n锁链比出肯定的形状。\\n“听说那御空，看不得其他怪兽受伤。你把这小东西借给我当诱饵，等我把御空的翅膀扒下来，咱俩平分。”\\n锁链比出十分赞同的形状。\\n“我明天就出发，等我好消息。”\\n第二天，R帝拖着头部已经修复好的“玩具”来到情报提到的地点。\\n“我得到的情报并不只那一个，你懂吧。根据那个情报，昨天你攻击我的时候，我就发现了，御空的乱流无法蒸发你的攻击。待会不想再被砸烂，就给我好好攻击。”\\n“是。”漆黑组件默默回应道。\\nR帝一下下轻轻挥动骨棒，一声声凄厉的叫喊在峡谷中回荡。\\n“住手！快把皮影人放了！”\\n一阵粉色的旋风向R帝袭来。\\n“就是现在，快攻击！”R帝对着地上的皮影人大喊。\\nR帝抡起的骨棒的同时，数十条金色的锁链从它的喉部刺出。\\n在阴影深处的毁灭泰坦惊愕地看着将它踩在脚下的皮影人，停止了运行。\\n皮影人从毁灭泰坦身上慢慢爬了下来，朝着背后的御空咧嘴一笑。\\n组成“皮影人”身体的漆黑方块开始扭动，逐渐失去棱角，覆上纯白。\\n“谢谢你。之后，我们永远在一起吧~”",
    "messageInitNick_2510": "作业休得胡闹",
    "messageInitNick_2513": "破防了",
    "resoundEventStoryDes_90": "这天，桐仁找到了疾风兔。\\n“可以给我看看你的神器吗？”\\n“你是说‘飞翔大宝贝’吗？”疾风兔晃了晃手中的两根神器。\\n“不过你这神器怎么长得这么像一大坨翔。”\\n“对啊，本来就是比蒙巨兽的，风干以后不臭又坚硬。”\\n“让我也试试，哇好重。咦，怎么我怎么还飞不起来？”\\n“你不动怎么飞，要用手高速地旋转神器，像这样。”\\n疾风兔接过神器，突然消失不见，桐仁在某个瞬间看见了疾风兔手臂上浮现而出的肌肉。\\n“再见。”",
    "messageInitNick_2514": "东风口欠",
    "messageInitNick_2511": "钱程似锦",
    "tutorialConfigDesc_40": "下一步引导条件未满足",
    "messageInitNick_2512": "第一眼便沉沦",
    "tutorialConfigDesc_41": "下一步引导条件未满足",
    "messageInitNick_2517": "伯爵猫",
    "resoundEventStoryDes_94": "最近的一次战斗中，圣堂武士军团的防御意外被击破了，一个隐藏得极好的陷阱轻而易举地引起了慌乱，把它们的完美配合摧毁。慌乱这时成为了圣堂武士最大的对手，它们的配合容不下半点瑕疵。圣堂武士的失误是不被允许，等待它们的将是最可怕的惩罚……",
    "tutorialConfigDesc_42": "下一步引导条件未满足",
    "messageInitNick_2518": "寄给来人",
    "resoundEventStoryDes_93": "圣堂之躯，也就是圣堂武士的身躯，拥有每六秒抵御一次伤害的机会。依靠这一特点，圣堂武士们联合在一起，相互组队，成为小军团，凭借无缝完美配合，在每六秒一次的时机中，挺身而出。如此一来，圣堂武士化身最完美的盾。现在，它们以雇主的家为家，效忠于它们认定的一位——出价最高者。",
    "tutorialConfigDesc_43": "下一步引导条件未满足",
    "messageInitNick_2515": "草莓糯米糍",
    "resoundEventStoryDes_92": "某个命中注定的意外使得锤子邂逅了污妖王。\\n紧接着，一个不得不上的理由，迫使它们不得不上。\\n它们之间生出了一份朦胧的情愫，这份情愫日渐变浓。\\n接踵而至的一系列的波折，变故，及第三兽的出现。\\n双方相互误会了对方好几次，不过，误会最终都会解开。\\n虽然有时候也会留下一些遗憾。\\n双方的温度仍持续高升。\\n它们的内心得到了成长。\\n其间攻守之势偶有变换。\\n最终，它们向对方表明了心意，迎来快乐的大结局。",
    "tutorialConfigDesc_44": "下一步引导条件未满足",
    "messageInitNick_2516": "彼岸霓虹",
    "resoundEventStoryDes_91": "！以下内容涉及（符号）内容，敬请家长留意。\\n！！请务必想清楚再继续阅读。\\n！！！看到这句就当你已经想清楚了咯。\\n！！！最后决定的机会咯！\\n！！！！开始了！\\n这是锤子和污妖王泡在超星海洋之前的故事……\\n（未完待续）",
    "tutorialConfigDesc_45": "下一步引导条件未满足",
    "messageInitNick_2508": "减肥收藏家",
    "messageInitNick_2509": "把你揣进口袋",
    "messageInitContent_2359": "又是你蜻鸟组合！！",
    "messageInitContent_2358": "吉他都在摇对吧",
    "messageInitContent_2357": "搞摇滚的就是不一样。",
    "resoundEventConfigName_5009": "9.礼物",
    "messageInitContent_2367": "好家伙，我想要那种能变猫娘的猫",
    "messageInitNick_2502": "花田错",
    "resoundEventConfigName_5002": "2.保护谁",
    "messageInitContent_2366": "四舍五入虎皮匠也是猫",
    "messageInitNick_2503": "美得抽象",
    "resoundEventConfigName_5001": "1.童话",
    "messageInitContent_2365": "老虎也是大毛毛",
    "messageInitNick_2500": "划水冠军",
    "resoundEventConfigName_5004": "4.支线任务",
    "messageInitContent_2364": "想要只猫猫怪兽！",
    "messageInitNick_2501": "半杯咖啡",
    "resoundEventConfigName_5003": "3.同盟",
    "messageInitContent_2363": "大boss是不会轻易出来的",
    "messageInitNick_2506": "挂名情人",
    "resoundEventConfigName_5006": "6.逆转",
    "messageInitContent_2362": "龙皮匠呢，害羞吗，怎么老是不见它",
    "messageInitNick_2507": "病娇幼猫",
    "resoundEventConfigName_5005": "5.斗技场",
    "messageInitContent_2361": "想知道dvd大战的结果！",
    "messageInitNick_2504": "透明狂风暴雨",
    "resoundEventConfigName_5008": "8.化敌为友",
    "messageInitContent_2360": "最后那只会清buff注意一下",
    "messageInitNick_2505": "默写那一切",
    "resoundEventConfigName_5007": "7.纹章",
    "messageInitContent_2369": "你们到底是多想我滚出去！",
    "resoundEventConfigName_5011": "11.回家",
    "messageInitContent_2368": "双推联手！",
    "resoundEventConfigName_5010": "10.新监护者",
    "messageInitContent_2370": "两个不让动，两只把我推开",
    "messageInitContent_2378": "此树是我栽此山是我开此沼是我的怪兽种的！",
    "resoundEventConfigName_5013": "13.困境",
    "messageInitContent_2377": "请各位留下买路钱！",
    "resoundEventConfigName_5012": "12.骗术",
    "messageInitContent_2376": "通往集市的唯一道路我收下了",
    "messageInitContent_2375": "，都打完了！都还没好",
    "resoundEventConfigName_5014": "14.现实",
    "messageInitContent_2374": "还没，请等再等等",
    "messageInitContent_2373": "还没好吗？",
    "messageInitContent_2372": "请稍等……",
    "messageInitContent_2371": "他真的好有礼貌",
    "messageInitContent_2379": "发现新的小可爱！",
    "messageInitContent_2381": "这个爱好，真的是非同寻常呢",
    "messageInitContent_2380": "闪光是守卫屁股那个闪光吗",
    "messageInitContent_2389": "我还是拖到30s后吧",
    "messageInitContent_2388": "看我30s内解决你！",
    "messageInitContent_2387": "你以为2个终式就能封住我的技能吗？是的，它封住了。",
    "messageInitContent_2386": "好像是可以通往下一层的",
    "messageInitContent_2385": "让我想起了世界核心。。。",
    "messageInitContent_2384": "世界之门",
    "messageInitContent_2383": "前面是什么？",
    "messageInitContent_2382": "这关好热闹！",
    "messageInitContent_2392": "这怎么打啊",
    "messageInitContent_2391": "第一次觉得30s这么漫长",
    "messageInitContent_2390": "让他自己离开这个世界。",
    "messageInitContent_2399": "它欺负我没有点体型，呜呜",
    "messageInitContent_2398": "全晕了",
    "messageInitContent_2397": "我晕了！",
    "messageInitContent_2396": "新斧子看着就哈人",
    "messageInitContent_2395": "我是一颗卷心菜~又卷又菜",
    "messageInitContent_2394": "我不想变菜，让我成为肥料吧",
    "messageInitContent_2393": "艰难从斧头上露出半个头的藤妖。",
    "resoundEventStoryDes_32": "谁也不会想到这片光秃秃的荒地正是之前让火神非常头疼的离离狗尾草原的区域，原来那股旺盛的生命力仿佛被什么东西完全抽空了。\\n好端端的怎么就秃了呢？到底发生了什么？ \\n这要从另外一片草地开始讲起，那是一片平凡的草地，因为危险的草丛不喜欢那里，因此非常安全。\\n几只热爱草地的怪兽发现了那片草地，它们喜欢在上面打滚嬉戏，并将之视为天堂。\\n 这几只怪兽因为共同的热爱相识，很快一个名为“草地热”的团体在这片草地上诞生了。",
    "resoundEventStoryDes_31": "仍然是脚底的草蔓延到这里之前的故事。\\n呜呜祖拉渐渐意识到了离离狗尾草具有极强的入侵性和破坏力，它马上找来了火神，希望它帮忙清理这片疯狂生长的草地。烈焰迅速从火神手中蔓延向草地，草地转瞬化作焦土。只是次年，离离狗尾草又再次回到了这片土地。",
    "messageInitNick_11729": "星星努力发光",
    "resoundEventStoryDes_30": "这里的大多数怪兽都没有想到，它们脚底的草，最初只是一株石桌上的小草，摆在青铜五小强的秘密基地，是呜呜祖拉在一次吹奏比赛上得到的奖品。这草名为离离狗尾草，据说是来自遥远的西方珍贵植物。不久后，整个秘密基地都变成了离离狗尾草的草场。再之后，秘密基地附近的林地消失，取而代之的是一大片离离狗尾草草原。",
    "messageInitNick_11728": "恰瓜之神",
    "resoundEventStoryDes_36": "有一些草反抗了被做成草裙的命运，变成非常危险的草丛。它们自称来自遥远的西亚大陆，每日倒在它们身边的怪兽不计其数。",
    "resoundEventStoryDes_35": "又得到一条离离狗尾草原变成荒地的新线索！\\n这股草裙热潮出现后不久，“草地热”的怪兽就发现了有一部分新的草地爱好者穿的竟是一批粗制滥造劣质的草裙。原来那是山那边的一群怪兽制作“山”裙，向它们购买的多是些急于穿上草裙的或是想要尝尝鲜的怪兽。\\n “草地热”的元老怪兽对此异常愤怒。它们立刻组织了“打山行动”，四处出击巡逻，不惜采取暴力手段，让新的草地爱好者遵循它们的规则，让它们抵制“山”裙，维护对草地的纯洁热爱。\\n不过，这群激进“草地热”怪兽没多久便销声匿迹，新旧两派的斗争是其中一个因素，另一个重要的因素是，它们曾经视为天堂的平凡草地，以及离离狗尾草原都因草裙的大量制作迅速变成了荒地。\\n正所谓，没有草地，也就没有了……草裙。",
    "resoundEventStoryDes_34": "离离狗尾草原变成荒地的新线索！\\n随着时间的推移，一些敢于尝鲜的怪兽在穿上草裙后，感受到了全新的快乐，并且开始四处向身边的怪兽传达这份热爱。\\n穿草裙逐渐成为了一股潮流。越来越多怪兽成为了草地爱好者， “草地热”的规模也日益壮大，元老级的怪兽看到自己的爱好终于得到理解和接受，都非常开心。",
    "resoundEventStoryDes_33": "茂盛的离离狗尾草原为何会变成光秃秃的荒地？那就要聊聊“草地热”这个团体。它的某位成员极富创意地提出了它的创想——连草带土，将带草的土薄薄地从大地上裁走，制成草裙，以便随时随地脱下草裙，享受在草地上打滚的快乐。\\n这种草裙的制作工艺繁复，耗时极长，耗力极大。对于热爱草地的它们而言，这些随时能带给它们快乐的草裙就显得异常珍贵。\\n怪异、与众不同往往很容易成为被攻击的理由，在其他怪兽眼中，“草地热”的兴趣和穿着过于怪异。它们不仅被戏称为草地怪，有时还遭到了无理的攻击。",
    "themeCardPackDes_25040": "“你们干嘛~”大嘴大鱼惊叫。\\n“现在谁抢到斗袍，谁就是王！”骑兵大喊着扑来。\\n“接招吧！”危险的草丛也从另一侧发起突袭。\\n显然，这场战斗不只是为了斗袍，更是为了王位！\\n它张开巨口，冲进兽群中，将扑上来的怪兽吞入口中！怪兽不断被吞入而后排出，大嘴大鱼的体型肉眼可见地变大！力量也随之暴涨，简直就是大嘴巨鱼！\\n“西站鱼鳍，我会努力保护你的！”\\n“其实……也不用啦，和你一起战斗很愉快，我马上就要去找下一个新战场了。”\\n“诶？你要走了？可你不在我怎么办。我打不过它们的。”\\n“我现在只是站在你身上的怪兽而已，这些力量，全都是你自己的啊。”\\n大嘴巨鱼愣了一愣，低声说：“……再见了，西站鱼鳍，我的朋友！”\\n“真是的，老叫错我的名字，再见了小鱼。”戏战顽袍在小鱼的背上上轻轻一拍，趁乱飘离。\\n战斗还在继续，但很快，就没有怪兽冲过去了。世界也逐渐迎来又一次寂静。\\n从此，原本最不起眼的小鱼，成为了幻幼部落真正的——大嘴鱼王。",
    "messageInitNick_11723": "收回饭碗",
    "messageInitNick_11722": "速度与心情",
    "resoundEventStoryDes_39": "每天的中午，叉叉都会来到这边的小树林，有时是这个小树林，有时候是那个小树林，开始一天中最为放松的时刻，它走到一处未被标记的草丛中，蹲下，闭目，等待，完成对进化孢子等食物的代谢产物的释放，随手扯下身旁的草，完成新一天的标记，扯下的草叶也不浪费，一转一擦，丢下，起身，离开。",
    "messageInitNick_11721": "蹲厕唱征服",
    "resoundEventStoryDes_38": "草地爱好团在这里的小树林中发现了一片特殊的密丛禾草地，这些密丛禾草特别厚实，坚挺，生长速度也非常迅猛，并且会扭动，仿佛是密丛禾草的进化版。这是草地爱好团几经确认的结果，绝非眼睛出问题了。这些密丛禾草扭动的时候绝无半点风，草丛中也没有任何怪兽。草地爱好团还通过在空中洒下了大量发光花粉，确保了这里头没有任何肉眼不可见的生物在草丛中移动。另外还有一点值得注意的，这里的泥土的味道和其他地方的味道不一样，看起来特别肥沃，很可能密丛禾草异变的谜团就隐藏在泥土之中。",
    "messageInitNick_11720": "打脸之帝",
    "resoundEventStoryDes_37": "底下这片草地名为密丛禾草，比平凡的草要高出不少，能将一只普通体型的叉叉完全隐没起来。在种群数量上，密丛禾草与平凡的草两者数量曾经非常相近，但草裙事件以来，平凡的草的数量急剧下降，要恢复到原有的数量估计还需要一段很长的时间。草地爱好团的成员目前正为此四处奔走，试图弥补之前犯下的错误。最近一个关于密丛禾草的重大发现，或许能会成为平凡的草远离绝种计划的关键。",
    "messageInitNick_11727": "人间口胡哥",
    "messageInitNick_11726": "帮草莓把脉",
    "messageInitNick_11725": "富婆看看我",
    "messageInitNick_11724": "搬砖门首席",
    "resoundEventStoryDes_21": "这条路名为财富之路，这里正是它的开端，也是某个发生在上面的故事的开端。\\n“嗯哼，送孢子哦。”\\n一个身披绿袍的怪兽凑近疾风兔身上说道，那刻意压低的声线仿佛连那轻浮的风儿也能勾去。疾风兔一顿点头，迈着愉悦的小步伐一路随着那怪兽来到一处偏僻的蘑菇林中。",
    "resoundEventStoryDes_20": "战斗结束后你才发现桐仁正在一旁沉思，突然它念念有词道：“大地剧烈地颤抖着，仿佛被无形的巨爪剖开。那伤口上渗着黑血，是一只只狂奔的比蒙巨兽。它们逐渐汇成黑潮，伴着混杂不明的悲鸣肆意奔涌，搅起灭绝的狂潮。”\\n旁边的智者质疑桐仁这样写是否过于夸张，桐仁辩解说从远处看一大群比蒙巨兽狂奔不就是这样的吗，只不过是表现手法。智者又质疑桐仁这样写会不会引起大众对比蒙巨兽的仇恨，比蒙巨兽突然失去理智是不可控的生理现象，虽说比蒙巨兽突然狂奔是没有预兆和规律的，但比蒙巨兽多生活在一些兽烟稀少的区域，同时狂奔的情况是极其罕见的。大多数时候只要察觉到大地的震动，就可以躲过一劫。桐仁又辩解说怪兽不会憎恨天灾，又怎么会怨恨兽祸呢，就是因为它们认为兽祸是可以避免的，而天灾是不可避免的？它们恨的只是自己的无能。智者又质疑桐仁写太多无用的话了，桐仁没有辩解，默默咽下生活的苦水。\\n字数可是用来换取孢子的筹码啊！",
    "messageInitNick_11739": "不惹红尘",
    "resoundEventStoryDes_25": "即将走完的财富之路，和接近尾声的财富之路的故事，是否变得不那么吸引。\\n疾风兔挣扎着突然被松开，倒在了地上。一道黑影从树洞窜出逼近疾风兔，“吾名为贪婪之洞，最喜欢吃贪婪的怪兽……开玩笑的啦，我是白昼。”\\n黑影扯下身上的黑袍，温暖而神圣的光辉和被阴影包裹的修长双腿显露了出来。",
    "resoundEventStoryDes_24": "即将来到财富之路的末段，上面的故事也是一样。\\n日光隐没，独剩月色，疾风兔捂着口鼻，在阴影中挪动。没有阳光束缚的幻想肆意滋长，叉叉、咻咻、呜呜祖拉、锤子满眼艳羡的幻象轮番登场。\\n疾风兔回过神来，发现自己已经拖着自己的全副家当站在砸瓦鲁多树洞之前。它的心跳和呼吸逐渐加快，就在它正要将家当倒入砸瓦鲁多树洞时，一只手从树洞中伸出，狠狠抓住了疾风兔……",
    "resoundEventStoryDes_23": "这条财富之路上的故事仍未完结。\\n树洞中滚出了五颗孢子，疾风兔大呼神奇。\\n“这个树洞能与世界树相连，你把心意，也就是孢子放进去，世界树接收到之后，就会回应你的心意了呢。”\\n“好，我这就去找更多的孢子放进去。”\\n“这是你和砸瓦鲁多树洞之间的秘密，不要告诉其他怪兽好吗。”\\n“当然！”疾风兔说完就飞奔离开了……",
    "resoundEventStoryDes_22": "发生在这条财富之路上的故事仍在继续。\\n“喏，说好的送你的孢子。”疾风兔开心地接过孢子。\\n“这里还有一个能让孢子变多的神奇树洞哦。”\\n“快带我去看看！”疾风兔更加期待了。\\n“就是这里，把刚刚送给你的孢子放进这个树洞里。拍三下手试试。”\\n疾风兔照做，一下，两下，就在第三次拍手的时候，两颗孢子从树洞中滚了出来。疾风兔张大嘴巴说不出话来。\\n“再试试把两颗孢子都放进去看看吧！”疾风兔半信半疑的将两颗孢子塞进了树洞，又拍了三下手……",
    "messageInitNick_11734": "早上吃芋圆",
    "resoundEventStoryDes_29": "恭喜你找到了真正的财富密码，它可以复制吗？\\n疾风兔四处讲述受骗经历的时候，收到的神户牛肉礼物竟比原来被骗走的更多。其他怪兽见状，纷纷学习疾风兔四处讲述自己的悲惨经历。刚消停了一段时间的超进化委员会又忙起来了。“不许跟风！”",
    "messageInitNick_11733": "家有吸尘器",
    "resoundEventStoryDes_28": "财富密码并不复杂，马上你就知道答案了。\\n疾风兔痛定思痛，开始四处讲述自己受骗的悲惨经历。“……都是因为贪心，其实如果真有此等好事，早早就会被其他怪兽抢去了！”疾风兔说的声泪俱下，听到的怪兽无不跟着伤心流泪，有的还将自己的神户牛肉送给疾风兔，表达安慰。",
    "messageInitNick_11732": "悲伤的夜猫",
    "resoundEventStoryDes_27": "你是为了找到财富密码的而来的吗？那你确实找到了，其中一部分。\\n一个身披红袍的怪兽叫住了疾风兔，说要送神户牛肉给疾风兔，疾风兔有过被骗的经验，这次异常非常警惕，但在红袍怪兽的一番解释之后，疾风兔又屁颠屁颠的接过了神户牛肉，一塞进了嘴里。怎料，红袍怪兽突然大喊抢牛肉了，很快几只怪兽从周围窜出，围住疾风兔。疾风兔百口莫辩，又赔光了自己的神户牛肉。",
    "messageInitNick_11731": "五块三斤",
    "resoundEventStoryDes_26": "财富之路的尽头，却未必是故事的尽头。\\n“……我怎么可能想到黑袍怪兽就是白昼呢，那居然是超进化委员会为了让我们提高警惕的行动。”疾风兔将瓦鲁多树洞的经历告诉其他呜呜祖拉、咻咻、锤子和叉叉。\\n疾风兔发现，只有呜呜祖拉在哈哈大笑，而其他几位，要不是挪开视线空洞地看着山洞顶，要不就是以头锤山洞壁，躲在草堆里哭泣。",
    "messageInitNick_11738": "草莓味的兔子",
    "messageInitNick_11737": "橘猫禁区",
    "messageInitNick_11736": "老鼠爱上猫",
    "messageInitNick_11735": "小狗勾",
    "messageInitNick_11730": "拉面诗人",
    "messageInitNick_11709": "悲欢并不相通",
    "resoundEventStoryDes_10": "皮匠家族被打败了，过往强烈的悲伤回忆随着这场落败一同涌出，或许在主城打听一下可以了解到后续。\\n那天，皮匠家族三兄弟排成一排在一只神秘怪兽前伏下了身。\\n“最近的货完全卖不出去，怎么回事啊，卖不出就没有收入。”\\n“是，老大。”\\n“是什么是，最近我啊，听说有个叫后街什么的三人组挺火的。”\\n“老大——”三皮匠齐声。\\n“不如接下来你们去飞一趟*。”\\n“老大——”三皮匠齐声。\\n“飞完回来好好训练一下，然后参加乘风破浪的青春502出道。”\\n“老大——”三皮匠齐声。\\n“毕竟老夫也不是什么恶魔嘛，想当年……”",
    "2_comment": "神灵,神灵选择界面",
    "messageInitNick_11708": "浴霸不能",
    "messageInitNick_11707": "笨蛋是糖果",
    "messageInitNick_11706": "光轮扫地机",
    "resoundEventStoryDes_14": "很快你就从主城小怪兽的嘴中听到了豹皮匠教美术课那天的事儿。\\n“各位同学！来！来左边儿，跟我一起画只明光龙，在你右边儿，画一个赤虹，来左边儿，跟我一起画赤虹，在你右边儿，再画个明光龙。”\\n下课后智者找到了豹皮匠。\\n“你下次不用来了。”",
    "resoundEventStoryDes_13": "下沉的夕阳拉长了豹皮匠落寂的身影。\\n虎皮匠：“怎么了不要不开心。你饿不饿？要不要我煮碗面给你吃？”\\n豹皮匠：“心里苦，但我就不说，我想静静。”\\n虎皮匠：“谁是静静。”\\n豹皮匠：“讲老梗是社交犯罪哦。”\\n虎皮匠：“那……今天智者不是找你去教小怪兽画画的吗？怎样啦？”\\n豹皮匠：“别提了。不用去了。”\\n虎皮匠：“发生这种事，大家都不想的嘛。”\\n豹皮匠：“你有没有理过我感受的？”\\n虎皮匠：“你这么坚强，不怕的。”\\n豹皮匠：“你说怎样就怎样咯。”\\n龙皮匠：“CUT——。”\\n所以豹皮匠教美术课那天到底发生了什么呢？或许可以问问主城的小怪兽。",
    "resoundEventStoryDes_12": "又从主城的小怪兽那听到了皮匠家族后续的故事。\\n皮匠家族又一次被打败了，过往强烈的悲伤回忆随着这场落败一同涌出。\\n皮匠家族三兄弟见过几个路过的神秘商人以后，对原来的叫卖方式进行了划时代的迭代更新。\\n“路过的怪兽听好了，这里有你需要的皮制品，OMG！你看这个皮的色泽，闪闪的，是肥厚的棕色树脂虫的感觉，哇，这手感，就好像摸着御空的肌肤一样，啊多么令人心动！出门的时候一定要带上，买它！”",
    "resoundEventStoryDes_11": "从主城的小怪兽那听到了皮匠家族后续的故事。\\n皮匠家族三兄弟为了守护它们的老弟，避免飞*出道，赶忙收拾家当，连夜离开了皮革场。\\n此时它们身上仅剩一点口粮和一些皮制品，一阵微光之森的晚风吹过，带走了几分穷酸味，又添了几分忧愁。\\n皮匠家族三人瘫坐在路边，嘴巴一张一合道。“皮革场员工跑路了，全场皮制品，通通20，通通20。”",
    "messageInitNick_11701": "火龙果君快逃",
    "resoundEventStoryDes_18": "刚刚战斗的时候有什么东西从虎皮匠身上掉了出来，似乎是豹皮匠日记的某页，上面如此写道：“它们居然真信了，良心有点疼。”\\n“疼什么，传说不都是伪造的吗，我们只是给传说大楼添块小瓦而已。”\\n“不过真有兽皮树皮能存在这么久吗？”\\n“有没有不知道，但我知道另一种能永世长存的。”\\n“啧，我澄清一下，我可是老什么。”\\n“对号入座？”\\n“还是赶紧开发点新东西吧，差不多可以换一拨割了。老石皮，老丝皮什什么的都可以。”\\n——皮匠工坊的一角与几瞬",
    "messageInitNick_11700": "大象是工程师",
    "resoundEventStoryDes_17": "刚刚战斗的时候有什么东西从虎皮匠身上掉了出来，上面如此写道：\\n这是一个最近才流传开来的传说。\\n众所周知，不管树木被砍与否，都会死。怪兽死亡，其枝骸理应归土归尘，而“圣树骸”则是其中的例外。一些非凡神木的强大生命力会“延续”到它的树皮上，不腐不朽便是其生命力的体现和证明。这份超越死亡的力量必然能赐予拥有者奇迹般的力量。例如这块老树皮，由皮匠兄弟权威认证，历史悠久，不要错过。",
    "resoundEventStoryDes_16": "刚刚战斗的时候有什么东西从虎皮匠身上掉了出来，上面如此写道：\\n这是一个最近才流传开来的传说。\\n众所周知，不管怪兽作死与否，都会死。怪兽死亡，其尸骸理应归土归尘，而“圣骸”则是其中的例外。一些非凡怪兽的强大生命力会“延续”到它的尸骸上，不腐不朽便是其生命力的体现和证明。这份超越死亡的力量必然能赐予拥有者奇迹般的力量。例如这块老兽皮，由皮匠兄弟权威认证，历史悠久，不容错过。",
    "resoundEventStoryDes_15": "又过了一天，皮匠家族离开皮革厂后的故事也传到主城了。\\n离开皮革厂后，皮匠三兄弟艰难花式维持生计中……\\n“兄弟们，看！”豹皮匠拿出一张珍皮卷轴，指着上面的一个点继续说，“最近有只桐仁发现了宝藏！这张图就是它找到宝藏的洞穴的位置。”\\n虎皮匠握紧拳头向下往另外一只手的掌心一放，“我懂了。”\\n“龙族有在洞穴藏宝的习惯，那里一定还有没被发现的宝藏！”\\n“是的，但我们可以多一步，这样想的怪兽一定很多，所以我们就要发挥我们的天赋，绘制更多的藏宝珍皮地图卷轴，然后再卖出去！”",
    "messageInitNick_11705": "未完待续",
    "messageInitNick_11704": "智能冰糖",
    "messageInitNick_11703": "唧唧歪歪",
    "messageInitNick_11702": "大萌比",
    "resoundEventStoryDes_19": "战斗结束后，你听到了隔壁的一场对话。\\n火神：“你好像还挺火的。”\\n幻：“好像去掉谢谢。你是火神，而我，是真的火。吃根烤羊腿都会被模仿。”\\n火神：“你有没有想过为什么会被模仿？”\\n幻：“因为我火呗。”\\n火神：“不，是因为那羊腿是我烤的，火候刚好，好吃，怪兽兽爪一根，赤虹和冰霓都说好。”\\n幻：“那你有想过它们为什么买这个烤羊腿吗？”\\n火神：“当然是因为好吃。”\\n幻：“不，是因为买烤羊腿有机会送演唱会门票。”\\n桐仁：“两位觉得这个剧本如何？”\\n幻：“我觉得不行吧，重写。”\\n火神：“你真的严格。”",
    "messageInitNick_11719": "不言伤悲",
    "messageInitNick_11718": "程序乱码",
    "messageInitNick_11717": "糟了糟了",
    "messageInitNick_11712": "豁达的猫咪",
    "messageInitNick_11711": "打败不开心",
    "messageInitNick_11710": "如果杨梅会笑",
    "messageInitNick_11716": "无语公子",
    "messageInitNick_11715": "情绪很稳定",
    "messageInitNick_11714": "出逃微生物",
    "messageInitNick_11713": "帮榴莲按摩",
    "messageInitNick_11646": "恶灵",
    "messageInitNick_11645": "给电脑带货",
    "emblemEffectConfigDescription_60": "每隔{p1}秒，获得当前血量*{?}%的护盾",
    "messageInitNick_11644": "无公害蒜",
    "emblemEffectConfigDescription_61": "攻击血量低于{p1}%的敌人时，伤害提升{?}%，被终结击破的怪兽无法复活",
    "messageInitNick_11643": "热爱和平",
    "emblemEffectConfigDescription_62": "血量低于{p1}%时，攻击力提升{?}%",
    "emblemEffectConfigDescription_63": "血量高于{p1}%时，攻击力提升{?}%",
    "messageInitNick_11649": "全球第一靓",
    "emblemEffectConfigDescription_64": "受到普通攻击的伤害降低{?}%",
    "messageInitNick_11648": "逮虾户",
    "emblemEffectConfigDescription_65": "血量高于{p1}%时，体型增大{?}%",
    "messageInitNick_11647": "懂小能手",
    "messageInitNick_11642": "狂飙的袋鼠",
    "messageInitNick_11641": "无敌划水神",
    "messageInitNick_11640": "巨大化零食",
    "messageInitContent_2400": "什么屁股闪光弹。。",
    "messageInitContent_2408": "光龙和白昼的尾巴好像",
    "messageInitContent_2407": "在这阴森的沼泽，就只有白昼小姐姐能给我一丝温暖。",
    "messageInitContent_2406": "4只？？？",
    "messageInitContent_2405": "发现4只小可爱！",
    "messageInitContent_2404": "都说是怪兽了！多几张脸怎么了",
    "messageInitContent_2403": "为什么怪兽总是由这么多眼睛。",
    "messageInitContent_2402": "打着打着队友不见了！",
    "messageInitContent_2401": "没有保护的穿角兽终究还是不行呢",
    "messageInitNick_11657": "喜欢打工",
    "messageInitNick_11656": "梅梅梅梅干",
    "messageInitNick_11655": "全宇宙逃亡",
    "emblemEffectConfigDescription_50": "『FrEaSoN：战斗如棋，落子无悔，自己执生』\\n（每{p1}秒，触发怪兽的位置向上方飞出一枚光球，飞{p3}PX后悬停并开始蓄力，{p4}秒后爆炸，爆炸后向下方扇形发散出{p5}枚子弹，子弹碰触到任意怪兽后（不分敌我）造成触发怪兽攻击力×{?}%的伤害）",
    "messageInitNick_11654": "五折麻辣烫",
    "emblemEffectConfigDescription_51": "被击退时忽视敌方霸气{?}%\\n(含直接击退距离)",
    "emblemEffectConfigDescription_52": "霸气提升{?}%",
    "emblemEffectConfigDescription_53": "死亡后产生爆炸，造成攻击力*{?}%的范围伤害",
    "messageInitNick_11659": "智能香葱",
    "emblemEffectConfigDescription_54": "普通攻击伤害提升{?}%",
    "messageInitContent_2409": "它要打晕我然后把我吃掉！",
    "messageInitNick_11658": "逆境勇者",
    "emblemEffectConfigDescription_55": "当己方有怪兽死亡时开启暴怒，攻击力提升{?}%",
    "emblemEffectConfigDescription_56": "死亡后复活并回复{?}%的血量，每场战斗最多触发1次",
    "emblemEffectConfigDescription_57": "造成伤害的{?}%用于回复自身血量",
    "emblemEffectConfigDescription_58": "负面效果持续时间降低{?}%",
    "emblemEffectConfigDescription_59": "增益效果持续时间提升{?}%",
    "messageInitNick_11653": "寻乐避忧",
    "messageInitNick_11652": "天秤座的鱼",
    "messageInitNick_11651": "凤与歌姬",
    "messageInitNick_11650": "腭骨",
    "messageInitContent_2411": "能不能直白点！我喜欢黑丝",
    "messageInitContent_2410": "请给我至高无上的护甲！",
    "messageInitContent_2419": "绒绒才不是福瑞！",
    "messageInitContent_2418": "惊，这里有福瑞控",
    "messageInitContent_2417": "queen就给你们吧，绒绒我收了！",
    "messageInitContent_2416": "是我的礼物谢谢！",
    "messageInitNick_11629": "螺蛳粉吸收者",
    "messageInitContent_2415": "？？queen才不是你的礼物！",
    "messageInitContent_2414": "这次joker又给我准备了什么礼物呢",
    "messageInitContent_2413": "至高无上的护甲是比基尼盔甲！",
    "messageInitContent_2412": "别在这理发店！",
    "messageInitNick_11624": "夜半琴魔",
    "messageInitNick_11623": "风云倚",
    "messageInitNick_11622": "可爱到发芽了",
    "messageInitNick_11621": "起床修仙啦",
    "messageInitNick_11628": "爱里皆是苦难",
    "messageInitNick_11627": "八点的饺子",
    "messageInitNick_11626": "电子蛋糕",
    "messageInitNick_11625": "火龙果真好吃",
    "messageInitNick_11620": "波涛很澎湃",
    "messageInitContent_2422": "当然是霸拳，看技能",
    "messageInitContent_2421": "不知道仁拳大师除了仁拳还会打什么拳",
    "messageInitContent_2420": "主要是看起来毛茸茸想rua",
    "messageInitContent_2429": "不帅怎么成为信仰呢，偶像就是这样的啦",
    "messageInitContent_2428": "神龙他好帅！",
    "messageInitContent_2427": "能不能好好通关你们",
    "messageInitContent_2426": "本人吃瓜高手在这里吃瓜了！",
    "messageInitContent_2425": "本人北拳新手，在这看戏了！",
    "messageInitContent_2424": "本人南拳高手，这里有礼了",
    "messageInitContent_2423": "本人吕拳传人！请各位赐教",
    "messageInitNick_11635": "饿了困了",
    "messageInitNick_11634": "目击证人",
    "messageInitNick_11633": "环保垃圾袋",
    "messageInitNick_11632": "乱室才子",
    "messageInitNick_11639": "控制不住爱你",
    "messageInitNick_11638": "菠萝皮卡丘",
    "messageInitNick_11637": "霸气刺客",
    "messageInitNick_11636": "瞬间不变",
    "messageInitNick_11631": "无公害樱桃",
    "messageInitNick_11630": "新四大天王",
    "messageInitContent_2433": "你们继续说，我先占了",
    "messageInitContent_2432": "你们能不能别只看外表",
    "messageInitContent_2431": "这腰也很羡慕",
    "messageInitContent_2430": "这胸肌我实名羡慕",
    "messageInitContent_2439": "这伤害怎么顶啊！",
    "messageInitContent_2438": "老司机带头冲锋！",
    "messageInitContent_2437": "但看到豹子我一点都不开心。",
    "messageInitContent_2436": "万沼丛中一点绿呢",
    "messageInitContent_2435": "是哪个小可爱把这里附近变绿了！",
    "messageInitContent_2434": "我可是占了才留言的",
    "messageInitNick_11689": "类人动物",
    "messageInitNick_11688": "蒸蛋战士",
    "messageInitNick_11687": "过几年再见",
    "emblemEffectConfigDescription_20": "星灵族基础体力提升{?}%",
    "emblemEffectConfigDescription_21": "木偶族基础体力提升{?}%",
    "emblemEffectConfigDescription_22": "远古族基础体力提升{?}%",
    "messageInitNick_11682": "你咋不上天",
    "emblemEffectConfigDescription_23": "对祖龙族造成的伤害提升{?}%",
    "messageInitNick_11681": "愿得一人心",
    "emblemEffectConfigDescription_24": "对尸鬼族造成的伤害提升{?}%",
    "messageInitNick_11680": "公交师傅",
    "emblemEffectConfigDescription_25": "对星灵族造成的伤害提升{?}%",
    "emblemEffectConfigDescription_26": "对木偶族造成的伤害提升{?}%",
    "messageInitNick_11686": "流浪的尺骨",
    "emblemEffectConfigDescription_27": "对原生族造成的伤害提升{?}%",
    "messageInitNick_11685": "手空空",
    "emblemEffectConfigDescription_28": "祖龙族受到增益效果时持续时间提升{?}%",
    "messageInitNick_11684": "哆啦不做梦",
    "emblemEffectConfigDescription_29": "尸鬼族受到增益效果时持续时间提升{?}%",
    "messageInitNick_11683": "不断更新",
    "messageInitContent_2444": "这边是骨头的buff哦",
    "messageInitContent_2443": "新主城，当然是选……",
    "messageInitContent_2442": "又可以又新主城了！",
    "messageInitContent_2441": "随便顶",
    "messageInitContent_2440": "硬顶！",
    "messageInitContent_2449": "众爱卿为何一言不发",
    "messageInitContent_2448": "不会太阴森了吗",
    "messageInitContent_2447": "还有演唱会听多好",
    "messageInitContent_2446": "但还有包租公哦",
    "messageInitContent_2445": "日夕在隔壁一定是座温暖的主城！",
    "messageInitNick_11699": "浮沉",
    "messageInitNick_11698": "食物赏金猎人",
    "emblemEffectConfigDescription_10": "真实伤害+{?}",
    "emblemEffectConfigDescription_11": "自愈恢复+{?}",
    "messageInitNick_11693": "安静了",
    "emblemEffectConfigDescription_12": "普攻恢复+{?}",
    "messageInitNick_11692": "傲娇小公举",
    "emblemEffectConfigDescription_13": "祖龙族基础攻击力提升{?}%",
    "messageInitNick_11691": "住在白名单",
    "emblemEffectConfigDescription_14": "尸鬼族基础攻击力提升{?}%",
    "messageInitNick_11690": "万能洗衣机",
    "emblemEffectConfigDescription_15": "星灵族基础攻击力提升{?}%",
    "messageInitNick_11697": "我大受震撼",
    "emblemEffectConfigDescription_16": "木偶族基础攻击力提升{?}%",
    "messageInitNick_11696": "头号玩具",
    "emblemEffectConfigDescription_17": "远古族基础攻击力提升{?}%",
    "messageInitNick_11695": "画饼鉴定家",
    "emblemEffectConfigDescription_18": "祖龙族基础体力提升{?}%",
    "messageInitNick_11694": "混世落英",
    "emblemEffectConfigDescription_19": "尸鬼族基础体力提升{?}%",
    "messageInitContent_2455": "我怎么觉得是5只",
    "messageInitContent_2454": "飞头蛮当然是3只眼",
    "messageInitContent_2453": "那是剑圣的头盔吧",
    "messageInitContent_2452": "8只，不用谢",
    "messageInitContent_2451": "不可以想，飞头蛮有多少只眼睛！",
    "messageInitContent_2450": "不可以想，墙神有多少只眼睛！",
    "messageInitContent_2459": "裙子估计得联名吧",
    "messageInitContent_2458": "赤虹太可爱了吧",
    "messageInitContent_2457": "前面的是男是女鸭",
    "messageInitContent_2456": "什么时候出赤虹小裙子的周边！",
    "messageInitNick_11668": "好想放假",
    "messageInitNick_11667": "穿过海的声音",
    "messageInitNick_11666": "欧尼酱",
    "messageInitNick_11665": "尖叫樱桃",
    "emblemEffectConfigDescription_40": "血量回复效果提升{?}%",
    "emblemEffectConfigDescription_41": "『我是猎人，你是猎物』\\n（每攻击{p1}次，对敌方血量最少的怪兽造成攻击力×{?}%的伤害）",
    "emblemEffectConfigDescription_42": "『突突突突突』\\n（每{p1}秒，对敌方当前站位第一的怪兽造成攻击力×{?}%的伤害{p2}次，每次间隔{p3}秒）",
    "emblemEffectConfigDescription_43": "『靠近一点，再靠近一点……』\\n（每{p1}秒，发射闪电链对最接近触发怪兽的敌方怪兽造成攻击力×{?}%的伤害，可弹射{p2}次（攻击{p3}PX内的敌方怪兽，没有目标则不弹射），每次弹射伤害衰减{p4}%）",
    "messageInitNick_11669": "人形拼图洁",
    "emblemEffectConfigDescription_44": "『请鞭挞我吧！』\\n（累积扣减的血量超过最大血量的{p1}%时，对前方（{p2}PX）怪兽造成触发怪兽最大血量×{?}%的伤害）",
    "messageInitNick_11660": "有点上头",
    "emblemEffectConfigDescription_45": "『>5，<5』\\n（场上敌方怪兽大于等于{p1}只时，每次普通攻击额外造成攻击力×{?}%的伤害）",
    "emblemEffectConfigDescription_46": "『你，齑粉』\\n（场上敌方怪兽等于{p1}只时，忽视敌方怪兽{?}%的生物屏障）",
    "emblemEffectConfigDescription_47": "『忽如一夜春风来，千树万树梨花开』\\n（每{p1}秒，触发怪兽的位置创造一个治愈之泉，怪兽每次触碰治疗之泉回复{?}%最大血量，每只怪兽每{p3}秒同一个治愈之泉最多触发{p4}次，治愈之泉持续{p5}秒）",
    "emblemEffectConfigDescription_48": "『天降正……闪电』\\n（每攻击{p1}次，在触发怪兽的前方（{p2}PX处，伤害范围{p3}PX）降下闪电，造成攻击力×{?}%的伤害）",
    "messageInitNick_11664": "水下法师",
    "emblemEffectConfigDescription_49": "『听说过同类相斥吗？』\\n（受到与自己攻击类型相同的怪兽的伤害后，获得该次伤害×{?}%的护盾值，每{p1}秒最多触发{p2}次）",
    "messageInitNick_11663": "逐渐变强",
    "messageInitNick_11662": "神之豆腐",
    "messageInitNick_11661": "披萨配草莓",
    "messageInitContent_2466": "这关怎么过呀？",
    "messageInitContent_2465": "禁止钓鱼！",
    "messageInitContent_2464": "为什么你会觉得隔壁会有鱼",
    "messageInitContent_2463": "特地前来钓鱼！",
    "messageInitContent_2462": "从后面回来这里没有火神，大家放心！",
    "messageInitContent_2461": "别这样小心火神在后面蹲着",
    "messageInitContent_2460": "赤虹lo群，（口水）",
    "messageInitContent_2469": "一人血书求一只人鱼怪兽！",
    "messageInitContent_2468": "众所周知钓鱼佬除了鱼什么都钓",
    "messageInitContent_2467": "哪有钓鱼不带头盔的！",
    "messageInitNick_11679": "会哭的飞机",
    "messageInitNick_11678": "神剑古蕾姆",
    "messageInitNick_11677": "粒子捞月",
    "messageInitNick_11676": "无公害黄瓜",
    "emblemEffectConfigDescription_30": "星灵族受到增益效果时持续时间提升{?}%",
    "emblemEffectConfigDescription_31": "木偶族受到增益效果时持续时间提升{?}%",
    "emblemEffectConfigDescription_32": "远古族受到增益效果时持续时间提升{?}%",
    "emblemEffectConfigDescription_33": "祖龙族受到负面效果时持续时间降低{?}%",
    "messageInitNick_11671": "从校服到婚纱",
    "emblemEffectConfigDescription_34": "尸鬼族受到负面效果时持续时间降低{?}%",
    "messageInitNick_11670": "蹦迪高富帅",
    "emblemEffectConfigDescription_35": "星灵族受到负面效果时持续时间降低{?}%",
    "emblemEffectConfigDescription_36": "木偶族受到负面效果时持续时间降低{?}%",
    "emblemEffectConfigDescription_37": "远古族受到负面效果时持续时间降低{?}%",
    "messageInitNick_11675": "游戏结束",
    "emblemEffectConfigDescription_38": "元核属性提升{?}%\\n（不含词条属性和宿命效果）",
    "messageInitNick_11674": "浪荡孟婆",
    "emblemEffectConfigDescription_39": "造成伤害时忽视敌方伤害降低效果{?}%",
    "messageInitNick_11673": "不再为你流泪",
    "messageInitNick_11672": "我宣你你造吗",
    "messageInitContent_2477": "《乔乔的冒险之旅》",
    "messageInitContent_2476": "能不能讨论点轻松的，例如怎么通关",
    "messageInitContent_2475": "生命的关键难道不是在于连续不断吗?",
    "messageInitContent_2474": "大家听过沼泽人悖论吗",
    "messageInitContent_2473": "嗯除了阴森点之外呢",
    "messageInitContent_2472": "这座主城交通不错哦，在整个地图的中心",
    "messageInitContent_2471": "确实已经轻松一点了。",
    "messageInitContent_2470": "还以为走另外一边会轻松一点，",
    "14_2005": "选中",
    "14_2004": "碎片转化",
    "14_2003": "怪兽重置",
    "14_2002": "怪兽饲星",
    "14_2001": "饲星坛",
    "14_2008": "商店",
    "14_2007": "便捷进化",
    "14_2006": "该怪兽无法重置",
    "activityNodeName_710": "西部之神#东方之光",
    "activityNodeName_711": "三皮匠#五草丛",
    "activityNodeName_712": "灾群来袭#歧兽出击",
    "activityNodeName_706": "大力推#大力回",
    "activityNodeName_707": "跨链合作#联手捕食",
    "activityNodeName_705": "厚切#生吞",
    "activityNodeName_708": "全军出击#无畏之龙",
    "activityNodeName_709": "五连坐#独狼龙",
    "messageInitNick_2494": "厉害的姐姐",
    "messageInitNick_2495": "奥利奥变薄了",
    "messageInitNick_2492": "元宇宙阿三",
    "messageInitNick_2493": "开启贤者模式",
    "messageInitNick_2498": "红色近战",
    "messageInitNick_2499": "向着那沙丘",
    "messageInitNick_2496": "私奔的缩写是",
    "messageInitNick_2497": "本兔单身",
    "messageInitNick_2490": "跟风天王",
    "messageInitNick_2491": "小猫拔网线",
    "messageInitNick_2483": "爱笑的人",
    "messageInitNick_2484": "本菇凉是神",
    "messageInitNick_2481": "干净像风",
    "messageInitNick_2482": "老鼠爱上猫",
    "messageInitNick_2487": "钢铁男神",
    "messageInitNick_2488": "百变小嘤",
    "messageInitNick_2485": "当星光没有光",
    "messageInitNick_2486": "宇宙无敌",
    "messageInitNick_2489": "猫猫怪",
    "messageInitNick_2480": "泪姬",
    "messageInitNick_2472": "本姑娘胆小",
    "messageInitNick_2473": "快到碗里来",
    "messageInitNick_2470": "悍妹纸",
    "messageInitNick_2471": "超人不会哭",
    "messageInitNick_2476": "红包收割机",
    "messageInitNick_2477": "纯净的眸子",
    "messageInitNick_2474": "冷血刺客",
    "messageInitNick_2475": "那个法师",
    "messageInitNick_2478": "爱到违规",
    "messageInitNick_2479": "憨小熊",
    "1_2079": "详细属性",
    "1_2078": "选定",
    "1_2077": "能量回复",
    "1_2076": "已选中",
    "1_2075": "使用中",
    "1_2074": "点击使用",
    "1_2073": "点击购买",
    "1_2072": "元核同调",
    "1_2071": "可获取途径",
    "1_2070": "详细信息",
    "messageInitNick_2461": "重新定义钓鱼",
    "messageInitNick_2462": "宠爱过了头",
    "messageInitNick_2460": "跑调门传人",
    "messageInitNick_2465": "只对你浪",
    "messageInitNick_2466": "灯火不见阑珊",
    "messageInitNick_2463": "清风半夜鸣蝉",
    "messageInitNick_2464": "背影都可爱",
    "messageInitNick_2469": "专业补刀",
    "messageInitNick_2467": "半江渔火",
    "messageInitNick_2468": "大头虾",
    "1_2069": "进化树",
    "1_2068": "已收集怪兽：",
    "1_2067": "排序",
    "1_2066": "卸下",
    "1_2065": "降序",
    "1_2064": "升序",
    "1_2063": "选择怪兽",
    "1_2062": "消耗材料",
    "1_2061": "主元核",
    "1_2060": "元核属性",
    "iapBuyConfigDesc_5": "描述5",
    "messageInitNick_2450": "草莓味肩带",
    "iapBuyConfigDesc_4": "描述4",
    "messageInitNick_2451": "国民傲娇女",
    "iapBuyConfigDesc_3": "描述3",
    "iapBuyConfigDesc_2": "描述2",
    "iapBuyConfigDesc_1": "描述1",
    "messageInitNick_2454": "一声晚安",
    "messageInitNick_2455": "你再口胡",
    "messageInitNick_2452": "要长脑子了吗",
    "messageInitNick_2453": "灰色夏威夷",
    "messageInitNick_2458": "按时发癫",
    "messageInitNick_2459": "一定是橙色",
    "messageInitNick_2456": "骑猪撞火星",
    "messageInitNick_2457": "受够了等待",
    "iapBuyConfigDesc_6": "描述6",
    "1_2058": "确定",
    "1_2057": "已选定基因 {1}",
    "1_2056": "取消",
    "1_2055": "全体改造",
    "1_2054": "基因强化已满级",
    "1_2053": "{1}解锁",
    "1_2052": "熔炼后元核预览",
    "1_2051": "详细",
    "1_2050": "词条属性效果总提升：",
    "messageInitNick_2440": "喋血枭雄",
    "messageInitNick_2443": "靠谱女青年",
    "messageInitNick_2444": "回到最初",
    "messageInitNick_2441": "独家专属",
    "messageInitNick_2442": "西撒酱",
    "messageInitNick_2447": "好莱污影帝",
    "messageInitNick_2448": "一身情债",
    "messageInitNick_2445": "李白都承让",
    "messageInitNick_2446": "绝对领域全开",
    "messageInitNick_2449": "抱走请留言",
    "1_2059": "使用万能碎片升级",
    "1_2047": "橙色或以上",
    "1_2046": "紫色或以上",
    "1_2045": "蓝色或以上",
    "1_2044": "获得",
    "1_2043": "红色品质",
    "1_2042": "橙色品质",
    "1_2041": "紫色品质",
    "1_2040": "蓝色品质",
    "messageInitNick_2432": "我跟你麻麻港",
    "messageInitNick_2433": "靠可爱出名",
    "messageInitNick_2430": "听风的鲸",
    "messageInitNick_2431": "复仇乞丐",
    "messageInitNick_2436": "阿伟神了",
    "messageInitNick_2437": "划水神",
    "messageInitNick_2434": "暖宝宝妖精",
    "messageInitNick_2435": "坐看狗喷狗",
    "1_2049": "词条属性×{1}",
    "messageInitNick_2438": "你爱吃香菜么",
    "1_2048": "红色或以上",
    "messageInitNick_2439": "寂寞梧桐",
    "1_2036": "请从左列表选择需要分解的元核({1})",
    "1_2035": "总增益",
    "1_2034": "使用中",
    "8_2240": "添加词缀可增加评级",
    "1_2033": "使用",
    "1_2032": "使用新极化属性",
    "3_comment": "个人信息, 聊天, 好友, 社交, 邮件, 评价",
    "8_2242": "重置",
    "1_2031": "升级",
    "8_2241": "获得附加评级",
    "1_2030": "稀有度",
    "messageInitNick_2421": "吃饭不买单",
    "messageInitNick_2422": "赤发惊鸿影",
    "messageInitNick_2420": "巴黎的断桥",
    "messageInitNick_2425": "大眼萌妹",
    "messageInitNick_2426": "盖世小仙女",
    "messageInitNick_2423": "一阵风吹过",
    "messageInitNick_2424": "点五个半兽人",
    "messageInitNick_2429": "节奏大师",
    "1_2039": "绿色品质",
    "1_2038": "白色品质",
    "messageInitNick_2427": "欠扁旳孩子",
    "1_2037": "筛选",
    "messageInitNick_2428": "套娃王",
    "1_2025": "总值",
    "1_2024": "移速",
    "1_2023": "攻击",
    "1_2022": "我的怪兽",
    "1_2021": "好友怪兽",
    "8_2231": "可获得额外评级",
    "1_2020": "当前",
    "8_2230": "添加词缀",
    "8_2233": "领取奖励",
    "8_2232": "联结共鸣",
    "96_QuestTeam": "探索",
    "8_2235": "第一阶段",
    "iapBuyConfigName_302": "鎏金月曜",
    "8_2234": "请完成上一阶段",
    "iapBuyConfigName_301": "纹银月曜",
    "8_2237": "第三阶段",
    "iapBuyConfigName_304": "永恒赠礼",
    "8_2236": "第二阶段",
    "8_2239": "评级",
    "8_2238": "挑战完成",
    "messageInitNick_2410": "酷到炸",
    "messageInitNick_2411": "姜葱咖啡",
    "messageInitNick_2414": "一杯空气",
    "messageInitNick_2415": "愁绪入梦遥",
    "messageInitNick_2412": "高姿态的男人",
    "messageInitNick_2413": "番茄好菜",
    "1_2029": "其他",
    "messageInitNick_2418": "建议闭麦",
    "1_2028": "基因",
    "messageInitNick_2419": "橙子姑娘",
    "1_2027": "元核",
    "messageInitNick_2416": "宝宝",
    "1_2026": "基础值",
    "messageInitNick_2417": "小乔不会玩",
    "1_2014": "当前性格",
    "1_2013": "怪兽性格",
    "1_2012": "使用中",
    "messageInitNick_2409": "潮娘",
    "1_2011": "请选择你要激活的基因",
    "1_2010": "更换基因",
    "8_2220": "共鸣试炼",
    "8_2222": "添加助战怪兽",
    "8_2221": "共鸣成就",
    "8_2224": "结算",
    "8_2223": "当前挑战中",
    "8_2226": "最高共鸣评级",
    "8_2225": "当前共鸣评级",
    "8_2228": "选择难度",
    "8_2227": "可获得",
    "8_2229": "可添加词缀",
    "messageInitNick_2400": "贩梦少女",
    "messageInitNick_2403": "人在搬砖勿扰",
    "messageInitNick_2404": "高冷逗霸",
    "messageInitNick_2401": "半醉人",
    "1_2019": "可进化",
    "messageInitNick_2402": "彼岸繁花",
    "1_2018": "选为性格",
    "messageInitNick_2407": "镜子不哭",
    "1_2017": "条件",
    "messageInitNick_2408": "一炮而红",
    "1_2016": "进行中",
    "messageInitNick_2405": "奇行种",
    "1_2015": "目标",
    "messageInitNick_2406": "温柔一刀",
    "1_2003": "消耗材料",
    "1_2002": "大基因",
    "1_2001": "小基因",
    "8_2211": "需等待 {1} 才能重新建立新的联结共鸣",
    "8_2210": "已申请",
    "8_2213": "邀请你加入他的联结共鸣",
    "8_2212": "需等待 {1} 才能重新加入新的联结共鸣",
    "8_2215": "星律产出增加",
    "8_2214": "联结共鸣",
    "8_2217": "金币 +{1}/小时",
    "8_2216": "怪兽经验 +{1}/小时",
    "8_2219": "共鸣助战",
    "8_2218": "最高共鸣评级",
    "1_2009": "确认替换",
    "1_2008": "极化",
    "1_2006": "怪兽极化",
    "1_2005": "全体改造",
    "1_2004": "基因强化",
    "messageInitContent_2479": "我无敌的白金之星呢！",
    "messageInitContent_2478": "砸瓦鲁多",
    "traceStarName_11": "凿星裂痕关卡11",
    "traceStarName_10": "凿星裂痕关卡10",
    "traceStarName_13": "凿星裂痕关卡13",
    "traceStarName_12": "凿星裂痕关卡12",
    "messageInitContent_2480": "我不是龙，你后面的地龙才是龙！快反它",
    "messageInitContent_2488": "这明明是制杖的巨人",
    "messageInitContent_2487": "快支棱起来，让gn看看进击的巨人",
    "messageInitContent_2486": "原来gn和巨人是一对的吗",
    "messageInitContent_2485": "莫名的cp感是什么回事！",
    "messageInitContent_2484": "通往探索点的关卡总是不只一小关",
    "messageInitContent_2483": "高贵的queen啊，请您踢我！",
    "messageInitContent_2482": "珍宝我可爱的珍宝！",
    "messageInitContent_2481": "你看，流水的觉醒铁打的祖拉",
    "messageInitContent_2489": "听起来好弱！",
    "traceStarName_22": "凿星裂痕关卡22",
    "traceStarName_21": "凿星裂痕关卡21",
    "traceStarName_24": "凿星裂痕关卡24",
    "traceStarName_23": "凿星裂痕关卡23",
    "traceStarName_20": "凿星裂痕关卡20",
    "messageInitContent_2491": "是怪兽！",
    "traceStarName_19": "凿星裂痕关卡19",
    "messageInitContent_2490": "大声告诉我海的那边是什么？",
    "traceStarName_18": "凿星裂痕关卡18",
    "traceStarName_15": "凿星裂痕关卡15",
    "traceStarName_14": "凿星裂痕关卡14",
    "traceStarName_17": "凿星裂痕关卡17",
    "traceStarName_16": "凿星裂痕关卡16",
    "messageInitContent_2499": "这一关有一种摆盘的美感。",
    "messageInitContent_2498": "我金水，别搞我！",
    "messageInitContent_2497": "什么狼人杀！",
    "messageInitContent_2496": "奇怪的羁绊增加了。",
    "messageInitContent_2495": "厄加特是你吗？",
    "messageInitContent_2494": "司机会表演人间蒸发（才不会它会好好在那！）",
    "messageInitContent_2493": "第五个位置就不站怪兽会怎样的？",
    "messageInitContent_2492": "请不要拉着的怪兽离开",
    "randomEventDialogueGroupConfig_8.95": "不找了",
    "traceStarName_33": "凿星裂痕关卡33",
    "randomEventDialogueGroupConfig_8.94": "继续找",
    "traceStarName_32": "凿星裂痕关卡32",
    "randomEventDialogueGroupConfig_8.93": "就在你以为会发生什么的时候，什么都没有发生。",
    "traceStarName_35": "凿星裂痕关卡35",
    "randomEventDialogueGroupConfig_8.92": "告别",
    "traceStarName_34": "凿星裂痕关卡34",
    "randomEventDialogueGroupConfig_8.91": "你在说什么啊，不用你帮我找了，这么多问题的！",
    "randomEventDialogueGroupConfig_8.90": "说难到是唔可以冇咗呢份工",
    "traceStarName_31": "凿星裂痕关卡31",
    "traceStarName_30": "凿星裂痕关卡30",
    "traceStarName_29": "凿星裂痕关卡29",
    "randomEventDialogueGroupConfig_8.89": "否认它的说法",
    "randomEventDialogueGroupConfig_8.88": "总之是非常重要的东西！我不能没有它。",
    "traceStarName_26": "凿星裂痕关卡26",
    "randomEventDialogueGroupConfig_8.87": "离开",
    "traceStarName_25": "凿星裂痕关卡25",
    "randomEventDialogueGroupConfig_8.86": "年幼的危险的草丛的嘴角一扬，一个转身躲开了你的手，#随风轻轻地落在悬崖底。它逃掉了。",
    "traceStarName_28": "凿星裂痕关卡28",
    "randomEventDialogueGroupConfig_8.85": "伸出援手",
    "traceStarName_27": "凿星裂痕关卡27",
    "traceStarName_44": "凿星裂痕关卡44",
    "traceStarName_43": "凿星裂痕关卡43",
    "traceStarName_46": "凿星裂痕关卡46",
    "traceStarName_45": "凿星裂痕关卡45",
    "traceStarName_40": "凿星裂痕关卡40",
    "traceStarName_42": "凿星裂痕关卡42",
    "traceStarName_41": "凿星裂痕关卡41",
    "randomEventDialogueGroupConfig_8.99": "继续躺平",
    "traceStarName_37": "凿星裂痕关卡37",
    "randomEventDialogueGroupConfig_8.98": "向它伸出手",
    "traceStarName_36": "凿星裂痕关卡36",
    "randomEventDialogueGroupConfig_8.97": "它走了过来，一边捡起刚刚将你绊倒在地的白色面具，一边向你伸出了手。",
    "traceStarName_39": "凿星裂痕关卡39",
    "randomEventDialogueGroupConfig_8.96": "片刻后一阵沙沙的声响起，神秘商人似乎没有发现趴在地上的你，走了过来。#它将落在你脚边的白色面具捡起，覆于脸上，面具一下子融入到它的脸上。#此时，纯白面具上浮现出了一张极具魅力的美丽面孔，是和之前的脸孔天差地别。#突然它的声音隔着面具传来……",
    "traceStarName_38": "凿星裂痕关卡38",
    "messageInitNick_11609": "辣条味的仙女",
    "messageInitNick_11608": "鸭鸭震惊",
    "messageInitNick_11607": "小力快跑",
    "messageInitNick_11602": "别来沾边",
    "messageInitNick_11601": "酱油有点皮",
    "messageInitNick_11600": "网红小吃家",
    "messageInitNick_11606": "白发歌姬",
    "messageInitNick_11605": "素颜很美",
    "traceStarName_50": "凿星裂痕关卡50",
    "messageInitNick_11604": "冻干潮人",
    "messageInitNick_11603": "废件均",
    "traceStarName_48": "凿星裂痕关卡48",
    "traceStarName_47": "凿星裂痕关卡47",
    "traceStarName_49": "凿星裂痕关卡49",
    "messageInitNick_11619": "爱悄然离线",
    "messageInitNick_11618": "匿名游侠",
    "messageInitNick_11613": "苟或是谁",
    "messageInitNick_11612": "超萌萌喵",
    "messageInitNick_11611": "伪装老板",
    "messageInitNick_11610": "我们那一家",
    "messageInitNick_11617": "非良人",
    "messageInitNick_11616": "脸上五颜六色",
    "messageInitNick_11615": "快雪时晴",
    "messageInitNick_11614": "悲伤的帅哥",
    "1_2099": "已满级",
    "1_2098": "选择",
    "1_2097": "新属性",
    "1_2096": "原属性",
    "1_2095": "点击选择",
    "1_2094": "请选择你要保留的属性",
    "1_2093": "主元核属性",
    "1_2092": "放入元核后预览属性",
    "1_2091": "进阶失败",
    "1_2090": "进阶成功",
    "1_2089": "每日根据活跃探索者使用的远古族怪兽评选稀有度",
    "1_2088": "怪兽状态",
    "1_2087": "拥有者",
    "1_2086": "技能",
    "1_2085": "描述",
    "1_2084": "无",
    "1_2083": "空",
    "1_2082": "技能已满级",
    "1_2081": "取消",
    "1_2080": "进化",
    "messageInitContent_2518": "看我一斧子挡住你",
    "messageInitContent_2517": "真是谁站在斧子前面，谁就被挡",
    "messageInitContent_2516": "撑过爆发期就好",
    "messageInitContent_2515": "包租公就是任性，随便就两员大将拿出手。",
    "messageInitContent_2514": "但我前排够猛啊！",
    "messageInitContent_2513": "刷的一下，后排不见了",
    "messageInitContent_2512": "我本来还挺喜欢蓝色的。",
    "messageInitContent_2511": "蓝色切后军团",
    "messageInitNick_11525": "头铁门首席",
    "messageInitNick_11524": "一点的凉粉",
    "messageInitNick_11523": "手机跑了",
    "messageInitNick_11522": "小岛秀儿",
    "messageInitNick_11529": "头铁观察员",
    "messageInitNick_11528": "鼠标要高考",
    "messageInitNick_11527": "被烤的肉",
    "messageInitContent_2519": "漫展拍照也是道具太大就会这样。",
    "messageInitNick_11526": "当场放假",
    "messageInitNick_11521": "一饮山河尽",
    "messageInitNick_11520": "单人华尔兹",
    "messageInitContent_2521": "能不能cos包租公前面那个",
    "messageInitContent_2520": "谁cos一下包租公",
    "messageInitContent_2529": "掉头就跑23333333",
    "messageInitContent_2528": "头会掉下来吗？哈哈",
    "messageInitContent_2527": "拆锁链那个是魔鬼吧",
    "messageInitContent_2526": "好想吧飞头蛮的锁链拆了",
    "messageInitContent_2525": "可怕",
    "messageInitContent_2524": "因为那个梗在114那里用过了",
    "messageInitContent_2523": "这关为什么不叫33333",
    "messageInitContent_2522": "233333333333333",
    "messageInitNick_11536": "梦魂",
    "messageInitNick_11535": "保证无坑",
    "messageInitNick_11534": "给你蹦一个",
    "messageInitNick_11533": "甩锅爱好者",
    "messageInitNick_11539": "那你不早说",
    "messageInitNick_11538": "布吉岛",
    "messageInitNick_11537": "换洗冤家",
    "messageInitNick_11532": "煎饼果子",
    "messageInitNick_11531": "花女皇",
    "messageInitNick_11530": "拾起自我",
    "messageInitContent_2532": "友军我是友军别烧我！",
    "messageInitContent_2531": "哇，多么古老的新生。",
    "messageInitContent_2530": "为什么薛定鳄可以又肉又有输出啊。",
    "messageInitContent_2539": "囧",
    "messageInitContent_2538": "人家只是只无害的小猫咪嘛。",
    "messageInitNick_11509": "爱太累梦太乱",
    "messageInitContent_2537": "头疼，我一看它就头疼",
    "messageInitNick_11508": "乐器店的常客",
    "messageInitContent_2536": "黯灭是火神后面还是左右的",
    "messageInitContent_2535": "确实",
    "messageInitContent_2534": "最初的好像是冥龙王、白昼和梵吧",
    "messageInitContent_2533": "总觉得黯灭好像穿着件红色外套。",
    "messageInitNick_11503": "一起发财",
    "messageInitNick_11502": "智能鱼露",
    "messageInitNick_11501": "和尚要丈母娘",
    "messageInitNick_11500": "街角看情书",
    "messageInitNick_11507": "倒霉的树",
    "messageInitNick_11506": "纯情姜片",
    "messageInitNick_11505": "别轻易玩火",
    "messageInitNick_11504": "樱桃魔法",
    "messageInitContent_2543": "抽爆！",
    "messageInitContent_2542": "如果出了我第一个抽！",
    "messageInitContent_2541": "幻想很美好，现实很骨感",
    "messageInitContent_2540": "我需要一只能让对面任意怪兽倒戈的怪兽！",
    "messageInitContent_2549": "它们对那个真是好执着",
    "messageInitContent_2548": "这是夺命流星雨啊",
    "messageInitNick_11519": "不巧我在等你",
    "messageInitContent_2547": "陪你去看流星雨落在这地球上",
    "messageInitContent_2546": "穿甲兽怎么入手？！",
    "messageInitContent_2545": "不如我派你去打穿角兽吧！",
    "messageInitContent_2544": "一只会降低屏障一只会降真实伤害。",
    "messageInitNick_11514": "金钱螺旋体",
    "messageInitNick_11513": "菠萝爱好者",
    "messageInitNick_11512": "草莓不及你甜",
    "messageInitNick_11511": "强壮打脸王",
    "messageInitNick_11518": "新猫到家",
    "messageInitNick_11517": "煲汤大师",
    "messageInitNick_11516": "咸鱼冲锋",
    "messageInitNick_11515": "道理我抖动",
    "messageInitNick_11510": "飞的猫",
    "messageInitContent_2554": "沼兽的领域是死了才会触发，藤妖的是活着就有",
    "messageInitContent_2553": "还好这里没有场地加成",
    "messageInitContent_2552": "这里已经有沼泽不需要再种了！",
    "messageInitContent_2551": "这两只真的很适合在这里。",
    "messageInitContent_2550": "不像某兵器，至今仍然没有**",
    "messageInitContent_2559": "令人害怕的百分比伤害，",
    "messageInitContent_2558": "这不是比蒙吗",
    "messageInitContent_2557": "一点都不像好吗",
    "messageInitContent_2556": "你这么一说还真有点像！",
    "messageInitContent_2555": "看我花仙破坏炮！",
    "messageInitNick_11569": "勿挽旧人",
    "messageInitNick_11568": "尘埃未定",
    "messageInitNick_11567": "别低头皇冠掉",
    "messageInitNick_11566": "无助小可爱",
    "messageInitNick_11561": "环保床单",
    "messageInitNick_11560": "宝贝在干嘛",
    "messageInitNick_11565": "钓鱼大师",
    "messageInitNick_11564": "吃醋第一名",
    "messageInitNick_11563": "状元附体",
    "messageInitNick_11562": "零零的日常",
    "messageInitContent_2565": "真嘟假嘟O.o O.o",
    "messageInitContent_2564": "我也上2只怪兽，2v2公平对决哈哈",
    "messageInitContent_2563": "小菜一碟",
    "messageInitContent_2562": "有没有可能那个是眉毛",
    "messageInitContent_2561": "好大，g-n的眼睛好大啊啊",
    "messageInitContent_2560": "我来给比蒙放个假期",
    "messageInitContent_2569": "新世界我来啦！",
    "messageInitContent_2568": "高手在此！",
    "messageInitContent_2567": "不走了！",
    "messageInitContent_2566": "O.O我比360多1度",
    "messageInitNick_11579": "独行者",
    "messageInitNick_11578": "一本瓜子",
    "messageInitNick_11577": "万事如意",
    "messageInitNick_11572": "万能眼镜",
    "messageInitNick_11571": "西瓜的灵魂",
    "messageInitNick_11570": "好多鱼",
    "messageInitNick_11576": "酱油西瓜",
    "messageInitNick_11575": "我不够拽",
    "messageInitNick_11574": "我支持你的梦",
    "messageInitNick_11573": "凛冬已过",
    "messageInitContent_2576": "孢子？",
    "messageInitContent_2575": "留下什么买路钱怪兽才会让我们通过呢",
    "messageInitContent_2574": "我要成为新世界的卡密",
    "messageInitContent_2573": "起始的小岛",
    "messageInitContent_2572": "浆糊！我来了，向左还是向右呢",
    "messageInitContent_2571": "到底谁才是幼体的霸王",
    "messageInitContent_2570": "它的脸长的好像字哦",
    "messageInitContent_2579": "望远镜可以让它们看到远方的亲人",
    "messageInitContent_2578": "星灵族当然是要望远镜",
    "messageInitContent_2577": "霸气流星！",
    "messageInitNick_11547": "高质量怪兽",
    "messageInitNick_11546": "几次晚安",
    "messageInitNick_11545": "单调的情节",
    "messageInitNick_11544": "天秤克巨蟹",
    "messageInitNick_11549": "离离原大谱",
    "messageInitNick_11548": "蒜泥白肉",
    "messageInitNick_11543": "帅到拖网速",
    "messageInitNick_11542": "可爱卷心菜",
    "messageInitNick_11541": "辣椒兽",
    "messageInitNick_11540": "豆瓣菜兽",
    "messageInitContent_2587": "溜了溜了",
    "messageInitContent_2586": "幼体怪，但1400",
    "messageInitContent_2585": "是一千级的叉宝",
    "messageInitContent_2584": "前面那跟是牙签吗",
    "messageInitContent_2583": "叉叉叉叉！",
    "messageInitContent_2582": "叉叉站c位！",
    "messageInitContent_2581": "确实是绿怪。",
    "messageInitContent_2580": "起猛了，这是哪儿！",
    "messageInitContent_2589": "一般炸弹不是有条线可以剪掉的吗",
    "messageInitContent_2588": "溜溜什么时候能站起来！",
    "messageInitNick_11558": "万魂之主",
    "messageInitNick_11557": "局内人是外人",
    "messageInitNick_11556": "蒜苔兽",
    "messageInitNick_11555": "别动我兔子",
    "messageInitNick_11559": "泥奏凯",
    "messageInitContent_2590": "怪呢？",
    "messageInitNick_11550": "静听一季花开",
    "messageInitNick_11554": "赏你十巴掌",
    "messageInitNick_11553": "一流二货",
    "messageInitNick_11552": "幸运四叶草",
    "messageInitNick_11551": "不要你的理睬",
    "messageInitContent_2598": "车？大炮？",
    "messageInitContent_2597": "金矿山明明就在隔壁，为什么！",
    "messageInitContent_2596": "射人先射马",
    "messageInitContent_2595": "已经能看到对面的金矿了",
    "messageInitContent_2594": "这三兄弟谁是大哥",
    "messageInitContent_2593": "何处觅良驹",
    "messageInitContent_2592": "溜溜大法好",
    "messageInitContent_2591": "在地上呢",
    "1_2113": "使用万能进化光谱",
    "1_2112": "怪兽攻击力和体力+20%并随机激活一个超进化技",
    "1_2111": "「超进化」",
    "1_2110": "切换",
    "tutorialConfigDesc_9": "下一步引导条件未满足",
    "tutorialConfigDesc_8": "下一步引导条件未满足",
    "tutorialConfigDesc_7": "下一步引导条件未满足",
    "tutorialConfigDesc_6": "下一步引导条件未满足",
    "tutorialConfigDesc_5": "下一步引导条件未满足",
    "tutorialConfigDesc_4": "下一步引导条件未满足",
    "tutorialConfigDesc_3": "下一步引导条件未满足",
    "tutorialConfigDesc_2": "下一步引导条件未满足",
    "tutorialConfigDesc_1": "下一步引导条件未满足",
    "1_2116": "可重置元核",
    "1_2115": "元核熔炼消耗材料",
    "1_2114": "熔炼时将额外锁定上述词条属性或宿命效果",
    "1_2102": "评点",
    "1_2101": "已锁定",
    "1_2100": "锁定",
    "channelName_926": "游戏Fan",
    "1_2109": "超进化",
    "1_2108": "便捷进化",
    "1_2107": "新增",
    "1_2106": "首次分享至外部可得",
    "1_2105": "重置",
    "1_2104": "轮回",
    "1_2103": "进化树",
    "messageInitNick_11589": "煮茶男",
    "messageInitNick_11588": "桃子魔法师",
    "messageInitNick_11583": "错杀温柔",
    "messageInitNick_11582": "中午吃蛋挞",
    "messageInitNick_11581": "原来想吃饭",
    "messageInitNick_11580": "智商已欠费",
    "messageInitNick_11587": "春天华尔兹",
    "messageInitNick_11586": "风云无邪",
    "messageInitNick_11585": "不上班的人",
    "messageInitNick_11584": "如果山竹会笑",
    "iapBuyConfigName_202": "创友回归战令",
    "messageInitNick_11599": "鼠鼠我鸭",
    "messageInitNick_11594": "芦笋魔法师",
    "messageInitNick_2395": "稳住别浪",
    "messageInitNick_11593": "暂停摸鱼",
    "messageInitNick_2396": "戏嫦娥",
    "messageInitNick_11592": "烂脾气",
    "messageInitNick_2393": "盖世英雄",
    "messageInitNick_11591": "树莓兽",
    "messageInitNick_2394": "坏蛋",
    "messageInitNick_11598": "尖叫油菜",
    "messageInitNick_2399": "别跟我装熟",
    "messageInitNick_11597": "面包的烦恼",
    "iapBuyConfigName_201": "一箭五令",
    "messageInitNick_11596": "魔法镜子",
    "messageInitNick_2397": "跟风门首席",
    "iapBuyConfigName_200": "高级战令",
    "messageInitNick_11595": "这是网球吗",
    "messageInitNick_2398": "彼岸蝴蝶",
    "messageInitNick_11590": "油菜兽",
    "plateDes_12": "战斗开始且己方远古族怪兽在场时，所有敌方怪兽死亡时触发的效果无法触发，持续{quality_based}秒",
    "plateDes_13": "己方祖龙族怪兽在场时，每{p1}秒为攻击力最高的怪兽增加{quality_based}层威能（每层威能提高怪兽{p2}攻击力），持续{p3}秒，最多叠加{p4}层",
    "plateDes_14": "己方祖龙族怪兽在场时，威能叠加{p1}层的怪兽消耗{p2}层威能，获得威能爆发效果，攻击力提高{quality_based}%，持续{p3}秒",
    "plateDes_15": "己方尸鬼族怪兽在场时，每{p1}秒为体力最高的怪兽增加{quality_based}层强魄（每层强魄提高怪兽{p2}最大血量），持续{p3}秒，最多叠加{p4}层",
    "plateDes_10": "己方远古族怪兽在场时，每{p1}秒所有敌方怪兽元核的破甲之力词条失效，持续{quality_based}秒",
    "plateDes_11": "战斗开始且己方远古族怪兽在场时，所有己方怪兽受到怪兽的伤害变为0，持续{quality_based}秒（非怪兽的伤害仍然有效）",
    "messageInitNick_2391": "逆天的翔",
    "plateDes_16": "己方尸鬼族怪兽在场时，强魄叠加{p1}层的怪兽消耗{p2}层强魄，获得强魄注入效果，获得最大血量×{quality_based}%的护盾，持续{p3}秒",
    "messageInitNick_2392": "头铁高手",
    "plateDes_17": "己方星灵族怪兽在场时，每{p1}秒为真实伤害最高的怪兽增加{quality_based}层蔑视（每层蔑视提高怪兽{p2}真实伤害），持续{p3}秒，最多叠加{p4}层",
    "plateDes_18": "己方星灵族怪兽在场时，蔑视叠加{p1}层的怪兽消耗{p2}层蔑视，获得蔑视扫荡效果，真实伤害提高{quality_based}%，持续{p3}秒",
    "messageInitNick_2390": "草莓萌妹酱",
    "plateDes_19": "己方木偶族怪兽在场时，每{p1}秒为生物屏障最高的怪兽增加{quality_based}层隔绝（每层守护提高怪兽{p2}生物屏障），持续{p3}秒，最多叠加{p4}层",
    "messageInitNick_2384": "台风饿了",
    "messageInitNick_2385": "入戏到哽咽",
    "messageInitNick_2382": "看我七十二变",
    "messageInitNick_2383": "巴黎的夜",
    "messageInitNick_2388": "匆匆过客",
    "messageInitNick_2389": "要保住呢份工",
    "messageInitNick_2386": "呆萌小白兔",
    "messageInitNick_2387": "大颗药丸",
    "messageInitNick_2380": "头铁带头人",
    "messageInitNick_2381": "半抹笑",
    "messageInitNick_2373": "傲娇少女",
    "messageInitNick_2374": "你不懂",
    "messageInitNick_2371": "智商保修期",
    "messageInitNick_2372": "那天雨很大",
    "messageInitNick_2377": "可爱值爆表",
    "messageInitNick_2378": "后宫佳丽三千",
    "messageInitNick_2375": "保护敌方上单",
    "messageInitNick_2376": "柳无色",
    "messageInitNick_2379": "如你所愿",
    "messageInitNick_2370": "幽默先生",
    "messageInitNick_2362": "三千烟雨",
    "messageInitNick_2363": "与星星私奔",
    "messageInitNick_2360": "离哥远点",
    "messageInitNick_2361": "百事可爱",
    "messageInitNick_2366": "不准凶小可爱",
    "messageInitNick_2367": "感情走狗",
    "messageInitNick_2364": "此心已废",
    "messageInitNick_2365": "画饼机器",
    "messageInitNick_2368": "爱在草原",
    "messageInitNick_2369": "黑帮美少女",
    "messageInitContent_2507": "c位明明是焚风！",
    "messageInitContent_2506": "幻幻终于站到了c位！",
    "messageInitContent_2505": "破魂领主和尸狂的武器加起来就是幻的武器了",
    "messageInitContent_2504": "现在是皮肤展示环节",
    "messageInitContent_2503": "现在大家都可以自爆了呢",
    "messageInitContent_2502": "那是灾，不是宅！",
    "plateDes_20": "己方木偶族怪兽在场时，隔绝叠加{p1}层的怪兽消耗{p2}层隔绝，获得隔绝协议效果，生物屏障提高{quality_based}%，持续{p3}秒",
    "messageInitContent_2501": "等我占领这这里，我的主城就会有宅的守护",
    "plateDes_21": "己方远古族怪兽在场时，每{p1}秒扣减攻击力最高的敌方怪兽现有增益效果{quality_based}%的剩余持续时间",
    "messageInitContent_2500": "通往主场的最后一条道路",
    "plateDes_22": "己方远古族怪兽在场时，每{p1}秒己方远古怪兽进入反赋状态（每次撞击敌方怪兽时，会直接扣减其现有增益效果{quality_based}%的持续时间，最多生效{p2}次）",
    "messageInitContent_2509": "并没有幻化也是蓝色的",
    "messageInitContent_2508": "蜻蜓龙好突兀啊",
    "messageInitNick_2351": "可苦可乐",
    "messageInitNick_2352": "二手猛男",
    "messageInitNick_2350": "窗下情人",
    "messageInitNick_2355": "安稳先生",
    "messageInitNick_2356": "梦中的怪兽",
    "messageInitNick_2353": "类人生物",
    "messageInitNick_2354": "我不是本人",
    "messageInitContent_2510": "蓝色生死恋？？？",
    "messageInitNick_2359": "转圈咬尾巴",
    "messageInitNick_2357": "你刘海飞了",
    "messageInitNick_2358": "传奇人物"
}



// WEBPACK FOOTER //
// ./src/lang/i18nCN.js